/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/DataVisFinal/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 481);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(488);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return atan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return atan2; });
/* unused harmony export ceil */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return exp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return floor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return log; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return pow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return round; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return sign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return tan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return epsilon2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return quarterPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return sqrt1_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return sqrt2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return sqrtPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return tau; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return degrees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return radians; });
/* harmony export (immutable) */ __webpack_exports__["z"] = sinci;
/* harmony export (immutable) */ __webpack_exports__["e"] = asin;
/* harmony export (immutable) */ __webpack_exports__["b"] = acos;
/* harmony export (immutable) */ __webpack_exports__["B"] = sqrt;
/* harmony export (immutable) */ __webpack_exports__["G"] = tanh;
/* harmony export (immutable) */ __webpack_exports__["A"] = sinh;
/* harmony export (immutable) */ __webpack_exports__["i"] = cosh;
/* harmony export (immutable) */ __webpack_exports__["d"] = arsinh;
/* harmony export (immutable) */ __webpack_exports__["c"] = arcosh;
var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var ceil = Math.ceil;
var cos = Math.cos;
var exp = Math.exp;
var floor = Math.floor;
var log = Math.log;
var max = Math.max;
var min = Math.min;
var pow = Math.pow;
var round = Math.round;
var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
var sin = Math.sin;
var tan = Math.tan;

var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var sqrt1_2 = Math.SQRT1_2;
var sqrt2 = sqrt(2);
var sqrtPi = sqrt(pi);
var tau = pi * 2;
var degrees = 180 / pi;
var radians = pi / 180;

function sinci(x) {
  return x ? x / Math.sin(x) : 1;
}

function asin(x) {
  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function sqrt(x) {
  return x > 0 ? Math.sqrt(x) : 0;
}

function tanh(x) {
  x = exp(2 * x);
  return (x - 1) / (x + 1);
}

function sinh(x) {
  return (exp(x) - exp(-x)) / 2;
}

function cosh(x) {
  return (exp(x) + exp(-x)) / 2;
}

function arsinh(x) {
  return log(x + sqrt(x * x + 1));
}

function arcosh(x) {
  return log(x + sqrt(x * x - 1));
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_area__ = __webpack_require__(256);
/* unused harmony reexport geoArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_bounds__ = __webpack_require__(549);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_bounds__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_centroid__ = __webpack_require__(550);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__src_centroid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_circle__ = __webpack_require__(257);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__src_circle__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_clip_antimeridian__ = __webpack_require__(259);
/* unused harmony reexport geoClipAntimeridian */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_clip_circle__ = __webpack_require__(277);
/* unused harmony reexport geoClipCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_clip_extent__ = __webpack_require__(568);
/* unused harmony reexport geoClipExtent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_clip_rectangle__ = __webpack_require__(101);
/* unused harmony reexport geoClipRectangle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_contains__ = __webpack_require__(570);
/* unused harmony reexport geoContains */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_distance__ = __webpack_require__(278);
/* unused harmony reexport geoDistance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_graticule__ = __webpack_require__(571);
/* unused harmony reexport geoGraticule */
/* unused harmony reexport geoGraticule10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_interpolate__ = __webpack_require__(572);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_11__src_interpolate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_length__ = __webpack_require__(279);
/* unused harmony reexport geoLength */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_path_index__ = __webpack_require__(573);
/* unused harmony reexport geoPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_projection_albers__ = __webpack_require__(281);
/* unused harmony reexport geoAlbers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_projection_albersUsa__ = __webpack_require__(581);
/* unused harmony reexport geoAlbersUsa */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_projection_azimuthalEqualArea__ = __webpack_require__(582);
/* unused harmony reexport geoAzimuthalEqualArea */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_16__src_projection_azimuthalEqualArea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_projection_azimuthalEquidistant__ = __webpack_require__(583);
/* unused harmony reexport geoAzimuthalEquidistant */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_17__src_projection_azimuthalEquidistant__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_projection_conicConformal__ = __webpack_require__(584);
/* unused harmony reexport geoConicConformal */
/* unused harmony reexport geoConicConformalRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_projection_conicEqualArea__ = __webpack_require__(149);
/* unused harmony reexport geoConicEqualArea */
/* unused harmony reexport geoConicEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_projection_conicEquidistant__ = __webpack_require__(585);
/* unused harmony reexport geoConicEquidistant */
/* unused harmony reexport geoConicEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_projection_equirectangular__ = __webpack_require__(282);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_21__src_projection_equirectangular__["a"]; });
/* unused harmony reexport geoEquirectangularRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_projection_gnomonic__ = __webpack_require__(586);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_22__src_projection_gnomonic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_22__src_projection_gnomonic__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_projection_identity__ = __webpack_require__(587);
/* unused harmony reexport geoIdentity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_projection_index__ = __webpack_require__(23);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_24__src_projection_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_24__src_projection_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_projection_mercator__ = __webpack_require__(152);
/* unused harmony reexport geoMercator */
/* unused harmony reexport geoMercatorRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_projection_naturalEarth1__ = __webpack_require__(588);
/* unused harmony reexport geoNaturalEarth1 */
/* unused harmony reexport geoNaturalEarth1Raw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_projection_orthographic__ = __webpack_require__(589);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_27__src_projection_orthographic__["a"]; });
/* unused harmony reexport geoOrthographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_projection_stereographic__ = __webpack_require__(590);
/* unused harmony reexport geoStereographic */
/* unused harmony reexport geoStereographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__src_projection_transverseMercator__ = __webpack_require__(591);
/* unused harmony reexport geoTransverseMercator */
/* unused harmony reexport geoTransverseMercatorRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__src_rotation__ = __webpack_require__(100);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_30__src_rotation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__src_stream__ = __webpack_require__(40);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_31__src_stream__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__src_transform__ = __webpack_require__(102);
/* unused harmony reexport geoTransform */






 // DEPRECATED! Use d3.geoIdentity().clipExtent(…).




























/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_bisect__ = __webpack_require__(265);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bisect", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bisectRight", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bisectLeft", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ascending__ = __webpack_require__(52);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ascending", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_bisector__ = __webpack_require__(266);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bisector", function() { return __WEBPACK_IMPORTED_MODULE_2__src_bisector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_cross__ = __webpack_require__(552);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cross", function() { return __WEBPACK_IMPORTED_MODULE_3__src_cross__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_descending__ = __webpack_require__(553);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "descending", function() { return __WEBPACK_IMPORTED_MODULE_4__src_descending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_deviation__ = __webpack_require__(268);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "deviation", function() { return __WEBPACK_IMPORTED_MODULE_5__src_deviation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_extent__ = __webpack_require__(270);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "extent", function() { return __WEBPACK_IMPORTED_MODULE_6__src_extent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_histogram__ = __webpack_require__(554);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "histogram", function() { return __WEBPACK_IMPORTED_MODULE_7__src_histogram__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold_freedmanDiaconis__ = __webpack_require__(557);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "thresholdFreedmanDiaconis", function() { return __WEBPACK_IMPORTED_MODULE_8__src_threshold_freedmanDiaconis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_threshold_scott__ = __webpack_require__(558);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "thresholdScott", function() { return __WEBPACK_IMPORTED_MODULE_9__src_threshold_scott__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__ = __webpack_require__(274);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "thresholdSturges", function() { return __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_max__ = __webpack_require__(559);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "max", function() { return __WEBPACK_IMPORTED_MODULE_11__src_max__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_mean__ = __webpack_require__(560);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mean", function() { return __WEBPACK_IMPORTED_MODULE_12__src_mean__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_median__ = __webpack_require__(561);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "median", function() { return __WEBPACK_IMPORTED_MODULE_13__src_median__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_merge__ = __webpack_require__(562);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return __WEBPACK_IMPORTED_MODULE_14__src_merge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_min__ = __webpack_require__(275);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "min", function() { return __WEBPACK_IMPORTED_MODULE_15__src_min__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_pairs__ = __webpack_require__(267);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pairs", function() { return __WEBPACK_IMPORTED_MODULE_16__src_pairs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_permute__ = __webpack_require__(563);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "permute", function() { return __WEBPACK_IMPORTED_MODULE_17__src_permute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_quantile__ = __webpack_require__(147);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "quantile", function() { return __WEBPACK_IMPORTED_MODULE_18__src_quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_range__ = __webpack_require__(272);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "range", function() { return __WEBPACK_IMPORTED_MODULE_19__src_range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_scan__ = __webpack_require__(564);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scan", function() { return __WEBPACK_IMPORTED_MODULE_20__src_scan__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_shuffle__ = __webpack_require__(565);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "shuffle", function() { return __WEBPACK_IMPORTED_MODULE_21__src_shuffle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_sum__ = __webpack_require__(566);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sum", function() { return __WEBPACK_IMPORTED_MODULE_22__src_sum__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_ticks__ = __webpack_require__(273);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ticks", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tickIncrement", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tickStep", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_transpose__ = __webpack_require__(276);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "transpose", function() { return __WEBPACK_IMPORTED_MODULE_24__src_transpose__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_variance__ = __webpack_require__(269);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "variance", function() { return __WEBPACK_IMPORTED_MODULE_25__src_variance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_zip__ = __webpack_require__(567);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return __WEBPACK_IMPORTED_MODULE_26__src_zip__["a"]; });





























/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return epsilon2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return quarterPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return tau; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return degrees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return radians; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return atan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ceil; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return exp; });
/* unused harmony export floor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return log; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return pow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return sign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return tan; });
/* harmony export (immutable) */ __webpack_exports__["b"] = acos;
/* harmony export (immutable) */ __webpack_exports__["c"] = asin;
/* harmony export (immutable) */ __webpack_exports__["m"] = haversin;
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;

var degrees = 180 / pi;
var radians = pi / 180;

var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var floor = Math.floor;
var log = Math.log;
var pow = Math.pow;
var sin = Math.sin;
var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
var sqrt = Math.sqrt;
var tan = Math.tan;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}

function haversin(x) {
  return (x = sin(x / 2)) * x;
}


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(specifier) {
  var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
  while (i < n) colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
  return colors;
});


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return epsilon2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return quarterPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return tau; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return degrees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return radians; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return atan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ceil; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return exp; });
/* unused harmony export floor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return log; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return pow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return sign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return tan; });
/* harmony export (immutable) */ __webpack_exports__["b"] = acos;
/* harmony export (immutable) */ __webpack_exports__["c"] = asin;
/* harmony export (immutable) */ __webpack_exports__["m"] = haversin;
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;

var degrees = 180 / pi;
var radians = pi / 180;

var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var floor = Math.floor;
var log = Math.log;
var pow = Math.pow;
var sin = Math.sin;
var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
var sqrt = Math.sqrt;
var tan = Math.tan;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}

function haversin(x) {
  return (x = sin(x / 2)) * x;
}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(508)();
}


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_color__ = __webpack_require__(167);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "color", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "rgb", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hsl", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_lab__ = __webpack_require__(721);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lab", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hcl", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__ = __webpack_require__(722);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cubehelix", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__["a"]; });





/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (function(scheme) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["e" /* interpolateRgbBasis */])(scheme[scheme.length - 1]);
});


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_value__ = __webpack_require__(166);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_array__ = __webpack_require__(315);
/* unused harmony reexport interpolateArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_basis__ = __webpack_require__(169);
/* unused harmony reexport interpolateBasis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__ = __webpack_require__(313);
/* unused harmony reexport interpolateBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_date__ = __webpack_require__(316);
/* unused harmony reexport interpolateDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_number__ = __webpack_require__(108);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__src_number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_object__ = __webpack_require__(317);
/* unused harmony reexport interpolateObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_round__ = __webpack_require__(723);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__src_round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_string__ = __webpack_require__(318);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_8__src_string__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_transform_index__ = __webpack_require__(724);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_zoom__ = __webpack_require__(727);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_10__src_zoom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_rgb__ = __webpack_require__(312);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["b"]; });
/* unused harmony reexport interpolateRgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_hsl__ = __webpack_require__(728);
/* unused harmony reexport interpolateHsl */
/* unused harmony reexport interpolateHslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_lab__ = __webpack_require__(729);
/* unused harmony reexport interpolateLab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_hcl__ = __webpack_require__(730);
/* unused harmony reexport interpolateHcl */
/* unused harmony reexport interpolateHclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(731);
/* unused harmony reexport interpolateCubehelix */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_quantize__ = __webpack_require__(732);
/* unused harmony reexport quantize */



















/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_create__ = __webpack_require__(775);
/* unused harmony reexport create */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_creator__ = __webpack_require__(111);
/* unused harmony reexport creator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_local__ = __webpack_require__(804);
/* unused harmony reexport local */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_matcher__ = __webpack_require__(332);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__src_matcher__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_mouse__ = __webpack_require__(805);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__src_mouse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_namespace__ = __webpack_require__(174);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__src_namespace__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_namespaces__ = __webpack_require__(175);
/* unused harmony reexport namespaces */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_point__ = __webpack_require__(112);
/* unused harmony reexport clientPoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_select__ = __webpack_require__(330);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__src_select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_selectAll__ = __webpack_require__(806);
/* unused harmony reexport selectAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_selection_index__ = __webpack_require__(17);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_10__src_selection_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_selector__ = __webpack_require__(176);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_11__src_selector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_selectorAll__ = __webpack_require__(331);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_12__src_selectorAll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_selection_style__ = __webpack_require__(335);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_13__src_selection_style__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_touch__ = __webpack_require__(807);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_14__src_touch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_touches__ = __webpack_require__(808);
/* unused harmony reexport touches */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_window__ = __webpack_require__(177);
/* unused harmony reexport window */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_selection_on__ = __webpack_require__(178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_17__src_selection_on__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_17__src_selection_on__["a"]; });




















/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_bisect__ = __webpack_require__(401);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bisect", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bisectRight", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bisectLeft", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ascending__ = __webpack_require__(59);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ascending", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_bisector__ = __webpack_require__(402);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bisector", function() { return __WEBPACK_IMPORTED_MODULE_2__src_bisector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_cross__ = __webpack_require__(1010);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cross", function() { return __WEBPACK_IMPORTED_MODULE_3__src_cross__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_descending__ = __webpack_require__(1011);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "descending", function() { return __WEBPACK_IMPORTED_MODULE_4__src_descending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_deviation__ = __webpack_require__(404);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "deviation", function() { return __WEBPACK_IMPORTED_MODULE_5__src_deviation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_extent__ = __webpack_require__(406);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "extent", function() { return __WEBPACK_IMPORTED_MODULE_6__src_extent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_histogram__ = __webpack_require__(1012);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "histogram", function() { return __WEBPACK_IMPORTED_MODULE_7__src_histogram__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold_freedmanDiaconis__ = __webpack_require__(1015);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "thresholdFreedmanDiaconis", function() { return __WEBPACK_IMPORTED_MODULE_8__src_threshold_freedmanDiaconis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_threshold_scott__ = __webpack_require__(1016);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "thresholdScott", function() { return __WEBPACK_IMPORTED_MODULE_9__src_threshold_scott__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__ = __webpack_require__(410);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "thresholdSturges", function() { return __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_max__ = __webpack_require__(1017);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "max", function() { return __WEBPACK_IMPORTED_MODULE_11__src_max__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_mean__ = __webpack_require__(1018);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mean", function() { return __WEBPACK_IMPORTED_MODULE_12__src_mean__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_median__ = __webpack_require__(1019);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "median", function() { return __WEBPACK_IMPORTED_MODULE_13__src_median__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_merge__ = __webpack_require__(1020);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return __WEBPACK_IMPORTED_MODULE_14__src_merge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_min__ = __webpack_require__(411);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "min", function() { return __WEBPACK_IMPORTED_MODULE_15__src_min__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_pairs__ = __webpack_require__(403);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pairs", function() { return __WEBPACK_IMPORTED_MODULE_16__src_pairs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_permute__ = __webpack_require__(1021);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "permute", function() { return __WEBPACK_IMPORTED_MODULE_17__src_permute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_quantile__ = __webpack_require__(207);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "quantile", function() { return __WEBPACK_IMPORTED_MODULE_18__src_quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_range__ = __webpack_require__(408);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "range", function() { return __WEBPACK_IMPORTED_MODULE_19__src_range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_scan__ = __webpack_require__(1022);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scan", function() { return __WEBPACK_IMPORTED_MODULE_20__src_scan__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_shuffle__ = __webpack_require__(1023);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "shuffle", function() { return __WEBPACK_IMPORTED_MODULE_21__src_shuffle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_sum__ = __webpack_require__(1024);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sum", function() { return __WEBPACK_IMPORTED_MODULE_22__src_sum__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_ticks__ = __webpack_require__(409);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ticks", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tickIncrement", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tickStep", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_transpose__ = __webpack_require__(412);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "transpose", function() { return __WEBPACK_IMPORTED_MODULE_24__src_transpose__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_variance__ = __webpack_require__(405);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "variance", function() { return __WEBPACK_IMPORTED_MODULE_25__src_variance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_zip__ = __webpack_require__(1025);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return __WEBPACK_IMPORTED_MODULE_26__src_zip__["a"]; });





























/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newInterval;
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_path__ = __webpack_require__(850);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_path__["a"]; });



/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarkContext = exports.Mark = exports.DraggableMark = undefined;

var _Mark = __webpack_require__(413);

var _Mark2 = _interopRequireDefault(_Mark);

var _DraggableMark = __webpack_require__(1134);

var _DraggableMark2 = _interopRequireDefault(_DraggableMark);

var _MarkContext = __webpack_require__(1135);

var _MarkContext2 = _interopRequireDefault(_MarkContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  DraggableMark: _DraggableMark2.default,
  Mark: _Mark2.default,
  MarkContext: _MarkContext2.default
};
exports.DraggableMark = _DraggableMark2.default;
exports.Mark = _Mark2.default;
exports.MarkContext = _MarkContext2.default;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arcBuilder = exports.pathBuilder = exports.lineBuilder = undefined;

var _d3Shape = __webpack_require__(76);

var lineBuilder = exports.lineBuilder = function lineBuilder(_ref) {
  var data = _ref.data,
      _ref$curve = _ref.curve,
      curve = _ref$curve === undefined ? _d3Shape.curveLinear : _ref$curve,
      canvasContext = _ref.canvasContext,
      className = _ref.className,
      classID = _ref.classID;

  var lineGen = (0, _d3Shape.line)().curve(curve);

  var builder = {
    type: "path",
    className: className,
    classID: classID,
    data: data
  };

  if (canvasContext) {
    lineGen.context(canvasContext);
    builder.pathMethods = lineGen;
  } else {
    builder.attrs = {
      d: lineGen(data)
    };
  }

  return builder;
};

var pathBuilder = exports.pathBuilder = function pathBuilder(_ref2) {
  var d = _ref2.d,
      _ref2$curve = _ref2.curve,
      curve = _ref2$curve === undefined ? _d3Shape.curveLinear : _ref2$curve,
      canvasContext = _ref2.canvasContext,
      className = _ref2.className,
      classID = _ref2.classID;

  var lineGen = (0, _d3Shape.line)().curve(curve);

  var builder = {
    type: "path",
    className: className,
    classID: classID
  };

  if (canvasContext) {
    lineGen.context(canvasContext);
  } else {
    builder.attrs = {
      d: d
    };
  }

  return builder;
};

var arcBuilder = exports.arcBuilder = function arcBuilder(_ref3) {
  var data = _ref3.data,
      canvasContext = _ref3.canvasContext,
      className = _ref3.className,
      classID = _ref3.classID;

  var builder = {
    type: "path",
    className: className,
    classID: classID,
    data: data
  };

  var arcShape = (0, _d3Shape.arc)().innerRadius(data.innerRadius || 0).outerRadius(data.outerRadius || data.radius || 2).startAngle(data.startAngle || 0).endAngle(data.endAngle || 2 * Math.PI);

  if (canvasContext) {
    arcShape.context(canvasContext);
  } else {
    builder.attrs = {
      d: arcShape()
    };
  }

  return builder;
};

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return root; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Selection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__select__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectAll__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enter__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__exit__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__merge__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__order__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sort__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__call__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__nodes__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__node__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__size__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__empty__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__each__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__attr__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__property__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__classed__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__text__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__html__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__raise__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lower__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__append__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__insert__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__remove__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__clone__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__datum__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__on__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__dispatch__ = __webpack_require__(803);































var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection([[document.documentElement]], root);
}

Selection.prototype = selection.prototype = {
  constructor: Selection,
  select: __WEBPACK_IMPORTED_MODULE_0__select__["a" /* default */],
  selectAll: __WEBPACK_IMPORTED_MODULE_1__selectAll__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_2__filter__["a" /* default */],
  data: __WEBPACK_IMPORTED_MODULE_3__data__["a" /* default */],
  enter: __WEBPACK_IMPORTED_MODULE_4__enter__["b" /* default */],
  exit: __WEBPACK_IMPORTED_MODULE_5__exit__["a" /* default */],
  merge: __WEBPACK_IMPORTED_MODULE_6__merge__["a" /* default */],
  order: __WEBPACK_IMPORTED_MODULE_7__order__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_8__sort__["a" /* default */],
  call: __WEBPACK_IMPORTED_MODULE_9__call__["a" /* default */],
  nodes: __WEBPACK_IMPORTED_MODULE_10__nodes__["a" /* default */],
  node: __WEBPACK_IMPORTED_MODULE_11__node__["a" /* default */],
  size: __WEBPACK_IMPORTED_MODULE_12__size__["a" /* default */],
  empty: __WEBPACK_IMPORTED_MODULE_13__empty__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_14__each__["a" /* default */],
  attr: __WEBPACK_IMPORTED_MODULE_15__attr__["a" /* default */],
  style: __WEBPACK_IMPORTED_MODULE_16__style__["a" /* default */],
  property: __WEBPACK_IMPORTED_MODULE_17__property__["a" /* default */],
  classed: __WEBPACK_IMPORTED_MODULE_18__classed__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_19__text__["a" /* default */],
  html: __WEBPACK_IMPORTED_MODULE_20__html__["a" /* default */],
  raise: __WEBPACK_IMPORTED_MODULE_21__raise__["a" /* default */],
  lower: __WEBPACK_IMPORTED_MODULE_22__lower__["a" /* default */],
  append: __WEBPACK_IMPORTED_MODULE_23__append__["a" /* default */],
  insert: __WEBPACK_IMPORTED_MODULE_24__insert__["a" /* default */],
  remove: __WEBPACK_IMPORTED_MODULE_25__remove__["a" /* default */],
  clone: __WEBPACK_IMPORTED_MODULE_26__clone__["a" /* default */],
  datum: __WEBPACK_IMPORTED_MODULE_27__datum__["a" /* default */],
  on: __WEBPACK_IMPORTED_MODULE_28__on__["b" /* default */],
  dispatch: __WEBPACK_IMPORTED_MODULE_29__dispatch__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["b"] = (selection);


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CREATED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SCHEDULED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STARTING; });
/* unused harmony export STARTED */
/* unused harmony export RUNNING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENDED; });
/* harmony export (immutable) */ __webpack_exports__["g"] = init;
/* harmony export (immutable) */ __webpack_exports__["h"] = set;
/* harmony export (immutable) */ __webpack_exports__["f"] = get;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_timer__ = __webpack_require__(45);



var emptyOn = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("start", "end", "interrupt");
var emptyTween = [];

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

/* harmony default export */ __webpack_exports__["e"] = (function(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
});

function init(node, id) {
  var schedule = get(node, id);
  if (schedule.state > CREATED) throw new Error("too late; already scheduled");
  return schedule;
}

function set(node, id) {
  var schedule = get(node, id);
  if (schedule.state > STARTING) throw new Error("too late; already started");
  return schedule;
}

function get(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
  return schedule;
}

function create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["c" /* timer */])(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["b" /* timeout */])(start);

      // Interrupt the active transition, if any.
      // Dispatch the interrupt event.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions. No interrupt event is dispatched
      // because the cancelled transitions never started. Note that this also
      // removes this transition from the pending list!
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["b" /* timeout */])(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(null, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_creator__ = __webpack_require__(208);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "creator", function() { return __WEBPACK_IMPORTED_MODULE_0__src_creator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_local__ = __webpack_require__(1026);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "local", function() { return __WEBPACK_IMPORTED_MODULE_1__src_local__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_matcher__ = __webpack_require__(414);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matcher", function() { return __WEBPACK_IMPORTED_MODULE_2__src_matcher__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_mouse__ = __webpack_require__(1027);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mouse", function() { return __WEBPACK_IMPORTED_MODULE_3__src_mouse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_namespace__ = __webpack_require__(209);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "namespace", function() { return __WEBPACK_IMPORTED_MODULE_4__src_namespace__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_namespaces__ = __webpack_require__(210);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "namespaces", function() { return __WEBPACK_IMPORTED_MODULE_5__src_namespaces__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_select__ = __webpack_require__(1028);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_6__src_select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_selectAll__ = __webpack_require__(1056);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selectAll", function() { return __WEBPACK_IMPORTED_MODULE_7__src_selectAll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_selection_index__ = __webpack_require__(20);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selection", function() { return __WEBPACK_IMPORTED_MODULE_8__src_selection_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_selector__ = __webpack_require__(214);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selector", function() { return __WEBPACK_IMPORTED_MODULE_9__src_selector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_selectorAll__ = __webpack_require__(415);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selectorAll", function() { return __WEBPACK_IMPORTED_MODULE_10__src_selectorAll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_selection_style__ = __webpack_require__(418);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "style", function() { return __WEBPACK_IMPORTED_MODULE_11__src_selection_style__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_touch__ = __webpack_require__(1057);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "touch", function() { return __WEBPACK_IMPORTED_MODULE_12__src_touch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_touches__ = __webpack_require__(1058);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "touches", function() { return __WEBPACK_IMPORTED_MODULE_13__src_touches__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_window__ = __webpack_require__(215);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "window", function() { return __WEBPACK_IMPORTED_MODULE_14__src_window__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_selection_on__ = __webpack_require__(212);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "event", function() { return __WEBPACK_IMPORTED_MODULE_15__src_selection_on__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "customEvent", function() { return __WEBPACK_IMPORTED_MODULE_15__src_selection_on__["a"]; });


















/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return root; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Selection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__select__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectAll__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enter__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__exit__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__merge__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__order__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sort__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__call__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__nodes__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__node__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__size__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__empty__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__each__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__attr__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__property__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__classed__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__text__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__html__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__raise__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lower__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__append__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__insert__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__remove__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__datum__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__on__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__dispatch__ = __webpack_require__(1055);






























var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection([[document.documentElement]], root);
}

Selection.prototype = selection.prototype = {
  constructor: Selection,
  select: __WEBPACK_IMPORTED_MODULE_0__select__["a" /* default */],
  selectAll: __WEBPACK_IMPORTED_MODULE_1__selectAll__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_2__filter__["a" /* default */],
  data: __WEBPACK_IMPORTED_MODULE_3__data__["a" /* default */],
  enter: __WEBPACK_IMPORTED_MODULE_4__enter__["b" /* default */],
  exit: __WEBPACK_IMPORTED_MODULE_5__exit__["a" /* default */],
  merge: __WEBPACK_IMPORTED_MODULE_6__merge__["a" /* default */],
  order: __WEBPACK_IMPORTED_MODULE_7__order__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_8__sort__["a" /* default */],
  call: __WEBPACK_IMPORTED_MODULE_9__call__["a" /* default */],
  nodes: __WEBPACK_IMPORTED_MODULE_10__nodes__["a" /* default */],
  node: __WEBPACK_IMPORTED_MODULE_11__node__["a" /* default */],
  size: __WEBPACK_IMPORTED_MODULE_12__size__["a" /* default */],
  empty: __WEBPACK_IMPORTED_MODULE_13__empty__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_14__each__["a" /* default */],
  attr: __WEBPACK_IMPORTED_MODULE_15__attr__["a" /* default */],
  style: __WEBPACK_IMPORTED_MODULE_16__style__["a" /* default */],
  property: __WEBPACK_IMPORTED_MODULE_17__property__["a" /* default */],
  classed: __WEBPACK_IMPORTED_MODULE_18__classed__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_19__text__["a" /* default */],
  html: __WEBPACK_IMPORTED_MODULE_20__html__["a" /* default */],
  raise: __WEBPACK_IMPORTED_MODULE_21__raise__["a" /* default */],
  lower: __WEBPACK_IMPORTED_MODULE_22__lower__["a" /* default */],
  append: __WEBPACK_IMPORTED_MODULE_23__append__["a" /* default */],
  insert: __WEBPACK_IMPORTED_MODULE_24__insert__["a" /* default */],
  remove: __WEBPACK_IMPORTED_MODULE_25__remove__["a" /* default */],
  datum: __WEBPACK_IMPORTED_MODULE_26__datum__["a" /* default */],
  on: __WEBPACK_IMPORTED_MODULE_27__on__["b" /* default */],
  dispatch: __WEBPACK_IMPORTED_MODULE_28__dispatch__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["b"] = (selection);


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CREATED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SCHEDULED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STARTING; });
/* unused harmony export STARTED */
/* unused harmony export RUNNING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENDED; });
/* harmony export (immutable) */ __webpack_exports__["g"] = init;
/* harmony export (immutable) */ __webpack_exports__["h"] = set;
/* harmony export (immutable) */ __webpack_exports__["f"] = get;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_timer__ = __webpack_require__(45);



var emptyOn = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("start", "end", "interrupt");
var emptyTween = [];

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

/* harmony default export */ __webpack_exports__["e"] = (function(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
});

function init(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id]) || schedule.state > CREATED) throw new Error("too late");
  return schedule;
}

function set(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id]) || schedule.state > STARTING) throw new Error("too late");
  return schedule;
}

function get(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("too late");
  return schedule;
}

function create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["c" /* timer */])(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["b" /* timeout */])(start);

      // Interrupt the active transition, if any.
      // Dispatch the interrupt event.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions. No interrupt event is dispatched
      // because the cancelled transitions never started. Note that this also
      // removes this transition from the pending list!
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["b" /* timeout */])(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(null, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return root; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Selection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__select__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectAll__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enter__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__exit__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__merge__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__order__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sort__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__call__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__nodes__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__node__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__size__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__empty__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__each__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__attr__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__property__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__classed__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__text__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__html__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__raise__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lower__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__append__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__insert__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__remove__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__datum__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__on__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__dispatch__ = __webpack_require__(1208);






























var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection([[document.documentElement]], root);
}

Selection.prototype = selection.prototype = {
  constructor: Selection,
  select: __WEBPACK_IMPORTED_MODULE_0__select__["a" /* default */],
  selectAll: __WEBPACK_IMPORTED_MODULE_1__selectAll__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_2__filter__["a" /* default */],
  data: __WEBPACK_IMPORTED_MODULE_3__data__["a" /* default */],
  enter: __WEBPACK_IMPORTED_MODULE_4__enter__["b" /* default */],
  exit: __WEBPACK_IMPORTED_MODULE_5__exit__["a" /* default */],
  merge: __WEBPACK_IMPORTED_MODULE_6__merge__["a" /* default */],
  order: __WEBPACK_IMPORTED_MODULE_7__order__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_8__sort__["a" /* default */],
  call: __WEBPACK_IMPORTED_MODULE_9__call__["a" /* default */],
  nodes: __WEBPACK_IMPORTED_MODULE_10__nodes__["a" /* default */],
  node: __WEBPACK_IMPORTED_MODULE_11__node__["a" /* default */],
  size: __WEBPACK_IMPORTED_MODULE_12__size__["a" /* default */],
  empty: __WEBPACK_IMPORTED_MODULE_13__empty__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_14__each__["a" /* default */],
  attr: __WEBPACK_IMPORTED_MODULE_15__attr__["a" /* default */],
  style: __WEBPACK_IMPORTED_MODULE_16__style__["a" /* default */],
  property: __WEBPACK_IMPORTED_MODULE_17__property__["a" /* default */],
  classed: __WEBPACK_IMPORTED_MODULE_18__classed__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_19__text__["a" /* default */],
  html: __WEBPACK_IMPORTED_MODULE_20__html__["a" /* default */],
  raise: __WEBPACK_IMPORTED_MODULE_21__raise__["a" /* default */],
  lower: __WEBPACK_IMPORTED_MODULE_22__lower__["a" /* default */],
  append: __WEBPACK_IMPORTED_MODULE_23__append__["a" /* default */],
  insert: __WEBPACK_IMPORTED_MODULE_24__insert__["a" /* default */],
  remove: __WEBPACK_IMPORTED_MODULE_25__remove__["a" /* default */],
  datum: __WEBPACK_IMPORTED_MODULE_26__datum__["a" /* default */],
  on: __WEBPACK_IMPORTED_MODULE_27__on__["b" /* default */],
  dispatch: __WEBPACK_IMPORTED_MODULE_28__dispatch__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["b"] = (selection);


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projection;
/* harmony export (immutable) */ __webpack_exports__["b"] = projectionMutator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clip_circle__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clip_rectangle__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__compose__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rotation__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transform__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fit__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resample__ = __webpack_require__(579);











var transformRadians = Object(__WEBPACK_IMPORTED_MODULE_7__transform__["a" /* transformer */])({
  point: function(x, y) {
    this.stream.point(x * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], y * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */]);
  }
});

function transformRotate(rotate) {
  return Object(__WEBPACK_IMPORTED_MODULE_7__transform__["a" /* transformer */])({
    point: function(x, y) {
      var r = rotate(x, y);
      return this.stream.point(r[0], r[1]);
    }
  });
}

function projection(project) {
  return projectionMutator(function() { return project; })();
}

function projectionMutator(projectAt) {
  var project,
      k = 150, // scale
      x = 480, y = 250, // translate
      dx, dy, lambda = 0, phi = 0, // center
      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
      theta = null, preclip = __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__["a" /* default */], // clip angle
      x0 = null, y0, x1, y1, postclip = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */], // clip extent
      delta2 = 0.5, projectResample = Object(__WEBPACK_IMPORTED_MODULE_9__resample__["a" /* default */])(projectTransform, delta2), // precision
      cache,
      cacheStream;

  function projection(point) {
    point = projectRotate(point[0] * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], point[1] * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */]);
    return [point[0] * k + dx, dy - point[1] * k];
  }

  function invert(point) {
    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
    return point && [point[0] * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], point[1] * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  }

  function projectTransform(x, y) {
    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
  }

  projection.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
  };

  projection.preclip = function(_) {
    return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
  };

  projection.postclip = function(_) {
    return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
  };

  projection.clipAngle = function(_) {
    return arguments.length ? (preclip = +_ ? Object(__WEBPACK_IMPORTED_MODULE_1__clip_circle__["a" /* default */])(theta = _ * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */]) : (theta = null, __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__["a" /* default */]), reset()) : theta * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */];
  };

  projection.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */]) : Object(__WEBPACK_IMPORTED_MODULE_2__clip_rectangle__["a" /* default */])(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  projection.scale = function(_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };

  projection.translate = function(_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };

  projection.center = function(_) {
    return arguments.length ? (lambda = _[0] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], phi = _[1] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], recenter()) : [lambda * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], phi * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  };

  projection.rotate = function(_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], deltaPhi = _[1] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], deltaGamma = _.length > 2 ? _[2] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */] : 0, recenter()) : [deltaLambda * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], deltaPhi * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], deltaGamma * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  };

  projection.precision = function(_) {
    return arguments.length ? (projectResample = Object(__WEBPACK_IMPORTED_MODULE_9__resample__["a" /* default */])(projectTransform, delta2 = _ * _), reset()) : Object(__WEBPACK_IMPORTED_MODULE_5__math__["u" /* sqrt */])(delta2);
  };

  projection.fitExtent = function(extent, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["a" /* fitExtent */])(projection, extent, object);
  };

  projection.fitSize = function(size, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["c" /* fitSize */])(projection, size, object);
  };

  projection.fitWidth = function(width, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["d" /* fitWidth */])(projection, width, object);
  };

  projection.fitHeight = function(height, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["b" /* fitHeight */])(projection, height, object);
  };

  function recenter() {
    projectRotate = Object(__WEBPACK_IMPORTED_MODULE_3__compose__["a" /* default */])(rotate = Object(__WEBPACK_IMPORTED_MODULE_6__rotation__["b" /* rotateRadians */])(deltaLambda, deltaPhi, deltaGamma), project);
    var center = project(lambda, phi);
    dx = x - center[0] * k;
    dy = y + center[1] * k;
    return reset();
  }

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return function() {
    project = projectAt.apply(this, arguments);
    projection.invert = project.invert && invert;
    return recenter();
  };
}


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_interval__ = __webpack_require__(13);
/* unused harmony reexport timeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_millisecond__ = __webpack_require__(748);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* unused harmony reexport timeMilliseconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* unused harmony reexport utcMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_second__ = __webpack_require__(749);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* unused harmony reexport timeSeconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* unused harmony reexport utcSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_minute__ = __webpack_require__(750);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__src_minute__["a"]; });
/* unused harmony reexport timeMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_hour__ = __webpack_require__(751);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__src_hour__["a"]; });
/* unused harmony reexport timeHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_day__ = __webpack_require__(752);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__src_day__["a"]; });
/* unused harmony reexport timeDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_week__ = __webpack_require__(753);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["b"]; });
/* unused harmony reexport timeWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["b"]; });
/* unused harmony reexport timeSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["a"]; });
/* unused harmony reexport timeMondays */
/* unused harmony reexport timeTuesday */
/* unused harmony reexport timeTuesdays */
/* unused harmony reexport timeWednesday */
/* unused harmony reexport timeWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["c"]; });
/* unused harmony reexport timeThursdays */
/* unused harmony reexport timeFriday */
/* unused harmony reexport timeFridays */
/* unused harmony reexport timeSaturday */
/* unused harmony reexport timeSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_month__ = __webpack_require__(754);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__src_month__["a"]; });
/* unused harmony reexport timeMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_year__ = __webpack_require__(755);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_8__src_year__["a"]; });
/* unused harmony reexport timeYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__ = __webpack_require__(756);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__["a"]; });
/* unused harmony reexport utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcHour__ = __webpack_require__(757);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcHour__["a"]; });
/* unused harmony reexport utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_utcDay__ = __webpack_require__(758);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__src_utcDay__["a"]; });
/* unused harmony reexport utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__ = __webpack_require__(759);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["b"]; });
/* unused harmony reexport utcWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["b"]; });
/* unused harmony reexport utcSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["a"]; });
/* unused harmony reexport utcMondays */
/* unused harmony reexport utcTuesday */
/* unused harmony reexport utcTuesdays */
/* unused harmony reexport utcWednesday */
/* unused harmony reexport utcWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["c"]; });
/* unused harmony reexport utcThursdays */
/* unused harmony reexport utcFriday */
/* unused harmony reexport utcFridays */
/* unused harmony reexport utcSaturday */
/* unused harmony reexport utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__ = __webpack_require__(760);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__["a"]; });
/* unused harmony reexport utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_utcYear__ = __webpack_require__(761);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_14__src_utcYear__["a"]; });
/* unused harmony reexport utcYears */































/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projection;
/* harmony export (immutable) */ __webpack_exports__["b"] = projectionMutator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clip_circle__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clip_extent__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__compose__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rotation__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transform__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fit__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resample__ = __webpack_require__(685);











var transformRadians = Object(__WEBPACK_IMPORTED_MODULE_7__transform__["b" /* transformer */])({
  point: function(x, y) {
    this.stream.point(x * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], y * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */]);
  }
});

function projection(project) {
  return projectionMutator(function() { return project; })();
}

function projectionMutator(projectAt) {
  var project,
      k = 150, // scale
      x = 480, y = 250, // translate
      dx, dy, lambda = 0, phi = 0, // center
      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
      theta = null, preclip = __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__["a" /* default */], // clip angle
      x0 = null, y0, x1, y1, postclip = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */], // clip extent
      delta2 = 0.5, projectResample = Object(__WEBPACK_IMPORTED_MODULE_9__resample__["a" /* default */])(projectTransform, delta2), // precision
      cache,
      cacheStream;

  function projection(point) {
    point = projectRotate(point[0] * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], point[1] * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */]);
    return [point[0] * k + dx, dy - point[1] * k];
  }

  function invert(point) {
    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
    return point && [point[0] * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], point[1] * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  }

  function projectTransform(x, y) {
    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
  }

  projection.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transformRadians(preclip(rotate, projectResample(postclip(cacheStream = stream))));
  };

  projection.clipAngle = function(_) {
    return arguments.length ? (preclip = +_ ? Object(__WEBPACK_IMPORTED_MODULE_1__clip_circle__["a" /* default */])(theta = _ * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], 6 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */]) : (theta = null, __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__["a" /* default */]), reset()) : theta * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */];
  };

  projection.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */]) : Object(__WEBPACK_IMPORTED_MODULE_2__clip_extent__["a" /* clipExtent */])(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  projection.scale = function(_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };

  projection.translate = function(_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };

  projection.center = function(_) {
    return arguments.length ? (lambda = _[0] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], phi = _[1] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], recenter()) : [lambda * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], phi * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  };

  projection.rotate = function(_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], deltaPhi = _[1] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */], deltaGamma = _.length > 2 ? _[2] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["r" /* radians */] : 0, recenter()) : [deltaLambda * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], deltaPhi * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], deltaGamma * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  };

  projection.precision = function(_) {
    return arguments.length ? (projectResample = Object(__WEBPACK_IMPORTED_MODULE_9__resample__["a" /* default */])(projectTransform, delta2 = _ * _), reset()) : Object(__WEBPACK_IMPORTED_MODULE_5__math__["u" /* sqrt */])(delta2);
  };

  projection.fitExtent = function(extent, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["a" /* fitExtent */])(projection, extent, object);
  };

  projection.fitSize = function(size, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit__["b" /* fitSize */])(projection, size, object);
  };

  function recenter() {
    projectRotate = Object(__WEBPACK_IMPORTED_MODULE_3__compose__["a" /* default */])(rotate = Object(__WEBPACK_IMPORTED_MODULE_6__rotation__["b" /* rotateRadians */])(deltaLambda, deltaPhi, deltaGamma), project);
    var center = project(lambda, phi);
    dx = x - center[0] * k;
    dy = y + center[1] * k;
    return reset();
  }

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return function() {
    project = projectAt.apply(this, arguments);
    projection.invert = project.invert && invert;
    return recenter();
  };
}


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(734);
/* unused harmony reexport formatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(320);
/* unused harmony reexport formatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__ = __webpack_require__(321);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__ = __webpack_require__(740);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__ = __webpack_require__(741);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__ = __webpack_require__(742);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__["a"]; });








/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return durationSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return durationMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durationDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(172);
/* unused harmony reexport timeFormatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* unused harmony reexport timeParse */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* unused harmony reexport utcParse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(326);
/* unused harmony reexport timeFormatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_isoFormat__ = __webpack_require__(327);
/* unused harmony reexport isoFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_isoParse__ = __webpack_require__(762);
/* unused harmony reexport isoParse */






/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_dispatch__ = __webpack_require__(773);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_dispatch__["a"]; });



/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_arc__ = __webpack_require__(987);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "arc", function() { return __WEBPACK_IMPORTED_MODULE_0__src_arc__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_area__ = __webpack_require__(388);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "area", function() { return __WEBPACK_IMPORTED_MODULE_1__src_area__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_line__ = __webpack_require__(204);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "line", function() { return __WEBPACK_IMPORTED_MODULE_2__src_line__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_pie__ = __webpack_require__(988);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pie", function() { return __WEBPACK_IMPORTED_MODULE_3__src_pie__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_radialArea__ = __webpack_require__(991);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "radialArea", function() { return __WEBPACK_IMPORTED_MODULE_4__src_radialArea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_radialLine__ = __webpack_require__(391);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "radialLine", function() { return __WEBPACK_IMPORTED_MODULE_5__src_radialLine__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_symbol__ = __webpack_require__(992);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbol", function() { return __WEBPACK_IMPORTED_MODULE_6__src_symbol__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbols", function() { return __WEBPACK_IMPORTED_MODULE_6__src_symbol__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_symbol_circle__ = __webpack_require__(392);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolCircle", function() { return __WEBPACK_IMPORTED_MODULE_7__src_symbol_circle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_symbol_cross__ = __webpack_require__(393);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolCross", function() { return __WEBPACK_IMPORTED_MODULE_8__src_symbol_cross__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_symbol_diamond__ = __webpack_require__(394);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolDiamond", function() { return __WEBPACK_IMPORTED_MODULE_9__src_symbol_diamond__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_symbol_square__ = __webpack_require__(396);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolSquare", function() { return __WEBPACK_IMPORTED_MODULE_10__src_symbol_square__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_symbol_star__ = __webpack_require__(395);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolStar", function() { return __WEBPACK_IMPORTED_MODULE_11__src_symbol_star__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_symbol_triangle__ = __webpack_require__(397);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolTriangle", function() { return __WEBPACK_IMPORTED_MODULE_12__src_symbol_triangle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_symbol_wye__ = __webpack_require__(398);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolWye", function() { return __WEBPACK_IMPORTED_MODULE_13__src_symbol_wye__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_curve_basisClosed__ = __webpack_require__(993);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_14__src_curve_basisClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_curve_basisOpen__ = __webpack_require__(994);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasisOpen", function() { return __WEBPACK_IMPORTED_MODULE_15__src_curve_basisOpen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_curve_basis__ = __webpack_require__(124);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasis", function() { return __WEBPACK_IMPORTED_MODULE_16__src_curve_basis__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_curve_bundle__ = __webpack_require__(995);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBundle", function() { return __WEBPACK_IMPORTED_MODULE_17__src_curve_bundle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_curve_cardinalClosed__ = __webpack_require__(399);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinalClosed", function() { return __WEBPACK_IMPORTED_MODULE_18__src_curve_cardinalClosed__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_curve_cardinalOpen__ = __webpack_require__(400);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinalOpen", function() { return __WEBPACK_IMPORTED_MODULE_19__src_curve_cardinalOpen__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_curve_cardinal__ = __webpack_require__(125);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinal", function() { return __WEBPACK_IMPORTED_MODULE_20__src_curve_cardinal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_curve_catmullRomClosed__ = __webpack_require__(996);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRomClosed", function() { return __WEBPACK_IMPORTED_MODULE_21__src_curve_catmullRomClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_curve_catmullRomOpen__ = __webpack_require__(997);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRomOpen", function() { return __WEBPACK_IMPORTED_MODULE_22__src_curve_catmullRomOpen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_curve_catmullRom__ = __webpack_require__(205);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRom", function() { return __WEBPACK_IMPORTED_MODULE_23__src_curve_catmullRom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_curve_linearClosed__ = __webpack_require__(998);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveLinearClosed", function() { return __WEBPACK_IMPORTED_MODULE_24__src_curve_linearClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_curve_linear__ = __webpack_require__(122);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveLinear", function() { return __WEBPACK_IMPORTED_MODULE_25__src_curve_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_curve_monotone__ = __webpack_require__(999);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveMonotoneX", function() { return __WEBPACK_IMPORTED_MODULE_26__src_curve_monotone__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveMonotoneY", function() { return __WEBPACK_IMPORTED_MODULE_26__src_curve_monotone__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_curve_natural__ = __webpack_require__(1000);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveNatural", function() { return __WEBPACK_IMPORTED_MODULE_27__src_curve_natural__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_curve_step__ = __webpack_require__(1001);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStep", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_step__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStepAfter", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_step__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStepBefore", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_step__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__src_stack__ = __webpack_require__(1002);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stack", function() { return __WEBPACK_IMPORTED_MODULE_29__src_stack__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__src_offset_expand__ = __webpack_require__(1004);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetExpand", function() { return __WEBPACK_IMPORTED_MODULE_30__src_offset_expand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__src_offset_none__ = __webpack_require__(83);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetNone", function() { return __WEBPACK_IMPORTED_MODULE_31__src_offset_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__src_offset_silhouette__ = __webpack_require__(1005);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetSilhouette", function() { return __WEBPACK_IMPORTED_MODULE_32__src_offset_silhouette__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__src_offset_wiggle__ = __webpack_require__(1006);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetWiggle", function() { return __WEBPACK_IMPORTED_MODULE_33__src_offset_wiggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__src_order_ascending__ = __webpack_require__(206);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderAscending", function() { return __WEBPACK_IMPORTED_MODULE_34__src_order_ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__src_order_descending__ = __webpack_require__(1007);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderDescending", function() { return __WEBPACK_IMPORTED_MODULE_35__src_order_descending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__src_order_insideOut__ = __webpack_require__(1008);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderInsideOut", function() { return __WEBPACK_IMPORTED_MODULE_36__src_order_insideOut__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__src_order_none__ = __webpack_require__(84);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderNone", function() { return __WEBPACK_IMPORTED_MODULE_37__src_order_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__src_order_reverse__ = __webpack_require__(1009);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderReverse", function() { return __WEBPACK_IMPORTED_MODULE_38__src_order_reverse__["a"]; });












































/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noop;
function noop() {}


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = mollweideBromleyTheta;
/* harmony export (immutable) */ __webpack_exports__["b"] = mollweideBromleyRaw;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mollweideRaw; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function mollweideBromleyTheta(cp, phi) {
  var cpsinPhi = cp * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi), i = 30, delta;
  do phi -= delta = (phi + Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi) - cpsinPhi) / (1 + Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi));
  while (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] && --i > 0);
  return phi / 2;
}

function mollweideBromleyRaw(cx, cy, cp) {

  function forward(lambda, phi) {
    return [cx * lambda * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi = mollweideBromleyTheta(cp, phi)), cy * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi)];
  }

  forward.invert = function(x, y) {
    return y = Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(y / cy), [x / (cx * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(y)), Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])((2 * y + Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(2 * y)) / cp)];
  };

  return forward;
}

var mollweideRaw = mollweideBromleyRaw(__WEBPACK_IMPORTED_MODULE_1__math__["D" /* sqrt2 */] / __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */], __WEBPACK_IMPORTED_MODULE_1__math__["D" /* sqrt2 */], __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]);

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(mollweideRaw)
      .scale(169.529);
});


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noop;
function noop() {}


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_nest__ = __webpack_require__(715);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "nest", function() { return __WEBPACK_IMPORTED_MODULE_0__src_nest__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_set__ = __webpack_require__(716);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "set", function() { return __WEBPACK_IMPORTED_MODULE_1__src_set__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_map__ = __webpack_require__(165);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "map", function() { return __WEBPACK_IMPORTED_MODULE_2__src_map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_keys__ = __webpack_require__(717);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "keys", function() { return __WEBPACK_IMPORTED_MODULE_3__src_keys__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_values__ = __webpack_require__(718);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "values", function() { return __WEBPACK_IMPORTED_MODULE_4__src_values__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_entries__ = __webpack_require__(719);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "entries", function() { return __WEBPACK_IMPORTED_MODULE_5__src_entries__["a"]; });








/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Transition;
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["b"] = newId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attr__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__attrTween__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__delay__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__duration__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ease__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filter__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__merge__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__on__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__remove__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__select__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectAll__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selection__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styleTween__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__text__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__transition__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__tween__ = __webpack_require__(113);



















var id = 0;

function Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function transition(name) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* selection */])().transition(name);
}

function newId() {
  return ++id;
}

var selection_prototype = __WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* selection */].prototype;

Transition.prototype = transition.prototype = {
  constructor: Transition,
  select: __WEBPACK_IMPORTED_MODULE_10__select__["a" /* default */],
  selectAll: __WEBPACK_IMPORTED_MODULE_11__selectAll__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_6__filter__["a" /* default */],
  merge: __WEBPACK_IMPORTED_MODULE_7__merge__["a" /* default */],
  selection: __WEBPACK_IMPORTED_MODULE_12__selection__["a" /* default */],
  transition: __WEBPACK_IMPORTED_MODULE_16__transition__["a" /* default */],
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: __WEBPACK_IMPORTED_MODULE_8__on__["a" /* default */],
  attr: __WEBPACK_IMPORTED_MODULE_1__attr__["a" /* default */],
  attrTween: __WEBPACK_IMPORTED_MODULE_2__attrTween__["a" /* default */],
  style: __WEBPACK_IMPORTED_MODULE_13__style__["a" /* default */],
  styleTween: __WEBPACK_IMPORTED_MODULE_14__styleTween__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_15__text__["a" /* default */],
  remove: __WEBPACK_IMPORTED_MODULE_9__remove__["a" /* default */],
  tween: __WEBPACK_IMPORTED_MODULE_17__tween__["a" /* default */],
  delay: __WEBPACK_IMPORTED_MODULE_3__delay__["a" /* default */],
  duration: __WEBPACK_IMPORTED_MODULE_4__duration__["a" /* default */],
  ease: __WEBPACK_IMPORTED_MODULE_5__ease__["a" /* default */]
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Handle = __webpack_require__(198);

var _Handle2 = _interopRequireDefault(_Handle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Subject = function (_React$Component) {
  _inherits(Subject, _React$Component);

  function Subject() {
    _classCallCheck(this, Subject);

    return _possibleConstructorReturn(this, (Subject.__proto__ || Object.getPrototypeOf(Subject)).apply(this, arguments));
  }

  _createClass(Subject, [{
    key: "getComponents",
    value: function getComponents() {}
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          editMode = _props.editMode,
          color = _props.color;


      var d = this.getComponents(this.props) || {};

      var handles = void 0;
      if (editMode) {
        handles = [_react2.default.createElement(_Handle2.default, {
          key: "subject-handle",
          handleStart: this.props.dragStart,
          handleStop: this.props.dragEnd,
          handleDrag: this.props.dragSubject
        })];

        if (d.handles) {
          handles = handles.concat(d.handles.map(function (h, i) {
            return _react2.default.createElement(_Handle2.default, {
              key: "subjecthandle-" + i,
              handleStart: _this2.props.dragStart,
              handleStop: _this2.props.dragEnd,
              x: h.x,
              y: h.y,
              offsetParent: h.offsetParent && _this2.subject,
              handleDrag: function handleDrag(e, data) {
                _this2.props.dragSubjectSettings(e, d.handleFunction(h, data));
              }
            });
          }));
        }
      }

      return _react2.default.createElement(
        "g",
        _extends({
          className: "annotation-subject"
        }, this.props.gAttrs, {
          ref: function ref(subject) {
            _this2.subject = subject;
          }
        }),
        d.components && d.components.map(function (c, i) {
          var attrs = {};
          if (!c) return null;
          Object.keys(c.attrs).forEach(function (k) {
            if (c.attrs[k] && k !== "text") {
              attrs[k.replace(/-([a-z])/g, function (g) {
                return g[1].toUpperCase();
              })] = c.attrs[k];
            }
          });
          return _react2.default.createElement(
            c.type,
            _extends({
              key: i,
              className: c.className,
              fill: "none",
              stroke: color
            }, attrs),
            c.attrs.text
          );
        }),
        handles
      );
    }
  }]);

  return Subject;
}(_react2.default.Component);

exports.default = Subject;

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Transition;
/* harmony export (immutable) */ __webpack_exports__["b"] = transition;
/* harmony export (immutable) */ __webpack_exports__["c"] = newId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attr__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__attrTween__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__delay__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__duration__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ease__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filter__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__merge__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__on__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__remove__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__select__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectAll__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selection__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styleTween__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__text__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__transition__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__tween__ = __webpack_require__(128);



















var id = 0;

function Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function transition(name) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["selection"])().transition(name);
}

function newId() {
  return ++id;
}

var selection_prototype = __WEBPACK_IMPORTED_MODULE_0_d3_selection__["selection"].prototype;

Transition.prototype = transition.prototype = {
  constructor: Transition,
  select: __WEBPACK_IMPORTED_MODULE_10__select__["a" /* default */],
  selectAll: __WEBPACK_IMPORTED_MODULE_11__selectAll__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_6__filter__["a" /* default */],
  merge: __WEBPACK_IMPORTED_MODULE_7__merge__["a" /* default */],
  selection: __WEBPACK_IMPORTED_MODULE_12__selection__["a" /* default */],
  transition: __WEBPACK_IMPORTED_MODULE_16__transition__["a" /* default */],
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: __WEBPACK_IMPORTED_MODULE_8__on__["a" /* default */],
  attr: __WEBPACK_IMPORTED_MODULE_1__attr__["a" /* default */],
  attrTween: __WEBPACK_IMPORTED_MODULE_2__attrTween__["a" /* default */],
  style: __WEBPACK_IMPORTED_MODULE_13__style__["a" /* default */],
  styleTween: __WEBPACK_IMPORTED_MODULE_14__styleTween__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_15__text__["a" /* default */],
  remove: __WEBPACK_IMPORTED_MODULE_9__remove__["a" /* default */],
  tween: __WEBPACK_IMPORTED_MODULE_17__tween__["a" /* default */],
  delay: __WEBPACK_IMPORTED_MODULE_3__delay__["a" /* default */],
  duration: __WEBPACK_IMPORTED_MODULE_4__duration__["a" /* default */],
  ease: __WEBPACK_IMPORTED_MODULE_5__ease__["a" /* default */]
};


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_value__ = __webpack_require__(216);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_array__ = __webpack_require__(423);
/* unused harmony reexport interpolateArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_basis__ = __webpack_require__(217);
/* unused harmony reexport interpolateBasis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__ = __webpack_require__(421);
/* unused harmony reexport interpolateBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_date__ = __webpack_require__(424);
/* unused harmony reexport interpolateDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_number__ = __webpack_require__(127);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__src_number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_object__ = __webpack_require__(425);
/* unused harmony reexport interpolateObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_round__ = __webpack_require__(1064);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__src_round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_string__ = __webpack_require__(426);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__src_string__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_transform_index__ = __webpack_require__(1065);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_zoom__ = __webpack_require__(1068);
/* unused harmony reexport interpolateZoom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_rgb__ = __webpack_require__(420);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["a"]; });
/* unused harmony reexport interpolateRgbBasis */
/* unused harmony reexport interpolateRgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_hsl__ = __webpack_require__(1069);
/* unused harmony reexport interpolateHsl */
/* unused harmony reexport interpolateHslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_lab__ = __webpack_require__(1070);
/* unused harmony reexport interpolateLab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_hcl__ = __webpack_require__(1071);
/* unused harmony reexport interpolateHcl */
/* unused harmony reexport interpolateHclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(1072);
/* unused harmony reexport interpolateCubehelix */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_quantize__ = __webpack_require__(1073);
/* unused harmony reexport quantize */



















/***/ }),
/* 39 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}

var streamObjectType = {
  Feature: function(object, stream) {
    streamGeometry(object.geometry, stream);
  },
  FeatureCollection: function(object, stream) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) streamGeometry(features[i].geometry, stream);
  }
};

var streamGeometryType = {
  Sphere: function(object, stream) {
    stream.sphere();
  },
  Point: function(object, stream) {
    object = object.coordinates;
    stream.point(object[0], object[1], object[2]);
  },
  MultiPoint: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
  },
  LineString: function(object, stream) {
    streamLine(object.coordinates, stream, 0);
  },
  MultiLineString: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamLine(coordinates[i], stream, 0);
  },
  Polygon: function(object, stream) {
    streamPolygon(object.coordinates, stream);
  },
  MultiPolygon: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamPolygon(coordinates[i], stream);
  },
  GeometryCollection: function(object, stream) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) streamGeometry(geometries[i], stream);
  }
};

function streamLine(coordinates, stream, closed) {
  var i = -1, n = coordinates.length - closed, coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}

function streamPolygon(coordinates, stream) {
  var i = -1, n = coordinates.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates[i], stream, 1);
  stream.polygonEnd();
}

/* harmony default export */ __webpack_exports__["a"] = (function(object, stream) {
  if (object && streamObjectType.hasOwnProperty(object.type)) {
    streamObjectType[object.type](object, stream);
  } else {
    streamGeometry(object, stream);
  }
});


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(1);




function pointEqual(a, b) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(a[0] - b[0]) < __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */] && Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(a[1] - b[1]) < __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */];
}

function interpolateLine(coordinates, m) {
  var i = -1,
      n = coordinates.length,
      p0 = coordinates[0],
      p1,
      dx,
      dy,
      resampled = [];
  while (++i < n) {
    p1 = coordinates[i];
    dx = (p1[0] - p0[0]) / m;
    dy = (p1[1] - p0[1]) / m;
    for (var j = 0; j < m; ++j) resampled.push([p0[0] + j * dx, p0[1] + j * dy]);
    p0 = p1;
  }
  resampled.push(p1);
  return resampled;
}

function interpolateSphere(lobes) {
  var coordinates = [],
      lobe,
      lambda0, phi0, phi1,
      lambda2, phi2,
      i, n = lobes[0].length;

  // Northern Hemisphere
  for (i = 0; i < n; ++i) {
    lobe = lobes[0][i];
    lambda0 = lobe[0][0], phi0 = lobe[0][1], phi1 = lobe[1][1];
    lambda2 = lobe[2][0], phi2 = lobe[2][1];
    coordinates.push(interpolateLine([
      [lambda0 + __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */], phi0 + __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */]],
      [lambda0 + __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */], phi1 - __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */]],
      [lambda2 - __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */], phi1 - __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */]],
      [lambda2 - __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */], phi2 + __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */]]
    ], 30));
  }

  // Southern Hemisphere
  for (i = lobes[1].length - 1; i >= 0; --i) {
    lobe = lobes[1][i];
    lambda0 = lobe[0][0], phi0 = lobe[0][1], phi1 = lobe[1][1];
    lambda2 = lobe[2][0], phi2 = lobe[2][1];
    coordinates.push(interpolateLine([
      [lambda2 - __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */], phi2 - __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */]],
      [lambda2 - __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */], phi1 + __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */]],
      [lambda0 + __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */], phi1 + __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */]],
      [lambda0 + __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */], phi0 - __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */]]
    ], 30));
  }

  return {
    type: "Polygon",
    coordinates: [Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["merge"])(coordinates)]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(project, lobes) {
  var sphere = interpolateSphere(lobes);

  lobes = lobes.map(function(lobe) {
    return lobe.map(function(l) {
      return [
        [l[0][0] * __WEBPACK_IMPORTED_MODULE_2__math__["v" /* radians */], l[0][1] * __WEBPACK_IMPORTED_MODULE_2__math__["v" /* radians */]],
        [l[1][0] * __WEBPACK_IMPORTED_MODULE_2__math__["v" /* radians */], l[1][1] * __WEBPACK_IMPORTED_MODULE_2__math__["v" /* radians */]],
        [l[2][0] * __WEBPACK_IMPORTED_MODULE_2__math__["v" /* radians */], l[2][1] * __WEBPACK_IMPORTED_MODULE_2__math__["v" /* radians */]]
      ];
    });
  });

  var bounds = lobes.map(function(lobe) {
    return lobe.map(function(l) {
      var x0 = project(l[0][0], l[0][1])[0],
          x1 = project(l[2][0], l[2][1])[0],
          y0 = project(l[1][0], l[0][1])[1],
          y1 = project(l[1][0], l[1][1])[1],
          t;
      if (y0 > y1) t = y0, y0 = y1, y1 = t;
      return [[x0, y0], [x1, y1]];
    });
  });

  function forward(lambda, phi) {
    var sign = phi < 0 ? -1 : +1, lobe = lobes[+(phi < 0)];
    for (var i = 0, n = lobe.length - 1; i < n && lambda > lobe[i][2][0]; ++i);
    var p = project(lambda - lobe[i][1][0], phi);
    p[0] += project(lobe[i][1][0], sign * phi > sign * lobe[i][0][1] ? lobe[i][0][1] : phi)[0];
    return p;
  }

  // Assumes mutually exclusive bounding boxes for lobes.
  if (project.invert) forward.invert = function(x, y) {
    var bound = bounds[+(y < 0)], lobe = lobes[+(y < 0)];
    for (var i = 0, n = bound.length; i < n; ++i) {
      var b = bound[i];
      if (b[0][0] <= x && x < b[1][0] && b[0][1] <= y && y < b[1][1]) {
        var p = project.invert(x - project(lobe[i][1][0], 0)[0], y);
        p[0] += lobe[i][1][0];
        return pointEqual(forward(p[0], p[1]), [x, y]) ? p : null;
      }
    }
  };

  var p = Object(__WEBPACK_IMPORTED_MODULE_1_d3_geo__["k" /* geoProjection */])(forward),
      stream_ = p.stream;

  p.stream = function(stream) {
    var rotate = p.rotate(),
        rotateStream = stream_(stream),
        sphereStream = (p.rotate([0, 0]), stream_(stream));
    p.rotate(rotate);
    rotateStream.sphere = function() { Object(__WEBPACK_IMPORTED_MODULE_1_d3_geo__["n" /* geoStream */])(sphere, sphereStream); };
    return rotateStream;
  };

  return p;
});


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_area__ = __webpack_require__(293);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoArea", function() { return __WEBPACK_IMPORTED_MODULE_0__src_area__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_bounds__ = __webpack_require__(670);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoBounds", function() { return __WEBPACK_IMPORTED_MODULE_1__src_bounds__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_centroid__ = __webpack_require__(671);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoCentroid", function() { return __WEBPACK_IMPORTED_MODULE_2__src_centroid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_circle__ = __webpack_require__(294);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoCircle", function() { return __WEBPACK_IMPORTED_MODULE_3__src_circle__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_clip_extent__ = __webpack_require__(157);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoClipExtent", function() { return __WEBPACK_IMPORTED_MODULE_4__src_clip_extent__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_contains__ = __webpack_require__(674);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoContains", function() { return __WEBPACK_IMPORTED_MODULE_5__src_contains__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_distance__ = __webpack_require__(300);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoDistance", function() { return __WEBPACK_IMPORTED_MODULE_6__src_distance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_graticule__ = __webpack_require__(675);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoGraticule", function() { return __WEBPACK_IMPORTED_MODULE_7__src_graticule__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoGraticule10", function() { return __WEBPACK_IMPORTED_MODULE_7__src_graticule__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_interpolate__ = __webpack_require__(676);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoInterpolate", function() { return __WEBPACK_IMPORTED_MODULE_8__src_interpolate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_length__ = __webpack_require__(301);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoLength", function() { return __WEBPACK_IMPORTED_MODULE_9__src_length__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_path_index__ = __webpack_require__(677);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoPath", function() { return __WEBPACK_IMPORTED_MODULE_10__src_path_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_projection_albers__ = __webpack_require__(303);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoAlbers", function() { return __WEBPACK_IMPORTED_MODULE_11__src_projection_albers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_projection_albersUsa__ = __webpack_require__(687);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoAlbersUsa", function() { return __WEBPACK_IMPORTED_MODULE_12__src_projection_albersUsa__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_projection_azimuthalEqualArea__ = __webpack_require__(688);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoAzimuthalEqualArea", function() { return __WEBPACK_IMPORTED_MODULE_13__src_projection_azimuthalEqualArea__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoAzimuthalEqualAreaRaw", function() { return __WEBPACK_IMPORTED_MODULE_13__src_projection_azimuthalEqualArea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_projection_azimuthalEquidistant__ = __webpack_require__(689);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoAzimuthalEquidistant", function() { return __WEBPACK_IMPORTED_MODULE_14__src_projection_azimuthalEquidistant__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoAzimuthalEquidistantRaw", function() { return __WEBPACK_IMPORTED_MODULE_14__src_projection_azimuthalEquidistant__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_projection_conicConformal__ = __webpack_require__(690);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoConicConformal", function() { return __WEBPACK_IMPORTED_MODULE_15__src_projection_conicConformal__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoConicConformalRaw", function() { return __WEBPACK_IMPORTED_MODULE_15__src_projection_conicConformal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_projection_conicEqualArea__ = __webpack_require__(159);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoConicEqualArea", function() { return __WEBPACK_IMPORTED_MODULE_16__src_projection_conicEqualArea__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoConicEqualAreaRaw", function() { return __WEBPACK_IMPORTED_MODULE_16__src_projection_conicEqualArea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_projection_conicEquidistant__ = __webpack_require__(691);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoConicEquidistant", function() { return __WEBPACK_IMPORTED_MODULE_17__src_projection_conicEquidistant__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoConicEquidistantRaw", function() { return __WEBPACK_IMPORTED_MODULE_17__src_projection_conicEquidistant__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_projection_equirectangular__ = __webpack_require__(305);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoEquirectangular", function() { return __WEBPACK_IMPORTED_MODULE_18__src_projection_equirectangular__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoEquirectangularRaw", function() { return __WEBPACK_IMPORTED_MODULE_18__src_projection_equirectangular__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_projection_gnomonic__ = __webpack_require__(692);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoGnomonic", function() { return __WEBPACK_IMPORTED_MODULE_19__src_projection_gnomonic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoGnomonicRaw", function() { return __WEBPACK_IMPORTED_MODULE_19__src_projection_gnomonic__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_projection_identity__ = __webpack_require__(693);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoIdentity", function() { return __WEBPACK_IMPORTED_MODULE_20__src_projection_identity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_projection_index__ = __webpack_require__(25);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoProjection", function() { return __WEBPACK_IMPORTED_MODULE_21__src_projection_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoProjectionMutator", function() { return __WEBPACK_IMPORTED_MODULE_21__src_projection_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_projection_mercator__ = __webpack_require__(162);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoMercator", function() { return __WEBPACK_IMPORTED_MODULE_22__src_projection_mercator__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoMercatorRaw", function() { return __WEBPACK_IMPORTED_MODULE_22__src_projection_mercator__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_projection_orthographic__ = __webpack_require__(694);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoOrthographic", function() { return __WEBPACK_IMPORTED_MODULE_23__src_projection_orthographic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoOrthographicRaw", function() { return __WEBPACK_IMPORTED_MODULE_23__src_projection_orthographic__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_projection_stereographic__ = __webpack_require__(695);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoStereographic", function() { return __WEBPACK_IMPORTED_MODULE_24__src_projection_stereographic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoStereographicRaw", function() { return __WEBPACK_IMPORTED_MODULE_24__src_projection_stereographic__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_projection_transverseMercator__ = __webpack_require__(696);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoTransverseMercator", function() { return __WEBPACK_IMPORTED_MODULE_25__src_projection_transverseMercator__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoTransverseMercatorRaw", function() { return __WEBPACK_IMPORTED_MODULE_25__src_projection_transverseMercator__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_rotation__ = __webpack_require__(105);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoRotation", function() { return __WEBPACK_IMPORTED_MODULE_26__src_rotation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_stream__ = __webpack_require__(43);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoStream", function() { return __WEBPACK_IMPORTED_MODULE_27__src_stream__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_transform__ = __webpack_require__(106);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoTransform", function() { return __WEBPACK_IMPORTED_MODULE_28__src_transform__["a"]; });




 // DEPRECATED! Use d3.geoIdentity().clipExtent(…).


























/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}

var streamObjectType = {
  Feature: function(object, stream) {
    streamGeometry(object.geometry, stream);
  },
  FeatureCollection: function(object, stream) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) streamGeometry(features[i].geometry, stream);
  }
};

var streamGeometryType = {
  Sphere: function(object, stream) {
    stream.sphere();
  },
  Point: function(object, stream) {
    object = object.coordinates;
    stream.point(object[0], object[1], object[2]);
  },
  MultiPoint: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
  },
  LineString: function(object, stream) {
    streamLine(object.coordinates, stream, 0);
  },
  MultiLineString: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamLine(coordinates[i], stream, 0);
  },
  Polygon: function(object, stream) {
    streamPolygon(object.coordinates, stream);
  },
  MultiPolygon: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamPolygon(coordinates[i], stream);
  },
  GeometryCollection: function(object, stream) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) streamGeometry(geometries[i], stream);
  }
};

function streamLine(coordinates, stream, closed) {
  var i = -1, n = coordinates.length - closed, coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}

function streamPolygon(coordinates, stream) {
  var i = -1, n = coordinates.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates[i], stream, 1);
  stream.polygonEnd();
}

/* harmony default export */ __webpack_exports__["a"] = (function(object, stream) {
  if (object && streamObjectType.hasOwnProperty(object.type)) {
    streamObjectType[object.type](object, stream);
  } else {
    streamGeometry(object, stream);
  }
});


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_timer__ = __webpack_require__(181);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_timer__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_timer__["c"]; });
/* unused harmony reexport timerFlush */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_timeout__ = __webpack_require__(813);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_timeout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_interval__ = __webpack_require__(814);
/* unused harmony reexport interval */







/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function constant() {
    return x;
  };
});


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnotationCalloutCustom = exports.AnnotationBracket = exports.AnnotationBadge = exports.AnnotationXYThreshold = exports.AnnotationCalloutRect = exports.AnnotationCalloutElbow = exports.AnnotationCalloutCurve = exports.AnnotationCalloutCircle = exports.AnnotationCallout = exports.AnnotationLabel = exports.EditableAnnotation = exports.Annotation = exports.BracketNote = exports.Note = exports.SubjectCustom = exports.SubjectBracket = exports.SubjectThreshold = exports.SubjectRect = exports.SubjectCircle = exports.SubjectBadge = exports.Subject = exports.ConnectorEndArrow = exports.ConnectorEndDot = exports.ConnectorLine = exports.ConnectorElbow = exports.ConnectorCurve = exports.Connector = undefined;

var _Connector = __webpack_require__(121);

var _Connector2 = _interopRequireDefault(_Connector);

var _ConnectorCurve = __webpack_require__(373);

var _ConnectorCurve2 = _interopRequireDefault(_ConnectorCurve);

var _ConnectorElbow = __webpack_require__(375);

var _ConnectorElbow2 = _interopRequireDefault(_ConnectorElbow);

var _ConnectorLine = __webpack_require__(376);

var _ConnectorLine2 = _interopRequireDefault(_ConnectorLine);

var _ConnectorEndDot = __webpack_require__(377);

var _ConnectorEndDot2 = _interopRequireDefault(_ConnectorEndDot);

var _ConnectorEndArrow = __webpack_require__(379);

var _ConnectorEndArrow2 = _interopRequireDefault(_ConnectorEndArrow);

var _Subject = __webpack_require__(36);

var _Subject2 = _interopRequireDefault(_Subject);

var _SubjectBadge = __webpack_require__(380);

var _SubjectBadge2 = _interopRequireDefault(_SubjectBadge);

var _SubjectCircle = __webpack_require__(381);

var _SubjectCircle2 = _interopRequireDefault(_SubjectCircle);

var _SubjectRect = __webpack_require__(382);

var _SubjectRect2 = _interopRequireDefault(_SubjectRect);

var _SubjectThreshold = __webpack_require__(383);

var _SubjectThreshold2 = _interopRequireDefault(_SubjectThreshold);

var _SubjectBracket = __webpack_require__(384);

var _SubjectBracket2 = _interopRequireDefault(_SubjectBracket);

var _SubjectCustom = __webpack_require__(385);

var _SubjectCustom2 = _interopRequireDefault(_SubjectCustom);

var _Note = __webpack_require__(199);

var _Note2 = _interopRequireDefault(_Note);

var _BracketNote = __webpack_require__(386);

var _BracketNote2 = _interopRequireDefault(_BracketNote);

var _Annotation = __webpack_require__(201);

var _Annotation2 = _interopRequireDefault(_Annotation);

var _EditableAnnotation = __webpack_require__(387);

var _EditableAnnotation2 = _interopRequireDefault(_EditableAnnotation);

var _Types = __webpack_require__(984);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// export individual components
exports.Connector = _Connector2.default;
exports.ConnectorCurve = _ConnectorCurve2.default;
exports.ConnectorElbow = _ConnectorElbow2.default;
exports.ConnectorLine = _ConnectorLine2.default;
exports.ConnectorEndDot = _ConnectorEndDot2.default;
exports.ConnectorEndArrow = _ConnectorEndArrow2.default;
exports.Subject = _Subject2.default;
exports.SubjectBadge = _SubjectBadge2.default;
exports.SubjectCircle = _SubjectCircle2.default;
exports.SubjectRect = _SubjectRect2.default;
exports.SubjectThreshold = _SubjectThreshold2.default;
exports.SubjectBracket = _SubjectBracket2.default;
exports.SubjectCustom = _SubjectCustom2.default;
exports.Note = _Note2.default;
exports.BracketNote = _BracketNote2.default;
exports.Annotation = _Annotation2.default;
exports.EditableAnnotation = _EditableAnnotation2.default;
exports.AnnotationLabel = _Types.AnnotationLabel;
exports.AnnotationCallout = _Types.AnnotationCallout;
exports.AnnotationCalloutCircle = _Types.AnnotationCalloutCircle;
exports.AnnotationCalloutCurve = _Types.AnnotationCalloutCurve;
exports.AnnotationCalloutElbow = _Types.AnnotationCalloutElbow;
exports.AnnotationCalloutRect = _Types.AnnotationCalloutRect;
exports.AnnotationXYThreshold = _Types.AnnotationXYThreshold;
exports.AnnotationBadge = _Types.AnnotationBadge;
exports.AnnotationBracket = _Types.AnnotationBracket;
exports.AnnotationCalloutCustom = _Types.AnnotationCalloutCustom;
exports.default = {
  Connector: _Connector2.default,
  ConnectorCurve: _ConnectorCurve2.default,
  ConnectorElbow: _ConnectorElbow2.default,
  ConnectorLine: _ConnectorLine2.default,
  ConnectorEndDot: _ConnectorEndDot2.default,
  ConnectorEndArrow: _ConnectorEndArrow2.default,
  Subject: _Subject2.default,
  SubjectBadge: _SubjectBadge2.default,
  SubjectCircle: _SubjectCircle2.default,
  SubjectRect: _SubjectRect2.default,
  SubjectThreshold: _SubjectThreshold2.default,
  SubjectBracket: _SubjectBracket2.default,
  SubjectCustom: _SubjectCustom2.default,
  Note: _Note2.default,
  BracketNote: _BracketNote2.default,
  Annotation: _Annotation2.default,
  EditableAnnotation: _EditableAnnotation2.default,
  AnnotationLabel: _Types.AnnotationLabel,
  AnnotationCallout: _Types.AnnotationCallout,
  AnnotationCalloutCircle: _Types.AnnotationCalloutCircle,
  AnnotationCalloutCurve: _Types.AnnotationCalloutCurve,
  AnnotationCalloutElbow: _Types.AnnotationCalloutElbow,
  AnnotationCalloutRect: _Types.AnnotationCalloutRect,
  AnnotationXYThreshold: _Types.AnnotationXYThreshold,
  AnnotationBadge: _Types.AnnotationBadge,
  AnnotationBracket: _Types.AnnotationBracket,
  AnnotationCalloutCustom: _Types.AnnotationCalloutCustom
};

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new Adder;
});

function Adder() {
  this.reset();
}

Adder.prototype = {
  constructor: Adder,
  reset: function() {
    this.s = // rounded value
    this.t = 0; // exact error
  },
  add: function(y) {
    add(temp, y, this.t);
    add(this, temp.s, this.s);
    if (this.s) this.t += temp.t;
    else this.s = temp.t;
  },
  valueOf: function() {
    return this.s;
  }
};

var temp = new Adder;

function add(adder, a, b) {
  var x = adder.s = a + b,
      bv = x - a,
      av = x - bv;
  adder.t = (a - av) + (b - bv);
}


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = (function(projectAt) {
  var phi0 = 0,
      m = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["l" /* geoProjectionMutator */])(projectAt),
      p = m(phi0);

  p.parallel = function(_) {
    return arguments.length ? m(phi0 = _ * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */]) : phi0 * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */];
  };

  return p;
});


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new Adder;
});

function Adder() {
  this.reset();
}

Adder.prototype = {
  constructor: Adder,
  reset: function() {
    this.s = // rounded value
    this.t = 0; // exact error
  },
  add: function(y) {
    add(temp, y, this.t);
    add(this, temp.s, this.s);
    if (this.s) this.t += temp.t;
    else this.s = temp.t;
  },
  valueOf: function() {
    return this.s;
  }
};

var temp = new Adder;

function add(adder, a, b) {
  var x = adder.s = a + b,
      bv = x - a,
      av = x - bv;
  adder.t = (a - av) + (b - bv);
}


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Math.random();
});


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactAnnotation = __webpack_require__(48);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SemioticAnnotation = function (_React$Component) {
  _inherits(SemioticAnnotation, _React$Component);

  function SemioticAnnotation() {
    _classCallCheck(this, SemioticAnnotation);

    return _possibleConstructorReturn(this, (SemioticAnnotation.__proto__ || Object.getPrototypeOf(SemioticAnnotation)).apply(this, arguments));
  }

  _createClass(SemioticAnnotation, [{
    key: "render",
    value: function render() {
      var noteData = this.props.noteData;
      var screenCoordinates = noteData.screenCoordinates;


      noteData.type = typeof noteData.type === "function" ? noteData.type : _reactAnnotation.AnnotationLabel;

      var eventListeners = noteData.eventListeners || {};

      if (noteData.coordinates && screenCoordinates) {
        //Multisubject annotation
        var setNX = noteData.nx || screenCoordinates[0][0] + noteData.dx;
        var setNY = noteData.ny || screenCoordinates[0][1] + noteData.dy;
        var notes = screenCoordinates.map(function (d, i) {
          var subjectNote = _extends({}, noteData, {
            note: i === 0 ? noteData.note : { label: "" },
            x: d[0],
            y: d[1],
            nx: setNX,
            ny: setNY
          });

          return _react2.default.createElement(noteData.type, _extends({ key: "multi-annotation-" + i }, subjectNote));
        });

        return _react2.default.createElement(
          "g",
          { events: eventListeners },
          notes
        );
      }

      return _react2.default.createElement(noteData.type, _extends({ events: eventListeners }, noteData));
    }
  }]);

  return SemioticAnnotation;
}(_react2.default.Component);

SemioticAnnotation.propTypes = {
  noteData: _propTypes2.default.object
};

exports.default = SemioticAnnotation;
module.exports = exports['default'];

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function constant() {
    return x;
  };
});


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function constant() {
    return x;
  };
});


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// components

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Scale = __webpack_require__(92);

var _axis = __webpack_require__(226);

var _Axis = __webpack_require__(137);

var _Axis2 = _interopRequireDefault(_Axis);

var _DownloadButton = __webpack_require__(227);

var _DownloadButton2 = _interopRequireDefault(_DownloadButton);

var _Frame = __webpack_require__(228);

var _Frame2 = _interopRequireDefault(_Frame);

var _xyframeRules = __webpack_require__(1217);

var _general = __webpack_require__(1239);

var _lineDrawing = __webpack_require__(126);

var _reactAnnotation = __webpack_require__(48);

var _frameFunctions = __webpack_require__(141);

var _downloadDataMapping = __webpack_require__(245);

var _coordinateNames = __webpack_require__(475);

var _dataFunctions = __webpack_require__(143);

var _jsx = __webpack_require__(246);

var _frame_props = __webpack_require__(247);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var emptyObjectReturnFunction = function emptyObjectReturnFunction() {
  return {};
};
var emptyStringReturnFunction = function emptyStringReturnFunction() {
  return "";
};

var xyframeKey = "";
var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
for (var i = 32; i > 0; --i) {
  xyframeKey += chars[Math.floor(Math.random() * chars.length)];
}var xyframeSettings = ["margin"];

var projectedCoordinateNames = {
  y: _coordinateNames.projectedY,
  x: _coordinateNames.projectedX,
  yMiddle: _coordinateNames.projectedYMiddle,
  yTop: _coordinateNames.projectedYTop,
  yBottom: _coordinateNames.projectedYBottom
};

function mapParentsToPoints(fullDataset) {
  return fullDataset.map(function (d) {
    if (d.parentLine) {
      return _extends({}, d, d.parentLine);
    }
    if (d.parentArea) {
      return _extends({}, d, d.parentArea);
    }
    return d;
  });
}

var XYFrame = (_temp = _class = function (_React$Component) {
  _inherits(XYFrame, _React$Component);

  function XYFrame(props) {
    _classCallCheck(this, XYFrame);

    var _this = _possibleConstructorReturn(this, (XYFrame.__proto__ || Object.getPrototypeOf(XYFrame)).call(this, props));

    _this.calculateXYFrame = _this.calculateXYFrame.bind(_this);

    _this.renderBody = _this.renderBody.bind(_this);

    _this.state = {
      lineData: null,
      pointData: null,
      areaData: null,
      projectedLines: null,
      projectedPoints: null,
      projectedAreas: null,
      fullDataset: null,
      adjustedPosition: null,
      adjustedSize: null,
      backgroundGraphics: null,
      foregroundGraphics: null,
      axesData: null,
      axes: null,
      renderNumber: 0,
      margin: { top: 0, bottom: 0, left: 0, right: 0 }
    };

    _this.xAccessor = null;
    _this.yAccessor = null;
    _this.xScale = null;
    _this.yScale = null;

    _this.settingsMap = new Map();
    xyframeSettings.forEach(function (d) {
      _this.settingsMap.set(d, new Map());
    });
    return _this;
  }

  _createClass(XYFrame, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.calculateXYFrame(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.state.dataVersion && this.state.dataVersion !== nextProps.dataVersion || !this.state.fullDataset) {
        this.calculateXYFrame(nextProps);
      } else if (this.state.size[0] !== nextProps.size[0] || this.state.size[1] !== nextProps.size[1] || !this.state.dataVersion && _frame_props.xyFrameChangeProps.find(function (d) {
        return _this2.props[d] !== nextProps[d];
      })) {
        this.calculateXYFrame(nextProps);
      }
    }
  }, {
    key: "screenScales",
    value: function screenScales(_ref) {
      var xExtent = _ref.xExtent,
          yExtent = _ref.yExtent,
          currentProps = _ref.currentProps,
          adjustedSize = _ref.adjustedSize;

      var xDomain = [0, adjustedSize[0]];
      var yDomain = [adjustedSize[1], 0];

      var xScaleType = currentProps.xScaleType || (0, _d3Scale.scaleLinear)();
      var yScaleType = currentProps.yScaleType || (0, _d3Scale.scaleLinear)();

      var xScale = xScaleType;
      var yScale = yScaleType;

      if (xScaleType.domain) {
        xScaleType.domain(xExtent);
      }
      if (yScaleType.domain) {
        yScaleType.domain(yExtent);
      }
      xScaleType.range(xDomain);
      yScaleType.range(yDomain);

      return { xScale: xScale, yScale: yScale };
    }
  }, {
    key: "calculateXYFrame",
    value: function calculateXYFrame(currentProps) {
      var margin = (0, _frameFunctions.calculateMargin)(currentProps);

      var _adjustedPositionSize = (0, _frameFunctions.adjustedPositionSize)(currentProps),
          adjustedPosition = _adjustedPositionSize.adjustedPosition,
          adjustedSize = _adjustedPositionSize.adjustedSize;

      var legend = currentProps.legend,
          lines = currentProps.lines,
          lineClass = currentProps.lineClass,
          pointStyle = currentProps.pointStyle,
          pointRenderMode = currentProps.pointRenderMode,
          pointClass = currentProps.pointClass,
          areaClass = currentProps.areaClass,
          canvasLines = currentProps.canvasLines,
          canvasPoints = currentProps.canvasPoints,
          canvasAreas = currentProps.canvasAreas,
          defined = currentProps.defined,
          size = currentProps.size,
          renderKey = currentProps.renderKey,
          lineType = currentProps.lineType,
          customLineMark = currentProps.customLineMark,
          customPointMark = currentProps.customPointMark,
          customAreaMark = currentProps.customAreaMark,
          areaStyle = currentProps.areaStyle,
          areaRenderMode = currentProps.areaRenderMode,
          lineStyle = currentProps.lineStyle,
          lineRenderMode = currentProps.lineRenderMode,
          baseXExtent = currentProps.xExtent,
          baseYExtent = currentProps.yExtent;
      var projectedLines = currentProps.projectedLines,
          projectedPoints = currentProps.projectedPoints,
          projectedAreas = currentProps.projectedAreas,
          fullDataset = currentProps.fullDataset;


      var xExtentSettings = baseXExtent === undefined || Array.isArray(baseXExtent) ? { extent: baseXExtent } : baseXExtent;
      var yExtentSettings = baseYExtent === undefined || Array.isArray(baseYExtent) ? { extent: baseYExtent } : baseYExtent;

      var xExtent = xExtentSettings.extent;
      var yExtent = yExtentSettings.extent;

      var calculatedXExtent = void 0,
          calculatedYExtent = void 0;

      var xAccessor = (0, _dataFunctions.stringToFn)(currentProps.xAccessor);
      var yAccessor = (0, _dataFunctions.stringToFn)(currentProps.yAccessor);
      var lineIDAccessor = (0, _dataFunctions.stringToFn)(currentProps.lineIDAccessor, function (l) {
        return l.semioticLineID;
      });

      if (!currentProps.dataVersion || currentProps.dataVersion && currentProps.dataVersion !== this.state.dataVersion) {
        if (!xExtent || !yExtent || !fullDataset || !projectedLines && !projectedPoints && !projectedAreas) {
          ;
          var _calculateDataExtent = (0, _dataFunctions.calculateDataExtent)(_extends({}, currentProps, { xExtent: xExtent, yExtent: yExtent }));

          xExtent = _calculateDataExtent.xExtent;
          yExtent = _calculateDataExtent.yExtent;
          projectedLines = _calculateDataExtent.projectedLines;
          projectedPoints = _calculateDataExtent.projectedPoints;
          projectedAreas = _calculateDataExtent.projectedAreas;
          fullDataset = _calculateDataExtent.fullDataset;
          calculatedXExtent = _calculateDataExtent.calculatedXExtent;
          calculatedYExtent = _calculateDataExtent.calculatedYExtent;
        }
      } else {
        ;var _state = this.state;
        xExtent = _state.xExtent;
        yExtent = _state.yExtent;
        projectedLines = _state.projectedLines;
        projectedPoints = _state.projectedPoints;
        projectedAreas = _state.projectedAreas;
        fullDataset = _state.fullDataset;
        calculatedXExtent = _state.calculatedXExtent;
        calculatedYExtent = _state.calculatedYExtent;
      }

      var _screenScales = this.screenScales({
        xExtent: xExtent,
        yExtent: yExtent,
        currentProps: currentProps,
        margin: margin,
        adjustedSize: adjustedSize
      }),
          xScale = _screenScales.xScale,
          yScale = _screenScales.yScale;

      var canvasDrawing = [];

      var title = (0, _frameFunctions.generateFrameTitle)(currentProps);

      //TODO: blow this shit up
      this.xScale = xScale;
      this.yScale = yScale;
      this.xAccessor = xAccessor;
      this.yAccessor = yAccessor;

      var axes = null;
      var axesTickLines = null;

      var existingBaselines = {};

      if (currentProps.axes) {
        axesTickLines = [];
        axes = currentProps.axes.map(function (d, i) {
          var axisClassname = d.className || "";
          axisClassname += " axis";
          var axisScale = yScale;
          if (existingBaselines[d.orient]) {
            d.baseline = d.baseline || false;
          }
          existingBaselines[d.orient] = true;
          if (d.orient === "top" || d.orient === "bottom") {
            axisClassname += " x";
            axisScale = xScale;
          } else {
            axisClassname += " y";
          }
          axisClassname += " " + d.orient;

          var tickValues = void 0;
          if (d.tickValues && Array.isArray(d.tickValues)) {
            tickValues = d.tickValues;
          } else if (d.tickValues) {
            //otherwise assume a function
            tickValues = d.tickValues(fullDataset, currentProps.size, axisScale);
          }
          var axisSize = [adjustedSize[0], adjustedSize[1]];

          var axisParts = (0, _axis.axisPieces)({
            padding: d.padding,
            tickValues: tickValues,
            scale: axisScale,
            ticks: d.ticks,
            orient: d.orient,
            size: axisSize,
            margin: margin,
            footer: d.footer,
            tickSize: d.tickSize
          });
          var axisTickLines = _react2.default.createElement(
            "g",
            { key: "axes-tick-lines-" + i, className: "axis " + axisClassname },
            (0, _axis.axisLines)({
              axisParts: axisParts,
              orient: d.orient,
              tickLineGenerator: d.tickLineGenerator
            })
          );
          axesTickLines.push(axisTickLines);
          return _react2.default.createElement(_Axis2.default, {
            label: d.label,
            axisParts: axisParts,
            key: d.key || "axis-" + i,
            orient: d.orient,
            size: axisSize,
            margin: margin,
            ticks: d.ticks,
            tickSize: d.tickSize,
            tickFormat: d.tickFormat,
            tickValues: tickValues,
            format: d.format,
            scale: axisScale,
            className: axisClassname,
            name: d.name,
            padding: d.padding,
            rotate: d.rotate,
            annotationFunction: d.axisAnnotationFunction,
            glyphFunction: d.glyphFunction,
            baseline: d.baseline
          });
        });
      }

      var marginGraphic = void 0;
      if (currentProps.matte) {
        marginGraphic = _react2.default.createElement("path", {
          fill: "white",
          transform: "translate(" + -margin.left + "," + -margin.top + ")",
          d: (0, _frameFunctions.drawMarginPath)({
            margin: margin,
            size: size,
            inset: currentProps.matte.inset
          }),
          className: "xyframe-matte"
        });
      }

      var legendSettings = void 0;

      if (legend) {
        legendSettings = legend === true ? {} : legend;
        if (lines && !legendSettings.legendGroups) {
          var typeString = lineType && lineType.type ? lineType.type : lineType;
          var type = ["stackedarea", "stackedpercent", "bumparea"].indexOf(typeString) === -1 ? "line" : "fill";
          var legendGroups = [{
            styleFn: currentProps.lineStyle,
            type: type,
            items: currentProps.lines.map(function (d) {
              return _extends({ label: lineIDAccessor(d) }, d);
            })
          }];
          legendSettings.legendGroups = legendGroups;
        }
      }
      var areaAnnotations = [];
      var areaType = currentProps.areaType;
      if (areaType && areaType.label && projectedAreas) {
        projectedAreas.forEach(function (d, i) {
          if (d.bounds) {
            var bounds = Array.isArray(d.bounds) ? d.bounds : [d.bounds];
            bounds.forEach(function (labelBounds) {
              var label = typeof areaType.label === "function" ? areaType.label(d) : areaType.label;
              if (label && label !== null) {
                var labelPosition = label.position || "center";
                var labelCenter = [xScale(labelBounds[labelPosition][0]), yScale(labelBounds[labelPosition][1])] || [xScale(d._xyfCoordinates[0]), yScale(d._xyfCoordinates[1])];
                var labelContent = label.content || function (p) {
                  return p.value || p.id || i;
                };

                areaAnnotations.push({
                  x: labelCenter[0],
                  y: labelCenter[1],
                  dx: label.dx,
                  dy: label.dy,
                  className: label.className,
                  type: label.type || _reactAnnotation.AnnotationCallout,
                  note: label.note || { title: labelContent(d) },
                  subject: label.subject || { text: labelContent(d) },
                  connector: label.connector
                });
              }
            });
          }
        });
      }

      var xyFrameRender = {
        lines: {
          data: projectedLines,
          styleFn: (0, _dataFunctions.stringToFn)(lineStyle, emptyObjectReturnFunction, true),
          classFn: (0, _dataFunctions.stringToFn)(lineClass, emptyStringReturnFunction, true),
          renderMode: (0, _dataFunctions.stringToFn)(lineRenderMode, undefined, true),
          canvasRender: (0, _dataFunctions.stringToFn)(canvasLines, undefined, true),
          customMark: customLineMark,
          type: lineType,
          defined: defined,
          renderKeyFn: (0, _dataFunctions.stringToFn)(renderKey, function (d, i) {
            return "line-" + i;
          }, true),
          behavior: _general.createLines
        },
        areas: {
          data: projectedAreas,
          styleFn: (0, _dataFunctions.stringToFn)(areaStyle, emptyObjectReturnFunction, true),
          classFn: (0, _dataFunctions.stringToFn)(areaClass, emptyStringReturnFunction, true),
          renderMode: (0, _dataFunctions.stringToFn)(areaRenderMode, undefined, true),
          canvasRender: (0, _dataFunctions.stringToFn)(canvasAreas, undefined, true),
          customMark: customAreaMark,
          type: areaType,
          renderKeyFn: (0, _dataFunctions.stringToFn)(renderKey, function (d, i) {
            return "area-" + i;
          }, true),
          behavior: _general.createAreas
        },
        points: {
          data: projectedPoints,
          styleFn: (0, _dataFunctions.stringToFn)(pointStyle, emptyObjectReturnFunction, true),
          classFn: (0, _dataFunctions.stringToFn)(pointClass, emptyStringReturnFunction, true),
          renderMode: (0, _dataFunctions.stringToFn)(pointRenderMode, undefined, true),
          canvasRender: (0, _dataFunctions.stringToFn)(canvasPoints, undefined, true),
          customMark: (0, _dataFunctions.stringToFn)(customPointMark, undefined, true),
          renderKeyFn: (0, _dataFunctions.stringToFn)(renderKey, function (d, i) {
            return "point-" + i;
          }, true),
          behavior: _general.createPoints
        }
      };

      if (xExtentSettings.onChange && (this.state.calculatedXExtent || []).join(",") !== (calculatedXExtent || []).join(",")) {
        xExtentSettings.onChange(calculatedXExtent);
      }
      if (yExtentSettings.onChange && (this.state.calculatedYExtent || []).join(",") !== (calculatedYExtent || []).join(",")) {
        yExtentSettings.onChange(calculatedYExtent);
      }

      this.setState({
        lineData: currentProps.lines,
        pointData: currentProps.points,
        areaData: currentProps.areas,
        dataVersion: currentProps.dataVersion,
        projectedLines: projectedLines,
        projectedPoints: projectedPoints,
        projectedAreas: projectedAreas,
        canvasDrawing: canvasDrawing,
        fullDataset: fullDataset,
        adjustedPosition: adjustedPosition,
        adjustedSize: adjustedSize,
        backgroundGraphics: currentProps.backgroundGraphics,
        foregroundGraphics: currentProps.foregroundGraphics,
        axesData: currentProps.axes,
        axes: axes,
        axesTickLines: axesTickLines,
        title: title,
        updatedFrame: undefined,
        renderNumber: this.state.renderNumber + 1,
        xScale: xScale,
        yScale: yScale,
        xExtent: xExtent,
        yExtent: yExtent,
        calculatedXExtent: calculatedXExtent,
        calculatedYExtent: calculatedYExtent,
        margin: margin,
        legendSettings: legendSettings,
        matte: marginGraphic,
        areaAnnotations: areaAnnotations,
        xyFrameRender: xyFrameRender,
        size: size
      });
    }
  }, {
    key: "defaultXYSVGRule",
    value: function defaultXYSVGRule(_ref2) {
      var d = _ref2.d,
          i = _ref2.i,
          annotationLayer = _ref2.annotationLayer,
          lines = _ref2.lines,
          areas = _ref2.areas,
          points = _ref2.points;

      var xAccessor = this.xAccessor;
      var yAccessor = this.yAccessor;

      var xScale = this.xScale;
      var yScale = this.yScale;

      var screenCoordinates = [];
      var idAccessor = (0, _dataFunctions.stringToFn)(this.props.lineIDAccessor, function (l) {
        return l.semioticLineID;
      });

      var _adjustedPositionSize2 = (0, _frameFunctions.adjustedPositionSize)(this.props),
          adjustedPosition = _adjustedPositionSize2.adjustedPosition,
          adjustedSize = _adjustedPositionSize2.adjustedSize;

      if (!d.coordinates) {
        var xCoord = d[_coordinateNames.projectedX] || xAccessor(d);
        screenCoordinates = [xScale(xCoord), (0, _lineDrawing.relativeY)({
          point: d,
          lines: lines,
          projectedYMiddle: _coordinateNames.projectedYMiddle,
          projectedY: _coordinateNames.projectedY,
          projectedX: _coordinateNames.projectedX,
          xAccessor: xAccessor,
          yAccessor: yAccessor,
          yScale: yScale,
          xScale: xScale,
          idAccessor: idAccessor
        })];
        if (screenCoordinates[0] === undefined || screenCoordinates[1] === undefined || screenCoordinates[0] === null || screenCoordinates[1] === null) {
          //NO ANNOTATION IF INVALID SCREEN COORDINATES
          return null;
        }
      } else if (!d.bounds) {
        screenCoordinates = d.coordinates.map(function (p) {
          return [xScale(xAccessor(p)) + adjustedPosition[0], (0, _lineDrawing.relativeY)({
            point: p,
            lines: lines,
            projectedYMiddle: _coordinateNames.projectedYMiddle,
            projectedY: _coordinateNames.projectedY,
            projectedX: _coordinateNames.projectedX,
            xAccessor: xAccessor,
            yAccessor: yAccessor,
            yScale: yScale,
            xScale: xScale,
            idAccessor: idAccessor
          }) + adjustedPosition[1]];
        });
      }

      var margin = (0, _frameFunctions.calculateMargin)(this.props);

      //point xy
      //y
      //area

      //TODO: Process your rules first
      if (this.props.svgAnnotationRules && this.props.svgAnnotationRules({
        d: d,
        i: i,
        screenCoordinates: screenCoordinates,
        xScale: xScale,
        yScale: yScale,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        xyFrameProps: this.props,
        xyFrameState: this.state,
        areas: areas,
        points: points,
        lines: lines
      }) !== null) {
        return this.props.svgAnnotationRules({
          d: d,
          i: i,
          screenCoordinates: screenCoordinates,
          xScale: xScale,
          yScale: yScale,
          xAccessor: xAccessor,
          yAccessor: yAccessor,
          xyFrameProps: this.props,
          xyFrameState: this.state,
          areas: areas,
          points: points,
          lines: lines
        });
      } else if (d.type === "xy" || d.type === "frame-hover") {
        return (0, _xyframeRules.svgXYAnnotation)({ d: d, screenCoordinates: screenCoordinates, i: i });
      } else if (d.type === "react-annotation" || typeof d.type === "function") {
        return (0, _xyframeRules.basicReactAnnotation)({ d: d, screenCoordinates: screenCoordinates, i: i });
      } else if (d.type === "enclose") {
        return (0, _xyframeRules.svgEncloseAnnotation)({ d: d, screenCoordinates: screenCoordinates, i: i });
      } else if (d.type === "enclose-rect") {
        return (0, _xyframeRules.svgRectEncloseRule)({ d: d, screenCoordinates: screenCoordinates, i: i });
      } else if (d.type === "x") {
        return (0, _xyframeRules.svgXAnnotation)({
          d: d,
          screenCoordinates: screenCoordinates,
          i: i,
          annotationLayer: annotationLayer,
          adjustedSize: adjustedSize,
          margin: margin
        });
      } else if (d.type === "y") {
        return (0, _xyframeRules.svgYAnnotation)({
          d: d,
          screenCoordinates: screenCoordinates,
          i: i,
          annotationLayer: annotationLayer,
          adjustedSize: adjustedSize,
          adjustedPosition: adjustedPosition,
          margin: margin
        });
      } else if (d.type === "bounds") {
        return (0, _xyframeRules.svgBoundsAnnotation)({
          screenCoordinates: screenCoordinates,
          d: d,
          i: i,
          adjustedSize: adjustedSize,
          adjustedPosition: adjustedPosition,
          xAccessor: xAccessor,
          yAccessor: yAccessor,
          xScale: xScale,
          yScale: yScale,
          margin: margin
        });
      } else if (d.type === "line") {
        return (0, _xyframeRules.svgLineAnnotation)({ d: d, i: i, screenCoordinates: screenCoordinates });
      } else if (d.type === "area") {
        return (0, _xyframeRules.svgAreaAnnotation)({
          d: d,
          i: i,
          screenCoordinates: screenCoordinates,
          xScale: xScale,
          xAccessor: xAccessor,
          yScale: yScale,
          yAccessor: yAccessor,
          annotationLayer: annotationLayer
        });
      } else if (d.type === "horizontal-points") {
        return (0, _xyframeRules.svgHorizontalPointsAnnotation)({
          d: d,
          lines: lines.data,
          points: points.data,
          xScale: xScale,
          yScale: yScale,
          pointStyle: points.styleFn
        });
      } else if (d.type === "vertical-points") {
        return (0, _xyframeRules.svgVerticalPointsAnnotation)({
          d: d,
          lines: lines.data,
          points: points.data,
          xScale: xScale,
          yScale: yScale,
          pointStyle: points.styleFn
        });
      }
      return null;
    }
  }, {
    key: "defaultXYHTMLRule",
    value: function defaultXYHTMLRule(_ref3) {
      var d = _ref3.d,
          i = _ref3.i,
          lines = _ref3.lines,
          areas = _ref3.areas,
          points = _ref3.points;

      var xAccessor = this.xAccessor;
      var yAccessor = this.yAccessor;

      var xScale = this.xScale;
      var yScale = this.yScale;

      var screenCoordinates = [];

      var size = this.props.size;


      var idAccessor = (0, _dataFunctions.stringToFn)(this.props.lineIDAccessor, function (l) {
        return l.semioticLineID;
      });
      var xCoord = d[_coordinateNames.projectedX] || xAccessor(d);
      var yCoord = d[_coordinateNames.projectedY] || yAccessor(d);

      var xString = xCoord && xCoord.toString ? xCoord.toString() : xCoord;
      var yString = yCoord && yCoord.toString ? yCoord.toString() : yCoord;

      var _adjustedPositionSize3 = (0, _frameFunctions.adjustedPositionSize)(this.props),
          adjustedPosition = _adjustedPositionSize3.adjustedPosition;

      if (!d.coordinates) {
        screenCoordinates = [xScale(xCoord), (0, _lineDrawing.relativeY)({
          point: d,
          lines: lines,
          projectedYMiddle: _coordinateNames.projectedYMiddle,
          projectedY: _coordinateNames.projectedY,
          projectedX: _coordinateNames.projectedX,
          xAccessor: xAccessor,
          yAccessor: yAccessor,
          yScale: yScale,
          xScale: xScale,
          idAccessor: idAccessor
        })];
        if (screenCoordinates[0] === undefined || screenCoordinates[1] === undefined || screenCoordinates[0] === null || screenCoordinates[1] === null) {
          //NO ANNOTATION IF INVALID SCREEN COORDINATES
          return null;
        }
      } else {
        screenCoordinates = d.coordinates.map(function (p) {
          return [xScale(xAccessor(p)) + adjustedPosition[0], (0, _lineDrawing.relativeY)({
            point: p,
            lines: lines,
            projectedYMiddle: _coordinateNames.projectedYMiddle,
            projectedY: _coordinateNames.projectedY,
            projectedX: _coordinateNames.projectedX,
            xAccessor: xAccessor,
            yAccessor: yAccessor,
            yScale: yScale,
            xScale: xScale,
            idAccessor: idAccessor
          }) + adjustedPosition[1]];
        });
      }

      if (this.props.htmlAnnotationRules && this.props.htmlAnnotationRules({
        d: d,
        i: i,
        screenCoordinates: screenCoordinates,
        xScale: xScale,
        yScale: yScale,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        xyFrameProps: this.props,
        xyFrameState: this.state,
        areas: areas,
        points: points,
        lines: lines
      }) !== null) {
        return this.props.htmlAnnotationRules({
          d: d,
          i: i,
          screenCoordinates: screenCoordinates,
          xScale: xScale,
          yScale: yScale,
          xAccessor: xAccessor,
          yAccessor: yAccessor,
          xyFrameProps: this.props,
          xyFrameState: this.state,
          areas: areas,
          points: points,
          lines: lines
        });
      }
      if (d.type === "frame-hover") {
        var content = _react2.default.createElement(
          "div",
          { className: "tooltip-content" },
          _react2.default.createElement(
            "p",
            { key: "html-annotation-content-1" },
            xString
          ),
          _react2.default.createElement(
            "p",
            { key: "html-annotation-content-2" },
            yString
          ),
          d.percent ? _react2.default.createElement(
            "p",
            { key: "html-annotation-content-3" },
            parseInt(d.percent * 1000, 10) / 10,
            "%"
          ) : null
        );

        if (d.type === "frame-hover" && this.props.tooltipContent) {
          content = this.props.tooltipContent(d);
        }
        return (0, _xyframeRules.htmlTooltipAnnotation)({
          content: content,
          screenCoordinates: screenCoordinates,
          size: size,
          i: i,
          d: d
        });
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderBody({});
    }
  }, {
    key: "renderBody",
    value: function renderBody(_ref4) {
      var afterElements = _ref4.afterElements,
          beforeElements = _ref4.beforeElements;
      var _props = this.props,
          downloadFields = _props.downloadFields,
          xAccessor = _props.xAccessor,
          yAccessor = _props.yAccessor,
          lines = _props.lines,
          points = _props.points,
          areas = _props.areas,
          name = _props.name,
          download = _props.download,
          size = _props.size,
          className = _props.className,
          annotationSettings = _props.annotationSettings,
          annotations = _props.annotations,
          additionalDefs = _props.additionalDefs,
          hoverAnnotation = _props.hoverAnnotation,
          interaction = _props.interaction,
          customClickBehavior = _props.customClickBehavior,
          customHoverBehavior = _props.customHoverBehavior,
          customDoubleClickBehavior = _props.customDoubleClickBehavior,
          canvasPostProcess = _props.canvasPostProcess,
          baseMarkProps = _props.baseMarkProps,
          useSpans = _props.useSpans;
      var _state2 = this.state,
          title = _state2.title,
          backgroundGraphics = _state2.backgroundGraphics,
          foregroundGraphics = _state2.foregroundGraphics,
          adjustedPosition = _state2.adjustedPosition,
          adjustedSize = _state2.adjustedSize,
          margin = _state2.margin,
          matte = _state2.matte,
          axes = _state2.axes,
          axesTickLines = _state2.axesTickLines,
          extent = _state2.extent,
          xScale = _state2.xScale,
          yScale = _state2.yScale,
          dataVersion = _state2.dataVersion,
          fullDataset = _state2.fullDataset,
          areaAnnotations = _state2.areaAnnotations,
          legendSettings = _state2.legendSettings,
          xyFrameRender = _state2.xyFrameRender;


      var downloadButton = void 0;
      if (download) {
        var downloadData = download === "points" ? mapParentsToPoints(fullDataset) : points || lines || areas;
        downloadButton = _react2.default.createElement(_DownloadButton2.default, {
          csvName: name + "-" + new Date().toJSON(),
          width: parseInt(size[0], 10),
          data: (0, _downloadDataMapping.xyDownloadMapping)({
            data: downloadData,
            xAccessor: download === "points" || points ? (0, _dataFunctions.stringToFn)(xAccessor) : undefined,
            yAccessor: download === "points" || points ? (0, _dataFunctions.stringToFn)(yAccessor) : undefined,
            fields: downloadFields
          })
        });
      }

      var finalFilterDefs = (0, _jsx.filterDefs)({
        matte: matte,
        key: matte && (this.props.frameKey || xyframeKey),
        additionalDefs: additionalDefs
      });

      // foreground and background graphics should handle either JSX or a function that passes size & margin and returns JSX
      return _react2.default.createElement(_Frame2.default, {
        name: "xyframe",
        renderPipeline: xyFrameRender,
        adjustedPosition: adjustedPosition,
        size: size,
        extent: extent,
        projectedCoordinateNames: projectedCoordinateNames,
        xScale: xScale,
        yScale: yScale,
        axes: axes,
        axesTickLines: axesTickLines,
        title: title,
        dataVersion: dataVersion,
        matte: matte,
        className: className,
        adjustedSize: adjustedSize,
        finalFilterDefs: finalFilterDefs,
        frameKey: xyframeKey,
        hoverAnnotation: hoverAnnotation,
        defaultSVGRule: this.defaultXYSVGRule.bind(this),
        defaultHTMLRule: this.defaultXYHTMLRule.bind(this),
        annotations: areaAnnotations.length > 0 ? [].concat(_toConsumableArray(annotations), _toConsumableArray(areaAnnotations)) : annotations,
        annotationSettings: annotationSettings,
        legendSettings: legendSettings,
        projectedYMiddle: _coordinateNames.projectedYMiddle,
        interaction: interaction,
        customClickBehavior: customClickBehavior,
        customHoverBehavior: customHoverBehavior,
        customDoubleClickBehavior: customDoubleClickBehavior,
        points: fullDataset,
        margin: margin,
        backgroundGraphics: backgroundGraphics,
        foregroundGraphics: foregroundGraphics,
        beforeElements: beforeElements,
        afterElements: afterElements,
        downloadButton: downloadButton,
        disableContext: this.props.disableContext,
        canvasPostProcess: canvasPostProcess,
        baseMarkProps: baseMarkProps,
        useSpans: useSpans
      });
    }
  }]);

  return XYFrame;
}(_react2.default.Component), _class.defaultProps = {
  annotations: [],
  foregroundGraphics: undefined,
  size: [500, 500],
  className: "",
  lineType: "line",
  name: "xyframe"
}, _temp);


XYFrame.propTypes = {
  name: _propTypes2.default.string,
  lines: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  points: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  areas: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  margin: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object]),
  dataVersion: _propTypes2.default.string,
  frameKey: _propTypes2.default.string,
  axes: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  matte: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
  size: _propTypes2.default.array,
  position: _propTypes2.default.array,
  xScaleType: _propTypes2.default.func,
  yScaleType: _propTypes2.default.func,
  xExtent: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  yExtent: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  invertX: _propTypes2.default.bool,
  invertY: _propTypes2.default.bool,
  xAccessor: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  yAccessor: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  lineDataAccessor: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  areaDataAccessor: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  backgroundGraphics: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  foregroundGraphics: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  canvasPostProcess: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  additionalDefs: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  customHoverBehavior: _propTypes2.default.func,
  customClickBehavior: _propTypes2.default.func,
  customDoubleclickBehavior: _propTypes2.default.func,
  lineType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  showLinePoints: _propTypes2.default.bool,
  defined: _propTypes2.default.func,
  lineStyle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  pointStyle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  areaStyle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  lineClass: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  pointClass: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  areaClass: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  canvasPoints: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.bool]),
  customPointMark: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  hoverAnnotation: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array, _propTypes2.default.func, _propTypes2.default.bool]),
  customLineMark: _propTypes2.default.func,
  customAreaMark: _propTypes2.default.func,
  lineIDAccessor: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  svgAnnotationRules: _propTypes2.default.func,
  htmlAnnotationRules: _propTypes2.default.func,
  tooltipContent: _propTypes2.default.func,
  annotations: _propTypes2.default.array,
  interaction: _propTypes2.default.object,
  baseMarkProps: _propTypes2.default.object,
  download: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]), //add a download button for graphs data as csv
  downloadFields: _propTypes2.default.array //additional fields aside from x,y to add to the csv
};

exports.default = XYFrame;
module.exports = exports['default'];

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_value__ = __webpack_require__(223);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolate", function() { return __WEBPACK_IMPORTED_MODULE_0__src_value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_array__ = __webpack_require__(449);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateArray", function() { return __WEBPACK_IMPORTED_MODULE_1__src_array__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_basis__ = __webpack_require__(224);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateBasis", function() { return __WEBPACK_IMPORTED_MODULE_2__src_basis__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__ = __webpack_require__(447);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_date__ = __webpack_require__(450);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateDate", function() { return __WEBPACK_IMPORTED_MODULE_4__src_date__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_number__ = __webpack_require__(135);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateNumber", function() { return __WEBPACK_IMPORTED_MODULE_5__src_number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_object__ = __webpack_require__(451);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateObject", function() { return __WEBPACK_IMPORTED_MODULE_6__src_object__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_round__ = __webpack_require__(1143);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRound", function() { return __WEBPACK_IMPORTED_MODULE_7__src_round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_string__ = __webpack_require__(452);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateString", function() { return __WEBPACK_IMPORTED_MODULE_8__src_string__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_transform_index__ = __webpack_require__(1144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateTransformCss", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateTransformSvg", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_zoom__ = __webpack_require__(1147);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateZoom", function() { return __WEBPACK_IMPORTED_MODULE_10__src_zoom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_rgb__ = __webpack_require__(446);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgb", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgbBasis", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgbBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_hsl__ = __webpack_require__(1148);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHsl", function() { return __WEBPACK_IMPORTED_MODULE_12__src_hsl__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHslLong", function() { return __WEBPACK_IMPORTED_MODULE_12__src_hsl__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_lab__ = __webpack_require__(1149);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateLab", function() { return __WEBPACK_IMPORTED_MODULE_13__src_lab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_hcl__ = __webpack_require__(1150);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHcl", function() { return __WEBPACK_IMPORTED_MODULE_14__src_hcl__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHclLong", function() { return __WEBPACK_IMPORTED_MODULE_14__src_hcl__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(1151);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelix", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelixLong", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_quantize__ = __webpack_require__(1152);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "quantize", function() { return __WEBPACK_IMPORTED_MODULE_16__src_quantize__["a"]; });



















/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = spherical;
/* harmony export (immutable) */ __webpack_exports__["a"] = cartesian;
/* harmony export (immutable) */ __webpack_exports__["d"] = cartesianDot;
/* harmony export (immutable) */ __webpack_exports__["c"] = cartesianCross;
/* harmony export (immutable) */ __webpack_exports__["b"] = cartesianAddInPlace;
/* harmony export (immutable) */ __webpack_exports__["f"] = cartesianScale;
/* harmony export (immutable) */ __webpack_exports__["e"] = cartesianNormalizeInPlace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(4);


function spherical(cartesian) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(cartesian[1], cartesian[0]), Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(cartesian[2])];
}

function cartesian(spherical) {
  var lambda = spherical[0], phi = spherical[1], cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  return [cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda), cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda), Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi)];
}

function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}

function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}

// TODO return a
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}

function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}

// TODO return d
function cartesianNormalizeInPlace(d) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = azimuthalRaw;
/* harmony export (immutable) */ __webpack_exports__["a"] = azimuthalInvert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(4);


function azimuthalRaw(scale) {
  return function(x, y) {
    var cx = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x),
        cy = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y),
        k = scale(cx * cy);
    return [
      k * cy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x),
      k * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y)
    ];
  }
}

function azimuthalInvert(angle) {
  return function(x, y) {
    var z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + y * y),
        c = angle(z),
        sc = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(c),
        cc = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(c);
    return [
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x * sc, z * cc),
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(z && y * sc / z)
    ];
  }
}


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = sinusoidalRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function sinusoidalRaw(lambda, phi) {
  return [lambda * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi), phi];
}

sinusoidalRaw.invert = function(x, y) {
  return [x / Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(y), y];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(sinusoidalRaw)
      .scale(152.63);
});


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = spherical;
/* harmony export (immutable) */ __webpack_exports__["a"] = cartesian;
/* harmony export (immutable) */ __webpack_exports__["d"] = cartesianDot;
/* harmony export (immutable) */ __webpack_exports__["c"] = cartesianCross;
/* harmony export (immutable) */ __webpack_exports__["b"] = cartesianAddInPlace;
/* harmony export (immutable) */ __webpack_exports__["f"] = cartesianScale;
/* harmony export (immutable) */ __webpack_exports__["e"] = cartesianNormalizeInPlace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(6);


function spherical(cartesian) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(cartesian[1], cartesian[0]), Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(cartesian[2])];
}

function cartesian(spherical) {
  var lambda = spherical[0], phi = spherical[1], cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  return [cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda), cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda), Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi)];
}

function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}

function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}

// TODO return a
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}

function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}

// TODO return d
function cartesianNormalizeInPlace(d) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = azimuthalRaw;
/* harmony export (immutable) */ __webpack_exports__["a"] = azimuthalInvert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(6);


function azimuthalRaw(scale) {
  return function(x, y) {
    var cx = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x),
        cy = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y),
        k = scale(cx * cy);
    return [
      k * cy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x),
      k * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y)
    ];
  }
}

function azimuthalInvert(angle) {
  return function(x, y) {
    var z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + y * y),
        c = angle(z),
        sc = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(c),
        cc = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(c);
    return [
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x * sc, z * cc),
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(z && y * sc / z)
    ];
  }
}


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateResizeFactor = calculateResizeFactor;
exports.calculateMousePosition = calculateMousePosition;
exports.isChildOfType = isChildOfType;
exports.createNewChildren = createNewChildren;
exports.roundPath = roundPath;
exports.createConnectorPath = createConnectorPath;
exports.createTextAnchor = createTextAnchor;
exports.computeBackdrop = computeBackdrop;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function calculateResizeFactor(actualDimension, baseDimension) {
  return 1 / 100 * (100 / actualDimension * baseDimension);
}

function calculateMousePosition(direction, projection, props, zoom, resizeFactor) {
  var center = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : props.center;
  var width = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : props.width;
  var height = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : props.height;

  var reference = { x: 0, y: 1 };
  var canRotate = !!projection.rotate;
  var reverseRotation = !!canRotate ? projection.rotate().map(function (item) {
    return -item;
  }) : false;
  var point = !!reverseRotation ? projection.rotate(reverseRotation)([-center[0], -center[1]]) : projection([center[0], center[1]]);
  var returner = point ? (point[reference[direction]] - (reference[direction] === 0 ? width : height) / 2) * zoom * (1 / resizeFactor) : 0;
  return !!reverseRotation ? returner : -returner;
}

function isChildOfType(child, expectedType) {
  return child.props.componentIdentifier === expectedType;
}

function createNewChildren(children, props) {
  if (!children) return;
  if (!children.length) {
    return isChildOfType(children, "Geographies") ? _react2.default.cloneElement(children, {
      projection: props.projection
    }) : isChildOfType(children, "Markers") || isChildOfType(children, "Annotations") || isChildOfType(children, "Annotation") || isChildOfType(child, "Graticule") ? _react2.default.cloneElement(children, {
      projection: props.projection,
      zoom: props.zoom,
      width: props.width,
      height: props.height
    }) : children;
  } else {
    return children.map(function (child, i) {
      if (!child) return;
      return isChildOfType(child, "Geographies") ? _react2.default.cloneElement(child, {
        key: "zoomable-child-" + i,
        projection: props.projection
      }) : isChildOfType(child, "Markers") || isChildOfType(child, "Annotations") || isChildOfType(child, "Annotation") || isChildOfType(child, "Graticule") ? _react2.default.cloneElement(child, {
        key: "zoomable-child-" + i,
        projection: props.projection,
        zoom: props.zoom,
        width: props.width,
        height: props.height
      }) : child;
    });
  }
}

function roundPath(path, precision) {
  if (!path) return;
  var query = /[\d\.-][\d\.e-]*/g;
  return path.replace(query, function (n) {
    return Math.round(n * (1 / precision)) / (1 / precision);
  });
}

function createConnectorPath(connectorType, endPoint, curve) {
  var e0 = endPoint[0];
  var e1 = endPoint[1];
  return "M0,0 Q " + (curve + 1) / 2 * e0 + "," + (e1 - (curve + 1) / 2 * e1) + " " + e0 + "," + e1;
}

function createTextAnchor(dx) {
  if (dx > 0) return "start";else if (dx < 0) return "end";else return "middle";
}

function computeBackdrop(projection, backdrop) {
  var canRotate = projection.rotate;

  var tl = canRotate ? projection.rotate([0, 0, 0])([backdrop.x[0], backdrop.y[0]]) : projection([backdrop.x[0], backdrop.y[0]]);

  var br = canRotate ? projection.rotate([0, 0, 0])([backdrop.x[1], backdrop.y[1]]) : projection([backdrop.x[1], backdrop.y[1]]);

  var x = tl ? tl[0] : 0;
  var x0 = br ? br[0] : 0;

  var y = tl ? tl[1] : 0;
  var y0 = br ? br[1] : 0;

  var width = x0 - x;
  var height = y0 - y;

  return { x: x, y: y, width: width, height: height };
}

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = linearish;
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(733);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["ticks"])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickIncrement"])(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickIncrement"])(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickIncrement"])(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateNumber */]);

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, linear());
  };

  return linearish(scale);
}


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hue;
/* harmony export (immutable) */ __webpack_exports__["b"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(314);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_quadtree__ = __webpack_require__(856);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_quadtree__["a"]; });



/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (x1 - x0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
});


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = linearish;
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(921);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["ticks"])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickIncrement"])(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickIncrement"])(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickIncrement"])(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateNumber */]);

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, linear());
  };

  return linearish(scale);
}


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
});


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_arc__ = __webpack_require__(936);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "arc", function() { return __WEBPACK_IMPORTED_MODULE_0__src_arc__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_area__ = __webpack_require__(354);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "area", function() { return __WEBPACK_IMPORTED_MODULE_1__src_area__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_line__ = __webpack_require__(192);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "line", function() { return __WEBPACK_IMPORTED_MODULE_2__src_line__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_pie__ = __webpack_require__(937);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pie", function() { return __WEBPACK_IMPORTED_MODULE_3__src_pie__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_areaRadial__ = __webpack_require__(940);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "areaRadial", function() { return __WEBPACK_IMPORTED_MODULE_4__src_areaRadial__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "radialArea", function() { return __WEBPACK_IMPORTED_MODULE_4__src_areaRadial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_lineRadial__ = __webpack_require__(356);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lineRadial", function() { return __WEBPACK_IMPORTED_MODULE_5__src_lineRadial__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "radialLine", function() { return __WEBPACK_IMPORTED_MODULE_5__src_lineRadial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_pointRadial__ = __webpack_require__(357);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pointRadial", function() { return __WEBPACK_IMPORTED_MODULE_6__src_pointRadial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_link_index__ = __webpack_require__(941);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "linkHorizontal", function() { return __WEBPACK_IMPORTED_MODULE_7__src_link_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "linkVertical", function() { return __WEBPACK_IMPORTED_MODULE_7__src_link_index__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "linkRadial", function() { return __WEBPACK_IMPORTED_MODULE_7__src_link_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_symbol__ = __webpack_require__(942);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbol", function() { return __WEBPACK_IMPORTED_MODULE_8__src_symbol__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbols", function() { return __WEBPACK_IMPORTED_MODULE_8__src_symbol__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_symbol_circle__ = __webpack_require__(359);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__src_symbol_circle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_symbol_cross__ = __webpack_require__(360);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolCross", function() { return __WEBPACK_IMPORTED_MODULE_10__src_symbol_cross__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_symbol_diamond__ = __webpack_require__(361);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolDiamond", function() { return __WEBPACK_IMPORTED_MODULE_11__src_symbol_diamond__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_symbol_square__ = __webpack_require__(363);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolSquare", function() { return __WEBPACK_IMPORTED_MODULE_12__src_symbol_square__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_symbol_star__ = __webpack_require__(362);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolStar", function() { return __WEBPACK_IMPORTED_MODULE_13__src_symbol_star__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_symbol_triangle__ = __webpack_require__(364);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolTriangle", function() { return __WEBPACK_IMPORTED_MODULE_14__src_symbol_triangle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_symbol_wye__ = __webpack_require__(365);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolWye", function() { return __WEBPACK_IMPORTED_MODULE_15__src_symbol_wye__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_curve_basisClosed__ = __webpack_require__(943);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_16__src_curve_basisClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_curve_basisOpen__ = __webpack_require__(944);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasisOpen", function() { return __WEBPACK_IMPORTED_MODULE_17__src_curve_basisOpen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_curve_basis__ = __webpack_require__(119);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasis", function() { return __WEBPACK_IMPORTED_MODULE_18__src_curve_basis__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_curve_bundle__ = __webpack_require__(945);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBundle", function() { return __WEBPACK_IMPORTED_MODULE_19__src_curve_bundle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_curve_cardinalClosed__ = __webpack_require__(366);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinalClosed", function() { return __WEBPACK_IMPORTED_MODULE_20__src_curve_cardinalClosed__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_curve_cardinalOpen__ = __webpack_require__(367);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinalOpen", function() { return __WEBPACK_IMPORTED_MODULE_21__src_curve_cardinalOpen__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_curve_cardinal__ = __webpack_require__(120);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinal", function() { return __WEBPACK_IMPORTED_MODULE_22__src_curve_cardinal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_curve_catmullRomClosed__ = __webpack_require__(946);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRomClosed", function() { return __WEBPACK_IMPORTED_MODULE_23__src_curve_catmullRomClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_curve_catmullRomOpen__ = __webpack_require__(947);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRomOpen", function() { return __WEBPACK_IMPORTED_MODULE_24__src_curve_catmullRomOpen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_curve_catmullRom__ = __webpack_require__(194);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRom", function() { return __WEBPACK_IMPORTED_MODULE_25__src_curve_catmullRom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_curve_linearClosed__ = __webpack_require__(948);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveLinearClosed", function() { return __WEBPACK_IMPORTED_MODULE_26__src_curve_linearClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_curve_linear__ = __webpack_require__(117);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveLinear", function() { return __WEBPACK_IMPORTED_MODULE_27__src_curve_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__ = __webpack_require__(949);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveMonotoneX", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveMonotoneY", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__src_curve_natural__ = __webpack_require__(950);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveNatural", function() { return __WEBPACK_IMPORTED_MODULE_29__src_curve_natural__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__src_curve_step__ = __webpack_require__(951);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStep", function() { return __WEBPACK_IMPORTED_MODULE_30__src_curve_step__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStepAfter", function() { return __WEBPACK_IMPORTED_MODULE_30__src_curve_step__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStepBefore", function() { return __WEBPACK_IMPORTED_MODULE_30__src_curve_step__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__src_stack__ = __webpack_require__(952);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stack", function() { return __WEBPACK_IMPORTED_MODULE_31__src_stack__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__src_offset_expand__ = __webpack_require__(953);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetExpand", function() { return __WEBPACK_IMPORTED_MODULE_32__src_offset_expand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__src_offset_diverging__ = __webpack_require__(954);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetDiverging", function() { return __WEBPACK_IMPORTED_MODULE_33__src_offset_diverging__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__src_offset_none__ = __webpack_require__(78);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetNone", function() { return __WEBPACK_IMPORTED_MODULE_34__src_offset_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__src_offset_silhouette__ = __webpack_require__(955);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetSilhouette", function() { return __WEBPACK_IMPORTED_MODULE_35__src_offset_silhouette__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__src_offset_wiggle__ = __webpack_require__(956);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetWiggle", function() { return __WEBPACK_IMPORTED_MODULE_36__src_offset_wiggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__src_order_ascending__ = __webpack_require__(195);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderAscending", function() { return __WEBPACK_IMPORTED_MODULE_37__src_order_ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__src_order_descending__ = __webpack_require__(957);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderDescending", function() { return __WEBPACK_IMPORTED_MODULE_38__src_order_descending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__src_order_insideOut__ = __webpack_require__(958);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderInsideOut", function() { return __WEBPACK_IMPORTED_MODULE_39__src_order_insideOut__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__src_order_none__ = __webpack_require__(79);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderNone", function() { return __WEBPACK_IMPORTED_MODULE_40__src_order_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__src_order_reverse__ = __webpack_require__(959);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderReverse", function() { return __WEBPACK_IMPORTED_MODULE_41__src_order_reverse__["a"]; });




 // Note: radialArea is deprecated!
 // Note: radialLine is deprecated!









































/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return tau; });
/* harmony export (immutable) */ __webpack_exports__["b"] = acos;
/* harmony export (immutable) */ __webpack_exports__["c"] = asin;
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
});


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
});


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return epsilon2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return beaches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cells; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return circles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return edges; });
/* harmony export (immutable) */ __webpack_exports__["d"] = Diagram;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Beach__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cell__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Circle__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Edge__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__ = __webpack_require__(196);






var epsilon = 1e-6;
var epsilon2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;

function triangleArea(a, b, c) {
  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}

function lexicographic(a, b) {
  return b[1] - a[1]
      || b[0] - a[0];
}

function Diagram(sites, extent) {
  var site = sites.sort(lexicographic).pop(),
      x,
      y,
      circle;

  edges = [];
  cells = new Array(sites.length);
  beaches = new __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__["b" /* default */];
  circles = new __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__["b" /* default */];

  while (true) {
    circle = __WEBPACK_IMPORTED_MODULE_2__Circle__["c" /* firstCircle */];
    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
      if (site[0] !== x || site[1] !== y) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Beach__["a" /* addBeach */])(site);
        x = site[0], y = site[1];
      }
      site = sites.pop();
    } else if (circle) {
      Object(__WEBPACK_IMPORTED_MODULE_0__Beach__["b" /* removeBeach */])(circle.arc);
    } else {
      break;
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["d" /* sortCellHalfedges */])();

  if (extent) {
    var x0 = +extent[0][0],
        y0 = +extent[0][1],
        x1 = +extent[1][0],
        y1 = +extent[1][1];
    Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["a" /* clipEdges */])(x0, y0, x1, y1);
    Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["b" /* clipCells */])(x0, y0, x1, y1);
  }

  this.edges = edges;
  this.cells = cells;

  beaches =
  circles =
  edges =
  cells = null;
}

Diagram.prototype = {
  constructor: Diagram,

  polygons: function() {
    var edges = this.edges;

    return this.cells.map(function(cell) {
      var polygon = cell.halfedges.map(function(i) { return Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["a" /* cellHalfedgeStart */])(cell, edges[i]); });
      polygon.data = cell.site.data;
      return polygon;
    });
  },

  triangles: function() {
    var triangles = [],
        edges = this.edges;

    this.cells.forEach(function(cell, i) {
      if (!(m = (halfedges = cell.halfedges).length)) return;
      var site = cell.site,
          halfedges,
          j = -1,
          m,
          s0,
          e1 = edges[halfedges[m - 1]],
          s1 = e1.left === site ? e1.right : e1.left;

      while (++j < m) {
        s0 = s1;
        e1 = edges[halfedges[j]];
        s1 = e1.left === site ? e1.right : e1.left;
        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
          triangles.push([site.data, s0.data, s1.data]);
        }
      }
    });

    return triangles;
  },

  links: function() {
    return this.edges.filter(function(edge) {
      return edge.right;
    }).map(function(edge) {
      return {
        source: edge.left.data,
        target: edge.right.data
      };
    });
  },

  find: function(x, y, radius) {
    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;

    // Use the previously-found cell, or start with an arbitrary one.
    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;

    // Traverse the half-edges to find a closer cell, if any.
    do {
      cell = that.cells[i0 = i1], i1 = null;
      cell.halfedges.forEach(function(e) {
        var edge = that.edges[e], v = edge.left;
        if ((v === cell.site || !v) && !(v = edge.right)) return;
        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
        if (v2 < d2) d2 = v2, i1 = v.index;
      });
    } while (i1 !== null);

    that._found = i0;

    return radius == null || d2 <= radius * radius ? cell.site : null;
  }
}


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mark = exports.chuckCloseCanvasTransform = exports.Legend = exports.SparkXYFrame = exports.SparkSmartFrame = exports.SparkNetworkFrame = exports.SparkOrdinalFrame = exports.ResponsiveXYFrame = exports.ResponsiveSmartFrame = exports.ResponsiveNetworkFrame = exports.ResponsiveORFrame = exports.ResponsiveOrdinalFrame = exports.ResponsiveMinimapXYFrame = exports.NetworkFrame = exports.Annotation = exports.calculateDataExtent = exports.SmartFrame = exports.funnelize = exports.ORFrame = exports.OrdinalFrame = exports.DebugComponent = exports.VisualizationLayer = exports.InteractionLayer = exports.Axis = exports.Brush = exports.MiniMap = exports.MinimapNetworkFrame = exports.MinimapXYFrame = exports.XYFrame = exports.DividedLine = exports.AnnotationLayer = undefined;

var _AnnotationLayer = __webpack_require__(371);

var _AnnotationLayer2 = _interopRequireDefault(_AnnotationLayer);

var _DividedLine = __webpack_require__(986);

var _DividedLine2 = _interopRequireDefault(_DividedLine);

var _XYFrame = __webpack_require__(61);

var _XYFrame2 = _interopRequireDefault(_XYFrame);

var _OrdinalFrame = __webpack_require__(144);

var _OrdinalFrame2 = _interopRequireDefault(_OrdinalFrame);

var _SmartFrame = __webpack_require__(249);

var _SmartFrame2 = _interopRequireDefault(_SmartFrame);

var _MinimapXYFrame = __webpack_require__(479);

var _MinimapXYFrame2 = _interopRequireDefault(_MinimapXYFrame);

var _MinimapNetworkFrame = __webpack_require__(1268);

var _MinimapNetworkFrame2 = _interopRequireDefault(_MinimapNetworkFrame);

var _MiniMap = __webpack_require__(250);

var _MiniMap2 = _interopRequireDefault(_MiniMap);

var _Axis = __webpack_require__(137);

var _Axis2 = _interopRequireDefault(_Axis);

var _Legend = __webpack_require__(372);

var _Legend2 = _interopRequireDefault(_Legend);

var _Annotation = __webpack_require__(57);

var _Annotation2 = _interopRequireDefault(_Annotation);

var _Brush = __webpack_require__(464);

var _Brush2 = _interopRequireDefault(_Brush);

var _Debug = __webpack_require__(1290);

var _Debug2 = _interopRequireDefault(_Debug);

var _InteractionLayer = __webpack_require__(456);

var _InteractionLayer2 = _interopRequireDefault(_InteractionLayer);

var _VisualizationLayer = __webpack_require__(465);

var _VisualizationLayer2 = _interopRequireDefault(_VisualizationLayer);

var _NetworkFrame = __webpack_require__(145);

var _NetworkFrame2 = _interopRequireDefault(_NetworkFrame);

var _lineDrawing = __webpack_require__(126);

var _dataFunctions = __webpack_require__(143);

var _ResponsiveFrame = __webpack_require__(1291);

var _SparkFrame = __webpack_require__(1293);

var _basicCanvasEffects = __webpack_require__(466);

var _semioticMark = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ORFrame = _OrdinalFrame2.default;

exports.default = {
  AnnotationLayer: _AnnotationLayer2.default,
  DividedLine: _DividedLine2.default,
  XYFrame: _XYFrame2.default,
  MinimapXYFrame: _MinimapXYFrame2.default,
  MinimapNetworkFrame: _MinimapNetworkFrame2.default,
  MiniMap: _MiniMap2.default,
  Brush: _Brush2.default,
  Axis: _Axis2.default,
  InteractionLayer: _InteractionLayer2.default,
  VisualizationLayer: _VisualizationLayer2.default,
  DebugComponent: _Debug2.default,
  OrdinalFrame: _OrdinalFrame2.default,
  ORFrame: ORFrame,
  funnelize: _lineDrawing.funnelize,
  SmartFrame: _SmartFrame2.default,
  calculateDataExtent: _dataFunctions.calculateDataExtent,
  Annotation: _Annotation2.default,
  NetworkFrame: _NetworkFrame2.default,
  ResponsiveMinimapXYFrame: _ResponsiveFrame.ResponsiveMinimapXYFrame,
  ResponsiveOrdinalFrame: _ResponsiveFrame.ResponsiveOrdinalFrame,
  ResponsiveORFrame: _ResponsiveFrame.ResponsiveORFrame,
  ResponsiveNetworkFrame: _ResponsiveFrame.ResponsiveNetworkFrame,
  ResponsiveSmartFrame: _ResponsiveFrame.ResponsiveSmartFrame,
  ResponsiveXYFrame: _ResponsiveFrame.ResponsiveXYFrame,
  SparkOrdinalFrame: _SparkFrame.SparkOrdinalFrame,
  SparkNetworkFrame: _SparkFrame.SparkNetworkFrame,
  SparkSmartFrame: _SparkFrame.SparkSmartFrame,
  SparkXYFrame: _SparkFrame.SparkXYFrame,
  Legend: _Legend2.default,
  chuckCloseCanvasTransform: _basicCanvasEffects.chuckCloseCanvasTransform,
  Mark: _semioticMark.Mark
};
exports.AnnotationLayer = _AnnotationLayer2.default;
exports.DividedLine = _DividedLine2.default;
exports.XYFrame = _XYFrame2.default;
exports.MinimapXYFrame = _MinimapXYFrame2.default;
exports.MinimapNetworkFrame = _MinimapNetworkFrame2.default;
exports.MiniMap = _MiniMap2.default;
exports.Brush = _Brush2.default;
exports.Axis = _Axis2.default;
exports.InteractionLayer = _InteractionLayer2.default;
exports.VisualizationLayer = _VisualizationLayer2.default;
exports.DebugComponent = _Debug2.default;
exports.OrdinalFrame = _OrdinalFrame2.default;
exports.ORFrame = ORFrame;
exports.funnelize = _lineDrawing.funnelize;
exports.SmartFrame = _SmartFrame2.default;
exports.calculateDataExtent = _dataFunctions.calculateDataExtent;
exports.Annotation = _Annotation2.default;
exports.NetworkFrame = _NetworkFrame2.default;
exports.ResponsiveMinimapXYFrame = _ResponsiveFrame.ResponsiveMinimapXYFrame;
exports.ResponsiveOrdinalFrame = _ResponsiveFrame.ResponsiveOrdinalFrame;
exports.ResponsiveORFrame = _ResponsiveFrame.ResponsiveORFrame;
exports.ResponsiveNetworkFrame = _ResponsiveFrame.ResponsiveNetworkFrame;
exports.ResponsiveSmartFrame = _ResponsiveFrame.ResponsiveSmartFrame;
exports.ResponsiveXYFrame = _ResponsiveFrame.ResponsiveXYFrame;
exports.SparkOrdinalFrame = _SparkFrame.SparkOrdinalFrame;
exports.SparkNetworkFrame = _SparkFrame.SparkNetworkFrame;
exports.SparkSmartFrame = _SparkFrame.SparkSmartFrame;
exports.SparkXYFrame = _SparkFrame.SparkXYFrame;
exports.Legend = _Legend2.default;
exports.chuckCloseCanvasTransform = _basicCanvasEffects.chuckCloseCanvasTransform;
exports.Mark = _semioticMark.Mark;

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tau; });
var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (var j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
});


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
});


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hue;
/* harmony export (immutable) */ __webpack_exports__["b"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(422);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tau; });
var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (var j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
});


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
});


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = linearish;
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(1118);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["ticks"])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(domain(), count, specifier);
  };

  scale.nice = function(count) {
    var d = domain(),
        i = d.length - 1,
        n = count == null ? 10 : count,
        start = d[0],
        stop = d[i],
        step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start, stop, n);

    if (step) {
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(Math.floor(start / step) * step, Math.ceil(stop / step) * step, n);
      d[0] = Math.floor(start / step) * step;
      d[i] = Math.ceil(stop / step) * step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateNumber */]);

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, linear());
  };

  return linearish(scale);
}


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
});


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_band__ = __webpack_require__(1136);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleBand", function() { return __WEBPACK_IMPORTED_MODULE_0__src_band__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scalePoint", function() { return __WEBPACK_IMPORTED_MODULE_0__src_band__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_identity__ = __webpack_require__(1142);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleIdentity", function() { return __WEBPACK_IMPORTED_MODULE_1__src_identity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_linear__ = __webpack_require__(93);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleLinear", function() { return __WEBPACK_IMPORTED_MODULE_2__src_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_log__ = __webpack_require__(1154);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleLog", function() { return __WEBPACK_IMPORTED_MODULE_3__src_log__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_ordinal__ = __webpack_require__(445);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleOrdinal", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleImplicit", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_pow__ = __webpack_require__(1155);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scalePow", function() { return __WEBPACK_IMPORTED_MODULE_5__src_pow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSqrt", function() { return __WEBPACK_IMPORTED_MODULE_5__src_pow__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_quantile__ = __webpack_require__(1156);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleQuantile", function() { return __WEBPACK_IMPORTED_MODULE_6__src_quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_quantize__ = __webpack_require__(1157);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleQuantize", function() { return __WEBPACK_IMPORTED_MODULE_7__src_quantize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold__ = __webpack_require__(1158);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleThreshold", function() { return __WEBPACK_IMPORTED_MODULE_8__src_threshold__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_time__ = __webpack_require__(455);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleTime", function() { return __WEBPACK_IMPORTED_MODULE_9__src_time__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcTime__ = __webpack_require__(1159);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleUtc", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcTime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_category10__ = __webpack_require__(1160);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory10", function() { return __WEBPACK_IMPORTED_MODULE_11__src_category10__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_category20b__ = __webpack_require__(1161);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory20b", function() { return __WEBPACK_IMPORTED_MODULE_12__src_category20b__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_category20c__ = __webpack_require__(1162);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory20c", function() { return __WEBPACK_IMPORTED_MODULE_13__src_category20c__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_category20__ = __webpack_require__(1163);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory20", function() { return __WEBPACK_IMPORTED_MODULE_14__src_category20__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(1164);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelixDefault", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_rainbow__ = __webpack_require__(1165);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRainbow", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateWarm", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCool", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_viridis__ = __webpack_require__(1166);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateViridis", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateMagma", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateInferno", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolatePlasma", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_sequential__ = __webpack_require__(1167);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequential", function() { return __WEBPACK_IMPORTED_MODULE_18__src_sequential__["a"]; });







































/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = linearish;
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(1153);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["ticks"])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(domain(), count, specifier);
  };

  scale.nice = function(count) {
    var d = domain(),
        i = d.length - 1,
        n = count == null ? 10 : count,
        start = d[0],
        stop = d[i],
        step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start, stop, n);

    if (step) {
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(Math.floor(start / step) * step, Math.ceil(stop / step) * step, n);
      d[0] = Math.floor(start / step) * step;
      d[i] = Math.ceil(stop / step) * step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateNumber"]);

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, linear());
  };

  return linearish(scale);
}


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hue;
/* harmony export (immutable) */ __webpack_exports__["b"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(448);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
});


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return epsilon2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return beaches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cells; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return circles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return edges; });
/* harmony export (immutable) */ __webpack_exports__["d"] = Diagram;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Beach__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cell__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Circle__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Edge__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__ = __webpack_require__(238);






var epsilon = 1e-6;
var epsilon2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;

function triangleArea(a, b, c) {
  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}

function lexicographic(a, b) {
  return b[1] - a[1]
      || b[0] - a[0];
}

function Diagram(sites, extent) {
  var site = sites.sort(lexicographic).pop(),
      x,
      y,
      circle;

  edges = [];
  cells = new Array(sites.length);
  beaches = new __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__["b" /* default */];
  circles = new __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__["b" /* default */];

  while (true) {
    circle = __WEBPACK_IMPORTED_MODULE_2__Circle__["c" /* firstCircle */];
    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
      if (site[0] !== x || site[1] !== y) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Beach__["a" /* addBeach */])(site);
        x = site[0], y = site[1];
      }
      site = sites.pop();
    } else if (circle) {
      Object(__WEBPACK_IMPORTED_MODULE_0__Beach__["b" /* removeBeach */])(circle.arc);
    } else {
      break;
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["d" /* sortCellHalfedges */])();

  if (extent) {
    var x0 = +extent[0][0],
        y0 = +extent[0][1],
        x1 = +extent[1][0],
        y1 = +extent[1][1];
    Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["a" /* clipEdges */])(x0, y0, x1, y1);
    Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["b" /* clipCells */])(x0, y0, x1, y1);
  }

  this.edges = edges;
  this.cells = cells;

  beaches =
  circles =
  edges =
  cells = null;
}

Diagram.prototype = {
  constructor: Diagram,

  polygons: function() {
    var edges = this.edges;

    return this.cells.map(function(cell) {
      var polygon = cell.halfedges.map(function(i) { return Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["a" /* cellHalfedgeStart */])(cell, edges[i]); });
      polygon.data = cell.site.data;
      return polygon;
    });
  },

  triangles: function() {
    var triangles = [],
        edges = this.edges;

    this.cells.forEach(function(cell, i) {
      var site = cell.site,
          halfedges = cell.halfedges,
          j = -1,
          m = halfedges.length,
          s0,
          e1 = edges[halfedges[m - 1]],
          s1 = e1.left === site ? e1.right : e1.left;

      while (++j < m) {
        s0 = s1;
        e1 = edges[halfedges[j]];
        s1 = e1.left === site ? e1.right : e1.left;
        if (i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
          triangles.push([site.data, s0.data, s1.data]);
        }
      }
    });

    return triangles;
  },

  links: function() {
    return this.edges.filter(function(edge) {
      return edge.right;
    }).map(function(edge) {
      return {
        source: edge.left.data,
        target: edge.right.data
      };
    });
  }
}


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (x1 - x0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
});


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = rotateRadians;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(4);



function rotationIdentity(lambda, phi) {
  return [lambda > __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda - __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda < -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda + __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda, phi];
}

rotationIdentity.invert = rotationIdentity;

function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */]) ? (deltaPhi || deltaGamma ? Object(__WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */])(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
    : rotationLambda(deltaLambda))
    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
    : rotationIdentity);
}

function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi) {
    return lambda += deltaLambda, [lambda > __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda - __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda < -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda + __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda, phi];
  };
}

function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}

function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(deltaPhi),
      sinDeltaPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(deltaPhi),
      cosDeltaGamma = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(deltaGamma),
      sinDeltaGamma = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(deltaGamma);

  function rotation(lambda, phi) {
    var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
        x = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(lambda) * cosPhi,
        y = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda) * cosPhi,
        z = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
        k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* asin */])(k * cosDeltaGamma + y * sinDeltaGamma)
    ];
  }

  rotation.invert = function(lambda, phi) {
    var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
        x = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(lambda) * cosPhi,
        y = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda) * cosPhi,
        z = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
        k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* asin */])(k * cosDeltaPhi - x * sinDeltaPhi)
    ];
  };

  return rotation;
}

/* harmony default export */ __webpack_exports__["a"] = (function(rotate) {
  rotate = rotateRadians(rotate[0] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], rotate[1] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], rotate.length > 2 ? rotate[2] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */] : 0);

  function forward(coordinates) {
    coordinates = rotate(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */]);
    return coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates;
  }

  forward.invert = function(coordinates) {
    coordinates = rotate.invert(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */]);
    return coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates;
  };

  return forward;
});


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clipRectangle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffer__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__line__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rejoin__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_array__ = __webpack_require__(3);






var clipMax = 1e9, clipMin = -clipMax;

// TODO Use d3-polygon’s polygonContains here for the ring check?
// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?

function clipRectangle(x0, y0, x1, y1) {

  function visible(x, y) {
    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
  }

  function interpolate(from, to, direction, stream) {
    var a = 0, a1 = 0;
    if (from == null
        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
        || comparePoint(from, to) < 0 ^ direction > 0) {
      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
      while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }

  function corner(p, direction) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(p[0] - x0) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] ? direction > 0 ? 0 : 3
        : Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(p[0] - x1) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] ? direction > 0 ? 2 : 1
        : Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(p[1] - y0) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] ? direction > 0 ? 1 : 0
        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
  }

  function compareIntersection(a, b) {
    return comparePoint(a.x, b.x);
  }

  function comparePoint(a, b) {
    var ca = corner(a, 1),
        cb = corner(b, 1);
    return ca !== cb ? ca - cb
        : ca === 0 ? b[1] - a[1]
        : ca === 1 ? a[0] - b[0]
        : ca === 2 ? a[1] - b[1]
        : b[0] - a[0];
  }

  return function(stream) {
    var activeStream = stream,
        bufferStream = Object(__WEBPACK_IMPORTED_MODULE_1__buffer__["a" /* default */])(),
        segments,
        polygon,
        ring,
        x__, y__, v__, // first point
        x_, y_, v_, // previous point
        first,
        clean;

    var clipStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: polygonStart,
      polygonEnd: polygonEnd
    };

    function point(x, y) {
      if (visible(x, y)) activeStream.point(x, y);
    }

    function polygonInside() {
      var winding = 0;

      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
        }
      }

      return winding;
    }

    // Buffer geometry within a polygon and then clip it en masse.
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }

    function polygonEnd() {
      var startInside = polygonInside(),
          cleanInside = clean && startInside,
          visible = (segments = Object(__WEBPACK_IMPORTED_MODULE_4_d3_array__["merge"])(segments)).length;
      if (cleanInside || visible) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible) {
          Object(__WEBPACK_IMPORTED_MODULE_3__rejoin__["a" /* default */])(segments, compareIntersection, startInside, interpolate, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }

    function lineStart() {
      clipStream.point = linePoint;
      if (polygon) polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }

    // TODO rather than special-case polygons, simply handle them separately.
    // Ideally, coincident intersection points should be jittered to avoid
    // clipping issues.
    function lineEnd() {
      if (segments) {
        linePoint(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point;
      if (v_) activeStream.lineEnd();
    }

    function linePoint(x, y) {
      var v = visible(x, y);
      if (polygon) ring.push([x, y]);
      if (first) {
        x__ = x, y__ = y, v__ = v;
        first = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_) activeStream.point(x, y);
        else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (Object(__WEBPACK_IMPORTED_MODULE_2__line__["a" /* default */])(a, b, x0, y0, x1, y1)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v) activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }

    return clipStream;
  };
}


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transformer;
/* unused harmony default export */ var _unused_webpack_default_export = (function(methods) {
  return {
    stream: transformer(methods)
  };
});

function transformer(methods) {
  return function(stream) {
    var s = new TransformStream;
    for (var key in methods) s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}

function TransformStream() {}

TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x, y) { this.stream.point(x, y); },
  sphere: function() { this.stream.sphere(); },
  lineStart: function() { this.stream.lineStart(); },
  lineEnd: function() { this.stream.lineEnd(); },
  polygonStart: function() { this.stream.polygonStart(); },
  polygonEnd: function() { this.stream.polygonEnd(); }
};


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b, c, d, e, f, g, h) {
  if (arguments.length < 8) h = 0;

  function forward(lambda, phi) {
    if (!phi) return [a * lambda / __WEBPACK_IMPORTED_MODULE_0__math__["s" /* pi */], 0];
    var phi2 = phi * phi,
        xB = a + phi2 * (b + phi2 * (c + phi2 * d)),
        yB = phi * (e - 1 + phi2 * (f - h + phi2 * g)),
        m = (xB * xB + yB * yB) / (2 * yB),
        alpha = lambda * Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* asin */])(xB / m) / __WEBPACK_IMPORTED_MODULE_0__math__["s" /* pi */];
    return [m * Object(__WEBPACK_IMPORTED_MODULE_0__math__["y" /* sin */])(alpha), phi * (1 + phi2 * h) + m * (1 - Object(__WEBPACK_IMPORTED_MODULE_0__math__["h" /* cos */])(alpha))];
  }

  forward.invert = function(x, y) {
    var lambda = __WEBPACK_IMPORTED_MODULE_0__math__["s" /* pi */] * x / a,
        phi = y,
        deltaLambda, deltaPhi, i = 50;
    do {
      var phi2 = phi * phi,
          xB = a + phi2 * (b + phi2 * (c + phi2 * d)),
          yB = phi * (e - 1 + phi2 * (f - h + phi2 * g)),
          p = xB * xB + yB * yB,
          q = 2 * yB,
          m = p / q,
          m2 = m * m,
          dAlphadLambda = Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* asin */])(xB / m) / __WEBPACK_IMPORTED_MODULE_0__math__["s" /* pi */],
          alpha = lambda * dAlphadLambda,
          xB2 = xB * xB,
          dxBdPhi = (2 * b + phi2 * (4 * c + phi2 * 6 * d)) * phi,
          dyBdPhi = e + phi2 * (3 * f + phi2 * 5 * g),
          dpdPhi = 2 * (xB * dxBdPhi + yB * (dyBdPhi - 1)),
          dqdPhi = 2 * (dyBdPhi - 1),
          dmdPhi = (dpdPhi * q - p * dqdPhi) / (q * q),
          cosAlpha = Object(__WEBPACK_IMPORTED_MODULE_0__math__["h" /* cos */])(alpha),
          sinAlpha = Object(__WEBPACK_IMPORTED_MODULE_0__math__["y" /* sin */])(alpha),
          mcosAlpha = m * cosAlpha,
          msinAlpha = m * sinAlpha,
          dAlphadPhi = ((lambda / __WEBPACK_IMPORTED_MODULE_0__math__["s" /* pi */]) * (1 / Object(__WEBPACK_IMPORTED_MODULE_0__math__["B" /* sqrt */])(1 - xB2 / m2)) * (dxBdPhi * m - xB * dmdPhi)) / m2,
          fx = msinAlpha - x,
          fy = phi * (1 + phi2 * h) + m - mcosAlpha - y,
          deltaxDeltaPhi = dmdPhi * sinAlpha + mcosAlpha * dAlphadPhi,
          deltaxDeltaLambda = mcosAlpha * dAlphadLambda,
          deltayDeltaPhi = 1 + dmdPhi - (dmdPhi * cosAlpha - msinAlpha * dAlphadPhi),
          deltayDeltaLambda = msinAlpha * dAlphadLambda,
          denominator = deltaxDeltaPhi * deltayDeltaLambda - deltayDeltaPhi * deltaxDeltaLambda;
      if (!denominator) break;
      lambda -= deltaLambda = (fy * deltaxDeltaPhi - fx * deltayDeltaPhi) / denominator;
      phi -= deltaPhi = (fx * deltayDeltaLambda - fy * deltaxDeltaLambda) / denominator;
    } while ((Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(deltaLambda) > __WEBPACK_IMPORTED_MODULE_0__math__["k" /* epsilon */] || Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(deltaPhi) > __WEBPACK_IMPORTED_MODULE_0__math__["k" /* epsilon */]) && --i > 0);
    return [lambda, phi];
  };

  return forward;
});


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__matrix__ = __webpack_require__(644);




// Creates a polyhedral projection.
//  * root: a spanning tree of polygon faces.  Nodes are automatically
//    augmented with a transform matrix.
//  * face: a function that returns the appropriate node for a given {lambda, phi}
//    point (radians).
//  * r: rotation angle for final polyhedral net.  Defaults to -pi / 6 (for
//    butterflies).
/* harmony default export */ __webpack_exports__["a"] = (function(root, face, r) {

  r = r == null ? -__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / 6 : r; // TODO automate

  recurse(root, {transform: [
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(r), Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(r), 0,
    -Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(r), Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(r), 0
  ]});

  function recurse(node, parent) {
    node.edges = faceEdges(node.face);
    // Find shared edge.
    if (parent.face) {
      var shared = node.shared = sharedEdge(node.face, parent.face),
          m = Object(__WEBPACK_IMPORTED_MODULE_2__matrix__["a" /* default */])(shared.map(parent.project), shared.map(node.project));
      node.transform = parent.transform ? Object(__WEBPACK_IMPORTED_MODULE_2__matrix__["c" /* multiply */])(parent.transform, m) : m;
      // Replace shared edge in parent edges array.
      var edges = parent.edges;
      for (var i = 0, n = edges.length; i < n; ++i) {
        if (pointEqual(shared[0], edges[i][1]) && pointEqual(shared[1], edges[i][0])) edges[i] = node;
        if (pointEqual(shared[0], edges[i][0]) && pointEqual(shared[1], edges[i][1])) edges[i] = node;
      }
      edges = node.edges;
      for (i = 0, n = edges.length; i < n; ++i) {
        if (pointEqual(shared[0], edges[i][0]) && pointEqual(shared[1], edges[i][1])) edges[i] = parent;
        if (pointEqual(shared[0], edges[i][1]) && pointEqual(shared[1], edges[i][0])) edges[i] = parent;
      }
    } else {
      node.transform = parent.transform;
    }
    if (node.children) {
      node.children.forEach(function(child) {
        recurse(child, node);
      });
    }
    return node;
  }

  function forward(lambda, phi) {
    var node = face(lambda, phi),
        point = node.project([lambda * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */], phi * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */]]),
        t;
    if (t = node.transform) {
      return [
        t[0] * point[0] + t[1] * point[1] + t[2],
        -(t[3] * point[0] + t[4] * point[1] + t[5])
      ];
    }
    point[1] = -point[1];
    return point;
  }

  // Naive inverse!  A faster solution would use bounding boxes, or even a
  // polygonal quadtree.
  if (hasInverse(root)) forward.invert = function(x, y) {
    var coordinates = faceInvert(root, [x, -y]);
    return coordinates && (coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */], coordinates);
  };

  function faceInvert(node, coordinates) {
    var invert = node.project.invert,
        t = node.transform,
        point = coordinates;
    if (t) {
      t = Object(__WEBPACK_IMPORTED_MODULE_2__matrix__["b" /* inverse */])(t);
      point = [
        t[0] * point[0] + t[1] * point[1] + t[2],
        (t[3] * point[0] + t[4] * point[1] + t[5])
      ];
    }
    if (invert && node === faceDegrees(p = invert(point))) return p;
    var p,
        children = node.children;
    for (var i = 0, n = children && children.length; i < n; ++i) {
      if (p = faceInvert(children[i], coordinates)) return p;
    }
  }

  function faceDegrees(coordinates) {
    return face(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */]);
  }

  var proj = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(forward),
      stream_ = proj.stream;

  proj.stream = function(stream) {
    var rotate = proj.rotate(),
        rotateStream = stream_(stream),
        sphereStream = (proj.rotate([0, 0]), stream_(stream));
    proj.rotate(rotate);
    rotateStream.sphere = function() {
      sphereStream.polygonStart();
      sphereStream.lineStart();
      outline(sphereStream, root);
      sphereStream.lineEnd();
      sphereStream.polygonEnd();
    };
    return rotateStream;
  };

  return proj;
});

function outline(stream, node, parent) {
  var point,
      edges = node.edges,
      n = edges.length,
      edge,
      multiPoint = {type: "MultiPoint", coordinates: node.face},
      notPoles = node.face.filter(function(d) { return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(d[1]) !== 90; }),
      b = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["c" /* geoBounds */])({type: "MultiPoint", coordinates: notPoles}),
      inside = false,
      j = -1,
      dx = b[1][0] - b[0][0];
  // TODO
  var c = dx === 180 || dx === 360
      ? [(b[0][0] + b[1][0]) / 2, (b[0][1] + b[1][1]) / 2]
      : Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["d" /* geoCentroid */])(multiPoint);
  // First find the shared edge…
  if (parent) while (++j < n) {
    if (edges[j] === parent) break;
  }
  ++j;
  for (var i = 0; i < n; ++i) {
    edge = edges[(i + j) % n];
    if (Array.isArray(edge)) {
      if (!inside) {
        stream.point((point = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["i" /* geoInterpolate */])(edge[0], c)(__WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]))[0], point[1]);
        inside = true;
      }
      stream.point((point = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["i" /* geoInterpolate */])(edge[1], c)(__WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]))[0], point[1]);
    } else {
      inside = false;
      if (edge !== parent) outline(stream, edge, node);
    }
  }
}

// Tests equality of two spherical points.
function pointEqual(a, b) {
  return a && b && a[0] === b[0] && a[1] === b[1];
}

// Finds a shared edge given two clockwise polygons.
function sharedEdge(a, b) {
  var x, y, n = a.length, found = null;
  for (var i = 0; i < n; ++i) {
    x = a[i];
    for (var j = b.length; --j >= 0;) {
      y = b[j];
      if (x[0] === y[0] && x[1] === y[1]) {
        if (found) return [found, x];
        found = x;
      }
    }
  }
}

// Converts an array of n face vertices to an array of n + 1 edges.
function faceEdges(face) {
  var n = face.length,
      edges = [];
  for (var a = face[n - 1], i = 0; i < n; ++i) edges.push([a, a = face[i]]);
  return edges;
}

function hasInverse(node) {
  return node.project.invert || node.children && node.children.some(hasInverse);
}


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = rotateRadians;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(6);



function rotationIdentity(lambda, phi) {
  return [lambda > __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda - __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda < -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda + __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda, phi];
}

rotationIdentity.invert = rotationIdentity;

function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */]) ? (deltaPhi || deltaGamma ? Object(__WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */])(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
    : rotationLambda(deltaLambda))
    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
    : rotationIdentity);
}

function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi) {
    return lambda += deltaLambda, [lambda > __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda - __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda < -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] ? lambda + __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] : lambda, phi];
  };
}

function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}

function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(deltaPhi),
      sinDeltaPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(deltaPhi),
      cosDeltaGamma = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(deltaGamma),
      sinDeltaGamma = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(deltaGamma);

  function rotation(lambda, phi) {
    var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
        x = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(lambda) * cosPhi,
        y = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda) * cosPhi,
        z = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
        k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* asin */])(k * cosDeltaGamma + y * sinDeltaGamma)
    ];
  }

  rotation.invert = function(lambda, phi) {
    var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
        x = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(lambda) * cosPhi,
        y = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda) * cosPhi,
        z = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
        k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* asin */])(k * cosDeltaPhi - x * sinDeltaPhi)
    ];
  };

  return rotation;
}

/* harmony default export */ __webpack_exports__["a"] = (function(rotate) {
  rotate = rotateRadians(rotate[0] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], rotate[1] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], rotate.length > 2 ? rotate[2] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */] : 0);

  function forward(coordinates) {
    coordinates = rotate(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */]);
    return coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates;
  }

  forward.invert = function(coordinates) {
    coordinates = rotate.invert(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */]);
    return coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates;
  };

  return forward;
});


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = transformer;
/* harmony default export */ __webpack_exports__["a"] = (function(methods) {
  return {
    stream: transformer(methods)
  };
});

function transformer(methods) {
  return function(stream) {
    var s = new TransformStream;
    for (var key in methods) s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}

function TransformStream() {}

TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x, y) { this.stream.point(x, y); },
  sphere: function() { this.stream.sphere(); },
  lineStart: function() { this.stream.lineStart(); },
  lineEnd: function() { this.stream.lineEnd(); },
  polygonStart: function() { this.stream.polygonStart(); },
  polygonEnd: function() { this.stream.polygonEnd(); }
};


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_band__ = __webpack_require__(714);
/* unused harmony reexport scaleBand */
/* unused harmony reexport scalePoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_identity__ = __webpack_require__(720);
/* unused harmony reexport scaleIdentity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_linear__ = __webpack_require__(70);
/* unused harmony reexport scaleLinear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_log__ = __webpack_require__(743);
/* unused harmony reexport scaleLog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_ordinal__ = __webpack_require__(310);
/* unused harmony reexport scaleOrdinal */
/* unused harmony reexport scaleImplicit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_pow__ = __webpack_require__(744);
/* unused harmony reexport scalePow */
/* unused harmony reexport scaleSqrt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_quantile__ = __webpack_require__(745);
/* unused harmony reexport scaleQuantile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_quantize__ = __webpack_require__(746);
/* unused harmony reexport scaleQuantize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold__ = __webpack_require__(747);
/* unused harmony reexport scaleThreshold */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_time__ = __webpack_require__(325);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9__src_time__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcTime__ = __webpack_require__(763);
/* unused harmony reexport scaleUtc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_sequential__ = __webpack_require__(764);
/* unused harmony reexport scaleSequential */

























/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = deinterpolateLinear;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["b"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(319);






var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolate */],
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["f" /* interpolateRound */], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(171);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(Math.abs(x)), x ? x[1] : NaN;
});


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__namespaces__ = __webpack_require__(175);



function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === __WEBPACK_IMPORTED_MODULE_1__namespaces__["b" /* xhtml */] && document.documentElement.namespaceURI === __WEBPACK_IMPORTED_MODULE_1__namespaces__["b" /* xhtml */]
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
});


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node, event) {
  var svg = node.ownerSVGElement || node;

  if (svg.createSVGPoint) {
    var point = svg.createSVGPoint();
    point.x = event.clientX, point.y = event.clientY;
    point = point.matrixTransform(node.getScreenCTM().inverse());
    return [point.x, point.y];
  }

  var rect = node.getBoundingClientRect();
  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
});


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tweenValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(18);


function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
});

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(node, id).value[name];
  };
}


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (y1 - y0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
});


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(190);


/* harmony default export */ __webpack_exports__["a"] = (function(defaultMimeType, response) {
  return function(url, callback) {
    var r = Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(url).mimeType(defaultMimeType).response(response);
    if (callback != null) {
      if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
      return r.get(callback);
    }
    return r;
  };
});


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = deinterpolateLinear;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["b"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(351);






var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolate */],
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["f" /* interpolateRound */], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Linear(context);
});


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Basis;
function point(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = (function(context) {
  return new Basis(context);
});


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Cardinal;
function point(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Connector = function (_React$Component) {
  _inherits(Connector, _React$Component);

  function Connector() {
    _classCallCheck(this, Connector);

    return _possibleConstructorReturn(this, (Connector.__proto__ || Object.getPrototypeOf(Connector)).apply(this, arguments));
  }

  _createClass(Connector, [{
    key: "getComponents",
    value: function getComponents() {}
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          color = _props.color,
          dx = _props.dx,
          dy = _props.dy,
          customID = _props.customID;


      if (dx === 0 && dy === 0) {
        return _react2.default.createElement("g", { className: "annotation-connector" });
      }

      var d = this.getComponents(this.props) || [];
      var cleanedProps = Object.assign({}, this.props);
      delete cleanedProps.children;

      var childrenWithProps = _react2.default.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, _extends({}, cleanedProps, child.props, {
          scale: cleanedProps.endScale || child.props.endScale,
          lineData: d.components[0].data
        }));
      });

      return _react2.default.createElement(
        "g",
        _extends({ className: "annotation-connector" }, this.props.gAttrs),
        d.components && d.components.map(function (c, i) {
          var attrs = {};
          if (!c) return null;
          Object.keys(c.attrs).forEach(function (k) {
            if (c.attrs[k] && k !== "text") {
              attrs[k.replace(/-([a-z])/g, function (g) {
                return g[1].toUpperCase();
              })] = c.attrs[k];
            }
          });
          return _react2.default.createElement(
            c.type,
            _extends({
              mask: customID ? "url(#" + customID + ")" : undefined,
              key: i,
              className: c.className,
              fill: "none",
              stroke: color
            }, attrs),
            c.attrs.text
          );
        }),
        childrenWithProps
      );
    }
  }]);

  return Connector;
}(_react2.default.Component);

exports.default = Connector;

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Linear(context);
});


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Basis;
function point(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = (function(context) {
  return new Basis(context);
});


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Cardinal;
function point(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dividedLine = exports.bumpChart = exports.lineChart = exports.stackedArea = exports.differenceLine = exports.projectLineData = exports.projectAreaData = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.funnelize = funnelize;
exports.relativeY = relativeY;

var _d3Array = __webpack_require__(12);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var datesForUnique = function datesForUnique(d) {
  return d instanceof Date ? d.toString() : d;
};

var projectAreaData = exports.projectAreaData = function projectAreaData(_ref) {
  var data = _ref.data,
      areaDataAccessor = _ref.areaDataAccessor,
      projection = _ref.projection,
      xAccessor = _ref.xAccessor,
      yAccessor = _ref.yAccessor;

  projection = projection ? projection : function (d) {
    return areaDataAccessor(d).map(function (p, q) {
      return [xAccessor(p, q), yAccessor(p, q)];
    });
  };
  data.forEach(function (d) {
    d._xyfCoordinates = projection(d);
  });
  return data;
};

var projectLineData = exports.projectLineData = function projectLineData(_ref2) {
  var data = _ref2.data,
      lineDataAccessor = _ref2.lineDataAccessor,
      xProp = _ref2.xProp,
      yProp = _ref2.yProp,
      yPropTop = _ref2.yPropTop,
      yPropBottom = _ref2.yPropBottom,
      xAccessor = _ref2.xAccessor,
      yAccessor = _ref2.yAccessor;

  if (!Array.isArray(data)) {
    data = [data];
  }
  return data.map(function (d, i) {
    var originalLineData = _extends({}, d);
    originalLineData.data = lineDataAccessor(d).map(function (p, q) {
      var originalCoords = {};

      originalCoords[xProp] = xAccessor(p, q);
      originalCoords[yProp] = yAccessor(p, q);
      originalCoords[yPropTop] = originalCoords[yProp];
      originalCoords[yPropBottom] = originalCoords[yProp];
      originalCoords.data = p;

      return originalCoords;
    });
    originalLineData.key = originalLineData.key || i;
    return originalLineData;
  });
};

var differenceLine = exports.differenceLine = function differenceLine(_ref3) {
  var data = _ref3.data,
      yProp = _ref3.yProp,
      yPropTop = _ref3.yPropTop,
      yPropBottom = _ref3.yPropBottom;

  data.forEach(function (l, i) {
    l.data.forEach(function (point, q) {
      var otherLine = i === 0 ? 1 : 0;
      if (point[yProp] > data[otherLine].data[q][yProp]) {
        point[yPropBottom] = data[otherLine].data[q][yProp];
        point[yPropTop] = point[yProp];
      } else {
        point[yPropTop] = point[yProp];
        point[yPropBottom] = point[yProp];
      }
    });
  });

  return data;
};

var stackedArea = exports.stackedArea = function stackedArea(_ref4) {
  var _ref4$type = _ref4.type,
      type = _ref4$type === undefined ? "stackedarea" : _ref4$type,
      data = _ref4.data,
      xProp = _ref4.xProp,
      yProp = _ref4.yProp,
      yPropMiddle = _ref4.yPropMiddle,
      sort = _ref4.sort,
      yPropTop = _ref4.yPropTop,
      yPropBottom = _ref4.yPropBottom;

  /* Object.keys(allData.map((d,i) => oAccessor(d,i)).reduce((p,c) => {
      p[c] = true
      return p
    }, {})) */

  var uniqXValues = [].concat(_toConsumableArray(new Set(data.map(function (d) {
    return d.data.map(function (p) {
      return datesForUnique(p[xProp]);
    });
  }).reduce(function (a, b) {
    return a.concat(b);
  }, []))));
  var stackSort = function stackSort(a, b) {
    return (0, _d3Array.sum)(b.data.map(function (p) {
      return p[yProp];
    })) - (0, _d3Array.sum)(a.data.map(function (p) {
      return p[yProp];
    }));
  };
  if (type === "stackedpercent-invert" || type === "stackedarea-invert") {
    stackSort = function stackSort(a, b) {
      return (0, _d3Array.sum)(a.data.map(function (p) {
        return p[yProp];
      })) - (0, _d3Array.sum)(b.data.map(function (p) {
        return p[yProp];
      }));
    };
  }
  sort = sort === undefined ? stackSort : sort;

  if (sort !== null) {
    data = data.sort(sort);
  }

  uniqXValues.forEach(function (xValue) {
    var negativeOffset = 0;
    var positiveOffset = 0;
    var stepValues = data.map(function (d) {
      return d.data.filter(function (p) {
        return datesForUnique(p[xProp]) === xValue;
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }, []);

    var positiveStepTotal = (0, _d3Array.sum)(stepValues.map(function (d) {
      return d[yProp] > 0 ? d[yProp] : 0;
    }));
    var negativeStepTotal = (0, _d3Array.sum)(stepValues.map(function (d) {
      return d[yProp] < 0 ? d[yProp] : 0;
    }));

    stepValues.forEach(function (l) {
      if (l[yProp] < 0) {
        if (type === "linepercent" || type === "stackedpercent" || type === "stackedpercent-invert") {
          var percent = l[yProp] / negativeStepTotal;
          l.percent = percent;
          if (type === "linepercent") {
            l[yPropBottom] = l[yPropTop] = l[yPropMiddle] = percent;
          } else {
            var adjustment = negativeStepTotal >= 0 ? 0 : percent;
            l[yPropBottom] = negativeStepTotal === 0 ? 0 : -(negativeOffset / negativeStepTotal);
            l[yPropTop] = l[yPropBottom] - adjustment;
            l[yPropMiddle] = l[yPropBottom] - adjustment / 2;
          }
        } else {
          l[yPropBottom] = negativeOffset;
          l[yPropTop] = negativeOffset + l[yProp];
          l[yPropMiddle] = negativeOffset + l[yProp] / 2;
        }
        negativeOffset += l[yProp];
      } else {
        if (type === "linepercent" || type === "stackedpercent" || type === "stackedpercent-invert") {
          var _percent = l[yProp] / positiveStepTotal;
          l.percent = _percent;

          if (type === "linepercent") {
            l[yPropBottom] = l[yPropTop] = l[yPropMiddle] = _percent;
          } else {
            var _adjustment = positiveStepTotal <= 0 ? 0 : _percent;
            l[yPropBottom] = positiveStepTotal === 0 ? 0 : positiveOffset / positiveStepTotal;
            l[yPropTop] = l[yPropBottom] + _adjustment;
            l[yPropMiddle] = l[yPropBottom] + _adjustment / 2;
          }
        } else {
          l[yPropBottom] = positiveOffset;
          l[yPropTop] = positiveOffset + l[yProp];
          l[yPropMiddle] = positiveOffset + l[yProp] / 2;
        }
        positiveOffset += l[yProp];
      }
    });
  });

  return data;
};

var lineChart = exports.lineChart = function lineChart(_ref5) {
  var data = _ref5.data,
      y1 = _ref5.y1,
      yPropTop = _ref5.yPropTop,
      yPropMiddle = _ref5.yPropMiddle,
      yPropBottom = _ref5.yPropBottom;

  if (y1) {
    data.forEach(function (d) {
      d.data.forEach(function (p) {
        p[yPropBottom] = y1(p);
        p[yPropMiddle] = p[yPropBottom] + p[yPropTop] / 2;
      });
    });
  }

  return data;
};

var bumpChart = exports.bumpChart = function bumpChart(_ref6) {
  var _ref6$type = _ref6.type,
      type = _ref6$type === undefined ? "bumpline" : _ref6$type,
      data = _ref6.data,
      xProp = _ref6.xProp,
      yProp = _ref6.yProp,
      yPropMiddle = _ref6.yPropMiddle,
      yPropTop = _ref6.yPropTop,
      yPropBottom = _ref6.yPropBottom;

  var uniqXValues = [].concat(_toConsumableArray(new Set(data.map(function (d) {
    return d.data.map(function (p) {
      return datesForUnique(p[xProp]);
    });
  }).reduce(function (a, b) {
    return a.concat(b);
  }, []))));

  var bumpSort = function bumpSort(a, b) {
    if (a[yProp] > b[yProp]) {
      return 1;
    }
    if (a[yProp] < b[yProp]) {
      return -1;
    }
    return -1;
  };
  if (type === "bumparea-invert" || type === "bumpline-invert") {
    bumpSort = function bumpSort(a, b) {
      if (a[yProp] < b[yProp]) {
        return 1;
      }
      if (a[yProp] > b[yProp]) {
        return -1;
      }
      return -1;
    };
  }

  uniqXValues.forEach(function (xValue) {
    var negativeOffset = 0;
    var positiveOffset = 0;

    data.map(function (d) {
      return d.data.filter(function (p) {
        return datesForUnique(p[xProp]) === xValue;
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }, []).sort(bumpSort).forEach(function (l, rank) {
      //determine ranking and offset by the number of less than this one at each step
      l._XYFrameRank = rank;
      if (type === "bumparea" || type === "bumparea-invert") {
        if (l[yProp] < 0) {
          l[yPropTop] = negativeOffset + l[yProp];
          l[yPropMiddle] = negativeOffset + l[yProp] / 2;
          l[yPropBottom] = negativeOffset;
          negativeOffset += l[yProp];
        } else {
          l[yPropTop] = positiveOffset + l[yProp];
          l[yPropMiddle] = positiveOffset + l[yProp] / 2;
          l[yPropBottom] = positiveOffset;
          positiveOffset += l[yProp];
        }
      } else {
        l[yProp] = rank;
        l[yPropTop] = rank;
        l[yPropBottom] = rank;
      }
    });
  });

  return data;
};

var dividedLine = exports.dividedLine = function dividedLine(parameters, points) {
  var searchIterations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;

  var currentParameters = parameters(points[0], 0);
  var currentPointsArray = [];
  var dividedLinesData = [{ key: currentParameters, points: currentPointsArray }];
  points.forEach(function (point, pointI) {
    var newParameters = parameters(point, pointI);

    var matchingParams = newParameters === currentParameters;
    var stringNewParams = JSON.stringify(newParameters);
    var stringCurrentParams = JSON.stringify(currentParameters);

    if ((typeof currentParameters === "undefined" ? "undefined" : _typeof(currentParameters)) === "object") {
      matchingParams = stringNewParams === stringCurrentParams;
    }

    if (matchingParams) {
      currentPointsArray.push(point);
    } else {
      var lastPoint = currentPointsArray[currentPointsArray.length - 1];
      var pointA = lastPoint;
      var pointB = point;
      var stringBParams = stringNewParams;

      var x = 0;
      while (x < searchIterations && stringNewParams === stringBParams) {
        var keys = Object.keys(pointA);
        var findPoints = simpleSearchFunction({
          pointA: pointA,
          pointB: pointB,
          currentParameters: currentParameters,
          parameters: parameters,
          keys: keys
        });
        pointA = findPoints[0];
        pointB = findPoints[1];
        stringBParams = JSON.stringify(parameters(pointB));
        x++;
      }
      currentPointsArray.push(pointB);
      currentPointsArray = [pointB, point];
      dividedLinesData.push({ key: newParameters, points: currentPointsArray });
      currentParameters = newParameters;
    }
  });
  return dividedLinesData;
};

function simpleSearchFunction(_ref7) {
  var pointA = _ref7.pointA,
      pointB = _ref7.pointB,
      currentParameters = _ref7.currentParameters,
      parameters = _ref7.parameters,
      keys = _ref7.keys;

  var betweenPoint = {};
  keys.forEach(function (key) {
    betweenPoint[key] = typeof pointA[key] === "number" ? (pointA[key] + pointB[key]) / 2 : undefined;
  });
  var stringBetween = JSON.stringify(parameters(betweenPoint));
  var stringCurrent = JSON.stringify(currentParameters);

  if (stringBetween === stringCurrent) {
    return [betweenPoint, pointB];
  }
  return [pointA, betweenPoint];
}

function funnelize(_ref8) {
  var data = _ref8.data,
      steps = _ref8.steps,
      key = _ref8.key;

  var funnelData = [];
  if (!Array.isArray(data)) {
    data = [data];
  }
  if (!steps) {
    steps = data.map(function (d) {
      return Object.keys(d);
    }).reduce(function (a, b) {
      return a.concat(b);
    }, []);
  }

  data.forEach(function (datum, i) {
    var datumKey = key ? datum[key] : i;
    steps.forEach(function (step) {
      var funnelDatum = { funnelKey: datumKey };
      funnelDatum.stepName = step;
      funnelDatum.stepValue = datum[step] ? datum[step] : 0;
      funnelData.push(funnelDatum);
    });
  });

  return funnelData;
}

function relativeY(_ref9) {
  var point = _ref9.point,
      lines = _ref9.lines,
      projectedYMiddle = _ref9.projectedYMiddle,
      projectedY = _ref9.projectedY,
      projectedX = _ref9.projectedX,
      xAccessor = _ref9.xAccessor,
      yAccessor = _ref9.yAccessor,
      yScale = _ref9.yScale,
      xScale = _ref9.xScale,
      idAccessor = _ref9.idAccessor;

  if (idAccessor(point)) {
    var thisLine = lines.data.find(function (l) {
      return idAccessor(l) === idAccessor(point);
    });
    if (!thisLine) {
      return null;
    }
    var thisPoint = thisLine.data.find(function (p) {
      return xScale(p[projectedX]) === xScale(xAccessor(point));
    });
    if (!thisPoint) {
      return null;
    }
    point = thisPoint;
  }
  return yScale(point[projectedYMiddle] || point[projectedY] || yAccessor(point));
}

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tweenValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(21);


function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
});

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(node, id).value[name];
  };
}


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Linear(context);
});


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Basis;
function point(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = (function(context) {
  return new Basis(context);
});


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Cardinal;
function point(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = deinterpolateLinear;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["b"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(442);






var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolate */],
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["e" /* interpolateRound */], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_nest__ = __webpack_require__(1137);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "nest", function() { return __WEBPACK_IMPORTED_MODULE_0__src_nest__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_set__ = __webpack_require__(1138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "set", function() { return __WEBPACK_IMPORTED_MODULE_1__src_set__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_map__ = __webpack_require__(222);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "map", function() { return __WEBPACK_IMPORTED_MODULE_2__src_map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_keys__ = __webpack_require__(1139);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "keys", function() { return __WEBPACK_IMPORTED_MODULE_3__src_keys__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_values__ = __webpack_require__(1140);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "values", function() { return __WEBPACK_IMPORTED_MODULE_4__src_values__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_entries__ = __webpack_require__(1141);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "entries", function() { return __WEBPACK_IMPORTED_MODULE_5__src_entries__["a"]; });








/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = deinterpolateLinear;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["b"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(453);






var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolate"],
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateRound"], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _axis = __webpack_require__(226);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// components

function formatValue(value, props) {
  if (props.tickFormat) {
    return props.tickFormat(value);
  }
  if (value.toString) {
    return value.toString();
  }
  return value;
}

var Axis = function (_React$Component) {
  _inherits(Axis, _React$Component);

  function Axis(props) {
    _classCallCheck(this, Axis);

    var _this = _possibleConstructorReturn(this, (Axis.__proto__ || Object.getPrototypeOf(Axis)).call(this, props));

    _this.state = { hoverAnnotation: 0 };
    return _this;
  }

  _createClass(Axis, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var position = this.props.position || [0, 0];
      var _props = this.props,
          rotate = _props.rotate,
          label = _props.label,
          _props$orient = _props.orient,
          orient = _props$orient === undefined ? "left" : _props$orient,
          _props$tickFormat = _props.tickFormat,
          tickFormat = _props$tickFormat === undefined ? function (d) {
        return d;
      } : _props$tickFormat,
          size = _props.size,
          _props$width = _props.width,
          width = _props$width === undefined ? size && size[0] || 0 : _props$width,
          _props$height = _props.height,
          height = _props$height === undefined ? size && size[1] || 0 : _props$height,
          className = _props.className,
          padding = _props.padding,
          tickValues = _props.tickValues,
          scale = _props.scale,
          ticks = _props.ticks,
          footer = _props.footer,
          tickSize = _props.tickSize,
          tickLineGenerator = _props.tickLineGenerator,
          _props$baseline = _props.baseline,
          baseline = _props$baseline === undefined ? true : _props$baseline,
          _props$margin = _props.margin,
          margin = _props$margin === undefined ? { top: 0, bottom: 0, left: 0, right: 0 } : _props$margin;


      if (this.props.format) {
        console.error("axis `format` has been deprecated use `tickFormat`");
      }

      var axisTickLines = void 0;
      var axisParts = this.props.axisParts;

      if (!axisParts) {
        axisParts = (0, _axis.axisPieces)({
          padding: padding,
          tickValues: tickValues,
          scale: scale,
          ticks: ticks,
          orient: orient,
          size: [width, height],
          footer: footer,
          tickSize: tickSize
        });
        axisTickLines = _react2.default.createElement(
          "g",
          { className: "axis " + className },
          (0, _axis.axisLines)({ axisParts: axisParts, orient: orient, tickLineGenerator: tickLineGenerator })
        );
      }
      if (axisParts.length === 0) {
        return null;
      }

      var hoverWidth = 50;
      var hoverHeight = height;
      var hoverX = -50;
      var hoverY = 0;
      var baselineX = 0;
      var baselineY = 0;
      var baselineX2 = 0;
      var baselineY2 = height;

      var hoverFunction = function hoverFunction(e) {
        return _this2.setState({ hoverAnnotation: e.nativeEvent.offsetY });
      };
      var circleX = 25;
      var textX = -25;
      var textY = 18;
      var lineWidth = width + 25;
      var lineHeight = 0;
      var circleY = this.state.hoverAnnotation;
      var annotationOffset = 0;
      var annotationType = "y";

      switch (orient) {
        case "right":
          position = [position[0], position[1]];
          hoverX = width;
          baselineX2 = baselineX = width;
          annotationOffset = margin.top;
          lineWidth = -width - 25;
          textX = 5;
          hoverFunction = function hoverFunction(e) {
            return _this2.setState({
              hoverAnnotation: e.nativeEvent.offsetY - annotationOffset
            });
          };
          break;
        case "top":
          position = [position[0], 0];
          hoverWidth = width;
          hoverHeight = 50;
          hoverY = -50;
          hoverX = 0;
          annotationOffset = margin.left;
          annotationType = "x";
          baselineX2 = width;
          baselineY2 = 0;
          hoverFunction = function hoverFunction(e) {
            return _this2.setState({
              hoverAnnotation: e.nativeEvent.offsetX - annotationOffset
            });
          };
          circleX = this.state.hoverAnnotation;
          circleY = 25;
          textX = 0;
          textY = -10;
          lineWidth = 0;
          lineHeight = height + 25;
          break;
        case "bottom":
          position = [position[0], position[1]];
          position = [position[0], 0];
          hoverWidth = width;
          hoverHeight = 50;
          baselineY = baselineY2 = hoverY = height;
          baselineX = hoverX = 0;
          baselineX2 = width;
          annotationOffset = margin.left;

          hoverFunction = function hoverFunction(e) {
            return _this2.setState({
              hoverAnnotation: e.nativeEvent.offsetX - annotationOffset
            });
          };
          circleX = this.state.hoverAnnotation;
          circleY = 25;
          textX = 0;
          textY = 15;
          lineWidth = 0;
          lineHeight = -height - 25;
          annotationType = "x";
          break;
        default:
          position = [position[0], position[1]];
          annotationOffset = margin.top;
          hoverFunction = function hoverFunction(e) {
            return _this2.setState({
              hoverAnnotation: e.nativeEvent.offsetY - annotationOffset
            });
          };
      }

      var annotationBrush = void 0;

      if (this.props.annotationFunction) {
        var formattedValue = formatValue(this.props.scale.invert(this.state.hoverAnnotation), this.props);
        var hoverGlyph = this.props.glyphFunction ? this.props.glyphFunction({
          lineHeight: lineHeight,
          lineWidth: lineWidth,
          value: this.props.scale.invert(this.state.hoverAnnotation)
        }) : _react2.default.createElement(
          "g",
          null,
          _react2.default.isValidElement(formattedValue) ? _react2.default.createElement(
            "g",
            { transform: "translate(" + textX + "," + textY + ")" },
            formattedValue
          ) : _react2.default.createElement(
            "text",
            { x: textX, y: textY },
            formattedValue
          ),
          _react2.default.createElement("circle", { r: 5 }),
          _react2.default.createElement("line", { x1: lineWidth, y1: lineHeight, style: { stroke: "black" } })
        );
        var annotationSymbol = this.state.hoverAnnotation ? _react2.default.createElement(
          "g",
          {
            style: { pointerEvents: "none" },
            transform: "translate(" + circleX + "," + circleY + ")"
          },
          hoverGlyph
        ) : null;

        annotationBrush = _react2.default.createElement(
          "g",
          {
            className: "annotation-brush",
            transform: "translate(" + hoverX + "," + hoverY + ")"
          },
          _react2.default.createElement("rect", {
            style: { fillOpacity: 0 },
            height: hoverHeight,
            width: hoverWidth,
            onMouseMove: hoverFunction,
            onClick: function onClick() {
              return _this2.props.annotationFunction({
                className: "dynamic-axis-annotation",
                type: annotationType,
                value: _this2.props.scale.invert(_this2.state.hoverAnnotation)
              });
            },
            onMouseOut: function onMouseOut() {
              return _this2.setState({ hoverAnnotation: undefined });
            }
          }),
          annotationSymbol
        );
      }

      var axisTitle = void 0;

      var axisTickLabels = (0, _axis.axisLabels)({
        tickFormat: tickFormat,
        axisParts: axisParts,
        orient: orient,
        rotate: rotate
      });
      if (label) {
        var labelName = label.name || label;
        var labelPosition = label.position || {};
        var locationMod = labelPosition.location || "outside";
        var anchorMod = labelPosition.anchor || "middle";
        var distance = label.locationDistance;

        var rotateHash = {
          left: -90,
          right: 90,
          top: 0,
          bottom: 0
        };

        var rotation = labelPosition.rotation || rotateHash[orient];

        var positionHash = {
          left: {
            start: [0, size[1]],
            middle: [0, size[1] / 2],
            end: [0, 0],
            inside: [distance || 15, 0],
            outside: [-(distance || 45), 0]
          },
          right: {
            start: [size[0] + 0, size[1]],
            middle: [size[0] + 0, size[1] / 2],
            end: [size[0] + 0, 0],
            inside: [-(distance || 15), 0],
            outside: [distance || 45, 0]
          },
          top: {
            start: [0, 0],
            middle: [0 + size[0] / 2, 0],
            end: [0 + size[0], 0],
            inside: [0, distance || 15],
            outside: [0, -(distance || 40)]
          },
          bottom: {
            start: [0, size[1]],
            middle: [0 + size[0] / 2, size[1]],
            end: [0 + size[0], size[1]],
            inside: [0, -(distance || 5)],
            outside: [0, distance || 50]
          }
        };

        var translation = positionHash[orient][anchorMod];
        var location = positionHash[orient][locationMod];

        translation[0] = translation[0] + location[0];
        translation[1] = translation[1] + location[1];

        if (anchorMod === "start" && orient === "right") {
          anchorMod = "end";
        } else if (anchorMod === "end" && orient === "right") {
          anchorMod = "start";
        }

        axisTitle = _react2.default.createElement(
          "g",
          {
            className: "axis-title",
            transform: "translate(" + [translation[0] + position[0], translation[1] + position[1]] + ") rotate(" + rotation + ")"
          },
          _react2.default.isValidElement(labelName) ? labelName : _react2.default.createElement(
            "text",
            { textAnchor: anchorMod },
            labelName
          )
        );
      }

      return _react2.default.createElement(
        "g",
        { className: className },
        annotationBrush,
        axisTickLabels,
        axisTickLines,
        baseline ? _react2.default.createElement("line", {
          key: "baseline",
          className: "axis-baseline",
          stroke: "black",
          strokeLinecap: "square",
          x1: baselineX,
          x2: baselineX2,
          y1: baselineY,
          y2: baselineY2
        }) : null,
        axisTitle
      );
    }
  }]);

  return Axis;
}(_react2.default.Component);

Axis.propTypes = {
  name: _propTypes2.default.string,
  className: _propTypes2.default.string,
  orient: _propTypes2.default.string,
  position: _propTypes2.default.array,
  size: _propTypes2.default.array.isRequired,
  rotate: _propTypes2.default.number,
  scale: _propTypes2.default.func.isRequired,
  annotationFunction: _propTypes2.default.func,
  format: _propTypes2.default.string,
  tickFormat: _propTypes2.default.func,
  tickValues: _propTypes2.default.array,
  padding: _propTypes2.default.number,
  baseline: _propTypes2.default.bool,
  ticks: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.number]),
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.object])
};

exports.default = Axis;
module.exports = exports['default'];

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupBarMark = exports.hexToRgb = exports.wrap = exports.drawAreaConnector = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.linearRibbon = linearRibbon;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Selection = __webpack_require__(229);

var _d3Shape = __webpack_require__(30);

var _semioticMark = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var twoPI = Math.PI * 2;

var drawAreaConnector = exports.drawAreaConnector = function drawAreaConnector(_ref) {
  var x1 = _ref.x1,
      x2 = _ref.x2,
      y1 = _ref.y1,
      y2 = _ref.y2,
      sizeX1 = _ref.sizeX1,
      sizeY1 = _ref.sizeY1,
      sizeX2 = _ref.sizeX2,
      sizeY2 = _ref.sizeY2;

  return "M" + x1 + "," + y1 + "L" + x2 + "," + y2 + "L" + (x2 + sizeX2) + "," + (y2 + sizeY2) + "L" + (x1 + sizeX1) + "," + (y1 + sizeY1) + "Z";
};

var wrap = exports.wrap = function wrap(text, width) {
  text.each(function () {
    var textNode = (0, _d3Selection.select)(this),
        words = textNode.text().split(/\s+/).reverse(),
        lineHeight = 1.1,
        // ems
    y = textNode.attr("y"),
        dy = parseFloat(textNode.attr("dy"));

    var word = void 0,
        wordline = [],
        lineNumber = 0,
        tspan = textNode.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");

    while (words.length > 0) {
      word = words.pop();
      wordline.push(word);
      tspan.text(wordline.join(" "));
      if (tspan.node().getComputedTextLength() > width) {
        wordline.pop();
        tspan.text(wordline.join(" "));
        wordline = [word];

        tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
      }
    }
  });
};

var hexToRgb = exports.hexToRgb = function hexToRgb(hex) {
  if (hex.substr(0, 1).toLowerCase() === "r") {
    return hex.split("(")[1].split(")")[0].split(",");
  }
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : [0, 0, 0];
};

var groupBarMark = exports.groupBarMark = function groupBarMark(_ref2) {
  var bins = _ref2.bins,
      binMax = _ref2.binMax,
      relativeBuckets = _ref2.relativeBuckets,
      columnWidth = _ref2.columnWidth,
      projection = _ref2.projection,
      adjustedSize = _ref2.adjustedSize,
      summaryI = _ref2.summaryI,
      summary = _ref2.summary,
      renderValue = _ref2.renderValue,
      summaryStyle = _ref2.summaryStyle,
      type = _ref2.type,
      baseMarkProps = _ref2.baseMarkProps;

  var xProp = -columnWidth / 2;

  var mappedBins = [];
  var mappedPoints = [];
  var actualMax = relativeBuckets && relativeBuckets[summary.name] || binMax;

  bins.forEach(function (d, i) {
    var opacity = d.value / actualMax;
    var finalStyle = type.type === "heatmap" ? { opacity: opacity, fill: summaryStyle.fill } : summaryStyle;
    var finalColumnWidth = type.type === "heatmap" ? columnWidth : columnWidth * opacity;
    var yProp = d.y;
    var height = d.y1;
    var width = finalColumnWidth;
    var xOffset = type.type === "heatmap" ? finalColumnWidth / 2 : finalColumnWidth;
    var yOffset = d.y1 / 2;

    if (projection === "horizontal") {
      yProp = type.type === "heatmap" ? -columnWidth / 2 : columnWidth / 2 - finalColumnWidth;
      xProp = d.y - d.y1;
      height = finalColumnWidth;
      width = d.y1;
      yOffset = type.type === "heatmap" ? finalColumnWidth / 2 : finalColumnWidth;
      xOffset = d.y1 / 2;
    } else if (projection === "radial") {
      var arcGenerator = (0, _d3Shape.arc)().innerRadius(d.y / 2).outerRadius((d.y + d.y1) / 2);

      var angle = summary.pct - summary.pct_padding;
      var startAngle = summary.pct_middle - summary.pct_padding;

      var endAngle = type.type === "heatmap" ? startAngle + angle : startAngle + angle * opacity;
      startAngle *= twoPI;
      endAngle *= twoPI;

      var arcAdjustX = adjustedSize[0] / 2;
      var arcAdjustY = adjustedSize[1] / 2;

      var arcTranslate = "translate(" + arcAdjustX + "," + arcAdjustY + ")";
      var arcCenter = arcGenerator.centroid({ startAngle: startAngle, endAngle: endAngle });
      mappedPoints.push({
        key: summary.name,
        value: d.value,
        pieces: d.pieces.map(function (p) {
          return p.piece;
        }),
        label: "Heatmap",
        x: arcCenter[0] + arcAdjustX,
        y: arcCenter[1] + arcAdjustY
      });
      mappedBins.push(_react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
        markType: "path",
        transform: arcTranslate,
        renderMode: renderValue,
        key: "groupIcon-" + summaryI + "-" + i,
        d: arcGenerator({ startAngle: startAngle, endAngle: endAngle }),
        style: finalStyle
      })));
    }
    if (projection !== "radial") {
      mappedPoints.push({
        key: summary.name,
        value: d.value,
        pieces: d.pieces.map(function (p) {
          return p.piece;
        }),
        label: "Heatmap",
        x: xProp + xOffset,
        y: yProp + yOffset
      });

      mappedBins.push(_react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
        markType: "rect",
        renderMode: renderValue,
        key: "groupIcon-" + summaryI + "-" + i,
        x: xProp,
        y: yProp,
        height: height,
        width: width,
        style: finalStyle
      })));
    }
  });

  return { marks: mappedBins, points: mappedPoints };
};

// FROM d3-svg-ribbon
function linearRibbon() {
  var _lineConstructor = (0, _d3Shape.line)();
  var _xAccessor = function _xAccessor(d) {
    return d.x;
  };
  var _yAccessor = function _yAccessor(d) {
    return d.y;
  };
  var _rAccessor = function _rAccessor(d) {
    return d.r;
  };
  var _interpolator = _d3Shape.curveLinearClosed;

  function _ribbon(pathData) {
    var bothPoints = buildRibbon(pathData);

    return _lineConstructor.x(_xAccessor).y(_yAccessor).curve(_interpolator)(bothPoints);
  }

  _ribbon.x = function (_value) {
    if (!arguments.length) return _xAccessor;

    _xAccessor = _value;
    return _ribbon;
  };

  _ribbon.y = function (_value) {
    if (!arguments.length) return _yAccessor;

    _yAccessor = _value;
    return _ribbon;
  };

  _ribbon.r = function (_value) {
    if (!arguments.length) return _rAccessor;

    _rAccessor = _value;
    return _ribbon;
  };

  _ribbon.interpolate = function (_value) {
    if (!arguments.length) return _interpolator;

    _interpolator = _value;
    return _ribbon;
  };

  return _ribbon;

  function offsetEdge(d) {
    var diffX = _yAccessor(d.target) - _yAccessor(d.source);
    var diffY = _xAccessor(d.target) - _xAccessor(d.source);

    var angle0 = Math.atan2(diffY, diffX) + Math.PI / 2;
    var angle1 = angle0 + Math.PI * 0.5;
    var angle2 = angle0 + Math.PI * 0.5;

    var x1 = _xAccessor(d.source) + _rAccessor(d.source) * Math.cos(angle1);
    var y1 = _yAccessor(d.source) - _rAccessor(d.source) * Math.sin(angle1);
    var x2 = _xAccessor(d.target) + _rAccessor(d.target) * Math.cos(angle2);
    var y2 = _yAccessor(d.target) - _rAccessor(d.target) * Math.sin(angle2);

    return { x1: x1, y1: y1, x2: x2, y2: y2 };
  }

  function buildRibbon(points) {
    var bothCode = [];
    var x = 0;
    var transformedPoints = {};

    while (x < points.length) {
      if (x !== points.length - 1) {
        transformedPoints = offsetEdge({
          source: points[x],
          target: points[x + 1]
        });
        var p1 = { x: transformedPoints.x1, y: transformedPoints.y1 };
        var p2 = { x: transformedPoints.x2, y: transformedPoints.y2 };
        bothCode.push(p1, p2);
        if (bothCode.length > 3) {
          var l = bothCode.length - 1;
          var lineA = { a: bothCode[l - 3], b: bothCode[l - 2] };
          var lineB = { a: bothCode[l - 1], b: bothCode[l] };
          var intersect = findIntersect(lineA.a.x, lineA.a.y, lineA.b.x, lineA.b.y, lineB.a.x, lineB.a.y, lineB.b.x, lineB.b.y);
          if (intersect.found === true) {
            lineA.b.x = intersect.x;
            lineA.b.y = intersect.y;
            lineB.a.x = intersect.x;
            lineB.a.y = intersect.y;
          }
        }
      }

      x++;
    }
    x--;
    //Back
    while (x >= 0) {
      if (x !== 0) {
        transformedPoints = offsetEdge({
          source: points[x],
          target: points[x - 1]
        });
        var _p = { x: transformedPoints.x1, y: transformedPoints.y1 };
        var _p2 = { x: transformedPoints.x2, y: transformedPoints.y2 };
        bothCode.push(_p, _p2);
        if (bothCode.length > 3) {
          var _l = bothCode.length - 1;
          var _lineA = { a: bothCode[_l - 3], b: bothCode[_l - 2] };
          var _lineB = { a: bothCode[_l - 1], b: bothCode[_l] };
          var _intersect = findIntersect(_lineA.a.x, _lineA.a.y, _lineA.b.x, _lineA.b.y, _lineB.a.x, _lineB.a.y, _lineB.b.x, _lineB.b.y);
          if (_intersect.found === true) {
            _lineA.b.x = _intersect.x;
            _lineA.b.y = _intersect.y;
            _lineB.a.x = _intersect.x;
            _lineB.a.y = _intersect.y;
          }
        }
      }

      x--;
    }

    return bothCode;
  }

  function findIntersect(l1x1, l1y1, l1x2, l1y2, l2x1, l2y1, l2x2, l2y2) {
    var a = void 0,
        b = void 0;

    var result = {
      x: null,
      y: null,
      found: false
    };

    var d = (l2y2 - l2y1) * (l1x2 - l1x1) - (l2x2 - l2x1) * (l1y2 - l1y1);
    if (d === 0) {
      return result;
    }
    a = l1y1 - l2y1;
    b = l1x1 - l2x1;
    var n1 = (l2x2 - l2x1) * a - (l2y2 - l2y1) * b;
    var n2 = (l1x2 - l1x1) * a - (l1y2 - l1y1) * b;
    a = n1 / d;
    b = n2 / d;

    result.x = l1x1 + a * (l1x2 - l1x1);
    result.y = l1y1 + a * (l1y2 - l1y1);

    if (a > 0 && a < 1 && b > 0 && b < 1) {
      result.found = true;
    }

    return result;
  }
}

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_cluster__ = __webpack_require__(1218);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cluster", function() { return __WEBPACK_IMPORTED_MODULE_0__src_cluster__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_hierarchy_index__ = __webpack_require__(240);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hierarchy", function() { return __WEBPACK_IMPORTED_MODULE_1__src_hierarchy_index__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_pack_index__ = __webpack_require__(1230);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pack", function() { return __WEBPACK_IMPORTED_MODULE_2__src_pack_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_pack_siblings__ = __webpack_require__(467);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "packSiblings", function() { return __WEBPACK_IMPORTED_MODULE_3__src_pack_siblings__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_pack_enclose__ = __webpack_require__(468);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "packEnclose", function() { return __WEBPACK_IMPORTED_MODULE_4__src_pack_enclose__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_partition__ = __webpack_require__(1232);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "partition", function() { return __WEBPACK_IMPORTED_MODULE_5__src_partition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_stratify__ = __webpack_require__(1233);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stratify", function() { return __WEBPACK_IMPORTED_MODULE_6__src_stratify__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_tree__ = __webpack_require__(1234);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tree", function() { return __WEBPACK_IMPORTED_MODULE_7__src_tree__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_treemap_index__ = __webpack_require__(1235);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "treemap", function() { return __WEBPACK_IMPORTED_MODULE_8__src_treemap_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_treemap_binary__ = __webpack_require__(1236);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "treemapBinary", function() { return __WEBPACK_IMPORTED_MODULE_9__src_treemap_binary__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_treemap_dice__ = __webpack_require__(97);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "treemapDice", function() { return __WEBPACK_IMPORTED_MODULE_10__src_treemap_dice__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_treemap_slice__ = __webpack_require__(140);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "treemapSlice", function() { return __WEBPACK_IMPORTED_MODULE_11__src_treemap_slice__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_treemap_sliceDice__ = __webpack_require__(1237);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "treemapSliceDice", function() { return __WEBPACK_IMPORTED_MODULE_12__src_treemap_sliceDice__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_treemap_squarify__ = __webpack_require__(242);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "treemapSquarify", function() { return __WEBPACK_IMPORTED_MODULE_13__src_treemap_squarify__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_treemap_resquarify__ = __webpack_require__(1238);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "treemapResquarify", function() { return __WEBPACK_IMPORTED_MODULE_14__src_treemap_resquarify__["a"]; });

















/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (y1 - y0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
});


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orFrameAxisGenerator = exports.calculateMargin = exports.trueAxis = exports.drawMarginPath = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.objectifyType = objectifyType;
exports.generateOrdinalFrameEventListeners = generateOrdinalFrameEventListeners;
exports.keyAndObjectifyBarData = keyAndObjectifyBarData;
exports.adjustedPositionSize = adjustedPositionSize;
exports.generateFrameTitle = generateFrameTitle;
exports.orFrameConnectionRenderer = orFrameConnectionRenderer;
exports.orFrameSummaryRenderer = orFrameSummaryRenderer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgHelper = __webpack_require__(138);

var _semioticMark = __webpack_require__(15);

var _Axis = __webpack_require__(137);

var _Axis2 = _interopRequireDefault(_Axis);

var _summaryLayouts = __webpack_require__(474);

var _axis = __webpack_require__(226);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function roundToTenth(number) {
  return Math.round(number * 10) / 10;
}

var circlePath = function circlePath(cx, cy, r) {
  return ["M", roundToTenth(cx - r), roundToTenth(cy), "a", r, r, 0, 1, 0, r * 2, 0, "a", r, r, 0, 1, 0, -(r * 2), 0].join(" ") + "Z";
};

var drawMarginPath = exports.drawMarginPath = function drawMarginPath(_ref) {
  var margin = _ref.margin,
      size = _ref.size,
      _ref$inset = _ref.inset,
      inset = _ref$inset === undefined ? 5 : _ref$inset;

  var iSize = [size[0] - inset, size[1] - inset];
  return "M0,0 h" + size[0] + " v" + size[1] + " h-" + size[0] + "Z M" + (margin.left - inset) + "," + (margin.top - inset) + " v" + (size[1] + inset * 2 - margin.top - margin.bottom) + " h" + (iSize[0] + inset * 3 - margin.left - margin.right) + " v-" + (iSize[1] + inset * 3 - margin.top - margin.bottom) + "Z";
};

var trueAxis = exports.trueAxis = function trueAxis(orient, projection) {
  if (projection === "horizontal" && ["top", "bottom"].indexOf(orient) === -1) {
    return "bottom";
  } else if ((!projection || projection === "vertical") && ["left", "right"].indexOf(orient) === -1) {
    return "left";
  } else if (!orient && projection === "horizontal") {
    return "bottom";
  } else if (!orient) {
    return "left";
  }
  return orient;
};

var calculateMargin = exports.calculateMargin = function calculateMargin(_ref2) {
  var margin = _ref2.margin,
      axis = _ref2.axis,
      axes = _ref2.axes,
      title = _ref2.title,
      oLabel = _ref2.oLabel,
      projection = _ref2.projection;

  if (margin !== undefined) {
    var tempMargin = margin;
    if ((typeof margin === "undefined" ? "undefined" : _typeof(margin)) !== "object") {
      tempMargin = { top: margin, bottom: margin, left: margin, right: margin };
    }
    return _extends({ top: 0, bottom: 0, left: 0, right: 0 }, tempMargin);
  }
  var finalMargin = { top: 0, bottom: 0, left: 0, right: 0 };
  if (title && title.length !== 0) {
    finalMargin.top = 30;
  }
  var orient = trueAxis(null, projection);
  if (axis && projection !== "radial") {
    orient = trueAxis(axis.orient, projection);
    finalMargin[orient] += 50;
  }
  if (axes) {
    axes.forEach(function (axisObj) {
      orient = axisObj.orient;
      finalMargin[orient] += 50;
    });
  }
  if (oLabel && projection !== "radial") {
    if (orient === "bottom" || orient === "top") {
      finalMargin.left += 50;
    } else {
      finalMargin.bottom += 50;
    }
  }
  return finalMargin;
};

function objectifyType(type) {
  return (typeof type === "undefined" ? "undefined" : _typeof(type)) === "object" && type !== null ? type : { type: type };
}

function generateOrdinalFrameEventListeners(customHoverBehavior, customClickBehavior) {
  var eventListenersGenerator = function eventListenersGenerator() {
    return {};
  };

  if (customHoverBehavior || customClickBehavior) {
    eventListenersGenerator = function eventListenersGenerator(d, i) {
      return {
        onMouseEnter: customHoverBehavior ? function () {
          return customHoverBehavior(d, i);
        } : undefined,
        onMouseLeave: customHoverBehavior ? function () {
          return customHoverBehavior(undefined);
        } : undefined,
        onClick: customClickBehavior ? function () {
          return customClickBehavior(d, i);
        } : undefined
      };
    };
  }
  return eventListenersGenerator;
}

function keyAndObjectifyBarData(_ref3) {
  var data = _ref3.data,
      _ref3$renderKey = _ref3.renderKey,
      renderKey = _ref3$renderKey === undefined ? function (d, i) {
    return i;
  } : _ref3$renderKey;

  return data ? data.map(function (d, i) {
    var appliedKey = renderKey(d, i);
    if ((typeof d === "undefined" ? "undefined" : _typeof(d)) !== "object") {
      return {
        data: { value: d, renderKey: appliedKey },
        value: d,
        renderKey: appliedKey
      };
    }
    return { renderKey: appliedKey, data: d };
  }) : [];
}

function adjustedPositionSize(_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === undefined ? [500, 500] : _ref4$size,
      _ref4$position = _ref4.position,
      position = _ref4$position === undefined ? [0, 0] : _ref4$position,
      margin = _ref4.margin,
      axis = _ref4.axis,
      axes = _ref4.axes,
      title = _ref4.title,
      oLabel = _ref4.oLabel,
      projection = _ref4.projection;

  var finalMargin = calculateMargin({
    margin: margin,
    axis: axis,
    axes: axes,
    title: title,
    oLabel: oLabel,
    projection: projection
  });

  var heightAdjust = finalMargin.top + finalMargin.bottom;
  var widthAdjust = finalMargin.left + finalMargin.right;

  var adjustedPosition = [position[0], position[1]];
  var adjustedSize = [size[0] - widthAdjust, size[1] - heightAdjust];
  if (projection === "radial") {
    var minSize = Math.min(adjustedSize[0], adjustedSize[1]);
    adjustedSize = [minSize, minSize];
  }

  return { adjustedPosition: adjustedPosition, adjustedSize: adjustedSize };
}

function generateFrameTitle(_ref5) {
  var title = _ref5.title,
      size = _ref5.size;

  var finalTitle = null;
  if (typeof title === "string" && title.length > 0) {
    finalTitle = _react2.default.createElement(
      "text",
      {
        x: size[0] / 2,
        y: 25,
        className: "frame-title",
        style: { textAnchor: "middle", pointerEvents: "none" }
      },
      title
    );
  } else if (title) {
    //assume if defined then its an svg mark of some sort
    finalTitle = title;
  }
  return finalTitle;
}

function orFrameConnectionRenderer(_ref6) {
  var type = _ref6.type,
      data = _ref6.data,
      renderMode = _ref6.renderMode,
      eventListenersGenerator = _ref6.eventListenersGenerator,
      styleFn = _ref6.styleFn,
      classFn = _ref6.classFn,
      projection = _ref6.projection,
      canvasRender = _ref6.canvasRender,
      canvasDrawing = _ref6.canvasDrawing,
      baseMarkProps = _ref6.baseMarkProps;

  if (!type.type) {
    return null;
  }
  var renderedConnectorMarks = [];
  if (typeof type.type === "function") {
    var connectionRule = type.type;
    var keys = Object.keys(data);

    keys.forEach(function (key, pieceArrayI) {
      var pieceArray = data[key];
      var nextColumn = data[keys[pieceArrayI + 1]];
      if (nextColumn) {
        var matchArray = nextColumn.map(function (d, i) {
          return connectionRule(d.piece.data, i);
        });
        pieceArray.forEach(function (piece, pieceI) {
          var thisConnectionPiece = connectionRule(piece.piece.data, pieceI);
          var matchingPieceIndex = matchArray.indexOf(connectionRule(piece.piece.data, pieceI));
          if (thisConnectionPiece !== undefined && thisConnectionPiece !== null && matchingPieceIndex !== -1) {
            var matchingPiece = nextColumn[matchingPieceIndex];
            var markD = void 0;
            var xy = piece.xy;
            var mxy = matchingPiece.xy;
            var x = xy.x,
                y = xy.y,
                _xy$height = xy.height,
                height = _xy$height === undefined ? 1 : _xy$height,
                _xy$width = xy.width,
                width = _xy$width === undefined ? 1 : _xy$width;
            var mx = mxy.x,
                my = mxy.y,
                _mxy$height = mxy.height,
                mheight = _mxy$height === undefined ? 1 : _mxy$height,
                _mxy$width = mxy.width,
                mwidth = _mxy$width === undefined ? 1 : _mxy$width;

            if (projection === "vertical") {
              markD = (0, _SvgHelper.drawAreaConnector)({
                x1: x + width,
                x2: mx,
                y1: y,
                y2: my,
                sizeX1: 0,
                sizeX2: 0,
                sizeY1: height,
                sizeY2: mheight
              });
            } else if (projection === "horizontal") {
              markD = (0, _SvgHelper.drawAreaConnector)({
                x1: x,
                x2: mx,
                y1: y + height,
                y2: my,
                sizeX1: width,
                sizeX2: mwidth,
                sizeY1: 0,
                sizeY2: 0
              });
            } else if (projection === "radial") {
              markD = (0, _SvgHelper.drawAreaConnector)({
                x1: x,
                x2: mx,
                y1: y + height,
                y2: my,
                sizeX1: width,
                sizeX2: mwidth,
                sizeY1: 0,
                sizeY2: 0
              });
            }
            var renderValue = renderMode && renderMode(piece.piece, pieceI);

            var calculatedStyle = styleFn({
              source: piece.piece.data,
              target: matchingPiece.piece
            });

            var eventListeners = eventListenersGenerator({ source: piece.piece.data, target: matchingPiece.piece.data }, pieceI);
            if (canvasRender && canvasRender(piece.piece) === true) {
              var canvasConnector = {
                baseClass: "xyframe-line",
                tx: 0,
                ty: 0,
                d: { source: piece.piece, target: matchingPiece.piece },
                markProps: { d: markD, markType: "path" },
                styleFn: styleFn,
                renderFn: renderMode,
                classFn: classFn
              };
              canvasDrawing.push(canvasConnector);
            } else {
              renderedConnectorMarks.push(_react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, eventListeners, {
                renderMode: renderValue,
                markType: "path",
                d: markD,
                className: classFn ? classFn(piece.piece.data, pieceI) : "",
                key: "connector" + piece.piece.renderKey,
                style: calculatedStyle
              })));
            }
          }
        });
      }
    });
  } else if (type.type) {
    console.error("Invalid connectorType - Must be a function that takes a data point and determines if it is connected to a data point in the next column");
  }
  return renderedConnectorMarks;
}

var summaryRenderHash = {
  contour: _summaryLayouts.contourRenderFn,
  boxplot: _summaryLayouts.boxplotRenderFn,
  violin: _summaryLayouts.bucketizedRenderingFn,
  heatmap: _summaryLayouts.bucketizedRenderingFn,
  joy: _summaryLayouts.bucketizedRenderingFn,
  histogram: _summaryLayouts.bucketizedRenderingFn
};

function orFrameSummaryRenderer(_ref7) {
  var data = _ref7.data,
      type = _ref7.type,
      renderMode = _ref7.renderMode,
      eventListenersGenerator = _ref7.eventListenersGenerator,
      styleFn = _ref7.styleFn,
      classFn = _ref7.classFn,
      positionFn = _ref7.positionFn,
      projection = _ref7.projection,
      adjustedSize = _ref7.adjustedSize,
      chartSize = _ref7.chartSize,
      baseMarkProps = _ref7.baseMarkProps;

  var summaryRenderFn = void 0;
  if (typeof type.type === "function") {
    summaryRenderFn = type.type;
  } else if (summaryRenderHash[type.type]) {
    summaryRenderFn = summaryRenderHash[type.type];
  } else {
    console.error("Invalid summary type: " + type.type + " - Must be a function or one of the following strings: " + Object.keys(summaryRenderHash));
    return;
  }
  return summaryRenderFn({
    data: data,
    type: type,
    renderMode: renderMode,
    eventListenersGenerator: eventListenersGenerator,
    styleFn: styleFn,
    classFn: classFn,
    positionFn: positionFn,
    projection: projection,
    adjustedSize: adjustedSize,
    chartSize: chartSize,
    baseMarkProps: baseMarkProps
  });
}

var orFrameAxisGenerator = exports.orFrameAxisGenerator = function orFrameAxisGenerator(_ref8) {
  var projection = _ref8.projection,
      axis = _ref8.axis,
      adjustedSize = _ref8.adjustedSize,
      size = _ref8.size,
      rScale = _ref8.rScale,
      rScaleType = _ref8.rScaleType,
      pieceType = _ref8.pieceType,
      rExtent = _ref8.rExtent,
      data = _ref8.data;

  var generatedAxis = void 0,
      axesTickLines = void 0;
  if (projection !== "radial" && axis) {
    axesTickLines = [];
    var axisPosition = [0, 0];
    var axes = Array.isArray(axis) ? axis : [axis];
    var axisBaseline = false;
    generatedAxis = axes.map(function (d, i) {
      if (axisBaseline) {
        d.axis = d.axis || false;
      }
      axisBaseline = true;

      var axisClassname = d.className || "";
      var tickValues = void 0;
      var axisScale = rScaleType().domain(rScale.domain());

      var orient = trueAxis(d.orient, projection);

      if (orient === "right") {
        axisScale.range([rScale.range()[1], rScale.range()[0]]);
        axisClassname += " right y";
      } else if (orient === "left") {
        axisClassname += " left y";
        axisScale.range([rScale.range()[1], rScale.range()[0]]);
      } else if (orient === "top") {
        axisClassname += " top x";
        axisScale.range(rScale.range());
      } else if (orient === "bottom") {
        axisClassname += " bottom x";
        axisScale.range(rScale.range());
      }

      if (d.tickValues && Array.isArray(d.tickValues)) {
        tickValues = d.tickValues;
      } else if (d.tickValues) {
        //otherwise assume a function
        tickValues = d.tickValues(data, size, rScale);
      }

      var axisParts = (0, _axis.axisPieces)({
        padding: d.padding,
        tickValues: tickValues,
        scale: axisScale,
        ticks: d.ticks,
        orient: orient,
        size: adjustedSize,
        footer: d.footer,
        tickSize: d.tickSize
      });
      var axisTickLines = (0, _axis.axisLines)({
        axisParts: axisParts,
        orient: orient,
        tickLineGenerator: d.tickLineGenerator
      });
      axesTickLines.push(axisTickLines);

      return _react2.default.createElement(_Axis2.default, {
        label: d.label,
        axisParts: axisParts,
        key: d.key || "orframe-axis-" + i,
        orient: orient,
        size: adjustedSize,
        position: axisPosition,
        ticks: d.ticks,
        tickSize: d.tickSize,
        tickFormat: d.tickFormat,
        tickValues: tickValues,
        format: d.format,
        rotate: d.rotate,
        scale: axisScale,
        className: axisClassname,
        name: d.name,
        baseline: d.baseline
      });
    });
  } else if (projection === "radial" && axis) {
    var _pieceType$innerRadiu = pieceType.innerRadius,
        innerRadius = _pieceType$innerRadiu === undefined ? 0 : _pieceType$innerRadiu;
    var _axis$tickValues = axis.tickValues,
        tickValues = _axis$tickValues === undefined ? rScale.ticks(Math.max(2, (adjustedSize[0] / 2 - innerRadius) / 50)) : _axis$tickValues,
        label = axis.label,
        _axis$tickFormat = axis.tickFormat,
        tickFormat = _axis$tickFormat === undefined ? function (d) {
      return d;
    } : _axis$tickFormat;


    var tickScale = rScaleType().domain(rExtent).range([innerRadius, adjustedSize[0] / 2]);
    var ticks = tickValues.map(function (t, i) {
      var tickSize = tickScale(t);
      if (!(innerRadius === 0 && t === 0)) {
        var axisLabel = void 0;
        var ref = "";
        if (label && i === tickValues.length - 1) {
          var labelSettings = typeof label === "string" ? { name: label } : label;
          var _labelSettings$locati = labelSettings.locationDistance,
              locationDistance = _labelSettings$locati === undefined ? 15 : _labelSettings$locati;

          ref = Math.random().toString() + " ";
          axisLabel = _react2.default.createElement(
            "g",
            {
              className: "axis-label radial",
              transform: "translate(0," + locationDistance + ")"
            },
            _react2.default.createElement(
              "text",
              { textAnchor: "middle" },
              _react2.default.createElement(
                "textPath",
                {
                  startOffset: tickSize * Math.PI * 0.5,
                  xlinkHref: "#" + ref
                },
                label.name
              )
            )
          );
        }
        return _react2.default.createElement(
          "g",
          {
            key: "orframe-radial-axis-element-" + t,
            className: "axis axis-label axis-tick radial",
            transform: "translate(0,0)"
          },
          _react2.default.createElement("path", {
            id: ref,
            d: circlePath(0, 0, tickSize),
            r: tickSize,
            stroke: "gray",
            fill: "none"
          }),
          _react2.default.createElement(
            "text",
            { y: -tickSize + 5, textAnchor: "middle" },
            tickFormat(t)
          ),
          axisLabel
        );
      }
      return null;
    });
    generatedAxis = _react2.default.createElement(
      "g",
      {
        key: axis.key || "orframe-radial-axis-container",
        transform: "translate(" + adjustedSize[0] / 2 + "," + adjustedSize[1] / 2 + ")"
      },
      ticks
    );
  }
  return { axis: generatedAxis, axesTickLines: axesTickLines };
};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderLaidOutPieces = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.pointOnArcAtAngle = pointOnArcAtAngle;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semioticMark = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function pointOnArcAtAngle(center, angle, distance) {
  var radians = Math.PI * (angle + 0.75) * 2;

  var xPosition = center[0] + distance * Math.cos(radians);
  var yPosition = center[1] + distance * Math.sin(radians);

  return [xPosition, yPosition];
}

var renderLaidOutPieces = exports.renderLaidOutPieces = function renderLaidOutPieces(_ref) {
  var data = _ref.data,
      shouldRender = _ref.shouldRender,
      canvasRender = _ref.canvasRender,
      canvasDrawing = _ref.canvasDrawing,
      styleFn = _ref.styleFn,
      classFn = _ref.classFn,
      baseMarkProps = _ref.baseMarkProps,
      renderKeyFn = _ref.renderKeyFn;

  if (!shouldRender) return null;
  var renderedPieces = [];
  data.forEach(function (d, i) {
    if (canvasRender && canvasRender(d) === true) {
      var canvasPiece = {
        baseClass: "orframe-piece",
        tx: d.renderElement.tx || 0,
        ty: d.renderElement.ty || 0,
        d: d.piece,
        i: i,
        markProps: d.renderElement || d,
        styleFn: styleFn,
        classFn: classFn
      };
      canvasDrawing.push(canvasPiece);
    } else {
      if (_react2.default.isValidElement(d.renderElement || d)) {
        renderedPieces.push(d.renderElement || d);
      } else {
        renderedPieces.push(_react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          key: renderKeyFn ? renderKeyFn(d.piece) : d.renderKey || "piece-render-" + i
        }, d.renderElement || d)));
      }
    }
  });

  return renderedPieces;
};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateDataExtent = exports.stringToFn = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lineDrawing = __webpack_require__(126);

var _coordinateNames = __webpack_require__(475);

var _areaDrawing = __webpack_require__(244);

var _d3Array = __webpack_require__(12);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var builtInTransformations = {
  "stackedarea": _lineDrawing.stackedArea,
  "stackedarea-invert": _lineDrawing.stackedArea,
  "stackedpercent": _lineDrawing.stackedArea,
  "stackedpercent-invert": _lineDrawing.stackedArea,
  "linepercent": _lineDrawing.stackedArea,
  "difference": _lineDrawing.differenceLine,
  "bumparea": _lineDrawing.bumpChart,
  "bumpline": _lineDrawing.bumpChart,
  "bumparea-invert": _lineDrawing.bumpChart,
  "line": _lineDrawing.lineChart
};

var stringToFn = exports.stringToFn = function stringToFn(accessor, defaultAccessor, raw) {
  if (!accessor) {
    return defaultAccessor;
  } else if (typeof accessor !== "function" && raw) {
    return function () {
      return accessor;
    };
  }
  return typeof accessor !== "function" ? function (d) {
    return d[accessor];
  } : accessor;
};

var calculateDataExtent = exports.calculateDataExtent = function calculateDataExtent(_ref) {
  var lineDataAccessor = _ref.lineDataAccessor,
      xAccessor = _ref.xAccessor,
      yAccessor = _ref.yAccessor,
      areas = _ref.areas,
      points = _ref.points,
      lines = _ref.lines,
      lineType = _ref.lineType,
      showLinePoints = _ref.showLinePoints,
      xExtent = _ref.xExtent,
      yExtent = _ref.yExtent,
      invertX = _ref.invertX,
      invertY = _ref.invertY,
      areaDataAccessor = _ref.areaDataAccessor,
      projection = _ref.projection,
      areaType = _ref.areaType,
      _ref$defined = _ref.defined,
      defined = _ref$defined === undefined ? function () {
    return true;
  } : _ref$defined;

  lineDataAccessor = stringToFn(lineDataAccessor, function (d) {
    return d.coordinates;
  });
  xAccessor = stringToFn(xAccessor, function (d) {
    return d[0];
  });
  yAccessor = stringToFn(yAccessor, function (d) {
    return d[1];
  });
  areaDataAccessor = stringToFn(areaDataAccessor, function (d) {
    return d.coordinates;
  });

  var fullDataset = [];
  var initialProjectedLines = [];

  var projectedPoints = [],
      projectedLines = [],
      projectedAreas = [];
  if (points) {
    projectedPoints = points.map(function (d, i) {
      var _ref2;

      var x = xAccessor(d, i);
      var y = yAccessor(d, i);
      return _ref2 = {}, _defineProperty(_ref2, _coordinateNames.projectedX, x), _defineProperty(_ref2, _coordinateNames.projectedY, y), _defineProperty(_ref2, "data", d), _ref2;
    });
    fullDataset = projectedPoints;
  }
  if (lines) {
    initialProjectedLines = (0, _lineDrawing.projectLineData)({
      data: lines,
      lineDataAccessor: lineDataAccessor,
      xProp: _coordinateNames.projectedX,
      yProp: _coordinateNames.projectedY,
      yPropTop: _coordinateNames.projectedYTop,
      yPropBottom: _coordinateNames.projectedYBottom,
      xAccessor: xAccessor,
      yAccessor: yAccessor
    });

    var optionsObject = {
      xProp: _coordinateNames.projectedX,
      yProp: _coordinateNames.projectedY,
      yPropMiddle: _coordinateNames.projectedYMiddle,
      yPropTop: _coordinateNames.projectedYTop,
      yPropBottom: _coordinateNames.projectedYBottom
    };

    projectedLines = lineTransformation(lineType, optionsObject)(initialProjectedLines);

    projectedLines.forEach(function (d) {
      fullDataset = [].concat(_toConsumableArray(fullDataset), _toConsumableArray(d.data.filter(function (p, q) {
        return defined(_extends({}, p.data, p), q);
      }).map(function (p) {
        var _mappedP;

        var mappedP = (_mappedP = {
          parentLine: d
        }, _defineProperty(_mappedP, _coordinateNames.projectedY, p[_coordinateNames.projectedY]), _defineProperty(_mappedP, _coordinateNames.projectedX, p[_coordinateNames.projectedX]), _defineProperty(_mappedP, _coordinateNames.projectedYTop, p[_coordinateNames.projectedYTop]), _defineProperty(_mappedP, _coordinateNames.projectedYMiddle, p[_coordinateNames.projectedYMiddle]), _defineProperty(_mappedP, _coordinateNames.projectedYBottom, p[_coordinateNames.projectedYBottom]), _defineProperty(_mappedP, "data", p.data), _mappedP);
        if (p.percent) {
          mappedP.percent = p.percent;
        }
        return mappedP;
      })));
    });
  }

  if (areas) {
    projectedAreas = (0, _lineDrawing.projectAreaData)({
      data: areas,
      areaDataAccessor: areaDataAccessor,
      projection: projection,
      xProp: _coordinateNames.projectedX,
      yProp: _coordinateNames.projectedY,
      yPropTop: _coordinateNames.projectedYTop,
      yPropBottom: _coordinateNames.projectedYBottom,
      xAccessor: xAccessor,
      yAccessor: yAccessor
    });
    projectedAreas.forEach(function (d) {
      var baseData = areaDataAccessor(d);
      if (d._xyfCoordinates[0][0][0]) {
        d._xyfCoordinates[0].forEach(function (multi) {
          fullDataset = [].concat(_toConsumableArray(fullDataset), _toConsumableArray(multi.map(function (p, q) {
            var _extends2;

            return _extends({ parentArea: d }, baseData[q], (_extends2 = {}, _defineProperty(_extends2, _coordinateNames.projectedX, p[0]), _defineProperty(_extends2, _coordinateNames.projectedY, p[1]), _extends2));
          })));
        });
      } else {
        fullDataset = [].concat(_toConsumableArray(fullDataset), _toConsumableArray(d._xyfCoordinates.map(function (p, q) {
          var _extends3;

          return _extends({ parentArea: d }, baseData[q], (_extends3 = {}, _defineProperty(_extends3, _coordinateNames.projectedX, p[0]), _defineProperty(_extends3, _coordinateNames.projectedY, p[1]), _extends3));
        })));
      }
    });
  }

  //Handle 'expose points on lines' option now that sending points and lines simultaneously is no longer allowed
  if (showLinePoints) {
    projectedPoints = fullDataset;
  }

  var calculatedXExtent = (0, _d3Array.extent)(fullDataset.map(function (d) {
    return d[_coordinateNames.projectedX];
  }));
  var calculatedYExtent = [(0, _d3Array.min)(fullDataset.map(function (d) {
    return d[_coordinateNames.projectedYBottom] === undefined ? d[_coordinateNames.projectedY] : Math.min(d[_coordinateNames.projectedYTop], d[_coordinateNames.projectedYBottom]);
  })), (0, _d3Array.max)(fullDataset.map(function (d) {
    return d[_coordinateNames.projectedYTop] === undefined ? d[_coordinateNames.projectedY] : Math.max(d[_coordinateNames.projectedYBottom], d[_coordinateNames.projectedYTop]);
  }))];

  var xMin = xExtent && xExtent[0] !== undefined ? xExtent[0] : calculatedXExtent[0];
  var xMax = xExtent && xExtent[1] !== undefined ? xExtent[1] : calculatedXExtent[1];

  var yMin = yExtent && yExtent[0] !== undefined ? yExtent[0] : calculatedYExtent[0];
  var yMax = yExtent && yExtent[1] !== undefined ? yExtent[1] : calculatedYExtent[1];

  var finalYExtent = [yMin, yMax];
  var finalXExtent = [xMin, xMax];

  if (invertX) {
    finalXExtent = [finalXExtent[1], finalXExtent[0]];
  }
  if (invertY) {
    finalYExtent = [finalYExtent[1], finalYExtent[0]];
  }

  if (areaType && (areaType === "contour" || areaType.type && areaType.type === "contour")) {
    projectedAreas = (0, _areaDrawing.contouring)({
      areaType: areaType,
      data: projectedAreas,
      projectedX: _coordinateNames.projectedX,
      projectedY: _coordinateNames.projectedY,
      finalXExtent: finalXExtent,
      finalYExtent: finalYExtent
    });
  } else if (typeof areaType === "function" || areaType && areaType.type && typeof areaType.type === "function") {
    var areaFunction = areaType.type || areaType;

    projectedAreas = areaFunction({
      xExtent: finalXExtent,
      yExtent: finalYExtent,
      projectedX: _coordinateNames.projectedX,
      projectedY: _coordinateNames.projectedY,
      fullDataset: fullDataset,
      projectedAreas: projectedAreas
    });
  }

  return {
    xExtent: finalXExtent,
    yExtent: finalYExtent,
    projectedLines: projectedLines,
    projectedPoints: projectedPoints,
    projectedAreas: projectedAreas,
    fullDataset: fullDataset,
    calculatedXExtent: calculatedXExtent,
    calculatedYExtent: calculatedYExtent
  };
};

function lineTransformation() {
  var lineType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { type: "line" };
  var options = arguments[1];

  var differenceCatch = function differenceCatch(olineType, data) {
    return (lineType === "difference" || lineType.type && lineType.type === "difference") && data.length !== 2 ? "line" : olineType;
  };
  if (builtInTransformations[lineType]) {
    return function (data) {
      return builtInTransformations[differenceCatch(lineType, data)](_extends({
        type: lineType
      }, options, {
        data: data
      }));
    };
  }

  if (builtInTransformations[lineType.type]) {
    return function (data) {
      return builtInTransformations[differenceCatch(lineType.type, data)](_extends({}, lineType, options, {
        data: data
      }));
    };
  }

  //otherwise assume a function
  return function (data) {
    return lineType(_extends({}, options, { data: data }));
  };
}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Collection = __webpack_require__(134);

var _d3Scale = __webpack_require__(92);

var _d3Array = __webpack_require__(12);

var _d3Shape = __webpack_require__(30);

var _jsx = __webpack_require__(246);

var _frame_props = __webpack_require__(247);

var _orframeRules = __webpack_require__(1249);

var _Frame = __webpack_require__(228);

var _Frame2 = _interopRequireDefault(_Frame);

var _semioticMark = __webpack_require__(15);

var _DownloadButton = __webpack_require__(227);

var _DownloadButton2 = _interopRequireDefault(_DownloadButton);

var _downloadDataMapping = __webpack_require__(245);

var _frameFunctions = __webpack_require__(141);

var _pieceDrawing = __webpack_require__(142);

var _pieceLayouts = __webpack_require__(1250);

var _summaryLayouts = __webpack_require__(474);

var _dataFunctions = __webpack_require__(143);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var xScale = (0, _d3Scale.scaleIdentity)();
var yScale = (0, _d3Scale.scaleIdentity)();

var midMod = function midMod(d) {
  return d.middle ? d.middle : 0;
};
var zeroFunction = function zeroFunction() {
  return 0;
};
var twoPI = Math.PI * 2;

var projectedCoordinatesObject = { y: "y", x: "x" };

var defaultOverflow = { top: 0, bottom: 0, left: 0, right: 0 };

var layoutHash = {
  clusterbar: _pieceLayouts.clusterBarLayout,
  bar: _pieceLayouts.barLayout,
  point: _pieceLayouts.pointLayout,
  swarm: _pieceLayouts.swarmLayout,
  timeline: _pieceLayouts.timelineLayout
};

var OrdinalFrame = (_temp = _class = function (_React$Component) {
  _inherits(OrdinalFrame, _React$Component);

  function OrdinalFrame(props) {
    _classCallCheck(this, OrdinalFrame);

    var _this = _possibleConstructorReturn(this, (OrdinalFrame.__proto__ || Object.getPrototypeOf(OrdinalFrame)).call(this, props));

    _this.calculateOrdinalFrame = _this.calculateOrdinalFrame.bind(_this);
    _this.defaultORHTMLRule = _this.defaultORHTMLRule.bind(_this);
    _this.defaultORSVGRule = _this.defaultORSVGRule.bind(_this);

    _this.renderBody = _this.renderBody.bind(_this);

    _this.state = {
      adjustedPosition: null,
      adjustedSize: null,
      backgroundGraphics: null,
      foregroundGraphics: null,
      axisData: null,
      axis: null,
      renderNumber: 0,
      oLabels: []
    };

    _this.oAccessor = null;
    _this.rAccessor = null;
    _this.oScale = null;
    _this.rScale = null;
    return _this;
  }

  _createClass(OrdinalFrame, [{
    key: "calculateOrdinalFrame",
    value: function calculateOrdinalFrame(currentProps) {
      var oLabels = void 0;
      var projectedColumns = {};

      var padding = currentProps.oPadding ? currentProps.oPadding : 0;

      var summaryType = (0, _frameFunctions.objectifyType)(currentProps.summaryType);
      var pieceType = (0, _frameFunctions.objectifyType)(currentProps.type);
      var connectorType = (0, _frameFunctions.objectifyType)(currentProps.connectorType);

      var projection = currentProps.projection,
          customHoverBehavior = currentProps.customHoverBehavior,
          customClickBehavior = currentProps.customClickBehavior,
          size = currentProps.size,
          pixelColumnWidth = currentProps.pixelColumnWidth;

      var eventListenersGenerator = (0, _frameFunctions.generateOrdinalFrameEventListeners)(customHoverBehavior, customClickBehavior);

      var oAccessor = (0, _dataFunctions.stringToFn)(currentProps.oAccessor, function (d) {
        return d.renderKey;
      });
      var rAccessor = (0, _dataFunctions.stringToFn)(currentProps.rAccessor, function (d) {
        return d.value || 1;
      });

      var connectorStyle = (0, _dataFunctions.stringToFn)(currentProps.connectorStyle, function () {
        return {};
      }, true);
      var summaryStyle = (0, _dataFunctions.stringToFn)(currentProps.summaryStyle, function () {
        return {};
      }, true);
      var pieceStyle = (0, _dataFunctions.stringToFn)(currentProps.style, function () {
        return {};
      }, true);
      var pieceClass = (0, _dataFunctions.stringToFn)(currentProps.pieceClass, function () {
        return "";
      }, true);
      var summaryClass = (0, _dataFunctions.stringToFn)(currentProps.summaryClass, function () {
        return "";
      }, true);
      var summaryPosition = currentProps.summaryPosition || function (position) {
        return position;
      };

      var barData = (0, _frameFunctions.keyAndObjectifyBarData)(currentProps);

      var allData = barData.map(function (d) {
        return d.data;
      });

      //      const dataAccessor = currentProps.dataAccessor || function (d) {return d}
      var margin = (0, _frameFunctions.calculateMargin)(currentProps);

      var _adjustedPositionSize = (0, _frameFunctions.adjustedPositionSize)(currentProps),
          adjustedPosition = _adjustedPositionSize.adjustedPosition,
          adjustedSize = _adjustedPositionSize.adjustedSize;

      var title = (0, _frameFunctions.generateFrameTitle)(currentProps);

      var baseOExtent = currentProps.oExtent;
      var oExtentSettings = baseOExtent === undefined || Array.isArray(baseOExtent) ? { extent: baseOExtent } : baseOExtent;

      var calculatedOExtent = [].concat(_toConsumableArray(new Set(allData.map(function (d, i) {
        return oAccessor(d, i);
      }))));

      var oExtent = oExtentSettings.extent || calculatedOExtent;

      if (pixelColumnWidth) {
        if (projection === "radial") {
          console.error("pixelColumnWidth is not honored in radial mode");
        } else if (projection === "vertical") {
          var sizeOffset = size[0] - adjustedSize[0];
          adjustedSize[0] = oExtent.length * pixelColumnWidth;
          size[0] = adjustedSize[0] + sizeOffset;
        } else {
          var _sizeOffset = size[1] - adjustedSize[1];
          adjustedSize[1] = oExtent.length * pixelColumnWidth;
          size[1] = adjustedSize[1] + _sizeOffset;
        }
      }

      var baseRExtent = currentProps.rExtent;
      var rExtentSettings = baseRExtent === undefined || Array.isArray(baseRExtent) ? { extent: baseRExtent } : baseRExtent;

      var rExtent = rExtentSettings.extent;
      var subZeroRExtent = [0, 0];

      if (pieceType.type === "bar" && summaryType.type && summaryType.type !== "none") {
        pieceType.type = undefined;
      }

      if (pieceType.type === "timeline") {
        var rData = allData.map(rAccessor);
        var leftExtent = (0, _d3Array.extent)(rData.map(function (d) {
          return d[0];
        }));
        var rightExtent = (0, _d3Array.extent)(rData.map(function (d) {
          return d[1];
        }));
        rExtent = (0, _d3Array.extent)([].concat(_toConsumableArray(leftExtent), _toConsumableArray(rightExtent)));
      } else if (pieceType.type !== "bar") {
        rExtent = (0, _d3Array.extent)(allData, rAccessor);
      } else {
        var positiveData = allData.filter(function (d) {
          return rAccessor(d) >= 0;
        });
        var negativeData = allData.filter(function (d) {
          return rAccessor(d) <= 0;
        });

        var nestedPositiveData = (0, _d3Collection.nest)().key(oAccessor).rollup(function (leaves) {
          return (0, _d3Array.sum)(leaves.map(rAccessor));
        }).entries(positiveData);

        var nestedNegativeData = (0, _d3Collection.nest)().key(oAccessor).rollup(function (leaves) {
          return (0, _d3Array.sum)(leaves.map(rAccessor));
        }).entries(negativeData);

        rExtent = [0, nestedPositiveData.length === 0 ? 0 : Math.max((0, _d3Array.max)(nestedPositiveData, function (d) {
          return d.value;
        }), 0)];

        subZeroRExtent = [0, nestedNegativeData.length === 0 ? 0 : Math.min((0, _d3Array.min)(nestedNegativeData, function (d) {
          return d.value;
        }), 0)];
        rExtent = [subZeroRExtent[1], rExtent[1]];
      }

      if (pieceType.type === "clusterbar") {
        rExtent[0] = 0;
      }

      var calculatedRExtent = rExtent;

      if (rExtentSettings.extent && rExtentSettings.extent[0] !== undefined && rExtentSettings.extent[1] !== undefined) {
        rExtent = rExtentSettings.extent;
      } else {
        if (rExtentSettings.extent && rExtentSettings.extent[1] !== undefined && rExtentSettings.extent[0] === undefined) {
          rExtent[1] = rExtentSettings.extent[1];
        }

        if (rExtentSettings.extent && rExtentSettings.extent[0] !== undefined && rExtentSettings.extent[1] === undefined) {
          rExtent[0] = rExtentSettings.extent[0];
        }
      }

      if (currentProps.sortO) {
        oExtent = oExtent.sort(currentProps.sortO);
      }
      if (currentProps.invertR || rExtentSettings.extent && rExtentSettings.extent[0] > rExtentSettings.extent[1]) {
        rExtent = [rExtent[1], rExtent[0]];
      }

      var rDomain = [0, adjustedSize[0]];
      var oDomain = [0, adjustedSize[1]];

      if (projection === "vertical") {
        oDomain = [0, adjustedSize[0]];
        rDomain = [0, adjustedSize[1]];
      }

      var oScaleType = currentProps.oScaleType || _d3Scale.scaleBand;
      var rScaleType = currentProps.rScaleType || _d3Scale.scaleLinear;

      var cwHash = void 0;

      var oScale = void 0;

      if (currentProps.dynamicColumnWidth) {
        var columnValueCreator = void 0;
        if (typeof currentProps.dynamicColumnWidth === "string") {
          columnValueCreator = function columnValueCreator(d) {
            return (0, _d3Array.sum)(d.map(function (p) {
              return p.data[currentProps.dynamicColumnWidth];
            }));
          };
        } else {
          columnValueCreator = function columnValueCreator(d) {
            return currentProps.dynamicColumnWidth(d.map(function (p) {
              return p.data;
            }));
          };
        }
        var thresholdDomain = [0];
        var maxColumnValues = 0;
        var columnValues = [];

        oExtent.forEach(function (d) {
          var oValues = barData.filter(function (p, q) {
            return oAccessor(p.data, q) === d;
          });
          var columnValue = columnValueCreator(oValues);

          columnValues.push(columnValue);
          maxColumnValues += columnValue;
        });

        cwHash = { total: 0 };
        oExtent.forEach(function (d, i) {
          var oValue = columnValues[i];
          var stepValue = oValue / maxColumnValues * (oDomain[1] - oDomain[0]);
          cwHash[d] = stepValue;
          cwHash.total += stepValue;
          if (i !== oExtent.length - 1) {
            thresholdDomain.push(stepValue + thresholdDomain[i]);
          }
        });

        oScale = (0, _d3Scale.scaleOrdinal)().domain(oExtent).range(thresholdDomain);
      } else {
        oScale = oScaleType().domain(oExtent).range(oDomain);
      }

      var rScale = rScaleType().domain(rExtent).range(rDomain);

      var rScaleReverse = rScaleType().domain(rDomain).range(rDomain.reverse());

      var rScaleVertical = rScaleType().domain(rExtent).range(rDomain);

      this.oScale = oScale;
      this.rScale = rScale;

      this.oAccessor = oAccessor;
      this.rAccessor = rAccessor;

      var columnWidth = cwHash ? 0 : oScale.bandwidth();

      var pieceData = [];

      var mappedMiddleSize = adjustedSize[1];
      if (projection === "vertical") {
        mappedMiddleSize = adjustedSize[0];
      }
      var mappedMiddles = this.mappedMiddles(oScale, mappedMiddleSize, padding);

      var nestedPieces = {};
      (0, _d3Collection.nest)().key(function (d, i) {
        return oAccessor(d.data, i);
      }).entries(barData).forEach(function (d) {
        nestedPieces[d.key] = d.values;
      });
      pieceData = oExtent.map(function (d) {
        return nestedPieces[d] ? nestedPieces[d] : [];
      });

      var zeroValue = projection === "vertical" ? rScaleReverse(rScale(0)) : rScale(0);

      oExtent.forEach(function (o, i) {
        projectedColumns[o] = { name: o, padding: padding, pieceData: pieceData[i] };
        projectedColumns[o].x = oScale(o) + padding / 2;
        projectedColumns[o].y = 0;
        projectedColumns[o].middle = mappedMiddles[o] + padding / 2;

        var negativeOffset = zeroValue;
        var positiveOffset = zeroValue;

        projectedColumns[o].pieceData.forEach(function (piece) {
          var valPosition = void 0;
          piece.value = rAccessor(piece.data);

          if (pieceType.type === "timeline") {
            piece.scaledValue = rScale(piece.value[0]);
            piece.scaledEndValue = rScale(piece.value[1]);
            piece.scaledVerticalValue = rScaleVertical(piece.value[0]);
            piece.scaledZeroOffset = rScaleVertical(0) - piece.scaledVerticalValue;
          } else if (pieceType.type !== "bar" && pieceType.type !== "clusterbar") {
            piece.scaledValue = rScale(piece.value);
            piece.scaledVerticalValue = rScaleVertical(piece.value);
            piece.scaledZeroOffset = piece.scaledValue - zeroValue;
          } else {
            valPosition = projection === "vertical" ? rScaleReverse(rScale(piece.value)) : rScale(piece.value);
            piece.scaledValue = Math.abs(zeroValue - valPosition);
            piece.scaledZeroOffset = valPosition - zeroValue;
          }

          piece.x = projectedColumns[o].x;
          if (piece.value >= 0) {
            piece.base = zeroValue;
            piece.bottom = positiveOffset;
            piece.middle = piece.scaledValue / 2 + positiveOffset;
            positiveOffset = projection === "vertical" ? positiveOffset - piece.scaledValue : positiveOffset + piece.scaledValue;
            piece.negative = false;
          } else {
            piece.base = zeroValue;
            piece.bottom = negativeOffset;
            piece.middle = positiveOffset - piece.scaledValue / 2;
            negativeOffset = projection === "vertical" ? negativeOffset + piece.scaledValue : negativeOffset - piece.scaledValue;
            piece.negative = true;
          }
        });

        if (cwHash) {
          projectedColumns[o].width = cwHash[o] - padding;

          if (currentProps.ordinalAlign === "center") {
            projectedColumns[o].x = projectedColumns[o].x - projectedColumns[o].width / 2;
            projectedColumns[o].middle = projectedColumns[o].middle - projectedColumns[o].width / 2;
          }
          projectedColumns[o].pct = cwHash[o] / cwHash.total;
          projectedColumns[o].pct_start = (projectedColumns[o].x - oDomain[0]) / cwHash.total;
          projectedColumns[o].pct_padding = padding / cwHash.total;
          projectedColumns[o].pct_middle = (projectedColumns[o].middle - oDomain[0]) / cwHash.total;
        } else {
          projectedColumns[o].width = columnWidth - padding;
          if (currentProps.ordinalAlign === "center") {
            projectedColumns[o].x = projectedColumns[o].x - projectedColumns[o].width / 2;
            projectedColumns[o].middle = projectedColumns[o].middle - projectedColumns[o].width / 2;
          }

          projectedColumns[o].pct = columnWidth / adjustedSize[1];
          projectedColumns[o].pct_start = (projectedColumns[o].x - oDomain[0]) / adjustedSize[1];
          projectedColumns[o].pct_padding = padding / adjustedSize[1];
          projectedColumns[o].pct_middle = (projectedColumns[o].middle - oDomain[0]) / adjustedSize[1];
        }
      });

      var labelArray = [];

      var pieArcs = [];

      if (currentProps.oLabel || currentProps.hoverAnnotation) {
        oExtent.forEach(function (d, i) {
          var arcGenerator = (0, _d3Shape.arc)().innerRadius(0).outerRadius(rScale.range()[1] / 2);
          var angle = 1 / oExtent.length;
          var startAngle = angle * i;
          angle = projectedColumns[d].pct;
          startAngle = projectedColumns[d].pct_start;

          var endAngle = startAngle + angle;
          var midAngle = startAngle + angle / 2;

          var markD = arcGenerator({
            startAngle: startAngle * twoPI,
            endAngle: endAngle * twoPI
          });
          var translate = [adjustedSize[0] / 2, adjustedSize[1] / 2];
          var centroid = arcGenerator.centroid({
            startAngle: startAngle * twoPI,
            endAngle: endAngle * twoPI
          });
          pieArcs.push({
            startAngle: startAngle,
            endAngle: endAngle,
            midAngle: midAngle,
            markD: markD,
            translate: translate,
            centroid: centroid
          });
        });
      }

      var labelSettings = _typeof(currentProps.oLabel) === "object" ? _extends({ label: true }, currentProps.oLabel) : { orient: "default", label: currentProps.oLabel };

      if (currentProps.oLabel) {
        var labelingFn = void 0;
        if (labelSettings.label === true) {
          labelingFn = function labelingFn(d) {
            return _react2.default.createElement(
              "text",
              {
                style: {
                  textAnchor: projection === "horizontal" && labelSettings.orient === "right" ? "start" : projection === "horizontal" ? "end" : "middle"
                }
              },
              d
            );
          };
        } else if (typeof labelSettings.label === "function") {
          labelingFn = labelSettings.label;
        }

        oExtent.forEach(function (d, i) {
          var xPosition = projectedColumns[d].middle;
          var yPosition = 0;

          if (projection === "horizontal") {
            yPosition = projectedColumns[d].middle;
            if (labelSettings.orient === "right") {
              xPosition = adjustedSize[0] + 3;
            } else {
              xPosition = -3;
            }
          } else if (projection === "radial") {
            xPosition = pieArcs[i].centroid[0] + pieArcs[i].translate[0];
            yPosition = pieArcs[i].centroid[1] + pieArcs[i].translate[1];
          }
          var label = labelingFn(d, currentProps.data ? currentProps.data.filter(function (p, q) {
            return oAccessor(p, q) === d;
          }) : undefined, i);
          labelArray.push(_react2.default.createElement(
            "g",
            {
              key: "olabel-" + i,
              transform: "translate(" + xPosition + "," + yPosition + ")"
            },
            label
          ));
        });

        if (projection === "vertical") {
          var labelY = void 0;
          if (labelSettings.orient === "top") {
            labelY = -15;
          } else {
            labelY = 15 + rScale.range()[1];
          }
          oLabels = _react2.default.createElement(
            "g",
            {
              key: "ordinalframe-labels-container",
              transform: "translate(" + margin.left + "," + (labelY + margin.top) + ")"
            },
            labelArray
          );
        } else if (projection === "horizontal") {
          oLabels = _react2.default.createElement(
            "g",
            {
              key: "ordinalframe-labels-container",
              transform: "translate(" + margin.left + "," + margin.top + ")"
            },
            labelArray
          );
        } else if (projection === "radial") {
          oLabels = _react2.default.createElement(
            "g",
            {
              key: "ordinalframe-labels-container",
              transform: "translate(" + margin.left + "," + margin.top + ")"
            },
            labelArray
          );
        }
      }

      var columnOverlays = void 0;

      if (currentProps.hoverAnnotation) {
        columnOverlays = oExtent.map(function (d, i) {
          var barColumnWidth = projectedColumns[d].width;
          var xPosition = projectedColumns[d].x;
          var yPosition = 0;
          var height = rScale.range()[1];
          var width = barColumnWidth + padding;
          if (projection === "horizontal") {
            yPosition = projectedColumns[d].x;
            xPosition = 0;
            width = rScale.range()[1];
            height = barColumnWidth;
          }

          if (projection === "radial") {
            var _pieArcs$i = pieArcs[i],
                markD = _pieArcs$i.markD,
                centroid = _pieArcs$i.centroid,
                translate = _pieArcs$i.translate,
                midAngle = _pieArcs$i.midAngle;

            return {
              markType: "path",
              key: "hover" + d,
              d: markD,
              transform: "translate(" + translate + ")",
              style: { opacity: 0, fill: "pink" },
              onClick: function onClick() {
                return {
                  type: "column-hover",
                  pieces: projectedColumns[d].pieceData,
                  summary: projectedColumns[d].pieceData,
                  arcAngles: {
                    centroid: centroid,
                    translate: translate,
                    midAngle: midAngle,
                    length: rScale.range()[1] / 2
                  }
                };
              },
              onMouseEnter: function onMouseEnter() {
                return {
                  type: "column-hover",
                  pieces: projectedColumns[d].pieceData,
                  summary: projectedColumns[d].pieceData,
                  arcAngles: {
                    centroid: centroid,
                    translate: translate,
                    midAngle: midAngle,
                    length: rScale.range()[1] / 2
                  }
                };
              },
              onMouseLeave: function onMouseLeave() {
                return {};
              }
            };
          }

          return {
            markType: "rect",
            key: "hover-" + d,
            x: xPosition,
            y: yPosition,
            height: height,
            width: width,
            style: { opacity: 0, stroke: "black", fill: "pink" },
            onClick: function onClick() {
              return {
                type: "column-hover",
                pieces: projectedColumns[d].pieceData,
                summary: projectedColumns[d].pieceData
              };
            },
            onMouseEnter: function onMouseEnter() {
              return {
                type: "column-hover",
                pieces: projectedColumns[d].pieceData,
                summary: projectedColumns[d].pieceData
              };
            },
            onMouseLeave: function onMouseLeave() {
              return {};
            }
          };
        });
      }

      var _orFrameAxisGenerator = (0, _frameFunctions.orFrameAxisGenerator)({
        axis: currentProps.axis,
        data: currentProps.data,
        projection: projection,
        adjustedSize: adjustedSize,
        size: size,
        rScale: rScale,
        rScaleType: rScaleType,
        pieceType: pieceType,
        rExtent: rExtent
      }),
          axis = _orFrameAxisGenerator.axis,
          axesTickLines = _orFrameAxisGenerator.axesTickLines;

      var renderMode = currentProps.renderMode,
          canvasSummaries = currentProps.canvasSummaries,
          summaryRenderMode = currentProps.summaryRenderMode,
          connectorClass = currentProps.connectorClass,
          connectorRenderMode = currentProps.connectorRenderMode,
          canvasConnectors = currentProps.canvasConnectors,
          canvasPieces = currentProps.canvasPieces;


      var pieceDataXY = void 0;
      var pieceRenderMode = (0, _dataFunctions.stringToFn)(renderMode, undefined, true);
      var pieceCanvasRender = (0, _dataFunctions.stringToFn)(canvasPieces, undefined, true);
      var summaryCanvasRender = (0, _dataFunctions.stringToFn)(canvasPieces, undefined, true);
      var connectorCanvasRender = (0, _dataFunctions.stringToFn)(canvasConnectors, undefined, true);

      var pieceTypeForXY = pieceType.type && pieceType.type !== "none" ? pieceType.type : "point";
      var pieceTypeLayout = typeof pieceTypeForXY === "function" ? pieceTypeForXY : layoutHash[pieceTypeForXY];
      var calculatedPieceData = pieceTypeLayout({
        type: pieceType,
        data: projectedColumns,
        renderMode: pieceRenderMode,
        eventListenersGenerator: eventListenersGenerator,
        styleFn: pieceStyle,
        projection: projection,
        classFn: pieceClass,
        adjustedSize: adjustedSize,
        rScale: rScale
      });

      var keyedData = calculatedPieceData.reduce(function (p, c) {
        if (!p[c.o]) {
          p[c.o] = [];
        }
        p[c.o].push(c);
        return p;
      }, {});

      Object.keys(projectedColumns).forEach(function (d) {
        projectedColumns[d].xyData = keyedData[d] || [];
      });
      var calculatedSummaries = {};

      if (summaryType.type) {
        calculatedSummaries = (0, _summaryLayouts.drawSummaries)({
          data: projectedColumns,
          type: summaryType,
          renderMode: (0, _dataFunctions.stringToFn)(summaryRenderMode, undefined, true),
          styleFn: (0, _dataFunctions.stringToFn)(summaryStyle, function () {
            return {};
          }, true),
          classFn: (0, _dataFunctions.stringToFn)(summaryClass, function () {
            return "";
          }, true),
          canvasRender: (0, _dataFunctions.stringToFn)(canvasSummaries, undefined, true),
          positionFn: summaryPosition,
          projection: projection,
          eventListenersGenerator: eventListenersGenerator,
          adjustedSize: adjustedSize,
          baseMarkProps: currentProps.baseMarkProps || {}
        });
      }

      if (currentProps.pieceHoverAnnotation || currentProps.summaryHoverAnnotation) {
        var yMod = projection === "horizontal" ? midMod : zeroFunction;
        var xMod = projection === "vertical" ? midMod : zeroFunction;

        if (currentProps.summaryHoverAnnotation && calculatedSummaries.xyPoints) {
          pieceDataXY = calculatedSummaries.xyPoints.map(function (d) {
            return _extends({}, d, {
              type: "frame-hover",
              isSummaryData: true,
              x: d.x,
              y: d.y
            });
          });
        } else if (currentProps.pieceHoverAnnotation && calculatedPieceData) {
          pieceDataXY = calculatedPieceData.map(function (d) {
            return _extends({}, d.piece, {
              type: "frame-hover",
              x: d.xy.x + xMod(d.xy),
              y: d.xy.y + yMod(d.xy)
            });
          });
        }
      }

      var orFrameRender = {
        connectors: {
          projection: projection,
          data: keyedData,
          styleFn: (0, _dataFunctions.stringToFn)(connectorStyle, function () {
            return {};
          }, true),
          classFn: (0, _dataFunctions.stringToFn)(connectorClass, function () {
            return "";
          }, true),
          renderMode: (0, _dataFunctions.stringToFn)(connectorRenderMode, undefined, true),
          canvasRender: connectorCanvasRender,
          behavior: _frameFunctions.orFrameConnectionRenderer,
          type: connectorType,
          eventListenersGenerator: eventListenersGenerator
        },
        summaries: {
          data: calculatedSummaries.marks,
          behavior: _summaryLayouts.renderLaidOutSummaries,
          canvasRender: summaryCanvasRender,
          styleFn: (0, _dataFunctions.stringToFn)(summaryStyle, function () {
            return {};
          }, true),
          classFn: (0, _dataFunctions.stringToFn)(summaryClass, function () {
            return "";
          }, true)
        },
        pieces: {
          shouldRender: pieceType.type && pieceType.type !== "none",
          data: calculatedPieceData,
          behavior: _pieceDrawing.renderLaidOutPieces,
          canvasRender: pieceCanvasRender,
          styleFn: (0, _dataFunctions.stringToFn)(pieceStyle, function () {
            return {};
          }, true),
          classFn: (0, _dataFunctions.stringToFn)(pieceClass, function () {
            return "";
          }, true)
        }
      };

      if (rExtentSettings.onChange && (this.state.calculatedRExtent || []).join(",") !== (calculatedRExtent || []).join(",")) {
        rExtentSettings.onChange(calculatedRExtent);
      }

      if (oExtentSettings.onChange && (this.state.calculatedOExtent || []).join(",") !== (calculatedOExtent || []).join(",")) {
        oExtentSettings.onChange(calculatedOExtent);
      }

      this.setState({
        pieceDataXY: pieceDataXY,
        adjustedPosition: adjustedPosition,
        adjustedSize: adjustedSize,
        backgroundGraphics: currentProps.backgroundGraphics,
        foregroundGraphics: currentProps.foregroundGraphics,
        axisData: currentProps.axis,
        axes: _react2.default.createElement(
          "g",
          { key: "ordinalframe-axis", className: "axis-labels" },
          axis
        ),
        axesTickLines: axesTickLines,
        oLabels: oLabels,
        title: title,
        columnOverlays: columnOverlays,
        renderNumber: this.state.renderNumber + 1,
        oAccessor: currentProps.oAccessor,
        rAccessor: currentProps.rAccessor,
        oScaleType: currentProps.oScaleType,
        rScaleType: currentProps.rScaleType,
        oExtent: oExtent,
        rExtent: rExtent,
        calculatedOExtent: calculatedOExtent,
        calculatedRExtent: calculatedRExtent,
        projectedColumns: projectedColumns,
        margin: margin,
        legendSettings: currentProps.legend,
        eventListenersGenerator: eventListenersGenerator,
        orFrameRender: orFrameRender
      });
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      this.calculateOrdinalFrame(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.state.dataVersion && this.state.dataVersion !== nextProps.dataVersion || !this.state.projectedColumns) {
        this.calculateOrdinalFrame(nextProps);
      } else if (this.props.size[0] !== nextProps.size[0] || this.props.size[1] !== nextProps.size[1] || !this.state.dataVersion && _frame_props.orFrameChangeProps.find(function (d) {
        return _this2.props[d] !== nextProps[d];
      })) {
        this.calculateOrdinalFrame(nextProps);
      }
    }
  }, {
    key: "clonedAppliedElement",
    value: function clonedAppliedElement(_ref) {
      var tx = _ref.tx,
          ty = _ref.ty,
          d = _ref.d,
          i = _ref.i,
          markProps = _ref.markProps,
          styleFn = _ref.styleFn,
          renderFn = _ref.renderFn,
          classFn = _ref.classFn,
          baseClass = _ref.baseClass;

      markProps.style = styleFn ? styleFn(d, i) : {};
      markProps.renderMode = renderFn ? renderFn(d, i) : undefined;

      if (tx || ty) {
        markProps.transform = "translate(" + (tx || 0) + "," + (ty || 0) + ")";
      }

      markProps.className = baseClass;

      markProps.key = baseClass + "-" + i;

      if (classFn) {
        markProps.className = baseClass + " " + classFn(d, i);
      }

      return _react2.default.createElement(_semioticMark.Mark, markProps);
    }
  }, {
    key: "defaultORSVGRule",
    value: function defaultORSVGRule(_ref2) {
      var d = _ref2.d,
          i = _ref2.i,
          annotationLayer = _ref2.annotationLayer;

      var oAccessor = this.oAccessor;
      var rAccessor = this.rAccessor;
      var oScale = this.oScale;
      var rScale = this.rScale;

      var projection = this.props.projection;
      var projectedColumns = this.state.projectedColumns;


      var pieceIDAccessor = (0, _dataFunctions.stringToFn)(this.props.pieceIDAccessor, function (p) {
        return p.semioticPieceID;
      });

      var _adjustedPositionSize2 = (0, _frameFunctions.adjustedPositionSize)(this.props),
          adjustedPosition = _adjustedPositionSize2.adjustedPosition,
          adjustedSize = _adjustedPositionSize2.adjustedSize;

      var screenProject = function screenProject(p) {
        var oColumn = projectedColumns[oAccessor(p)];
        var o = void 0;
        if (oColumn) {
          o = oColumn.middle;
        } else {
          o = 0;
        }
        var idPiece = pieceIDAccessor(d) && oColumn.pieceData.find(function (r) {
          return pieceIDAccessor(r.data) === pieceIDAccessor(d);
        });

        if (oColumn && projection === "radial") {
          return (0, _pieceDrawing.pointOnArcAtAngle)([adjustedSize[0] / 2, adjustedSize[1] / 2], oColumn.pct_middle, idPiece ? (idPiece.bottom + idPiece.scaledValue / 2) / 2 : rScale(rAccessor(p)) / 2);
        }
        if (projection === "horizontal") {
          return [idPiece ? idPiece.bottom + idPiece.scaledValue / 2 : rScale(rAccessor(p)), o];
        }
        var newScale = (0, _d3Scale.scaleLinear)().domain(rScale.domain()).range(rScale.range().reverse());

        return [o, idPiece ? idPiece.bottom - idPiece.scaledValue / 2 : newScale(rAccessor(p))];
      };

      var screenCoordinates = [0, 0];

      //TODO: Support radial??
      if (d.coordinates || d.type === "enclose" && d.neighbors) {
        screenCoordinates = (d.coordinates || d.neighbors).map(function (p) {
          return screenProject(p);
        });
      } else {
        screenCoordinates = screenProject(d);
      }

      //TODO: Process your rules first
      var customAnnotation = this.props.svgAnnotationRules && this.props.svgAnnotationRules({
        d: d,
        i: i,
        oScale: oScale,
        rScale: rScale,
        oAccessor: oAccessor,
        rAccessor: rAccessor,
        orFrameProps: this.props,
        screenCoordinates: screenCoordinates,
        adjustedPosition: adjustedPosition,
        adjustedSize: adjustedSize,
        annotationLayer: annotationLayer,
        orFrameState: this.state,
        categories: this.state.projectedColumns
      });
      if (this.props.svgAnnotationRules && customAnnotation !== null) {
        return customAnnotation;
      } else if (d.type === "or") {
        return (0, _orframeRules.svgORRule)({ d: d, i: i, screenCoordinates: screenCoordinates, projection: projection });
      } else if (d.type === "react-annotation" || typeof d.type === "function") {
        return (0, _orframeRules.basicReactAnnotationRule)({ d: d, i: i, screenCoordinates: screenCoordinates });
      } else if (d.type === "enclose") {
        return (0, _orframeRules.svgEncloseRule)({ d: d, i: i, screenCoordinates: screenCoordinates });
      } else if (d.type === "enclose-rect") {
        return (0, _orframeRules.svgRectEncloseRule)({ d: d, screenCoordinates: screenCoordinates, i: i });
      } else if (d.type === "r") {
        return (0, _orframeRules.svgRRule)({
          d: d,
          i: i,
          screenCoordinates: screenCoordinates,
          rScale: rScale,
          rAccessor: rAccessor,
          projection: projection,
          adjustedSize: adjustedSize,
          adjustedPosition: adjustedPosition
        });
      } else if (d.type === "category") {
        return (0, _orframeRules.svgCategoryRule)({
          projection: projection,
          d: d,
          i: i,
          categories: this.state.projectedColumns,
          adjustedSize: adjustedSize
        });
      }
      return null;
    }
  }, {
    key: "defaultORHTMLRule",
    value: function defaultORHTMLRule(_ref3) {
      var d = _ref3.d,
          i = _ref3.i;

      var oAccessor = this.oAccessor;
      var rAccessor = this.rAccessor;
      var oScale = this.oScale;
      var rScale = this.rScale;

      var _props = this.props,
          htmlAnnotationRules = _props.htmlAnnotationRules,
          tooltipContent = _props.tooltipContent,
          projection = _props.projection,
          size = _props.size;
      var projectedColumns = this.state.projectedColumns;


      var type = _typeof(this.props.type) === "object" ? this.props.type : { type: this.props.type };
      var summaryType = _typeof(this.props.summaryType) === "object" ? this.props.summaryType : { type: this.props.summaryType };

      var _adjustedPositionSize3 = (0, _frameFunctions.adjustedPositionSize)(this.props),
          adjustedPosition = _adjustedPositionSize3.adjustedPosition,
          adjustedSize = _adjustedPositionSize3.adjustedSize;

      //TODO: Process your rules first


      if (htmlAnnotationRules && htmlAnnotationRules({
        d: d,
        i: i,
        oScale: oScale,
        rScale: rScale,
        oAccessor: oAccessor,
        rAccessor: rAccessor,
        orFrameProps: this.props,
        orFrameState: this.state,
        categories: this.state.projectedColumns
      }) !== null) {
        return htmlAnnotationRules({
          d: d,
          i: i,
          oScale: oScale,
          rScale: rScale,
          oAccessor: oAccessor,
          rAccessor: rAccessor,
          orFrameProps: this.props,
          categories: this.state.projectedColumns
        });
      }

      if (d.type === "frame-hover") {
        return (0, _orframeRules.htmlFrameHoverRule)({
          d: d,
          i: i,
          rAccessor: rAccessor,
          oAccessor: oAccessor,
          size: size,
          projection: projection,
          tooltipContent: tooltipContent
        });
      } else if (d.type === "column-hover") {
        return (0, _orframeRules.htmlColumnHoverRule)({
          d: d,
          i: i,
          summaryType: summaryType,
          oAccessor: oAccessor,
          rAccessor: rAccessor,
          projectedColumns: projectedColumns,
          type: type,
          adjustedPosition: adjustedPosition,
          adjustedSize: adjustedSize,
          projection: projection,
          tooltipContent: tooltipContent
        });
      }
      return null;
    }
  }, {
    key: "mappedMiddles",
    value: function mappedMiddles(oScale, middleMax, padding) {
      var oScaleDomainValues = oScale.domain();

      var mappedMiddles = {};
      oScaleDomainValues.forEach(function (p, q) {
        var base = oScale(p) - padding;
        var next = oScaleDomainValues[q + 1] ? oScale(oScaleDomainValues[q + 1]) : middleMax;
        var diff = (next - base) / 2;
        mappedMiddles[p] = base + diff;
      });

      return mappedMiddles;
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderBody({ afterElements: this.props.afterElements });
    }
  }, {
    key: "renderBody",
    value: function renderBody(_ref4) {
      var afterElements = _ref4.afterElements;
      var _props2 = this.props,
          className = _props2.className,
          annotationSettings = _props2.annotationSettings,
          size = _props2.size,
          downloadFields = _props2.downloadFields,
          rAccessor = _props2.rAccessor,
          oAccessor = _props2.oAccessor,
          name = _props2.name,
          download = _props2.download,
          annotations = _props2.annotations,
          matte = _props2.matte,
          renderKey = _props2.renderKey,
          interaction = _props2.interaction,
          customClickBehavior = _props2.customClickBehavior,
          customHoverBehavior = _props2.customHoverBehavior,
          customDoubleClickBehavior = _props2.customDoubleClickBehavior,
          projection = _props2.projection,
          backgroundGraphics = _props2.backgroundGraphics,
          foregroundGraphics = _props2.foregroundGraphics,
          beforeElements = _props2.beforeElements,
          disableContext = _props2.disableContext,
          summaryType = _props2.summaryType,
          summaryHoverAnnotation = _props2.summaryHoverAnnotation,
          pieceHoverAnnotation = _props2.pieceHoverAnnotation,
          hoverAnnotation = _props2.hoverAnnotation,
          canvasPostProcess = _props2.canvasPostProcess,
          baseMarkProps = _props2.baseMarkProps,
          useSpans = _props2.useSpans;
      var _state = this.state,
          orFrameRender = _state.orFrameRender,
          projectedColumns = _state.projectedColumns,
          adjustedPosition = _state.adjustedPosition,
          adjustedSize = _state.adjustedSize,
          legendSettings = _state.legendSettings,
          columnOverlays = _state.columnOverlays,
          axesTickLines = _state.axesTickLines,
          axes = _state.axes,
          margin = _state.margin,
          pieceDataXY = _state.pieceDataXY,
          oLabels = _state.oLabels,
          title = _state.title;


      var downloadButton = void 0;

      if (download) {
        downloadButton = _react2.default.createElement(_DownloadButton2.default, {
          csvName: (name || "orframe") + "-" + new Date().toJSON(),
          width: size[0],
          data: (0, _downloadDataMapping.orDownloadMapping)({
            data: projectedColumns,
            rAccessor: (0, _dataFunctions.stringToFn)(rAccessor),
            oAccessor: (0, _dataFunctions.stringToFn)(oAccessor),
            fields: downloadFields
          })
        });
      }

      var finalFilterDefs = (0, _jsx.filterDefs)({
        key: "orframe",
        additionalDefs: this.props.additionalDefs
      });

      var interactionOverflow = void 0;

      if (summaryType && summaryType.amplitude) {
        if (projection === "horizontal") {
          interactionOverflow = {
            top: summaryType.amplitude,
            bottom: 0,
            left: 0,
            right: 0
          };
        } else if (projection === "radial") {
          interactionOverflow = defaultOverflow;
        } else {
          interactionOverflow = {
            top: 0,
            bottom: 0,
            left: summaryType.amplitude,
            right: 0
          };
        }
      }

      return _react2.default.createElement(_Frame2.default, {
        name: "ordinalframe",
        renderPipeline: orFrameRender,
        adjustedPosition: adjustedPosition,
        adjustedSize: adjustedSize,
        size: size,
        xScale: xScale,
        yScale: yScale,
        axes: [axes],
        useSpans: useSpans,
        axesTickLines: axesTickLines,
        title: title,
        matte: matte,
        className: className,
        finalFilterDefs: finalFilterDefs,
        frameKey: "none",
        renderKeyFn: renderKey,
        projectedCoordinateNames: projectedCoordinatesObject,
        defaultSVGRule: this.defaultORSVGRule.bind(this),
        defaultHTMLRule: this.defaultORHTMLRule.bind(this),
        hoverAnnotation: summaryHoverAnnotation || pieceHoverAnnotation || hoverAnnotation,
        annotations: annotations,
        annotationSettings: annotationSettings,
        legendSettings: legendSettings,
        interaction: interaction,
        customClickBehavior: customClickBehavior,
        customHoverBehavior: customHoverBehavior,
        customDoubleClickBehavior: customDoubleClickBehavior,
        points: pieceDataXY,
        margin: margin,
        columns: projectedColumns,
        backgroundGraphics: backgroundGraphics,
        foregroundGraphics: [foregroundGraphics, oLabels],
        beforeElements: beforeElements,
        afterElements: afterElements,
        downloadButton: downloadButton,
        overlay: columnOverlays,
        rScale: this.rScale,
        projection: projection,
        disableContext: disableContext,
        interactionOverflow: interactionOverflow,
        canvasPostProcess: canvasPostProcess,
        baseMarkProps: baseMarkProps
      });
    }
  }]);

  return OrdinalFrame;
}(_react2.default.Component), _class.defaultProps = {
  annotations: [],
  foregroundGraphics: [],
  annotationSettings: {},
  projection: "vertical",
  size: [500, 500],
  className: ""
}, _temp);


OrdinalFrame.propTypes = {
  data: _propTypes2.default.array,
  name: _propTypes2.default.string,
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  margin: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object]),
  size: _propTypes2.default.array,
  position: _propTypes2.default.array,
  oScaleType: _propTypes2.default.func,
  rScaleType: _propTypes2.default.func,
  oExtent: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  rExtent: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  invertO: _propTypes2.default.bool,
  invertR: _propTypes2.default.bool,
  oAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  rAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  annotations: _propTypes2.default.array,
  customHoverBehavior: _propTypes2.default.func,
  customClickBehavior: _propTypes2.default.func,
  svgAnnotationRules: _propTypes2.default.func,
  oPadding: _propTypes2.default.number,
  projection: _propTypes2.default.string,
  htmlAnnotationRules: _propTypes2.default.func,
  type: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.func]),
  summaryType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  connectorType: _propTypes2.default.func,
  tooltipContent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  className: _propTypes2.default.string,
  additionalDefs: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  interaction: _propTypes2.default.object,
  baseMarkProps: _propTypes2.default.object,
  renderKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  dataAccessor: _propTypes2.default.func,
  rBaseline: _propTypes2.default.number,
  sortO: _propTypes2.default.func,
  pixelColumnWidth: _propTypes2.default.number,
  dynamicColumnWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  renderFn: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  style: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  connectorStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  summaryStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  summaryPosition: _propTypes2.default.func,
  oLabel: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object]),
  hoverAnnotation: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array, _propTypes2.default.func, _propTypes2.default.bool]),
  pieceHoverAnnotation: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array, _propTypes2.default.func, _propTypes2.default.bool]),
  summaryHoverAnnotation: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array, _propTypes2.default.func, _propTypes2.default.bool]),
  axis: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
  canvasPostProcess: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  backgroundGraphics: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
  foregroundGraphics: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array])
};

exports.default = OrdinalFrame;
module.exports = exports['default'];

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Force = __webpack_require__(476);

var _d3BboxCollide = __webpack_require__(1269);

var _d3Scale = __webpack_require__(92);

var _d3Array = __webpack_require__(12);

var _jsx = __webpack_require__(246);

var _reactAnnotation = __webpack_require__(48);

var _Frame = __webpack_require__(228);

var _Frame2 = _interopRequireDefault(_Frame);

var _DownloadButton = __webpack_require__(227);

var _DownloadButton2 = _interopRequireDefault(_DownloadButton);

var _SvgHelper = __webpack_require__(138);

var _frameFunctions = __webpack_require__(141);

var _pieceDrawing = __webpack_require__(142);

var _networkDrawing = __webpack_require__(1284);

var _dataFunctions = __webpack_require__(143);

var _downloadDataMapping = __webpack_require__(245);

var _d3SankeyCircular = __webpack_require__(1286);

var _d3Interpolate = __webpack_require__(62);

var _d3Chord = __webpack_require__(340);

var _d3Shape = __webpack_require__(30);

var _d3Hierarchy = __webpack_require__(139);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _frame_props = __webpack_require__(247);

var _networkframeRules = __webpack_require__(1289);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var basicMiddle = function basicMiddle(d) {
  return {
    edge: d,
    x: (d.source.x + d.target.x) / 2,
    y: (d.source.y + d.target.y) / 2
  };
};

var edgePointHash = {
  sankey: function sankey(d) {
    return {
      edge: d,
      x: (d.source.x1 + d.target.x0) / 2,
      y: d.circularPathData ? d.circularPathData.verticalFullExtent : ((d.y0 + d.y1) / 2 + (d.y0 + d.y1) / 2) / 2
    };
  },
  force: basicMiddle,
  tree: basicMiddle,
  cluster: basicMiddle
};

var hierarchicalTypeHash = {
  dendrogram: _d3Hierarchy.tree,
  tree: _d3Hierarchy.tree,
  circlepack: _d3Hierarchy.pack,
  cluster: _d3Hierarchy.cluster,
  treemap: _d3Hierarchy.treemap,
  partition: _d3Hierarchy.partition
};

var hierarchicalCustomNodeHash = {
  partition: _networkDrawing.hierarchicalRectNodeGenerator,
  treemap: _networkDrawing.hierarchicalRectNodeGenerator,
  circlepack: _networkDrawing.circleNodeGenerator
};

var hierarchicalProjectable = {
  partition: true,
  cluster: true,
  tree: true,
  dendrogram: true
};

var radialProjectable = {
  partition: true,
  cluster: true,
  tree: true,
  dendrogram: true

  /*
  const customEdgeHashProject = {
    offset: glyphProject.offset,
    parallel: glyphProject.parallel
  }
  
  const customEdgeHashMutate = {
    particle: glyphMutate.particle
  }
  */

};function breadthFirstCompontents(baseNodes, hash) {
  var componentHash = {
    "0": { componentNodes: [], componentEdges: [] }
  };
  var components = [componentHash["0"]];

  var componentID = 0;

  traverseNodesBF(baseNodes, true);

  function traverseNodesBF(nodes, top) {
    nodes.forEach(function (node) {
      var hashNode = hash.get(node);
      if (!hashNode) {
        componentHash["0"].componentNodes.push(node);
      } else if (hashNode.component === null) {
        var _componentHash$compon;

        if (top === true) {
          componentID++;
          componentHash[componentID] = {
            componentNodes: [],
            componentEdges: []
          };
          components.push(componentHash[componentID]);
        }

        hashNode.component = componentID;
        componentHash[componentID].componentNodes.push(node);
        (_componentHash$compon = componentHash[componentID].componentEdges).push.apply(_componentHash$compon, _toConsumableArray(hashNode.edges));
        var traversibleNodes = [].concat(_toConsumableArray(hashNode.connectedNodes));
        traverseNodesBF(traversibleNodes);
      }
    });
  }

  return components.sort(function (a, b) {
    return b.componentNodes.length - a.componentNodes.length;
  });
}

var projectedCoordinateNames = { y: "y", x: "x" };

function recursiveIDAccessor(idAccessor, node, accessorString) {
  if (node.parent) {
    accessorString = accessorString + "-" + recursiveIDAccessor(idAccessor, node.parent, accessorString);
  }
  return accessorString + "-" + idAccessor(node.data);
}

var sankeyOrientHash = {
  left: _d3SankeyCircular.sankeyLeft,
  right: _d3SankeyCircular.sankeyRight,
  center: _d3SankeyCircular.sankeyCenter,
  justify: _d3SankeyCircular.sankeyJustify
};

var xScale = (0, _d3Scale.scaleIdentity)();
var yScale = (0, _d3Scale.scaleIdentity)();

var curvature = 0.5;

var areaLink = function areaLink(d) {
  var x0 = d.source.x1,
      x1 = d.target.x0,
      xi = (0, _d3Interpolate.interpolateNumber)(x0, x1),
      x2 = xi(curvature),
      x3 = xi(1 - curvature),
      y0 = d.y0 - d.sankeyWidth / 2,
      y1 = d.y1 - d.sankeyWidth / 2,
      y2 = d.y1 + d.sankeyWidth / 2,
      y3 = d.y0 + d.sankeyWidth / 2;

  return "M" + x0 + "," + y0 + "C" + x2 + "," + y0 + " " + x3 + "," + y1 + " " + x1 + "," + y1 + "L" + x1 + "," + y2 + "C" + x3 + "," + y2 + " " + x2 + "," + y2 + " " + x0 + "," + y3 + "Z";
};

function circularAreaLink(link) {
  var linkGenerator = (0, _SvgHelper.linearRibbon)().x(function (d) {
    return d.x;
  }).y(function (d) {
    return d.y;
  })
  //    .interpolate(curveBasisClosed)
  .r(function () {
    return link.sankeyWidth / 2;
  });

  var xyForLink = [{
    x: link.circularPathData.sourceX,
    y: link.circularPathData.sourceY
  }, {
    x: link.circularPathData.leftFullExtent,
    y: link.circularPathData.sourceY
  }, {
    x: link.circularPathData.leftFullExtent,
    y: link.circularPathData.verticalFullExtent
  }, {
    x: link.circularPathData.rightFullExtent,
    y: link.circularPathData.verticalFullExtent
  }, {
    x: link.circularPathData.rightFullExtent,
    y: link.circularPathData.targetY
  }, {
    x: link.circularPathData.targetX,
    y: link.circularPathData.targetY
  }];

  return linkGenerator(xyForLink);
}

var matrixify = function matrixify(_ref) {
  var edgeHash = _ref.edgeHash,
      nodes = _ref.nodes,
      edgeWidthAccessor = _ref.edgeWidthAccessor,
      nodeIDAccessor = _ref.nodeIDAccessor;

  var matrix = [];
  nodes.forEach(function (nodeSource) {
    var nodeSourceID = nodeIDAccessor(nodeSource);
    var sourceRow = [];
    matrix.push(sourceRow);
    nodes.forEach(function (nodeTarget) {
      var nodeTargetID = nodeIDAccessor(nodeTarget);
      var theEdge = edgeHash.get(nodeSourceID + "|" + nodeTargetID);
      if (theEdge) {
        sourceRow.push(edgeWidthAccessor(theEdge));
      } else {
        sourceRow.push(0);
      }
    });
  });
  return matrix;
};

var NetworkFrame = (_temp = _class = function (_React$Component) {
  _inherits(NetworkFrame, _React$Component);

  function NetworkFrame(props) {
    _classCallCheck(this, NetworkFrame);

    var _this = _possibleConstructorReturn(this, (NetworkFrame.__proto__ || Object.getPrototypeOf(NetworkFrame)).call(this, props));

    _this.calculateNetworkFrame = _this.calculateNetworkFrame.bind(_this);
    _this.defaultNetworkHTMLRule = _this.defaultNetworkHTMLRule.bind(_this);
    _this.defaultNetworkSVGRule = _this.defaultNetworkSVGRule.bind(_this);

    _this.renderBody = _this.renderBody.bind(_this);

    _this.graphSettings = {
      numberOfNodes: 0,
      numberOfEdges: 0,
      type: "empty-start"
    };
    _this.state = {
      nodeData: null,
      edgeData: null,
      adjustedPosition: null,
      adjustedSize: null,
      backgroundGraphics: null,
      foregroundGraphics: null,
      projectedNodes: undefined,
      projectedEdges: undefined,
      renderNumber: 0,
      voronoiHover: null,
      nodeLabelAnnotations: []
    };

    _this.oAccessor = null;
    _this.rAccessor = null;
    _this.oScale = null;
    _this.rScale = null;
    return _this;
  }

  _createClass(NetworkFrame, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.calculateNetworkFrame(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.state.dataVersion && this.state.dataVersion !== nextProps.dataVersion || !this.state.projectedNodes && !this.state.projectedEdges) {
        this.calculateNetworkFrame(nextProps);
      } else if (this.props.size[0] !== nextProps.size[0] || this.props.size[1] !== nextProps.size[1] || !this.state.dataVersion && _frame_props.networkFrameChangeProps.find(function (d) {
        return _this2.props[d] !== nextProps[d];
      })) {
        this.calculateNetworkFrame(nextProps);
      }
    }
  }, {
    key: "onNodeClick",
    value: function onNodeClick(d, i) {
      if (this.props.onNodeClick) {
        this.props.onNodeClick(d, i);
      }
    }
  }, {
    key: "onNodeEnter",
    value: function onNodeEnter(d, i) {
      if (this.props.onNodeEnter) {
        this.props.onNodeEnter(d, i);
      }
    }
  }, {
    key: "onNodeOut",
    value: function onNodeOut(d, i) {
      if (this.props.onNodeOut) {
        this.props.onNodeOut(d, i);
      }
    }
  }, {
    key: "calculateNetworkFrame",
    value: function calculateNetworkFrame(currentProps) {
      var _this3 = this;

      var nodes = currentProps.nodes,
          edges = currentProps.edges,
          networkType = currentProps.networkType,
          size = currentProps.size,
          nodeStyle = currentProps.nodeStyle,
          nodeClass = currentProps.nodeClass,
          canvasNodes = currentProps.canvasNodes,
          edgeStyle = currentProps.edgeStyle,
          edgeClass = currentProps.edgeClass,
          canvasEdges = currentProps.canvasEdges,
          nodeRenderMode = currentProps.nodeRenderMode,
          edgeRenderMode = currentProps.edgeRenderMode,
          nodeLabels = currentProps.nodeLabels;
      //    const eventListenersGenerator = generatenetworkFrameEventListeners(customHoverBehavior, customClickBehavior)

      var edgeType = currentProps.edgeType,
          customNodeIcon = currentProps.customNodeIcon,
          customEdgeIcon = currentProps.customEdgeIcon;
      var hoverAnnotation = currentProps.hoverAnnotation;


      var networkSettings = void 0;

      if (typeof networkType === "string") {
        networkSettings = { type: networkType, iterations: 500 };
      } else {
        networkSettings = networkType;
      }

      var nodeIDAccessor = (0, _dataFunctions.stringToFn)(currentProps.nodeIDAccessor, function (d) {
        return d.id;
      });
      var sourceAccessor = (0, _dataFunctions.stringToFn)(currentProps.sourceAccessor, function (d) {
        return d.source;
      });
      var targetAccessor = (0, _dataFunctions.stringToFn)(currentProps.targetAccessor, function (d) {
        return d.target;
      });
      var nodeSizeAccessor = typeof currentProps.nodeSizeAccessor === "number" ? function () {
        return currentProps.nodeSizeAccessor;
      } : (0, _dataFunctions.stringToFn)(currentProps.nodeSizeAccessor, function (d) {
        return d.r || 5;
      });
      var edgeWidthAccessor = (0, _dataFunctions.stringToFn)(currentProps.edgeWidthAccessor, function (d) {
        return d.weight || 1;
      });
      var nodeStyleFn = (0, _dataFunctions.stringToFn)(nodeStyle, function () {
        return {};
      }, true);
      var nodeClassFn = (0, _dataFunctions.stringToFn)(nodeClass, function () {
        return "";
      }, true);
      var nodeRenderModeFn = (0, _dataFunctions.stringToFn)(nodeRenderMode, undefined, true);
      var nodeCanvasRenderFn = (0, _dataFunctions.stringToFn)(canvasNodes, undefined, true);

      var margin = (0, _frameFunctions.calculateMargin)(currentProps);

      var _adjustedPositionSize = (0, _frameFunctions.adjustedPositionSize)(currentProps),
          adjustedPosition = _adjustedPositionSize.adjustedPosition,
          adjustedSize = _adjustedPositionSize.adjustedSize;

      var title = (0, _frameFunctions.generateFrameTitle)(currentProps);

      var _state = this.state,
          projectedNodes = _state.projectedNodes,
          projectedEdges = _state.projectedEdges;


      var changedData = !this.state.projectedNodes || !this.state.projectedEdges || this.graphSettings.nodes !== currentProps.nodes || this.graphSettings.edges !== currentProps.edges || hierarchicalTypeHash[networkSettings.type];

      if (changedData) {
        this.edgeHash = new Map();
        this.nodeHash = new Map();
        projectedNodes = [];
        projectedEdges = [];
        nodes.forEach(function (node) {
          var id = nodeIDAccessor(node);
          _this3.nodeHash.set(id, node);
          _this3.nodeHash.set(node, node);
          projectedNodes.push(node);
          node.id = id;
          node.inDegree = 0;
          node.outDegree = 0;
          node.degree = 0;
        });

        var operationalEdges = edges;

        if (!Array.isArray(edges)) {
          this.hierarchicalNetwork = true;
          var rootNode = (0, _d3Hierarchy.hierarchy)(edges, networkSettings.hierarchyChildren);

          rootNode.sum(networkSettings.hierarchySum || function (d) {
            return d.value;
          });

          if (hierarchicalTypeHash[networkSettings.type]) {
            var layout = networkSettings.layout || hierarchicalTypeHash[networkSettings.type];
            var hierarchicalLayout = layout();
            var networkSettingKeys = Object.keys(networkSettings);

            networkSettingKeys.forEach(function (key) {
              if (hierarchicalLayout[key]) {
                hierarchicalLayout[key](networkSettings[key]);
              }
            });
            var layoutSize = networkSettings.projection === "horizontal" && hierarchicalProjectable[networkSettings.type] ? [adjustedSize[1], adjustedSize[0]] : adjustedSize;
            if (!networkSettings.nodeSize) {
              hierarchicalLayout.size(layoutSize);
            }
            hierarchicalLayout(rootNode);
          }

          operationalEdges = rootNode.descendants().filter(function (d) {
            return d.parent !== null;
          }).map(function (d) {
            return {
              source: _extends(d.parent, d.parent.data),
              target: _extends(d, d.data),
              depth: d.depth,
              weight: 1,
              value: 1,
              _NWFEdgeKey: nodeIDAccessor(d.data) + "-" + recursiveIDAccessor(nodeIDAccessor, d.parent, "")
            };
          });
        }
        operationalEdges.forEach(function (edge) {
          var source = sourceAccessor(edge);
          var target = targetAccessor(edge);
          var sourceTarget = [source, target];
          sourceTarget.forEach(function (nodeDirection) {
            if (!_this3.nodeHash.get(nodeDirection)) {
              var nodeObject = (typeof nodeDirection === "undefined" ? "undefined" : _typeof(nodeDirection)) === "object" ? _extends(nodeDirection, {
                degree: 0,
                inDegree: 0,
                outDegree: 0
              }) : {
                id: nodeDirection,
                inDegree: 0,
                outDegree: 0,
                degree: 0,
                createdByFrame: true
              };
              _this3.nodeHash.set(nodeDirection, nodeObject);
              projectedNodes.push(nodeObject);
            }
          });
          var edgeWeight = edge.weight || 1;
          _this3.nodeHash.get(target).inDegree += edgeWeight;
          _this3.nodeHash.get(source).outDegree += edgeWeight;
          _this3.nodeHash.get(target).degree += edgeWeight;
          _this3.nodeHash.get(source).degree += edgeWeight;

          var edgeKey = (nodeIDAccessor(source) || source) + "|" + (nodeIDAccessor(target) || target);
          var newEdge = _extends({}, edge, {
            source: _this3.nodeHash.get(source),
            target: _this3.nodeHash.get(target)
          });
          _this3.edgeHash.set(edgeKey, newEdge);
          projectedEdges.push(newEdge);
        });
      } else {
        this.edgeHash = new Map();
        projectedEdges.forEach(function (edge) {
          var edgeKey = (nodeIDAccessor(edge.source) || edge.source) + "|" + (nodeIDAccessor(edge.target) || edge.target);
          _this3.edgeHash.set(edgeKey, edge);
        });
      }

      if ((networkSettings.type === "sankey" || networkSettings.type === "flowchart") && (0, _networkDrawing.topologicalSort)(projectedNodes, projectedEdges) === null) {
        networkSettings.customSankey = _d3SankeyCircular.sankeyCircular;
      }
      networkSettings.width = size[0];
      networkSettings.height = size[1];

      var networkSettingsKeys = Object.keys(networkSettings);
      var networkSettingsChanged = false;

      networkSettingsKeys.forEach(function (key) {
        if (key !== "edgeType" && networkSettings[key] !== _this3.graphSettings[key]) {
          networkSettingsChanged = true;
        }
      });

      //Support bubble chart with circle pack and with force
      if (networkSettings.type === "sankey") {
        edgeType = function edgeType(d) {
          return d.circular ? circularAreaLink(d) : areaLink(d);
        };

        customNodeIcon = customNodeIcon ? customNodeIcon : _networkDrawing.sankeyNodeGenerator;
      } else if (networkSettings.type === "chord") {
        customNodeIcon = (0, _networkDrawing.chordNodeGenerator)(size);
        customEdgeIcon = (0, _networkDrawing.chordEdgeGenerator)(size);
      } else if (networkSettings.type === "wordcloud") {
        customNodeIcon = customNodeIcon ? customNodeIcon : _networkDrawing.wordcloudNodeGenerator;
      } else if (hierarchicalTypeHash[networkSettings.type]) {
        if (hierarchicalCustomNodeHash[networkSettings.type]) {
          customNodeIcon = hierarchicalCustomNodeHash[networkSettings.type];
          customEdgeIcon = function customEdgeIcon() {
            return null;
          };
        }
        var radialSize = adjustedSize;
        var radialCenter = [radialSize[0] / 2, radialSize[1] / 2];
        if ((networkSettings.type === "partition" || networkSettings.type === "treemap") && networkSettings.projection === "radial") {
          customNodeIcon = (0, _networkDrawing.radialRectNodeGenerator)(radialSize, radialCenter);
        }

        projectedNodes.forEach(function (node) {
          if (node.x0 !== undefined) {
            node.x = (node.x0 + node.x1) / 2;
            node.y = (node.y0 + node.y1) / 2;
          }
          if (hierarchicalProjectable[networkSettings.type] && networkSettings.projection === "horizontal") {
            var ox = node.x;
            node.x = node.y;
            node.y = ox;

            if (node.x0 !== undefined) {
              var ox0 = node.x0;
              var ox1 = node.x1;
              node.x0 = node.y0;
              node.x1 = node.y1;
              node.y0 = ox0;
              node.y1 = ox1;
            }
          } else if (radialProjectable[networkSettings.type] && networkSettings.projection === "radial") {
            var radialPoint = (0, _pieceDrawing.pointOnArcAtAngle)(radialCenter, node.x / radialSize[0], node.y / 2);
            node.x = radialPoint[0];
            node.y = radialPoint[1];
          } else {
            node.x = node.x;
            node.y = node.y;
            if (node.x0 !== undefined) {
              node.x0 = node.x0;
              node.x1 = node.x1;
              node.y0 = node.y0;
              node.y1 = node.y1;
            }
          }
        });
      }

      if (changedData || networkSettingsChanged) {
        var components = [{
          componentNodes: projectedNodes,
          componentEdges: projectedEdges
        }];

        if (networkSettings.type === "chord") {
          var radius = size[1] / 2;
          var _networkSettings = networkSettings,
              _networkSettings$grou = _networkSettings.groupWidth,
              groupWidth = _networkSettings$grou === undefined ? 20 : _networkSettings$grou,
              _networkSettings$padA = _networkSettings.padAngle,
              padAngle = _networkSettings$padA === undefined ? 0.01 : _networkSettings$padA;

          var arcGenerator = (0, _d3Shape.arc)().innerRadius(radius - groupWidth).outerRadius(radius);

          var ribbonGenerator = (0, _d3Chord.ribbon)().radius(radius - groupWidth);

          var matrixifiedNetwork = matrixify({
            edgeHash: this.edgeHash,
            nodes: projectedNodes,
            edges: projectedEdges,
            edgeWidthAccessor: edgeWidthAccessor,
            nodeIDAccessor: nodeIDAccessor
          });

          var chordLayout = (0, _d3Chord.chord)().padAngle(padAngle);

          var chords = chordLayout(matrixifiedNetwork);
          var groups = chords.groups;

          groups.forEach(function (group) {
            var groupCentroid = arcGenerator.centroid(group);
            var groupD = arcGenerator(group);
            var groupNode = projectedNodes[group.index];
            groupNode.d = groupD;
            groupNode.index = group.index;
            groupNode.x = groupCentroid[0] + size[0] / 2;
            groupNode.y = groupCentroid[1] + size[1] / 2;
          });

          chords.forEach(function (generatedChord) {
            var chordD = ribbonGenerator(generatedChord);
            //this is incorrect should use edgeHash
            var nodeSourceID = nodeIDAccessor(projectedNodes[generatedChord.source.index]);
            var nodeTargetID = nodeIDAccessor(projectedNodes[generatedChord.target.index]);
            var chordEdge = _this3.edgeHash.get(nodeSourceID + "|" + nodeTargetID);
            chordEdge.d = chordD;
          });
        } else if (networkSettings.type === "sankey" || networkSettings.type === "flowchart") {
          var _networkSettings2 = networkSettings,
              _networkSettings2$ori = _networkSettings2.orient,
              orient = _networkSettings2$ori === undefined ? "center" : _networkSettings2$ori,
              _networkSettings2$ite = _networkSettings2.iterations,
              iterations = _networkSettings2$ite === undefined ? 100 : _networkSettings2$ite,
              _networkSettings2$nod = _networkSettings2.nodePadding,
              nodePadding = _networkSettings2$nod === undefined ? 8 : _networkSettings2$nod,
              _networkSettings2$nod2 = _networkSettings2.nodeWidth,
              nodeWidth = _networkSettings2$nod2 === undefined ? networkSettings.type === "flowchart" ? 2 : 24 : _networkSettings2$nod2,
              customSankey = _networkSettings2.customSankey;

          var sankeyOrient = sankeyOrientHash[orient];

          var actualSankey = customSankey || _d3SankeyCircular.sankeyCircular;

          var frameExtent = [[0, 0], adjustedSize];

          if (networkSettings.direction === "up" || networkSettings.direction === "down") {
            frameExtent = [[0, 0], [adjustedSize[1], adjustedSize[0]]];
          }

          //Temporary fix for when sankey-circular sets the size incorrectly
          var initialSettings = actualSankey().extent(frameExtent).links(projectedEdges).nodes(projectedNodes).nodeAlign(sankeyOrient).nodeId(nodeIDAccessor).nodePadding(nodePadding).nodeWidth(nodeWidth).iterations(1);

          initialSettings();

          var circularEdges = projectedEdges.filter(function (d) {
            return d.circular === true;
          });

          if (circularEdges.length === 0) {
            frameExtent = [[0, -frameExtent[1][1]], [frameExtent[1][0], frameExtent[1][1]]];
          } else if (!circularEdges.find(function (d) {
            return d.circularLinkType === "top";
          })) {
            var bottomEdges = circularEdges.filter(function (d) {
              return d.circularLinkType === "bottom";
            });

            var offset = bottomEdges.map(function (d) {
              return d.circularPathData.leftLargeArcRadius;
            }).reduce(function (p, c) {
              return p + c;
            });
            frameExtent = [[0, -frameExtent[1][1]], [frameExtent[1][0], frameExtent[1][1] - offset]];
          }
          //End temporary

          var frameSankey = actualSankey().extent(frameExtent).links(projectedEdges).nodes(projectedNodes).nodeAlign(sankeyOrient).nodeId(nodeIDAccessor).nodePadding(nodePadding).nodeWidth(nodeWidth).iterations(iterations);

          frameSankey();

          projectedNodes.forEach(function (d) {
            d.height = d.y1 - d.y0;
            d.width = d.x1 - d.x0;
            d.x = d.x0 + d.width / 2;
            d.y = d.y0 + d.height / 2;
            d.radius = d.height / 2;
          });

          projectedEdges.forEach(function (d) {
            d.sankeyWidth = d.width;
            d.width = undefined;
          });
        } else if (networkSettings.type === "wordcloud") {
          var _networkSettings3 = networkSettings,
              _networkSettings3$ite = _networkSettings3.iterations,
              _iterations = _networkSettings3$ite === undefined ? 500 : _networkSettings3$ite,
              _networkSettings3$fon = _networkSettings3.fontSize,
              fontSize = _networkSettings3$fon === undefined ? 18 : _networkSettings3$fon,
              rotate = _networkSettings3.rotate,
              _networkSettings3$fon2 = _networkSettings3.fontWeight,
              fontWeight = _networkSettings3$fon2 === undefined ? 300 : _networkSettings3$fon2,
              _networkSettings3$tex = _networkSettings3.textAccessor,
              textAccessor = _networkSettings3$tex === undefined ? function (d) {
            return d.text;
          } : _networkSettings3$tex;

          var fontWeightMod = (fontWeight / 300 - 1) / 5 + 1;
          var fontWidth = fontSize / 1.5 * fontWeightMod;

          nodes.forEach(function (d, i) {
            var calcualatedNodeSize = nodeSizeAccessor(d);
            d._NWFText = textAccessor(d);
            var textWidth = fontWidth * d._NWFText.length * calcualatedNodeSize * 1.4;
            var textHeight = fontSize * calcualatedNodeSize;

            d.textHeight = textHeight + 4;
            d.textWidth = textWidth + 4;
            d.rotate = rotate ? rotate(d, i) : 0;
            d.fontSize = fontSize * calcualatedNodeSize;
            d.fontWeight = fontWeight;
            d.radius = d.r = textWidth / 2;
          });

          nodes.sort(function (a, b) {
            return b.textWidth - a.textWidth;
          });

          //bubblepack for initial position
          (0, _d3Hierarchy.packSiblings)(nodes);

          //        if (rotate) {
          var collide = (0, _d3BboxCollide.bboxCollide)(function (d) {
            if (d.rotate) {
              return [[-d.textHeight / 2, -d.textWidth / 2], [d.textHeight / 2, d.textWidth / 2]];
            }
            return [[-d.textWidth / 2, -d.textHeight / 2], [d.textWidth / 2, d.textHeight / 2]];
          }).iterations(1);

          var xCenter = size[0] / 2;
          var yCenter = size[1] / 2;

          var simulation = (0, _d3Force.forceSimulation)(nodes).velocityDecay(0.6).force("x", (0, _d3Force.forceX)(xCenter).strength(1.2)).force("y", (0, _d3Force.forceY)(yCenter).strength(1.2)).force("collide", collide);

          simulation.stop();

          for (var i = 0; i < _iterations; ++i) {
            simulation.tick();
          } //      }

          var xMin = (0, _d3Array.min)(projectedNodes.map(function (p) {
            return p.x - (p.rotate ? p.textHeight / 2 : p.textWidth / 2);
          }));
          var xMax = (0, _d3Array.max)(projectedNodes.map(function (p) {
            return p.x + (p.rotate ? p.textHeight / 2 : p.textWidth / 2);
          }));
          var yMin = (0, _d3Array.min)(projectedNodes.map(function (p) {
            return p.y - (p.rotate ? p.textWidth / 2 : p.textHeight / 2);
          }));
          var yMax = (0, _d3Array.max)(projectedNodes.map(function (p) {
            return p.y + (p.rotate ? p.textWidth / 2 : p.textHeight / 2);
          }));
          var projectionScaleX = (0, _d3Scale.scaleLinear)().domain([xMin, xMax]).range([0, adjustedSize[0]]);
          var projectionScaleY = (0, _d3Scale.scaleLinear)().domain([yMin, yMax]).range([0, adjustedSize[1]]);
          var xMod = adjustedSize[0] / xMax;
          var yMod = adjustedSize[1] / yMax;

          var sizeMod = Math.min(xMod, yMod) * 1.2;
          projectedNodes.forEach(function (node) {
            node.x = projectionScaleX(node.x);
            node.y = projectionScaleY(node.y);
            node.fontSize = node.fontSize * sizeMod;
            node.scale = 1;
            node.radius = node.r = Math.max(node.textHeight / 4 * yMod, node.textWidth / 4 * xMod);
            //      node.textHeight = projectionScaleY(node.textHeight)
            //      node.textWidth = projectionScaleY(node.textWidth)
          });
        } else if (networkSettings.type === "force") {
          var _networkSettings4 = networkSettings,
              _networkSettings4$ite = _networkSettings4.iterations,
              _iterations2 = _networkSettings4$ite === undefined ? 500 : _networkSettings4$ite,
              _networkSettings4$edg = _networkSettings4.edgeStrength,
              edgeStrength = _networkSettings4$edg === undefined ? 0.1 : _networkSettings4$edg,
              _networkSettings4$dis = _networkSettings4.distanceMax,
              distanceMax = _networkSettings4$dis === undefined ? Infinity : _networkSettings4$dis,
              edgeDistance = _networkSettings4.edgeDistance;

          var linkForce = (0, _d3Force.forceLink)().strength(function (d) {
            return d.weight ? d.weight * edgeStrength : edgeStrength;
          });

          if (edgeDistance) {
            linkForce.distance(edgeDistance);
          }

          var _simulation = networkSettings.simulation || (0, _d3Force.forceSimulation)().force("charge", (0, _d3Force.forceManyBody)().distanceMax(distanceMax).strength(networkSettings.forceManyBody || function (d) {
            return -25 * nodeSizeAccessor(d);
          }));

          //        simulation.force("link", linkForce).nodes(projectedNodes)

          _simulation.nodes(projectedNodes);

          if (!_simulation.force("x")) {
            _simulation.force("x", (0, _d3Force.forceX)(size[0] / 2));
          }
          if (!_simulation.force("y")) {
            _simulation.force("y", (0, _d3Force.forceY)(size[1] / 2));
          }

          if (projectedEdges.length !== 0 && !_simulation.force("link")) {
            _simulation.force("link", linkForce);
            _simulation.force("link").links(projectedEdges);
          }

          //reset alpha if it's too cold
          if (_simulation.alpha() < 0.1) {
            _simulation.alpha(1);
          }

          _simulation.stop();

          for (var _i = 0; _i < _iterations2; ++_i) {
            _simulation.tick();
          }
        } else if (networkSettings.type === "motifs") {
          var componentHash = new Map();
          projectedEdges.forEach(function (edge) {
            ;[edge.source, edge.target].forEach(function (node) {
              if (!componentHash.get(node)) {
                componentHash.set(node, {
                  node: node,
                  component: null,
                  connectedNodes: [],
                  edges: []
                });
              }
            });
            componentHash.get(edge.source).connectedNodes.push(edge.target);
            componentHash.get(edge.target).connectedNodes.push(edge.source);
            componentHash.get(edge.source).edges.push(edge);
          });

          components = breadthFirstCompontents(projectedNodes, componentHash);

          var largestComponent = Math.max(projectedNodes.length / 3, components[0].componentNodes.length);

          var _layoutSize = size[0] > size[1] ? size[1] : size[0];
          var layoutDirection = size[0] > size[1] ? "horizontal" : "vertical";

          //        louvain.assign(graph)

          var _networkSettings5 = networkSettings,
              _networkSettings5$ite = _networkSettings5.iterations,
              _iterations3 = _networkSettings5$ite === undefined ? 500 : _networkSettings5$ite,
              _networkSettings5$edg = _networkSettings5.edgeStrength,
              _edgeStrength = _networkSettings5$edg === undefined ? 0.1 : _networkSettings5$edg,
              _edgeDistance = _networkSettings5.edgeDistance;

          var currentX = 0;
          var currentY = 0;

          components.forEach(function (_ref2) {
            var componentNodes = _ref2.componentNodes,
                componentEdges = _ref2.componentEdges;

            var linkForce = (0, _d3Force.forceLink)().strength(function (d) {
              return d.weight ? d.weight * _edgeStrength : _edgeStrength;
            });

            if (_edgeDistance) {
              linkForce.distance(_edgeDistance);
            }

            var componentLayoutSize = Math.max(componentNodes.length / largestComponent, 0.2) * _layoutSize;

            var xBound = componentLayoutSize + currentX;
            var yBound = componentLayoutSize + currentY;

            if (layoutDirection === "horizontal") {
              if (yBound > size[1]) {
                currentX = componentLayoutSize + currentX;
                currentY = componentLayoutSize;
              } else {
                currentY = componentLayoutSize + currentY;
              }
            } else {
              if (xBound > size[0]) {
                currentY = componentLayoutSize + currentY;
                currentX = componentLayoutSize;
              } else {
                currentX = componentLayoutSize + currentX;
              }
            }

            var xCenter = currentX - componentLayoutSize / 2;
            var yCenter = currentY - componentLayoutSize / 2;

            var simulation = (0, _d3Force.forceSimulation)().force("charge", (0, _d3Force.forceManyBody)().strength(networkSettings.forceManyBody || function (d) {
              return -25 * nodeSizeAccessor(d);
            })).force("link", linkForce);

            simulation.force("x", (0, _d3Force.forceX)(xCenter)).force("y", (0, _d3Force.forceY)(yCenter)).nodes(componentNodes);

            simulation.force("link").links(componentEdges);

            simulation.stop();

            for (var _i2 = 0; _i2 < _iterations3; ++_i2) {
              simulation.tick();
            }var maxX = (0, _d3Array.max)(componentNodes.map(function (d) {
              return d.x;
            }));
            var maxY = (0, _d3Array.max)(componentNodes.map(function (d) {
              return d.y;
            }));
            var minX = (0, _d3Array.min)(componentNodes.map(function (d) {
              return d.x;
            }));
            var minY = (0, _d3Array.min)(componentNodes.map(function (d) {
              return d.y;
            }));

            var resetX = (0, _d3Scale.scaleLinear)().domain([minX, maxX]).range([currentX - componentLayoutSize, currentX - 20]);
            var resetY = (0, _d3Scale.scaleLinear)().domain([minY, maxY]).range([currentY - componentLayoutSize, currentY - 20]);

            componentNodes.forEach(function (node) {
              node.x = resetX(node.x);
              node.y = resetY(node.y);
            });
          });
        } else if (typeof networkSettings.type === "function") {
          networkSettings.type({
            nodes: projectedNodes,
            edges: projectedEdges
          });
        } else {
          projectedNodes.forEach(function (node) {
            node.x = node.x === undefined ? (node.x0 + node.x1) / 2 : node.x;
            node.y = node.y === undefined ? node.y0 : node.y;
          });
        }

        this.graphSettings = networkSettings;
        this.graphSettings.nodes = currentProps.nodes;
        this.graphSettings.edges = currentProps.edges;
      }

      if (networkSettings.type === "flowchart") {
        if (networkSettings.direction === "up") {
          projectedNodes.forEach(function (node) {
            var ox = node.x;
            node.x = node.y;
            node.y = adjustedSize[1] - ox;
          });
        } else if (networkSettings.direction === "down") {
          projectedNodes.forEach(function (node) {
            var ox = node.x;
            node.x = node.y;
            node.y = ox;
          });
        } else if (networkSettings.direction === "left") {
          projectedNodes.forEach(function (node) {
            node.x = adjustedSize[0] - node.x;
          });
        }
      }
      if (networkSettings.zoom !== false && networkSettings.type !== "wordcloud" && networkSettings.type !== "chord" && networkSettings.type !== "sankey" && (hierarchicalTypeHash[networkSettings.type] === undefined || networkSettings.nodeSize)) {
        var _xMin = (0, _d3Array.min)(projectedNodes.map(function (p) {
          return p.x - nodeSizeAccessor(p);
        }));
        var _xMax = (0, _d3Array.max)(projectedNodes.map(function (p) {
          return p.x + nodeSizeAccessor(p);
        }));
        var _yMin = (0, _d3Array.min)(projectedNodes.map(function (p) {
          return p.y - nodeSizeAccessor(p);
        }));
        var _yMax = (0, _d3Array.max)(projectedNodes.map(function (p) {
          return p.y + nodeSizeAccessor(p);
        }));

        var _projectionScaleX = (0, _d3Scale.scaleLinear)().domain([_xMin, _xMax]).range([0, adjustedSize[0]]);
        var _projectionScaleY = (0, _d3Scale.scaleLinear)().domain([_yMin, _yMax]).range([0, adjustedSize[1]]);
        projectedNodes.forEach(function (node) {
          node.x = _projectionScaleX(node.x);
          node.y = _projectionScaleY(node.y);
        });
      }

      projectedNodes.forEach(function (node) {
        node.nodeSize = nodeSizeAccessor(node);
      });

      projectedEdges.forEach(function (edge) {
        edge.width = edgeWidthAccessor(edge);
      });

      var legendSettings = void 0;

      if (currentProps.legend) {
        legendSettings = currentProps.legend === true ? {} : currentProps.legend;
        if (!legendSettings.legendGroups) {
          ///Something auto for networks
          var legendGroups = [{
            styleFn: currentProps.nodeStyle,
            type: "fill",
            items: []
          }];
          legendSettings.legendGroups = legendGroups;
        }
      }

      var networkFrameRender = {
        edges: {
          data: projectedEdges,
          styleFn: (0, _dataFunctions.stringToFn)(edgeStyle, function () {
            return {};
          }, true),
          classFn: (0, _dataFunctions.stringToFn)(edgeClass, function () {
            return "";
          }, true),
          renderMode: (0, _dataFunctions.stringToFn)(edgeRenderMode, undefined, true),
          canvasRenderFn: (0, _dataFunctions.stringToFn)(canvasEdges, undefined, true),
          renderKeyFn: currentProps.edgeRenderKey ? currentProps.edgeRenderKey : function (d) {
            return d._NWFEdgeKey || d.source.id + "-" + d.target.id;
          },
          behavior: _networkDrawing.drawEdges,
          type: edgeType,
          customMark: customEdgeIcon
        },
        nodes: {
          data: projectedNodes,
          styleFn: nodeStyleFn,
          classFn: nodeClassFn,
          renderMode: nodeRenderModeFn,
          canvasRenderFn: nodeCanvasRenderFn,
          customMark: customNodeIcon,
          behavior: _networkDrawing.drawNodes,
          renderKeyFn: currentProps.nodeRenderKey
        }
      };

      var nodeLabelAnnotations = [];
      if (this.props.nodeLabels && projectedNodes) {
        projectedNodes.forEach(function (node, nodei) {
          if (nodeLabels === true || nodeLabels && nodeLabels(node, nodei)) {
            var actualLabel = nodeLabels === true ? nodeIDAccessor(node, nodei) : nodeLabels(node, nodei);

            var nodeLabel = void 0;

            if (_react2.default.isValidElement(actualLabel)) {
              nodeLabel = {
                type: "basic-node-label",
                x: node.x,
                y: node.y,
                element: actualLabel
              };
            } else {
              nodeLabel = {
                className: "node-label",
                dx: 0,
                dy: 0,
                x: node.x,
                y: node.y,
                note: { label: actualLabel },
                connector: { end: "none" },
                type: _reactAnnotation.AnnotationLabel,
                subject: { radius: nodeSizeAccessor(node) + 2 }
              };
            }

            nodeLabelAnnotations.push(nodeLabel);
          }
        });
      }

      var projectedXYPoints = void 0;

      if (hoverAnnotation === "edge" && edgePointHash[networkSettings.type]) {
        projectedXYPoints = projectedEdges.map(edgePointHash[networkSettings.type]);
      } else if (hoverAnnotation === true || hoverAnnotation === "node") {
        projectedXYPoints = projectedNodes;
      } else if (hoverAnnotation === "all") {
        projectedXYPoints = [].concat(_toConsumableArray(projectedEdges.map(edgePointHash[networkSettings.type])), _toConsumableArray(projectedNodes));
      }

      this.setState({
        voronoiHover: null,
        adjustedPosition: adjustedPosition,
        adjustedSize: adjustedSize,
        backgroundGraphics: currentProps.backgroundGraphics,
        foregroundGraphics: currentProps.foregroundGraphics,
        title: title,
        renderNumber: this.state.renderNumber + 1,
        nodeData: null,
        edgeData: null,
        projectedNodes: projectedNodes,
        projectedEdges: projectedEdges,
        projectedXYPoints: projectedXYPoints,
        nodeIDAccessor: nodeIDAccessor,
        sourceAccessor: sourceAccessor,
        targetAccessor: targetAccessor,
        nodeSizeAccessor: nodeSizeAccessor,
        edgeWidthAccessor: edgeWidthAccessor,
        margin: margin,
        legendSettings: legendSettings,
        networkFrameRender: networkFrameRender,
        nodeLabelAnnotations: nodeLabelAnnotations
      });
    }
  }, {
    key: "defaultNetworkSVGRule",
    value: function defaultNetworkSVGRule(_ref3) {
      var d = _ref3.d,
          i = _ref3.i;
      var _state2 = this.state,
          projectedNodes = _state2.projectedNodes,
          nodeIDAccessor = _state2.nodeIDAccessor,
          nodeSizeAccessor = _state2.nodeSizeAccessor;
      var svgAnnotationRules = this.props.svgAnnotationRules;


      if (svgAnnotationRules) {
        var customAnnotation = svgAnnotationRules({
          d: d,
          i: i,
          networkFrameProps: this.props,
          networkFrameState: this.state,
          nodes: this.state.projectedNodes,
          edges: this.state.projectedEdges
        });
        if (customAnnotation !== null) {
          return customAnnotation;
        }
      }
      if (d.type === "node") {
        return (0, _networkframeRules.svgNodeRule)({
          d: d,
          i: i,
          projectedNodes: projectedNodes,
          nodeIDAccessor: nodeIDAccessor,
          nodeSizeAccessor: nodeSizeAccessor
        });
      } else if (d.type === "basic-node-label") {
        return _react2.default.createElement(
          "g",
          { transform: "translate(" + d.x + "," + d.y + ")" },
          d.element
        );
      } else if (d.type === "react-annotation" || typeof d.type === "function") {
        return (0, _networkframeRules.svgReactAnnotationRule)({
          d: d,
          projectedNodes: projectedNodes,
          nodeIDAccessor: nodeIDAccessor
        });
      } else if (d.type === "enclose") {
        return (0, _networkframeRules.svgEncloseRule)({
          d: d,
          i: i,
          projectedNodes: projectedNodes,
          nodeIDAccessor: nodeIDAccessor,
          nodeSizeAccessor: nodeSizeAccessor
        });
      } else if (d.type === "enclose-rect") {
        return (0, _networkframeRules.svgRectEncloseRule)({
          d: d,
          i: i,
          projectedNodes: projectedNodes,
          nodeIDAccessor: nodeIDAccessor,
          nodeSizeAccessor: nodeSizeAccessor
        });
      }
      return null;
    }
  }, {
    key: "defaultNetworkHTMLRule",
    value: function defaultNetworkHTMLRule(_ref4) {
      var d = _ref4.d,
          i = _ref4.i;
      var _props = this.props,
          tooltipContent = _props.tooltipContent,
          size = _props.size;

      if (this.props.htmlAnnotationRules) {
        var customAnnotation = this.props.htmlAnnotationRules({
          d: d,
          i: i,
          networkFrameProps: this.props,
          networkFrameState: this.state,
          nodes: this.state.projectedNodes,
          edges: this.state.projectedEdges
        });
        if (customAnnotation !== null) {
          return customAnnotation;
        }
      }
      if (d.type === "frame-hover") {
        return (0, _networkframeRules.htmlFrameHoverRule)({ d: d, i: i, tooltipContent: tooltipContent, size: size });
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderBody({});
    }
  }, {
    key: "renderBody",
    value: function renderBody(_ref5) {
      var afterElements = _ref5.afterElements;
      var _props2 = this.props,
          annotations = _props2.annotations,
          annotationSettings = _props2.annotationSettings,
          className = _props2.className,
          customClickBehavior = _props2.customClickBehavior,
          customDoubleClickBehavior = _props2.customDoubleClickBehavior,
          customHoverBehavior = _props2.customHoverBehavior,
          size = _props2.size,
          matte = _props2.matte,
          renderKey = _props2.renderKey,
          hoverAnnotation = _props2.hoverAnnotation,
          beforeElements = _props2.beforeElements,
          interaction = _props2.interaction,
          title = _props2.title,
          disableContext = _props2.disableContext,
          canvasPostProcess = _props2.canvasPostProcess,
          baseMarkProps = _props2.baseMarkProps,
          useSpans = _props2.useSpans;
      var _state3 = this.state,
          backgroundGraphics = _state3.backgroundGraphics,
          foregroundGraphics = _state3.foregroundGraphics,
          projectedXYPoints = _state3.projectedXYPoints,
          margin = _state3.margin,
          legendSettings = _state3.legendSettings,
          adjustedPosition = _state3.adjustedPosition,
          adjustedSize = _state3.adjustedSize,
          networkFrameRender = _state3.networkFrameRender,
          nodeLabelAnnotations = _state3.nodeLabelAnnotations;


      var downloadButton = [];

      if (this.props.download && this.state.projectedNodes.length > 0) {
        downloadButton.push(_react2.default.createElement(_DownloadButton2.default, {
          key: "network-download-nodes",
          csvName: (this.props.name || "networkframe") + "-" + new Date().toJSON(),
          width: this.props.size[0],
          label: "Download Node List",
          data: (0, _downloadDataMapping.networkNodeDownloadMapping)({
            data: this.state.projectedNodes,
            fields: this.props.downloadFields
          })
        }));
      }
      if (this.props.download && this.state.projectedEdges.length > 0) {
        downloadButton.push(_react2.default.createElement(_DownloadButton2.default, {
          key: "network-download-edges",
          csvName: (this.props.name || "networkframe") + "-" + new Date().toJSON(),
          width: this.props.size[0],
          label: "Download Edge List",
          data: (0, _downloadDataMapping.networkEdgeDownloadMapping)({
            data: this.state.projectedEdges,
            fields: this.props.downloadFields
          })
        }));
      }

      var finalFilterDefs = (0, _jsx.filterDefs)({
        key: "networkFrame",
        additionalDefs: this.props.additionalDefs
      });

      return _react2.default.createElement(_Frame2.default, {
        name: "networkframe",
        renderPipeline: networkFrameRender,
        adjustedPosition: adjustedPosition,
        adjustedSize: adjustedSize,
        size: size,
        xScale: xScale,
        yScale: yScale,
        title: title,
        matte: matte,
        className: className,
        finalFilterDefs: finalFilterDefs,
        frameKey: "none",
        renderKeyFn: renderKey,
        projectedCoordinateNames: projectedCoordinateNames,
        defaultSVGRule: this.defaultNetworkSVGRule.bind(this),
        defaultHTMLRule: this.defaultNetworkHTMLRule.bind(this),
        hoverAnnotation: !!hoverAnnotation,
        annotations: [].concat(_toConsumableArray(annotations), _toConsumableArray(nodeLabelAnnotations)),
        annotationSettings: annotationSettings,
        legendSettings: legendSettings,
        interaction: interaction,
        customClickBehavior: customClickBehavior,
        customHoverBehavior: customHoverBehavior,
        customDoubleClickBehavior: customDoubleClickBehavior,
        points: projectedXYPoints,
        margin: margin,
        backgroundGraphics: backgroundGraphics,
        foregroundGraphics: foregroundGraphics,
        beforeElements: beforeElements,
        afterElements: afterElements,
        downloadButton: downloadButton,
        disableContext: disableContext,
        canvasPostProcess: canvasPostProcess,
        baseMarkProps: baseMarkProps,
        useSpans: useSpans
      });
    }
  }]);

  return NetworkFrame;
}(_react2.default.Component), _class.defaultProps = {
  annotations: [],
  foregroundGraphics: [],
  annotationSettings: {},
  size: [500, 500],
  className: "",
  name: "networkframe",
  edges: [],
  nodes: [],
  networkType: { type: "force", iterations: 500 }
}, _temp);


NetworkFrame.propTypes = {
  name: _propTypes2.default.string,
  nodes: _propTypes2.default.array,
  edges: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  margin: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object]),
  size: _propTypes2.default.array,
  position: _propTypes2.default.array,
  nodeIDAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  sourceAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  targetAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  nodeSizeAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
  nodeLabels: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  edgeWidthAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  annotations: _propTypes2.default.array,
  customHoverBehavior: _propTypes2.default.func,
  customClickBehavior: _propTypes2.default.func,
  customDoubleClickBehavior: _propTypes2.default.func,
  htmlAnnotationRules: _propTypes2.default.func,
  networkType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  tooltipContent: _propTypes2.default.func,
  className: _propTypes2.default.string,
  additionalDefs: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  interaction: _propTypes2.default.object,
  baseMarkProps: _propTypes2.default.object,
  renderFn: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  nodeStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  edgeStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  hoverAnnotation: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array, _propTypes2.default.func, _propTypes2.default.bool, _propTypes2.default.string]),
  canvasPostProcess: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  backgroundGraphics: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
  foregroundGraphics: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
  customNodeIcon: _propTypes2.default.func,
  edgeType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
};

exports.default = NetworkFrame;
module.exports = exports['default'];

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(64);


/* harmony default export */ __webpack_exports__["a"] = (function(values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export conicEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cylindricalEqualArea__ = __webpack_require__(580);




function conicEqualAreaRaw(y0, y1) {
  var sy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0), n = (sy0 + Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y1)) / 2;

  // Are the parallels symmetrical around the Equator?
  if (Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(n) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) return Object(__WEBPACK_IMPORTED_MODULE_2__cylindricalEqualArea__["a" /* cylindricalEqualAreaRaw */])(y0);

  var c = 1 + sy0 * (2 * n - sy0), r0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(c) / n;

  function project(x, y) {
    var r = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(c - 2 * n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y)) / n;
    return [r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x *= n), r0 - r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x)];
  }

  project.invert = function(x, y) {
    var r0y = r0 - y;
    return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(r0y)) / n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(r0y), Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };

  return project;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicEqualAreaRaw)
      .scale(155.424)
      .center([0, 33.6442]);
});


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = conicProjection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(23);



function conicProjection(projectAt) {
  var phi0 = 0,
      phi1 = __WEBPACK_IMPORTED_MODULE_0__math__["o" /* pi */] / 3,
      m = Object(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* projectionMutator */])(projectAt),
      p = m(phi0, phi1);

  p.parallels = function(_) {
    return arguments.length ? m(phi0 = _[0] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi1 = _[1] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */]) : [phi0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], phi1 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
  };

  return p;
}


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fitExtent;
/* harmony export (immutable) */ __webpack_exports__["c"] = fitSize;
/* harmony export (immutable) */ __webpack_exports__["d"] = fitWidth;
/* harmony export (immutable) */ __webpack_exports__["b"] = fitHeight;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stream__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__path_bounds__ = __webpack_require__(280);



function fit(projection, fitBounds, object) {
  var clip = projection.clipExtent && projection.clipExtent();
  projection.scale(150).translate([0, 0]);
  if (clip != null) projection.clipExtent(null);
  Object(__WEBPACK_IMPORTED_MODULE_0__stream__["a" /* default */])(object, projection.stream(__WEBPACK_IMPORTED_MODULE_1__path_bounds__["a" /* default */]));
  fitBounds(__WEBPACK_IMPORTED_MODULE_1__path_bounds__["a" /* default */].result());
  if (clip != null) projection.clipExtent(clip);
  return projection;
}

function fitExtent(projection, extent, object) {
  return fit(projection, function(b) {
    var w = extent[1][0] - extent[0][0],
        h = extent[1][1] - extent[0][1],
        k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
        x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
        y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

function fitSize(projection, size, object) {
  return fitExtent(projection, [[0, 0], size], object);
}

function fitWidth(projection, width, object) {
  return fit(projection, function(b) {
    var w = +width,
        k = w / (b[1][0] - b[0][0]),
        x = (w - k * (b[1][0] + b[0][0])) / 2,
        y = -k * b[0][1];
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

function fitHeight(projection, height, object) {
  return fit(projection, function(b) {
    var h = +height,
        k = h / (b[1][1] - b[0][1]),
        x = -k * b[0][0],
        y = (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = mercatorRaw;
/* harmony export (immutable) */ __webpack_exports__["a"] = mercatorProjection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rotation__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(23);




function mercatorRaw(lambda, phi) {
  return [lambda, Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["v" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + phi) / 2))];
}

mercatorRaw.invert = function(x, y) {
  return [x, 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["k" /* exp */])(y)) - __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */]];
};

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return mercatorProjection(mercatorRaw)
      .scale(961 / __WEBPACK_IMPORTED_MODULE_0__math__["w" /* tau */]);
});

function mercatorProjection(project) {
  var m = Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(project),
      center = m.center,
      scale = m.scale,
      translate = m.translate,
      clipExtent = m.clipExtent,
      x0 = null, y0, x1, y1; // clip extent

  m.scale = function(_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };

  m.translate = function(_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };

  m.center = function(_) {
    return arguments.length ? (center(_), reclip()) : center();
  };

  m.clipExtent = function(_) {
    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  function reclip() {
    var k = __WEBPACK_IMPORTED_MODULE_0__math__["o" /* pi */] * scale(),
        t = m(Object(__WEBPACK_IMPORTED_MODULE_1__rotation__["a" /* default */])(m.rotate()).invert([0, 0]));
    return clipExtent(x0 == null
        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
  }

  return reclip();
}


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = collignonRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function collignonRaw(lambda, phi) {
  var alpha = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(1 - Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi));
  return [(2 / __WEBPACK_IMPORTED_MODULE_1__math__["E" /* sqrtPi */]) * lambda * alpha, __WEBPACK_IMPORTED_MODULE_1__math__["E" /* sqrtPi */] * (1 - alpha)];
}

collignonRaw.invert = function(x, y) {
  var lambda = (lambda = y / __WEBPACK_IMPORTED_MODULE_1__math__["E" /* sqrtPi */] - 1) * lambda;
  return [lambda > 0 ? x * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / lambda) / 2 : 0, Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(1 - lambda)];
};

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(collignonRaw)
      .scale(95.6464)
      .center([0, 30]);
});


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sinuMollweidePhi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sinuMollweideY; });
/* harmony export (immutable) */ __webpack_exports__["c"] = sinuMollweideRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mollweide__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sinusoidal__ = __webpack_require__(66);




var sinuMollweidePhi = 0.7109889596207567;

var sinuMollweideY = 0.0528035274542;

function sinuMollweideRaw(lambda, phi) {
  return phi > -sinuMollweidePhi
      ? (lambda = Object(__WEBPACK_IMPORTED_MODULE_1__mollweide__["d" /* mollweideRaw */])(lambda, phi), lambda[1] += sinuMollweideY, lambda)
      : Object(__WEBPACK_IMPORTED_MODULE_2__sinusoidal__["b" /* sinusoidalRaw */])(lambda, phi);
}

sinuMollweideRaw.invert = function(x, y) {
  return y > -sinuMollweidePhi
      ? __WEBPACK_IMPORTED_MODULE_1__mollweide__["d" /* mollweideRaw */].invert(x, y - sinuMollweideY)
      : __WEBPACK_IMPORTED_MODULE_2__sinusoidal__["b" /* sinusoidalRaw */].invert(x, y);
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(sinuMollweideRaw)
      .rotate([-20, -55])
      .scale(164.263)
      .center([0, -5.4036]);
});


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// TODO generate on-the-fly to avoid external modification.
var octahedron = [
  [0, 90],
  [-90, 0], [0, 0], [90, 0], [180, 0],
  [0, -90]
];

/* harmony default export */ __webpack_exports__["a"] = ([
  [0, 2, 1],
  [0, 3, 2],
  [5, 1, 2],
  [5, 2, 3],
  [0, 1, 4],
  [0, 4, 3],
  [5, 4, 1],
  [5, 3, 4]
].map(function(face) {
  return face.map(function(i) {
    return octahedron[i];
  });
}));


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = (function(project) {
  var dx = project(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */], 0)[0] - project(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */], 0)[0];

  function projectQuincuncial(lambda, phi) {
    var t = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda) < __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */],
        p = project(t ? lambda : lambda > 0 ? lambda - __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] : lambda + __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */], phi),
        x = (p[0] - p[1]) * __WEBPACK_IMPORTED_MODULE_1__math__["C" /* sqrt1_2 */],
        y = (p[0] + p[1]) * __WEBPACK_IMPORTED_MODULE_1__math__["C" /* sqrt1_2 */];
    if (t) return [x, y];
    var d = dx * __WEBPACK_IMPORTED_MODULE_1__math__["C" /* sqrt1_2 */],
        s = x > 0 ^ y > 0 ? -1 : 1;
    return [s * x - Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(y) * d, s * y - Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(x) * d];
  }

  if (project.invert) projectQuincuncial.invert = function(x0, y0) {
    var x = (x0 + y0) * __WEBPACK_IMPORTED_MODULE_1__math__["C" /* sqrt1_2 */],
        y = (y0 - x0) * __WEBPACK_IMPORTED_MODULE_1__math__["C" /* sqrt1_2 */],
        t = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(x) < 0.5 * dx && Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(y) < 0.5 * dx;

    if (!t) {
      var d = dx * __WEBPACK_IMPORTED_MODULE_1__math__["C" /* sqrt1_2 */],
          s = x > 0 ^ y > 0 ? -1 : 1,
          x1 = -s * (x0 + (y > 0 ? 1 : -1) * d),
          y1 = -s * (y0 + (x > 0 ? 1 : -1) * d);
      x = (-x1 - y1) * __WEBPACK_IMPORTED_MODULE_1__math__["C" /* sqrt1_2 */];
      y = (x1 - y1) * __WEBPACK_IMPORTED_MODULE_1__math__["C" /* sqrt1_2 */];
    }

    var p = project.invert(x, y);
    if (!t) p[0] += x > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */];
    return p;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(projectQuincuncial)
      .rotate([-90, -90, 45])
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clipExtent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffer__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__line__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polygon__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_array__ = __webpack_require__(3);






var clipMax = 1e9, clipMin = -clipMax;

// TODO Use d3-polygon’s polygonContains here for the ring check?
// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?

function clipExtent(x0, y0, x1, y1) {

  function visible(x, y) {
    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
  }

  function interpolate(from, to, direction, stream) {
    var a = 0, a1 = 0;
    if (from == null
        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
        || comparePoint(from, to) < 0 ^ direction > 0) {
      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
      while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }

  function corner(p, direction) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(p[0] - x0) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] ? direction > 0 ? 0 : 3
        : Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(p[0] - x1) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] ? direction > 0 ? 2 : 1
        : Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(p[1] - y0) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] ? direction > 0 ? 1 : 0
        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
  }

  function compareIntersection(a, b) {
    return comparePoint(a.x, b.x);
  }

  function comparePoint(a, b) {
    var ca = corner(a, 1),
        cb = corner(b, 1);
    return ca !== cb ? ca - cb
        : ca === 0 ? b[1] - a[1]
        : ca === 1 ? a[0] - b[0]
        : ca === 2 ? a[1] - b[1]
        : b[0] - a[0];
  }

  return function(stream) {
    var activeStream = stream,
        bufferStream = Object(__WEBPACK_IMPORTED_MODULE_1__buffer__["a" /* default */])(),
        segments,
        polygon,
        ring,
        x__, y__, v__, // first point
        x_, y_, v_, // previous point
        first,
        clean;

    var clipStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: polygonStart,
      polygonEnd: polygonEnd
    };

    function point(x, y) {
      if (visible(x, y)) activeStream.point(x, y);
    }

    function polygonInside() {
      var winding = 0;

      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
        }
      }

      return winding;
    }

    // Buffer geometry within a polygon and then clip it en masse.
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }

    function polygonEnd() {
      var startInside = polygonInside(),
          cleanInside = clean && startInside,
          visible = (segments = Object(__WEBPACK_IMPORTED_MODULE_4_d3_array__["merge"])(segments)).length;
      if (cleanInside || visible) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible) {
          Object(__WEBPACK_IMPORTED_MODULE_3__polygon__["a" /* default */])(segments, compareIntersection, startInside, interpolate, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }

    function lineStart() {
      clipStream.point = linePoint;
      if (polygon) polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }

    // TODO rather than special-case polygons, simply handle them separately.
    // Ideally, coincident intersection points should be jittered to avoid
    // clipping issues.
    function lineEnd() {
      if (segments) {
        linePoint(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point;
      if (v_) activeStream.lineEnd();
    }

    function linePoint(x, y) {
      var v = visible(x, y);
      if (polygon) ring.push([x, y]);
      if (first) {
        x__ = x, y__ = y, v__ = v;
        first = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_) activeStream.point(x, y);
        else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (Object(__WEBPACK_IMPORTED_MODULE_2__line__["a" /* default */])(a, b, x0, y0, x1, y1)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v) activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }

    return clipStream;
  };
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  var x0 = 0,
      y0 = 0,
      x1 = 960,
      y1 = 500,
      cache,
      cacheStream,
      clip;

  return clip = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = clipExtent(x0, y0, x1, y1)(cacheStream = stream);
    },
    extent: function(_) {
      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
    }
  };
});


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = conicEqualAreaRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cylindricalEqualArea__ = __webpack_require__(686);




function conicEqualAreaRaw(y0, y1) {
  var sy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0), n = (sy0 + Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y1)) / 2;

  // Are the parallels symmetrical around the Equator?
  if (Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(n) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) return Object(__WEBPACK_IMPORTED_MODULE_2__cylindricalEqualArea__["a" /* cylindricalEqualAreaRaw */])(y0);

  var c = 1 + sy0 * (2 * n - sy0), r0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(c) / n;

  function project(x, y) {
    var r = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(c - 2 * n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y)) / n;
    return [r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x *= n), r0 - r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x)];
  }

  project.invert = function(x, y) {
    var r0y = r0 - y;
    return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(r0y)) / n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(r0y), Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };

  return project;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicEqualAreaRaw)
      .scale(155.424)
      .center([0, 33.6442]);
});


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = conicProjection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(25);



function conicProjection(projectAt) {
  var phi0 = 0,
      phi1 = __WEBPACK_IMPORTED_MODULE_0__math__["o" /* pi */] / 3,
      m = Object(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* projectionMutator */])(projectAt),
      p = m(phi0, phi1);

  p.parallels = function(_) {
    return arguments.length ? m(phi0 = _[0] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi1 = _[1] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */]) : [phi0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], phi1 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
  };

  return p;
}


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fitExtent;
/* harmony export (immutable) */ __webpack_exports__["b"] = fitSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stream__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__path_bounds__ = __webpack_require__(302);



function fitExtent(projection, extent, object) {
  var w = extent[1][0] - extent[0][0],
      h = extent[1][1] - extent[0][1],
      clip = projection.clipExtent && projection.clipExtent();

  projection
      .scale(150)
      .translate([0, 0]);

  if (clip != null) projection.clipExtent(null);

  Object(__WEBPACK_IMPORTED_MODULE_0__stream__["a" /* default */])(object, projection.stream(__WEBPACK_IMPORTED_MODULE_1__path_bounds__["a" /* default */]));

  var b = __WEBPACK_IMPORTED_MODULE_1__path_bounds__["a" /* default */].result(),
      k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
      x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
      y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;

  if (clip != null) projection.clipExtent(clip);

  return projection
      .scale(k * 150)
      .translate([x, y]);
}

function fitSize(projection, size, object) {
  return fitExtent(projection, [[0, 0], size], object);
}


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = mercatorRaw;
/* harmony export (immutable) */ __webpack_exports__["b"] = mercatorProjection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rotation__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(25);




function mercatorRaw(lambda, phi) {
  return [lambda, Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["v" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + phi) / 2))];
}

mercatorRaw.invert = function(x, y) {
  return [x, 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["k" /* exp */])(y)) - __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */]];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return mercatorProjection(mercatorRaw)
      .scale(961 / __WEBPACK_IMPORTED_MODULE_0__math__["w" /* tau */]);
});

function mercatorProjection(project) {
  var m = Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(project),
      center = m.center,
      scale = m.scale,
      translate = m.translate,
      clipExtent = m.clipExtent,
      x0 = null, y0, x1, y1; // clip extent

  m.scale = function(_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };

  m.translate = function(_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };

  m.center = function(_) {
    return arguments.length ? (center(_), reclip()) : center();
  };

  m.clipExtent = function(_) {
    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  function reclip() {
    var k = __WEBPACK_IMPORTED_MODULE_0__math__["o" /* pi */] * scale(),
        t = m(Object(__WEBPACK_IMPORTED_MODULE_1__rotation__["a" /* default */])(m.rotate()).invert([0, 0]));
    return clipExtent(x0 == null
        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
  }

  return reclip();
}


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity__ = __webpack_require__(308);


/* harmony default export */ __webpack_exports__["a"] = (function(topology) {
  if ((transform = topology.transform) == null) return __WEBPACK_IMPORTED_MODULE_0__identity__["a" /* default */];
  var transform,
      x0,
      y0,
      kx = transform.scale[0],
      ky = transform.scale[1],
      dx = transform.translate[0],
      dy = transform.translate[1];
  return function(point, i) {
    if (!i) x0 = y0 = 0;
    point[0] = (x0 += point[0]) * kx + dx;
    point[1] = (y0 += point[1]) * ky + dy;
    return point;
  };
});


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export feature */
/* harmony export (immutable) */ __webpack_exports__["b"] = object;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reverse__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transform__ = __webpack_require__(163);



/* harmony default export */ __webpack_exports__["a"] = (function(topology, o) {
  return o.type === "GeometryCollection"
      ? {type: "FeatureCollection", features: o.geometries.map(function(o) { return feature(topology, o); })}
      : feature(topology, o);
});

function feature(topology, o) {
  var id = o.id,
      bbox = o.bbox,
      properties = o.properties == null ? {} : o.properties,
      geometry = object(topology, o);
  return id == null && bbox == null ? {type: "Feature", properties: properties, geometry: geometry}
      : bbox == null ? {type: "Feature", id: id, properties: properties, geometry: geometry}
      : {type: "Feature", id: id, bbox: bbox, properties: properties, geometry: geometry};
}

function object(topology, o) {
  var transformPoint = Object(__WEBPACK_IMPORTED_MODULE_1__transform__["a" /* default */])(topology),
      arcs = topology.arcs;

  function arc(i, points) {
    if (points.length) points.pop();
    for (var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k) {
      points.push(transformPoint(a[k].slice(), k));
    }
    if (i < 0) Object(__WEBPACK_IMPORTED_MODULE_0__reverse__["a" /* default */])(points, n);
  }

  function point(p) {
    return transformPoint(p.slice());
  }

  function line(arcs) {
    var points = [];
    for (var i = 0, n = arcs.length; i < n; ++i) arc(arcs[i], points);
    if (points.length < 2) points.push(points[0].slice());
    return points;
  }

  function ring(arcs) {
    var points = line(arcs);
    while (points.length < 4) points.push(points[0].slice());
    return points;
  }

  function polygon(arcs) {
    return arcs.map(ring);
  }

  function geometry(o) {
    var type = o.type, coordinates;
    switch (type) {
      case "GeometryCollection": return {type: type, geometries: o.geometries.map(geometry)};
      case "Point": coordinates = point(o.coordinates); break;
      case "MultiPoint": coordinates = o.coordinates.map(point); break;
      case "LineString": coordinates = line(o.arcs); break;
      case "MultiLineString": coordinates = o.arcs.map(line); break;
      case "Polygon": coordinates = polygon(o.arcs); break;
      case "MultiPolygon": coordinates = o.arcs.map(polygon); break;
      default: return null;
    }
    return {type: type, coordinates: coordinates};
  }

  return geometry(o);
}


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefix; });
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

/* harmony default export */ __webpack_exports__["a"] = (map);


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(314);









/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? Object(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]
      : t === "string" ? ((c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["color"])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["color"] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["e"] = color;
/* harmony export (immutable) */ __webpack_exports__["h"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["b"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(168);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Rgb, rgb, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hsl, hsl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["b"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
});


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return timeFormat; });
/* unused harmony export timeParse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcParse; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(326);


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_drag__ = __webpack_require__(774);
/* unused harmony reexport drag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_nodrag__ = __webpack_require__(336);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_nodrag__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_nodrag__["b"]; });




/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespaces__ = __webpack_require__(175);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return __WEBPACK_IMPORTED_MODULE_0__namespaces__["a" /* default */].hasOwnProperty(prefix) ? {space: __WEBPACK_IMPORTED_MODULE_0__namespaces__["a" /* default */][prefix], local: name} : name;
});


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return xhtml; });
var xhtml = "http://www.w3.org/1999/xhtml";

/* harmony default export */ __webpack_exports__["a"] = ({
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
});


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function none() {}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
});


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
});


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return event; });
/* harmony export (immutable) */ __webpack_exports__["a"] = customEvent;
var filterEvents = {};

var event = null;

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!("onmouseenter" in element)) {
    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
  }
}

function filterContextListener(listener, index, group) {
  listener = contextListener(listener, index, group);
  return function(event) {
    var related = event.relatedTarget;
    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
      listener.call(this, event);
    }
  };
}

function contextListener(listener, index, group) {
  return function(event1) {
    var event0 = event; // Events can be reentrant (e.g., focus).
    event = event1;
    try {
      listener.call(this, this.__data__, index, group);
    } finally {
      event = event0;
    }
  };
}

function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, capture) {
  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
  return function(d, i, group) {
    var on = this.__on, o, listener = wrap(value, i, group);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, capture);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

/* harmony default export */ __webpack_exports__["b"] = (function(typename, value, capture) {
  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  if (capture == null) capture = false;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
  return this;
});

function customEvent(event1, listener, that, args) {
  var event0 = event;
  event1.sourceEvent = event;
  event = event1;
  try {
    return listener.apply(that, args);
  } finally {
    event = event0;
  }
}


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_on__ = __webpack_require__(178);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var current = __WEBPACK_IMPORTED_MODULE_0__selection_on__["c" /* event */], source;
  while (source = current.sourceEvent) current = source;
  return current;
});


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_selection_index__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_transition_index__ = __webpack_require__(35);
/* unused harmony reexport transition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_active__ = __webpack_require__(842);
/* unused harmony reexport active */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_interrupt__ = __webpack_require__(338);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__src_interrupt__["a"]; });






/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = now;
/* harmony export (immutable) */ __webpack_exports__["a"] = Timer;
/* harmony export (immutable) */ __webpack_exports__["c"] = timer;
/* unused harmony export timerFlush */
var frame = 0, // is an animation frame pending?
    timeout = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_linear__ = __webpack_require__(832);
/* unused harmony reexport easeLinear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_quad__ = __webpack_require__(833);
/* unused harmony reexport easeQuad */
/* unused harmony reexport easeQuadIn */
/* unused harmony reexport easeQuadOut */
/* unused harmony reexport easeQuadInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cubic__ = __webpack_require__(834);
/* unused harmony reexport easeCubic */
/* unused harmony reexport easeCubicIn */
/* unused harmony reexport easeCubicOut */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_poly__ = __webpack_require__(835);
/* unused harmony reexport easePoly */
/* unused harmony reexport easePolyIn */
/* unused harmony reexport easePolyOut */
/* unused harmony reexport easePolyInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_sin__ = __webpack_require__(836);
/* unused harmony reexport easeSin */
/* unused harmony reexport easeSinIn */
/* unused harmony reexport easeSinOut */
/* unused harmony reexport easeSinInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_exp__ = __webpack_require__(837);
/* unused harmony reexport easeExp */
/* unused harmony reexport easeExpIn */
/* unused harmony reexport easeExpOut */
/* unused harmony reexport easeExpInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_circle__ = __webpack_require__(838);
/* unused harmony reexport easeCircle */
/* unused harmony reexport easeCircleIn */
/* unused harmony reexport easeCircleOut */
/* unused harmony reexport easeCircleInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_bounce__ = __webpack_require__(839);
/* unused harmony reexport easeBounce */
/* unused harmony reexport easeBounceIn */
/* unused harmony reexport easeBounceOut */
/* unused harmony reexport easeBounceInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_back__ = __webpack_require__(840);
/* unused harmony reexport easeBack */
/* unused harmony reexport easeBackIn */
/* unused harmony reexport easeBackOut */
/* unused harmony reexport easeBackInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_elastic__ = __webpack_require__(841);
/* unused harmony reexport easeElastic */
/* unused harmony reexport easeElasticIn */
/* unused harmony reexport easeElasticOut */
/* unused harmony reexport easeElasticInOut */





















/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_dsv__ = __webpack_require__(184);
/* unused harmony reexport dsvFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_csv__ = __webpack_require__(851);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_csv__["a"]; });
/* unused harmony reexport csvParseRows */
/* unused harmony reexport csvFormat */
/* unused harmony reexport csvFormatRows */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_tsv__ = __webpack_require__(852);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__src_tsv__["a"]; });
/* unused harmony reexport tsvParseRows */
/* unused harmony reexport tsvFormat */
/* unused harmony reexport tsvFormatRows */





/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var EOL = {},
    EOF = {},
    QUOTE = 34,
    NEWLINE = 10,
    RETURN = 13;

function objectConverter(columns) {
  return new Function("d", "return {" + columns.map(function(name, i) {
    return JSON.stringify(name) + ": d[" + i + "]";
  }).join(",") + "}");
}

function customConverter(columns, f) {
  var object = objectConverter(columns);
  return function(row, i) {
    return f(object(row), i, columns);
  };
}

// Compute unique columns in order of discovery.
function inferColumns(rows) {
  var columnSet = Object.create(null),
      columns = [];

  rows.forEach(function(row) {
    for (var column in row) {
      if (!(column in columnSet)) {
        columns.push(columnSet[column] = column);
      }
    }
  });

  return columns;
}

/* harmony default export */ __webpack_exports__["a"] = (function(delimiter) {
  var reFormat = new RegExp("[\"" + delimiter + "\n\r]"),
      DELIMITER = delimiter.charCodeAt(0);

  function parse(text, f) {
    var convert, columns, rows = parseRows(text, function(row, i) {
      if (convert) return convert(row, i - 1);
      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
    });
    rows.columns = columns || [];
    return rows;
  }

  function parseRows(text, f) {
    var rows = [], // output rows
        N = text.length,
        I = 0, // current character index
        n = 0, // current line number
        t, // current token
        eof = N <= 0, // current token followed by EOF?
        eol = false; // current token followed by EOL?

    // Strip the trailing newline.
    if (text.charCodeAt(N - 1) === NEWLINE) --N;
    if (text.charCodeAt(N - 1) === RETURN) --N;

    function token() {
      if (eof) return EOF;
      if (eol) return eol = false, EOL;

      // Unescape quotes.
      var i, j = I, c;
      if (text.charCodeAt(j) === QUOTE) {
        while (I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
        if ((i = I) >= N) eof = true;
        else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;
        else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
        return text.slice(j + 1, i - 1).replace(/""/g, "\"");
      }

      // Find next delimiter or newline.
      while (I < N) {
        if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
        else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
        else if (c !== DELIMITER) continue;
        return text.slice(j, i);
      }

      // Return last token before EOF.
      return eof = true, text.slice(j, N);
    }

    while ((t = token()) !== EOF) {
      var row = [];
      while (t !== EOL && t !== EOF) row.push(t), t = token();
      if (f && (row = f(row, n++)) == null) continue;
      rows.push(row);
    }

    return rows;
  }

  function format(rows, columns) {
    if (columns == null) columns = inferColumns(rows);
    return [columns.map(formatValue).join(delimiter)].concat(rows.map(function(row) {
      return columns.map(function(column) {
        return formatValue(row[column]);
      }).join(delimiter);
    })).join("\n");
  }

  function formatRows(rows) {
    return rows.map(formatRow).join("\n");
  }

  function formatRow(row) {
    return row.map(formatValue).join(delimiter);
  }

  function formatValue(text) {
    return text == null ? ""
        : reFormat.test(text += "") ? "\"" + text.replace(/"/g, "\"\"") + "\""
        : text;
  }

  return {
    parse: parse,
    parseRows: parseRows,
    format: format,
    formatRows: formatRows
  };
});


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return (Math.random() - 0.5) * 1e-6;
});


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node, x0, y0, x1, y1) {
  this.node = node;
  this.x0 = x0;
  this.y0 = y0;
  this.x1 = x1;
  this.y1 = y1;
});


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["b"] = computeHeight;
/* harmony export (immutable) */ __webpack_exports__["a"] = Node;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__count__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eachBefore__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eachAfter__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sum__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sort__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__path__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ancestors__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__descendants__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__leaves__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__links__ = __webpack_require__(886);












function hierarchy(data, children) {
  var root = new Node(data),
      valued = +data.value && (root.value = data.value),
      node,
      nodes = [root],
      child,
      childs,
      i,
      n;

  if (children == null) children = defaultChildren;

  while (node = nodes.pop()) {
    if (valued) node.value = +node.data.value;
    if ((childs = children(node.data)) && (n = childs.length)) {
      node.children = new Array(n);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new Node(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }

  return root.eachBefore(computeHeight);
}

function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}

function defaultChildren(d) {
  return d.children;
}

function copyData(node) {
  node.data = node.data.data;
}

function computeHeight(node) {
  var height = 0;
  do node.height = height;
  while ((node = node.parent) && (node.height < ++height));
}

function Node(data) {
  this.data = data;
  this.depth =
  this.height = 0;
  this.parent = null;
}

Node.prototype = hierarchy.prototype = {
  constructor: Node,
  count: __WEBPACK_IMPORTED_MODULE_0__count__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_1__each__["a" /* default */],
  eachAfter: __WEBPACK_IMPORTED_MODULE_3__eachAfter__["a" /* default */],
  eachBefore: __WEBPACK_IMPORTED_MODULE_2__eachBefore__["a" /* default */],
  sum: __WEBPACK_IMPORTED_MODULE_4__sum__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_5__sort__["a" /* default */],
  path: __WEBPACK_IMPORTED_MODULE_6__path__["a" /* default */],
  ancestors: __WEBPACK_IMPORTED_MODULE_7__ancestors__["a" /* default */],
  descendants: __WEBPACK_IMPORTED_MODULE_8__descendants__["a" /* default */],
  leaves: __WEBPACK_IMPORTED_MODULE_9__leaves__["a" /* default */],
  links: __WEBPACK_IMPORTED_MODULE_10__links__["a" /* default */],
  copy: node_copy
};


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = optional;
/* harmony export (immutable) */ __webpack_exports__["b"] = required;
function optional(f) {
  return f == null ? null : required(f);
}

function required(f) {
  if (typeof f !== "function") throw new Error;
  return f;
}


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return phi; });
/* harmony export (immutable) */ __webpack_exports__["c"] = squarifyRatio;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(114);



var phi = (1 + Math.sqrt(5)) / 2;

function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [],
      nodes = parent.children,
      row,
      nodeValue,
      i0 = 0,
      i1 = 0,
      n = nodes.length,
      dx, dy,
      value = parent.value,
      sumValue,
      minValue,
      maxValue,
      newRatio,
      minRatio,
      alpha,
      beta;

  while (i0 < n) {
    dx = x1 - x0, dy = y1 - y0;

    // Find the next non-empty node.
    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);

    // Keep adding nodes while the aspect ratio maintains or improves.
    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
      minRatio = newRatio;
    }

    // Position and record the row orientation.
    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
    if (row.dice) Object(__WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    else Object(__WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */])(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }

  return rows;
}

/* harmony default export */ __webpack_exports__["a"] = ((function custom(ratio) {

  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }

  squarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return squarify;
})(phi));


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_dispatch__ = __webpack_require__(29);



/* harmony default export */ __webpack_exports__["a"] = (function(url, callback) {
  var request,
      event = Object(__WEBPACK_IMPORTED_MODULE_1_d3_dispatch__["a" /* dispatch */])("beforesend", "progress", "load", "error"),
      mimeType,
      headers = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["map"])(),
      xhr = new XMLHttpRequest,
      user = null,
      password = null,
      response,
      responseType,
      timeout = 0;

  // If IE does not support CORS, use XDomainRequest.
  if (typeof XDomainRequest !== "undefined"
      && !("withCredentials" in xhr)
      && /^(http(s)?:)?\/\//.test(url)) xhr = new XDomainRequest;

  "onload" in xhr
      ? xhr.onload = xhr.onerror = xhr.ontimeout = respond
      : xhr.onreadystatechange = function(o) { xhr.readyState > 3 && respond(o); };

  function respond(o) {
    var status = xhr.status, result;
    if (!status && hasResponse(xhr)
        || status >= 200 && status < 300
        || status === 304) {
      if (response) {
        try {
          result = response.call(request, xhr);
        } catch (e) {
          event.call("error", request, e);
          return;
        }
      } else {
        result = xhr;
      }
      event.call("load", request, result);
    } else {
      event.call("error", request, o);
    }
  }

  xhr.onprogress = function(e) {
    event.call("progress", request, e);
  };

  request = {
    header: function(name, value) {
      name = (name + "").toLowerCase();
      if (arguments.length < 2) return headers.get(name);
      if (value == null) headers.remove(name);
      else headers.set(name, value + "");
      return request;
    },

    // If mimeType is non-null and no Accept header is set, a default is used.
    mimeType: function(value) {
      if (!arguments.length) return mimeType;
      mimeType = value == null ? null : value + "";
      return request;
    },

    // Specifies what type the response value should take;
    // for instance, arraybuffer, blob, document, or text.
    responseType: function(value) {
      if (!arguments.length) return responseType;
      responseType = value;
      return request;
    },

    timeout: function(value) {
      if (!arguments.length) return timeout;
      timeout = +value;
      return request;
    },

    user: function(value) {
      return arguments.length < 1 ? user : (user = value == null ? null : value + "", request);
    },

    password: function(value) {
      return arguments.length < 1 ? password : (password = value == null ? null : value + "", request);
    },

    // Specify how to convert the response content to a specific type;
    // changes the callback value on "load" events.
    response: function(value) {
      response = value;
      return request;
    },

    // Alias for send("GET", …).
    get: function(data, callback) {
      return request.send("GET", data, callback);
    },

    // Alias for send("POST", …).
    post: function(data, callback) {
      return request.send("POST", data, callback);
    },

    // If callback is non-null, it will be used for error and load events.
    send: function(method, data, callback) {
      xhr.open(method, url, true, user, password);
      if (mimeType != null && !headers.has("accept")) headers.set("accept", mimeType + ",*/*");
      if (xhr.setRequestHeader) headers.each(function(value, name) { xhr.setRequestHeader(name, value); });
      if (mimeType != null && xhr.overrideMimeType) xhr.overrideMimeType(mimeType);
      if (responseType != null) xhr.responseType = responseType;
      if (timeout > 0) xhr.timeout = timeout;
      if (callback == null && typeof data === "function") callback = data, data = null;
      if (callback != null && callback.length === 1) callback = fixCallback(callback);
      if (callback != null) request.on("error", callback).on("load", function(xhr) { callback(null, xhr); });
      event.call("beforesend", request, xhr);
      xhr.send(data == null ? null : data);
      return request;
    },

    abort: function() {
      xhr.abort();
      return request;
    },

    on: function() {
      var value = event.on.apply(event, arguments);
      return value === event ? request : value;
    }
  };

  if (callback != null) {
    if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
    return request.get(callback);
  }

  return request;
});

function fixCallback(callback) {
  return function(error, xhr) {
    callback(error == null ? xhr : null);
  };
}

function hasResponse(xhr) {
  var type = xhr.responseType;
  return type && type !== "text"
      ? xhr.response // null on error
      : xhr.responseText; // "" on error
}


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(193);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
});


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(120);



function point(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > __WEBPACK_IMPORTED_MODULE_0__math__["f" /* epsilon */]) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > __WEBPACK_IMPORTED_MODULE_0__math__["f" /* epsilon */]) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new __WEBPACK_IMPORTED_MODULE_1__cardinal__["a" /* Cardinal */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = sum;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(79);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var sums = series.map(sum);
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[a] - sums[b]; });
});

function sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = RedBlackNode;
function RedBlackTree() {
  this._ = null; // root node
}

function RedBlackNode(node) {
  node.U = // parent node
  node.C = // color - true for red, false for black
  node.L = // left node
  node.R = // right node
  node.P = // previous node
  node.N = null; // next node
}

RedBlackTree.prototype = {
  constructor: RedBlackTree,

  insert: function(after, node) {
    var parent, grandpa, uncle;

    if (after) {
      node.P = after;
      node.N = after.N;
      if (after.N) after.N.P = node;
      after.N = node;
      if (after.R) {
        after = after.R;
        while (after.L) after = after.L;
        after.L = node;
      } else {
        after.R = node;
      }
      parent = after;
    } else if (this._) {
      after = RedBlackFirst(this._);
      node.P = null;
      node.N = after;
      after.P = after.L = node;
      parent = after;
    } else {
      node.P = node.N = null;
      this._ = node;
      parent = null;
    }
    node.L = node.R = null;
    node.U = parent;
    node.C = true;

    after = node;
    while (parent && parent.C) {
      grandpa = parent.U;
      if (parent === grandpa.L) {
        uncle = grandpa.R;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.R) {
            RedBlackRotateLeft(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateRight(this, grandpa);
        }
      } else {
        uncle = grandpa.L;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.L) {
            RedBlackRotateRight(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateLeft(this, grandpa);
        }
      }
      parent = after.U;
    }
    this._.C = false;
  },

  remove: function(node) {
    if (node.N) node.N.P = node.P;
    if (node.P) node.P.N = node.N;
    node.N = node.P = null;

    var parent = node.U,
        sibling,
        left = node.L,
        right = node.R,
        next,
        red;

    if (!left) next = right;
    else if (!right) next = left;
    else next = RedBlackFirst(right);

    if (parent) {
      if (parent.L === node) parent.L = next;
      else parent.R = next;
    } else {
      this._ = next;
    }

    if (left && right) {
      red = next.C;
      next.C = node.C;
      next.L = left;
      left.U = next;
      if (next !== right) {
        parent = next.U;
        next.U = node.U;
        node = next.R;
        parent.L = node;
        next.R = right;
        right.U = next;
      } else {
        next.U = parent;
        parent = next;
        node = next.R;
      }
    } else {
      red = node.C;
      node = next;
    }

    if (node) node.U = parent;
    if (red) return;
    if (node && node.C) { node.C = false; return; }

    do {
      if (node === this._) break;
      if (node === parent.L) {
        sibling = parent.R;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateLeft(this, parent);
          sibling = parent.R;
        }
        if ((sibling.L && sibling.L.C)
            || (sibling.R && sibling.R.C)) {
          if (!sibling.R || !sibling.R.C) {
            sibling.L.C = false;
            sibling.C = true;
            RedBlackRotateRight(this, sibling);
            sibling = parent.R;
          }
          sibling.C = parent.C;
          parent.C = sibling.R.C = false;
          RedBlackRotateLeft(this, parent);
          node = this._;
          break;
        }
      } else {
        sibling = parent.L;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateRight(this, parent);
          sibling = parent.L;
        }
        if ((sibling.L && sibling.L.C)
          || (sibling.R && sibling.R.C)) {
          if (!sibling.L || !sibling.L.C) {
            sibling.R.C = false;
            sibling.C = true;
            RedBlackRotateLeft(this, sibling);
            sibling = parent.L;
          }
          sibling.C = parent.C;
          parent.C = sibling.L.C = false;
          RedBlackRotateRight(this, parent);
          node = this._;
          break;
        }
      }
      sibling.C = true;
      node = parent;
      parent = parent.U;
    } while (!node.C);

    if (node) node.C = false;
  }
};

function RedBlackRotateLeft(tree, node) {
  var p = node,
      q = node.R,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.R = q.L;
  if (p.R) p.R.U = p;
  q.L = p;
}

function RedBlackRotateRight(tree, node) {
  var p = node,
      q = node.L,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.L = q.R;
  if (p.L) p.L.U = p;
  q.R = p;
}

function RedBlackFirst(node) {
  while (node.L) node = node.L;
  return node;
}

/* harmony default export */ __webpack_exports__["b"] = (RedBlackTree);


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = createEdge;
/* harmony export (immutable) */ __webpack_exports__["b"] = createBorderEdge;
/* harmony export (immutable) */ __webpack_exports__["d"] = setEdgeEnd;
/* harmony export (immutable) */ __webpack_exports__["a"] = clipEdges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Diagram__ = __webpack_require__(80);


function createEdge(left, right, v0, v1) {
  var edge = [null, null],
      index = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */].push(edge) - 1;
  edge.left = left;
  edge.right = right;
  if (v0) setEdgeEnd(edge, left, right, v0);
  if (v1) setEdgeEnd(edge, right, left, v1);
  __WEBPACK_IMPORTED_MODULE_0__Diagram__["b" /* cells */][left.index].halfedges.push(index);
  __WEBPACK_IMPORTED_MODULE_0__Diagram__["b" /* cells */][right.index].halfedges.push(index);
  return edge;
}

function createBorderEdge(left, v0, v1) {
  var edge = [v0, v1];
  edge.left = left;
  return edge;
}

function setEdgeEnd(edge, left, right, vertex) {
  if (!edge[0] && !edge[1]) {
    edge[0] = vertex;
    edge.left = left;
    edge.right = right;
  } else if (edge.left === right) {
    edge[1] = vertex;
  } else {
    edge[0] = vertex;
  }
}

// Liang–Barsky line clipping.
function clipEdge(edge, x0, y0, x1, y1) {
  var a = edge[0],
      b = edge[1],
      ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?

  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
  return true;
}

function connectEdge(edge, x0, y0, x1, y1) {
  var v1 = edge[1];
  if (v1) return true;

  var v0 = edge[0],
      left = edge.left,
      right = edge.right,
      lx = left[0],
      ly = left[1],
      rx = right[0],
      ry = right[1],
      fx = (lx + rx) / 2,
      fy = (ly + ry) / 2,
      fm,
      fb;

  if (ry === ly) {
    if (fx < x0 || fx >= x1) return;
    if (lx > rx) {
      if (!v0) v0 = [fx, y0];
      else if (v0[1] >= y1) return;
      v1 = [fx, y1];
    } else {
      if (!v0) v0 = [fx, y1];
      else if (v0[1] < y0) return;
      v1 = [fx, y0];
    }
  } else {
    fm = (lx - rx) / (ry - ly);
    fb = fy - fm * fx;
    if (fm < -1 || fm > 1) {
      if (lx > rx) {
        if (!v0) v0 = [(y0 - fb) / fm, y0];
        else if (v0[1] >= y1) return;
        v1 = [(y1 - fb) / fm, y1];
      } else {
        if (!v0) v0 = [(y1 - fb) / fm, y1];
        else if (v0[1] < y0) return;
        v1 = [(y0 - fb) / fm, y0];
      }
    } else {
      if (ly < ry) {
        if (!v0) v0 = [x0, fm * x0 + fb];
        else if (v0[0] >= x1) return;
        v1 = [x1, fm * x1 + fb];
      } else {
        if (!v0) v0 = [x1, fm * x1 + fb];
        else if (v0[0] < x0) return;
        v1 = [x0, fm * x0 + fb];
      }
    }
  }

  edge[0] = v0;
  edge[1] = v1;
  return true;
}

function clipEdges(x0, y0, x1, y1) {
  var i = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */].length,
      edge;

  while (i--) {
    if (!connectEdge(edge = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */][i], x0, y0, x1, y1)
        || !clipEdge(edge, x0, y0, x1, y1)
        || !(Math.abs(edge[0][0] - edge[1][0]) > __WEBPACK_IMPORTED_MODULE_0__Diagram__["f" /* epsilon */]
            || Math.abs(edge[0][1] - edge[1][1]) > __WEBPACK_IMPORTED_MODULE_0__Diagram__["f" /* epsilon */])) {
      delete __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */][i];
    }
  }
}


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDraggable = __webpack_require__(976);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Handle = function (_React$Component) {
  _inherits(Handle, _React$Component);

  function Handle() {
    _classCallCheck(this, Handle);

    return _possibleConstructorReturn(this, (Handle.__proto__ || Object.getPrototypeOf(Handle)).apply(this, arguments));
  }

  _createClass(Handle, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          _props$x = _props.x,
          x = _props$x === undefined ? 0 : _props$x,
          _props$y = _props.y,
          y = _props$y === undefined ? 0 : _props$y,
          _props$r = _props.r,
          r = _props$r === undefined ? 10 : _props$r,
          handleStart = _props.handleStart,
          handleDrag = _props.handleDrag,
          handleStop = _props.handleStop,
          offsetParent = _props.offsetParent;


      return _react2.default.createElement(
        _reactDraggable.DraggableCore,
        {
          handle: ".handle",
          defaultPosition: { x: 0, y: 0 },
          position: null,
          onStart: handleStart,
          onDrag: handleDrag,
          onStop: handleStop,
          offsetParent: offsetParent,
          defaultClassNameDragging: "dragging"
        },
        _react2.default.createElement("circle", {
          className: "handle",
          cx: x,
          cy: y,
          r: r,
          strokeDasharray: "5",
          stroke: "grey",
          fill: "white",
          fillOpacity: 0
        })
      );
    }
  }]);

  return Handle;
}(_react2.default.Component);

exports.default = Handle;


Handle.propTypes = {
  x: _propTypes2.default.number,
  y: _propTypes2.default.number,
  r: _propTypes2.default.number,
  handleStart: _propTypes2.default.func,
  handleStop: _propTypes2.default.func,
  handleDrag: _propTypes2.default.func
};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _alignment4 = __webpack_require__(200);

var _alignment5 = _interopRequireDefault(_alignment4);

var _Handle = __webpack_require__(198);

var _Handle2 = _interopRequireDefault(_Handle);

var _lineTypeVertical = __webpack_require__(982);

var _lineTypeVertical2 = _interopRequireDefault(_lineTypeVertical);

var _lineTypeHorizontal = __webpack_require__(983);

var _lineTypeHorizontal2 = _interopRequireDefault(_lineTypeHorizontal);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getOuterBBox = function getOuterBBox() {
  for (var _len = arguments.length, domNodes = Array(_len), _key = 0; _key < _len; _key++) {
    domNodes[_key] = arguments[_key];
  }

  return [].concat(domNodes).reduce(function (p, c) {
    if (c) {
      var bbox = c.getBBox();
      p.x = Math.min(p.x, bbox.x);
      p.y = Math.min(p.y, bbox.y);
      p.width = Math.max(p.width, bbox.width);

      var yOffset = c && c.attributes && c.attributes.y;
      p.height = Math.max(p.height, (yOffset && parseFloat(yOffset.value) || 0) + bbox.height);
    }
    return p;
  }, { x: 0, y: 0, width: 0, height: 0 });
};

var Note = function (_React$Component) {
  _inherits(Note, _React$Component);

  function Note(props) {
    _classCallCheck(this, Note);

    var _this = _possibleConstructorReturn(this, (Note.__proto__ || Object.getPrototypeOf(Note)).call(this, props));

    _this.state = {
      translateX: 0,
      translateY: 0,
      labelOffset: 0,
      changed: 0,
      bbox: { width: 0, height: 0, x: 0, y: 0 }
    };


    _this.updateText = _this.updateText.bind(_this);
    return _this;
  }

  _createClass(Note, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateText(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.title !== this.props.title || nextProps.label !== this.props.label || nextProps.wrap !== this.props.wrap) {
        this.updateText(nextProps);
      }
      if (nextProps.editMode && (nextProps.align === "dynamic" || !nextProps.align)) {
        this.updateText(nextProps);
      }
    }
  }, {
    key: "updateText",
    value: function updateText(_ref) {
      var _this2 = this;

      var orientation = _ref.orientation,
          padding = _ref.padding,
          align = _ref.align,
          lineType = _ref.lineType,
          label = _ref.label,
          title = _ref.title,
          wrap = _ref.wrap,
          wrapSplitter = _ref.wrapSplitter,
          dx = _ref.dx,
          dy = _ref.dy;

      var newState = {
        titleWrapped: null,
        labelWrapped: null
      };
      newState.changed = this.state.changed + 1;

      if (title) {
        newState.titleWrapped = this.refs.title && this.wrapText(this.refs.title, newState.changed, title, wrap, wrapSplitter);
      }
      if (label) newState.labelWrapped = this.refs.label && this.wrapText(this.refs.label, newState.changed, label, wrap, wrapSplitter);

      this.setState(newState, function () {
        var setLabel = function setLabel() {
          var bbox = getOuterBBox(_this2.refs.title, _this2.refs.label);
          var noteParams = {
            padding: padding,
            bbox: bbox,
            offset: { x: dx, y: dy },
            orientation: orientation,
            align: align
          };
          if (lineType === "vertical") noteParams.orientation = "leftRight";else if (lineType === "horizontal") noteParams.orientation = "topBottom";

          var _alignment = (0, _alignment5.default)(noteParams),
              x = _alignment.x,
              y = _alignment.y;

          _this2.setState({
            translateX: x,
            translateY: y,
            bbox: bbox
          });
        };

        _this2.setState({
          labelOffset: title && _this2.refs.title.getBBox().height || 0
        }, setLabel);
      });
    }
  }, {
    key: "wrapText",
    value: function wrapText(textRef, key, text, width, wrapSplitter) {
      var initialAttrs = {
        x: 0,
        dy: "1.2em"
      };

      var words = text.split(wrapSplitter || /[ \t\r\n]+/).reverse().filter(function (w) {
        return w !== "";
      });

      var word = void 0,
          line = [];

      var tspans = [];

      while (word = words.pop()) {
        line.push(word);
        textRef.lastChild.textContent = line.join(" ");

        var length = textRef.lastChild.getComputedTextLength();

        textRef.lastChild.textContent = "";

        if (length > width && line.length > 1) {
          line.pop();
          tspans.push(_react2.default.createElement(
            "tspan",
            _extends({ key: tspans.length + text }, initialAttrs),
            line.join(" ")
          ));
          line = [word];
        }
      }

      if (line.length !== 0) {
        tspans.push(_react2.default.createElement(
          "tspan",
          _extends({ key: tspans.length + text }, initialAttrs),
          line.join(" ")
        ));
      }

      return _react2.default.createElement(
        "tspan",
        _extends({}, initialAttrs, { key: key + text }),
        tspans
      );
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          orientation = _props.orientation,
          padding = _props.padding,
          align = _props.align,
          dx = _props.dx,
          dy = _props.dy,
          lineType = _props.lineType;


      if (this.state.bbox.width && (prevProps.dx !== this.props.dx || prevProps.dy !== this.props.dy) && (this.refs.title || this.refs.label)) {
        var bbox = getOuterBBox(this.refs.title, this.refs.label);
        var noteParams = {
          padding: padding,
          bbox: bbox,
          offset: { x: dx, y: dy },
          orientation: orientation,
          align: align
        };

        if (lineType === "vertical") noteParams.orientation = "leftRight";else if (lineType === "horizontal") noteParams.orientation = "topBottom";

        var _alignment2 = (0, _alignment5.default)(noteParams),
            x = _alignment2.x,
            y = _alignment2.y;

        var updates = { bbox: bbox };
        if (this.state.translateX !== x) updates.translateX = x;
        if (this.state.translateY !== y) updates.translateY = y;
        if (updates.translateX !== undefined || updates.translateY !== undefined) {
          this.setState(updates);
        }
      } else if (this.state.align !== prevProps.align || this.props.orientation !== prevProps.orientation || this.props.padding !== prevProps.padding) {
        var _noteParams = {
          padding: padding,
          bbox: this.state.bbox,
          offset: { x: dx, y: dy },
          orientation: orientation,
          align: align
        };

        if (lineType === "vertical") _noteParams.orientation = "leftRight";else if (lineType === "horizontal") _noteParams.orientation = "topBottom";

        var _alignment3 = (0, _alignment5.default)(_noteParams),
            _x = _alignment3.x,
            _y = _alignment3.y;

        var _updates = {};
        if (this.state.translateX !== _x) _updates.translateX = _x;
        if (this.state.translateY !== _y) _updates.translateY = _y;
        if (_updates.translateX !== undefined || _updates.translateY !== undefined) {
          this.setState(_updates);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          dx = _props2.dx,
          dy = _props2.dy,
          title = _props2.title,
          label = _props2.label,
          align = _props2.align,
          editMode = _props2.editMode,
          lineType = _props2.lineType,
          color = _props2.color,
          titleColor = _props2.titleColor,
          labelColor = _props2.labelColor;


      var noteTitle = void 0,
          noteText = void 0,
          noteLineType = void 0;
      if (title) {
        noteTitle = _react2.default.createElement(
          "text",
          {
            ref: "title",
            className: "annotation-note-title",
            fontWeight: "bold",
            key: "title",
            fill: titleColor || color
          },
          this.state.titleWrapped || _react2.default.createElement(
            "tspan",
            { x: 0, dy: ".8em" },
            title
          )
        );
      }

      if (label) {
        noteText = _react2.default.createElement(
          "text",
          {
            ref: "label",
            className: "annotation-note-label",
            y: this.state.labelOffset * 1.1,
            key: "label",
            fill: labelColor || color
          },
          this.state.labelWrapped || _react2.default.createElement(
            "tspan",
            { x: 0, dy: ".8em" },
            label
          )
        );
      }

      if (lineType && this.state.bbox.width) {
        var noteParams = {
          bbox: this.state.bbox,
          align: align,
          offset: { x: dx, y: dy }
        };

        var noteComponent = (lineType === "vertical" && (0, _lineTypeVertical2.default)(noteParams) || lineType === "horizontal" && (0, _lineTypeHorizontal2.default)(noteParams)).components[0];

        noteLineType = _react2.default.createElement(noteComponent.type, _extends({
          className: noteComponent.className
        }, noteComponent.attrs, {
          stroke: color
        }));
      }

      var handle = void 0;

      if (editMode) {
        handle = _react2.default.createElement(_Handle2.default, {
          handleStart: this.props.dragStart,
          handleStop: this.props.dragEnd,
          handleDrag: this.props.dragNote
        });
      }

      return _react2.default.createElement(
        "g",
        _extends({
          transform: "translate(" + dx + ", " + dy + ")",
          className: "annotation-note"
        }, this.props.gProps),
        _react2.default.createElement(
          "g",
          {
            className: "annotation-note-content",
            transform: "translate(" + this.state.translateX + ",\n          " + this.state.translateY + ")",
            ref: "note"
          },
          _react2.default.createElement("rect", {
            className: "annotation-note-bg",
            width: this.state.bbox.width,
            height: this.state.bbox.height,
            stroke: "none",
            fill: "white",
            fillOpacity: "0"
          }),
          noteTitle,
          noteText
        ),
        noteLineType,
        handle
      );
    }
  }]);

  return Note;
}(_react2.default.Component);

exports.default = Note;


Note.defaultProps = {
  wrap: 120,
  align: "dynamic",
  orientation: "topBottom",
  padding: 3
};

Note.propTypes = {
  dx: _propTypes2.default.number,
  dy: _propTypes2.default.number,
  title: _propTypes2.default.string,
  label: _propTypes2.default.string,
  orientation: _propTypes2.default.oneOf(["leftRight", "topBottom"]),
  padding: _propTypes2.default.number,
  align: _propTypes2.default.oneOf(["left", "right", "middle", "top", "bottom", "dynamic"]),
  editMode: _propTypes2.default.bool,
  lineType: _propTypes2.default.oneOf(["vertical", "horizontal"]),
  color: _propTypes2.default.string,
  titleColor: _propTypes2.default.string,
  labelColor: _propTypes2.default.string
};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var leftRightDynamic = exports.leftRightDynamic = function leftRightDynamic(align, y) {
  if (!align || align === "dynamic" || align === "left" || align === "right") {
    if (y < 0) {
      align = "top";
    } else {
      align = "bottom";
    }
  }
  return align;
};

var topBottomDynamic = exports.topBottomDynamic = function topBottomDynamic(align, x) {
  if (!align || align === "dynamic" || align === "top" || align === "bottom") {
    if (x < 0) {
      align = "right";
    } else {
      align = "left";
    }
  }
  return align;
};

var orientationTopBottom = ["topBottom", "top", "bottom"];
var orientationLeftRight = ["leftRight", "left", "right"];

exports.default = function (_ref) {
  var _ref$padding = _ref.padding,
      padding = _ref$padding === undefined ? 0 : _ref$padding,
      _ref$bbox = _ref.bbox,
      bbox = _ref$bbox === undefined ? { x: 0, y: 0, width: 0, height: 0 } : _ref$bbox,
      align = _ref.align,
      orientation = _ref.orientation,
      _ref$offset = _ref.offset,
      offset = _ref$offset === undefined ? { x: 0, y: 0 } : _ref$offset;

  var x = -bbox.x;
  var y = -bbox.y;
  if (orientationTopBottom.indexOf(orientation) !== -1) {
    align = topBottomDynamic(align, offset.x);
    if (offset.y < 0 && orientation === "topBottom" || orientation === "top") {
      y -= bbox.height + padding;
    } else {
      y += padding;
    }

    if (align === "middle") {
      x -= bbox.width / 2;
    } else if (align === "right") {
      x -= bbox.width;
    }
  } else if (orientationLeftRight.indexOf(orientation) !== -1) {
    align = leftRightDynamic(align, offset.y);
    if (offset.x < 0 && orientation === "leftRight" || orientation === "left") {
      x -= bbox.width + padding;
    } else {
      x += padding;
    }

    if (align === "middle") {
      y -= bbox.height / 2;
    } else if (align === "top") {
      y -= bbox.height;
    }
  }

  return { x: x, y: y };
};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(202);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Annotation = function (_React$Component) {
  _inherits(Annotation, _React$Component);

  function Annotation() {
    _classCallCheck(this, Annotation);

    return _possibleConstructorReturn(this, (Annotation.__proto__ || Object.getPrototypeOf(Annotation)).apply(this, arguments));
  }

  _createClass(Annotation, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          x = _props.x,
          y = _props.y,
          nx = _props.nx,
          ny = _props.ny,
          events = _props.events;


      var cleanedProps = Object.assign({}, this.props);
      delete cleanedProps.children;

      if (nx !== undefined) cleanedProps.dx = nx - x;
      if (ny !== undefined) cleanedProps.dy = ny - y;

      var childrenWithProps = _react2.default.Children.toArray(this.props.children).map(function (child) {
        return _react2.default.cloneElement(child, _extends({}, cleanedProps, child.props));
      });
      return _react2.default.createElement(
        "g",
        _extends({
          className: (0, _classnames2.default)("annotation", this.props.className),
          transform: "translate(" + x + ", " + y + ")"
        }, events),
        childrenWithProps
      );
    }
  }]);

  return Annotation;
}(_react2.default.Component);

exports.default = Annotation;


Annotation.defaultProps = {
  x: 0,
  y: 0,
  dx: 0,
  dy: 0,
  color: "grey"
};

Annotation.propTypes = {
  x: _propTypes2.default.number,
  y: _propTypes2.default.number,
  dx: _propTypes2.default.number,
  dy: _propTypes2.default.number,
  color: _propTypes2.default.string,
  editMode: _propTypes2.default.bool,
  events: _propTypes2.default.object
};

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
  var style = props.style,
      className = props.className,
      children = props.children;

  if (props.span) return _react2.default.createElement(
    'span',
    { className: className, style: _extends({ display: 'block' }, style) },
    children
  );

  return _react2.default.createElement(
    'div',
    { className: className, style: style },
    children
  );
};

module.exports = exports['default'];

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(389);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
});


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(125);



function point(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > __WEBPACK_IMPORTED_MODULE_0__math__["a" /* epsilon */]) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > __WEBPACK_IMPORTED_MODULE_0__math__["a" /* epsilon */]) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new __WEBPACK_IMPORTED_MODULE_1__cardinal__["a" /* Cardinal */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = sum;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(84);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var sums = series.map(sum);
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[a] - sums[b]; });
});

function sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(85);


/* harmony default export */ __webpack_exports__["a"] = (function(values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__namespaces__ = __webpack_require__(210);



function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === __WEBPACK_IMPORTED_MODULE_1__namespaces__["b" /* xhtml */] && document.documentElement.namespaceURI === __WEBPACK_IMPORTED_MODULE_1__namespaces__["b" /* xhtml */]
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
});


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespaces__ = __webpack_require__(210);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return __WEBPACK_IMPORTED_MODULE_0__namespaces__["a" /* default */].hasOwnProperty(prefix) ? {space: __WEBPACK_IMPORTED_MODULE_0__namespaces__["a" /* default */][prefix], local: name} : name;
});


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return xhtml; });
var xhtml = "http://www.w3.org/1999/xhtml";

/* harmony default export */ __webpack_exports__["a"] = ({
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
});


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_on__ = __webpack_require__(212);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var current = __WEBPACK_IMPORTED_MODULE_0__selection_on__["c" /* event */], source;
  while (source = current.sourceEvent) current = source;
  return current;
});


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return event; });
/* harmony export (immutable) */ __webpack_exports__["a"] = customEvent;
var filterEvents = {};

var event = null;

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!("onmouseenter" in element)) {
    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
  }
}

function filterContextListener(listener, index, group) {
  listener = contextListener(listener, index, group);
  return function(event) {
    var related = event.relatedTarget;
    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
      listener.call(this, event);
    }
  };
}

function contextListener(listener, index, group) {
  return function(event1) {
    var event0 = event; // Events can be reentrant (e.g., focus).
    event = event1;
    try {
      listener.call(this, this.__data__, index, group);
    } finally {
      event = event0;
    }
  };
}

function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, capture) {
  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
  return function(d, i, group) {
    var on = this.__on, o, listener = wrap(value, i, group);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, capture);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

/* harmony default export */ __webpack_exports__["b"] = (function(typename, value, capture) {
  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  if (capture == null) capture = false;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
  return this;
});

function customEvent(event1, listener, that, args) {
  var event0 = event;
  event1.sourceEvent = event;
  event = event1;
  try {
    return listener.apply(that, args);
  } finally {
    event = event0;
  }
}


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node, event) {
  var svg = node.ownerSVGElement || node;

  if (svg.createSVGPoint) {
    var point = svg.createSVGPoint();
    point.x = event.clientX, point.y = event.clientY;
    point = point.matrixTransform(node.getScreenCTM().inverse());
    return [point.x, point.y];
  }

  var rect = node.getBoundingClientRect();
  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
});


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function none() {}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
});


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
});


/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(422);









/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? Object(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]
      : t === "string" ? ((c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["color"])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["color"] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["b"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(429);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
});


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(132);



function point(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > __WEBPACK_IMPORTED_MODULE_0__math__["a" /* epsilon */]) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > __WEBPACK_IMPORTED_MODULE_0__math__["a" /* epsilon */]) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new __WEBPACK_IMPORTED_MODULE_1__cardinal__["a" /* Cardinal */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = sum;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var sums = series.map(sum);
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[a] - sums[b]; });
});

function sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefix; });
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

/* harmony default export */ __webpack_exports__["a"] = (map);


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(448);









/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? Object(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]
      : t === "string" ? ((c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["color"])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["color"] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["b"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.axisLines = exports.axisLabels = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.axisPieces = axisPieces;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semioticMark = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultTickLineGenerator = function defaultTickLineGenerator(_ref) {
  var xy = _ref.xy,
      orient = _ref.orient,
      i = _ref.i;
  return _react2.default.createElement(_semioticMark.Mark, {
    key: i,
    markType: "path",
    renderMode: xy.renderMode,
    stroke: "black",
    strokeWidth: "1px",
    simpleInterpolate: true,
    d: "M" + xy.x1 + "," + xy.y1 + "L" + xy.x2 + "," + xy.y2,
    className: "tick-line tick " + orient
  });
};

function axisPieces(_ref2) {
  var _ref2$renderMode = _ref2.renderMode,
      renderMode = _ref2$renderMode === undefined ? function () {
    return undefined;
  } : _ref2$renderMode,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === undefined ? 5 : _ref2$padding,
      tickValues = _ref2.tickValues,
      scale = _ref2.scale,
      ticks = _ref2.ticks,
      _ref2$orient = _ref2.orient,
      orient = _ref2$orient === undefined ? "left" : _ref2$orient,
      size = _ref2.size,
      _ref2$footer = _ref2.footer,
      footer = _ref2$footer === undefined ? false : _ref2$footer,
      _ref2$tickSize = _ref2.tickSize,
      tickSize = _ref2$tickSize === undefined ? footer ? -10 : ["top", "bottom"].find(function (d) {
    return d === orient;
  }) ? size[1] : size[0] : _ref2$tickSize;

  //returns x1 (start of line), x2 (end of line) associated with the value of the tick
  var axisDomain = [],
      position1 = void 0,
      position2 = void 0,
      domain1 = void 0,
      domain2 = void 0,
      tposition1 = void 0,
      tposition2 = void 0,
      textPositionMod = 0,
      textPositionMod2 = 0,
      defaultAnchor = "middle";

  switch (orient) {
    case "top":
      position1 = "x1";
      position2 = "x2";
      domain1 = "y1";
      domain2 = "y2";
      axisDomain = [0, tickSize];
      tposition1 = "tx";
      tposition2 = "ty";
      textPositionMod -= 20 - padding;
      break;
    case "bottom":
      position1 = "x1";
      position2 = "x2";
      domain1 = "y2";
      domain2 = "y1";
      axisDomain = [size[1], size[1] - tickSize];
      tposition1 = "tx";
      tposition2 = "ty";
      textPositionMod += 20 + padding;
      break;
    case "right":
      position1 = "y2";
      position2 = "y1";
      domain1 = "x2";
      domain2 = "x1";
      axisDomain = [size[0], size[0] - tickSize];
      tposition1 = "ty";
      tposition2 = "tx";
      textPositionMod += 5 + padding;
      textPositionMod2 += 5;
      defaultAnchor = "start";
      break;
    //left
    default:
      position1 = "y1";
      position2 = "y2";
      domain1 = "x1";
      domain2 = "x2";
      axisDomain = [0, tickSize];
      tposition1 = "ty";
      tposition2 = "tx";
      textPositionMod -= 5 + padding;
      textPositionMod2 += 5;
      defaultAnchor = "end";
      break;
  }

  var axisSize = Math.abs(scale.range()[1] - scale.range()[0]);

  if (!tickValues) {
    if (!ticks) {
      ticks = Math.max(1, parseInt(axisSize / 40, 10));
    }
    tickValues = scale.ticks(ticks);
  }

  return tickValues.map(function (tick, i) {
    var _ref3;

    var tickPosition = scale(tick);
    return _ref3 = {}, _defineProperty(_ref3, position1, tickPosition), _defineProperty(_ref3, position2, tickPosition), _defineProperty(_ref3, domain1, axisDomain[0]), _defineProperty(_ref3, domain2, axisDomain[1]), _defineProperty(_ref3, tposition1, tickPosition + textPositionMod2), _defineProperty(_ref3, tposition2, axisDomain[0] + textPositionMod), _defineProperty(_ref3, "defaultAnchor", defaultAnchor), _defineProperty(_ref3, "renderMode", renderMode(tick, i)), _defineProperty(_ref3, "value", tick), _ref3;
  });
}

var axisLabels = exports.axisLabels = function axisLabels(_ref4) {
  var axisParts = _ref4.axisParts,
      tickFormat = _ref4.tickFormat,
      _ref4$rotate = _ref4.rotate,
      rotate = _ref4$rotate === undefined ? 0 : _ref4$rotate;

  return axisParts.map(function (axisPart, i) {
    var renderedValue = tickFormat(axisPart.value);
    if ((typeof renderedValue === "undefined" ? "undefined" : _typeof(renderedValue)) !== "object" || renderedValue instanceof Date) {
      renderedValue = _react2.default.createElement(
        "text",
        { textAnchor: axisPart.defaultAnchor },
        renderedValue.toString ? renderedValue.toString() : renderedValue
      );
    }

    return _react2.default.createElement(
      "g",
      {
        key: i,
        pointerEvents: "none",
        transform: "translate(" + axisPart.tx + "," + axisPart.ty + ")rotate(" + rotate + ")"
      },
      renderedValue
    );
  });
};

var axisLines = exports.axisLines = function axisLines(_ref5) {
  var axisParts = _ref5.axisParts,
      orient = _ref5.orient,
      _ref5$tickLineGenerat = _ref5.tickLineGenerator,
      tickLineGenerator = _ref5$tickLineGenerat === undefined ? defaultTickLineGenerator : _ref5$tickLineGenerat;

  return axisParts.map(function (axisPart, i) {
    return tickLineGenerator({ xy: axisPart, orient: orient, i: i });
  });
};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadCSV = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _json2csv = __webpack_require__(1168);

var _json2csv2 = _interopRequireDefault(_json2csv);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var downloadCSV = exports.downloadCSV = function downloadCSV(csvName, data) {
  (0, _json2csv2.default)(_extends({}, { data: data }), function (err, csv) {
    var blob = new Blob([csv], { type: "text/csv" });

    var dlink = document.createElement("a");
    dlink.download = csvName ? csvName.replace(/ /g, "_") + ".csv" : "vis.csv";
    dlink.href = window.URL.createObjectURL(blob);
    dlink.onclick = function () {
      // revokeObjectURL needs a delay to work properly
      var revokeFn = function revokeFn() {
        window.URL.revokeObjectURL(undefined.href);
      };
      setTimeout(revokeFn.bind(undefined), 1500);
    };

    dlink.click();
    dlink.remove();
  });
};

var DownloadButton = function (_React$Component) {
  _inherits(DownloadButton, _React$Component);

  function DownloadButton() {
    _classCallCheck(this, DownloadButton);

    return _possibleConstructorReturn(this, (DownloadButton.__proto__ || Object.getPrototypeOf(DownloadButton)).apply(this, arguments));
  }

  _createClass(DownloadButton, [{
    key: "render",

    /*
      renderBody({ csvName, data }) {
          return <div className='download-div'>
                  <button alt='download' onClick={downloadCSV.bind(this, csvName, data)} className='download-data-button'>
                      <a>Download</a>
                  </button>
              </div>
      }
    */
    value: function render() {
      var _props = this.props,
          csvName = _props.csvName,
          data = _props.data,
          width = _props.width,
          _props$label = _props.label,
          label = _props$label === undefined ? "Download" : _props$label;

      return _react2.default.createElement(
        "div",
        { className: "download-div", style: { width: width } },
        _react2.default.createElement(
          "button",
          {
            alt: "download",
            onClick: downloadCSV.bind(this, csvName, data),
            className: "download-data-button"
          },
          _react2.default.createElement(
            "a",
            null,
            label
          )
        )
      );
    }
  }]);

  return DownloadButton;
}(_react2.default.Component);

DownloadButton.propTypes = {
  csvName: _propTypes2.default.string,
  data: _propTypes2.default.array,
  width: _propTypes2.default.number
};

exports.default = DownloadButton;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AnnotationLayer = __webpack_require__(371);

var _AnnotationLayer2 = _interopRequireDefault(_AnnotationLayer);

var _InteractionLayer = __webpack_require__(456);

var _InteractionLayer2 = _interopRequireDefault(_InteractionLayer);

var _VisualizationLayer = __webpack_require__(465);

var _VisualizationLayer2 = _interopRequireDefault(_VisualizationLayer);

var _SpanOrDiv = __webpack_require__(203);

var _SpanOrDiv2 = _interopRequireDefault(_SpanOrDiv);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultZeroMargin = { top: 0, bottom: 0, left: 0, right: 0 };

var Frame = (_temp = _class = function (_React$Component) {
  _inherits(Frame, _React$Component);

  function Frame(props) {
    _classCallCheck(this, Frame);

    var _this = _possibleConstructorReturn(this, (Frame.__proto__ || Object.getPrototypeOf(Frame)).call(this, props));

    _this.state = {
      canvasContext: null,
      voronoiHover: undefined
    };
    return _this;
  }

  _createClass(Frame, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({ canvasContext: this.canvasContext });
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      return { canvas: this.canvasContext };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          axes = _props.axes,
          axesTickLines = _props.axesTickLines,
          className = _props.className,
          extent = _props.extent,
          matte = _props.matte,
          name = _props.name,
          projectedCoordinateNames = _props.projectedCoordinateNames,
          renderPipeline = _props.renderPipeline,
          size = _props.size,
          _props$adjustedSize = _props.adjustedSize,
          adjustedSize = _props$adjustedSize === undefined ? size : _props$adjustedSize,
          title = _props.title,
          xScale = _props.xScale,
          yScale = _props.yScale,
          finalFilterDefs = _props.finalFilterDefs,
          frameKey = _props.frameKey,
          dataVersion = _props.dataVersion,
          annotations = _props.annotations,
          hoverAnnotation = _props.hoverAnnotation,
          projectedYMiddle = _props.projectedYMiddle,
          interaction = _props.interaction,
          customClickBehavior = _props.customClickBehavior,
          customHoverBehavior = _props.customHoverBehavior,
          customDoubleClickBehavior = _props.customDoubleClickBehavior,
          points = _props.points,
          _props$margin = _props.margin,
          margin = _props$margin === undefined ? defaultZeroMargin : _props$margin,
          backgroundGraphics = _props.backgroundGraphics,
          foregroundGraphics = _props.foregroundGraphics,
          beforeElements = _props.beforeElements,
          afterElements = _props.afterElements,
          downloadButton = _props.downloadButton,
          defaultSVGRule = _props.defaultSVGRule,
          defaultHTMLRule = _props.defaultHTMLRule,
          adjustedPosition = _props.adjustedPosition,
          legendSettings = _props.legendSettings,
          annotationSettings = _props.annotationSettings,
          overlay = _props.overlay,
          columns = _props.columns,
          rScale = _props.rScale,
          projection = _props.projection,
          interactionOverflow = _props.interactionOverflow,
          canvasPostProcess = _props.canvasPostProcess,
          baseMarkProps = _props.baseMarkProps,
          useSpans = _props.useSpans;
      var voronoiHover = this.state.voronoiHover;


      var areaAnnotations = [];

      var totalAnnotations = annotations ? [].concat(_toConsumableArray(annotations), areaAnnotations) : areaAnnotations;

      if (voronoiHover) {
        if (Array.isArray(voronoiHover)) {
          totalAnnotations.push.apply(totalAnnotations, _toConsumableArray(voronoiHover));
        } else {
          totalAnnotations.push(voronoiHover);
        }
      }

      var annotationLayer = (totalAnnotations || legendSettings) && _react2.default.createElement(_AnnotationLayer2.default, {
        legendSettings: legendSettings,
        margin: margin,
        axes: axes,
        annotationHandling: annotationSettings.layout,
        pointSizeFunction: annotationSettings.pointSizeFunction,
        labelSizeFunction: annotationSettings.labelSizeFunction,
        annotations: totalAnnotations,
        svgAnnotationRule: function svgAnnotationRule(d, i, thisALayer) {
          return defaultSVGRule(_extends({
            d: d,
            i: i,
            annotationLayer: thisALayer
          }, renderPipeline));
        },
        htmlAnnotationRule: function htmlAnnotationRule(d, i, thisALayer) {
          return defaultHTMLRule(_extends({
            d: d,
            i: i,
            annotationLayer: thisALayer
          }, renderPipeline));
        },
        useSpans: useSpans,
        size: adjustedSize,
        position: [adjustedPosition[0] + margin.left, adjustedPosition[1] + margin.top]
      });

      return _react2.default.createElement(
        _SpanOrDiv2.default,
        {
          span: useSpans,
          className: className + " frame " + name,
          style: {
            background: "none"
          }
        },
        beforeElements && _react2.default.createElement(
          _SpanOrDiv2.default,
          {
            span: useSpans,
            className: name + " frame-before-elements"
          },
          beforeElements
        ),
        _react2.default.createElement(
          _SpanOrDiv2.default,
          {
            span: useSpans,
            className: "frame-elements",
            style: { height: size[1] + "px" }
          },
          _react2.default.createElement(
            _SpanOrDiv2.default,
            {
              span: useSpans,
              className: "visualization-layer",
              style: { position: "absolute" }
            },
            _react2.default.createElement("canvas", {
              className: "frame-canvas",
              ref: function ref(canvasContext) {
                return _this2.canvasContext = canvasContext;
              },
              style: {
                position: "absolute",
                left: "0px",
                top: "0px"
              },
              width: size[0],
              height: size[1]
            }),
            _react2.default.createElement(
              "svg",
              {
                className: "visualization-layer",
                style: { position: "absolute" },
                width: size[0],
                height: size[1]
              },
              finalFilterDefs,
              backgroundGraphics && _react2.default.createElement(
                "g",
                { className: "background-graphics" },
                backgroundGraphics
              ),
              _react2.default.createElement(_VisualizationLayer2.default, {
                disableContext: this.props.disableContext,
                renderPipeline: renderPipeline,
                position: adjustedPosition,
                size: adjustedSize,
                extent: extent,
                projectedCoordinateNames: projectedCoordinateNames,
                xScale: xScale,
                yScale: yScale,
                axes: axes,
                axesTickLines: axesTickLines,
                title: title,
                frameKey: frameKey,
                canvasContext: this.state.canvasContext,
                dataVersion: dataVersion,
                matte: matte,
                margin: margin,
                canvasPostProcess: canvasPostProcess,
                baseMarkProps: baseMarkProps
              }),
              title && _react2.default.createElement(
                "g",
                { className: "frame-title" },
                title
              ),
              foregroundGraphics && _react2.default.createElement(
                "g",
                { className: "foreground-graphics" },
                foregroundGraphics
              )
            )
          ),
          _react2.default.createElement(_InteractionLayer2.default, {
            useSpans: useSpans,
            hoverAnnotation: hoverAnnotation,
            projectedX: projectedCoordinateNames.x,
            projectedY: projectedCoordinateNames.y,
            projectedYMiddle: projectedYMiddle,
            interaction: interaction,
            voronoiHover: function voronoiHover(d) {
              return _this2.setState({ voronoiHover: d });
            },
            customClickBehavior: customClickBehavior,
            customHoverBehavior: customHoverBehavior,
            customDoubleClickBehavior: customDoubleClickBehavior,
            points: points,
            position: adjustedPosition,
            margin: margin,
            size: adjustedSize,
            svgSize: size,
            xScale: xScale,
            yScale: yScale,
            enabled: true,
            overlay: overlay,
            oColumns: columns,
            rScale: rScale,
            projection: projection,
            interactionOverflow: interactionOverflow
          }),
          annotationLayer
        ),
        (downloadButton || afterElements) && _react2.default.createElement(
          _SpanOrDiv2.default,
          { span: useSpans, className: name + " frame-after-elements" },
          downloadButton,
          afterElements
        )
      );
    }
  }]);

  return Frame;
}(_react2.default.Component), _class.defaultProps = {
  annotationSettings: {},
  adjustedPosition: [0, 0],
  projectedCoordinateNames: { x: "x", y: "y" }
}, _temp);


Frame.propTypes = {
  name: _propTypes2.default.string,
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  margin: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object]),
  size: _propTypes2.default.array.isRequired,
  annotationSettings: _propTypes2.default.object,
  position: _propTypes2.default.array,
  annotations: _propTypes2.default.array,
  customHoverBehavior: _propTypes2.default.func,
  customClickBehavior: _propTypes2.default.func,
  customDoubleClickBehavior: _propTypes2.default.func,
  htmlAnnotationRules: _propTypes2.default.func,
  tooltipContent: _propTypes2.default.func,
  className: _propTypes2.default.string,
  additionalDefs: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  interaction: _propTypes2.default.object,
  renderFn: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  hoverAnnotation: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array, _propTypes2.default.func, _propTypes2.default.bool]),
  backgroundGraphics: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
  foregroundGraphics: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
  interactionOverflow: _propTypes2.default.object
};

Frame.childContextTypes = {
  canvas: _propTypes2.default.object
};

exports.default = Frame;
module.exports = exports['default'];

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_creator__ = __webpack_require__(230);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "creator", function() { return __WEBPACK_IMPORTED_MODULE_0__src_creator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_local__ = __webpack_require__(1179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "local", function() { return __WEBPACK_IMPORTED_MODULE_1__src_local__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_matcher__ = __webpack_require__(457);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matcher", function() { return __WEBPACK_IMPORTED_MODULE_2__src_matcher__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_mouse__ = __webpack_require__(1180);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mouse", function() { return __WEBPACK_IMPORTED_MODULE_3__src_mouse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_namespace__ = __webpack_require__(231);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "namespace", function() { return __WEBPACK_IMPORTED_MODULE_4__src_namespace__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_namespaces__ = __webpack_require__(232);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "namespaces", function() { return __WEBPACK_IMPORTED_MODULE_5__src_namespaces__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_select__ = __webpack_require__(1181);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_6__src_select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_selectAll__ = __webpack_require__(1209);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selectAll", function() { return __WEBPACK_IMPORTED_MODULE_7__src_selectAll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_selection_index__ = __webpack_require__(22);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selection", function() { return __WEBPACK_IMPORTED_MODULE_8__src_selection_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_selector__ = __webpack_require__(236);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selector", function() { return __WEBPACK_IMPORTED_MODULE_9__src_selector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_selectorAll__ = __webpack_require__(458);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selectorAll", function() { return __WEBPACK_IMPORTED_MODULE_10__src_selectorAll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_selection_style__ = __webpack_require__(461);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "style", function() { return __WEBPACK_IMPORTED_MODULE_11__src_selection_style__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_touch__ = __webpack_require__(1210);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "touch", function() { return __WEBPACK_IMPORTED_MODULE_12__src_touch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_touches__ = __webpack_require__(1211);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "touches", function() { return __WEBPACK_IMPORTED_MODULE_13__src_touches__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_window__ = __webpack_require__(237);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "window", function() { return __WEBPACK_IMPORTED_MODULE_14__src_window__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_selection_on__ = __webpack_require__(234);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "event", function() { return __WEBPACK_IMPORTED_MODULE_15__src_selection_on__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "customEvent", function() { return __WEBPACK_IMPORTED_MODULE_15__src_selection_on__["a"]; });


















/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__namespaces__ = __webpack_require__(232);



function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === __WEBPACK_IMPORTED_MODULE_1__namespaces__["b" /* xhtml */] && document.documentElement.namespaceURI === __WEBPACK_IMPORTED_MODULE_1__namespaces__["b" /* xhtml */]
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
});


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespaces__ = __webpack_require__(232);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return __WEBPACK_IMPORTED_MODULE_0__namespaces__["a" /* default */].hasOwnProperty(prefix) ? {space: __WEBPACK_IMPORTED_MODULE_0__namespaces__["a" /* default */][prefix], local: name} : name;
});


/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return xhtml; });
var xhtml = "http://www.w3.org/1999/xhtml";

/* harmony default export */ __webpack_exports__["a"] = ({
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
});


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_on__ = __webpack_require__(234);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var current = __WEBPACK_IMPORTED_MODULE_0__selection_on__["c" /* event */], source;
  while (source = current.sourceEvent) current = source;
  return current;
});


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return event; });
/* harmony export (immutable) */ __webpack_exports__["a"] = customEvent;
var filterEvents = {};

var event = null;

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!("onmouseenter" in element)) {
    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
  }
}

function filterContextListener(listener, index, group) {
  listener = contextListener(listener, index, group);
  return function(event) {
    var related = event.relatedTarget;
    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
      listener.call(this, event);
    }
  };
}

function contextListener(listener, index, group) {
  return function(event1) {
    var event0 = event; // Events can be reentrant (e.g., focus).
    event = event1;
    try {
      listener.call(this, this.__data__, index, group);
    } finally {
      event = event0;
    }
  };
}

function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, capture) {
  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
  return function(d, i, group) {
    var on = this.__on, o, listener = wrap(value, i, group);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, capture);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

/* harmony default export */ __webpack_exports__["b"] = (function(typename, value, capture) {
  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  if (capture == null) capture = false;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
  return this;
});

function customEvent(event1, listener, that, args) {
  var event0 = event;
  event1.sourceEvent = event;
  event = event1;
  try {
    return listener.apply(that, args);
  } finally {
    event = event0;
  }
}


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node, event) {
  var svg = node.ownerSVGElement || node;

  if (svg.createSVGPoint) {
    var point = svg.createSVGPoint();
    point.x = event.clientX, point.y = event.clientY;
    point = point.matrixTransform(node.getScreenCTM().inverse());
    return [point.x, point.y];
  }

  var rect = node.getBoundingClientRect();
  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
});


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function none() {}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
});


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
});


/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = RedBlackNode;
function RedBlackTree() {
  this._ = null; // root node
}

function RedBlackNode(node) {
  node.U = // parent node
  node.C = // color - true for red, false for black
  node.L = // left node
  node.R = // right node
  node.P = // previous node
  node.N = null; // next node
}

RedBlackTree.prototype = {
  constructor: RedBlackTree,

  insert: function(after, node) {
    var parent, grandpa, uncle;

    if (after) {
      node.P = after;
      node.N = after.N;
      if (after.N) after.N.P = node;
      after.N = node;
      if (after.R) {
        after = after.R;
        while (after.L) after = after.L;
        after.L = node;
      } else {
        after.R = node;
      }
      parent = after;
    } else if (this._) {
      after = RedBlackFirst(this._);
      node.P = null;
      node.N = after;
      after.P = after.L = node;
      parent = after;
    } else {
      node.P = node.N = null;
      this._ = node;
      parent = null;
    }
    node.L = node.R = null;
    node.U = parent;
    node.C = true;

    after = node;
    while (parent && parent.C) {
      grandpa = parent.U;
      if (parent === grandpa.L) {
        uncle = grandpa.R;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.R) {
            RedBlackRotateLeft(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateRight(this, grandpa);
        }
      } else {
        uncle = grandpa.L;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.L) {
            RedBlackRotateRight(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateLeft(this, grandpa);
        }
      }
      parent = after.U;
    }
    this._.C = false;
  },

  remove: function(node) {
    if (node.N) node.N.P = node.P;
    if (node.P) node.P.N = node.N;
    node.N = node.P = null;

    var parent = node.U,
        sibling,
        left = node.L,
        right = node.R,
        next,
        red;

    if (!left) next = right;
    else if (!right) next = left;
    else next = RedBlackFirst(right);

    if (parent) {
      if (parent.L === node) parent.L = next;
      else parent.R = next;
    } else {
      this._ = next;
    }

    if (left && right) {
      red = next.C;
      next.C = node.C;
      next.L = left;
      left.U = next;
      if (next !== right) {
        parent = next.U;
        next.U = node.U;
        node = next.R;
        parent.L = node;
        next.R = right;
        right.U = next;
      } else {
        next.U = parent;
        parent = next;
        node = next.R;
      }
    } else {
      red = node.C;
      node = next;
    }

    if (node) node.U = parent;
    if (red) return;
    if (node && node.C) { node.C = false; return; }

    do {
      if (node === this._) break;
      if (node === parent.L) {
        sibling = parent.R;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateLeft(this, parent);
          sibling = parent.R;
        }
        if ((sibling.L && sibling.L.C)
            || (sibling.R && sibling.R.C)) {
          if (!sibling.R || !sibling.R.C) {
            sibling.L.C = false;
            sibling.C = true;
            RedBlackRotateRight(this, sibling);
            sibling = parent.R;
          }
          sibling.C = parent.C;
          parent.C = sibling.R.C = false;
          RedBlackRotateLeft(this, parent);
          node = this._;
          break;
        }
      } else {
        sibling = parent.L;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateRight(this, parent);
          sibling = parent.L;
        }
        if ((sibling.L && sibling.L.C)
          || (sibling.R && sibling.R.C)) {
          if (!sibling.L || !sibling.L.C) {
            sibling.R.C = false;
            sibling.C = true;
            RedBlackRotateLeft(this, sibling);
            sibling = parent.L;
          }
          sibling.C = parent.C;
          parent.C = sibling.L.C = false;
          RedBlackRotateRight(this, parent);
          node = this._;
          break;
        }
      }
      sibling.C = true;
      node = parent;
      parent = parent.U;
    } while (!node.C);

    if (node) node.C = false;
  }
};

function RedBlackRotateLeft(tree, node) {
  var p = node,
      q = node.R,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.R = q.L;
  if (p.R) p.R.U = p;
  q.L = p;
}

function RedBlackRotateRight(tree, node) {
  var p = node,
      q = node.L,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.L = q.R;
  if (p.L) p.L.U = p;
  q.R = p;
}

function RedBlackFirst(node) {
  while (node.L) node = node.L;
  return node;
}

/* harmony default export */ __webpack_exports__["b"] = (RedBlackTree);


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = createEdge;
/* harmony export (immutable) */ __webpack_exports__["b"] = createBorderEdge;
/* harmony export (immutable) */ __webpack_exports__["d"] = setEdgeEnd;
/* harmony export (immutable) */ __webpack_exports__["a"] = clipEdges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Diagram__ = __webpack_require__(96);


function createEdge(left, right, v0, v1) {
  var edge = [null, null],
      index = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */].push(edge) - 1;
  edge.left = left;
  edge.right = right;
  if (v0) setEdgeEnd(edge, left, right, v0);
  if (v1) setEdgeEnd(edge, right, left, v1);
  __WEBPACK_IMPORTED_MODULE_0__Diagram__["b" /* cells */][left.index].halfedges.push(index);
  __WEBPACK_IMPORTED_MODULE_0__Diagram__["b" /* cells */][right.index].halfedges.push(index);
  return edge;
}

function createBorderEdge(left, v0, v1) {
  var edge = [v0, v1];
  edge.left = left;
  return edge;
}

function setEdgeEnd(edge, left, right, vertex) {
  if (!edge[0] && !edge[1]) {
    edge[0] = vertex;
    edge.left = left;
    edge.right = right;
  } else if (edge.left === right) {
    edge[1] = vertex;
  } else {
    edge[0] = vertex;
  }
}

// Liang–Barsky line clipping.
function clipEdge(edge, x0, y0, x1, y1) {
  var a = edge[0],
      b = edge[1],
      ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?

  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
  return true;
}

function connectEdge(edge, x0, y0, x1, y1) {
  var v1 = edge[1];
  if (v1) return true;

  var v0 = edge[0],
      left = edge.left,
      right = edge.right,
      lx = left[0],
      ly = left[1],
      rx = right[0],
      ry = right[1],
      fx = (lx + rx) / 2,
      fy = (ly + ry) / 2,
      fm,
      fb;

  if (ry === ly) {
    if (fx < x0 || fx >= x1) return;
    if (lx > rx) {
      if (!v0) v0 = [fx, y0];
      else if (v0[1] >= y1) return;
      v1 = [fx, y1];
    } else {
      if (!v0) v0 = [fx, y1];
      else if (v0[1] < y0) return;
      v1 = [fx, y0];
    }
  } else {
    fm = (lx - rx) / (ry - ly);
    fb = fy - fm * fx;
    if (fm < -1 || fm > 1) {
      if (lx > rx) {
        if (!v0) v0 = [(y0 - fb) / fm, y0];
        else if (v0[1] >= y1) return;
        v1 = [(y1 - fb) / fm, y1];
      } else {
        if (!v0) v0 = [(y1 - fb) / fm, y1];
        else if (v0[1] < y0) return;
        v1 = [(y0 - fb) / fm, y0];
      }
    } else {
      if (ly < ry) {
        if (!v0) v0 = [x0, fm * x0 + fb];
        else if (v0[0] >= x1) return;
        v1 = [x1, fm * x1 + fb];
      } else {
        if (!v0) v0 = [x1, fm * x1 + fb];
        else if (v0[0] < x0) return;
        v1 = [x0, fm * x0 + fb];
      }
    }
  }

  edge[0] = v0;
  edge[1] = v1;
  return true;
}

function clipEdges(x0, y0, x1, y1) {
  var i = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */].length,
      edge;

  while (i--) {
    if (!connectEdge(edge = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */][i], x0, y0, x1, y1)
        || !clipEdge(edge, x0, y0, x1, y1)
        || !(Math.abs(edge[0][0] - edge[1][0]) > __WEBPACK_IMPORTED_MODULE_0__Diagram__["f" /* epsilon */]
            || Math.abs(edge[0][1] - edge[1][1]) > __WEBPACK_IMPORTED_MODULE_0__Diagram__["f" /* epsilon */])) {
      delete __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */][i];
    }
  }
}


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hierarchy;
/* harmony export (immutable) */ __webpack_exports__["b"] = computeHeight;
/* harmony export (immutable) */ __webpack_exports__["a"] = Node;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__count__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eachBefore__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eachAfter__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sum__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sort__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__path__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ancestors__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__descendants__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__leaves__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__links__ = __webpack_require__(1229);












function hierarchy(data, children) {
  var root = new Node(data),
      valued = +data.value && (root.value = data.value),
      node,
      nodes = [root],
      child,
      childs,
      i,
      n;

  if (children == null) children = defaultChildren;

  while (node = nodes.pop()) {
    if (valued) node.value = +node.data.value;
    if ((childs = children(node.data)) && (n = childs.length)) {
      node.children = new Array(n);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new Node(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }

  return root.eachBefore(computeHeight);
}

function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}

function defaultChildren(d) {
  return d.children;
}

function copyData(node) {
  node.data = node.data.data;
}

function computeHeight(node) {
  var height = 0;
  do node.height = height;
  while ((node = node.parent) && (node.height < ++height));
}

function Node(data) {
  this.data = data;
  this.depth =
  this.height = 0;
  this.parent = null;
}

Node.prototype = hierarchy.prototype = {
  constructor: Node,
  count: __WEBPACK_IMPORTED_MODULE_0__count__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_1__each__["a" /* default */],
  eachAfter: __WEBPACK_IMPORTED_MODULE_3__eachAfter__["a" /* default */],
  eachBefore: __WEBPACK_IMPORTED_MODULE_2__eachBefore__["a" /* default */],
  sum: __WEBPACK_IMPORTED_MODULE_4__sum__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_5__sort__["a" /* default */],
  path: __WEBPACK_IMPORTED_MODULE_6__path__["a" /* default */],
  ancestors: __WEBPACK_IMPORTED_MODULE_7__ancestors__["a" /* default */],
  descendants: __WEBPACK_IMPORTED_MODULE_8__descendants__["a" /* default */],
  leaves: __WEBPACK_IMPORTED_MODULE_9__leaves__["a" /* default */],
  links: __WEBPACK_IMPORTED_MODULE_10__links__["a" /* default */],
  copy: node_copy
};


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = optional;
/* harmony export (immutable) */ __webpack_exports__["b"] = required;
function optional(f) {
  return f == null ? null : required(f);
}

function required(f) {
  if (typeof f !== "function") throw new Error;
  return f;
}


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return phi; });
/* harmony export (immutable) */ __webpack_exports__["c"] = squarifyRatio;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(140);



var phi = (1 + Math.sqrt(5)) / 2;

function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [],
      nodes = parent.children,
      row,
      nodeValue,
      i0 = 0,
      i1 = 0,
      n = nodes.length,
      dx, dy,
      value = parent.value,
      sumValue,
      minValue,
      maxValue,
      newRatio,
      minRatio,
      alpha,
      beta;

  while (i0 < n) {
    dx = x1 - x0, dy = y1 - y0;

    // Find the next non-empty node.
    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);

    // Keep adding nodes while the aspect ratio maintains or improves.
    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
      minRatio = newRatio;
    }

    // Position and record the row orientation.
    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
    if (row.dice) Object(__WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    else Object(__WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */])(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }

  return rows;
}

/* harmony default export */ __webpack_exports__["a"] = ((function custom(ratio) {

  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }

  squarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return squarify;
})(phi));


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rectangleEnclosure = exports.circleEnclosure = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactAnnotation = __webpack_require__(48);

var _Annotation = __webpack_require__(57);

var _Annotation2 = _interopRequireDefault(_Annotation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var circleEnclosure = exports.circleEnclosure = function circleEnclosure(_ref) {
  var d = _ref.d,
      i = _ref.i,
      circle = _ref.circle;

  var noteData = _extends({
    dx: 0,
    dy: 0,
    note: { label: d.label },
    connector: { end: "arrow" }
  }, d, {
    coordinates: undefined,
    x: circle.x,
    y: circle.y,
    type: _reactAnnotation.AnnotationCalloutCircle,
    subject: {
      radius: circle.r,
      radiusPadding: d.radiusPadding || 2
    }
  });

  if (noteData.rp) {
    switch (noteData.rp) {
      case "top":
        noteData.dx = 0;
        noteData.dy = -circle.r - noteData.rd;
        break;
      case "bottom":
        noteData.dx = 0;
        noteData.dy = circle.r + noteData.rd;
        break;
      case "left":
        noteData.dx = -circle.r - noteData.rd;
        noteData.dy = 0;
        break;
      default:
        noteData.dx = circle.r + noteData.rd;
        noteData.dy = 0;
    }
  }
  //TODO: Support .ra (setting angle)

  return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: noteData });
};

var rectangleEnclosure = exports.rectangleEnclosure = function rectangleEnclosure(_ref2) {
  var bboxNodes = _ref2.bboxNodes,
      d = _ref2.d,
      i = _ref2.i;
  var _d$padding = d.padding,
      padding = _d$padding === undefined ? 0 : _d$padding;

  var bbox = [[Math.min.apply(Math, _toConsumableArray(bboxNodes.map(function (p) {
    return p.x0;
  }))) - padding, Math.min.apply(Math, _toConsumableArray(bboxNodes.map(function (p) {
    return p.y0;
  }))) - padding], [Math.max.apply(Math, _toConsumableArray(bboxNodes.map(function (p) {
    return p.x1;
  }))) + padding, Math.max.apply(Math, _toConsumableArray(bboxNodes.map(function (p) {
    return p.y1;
  }))) + padding]];

  var noteData = _extends({
    dx: d.dx || -25,
    dy: d.dy || -25,
    note: { label: d.label },
    connector: { end: "arrow" }
  }, d, {
    type: _reactAnnotation.AnnotationCalloutRect,
    x: bbox[0][0],
    y: bbox[0][1],
    subject: {
      width: bbox[1][0] - bbox[0][0],
      height: bbox[1][1] - bbox[0][1]
    }
  });

  return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: noteData });
};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contouring = contouring;
exports.shapeBounds = shapeBounds;

var _d3Contour = __webpack_require__(1240);

var _d3Scale = __webpack_require__(92);

var _polylabel = __webpack_require__(1247);

var _polylabel2 = _interopRequireDefault(_polylabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function contouring(_ref) {
  var areaType = _ref.areaType,
      data = _ref.data,
      finalXExtent = _ref.finalXExtent,
      finalYExtent = _ref.finalYExtent;

  var projectedAreas = [];
  if (!areaType.type) {
    areaType = { type: areaType };
  }

  var _areaType = areaType,
      _areaType$resolution = _areaType.resolution,
      resolution = _areaType$resolution === undefined ? 500 : _areaType$resolution,
      _areaType$thresholds = _areaType.thresholds,
      thresholds = _areaType$thresholds === undefined ? 10 : _areaType$thresholds,
      _areaType$bandwidth = _areaType.bandwidth,
      bandwidth = _areaType$bandwidth === undefined ? 20 : _areaType$bandwidth,
      neighborhood = _areaType.neighborhood;


  var xScale = (0, _d3Scale.scaleLinear)().domain(finalXExtent).rangeRound([0, resolution]).nice();
  var yScale = (0, _d3Scale.scaleLinear)().domain(finalYExtent).rangeRound([resolution, 0]).nice();

  data.forEach(function (contourData) {
    var contourProjectedAreas = (0, _d3Contour.contourDensity)().size([resolution, resolution]).x(function (d) {
      return xScale(d[0]);
    }).y(function (d) {
      return yScale(d[1]);
    }).thresholds(thresholds).bandwidth(bandwidth)(contourData._xyfCoordinates);

    if (neighborhood) {
      contourProjectedAreas = [contourProjectedAreas[0]];
    }

    contourProjectedAreas.forEach(function (area) {
      area.parentArea = contourData;
      area.bounds = [];
      area.coordinates.forEach(function (poly) {
        poly.forEach(function (subpoly, i) {
          poly[i] = subpoly.map(function (coordpair) {
            coordpair = [xScale.invert(coordpair[0]), yScale.invert(coordpair[1])];
            return coordpair;
          });
          //Only push bounds for the main poly, not its interior rings, otherwise you end up labeling interior cutouts
          if (i === 0) {
            area.bounds.push(shapeBounds(poly[i]));
          }
        });
      });
    });
    projectedAreas = [].concat(_toConsumableArray(projectedAreas), _toConsumableArray(contourProjectedAreas));
  });

  return projectedAreas;
}

function shapeBounds(coordinates) {
  var left = [Infinity, 0];
  var right = [-Infinity, 0];
  var top = [0, Infinity];
  var bottom = [0, -Infinity];
  coordinates.forEach(function (d) {
    left = d[0] < left[0] ? d : left;
    right = d[0] > right[0] ? d : right;
    bottom = d[1] > bottom[1] ? d : bottom;
    top = d[1] < top[1] ? d : top;
  });

  return { center: (0, _polylabel2.default)([coordinates]), top: top, left: left, right: right, bottom: bottom };
}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var cleanDates = function cleanDates(value) {
  if (value && value.toJSON) {
    return value.toJSON();
  }
  return value;
};

var xyDownloadMapping = exports.xyDownloadMapping = function xyDownloadMapping(_ref) {
  var data = _ref.data,
      xAccessor = _ref.xAccessor,
      yAccessor = _ref.yAccessor,
      _ref$fields = _ref.fields,
      fields = _ref$fields === undefined ? [] : _ref$fields;

  var csvData = [];
  data.forEach(function (datum) {
    if (Array.isArray(datum)) {
      datum.forEach(function (a) {
        var row = {};
        if (xAccessor) {
          row.x = cleanDates(xAccessor(a));
        } else if (a.x) {
          row.x = a.x;
        }

        if (yAccessor) {
          row.y = cleanDates(yAccessor(a));
        } else if (a.y) {
          row.y = a.y;
        }

        if (datum.id !== undefined) row.id = datum.id;

        if (fields && Array.isArray(fields)) {
          fields.forEach(function (f) {
            row[f] = cleanDates(a[f]);
          });
        }

        csvData.push(row);
      });
    } else {
      var row = {};
      if (xAccessor) {
        row.x = cleanDates(xAccessor(datum));
      } else if (datum.x) {
        row.x = datum.x;
      }

      if (yAccessor) {
        row.y = cleanDates(yAccessor(datum));
      } else if (datum.y) {
        row.y = datum.y;
      }

      if (datum.id !== undefined) {
        row.id = datum.id;
      }

      fields.forEach(function (f) {
        row[f] = datum[f];
      });
      csvData.push(row);
    }
  });
  return csvData;
};

var orDownloadMapping = exports.orDownloadMapping = function orDownloadMapping(_ref2) {
  var data = _ref2.data,
      oAccessor = _ref2.oAccessor,
      rAccessor = _ref2.rAccessor,
      _ref2$fields = _ref2.fields,
      fields = _ref2$fields === undefined ? [] : _ref2$fields;

  var dataKeys = Object.keys(data);
  var csvData = [];

  dataKeys.forEach(function (key) {
    data[key].pieceData.forEach(function (piece) {
      var row = {};
      if (oAccessor) {
        row.column = oAccessor(piece);
      } else if (piece.x) {
        row.column = piece.x;
      }

      if (rAccessor) {
        row.value = rAccessor(piece);
      } else if (piece.renderKey) {
        row.value = piece.renderKey;
      }

      if (piece.id !== undefined) row.id = piece.id;

      fields.forEach(function (f) {
        row[f] = cleanDates(piece[f]);
      });

      csvData.push(row);
    });
  });

  return csvData;
};

var networkNodeDownloadMapping = exports.networkNodeDownloadMapping = function networkNodeDownloadMapping(_ref3) {
  var data = _ref3.data,
      _ref3$fields = _ref3.fields,
      fields = _ref3$fields === undefined ? [] : _ref3$fields;

  var csvData = [];
  data.forEach(function (d) {
    var row = {};
    row.id = d.id;
    fields.forEach(function (f) {
      row[f] = d[f];
    });
    csvData.push(row);
  });
  return csvData;
};

var networkEdgeDownloadMapping = exports.networkEdgeDownloadMapping = function networkEdgeDownloadMapping(_ref4) {
  var data = _ref4.data,
      _ref4$fields = _ref4.fields,
      fields = _ref4$fields === undefined ? [] : _ref4$fields;

  var csvData = [];
  data.forEach(function (d) {
    var row = {};
    row.source = d.source.id;
    row.target = d.target.id;
    fields.forEach(function (f) {
      row[f] = d[f];
    });
    csvData.push(row);
  });

  return csvData;
};

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterDefs = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var filterDefs = exports.filterDefs = function filterDefs(_ref) {
  var matte = _ref.matte,
      key = _ref.key,
      additionalDefs = _ref.additionalDefs;
  return _react2.default.createElement(
    "defs",
    null,
    _react2.default.createElement(
      "filter",
      { id: "paintyFilterHeavy" },
      _react2.default.createElement("feGaussianBlur", {
        id: "gaussblurrer",
        "in": "SourceGraphic",
        stdDeviation: 4,
        colorInterpolationFilters: "sRGB",
        result: "blur"
      }),
      _react2.default.createElement("feColorMatrix", {
        "in": "blur",
        mode: "matrix",
        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 34 -7",
        result: "gooey"
      })
    ),
    _react2.default.createElement(
      "filter",
      { id: "paintyFilterLight" },
      _react2.default.createElement("feGaussianBlur", {
        id: "gaussblurrer",
        "in": "SourceGraphic",
        stdDeviation: 2,
        colorInterpolationFilters: "sRGB",
        result: "blur"
      }),
      _react2.default.createElement("feColorMatrix", {
        "in": "blur",
        mode: "matrix",
        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 34 -7",
        result: "gooey"
      })
    ),
    _react2.default.createElement(
      "clipPath",
      { id: "matte-clip-" + key },
      matte
    ),
    additionalDefs
  );
};

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//size is a special case and handled checking the actual values in the size array

var xyFrameChangeProps = exports.xyFrameChangeProps = ["name", "lines", "points", "areas", "title", "margin", "axes", "position", "xScaleType", "yScaleType", "xExtent", "yExtent", "invertX", "invertY", "xAccessor", "yAccessor", "hoverAnnotation", "lineDataAccessor", "areaDataAccessor", "additionalDefs", "lineType", "showLinePoints", "defined", "lineStyle", "pointStyle", "areaStyle", "lineClass", "pointClass", "areaClass", "canvasPoints", "customPointMark", "customLineMark", "lineIDAccessor"];

var orFrameChangeProps = exports.orFrameChangeProps = ["data", "name", "orient", "title", "margin", "format", "position", "oScaleType", "rScaleType", "oExtent", "rExtent", "invertO", "invertR", "oAccessor", "rAccessor", "oPadding", "projection", "type", "summaryType", "connectorType", "className", "additionalDefs", "renderKey", "dataAccessor", "rBaseline", "sortO", "dynamicColumnWidth", "renderFn", "style", "connectorStyle", "summaryStyle", "summaryPosition", "oLabel", "axis"];

var networkFrameChangeProps = exports.networkFrameChangeProps = ["name", "nodes", "edges", "title", "margin", "position", "nodeIDAccessor", "sourceAccessor", "targetAccessor", "nodeSizeAccessor", "customNodeIcon", "nodeLabels", "edgeWidthAccessor", "networkType", "className", "additionalDefs", "renderFn", "nodeStyle", "edgeStyle", "edgeType"];

/*
const xyFrameOtherProps = [
  "matte",
  "tooltipContent",
  "interaction",
  "annotations",
  "svgAnnotationRules",
  "htmlAnnotationRules",
  "customHoverBehavior",
  "customClickBehavior",
  "customDoubleclickBehavior",
  "backgroundGraphics",
  "foregroundGraphics",
  "download",
  "downloadFields"
]

const orFrameOtherProps = [
  "annotations",
  "htmlAnnotationRules",
  "tooltipContent",
  "interaction",
  "customHoverBehavior",
  "customClickBehavior",
  "svgAnnotationRules",
  "hoverAnnotation",
  "backgroundGraphics",
  "foregroundGraphics"
]

const networkFrameOtherProps = [
  "annotations",
  "htmlAnnotationRules",
  "tooltipContent",
  "interaction",
  "customHoverBehavior",
  "customClickBehavior",
  "customDoubleClickBehavior",
  "svgAnnotationRules",
  "hoverAnnotation",
  "backgroundGraphics",
  "foregroundGraphics"
]
*/

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return (Math.random() - 0.5) * 1e-6;
});


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _XYFrame = __webpack_require__(61);

var _XYFrame2 = _interopRequireDefault(_XYFrame);

var _OrdinalFrame = __webpack_require__(144);

var _OrdinalFrame2 = _interopRequireDefault(_OrdinalFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
  if (props.frameType === "orFrame") {
    return _react2.default.createElement(_OrdinalFrame2.default, _extends({}, props, {
      oAccessor: props.xAccessor,
      rAccessor: props.yAccessor,
      data: props.pieceData,
      groupData: props.aggData,
      groupDataAccessor: props.aggDataAccessor,
      dataAccessor: props.pieceDataAccessor,
      groupType: props.customAggType,
      groupStyle: props.aggStyle,
      style: props.pieceStyle,
      type: props.customPieceType
    }));
  }
  return _react2.default.createElement(_XYFrame2.default, _extends({}, props, {
    points: props.pieceData,
    lines: props.aggData,
    lineDataAccessor: props.aggDataAccessor,
    pointDataAccessor: props.pieceDataAccessor,
    lineType: props.customAggType,
    lineStyle: props.aggStyle,
    pointStyle: props.pieceStyle
  }));
};

module.exports = exports['default'];

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _XYFrame = __webpack_require__(61);

var _XYFrame2 = _interopRequireDefault(_XYFrame);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// components

var MiniMap = function MiniMap(props) {
  var interactivity = {
    start: props.brushStart,
    during: props.brush,
    end: props.brushEnd
  };

  if (props.xBrushable && props.yBrushable) {
    interactivity.brush = "xyBrush";

    if (props.xBrushExtent || props.yBrushExtent) {
      interactivity.extent = [[0, 0], [].concat(_toConsumableArray(props.size))];
    }
    if (props.xBrushExtent) {
      interactivity.extent[0] = props.xBrushExtent;
    }
    if (props.yBrushExtent) {
      interactivity.extent[1] = props.yBrushExtent;
    }
  } else if (props.xBrushable) {
    interactivity.brush = "xBrush";
    if (props.xBrushExtent) {
      interactivity.extent = props.xBrushExtent;
    }
  } else if (props.yBrushable) {
    interactivity.brush = "yBrush";
    if (props.yBrushExtent) {
      interactivity.extent = props.yBrushExtent;
    }
  }

  return _react2.default.createElement(_XYFrame2.default, _extends({}, props, { interaction: interactivity }));
};

MiniMap.propTypes = {
  brushStart: _propTypes2.default.func,
  brush: _propTypes2.default.func,
  brushEnd: _propTypes2.default.func,
  xBrushExtent: _propTypes2.default.array,
  yBrushExtent: _propTypes2.default.array,
  xBrushable: _propTypes2.default.bool,
  yBrushable: _propTypes2.default.bool
};

exports.default = MiniMap;
module.exports = exports['default'];

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node, x0, y0, x1, y1) {
  this.node = node;
  this.x0 = x0;
  this.y0 = y0;
  this.x1 = x1;
  this.y1 = y1;
});


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var colorMap={coal:"#282827",//Coal
petroleum:"#7DAAA7",//Petroleum
naturalGas:"#F9BD15",//Natural Gas
otherGas:"#F04B31",//Other Gases
nuclear:"#D385AA",//Nuclear
hydroPumped:"#3F87A6",//Hydroelectric Pumped Storage
hydroConventional:"#3F87A6",//Conventional Hydroelectric Power
wood:"#B15A28",//Wood
waste:"#938373",//Waste
geothermal:"#426B45",//Geothermal
solar:"#F58020",//Solar
wind:"#8DC179"//Wind
};/* harmony default export */ __webpack_exports__["a"] = (colorMap);

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(484);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(489);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return areaRingSum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return areaStream; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stream__ = __webpack_require__(40);





var areaRingSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])();

var areaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lambda00,
    phi00,
    lambda0,
    cosPhi0,
    sinPhi0;

var areaStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: function() {
    areaRingSum.reset();
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    var areaRing = +areaRingSum;
    areaSum.add(areaRing < 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
  },
  sphere: function() {
    areaSum.add(__WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */]);
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaRingEnd() {
  areaPoint(lambda00, phi00);
}

function areaPointFirst(lambda, phi) {
  areaStream.point = areaPoint;
  lambda00 = lambda, phi00 = phi;
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  lambda0 = lambda, cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi = phi / 2 + __WEBPACK_IMPORTED_MODULE_1__math__["q" /* quarterPi */]), sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi);
}

function areaPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  phi = phi / 2 + __WEBPACK_IMPORTED_MODULE_1__math__["q" /* quarterPi */]; // half the angular distance from south pole

  // Spherical excess E for a spherical triangle with vertices: south pole,
  // previous point, current point.  Uses a formula derived from Cagnoli’s
  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
  var dLambda = lambda - lambda0,
      sdLambda = dLambda >= 0 ? 1 : -1,
      adLambda = sdLambda * dLambda,
      cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
      sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
      k = sinPhi0 * sinPhi,
      u = cosPhi0 * cosPhi + k * Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(adLambda),
      v = k * sdLambda * Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(adLambda);
  areaRingSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(v, u));

  // Advance the previous points.
  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(object) {
  areaSum.reset();
  Object(__WEBPACK_IMPORTED_MODULE_3__stream__["a" /* default */])(object, areaStream);
  return areaSum * 2;
});


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = circleStream;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rotation__ = __webpack_require__(100);





// Generates a circle centered at [0°, 0°], with a given radius and precision.
function circleStream(stream, radius, delta, direction, t0, t1) {
  if (!delta) return;
  var cosRadius = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(radius),
      sinRadius = Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(radius),
      step = direction * delta;
  if (t0 == null) {
    t0 = radius + direction * __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */];
    t1 = radius - step / 2;
  } else {
    t0 = circleRadius(cosRadius, t0);
    t1 = circleRadius(cosRadius, t1);
    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */];
  }
  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
    point = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" /* spherical */])([cosRadius, -sinRadius * Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(t), -sinRadius * Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(t)]);
    stream.point(point[0], point[1]);
  }
}

// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
  point = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(point), point[0] -= cosRadius;
  Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["e" /* cartesianNormalizeInPlace */])(point);
  var radius = Object(__WEBPACK_IMPORTED_MODULE_2__math__["b" /* acos */])(-point[1]);
  return ((-point[2] < 0 ? -radius : radius) + __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */]) % __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */];
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  var center = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([0, 0]),
      radius = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(90),
      precision = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(6),
      ring,
      rotate,
      stream = {point: point};

  function point(x, y) {
    ring.push(x = rotate(x, y));
    x[0] *= __WEBPACK_IMPORTED_MODULE_2__math__["h" /* degrees */], x[1] *= __WEBPACK_IMPORTED_MODULE_2__math__["h" /* degrees */];
  }

  function circle() {
    var c = center.apply(this, arguments),
        r = radius.apply(this, arguments) * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */],
        p = precision.apply(this, arguments) * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */];
    ring = [];
    rotate = Object(__WEBPACK_IMPORTED_MODULE_3__rotation__["b" /* rotateRadians */])(-c[0] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */], -c[1] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */], 0).invert;
    circleStream(stream, r, p, 1);
    c = {type: "Polygon", coordinates: [ring]};
    ring = rotate = null;
    return c;
  }

  circle.center = function(_) {
    return arguments.length ? (center = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([+_[0], +_[1]]), circle) : center;
  };

  circle.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), circle) : radius;
  };

  circle.precision = function(_) {
    return arguments.length ? (precision = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), circle) : precision;
  };

  return circle;
});


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {

  function compose(x, y) {
    return x = a(x, y), b(x[0], x[1]);
  }

  if (a.invert && b.invert) compose.invert = function(x, y) {
    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
  };

  return compose;
});


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(
  function() { return true; },
  clipAntimeridianLine,
  clipAntimeridianInterpolate,
  [-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], -__WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */]]
));

// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
  var lambda0 = NaN,
      phi0 = NaN,
      sign0 = NaN,
      clean; // no intersections

  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda1, phi1) {
      var sign1 = lambda1 > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */],
          delta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda1 - lambda0);
      if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta - __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */]) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) { // line crosses a pole
        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */]);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        stream.point(lambda1, phi0);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */]) { // line crosses antimeridian
        if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda0 - sign0) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) lambda0 -= sign0 * __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]; // handle degeneracies
        if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda1 - sign1) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) lambda1 -= sign1 * __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */];
        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        clean = 0;
      }
      stream.point(lambda0 = lambda1, phi0 = phi1);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda0 = phi0 = NaN;
    },
    clean: function() {
      return 2 - clean; // if intersections, rejoin first and last segments
    }
  };
}

function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
  var cosPhi0,
      cosPhi1,
      sinLambda0Lambda1 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda0 - lambda1);
  return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(sinLambda0Lambda1) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]
      ? Object(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* atan */])((Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi0) * (cosPhi1 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi1)) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda1)
          - Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi1) * (cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi0)) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda0))
          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
      : (phi0 + phi1) / 2;
}

function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi;
  if (from == null) {
    phi = direction * __WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */];
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], phi);
    stream.point(0, phi);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], phi);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], 0);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], -phi);
    stream.point(0, -phi);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], -phi);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], 0);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], phi);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(from[0] - to[0]) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) {
    var lambda = from[0] < to[0] ? __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */];
    phi = direction * lambda / 2;
    stream.point(-lambda, phi);
    stream.point(0, phi);
    stream.point(lambda, phi);
  } else {
    stream.point(to[0], to[1]);
  }
}


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buffer__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rejoin__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polygonContains__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_array__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["a"] = (function(pointVisible, clipLine, interpolate, start) {
  return function(sink) {
    var line = clipLine(sink),
        ringBuffer = Object(__WEBPACK_IMPORTED_MODULE_0__buffer__["a" /* default */])(),
        ringSink = clipLine(ringBuffer),
        polygonStarted = false,
        polygon,
        segments,
        ring;

    var clip = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        clip.point = pointRing;
        clip.lineStart = ringStart;
        clip.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip.point = point;
        clip.lineStart = lineStart;
        clip.lineEnd = lineEnd;
        segments = Object(__WEBPACK_IMPORTED_MODULE_4_d3_array__["merge"])(segments);
        var startInside = Object(__WEBPACK_IMPORTED_MODULE_3__polygonContains__["a" /* default */])(polygon, start);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          Object(__WEBPACK_IMPORTED_MODULE_1__rejoin__["a" /* default */])(segments, compareIntersection, startInside, interpolate, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };

    function point(lambda, phi) {
      if (pointVisible(lambda, phi)) sink.point(lambda, phi);
    }

    function pointLine(lambda, phi) {
      line.point(lambda, phi);
    }

    function lineStart() {
      clip.point = pointLine;
      line.lineStart();
    }

    function lineEnd() {
      clip.point = point;
      line.lineEnd();
    }

    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      ringSink.point(lambda, phi);
    }

    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }

    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();

      var clean = ringSink.clean(),
          ringSegments = ringBuffer.result(),
          i, n = ringSegments.length, m,
          segment,
          point;

      ring.pop();
      polygon.push(ring);
      ring = null;

      if (!n) return;

      // No intersections.
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
          sink.lineEnd();
        }
        return;
      }

      // Rejoin connected segments.
      // TODO reuse ringBuffer.rejoin()?
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));

      segments.push(ringSegments.filter(validSegment));
    }

    return clip;
  };
});

function validSegment(segment) {
  return segment.length > 1;
}

// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] : __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - a[1])
       - ((b = b.x)[0] < 0 ? b[1] - __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] : __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - b[1]);
}


/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(31);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var lines = [],
      line;
  return {
    point: function(x, y) {
      line.push([x, y]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
    rejoin: function() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
});


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pointEqual__ = __webpack_require__(263);


function Intersection(point, points, other, entry) {
  this.x = point;
  this.z = points;
  this.o = other; // another intersection
  this.e = entry; // is an entry?
  this.v = false; // visited
  this.n = this.p = null; // next & previous
}

// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
/* harmony default export */ __webpack_exports__["a"] = (function(segments, compareIntersection, startInside, interpolate, stream) {
  var subject = [],
      clip = [],
      i,
      n;

  segments.forEach(function(segment) {
    if ((n = segment.length - 1) <= 0) return;
    var n, p0 = segment[0], p1 = segment[n], x;

    // If the first and last points of a segment are coincident, then treat as a
    // closed ring. TODO if all rings are closed, then the winding order of the
    // exterior ring should be checked.
    if (Object(__WEBPACK_IMPORTED_MODULE_0__pointEqual__["a" /* default */])(p0, p1)) {
      stream.lineStart();
      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
      stream.lineEnd();
      return;
    }

    subject.push(x = new Intersection(p0, segment, null, true));
    clip.push(x.o = new Intersection(p0, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip.push(x.o = new Intersection(p1, null, x, true));
  });

  if (!subject.length) return;

  clip.sort(compareIntersection);
  link(subject);
  link(clip);

  for (i = 0, n = clip.length; i < n; ++i) {
    clip[i].e = startInside = !startInside;
  }

  var start = subject[0],
      points,
      point;

  while (1) {
    // Find first unvisited intersection.
    var current = start,
        isSubject = true;
    while (current.v) if ((current = current.n) === start) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
});

function link(array) {
  if (!(n = array.length)) return;
  var n,
      i = 0,
      a = array[0],
      b;
  while (++i < n) {
    a.n = b = array[i];
    b.p = a;
    a = b;
  }
  a.n = b = array[0];
  b.p = a;
}


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(4);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(a[0] - b[0]) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] && Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(a[1] - b[1]) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */];
});


/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(4);




var sum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (function(polygon, point) {
  var lambda = point[0],
      phi = point[1],
      normal = [Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(lambda), -Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(lambda), 0],
      angle = 0,
      winding = 0;

  sum.reset();

  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring = polygon[i]).length)) continue;
    var ring,
        m,
        point0 = ring[m - 1],
        lambda0 = point0[0],
        phi0 = point0[1] / 2 + __WEBPACK_IMPORTED_MODULE_2__math__["q" /* quarterPi */],
        sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(phi0),
        cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(phi0);

    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
      var point1 = ring[j],
          lambda1 = point1[0],
          phi1 = point1[1] / 2 + __WEBPACK_IMPORTED_MODULE_2__math__["q" /* quarterPi */],
          sinPhi1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(phi1),
          cosPhi1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(phi1),
          delta = lambda1 - lambda0,
          sign = delta >= 0 ? 1 : -1,
          absDelta = sign * delta,
          antimeridian = absDelta > __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */],
          k = sinPhi0 * sinPhi1;

      sum.add(Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* atan2 */])(k * sign * Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(absDelta), cosPhi0 * cosPhi1 + k * Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(absDelta)));
      angle += antimeridian ? delta + sign * __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */] : delta;

      // Are the longitudes either side of the point’s meridian (lambda),
      // and are the latitudes smaller than the parallel (phi)?
      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
        var arc = Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["c" /* cartesianCross */])(Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["a" /* cartesian */])(point0), Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["a" /* cartesian */])(point1));
        Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["e" /* cartesianNormalizeInPlace */])(arc);
        var intersection = Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["c" /* cartesianCross */])(normal, arc);
        Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["e" /* cartesianNormalizeInPlace */])(intersection);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(intersection[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }

  // First, determine whether the South pole is inside or outside:
  //
  // It is inside if:
  // * the polygon winds around it in a clockwise direction.
  // * the polygon does not (cumulatively) wind around it, but has a negative
  //   (counter-clockwise) area.
  //
  // Second, count the (signed) number of times a segment crosses a lambda
  // from the point to the South pole.  If it is zero, then the point is the
  // same side as the South pole.

  return (angle < -__WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] || angle < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] && sum < -__WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */]) ^ (winding & 1);
});


/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bisectRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bisectLeft; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(266);



var ascendingBisect = Object(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["c"] = (bisectRight);


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(52);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}


/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = pair;
/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}


/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(269);


/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  var v = Object(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(64);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});


/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});


/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;


/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tickIncrement;
/* harmony export (immutable) */ __webpack_exports__["c"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});


/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(275);


/* harmony default export */ __webpack_exports__["a"] = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = Object(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__circle__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pointEqual__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(260);






/* harmony default export */ __webpack_exports__["a"] = (function(radius) {
  var cr = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(radius),
      delta = 6 * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */],
      smallRadius = cr > 0,
      notHemisphere = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(cr) > __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */]; // TODO optimise for this common case

  function interpolate(from, to, direction, stream) {
    Object(__WEBPACK_IMPORTED_MODULE_1__circle__["a" /* circleStream */])(stream, radius, delta, direction, from, to);
  }

  function visible(lambda, phi) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(lambda) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(phi) > cr;
  }

  // Takes a line and cuts into visible segments. Return values used for polygon
  // clipping: 0 - there were intersections or the line was empty; 1 - no
  // intersections 2 - there were intersections, and the first and last segments
  // should be rejoined.
  function clipLine(stream) {
    var point0, // previous point
        c0, // code for previous point
        v0, // visibility of previous point
        v00, // visibility of first point
        clean; // no intersections
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi) {
        var point1 = [lambda, phi],
            point2,
            v = visible(lambda, phi),
            c = smallRadius
              ? v ? 0 : code(lambda, phi)
              : v ? code(lambda + (lambda < 0 ? __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */] : -__WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */]), phi) : 0;
        if (!point0 && (v00 = v0 = v)) stream.lineStart();
        // Handle degeneracies.
        // TODO ignore if not clipping polygons.
        if (v !== v0) {
          point2 = intersect(point0, point1);
          if (!point2 || Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point0, point2) || Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point1, point2)) {
            point1[0] += __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];
            point1[1] += __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];
            v = visible(point1[0], point1[1]);
          }
        }
        if (v !== v0) {
          clean = 0;
          if (v) {
            // outside going in
            stream.lineStart();
            point2 = intersect(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            // inside going out
            point2 = intersect(point0, point1);
            stream.point(point2[0], point2[1]);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          // If the codes for two points are different, or are both zero,
          // and there this segment intersects with the small circle.
          if (!(c & c0) && (t = intersect(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
            }
          }
        }
        if (v && (!point0 || !Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c;
      },
      lineEnd: function() {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | ((v00 && v0) << 1);
      }
    };
  }

  // Intersects the great circle between a and b with the clip circle.
  function intersect(a, b, two) {
    var pa = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(a),
        pb = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(b);

    // We have two planes, n1.p = d1 and n2.p = d2.
    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
    var n1 = [1, 0, 0], // normal
        n2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianCross */])(pa, pb),
        n2n2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(n2, n2),
        n1n2 = n2[0], // cartesianDot(n1, n2),
        determinant = n2n2 - n1n2 * n1n2;

    // Two polar points.
    if (!determinant) return !two && a;

    var c1 =  cr * n2n2 / determinant,
        c2 = -cr * n1n2 / determinant,
        n1xn2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianCross */])(n1, n2),
        A = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(n1, c1),
        B = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(n2, c2);
    Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianAddInPlace */])(A, B);

    // Solve |p(t)|^2 = 1.
    var u = n1xn2,
        w = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(A, u),
        uu = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(u, u),
        t2 = w * w - uu * (Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(A, A) - 1);

    if (t2 < 0) return;

    var t = Object(__WEBPACK_IMPORTED_MODULE_2__math__["u" /* sqrt */])(t2),
        q = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(u, (-w - t) / uu);
    Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianAddInPlace */])(q, A);
    q = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" /* spherical */])(q);

    if (!two) return q;

    // Two intersection points.
    var lambda0 = a[0],
        lambda1 = b[0],
        phi0 = a[1],
        phi1 = b[1],
        z;

    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;

    var delta = lambda1 - lambda0,
        polar = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(delta - __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */]) < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */],
        meridian = polar || delta < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];

    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;

    // Check that the first point is between a and b.
    if (meridian
        ? polar
          ? phi0 + phi1 > 0 ^ q[1] < (Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(q[0] - lambda0) < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] ? phi0 : phi1)
          : phi0 <= q[1] && q[1] <= phi1
        : delta > __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */] ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
      var q1 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(u, (-w + t) / uu);
      Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianAddInPlace */])(q1, A);
      return [q, Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" /* spherical */])(q1)];
    }
  }

  // Generates a 4-bit vector representing the location of a point relative to
  // the small circle's bounding box.
  function code(lambda, phi) {
    var r = smallRadius ? radius : __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */] - radius,
        code = 0;
    if (lambda < -r) code |= 1; // left
    else if (lambda > r) code |= 2; // right
    if (phi < -r) code |= 4; // below
    else if (phi > r) code |= 8; // above
    return code;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */])(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-__WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */], radius - __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */]]);
});


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__length__ = __webpack_require__(279);


var coordinates = [null, null],
    object = {type: "LineString", coordinates: coordinates};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  coordinates[0] = a;
  coordinates[1] = b;
  return Object(__WEBPACK_IMPORTED_MODULE_0__length__["a" /* default */])(object);
});


/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stream__ = __webpack_require__(40);





var lengthSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lambda0,
    sinPhi0,
    cosPhi0;

var lengthStream = {
  sphere: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: lengthLineStart,
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */]
};

function lengthLineStart() {
  lengthStream.point = lengthPointFirst;
  lengthStream.lineEnd = lengthLineEnd;
}

function lengthLineEnd() {
  lengthStream.point = lengthStream.lineEnd = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
}

function lengthPointFirst(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  lambda0 = lambda, sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi), cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi);
  lengthStream.point = lengthPoint;
}

function lengthPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  var sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
      cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
      delta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda - lambda0),
      cosDelta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(delta),
      sinDelta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(delta),
      x = cosPhi * sinDelta,
      y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta,
      z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
  lengthSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* sqrt */])(x * x + y * y), z));
  lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
}

/* harmony default export */ __webpack_exports__["a"] = (function(object) {
  lengthSum.reset();
  Object(__WEBPACK_IMPORTED_MODULE_3__stream__["a" /* default */])(object, lengthStream);
  return +lengthSum;
});


/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(31);


var x0 = Infinity,
    y0 = x0,
    x1 = -x0,
    y1 = x1;

var boundsStream = {
  point: boundsPoint,
  lineStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  polygonStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  polygonEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  result: function() {
    var bounds = [[x0, y0], [x1, y1]];
    x1 = y1 = -(y0 = x0 = Infinity);
    return bounds;
  }
};

function boundsPoint(x, y) {
  if (x < x0) x0 = x;
  if (x > x1) x1 = x;
  if (y < y0) y0 = y;
  if (y > y1) y1 = y;
}

/* harmony default export */ __webpack_exports__["a"] = (boundsStream);


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conicEqualArea__ = __webpack_require__(149);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__conicEqualArea__["a" /* default */])()
      .parallels([29.5, 45.5])
      .scale(1070)
      .translate([480, 250])
      .rotate([96, 0])
      .center([-0.6, 38.7]);
});


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = equirectangularRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(23);


function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}

equirectangularRaw.invert = equirectangularRaw;

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(equirectangularRaw)
      .scale(152.63);
});


/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = aitoffRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function aitoffRaw(x, y) {
  var cosy = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(y), sincia = Object(__WEBPACK_IMPORTED_MODULE_1__math__["z" /* sinci */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["b" /* acos */])(cosy * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(x /= 2)));
  return [2 * cosy * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(x) * sincia, Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(y) * sincia];
}

// Abort if [x, y] is not within an ellipse centered at [0, 0] with
// semi-major axis pi and semi-minor axis pi/2.
aitoffRaw.invert = function(x, y) {
  if (x * x + 4 * y * y > __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] + __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]) return;
  var x1 = x, y1 = y, i = 25;
  do {
    var sinx = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(x1),
        sinx_2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(x1 / 2),
        cosx_2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(x1 / 2),
        siny = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(y1),
        cosy = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(y1),
        sin_2y = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(2 * y1),
        sin2y = siny * siny,
        cos2y = cosy * cosy,
        sin2x_2 = sinx_2 * sinx_2,
        c = 1 - cos2y * cosx_2 * cosx_2,
        e = c ? Object(__WEBPACK_IMPORTED_MODULE_1__math__["b" /* acos */])(cosy * cosx_2) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(f = 1 / c) : f = 0,
        f,
        fx = 2 * e * cosy * sinx_2 - x,
        fy = e * siny - y,
        dxdx = f * (cos2y * sin2x_2 + e * cosy * cosx_2 * sin2y),
        dxdy = f * (0.5 * sinx * sin_2y - e * 2 * siny * sinx_2),
        dydx = f * 0.25 * (sin_2y * sinx_2 - e * siny * cos2y * sinx),
        dydy = f * (sin2y * cosx_2 + e * sin2x_2 * cosy),
        z = dxdy * dydx - dydy * dxdx;
    if (!z) break;
    var dx = (fy * dxdy - fx * dydy) / z,
        dy = (fx * dydx - fy * dxdx) / z;
    x1 -= dx, y1 -= dy;
  } while ((Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(dx) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(dy) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]) && --i > 0);
  return [x1, y1];
};

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(aitoffRaw)
      .scale(152.63);
});


/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = augustRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function augustRaw(lambda, phi) {
  var tanPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(phi / 2),
      k = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(1 - tanPhi * tanPhi),
      c = 1 + k * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(lambda /= 2),
      x = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(lambda) * k / c,
      y = tanPhi / c,
      x2 = x * x,
      y2 = y * y;
  return [
    4 / 3 * x * (3 + x2 - 3 * y2),
    4 / 3 * y * (3 + 3 * x2 - y2)
  ];
}

augustRaw.invert = function(x, y) {
  x *= 3 / 8, y *= 3 / 8;
  if (!x && Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(y) > 1) return null;
  var x2 = x * x,
      y2 = y * y,
      s = 1 + x2 + y2,
      sin3Eta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])((s - Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(s * s - 4 * y * y)) / 2),
      eta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(sin3Eta) / 3,
      xi = sin3Eta ? Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* arcosh */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(y / sin3Eta)) / 3 : Object(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* arsinh */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(x)) / 3,
      cosEta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(eta),
      coshXi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["i" /* cosh */])(xi),
      d = coshXi * coshXi - cosEta * cosEta;
  return [
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(x) * 2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["A" /* sinh */])(xi) * cosEta, 0.25 - d),
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(y) * 2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(coshXi * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(eta), 0.25 + d)
  ];
};

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(augustRaw)
      .scale(66.1603);
});


/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = boggsRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mollweide__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(1);




var k = 2.00276,
    w = 1.11072;

function boggsRaw(lambda, phi) {
  var theta = Object(__WEBPACK_IMPORTED_MODULE_1__mollweide__["c" /* mollweideBromleyTheta */])(__WEBPACK_IMPORTED_MODULE_2__math__["s" /* pi */], phi);
  return [k * lambda / (1 / Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(phi) + w / Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(theta)), (phi + __WEBPACK_IMPORTED_MODULE_2__math__["D" /* sqrt2 */] * Object(__WEBPACK_IMPORTED_MODULE_2__math__["y" /* sin */])(theta)) / k];
}

boggsRaw.invert = function(x, y) {
  var ky = k * y, theta = y < 0 ? -__WEBPACK_IMPORTED_MODULE_2__math__["u" /* quarterPi */] : __WEBPACK_IMPORTED_MODULE_2__math__["u" /* quarterPi */], i = 25, delta, phi;
  do {
    phi = ky - __WEBPACK_IMPORTED_MODULE_2__math__["D" /* sqrt2 */] * Object(__WEBPACK_IMPORTED_MODULE_2__math__["y" /* sin */])(theta);
    theta -= delta = (Object(__WEBPACK_IMPORTED_MODULE_2__math__["y" /* sin */])(2 * theta) + 2 * theta - __WEBPACK_IMPORTED_MODULE_2__math__["s" /* pi */] * Object(__WEBPACK_IMPORTED_MODULE_2__math__["y" /* sin */])(phi)) / (2 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(2 * theta) + 2 + __WEBPACK_IMPORTED_MODULE_2__math__["s" /* pi */] * Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(phi) * __WEBPACK_IMPORTED_MODULE_2__math__["D" /* sqrt2 */] * Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(theta));
  } while (Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */] && --i > 0);
  phi = ky - __WEBPACK_IMPORTED_MODULE_2__math__["D" /* sqrt2 */] * Object(__WEBPACK_IMPORTED_MODULE_2__math__["y" /* sin */])(theta);
  return [x * (1 / Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(phi) + w / Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(theta)) / k, phi];
};

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(boggsRaw)
      .scale(160.857);
});


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cylindricalEqualAreaRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parallel1__ = __webpack_require__(53);



function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["h" /* cos */])(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, Object(__WEBPACK_IMPORTED_MODULE_0__math__["y" /* sin */])(phi) / cosPhi0];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* asin */])(y * cosPhi0)];
  };

  return forward;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__parallel1__["a" /* default */])(cylindricalEqualAreaRaw)
      .parallel(38.58) // acos(sqrt(width / height / pi)) * radians
      .scale(195.044); // width / (sqrt(width / height / pi) * 2 * pi)
});


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = gringortenRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__square__ = __webpack_require__(288);




function gringortenRaw(lambda, phi) {
  var sLambda = Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(lambda),
      sPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(phi),
      cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi),
      x = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(lambda) * cosPhi,
      y = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(lambda) * cosPhi,
      z = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(sPhi * phi);
  lambda = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(y, z));
  phi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(x);
  if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda - __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]) lambda %= __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */];
  var point = gringortenHexadecant(lambda > __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / 4 ? __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */] - lambda : lambda, phi);
  if (lambda > __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / 4) z = point[0], point[0] = -point[1], point[1] = -z;
  return (point[0] *= sLambda, point[1] *= -sPhi, point);
}

gringortenRaw.invert = function(x, y) {
  var sx = Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(x),
      sy = Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(y),
      x0 = -sx * x,
      y0 = -sy * y,
      t = y0 / x0 < 1,
      p = gringortenHexadecantInvert(t ? y0 : x0, t ? x0 : y0),
      lambda = p[0],
      phi = p[1],
      cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi);
  if (t) lambda = -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */] - lambda;
  return [sx * (Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(lambda) * cosPhi, -Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi)) + __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]), sy * Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(lambda) * cosPhi)];
};

function gringortenHexadecant(lambda, phi) {
  if (phi === __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]) return [0, 0];

  var sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi),
      r = sinPhi * sinPhi,
      r2 = r * r,
      j = 1 + r2,
      k = 1 + 3 * r2,
      q = 1 - r2,
      z = Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(1 / Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(j)),
      v = q + r * j * z,
      p2 = (1 - sinPhi) / v,
      p = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(p2),
      a2 = p2 * j,
      a = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(a2),
      h = p * q,
      x,
      i;

  if (lambda === 0) return [0, -(h + r * a)];

  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi),
      secPhi = 1 / cosPhi,
      drdPhi = 2 * sinPhi * cosPhi,
      dvdPhi = (-3 * r + z * k) * drdPhi,
      dp2dPhi = (-v * cosPhi - (1 - sinPhi) * dvdPhi) / (v * v),
      dpdPhi = (0.5 * dp2dPhi) / p,
      dhdPhi = q * dpdPhi - 2 * r * p * drdPhi,
      dra2dPhi = r * j * dp2dPhi + p2 * k * drdPhi,
      mu = -secPhi * drdPhi,
      nu = -secPhi * dra2dPhi,
      zeta = -2 * secPhi * dhdPhi,
      lambda1 = 4 * lambda / __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */],
      delta;

  // Slower but accurate bisection method.
  if (lambda > 0.222 * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] || phi < __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / 4 && lambda > 0.175 * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]) {
    x = (h + r * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(a2 * (1 + r2) - h * h)) / (1 + r2);
    if (lambda > __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / 4) return [x, x];
    var x1 = x, x0 = 0.5 * x;
    x = 0.5 * (x0 + x1), i = 50;
    do {
      var g = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(a2 - x * x),
          f = (x * (zeta + mu * g) + nu * Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(x / a)) - lambda1;
      if (!f) break;
      if (f < 0) x0 = x;
      else x1 = x;
      x = 0.5 * (x0 + x1);
    } while (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(x1 - x0) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] && --i > 0);
  }

  // Newton-Raphson.
  else {
    x = __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */], i = 25;
    do {
      var x2 = x * x,
          g2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(a2 - x2),
          zetaMug = zeta + mu * g2,
          f2 = x * zetaMug + nu * Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(x / a) - lambda1,
          df = zetaMug + (nu - mu * x2) / g2;
      x -= delta = g2 ? f2 / df : 0;
    } while (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] && --i > 0);
  }

  return [x, -h - r * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(a2 - x * x)];
}

function gringortenHexadecantInvert(x, y) {
  var x0 = 0,
      x1 = 1,
      r = 0.5,
      i = 50;

  while (true) {
    var r2 = r * r,
        sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(r),
        z = Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(1 / Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(1 + r2)),
        v = (1 - r2) + r * (1 + r2) * z,
        p2 = (1 - sinPhi) / v,
        p = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(p2),
        a2 = p2 * (1 + r2),
        h = p * (1 - r2),
        g2 = a2 - x * x,
        g = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(g2),
        y0 = y + h + r * g;
    if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(x1 - x0) < __WEBPACK_IMPORTED_MODULE_1__math__["l" /* epsilon2 */] || --i === 0 || y0 === 0) break;
    if (y0 > 0) x0 = r;
    else x1 = r;
    r = 0.5 * (x0 + x1);
  }

  if (!i) return null;

  var phi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(sinPhi),
      cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi),
      secPhi = 1 / cosPhi,
      drdPhi = 2 * sinPhi * cosPhi,
      dvdPhi = (-3 * r + z * (1 + 3 * r2)) * drdPhi,
      dp2dPhi = (-v * cosPhi - (1 - sinPhi) * dvdPhi) / (v * v),
      dpdPhi = 0.5 * dp2dPhi / p,
      dhdPhi = (1 - r2) * dpdPhi - 2 * r * p * drdPhi,
      zeta = -2 * secPhi * dhdPhi,
      mu = -secPhi * drdPhi,
      nu = -secPhi * (r * (1 + r2) * dp2dPhi + p2 * (1 + 3 * r2) * drdPhi);

  return [__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / 4 * (x * (zeta + mu * g) + nu * Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(x / Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(a2))), phi];
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(Object(__WEBPACK_IMPORTED_MODULE_2__square__["a" /* default */])(gringortenRaw))
      .scale(239.75);
});


/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = (function(project) {
  var dx = project(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* halfPi */], 0)[0] - project(-__WEBPACK_IMPORTED_MODULE_0__math__["o" /* halfPi */], 0)[0];

  function projectSquare(lambda, phi) {
    var s = lambda > 0 ? -0.5 : 0.5,
        point = project(lambda + s * __WEBPACK_IMPORTED_MODULE_0__math__["s" /* pi */], phi);
    point[0] -= s * dx;
    return point;
  }

  if (project.invert) projectSquare.invert = function(x, y) {
    var s = x > 0 ? -0.5 : 0.5,
        location = project.invert(x + s * dx, y),
        lambda = location[0] - s * __WEBPACK_IMPORTED_MODULE_0__math__["s" /* pi */];
    if (lambda < -__WEBPACK_IMPORTED_MODULE_0__math__["s" /* pi */]) lambda += 2 * __WEBPACK_IMPORTED_MODULE_0__math__["s" /* pi */];
    else if (lambda > __WEBPACK_IMPORTED_MODULE_0__math__["s" /* pi */]) lambda -= 2 * __WEBPACK_IMPORTED_MODULE_0__math__["s" /* pi */];
    location[0] = lambda;
    return location;
  };

  return projectSquare;
});


/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = guyouRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elliptic__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__square__ = __webpack_require__(288);





function guyouRaw(lambda, phi) {
  var k_ = (__WEBPACK_IMPORTED_MODULE_2__math__["D" /* sqrt2 */] - 1) / (__WEBPACK_IMPORTED_MODULE_2__math__["D" /* sqrt2 */] + 1),
      k = Object(__WEBPACK_IMPORTED_MODULE_2__math__["B" /* sqrt */])(1 - k_ * k_),
      K = Object(__WEBPACK_IMPORTED_MODULE_1__elliptic__["a" /* ellipticF */])(__WEBPACK_IMPORTED_MODULE_2__math__["o" /* halfPi */], k * k),
      f = -1,
      psi = Object(__WEBPACK_IMPORTED_MODULE_2__math__["p" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["F" /* tan */])(__WEBPACK_IMPORTED_MODULE_2__math__["s" /* pi */] / 4 + Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(phi) / 2)),
      r = Object(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* exp */])(f * psi) / Object(__WEBPACK_IMPORTED_MODULE_2__math__["B" /* sqrt */])(k_),
      at = guyouComplexAtan(r * Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(f * lambda), r * Object(__WEBPACK_IMPORTED_MODULE_2__math__["y" /* sin */])(f * lambda)),
      t = Object(__WEBPACK_IMPORTED_MODULE_1__elliptic__["b" /* ellipticFi */])(at[0], at[1], k * k);
  return [-t[1], (phi >= 0 ? 1 : -1) * (0.5 * K - t[0])];
}

function guyouComplexAtan(x, y) {
  var x2 = x * x,
      y_1 = y + 1,
      t = 1 - x2 - y * y;
  return [
   0.5 * ((x >= 0 ? __WEBPACK_IMPORTED_MODULE_2__math__["o" /* halfPi */] : -__WEBPACK_IMPORTED_MODULE_2__math__["o" /* halfPi */]) - Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* atan2 */])(t, 2 * x)),
    -0.25 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["p" /* log */])(t * t + 4 * x2) +0.5 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["p" /* log */])(y_1 * y_1 + x2)
  ];
}

function guyouComplexDivide(a, b) {
  var denominator = b[0] * b[0] + b[1] * b[1];
  return [
    (a[0] * b[0] + a[1] * b[1]) / denominator,
    (a[1] * b[0] - a[0] * b[1]) / denominator
  ];
}

guyouRaw.invert = function(x, y) {
  var k_ = (__WEBPACK_IMPORTED_MODULE_2__math__["D" /* sqrt2 */] - 1) / (__WEBPACK_IMPORTED_MODULE_2__math__["D" /* sqrt2 */] + 1),
      k = Object(__WEBPACK_IMPORTED_MODULE_2__math__["B" /* sqrt */])(1 - k_ * k_),
      K = Object(__WEBPACK_IMPORTED_MODULE_1__elliptic__["a" /* ellipticF */])(__WEBPACK_IMPORTED_MODULE_2__math__["o" /* halfPi */], k * k),
      f = -1,
      j = Object(__WEBPACK_IMPORTED_MODULE_1__elliptic__["c" /* ellipticJi */])(0.5 * K - y, -x, k * k),
      tn = guyouComplexDivide(j[0], j[1]),
      lambda = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* atan2 */])(tn[1], tn[0]) / f;
  return [
    lambda,
    2 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["f" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* exp */])(0.5 / f * Object(__WEBPACK_IMPORTED_MODULE_2__math__["p" /* log */])(k_ * tn[0] * tn[0] + k_ * tn[1] * tn[1]))) - __WEBPACK_IMPORTED_MODULE_2__math__["o" /* halfPi */]
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(Object(__WEBPACK_IMPORTED_MODULE_3__square__["a" /* default */])(guyouRaw))
      .scale(151.496);
});


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = homolosineRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mollweide__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sinusoidal__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sinuMollweide__ = __webpack_require__(154);






function homolosineRaw(lambda, phi) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(phi) > __WEBPACK_IMPORTED_MODULE_4__sinuMollweide__["b" /* sinuMollweidePhi */]
      ? (lambda = Object(__WEBPACK_IMPORTED_MODULE_2__mollweide__["d" /* mollweideRaw */])(lambda, phi), lambda[1] -= phi > 0 ? __WEBPACK_IMPORTED_MODULE_4__sinuMollweide__["d" /* sinuMollweideY */] : -__WEBPACK_IMPORTED_MODULE_4__sinuMollweide__["d" /* sinuMollweideY */], lambda)
      : Object(__WEBPACK_IMPORTED_MODULE_3__sinusoidal__["b" /* sinusoidalRaw */])(lambda, phi);
}

homolosineRaw.invert = function(x, y) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(y) > __WEBPACK_IMPORTED_MODULE_4__sinuMollweide__["b" /* sinuMollweidePhi */]
      ? __WEBPACK_IMPORTED_MODULE_2__mollweide__["d" /* mollweideRaw */].invert(x, y + (y > 0 ? __WEBPACK_IMPORTED_MODULE_4__sinuMollweide__["d" /* sinuMollweideY */] : -__WEBPACK_IMPORTED_MODULE_4__sinuMollweide__["d" /* sinuMollweideY */]))
      : __WEBPACK_IMPORTED_MODULE_3__sinusoidal__["b" /* sinusoidalRaw */].invert(x, y);
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(homolosineRaw)
      .scale(152.63);
});


/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__guyou__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(156);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__guyou__["b" /* guyouRaw */])
      .scale(111.48);
});


/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



// Compute the origin as the midpoint of the two reference points.
// Rotate one of the reference points by the origin.
// Apply the spherical law of sines to compute gamma rotation.
/* harmony default export */ __webpack_exports__["a"] = (function(raw, p0, p1) {
  var i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["i" /* geoInterpolate */])(p0, p1),
      o = i(0.5),
      a = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["m" /* geoRotation */])([-o[0], -o[1]])(p0),
      b = i.distance / 2,
      y = -Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(a[1] * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */]) / Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(b)),
      R = [-o[0], -o[1], -(a[0] > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] - y : y) * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */]],
      p = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(raw(b)).rotate(R),
      r = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["m" /* geoRotation */])(R),
      center = p.center;

  delete p.rotate;

  p.center = function(_) {
    return arguments.length ? center(r(_)) : r.invert(center());
  };

  return p
      .clipAngle(90);
});


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return areaRingSum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return areaStream; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stream__ = __webpack_require__(43);





var areaRingSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])();

var areaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lambda00,
    phi00,
    lambda0,
    cosPhi0,
    sinPhi0;

var areaStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: function() {
    areaRingSum.reset();
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    var areaRing = +areaRingSum;
    areaSum.add(areaRing < 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */] + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
  },
  sphere: function() {
    areaSum.add(__WEBPACK_IMPORTED_MODULE_1__math__["w" /* tau */]);
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaRingEnd() {
  areaPoint(lambda00, phi00);
}

function areaPointFirst(lambda, phi) {
  areaStream.point = areaPoint;
  lambda00 = lambda, phi00 = phi;
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  lambda0 = lambda, cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi = phi / 2 + __WEBPACK_IMPORTED_MODULE_1__math__["q" /* quarterPi */]), sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi);
}

function areaPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  phi = phi / 2 + __WEBPACK_IMPORTED_MODULE_1__math__["q" /* quarterPi */]; // half the angular distance from south pole

  // Spherical excess E for a spherical triangle with vertices: south pole,
  // previous point, current point.  Uses a formula derived from Cagnoli’s
  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
  var dLambda = lambda - lambda0,
      sdLambda = dLambda >= 0 ? 1 : -1,
      adLambda = sdLambda * dLambda,
      cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
      sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
      k = sinPhi0 * sinPhi,
      u = cosPhi0 * cosPhi + k * Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(adLambda),
      v = k * sdLambda * Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(adLambda);
  areaRingSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(v, u));

  // Advance the previous points.
  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

/* harmony default export */ __webpack_exports__["c"] = (function(object) {
  areaSum.reset();
  Object(__WEBPACK_IMPORTED_MODULE_3__stream__["a" /* default */])(object, areaStream);
  return areaSum * 2;
});


/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = circleStream;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rotation__ = __webpack_require__(105);





// Generates a circle centered at [0°, 0°], with a given radius and precision.
function circleStream(stream, radius, delta, direction, t0, t1) {
  if (!delta) return;
  var cosRadius = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(radius),
      sinRadius = Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(radius),
      step = direction * delta;
  if (t0 == null) {
    t0 = radius + direction * __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */];
    t1 = radius - step / 2;
  } else {
    t0 = circleRadius(cosRadius, t0);
    t1 = circleRadius(cosRadius, t1);
    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */];
  }
  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
    point = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" /* spherical */])([cosRadius, -sinRadius * Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(t), -sinRadius * Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(t)]);
    stream.point(point[0], point[1]);
  }
}

// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
  point = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(point), point[0] -= cosRadius;
  Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["e" /* cartesianNormalizeInPlace */])(point);
  var radius = Object(__WEBPACK_IMPORTED_MODULE_2__math__["b" /* acos */])(-point[1]);
  return ((-point[2] < 0 ? -radius : radius) + __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */]) % __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */];
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  var center = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([0, 0]),
      radius = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(90),
      precision = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(6),
      ring,
      rotate,
      stream = {point: point};

  function point(x, y) {
    ring.push(x = rotate(x, y));
    x[0] *= __WEBPACK_IMPORTED_MODULE_2__math__["h" /* degrees */], x[1] *= __WEBPACK_IMPORTED_MODULE_2__math__["h" /* degrees */];
  }

  function circle() {
    var c = center.apply(this, arguments),
        r = radius.apply(this, arguments) * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */],
        p = precision.apply(this, arguments) * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */];
    ring = [];
    rotate = Object(__WEBPACK_IMPORTED_MODULE_3__rotation__["b" /* rotateRadians */])(-c[0] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */], -c[1] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */], 0).invert;
    circleStream(stream, r, p, 1);
    c = {type: "Polygon", coordinates: [ring]};
    ring = rotate = null;
    return c;
  }

  circle.center = function(_) {
    return arguments.length ? (center = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([+_[0], +_[1]]), circle) : center;
  };

  circle.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), circle) : radius;
  };

  circle.precision = function(_) {
    return arguments.length ? (precision = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), circle) : precision;
  };

  return circle;
});


/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {

  function compose(x, y) {
    return x = a(x, y), b(x[0], x[1]);
  }

  if (a.invert && b.invert) compose.invert = function(x, y) {
    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
  };

  return compose;
});


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(33);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var lines = [],
      line;
  return {
    point: function(x, y) {
      line.push([x, y]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
    rejoin: function() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
});


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pointEqual__ = __webpack_require__(298);


function Intersection(point, points, other, entry) {
  this.x = point;
  this.z = points;
  this.o = other; // another intersection
  this.e = entry; // is an entry?
  this.v = false; // visited
  this.n = this.p = null; // next & previous
}

// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
/* harmony default export */ __webpack_exports__["a"] = (function(segments, compareIntersection, startInside, interpolate, stream) {
  var subject = [],
      clip = [],
      i,
      n;

  segments.forEach(function(segment) {
    if ((n = segment.length - 1) <= 0) return;
    var n, p0 = segment[0], p1 = segment[n], x;

    // If the first and last points of a segment are coincident, then treat as a
    // closed ring. TODO if all rings are closed, then the winding order of the
    // exterior ring should be checked.
    if (Object(__WEBPACK_IMPORTED_MODULE_0__pointEqual__["a" /* default */])(p0, p1)) {
      stream.lineStart();
      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
      stream.lineEnd();
      return;
    }

    subject.push(x = new Intersection(p0, segment, null, true));
    clip.push(x.o = new Intersection(p0, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip.push(x.o = new Intersection(p1, null, x, true));
  });

  if (!subject.length) return;

  clip.sort(compareIntersection);
  link(subject);
  link(clip);

  for (i = 0, n = clip.length; i < n; ++i) {
    clip[i].e = startInside = !startInside;
  }

  var start = subject[0],
      points,
      point;

  while (1) {
    // Find first unvisited intersection.
    var current = start,
        isSubject = true;
    while (current.v) if ((current = current.n) === start) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
});

function link(array) {
  if (!(n = array.length)) return;
  var n,
      i = 0,
      a = array[0],
      b;
  while (++i < n) {
    a.n = b = array[i];
    b.p = a;
    a = b;
  }
  a.n = b = array[0];
  b.p = a;
}


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(a[0] - b[0]) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */] && Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(a[1] - b[1]) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */];
});


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(6);




var sum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (function(polygon, point) {
  var lambda = point[0],
      phi = point[1],
      normal = [Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(lambda), -Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(lambda), 0],
      angle = 0,
      winding = 0;

  sum.reset();

  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring = polygon[i]).length)) continue;
    var ring,
        m,
        point0 = ring[m - 1],
        lambda0 = point0[0],
        phi0 = point0[1] / 2 + __WEBPACK_IMPORTED_MODULE_2__math__["q" /* quarterPi */],
        sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(phi0),
        cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(phi0);

    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
      var point1 = ring[j],
          lambda1 = point1[0],
          phi1 = point1[1] / 2 + __WEBPACK_IMPORTED_MODULE_2__math__["q" /* quarterPi */],
          sinPhi1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(phi1),
          cosPhi1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(phi1),
          delta = lambda1 - lambda0,
          sign = delta >= 0 ? 1 : -1,
          absDelta = sign * delta,
          antimeridian = absDelta > __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */],
          k = sinPhi0 * sinPhi1;

      sum.add(Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* atan2 */])(k * sign * Object(__WEBPACK_IMPORTED_MODULE_2__math__["t" /* sin */])(absDelta), cosPhi0 * cosPhi1 + k * Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(absDelta)));
      angle += antimeridian ? delta + sign * __WEBPACK_IMPORTED_MODULE_2__math__["w" /* tau */] : delta;

      // Are the longitudes either side of the point’s meridian (lambda),
      // and are the latitudes smaller than the parallel (phi)?
      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
        var arc = Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["c" /* cartesianCross */])(Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["a" /* cartesian */])(point0), Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["a" /* cartesian */])(point1));
        Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["e" /* cartesianNormalizeInPlace */])(arc);
        var intersection = Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["c" /* cartesianCross */])(normal, arc);
        Object(__WEBPACK_IMPORTED_MODULE_1__cartesian__["e" /* cartesianNormalizeInPlace */])(intersection);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(intersection[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }

  // First, determine whether the South pole is inside or outside:
  //
  // It is inside if:
  // * the polygon winds around it in a clockwise direction.
  // * the polygon does not (cumulatively) wind around it, but has a negative
  //   (counter-clockwise) area.
  //
  // Second, count the (signed) number of times a segment crosses a lambda
  // from the point to the South pole.  If it is zero, then the point is the
  // same side as the South pole.

  return (angle < -__WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] || angle < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] && sum < -__WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */]) ^ (winding & 1);
});


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__length__ = __webpack_require__(301);


var coordinates = [null, null],
    object = {type: "LineString", coordinates: coordinates};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  coordinates[0] = a;
  coordinates[1] = b;
  return Object(__WEBPACK_IMPORTED_MODULE_0__length__["a" /* default */])(object);
});


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stream__ = __webpack_require__(43);





var lengthSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lambda0,
    sinPhi0,
    cosPhi0;

var lengthStream = {
  sphere: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: lengthLineStart,
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */]
};

function lengthLineStart() {
  lengthStream.point = lengthPointFirst;
  lengthStream.lineEnd = lengthLineEnd;
}

function lengthLineEnd() {
  lengthStream.point = lengthStream.lineEnd = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
}

function lengthPointFirst(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  lambda0 = lambda, sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi), cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi);
  lengthStream.point = lengthPoint;
}

function lengthPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */];
  var sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi),
      cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi),
      delta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda - lambda0),
      cosDelta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(delta),
      sinDelta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(delta),
      x = cosPhi * sinDelta,
      y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta,
      z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
  lengthSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* sqrt */])(x * x + y * y), z));
  lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
}

/* harmony default export */ __webpack_exports__["a"] = (function(object) {
  lengthSum.reset();
  Object(__WEBPACK_IMPORTED_MODULE_3__stream__["a" /* default */])(object, lengthStream);
  return +lengthSum;
});


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(33);


var x0 = Infinity,
    y0 = x0,
    x1 = -x0,
    y1 = x1;

var boundsStream = {
  point: boundsPoint,
  lineStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  polygonStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  polygonEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  result: function() {
    var bounds = [[x0, y0], [x1, y1]];
    x1 = y1 = -(y0 = x0 = Infinity);
    return bounds;
  }
};

function boundsPoint(x, y) {
  if (x < x0) x0 = x;
  if (x > x1) x1 = x;
  if (y < y0) y0 = y;
  if (y > y1) y1 = y;
}

/* harmony default export */ __webpack_exports__["a"] = (boundsStream);


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conicEqualArea__ = __webpack_require__(159);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__conicEqualArea__["b" /* default */])()
      .parallels([29.5, 45.5])
      .scale(1070)
      .translate([480, 250])
      .rotate([96, 0])
      .center([-0.6, 38.7]);
});


/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buffer__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polygon__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polygonContains__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_array__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["a"] = (function(pointVisible, clipLine, interpolate, start) {
  return function(rotate, sink) {
    var line = clipLine(sink),
        rotatedStart = rotate.invert(start[0], start[1]),
        ringBuffer = Object(__WEBPACK_IMPORTED_MODULE_0__buffer__["a" /* default */])(),
        ringSink = clipLine(ringBuffer),
        polygonStarted = false,
        polygon,
        segments,
        ring;

    var clip = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        clip.point = pointRing;
        clip.lineStart = ringStart;
        clip.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip.point = point;
        clip.lineStart = lineStart;
        clip.lineEnd = lineEnd;
        segments = Object(__WEBPACK_IMPORTED_MODULE_4_d3_array__["merge"])(segments);
        var startInside = Object(__WEBPACK_IMPORTED_MODULE_3__polygonContains__["a" /* default */])(polygon, rotatedStart);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          Object(__WEBPACK_IMPORTED_MODULE_1__polygon__["a" /* default */])(segments, compareIntersection, startInside, interpolate, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };

    function point(lambda, phi) {
      var point = rotate(lambda, phi);
      if (pointVisible(lambda = point[0], phi = point[1])) sink.point(lambda, phi);
    }

    function pointLine(lambda, phi) {
      var point = rotate(lambda, phi);
      line.point(point[0], point[1]);
    }

    function lineStart() {
      clip.point = pointLine;
      line.lineStart();
    }

    function lineEnd() {
      clip.point = point;
      line.lineEnd();
    }

    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      var point = rotate(lambda, phi);
      ringSink.point(point[0], point[1]);
    }

    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }

    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();

      var clean = ringSink.clean(),
          ringSegments = ringBuffer.result(),
          i, n = ringSegments.length, m,
          segment,
          point;

      ring.pop();
      polygon.push(ring);
      ring = null;

      if (!n) return;

      // No intersections.
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
          sink.lineEnd();
        }
        return;
      }

      // Rejoin connected segments.
      // TODO reuse ringBuffer.rejoin()?
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));

      segments.push(ringSegments.filter(validSegment));
    }

    return clip;
  };
});

function validSegment(segment) {
  return segment.length > 1;
}

// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] : __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - a[1])
       - ((b = b.x)[0] < 0 ? b[1] - __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] : __WEBPACK_IMPORTED_MODULE_2__math__["l" /* halfPi */] - b[1]);
}


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = equirectangularRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(25);


function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}

equirectangularRaw.invert = equirectangularRaw;

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(equirectangularRaw)
      .scale(152.63);
});


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  scale: 160,
  xOffset: 0,
  yOffset: 0,
  rotation: [0, 0, 0],
  precision: 0.1
};

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transform__ = __webpack_require__(163);


/* harmony default export */ __webpack_exports__["a"] = (function(topology) {
  var bbox = topology.bbox;

  function bboxPoint(p0) {
    p1[0] = p0[0], p1[1] = p0[1], t(p1);
    if (p1[0] < x0) x0 = p1[0];
    if (p1[0] > x1) x1 = p1[0];
    if (p1[1] < y0) y0 = p1[1];
    if (p1[1] > y1) y1 = p1[1];
  }

  function bboxGeometry(o) {
    switch (o.type) {
      case "GeometryCollection": o.geometries.forEach(bboxGeometry); break;
      case "Point": bboxPoint(o.coordinates); break;
      case "MultiPoint": o.coordinates.forEach(bboxPoint); break;
    }
  }

  if (!bbox) {
    var t = Object(__WEBPACK_IMPORTED_MODULE_0__transform__["a" /* default */])(topology), p0, p1 = new Array(2), name,
        x0 = Infinity, y0 = x0, x1 = -x0, y1 = -x0;

    topology.arcs.forEach(function(arc) {
      var i = -1, n = arc.length;
      while (++i < n) {
        p0 = arc[i], p1[0] = p0[0], p1[1] = p0[1], t(p1, i);
        if (p1[0] < x0) x0 = p1[0];
        if (p1[0] > x1) x1 = p1[0];
        if (p1[1] < y0) y0 = p1[1];
        if (p1[1] > y1) y1 = p1[1];
      }
    });

    for (name in topology.objects) {
      bboxGeometry(topology.objects[name]);
    }

    bbox = topology.bbox = [x0, y0, x1, y1];
  }

  return bbox;
});


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(topology, arcs) {
  var stitchedArcs = {},
      fragmentByStart = {},
      fragmentByEnd = {},
      fragments = [],
      emptyIndex = -1;

  // Stitch empty arcs first, since they may be subsumed by other arcs.
  arcs.forEach(function(i, j) {
    var arc = topology.arcs[i < 0 ? ~i : i], t;
    if (arc.length < 3 && !arc[1][0] && !arc[1][1]) {
      t = arcs[++emptyIndex], arcs[emptyIndex] = i, arcs[j] = t;
    }
  });

  arcs.forEach(function(i) {
    var e = ends(i),
        start = e[0],
        end = e[1],
        f, g;

    if (f = fragmentByEnd[start]) {
      delete fragmentByEnd[f.end];
      f.push(i);
      f.end = end;
      if (g = fragmentByStart[end]) {
        delete fragmentByStart[g.start];
        var fg = g === f ? f : f.concat(g);
        fragmentByStart[fg.start = f.start] = fragmentByEnd[fg.end = g.end] = fg;
      } else {
        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
      }
    } else if (f = fragmentByStart[end]) {
      delete fragmentByStart[f.start];
      f.unshift(i);
      f.start = start;
      if (g = fragmentByEnd[start]) {
        delete fragmentByEnd[g.end];
        var gf = g === f ? f : g.concat(f);
        fragmentByStart[gf.start = g.start] = fragmentByEnd[gf.end = f.end] = gf;
      } else {
        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
      }
    } else {
      f = [i];
      fragmentByStart[f.start = start] = fragmentByEnd[f.end = end] = f;
    }
  });

  function ends(i) {
    var arc = topology.arcs[i < 0 ? ~i : i], p0 = arc[0], p1;
    if (topology.transform) p1 = [0, 0], arc.forEach(function(dp) { p1[0] += dp[0], p1[1] += dp[1]; });
    else p1 = arc[arc.length - 1];
    return i < 0 ? [p1, p0] : [p0, p1];
  }

  function flush(fragmentByEnd, fragmentByStart) {
    for (var k in fragmentByEnd) {
      var f = fragmentByEnd[k];
      delete fragmentByStart[f.start];
      delete f.start;
      delete f.end;
      f.forEach(function(i) { stitchedArcs[i < 0 ? ~i : i] = 1; });
      fragments.push(f);
    }
  }

  flush(fragmentByEnd, fragmentByStart);
  flush(fragmentByStart, fragmentByEnd);
  arcs.forEach(function(i) { if (!stitchedArcs[i < 0 ? ~i : i]) fragments.push([i]); });

  return fragments;
});


/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export implicit */
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(44);



var implicit = {name: "implicit"};

function ordinal(range) {
  var index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["map"])(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["map"])();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}


/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rgbBasis; });
/* unused harmony export rgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(71);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = Object(__WEBPACK_IMPORTED_MODULE_3__color__["b" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["rgb"])(start)).r, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["rgb"])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["rgb"])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["b" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(169);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return Object(__WEBPACK_IMPORTED_MODULE_0__basis__["a" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(166);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(166);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(108);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return +x;
});


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTypes__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__identity__ = __webpack_require__(739);








var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping && locale.thousands ? Object(__WEBPACK_IMPORTED_MODULE_1__formatGroup__["a" /* default */])(locale.grouping, locale.thousands) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? Object(__WEBPACK_IMPORTED_MODULE_2__formatNumerals__["a" /* default */])(locale.numerals) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        type = specifier.type;

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_4__formatTypes__["a" /* default */][type],
        maybeSuffix = !type || /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? (type ? 6 : 12)
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__["b" /* prefixExponent */] / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatTypes__ = __webpack_require__(322);


// [[fill]align][sign][symbol][0][width][,][.precision][type]
var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);

  var match,
      fill = match[1] || " ",
      align = match[2] || ">",
      sign = match[3] || "-",
      symbol = match[4] || "",
      zero = !!match[5],
      width = match[6] && +match[6],
      comma = !!match[7],
      precision = match[8] && +match[8].slice(1),
      type = match[9] || "";

  // The "n" type is an alias for ",g".
  if (type === "n") comma = true, type = "g";

  // Map invalid types to the default format.
  else if (!__WEBPACK_IMPORTED_MODULE_0__formatTypes__["a" /* default */][type]) type = "";

  // If zero fill is specified, padding goes after sign and before digits.
  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

  this.fill = fill;
  this.align = align;
  this.sign = sign;
  this.symbol = symbol;
  this.zero = zero;
  this.width = width;
  this.comma = comma;
  this.precision = precision;
  this.type = type;
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + this.type;
};


/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDefault__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatRounded__ = __webpack_require__(738);




/* harmony default export */ __webpack_exports__["a"] = ({
  "": __WEBPACK_IMPORTED_MODULE_0__formatDefault__["a" /* default */],
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return Object(__WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */])(x * 100, p); },
  "r": __WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__["a" /* default */],
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(171);


var prefixExponent;

/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});


/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_time_format__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__array__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__continuous__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(324);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_5__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateNumber */]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisector"])(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = Math.max(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start, stop, interval), 1);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_4__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(Object(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval))
        : scale;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["a" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__["k" /* timeYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["f" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["j" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["a" /* timeDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["b" /* timeHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["d" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["g" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["c" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_3_d3_time_format__["a" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
});


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__(24);


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function(string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newYear(d.y)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* utcDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = newDate(newYear(d.y)), day = week.getDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["h" /* timeSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d), p, 2);
}

function formatWeekNumberISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* utcDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["s" /* utcSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d), p, 2);
}

function formatUTCWeekNumberISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isoSpecifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__(172);


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_0__defaultLocale__["b" /* utcFormat */])(isoSpecifier);

/* unused harmony default export */ var _unused_webpack_default_export = (formatIso);


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_package__ = __webpack_require__(767);
/* unused harmony reexport version */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_array__ = __webpack_require__(3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_axis__ = __webpack_require__(768);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_brush__ = __webpack_require__(329);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_chord__ = __webpack_require__(340);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3_collection__ = __webpack_require__(34);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_d3_color__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_d3_dispatch__ = __webpack_require__(29);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_d3_drag__ = __webpack_require__(173);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_d3_dsv__ = __webpack_require__(183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_d3_ease__ = __webpack_require__(182);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_d3_force__ = __webpack_require__(853);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_d3_format__ = __webpack_require__(26);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_d3_geo__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_d3_hierarchy__ = __webpack_require__(874);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_d3_interpolate__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_d3_path__ = __webpack_require__(14);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_d3_polygon__ = __webpack_require__(896);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_d3_quadtree__ = __webpack_require__(72);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_d3_queue__ = __webpack_require__(903);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_d3_random__ = __webpack_require__(906);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_d3_request__ = __webpack_require__(911);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_d3_scale__ = __webpack_require__(918);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_d3_selection__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_d3_shape__ = __webpack_require__(76);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_24_d3_shape__["curveMonotoneX"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_d3_time__ = __webpack_require__(24);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_d3_time_format__ = __webpack_require__(28);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_d3_timer__ = __webpack_require__(45);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_d3_transition__ = __webpack_require__(180);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_d3_voronoi__ = __webpack_require__(960);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_d3_zoom__ = __webpack_require__(965);
/* unused harmony namespace reexport */

































/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_brush__ = __webpack_require__(772);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "brush", function() { return __WEBPACK_IMPORTED_MODULE_0__src_brush__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "brushX", function() { return __WEBPACK_IMPORTED_MODULE_0__src_brush__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "brushY", function() { return __WEBPACK_IMPORTED_MODULE_0__src_brush__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "brushSelection", function() { return __WEBPACK_IMPORTED_MODULE_0__src_brush__["a"]; });



/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(17);


/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([[document.querySelector(selector)]], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([[selector]], __WEBPACK_IMPORTED_MODULE_0__selection_index__["c" /* root */]);
});


/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function empty() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
});


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var matcher = function(selector) {
  return function() {
    return this.matches(selector);
  };
};

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!element.matches) {
    var vendorMatches = element.webkitMatchesSelector
        || element.msMatchesSelector
        || element.mozMatchesSelector
        || element.oMatchesSelector;
    matcher = function(selector) {
      return function() {
        return vendorMatches.call(this, selector);
      };
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (matcher);


/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = EnterNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(17);



/* harmony default export */ __webpack_exports__["b"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Selection */](this._enter || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};


/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(update) {
  return new Array(update.length);
});


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = styleValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(177);


function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove : typeof value === "function"
            ? styleFunction
            : styleConstant)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
});

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || Object(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node).getComputedStyle(node, null).getPropertyValue(name);
}


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = yesdrag;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noevent__ = __webpack_require__(337);



/* harmony default export */ __webpack_exports__["a"] = (function(view) {
  var root = view.document.documentElement,
      selection = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["f" /* select */])(view).on("dragstart.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" /* default */], true);
  if ("onselectstart" in root) {
    selection.on("selectstart.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" /* default */], true);
  } else {
    root.__noselect = root.style.MozUserSelect;
    root.style.MozUserSelect = "none";
  }
});

function yesdrag(view, noclick) {
  var root = view.document.documentElement,
      selection = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["f" /* select */])(view).on("dragstart.drag", null);
  if (noclick) {
    selection.on("click.drag", __WEBPACK_IMPORTED_MODULE_1__noevent__["a" /* default */], true);
    setTimeout(function() { selection.on("click.drag", null); }, 0);
  }
  if ("onselectstart" in root) {
    selection.on("selectstart.drag", null);
  } else {
    root.style.MozUserSelect = root.__noselect;
    delete root.__noselect;
  }
}


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = nopropagation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(11);


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].stopImmediatePropagation();
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].stopImmediatePropagation();
});


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_schedule__ = __webpack_require__(18);


/* harmony default export */ __webpack_exports__["a"] = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule.state > __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["d" /* STARTING */] && schedule.state < __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["b" /* ENDING */];
    schedule.state = __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["a" /* ENDED */];
    schedule.timer.stop();
    if (active) schedule.on.call("interrupt", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
});


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var c;
  return (typeof b === "number" ? __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateNumber */]
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["color"] ? __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateRgb */]
      : (c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["color"])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateRgb */])
      : __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["g" /* interpolateString */])(a, b);
});


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_chord__ = __webpack_require__(846);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "chord", function() { return __WEBPACK_IMPORTED_MODULE_0__src_chord__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ribbon__ = __webpack_require__(847);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ribbon", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ribbon__["a"]; });




/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sin; });
/* unused harmony export pi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return tau; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return max; });
var cos = Math.cos;
var sin = Math.sin;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = pi * 2;
var max = Math.max;


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_collection__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_timer__ = __webpack_require__(45);




function x(d) {
  return d.x;
}

function y(d) {
  return d.y;
}

var initialRadius = 10,
    initialAngle = Math.PI * (3 - Math.sqrt(5));

/* unused harmony default export */ var _unused_webpack_default_export = (function(nodes) {
  var simulation,
      alpha = 1,
      alphaMin = 0.001,
      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
      alphaTarget = 0,
      velocityDecay = 0.6,
      forces = Object(__WEBPACK_IMPORTED_MODULE_1_d3_collection__["map"])(),
      stepper = Object(__WEBPACK_IMPORTED_MODULE_2_d3_timer__["c" /* timer */])(step),
      event = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("tick", "end");

  if (nodes == null) nodes = [];

  function step() {
    tick();
    event.call("tick", simulation);
    if (alpha < alphaMin) {
      stepper.stop();
      event.call("end", simulation);
    }
  }

  function tick() {
    var i, n = nodes.length, node;

    alpha += (alphaTarget - alpha) * alphaDecay;

    forces.each(function(force) {
      force(alpha);
    });

    for (i = 0; i < n; ++i) {
      node = nodes[i];
      if (node.fx == null) node.x += node.vx *= velocityDecay;
      else node.x = node.fx, node.vx = 0;
      if (node.fy == null) node.y += node.vy *= velocityDecay;
      else node.y = node.fy, node.vy = 0;
    }
  }

  function initializeNodes() {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.index = i;
      if (isNaN(node.x) || isNaN(node.y)) {
        var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
        node.x = radius * Math.cos(angle);
        node.y = radius * Math.sin(angle);
      }
      if (isNaN(node.vx) || isNaN(node.vy)) {
        node.vx = node.vy = 0;
      }
    }
  }

  function initializeForce(force) {
    if (force.initialize) force.initialize(nodes);
    return force;
  }

  initializeNodes();

  return simulation = {
    tick: tick,

    restart: function() {
      return stepper.restart(step), simulation;
    },

    stop: function() {
      return stepper.stop(), simulation;
    },

    nodes: function(_) {
      return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
    },

    alpha: function(_) {
      return arguments.length ? (alpha = +_, simulation) : alpha;
    },

    alphaMin: function(_) {
      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
    },

    alphaDecay: function(_) {
      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
    },

    alphaTarget: function(_) {
      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
    },

    velocityDecay: function(_) {
      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
    },

    force: function(name, _) {
      return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
    },

    find: function(x, y, radius) {
      var i = 0,
          n = nodes.length,
          dx,
          dy,
          d2,
          node,
          closest;

      if (radius == null) radius = Infinity;
      else radius *= radius;

      for (i = 0; i < n; ++i) {
        node = nodes[i];
        dx = x - node.x;
        dy = y - node.y;
        d2 = dx * dx + dy * dy;
        if (d2 < radius) closest = node, radius = d2;
      }

      return closest;
    },

    on: function(name, _) {
      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
    }
  };
});


/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = packEnclose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enclose__ = __webpack_require__(344);


function place(a, b, c) {
  var ax = a.x,
      ay = a.y,
      da = b.r + c.r,
      db = a.r + c.r,
      dx = b.x - ax,
      dy = b.y - ay,
      dc = dx * dx + dy * dy;
  if (dc) {
    var x = 0.5 + ((db *= db) - (da *= da)) / (2 * dc),
        y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
    c.x = ax + x * dx + y * dy;
    c.y = ay + x * dy - y * dx;
  } else {
    c.x = ax + db;
    c.y = ay;
  }
}

function intersects(a, b) {
  var dx = b.x - a.x,
      dy = b.y - a.y,
      dr = a.r + b.r;
  return dr * dr - 1e-6 > dx * dx + dy * dy;
}

function score(node) {
  var a = node._,
      b = node.next._,
      ab = a.r + b.r,
      dx = (a.x * b.r + b.x * a.r) / ab,
      dy = (a.y * b.r + b.y * a.r) / ab;
  return dx * dx + dy * dy;
}

function Node(circle) {
  this._ = circle;
  this.next = null;
  this.previous = null;
}

function packEnclose(circles) {
  if (!(n = circles.length)) return 0;

  var a, b, c, n, aa, ca, i, j, k, sj, sk;

  // Place the first circle.
  a = circles[0], a.x = 0, a.y = 0;
  if (!(n > 1)) return a.r;

  // Place the second circle.
  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
  if (!(n > 2)) return a.r + b.r;

  // Place the third circle.
  place(b, a, c = circles[2]);

  // Initialize the front-chain using the first three circles a, b and c.
  a = new Node(a), b = new Node(b), c = new Node(c);
  a.next = c.previous = b;
  b.next = a.previous = c;
  c.next = b.previous = a;

  // Attempt to place each remaining circle…
  pack: for (i = 3; i < n; ++i) {
    place(a._, b._, c = circles[i]), c = new Node(c);

    // Find the closest intersecting circle on the front-chain, if any.
    // “Closeness” is determined by linear distance along the front-chain.
    // “Ahead” or “behind” is likewise determined by linear distance.
    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
    do {
      if (sj <= sk) {
        if (intersects(j._, c._)) {
          b = j, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sj += j._.r, j = j.next;
      } else {
        if (intersects(k._, c._)) {
          a = k, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sk += k._.r, k = k.previous;
      }
    } while (j !== k.next);

    // Success! Insert the new circle c between a and b.
    c.previous = a, c.next = b, a.next = b.previous = b = c;

    // Compute the new closest circle pair to the centroid.
    aa = score(a);
    while ((c = c.next) !== b) {
      if ((ca = score(c)) < aa) {
        a = c, aa = ca;
      }
    }
    b = a.next;
  }

  // Compute the enclosing circle of the front chain.
  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = Object(__WEBPACK_IMPORTED_MODULE_0__enclose__["a" /* default */])(a);

  // Translate the circles to put the enclosing circle around the origin.
  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;

  return c.r;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(circles) {
  packEnclose(circles);
  return circles;
});


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(888);


/* harmony default export */ __webpack_exports__["a"] = (function(circles) {
  var i = 0, n = (circles = Object(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* shuffle */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(circles))).length, B = [], p, e;

  while (i < n) {
    p = circles[i];
    if (e && enclosesWeak(e, p)) ++i;
    else e = encloseBasis(B = extendBasis(B, p)), i = 0;
  }

  return e;
});

function extendBasis(B, p) {
  var i, j;

  if (enclosesWeakAll(p, B)) return [p];

  // If we get here then B must have at least one element.
  for (i = 0; i < B.length; ++i) {
    if (enclosesNot(p, B[i])
        && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
      return [B[i], p];
    }
  }

  // If we get here then B must have at least two elements.
  for (i = 0; i < B.length - 1; ++i) {
    for (j = i + 1; j < B.length; ++j) {
      if (enclosesNot(encloseBasis2(B[i], B[j]), p)
          && enclosesNot(encloseBasis2(B[i], p), B[j])
          && enclosesNot(encloseBasis2(B[j], p), B[i])
          && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
        return [B[i], B[j], p];
      }
    }
  }

  // If we get here then something is very wrong.
  throw new Error;
}

function enclosesNot(a, b) {
  var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
  return dr < 0 || dr * dr < dx * dx + dy * dy;
}

function enclosesWeak(a, b) {
  var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function enclosesWeakAll(a, B) {
  for (var i = 0; i < B.length; ++i) {
    if (!enclosesWeak(a, B[i])) {
      return false;
    }
  }
  return true;
}

function encloseBasis(B) {
  switch (B.length) {
    case 1: return encloseBasis1(B[0]);
    case 2: return encloseBasis2(B[0], B[1]);
    case 3: return encloseBasis3(B[0], B[1], B[2]);
  }
}

function encloseBasis1(a) {
  return {
    x: a.x,
    y: a.y,
    r: a.r
  };
}

function encloseBasis2(a, b) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
      l = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x1 + x2 + x21 / l * r21) / 2,
    y: (y1 + y2 + y21 / l * r21) / 2,
    r: (l + r1 + r2) / 2
  };
}

function encloseBasis3(a, b, c) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x3 = c.x, y3 = c.y, r3 = c.r,
      a2 = x1 - x2,
      a3 = x1 - x3,
      b2 = y1 - y2,
      b3 = y1 - y3,
      c2 = r2 - r1,
      c3 = r3 - r1,
      d1 = x1 * x1 + y1 * y1 - r1 * r1,
      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
      ab = a3 * b2 - a2 * b3,
      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
      xb = (b3 * c2 - b2 * c3) / ab,
      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
      yb = (a2 * c3 - a3 * c2) / ab,
      A = xb * xb + yb * yb - 1,
      B = 2 * (r1 + xa * xb + ya * yb),
      C = xa * xa + ya * ya - r1 * r1,
      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
  return {
    x: x1 + xa + xb * r,
    y: y1 + ya + yb * r,
    r: r
  };
}


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = constantZero;
function constantZero() {
  return 0;
}

/* harmony default export */ __webpack_exports__["b"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
});


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(56);


/* harmony default export */ __webpack_exports__["a"] = ((function sourceRandomNormal(source) {
  function randomNormal(mu, sigma) {
    var x, r;
    mu = mu == null ? 0 : +mu;
    sigma = sigma == null ? 1 : +sigma;
    return function() {
      var y;

      // If available, use the second previously-generated uniform random.
      if (x != null) y = x, x = null;

      // Otherwise, generate a new x and y.
      else do {
        x = source() * 2 - 1;
        y = source() * 2 - 1;
        r = x * x + y * y;
      } while (!r || r > 1);

      return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
    };
  }

  randomNormal.source = sourceRandomNormal;

  return randomNormal;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(56);


/* harmony default export */ __webpack_exports__["a"] = ((function sourceRandomIrwinHall(source) {
  function randomIrwinHall(n) {
    return function() {
      for (var sum = 0, i = 0; i < n; ++i) sum += source();
      return sum;
    };
  }

  randomIrwinHall.source = sourceRandomIrwinHall;

  return randomIrwinHall;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(190);


/* harmony default export */ __webpack_exports__["a"] = (function(defaultMimeType, parse) {
  return function(url, row, callback) {
    if (arguments.length < 3) callback = row, row = null;
    var r = Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(url).mimeType(defaultMimeType);
    r.row = function(_) { return arguments.length ? r.response(responseOf(parse, row = _)) : row; };
    r.row(row);
    return callback ? r.get(callback) : r;
  };
});

function responseOf(parse, row) {
  return function(request) {
    return parse(request.responseText, row);
  };
}


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export implicit */
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(46);



var implicit = {name: "implicit"};

function ordinal(range) {
  var index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["map"])(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["map"])();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return +x;
});


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_time_format__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__array__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__continuous__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(352);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_5__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateNumber */]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisector"])(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = Math.max(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start, stop, interval), 1);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_4__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(Object(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval))
        : scale;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["a" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__["k" /* timeYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["f" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["j" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["a" /* timeDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["b" /* timeHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["d" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["g" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["c" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_3_d3_time_format__["a" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
});


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__point__ = __webpack_require__(193);






/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x0 = __WEBPACK_IMPORTED_MODULE_4__point__["a" /* x */],
      x1 = null,
      y0 = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      y1 = __WEBPACK_IMPORTED_MODULE_4__point__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return Object(__WEBPACK_IMPORTED_MODULE_3__line__["a" /* default */])().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
});


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return curveRadialLinear; });
/* harmony export (immutable) */ __webpack_exports__["b"] = curveRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(117);


var curveRadialLinear = curveRadial(__WEBPACK_IMPORTED_MODULE_0__linear__["a" /* default */]);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = lineRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line__ = __webpack_require__(192);



function lineRadial(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* default */])(_)) : c()._curve;
  };

  return l;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return lineRadial(Object(__WEBPACK_IMPORTED_MODULE_1__line__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* curveRadialLinear */]));
});


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
});


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(77);


/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / __WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */]);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, __WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */]);
  }
});


/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
});


/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
});


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(77);


var ka = 0.89081309152928522810,
    kr = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */] / 10) / Math.sin(7 * __WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */] / 10),
    kx = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] / 10) * kr,
    ky = -Math.cos(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] / 10) * kr;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = __WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
});


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
});


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sqrt3 = Math.sqrt(3);

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
});


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var c = -0.5,
    s = Math.sqrt(3) / 2,
    k = 1 / Math.sqrt(12),
    a = (k / 2 + 1) * 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
});


/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalClosed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(120);



function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__cardinal__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinal__ = __webpack_require__(120);


function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__cardinal__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = createCell;
/* harmony export (immutable) */ __webpack_exports__["a"] = cellHalfedgeStart;
/* unused harmony export cellHalfedgeEnd */
/* harmony export (immutable) */ __webpack_exports__["d"] = sortCellHalfedges;
/* harmony export (immutable) */ __webpack_exports__["b"] = clipCells;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Edge__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Diagram__ = __webpack_require__(80);



function createCell(site) {
  return __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][site.index] = {
    site: site,
    halfedges: []
  };
}

function cellHalfedgeAngle(cell, edge) {
  var site = cell.site,
      va = edge.left,
      vb = edge.right;
  if (site === vb) vb = va, va = site;
  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
  if (site === va) va = edge[1], vb = edge[0];
  else va = edge[0], vb = edge[1];
  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}

function cellHalfedgeStart(cell, edge) {
  return edge[+(edge.left !== cell.site)];
}

function cellHalfedgeEnd(cell, edge) {
  return edge[+(edge.left === cell.site)];
}

function sortCellHalfedges() {
  for (var i = 0, n = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */].length, cell, halfedges, j, m; i < n; ++i) {
    if ((cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][i]) && (m = (halfedges = cell.halfedges).length)) {
      var index = new Array(m),
          array = new Array(m);
      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[j]]);
      index.sort(function(i, j) { return array[j] - array[i]; });
      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
      for (j = 0; j < m; ++j) halfedges[j] = array[j];
    }
  }
}

function clipCells(x0, y0, x1, y1) {
  var nCells = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */].length,
      iCell,
      cell,
      site,
      iHalfedge,
      halfedges,
      nHalfedges,
      start,
      startX,
      startY,
      end,
      endX,
      endY,
      cover = true;

  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell]) {
      site = cell.site;
      halfedges = cell.halfedges;
      iHalfedge = halfedges.length;

      // Remove any dangling clipped edges.
      while (iHalfedge--) {
        if (!__WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[iHalfedge]]) {
          halfedges.splice(iHalfedge, 1);
        }
      }

      // Insert any border edges as necessary.
      iHalfedge = 0, nHalfedges = halfedges.length;
      while (iHalfedge < nHalfedges) {
        end = cellHalfedgeEnd(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[iHalfedge]]), endX = end[0], endY = end[1];
        start = cellHalfedgeStart(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
        if (Math.abs(endX - startX) > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] || Math.abs(endY - startY) > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */]) {
          halfedges.splice(iHalfedge, 0, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, end,
              Math.abs(endX - x0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && y1 - endY > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [x0, Math.abs(startX - x0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startY : y1]
              : Math.abs(endY - y1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && x1 - endX > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [Math.abs(startY - y1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startX : x1, y1]
              : Math.abs(endX - x1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && endY - y0 > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [x1, Math.abs(startX - x1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startY : y0]
              : Math.abs(endY - y0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && endX - x0 > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [Math.abs(startY - y0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startX : x0, y0]
              : null)) - 1);
          ++nHalfedges;
        }
      }

      if (nHalfedges) cover = false;
    }
  }

  // If there weren’t any edges, have the closest site cover the extent.
  // It doesn’t matter which corner of the extent we measure!
  if (cover) {
    var dx, dy, d2, dc = Infinity;

    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
      if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell]) {
        site = cell.site;
        dx = site[0] - x0;
        dy = site[1] - y0;
        d2 = dx * dx + dy * dy;
        if (d2 < dc) dc = d2, cover = cell;
      }
    }

    if (cover) {
      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
      cover.halfedges.push(
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site = cover.site, v00, v01)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v01, v11)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v11, v10)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v10, v00)) - 1
      );
    }
  }

  // Lastly delete any cells with no edges; these were entirely clipped.
  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell]) {
      if (!cell.halfedges.length) {
        delete __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell];
      }
    }
  }
}


/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return firstCircle; });
/* harmony export (immutable) */ __webpack_exports__["a"] = attachCircle;
/* harmony export (immutable) */ __webpack_exports__["b"] = detachCircle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RedBlackTree__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Diagram__ = __webpack_require__(80);



var circlePool = [];

var firstCircle;

function Circle() {
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(this);
  this.x =
  this.y =
  this.arc =
  this.site =
  this.cy = null;
}

function attachCircle(arc) {
  var lArc = arc.P,
      rArc = arc.N;

  if (!lArc || !rArc) return;

  var lSite = lArc.site,
      cSite = arc.site,
      rSite = rArc.site;

  if (lSite === rSite) return;

  var bx = cSite[0],
      by = cSite[1],
      ax = lSite[0] - bx,
      ay = lSite[1] - by,
      cx = rSite[0] - bx,
      cy = rSite[1] - by;

  var d = 2 * (ax * cy - ay * cx);
  if (d >= -__WEBPACK_IMPORTED_MODULE_1__Diagram__["g" /* epsilon2 */]) return;

  var ha = ax * ax + ay * ay,
      hc = cx * cx + cy * cy,
      x = (cy * ha - ay * hc) / d,
      y = (ax * hc - cx * ha) / d;

  var circle = circlePool.pop() || new Circle;
  circle.arc = arc;
  circle.site = cSite;
  circle.x = x + bx;
  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom

  arc.circle = circle;

  var before = null,
      node = __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* circles */]._;

  while (node) {
    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
      if (node.L) node = node.L;
      else { before = node.P; break; }
    } else {
      if (node.R) node = node.R;
      else { before = node; break; }
    }
  }

  __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* circles */].insert(before, circle);
  if (!before) firstCircle = circle;
}

function detachCircle(arc) {
  var circle = arc.circle;
  if (circle) {
    if (!circle.P) firstCircle = circle.N;
    __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* circles */].remove(circle);
    circlePool.push(circle);
    Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(circle);
    arc.circle = null;
  }
}


/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Transform;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
/* unused harmony export default */
function Transform(k, x, y) {
  this.k = k;
  this.x = x;
  this.y = y;
}

Transform.prototype = {
  constructor: Transform,
  scale: function(k) {
    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
  },
  translate: function(x, y) {
    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
  },
  apply: function(point) {
    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
  },
  applyX: function(x) {
    return x * this.k + this.x;
  },
  applyY: function(y) {
    return y * this.k + this.y;
  },
  invert: function(location) {
    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
  },
  invertX: function(x) {
    return (x - this.x) / this.k;
  },
  invertY: function(y) {
    return (y - this.y) / this.k;
  },
  rescaleX: function(x) {
    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
  },
  rescaleY: function(y) {
    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};

var identity = new Transform(1, 0, 0);

transform.prototype = Transform.prototype;

function transform(node) {
  return node.__zoom || identity;
}


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _annotationHandling = __webpack_require__(970);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Legend = __webpack_require__(372);

var _Legend2 = _interopRequireDefault(_Legend);

var _Annotation = __webpack_require__(57);

var _Annotation2 = _interopRequireDefault(_Annotation);

var _labella = __webpack_require__(985);

var _labella2 = _interopRequireDefault(_labella);

var _SpanOrDiv = __webpack_require__(203);

var _SpanOrDiv2 = _interopRequireDefault(_SpanOrDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // modules

//import { load } from 'opentype.js'


function adjustedAnnotationKeyMapper(d) {
  return d.props.noteData.id || d.props.noteData.x + "-" + d.props.noteData.y;
}

function noteDataWidth(noteData) {
  var charWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;

  var wrap = noteData.note && noteData.note.wrap || 120;
  var noteText = noteData.note.label || noteData.note.label || "";
  return Math.min(wrap, noteText.length * charWidth);
}

function noteDataHeight(noteData) {
  var charWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
  var lineHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;

  var wrap = noteData.note && noteData.note.wrap || 120;
  var text = noteData.note.label || noteData.note.title || "";
  return Math.ceil(text.length * charWidth / wrap) * lineHeight + (noteData.note.label && noteData.note.title ? lineHeight : 0);
}

function objectStringKey(object) {
  var finalKey = "";
  Object.keys(object).forEach(function (key) {
    finalKey += !object[key] || !object[key].toString ? object[key] : object[key].toString();
  });

  return finalKey;
}

var AnnotationLayer = function (_React$Component) {
  _inherits(AnnotationLayer, _React$Component);

  function AnnotationLayer(props) {
    _classCallCheck(this, AnnotationLayer);

    var _this = _possibleConstructorReturn(this, (AnnotationLayer.__proto__ || Object.getPrototypeOf(AnnotationLayer)).call(this, props));

    _this.generateSVGAnnotations = _this.generateSVGAnnotations.bind(_this);
    _this.generateHTMLAnnotations = _this.generateHTMLAnnotations.bind(_this);

    _this.state = {
      font: undefined,
      svgAnnotations: [],
      htmlAnnotations: [],
      adjustedAnnotations: 0,
      adjustedAnnotationsKey: "",
      adjustedAnnotationsDataVersion: ""
    };
    return _this;
  }

  /*    componentWillMount() {
      const fontLocation = this.props.fontLocation
       if (fontLocation) {
        load(fontLocation, function(err, font) {
            if (err) {
                return null
            } else {
                this.setState({ font });
            }
        });
      }
    } */

  _createClass(AnnotationLayer, [{
    key: "generateSVGAnnotations",
    value: function generateSVGAnnotations(props, annotations) {
      var renderedAnnotations = annotations.map(function (d, i) {
        return props.svgAnnotationRule(d, i, props);
      }).filter(function (d) {
        return d !== null && d !== undefined;
      });

      return renderedAnnotations;
    }
  }, {
    key: "generateHTMLAnnotations",
    value: function generateHTMLAnnotations(props, annotations) {
      var renderedAnnotations = annotations.map(function (d, i) {
        return props.htmlAnnotationRule(d, i, props);
      }).filter(function (d) {
        return d !== null && d !== undefined;
      });

      return renderedAnnotations;
    }
  }, {
    key: "processAnnotations",
    value: function processAnnotations(adjustableAnnotations, annotationProcessor, props) {
      if (annotationProcessor.type === false) {
        return adjustableAnnotations;
      }

      var _props$margin = props.margin,
          margin = _props$margin === undefined ? { top: 0, bottom: 0, left: 0, right: 0 } : _props$margin;
      var size = props.size,
          axes = props.axes;


      margin = typeof margin === "number" ? { top: margin, left: margin, right: margin, bottom: margin } : margin;

      var _annotationProcessor$ = annotationProcessor.padding,
          padding = _annotationProcessor$ === undefined ? 2 : _annotationProcessor$;


      if (annotationProcessor.type === "bump") {
        var adjustedAnnotations = (0, _annotationHandling.bumpAnnotations)(adjustableAnnotations, props, annotationProcessor);
        return adjustedAnnotations;
      } else if (annotationProcessor.type === "marginalia") {
        var marginOffset = annotationProcessor.marginOffset;

        var finalOrientation = !annotationProcessor.orient || annotationProcessor.orient === "nearest" ? ["left", "right", "top", "bottom"] : Array.isArray(annotationProcessor.orient) ? annotationProcessor.orient : [annotationProcessor.orient];
        var marginOffsetFn = function marginOffsetFn(orient, axisSettings) {
          if (axisSettings.find(function (d) {
            return d.props.orient === orient;
          })) {
            return 50;
          }
          return 10;
        };
        if (typeof marginOffset === "number") {
          marginOffsetFn = function marginOffsetFn() {
            return marginOffset;
          };
        }

        var leftOn = finalOrientation.find(function (d) {
          return d === "left";
        });
        var rightOn = finalOrientation.find(function (d) {
          return d === "right";
        });
        var topOn = finalOrientation.find(function (d) {
          return d === "top";
        });
        var bottomOn = finalOrientation.find(function (d) {
          return d === "bottom";
        });

        var leftNodes = [];
        var rightNodes = [];
        var topNodes = [];
        var bottomNodes = [];

        adjustableAnnotations.forEach(function (aNote) {
          var noteData = aNote.props.noteData;
          var leftDist = leftOn ? noteData.x : Infinity;
          var rightDist = rightOn ? size[0] - noteData.x : Infinity;
          var topDist = topOn ? noteData.y : Infinity;
          var bottomDist = bottomOn ? size[1] - noteData.y : Infinity;

          var minDist = Math.min(leftDist, rightDist, topDist, bottomDist);

          if (leftDist === minDist) {
            leftNodes.push(aNote);
          } else if (rightDist === minDist) {
            rightNodes.push(aNote);
          } else if (topDist === minDist) {
            topNodes.push(aNote);
          } else {
            bottomNodes.push(aNote);
          }
        });

        //Adjust the margins based on which regions are active

        var leftForce = new _labella2.default.Force({
          minPos: 0 - margin.top,
          maxPos: bottomOn ? size[1] : size[1] + margin.bottom
        }).nodes(leftNodes.map(function (d) {
          return new _labella2.default.Node(d.props.noteData.y, noteDataHeight(d.props.noteData, annotationProcessor.characterWidth, annotationProcessor.lineHeight) + padding);
        })).compute();

        var rightForce = new _labella2.default.Force({
          minPos: topOn ? 0 : 0 - margin.top,
          maxPos: size[1] + margin.bottom
        }).nodes(rightNodes.map(function (d) {
          return new _labella2.default.Node(d.props.noteData.y, noteDataHeight(d.props.noteData, annotationProcessor.characterWidth, annotationProcessor.lineHeight) + padding);
        })).compute();

        var topForce = new _labella2.default.Force({
          minPos: leftOn ? 0 : 0 - margin.left,
          maxPos: size[0] + margin.right
        }).nodes(topNodes.map(function (d) {
          return new _labella2.default.Node(d.props.noteData.x, noteDataWidth(d.props.noteData, annotationProcessor.characterWidth) + padding);
        })).compute();

        var bottomForce = new _labella2.default.Force({
          minPos: 0 - margin.left,
          maxPos: rightOn ? size[0] : size[0] + margin.right
        }).nodes(bottomNodes.map(function (d) {
          return new _labella2.default.Node(d.props.noteData.x, noteDataWidth(d.props.noteData, annotationProcessor.characterWidth) + padding);
        })).compute();

        var bottomOffset = Math.max.apply(Math, _toConsumableArray(bottomNodes.map(function (d) {
          return noteDataHeight(d.props.noteData, annotationProcessor.characterWidth, annotationProcessor.lineHeight) + padding;
        })));
        var topOffset = Math.max.apply(Math, _toConsumableArray(topNodes.map(function (d) {
          return noteDataHeight(d.props.noteData, annotationProcessor.characterWidth, annotationProcessor.lineHeight) + padding;
        })));
        var leftOffset = Math.max.apply(Math, _toConsumableArray(leftNodes.map(function (d) {
          return noteDataWidth(d.props.noteData, annotationProcessor.characterWidth) + padding;
        })));
        var rightOffset = Math.max.apply(Math, _toConsumableArray(rightNodes.map(function (d) {
          return noteDataWidth(d.props.noteData, annotationProcessor.characterWidth) + padding;
        })));

        //      const nodeOffsetHeight = Math.max()

        var leftSortedNodes = leftForce.nodes();
        var rightSortedNodes = rightForce.nodes();
        var topSortedNodes = topForce.nodes();
        var bottomSortedNodes = bottomForce.nodes();

        leftNodes.forEach(function (note, i) {
          note.props.noteData.ny = leftSortedNodes[i].currentPos;
          note.props.noteData.nx = 0 - leftSortedNodes[i].layerIndex * leftOffset - marginOffsetFn("left", axes);
          if (note.props.noteData.note) {
            note.props.noteData.note.orientation = "leftRight";
            note.props.noteData.note.align = "right";
          }
        });

        rightNodes.forEach(function (note, i) {
          note.props.noteData.ny = rightSortedNodes[i].currentPos;
          note.props.noteData.nx = size[0] + rightSortedNodes[i].layerIndex * rightOffset + marginOffsetFn("right", axes);
          if (note.props.noteData.note) {
            note.props.noteData.note.orientation = "leftRight";
            note.props.noteData.note.align = "left";
          }
        });

        topNodes.forEach(function (note, i) {
          note.props.noteData.nx = topSortedNodes[i].currentPos;
          note.props.noteData.ny = 0 - topSortedNodes[i].layerIndex * topOffset - marginOffsetFn("top", axes);
        });

        bottomNodes.forEach(function (note, i) {
          note.props.noteData.nx = bottomSortedNodes[i].currentPos;
          note.props.noteData.ny = size[1] + bottomSortedNodes[i].layerIndex * bottomOffset + marginOffsetFn("bottom", axes);
        });
        return adjustableAnnotations;
      }
      return adjustableAnnotations;
      console.error("Unknown annotation handling function: Must be of a string 'bump' or 'marginalia' or a an object with type of those strings or a function that takes adjustable annotations and returns adjusted annotations");
    }
  }, {
    key: "createAnnotations",
    value: function createAnnotations(props) {
      var renderedSVGAnnotations = this.state.svgAnnotations,
          renderedHTMLAnnotations = [],
          adjustedAnnotations = this.state.adjustedAnnotations,
          adjustableAnnotationsKey = this.state.adjustedAnnotationsKey;

      var adjustedAnnotationsKey = this.state.adjustedAnnotationsKey,
          adjustedAnnotationsDataVersion = this.state.adjustedAnnotationsDataVersion;

      var annotations = props.annotations,
          _props$annotationHand = props.annotationHandling,
          annotationHandling = _props$annotationHand === undefined ? false : _props$annotationHand;

      var annotationProcessor = (typeof annotationHandling === "undefined" ? "undefined" : _typeof(annotationHandling)) !== "object" ? { type: annotationHandling } : annotationHandling;

      var _annotationProcessor$2 = annotationProcessor.dataVersion,
          dataVersion = _annotationProcessor$2 === undefined ? "" : _annotationProcessor$2;


      if (this.props.svgAnnotationRule) {
        var initialSVGAnnotations = this.generateSVGAnnotations(props, annotations);
        var adjustableAnnotations = initialSVGAnnotations.filter(function (d) {
          return d.props && d.props.noteData && !d.props.noteData.fixedPosition;
        });
        var fixedAnnotations = initialSVGAnnotations.filter(function (d) {
          return !d.props || !d.props.noteData || d.props.noteData.fixedPosition;
        });
        adjustableAnnotationsKey = adjustableAnnotations.map(adjustedAnnotationKeyMapper).join(",") + objectStringKey(_extends(annotationProcessor, {
          point: props.pointSizeFunction,
          label: props.labelSizeFunction
        }));

        if (annotationProcessor.type === false) {
          adjustedAnnotations = adjustableAnnotations;
        }

        if (adjustedAnnotations.length !== adjustableAnnotations.length || adjustedAnnotationsKey !== adjustableAnnotationsKey || adjustedAnnotationsDataVersion !== dataVersion) {
          adjustedAnnotations = this.processAnnotations(adjustableAnnotations, annotationProcessor, props);
        } else {
          //Handle when style or other attributes change
          adjustedAnnotations = adjustedAnnotations.map(function (d, i) {
            var newNoteData = _extends(adjustableAnnotations[i].props.noteData, {
              nx: d.props.noteData.nx,
              ny: d.props.noteData.ny,
              note: d.props.noteData.note
            });
            return _react2.default.createElement(_Annotation2.default, { key: d.key, noteData: newNoteData });
          });
        }

        renderedSVGAnnotations = [].concat(_toConsumableArray(adjustedAnnotations), _toConsumableArray(fixedAnnotations));
      }

      if (this.props.htmlAnnotationRule) {
        renderedHTMLAnnotations = this.generateHTMLAnnotations(props, annotations);
      }

      this.setState({
        svgAnnotations: renderedSVGAnnotations,
        htmlAnnotations: renderedHTMLAnnotations,
        adjustedAnnotations: adjustedAnnotations,
        adjustedAnnotationsKey: adjustableAnnotationsKey,
        adjustedAnnotationsDataVersion: dataVersion
      });
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      this.createAnnotations(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.createAnnotations(nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _state = this.state,
          svgAnnotations = _state.svgAnnotations,
          htmlAnnotations = _state.htmlAnnotations;
      var _props = this.props,
          useSpans = _props.useSpans,
          legendSettings = _props.legendSettings,
          margin = _props.margin;


      var renderedLegend = void 0;
      if (legendSettings) {
        var positionHash = {
          left: [15, 15],
          right: [this.props.size[0] + 15, 15]
        };
        var _legendSettings$posit = legendSettings.position,
            position = _legendSettings$posit === undefined ? "right" : _legendSettings$posit,
            _legendSettings$title = legendSettings.title,
            title = _legendSettings$title === undefined ? "Legend" : _legendSettings$title;

        var legendPosition = positionHash[position] || position;
        renderedLegend = _react2.default.createElement(
          "g",
          { transform: "translate(" + legendPosition + ")" },
          _react2.default.createElement(_Legend2.default, _extends({}, legendSettings, { title: title, position: position }))
        );
      }
      var svgStyle = {
        background: "none",
        pointerEvents: "none",
        position: "absolute",
        left: margin.left + "px",
        top: margin.top + "px"
        //    if (useSpans) {
      };svgStyle.overflow = "visible";
      //    }

      return _react2.default.createElement(
        _SpanOrDiv2.default,
        {
          span: useSpans,
          className: "annotation-layer",
          style: {
            position: "absolute",
            pointerEvents: "none",
            background: "none"
          }
        },
        _react2.default.createElement(
          "svg",
          {
            className: "annotation-layer-svg",
            height: this.props.size[1],
            width: this.props.size[0],
            style: svgStyle
          },
          _react2.default.createElement(
            "g",
            null,
            renderedLegend,
            svgAnnotations
          )
        ),
        useSpans ? null : _react2.default.createElement(
          "div",
          {
            className: "annotation-layer-html",
            style: {
              background: "none",
              pointerEvents: "none",
              position: "absolute",
              height: this.props.size[1] + "px",
              width: this.props.size[0] + "px",
              left: margin.left + "px",
              top: margin.top + "px"
            }
          },
          htmlAnnotations
        )
      );
    }
  }]);

  return AnnotationLayer;
}(_react2.default.Component);

AnnotationLayer.propTypes = {
  scale: _propTypes2.default.func,
  orient: _propTypes2.default.string,
  title: _propTypes2.default.string,
  format: _propTypes2.default.string,
  values: _propTypes2.default.array,
  properties: _propTypes2.default.object,
  position: _propTypes2.default.array
};

exports.default = AnnotationLayer;
module.exports = exports['default'];

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var typeHash = {
  fill: function fill(style) {
    return _react2.default.createElement("rect", { style: style, width: 20, height: 20 });
  },
  line: function line(style) {
    return _react2.default.createElement("line", { style: style, x1: 0, y1: 0, x2: 20, y2: 20 });
  }
};

var Legend = function (_React$Component) {
  _inherits(Legend, _React$Component);

  function Legend() {
    _classCallCheck(this, Legend);

    return _possibleConstructorReturn(this, (Legend.__proto__ || Object.getPrototypeOf(Legend)).apply(this, arguments));
  }

  _createClass(Legend, [{
    key: "renderLegendGroup",
    value: function renderLegendGroup(legendGroup) {
      var _legendGroup$type = legendGroup.type,
          type = _legendGroup$type === undefined ? "fill" : _legendGroup$type,
          styleFn = legendGroup.styleFn,
          items = legendGroup.items;

      var renderedItems = [];
      var itemOffset = 0;
      items.forEach(function (item, i) {
        var Type = typeHash[type];
        var renderedType = void 0;
        if (Type) {
          var style = styleFn(item, i);
          renderedType = Type(style);
        } else {
          renderedType = type(item);
        }
        renderedItems.push(_react2.default.createElement(
          "g",
          { key: "legend-item-" + i, transform: "translate(0," + itemOffset + ")" },
          renderedType,
          _react2.default.createElement(
            "text",
            { y: 15, x: 30 },
            item.label
          )
        ));
        itemOffset += 25;
      });
      return renderedItems;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          legendGroups = _props.legendGroups,
          _props$title = _props.title,
          title = _props$title === undefined ? "Legend" : _props$title,
          _props$width = _props.width,
          width = _props$width === undefined ? 100 : _props$width;

      var offset = 30;
      var renderedGroups = [];
      legendGroups.forEach(function (l, i) {
        offset += 5;
        renderedGroups.push(_react2.default.createElement("line", {
          key: "legend-top-line legend-symbol-" + i,
          stroke: "gray",
          x1: 0,
          y1: offset,
          x2: width,
          y2: offset
        }));
        offset += 10;
        if (l.label) {
          offset += 20;
          renderedGroups.push(_react2.default.createElement(
            "text",
            {
              key: "legend-text-" + i,
              y: offset,
              className: "legend-group-label"
            },
            l.label
          ));
          offset += 10;
        }

        renderedGroups.push(_react2.default.createElement(
          "g",
          {
            key: "legend-group-" + i,
            className: "legend-item",
            transform: "translate(0," + offset + ")"
          },
          _this2.renderLegendGroup(l)
        ));
        offset += l.items.length * 25 + 10;
      });

      return _react2.default.createElement(
        "g",
        null,
        _react2.default.createElement(
          "text",
          { className: "legend-title", y: 20, x: width / 2, textAnchor: "middle" },
          title
        ),
        renderedGroups
      );
    }
  }]);

  return Legend;
}(_react2.default.Component);

Legend.propTypes = {
  title: _propTypes2.default.string,
  width: _propTypes2.default.number,
  legendGroups: _propTypes2.default.array
};

exports.default = Legend;
module.exports = exports['default'];

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _typeCurve = __webpack_require__(972);

var _typeCurve2 = _interopRequireDefault(_typeCurve);

var _Connector2 = __webpack_require__(121);

var _Connector3 = _interopRequireDefault(_Connector2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */


var ConnectorCurve = function (_Connector) {
  _inherits(ConnectorCurve, _Connector);

  function ConnectorCurve() {
    _classCallCheck(this, ConnectorCurve);

    return _possibleConstructorReturn(this, (ConnectorCurve.__proto__ || Object.getPrototypeOf(ConnectorCurve)).apply(this, arguments));
  }

  _createClass(ConnectorCurve, [{
    key: "getComponents",
    value: function getComponents(_ref) {
      var curve = _ref.curve,
          points = _ref.points,
          x = _ref.x,
          y = _ref.y,
          dx = _ref.dx,
          dy = _ref.dy,
          radius = _ref.radius,
          outerRadius = _ref.outerRadius,
          width = _ref.width,
          height = _ref.height;

      return (0, _typeCurve2.default)({
        curve: curve,
        points: points,
        x: x,
        y: y,
        dx: dx,
        dy: dy,
        radius: radius,
        outerRadius: outerRadius,
        width: width,
        height: height
      });
    }
  }]);

  return ConnectorCurve;
}(_Connector3.default);

exports.default = ConnectorCurve;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lineSetup = undefined;

var _Builder = __webpack_require__(16);

var lineSetup = exports.lineSetup = function lineSetup(_ref) {
  var dx = _ref.dx,
      dy = _ref.dy,
      radius = _ref.radius,
      outerRadius = _ref.outerRadius,
      radiusPadding = _ref.radiusPadding,
      width = _ref.width,
      height = _ref.height;

  var x1 = 0,
      x2 = dx,
      y1 = 0,
      y2 = dy;

  if (outerRadius || radius) {
    var h = Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
    var angle = Math.asin(-y2 / h);
    var r = (outerRadius || radius) + (radiusPadding || 0);

    x1 = Math.abs(Math.cos(angle) * r) * (x2 < 0 ? -1 : 1);
    y1 = Math.abs(Math.sin(angle) * r) * (y2 < 0 ? -1 : 1);
  }

  if (width && height) {
    if (width > 0 && dx > 0 || width < 0 && dx < 0) {
      if (Math.abs(width) > Math.abs(dx)) x1 = width / 2;else x1 = width;
    }
    if (height > 0 && dy > 0 || height < 0 && dy < 0) {
      if (Math.abs(height) > Math.abs(dy)) y1 = height / 2;else y1 = height;
    }
    if (x1 === width / 2 && y1 === height / 2) {
      x1 = x2;
      y1 = y2;
    }
  }

  return [[x1, y1], [x2, y2]];
};

exports.default = function (connectorData) {
  var data = lineSetup(connectorData);
  return { components: [(0, _Builder.lineBuilder)({ data: data, className: "connector" })] };
};

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _typeElbow = __webpack_require__(973);

var _typeElbow2 = _interopRequireDefault(_typeElbow);

var _Connector2 = __webpack_require__(121);

var _Connector3 = _interopRequireDefault(_Connector2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */


var ConnectorElbow = function (_Connector) {
  _inherits(ConnectorElbow, _Connector);

  function ConnectorElbow() {
    _classCallCheck(this, ConnectorElbow);

    return _possibleConstructorReturn(this, (ConnectorElbow.__proto__ || Object.getPrototypeOf(ConnectorElbow)).apply(this, arguments));
  }

  _createClass(ConnectorElbow, [{
    key: "getComponents",
    value: function getComponents(_ref) {
      var x = _ref.x,
          y = _ref.y,
          dy = _ref.dy,
          dx = _ref.dx,
          radius = _ref.radius,
          radiusPadding = _ref.radiusPadding,
          outerRadius = _ref.outerRadius,
          width = _ref.width,
          height = _ref.height;

      return (0, _typeElbow2.default)({
        x: x,
        y: y,
        dx: dx,
        dy: dy,
        radius: radius,
        radiusPadding: radiusPadding,
        outerRadius: outerRadius,
        width: width,
        height: height
      });
    }
  }]);

  return ConnectorElbow;
}(_Connector3.default);

exports.default = ConnectorElbow;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _typeLine = __webpack_require__(374);

var _typeLine2 = _interopRequireDefault(_typeLine);

var _Connector2 = __webpack_require__(121);

var _Connector3 = _interopRequireDefault(_Connector2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */


var ConnectorLine = function (_Connector) {
  _inherits(ConnectorLine, _Connector);

  function ConnectorLine() {
    _classCallCheck(this, ConnectorLine);

    return _possibleConstructorReturn(this, (ConnectorLine.__proto__ || Object.getPrototypeOf(ConnectorLine)).apply(this, arguments));
  }

  _createClass(ConnectorLine, [{
    key: "getComponents",
    value: function getComponents(_ref) {
      var x = _ref.x,
          y = _ref.y,
          dy = _ref.dy,
          dx = _ref.dx,
          radius = _ref.radius,
          outerRadius = _ref.outerRadius,
          width = _ref.width,
          height = _ref.height;

      return (0, _typeLine2.default)({ x: x, y: y, dx: dx, dy: dy, radius: radius, outerRadius: outerRadius, width: width, height: height });
    }
  }]);

  return ConnectorLine;
}(_Connector3.default);

exports.default = ConnectorLine;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _endDot = __webpack_require__(974);

var _endDot2 = _interopRequireDefault(_endDot);

var _ConnectorEnd2 = __webpack_require__(378);

var _ConnectorEnd3 = _interopRequireDefault(_ConnectorEnd2);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */


var ConnectorEndDot = function (_ConnectorEnd) {
  _inherits(ConnectorEndDot, _ConnectorEnd);

  function ConnectorEndDot() {
    _classCallCheck(this, ConnectorEndDot);

    return _possibleConstructorReturn(this, (ConnectorEndDot.__proto__ || Object.getPrototypeOf(ConnectorEndDot)).apply(this, arguments));
  }

  _createClass(ConnectorEndDot, [{
    key: "getComponents",
    value: function getComponents(_ref) {
      var x = _ref.x,
          y = _ref.y,
          dy = _ref.dy,
          dx = _ref.dx,
          lineData = _ref.lineData,
          scale = _ref.scale;

      return (0, _endDot2.default)({ x: x, y: y, dx: dx, dy: dy, lineData: lineData, scale: scale });
    }
  }]);

  return ConnectorEndDot;
}(_ConnectorEnd3.default);

exports.default = ConnectorEndDot;


ConnectorEndDot.propTypes = {
  x: _propTypes2.default.number,
  y: _propTypes2.default.number,
  dx: _propTypes2.default.number,
  dy: _propTypes2.default.number,
  scale: _propTypes2.default.number,
  lineData: _propTypes2.default.array
  //array of arrays of x,y coordinates for the connector line
};

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConnectorEnd = function (_React$Component) {
  _inherits(ConnectorEnd, _React$Component);

  function ConnectorEnd() {
    _classCallCheck(this, ConnectorEnd);

    return _possibleConstructorReturn(this, (ConnectorEnd.__proto__ || Object.getPrototypeOf(ConnectorEnd)).apply(this, arguments));
  }

  _createClass(ConnectorEnd, [{
    key: "getComponents",
    value: function getComponents() {}
  }, {
    key: "render",
    value: function render() {
      var color = this.props.color;

      var d = this.getComponents(this.props) || [];
      var c = d.components[0];

      return _react2.default.createElement(c.type, _extends({ className: c.className }, c.attrs, { fill: color }));
    }
  }]);

  return ConnectorEnd;
}(_react2.default.Component);

exports.default = ConnectorEnd;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _endArrow = __webpack_require__(975);

var _endArrow2 = _interopRequireDefault(_endArrow);

var _ConnectorEnd2 = __webpack_require__(378);

var _ConnectorEnd3 = _interopRequireDefault(_ConnectorEnd2);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */


var ConnectorEndArrow = function (_ConnectorEnd) {
  _inherits(ConnectorEndArrow, _ConnectorEnd);

  function ConnectorEndArrow() {
    _classCallCheck(this, ConnectorEndArrow);

    return _possibleConstructorReturn(this, (ConnectorEndArrow.__proto__ || Object.getPrototypeOf(ConnectorEndArrow)).apply(this, arguments));
  }

  _createClass(ConnectorEndArrow, [{
    key: "getComponents",
    value: function getComponents(_ref) {
      var x = _ref.x,
          y = _ref.y,
          dy = _ref.dy,
          dx = _ref.dx,
          lineData = _ref.lineData,
          scale = _ref.scale;

      var start = lineData[1];
      var end = lineData[0];
      var distance = Math.sqrt(Math.pow(start[0] - end[0], 2) + Math.pow(start[1] - end[1], 2));
      if (distance < 5 && lineData[2]) {
        start = lineData[2];
      }

      return (0, _endArrow2.default)({ x: x, y: y, dx: dx, dy: dy, start: start, end: end, scale: scale });
    }
  }]);

  return ConnectorEndArrow;
}(_ConnectorEnd3.default);

exports.default = ConnectorEndArrow;


ConnectorEndArrow.propTypes = {
  x: _propTypes2.default.number,
  y: _propTypes2.default.number,
  dx: _propTypes2.default.number,
  dy: _propTypes2.default.number,
  scale: _propTypes2.default.number,
  lineData: _propTypes2.default.array
};

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _badge = __webpack_require__(977);

var _badge2 = _interopRequireDefault(_badge);

var _Subject2 = __webpack_require__(36);

var _Subject3 = _interopRequireDefault(_Subject2);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */


var SubjectBadge = function (_Subject) {
  _inherits(SubjectBadge, _Subject);

  function SubjectBadge() {
    _classCallCheck(this, SubjectBadge);

    return _possibleConstructorReturn(this, (SubjectBadge.__proto__ || Object.getPrototypeOf(SubjectBadge)).apply(this, arguments));
  }

  _createClass(SubjectBadge, [{
    key: "getComponents",
    value: function getComponents(_ref) {
      var leftRight = _ref.leftRight,
          topBottom = _ref.topBottom,
          text = _ref.text,
          editMode = _ref.editMode,
          color = _ref.color,
          radius = _ref.radius;

      var components = (0, _badge2.default)({
        leftRight: leftRight,
        topBottom: topBottom,
        text: text,
        editMode: editMode,
        color: color,
        radius: radius
      });

      components.handleKeys = { leftRight: leftRight, topBottom: topBottom };
      components.handleFunction = function (h, data) {
        var lr = data.x < -radius * 2 ? "left" : data.x > radius * 2 ? "right" : undefined;
        var tb = data.y < -radius * 2 ? "top" : data.y > radius * 2 ? "bottom" : undefined;

        return {
          leftRight: lr,
          topBottom: tb
        };
      };

      return components;
    }
  }]);

  return SubjectBadge;
}(_Subject3.default);

exports.default = SubjectBadge;


SubjectBadge.propTypes = {
  leftRight: _propTypes2.default.oneOf(["left", "right"]),
  topBottom: _propTypes2.default.oneOf(["top", "bottom"]),
  text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  color: _propTypes2.default.string,
  editMode: _propTypes2.default.bool
};

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _circle = __webpack_require__(978);

var _circle2 = _interopRequireDefault(_circle);

var _Subject2 = __webpack_require__(36);

var _Subject3 = _interopRequireDefault(_Subject2);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */


var SubjectCircle = function (_Subject) {
  _inherits(SubjectCircle, _Subject);

  function SubjectCircle() {
    _classCallCheck(this, SubjectCircle);

    return _possibleConstructorReturn(this, (SubjectCircle.__proto__ || Object.getPrototypeOf(SubjectCircle)).apply(this, arguments));
  }

  _createClass(SubjectCircle, [{
    key: "getComponents",
    value: function getComponents(_ref) {
      var _ref$radius = _ref.radius,
          radius = _ref$radius === undefined ? 20 : _ref$radius,
          innerRadius = _ref.innerRadius,
          outerRadius = _ref.outerRadius,
          radiusPadding = _ref.radiusPadding,
          editMode = _ref.editMode;

      var components = (0, _circle2.default)({
        radius: radius,
        radiusPadding: radiusPadding,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        editMode: editMode
      });

      components.handleKeys = { radius: radius, innerRadius: innerRadius, outerRadius: outerRadius };
      components.handleFunction = function (h, data) {
        return _defineProperty({}, h.key, components.handleKeys[h.key] + data.deltaX * Math.sqrt(2));
      };
      return components;
    }
  }]);

  return SubjectCircle;
}(_Subject3.default);

exports.default = SubjectCircle;


SubjectCircle.propTypes = {
  radius: _propTypes2.default.number,
  innerRadius: _propTypes2.default.number,
  outerRadius: _propTypes2.default.number,
  radiusPadding: _propTypes2.default.number,
  editMode: _propTypes2.default.bool
};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rect = __webpack_require__(979);

var _rect2 = _interopRequireDefault(_rect);

var _Subject2 = __webpack_require__(36);

var _Subject3 = _interopRequireDefault(_Subject2);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */


var SubjectRect = function (_Subject) {
  _inherits(SubjectRect, _Subject);

  function SubjectRect() {
    _classCallCheck(this, SubjectRect);

    return _possibleConstructorReturn(this, (SubjectRect.__proto__ || Object.getPrototypeOf(SubjectRect)).apply(this, arguments));
  }

  _createClass(SubjectRect, [{
    key: "getComponents",
    value: function getComponents(_ref) {
      var _ref$width = _ref.width,
          width = _ref$width === undefined ? 100 : _ref$width,
          _ref$height = _ref.height,
          height = _ref$height === undefined ? 100 : _ref$height,
          editMode = _ref.editMode;

      var components = (0, _rect2.default)({ width: width, height: height, editMode: editMode });
      components.handleKeys = { width: width, height: height };

      components.handleFunction = function (h, data) {
        return _defineProperty({}, h.key, h.key === "width" ? width + data.deltaX : height + data.deltaY);
      };

      return components;
    }
  }]);

  return SubjectRect;
}(_Subject3.default);

exports.default = SubjectRect;


SubjectRect.propTypes = {
  width: _propTypes2.default.number,
  height: _propTypes2.default.number,
  editMode: _propTypes2.default.bool
};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _threshold = __webpack_require__(980);

var _threshold2 = _interopRequireDefault(_threshold);

var _Subject2 = __webpack_require__(36);

var _Subject3 = _interopRequireDefault(_Subject2);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */


var SubjectThreshold = function (_Subject) {
  _inherits(SubjectThreshold, _Subject);

  function SubjectThreshold() {
    _classCallCheck(this, SubjectThreshold);

    return _possibleConstructorReturn(this, (SubjectThreshold.__proto__ || Object.getPrototypeOf(SubjectThreshold)).apply(this, arguments));
  }

  _createClass(SubjectThreshold, [{
    key: "getComponents",
    value: function getComponents(_ref) {
      var x1 = _ref.x1,
          x2 = _ref.x2,
          y1 = _ref.y1,
          y2 = _ref.y2,
          x = _ref.x,
          y = _ref.y,
          editMode = _ref.editMode;

      return (0, _threshold2.default)({ x1: x1, x2: x2, y1: y1, y2: y2, x: x, y: y, editMode: editMode });
    }
  }]);

  return SubjectThreshold;
}(_Subject3.default);

exports.default = SubjectThreshold;


SubjectThreshold.propTypes = {
  x: _propTypes2.default.number,
  x1: _propTypes2.default.number,
  x2: _propTypes2.default.number,
  y: _propTypes2.default.number,
  y1: _propTypes2.default.number,
  y2: _propTypes2.default.number,
  editMode: _propTypes2.default.bool
};

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _bracket = __webpack_require__(981);

var _bracket2 = _interopRequireDefault(_bracket);

var _Subject2 = __webpack_require__(36);

var _Subject3 = _interopRequireDefault(_Subject2);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */


var SubjectBracket = function (_Subject) {
  _inherits(SubjectBracket, _Subject);

  function SubjectBracket() {
    _classCallCheck(this, SubjectBracket);

    return _possibleConstructorReturn(this, (SubjectBracket.__proto__ || Object.getPrototypeOf(SubjectBracket)).apply(this, arguments));
  }

  _createClass(SubjectBracket, [{
    key: "getComponents",
    value: function getComponents(_ref) {
      var height = _ref.height,
          width = _ref.width,
          _ref$depth = _ref.depth,
          depth = _ref$depth === undefined ? 20 : _ref$depth,
          _ref$type = _ref.type,
          type = _ref$type === undefined ? "square" : _ref$type,
          editMode = _ref.editMode;

      var components = (0, _bracket2.default)({ height: height, width: width, depth: depth, type: type, editMode: editMode });

      var handleKeys = { height: height, width: width, depth: depth };
      components.handleFunction = function (h, data) {
        if (h.key === "depth") {
          return {
            depth: depth + data["delta" + h.type]
          };
        } else {
          return _defineProperty({}, h.key, handleKeys[h.key] + data[h.key === "width" ? "deltaX" : "deltaY"]);
        }
      };

      return components;
    }
  }]);

  return SubjectBracket;
}(_Subject3.default);

exports.default = SubjectBracket;


SubjectBracket.propTypes = {
  width: _propTypes2.default.number,
  height: _propTypes2.default.number,
  depth: _propTypes2.default.number,
  editMode: _propTypes2.default.bool
};

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Subject2 = __webpack_require__(36);

var _Subject3 = _interopRequireDefault(_Subject2);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Handle = __webpack_require__(198);

var _Handle2 = _interopRequireDefault(_Handle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */
// import Bracket from "./bracket"


var SubjectCustom = function (_Subject) {
  _inherits(SubjectCustom, _Subject);

  function SubjectCustom() {
    _classCallCheck(this, SubjectCustom);

    return _possibleConstructorReturn(this, (SubjectCustom.__proto__ || Object.getPrototypeOf(SubjectCustom)).apply(this, arguments));
  }

  _createClass(SubjectCustom, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          _props$custom = _props.custom,
          custom = _props$custom === undefined ? "M0,0" : _props$custom,
          customID = _props.customID,
          editMode = _props.editMode,
          transform = _props.transform;


      var handles = void 0;
      if (editMode) {
        handles = _react2.default.createElement(_Handle2.default, {
          handleStart: this.props.onDragStart,
          handleStop: this.props.onDragEnd,
          handleDrag: this.props.dragSubject
        });
      }

      return _react2.default.createElement(
        "g",
        { className: "annotation-subject" },
        _react2.default.createElement(
          "g",
          { transform: transform },
          typeof custom === "string" ? _react2.default.createElement("path", { d: custom, pointerEvents: "none" }) : _react2.default.createElement(
            "g",
            { pointerEvents: "none" },
            custom
          ),
          _react2.default.createElement(
            "mask",
            { id: customID, pointerEvents: "none" },
            _react2.default.createElement(
              "g",
              { transform: transform },
              _react2.default.createElement("rect", {
                x: "-100%",
                y: "-100%",
                height: "200%",
                width: "200%",
                fill: "white",
                pointerEvents: "none"
              }),
              typeof custom === "string" ? _react2.default.createElement("path", { d: custom, fill: "black", pointerEvents: "none" }) : _react2.default.createElement(
                "g",
                { fill: "black", pointerEvents: "none" },
                custom.map(function (c, i) {
                  return _react2.default.cloneElement(c, Object.assign({}, c.props, {
                    fill: "black",
                    opacity: 1,
                    key: "customSubject-" + i
                  }));
                })
              ),
              "}"
            )
          )
        ),
        handles
      );
    }
  }]);

  return SubjectCustom;
}(_Subject3.default);

exports.default = SubjectCustom;


SubjectCustom.propTypes = {
  editMode: _propTypes2.default.bool
};

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = BracketNote;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Note = __webpack_require__(199);

var _Note2 = _interopRequireDefault(_Note);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */

function BracketNote(_ref) {
  var width = _ref.width,
      height = _ref.height,
      depth = _ref.depth,
      rest = _objectWithoutProperties(_ref, ["width", "height", "depth"]);

  var dx = rest.dx,
      orientation = void 0,
      align = "middle",
      dy = rest.dy;

  if (height) {
    if (!dy) dy = height / 2;
    if (!dx) dx = depth;
    orientation = "leftRight";
  } else if (width) {
    if (!dx) dx = width / 2;
    if (!dy) dy = depth;
    orientation = "topBottom";
  }

  return _react2.default.createElement(_Note2.default, _extends({
    align: align,
    orientation: orientation,
    padding: 10
  }, rest, {
    editMode: false,
    dx: dx,
    dy: dy
  }));
}

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Annotation = __webpack_require__(201);

var _Annotation2 = _interopRequireDefault(_Annotation);

var _classnames = __webpack_require__(202);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditableAnnotation = function (_React$Component) {
  _inherits(EditableAnnotation, _React$Component);

  function EditableAnnotation() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EditableAnnotation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditableAnnotation.__proto__ || Object.getPrototypeOf(EditableAnnotation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      x: 0,
      y: 0,
      dx: 0,
      dy: 0
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EditableAnnotation, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.setState({
        x: this.props.x,
        y: this.props.y,
        dx: this.props.dx,
        dy: this.props.dy
      });
    }
  }, {
    key: "getData",
    value: function getData() {
      return Object.assign({}, this.props, this.state);
    }
  }, {
    key: "dragEnd",
    value: function dragEnd() {
      if (this.props.onDragEnd) {
        this.props.onDragEnd(this.getData());
      }
    }
  }, {
    key: "dragStart",
    value: function dragStart() {
      if (this.props.onDragStart) {
        this.props.onDragStart(this.getData());
      }
    }
  }, {
    key: "dragSubject",
    value: function dragSubject(event, data) {
      var _this2 = this;

      this.setState({
        x: this.state.x + data.deltaX,
        y: this.state.y + data.deltaY
      }, function () {
        if (_this2.props.onDrag) _this2.props.onDrag(_this2.getData());
      });
    }
  }, {
    key: "dragSubjectSettings",
    value: function dragSubjectSettings(event, data) {
      var _this3 = this;

      this.setState(data, function () {
        if (_this3.props.onDrag) _this3.props.onDrag(_this3.getData());
      });
    }
  }, {
    key: "dragNote",
    value: function dragNote(event, data) {
      var _this4 = this;

      this.setState({
        dx: this.state.dx + data.deltaX,
        dy: this.state.dy + data.deltaY
      }, function () {
        if (_this4.props.onDrag) _this4.props.onDrag(_this4.getData());
      });
    }
  }, {
    key: "render",
    value: function render() {
      var cleanedProps = Object.assign({}, this.props, _extends({}, this.state, {
        dragSubject: this.dragSubject.bind(this),
        dragNote: this.dragNote.bind(this),
        dragSubjectSettings: this.dragSubjectSettings.bind(this),
        dragEnd: this.dragEnd.bind(this),
        dragStart: this.dragStart.bind(this),
        editMode: true,
        className: (0, _classnames2.default)(this.props.className, "editable")
      }));

      return _react2.default.createElement(_Annotation2.default, cleanedProps);
    }
  }]);

  return EditableAnnotation;
}(_react2.default.Component);

exports.default = EditableAnnotation;

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__point__ = __webpack_require__(389);






/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x0 = __WEBPACK_IMPORTED_MODULE_4__point__["a" /* x */],
      x1 = null,
      y0 = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      y1 = __WEBPACK_IMPORTED_MODULE_4__point__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return Object(__WEBPACK_IMPORTED_MODULE_3__line__["a" /* default */])().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
});


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}


/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return curveRadialLinear; });
/* harmony export (immutable) */ __webpack_exports__["b"] = curveRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(122);


var curveRadialLinear = curveRadial(__WEBPACK_IMPORTED_MODULE_0__linear__["a" /* default */]);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}


/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = radialLine;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line__ = __webpack_require__(204);



function radialLine(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* default */])(_)) : c()._curve;
  };

  return l;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return radialLine(Object(__WEBPACK_IMPORTED_MODULE_1__line__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* curveRadialLinear */]));
});


/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(82);


/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / __WEBPACK_IMPORTED_MODULE_0__math__["c" /* pi */]);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, __WEBPACK_IMPORTED_MODULE_0__math__["d" /* tau */]);
  }
});


/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
});


/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
});


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(82);


var ka = 0.89081309152928522810,
    kr = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* pi */] / 10) / Math.sin(7 * __WEBPACK_IMPORTED_MODULE_0__math__["c" /* pi */] / 10),
    kx = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* tau */] / 10) * kr,
    ky = -Math.cos(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* tau */] / 10) * kr;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = __WEBPACK_IMPORTED_MODULE_0__math__["d" /* tau */] * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
});


/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
});


/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sqrt3 = Math.sqrt(3);

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
});


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var c = -0.5,
    s = Math.sqrt(3) / 2,
    k = 1 / Math.sqrt(12),
    a = (k / 2 + 1) * 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
});


/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalClosed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(125);



function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__cardinal__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinal__ = __webpack_require__(125);


function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__cardinal__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bisectRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bisectLeft; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(402);



var ascendingBisect = Object(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["c"] = (bisectRight);


/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(59);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = pair;
/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(405);


/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  var v = Object(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});


/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(85);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tickIncrement;
/* harmony export (immutable) */ __webpack_exports__["c"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, count) {
  var reverse = stop < start,
      i = -1,
      n,
      ticks,
      step;

  if (reverse) n = start, start = stop, stop = n;

  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});


/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(411);


/* harmony default export */ __webpack_exports__["a"] = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = Object(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Selection = __webpack_require__(19);

__webpack_require__(1059);

var _drawing = __webpack_require__(1090);

var _markTransition = __webpack_require__(1133);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Mark = function (_React$Component) {
  _inherits(Mark, _React$Component);

  function Mark(props) {
    _classCallCheck(this, Mark);

    var _this = _possibleConstructorReturn(this, (Mark.__proto__ || Object.getPrototypeOf(Mark)).call(this, props));

    _this._mouseup = _this._mouseup.bind(_this);
    _this._mousedown = _this._mousedown.bind(_this);
    _this._mousemove = _this._mousemove.bind(_this);

    _this.state = {
      translate: [0, 0],
      mouseOrigin: [],
      translateOrigin: [0, 0],
      dragging: false,
      uiUpdate: false
    };
    return _this;
  }

  _createClass(Mark, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      //data-driven transition time?
      if (this.props.markType !== nextProps.markType || this.state.dragging || this.props.forceUpdate || nextProps.forceUpdate || this.props.renderMode !== nextProps.renderMode || this.props.className !== nextProps.className || this.props.children !== nextProps.children) {
        return true;
      }

      var canvas = this.props.canvas !== true && this.props.canvas || this.context && this.context.canvas;

      var node = this.node;

      var actualSVG = (0, _drawing.generateSVG)(nextProps, nextProps.className);
      var cloneProps = actualSVG.props;

      if (!cloneProps) {
        return true;
      }

      var _nextProps$transition = nextProps.transitionDuration,
          transitionDuration = _nextProps$transition === undefined ? {} : _nextProps$transition;

      var isDefault = typeof transitionDuration === "number";
      var defaultDuration = isDefault ? transitionDuration : 1000;
      transitionDuration = isDefault ? { default: defaultDuration } : _extends({ default: defaultDuration }, transitionDuration);

      _markTransition.attributeTransitionWhitelist.forEach(function (attr) {
        if ((0, _d3Selection.select)(node).select("*").transition) {
          if (attr === "d" && (0, _markTransition.differentD)(cloneProps.d, this.props.d)) {
            (0, _d3Selection.select)(node).select("*").attr("d", cloneProps.d);
          } else if (cloneProps[attr] !== this.props[attr]) {
            if (_markTransition.reactCSSNameStyleHash[attr]) {
              attr = _markTransition.reactCSSNameStyleHash[attr];
            }

            var _transitionDuration = transitionDuration,
                defaultDur = _transitionDuration.default,
                _transitionDuration$a = _transitionDuration[attr],
                appliedDuration = _transitionDuration$a === undefined ? defaultDur : _transitionDuration$a;


            (0, _d3Selection.select)(node).select("*").transition(attr).duration(appliedDuration).attr(attr, cloneProps[attr]);
          }
        }
      }, this);

      if (cloneProps.style) {
        _markTransition.attributeTransitionWhitelist.forEach(function (style) {
          if (cloneProps.style[style] !== this.props.style[style]) {
            var nextValue = cloneProps.style[style];

            if (_markTransition.reactCSSNameStyleHash[style]) {
              style = _markTransition.reactCSSNameStyleHash[style];
            }

            if ((0, _d3Selection.select)(node).select("*").transition) {
              var _transitionDuration2 = transitionDuration,
                  defaultDur = _transitionDuration2.default,
                  _transitionDuration2$ = _transitionDuration2[style],
                  appliedDuration = _transitionDuration2$ === undefined ? defaultDur : _transitionDuration2$;


              (0, _d3Selection.select)(node).select("*").transition(style).duration(appliedDuration).style(style, nextValue);
            } else {
              (0, _d3Selection.select)(node).select("*").style(style, nextValue);
            }
          }
        }, this);
      }

      return false;
    }
  }, {
    key: "_mouseup",
    value: function _mouseup() {
      document.onmousemove = null;

      var finalTranslate = [0, 0];
      if (!this.props.resetAfter) finalTranslate = this.state.translate;

      this.setState({
        dragging: false,
        translate: finalTranslate,
        uiUpdate: false
      });
      if (this.props.dropFunction && this.props.context && this.props.context.dragSource) {
        this.props.dropFunction(this.props.context.dragSource.props, this.props);
        this.props.updateContext("dragSource", undefined);
      }
    }
  }, {
    key: "_mousedown",
    value: function _mousedown(event) {
      this.setState({
        mouseOrigin: [event.pageX, event.pageY],
        translateOrigin: this.state.translate,
        dragging: true
      });
      document.onmouseup = this._mouseup;
      document.onmousemove = this._mousemove;
    }
  }, {
    key: "_mousemove",
    value: function _mousemove(event) {
      var xAdjust = this.props.freezeX ? 0 : 1;
      var yAdjust = this.props.freezeY ? 0 : 1;

      var adjustedPosition = [event.pageX - this.state.mouseOrigin[0], event.pageY - this.state.mouseOrigin[1]];
      var adjustedTranslate = [(adjustedPosition[0] + this.state.translateOrigin[0]) * xAdjust, (adjustedPosition[1] + this.state.translateOrigin[1]) * yAdjust];
      if (this.props.dropFunction && this.state.uiUpdate === false) {
        this.props.updateContext("dragSource", this);
        this.setState({
          translate: adjustedTranslate,
          uiUpdate: true,
          dragging: true
        });
      } else {
        this.setState({ translate: adjustedTranslate });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var className = this.props.className || "";

      var mouseIn = null;
      var mouseOut = null;

      var actualSVG = (0, _drawing.generateSVG)(this.props, className);

      if (this.props.draggable) {
        return _react2.default.createElement(
          "g",
          {
            ref: function ref(node) {
              return _this2.node = node;
            },
            className: className,
            onMouseEnter: mouseIn,
            onMouseOut: mouseOut,
            onDoubleClick: this._doubleclick,
            style: {
              pointerEvents: this.props.dropFunction && this.state.dragging ? "none" : "all"
            },
            onMouseDown: this._mousedown,
            onMouseUp: this._mouseup,
            transform: "translate(" + this.state.translate + ")"
          },
          actualSVG
        );
      } else {
        return _react2.default.createElement(
          "g",
          {
            ref: function ref(node) {
              return _this2.node = node;
            },
            className: className,
            onMouseEnter: mouseIn,
            onMouseOut: mouseOut
          },
          actualSVG
        );
      }
    }
  }]);

  return Mark;
}(_react2.default.Component);

Mark.propTypes = {
  markType: _propTypes2.default.string.isRequired,
  forceUpdate: _propTypes2.default.bool,
  renderMode: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  draggable: _propTypes2.default.bool,
  dropFunction: _propTypes2.default.func,
  resetAfter: _propTypes2.default.bool,
  freezeX: _propTypes2.default.bool,
  freezeY: _propTypes2.default.bool,
  context: _propTypes2.default.object,
  updateContext: _propTypes2.default.func,
  className: _propTypes2.default.string
};

Mark.contextTypes = {
  canvas: _propTypes2.default.object
};

exports.default = Mark;
module.exports = exports['default'];

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var matcher = function(selector) {
  return function() {
    return this.matches(selector);
  };
};

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!element.matches) {
    var vendorMatches = element.webkitMatchesSelector
        || element.msMatchesSelector
        || element.mozMatchesSelector
        || element.oMatchesSelector;
    matcher = function(selector) {
      return function() {
        return vendorMatches.call(this, selector);
      };
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (matcher);


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function empty() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
});


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = EnterNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(20);



/* harmony default export */ __webpack_exports__["b"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Selection */](this._enter || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(update) {
  return new Array(update.length);
});


/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = styleValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(215);


function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove : typeof value === "function"
            ? styleFunction
            : styleConstant)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
});

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || Object(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node).getComputedStyle(node, null).getPropertyValue(name);
}


/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_schedule__ = __webpack_require__(21);


/* harmony default export */ __webpack_exports__["a"] = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule.state > __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["d" /* STARTING */] && schedule.state < __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["b" /* ENDING */];
    schedule.state = __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["a" /* ENDED */];
    schedule.timer.stop();
    if (active) schedule.on.call("interrupt", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
});


/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rgbBasis */
/* unused harmony export rgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(86);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = Object(__WEBPACK_IMPORTED_MODULE_3__color__["b" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["rgb"])(start)).r, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["rgb"])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["rgb"])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["b" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);


/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(217);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return Object(__WEBPACK_IMPORTED_MODULE_0__basis__["a" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(216);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(nb),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(216);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(127);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(38);



/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var c;
  return (typeof b === "number" ? __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateNumber */]
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["color"] ? __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateRgb */]
      : (c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["color"])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateRgb */])
      : __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["f" /* interpolateString */])(a, b);
});


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__point__ = __webpack_require__(429);






/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x0 = __WEBPACK_IMPORTED_MODULE_4__point__["a" /* x */],
      x1 = null,
      y0 = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      y1 = __WEBPACK_IMPORTED_MODULE_4__point__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return Object(__WEBPACK_IMPORTED_MODULE_3__line__["a" /* default */])().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
});


/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return curveRadialLinear; });
/* harmony export (immutable) */ __webpack_exports__["b"] = curveRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(129);


var curveRadialLinear = curveRadial(__WEBPACK_IMPORTED_MODULE_0__linear__["a" /* default */]);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = radialLine;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line__ = __webpack_require__(218);



function radialLine(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* default */])(_)) : c()._curve;
  };

  return l;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return radialLine(Object(__WEBPACK_IMPORTED_MODULE_1__line__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* curveRadialLinear */]));
});


/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(87);


/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / __WEBPACK_IMPORTED_MODULE_0__math__["c" /* pi */]);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, __WEBPACK_IMPORTED_MODULE_0__math__["d" /* tau */]);
  }
});


/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
});


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
});


/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(87);


var ka = 0.89081309152928522810,
    kr = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* pi */] / 10) / Math.sin(7 * __WEBPACK_IMPORTED_MODULE_0__math__["c" /* pi */] / 10),
    kx = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* tau */] / 10) * kr,
    ky = -Math.cos(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* tau */] / 10) * kr;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = __WEBPACK_IMPORTED_MODULE_0__math__["d" /* tau */] * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
});


/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
});


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sqrt3 = Math.sqrt(3);

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
});


/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var c = -0.5,
    s = Math.sqrt(3) / 2,
    k = 1 / Math.sqrt(12),
    a = (k / 2 + 1) * 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
});


/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalClosed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(132);



function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__cardinal__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinal__ = __webpack_require__(132);


function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__cardinal__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return implicit; });
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(49);



var implicit = {name: "implicit"};

function ordinal(range) {
  var index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["map"])(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["map"])();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}


/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return +x;
});


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_time_format__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__array__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__continuous__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(443);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_5__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateNumber */]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisector"])(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start, stop, interval);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_4__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(Object(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval))
        : scale;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["a" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__["k" /* timeYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["f" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["j" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["a" /* timeDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["b" /* timeHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["d" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["g" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["c" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_3_d3_time_format__["a" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
});


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return implicit; });
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(50);



var implicit = {name: "implicit"};

function ordinal(range) {
  var index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["map"])(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["map"])();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rgbBasis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rgbBasisClosed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(94);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = Object(__WEBPACK_IMPORTED_MODULE_3__color__["b" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["rgb"])(start)).r, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["rgb"])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["rgb"])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["b" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(224);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return Object(__WEBPACK_IMPORTED_MODULE_0__basis__["a" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(223);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(nb),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(223);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(135);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return +x;
});


/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_time_format__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__array__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__continuous__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(454);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_5__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateNumber"]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisector"])(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start, stop, interval);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_4__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(Object(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval))
        : scale;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["a" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__["k" /* timeYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["f" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["j" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["a" /* timeDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["b" /* timeHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["d" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["g" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["c" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_3_d3_time_format__["a" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
});


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Brush = __webpack_require__(329);

var _d3Array = __webpack_require__(12);

var _d3Selection = __webpack_require__(229);

var _d3Voronoi = __webpack_require__(1212);

var _semioticMark = __webpack_require__(15);

var _Brush = __webpack_require__(464);

var _Brush2 = _interopRequireDefault(_Brush);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SpanOrDiv = __webpack_require__(203);

var _SpanOrDiv2 = _interopRequireDefault(_SpanOrDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// components


var InteractionLayer = function (_React$Component) {
  _inherits(InteractionLayer, _React$Component);

  function InteractionLayer(props) {
    _classCallCheck(this, InteractionLayer);

    var _this = _possibleConstructorReturn(this, (InteractionLayer.__proto__ || Object.getPrototypeOf(InteractionLayer)).call(this, props));

    _this.createBrush = _this.createBrush.bind(_this);
    _this.createColumnsBrush = _this.createColumnsBrush.bind(_this);
    _this.brushStart = _this.brushStart.bind(_this);
    _this.brush = _this.brush.bind(_this);
    _this.brushEnd = _this.brushEnd.bind(_this);
    _this.changeVoronoi = _this.changeVoronoi.bind(_this);
    _this.doubleclickVoronoi = _this.doubleclickVoronoi.bind(_this);
    _this.clickVoronoi = _this.clickVoronoi.bind(_this);
    _this.calculateOverlay = _this.calculateOverlay.bind(_this);

    var initialOverlay = _this.calculateOverlay(props);

    _this.state = {
      overlayRegions: initialOverlay
    };
    return _this;
  }

  _createClass(InteractionLayer, [{
    key: "changeVoronoi",
    value: function changeVoronoi(d, customHoverTypes) {
      //Until semiotic 2
      var dataObject = d && d.data ? _extends({}, d.data, d) : d;
      if (this.props.customHoverBehavior) this.props.customHoverBehavior(dataObject);

      if (!d) this.props.voronoiHover(null);else if (customHoverTypes === true) {
        var vorD = _extends({}, dataObject);
        vorD.type = vorD.type === "column-hover" ? "column-hover" : "frame-hover";
        this.props.voronoiHover(vorD);
      } else {
        var arrayWrappedHoverTypes = Array.isArray(customHoverTypes) ? customHoverTypes : [customHoverTypes];
        var mappedHoverTypes = arrayWrappedHoverTypes.map(function (c) {
          var finalC = typeof c === "function" ? c(dataObject) : c;
          return _extends({}, dataObject, finalC);
        });
        this.props.voronoiHover(mappedHoverTypes);
      }
    }
  }, {
    key: "clickVoronoi",
    value: function clickVoronoi(d) {
      //Until semiotic 2
      var dataObject = d.data ? _extends({}, d.data, d) : d;

      if (this.props.customClickBehavior) this.props.customClickBehavior(dataObject);
    }
  }, {
    key: "doubleclickVoronoi",
    value: function doubleclickVoronoi(d) {
      //Until semiotic 2
      var dataObject = d.data ? _extends({}, d.data, d) : d;

      if (this.props.customDoubleClickBehavior) this.props.customClickBehavior(dataObject);
    }
  }, {
    key: "brushStart",
    value: function brushStart(e, c) {
      if (this.props.interaction.start) this.props.interaction.start(e, c);
    }
  }, {
    key: "brush",
    value: function brush(e, c) {
      if (this.props.interaction.during) this.props.interaction.during(e, c);
    }
  }, {
    key: "brushEnd",
    value: function brushEnd(e, c) {
      if (this.props.interaction.end) this.props.interaction.end(e, c);
    }
  }, {
    key: "createBrush",
    value: function createBrush() {
      var _this2 = this;

      var semioticBrush = void 0,
          mappingFn = void 0,
          selectedExtent = void 0;

      var _props = this.props,
          interaction = _props.interaction,
          xScale = _props.xScale,
          yScale = _props.yScale,
          size = _props.size;
      var _interaction$extent = interaction.extent,
          extent = _interaction$extent === undefined ? interaction.brush === "xyBrush" ? [[xScale.invert(0), yScale.invert(0)], [xScale.invert(size[0]), yScale.invert(size[1])]] : interaction.brush === "xBrush" ? [xScale.invert(0), xScale.invert(size[0])] : [yScale.invert(0), yScale.invert(size[1])] : _interaction$extent;


      if (extent.indexOf(undefined) !== -1) {
        return _react2.default.createElement("g", null);
      }

      if (interaction.brush === "xBrush") {
        if (extent.indexOf(undefined) !== -1) {
          return _react2.default.createElement("g", null);
        }

        mappingFn = function mappingFn(d) {
          return !d ? null : [xScale.invert(d[0]), xScale.invert(d[1])];
        };
        semioticBrush = (0, _d3Brush.brushX)();
        selectedExtent = extent.map(function (d) {
          return xScale(d);
        });
      } else if (interaction.brush === "yBrush") {
        if (extent.indexOf(undefined) !== -1) {
          return _react2.default.createElement("g", null);
        }

        mappingFn = function mappingFn(d) {
          return !d ? null : [yScale.invert(d[0]), yScale.invert(d[1])];
        };
        semioticBrush = (0, _d3Brush.brushY)();
        selectedExtent = extent.map(function (d) {
          return yScale(d);
        });
      } else {
        if (extent.indexOf(undefined) !== -1 || extent[0].indexOf(undefined) !== -1 || extent[1].indexOf(undefined) !== -1) {
          return _react2.default.createElement("g", null);
        }

        semioticBrush = (0, _d3Brush.brush)();
        mappingFn = function mappingFn(d) {
          return !d ? null : [[xScale.invert(d[0][0]), yScale.invert(d[0][1])], [xScale.invert(d[1][0]), yScale.invert(d[1][1])]];
        };
        selectedExtent = extent.map(function (d) {
          return [xScale(d[0]), yScale(d[1])];
        });
      }

      semioticBrush.extent([[0, 0], [this.props.size[0], this.props.size[1]]]).on("start", function () {
        _this2.brushStart(mappingFn(_d3Selection.event.selection));
      }).on("brush", function () {
        _this2.brush(mappingFn(_d3Selection.event.selection));
      }).on("end", function () {
        _this2.brushEnd(mappingFn(_d3Selection.event.selection));
      });

      return _react2.default.createElement(
        "g",
        { className: "brush" },
        _react2.default.createElement(_Brush2.default, {
          type: interaction.brush,
          selectedExtent: selectedExtent,
          extent: extent,
          svgBrush: semioticBrush,
          size: size
        })
      );
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ overlayRegions: this.calculateOverlay(nextProps) });
    }
  }, {
    key: "calculateOverlay",
    value: function calculateOverlay(props) {
      var _this3 = this;

      var voronoiPaths = [];
      var xScale = props.xScale,
          yScale = props.yScale,
          points = props.points,
          projectedX = props.projectedX,
          projectedY = props.projectedY,
          projectedYMiddle = props.projectedYMiddle,
          size = props.size,
          overlay = props.overlay,
          _props$interactionOve = props.interactionOverflow,
          interactionOverflow = _props$interactionOve === undefined ? { top: 0, bottom: 0, left: 0, right: 0 } : _props$interactionOve;


      if (points && props.hoverAnnotation && !overlay) {
        var voronoiDataset = [];
        var voronoiUniqueHash = {};

        points.forEach(function (d) {
          var xValue = parseInt(xScale(d[projectedX]), 10);
          var yValue = parseInt(yScale(d[projectedYMiddle] || d[projectedY]), 10);
          if (xValue >= 0 && xValue <= size[0] && yValue >= 0 && yValue <= size[1] && xValue !== undefined && yValue !== undefined && isNaN(xValue) === false && isNaN(yValue) === false) {
            var pointKey = xValue + "," + yValue;
            if (!voronoiUniqueHash[pointKey]) {
              var voronoiPoint = _extends({}, d, {
                coincidentPoints: [d],
                voronoiX: xValue,
                voronoiY: yValue
              });
              voronoiDataset.push(voronoiPoint);
              voronoiUniqueHash[pointKey] = voronoiPoint;
            } else voronoiUniqueHash[pointKey].coincidentPoints.push(d);
          }
        });

        var voronoiXExtent = (0, _d3Array.extent)(voronoiDataset.map(function (d) {
          return d.voronoiX;
        }));
        var voronoiYExtent = (0, _d3Array.extent)(voronoiDataset.map(function (d) {
          return d.voronoiY;
        }));

        var voronoiExtent = [[Math.min(voronoiXExtent[0], -interactionOverflow.left), Math.min(voronoiYExtent[0], -interactionOverflow.top)], [Math.max(voronoiXExtent[1], size[0] + interactionOverflow.right), Math.max(voronoiYExtent[1], size[1] + interactionOverflow.bottom)]];

        var voronoiDiagram = (0, _d3Voronoi.voronoi)().extent(voronoiExtent).x(function (d) {
          return d.voronoiX;
        }).y(function (d) {
          return d.voronoiY;
        });

        var voronoiData = voronoiDiagram.polygons(voronoiDataset);
        var voronoiLinks = voronoiDiagram.links(voronoiDataset);

        //create neighbors
        voronoiLinks.forEach(function (v) {
          if (!v.source.neighbors) v.source.neighbors = [];

          v.source.neighbors.push(v.target);
        });

        voronoiPaths = voronoiData.map(function (d, i) {
          return _react2.default.createElement("path", {
            onClick: function onClick() {
              _this3.clickVoronoi(voronoiDataset[i]);
            },
            onDoubleClick: function onDoubleClick() {
              _this3.doubleclickVoronoi(voronoiDataset[i]);
            },
            onMouseEnter: function onMouseEnter() {
              _this3.changeVoronoi(voronoiDataset[i], props.hoverAnnotation);
            },
            onMouseLeave: function onMouseLeave() {
              _this3.changeVoronoi();
            },
            key: "interactionVoronoi" + i,
            d: "M" + d.join("L") + "Z",
            style: { fillOpacity: 0 }
          });
        }, this);
        return voronoiPaths;
      } else if (overlay) {
        var renderedOverlay = overlay.map(function (overlayRegion, i) {
          return _react2.default.createElement(_semioticMark.Mark, _extends({
            key: "overlay-" + i,
            forceUpdate: true
          }, overlayRegion, {
            onClick: function onClick() {
              _this3.clickVoronoi(overlayRegion.onClick());
            },
            onDoubleClick: function onDoubleClick() {
              _this3.doubleclickVoronoi(overlayRegion.onDoubleClick());
            },
            onMouseEnter: function onMouseEnter() {
              _this3.changeVoronoi(overlayRegion.onMouseEnter(), props.hoverAnnotation);
            },
            onMouseLeave: function onMouseLeave() {
              _this3.changeVoronoi();
            }
          }));
        });

        return renderedOverlay;
      }
    }
  }, {
    key: "createColumnsBrush",
    value: function createColumnsBrush() {
      var _this4 = this;

      var _props2 = this.props,
          projection = _props2.projection,
          rScale = _props2.rScale,
          interaction = _props2.interaction,
          size = _props2.size,
          oColumns = _props2.oColumns;


      var semioticBrush = void 0,
          mappingFn = void 0;

      var max = rScale.domain()[1];

      var type = "yBrush";

      if (projection && projection === "horizontal") {
        type = "xBrush";
        mappingFn = function mappingFn(d) {
          return !d ? null : [rScale.invert(d[0]), rScale.invert(d[1])];
        };
      } else mappingFn = function mappingFn(d) {
        return !d ? null : [Math.abs(rScale.invert(d[1]) - max), Math.abs(rScale.invert(d[0]) - max)];
      };

      var rRange = rScale.range();

      var columnHash = oColumns;
      var brushPosition = void 0,
          selectedExtent = void 0;
      var brushes = Object.keys(columnHash).map(function (c) {
        if (projection && projection === "horizontal") {
          selectedExtent = interaction.extent[c] ? interaction.extent[c].map(function (d) {
            return rScale(d);
          }) : rRange;
          brushPosition = [0, columnHash[c].x];
          semioticBrush = (0, _d3Brush.brushX)();
          semioticBrush.extent([[rRange[0], 0], [rRange[1], columnHash[c].width]]).on("start", function () {
            _this4.brushStart(mappingFn(_d3Selection.event.selection), c);
          }).on("brush", function () {
            _this4.brush(mappingFn(_d3Selection.event.selection), c);
          }).on("end", function () {
            _this4.brushEnd(mappingFn(_d3Selection.event.selection), c);
          });
        } else {
          selectedExtent = interaction.extent[c] ? interaction.extent[c].map(function (d) {
            return rRange[1] - rScale(d);
          }).reverse() : rRange;
          brushPosition = [columnHash[c].x, 0];
          semioticBrush = (0, _d3Brush.brushY)();
          semioticBrush.extent([[0, rRange[0]], [columnHash[c].width, rRange[1]]]).on("start", function () {
            _this4.brushStart(mappingFn(_d3Selection.event.selection), c);
          }).on("brush", function () {
            _this4.brush(mappingFn(_d3Selection.event.selection), c);
          }).on("end", function () {
            _this4.brushEnd(mappingFn(_d3Selection.event.selection), c);
          });
        }

        return _react2.default.createElement(
          "g",
          { key: "column-brush-" + c, className: "brush" },
          _react2.default.createElement(_Brush2.default, {
            type: type,
            position: brushPosition,
            key: "orbrush" + c,
            selectedExtent: selectedExtent,
            svgBrush: semioticBrush,
            size: size
          })
        );
      });
      return brushes;
    }
  }, {
    key: "render",
    value: function render() {
      var semioticBrush = null;
      var _props3 = this.props,
          interaction = _props3.interaction,
          svgSize = _props3.svgSize,
          margin = _props3.margin,
          useSpans = _props3.useSpans;
      var overlayRegions = this.state.overlayRegions;
      var enabled = this.props.enabled;


      if (interaction && interaction.brush) {
        enabled = true;
        semioticBrush = this.createBrush();
      }
      if (interaction && interaction.columnsBrush) {
        enabled = true;
        semioticBrush = this.createColumnsBrush();
      }

      if (!overlayRegions && !semioticBrush) {
        return null;
      }

      return _react2.default.createElement(
        _SpanOrDiv2.default,
        {
          span: useSpans,
          className: "interaction-layer",
          style: {
            position: "absolute",
            background: "none",
            pointerEvents: "none"
          }
        },
        _react2.default.createElement(
          "svg",
          {
            height: svgSize[1],
            width: svgSize[0],
            style: { background: "none", pointerEvents: "none" }
          },
          _react2.default.createElement(
            "g",
            {
              className: "interaction-overlay",
              transform: "translate(" + margin.left + "," + margin.top + ")",
              style: { pointerEvents: enabled ? "all" : "none" }
            },
            _react2.default.createElement(
              "g",
              { className: "interaction-regions" },
              overlayRegions
            ),
            semioticBrush
          )
        )
      );
    }
  }]);

  return InteractionLayer;
}(_react2.default.Component);

InteractionLayer.propTypes = {
  name: _propTypes2.default.string,
  interaction: _propTypes2.default.object,
  overlay: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  oColumns: _propTypes2.default.object,
  xScale: _propTypes2.default.func,
  yScale: _propTypes2.default.func,
  rScale: _propTypes2.default.func,
  svgSize: _propTypes2.default.array
};

exports.default = InteractionLayer;
module.exports = exports['default'];

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var matcher = function(selector) {
  return function() {
    return this.matches(selector);
  };
};

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!element.matches) {
    var vendorMatches = element.webkitMatchesSelector
        || element.msMatchesSelector
        || element.mozMatchesSelector
        || element.oMatchesSelector;
    matcher = function(selector) {
      return function() {
        return vendorMatches.call(this, selector);
      };
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (matcher);


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function empty() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
});


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = EnterNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(22);



/* harmony default export */ __webpack_exports__["b"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Selection */](this._enter || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};


/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(update) {
  return new Array(update.length);
});


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = styleValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(237);


function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove : typeof value === "function"
            ? styleFunction
            : styleConstant)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
});

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || Object(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node).getComputedStyle(node, null).getPropertyValue(name);
}


/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = createCell;
/* harmony export (immutable) */ __webpack_exports__["a"] = cellHalfedgeStart;
/* unused harmony export cellHalfedgeEnd */
/* harmony export (immutable) */ __webpack_exports__["d"] = sortCellHalfedges;
/* harmony export (immutable) */ __webpack_exports__["b"] = clipCells;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Edge__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Diagram__ = __webpack_require__(96);



function createCell(site) {
  return __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][site.index] = {
    site: site,
    halfedges: []
  };
}

function cellHalfedgeAngle(cell, edge) {
  var site = cell.site,
      va = edge.left,
      vb = edge.right;
  if (site === vb) vb = va, va = site;
  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
  if (site === va) va = edge[1], vb = edge[0];
  else va = edge[0], vb = edge[1];
  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}

function cellHalfedgeStart(cell, edge) {
  return edge[+(edge.left !== cell.site)];
}

function cellHalfedgeEnd(cell, edge) {
  return edge[+(edge.left === cell.site)];
}

function sortCellHalfedges() {
  for (var i = 0, n = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */].length, cell, halfedges, j, m; i < n; ++i) {
    if ((cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][i]) && (m = (halfedges = cell.halfedges).length)) {
      var index = new Array(m),
          array = new Array(m);
      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[j]]);
      index.sort(function(i, j) { return array[j] - array[i]; });
      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
      for (j = 0; j < m; ++j) halfedges[j] = array[j];
    }
  }
}

function clipCells(x0, y0, x1, y1) {
  var nCells = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */].length,
      iCell,
      cell,
      site,
      iHalfedge,
      halfedges,
      nHalfedges,
      start,
      startX,
      startY,
      end,
      endX,
      endY,
      cover = true;

  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell]) {
      site = cell.site;
      halfedges = cell.halfedges;
      iHalfedge = halfedges.length;

      // Remove any dangling clipped edges.
      while (iHalfedge--) {
        if (!__WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[iHalfedge]]) {
          halfedges.splice(iHalfedge, 1);
        }
      }

      // Insert any border edges as necessary.
      iHalfedge = 0, nHalfedges = halfedges.length;
      while (iHalfedge < nHalfedges) {
        end = cellHalfedgeEnd(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[iHalfedge]]), endX = end[0], endY = end[1];
        start = cellHalfedgeStart(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
        if (Math.abs(endX - startX) > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] || Math.abs(endY - startY) > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */]) {
          halfedges.splice(iHalfedge, 0, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, end,
              Math.abs(endX - x0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && y1 - endY > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [x0, Math.abs(startX - x0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startY : y1]
              : Math.abs(endY - y1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && x1 - endX > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [Math.abs(startY - y1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startX : x1, y1]
              : Math.abs(endX - x1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && endY - y0 > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [x1, Math.abs(startX - x1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startY : y0]
              : Math.abs(endY - y0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && endX - x0 > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [Math.abs(startY - y0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startX : x0, y0]
              : null)) - 1);
          ++nHalfedges;
        }
      }

      if (nHalfedges) cover = false;
    }
  }

  // If there weren’t any edges, have the closest site cover the extent.
  // It doesn’t matter which corner of the extent we measure!
  if (cover) {
    var dx, dy, d2, dc = Infinity;

    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
      if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell]) {
        site = cell.site;
        dx = site[0] - x0;
        dy = site[1] - y0;
        d2 = dx * dx + dy * dy;
        if (d2 < dc) dc = d2, cover = cell;
      }
    }

    if (cover) {
      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
      cover.halfedges.push(
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site = cover.site, v00, v01)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v01, v11)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v11, v10)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v10, v00)) - 1
      );
    }
  }

  // Lastly delete any cells with no edges; these were entirely clipped.
  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell]) {
      if (!cell.halfedges.length) {
        delete __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell];
      }
    }
  }
}


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return firstCircle; });
/* harmony export (immutable) */ __webpack_exports__["a"] = attachCircle;
/* harmony export (immutable) */ __webpack_exports__["b"] = detachCircle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RedBlackTree__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Diagram__ = __webpack_require__(96);



var circlePool = [];

var firstCircle;

function Circle() {
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(this);
  this.x =
  this.y =
  this.arc =
  this.site =
  this.cy = null;
}

function attachCircle(arc) {
  var lArc = arc.P,
      rArc = arc.N;

  if (!lArc || !rArc) return;

  var lSite = lArc.site,
      cSite = arc.site,
      rSite = rArc.site;

  if (lSite === rSite) return;

  var bx = cSite[0],
      by = cSite[1],
      ax = lSite[0] - bx,
      ay = lSite[1] - by,
      cx = rSite[0] - bx,
      cy = rSite[1] - by;

  var d = 2 * (ax * cy - ay * cx);
  if (d >= -__WEBPACK_IMPORTED_MODULE_1__Diagram__["g" /* epsilon2 */]) return;

  var ha = ax * ax + ay * ay,
      hc = cx * cx + cy * cy,
      x = (cy * ha - ay * hc) / d,
      y = (ax * hc - cx * ha) / d;

  var circle = circlePool.pop() || new Circle;
  circle.arc = arc;
  circle.site = cSite;
  circle.x = x + bx;
  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom

  arc.circle = circle;

  var before = null,
      node = __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* circles */]._;

  while (node) {
    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
      if (node.L) node = node.L;
      else { before = node.P; break; }
    } else {
      if (node.R) node = node.R;
      else { before = node; break; }
    }
  }

  __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* circles */].insert(before, circle);
  if (!before) firstCircle = circle;
}

function detachCircle(arc) {
  var circle = arc.circle;
  if (circle) {
    if (!circle.P) firstCircle = circle.N;
    __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* circles */].remove(circle);
    circlePool.push(circle);
    Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(circle);
    arc.circle = null;
  }
}


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Selection = __webpack_require__(229);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// components

var flatten = function flatten(list) {
  return list.reduce(function (a, b) {
    return a.concat(Array.isArray(b) ? flatten(b) : b);
  }, []);
};

function flatShortArray(array) {
  if (!Array.isArray(array)) return "not-array";
  var flat = flatten(array);
  return flat.map(function (d) {
    return d && d.toFixed && d.toFixed(2) || "empty";
  }).toString();
}

var Brush = function (_React$Component) {
  _inherits(Brush, _React$Component);

  function Brush(props) {
    _classCallCheck(this, Brush);

    var _this = _possibleConstructorReturn(this, (Brush.__proto__ || Object.getPrototypeOf(Brush)).call(this, props));

    _this.createBrush = _this.createBrush.bind(_this);
    return _this;
  }

  _createClass(Brush, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createBrush();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(lastProps) {
      if (lastProps.extent && this.props.extent && flatShortArray(lastProps.extent) !== flatShortArray(this.props.extent) || lastProps.selectedExtent && this.props.selectedExtent && flatShortArray(lastProps.selectedExtent) !== flatShortArray(this.props.selectedExtent) || !lastProps.selectedExtent && this.props.selectedExtent || lastProps.selectedExtent && !this.props.selectedExtent) {
        this.createBrush();
      }
    }
  }, {
    key: "createBrush",
    value: function createBrush() {
      var node = this.node;
      var brush = this.props.svgBrush;
      (0, _d3Selection.select)(node).call(brush);
      if (this.props.selectedExtent) {
        (0, _d3Selection.select)(node).call(brush.move, this.props.selectedExtent);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement("g", {
        ref: function ref(node) {
          return _this2.node = node;
        },
        transform: "translate(" + (this.props.position || [0, 0]) + ")",
        className: "xybrush"
      });
    }
  }]);

  return Brush;
}(_react2.default.Component);

Brush.propTypes = {
  size: _propTypes2.default.array,
  position: _propTypes2.default.array,
  selectedExtent: _propTypes2.default.array,
  svgBrush: _propTypes2.default.func
};

exports.default = Brush;
module.exports = exports['default'];

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;
//import ReactDOM from 'react-dom'

//import MarkContext from './MarkContext'


//import Rx from 'rxjs/Rx'

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgHelper = __webpack_require__(138);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _basicCanvasEffects = __webpack_require__(466);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VisualizationLayer = (_temp = _class = function (_React$PureComponent) {
  _inherits(VisualizationLayer, _React$PureComponent);

  function VisualizationLayer(props) {
    _classCallCheck(this, VisualizationLayer);

    var _this = _possibleConstructorReturn(this, (VisualizationLayer.__proto__ || Object.getPrototypeOf(VisualizationLayer)).call(this, props));

    _this.canvasDrawing = [];
    _this.state = {
      canvasDrawing: [],
      dataVersion: "",
      renderedElements: []
    };

    _this.updateVisualizationLayer = _this.updateVisualizationLayer.bind(_this);
    return _this;
  }

  _createClass(VisualizationLayer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      if (this.props.disableContext || !this.props.canvasContext || !this.canvasDrawing) return;

      var size = [this.props.size[0] + this.props.margin.left + this.props.margin.right, this.props.size[1] + this.props.margin.top + this.props.margin.bottom];

      var context = this.props.canvasContext.getContext("2d");
      context.setTransform(1, 0, 0, 1, this.props.margin.left, this.props.margin.top);
      context.clearRect(0, 0, size[0], size[1]);

      this.canvasDrawing.forEach(function (piece) {
        var style = piece.styleFn ? piece.styleFn(piece.d, piece.i) : { fill: "black", stroke: "black" };
        var fill = style.fill ? style.fill : "black";
        var stroke = style.stroke ? style.stroke : "black";
        fill = !style.fillOpacity ? fill : "rgba(" + [].concat(_toConsumableArray((0, _SvgHelper.hexToRgb)(fill)), [style.fillOpacity]) + ")";
        stroke = !style.strokeOpacity ? stroke : "rgba(" + [].concat(_toConsumableArray((0, _SvgHelper.hexToRgb)(stroke)), [style.strokeOpacity]) + ")";
        context.setTransform(1, 0, 0, 1, _this2.props.margin.left, _this2.props.margin.top);
        context.translate.apply(context, _toConsumableArray(_this2.props.position));
        context.translate(piece.tx, piece.ty);
        context.fillStyle = fill;
        context.strokeStyle = stroke;
        context.lineWidth = style.strokeWidth ? style.strokeWidth : "black";

        if (piece.markProps.markType === "circle" || piece.markProps.markType === "rect" && piece.markProps.rx > 0) {
          var vizX = 0,
              vizY = 0,
              r = piece.markProps.r;
          if (piece.markProps.width) {
            var halfWidth = piece.markProps.width / 2;
            vizX = piece.markProps.x + halfWidth;
            vizY = piece.markProps.y + halfWidth;
            r = halfWidth;
          }
          context.beginPath();
          context.arc(vizX, vizY, r, 0, 2 * Math.PI);
          context.fill();
          context.stroke();
        } else if (piece.markProps.markType === "rect") {
          context.fillRect(piece.markProps.x, piece.markProps.y, piece.markProps.width, piece.markProps.height);
          context.strokeRect(piece.markProps.x, piece.markProps.y, piece.markProps.width, piece.markProps.height);
        } else if (piece.markProps.markType === "path") {
          var p = new Path2D(piece.markProps.d);
          context.stroke(p);
          context.fill(p);
        } else {
          console.error("CURRENTLY UNSUPPORTED MARKTYPE FOR CANVAS RENDERING");
        }
      });
      context.setTransform(1, 0, 0, 1, 0, 0);

      if (this.props.canvasPostProcess === "chuckClose") {
        (0, _basicCanvasEffects.chuckCloseCanvasTransform)(this.props.canvasContext, context, size);
      } else if (typeof this.props.canvasPostProcess === "function") {
        this.props.canvasPostProcess(this.props.canvasContext, context, size);
      }
    }
  }, {
    key: "updateVisualizationLayer",
    value: function updateVisualizationLayer(props) {
      var xScale = props.xScale,
          yScale = props.yScale,
          dataVersion = props.dataVersion,
          projectedCoordinateNames = props.projectedCoordinateNames,
          renderKeyFn = props.renderKeyFn,
          _props$renderPipeline = props.renderPipeline,
          renderPipeline = _props$renderPipeline === undefined ? {} : _props$renderPipeline,
          _props$baseMarkProps = props.baseMarkProps,
          baseMarkProps = _props$baseMarkProps === undefined ? {} : _props$baseMarkProps;

      this.canvasDrawing = [];
      var canvasDrawing = this.canvasDrawing;

      var renderedElements = [];
      Object.keys(renderPipeline).forEach(function (k) {
        var pipe = renderPipeline[k];
        if (pipe.data && _typeof(pipe.data) === "object" && !Array.isArray(pipe.data) || pipe.data && pipe.data.length > 0) {
          var renderedPipe = pipe.behavior(_extends({
            xScale: xScale,
            yScale: yScale,
            canvasDrawing: canvasDrawing,
            projectedCoordinateNames: projectedCoordinateNames,
            renderKeyFn: renderKeyFn,
            baseMarkProps: baseMarkProps
          }, pipe));

          if (renderedPipe && renderedPipe.length > 0) {
            renderedElements.push(_react2.default.createElement(
              "g",
              { key: k, className: k },
              renderedPipe
            ));
          }
        }
      });

      this.setState({
        renderedElements: renderedElements,
        dataVersion: dataVersion
      });
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      this.updateVisualizationLayer(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(np) {
      var lp = this.props;
      var propKeys = Object.keys(np);

      var update = false;
      propKeys.forEach(function (key) {
        if (lp[key] !== np[key]) {
          update = true;
        }
      });

      if (update === true || np.dataVersion && np.dataVersion !== this.state.dataVersion) {
        this.updateVisualizationLayer(np);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var matte = props.matte,
          matteClip = props.matteClip,
          axes = props.axes,
          axesTickLines = props.axesTickLines,
          frameKey = props.frameKey,
          margin = props.margin;
      var renderedElements = this.state.renderedElements;


      var renderedAxes = axes && _react2.default.createElement(
        "g",
        { key: "visualization-axis-labels", className: "axis axis-labels" },
        axes
      );
      var renderedAxesTickLines = axesTickLines && _react2.default.createElement(
        "g",
        { key: "visualization-tick-lines", className: "axis axis-tick-lines" },
        axesTickLines
      );
      var renderedDataVisualization = (renderedAxes || renderedAxesTickLines || renderedElements && renderedElements.length > 0) && _react2.default.createElement(
        "g",
        {
          className: "data-visualization",
          key: "visualization-clip-path",
          clipPath: matteClip && matte ? "url(#matte-clip" + frameKey + ")" : undefined,
          transform: "translate(" + margin.left + "," + margin.top + ")"
        },
        renderedAxesTickLines,
        renderedElements,
        matte,
        renderedAxes
      ) || null;

      return renderedDataVisualization;
    }
  }]);

  return VisualizationLayer;
}(_react2.default.PureComponent), _class.defaultProps = {
  position: [0, 0],
  margin: { left: 0, top: 0, right: 0, bottom: 0 }
}, _temp);


VisualizationLayer.propTypes = {
  axes: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  frameKey: _propTypes2.default.string,
  xScale: _propTypes2.default.func,
  yScale: _propTypes2.default.func,
  pointData: _propTypes2.default.array,
  lineData: _propTypes2.default.array,
  areaData: _propTypes2.default.array,
  dataVersion: _propTypes2.default.string,
  canvasContext: _propTypes2.default.object,
  size: _propTypes2.default.array.isRequired,
  margin: _propTypes2.default.object
};

exports.default = VisualizationLayer;
module.exports = exports['default'];

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var chuckCloseCanvasTransform = exports.chuckCloseCanvasTransform = function chuckCloseCanvasTransform(canvas, context, size) {
  var pixelSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;

  var _size = _slicedToArray(size, 2),
      baseWidth = _size[0],
      baseHeight = _size[1];

  var height = baseHeight + (baseHeight % pixelSize === 0 ? 0 : pixelSize - baseHeight % pixelSize);

  var width = baseWidth + (baseWidth % pixelSize === 0 ? 0 : pixelSize - baseWidth % pixelSize);

  var rgbStep = 4 * pixelSize;

  var imageData = context.getImageData(0, 0, width, height);
  var rgbaArray = [];
  var imageArray = imageData.data;

  var rgbWidth = width * 4;
  var halfPixelSize = pixelSize / 2;

  for (var i = 0; i < imageArray.length; i += rgbStep) {
    var pixelPoint = {};
    if (pixelSize === 1) {
      pixelPoint = {
        r: imageArray[i],
        g: imageArray[i + 1],
        b: imageArray[i + 2],
        a: imageArray[i + 3],
        x: i / 4 % width,
        y: Math.floor(i / 4 / width)
      };
    } else {
      var rgbHash = {};
      var totalHash = 0;

      for (var p = 0; p < pixelSize * 4; p += pixelSize * 4) {
        for (var q = 0; q < pixelSize * rgbWidth; q += rgbWidth) {
          if (imageArray[p + i + q + 3] !== -1) {
            var hashVal = "rgba(" + imageArray[p + i + q] + "," + imageArray[p + i + q + 1] + "," + imageArray[p + i + q + 2] + "," + imageArray[p + i + q + 3] + ")";
            rgbHash[hashVal] = rgbHash[hashVal] ? rgbHash[hashVal] + 1 : 1;
            totalHash += 1;
          }
        }
      }
      pixelPoint = {
        rgbEntries: Object.entries(rgbHash).sort(function (a, b) {
          return b[1] - a[1];
        }),
        totalEntries: totalHash,
        x: i / 4 % width,
        y: Math.floor(i / 4 / width),
        rmod: pixelSize
      };
    }

    rgbaArray.push(pixelPoint);
    if (pixelSize !== 1 && (i + rgbStep) % rgbWidth === 0) {
      i += rgbWidth * (pixelSize - 1);
    }
  }

  var scale = 1;
  var r = scale / 2;
  context.clearRect(0, 0, width, height);
  var circleArc = 2 * Math.PI;
  rgbaArray.forEach(function (point) {
    var currentR = r * pixelSize;
    var rStep = currentR / point.totalEntries;
    var baseX = point.x * scale + halfPixelSize;
    var baseY = point.y * scale + halfPixelSize;
    point.rgbEntries.forEach(function (e) {
      context.fillStyle = e[0];
      context.beginPath();
      context.arc(baseX, baseY, currentR, 0, circleArc);
      context.fill();
      currentR -= e[1] * rStep;
    });
  });
};

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = packEnclose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enclose__ = __webpack_require__(468);


function place(a, b, c) {
  var ax = a.x,
      ay = a.y,
      da = b.r + c.r,
      db = a.r + c.r,
      dx = b.x - ax,
      dy = b.y - ay,
      dc = dx * dx + dy * dy;
  if (dc) {
    var x = 0.5 + ((db *= db) - (da *= da)) / (2 * dc),
        y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
    c.x = ax + x * dx + y * dy;
    c.y = ay + x * dy - y * dx;
  } else {
    c.x = ax + db;
    c.y = ay;
  }
}

function intersects(a, b) {
  var dx = b.x - a.x,
      dy = b.y - a.y,
      dr = a.r + b.r;
  return dr * dr - 1e-6 > dx * dx + dy * dy;
}

function distance1(a, b) {
  var l = a._.r;
  while (a !== b) l += 2 * (a = a.next)._.r;
  return l - b._.r;
}

function distance2(node, x, y) {
  var a = node._,
      b = node.next._,
      ab = a.r + b.r,
      dx = (a.x * b.r + b.x * a.r) / ab - x,
      dy = (a.y * b.r + b.y * a.r) / ab - y;
  return dx * dx + dy * dy;
}

function Node(circle) {
  this._ = circle;
  this.next = null;
  this.previous = null;
}

function packEnclose(circles) {
  if (!(n = circles.length)) return 0;

  var a, b, c, n;

  // Place the first circle.
  a = circles[0], a.x = 0, a.y = 0;
  if (!(n > 1)) return a.r;

  // Place the second circle.
  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
  if (!(n > 2)) return a.r + b.r;

  // Place the third circle.
  place(b, a, c = circles[2]);

  // Initialize the weighted centroid.
  var aa = a.r * a.r,
      ba = b.r * b.r,
      ca = c.r * c.r,
      oa = aa + ba + ca,
      ox = aa * a.x + ba * b.x + ca * c.x,
      oy = aa * a.y + ba * b.y + ca * c.y,
      cx, cy, i, j, k, sj, sk;

  // Initialize the front-chain using the first three circles a, b and c.
  a = new Node(a), b = new Node(b), c = new Node(c);
  a.next = c.previous = b;
  b.next = a.previous = c;
  c.next = b.previous = a;

  // Attempt to place each remaining circle…
  pack: for (i = 3; i < n; ++i) {
    place(a._, b._, c = circles[i]), c = new Node(c);

    // Find the closest intersecting circle on the front-chain, if any.
    // “Closeness” is determined by linear distance along the front-chain.
    // “Ahead” or “behind” is likewise determined by linear distance.
    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
    do {
      if (sj <= sk) {
        if (intersects(j._, c._)) {
          if (sj + a._.r + b._.r > distance1(j, b)) a = j; else b = j;
          a.next = b, b.previous = a, --i;
          continue pack;
        }
        sj += j._.r, j = j.next;
      } else {
        if (intersects(k._, c._)) {
          if (distance1(a, k) > sk + a._.r + b._.r) a = k; else b = k;
          a.next = b, b.previous = a, --i;
          continue pack;
        }
        sk += k._.r, k = k.previous;
      }
    } while (j !== k.next);

    // Success! Insert the new circle c between a and b.
    c.previous = a, c.next = b, a.next = b.previous = b = c;

    // Update the weighted centroid.
    oa += ca = c._.r * c._.r;
    ox += ca * c._.x;
    oy += ca * c._.y;

    // Compute the new closest circle pair to the centroid.
    aa = distance2(a, cx = ox / oa, cy = oy / oa);
    while ((c = c.next) !== b) {
      if ((ca = distance2(c, cx, cy)) < aa) {
        a = c, aa = ca;
      }
    }
    b = a.next;
  }

  // Compute the enclosing circle of the front chain.
  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = Object(__WEBPACK_IMPORTED_MODULE_0__enclose__["a" /* default */])(a);

  // Translate the circles to put the enclosing circle around the origin.
  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;

  return c.r;
}

/* harmony default export */ __webpack_exports__["a"] = (function(circles) {
  packEnclose(circles);
  return circles;
});


/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shuffle__ = __webpack_require__(1231);


/* harmony default export */ __webpack_exports__["a"] = (function(circles) {
  return encloseN(Object(__WEBPACK_IMPORTED_MODULE_0__shuffle__["a" /* default */])(circles), []);
});

function encloses(a, b) {
  var dx = b.x - a.x,
      dy = b.y - a.y,
      dr = a.r - b.r;
  return dr * dr + 1e-6 > dx * dx + dy * dy;
}

// Returns the smallest circle that contains circles L and intersects circles B.
function encloseN(L, B) {
  var circle,
      l0 = null,
      l1 = L.head,
      l2,
      p1;

  switch (B.length) {
    case 1: circle = enclose1(B[0]); break;
    case 2: circle = enclose2(B[0], B[1]); break;
    case 3: circle = enclose3(B[0], B[1], B[2]); break;
  }

  while (l1) {
    p1 = l1._, l2 = l1.next;
    if (!circle || !encloses(circle, p1)) {

      // Temporarily truncate L before l1.
      if (l0) L.tail = l0, l0.next = null;
      else L.head = L.tail = null;

      B.push(p1);
      circle = encloseN(L, B); // Note: reorders L!
      B.pop();

      // Move l1 to the front of L and reconnect the truncated list L.
      if (L.head) l1.next = L.head, L.head = l1;
      else l1.next = null, L.head = L.tail = l1;
      l0 = L.tail, l0.next = l2;

    } else {
      l0 = l1;
    }
    l1 = l2;
  }

  L.tail = l0;
  return circle;
}

function enclose1(a) {
  return {
    x: a.x,
    y: a.y,
    r: a.r
  };
}

function enclose2(a, b) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
      l = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x1 + x2 + x21 / l * r21) / 2,
    y: (y1 + y2 + y21 / l * r21) / 2,
    r: (l + r1 + r2) / 2
  };
}

function enclose3(a, b, c) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x3 = c.x, y3 = c.y, r3 = c.r,
      a2 = 2 * (x1 - x2),
      b2 = 2 * (y1 - y2),
      c2 = 2 * (r2 - r1),
      d2 = x1 * x1 + y1 * y1 - r1 * r1 - x2 * x2 - y2 * y2 + r2 * r2,
      a3 = 2 * (x1 - x3),
      b3 = 2 * (y1 - y3),
      c3 = 2 * (r3 - r1),
      d3 = x1 * x1 + y1 * y1 - r1 * r1 - x3 * x3 - y3 * y3 + r3 * r3,
      ab = a3 * b2 - a2 * b3,
      xa = (b2 * d3 - b3 * d2) / ab - x1,
      xb = (b3 * c2 - b2 * c3) / ab,
      ya = (a3 * d2 - a2 * d3) / ab - y1,
      yb = (a2 * c3 - a3 * c2) / ab,
      A = xb * xb + yb * yb - 1,
      B = 2 * (xa * xb + ya * yb + r1),
      C = xa * xa + ya * ya - r1 * r1,
      r = (-B - Math.sqrt(B * B - 4 * A * C)) / (2 * A);
  return {
    x: xa + xb * r + x1,
    y: ya + yb * r + y1,
    r: r
  };
}


/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = constantZero;
function constantZero() {
  return 0;
}

/* harmony default export */ __webpack_exports__["b"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
});


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ascending__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__area__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constant__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contains__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__noop__ = __webpack_require__(1244);








var cases = [
  [],
  [[[1,1.5],[0.5,1]]],
  [[[1.5,1],[1,1.5]]],
  [[[1.5,1],[0.5,1]]],
  [[[1,0.5],[1.5,1]]],
  [[[1,0.5],[0.5,1]],[[1,1.5],[1.5,1]]],
  [[[1,0.5],[1,1.5]]],
  [[[1,0.5],[0.5,1]]],
  [[[0.5,1],[1,0.5]]],
  [[[1,1.5],[1,0.5]]],
  [[[0.5,1],[1,1.5]],[[1.5,1],[1,0.5]]],
  [[[1.5,1],[1,0.5]]],
  [[[0.5,1],[1.5,1]]],
  [[[1,1.5],[1.5,1]]],
  [[[0.5,1],[1,1.5]]],
  []
];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var dx = 1,
      dy = 1,
      threshold = __WEBPACK_IMPORTED_MODULE_0_d3_array__["thresholdSturges"],
      smooth = smoothLinear;

  function contours(values) {
    var tz = threshold(values);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      var domain = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["extent"])(values), start = domain[0], stop = domain[1];
      tz = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start, stop, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(Math.floor(start / tz) * tz, Math.floor(stop / tz) * tz, tz);
    } else {
      tz = tz.slice().sort(__WEBPACK_IMPORTED_MODULE_2__ascending__["a" /* default */]);
    }

    // Accumulate, smooth contour rings, assign holes to exterior rings.
    // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
    var layers = tz.map(function(value) {
      var polygons = [],
          holes = [];

      isorings(values, value, function(ring) {
        smooth(ring, values, value);
        if (Object(__WEBPACK_IMPORTED_MODULE_3__area__["a" /* default */])(ring) > 0) polygons.push([ring]);
        else holes.push(ring);
      });

      holes.forEach(function(hole) {
        for (var i = 0, n = polygons.length, polygon; i < n; ++i) {
          if (Object(__WEBPACK_IMPORTED_MODULE_5__contains__["a" /* default */])((polygon = polygons[i])[0], hole) !== -1) {
            polygon.push(hole);
            return;
          }
        }
      });

      return polygons;
    });

    return layers.map(function(polygons, i) {
      return {
        type: "MultiPolygon",
        value: tz[i],
        coordinates: polygons
      };
    });
  }

  // Marching squares with isolines stitched into rings.
  // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
  function isorings(values, value, callback) {
    var fragmentByStart = new Array,
        fragmentByEnd = new Array,
        x, y, t0, t1, t2, t3;

    // Special case for the first row (y = -1, t2 = t3 = 0).
    x = y = -1;
    t1 = values[0] >= value;
    cases[t1 << 1].forEach(stitch);
    while (++x < dx - 1) {
      t0 = t1, t1 = values[x + 1] >= value;
      cases[t0 | t1 << 1].forEach(stitch);
    }
    cases[t1 << 0].forEach(stitch);

    // General case for the intermediate rows.
    while (++y < dy - 1) {
      x = -1;
      t1 = values[y * dx + dx] >= value;
      t2 = values[y * dx] >= value;
      cases[t1 << 1 | t2 << 2].forEach(stitch);
      while (++x < dx - 1) {
        t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
        t3 = t2, t2 = values[y * dx + x + 1] >= value;
        cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
      }
      cases[t1 | t2 << 3].forEach(stitch);
    }

    // Special case for the last row (y = dy - 1, t0 = t1 = 0).
    x = -1;
    t2 = values[y * dx] >= value;
    cases[t2 << 2].forEach(stitch);
    while (++x < dx - 1) {
      t3 = t2, t2 = values[y * dx + x + 1] >= value;
      cases[t2 << 2 | t3 << 3].forEach(stitch);
    }
    cases[t2 << 3].forEach(stitch);

    function stitch(line) {
      var start = [line[0][0] + x, line[0][1] + y],
          end = [line[1][0] + x, line[1][1] + y],
          startIndex = index(start),
          endIndex = index(end),
          f, g;
      if (f = fragmentByEnd[startIndex]) {
        if (g = fragmentByStart[endIndex]) {
          delete fragmentByEnd[f.end];
          delete fragmentByStart[g.start];
          if (f === g) {
            f.ring.push(end);
            callback(f.ring);
          } else {
            fragmentByStart[f.start] = fragmentByEnd[g.end] = {start: f.start, end: g.end, ring: f.ring.concat(g.ring)};
          }
        } else {
          delete fragmentByEnd[f.end];
          f.ring.push(end);
          fragmentByEnd[f.end = endIndex] = f;
        }
      } else if (f = fragmentByStart[endIndex]) {
        if (g = fragmentByEnd[startIndex]) {
          delete fragmentByStart[f.start];
          delete fragmentByEnd[g.end];
          if (f === g) {
            f.ring.push(end);
            callback(f.ring);
          } else {
            fragmentByStart[g.start] = fragmentByEnd[f.end] = {start: g.start, end: f.end, ring: g.ring.concat(f.ring)};
          }
        } else {
          delete fragmentByStart[f.start];
          f.ring.unshift(start);
          fragmentByStart[f.start = startIndex] = f;
        }
      } else {
        fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {start: startIndex, end: endIndex, ring: [start, end]};
      }
    }
  }

  function index(point) {
    return point[0] * 2 + point[1] * (dx + 1) * 4;
  }

  function smoothLinear(ring, values, value) {
    ring.forEach(function(point) {
      var x = point[0],
          y = point[1],
          xt = x | 0,
          yt = y | 0,
          v0,
          v1 = values[yt * dx + xt];
      if (x > 0 && x < dx && xt === x) {
        v0 = values[yt * dx + xt - 1];
        point[0] = x + (value - v0) / (v1 - v0) - 0.5;
      }
      if (y > 0 && y < dy && yt === y) {
        v0 = values[(yt - 1) * dx + xt];
        point[1] = y + (value - v0) / (v1 - v0) - 0.5;
      }
    });
  }

  contours.size = function(_) {
    if (!arguments.length) return [dx, dy];
    var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
    if (!(_0 > 0) || !(_1 > 0)) throw new Error("invalid size");
    return dx = _0, dy = _1, contours;
  };

  contours.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(_), contours) : threshold;
  };

  contours.smooth = function(_) {
    return arguments.length ? (smooth = _ ? smoothLinear : __WEBPACK_IMPORTED_MODULE_6__noop__["a" /* default */], contours) : smooth === smoothLinear;
  };

  return contours;
});


/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var array = Array.prototype;

var slice = array.slice;


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderLaidOutSummaries = exports.drawSummaries = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.boxplotRenderFn = boxplotRenderFn;
exports.contourRenderFn = contourRenderFn;
exports.bucketizedRenderingFn = bucketizedRenderingFn;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Axis = __webpack_require__(137);

var _Axis2 = _interopRequireDefault(_Axis);

var _semioticMark = __webpack_require__(15);

var _areaDrawing = __webpack_require__(244);

var _d3Array = __webpack_require__(12);

var _SvgHelper = __webpack_require__(138);

var _d3Shape = __webpack_require__(30);

var _pieceDrawing = __webpack_require__(142);

var _frameFunctions = __webpack_require__(141);

var _d3Scale = __webpack_require__(92);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var contourMap = function contourMap(d) {
  return [d.xy.x, d.xy.y];
};

var verticalXYSorting = function verticalXYSorting(a, b) {
  return a.xy.y - b.xy.y;
};
var horizontalXYSorting = function horizontalXYSorting(a, b) {
  return b.xy.x - a.xy.x;
};
var emptyObjectReturnFn = function emptyObjectReturnFn() {
  return {};
};

function boxplotRenderFn(_ref) {
  var data = _ref.data,
      type = _ref.type,
      renderMode = _ref.renderMode,
      eventListenersGenerator = _ref.eventListenersGenerator,
      styleFn = _ref.styleFn,
      classFn = _ref.classFn,
      _ref$positionFn = _ref.positionFn,
      positionFn = _ref$positionFn === undefined ? function (position) {
    return position;
  } : _ref$positionFn,
      projection = _ref.projection,
      adjustedSize = _ref.adjustedSize,
      baseMarkProps = _ref.baseMarkProps;

  var summaryElementStylingFn = type.elementStyleFn || emptyObjectReturnFn;

  var keys = Object.keys(data);
  var renderedSummaryMarks = [];
  var summaryXYCoords = [];
  keys.forEach(function (key, summaryI) {
    var summary = data[key];
    var eventListeners = eventListenersGenerator(summary, summaryI);

    var columnWidth = summary.width;

    var thisSummaryData = summary.pieceData;

    var calculatedSummaryStyle = styleFn(thisSummaryData[0].data, summaryI);
    var calculatedSummaryClass = classFn(thisSummaryData[0].data, summaryI);

    var summaryPositionNest = void 0,
        summaryValueNest = void 0,
        translate = void 0,
        extentlineX1 = void 0,
        extentlineX2 = void 0,
        extentlineY1 = void 0,
        extentlineY2 = void 0,
        topLineX1 = void 0,
        topLineX2 = void 0,
        midLineX1 = void 0,
        midLineX2 = void 0,
        bottomLineX1 = void 0,
        bottomLineX2 = void 0,
        rectTopWidth = void 0,
        rectTopHeight = void 0,
        rectTopY = void 0,
        rectTopX = void 0,
        rectBottomWidth = void 0,
        rectBottomHeight = void 0,
        rectBottomY = void 0,
        rectBottomX = void 0,
        rectWholeWidth = void 0,
        rectWholeHeight = void 0,
        rectWholeY = void 0,
        rectWholeX = void 0,
        topLineY1 = void 0,
        topLineY2 = void 0,
        bottomLineY1 = void 0,
        bottomLineY2 = void 0,
        midLineY1 = void 0,
        midLineY2 = void 0;

    var renderValue = renderMode ? renderMode(summary, summaryI) : undefined;

    summaryValueNest = thisSummaryData.map(function (p) {
      return p.value;
    }).sort(function (a, b) {
      return a - b;
    });

    summaryValueNest = [(0, _d3Array.quantile)(summaryValueNest, 0.0), (0, _d3Array.quantile)(summaryValueNest, 0.25), (0, _d3Array.quantile)(summaryValueNest, 0.5), (0, _d3Array.quantile)(summaryValueNest, 0.75), (0, _d3Array.quantile)(summaryValueNest, 1.0)];

    if (projection === "vertical") {
      summaryPositionNest = thisSummaryData.map(function (p) {
        return p.scaledVerticalValue;
      }).sort(function (a, b) {
        return b - a;
      });

      summaryPositionNest = [(0, _d3Array.quantile)(summaryPositionNest, 0.0), (0, _d3Array.quantile)(summaryPositionNest, 0.25), (0, _d3Array.quantile)(summaryPositionNest, 0.5), (0, _d3Array.quantile)(summaryPositionNest, 0.75), (0, _d3Array.quantile)(summaryPositionNest, 1.0)];

      var xPosition = positionFn(summary.middle, key, summaryI);

      translate = "translate(" + xPosition + ",0)";
      extentlineX1 = 0;
      extentlineX2 = 0;
      extentlineY1 = summaryPositionNest[0];
      extentlineY2 = summaryPositionNest[4];
      topLineX1 = -columnWidth / 2;
      topLineX2 = columnWidth / 2;
      midLineX1 = -columnWidth / 2;
      midLineX2 = columnWidth / 2;
      bottomLineX1 = -columnWidth / 2;
      bottomLineX2 = columnWidth / 2;
      rectBottomWidth = columnWidth;
      rectBottomHeight = summaryPositionNest[1] - summaryPositionNest[2];
      rectBottomY = summaryPositionNest[2];
      rectBottomX = -columnWidth / 2;
      rectTopWidth = columnWidth;
      rectTopHeight = summaryPositionNest[2] - summaryPositionNest[3];
      rectWholeWidth = columnWidth;
      rectWholeHeight = summaryPositionNest[1] - summaryPositionNest[3];
      rectWholeY = summaryPositionNest[3];
      rectWholeX = -columnWidth / 2;
      rectTopY = summaryPositionNest[3];
      rectTopX = -columnWidth / 2;
      topLineY1 = summaryPositionNest[0];
      topLineY2 = summaryPositionNest[0];
      bottomLineY1 = summaryPositionNest[4];
      bottomLineY2 = summaryPositionNest[4];
      midLineY1 = summaryPositionNest[2];
      midLineY2 = summaryPositionNest[2];

      summaryXYCoords.push({
        label: "Maximum",
        key: key,
        summaryPieceName: "max",
        x: xPosition,
        y: summaryPositionNest[4],
        value: summaryValueNest[4]
      }, {
        label: "3rd Quartile",
        key: key,
        summaryPieceName: "q3area",
        x: xPosition,
        y: summaryPositionNest[3],
        value: summaryValueNest[3]
      }, {
        label: "Median",
        key: key,
        summaryPieceName: "median",
        x: xPosition,
        y: summaryPositionNest[2],
        value: summaryValueNest[2]
      }, {
        label: "1st Quartile",
        key: key,
        summaryPieceName: "q1area",
        x: xPosition,
        y: summaryPositionNest[1],
        value: summaryValueNest[1]
      }, {
        label: "Minimum",
        key: key,
        summaryPieceName: "min",
        x: xPosition,
        y: summaryPositionNest[0],
        value: summaryValueNest[0]
      });
    } else if (projection === "horizontal") {
      summaryPositionNest = thisSummaryData.map(function (p) {
        return p.scaledValue;
      }).sort(function (a, b) {
        return a - b;
      });

      summaryPositionNest = [(0, _d3Array.quantile)(summaryPositionNest, 0.0), (0, _d3Array.quantile)(summaryPositionNest, 0.25), (0, _d3Array.quantile)(summaryPositionNest, 0.5), (0, _d3Array.quantile)(summaryPositionNest, 0.75), (0, _d3Array.quantile)(summaryPositionNest, 1.0)];

      var yPosition = positionFn(summary.middle, key, summaryI);

      translate = "translate(0," + yPosition + ")";
      extentlineY1 = 0;
      extentlineY2 = 0;
      extentlineX1 = summaryPositionNest[0];
      extentlineX2 = summaryPositionNest[4];
      topLineY1 = -columnWidth / 2;
      topLineY2 = columnWidth / 2;
      midLineY1 = -columnWidth / 2;
      midLineY2 = columnWidth / 2;
      bottomLineY1 = -columnWidth / 2;
      bottomLineY2 = columnWidth / 2;
      rectTopHeight = columnWidth;
      rectTopWidth = summaryPositionNest[3] - summaryPositionNest[2];
      rectTopX = summaryPositionNest[2];
      rectTopY = -columnWidth / 2;
      rectBottomHeight = columnWidth;
      rectBottomWidth = summaryPositionNest[2] - summaryPositionNest[1];
      rectBottomX = summaryPositionNest[1];
      rectBottomY = -columnWidth / 2;
      rectWholeHeight = columnWidth;
      rectWholeWidth = summaryPositionNest[3] - summaryPositionNest[1];
      rectWholeX = summaryPositionNest[1];
      rectWholeY = -columnWidth / 2;
      topLineX1 = summaryPositionNest[0];
      topLineX2 = summaryPositionNest[0];
      bottomLineX1 = summaryPositionNest[4];
      bottomLineX2 = summaryPositionNest[4];
      midLineX1 = summaryPositionNest[2];
      midLineX2 = summaryPositionNest[2];

      summaryXYCoords.push({
        label: "Maximum",
        key: key,
        summaryPieceName: "max",
        x: summaryPositionNest[4],
        y: yPosition,
        value: summaryValueNest[4]
      }, {
        label: "3rd Quartile",
        key: key,
        summaryPieceName: "q3area",
        x: summaryPositionNest[3],
        y: yPosition,
        value: summaryValueNest[3]
      }, {
        label: "Median",
        key: key,
        summaryPieceName: "median",
        x: summaryPositionNest[2],
        y: yPosition,
        value: summaryValueNest[2]
      }, {
        label: "1st Quartile",
        key: key,
        summaryPieceName: "q1area",
        x: summaryPositionNest[1],
        y: yPosition,
        value: summaryValueNest[1]
      }, {
        label: "Minimum",
        key: key,
        summaryPieceName: "min",
        x: summaryPositionNest[0],
        y: yPosition,
        value: summaryValueNest[0]
      });
    }

    if (projection === "radial") {
      summaryPositionNest = thisSummaryData.map(function (p) {
        return p.scaledValue;
      }).sort(function (a, b) {
        return a - b;
      });

      summaryPositionNest = [(0, _d3Array.quantile)(summaryPositionNest, 0.0), (0, _d3Array.quantile)(summaryPositionNest, 0.25), (0, _d3Array.quantile)(summaryPositionNest, 0.5), (0, _d3Array.quantile)(summaryPositionNest, 0.75), (0, _d3Array.quantile)(summaryPositionNest, 1.0)];

      extentlineX1 = 0;
      extentlineX2 = 0;
      extentlineY1 = summaryPositionNest[0];
      extentlineY2 = summaryPositionNest[4];
      topLineX1 = -columnWidth / 2;
      topLineX2 = columnWidth / 2;
      midLineX1 = -columnWidth / 2;
      midLineX2 = columnWidth / 2;
      bottomLineX1 = -columnWidth / 2;
      bottomLineX2 = columnWidth / 2;
      rectTopWidth = columnWidth;
      rectTopHeight = summaryPositionNest[1] - summaryPositionNest[3];
      rectTopY = summaryPositionNest[3];
      rectTopX = -columnWidth / 2;
      rectBottomWidth = columnWidth;
      rectBottomHeight = summaryPositionNest[1] - summaryPositionNest[3];
      rectBottomY = summaryPositionNest[3];
      rectBottomX = -columnWidth / 2;
      topLineY1 = summaryPositionNest[0];
      topLineY2 = summaryPositionNest[0];
      bottomLineY1 = summaryPositionNest[4];
      bottomLineY2 = summaryPositionNest[4];
      midLineY1 = summaryPositionNest[2];
      midLineY2 = summaryPositionNest[2];

      var twoPI = Math.PI * 2;

      var bottomLineArcGenerator = (0, _d3Shape.arc)().innerRadius(bottomLineY1 / 2).outerRadius(bottomLineY1 / 2);
      //        .padAngle(summary.pct_padding * twoPI);

      var topLineArcGenerator = (0, _d3Shape.arc)().innerRadius(topLineY1 / 2).outerRadius(topLineY1 / 2);
      //        .padAngle(summary.pct_padding * twoPI);

      var midLineArcGenerator = (0, _d3Shape.arc)().innerRadius(midLineY1 / 2).outerRadius(midLineY1 / 2);
      //        .padAngle(summary.pct_padding * twoPI);

      var bodyArcTopGenerator = (0, _d3Shape.arc)().innerRadius(summaryPositionNest[1] / 2).outerRadius(midLineY1 / 2);
      //        .padAngle(summary.pct_padding * twoPI);

      var bodyArcBottomGenerator = (0, _d3Shape.arc)().innerRadius(midLineY1 / 2).outerRadius(summaryPositionNest[3] / 2);
      //        .padAngle(summary.pct_padding * twoPI);

      var bodyArcWholeGenerator = (0, _d3Shape.arc)().innerRadius(summaryPositionNest[1] / 2).outerRadius(summaryPositionNest[3] / 2);
      //        .padAngle(summary.pct_padding * twoPI);

      var startAngle = summary.pct_start + summary.pct_padding / 2;
      var endAngle = summary.pct + summary.pct_start - summary.pct_padding / 2;
      var midAngle = summary.pct / 2 + summary.pct_start;
      startAngle *= twoPI;
      endAngle *= twoPI;

      var radialAdjustX = adjustedSize[0] / 2;

      var radialAdjustY = adjustedSize[1] / 2;

      //        const bottomPoint = bottomLineArcGenerator.centroid({ startAngle, endAngle })
      //        const topPoint = topLineArcGenerator.centroid({ startAngle, endAngle })
      var bottomPoint = (0, _pieceDrawing.pointOnArcAtAngle)([0, 0], midAngle, summaryPositionNest[4] / 2);
      var topPoint = (0, _pieceDrawing.pointOnArcAtAngle)([0, 0], midAngle, summaryPositionNest[0] / 2);
      var thirdPoint = (0, _pieceDrawing.pointOnArcAtAngle)([0, 0], midAngle, summaryPositionNest[3] / 2);
      var midPoint = (0, _pieceDrawing.pointOnArcAtAngle)([0, 0], midAngle, summaryPositionNest[2] / 2);
      var firstPoint = (0, _pieceDrawing.pointOnArcAtAngle)([0, 0], midAngle, summaryPositionNest[1] / 2);

      summaryXYCoords.push({
        label: "Minimum",
        key: key,
        summaryPieceName: "min",
        x: topPoint[0] + radialAdjustX,
        y: topPoint[1] + radialAdjustY,
        value: summaryValueNest[0]
      }, {
        label: "1st Quartile",
        key: key,
        summaryPieceName: "q3area",
        x: firstPoint[0] + radialAdjustX,
        y: firstPoint[1] + radialAdjustY,
        value: summaryValueNest[1]
      }, {
        label: "Median",
        key: key,
        summaryPieceName: "median",
        x: midPoint[0] + radialAdjustX,
        y: midPoint[1] + radialAdjustY,
        value: summaryValueNest[2]
      }, {
        label: "3rd Quartile",
        key: key,
        summaryPieceName: "q1area",
        x: thirdPoint[0] + radialAdjustX,
        y: thirdPoint[1] + radialAdjustY,
        value: summaryValueNest[3]
      }, {
        label: "Maximum",
        key: key,
        summaryPieceName: "max",
        x: bottomPoint[0] + radialAdjustX,
        y: bottomPoint[1] + radialAdjustY,
        value: summaryValueNest[4]
      });
      translate = "translate(" + radialAdjustX + "," + radialAdjustY + ")";

      renderedSummaryMarks.push(_react2.default.createElement(
        "g",
        _extends({}, eventListeners, {
          className: calculatedSummaryClass,
          transform: translate,
          key: "summaryPiece-" + summaryI
        }),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "line",
          x1: bottomPoint[0],
          x2: topPoint[0],
          y1: bottomPoint[1],
          y2: topPoint[1],
          style: _extends({ strokeWidth: 2 }, calculatedSummaryStyle, summaryElementStylingFn("whisker"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "path",
          d: topLineArcGenerator({ startAngle: startAngle, endAngle: endAngle }),
          style: _extends({ strokeWidth: 4 }, calculatedSummaryStyle, { fill: "none" }, summaryElementStylingFn("max"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "path",
          d: midLineArcGenerator({ startAngle: startAngle, endAngle: endAngle }),
          style: _extends({ strokeWidth: 4 }, calculatedSummaryStyle, { fill: "none" }, summaryElementStylingFn("median"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "path",
          d: bottomLineArcGenerator({ startAngle: startAngle, endAngle: endAngle }),
          style: _extends({ strokeWidth: 4 }, calculatedSummaryStyle, { fill: "none" }, summaryElementStylingFn("min"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "path",
          d: bodyArcWholeGenerator({ startAngle: startAngle, endAngle: endAngle }),
          style: _extends({ strokeWidth: 4 }, calculatedSummaryStyle, summaryElementStylingFn("iqrarea"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "path",
          d: bodyArcTopGenerator({ startAngle: startAngle, endAngle: endAngle }),
          style: _extends({}, calculatedSummaryStyle, { fill: "none", stroke: "none" }, summaryElementStylingFn("q3area"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "path",
          d: bodyArcBottomGenerator({ startAngle: startAngle, endAngle: endAngle }),
          style: _extends({}, calculatedSummaryStyle, { fill: "none", stroke: "none" }, summaryElementStylingFn("q1area"))
        }))
      ));
    } else {
      renderedSummaryMarks.push(_react2.default.createElement(
        "g",
        _extends({}, eventListeners, {
          className: calculatedSummaryClass,
          transform: translate,
          key: "summaryPiece-" + summaryI
        }),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "line",
          x1: extentlineX1,
          x2: extentlineX2,
          y1: extentlineY1,
          y2: extentlineY2,
          style: _extends({ strokeWidth: "2px" }, calculatedSummaryStyle, summaryElementStylingFn("whisker"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "line",
          x1: topLineX1,
          x2: topLineX2,
          y1: topLineY1,
          y2: topLineY2,
          style: _extends({ strokeWidth: "2px" }, calculatedSummaryStyle, summaryElementStylingFn("min"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "line",
          x1: bottomLineX1,
          x2: bottomLineX2,
          y1: bottomLineY1,
          y2: bottomLineY2,
          style: _extends({ strokeWidth: "2px" }, calculatedSummaryStyle, summaryElementStylingFn("max"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "rect",
          x: rectWholeX,
          width: rectWholeWidth,
          y: rectWholeY,
          height: rectWholeHeight,
          style: _extends({ strokeWidth: "1px" }, calculatedSummaryStyle, summaryElementStylingFn("iqrarea"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "rect",
          x: rectTopX,
          width: rectTopWidth,
          y: rectTopY,
          height: rectTopHeight,
          style: _extends({}, calculatedSummaryStyle, { fill: "none", stroke: "none" }, summaryElementStylingFn("q3area"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "rect",
          x: rectBottomX,
          width: rectBottomWidth,
          y: rectBottomY,
          height: rectBottomHeight,
          style: _extends({}, calculatedSummaryStyle, { fill: "none", stroke: "none" }, summaryElementStylingFn("q1area"))
        })),
        _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          renderMode: renderValue,
          markType: "line",
          x1: midLineX1,
          x2: midLineX2,
          y1: midLineY1,
          y2: midLineY2,
          style: _extends({ strokeWidth: "2px" }, calculatedSummaryStyle, summaryElementStylingFn("median"))
        }))
      ));
    }
  });

  return { marks: renderedSummaryMarks, xyPoints: summaryXYCoords };
}

function contourRenderFn(_ref2) {
  var data = _ref2.data,
      type = _ref2.type,
      renderMode = _ref2.renderMode,
      eventListenersGenerator = _ref2.eventListenersGenerator,
      styleFn = _ref2.styleFn,
      classFn = _ref2.classFn,
      adjustedSize = _ref2.adjustedSize,
      baseMarkProps = _ref2.baseMarkProps;

  var keys = Object.keys(data);
  var renderedSummaryMarks = [];
  var summaryXYCoords = [];

  keys.forEach(function (key, ordsetI) {
    var ordset = data[key];
    var renderValue = renderMode && renderMode(ordset, ordsetI);
    type.thresholds = type.thresholds || 8;
    type.bandwidth = type.bandwidth || 12;
    type.resolution = type.resolution || 1000;

    var projectedOrd = [{ id: ordset, _xyfCoordinates: ordset.xyData.map(contourMap) }];

    var oContours = (0, _areaDrawing.contouring)({
      areaType: type,
      data: projectedOrd,
      projectedX: "x",
      projectedY: "y",
      finalXExtent: [0, adjustedSize[0]],
      finalYExtent: [0, adjustedSize[1]]
    });
    var contourMarks = [];
    oContours.forEach(function (d, i) {
      d.coordinates.forEach(function (coords, ii) {
        var eventListeners = eventListenersGenerator(d, i);
        contourMarks.push(_react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, eventListeners, {
          renderMode: renderValue,
          simpleInterpolate: true,
          key: i + "-" + ii,
          style: styleFn(ordset.pieceData[0].data, ordsetI),
          className: classFn(ordset.pieceData[0].data, ordsetI),
          markType: "path",
          d: "M" + d.coordinates[0].map(function (p) {
            return p.join(",");
          }).join("L") + "Z"
        })));
      });
    });

    renderedSummaryMarks.push(_react2.default.createElement(
      "g",
      { key: "contour-container-" + ordsetI },
      contourMarks
    ));
  });
  return { marks: renderedSummaryMarks, xyPoints: summaryXYCoords };
}

function axisGenerator(axisProps, i, axisScale) {
  return _react2.default.createElement(_Axis2.default, {
    label: axisProps.label,
    key: axisProps.key || "orframe-summary-axis-" + i,
    orient: axisProps.orient,
    size: axisProps.size,
    ticks: axisProps.ticks,
    tickSize: axisProps.tickSize,
    tickFormat: axisProps.tickFormat,
    tickValues: axisProps.tickValues,
    format: axisProps.format,
    rotate: axisProps.rotate,
    scale: axisScale,
    className: axisProps.className,
    name: axisProps.name
  });
}

function bucketizedRenderingFn(_ref3) {
  var data = _ref3.data,
      type = _ref3.type,
      renderMode = _ref3.renderMode,
      eventListenersGenerator = _ref3.eventListenersGenerator,
      styleFn = _ref3.styleFn,
      classFn = _ref3.classFn,
      projection = _ref3.projection,
      adjustedSize = _ref3.adjustedSize,
      chartSize = _ref3.chartSize,
      baseMarkProps = _ref3.baseMarkProps;

  var renderedSummaryMarks = [];
  var summaryXYCoords = [];

  var buckets = type.bins || 25;
  var relativeBuckets = type.relative ? {} : false;
  var summaryValueAccessor = type.binValue || function (d) {
    return d.length;
  };
  var axisCreator = void 0;
  if (type.axis) {
    type.axis.orient = projection === "horizontal" && ["left", "right"].indexOf(type.axis.orient) === -1 ? "left" : type.axis.orient;
    type.axis.orient = projection === "vertical" && ["bottom", "top"].indexOf(type.axis.orient) === -1 ? "bottom" : type.axis.orient;
    axisCreator = axisGenerator;
    if (projection === "radial") {
      console.error("Summary axes cannot be drawn for radial histograms");
      axisCreator = function axisCreator() {
        return null;
      };
    }
  }

  var bucketSize = chartSize / buckets;

  var keys = Object.keys(data);
  var binMax = 0;
  var calculatedBins = keys.map(function (key, summaryI) {
    var summary = data[key];

    var thisSummaryData = summary.xyData;

    var xySorting = projection === "vertical" ? verticalXYSorting : horizontalXYSorting;

    var summaryPositionNest = thisSummaryData.sort(xySorting);

    var violinHist = (0, _d3Array.histogram)();
    var binDomain = projection === "vertical" ? [0, chartSize] : [0, chartSize];

    var binOffset = 0;
    var binBuckets = [];

    for (var x = 0; x < buckets; x++) {
      binBuckets.push(binDomain[0] + x / buckets * (chartSize - binOffset));
    }
    //    binBuckets.push(binDomain[1]);

    var xyValue = projection === "vertical" ? function (p) {
      return p.piece.scaledVerticalValue;
    } : function (p) {
      return p.piece.scaledValue;
    };

    var keyBins = void 0;
    if (type.useBins === false) {
      var calculatedValues = summaryPositionNest.map(function (value) {
        return xyValue(value);
      });
      keyBins = summaryPositionNest.map(function (value, i) {
        var bucketArray = [];
        bucketArray.x0 = calculatedValues[i] - 1;
        bucketArray.x1 = calculatedValues[i] + 1;
        bucketArray.push(value);
        return bucketArray;
      }).sort(function (a, b) {
        return a.x0 - b.x0;
      });
      bucketSize = 2;
    } else {
      keyBins = violinHist.domain(binDomain).thresholds(binBuckets).value(xyValue)(summaryPositionNest);
    }

    keyBins = keyBins.map(function (d) {
      return {
        y: d.x0,
        y1: d.x1 - d.x0,
        pieces: d,
        value: summaryValueAccessor(d.map(function (p) {
          return p.piece;
        }))
      };
    });

    if (type.type === "histogram" || type.type === "heatmap") {
      keyBins = keyBins.filter(function (d) {
        return d.value !== 0;
      });
    }

    var relativeMax = keyBins.length === 0 ? 0 : (0, _d3Array.max)(keyBins.map(function (d) {
      return d.value;
    }));
    if (relativeBuckets) {
      relativeBuckets[key] = relativeMax;
    }

    binMax = Math.max(binMax, relativeMax);

    return { bins: keyBins, summary: summary, summaryI: summaryI, thisSummaryData: thisSummaryData };
  });
  calculatedBins.forEach(function (_ref4) {
    var bins = _ref4.bins,
        summary = _ref4.summary,
        summaryI = _ref4.summaryI,
        thisSummaryData = _ref4.thisSummaryData;

    var eventListeners = eventListenersGenerator(summary, summaryI);
    var columnWidth = summary.width;
    var renderValue = renderMode && renderMode(summary, summaryI);

    var calculatedSummaryStyle = thisSummaryData[0] ? styleFn(thisSummaryData[0].piece.data, summaryI) : {};
    var calculatedSummaryClass = thisSummaryData[0] ? classFn(thisSummaryData[0].piece.data, summaryI) : "";

    var translate = [summary.middle, 0];
    if (projection === "horizontal") {
      translate = [bucketSize, summary.middle];
    } else if (projection === "radial") {
      translate = [adjustedSize[0] / 2, adjustedSize[1] / 2];
    }

    var actualMax = relativeBuckets && relativeBuckets[summary.name] || binMax;

    if (type.type === "heatmap" || type.type === "histogram") {
      var mappedBars = (0, _SvgHelper.groupBarMark)({
        bins: bins,
        binMax: binMax,
        relativeBuckets: relativeBuckets,
        columnWidth: columnWidth,
        bucketSize: bucketSize,
        projection: projection,
        adjustedSize: adjustedSize,
        chartSize: chartSize,
        summaryI: summaryI,
        data: data,
        summary: summary,
        renderValue: renderValue,
        summaryStyle: calculatedSummaryStyle,
        type: type,
        baseMarkProps: baseMarkProps
      });
      var tiles = mappedBars.marks;
      if (projection === "radial") {
        translate = [0, 0];
      }

      if (type.axis && type.type === "histogram") {
        var axisTranslate = "translate(" + summary.x + ",0)";
        var axisDomain = [0, actualMax];
        if (projection === "horizontal") {
          axisTranslate = "translate(" + bucketSize + "," + summary.x + ")";
          axisDomain = [actualMax, 0];
        } else if (projection === "radial") {
          axisTranslate = translate(0, 0);
        }

        var axisWidth = projection === "horizontal" ? adjustedSize[0] : columnWidth;
        var axisHeight = projection === "vertical" ? adjustedSize[1] : columnWidth;
        type.axis.size = [axisWidth, axisHeight];
        var axisScale = (0, _d3Scale.scaleLinear)().domain(axisDomain).range([0, columnWidth]);
        var renderedSummaryAxis = axisCreator(type.axis, summaryI, axisScale);

        renderedSummaryMarks.push(_react2.default.createElement(
          "g",
          {
            className: "summary-axis",
            key: "summaryPiece-axis-" + summaryI,
            transform: axisTranslate
          },
          renderedSummaryAxis
        ));
      }
      mappedBars.points.forEach(function (d) {
        d.x += translate[0];
        d.y += translate[1];
      });

      summaryXYCoords.push.apply(summaryXYCoords, _toConsumableArray(mappedBars.points));
      renderedSummaryMarks.push(_react2.default.createElement(
        "g",
        _extends({}, eventListeners, {
          transform: "translate(" + translate + ")",
          key: "summaryPiece-" + summaryI
        }),
        tiles
      ));
    } else if (type.type === "violin") {
      bins[0].y = bins[0].y - bucketSize / 2;
      bins[bins.length - 1].y = bins[bins.length - 1].y + bucketSize / 2;
      var violinArea = (0, _d3Shape.area)().curve(type.curve || _d3Shape.curveCatmullRom);

      var violinPoints = [];

      if (projection === "horizontal") {
        bins.forEach(function (summaryPoint) {
          var xValue = summaryPoint.y - bucketSize / 2;
          var yValue = summaryPoint.value / actualMax * columnWidth / 2;

          violinPoints.push({
            x: xValue,
            y0: -yValue,
            y1: yValue
          });
          summaryXYCoords.push({
            key: summary.name,
            x: xValue + translate[0],
            y: yValue + translate[1],
            pieces: summaryPoint.pieces.map(function (d) {
              return d.piece;
            }),
            value: summaryPoint.value
          });
        });
        violinArea.x(function (d) {
          return d.x;
        }).y0(function (d) {
          return d.y0;
        }).y1(function (d) {
          return d.y1;
        }).defined(function (d, i) {
          return d.y0 !== 0 || violinPoints[i - 1] && violinPoints[i - 1].y0 !== 0 || violinPoints[i + 1] && violinPoints[i + 1].y0 !== 0;
        });
      } else if (projection === "vertical") {
        bins.forEach(function (summaryPoint) {
          var yValue = summaryPoint.y + bucketSize / 2;
          var xValue = summaryPoint.value / actualMax * columnWidth / 2;

          violinPoints.push({
            y: yValue,
            x0: -xValue,
            x1: xValue
          });

          summaryXYCoords.push({
            key: summary.name,
            x: xValue + translate[0],
            y: yValue + translate[1],
            pieces: summaryPoint.pieces.map(function (d) {
              return d.piece;
            }),
            value: summaryPoint.value
          });
        });
        violinArea.y(function (d) {
          return d.y;
        }).x0(function (d) {
          return d.x0;
        }).x1(function (d) {
          return d.x1;
        }).defined(function (d, i) {
          return d.x0 !== 0 || violinPoints[i - 1] && violinPoints[i - 1].x0 !== 0 || violinPoints[i + 1] && violinPoints[i + 1].x0 !== 0;
        });
      } else if (projection === "radial") {
        var angle = summary.pct - summary.pct_padding / 2;
        var midAngle = summary.pct_middle;
        violinPoints = bins;
        violinArea = function violinArea(inbins) {
          var forward = [];
          var backward = [];
          inbins.forEach(function (bin) {
            var outsidePoint = (0, _pieceDrawing.pointOnArcAtAngle)([0, 0], midAngle + angle * bin.value / actualMax / 2, (bin.y + bin.y1 - bucketSize / 2) / 2);
            var insidePoint = (0, _pieceDrawing.pointOnArcAtAngle)([0, 0], midAngle - angle * bin.value / actualMax / 2, (bin.y + bin.y1 - bucketSize / 2) / 2);

            //Ugh a terrible side effect has appeared
            summaryXYCoords.push({
              key: summary.name,
              x: insidePoint[0] + translate[0],
              y: insidePoint[1] + translate[1],
              pieces: bin.pieces.map(function (d) {
                return d.piece;
              }),
              value: bin.value
            });
            summaryXYCoords.push({
              key: summary.name,
              x: outsidePoint[0] + translate[0],
              y: outsidePoint[1] + translate[1],
              pieces: bin.pieces.map(function (d) {
                return d.piece;
              }),
              value: bin.value
            });

            forward.push(outsidePoint);
            backward.push(insidePoint);
          });
          return "M" + forward.map(function (d) {
            return d.join(",");
          }).join("L") + "L" + backward.reverse().map(function (d) {
            return d.join(",");
          }).join("L") + "Z";
        };
      }

      renderedSummaryMarks.push(_react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
        transform: "translate(" + translate + ")",
        key: "summaryPiece-" + summaryI
      }, eventListeners, {
        renderMode: renderValue,
        markType: "path",
        className: calculatedSummaryClass,
        style: calculatedSummaryStyle,
        d: violinArea(violinPoints)
      })));
    } else if (type.type === "joy") {
      var zeroedStart = _extends({}, bins[0], { value: 0 });
      var zeroedEnd = _extends({}, bins[bins.length - 1], { value: 0 });
      //Joy plots need to visually signify the zero baseline with their start and end position

      zeroedStart.y = zeroedStart.y - bucketSize / 2;
      zeroedEnd.y = zeroedEnd.y + bucketSize / 2;

      var joyBins = [zeroedStart].concat(_toConsumableArray(bins), [zeroedEnd]);
      var joyPoints = [];

      var joyArea = (0, _d3Shape.line)().curve(type.curve || _d3Shape.curveCatmullRom).x(function (d) {
        return d.x;
      }).y(function (d) {
        return d.y;
      });

      var joyHeight = type.amplitude || 0;

      if (projection === "horizontal") {
        joyBins.forEach(function (summaryPoint, i) {
          var xValue = summaryPoint.y - bucketSize / 2;
          var yValue = -summaryPoint.value / actualMax * (columnWidth + joyHeight) + columnWidth / 2;

          joyPoints.push({
            y: yValue,
            x: xValue
          });

          //Don't make an interaction point for the first or last
          if (i !== 0 && i !== joyBins.length - 1) {
            summaryXYCoords.push({
              key: summary.name,
              x: xValue + translate[0],
              y: yValue + translate[1],
              pieces: summaryPoint.pieces.map(function (d) {
                return d.piece;
              }),
              value: summaryPoint.value
            });
          }
        });
      } else if (projection === "vertical") {
        joyBins.forEach(function (summaryPoint) {
          var yValue = summaryPoint.y + bucketSize / 2;
          var xValue = -summaryPoint.value / actualMax * (columnWidth + joyHeight) + columnWidth / 2;

          joyPoints.push({
            y: yValue,
            x: xValue
          });

          summaryXYCoords.push({
            key: summary.name,
            x: xValue + translate[0],
            y: yValue + translate[1],
            pieces: summaryPoint.pieces.map(function (d) {
              return d.piece;
            }),
            value: summaryPoint.value
          });
        });
      } else if (projection === "radial") {
        var _angle = summary.pct - summary.pct_padding / 2;
        var _midAngle = summary.pct_start + summary.pct_padding / 2;

        translate = [0, 0];
        joyPoints = joyBins;
        joyArea = function joyArea(inbins) {
          var forward = [];
          inbins.forEach(function (bin) {
            var outsidePoint = (0, _pieceDrawing.pointOnArcAtAngle)([adjustedSize[0] / 2, adjustedSize[1] / 2], _midAngle + _angle * bin.value / actualMax, (bin.y + bin.y1 - bucketSize / 2) / 2);
            //Ugh a terrible side effect has appeared
            summaryXYCoords.push({
              key: summary.name,
              x: outsidePoint[0] + translate[0],
              y: outsidePoint[1] + translate[1],
              pieces: bin.pieces.map(function (d) {
                return d.piece;
              }),
              value: bin.value
            });

            forward.push(outsidePoint);
          });
          return "M" + forward.map(function (d) {
            return d.join(",");
          }).join("L") + "Z";
        };
      }

      renderedSummaryMarks.push(_react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
        transform: "translate(" + translate + ")",
        key: "summaryPiece-" + summaryI
      }, eventListeners, {
        renderMode: renderValue,
        markType: "path",
        className: calculatedSummaryClass,
        style: calculatedSummaryStyle,
        d: joyArea(joyPoints)
      })));
    }
  });

  return { marks: renderedSummaryMarks, xyPoints: summaryXYCoords };
}

var drawSummaries = exports.drawSummaries = function drawSummaries(_ref5) {
  var data = _ref5.data,
      type = _ref5.type,
      renderMode = _ref5.renderMode,
      eventListenersGenerator = _ref5.eventListenersGenerator,
      styleFn = _ref5.styleFn,
      classFn = _ref5.classFn,
      positionFn = _ref5.positionFn,
      projection = _ref5.projection,
      adjustedSize = _ref5.adjustedSize,
      canvasRender = _ref5.canvasRender,
      canvasDrawing = _ref5.canvasDrawing,
      baseMarkProps = _ref5.baseMarkProps;

  if (!type || !type.type) return;
  type = typeof type === "string" ? { type: type } : type;
  var chartSize = projection === "vertical" ? adjustedSize[1] : adjustedSize[0];
  return (0, _frameFunctions.orFrameSummaryRenderer)({
    data: data,
    type: type,
    renderMode: renderMode,
    eventListenersGenerator: eventListenersGenerator,
    styleFn: styleFn,
    classFn: classFn,
    positionFn: positionFn,
    projection: projection,
    adjustedSize: adjustedSize,
    chartSize: chartSize,
    canvasRender: canvasRender,
    canvasDrawing: canvasDrawing,
    baseMarkProps: baseMarkProps
  });
};

var renderLaidOutSummaries = exports.renderLaidOutSummaries = function renderLaidOutSummaries(_ref6) {
  var data = _ref6.data;

  return data;
};

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var projectedX = exports.projectedX = "x";
var projectedY = exports.projectedY = "y";
var projectedYMiddle = exports.projectedYMiddle = "yMiddle";
var projectedYTop = exports.projectedYTop = "yTop";
var projectedYBottom = exports.projectedYBottom = "yBottom";

/*
Use symbols for x/y/offset to avoid conflicts when projecting the dataset
But how to expose those for custom hover rules?
*/

/*
const projectedX = Symbol('x');
const projectedY = Symbol('y');
const projectedYMiddle = Symbol('y-middle');
const projectedOffset = Symbol('offset');
*/

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_center__ = __webpack_require__(1251);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "forceCenter", function() { return __WEBPACK_IMPORTED_MODULE_0__src_center__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_collide__ = __webpack_require__(1252);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "forceCollide", function() { return __WEBPACK_IMPORTED_MODULE_1__src_collide__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_link__ = __webpack_require__(1253);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "forceLink", function() { return __WEBPACK_IMPORTED_MODULE_2__src_link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_manyBody__ = __webpack_require__(1254);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "forceManyBody", function() { return __WEBPACK_IMPORTED_MODULE_3__src_manyBody__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_simulation__ = __webpack_require__(477);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "forceSimulation", function() { return __WEBPACK_IMPORTED_MODULE_4__src_simulation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_x__ = __webpack_require__(1255);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "forceX", function() { return __WEBPACK_IMPORTED_MODULE_5__src_x__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_y__ = __webpack_require__(1256);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "forceY", function() { return __WEBPACK_IMPORTED_MODULE_6__src_y__["a"]; });









/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = x;
/* harmony export (immutable) */ __webpack_exports__["c"] = y;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_collection__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_timer__ = __webpack_require__(45);




function x(d) {
  return d.x;
}

function y(d) {
  return d.y;
}

var initialRadius = 10,
    initialAngle = Math.PI * (3 - Math.sqrt(5));

/* harmony default export */ __webpack_exports__["a"] = (function(nodes) {
  var simulation,
      alpha = 1,
      alphaMin = 0.001,
      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
      alphaTarget = 0,
      velocityDecay = 0.6,
      forces = Object(__WEBPACK_IMPORTED_MODULE_1_d3_collection__["map"])(),
      stepper = Object(__WEBPACK_IMPORTED_MODULE_2_d3_timer__["c" /* timer */])(step),
      event = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("tick", "end");

  if (nodes == null) nodes = [];

  function step() {
    tick();
    event.call("tick", simulation);
    if (alpha < alphaMin) {
      stepper.stop();
      event.call("end", simulation);
    }
  }

  function tick() {
    var i, n = nodes.length, node;

    alpha += (alphaTarget - alpha) * alphaDecay;

    forces.each(function(force) {
      force(alpha);
    });

    for (i = 0; i < n; ++i) {
      node = nodes[i];
      if (node.fx == null) node.x += node.vx *= velocityDecay;
      else node.x = node.fx, node.vx = 0;
      if (node.fy == null) node.y += node.vy *= velocityDecay;
      else node.y = node.fy, node.vy = 0;
    }
  }

  function initializeNodes() {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.index = i;
      if (isNaN(node.x) || isNaN(node.y)) {
        var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
        node.x = radius * Math.cos(angle);
        node.y = radius * Math.sin(angle);
      }
      if (isNaN(node.vx) || isNaN(node.vy)) {
        node.vx = node.vy = 0;
      }
    }
  }

  function initializeForce(force) {
    if (force.initialize) force.initialize(nodes);
    return force;
  }

  initializeNodes();

  return simulation = {
    tick: tick,

    restart: function() {
      return stepper.restart(step), simulation;
    },

    stop: function() {
      return stepper.stop(), simulation;
    },

    nodes: function(_) {
      return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
    },

    alpha: function(_) {
      return arguments.length ? (alpha = +_, simulation) : alpha;
    },

    alphaMin: function(_) {
      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
    },

    alphaDecay: function(_) {
      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
    },

    alphaTarget: function(_) {
      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
    },

    velocityDecay: function(_) {
      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
    },

    force: function(name, _) {
      return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
    },

    find: function(x, y, radius) {
      var i = 0,
          n = nodes.length,
          dx,
          dy,
          d2,
          node,
          closest;

      if (radius == null) radius = Infinity;
      else radius *= radius;

      for (i = 0; i < n; ++i) {
        node = nodes[i];
        dx = x - node.x;
        dy = y - node.y;
        d2 = dx * dx + dy * dy;
        if (d2 < radius) closest = node, radius = d2;
      }

      return closest;
    },

    on: function(name, _) {
      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
    }
  };
});


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// combine 2 matrixes
// m1, m2 - [a, b, c, d, e, g]
//
function combine(m1, m2) {
  return [
    m1[0] * m2[0] + m1[2] * m2[1],
    m1[1] * m2[0] + m1[3] * m2[1],
    m1[0] * m2[2] + m1[2] * m2[3],
    m1[1] * m2[2] + m1[3] * m2[3],
    m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
    m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
  ];
}


function Matrix() {
  if (!(this instanceof Matrix)) { return new Matrix(); }
  this.queue = [];   // list of matrixes to apply
  this.cache = null; // combined matrix cache
}


Matrix.prototype.matrix = function (m) {
  if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1 && m[4] === 0 && m[5] === 0) {
    return this;
  }
  this.cache = null;
  this.queue.push(m);
  return this;
};


Matrix.prototype.translate = function (tx, ty) {
  if (tx !== 0 || ty !== 0) {
    this.cache = null;
    this.queue.push([ 1, 0, 0, 1, tx, ty ]);
  }
  return this;
};


Matrix.prototype.scale = function (sx, sy) {
  if (sx !== 1 || sy !== 1) {
    this.cache = null;
    this.queue.push([ sx, 0, 0, sy, 0, 0 ]);
  }
  return this;
};


Matrix.prototype.rotate = function (angle, rx, ry) {
  var rad, cos, sin;

  if (angle !== 0) {
    this.translate(rx, ry);

    rad = angle * Math.PI / 180;
    cos = Math.cos(rad);
    sin = Math.sin(rad);

    this.queue.push([ cos, sin, -sin, cos, 0, 0 ]);
    this.cache = null;

    this.translate(-rx, -ry);
  }
  return this;
};


Matrix.prototype.skewX = function (angle) {
  if (angle !== 0) {
    this.cache = null;
    this.queue.push([ 1, 0, Math.tan(angle * Math.PI / 180), 1, 0, 0 ]);
  }
  return this;
};


Matrix.prototype.skewY = function (angle) {
  if (angle !== 0) {
    this.cache = null;
    this.queue.push([ 1, Math.tan(angle * Math.PI / 180), 0, 1, 0, 0 ]);
  }
  return this;
};


// Flatten queue
//
Matrix.prototype.toArray = function () {
  if (this.cache) {
    return this.cache;
  }

  if (!this.queue.length) {
    this.cache = [ 1, 0, 0, 1, 0, 0 ];
    return this.cache;
  }

  this.cache = this.queue[0];

  if (this.queue.length === 1) {
    return this.cache;
  }

  for (var i = 1; i < this.queue.length; i++) {
    this.cache = combine(this.cache, this.queue[i]);
  }

  return this.cache;
};


// Apply list of matrixes to (x,y) point.
// If `isRelative` set, `translate` component of matrix will be skipped
//
Matrix.prototype.calc = function (x, y, isRelative) {
  var m;

  // Don't change point on empty transforms queue
  if (!this.queue.length) { return [ x, y ]; }

  // Calculate final matrix, if not exists
  //
  // NB. if you deside to apply transforms to point one-by-one,
  // they should be taken in reverse order

  if (!this.cache) {
    this.cache = this.toArray();
  }

  m = this.cache;

  // Apply matrix to point
  return [
    x * m[0] + y * m[2] + (isRelative ? 0 : m[4]),
    x * m[1] + y * m[3] + (isRelative ? 0 : m[5])
  ];
};


module.exports = Matrix;


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _XYFrame2 = __webpack_require__(61);

var _XYFrame3 = _interopRequireDefault(_XYFrame2);

var _MiniMap = __webpack_require__(250);

var _MiniMap2 = _interopRequireDefault(_MiniMap);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// components


var MinimapXYFrame = function (_XYFrame) {
  _inherits(MinimapXYFrame, _XYFrame);

  function MinimapXYFrame(props) {
    _classCallCheck(this, MinimapXYFrame);

    var _this = _possibleConstructorReturn(this, (MinimapXYFrame.__proto__ || Object.getPrototypeOf(MinimapXYFrame)).call(this, props));

    _this.generateMinimap = _this.generateMinimap.bind(_this);
    return _this;
  }

  _createClass(MinimapXYFrame, [{
    key: "generateMinimap",
    value: function generateMinimap() {
      var miniDefaults = {
        title: "",
        position: [0, 0],
        size: [this.props.size[0], this.props.size[1] * 0.25],
        xAccessor: this.props.xAccessor,
        yAccessor: this.props.yAccessor,
        points: this.props.points,
        lines: this.props.lines,
        areas: this.props.areas,
        lineDataAccessor: this.props.lineDataAccessor,
        xBrushable: true,
        yBrushable: true,
        brushStart: function brushStart() {},
        brush: function brush() {},
        brushEnd: function brushEnd() {},
        lineType: this.props.lineType
      };

      var combinedOptions = _extends(miniDefaults, this.props.minimap);

      combinedOptions.hoverAnnotation = false;

      return _react2.default.createElement(_MiniMap2.default, combinedOptions);
    }
  }, {
    key: "render",
    value: function render() {
      var miniMap = this.generateMinimap();
      var options = {};
      if (this.props.renderBefore) {
        options.beforeElements = miniMap;
      } else {
        options.afterElements = miniMap;
      }

      return this.renderBody(options);
    }
  }]);

  return MinimapXYFrame;
}(_XYFrame3.default);

MinimapXYFrame.propTypes = {
  size: _propTypes2.default.array,
  xAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  yAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  points: _propTypes2.default.array,
  lines: _propTypes2.default.array,
  areas: _propTypes2.default.array,
  lineDataAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  lineType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  minimap: _propTypes2.default.object,
  renderBefore: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])
};

exports.default = MinimapXYFrame;
module.exports = exports['default'];

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.left = left;
exports.right = right;
exports.justify = justify;
exports.center = center;

var _d3Array = __webpack_require__(3);

// For a given link, return the target node's depth
function targetDepth(d) {
  return d.target.depth;
}

// The depth of a node when the nodeAlign (align) is set to 'left'
function left(node) {
  return node.depth;
}

// The depth of a node when the nodeAlign (align) is set to 'right'
function right(node, n) {
  return n - 1 - node.height;
}

// The depth of a node when the nodeAlign (align) is set to 'justify'
function justify(node, n) {
  return node.sourceLinks.length ? node.depth : n - 1;
}

// The depth of a node when the nodeAlign (align) is set to 'center'
function center(node) {
  return node.targetLinks.length ? node.depth : node.sourceLinks.length ? (0, _d3Array.min)(node.sourceLinks, targetDepth) - 1 : 0;
}

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(482);
module.exports = __webpack_require__(487);


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(483).enable();
  window.Promise = __webpack_require__(485);
}

// fetch() polyfill for making API calls.
__webpack_require__(486);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(146);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(253);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(253);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 486 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bulma_css_bulma_css__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bulma_css_bulma_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bulma_css_bulma_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__ = __webpack_require__(1340);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(146),n=__webpack_require__(254),p=__webpack_require__(99),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),l=__webpack_require__(490),B=__webpack_require__(146),C=__webpack_require__(99),ba=__webpack_require__(491),da=__webpack_require__(492),ea=__webpack_require__(493),fa=__webpack_require__(494),ia=__webpack_require__(497),D=__webpack_require__(254);
function E(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:E("227");
var oa={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0};function pa(a,b){return(a&b)===b}
var ta={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ta,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){ua.hasOwnProperty(f)?E("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:pa(h,b.MUST_USE_PROPERTY),
hasBooleanValue:pa(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:pa(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:pa(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:pa(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:pa(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:E("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);ua[f]=g}}},ua={};
function va(a,b){if(oa.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return oa.hasOwnProperty(a)?a=!0:(b=wa(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case "undefined":case "number":case "string":case "object":return!0;default:return!1}}function wa(a){return ua.hasOwnProperty(a)?ua[a]:null}
var xa=ta,ya=xa.MUST_USE_PROPERTY,K=xa.HAS_BOOLEAN_VALUE,za=xa.HAS_NUMERIC_VALUE,Aa=xa.HAS_POSITIVE_NUMERIC_VALUE,Ba=xa.HAS_OVERLOADED_BOOLEAN_VALUE,Ca=xa.HAS_STRING_BOOLEAN_VALUE,Da={Properties:{allowFullScreen:K,async:K,autoFocus:K,autoPlay:K,capture:Ba,checked:ya|K,cols:Aa,contentEditable:Ca,controls:K,"default":K,defer:K,disabled:K,download:Ba,draggable:Ca,formNoValidate:K,hidden:K,loop:K,multiple:ya|K,muted:ya|K,noValidate:K,open:K,playsInline:K,readOnly:K,required:K,reversed:K,rows:Aa,rowSpan:za,
scoped:K,seamless:K,selected:ya|K,size:Aa,start:za,span:Aa,spellCheck:Ca,style:0,tabIndex:0,itemScope:K,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ca},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&
a.setAttribute("value",""+b)}}},Ea=xa.HAS_STRING_BOOLEAN_VALUE,M={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Ga={Properties:{autoReverse:Ea,externalResourcesRequired:Ea,preserveAlpha:Ea},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:M.xlink,xlinkArcrole:M.xlink,xlinkHref:M.xlink,xlinkRole:M.xlink,xlinkShow:M.xlink,xlinkTitle:M.xlink,xlinkType:M.xlink,
xmlBase:M.xml,xmlLang:M.xml,xmlSpace:M.xml}},Ha=/[\-\:]([a-z])/g;function Ia(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Ha,
Ia);Ga.Properties[b]=0;Ga.DOMAttributeNames[b]=a});xa.injectDOMPropertyConfig(Da);xa.injectDOMPropertyConfig(Ga);
var P={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?E("197"):void 0;Ja=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){Ja.apply(P,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){P.invokeGuardedCallback.apply(this,arguments);if(P.hasCaughtError()){var q=P.clearCaughtError();P._hasRethrowError||(P._hasRethrowError=!0,P._rethrowError=
q)}},rethrowCaughtError:function(){return Ka.apply(P,arguments)},hasCaughtError:function(){return P._hasCaughtError},clearCaughtError:function(){if(P._hasCaughtError){var a=P._caughtError;P._caughtError=null;P._hasCaughtError=!1;return a}E("198")}};function Ja(a,b,c,d,e,f,g,h,k){P._hasCaughtError=!1;P._caughtError=null;var q=Array.prototype.slice.call(arguments,3);try{b.apply(c,q)}catch(v){P._caughtError=v,P._hasCaughtError=!0}}
function Ka(){if(P._hasRethrowError){var a=P._rethrowError;P._rethrowError=null;P._hasRethrowError=!1;throw a;}}var La=null,Ma={};
function Na(){if(La)for(var a in Ma){var b=Ma[a],c=La.indexOf(a);-1<c?void 0:E("96",a);if(!Oa[c]){b.extractEvents?void 0:E("97",a);Oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;Pa.hasOwnProperty(h)?E("99",h):void 0;Pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Qa(k[e],g,h);e=!0}else f.registrationName?(Qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:E("98",d,a)}}}}
function Qa(a,b,c){Ra[a]?E("100",a):void 0;Ra[a]=b;Sa[a]=b.eventTypes[c].dependencies}var Oa=[],Pa={},Ra={},Sa={};function Ta(a){La?E("101"):void 0;La=Array.prototype.slice.call(a);Na()}function Ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];Ma.hasOwnProperty(c)&&Ma[c]===d||(Ma[c]?E("102",c):void 0,Ma[c]=d,b=!0)}b&&Na()}
var Va=Object.freeze({plugins:Oa,eventNameDispatchConfigs:Pa,registrationNameModules:Ra,registrationNameDependencies:Sa,possibleRegistrationNames:null,injectEventPluginOrder:Ta,injectEventPluginsByName:Ua}),Wa=null,Xa=null,Ya=null;function Za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ya(d);P.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function $a(a,b){null==b?E("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function ab(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var bb=null;
function cb(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Za(a,b,c[e],d[e]);else c&&Za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function db(a){return cb(a,!0)}function gb(a){return cb(a,!1)}var hb={injectEventPluginOrder:Ta,injectEventPluginsByName:Ua};
function ib(a,b){var c=a.stateNode;if(!c)return null;var d=Wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?E("231",b,typeof c):void 0;
return c}function jb(a,b,c,d){for(var e,f=0;f<Oa.length;f++){var g=Oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=$a(e,g))}return e}function kb(a){a&&(bb=$a(bb,a))}function lb(a){var b=bb;bb=null;b&&(a?ab(b,db):ab(b,gb),bb?E("95"):void 0,P.rethrowCaughtError())}var mb=Object.freeze({injection:hb,getListener:ib,extractEvents:jb,enqueueEvents:kb,processEventQueue:lb}),nb=Math.random().toString(36).slice(2),Q="__reactInternalInstance$"+nb,ob="__reactEventHandlers$"+nb;
function pb(a){if(a[Q])return a[Q];for(var b=[];!a[Q];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=void 0,d=a[Q];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[Q]);a=b.pop())c=d;return c}function qb(a){if(5===a.tag||6===a.tag)return a.stateNode;E("33")}function rb(a){return a[ob]||null}
var sb=Object.freeze({precacheFiberNode:function(a,b){b[Q]=a},getClosestInstanceFromNode:pb,getInstanceFromNode:function(a){a=a[Q];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:qb,getFiberCurrentPropsFromNode:rb,updateFiberProps:function(a,b){a[ob]=b}});function tb(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function ub(a,b,c){for(var d=[];a;)d.push(a),a=tb(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}
function vb(a,b,c){if(b=ib(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a)}function wb(a){a&&a.dispatchConfig.phasedRegistrationNames&&ub(a._targetInst,vb,a)}function xb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?tb(b):null;ub(b,vb,a)}}
function yb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=ib(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a))}function zb(a){a&&a.dispatchConfig.registrationName&&yb(a._targetInst,null,a)}function Ab(a){ab(a,wb)}
function Bb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=tb(h))g++;h=0;for(var k=f;k;k=tb(k))h++;for(;0<g-h;)e=tb(e),g--;for(;0<h-g;)f=tb(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=tb(e);f=tb(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=tb(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=tb(d)}for(d=0;d<e.length;d++)yb(e[d],"bubbled",a);for(a=c.length;0<a--;)yb(c[a],"captured",b)}
var Cb=Object.freeze({accumulateTwoPhaseDispatches:Ab,accumulateTwoPhaseDispatchesSkipTarget:function(a){ab(a,xb)},accumulateEnterLeaveDispatches:Bb,accumulateDirectDispatches:function(a){ab(a,zb)}}),Db=null;function Eb(){!Db&&l.canUseDOM&&(Db="textContent"in document.documentElement?"textContent":"innerText");return Db}var S={_root:null,_startText:null,_fallbackText:null};
function Fb(){if(S._fallbackText)return S._fallbackText;var a,b=S._startText,c=b.length,d,e=Gb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);S._fallbackText=e.slice(a,1<d?1-d:void 0);return S._fallbackText}function Gb(){return"value"in S._root?S._root.value:S._root[Eb()]}
var Hb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Ib={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function T(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
B(T.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Hb.length;a++)this[Hb[a]]=null}});T.Interface=Ib;T.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;B(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=B({},this.Interface,b);a.augmentClass=this.augmentClass;Jb(a)};Jb(T);function Kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Lb(a){a instanceof this?void 0:E("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Jb(a){a.eventPool=[];a.getPooled=Kb;a.release=Lb}function Mb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Mb,{data:null});function Nb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Nb,{data:null});var Pb=[9,13,27,32],Vb=l.canUseDOM&&"CompositionEvent"in window,Wb=null;l.canUseDOM&&"documentMode"in document&&(Wb=document.documentMode);var Xb;
if(Xb=l.canUseDOM&&"TextEvent"in window&&!Wb){var Yb=window.opera;Xb=!("object"===typeof Yb&&"function"===typeof Yb.version&&12>=parseInt(Yb.version(),10))}
var Zb=Xb,$b=l.canUseDOM&&(!Vb||Wb&&8<Wb&&11>=Wb),ac=String.fromCharCode(32),bc={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},cc=!1;
function dc(a,b){switch(a){case "topKeyUp":return-1!==Pb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ec(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var fc=!1;function gc(a,b){switch(a){case "topCompositionEnd":return ec(b);case "topKeyPress":if(32!==b.which)return null;cc=!0;return ac;case "topTextInput":return a=b.data,a===ac&&cc?null:a;default:return null}}
function hc(a,b){if(fc)return"topCompositionEnd"===a||!Vb&&dc(a,b)?(a=Fb(),S._root=null,S._startText=null,S._fallbackText=null,fc=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return $b?null:b.data;default:return null}}
var ic={eventTypes:bc,extractEvents:function(a,b,c,d){var e;if(Vb)b:{switch(a){case "topCompositionStart":var f=bc.compositionStart;break b;case "topCompositionEnd":f=bc.compositionEnd;break b;case "topCompositionUpdate":f=bc.compositionUpdate;break b}f=void 0}else fc?dc(a,c)&&(f=bc.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=bc.compositionStart);f?($b&&(fc||f!==bc.compositionStart?f===bc.compositionEnd&&fc&&(e=Fb()):(S._root=d,S._startText=Gb(),fc=!0)),f=Mb.getPooled(f,b,c,d),e?f.data=
e:(e=ec(c),null!==e&&(f.data=e)),Ab(f),e=f):e=null;(a=Zb?gc(a,c):hc(a,c))?(b=Nb.getPooled(bc.beforeInput,b,c,d),b.data=a,Ab(b)):b=null;return[e,b]}},jc=null,kc=null,lc=null;function mc(a){if(a=Xa(a)){jc&&"function"===typeof jc.restoreControlledState?void 0:E("194");var b=Wa(a.stateNode);jc.restoreControlledState(a.stateNode,a.type,b)}}var nc={injectFiberControlledHostComponent:function(a){jc=a}};function oc(a){kc?lc?lc.push(a):lc=[a]:kc=a}
function pc(){if(kc){var a=kc,b=lc;lc=kc=null;mc(a);if(b)for(a=0;a<b.length;a++)mc(b[a])}}var qc=Object.freeze({injection:nc,enqueueStateRestore:oc,restoreStateIfNeeded:pc});function rc(a,b){return a(b)}var sc=!1;function tc(a,b){if(sc)return rc(a,b);sc=!0;try{return rc(a,b)}finally{sc=!1,pc()}}var uc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};
function vc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!uc[a.type]:"textarea"===b?!0:!1}function wc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var xc;l.canUseDOM&&(xc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function yc(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&xc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function Bc(a){a._valueTracker||(a._valueTracker=Ac(a))}function Cc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Dc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};
function Ec(a,b,c){a=T.getPooled(Dc.change,a,b,c);a.type="change";oc(c);Ab(a);return a}var Fc=null,Gc=null;function Hc(a){kb(a);lb(!1)}function Ic(a){var b=qb(a);if(Cc(b))return a}function Jc(a,b){if("topChange"===a)return b}var Kc=!1;l.canUseDOM&&(Kc=yc("input")&&(!document.documentMode||9<document.documentMode));function Lc(){Fc&&(Fc.detachEvent("onpropertychange",Mc),Gc=Fc=null)}function Mc(a){"value"===a.propertyName&&Ic(Gc)&&(a=Ec(Gc,a,wc(a)),tc(Hc,a))}
function Nc(a,b,c){"topFocus"===a?(Lc(),Fc=b,Gc=c,Fc.attachEvent("onpropertychange",Mc)):"topBlur"===a&&Lc()}function Oc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Ic(Gc)}function Pc(a,b){if("topClick"===a)return Ic(b)}function $c(a,b){if("topInput"===a||"topChange"===a)return Ic(b)}
var ad={eventTypes:Dc,_isInputEventSupported:Kc,extractEvents:function(a,b,c,d){var e=b?qb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Jc;else if(vc(e))if(Kc)g=$c;else{g=Oc;var h=Nc}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Pc);if(g&&(g=g(a,b)))return Ec(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==
a&&e.setAttribute("value",a))}};function bd(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(bd,{view:null,detail:null});var cd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}function fd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(fd,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?pb(b):null):a=null;if(a===
b)return null;var f=null==a?e:qb(a);e=null==b?e:qb(b);var g=fd.getPooled(gd.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=fd.getPooled(gd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Bb(g,c,a,b);return[g,c]}},id=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;function jd(a){a=a.type;return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}
function kd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){return(a=a._reactInternalFiber)?2===kd(a):!1}function md(a){2!==kd(a)?E("188"):void 0}
function nd(a){var b=a.alternate;if(!b)return b=kd(a),3===b?E("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return md(e),a;if(g===d)return md(e),b;g=g.sibling}E("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:E("189")}}c.alternate!==d?E("190"):void 0}3!==c.tag?E("188"):void 0;return c.stateNode.current===c?a:b}function od(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function pd(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var qd=[];
function rd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=pb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],sd(a.topLevelType,b,a.nativeEvent,wc(a.nativeEvent))}var td=!0,sd=void 0;function ud(a){td=!!a}function U(a,b,c){return c?ba.listen(c,b,vd.bind(null,a)):null}function wd(a,b,c){return c?ba.capture(c,b,vd.bind(null,a)):null}
function vd(a,b){if(td){var c=wc(b);c=pb(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(qd.length){var d=qd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{tc(rd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>qd.length&&qd.push(a)}}}
var xd=Object.freeze({get _enabled(){return td},get _handleTopLevel(){return sd},setHandleTopLevel:function(a){sd=a},setEnabled:ud,isEnabled:function(){return td},trapBubbledEvent:U,trapCapturedEvent:wd,dispatchEvent:vd});function yd(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var zd={animationend:yd("Animation","AnimationEnd"),animationiteration:yd("Animation","AnimationIteration"),animationstart:yd("Animation","AnimationStart"),transitionend:yd("Transition","TransitionEnd")},Ad={},Bd={};l.canUseDOM&&(Bd=document.createElement("div").style,"AnimationEvent"in window||(delete zd.animationend.animation,delete zd.animationiteration.animation,delete zd.animationstart.animation),"TransitionEvent"in window||delete zd.transitionend.transition);
function Cd(a){if(Ad[a])return Ad[a];if(!zd[a])return a;var b=zd[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Bd)return Ad[a]=b[c];return""}
var Dd={topAbort:"abort",topAnimationEnd:Cd("animationend")||"animationend",topAnimationIteration:Cd("animationiteration")||"animationiteration",topAnimationStart:Cd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Cd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Ed={},Fd=0,Gd="_reactListenersID"+(""+Math.random()).slice(2);function Hd(a){Object.prototype.hasOwnProperty.call(a,Gd)||(a[Gd]=Fd++,Ed[a[Gd]]={});return Ed[a[Gd]]}function Id(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Jd(a,b){var c=Id(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Id(c)}}function Kd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ld=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Md={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Nd=null,Od=null,Pd=null,Qd=!1;
function Rd(a,b){if(Qd||null==Nd||Nd!==da())return null;var c=Nd;"selectionStart"in c&&Kd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Pd&&ea(Pd,c)?null:(Pd=c,a=T.getPooled(Md.select,Od,a,b),a.type="select",a.target=Nd,Ab(a),a)}
var Sd={eventTypes:Md,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Hd(e);f=Sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?qb(b):window;switch(a){case "topFocus":if(vc(e)||"true"===e.contentEditable)Nd=e,Od=b,Pd=null;break;case "topBlur":Pd=Od=Nd=null;break;case "topMouseDown":Qd=!0;break;case "topContextMenu":case "topMouseUp":return Qd=!1,Rd(c,d);case "topSelectionChange":if(Ld)break;
case "topKeyDown":case "topKeyUp":return Rd(c,d)}return null}};function Td(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Td,{animationName:null,elapsedTime:null,pseudoElement:null});function Ud(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Ud,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function Vd(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(Vd,{relatedTarget:null});
function Wd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var Xd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Yd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function Zd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(Zd,{key:function(a){if(a.key){var b=Xd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Wd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Yd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===a.type?Wd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?Wd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function $d(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass($d,{dataTransfer:null});function ae(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(ae,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed});function be(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(be,{propertyName:null,elapsedTime:null,pseudoElement:null});
function ce(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass(ce,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var de={},ee={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};de[a]=c;ee[b]=c});
var fe={eventTypes:de,extractEvents:function(a,b,c,d){var e=ee[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Wd(c))return null;case "topKeyDown":case "topKeyUp":a=Zd;break;case "topBlur":case "topFocus":a=Vd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=fd;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=
$d;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=ae;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Td;break;case "topTransitionEnd":a=be;break;case "topScroll":a=bd;break;case "topWheel":a=ce;break;case "topCopy":case "topCut":case "topPaste":a=Ud;break;default:a=T}b=a.getPooled(e,b,c,d);Ab(b);return b}};sd=function(a,b,c,d){a=jb(a,b,c,d);kb(a);lb(!1)};hb.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
Wa=sb.getFiberCurrentPropsFromNode;Xa=sb.getInstanceFromNode;Ya=sb.getNodeFromInstance;hb.injectEventPluginsByName({SimpleEventPlugin:fe,EnterLeaveEventPlugin:hd,ChangeEventPlugin:ad,SelectEventPlugin:Sd,BeforeInputEventPlugin:ic});var ge=[],he=-1;function V(a){0>he||(a.current=ge[he],ge[he]=null,he--)}function W(a,b){he++;ge[he]=a.current;a.current=b}new Set;var ie={current:D},X={current:!1},je=D;function ke(a){return le(a)?je:ie.current}
function me(a,b){var c=a.type.contextTypes;if(!c)return D;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function le(a){return 2===a.tag&&null!=a.type.childContextTypes}function ne(a){le(a)&&(V(X,a),V(ie,a))}
function oe(a,b,c){null!=ie.cursor?E("168"):void 0;W(ie,b,a);W(X,c,a)}function pe(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:E("108",jd(a)||"Unknown",e);return B({},b,c)}function qe(a){if(!le(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||D;je=ie.current;W(ie,b,a);W(X,X.current,a);return!0}
function re(a,b){var c=a.stateNode;c?void 0:E("169");if(b){var d=pe(a,je);c.__reactInternalMemoizedMergedChildContext=d;V(X,a);V(ie,a);W(ie,d,a)}else V(X,a);W(X,b,a)}
function Y(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function se(a,b,c){var d=a.alternate;null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.pendingProps=b;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function te(a,b,c){var d=void 0,e=a.type,f=a.key;"function"===typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"===typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"===typeof e&&null!==e&&"number"===typeof e.tag?(d=e,d.pendingProps=a.props):E("130",null==e?e:typeof e,"");d.expirationTime=c;return d}function ue(a,b,c,d){b=new Y(10,d,b);b.pendingProps=a;b.expirationTime=c;return b}
function ve(a,b,c){b=new Y(6,null,b);b.pendingProps=a;b.expirationTime=c;return b}function we(a,b,c){b=new Y(7,a.key,b);b.type=a.handler;b.pendingProps=a;b.expirationTime=c;return b}function xe(a,b,c){a=new Y(9,null,b);a.expirationTime=c;return a}function ye(a,b,c){b=new Y(4,a.key,b);b.pendingProps=a.children||[];b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var ze=null,Ae=null;
function Be(a){return function(b){try{return a(b)}catch(c){}}}function Ce(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ze=Be(function(a){return b.onCommitFiberRoot(c,a)});Ae=Be(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function De(a){"function"===typeof ze&&ze(a)}function Ee(a){"function"===typeof Ae&&Ae(a)}
function Fe(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Ge(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}
function He(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Fe(null));null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=Fe(null))):a=null;a=a!==d?a:null;null===a?Ge(d,b):null===d.last||null===a.last?(Ge(d,b),Ge(a,b)):(Ge(d,b),a.last=b)}function Ie(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Je(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,h=c.first,k=!1;null!==h;){var q=h.expirationTime;if(q>f){var v=c.expirationTime;if(0===v||v>q)c.expirationTime=q;k||(k=!0,c.baseState=a)}else{k||(c.first=h.next,null===
c.first&&(c.last=null));if(h.isReplace)a=Ie(h,d,a,e),g=!0;else if(q=Ie(h,d,a,e))a=g?B({},a,q):B(a,q),g=!1;h.isForced&&(c.hasForceUpdate=!0);null!==h.callback&&(q=c.callbackList,null===q&&(q=c.callbackList=[]),q.push(h))}h=h.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null);k||(c.baseState=a);return a}
function Ke(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?E("191",e):void 0;e.call(b)}}
function Le(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;b._reactInternalFiber=a}var f={isMounted:ld,enqueueSetState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null});a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null});
a(c,g)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber;d=void 0===d?null:d;var e=b(c);He(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null});a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=ke(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?me(a,d):D;b=new c(b,g);e(a,b);f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g);return b},mountClassInstance:function(a,
b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:E("158");var h=ke(a);d.props=g;d.state=a.memoizedState=e;d.refs=D;d.context=me(a,h);null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1);"function"===typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),e=a.updateQueue,null!==e&&(d.state=Je(c,a,e,d,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=
4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?E("159"):void 0);var u=g.context,z=ke(b);z=me(b,z);"function"!==typeof g.componentWillReceiveProps||h===k&&u===z||(u=g.state,g.componentWillReceiveProps(k,z),g.state!==u&&f.enqueueReplaceState(g,g.state,null));u=b.memoizedState;e=null!==b.updateQueue?Je(a,b,b.updateQueue,g,k,e):u;if(!(h!==k||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==
typeof g.componentDidUpdate||h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var G=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)G=!0;else{var I=b.stateNode,L=b.type;G="function"===typeof I.shouldComponentUpdate?I.shouldComponentUpdate(G,e,z):L.prototype&&L.prototype.isPureReactComponent?!ea(h,G)||!ea(u,e):!0}G?("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(k,e,z),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,k),d(b,e));g.props=k;g.state=e;g.context=z;return G}}}var Qe="function"===typeof Symbol&&Symbol["for"],Re=Qe?Symbol["for"]("react.element"):60103,Se=Qe?Symbol["for"]("react.call"):60104,Te=Qe?Symbol["for"]("react.return"):60105,Ue=Qe?Symbol["for"]("react.portal"):60106,Ve=Qe?Symbol["for"]("react.fragment"):60107,We="function"===typeof Symbol&&Symbol.iterator;
function Xe(a){if(null===a||"undefined"===typeof a)return null;a=We&&a[We]||a["@@iterator"];return"function"===typeof a?a:null}var Ye=Array.isArray;
function Ze(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag?E("110"):void 0,d=b.stateNode);d?void 0:E("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===D?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?E("148"):void 0;b._owner?void 0:E("149",c)}return c}
function $e(a,b){"textarea"!==a.type&&E("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function af(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=se(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=ve(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ze(b,c),d["return"]=a,d;d=te(c,a.internalContextTag,d);d.ref=Ze(b,c);d["return"]=a;return d}function q(a,b,c,d){if(null===b||7!==b.tag)return b=we(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);
b["return"]=a;return b}function v(a,b,c,d){if(null===b||9!==b.tag)return b=xe(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=e(b,null,d);b.type=c.value;b["return"]=a;return b}function y(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=ye(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function u(a,b,c,d,f){if(null===b||10!==b.tag)return b=ue(c,a.internalContextTag,
d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ve(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Re:if(b.type===Ve)return b=ue(b.props.children,a.internalContextTag,c,b.key),b["return"]=a,b;c=te(b,a.internalContextTag,c);c.ref=Ze(null,b);c["return"]=a;return c;case Se:return b=we(b,a.internalContextTag,c),b["return"]=a,b;case Te:return c=xe(b,a.internalContextTag,
c),c.type=b.value,c["return"]=a,c;case Ue:return b=ye(b,a.internalContextTag,c),b["return"]=a,b}if(Ye(b)||Xe(b))return b=ue(b,a.internalContextTag,c,null),b["return"]=a,b;$e(a,b)}return null}function G(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Re:return c.key===e?c.type===Ve?u(a,b,c.props.children,d,e):k(a,b,c,d):null;case Se:return c.key===e?q(a,b,c,d):null;case Te:return null===
e?v(a,b,c,d):null;case Ue:return c.key===e?y(a,b,c,d):null}if(Ye(c)||Xe(c))return null!==e?null:u(a,b,c,d,null);$e(a,c)}return null}function I(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Re:return a=a.get(null===d.key?c:d.key)||null,d.type===Ve?u(b,a,d.props.children,e,d.key):k(b,a,d,e);case Se:return a=a.get(null===d.key?c:d.key)||null,q(b,a,d,e);case Te:return a=a.get(c)||null,v(b,a,d,e);case Ue:return a=
a.get(null===d.key?c:d.key)||null,y(b,a,d,e)}if(Ye(d)||Xe(d))return a=a.get(c)||null,u(b,a,d,e,null);$e(b,d)}return null}function L(e,g,m,A){for(var h=null,r=null,n=g,w=g=0,k=null;null!==n&&w<m.length;w++){n.index>w?(k=n,n=null):k=n.sibling;var x=G(e,n,m[w],A);if(null===x){null===n&&(n=k);break}a&&n&&null===x.alternate&&b(e,n);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x;n=k}if(w===m.length)return c(e,n),h;if(null===n){for(;w<m.length;w++)if(n=z(e,m[w],A))g=f(n,g,w),null===r?h=n:r.sibling=n,r=n;return h}for(n=
d(e,n);w<m.length;w++)if(k=I(n,e,w,m[w],A)){if(a&&null!==k.alternate)n["delete"](null===k.key?w:k.key);g=f(k,g,w);null===r?h=k:r.sibling=k;r=k}a&&n.forEach(function(a){return b(e,a)});return h}function N(e,g,m,A){var h=Xe(m);"function"!==typeof h?E("150"):void 0;m=h.call(m);null==m?E("151"):void 0;for(var r=h=null,n=g,w=g=0,k=null,x=m.next();null!==n&&!x.done;w++,x=m.next()){n.index>w?(k=n,n=null):k=n.sibling;var J=G(e,n,x.value,A);if(null===J){n||(n=k);break}a&&n&&null===J.alternate&&b(e,n);g=f(J,
g,w);null===r?h=J:r.sibling=J;r=J;n=k}if(x.done)return c(e,n),h;if(null===n){for(;!x.done;w++,x=m.next())x=z(e,x.value,A),null!==x&&(g=f(x,g,w),null===r?h=x:r.sibling=x,r=x);return h}for(n=d(e,n);!x.done;w++,x=m.next())if(x=I(n,e,w,x.value,A),null!==x){if(a&&null!==x.alternate)n["delete"](null===x.key?w:x.key);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x}a&&n.forEach(function(a){return b(e,a)});return h}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===Ve&&null===f.key&&(f=f.props.children);
var m="object"===typeof f&&null!==f;if(m)switch(f.$$typeof){case Re:a:{var r=f.key;for(m=d;null!==m;){if(m.key===r)if(10===m.tag?f.type===Ve:m.type===f.type){c(a,m.sibling);d=e(m,f.type===Ve?f.props.children:f.props,h);d.ref=Ze(m,f);d["return"]=a;a=d;break a}else{c(a,m);break}else b(a,m);m=m.sibling}f.type===Ve?(d=ue(f.props.children,a.internalContextTag,h,f.key),d["return"]=a,a=d):(h=te(f,a.internalContextTag,h),h.ref=Ze(d,f),h["return"]=a,a=h)}return g(a);case Se:a:{for(m=f.key;null!==d;){if(d.key===
m)if(7===d.tag){c(a,d.sibling);d=e(d,f,h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=we(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a);case Te:a:{if(null!==d)if(9===d.tag){c(a,d.sibling);d=e(d,null,h);d.type=f.value;d["return"]=a;a=d;break a}else c(a,d);d=xe(f,a.internalContextTag,h);d.type=f.value;d["return"]=a;a=d}return g(a);case Ue:a:{for(m=f.key;null!==d;){if(d.key===m)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===
f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ye(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h)):(c(a,d),d=ve(f,a.internalContextTag,h)),d["return"]=a,a=d,g(a);if(Ye(f))return L(a,d,f,h);if(Xe(f))return N(a,d,f,h);m&&$e(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,E("152",h.displayName||
h.name||"Component")}return c(a,d)}}var bf=af(!0),cf=af(!1);
function df(a,b,c,d,e){function f(a,b,c){var d=b.expirationTime;b.child=null===a?cf(b,null,c,d):bf(b,a.child,c,d)}function g(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){g(a,b);if(!c)return d&&re(b,!1),q(a,b);c=b.stateNode;id.current=b;var e=c.render();b.effectTag|=1;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&re(b,!0);return b.child}function k(a){var b=a.stateNode;b.pendingContext?oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&oe(a,
b.context,!1);I(a,b.containerInfo)}function q(a,b){null!==a&&b.child!==a.child?E("153"):void 0;if(null!==b.child){a=b.child;var c=se(a,a.pendingProps,a.expirationTime);b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=se(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}function v(a,b){switch(b.tag){case 3:k(b);break;case 2:qe(b);break;case 4:I(b,b.stateNode.containerInfo)}return null}var y=a.shouldSetTextContent,u=a.useSyncScheduling,z=a.shouldDeprioritizeSubtree,
G=b.pushHostContext,I=b.pushHostContainer,L=c.enterHydrationState,N=c.resetHydrationState,J=c.tryToClaimNextHydratableInstance;a=Le(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var w=a.adoptClassInstance,m=a.constructClassInstance,A=a.mountClassInstance,Ob=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return v(a,b);switch(b.tag){case 0:null!==a?E("155"):void 0;var d=b.type,e=b.pendingProps,r=ke(b);r=me(b,r);d=d(e,r);b.effectTag|=
1;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=2,e=qe(b),w(b,d),A(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child);return b;case 1:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(X.current)null===c&&(c=d);else if(null===c||d===c){b=q(a,b);break a}d=ke(b);d=me(b,d);e=e(c,d);b.effectTag|=1;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case 2:return e=qe(b),d=void 0,null===a?b.stateNode?E("153"):(m(b,b.pendingProps),A(b,c),d=!0):d=Ob(a,b,c),h(a,b,d,e);case 3:return k(b),
e=b.updateQueue,null!==e?(d=b.memoizedState,e=Je(a,b,e,null,null,c),d===e?(N(),b=q(a,b)):(d=e.element,r=b.stateNode,(null===a||null===a.child)&&r.hydrate&&L(b)?(b.effectTag|=2,b.child=cf(b,null,d,c)):(N(),f(a,b,d)),b.memoizedState=e,b=b.child)):(N(),b=q(a,b)),b;case 5:G(b);null===a&&J(b);e=b.type;var n=b.memoizedProps;d=b.pendingProps;null===d&&(d=n,null===d?E("154"):void 0);r=null!==a?a.memoizedProps:null;X.current||null!==d&&n!==d?(n=d.children,y(e,d)?n=null:r&&y(e,r)&&(b.effectTag|=16),g(a,b),
2147483647!==c&&!u&&z(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,n),b.memoizedProps=d,b=b.child)):b=q(a,b);return b;case 6:return null===a&&J(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null===e?E("154"):void 0);else if(null===e||b.memoizedProps===e)e=b.memoizedProps;d=e.children;b.stateNode=null===a?cf(b,b.stateNode,d,c):bf(b,b.stateNode,d,c);b.memoizedProps=e;return b.stateNode;
case 9:return null;case 4:a:{I(b,b.stateNode.containerInfo);e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null==e?E("154"):void 0);else if(null===e||b.memoizedProps===e){b=q(a,b);break a}null===a?b.child=bf(b,null,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case 10:a:{c=b.pendingProps;if(X.current)null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=q(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:E("156")}},beginFailedWork:function(a,b,
c){switch(b.tag){case 2:qe(b);break;case 3:k(b);break;default:E("157")}b.effectTag|=64;null===a?b.child=null:b.child!==a.child&&(b.child=a.child);if(0===b.expirationTime||b.expirationTime>c)return v(a,b);b.firstEffect=null;b.lastEffect=null;b.child=null===a?cf(b,null,null,c):bf(b,a.child,null,c);2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
function ef(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,h=a.finalizeInitialChildren,k=a.prepareUpdate,q=a.persistence,v=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,z=b.popHostContainer,G=c.prepareToHydrateHostInstance,I=c.prepareToHydrateHostTextInstance,L=c.popHydrationState,N=void 0,J=void 0,w=void 0;a.mutation?(N=function(){},J=function(a,b,c){(b.updateQueue=c)&&d(b)},w=function(a,b,c,e){c!==e&&d(b)}):q?E("235"):E("236");
return{completeWork:function(a,b,c){var m=b.pendingProps;if(null===m)m=b.memoizedProps;else if(2147483647!==b.expirationTime||2147483647===c)b.pendingProps=null;switch(b.tag){case 1:return null;case 2:return ne(b),null;case 3:z(b);V(X,b);V(ie,b);m=b.stateNode;m.pendingContext&&(m.context=m.pendingContext,m.pendingContext=null);if(null===a||null===a.child)L(b),b.effectTag&=-3;N(b);return null;case 5:y(b);c=v();var A=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,q=b.stateNode,x=u();q=
k(q,A,p,m,c,x);J(a,b,q,A,p,m,c);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!m)return null===b.stateNode?E("166"):void 0,null;a=u();if(L(b))G(b,c,a)&&d(b);else{a=e(A,m,c,a,b);a:for(p=b.child;null!==p;){if(5===p.tag||6===p.tag)g(a,p.stateNode);else if(4!==p.tag&&null!==p.child){p.child["return"]=p;p=p.child;continue}if(p===b)break;for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}h(a,A,m,c)&&d(b);b.stateNode=a}null!==b.ref&&
(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)w(a,b,a.memoizedProps,m);else{if("string"!==typeof m)return null===b.stateNode?E("166"):void 0,null;a=v();c=u();L(b)?I(b)&&d(b):b.stateNode=f(m,a,c,b)}return null;case 7:(m=b.memoizedProps)?void 0:E("165");b.tag=8;A=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==p;){if(5===p.tag||6===p.tag||4===p.tag)E("247");else if(9===p.tag)A.push(p.type);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===
p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=m.handler;m=p(m.props,A);b.child=bf(b,null!==a?a.child:null,m,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 10:return null;case 4:return z(b),N(b),null;case 0:E("167");default:E("156")}}}}
function ff(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(A){b(a,A)}}function d(a){"function"===typeof Ee&&Ee(a);switch(a.tag){case 2:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(A){b(a,A)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:k&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||k&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||
b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?E("160"):void 0;switch(c.tag){case 5:f=c.stateNode;g=!1;break a;case 3:f=c.stateNode.containerInfo;g=!0;break a;case 4:f=c.stateNode.containerInfo;g=!0;break a}c=c["return"]}c=!0}if(5===b.tag||6===b.tag)e(b),g?J(f,b.stateNode):N(f,b.stateNode);
else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var h=a.getPublicInstance,k=a.mutation;a=a.persistence;k||(a?E("235"):E("236"));var q=k.commitMount,v=k.commitUpdate,y=k.resetTextContent,u=k.commitTextUpdate,z=k.appendChild,G=k.appendChildToContainer,I=k.insertBefore,L=k.insertInContainerBefore,
N=k.removeChild,J=k.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(f(b)){var c=b;break a}b=b["return"]}E("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:E("161")}c.effectTag&16&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||f(c["return"])){c=
null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?L(b,e.stateNode,c):I(b,e.stateNode,c):d?G(b,e.stateNode):z(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===
a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){g(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&v(c,f,e,a,d,b)}break;case 6:null===b.stateNode?E("162"):void 0;c=b.memoizedProps;u(b.stateNode,null!==a?a.memoizedProps:
c,c);break;case 3:break;default:E("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(b.effectTag&4)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b=b.updateQueue;null!==b&&Ke(b,c);break;case 3:c=b.updateQueue;null!==c&&Ke(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode;null===a&&b.effectTag&4&&q(c,
b.type,b.memoizedProps,b);break;case 6:break;case 4:break;default:E("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(h(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var gf={};
function hf(a){function b(a){a===gf?E("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:gf},f={current:gf},g={current:gf};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a);V(f,a);V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a);b=d(b);W(f,a,a);W(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);
d=c(h,a.type,d);h!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=gf;g.current=gf}}}
function jf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=g(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];y=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){E("175")},prepareToHydrateHostTextInstance:function(){E("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,q=a.hydrateInstance,v=a.hydrateTextInstance,y=null,u=null,z=!1;return{enterHydrationState:function(a){u=
k(a.stateNode.containerInfo);y=a;return z=!0},resetHydrationState:function(){u=y=null;z=!1},tryToClaimNextHydratableInstance:function(a){if(z){var d=u;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=2;z=!1;y=a;return}b(y,u)}y=a;u=k(d)}else a.effectTag|=2,z=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=q(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return v(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
y)return!1;if(!z)return d(a),z=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=h(c);d(a);u=y?h(a.stateNode):null;return!0}}}
function kf(a){function b(a){Qb=ja=!0;var b=a.stateNode;b.current===a?E("177"):void 0;b.isReadyForCommit=!1;id.current=null;if(1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;yg();for(t=c;null!==t;){var d=!1,e=void 0;try{for(;null!==t;){var f=t.effectTag;f&16&&zg(t);if(f&128){var g=t.alternate;null!==g&&Ag(g)}switch(f&-242){case 2:Ne(t);t.effectTag&=-3;break;case 6:Ne(t);t.effectTag&=-3;Oe(t.alternate,t);break;case 4:Oe(t.alternate,
t);break;case 8:Sc=!0,Bg(t),Sc=!1}t=t.nextEffect}}catch(Tc){d=!0,e=Tc}d&&(null===t?E("178"):void 0,h(t,e),null!==t&&(t=t.nextEffect))}Cg();b.current=a;for(t=c;null!==t;){c=!1;d=void 0;try{for(;null!==t;){var k=t.effectTag;k&36&&Dg(t.alternate,t);k&128&&Eg(t);if(k&64)switch(e=t,f=void 0,null!==R&&(f=R.get(e),R["delete"](e),null==f&&null!==e.alternate&&(e=e.alternate,f=R.get(e),R["delete"](e))),null==f?E("184"):void 0,e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});
break;case 3:null===ca&&(ca=f.error);break;default:E("157")}var Qc=t.nextEffect;t.nextEffect=null;t=Qc}}catch(Tc){c=!0,d=Tc}c&&(null===t?E("178"):void 0,h(t,d),null!==t&&(t=t.nextEffect))}ja=Qb=!1;"function"===typeof De&&De(a.stateNode);ha&&(ha.forEach(G),ha=null);null!==ca&&(a=ca,ca=null,Ob(a));b=b.current.expirationTime;0===b&&(qa=R=null);return b}function c(a){for(;;){var b=Fg(a.alternate,a,H),c=a["return"],d=a.sibling;var e=a;if(2147483647===H||2147483647!==e.expirationTime){if(2!==e.tag&&3!==
e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;
if(null!==c)a=c;else{a.stateNode.isReadyForCommit=!0;break}}return null}function d(a){var b=rg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function e(a){var b=Gg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function f(a){if(null!==R){if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=k(F)?e(F):d(F);else for(;null!==F&&!A();)F=k(F)?e(F):d(F)}else if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=d(F);else for(;null!==F&&!A();)F=d(F)}function g(a,b){ja?E("243"):void 0;ja=!0;a.isReadyForCommit=
!1;if(a!==ra||b!==H||null===F){for(;-1<he;)ge[he]=null,he--;je=D;ie.current=D;X.current=!1;x();ra=a;H=b;F=se(ra.current,null,b)}var c=!1,d=null;try{f(b)}catch(Rc){c=!0,d=Rc}for(;c;){if(eb){ca=d;break}var g=F;if(null===g)eb=!0;else{var k=h(g,d);null===k?E("183"):void 0;if(!eb){try{c=k;d=b;for(k=c;null!==g;){switch(g.tag){case 2:ne(g);break;case 5:qg(g);break;case 3:p(g);break;case 4:p(g)}if(g===k||g.alternate===k)break;g=g["return"]}F=e(c);f(d)}catch(Rc){c=!0;d=Rc;continue}break}}}b=ca;eb=ja=!1;ca=
null;null!==b&&Ob(b);return a.isReadyForCommit?a.current.alternate:null}function h(a,b){var c=id.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,q(a)&&(eb=!0);else for(var g=a["return"];null!==g&&null===c;){2===g.tag?"function"===typeof g.stateNode.componentDidCatch&&(d=!0,f=jd(g),c=g,e=!0):3===g.tag&&(c=g);if(q(g)){if(Sc||null!==ha&&(ha.has(g)||null!==g.alternate&&ha.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===qa&&(qa=new Set);qa.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=
g._debugOwner,Qc=g._debugSource;var m=jd(g);var n=null;k&&(n=jd(k));k=Qc;m="\n    in "+(m||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:m=""}h+=m;g=g["return"]}while(g);g=h;a=jd(a);null===R&&(R=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};R.set(c,b);try{var p=b.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(Vc){Vc&&
Vc.suppressReactErrorLogging||console.error(Vc)}Qb?(null===ha&&(ha=new Set),ha.add(c)):G(c);return c}null===ca&&(ca=b);return null}function k(a){return null!==R&&(R.has(a)||null!==a.alternate&&R.has(a.alternate))}function q(a){return null!==qa&&(qa.has(a)||null!==a.alternate&&qa.has(a.alternate))}function v(){return 20*(((I()+100)/20|0)+1)}function y(a){return 0!==ka?ka:ja?Qb?1:H:!Hg||a.internalContextTag&1?v():1}function u(a,b){return z(a,b,!1)}function z(a,b){for(;null!==a;){if(0===a.expirationTime||
a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a["return"])if(3===a.tag){var c=a.stateNode;!ja&&c===ra&&b<H&&(F=ra=null,H=0);var d=c,e=b;Rb>Ig&&E("185");if(null===d.nextScheduledRoot)d.remainingExpirationTime=e,null===O?(sa=O=d,d.nextScheduledRoot=d):(O=O.nextScheduledRoot=d,O.nextScheduledRoot=sa);else{var f=d.remainingExpirationTime;if(0===f||e<f)d.remainingExpirationTime=e}Fa||(la?
Sb&&(ma=d,na=1,m(ma,na)):1===e?w(1,null):L(e));!ja&&c===ra&&b<H&&(F=ra=null,H=0)}else break;a=a["return"]}}function G(a){z(a,1,!0)}function I(){return Uc=((Wc()-Pe)/10|0)+2}function L(a){if(0!==Tb){if(a>Tb)return;Jg(Xc)}var b=Wc()-Pe;Tb=a;Xc=Kg(J,{timeout:10*(a-2)-b})}function N(){var a=0,b=null;if(null!==O)for(var c=O,d=sa;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===O?E("244"):void 0;if(d===d.nextScheduledRoot){sa=O=d.nextScheduledRoot=null;break}else if(d===sa)sa=e=d.nextScheduledRoot,
O.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===O){O=c;O.nextScheduledRoot=sa;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===O)break;c=d;d=d.nextScheduledRoot}}c=ma;null!==c&&c===b?Rb++:Rb=0;ma=b;na=a}function J(a){w(0,a)}function w(a,b){fb=b;for(N();null!==ma&&0!==na&&(0===a||na<=a)&&!Yc;)m(ma,na),N();null!==fb&&(Tb=0,Xc=-1);0!==na&&L(na);fb=null;Yc=!1;Rb=0;if(Ub)throw a=Zc,Zc=
null,Ub=!1,a;}function m(a,c){Fa?E("245"):void 0;Fa=!0;if(c<=I()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(a.remainingExpirationTime=b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(A()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Fa=!1}function A(){return null===fb||fb.timeRemaining()>Lg?!1:Yc=!0}function Ob(a){null===ma?E("246"):
void 0;ma.remainingExpirationTime=0;Ub||(Ub=!0,Zc=a)}var r=hf(a),n=jf(a),p=r.popHostContainer,qg=r.popHostContext,x=r.resetHostContainer,Me=df(a,r,n,u,y),rg=Me.beginWork,Gg=Me.beginFailedWork,Fg=ef(a,r,n).completeWork;r=ff(a,h);var zg=r.commitResetTextContent,Ne=r.commitPlacement,Bg=r.commitDeletion,Oe=r.commitWork,Dg=r.commitLifeCycles,Eg=r.commitAttachRef,Ag=r.commitDetachRef,Wc=a.now,Kg=a.scheduleDeferredCallback,Jg=a.cancelDeferredCallback,Hg=a.useSyncScheduling,yg=a.prepareForCommit,Cg=a.resetAfterCommit,
Pe=Wc(),Uc=2,ka=0,ja=!1,F=null,ra=null,H=0,t=null,R=null,qa=null,ha=null,ca=null,eb=!1,Qb=!1,Sc=!1,sa=null,O=null,Tb=0,Xc=-1,Fa=!1,ma=null,na=0,Yc=!1,Ub=!1,Zc=null,fb=null,la=!1,Sb=!1,Ig=1E3,Rb=0,Lg=1;return{computeAsyncExpiration:v,computeExpirationForFiber:y,scheduleWork:u,batchedUpdates:function(a,b){var c=la;la=!0;try{return a(b)}finally{(la=c)||Fa||w(1,null)}},unbatchedUpdates:function(a){if(la&&!Sb){Sb=!0;try{return a()}finally{Sb=!1}}return a()},flushSync:function(a){var b=la;la=!0;try{a:{var c=
ka;ka=1;try{var d=a();break a}finally{ka=c}d=void 0}return d}finally{la=b,Fa?E("187"):void 0,w(1,null)}},deferredUpdates:function(a){var b=ka;ka=v();try{return a()}finally{ka=b}}}}
function lf(a){function b(a){a=od(a);return null===a?null:a.stateNode}var c=a.getPublicInstance;a=kf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null};return c.stateNode=a},updateContainer:function(a,b,c,q){var g=b.current;if(c){c=
c._reactInternalFiber;var h;b:{2===kd(c)&&2===c.tag?void 0:E("170");for(h=c;3!==h.tag;){if(le(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h["return"])?void 0:E("171")}h=h.stateNode.context}c=le(c)?pe(c,h):h}else c=D;null===b.context?b.context=c:b.pendingContext=c;b=q;b=void 0===b?null:b;q=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g);He(g,{expirationTime:q,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,
nextCallback:null,next:null});f(g,q)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){a=pd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return Ce(B({},
a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ue,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};
var sf=void 0,tf=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==wf&&wf<=
a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity}})})},
tf=function(a){clearTimeout(a)};var Ef=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Ff={},Gf={};
function Hf(a){if(Gf.hasOwnProperty(a))return!0;if(Ff.hasOwnProperty(a))return!1;if(Ef.test(a))return Gf[a]=!0;Ff[a]=!0;return!1}
function If(a,b,c){var d=wa(b);if(d&&va(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Jf(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Kf(a,b,va(b,c)?c:null)}
function Kf(a,b,c){Hf(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Jf(a,b){var c=wa(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}
function Lf(a,b){var c=b.value,d=b.checked;return B({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function Mf(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}
function Nf(a,b){b=b.checked;null!=b&&If(a,"checked",b)}function Of(a,b){Nf(a,b);var c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Pf(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Qf(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function Rf(a,b){a=B({children:void 0},b);if(b=Qf(b.children))a.children=b;return a}function Sf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Tf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Uf(a,b){null!=b.dangerouslySetInnerHTML?E("91"):void 0;return B({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Vf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?E("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:E("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Wf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Xf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Yf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Zf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function $f(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Zf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ag=void 0,bg=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Yf.svg||"innerHTML"in a)a.innerHTML=b;else{ag=ag||document.createElement("div");ag.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=ag.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function cg(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var dg={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},eg=["Webkit","ms","Moz","O"];Object.keys(dg).forEach(function(a){eg.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);dg[b]=dg[a]})});
function fg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||dg.hasOwnProperty(e)&&dg[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var gg=B({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function hg(a,b,c){b&&(gg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?E("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?E("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:E("61")),null!=b.style&&"object"!==typeof b.style?E("62",c()):void 0)}
function ig(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var jg=Yf.html,kg=C.thatReturns("");
function lg(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Hd(a);b=Sa[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?wd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(wd("topFocus","focus",a),wd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(yc("cancel",!0)&&wd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(yc("close",!0)&&wd("topClose","close",a),c.topClose=!0):Dd.hasOwnProperty(e)&&U(e,Dd[e],a),c[e]=!0)}}
var mg={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"};function ng(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===jg&&(d=Zf(a));d===jg?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function og(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function pg(a,b,c,d){var e=ig(b,c);switch(b){case "iframe":case "object":U("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);f=c;break;case "source":U("topError","error",a);f=c;break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);f=c;break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);f=c;break;case "details":U("topToggle","toggle",a);f=c;break;case "input":Mf(a,c);f=Lf(a,c);U("topInvalid","invalid",a);
lg(d,"onChange");break;case "option":f=Rf(a,c);break;case "select":Tf(a,c);f=B({},c,{value:void 0});U("topInvalid","invalid",a);lg(d,"onChange");break;case "textarea":Vf(a,c);f=Uf(a,c);U("topInvalid","invalid",a);lg(d,"onChange");break;default:f=c}hg(b,f,kg);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?fg(a,k,kg):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&bg(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&cg(a,k):"number"===typeof k&&cg(a,
""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Ra.hasOwnProperty(h)?null!=k&&lg(d,h):e?Kf(a,h,k):null!=k&&If(a,h,k))}switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Sf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Sf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=
C)}}
function sg(a,b,c,d,e){var f=null;switch(b){case "input":c=Lf(a,c);d=Lf(a,d);f=[];break;case "option":c=Rf(a,c);d=Rf(a,d);f=[];break;case "select":c=B({},c,{value:void 0});d=B({},d,{value:void 0});f=[];break;case "textarea":c=Uf(a,c);d=Uf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}hg(b,d,kg);var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]=
"");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Ra.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===
g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Ra.hasOwnProperty(g)?(null!=k&&lg(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f}
function tg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Nf(a,e);ig(c,d);d=ig(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?fg(a,h,kg):"dangerouslySetInnerHTML"===g?bg(a,h):"children"===g?cg(a,h):d?null!=h?Kf(a,g,h):a.removeAttribute(g):null!=h?If(a,g,h):Jf(a,g)}switch(c){case "input":Of(a,e);break;case "textarea":Wf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Sf(a,
!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?Sf(a,!!e.multiple,e.defaultValue,!0):Sf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function ug(a,b,c,d,e){switch(b){case "iframe":case "object":U("topLoad","load",a);break;case "video":case "audio":for(var f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);break;case "source":U("topError","error",a);break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);break;case "details":U("topToggle","toggle",a);break;case "input":Mf(a,c);U("topInvalid","invalid",a);lg(e,"onChange");break;case "select":Tf(a,c);
U("topInvalid","invalid",a);lg(e,"onChange");break;case "textarea":Vf(a,c),U("topInvalid","invalid",a),lg(e,"onChange")}hg(b,c,kg);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Ra.hasOwnProperty(g)&&null!=f&&lg(e,g));switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function vg(a,b){return a.nodeValue!==b}
var wg=Object.freeze({createElement:ng,createTextNode:og,setInitialProperties:pg,diffProperties:sg,updateProperties:tg,diffHydratedProperties:ug,diffHydratedText:vg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Of(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=rb(d);e?void 0:E("90");Cc(d);Of(d,e)}}}break;case "textarea":Wf(a,c);break;case "select":b=c.value,null!=b&&Sf(a,!!c.multiple,b,!1)}}});nc.injectFiberControlledHostComponent(wg);var xg=null,Mg=null;function Ng(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function Og(a){a=a?9===a.nodeType?a.documentElement:a.firstChild:null;return!(!a||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}
var Z=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:$f(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=$f(a,b)}return a},getChildHostContext:function(a,b){return $f(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){xg=td;var a=da();if(Kd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(z){b=null;break a}var f=0,g=-1,h=-1,k=0,q=0,v=a,y=null;b:for(;;){for(var u;;){v!==b||0!==d&&3!==v.nodeType||(g=f+d);v!==e||0!==c&&3!==v.nodeType||(h=f+c);3===v.nodeType&&(f+=v.nodeValue.length);if(null===(u=v.firstChild))break;y=v;v=u}for(;;){if(v===a)break b;y===b&&++k===d&&(g=f);y===e&&++q===c&&(h=f);if(null!==(u=v.nextSibling))break;v=y;y=v.parentNode}v=u}b=-1===g||-1===h?null:
{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;Mg={focusedElem:a,selectionRange:b};ud(!1)},resetAfterCommit:function(){var a=Mg,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){if(Kd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Eb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=Jd(c,a);var f=Jd(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ia(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=
a.top}Mg=null;ud(xg);xg=null},createInstance:function(a,b,c,d,e){a=ng(a,b,c,d);a[Q]=e;a[ob]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){pg(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return sg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===
typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=og(a,b);a[Q]=d;return a},now:rf,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[ob]=e;tg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,
b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,
b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[Q]=f;a[ob]=c;return ug(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[Q]=c;return vg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},
didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf,useSyncScheduling:!0});rc=Z.batchedUpdates;
function Pg(a,b,c,d,e){Ng(c)?void 0:E("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{d=d||Og(c);if(!d)for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g;Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Qg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ng(b)?void 0:E("200");return pf(a,b,null,c)}
function Rg(a,b){this._reactRootContainer=Z.createContainer(a,b)}Rg.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)};Rg.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};
var Sg={createPortal:Qg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"===typeof a.render?E("188"):E("213",Object.keys(a))},hydrate:function(a,b,c){return Pg(null,a,b,!0,c)},render:function(a,b,c){return Pg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?E("38"):void 0;return Pg(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ng(a)?void 0:
E("40");return a._reactRootContainer?(Z.unbatchedUpdates(function(){Pg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:Qg,unstable_batchedUpdates:tc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:mb,EventPluginRegistry:Va,EventPropagators:Cb,ReactControlledComponent:qc,ReactDOMComponentTree:sb,ReactDOMEventListener:xd}};
Z.injectIntoDevTools({findFiberByHostInstance:pb,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var Tg=Object.freeze({default:Sg}),Ug=Tg&&Sg||Tg;module.exports=Ug["default"]?Ug["default"]:Ug;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(99);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(495);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(496);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_waypoint__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__USMapChart__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_56_years_totals_json__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_56_years_totals_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__data_56_years_totals_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_semiotic_stacked_area__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_semiotic_line_graph__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EmploymentChart__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ScrollyTextBox__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Waypoints_js__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EmmissionsChart__ = __webpack_require__(1339);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// var ReactCSSTransitionGroup = require('react-transition-group'); // ES5 with npm
// Sort of works
// const Fade = function({ children, ...props }) {
//   console.log("#faded key: ", props);
//   return (
//     <CSSTransition
//       {...props}
//       timeout={1000}
//       classNames="fade"
//     >
//       {children}
//     </CSSTransition>);
// };
// <TransitionGroup className='vis-transition-group'>
//    <Fade key={this.state.activeWaypoint.correspondingVis}>
//      {this.renderCurrentVis()}
//    </Fade>
// </TransitionGroup>
var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.state={activeWaypoint:{correspondingVis:1},chartFixed:false,chartAtBottom:false,firstRender:true};return _this;}_createClass(App,[{key:'handleAllWaypointEnters',value:function handleAllWaypointEnters(props,id){this.setState({activeWaypoint:__WEBPACK_IMPORTED_MODULE_8__Waypoints_js__["a" /* waypoints */][id],chartFixed:true});}},{key:'handleAllWaypointLeaves',value:function handleAllWaypointLeaves(props,id){if(props.currentPosition===__WEBPACK_IMPORTED_MODULE_1_react_waypoint__["a" /* default */].below&&id!==0){this.setState({activeWaypoint:__WEBPACK_IMPORTED_MODULE_8__Waypoints_js__["a" /* waypoints */][id-1]});}}},{key:'handleHeaderWaypointEnter',value:function handleHeaderWaypointEnter(props){this.setState({chartFixed:false});}},{key:'handleHeaderWaypointLeave',value:function handleHeaderWaypointLeave(props){if(props.currentPosition===__WEBPACK_IMPORTED_MODULE_1_react_waypoint__["a" /* default */].above){this.setState({chartFixed:true});}}},{key:'handleFooterWaypointEnter',value:function handleFooterWaypointEnter(){this.setState({chartFixed:false,chartAtBottom:true});}},{key:'handleFooterWaypointLeave',value:function handleFooterWaypointLeave(){this.setState({chartFixed:true,chartAtBottom:false});}},{key:'renderCurrentVis',value:function renderCurrentVis(){if(!this.state.activeWaypoint)return null;switch(this.state.activeWaypoint.correspondingVis){case 0:return null;case 1:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"vis-area-container stacked "+(this.state.chartFixed?"fixed":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'U.S. Electric Power Generation Over Time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_semiotic_stacked_area__["a" /* Semiotic_Stacked_Area */],{data:__WEBPACK_IMPORTED_MODULE_3__data_56_years_totals_json___default.a,annotations:this.state.activeWaypoint.annotations}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'legend.png',className:'legend-stacked-area'}));case 2:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"vis-area-container "+(this.state.chartFixed?"fixed":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__EmmissionsChart__["a" /* default */],null));case 3:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"vis-area-container "+(this.state.chartFixed?"fixed":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__EmploymentChart__["a" /* default */],{annotations:this.state.activeWaypoint.annotations}));case 4:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"vis-area-container "+(this.state.chartFixed?"fixed":""),style:{padding:"0px 20px 20px 20px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:"100%",height:"90%",alignContent:"center",display:"flex",flexDirection:"column",justifyContent:"opposite"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__USMapChart__["a" /* default */],{annotations:this.state.activeWaypoint.annotations,year:new Date(this.state.activeWaypoint.annotations[0].YYYYMM).getFullYear().toString()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_semiotic_line_graph__["a" /* Semiotic_Line_Graph */],{data:__WEBPACK_IMPORTED_MODULE_3__data_56_years_totals_json___default.a,annotations:this.state.activeWaypoint.annotations})));default:return null;}}},{key:'renderScrollyTextBoxes',value:function renderScrollyTextBoxes(){var _this2=this;var i=0;__WEBPACK_IMPORTED_MODULE_8__Waypoints_js__["a" /* waypoints */].forEach(function(w){return w.id=i++;});return __WEBPACK_IMPORTED_MODULE_8__Waypoints_js__["a" /* waypoints */].map(function(w){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:w.id,className:'waypoint-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_waypoint__["a" /* default */],{onEnter:function onEnter(waypointProps){return _this2.handleAllWaypointEnters(waypointProps,w.id);},onLeave:function onLeave(waypointProps){return _this2.handleAllWaypointLeaves(waypointProps,w.id);},bottomOffset:'300px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ScrollyTextBox__["a" /* default */],{color:w.textBoxColor,description:w.textBoxDescription,title:w.textBoxTitle,active:_this2.state.activeWaypoint.id===w.id,href:w.citation,id:w.id})));});}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-page',id:'header-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'power-plant2.png',className:'header-image'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Beautiful, clean coal?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'An interactive visual essay by Ian Banatoski, Derek Feehrer, and Michael Moukarzel'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_waypoint__["a" /* default */],{onEnter:function onEnter(props){return _this3.handleHeaderWaypointEnter(props);},onLeave:function onLeave(props){return _this3.handleHeaderWaypointLeave(props);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'intro-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('quote',null,'We have ended the war on American energy, and we have ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'ended the war on beautiful, clean coal.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'~President Trump, State of the Union Address 2018'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The "war on coal" is a phrase that has been used for years by the coal industry and its advocates to describe a struggle between environmental regulations and coal. But is this battle really as black and white as the term implies? As with most real wars, it is often difficult to identify the antagonists.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Furthermore, could coal really be clean? Trump\'s term as president has reignited interest in these questions once again. In order to understand this story, we\'ll have to take a trip back through time. Our journey begins over 70 years ago in 1954.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Scroll down to begin...')))),this.renderCurrentVis(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column scrolly-column'},this.renderScrollyTextBoxes()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_waypoint__["a" /* default */],{onEnter:function onEnter(){return _this3.handleFooterWaypointEnter();},onLeave:function onLeave(){return _this3.handleFooterWaypointLeave();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'conclusion-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'conclusion-section-paragraph'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The war on coal is real, but the situation is a lot more complicated than it might initially appear. Market forces and environmental factors both have a role in this story. The country is continually demanding more and more energy and in not so distant future we will be consuming vastly more energy than we do today. Therefore we should expand, rather than limit, our options for clean low-carbon energy.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The past decade shows that natural gas has played a key role in helping decarbonize US power. Natural gas is not by any means a perfect energy source, but it may be the lesser of two evils. If coal truly is dying because cheaper cleaner options are becoming more availble, is it worth it to invest more money into saving an energy source that the market is already phasing out.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'At the end of the day, it\'s a matter of perspective.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'tree-clouds.png',className:'conclusion-image'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sources-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Data Sources:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{style:{listStyleType:"circle",listStylePosition:"inside"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"https://www.eia.gov/electricity/data.php#elecenv"},'Extra EIA Data')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"https://www.eia.gov/totalenergy/data/browser/csv.cfm?tbl=T07.02A"},'1950-2016 Monthly Generation')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"https://www.ipcc.ch/pdf/assessment-report/ar5/wg3/ipcc_wg3_ar5_annex-iii.pdf"},'Emmisions Data')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"https://data.bls.gov/timeseries/CES1021210001"},'Unemployment Data')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.freepik.com'},'Polygon icons designed by Freepik')))))));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_consolidated_events__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_consolidated_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_consolidated_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);




/**
 * Attempts to parse the offset provided as a prop as a percentage. For
 * instance, if the component has been provided with the string "20%" as
 * a value of one of the offset props. If the value matches, then it returns
 * a numeric version of the prop. For instance, "20%" would become `0.2`.
 * If `str` isn't a percentage, then `undefined` will be returned.
 *
 * @param {string} str The value of an offset prop to be converted to a
 *   number.
 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
 *   was not a percentage.
 */
function parseOffsetAsPercentage(str) {
  if (str.slice(-1) === '%') {
    return parseFloat(str.slice(0, -1)) / 100;
  }
}

/**
 * Attempts to parse the offset provided as a prop as a pixel value. If
 * parsing fails, then `undefined` is returned. Three examples of values that
 * will be successfully parsed are:
 * `20`
 * "20px"
 * "20"
 *
 * @param {string|number} str A string of the form "{number}" or "{number}px",
 *   or just a number.
 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
 *   was neither a number nor string ending in "px".
 */
function parseOffsetAsPixels(str) {
  if (!isNaN(parseFloat(str)) && isFinite(str)) {
    return parseFloat(str);
  } else if (str.slice(-2) === 'px') {
    return parseFloat(str.slice(0, -2));
  }
}

/**
 * @param {string|number} offset
 * @param {number} contextHeight
 * @return {number} A number representing `offset` converted into pixels.
 */
function computeOffsetPixels(offset, contextHeight) {
  var pixelOffset = parseOffsetAsPixels(offset);

  if (typeof pixelOffset === 'number') {
    return pixelOffset;
  }

  var percentOffset = parseOffsetAsPercentage(offset);
  if (typeof percentOffset === 'number') {
    return percentOffset * contextHeight;
  }
}

var constants = {
  above: 'above',
  inside: 'inside',
  below: 'below',
  invisible: 'invisible'
};

function debugLog() {
  if (false) {
    console.log(arguments); // eslint-disable-line no-console
  }
}

var errorMessage = '<Waypoint> expected to receive a single React element child.\n\n' + 'See https://goo.gl/LrBNgw for more info.';

/**
 * Raise an error if more that one child was provided to "children"
 *
 * @param {?React.element} children
 * @return {undefined}
 */
function ensureChildrenIsValid(children) {
  if (children) {
    try {
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);
    } catch (e) {
      throw new Error(errorMessage);
    }
  }
}

/**
 * When an element's type is a string, it represents a DOM node with that tag name
 * https://facebook.github.io/react/blog/2015/12/18/react-components-elements-and-instances.html#dom-elements
 *
 * @param {React.element} Component
 * @return {bool} Whether the component is a DOM Element
 */
function isDOMElement(Component) {
  return typeof Component.type === 'string';
}

var errorMessage$1 = '<Waypoint> needs a DOM element to compute boundaries. The child you passed is neither a ' + 'DOM element (e.g. <div>) nor does it use the innerRef prop.\n\n' + 'See https://goo.gl/LrBNgw for more info.';

/**
 * Raise an error if "children" is not a DOM Element and there is no ref provided to Waypoint
 *
 * @param {?React.element} children
 * @param {?HTMLElement} ref
 * @return {undefined}
 */
function ensureRefIsProvidedByChild(children, ref) {
  if (children && !isDOMElement(children) && !ref) {
    throw new Error(errorMessage$1);
  }
}

/**
 * @param {object} bounds An object with bounds data for the waypoint and
 *   scrollable parent
 * @return {string} The current position of the waypoint in relation to the
 *   visible portion of the scrollable parent. One of `constants.above`,
 *   `constants.below`, or `constants.inside`.
 */
function getCurrentPosition(bounds) {
  if (bounds.viewportBottom - bounds.viewportTop === 0) {
    return constants.invisible;
  }

  // top is within the viewport
  if (bounds.viewportTop <= bounds.waypointTop && bounds.waypointTop <= bounds.viewportBottom) {
    return constants.inside;
  }

  // bottom is within the viewport
  if (bounds.viewportTop <= bounds.waypointBottom && bounds.waypointBottom <= bounds.viewportBottom) {
    return constants.inside;
  }

  // top is above the viewport and bottom is below the viewport
  if (bounds.waypointTop <= bounds.viewportTop && bounds.viewportBottom <= bounds.waypointBottom) {
    return constants.inside;
  }

  if (bounds.viewportBottom < bounds.waypointTop) {
    return constants.below;
  }

  if (bounds.waypointTop < bounds.viewportTop) {
    return constants.above;
  }

  return constants.invisible;
}

var timeout = void 0;
var timeoutQueue = [];

function onNextTick(cb) {
  timeoutQueue.push(cb);

  if (!timeout) {
    timeout = setTimeout(function () {
      timeout = null;

      // Drain the timeoutQueue
      var item = void 0;
      // eslint-disable-next-line no-cond-assign
      while (item = timeoutQueue.shift()) {
        item();
      }
    }, 0);
  }

  var isSubscribed = true;

  return function () {
    function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      var index = timeoutQueue.indexOf(cb);
      if (index === -1) {
        return;
      }

      timeoutQueue.splice(index, 1);

      if (!timeoutQueue.length && timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
    }

    return unsubscribe;
  }();
}

function resolveScrollableAncestorProp(scrollableAncestor) {
  // When Waypoint is rendered on the server, `window` is not available.
  // To make Waypoint easier to work with, we allow this to be specified in
  // string form and safely convert to `window` here.
  if (scrollableAncestor === 'window') {
    return global.window;
  }

  return scrollableAncestor;
}

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultProps = {
  topOffset: '0px',
  bottomOffset: '0px',
  horizontal: false,
  onEnter: function () {
    function onEnter() {}

    return onEnter;
  }(),
  onLeave: function () {
    function onLeave() {}

    return onLeave;
  }(),
  onPositionChange: function () {
    function onPositionChange() {}

    return onPositionChange;
  }(),

  fireOnRapidScroll: true
};

/**
 * Calls a function when you scroll to the element.
 */

var Waypoint = function (_React$Component) {
  _inherits(Waypoint, _React$Component);

  function Waypoint(props) {
    _classCallCheck(this, Waypoint);

    var _this = _possibleConstructorReturn(this, (Waypoint.__proto__ || Object.getPrototypeOf(Waypoint)).call(this, props));

    _this.refElement = function (e) {
      return _this._ref = e;
    };
    return _this;
  }

  _createClass(Waypoint, [{
    key: 'componentWillMount',
    value: function () {
      function componentWillMount() {
        ensureChildrenIsValid(this.props.children);
      }

      return componentWillMount;
    }()
  }, {
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _this2 = this;

        if (!Waypoint.getWindow()) {
          return;
        }

        // this._ref may occasionally not be set at this time. To help ensure that
        // this works smoothly, we want to delay the initial execution until the
        // next tick.
        this.cancelInitialTimeout = onNextTick(function () {
          // Berofe doing anything, we want to check that this._ref is avaliable in Waypoint
          ensureRefIsProvidedByChild(_this2.props.children, _this2._ref);

          _this2._handleScroll = _this2._handleScroll.bind(_this2);
          _this2.scrollableAncestor = _this2._findScrollableAncestor();

          if (false) {
            debugLog('scrollableAncestor', _this2.scrollableAncestor);
          }

          _this2.scrollEventListenerUnsubscribe = Object(__WEBPACK_IMPORTED_MODULE_0_consolidated_events__["addEventListener"])(_this2.scrollableAncestor, 'scroll', _this2._handleScroll, { passive: true });

          _this2.resizeEventListenerUnsubscribe = Object(__WEBPACK_IMPORTED_MODULE_0_consolidated_events__["addEventListener"])(window, 'resize', _this2._handleScroll, { passive: true });

          _this2._handleScroll(null);
        });
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(newProps) {
        ensureChildrenIsValid(newProps.children);
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate() {
        if (!Waypoint.getWindow()) {
          return;
        }

        if (!this.scrollableAncestor) {
          // The Waypoint has not yet initialized.
          return;
        }

        // The element may have moved.
        this._handleScroll(null);
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        if (!Waypoint.getWindow()) {
          return;
        }

        if (this.scrollEventListenerUnsubscribe) {
          this.scrollEventListenerUnsubscribe();
        }
        if (this.resizeEventListenerUnsubscribe) {
          this.resizeEventListenerUnsubscribe();
        }

        if (this.cancelInitialTimeout) {
          this.cancelInitialTimeout();
        }
      }

      return componentWillUnmount;
    }()

    /**
     * Traverses up the DOM to find an ancestor container which has an overflow
     * style that allows for scrolling.
     *
     * @return {Object} the closest ancestor element with an overflow style that
     *   allows for scrolling. If none is found, the `window` object is returned
     *   as a fallback.
     */

  }, {
    key: '_findScrollableAncestor',
    value: function () {
      function _findScrollableAncestor() {
        var _props = this.props,
            horizontal = _props.horizontal,
            scrollableAncestor = _props.scrollableAncestor;


        if (scrollableAncestor) {
          return resolveScrollableAncestorProp(scrollableAncestor);
        }

        var node = this._ref;

        while (node.parentNode) {
          node = node.parentNode;

          if (node === document.body) {
            // We've reached all the way to the root node.
            return window;
          }

          var style = window.getComputedStyle(node);
          var overflowDirec = horizontal ? style.getPropertyValue('overflow-x') : style.getPropertyValue('overflow-y');
          var overflow = overflowDirec || style.getPropertyValue('overflow');

          if (overflow === 'auto' || overflow === 'scroll') {
            return node;
          }
        }

        // A scrollable ancestor element was not found, which means that we need to
        // do stuff on window.
        return window;
      }

      return _findScrollableAncestor;
    }()

    /**
     * @param {Object} event the native scroll event coming from the scrollable
     *   ancestor, or resize event coming from the window. Will be undefined if
     *   called by a React lifecyle method
     */

  }, {
    key: '_handleScroll',
    value: function () {
      function _handleScroll(event) {
        if (!this._ref) {
          // There's a chance we end up here after the component has been unmounted.
          return;
        }

        var bounds = this._getBounds();
        var currentPosition = getCurrentPosition(bounds);
        var previousPosition = this._previousPosition;

        if (false) {
          debugLog('currentPosition', currentPosition);
          debugLog('previousPosition', previousPosition);
        }

        // Save previous position as early as possible to prevent cycles
        this._previousPosition = currentPosition;

        if (previousPosition === currentPosition) {
          // No change since last trigger
          return;
        }

        var callbackArg = {
          currentPosition: currentPosition,
          previousPosition: previousPosition,
          event: event,
          waypointTop: bounds.waypointTop,
          waypointBottom: bounds.waypointBottom,
          viewportTop: bounds.viewportTop,
          viewportBottom: bounds.viewportBottom
        };
        this.props.onPositionChange.call(this, callbackArg);

        if (currentPosition === constants.inside) {
          this.props.onEnter.call(this, callbackArg);
        } else if (previousPosition === constants.inside) {
          this.props.onLeave.call(this, callbackArg);
        }

        var isRapidScrollDown = previousPosition === constants.below && currentPosition === constants.above;
        var isRapidScrollUp = previousPosition === constants.above && currentPosition === constants.below;

        if (this.props.fireOnRapidScroll && (isRapidScrollDown || isRapidScrollUp)) {
          // If the scroll event isn't fired often enough to occur while the
          // waypoint was visible, we trigger both callbacks anyway.
          this.props.onEnter.call(this, {
            currentPosition: constants.inside,
            previousPosition: previousPosition,
            event: event,
            waypointTop: bounds.waypointTop,
            waypointBottom: bounds.waypointBottom,
            viewportTop: bounds.viewportTop,
            viewportBottom: bounds.viewportBottom
          });
          this.props.onLeave.call(this, {
            currentPosition: currentPosition,
            previousPosition: constants.inside,
            event: event,
            waypointTop: bounds.waypointTop,
            waypointBottom: bounds.waypointBottom,
            viewportTop: bounds.viewportTop,
            viewportBottom: bounds.viewportBottom
          });
        }
      }

      return _handleScroll;
    }()
  }, {
    key: '_getBounds',
    value: function () {
      function _getBounds() {
        var horizontal = this.props.horizontal;

        var _ref$getBoundingClien = this._ref.getBoundingClientRect(),
            left = _ref$getBoundingClien.left,
            top = _ref$getBoundingClien.top,
            right = _ref$getBoundingClien.right,
            bottom = _ref$getBoundingClien.bottom;

        var waypointTop = horizontal ? left : top;
        var waypointBottom = horizontal ? right : bottom;

        var contextHeight = void 0;
        var contextScrollTop = void 0;
        if (this.scrollableAncestor === window) {
          contextHeight = horizontal ? window.innerWidth : window.innerHeight;
          contextScrollTop = 0;
        } else {
          contextHeight = horizontal ? this.scrollableAncestor.offsetWidth : this.scrollableAncestor.offsetHeight;
          contextScrollTop = horizontal ? this.scrollableAncestor.getBoundingClientRect().left : this.scrollableAncestor.getBoundingClientRect().top;
        }

        if (false) {
          debugLog('waypoint top', waypointTop);
          debugLog('waypoint bottom', waypointBottom);
          debugLog('scrollableAncestor height', contextHeight);
          debugLog('scrollableAncestor scrollTop', contextScrollTop);
        }

        var _props2 = this.props,
            bottomOffset = _props2.bottomOffset,
            topOffset = _props2.topOffset;

        var topOffsetPx = computeOffsetPixels(topOffset, contextHeight);
        var bottomOffsetPx = computeOffsetPixels(bottomOffset, contextHeight);
        var contextBottom = contextScrollTop + contextHeight;

        return {
          waypointTop: waypointTop,
          waypointBottom: waypointBottom,
          viewportTop: contextScrollTop + topOffsetPx,
          viewportBottom: contextBottom - bottomOffsetPx
        };
      }

      return _getBounds;
    }()

    /**
     * @return {Object}
     */

  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this3 = this;

        var children = this.props.children;


        if (!children) {
          // We need an element that we can locate in the DOM to determine where it is
          // rendered relative to the top of its context.
          return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { ref: this.refElement, style: { fontSize: 0 } });
        }

        if (isDOMElement(children)) {
          var ref = function () {
            function ref(node) {
              _this3.refElement(node);
              if (children.ref) {
                children.ref(node);
              }
            }

            return ref;
          }();

          return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(children, { ref: ref });
        }

        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(children, { innerRef: this.refElement });
      }

      return render;
    }()
  }]);

  return Waypoint;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

 false ? Waypoint.propTypes = {
  children: PropTypes.node,
  debug: PropTypes.bool,
  onEnter: PropTypes.func,
  onLeave: PropTypes.func,
  onPositionChange: PropTypes.func,
  fireOnRapidScroll: PropTypes.bool,
  scrollableAncestor: PropTypes.any,
  horizontal: PropTypes.bool,

  // `topOffset` can either be a number, in which case its a distance from the
  // top of the container in pixels, or a string value. Valid string values are
  // of the form "20px", which is parsed as pixels, or "20%", which is parsed
  // as a percentage of the height of the containing element.
  // For instance, if you pass "-20%", and the containing element is 100px tall,
  // then the waypoint will be triggered when it has been scrolled 20px beyond
  // the top of the containing element.
  topOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  // `bottomOffset` is like `topOffset`, but for the bottom of the container.
  bottomOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : void 0;

Waypoint.above = constants.above;
Waypoint.below = constants.below;
Waypoint.inside = constants.inside;
Waypoint.invisible = constants.invisible;
Waypoint.getWindow = function () {
  if (typeof window !== 'undefined') {
    return window;
  }
};
Waypoint.defaultProps = defaultProps;
Waypoint.displayName = 'Waypoint';

/* harmony default export */ __webpack_exports__["a"] = (Waypoint);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(39)))

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENT_HANDLERS_KEY = undefined;
exports.addEventListener = addEventListener;
exports.removeEventListener = removeEventListener;

var _normalizeEventOptions = __webpack_require__(503);

var _normalizeEventOptions2 = _interopRequireDefault(_normalizeEventOptions);

var _TargetEventHandlers = __webpack_require__(506);

var _TargetEventHandlers2 = _interopRequireDefault(_TargetEventHandlers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Export to make testing possible.
var EVENT_HANDLERS_KEY = exports.EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';

function addEventListener(target, eventName, listener, options) {
  if (!target[EVENT_HANDLERS_KEY]) {
    // eslint-disable-next-line no-param-reassign
    target[EVENT_HANDLERS_KEY] = new _TargetEventHandlers2['default'](target);
  }
  var normalizedEventOptions = (0, _normalizeEventOptions2['default'])(options);
  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
}

// Deprecated
function removeEventListener(unsubscribeFn) {
  unsubscribeFn();
}

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = normalizeEventOptions;

var _canUsePassiveEventListeners = __webpack_require__(504);

var _canUsePassiveEventListeners2 = _interopRequireDefault(_canUsePassiveEventListeners);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function normalizeEventOptions(eventOptions) {
  if (!eventOptions) {
    return undefined;
  }

  if (!(0, _canUsePassiveEventListeners2['default'])()) {
    // If the browser does not support the passive option, then it is expecting
    // a boolean for the options argument to specify whether it should use
    // capture or not. In more modern browsers, this is passed via the `capture`
    // option, so let's just hoist that value up.
    return !!eventOptions.capture;
  }

  return eventOptions;
}

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = canUsePassiveEventListeners;

var _canUseDOM = __webpack_require__(505);

var _canUseDOM2 = _interopRequireDefault(_canUseDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Adapted from Modernizr
// https://github.com/Modernizr/Modernizr/blob/5eea7e2a/feature-detects/dom/passiveeventlisteners.js#L26-L35
function testPassiveEventListeners() {
  if (!_canUseDOM2['default']) {
    return false;
  }

  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
    return false;
  }

  var supportsPassiveOption = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function () {
        function get() {
          supportsPassiveOption = true;
        }

        return get;
      }()
    });
    window.addEventListener('test', null, opts);
  } catch (e) {
    // do nothing
  }

  return supportsPassiveOption;
}

var memoized = void 0;

function canUsePassiveEventListeners() {
  if (memoized === undefined) {
    memoized = testPassiveEventListeners();
  }
  return memoized;
}

/***/ }),
/* 505 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports['default'] = CAN_USE_DOM;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventOptionsKey = __webpack_require__(507);

var _eventOptionsKey2 = _interopRequireDefault(_eventOptionsKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ensureCanMutateNextEventHandlers(eventHandlers) {
  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
    // eslint-disable-next-line no-param-reassign
    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
  }
}

var TargetEventHandlers = function () {
  function TargetEventHandlers(target) {
    _classCallCheck(this, TargetEventHandlers);

    this.target = target;
    this.events = {};
  }

  _createClass(TargetEventHandlers, [{
    key: 'getEventHandlers',
    value: function () {
      function getEventHandlers(eventName, options) {
        var key = String(eventName) + ' ' + String((0, _eventOptionsKey2['default'])(options));

        if (!this.events[key]) {
          this.events[key] = {
            handlers: [],
            handleEvent: undefined
          };
          this.events[key].nextHandlers = this.events[key].handlers;
        }

        return this.events[key];
      }

      return getEventHandlers;
    }()
  }, {
    key: 'handleEvent',
    value: function () {
      function handleEvent(eventName, options, event) {
        var eventHandlers = this.getEventHandlers(eventName, options);
        eventHandlers.handlers = eventHandlers.nextHandlers;
        eventHandlers.handlers.forEach(function (handler) {
          if (handler) {
            // We need to check for presence here because a handler function may
            // cause later handlers to get removed. This can happen if you for
            // instance have a waypoint that unmounts another waypoint as part of an
            // onEnter/onLeave handler.
            handler(event);
          }
        });
      }

      return handleEvent;
    }()
  }, {
    key: 'add',
    value: function () {
      function add(eventName, listener, options) {
        var _this = this;

        // options has already been normalized at this point.
        var eventHandlers = this.getEventHandlers(eventName, options);

        ensureCanMutateNextEventHandlers(eventHandlers);

        if (eventHandlers.nextHandlers.length === 0) {
          eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);

          this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
        }

        eventHandlers.nextHandlers.push(listener);

        var isSubscribed = true;
        var unsubscribe = function () {
          function unsubscribe() {
            if (!isSubscribed) {
              return;
            }

            isSubscribed = false;

            ensureCanMutateNextEventHandlers(eventHandlers);
            var index = eventHandlers.nextHandlers.indexOf(listener);
            eventHandlers.nextHandlers.splice(index, 1);

            if (eventHandlers.nextHandlers.length === 0) {
              // All event handlers have been removed, so we want to remove the event
              // listener from the target node.

              if (_this.target) {
                // There can be a race condition where the target may no longer exist
                // when this function is called, e.g. when a React component is
                // unmounting. Guarding against this prevents the following error:
                //
                //   Cannot read property 'removeEventListener' of undefined
                _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
              }

              eventHandlers.handleEvent = undefined;
            }
          }

          return unsubscribe;
        }();
        return unsubscribe;
      }

      return add;
    }()
  }]);

  return TargetEventHandlers;
}();

exports['default'] = TargetEventHandlers;

/***/ }),
/* 507 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = eventOptionsKey;
/* eslint-disable no-bitwise */

/**
 * Generate a unique key for any set of event options
 */
function eventOptionsKey(normalizedEventOptions) {
  if (!normalizedEventOptions) {
    return 0;
  }

  // If the browser does not support passive event listeners, the normalized
  // event options will be a boolean.
  if (normalizedEventOptions === true) {
    return 100;
  }

  // At this point, the browser supports passive event listeners, so we expect
  // the event options to be an object with possible properties of capture,
  // passive, and once.
  //
  // We want to consistently return the same value, regardless of the order of
  // these properties, so let's use binary maths to assign each property to a
  // bit, and then add those together (with an offset to account for the
  // booleans at the beginning of this function).
  var capture = normalizedEventOptions.capture << 0;
  var passive = normalizedEventOptions.passive << 1;
  var once = normalizedEventOptions.once << 2;
  return capture + passive + once;
}

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(99);
var invariant = __webpack_require__(509);
var ReactPropTypesSecret = __webpack_require__(510);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapData_eia8602001coal_json__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapData_eia8602001coal_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mapData_eia8602001coal_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapData_eia8602002coal_json__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapData_eia8602002coal_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__mapData_eia8602002coal_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapData_eia8602003coal_json__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapData_eia8602003coal_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__mapData_eia8602003coal_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapData_eia8602004coal_json__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapData_eia8602004coal_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__mapData_eia8602004coal_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapData_eia8602005coal_json__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapData_eia8602005coal_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__mapData_eia8602005coal_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapData_eia8602006coal_json__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapData_eia8602006coal_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__mapData_eia8602006coal_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mapData_eia8602007coal_json__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mapData_eia8602007coal_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__mapData_eia8602007coal_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mapData_eia8602008coal_json__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mapData_eia8602008coal_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__mapData_eia8602008coal_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mapData_eia8602009coal_json__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mapData_eia8602009coal_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__mapData_eia8602009coal_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mapData_eia8602010coal_json__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mapData_eia8602010coal_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__mapData_eia8602010coal_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mapData_eia8602011coal_json__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mapData_eia8602011coal_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__mapData_eia8602011coal_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mapData_eia8602012coal_json__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mapData_eia8602012coal_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__mapData_eia8602012coal_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mapData_eia8602013coal_json__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mapData_eia8602013coal_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__mapData_eia8602013coal_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mapData_eia8602014coal_json__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mapData_eia8602014coal_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__mapData_eia8602014coal_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mapData_eia8602015coal_json__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mapData_eia8602015coal_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__mapData_eia8602015coal_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mapData_eia8602016coal_json__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mapData_eia8602016coal_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__mapData_eia8602016coal_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mapData_eia8602001gas_json__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mapData_eia8602001gas_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__mapData_eia8602001gas_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mapData_eia8602002gas_json__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mapData_eia8602002gas_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__mapData_eia8602002gas_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mapData_eia8602003gas_json__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mapData_eia8602003gas_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__mapData_eia8602003gas_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mapData_eia8602004gas_json__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mapData_eia8602004gas_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__mapData_eia8602004gas_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mapData_eia8602005gas_json__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mapData_eia8602005gas_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__mapData_eia8602005gas_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mapData_eia8602006gas_json__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mapData_eia8602006gas_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__mapData_eia8602006gas_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__mapData_eia8602007gas_json__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__mapData_eia8602007gas_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__mapData_eia8602007gas_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__mapData_eia8602008gas_json__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__mapData_eia8602008gas_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__mapData_eia8602008gas_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__mapData_eia8602009gas_json__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__mapData_eia8602009gas_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__mapData_eia8602009gas_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__mapData_eia8602010gas_json__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__mapData_eia8602010gas_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__mapData_eia8602010gas_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__mapData_eia8602011gas_json__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__mapData_eia8602011gas_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__mapData_eia8602011gas_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__mapData_eia8602012gas_json__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__mapData_eia8602012gas_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__mapData_eia8602012gas_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__mapData_eia8602013gas_json__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__mapData_eia8602013gas_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__mapData_eia8602013gas_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__mapData_eia8602014gas_json__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__mapData_eia8602014gas_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__mapData_eia8602014gas_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__mapData_eia8602015gas_json__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__mapData_eia8602015gas_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__mapData_eia8602015gas_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__mapData_eia8602016gas_json__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__mapData_eia8602016gas_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__mapData_eia8602016gas_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_react_simple_maps__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_react_simple_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_react_simple_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_d3_scale__ = __webpack_require__(107);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MIN_OUTPUT=400;var wrapperStyles={width:"100%",maxWidth:980,margin:"50 auto",fontFamily:"Roboto, sans-serif"};//const wrapperStyles = {
//  width: "100%",
//  maxWidth: 980,
//  margin: "0 auto",
//}
//const utilityScale = scaleLinear()
//  .domain([0,37843000])
//  .range([1,25])
var yearDataCoal={A2001:__WEBPACK_IMPORTED_MODULE_0__mapData_eia8602001coal_json___default.a,A2002:__WEBPACK_IMPORTED_MODULE_1__mapData_eia8602002coal_json___default.a,A2003:__WEBPACK_IMPORTED_MODULE_2__mapData_eia8602003coal_json___default.a,A2004:__WEBPACK_IMPORTED_MODULE_3__mapData_eia8602004coal_json___default.a,A2005:__WEBPACK_IMPORTED_MODULE_4__mapData_eia8602005coal_json___default.a,A2006:__WEBPACK_IMPORTED_MODULE_5__mapData_eia8602006coal_json___default.a,A2007:__WEBPACK_IMPORTED_MODULE_6__mapData_eia8602007coal_json___default.a,A2008:__WEBPACK_IMPORTED_MODULE_7__mapData_eia8602008coal_json___default.a,A2009:__WEBPACK_IMPORTED_MODULE_8__mapData_eia8602009coal_json___default.a,A2010:__WEBPACK_IMPORTED_MODULE_9__mapData_eia8602010coal_json___default.a,A2011:__WEBPACK_IMPORTED_MODULE_10__mapData_eia8602011coal_json___default.a,A2012:__WEBPACK_IMPORTED_MODULE_11__mapData_eia8602012coal_json___default.a,A2013:__WEBPACK_IMPORTED_MODULE_12__mapData_eia8602013coal_json___default.a,A2014:__WEBPACK_IMPORTED_MODULE_13__mapData_eia8602014coal_json___default.a,A2015:__WEBPACK_IMPORTED_MODULE_14__mapData_eia8602015coal_json___default.a,A2016:__WEBPACK_IMPORTED_MODULE_15__mapData_eia8602016coal_json___default.a};var yearDataGas={A2001:__WEBPACK_IMPORTED_MODULE_16__mapData_eia8602001gas_json___default.a,A2002:__WEBPACK_IMPORTED_MODULE_17__mapData_eia8602002gas_json___default.a,A2003:__WEBPACK_IMPORTED_MODULE_18__mapData_eia8602003gas_json___default.a,A2004:__WEBPACK_IMPORTED_MODULE_19__mapData_eia8602004gas_json___default.a,A2005:__WEBPACK_IMPORTED_MODULE_20__mapData_eia8602005gas_json___default.a,A2006:__WEBPACK_IMPORTED_MODULE_21__mapData_eia8602006gas_json___default.a,A2007:__WEBPACK_IMPORTED_MODULE_22__mapData_eia8602007gas_json___default.a,A2008:__WEBPACK_IMPORTED_MODULE_23__mapData_eia8602008gas_json___default.a,A2009:__WEBPACK_IMPORTED_MODULE_24__mapData_eia8602009gas_json___default.a,A2010:__WEBPACK_IMPORTED_MODULE_25__mapData_eia8602010gas_json___default.a,A2011:__WEBPACK_IMPORTED_MODULE_26__mapData_eia8602011gas_json___default.a,A2012:__WEBPACK_IMPORTED_MODULE_27__mapData_eia8602012gas_json___default.a,A2013:__WEBPACK_IMPORTED_MODULE_28__mapData_eia8602013gas_json___default.a,A2014:__WEBPACK_IMPORTED_MODULE_29__mapData_eia8602014gas_json___default.a,A2015:__WEBPACK_IMPORTED_MODULE_30__mapData_eia8602015gas_json___default.a,A2016:__WEBPACK_IMPORTED_MODULE_31__mapData_eia8602016gas_json___default.a};var color={CLETPUS:"black",//Coal
PAETPUS:"#19586D",//Petroleum
NGETPUS:"#ffcc00",//Natural Gas
OJETPUS:"#D3D3D3",//Other Gases
NUETPUS:"81FF14",//Nuclear
HPETPUS:"blue",//Hydroelectric Pumped Storage
HVETPUS:"blue",//Conventional Hydroelectric Power
WDETPUS:"brown",//Wood
WSETPUS:"#847e08",//Waste
GEETPUS:"#ee3b3b",//Geothermal
SOETPUS:"#ffd900",//Solar
WYETPUS:"#ADD8E6"//Wind
};var BasicMap=function(_Component){_inherits(BasicMap,_Component);function BasicMap(props){_classCallCheck(this,BasicMap);var _this=_possibleConstructorReturn(this,(BasicMap.__proto__||Object.getPrototypeOf(BasicMap)).call(this,props));_this.state={//utility: [],
utilityCoal:[],utilityGas:[]};_this.fetchUtility=_this.fetchUtility.bind(_this);return _this;}_createClass(BasicMap,[{key:"componentDidMount",value:function componentDidMount(){//this.fetchUtility()
setTimeout(this.fetchUtility,1000);}},{key:"fetchUtility",value:function fetchUtility(){var self=this;var year="A"+self.props.year;// console.log("################# year", year);
//
// console.log("year data", yearData[year]);
var yDataCoal=yearDataCoal[year];var yDataGas=yearDataGas[year];//mapBubbles[i]=addBubble(topojson.feature(geodata, geodata.objects.collection).features.filter(function(d){return d.properties[engList[i]]>engMin;}), engList[i]);
//let filteredData = eia8602011.filter(d => d.Coal > 100 || d.Gas > 100);
//let filteredDataCoal = yData.filter(d => d.Coal > 100);
//let filteredDataGas = yData.filter(d =>  d.Gas > 100);
self.setState({//utility: filteredData,
utilityCoal:yDataCoal,utilityGas:yDataGas});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(){console.log("received new props");this.fetchUtility();}},{key:"render",value:function render(){//        const wrapperStyles = {
//            width: "100%",
//            maxWidth: 980,
//            margin: "0 auto",
//            display: (this.props.hidden ? 'none': 'block'),
//            height: 551
//        };
return __WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"ratio-container"},__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{style:wrapperStyles,className:"ratio-container-content"},__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"map-title"},__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("h2",null,"Power Plant Output Over Time")),__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("img",{src:"map-legend.png",className:"legend-map"}),__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33_react_simple_maps__["ComposableMap"],{projection:"albersUsa",projectionConfig:{scale:1000//                            scale: 400,
//                            rotation: [-11,0,0],
},width:980,height:500,style:{width:"100%",height:"auto"}},__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33_react_simple_maps__["ZoomableGroup"],{center:[-100,40],disablePanning:true},__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33_react_simple_maps__["Geographies"],{geography:"us-states.json"},function(geographies,projection){return geographies.map(function(geography,i){return geography.id!=="ATA"&&__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33_react_simple_maps__["Geography"],{key:i,geography:geography,projection:projection,style:{default:{fill:"#ECEFF1",stroke:"#607D8B",strokeWidth:0.75,outline:"none"},hover:{fill:"#ECEFF1",stroke:"#607D8B",strokeWidth:0.75,outline:"none"},pressed:{fill:"#ECEFF1",stroke:"#607D8B",strokeWidth:0.75,outline:"none"}}});});}),__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33_react_simple_maps__["Markers"],null,this.state.utilityCoal.map(function(utilityCoal,i){return __WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33_react_simple_maps__["Marker"],{key:i,marker:utilityCoal},__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("circle",{cx:0,cy:0,r:utilityCoal.Coal/200//{utilityScale(utility.Gas)}
,fill:color.CLETPUS,opacity:0.5}));})),__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33_react_simple_maps__["Markers"],null,this.state.utilityGas.map(function(utilityGas,i){return __WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33_react_simple_maps__["Marker"],{key:i,marker:utilityGas},__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("circle",{cx:0,cy:0,r:utilityGas.Gas/200//{utilityScale(utility.Gas)}
,fill:color.NGETPUS,opacity:0.5}));}))))));}}]);return BasicMap;}(__WEBPACK_IMPORTED_MODULE_32_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BasicMap);

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Coal":262,"coordinates":[-87.7811,32.6017]},{"Plant":"ACE Cogeneration Facility","State":"CA","Coal":101.2,"coordinates":[-117.3836,35.7658]},{"Plant":"Cayuga","State":"IN","Coal":990,"coordinates":[-87.4244,39.9242]},{"Plant":"RED-Rochester, LLC","State":"NY","Coal":180.8,"coordinates":[-77.6319,43.1989]},{"Plant":"Edwardsport","State":"IN","Coal":120,"coordinates":[-87.2472,38.8067]},{"Plant":"Logan Generating Company LP","State":"NJ","Coal":219,"coordinates":[-75.4067,39.7928]},{"Plant":"Portsmouth Genco LLC","State":"VA","Coal":115,"coordinates":[-76.3529,36.8702]},{"Plant":"Taconite Harbor Energy Center","State":"MN","Coal":225,"coordinates":[-90.9114,47.5314]},{"Plant":"R Gallagher","State":"IN","Coal":560,"coordinates":[-85.8381,38.2636]},{"Plant":"Wabash River","State":"IN","Coal":898.3,"coordinates":[-87.4247,39.53]},{"Plant":"F B Culley","State":"IN","Coal":406,"coordinates":[-87.3275,37.9111]},{"Plant":"Colver Power Project","State":"PA","Coal":110,"coordinates":[-78.8,40.55]},{"Plant":"Florida Power Development","State":"FL","Coal":139,"coordinates":[-82.4311,28.5819]},{"Plant":"Green Bay West Mill","State":"WI","Coal":110.47,"coordinates":[-88.0303,44.4936]},{"Plant":"CPI USA NC Southport","State":"NC","Coal":107,"coordinates":[-78.0118,33.9444]},{"Plant":"Edgecombe Genco LLC","State":"NC","Coal":105,"coordinates":[-77.7533,36.0373]},{"Plant":"Frank E Ratts","State":"IN","Coal":244,"coordinates":[-87.2662,38.5201]},{"Plant":"Lansing","State":"IA","Coal":323,"coordinates":[-91.1675,43.3359]},{"Plant":"4 AC Station","State":"IN","Coal":126.5,"coordinates":[-87.4264,41.68]},{"Plant":"Milton L Kapp","State":"IA","Coal":217,"coordinates":[-90.2336,41.8081]},{"Plant":"Chambers Cogeneration LP","State":"NJ","Coal":262,"coordinates":[-75.4858,39.6935]},{"Plant":"AES Shady Point LLC","State":"OK","Coal":320,"coordinates":[-94.6458,35.1931]},{"Plant":"Cedar Bay Generating Company LP","State":"FL","Coal":250,"coordinates":[-81.6064,30.4225]},{"Plant":"AES Hawaii","State":"HI","Coal":180,"coordinates":[-158.1065,21.3034]},{"Plant":"AES Thames","State":"CT","Coal":181,"coordinates":[-72.055,41.2607]},{"Plant":"AES Beaver Valley Partners Beaver Valley","State":"PA","Coal":146,"coordinates":[-80.3539,40.6572]},{"Plant":"AES Warrior Run Cogeneration Facility","State":"MD","Coal":180,"coordinates":[-78.7453,39.5952]},{"Plant":"Prairie Creek","State":"IA","Coal":193.1,"coordinates":[-91.6392,41.944]},{"Plant":"Sutherland","State":"IA","Coal":142.8,"coordinates":[-92.8594,42.0473]},{"Plant":"Holcomb","State":"KS","Coal":331,"coordinates":[-100.9725,37.9308]},{"Plant":"Riverside","State":"IA","Coal":135,"coordinates":[-90.4481,41.54]},{"Plant":"Walter Scott Jr Energy Center","State":"IA","Coal":806,"coordinates":[-95.8408,41.18]},{"Plant":"Silver Bay Power","State":"MN","Coal":105,"coordinates":[-91.2605,47.2866]},{"Plant":"Archer Daniels Midland Cedar Rapids","State":"IA","Coal":260,"coordinates":[-91.6875,41.9221]},{"Plant":"Archer Daniels Midland Decatur","State":"IL","Coal":230,"coordinates":[-88.8908,39.8701]},{"Plant":"George Neal North","State":"IA","Coal":950,"coordinates":[-96.3617,42.2998]},{"Plant":"Burlington","State":"IA","Coal":211.6,"coordinates":[-91.1167,40.7412]},{"Plant":"Cholla","State":"AZ","Coal":995,"coordinates":[-110.3033,34.9394]},{"Plant":"Muscatine Plant #1","State":"IA","Coal":268.8,"coordinates":[-91.0569,41.3917]},{"Plant":"La Cygne","State":"KS","Coal":1362,"coordinates":[-94.6456,38.3481]},{"Plant":"Lawrence Energy Center","State":"KS","Coal":598,"coordinates":[-95.2692,39.0072]},{"Plant":"Tecumseh Energy Center","State":"KS","Coal":243,"coordinates":[-95.5689,39.0539]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Coal":156,"coordinates":[-110.9047,32.16]},{"Plant":"Oklaunion","State":"TX","Coal":690,"coordinates":[-99.1753,34.0825]},{"Plant":"Quindaro","State":"KS","Coal":208,"coordinates":[-94.6381,39.1492]},{"Plant":"Cross","State":"SC","Coal":1160,"coordinates":[-80.1119,33.3692]},{"Plant":"Big Sandy","State":"KY","Coal":1060,"coordinates":[-82.6176,38.1707]},{"Plant":"E W Brown","State":"KY","Coal":711,"coordinates":[-84.7126,37.7883]},{"Plant":"Ghent","State":"KY","Coal":1968,"coordinates":[-85.035,38.7497]},{"Plant":"Green River","State":"KY","Coal":232,"coordinates":[-87.1214,37.3636]},{"Plant":"Seminole","State":"FL","Coal":1316,"coordinates":[-81.6328,29.7331]},{"Plant":"Cane Run","State":"KY","Coal":563,"coordinates":[-85.8892,38.1831]},{"Plant":"Mill Creek","State":"KY","Coal":1470,"coordinates":[-85.9103,38.0525]},{"Plant":"Elmer Smith","State":"KY","Coal":412.7,"coordinates":[-87.0608,37.7942]},{"Plant":"Paradise","State":"KY","Coal":2190,"coordinates":[-86.9783,37.2608]},{"Plant":"Shawnee","State":"KY","Coal":1330,"coordinates":[-88.775,37.1517]},{"Plant":"Kenneth C Coleman","State":"KY","Coal":455,"coordinates":[-86.7911,37.9631]},{"Plant":"HMP&L Station Two Henderson","State":"KY","Coal":312,"coordinates":[-87.5028,37.6469]},{"Plant":"Cooper","State":"KY","Coal":341,"coordinates":[-84.5919,36.9981]},{"Plant":"Dale","State":"KY","Coal":198,"coordinates":[-84.2619,37.8806]},{"Plant":"Herbert A Wagner","State":"MD","Coal":545,"coordinates":[-76.5268,39.1781]},{"Plant":"FirstEnergy R Paul Smith Power Station","State":"MD","Coal":102.61,"coordinates":[-77.8269,39.595]},{"Plant":"Chalk Point LLC","State":"MD","Coal":682,"coordinates":[-76.6861,38.5444]},{"Plant":"Dickerson","State":"MD","Coal":546,"coordinates":[-77.4644,39.2097]},{"Plant":"Morgantown Generating Plant","State":"MD","Coal":1244,"coordinates":[-76.9767,38.3592]},{"Plant":"Apache Station","State":"AZ","Coal":350,"coordinates":[-109.8931,32.0603]},{"Plant":"Mount Tom","State":"MA","Coal":145.1,"coordinates":[-72.6055,42.2806]},{"Plant":"Somerset Station","State":"MA","Coal":108,"coordinates":[-71.146,41.7374]},{"Plant":"Brayton Point","State":"MA","Coal":1053.76,"coordinates":[-71.1931,41.7103]},{"Plant":"Salem Harbor","State":"MA","Coal":308.83,"coordinates":[-70.8772,42.5256]},{"Plant":"GRDA","State":"OK","Coal":1010,"coordinates":[-95.2894,36.1903]},{"Plant":"B C Cobb","State":"MI","Coal":320,"coordinates":[-86.2423,43.2588]},{"Plant":"Dan E Karn","State":"MI","Coal":515,"coordinates":[-83.8401,43.645]},{"Plant":"J H Campbell","State":"MI","Coal":1429,"coordinates":[-86.2007,42.9103]},{"Plant":"J C Weadock","State":"MI","Coal":310,"coordinates":[-83.8447,43.6399]},{"Plant":"J R Whiting","State":"MI","Coal":324,"coordinates":[-83.4495,41.7921]},{"Plant":"Harbor Beach","State":"MI","Coal":103,"coordinates":[-82.6436,43.8519]},{"Plant":"Marysville","State":"MI","Coal":200,"coordinates":[-82.4606,42.9256]},{"Plant":"Monroe","State":"MI","Coal":3000,"coordinates":[-83.3464,41.8906]},{"Plant":"River Rouge","State":"MI","Coal":514,"coordinates":[-83.1119,42.2739]},{"Plant":"St Clair","State":"MI","Coal":1417,"coordinates":[-82.4719,42.7642]},{"Plant":"Trenton Channel","State":"MI","Coal":725,"coordinates":[-83.1808,42.1217]},{"Plant":"Presque Isle","State":"MI","Coal":618,"coordinates":[-87.395,46.5789]},{"Plant":"Eckert Station","State":"MI","Coal":356.5,"coordinates":[-84.5581,42.7184]},{"Plant":"Erickson Station","State":"MI","Coal":158.4,"coordinates":[-84.6572,42.6922]},{"Plant":"Syl Laskin","State":"MN","Coal":110,"coordinates":[-92.1619,47.5306]},{"Plant":"Clay Boswell","State":"MN","Coal":1022.5,"coordinates":[-93.6528,47.2611]},{"Plant":"Black Dog","State":"MN","Coal":355.9,"coordinates":[-93.2501,44.8108]},{"Plant":"High Bridge","State":"MN","Coal":269,"coordinates":[-93.1117,44.9314]},{"Plant":"Allen S King","State":"MN","Coal":571,"coordinates":[-92.7786,45.03]},{"Plant":"Riverside","State":"MN","Coal":382.1,"coordinates":[-93.2753,45.0203]},{"Plant":"Hoot Lake","State":"MN","Coal":156.4,"coordinates":[-96.0433,46.2906]},{"Plant":"Silver Lake","State":"MN","Coal":105.6,"coordinates":[-92.4604,44.0282]},{"Plant":"Jack Watson","State":"MS","Coal":762,"coordinates":[-89.0286,30.4392]},{"Plant":"St Johns River Power Park","State":"FL","Coal":1252,"coordinates":[-81.5508,30.4308]},{"Plant":"Asbury","State":"MO","Coal":213,"coordinates":[-94.5893,37.3613]},{"Plant":"Hawthorn","State":"MO","Coal":550,"coordinates":[-94.4778,39.1306]},{"Plant":"Montrose","State":"MO","Coal":510,"coordinates":[-93.9348,38.3114]},{"Plant":"Sibley","State":"MO","Coal":501.7,"coordinates":[-94.1844,39.1783]},{"Plant":"Labadie","State":"MO","Coal":2300,"coordinates":[-90.8377,38.5622]},{"Plant":"Meramec","State":"MO","Coal":876,"coordinates":[-90.3358,38.4017]},{"Plant":"Sioux","State":"MO","Coal":950,"coordinates":[-90.2902,38.9155]},{"Plant":"James River Power Station","State":"MO","Coal":236,"coordinates":[-93.2619,37.1086]},{"Plant":"New Madrid","State":"MO","Coal":1160,"coordinates":[-89.5617,36.5147]},{"Plant":"Thomas Hill","State":"MO","Coal":1120,"coordinates":[-92.6381,39.5522]},{"Plant":"J E Corette Plant","State":"MT","Coal":154,"coordinates":[-108.481,45.7756]},{"Plant":"Lon Wright","State":"NE","Coal":120,"coordinates":[-96.4623,41.4281]},{"Plant":"Sheldon","State":"NE","Coal":225,"coordinates":[-96.7847,40.5589]},{"Plant":"North Omaha","State":"NE","Coal":662.8,"coordinates":[-95.9447,41.3291]},{"Plant":"Reid Gardner","State":"NV","Coal":556,"coordinates":[-114.6333,36.6573]},{"Plant":"Mohave","State":"NV","Coal":1580,"coordinates":[-114.5917,35.1458]},{"Plant":"Merrimack","State":"NH","Coal":432.5,"coordinates":[-71.4692,43.1411]},{"Plant":"Schiller","State":"NH","Coal":142.6,"coordinates":[-70.7842,43.0978]},{"Plant":"B L England","State":"NJ","Coal":284,"coordinates":[-74.6364,39.2908]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Coal":608,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Mercer Generating Station","State":"NJ","Coal":611.68,"coordinates":[-74.7339,40.1792]},{"Plant":"Four Corners","State":"NM","Coal":2040,"coordinates":[-108.4814,36.69]},{"Plant":"San Juan","State":"NM","Coal":1643,"coordinates":[-108.4386,36.8006]},{"Plant":"Danskammer Generating Station","State":"NY","Coal":370,"coordinates":[-73.975,41.5712]},{"Plant":"GMMM Westover","State":"NY","Coal":127.7,"coordinates":[-75.9747,42.1117]},{"Plant":"GMMGreenidge LLC","State":"NY","Coal":138.33,"coordinates":[-76.9483,42.6789]},{"Plant":"Cayuga Operating Company","State":"NY","Coal":306,"coordinates":[-76.6336,42.6028]},{"Plant":"C R Huntley Generating Station","State":"NY","Coal":727,"coordinates":[-78.93,42.97]},{"Plant":"Dunkirk Generating Plant","State":"NY","Coal":588,"coordinates":[-79.3466,42.4915]},{"Plant":"E C Gaston","State":"AL","Coal":1890,"coordinates":[-86.4581,33.2442]},{"Plant":"Lovett","State":"NY","Coal":363,"coordinates":[-73.9797,41.2578]},{"Plant":"Rochester 7","State":"NY","Coal":252,"coordinates":[-77.6294,43.2689]},{"Plant":"Asheville","State":"NC","Coal":392,"coordinates":[-82.5417,35.4731]},{"Plant":"Cape Fear","State":"NC","Coal":316,"coordinates":[-79.0495,35.595]},{"Plant":"HF Lee Plant","State":"NC","Coal":407,"coordinates":[-78.0878,35.3799]},{"Plant":"Roxboro","State":"NC","Coal":2462,"coordinates":[-79.0731,36.4833]},{"Plant":"L V Sutton Steam","State":"NC","Coal":613,"coordinates":[-77.9853,34.2831]},{"Plant":"W H Weatherspoon","State":"NC","Coal":176,"coordinates":[-78.9755,34.5875]},{"Plant":"G G Allen","State":"NC","Coal":1140,"coordinates":[-81.0122,35.1897]},{"Plant":"Buck","State":"NC","Coal":369,"coordinates":[-80.3767,35.7133]},{"Plant":"Cliffside","State":"NC","Coal":760,"coordinates":[-81.7594,35.22]},{"Plant":"Dan River","State":"NC","Coal":276,"coordinates":[-79.7208,36.4862]},{"Plant":"Marshall","State":"NC","Coal":2090,"coordinates":[-80.9658,35.5975]},{"Plant":"Riverbend","State":"NC","Coal":454,"coordinates":[-80.9742,35.36]},{"Plant":"R M Heskett","State":"ND","Coal":104.3,"coordinates":[-100.8836,46.8669]},{"Plant":"Leland Olds","State":"ND","Coal":669,"coordinates":[-101.3212,47.2808]},{"Plant":"Milton R Young","State":"ND","Coal":705,"coordinates":[-101.2131,47.0659]},{"Plant":"Stanton","State":"ND","Coal":183,"coordinates":[-101.3319,47.2866]},{"Plant":"Cardinal","State":"OH","Coal":1800,"coordinates":[-80.6486,40.2522]},{"Plant":"Walter C Beckjord","State":"OH","Coal":1118,"coordinates":[-84.2981,38.9917]},{"Plant":"Miami Fort","State":"OH","Coal":1243,"coordinates":[-84.8036,39.1128]},{"Plant":"FirstEnergy Ashtabula","State":"OH","Coal":418,"coordinates":[-80.7697,41.9086]},{"Plant":"Avon Lake","State":"OH","Coal":721,"coordinates":[-82.0546,41.5045]},{"Plant":"FirstEnergy Eastlake","State":"OH","Coal":1222,"coordinates":[-81.4425,41.6711]},{"Plant":"FirstEnergy Lake Shore","State":"OH","Coal":210,"coordinates":[-81.6419,41.5356]},{"Plant":"Conesville","State":"OH","Coal":1925,"coordinates":[-81.8811,40.1842]},{"Plant":"O H Hutchings","State":"OH","Coal":365,"coordinates":[-84.2921,39.6088]},{"Plant":"J M Stuart","State":"OH","Coal":2340,"coordinates":[-83.6939,38.6361]},{"Plant":"Niles","State":"OH","Coal":216,"coordinates":[-80.7477,41.1669]},{"Plant":"FirstEnergy R E Burger","State":"OH","Coal":406,"coordinates":[-80.7608,39.91]},{"Plant":"FirstEnergy W H Sammis","State":"OH","Coal":2220,"coordinates":[-80.6319,40.5317]},{"Plant":"FirstEnergy Toronto","State":"OH","Coal":172,"coordinates":[-80.6044,40.4825]},{"Plant":"Muskingum River","State":"OH","Coal":1365,"coordinates":[-81.6797,39.5908]},{"Plant":"Kyger Creek","State":"OH","Coal":1025,"coordinates":[-82.1289,38.9144]},{"Plant":"FirstEnergy Bay Shore","State":"OH","Coal":489,"coordinates":[-83.4378,41.6917]},{"Plant":"Lake Road","State":"OH","Coal":160,"coordinates":[-81.6494,41.5278]},{"Plant":"Muskogee","State":"OK","Coal":1519.2,"coordinates":[-95.2873,35.7614]},{"Plant":"Northeastern","State":"OK","Coal":910,"coordinates":[-95.7008,36.4317]},{"Plant":"Limestone","State":"TX","Coal":1532,"coordinates":[-96.2525,31.4219]},{"Plant":"Barry","State":"AL","Coal":1658,"coordinates":[-88.0103,31.0069]},{"Plant":"Elrama Power Plant","State":"PA","Coal":474,"coordinates":[-79.918,40.2518]},{"Plant":"Portland","State":"PA","Coal":401,"coordinates":[-75.0794,40.9102]},{"Plant":"Titus","State":"PA","Coal":243,"coordinates":[-75.9081,40.3056]},{"Plant":"Conemaugh","State":"PA","Coal":1700,"coordinates":[-79.0611,40.3842]},{"Plant":"Homer City Generating Station","State":"PA","Coal":1884,"coordinates":[-79.1961,40.5128]},{"Plant":"Seward","State":"PA","Coal":196,"coordinates":[-79.0337,40.4062]},{"Plant":"Shawville","State":"PA","Coal":597,"coordinates":[-78.3662,41.0675]},{"Plant":"Keystone","State":"PA","Coal":1700,"coordinates":[-79.3411,40.6604]},{"Plant":"New Castle Plant","State":"PA","Coal":413,"coordinates":[-80.369,40.9379]},{"Plant":"Brunner Island","State":"PA","Coal":1434,"coordinates":[-76.6962,40.0961]},{"Plant":"PPL Martins Creek","State":"PA","Coal":292.72,"coordinates":[-75.1054,40.7978]},{"Plant":"PPL Montour","State":"PA","Coal":1538.27,"coordinates":[-76.6672,41.0714]},{"Plant":"Sunbury Generation LP","State":"PA","Coal":384.31,"coordinates":[-76.825,40.8361]},{"Plant":"Cromby Generating Station","State":"PA","Coal":144,"coordinates":[-75.5294,40.1531]},{"Plant":"Eddystone Generating Station","State":"PA","Coal":581,"coordinates":[-75.323,39.858]},{"Plant":"FirstEnergy Armstrong Power Station","State":"PA","Coal":299.28,"coordinates":[-79.4656,40.9292]},{"Plant":"Hatfields Ferry Power Station","State":"PA","Coal":1619.13,"coordinates":[-79.9275,39.8556]},{"Plant":"FirstEnergy Mitchell Power Station","State":"PA","Coal":280.35,"coordinates":[-79.9683,40.2211]},{"Plant":"H B Robinson","State":"SC","Coal":174,"coordinates":[-80.1589,34.4017]},{"Plant":"W S Lee","State":"SC","Coal":370,"coordinates":[-82.435,34.6022]},{"Plant":"Canadys Steam","State":"SC","Coal":396,"coordinates":[-80.6228,33.0647]},{"Plant":"McMeekin","State":"SC","Coal":250,"coordinates":[-81.2172,34.0556]},{"Plant":"Urquhart","State":"SC","Coal":234,"coordinates":[-81.9111,33.435]},{"Plant":"Wateree","State":"SC","Coal":700,"coordinates":[-80.6228,33.8264]},{"Plant":"Williams","State":"SC","Coal":615,"coordinates":[-79.9297,33.0158]},{"Plant":"Dolphus M Grainger","State":"SC","Coal":170,"coordinates":[-79.0533,33.8264]},{"Plant":"Jefferies","State":"SC","Coal":306,"coordinates":[-79.9875,33.2422]},{"Plant":"Allen Steam Plant","State":"TN","Coal":744,"coordinates":[-90.1487,35.0741]},{"Plant":"Bull Run","State":"TN","Coal":868,"coordinates":[-84.1567,36.0211]},{"Plant":"Cumberland","State":"TN","Coal":2462,"coordinates":[-87.6539,36.3903]},{"Plant":"Gallatin","State":"TN","Coal":976,"coordinates":[-86.4006,36.3156]},{"Plant":"John Sevier","State":"TN","Coal":704,"coordinates":[-82.9639,36.3767]},{"Plant":"Johnsonville","State":"TN","Coal":1206,"coordinates":[-87.9861,36.0278]},{"Plant":"Kingston","State":"TN","Coal":1434,"coordinates":[-84.5194,35.8992]},{"Plant":"Watts Bar Fossil","State":"TN","Coal":224,"coordinates":[-84.7811,35.6108]},{"Plant":"W A Parish","State":"TX","Coal":2455,"coordinates":[-95.6311,29.4828]},{"Plant":"Big Brown","State":"TX","Coal":1150,"coordinates":[-96.0544,31.8206]},{"Plant":"Carbon","State":"UT","Coal":175,"coordinates":[-110.8644,39.7272]},{"Plant":"Clinch River","State":"VA","Coal":690,"coordinates":[-82.1997,36.9333]},{"Plant":"Glen Lyn","State":"VA","Coal":325,"coordinates":[-80.8633,37.3706]},{"Plant":"Potomac River","State":"VA","Coal":482,"coordinates":[-77.0411,38.8203]},{"Plant":"Bremo Bluff","State":"VA","Coal":227,"coordinates":[-78.2878,37.7089]},{"Plant":"Chesterfield","State":"VA","Coal":1229,"coordinates":[-77.3833,37.3822]},{"Plant":"Chesapeake","State":"VA","Coal":595,"coordinates":[-76.3019,36.7711]},{"Plant":"Possum Point","State":"VA","Coal":322,"coordinates":[-77.2806,38.5367]},{"Plant":"Yorktown","State":"VA","Coal":326,"coordinates":[-76.4611,37.2144]},{"Plant":"Joliet 29","State":"IL","Coal":1036,"coordinates":[-88.1238,41.4946]},{"Plant":"Transalta Centralia Generation","State":"WA","Coal":1405,"coordinates":[-122.8598,46.7559]},{"Plant":"John E Amos","State":"WV","Coal":2900,"coordinates":[-81.8233,38.4731]},{"Plant":"Kanawha River","State":"WV","Coal":390,"coordinates":[-81.4211,38.2056]},{"Plant":"Philip Sporn","State":"WV","Coal":1020,"coordinates":[-81.9231,38.9669]},{"Plant":"FirstEnergy Albright","State":"WV","Coal":283,"coordinates":[-79.6369,39.4886]},{"Plant":"FirstEnergy Fort Martin Power Station","State":"WV","Coal":1107,"coordinates":[-79.9275,39.7108]},{"Plant":"FirstEnergy Harrison Power Station","State":"WV","Coal":1920,"coordinates":[-80.3325,39.3842]},{"Plant":"FirstEnergy Rivesville","State":"WV","Coal":137,"coordinates":[-80.1131,39.5314]},{"Plant":"FirstEnergy Willow Island","State":"WV","Coal":235,"coordinates":[-81.3,39.3672]},{"Plant":"Kammer","State":"WV","Coal":600,"coordinates":[-80.8186,39.8461]},{"Plant":"Mitchell","State":"WV","Coal":1600,"coordinates":[-80.8153,39.8297]},{"Plant":"Mt Storm","State":"WV","Coal":1587,"coordinates":[-79.2636,39.2008]},{"Plant":"Blount Street","State":"WI","Coal":196,"coordinates":[-89.3744,43.0789]},{"Plant":"Port Washington Generating Station","State":"WI","Coal":320,"coordinates":[-87.8689,43.3842]},{"Plant":"South Oak Creek","State":"WI","Coal":1135,"coordinates":[-87.8294,42.8457]},{"Plant":"Valley","State":"WI","Coal":267,"coordinates":[-87.9233,43.0303]},{"Plant":"Edgewater","State":"WI","Coal":824.1,"coordinates":[-87.7059,43.7151]},{"Plant":"Nelson Dewey Coal Refining Facility","State":"WI","Coal":223.7,"coordinates":[-91.0085,42.7225]},{"Plant":"Pulliam","State":"WI","Coal":395.8,"coordinates":[-88.0086,44.54]},{"Plant":"Weston","State":"WI","Coal":490.4,"coordinates":[-89.6553,44.8606]},{"Plant":"Alma","State":"WI","Coal":183.8,"coordinates":[-91.9111,44.3083]},{"Plant":"Genoa","State":"WI","Coal":351.6,"coordinates":[-91.2325,43.5589]},{"Plant":"Dave Johnston","State":"WY","Coal":762,"coordinates":[-105.7769,42.8378]},{"Plant":"Naughton","State":"WY","Coal":700,"coordinates":[-110.5983,41.7581]},{"Plant":"John P Madgett","State":"WI","Coal":373.5,"coordinates":[-91.9126,44.3036]},{"Plant":"Arapahoe","State":"CO","Coal":246,"coordinates":[-105.0028,39.67]},{"Plant":"Cherokee","State":"CO","Coal":717,"coordinates":[-104.9645,39.8073]},{"Plant":"Colbert","State":"AL","Coal":1173,"coordinates":[-87.8486,34.7439]},{"Plant":"Comanche","State":"CO","Coal":660,"coordinates":[-104.5747,38.2081]},{"Plant":"Valmont","State":"CO","Coal":186,"coordinates":[-105.202,40.0195]},{"Plant":"Martin Drake","State":"CO","Coal":259,"coordinates":[-104.8333,38.8244]},{"Plant":"Navajo","State":"AZ","Coal":2250,"coordinates":[-111.3886,36.9047]},{"Plant":"Widows Creek","State":"AL","Coal":1610,"coordinates":[-85.7553,34.883]},{"Plant":"G F Weaton Power Station","State":"PA","Coal":112,"coordinates":[-80.3462,40.6673]},{"Plant":"International Paper Savanna Mill","State":"GA","Coal":184.6,"coordinates":[-81.1242,32.1004]},{"Plant":"Tennessee Eastman Operations","State":"TN","Coal":194.3,"coordinates":[-82.5431,36.5219]},{"Plant":"Axiall Natrium Plant","State":"WV","Coal":123,"coordinates":[-80.8547,39.7475]},{"Plant":"Northampton Generating Company LP","State":"PA","Coal":108,"coordinates":[-75.4792,40.6917]},{"Plant":"Indiantown Cogeneration LP","State":"FL","Coal":330,"coordinates":[-80.5125,27.0389]},{"Plant":"Dolet Hills","State":"LA","Coal":650,"coordinates":[-93.5692,32.0306]},{"Plant":"Mecklenburg Power Station","State":"VA","Coal":131,"coordinates":[-78.53,36.6]},{"Plant":"Sandow No 5","State":"TX","Coal":390,"coordinates":[-97.0614,30.5681]},{"Plant":"Hayden","State":"CO","Coal":446,"coordinates":[-107.185,40.4856]},{"Plant":"Roanoke Valley Energy Facililty I","State":"NC","Coal":165,"coordinates":[-77.6167,36.4364]},{"Plant":"Spruance Genco LLC","State":"VA","Coal":190,"coordinates":[-77.4308,37.4556]},{"Plant":"Birchwood Power","State":"VA","Coal":237.3,"coordinates":[-77.3147,38.2667]},{"Plant":"Charles R Lowman","State":"AL","Coal":551,"coordinates":[-87.9107,31.488]},{"Plant":"Stanton Energy Center","State":"FL","Coal":886,"coordinates":[-81.1678,28.4822]},{"Plant":"Bridgeport Station","State":"CT","Coal":374.33,"coordinates":[-73.1844,41.1706]},{"Plant":"Edge Moor","State":"DE","Coal":260,"coordinates":[-75.5038,39.7389]},{"Plant":"Indian River Generating Station","State":"DE","Coal":767,"coordinates":[-75.2341,38.5857]},{"Plant":"James H Miller Jr","State":"AL","Coal":2800,"coordinates":[-87.0597,33.6319]},{"Plant":"FirstEnergy Pleasants Power Station","State":"WV","Coal":1260,"coordinates":[-81.2944,39.3667]},{"Plant":"White Bluff","State":"AR","Coal":1610,"coordinates":[-92.1406,34.4228]},{"Plant":"Duck Creek","State":"IL","Coal":366,"coordinates":[-89.9841,40.4663]},{"Plant":"Newton","State":"IL","Coal":1110,"coordinates":[-88.2781,38.9361]},{"Plant":"East Bend","State":"KY","Coal":600,"coordinates":[-84.8514,38.9036]},{"Plant":"W H Zimmer","State":"OH","Coal":1300,"coordinates":[-84.2289,38.8675]},{"Plant":"Brandon Shores","State":"MD","Coal":1286,"coordinates":[-76.5389,39.18]},{"Plant":"Craig","State":"CO","Coal":1264,"coordinates":[-107.5912,40.4627]},{"Plant":"Coal Creek","State":"ND","Coal":1094.2,"coordinates":[-101.1571,47.3777]},{"Plant":"Killen Station","State":"OH","Coal":600,"coordinates":[-83.4803,38.6903]},{"Plant":"Belle River","State":"MI","Coal":1260,"coordinates":[-82.495,42.7756]},{"Plant":"H L Spurlock","State":"KY","Coal":850,"coordinates":[-83.8181,38.7]},{"Plant":"Wansley","State":"GA","Coal":1783,"coordinates":[-85.0323,33.4134]},{"Plant":"Big Cajun 2","State":"LA","Coal":1783.11,"coordinates":[-91.3692,30.7261]},{"Plant":"R D Morrow","State":"MS","Coal":400,"coordinates":[-89.394,31.2186]},{"Plant":"Nearman Creek","State":"KS","Coal":235,"coordinates":[-94.6975,39.1681]},{"Plant":"Iatan","State":"MO","Coal":670,"coordinates":[-94.98,39.4472]},{"Plant":"Jeffrey Energy Center","State":"KS","Coal":2226,"coordinates":[-96.1172,39.2865]},{"Plant":"Trimble County","State":"KY","Coal":495,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Coal":1046,"coordinates":[-88.5553,30.5322]},{"Plant":"Colstrip","State":"MT","Coal":2094,"coordinates":[-106.614,45.8831]},{"Plant":"Gerald Gentleman","State":"NE","Coal":1365,"coordinates":[-101.1408,41.0808]},{"Plant":"Somerset Operating Co LLC","State":"NY","Coal":693,"coordinates":[-78.6047,43.3589]},{"Plant":"R M Schahfer","State":"IN","Coal":1625,"coordinates":[-87.0261,41.2164]},{"Plant":"Sherburne County","State":"MN","Coal":2292.3,"coordinates":[-93.8931,45.3808]},{"Plant":"FirstEnergy Bruce Mansfield","State":"PA","Coal":2360,"coordinates":[-80.4159,40.6348]},{"Plant":"Sooner","State":"OK","Coal":1012,"coordinates":[-97.0528,36.4531]},{"Plant":"Nebraska City","State":"NE","Coal":631.5,"coordinates":[-95.7764,40.6214]},{"Plant":"Big Stone","State":"SD","Coal":455.7,"coordinates":[-96.5101,45.3037]},{"Plant":"Wyodak","State":"WY","Coal":335,"coordinates":[-105.3815,44.2901]},{"Plant":"Boardman","State":"OR","Coal":556.7,"coordinates":[-119.8088,45.6932]},{"Plant":"Gibson","State":"IN","Coal":3131,"coordinates":[-87.7658,38.3722]},{"Plant":"McIntosh","State":"GA","Coal":155,"coordinates":[-81.1683,32.3563]},{"Plant":"Gibbons Creek","State":"TX","Coal":462,"coordinates":[-96.0818,30.6199]},{"Plant":"A B Brown","State":"IN","Coal":500,"coordinates":[-87.715,37.9053]},{"Plant":"Flint Creek","State":"AR","Coal":480,"coordinates":[-94.5241,36.2561]},{"Plant":"Welsh","State":"TX","Coal":1584,"coordinates":[-94.84,33.0552]},{"Plant":"Martin Lake","State":"TX","Coal":2250,"coordinates":[-94.5706,32.2606]},{"Plant":"Monticello","State":"TX","Coal":1885,"coordinates":[-95.0417,33.0917]},{"Plant":"Rush Island","State":"MO","Coal":1166,"coordinates":[-90.2632,38.1312]},{"Plant":"Hunter","State":"UT","Coal":1320,"coordinates":[-111.0289,39.1747]},{"Plant":"Rockport","State":"IN","Coal":2600,"coordinates":[-87.0372,37.9256]},{"Plant":"Pleasant Prairie","State":"WI","Coal":1212,"coordinates":[-87.9033,42.5381]},{"Plant":"Coronado","State":"AZ","Coal":785,"coordinates":[-109.2708,34.5789]},{"Plant":"Coleto Creek","State":"TX","Coal":632,"coordinates":[-97.2142,28.7128]},{"Plant":"Fayette Power Project","State":"TX","Coal":1605,"coordinates":[-96.7506,29.9172]},{"Plant":"J T Deely","State":"TX","Coal":830,"coordinates":[-98.3228,29.3081]},{"Plant":"San Miguel","State":"TX","Coal":391,"coordinates":[-98.4775,28.7044]},{"Plant":"Brame Energy Center","State":"LA","Coal":523,"coordinates":[-92.7167,31.395]},{"Plant":"Harrington","State":"TX","Coal":1066,"coordinates":[-101.7472,35.2982]},{"Plant":"Tolk","State":"TX","Coal":1080,"coordinates":[-102.57,34.1865]},{"Plant":"John Twitty Energy Center","State":"MO","Coal":178,"coordinates":[-93.388,37.1517]},{"Plant":"Laramie River Station","State":"WY","Coal":1668,"coordinates":[-104.8825,42.1089]},{"Plant":"Merom","State":"IN","Coal":1000,"coordinates":[-87.5108,39.0694]},{"Plant":"Pawnee","State":"CO","Coal":505,"coordinates":[-103.6803,40.2217]},{"Plant":"Winyah","State":"SC","Coal":1155,"coordinates":[-79.3581,33.3317]},{"Plant":"Mayo","State":"NC","Coal":745,"coordinates":[-78.8917,36.5278]},{"Plant":"Ottumwa","State":"IA","Coal":738,"coordinates":[-92.5558,41.0961]},{"Plant":"Scherer","State":"GA","Coal":3429.7,"coordinates":[-83.8075,33.0606]},{"Plant":"Mountaineer","State":"WV","Coal":1300,"coordinates":[-81.9344,38.9794]},{"Plant":"Crystal River","State":"FL","Coal":2302,"coordinates":[-82.6977,28.9656]},{"Plant":"Crist","State":"FL","Coal":937,"coordinates":[-87.2244,30.5661]},{"Plant":"Lansing Smith","State":"FL","Coal":351,"coordinates":[-85.7003,30.2686]},{"Plant":"Big Bend","State":"FL","Coal":1707,"coordinates":[-82.4036,27.7944]},{"Plant":"F J Gannon","State":"FL","Coal":1120,"coordinates":[-82.4231,27.9072]},{"Plant":"Antelope Valley","State":"ND","Coal":904,"coordinates":[-101.3194,47.2819]},{"Plant":"Intermountain Power Project","State":"UT","Coal":1640,"coordinates":[-112.5802,39.5097]},{"Plant":"Deerhaven Generating Station","State":"FL","Coal":228.4,"coordinates":[-82.3878,29.7592]},{"Plant":"R D Green","State":"KY","Coal":464,"coordinates":[-87.5,37.6461]},{"Plant":"Independence","State":"AR","Coal":1651,"coordinates":[-91.4088,35.6784]},{"Plant":"Sandow No 4","State":"TX","Coal":444,"coordinates":[-97.064,30.5659]},{"Plant":"Louisa","State":"IA","Coal":700,"coordinates":[-91.0931,41.3181]},{"Plant":"Warrick","State":"IN","Coal":270,"coordinates":[-87.3328,37.915]},{"Plant":"C D McIntosh Jr","State":"FL","Coal":342,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Coal":270,"coordinates":[-105.0212,40.8609]},{"Plant":"Sikeston Power Station","State":"MO","Coal":233,"coordinates":[-89.6209,36.8791]},{"Plant":"Hugo","State":"OK","Coal":405,"coordinates":[-95.3206,34.0158]},{"Plant":"D B Wilson","State":"KY","Coal":420,"coordinates":[-87.0806,37.4497]},{"Plant":"Gadsden","State":"AL","Coal":130,"coordinates":[-85.9708,34.0128]},{"Plant":"Bowen","State":"GA","Coal":3262,"coordinates":[-84.9222,34.1256]},{"Plant":"Major Oak Power","State":"TX","Coal":305,"coordinates":[-96.695,31.0919]},{"Plant":"Hammond","State":"GA","Coal":846,"coordinates":[-85.3456,34.2528]},{"Plant":"Harllee Branch","State":"GA","Coal":1607,"coordinates":[-83.2983,33.195]},{"Plant":"J K Spruce","State":"TX","Coal":555,"coordinates":[-98.3203,29.3097]},{"Plant":"Jack McDonough","State":"GA","Coal":517,"coordinates":[-84.4758,33.8239]},{"Plant":"Cope","State":"SC","Coal":422,"coordinates":[-81.03,33.3644]},{"Plant":"Clover","State":"VA","Coal":882,"coordinates":[-78.704,36.869]},{"Plant":"Polk","State":"FL","Coal":250,"coordinates":[-81.9897,27.7286]},{"Plant":"Mitchell","State":"GA","Coal":193,"coordinates":[-84.1347,31.4447]},{"Plant":"Yates","State":"GA","Coal":1295,"coordinates":[-84.8986,33.4622]},{"Plant":"Richard Gorsuch","State":"OH","Coal":212.3,"coordinates":[-81.5211,39.3664]},{"Plant":"Kraft","State":"GA","Coal":317,"coordinates":[-81.1458,32.1486]},{"Plant":"George Neal South","State":"IA","Coal":644,"coordinates":[-96.3617,42.3006]},{"Plant":"Nelson Coal","State":"LA","Coal":550,"coordinates":[-93.2885,30.2448]},{"Plant":"Bonanza","State":"UT","Coal":425,"coordinates":[-109.2844,40.0864]},{"Plant":"Pirkey","State":"TX","Coal":580,"coordinates":[-94.4852,32.4607]},{"Plant":"Gorgas","State":"AL","Coal":1288,"coordinates":[-87.1965,33.6443]},{"Plant":"Columbia","State":"WI","Coal":1073.7,"coordinates":[-89.4203,43.4864]},{"Plant":"Belews Creek","State":"NC","Coal":2240,"coordinates":[-80.0603,36.2811]},{"Plant":"Jim Bridger","State":"WY","Coal":2120,"coordinates":[-108.7875,41.7378]},{"Plant":"Huntington","State":"UT","Coal":895,"coordinates":[-111.0781,39.3792]},{"Plant":"General James M Gavin","State":"OH","Coal":2600,"coordinates":[-82.1158,38.9347]},{"Plant":"Ray D Nixon","State":"CO","Coal":208,"coordinates":[-104.7058,38.6335]},{"Plant":"Coyote","State":"ND","Coal":427,"coordinates":[-101.8157,47.2214]},{"Plant":"Springerville","State":"AZ","Coal":800,"coordinates":[-109.1639,34.3186]},{"Plant":"North Valmy","State":"NV","Coal":522,"coordinates":[-117.1516,40.8813]},{"Plant":"Cheswick Power Plant","State":"PA","Coal":562,"coordinates":[-79.7906,40.5383]},{"Plant":"E D Edwards","State":"IL","Coal":740,"coordinates":[-89.6631,40.5958]},{"Plant":"Coffeen","State":"IL","Coal":900,"coordinates":[-89.4031,39.0586]},{"Plant":"Grand Tower","State":"IL","Coal":186,"coordinates":[-89.5112,37.6577]},{"Plant":"Hutsonville","State":"IL","Coal":153,"coordinates":[-87.6597,39.1333]},{"Plant":"Meredosia","State":"IL","Coal":339,"coordinates":[-90.5672,39.8233]},{"Plant":"Crawford","State":"IL","Coal":532,"coordinates":[-87.7229,41.8285]},{"Plant":"Escalante","State":"NM","Coal":247,"coordinates":[-108.082,35.4159]},{"Plant":"Joliet 9","State":"IL","Coal":314,"coordinates":[-88.1153,41.4931]},{"Plant":"Kincaid Generation LLC","State":"IL","Coal":1168,"coordinates":[-89.4964,39.5906]},{"Plant":"Powerton","State":"IL","Coal":1538,"coordinates":[-89.6786,40.5408]},{"Plant":"Waukegan","State":"IL","Coal":789,"coordinates":[-87.8133,42.3833]},{"Plant":"Will County","State":"IL","Coal":1060,"coordinates":[-88.0629,41.6334]},{"Plant":"Fisk Street","State":"IL","Coal":326,"coordinates":[-87.6533,41.8508]},{"Plant":"Joppa Steam","State":"IL","Coal":1014,"coordinates":[-88.8589,37.2094]},{"Plant":"Baldwin Energy Complex","State":"IL","Coal":1716,"coordinates":[-89.8544,38.205]},{"Plant":"Havana","State":"IL","Coal":445,"coordinates":[-90.08,40.2797]},{"Plant":"Hennepin Power Station","State":"IL","Coal":289,"coordinates":[-89.315,41.3028]},{"Plant":"Vermilion","State":"IL","Coal":181,"coordinates":[-87.7481,40.1781]},{"Plant":"Wood River","State":"IL","Coal":458,"coordinates":[-90.1347,38.8639]},{"Plant":"Dallman","State":"IL","Coal":372,"coordinates":[-89.6024,39.7548]},{"Plant":"Marion","State":"IL","Coal":272,"coordinates":[-88.9531,37.6197]},{"Plant":"State Line Energy","State":"IN","Coal":515,"coordinates":[-87.5217,41.7072]},{"Plant":"Clifty Creek","State":"IN","Coal":1247,"coordinates":[-85.4206,38.7378]},{"Plant":"Tanners Creek","State":"IN","Coal":980,"coordinates":[-84.8594,39.0814]},{"Plant":"Harding Street","State":"IN","Coal":634,"coordinates":[-86.1969,39.7113]},{"Plant":"Eagle Valley","State":"IN","Coal":260,"coordinates":[-86.4183,39.4852]},{"Plant":"AES Petersburg","State":"IN","Coal":1664,"coordinates":[-87.2525,38.5281]},{"Plant":"Bailly","State":"IN","Coal":480,"coordinates":[-87.1225,41.645]},{"Plant":"Dean H Mitchell","State":"IN","Coal":360,"coordinates":[-87.4069,41.6392]},{"Plant":"Michigan City","State":"IN","Coal":469,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Coal":262,"coordinates":[-87.7811,32.6017]},{"Plant":"ACE Cogeneration Facility","State":"CA","Coal":101.2,"coordinates":[-117.3836,35.7658]},{"Plant":"Cayuga","State":"IN","Coal":995,"coordinates":[-87.4244,39.9242]},{"Plant":"RED-Rochester, LLC","State":"NY","Coal":180.8,"coordinates":[-77.6319,43.1989]},{"Plant":"Edwardsport","State":"IN","Coal":120,"coordinates":[-87.2472,38.8067]},{"Plant":"Logan Generating Company LP","State":"NJ","Coal":219,"coordinates":[-75.4067,39.7928]},{"Plant":"Portsmouth Genco LLC","State":"VA","Coal":115,"coordinates":[-76.3529,36.8702]},{"Plant":"Taconite Harbor Energy Center","State":"MN","Coal":225,"coordinates":[-90.9114,47.5314]},{"Plant":"R Gallagher","State":"IN","Coal":560,"coordinates":[-85.8381,38.2636]},{"Plant":"Wabash River","State":"IN","Coal":928,"coordinates":[-87.4247,39.53]},{"Plant":"F B Culley","State":"IN","Coal":406,"coordinates":[-87.3275,37.9111]},{"Plant":"Colver Power Project","State":"PA","Coal":110,"coordinates":[-78.8,40.55]},{"Plant":"Florida Power Development","State":"FL","Coal":139,"coordinates":[-82.4311,28.5819]},{"Plant":"Green Bay West Mill","State":"WI","Coal":110.47,"coordinates":[-88.0303,44.4936]},{"Plant":"CPI USA NC Southport","State":"NC","Coal":107,"coordinates":[-78.0118,33.9444]},{"Plant":"Edgecombe Genco LLC","State":"NC","Coal":105,"coordinates":[-77.7533,36.0373]},{"Plant":"Frank E Ratts","State":"IN","Coal":244,"coordinates":[-87.2662,38.5201]},{"Plant":"Lansing","State":"IA","Coal":317.1,"coordinates":[-91.1675,43.3359]},{"Plant":"4 AC Station","State":"IN","Coal":126.5,"coordinates":[-87.4264,41.68]},{"Plant":"Milton L Kapp","State":"IA","Coal":218,"coordinates":[-90.2336,41.8081]},{"Plant":"Chambers Cogeneration LP","State":"NJ","Coal":262,"coordinates":[-75.4858,39.6935]},{"Plant":"AES Shady Point LLC","State":"OK","Coal":320,"coordinates":[-94.6458,35.1931]},{"Plant":"Cedar Bay Generating Company LP","State":"FL","Coal":250,"coordinates":[-81.6064,30.4225]},{"Plant":"AES Hawaii","State":"HI","Coal":180,"coordinates":[-158.1065,21.3034]},{"Plant":"AES Thames","State":"CT","Coal":181,"coordinates":[-72.055,41.2607]},{"Plant":"AES Beaver Valley Partners Beaver Valley","State":"PA","Coal":146,"coordinates":[-80.3539,40.6572]},{"Plant":"AES Warrior Run Cogeneration Facility","State":"MD","Coal":180,"coordinates":[-78.7453,39.5952]},{"Plant":"Prairie Creek","State":"IA","Coal":210.9,"coordinates":[-91.6392,41.944]},{"Plant":"Sutherland","State":"IA","Coal":147.1,"coordinates":[-92.8594,42.0473]},{"Plant":"Holcomb","State":"KS","Coal":360,"coordinates":[-100.9725,37.9308]},{"Plant":"Riverside","State":"IA","Coal":135,"coordinates":[-90.4481,41.54]},{"Plant":"Walter Scott Jr Energy Center","State":"IA","Coal":806,"coordinates":[-95.8408,41.18]},{"Plant":"Silver Bay Power","State":"MN","Coal":105,"coordinates":[-91.2605,47.2866]},{"Plant":"Archer Daniels Midland Cedar Rapids","State":"IA","Coal":260,"coordinates":[-91.6875,41.9221]},{"Plant":"Archer Daniels Midland Decatur","State":"IL","Coal":230,"coordinates":[-88.8908,39.8701]},{"Plant":"George Neal North","State":"IA","Coal":950,"coordinates":[-96.3617,42.2998]},{"Plant":"Burlington","State":"IA","Coal":214.1,"coordinates":[-91.1167,40.7412]},{"Plant":"Cholla","State":"AZ","Coal":995,"coordinates":[-110.3033,34.9394]},{"Plant":"Muscatine Plant #1","State":"IA","Coal":233.5,"coordinates":[-91.0569,41.3917]},{"Plant":"La Cygne","State":"KS","Coal":1362,"coordinates":[-94.6456,38.3481]},{"Plant":"Lawrence Energy Center","State":"KS","Coal":598,"coordinates":[-95.2692,39.0072]},{"Plant":"Tecumseh Energy Center","State":"KS","Coal":243,"coordinates":[-95.5689,39.0539]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Coal":156,"coordinates":[-110.9047,32.16]},{"Plant":"Oklaunion","State":"TX","Coal":690,"coordinates":[-99.1753,34.0825]},{"Plant":"Quindaro","State":"KS","Coal":208,"coordinates":[-94.6381,39.1492]},{"Plant":"Cross","State":"SC","Coal":1160,"coordinates":[-80.1119,33.3692]},{"Plant":"Big Sandy","State":"KY","Coal":1060,"coordinates":[-82.6176,38.1707]},{"Plant":"E W Brown","State":"KY","Coal":701,"coordinates":[-84.7126,37.7883]},{"Plant":"Ghent","State":"KY","Coal":1966,"coordinates":[-85.035,38.7497]},{"Plant":"Green River","State":"KY","Coal":212,"coordinates":[-87.1214,37.3636]},{"Plant":"Seminole","State":"FL","Coal":1316,"coordinates":[-81.6328,29.7331]},{"Plant":"Cane Run","State":"KY","Coal":563,"coordinates":[-85.8892,38.1831]},{"Plant":"Mill Creek","State":"KY","Coal":1485,"coordinates":[-85.9103,38.0525]},{"Plant":"Elmer Smith","State":"KY","Coal":414.2,"coordinates":[-87.0608,37.7942]},{"Plant":"Paradise","State":"KY","Coal":2159,"coordinates":[-86.9783,37.2608]},{"Plant":"Shawnee","State":"KY","Coal":1330,"coordinates":[-88.775,37.1517]},{"Plant":"Kenneth C Coleman","State":"KY","Coal":455,"coordinates":[-86.7911,37.9631]},{"Plant":"HMP&L Station Two Henderson","State":"KY","Coal":312,"coordinates":[-87.5028,37.6469]},{"Plant":"Cooper","State":"KY","Coal":341,"coordinates":[-84.5919,36.9981]},{"Plant":"Dale","State":"KY","Coal":196,"coordinates":[-84.2619,37.8806]},{"Plant":"R S Nelson","State":"LA","Coal":550,"coordinates":[-93.2911,30.2844]},{"Plant":"C P Crane","State":"MD","Coal":385,"coordinates":[-76.3651,39.3236]},{"Plant":"Herbert A Wagner","State":"MD","Coal":459,"coordinates":[-76.5268,39.1781]},{"Plant":"FirstEnergy R Paul Smith Power Station","State":"MD","Coal":114,"coordinates":[-77.8269,39.595]},{"Plant":"Chalk Point LLC","State":"MD","Coal":683,"coordinates":[-76.6861,38.5444]},{"Plant":"Dickerson","State":"MD","Coal":546,"coordinates":[-77.4644,39.2097]},{"Plant":"Morgantown Generating Plant","State":"MD","Coal":1244,"coordinates":[-76.9767,38.3592]},{"Plant":"Apache Station","State":"AZ","Coal":350,"coordinates":[-109.8931,32.0603]},{"Plant":"Mount Tom","State":"MA","Coal":145.1,"coordinates":[-72.6055,42.2806]},{"Plant":"Somerset Station","State":"MA","Coal":108,"coordinates":[-71.146,41.7374]},{"Plant":"Brayton Point","State":"MA","Coal":1095.5,"coordinates":[-71.1931,41.7103]},{"Plant":"Salem Harbor","State":"MA","Coal":311.3,"coordinates":[-70.8772,42.5256]},{"Plant":"GRDA","State":"OK","Coal":1010,"coordinates":[-95.2894,36.1903]},{"Plant":"B C Cobb","State":"MI","Coal":312,"coordinates":[-86.2423,43.2588]},{"Plant":"Dan E Karn","State":"MI","Coal":511,"coordinates":[-83.8401,43.645]},{"Plant":"J H Campbell","State":"MI","Coal":1435,"coordinates":[-86.2007,42.9103]},{"Plant":"J C Weadock","State":"MI","Coal":310,"coordinates":[-83.8447,43.6399]},{"Plant":"J R Whiting","State":"MI","Coal":326,"coordinates":[-83.4495,41.7921]},{"Plant":"Harbor Beach","State":"MI","Coal":103,"coordinates":[-82.6436,43.8519]},{"Plant":"Marysville","State":"MI","Coal":200,"coordinates":[-82.4606,42.9256]},{"Plant":"Monroe","State":"MI","Coal":3020,"coordinates":[-83.3464,41.8906]},{"Plant":"River Rouge","State":"MI","Coal":510,"coordinates":[-83.1119,42.2739]},{"Plant":"St Clair","State":"MI","Coal":1415,"coordinates":[-82.4719,42.7642]},{"Plant":"Trenton Channel","State":"MI","Coal":730,"coordinates":[-83.1808,42.1217]},{"Plant":"Presque Isle","State":"MI","Coal":618,"coordinates":[-87.395,46.5789]},{"Plant":"Eckert Station","State":"MI","Coal":356.7,"coordinates":[-84.5581,42.7184]},{"Plant":"Erickson Station","State":"MI","Coal":158.4,"coordinates":[-84.6572,42.6922]},{"Plant":"Syl Laskin","State":"MN","Coal":110,"coordinates":[-92.1619,47.5306]},{"Plant":"Clay Boswell","State":"MN","Coal":912.9,"coordinates":[-93.6528,47.2611]},{"Plant":"Black Dog","State":"MN","Coal":456.9,"coordinates":[-93.2501,44.8108]},{"Plant":"High Bridge","State":"MN","Coal":269,"coordinates":[-93.1117,44.9314]},{"Plant":"Allen S King","State":"MN","Coal":571,"coordinates":[-92.7786,45.03]},{"Plant":"Riverside","State":"MN","Coal":384.2,"coordinates":[-93.2753,45.0203]},{"Plant":"Hoot Lake","State":"MN","Coal":154.4,"coordinates":[-96.0433,46.2906]},{"Plant":"Silver Lake","State":"MN","Coal":110.2,"coordinates":[-92.4604,44.0282]},{"Plant":"Jack Watson","State":"MS","Coal":775,"coordinates":[-89.0286,30.4392]},{"Plant":"St Johns River Power Park","State":"FL","Coal":1252,"coordinates":[-81.5508,30.4308]},{"Plant":"Asbury","State":"MO","Coal":213,"coordinates":[-94.5893,37.3613]},{"Plant":"Hawthorn","State":"MO","Coal":565,"coordinates":[-94.4778,39.1306]},{"Plant":"Montrose","State":"MO","Coal":510,"coordinates":[-93.9348,38.3114]},{"Plant":"Sibley","State":"MO","Coal":508,"coordinates":[-94.1844,39.1783]},{"Plant":"Labadie","State":"MO","Coal":2300,"coordinates":[-90.8377,38.5622]},{"Plant":"Meramec","State":"MO","Coal":876,"coordinates":[-90.3358,38.4017]},{"Plant":"Sioux","State":"MO","Coal":950,"coordinates":[-90.2902,38.9155]},{"Plant":"James River Power Station","State":"MO","Coal":236,"coordinates":[-93.2619,37.1086]},{"Plant":"New Madrid","State":"MO","Coal":1160,"coordinates":[-89.5617,36.5147]},{"Plant":"Thomas Hill","State":"MO","Coal":1120,"coordinates":[-92.6381,39.5522]},{"Plant":"J E Corette Plant","State":"MT","Coal":150,"coordinates":[-108.481,45.7756]},{"Plant":"Lon Wright","State":"NE","Coal":120,"coordinates":[-96.4623,41.4281]},{"Plant":"Sheldon","State":"NE","Coal":225,"coordinates":[-96.7847,40.5589]},{"Plant":"North Omaha","State":"NE","Coal":662.8,"coordinates":[-95.9447,41.3291]},{"Plant":"Reid Gardner","State":"NV","Coal":556,"coordinates":[-114.6333,36.6573]},{"Plant":"Mohave","State":"NV","Coal":1580,"coordinates":[-114.5917,35.1458]},{"Plant":"Merrimack","State":"NH","Coal":432.5,"coordinates":[-71.4692,43.1411]},{"Plant":"Schiller","State":"NH","Coal":142.6,"coordinates":[-70.7842,43.0978]},{"Plant":"B L England","State":"NJ","Coal":284,"coordinates":[-74.6364,39.2908]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Coal":608,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Mercer Generating Station","State":"NJ","Coal":648,"coordinates":[-74.7339,40.1792]},{"Plant":"Four Corners","State":"NM","Coal":2040,"coordinates":[-108.4814,36.69]},{"Plant":"San Juan","State":"NM","Coal":1643,"coordinates":[-108.4386,36.8006]},{"Plant":"Danskammer Generating Station","State":"NY","Coal":370,"coordinates":[-73.975,41.5712]},{"Plant":"GMMM Westover","State":"NY","Coal":127.7,"coordinates":[-75.9747,42.1117]},{"Plant":"GMMGreenidge LLC","State":"NY","Coal":162,"coordinates":[-76.9483,42.6789]},{"Plant":"Cayuga Operating Company","State":"NY","Coal":306,"coordinates":[-76.6336,42.6028]},{"Plant":"C R Huntley Generating Station","State":"NY","Coal":712,"coordinates":[-78.93,42.97]},{"Plant":"Dunkirk Generating Plant","State":"NY","Coal":607,"coordinates":[-79.3466,42.4915]},{"Plant":"E C Gaston","State":"AL","Coal":1890,"coordinates":[-86.4581,33.2442]},{"Plant":"Lovett","State":"NY","Coal":363,"coordinates":[-73.9797,41.2578]},{"Plant":"Rochester 7","State":"NY","Coal":252,"coordinates":[-77.6294,43.2689]},{"Plant":"Asheville","State":"NC","Coal":392,"coordinates":[-82.5417,35.4731]},{"Plant":"Cape Fear","State":"NC","Coal":316,"coordinates":[-79.0495,35.595]},{"Plant":"HF Lee Plant","State":"NC","Coal":407,"coordinates":[-78.0878,35.3799]},{"Plant":"Roxboro","State":"NC","Coal":2462,"coordinates":[-79.0731,36.4833]},{"Plant":"L V Sutton Steam","State":"NC","Coal":613,"coordinates":[-77.9853,34.2831]},{"Plant":"W H Weatherspoon","State":"NC","Coal":176,"coordinates":[-78.9755,34.5875]},{"Plant":"G G Allen","State":"NC","Coal":1140,"coordinates":[-81.0122,35.1897]},{"Plant":"Buck","State":"NC","Coal":369,"coordinates":[-80.3767,35.7133]},{"Plant":"Cliffside","State":"NC","Coal":760,"coordinates":[-81.7594,35.22]},{"Plant":"Dan River","State":"NC","Coal":276,"coordinates":[-79.7208,36.4862]},{"Plant":"Marshall","State":"NC","Coal":2090,"coordinates":[-80.9658,35.5975]},{"Plant":"Riverbend","State":"NC","Coal":454,"coordinates":[-80.9742,35.36]},{"Plant":"R M Heskett","State":"ND","Coal":102.1,"coordinates":[-100.8836,46.8669]},{"Plant":"Leland Olds","State":"ND","Coal":669,"coordinates":[-101.3212,47.2808]},{"Plant":"Milton R Young","State":"ND","Coal":705,"coordinates":[-101.2131,47.0659]},{"Plant":"Stanton","State":"ND","Coal":187.4,"coordinates":[-101.3319,47.2866]},{"Plant":"Cardinal","State":"OH","Coal":1800,"coordinates":[-80.6486,40.2522]},{"Plant":"Walter C Beckjord","State":"OH","Coal":1118,"coordinates":[-84.2981,38.9917]},{"Plant":"Miami Fort","State":"OH","Coal":1243,"coordinates":[-84.8036,39.1128]},{"Plant":"FirstEnergy Ashtabula","State":"OH","Coal":420,"coordinates":[-80.7697,41.9086]},{"Plant":"Avon Lake","State":"OH","Coal":721,"coordinates":[-82.0546,41.5045]},{"Plant":"FirstEnergy Eastlake","State":"OH","Coal":1233,"coordinates":[-81.4425,41.6711]},{"Plant":"FirstEnergy Lake Shore","State":"OH","Coal":245,"coordinates":[-81.6419,41.5356]},{"Plant":"Conesville","State":"OH","Coal":1925,"coordinates":[-81.8811,40.1842]},{"Plant":"O H Hutchings","State":"OH","Coal":365,"coordinates":[-84.2921,39.6088]},{"Plant":"J M Stuart","State":"OH","Coal":2340,"coordinates":[-83.6939,38.6361]},{"Plant":"Niles","State":"OH","Coal":216,"coordinates":[-80.7477,41.1669]},{"Plant":"FirstEnergy R E Burger","State":"OH","Coal":406,"coordinates":[-80.7608,39.91]},{"Plant":"FirstEnergy W H Sammis","State":"OH","Coal":2220,"coordinates":[-80.6319,40.5317]},{"Plant":"FirstEnergy Toronto","State":"OH","Coal":172,"coordinates":[-80.6044,40.4825]},{"Plant":"Muskingum River","State":"OH","Coal":1365,"coordinates":[-81.6797,39.5908]},{"Plant":"Kyger Creek","State":"OH","Coal":1023,"coordinates":[-82.1289,38.9144]},{"Plant":"FirstEnergy Bay Shore","State":"OH","Coal":495,"coordinates":[-83.4378,41.6917]},{"Plant":"Lake Road","State":"OH","Coal":160,"coordinates":[-81.6494,41.5278]},{"Plant":"Muskogee","State":"OK","Coal":1516.5,"coordinates":[-95.2873,35.7614]},{"Plant":"Northeastern","State":"OK","Coal":945,"coordinates":[-95.7008,36.4317]},{"Plant":"Limestone","State":"TX","Coal":1646,"coordinates":[-96.2525,31.4219]},{"Plant":"Barry","State":"AL","Coal":1658,"coordinates":[-88.0103,31.0069]},{"Plant":"Elrama Power Plant","State":"PA","Coal":474,"coordinates":[-79.918,40.2518]},{"Plant":"Portland","State":"PA","Coal":401,"coordinates":[-75.0794,40.9102]},{"Plant":"Titus","State":"PA","Coal":243,"coordinates":[-75.9081,40.3056]},{"Plant":"Conemaugh","State":"PA","Coal":1700,"coordinates":[-79.0611,40.3842]},{"Plant":"Homer City Generating Station","State":"PA","Coal":1884,"coordinates":[-79.1961,40.5128]},{"Plant":"Seward","State":"PA","Coal":196,"coordinates":[-79.0337,40.4062]},{"Plant":"Shawville","State":"PA","Coal":597,"coordinates":[-78.3662,41.0675]},{"Plant":"Keystone","State":"PA","Coal":1700,"coordinates":[-79.3411,40.6604]},{"Plant":"New Castle Plant","State":"PA","Coal":413,"coordinates":[-80.369,40.9379]},{"Plant":"Brunner Island","State":"PA","Coal":1448,"coordinates":[-76.6962,40.0961]},{"Plant":"PPL Martins Creek","State":"PA","Coal":280,"coordinates":[-75.1054,40.7978]},{"Plant":"PPL Montour","State":"PA","Coal":1540,"coordinates":[-76.6672,41.0714]},{"Plant":"Sunbury Generation LP","State":"PA","Coal":361,"coordinates":[-76.825,40.8361]},{"Plant":"Cromby Generating Station","State":"PA","Coal":144,"coordinates":[-75.5294,40.1531]},{"Plant":"Eddystone Generating Station","State":"PA","Coal":581,"coordinates":[-75.323,39.858]},{"Plant":"FirstEnergy Armstrong Power Station","State":"PA","Coal":343,"coordinates":[-79.4656,40.9292]},{"Plant":"Hatfields Ferry Power Station","State":"PA","Coal":1590,"coordinates":[-79.9275,39.8556]},{"Plant":"FirstEnergy Mitchell Power Station","State":"PA","Coal":277,"coordinates":[-79.9683,40.2211]},{"Plant":"H B Robinson","State":"SC","Coal":174,"coordinates":[-80.1589,34.4017]},{"Plant":"W S Lee","State":"SC","Coal":370,"coordinates":[-82.435,34.6022]},{"Plant":"Canadys Steam","State":"SC","Coal":396,"coordinates":[-80.6228,33.0647]},{"Plant":"McMeekin","State":"SC","Coal":250,"coordinates":[-81.2172,34.0556]},{"Plant":"Wateree","State":"SC","Coal":700,"coordinates":[-80.6228,33.8264]},{"Plant":"Williams","State":"SC","Coal":615,"coordinates":[-79.9297,33.0158]},{"Plant":"Dolphus M Grainger","State":"SC","Coal":170,"coordinates":[-79.0533,33.8264]},{"Plant":"Jefferies","State":"SC","Coal":306,"coordinates":[-79.9875,33.2422]},{"Plant":"Allen Steam Plant","State":"TN","Coal":738,"coordinates":[-90.1487,35.0741]},{"Plant":"Bull Run","State":"TN","Coal":865,"coordinates":[-84.1567,36.0211]},{"Plant":"Cumberland","State":"TN","Coal":2455,"coordinates":[-87.6539,36.3903]},{"Plant":"Gallatin","State":"TN","Coal":976,"coordinates":[-86.4006,36.3156]},{"Plant":"John Sevier","State":"TN","Coal":704,"coordinates":[-82.9639,36.3767]},{"Plant":"Johnsonville","State":"TN","Coal":1206,"coordinates":[-87.9861,36.0278]},{"Plant":"Kingston","State":"TN","Coal":1434,"coordinates":[-84.5194,35.8992]},{"Plant":"Watts Bar Fossil","State":"TN","Coal":224,"coordinates":[-84.7811,35.6108]},{"Plant":"W A Parish","State":"TX","Coal":2550,"coordinates":[-95.6311,29.4828]},{"Plant":"Big Brown","State":"TX","Coal":1130,"coordinates":[-96.0544,31.8206]},{"Plant":"Carbon","State":"UT","Coal":172,"coordinates":[-110.8644,39.7272]},{"Plant":"Clinch River","State":"VA","Coal":690,"coordinates":[-82.1997,36.9333]},{"Plant":"Glen Lyn","State":"VA","Coal":325,"coordinates":[-80.8633,37.3706]},{"Plant":"Potomac River","State":"VA","Coal":482,"coordinates":[-77.0411,38.8203]},{"Plant":"Bremo Bluff","State":"VA","Coal":227,"coordinates":[-78.2878,37.7089]},{"Plant":"Chesterfield","State":"VA","Coal":1234,"coordinates":[-77.3833,37.3822]},{"Plant":"Chesapeake","State":"VA","Coal":595,"coordinates":[-76.3019,36.7711]},{"Plant":"Possum Point","State":"VA","Coal":322,"coordinates":[-77.2806,38.5367]},{"Plant":"Yorktown","State":"VA","Coal":326,"coordinates":[-76.4611,37.2144]},{"Plant":"Joliet 29","State":"IL","Coal":1036,"coordinates":[-88.1238,41.4946]},{"Plant":"Transalta Centralia Generation","State":"WA","Coal":1405,"coordinates":[-122.8598,46.7559]},{"Plant":"John E Amos","State":"WV","Coal":2900,"coordinates":[-81.8233,38.4731]},{"Plant":"Kanawha River","State":"WV","Coal":390,"coordinates":[-81.4211,38.2056]},{"Plant":"Philip Sporn","State":"WV","Coal":1020,"coordinates":[-81.9231,38.9669]},{"Plant":"FirstEnergy Albright","State":"WV","Coal":283,"coordinates":[-79.6369,39.4886]},{"Plant":"FirstEnergy Fort Martin Power Station","State":"WV","Coal":1107,"coordinates":[-79.9275,39.7108]},{"Plant":"FirstEnergy Harrison Power Station","State":"WV","Coal":1933,"coordinates":[-80.3325,39.3842]},{"Plant":"FirstEnergy Rivesville","State":"WV","Coal":137,"coordinates":[-80.1131,39.5314]},{"Plant":"FirstEnergy Willow Island","State":"WV","Coal":235,"coordinates":[-81.3,39.3672]},{"Plant":"Kammer","State":"WV","Coal":600,"coordinates":[-80.8186,39.8461]},{"Plant":"Mitchell","State":"WV","Coal":1600,"coordinates":[-80.8153,39.8297]},{"Plant":"Mt Storm","State":"WV","Coal":1569,"coordinates":[-79.2636,39.2008]},{"Plant":"Blount Street","State":"WI","Coal":194.1,"coordinates":[-89.3744,43.0789]},{"Plant":"Port Washington Generating Station","State":"WI","Coal":305,"coordinates":[-87.8689,43.3842]},{"Plant":"South Oak Creek","State":"WI","Coal":1135,"coordinates":[-87.8294,42.8457]},{"Plant":"Valley","State":"WI","Coal":267,"coordinates":[-87.9233,43.0303]},{"Plant":"Edgewater","State":"WI","Coal":835.8,"coordinates":[-87.7059,43.7151]},{"Plant":"Nelson Dewey Coal Refining Facility","State":"WI","Coal":223.1,"coordinates":[-91.0085,42.7225]},{"Plant":"Pulliam","State":"WI","Coal":389,"coordinates":[-88.0086,44.54]},{"Plant":"Weston","State":"WI","Coal":482,"coordinates":[-89.6553,44.8606]},{"Plant":"Alma","State":"WI","Coal":183.8,"coordinates":[-91.9111,44.3083]},{"Plant":"Genoa","State":"WI","Coal":351.6,"coordinates":[-91.2325,43.5589]},{"Plant":"Dave Johnston","State":"WY","Coal":762,"coordinates":[-105.7769,42.8378]},{"Plant":"Naughton","State":"WY","Coal":700,"coordinates":[-110.5983,41.7581]},{"Plant":"John P Madgett","State":"WI","Coal":373.5,"coordinates":[-91.9126,44.3036]},{"Plant":"Arapahoe","State":"CO","Coal":246,"coordinates":[-105.0028,39.67]},{"Plant":"Cherokee","State":"CO","Coal":717,"coordinates":[-104.9645,39.8073]},{"Plant":"Colbert","State":"AL","Coal":1173,"coordinates":[-87.8486,34.7439]},{"Plant":"Comanche","State":"CO","Coal":660,"coordinates":[-104.5747,38.2081]},{"Plant":"Valmont","State":"CO","Coal":186,"coordinates":[-105.202,40.0195]},{"Plant":"Martin Drake","State":"CO","Coal":259,"coordinates":[-104.8333,38.8244]},{"Plant":"Navajo","State":"AZ","Coal":2250,"coordinates":[-111.3886,36.9047]},{"Plant":"Widows Creek","State":"AL","Coal":1608,"coordinates":[-85.7553,34.883]},{"Plant":"G F Weaton Power Station","State":"PA","Coal":112,"coordinates":[-80.3462,40.6673]},{"Plant":"International Paper Savanna Mill","State":"GA","Coal":189.09,"coordinates":[-81.1242,32.1004]},{"Plant":"Tennessee Eastman Operations","State":"TN","Coal":194.3,"coordinates":[-82.5431,36.5219]},{"Plant":"Axiall Natrium Plant","State":"WV","Coal":123,"coordinates":[-80.8547,39.7475]},{"Plant":"Northampton Generating Company LP","State":"PA","Coal":112,"coordinates":[-75.4792,40.6917]},{"Plant":"Indiantown Cogeneration LP","State":"FL","Coal":330,"coordinates":[-80.5125,27.0389]},{"Plant":"Dolet Hills","State":"LA","Coal":650,"coordinates":[-93.5692,32.0306]},{"Plant":"Mecklenburg Power Station","State":"VA","Coal":132,"coordinates":[-78.53,36.6]},{"Plant":"Sandow No 5","State":"TX","Coal":363,"coordinates":[-97.0614,30.5681]},{"Plant":"Hayden","State":"CO","Coal":446,"coordinates":[-107.185,40.4856]},{"Plant":"Roanoke Valley Energy Facililty I","State":"NC","Coal":165,"coordinates":[-77.6167,36.4364]},{"Plant":"Spruance Genco LLC","State":"VA","Coal":190,"coordinates":[-77.4308,37.4556]},{"Plant":"Birchwood Power","State":"VA","Coal":237.8,"coordinates":[-77.3147,38.2667]},{"Plant":"Red Hills Generating Facility","State":"MS","Coal":440,"coordinates":[-89.2183,33.3761]},{"Plant":"Charles R Lowman","State":"AL","Coal":551,"coordinates":[-87.9107,31.488]},{"Plant":"Stanton Energy Center","State":"FL","Coal":886,"coordinates":[-81.1678,28.4822]},{"Plant":"Bridgeport Station","State":"CT","Coal":372.2,"coordinates":[-73.1844,41.1706]},{"Plant":"Edge Moor","State":"DE","Coal":260,"coordinates":[-75.5038,39.7389]},{"Plant":"Indian River Generating Station","State":"DE","Coal":767,"coordinates":[-75.2341,38.5857]},{"Plant":"James H Miller Jr","State":"AL","Coal":2686,"coordinates":[-87.0597,33.6319]},{"Plant":"FirstEnergy Pleasants Power Station","State":"WV","Coal":1278,"coordinates":[-81.2944,39.3667]},{"Plant":"White Bluff","State":"AR","Coal":1620,"coordinates":[-92.1406,34.4228]},{"Plant":"Duck Creek","State":"IL","Coal":366,"coordinates":[-89.9841,40.4663]},{"Plant":"Newton","State":"IL","Coal":1110,"coordinates":[-88.2781,38.9361]},{"Plant":"East Bend","State":"KY","Coal":600,"coordinates":[-84.8514,38.9036]},{"Plant":"W H Zimmer","State":"OH","Coal":1300,"coordinates":[-84.2289,38.8675]},{"Plant":"Brandon Shores","State":"MD","Coal":1286,"coordinates":[-76.5389,39.18]},{"Plant":"Craig","State":"CO","Coal":1264,"coordinates":[-107.5912,40.4627]},{"Plant":"Coal Creek","State":"ND","Coal":1089,"coordinates":[-101.1571,47.3777]},{"Plant":"Killen Station","State":"OH","Coal":600,"coordinates":[-83.4803,38.6903]},{"Plant":"Belle River","State":"MI","Coal":1260,"coordinates":[-82.495,42.7756]},{"Plant":"H L Spurlock","State":"KY","Coal":850,"coordinates":[-83.8181,38.7]},{"Plant":"Wansley","State":"GA","Coal":1778,"coordinates":[-85.0323,33.4134]},{"Plant":"Big Cajun 2","State":"LA","Coal":1730,"coordinates":[-91.3692,30.7261]},{"Plant":"R D Morrow","State":"MS","Coal":400,"coordinates":[-89.394,31.2186]},{"Plant":"Nearman Creek","State":"KS","Coal":235,"coordinates":[-94.6975,39.1681]},{"Plant":"Iatan","State":"MO","Coal":670,"coordinates":[-94.98,39.4472]},{"Plant":"Jeffrey Energy Center","State":"KS","Coal":2212,"coordinates":[-96.1172,39.2865]},{"Plant":"Trimble County","State":"KY","Coal":512,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Coal":1050,"coordinates":[-88.5553,30.5322]},{"Plant":"Colstrip","State":"MT","Coal":2094,"coordinates":[-106.614,45.8831]},{"Plant":"Gerald Gentleman","State":"NE","Coal":1365,"coordinates":[-101.1408,41.0808]},{"Plant":"Somerset Operating Co LLC","State":"NY","Coal":684,"coordinates":[-78.6047,43.3589]},{"Plant":"R M Schahfer","State":"IN","Coal":1625,"coordinates":[-87.0261,41.2164]},{"Plant":"Sherburne County","State":"MN","Coal":2292.4,"coordinates":[-93.8931,45.3808]},{"Plant":"FirstEnergy Bruce Mansfield","State":"PA","Coal":2360,"coordinates":[-80.4159,40.6348]},{"Plant":"Sooner","State":"OK","Coal":1019.1,"coordinates":[-97.0528,36.4531]},{"Plant":"Nebraska City","State":"NE","Coal":646,"coordinates":[-95.7764,40.6214]},{"Plant":"Big Stone","State":"SD","Coal":455.5,"coordinates":[-96.5101,45.3037]},{"Plant":"Wyodak","State":"WY","Coal":335,"coordinates":[-105.3815,44.2901]},{"Plant":"Boardman","State":"OR","Coal":556.7,"coordinates":[-119.8088,45.6932]},{"Plant":"Gibson","State":"IN","Coal":3131,"coordinates":[-87.7658,38.3722]},{"Plant":"McIntosh","State":"GA","Coal":155,"coordinates":[-81.1683,32.3563]},{"Plant":"Gibbons Creek","State":"TX","Coal":462,"coordinates":[-96.0818,30.6199]},{"Plant":"A B Brown","State":"IN","Coal":500,"coordinates":[-87.715,37.9053]},{"Plant":"Flint Creek","State":"AR","Coal":480,"coordinates":[-94.5241,36.2561]},{"Plant":"Welsh","State":"TX","Coal":1584,"coordinates":[-94.84,33.0552]},{"Plant":"Martin Lake","State":"TX","Coal":2250,"coordinates":[-94.5706,32.2606]},{"Plant":"Monticello","State":"TX","Coal":1875,"coordinates":[-95.0417,33.0917]},{"Plant":"Rush Island","State":"MO","Coal":1166,"coordinates":[-90.2632,38.1312]},{"Plant":"Hunter","State":"UT","Coal":1320,"coordinates":[-111.0289,39.1747]},{"Plant":"Rockport","State":"IN","Coal":2600,"coordinates":[-87.0372,37.9256]},{"Plant":"Pleasant Prairie","State":"WI","Coal":1224,"coordinates":[-87.9033,42.5381]},{"Plant":"Coronado","State":"AZ","Coal":785,"coordinates":[-109.2708,34.5789]},{"Plant":"Coleto Creek","State":"TX","Coal":632,"coordinates":[-97.2142,28.7128]},{"Plant":"Fayette Power Project","State":"TX","Coal":1605,"coordinates":[-96.7506,29.9172]},{"Plant":"J T Deely","State":"TX","Coal":810,"coordinates":[-98.3228,29.3081]},{"Plant":"San Miguel","State":"TX","Coal":391,"coordinates":[-98.4775,28.7044]},{"Plant":"Brame Energy Center","State":"LA","Coal":523,"coordinates":[-92.7167,31.395]},{"Plant":"Harrington","State":"TX","Coal":1066,"coordinates":[-101.7472,35.2982]},{"Plant":"Tolk","State":"TX","Coal":1080,"coordinates":[-102.57,34.1865]},{"Plant":"John Twitty Energy Center","State":"MO","Coal":178,"coordinates":[-93.388,37.1517]},{"Plant":"Laramie River Station","State":"WY","Coal":1650,"coordinates":[-104.8825,42.1089]},{"Plant":"Merom","State":"IN","Coal":1000,"coordinates":[-87.5108,39.0694]},{"Plant":"Pawnee","State":"CO","Coal":505,"coordinates":[-103.6803,40.2217]},{"Plant":"Winyah","State":"SC","Coal":1155,"coordinates":[-79.3581,33.3317]},{"Plant":"Mayo","State":"NC","Coal":745,"coordinates":[-78.8917,36.5278]},{"Plant":"Ottumwa","State":"IA","Coal":720.2,"coordinates":[-92.5558,41.0961]},{"Plant":"Scherer","State":"GA","Coal":3429.7,"coordinates":[-83.8075,33.0606]},{"Plant":"Mountaineer","State":"WV","Coal":1300,"coordinates":[-81.9344,38.9794]},{"Plant":"Crystal River","State":"FL","Coal":2302,"coordinates":[-82.6977,28.9656]},{"Plant":"Crist","State":"FL","Coal":937,"coordinates":[-87.2244,30.5661]},{"Plant":"Lansing Smith","State":"FL","Coal":351,"coordinates":[-85.7003,30.2686]},{"Plant":"Big Bend","State":"FL","Coal":1712,"coordinates":[-82.4036,27.7944]},{"Plant":"F J Gannon","State":"FL","Coal":1082,"coordinates":[-82.4231,27.9072]},{"Plant":"Antelope Valley","State":"ND","Coal":904,"coordinates":[-101.3194,47.2819]},{"Plant":"Intermountain Power Project","State":"UT","Coal":1640,"coordinates":[-112.5802,39.5097]},{"Plant":"Deerhaven Generating Station","State":"FL","Coal":228,"coordinates":[-82.3878,29.7592]},{"Plant":"R D Green","State":"KY","Coal":464,"coordinates":[-87.5,37.6461]},{"Plant":"Independence","State":"AR","Coal":1657,"coordinates":[-91.4088,35.6784]},{"Plant":"Sandow No 4","State":"TX","Coal":553.39,"coordinates":[-97.064,30.5659]},{"Plant":"Louisa","State":"IA","Coal":700,"coordinates":[-91.0931,41.3181]},{"Plant":"Northside Generating Station","State":"FL","Coal":550,"coordinates":[-81.5525,30.4172]},{"Plant":"Warrick","State":"IN","Coal":687,"coordinates":[-87.3328,37.915]},{"Plant":"C D McIntosh Jr","State":"FL","Coal":338,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Coal":270,"coordinates":[-105.0212,40.8609]},{"Plant":"Sikeston Power Station","State":"MO","Coal":233,"coordinates":[-89.6209,36.8791]},{"Plant":"Hugo","State":"OK","Coal":405,"coordinates":[-95.3206,34.0158]},{"Plant":"D B Wilson","State":"KY","Coal":420,"coordinates":[-87.0806,37.4497]},{"Plant":"Gadsden","State":"AL","Coal":130,"coordinates":[-85.9708,34.0128]},{"Plant":"Bowen","State":"GA","Coal":3262,"coordinates":[-84.9222,34.1256]},{"Plant":"Major Oak Power","State":"TX","Coal":305,"coordinates":[-96.695,31.0919]},{"Plant":"Hammond","State":"GA","Coal":846,"coordinates":[-85.3456,34.2528]},{"Plant":"Harllee Branch","State":"GA","Coal":1607,"coordinates":[-83.2983,33.195]},{"Plant":"J K Spruce","State":"TX","Coal":585,"coordinates":[-98.3203,29.3097]},{"Plant":"Jack McDonough","State":"GA","Coal":517,"coordinates":[-84.4758,33.8239]},{"Plant":"Cope","State":"SC","Coal":410,"coordinates":[-81.03,33.3644]},{"Plant":"Clover","State":"VA","Coal":882,"coordinates":[-78.704,36.869]},{"Plant":"Polk","State":"FL","Coal":255,"coordinates":[-81.9897,27.7286]},{"Plant":"Mitchell","State":"GA","Coal":193,"coordinates":[-84.1347,31.4447]},{"Plant":"Yates","State":"GA","Coal":1295,"coordinates":[-84.8986,33.4622]},{"Plant":"Richard Gorsuch","State":"OH","Coal":200,"coordinates":[-81.5211,39.3664]},{"Plant":"Kraft","State":"GA","Coal":317,"coordinates":[-81.1458,32.1486]},{"Plant":"George Neal South","State":"IA","Coal":644,"coordinates":[-96.3617,42.3006]},{"Plant":"Bonanza","State":"UT","Coal":425,"coordinates":[-109.2844,40.0864]},{"Plant":"Pirkey","State":"TX","Coal":580.1,"coordinates":[-94.4852,32.4607]},{"Plant":"Gorgas","State":"AL","Coal":1288,"coordinates":[-87.1965,33.6443]},{"Plant":"Columbia","State":"WI","Coal":1098.1,"coordinates":[-89.4203,43.4864]},{"Plant":"Belews Creek","State":"NC","Coal":2240,"coordinates":[-80.0603,36.2811]},{"Plant":"Jim Bridger","State":"WY","Coal":2120,"coordinates":[-108.7875,41.7378]},{"Plant":"Huntington","State":"UT","Coal":895,"coordinates":[-111.0781,39.3792]},{"Plant":"General James M Gavin","State":"OH","Coal":2600,"coordinates":[-82.1158,38.9347]},{"Plant":"Ray D Nixon","State":"CO","Coal":208,"coordinates":[-104.7058,38.6335]},{"Plant":"Coyote","State":"ND","Coal":427,"coordinates":[-101.8157,47.2214]},{"Plant":"Springerville","State":"AZ","Coal":800,"coordinates":[-109.1639,34.3186]},{"Plant":"North Valmy","State":"NV","Coal":522,"coordinates":[-117.1516,40.8813]},{"Plant":"Cheswick Power Plant","State":"PA","Coal":562,"coordinates":[-79.7906,40.5383]},{"Plant":"E D Edwards","State":"IL","Coal":740,"coordinates":[-89.6631,40.5958]},{"Plant":"Coffeen","State":"IL","Coal":900,"coordinates":[-89.4031,39.0586]},{"Plant":"Hutsonville","State":"IL","Coal":153,"coordinates":[-87.6597,39.1333]},{"Plant":"Meredosia","State":"IL","Coal":339,"coordinates":[-90.5672,39.8233]},{"Plant":"Crawford","State":"IL","Coal":532,"coordinates":[-87.7229,41.8285]},{"Plant":"Escalante","State":"NM","Coal":247,"coordinates":[-108.082,35.4159]},{"Plant":"Joliet 9","State":"IL","Coal":314,"coordinates":[-88.1153,41.4931]},{"Plant":"Kincaid Generation LLC","State":"IL","Coal":1168,"coordinates":[-89.4964,39.5906]},{"Plant":"Powerton","State":"IL","Coal":1538,"coordinates":[-89.6786,40.5408]},{"Plant":"Waukegan","State":"IL","Coal":789,"coordinates":[-87.8133,42.3833]},{"Plant":"Will County","State":"IL","Coal":1060,"coordinates":[-88.0629,41.6334]},{"Plant":"Fisk Street","State":"IL","Coal":326,"coordinates":[-87.6533,41.8508]},{"Plant":"Joppa Steam","State":"IL","Coal":1014,"coordinates":[-88.8589,37.2094]},{"Plant":"Baldwin Energy Complex","State":"IL","Coal":1761,"coordinates":[-89.8544,38.205]},{"Plant":"Havana","State":"IL","Coal":445,"coordinates":[-90.08,40.2797]},{"Plant":"Hennepin Power Station","State":"IL","Coal":289,"coordinates":[-89.315,41.3028]},{"Plant":"Vermilion","State":"IL","Coal":181,"coordinates":[-87.7481,40.1781]},{"Plant":"Wood River","State":"IL","Coal":458,"coordinates":[-90.1347,38.8639]},{"Plant":"Dallman","State":"IL","Coal":372,"coordinates":[-89.6024,39.7548]},{"Plant":"Marion","State":"IL","Coal":272,"coordinates":[-88.9531,37.6197]},{"Plant":"State Line Energy","State":"IN","Coal":515,"coordinates":[-87.5217,41.7072]},{"Plant":"Clifty Creek","State":"IN","Coal":1235,"coordinates":[-85.4206,38.7378]},{"Plant":"Tanners Creek","State":"IN","Coal":980,"coordinates":[-84.8594,39.0814]},{"Plant":"Harding Street","State":"IN","Coal":647,"coordinates":[-86.1969,39.7113]},{"Plant":"Eagle Valley","State":"IN","Coal":260,"coordinates":[-86.4183,39.4852]},{"Plant":"AES Petersburg","State":"IN","Coal":1694,"coordinates":[-87.2525,38.5281]},{"Plant":"Bailly","State":"IN","Coal":480,"coordinates":[-87.1225,41.645]},{"Plant":"Dean H Mitchell","State":"IN","Coal":360,"coordinates":[-87.4069,41.6392]},{"Plant":"Michigan City","State":"IN","Coal":469,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Coal":254,"coordinates":[-87.7811,32.6017]},{"Plant":"ACE Cogeneration Facility","State":"CA","Coal":101.2,"coordinates":[-117.3836,35.7658]},{"Plant":"Cayuga","State":"IN","Coal":995,"coordinates":[-87.4244,39.9242]},{"Plant":"RED-Rochester, LLC","State":"NY","Coal":180.8,"coordinates":[-77.6319,43.1989]},{"Plant":"Edwardsport","State":"IN","Coal":120,"coordinates":[-87.2472,38.8067]},{"Plant":"Logan Generating Company LP","State":"NJ","Coal":219,"coordinates":[-75.4067,39.7928]},{"Plant":"Portsmouth Genco LLC","State":"VA","Coal":115,"coordinates":[-76.3529,36.8702]},{"Plant":"Taconite Harbor Energy Center","State":"MN","Coal":200,"coordinates":[-90.9114,47.5314]},{"Plant":"R Gallagher","State":"IN","Coal":560,"coordinates":[-85.8381,38.2636]},{"Plant":"Wabash River","State":"IN","Coal":928,"coordinates":[-87.4247,39.53]},{"Plant":"F B Culley","State":"IN","Coal":406,"coordinates":[-87.3275,37.9111]},{"Plant":"Colver Power Project","State":"PA","Coal":110,"coordinates":[-78.8,40.55]},{"Plant":"Florida Power Development","State":"FL","Coal":139,"coordinates":[-82.4311,28.5819]},{"Plant":"Green Bay West Mill","State":"WI","Coal":110.47,"coordinates":[-88.0303,44.4936]},{"Plant":"CPI USA NC Southport","State":"NC","Coal":107,"coordinates":[-78.0118,33.9444]},{"Plant":"Edgecombe Genco LLC","State":"NC","Coal":105,"coordinates":[-77.7533,36.0373]},{"Plant":"Frank E Ratts","State":"IN","Coal":244,"coordinates":[-87.2662,38.5201]},{"Plant":"Lansing","State":"IA","Coal":327.91,"coordinates":[-91.1675,43.3359]},{"Plant":"4 AC Station","State":"IN","Coal":126.5,"coordinates":[-87.4264,41.68]},{"Plant":"Milton L Kapp","State":"IA","Coal":219.42,"coordinates":[-90.2336,41.8081]},{"Plant":"Chambers Cogeneration LP","State":"NJ","Coal":262,"coordinates":[-75.4858,39.6935]},{"Plant":"AES Shady Point LLC","State":"OK","Coal":320,"coordinates":[-94.6458,35.1931]},{"Plant":"Cedar Bay Generating Company LP","State":"FL","Coal":250,"coordinates":[-81.6064,30.4225]},{"Plant":"AES Hawaii","State":"HI","Coal":180,"coordinates":[-158.1065,21.3034]},{"Plant":"AES Thames","State":"CT","Coal":181,"coordinates":[-72.055,41.2607]},{"Plant":"AES Beaver Valley Partners Beaver Valley","State":"PA","Coal":146,"coordinates":[-80.3539,40.6572]},{"Plant":"AES Warrior Run Cogeneration Facility","State":"MD","Coal":180,"coordinates":[-78.7453,39.5952]},{"Plant":"Prairie Creek","State":"IA","Coal":215.56,"coordinates":[-91.6392,41.944]},{"Plant":"Sutherland","State":"IA","Coal":143.26,"coordinates":[-92.8594,42.0473]},{"Plant":"Holcomb","State":"KS","Coal":360,"coordinates":[-100.9725,37.9308]},{"Plant":"Riverside","State":"IA","Coal":135,"coordinates":[-90.4481,41.54]},{"Plant":"Walter Scott Jr Energy Center","State":"IA","Coal":823,"coordinates":[-95.8408,41.18]},{"Plant":"Silver Bay Power","State":"MN","Coal":105,"coordinates":[-91.2605,47.2866]},{"Plant":"Archer Daniels Midland Cedar Rapids","State":"IA","Coal":260,"coordinates":[-91.6875,41.9221]},{"Plant":"Archer Daniels Midland Decatur","State":"IL","Coal":230,"coordinates":[-88.8908,39.8701]},{"Plant":"George Neal North","State":"IA","Coal":950,"coordinates":[-96.3617,42.2998]},{"Plant":"Burlington","State":"IA","Coal":215.72,"coordinates":[-91.1167,40.7412]},{"Plant":"Cholla","State":"AZ","Coal":995,"coordinates":[-110.3033,34.9394]},{"Plant":"Muscatine Plant #1","State":"IA","Coal":236.2,"coordinates":[-91.0569,41.3917]},{"Plant":"La Cygne","State":"KS","Coal":1362,"coordinates":[-94.6456,38.3481]},{"Plant":"Lawrence Energy Center","State":"KS","Coal":593,"coordinates":[-95.2692,39.0072]},{"Plant":"Tecumseh Energy Center","State":"KS","Coal":228,"coordinates":[-95.5689,39.0539]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Coal":156,"coordinates":[-110.9047,32.16]},{"Plant":"Oklaunion","State":"TX","Coal":690,"coordinates":[-99.1753,34.0825]},{"Plant":"Quindaro","State":"KS","Coal":208,"coordinates":[-94.6381,39.1492]},{"Plant":"Cross","State":"SC","Coal":1160,"coordinates":[-80.1119,33.3692]},{"Plant":"Big Sandy","State":"KY","Coal":1060,"coordinates":[-82.6176,38.1707]},{"Plant":"E W Brown","State":"KY","Coal":697,"coordinates":[-84.7126,37.7883]},{"Plant":"Ghent","State":"KY","Coal":1954,"coordinates":[-85.035,38.7497]},{"Plant":"Green River","State":"KY","Coal":207,"coordinates":[-87.1214,37.3636]},{"Plant":"Seminole","State":"FL","Coal":1316,"coordinates":[-81.6328,29.7331]},{"Plant":"Cane Run","State":"KY","Coal":563,"coordinates":[-85.8892,38.1831]},{"Plant":"Mill Creek","State":"KY","Coal":1472,"coordinates":[-85.9103,38.0525]},{"Plant":"Elmer Smith","State":"KY","Coal":414.2,"coordinates":[-87.0608,37.7942]},{"Plant":"Paradise","State":"KY","Coal":2179,"coordinates":[-86.9783,37.2608]},{"Plant":"Shawnee","State":"KY","Coal":1330,"coordinates":[-88.775,37.1517]},{"Plant":"Kenneth C Coleman","State":"KY","Coal":455,"coordinates":[-86.7911,37.9631]},{"Plant":"HMP&L Station Two Henderson","State":"KY","Coal":312,"coordinates":[-87.5028,37.6469]},{"Plant":"Cooper","State":"KY","Coal":341,"coordinates":[-84.5919,36.9981]},{"Plant":"Dale","State":"KY","Coal":196,"coordinates":[-84.2619,37.8806]},{"Plant":"R S Nelson","State":"LA","Coal":550,"coordinates":[-93.2911,30.2844]},{"Plant":"C P Crane","State":"MD","Coal":385,"coordinates":[-76.3651,39.3236]},{"Plant":"Herbert A Wagner","State":"MD","Coal":459,"coordinates":[-76.5268,39.1781]},{"Plant":"FirstEnergy R Paul Smith Power Station","State":"MD","Coal":114,"coordinates":[-77.8269,39.595]},{"Plant":"Chalk Point LLC","State":"MD","Coal":683,"coordinates":[-76.6861,38.5444]},{"Plant":"Dickerson","State":"MD","Coal":546,"coordinates":[-77.4644,39.2097]},{"Plant":"Morgantown Generating Plant","State":"MD","Coal":1244,"coordinates":[-76.9767,38.3592]},{"Plant":"Apache Station","State":"AZ","Coal":350,"coordinates":[-109.8931,32.0603]},{"Plant":"Mount Tom","State":"MA","Coal":145.11,"coordinates":[-72.6055,42.2806]},{"Plant":"Somerset Station","State":"MA","Coal":105.6,"coordinates":[-71.146,41.7374]},{"Plant":"Brayton Point","State":"MA","Coal":1095.46,"coordinates":[-71.1931,41.7103]},{"Plant":"Salem Harbor","State":"MA","Coal":304.63,"coordinates":[-70.8772,42.5256]},{"Plant":"GRDA","State":"OK","Coal":1010,"coordinates":[-95.2894,36.1903]},{"Plant":"B C Cobb","State":"MI","Coal":312,"coordinates":[-86.2423,43.2588]},{"Plant":"Dan E Karn","State":"MI","Coal":515,"coordinates":[-83.8401,43.645]},{"Plant":"J H Campbell","State":"MI","Coal":1435,"coordinates":[-86.2007,42.9103]},{"Plant":"J C Weadock","State":"MI","Coal":310,"coordinates":[-83.8447,43.6399]},{"Plant":"J R Whiting","State":"MI","Coal":326,"coordinates":[-83.4495,41.7921]},{"Plant":"Harbor Beach","State":"MI","Coal":103,"coordinates":[-82.6436,43.8519]},{"Plant":"Marysville","State":"MI","Coal":201,"coordinates":[-82.4606,42.9256]},{"Plant":"Monroe","State":"MI","Coal":3045,"coordinates":[-83.3464,41.8906]},{"Plant":"River Rouge","State":"MI","Coal":510,"coordinates":[-83.1119,42.2739]},{"Plant":"St Clair","State":"MI","Coal":1415,"coordinates":[-82.4719,42.7642]},{"Plant":"Trenton Channel","State":"MI","Coal":730,"coordinates":[-83.1808,42.1217]},{"Plant":"Presque Isle","State":"MI","Coal":618,"coordinates":[-87.395,46.5789]},{"Plant":"Eckert Station","State":"MI","Coal":337.6,"coordinates":[-84.5581,42.7184]},{"Plant":"Erickson Station","State":"MI","Coal":157.1,"coordinates":[-84.6572,42.6922]},{"Plant":"Syl Laskin","State":"MN","Coal":110,"coordinates":[-92.1619,47.5306]},{"Plant":"Clay Boswell","State":"MN","Coal":913.71,"coordinates":[-93.6528,47.2611]},{"Plant":"Black Dog","State":"MN","Coal":356.71,"coordinates":[-93.2501,44.8108]},{"Plant":"High Bridge","State":"MN","Coal":269,"coordinates":[-93.1117,44.9314]},{"Plant":"Allen S King","State":"MN","Coal":573,"coordinates":[-92.7786,45.03]},{"Plant":"Riverside","State":"MN","Coal":387.1,"coordinates":[-93.2753,45.0203]},{"Plant":"Hoot Lake","State":"MN","Coal":153.2,"coordinates":[-96.0433,46.2906]},{"Plant":"Silver Lake","State":"MN","Coal":110.2,"coordinates":[-92.4604,44.0282]},{"Plant":"Jack Watson","State":"MS","Coal":775,"coordinates":[-89.0286,30.4392]},{"Plant":"St Johns River Power Park","State":"FL","Coal":1252,"coordinates":[-81.5508,30.4308]},{"Plant":"Asbury","State":"MO","Coal":210,"coordinates":[-94.5893,37.3613]},{"Plant":"Hawthorn","State":"MO","Coal":565,"coordinates":[-94.4778,39.1306]},{"Plant":"Montrose","State":"MO","Coal":510,"coordinates":[-93.9348,38.3114]},{"Plant":"Sibley","State":"MO","Coal":508,"coordinates":[-94.1844,39.1783]},{"Plant":"Labadie","State":"MO","Coal":2421,"coordinates":[-90.8377,38.5622]},{"Plant":"Meramec","State":"MO","Coal":821,"coordinates":[-90.3358,38.4017]},{"Plant":"Sioux","State":"MO","Coal":978,"coordinates":[-90.2902,38.9155]},{"Plant":"James River Power Station","State":"MO","Coal":236,"coordinates":[-93.2619,37.1086]},{"Plant":"New Madrid","State":"MO","Coal":1160,"coordinates":[-89.5617,36.5147]},{"Plant":"Thomas Hill","State":"MO","Coal":1120,"coordinates":[-92.6381,39.5522]},{"Plant":"J E Corette Plant","State":"MT","Coal":154,"coordinates":[-108.481,45.7756]},{"Plant":"Lon Wright","State":"NE","Coal":120,"coordinates":[-96.4623,41.4281]},{"Plant":"Sheldon","State":"NE","Coal":225,"coordinates":[-96.7847,40.5589]},{"Plant":"North Omaha","State":"NE","Coal":662.8,"coordinates":[-95.9447,41.3291]},{"Plant":"Reid Gardner","State":"NV","Coal":555,"coordinates":[-114.6333,36.6573]},{"Plant":"Mohave","State":"NV","Coal":1580,"coordinates":[-114.5917,35.1458]},{"Plant":"Merrimack","State":"NH","Coal":432.5,"coordinates":[-71.4692,43.1411]},{"Plant":"Schiller","State":"NH","Coal":142.6,"coordinates":[-70.7842,43.0978]},{"Plant":"B L England","State":"NJ","Coal":284,"coordinates":[-74.6364,39.2908]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Coal":608,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Mercer Generating Station","State":"NJ","Coal":648,"coordinates":[-74.7339,40.1792]},{"Plant":"Four Corners","State":"NM","Coal":2040,"coordinates":[-108.4814,36.69]},{"Plant":"San Juan","State":"NM","Coal":1643,"coordinates":[-108.4386,36.8006]},{"Plant":"Danskammer Generating Station","State":"NY","Coal":369,"coordinates":[-73.975,41.5712]},{"Plant":"GMMM Westover","State":"NY","Coal":127.7,"coordinates":[-75.9747,42.1117]},{"Plant":"GMMGreenidge LLC","State":"NY","Coal":162,"coordinates":[-76.9483,42.6789]},{"Plant":"Cayuga Operating Company","State":"NY","Coal":306,"coordinates":[-76.6336,42.6028]},{"Plant":"C R Huntley Generating Station","State":"NY","Coal":816,"coordinates":[-78.93,42.97]},{"Plant":"Dunkirk Generating Plant","State":"NY","Coal":586,"coordinates":[-79.3466,42.4915]},{"Plant":"E C Gaston","State":"AL","Coal":1881,"coordinates":[-86.4581,33.2442]},{"Plant":"Lovett","State":"NY","Coal":363,"coordinates":[-73.9797,41.2578]},{"Plant":"Rochester 7","State":"NY","Coal":252,"coordinates":[-77.6294,43.2689]},{"Plant":"Asheville","State":"NC","Coal":392,"coordinates":[-82.5417,35.4731]},{"Plant":"Cape Fear","State":"NC","Coal":316,"coordinates":[-79.0495,35.595]},{"Plant":"HF Lee Plant","State":"NC","Coal":407,"coordinates":[-78.0878,35.3799]},{"Plant":"Roxboro","State":"NC","Coal":2462,"coordinates":[-79.0731,36.4833]},{"Plant":"L V Sutton Steam","State":"NC","Coal":613,"coordinates":[-77.9853,34.2831]},{"Plant":"W H Weatherspoon","State":"NC","Coal":176,"coordinates":[-78.9755,34.5875]},{"Plant":"G G Allen","State":"NC","Coal":1140,"coordinates":[-81.0122,35.1897]},{"Plant":"Buck","State":"NC","Coal":369,"coordinates":[-80.3767,35.7133]},{"Plant":"Cliffside","State":"NC","Coal":760,"coordinates":[-81.7594,35.22]},{"Plant":"Dan River","State":"NC","Coal":276,"coordinates":[-79.7208,36.4862]},{"Plant":"Marshall","State":"NC","Coal":2090,"coordinates":[-80.9658,35.5975]},{"Plant":"Riverbend","State":"NC","Coal":454,"coordinates":[-80.9742,35.36]},{"Plant":"R M Heskett","State":"ND","Coal":104.1,"coordinates":[-100.8836,46.8669]},{"Plant":"Leland Olds","State":"ND","Coal":669,"coordinates":[-101.3212,47.2808]},{"Plant":"Milton R Young","State":"ND","Coal":705,"coordinates":[-101.2131,47.0659]},{"Plant":"Stanton","State":"ND","Coal":188.2,"coordinates":[-101.3319,47.2866]},{"Plant":"Cardinal","State":"OH","Coal":1800,"coordinates":[-80.6486,40.2522]},{"Plant":"Walter C Beckjord","State":"OH","Coal":1118,"coordinates":[-84.2981,38.9917]},{"Plant":"Miami Fort","State":"OH","Coal":1243,"coordinates":[-84.8036,39.1128]},{"Plant":"FirstEnergy Ashtabula","State":"OH","Coal":420,"coordinates":[-80.7697,41.9086]},{"Plant":"Avon Lake","State":"OH","Coal":721,"coordinates":[-82.0546,41.5045]},{"Plant":"FirstEnergy Eastlake","State":"OH","Coal":1233,"coordinates":[-81.4425,41.6711]},{"Plant":"FirstEnergy Lake Shore","State":"OH","Coal":245,"coordinates":[-81.6419,41.5356]},{"Plant":"Conesville","State":"OH","Coal":1925,"coordinates":[-81.8811,40.1842]},{"Plant":"O H Hutchings","State":"OH","Coal":365,"coordinates":[-84.2921,39.6088]},{"Plant":"J M Stuart","State":"OH","Coal":2340,"coordinates":[-83.6939,38.6361]},{"Plant":"Niles","State":"OH","Coal":216,"coordinates":[-80.7477,41.1669]},{"Plant":"FirstEnergy R E Burger","State":"OH","Coal":406,"coordinates":[-80.7608,39.91]},{"Plant":"FirstEnergy W H Sammis","State":"OH","Coal":2220,"coordinates":[-80.6319,40.5317]},{"Plant":"FirstEnergy Toronto","State":"OH","Coal":172,"coordinates":[-80.6044,40.4825]},{"Plant":"Muskingum River","State":"OH","Coal":1365,"coordinates":[-81.6797,39.5908]},{"Plant":"Kyger Creek","State":"OH","Coal":985.7,"coordinates":[-82.1289,38.9144]},{"Plant":"FirstEnergy Bay Shore","State":"OH","Coal":495,"coordinates":[-83.4378,41.6917]},{"Plant":"Lake Road","State":"OH","Coal":160,"coordinates":[-81.6494,41.5278]},{"Plant":"Muskogee","State":"OK","Coal":1516.5,"coordinates":[-95.2873,35.7614]},{"Plant":"Northeastern","State":"OK","Coal":945,"coordinates":[-95.7008,36.4317]},{"Plant":"Limestone","State":"TX","Coal":1602,"coordinates":[-96.2525,31.4219]},{"Plant":"Barry","State":"AL","Coal":1658,"coordinates":[-88.0103,31.0069]},{"Plant":"F R Phillips","State":"PA","Coal":310,"coordinates":[-80.2286,40.5758]},{"Plant":"Portland","State":"PA","Coal":401,"coordinates":[-75.0794,40.9102]},{"Plant":"Titus","State":"PA","Coal":243,"coordinates":[-75.9081,40.3056]},{"Plant":"Conemaugh","State":"PA","Coal":1700,"coordinates":[-79.0611,40.3842]},{"Plant":"Homer City Generating Station","State":"PA","Coal":1884,"coordinates":[-79.1961,40.5128]},{"Plant":"Seward","State":"PA","Coal":196,"coordinates":[-79.0337,40.4062]},{"Plant":"Shawville","State":"PA","Coal":597,"coordinates":[-78.3662,41.0675]},{"Plant":"Keystone","State":"PA","Coal":1700,"coordinates":[-79.3411,40.6604]},{"Plant":"New Castle Plant","State":"PA","Coal":413,"coordinates":[-80.369,40.9379]},{"Plant":"Brunner Island","State":"PA","Coal":1448,"coordinates":[-76.6962,40.0961]},{"Plant":"PPL Martins Creek","State":"PA","Coal":280,"coordinates":[-75.1054,40.7978]},{"Plant":"PPL Montour","State":"PA","Coal":1540,"coordinates":[-76.6672,41.0714]},{"Plant":"Sunbury Generation LP","State":"PA","Coal":361,"coordinates":[-76.825,40.8361]},{"Plant":"Cromby Generating Station","State":"PA","Coal":144,"coordinates":[-75.5294,40.1531]},{"Plant":"Eddystone Generating Station","State":"PA","Coal":581,"coordinates":[-75.323,39.858]},{"Plant":"FirstEnergy Armstrong Power Station","State":"PA","Coal":343,"coordinates":[-79.4656,40.9292]},{"Plant":"Hatfields Ferry Power Station","State":"PA","Coal":1590,"coordinates":[-79.9275,39.8556]},{"Plant":"FirstEnergy Mitchell Power Station","State":"PA","Coal":277,"coordinates":[-79.9683,40.2211]},{"Plant":"H B Robinson","State":"SC","Coal":174,"coordinates":[-80.1589,34.4017]},{"Plant":"W S Lee","State":"SC","Coal":370,"coordinates":[-82.435,34.6022]},{"Plant":"Canadys Steam","State":"SC","Coal":396,"coordinates":[-80.6228,33.0647]},{"Plant":"McMeekin","State":"SC","Coal":250,"coordinates":[-81.2172,34.0556]},{"Plant":"Wateree","State":"SC","Coal":700,"coordinates":[-80.6228,33.8264]},{"Plant":"Williams","State":"SC","Coal":615,"coordinates":[-79.9297,33.0158]},{"Plant":"Dolphus M Grainger","State":"SC","Coal":170,"coordinates":[-79.0533,33.8264]},{"Plant":"Jefferies","State":"SC","Coal":306,"coordinates":[-79.9875,33.2422]},{"Plant":"Allen Steam Plant","State":"TN","Coal":741,"coordinates":[-90.1487,35.0741]},{"Plant":"Bull Run","State":"TN","Coal":865,"coordinates":[-84.1567,36.0211]},{"Plant":"Cumberland","State":"TN","Coal":2465,"coordinates":[-87.6539,36.3903]},{"Plant":"Gallatin","State":"TN","Coal":976,"coordinates":[-86.4006,36.3156]},{"Plant":"John Sevier","State":"TN","Coal":704,"coordinates":[-82.9639,36.3767]},{"Plant":"Johnsonville","State":"TN","Coal":1206,"coordinates":[-87.9861,36.0278]},{"Plant":"Kingston","State":"TN","Coal":1428,"coordinates":[-84.5194,35.8992]},{"Plant":"Watts Bar Fossil","State":"TN","Coal":224,"coordinates":[-84.7811,35.6108]},{"Plant":"W A Parish","State":"TX","Coal":2462,"coordinates":[-95.6311,29.4828]},{"Plant":"Big Brown","State":"TX","Coal":1130,"coordinates":[-96.0544,31.8206]},{"Plant":"Carbon","State":"UT","Coal":172,"coordinates":[-110.8644,39.7272]},{"Plant":"Clinch River","State":"VA","Coal":690,"coordinates":[-82.1997,36.9333]},{"Plant":"Glen Lyn","State":"VA","Coal":325,"coordinates":[-80.8633,37.3706]},{"Plant":"Potomac River","State":"VA","Coal":482,"coordinates":[-77.0411,38.8203]},{"Plant":"Bremo Bluff","State":"VA","Coal":227,"coordinates":[-78.2878,37.7089]},{"Plant":"Chesterfield","State":"VA","Coal":1234,"coordinates":[-77.3833,37.3822]},{"Plant":"Chesapeake","State":"VA","Coal":595,"coordinates":[-76.3019,36.7711]},{"Plant":"Yorktown","State":"VA","Coal":326,"coordinates":[-76.4611,37.2144]},{"Plant":"Joliet 29","State":"IL","Coal":1036,"coordinates":[-88.1238,41.4946]},{"Plant":"Transalta Centralia Generation","State":"WA","Coal":1405,"coordinates":[-122.8598,46.7559]},{"Plant":"John E Amos","State":"WV","Coal":2900,"coordinates":[-81.8233,38.4731]},{"Plant":"Kanawha River","State":"WV","Coal":390,"coordinates":[-81.4211,38.2056]},{"Plant":"Philip Sporn","State":"WV","Coal":1020,"coordinates":[-81.9231,38.9669]},{"Plant":"FirstEnergy Albright","State":"WV","Coal":283,"coordinates":[-79.6369,39.4886]},{"Plant":"FirstEnergy Fort Martin Power Station","State":"WV","Coal":1107,"coordinates":[-79.9275,39.7108]},{"Plant":"FirstEnergy Harrison Power Station","State":"WV","Coal":1933,"coordinates":[-80.3325,39.3842]},{"Plant":"FirstEnergy Rivesville","State":"WV","Coal":137,"coordinates":[-80.1131,39.5314]},{"Plant":"FirstEnergy Willow Island","State":"WV","Coal":235,"coordinates":[-81.3,39.3672]},{"Plant":"Kammer","State":"WV","Coal":600,"coordinates":[-80.8186,39.8461]},{"Plant":"Mitchell","State":"WV","Coal":1600,"coordinates":[-80.8153,39.8297]},{"Plant":"Mt Storm","State":"WV","Coal":1569,"coordinates":[-79.2636,39.2008]},{"Plant":"Blount Street","State":"WI","Coal":194.1,"coordinates":[-89.3744,43.0789]},{"Plant":"Port Washington Generating Station","State":"WI","Coal":305,"coordinates":[-87.8689,43.3842]},{"Plant":"South Oak Creek","State":"WI","Coal":1135,"coordinates":[-87.8294,42.8457]},{"Plant":"Valley","State":"WI","Coal":267,"coordinates":[-87.9233,43.0303]},{"Plant":"Edgewater","State":"WI","Coal":830.83,"coordinates":[-87.7059,43.7151]},{"Plant":"Nelson Dewey Coal Refining Facility","State":"WI","Coal":218.22,"coordinates":[-91.0085,42.7225]},{"Plant":"Pulliam","State":"WI","Coal":389.7,"coordinates":[-88.0086,44.54]},{"Plant":"Weston","State":"WI","Coal":485.8,"coordinates":[-89.6553,44.8606]},{"Plant":"Alma","State":"WI","Coal":192.77,"coordinates":[-91.9111,44.3083]},{"Plant":"Genoa","State":"WI","Coal":349.31,"coordinates":[-91.2325,43.5589]},{"Plant":"Dave Johnston","State":"WY","Coal":762,"coordinates":[-105.7769,42.8378]},{"Plant":"Naughton","State":"WY","Coal":700,"coordinates":[-110.5983,41.7581]},{"Plant":"John P Madgett","State":"WI","Coal":365.7,"coordinates":[-91.9126,44.3036]},{"Plant":"Arapahoe","State":"CO","Coal":246,"coordinates":[-105.0028,39.67]},{"Plant":"Cherokee","State":"CO","Coal":717,"coordinates":[-104.9645,39.8073]},{"Plant":"Colbert","State":"AL","Coal":1167,"coordinates":[-87.8486,34.7439]},{"Plant":"Comanche","State":"CO","Coal":660,"coordinates":[-104.5747,38.2081]},{"Plant":"Valmont","State":"CO","Coal":186,"coordinates":[-105.202,40.0195]},{"Plant":"Martin Drake","State":"CO","Coal":259,"coordinates":[-104.8333,38.8244]},{"Plant":"Navajo","State":"AZ","Coal":2250,"coordinates":[-111.3886,36.9047]},{"Plant":"Widows Creek","State":"AL","Coal":1603,"coordinates":[-85.7553,34.883]},{"Plant":"G F Weaton Power Station","State":"PA","Coal":112,"coordinates":[-80.3462,40.6673]},{"Plant":"International Paper Savanna Mill","State":"GA","Coal":189.09,"coordinates":[-81.1242,32.1004]},{"Plant":"Tennessee Eastman Operations","State":"TN","Coal":194.3,"coordinates":[-82.5431,36.5219]},{"Plant":"Axiall Natrium Plant","State":"WV","Coal":123,"coordinates":[-80.8547,39.7475]},{"Plant":"Northampton Generating Company LP","State":"PA","Coal":112,"coordinates":[-75.4792,40.6917]},{"Plant":"Indiantown Cogeneration LP","State":"FL","Coal":330,"coordinates":[-80.5125,27.0389]},{"Plant":"Dolet Hills","State":"LA","Coal":650,"coordinates":[-93.5692,32.0306]},{"Plant":"Mecklenburg Power Station","State":"VA","Coal":132,"coordinates":[-78.53,36.6]},{"Plant":"Sandow No 5","State":"TX","Coal":363,"coordinates":[-97.0614,30.5681]},{"Plant":"Hayden","State":"CO","Coal":446,"coordinates":[-107.185,40.4856]},{"Plant":"Roanoke Valley Energy Facililty I","State":"NC","Coal":165,"coordinates":[-77.6167,36.4364]},{"Plant":"Spruance Genco LLC","State":"VA","Coal":190,"coordinates":[-77.4308,37.4556]},{"Plant":"Birchwood Power","State":"VA","Coal":237.8,"coordinates":[-77.3147,38.2667]},{"Plant":"Red Hills Generating Facility","State":"MS","Coal":440,"coordinates":[-89.2183,33.3761]},{"Plant":"Charles R Lowman","State":"AL","Coal":547,"coordinates":[-87.9107,31.488]},{"Plant":"Stanton Energy Center","State":"FL","Coal":886,"coordinates":[-81.1678,28.4822]},{"Plant":"Bridgeport Station","State":"CT","Coal":372.2,"coordinates":[-73.1844,41.1706]},{"Plant":"Edge Moor","State":"DE","Coal":260,"coordinates":[-75.5038,39.7389]},{"Plant":"Indian River Generating Station","State":"DE","Coal":767,"coordinates":[-75.2341,38.5857]},{"Plant":"James H Miller Jr","State":"AL","Coal":2741.8,"coordinates":[-87.0597,33.6319]},{"Plant":"FirstEnergy Pleasants Power Station","State":"WV","Coal":1278,"coordinates":[-81.2944,39.3667]},{"Plant":"White Bluff","State":"AR","Coal":1635,"coordinates":[-92.1406,34.4228]},{"Plant":"Duck Creek","State":"IL","Coal":366,"coordinates":[-89.9841,40.4663]},{"Plant":"Newton","State":"IL","Coal":1126,"coordinates":[-88.2781,38.9361]},{"Plant":"East Bend","State":"KY","Coal":600,"coordinates":[-84.8514,38.9036]},{"Plant":"W H Zimmer","State":"OH","Coal":1300,"coordinates":[-84.2289,38.8675]},{"Plant":"Brandon Shores","State":"MD","Coal":1286,"coordinates":[-76.5389,39.18]},{"Plant":"Craig","State":"CO","Coal":1264,"coordinates":[-107.5912,40.4627]},{"Plant":"Coal Creek","State":"ND","Coal":1114,"coordinates":[-101.1571,47.3777]},{"Plant":"Killen Station","State":"OH","Coal":600,"coordinates":[-83.4803,38.6903]},{"Plant":"Belle River","State":"MI","Coal":1260,"coordinates":[-82.495,42.7756]},{"Plant":"H L Spurlock","State":"KY","Coal":850,"coordinates":[-83.8181,38.7]},{"Plant":"Wansley","State":"GA","Coal":1778,"coordinates":[-85.0323,33.4134]},{"Plant":"Big Cajun 2","State":"LA","Coal":1730,"coordinates":[-91.3692,30.7261]},{"Plant":"R D Morrow","State":"MS","Coal":400,"coordinates":[-89.394,31.2186]},{"Plant":"Nearman Creek","State":"KS","Coal":235,"coordinates":[-94.6975,39.1681]},{"Plant":"Iatan","State":"MO","Coal":670,"coordinates":[-94.98,39.4472]},{"Plant":"Jeffrey Energy Center","State":"KS","Coal":2213,"coordinates":[-96.1172,39.2865]},{"Plant":"Trimble County","State":"KY","Coal":509,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Coal":1056,"coordinates":[-88.5553,30.5322]},{"Plant":"Colstrip","State":"MT","Coal":2094,"coordinates":[-106.614,45.8831]},{"Plant":"Gerald Gentleman","State":"NE","Coal":1365,"coordinates":[-101.1408,41.0808]},{"Plant":"Somerset Operating Co LLC","State":"NY","Coal":684,"coordinates":[-78.6047,43.3589]},{"Plant":"R M Schahfer","State":"IN","Coal":1625,"coordinates":[-87.0261,41.2164]},{"Plant":"Sherburne County","State":"MN","Coal":2302,"coordinates":[-93.8931,45.3808]},{"Plant":"FirstEnergy Bruce Mansfield","State":"PA","Coal":2360,"coordinates":[-80.4159,40.6348]},{"Plant":"Sooner","State":"OK","Coal":1019.1,"coordinates":[-97.0528,36.4531]},{"Plant":"Nebraska City","State":"NE","Coal":646,"coordinates":[-95.7764,40.6214]},{"Plant":"Big Stone","State":"SD","Coal":454.8,"coordinates":[-96.5101,45.3037]},{"Plant":"Wyodak","State":"WY","Coal":335,"coordinates":[-105.3815,44.2901]},{"Plant":"Boardman","State":"OR","Coal":556.3,"coordinates":[-119.8088,45.6932]},{"Plant":"Gibson","State":"IN","Coal":3131,"coordinates":[-87.7658,38.3722]},{"Plant":"McIntosh","State":"GA","Coal":155,"coordinates":[-81.1683,32.3563]},{"Plant":"Gibbons Creek","State":"TX","Coal":462,"coordinates":[-96.0818,30.6199]},{"Plant":"A B Brown","State":"IN","Coal":500,"coordinates":[-87.715,37.9053]},{"Plant":"Flint Creek","State":"AR","Coal":480,"coordinates":[-94.5241,36.2561]},{"Plant":"Welsh","State":"TX","Coal":1584,"coordinates":[-94.84,33.0552]},{"Plant":"Martin Lake","State":"TX","Coal":2250,"coordinates":[-94.5706,32.2606]},{"Plant":"Monticello","State":"TX","Coal":1875,"coordinates":[-95.0417,33.0917]},{"Plant":"Rush Island","State":"MO","Coal":1194,"coordinates":[-90.2632,38.1312]},{"Plant":"Hunter","State":"UT","Coal":1320,"coordinates":[-111.0289,39.1747]},{"Plant":"Rockport","State":"IN","Coal":2600,"coordinates":[-87.0372,37.9256]},{"Plant":"Pleasant Prairie","State":"WI","Coal":1224,"coordinates":[-87.9033,42.5381]},{"Plant":"Coronado","State":"AZ","Coal":785,"coordinates":[-109.2708,34.5789]},{"Plant":"Coleto Creek","State":"TX","Coal":632,"coordinates":[-97.2142,28.7128]},{"Plant":"Fayette Power Project","State":"TX","Coal":1605,"coordinates":[-96.7506,29.9172]},{"Plant":"J T Deely","State":"TX","Coal":810,"coordinates":[-98.3228,29.3081]},{"Plant":"San Miguel","State":"TX","Coal":391,"coordinates":[-98.4775,28.7044]},{"Plant":"Brame Energy Center","State":"LA","Coal":523,"coordinates":[-92.7167,31.395]},{"Plant":"Harrington","State":"TX","Coal":1066,"coordinates":[-101.7472,35.2982]},{"Plant":"Tolk","State":"TX","Coal":1080,"coordinates":[-102.57,34.1865]},{"Plant":"John Twitty Energy Center","State":"MO","Coal":178,"coordinates":[-93.388,37.1517]},{"Plant":"Laramie River Station","State":"WY","Coal":1650,"coordinates":[-104.8825,42.1089]},{"Plant":"Merom","State":"IN","Coal":1000,"coordinates":[-87.5108,39.0694]},{"Plant":"Pawnee","State":"CO","Coal":505,"coordinates":[-103.6803,40.2217]},{"Plant":"Winyah","State":"SC","Coal":1155,"coordinates":[-79.3581,33.3317]},{"Plant":"Mayo","State":"NC","Coal":745,"coordinates":[-78.8917,36.5278]},{"Plant":"Ottumwa","State":"IA","Coal":730.57,"coordinates":[-92.5558,41.0961]},{"Plant":"Scherer","State":"GA","Coal":3429.7,"coordinates":[-83.8075,33.0606]},{"Plant":"Mountaineer","State":"WV","Coal":1300,"coordinates":[-81.9344,38.9794]},{"Plant":"Crystal River","State":"FL","Coal":2302,"coordinates":[-82.6977,28.9656]},{"Plant":"Crist","State":"FL","Coal":937,"coordinates":[-87.2244,30.5661]},{"Plant":"Lansing Smith","State":"FL","Coal":351,"coordinates":[-85.7003,30.2686]},{"Plant":"Big Bend","State":"FL","Coal":1712,"coordinates":[-82.4036,27.7944]},{"Plant":"F J Gannon","State":"FL","Coal":508,"coordinates":[-82.4231,27.9072]},{"Plant":"Antelope Valley","State":"ND","Coal":900,"coordinates":[-101.3194,47.2819]},{"Plant":"Intermountain Power Project","State":"UT","Coal":1640,"coordinates":[-112.5802,39.5097]},{"Plant":"Deerhaven Generating Station","State":"FL","Coal":228,"coordinates":[-82.3878,29.7592]},{"Plant":"R D Green","State":"KY","Coal":464,"coordinates":[-87.5,37.6461]},{"Plant":"Independence","State":"AR","Coal":1630,"coordinates":[-91.4088,35.6784]},{"Plant":"Sandow No 4","State":"TX","Coal":553.39,"coordinates":[-97.064,30.5659]},{"Plant":"Louisa","State":"IA","Coal":700,"coordinates":[-91.0931,41.3181]},{"Plant":"Northside Generating Station","State":"FL","Coal":550,"coordinates":[-81.5525,30.4172]},{"Plant":"Warrick","State":"IN","Coal":693,"coordinates":[-87.3328,37.915]},{"Plant":"C D McIntosh Jr","State":"FL","Coal":342,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Coal":270,"coordinates":[-105.0212,40.8609]},{"Plant":"Sikeston Power Station","State":"MO","Coal":233,"coordinates":[-89.6209,36.8791]},{"Plant":"Hugo","State":"OK","Coal":450,"coordinates":[-95.3206,34.0158]},{"Plant":"D B Wilson","State":"KY","Coal":420,"coordinates":[-87.0806,37.4497]},{"Plant":"Gadsden","State":"AL","Coal":130,"coordinates":[-85.9708,34.0128]},{"Plant":"Bowen","State":"GA","Coal":3222,"coordinates":[-84.9222,34.1256]},{"Plant":"Major Oak Power","State":"TX","Coal":305,"coordinates":[-96.695,31.0919]},{"Plant":"Hammond","State":"GA","Coal":846,"coordinates":[-85.3456,34.2528]},{"Plant":"Harllee Branch","State":"GA","Coal":1607,"coordinates":[-83.2983,33.195]},{"Plant":"J K Spruce","State":"TX","Coal":585,"coordinates":[-98.3203,29.3097]},{"Plant":"Jack McDonough","State":"GA","Coal":517,"coordinates":[-84.4758,33.8239]},{"Plant":"Cope","State":"SC","Coal":410,"coordinates":[-81.03,33.3644]},{"Plant":"Clover","State":"VA","Coal":882,"coordinates":[-78.704,36.869]},{"Plant":"Polk","State":"FL","Coal":255,"coordinates":[-81.9897,27.7286]},{"Plant":"Mitchell","State":"GA","Coal":193,"coordinates":[-84.1347,31.4447]},{"Plant":"Yates","State":"GA","Coal":1295,"coordinates":[-84.8986,33.4622]},{"Plant":"Richard Gorsuch","State":"OH","Coal":200,"coordinates":[-81.5211,39.3664]},{"Plant":"Kraft","State":"GA","Coal":316,"coordinates":[-81.1458,32.1486]},{"Plant":"George Neal South","State":"IA","Coal":644,"coordinates":[-96.3617,42.3006]},{"Plant":"Bonanza","State":"UT","Coal":425,"coordinates":[-109.2844,40.0864]},{"Plant":"Pirkey","State":"TX","Coal":580.1,"coordinates":[-94.4852,32.4607]},{"Plant":"Gorgas","State":"AL","Coal":1235,"coordinates":[-87.1965,33.6443]},{"Plant":"Columbia","State":"WI","Coal":1109.16,"coordinates":[-89.4203,43.4864]},{"Plant":"Belews Creek","State":"NC","Coal":2240,"coordinates":[-80.0603,36.2811]},{"Plant":"Jim Bridger","State":"WY","Coal":2120,"coordinates":[-108.7875,41.7378]},{"Plant":"Huntington","State":"UT","Coal":895,"coordinates":[-111.0781,39.3792]},{"Plant":"General James M Gavin","State":"OH","Coal":2600,"coordinates":[-82.1158,38.9347]},{"Plant":"Ray D Nixon","State":"CO","Coal":208,"coordinates":[-104.7058,38.6335]},{"Plant":"Coyote","State":"ND","Coal":427,"coordinates":[-101.8157,47.2214]},{"Plant":"Springerville","State":"AZ","Coal":800,"coordinates":[-109.1639,34.3186]},{"Plant":"North Valmy","State":"NV","Coal":522,"coordinates":[-117.1516,40.8813]},{"Plant":"Cheswick Power Plant","State":"PA","Coal":580,"coordinates":[-79.7906,40.5383]},{"Plant":"E D Edwards","State":"IL","Coal":740,"coordinates":[-89.6631,40.5958]},{"Plant":"Coffeen","State":"IL","Coal":900,"coordinates":[-89.4031,39.0586]},{"Plant":"Hutsonville","State":"IL","Coal":153,"coordinates":[-87.6597,39.1333]},{"Plant":"Meredosia","State":"IL","Coal":327,"coordinates":[-90.5672,39.8233]},{"Plant":"Crawford","State":"IL","Coal":532,"coordinates":[-87.7229,41.8285]},{"Plant":"Escalante","State":"NM","Coal":247,"coordinates":[-108.082,35.4159]},{"Plant":"Joliet 9","State":"IL","Coal":314,"coordinates":[-88.1153,41.4931]},{"Plant":"Kincaid Generation LLC","State":"IL","Coal":1168,"coordinates":[-89.4964,39.5906]},{"Plant":"Powerton","State":"IL","Coal":1538,"coordinates":[-89.6786,40.5408]},{"Plant":"Waukegan","State":"IL","Coal":789,"coordinates":[-87.8133,42.3833]},{"Plant":"Will County","State":"IL","Coal":1060,"coordinates":[-88.0629,41.6334]},{"Plant":"Fisk Street","State":"IL","Coal":326,"coordinates":[-87.6533,41.8508]},{"Plant":"Joppa Steam","State":"IL","Coal":1002,"coordinates":[-88.8589,37.2094]},{"Plant":"Baldwin Energy Complex","State":"IL","Coal":1761,"coordinates":[-89.8544,38.205]},{"Plant":"Havana","State":"IL","Coal":445,"coordinates":[-90.08,40.2797]},{"Plant":"Hennepin Power Station","State":"IL","Coal":289,"coordinates":[-89.315,41.3028]},{"Plant":"Vermilion","State":"IL","Coal":181,"coordinates":[-87.7481,40.1781]},{"Plant":"Wood River","State":"IL","Coal":458,"coordinates":[-90.1347,38.8639]},{"Plant":"Dallman","State":"IL","Coal":372,"coordinates":[-89.6024,39.7548]},{"Plant":"Marion","State":"IL","Coal":290,"coordinates":[-88.9531,37.6197]},{"Plant":"State Line Energy","State":"IN","Coal":515,"coordinates":[-87.5217,41.7072]},{"Plant":"Clifty Creek","State":"IN","Coal":1195.8,"coordinates":[-85.4206,38.7378]},{"Plant":"Tanners Creek","State":"IN","Coal":980,"coordinates":[-84.8594,39.0814]},{"Plant":"Harding Street","State":"IN","Coal":647,"coordinates":[-86.1969,39.7113]},{"Plant":"Eagle Valley","State":"IN","Coal":260,"coordinates":[-86.4183,39.4852]},{"Plant":"AES Petersburg","State":"IN","Coal":1694,"coordinates":[-87.2525,38.5281]},{"Plant":"Bailly","State":"IN","Coal":480,"coordinates":[-87.1225,41.645]},{"Plant":"Dean H Mitchell","State":"IN","Coal":360,"coordinates":[-87.4069,41.6392]},{"Plant":"Michigan City","State":"IN","Coal":469,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Coal":254,"coordinates":[-87.7811,32.6017]},{"Plant":"ACE Cogeneration Facility","State":"CA","Coal":101.2,"coordinates":[-117.3836,35.7658]},{"Plant":"Cayuga","State":"IN","Coal":995,"coordinates":[-87.4244,39.9242]},{"Plant":"RED-Rochester, LLC","State":"NY","Coal":180.8,"coordinates":[-77.6319,43.1989]},{"Plant":"Edwardsport","State":"IN","Coal":120,"coordinates":[-87.2472,38.8067]},{"Plant":"Logan Generating Company LP","State":"NJ","Coal":219,"coordinates":[-75.4067,39.7928]},{"Plant":"Portsmouth Genco LLC","State":"VA","Coal":115,"coordinates":[-76.3529,36.8702]},{"Plant":"Taconite Harbor Energy Center","State":"MN","Coal":200,"coordinates":[-90.9114,47.5314]},{"Plant":"R Gallagher","State":"IN","Coal":560,"coordinates":[-85.8381,38.2636]},{"Plant":"Wabash River","State":"IN","Coal":928,"coordinates":[-87.4247,39.53]},{"Plant":"F B Culley","State":"IN","Coal":402,"coordinates":[-87.3275,37.9111]},{"Plant":"Colver Power Project","State":"PA","Coal":110,"coordinates":[-78.8,40.55]},{"Plant":"Florida Power Development","State":"FL","Coal":139,"coordinates":[-82.4311,28.5819]},{"Plant":"Green Bay West Mill","State":"WI","Coal":110.47,"coordinates":[-88.0303,44.4936]},{"Plant":"CPI USA NC Southport","State":"NC","Coal":107,"coordinates":[-78.0118,33.9444]},{"Plant":"Edgecombe Genco LLC","State":"NC","Coal":105,"coordinates":[-77.7533,36.0373]},{"Plant":"Frank E Ratts","State":"IN","Coal":244,"coordinates":[-87.2662,38.5201]},{"Plant":"Lansing","State":"IA","Coal":291.05,"coordinates":[-91.1675,43.3359]},{"Plant":"4 AC Station","State":"IN","Coal":126.5,"coordinates":[-87.4264,41.68]},{"Plant":"Milton L Kapp","State":"IA","Coal":222.35,"coordinates":[-90.2336,41.8081]},{"Plant":"Chambers Cogeneration LP","State":"NJ","Coal":262,"coordinates":[-75.4858,39.6935]},{"Plant":"AES Shady Point LLC","State":"OK","Coal":320,"coordinates":[-94.6458,35.1931]},{"Plant":"Cedar Bay Generating Company LP","State":"FL","Coal":250,"coordinates":[-81.6064,30.4225]},{"Plant":"AES Hawaii","State":"HI","Coal":180,"coordinates":[-158.1065,21.3034]},{"Plant":"AES Thames","State":"CT","Coal":181,"coordinates":[-72.055,41.2607]},{"Plant":"AES Beaver Valley Partners Beaver Valley","State":"PA","Coal":146,"coordinates":[-80.3539,40.6572]},{"Plant":"AES Warrior Run Cogeneration Facility","State":"MD","Coal":180,"coordinates":[-78.7453,39.5952]},{"Plant":"Prairie Creek","State":"IA","Coal":212.58,"coordinates":[-91.6392,41.944]},{"Plant":"Sutherland","State":"IA","Coal":142.42,"coordinates":[-92.8594,42.0473]},{"Plant":"Holcomb","State":"KS","Coal":360,"coordinates":[-100.9725,37.9308]},{"Plant":"Riverside","State":"IA","Coal":135,"coordinates":[-90.4481,41.54]},{"Plant":"Walter Scott Jr Energy Center","State":"IA","Coal":823,"coordinates":[-95.8408,41.18]},{"Plant":"Silver Bay Power","State":"MN","Coal":105,"coordinates":[-91.2605,47.2866]},{"Plant":"Archer Daniels Midland Cedar Rapids","State":"IA","Coal":260,"coordinates":[-91.6875,41.9221]},{"Plant":"Archer Daniels Midland Decatur","State":"IL","Coal":230,"coordinates":[-88.8908,39.8701]},{"Plant":"George Neal North","State":"IA","Coal":950,"coordinates":[-96.3617,42.2998]},{"Plant":"Burlington","State":"IA","Coal":214.93,"coordinates":[-91.1167,40.7412]},{"Plant":"Ames Electric Services Power Plant","State":"IA","Coal":103,"coordinates":[-93.6089,42.0258]},{"Plant":"Cholla","State":"AZ","Coal":995,"coordinates":[-110.3033,34.9394]},{"Plant":"Muscatine Plant #1","State":"IA","Coal":236.9,"coordinates":[-91.0569,41.3917]},{"Plant":"La Cygne","State":"KS","Coal":1362,"coordinates":[-94.6456,38.3481]},{"Plant":"Lawrence Energy Center","State":"KS","Coal":593,"coordinates":[-95.2692,39.0072]},{"Plant":"Tecumseh Energy Center","State":"KS","Coal":204,"coordinates":[-95.5689,39.0539]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Coal":156,"coordinates":[-110.9047,32.16]},{"Plant":"Oklaunion","State":"TX","Coal":690,"coordinates":[-99.1753,34.0825]},{"Plant":"Quindaro","State":"KS","Coal":190.6,"coordinates":[-94.6381,39.1492]},{"Plant":"Cross","State":"SC","Coal":1160,"coordinates":[-80.1119,33.3692]},{"Plant":"Big Sandy","State":"KY","Coal":1060,"coordinates":[-82.6176,38.1707]},{"Plant":"E W Brown","State":"KY","Coal":697,"coordinates":[-84.7126,37.7883]},{"Plant":"Ghent","State":"KY","Coal":1945,"coordinates":[-85.035,38.7497]},{"Plant":"Green River","State":"KY","Coal":207,"coordinates":[-87.1214,37.3636]},{"Plant":"Seminole","State":"FL","Coal":1316,"coordinates":[-81.6328,29.7331]},{"Plant":"Cane Run","State":"KY","Coal":563,"coordinates":[-85.8892,38.1831]},{"Plant":"Mill Creek","State":"KY","Coal":1472,"coordinates":[-85.9103,38.0525]},{"Plant":"Elmer Smith","State":"KY","Coal":405.1,"coordinates":[-87.0608,37.7942]},{"Plant":"Paradise","State":"KY","Coal":2201,"coordinates":[-86.9783,37.2608]},{"Plant":"Shawnee","State":"KY","Coal":1330,"coordinates":[-88.775,37.1517]},{"Plant":"HMP&L Station Two Henderson","State":"KY","Coal":312,"coordinates":[-87.5028,37.6469]},{"Plant":"Cooper","State":"KY","Coal":341,"coordinates":[-84.5919,36.9981]},{"Plant":"Dale","State":"KY","Coal":196,"coordinates":[-84.2619,37.8806]},{"Plant":"R S Nelson","State":"LA","Coal":550,"coordinates":[-93.2911,30.2844]},{"Plant":"C P Crane","State":"MD","Coal":385,"coordinates":[-76.3651,39.3236]},{"Plant":"Herbert A Wagner","State":"MD","Coal":459,"coordinates":[-76.5268,39.1781]},{"Plant":"FirstEnergy R Paul Smith Power Station","State":"MD","Coal":115,"coordinates":[-77.8269,39.595]},{"Plant":"Dickerson","State":"MD","Coal":546,"coordinates":[-77.4644,39.2097]},{"Plant":"Apache Station","State":"AZ","Coal":350,"coordinates":[-109.8931,32.0603]},{"Plant":"Mount Tom","State":"MA","Coal":145.11,"coordinates":[-72.6055,42.2806]},{"Plant":"Somerset Station","State":"MA","Coal":179.1,"coordinates":[-71.146,41.7374]},{"Plant":"Brayton Point","State":"MA","Coal":1078.11,"coordinates":[-71.1931,41.7103]},{"Plant":"Salem Harbor","State":"MA","Coal":311.79,"coordinates":[-70.8772,42.5256]},{"Plant":"GRDA","State":"OK","Coal":1010,"coordinates":[-95.2894,36.1903]},{"Plant":"B C Cobb","State":"MI","Coal":312,"coordinates":[-86.2423,43.2588]},{"Plant":"Dan E Karn","State":"MI","Coal":515,"coordinates":[-83.8401,43.645]},{"Plant":"J H Campbell","State":"MI","Coal":1435,"coordinates":[-86.2007,42.9103]},{"Plant":"J C Weadock","State":"MI","Coal":302,"coordinates":[-83.8447,43.6399]},{"Plant":"J R Whiting","State":"MI","Coal":328,"coordinates":[-83.4495,41.7921]},{"Plant":"Harbor Beach","State":"MI","Coal":103,"coordinates":[-82.6436,43.8519]},{"Plant":"Marysville","State":"MI","Coal":201,"coordinates":[-82.4606,42.9256]},{"Plant":"Monroe","State":"MI","Coal":3080,"coordinates":[-83.3464,41.8906]},{"Plant":"River Rouge","State":"MI","Coal":510,"coordinates":[-83.1119,42.2739]},{"Plant":"St Clair","State":"MI","Coal":1415,"coordinates":[-82.4719,42.7642]},{"Plant":"Trenton Channel","State":"MI","Coal":730,"coordinates":[-83.1808,42.1217]},{"Plant":"Presque Isle","State":"MI","Coal":618,"coordinates":[-87.395,46.5789]},{"Plant":"Eckert Station","State":"MI","Coal":338.4,"coordinates":[-84.5581,42.7184]},{"Plant":"Erickson Station","State":"MI","Coal":153.5,"coordinates":[-84.6572,42.6922]},{"Plant":"Syl Laskin","State":"MN","Coal":110,"coordinates":[-92.1619,47.5306]},{"Plant":"Clay Boswell","State":"MN","Coal":917.2,"coordinates":[-93.6528,47.2611]},{"Plant":"Black Dog","State":"MN","Coal":356.71,"coordinates":[-93.2501,44.8108]},{"Plant":"High Bridge","State":"MN","Coal":269,"coordinates":[-93.1117,44.9314]},{"Plant":"Allen S King","State":"MN","Coal":573,"coordinates":[-92.7786,45.03]},{"Plant":"Riverside","State":"MN","Coal":387.1,"coordinates":[-93.2753,45.0203]},{"Plant":"Hoot Lake","State":"MN","Coal":152.4,"coordinates":[-96.0433,46.2906]},{"Plant":"Silver Lake","State":"MN","Coal":110.2,"coordinates":[-92.4604,44.0282]},{"Plant":"Jack Watson","State":"MS","Coal":775,"coordinates":[-89.0286,30.4392]},{"Plant":"St Johns River Power Park","State":"FL","Coal":1252,"coordinates":[-81.5508,30.4308]},{"Plant":"Asbury","State":"MO","Coal":210,"coordinates":[-94.5893,37.3613]},{"Plant":"Hawthorn","State":"MO","Coal":565,"coordinates":[-94.4778,39.1306]},{"Plant":"Montrose","State":"MO","Coal":510,"coordinates":[-93.9348,38.3114]},{"Plant":"Sibley","State":"MO","Coal":508,"coordinates":[-94.1844,39.1783]},{"Plant":"Labadie","State":"MO","Coal":2421,"coordinates":[-90.8377,38.5622]},{"Plant":"Meramec","State":"MO","Coal":821,"coordinates":[-90.3358,38.4017]},{"Plant":"Sioux","State":"MO","Coal":978,"coordinates":[-90.2902,38.9155]},{"Plant":"James River Power Station","State":"MO","Coal":236,"coordinates":[-93.2619,37.1086]},{"Plant":"New Madrid","State":"MO","Coal":1160,"coordinates":[-89.5617,36.5147]},{"Plant":"Thomas Hill","State":"MO","Coal":1120,"coordinates":[-92.6381,39.5522]},{"Plant":"J E Corette Plant","State":"MT","Coal":154,"coordinates":[-108.481,45.7756]},{"Plant":"Lon Wright","State":"NE","Coal":120,"coordinates":[-96.4623,41.4281]},{"Plant":"Sheldon","State":"NE","Coal":225,"coordinates":[-96.7847,40.5589]},{"Plant":"North Omaha","State":"NE","Coal":662.8,"coordinates":[-95.9447,41.3291]},{"Plant":"Reid Gardner","State":"NV","Coal":555,"coordinates":[-114.6333,36.6573]},{"Plant":"Mohave","State":"NV","Coal":1580,"coordinates":[-114.5917,35.1458]},{"Plant":"Merrimack","State":"NH","Coal":432.5,"coordinates":[-71.4692,43.1411]},{"Plant":"Schiller","State":"NH","Coal":142.6,"coordinates":[-70.7842,43.0978]},{"Plant":"B L England","State":"NJ","Coal":284,"coordinates":[-74.6364,39.2908]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Coal":608,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Mercer Generating Station","State":"NJ","Coal":648,"coordinates":[-74.7339,40.1792]},{"Plant":"Four Corners","State":"NM","Coal":2040,"coordinates":[-108.4814,36.69]},{"Plant":"San Juan","State":"NM","Coal":1643,"coordinates":[-108.4386,36.8006]},{"Plant":"Danskammer Generating Station","State":"NY","Coal":369,"coordinates":[-73.975,41.5712]},{"Plant":"GMMM Westover","State":"NY","Coal":127.7,"coordinates":[-75.9747,42.1117]},{"Plant":"GMMGreenidge LLC","State":"NY","Coal":158.5,"coordinates":[-76.9483,42.6789]},{"Plant":"Cayuga Operating Company","State":"NY","Coal":306,"coordinates":[-76.6336,42.6028]},{"Plant":"C R Huntley Generating Station","State":"NY","Coal":816,"coordinates":[-78.93,42.97]},{"Plant":"Dunkirk Generating Plant","State":"NY","Coal":572,"coordinates":[-79.3466,42.4915]},{"Plant":"E C Gaston","State":"AL","Coal":1881,"coordinates":[-86.4581,33.2442]},{"Plant":"Lovett","State":"NY","Coal":363,"coordinates":[-73.9797,41.2578]},{"Plant":"Rochester 7","State":"NY","Coal":252,"coordinates":[-77.6294,43.2689]},{"Plant":"Asheville","State":"NC","Coal":392,"coordinates":[-82.5417,35.4731]},{"Plant":"Cape Fear","State":"NC","Coal":316,"coordinates":[-79.0495,35.595]},{"Plant":"HF Lee Plant","State":"NC","Coal":407,"coordinates":[-78.0878,35.3799]},{"Plant":"Roxboro","State":"NC","Coal":2462,"coordinates":[-79.0731,36.4833]},{"Plant":"L V Sutton Steam","State":"NC","Coal":613,"coordinates":[-77.9853,34.2831]},{"Plant":"W H Weatherspoon","State":"NC","Coal":176,"coordinates":[-78.9755,34.5875]},{"Plant":"G G Allen","State":"NC","Coal":1145,"coordinates":[-81.0122,35.1897]},{"Plant":"Buck","State":"NC","Coal":369,"coordinates":[-80.3767,35.7133]},{"Plant":"Cliffside","State":"NC","Coal":760,"coordinates":[-81.7594,35.22]},{"Plant":"Dan River","State":"NC","Coal":276,"coordinates":[-79.7208,36.4862]},{"Plant":"Marshall","State":"NC","Coal":2110,"coordinates":[-80.9658,35.5975]},{"Plant":"Riverbend","State":"NC","Coal":454,"coordinates":[-80.9742,35.36]},{"Plant":"R M Heskett","State":"ND","Coal":103.8,"coordinates":[-100.8836,46.8669]},{"Plant":"Leland Olds","State":"ND","Coal":669,"coordinates":[-101.3212,47.2808]},{"Plant":"Milton R Young","State":"ND","Coal":705,"coordinates":[-101.2131,47.0659]},{"Plant":"Stanton","State":"ND","Coal":187.7,"coordinates":[-101.3319,47.2866]},{"Plant":"Cardinal","State":"OH","Coal":1800,"coordinates":[-80.6486,40.2522]},{"Plant":"Walter C Beckjord","State":"OH","Coal":1118,"coordinates":[-84.2981,38.9917]},{"Plant":"Miami Fort","State":"OH","Coal":1243,"coordinates":[-84.8036,39.1128]},{"Plant":"FirstEnergy Ashtabula","State":"OH","Coal":420,"coordinates":[-80.7697,41.9086]},{"Plant":"Avon Lake","State":"OH","Coal":721,"coordinates":[-82.0546,41.5045]},{"Plant":"FirstEnergy Eastlake","State":"OH","Coal":1233,"coordinates":[-81.4425,41.6711]},{"Plant":"FirstEnergy Lake Shore","State":"OH","Coal":245,"coordinates":[-81.6419,41.5356]},{"Plant":"Conesville","State":"OH","Coal":1925,"coordinates":[-81.8811,40.1842]},{"Plant":"O H Hutchings","State":"OH","Coal":365,"coordinates":[-84.2921,39.6088]},{"Plant":"J M Stuart","State":"OH","Coal":2340,"coordinates":[-83.6939,38.6361]},{"Plant":"Niles","State":"OH","Coal":216,"coordinates":[-80.7477,41.1669]},{"Plant":"FirstEnergy R E Burger","State":"OH","Coal":518,"coordinates":[-80.7608,39.91]},{"Plant":"FirstEnergy W H Sammis","State":"OH","Coal":2220,"coordinates":[-80.6319,40.5317]},{"Plant":"FirstEnergy Toronto","State":"OH","Coal":172,"coordinates":[-80.6044,40.4825]},{"Plant":"Muskingum River","State":"OH","Coal":1365,"coordinates":[-81.6797,39.5908]},{"Plant":"Kyger Creek","State":"OH","Coal":985.7,"coordinates":[-82.1289,38.9144]},{"Plant":"FirstEnergy Bay Shore","State":"OH","Coal":495,"coordinates":[-83.4378,41.6917]},{"Plant":"Lake Road","State":"OH","Coal":160,"coordinates":[-81.6494,41.5278]},{"Plant":"Muskogee","State":"OK","Coal":1524,"coordinates":[-95.2873,35.7614]},{"Plant":"Northeastern","State":"OK","Coal":945,"coordinates":[-95.7008,36.4317]},{"Plant":"Limestone","State":"TX","Coal":1602,"coordinates":[-96.2525,31.4219]},{"Plant":"Barry","State":"AL","Coal":1658,"coordinates":[-88.0103,31.0069]},{"Plant":"F R Phillips","State":"PA","Coal":310,"coordinates":[-80.2286,40.5758]},{"Plant":"Portland","State":"PA","Coal":401,"coordinates":[-75.0794,40.9102]},{"Plant":"Titus","State":"PA","Coal":243,"coordinates":[-75.9081,40.3056]},{"Plant":"Conemaugh","State":"PA","Coal":1700,"coordinates":[-79.0611,40.3842]},{"Plant":"Homer City Generating Station","State":"PA","Coal":1884,"coordinates":[-79.1961,40.5128]},{"Plant":"Seward","State":"PA","Coal":196,"coordinates":[-79.0337,40.4062]},{"Plant":"Shawville","State":"PA","Coal":597,"coordinates":[-78.3662,41.0675]},{"Plant":"New Castle Plant","State":"PA","Coal":413,"coordinates":[-80.369,40.9379]},{"Plant":"Brunner Island","State":"PA","Coal":1448,"coordinates":[-76.6962,40.0961]},{"Plant":"PPL Martins Creek","State":"PA","Coal":280,"coordinates":[-75.1054,40.7978]},{"Plant":"PPL Montour","State":"PA","Coal":1540,"coordinates":[-76.6672,41.0714]},{"Plant":"Sunbury Generation LP","State":"PA","Coal":361,"coordinates":[-76.825,40.8361]},{"Plant":"Cromby Generating Station","State":"PA","Coal":144,"coordinates":[-75.5294,40.1531]},{"Plant":"Eddystone Generating Station","State":"PA","Coal":581,"coordinates":[-75.323,39.858]},{"Plant":"FirstEnergy Armstrong Power Station","State":"PA","Coal":343,"coordinates":[-79.4656,40.9292]},{"Plant":"Hatfields Ferry Power Station","State":"PA","Coal":1590,"coordinates":[-79.9275,39.8556]},{"Plant":"FirstEnergy Mitchell Power Station","State":"PA","Coal":277,"coordinates":[-79.9683,40.2211]},{"Plant":"H B Robinson","State":"SC","Coal":174,"coordinates":[-80.1589,34.4017]},{"Plant":"W S Lee","State":"SC","Coal":370,"coordinates":[-82.435,34.6022]},{"Plant":"Canadys Steam","State":"SC","Coal":396,"coordinates":[-80.6228,33.0647]},{"Plant":"Wateree","State":"SC","Coal":700,"coordinates":[-80.6228,33.8264]},{"Plant":"Williams","State":"SC","Coal":615,"coordinates":[-79.9297,33.0158]},{"Plant":"Dolphus M Grainger","State":"SC","Coal":170,"coordinates":[-79.0533,33.8264]},{"Plant":"Jefferies","State":"SC","Coal":306,"coordinates":[-79.9875,33.2422]},{"Plant":"Allen Steam Plant","State":"TN","Coal":741,"coordinates":[-90.1487,35.0741]},{"Plant":"Bull Run","State":"TN","Coal":881,"coordinates":[-84.1567,36.0211]},{"Plant":"Cumberland","State":"TN","Coal":2465,"coordinates":[-87.6539,36.3903]},{"Plant":"Gallatin","State":"TN","Coal":976,"coordinates":[-86.4006,36.3156]},{"Plant":"John Sevier","State":"TN","Coal":704,"coordinates":[-82.9639,36.3767]},{"Plant":"Johnsonville","State":"TN","Coal":1206,"coordinates":[-87.9861,36.0278]},{"Plant":"Kingston","State":"TN","Coal":1426,"coordinates":[-84.5194,35.8992]},{"Plant":"Watts Bar Fossil","State":"TN","Coal":224,"coordinates":[-84.7811,35.6108]},{"Plant":"W A Parish","State":"TX","Coal":2462,"coordinates":[-95.6311,29.4828]},{"Plant":"Big Brown","State":"TX","Coal":1150,"coordinates":[-96.0544,31.8206]},{"Plant":"Carbon","State":"UT","Coal":172,"coordinates":[-110.8644,39.7272]},{"Plant":"Clinch River","State":"VA","Coal":690,"coordinates":[-82.1997,36.9333]},{"Plant":"Glen Lyn","State":"VA","Coal":325,"coordinates":[-80.8633,37.3706]},{"Plant":"Potomac River","State":"VA","Coal":482,"coordinates":[-77.0411,38.8203]},{"Plant":"Bremo Bluff","State":"VA","Coal":227,"coordinates":[-78.2878,37.7089]},{"Plant":"Chesterfield","State":"VA","Coal":1234,"coordinates":[-77.3833,37.3822]},{"Plant":"Chesapeake","State":"VA","Coal":595,"coordinates":[-76.3019,36.7711]},{"Plant":"Yorktown","State":"VA","Coal":326,"coordinates":[-76.4611,37.2144]},{"Plant":"Joliet 29","State":"IL","Coal":1036,"coordinates":[-88.1238,41.4946]},{"Plant":"Transalta Centralia Generation","State":"WA","Coal":1405,"coordinates":[-122.8598,46.7559]},{"Plant":"John E Amos","State":"WV","Coal":2900,"coordinates":[-81.8233,38.4731]},{"Plant":"Kanawha River","State":"WV","Coal":390,"coordinates":[-81.4211,38.2056]},{"Plant":"Philip Sporn","State":"WV","Coal":1020,"coordinates":[-81.9231,38.9669]},{"Plant":"FirstEnergy Albright","State":"WV","Coal":283,"coordinates":[-79.6369,39.4886]},{"Plant":"FirstEnergy Fort Martin Power Station","State":"WV","Coal":1107,"coordinates":[-79.9275,39.7108]},{"Plant":"FirstEnergy Harrison Power Station","State":"WV","Coal":1933,"coordinates":[-80.3325,39.3842]},{"Plant":"FirstEnergy Rivesville","State":"WV","Coal":137,"coordinates":[-80.1131,39.5314]},{"Plant":"FirstEnergy Willow Island","State":"WV","Coal":235,"coordinates":[-81.3,39.3672]},{"Plant":"Kammer","State":"WV","Coal":600,"coordinates":[-80.8186,39.8461]},{"Plant":"Mitchell","State":"WV","Coal":1600,"coordinates":[-80.8153,39.8297]},{"Plant":"Mt Storm","State":"WV","Coal":1569,"coordinates":[-79.2636,39.2008]},{"Plant":"Blount Street","State":"WI","Coal":194.1,"coordinates":[-89.3744,43.0789]},{"Plant":"Port Washington Generating Station","State":"WI","Coal":305,"coordinates":[-87.8689,43.3842]},{"Plant":"South Oak Creek","State":"WI","Coal":1135,"coordinates":[-87.8294,42.8457]},{"Plant":"Valley","State":"WI","Coal":267,"coordinates":[-87.9233,43.0303]},{"Plant":"Edgewater","State":"WI","Coal":816.5,"coordinates":[-87.7059,43.7151]},{"Plant":"Nelson Dewey Coal Refining Facility","State":"WI","Coal":219.71,"coordinates":[-91.0085,42.7225]},{"Plant":"Pulliam","State":"WI","Coal":389.8,"coordinates":[-88.0086,44.54]},{"Plant":"Weston","State":"WI","Coal":486,"coordinates":[-89.6553,44.8606]},{"Plant":"Alma","State":"WI","Coal":186.15,"coordinates":[-91.9111,44.3083]},{"Plant":"Genoa","State":"WI","Coal":354.79,"coordinates":[-91.2325,43.5589]},{"Plant":"Dave Johnston","State":"WY","Coal":762,"coordinates":[-105.7769,42.8378]},{"Plant":"Naughton","State":"WY","Coal":700,"coordinates":[-110.5983,41.7581]},{"Plant":"John P Madgett","State":"WI","Coal":397.59,"coordinates":[-91.9126,44.3036]},{"Plant":"Arapahoe","State":"CO","Coal":246,"coordinates":[-105.0028,39.67]},{"Plant":"Cherokee","State":"CO","Coal":717,"coordinates":[-104.9645,39.8073]},{"Plant":"Colbert","State":"AL","Coal":1171,"coordinates":[-87.8486,34.7439]},{"Plant":"Comanche","State":"CO","Coal":660,"coordinates":[-104.5747,38.2081]},{"Plant":"Valmont","State":"CO","Coal":186,"coordinates":[-105.202,40.0195]},{"Plant":"Martin Drake","State":"CO","Coal":259,"coordinates":[-104.8333,38.8244]},{"Plant":"Navajo","State":"AZ","Coal":2250,"coordinates":[-111.3886,36.9047]},{"Plant":"Widows Creek","State":"AL","Coal":1603,"coordinates":[-85.7553,34.883]},{"Plant":"G F Weaton Power Station","State":"PA","Coal":112,"coordinates":[-80.3462,40.6673]},{"Plant":"International Paper Savanna Mill","State":"GA","Coal":189.09,"coordinates":[-81.1242,32.1004]},{"Plant":"Mobile Energy Services LLC","State":"AL","Coal":124.9,"coordinates":[-88.0516,30.7365]},{"Plant":"Tennessee Eastman Operations","State":"TN","Coal":194.3,"coordinates":[-82.5431,36.5219]},{"Plant":"Axiall Natrium Plant","State":"WV","Coal":123,"coordinates":[-80.8547,39.7475]},{"Plant":"Northampton Generating Company LP","State":"PA","Coal":112,"coordinates":[-75.4792,40.6917]},{"Plant":"Indiantown Cogeneration LP","State":"FL","Coal":330,"coordinates":[-80.5125,27.0389]},{"Plant":"Dolet Hills","State":"LA","Coal":650,"coordinates":[-93.5692,32.0306]},{"Plant":"Mecklenburg Power Station","State":"VA","Coal":132,"coordinates":[-78.53,36.6]},{"Plant":"Sandow No 5","State":"TX","Coal":363,"coordinates":[-97.0614,30.5681]},{"Plant":"Hayden","State":"CO","Coal":446,"coordinates":[-107.185,40.4856]},{"Plant":"Roanoke Valley Energy Facililty I","State":"NC","Coal":165,"coordinates":[-77.6167,36.4364]},{"Plant":"Spruance Genco LLC","State":"VA","Coal":190,"coordinates":[-77.4308,37.4556]},{"Plant":"Birchwood Power","State":"VA","Coal":238.8,"coordinates":[-77.3147,38.2667]},{"Plant":"Red Hills Generating Facility","State":"MS","Coal":440,"coordinates":[-89.2183,33.3761]},{"Plant":"Seward","State":"PA","Coal":521,"coordinates":[-79.038,40.4016]},{"Plant":"Charles R Lowman","State":"AL","Coal":556,"coordinates":[-87.9107,31.488]},{"Plant":"Kennecott Power Plant","State":"UT","Coal":130.1,"coordinates":[-112.1225,40.7119]},{"Plant":"Stanton Energy Center","State":"FL","Coal":886,"coordinates":[-81.1678,28.4822]},{"Plant":"Bridgeport Station","State":"CT","Coal":372.2,"coordinates":[-73.1844,41.1706]},{"Plant":"Edge Moor","State":"DE","Coal":260,"coordinates":[-75.5038,39.7389]},{"Plant":"Indian River Generating Station","State":"DE","Coal":767,"coordinates":[-75.2341,38.5857]},{"Plant":"James H Miller Jr","State":"AL","Coal":2749.8,"coordinates":[-87.0597,33.6319]},{"Plant":"FirstEnergy Pleasants Power Station","State":"WV","Coal":1278,"coordinates":[-81.2944,39.3667]},{"Plant":"White Bluff","State":"AR","Coal":1635,"coordinates":[-92.1406,34.4228]},{"Plant":"Duck Creek","State":"IL","Coal":355,"coordinates":[-89.9841,40.4663]},{"Plant":"Newton","State":"IL","Coal":1126,"coordinates":[-88.2781,38.9361]},{"Plant":"East Bend","State":"KY","Coal":600,"coordinates":[-84.8514,38.9036]},{"Plant":"W H Zimmer","State":"OH","Coal":1300,"coordinates":[-84.2289,38.8675]},{"Plant":"Brandon Shores","State":"MD","Coal":1286,"coordinates":[-76.5389,39.18]},{"Plant":"Craig","State":"CO","Coal":1264,"coordinates":[-107.5912,40.4627]},{"Plant":"Coal Creek","State":"ND","Coal":1112,"coordinates":[-101.1571,47.3777]},{"Plant":"Killen Station","State":"OH","Coal":600,"coordinates":[-83.4803,38.6903]},{"Plant":"Belle River","State":"MI","Coal":1260,"coordinates":[-82.495,42.7756]},{"Plant":"H L Spurlock","State":"KY","Coal":850,"coordinates":[-83.8181,38.7]},{"Plant":"Wansley","State":"GA","Coal":1778,"coordinates":[-85.0323,33.4134]},{"Plant":"Big Cajun 2","State":"LA","Coal":1730,"coordinates":[-91.3692,30.7261]},{"Plant":"R D Morrow","State":"MS","Coal":360,"coordinates":[-89.394,31.2186]},{"Plant":"Nearman Creek","State":"KS","Coal":232.2,"coordinates":[-94.6975,39.1681]},{"Plant":"Iatan","State":"MO","Coal":671,"coordinates":[-94.98,39.4472]},{"Plant":"Jeffrey Energy Center","State":"KS","Coal":2214,"coordinates":[-96.1172,39.2865]},{"Plant":"Trimble County","State":"KY","Coal":511,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Coal":1056,"coordinates":[-88.5553,30.5322]},{"Plant":"Colstrip","State":"MT","Coal":2094,"coordinates":[-106.614,45.8831]},{"Plant":"Gerald Gentleman","State":"NE","Coal":1365,"coordinates":[-101.1408,41.0808]},{"Plant":"Somerset Operating Co LLC","State":"NY","Coal":680.8,"coordinates":[-78.6047,43.3589]},{"Plant":"R M Schahfer","State":"IN","Coal":1625,"coordinates":[-87.0261,41.2164]},{"Plant":"Sherburne County","State":"MN","Coal":2302,"coordinates":[-93.8931,45.3808]},{"Plant":"FirstEnergy Bruce Mansfield","State":"PA","Coal":2360,"coordinates":[-80.4159,40.6348]},{"Plant":"Sooner","State":"OK","Coal":1020,"coordinates":[-97.0528,36.4531]},{"Plant":"Nebraska City","State":"NE","Coal":646,"coordinates":[-95.7764,40.6214]},{"Plant":"Big Stone","State":"SD","Coal":455,"coordinates":[-96.5101,45.3037]},{"Plant":"Wyodak","State":"WY","Coal":335,"coordinates":[-105.3815,44.2901]},{"Plant":"Boardman","State":"OR","Coal":556.3,"coordinates":[-119.8088,45.6932]},{"Plant":"Gibson","State":"IN","Coal":3131,"coordinates":[-87.7658,38.3722]},{"Plant":"McIntosh","State":"GA","Coal":156.5,"coordinates":[-81.1683,32.3563]},{"Plant":"Gibbons Creek","State":"TX","Coal":462,"coordinates":[-96.0818,30.6199]},{"Plant":"A B Brown","State":"IN","Coal":500,"coordinates":[-87.715,37.9053]},{"Plant":"Flint Creek","State":"AR","Coal":480,"coordinates":[-94.5241,36.2561]},{"Plant":"Welsh","State":"TX","Coal":1584,"coordinates":[-94.84,33.0552]},{"Plant":"Martin Lake","State":"TX","Coal":2250,"coordinates":[-94.5706,32.2606]},{"Plant":"Monticello","State":"TX","Coal":1880,"coordinates":[-95.0417,33.0917]},{"Plant":"Rush Island","State":"MO","Coal":1194,"coordinates":[-90.2632,38.1312]},{"Plant":"Hunter","State":"UT","Coal":1320,"coordinates":[-111.0289,39.1747]},{"Plant":"Rockport","State":"IN","Coal":2600,"coordinates":[-87.0372,37.9256]},{"Plant":"Pleasant Prairie","State":"WI","Coal":1224,"coordinates":[-87.9033,42.5381]},{"Plant":"Coronado","State":"AZ","Coal":785,"coordinates":[-109.2708,34.5789]},{"Plant":"Coleto Creek","State":"TX","Coal":632,"coordinates":[-97.2142,28.7128]},{"Plant":"Fayette Power Project","State":"TX","Coal":1641,"coordinates":[-96.7506,29.9172]},{"Plant":"J T Deely","State":"TX","Coal":810,"coordinates":[-98.3228,29.3081]},{"Plant":"San Miguel","State":"TX","Coal":391,"coordinates":[-98.4775,28.7044]},{"Plant":"Brame Energy Center","State":"LA","Coal":523,"coordinates":[-92.7167,31.395]},{"Plant":"Harrington","State":"TX","Coal":1066,"coordinates":[-101.7472,35.2982]},{"Plant":"Tolk","State":"TX","Coal":1080,"coordinates":[-102.57,34.1865]},{"Plant":"John Twitty Energy Center","State":"MO","Coal":178,"coordinates":[-93.388,37.1517]},{"Plant":"Laramie River Station","State":"WY","Coal":1650,"coordinates":[-104.8825,42.1089]},{"Plant":"Merom","State":"IN","Coal":1000,"coordinates":[-87.5108,39.0694]},{"Plant":"Pawnee","State":"CO","Coal":505,"coordinates":[-103.6803,40.2217]},{"Plant":"Winyah","State":"SC","Coal":1155,"coordinates":[-79.3581,33.3317]},{"Plant":"Mayo","State":"NC","Coal":745,"coordinates":[-78.8917,36.5278]},{"Plant":"Ottumwa","State":"IA","Coal":716.75,"coordinates":[-92.5558,41.0961]},{"Plant":"Scherer","State":"GA","Coal":3429.7,"coordinates":[-83.8075,33.0606]},{"Plant":"Mountaineer","State":"WV","Coal":1300,"coordinates":[-81.9344,38.9794]},{"Plant":"Crystal River","State":"FL","Coal":2302,"coordinates":[-82.6977,28.9656]},{"Plant":"Crist","State":"FL","Coal":937,"coordinates":[-87.2244,30.5661]},{"Plant":"Lansing Smith","State":"FL","Coal":351,"coordinates":[-85.7003,30.2686]},{"Plant":"Big Bend","State":"FL","Coal":1692,"coordinates":[-82.4036,27.7944]},{"Plant":"F J Gannon","State":"FL","Coal":508,"coordinates":[-82.4231,27.9072]},{"Plant":"Antelope Valley","State":"ND","Coal":900,"coordinates":[-101.3194,47.2819]},{"Plant":"Intermountain Power Project","State":"UT","Coal":1800,"coordinates":[-112.5802,39.5097]},{"Plant":"Deerhaven Generating Station","State":"FL","Coal":228,"coordinates":[-82.3878,29.7592]},{"Plant":"R D Green","State":"KY","Coal":464,"coordinates":[-87.5,37.6461]},{"Plant":"Independence","State":"AR","Coal":1630,"coordinates":[-91.4088,35.6784]},{"Plant":"Sandow No 4","State":"TX","Coal":545,"coordinates":[-97.064,30.5659]},{"Plant":"Louisa","State":"IA","Coal":700,"coordinates":[-91.0931,41.3181]},{"Plant":"Warrick","State":"IN","Coal":693,"coordinates":[-87.3328,37.915]},{"Plant":"C D McIntosh Jr","State":"FL","Coal":342,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Coal":270,"coordinates":[-105.0212,40.8609]},{"Plant":"Sikeston Power Station","State":"MO","Coal":233,"coordinates":[-89.6209,36.8791]},{"Plant":"Hugo","State":"OK","Coal":450,"coordinates":[-95.3206,34.0158]},{"Plant":"D B Wilson","State":"KY","Coal":420,"coordinates":[-87.0806,37.4497]},{"Plant":"Gadsden","State":"AL","Coal":130,"coordinates":[-85.9708,34.0128]},{"Plant":"Bowen","State":"GA","Coal":3222,"coordinates":[-84.9222,34.1256]},{"Plant":"Major Oak Power","State":"TX","Coal":305,"coordinates":[-96.695,31.0919]},{"Plant":"Hammond","State":"GA","Coal":846,"coordinates":[-85.3456,34.2528]},{"Plant":"Harllee Branch","State":"GA","Coal":1607,"coordinates":[-83.2983,33.195]},{"Plant":"J K Spruce","State":"TX","Coal":585,"coordinates":[-98.3203,29.3097]},{"Plant":"Jack McDonough","State":"GA","Coal":517,"coordinates":[-84.4758,33.8239]},{"Plant":"Clover","State":"VA","Coal":882,"coordinates":[-78.704,36.869]},{"Plant":"Polk","State":"FL","Coal":255,"coordinates":[-81.9897,27.7286]},{"Plant":"Mitchell","State":"GA","Coal":193,"coordinates":[-84.1347,31.4447]},{"Plant":"Yates","State":"GA","Coal":1295,"coordinates":[-84.8986,33.4622]},{"Plant":"Richard Gorsuch","State":"OH","Coal":200,"coordinates":[-81.5211,39.3664]},{"Plant":"Kraft","State":"GA","Coal":201,"coordinates":[-81.1458,32.1486]},{"Plant":"George Neal South","State":"IA","Coal":644,"coordinates":[-96.3617,42.3006]},{"Plant":"Bonanza","State":"UT","Coal":458,"coordinates":[-109.2844,40.0864]},{"Plant":"Pirkey","State":"TX","Coal":675,"coordinates":[-94.4852,32.4607]},{"Plant":"Gorgas","State":"AL","Coal":1235,"coordinates":[-87.1965,33.6443]},{"Plant":"Columbia","State":"WI","Coal":1092.93,"coordinates":[-89.4203,43.4864]},{"Plant":"Belews Creek","State":"NC","Coal":2270,"coordinates":[-80.0603,36.2811]},{"Plant":"Jim Bridger","State":"WY","Coal":2120,"coordinates":[-108.7875,41.7378]},{"Plant":"Huntington","State":"UT","Coal":895,"coordinates":[-111.0781,39.3792]},{"Plant":"General James M Gavin","State":"OH","Coal":2600,"coordinates":[-82.1158,38.9347]},{"Plant":"Ray D Nixon","State":"CO","Coal":208,"coordinates":[-104.7058,38.6335]},{"Plant":"Coyote","State":"ND","Coal":427,"coordinates":[-101.8157,47.2214]},{"Plant":"Springerville","State":"AZ","Coal":800,"coordinates":[-109.1639,34.3186]},{"Plant":"North Valmy","State":"NV","Coal":522,"coordinates":[-117.1516,40.8813]},{"Plant":"Cheswick Power Plant","State":"PA","Coal":580,"coordinates":[-79.7906,40.5383]},{"Plant":"E D Edwards","State":"IL","Coal":744,"coordinates":[-89.6631,40.5958]},{"Plant":"Coffeen","State":"IL","Coal":900,"coordinates":[-89.4031,39.0586]},{"Plant":"Hutsonville","State":"IL","Coal":153,"coordinates":[-87.6597,39.1333]},{"Plant":"Meredosia","State":"IL","Coal":327,"coordinates":[-90.5672,39.8233]},{"Plant":"Crawford","State":"IL","Coal":532,"coordinates":[-87.7229,41.8285]},{"Plant":"Escalante","State":"NM","Coal":247,"coordinates":[-108.082,35.4159]},{"Plant":"Joliet 9","State":"IL","Coal":314,"coordinates":[-88.1153,41.4931]},{"Plant":"Kincaid Generation LLC","State":"IL","Coal":1168,"coordinates":[-89.4964,39.5906]},{"Plant":"Powerton","State":"IL","Coal":1538,"coordinates":[-89.6786,40.5408]},{"Plant":"Waukegan","State":"IL","Coal":789,"coordinates":[-87.8133,42.3833]},{"Plant":"Will County","State":"IL","Coal":1060,"coordinates":[-88.0629,41.6334]},{"Plant":"Fisk Street","State":"IL","Coal":326,"coordinates":[-87.6533,41.8508]},{"Plant":"Joppa Steam","State":"IL","Coal":1002,"coordinates":[-88.8589,37.2094]},{"Plant":"Baldwin Energy Complex","State":"IL","Coal":1761,"coordinates":[-89.8544,38.205]},{"Plant":"Havana","State":"IL","Coal":445,"coordinates":[-90.08,40.2797]},{"Plant":"Hennepin Power Station","State":"IL","Coal":289,"coordinates":[-89.315,41.3028]},{"Plant":"Vermilion","State":"IL","Coal":181,"coordinates":[-87.7481,40.1781]},{"Plant":"Wood River","State":"IL","Coal":458,"coordinates":[-90.1347,38.8639]},{"Plant":"Dallman","State":"IL","Coal":372,"coordinates":[-89.6024,39.7548]},{"Plant":"Marion","State":"IL","Coal":290,"coordinates":[-88.9531,37.6197]},{"Plant":"State Line Energy","State":"IN","Coal":515,"coordinates":[-87.5217,41.7072]},{"Plant":"Clifty Creek","State":"IN","Coal":1195.8,"coordinates":[-85.4206,38.7378]},{"Plant":"Tanners Creek","State":"IN","Coal":980,"coordinates":[-84.8594,39.0814]},{"Plant":"Harding Street","State":"IN","Coal":647,"coordinates":[-86.1969,39.7113]},{"Plant":"Eagle Valley","State":"IN","Coal":260,"coordinates":[-86.4183,39.4852]},{"Plant":"AES Petersburg","State":"IN","Coal":1722,"coordinates":[-87.2525,38.5281]},{"Plant":"Bailly","State":"IN","Coal":480,"coordinates":[-87.1225,41.645]},{"Plant":"Dean H Mitchell","State":"IN","Coal":360,"coordinates":[-87.4069,41.6392]},{"Plant":"Michigan City","State":"IN","Coal":469,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Coal":254,"coordinates":[-87.7811,32.6017]},{"Plant":"ACE Cogeneration Facility","State":"CA","Coal":101.2,"coordinates":[-117.3836,35.7658]},{"Plant":"Cayuga","State":"IN","Coal":995,"coordinates":[-87.4244,39.9242]},{"Plant":"RED-Rochester, LLC","State":"NY","Coal":180.8,"coordinates":[-77.6319,43.1989]},{"Plant":"Edwardsport","State":"IN","Coal":120,"coordinates":[-87.2472,38.8067]},{"Plant":"Logan Generating Company LP","State":"NJ","Coal":219,"coordinates":[-75.4067,39.7928]},{"Plant":"Portsmouth Genco LLC","State":"VA","Coal":115,"coordinates":[-76.3529,36.8702]},{"Plant":"Taconite Harbor Energy Center","State":"MN","Coal":200,"coordinates":[-90.9114,47.5314]},{"Plant":"R Gallagher","State":"IN","Coal":560,"coordinates":[-85.8381,38.2636]},{"Plant":"Wabash River","State":"IN","Coal":942,"coordinates":[-87.4247,39.53]},{"Plant":"F B Culley","State":"IN","Coal":402,"coordinates":[-87.3275,37.9111]},{"Plant":"Colver Power Project","State":"PA","Coal":110,"coordinates":[-78.8,40.55]},{"Plant":"Florida Power Development","State":"FL","Coal":139,"coordinates":[-82.4311,28.5819]},{"Plant":"Green Bay West Mill","State":"WI","Coal":136.89,"coordinates":[-88.0303,44.4936]},{"Plant":"CPI USA NC Southport","State":"NC","Coal":107,"coordinates":[-78.0118,33.9444]},{"Plant":"Edgecombe Genco LLC","State":"NC","Coal":115.5,"coordinates":[-77.7533,36.0373]},{"Plant":"Frank E Ratts","State":"IN","Coal":244,"coordinates":[-87.2662,38.5201]},{"Plant":"Lansing","State":"IA","Coal":328.56,"coordinates":[-91.1675,43.3359]},{"Plant":"4 AC Station","State":"IN","Coal":126.5,"coordinates":[-87.4264,41.68]},{"Plant":"Milton L Kapp","State":"IA","Coal":220.2,"coordinates":[-90.2336,41.8081]},{"Plant":"Chambers Cogeneration LP","State":"NJ","Coal":262,"coordinates":[-75.4858,39.6935]},{"Plant":"AES Shady Point LLC","State":"OK","Coal":320,"coordinates":[-94.6458,35.1931]},{"Plant":"Cedar Bay Generating Company LP","State":"FL","Coal":250,"coordinates":[-81.6064,30.4225]},{"Plant":"AES Hawaii","State":"HI","Coal":180,"coordinates":[-158.1065,21.3034]},{"Plant":"AES Thames","State":"CT","Coal":181,"coordinates":[-72.055,41.2607]},{"Plant":"AES Beaver Valley Partners Beaver Valley","State":"PA","Coal":146,"coordinates":[-80.3539,40.6572]},{"Plant":"AES Warrior Run Cogeneration Facility","State":"MD","Coal":180,"coordinates":[-78.7453,39.5952]},{"Plant":"Prairie Creek","State":"IA","Coal":201.84,"coordinates":[-91.6392,41.944]},{"Plant":"Sutherland","State":"IA","Coal":139.6,"coordinates":[-92.8594,42.0473]},{"Plant":"Holcomb","State":"KS","Coal":360,"coordinates":[-100.9725,37.9308]},{"Plant":"Riverside","State":"IA","Coal":135,"coordinates":[-90.4481,41.54]},{"Plant":"Walter Scott Jr Energy Center","State":"IA","Coal":823,"coordinates":[-95.8408,41.18]},{"Plant":"Silver Bay Power","State":"MN","Coal":105,"coordinates":[-91.2605,47.2866]},{"Plant":"Archer Daniels Midland Cedar Rapids","State":"IA","Coal":260,"coordinates":[-91.6875,41.9221]},{"Plant":"Archer Daniels Midland Decatur","State":"IL","Coal":335,"coordinates":[-88.8908,39.8701]},{"Plant":"George Neal North","State":"IA","Coal":950,"coordinates":[-96.3617,42.2998]},{"Plant":"Burlington","State":"IA","Coal":212,"coordinates":[-91.1167,40.7412]},{"Plant":"Ames Electric Services Power Plant","State":"IA","Coal":103,"coordinates":[-93.6089,42.0258]},{"Plant":"Cholla","State":"AZ","Coal":1021,"coordinates":[-110.3033,34.9394]},{"Plant":"Muscatine Plant #1","State":"IA","Coal":233.4,"coordinates":[-91.0569,41.3917]},{"Plant":"La Cygne","State":"KS","Coal":1422,"coordinates":[-94.6456,38.3481]},{"Plant":"Lawrence Energy Center","State":"KS","Coal":565,"coordinates":[-95.2692,39.0072]},{"Plant":"Tecumseh Energy Center","State":"KS","Coal":204,"coordinates":[-95.5689,39.0539]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Coal":156,"coordinates":[-110.9047,32.16]},{"Plant":"Oklaunion","State":"TX","Coal":690,"coordinates":[-99.1753,34.0825]},{"Plant":"Quindaro","State":"KS","Coal":190.6,"coordinates":[-94.6381,39.1492]},{"Plant":"Cross","State":"SC","Coal":1160,"coordinates":[-80.1119,33.3692]},{"Plant":"Big Sandy","State":"KY","Coal":1060,"coordinates":[-82.6176,38.1707]},{"Plant":"E W Brown","State":"KY","Coal":697,"coordinates":[-84.7126,37.7883]},{"Plant":"Ghent","State":"KY","Coal":1945,"coordinates":[-85.035,38.7497]},{"Plant":"Green River","State":"KY","Coal":207,"coordinates":[-87.1214,37.3636]},{"Plant":"Seminole","State":"FL","Coal":1316,"coordinates":[-81.6328,29.7331]},{"Plant":"Cane Run","State":"KY","Coal":563,"coordinates":[-85.8892,38.1831]},{"Plant":"Mill Creek","State":"KY","Coal":1472,"coordinates":[-85.9103,38.0525]},{"Plant":"Elmer Smith","State":"KY","Coal":405.1,"coordinates":[-87.0608,37.7942]},{"Plant":"Paradise","State":"KY","Coal":2113,"coordinates":[-86.9783,37.2608]},{"Plant":"Shawnee","State":"KY","Coal":1330,"coordinates":[-88.775,37.1517]},{"Plant":"Kenneth C Coleman","State":"KY","Coal":455,"coordinates":[-86.7911,37.9631]},{"Plant":"HMP&L Station Two Henderson","State":"KY","Coal":312,"coordinates":[-87.5028,37.6469]},{"Plant":"Cooper","State":"KY","Coal":341,"coordinates":[-84.5919,36.9981]},{"Plant":"Dale","State":"KY","Coal":196,"coordinates":[-84.2619,37.8806]},{"Plant":"R S Nelson","State":"LA","Coal":550,"coordinates":[-93.2911,30.2844]},{"Plant":"C P Crane","State":"MD","Coal":385,"coordinates":[-76.3651,39.3236]},{"Plant":"Herbert A Wagner","State":"MD","Coal":459,"coordinates":[-76.5268,39.1781]},{"Plant":"FirstEnergy R Paul Smith Power Station","State":"MD","Coal":115,"coordinates":[-77.8269,39.595]},{"Plant":"Chalk Point LLC","State":"MD","Coal":683,"coordinates":[-76.6861,38.5444]},{"Plant":"Dickerson","State":"MD","Coal":546,"coordinates":[-77.4644,39.2097]},{"Plant":"Apache Station","State":"AZ","Coal":350,"coordinates":[-109.8931,32.0603]},{"Plant":"Mount Tom","State":"MA","Coal":143.62,"coordinates":[-72.6055,42.2806]},{"Plant":"Somerset Station","State":"MA","Coal":179.1,"coordinates":[-71.146,41.7374]},{"Plant":"Brayton Point","State":"MA","Coal":1099.46,"coordinates":[-71.1931,41.7103]},{"Plant":"Salem Harbor","State":"MA","Coal":311.79,"coordinates":[-70.8772,42.5256]},{"Plant":"GRDA","State":"OK","Coal":1010,"coordinates":[-95.2894,36.1903]},{"Plant":"B C Cobb","State":"MI","Coal":312,"coordinates":[-86.2423,43.2588]},{"Plant":"Dan E Karn","State":"MI","Coal":515,"coordinates":[-83.8401,43.645]},{"Plant":"J H Campbell","State":"MI","Coal":1435,"coordinates":[-86.2007,42.9103]},{"Plant":"J C Weadock","State":"MI","Coal":302,"coordinates":[-83.8447,43.6399]},{"Plant":"J R Whiting","State":"MI","Coal":328,"coordinates":[-83.4495,41.7921]},{"Plant":"Harbor Beach","State":"MI","Coal":103,"coordinates":[-82.6436,43.8519]},{"Plant":"Marysville","State":"MI","Coal":200,"coordinates":[-82.4606,42.9256]},{"Plant":"Monroe","State":"MI","Coal":3115,"coordinates":[-83.3464,41.8906]},{"Plant":"River Rouge","State":"MI","Coal":510,"coordinates":[-83.1119,42.2739]},{"Plant":"St Clair","State":"MI","Coal":1415,"coordinates":[-82.4719,42.7642]},{"Plant":"Trenton Channel","State":"MI","Coal":730,"coordinates":[-83.1808,42.1217]},{"Plant":"Presque Isle","State":"MI","Coal":618,"coordinates":[-87.395,46.5789]},{"Plant":"Eckert Station","State":"MI","Coal":323.5,"coordinates":[-84.5581,42.7184]},{"Plant":"Erickson Station","State":"MI","Coal":154.2,"coordinates":[-84.6572,42.6922]},{"Plant":"Syl Laskin","State":"MN","Coal":110,"coordinates":[-92.1619,47.5306]},{"Plant":"Clay Boswell","State":"MN","Coal":917.2,"coordinates":[-93.6528,47.2611]},{"Plant":"Black Dog","State":"MN","Coal":353.7,"coordinates":[-93.2501,44.8108]},{"Plant":"High Bridge","State":"MN","Coal":271.1,"coordinates":[-93.1117,44.9314]},{"Plant":"Allen S King","State":"MN","Coal":527.76,"coordinates":[-92.7786,45.03]},{"Plant":"Riverside","State":"MN","Coal":381.25,"coordinates":[-93.2753,45.0203]},{"Plant":"Hoot Lake","State":"MN","Coal":153.69,"coordinates":[-96.0433,46.2906]},{"Plant":"Silver Lake","State":"MN","Coal":110.2,"coordinates":[-92.4604,44.0282]},{"Plant":"Jack Watson","State":"MS","Coal":706,"coordinates":[-89.0286,30.4392]},{"Plant":"St Johns River Power Park","State":"FL","Coal":1252,"coordinates":[-81.5508,30.4308]},{"Plant":"Asbury","State":"MO","Coal":210,"coordinates":[-94.5893,37.3613]},{"Plant":"Hawthorn","State":"MO","Coal":563,"coordinates":[-94.4778,39.1306]},{"Plant":"Montrose","State":"MO","Coal":510,"coordinates":[-93.9348,38.3114]},{"Plant":"Sibley","State":"MO","Coal":508,"coordinates":[-94.1844,39.1783]},{"Plant":"Labadie","State":"MO","Coal":2415,"coordinates":[-90.8377,38.5622]},{"Plant":"Meramec","State":"MO","Coal":832,"coordinates":[-90.3358,38.4017]},{"Plant":"Sioux","State":"MO","Coal":994,"coordinates":[-90.2902,38.9155]},{"Plant":"James River Power Station","State":"MO","Coal":236,"coordinates":[-93.2619,37.1086]},{"Plant":"New Madrid","State":"MO","Coal":1160,"coordinates":[-89.5617,36.5147]},{"Plant":"Thomas Hill","State":"MO","Coal":1120,"coordinates":[-92.6381,39.5522]},{"Plant":"J E Corette Plant","State":"MT","Coal":158,"coordinates":[-108.481,45.7756]},{"Plant":"Lon Wright","State":"NE","Coal":120,"coordinates":[-96.4623,41.4281]},{"Plant":"Sheldon","State":"NE","Coal":225,"coordinates":[-96.7847,40.5589]},{"Plant":"North Omaha","State":"NE","Coal":662.8,"coordinates":[-95.9447,41.3291]},{"Plant":"Reid Gardner","State":"NV","Coal":555,"coordinates":[-114.6333,36.6573]},{"Plant":"Mohave","State":"NV","Coal":1580,"coordinates":[-114.5917,35.1458]},{"Plant":"Merrimack","State":"NH","Coal":432.5,"coordinates":[-71.4692,43.1411]},{"Plant":"Schiller","State":"NH","Coal":142.6,"coordinates":[-70.7842,43.0978]},{"Plant":"B L England","State":"NJ","Coal":284,"coordinates":[-74.6364,39.2908]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Coal":583.4,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Mercer Generating Station","State":"NJ","Coal":625.2,"coordinates":[-74.7339,40.1792]},{"Plant":"Four Corners","State":"NM","Coal":2060,"coordinates":[-108.4814,36.69]},{"Plant":"San Juan","State":"NM","Coal":1643,"coordinates":[-108.4386,36.8006]},{"Plant":"Danskammer Generating Station","State":"NY","Coal":369,"coordinates":[-73.975,41.5712]},{"Plant":"GMMM Westover","State":"NY","Coal":127.7,"coordinates":[-75.9747,42.1117]},{"Plant":"GMMGreenidge LLC","State":"NY","Coal":159,"coordinates":[-76.9483,42.6789]},{"Plant":"Cayuga Operating Company","State":"NY","Coal":305,"coordinates":[-76.6336,42.6028]},{"Plant":"C R Huntley Generating Station","State":"NY","Coal":816,"coordinates":[-78.93,42.97]},{"Plant":"Dunkirk Generating Plant","State":"NY","Coal":586,"coordinates":[-79.3466,42.4915]},{"Plant":"E C Gaston","State":"AL","Coal":1881,"coordinates":[-86.4581,33.2442]},{"Plant":"Lovett","State":"NY","Coal":363,"coordinates":[-73.9797,41.2578]},{"Plant":"Rochester 7","State":"NY","Coal":252,"coordinates":[-77.6294,43.2689]},{"Plant":"Asheville","State":"NC","Coal":384,"coordinates":[-82.5417,35.4731]},{"Plant":"Cape Fear","State":"NC","Coal":316,"coordinates":[-79.0495,35.595]},{"Plant":"HF Lee Plant","State":"NC","Coal":407,"coordinates":[-78.0878,35.3799]},{"Plant":"Roxboro","State":"NC","Coal":2462,"coordinates":[-79.0731,36.4833]},{"Plant":"L V Sutton Steam","State":"NC","Coal":613,"coordinates":[-77.9853,34.2831]},{"Plant":"W H Weatherspoon","State":"NC","Coal":176,"coordinates":[-78.9755,34.5875]},{"Plant":"G G Allen","State":"NC","Coal":1145,"coordinates":[-81.0122,35.1897]},{"Plant":"Buck","State":"NC","Coal":369,"coordinates":[-80.3767,35.7133]},{"Plant":"Cliffside","State":"NC","Coal":760,"coordinates":[-81.7594,35.22]},{"Plant":"Dan River","State":"NC","Coal":276,"coordinates":[-79.7208,36.4862]},{"Plant":"Marshall","State":"NC","Coal":2110,"coordinates":[-80.9658,35.5975]},{"Plant":"Riverbend","State":"NC","Coal":454,"coordinates":[-80.9742,35.36]},{"Plant":"R M Heskett","State":"ND","Coal":102.87,"coordinates":[-100.8836,46.8669]},{"Plant":"Leland Olds","State":"ND","Coal":669,"coordinates":[-101.3212,47.2808]},{"Plant":"Milton R Young","State":"ND","Coal":705,"coordinates":[-101.2131,47.0659]},{"Plant":"Stanton","State":"ND","Coal":187.7,"coordinates":[-101.3319,47.2866]},{"Plant":"Cardinal","State":"OH","Coal":1815,"coordinates":[-80.6486,40.2522]},{"Plant":"Walter C Beckjord","State":"OH","Coal":1118,"coordinates":[-84.2981,38.9917]},{"Plant":"Miami Fort","State":"OH","Coal":1243,"coordinates":[-84.8036,39.1128]},{"Plant":"FirstEnergy Ashtabula","State":"OH","Coal":420,"coordinates":[-80.7697,41.9086]},{"Plant":"Avon Lake","State":"OH","Coal":721,"coordinates":[-82.0546,41.5045]},{"Plant":"FirstEnergy Eastlake","State":"OH","Coal":1233,"coordinates":[-81.4425,41.6711]},{"Plant":"FirstEnergy Lake Shore","State":"OH","Coal":245,"coordinates":[-81.6419,41.5356]},{"Plant":"Conesville","State":"OH","Coal":1925,"coordinates":[-81.8811,40.1842]},{"Plant":"O H Hutchings","State":"OH","Coal":365,"coordinates":[-84.2921,39.6088]},{"Plant":"J M Stuart","State":"OH","Coal":2376,"coordinates":[-83.6939,38.6361]},{"Plant":"Niles","State":"OH","Coal":216,"coordinates":[-80.7477,41.1669]},{"Plant":"FirstEnergy R E Burger","State":"OH","Coal":518,"coordinates":[-80.7608,39.91]},{"Plant":"FirstEnergy W H Sammis","State":"OH","Coal":2220,"coordinates":[-80.6319,40.5317]},{"Plant":"FirstEnergy Toronto","State":"OH","Coal":172,"coordinates":[-80.6044,40.4825]},{"Plant":"Muskingum River","State":"OH","Coal":1375,"coordinates":[-81.6797,39.5908]},{"Plant":"Kyger Creek","State":"OH","Coal":985.7,"coordinates":[-82.1289,38.9144]},{"Plant":"FirstEnergy Bay Shore","State":"OH","Coal":495,"coordinates":[-83.4378,41.6917]},{"Plant":"Lake Road","State":"OH","Coal":160,"coordinates":[-81.6494,41.5278]},{"Plant":"Muskogee","State":"OK","Coal":1547.1,"coordinates":[-95.2873,35.7614]},{"Plant":"Northeastern","State":"OK","Coal":945,"coordinates":[-95.7008,36.4317]},{"Plant":"Limestone","State":"TX","Coal":1614,"coordinates":[-96.2525,31.4219]},{"Plant":"Barry","State":"AL","Coal":1658,"coordinates":[-88.0103,31.0069]},{"Plant":"F R Phillips","State":"PA","Coal":310,"coordinates":[-80.2286,40.5758]},{"Plant":"Portland","State":"PA","Coal":401,"coordinates":[-75.0794,40.9102]},{"Plant":"Titus","State":"PA","Coal":243,"coordinates":[-75.9081,40.3056]},{"Plant":"Conemaugh","State":"PA","Coal":1700,"coordinates":[-79.0611,40.3842]},{"Plant":"Homer City Generating Station","State":"PA","Coal":1884,"coordinates":[-79.1961,40.5128]},{"Plant":"Seward","State":"PA","Coal":717,"coordinates":[-79.0337,40.4062]},{"Plant":"Shawville","State":"PA","Coal":597,"coordinates":[-78.3662,41.0675]},{"Plant":"Keystone","State":"PA","Coal":1700,"coordinates":[-79.3411,40.6604]},{"Plant":"New Castle Plant","State":"PA","Coal":413,"coordinates":[-80.369,40.9379]},{"Plant":"Brunner Island","State":"PA","Coal":1448,"coordinates":[-76.6962,40.0961]},{"Plant":"PPL Martins Creek","State":"PA","Coal":280,"coordinates":[-75.1054,40.7978]},{"Plant":"PPL Montour","State":"PA","Coal":1525,"coordinates":[-76.6672,41.0714]},{"Plant":"Sunbury Generation LP","State":"PA","Coal":361,"coordinates":[-76.825,40.8361]},{"Plant":"Cromby Generating Station","State":"PA","Coal":144,"coordinates":[-75.5294,40.1531]},{"Plant":"Eddystone Generating Station","State":"PA","Coal":588,"coordinates":[-75.323,39.858]},{"Plant":"FirstEnergy Armstrong Power Station","State":"PA","Coal":343,"coordinates":[-79.4656,40.9292]},{"Plant":"Hatfields Ferry Power Station","State":"PA","Coal":1590,"coordinates":[-79.9275,39.8556]},{"Plant":"FirstEnergy Mitchell Power Station","State":"PA","Coal":277,"coordinates":[-79.9683,40.2211]},{"Plant":"H B Robinson","State":"SC","Coal":174,"coordinates":[-80.1589,34.4017]},{"Plant":"W S Lee","State":"SC","Coal":370,"coordinates":[-82.435,34.6022]},{"Plant":"Canadys Steam","State":"SC","Coal":396,"coordinates":[-80.6228,33.0647]},{"Plant":"Wateree","State":"SC","Coal":700,"coordinates":[-80.6228,33.8264]},{"Plant":"Williams","State":"SC","Coal":615,"coordinates":[-79.9297,33.0158]},{"Plant":"Dolphus M Grainger","State":"SC","Coal":170,"coordinates":[-79.0533,33.8264]},{"Plant":"Jefferies","State":"SC","Coal":306,"coordinates":[-79.9875,33.2422]},{"Plant":"Allen Steam Plant","State":"TN","Coal":741,"coordinates":[-90.1487,35.0741]},{"Plant":"Bull Run","State":"TN","Coal":879,"coordinates":[-84.1567,36.0211]},{"Plant":"Cumberland","State":"TN","Coal":2462,"coordinates":[-87.6539,36.3903]},{"Plant":"Gallatin","State":"TN","Coal":976,"coordinates":[-86.4006,36.3156]},{"Plant":"John Sevier","State":"TN","Coal":704,"coordinates":[-82.9639,36.3767]},{"Plant":"Johnsonville","State":"TN","Coal":1206,"coordinates":[-87.9861,36.0278]},{"Plant":"Kingston","State":"TN","Coal":1426,"coordinates":[-84.5194,35.8992]},{"Plant":"Watts Bar Fossil","State":"TN","Coal":224,"coordinates":[-84.7811,35.6108]},{"Plant":"W A Parish","State":"TX","Coal":2463,"coordinates":[-95.6311,29.4828]},{"Plant":"Big Brown","State":"TX","Coal":1150,"coordinates":[-96.0544,31.8206]},{"Plant":"Carbon","State":"UT","Coal":172,"coordinates":[-110.8644,39.7272]},{"Plant":"Clinch River","State":"VA","Coal":690,"coordinates":[-82.1997,36.9333]},{"Plant":"Glen Lyn","State":"VA","Coal":325,"coordinates":[-80.8633,37.3706]},{"Plant":"Potomac River","State":"VA","Coal":482,"coordinates":[-77.0411,38.8203]},{"Plant":"Chesapeake","State":"VA","Coal":595,"coordinates":[-76.3019,36.7711]},{"Plant":"Yorktown","State":"VA","Coal":323,"coordinates":[-76.4611,37.2144]},{"Plant":"Joliet 29","State":"IL","Coal":1036,"coordinates":[-88.1238,41.4946]},{"Plant":"Transalta Centralia Generation","State":"WA","Coal":1405,"coordinates":[-122.8598,46.7559]},{"Plant":"John E Amos","State":"WV","Coal":2900,"coordinates":[-81.8233,38.4731]},{"Plant":"Kanawha River","State":"WV","Coal":400,"coordinates":[-81.4211,38.2056]},{"Plant":"Philip Sporn","State":"WV","Coal":1020,"coordinates":[-81.9231,38.9669]},{"Plant":"FirstEnergy Albright","State":"WV","Coal":283,"coordinates":[-79.6369,39.4886]},{"Plant":"FirstEnergy Fort Martin Power Station","State":"WV","Coal":1107,"coordinates":[-79.9275,39.7108]},{"Plant":"FirstEnergy Harrison Power Station","State":"WV","Coal":1933,"coordinates":[-80.3325,39.3842]},{"Plant":"FirstEnergy Rivesville","State":"WV","Coal":137,"coordinates":[-80.1131,39.5314]},{"Plant":"FirstEnergy Willow Island","State":"WV","Coal":235,"coordinates":[-81.3,39.3672]},{"Plant":"Kammer","State":"WV","Coal":600,"coordinates":[-80.8186,39.8461]},{"Plant":"Mitchell","State":"WV","Coal":1600,"coordinates":[-80.8153,39.8297]},{"Plant":"Blount Street","State":"WI","Coal":194.1,"coordinates":[-89.3744,43.0789]},{"Plant":"Port Washington Generating Station","State":"WI","Coal":305,"coordinates":[-87.8689,43.3842]},{"Plant":"South Oak Creek","State":"WI","Coal":1135,"coordinates":[-87.8294,42.8457]},{"Plant":"Valley","State":"WI","Coal":267,"coordinates":[-87.9233,43.0303]},{"Plant":"Edgewater","State":"WI","Coal":809.52,"coordinates":[-87.7059,43.7151]},{"Plant":"Nelson Dewey Coal Refining Facility","State":"WI","Coal":219.9,"coordinates":[-91.0085,42.7225]},{"Plant":"Pulliam","State":"WI","Coal":385.8,"coordinates":[-88.0086,44.54]},{"Plant":"Weston","State":"WI","Coal":477.5,"coordinates":[-89.6553,44.8606]},{"Plant":"Alma","State":"WI","Coal":186.15,"coordinates":[-91.9111,44.3083]},{"Plant":"Genoa","State":"WI","Coal":356.24,"coordinates":[-91.2325,43.5589]},{"Plant":"Dave Johnston","State":"WY","Coal":762,"coordinates":[-105.7769,42.8378]},{"Plant":"Naughton","State":"WY","Coal":700,"coordinates":[-110.5983,41.7581]},{"Plant":"John P Madgett","State":"WI","Coal":397.59,"coordinates":[-91.9126,44.3036]},{"Plant":"Arapahoe","State":"CO","Coal":246,"coordinates":[-105.0028,39.67]},{"Plant":"Cherokee","State":"CO","Coal":717,"coordinates":[-104.9645,39.8073]},{"Plant":"Colbert","State":"AL","Coal":1176,"coordinates":[-87.8486,34.7439]},{"Plant":"Comanche","State":"CO","Coal":660,"coordinates":[-104.5747,38.2081]},{"Plant":"Valmont","State":"CO","Coal":186,"coordinates":[-105.202,40.0195]},{"Plant":"Martin Drake","State":"CO","Coal":255,"coordinates":[-104.8333,38.8244]},{"Plant":"Navajo","State":"AZ","Coal":2250,"coordinates":[-111.3886,36.9047]},{"Plant":"Widows Creek","State":"AL","Coal":1605,"coordinates":[-85.7553,34.883]},{"Plant":"G F Weaton Power Station","State":"PA","Coal":112,"coordinates":[-80.3462,40.6673]},{"Plant":"International Paper Savanna Mill","State":"GA","Coal":189.09,"coordinates":[-81.1242,32.1004]},{"Plant":"Tennessee Eastman Operations","State":"TN","Coal":194.3,"coordinates":[-82.5431,36.5219]},{"Plant":"Axiall Natrium Plant","State":"WV","Coal":123,"coordinates":[-80.8547,39.7475]},{"Plant":"Northampton Generating Company LP","State":"PA","Coal":112,"coordinates":[-75.4792,40.6917]},{"Plant":"Indiantown Cogeneration LP","State":"FL","Coal":330,"coordinates":[-80.5125,27.0389]},{"Plant":"Dolet Hills","State":"LA","Coal":650,"coordinates":[-93.5692,32.0306]},{"Plant":"Mecklenburg Power Station","State":"VA","Coal":138,"coordinates":[-78.53,36.6]},{"Plant":"Sandow No 5","State":"TX","Coal":363,"coordinates":[-97.0614,30.5681]},{"Plant":"Hayden","State":"CO","Coal":446,"coordinates":[-107.185,40.4856]},{"Plant":"Roanoke Valley Energy Facililty I","State":"NC","Coal":165,"coordinates":[-77.6167,36.4364]},{"Plant":"Spruance Genco LLC","State":"VA","Coal":190,"coordinates":[-77.4308,37.4556]},{"Plant":"Birchwood Power","State":"VA","Coal":238.8,"coordinates":[-77.3147,38.2667]},{"Plant":"Red Hills Generating Facility","State":"MS","Coal":440,"coordinates":[-89.2183,33.3761]},{"Plant":"Charles R Lowman","State":"AL","Coal":556,"coordinates":[-87.9107,31.488]},{"Plant":"Kennecott Power Plant","State":"UT","Coal":155,"coordinates":[-112.1225,40.7119]},{"Plant":"Stanton Energy Center","State":"FL","Coal":886,"coordinates":[-81.1678,28.4822]},{"Plant":"Bridgeport Station","State":"CT","Coal":374.3,"coordinates":[-73.1844,41.1706]},{"Plant":"Edge Moor","State":"DE","Coal":260,"coordinates":[-75.5038,39.7389]},{"Plant":"Indian River Generating Station","State":"DE","Coal":780,"coordinates":[-75.2341,38.5857]},{"Plant":"James H Miller Jr","State":"AL","Coal":2749.8,"coordinates":[-87.0597,33.6319]},{"Plant":"FirstEnergy Pleasants Power Station","State":"WV","Coal":1278,"coordinates":[-81.2944,39.3667]},{"Plant":"White Bluff","State":"AR","Coal":1635,"coordinates":[-92.1406,34.4228]},{"Plant":"Duck Creek","State":"IL","Coal":335,"coordinates":[-89.9841,40.4663]},{"Plant":"Newton","State":"IL","Coal":1126,"coordinates":[-88.2781,38.9361]},{"Plant":"East Bend","State":"KY","Coal":600,"coordinates":[-84.8514,38.9036]},{"Plant":"W H Zimmer","State":"OH","Coal":1300,"coordinates":[-84.2289,38.8675]},{"Plant":"Brandon Shores","State":"MD","Coal":1286,"coordinates":[-76.5389,39.18]},{"Plant":"Craig","State":"CO","Coal":1264,"coordinates":[-107.5912,40.4627]},{"Plant":"Coal Creek","State":"ND","Coal":1114.3,"coordinates":[-101.1571,47.3777]},{"Plant":"Killen Station","State":"OH","Coal":615,"coordinates":[-83.4803,38.6903]},{"Plant":"Belle River","State":"MI","Coal":1260,"coordinates":[-82.495,42.7756]},{"Plant":"H L Spurlock","State":"KY","Coal":1118,"coordinates":[-83.8181,38.7]},{"Plant":"Wansley","State":"GA","Coal":1778,"coordinates":[-85.0323,33.4134]},{"Plant":"Big Cajun 2","State":"LA","Coal":1730,"coordinates":[-91.3692,30.7261]},{"Plant":"R D Morrow","State":"MS","Coal":360,"coordinates":[-89.394,31.2186]},{"Plant":"Nearman Creek","State":"KS","Coal":232.2,"coordinates":[-94.6975,39.1681]},{"Plant":"Iatan","State":"MO","Coal":651,"coordinates":[-94.98,39.4472]},{"Plant":"Jeffrey Energy Center","State":"KS","Coal":2210,"coordinates":[-96.1172,39.2865]},{"Plant":"Trimble County","State":"KY","Coal":511,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Coal":1028,"coordinates":[-88.5553,30.5322]},{"Plant":"Colstrip","State":"MT","Coal":2094,"coordinates":[-106.614,45.8831]},{"Plant":"Gerald Gentleman","State":"NE","Coal":1365,"coordinates":[-101.1408,41.0808]},{"Plant":"Somerset Operating Co LLC","State":"NY","Coal":680.8,"coordinates":[-78.6047,43.3589]},{"Plant":"R M Schahfer","State":"IN","Coal":1625,"coordinates":[-87.0261,41.2164]},{"Plant":"Sherburne County","State":"MN","Coal":2233,"coordinates":[-93.8931,45.3808]},{"Plant":"FirstEnergy Bruce Mansfield","State":"PA","Coal":2360,"coordinates":[-80.4159,40.6348]},{"Plant":"Sooner","State":"OK","Coal":1022,"coordinates":[-97.0528,36.4531]},{"Plant":"Nebraska City","State":"NE","Coal":646,"coordinates":[-95.7764,40.6214]},{"Plant":"Big Stone","State":"SD","Coal":460.5,"coordinates":[-96.5101,45.3037]},{"Plant":"Wyodak","State":"WY","Coal":335,"coordinates":[-105.3815,44.2901]},{"Plant":"Boardman","State":"OR","Coal":585,"coordinates":[-119.8088,45.6932]},{"Plant":"Gibson","State":"IN","Coal":3131,"coordinates":[-87.7658,38.3722]},{"Plant":"McIntosh","State":"GA","Coal":156.5,"coordinates":[-81.1683,32.3563]},{"Plant":"Gibbons Creek","State":"TX","Coal":462,"coordinates":[-96.0818,30.6199]},{"Plant":"A B Brown","State":"IN","Coal":500,"coordinates":[-87.715,37.9053]},{"Plant":"Flint Creek","State":"AR","Coal":480,"coordinates":[-94.5241,36.2561]},{"Plant":"Welsh","State":"TX","Coal":1584,"coordinates":[-94.84,33.0552]},{"Plant":"Martin Lake","State":"TX","Coal":2250,"coordinates":[-94.5706,32.2606]},{"Plant":"Monticello","State":"TX","Coal":1880,"coordinates":[-95.0417,33.0917]},{"Plant":"Rush Island","State":"MO","Coal":1208,"coordinates":[-90.2632,38.1312]},{"Plant":"Hunter","State":"UT","Coal":1320,"coordinates":[-111.0289,39.1747]},{"Plant":"Rockport","State":"IN","Coal":2600,"coordinates":[-87.0372,37.9256]},{"Plant":"Pleasant Prairie","State":"WI","Coal":1224,"coordinates":[-87.9033,42.5381]},{"Plant":"Coronado","State":"AZ","Coal":785,"coordinates":[-109.2708,34.5789]},{"Plant":"Coleto Creek","State":"TX","Coal":632,"coordinates":[-97.2142,28.7128]},{"Plant":"Fayette Power Project","State":"TX","Coal":1641,"coordinates":[-96.7506,29.9172]},{"Plant":"J T Deely","State":"TX","Coal":810,"coordinates":[-98.3228,29.3081]},{"Plant":"San Miguel","State":"TX","Coal":391,"coordinates":[-98.4775,28.7044]},{"Plant":"Brame Energy Center","State":"LA","Coal":523,"coordinates":[-92.7167,31.395]},{"Plant":"Harrington","State":"TX","Coal":1066,"coordinates":[-101.7472,35.2982]},{"Plant":"Tolk","State":"TX","Coal":1080,"coordinates":[-102.57,34.1865]},{"Plant":"John Twitty Energy Center","State":"MO","Coal":178,"coordinates":[-93.388,37.1517]},{"Plant":"Laramie River Station","State":"WY","Coal":1705,"coordinates":[-104.8825,42.1089]},{"Plant":"Merom","State":"IN","Coal":1000,"coordinates":[-87.5108,39.0694]},{"Plant":"Pawnee","State":"CO","Coal":505,"coordinates":[-103.6803,40.2217]},{"Plant":"Winyah","State":"SC","Coal":1155,"coordinates":[-79.3581,33.3317]},{"Plant":"Mayo","State":"NC","Coal":745,"coordinates":[-78.8917,36.5278]},{"Plant":"Ottumwa","State":"IA","Coal":670.1,"coordinates":[-92.5558,41.0961]},{"Plant":"Scherer","State":"GA","Coal":3404.7,"coordinates":[-83.8075,33.0606]},{"Plant":"Mountaineer","State":"WV","Coal":1300,"coordinates":[-81.9344,38.9794]},{"Plant":"Crystal River","State":"FL","Coal":2302,"coordinates":[-82.6977,28.9656]},{"Plant":"Crist","State":"FL","Coal":937,"coordinates":[-87.2244,30.5661]},{"Plant":"Lansing Smith","State":"FL","Coal":351,"coordinates":[-85.7003,30.2686]},{"Plant":"Big Bend","State":"FL","Coal":1673,"coordinates":[-82.4036,27.7944]},{"Plant":"F J Gannon","State":"FL","Coal":508,"coordinates":[-82.4231,27.9072]},{"Plant":"Antelope Valley","State":"ND","Coal":900,"coordinates":[-101.3194,47.2819]},{"Plant":"Intermountain Power Project","State":"UT","Coal":1800,"coordinates":[-112.5802,39.5097]},{"Plant":"Deerhaven Generating Station","State":"FL","Coal":228,"coordinates":[-82.3878,29.7592]},{"Plant":"R D Green","State":"KY","Coal":464,"coordinates":[-87.5,37.6461]},{"Plant":"Independence","State":"AR","Coal":1678,"coordinates":[-91.4088,35.6784]},{"Plant":"Sandow No 4","State":"TX","Coal":545,"coordinates":[-97.064,30.5659]},{"Plant":"Louisa","State":"IA","Coal":700,"coordinates":[-91.0931,41.3181]},{"Plant":"Warrick","State":"IN","Coal":693,"coordinates":[-87.3328,37.915]},{"Plant":"C D McIntosh Jr","State":"FL","Coal":342,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Coal":270,"coordinates":[-105.0212,40.8609]},{"Plant":"Sikeston Power Station","State":"MO","Coal":233,"coordinates":[-89.6209,36.8791]},{"Plant":"Hugo","State":"OK","Coal":440,"coordinates":[-95.3206,34.0158]},{"Plant":"D B Wilson","State":"KY","Coal":420,"coordinates":[-87.0806,37.4497]},{"Plant":"Gadsden","State":"AL","Coal":130,"coordinates":[-85.9708,34.0128]},{"Plant":"Bowen","State":"GA","Coal":3222,"coordinates":[-84.9222,34.1256]},{"Plant":"Major Oak Power","State":"TX","Coal":305,"coordinates":[-96.695,31.0919]},{"Plant":"Hammond","State":"GA","Coal":846,"coordinates":[-85.3456,34.2528]},{"Plant":"Harllee Branch","State":"GA","Coal":1607,"coordinates":[-83.2983,33.195]},{"Plant":"J K Spruce","State":"TX","Coal":585,"coordinates":[-98.3203,29.3097]},{"Plant":"Jack McDonough","State":"GA","Coal":517,"coordinates":[-84.4758,33.8239]},{"Plant":"Polk","State":"FL","Coal":255,"coordinates":[-81.9897,27.7286]},{"Plant":"Mitchell","State":"GA","Coal":195,"coordinates":[-84.1347,31.4447]},{"Plant":"Yates","State":"GA","Coal":1295,"coordinates":[-84.8986,33.4622]},{"Plant":"Richard Gorsuch","State":"OH","Coal":200,"coordinates":[-81.5211,39.3664]},{"Plant":"Kraft","State":"GA","Coal":201,"coordinates":[-81.1458,32.1486]},{"Plant":"George Neal South","State":"IA","Coal":644,"coordinates":[-96.3617,42.3006]},{"Plant":"Bonanza","State":"UT","Coal":458,"coordinates":[-109.2844,40.0864]},{"Plant":"Pirkey","State":"TX","Coal":675,"coordinates":[-94.4852,32.4607]},{"Plant":"Gorgas","State":"AL","Coal":1235,"coordinates":[-87.1965,33.6443]},{"Plant":"Columbia","State":"WI","Coal":1108.53,"coordinates":[-89.4203,43.4864]},{"Plant":"Belews Creek","State":"NC","Coal":2270,"coordinates":[-80.0603,36.2811]},{"Plant":"Jim Bridger","State":"WY","Coal":2120,"coordinates":[-108.7875,41.7378]},{"Plant":"Huntington","State":"UT","Coal":895,"coordinates":[-111.0781,39.3792]},{"Plant":"General James M Gavin","State":"OH","Coal":2600,"coordinates":[-82.1158,38.9347]},{"Plant":"Ray D Nixon","State":"CO","Coal":209,"coordinates":[-104.7058,38.6335]},{"Plant":"Coyote","State":"ND","Coal":427,"coordinates":[-101.8157,47.2214]},{"Plant":"Springerville","State":"AZ","Coal":800,"coordinates":[-109.1639,34.3186]},{"Plant":"North Valmy","State":"NV","Coal":522,"coordinates":[-117.1516,40.8813]},{"Plant":"Cheswick Power Plant","State":"PA","Coal":580,"coordinates":[-79.7906,40.5383]},{"Plant":"E D Edwards","State":"IL","Coal":749,"coordinates":[-89.6631,40.5958]},{"Plant":"Coffeen","State":"IL","Coal":900,"coordinates":[-89.4031,39.0586]},{"Plant":"Hutsonville","State":"IL","Coal":153,"coordinates":[-87.6597,39.1333]},{"Plant":"Meredosia","State":"IL","Coal":327,"coordinates":[-90.5672,39.8233]},{"Plant":"Crawford","State":"IL","Coal":532,"coordinates":[-87.7229,41.8285]},{"Plant":"Escalante","State":"NM","Coal":247,"coordinates":[-108.082,35.4159]},{"Plant":"Joliet 9","State":"IL","Coal":314,"coordinates":[-88.1153,41.4931]},{"Plant":"Kincaid Generation LLC","State":"IL","Coal":1168,"coordinates":[-89.4964,39.5906]},{"Plant":"Powerton","State":"IL","Coal":1538,"coordinates":[-89.6786,40.5408]},{"Plant":"Waukegan","State":"IL","Coal":789,"coordinates":[-87.8133,42.3833]},{"Plant":"Will County","State":"IL","Coal":1060,"coordinates":[-88.0629,41.6334]},{"Plant":"Fisk Street","State":"IL","Coal":326,"coordinates":[-87.6533,41.8508]},{"Plant":"Joppa Steam","State":"IL","Coal":1002,"coordinates":[-88.8589,37.2094]},{"Plant":"Baldwin Energy Complex","State":"IL","Coal":1768,"coordinates":[-89.8544,38.205]},{"Plant":"Havana","State":"IL","Coal":445,"coordinates":[-90.08,40.2797]},{"Plant":"Hennepin Power Station","State":"IL","Coal":290,"coordinates":[-89.315,41.3028]},{"Plant":"Vermilion","State":"IL","Coal":181,"coordinates":[-87.7481,40.1781]},{"Plant":"Wood River","State":"IL","Coal":458,"coordinates":[-90.1347,38.8639]},{"Plant":"Dallman","State":"IL","Coal":372,"coordinates":[-89.6024,39.7548]},{"Plant":"Marion","State":"IL","Coal":290,"coordinates":[-88.9531,37.6197]},{"Plant":"State Line Energy","State":"IN","Coal":515,"coordinates":[-87.5217,41.7072]},{"Plant":"Clifty Creek","State":"IN","Coal":1195.8,"coordinates":[-85.4206,38.7378]},{"Plant":"Tanners Creek","State":"IN","Coal":995,"coordinates":[-84.8594,39.0814]},{"Plant":"Harding Street","State":"IN","Coal":647,"coordinates":[-86.1969,39.7113]},{"Plant":"Eagle Valley","State":"IN","Coal":260,"coordinates":[-86.4183,39.4852]},{"Plant":"AES Petersburg","State":"IN","Coal":1722,"coordinates":[-87.2525,38.5281]},{"Plant":"Bailly","State":"IN","Coal":480,"coordinates":[-87.1225,41.645]},{"Plant":"Dean H Mitchell","State":"IN","Coal":360,"coordinates":[-87.4069,41.6392]},{"Plant":"Michigan City","State":"IN","Coal":469,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Coal":254,"coordinates":[-87.7811,32.6017]},{"Plant":"ACE Cogeneration Facility","State":"CA","Coal":101.2,"coordinates":[-117.3836,35.7658]},{"Plant":"Cayuga","State":"IN","Coal":995,"coordinates":[-87.4244,39.9242]},{"Plant":"RED-Rochester, LLC","State":"NY","Coal":180.8,"coordinates":[-77.6319,43.1989]},{"Plant":"Edwardsport","State":"IN","Coal":120,"coordinates":[-87.2472,38.8067]},{"Plant":"Logan Generating Company LP","State":"NJ","Coal":219,"coordinates":[-75.4067,39.7928]},{"Plant":"Portsmouth Genco LLC","State":"VA","Coal":115,"coordinates":[-76.3529,36.8702]},{"Plant":"Taconite Harbor Energy Center","State":"MN","Coal":200,"coordinates":[-90.9114,47.5314]},{"Plant":"R Gallagher","State":"IN","Coal":560,"coordinates":[-85.8381,38.2636]},{"Plant":"Wabash River","State":"IN","Coal":942,"coordinates":[-87.4247,39.53]},{"Plant":"F B Culley","State":"IN","Coal":402,"coordinates":[-87.3275,37.9111]},{"Plant":"Colver Power Project","State":"PA","Coal":110,"coordinates":[-78.8,40.55]},{"Plant":"Florida Power Development","State":"FL","Coal":139,"coordinates":[-82.4311,28.5819]},{"Plant":"CPI USA NC Southport","State":"NC","Coal":107,"coordinates":[-78.0118,33.9444]},{"Plant":"Edgecombe Genco LLC","State":"NC","Coal":115.5,"coordinates":[-77.7533,36.0373]},{"Plant":"Frank E Ratts","State":"IN","Coal":244,"coordinates":[-87.2662,38.5201]},{"Plant":"Lansing","State":"IA","Coal":323.26,"coordinates":[-91.1675,43.3359]},{"Plant":"4 AC Station","State":"IN","Coal":126.5,"coordinates":[-87.4264,41.68]},{"Plant":"Milton L Kapp","State":"IA","Coal":211.19,"coordinates":[-90.2336,41.8081]},{"Plant":"Chambers Cogeneration LP","State":"NJ","Coal":262,"coordinates":[-75.4858,39.6935]},{"Plant":"AES Shady Point LLC","State":"OK","Coal":320,"coordinates":[-94.6458,35.1931]},{"Plant":"Cedar Bay Generating Company LP","State":"FL","Coal":250,"coordinates":[-81.6064,30.4225]},{"Plant":"AES Hawaii","State":"HI","Coal":180,"coordinates":[-158.1065,21.3034]},{"Plant":"AES Thames","State":"CT","Coal":181,"coordinates":[-72.055,41.2607]},{"Plant":"AES Beaver Valley Partners Beaver Valley","State":"PA","Coal":146,"coordinates":[-80.3539,40.6572]},{"Plant":"AES Warrior Run Cogeneration Facility","State":"MD","Coal":180,"coordinates":[-78.7453,39.5952]},{"Plant":"Prairie Creek","State":"IA","Coal":185.45,"coordinates":[-91.6392,41.944]},{"Plant":"Sutherland","State":"IA","Coal":143.72,"coordinates":[-92.8594,42.0473]},{"Plant":"Holcomb","State":"KS","Coal":360,"coordinates":[-100.9725,37.9308]},{"Plant":"Riverside","State":"IA","Coal":134,"coordinates":[-90.4481,41.54]},{"Plant":"Walter Scott Jr Energy Center","State":"IA","Coal":823,"coordinates":[-95.8408,41.18]},{"Plant":"Silver Bay Power","State":"MN","Coal":105,"coordinates":[-91.2605,47.2866]},{"Plant":"Archer Daniels Midland Cedar Rapids","State":"IA","Coal":260,"coordinates":[-91.6875,41.9221]},{"Plant":"Archer Daniels Midland Decatur","State":"IL","Coal":335,"coordinates":[-88.8908,39.8701]},{"Plant":"George Neal North","State":"IA","Coal":950,"coordinates":[-96.3617,42.2998]},{"Plant":"Burlington","State":"IA","Coal":209.38,"coordinates":[-91.1167,40.7412]},{"Plant":"Ames Electric Services Power Plant","State":"IA","Coal":103,"coordinates":[-93.6089,42.0258]},{"Plant":"Cholla","State":"AZ","Coal":1021,"coordinates":[-110.3033,34.9394]},{"Plant":"Muscatine Plant #1","State":"IA","Coal":236.58,"coordinates":[-91.0569,41.3917]},{"Plant":"La Cygne","State":"KS","Coal":1422,"coordinates":[-94.6456,38.3481]},{"Plant":"Lawrence Energy Center","State":"KS","Coal":550,"coordinates":[-95.2692,39.0072]},{"Plant":"Tecumseh Energy Center","State":"KS","Coal":203,"coordinates":[-95.5689,39.0539]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Coal":156,"coordinates":[-110.9047,32.16]},{"Plant":"Oklaunion","State":"TX","Coal":690,"coordinates":[-99.1753,34.0825]},{"Plant":"Quindaro","State":"KS","Coal":183,"coordinates":[-94.6381,39.1492]},{"Plant":"Cross","State":"SC","Coal":1160,"coordinates":[-80.1119,33.3692]},{"Plant":"Big Sandy","State":"KY","Coal":1060,"coordinates":[-82.6176,38.1707]},{"Plant":"E W Brown","State":"KY","Coal":697,"coordinates":[-84.7126,37.7883]},{"Plant":"Ghent","State":"KY","Coal":1945,"coordinates":[-85.035,38.7497]},{"Plant":"Green River","State":"KY","Coal":207,"coordinates":[-87.1214,37.3636]},{"Plant":"Seminole","State":"FL","Coal":1316,"coordinates":[-81.6328,29.7331]},{"Plant":"Cane Run","State":"KY","Coal":563,"coordinates":[-85.8892,38.1831]},{"Plant":"Mill Creek","State":"KY","Coal":1472,"coordinates":[-85.9103,38.0525]},{"Plant":"Elmer Smith","State":"KY","Coal":393.06,"coordinates":[-87.0608,37.7942]},{"Plant":"Paradise","State":"KY","Coal":2175,"coordinates":[-86.9783,37.2608]},{"Plant":"Shawnee","State":"KY","Coal":1329,"coordinates":[-88.775,37.1517]},{"Plant":"Kenneth C Coleman","State":"KY","Coal":455,"coordinates":[-86.7911,37.9631]},{"Plant":"HMP&L Station Two Henderson","State":"KY","Coal":312,"coordinates":[-87.5028,37.6469]},{"Plant":"Cooper","State":"KY","Coal":341,"coordinates":[-84.5919,36.9981]},{"Plant":"Dale","State":"KY","Coal":196,"coordinates":[-84.2619,37.8806]},{"Plant":"R S Nelson","State":"LA","Coal":550,"coordinates":[-93.2911,30.2844]},{"Plant":"C P Crane","State":"MD","Coal":385,"coordinates":[-76.3651,39.3236]},{"Plant":"Herbert A Wagner","State":"MD","Coal":459,"coordinates":[-76.5268,39.1781]},{"Plant":"FirstEnergy R Paul Smith Power Station","State":"MD","Coal":115,"coordinates":[-77.8269,39.595]},{"Plant":"Chalk Point LLC","State":"MD","Coal":683,"coordinates":[-76.6861,38.5444]},{"Plant":"Dickerson","State":"MD","Coal":546,"coordinates":[-77.4644,39.2097]},{"Plant":"Apache Station","State":"AZ","Coal":350,"coordinates":[-109.8931,32.0603]},{"Plant":"Mount Tom","State":"MA","Coal":143.62,"coordinates":[-72.6055,42.2806]},{"Plant":"Somerset Station","State":"MA","Coal":179.1,"coordinates":[-71.146,41.7374]},{"Plant":"Brayton Point","State":"MA","Coal":1099.46,"coordinates":[-71.1931,41.7103]},{"Plant":"Salem Harbor","State":"MA","Coal":311.79,"coordinates":[-70.8772,42.5256]},{"Plant":"GRDA","State":"OK","Coal":1010,"coordinates":[-95.2894,36.1903]},{"Plant":"B C Cobb","State":"MI","Coal":312,"coordinates":[-86.2423,43.2588]},{"Plant":"Dan E Karn","State":"MI","Coal":515,"coordinates":[-83.8401,43.645]},{"Plant":"J H Campbell","State":"MI","Coal":1435,"coordinates":[-86.2007,42.9103]},{"Plant":"J C Weadock","State":"MI","Coal":302,"coordinates":[-83.8447,43.6399]},{"Plant":"J R Whiting","State":"MI","Coal":328,"coordinates":[-83.4495,41.7921]},{"Plant":"Harbor Beach","State":"MI","Coal":103,"coordinates":[-82.6436,43.8519]},{"Plant":"Marysville","State":"MI","Coal":167,"coordinates":[-82.4606,42.9256]},{"Plant":"Monroe","State":"MI","Coal":3115,"coordinates":[-83.3464,41.8906]},{"Plant":"River Rouge","State":"MI","Coal":523,"coordinates":[-83.1119,42.2739]},{"Plant":"St Clair","State":"MI","Coal":1368,"coordinates":[-82.4719,42.7642]},{"Plant":"Trenton Channel","State":"MI","Coal":730,"coordinates":[-83.1808,42.1217]},{"Plant":"Presque Isle","State":"MI","Coal":609,"coordinates":[-87.395,46.5789]},{"Plant":"Eckert Station","State":"MI","Coal":327.14,"coordinates":[-84.5581,42.7184]},{"Plant":"Erickson Station","State":"MI","Coal":151.5,"coordinates":[-84.6572,42.6922]},{"Plant":"Syl Laskin","State":"MN","Coal":110,"coordinates":[-92.1619,47.5306]},{"Plant":"Clay Boswell","State":"MN","Coal":916.53,"coordinates":[-93.6528,47.2611]},{"Plant":"Black Dog","State":"MN","Coal":353.7,"coordinates":[-93.2501,44.8108]},{"Plant":"High Bridge","State":"MN","Coal":271.1,"coordinates":[-93.1117,44.9314]},{"Plant":"Allen S King","State":"MN","Coal":527.76,"coordinates":[-92.7786,45.03]},{"Plant":"Riverside","State":"MN","Coal":381.25,"coordinates":[-93.2753,45.0203]},{"Plant":"Hoot Lake","State":"MN","Coal":151.6,"coordinates":[-96.0433,46.2906]},{"Plant":"Silver Lake","State":"MN","Coal":106.96,"coordinates":[-92.4604,44.0282]},{"Plant":"Jack Watson","State":"MS","Coal":706,"coordinates":[-89.0286,30.4392]},{"Plant":"St Johns River Power Park","State":"FL","Coal":1252,"coordinates":[-81.5508,30.4308]},{"Plant":"Asbury","State":"MO","Coal":210,"coordinates":[-94.5893,37.3613]},{"Plant":"Hawthorn","State":"MO","Coal":563,"coordinates":[-94.4778,39.1306]},{"Plant":"Montrose","State":"MO","Coal":510,"coordinates":[-93.9348,38.3114]},{"Plant":"Sibley","State":"MO","Coal":508.3,"coordinates":[-94.1844,39.1783]},{"Plant":"Labadie","State":"MO","Coal":2415,"coordinates":[-90.8377,38.5622]},{"Plant":"Meramec","State":"MO","Coal":858,"coordinates":[-90.3358,38.4017]},{"Plant":"Sioux","State":"MO","Coal":994,"coordinates":[-90.2902,38.9155]},{"Plant":"James River Power Station","State":"MO","Coal":236,"coordinates":[-93.2619,37.1086]},{"Plant":"New Madrid","State":"MO","Coal":1160,"coordinates":[-89.5617,36.5147]},{"Plant":"Thomas Hill","State":"MO","Coal":1120,"coordinates":[-92.6381,39.5522]},{"Plant":"J E Corette Plant","State":"MT","Coal":158,"coordinates":[-108.481,45.7756]},{"Plant":"Lon Wright","State":"NE","Coal":120,"coordinates":[-96.4623,41.4281]},{"Plant":"Sheldon","State":"NE","Coal":225,"coordinates":[-96.7847,40.5589]},{"Plant":"North Omaha","State":"NE","Coal":662.8,"coordinates":[-95.9447,41.3291]},{"Plant":"Reid Gardner","State":"NV","Coal":555,"coordinates":[-114.6333,36.6573]},{"Plant":"Mohave","State":"NV","Coal":1580,"coordinates":[-114.5917,35.1458]},{"Plant":"Merrimack","State":"NH","Coal":432.5,"coordinates":[-71.4692,43.1411]},{"Plant":"B L England","State":"NJ","Coal":284,"coordinates":[-74.6364,39.2908]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Coal":608,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Mercer Generating Station","State":"NJ","Coal":648,"coordinates":[-74.7339,40.1792]},{"Plant":"Four Corners","State":"NM","Coal":2060,"coordinates":[-108.4814,36.69]},{"Plant":"San Juan","State":"NM","Coal":1643,"coordinates":[-108.4386,36.8006]},{"Plant":"Danskammer Generating Station","State":"NY","Coal":369,"coordinates":[-73.975,41.5712]},{"Plant":"GMMM Westover","State":"NY","Coal":127.7,"coordinates":[-75.9747,42.1117]},{"Plant":"GMMGreenidge LLC","State":"NY","Coal":159,"coordinates":[-76.9483,42.6789]},{"Plant":"Cayuga Operating Company","State":"NY","Coal":305,"coordinates":[-76.6336,42.6028]},{"Plant":"C R Huntley Generating Station","State":"NY","Coal":816,"coordinates":[-78.93,42.97]},{"Plant":"Dunkirk Generating Plant","State":"NY","Coal":584,"coordinates":[-79.3466,42.4915]},{"Plant":"E C Gaston","State":"AL","Coal":1881,"coordinates":[-86.4581,33.2442]},{"Plant":"Lovett","State":"NY","Coal":363,"coordinates":[-73.9797,41.2578]},{"Plant":"Rochester 7","State":"NY","Coal":252,"coordinates":[-77.6294,43.2689]},{"Plant":"Asheville","State":"NC","Coal":383,"coordinates":[-82.5417,35.4731]},{"Plant":"Cape Fear","State":"NC","Coal":317,"coordinates":[-79.0495,35.595]},{"Plant":"HF Lee Plant","State":"NC","Coal":406,"coordinates":[-78.0878,35.3799]},{"Plant":"Roxboro","State":"NC","Coal":2425,"coordinates":[-79.0731,36.4833]},{"Plant":"L V Sutton Steam","State":"NC","Coal":606,"coordinates":[-77.9853,34.2831]},{"Plant":"W H Weatherspoon","State":"NC","Coal":177,"coordinates":[-78.9755,34.5875]},{"Plant":"G G Allen","State":"NC","Coal":1145,"coordinates":[-81.0122,35.1897]},{"Plant":"Buck","State":"NC","Coal":369,"coordinates":[-80.3767,35.7133]},{"Plant":"Cliffside","State":"NC","Coal":760,"coordinates":[-81.7594,35.22]},{"Plant":"Dan River","State":"NC","Coal":276,"coordinates":[-79.7208,36.4862]},{"Plant":"Marshall","State":"NC","Coal":2110,"coordinates":[-80.9658,35.5975]},{"Plant":"Riverbend","State":"NC","Coal":454,"coordinates":[-80.9742,35.36]},{"Plant":"R M Heskett","State":"ND","Coal":102.87,"coordinates":[-100.8836,46.8669]},{"Plant":"Leland Olds","State":"ND","Coal":669,"coordinates":[-101.3212,47.2808]},{"Plant":"Milton R Young","State":"ND","Coal":705,"coordinates":[-101.2131,47.0659]},{"Plant":"Stanton","State":"ND","Coal":187.7,"coordinates":[-101.3319,47.2866]},{"Plant":"Cardinal","State":"OH","Coal":1815,"coordinates":[-80.6486,40.2522]},{"Plant":"Walter C Beckjord","State":"OH","Coal":1118,"coordinates":[-84.2981,38.9917]},{"Plant":"Miami Fort","State":"OH","Coal":1243,"coordinates":[-84.8036,39.1128]},{"Plant":"FirstEnergy Ashtabula","State":"OH","Coal":420,"coordinates":[-80.7697,41.9086]},{"Plant":"Avon Lake","State":"OH","Coal":721,"coordinates":[-82.0546,41.5045]},{"Plant":"FirstEnergy Eastlake","State":"OH","Coal":1233,"coordinates":[-81.4425,41.6711]},{"Plant":"FirstEnergy Lake Shore","State":"OH","Coal":245,"coordinates":[-81.6419,41.5356]},{"Plant":"Conesville","State":"OH","Coal":1925,"coordinates":[-81.8811,40.1842]},{"Plant":"O H Hutchings","State":"OH","Coal":365,"coordinates":[-84.2921,39.6088]},{"Plant":"J M Stuart","State":"OH","Coal":2388,"coordinates":[-83.6939,38.6361]},{"Plant":"Niles","State":"OH","Coal":216,"coordinates":[-80.7477,41.1669]},{"Plant":"FirstEnergy R E Burger","State":"OH","Coal":518,"coordinates":[-80.7608,39.91]},{"Plant":"FirstEnergy W H Sammis","State":"OH","Coal":2220,"coordinates":[-80.6319,40.5317]},{"Plant":"FirstEnergy Toronto","State":"OH","Coal":172,"coordinates":[-80.6044,40.4825]},{"Plant":"Muskingum River","State":"OH","Coal":1375,"coordinates":[-81.6797,39.5908]},{"Plant":"Kyger Creek","State":"OH","Coal":985.7,"coordinates":[-82.1289,38.9144]},{"Plant":"FirstEnergy Bay Shore","State":"OH","Coal":495,"coordinates":[-83.4378,41.6917]},{"Plant":"Lake Road","State":"OH","Coal":160,"coordinates":[-81.6494,41.5278]},{"Plant":"Muskogee","State":"OK","Coal":1547.1,"coordinates":[-95.2873,35.7614]},{"Plant":"Northeastern","State":"OK","Coal":918,"coordinates":[-95.7008,36.4317]},{"Plant":"Limestone","State":"TX","Coal":1700,"coordinates":[-96.2525,31.4219]},{"Plant":"Barry","State":"AL","Coal":1636,"coordinates":[-88.0103,31.0069]},{"Plant":"Elrama Power Plant","State":"PA","Coal":474,"coordinates":[-79.918,40.2518]},{"Plant":"F R Phillips","State":"PA","Coal":310,"coordinates":[-80.2286,40.5758]},{"Plant":"Portland","State":"PA","Coal":401,"coordinates":[-75.0794,40.9102]},{"Plant":"Titus","State":"PA","Coal":243,"coordinates":[-75.9081,40.3056]},{"Plant":"Conemaugh","State":"PA","Coal":1700,"coordinates":[-79.0611,40.3842]},{"Plant":"Homer City Generating Station","State":"PA","Coal":1884,"coordinates":[-79.1961,40.5128]},{"Plant":"Seward","State":"PA","Coal":717,"coordinates":[-79.0337,40.4062]},{"Plant":"Shawville","State":"PA","Coal":597,"coordinates":[-78.3662,41.0675]},{"Plant":"Keystone","State":"PA","Coal":1700,"coordinates":[-79.3411,40.6604]},{"Plant":"New Castle Plant","State":"PA","Coal":413,"coordinates":[-80.369,40.9379]},{"Plant":"Brunner Island","State":"PA","Coal":1448,"coordinates":[-76.6962,40.0961]},{"Plant":"PPL Martins Creek","State":"PA","Coal":280,"coordinates":[-75.1054,40.7978]},{"Plant":"PPL Montour","State":"PA","Coal":1525,"coordinates":[-76.6672,41.0714]},{"Plant":"Sunbury Generation LP","State":"PA","Coal":373,"coordinates":[-76.825,40.8361]},{"Plant":"Cromby Generating Station","State":"PA","Coal":144,"coordinates":[-75.5294,40.1531]},{"Plant":"Eddystone Generating Station","State":"PA","Coal":588,"coordinates":[-75.323,39.858]},{"Plant":"FirstEnergy Armstrong Power Station","State":"PA","Coal":343,"coordinates":[-79.4656,40.9292]},{"Plant":"Hatfields Ferry Power Station","State":"PA","Coal":1590,"coordinates":[-79.9275,39.8556]},{"Plant":"FirstEnergy Mitchell Power Station","State":"PA","Coal":277,"coordinates":[-79.9683,40.2211]},{"Plant":"H B Robinson","State":"SC","Coal":180,"coordinates":[-80.1589,34.4017]},{"Plant":"W S Lee","State":"SC","Coal":370,"coordinates":[-82.435,34.6022]},{"Plant":"Canadys Steam","State":"SC","Coal":396,"coordinates":[-80.6228,33.0647]},{"Plant":"Wateree","State":"SC","Coal":700,"coordinates":[-80.6228,33.8264]},{"Plant":"Williams","State":"SC","Coal":615,"coordinates":[-79.9297,33.0158]},{"Plant":"Dolphus M Grainger","State":"SC","Coal":170,"coordinates":[-79.0533,33.8264]},{"Plant":"Jefferies","State":"SC","Coal":306,"coordinates":[-79.9875,33.2422]},{"Plant":"Allen Steam Plant","State":"TN","Coal":735,"coordinates":[-90.1487,35.0741]},{"Plant":"Bull Run","State":"TN","Coal":885,"coordinates":[-84.1567,36.0211]},{"Plant":"Cumberland","State":"TN","Coal":2462,"coordinates":[-87.6539,36.3903]},{"Plant":"Gallatin","State":"TN","Coal":964,"coordinates":[-86.4006,36.3156]},{"Plant":"John Sevier","State":"TN","Coal":704,"coordinates":[-82.9639,36.3767]},{"Plant":"Johnsonville","State":"TN","Coal":1200,"coordinates":[-87.9861,36.0278]},{"Plant":"Kingston","State":"TN","Coal":1411,"coordinates":[-84.5194,35.8992]},{"Plant":"Watts Bar Fossil","State":"TN","Coal":224,"coordinates":[-84.7811,35.6108]},{"Plant":"W A Parish","State":"TX","Coal":2490,"coordinates":[-95.6311,29.4828]},{"Plant":"Big Brown","State":"TX","Coal":1150,"coordinates":[-96.0544,31.8206]},{"Plant":"Carbon","State":"UT","Coal":172,"coordinates":[-110.8644,39.7272]},{"Plant":"Clinch River","State":"VA","Coal":690,"coordinates":[-82.1997,36.9333]},{"Plant":"Glen Lyn","State":"VA","Coal":325,"coordinates":[-80.8633,37.3706]},{"Plant":"Potomac River","State":"VA","Coal":482,"coordinates":[-77.0411,38.8203]},{"Plant":"Chesapeake","State":"VA","Coal":595,"coordinates":[-76.3019,36.7711]},{"Plant":"Yorktown","State":"VA","Coal":323,"coordinates":[-76.4611,37.2144]},{"Plant":"Joliet 29","State":"IL","Coal":1036,"coordinates":[-88.1238,41.4946]},{"Plant":"Transalta Centralia Generation","State":"WA","Coal":1405,"coordinates":[-122.8598,46.7559]},{"Plant":"John E Amos","State":"WV","Coal":2900,"coordinates":[-81.8233,38.4731]},{"Plant":"Kanawha River","State":"WV","Coal":400,"coordinates":[-81.4211,38.2056]},{"Plant":"Philip Sporn","State":"WV","Coal":1020,"coordinates":[-81.9231,38.9669]},{"Plant":"FirstEnergy Albright","State":"WV","Coal":283,"coordinates":[-79.6369,39.4886]},{"Plant":"FirstEnergy Fort Martin Power Station","State":"WV","Coal":1107,"coordinates":[-79.9275,39.7108]},{"Plant":"FirstEnergy Harrison Power Station","State":"WV","Coal":1945,"coordinates":[-80.3325,39.3842]},{"Plant":"FirstEnergy Rivesville","State":"WV","Coal":137,"coordinates":[-80.1131,39.5314]},{"Plant":"FirstEnergy Willow Island","State":"WV","Coal":235,"coordinates":[-81.3,39.3672]},{"Plant":"Kammer","State":"WV","Coal":600,"coordinates":[-80.8186,39.8461]},{"Plant":"Mitchell","State":"WV","Coal":1600,"coordinates":[-80.8153,39.8297]},{"Plant":"Blount Street","State":"WI","Coal":194.1,"coordinates":[-89.3744,43.0789]},{"Plant":"Port Washington Generating Station","State":"WI","Coal":305,"coordinates":[-87.8689,43.3842]},{"Plant":"South Oak Creek","State":"WI","Coal":1135,"coordinates":[-87.8294,42.8457]},{"Plant":"Valley","State":"WI","Coal":267,"coordinates":[-87.9233,43.0303]},{"Plant":"Edgewater","State":"WI","Coal":811.51,"coordinates":[-87.7059,43.7151]},{"Plant":"Nelson Dewey Coal Refining Facility","State":"WI","Coal":217.83,"coordinates":[-91.0085,42.7225]},{"Plant":"Pulliam","State":"WI","Coal":397,"coordinates":[-88.0086,44.54]},{"Plant":"Weston","State":"WI","Coal":487.4,"coordinates":[-89.6553,44.8606]},{"Plant":"Alma","State":"WI","Coal":184.27,"coordinates":[-91.9111,44.3083]},{"Plant":"Genoa","State":"WI","Coal":356.24,"coordinates":[-91.2325,43.5589]},{"Plant":"Dave Johnston","State":"WY","Coal":762,"coordinates":[-105.7769,42.8378]},{"Plant":"Naughton","State":"WY","Coal":700,"coordinates":[-110.5983,41.7581]},{"Plant":"John P Madgett","State":"WI","Coal":397.59,"coordinates":[-91.9126,44.3036]},{"Plant":"Arapahoe","State":"CO","Coal":246,"coordinates":[-105.0028,39.67]},{"Plant":"Cherokee","State":"CO","Coal":717,"coordinates":[-104.9645,39.8073]},{"Plant":"Colbert","State":"AL","Coal":1168,"coordinates":[-87.8486,34.7439]},{"Plant":"Comanche","State":"CO","Coal":660,"coordinates":[-104.5747,38.2081]},{"Plant":"Valmont","State":"CO","Coal":186,"coordinates":[-105.202,40.0195]},{"Plant":"Martin Drake","State":"CO","Coal":254,"coordinates":[-104.8333,38.8244]},{"Plant":"Navajo","State":"AZ","Coal":2250,"coordinates":[-111.3886,36.9047]},{"Plant":"Widows Creek","State":"AL","Coal":1604,"coordinates":[-85.7553,34.883]},{"Plant":"G F Weaton Power Station","State":"PA","Coal":112,"coordinates":[-80.3462,40.6673]},{"Plant":"International Paper Savanna Mill","State":"GA","Coal":189.09,"coordinates":[-81.1242,32.1004]},{"Plant":"Tennessee Eastman Operations","State":"TN","Coal":194.3,"coordinates":[-82.5431,36.5219]},{"Plant":"Axiall Natrium Plant","State":"WV","Coal":123,"coordinates":[-80.8547,39.7475]},{"Plant":"Northampton Generating Company LP","State":"PA","Coal":112,"coordinates":[-75.4792,40.6917]},{"Plant":"Indiantown Cogeneration LP","State":"FL","Coal":330,"coordinates":[-80.5125,27.0389]},{"Plant":"Dolet Hills","State":"LA","Coal":650,"coordinates":[-93.5692,32.0306]},{"Plant":"Mecklenburg Power Station","State":"VA","Coal":138,"coordinates":[-78.53,36.6]},{"Plant":"Sandow No 5","State":"TX","Coal":363,"coordinates":[-97.0614,30.5681]},{"Plant":"Hayden","State":"CO","Coal":446,"coordinates":[-107.185,40.4856]},{"Plant":"Roanoke Valley Energy Facililty I","State":"NC","Coal":165,"coordinates":[-77.6167,36.4364]},{"Plant":"Spruance Genco LLC","State":"VA","Coal":190,"coordinates":[-77.4308,37.4556]},{"Plant":"Birchwood Power","State":"VA","Coal":238.8,"coordinates":[-77.3147,38.2667]},{"Plant":"Red Hills Generating Facility","State":"MS","Coal":440,"coordinates":[-89.2183,33.3761]},{"Plant":"Hardin Generator Project","State":"MT","Coal":108.6,"coordinates":[-107.6,45.7578]},{"Plant":"Charles R Lowman","State":"AL","Coal":556,"coordinates":[-87.9107,31.488]},{"Plant":"Kennecott Power Plant","State":"UT","Coal":155,"coordinates":[-112.1225,40.7119]},{"Plant":"Stanton Energy Center","State":"FL","Coal":886,"coordinates":[-81.1678,28.4822]},{"Plant":"Bridgeport Station","State":"CT","Coal":370.3,"coordinates":[-73.1844,41.1706]},{"Plant":"Edge Moor","State":"DE","Coal":260,"coordinates":[-75.5038,39.7389]},{"Plant":"Indian River Generating Station","State":"DE","Coal":780,"coordinates":[-75.2341,38.5857]},{"Plant":"James H Miller Jr","State":"AL","Coal":2746.3,"coordinates":[-87.0597,33.6319]},{"Plant":"FirstEnergy Pleasants Power Station","State":"WV","Coal":1278,"coordinates":[-81.2944,39.3667]},{"Plant":"White Bluff","State":"AR","Coal":1640,"coordinates":[-92.1406,34.4228]},{"Plant":"Duck Creek","State":"IL","Coal":335,"coordinates":[-89.9841,40.4663]},{"Plant":"Newton","State":"IL","Coal":1126,"coordinates":[-88.2781,38.9361]},{"Plant":"East Bend","State":"KY","Coal":600,"coordinates":[-84.8514,38.9036]},{"Plant":"W H Zimmer","State":"OH","Coal":1300,"coordinates":[-84.2289,38.8675]},{"Plant":"Brandon Shores","State":"MD","Coal":1286,"coordinates":[-76.5389,39.18]},{"Plant":"Craig","State":"CO","Coal":1274,"coordinates":[-107.5912,40.4627]},{"Plant":"Coal Creek","State":"ND","Coal":1114.3,"coordinates":[-101.1571,47.3777]},{"Plant":"Killen Station","State":"OH","Coal":615,"coordinates":[-83.4803,38.6903]},{"Plant":"Belle River","State":"MI","Coal":1260,"coordinates":[-82.495,42.7756]},{"Plant":"H L Spurlock","State":"KY","Coal":1118,"coordinates":[-83.8181,38.7]},{"Plant":"Wansley","State":"GA","Coal":1778,"coordinates":[-85.0323,33.4134]},{"Plant":"Big Cajun 2","State":"LA","Coal":1730,"coordinates":[-91.3692,30.7261]},{"Plant":"R D Morrow","State":"MS","Coal":360,"coordinates":[-89.394,31.2186]},{"Plant":"Nearman Creek","State":"KS","Coal":229,"coordinates":[-94.6975,39.1681]},{"Plant":"Iatan","State":"MO","Coal":651,"coordinates":[-94.98,39.4472]},{"Plant":"Jeffrey Energy Center","State":"KS","Coal":2190,"coordinates":[-96.1172,39.2865]},{"Plant":"Trimble County","State":"KY","Coal":511,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Coal":1013,"coordinates":[-88.5553,30.5322]},{"Plant":"Colstrip","State":"MT","Coal":2094,"coordinates":[-106.614,45.8831]},{"Plant":"Gerald Gentleman","State":"NE","Coal":1365,"coordinates":[-101.1408,41.0808]},{"Plant":"Somerset Operating Co LLC","State":"NY","Coal":680.8,"coordinates":[-78.6047,43.3589]},{"Plant":"R M Schahfer","State":"IN","Coal":1625,"coordinates":[-87.0261,41.2164]},{"Plant":"Sherburne County","State":"MN","Coal":2238.6,"coordinates":[-93.8931,45.3808]},{"Plant":"FirstEnergy Bruce Mansfield","State":"PA","Coal":2460,"coordinates":[-80.4159,40.6348]},{"Plant":"Sooner","State":"OK","Coal":1066,"coordinates":[-97.0528,36.4531]},{"Plant":"Nebraska City","State":"NE","Coal":646,"coordinates":[-95.7764,40.6214]},{"Plant":"Big Stone","State":"SD","Coal":470.2,"coordinates":[-96.5101,45.3037]},{"Plant":"Wyodak","State":"WY","Coal":335,"coordinates":[-105.3815,44.2901]},{"Plant":"Boardman","State":"OR","Coal":585,"coordinates":[-119.8088,45.6932]},{"Plant":"Gibson","State":"IN","Coal":3131,"coordinates":[-87.7658,38.3722]},{"Plant":"McIntosh","State":"GA","Coal":156.5,"coordinates":[-81.1683,32.3563]},{"Plant":"Gibbons Creek","State":"TX","Coal":462,"coordinates":[-96.0818,30.6199]},{"Plant":"A B Brown","State":"IN","Coal":490,"coordinates":[-87.715,37.9053]},{"Plant":"Flint Creek","State":"AR","Coal":528,"coordinates":[-94.5241,36.2561]},{"Plant":"Welsh","State":"TX","Coal":1584,"coordinates":[-94.84,33.0552]},{"Plant":"Martin Lake","State":"TX","Coal":2250,"coordinates":[-94.5706,32.2606]},{"Plant":"Monticello","State":"TX","Coal":1880,"coordinates":[-95.0417,33.0917]},{"Plant":"Rush Island","State":"MO","Coal":1208,"coordinates":[-90.2632,38.1312]},{"Plant":"Hunter","State":"UT","Coal":1320,"coordinates":[-111.0289,39.1747]},{"Plant":"Rockport","State":"IN","Coal":2600,"coordinates":[-87.0372,37.9256]},{"Plant":"Pleasant Prairie","State":"WI","Coal":1224,"coordinates":[-87.9033,42.5381]},{"Plant":"Coronado","State":"AZ","Coal":785,"coordinates":[-109.2708,34.5789]},{"Plant":"Coleto Creek","State":"TX","Coal":632,"coordinates":[-97.2142,28.7128]},{"Plant":"Fayette Power Project","State":"TX","Coal":1641,"coordinates":[-96.7506,29.9172]},{"Plant":"J T Deely","State":"TX","Coal":770,"coordinates":[-98.3228,29.3081]},{"Plant":"San Miguel","State":"TX","Coal":391,"coordinates":[-98.4775,28.7044]},{"Plant":"Brame Energy Center","State":"LA","Coal":523,"coordinates":[-92.7167,31.395]},{"Plant":"Harrington","State":"TX","Coal":1041,"coordinates":[-101.7472,35.2982]},{"Plant":"Tolk","State":"TX","Coal":1080,"coordinates":[-102.57,34.1865]},{"Plant":"John Twitty Energy Center","State":"MO","Coal":178,"coordinates":[-93.388,37.1517]},{"Plant":"Laramie River Station","State":"WY","Coal":1705,"coordinates":[-104.8825,42.1089]},{"Plant":"Merom","State":"IN","Coal":1000,"coordinates":[-87.5108,39.0694]},{"Plant":"Pawnee","State":"CO","Coal":505,"coordinates":[-103.6803,40.2217]},{"Plant":"Winyah","State":"SC","Coal":1155,"coordinates":[-79.3581,33.3317]},{"Plant":"Mayo","State":"NC","Coal":741,"coordinates":[-78.8917,36.5278]},{"Plant":"Ottumwa","State":"IA","Coal":672.63,"coordinates":[-92.5558,41.0961]},{"Plant":"Scherer","State":"GA","Coal":3404.7,"coordinates":[-83.8075,33.0606]},{"Plant":"Mountaineer","State":"WV","Coal":1300,"coordinates":[-81.9344,38.9794]},{"Plant":"Crystal River","State":"FL","Coal":2313,"coordinates":[-82.6977,28.9656]},{"Plant":"Crist","State":"FL","Coal":930,"coordinates":[-87.2244,30.5661]},{"Plant":"Lansing Smith","State":"FL","Coal":357,"coordinates":[-85.7003,30.2686]},{"Plant":"Big Bend","State":"FL","Coal":1593,"coordinates":[-82.4036,27.7944]},{"Plant":"F J Gannon","State":"FL","Coal":508,"coordinates":[-82.4231,27.9072]},{"Plant":"Antelope Valley","State":"ND","Coal":900,"coordinates":[-101.3194,47.2819]},{"Plant":"Intermountain Power Project","State":"UT","Coal":1800,"coordinates":[-112.5802,39.5097]},{"Plant":"Deerhaven Generating Station","State":"FL","Coal":228,"coordinates":[-82.3878,29.7592]},{"Plant":"R D Green","State":"KY","Coal":464,"coordinates":[-87.5,37.6461]},{"Plant":"Independence","State":"AR","Coal":1678,"coordinates":[-91.4088,35.6784]},{"Plant":"Sandow No 4","State":"TX","Coal":545,"coordinates":[-97.064,30.5659]},{"Plant":"Louisa","State":"IA","Coal":700,"coordinates":[-91.0931,41.3181]},{"Plant":"Warrick","State":"IN","Coal":693,"coordinates":[-87.3328,37.915]},{"Plant":"C D McIntosh Jr","State":"FL","Coal":342,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Coal":274,"coordinates":[-105.0212,40.8609]},{"Plant":"Sikeston Power Station","State":"MO","Coal":233,"coordinates":[-89.6209,36.8791]},{"Plant":"Hugo","State":"OK","Coal":440,"coordinates":[-95.3206,34.0158]},{"Plant":"D B Wilson","State":"KY","Coal":420,"coordinates":[-87.0806,37.4497]},{"Plant":"Gadsden","State":"AL","Coal":130,"coordinates":[-85.9708,34.0128]},{"Plant":"Bowen","State":"GA","Coal":3222,"coordinates":[-84.9222,34.1256]},{"Plant":"Major Oak Power","State":"TX","Coal":305,"coordinates":[-96.695,31.0919]},{"Plant":"Hammond","State":"GA","Coal":846,"coordinates":[-85.3456,34.2528]},{"Plant":"Harllee Branch","State":"GA","Coal":1607,"coordinates":[-83.2983,33.195]},{"Plant":"J K Spruce","State":"TX","Coal":555,"coordinates":[-98.3203,29.3097]},{"Plant":"Jack McDonough","State":"GA","Coal":517,"coordinates":[-84.4758,33.8239]},{"Plant":"Polk","State":"FL","Coal":255,"coordinates":[-81.9897,27.7286]},{"Plant":"Mitchell","State":"GA","Coal":195,"coordinates":[-84.1347,31.4447]},{"Plant":"Yates","State":"GA","Coal":1295,"coordinates":[-84.8986,33.4622]},{"Plant":"Richard Gorsuch","State":"OH","Coal":200,"coordinates":[-81.5211,39.3664]},{"Plant":"Kraft","State":"GA","Coal":201,"coordinates":[-81.1458,32.1486]},{"Plant":"George Neal South","State":"IA","Coal":632,"coordinates":[-96.3617,42.3006]},{"Plant":"Bonanza","State":"UT","Coal":458,"coordinates":[-109.2844,40.0864]},{"Plant":"Pirkey","State":"TX","Coal":675,"coordinates":[-94.4852,32.4607]},{"Plant":"Gorgas","State":"AL","Coal":1247,"coordinates":[-87.1965,33.6443]},{"Plant":"Columbia","State":"WI","Coal":1113.82,"coordinates":[-89.4203,43.4864]},{"Plant":"Belews Creek","State":"NC","Coal":2270,"coordinates":[-80.0603,36.2811]},{"Plant":"Jim Bridger","State":"WY","Coal":2120,"coordinates":[-108.7875,41.7378]},{"Plant":"Huntington","State":"UT","Coal":895,"coordinates":[-111.0781,39.3792]},{"Plant":"General James M Gavin","State":"OH","Coal":2610,"coordinates":[-82.1158,38.9347]},{"Plant":"Ray D Nixon","State":"CO","Coal":208,"coordinates":[-104.7058,38.6335]},{"Plant":"Coyote","State":"ND","Coal":427,"coordinates":[-101.8157,47.2214]},{"Plant":"Springerville","State":"AZ","Coal":1200,"coordinates":[-109.1639,34.3186]},{"Plant":"North Valmy","State":"NV","Coal":522,"coordinates":[-117.1516,40.8813]},{"Plant":"Cheswick Power Plant","State":"PA","Coal":580,"coordinates":[-79.7906,40.5383]},{"Plant":"E D Edwards","State":"IL","Coal":749,"coordinates":[-89.6631,40.5958]},{"Plant":"Coffeen","State":"IL","Coal":900,"coordinates":[-89.4031,39.0586]},{"Plant":"Hutsonville","State":"IL","Coal":153,"coordinates":[-87.6597,39.1333]},{"Plant":"Meredosia","State":"IL","Coal":327,"coordinates":[-90.5672,39.8233]},{"Plant":"Crawford","State":"IL","Coal":532,"coordinates":[-87.7229,41.8285]},{"Plant":"Escalante","State":"NM","Coal":247,"coordinates":[-108.082,35.4159]},{"Plant":"Joliet 9","State":"IL","Coal":314,"coordinates":[-88.1153,41.4931]},{"Plant":"Kincaid Generation LLC","State":"IL","Coal":1168,"coordinates":[-89.4964,39.5906]},{"Plant":"Powerton","State":"IL","Coal":1538,"coordinates":[-89.6786,40.5408]},{"Plant":"Waukegan","State":"IL","Coal":789,"coordinates":[-87.8133,42.3833]},{"Plant":"Will County","State":"IL","Coal":1060,"coordinates":[-88.0629,41.6334]},{"Plant":"Fisk Street","State":"IL","Coal":326,"coordinates":[-87.6533,41.8508]},{"Plant":"Joppa Steam","State":"IL","Coal":1002,"coordinates":[-88.8589,37.2094]},{"Plant":"Baldwin Energy Complex","State":"IL","Coal":1764,"coordinates":[-89.8544,38.205]},{"Plant":"Havana","State":"IL","Coal":438,"coordinates":[-90.08,40.2797]},{"Plant":"Hennepin Power Station","State":"IL","Coal":282,"coordinates":[-89.315,41.3028]},{"Plant":"Vermilion","State":"IL","Coal":163,"coordinates":[-87.7481,40.1781]},{"Plant":"Wood River","State":"IL","Coal":437,"coordinates":[-90.1347,38.8639]},{"Plant":"Dallman","State":"IL","Coal":372,"coordinates":[-89.6024,39.7548]},{"Plant":"Marion","State":"IL","Coal":290,"coordinates":[-88.9531,37.6197]},{"Plant":"State Line Energy","State":"IN","Coal":515,"coordinates":[-87.5217,41.7072]},{"Plant":"Clifty Creek","State":"IN","Coal":1195.8,"coordinates":[-85.4206,38.7378]},{"Plant":"Tanners Creek","State":"IN","Coal":990,"coordinates":[-84.8594,39.0814]},{"Plant":"Harding Street","State":"IN","Coal":647,"coordinates":[-86.1969,39.7113]},{"Plant":"Eagle Valley","State":"IN","Coal":260,"coordinates":[-86.4183,39.4852]},{"Plant":"AES Petersburg","State":"IN","Coal":1752,"coordinates":[-87.2525,38.5281]},{"Plant":"Bailly","State":"IN","Coal":480,"coordinates":[-87.1225,41.645]},{"Plant":"Dean H Mitchell","State":"IN","Coal":360,"coordinates":[-87.4069,41.6392]},{"Plant":"Michigan City","State":"IN","Coal":469,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Coal":497,"coordinates":[-87.7811,32.6017]},{"Plant":"ACE Cogeneration Facility","State":"CA","Coal":101.2,"coordinates":[-117.3836,35.7658]},{"Plant":"Cayuga","State":"IN","Coal":995,"coordinates":[-87.4244,39.9242]},{"Plant":"RED-Rochester, LLC","State":"NY","Coal":180.8,"coordinates":[-77.6319,43.1989]},{"Plant":"Edwardsport","State":"IN","Coal":120,"coordinates":[-87.2472,38.8067]},{"Plant":"Logan Generating Company LP","State":"NJ","Coal":219,"coordinates":[-75.4067,39.7928]},{"Plant":"Portsmouth Genco LLC","State":"VA","Coal":115,"coordinates":[-76.3529,36.8702]},{"Plant":"Taconite Harbor Energy Center","State":"MN","Coal":200,"coordinates":[-90.9114,47.5314]},{"Plant":"R Gallagher","State":"IN","Coal":560,"coordinates":[-85.8381,38.2636]},{"Plant":"Wabash River","State":"IN","Coal":942,"coordinates":[-87.4247,39.53]},{"Plant":"F B Culley","State":"IN","Coal":402,"coordinates":[-87.3275,37.9111]},{"Plant":"Colver Power Project","State":"PA","Coal":110,"coordinates":[-78.8,40.55]},{"Plant":"Florida Power Development","State":"FL","Coal":139,"coordinates":[-82.4311,28.5819]},{"Plant":"CPI USA NC Southport","State":"NC","Coal":107,"coordinates":[-78.0118,33.9444]},{"Plant":"Edgecombe Genco LLC","State":"NC","Coal":115.6,"coordinates":[-77.7533,36.0373]},{"Plant":"Frank E Ratts","State":"IN","Coal":245,"coordinates":[-87.2662,38.5201]},{"Plant":"Lansing","State":"IA","Coal":319.9,"coordinates":[-91.1675,43.3359]},{"Plant":"4 AC Station","State":"IN","Coal":126.6,"coordinates":[-87.4264,41.68]},{"Plant":"Milton L Kapp","State":"IA","Coal":212.4,"coordinates":[-90.2336,41.8081]},{"Plant":"Chambers Cogeneration LP","State":"NJ","Coal":262,"coordinates":[-75.4858,39.6935]},{"Plant":"AES Shady Point LLC","State":"OK","Coal":320,"coordinates":[-94.6458,35.1931]},{"Plant":"Cedar Bay Generating Company LP","State":"FL","Coal":250,"coordinates":[-81.6064,30.4225]},{"Plant":"AES Hawaii","State":"HI","Coal":180,"coordinates":[-158.1065,21.3034]},{"Plant":"AES Thames","State":"CT","Coal":181,"coordinates":[-72.055,41.2607]},{"Plant":"AES Beaver Valley Partners Beaver Valley","State":"PA","Coal":146,"coordinates":[-80.3539,40.6572]},{"Plant":"AES Warrior Run Cogeneration Facility","State":"MD","Coal":180,"coordinates":[-78.7453,39.5952]},{"Plant":"Prairie Creek","State":"IA","Coal":207.9,"coordinates":[-91.6392,41.944]},{"Plant":"Sutherland","State":"IA","Coal":140.8,"coordinates":[-92.8594,42.0473]},{"Plant":"Holcomb","State":"KS","Coal":360,"coordinates":[-100.9725,37.9308]},{"Plant":"Riverside","State":"IA","Coal":135,"coordinates":[-90.4481,41.54]},{"Plant":"Walter Scott Jr Energy Center","State":"IA","Coal":1623,"coordinates":[-95.8408,41.18]},{"Plant":"Silver Bay Power","State":"MN","Coal":105,"coordinates":[-91.2605,47.2866]},{"Plant":"Archer Daniels Midland Cedar Rapids","State":"IA","Coal":260,"coordinates":[-91.6875,41.9221]},{"Plant":"Archer Daniels Midland Decatur","State":"IL","Coal":335,"coordinates":[-88.8908,39.8701]},{"Plant":"George Neal North","State":"IA","Coal":938.6,"coordinates":[-96.3617,42.2998]},{"Plant":"Burlington","State":"IA","Coal":191.9,"coordinates":[-91.1167,40.7412]},{"Plant":"Ames Electric Services Power Plant","State":"IA","Coal":107.7,"coordinates":[-93.6089,42.0258]},{"Plant":"Cholla","State":"AZ","Coal":1021,"coordinates":[-110.3033,34.9394]},{"Plant":"Muscatine Plant #1","State":"IA","Coal":234.3,"coordinates":[-91.0569,41.3917]},{"Plant":"La Cygne","State":"KS","Coal":1418,"coordinates":[-94.6456,38.3481]},{"Plant":"Lawrence Energy Center","State":"KS","Coal":558,"coordinates":[-95.2692,39.0072]},{"Plant":"Tecumseh Energy Center","State":"KS","Coal":204,"coordinates":[-95.5689,39.0539]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Coal":156,"coordinates":[-110.9047,32.16]},{"Plant":"Oklaunion","State":"TX","Coal":650,"coordinates":[-99.1753,34.0825]},{"Plant":"Quindaro","State":"KS","Coal":183,"coordinates":[-94.6381,39.1492]},{"Plant":"Cross","State":"SC","Coal":1713.8,"coordinates":[-80.1119,33.3692]},{"Plant":"Big Sandy","State":"KY","Coal":1060,"coordinates":[-82.6176,38.1707]},{"Plant":"E W Brown","State":"KY","Coal":697,"coordinates":[-84.7126,37.7883]},{"Plant":"Ghent","State":"KY","Coal":1932,"coordinates":[-85.035,38.7497]},{"Plant":"Green River","State":"KY","Coal":207,"coordinates":[-87.1214,37.3636]},{"Plant":"Seminole","State":"FL","Coal":1316,"coordinates":[-81.6328,29.7331]},{"Plant":"Cane Run","State":"KY","Coal":563,"coordinates":[-85.8892,38.1831]},{"Plant":"Mill Creek","State":"KY","Coal":1472,"coordinates":[-85.9103,38.0525]},{"Plant":"Elmer Smith","State":"KY","Coal":392.5,"coordinates":[-87.0608,37.7942]},{"Plant":"Paradise","State":"KY","Coal":2201,"coordinates":[-86.9783,37.2608]},{"Plant":"Shawnee","State":"KY","Coal":1329,"coordinates":[-88.775,37.1517]},{"Plant":"Kenneth C Coleman","State":"KY","Coal":443,"coordinates":[-86.7911,37.9631]},{"Plant":"HMP&L Station Two Henderson","State":"KY","Coal":311.2,"coordinates":[-87.5028,37.6469]},{"Plant":"Cooper","State":"KY","Coal":341,"coordinates":[-84.5919,36.9981]},{"Plant":"Dale","State":"KY","Coal":195,"coordinates":[-84.2619,37.8806]},{"Plant":"R S Nelson","State":"LA","Coal":550,"coordinates":[-93.2911,30.2844]},{"Plant":"C P Crane","State":"MD","Coal":385,"coordinates":[-76.3651,39.3236]},{"Plant":"Herbert A Wagner","State":"MD","Coal":459,"coordinates":[-76.5268,39.1781]},{"Plant":"FirstEnergy R Paul Smith Power Station","State":"MD","Coal":115,"coordinates":[-77.8269,39.595]},{"Plant":"Chalk Point LLC","State":"MD","Coal":683,"coordinates":[-76.6861,38.5444]},{"Plant":"Dickerson","State":"MD","Coal":546,"coordinates":[-77.4644,39.2097]},{"Plant":"Apache Station","State":"AZ","Coal":350,"coordinates":[-109.8931,32.0603]},{"Plant":"Mount Tom","State":"MA","Coal":143.6,"coordinates":[-72.6055,42.2806]},{"Plant":"Somerset Station","State":"MA","Coal":179.1,"coordinates":[-71.146,41.7374]},{"Plant":"Brayton Point","State":"MA","Coal":1099.5,"coordinates":[-71.1931,41.7103]},{"Plant":"Salem Harbor","State":"MA","Coal":311.8,"coordinates":[-70.8772,42.5256]},{"Plant":"GRDA","State":"OK","Coal":1010,"coordinates":[-95.2894,36.1903]},{"Plant":"B C Cobb","State":"MI","Coal":312,"coordinates":[-86.2423,43.2588]},{"Plant":"Dan E Karn","State":"MI","Coal":515,"coordinates":[-83.8401,43.645]},{"Plant":"J H Campbell","State":"MI","Coal":1440,"coordinates":[-86.2007,42.9103]},{"Plant":"J C Weadock","State":"MI","Coal":306,"coordinates":[-83.8447,43.6399]},{"Plant":"J R Whiting","State":"MI","Coal":328,"coordinates":[-83.4495,41.7921]},{"Plant":"Harbor Beach","State":"MI","Coal":103,"coordinates":[-82.6436,43.8519]},{"Plant":"Marysville","State":"MI","Coal":166,"coordinates":[-82.4606,42.9256]},{"Plant":"Monroe","State":"MI","Coal":3115,"coordinates":[-83.3464,41.8906]},{"Plant":"River Rouge","State":"MI","Coal":523,"coordinates":[-83.1119,42.2739]},{"Plant":"St Clair","State":"MI","Coal":1368,"coordinates":[-82.4719,42.7642]},{"Plant":"Trenton Channel","State":"MI","Coal":730,"coordinates":[-83.1808,42.1217]},{"Plant":"Presque Isle","State":"MI","Coal":609,"coordinates":[-87.395,46.5789]},{"Plant":"Eckert Station","State":"MI","Coal":316.1,"coordinates":[-84.5581,42.7184]},{"Plant":"Erickson Station","State":"MI","Coal":153,"coordinates":[-84.6572,42.6922]},{"Plant":"Syl Laskin","State":"MN","Coal":110,"coordinates":[-92.1619,47.5306]},{"Plant":"Clay Boswell","State":"MN","Coal":916.5,"coordinates":[-93.6528,47.2611]},{"Plant":"Black Dog","State":"MN","Coal":353.7,"coordinates":[-93.2501,44.8108]},{"Plant":"High Bridge","State":"MN","Coal":271.1,"coordinates":[-93.1117,44.9314]},{"Plant":"Allen S King","State":"MN","Coal":555,"coordinates":[-92.7786,45.03]},{"Plant":"Riverside","State":"MN","Coal":371.3,"coordinates":[-93.2753,45.0203]},{"Plant":"Hoot Lake","State":"MN","Coal":151.6,"coordinates":[-96.0433,46.2906]},{"Plant":"Silver Lake","State":"MN","Coal":106.5,"coordinates":[-92.4604,44.0282]},{"Plant":"Jack Watson","State":"MS","Coal":706,"coordinates":[-89.0286,30.4392]},{"Plant":"St Johns River Power Park","State":"FL","Coal":1252,"coordinates":[-81.5508,30.4308]},{"Plant":"Asbury","State":"MO","Coal":210,"coordinates":[-94.5893,37.3613]},{"Plant":"Hawthorn","State":"MO","Coal":563,"coordinates":[-94.4778,39.1306]},{"Plant":"Montrose","State":"MO","Coal":510,"coordinates":[-93.9348,38.3114]},{"Plant":"Sibley","State":"MO","Coal":508.3,"coordinates":[-94.1844,39.1783]},{"Plant":"Labadie","State":"MO","Coal":2396,"coordinates":[-90.8377,38.5622]},{"Plant":"Meramec","State":"MO","Coal":855,"coordinates":[-90.3358,38.4017]},{"Plant":"Sioux","State":"MO","Coal":994,"coordinates":[-90.2902,38.9155]},{"Plant":"James River Power Station","State":"MO","Coal":236,"coordinates":[-93.2619,37.1086]},{"Plant":"New Madrid","State":"MO","Coal":1160,"coordinates":[-89.5617,36.5147]},{"Plant":"Thomas Hill","State":"MO","Coal":1120,"coordinates":[-92.6381,39.5522]},{"Plant":"J E Corette Plant","State":"MT","Coal":158,"coordinates":[-108.481,45.7756]},{"Plant":"Lon Wright","State":"NE","Coal":120,"coordinates":[-96.4623,41.4281]},{"Plant":"Sheldon","State":"NE","Coal":225,"coordinates":[-96.7847,40.5589]},{"Plant":"North Omaha","State":"NE","Coal":662.8,"coordinates":[-95.9447,41.3291]},{"Plant":"Reid Gardner","State":"NV","Coal":587,"coordinates":[-114.6333,36.6573]},{"Plant":"Mohave","State":"NV","Coal":1580,"coordinates":[-114.5917,35.1458]},{"Plant":"Merrimack","State":"NH","Coal":432.5,"coordinates":[-71.4692,43.1411]},{"Plant":"B L England","State":"NJ","Coal":264,"coordinates":[-74.6364,39.2908]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Coal":558,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Mercer Generating Station","State":"NJ","Coal":648,"coordinates":[-74.7339,40.1792]},{"Plant":"Four Corners","State":"NM","Coal":2060,"coordinates":[-108.4814,36.69]},{"Plant":"San Juan","State":"NM","Coal":1643,"coordinates":[-108.4386,36.8006]},{"Plant":"Danskammer Generating Station","State":"NY","Coal":365.2,"coordinates":[-73.975,41.5712]},{"Plant":"GMMM Westover","State":"NY","Coal":127.7,"coordinates":[-75.9747,42.1117]},{"Plant":"GMMGreenidge LLC","State":"NY","Coal":158.7,"coordinates":[-76.9483,42.6789]},{"Plant":"Cayuga Operating Company","State":"NY","Coal":305,"coordinates":[-76.6336,42.6028]},{"Plant":"C R Huntley Generating Station","State":"NY","Coal":816,"coordinates":[-78.93,42.97]},{"Plant":"Dunkirk Generating Plant","State":"NY","Coal":520,"coordinates":[-79.3466,42.4915]},{"Plant":"E C Gaston","State":"AL","Coal":1862,"coordinates":[-86.4581,33.2442]},{"Plant":"Lovett","State":"NY","Coal":363,"coordinates":[-73.9797,41.2578]},{"Plant":"Rochester 7","State":"NY","Coal":252,"coordinates":[-77.6294,43.2689]},{"Plant":"Asheville","State":"NC","Coal":383,"coordinates":[-82.5417,35.4731]},{"Plant":"Cape Fear","State":"NC","Coal":317,"coordinates":[-79.0495,35.595]},{"Plant":"HF Lee Plant","State":"NC","Coal":406,"coordinates":[-78.0878,35.3799]},{"Plant":"Roxboro","State":"NC","Coal":2380,"coordinates":[-79.0731,36.4833]},{"Plant":"L V Sutton Steam","State":"NC","Coal":606,"coordinates":[-77.9853,34.2831]},{"Plant":"W H Weatherspoon","State":"NC","Coal":177,"coordinates":[-78.9755,34.5875]},{"Plant":"G G Allen","State":"NC","Coal":1145,"coordinates":[-81.0122,35.1897]},{"Plant":"Buck","State":"NC","Coal":369,"coordinates":[-80.3767,35.7133]},{"Plant":"Cliffside","State":"NC","Coal":760,"coordinates":[-81.7594,35.22]},{"Plant":"Dan River","State":"NC","Coal":276,"coordinates":[-79.7208,36.4862]},{"Plant":"Marshall","State":"NC","Coal":2110,"coordinates":[-80.9658,35.5975]},{"Plant":"Riverbend","State":"NC","Coal":454,"coordinates":[-80.9742,35.36]},{"Plant":"R M Heskett","State":"ND","Coal":102.9,"coordinates":[-100.8836,46.8669]},{"Plant":"Leland Olds","State":"ND","Coal":669,"coordinates":[-101.3212,47.2808]},{"Plant":"Milton R Young","State":"ND","Coal":697,"coordinates":[-101.2131,47.0659]},{"Plant":"Stanton","State":"ND","Coal":187.7,"coordinates":[-101.3319,47.2866]},{"Plant":"Cardinal","State":"OH","Coal":1800,"coordinates":[-80.6486,40.2522]},{"Plant":"Walter C Beckjord","State":"OH","Coal":1118,"coordinates":[-84.2981,38.9917]},{"Plant":"Miami Fort","State":"OH","Coal":1243,"coordinates":[-84.8036,39.1128]},{"Plant":"FirstEnergy Ashtabula","State":"OH","Coal":420,"coordinates":[-80.7697,41.9086]},{"Plant":"Avon Lake","State":"OH","Coal":735,"coordinates":[-82.0546,41.5045]},{"Plant":"FirstEnergy Eastlake","State":"OH","Coal":1233,"coordinates":[-81.4425,41.6711]},{"Plant":"FirstEnergy Lake Shore","State":"OH","Coal":245,"coordinates":[-81.6419,41.5356]},{"Plant":"Conesville","State":"OH","Coal":1925,"coordinates":[-81.8811,40.1842]},{"Plant":"O H Hutchings","State":"OH","Coal":336,"coordinates":[-84.2921,39.6088]},{"Plant":"J M Stuart","State":"OH","Coal":2388,"coordinates":[-83.6939,38.6361]},{"Plant":"Niles","State":"OH","Coal":216,"coordinates":[-80.7477,41.1669]},{"Plant":"FirstEnergy R E Burger","State":"OH","Coal":518,"coordinates":[-80.7608,39.91]},{"Plant":"FirstEnergy W H Sammis","State":"OH","Coal":2220,"coordinates":[-80.6319,40.5317]},{"Plant":"FirstEnergy Toronto","State":"OH","Coal":172,"coordinates":[-80.6044,40.4825]},{"Plant":"Muskingum River","State":"OH","Coal":1375,"coordinates":[-81.6797,39.5908]},{"Plant":"Kyger Creek","State":"OH","Coal":992.8,"coordinates":[-82.1289,38.9144]},{"Plant":"FirstEnergy Bay Shore","State":"OH","Coal":495,"coordinates":[-83.4378,41.6917]},{"Plant":"Lake Road","State":"OH","Coal":160,"coordinates":[-81.6494,41.5278]},{"Plant":"Muskogee","State":"OK","Coal":1542.8,"coordinates":[-95.2873,35.7614]},{"Plant":"Northeastern","State":"OK","Coal":930,"coordinates":[-95.7008,36.4317]},{"Plant":"Limestone","State":"TX","Coal":1689,"coordinates":[-96.2525,31.4219]},{"Plant":"Barry","State":"AL","Coal":1636,"coordinates":[-88.0103,31.0069]},{"Plant":"Elrama Power Plant","State":"PA","Coal":474,"coordinates":[-79.918,40.2518]},{"Plant":"F R Phillips","State":"PA","Coal":310,"coordinates":[-80.2286,40.5758]},{"Plant":"Portland","State":"PA","Coal":401,"coordinates":[-75.0794,40.9102]},{"Plant":"Titus","State":"PA","Coal":243,"coordinates":[-75.9081,40.3056]},{"Plant":"Conemaugh","State":"PA","Coal":1700,"coordinates":[-79.0611,40.3842]},{"Plant":"Homer City Generating Station","State":"PA","Coal":1884,"coordinates":[-79.1961,40.5128]},{"Plant":"Seward","State":"PA","Coal":717,"coordinates":[-79.0337,40.4062]},{"Plant":"Shawville","State":"PA","Coal":597,"coordinates":[-78.3662,41.0675]},{"Plant":"Keystone","State":"PA","Coal":1700,"coordinates":[-79.3411,40.6604]},{"Plant":"New Castle Plant","State":"PA","Coal":413,"coordinates":[-80.369,40.9379]},{"Plant":"Brunner Island","State":"PA","Coal":1448,"coordinates":[-76.6962,40.0961]},{"Plant":"PPL Martins Creek","State":"PA","Coal":280,"coordinates":[-75.1054,40.7978]},{"Plant":"PPL Montour","State":"PA","Coal":1525,"coordinates":[-76.6672,41.0714]},{"Plant":"Sunbury Generation LP","State":"PA","Coal":382,"coordinates":[-76.825,40.8361]},{"Plant":"Cromby Generating Station","State":"PA","Coal":144,"coordinates":[-75.5294,40.1531]},{"Plant":"Eddystone Generating Station","State":"PA","Coal":588,"coordinates":[-75.323,39.858]},{"Plant":"FirstEnergy Armstrong Power Station","State":"PA","Coal":344,"coordinates":[-79.4656,40.9292]},{"Plant":"Hatfields Ferry Power Station","State":"PA","Coal":1590,"coordinates":[-79.9275,39.8556]},{"Plant":"FirstEnergy Mitchell Power Station","State":"PA","Coal":278,"coordinates":[-79.9683,40.2211]},{"Plant":"H B Robinson","State":"SC","Coal":180,"coordinates":[-80.1589,34.4017]},{"Plant":"W S Lee","State":"SC","Coal":370,"coordinates":[-82.435,34.6022]},{"Plant":"Canadys Steam","State":"SC","Coal":396,"coordinates":[-80.6228,33.0647]},{"Plant":"Wateree","State":"SC","Coal":700,"coordinates":[-80.6228,33.8264]},{"Plant":"Williams","State":"SC","Coal":615,"coordinates":[-79.9297,33.0158]},{"Plant":"Dolphus M Grainger","State":"SC","Coal":170,"coordinates":[-79.0533,33.8264]},{"Plant":"Jefferies","State":"SC","Coal":306,"coordinates":[-79.9875,33.2422]},{"Plant":"Allen Steam Plant","State":"TN","Coal":735,"coordinates":[-90.1487,35.0741]},{"Plant":"Bull Run","State":"TN","Coal":885,"coordinates":[-84.1567,36.0211]},{"Plant":"Cumberland","State":"TN","Coal":2478,"coordinates":[-87.6539,36.3903]},{"Plant":"Gallatin","State":"TN","Coal":962,"coordinates":[-86.4006,36.3156]},{"Plant":"John Sevier","State":"TN","Coal":704,"coordinates":[-82.9639,36.3767]},{"Plant":"Johnsonville","State":"TN","Coal":1200,"coordinates":[-87.9861,36.0278]},{"Plant":"Kingston","State":"TN","Coal":1411,"coordinates":[-84.5194,35.8992]},{"Plant":"Watts Bar Fossil","State":"TN","Coal":224,"coordinates":[-84.7811,35.6108]},{"Plant":"W A Parish","State":"TX","Coal":2460,"coordinates":[-95.6311,29.4828]},{"Plant":"Big Brown","State":"TX","Coal":1150,"coordinates":[-96.0544,31.8206]},{"Plant":"Carbon","State":"UT","Coal":172,"coordinates":[-110.8644,39.7272]},{"Plant":"Clinch River","State":"VA","Coal":690,"coordinates":[-82.1997,36.9333]},{"Plant":"Glen Lyn","State":"VA","Coal":325,"coordinates":[-80.8633,37.3706]},{"Plant":"Potomac River","State":"VA","Coal":482,"coordinates":[-77.0411,38.8203]},{"Plant":"Chesapeake","State":"VA","Coal":595,"coordinates":[-76.3019,36.7711]},{"Plant":"Yorktown","State":"VA","Coal":323,"coordinates":[-76.4611,37.2144]},{"Plant":"Joliet 29","State":"IL","Coal":1036,"coordinates":[-88.1238,41.4946]},{"Plant":"Transalta Centralia Generation","State":"WA","Coal":1405,"coordinates":[-122.8598,46.7559]},{"Plant":"John E Amos","State":"WV","Coal":2900,"coordinates":[-81.8233,38.4731]},{"Plant":"Kanawha River","State":"WV","Coal":400,"coordinates":[-81.4211,38.2056]},{"Plant":"Philip Sporn","State":"WV","Coal":1020,"coordinates":[-81.9231,38.9669]},{"Plant":"FirstEnergy Albright","State":"WV","Coal":283,"coordinates":[-79.6369,39.4886]},{"Plant":"FirstEnergy Fort Martin Power Station","State":"WV","Coal":1107,"coordinates":[-79.9275,39.7108]},{"Plant":"FirstEnergy Harrison Power Station","State":"WV","Coal":1954,"coordinates":[-80.3325,39.3842]},{"Plant":"FirstEnergy Rivesville","State":"WV","Coal":137,"coordinates":[-80.1131,39.5314]},{"Plant":"FirstEnergy Willow Island","State":"WV","Coal":235,"coordinates":[-81.3,39.3672]},{"Plant":"Kammer","State":"WV","Coal":600,"coordinates":[-80.8186,39.8461]},{"Plant":"Mitchell","State":"WV","Coal":1560,"coordinates":[-80.8153,39.8297]},{"Plant":"Blount Street","State":"WI","Coal":194.1,"coordinates":[-89.3744,43.0789]},{"Plant":"Port Washington Generating Station","State":"WI","Coal":305,"coordinates":[-87.8689,43.3842]},{"Plant":"South Oak Creek","State":"WI","Coal":1135,"coordinates":[-87.8294,42.8457]},{"Plant":"Valley","State":"WI","Coal":267,"coordinates":[-87.9233,43.0303]},{"Plant":"Edgewater","State":"WI","Coal":807.4,"coordinates":[-87.7059,43.7151]},{"Plant":"Nelson Dewey Coal Refining Facility","State":"WI","Coal":223.2,"coordinates":[-91.0085,42.7225]},{"Plant":"Pulliam","State":"WI","Coal":383.9,"coordinates":[-88.0086,44.54]},{"Plant":"Weston","State":"WI","Coal":477,"coordinates":[-89.6553,44.8606]},{"Plant":"Alma","State":"WI","Coal":184.3,"coordinates":[-91.9111,44.3083]},{"Plant":"Genoa","State":"WI","Coal":356.2,"coordinates":[-91.2325,43.5589]},{"Plant":"Dave Johnston","State":"WY","Coal":762,"coordinates":[-105.7769,42.8378]},{"Plant":"Naughton","State":"WY","Coal":700,"coordinates":[-110.5983,41.7581]},{"Plant":"John P Madgett","State":"WI","Coal":395.7,"coordinates":[-91.9126,44.3036]},{"Plant":"Arapahoe","State":"CO","Coal":243,"coordinates":[-105.0028,39.67]},{"Plant":"Cherokee","State":"CO","Coal":717,"coordinates":[-104.9645,39.8073]},{"Plant":"Colbert","State":"AL","Coal":1176,"coordinates":[-87.8486,34.7439]},{"Plant":"Comanche","State":"CO","Coal":660,"coordinates":[-104.5747,38.2081]},{"Plant":"Valmont","State":"CO","Coal":186,"coordinates":[-105.202,40.0195]},{"Plant":"Martin Drake","State":"CO","Coal":254,"coordinates":[-104.8333,38.8244]},{"Plant":"Navajo","State":"AZ","Coal":2250,"coordinates":[-111.3886,36.9047]},{"Plant":"Widows Creek","State":"AL","Coal":1604,"coordinates":[-85.7553,34.883]},{"Plant":"G F Weaton Power Station","State":"PA","Coal":112,"coordinates":[-80.3462,40.6673]},{"Plant":"International Paper Savanna Mill","State":"GA","Coal":106.3,"coordinates":[-81.1242,32.1004]},{"Plant":"Tennessee Eastman Operations","State":"TN","Coal":194.3,"coordinates":[-82.5431,36.5219]},{"Plant":"Axiall Natrium Plant","State":"WV","Coal":123,"coordinates":[-80.8547,39.7475]},{"Plant":"Northampton Generating Company LP","State":"PA","Coal":112,"coordinates":[-75.4792,40.6917]},{"Plant":"Indiantown Cogeneration LP","State":"FL","Coal":330,"coordinates":[-80.5125,27.0389]},{"Plant":"Dolet Hills","State":"LA","Coal":672,"coordinates":[-93.5692,32.0306]},{"Plant":"Mecklenburg Power Station","State":"VA","Coal":138,"coordinates":[-78.53,36.6]},{"Plant":"Sandow No 5","State":"TX","Coal":363,"coordinates":[-97.0614,30.5681]},{"Plant":"Hayden","State":"CO","Coal":446,"coordinates":[-107.185,40.4856]},{"Plant":"Roanoke Valley Energy Facililty I","State":"NC","Coal":165,"coordinates":[-77.6167,36.4364]},{"Plant":"Spruance Genco LLC","State":"VA","Coal":190,"coordinates":[-77.4308,37.4556]},{"Plant":"Birchwood Power","State":"VA","Coal":237.8,"coordinates":[-77.3147,38.2667]},{"Plant":"Red Hills Generating Facility","State":"MS","Coal":440,"coordinates":[-89.2183,33.3761]},{"Plant":"Hardin Generator Project","State":"MT","Coal":107,"coordinates":[-107.6,45.7578]},{"Plant":"Charles R Lowman","State":"AL","Coal":550,"coordinates":[-87.9107,31.488]},{"Plant":"Kennecott Power Plant","State":"UT","Coal":175,"coordinates":[-112.1225,40.7119]},{"Plant":"Stanton Energy Center","State":"FL","Coal":886,"coordinates":[-81.1678,28.4822]},{"Plant":"Bridgeport Station","State":"CT","Coal":370.3,"coordinates":[-73.1844,41.1706]},{"Plant":"Edge Moor","State":"DE","Coal":260,"coordinates":[-75.5038,39.7389]},{"Plant":"Indian River Generating Station","State":"DE","Coal":780,"coordinates":[-75.2341,38.5857]},{"Plant":"James H Miller Jr","State":"AL","Coal":2749.7,"coordinates":[-87.0597,33.6319]},{"Plant":"FirstEnergy Pleasants Power Station","State":"WV","Coal":1278,"coordinates":[-81.2944,39.3667]},{"Plant":"White Bluff","State":"AR","Coal":1640,"coordinates":[-92.1406,34.4228]},{"Plant":"Duck Creek","State":"IL","Coal":335,"coordinates":[-89.9841,40.4663]},{"Plant":"Newton","State":"IL","Coal":1164,"coordinates":[-88.2781,38.9361]},{"Plant":"East Bend","State":"KY","Coal":600,"coordinates":[-84.8514,38.9036]},{"Plant":"W H Zimmer","State":"OH","Coal":1300,"coordinates":[-84.2289,38.8675]},{"Plant":"Brandon Shores","State":"MD","Coal":1286,"coordinates":[-76.5389,39.18]},{"Plant":"Craig","State":"CO","Coal":1274,"coordinates":[-107.5912,40.4627]},{"Plant":"Coal Creek","State":"ND","Coal":1114.3,"coordinates":[-101.1571,47.3777]},{"Plant":"Killen Station","State":"OH","Coal":600,"coordinates":[-83.4803,38.6903]},{"Plant":"Belle River","State":"MI","Coal":1260,"coordinates":[-82.495,42.7756]},{"Plant":"H L Spurlock","State":"KY","Coal":1118,"coordinates":[-83.8181,38.7]},{"Plant":"Wansley","State":"GA","Coal":1778,"coordinates":[-85.0323,33.4134]},{"Plant":"Big Cajun 2","State":"LA","Coal":1743,"coordinates":[-91.3692,30.7261]},{"Plant":"R D Morrow","State":"MS","Coal":360,"coordinates":[-89.394,31.2186]},{"Plant":"Nearman Creek","State":"KS","Coal":229,"coordinates":[-94.6975,39.1681]},{"Plant":"Iatan","State":"MO","Coal":651,"coordinates":[-94.98,39.4472]},{"Plant":"Jeffrey Energy Center","State":"KS","Coal":2190,"coordinates":[-96.1172,39.2865]},{"Plant":"Trimble County","State":"KY","Coal":511,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Coal":1007,"coordinates":[-88.5553,30.5322]},{"Plant":"Colstrip","State":"MT","Coal":2094,"coordinates":[-106.614,45.8831]},{"Plant":"Gerald Gentleman","State":"NE","Coal":1365,"coordinates":[-101.1408,41.0808]},{"Plant":"Somerset Operating Co LLC","State":"NY","Coal":680.8,"coordinates":[-78.6047,43.3589]},{"Plant":"R M Schahfer","State":"IN","Coal":1625,"coordinates":[-87.0261,41.2164]},{"Plant":"Sherburne County","State":"MN","Coal":2258.4,"coordinates":[-93.8931,45.3808]},{"Plant":"FirstEnergy Bruce Mansfield","State":"PA","Coal":2510,"coordinates":[-80.4159,40.6348]},{"Plant":"Sooner","State":"OK","Coal":1052,"coordinates":[-97.0528,36.4531]},{"Plant":"Nebraska City","State":"NE","Coal":646,"coordinates":[-95.7764,40.6214]},{"Plant":"Big Stone","State":"SD","Coal":470.2,"coordinates":[-96.5101,45.3037]},{"Plant":"Wyodak","State":"WY","Coal":335,"coordinates":[-105.3815,44.2901]},{"Plant":"Boardman","State":"OR","Coal":585,"coordinates":[-119.8088,45.6932]},{"Plant":"Gibson","State":"IN","Coal":3131,"coordinates":[-87.7658,38.3722]},{"Plant":"McIntosh","State":"GA","Coal":156.5,"coordinates":[-81.1683,32.3563]},{"Plant":"Gibbons Creek","State":"TX","Coal":462,"coordinates":[-96.0818,30.6199]},{"Plant":"A B Brown","State":"IN","Coal":490,"coordinates":[-87.715,37.9053]},{"Plant":"Flint Creek","State":"AR","Coal":528,"coordinates":[-94.5241,36.2561]},{"Plant":"Welsh","State":"TX","Coal":1584,"coordinates":[-94.84,33.0552]},{"Plant":"Martin Lake","State":"TX","Coal":2250,"coordinates":[-94.5706,32.2606]},{"Plant":"Monticello","State":"TX","Coal":1880,"coordinates":[-95.0417,33.0917]},{"Plant":"Rush Island","State":"MO","Coal":1161,"coordinates":[-90.2632,38.1312]},{"Plant":"Hunter","State":"UT","Coal":1320,"coordinates":[-111.0289,39.1747]},{"Plant":"Rockport","State":"IN","Coal":2610,"coordinates":[-87.0372,37.9256]},{"Plant":"Pleasant Prairie","State":"WI","Coal":1208,"coordinates":[-87.9033,42.5381]},{"Plant":"Coronado","State":"AZ","Coal":773,"coordinates":[-109.2708,34.5789]},{"Plant":"Coleto Creek","State":"TX","Coal":632,"coordinates":[-97.2142,28.7128]},{"Plant":"Fayette Power Project","State":"TX","Coal":1641,"coordinates":[-96.7506,29.9172]},{"Plant":"J T Deely","State":"TX","Coal":825,"coordinates":[-98.3228,29.3081]},{"Plant":"San Miguel","State":"TX","Coal":391,"coordinates":[-98.4775,28.7044]},{"Plant":"Brame Energy Center","State":"LA","Coal":517,"coordinates":[-92.7167,31.395]},{"Plant":"Harrington","State":"TX","Coal":1041,"coordinates":[-101.7472,35.2982]},{"Plant":"Tolk","State":"TX","Coal":1080,"coordinates":[-102.57,34.1865]},{"Plant":"John Twitty Energy Center","State":"MO","Coal":178,"coordinates":[-93.388,37.1517]},{"Plant":"Laramie River Station","State":"WY","Coal":1705,"coordinates":[-104.8825,42.1089]},{"Plant":"Merom","State":"IN","Coal":970,"coordinates":[-87.5108,39.0694]},{"Plant":"Pawnee","State":"CO","Coal":505,"coordinates":[-103.6803,40.2217]},{"Plant":"Winyah","State":"SC","Coal":1155,"coordinates":[-79.3581,33.3317]},{"Plant":"Mayo","State":"NC","Coal":741,"coordinates":[-78.8917,36.5278]},{"Plant":"Ottumwa","State":"IA","Coal":710.4,"coordinates":[-92.5558,41.0961]},{"Plant":"Scherer","State":"GA","Coal":3404.7,"coordinates":[-83.8075,33.0606]},{"Plant":"Mountaineer","State":"WV","Coal":1310,"coordinates":[-81.9344,38.9794]},{"Plant":"Crystal River","State":"FL","Coal":2310,"coordinates":[-82.6977,28.9656]},{"Plant":"Crist","State":"FL","Coal":930,"coordinates":[-87.2244,30.5661]},{"Plant":"Lansing Smith","State":"FL","Coal":357,"coordinates":[-85.7003,30.2686]},{"Plant":"Big Bend","State":"FL","Coal":1565,"coordinates":[-82.4036,27.7944]},{"Plant":"F J Gannon","State":"FL","Coal":508,"coordinates":[-82.4231,27.9072]},{"Plant":"Antelope Valley","State":"ND","Coal":900,"coordinates":[-101.3194,47.2819]},{"Plant":"Intermountain Power Project","State":"UT","Coal":1800,"coordinates":[-112.5802,39.5097]},{"Plant":"Deerhaven Generating Station","State":"FL","Coal":228.4,"coordinates":[-82.3878,29.7592]},{"Plant":"R D Green","State":"KY","Coal":454,"coordinates":[-87.5,37.6461]},{"Plant":"Independence","State":"AR","Coal":1678,"coordinates":[-91.4088,35.6784]},{"Plant":"Sandow No 4","State":"TX","Coal":545,"coordinates":[-97.064,30.5659]},{"Plant":"Louisa","State":"IA","Coal":745,"coordinates":[-91.0931,41.3181]},{"Plant":"Warrick","State":"IN","Coal":747,"coordinates":[-87.3328,37.915]},{"Plant":"C D McIntosh Jr","State":"FL","Coal":342,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Coal":274,"coordinates":[-105.0212,40.8609]},{"Plant":"Sikeston Power Station","State":"MO","Coal":233,"coordinates":[-89.6209,36.8791]},{"Plant":"Hugo","State":"OK","Coal":440,"coordinates":[-95.3206,34.0158]},{"Plant":"D B Wilson","State":"KY","Coal":419,"coordinates":[-87.0806,37.4497]},{"Plant":"Gadsden","State":"AL","Coal":130,"coordinates":[-85.9708,34.0128]},{"Plant":"Bowen","State":"GA","Coal":3222,"coordinates":[-84.9222,34.1256]},{"Plant":"Major Oak Power","State":"TX","Coal":305,"coordinates":[-96.695,31.0919]},{"Plant":"Hammond","State":"GA","Coal":846,"coordinates":[-85.3456,34.2528]},{"Plant":"Harllee Branch","State":"GA","Coal":1607,"coordinates":[-83.2983,33.195]},{"Plant":"J K Spruce","State":"TX","Coal":555,"coordinates":[-98.3203,29.3097]},{"Plant":"Jack McDonough","State":"GA","Coal":517,"coordinates":[-84.4758,33.8239]},{"Plant":"Polk","State":"FL","Coal":250,"coordinates":[-81.9897,27.7286]},{"Plant":"Mitchell","State":"GA","Coal":195,"coordinates":[-84.1347,31.4447]},{"Plant":"Yates","State":"GA","Coal":1295,"coordinates":[-84.8986,33.4622]},{"Plant":"Richard Gorsuch","State":"OH","Coal":200,"coordinates":[-81.5211,39.3664]},{"Plant":"Kraft","State":"GA","Coal":201,"coordinates":[-81.1458,32.1486]},{"Plant":"George Neal South","State":"IA","Coal":644,"coordinates":[-96.3617,42.3006]},{"Plant":"Bonanza","State":"UT","Coal":458,"coordinates":[-109.2844,40.0864]},{"Plant":"Pirkey","State":"TX","Coal":675,"coordinates":[-94.4852,32.4607]},{"Plant":"Gorgas","State":"AL","Coal":1247,"coordinates":[-87.1965,33.6443]},{"Plant":"Columbia","State":"WI","Coal":1106.7,"coordinates":[-89.4203,43.4864]},{"Plant":"Belews Creek","State":"NC","Coal":2270,"coordinates":[-80.0603,36.2811]},{"Plant":"Jim Bridger","State":"WY","Coal":2120,"coordinates":[-108.7875,41.7378]},{"Plant":"Huntington","State":"UT","Coal":895,"coordinates":[-111.0781,39.3792]},{"Plant":"General James M Gavin","State":"OH","Coal":2640,"coordinates":[-82.1158,38.9347]},{"Plant":"Ray D Nixon","State":"CO","Coal":208,"coordinates":[-104.7058,38.6335]},{"Plant":"Coyote","State":"ND","Coal":427,"coordinates":[-101.8157,47.2214]},{"Plant":"Springerville","State":"AZ","Coal":1200,"coordinates":[-109.1639,34.3186]},{"Plant":"North Valmy","State":"NV","Coal":522,"coordinates":[-117.1516,40.8813]},{"Plant":"Cheswick Power Plant","State":"PA","Coal":580,"coordinates":[-79.7906,40.5383]},{"Plant":"E D Edwards","State":"IL","Coal":672,"coordinates":[-89.6631,40.5958]},{"Plant":"Coffeen","State":"IL","Coal":900,"coordinates":[-89.4031,39.0586]},{"Plant":"Hutsonville","State":"IL","Coal":150,"coordinates":[-87.6597,39.1333]},{"Plant":"Meredosia","State":"IL","Coal":327,"coordinates":[-90.5672,39.8233]},{"Plant":"Crawford","State":"IL","Coal":532,"coordinates":[-87.7229,41.8285]},{"Plant":"Escalante","State":"NM","Coal":247,"coordinates":[-108.082,35.4159]},{"Plant":"Joliet 9","State":"IL","Coal":314,"coordinates":[-88.1153,41.4931]},{"Plant":"Kincaid Generation LLC","State":"IL","Coal":1158,"coordinates":[-89.4964,39.5906]},{"Plant":"Powerton","State":"IL","Coal":1538,"coordinates":[-89.6786,40.5408]},{"Plant":"Waukegan","State":"IL","Coal":789,"coordinates":[-87.8133,42.3833]},{"Plant":"Will County","State":"IL","Coal":1060,"coordinates":[-88.0629,41.6334]},{"Plant":"Fisk Street","State":"IL","Coal":326,"coordinates":[-87.6533,41.8508]},{"Plant":"Joppa Steam","State":"IL","Coal":1002,"coordinates":[-88.8589,37.2094]},{"Plant":"Baldwin Energy Complex","State":"IL","Coal":1764,"coordinates":[-89.8544,38.205]},{"Plant":"Havana","State":"IL","Coal":438,"coordinates":[-90.08,40.2797]},{"Plant":"Hennepin Power Station","State":"IL","Coal":282,"coordinates":[-89.315,41.3028]},{"Plant":"Vermilion","State":"IL","Coal":163,"coordinates":[-87.7481,40.1781]},{"Plant":"Wood River","State":"IL","Coal":437,"coordinates":[-90.1347,38.8639]},{"Plant":"Dallman","State":"IL","Coal":372,"coordinates":[-89.6024,39.7548]},{"Plant":"Marion","State":"IL","Coal":290,"coordinates":[-88.9531,37.6197]},{"Plant":"State Line Energy","State":"IN","Coal":515,"coordinates":[-87.5217,41.7072]},{"Plant":"Clifty Creek","State":"IN","Coal":1203,"coordinates":[-85.4206,38.7378]},{"Plant":"Tanners Creek","State":"IN","Coal":990,"coordinates":[-84.8594,39.0814]},{"Plant":"Harding Street","State":"IN","Coal":647,"coordinates":[-86.1969,39.7113]},{"Plant":"Eagle Valley","State":"IN","Coal":260,"coordinates":[-86.4183,39.4852]},{"Plant":"AES Petersburg","State":"IN","Coal":1752,"coordinates":[-87.2525,38.5281]},{"Plant":"Bailly","State":"IN","Coal":480,"coordinates":[-87.1225,41.645]},{"Plant":"Dean H Mitchell","State":"IN","Coal":360,"coordinates":[-87.4069,41.6392]},{"Plant":"Michigan City","State":"IN","Coal":469,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Coal":497,"coordinates":[-87.7811,32.6017]},{"Plant":"ACE Cogeneration Facility","State":"CA","Coal":101.2,"coordinates":[-117.3836,35.7658]},{"Plant":"Cayuga","State":"IN","Coal":995,"coordinates":[-87.4244,39.9242]},{"Plant":"RED-Rochester, LLC","State":"NY","Coal":180.8,"coordinates":[-77.6319,43.1989]},{"Plant":"Edwardsport","State":"IN","Coal":120,"coordinates":[-87.2472,38.8067]},{"Plant":"Logan Generating Company LP","State":"NJ","Coal":219,"coordinates":[-75.4067,39.7928]},{"Plant":"Portsmouth Genco LLC","State":"VA","Coal":115,"coordinates":[-76.3529,36.8702]},{"Plant":"Taconite Harbor Energy Center","State":"MN","Coal":230.5,"coordinates":[-90.9114,47.5314]},{"Plant":"R Gallagher","State":"IN","Coal":560,"coordinates":[-85.8381,38.2636]},{"Plant":"Wabash River","State":"IN","Coal":942,"coordinates":[-87.4247,39.53]},{"Plant":"F B Culley","State":"IN","Coal":402,"coordinates":[-87.3275,37.9111]},{"Plant":"Colver Power Project","State":"PA","Coal":110,"coordinates":[-78.8,40.55]},{"Plant":"Florida Power Development","State":"FL","Coal":136,"coordinates":[-82.4311,28.5819]},{"Plant":"Green Bay West Mill","State":"WI","Coal":112.9,"coordinates":[-88.0303,44.4936]},{"Plant":"CPI USA NC Southport","State":"NC","Coal":107,"coordinates":[-78.0118,33.9444]},{"Plant":"Edgecombe Genco LLC","State":"NC","Coal":115.6,"coordinates":[-77.7533,36.0373]},{"Plant":"Frank E Ratts","State":"IN","Coal":245,"coordinates":[-87.2662,38.5201]},{"Plant":"Lansing","State":"IA","Coal":319.9,"coordinates":[-91.1675,43.3359]},{"Plant":"4 AC Station","State":"IN","Coal":126.6,"coordinates":[-87.4264,41.68]},{"Plant":"Milton L Kapp","State":"IA","Coal":212.4,"coordinates":[-90.2336,41.8081]},{"Plant":"Chambers Cogeneration LP","State":"NJ","Coal":262,"coordinates":[-75.4858,39.6935]},{"Plant":"AES Shady Point LLC","State":"OK","Coal":320,"coordinates":[-94.6458,35.1931]},{"Plant":"Cedar Bay Generating Company LP","State":"FL","Coal":250,"coordinates":[-81.6064,30.4225]},{"Plant":"AES Hawaii","State":"HI","Coal":180,"coordinates":[-158.1065,21.3034]},{"Plant":"AES Thames","State":"CT","Coal":181,"coordinates":[-72.055,41.2607]},{"Plant":"AES Beaver Valley Partners Beaver Valley","State":"PA","Coal":146,"coordinates":[-80.3539,40.6572]},{"Plant":"AES Warrior Run Cogeneration Facility","State":"MD","Coal":180,"coordinates":[-78.7453,39.5952]},{"Plant":"Prairie Creek","State":"IA","Coal":207.9,"coordinates":[-91.6392,41.944]},{"Plant":"Sutherland","State":"IA","Coal":134.4,"coordinates":[-92.8594,42.0473]},{"Plant":"Holcomb","State":"KS","Coal":362,"coordinates":[-100.9725,37.9308]},{"Plant":"Riverside","State":"IA","Coal":134.8,"coordinates":[-90.4481,41.54]},{"Plant":"Walter Scott Jr Energy Center","State":"IA","Coal":1623,"coordinates":[-95.8408,41.18]},{"Plant":"Silver Bay Power","State":"MN","Coal":105,"coordinates":[-91.2605,47.2866]},{"Plant":"Archer Daniels Midland Cedar Rapids","State":"IA","Coal":260,"coordinates":[-91.6875,41.9221]},{"Plant":"Archer Daniels Midland Decatur","State":"IL","Coal":335,"coordinates":[-88.8908,39.8701]},{"Plant":"George Neal North","State":"IA","Coal":944.9,"coordinates":[-96.3617,42.2998]},{"Plant":"Burlington","State":"IA","Coal":191.9,"coordinates":[-91.1167,40.7412]},{"Plant":"Ames Electric Services Power Plant","State":"IA","Coal":104.9,"coordinates":[-93.6089,42.0258]},{"Plant":"Cholla","State":"AZ","Coal":1021,"coordinates":[-110.3033,34.9394]},{"Plant":"Muscatine Plant #1","State":"IA","Coal":235,"coordinates":[-91.0569,41.3917]},{"Plant":"La Cygne","State":"KS","Coal":1418,"coordinates":[-94.6456,38.3481]},{"Plant":"Lawrence Energy Center","State":"KS","Coal":558,"coordinates":[-95.2692,39.0072]},{"Plant":"Tecumseh Energy Center","State":"KS","Coal":204,"coordinates":[-95.5689,39.0539]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Coal":156,"coordinates":[-110.9047,32.16]},{"Plant":"Oklaunion","State":"TX","Coal":670,"coordinates":[-99.1753,34.0825]},{"Plant":"Quindaro","State":"KS","Coal":183,"coordinates":[-94.6381,39.1492]},{"Plant":"Cross","State":"SC","Coal":2320,"coordinates":[-80.1119,33.3692]},{"Plant":"Big Sandy","State":"KY","Coal":1060,"coordinates":[-82.6176,38.1707]},{"Plant":"E W Brown","State":"KY","Coal":697,"coordinates":[-84.7126,37.7883]},{"Plant":"Ghent","State":"KY","Coal":1918,"coordinates":[-85.035,38.7497]},{"Plant":"Green River","State":"KY","Coal":207,"coordinates":[-87.1214,37.3636]},{"Plant":"Seminole","State":"FL","Coal":1316,"coordinates":[-81.6328,29.7331]},{"Plant":"Cane Run","State":"KY","Coal":563,"coordinates":[-85.8892,38.1831]},{"Plant":"Mill Creek","State":"KY","Coal":1472,"coordinates":[-85.9103,38.0525]},{"Plant":"Elmer Smith","State":"KY","Coal":390.5,"coordinates":[-87.0608,37.7942]},{"Plant":"Paradise","State":"KY","Coal":2201,"coordinates":[-86.9783,37.2608]},{"Plant":"Shawnee","State":"KY","Coal":1330,"coordinates":[-88.775,37.1517]},{"Plant":"Kenneth C Coleman","State":"KY","Coal":439.6,"coordinates":[-86.7911,37.9631]},{"Plant":"HMP&L Station Two Henderson","State":"KY","Coal":310.2,"coordinates":[-87.5028,37.6469]},{"Plant":"Cooper","State":"KY","Coal":341,"coordinates":[-84.5919,36.9981]},{"Plant":"Dale","State":"KY","Coal":195,"coordinates":[-84.2619,37.8806]},{"Plant":"R S Nelson","State":"LA","Coal":550,"coordinates":[-93.2911,30.2844]},{"Plant":"C P Crane","State":"MD","Coal":385,"coordinates":[-76.3651,39.3236]},{"Plant":"Herbert A Wagner","State":"MD","Coal":459,"coordinates":[-76.5268,39.1781]},{"Plant":"FirstEnergy R Paul Smith Power Station","State":"MD","Coal":115,"coordinates":[-77.8269,39.595]},{"Plant":"Chalk Point LLC","State":"MD","Coal":679,"coordinates":[-76.6861,38.5444]},{"Plant":"Dickerson","State":"MD","Coal":542,"coordinates":[-77.4644,39.2097]},{"Plant":"Morgantown Generating Plant","State":"MD","Coal":1238,"coordinates":[-76.9767,38.3592]},{"Plant":"Apache Station","State":"AZ","Coal":350,"coordinates":[-109.8931,32.0603]},{"Plant":"Mount Tom","State":"MA","Coal":143.6,"coordinates":[-72.6055,42.2806]},{"Plant":"Somerset Station","State":"MA","Coal":179.1,"coordinates":[-71.146,41.7374]},{"Plant":"Brayton Point","State":"MA","Coal":1099.5,"coordinates":[-71.1931,41.7103]},{"Plant":"Salem Harbor","State":"MA","Coal":300.6,"coordinates":[-70.8772,42.5256]},{"Plant":"GRDA","State":"OK","Coal":1010,"coordinates":[-95.2894,36.1903]},{"Plant":"B C Cobb","State":"MI","Coal":312,"coordinates":[-86.2423,43.2588]},{"Plant":"Dan E Karn","State":"MI","Coal":515,"coordinates":[-83.8401,43.645]},{"Plant":"J H Campbell","State":"MI","Coal":1440,"coordinates":[-86.2007,42.9103]},{"Plant":"J C Weadock","State":"MI","Coal":306,"coordinates":[-83.8447,43.6399]},{"Plant":"J R Whiting","State":"MI","Coal":328,"coordinates":[-83.4495,41.7921]},{"Plant":"Harbor Beach","State":"MI","Coal":103,"coordinates":[-82.6436,43.8519]},{"Plant":"Marysville","State":"MI","Coal":199,"coordinates":[-82.4606,42.9256]},{"Plant":"Monroe","State":"MI","Coal":3115,"coordinates":[-83.3464,41.8906]},{"Plant":"River Rouge","State":"MI","Coal":523,"coordinates":[-83.1119,42.2739]},{"Plant":"St Clair","State":"MI","Coal":1368,"coordinates":[-82.4719,42.7642]},{"Plant":"Trenton Channel","State":"MI","Coal":730,"coordinates":[-83.1808,42.1217]},{"Plant":"Presque Isle","State":"MI","Coal":609,"coordinates":[-87.395,46.5789]},{"Plant":"Eckert Station","State":"MI","Coal":318.5,"coordinates":[-84.5581,42.7184]},{"Plant":"Erickson Station","State":"MI","Coal":153.2,"coordinates":[-84.6572,42.6922]},{"Plant":"Syl Laskin","State":"MN","Coal":110,"coordinates":[-92.1619,47.5306]},{"Plant":"Clay Boswell","State":"MN","Coal":916.5,"coordinates":[-93.6528,47.2611]},{"Plant":"Black Dog","State":"MN","Coal":353.7,"coordinates":[-93.2501,44.8108]},{"Plant":"High Bridge","State":"MN","Coal":271.1,"coordinates":[-93.1117,44.9314]},{"Plant":"Allen S King","State":"MN","Coal":555,"coordinates":[-92.7786,45.03]},{"Plant":"Riverside","State":"MN","Coal":371.3,"coordinates":[-93.2753,45.0203]},{"Plant":"Hoot Lake","State":"MN","Coal":152,"coordinates":[-96.0433,46.2906]},{"Plant":"Silver Lake","State":"MN","Coal":104,"coordinates":[-92.4604,44.0282]},{"Plant":"Jack Watson","State":"MS","Coal":706,"coordinates":[-89.0286,30.4392]},{"Plant":"St Johns River Power Park","State":"FL","Coal":1252,"coordinates":[-81.5508,30.4308]},{"Plant":"Asbury","State":"MO","Coal":210,"coordinates":[-94.5893,37.3613]},{"Plant":"Hawthorn","State":"MO","Coal":563,"coordinates":[-94.4778,39.1306]},{"Plant":"Montrose","State":"MO","Coal":510,"coordinates":[-93.9348,38.3114]},{"Plant":"Sibley","State":"MO","Coal":508.3,"coordinates":[-94.1844,39.1783]},{"Plant":"Labadie","State":"MO","Coal":2406,"coordinates":[-90.8377,38.5622]},{"Plant":"Meramec","State":"MO","Coal":842,"coordinates":[-90.3358,38.4017]},{"Plant":"Sioux","State":"MO","Coal":993,"coordinates":[-90.2902,38.9155]},{"Plant":"James River Power Station","State":"MO","Coal":236,"coordinates":[-93.2619,37.1086]},{"Plant":"New Madrid","State":"MO","Coal":1160,"coordinates":[-89.5617,36.5147]},{"Plant":"Thomas Hill","State":"MO","Coal":1120,"coordinates":[-92.6381,39.5522]},{"Plant":"J E Corette Plant","State":"MT","Coal":154,"coordinates":[-108.481,45.7756]},{"Plant":"Lon Wright","State":"NE","Coal":120,"coordinates":[-96.4623,41.4281]},{"Plant":"Sheldon","State":"NE","Coal":225,"coordinates":[-96.7847,40.5589]},{"Plant":"North Omaha","State":"NE","Coal":662.8,"coordinates":[-95.9447,41.3291]},{"Plant":"Reid Gardner","State":"NV","Coal":587,"coordinates":[-114.6333,36.6573]},{"Plant":"Mohave","State":"NV","Coal":1580,"coordinates":[-114.5917,35.1458]},{"Plant":"Merrimack","State":"NH","Coal":432.5,"coordinates":[-71.4692,43.1411]},{"Plant":"B L England","State":"NJ","Coal":264,"coordinates":[-74.6364,39.2908]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Coal":568,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Mercer Generating Station","State":"NJ","Coal":638,"coordinates":[-74.7339,40.1792]},{"Plant":"Four Corners","State":"NM","Coal":2060,"coordinates":[-108.4814,36.69]},{"Plant":"San Juan","State":"NM","Coal":1643,"coordinates":[-108.4386,36.8006]},{"Plant":"Danskammer Generating Station","State":"NY","Coal":367.2,"coordinates":[-73.975,41.5712]},{"Plant":"GMMM Westover","State":"NY","Coal":127.7,"coordinates":[-75.9747,42.1117]},{"Plant":"GMMGreenidge LLC","State":"NY","Coal":155.5,"coordinates":[-76.9483,42.6789]},{"Plant":"Cayuga Operating Company","State":"NY","Coal":306.1,"coordinates":[-76.6336,42.6028]},{"Plant":"C R Huntley Generating Station","State":"NY","Coal":816,"coordinates":[-78.93,42.97]},{"Plant":"Dunkirk Generating Plant","State":"NY","Coal":520,"coordinates":[-79.3466,42.4915]},{"Plant":"E C Gaston","State":"AL","Coal":1862,"coordinates":[-86.4581,33.2442]},{"Plant":"Lovett","State":"NY","Coal":363,"coordinates":[-73.9797,41.2578]},{"Plant":"Rochester 7","State":"NY","Coal":252,"coordinates":[-77.6294,43.2689]},{"Plant":"Asheville","State":"NC","Coal":376,"coordinates":[-82.5417,35.4731]},{"Plant":"Cape Fear","State":"NC","Coal":316,"coordinates":[-79.0495,35.595]},{"Plant":"HF Lee Plant","State":"NC","Coal":397,"coordinates":[-78.0878,35.3799]},{"Plant":"Roxboro","State":"NC","Coal":2424,"coordinates":[-79.0731,36.4833]},{"Plant":"L V Sutton Steam","State":"NC","Coal":600,"coordinates":[-77.9853,34.2831]},{"Plant":"W H Weatherspoon","State":"NC","Coal":172,"coordinates":[-78.9755,34.5875]},{"Plant":"G G Allen","State":"NC","Coal":1145,"coordinates":[-81.0122,35.1897]},{"Plant":"Buck","State":"NC","Coal":369,"coordinates":[-80.3767,35.7133]},{"Plant":"Cliffside","State":"NC","Coal":760,"coordinates":[-81.7594,35.22]},{"Plant":"Dan River","State":"NC","Coal":276,"coordinates":[-79.7208,36.4862]},{"Plant":"Marshall","State":"NC","Coal":2110,"coordinates":[-80.9658,35.5975]},{"Plant":"Riverbend","State":"NC","Coal":454,"coordinates":[-80.9742,35.36]},{"Plant":"R M Heskett","State":"ND","Coal":102.9,"coordinates":[-100.8836,46.8669]},{"Plant":"Leland Olds","State":"ND","Coal":669,"coordinates":[-101.3212,47.2808]},{"Plant":"Milton R Young","State":"ND","Coal":697,"coordinates":[-101.2131,47.0659]},{"Plant":"Stanton","State":"ND","Coal":187.7,"coordinates":[-101.3319,47.2866]},{"Plant":"Cardinal","State":"OH","Coal":1800,"coordinates":[-80.6486,40.2522]},{"Plant":"Walter C Beckjord","State":"OH","Coal":1118,"coordinates":[-84.2981,38.9917]},{"Plant":"Miami Fort","State":"OH","Coal":1243,"coordinates":[-84.8036,39.1128]},{"Plant":"FirstEnergy Ashtabula","State":"OH","Coal":420,"coordinates":[-80.7697,41.9086]},{"Plant":"Avon Lake","State":"OH","Coal":721,"coordinates":[-82.0546,41.5045]},{"Plant":"FirstEnergy Eastlake","State":"OH","Coal":1233,"coordinates":[-81.4425,41.6711]},{"Plant":"FirstEnergy Lake Shore","State":"OH","Coal":245,"coordinates":[-81.6419,41.5356]},{"Plant":"Conesville","State":"OH","Coal":1925,"coordinates":[-81.8811,40.1842]},{"Plant":"O H Hutchings","State":"OH","Coal":329,"coordinates":[-84.2921,39.6088]},{"Plant":"J M Stuart","State":"OH","Coal":2340,"coordinates":[-83.6939,38.6361]},{"Plant":"Niles","State":"OH","Coal":216,"coordinates":[-80.7477,41.1669]},{"Plant":"FirstEnergy R E Burger","State":"OH","Coal":518,"coordinates":[-80.7608,39.91]},{"Plant":"FirstEnergy W H Sammis","State":"OH","Coal":2220,"coordinates":[-80.6319,40.5317]},{"Plant":"FirstEnergy Toronto","State":"OH","Coal":172,"coordinates":[-80.6044,40.4825]},{"Plant":"Muskingum River","State":"OH","Coal":1375,"coordinates":[-81.6797,39.5908]},{"Plant":"Kyger Creek","State":"OH","Coal":992.8,"coordinates":[-82.1289,38.9144]},{"Plant":"FirstEnergy Bay Shore","State":"OH","Coal":495,"coordinates":[-83.4378,41.6917]},{"Plant":"Lake Road","State":"OH","Coal":160,"coordinates":[-81.6494,41.5278]},{"Plant":"Muskogee","State":"OK","Coal":1496,"coordinates":[-95.2873,35.7614]},{"Plant":"Northeastern","State":"OK","Coal":920,"coordinates":[-95.7008,36.4317]},{"Plant":"Limestone","State":"TX","Coal":1689,"coordinates":[-96.2525,31.4219]},{"Plant":"Barry","State":"AL","Coal":1620,"coordinates":[-88.0103,31.0069]},{"Plant":"Elrama Power Plant","State":"PA","Coal":460,"coordinates":[-79.918,40.2518]},{"Plant":"F R Phillips","State":"PA","Coal":310,"coordinates":[-80.2286,40.5758]},{"Plant":"Portland","State":"PA","Coal":401,"coordinates":[-75.0794,40.9102]},{"Plant":"Titus","State":"PA","Coal":243,"coordinates":[-75.9081,40.3056]},{"Plant":"Conemaugh","State":"PA","Coal":1700,"coordinates":[-79.0611,40.3842]},{"Plant":"Homer City Generating Station","State":"PA","Coal":1884,"coordinates":[-79.1961,40.5128]},{"Plant":"Seward","State":"PA","Coal":717,"coordinates":[-79.0337,40.4062]},{"Plant":"Shawville","State":"PA","Coal":597,"coordinates":[-78.3662,41.0675]},{"Plant":"Keystone","State":"PA","Coal":1700,"coordinates":[-79.3411,40.6604]},{"Plant":"New Castle Plant","State":"PA","Coal":400,"coordinates":[-80.369,40.9379]},{"Plant":"Brunner Island","State":"PA","Coal":1442,"coordinates":[-76.6962,40.0961]},{"Plant":"PPL Martins Creek","State":"PA","Coal":280,"coordinates":[-75.1054,40.7978]},{"Plant":"PPL Montour","State":"PA","Coal":1495,"coordinates":[-76.6672,41.0714]},{"Plant":"Sunbury Generation LP","State":"PA","Coal":382,"coordinates":[-76.825,40.8361]},{"Plant":"Cromby Generating Station","State":"PA","Coal":144,"coordinates":[-75.5294,40.1531]},{"Plant":"Eddystone Generating Station","State":"PA","Coal":588,"coordinates":[-75.323,39.858]},{"Plant":"FirstEnergy Armstrong Power Station","State":"PA","Coal":343,"coordinates":[-79.4656,40.9292]},{"Plant":"Hatfields Ferry Power Station","State":"PA","Coal":1590,"coordinates":[-79.9275,39.8556]},{"Plant":"FirstEnergy Mitchell Power Station","State":"PA","Coal":277,"coordinates":[-79.9683,40.2211]},{"Plant":"H B Robinson","State":"SC","Coal":174,"coordinates":[-80.1589,34.4017]},{"Plant":"W S Lee","State":"SC","Coal":370,"coordinates":[-82.435,34.6022]},{"Plant":"Canadys Steam","State":"SC","Coal":396,"coordinates":[-80.6228,33.0647]},{"Plant":"McMeekin","State":"SC","Coal":250,"coordinates":[-81.2172,34.0556]},{"Plant":"Wateree","State":"SC","Coal":700,"coordinates":[-80.6228,33.8264]},{"Plant":"Williams","State":"SC","Coal":615,"coordinates":[-79.9297,33.0158]},{"Plant":"Dolphus M Grainger","State":"SC","Coal":170,"coordinates":[-79.0533,33.8264]},{"Plant":"Jefferies","State":"SC","Coal":306,"coordinates":[-79.9875,33.2422]},{"Plant":"Allen Steam Plant","State":"TN","Coal":741,"coordinates":[-90.1487,35.0741]},{"Plant":"Bull Run","State":"TN","Coal":870,"coordinates":[-84.1567,36.0211]},{"Plant":"Cumberland","State":"TN","Coal":2478,"coordinates":[-87.6539,36.3903]},{"Plant":"Gallatin","State":"TN","Coal":976,"coordinates":[-86.4006,36.3156]},{"Plant":"John Sevier","State":"TN","Coal":704,"coordinates":[-82.9639,36.3767]},{"Plant":"Johnsonville","State":"TN","Coal":1206,"coordinates":[-87.9861,36.0278]},{"Plant":"Kingston","State":"TN","Coal":1425,"coordinates":[-84.5194,35.8992]},{"Plant":"Watts Bar Fossil","State":"TN","Coal":224,"coordinates":[-84.7811,35.6108]},{"Plant":"W A Parish","State":"TX","Coal":2476,"coordinates":[-95.6311,29.4828]},{"Plant":"Big Brown","State":"TX","Coal":1192,"coordinates":[-96.0544,31.8206]},{"Plant":"Carbon","State":"UT","Coal":172,"coordinates":[-110.8644,39.7272]},{"Plant":"Clinch River","State":"VA","Coal":690,"coordinates":[-82.1997,36.9333]},{"Plant":"Glen Lyn","State":"VA","Coal":325,"coordinates":[-80.8633,37.3706]},{"Plant":"Potomac River","State":"VA","Coal":482,"coordinates":[-77.0411,38.8203]},{"Plant":"Bremo Bluff","State":"VA","Coal":227,"coordinates":[-78.2878,37.7089]},{"Plant":"Chesterfield","State":"VA","Coal":1235,"coordinates":[-77.3833,37.3822]},{"Plant":"Chesapeake","State":"VA","Coal":595,"coordinates":[-76.3019,36.7711]},{"Plant":"Yorktown","State":"VA","Coal":323,"coordinates":[-76.4611,37.2144]},{"Plant":"Joliet 29","State":"IL","Coal":1036,"coordinates":[-88.1238,41.4946]},{"Plant":"Transalta Centralia Generation","State":"WA","Coal":1376,"coordinates":[-122.8598,46.7559]},{"Plant":"John E Amos","State":"WV","Coal":2900,"coordinates":[-81.8233,38.4731]},{"Plant":"Kanawha River","State":"WV","Coal":400,"coordinates":[-81.4211,38.2056]},{"Plant":"Philip Sporn","State":"WV","Coal":1020,"coordinates":[-81.9231,38.9669]},{"Plant":"FirstEnergy Albright","State":"WV","Coal":283,"coordinates":[-79.6369,39.4886]},{"Plant":"FirstEnergy Fort Martin Power Station","State":"WV","Coal":1107,"coordinates":[-79.9275,39.7108]},{"Plant":"FirstEnergy Harrison Power Station","State":"WV","Coal":1954,"coordinates":[-80.3325,39.3842]},{"Plant":"FirstEnergy Rivesville","State":"WV","Coal":125,"coordinates":[-80.1131,39.5314]},{"Plant":"FirstEnergy Willow Island","State":"WV","Coal":235,"coordinates":[-81.3,39.3672]},{"Plant":"Kammer","State":"WV","Coal":600,"coordinates":[-80.8186,39.8461]},{"Plant":"Mitchell","State":"WV","Coal":1560,"coordinates":[-80.8153,39.8297]},{"Plant":"Mt Storm","State":"WV","Coal":1560,"coordinates":[-79.2636,39.2008]},{"Plant":"Blount Street","State":"WI","Coal":194.1,"coordinates":[-89.3744,43.0789]},{"Plant":"Port Washington Generating Station","State":"WI","Coal":305,"coordinates":[-87.8689,43.3842]},{"Plant":"South Oak Creek","State":"WI","Coal":1135,"coordinates":[-87.8294,42.8457]},{"Plant":"Valley","State":"WI","Coal":267,"coordinates":[-87.9233,43.0303]},{"Plant":"Edgewater","State":"WI","Coal":804.8,"coordinates":[-87.7059,43.7151]},{"Plant":"Nelson Dewey Coal Refining Facility","State":"WI","Coal":225.1,"coordinates":[-91.0085,42.7225]},{"Plant":"Pulliam","State":"WI","Coal":385.3,"coordinates":[-88.0086,44.54]},{"Plant":"Weston","State":"WI","Coal":1011.4,"coordinates":[-89.6553,44.8606]},{"Plant":"Alma","State":"WI","Coal":197.1,"coordinates":[-91.9111,44.3083]},{"Plant":"Genoa","State":"WI","Coal":351.3,"coordinates":[-91.2325,43.5589]},{"Plant":"Dave Johnston","State":"WY","Coal":762,"coordinates":[-105.7769,42.8378]},{"Plant":"Naughton","State":"WY","Coal":700,"coordinates":[-110.5983,41.7581]},{"Plant":"John P Madgett","State":"WI","Coal":392.5,"coordinates":[-91.9126,44.3036]},{"Plant":"Arapahoe","State":"CO","Coal":243,"coordinates":[-105.0028,39.67]},{"Plant":"Cherokee","State":"CO","Coal":717,"coordinates":[-104.9645,39.8073]},{"Plant":"Colbert","State":"AL","Coal":1184,"coordinates":[-87.8486,34.7439]},{"Plant":"Comanche","State":"CO","Coal":660,"coordinates":[-104.5747,38.2081]},{"Plant":"Valmont","State":"CO","Coal":186,"coordinates":[-105.202,40.0195]},{"Plant":"Martin Drake","State":"CO","Coal":254,"coordinates":[-104.8333,38.8244]},{"Plant":"Navajo","State":"AZ","Coal":2250,"coordinates":[-111.3886,36.9047]},{"Plant":"Widows Creek","State":"AL","Coal":1604,"coordinates":[-85.7553,34.883]},{"Plant":"G F Weaton Power Station","State":"PA","Coal":112,"coordinates":[-80.3462,40.6673]},{"Plant":"International Paper Savanna Mill","State":"GA","Coal":106.3,"coordinates":[-81.1242,32.1004]},{"Plant":"Tennessee Eastman Operations","State":"TN","Coal":194.3,"coordinates":[-82.5431,36.5219]},{"Plant":"Axiall Natrium Plant","State":"WV","Coal":123,"coordinates":[-80.8547,39.7475]},{"Plant":"Northampton Generating Company LP","State":"PA","Coal":112,"coordinates":[-75.4792,40.6917]},{"Plant":"Indiantown Cogeneration LP","State":"FL","Coal":330,"coordinates":[-80.5125,27.0389]},{"Plant":"Dolet Hills","State":"LA","Coal":672,"coordinates":[-93.5692,32.0306]},{"Plant":"Mecklenburg Power Station","State":"VA","Coal":138,"coordinates":[-78.53,36.6]},{"Plant":"Sandow No 5","State":"TX","Coal":363,"coordinates":[-97.0614,30.5681]},{"Plant":"Hayden","State":"CO","Coal":446,"coordinates":[-107.185,40.4856]},{"Plant":"Roanoke Valley Energy Facililty I","State":"NC","Coal":165,"coordinates":[-77.6167,36.4364]},{"Plant":"Spruance Genco LLC","State":"VA","Coal":190,"coordinates":[-77.4308,37.4556]},{"Plant":"Birchwood Power","State":"VA","Coal":237.8,"coordinates":[-77.3147,38.2667]},{"Plant":"Red Hills Generating Facility","State":"MS","Coal":440,"coordinates":[-89.2183,33.3761]},{"Plant":"Hardin Generator Project","State":"MT","Coal":107,"coordinates":[-107.6,45.7578]},{"Plant":"Charles R Lowman","State":"AL","Coal":550,"coordinates":[-87.9107,31.488]},{"Plant":"Kennecott Power Plant","State":"UT","Coal":175,"coordinates":[-112.1225,40.7119]},{"Plant":"TS Power Plant","State":"NV","Coal":226.8,"coordinates":[-116.5297,40.7461]},{"Plant":"Stanton Energy Center","State":"FL","Coal":886,"coordinates":[-81.1678,28.4822]},{"Plant":"Bridgeport Station","State":"CT","Coal":372.2,"coordinates":[-73.1844,41.1706]},{"Plant":"Edge Moor","State":"DE","Coal":260,"coordinates":[-75.5038,39.7389]},{"Plant":"Indian River Generating Station","State":"DE","Coal":780,"coordinates":[-75.2341,38.5857]},{"Plant":"James H Miller Jr","State":"AL","Coal":2751.8,"coordinates":[-87.0597,33.6319]},{"Plant":"FirstEnergy Pleasants Power Station","State":"WV","Coal":1278,"coordinates":[-81.2944,39.3667]},{"Plant":"White Bluff","State":"AR","Coal":1655,"coordinates":[-92.1406,34.4228]},{"Plant":"Duck Creek","State":"IL","Coal":358,"coordinates":[-89.9841,40.4663]},{"Plant":"Newton","State":"IL","Coal":1201,"coordinates":[-88.2781,38.9361]},{"Plant":"East Bend","State":"KY","Coal":600,"coordinates":[-84.8514,38.9036]},{"Plant":"W H Zimmer","State":"OH","Coal":1300,"coordinates":[-84.2289,38.8675]},{"Plant":"Brandon Shores","State":"MD","Coal":1286,"coordinates":[-76.5389,39.18]},{"Plant":"Craig","State":"CO","Coal":1274,"coordinates":[-107.5912,40.4627]},{"Plant":"Coal Creek","State":"ND","Coal":1114.3,"coordinates":[-101.1571,47.3777]},{"Plant":"Killen Station","State":"OH","Coal":600,"coordinates":[-83.4803,38.6903]},{"Plant":"Belle River","State":"MI","Coal":1270,"coordinates":[-82.495,42.7756]},{"Plant":"H L Spurlock","State":"KY","Coal":1103,"coordinates":[-83.8181,38.7]},{"Plant":"Wansley","State":"GA","Coal":1752,"coordinates":[-85.0323,33.4134]},{"Plant":"Big Cajun 2","State":"LA","Coal":1743,"coordinates":[-91.3692,30.7261]},{"Plant":"R D Morrow","State":"MS","Coal":360,"coordinates":[-89.394,31.2186]},{"Plant":"Nearman Creek","State":"KS","Coal":229,"coordinates":[-94.6975,39.1681]},{"Plant":"Iatan","State":"MO","Coal":651,"coordinates":[-94.98,39.4472]},{"Plant":"Jeffrey Energy Center","State":"KS","Coal":2170,"coordinates":[-96.1172,39.2865]},{"Plant":"Trimble County","State":"KY","Coal":511,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Coal":1020,"coordinates":[-88.5553,30.5322]},{"Plant":"Colstrip","State":"MT","Coal":2094,"coordinates":[-106.614,45.8831]},{"Plant":"Gerald Gentleman","State":"NE","Coal":1365,"coordinates":[-101.1408,41.0808]},{"Plant":"Somerset Operating Co LLC","State":"NY","Coal":680.8,"coordinates":[-78.6047,43.3589]},{"Plant":"R M Schahfer","State":"IN","Coal":1625,"coordinates":[-87.0261,41.2164]},{"Plant":"Sherburne County","State":"MN","Coal":2258.4,"coordinates":[-93.8931,45.3808]},{"Plant":"FirstEnergy Bruce Mansfield","State":"PA","Coal":2510,"coordinates":[-80.4159,40.6348]},{"Plant":"Sooner","State":"OK","Coal":1046,"coordinates":[-97.0528,36.4531]},{"Plant":"Nebraska City","State":"NE","Coal":646,"coordinates":[-95.7764,40.6214]},{"Plant":"Big Stone","State":"SD","Coal":475,"coordinates":[-96.5101,45.3037]},{"Plant":"Wyodak","State":"WY","Coal":335,"coordinates":[-105.3815,44.2901]},{"Plant":"Boardman","State":"OR","Coal":585,"coordinates":[-119.8088,45.6932]},{"Plant":"Gibson","State":"IN","Coal":3131,"coordinates":[-87.7658,38.3722]},{"Plant":"McIntosh","State":"GA","Coal":156.5,"coordinates":[-81.1683,32.3563]},{"Plant":"Gibbons Creek","State":"TX","Coal":470,"coordinates":[-96.0818,30.6199]},{"Plant":"A B Brown","State":"IN","Coal":490,"coordinates":[-87.715,37.9053]},{"Plant":"Flint Creek","State":"AR","Coal":528,"coordinates":[-94.5241,36.2561]},{"Plant":"Welsh","State":"TX","Coal":1584,"coordinates":[-94.84,33.0552]},{"Plant":"Martin Lake","State":"TX","Coal":2418,"coordinates":[-94.5706,32.2606]},{"Plant":"Monticello","State":"TX","Coal":1931,"coordinates":[-95.0417,33.0917]},{"Plant":"Rush Island","State":"MO","Coal":1181,"coordinates":[-90.2632,38.1312]},{"Plant":"Hunter","State":"UT","Coal":1320,"coordinates":[-111.0289,39.1747]},{"Plant":"Rockport","State":"IN","Coal":2610,"coordinates":[-87.0372,37.9256]},{"Plant":"Pleasant Prairie","State":"WI","Coal":1208,"coordinates":[-87.9033,42.5381]},{"Plant":"Coronado","State":"AZ","Coal":773,"coordinates":[-109.2708,34.5789]},{"Plant":"Coleto Creek","State":"TX","Coal":632,"coordinates":[-97.2142,28.7128]},{"Plant":"Fayette Power Project","State":"TX","Coal":1641,"coordinates":[-96.7506,29.9172]},{"Plant":"J T Deely","State":"TX","Coal":871,"coordinates":[-98.3228,29.3081]},{"Plant":"San Miguel","State":"TX","Coal":391,"coordinates":[-98.4775,28.7044]},{"Plant":"Brame Energy Center","State":"LA","Coal":517,"coordinates":[-92.7167,31.395]},{"Plant":"Harrington","State":"TX","Coal":1041,"coordinates":[-101.7472,35.2982]},{"Plant":"Tolk","State":"TX","Coal":1080,"coordinates":[-102.57,34.1865]},{"Plant":"John Twitty Energy Center","State":"MO","Coal":178,"coordinates":[-93.388,37.1517]},{"Plant":"Laramie River Station","State":"WY","Coal":1705,"coordinates":[-104.8825,42.1089]},{"Plant":"Merom","State":"IN","Coal":955,"coordinates":[-87.5108,39.0694]},{"Plant":"Pawnee","State":"CO","Coal":505,"coordinates":[-103.6803,40.2217]},{"Plant":"Winyah","State":"SC","Coal":1155,"coordinates":[-79.3581,33.3317]},{"Plant":"Mayo","State":"NC","Coal":742,"coordinates":[-78.8917,36.5278]},{"Plant":"Ottumwa","State":"IA","Coal":710.4,"coordinates":[-92.5558,41.0961]},{"Plant":"Scherer","State":"GA","Coal":3404.7,"coordinates":[-83.8075,33.0606]},{"Plant":"Mountaineer","State":"WV","Coal":1310,"coordinates":[-81.9344,38.9794]},{"Plant":"Crystal River","State":"FL","Coal":2311,"coordinates":[-82.6977,28.9656]},{"Plant":"Crist","State":"FL","Coal":930,"coordinates":[-87.2244,30.5661]},{"Plant":"Lansing Smith","State":"FL","Coal":357,"coordinates":[-85.7003,30.2686]},{"Plant":"Big Bend","State":"FL","Coal":1550,"coordinates":[-82.4036,27.7944]},{"Plant":"F J Gannon","State":"FL","Coal":508,"coordinates":[-82.4231,27.9072]},{"Plant":"Antelope Valley","State":"ND","Coal":900,"coordinates":[-101.3194,47.2819]},{"Plant":"Intermountain Power Project","State":"UT","Coal":1800,"coordinates":[-112.5802,39.5097]},{"Plant":"Deerhaven Generating Station","State":"FL","Coal":228.4,"coordinates":[-82.3878,29.7592]},{"Plant":"R D Green","State":"KY","Coal":454,"coordinates":[-87.5,37.6461]},{"Plant":"Independence","State":"AR","Coal":1678,"coordinates":[-91.4088,35.6784]},{"Plant":"Sandow No 4","State":"TX","Coal":568,"coordinates":[-97.064,30.5659]},{"Plant":"Louisa","State":"IA","Coal":745,"coordinates":[-91.0931,41.3181]},{"Plant":"Warrick","State":"IN","Coal":723,"coordinates":[-87.3328,37.915]},{"Plant":"C D McIntosh Jr","State":"FL","Coal":342,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Coal":278,"coordinates":[-105.0212,40.8609]},{"Plant":"Sikeston Power Station","State":"MO","Coal":233,"coordinates":[-89.6209,36.8791]},{"Plant":"Hugo","State":"OK","Coal":440,"coordinates":[-95.3206,34.0158]},{"Plant":"D B Wilson","State":"KY","Coal":416.8,"coordinates":[-87.0806,37.4497]},{"Plant":"Gadsden","State":"AL","Coal":130,"coordinates":[-85.9708,34.0128]},{"Plant":"Bowen","State":"GA","Coal":3221,"coordinates":[-84.9222,34.1256]},{"Plant":"Major Oak Power","State":"TX","Coal":305,"coordinates":[-96.695,31.0919]},{"Plant":"Hammond","State":"GA","Coal":833,"coordinates":[-85.3456,34.2528]},{"Plant":"Harllee Branch","State":"GA","Coal":1607,"coordinates":[-83.2983,33.195]},{"Plant":"J K Spruce","State":"TX","Coal":555,"coordinates":[-98.3203,29.3097]},{"Plant":"Jack McDonough","State":"GA","Coal":503,"coordinates":[-84.4758,33.8239]},{"Plant":"Cope","State":"SC","Coal":420,"coordinates":[-81.03,33.3644]},{"Plant":"Clover","State":"VA","Coal":865,"coordinates":[-78.704,36.869]},{"Plant":"Polk","State":"FL","Coal":235,"coordinates":[-81.9897,27.7286]},{"Plant":"Mitchell","State":"GA","Coal":195,"coordinates":[-84.1347,31.4447]},{"Plant":"Yates","State":"GA","Coal":1286,"coordinates":[-84.8986,33.4622]},{"Plant":"Richard Gorsuch","State":"OH","Coal":200,"coordinates":[-81.5211,39.3664]},{"Plant":"Kraft","State":"GA","Coal":201,"coordinates":[-81.1458,32.1486]},{"Plant":"George Neal South","State":"IA","Coal":644,"coordinates":[-96.3617,42.3006]},{"Plant":"Bonanza","State":"UT","Coal":458,"coordinates":[-109.2844,40.0864]},{"Plant":"Pirkey","State":"TX","Coal":675,"coordinates":[-94.4852,32.4607]},{"Plant":"Gorgas","State":"AL","Coal":1215,"coordinates":[-87.1965,33.6443]},{"Plant":"Columbia","State":"WI","Coal":1118,"coordinates":[-89.4203,43.4864]},{"Plant":"Belews Creek","State":"NC","Coal":2270,"coordinates":[-80.0603,36.2811]},{"Plant":"Jim Bridger","State":"WY","Coal":2120,"coordinates":[-108.7875,41.7378]},{"Plant":"Huntington","State":"UT","Coal":895,"coordinates":[-111.0781,39.3792]},{"Plant":"General James M Gavin","State":"OH","Coal":2640,"coordinates":[-82.1158,38.9347]},{"Plant":"Ray D Nixon","State":"CO","Coal":208,"coordinates":[-104.7058,38.6335]},{"Plant":"Coyote","State":"ND","Coal":427,"coordinates":[-101.8157,47.2214]},{"Plant":"Springerville","State":"AZ","Coal":1200,"coordinates":[-109.1639,34.3186]},{"Plant":"North Valmy","State":"NV","Coal":522,"coordinates":[-117.1516,40.8813]},{"Plant":"Cheswick Power Plant","State":"PA","Coal":580,"coordinates":[-79.7906,40.5383]},{"Plant":"E D Edwards","State":"IL","Coal":715,"coordinates":[-89.6631,40.5958]},{"Plant":"Coffeen","State":"IL","Coal":900,"coordinates":[-89.4031,39.0586]},{"Plant":"Hutsonville","State":"IL","Coal":151,"coordinates":[-87.6597,39.1333]},{"Plant":"Meredosia","State":"IL","Coal":293,"coordinates":[-90.5672,39.8233]},{"Plant":"Crawford","State":"IL","Coal":532,"coordinates":[-87.7229,41.8285]},{"Plant":"Escalante","State":"NM","Coal":247,"coordinates":[-108.082,35.4159]},{"Plant":"Joliet 9","State":"IL","Coal":314,"coordinates":[-88.1153,41.4931]},{"Plant":"Kincaid Generation LLC","State":"IL","Coal":1158,"coordinates":[-89.4964,39.5906]},{"Plant":"Powerton","State":"IL","Coal":1538,"coordinates":[-89.6786,40.5408]},{"Plant":"Waukegan","State":"IL","Coal":789,"coordinates":[-87.8133,42.3833]},{"Plant":"Will County","State":"IL","Coal":1060,"coordinates":[-88.0629,41.6334]},{"Plant":"Fisk Street","State":"IL","Coal":326,"coordinates":[-87.6533,41.8508]},{"Plant":"Joppa Steam","State":"IL","Coal":1002,"coordinates":[-88.8589,37.2094]},{"Plant":"Baldwin Energy Complex","State":"IL","Coal":1764,"coordinates":[-89.8544,38.205]},{"Plant":"Havana","State":"IL","Coal":438,"coordinates":[-90.08,40.2797]},{"Plant":"Hennepin Power Station","State":"IL","Coal":282,"coordinates":[-89.315,41.3028]},{"Plant":"Vermilion","State":"IL","Coal":163,"coordinates":[-87.7481,40.1781]},{"Plant":"Wood River","State":"IL","Coal":437,"coordinates":[-90.1347,38.8639]},{"Plant":"Dallman","State":"IL","Coal":372,"coordinates":[-89.6024,39.7548]},{"Plant":"Marion","State":"IL","Coal":290,"coordinates":[-88.9531,37.6197]},{"Plant":"State Line Energy","State":"IN","Coal":515,"coordinates":[-87.5217,41.7072]},{"Plant":"Clifty Creek","State":"IN","Coal":1203,"coordinates":[-85.4206,38.7378]},{"Plant":"Tanners Creek","State":"IN","Coal":990,"coordinates":[-84.8594,39.0814]},{"Plant":"Harding Street","State":"IN","Coal":647,"coordinates":[-86.1969,39.7113]},{"Plant":"Eagle Valley","State":"IN","Coal":260,"coordinates":[-86.4183,39.4852]},{"Plant":"AES Petersburg","State":"IN","Coal":1752,"coordinates":[-87.2525,38.5281]},{"Plant":"Bailly","State":"IN","Coal":480,"coordinates":[-87.1225,41.645]},{"Plant":"Dean H Mitchell","State":"IN","Coal":360,"coordinates":[-87.4069,41.6392]},{"Plant":"Michigan City","State":"IN","Coal":469,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Coal":497,"coordinates":[-87.7811,32.6017]},{"Plant":"ACE Cogeneration Facility","State":"CA","Coal":101.2,"coordinates":[-117.3836,35.7658]},{"Plant":"Cayuga","State":"IN","Coal":995,"coordinates":[-87.4244,39.9242]},{"Plant":"RED-Rochester, LLC","State":"NY","Coal":129.9,"coordinates":[-77.6319,43.1989]},{"Plant":"Edwardsport","State":"IN","Coal":120,"coordinates":[-87.2472,38.8067]},{"Plant":"Logan Generating Company LP","State":"NJ","Coal":219,"coordinates":[-75.4067,39.7928]},{"Plant":"Portsmouth Genco LLC","State":"VA","Coal":115,"coordinates":[-76.3529,36.8702]},{"Plant":"Taconite Harbor Energy Center","State":"MN","Coal":228.1,"coordinates":[-90.9114,47.5314]},{"Plant":"R Gallagher","State":"IN","Coal":560,"coordinates":[-85.8381,38.2636]},{"Plant":"Wabash River","State":"IN","Coal":942,"coordinates":[-87.4247,39.53]},{"Plant":"F B Culley","State":"IN","Coal":360,"coordinates":[-87.3275,37.9111]},{"Plant":"Colver Power Project","State":"PA","Coal":110,"coordinates":[-78.8,40.55]},{"Plant":"Florida Power Development","State":"FL","Coal":136,"coordinates":[-82.4311,28.5819]},{"Plant":"Green Bay West Mill","State":"WI","Coal":112.9,"coordinates":[-88.0303,44.4936]},{"Plant":"CPI USA NC Southport","State":"NC","Coal":107,"coordinates":[-78.0118,33.9444]},{"Plant":"Edgecombe Genco LLC","State":"NC","Coal":115.6,"coordinates":[-77.7533,36.0373]},{"Plant":"Frank E Ratts","State":"IN","Coal":244,"coordinates":[-87.2662,38.5201]},{"Plant":"Lansing","State":"IA","Coal":290.2,"coordinates":[-91.1675,43.3359]},{"Plant":"Milton L Kapp","State":"IA","Coal":212.4,"coordinates":[-90.2336,41.8081]},{"Plant":"Chambers Cogeneration LP","State":"NJ","Coal":262,"coordinates":[-75.4858,39.6935]},{"Plant":"AES Shady Point LLC","State":"OK","Coal":320,"coordinates":[-94.6458,35.1931]},{"Plant":"Cedar Bay Generating Company LP","State":"FL","Coal":250,"coordinates":[-81.6064,30.4225]},{"Plant":"AES Hawaii","State":"HI","Coal":180,"coordinates":[-158.1065,21.3034]},{"Plant":"AES Thames","State":"CT","Coal":181,"coordinates":[-72.055,41.2607]},{"Plant":"AES Beaver Valley Partners Beaver Valley","State":"PA","Coal":146,"coordinates":[-80.3539,40.6572]},{"Plant":"AES Warrior Run Cogeneration Facility","State":"MD","Coal":180,"coordinates":[-78.7453,39.5952]},{"Plant":"Prairie Creek","State":"IA","Coal":207.9,"coordinates":[-91.6392,41.944]},{"Plant":"Sutherland","State":"IA","Coal":134.4,"coordinates":[-92.8594,42.0473]},{"Plant":"Holcomb","State":"KS","Coal":362,"coordinates":[-100.9725,37.9308]},{"Plant":"Riverside","State":"IA","Coal":134.8,"coordinates":[-90.4481,41.54]},{"Plant":"Walter Scott Jr Energy Center","State":"IA","Coal":1623,"coordinates":[-95.8408,41.18]},{"Plant":"Silver Bay Power","State":"MN","Coal":105,"coordinates":[-91.2605,47.2866]},{"Plant":"Archer Daniels Midland Clinton","State":"IA","Coal":180,"coordinates":[-90.2097,41.8206]},{"Plant":"Archer Daniels Midland Cedar Rapids","State":"IA","Coal":260,"coordinates":[-91.6875,41.9221]},{"Plant":"Archer Daniels Midland Decatur","State":"IL","Coal":335,"coordinates":[-88.8908,39.8701]},{"Plant":"George Neal North","State":"IA","Coal":944.9,"coordinates":[-96.3617,42.2998]},{"Plant":"Burlington","State":"IA","Coal":199.1,"coordinates":[-91.1167,40.7412]},{"Plant":"Ames Electric Services Power Plant","State":"IA","Coal":104.9,"coordinates":[-93.6089,42.0258]},{"Plant":"Cholla","State":"AZ","Coal":1021,"coordinates":[-110.3033,34.9394]},{"Plant":"Muscatine Plant #1","State":"IA","Coal":235,"coordinates":[-91.0569,41.3917]},{"Plant":"La Cygne","State":"KS","Coal":1418,"coordinates":[-94.6456,38.3481]},{"Plant":"Lawrence Energy Center","State":"KS","Coal":530,"coordinates":[-95.2692,39.0072]},{"Plant":"Tecumseh Energy Center","State":"KS","Coal":202,"coordinates":[-95.5689,39.0539]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Coal":156,"coordinates":[-110.9047,32.16]},{"Plant":"Oklaunion","State":"TX","Coal":670,"coordinates":[-99.1753,34.0825]},{"Plant":"Quindaro","State":"KS","Coal":183,"coordinates":[-94.6381,39.1492]},{"Plant":"Cross","State":"SC","Coal":2330,"coordinates":[-80.1119,33.3692]},{"Plant":"Big Sandy","State":"KY","Coal":1060,"coordinates":[-82.6176,38.1707]},{"Plant":"E W Brown","State":"KY","Coal":697,"coordinates":[-84.7126,37.7883]},{"Plant":"Ghent","State":"KY","Coal":1918,"coordinates":[-85.035,38.7497]},{"Plant":"Green River","State":"KY","Coal":163,"coordinates":[-87.1214,37.3636]},{"Plant":"Seminole","State":"FL","Coal":1312,"coordinates":[-81.6328,29.7331]},{"Plant":"Cane Run","State":"KY","Coal":563,"coordinates":[-85.8892,38.1831]},{"Plant":"Mill Creek","State":"KY","Coal":1472,"coordinates":[-85.9103,38.0525]},{"Plant":"Elmer Smith","State":"KY","Coal":399.3,"coordinates":[-87.0608,37.7942]},{"Plant":"Paradise","State":"KY","Coal":2201,"coordinates":[-86.9783,37.2608]},{"Plant":"Shawnee","State":"KY","Coal":1330,"coordinates":[-88.775,37.1517]},{"Plant":"Kenneth C Coleman","State":"KY","Coal":439.6,"coordinates":[-86.7911,37.9631]},{"Plant":"HMP&L Station Two Henderson","State":"KY","Coal":310.2,"coordinates":[-87.5028,37.6469]},{"Plant":"Cooper","State":"KY","Coal":341,"coordinates":[-84.5919,36.9981]},{"Plant":"Dale","State":"KY","Coal":195,"coordinates":[-84.2619,37.8806]},{"Plant":"R S Nelson","State":"LA","Coal":550,"coordinates":[-93.2911,30.2844]},{"Plant":"C P Crane","State":"MD","Coal":385,"coordinates":[-76.3651,39.3236]},{"Plant":"Herbert A Wagner","State":"MD","Coal":440,"coordinates":[-76.5268,39.1781]},{"Plant":"FirstEnergy R Paul Smith Power Station","State":"MD","Coal":115,"coordinates":[-77.8269,39.595]},{"Plant":"Chalk Point LLC","State":"MD","Coal":667,"coordinates":[-76.6861,38.5444]},{"Plant":"Dickerson","State":"MD","Coal":537,"coordinates":[-77.4644,39.2097]},{"Plant":"Morgantown Generating Plant","State":"MD","Coal":1219,"coordinates":[-76.9767,38.3592]},{"Plant":"Apache Station","State":"AZ","Coal":350,"coordinates":[-109.8931,32.0603]},{"Plant":"Mount Tom","State":"MA","Coal":143.6,"coordinates":[-72.6055,42.2806]},{"Plant":"Somerset Station","State":"MA","Coal":109.1,"coordinates":[-71.146,41.7374]},{"Plant":"Brayton Point","State":"MA","Coal":1099.5,"coordinates":[-71.1931,41.7103]},{"Plant":"Salem Harbor","State":"MA","Coal":307.5,"coordinates":[-70.8772,42.5256]},{"Plant":"GRDA","State":"OK","Coal":1010,"coordinates":[-95.2894,36.1903]},{"Plant":"B C Cobb","State":"MI","Coal":312,"coordinates":[-86.2423,43.2588]},{"Plant":"Dan E Karn","State":"MI","Coal":515,"coordinates":[-83.8401,43.645]},{"Plant":"J H Campbell","State":"MI","Coal":1440,"coordinates":[-86.2007,42.9103]},{"Plant":"J C Weadock","State":"MI","Coal":306,"coordinates":[-83.8447,43.6399]},{"Plant":"J R Whiting","State":"MI","Coal":328,"coordinates":[-83.4495,41.7921]},{"Plant":"Harbor Beach","State":"MI","Coal":103,"coordinates":[-82.6436,43.8519]},{"Plant":"Marysville","State":"MI","Coal":166,"coordinates":[-82.4606,42.9256]},{"Plant":"Monroe","State":"MI","Coal":3115,"coordinates":[-83.3464,41.8906]},{"Plant":"River Rouge","State":"MI","Coal":523,"coordinates":[-83.1119,42.2739]},{"Plant":"St Clair","State":"MI","Coal":1368,"coordinates":[-82.4719,42.7642]},{"Plant":"Trenton Channel","State":"MI","Coal":730,"coordinates":[-83.1808,42.1217]},{"Plant":"Presque Isle","State":"MI","Coal":431,"coordinates":[-87.395,46.5789]},{"Plant":"Eckert Station","State":"MI","Coal":318.5,"coordinates":[-84.5581,42.7184]},{"Plant":"Erickson Station","State":"MI","Coal":153.2,"coordinates":[-84.6572,42.6922]},{"Plant":"Syl Laskin","State":"MN","Coal":105.7,"coordinates":[-92.1619,47.5306]},{"Plant":"Clay Boswell","State":"MN","Coal":916.5,"coordinates":[-93.6528,47.2611]},{"Plant":"Black Dog","State":"MN","Coal":282,"coordinates":[-93.2501,44.8108]},{"Plant":"Allen S King","State":"MN","Coal":510,"coordinates":[-92.7786,45.03]},{"Plant":"Hoot Lake","State":"MN","Coal":138,"coordinates":[-96.0433,46.2906]},{"Plant":"Silver Lake","State":"MN","Coal":104,"coordinates":[-92.4604,44.0282]},{"Plant":"Jack Watson","State":"MS","Coal":706,"coordinates":[-89.0286,30.4392]},{"Plant":"St Johns River Power Park","State":"FL","Coal":1252,"coordinates":[-81.5508,30.4308]},{"Plant":"Asbury","State":"MO","Coal":210,"coordinates":[-94.5893,37.3613]},{"Plant":"Hawthorn","State":"MO","Coal":563,"coordinates":[-94.4778,39.1306]},{"Plant":"Montrose","State":"MO","Coal":510,"coordinates":[-93.9348,38.3114]},{"Plant":"Sibley","State":"MO","Coal":508.3,"coordinates":[-94.1844,39.1783]},{"Plant":"Labadie","State":"MO","Coal":2405,"coordinates":[-90.8377,38.5622]},{"Plant":"Meramec","State":"MO","Coal":841,"coordinates":[-90.3358,38.4017]},{"Plant":"Sioux","State":"MO","Coal":986,"coordinates":[-90.2902,38.9155]},{"Plant":"James River Power Station","State":"MO","Coal":236,"coordinates":[-93.2619,37.1086]},{"Plant":"New Madrid","State":"MO","Coal":1160,"coordinates":[-89.5617,36.5147]},{"Plant":"Thomas Hill","State":"MO","Coal":1120,"coordinates":[-92.6381,39.5522]},{"Plant":"J E Corette Plant","State":"MT","Coal":154,"coordinates":[-108.481,45.7756]},{"Plant":"Lon Wright","State":"NE","Coal":120,"coordinates":[-96.4623,41.4281]},{"Plant":"Sheldon","State":"NE","Coal":225,"coordinates":[-96.7847,40.5589]},{"Plant":"North Omaha","State":"NE","Coal":646.1,"coordinates":[-95.9447,41.3291]},{"Plant":"Reid Gardner","State":"NV","Coal":587,"coordinates":[-114.6333,36.6573]},{"Plant":"Mohave","State":"NV","Coal":1580,"coordinates":[-114.5917,35.1458]},{"Plant":"Merrimack","State":"NH","Coal":432.5,"coordinates":[-71.4692,43.1411]},{"Plant":"B L England","State":"NJ","Coal":268,"coordinates":[-74.6364,39.2908]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Coal":574.5,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Mercer Generating Station","State":"NJ","Coal":638,"coordinates":[-74.7339,40.1792]},{"Plant":"Four Corners","State":"NM","Coal":2080,"coordinates":[-108.4814,36.69]},{"Plant":"San Juan","State":"NM","Coal":1643,"coordinates":[-108.4386,36.8006]},{"Plant":"Danskammer Generating Station","State":"NY","Coal":367.2,"coordinates":[-73.975,41.5712]},{"Plant":"GMMGreenidge LLC","State":"NY","Coal":107.5,"coordinates":[-76.9483,42.6789]},{"Plant":"Cayuga Operating Company","State":"NY","Coal":305.7,"coordinates":[-76.6336,42.6028]},{"Plant":"C R Huntley Generating Station","State":"NY","Coal":436,"coordinates":[-78.93,42.97]},{"Plant":"Dunkirk Generating Plant","State":"NY","Coal":520,"coordinates":[-79.3466,42.4915]},{"Plant":"E C Gaston","State":"AL","Coal":1862,"coordinates":[-86.4581,33.2442]},{"Plant":"Asheville","State":"NC","Coal":376,"coordinates":[-82.5417,35.4731]},{"Plant":"Cape Fear","State":"NC","Coal":316,"coordinates":[-79.0495,35.595]},{"Plant":"HF Lee Plant","State":"NC","Coal":397,"coordinates":[-78.0878,35.3799]},{"Plant":"Roxboro","State":"NC","Coal":2422,"coordinates":[-79.0731,36.4833]},{"Plant":"L V Sutton Steam","State":"NC","Coal":604,"coordinates":[-77.9853,34.2831]},{"Plant":"W H Weatherspoon","State":"NC","Coal":171,"coordinates":[-78.9755,34.5875]},{"Plant":"G G Allen","State":"NC","Coal":1124,"coordinates":[-81.0122,35.1897]},{"Plant":"Buck","State":"NC","Coal":369,"coordinates":[-80.3767,35.7133]},{"Plant":"Cliffside","State":"NC","Coal":760,"coordinates":[-81.7594,35.22]},{"Plant":"Dan River","State":"NC","Coal":276,"coordinates":[-79.7208,36.4862]},{"Plant":"Marshall","State":"NC","Coal":2078,"coordinates":[-80.9658,35.5975]},{"Plant":"Riverbend","State":"NC","Coal":454,"coordinates":[-80.9742,35.36]},{"Plant":"R M Heskett","State":"ND","Coal":102.7,"coordinates":[-100.8836,46.8669]},{"Plant":"Leland Olds","State":"ND","Coal":669,"coordinates":[-101.3212,47.2808]},{"Plant":"Milton R Young","State":"ND","Coal":697,"coordinates":[-101.2131,47.0659]},{"Plant":"Stanton","State":"ND","Coal":190.5,"coordinates":[-101.3319,47.2866]},{"Plant":"Cardinal","State":"OH","Coal":1800,"coordinates":[-80.6486,40.2522]},{"Plant":"Walter C Beckjord","State":"OH","Coal":1118,"coordinates":[-84.2981,38.9917]},{"Plant":"Miami Fort","State":"OH","Coal":1181,"coordinates":[-84.8036,39.1128]},{"Plant":"FirstEnergy Ashtabula","State":"OH","Coal":244,"coordinates":[-80.7697,41.9086]},{"Plant":"Avon Lake","State":"OH","Coal":721,"coordinates":[-82.0546,41.5045]},{"Plant":"FirstEnergy Eastlake","State":"OH","Coal":1233,"coordinates":[-81.4425,41.6711]},{"Plant":"FirstEnergy Lake Shore","State":"OH","Coal":245,"coordinates":[-81.6419,41.5356]},{"Plant":"Conesville","State":"OH","Coal":1695,"coordinates":[-81.8811,40.1842]},{"Plant":"O H Hutchings","State":"OH","Coal":365,"coordinates":[-84.2921,39.6088]},{"Plant":"J M Stuart","State":"OH","Coal":2308,"coordinates":[-83.6939,38.6361]},{"Plant":"Niles","State":"OH","Coal":216,"coordinates":[-80.7477,41.1669]},{"Plant":"FirstEnergy R E Burger","State":"OH","Coal":406,"coordinates":[-80.7608,39.91]},{"Plant":"FirstEnergy W H Sammis","State":"OH","Coal":2220,"coordinates":[-80.6319,40.5317]},{"Plant":"Muskingum River","State":"OH","Coal":1375,"coordinates":[-81.6797,39.5908]},{"Plant":"Kyger Creek","State":"OH","Coal":992.8,"coordinates":[-82.1289,38.9144]},{"Plant":"FirstEnergy Bay Shore","State":"OH","Coal":495,"coordinates":[-83.4378,41.6917]},{"Plant":"Muskogee","State":"OK","Coal":1524.3,"coordinates":[-95.2873,35.7614]},{"Plant":"Northeastern","State":"OK","Coal":920,"coordinates":[-95.7008,36.4317]},{"Plant":"Limestone","State":"TX","Coal":1689,"coordinates":[-96.2525,31.4219]},{"Plant":"Barry","State":"AL","Coal":1620,"coordinates":[-88.0103,31.0069]},{"Plant":"Elrama Power Plant","State":"PA","Coal":460,"coordinates":[-79.918,40.2518]},{"Plant":"Portland","State":"PA","Coal":401,"coordinates":[-75.0794,40.9102]},{"Plant":"Titus","State":"PA","Coal":243,"coordinates":[-75.9081,40.3056]},{"Plant":"Conemaugh","State":"PA","Coal":1700,"coordinates":[-79.0611,40.3842]},{"Plant":"Homer City Generating Station","State":"PA","Coal":1884,"coordinates":[-79.1961,40.5128]},{"Plant":"Seward","State":"PA","Coal":525,"coordinates":[-79.0337,40.4062]},{"Plant":"Shawville","State":"PA","Coal":597,"coordinates":[-78.3662,41.0675]},{"Plant":"Keystone","State":"PA","Coal":1700,"coordinates":[-79.3411,40.6604]},{"Plant":"New Castle Plant","State":"PA","Coal":320,"coordinates":[-80.369,40.9379]},{"Plant":"Brunner Island","State":"PA","Coal":1442,"coordinates":[-76.6962,40.0961]},{"Plant":"PPL Montour","State":"PA","Coal":1515,"coordinates":[-76.6672,41.0714]},{"Plant":"Sunbury Generation LP","State":"PA","Coal":382,"coordinates":[-76.825,40.8361]},{"Plant":"Cromby Generating Station","State":"PA","Coal":144,"coordinates":[-75.5294,40.1531]},{"Plant":"Eddystone Generating Station","State":"PA","Coal":588,"coordinates":[-75.323,39.858]},{"Plant":"FirstEnergy Armstrong Power Station","State":"PA","Coal":344,"coordinates":[-79.4656,40.9292]},{"Plant":"Hatfields Ferry Power Station","State":"PA","Coal":1590,"coordinates":[-79.9275,39.8556]},{"Plant":"FirstEnergy Mitchell Power Station","State":"PA","Coal":278,"coordinates":[-79.9683,40.2211]},{"Plant":"H B Robinson","State":"SC","Coal":177,"coordinates":[-80.1589,34.4017]},{"Plant":"W S Lee","State":"SC","Coal":370,"coordinates":[-82.435,34.6022]},{"Plant":"Canadys Steam","State":"SC","Coal":400,"coordinates":[-80.6228,33.0647]},{"Plant":"McMeekin","State":"SC","Coal":250,"coordinates":[-81.2172,34.0556]},{"Plant":"Wateree","State":"SC","Coal":684,"coordinates":[-80.6228,33.8264]},{"Plant":"Williams","State":"SC","Coal":615,"coordinates":[-79.9297,33.0158]},{"Plant":"Dolphus M Grainger","State":"SC","Coal":166,"coordinates":[-79.0533,33.8264]},{"Plant":"Jefferies","State":"SC","Coal":302,"coordinates":[-79.9875,33.2422]},{"Plant":"Allen Steam Plant","State":"TN","Coal":741,"coordinates":[-90.1487,35.0741]},{"Plant":"Bull Run","State":"TN","Coal":870,"coordinates":[-84.1567,36.0211]},{"Plant":"Cumberland","State":"TN","Coal":2470,"coordinates":[-87.6539,36.3903]},{"Plant":"Gallatin","State":"TN","Coal":976,"coordinates":[-86.4006,36.3156]},{"Plant":"John Sevier","State":"TN","Coal":704,"coordinates":[-82.9639,36.3767]},{"Plant":"Johnsonville","State":"TN","Coal":1206,"coordinates":[-87.9861,36.0278]},{"Plant":"Kingston","State":"TN","Coal":1398,"coordinates":[-84.5194,35.8992]},{"Plant":"Watts Bar Fossil","State":"TN","Coal":224,"coordinates":[-84.7811,35.6108]},{"Plant":"W A Parish","State":"TX","Coal":2488,"coordinates":[-95.6311,29.4828]},{"Plant":"Big Brown","State":"TX","Coal":1192,"coordinates":[-96.0544,31.8206]},{"Plant":"Carbon","State":"UT","Coal":172,"coordinates":[-110.8644,39.7272]},{"Plant":"Clinch River","State":"VA","Coal":690,"coordinates":[-82.1997,36.9333]},{"Plant":"Glen Lyn","State":"VA","Coal":325,"coordinates":[-80.8633,37.3706]},{"Plant":"Potomac River","State":"VA","Coal":482,"coordinates":[-77.0411,38.8203]},{"Plant":"Bremo Bluff","State":"VA","Coal":227,"coordinates":[-78.2878,37.7089]},{"Plant":"Chesterfield","State":"VA","Coal":1235,"coordinates":[-77.3833,37.3822]},{"Plant":"Chesapeake","State":"VA","Coal":595,"coordinates":[-76.3019,36.7711]},{"Plant":"Yorktown","State":"VA","Coal":323,"coordinates":[-76.4611,37.2144]},{"Plant":"Joliet 29","State":"IL","Coal":1036,"coordinates":[-88.1238,41.4946]},{"Plant":"Transalta Centralia Generation","State":"WA","Coal":1376,"coordinates":[-122.8598,46.7559]},{"Plant":"John E Amos","State":"WV","Coal":2900,"coordinates":[-81.8233,38.4731]},{"Plant":"Kanawha River","State":"WV","Coal":400,"coordinates":[-81.4211,38.2056]},{"Plant":"Philip Sporn","State":"WV","Coal":1020,"coordinates":[-81.9231,38.9669]},{"Plant":"FirstEnergy Albright","State":"WV","Coal":283,"coordinates":[-79.6369,39.4886]},{"Plant":"FirstEnergy Fort Martin Power Station","State":"WV","Coal":1107,"coordinates":[-79.9275,39.7108]},{"Plant":"FirstEnergy Harrison Power Station","State":"WV","Coal":1954,"coordinates":[-80.3325,39.3842]},{"Plant":"FirstEnergy Rivesville","State":"WV","Coal":125,"coordinates":[-80.1131,39.5314]},{"Plant":"FirstEnergy Willow Island","State":"WV","Coal":235,"coordinates":[-81.3,39.3672]},{"Plant":"Kammer","State":"WV","Coal":600,"coordinates":[-80.8186,39.8461]},{"Plant":"Mitchell","State":"WV","Coal":1560,"coordinates":[-80.8153,39.8297]},{"Plant":"Mt Storm","State":"WV","Coal":1560,"coordinates":[-79.2636,39.2008]},{"Plant":"Blount Street","State":"WI","Coal":188.1,"coordinates":[-89.3744,43.0789]},{"Plant":"South Oak Creek","State":"WI","Coal":1135,"coordinates":[-87.8294,42.8457]},{"Plant":"Valley","State":"WI","Coal":267,"coordinates":[-87.9233,43.0303]},{"Plant":"Edgewater","State":"WI","Coal":767,"coordinates":[-87.7059,43.7151]},{"Plant":"Nelson Dewey Coal Refining Facility","State":"WI","Coal":223.7,"coordinates":[-91.0085,42.7225]},{"Plant":"Pulliam","State":"WI","Coal":322.9,"coordinates":[-88.0086,44.54]},{"Plant":"Weston","State":"WI","Coal":1010.2,"coordinates":[-89.6553,44.8606]},{"Plant":"Alma","State":"WI","Coal":175,"coordinates":[-91.9111,44.3083]},{"Plant":"Genoa","State":"WI","Coal":342,"coordinates":[-91.2325,43.5589]},{"Plant":"Dave Johnston","State":"WY","Coal":762,"coordinates":[-105.7769,42.8378]},{"Plant":"Naughton","State":"WY","Coal":700,"coordinates":[-110.5983,41.7581]},{"Plant":"John P Madgett","State":"WI","Coal":392.1,"coordinates":[-91.9126,44.3036]},{"Plant":"Arapahoe","State":"CO","Coal":153,"coordinates":[-105.0028,39.67]},{"Plant":"Cherokee","State":"CO","Coal":717,"coordinates":[-104.9645,39.8073]},{"Plant":"Colbert","State":"AL","Coal":1184,"coordinates":[-87.8486,34.7439]},{"Plant":"Comanche","State":"CO","Coal":660,"coordinates":[-104.5747,38.2081]},{"Plant":"Valmont","State":"CO","Coal":186,"coordinates":[-105.202,40.0195]},{"Plant":"Martin Drake","State":"CO","Coal":254,"coordinates":[-104.8333,38.8244]},{"Plant":"Navajo","State":"AZ","Coal":2250,"coordinates":[-111.3886,36.9047]},{"Plant":"Widows Creek","State":"AL","Coal":1604,"coordinates":[-85.7553,34.883]},{"Plant":"G F Weaton Power Station","State":"PA","Coal":112,"coordinates":[-80.3462,40.6673]},{"Plant":"Tennessee Eastman Operations","State":"TN","Coal":194.3,"coordinates":[-82.5431,36.5219]},{"Plant":"Axiall Natrium Plant","State":"WV","Coal":123,"coordinates":[-80.8547,39.7475]},{"Plant":"Northampton Generating Company LP","State":"PA","Coal":112,"coordinates":[-75.4792,40.6917]},{"Plant":"Indiantown Cogeneration LP","State":"FL","Coal":330,"coordinates":[-80.5125,27.0389]},{"Plant":"Dolet Hills","State":"LA","Coal":672,"coordinates":[-93.5692,32.0306]},{"Plant":"Mecklenburg Power Station","State":"VA","Coal":138,"coordinates":[-78.53,36.6]},{"Plant":"Hayden","State":"CO","Coal":446,"coordinates":[-107.185,40.4856]},{"Plant":"Roanoke Valley Energy Facililty I","State":"NC","Coal":165,"coordinates":[-77.6167,36.4364]},{"Plant":"Spruance Genco LLC","State":"VA","Coal":190,"coordinates":[-77.4308,37.4556]},{"Plant":"Birchwood Power","State":"VA","Coal":237.8,"coordinates":[-77.3147,38.2667]},{"Plant":"Red Hills Generating Facility","State":"MS","Coal":440,"coordinates":[-89.2183,33.3761]},{"Plant":"Hardin Generator Project","State":"MT","Coal":107,"coordinates":[-107.6,45.7578]},{"Plant":"Charles R Lowman","State":"AL","Coal":550,"coordinates":[-87.9107,31.488]},{"Plant":"Kennecott Power Plant","State":"UT","Coal":175,"coordinates":[-112.1225,40.7119]},{"Plant":"TS Power Plant","State":"NV","Coal":226.8,"coordinates":[-116.5297,40.7461]},{"Plant":"Stanton Energy Center","State":"FL","Coal":886,"coordinates":[-81.1678,28.4822]},{"Plant":"Bridgeport Station","State":"CT","Coal":383.4,"coordinates":[-73.1844,41.1706]},{"Plant":"Edge Moor","State":"DE","Coal":260,"coordinates":[-75.5038,39.7389]},{"Plant":"Indian River Generating Station","State":"DE","Coal":780,"coordinates":[-75.2341,38.5857]},{"Plant":"James H Miller Jr","State":"AL","Coal":2738.8,"coordinates":[-87.0597,33.6319]},{"Plant":"FirstEnergy Pleasants Power Station","State":"WV","Coal":1288,"coordinates":[-81.2944,39.3667]},{"Plant":"White Bluff","State":"AR","Coal":1658,"coordinates":[-92.1406,34.4228]},{"Plant":"Duck Creek","State":"IL","Coal":410,"coordinates":[-89.9841,40.4663]},{"Plant":"Newton","State":"IL","Coal":1204,"coordinates":[-88.2781,38.9361]},{"Plant":"East Bend","State":"KY","Coal":600,"coordinates":[-84.8514,38.9036]},{"Plant":"W H Zimmer","State":"OH","Coal":1301,"coordinates":[-84.2289,38.8675]},{"Plant":"Brandon Shores","State":"MD","Coal":1273,"coordinates":[-76.5389,39.18]},{"Plant":"Craig","State":"CO","Coal":1304,"coordinates":[-107.5912,40.4627]},{"Plant":"Coal Creek","State":"ND","Coal":1140.8,"coordinates":[-101.1571,47.3777]},{"Plant":"Killen Station","State":"OH","Coal":600,"coordinates":[-83.4803,38.6903]},{"Plant":"Belle River","State":"MI","Coal":1270,"coordinates":[-82.495,42.7756]},{"Plant":"H L Spurlock","State":"KY","Coal":1346,"coordinates":[-83.8181,38.7]},{"Plant":"Wansley","State":"GA","Coal":1744,"coordinates":[-85.0323,33.4134]},{"Plant":"Big Cajun 2","State":"LA","Coal":1743,"coordinates":[-91.3692,30.7261]},{"Plant":"R D Morrow","State":"MS","Coal":360,"coordinates":[-89.394,31.2186]},{"Plant":"Nearman Creek","State":"KS","Coal":229,"coordinates":[-94.6975,39.1681]},{"Plant":"Iatan","State":"MO","Coal":651,"coordinates":[-94.98,39.4472]},{"Plant":"Jeffrey Energy Center","State":"KS","Coal":2164,"coordinates":[-96.1172,39.2865]},{"Plant":"Trimble County","State":"KY","Coal":511,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Coal":1020,"coordinates":[-88.5553,30.5322]},{"Plant":"Colstrip","State":"MT","Coal":2094,"coordinates":[-106.614,45.8831]},{"Plant":"Gerald Gentleman","State":"NE","Coal":1365,"coordinates":[-101.1408,41.0808]},{"Plant":"Somerset Operating Co LLC","State":"NY","Coal":684.2,"coordinates":[-78.6047,43.3589]},{"Plant":"R M Schahfer","State":"IN","Coal":1625,"coordinates":[-87.0261,41.2164]},{"Plant":"Sherburne County","State":"MN","Coal":2278,"coordinates":[-93.8931,45.3808]},{"Plant":"FirstEnergy Bruce Mansfield","State":"PA","Coal":2510,"coordinates":[-80.4159,40.6348]},{"Plant":"Sooner","State":"OK","Coal":1046,"coordinates":[-97.0528,36.4531]},{"Plant":"Nebraska City","State":"NE","Coal":1330.2,"coordinates":[-95.7764,40.6214]},{"Plant":"Big Stone","State":"SD","Coal":475,"coordinates":[-96.5101,45.3037]},{"Plant":"Wyodak","State":"WY","Coal":335,"coordinates":[-105.3815,44.2901]},{"Plant":"Boardman","State":"OR","Coal":585,"coordinates":[-119.8088,45.6932]},{"Plant":"Gibson","State":"IN","Coal":3131,"coordinates":[-87.7658,38.3722]},{"Plant":"McIntosh","State":"GA","Coal":156.5,"coordinates":[-81.1683,32.3563]},{"Plant":"Gibbons Creek","State":"TX","Coal":470,"coordinates":[-96.0818,30.6199]},{"Plant":"A B Brown","State":"IN","Coal":490,"coordinates":[-87.715,37.9053]},{"Plant":"Flint Creek","State":"AR","Coal":528,"coordinates":[-94.5241,36.2561]},{"Plant":"Welsh","State":"TX","Coal":1584,"coordinates":[-94.84,33.0552]},{"Plant":"Martin Lake","State":"TX","Coal":2418,"coordinates":[-94.5706,32.2606]},{"Plant":"Monticello","State":"TX","Coal":1931,"coordinates":[-95.0417,33.0917]},{"Plant":"Rush Island","State":"MO","Coal":1181,"coordinates":[-90.2632,38.1312]},{"Plant":"Hunter","State":"UT","Coal":1320,"coordinates":[-111.0289,39.1747]},{"Plant":"Rockport","State":"IN","Coal":2610,"coordinates":[-87.0372,37.9256]},{"Plant":"Pleasant Prairie","State":"WI","Coal":1208,"coordinates":[-87.9033,42.5381]},{"Plant":"Coronado","State":"AZ","Coal":773,"coordinates":[-109.2708,34.5789]},{"Plant":"Coleto Creek","State":"TX","Coal":632,"coordinates":[-97.2142,28.7128]},{"Plant":"Fayette Power Project","State":"TX","Coal":1641,"coordinates":[-96.7506,29.9172]},{"Plant":"J T Deely","State":"TX","Coal":871,"coordinates":[-98.3228,29.3081]},{"Plant":"San Miguel","State":"TX","Coal":391,"coordinates":[-98.4775,28.7044]},{"Plant":"Brame Energy Center","State":"LA","Coal":517,"coordinates":[-92.7167,31.395]},{"Plant":"Harrington","State":"TX","Coal":1041,"coordinates":[-101.7472,35.2982]},{"Plant":"Tolk","State":"TX","Coal":1080,"coordinates":[-102.57,34.1865]},{"Plant":"John Twitty Energy Center","State":"MO","Coal":178,"coordinates":[-93.388,37.1517]},{"Plant":"Laramie River Station","State":"WY","Coal":1705,"coordinates":[-104.8825,42.1089]},{"Plant":"Merom","State":"IN","Coal":989,"coordinates":[-87.5108,39.0694]},{"Plant":"Pawnee","State":"CO","Coal":505,"coordinates":[-103.6803,40.2217]},{"Plant":"Winyah","State":"SC","Coal":1130,"coordinates":[-79.3581,33.3317]},{"Plant":"Mayo","State":"NC","Coal":727,"coordinates":[-78.8917,36.5278]},{"Plant":"Ottumwa","State":"IA","Coal":710.4,"coordinates":[-92.5558,41.0961]},{"Plant":"Scherer","State":"GA","Coal":3399.7,"coordinates":[-83.8075,33.0606]},{"Plant":"Mountaineer","State":"WV","Coal":1310,"coordinates":[-81.9344,38.9794]},{"Plant":"Crystal River","State":"FL","Coal":2290,"coordinates":[-82.6977,28.9656]},{"Plant":"Crist","State":"FL","Coal":930,"coordinates":[-87.2244,30.5661]},{"Plant":"Lansing Smith","State":"FL","Coal":357,"coordinates":[-85.7003,30.2686]},{"Plant":"Big Bend","State":"FL","Coal":1577,"coordinates":[-82.4036,27.7944]},{"Plant":"Antelope Valley","State":"ND","Coal":900,"coordinates":[-101.3194,47.2819]},{"Plant":"Intermountain Power Project","State":"UT","Coal":1800,"coordinates":[-112.5802,39.5097]},{"Plant":"Deerhaven Generating Station","State":"FL","Coal":222.1,"coordinates":[-82.3878,29.7592]},{"Plant":"R D Green","State":"KY","Coal":454,"coordinates":[-87.5,37.6461]},{"Plant":"Independence","State":"AR","Coal":1678,"coordinates":[-91.4088,35.6784]},{"Plant":"Sandow No 4","State":"TX","Coal":568,"coordinates":[-97.064,30.5659]},{"Plant":"Louisa","State":"IA","Coal":745,"coordinates":[-91.0931,41.3181]},{"Plant":"Warrick","State":"IN","Coal":723,"coordinates":[-87.3328,37.915]},{"Plant":"C D McIntosh Jr","State":"FL","Coal":342,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Coal":278,"coordinates":[-105.0212,40.8609]},{"Plant":"Sikeston Power Station","State":"MO","Coal":233,"coordinates":[-89.6209,36.8791]},{"Plant":"Hugo","State":"OK","Coal":440,"coordinates":[-95.3206,34.0158]},{"Plant":"D B Wilson","State":"KY","Coal":416.8,"coordinates":[-87.0806,37.4497]},{"Plant":"Gadsden","State":"AL","Coal":130,"coordinates":[-85.9708,34.0128]},{"Plant":"Bowen","State":"GA","Coal":3182,"coordinates":[-84.9222,34.1256]},{"Plant":"Major Oak Power","State":"TX","Coal":305,"coordinates":[-96.695,31.0919]},{"Plant":"Hammond","State":"GA","Coal":840,"coordinates":[-85.3456,34.2528]},{"Plant":"Harllee Branch","State":"GA","Coal":1607,"coordinates":[-83.2983,33.195]},{"Plant":"J K Spruce","State":"TX","Coal":555,"coordinates":[-98.3203,29.3097]},{"Plant":"Jack McDonough","State":"GA","Coal":503,"coordinates":[-84.4758,33.8239]},{"Plant":"Cope","State":"SC","Coal":420,"coordinates":[-81.03,33.3644]},{"Plant":"Clover","State":"VA","Coal":865,"coordinates":[-78.704,36.869]},{"Plant":"Polk","State":"FL","Coal":235,"coordinates":[-81.9897,27.7286]},{"Plant":"Mitchell","State":"GA","Coal":155,"coordinates":[-84.1347,31.4447]},{"Plant":"Yates","State":"GA","Coal":1286,"coordinates":[-84.8986,33.4622]},{"Plant":"Richard Gorsuch","State":"OH","Coal":200,"coordinates":[-81.5211,39.3664]},{"Plant":"Kraft","State":"GA","Coal":201,"coordinates":[-81.1458,32.1486]},{"Plant":"George Neal South","State":"IA","Coal":644,"coordinates":[-96.3617,42.3006]},{"Plant":"Bonanza","State":"UT","Coal":458,"coordinates":[-109.2844,40.0864]},{"Plant":"Pirkey","State":"TX","Coal":721,"coordinates":[-94.4852,32.4607]},{"Plant":"Gorgas","State":"AL","Coal":1215,"coordinates":[-87.1965,33.6443]},{"Plant":"Columbia","State":"WI","Coal":1118,"coordinates":[-89.4203,43.4864]},{"Plant":"Belews Creek","State":"NC","Coal":2220,"coordinates":[-80.0603,36.2811]},{"Plant":"Jim Bridger","State":"WY","Coal":2117,"coordinates":[-108.7875,41.7378]},{"Plant":"Huntington","State":"UT","Coal":895,"coordinates":[-111.0781,39.3792]},{"Plant":"General James M Gavin","State":"OH","Coal":2640,"coordinates":[-82.1158,38.9347]},{"Plant":"Ray D Nixon","State":"CO","Coal":208,"coordinates":[-104.7058,38.6335]},{"Plant":"Coyote","State":"ND","Coal":427,"coordinates":[-101.8157,47.2214]},{"Plant":"Springerville","State":"AZ","Coal":1609,"coordinates":[-109.1639,34.3186]},{"Plant":"North Valmy","State":"NV","Coal":522,"coordinates":[-117.1516,40.8813]},{"Plant":"Cheswick Power Plant","State":"PA","Coal":580,"coordinates":[-79.7906,40.5383]},{"Plant":"E D Edwards","State":"IL","Coal":720,"coordinates":[-89.6631,40.5958]},{"Plant":"Coffeen","State":"IL","Coal":916,"coordinates":[-89.4031,39.0586]},{"Plant":"Hutsonville","State":"IL","Coal":151,"coordinates":[-87.6597,39.1333]},{"Plant":"Meredosia","State":"IL","Coal":308,"coordinates":[-90.5672,39.8233]},{"Plant":"Crawford","State":"IL","Coal":532,"coordinates":[-87.7229,41.8285]},{"Plant":"Escalante","State":"NM","Coal":247,"coordinates":[-108.082,35.4159]},{"Plant":"Joliet 9","State":"IL","Coal":314,"coordinates":[-88.1153,41.4931]},{"Plant":"Kincaid Generation LLC","State":"IL","Coal":1158,"coordinates":[-89.4964,39.5906]},{"Plant":"Powerton","State":"IL","Coal":1538,"coordinates":[-89.6786,40.5408]},{"Plant":"Waukegan","State":"IL","Coal":689,"coordinates":[-87.8133,42.3833]},{"Plant":"Will County","State":"IL","Coal":1060,"coordinates":[-88.0629,41.6334]},{"Plant":"Fisk Street","State":"IL","Coal":326,"coordinates":[-87.6533,41.8508]},{"Plant":"Joppa Steam","State":"IL","Coal":1002,"coordinates":[-88.8589,37.2094]},{"Plant":"Baldwin Energy Complex","State":"IL","Coal":1761,"coordinates":[-89.8544,38.205]},{"Plant":"Havana","State":"IL","Coal":427,"coordinates":[-90.08,40.2797]},{"Plant":"Hennepin Power Station","State":"IL","Coal":282,"coordinates":[-89.315,41.3028]},{"Plant":"Vermilion","State":"IL","Coal":161,"coordinates":[-87.7481,40.1781]},{"Plant":"Wood River","State":"IL","Coal":454,"coordinates":[-90.1347,38.8639]},{"Plant":"Dallman","State":"IL","Coal":556,"coordinates":[-89.6024,39.7548]},{"Plant":"Marion","State":"IL","Coal":290,"coordinates":[-88.9531,37.6197]},{"Plant":"State Line Energy","State":"IN","Coal":515,"coordinates":[-87.5217,41.7072]},{"Plant":"Clifty Creek","State":"IN","Coal":1203,"coordinates":[-85.4206,38.7378]},{"Plant":"Tanners Creek","State":"IN","Coal":990,"coordinates":[-84.8594,39.0814]},{"Plant":"Harding Street","State":"IN","Coal":647,"coordinates":[-86.1969,39.7113]},{"Plant":"Eagle Valley","State":"IN","Coal":260,"coordinates":[-86.4183,39.4852]},{"Plant":"AES Petersburg","State":"IN","Coal":1752,"coordinates":[-87.2525,38.5281]},{"Plant":"Bailly","State":"IN","Coal":480,"coordinates":[-87.1225,41.645]},{"Plant":"Dean H Mitchell","State":"IN","Coal":360,"coordinates":[-87.4069,41.6392]},{"Plant":"Michigan City","State":"IN","Coal":469,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Coal":497,"coordinates":[-87.7811,32.6017]},{"Plant":"ACE Cogeneration Facility","State":"CA","Coal":101.2,"coordinates":[-117.3836,35.7658]},{"Plant":"Cayuga","State":"IN","Coal":995,"coordinates":[-87.4244,39.9242]},{"Plant":"RED-Rochester, LLC","State":"NY","Coal":129.9,"coordinates":[-77.6319,43.1989]},{"Plant":"Edwardsport","State":"IN","Coal":120,"coordinates":[-87.2472,38.8067]},{"Plant":"Logan Generating Company LP","State":"NJ","Coal":219,"coordinates":[-75.4067,39.7928]},{"Plant":"Portsmouth Genco LLC","State":"VA","Coal":115,"coordinates":[-76.3529,36.8702]},{"Plant":"Taconite Harbor Energy Center","State":"MN","Coal":228.1,"coordinates":[-90.9114,47.5314]},{"Plant":"R Gallagher","State":"IN","Coal":560,"coordinates":[-85.8381,38.2636]},{"Plant":"Wabash River","State":"IN","Coal":942,"coordinates":[-87.4247,39.53]},{"Plant":"F B Culley","State":"IN","Coal":360,"coordinates":[-87.3275,37.9111]},{"Plant":"Colver Power Project","State":"PA","Coal":110,"coordinates":[-78.8,40.55]},{"Plant":"Florida Power Development","State":"FL","Coal":135,"coordinates":[-82.4311,28.5819]},{"Plant":"Green Bay West Mill","State":"WI","Coal":112.9,"coordinates":[-88.0303,44.4936]},{"Plant":"Edgecombe Genco LLC","State":"NC","Coal":115.6,"coordinates":[-77.7533,36.0373]},{"Plant":"Frank E Ratts","State":"IN","Coal":241,"coordinates":[-87.2662,38.5201]},{"Plant":"Lansing","State":"IA","Coal":266,"coordinates":[-91.1675,43.3359]},{"Plant":"Milton L Kapp","State":"IA","Coal":210.7,"coordinates":[-90.2336,41.8081]},{"Plant":"Chambers Cogeneration LP","State":"NJ","Coal":262,"coordinates":[-75.4858,39.6935]},{"Plant":"AES Shady Point LLC","State":"OK","Coal":320,"coordinates":[-94.6458,35.1931]},{"Plant":"Cedar Bay Generating Company LP","State":"FL","Coal":250,"coordinates":[-81.6064,30.4225]},{"Plant":"AES Hawaii","State":"HI","Coal":180,"coordinates":[-158.1065,21.3034]},{"Plant":"AES Thames","State":"CT","Coal":181,"coordinates":[-72.055,41.2607]},{"Plant":"AES Beaver Valley Partners Beaver Valley","State":"PA","Coal":146,"coordinates":[-80.3539,40.6572]},{"Plant":"AES Warrior Run Cogeneration Facility","State":"MD","Coal":180,"coordinates":[-78.7453,39.5952]},{"Plant":"Prairie Creek","State":"IA","Coal":167.9,"coordinates":[-91.6392,41.944]},{"Plant":"Sutherland","State":"IA","Coal":107.6,"coordinates":[-92.8594,42.0473]},{"Plant":"Holcomb","State":"KS","Coal":362,"coordinates":[-100.9725,37.9308]},{"Plant":"Riverside","State":"IA","Coal":132.9,"coordinates":[-90.4481,41.54]},{"Plant":"Walter Scott Jr Energy Center","State":"IA","Coal":1660,"coordinates":[-95.8408,41.18]},{"Plant":"Silver Bay Power","State":"MN","Coal":105,"coordinates":[-91.2605,47.2866]},{"Plant":"Archer Daniels Midland Clinton","State":"IA","Coal":180,"coordinates":[-90.2097,41.8206]},{"Plant":"Archer Daniels Midland Cedar Rapids","State":"IA","Coal":260,"coordinates":[-91.6875,41.9221]},{"Plant":"Archer Daniels Midland Decatur","State":"IL","Coal":335,"coordinates":[-88.8908,39.8701]},{"Plant":"George Neal North","State":"IA","Coal":957.4,"coordinates":[-96.3617,42.2998]},{"Plant":"Burlington","State":"IA","Coal":198.1,"coordinates":[-91.1167,40.7412]},{"Plant":"Ames Electric Services Power Plant","State":"IA","Coal":104.2,"coordinates":[-93.6089,42.0258]},{"Plant":"Cholla","State":"AZ","Coal":1027,"coordinates":[-110.3033,34.9394]},{"Plant":"Muscatine Plant #1","State":"IA","Coal":238.9,"coordinates":[-91.0569,41.3917]},{"Plant":"La Cygne","State":"KS","Coal":1418,"coordinates":[-94.6456,38.3481]},{"Plant":"Lawrence Energy Center","State":"KS","Coal":529,"coordinates":[-95.2692,39.0072]},{"Plant":"Tecumseh Energy Center","State":"KS","Coal":202,"coordinates":[-95.5689,39.0539]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Coal":156,"coordinates":[-110.9047,32.16]},{"Plant":"Oklaunion","State":"TX","Coal":670,"coordinates":[-99.1753,34.0825]},{"Plant":"Quindaro","State":"KS","Coal":183,"coordinates":[-94.6381,39.1492]},{"Plant":"Cross","State":"SC","Coal":2350,"coordinates":[-80.1119,33.3692]},{"Plant":"Big Sandy","State":"KY","Coal":1060,"coordinates":[-82.6176,38.1707]},{"Plant":"E W Brown","State":"KY","Coal":697,"coordinates":[-84.7126,37.7883]},{"Plant":"Ghent","State":"KY","Coal":1918,"coordinates":[-85.035,38.7497]},{"Plant":"Green River","State":"KY","Coal":163,"coordinates":[-87.1214,37.3636]},{"Plant":"Seminole","State":"FL","Coal":1310,"coordinates":[-81.6328,29.7331]},{"Plant":"Cane Run","State":"KY","Coal":563,"coordinates":[-85.8892,38.1831]},{"Plant":"Mill Creek","State":"KY","Coal":1472,"coordinates":[-85.9103,38.0525]},{"Plant":"Elmer Smith","State":"KY","Coal":407.1,"coordinates":[-87.0608,37.7942]},{"Plant":"Paradise","State":"KY","Coal":2201,"coordinates":[-86.9783,37.2608]},{"Plant":"Shawnee","State":"KY","Coal":1330,"coordinates":[-88.775,37.1517]},{"Plant":"Kenneth C Coleman","State":"KY","Coal":443,"coordinates":[-86.7911,37.9631]},{"Plant":"HMP&L Station Two Henderson","State":"KY","Coal":312,"coordinates":[-87.5028,37.6469]},{"Plant":"Cooper","State":"KY","Coal":341,"coordinates":[-84.5919,36.9981]},{"Plant":"Dale","State":"KY","Coal":195,"coordinates":[-84.2619,37.8806]},{"Plant":"R S Nelson","State":"LA","Coal":550,"coordinates":[-93.2911,30.2844]},{"Plant":"C P Crane","State":"MD","Coal":385,"coordinates":[-76.3651,39.3236]},{"Plant":"Herbert A Wagner","State":"MD","Coal":440,"coordinates":[-76.5268,39.1781]},{"Plant":"FirstEnergy R Paul Smith Power Station","State":"MD","Coal":115,"coordinates":[-77.8269,39.595]},{"Plant":"Chalk Point LLC","State":"MD","Coal":667,"coordinates":[-76.6861,38.5444]},{"Plant":"Dickerson","State":"MD","Coal":537,"coordinates":[-77.4644,39.2097]},{"Plant":"Morgantown Generating Plant","State":"MD","Coal":1229,"coordinates":[-76.9767,38.3592]},{"Plant":"Apache Station","State":"AZ","Coal":350,"coordinates":[-109.8931,32.0603]},{"Plant":"Mount Tom","State":"MA","Coal":143.6,"coordinates":[-72.6055,42.2806]},{"Plant":"Somerset Station","State":"MA","Coal":109.1,"coordinates":[-71.146,41.7374]},{"Plant":"Brayton Point","State":"MA","Coal":1099.5,"coordinates":[-71.1931,41.7103]},{"Plant":"Salem Harbor","State":"MA","Coal":307.5,"coordinates":[-70.8772,42.5256]},{"Plant":"GRDA","State":"OK","Coal":1010,"coordinates":[-95.2894,36.1903]},{"Plant":"B C Cobb","State":"MI","Coal":312,"coordinates":[-86.2423,43.2588]},{"Plant":"Dan E Karn","State":"MI","Coal":515,"coordinates":[-83.8401,43.645]},{"Plant":"J H Campbell","State":"MI","Coal":1440,"coordinates":[-86.2007,42.9103]},{"Plant":"J C Weadock","State":"MI","Coal":306,"coordinates":[-83.8447,43.6399]},{"Plant":"J R Whiting","State":"MI","Coal":322.5,"coordinates":[-83.4495,41.7921]},{"Plant":"Marysville","State":"MI","Coal":166,"coordinates":[-82.4606,42.9256]},{"Plant":"Monroe","State":"MI","Coal":2930,"coordinates":[-83.3464,41.8906]},{"Plant":"River Rouge","State":"MI","Coal":527,"coordinates":[-83.1119,42.2739]},{"Plant":"St Clair","State":"MI","Coal":1374,"coordinates":[-82.4719,42.7642]},{"Plant":"Trenton Channel","State":"MI","Coal":713,"coordinates":[-83.1808,42.1217]},{"Plant":"Presque Isle","State":"MI","Coal":431,"coordinates":[-87.395,46.5789]},{"Plant":"Eckert Station","State":"MI","Coal":299.9,"coordinates":[-84.5581,42.7184]},{"Plant":"Erickson Station","State":"MI","Coal":151.1,"coordinates":[-84.6572,42.6922]},{"Plant":"Syl Laskin","State":"MN","Coal":105.7,"coordinates":[-92.1619,47.5306]},{"Plant":"Clay Boswell","State":"MN","Coal":923.5,"coordinates":[-93.6528,47.2611]},{"Plant":"Black Dog","State":"MN","Coal":241,"coordinates":[-93.2501,44.8108]},{"Plant":"Allen S King","State":"MN","Coal":510,"coordinates":[-92.7786,45.03]},{"Plant":"Hoot Lake","State":"MN","Coal":138,"coordinates":[-96.0433,46.2906]},{"Plant":"Silver Lake","State":"MN","Coal":104,"coordinates":[-92.4604,44.0282]},{"Plant":"Jack Watson","State":"MS","Coal":706,"coordinates":[-89.0286,30.4392]},{"Plant":"St Johns River Power Park","State":"FL","Coal":1252,"coordinates":[-81.5508,30.4308]},{"Plant":"Asbury","State":"MO","Coal":207,"coordinates":[-94.5893,37.3613]},{"Plant":"Hawthorn","State":"MO","Coal":559,"coordinates":[-94.4778,39.1306]},{"Plant":"Montrose","State":"MO","Coal":504,"coordinates":[-93.9348,38.3114]},{"Plant":"Sibley","State":"MO","Coal":428.1,"coordinates":[-94.1844,39.1783]},{"Plant":"Labadie","State":"MO","Coal":2407,"coordinates":[-90.8377,38.5622]},{"Plant":"Meramec","State":"MO","Coal":839,"coordinates":[-90.3358,38.4017]},{"Plant":"Sioux","State":"MO","Coal":986,"coordinates":[-90.2902,38.9155]},{"Plant":"James River Power Station","State":"MO","Coal":236,"coordinates":[-93.2619,37.1086]},{"Plant":"New Madrid","State":"MO","Coal":1160,"coordinates":[-89.5617,36.5147]},{"Plant":"Thomas Hill","State":"MO","Coal":1125,"coordinates":[-92.6381,39.5522]},{"Plant":"J E Corette Plant","State":"MT","Coal":154,"coordinates":[-108.481,45.7756]},{"Plant":"Lon Wright","State":"NE","Coal":120,"coordinates":[-96.4623,41.4281]},{"Plant":"Sheldon","State":"NE","Coal":225,"coordinates":[-96.7847,40.5589]},{"Plant":"North Omaha","State":"NE","Coal":646.1,"coordinates":[-95.9447,41.3291]},{"Plant":"Reid Gardner","State":"NV","Coal":553,"coordinates":[-114.6333,36.6573]},{"Plant":"Mohave","State":"NV","Coal":1580,"coordinates":[-114.5917,35.1458]},{"Plant":"Merrimack","State":"NH","Coal":450.9,"coordinates":[-71.4692,43.1411]},{"Plant":"B L England","State":"NJ","Coal":268,"coordinates":[-74.6364,39.2908]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Coal":574.5,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Mercer Generating Station","State":"NJ","Coal":632,"coordinates":[-74.7339,40.1792]},{"Plant":"Four Corners","State":"NM","Coal":2100,"coordinates":[-108.4814,36.69]},{"Plant":"San Juan","State":"NM","Coal":1643,"coordinates":[-108.4386,36.8006]},{"Plant":"Danskammer Generating Station","State":"NY","Coal":375.2,"coordinates":[-73.975,41.5712]},{"Plant":"GMMGreenidge LLC","State":"NY","Coal":107.5,"coordinates":[-76.9483,42.6789]},{"Plant":"Cayuga Operating Company","State":"NY","Coal":312.7,"coordinates":[-76.6336,42.6028]},{"Plant":"C R Huntley Generating Station","State":"NY","Coal":436,"coordinates":[-78.93,42.97]},{"Plant":"Dunkirk Generating Plant","State":"NY","Coal":520,"coordinates":[-79.3466,42.4915]},{"Plant":"E C Gaston","State":"AL","Coal":1862,"coordinates":[-86.4581,33.2442]},{"Plant":"Asheville","State":"NC","Coal":376,"coordinates":[-82.5417,35.4731]},{"Plant":"Cape Fear","State":"NC","Coal":316,"coordinates":[-79.0495,35.595]},{"Plant":"HF Lee Plant","State":"NC","Coal":391,"coordinates":[-78.0878,35.3799]},{"Plant":"Roxboro","State":"NC","Coal":2417,"coordinates":[-79.0731,36.4833]},{"Plant":"L V Sutton Steam","State":"NC","Coal":590,"coordinates":[-77.9853,34.2831]},{"Plant":"W H Weatherspoon","State":"NC","Coal":170,"coordinates":[-78.9755,34.5875]},{"Plant":"G G Allen","State":"NC","Coal":1127,"coordinates":[-81.0122,35.1897]},{"Plant":"Buck","State":"NC","Coal":369,"coordinates":[-80.3767,35.7133]},{"Plant":"Cliffside","State":"NC","Coal":760,"coordinates":[-81.7594,35.22]},{"Plant":"Dan River","State":"NC","Coal":276,"coordinates":[-79.7208,36.4862]},{"Plant":"Marshall","State":"NC","Coal":2078,"coordinates":[-80.9658,35.5975]},{"Plant":"Riverbend","State":"NC","Coal":454,"coordinates":[-80.9742,35.36]},{"Plant":"R M Heskett","State":"ND","Coal":104.4,"coordinates":[-100.8836,46.8669]},{"Plant":"Leland Olds","State":"ND","Coal":670,"coordinates":[-101.3212,47.2808]},{"Plant":"Milton R Young","State":"ND","Coal":697,"coordinates":[-101.2131,47.0659]},{"Plant":"Stanton","State":"ND","Coal":202,"coordinates":[-101.3319,47.2866]},{"Plant":"Cardinal","State":"OH","Coal":1800,"coordinates":[-80.6486,40.2522]},{"Plant":"Walter C Beckjord","State":"OH","Coal":1118,"coordinates":[-84.2981,38.9917]},{"Plant":"Miami Fort","State":"OH","Coal":1183,"coordinates":[-84.8036,39.1128]},{"Plant":"FirstEnergy Ashtabula","State":"OH","Coal":244,"coordinates":[-80.7697,41.9086]},{"Plant":"Avon Lake","State":"OH","Coal":736,"coordinates":[-82.0546,41.5045]},{"Plant":"FirstEnergy Eastlake","State":"OH","Coal":1233,"coordinates":[-81.4425,41.6711]},{"Plant":"FirstEnergy Lake Shore","State":"OH","Coal":245,"coordinates":[-81.6419,41.5356]},{"Plant":"Conesville","State":"OH","Coal":1695,"coordinates":[-81.8811,40.1842]},{"Plant":"O H Hutchings","State":"OH","Coal":365,"coordinates":[-84.2921,39.6088]},{"Plant":"J M Stuart","State":"OH","Coal":2308,"coordinates":[-83.6939,38.6361]},{"Plant":"Niles","State":"OH","Coal":216,"coordinates":[-80.7477,41.1669]},{"Plant":"FirstEnergy W H Sammis","State":"OH","Coal":2220,"coordinates":[-80.6319,40.5317]},{"Plant":"Muskingum River","State":"OH","Coal":1375,"coordinates":[-81.6797,39.5908]},{"Plant":"Kyger Creek","State":"OH","Coal":992.8,"coordinates":[-82.1289,38.9144]},{"Plant":"FirstEnergy Bay Shore","State":"OH","Coal":495,"coordinates":[-83.4378,41.6917]},{"Plant":"Muskogee","State":"OK","Coal":1524.3,"coordinates":[-95.2873,35.7614]},{"Plant":"Northeastern","State":"OK","Coal":920,"coordinates":[-95.7008,36.4317]},{"Plant":"Limestone","State":"TX","Coal":1689,"coordinates":[-96.2525,31.4219]},{"Plant":"Barry","State":"AL","Coal":1612.5,"coordinates":[-88.0103,31.0069]},{"Plant":"Elrama Power Plant","State":"PA","Coal":460,"coordinates":[-79.918,40.2518]},{"Plant":"Portland","State":"PA","Coal":401,"coordinates":[-75.0794,40.9102]},{"Plant":"Titus","State":"PA","Coal":243,"coordinates":[-75.9081,40.3056]},{"Plant":"Conemaugh","State":"PA","Coal":1700,"coordinates":[-79.0611,40.3842]},{"Plant":"Homer City Generating Station","State":"PA","Coal":1884,"coordinates":[-79.1961,40.5128]},{"Plant":"Seward","State":"PA","Coal":525,"coordinates":[-79.0337,40.4062]},{"Plant":"Shawville","State":"PA","Coal":597,"coordinates":[-78.3662,41.0675]},{"Plant":"Keystone","State":"PA","Coal":1700,"coordinates":[-79.3411,40.6604]},{"Plant":"New Castle Plant","State":"PA","Coal":320,"coordinates":[-80.369,40.9379]},{"Plant":"Brunner Island","State":"PA","Coal":1427,"coordinates":[-76.6962,40.0961]},{"Plant":"PPL Montour","State":"PA","Coal":1515,"coordinates":[-76.6672,41.0714]},{"Plant":"Sunbury Generation LP","State":"PA","Coal":382,"coordinates":[-76.825,40.8361]},{"Plant":"Cromby Generating Station","State":"PA","Coal":144,"coordinates":[-75.5294,40.1531]},{"Plant":"Eddystone Generating Station","State":"PA","Coal":588,"coordinates":[-75.323,39.858]},{"Plant":"FirstEnergy Armstrong Power Station","State":"PA","Coal":344,"coordinates":[-79.4656,40.9292]},{"Plant":"Hatfields Ferry Power Station","State":"PA","Coal":1590,"coordinates":[-79.9275,39.8556]},{"Plant":"FirstEnergy Mitchell Power Station","State":"PA","Coal":278,"coordinates":[-79.9683,40.2211]},{"Plant":"H B Robinson","State":"SC","Coal":177,"coordinates":[-80.1589,34.4017]},{"Plant":"W S Lee","State":"SC","Coal":370,"coordinates":[-82.435,34.6022]},{"Plant":"Canadys Steam","State":"SC","Coal":400,"coordinates":[-80.6228,33.0647]},{"Plant":"McMeekin","State":"SC","Coal":250,"coordinates":[-81.2172,34.0556]},{"Plant":"Wateree","State":"SC","Coal":684,"coordinates":[-80.6228,33.8264]},{"Plant":"Williams","State":"SC","Coal":615,"coordinates":[-79.9297,33.0158]},{"Plant":"Dolphus M Grainger","State":"SC","Coal":166,"coordinates":[-79.0533,33.8264]},{"Plant":"Jefferies","State":"SC","Coal":302,"coordinates":[-79.9875,33.2422]},{"Plant":"Allen Steam Plant","State":"TN","Coal":741,"coordinates":[-90.1487,35.0741]},{"Plant":"Bull Run","State":"TN","Coal":870,"coordinates":[-84.1567,36.0211]},{"Plant":"Cumberland","State":"TN","Coal":2470,"coordinates":[-87.6539,36.3903]},{"Plant":"Gallatin","State":"TN","Coal":976,"coordinates":[-86.4006,36.3156]},{"Plant":"John Sevier","State":"TN","Coal":704,"coordinates":[-82.9639,36.3767]},{"Plant":"Johnsonville","State":"TN","Coal":1206,"coordinates":[-87.9861,36.0278]},{"Plant":"Kingston","State":"TN","Coal":1398,"coordinates":[-84.5194,35.8992]},{"Plant":"Watts Bar Fossil","State":"TN","Coal":224,"coordinates":[-84.7811,35.6108]},{"Plant":"W A Parish","State":"TX","Coal":2488,"coordinates":[-95.6311,29.4828]},{"Plant":"Big Brown","State":"TX","Coal":1195,"coordinates":[-96.0544,31.8206]},{"Plant":"Carbon","State":"UT","Coal":172,"coordinates":[-110.8644,39.7272]},{"Plant":"Clinch River","State":"VA","Coal":690,"coordinates":[-82.1997,36.9333]},{"Plant":"Glen Lyn","State":"VA","Coal":325,"coordinates":[-80.8633,37.3706]},{"Plant":"Potomac River","State":"VA","Coal":482,"coordinates":[-77.0411,38.8203]},{"Plant":"Bremo Bluff","State":"VA","Coal":227,"coordinates":[-78.2878,37.7089]},{"Plant":"Chesterfield","State":"VA","Coal":1242,"coordinates":[-77.3833,37.3822]},{"Plant":"Chesapeake","State":"VA","Coal":595,"coordinates":[-76.3019,36.7711]},{"Plant":"Yorktown","State":"VA","Coal":323,"coordinates":[-76.4611,37.2144]},{"Plant":"Joliet 29","State":"IL","Coal":1036,"coordinates":[-88.1238,41.4946]},{"Plant":"Transalta Centralia Generation","State":"WA","Coal":1340,"coordinates":[-122.8598,46.7559]},{"Plant":"John E Amos","State":"WV","Coal":2900,"coordinates":[-81.8233,38.4731]},{"Plant":"Kanawha River","State":"WV","Coal":400,"coordinates":[-81.4211,38.2056]},{"Plant":"Philip Sporn","State":"WV","Coal":1020,"coordinates":[-81.9231,38.9669]},{"Plant":"FirstEnergy Albright","State":"WV","Coal":283,"coordinates":[-79.6369,39.4886]},{"Plant":"FirstEnergy Fort Martin Power Station","State":"WV","Coal":1107,"coordinates":[-79.9275,39.7108]},{"Plant":"FirstEnergy Harrison Power Station","State":"WV","Coal":1954,"coordinates":[-80.3325,39.3842]},{"Plant":"FirstEnergy Rivesville","State":"WV","Coal":125,"coordinates":[-80.1131,39.5314]},{"Plant":"FirstEnergy Willow Island","State":"WV","Coal":235,"coordinates":[-81.3,39.3672]},{"Plant":"Kammer","State":"WV","Coal":600,"coordinates":[-80.8186,39.8461]},{"Plant":"Mitchell","State":"WV","Coal":1560,"coordinates":[-80.8153,39.8297]},{"Plant":"Mt Storm","State":"WV","Coal":1560,"coordinates":[-79.2636,39.2008]},{"Plant":"Blount Street","State":"WI","Coal":188.1,"coordinates":[-89.3744,43.0789]},{"Plant":"South Oak Creek","State":"WI","Coal":1135,"coordinates":[-87.8294,42.8457]},{"Plant":"Valley","State":"WI","Coal":267,"coordinates":[-87.9233,43.0303]},{"Plant":"Edgewater","State":"WI","Coal":784.1,"coordinates":[-87.7059,43.7151]},{"Plant":"Nelson Dewey Coal Refining Facility","State":"WI","Coal":226.4,"coordinates":[-91.0085,42.7225]},{"Plant":"Pulliam","State":"WI","Coal":335.5,"coordinates":[-88.0086,44.54]},{"Plant":"Weston","State":"WI","Coal":1016.3,"coordinates":[-89.6553,44.8606]},{"Plant":"Alma","State":"WI","Coal":176.2,"coordinates":[-91.9111,44.3083]},{"Plant":"Genoa","State":"WI","Coal":325,"coordinates":[-91.2325,43.5589]},{"Plant":"Dave Johnston","State":"WY","Coal":762,"coordinates":[-105.7769,42.8378]},{"Plant":"Naughton","State":"WY","Coal":700,"coordinates":[-110.5983,41.7581]},{"Plant":"John P Madgett","State":"WI","Coal":372,"coordinates":[-91.9126,44.3036]},{"Plant":"Arapahoe","State":"CO","Coal":153,"coordinates":[-105.0028,39.67]},{"Plant":"Cherokee","State":"CO","Coal":717,"coordinates":[-104.9645,39.8073]},{"Plant":"Colbert","State":"AL","Coal":1184,"coordinates":[-87.8486,34.7439]},{"Plant":"Comanche","State":"CO","Coal":1426,"coordinates":[-104.5747,38.2081]},{"Plant":"Valmont","State":"CO","Coal":184,"coordinates":[-105.202,40.0195]},{"Plant":"Martin Drake","State":"CO","Coal":254,"coordinates":[-104.8333,38.8244]},{"Plant":"Navajo","State":"AZ","Coal":2250,"coordinates":[-111.3886,36.9047]},{"Plant":"Widows Creek","State":"AL","Coal":1604,"coordinates":[-85.7553,34.883]},{"Plant":"G F Weaton Power Station","State":"PA","Coal":112,"coordinates":[-80.3462,40.6673]},{"Plant":"Tennessee Eastman Operations","State":"TN","Coal":194.3,"coordinates":[-82.5431,36.5219]},{"Plant":"Axiall Natrium Plant","State":"WV","Coal":123,"coordinates":[-80.8547,39.7475]},{"Plant":"Northampton Generating Company LP","State":"PA","Coal":112,"coordinates":[-75.4792,40.6917]},{"Plant":"Indiantown Cogeneration LP","State":"FL","Coal":330,"coordinates":[-80.5125,27.0389]},{"Plant":"Dolet Hills","State":"LA","Coal":638,"coordinates":[-93.5692,32.0306]},{"Plant":"Mecklenburg Power Station","State":"VA","Coal":138,"coordinates":[-78.53,36.6]},{"Plant":"Sandow No 5","State":"TX","Coal":570,"coordinates":[-97.0614,30.5681]},{"Plant":"Hayden","State":"CO","Coal":446,"coordinates":[-107.185,40.4856]},{"Plant":"Roanoke Valley Energy Facililty I","State":"NC","Coal":165,"coordinates":[-77.6167,36.4364]},{"Plant":"Spruance Genco LLC","State":"VA","Coal":190,"coordinates":[-77.4308,37.4556]},{"Plant":"Birchwood Power","State":"VA","Coal":237.8,"coordinates":[-77.3147,38.2667]},{"Plant":"Red Hills Generating Facility","State":"MS","Coal":440,"coordinates":[-89.2183,33.3761]},{"Plant":"Hardin Generator Project","State":"MT","Coal":107,"coordinates":[-107.6,45.7578]},{"Plant":"Charles R Lowman","State":"AL","Coal":550,"coordinates":[-87.9107,31.488]},{"Plant":"Elm Road Generating Station","State":"WI","Coal":634,"coordinates":[-87.8336,42.8492]},{"Plant":"Kennecott Power Plant","State":"UT","Coal":175,"coordinates":[-112.1225,40.7119]},{"Plant":"TS Power Plant","State":"NV","Coal":218.4,"coordinates":[-116.5297,40.7461]},{"Plant":"Stanton Energy Center","State":"FL","Coal":886,"coordinates":[-81.1678,28.4822]},{"Plant":"Plum Point Energy Station","State":"AR","Coal":670,"coordinates":[-89.9489,35.6644]},{"Plant":"Bridgeport Station","State":"CT","Coal":383.4,"coordinates":[-73.1844,41.1706]},{"Plant":"Edge Moor","State":"DE","Coal":260,"coordinates":[-75.5038,39.7389]},{"Plant":"Indian River Generating Station","State":"DE","Coal":778,"coordinates":[-75.2341,38.5857]},{"Plant":"James H Miller Jr","State":"AL","Coal":2675.2,"coordinates":[-87.0597,33.6319]},{"Plant":"FirstEnergy Pleasants Power Station","State":"WV","Coal":1288,"coordinates":[-81.2944,39.3667]},{"Plant":"White Bluff","State":"AR","Coal":1659,"coordinates":[-92.1406,34.4228]},{"Plant":"Duck Creek","State":"IL","Coal":410,"coordinates":[-89.9841,40.4663]},{"Plant":"Newton","State":"IL","Coal":1197,"coordinates":[-88.2781,38.9361]},{"Plant":"East Bend","State":"KY","Coal":600,"coordinates":[-84.8514,38.9036]},{"Plant":"W H Zimmer","State":"OH","Coal":1300,"coordinates":[-84.2289,38.8675]},{"Plant":"Brandon Shores","State":"MD","Coal":1273,"coordinates":[-76.5389,39.18]},{"Plant":"Craig","State":"CO","Coal":1304,"coordinates":[-107.5912,40.4627]},{"Plant":"Coal Creek","State":"ND","Coal":1131,"coordinates":[-101.1571,47.3777]},{"Plant":"Killen Station","State":"OH","Coal":600,"coordinates":[-83.4803,38.6903]},{"Plant":"Belle River","State":"MI","Coal":1284,"coordinates":[-82.495,42.7756]},{"Plant":"H L Spurlock","State":"KY","Coal":1346,"coordinates":[-83.8181,38.7]},{"Plant":"Wansley","State":"GA","Coal":1744,"coordinates":[-85.0323,33.4134]},{"Plant":"Big Cajun 2","State":"LA","Coal":1743,"coordinates":[-91.3692,30.7261]},{"Plant":"R D Morrow","State":"MS","Coal":360,"coordinates":[-89.394,31.2186]},{"Plant":"Nearman Creek","State":"KS","Coal":229,"coordinates":[-94.6975,39.1681]},{"Plant":"Iatan","State":"MO","Coal":1554.7,"coordinates":[-94.98,39.4472]},{"Plant":"Jeffrey Energy Center","State":"KS","Coal":2164,"coordinates":[-96.1172,39.2865]},{"Plant":"Trimble County","State":"KY","Coal":511,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Coal":1020,"coordinates":[-88.5553,30.5322]},{"Plant":"Colstrip","State":"MT","Coal":2094,"coordinates":[-106.614,45.8831]},{"Plant":"Gerald Gentleman","State":"NE","Coal":1365,"coordinates":[-101.1408,41.0808]},{"Plant":"Somerset Operating Co LLC","State":"NY","Coal":686.5,"coordinates":[-78.6047,43.3589]},{"Plant":"R M Schahfer","State":"IN","Coal":1625,"coordinates":[-87.0261,41.2164]},{"Plant":"Sherburne County","State":"MN","Coal":2275,"coordinates":[-93.8931,45.3808]},{"Plant":"FirstEnergy Bruce Mansfield","State":"PA","Coal":2510,"coordinates":[-80.4159,40.6348]},{"Plant":"Sooner","State":"OK","Coal":1046,"coordinates":[-97.0528,36.4531]},{"Plant":"Nebraska City","State":"NE","Coal":1330.2,"coordinates":[-95.7764,40.6214]},{"Plant":"Big Stone","State":"SD","Coal":475,"coordinates":[-96.5101,45.3037]},{"Plant":"Wyodak","State":"WY","Coal":335,"coordinates":[-105.3815,44.2901]},{"Plant":"Boardman","State":"OR","Coal":585,"coordinates":[-119.8088,45.6932]},{"Plant":"Gibson","State":"IN","Coal":3131,"coordinates":[-87.7658,38.3722]},{"Plant":"McIntosh","State":"GA","Coal":156.5,"coordinates":[-81.1683,32.3563]},{"Plant":"Gibbons Creek","State":"TX","Coal":470,"coordinates":[-96.0818,30.6199]},{"Plant":"A B Brown","State":"IN","Coal":490,"coordinates":[-87.715,37.9053]},{"Plant":"Flint Creek","State":"AR","Coal":528,"coordinates":[-94.5241,36.2561]},{"Plant":"Welsh","State":"TX","Coal":1584,"coordinates":[-94.84,33.0552]},{"Plant":"Martin Lake","State":"TX","Coal":2425,"coordinates":[-94.5706,32.2606]},{"Plant":"Monticello","State":"TX","Coal":1890,"coordinates":[-95.0417,33.0917]},{"Plant":"Rush Island","State":"MO","Coal":1204,"coordinates":[-90.2632,38.1312]},{"Plant":"Hunter","State":"UT","Coal":1336,"coordinates":[-111.0289,39.1747]},{"Plant":"Rockport","State":"IN","Coal":2610,"coordinates":[-87.0372,37.9256]},{"Plant":"Pleasant Prairie","State":"WI","Coal":1188,"coordinates":[-87.9033,42.5381]},{"Plant":"Coronado","State":"AZ","Coal":773,"coordinates":[-109.2708,34.5789]},{"Plant":"Coleto Creek","State":"TX","Coal":592.4,"coordinates":[-97.2142,28.7128]},{"Plant":"Fayette Power Project","State":"TX","Coal":1641,"coordinates":[-96.7506,29.9172]},{"Plant":"Oak Grove","State":"TX","Coal":820,"coordinates":[-96.4866,31.1803]},{"Plant":"J T Deely","State":"TX","Coal":871,"coordinates":[-98.3228,29.3081]},{"Plant":"San Miguel","State":"TX","Coal":391,"coordinates":[-98.4775,28.7044]},{"Plant":"Brame Energy Center","State":"LA","Coal":486,"coordinates":[-92.7167,31.395]},{"Plant":"Harrington","State":"TX","Coal":1018,"coordinates":[-101.7472,35.2982]},{"Plant":"Tolk","State":"TX","Coal":1065,"coordinates":[-102.57,34.1865]},{"Plant":"John Twitty Energy Center","State":"MO","Coal":187,"coordinates":[-93.388,37.1517]},{"Plant":"Laramie River Station","State":"WY","Coal":1710,"coordinates":[-104.8825,42.1089]},{"Plant":"Merom","State":"IN","Coal":1005,"coordinates":[-87.5108,39.0694]},{"Plant":"Pawnee","State":"CO","Coal":505,"coordinates":[-103.6803,40.2217]},{"Plant":"Winyah","State":"SC","Coal":1130,"coordinates":[-79.3581,33.3317]},{"Plant":"Mayo","State":"NC","Coal":727,"coordinates":[-78.8917,36.5278]},{"Plant":"Ottumwa","State":"IA","Coal":695.7,"coordinates":[-92.5558,41.0961]},{"Plant":"Scherer","State":"GA","Coal":3399.7,"coordinates":[-83.8075,33.0606]},{"Plant":"Mountaineer","State":"WV","Coal":1310,"coordinates":[-81.9344,38.9794]},{"Plant":"Crystal River","State":"FL","Coal":2291,"coordinates":[-82.6977,28.9656]},{"Plant":"Crist","State":"FL","Coal":906,"coordinates":[-87.2244,30.5661]},{"Plant":"Lansing Smith","State":"FL","Coal":357,"coordinates":[-85.7003,30.2686]},{"Plant":"Big Bend","State":"FL","Coal":1552,"coordinates":[-82.4036,27.7944]},{"Plant":"Antelope Valley","State":"ND","Coal":900,"coordinates":[-101.3194,47.2819]},{"Plant":"Intermountain Power Project","State":"UT","Coal":1800,"coordinates":[-112.5802,39.5097]},{"Plant":"Deerhaven Generating Station","State":"FL","Coal":222.1,"coordinates":[-82.3878,29.7592]},{"Plant":"R D Green","State":"KY","Coal":454,"coordinates":[-87.5,37.6461]},{"Plant":"Independence","State":"AR","Coal":1678,"coordinates":[-91.4088,35.6784]},{"Plant":"Sandow No 4","State":"TX","Coal":600,"coordinates":[-97.064,30.5659]},{"Plant":"Louisa","State":"IA","Coal":746,"coordinates":[-91.0931,41.3181]},{"Plant":"Warrick","State":"IN","Coal":723,"coordinates":[-87.3328,37.915]},{"Plant":"C D McIntosh Jr","State":"FL","Coal":342,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Coal":278,"coordinates":[-105.0212,40.8609]},{"Plant":"Sikeston Power Station","State":"MO","Coal":233,"coordinates":[-89.6209,36.8791]},{"Plant":"Hugo","State":"OK","Coal":440,"coordinates":[-95.3206,34.0158]},{"Plant":"D B Wilson","State":"KY","Coal":417,"coordinates":[-87.0806,37.4497]},{"Plant":"Gadsden","State":"AL","Coal":130,"coordinates":[-85.9708,34.0128]},{"Plant":"Bowen","State":"GA","Coal":3202,"coordinates":[-84.9222,34.1256]},{"Plant":"Major Oak Power","State":"TX","Coal":305,"coordinates":[-96.695,31.0919]},{"Plant":"Hammond","State":"GA","Coal":840,"coordinates":[-85.3456,34.2528]},{"Plant":"Harllee Branch","State":"GA","Coal":1607,"coordinates":[-83.2983,33.195]},{"Plant":"J K Spruce","State":"TX","Coal":1330,"coordinates":[-98.3203,29.3097]},{"Plant":"Jack McDonough","State":"GA","Coal":502,"coordinates":[-84.4758,33.8239]},{"Plant":"Cope","State":"SC","Coal":420,"coordinates":[-81.03,33.3644]},{"Plant":"Clover","State":"VA","Coal":865,"coordinates":[-78.704,36.869]},{"Plant":"Polk","State":"FL","Coal":220,"coordinates":[-81.9897,27.7286]},{"Plant":"Mitchell","State":"GA","Coal":155,"coordinates":[-84.1347,31.4447]},{"Plant":"Yates","State":"GA","Coal":1286,"coordinates":[-84.8986,33.4622]},{"Plant":"Kraft","State":"GA","Coal":201,"coordinates":[-81.1458,32.1486]},{"Plant":"George Neal South","State":"IA","Coal":645,"coordinates":[-96.3617,42.3006]},{"Plant":"Bonanza","State":"UT","Coal":458,"coordinates":[-109.2844,40.0864]},{"Plant":"Pirkey","State":"TX","Coal":721,"coordinates":[-94.4852,32.4607]},{"Plant":"Gorgas","State":"AL","Coal":1241,"coordinates":[-87.1965,33.6443]},{"Plant":"Columbia","State":"WI","Coal":1118,"coordinates":[-89.4203,43.4864]},{"Plant":"Belews Creek","State":"NC","Coal":2220,"coordinates":[-80.0603,36.2811]},{"Plant":"Jim Bridger","State":"WY","Coal":2118,"coordinates":[-108.7875,41.7378]},{"Plant":"Huntington","State":"UT","Coal":911,"coordinates":[-111.0781,39.3792]},{"Plant":"General James M Gavin","State":"OH","Coal":2640,"coordinates":[-82.1158,38.9347]},{"Plant":"Ray D Nixon","State":"CO","Coal":208,"coordinates":[-104.7058,38.6335]},{"Plant":"Coyote","State":"ND","Coal":427,"coordinates":[-101.8157,47.2214]},{"Plant":"Springerville","State":"AZ","Coal":1609,"coordinates":[-109.1639,34.3186]},{"Plant":"North Valmy","State":"NV","Coal":522,"coordinates":[-117.1516,40.8813]},{"Plant":"Cheswick Power Plant","State":"PA","Coal":580,"coordinates":[-79.7906,40.5383]},{"Plant":"E D Edwards","State":"IL","Coal":715,"coordinates":[-89.6631,40.5958]},{"Plant":"Coffeen","State":"IL","Coal":916,"coordinates":[-89.4031,39.0586]},{"Plant":"Hutsonville","State":"IL","Coal":151,"coordinates":[-87.6597,39.1333]},{"Plant":"Meredosia","State":"IL","Coal":308,"coordinates":[-90.5672,39.8233]},{"Plant":"Crawford","State":"IL","Coal":532,"coordinates":[-87.7229,41.8285]},{"Plant":"Escalante","State":"NM","Coal":247,"coordinates":[-108.082,35.4159]},{"Plant":"Joliet 9","State":"IL","Coal":314,"coordinates":[-88.1153,41.4931]},{"Plant":"Kincaid Generation LLC","State":"IL","Coal":1158,"coordinates":[-89.4964,39.5906]},{"Plant":"Powerton","State":"IL","Coal":1538,"coordinates":[-89.6786,40.5408]},{"Plant":"Waukegan","State":"IL","Coal":689,"coordinates":[-87.8133,42.3833]},{"Plant":"Will County","State":"IL","Coal":761,"coordinates":[-88.0629,41.6334]},{"Plant":"Fisk Street","State":"IL","Coal":326,"coordinates":[-87.6533,41.8508]},{"Plant":"Joppa Steam","State":"IL","Coal":1002,"coordinates":[-88.8589,37.2094]},{"Plant":"Baldwin Energy Complex","State":"IL","Coal":1785,"coordinates":[-89.8544,38.205]},{"Plant":"Havana","State":"IL","Coal":427,"coordinates":[-90.08,40.2797]},{"Plant":"Hennepin Power Station","State":"IL","Coal":282,"coordinates":[-89.315,41.3028]},{"Plant":"Vermilion","State":"IL","Coal":161,"coordinates":[-87.7481,40.1781]},{"Plant":"Wood River","State":"IL","Coal":454,"coordinates":[-90.1347,38.8639]},{"Plant":"Dallman","State":"IL","Coal":556,"coordinates":[-89.6024,39.7548]},{"Plant":"Marion","State":"IL","Coal":290,"coordinates":[-88.9531,37.6197]},{"Plant":"State Line Energy","State":"IN","Coal":515,"coordinates":[-87.5217,41.7072]},{"Plant":"Clifty Creek","State":"IN","Coal":1203,"coordinates":[-85.4206,38.7378]},{"Plant":"Tanners Creek","State":"IN","Coal":990,"coordinates":[-84.8594,39.0814]},{"Plant":"Harding Street","State":"IN","Coal":647,"coordinates":[-86.1969,39.7113]},{"Plant":"Eagle Valley","State":"IN","Coal":257,"coordinates":[-86.4183,39.4852]},{"Plant":"AES Petersburg","State":"IN","Coal":1715.5,"coordinates":[-87.2525,38.5281]},{"Plant":"Bailly","State":"IN","Coal":480,"coordinates":[-87.1225,41.645]},{"Plant":"Michigan City","State":"IN","Coal":469,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Coal":497,"coordinates":[-87.7811,32.6017]},{"Plant":"ACE Cogeneration Facility","State":"CA","Coal":101.2,"coordinates":[-117.3836,35.7658]},{"Plant":"Cayuga","State":"IN","Coal":995,"coordinates":[-87.4244,39.9242]},{"Plant":"RED-Rochester, LLC","State":"NY","Coal":129.9,"coordinates":[-77.6319,43.1989]},{"Plant":"Logan Generating Company LP","State":"NJ","Coal":219,"coordinates":[-75.4067,39.7928]},{"Plant":"Portsmouth Genco LLC","State":"VA","Coal":115,"coordinates":[-76.3529,36.8702]},{"Plant":"Taconite Harbor Energy Center","State":"MN","Coal":234.1,"coordinates":[-90.9114,47.5314]},{"Plant":"R Gallagher","State":"IN","Coal":560,"coordinates":[-85.8381,38.2636]},{"Plant":"Wabash River","State":"IN","Coal":668,"coordinates":[-87.4247,39.53]},{"Plant":"F B Culley","State":"IN","Coal":360,"coordinates":[-87.3275,37.9111]},{"Plant":"Colver Power Project","State":"PA","Coal":110,"coordinates":[-78.8,40.55]},{"Plant":"Florida Power Development","State":"FL","Coal":135,"coordinates":[-82.4311,28.5819]},{"Plant":"Green Bay West Mill","State":"WI","Coal":112.9,"coordinates":[-88.0303,44.4936]},{"Plant":"Edgecombe Genco LLC","State":"NC","Coal":115.6,"coordinates":[-77.7533,36.0373]},{"Plant":"Frank E Ratts","State":"IN","Coal":240,"coordinates":[-87.2662,38.5201]},{"Plant":"Lansing","State":"IA","Coal":269.5,"coordinates":[-91.1675,43.3359]},{"Plant":"Milton L Kapp","State":"IA","Coal":210,"coordinates":[-90.2336,41.8081]},{"Plant":"Chambers Cogeneration LP","State":"NJ","Coal":262,"coordinates":[-75.4858,39.6935]},{"Plant":"AES Shady Point LLC","State":"OK","Coal":320,"coordinates":[-94.6458,35.1931]},{"Plant":"Cedar Bay Generating Company LP","State":"FL","Coal":250,"coordinates":[-81.6064,30.4225]},{"Plant":"AES Hawaii","State":"HI","Coal":180,"coordinates":[-158.1065,21.3034]},{"Plant":"AES Thames","State":"CT","Coal":181,"coordinates":[-72.055,41.2607]},{"Plant":"AES Beaver Valley Partners Beaver Valley","State":"PA","Coal":146,"coordinates":[-80.3539,40.6572]},{"Plant":"AES Warrior Run Cogeneration Facility","State":"MD","Coal":180,"coordinates":[-78.7453,39.5952]},{"Plant":"Prairie Creek","State":"IA","Coal":170.2,"coordinates":[-91.6392,41.944]},{"Plant":"Sutherland","State":"IA","Coal":106.1,"coordinates":[-92.8594,42.0473]},{"Plant":"Holcomb","State":"KS","Coal":362,"coordinates":[-100.9725,37.9308]},{"Plant":"Riverside","State":"IA","Coal":137.3,"coordinates":[-90.4481,41.54]},{"Plant":"Walter Scott Jr Energy Center","State":"IA","Coal":1641.5,"coordinates":[-95.8408,41.18]},{"Plant":"Silver Bay Power","State":"MN","Coal":105,"coordinates":[-91.2605,47.2866]},{"Plant":"Archer Daniels Midland Clinton","State":"IA","Coal":180,"coordinates":[-90.2097,41.8206]},{"Plant":"Archer Daniels Midland Cedar Rapids","State":"IA","Coal":260,"coordinates":[-91.6875,41.9221]},{"Plant":"Archer Daniels Midland Decatur","State":"IL","Coal":335,"coordinates":[-88.8908,39.8701]},{"Plant":"George Neal North","State":"IA","Coal":956.4,"coordinates":[-96.3617,42.2998]},{"Plant":"Burlington","State":"IA","Coal":192,"coordinates":[-91.1167,40.7412]},{"Plant":"Ames Electric Services Power Plant","State":"IA","Coal":101.7,"coordinates":[-93.6089,42.0258]},{"Plant":"Cholla","State":"AZ","Coal":1027,"coordinates":[-110.3033,34.9394]},{"Plant":"Muscatine Plant #1","State":"IA","Coal":239.7,"coordinates":[-91.0569,41.3917]},{"Plant":"La Cygne","State":"KS","Coal":1421.2,"coordinates":[-94.6456,38.3481]},{"Plant":"Lawrence Energy Center","State":"KS","Coal":531,"coordinates":[-95.2692,39.0072]},{"Plant":"Tecumseh Energy Center","State":"KS","Coal":205,"coordinates":[-95.5689,39.0539]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Coal":156,"coordinates":[-110.9047,32.16]},{"Plant":"Oklaunion","State":"TX","Coal":670,"coordinates":[-99.1753,34.0825]},{"Plant":"Quindaro","State":"KS","Coal":183,"coordinates":[-94.6381,39.1492]},{"Plant":"Cross","State":"SC","Coal":2350,"coordinates":[-80.1119,33.3692]},{"Plant":"Big Sandy","State":"KY","Coal":1060,"coordinates":[-82.6176,38.1707]},{"Plant":"E W Brown","State":"KY","Coal":684,"coordinates":[-84.7126,37.7883]},{"Plant":"Ghent","State":"KY","Coal":1932,"coordinates":[-85.035,38.7497]},{"Plant":"Green River","State":"KY","Coal":161,"coordinates":[-87.1214,37.3636]},{"Plant":"Seminole","State":"FL","Coal":1310,"coordinates":[-81.6328,29.7331]},{"Plant":"Cane Run","State":"KY","Coal":563,"coordinates":[-85.8892,38.1831]},{"Plant":"Mill Creek","State":"KY","Coal":1472,"coordinates":[-85.9103,38.0525]},{"Plant":"Elmer Smith","State":"KY","Coal":399.6,"coordinates":[-87.0608,37.7942]},{"Plant":"Paradise","State":"KY","Coal":2201,"coordinates":[-86.9783,37.2608]},{"Plant":"Shawnee","State":"KY","Coal":1330,"coordinates":[-88.775,37.1517]},{"Plant":"Kenneth C Coleman","State":"KY","Coal":443,"coordinates":[-86.7911,37.9631]},{"Plant":"HMP&L Station Two Henderson","State":"KY","Coal":312,"coordinates":[-87.5028,37.6469]},{"Plant":"Cooper","State":"KY","Coal":341,"coordinates":[-84.5919,36.9981]},{"Plant":"Dale","State":"KY","Coal":195,"coordinates":[-84.2619,37.8806]},{"Plant":"R S Nelson","State":"LA","Coal":550,"coordinates":[-93.2911,30.2844]},{"Plant":"C P Crane","State":"MD","Coal":385,"coordinates":[-76.3651,39.3236]},{"Plant":"Herbert A Wagner","State":"MD","Coal":440,"coordinates":[-76.5268,39.1781]},{"Plant":"FirstEnergy R Paul Smith Power Station","State":"MD","Coal":115,"coordinates":[-77.8269,39.595]},{"Plant":"Chalk Point LLC","State":"MD","Coal":667,"coordinates":[-76.6861,38.5444]},{"Plant":"Dickerson","State":"MD","Coal":537,"coordinates":[-77.4644,39.2097]},{"Plant":"Morgantown Generating Plant","State":"MD","Coal":1229,"coordinates":[-76.9767,38.3592]},{"Plant":"Apache Station","State":"AZ","Coal":350,"coordinates":[-109.8931,32.0603]},{"Plant":"Mount Tom","State":"MA","Coal":143.6,"coordinates":[-72.6055,42.2806]},{"Plant":"Brayton Point","State":"MA","Coal":1099.5,"coordinates":[-71.1931,41.7103]},{"Plant":"Salem Harbor","State":"MA","Coal":307.5,"coordinates":[-70.8772,42.5256]},{"Plant":"GRDA","State":"OK","Coal":1010,"coordinates":[-95.2894,36.1903]},{"Plant":"B C Cobb","State":"MI","Coal":312,"coordinates":[-86.2423,43.2588]},{"Plant":"Dan E Karn","State":"MI","Coal":515,"coordinates":[-83.8401,43.645]},{"Plant":"J H Campbell","State":"MI","Coal":1440,"coordinates":[-86.2007,42.9103]},{"Plant":"J C Weadock","State":"MI","Coal":310,"coordinates":[-83.8447,43.6399]},{"Plant":"J R Whiting","State":"MI","Coal":322.5,"coordinates":[-83.4495,41.7921]},{"Plant":"Monroe","State":"MI","Coal":2930,"coordinates":[-83.3464,41.8906]},{"Plant":"River Rouge","State":"MI","Coal":527,"coordinates":[-83.1119,42.2739]},{"Plant":"St Clair","State":"MI","Coal":1374,"coordinates":[-82.4719,42.7642]},{"Plant":"Trenton Channel","State":"MI","Coal":713,"coordinates":[-83.1808,42.1217]},{"Plant":"Presque Isle","State":"MI","Coal":407,"coordinates":[-87.395,46.5789]},{"Plant":"Eckert Station","State":"MI","Coal":298.9,"coordinates":[-84.5581,42.7184]},{"Plant":"Erickson Station","State":"MI","Coal":153.5,"coordinates":[-84.6572,42.6922]},{"Plant":"Syl Laskin","State":"MN","Coal":105.7,"coordinates":[-92.1619,47.5306]},{"Plant":"Clay Boswell","State":"MN","Coal":923.5,"coordinates":[-93.6528,47.2611]},{"Plant":"Black Dog","State":"MN","Coal":232,"coordinates":[-93.2501,44.8108]},{"Plant":"Allen S King","State":"MN","Coal":511,"coordinates":[-92.7786,45.03]},{"Plant":"Hoot Lake","State":"MN","Coal":138,"coordinates":[-96.0433,46.2906]},{"Plant":"Jack Watson","State":"MS","Coal":706,"coordinates":[-89.0286,30.4392]},{"Plant":"St Johns River Power Park","State":"FL","Coal":1252,"coordinates":[-81.5508,30.4308]},{"Plant":"Asbury","State":"MO","Coal":207,"coordinates":[-94.5893,37.3613]},{"Plant":"Hawthorn","State":"MO","Coal":564,"coordinates":[-94.4778,39.1306]},{"Plant":"Montrose","State":"MO","Coal":510,"coordinates":[-93.9348,38.3114]},{"Plant":"Sibley","State":"MO","Coal":462.1,"coordinates":[-94.1844,39.1783]},{"Plant":"Labadie","State":"MO","Coal":2401,"coordinates":[-90.8377,38.5622]},{"Plant":"Meramec","State":"MO","Coal":835,"coordinates":[-90.3358,38.4017]},{"Plant":"Sioux","State":"MO","Coal":970,"coordinates":[-90.2902,38.9155]},{"Plant":"James River Power Station","State":"MO","Coal":236,"coordinates":[-93.2619,37.1086]},{"Plant":"New Madrid","State":"MO","Coal":1179,"coordinates":[-89.5617,36.5147]},{"Plant":"Thomas Hill","State":"MO","Coal":1126.7,"coordinates":[-92.6381,39.5522]},{"Plant":"J E Corette Plant","State":"MT","Coal":153,"coordinates":[-108.481,45.7756]},{"Plant":"Lon Wright","State":"NE","Coal":120,"coordinates":[-96.4623,41.4281]},{"Plant":"Sheldon","State":"NE","Coal":225,"coordinates":[-96.7847,40.5589]},{"Plant":"North Omaha","State":"NE","Coal":638.2,"coordinates":[-95.9447,41.3291]},{"Plant":"Reid Gardner","State":"NV","Coal":553,"coordinates":[-114.6333,36.6573]},{"Plant":"Mohave","State":"NV","Coal":1580,"coordinates":[-114.5917,35.1458]},{"Plant":"Merrimack","State":"NH","Coal":450.9,"coordinates":[-71.4692,43.1411]},{"Plant":"B L England","State":"NJ","Coal":268,"coordinates":[-74.6364,39.2908]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Coal":613.1,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Mercer Generating Station","State":"NJ","Coal":638.8,"coordinates":[-74.7339,40.1792]},{"Plant":"Four Corners","State":"NM","Coal":2100,"coordinates":[-108.4814,36.69]},{"Plant":"San Juan","State":"NM","Coal":1643,"coordinates":[-108.4386,36.8006]},{"Plant":"Danskammer Generating Station","State":"NY","Coal":374.7,"coordinates":[-73.975,41.5712]},{"Plant":"GMMGreenidge LLC","State":"NY","Coal":107.5,"coordinates":[-76.9483,42.6789]},{"Plant":"Cayuga Operating Company","State":"NY","Coal":302.4,"coordinates":[-76.6336,42.6028]},{"Plant":"C R Huntley Generating Station","State":"NY","Coal":436,"coordinates":[-78.93,42.97]},{"Plant":"Dunkirk Generating Plant","State":"NY","Coal":520,"coordinates":[-79.3466,42.4915]},{"Plant":"E C Gaston","State":"AL","Coal":1862,"coordinates":[-86.4581,33.2442]},{"Plant":"Asheville","State":"NC","Coal":376,"coordinates":[-82.5417,35.4731]},{"Plant":"Cape Fear","State":"NC","Coal":316,"coordinates":[-79.0495,35.595]},{"Plant":"HF Lee Plant","State":"NC","Coal":382,"coordinates":[-78.0878,35.3799]},{"Plant":"Roxboro","State":"NC","Coal":2417,"coordinates":[-79.0731,36.4833]},{"Plant":"L V Sutton Steam","State":"NC","Coal":575,"coordinates":[-77.9853,34.2831]},{"Plant":"G G Allen","State":"NC","Coal":1127,"coordinates":[-81.0122,35.1897]},{"Plant":"Buck","State":"NC","Coal":256,"coordinates":[-80.3767,35.7133]},{"Plant":"Cliffside","State":"NC","Coal":552,"coordinates":[-81.7594,35.22]},{"Plant":"Dan River","State":"NC","Coal":276,"coordinates":[-79.7208,36.4862]},{"Plant":"Marshall","State":"NC","Coal":2078,"coordinates":[-80.9658,35.5975]},{"Plant":"Riverbend","State":"NC","Coal":454,"coordinates":[-80.9742,35.36]},{"Plant":"R M Heskett","State":"ND","Coal":104.3,"coordinates":[-100.8836,46.8669]},{"Plant":"Leland Olds","State":"ND","Coal":670,"coordinates":[-101.3212,47.2808]},{"Plant":"Milton R Young","State":"ND","Coal":697,"coordinates":[-101.2131,47.0659]},{"Plant":"Stanton","State":"ND","Coal":187.4,"coordinates":[-101.3319,47.2866]},{"Plant":"Cardinal","State":"OH","Coal":1800,"coordinates":[-80.6486,40.2522]},{"Plant":"Walter C Beckjord","State":"OH","Coal":1118,"coordinates":[-84.2981,38.9917]},{"Plant":"Miami Fort","State":"OH","Coal":1183,"coordinates":[-84.8036,39.1128]},{"Plant":"FirstEnergy Ashtabula","State":"OH","Coal":244,"coordinates":[-80.7697,41.9086]},{"Plant":"Avon Lake","State":"OH","Coal":736,"coordinates":[-82.0546,41.5045]},{"Plant":"FirstEnergy Eastlake","State":"OH","Coal":1233,"coordinates":[-81.4425,41.6711]},{"Plant":"FirstEnergy Lake Shore","State":"OH","Coal":245,"coordinates":[-81.6419,41.5356]},{"Plant":"Conesville","State":"OH","Coal":1695,"coordinates":[-81.8811,40.1842]},{"Plant":"O H Hutchings","State":"OH","Coal":365,"coordinates":[-84.2921,39.6088]},{"Plant":"J M Stuart","State":"OH","Coal":2308,"coordinates":[-83.6939,38.6361]},{"Plant":"Niles","State":"OH","Coal":216,"coordinates":[-80.7477,41.1669]},{"Plant":"FirstEnergy W H Sammis","State":"OH","Coal":2220,"coordinates":[-80.6319,40.5317]},{"Plant":"Muskingum River","State":"OH","Coal":1375,"coordinates":[-81.6797,39.5908]},{"Plant":"Kyger Creek","State":"OH","Coal":974.8,"coordinates":[-82.1289,38.9144]},{"Plant":"FirstEnergy Bay Shore","State":"OH","Coal":495,"coordinates":[-83.4378,41.6917]},{"Plant":"Muskogee","State":"OK","Coal":1510,"coordinates":[-95.2873,35.7614]},{"Plant":"Northeastern","State":"OK","Coal":920,"coordinates":[-95.7008,36.4317]},{"Plant":"Limestone","State":"TX","Coal":1689,"coordinates":[-96.2525,31.4219]},{"Plant":"Barry","State":"AL","Coal":1612.5,"coordinates":[-88.0103,31.0069]},{"Plant":"Elrama Power Plant","State":"PA","Coal":460,"coordinates":[-79.918,40.2518]},{"Plant":"Portland","State":"PA","Coal":401,"coordinates":[-75.0794,40.9102]},{"Plant":"Titus","State":"PA","Coal":243,"coordinates":[-75.9081,40.3056]},{"Plant":"Conemaugh","State":"PA","Coal":1700,"coordinates":[-79.0611,40.3842]},{"Plant":"Homer City Generating Station","State":"PA","Coal":1884,"coordinates":[-79.1961,40.5128]},{"Plant":"Seward","State":"PA","Coal":525,"coordinates":[-79.0337,40.4062]},{"Plant":"Shawville","State":"PA","Coal":597,"coordinates":[-78.3662,41.0675]},{"Plant":"Keystone","State":"PA","Coal":1700,"coordinates":[-79.3411,40.6604]},{"Plant":"New Castle Plant","State":"PA","Coal":320,"coordinates":[-80.369,40.9379]},{"Plant":"Brunner Island","State":"PA","Coal":1437,"coordinates":[-76.6962,40.0961]},{"Plant":"PPL Montour","State":"PA","Coal":1515,"coordinates":[-76.6672,41.0714]},{"Plant":"Sunbury Generation LP","State":"PA","Coal":382,"coordinates":[-76.825,40.8361]},{"Plant":"Eddystone Generating Station","State":"PA","Coal":309,"coordinates":[-75.323,39.858]},{"Plant":"FirstEnergy Armstrong Power Station","State":"PA","Coal":344,"coordinates":[-79.4656,40.9292]},{"Plant":"Hatfields Ferry Power Station","State":"PA","Coal":1590,"coordinates":[-79.9275,39.8556]},{"Plant":"FirstEnergy Mitchell Power Station","State":"PA","Coal":278,"coordinates":[-79.9683,40.2211]},{"Plant":"H B Robinson","State":"SC","Coal":177,"coordinates":[-80.1589,34.4017]},{"Plant":"W S Lee","State":"SC","Coal":370,"coordinates":[-82.435,34.6022]},{"Plant":"Canadys Steam","State":"SC","Coal":400,"coordinates":[-80.6228,33.0647]},{"Plant":"McMeekin","State":"SC","Coal":250,"coordinates":[-81.2172,34.0556]},{"Plant":"Wateree","State":"SC","Coal":684,"coordinates":[-80.6228,33.8264]},{"Plant":"Williams","State":"SC","Coal":605,"coordinates":[-79.9297,33.0158]},{"Plant":"Dolphus M Grainger","State":"SC","Coal":166,"coordinates":[-79.0533,33.8264]},{"Plant":"Jefferies","State":"SC","Coal":302,"coordinates":[-79.9875,33.2422]},{"Plant":"Allen Steam Plant","State":"TN","Coal":741,"coordinates":[-90.1487,35.0741]},{"Plant":"Bull Run","State":"TN","Coal":870,"coordinates":[-84.1567,36.0211]},{"Plant":"Cumberland","State":"TN","Coal":2470,"coordinates":[-87.6539,36.3903]},{"Plant":"Gallatin","State":"TN","Coal":976,"coordinates":[-86.4006,36.3156]},{"Plant":"John Sevier","State":"TN","Coal":704,"coordinates":[-82.9639,36.3767]},{"Plant":"Johnsonville","State":"TN","Coal":1206,"coordinates":[-87.9861,36.0278]},{"Plant":"Kingston","State":"TN","Coal":1398,"coordinates":[-84.5194,35.8992]},{"Plant":"W A Parish","State":"TX","Coal":2499,"coordinates":[-95.6311,29.4828]},{"Plant":"Big Brown","State":"TX","Coal":1195,"coordinates":[-96.0544,31.8206]},{"Plant":"Carbon","State":"UT","Coal":172,"coordinates":[-110.8644,39.7272]},{"Plant":"Clinch River","State":"VA","Coal":690,"coordinates":[-82.1997,36.9333]},{"Plant":"Glen Lyn","State":"VA","Coal":325,"coordinates":[-80.8633,37.3706]},{"Plant":"Potomac River","State":"VA","Coal":482,"coordinates":[-77.0411,38.8203]},{"Plant":"Bremo Bluff","State":"VA","Coal":227,"coordinates":[-78.2878,37.7089]},{"Plant":"Chesterfield","State":"VA","Coal":1248.5,"coordinates":[-77.3833,37.3822]},{"Plant":"Chesapeake","State":"VA","Coal":595,"coordinates":[-76.3019,36.7711]},{"Plant":"Yorktown","State":"VA","Coal":323,"coordinates":[-76.4611,37.2144]},{"Plant":"Joliet 29","State":"IL","Coal":1036,"coordinates":[-88.1238,41.4946]},{"Plant":"Transalta Centralia Generation","State":"WA","Coal":1340,"coordinates":[-122.8598,46.7559]},{"Plant":"John E Amos","State":"WV","Coal":2900,"coordinates":[-81.8233,38.4731]},{"Plant":"Kanawha River","State":"WV","Coal":400,"coordinates":[-81.4211,38.2056]},{"Plant":"Philip Sporn","State":"WV","Coal":1020,"coordinates":[-81.9231,38.9669]},{"Plant":"FirstEnergy Albright","State":"WV","Coal":283,"coordinates":[-79.6369,39.4886]},{"Plant":"FirstEnergy Fort Martin Power Station","State":"WV","Coal":1107,"coordinates":[-79.9275,39.7108]},{"Plant":"FirstEnergy Harrison Power Station","State":"WV","Coal":1954,"coordinates":[-80.3325,39.3842]},{"Plant":"FirstEnergy Rivesville","State":"WV","Coal":125,"coordinates":[-80.1131,39.5314]},{"Plant":"FirstEnergy Willow Island","State":"WV","Coal":235,"coordinates":[-81.3,39.3672]},{"Plant":"Kammer","State":"WV","Coal":600,"coordinates":[-80.8186,39.8461]},{"Plant":"Mitchell","State":"WV","Coal":1560,"coordinates":[-80.8153,39.8297]},{"Plant":"Mt Storm","State":"WV","Coal":1591,"coordinates":[-79.2636,39.2008]},{"Plant":"South Oak Creek","State":"WI","Coal":1048.4,"coordinates":[-87.8294,42.8457]},{"Plant":"Valley","State":"WI","Coal":232.5,"coordinates":[-87.9233,43.0303]},{"Plant":"Edgewater","State":"WI","Coal":786.8,"coordinates":[-87.7059,43.7151]},{"Plant":"Nelson Dewey Coal Refining Facility","State":"WI","Coal":207.9,"coordinates":[-91.0085,42.7225]},{"Plant":"Pulliam","State":"WI","Coal":330.6,"coordinates":[-88.0086,44.54]},{"Plant":"Weston","State":"WI","Coal":1012,"coordinates":[-89.6553,44.8606]},{"Plant":"Alma","State":"WI","Coal":176.2,"coordinates":[-91.9111,44.3083]},{"Plant":"Genoa","State":"WI","Coal":269.4,"coordinates":[-91.2325,43.5589]},{"Plant":"Dave Johnston","State":"WY","Coal":762,"coordinates":[-105.7769,42.8378]},{"Plant":"Naughton","State":"WY","Coal":700,"coordinates":[-110.5983,41.7581]},{"Plant":"John P Madgett","State":"WI","Coal":372,"coordinates":[-91.9126,44.3036]},{"Plant":"Arapahoe","State":"CO","Coal":153,"coordinates":[-105.0028,39.67]},{"Plant":"Cherokee","State":"CO","Coal":611,"coordinates":[-104.9645,39.8073]},{"Plant":"Colbert","State":"AL","Coal":1184,"coordinates":[-87.8486,34.7439]},{"Plant":"Comanche","State":"CO","Coal":1426,"coordinates":[-104.5747,38.2081]},{"Plant":"Valmont","State":"CO","Coal":184,"coordinates":[-105.202,40.0195]},{"Plant":"Martin Drake","State":"CO","Coal":254,"coordinates":[-104.8333,38.8244]},{"Plant":"Navajo","State":"AZ","Coal":2250,"coordinates":[-111.3886,36.9047]},{"Plant":"Widows Creek","State":"AL","Coal":1604,"coordinates":[-85.7553,34.883]},{"Plant":"G F Weaton Power Station","State":"PA","Coal":112,"coordinates":[-80.3462,40.6673]},{"Plant":"Tennessee Eastman Operations","State":"TN","Coal":194.3,"coordinates":[-82.5431,36.5219]},{"Plant":"Axiall Natrium Plant","State":"WV","Coal":123,"coordinates":[-80.8547,39.7475]},{"Plant":"Northampton Generating Company LP","State":"PA","Coal":112,"coordinates":[-75.4792,40.6917]},{"Plant":"Indiantown Cogeneration LP","State":"FL","Coal":330,"coordinates":[-80.5125,27.0389]},{"Plant":"Dolet Hills","State":"LA","Coal":638,"coordinates":[-93.5692,32.0306]},{"Plant":"Mecklenburg Power Station","State":"VA","Coal":138,"coordinates":[-78.53,36.6]},{"Plant":"Sandow No 5","State":"TX","Coal":570,"coordinates":[-97.0614,30.5681]},{"Plant":"Hayden","State":"CO","Coal":446,"coordinates":[-107.185,40.4856]},{"Plant":"Roanoke Valley Energy Facililty I","State":"NC","Coal":165,"coordinates":[-77.6167,36.4364]},{"Plant":"Spruance Genco LLC","State":"VA","Coal":190,"coordinates":[-77.4308,37.4556]},{"Plant":"Birchwood Power","State":"VA","Coal":237.8,"coordinates":[-77.3147,38.2667]},{"Plant":"Red Hills Generating Facility","State":"MS","Coal":440,"coordinates":[-89.2183,33.3761]},{"Plant":"Hardin Generator Project","State":"MT","Coal":107,"coordinates":[-107.6,45.7578]},{"Plant":"Charles R Lowman","State":"AL","Coal":550,"coordinates":[-87.9107,31.488]},{"Plant":"Elm Road Generating Station","State":"WI","Coal":1269.8,"coordinates":[-87.8336,42.8492]},{"Plant":"Kennecott Power Plant","State":"UT","Coal":175,"coordinates":[-112.1225,40.7119]},{"Plant":"TS Power Plant","State":"NV","Coal":218.4,"coordinates":[-116.5297,40.7461]},{"Plant":"Stanton Energy Center","State":"FL","Coal":886,"coordinates":[-81.1678,28.4822]},{"Plant":"Plum Point Energy Station","State":"AR","Coal":670,"coordinates":[-89.9489,35.6644]},{"Plant":"Dry Fork Station","State":"WY","Coal":405,"coordinates":[-105.4608,44.3889]},{"Plant":"Longview Power LLC","State":"WV","Coal":700,"coordinates":[-79.959,39.7079]},{"Plant":"Bridgeport Station","State":"CT","Coal":383.4,"coordinates":[-73.1844,41.1706]},{"Plant":"Indian River Generating Station","State":"DE","Coal":778,"coordinates":[-75.2341,38.5857]},{"Plant":"Whelan Energy Center","State":"NE","Coal":302,"coordinates":[-98.3124,40.5809]},{"Plant":"James H Miller Jr","State":"AL","Coal":2675.2,"coordinates":[-87.0597,33.6319]},{"Plant":"FirstEnergy Pleasants Power Station","State":"WV","Coal":1288,"coordinates":[-81.2944,39.3667]},{"Plant":"White Bluff","State":"AR","Coal":1659,"coordinates":[-92.1406,34.4228]},{"Plant":"Duck Creek","State":"IL","Coal":410,"coordinates":[-89.9841,40.4663]},{"Plant":"Newton","State":"IL","Coal":1197,"coordinates":[-88.2781,38.9361]},{"Plant":"East Bend","State":"KY","Coal":600,"coordinates":[-84.8514,38.9036]},{"Plant":"W H Zimmer","State":"OH","Coal":1300,"coordinates":[-84.2289,38.8675]},{"Plant":"Brandon Shores","State":"MD","Coal":1273,"coordinates":[-76.5389,39.18]},{"Plant":"Craig","State":"CO","Coal":1304,"coordinates":[-107.5912,40.4627]},{"Plant":"Coal Creek","State":"ND","Coal":1140.3,"coordinates":[-101.1571,47.3777]},{"Plant":"Killen Station","State":"OH","Coal":600,"coordinates":[-83.4803,38.6903]},{"Plant":"Belle River","State":"MI","Coal":1284,"coordinates":[-82.495,42.7756]},{"Plant":"H L Spurlock","State":"KY","Coal":1346,"coordinates":[-83.8181,38.7]},{"Plant":"Wansley","State":"GA","Coal":1744,"coordinates":[-85.0323,33.4134]},{"Plant":"Big Cajun 2","State":"LA","Coal":1743,"coordinates":[-91.3692,30.7261]},{"Plant":"R D Morrow","State":"MS","Coal":360,"coordinates":[-89.394,31.2186]},{"Plant":"Nearman Creek","State":"KS","Coal":229,"coordinates":[-94.6975,39.1681]},{"Plant":"Iatan","State":"MO","Coal":1585.8,"coordinates":[-94.98,39.4472]},{"Plant":"Jeffrey Energy Center","State":"KS","Coal":2165,"coordinates":[-96.1172,39.2865]},{"Plant":"Trimble County","State":"KY","Coal":1242.9,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Coal":1020,"coordinates":[-88.5553,30.5322]},{"Plant":"Colstrip","State":"MT","Coal":2094,"coordinates":[-106.614,45.8831]},{"Plant":"Gerald Gentleman","State":"NE","Coal":1365,"coordinates":[-101.1408,41.0808]},{"Plant":"Somerset Operating Co LLC","State":"NY","Coal":684.8,"coordinates":[-78.6047,43.3589]},{"Plant":"R M Schahfer","State":"IN","Coal":1625,"coordinates":[-87.0261,41.2164]},{"Plant":"Sherburne County","State":"MN","Coal":2222,"coordinates":[-93.8931,45.3808]},{"Plant":"FirstEnergy Bruce Mansfield","State":"PA","Coal":2510,"coordinates":[-80.4159,40.6348]},{"Plant":"Sooner","State":"OK","Coal":1038,"coordinates":[-97.0528,36.4531]},{"Plant":"Nebraska City","State":"NE","Coal":1336.1,"coordinates":[-95.7764,40.6214]},{"Plant":"Big Stone","State":"SD","Coal":475,"coordinates":[-96.5101,45.3037]},{"Plant":"Wyodak","State":"WY","Coal":335,"coordinates":[-105.3815,44.2901]},{"Plant":"Boardman","State":"OR","Coal":585,"coordinates":[-119.8088,45.6932]},{"Plant":"Gibson","State":"IN","Coal":3132,"coordinates":[-87.7658,38.3722]},{"Plant":"McIntosh","State":"GA","Coal":156.5,"coordinates":[-81.1683,32.3563]},{"Plant":"Gibbons Creek","State":"TX","Coal":470,"coordinates":[-96.0818,30.6199]},{"Plant":"A B Brown","State":"IN","Coal":490,"coordinates":[-87.715,37.9053]},{"Plant":"Flint Creek","State":"AR","Coal":528,"coordinates":[-94.5241,36.2561]},{"Plant":"Welsh","State":"TX","Coal":1584,"coordinates":[-94.84,33.0552]},{"Plant":"Martin Lake","State":"TX","Coal":2410,"coordinates":[-94.5706,32.2606]},{"Plant":"Monticello","State":"TX","Coal":1890,"coordinates":[-95.0417,33.0917]},{"Plant":"Rush Island","State":"MO","Coal":1222,"coordinates":[-90.2632,38.1312]},{"Plant":"Hunter","State":"UT","Coal":1336,"coordinates":[-111.0289,39.1747]},{"Plant":"Rockport","State":"IN","Coal":2600,"coordinates":[-87.0372,37.9256]},{"Plant":"Pleasant Prairie","State":"WI","Coal":1205.1,"coordinates":[-87.9033,42.5381]},{"Plant":"Coronado","State":"AZ","Coal":765,"coordinates":[-109.2708,34.5789]},{"Plant":"Coleto Creek","State":"TX","Coal":592.4,"coordinates":[-97.2142,28.7128]},{"Plant":"Fayette Power Project","State":"TX","Coal":1641,"coordinates":[-96.7506,29.9172]},{"Plant":"Oak Grove","State":"TX","Coal":1665,"coordinates":[-96.4866,31.1803]},{"Plant":"J T Deely","State":"TX","Coal":871,"coordinates":[-98.3228,29.3081]},{"Plant":"San Miguel","State":"TX","Coal":391,"coordinates":[-98.4775,28.7044]},{"Plant":"Brame Energy Center","State":"LA","Coal":493,"coordinates":[-92.7167,31.395]},{"Plant":"Harrington","State":"TX","Coal":1018,"coordinates":[-101.7472,35.2982]},{"Plant":"Tolk","State":"TX","Coal":1067,"coordinates":[-102.57,34.1865]},{"Plant":"John Twitty Energy Center","State":"MO","Coal":466,"coordinates":[-93.388,37.1517]},{"Plant":"Laramie River Station","State":"WY","Coal":1710,"coordinates":[-104.8825,42.1089]},{"Plant":"Merom","State":"IN","Coal":995,"coordinates":[-87.5108,39.0694]},{"Plant":"Pawnee","State":"CO","Coal":505,"coordinates":[-103.6803,40.2217]},{"Plant":"Winyah","State":"SC","Coal":1130,"coordinates":[-79.3581,33.3317]},{"Plant":"Mayo","State":"NC","Coal":727,"coordinates":[-78.8917,36.5278]},{"Plant":"Ottumwa","State":"IA","Coal":697.3,"coordinates":[-92.5558,41.0961]},{"Plant":"Scherer","State":"GA","Coal":3406.7,"coordinates":[-83.8075,33.0606]},{"Plant":"Mountaineer","State":"WV","Coal":1300,"coordinates":[-81.9344,38.9794]},{"Plant":"Crystal River","State":"FL","Coal":2295,"coordinates":[-82.6977,28.9656]},{"Plant":"Crist","State":"FL","Coal":906,"coordinates":[-87.2244,30.5661]},{"Plant":"Lansing Smith","State":"FL","Coal":357,"coordinates":[-85.7003,30.2686]},{"Plant":"Big Bend","State":"FL","Coal":1552,"coordinates":[-82.4036,27.7944]},{"Plant":"Antelope Valley","State":"ND","Coal":900,"coordinates":[-101.3194,47.2819]},{"Plant":"Intermountain Power Project","State":"UT","Coal":1800,"coordinates":[-112.5802,39.5097]},{"Plant":"Deerhaven Generating Station","State":"FL","Coal":227,"coordinates":[-82.3878,29.7592]},{"Plant":"R D Green","State":"KY","Coal":454,"coordinates":[-87.5,37.6461]},{"Plant":"Independence","State":"AR","Coal":1678,"coordinates":[-91.4088,35.6784]},{"Plant":"Sandow No 4","State":"TX","Coal":600,"coordinates":[-97.064,30.5659]},{"Plant":"Louisa","State":"IA","Coal":750.2,"coordinates":[-91.0931,41.3181]},{"Plant":"Warrick","State":"IN","Coal":730,"coordinates":[-87.3328,37.915]},{"Plant":"C D McIntosh Jr","State":"FL","Coal":342,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Coal":278,"coordinates":[-105.0212,40.8609]},{"Plant":"Sikeston Power Station","State":"MO","Coal":233,"coordinates":[-89.6209,36.8791]},{"Plant":"Hugo","State":"OK","Coal":440,"coordinates":[-95.3206,34.0158]},{"Plant":"D B Wilson","State":"KY","Coal":417,"coordinates":[-87.0806,37.4497]},{"Plant":"Gadsden","State":"AL","Coal":130,"coordinates":[-85.9708,34.0128]},{"Plant":"Bowen","State":"GA","Coal":3202,"coordinates":[-84.9222,34.1256]},{"Plant":"Major Oak Power","State":"TX","Coal":305,"coordinates":[-96.695,31.0919]},{"Plant":"Hammond","State":"GA","Coal":840,"coordinates":[-85.3456,34.2528]},{"Plant":"Harllee Branch","State":"GA","Coal":1607,"coordinates":[-83.2983,33.195]},{"Plant":"J K Spruce","State":"TX","Coal":1330,"coordinates":[-98.3203,29.3097]},{"Plant":"Jack McDonough","State":"GA","Coal":251,"coordinates":[-84.4758,33.8239]},{"Plant":"Cope","State":"SC","Coal":420,"coordinates":[-81.03,33.3644]},{"Plant":"Clover","State":"VA","Coal":865,"coordinates":[-78.704,36.869]},{"Plant":"Polk","State":"FL","Coal":220,"coordinates":[-81.9897,27.7286]},{"Plant":"Mitchell","State":"GA","Coal":155,"coordinates":[-84.1347,31.4447]},{"Plant":"Yates","State":"GA","Coal":1286,"coordinates":[-84.8986,33.4622]},{"Plant":"Kraft","State":"GA","Coal":201,"coordinates":[-81.1458,32.1486]},{"Plant":"George Neal South","State":"IA","Coal":645.1,"coordinates":[-96.3617,42.3006]},{"Plant":"Bonanza","State":"UT","Coal":458,"coordinates":[-109.2844,40.0864]},{"Plant":"Pirkey","State":"TX","Coal":721,"coordinates":[-94.4852,32.4607]},{"Plant":"Gorgas","State":"AL","Coal":1241,"coordinates":[-87.1965,33.6443]},{"Plant":"Columbia","State":"WI","Coal":1099,"coordinates":[-89.4203,43.4864]},{"Plant":"Belews Creek","State":"NC","Coal":2220,"coordinates":[-80.0603,36.2811]},{"Plant":"Jim Bridger","State":"WY","Coal":2118,"coordinates":[-108.7875,41.7378]},{"Plant":"Huntington","State":"UT","Coal":911,"coordinates":[-111.0781,39.3792]},{"Plant":"General James M Gavin","State":"OH","Coal":2600,"coordinates":[-82.1158,38.9347]},{"Plant":"Ray D Nixon","State":"CO","Coal":208,"coordinates":[-104.7058,38.6335]},{"Plant":"Coyote","State":"ND","Coal":427,"coordinates":[-101.8157,47.2214]},{"Plant":"Springerville","State":"AZ","Coal":1609,"coordinates":[-109.1639,34.3186]},{"Plant":"North Valmy","State":"NV","Coal":522,"coordinates":[-117.1516,40.8813]},{"Plant":"Cheswick Power Plant","State":"PA","Coal":580,"coordinates":[-79.7906,40.5383]},{"Plant":"E D Edwards","State":"IL","Coal":650,"coordinates":[-89.6631,40.5958]},{"Plant":"Coffeen","State":"IL","Coal":895,"coordinates":[-89.4031,39.0586]},{"Plant":"Crawford","State":"IL","Coal":532,"coordinates":[-87.7229,41.8285]},{"Plant":"Escalante","State":"NM","Coal":247,"coordinates":[-108.082,35.4159]},{"Plant":"Joliet 9","State":"IL","Coal":314,"coordinates":[-88.1153,41.4931]},{"Plant":"Kincaid Generation LLC","State":"IL","Coal":1158,"coordinates":[-89.4964,39.5906]},{"Plant":"Powerton","State":"IL","Coal":1538,"coordinates":[-89.6786,40.5408]},{"Plant":"Waukegan","State":"IL","Coal":689,"coordinates":[-87.8133,42.3833]},{"Plant":"Will County","State":"IL","Coal":761,"coordinates":[-88.0629,41.6334]},{"Plant":"Fisk Street","State":"IL","Coal":326,"coordinates":[-87.6533,41.8508]},{"Plant":"Joppa Steam","State":"IL","Coal":1002,"coordinates":[-88.8589,37.2094]},{"Plant":"Baldwin Energy Complex","State":"IL","Coal":1785,"coordinates":[-89.8544,38.205]},{"Plant":"Havana","State":"IL","Coal":428,"coordinates":[-90.08,40.2797]},{"Plant":"Hennepin Power Station","State":"IL","Coal":285,"coordinates":[-89.315,41.3028]},{"Plant":"Wood River","State":"IL","Coal":456,"coordinates":[-90.1347,38.8639]},{"Plant":"Dallman","State":"IL","Coal":556,"coordinates":[-89.6024,39.7548]},{"Plant":"Marion","State":"IL","Coal":290,"coordinates":[-88.9531,37.6197]},{"Plant":"State Line Energy","State":"IN","Coal":515,"coordinates":[-87.5217,41.7072]},{"Plant":"Clifty Creek","State":"IN","Coal":1203,"coordinates":[-85.4206,38.7378]},{"Plant":"Tanners Creek","State":"IN","Coal":990,"coordinates":[-84.8594,39.0814]},{"Plant":"Harding Street","State":"IN","Coal":647,"coordinates":[-86.1969,39.7113]},{"Plant":"Eagle Valley","State":"IN","Coal":257,"coordinates":[-86.4183,39.4852]},{"Plant":"AES Petersburg","State":"IN","Coal":1701.5,"coordinates":[-87.2525,38.5281]},{"Plant":"Bailly","State":"IN","Coal":480,"coordinates":[-87.1225,41.645]},{"Plant":"Michigan City","State":"IN","Coal":469,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Coal":497,"coordinates":[-87.7811,32.6017]},{"Plant":"ACE Cogeneration Facility","State":"CA","Coal":101.2,"coordinates":[-117.3836,35.7658]},{"Plant":"Cayuga","State":"IN","Coal":995,"coordinates":[-87.4244,39.9242]},{"Plant":"RED-Rochester, LLC","State":"NY","Coal":129.9,"coordinates":[-77.6319,43.1989]},{"Plant":"Logan Generating Company LP","State":"NJ","Coal":219,"coordinates":[-75.4067,39.7928]},{"Plant":"Portsmouth Genco LLC","State":"VA","Coal":115,"coordinates":[-76.3529,36.8702]},{"Plant":"Taconite Harbor Energy Center","State":"MN","Coal":238.5,"coordinates":[-90.9114,47.5314]},{"Plant":"R Gallagher","State":"IN","Coal":280,"coordinates":[-85.8381,38.2636]},{"Plant":"Wabash River","State":"IN","Coal":668,"coordinates":[-87.4247,39.53]},{"Plant":"F B Culley","State":"IN","Coal":360,"coordinates":[-87.3275,37.9111]},{"Plant":"Colver Power Project","State":"PA","Coal":110,"coordinates":[-78.8,40.55]},{"Plant":"Florida Power Development","State":"FL","Coal":135,"coordinates":[-82.4311,28.5819]},{"Plant":"Green Bay West Mill","State":"WI","Coal":112.9,"coordinates":[-88.0303,44.4936]},{"Plant":"Edgecombe Genco LLC","State":"NC","Coal":115.6,"coordinates":[-77.7533,36.0373]},{"Plant":"Frank E Ratts","State":"IN","Coal":237,"coordinates":[-87.2662,38.5201]},{"Plant":"Lansing","State":"IA","Coal":276.9,"coordinates":[-91.1675,43.3359]},{"Plant":"Milton L Kapp","State":"IA","Coal":204.4,"coordinates":[-90.2336,41.8081]},{"Plant":"Chambers Cogeneration LP","State":"NJ","Coal":262,"coordinates":[-75.4858,39.6935]},{"Plant":"AES Shady Point LLC","State":"OK","Coal":320,"coordinates":[-94.6458,35.1931]},{"Plant":"Cedar Bay Generating Company LP","State":"FL","Coal":250,"coordinates":[-81.6064,30.4225]},{"Plant":"AES Hawaii","State":"HI","Coal":180,"coordinates":[-158.1065,21.3034]},{"Plant":"AES Beaver Valley Partners Beaver Valley","State":"PA","Coal":146,"coordinates":[-80.3539,40.6572]},{"Plant":"AES Warrior Run Cogeneration Facility","State":"MD","Coal":180,"coordinates":[-78.7453,39.5952]},{"Plant":"Prairie Creek","State":"IA","Coal":156.7,"coordinates":[-91.6392,41.944]},{"Plant":"Holcomb","State":"KS","Coal":358.8,"coordinates":[-100.9725,37.9308]},{"Plant":"Riverside","State":"IA","Coal":137.3,"coordinates":[-90.4481,41.54]},{"Plant":"Walter Scott Jr Energy Center","State":"IA","Coal":1635.5,"coordinates":[-95.8408,41.18]},{"Plant":"Silver Bay Power","State":"MN","Coal":105,"coordinates":[-91.2605,47.2866]},{"Plant":"Archer Daniels Midland Clinton","State":"IA","Coal":180,"coordinates":[-90.2097,41.8206]},{"Plant":"Archer Daniels Midland Cedar Rapids","State":"IA","Coal":260,"coordinates":[-91.6875,41.9221]},{"Plant":"Archer Daniels Midland Decatur","State":"IL","Coal":335,"coordinates":[-88.8908,39.8701]},{"Plant":"George Neal North","State":"IA","Coal":909.9,"coordinates":[-96.3617,42.2998]},{"Plant":"Burlington","State":"IA","Coal":207.7,"coordinates":[-91.1167,40.7412]},{"Plant":"Cholla","State":"AZ","Coal":1027,"coordinates":[-110.3033,34.9394]},{"Plant":"Muscatine Plant #1","State":"IA","Coal":239.7,"coordinates":[-91.0569,41.3917]},{"Plant":"La Cygne","State":"KS","Coal":1421.2,"coordinates":[-94.6456,38.3481]},{"Plant":"Lawrence Energy Center","State":"KS","Coal":531,"coordinates":[-95.2692,39.0072]},{"Plant":"Tecumseh Energy Center","State":"KS","Coal":205,"coordinates":[-95.5689,39.0539]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Coal":156,"coordinates":[-110.9047,32.16]},{"Plant":"Oklaunion","State":"TX","Coal":670,"coordinates":[-99.1753,34.0825]},{"Plant":"Quindaro","State":"KS","Coal":207,"coordinates":[-94.6381,39.1492]},{"Plant":"Cross","State":"SC","Coal":2330,"coordinates":[-80.1119,33.3692]},{"Plant":"Big Sandy","State":"KY","Coal":1060,"coordinates":[-82.6176,38.1707]},{"Plant":"E W Brown","State":"KY","Coal":684,"coordinates":[-84.7126,37.7883]},{"Plant":"Ghent","State":"KY","Coal":1932,"coordinates":[-85.035,38.7497]},{"Plant":"Green River","State":"KY","Coal":163,"coordinates":[-87.1214,37.3636]},{"Plant":"Seminole","State":"FL","Coal":1363,"coordinates":[-81.6328,29.7331]},{"Plant":"Cane Run","State":"KY","Coal":563,"coordinates":[-85.8892,38.1831]},{"Plant":"Mill Creek","State":"KY","Coal":1472,"coordinates":[-85.9103,38.0525]},{"Plant":"Elmer Smith","State":"KY","Coal":401.3,"coordinates":[-87.0608,37.7942]},{"Plant":"Paradise","State":"KY","Coal":2201,"coordinates":[-86.9783,37.2608]},{"Plant":"Shawnee","State":"KY","Coal":1330,"coordinates":[-88.775,37.1517]},{"Plant":"Kenneth C Coleman","State":"KY","Coal":443,"coordinates":[-86.7911,37.9631]},{"Plant":"HMP&L Station Two Henderson","State":"KY","Coal":312,"coordinates":[-87.5028,37.6469]},{"Plant":"Cooper","State":"KY","Coal":341,"coordinates":[-84.5919,36.9981]},{"Plant":"Dale","State":"KY","Coal":195,"coordinates":[-84.2619,37.8806]},{"Plant":"R S Nelson","State":"LA","Coal":540,"coordinates":[-93.2911,30.2844]},{"Plant":"C P Crane","State":"MD","Coal":385,"coordinates":[-76.3651,39.3236]},{"Plant":"Herbert A Wagner","State":"MD","Coal":440,"coordinates":[-76.5268,39.1781]},{"Plant":"Chalk Point LLC","State":"MD","Coal":667,"coordinates":[-76.6861,38.5444]},{"Plant":"Dickerson","State":"MD","Coal":537,"coordinates":[-77.4644,39.2097]},{"Plant":"Morgantown Generating Plant","State":"MD","Coal":1205,"coordinates":[-76.9767,38.3592]},{"Plant":"Apache Station","State":"AZ","Coal":350,"coordinates":[-109.8931,32.0603]},{"Plant":"Mount Tom","State":"MA","Coal":143.6,"coordinates":[-72.6055,42.2806]},{"Plant":"Brayton Point","State":"MA","Coal":1083.5,"coordinates":[-71.1931,41.7103]},{"Plant":"Salem Harbor","State":"MA","Coal":307.5,"coordinates":[-70.8772,42.5256]},{"Plant":"GRDA","State":"OK","Coal":1010,"coordinates":[-95.2894,36.1903]},{"Plant":"B C Cobb","State":"MI","Coal":312,"coordinates":[-86.2423,43.2588]},{"Plant":"Dan E Karn","State":"MI","Coal":515,"coordinates":[-83.8401,43.645]},{"Plant":"J H Campbell","State":"MI","Coal":1440,"coordinates":[-86.2007,42.9103]},{"Plant":"J C Weadock","State":"MI","Coal":310,"coordinates":[-83.8447,43.6399]},{"Plant":"J R Whiting","State":"MI","Coal":325,"coordinates":[-83.4495,41.7921]},{"Plant":"Monroe","State":"MI","Coal":2930,"coordinates":[-83.3464,41.8906]},{"Plant":"River Rouge","State":"MI","Coal":527,"coordinates":[-83.1119,42.2739]},{"Plant":"St Clair","State":"MI","Coal":1374,"coordinates":[-82.4719,42.7642]},{"Plant":"Trenton Channel","State":"MI","Coal":713,"coordinates":[-83.1808,42.1217]},{"Plant":"Presque Isle","State":"MI","Coal":344,"coordinates":[-87.395,46.5789]},{"Plant":"Eckert Station","State":"MI","Coal":298.9,"coordinates":[-84.5581,42.7184]},{"Plant":"Erickson Station","State":"MI","Coal":154.6,"coordinates":[-84.6572,42.6922]},{"Plant":"Clay Boswell","State":"MN","Coal":964.7,"coordinates":[-93.6528,47.2611]},{"Plant":"Black Dog","State":"MN","Coal":232,"coordinates":[-93.2501,44.8108]},{"Plant":"Allen S King","State":"MN","Coal":511,"coordinates":[-92.7786,45.03]},{"Plant":"Hoot Lake","State":"MN","Coal":138,"coordinates":[-96.0433,46.2906]},{"Plant":"Jack Watson","State":"MS","Coal":706,"coordinates":[-89.0286,30.4392]},{"Plant":"St Johns River Power Park","State":"FL","Coal":1252,"coordinates":[-81.5508,30.4308]},{"Plant":"Asbury","State":"MO","Coal":203.5,"coordinates":[-94.5893,37.3613]},{"Plant":"Hawthorn","State":"MO","Coal":564,"coordinates":[-94.4778,39.1306]},{"Plant":"Montrose","State":"MO","Coal":510,"coordinates":[-93.9348,38.3114]},{"Plant":"Sibley","State":"MO","Coal":457.3,"coordinates":[-94.1844,39.1783]},{"Plant":"Labadie","State":"MO","Coal":2412,"coordinates":[-90.8377,38.5622]},{"Plant":"Meramec","State":"MO","Coal":836,"coordinates":[-90.3358,38.4017]},{"Plant":"Sioux","State":"MO","Coal":966,"coordinates":[-90.2902,38.9155]},{"Plant":"James River Power Station","State":"MO","Coal":236,"coordinates":[-93.2619,37.1086]},{"Plant":"New Madrid","State":"MO","Coal":1199,"coordinates":[-89.5617,36.5147]},{"Plant":"Thomas Hill","State":"MO","Coal":1145,"coordinates":[-92.6381,39.5522]},{"Plant":"J E Corette Plant","State":"MT","Coal":153,"coordinates":[-108.481,45.7756]},{"Plant":"Lon Wright","State":"NE","Coal":120,"coordinates":[-96.4623,41.4281]},{"Plant":"Sheldon","State":"NE","Coal":215,"coordinates":[-96.7847,40.5589]},{"Plant":"North Omaha","State":"NE","Coal":626.7,"coordinates":[-95.9447,41.3291]},{"Plant":"Reid Gardner","State":"NV","Coal":553,"coordinates":[-114.6333,36.6573]},{"Plant":"Merrimack","State":"NH","Coal":438.5,"coordinates":[-71.4692,43.1411]},{"Plant":"B L England","State":"NJ","Coal":268,"coordinates":[-74.6364,39.2908]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Coal":617.6,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Mercer Generating Station","State":"NJ","Coal":640,"coordinates":[-74.7339,40.1792]},{"Plant":"Four Corners","State":"NM","Coal":2100,"coordinates":[-108.4814,36.69]},{"Plant":"San Juan","State":"NM","Coal":1684,"coordinates":[-108.4386,36.8006]},{"Plant":"Danskammer Generating Station","State":"NY","Coal":369.5,"coordinates":[-73.975,41.5712]},{"Plant":"GMMGreenidge LLC","State":"NY","Coal":107.5,"coordinates":[-76.9483,42.6789]},{"Plant":"Cayuga Operating Company","State":"NY","Coal":304.6,"coordinates":[-76.6336,42.6028]},{"Plant":"C R Huntley Generating Station","State":"NY","Coal":380,"coordinates":[-78.93,42.97]},{"Plant":"Dunkirk Generating Plant","State":"NY","Coal":520,"coordinates":[-79.3466,42.4915]},{"Plant":"E C Gaston","State":"AL","Coal":1862,"coordinates":[-86.4581,33.2442]},{"Plant":"Asheville","State":"NC","Coal":376,"coordinates":[-82.5417,35.4731]},{"Plant":"Roxboro","State":"NC","Coal":2432,"coordinates":[-79.0731,36.4833]},{"Plant":"L V Sutton Steam","State":"NC","Coal":553,"coordinates":[-77.9853,34.2831]},{"Plant":"G G Allen","State":"NC","Coal":1127,"coordinates":[-81.0122,35.1897]},{"Plant":"Buck","State":"NC","Coal":256,"coordinates":[-80.3767,35.7133]},{"Plant":"Cliffside","State":"NC","Coal":1377,"coordinates":[-81.7594,35.22]},{"Plant":"Marshall","State":"NC","Coal":2078,"coordinates":[-80.9658,35.5975]},{"Plant":"Riverbend","State":"NC","Coal":454,"coordinates":[-80.9742,35.36]},{"Plant":"R M Heskett","State":"ND","Coal":104.3,"coordinates":[-100.8836,46.8669]},{"Plant":"Leland Olds","State":"ND","Coal":667,"coordinates":[-101.3212,47.2808]},{"Plant":"Milton R Young","State":"ND","Coal":697,"coordinates":[-101.2131,47.0659]},{"Plant":"Stanton","State":"ND","Coal":188.5,"coordinates":[-101.3319,47.2866]},{"Plant":"Cardinal","State":"OH","Coal":1800,"coordinates":[-80.6486,40.2522]},{"Plant":"Walter C Beckjord","State":"OH","Coal":1024,"coordinates":[-84.2981,38.9917]},{"Plant":"Miami Fort","State":"OH","Coal":1183,"coordinates":[-84.8036,39.1128]},{"Plant":"FirstEnergy Ashtabula","State":"OH","Coal":244,"coordinates":[-80.7697,41.9086]},{"Plant":"Avon Lake","State":"OH","Coal":710,"coordinates":[-82.0546,41.5045]},{"Plant":"FirstEnergy Eastlake","State":"OH","Coal":396,"coordinates":[-81.4425,41.6711]},{"Plant":"FirstEnergy Lake Shore","State":"OH","Coal":245,"coordinates":[-81.6419,41.5356]},{"Plant":"Conesville","State":"OH","Coal":1530,"coordinates":[-81.8811,40.1842]},{"Plant":"O H Hutchings","State":"OH","Coal":365,"coordinates":[-84.2921,39.6088]},{"Plant":"J M Stuart","State":"OH","Coal":2308,"coordinates":[-83.6939,38.6361]},{"Plant":"FirstEnergy W H Sammis","State":"OH","Coal":2220,"coordinates":[-80.6319,40.5317]},{"Plant":"Muskingum River","State":"OH","Coal":1375,"coordinates":[-81.6797,39.5908]},{"Plant":"Kyger Creek","State":"OH","Coal":962.8,"coordinates":[-82.1289,38.9144]},{"Plant":"Muskogee","State":"OK","Coal":1505,"coordinates":[-95.2873,35.7614]},{"Plant":"Northeastern","State":"OK","Coal":920,"coordinates":[-95.7008,36.4317]},{"Plant":"Limestone","State":"TX","Coal":1689,"coordinates":[-96.2525,31.4219]},{"Plant":"Barry","State":"AL","Coal":1612.5,"coordinates":[-88.0103,31.0069]},{"Plant":"Elrama Power Plant","State":"PA","Coal":460,"coordinates":[-79.918,40.2518]},{"Plant":"Portland","State":"PA","Coal":335,"coordinates":[-75.0794,40.9102]},{"Plant":"Titus","State":"PA","Coal":216,"coordinates":[-75.9081,40.3056]},{"Plant":"Conemaugh","State":"PA","Coal":1700,"coordinates":[-79.0611,40.3842]},{"Plant":"Homer City Generating Station","State":"PA","Coal":1884,"coordinates":[-79.1961,40.5128]},{"Plant":"Seward","State":"PA","Coal":521,"coordinates":[-79.0337,40.4062]},{"Plant":"Shawville","State":"PA","Coal":565,"coordinates":[-78.3662,41.0675]},{"Plant":"Keystone","State":"PA","Coal":1700,"coordinates":[-79.3411,40.6604]},{"Plant":"New Castle Plant","State":"PA","Coal":305,"coordinates":[-80.369,40.9379]},{"Plant":"Brunner Island","State":"PA","Coal":1437,"coordinates":[-76.6962,40.0961]},{"Plant":"PPL Montour","State":"PA","Coal":1515,"coordinates":[-76.6672,41.0714]},{"Plant":"Sunbury Generation LP","State":"PA","Coal":382,"coordinates":[-76.825,40.8361]},{"Plant":"Hatfields Ferry Power Station","State":"PA","Coal":1590,"coordinates":[-79.9275,39.8556]},{"Plant":"FirstEnergy Mitchell Power Station","State":"PA","Coal":278,"coordinates":[-79.9683,40.2211]},{"Plant":"W S Lee","State":"SC","Coal":370,"coordinates":[-82.435,34.6022]},{"Plant":"Canadys Steam","State":"SC","Coal":295,"coordinates":[-80.6228,33.0647]},{"Plant":"McMeekin","State":"SC","Coal":250,"coordinates":[-81.2172,34.0556]},{"Plant":"Wateree","State":"SC","Coal":684,"coordinates":[-80.6228,33.8264]},{"Plant":"Williams","State":"SC","Coal":605,"coordinates":[-79.9297,33.0158]},{"Plant":"Allen Steam Plant","State":"TN","Coal":741,"coordinates":[-90.1487,35.0741]},{"Plant":"Bull Run","State":"TN","Coal":870,"coordinates":[-84.1567,36.0211]},{"Plant":"Cumberland","State":"TN","Coal":2470,"coordinates":[-87.6539,36.3903]},{"Plant":"Gallatin","State":"TN","Coal":976,"coordinates":[-86.4006,36.3156]},{"Plant":"John Sevier","State":"TN","Coal":352,"coordinates":[-82.9639,36.3767]},{"Plant":"Johnsonville","State":"TN","Coal":1206,"coordinates":[-87.9861,36.0278]},{"Plant":"Kingston","State":"TN","Coal":1398,"coordinates":[-84.5194,35.8992]},{"Plant":"W A Parish","State":"TX","Coal":2499,"coordinates":[-95.6311,29.4828]},{"Plant":"Big Brown","State":"TX","Coal":1195,"coordinates":[-96.0544,31.8206]},{"Plant":"Carbon","State":"UT","Coal":172,"coordinates":[-110.8644,39.7272]},{"Plant":"Clinch River","State":"VA","Coal":690,"coordinates":[-82.1997,36.9333]},{"Plant":"Glen Lyn","State":"VA","Coal":325,"coordinates":[-80.8633,37.3706]},{"Plant":"Bremo Bluff","State":"VA","Coal":227,"coordinates":[-78.2878,37.7089]},{"Plant":"Chesterfield","State":"VA","Coal":1253,"coordinates":[-77.3833,37.3822]},{"Plant":"Chesapeake","State":"VA","Coal":595,"coordinates":[-76.3019,36.7711]},{"Plant":"Yorktown","State":"VA","Coal":323,"coordinates":[-76.4611,37.2144]},{"Plant":"Joliet 29","State":"IL","Coal":1036,"coordinates":[-88.1238,41.4946]},{"Plant":"Transalta Centralia Generation","State":"WA","Coal":1340,"coordinates":[-122.8598,46.7559]},{"Plant":"John E Amos","State":"WV","Coal":2900,"coordinates":[-81.8233,38.4731]},{"Plant":"Kanawha River","State":"WV","Coal":400,"coordinates":[-81.4211,38.2056]},{"Plant":"Philip Sporn","State":"WV","Coal":580,"coordinates":[-81.9231,38.9669]},{"Plant":"FirstEnergy Fort Martin Power Station","State":"WV","Coal":1107,"coordinates":[-79.9275,39.7108]},{"Plant":"FirstEnergy Harrison Power Station","State":"WV","Coal":1954,"coordinates":[-80.3325,39.3842]},{"Plant":"Kammer","State":"WV","Coal":600,"coordinates":[-80.8186,39.8461]},{"Plant":"Mitchell","State":"WV","Coal":1560,"coordinates":[-80.8153,39.8297]},{"Plant":"Mt Storm","State":"WV","Coal":1599,"coordinates":[-79.2636,39.2008]},{"Plant":"South Oak Creek","State":"WI","Coal":976,"coordinates":[-87.8294,42.8457]},{"Plant":"Valley","State":"WI","Coal":256,"coordinates":[-87.9233,43.0303]},{"Plant":"Edgewater","State":"WI","Coal":797,"coordinates":[-87.7059,43.7151]},{"Plant":"Nelson Dewey Coal Refining Facility","State":"WI","Coal":212.4,"coordinates":[-91.0085,42.7225]},{"Plant":"Pulliam","State":"WI","Coal":330.6,"coordinates":[-88.0086,44.54]},{"Plant":"Weston","State":"WI","Coal":1004.3,"coordinates":[-89.6553,44.8606]},{"Plant":"Alma","State":"WI","Coal":132,"coordinates":[-91.9111,44.3083]},{"Plant":"Genoa","State":"WI","Coal":288.5,"coordinates":[-91.2325,43.5589]},{"Plant":"Dave Johnston","State":"WY","Coal":760,"coordinates":[-105.7769,42.8378]},{"Plant":"Naughton","State":"WY","Coal":687,"coordinates":[-110.5983,41.7581]},{"Plant":"John P Madgett","State":"WI","Coal":386.3,"coordinates":[-91.9126,44.3036]},{"Plant":"Arapahoe","State":"CO","Coal":144,"coordinates":[-105.0028,39.67]},{"Plant":"Cherokee","State":"CO","Coal":504,"coordinates":[-104.9645,39.8073]},{"Plant":"Colbert","State":"AL","Coal":1184,"coordinates":[-87.8486,34.7439]},{"Plant":"Comanche","State":"CO","Coal":1426,"coordinates":[-104.5747,38.2081]},{"Plant":"Valmont","State":"CO","Coal":184,"coordinates":[-105.202,40.0195]},{"Plant":"Martin Drake","State":"CO","Coal":254,"coordinates":[-104.8333,38.8244]},{"Plant":"Navajo","State":"AZ","Coal":2250,"coordinates":[-111.3886,36.9047]},{"Plant":"Widows Creek","State":"AL","Coal":1604,"coordinates":[-85.7553,34.883]},{"Plant":"G F Weaton Power Station","State":"PA","Coal":112,"coordinates":[-80.3462,40.6673]},{"Plant":"Tennessee Eastman Operations","State":"TN","Coal":194.3,"coordinates":[-82.5431,36.5219]},{"Plant":"Axiall Natrium Plant","State":"WV","Coal":123,"coordinates":[-80.8547,39.7475]},{"Plant":"Northampton Generating Company LP","State":"PA","Coal":112,"coordinates":[-75.4792,40.6917]},{"Plant":"Indiantown Cogeneration LP","State":"FL","Coal":330,"coordinates":[-80.5125,27.0389]},{"Plant":"Dolet Hills","State":"LA","Coal":638,"coordinates":[-93.5692,32.0306]},{"Plant":"Mecklenburg Power Station","State":"VA","Coal":138,"coordinates":[-78.53,36.6]},{"Plant":"Sandow No 5","State":"TX","Coal":570,"coordinates":[-97.0614,30.5681]},{"Plant":"Hayden","State":"CO","Coal":446,"coordinates":[-107.185,40.4856]},{"Plant":"Roanoke Valley Energy Facililty I","State":"NC","Coal":165,"coordinates":[-77.6167,36.4364]},{"Plant":"Spruance Genco LLC","State":"VA","Coal":190,"coordinates":[-77.4308,37.4556]},{"Plant":"Birchwood Power","State":"VA","Coal":243.5,"coordinates":[-77.3147,38.2667]},{"Plant":"Red Hills Generating Facility","State":"MS","Coal":440,"coordinates":[-89.2183,33.3761]},{"Plant":"Hardin Generator Project","State":"MT","Coal":107,"coordinates":[-107.6,45.7578]},{"Plant":"Prairie State Generating Station","State":"IL","Coal":1629,"coordinates":[-89.6669,38.2792]},{"Plant":"Charles R Lowman","State":"AL","Coal":550,"coordinates":[-87.9107,31.488]},{"Plant":"Elm Road Generating Station","State":"WI","Coal":1268,"coordinates":[-87.8336,42.8492]},{"Plant":"Kennecott Power Plant","State":"UT","Coal":175,"coordinates":[-112.1225,40.7119]},{"Plant":"TS Power Plant","State":"NV","Coal":218.4,"coordinates":[-116.5297,40.7461]},{"Plant":"Stanton Energy Center","State":"FL","Coal":886,"coordinates":[-81.1678,28.4822]},{"Plant":"Plum Point Energy Station","State":"AR","Coal":670,"coordinates":[-89.9489,35.6644]},{"Plant":"John W Turk Jr Power Plant","State":"AR","Coal":609,"coordinates":[-93.8119,33.6497]},{"Plant":"Dry Fork Station","State":"WY","Coal":380,"coordinates":[-105.4608,44.3889]},{"Plant":"Longview Power LLC","State":"WV","Coal":700,"coordinates":[-79.959,39.7079]},{"Plant":"Bridgeport Station","State":"CT","Coal":389.1,"coordinates":[-73.1844,41.1706]},{"Plant":"Virginia City Hybrid Energy Center","State":"VA","Coal":600,"coordinates":[-82.3381,36.9164]},{"Plant":"Indian River Generating Station","State":"DE","Coal":726,"coordinates":[-75.2341,38.5857]},{"Plant":"Whelan Energy Center","State":"NE","Coal":309,"coordinates":[-98.3124,40.5809]},{"Plant":"James H Miller Jr","State":"AL","Coal":2675.2,"coordinates":[-87.0597,33.6319]},{"Plant":"FirstEnergy Pleasants Power Station","State":"WV","Coal":1288,"coordinates":[-81.2944,39.3667]},{"Plant":"White Bluff","State":"AR","Coal":1659,"coordinates":[-92.1406,34.4228]},{"Plant":"Duck Creek","State":"IL","Coal":410,"coordinates":[-89.9841,40.4663]},{"Plant":"Newton","State":"IL","Coal":1197,"coordinates":[-88.2781,38.9361]},{"Plant":"East Bend","State":"KY","Coal":600,"coordinates":[-84.8514,38.9036]},{"Plant":"W H Zimmer","State":"OH","Coal":1300,"coordinates":[-84.2289,38.8675]},{"Plant":"Brandon Shores","State":"MD","Coal":1273,"coordinates":[-76.5389,39.18]},{"Plant":"Craig","State":"CO","Coal":1304,"coordinates":[-107.5912,40.4627]},{"Plant":"Coal Creek","State":"ND","Coal":1138,"coordinates":[-101.1571,47.3777]},{"Plant":"Killen Station","State":"OH","Coal":600,"coordinates":[-83.4803,38.6903]},{"Plant":"Belle River","State":"MI","Coal":1284,"coordinates":[-82.495,42.7756]},{"Plant":"H L Spurlock","State":"KY","Coal":1346,"coordinates":[-83.8181,38.7]},{"Plant":"Wansley","State":"GA","Coal":1744,"coordinates":[-85.0323,33.4134]},{"Plant":"Big Cajun 2","State":"LA","Coal":1743,"coordinates":[-91.3692,30.7261]},{"Plant":"R D Morrow","State":"MS","Coal":360,"coordinates":[-89.394,31.2186]},{"Plant":"Nearman Creek","State":"KS","Coal":229,"coordinates":[-94.6975,39.1681]},{"Plant":"Iatan","State":"MO","Coal":1585.8,"coordinates":[-94.98,39.4472]},{"Plant":"Jeffrey Energy Center","State":"KS","Coal":2179,"coordinates":[-96.1172,39.2865]},{"Plant":"Trimble County","State":"KY","Coal":1243,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Coal":1020,"coordinates":[-88.5553,30.5322]},{"Plant":"Colstrip","State":"MT","Coal":2094,"coordinates":[-106.614,45.8831]},{"Plant":"Gerald Gentleman","State":"NE","Coal":1365,"coordinates":[-101.1408,41.0808]},{"Plant":"Somerset Operating Co LLC","State":"NY","Coal":679.4,"coordinates":[-78.6047,43.3589]},{"Plant":"R M Schahfer","State":"IN","Coal":1625,"coordinates":[-87.0261,41.2164]},{"Plant":"Sherburne County","State":"MN","Coal":2222,"coordinates":[-93.8931,45.3808]},{"Plant":"FirstEnergy Bruce Mansfield","State":"PA","Coal":2510,"coordinates":[-80.4159,40.6348]},{"Plant":"Sooner","State":"OK","Coal":1035.5,"coordinates":[-97.0528,36.4531]},{"Plant":"Nebraska City","State":"NE","Coal":1336.1,"coordinates":[-95.7764,40.6214]},{"Plant":"Big Stone","State":"SD","Coal":475,"coordinates":[-96.5101,45.3037]},{"Plant":"Wyodak","State":"WY","Coal":332,"coordinates":[-105.3815,44.2901]},{"Plant":"Boardman","State":"OR","Coal":585,"coordinates":[-119.8088,45.6932]},{"Plant":"Gibson","State":"IN","Coal":3132,"coordinates":[-87.7658,38.3722]},{"Plant":"McIntosh","State":"GA","Coal":156.5,"coordinates":[-81.1683,32.3563]},{"Plant":"Gibbons Creek","State":"TX","Coal":470,"coordinates":[-96.0818,30.6199]},{"Plant":"A B Brown","State":"IN","Coal":490,"coordinates":[-87.715,37.9053]},{"Plant":"Flint Creek","State":"AR","Coal":528,"coordinates":[-94.5241,36.2561]},{"Plant":"Welsh","State":"TX","Coal":1584,"coordinates":[-94.84,33.0552]},{"Plant":"Martin Lake","State":"TX","Coal":2410,"coordinates":[-94.5706,32.2606]},{"Plant":"Monticello","State":"TX","Coal":1865,"coordinates":[-95.0417,33.0917]},{"Plant":"Rush Island","State":"MO","Coal":1212,"coordinates":[-90.2632,38.1312]},{"Plant":"Hunter","State":"UT","Coal":1336,"coordinates":[-111.0289,39.1747]},{"Plant":"Rockport","State":"IN","Coal":2600,"coordinates":[-87.0372,37.9256]},{"Plant":"Pleasant Prairie","State":"WI","Coal":1188,"coordinates":[-87.9033,42.5381]},{"Plant":"Coronado","State":"AZ","Coal":765,"coordinates":[-109.2708,34.5789]},{"Plant":"Coleto Creek","State":"TX","Coal":592.4,"coordinates":[-97.2142,28.7128]},{"Plant":"Fayette Power Project","State":"TX","Coal":1641,"coordinates":[-96.7506,29.9172]},{"Plant":"Oak Grove","State":"TX","Coal":1665,"coordinates":[-96.4866,31.1803]},{"Plant":"J T Deely","State":"TX","Coal":840,"coordinates":[-98.3228,29.3081]},{"Plant":"San Miguel","State":"TX","Coal":391,"coordinates":[-98.4775,28.7044]},{"Plant":"Brame Energy Center","State":"LA","Coal":493,"coordinates":[-92.7167,31.395]},{"Plant":"Harrington","State":"TX","Coal":1018,"coordinates":[-101.7472,35.2982]},{"Plant":"Tolk","State":"TX","Coal":1067,"coordinates":[-102.57,34.1865]},{"Plant":"John Twitty Energy Center","State":"MO","Coal":466,"coordinates":[-93.388,37.1517]},{"Plant":"Laramie River Station","State":"WY","Coal":1710,"coordinates":[-104.8825,42.1089]},{"Plant":"Merom","State":"IN","Coal":975,"coordinates":[-87.5108,39.0694]},{"Plant":"Pawnee","State":"CO","Coal":505,"coordinates":[-103.6803,40.2217]},{"Plant":"Winyah","State":"SC","Coal":1130,"coordinates":[-79.3581,33.3317]},{"Plant":"Mayo","State":"NC","Coal":727,"coordinates":[-78.8917,36.5278]},{"Plant":"Ottumwa","State":"IA","Coal":708.3,"coordinates":[-92.5558,41.0961]},{"Plant":"Scherer","State":"GA","Coal":3406.7,"coordinates":[-83.8075,33.0606]},{"Plant":"Mountaineer","State":"WV","Coal":1299,"coordinates":[-81.9344,38.9794]},{"Plant":"Crystal River","State":"FL","Coal":2291,"coordinates":[-82.6977,28.9656]},{"Plant":"Crist","State":"FL","Coal":924,"coordinates":[-87.2244,30.5661]},{"Plant":"Lansing Smith","State":"FL","Coal":357,"coordinates":[-85.7003,30.2686]},{"Plant":"Big Bend","State":"FL","Coal":1542,"coordinates":[-82.4036,27.7944]},{"Plant":"Antelope Valley","State":"ND","Coal":900,"coordinates":[-101.3194,47.2819]},{"Plant":"Intermountain Power Project","State":"UT","Coal":1800,"coordinates":[-112.5802,39.5097]},{"Plant":"Deerhaven Generating Station","State":"FL","Coal":232,"coordinates":[-82.3878,29.7592]},{"Plant":"R D Green","State":"KY","Coal":454,"coordinates":[-87.5,37.6461]},{"Plant":"Independence","State":"AR","Coal":1678,"coordinates":[-91.4088,35.6784]},{"Plant":"Sandow No 4","State":"TX","Coal":600,"coordinates":[-97.064,30.5659]},{"Plant":"Louisa","State":"IA","Coal":746.2,"coordinates":[-91.0931,41.3181]},{"Plant":"Warrick","State":"IN","Coal":736,"coordinates":[-87.3328,37.915]},{"Plant":"C D McIntosh Jr","State":"FL","Coal":342,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Coal":278,"coordinates":[-105.0212,40.8609]},{"Plant":"Sikeston Power Station","State":"MO","Coal":233,"coordinates":[-89.6209,36.8791]},{"Plant":"Hugo","State":"OK","Coal":440,"coordinates":[-95.3206,34.0158]},{"Plant":"D B Wilson","State":"KY","Coal":417,"coordinates":[-87.0806,37.4497]},{"Plant":"Gadsden","State":"AL","Coal":130,"coordinates":[-85.9708,34.0128]},{"Plant":"Bowen","State":"GA","Coal":3202,"coordinates":[-84.9222,34.1256]},{"Plant":"Major Oak Power","State":"TX","Coal":305,"coordinates":[-96.695,31.0919]},{"Plant":"Hammond","State":"GA","Coal":840,"coordinates":[-85.3456,34.2528]},{"Plant":"Harllee Branch","State":"GA","Coal":1607,"coordinates":[-83.2983,33.195]},{"Plant":"J K Spruce","State":"TX","Coal":1340,"coordinates":[-98.3203,29.3097]},{"Plant":"Cope","State":"SC","Coal":415,"coordinates":[-81.03,33.3644]},{"Plant":"Clover","State":"VA","Coal":865,"coordinates":[-78.704,36.869]},{"Plant":"Polk","State":"FL","Coal":220,"coordinates":[-81.9897,27.7286]},{"Plant":"Mitchell","State":"GA","Coal":155,"coordinates":[-84.1347,31.4447]},{"Plant":"Yates","State":"GA","Coal":1286,"coordinates":[-84.8986,33.4622]},{"Plant":"Kraft","State":"GA","Coal":201,"coordinates":[-81.1458,32.1486]},{"Plant":"George Neal South","State":"IA","Coal":644.8,"coordinates":[-96.3617,42.3006]},{"Plant":"Bonanza","State":"UT","Coal":458,"coordinates":[-109.2844,40.0864]},{"Plant":"Pirkey","State":"TX","Coal":721,"coordinates":[-94.4852,32.4607]},{"Plant":"Gorgas","State":"AL","Coal":1241,"coordinates":[-87.1965,33.6443]},{"Plant":"Columbia","State":"WI","Coal":1122,"coordinates":[-89.4203,43.4864]},{"Plant":"Belews Creek","State":"NC","Coal":2220,"coordinates":[-80.0603,36.2811]},{"Plant":"Jim Bridger","State":"WY","Coal":2111,"coordinates":[-108.7875,41.7378]},{"Plant":"Huntington","State":"UT","Coal":909,"coordinates":[-111.0781,39.3792]},{"Plant":"General James M Gavin","State":"OH","Coal":2598,"coordinates":[-82.1158,38.9347]},{"Plant":"Ray D Nixon","State":"CO","Coal":208,"coordinates":[-104.7058,38.6335]},{"Plant":"Coyote","State":"ND","Coal":427,"coordinates":[-101.8157,47.2214]},{"Plant":"Springerville","State":"AZ","Coal":1609,"coordinates":[-109.1639,34.3186]},{"Plant":"North Valmy","State":"NV","Coal":522,"coordinates":[-117.1516,40.8813]},{"Plant":"Cheswick Power Plant","State":"PA","Coal":563,"coordinates":[-79.7906,40.5383]},{"Plant":"E D Edwards","State":"IL","Coal":650,"coordinates":[-89.6631,40.5958]},{"Plant":"Coffeen","State":"IL","Coal":895,"coordinates":[-89.4031,39.0586]},{"Plant":"Escalante","State":"NM","Coal":247,"coordinates":[-108.082,35.4159]},{"Plant":"Joliet 9","State":"IL","Coal":314,"coordinates":[-88.1153,41.4931]},{"Plant":"Kincaid Generation LLC","State":"IL","Coal":1158,"coordinates":[-89.4964,39.5906]},{"Plant":"Powerton","State":"IL","Coal":1538,"coordinates":[-89.6786,40.5408]},{"Plant":"Waukegan","State":"IL","Coal":689,"coordinates":[-87.8133,42.3833]},{"Plant":"Will County","State":"IL","Coal":761,"coordinates":[-88.0629,41.6334]},{"Plant":"Joppa Steam","State":"IL","Coal":1002,"coordinates":[-88.8589,37.2094]},{"Plant":"Baldwin Energy Complex","State":"IL","Coal":1775,"coordinates":[-89.8544,38.205]},{"Plant":"Havana","State":"IL","Coal":428,"coordinates":[-90.08,40.2797]},{"Plant":"Hennepin Power Station","State":"IL","Coal":285,"coordinates":[-89.315,41.3028]},{"Plant":"Wood River","State":"IL","Coal":456,"coordinates":[-90.1347,38.8639]},{"Plant":"Dallman","State":"IL","Coal":534,"coordinates":[-89.6024,39.7548]},{"Plant":"Marion","State":"IL","Coal":290,"coordinates":[-88.9531,37.6197]},{"Plant":"Clifty Creek","State":"IN","Coal":1203,"coordinates":[-85.4206,38.7378]},{"Plant":"Tanners Creek","State":"IN","Coal":990,"coordinates":[-84.8594,39.0814]},{"Plant":"Harding Street","State":"IN","Coal":647,"coordinates":[-86.1969,39.7113]},{"Plant":"Eagle Valley","State":"IN","Coal":257,"coordinates":[-86.4183,39.4852]},{"Plant":"AES Petersburg","State":"IN","Coal":1701.5,"coordinates":[-87.2525,38.5281]},{"Plant":"Bailly","State":"IN","Coal":480,"coordinates":[-87.1225,41.645]},{"Plant":"Michigan City","State":"IN","Coal":469,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Coal":497,"coordinates":[-87.7811,32.6017]},{"Plant":"ACE Cogeneration Facility","State":"CA","Coal":101.2,"coordinates":[-117.3836,35.7658]},{"Plant":"Cayuga","State":"IN","Coal":995,"coordinates":[-87.4244,39.9242]},{"Plant":"RED-Rochester, LLC","State":"NY","Coal":129.9,"coordinates":[-77.6319,43.1989]},{"Plant":"Edwardsport","State":"IN","Coal":571,"coordinates":[-87.2472,38.8067]},{"Plant":"Logan Generating Company LP","State":"NJ","Coal":219,"coordinates":[-75.4067,39.7928]},{"Plant":"Portsmouth Genco LLC","State":"VA","Coal":115,"coordinates":[-76.3529,36.8702]},{"Plant":"Taconite Harbor Energy Center","State":"MN","Coal":238.5,"coordinates":[-90.9114,47.5314]},{"Plant":"R Gallagher","State":"IN","Coal":280,"coordinates":[-85.8381,38.2636]},{"Plant":"Wabash River","State":"IN","Coal":668,"coordinates":[-87.4247,39.53]},{"Plant":"F B Culley","State":"IN","Coal":360,"coordinates":[-87.3275,37.9111]},{"Plant":"Colver Power Project","State":"PA","Coal":110,"coordinates":[-78.8,40.55]},{"Plant":"Green Bay West Mill","State":"WI","Coal":112.9,"coordinates":[-88.0303,44.4936]},{"Plant":"Edgecombe Genco LLC","State":"NC","Coal":115.6,"coordinates":[-77.7533,36.0373]},{"Plant":"Frank E Ratts","State":"IN","Coal":224,"coordinates":[-87.2662,38.5201]},{"Plant":"Lansing","State":"IA","Coal":249.4,"coordinates":[-91.1675,43.3359]},{"Plant":"Milton L Kapp","State":"IA","Coal":204.1,"coordinates":[-90.2336,41.8081]},{"Plant":"Chambers Cogeneration LP","State":"NJ","Coal":249.8,"coordinates":[-75.4858,39.6935]},{"Plant":"AES Shady Point LLC","State":"OK","Coal":320,"coordinates":[-94.6458,35.1931]},{"Plant":"Cedar Bay Generating Company LP","State":"FL","Coal":250,"coordinates":[-81.6064,30.4225]},{"Plant":"AES Hawaii","State":"HI","Coal":180,"coordinates":[-158.1065,21.3034]},{"Plant":"AES Beaver Valley Partners Beaver Valley","State":"PA","Coal":146,"coordinates":[-80.3539,40.6572]},{"Plant":"AES Warrior Run Cogeneration Facility","State":"MD","Coal":180,"coordinates":[-78.7453,39.5952]},{"Plant":"Prairie Creek","State":"IA","Coal":157.4,"coordinates":[-91.6392,41.944]},{"Plant":"Holcomb","State":"KS","Coal":358.8,"coordinates":[-100.9725,37.9308]},{"Plant":"Riverside","State":"IA","Coal":133.3,"coordinates":[-90.4481,41.54]},{"Plant":"Walter Scott Jr Energy Center","State":"IA","Coal":1635.5,"coordinates":[-95.8408,41.18]},{"Plant":"Silver Bay Power","State":"MN","Coal":105,"coordinates":[-91.2605,47.2866]},{"Plant":"Archer Daniels Midland Clinton","State":"IA","Coal":180,"coordinates":[-90.2097,41.8206]},{"Plant":"Archer Daniels Midland Cedar Rapids","State":"IA","Coal":260,"coordinates":[-91.6875,41.9221]},{"Plant":"Archer Daniels Midland Decatur","State":"IL","Coal":335,"coordinates":[-88.8908,39.8701]},{"Plant":"George Neal North","State":"IA","Coal":909.9,"coordinates":[-96.3617,42.2998]},{"Plant":"Burlington","State":"IA","Coal":212,"coordinates":[-91.1167,40.7412]},{"Plant":"Cholla","State":"AZ","Coal":1027,"coordinates":[-110.3033,34.9394]},{"Plant":"Muscatine Plant #1","State":"IA","Coal":230.7,"coordinates":[-91.0569,41.3917]},{"Plant":"La Cygne","State":"KS","Coal":1415.3,"coordinates":[-94.6456,38.3481]},{"Plant":"Lawrence Energy Center","State":"KS","Coal":534,"coordinates":[-95.2692,39.0072]},{"Plant":"Tecumseh Energy Center","State":"KS","Coal":197,"coordinates":[-95.5689,39.0539]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Coal":156,"coordinates":[-110.9047,32.16]},{"Plant":"Oklaunion","State":"TX","Coal":650,"coordinates":[-99.1753,34.0825]},{"Plant":"Quindaro","State":"KS","Coal":207,"coordinates":[-94.6381,39.1492]},{"Plant":"Cross","State":"SC","Coal":2350,"coordinates":[-80.1119,33.3692]},{"Plant":"Big Sandy","State":"KY","Coal":1060,"coordinates":[-82.6176,38.1707]},{"Plant":"E W Brown","State":"KY","Coal":684,"coordinates":[-84.7126,37.7883]},{"Plant":"Ghent","State":"KY","Coal":1932,"coordinates":[-85.035,38.7497]},{"Plant":"Green River","State":"KY","Coal":163,"coordinates":[-87.1214,37.3636]},{"Plant":"Seminole","State":"FL","Coal":1309,"coordinates":[-81.6328,29.7331]},{"Plant":"Cane Run","State":"KY","Coal":563,"coordinates":[-85.8892,38.1831]},{"Plant":"Mill Creek","State":"KY","Coal":1472,"coordinates":[-85.9103,38.0525]},{"Plant":"Elmer Smith","State":"KY","Coal":398.7,"coordinates":[-87.0608,37.7942]},{"Plant":"Paradise","State":"KY","Coal":2201,"coordinates":[-86.9783,37.2608]},{"Plant":"Shawnee","State":"KY","Coal":1330,"coordinates":[-88.775,37.1517]},{"Plant":"Kenneth C Coleman","State":"KY","Coal":443,"coordinates":[-86.7911,37.9631]},{"Plant":"HMP&L Station Two Henderson","State":"KY","Coal":312,"coordinates":[-87.5028,37.6469]},{"Plant":"Cooper","State":"KY","Coal":341,"coordinates":[-84.5919,36.9981]},{"Plant":"Dale","State":"KY","Coal":195,"coordinates":[-84.2619,37.8806]},{"Plant":"R S Nelson","State":"LA","Coal":550.8,"coordinates":[-93.2911,30.2844]},{"Plant":"C P Crane","State":"MD","Coal":385,"coordinates":[-76.3651,39.3236]},{"Plant":"Herbert A Wagner","State":"MD","Coal":440,"coordinates":[-76.5268,39.1781]},{"Plant":"Chalk Point LLC","State":"MD","Coal":667,"coordinates":[-76.6861,38.5444]},{"Plant":"Dickerson","State":"MD","Coal":537,"coordinates":[-77.4644,39.2097]},{"Plant":"Morgantown Generating Plant","State":"MD","Coal":1205,"coordinates":[-76.9767,38.3592]},{"Plant":"Apache Station","State":"AZ","Coal":350,"coordinates":[-109.8931,32.0603]},{"Plant":"Mount Tom","State":"MA","Coal":143.6,"coordinates":[-72.6055,42.2806]},{"Plant":"Brayton Point","State":"MA","Coal":1083.5,"coordinates":[-71.1931,41.7103]},{"Plant":"Salem Harbor","State":"MA","Coal":149.8,"coordinates":[-70.8772,42.5256]},{"Plant":"GRDA","State":"OK","Coal":1010,"coordinates":[-95.2894,36.1903]},{"Plant":"B C Cobb","State":"MI","Coal":307,"coordinates":[-86.2423,43.2588]},{"Plant":"Dan E Karn","State":"MI","Coal":510,"coordinates":[-83.8401,43.645]},{"Plant":"J H Campbell","State":"MI","Coal":1416,"coordinates":[-86.2007,42.9103]},{"Plant":"J C Weadock","State":"MI","Coal":309,"coordinates":[-83.8447,43.6399]},{"Plant":"J R Whiting","State":"MI","Coal":317,"coordinates":[-83.4495,41.7921]},{"Plant":"Monroe","State":"MI","Coal":2930,"coordinates":[-83.3464,41.8906]},{"Plant":"River Rouge","State":"MI","Coal":527,"coordinates":[-83.1119,42.2739]},{"Plant":"St Clair","State":"MI","Coal":1374,"coordinates":[-82.4719,42.7642]},{"Plant":"Trenton Channel","State":"MI","Coal":713,"coordinates":[-83.1808,42.1217]},{"Plant":"Presque Isle","State":"MI","Coal":344,"coordinates":[-87.395,46.5789]},{"Plant":"Eckert Station","State":"MI","Coal":285,"coordinates":[-84.5581,42.7184]},{"Plant":"Erickson Station","State":"MI","Coal":154.5,"coordinates":[-84.6572,42.6922]},{"Plant":"Clay Boswell","State":"MN","Coal":1081.6,"coordinates":[-93.6528,47.2611]},{"Plant":"Black Dog","State":"MN","Coal":232,"coordinates":[-93.2501,44.8108]},{"Plant":"Allen S King","State":"MN","Coal":511,"coordinates":[-92.7786,45.03]},{"Plant":"Hoot Lake","State":"MN","Coal":138,"coordinates":[-96.0433,46.2906]},{"Plant":"Jack Watson","State":"MS","Coal":706,"coordinates":[-89.0286,30.4392]},{"Plant":"St Johns River Power Park","State":"FL","Coal":1252,"coordinates":[-81.5508,30.4308]},{"Plant":"Asbury","State":"MO","Coal":189,"coordinates":[-94.5893,37.3613]},{"Plant":"Hawthorn","State":"MO","Coal":564,"coordinates":[-94.4778,39.1306]},{"Plant":"Montrose","State":"MO","Coal":510,"coordinates":[-93.9348,38.3114]},{"Plant":"Sibley","State":"MO","Coal":462.4,"coordinates":[-94.1844,39.1783]},{"Plant":"Labadie","State":"MO","Coal":2374,"coordinates":[-90.8377,38.5622]},{"Plant":"Meramec","State":"MO","Coal":836,"coordinates":[-90.3358,38.4017]},{"Plant":"Sioux","State":"MO","Coal":974,"coordinates":[-90.2902,38.9155]},{"Plant":"James River Power Station","State":"MO","Coal":236,"coordinates":[-93.2619,37.1086]},{"Plant":"New Madrid","State":"MO","Coal":1154,"coordinates":[-89.5617,36.5147]},{"Plant":"Thomas Hill","State":"MO","Coal":1133,"coordinates":[-92.6381,39.5522]},{"Plant":"J E Corette Plant","State":"MT","Coal":153,"coordinates":[-108.481,45.7756]},{"Plant":"Lon Wright","State":"NE","Coal":120,"coordinates":[-96.4623,41.4281]},{"Plant":"Sheldon","State":"NE","Coal":215,"coordinates":[-96.7847,40.5589]},{"Plant":"North Omaha","State":"NE","Coal":648.3,"coordinates":[-95.9447,41.3291]},{"Plant":"Reid Gardner","State":"NV","Coal":555,"coordinates":[-114.6333,36.6573]},{"Plant":"Merrimack","State":"NH","Coal":438.5,"coordinates":[-71.4692,43.1411]},{"Plant":"B L England","State":"NJ","Coal":268,"coordinates":[-74.6364,39.2908]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Coal":620,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Mercer Generating Station","State":"NJ","Coal":632,"coordinates":[-74.7339,40.1792]},{"Plant":"Four Corners","State":"NM","Coal":1540,"coordinates":[-108.4814,36.69]},{"Plant":"San Juan","State":"NM","Coal":1684,"coordinates":[-108.4386,36.8006]},{"Plant":"Danskammer Generating Station","State":"NY","Coal":369.5,"coordinates":[-73.975,41.5712]},{"Plant":"GMMGreenidge LLC","State":"NY","Coal":107.5,"coordinates":[-76.9483,42.6789]},{"Plant":"Cayuga Operating Company","State":"NY","Coal":314.9,"coordinates":[-76.6336,42.6028]},{"Plant":"C R Huntley Generating Station","State":"NY","Coal":380,"coordinates":[-78.93,42.97]},{"Plant":"Dunkirk Generating Plant","State":"NY","Coal":520,"coordinates":[-79.3466,42.4915]},{"Plant":"E C Gaston","State":"AL","Coal":1862,"coordinates":[-86.4581,33.2442]},{"Plant":"Asheville","State":"NC","Coal":376,"coordinates":[-82.5417,35.4731]},{"Plant":"Roxboro","State":"NC","Coal":2433,"coordinates":[-79.0731,36.4833]},{"Plant":"G G Allen","State":"NC","Coal":1127,"coordinates":[-81.0122,35.1897]},{"Plant":"Cliffside","State":"NC","Coal":1396,"coordinates":[-81.7594,35.22]},{"Plant":"Marshall","State":"NC","Coal":2078,"coordinates":[-80.9658,35.5975]},{"Plant":"R M Heskett","State":"ND","Coal":104.3,"coordinates":[-100.8836,46.8669]},{"Plant":"Leland Olds","State":"ND","Coal":667,"coordinates":[-101.3212,47.2808]},{"Plant":"Milton R Young","State":"ND","Coal":684,"coordinates":[-101.2131,47.0659]},{"Plant":"Stanton","State":"ND","Coal":186.9,"coordinates":[-101.3319,47.2866]},{"Plant":"Cardinal","State":"OH","Coal":1800,"coordinates":[-80.6486,40.2522]},{"Plant":"Walter C Beckjord","State":"OH","Coal":802,"coordinates":[-84.2981,38.9917]},{"Plant":"Miami Fort","State":"OH","Coal":1183,"coordinates":[-84.8036,39.1128]},{"Plant":"FirstEnergy Ashtabula","State":"OH","Coal":244,"coordinates":[-80.7697,41.9086]},{"Plant":"Avon Lake","State":"OH","Coal":710,"coordinates":[-82.0546,41.5045]},{"Plant":"FirstEnergy Eastlake","State":"OH","Coal":396,"coordinates":[-81.4425,41.6711]},{"Plant":"FirstEnergy Lake Shore","State":"OH","Coal":245,"coordinates":[-81.6419,41.5356]},{"Plant":"Conesville","State":"OH","Coal":1530,"coordinates":[-81.8811,40.1842]},{"Plant":"O H Hutchings","State":"OH","Coal":302,"coordinates":[-84.2921,39.6088]},{"Plant":"J M Stuart","State":"OH","Coal":2308,"coordinates":[-83.6939,38.6361]},{"Plant":"FirstEnergy W H Sammis","State":"OH","Coal":2220,"coordinates":[-80.6319,40.5317]},{"Plant":"Muskingum River","State":"OH","Coal":1375,"coordinates":[-81.6797,39.5908]},{"Plant":"Kyger Creek","State":"OH","Coal":962.8,"coordinates":[-82.1289,38.9144]},{"Plant":"Muskogee","State":"OK","Coal":1505.5,"coordinates":[-95.2873,35.7614]},{"Plant":"Northeastern","State":"OK","Coal":920,"coordinates":[-95.7008,36.4317]},{"Plant":"Limestone","State":"TX","Coal":1689,"coordinates":[-96.2525,31.4219]},{"Plant":"Barry","State":"AL","Coal":1612.5,"coordinates":[-88.0103,31.0069]},{"Plant":"Portland","State":"PA","Coal":335,"coordinates":[-75.0794,40.9102]},{"Plant":"Conemaugh","State":"PA","Coal":1700,"coordinates":[-79.0611,40.3842]},{"Plant":"Homer City Generating Station","State":"PA","Coal":1892.3,"coordinates":[-79.1961,40.5128]},{"Plant":"Seward","State":"PA","Coal":521,"coordinates":[-79.0337,40.4062]},{"Plant":"Shawville","State":"PA","Coal":565,"coordinates":[-78.3662,41.0675]},{"Plant":"Keystone","State":"PA","Coal":1700,"coordinates":[-79.3411,40.6604]},{"Plant":"New Castle Plant","State":"PA","Coal":305,"coordinates":[-80.369,40.9379]},{"Plant":"Brunner Island","State":"PA","Coal":1428,"coordinates":[-76.6962,40.0961]},{"Plant":"PPL Montour","State":"PA","Coal":1516,"coordinates":[-76.6672,41.0714]},{"Plant":"Sunbury Generation LP","State":"PA","Coal":382,"coordinates":[-76.825,40.8361]},{"Plant":"W S Lee","State":"SC","Coal":370,"coordinates":[-82.435,34.6022]},{"Plant":"McMeekin","State":"SC","Coal":250,"coordinates":[-81.2172,34.0556]},{"Plant":"Wateree","State":"SC","Coal":684,"coordinates":[-80.6228,33.8264]},{"Plant":"Williams","State":"SC","Coal":605,"coordinates":[-79.9297,33.0158]},{"Plant":"Allen Steam Plant","State":"TN","Coal":741,"coordinates":[-90.1487,35.0741]},{"Plant":"Bull Run","State":"TN","Coal":870,"coordinates":[-84.1567,36.0211]},{"Plant":"Cumberland","State":"TN","Coal":2470,"coordinates":[-87.6539,36.3903]},{"Plant":"Gallatin","State":"TN","Coal":976,"coordinates":[-86.4006,36.3156]},{"Plant":"John Sevier","State":"TN","Coal":352,"coordinates":[-82.9639,36.3767]},{"Plant":"Johnsonville","State":"TN","Coal":1206,"coordinates":[-87.9861,36.0278]},{"Plant":"Kingston","State":"TN","Coal":1398,"coordinates":[-84.5194,35.8992]},{"Plant":"W A Parish","State":"TX","Coal":2499,"coordinates":[-95.6311,29.4828]},{"Plant":"Big Brown","State":"TX","Coal":1195,"coordinates":[-96.0544,31.8206]},{"Plant":"Carbon","State":"UT","Coal":172,"coordinates":[-110.8644,39.7272]},{"Plant":"Clinch River","State":"VA","Coal":690,"coordinates":[-82.1997,36.9333]},{"Plant":"Glen Lyn","State":"VA","Coal":325,"coordinates":[-80.8633,37.3706]},{"Plant":"Chesterfield","State":"VA","Coal":1253,"coordinates":[-77.3833,37.3822]},{"Plant":"Chesapeake","State":"VA","Coal":595,"coordinates":[-76.3019,36.7711]},{"Plant":"Yorktown","State":"VA","Coal":323,"coordinates":[-76.4611,37.2144]},{"Plant":"Joliet 29","State":"IL","Coal":1036,"coordinates":[-88.1238,41.4946]},{"Plant":"Transalta Centralia Generation","State":"WA","Coal":1340,"coordinates":[-122.8598,46.7559]},{"Plant":"John E Amos","State":"WV","Coal":2900,"coordinates":[-81.8233,38.4731]},{"Plant":"Kanawha River","State":"WV","Coal":400,"coordinates":[-81.4211,38.2056]},{"Plant":"Philip Sporn","State":"WV","Coal":580,"coordinates":[-81.9231,38.9669]},{"Plant":"FirstEnergy Fort Martin Power Station","State":"WV","Coal":1098,"coordinates":[-79.9275,39.7108]},{"Plant":"FirstEnergy Harrison Power Station","State":"WV","Coal":1954,"coordinates":[-80.3325,39.3842]},{"Plant":"Kammer","State":"WV","Coal":600,"coordinates":[-80.8186,39.8461]},{"Plant":"Mitchell","State":"WV","Coal":1560,"coordinates":[-80.8153,39.8297]},{"Plant":"Mt Storm","State":"WV","Coal":1629,"coordinates":[-79.2636,39.2008]},{"Plant":"South Oak Creek","State":"WI","Coal":993,"coordinates":[-87.8294,42.8457]},{"Plant":"Valley","State":"WI","Coal":236,"coordinates":[-87.9233,43.0303]},{"Plant":"Edgewater","State":"WI","Coal":736,"coordinates":[-87.7059,43.7151]},{"Plant":"Nelson Dewey Coal Refining Facility","State":"WI","Coal":206.2,"coordinates":[-91.0085,42.7225]},{"Plant":"Pulliam","State":"WI","Coal":328,"coordinates":[-88.0086,44.54]},{"Plant":"Weston","State":"WI","Coal":995.1,"coordinates":[-89.6553,44.8606]},{"Plant":"Alma","State":"WI","Coal":102.5,"coordinates":[-91.9111,44.3083]},{"Plant":"Genoa","State":"WI","Coal":306.7,"coordinates":[-91.2325,43.5589]},{"Plant":"Dave Johnston","State":"WY","Coal":760,"coordinates":[-105.7769,42.8378]},{"Plant":"Naughton","State":"WY","Coal":687,"coordinates":[-110.5983,41.7581]},{"Plant":"John P Madgett","State":"WI","Coal":388.8,"coordinates":[-91.9126,44.3036]},{"Plant":"Cherokee","State":"CO","Coal":504,"coordinates":[-104.9645,39.8073]},{"Plant":"Colbert","State":"AL","Coal":1184,"coordinates":[-87.8486,34.7439]},{"Plant":"Comanche","State":"CO","Coal":1410,"coordinates":[-104.5747,38.2081]},{"Plant":"Valmont","State":"CO","Coal":184,"coordinates":[-105.202,40.0195]},{"Plant":"Martin Drake","State":"CO","Coal":254,"coordinates":[-104.8333,38.8244]},{"Plant":"Navajo","State":"AZ","Coal":2250,"coordinates":[-111.3886,36.9047]},{"Plant":"Widows Creek","State":"AL","Coal":1382,"coordinates":[-85.7553,34.883]},{"Plant":"Tennessee Eastman Operations","State":"TN","Coal":194.3,"coordinates":[-82.5431,36.5219]},{"Plant":"Axiall Natrium Plant","State":"WV","Coal":123,"coordinates":[-80.8547,39.7475]},{"Plant":"Northampton Generating Company LP","State":"PA","Coal":112,"coordinates":[-75.4792,40.6917]},{"Plant":"Indiantown Cogeneration LP","State":"FL","Coal":330,"coordinates":[-80.5125,27.0389]},{"Plant":"Dolet Hills","State":"LA","Coal":638,"coordinates":[-93.5692,32.0306]},{"Plant":"Mecklenburg Power Station","State":"VA","Coal":138,"coordinates":[-78.53,36.6]},{"Plant":"Sandow No 5","State":"TX","Coal":570,"coordinates":[-97.0614,30.5681]},{"Plant":"Hayden","State":"CO","Coal":446,"coordinates":[-107.185,40.4856]},{"Plant":"Roanoke Valley Energy Facililty I","State":"NC","Coal":165,"coordinates":[-77.6167,36.4364]},{"Plant":"Spruance Genco LLC","State":"VA","Coal":190,"coordinates":[-77.4308,37.4556]},{"Plant":"Birchwood Power","State":"VA","Coal":238.3,"coordinates":[-77.3147,38.2667]},{"Plant":"Red Hills Generating Facility","State":"MS","Coal":440,"coordinates":[-89.2183,33.3761]},{"Plant":"Hardin Generator Project","State":"MT","Coal":107,"coordinates":[-107.6,45.7578]},{"Plant":"Prairie State Generating Station","State":"IL","Coal":1628,"coordinates":[-89.6669,38.2792]},{"Plant":"Charles R Lowman","State":"AL","Coal":553,"coordinates":[-87.9107,31.488]},{"Plant":"Elm Road Generating Station","State":"WI","Coal":1268,"coordinates":[-87.8336,42.8492]},{"Plant":"Kennecott Power Plant","State":"UT","Coal":175,"coordinates":[-112.1225,40.7119]},{"Plant":"TS Power Plant","State":"NV","Coal":218.4,"coordinates":[-116.5297,40.7461]},{"Plant":"Stanton Energy Center","State":"FL","Coal":896,"coordinates":[-81.1678,28.4822]},{"Plant":"Plum Point Energy Station","State":"AR","Coal":670,"coordinates":[-89.9489,35.6644]},{"Plant":"John W Turk Jr Power Plant","State":"AR","Coal":609,"coordinates":[-93.8119,33.6497]},{"Plant":"Dry Fork Station","State":"WY","Coal":380,"coordinates":[-105.4608,44.3889]},{"Plant":"Sandy Creek Energy Station","State":"TX","Coal":936.5,"coordinates":[-96.9571,31.4744]},{"Plant":"Longview Power LLC","State":"WV","Coal":700,"coordinates":[-79.959,39.7079]},{"Plant":"Bridgeport Station","State":"CT","Coal":383.4,"coordinates":[-73.1844,41.1706]},{"Plant":"Virginia City Hybrid Energy Center","State":"VA","Coal":610,"coordinates":[-82.3381,36.9164]},{"Plant":"Indian River Generating Station","State":"DE","Coal":575,"coordinates":[-75.2341,38.5857]},{"Plant":"Whelan Energy Center","State":"NE","Coal":309,"coordinates":[-98.3124,40.5809]},{"Plant":"James H Miller Jr","State":"AL","Coal":2675.2,"coordinates":[-87.0597,33.6319]},{"Plant":"FirstEnergy Pleasants Power Station","State":"WV","Coal":1288,"coordinates":[-81.2944,39.3667]},{"Plant":"White Bluff","State":"AR","Coal":1636.7,"coordinates":[-92.1406,34.4228]},{"Plant":"Duck Creek","State":"IL","Coal":410,"coordinates":[-89.9841,40.4663]},{"Plant":"Newton","State":"IL","Coal":1197,"coordinates":[-88.2781,38.9361]},{"Plant":"East Bend","State":"KY","Coal":600,"coordinates":[-84.8514,38.9036]},{"Plant":"W H Zimmer","State":"OH","Coal":1344,"coordinates":[-84.2289,38.8675]},{"Plant":"Brandon Shores","State":"MD","Coal":1273,"coordinates":[-76.5389,39.18]},{"Plant":"Craig","State":"CO","Coal":1304,"coordinates":[-107.5912,40.4627]},{"Plant":"Coal Creek","State":"ND","Coal":1139.9,"coordinates":[-101.1571,47.3777]},{"Plant":"Killen Station","State":"OH","Coal":600,"coordinates":[-83.4803,38.6903]},{"Plant":"Belle River","State":"MI","Coal":1284,"coordinates":[-82.495,42.7756]},{"Plant":"H L Spurlock","State":"KY","Coal":1346,"coordinates":[-83.8181,38.7]},{"Plant":"Wansley","State":"GA","Coal":1744,"coordinates":[-85.0323,33.4134]},{"Plant":"Big Cajun 2","State":"LA","Coal":1756,"coordinates":[-91.3692,30.7261]},{"Plant":"R D Morrow","State":"MS","Coal":360,"coordinates":[-89.394,31.2186]},{"Plant":"Nearman Creek","State":"KS","Coal":229,"coordinates":[-94.6975,39.1681]},{"Plant":"Iatan","State":"MO","Coal":1593.8,"coordinates":[-94.98,39.4472]},{"Plant":"Jeffrey Energy Center","State":"KS","Coal":2155,"coordinates":[-96.1172,39.2865]},{"Plant":"Trimble County","State":"KY","Coal":1243,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Coal":1020,"coordinates":[-88.5553,30.5322]},{"Plant":"Colstrip","State":"MT","Coal":2094,"coordinates":[-106.614,45.8831]},{"Plant":"Gerald Gentleman","State":"NE","Coal":1365,"coordinates":[-101.1408,41.0808]},{"Plant":"Somerset Operating Co LLC","State":"NY","Coal":685.5,"coordinates":[-78.6047,43.3589]},{"Plant":"R M Schahfer","State":"IN","Coal":1625,"coordinates":[-87.0261,41.2164]},{"Plant":"Sherburne County","State":"MN","Coal":2242.8,"coordinates":[-93.8931,45.3808]},{"Plant":"FirstEnergy Bruce Mansfield","State":"PA","Coal":2510,"coordinates":[-80.4159,40.6348]},{"Plant":"Sooner","State":"OK","Coal":1041.5,"coordinates":[-97.0528,36.4531]},{"Plant":"Nebraska City","State":"NE","Coal":1339.3,"coordinates":[-95.7764,40.6214]},{"Plant":"Big Stone","State":"SD","Coal":475,"coordinates":[-96.5101,45.3037]},{"Plant":"Wyodak","State":"WY","Coal":332,"coordinates":[-105.3815,44.2901]},{"Plant":"Boardman","State":"OR","Coal":585,"coordinates":[-119.8088,45.6932]},{"Plant":"Gibson","State":"IN","Coal":3132,"coordinates":[-87.7658,38.3722]},{"Plant":"McIntosh","State":"GA","Coal":156.5,"coordinates":[-81.1683,32.3563]},{"Plant":"Gibbons Creek","State":"TX","Coal":470,"coordinates":[-96.0818,30.6199]},{"Plant":"A B Brown","State":"IN","Coal":490,"coordinates":[-87.715,37.9053]},{"Plant":"Flint Creek","State":"AR","Coal":528,"coordinates":[-94.5241,36.2561]},{"Plant":"Welsh","State":"TX","Coal":1584,"coordinates":[-94.84,33.0552]},{"Plant":"Martin Lake","State":"TX","Coal":2410,"coordinates":[-94.5706,32.2606]},{"Plant":"Monticello","State":"TX","Coal":1865,"coordinates":[-95.0417,33.0917]},{"Plant":"Rush Island","State":"MO","Coal":1182,"coordinates":[-90.2632,38.1312]},{"Plant":"Hunter","State":"UT","Coal":1361,"coordinates":[-111.0289,39.1747]},{"Plant":"Rockport","State":"IN","Coal":2600,"coordinates":[-87.0372,37.9256]},{"Plant":"Pleasant Prairie","State":"WI","Coal":1188,"coordinates":[-87.9033,42.5381]},{"Plant":"Coronado","State":"AZ","Coal":765,"coordinates":[-109.2708,34.5789]},{"Plant":"Coleto Creek","State":"TX","Coal":635,"coordinates":[-97.2142,28.7128]},{"Plant":"Fayette Power Project","State":"TX","Coal":1641,"coordinates":[-96.7506,29.9172]},{"Plant":"Oak Grove","State":"TX","Coal":1665,"coordinates":[-96.4866,31.1803]},{"Plant":"J T Deely","State":"TX","Coal":840,"coordinates":[-98.3228,29.3081]},{"Plant":"San Miguel","State":"TX","Coal":391,"coordinates":[-98.4775,28.7044]},{"Plant":"Brame Energy Center","State":"LA","Coal":493,"coordinates":[-92.7167,31.395]},{"Plant":"Harrington","State":"TX","Coal":1018,"coordinates":[-101.7472,35.2982]},{"Plant":"Tolk","State":"TX","Coal":1067,"coordinates":[-102.57,34.1865]},{"Plant":"John Twitty Energy Center","State":"MO","Coal":459,"coordinates":[-93.388,37.1517]},{"Plant":"Laramie River Station","State":"WY","Coal":1710,"coordinates":[-104.8825,42.1089]},{"Plant":"Merom","State":"IN","Coal":977,"coordinates":[-87.5108,39.0694]},{"Plant":"Pawnee","State":"CO","Coal":505,"coordinates":[-103.6803,40.2217]},{"Plant":"Winyah","State":"SC","Coal":1130,"coordinates":[-79.3581,33.3317]},{"Plant":"Mayo","State":"NC","Coal":727,"coordinates":[-78.8917,36.5278]},{"Plant":"Ottumwa","State":"IA","Coal":718.4,"coordinates":[-92.5558,41.0961]},{"Plant":"Scherer","State":"GA","Coal":3406.7,"coordinates":[-83.8075,33.0606]},{"Plant":"Mountaineer","State":"WV","Coal":1299,"coordinates":[-81.9344,38.9794]},{"Plant":"Crystal River","State":"FL","Coal":2291,"coordinates":[-82.6977,28.9656]},{"Plant":"Crist","State":"FL","Coal":924,"coordinates":[-87.2244,30.5661]},{"Plant":"Lansing Smith","State":"FL","Coal":357,"coordinates":[-85.7003,30.2686]},{"Plant":"Big Bend","State":"FL","Coal":1542,"coordinates":[-82.4036,27.7944]},{"Plant":"Antelope Valley","State":"ND","Coal":900,"coordinates":[-101.3194,47.2819]},{"Plant":"Intermountain Power Project","State":"UT","Coal":1800,"coordinates":[-112.5802,39.5097]},{"Plant":"Deerhaven Generating Station","State":"FL","Coal":232,"coordinates":[-82.3878,29.7592]},{"Plant":"R D Green","State":"KY","Coal":454,"coordinates":[-87.5,37.6461]},{"Plant":"Independence","State":"AR","Coal":1678.6,"coordinates":[-91.4088,35.6784]},{"Plant":"Sandow No 4","State":"TX","Coal":600,"coordinates":[-97.064,30.5659]},{"Plant":"Louisa","State":"IA","Coal":746.2,"coordinates":[-91.0931,41.3181]},{"Plant":"Warrick","State":"IN","Coal":745,"coordinates":[-87.3328,37.915]},{"Plant":"C D McIntosh Jr","State":"FL","Coal":342,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Coal":280,"coordinates":[-105.0212,40.8609]},{"Plant":"Sikeston Power Station","State":"MO","Coal":233,"coordinates":[-89.6209,36.8791]},{"Plant":"Hugo","State":"OK","Coal":440,"coordinates":[-95.3206,34.0158]},{"Plant":"D B Wilson","State":"KY","Coal":417,"coordinates":[-87.0806,37.4497]},{"Plant":"Gadsden","State":"AL","Coal":130,"coordinates":[-85.9708,34.0128]},{"Plant":"Bowen","State":"GA","Coal":3202,"coordinates":[-84.9222,34.1256]},{"Plant":"Major Oak Power","State":"TX","Coal":305,"coordinates":[-96.695,31.0919]},{"Plant":"Hammond","State":"GA","Coal":840,"coordinates":[-85.3456,34.2528]},{"Plant":"Harllee Branch","State":"GA","Coal":1282,"coordinates":[-83.2983,33.195]},{"Plant":"J K Spruce","State":"TX","Coal":1340,"coordinates":[-98.3203,29.3097]},{"Plant":"Cope","State":"SC","Coal":415,"coordinates":[-81.03,33.3644]},{"Plant":"Clover","State":"VA","Coal":877,"coordinates":[-78.704,36.869]},{"Plant":"Polk","State":"FL","Coal":220,"coordinates":[-81.9897,27.7286]},{"Plant":"Mitchell","State":"GA","Coal":155,"coordinates":[-84.1347,31.4447]},{"Plant":"Yates","State":"GA","Coal":1286,"coordinates":[-84.8986,33.4622]},{"Plant":"Kraft","State":"GA","Coal":201,"coordinates":[-81.1458,32.1486]},{"Plant":"George Neal South","State":"IA","Coal":644.8,"coordinates":[-96.3617,42.3006]},{"Plant":"Bonanza","State":"UT","Coal":458,"coordinates":[-109.2844,40.0864]},{"Plant":"Pirkey","State":"TX","Coal":721,"coordinates":[-94.4852,32.4607]},{"Plant":"Gorgas","State":"AL","Coal":1241,"coordinates":[-87.1965,33.6443]},{"Plant":"Columbia","State":"WI","Coal":1122,"coordinates":[-89.4203,43.4864]},{"Plant":"Belews Creek","State":"NC","Coal":2220,"coordinates":[-80.0603,36.2811]},{"Plant":"Jim Bridger","State":"WY","Coal":2111,"coordinates":[-108.7875,41.7378]},{"Plant":"Huntington","State":"UT","Coal":909,"coordinates":[-111.0781,39.3792]},{"Plant":"General James M Gavin","State":"OH","Coal":2598,"coordinates":[-82.1158,38.9347]},{"Plant":"Ray D Nixon","State":"CO","Coal":208,"coordinates":[-104.7058,38.6335]},{"Plant":"Coyote","State":"ND","Coal":427,"coordinates":[-101.8157,47.2214]},{"Plant":"Springerville","State":"AZ","Coal":1609,"coordinates":[-109.1639,34.3186]},{"Plant":"North Valmy","State":"NV","Coal":522,"coordinates":[-117.1516,40.8813]},{"Plant":"Cheswick Power Plant","State":"PA","Coal":563,"coordinates":[-79.7906,40.5383]},{"Plant":"E D Edwards","State":"IL","Coal":650,"coordinates":[-89.6631,40.5958]},{"Plant":"Coffeen","State":"IL","Coal":895,"coordinates":[-89.4031,39.0586]},{"Plant":"Escalante","State":"NM","Coal":247,"coordinates":[-108.082,35.4159]},{"Plant":"Joliet 9","State":"IL","Coal":314,"coordinates":[-88.1153,41.4931]},{"Plant":"Kincaid Generation LLC","State":"IL","Coal":1158,"coordinates":[-89.4964,39.5906]},{"Plant":"Powerton","State":"IL","Coal":1538,"coordinates":[-89.6786,40.5408]},{"Plant":"Waukegan","State":"IL","Coal":689,"coordinates":[-87.8133,42.3833]},{"Plant":"Will County","State":"IL","Coal":761,"coordinates":[-88.0629,41.6334]},{"Plant":"Joppa Steam","State":"IL","Coal":948,"coordinates":[-88.8589,37.2094]},{"Plant":"Baldwin Energy Complex","State":"IL","Coal":1775,"coordinates":[-89.8544,38.205]},{"Plant":"Havana","State":"IL","Coal":428,"coordinates":[-90.08,40.2797]},{"Plant":"Hennepin Power Station","State":"IL","Coal":285,"coordinates":[-89.315,41.3028]},{"Plant":"Wood River","State":"IL","Coal":456,"coordinates":[-90.1347,38.8639]},{"Plant":"Dallman","State":"IL","Coal":534,"coordinates":[-89.6024,39.7548]},{"Plant":"Marion","State":"IL","Coal":290,"coordinates":[-88.9531,37.6197]},{"Plant":"Clifty Creek","State":"IN","Coal":1173,"coordinates":[-85.4206,38.7378]},{"Plant":"Tanners Creek","State":"IN","Coal":990,"coordinates":[-84.8594,39.0814]},{"Plant":"Harding Street","State":"IN","Coal":618,"coordinates":[-86.1969,39.7113]},{"Plant":"Eagle Valley","State":"IN","Coal":257,"coordinates":[-86.4183,39.4852]},{"Plant":"AES Petersburg","State":"IN","Coal":1701.5,"coordinates":[-87.2525,38.5281]},{"Plant":"Bailly","State":"IN","Coal":480,"coordinates":[-87.1225,41.645]},{"Plant":"Michigan City","State":"IN","Coal":469,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Coal":497,"coordinates":[-87.7811,32.6017]},{"Plant":"Cayuga","State":"IN","Coal":995,"coordinates":[-87.4244,39.9242]},{"Plant":"RED-Rochester, LLC","State":"NY","Coal":129.9,"coordinates":[-77.6319,43.1989]},{"Plant":"Edwardsport","State":"IN","Coal":571,"coordinates":[-87.2472,38.8067]},{"Plant":"Logan Generating Company LP","State":"NJ","Coal":219,"coordinates":[-75.4067,39.7928]},{"Plant":"Portsmouth Genco LLC","State":"VA","Coal":115,"coordinates":[-76.3529,36.8702]},{"Plant":"Taconite Harbor Energy Center","State":"MN","Coal":238.5,"coordinates":[-90.9114,47.5314]},{"Plant":"R Gallagher","State":"IN","Coal":280,"coordinates":[-85.8381,38.2636]},{"Plant":"Wabash River","State":"IN","Coal":668,"coordinates":[-87.4247,39.53]},{"Plant":"F B Culley","State":"IN","Coal":360,"coordinates":[-87.3275,37.9111]},{"Plant":"Colver Power Project","State":"PA","Coal":110,"coordinates":[-78.8,40.55]},{"Plant":"Edgecombe Genco LLC","State":"NC","Coal":115.6,"coordinates":[-77.7533,36.0373]},{"Plant":"Frank E Ratts","State":"IN","Coal":210,"coordinates":[-87.2662,38.5201]},{"Plant":"Lansing","State":"IA","Coal":249.4,"coordinates":[-91.1675,43.3359]},{"Plant":"Milton L Kapp","State":"IA","Coal":204.1,"coordinates":[-90.2336,41.8081]},{"Plant":"Chambers Cogeneration LP","State":"NJ","Coal":244,"coordinates":[-75.4858,39.6935]},{"Plant":"AES Shady Point LLC","State":"OK","Coal":320,"coordinates":[-94.6458,35.1931]},{"Plant":"Cedar Bay Generating Company LP","State":"FL","Coal":250,"coordinates":[-81.6064,30.4225]},{"Plant":"AES Hawaii","State":"HI","Coal":180,"coordinates":[-158.1065,21.3034]},{"Plant":"AES Beaver Valley Partners Beaver Valley","State":"PA","Coal":146,"coordinates":[-80.3539,40.6572]},{"Plant":"AES Warrior Run Cogeneration Facility","State":"MD","Coal":180,"coordinates":[-78.7453,39.5952]},{"Plant":"Prairie Creek","State":"IA","Coal":164.2,"coordinates":[-91.6392,41.944]},{"Plant":"Holcomb","State":"KS","Coal":358.8,"coordinates":[-100.9725,37.9308]},{"Plant":"Riverside","State":"IA","Coal":125,"coordinates":[-90.4481,41.54]},{"Plant":"Walter Scott Jr Energy Center","State":"IA","Coal":1635.5,"coordinates":[-95.8408,41.18]},{"Plant":"Silver Bay Power","State":"MN","Coal":105,"coordinates":[-91.2605,47.2866]},{"Plant":"Archer Daniels Midland Clinton","State":"IA","Coal":180,"coordinates":[-90.2097,41.8206]},{"Plant":"Archer Daniels Midland Cedar Rapids","State":"IA","Coal":260,"coordinates":[-91.6875,41.9221]},{"Plant":"Archer Daniels Midland Decatur","State":"IL","Coal":335,"coordinates":[-88.8908,39.8701]},{"Plant":"George Neal North","State":"IA","Coal":918.7,"coordinates":[-96.3617,42.2998]},{"Plant":"Burlington","State":"IA","Coal":210,"coordinates":[-91.1167,40.7412]},{"Plant":"Ames Electric Services Power Plant","State":"IA","Coal":105.4,"coordinates":[-93.6089,42.0258]},{"Plant":"Cholla","State":"AZ","Coal":1027,"coordinates":[-110.3033,34.9394]},{"Plant":"Muscatine Plant #1","State":"IA","Coal":230.7,"coordinates":[-91.0569,41.3917]},{"Plant":"La Cygne","State":"KS","Coal":1415.3,"coordinates":[-94.6456,38.3481]},{"Plant":"Lawrence Energy Center","State":"KS","Coal":530,"coordinates":[-95.2692,39.0072]},{"Plant":"Tecumseh Energy Center","State":"KS","Coal":202,"coordinates":[-95.5689,39.0539]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Coal":156,"coordinates":[-110.9047,32.16]},{"Plant":"Oklaunion","State":"TX","Coal":650,"coordinates":[-99.1753,34.0825]},{"Plant":"Quindaro","State":"KS","Coal":207,"coordinates":[-94.6381,39.1492]},{"Plant":"Cross","State":"SC","Coal":2350,"coordinates":[-80.1119,33.3692]},{"Plant":"Big Sandy","State":"KY","Coal":1060,"coordinates":[-82.6176,38.1707]},{"Plant":"E W Brown","State":"KY","Coal":684,"coordinates":[-84.7126,37.7883]},{"Plant":"Ghent","State":"KY","Coal":1928,"coordinates":[-85.035,38.7497]},{"Plant":"Green River","State":"KY","Coal":161,"coordinates":[-87.1214,37.3636]},{"Plant":"Seminole","State":"FL","Coal":1309,"coordinates":[-81.6328,29.7331]},{"Plant":"Cane Run","State":"KY","Coal":563,"coordinates":[-85.8892,38.1831]},{"Plant":"Mill Creek","State":"KY","Coal":1472,"coordinates":[-85.9103,38.0525]},{"Plant":"Elmer Smith","State":"KY","Coal":398.7,"coordinates":[-87.0608,37.7942]},{"Plant":"Paradise","State":"KY","Coal":2201,"coordinates":[-86.9783,37.2608]},{"Plant":"Shawnee","State":"KY","Coal":1206,"coordinates":[-88.775,37.1517]},{"Plant":"Kenneth C Coleman","State":"KY","Coal":443,"coordinates":[-86.7911,37.9631]},{"Plant":"HMP&L Station Two Henderson","State":"KY","Coal":312,"coordinates":[-87.5028,37.6469]},{"Plant":"Cooper","State":"KY","Coal":341,"coordinates":[-84.5919,36.9981]},{"Plant":"Dale","State":"KY","Coal":195,"coordinates":[-84.2619,37.8806]},{"Plant":"R S Nelson","State":"LA","Coal":537.1,"coordinates":[-93.2911,30.2844]},{"Plant":"C P Crane","State":"MD","Coal":385,"coordinates":[-76.3651,39.3236]},{"Plant":"Herbert A Wagner","State":"MD","Coal":440,"coordinates":[-76.5268,39.1781]},{"Plant":"Chalk Point LLC","State":"MD","Coal":667,"coordinates":[-76.6861,38.5444]},{"Plant":"Dickerson","State":"MD","Coal":519,"coordinates":[-77.4644,39.2097]},{"Plant":"Morgantown Generating Plant","State":"MD","Coal":1205,"coordinates":[-76.9767,38.3592]},{"Plant":"Apache Station","State":"AZ","Coal":350,"coordinates":[-109.8931,32.0603]},{"Plant":"Brayton Point","State":"MA","Coal":1071,"coordinates":[-71.1931,41.7103]},{"Plant":"GRDA","State":"OK","Coal":990,"coordinates":[-95.2894,36.1903]},{"Plant":"B C Cobb","State":"MI","Coal":312,"coordinates":[-86.2423,43.2588]},{"Plant":"Dan E Karn","State":"MI","Coal":510,"coordinates":[-83.8401,43.645]},{"Plant":"J H Campbell","State":"MI","Coal":1408,"coordinates":[-86.2007,42.9103]},{"Plant":"J C Weadock","State":"MI","Coal":303,"coordinates":[-83.8447,43.6399]},{"Plant":"J R Whiting","State":"MI","Coal":319,"coordinates":[-83.4495,41.7921]},{"Plant":"Monroe","State":"MI","Coal":3066,"coordinates":[-83.3464,41.8906]},{"Plant":"River Rouge","State":"MI","Coal":523,"coordinates":[-83.1119,42.2739]},{"Plant":"St Clair","State":"MI","Coal":1367,"coordinates":[-82.4719,42.7642]},{"Plant":"Trenton Channel","State":"MI","Coal":730,"coordinates":[-83.1808,42.1217]},{"Plant":"Presque Isle","State":"MI","Coal":344,"coordinates":[-87.395,46.5789]},{"Plant":"Eckert Station","State":"MI","Coal":253.4,"coordinates":[-84.5581,42.7184]},{"Plant":"Erickson Station","State":"MI","Coal":154.5,"coordinates":[-84.6572,42.6922]},{"Plant":"Clay Boswell","State":"MN","Coal":1081.6,"coordinates":[-93.6528,47.2611]},{"Plant":"Black Dog","State":"MN","Coal":219,"coordinates":[-93.2501,44.8108]},{"Plant":"Allen S King","State":"MN","Coal":511,"coordinates":[-92.7786,45.03]},{"Plant":"Hoot Lake","State":"MN","Coal":138,"coordinates":[-96.0433,46.2906]},{"Plant":"Jack Watson","State":"MS","Coal":706,"coordinates":[-89.0286,30.4392]},{"Plant":"St Johns River Power Park","State":"FL","Coal":1252,"coordinates":[-81.5508,30.4308]},{"Plant":"Asbury","State":"MO","Coal":189,"coordinates":[-94.5893,37.3613]},{"Plant":"Hawthorn","State":"MO","Coal":564,"coordinates":[-94.4778,39.1306]},{"Plant":"Montrose","State":"MO","Coal":510,"coordinates":[-93.9348,38.3114]},{"Plant":"Sibley","State":"MO","Coal":461,"coordinates":[-94.1844,39.1783]},{"Plant":"Labadie","State":"MO","Coal":2371,"coordinates":[-90.8377,38.5622]},{"Plant":"Meramec","State":"MO","Coal":834,"coordinates":[-90.3358,38.4017]},{"Plant":"Sioux","State":"MO","Coal":974,"coordinates":[-90.2902,38.9155]},{"Plant":"James River Power Station","State":"MO","Coal":236,"coordinates":[-93.2619,37.1086]},{"Plant":"New Madrid","State":"MO","Coal":1154,"coordinates":[-89.5617,36.5147]},{"Plant":"Thomas Hill","State":"MO","Coal":1133,"coordinates":[-92.6381,39.5522]},{"Plant":"J E Corette Plant","State":"MT","Coal":130,"coordinates":[-108.481,45.7756]},{"Plant":"Lon Wright","State":"NE","Coal":120,"coordinates":[-96.4623,41.4281]},{"Plant":"Sheldon","State":"NE","Coal":215,"coordinates":[-96.7847,40.5589]},{"Plant":"North Omaha","State":"NE","Coal":641.5,"coordinates":[-95.9447,41.3291]},{"Plant":"Reid Gardner","State":"NV","Coal":257,"coordinates":[-114.6333,36.6573]},{"Plant":"Merrimack","State":"NH","Coal":438.5,"coordinates":[-71.4692,43.1411]},{"Plant":"B L England","State":"NJ","Coal":155,"coordinates":[-74.6364,39.2908]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Coal":620,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Mercer Generating Station","State":"NJ","Coal":632,"coordinates":[-74.7339,40.1792]},{"Plant":"Four Corners","State":"NM","Coal":1540,"coordinates":[-108.4814,36.69]},{"Plant":"San Juan","State":"NM","Coal":1684,"coordinates":[-108.4386,36.8006]},{"Plant":"Danskammer Generating Station","State":"NY","Coal":369.5,"coordinates":[-73.975,41.5712]},{"Plant":"GMMGreenidge LLC","State":"NY","Coal":107.5,"coordinates":[-76.9483,42.6789]},{"Plant":"Cayuga Operating Company","State":"NY","Coal":306.5,"coordinates":[-76.6336,42.6028]},{"Plant":"C R Huntley Generating Station","State":"NY","Coal":380,"coordinates":[-78.93,42.97]},{"Plant":"Dunkirk Generating Plant","State":"NY","Coal":520,"coordinates":[-79.3466,42.4915]},{"Plant":"E C Gaston","State":"AL","Coal":1862,"coordinates":[-86.4581,33.2442]},{"Plant":"Asheville","State":"NC","Coal":376,"coordinates":[-82.5417,35.4731]},{"Plant":"Roxboro","State":"NC","Coal":2439,"coordinates":[-79.0731,36.4833]},{"Plant":"G G Allen","State":"NC","Coal":1127,"coordinates":[-81.0122,35.1897]},{"Plant":"Cliffside","State":"NC","Coal":1396,"coordinates":[-81.7594,35.22]},{"Plant":"Marshall","State":"NC","Coal":2078,"coordinates":[-80.9658,35.5975]},{"Plant":"R M Heskett","State":"ND","Coal":104.3,"coordinates":[-100.8836,46.8669]},{"Plant":"Leland Olds","State":"ND","Coal":667,"coordinates":[-101.3212,47.2808]},{"Plant":"Milton R Young","State":"ND","Coal":684,"coordinates":[-101.2131,47.0659]},{"Plant":"Stanton","State":"ND","Coal":188.5,"coordinates":[-101.3319,47.2866]},{"Plant":"Cardinal","State":"OH","Coal":1800,"coordinates":[-80.6486,40.2522]},{"Plant":"Miami Fort","State":"OH","Coal":1183,"coordinates":[-84.8036,39.1128]},{"Plant":"FirstEnergy Ashtabula","State":"OH","Coal":244,"coordinates":[-80.7697,41.9086]},{"Plant":"Avon Lake","State":"OH","Coal":710,"coordinates":[-82.0546,41.5045]},{"Plant":"FirstEnergy Eastlake","State":"OH","Coal":396,"coordinates":[-81.4425,41.6711]},{"Plant":"FirstEnergy Lake Shore","State":"OH","Coal":245,"coordinates":[-81.6419,41.5356]},{"Plant":"Conesville","State":"OH","Coal":1530,"coordinates":[-81.8811,40.1842]},{"Plant":"O H Hutchings","State":"OH","Coal":302,"coordinates":[-84.2921,39.6088]},{"Plant":"J M Stuart","State":"OH","Coal":2308,"coordinates":[-83.6939,38.6361]},{"Plant":"FirstEnergy W H Sammis","State":"OH","Coal":2210,"coordinates":[-80.6319,40.5317]},{"Plant":"Muskingum River","State":"OH","Coal":1375,"coordinates":[-81.6797,39.5908]},{"Plant":"Kyger Creek","State":"OH","Coal":962.8,"coordinates":[-82.1289,38.9144]},{"Plant":"Muskogee","State":"OK","Coal":1475,"coordinates":[-95.2873,35.7614]},{"Plant":"Northeastern","State":"OK","Coal":920,"coordinates":[-95.7008,36.4317]},{"Plant":"Limestone","State":"TX","Coal":1689,"coordinates":[-96.2525,31.4219]},{"Plant":"Barry","State":"AL","Coal":1612.5,"coordinates":[-88.0103,31.0069]},{"Plant":"Portland","State":"PA","Coal":377,"coordinates":[-75.0794,40.9102]},{"Plant":"Conemaugh","State":"PA","Coal":1700,"coordinates":[-79.0611,40.3842]},{"Plant":"Homer City Generating Station","State":"PA","Coal":1897.4,"coordinates":[-79.1961,40.5128]},{"Plant":"Seward","State":"PA","Coal":521,"coordinates":[-79.0337,40.4062]},{"Plant":"Shawville","State":"PA","Coal":565,"coordinates":[-78.3662,41.0675]},{"Plant":"Keystone","State":"PA","Coal":1700,"coordinates":[-79.3411,40.6604]},{"Plant":"New Castle Plant","State":"PA","Coal":305,"coordinates":[-80.369,40.9379]},{"Plant":"Brunner Island","State":"PA","Coal":1411,"coordinates":[-76.6962,40.0961]},{"Plant":"PPL Montour","State":"PA","Coal":1515,"coordinates":[-76.6672,41.0714]},{"Plant":"McMeekin","State":"SC","Coal":250,"coordinates":[-81.2172,34.0556]},{"Plant":"Wateree","State":"SC","Coal":684,"coordinates":[-80.6228,33.8264]},{"Plant":"Williams","State":"SC","Coal":605,"coordinates":[-79.9297,33.0158]},{"Plant":"Allen Steam Plant","State":"TN","Coal":741,"coordinates":[-90.1487,35.0741]},{"Plant":"Bull Run","State":"TN","Coal":870,"coordinates":[-84.1567,36.0211]},{"Plant":"Cumberland","State":"TN","Coal":2470,"coordinates":[-87.6539,36.3903]},{"Plant":"Gallatin","State":"TN","Coal":976,"coordinates":[-86.4006,36.3156]},{"Plant":"Johnsonville","State":"TN","Coal":1206,"coordinates":[-87.9861,36.0278]},{"Plant":"Kingston","State":"TN","Coal":1398,"coordinates":[-84.5194,35.8992]},{"Plant":"W A Parish","State":"TX","Coal":2499,"coordinates":[-95.6311,29.4828]},{"Plant":"Big Brown","State":"TX","Coal":1195,"coordinates":[-96.0544,31.8206]},{"Plant":"Carbon","State":"UT","Coal":172,"coordinates":[-110.8644,39.7272]},{"Plant":"Clinch River","State":"VA","Coal":690,"coordinates":[-82.1997,36.9333]},{"Plant":"Glen Lyn","State":"VA","Coal":325,"coordinates":[-80.8633,37.3706]},{"Plant":"Chesterfield","State":"VA","Coal":1253,"coordinates":[-77.3833,37.3822]},{"Plant":"Chesapeake","State":"VA","Coal":595,"coordinates":[-76.3019,36.7711]},{"Plant":"Yorktown","State":"VA","Coal":323,"coordinates":[-76.4611,37.2144]},{"Plant":"Joliet 29","State":"IL","Coal":1036,"coordinates":[-88.1238,41.4946]},{"Plant":"Transalta Centralia Generation","State":"WA","Coal":1340,"coordinates":[-122.8598,46.7559]},{"Plant":"John E Amos","State":"WV","Coal":2900,"coordinates":[-81.8233,38.4731]},{"Plant":"Kanawha River","State":"WV","Coal":400,"coordinates":[-81.4211,38.2056]},{"Plant":"Philip Sporn","State":"WV","Coal":580,"coordinates":[-81.9231,38.9669]},{"Plant":"FirstEnergy Fort Martin Power Station","State":"WV","Coal":1098,"coordinates":[-79.9275,39.7108]},{"Plant":"FirstEnergy Harrison Power Station","State":"WV","Coal":1954,"coordinates":[-80.3325,39.3842]},{"Plant":"Kammer","State":"WV","Coal":600,"coordinates":[-80.8186,39.8461]},{"Plant":"Mitchell","State":"WV","Coal":1560,"coordinates":[-80.8153,39.8297]},{"Plant":"Mt Storm","State":"WV","Coal":1629,"coordinates":[-79.2636,39.2008]},{"Plant":"South Oak Creek","State":"WI","Coal":993,"coordinates":[-87.8294,42.8457]},{"Plant":"Valley","State":"WI","Coal":236,"coordinates":[-87.9233,43.0303]},{"Plant":"Edgewater","State":"WI","Coal":741.9,"coordinates":[-87.7059,43.7151]},{"Plant":"Nelson Dewey Coal Refining Facility","State":"WI","Coal":209.1,"coordinates":[-91.0085,42.7225]},{"Plant":"Pulliam","State":"WI","Coal":328.1,"coordinates":[-88.0086,44.54]},{"Plant":"Weston","State":"WI","Coal":991.4,"coordinates":[-89.6553,44.8606]},{"Plant":"Genoa","State":"WI","Coal":301,"coordinates":[-91.2325,43.5589]},{"Plant":"Dave Johnston","State":"WY","Coal":760,"coordinates":[-105.7769,42.8378]},{"Plant":"Naughton","State":"WY","Coal":687,"coordinates":[-110.5983,41.7581]},{"Plant":"John P Madgett","State":"WI","Coal":391.8,"coordinates":[-91.9126,44.3036]},{"Plant":"Cherokee","State":"CO","Coal":504,"coordinates":[-104.9645,39.8073]},{"Plant":"Colbert","State":"AL","Coal":1184,"coordinates":[-87.8486,34.7439]},{"Plant":"Comanche","State":"CO","Coal":1410,"coordinates":[-104.5747,38.2081]},{"Plant":"Valmont","State":"CO","Coal":184,"coordinates":[-105.202,40.0195]},{"Plant":"Martin Drake","State":"CO","Coal":254,"coordinates":[-104.8333,38.8244]},{"Plant":"Navajo","State":"AZ","Coal":2250,"coordinates":[-111.3886,36.9047]},{"Plant":"Widows Creek","State":"AL","Coal":938,"coordinates":[-85.7553,34.883]},{"Plant":"Tennessee Eastman Operations","State":"TN","Coal":176.3,"coordinates":[-82.5431,36.5219]},{"Plant":"Axiall Natrium Plant","State":"WV","Coal":123,"coordinates":[-80.8547,39.7475]},{"Plant":"Northampton Generating Company LP","State":"PA","Coal":112,"coordinates":[-75.4792,40.6917]},{"Plant":"Indiantown Cogeneration LP","State":"FL","Coal":330,"coordinates":[-80.5125,27.0389]},{"Plant":"Dolet Hills","State":"LA","Coal":642.4,"coordinates":[-93.5692,32.0306]},{"Plant":"Mecklenburg Power Station","State":"VA","Coal":138,"coordinates":[-78.53,36.6]},{"Plant":"Sandow No 5","State":"TX","Coal":600,"coordinates":[-97.0614,30.5681]},{"Plant":"Hayden","State":"CO","Coal":446,"coordinates":[-107.185,40.4856]},{"Plant":"Roanoke Valley Energy Facililty I","State":"NC","Coal":165,"coordinates":[-77.6167,36.4364]},{"Plant":"Spruance Genco LLC","State":"VA","Coal":190,"coordinates":[-77.4308,37.4556]},{"Plant":"Birchwood Power","State":"VA","Coal":238.2,"coordinates":[-77.3147,38.2667]},{"Plant":"Red Hills Generating Facility","State":"MS","Coal":440,"coordinates":[-89.2183,33.3761]},{"Plant":"Hardin Generator Project","State":"MT","Coal":107,"coordinates":[-107.6,45.7578]},{"Plant":"Prairie State Generating Station","State":"IL","Coal":1628,"coordinates":[-89.6669,38.2792]},{"Plant":"Charles R Lowman","State":"AL","Coal":556,"coordinates":[-87.9107,31.488]},{"Plant":"Elm Road Generating Station","State":"WI","Coal":1268,"coordinates":[-87.8336,42.8492]},{"Plant":"Kennecott Power Plant","State":"UT","Coal":175,"coordinates":[-112.1225,40.7119]},{"Plant":"TS Power Plant","State":"NV","Coal":218.4,"coordinates":[-116.5297,40.7461]},{"Plant":"Stanton Energy Center","State":"FL","Coal":896,"coordinates":[-81.1678,28.4822]},{"Plant":"Plum Point Energy Station","State":"AR","Coal":670,"coordinates":[-89.9489,35.6644]},{"Plant":"John W Turk Jr Power Plant","State":"AR","Coal":609,"coordinates":[-93.8119,33.6497]},{"Plant":"Dry Fork Station","State":"WY","Coal":380,"coordinates":[-105.4608,44.3889]},{"Plant":"Sandy Creek Energy Station","State":"TX","Coal":936.5,"coordinates":[-96.9571,31.4744]},{"Plant":"Longview Power LLC","State":"WV","Coal":700,"coordinates":[-79.959,39.7079]},{"Plant":"Bridgeport Station","State":"CT","Coal":383.4,"coordinates":[-73.1844,41.1706]},{"Plant":"Virginia City Hybrid Energy Center","State":"VA","Coal":610,"coordinates":[-82.3381,36.9164]},{"Plant":"Indian River Generating Station","State":"DE","Coal":410,"coordinates":[-75.2341,38.5857]},{"Plant":"Whelan Energy Center","State":"NE","Coal":309,"coordinates":[-98.3124,40.5809]},{"Plant":"James H Miller Jr","State":"AL","Coal":2725.9,"coordinates":[-87.0597,33.6319]},{"Plant":"FirstEnergy Pleasants Power Station","State":"WV","Coal":1288,"coordinates":[-81.2944,39.3667]},{"Plant":"White Bluff","State":"AR","Coal":1637,"coordinates":[-92.1406,34.4228]},{"Plant":"Duck Creek","State":"IL","Coal":410,"coordinates":[-89.9841,40.4663]},{"Plant":"Newton","State":"IL","Coal":1195,"coordinates":[-88.2781,38.9361]},{"Plant":"East Bend","State":"KY","Coal":600,"coordinates":[-84.8514,38.9036]},{"Plant":"W H Zimmer","State":"OH","Coal":1344,"coordinates":[-84.2289,38.8675]},{"Plant":"Brandon Shores","State":"MD","Coal":1273,"coordinates":[-76.5389,39.18]},{"Plant":"Craig","State":"CO","Coal":1304,"coordinates":[-107.5912,40.4627]},{"Plant":"Coal Creek","State":"ND","Coal":1142.5,"coordinates":[-101.1571,47.3777]},{"Plant":"Killen Station","State":"OH","Coal":600,"coordinates":[-83.4803,38.6903]},{"Plant":"Belle River","State":"MI","Coal":1270,"coordinates":[-82.495,42.7756]},{"Plant":"H L Spurlock","State":"KY","Coal":1346,"coordinates":[-83.8181,38.7]},{"Plant":"Wansley","State":"GA","Coal":1744,"coordinates":[-85.0323,33.4134]},{"Plant":"Big Cajun 2","State":"LA","Coal":1743,"coordinates":[-91.3692,30.7261]},{"Plant":"R D Morrow","State":"MS","Coal":360,"coordinates":[-89.394,31.2186]},{"Plant":"Nearman Creek","State":"KS","Coal":229,"coordinates":[-94.6975,39.1681]},{"Plant":"Iatan","State":"MO","Coal":1594.4,"coordinates":[-94.98,39.4472]},{"Plant":"Jeffrey Energy Center","State":"KS","Coal":2155,"coordinates":[-96.1172,39.2865]},{"Plant":"Trimble County","State":"KY","Coal":1243,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Coal":1020,"coordinates":[-88.5553,30.5322]},{"Plant":"Colstrip","State":"MT","Coal":2094,"coordinates":[-106.614,45.8831]},{"Plant":"Gerald Gentleman","State":"NE","Coal":1365,"coordinates":[-101.1408,41.0808]},{"Plant":"Somerset Operating Co LLC","State":"NY","Coal":685.5,"coordinates":[-78.6047,43.3589]},{"Plant":"R M Schahfer","State":"IN","Coal":1625,"coordinates":[-87.0261,41.2164]},{"Plant":"Sherburne County","State":"MN","Coal":2222,"coordinates":[-93.8931,45.3808]},{"Plant":"FirstEnergy Bruce Mansfield","State":"PA","Coal":2510,"coordinates":[-80.4159,40.6348]},{"Plant":"Sooner","State":"OK","Coal":1040.5,"coordinates":[-97.0528,36.4531]},{"Plant":"Nebraska City","State":"NE","Coal":1343.5,"coordinates":[-95.7764,40.6214]},{"Plant":"Big Stone","State":"SD","Coal":475,"coordinates":[-96.5101,45.3037]},{"Plant":"Wyodak","State":"WY","Coal":332,"coordinates":[-105.3815,44.2901]},{"Plant":"Boardman","State":"OR","Coal":585,"coordinates":[-119.8088,45.6932]},{"Plant":"Gibson","State":"IN","Coal":3132,"coordinates":[-87.7658,38.3722]},{"Plant":"McIntosh","State":"GA","Coal":138.5,"coordinates":[-81.1683,32.3563]},{"Plant":"Gibbons Creek","State":"TX","Coal":470,"coordinates":[-96.0818,30.6199]},{"Plant":"A B Brown","State":"IN","Coal":490,"coordinates":[-87.715,37.9053]},{"Plant":"Flint Creek","State":"AR","Coal":528,"coordinates":[-94.5241,36.2561]},{"Plant":"Welsh","State":"TX","Coal":1584,"coordinates":[-94.84,33.0552]},{"Plant":"Martin Lake","State":"TX","Coal":2410,"coordinates":[-94.5706,32.2606]},{"Plant":"Monticello","State":"TX","Coal":1865,"coordinates":[-95.0417,33.0917]},{"Plant":"Rush Island","State":"MO","Coal":1182,"coordinates":[-90.2632,38.1312]},{"Plant":"Hunter","State":"UT","Coal":1361,"coordinates":[-111.0289,39.1747]},{"Plant":"Rockport","State":"IN","Coal":2600,"coordinates":[-87.0372,37.9256]},{"Plant":"Pleasant Prairie","State":"WI","Coal":1188,"coordinates":[-87.9033,42.5381]},{"Plant":"Coronado","State":"AZ","Coal":762,"coordinates":[-109.2708,34.5789]},{"Plant":"Coleto Creek","State":"TX","Coal":635,"coordinates":[-97.2142,28.7128]},{"Plant":"Fayette Power Project","State":"TX","Coal":1641,"coordinates":[-96.7506,29.9172]},{"Plant":"Oak Grove","State":"TX","Coal":1665,"coordinates":[-96.4866,31.1803]},{"Plant":"J T Deely","State":"TX","Coal":840,"coordinates":[-98.3228,29.3081]},{"Plant":"San Miguel","State":"TX","Coal":391,"coordinates":[-98.4775,28.7044]},{"Plant":"Brame Energy Center","State":"LA","Coal":496.1,"coordinates":[-92.7167,31.395]},{"Plant":"Harrington","State":"TX","Coal":1018,"coordinates":[-101.7472,35.2982]},{"Plant":"Tolk","State":"TX","Coal":1067,"coordinates":[-102.57,34.1865]},{"Plant":"John Twitty Energy Center","State":"MO","Coal":459,"coordinates":[-93.388,37.1517]},{"Plant":"Laramie River Station","State":"WY","Coal":1710,"coordinates":[-104.8825,42.1089]},{"Plant":"Merom","State":"IN","Coal":982,"coordinates":[-87.5108,39.0694]},{"Plant":"Pawnee","State":"CO","Coal":505,"coordinates":[-103.6803,40.2217]},{"Plant":"Winyah","State":"SC","Coal":1130,"coordinates":[-79.3581,33.3317]},{"Plant":"Mayo","State":"NC","Coal":727,"coordinates":[-78.8917,36.5278]},{"Plant":"Ottumwa","State":"IA","Coal":746.3,"coordinates":[-92.5558,41.0961]},{"Plant":"Scherer","State":"GA","Coal":3389,"coordinates":[-83.8075,33.0606]},{"Plant":"Mountaineer","State":"WV","Coal":1299,"coordinates":[-81.9344,38.9794]},{"Plant":"Crystal River","State":"FL","Coal":2291,"coordinates":[-82.6977,28.9656]},{"Plant":"Crist","State":"FL","Coal":924,"coordinates":[-87.2244,30.5661]},{"Plant":"Lansing Smith","State":"FL","Coal":357,"coordinates":[-85.7003,30.2686]},{"Plant":"Big Bend","State":"FL","Coal":1602,"coordinates":[-82.4036,27.7944]},{"Plant":"Antelope Valley","State":"ND","Coal":900,"coordinates":[-101.3194,47.2819]},{"Plant":"Intermountain Power Project","State":"UT","Coal":1800,"coordinates":[-112.5802,39.5097]},{"Plant":"Deerhaven Generating Station","State":"FL","Coal":232,"coordinates":[-82.3878,29.7592]},{"Plant":"R D Green","State":"KY","Coal":454,"coordinates":[-87.5,37.6461]},{"Plant":"Independence","State":"AR","Coal":1680.5,"coordinates":[-91.4088,35.6784]},{"Plant":"Sandow No 4","State":"TX","Coal":600,"coordinates":[-97.064,30.5659]},{"Plant":"Louisa","State":"IA","Coal":746.2,"coordinates":[-91.0931,41.3181]},{"Plant":"Warrick","State":"IN","Coal":759,"coordinates":[-87.3328,37.915]},{"Plant":"C D McIntosh Jr","State":"FL","Coal":342,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Coal":280,"coordinates":[-105.0212,40.8609]},{"Plant":"Sikeston Power Station","State":"MO","Coal":233,"coordinates":[-89.6209,36.8791]},{"Plant":"Hugo","State":"OK","Coal":440,"coordinates":[-95.3206,34.0158]},{"Plant":"D B Wilson","State":"KY","Coal":417,"coordinates":[-87.0806,37.4497]},{"Plant":"Gadsden","State":"AL","Coal":130,"coordinates":[-85.9708,34.0128]},{"Plant":"Bowen","State":"GA","Coal":3202,"coordinates":[-84.9222,34.1256]},{"Plant":"Major Oak Power","State":"TX","Coal":305,"coordinates":[-96.695,31.0919]},{"Plant":"Hammond","State":"GA","Coal":840,"coordinates":[-85.3456,34.2528]},{"Plant":"Harllee Branch","State":"GA","Coal":1264,"coordinates":[-83.2983,33.195]},{"Plant":"J K Spruce","State":"TX","Coal":1340,"coordinates":[-98.3203,29.3097]},{"Plant":"Cope","State":"SC","Coal":415,"coordinates":[-81.03,33.3644]},{"Plant":"Clover","State":"VA","Coal":877,"coordinates":[-78.704,36.869]},{"Plant":"Polk","State":"FL","Coal":220,"coordinates":[-81.9897,27.7286]},{"Plant":"Mitchell","State":"GA","Coal":155,"coordinates":[-84.1347,31.4447]},{"Plant":"Yates","State":"GA","Coal":1286,"coordinates":[-84.8986,33.4622]},{"Plant":"Kraft","State":"GA","Coal":201,"coordinates":[-81.1458,32.1486]},{"Plant":"George Neal South","State":"IA","Coal":644,"coordinates":[-96.3617,42.3006]},{"Plant":"Bonanza","State":"UT","Coal":458,"coordinates":[-109.2844,40.0864]},{"Plant":"Pirkey","State":"TX","Coal":721,"coordinates":[-94.4852,32.4607]},{"Plant":"Gorgas","State":"AL","Coal":1241,"coordinates":[-87.1965,33.6443]},{"Plant":"Columbia","State":"WI","Coal":1110,"coordinates":[-89.4203,43.4864]},{"Plant":"Belews Creek","State":"NC","Coal":2220,"coordinates":[-80.0603,36.2811]},{"Plant":"Jim Bridger","State":"WY","Coal":2111,"coordinates":[-108.7875,41.7378]},{"Plant":"Huntington","State":"UT","Coal":909,"coordinates":[-111.0781,39.3792]},{"Plant":"General James M Gavin","State":"OH","Coal":2598,"coordinates":[-82.1158,38.9347]},{"Plant":"Ray D Nixon","State":"CO","Coal":208,"coordinates":[-104.7058,38.6335]},{"Plant":"Coyote","State":"ND","Coal":427,"coordinates":[-101.8157,47.2214]},{"Plant":"Springerville","State":"AZ","Coal":1625,"coordinates":[-109.1639,34.3186]},{"Plant":"North Valmy","State":"NV","Coal":522,"coordinates":[-117.1516,40.8813]},{"Plant":"Cheswick Power Plant","State":"PA","Coal":563,"coordinates":[-79.7906,40.5383]},{"Plant":"E D Edwards","State":"IL","Coal":650,"coordinates":[-89.6631,40.5958]},{"Plant":"Coffeen","State":"IL","Coal":895,"coordinates":[-89.4031,39.0586]},{"Plant":"Escalante","State":"NM","Coal":247,"coordinates":[-108.082,35.4159]},{"Plant":"Joliet 9","State":"IL","Coal":314,"coordinates":[-88.1153,41.4931]},{"Plant":"Kincaid Generation LLC","State":"IL","Coal":1158,"coordinates":[-89.4964,39.5906]},{"Plant":"Powerton","State":"IL","Coal":1538,"coordinates":[-89.6786,40.5408]},{"Plant":"Waukegan","State":"IL","Coal":689,"coordinates":[-87.8133,42.3833]},{"Plant":"Will County","State":"IL","Coal":510,"coordinates":[-88.0629,41.6334]},{"Plant":"Joppa Steam","State":"IL","Coal":948,"coordinates":[-88.8589,37.2094]},{"Plant":"Baldwin Energy Complex","State":"IL","Coal":1778,"coordinates":[-89.8544,38.205]},{"Plant":"Havana","State":"IL","Coal":431,"coordinates":[-90.08,40.2797]},{"Plant":"Hennepin Power Station","State":"IL","Coal":284,"coordinates":[-89.315,41.3028]},{"Plant":"Wood River","State":"IL","Coal":465,"coordinates":[-90.1347,38.8639]},{"Plant":"Dallman","State":"IL","Coal":534,"coordinates":[-89.6024,39.7548]},{"Plant":"Marion","State":"IL","Coal":290,"coordinates":[-88.9531,37.6197]},{"Plant":"Clifty Creek","State":"IN","Coal":1173,"coordinates":[-85.4206,38.7378]},{"Plant":"Tanners Creek","State":"IN","Coal":990,"coordinates":[-84.8594,39.0814]},{"Plant":"Harding Street","State":"IN","Coal":618,"coordinates":[-86.1969,39.7113]},{"Plant":"Eagle Valley","State":"IN","Coal":257,"coordinates":[-86.4183,39.4852]},{"Plant":"AES Petersburg","State":"IN","Coal":1701.5,"coordinates":[-87.2525,38.5281]},{"Plant":"Bailly","State":"IN","Coal":480,"coordinates":[-87.1225,41.645]},{"Plant":"Michigan City","State":"IN","Coal":469,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Coal":497,"coordinates":[-87.7811,32.6017]},{"Plant":"Cayuga","State":"IN","Coal":995,"coordinates":[-87.4244,39.9242]},{"Plant":"RED-Rochester, LLC","State":"NY","Coal":132.1,"coordinates":[-77.6319,43.1989]},{"Plant":"Edwardsport","State":"IN","Coal":595,"coordinates":[-87.2472,38.8067]},{"Plant":"Logan Generating Company LP","State":"NJ","Coal":219,"coordinates":[-75.4067,39.7928]},{"Plant":"Portsmouth Genco LLC","State":"VA","Coal":115,"coordinates":[-76.3529,36.8702]},{"Plant":"Taconite Harbor Energy Center","State":"MN","Coal":154.9,"coordinates":[-90.9114,47.5314]},{"Plant":"R Gallagher","State":"IN","Coal":280,"coordinates":[-85.8381,38.2636]},{"Plant":"Wabash River","State":"IN","Coal":668,"coordinates":[-87.4247,39.53]},{"Plant":"F B Culley","State":"IN","Coal":360,"coordinates":[-87.3275,37.9111]},{"Plant":"Colver Power Project","State":"PA","Coal":110,"coordinates":[-78.8,40.55]},{"Plant":"Edgecombe Genco LLC","State":"NC","Coal":115.6,"coordinates":[-77.7533,36.0373]},{"Plant":"Lansing","State":"IA","Coal":252.3,"coordinates":[-91.1675,43.3359]},{"Plant":"Milton L Kapp","State":"IA","Coal":102.4,"coordinates":[-90.2336,41.8081]},{"Plant":"Chambers Cogeneration LP","State":"NJ","Coal":244,"coordinates":[-75.4858,39.6935]},{"Plant":"AES Shady Point LLC","State":"OK","Coal":320,"coordinates":[-94.6458,35.1931]},{"Plant":"Cedar Bay Generating Company LP","State":"FL","Coal":250,"coordinates":[-81.6064,30.4225]},{"Plant":"AES Hawaii","State":"HI","Coal":180,"coordinates":[-158.1065,21.3034]},{"Plant":"AES Warrior Run Cogeneration Facility","State":"MD","Coal":180,"coordinates":[-78.7453,39.5952]},{"Plant":"Prairie Creek","State":"IA","Coal":162.6,"coordinates":[-91.6392,41.944]},{"Plant":"Holcomb","State":"KS","Coal":358.8,"coordinates":[-100.9725,37.9308]},{"Plant":"Walter Scott Jr Energy Center","State":"IA","Coal":1517.3,"coordinates":[-95.8408,41.18]},{"Plant":"Silver Bay Power","State":"MN","Coal":105,"coordinates":[-91.2605,47.2866]},{"Plant":"Archer Daniels Midland Clinton","State":"IA","Coal":180,"coordinates":[-90.2097,41.8206]},{"Plant":"Archer Daniels Midland Cedar Rapids","State":"IA","Coal":260,"coordinates":[-91.6875,41.9221]},{"Plant":"Archer Daniels Midland Decatur","State":"IL","Coal":335,"coordinates":[-88.8908,39.8701]},{"Plant":"George Neal North","State":"IA","Coal":918,"coordinates":[-96.3617,42.2998]},{"Plant":"Burlington","State":"IA","Coal":212.9,"coordinates":[-91.1167,40.7412]},{"Plant":"Ames Electric Services Power Plant","State":"IA","Coal":105.4,"coordinates":[-93.6089,42.0258]},{"Plant":"Cholla","State":"AZ","Coal":767,"coordinates":[-110.3033,34.9394]},{"Plant":"Muscatine Plant #1","State":"IA","Coal":231.3,"coordinates":[-91.0569,41.3917]},{"Plant":"La Cygne","State":"KS","Coal":1398.4,"coordinates":[-94.6456,38.3481]},{"Plant":"Lawrence Energy Center","State":"KS","Coal":474,"coordinates":[-95.2692,39.0072]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Coal":156,"coordinates":[-110.9047,32.16]},{"Plant":"Oklaunion","State":"TX","Coal":650,"coordinates":[-99.1753,34.0825]},{"Plant":"Cross","State":"SC","Coal":2350,"coordinates":[-80.1119,33.3692]},{"Plant":"Big Sandy","State":"KY","Coal":260,"coordinates":[-82.6176,38.1707]},{"Plant":"E W Brown","State":"KY","Coal":682,"coordinates":[-84.7126,37.7883]},{"Plant":"Ghent","State":"KY","Coal":1919,"coordinates":[-85.035,38.7497]},{"Plant":"Seminole","State":"FL","Coal":1309,"coordinates":[-81.6328,29.7331]},{"Plant":"Mill Creek","State":"KY","Coal":1465,"coordinates":[-85.9103,38.0525]},{"Plant":"Elmer Smith","State":"KY","Coal":398.7,"coordinates":[-87.0608,37.7942]},{"Plant":"Paradise","State":"KY","Coal":2201,"coordinates":[-86.9783,37.2608]},{"Plant":"Shawnee","State":"KY","Coal":1206,"coordinates":[-88.775,37.1517]},{"Plant":"Kenneth C Coleman","State":"KY","Coal":443,"coordinates":[-86.7911,37.9631]},{"Plant":"HMP&L Station Two Henderson","State":"KY","Coal":312,"coordinates":[-87.5028,37.6469]},{"Plant":"Cooper","State":"KY","Coal":341,"coordinates":[-84.5919,36.9981]},{"Plant":"Dale","State":"KY","Coal":149,"coordinates":[-84.2619,37.8806]},{"Plant":"R S Nelson","State":"LA","Coal":550,"coordinates":[-93.2911,30.2844]},{"Plant":"C P Crane","State":"MD","Coal":385,"coordinates":[-76.3651,39.3236]},{"Plant":"Herbert A Wagner","State":"MD","Coal":423,"coordinates":[-76.5268,39.1781]},{"Plant":"Chalk Point LLC","State":"MD","Coal":667,"coordinates":[-76.6861,38.5444]},{"Plant":"Dickerson","State":"MD","Coal":519,"coordinates":[-77.4644,39.2097]},{"Plant":"Morgantown Generating Plant","State":"MD","Coal":1205,"coordinates":[-76.9767,38.3592]},{"Plant":"Apache Station","State":"AZ","Coal":350,"coordinates":[-109.8931,32.0603]},{"Plant":"Brayton Point","State":"MA","Coal":1071,"coordinates":[-71.1931,41.7103]},{"Plant":"GRDA","State":"OK","Coal":1010,"coordinates":[-95.2894,36.1903]},{"Plant":"B C Cobb","State":"MI","Coal":312,"coordinates":[-86.2423,43.2588]},{"Plant":"Dan E Karn","State":"MI","Coal":498,"coordinates":[-83.8401,43.645]},{"Plant":"J H Campbell","State":"MI","Coal":1419,"coordinates":[-86.2007,42.9103]},{"Plant":"J C Weadock","State":"MI","Coal":303,"coordinates":[-83.8447,43.6399]},{"Plant":"J R Whiting","State":"MI","Coal":319,"coordinates":[-83.4495,41.7921]},{"Plant":"Monroe","State":"MI","Coal":3066,"coordinates":[-83.3464,41.8906]},{"Plant":"River Rouge","State":"MI","Coal":523,"coordinates":[-83.1119,42.2739]},{"Plant":"St Clair","State":"MI","Coal":1367,"coordinates":[-82.4719,42.7642]},{"Plant":"Trenton Channel","State":"MI","Coal":630,"coordinates":[-83.1808,42.1217]},{"Plant":"Presque Isle","State":"MI","Coal":344,"coordinates":[-87.395,46.5789]},{"Plant":"Eckert Station","State":"MI","Coal":253.4,"coordinates":[-84.5581,42.7184]},{"Plant":"Erickson Station","State":"MI","Coal":154.5,"coordinates":[-84.6572,42.6922]},{"Plant":"Clay Boswell","State":"MN","Coal":1081.6,"coordinates":[-93.6528,47.2611]},{"Plant":"Allen S King","State":"MN","Coal":511,"coordinates":[-92.7786,45.03]},{"Plant":"Hoot Lake","State":"MN","Coal":138,"coordinates":[-96.0433,46.2906]},{"Plant":"St Johns River Power Park","State":"FL","Coal":1252,"coordinates":[-81.5508,30.4308]},{"Plant":"Asbury","State":"MO","Coal":198,"coordinates":[-94.5893,37.3613]},{"Plant":"Hawthorn","State":"MO","Coal":564,"coordinates":[-94.4778,39.1306]},{"Plant":"Montrose","State":"MO","Coal":510,"coordinates":[-93.9348,38.3114]},{"Plant":"Sibley","State":"MO","Coal":461,"coordinates":[-94.1844,39.1783]},{"Plant":"Labadie","State":"MO","Coal":2372,"coordinates":[-90.8377,38.5622]},{"Plant":"Meramec","State":"MO","Coal":833,"coordinates":[-90.3358,38.4017]},{"Plant":"Sioux","State":"MO","Coal":972,"coordinates":[-90.2902,38.9155]},{"Plant":"James River Power Station","State":"MO","Coal":236,"coordinates":[-93.2619,37.1086]},{"Plant":"New Madrid","State":"MO","Coal":1154,"coordinates":[-89.5617,36.5147]},{"Plant":"Thomas Hill","State":"MO","Coal":1133,"coordinates":[-92.6381,39.5522]},{"Plant":"Lon Wright","State":"NE","Coal":120,"coordinates":[-96.4623,41.4281]},{"Plant":"Sheldon","State":"NE","Coal":215,"coordinates":[-96.7847,40.5589]},{"Plant":"North Omaha","State":"NE","Coal":513,"coordinates":[-95.9447,41.3291]},{"Plant":"Reid Gardner","State":"NV","Coal":257,"coordinates":[-114.6333,36.6573]},{"Plant":"Merrimack","State":"NH","Coal":438.5,"coordinates":[-71.4692,43.1411]},{"Plant":"B L England","State":"NJ","Coal":150,"coordinates":[-74.6364,39.2908]},{"Plant":"PSEG Mercer Generating Station","State":"NJ","Coal":632,"coordinates":[-74.7339,40.1792]},{"Plant":"Four Corners","State":"NM","Coal":1540,"coordinates":[-108.4814,36.69]},{"Plant":"San Juan","State":"NM","Coal":1684,"coordinates":[-108.4386,36.8006]},{"Plant":"GMMGreenidge LLC","State":"NY","Coal":107.5,"coordinates":[-76.9483,42.6789]},{"Plant":"Cayuga Operating Company","State":"NY","Coal":304.7,"coordinates":[-76.6336,42.6028]},{"Plant":"C R Huntley Generating Station","State":"NY","Coal":380,"coordinates":[-78.93,42.97]},{"Plant":"Dunkirk Generating Plant","State":"NY","Coal":520,"coordinates":[-79.3466,42.4915]},{"Plant":"E C Gaston","State":"AL","Coal":1606,"coordinates":[-86.4581,33.2442]},{"Plant":"Asheville","State":"NC","Coal":378,"coordinates":[-82.5417,35.4731]},{"Plant":"Roxboro","State":"NC","Coal":2439,"coordinates":[-79.0731,36.4833]},{"Plant":"G G Allen","State":"NC","Coal":1127,"coordinates":[-81.0122,35.1897]},{"Plant":"Cliffside","State":"NC","Coal":1396,"coordinates":[-81.7594,35.22]},{"Plant":"Marshall","State":"NC","Coal":2078,"coordinates":[-80.9658,35.5975]},{"Plant":"R M Heskett","State":"ND","Coal":104.3,"coordinates":[-100.8836,46.8669]},{"Plant":"Leland Olds","State":"ND","Coal":667,"coordinates":[-101.3212,47.2808]},{"Plant":"Milton R Young","State":"ND","Coal":684,"coordinates":[-101.2131,47.0659]},{"Plant":"Stanton","State":"ND","Coal":188.1,"coordinates":[-101.3319,47.2866]},{"Plant":"Cardinal","State":"OH","Coal":1800,"coordinates":[-80.6486,40.2522]},{"Plant":"Miami Fort","State":"OH","Coal":1020,"coordinates":[-84.8036,39.1128]},{"Plant":"Avon Lake","State":"OH","Coal":710,"coordinates":[-82.0546,41.5045]},{"Plant":"Conesville","State":"OH","Coal":1530,"coordinates":[-81.8811,40.1842]},{"Plant":"J M Stuart","State":"OH","Coal":2308,"coordinates":[-83.6939,38.6361]},{"Plant":"FirstEnergy W H Sammis","State":"OH","Coal":2210,"coordinates":[-80.6319,40.5317]},{"Plant":"Kyger Creek","State":"OH","Coal":962.8,"coordinates":[-82.1289,38.9144]},{"Plant":"Muskogee","State":"OK","Coal":1509.5,"coordinates":[-95.2873,35.7614]},{"Plant":"Northeastern","State":"OK","Coal":920,"coordinates":[-95.7008,36.4317]},{"Plant":"Limestone","State":"TX","Coal":1689,"coordinates":[-96.2525,31.4219]},{"Plant":"Barry","State":"AL","Coal":1088.5,"coordinates":[-88.0103,31.0069]},{"Plant":"Conemaugh","State":"PA","Coal":1700,"coordinates":[-79.0611,40.3842]},{"Plant":"Homer City Generating Station","State":"PA","Coal":1892.5,"coordinates":[-79.1961,40.5128]},{"Plant":"Seward","State":"PA","Coal":521,"coordinates":[-79.0337,40.4062]},{"Plant":"Shawville","State":"PA","Coal":565,"coordinates":[-78.3662,41.0675]},{"Plant":"Keystone","State":"PA","Coal":1700,"coordinates":[-79.3411,40.6604]},{"Plant":"New Castle Plant","State":"PA","Coal":305,"coordinates":[-80.369,40.9379]},{"Plant":"Brunner Island","State":"PA","Coal":1411,"coordinates":[-76.6962,40.0961]},{"Plant":"PPL Montour","State":"PA","Coal":1515,"coordinates":[-76.6672,41.0714]},{"Plant":"McMeekin","State":"SC","Coal":250,"coordinates":[-81.2172,34.0556]},{"Plant":"Wateree","State":"SC","Coal":684,"coordinates":[-80.6228,33.8264]},{"Plant":"Williams","State":"SC","Coal":605,"coordinates":[-79.9297,33.0158]},{"Plant":"Allen Steam Plant","State":"TN","Coal":741,"coordinates":[-90.1487,35.0741]},{"Plant":"Bull Run","State":"TN","Coal":870,"coordinates":[-84.1567,36.0211]},{"Plant":"Cumberland","State":"TN","Coal":2470,"coordinates":[-87.6539,36.3903]},{"Plant":"Gallatin","State":"TN","Coal":976,"coordinates":[-86.4006,36.3156]},{"Plant":"Johnsonville","State":"TN","Coal":428,"coordinates":[-87.9861,36.0278]},{"Plant":"Kingston","State":"TN","Coal":1398,"coordinates":[-84.5194,35.8992]},{"Plant":"W A Parish","State":"TX","Coal":2499,"coordinates":[-95.6311,29.4828]},{"Plant":"Big Brown","State":"TX","Coal":1208,"coordinates":[-96.0544,31.8206]},{"Plant":"Clinch River","State":"VA","Coal":460,"coordinates":[-82.1997,36.9333]},{"Plant":"Chesterfield","State":"VA","Coal":1266,"coordinates":[-77.3833,37.3822]},{"Plant":"Yorktown","State":"VA","Coal":323,"coordinates":[-76.4611,37.2144]},{"Plant":"Joliet 29","State":"IL","Coal":1036,"coordinates":[-88.1238,41.4946]},{"Plant":"Transalta Centralia Generation","State":"WA","Coal":1340,"coordinates":[-122.8598,46.7559]},{"Plant":"John E Amos","State":"WV","Coal":2900,"coordinates":[-81.8233,38.4731]},{"Plant":"Kanawha River","State":"WV","Coal":400,"coordinates":[-81.4211,38.2056]},{"Plant":"FirstEnergy Fort Martin Power Station","State":"WV","Coal":1098,"coordinates":[-79.9275,39.7108]},{"Plant":"FirstEnergy Harrison Power Station","State":"WV","Coal":1954,"coordinates":[-80.3325,39.3842]},{"Plant":"Mitchell","State":"WV","Coal":1560,"coordinates":[-80.8153,39.8297]},{"Plant":"Mt Storm","State":"WV","Coal":1629,"coordinates":[-79.2636,39.2008]},{"Plant":"South Oak Creek","State":"WI","Coal":993,"coordinates":[-87.8294,42.8457]},{"Plant":"Valley","State":"WI","Coal":120,"coordinates":[-87.9233,43.0303]},{"Plant":"Edgewater","State":"WI","Coal":700.6,"coordinates":[-87.7059,43.7151]},{"Plant":"Pulliam","State":"WI","Coal":211.6,"coordinates":[-88.0086,44.54]},{"Plant":"Weston","State":"WI","Coal":930.7,"coordinates":[-89.6553,44.8606]},{"Plant":"Genoa","State":"WI","Coal":298.6,"coordinates":[-91.2325,43.5589]},{"Plant":"Dave Johnston","State":"WY","Coal":760,"coordinates":[-105.7769,42.8378]},{"Plant":"Naughton","State":"WY","Coal":687,"coordinates":[-110.5983,41.7581]},{"Plant":"John P Madgett","State":"WI","Coal":387.7,"coordinates":[-91.9126,44.3036]},{"Plant":"Cherokee","State":"CO","Coal":352,"coordinates":[-104.9645,39.8073]},{"Plant":"Colbert","State":"AL","Coal":1184,"coordinates":[-87.8486,34.7439]},{"Plant":"Comanche","State":"CO","Coal":1410,"coordinates":[-104.5747,38.2081]},{"Plant":"Valmont","State":"CO","Coal":184,"coordinates":[-105.202,40.0195]},{"Plant":"Martin Drake","State":"CO","Coal":254,"coordinates":[-104.8333,38.8244]},{"Plant":"Navajo","State":"AZ","Coal":2250,"coordinates":[-111.3886,36.9047]},{"Plant":"Tennessee Eastman Operations","State":"TN","Coal":194.3,"coordinates":[-82.5431,36.5219]},{"Plant":"Axiall Natrium Plant","State":"WV","Coal":123,"coordinates":[-80.8547,39.7475]},{"Plant":"Northampton Generating Company LP","State":"PA","Coal":112,"coordinates":[-75.4792,40.6917]},{"Plant":"Indiantown Cogeneration LP","State":"FL","Coal":330,"coordinates":[-80.5125,27.0389]},{"Plant":"Dolet Hills","State":"LA","Coal":641,"coordinates":[-93.5692,32.0306]},{"Plant":"Mecklenburg Power Station","State":"VA","Coal":138,"coordinates":[-78.53,36.6]},{"Plant":"Sandow No 5","State":"TX","Coal":600,"coordinates":[-97.0614,30.5681]},{"Plant":"Hayden","State":"CO","Coal":446,"coordinates":[-107.185,40.4856]},{"Plant":"Roanoke Valley Energy Facililty I","State":"NC","Coal":165,"coordinates":[-77.6167,36.4364]},{"Plant":"Spruance Genco LLC","State":"VA","Coal":190,"coordinates":[-77.4308,37.4556]},{"Plant":"Birchwood Power","State":"VA","Coal":239.8,"coordinates":[-77.3147,38.2667]},{"Plant":"Red Hills Generating Facility","State":"MS","Coal":440,"coordinates":[-89.2183,33.3761]},{"Plant":"Hardin Generator Project","State":"MT","Coal":107,"coordinates":[-107.6,45.7578]},{"Plant":"Prairie State Generating Station","State":"IL","Coal":1628,"coordinates":[-89.6669,38.2792]},{"Plant":"Charles R Lowman","State":"AL","Coal":556,"coordinates":[-87.9107,31.488]},{"Plant":"Elm Road Generating Station","State":"WI","Coal":1268,"coordinates":[-87.8336,42.8492]},{"Plant":"Kennecott Power Plant","State":"UT","Coal":175,"coordinates":[-112.1225,40.7119]},{"Plant":"TS Power Plant","State":"NV","Coal":218.4,"coordinates":[-116.5297,40.7461]},{"Plant":"Stanton Energy Center","State":"FL","Coal":896,"coordinates":[-81.1678,28.4822]},{"Plant":"Plum Point Energy Station","State":"AR","Coal":670,"coordinates":[-89.9489,35.6644]},{"Plant":"John W Turk Jr Power Plant","State":"AR","Coal":609,"coordinates":[-93.8119,33.6497]},{"Plant":"Dry Fork Station","State":"WY","Coal":380,"coordinates":[-105.4608,44.3889]},{"Plant":"Sandy Creek Energy Station","State":"TX","Coal":936.5,"coordinates":[-96.9571,31.4744]},{"Plant":"Longview Power LLC","State":"WV","Coal":700,"coordinates":[-79.959,39.7079]},{"Plant":"Bridgeport Station","State":"CT","Coal":383.4,"coordinates":[-73.1844,41.1706]},{"Plant":"Virginia City Hybrid Energy Center","State":"VA","Coal":610,"coordinates":[-82.3381,36.9164]},{"Plant":"Indian River Generating Station","State":"DE","Coal":410,"coordinates":[-75.2341,38.5857]},{"Plant":"Whelan Energy Center","State":"NE","Coal":309,"coordinates":[-98.3124,40.5809]},{"Plant":"James H Miller Jr","State":"AL","Coal":2725.9,"coordinates":[-87.0597,33.6319]},{"Plant":"FirstEnergy Pleasants Power Station","State":"WV","Coal":1288,"coordinates":[-81.2944,39.3667]},{"Plant":"White Bluff","State":"AR","Coal":1634.9,"coordinates":[-92.1406,34.4228]},{"Plant":"Duck Creek","State":"IL","Coal":410,"coordinates":[-89.9841,40.4663]},{"Plant":"Newton","State":"IL","Coal":1195,"coordinates":[-88.2781,38.9361]},{"Plant":"East Bend","State":"KY","Coal":600,"coordinates":[-84.8514,38.9036]},{"Plant":"W H Zimmer","State":"OH","Coal":1344,"coordinates":[-84.2289,38.8675]},{"Plant":"Brandon Shores","State":"MD","Coal":1273,"coordinates":[-76.5389,39.18]},{"Plant":"Craig","State":"CO","Coal":1304,"coordinates":[-107.5912,40.4627]},{"Plant":"Coal Creek","State":"ND","Coal":1141.2,"coordinates":[-101.1571,47.3777]},{"Plant":"Killen Station","State":"OH","Coal":600,"coordinates":[-83.4803,38.6903]},{"Plant":"Belle River","State":"MI","Coal":1270,"coordinates":[-82.495,42.7756]},{"Plant":"H L Spurlock","State":"KY","Coal":1346,"coordinates":[-83.8181,38.7]},{"Plant":"Wansley","State":"GA","Coal":1744,"coordinates":[-85.0323,33.4134]},{"Plant":"Big Cajun 2","State":"LA","Coal":1168,"coordinates":[-91.3692,30.7261]},{"Plant":"R D Morrow","State":"MS","Coal":360,"coordinates":[-89.394,31.2186]},{"Plant":"Nearman Creek","State":"KS","Coal":229,"coordinates":[-94.6975,39.1681]},{"Plant":"Iatan","State":"MO","Coal":1594.4,"coordinates":[-94.98,39.4472]},{"Plant":"Jeffrey Energy Center","State":"KS","Coal":2155,"coordinates":[-96.1172,39.2865]},{"Plant":"Trimble County","State":"KY","Coal":1243,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Coal":1020,"coordinates":[-88.5553,30.5322]},{"Plant":"Colstrip","State":"MT","Coal":2094,"coordinates":[-106.614,45.8831]},{"Plant":"Gerald Gentleman","State":"NE","Coal":1365,"coordinates":[-101.1408,41.0808]},{"Plant":"Somerset Operating Co LLC","State":"NY","Coal":685.3,"coordinates":[-78.6047,43.3589]},{"Plant":"R M Schahfer","State":"IN","Coal":1625,"coordinates":[-87.0261,41.2164]},{"Plant":"Sherburne County","State":"MN","Coal":2238,"coordinates":[-93.8931,45.3808]},{"Plant":"FirstEnergy Bruce Mansfield","State":"PA","Coal":2510,"coordinates":[-80.4159,40.6348]},{"Plant":"Sooner","State":"OK","Coal":1041,"coordinates":[-97.0528,36.4531]},{"Plant":"Nebraska City","State":"NE","Coal":1320.1,"coordinates":[-95.7764,40.6214]},{"Plant":"Big Stone","State":"SD","Coal":475,"coordinates":[-96.5101,45.3037]},{"Plant":"Wyodak","State":"WY","Coal":332,"coordinates":[-105.3815,44.2901]},{"Plant":"Boardman","State":"OR","Coal":585,"coordinates":[-119.8088,45.6932]},{"Plant":"Gibson","State":"IN","Coal":3132,"coordinates":[-87.7658,38.3722]},{"Plant":"McIntosh","State":"GA","Coal":138.5,"coordinates":[-81.1683,32.3563]},{"Plant":"Gibbons Creek","State":"TX","Coal":470,"coordinates":[-96.0818,30.6199]},{"Plant":"A B Brown","State":"IN","Coal":490,"coordinates":[-87.715,37.9053]},{"Plant":"Flint Creek","State":"AR","Coal":528,"coordinates":[-94.5241,36.2561]},{"Plant":"Welsh","State":"TX","Coal":1584,"coordinates":[-94.84,33.0552]},{"Plant":"Martin Lake","State":"TX","Coal":2410,"coordinates":[-94.5706,32.2606]},{"Plant":"Monticello","State":"TX","Coal":1865,"coordinates":[-95.0417,33.0917]},{"Plant":"Rush Island","State":"MO","Coal":1180,"coordinates":[-90.2632,38.1312]},{"Plant":"Hunter","State":"UT","Coal":1361,"coordinates":[-111.0289,39.1747]},{"Plant":"Rockport","State":"IN","Coal":2600,"coordinates":[-87.0372,37.9256]},{"Plant":"Pleasant Prairie","State":"WI","Coal":1188,"coordinates":[-87.9033,42.5381]},{"Plant":"Coronado","State":"AZ","Coal":762,"coordinates":[-109.2708,34.5789]},{"Plant":"Coleto Creek","State":"TX","Coal":635,"coordinates":[-97.2142,28.7128]},{"Plant":"Fayette Power Project","State":"TX","Coal":1615,"coordinates":[-96.7506,29.9172]},{"Plant":"Oak Grove","State":"TX","Coal":1665,"coordinates":[-96.4866,31.1803]},{"Plant":"J T Deely","State":"TX","Coal":840,"coordinates":[-98.3228,29.3081]},{"Plant":"San Miguel","State":"TX","Coal":391,"coordinates":[-98.4775,28.7044]},{"Plant":"Brame Energy Center","State":"LA","Coal":496.1,"coordinates":[-92.7167,31.395]},{"Plant":"Harrington","State":"TX","Coal":1018,"coordinates":[-101.7472,35.2982]},{"Plant":"Tolk","State":"TX","Coal":1067,"coordinates":[-102.57,34.1865]},{"Plant":"John Twitty Energy Center","State":"MO","Coal":459,"coordinates":[-93.388,37.1517]},{"Plant":"Laramie River Station","State":"WY","Coal":1710,"coordinates":[-104.8825,42.1089]},{"Plant":"Merom","State":"IN","Coal":983,"coordinates":[-87.5108,39.0694]},{"Plant":"Pawnee","State":"CO","Coal":505,"coordinates":[-103.6803,40.2217]},{"Plant":"Winyah","State":"SC","Coal":1130,"coordinates":[-79.3581,33.3317]},{"Plant":"Mayo","State":"NC","Coal":727,"coordinates":[-78.8917,36.5278]},{"Plant":"Ottumwa","State":"IA","Coal":730,"coordinates":[-92.5558,41.0961]},{"Plant":"Scherer","State":"GA","Coal":3389,"coordinates":[-83.8075,33.0606]},{"Plant":"Mountaineer","State":"WV","Coal":1299,"coordinates":[-81.9344,38.9794]},{"Plant":"Crystal River","State":"FL","Coal":2291,"coordinates":[-82.6977,28.9656]},{"Plant":"Crist","State":"FL","Coal":924,"coordinates":[-87.2244,30.5661]},{"Plant":"Lansing Smith","State":"FL","Coal":357,"coordinates":[-85.7003,30.2686]},{"Plant":"Big Bend","State":"FL","Coal":1602,"coordinates":[-82.4036,27.7944]},{"Plant":"Antelope Valley","State":"ND","Coal":900,"coordinates":[-101.3194,47.2819]},{"Plant":"Intermountain Power Project","State":"UT","Coal":1800,"coordinates":[-112.5802,39.5097]},{"Plant":"Deerhaven Generating Station","State":"FL","Coal":232,"coordinates":[-82.3878,29.7592]},{"Plant":"R D Green","State":"KY","Coal":454,"coordinates":[-87.5,37.6461]},{"Plant":"Independence","State":"AR","Coal":1680.5,"coordinates":[-91.4088,35.6784]},{"Plant":"Sandow No 4","State":"TX","Coal":600,"coordinates":[-97.064,30.5659]},{"Plant":"Louisa","State":"IA","Coal":746.2,"coordinates":[-91.0931,41.3181]},{"Plant":"Northside Generating Station","State":"FL","Coal":586,"coordinates":[-81.5525,30.4172]},{"Plant":"Warrick","State":"IN","Coal":754,"coordinates":[-87.3328,37.915]},{"Plant":"C D McIntosh Jr","State":"FL","Coal":342,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Coal":280,"coordinates":[-105.0212,40.8609]},{"Plant":"Sikeston Power Station","State":"MO","Coal":240,"coordinates":[-89.6209,36.8791]},{"Plant":"Hugo","State":"OK","Coal":440,"coordinates":[-95.3206,34.0158]},{"Plant":"D B Wilson","State":"KY","Coal":417,"coordinates":[-87.0806,37.4497]},{"Plant":"Bowen","State":"GA","Coal":3232,"coordinates":[-84.9222,34.1256]},{"Plant":"Major Oak Power","State":"TX","Coal":305,"coordinates":[-96.695,31.0919]},{"Plant":"Hammond","State":"GA","Coal":840,"coordinates":[-85.3456,34.2528]},{"Plant":"J K Spruce","State":"TX","Coal":1348,"coordinates":[-98.3203,29.3097]},{"Plant":"Cope","State":"SC","Coal":415,"coordinates":[-81.03,33.3644]},{"Plant":"Clover","State":"VA","Coal":877,"coordinates":[-78.704,36.869]},{"Plant":"Polk","State":"FL","Coal":220,"coordinates":[-81.9897,27.7286]},{"Plant":"Mitchell","State":"GA","Coal":155,"coordinates":[-84.1347,31.4447]},{"Plant":"George Neal South","State":"IA","Coal":644,"coordinates":[-96.3617,42.3006]},{"Plant":"Bonanza","State":"UT","Coal":458,"coordinates":[-109.2844,40.0864]},{"Plant":"Pirkey","State":"TX","Coal":721,"coordinates":[-94.4852,32.4607]},{"Plant":"Gorgas","State":"AL","Coal":1034,"coordinates":[-87.1965,33.6443]},{"Plant":"Columbia","State":"WI","Coal":1114.9,"coordinates":[-89.4203,43.4864]},{"Plant":"Belews Creek","State":"NC","Coal":2220,"coordinates":[-80.0603,36.2811]},{"Plant":"Jim Bridger","State":"WY","Coal":2111,"coordinates":[-108.7875,41.7378]},{"Plant":"Huntington","State":"UT","Coal":909,"coordinates":[-111.0781,39.3792]},{"Plant":"General James M Gavin","State":"OH","Coal":2598,"coordinates":[-82.1158,38.9347]},{"Plant":"Ray D Nixon","State":"CO","Coal":208,"coordinates":[-104.7058,38.6335]},{"Plant":"Coyote","State":"ND","Coal":427,"coordinates":[-101.8157,47.2214]},{"Plant":"Springerville","State":"AZ","Coal":1625,"coordinates":[-109.1639,34.3186]},{"Plant":"North Valmy","State":"NV","Coal":522,"coordinates":[-117.1516,40.8813]},{"Plant":"Cheswick Power Plant","State":"PA","Coal":563,"coordinates":[-79.7906,40.5383]},{"Plant":"E D Edwards","State":"IL","Coal":555,"coordinates":[-89.6631,40.5958]},{"Plant":"Coffeen","State":"IL","Coal":895,"coordinates":[-89.4031,39.0586]},{"Plant":"Escalante","State":"NM","Coal":247,"coordinates":[-108.082,35.4159]},{"Plant":"Joliet 9","State":"IL","Coal":314,"coordinates":[-88.1153,41.4931]},{"Plant":"Kincaid Generation LLC","State":"IL","Coal":1158,"coordinates":[-89.4964,39.5906]},{"Plant":"Powerton","State":"IL","Coal":1538,"coordinates":[-89.6786,40.5408]},{"Plant":"Waukegan","State":"IL","Coal":689,"coordinates":[-87.8133,42.3833]},{"Plant":"Will County","State":"IL","Coal":510,"coordinates":[-88.0629,41.6334]},{"Plant":"Joppa Steam","State":"IL","Coal":948,"coordinates":[-88.8589,37.2094]},{"Plant":"Baldwin Energy Complex","State":"IL","Coal":1778,"coordinates":[-89.8544,38.205]},{"Plant":"Havana","State":"IL","Coal":431,"coordinates":[-90.08,40.2797]},{"Plant":"Hennepin Power Station","State":"IL","Coal":284,"coordinates":[-89.315,41.3028]},{"Plant":"Wood River","State":"IL","Coal":465,"coordinates":[-90.1347,38.8639]},{"Plant":"Dallman","State":"IL","Coal":534,"coordinates":[-89.6024,39.7548]},{"Plant":"Marion","State":"IL","Coal":290,"coordinates":[-88.9531,37.6197]},{"Plant":"Clifty Creek","State":"IN","Coal":1173,"coordinates":[-85.4206,38.7378]},{"Plant":"Harding Street","State":"IN","Coal":628,"coordinates":[-86.1969,39.7113]},{"Plant":"Eagle Valley","State":"IN","Coal":257,"coordinates":[-86.4183,39.4852]},{"Plant":"AES Petersburg","State":"IN","Coal":1701.5,"coordinates":[-87.2525,38.5281]},{"Plant":"Bailly","State":"IN","Coal":480,"coordinates":[-87.1225,41.645]},{"Plant":"Michigan City","State":"IN","Coal":469,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Cayuga","State":"IN","Coal":995,"coordinates":[-87.4244,39.9242]},{"Plant":"RED-Rochester, LLC","State":"NY","Coal":132.1,"coordinates":[-77.6319,43.1989]},{"Plant":"Edwardsport","State":"IN","Coal":595,"coordinates":[-87.2472,38.8067]},{"Plant":"Logan Generating Company LP","State":"NJ","Coal":219,"coordinates":[-75.4067,39.7928]},{"Plant":"Taconite Harbor Energy Center","State":"MN","Coal":154.9,"coordinates":[-90.9114,47.5314]},{"Plant":"R Gallagher","State":"IN","Coal":280,"coordinates":[-85.8381,38.2636]},{"Plant":"F B Culley","State":"IN","Coal":360,"coordinates":[-87.3275,37.9111]},{"Plant":"Colver Power Project","State":"PA","Coal":110,"coordinates":[-78.8,40.55]},{"Plant":"Edgecombe Genco LLC","State":"NC","Coal":115.6,"coordinates":[-77.7533,36.0373]},{"Plant":"Lansing","State":"IA","Coal":228.7,"coordinates":[-91.1675,43.3359]},{"Plant":"Chambers Cogeneration LP","State":"NJ","Coal":244,"coordinates":[-75.4858,39.6935]},{"Plant":"AES Shady Point LLC","State":"OK","Coal":320,"coordinates":[-94.6458,35.1931]},{"Plant":"AES Hawaii","State":"HI","Coal":180,"coordinates":[-158.1065,21.3034]},{"Plant":"AES Warrior Run Cogeneration Facility","State":"MD","Coal":180,"coordinates":[-78.7453,39.5952]},{"Plant":"Prairie Creek","State":"IA","Coal":163.1,"coordinates":[-91.6392,41.944]},{"Plant":"Holcomb","State":"KS","Coal":358.8,"coordinates":[-100.9725,37.9308]},{"Plant":"Walter Scott Jr Energy Center","State":"IA","Coal":1517.3,"coordinates":[-95.8408,41.18]},{"Plant":"Silver Bay Power","State":"MN","Coal":105,"coordinates":[-91.2605,47.2866]},{"Plant":"Archer Daniels Midland Clinton","State":"IA","Coal":180,"coordinates":[-90.2097,41.8206]},{"Plant":"Archer Daniels Midland Cedar Rapids","State":"IA","Coal":260,"coordinates":[-91.6875,41.9221]},{"Plant":"Archer Daniels Midland Decatur","State":"IL","Coal":335,"coordinates":[-88.8908,39.8701]},{"Plant":"George Neal North","State":"IA","Coal":510,"coordinates":[-96.3617,42.2998]},{"Plant":"Burlington","State":"IA","Coal":213.7,"coordinates":[-91.1167,40.7412]},{"Plant":"Cholla","State":"AZ","Coal":767,"coordinates":[-110.3033,34.9394]},{"Plant":"Muscatine Plant #1","State":"IA","Coal":222.7,"coordinates":[-91.0569,41.3917]},{"Plant":"La Cygne","State":"KS","Coal":1398.4,"coordinates":[-94.6456,38.3481]},{"Plant":"Lawrence Energy Center","State":"KS","Coal":474,"coordinates":[-95.2692,39.0072]},{"Plant":"Oklaunion","State":"TX","Coal":650,"coordinates":[-99.1753,34.0825]},{"Plant":"Cross","State":"SC","Coal":2350,"coordinates":[-80.1119,33.3692]},{"Plant":"E W Brown","State":"KY","Coal":681,"coordinates":[-84.7126,37.7883]},{"Plant":"Ghent","State":"KY","Coal":1919,"coordinates":[-85.035,38.7497]},{"Plant":"Seminole","State":"FL","Coal":1309,"coordinates":[-81.6328,29.7331]},{"Plant":"Mill Creek","State":"KY","Coal":1465,"coordinates":[-85.9103,38.0525]},{"Plant":"Elmer Smith","State":"KY","Coal":399.8,"coordinates":[-87.0608,37.7942]},{"Plant":"Paradise","State":"KY","Coal":2201,"coordinates":[-86.9783,37.2608]},{"Plant":"Shawnee","State":"KY","Coal":1206,"coordinates":[-88.775,37.1517]},{"Plant":"Kenneth C Coleman","State":"KY","Coal":443,"coordinates":[-86.7911,37.9631]},{"Plant":"HMP&L Station Two Henderson","State":"KY","Coal":312,"coordinates":[-87.5028,37.6469]},{"Plant":"Cooper","State":"KY","Coal":341,"coordinates":[-84.5919,36.9981]},{"Plant":"R S Nelson","State":"LA","Coal":550,"coordinates":[-93.2911,30.2844]},{"Plant":"C P Crane","State":"MD","Coal":385,"coordinates":[-76.3651,39.3236]},{"Plant":"Herbert A Wagner","State":"MD","Coal":423,"coordinates":[-76.5268,39.1781]},{"Plant":"Chalk Point LLC","State":"MD","Coal":667,"coordinates":[-76.6861,38.5444]},{"Plant":"Dickerson","State":"MD","Coal":519,"coordinates":[-77.4644,39.2097]},{"Plant":"Morgantown Generating Plant","State":"MD","Coal":1205,"coordinates":[-76.9767,38.3592]},{"Plant":"Apache Station","State":"AZ","Coal":350,"coordinates":[-109.8931,32.0603]},{"Plant":"Brayton Point","State":"MA","Coal":1038,"coordinates":[-71.1931,41.7103]},{"Plant":"GRDA","State":"OK","Coal":1010,"coordinates":[-95.2894,36.1903]},{"Plant":"Dan E Karn","State":"MI","Coal":515,"coordinates":[-83.8401,43.645]},{"Plant":"J H Campbell","State":"MI","Coal":1443,"coordinates":[-86.2007,42.9103]},{"Plant":"Monroe","State":"MI","Coal":3066,"coordinates":[-83.3464,41.8906]},{"Plant":"River Rouge","State":"MI","Coal":272,"coordinates":[-83.1119,42.2739]},{"Plant":"St Clair","State":"MI","Coal":1367,"coordinates":[-82.4719,42.7642]},{"Plant":"Trenton Channel","State":"MI","Coal":520,"coordinates":[-83.1808,42.1217]},{"Plant":"Presque Isle","State":"MI","Coal":359,"coordinates":[-87.395,46.5789]},{"Plant":"Eckert Station","State":"MI","Coal":189.9,"coordinates":[-84.5581,42.7184]},{"Plant":"Erickson Station","State":"MI","Coal":154.5,"coordinates":[-84.6572,42.6922]},{"Plant":"Clay Boswell","State":"MN","Coal":1082.5,"coordinates":[-93.6528,47.2611]},{"Plant":"Allen S King","State":"MN","Coal":511,"coordinates":[-92.7786,45.03]},{"Plant":"Hoot Lake","State":"MN","Coal":138,"coordinates":[-96.0433,46.2906]},{"Plant":"St Johns River Power Park","State":"FL","Coal":1252,"coordinates":[-81.5508,30.4308]},{"Plant":"Asbury","State":"MO","Coal":198,"coordinates":[-94.5893,37.3613]},{"Plant":"Hawthorn","State":"MO","Coal":564,"coordinates":[-94.4778,39.1306]},{"Plant":"Montrose","State":"MO","Coal":334,"coordinates":[-93.9348,38.3114]},{"Plant":"Sibley","State":"MO","Coal":448.4,"coordinates":[-94.1844,39.1783]},{"Plant":"Labadie","State":"MO","Coal":2372,"coordinates":[-90.8377,38.5622]},{"Plant":"Meramec","State":"MO","Coal":833,"coordinates":[-90.3358,38.4017]},{"Plant":"Sioux","State":"MO","Coal":972,"coordinates":[-90.2902,38.9155]},{"Plant":"New Madrid","State":"MO","Coal":1153,"coordinates":[-89.5617,36.5147]},{"Plant":"Thomas Hill","State":"MO","Coal":1138,"coordinates":[-92.6381,39.5522]},{"Plant":"Lon Wright","State":"NE","Coal":118.5,"coordinates":[-96.4623,41.4281]},{"Plant":"Sheldon","State":"NE","Coal":215,"coordinates":[-96.7847,40.5589]},{"Plant":"North Omaha","State":"NE","Coal":315.8,"coordinates":[-95.9447,41.3291]},{"Plant":"Reid Gardner","State":"NV","Coal":257,"coordinates":[-114.6333,36.6573]},{"Plant":"Merrimack","State":"NH","Coal":438.5,"coordinates":[-71.4692,43.1411]},{"Plant":"B L England","State":"NJ","Coal":150,"coordinates":[-74.6364,39.2908]},{"Plant":"PSEG Mercer Generating Station","State":"NJ","Coal":632,"coordinates":[-74.7339,40.1792]},{"Plant":"Four Corners","State":"NM","Coal":1540,"coordinates":[-108.4814,36.69]},{"Plant":"San Juan","State":"NM","Coal":1684,"coordinates":[-108.4386,36.8006]},{"Plant":"GMMGreenidge LLC","State":"NY","Coal":107.5,"coordinates":[-76.9483,42.6789]},{"Plant":"Cayuga Operating Company","State":"NY","Coal":302.2,"coordinates":[-76.6336,42.6028]},{"Plant":"Dunkirk Generating Plant","State":"NY","Coal":520,"coordinates":[-79.3466,42.4915]},{"Plant":"E C Gaston","State":"AL","Coal":832,"coordinates":[-86.4581,33.2442]},{"Plant":"Asheville","State":"NC","Coal":378,"coordinates":[-82.5417,35.4731]},{"Plant":"Roxboro","State":"NC","Coal":2439,"coordinates":[-79.0731,36.4833]},{"Plant":"G G Allen","State":"NC","Coal":1098,"coordinates":[-81.0122,35.1897]},{"Plant":"Cliffside","State":"NC","Coal":1388,"coordinates":[-81.7594,35.22]},{"Plant":"Marshall","State":"NC","Coal":2058,"coordinates":[-80.9658,35.5975]},{"Plant":"R M Heskett","State":"ND","Coal":104.3,"coordinates":[-100.8836,46.8669]},{"Plant":"Leland Olds","State":"ND","Coal":667,"coordinates":[-101.3212,47.2808]},{"Plant":"Milton R Young","State":"ND","Coal":684,"coordinates":[-101.2131,47.0659]},{"Plant":"Stanton","State":"ND","Coal":187.2,"coordinates":[-101.3319,47.2866]},{"Plant":"Cardinal","State":"OH","Coal":1800,"coordinates":[-80.6486,40.2522]},{"Plant":"Miami Fort","State":"OH","Coal":1020,"coordinates":[-84.8036,39.1128]},{"Plant":"Avon Lake","State":"OH","Coal":640,"coordinates":[-82.0546,41.5045]},{"Plant":"Conesville","State":"OH","Coal":1530,"coordinates":[-81.8811,40.1842]},{"Plant":"J M Stuart","State":"OH","Coal":2308,"coordinates":[-83.6939,38.6361]},{"Plant":"FirstEnergy W H Sammis","State":"OH","Coal":2210,"coordinates":[-80.6319,40.5317]},{"Plant":"Kyger Creek","State":"OH","Coal":962.8,"coordinates":[-82.1289,38.9144]},{"Plant":"Muskogee","State":"OK","Coal":1526.5,"coordinates":[-95.2873,35.7614]},{"Plant":"Northeastern","State":"OK","Coal":460,"coordinates":[-95.7008,36.4317]},{"Plant":"Limestone","State":"TX","Coal":1689,"coordinates":[-96.2525,31.4219]},{"Plant":"Barry","State":"AL","Coal":1100.5,"coordinates":[-88.0103,31.0069]},{"Plant":"Conemaugh","State":"PA","Coal":1700,"coordinates":[-79.0611,40.3842]},{"Plant":"Homer City Generating Station","State":"PA","Coal":1889.5,"coordinates":[-79.1961,40.5128]},{"Plant":"Seward","State":"PA","Coal":521,"coordinates":[-79.0337,40.4062]},{"Plant":"Keystone","State":"PA","Coal":1700,"coordinates":[-79.3411,40.6604]},{"Plant":"Brunner Island","State":"PA","Coal":1411,"coordinates":[-76.6962,40.0961]},{"Plant":"PPL Montour","State":"PA","Coal":1515,"coordinates":[-76.6672,41.0714]},{"Plant":"Wateree","State":"SC","Coal":684,"coordinates":[-80.6228,33.8264]},{"Plant":"Williams","State":"SC","Coal":605,"coordinates":[-79.9297,33.0158]},{"Plant":"Allen Steam Plant","State":"TN","Coal":741,"coordinates":[-90.1487,35.0741]},{"Plant":"Bull Run","State":"TN","Coal":870,"coordinates":[-84.1567,36.0211]},{"Plant":"Cumberland","State":"TN","Coal":2470,"coordinates":[-87.6539,36.3903]},{"Plant":"Gallatin","State":"TN","Coal":976,"coordinates":[-86.4006,36.3156]},{"Plant":"Johnsonville","State":"TN","Coal":428,"coordinates":[-87.9861,36.0278]},{"Plant":"Kingston","State":"TN","Coal":1398,"coordinates":[-84.5194,35.8992]},{"Plant":"W A Parish","State":"TX","Coal":2499,"coordinates":[-95.6311,29.4828]},{"Plant":"Big Brown","State":"TX","Coal":1208,"coordinates":[-96.0544,31.8206]},{"Plant":"Chesterfield","State":"VA","Coal":1266,"coordinates":[-77.3833,37.3822]},{"Plant":"Yorktown","State":"VA","Coal":323,"coordinates":[-76.4611,37.2144]},{"Plant":"Joliet 29","State":"IL","Coal":1036,"coordinates":[-88.1238,41.4946]},{"Plant":"Transalta Centralia Generation","State":"WA","Coal":1340,"coordinates":[-122.8598,46.7559]},{"Plant":"John E Amos","State":"WV","Coal":2900,"coordinates":[-81.8233,38.4731]},{"Plant":"Kanawha River","State":"WV","Coal":400,"coordinates":[-81.4211,38.2056]},{"Plant":"FirstEnergy Fort Martin Power Station","State":"WV","Coal":1098,"coordinates":[-79.9275,39.7108]},{"Plant":"FirstEnergy Harrison Power Station","State":"WV","Coal":1954,"coordinates":[-80.3325,39.3842]},{"Plant":"Mitchell","State":"WV","Coal":1560,"coordinates":[-80.8153,39.8297]},{"Plant":"Mt Storm","State":"WV","Coal":1629,"coordinates":[-79.2636,39.2008]},{"Plant":"South Oak Creek","State":"WI","Coal":995,"coordinates":[-87.8294,42.8457]},{"Plant":"Edgewater","State":"WI","Coal":698.7,"coordinates":[-87.7059,43.7151]},{"Plant":"Pulliam","State":"WI","Coal":210.6,"coordinates":[-88.0086,44.54]},{"Plant":"Weston","State":"WI","Coal":867.6,"coordinates":[-89.6553,44.8606]},{"Plant":"Genoa","State":"WI","Coal":289.7,"coordinates":[-91.2325,43.5589]},{"Plant":"Dave Johnston","State":"WY","Coal":760,"coordinates":[-105.7769,42.8378]},{"Plant":"Naughton","State":"WY","Coal":687,"coordinates":[-110.5983,41.7581]},{"Plant":"John P Madgett","State":"WI","Coal":387.8,"coordinates":[-91.9126,44.3036]},{"Plant":"Cherokee","State":"CO","Coal":352,"coordinates":[-104.9645,39.8073]},{"Plant":"Comanche","State":"CO","Coal":1410,"coordinates":[-104.5747,38.2081]},{"Plant":"Valmont","State":"CO","Coal":184,"coordinates":[-105.202,40.0195]},{"Plant":"Martin Drake","State":"CO","Coal":208,"coordinates":[-104.8333,38.8244]},{"Plant":"Navajo","State":"AZ","Coal":2250,"coordinates":[-111.3886,36.9047]},{"Plant":"Tennessee Eastman Operations","State":"TN","Coal":131.3,"coordinates":[-82.5431,36.5219]},{"Plant":"Northampton Generating Company LP","State":"PA","Coal":112,"coordinates":[-75.4792,40.6917]},{"Plant":"Indiantown Cogeneration LP","State":"FL","Coal":330,"coordinates":[-80.5125,27.0389]},{"Plant":"Dolet Hills","State":"LA","Coal":641,"coordinates":[-93.5692,32.0306]},{"Plant":"Mecklenburg Power Station","State":"VA","Coal":138,"coordinates":[-78.53,36.6]},{"Plant":"Sandow No 5","State":"TX","Coal":600,"coordinates":[-97.0614,30.5681]},{"Plant":"Hayden","State":"CO","Coal":441,"coordinates":[-107.185,40.4856]},{"Plant":"Roanoke Valley Energy Facililty I","State":"NC","Coal":165,"coordinates":[-77.6167,36.4364]},{"Plant":"Spruance Genco LLC","State":"VA","Coal":190,"coordinates":[-77.4308,37.4556]},{"Plant":"Birchwood Power","State":"VA","Coal":238.4,"coordinates":[-77.3147,38.2667]},{"Plant":"Red Hills Generating Facility","State":"MS","Coal":440,"coordinates":[-89.2183,33.3761]},{"Plant":"Hardin Generator Project","State":"MT","Coal":107,"coordinates":[-107.6,45.7578]},{"Plant":"Prairie State Generating Station","State":"IL","Coal":1627,"coordinates":[-89.6669,38.2792]},{"Plant":"Charles R Lowman","State":"AL","Coal":556,"coordinates":[-87.9107,31.488]},{"Plant":"Elm Road Generating Station","State":"WI","Coal":1268,"coordinates":[-87.8336,42.8492]},{"Plant":"TS Power Plant","State":"NV","Coal":218.4,"coordinates":[-116.5297,40.7461]},{"Plant":"Stanton Energy Center","State":"FL","Coal":896,"coordinates":[-81.1678,28.4822]},{"Plant":"Plum Point Energy Station","State":"AR","Coal":670,"coordinates":[-89.9489,35.6644]},{"Plant":"John W Turk Jr Power Plant","State":"AR","Coal":609,"coordinates":[-93.8119,33.6497]},{"Plant":"Dry Fork Station","State":"WY","Coal":380,"coordinates":[-105.4608,44.3889]},{"Plant":"Sandy Creek Energy Station","State":"TX","Coal":940,"coordinates":[-96.9571,31.4744]},{"Plant":"Longview Power LLC","State":"WV","Coal":700,"coordinates":[-79.959,39.7079]},{"Plant":"Bridgeport Station","State":"CT","Coal":383.4,"coordinates":[-73.1844,41.1706]},{"Plant":"Virginia City Hybrid Energy Center","State":"VA","Coal":610,"coordinates":[-82.3381,36.9164]},{"Plant":"Indian River Generating Station","State":"DE","Coal":410,"coordinates":[-75.2341,38.5857]},{"Plant":"Whelan Energy Center","State":"NE","Coal":309,"coordinates":[-98.3124,40.5809]},{"Plant":"James H Miller Jr","State":"AL","Coal":2741.2,"coordinates":[-87.0597,33.6319]},{"Plant":"FirstEnergy Pleasants Power Station","State":"WV","Coal":1288,"coordinates":[-81.2944,39.3667]},{"Plant":"White Bluff","State":"AR","Coal":1631,"coordinates":[-92.1406,34.4228]},{"Plant":"Duck Creek","State":"IL","Coal":410,"coordinates":[-89.9841,40.4663]},{"Plant":"Newton","State":"IL","Coal":595,"coordinates":[-88.2781,38.9361]},{"Plant":"East Bend","State":"KY","Coal":600,"coordinates":[-84.8514,38.9036]},{"Plant":"W H Zimmer","State":"OH","Coal":1344,"coordinates":[-84.2289,38.8675]},{"Plant":"Brandon Shores","State":"MD","Coal":1273,"coordinates":[-76.5389,39.18]},{"Plant":"Craig","State":"CO","Coal":1304,"coordinates":[-107.5912,40.4627]},{"Plant":"Coal Creek","State":"ND","Coal":1141.7,"coordinates":[-101.1571,47.3777]},{"Plant":"Killen Station","State":"OH","Coal":600,"coordinates":[-83.4803,38.6903]},{"Plant":"Belle River","State":"MI","Coal":1270,"coordinates":[-82.495,42.7756]},{"Plant":"H L Spurlock","State":"KY","Coal":1346,"coordinates":[-83.8181,38.7]},{"Plant":"Wansley","State":"GA","Coal":1744,"coordinates":[-85.0323,33.4134]},{"Plant":"Big Cajun 2","State":"LA","Coal":1168,"coordinates":[-91.3692,30.7261]},{"Plant":"R D Morrow","State":"MS","Coal":360,"coordinates":[-89.394,31.2186]},{"Plant":"Nearman Creek","State":"KS","Coal":240,"coordinates":[-94.6975,39.1681]},{"Plant":"Iatan","State":"MO","Coal":1581.9,"coordinates":[-94.98,39.4472]},{"Plant":"Jeffrey Energy Center","State":"KS","Coal":2147,"coordinates":[-96.1172,39.2865]},{"Plant":"Trimble County","State":"KY","Coal":1243,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Coal":1020,"coordinates":[-88.5553,30.5322]},{"Plant":"Colstrip","State":"MT","Coal":2094,"coordinates":[-106.614,45.8831]},{"Plant":"Gerald Gentleman","State":"NE","Coal":1365,"coordinates":[-101.1408,41.0808]},{"Plant":"Somerset Operating Co LLC","State":"NY","Coal":685.6,"coordinates":[-78.6047,43.3589]},{"Plant":"R M Schahfer","State":"IN","Coal":1625,"coordinates":[-87.0261,41.2164]},{"Plant":"Sherburne County","State":"MN","Coal":2238,"coordinates":[-93.8931,45.3808]},{"Plant":"FirstEnergy Bruce Mansfield","State":"PA","Coal":2510,"coordinates":[-80.4159,40.6348]},{"Plant":"Sooner","State":"OK","Coal":1041,"coordinates":[-97.0528,36.4531]},{"Plant":"Nebraska City","State":"NE","Coal":1320.1,"coordinates":[-95.7764,40.6214]},{"Plant":"Big Stone","State":"SD","Coal":474,"coordinates":[-96.5101,45.3037]},{"Plant":"Wyodak","State":"WY","Coal":332,"coordinates":[-105.3815,44.2901]},{"Plant":"Boardman","State":"OR","Coal":585,"coordinates":[-119.8088,45.6932]},{"Plant":"Gibson","State":"IN","Coal":3132,"coordinates":[-87.7658,38.3722]},{"Plant":"McIntosh","State":"GA","Coal":142.5,"coordinates":[-81.1683,32.3563]},{"Plant":"Gibbons Creek","State":"TX","Coal":470,"coordinates":[-96.0818,30.6199]},{"Plant":"A B Brown","State":"IN","Coal":490,"coordinates":[-87.715,37.9053]},{"Plant":"Flint Creek","State":"AR","Coal":528,"coordinates":[-94.5241,36.2561]},{"Plant":"Welsh","State":"TX","Coal":1056,"coordinates":[-94.84,33.0552]},{"Plant":"Martin Lake","State":"TX","Coal":2410,"coordinates":[-94.5706,32.2606]},{"Plant":"Monticello","State":"TX","Coal":1865,"coordinates":[-95.0417,33.0917]},{"Plant":"Rush Island","State":"MO","Coal":1180,"coordinates":[-90.2632,38.1312]},{"Plant":"Hunter","State":"UT","Coal":1361,"coordinates":[-111.0289,39.1747]},{"Plant":"Rockport","State":"IN","Coal":2600,"coordinates":[-87.0372,37.9256]},{"Plant":"Pleasant Prairie","State":"WI","Coal":1188,"coordinates":[-87.9033,42.5381]},{"Plant":"Coronado","State":"AZ","Coal":762,"coordinates":[-109.2708,34.5789]},{"Plant":"Coleto Creek","State":"TX","Coal":635,"coordinates":[-97.2142,28.7128]},{"Plant":"Fayette Power Project","State":"TX","Coal":1615,"coordinates":[-96.7506,29.9172]},{"Plant":"Oak Grove","State":"TX","Coal":1665,"coordinates":[-96.4866,31.1803]},{"Plant":"J T Deely","State":"TX","Coal":840,"coordinates":[-98.3228,29.3081]},{"Plant":"San Miguel","State":"TX","Coal":391,"coordinates":[-98.4775,28.7044]},{"Plant":"Brame Energy Center","State":"LA","Coal":493.9,"coordinates":[-92.7167,31.395]},{"Plant":"Harrington","State":"TX","Coal":1018,"coordinates":[-101.7472,35.2982]},{"Plant":"Tolk","State":"TX","Coal":1067,"coordinates":[-102.57,34.1865]},{"Plant":"John Twitty Energy Center","State":"MO","Coal":459,"coordinates":[-93.388,37.1517]},{"Plant":"Laramie River Station","State":"WY","Coal":1710,"coordinates":[-104.8825,42.1089]},{"Plant":"Merom","State":"IN","Coal":983,"coordinates":[-87.5108,39.0694]},{"Plant":"Pawnee","State":"CO","Coal":505,"coordinates":[-103.6803,40.2217]},{"Plant":"Winyah","State":"SC","Coal":1130,"coordinates":[-79.3581,33.3317]},{"Plant":"Mayo","State":"NC","Coal":727,"coordinates":[-78.8917,36.5278]},{"Plant":"Ottumwa","State":"IA","Coal":730,"coordinates":[-92.5558,41.0961]},{"Plant":"Scherer","State":"GA","Coal":3392,"coordinates":[-83.8075,33.0606]},{"Plant":"Mountaineer","State":"WV","Coal":1299,"coordinates":[-81.9344,38.9794]},{"Plant":"Crystal River","State":"FL","Coal":2188,"coordinates":[-82.6977,28.9656]},{"Plant":"Crist","State":"FL","Coal":924,"coordinates":[-87.2244,30.5661]},{"Plant":"Big Bend","State":"FL","Coal":1602,"coordinates":[-82.4036,27.7944]},{"Plant":"Antelope Valley","State":"ND","Coal":900,"coordinates":[-101.3194,47.2819]},{"Plant":"Intermountain Power Project","State":"UT","Coal":1800,"coordinates":[-112.5802,39.5097]},{"Plant":"Deerhaven Generating Station","State":"FL","Coal":232,"coordinates":[-82.3878,29.7592]},{"Plant":"R D Green","State":"KY","Coal":454,"coordinates":[-87.5,37.6461]},{"Plant":"Independence","State":"AR","Coal":1678,"coordinates":[-91.4088,35.6784]},{"Plant":"Sandow No 4","State":"TX","Coal":600,"coordinates":[-97.064,30.5659]},{"Plant":"Louisa","State":"IA","Coal":743.9,"coordinates":[-91.0931,41.3181]},{"Plant":"Northside Generating Station","State":"FL","Coal":586,"coordinates":[-81.5525,30.4172]},{"Plant":"Warrick","State":"IN","Coal":751,"coordinates":[-87.3328,37.915]},{"Plant":"C D McIntosh Jr","State":"FL","Coal":342,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Coal":280,"coordinates":[-105.0212,40.8609]},{"Plant":"Sikeston Power Station","State":"MO","Coal":240,"coordinates":[-89.6209,36.8791]},{"Plant":"Hugo","State":"OK","Coal":440,"coordinates":[-95.3206,34.0158]},{"Plant":"D B Wilson","State":"KY","Coal":417,"coordinates":[-87.0806,37.4497]},{"Plant":"Bowen","State":"GA","Coal":3232,"coordinates":[-84.9222,34.1256]},{"Plant":"Major Oak Power","State":"TX","Coal":305,"coordinates":[-96.695,31.0919]},{"Plant":"Hammond","State":"GA","Coal":840,"coordinates":[-85.3456,34.2528]},{"Plant":"J K Spruce","State":"TX","Coal":1345,"coordinates":[-98.3203,29.3097]},{"Plant":"Cope","State":"SC","Coal":415,"coordinates":[-81.03,33.3644]},{"Plant":"Clover","State":"VA","Coal":877,"coordinates":[-78.704,36.869]},{"Plant":"Polk","State":"FL","Coal":220,"coordinates":[-81.9897,27.7286]},{"Plant":"George Neal South","State":"IA","Coal":644,"coordinates":[-96.3617,42.3006]},{"Plant":"Bonanza","State":"UT","Coal":458,"coordinates":[-109.2844,40.0864]},{"Plant":"Pirkey","State":"TX","Coal":721,"coordinates":[-94.4852,32.4607]},{"Plant":"Gorgas","State":"AL","Coal":1053.7,"coordinates":[-87.1965,33.6443]},{"Plant":"Columbia","State":"WI","Coal":1137.7,"coordinates":[-89.4203,43.4864]},{"Plant":"Belews Creek","State":"NC","Coal":2220,"coordinates":[-80.0603,36.2811]},{"Plant":"Jim Bridger","State":"WY","Coal":2111,"coordinates":[-108.7875,41.7378]},{"Plant":"Huntington","State":"UT","Coal":909,"coordinates":[-111.0781,39.3792]},{"Plant":"General James M Gavin","State":"OH","Coal":2598,"coordinates":[-82.1158,38.9347]},{"Plant":"Ray D Nixon","State":"CO","Coal":208,"coordinates":[-104.7058,38.6335]},{"Plant":"Coyote","State":"ND","Coal":429,"coordinates":[-101.8157,47.2214]},{"Plant":"Springerville","State":"AZ","Coal":1625,"coordinates":[-109.1639,34.3186]},{"Plant":"North Valmy","State":"NV","Coal":522,"coordinates":[-117.1516,40.8813]},{"Plant":"Cheswick Power Plant","State":"PA","Coal":565,"coordinates":[-79.7906,40.5383]},{"Plant":"E D Edwards","State":"IL","Coal":560,"coordinates":[-89.6631,40.5958]},{"Plant":"Coffeen","State":"IL","Coal":895,"coordinates":[-89.4031,39.0586]},{"Plant":"Escalante","State":"NM","Coal":247,"coordinates":[-108.082,35.4159]},{"Plant":"Joliet 9","State":"IL","Coal":314,"coordinates":[-88.1153,41.4931]},{"Plant":"Kincaid Generation LLC","State":"IL","Coal":1158,"coordinates":[-89.4964,39.5906]},{"Plant":"Powerton","State":"IL","Coal":1538,"coordinates":[-89.6786,40.5408]},{"Plant":"Waukegan","State":"IL","Coal":689,"coordinates":[-87.8133,42.3833]},{"Plant":"Will County","State":"IL","Coal":510,"coordinates":[-88.0629,41.6334]},{"Plant":"Joppa Steam","State":"IL","Coal":948,"coordinates":[-88.8589,37.2094]},{"Plant":"Baldwin Energy Complex","State":"IL","Coal":1778,"coordinates":[-89.8544,38.205]},{"Plant":"Havana","State":"IL","Coal":411,"coordinates":[-90.08,40.2797]},{"Plant":"Hennepin Power Station","State":"IL","Coal":284,"coordinates":[-89.315,41.3028]},{"Plant":"Dallman","State":"IL","Coal":534,"coordinates":[-89.6024,39.7548]},{"Plant":"Marion","State":"IL","Coal":290,"coordinates":[-88.9531,37.6197]},{"Plant":"Clifty Creek","State":"IN","Coal":1173,"coordinates":[-85.4206,38.7378]},{"Plant":"AES Petersburg","State":"IN","Coal":1701.5,"coordinates":[-87.2525,38.5281]},{"Plant":"Bailly","State":"IN","Coal":480,"coordinates":[-87.1225,41.645]},{"Plant":"Michigan City","State":"IN","Coal":469,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Gas":995,"coordinates":[-87.7811,32.6017]},{"Plant":"Cayuga","State":"IN","Gas":105.8,"coordinates":[-87.4244,39.9242]},{"Plant":"Pedricktown Cogeneration Company LP","State":"NJ","Gas":115.67,"coordinates":[-75.4238,39.7668]},{"Plant":"Broadway","State":"IN","Gas":115,"coordinates":[-87.6049,37.9691]},{"Plant":"Butler-Warner Generation Plant","State":"NC","Gas":215,"coordinates":[-78.8294,35.0986]},{"Plant":"El Segundo Cogen","State":"CA","Gas":116.6,"coordinates":[-118.4031,33.9058]},{"Plant":"ArcelorMittal Burns Harbor","State":"IN","Gas":177.7,"coordinates":[-87.1387,41.635]},{"Plant":"Bayou Cogen Plant","State":"TX","Gas":280,"coordinates":[-95.0458,29.6225]},{"Plant":"Bellingham Cogeneration Facility","State":"MA","Gas":194,"coordinates":[-71.4833,42.0925]},{"Plant":"Sayreville Cogeneration Facility","State":"NJ","Gas":196,"coordinates":[-74.3444,40.439]},{"Plant":"Foster Wheeler Martinez","State":"CA","Gas":103.5,"coordinates":[-122.0589,38.0244]},{"Plant":"ExxonMobil Baytown Refinery","State":"TX","Gas":169.93,"coordinates":[-94.9973,29.7535]},{"Plant":"RG Steel Sparrows Point, LLC","State":"MD","Gas":153,"coordinates":[-76.4729,39.213]},{"Plant":"Kern River Cogeneration","State":"CA","Gas":293.6,"coordinates":[-118.9849,35.4515]},{"Plant":"Formosa Utility Venture Ltd","State":"TX","Gas":477.5,"coordinates":[-96.5417,28.6917]},{"Plant":"Hopewell Cogeneration","State":"VA","Gas":252.3,"coordinates":[-77.2811,37.2917]},{"Plant":"ExxonMobil Baytown Turbine","State":"TX","Gas":180.13,"coordinates":[-95.0096,29.7591]},{"Plant":"Selkirk Cogen","State":"NY","Gas":228.76,"coordinates":[-73.8592,42.5744]},{"Plant":"Masspower","State":"MA","Gas":149.64,"coordinates":[-72.5225,42.1575]},{"Plant":"Clear Lake Cogeneration Ltd","State":"TX","Gas":300,"coordinates":[-95.067,29.6255]},{"Plant":"Midland Cogeneration Venture","State":"MI","Gas":1378.91,"coordinates":[-84.2242,43.5861]},{"Plant":"River Hills","State":"IA","Gas":120,"coordinates":[-93.6195,41.5902]},{"Plant":"Ocotillo","State":"AZ","Gas":320,"coordinates":[-111.9122,33.4225]},{"Plant":"West Phoenix","State":"AZ","Gas":448.3,"coordinates":[-112.1583,33.4417]},{"Plant":"Saguaro","State":"AZ","Gas":310,"coordinates":[-111.3,32.5517]},{"Plant":"Yucca","State":"AZ","Gas":163,"coordinates":[-114.7106,32.7214]},{"Plant":"Fort Dodge","State":"KS","Gas":137,"coordinates":[-99.9497,37.7328]},{"Plant":"Gordon Evans Energy Center","State":"KS","Gas":658,"coordinates":[-97.5217,37.7903]},{"Plant":"Murray Gill","State":"KS","Gas":335,"coordinates":[-97.4136,37.5967]},{"Plant":"Hutchinson Energy Center","State":"KS","Gas":490,"coordinates":[-97.8747,38.0906]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Gas":316,"coordinates":[-110.9047,32.16]},{"Plant":"Kaw","State":"KS","Gas":129,"coordinates":[-94.6514,39.0867]},{"Plant":"McPherson 2","State":"KS","Gas":131.5,"coordinates":[-97.6834,38.3634]},{"Plant":"Garden City","State":"KS","Gas":197,"coordinates":[-100.8956,37.9703]},{"Plant":"E W Brown","State":"KY","Gas":952.5,"coordinates":[-84.7126,37.7883]},{"Plant":"Paddys Run","State":"KY","Gas":194.3,"coordinates":[-85.8417,38.2236]},{"Plant":"Louisiana 1","State":"LA","Gas":218,"coordinates":[-91.1864,30.4922]},{"Plant":"Louisiana 2","State":"LA","Gas":129,"coordinates":[-91.1864,30.4922]},{"Plant":"R S Nelson","State":"LA","Gas":849,"coordinates":[-93.2911,30.2844]},{"Plant":"Willow Glen","State":"LA","Gas":1842,"coordinates":[-91.1164,30.2743]},{"Plant":"Teche","State":"LA","Gas":430,"coordinates":[-91.5425,29.8222]},{"Plant":"Little Gypsy","State":"LA","Gas":1195,"coordinates":[-90.4617,30.0051]},{"Plant":"Nine Mile Point","State":"LA","Gas":1668,"coordinates":[-90.1458,29.9472]},{"Plant":"Sterlington","State":"LA","Gas":412,"coordinates":[-92.0792,32.7047]},{"Plant":"A B Paterson","State":"LA","Gas":116,"coordinates":[-90.0256,30.0158]},{"Plant":"Michoud","State":"LA","Gas":840,"coordinates":[-89.9372,30.0081]},{"Plant":"Agua Fria","State":"AZ","Gas":626,"coordinates":[-112.2153,33.5561]},{"Plant":"Arsenal Hill","State":"LA","Gas":110,"coordinates":[-93.7611,32.5181]},{"Plant":"Lieberman","State":"LA","Gas":269,"coordinates":[-93.9597,32.7047]},{"Plant":"Louis Doc Bonin","State":"LA","Gas":302,"coordinates":[-92.0463,30.238]},{"Plant":"Monroe","State":"LA","Gas":117,"coordinates":[-92.1794,32.5233]},{"Plant":"Big Cajun 1","State":"LA","Gas":248.5,"coordinates":[-91.3556,30.6739]},{"Plant":"Kyrene","State":"AZ","Gas":271,"coordinates":[-111.9353,33.3556]},{"Plant":"Notch Cliff","State":"MD","Gas":128,"coordinates":[-76.5087,39.4217]},{"Plant":"Riverside","State":"MD","Gas":207,"coordinates":[-76.5133,39.2369]},{"Plant":"Westport","State":"MD","Gas":121,"coordinates":[-76.6295,39.266]},{"Plant":"Chalk Point LLC","State":"MD","Gas":474,"coordinates":[-76.6861,38.5444]},{"Plant":"Dickerson","State":"MD","Gas":294,"coordinates":[-77.4644,39.2097]},{"Plant":"New Boston Generating Station","State":"MA","Gas":706,"coordinates":[-71.0353,42.3392]},{"Plant":"Brayton Point","State":"MA","Gas":442.22,"coordinates":[-71.1931,41.7103]},{"Plant":"Cecil Lynch","State":"AR","Gas":170,"coordinates":[-92.1987,34.7535]},{"Plant":"Hamilton Moses","State":"AR","Gas":140,"coordinates":[-90.8722,34.9806]},{"Plant":"Cleary Flood","State":"MA","Gas":105,"coordinates":[-71.1061,41.8653]},{"Plant":"Harvey Couch","State":"AR","Gas":148,"coordinates":[-93.4649,33.3592]},{"Plant":"Lake Catherine","State":"AR","Gas":745,"coordinates":[-92.9049,34.4341]},{"Plant":"Dan E Karn","State":"MI","Gas":1276,"coordinates":[-83.8401,43.645]},{"Plant":"Thetford","State":"MI","Gas":192,"coordinates":[-83.6286,43.1567]},{"Plant":"Conners Creek","State":"MI","Gas":236,"coordinates":[-82.9597,42.3592]},{"Plant":"Delray","State":"MI","Gas":125,"coordinates":[-83.1019,42.2947]},{"Plant":"Robert E Ritchie","State":"AR","Gas":878,"coordinates":[-90.5987,34.4629]},{"Plant":"Hancock","State":"MI","Gas":141,"coordinates":[-83.4425,42.5497]},{"Plant":"Mistersky","State":"MI","Gas":154,"coordinates":[-83.0903,42.3039]},{"Plant":"Black Dog","State":"MN","Gas":101,"coordinates":[-93.2501,44.8108]},{"Plant":"Carl Bailey","State":"AR","Gas":122,"coordinates":[-91.3634,35.2601]},{"Plant":"McClellan","State":"AR","Gas":134,"coordinates":[-92.7917,33.5648]},{"Plant":"Chevron Oil","State":"MS","Gas":127,"coordinates":[-88.4919,30.34]},{"Plant":"Sweatt","State":"MS","Gas":125.6,"coordinates":[-88.7461,32.2925]},{"Plant":"Jack Watson","State":"MS","Gas":299,"coordinates":[-89.0286,30.4392]},{"Plant":"Baxter Wilson","State":"MS","Gas":1211,"coordinates":[-90.9306,32.2831]},{"Plant":"Delta","State":"MS","Gas":192,"coordinates":[-90.7139,33.7947]},{"Plant":"Rex Brown","State":"MS","Gas":295,"coordinates":[-90.213,32.357]},{"Plant":"Moselle","State":"MS","Gas":260,"coordinates":[-89.3004,31.528]},{"Plant":"Hawthorn","State":"MO","Gas":278.2,"coordinates":[-94.4778,39.1306]},{"Plant":"Lake Road","State":"MO","Gas":118,"coordinates":[-94.8773,39.7246]},{"Plant":"James River Power Station","State":"MO","Gas":155,"coordinates":[-93.2619,37.1086]},{"Plant":"Canaday","State":"NE","Gas":118,"coordinates":[-99.7011,40.6942]},{"Plant":"C W Burdick","State":"NE","Gas":107.3,"coordinates":[-98.3269,40.9228]},{"Plant":"Contra Costa","State":"CA","Gas":672,"coordinates":[-121.7642,38.0192]},{"Plant":"Clark","State":"NV","Gas":525,"coordinates":[-115.0507,36.0875]},{"Plant":"Sunrise","State":"NV","Gas":149,"coordinates":[-115.036,36.1384]},{"Plant":"Fort Churchill","State":"NV","Gas":226,"coordinates":[-119.1322,39.1281]},{"Plant":"Tracy","State":"NV","Gas":382,"coordinates":[-119.525,39.5625]},{"Plant":"Deepwater","State":"NJ","Gas":105,"coordinates":[-75.5083,39.6831]},{"Plant":"Sayreville","State":"NJ","Gas":220,"coordinates":[-74.3523,40.4765]},{"Plant":"Gilbert","State":"NJ","Gas":439,"coordinates":[-75.1639,40.5658]},{"Plant":"Bergen Generating Station","State":"NJ","Gas":501,"coordinates":[-74.0244,40.8375]},{"Plant":"PSEG Burlington Generating Station","State":"NJ","Gas":417,"coordinates":[-74.8792,40.0766]},{"Plant":"PSEG Edison Generating Station","State":"NJ","Gas":504,"coordinates":[-74.3956,40.4911]},{"Plant":"PSEG Essex Generating Station","State":"NJ","Gas":617,"coordinates":[-74.1206,40.7372]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Gas":383,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Kearny Generating Station","State":"NJ","Gas":648.6,"coordinates":[-74.0965,40.7373]},{"Plant":"PSEG Linden Generating Station","State":"NJ","Gas":342.31,"coordinates":[-74.2072,40.6217]},{"Plant":"PSEG Sewaren Generating Station","State":"NJ","Gas":400.83,"coordinates":[-74.2469,40.5558]},{"Plant":"Rio Grande","State":"NM","Gas":236,"coordinates":[-106.5472,31.8047]},{"Plant":"Maddox","State":"NM","Gas":194,"coordinates":[-103.3015,32.7142]},{"Plant":"Reeves","State":"NM","Gas":154,"coordinates":[-106.6019,35.171]},{"Plant":"Cunningham","State":"NM","Gas":511,"coordinates":[-103.3533,32.7131]},{"Plant":"Humboldt Bay","State":"CA","Gas":105,"coordinates":[-124.2103,40.7415]},{"Plant":"Hunters Point","State":"CA","Gas":377,"coordinates":[-122.3897,37.7336]},{"Plant":"Arthur Kill Generating Station","State":"NY","Gas":841,"coordinates":[-74.2,40.5916]},{"Plant":"Gowanus Gas Turbines Generating","State":"NY","Gas":266,"coordinates":[-74.0051,40.6635]},{"Plant":"Narrows Gas Turbines Generating","State":"NY","Gas":266,"coordinates":[-74.0208,40.6486]},{"Plant":"Ravenswood","State":"NY","Gas":1204.85,"coordinates":[-73.9461,40.7592]},{"Plant":"E F Barrett","State":"NY","Gas":702.3,"coordinates":[-73.6479,40.6167]},{"Plant":"Far Rockaway","State":"NY","Gas":110,"coordinates":[-73.761,40.6109]},{"Plant":"Glenwood","State":"NY","Gas":229,"coordinates":[-73.6475,40.8271]},{"Plant":"Northport","State":"NY","Gas":779,"coordinates":[-73.3423,40.9236]},{"Plant":"Port Jefferson","State":"NY","Gas":190,"coordinates":[-73.0785,40.9497]},{"Plant":"Dynegy Morro Bay LLC","State":"CA","Gas":999,"coordinates":[-120.8566,35.3722]},{"Plant":"Oswego Harbor Power","State":"NY","Gas":850,"coordinates":[-76.5319,43.4586]},{"Plant":"Dynegy Moss Landing Power Plant","State":"CA","Gas":1478,"coordinates":[-121.7822,36.8048]},{"Plant":"Bowline Point","State":"NY","Gas":1139,"coordinates":[-73.9689,41.2044]},{"Plant":"Asheville","State":"NC","Gas":510.03,"coordinates":[-82.5417,35.4731]},{"Plant":"Pittsburg Power","State":"CA","Gas":1901,"coordinates":[-121.8945,38.0392]},{"Plant":"Potrero Power","State":"CA","Gas":206,"coordinates":[-122.387,37.7566]},{"Plant":"Dicks Creek","State":"OH","Gas":106.2,"coordinates":[-84.3778,39.465]},{"Plant":"Frank M Tait","State":"OH","Gas":256,"coordinates":[-84.2111,39.7272]},{"Plant":"Yankee Street","State":"OH","Gas":107,"coordinates":[-84.2047,39.603]},{"Plant":"FirstEnergy West Lorain","State":"OH","Gas":361,"coordinates":[-82.2644,41.4294]},{"Plant":"Horseshoe Lake","State":"OK","Gas":807.3,"coordinates":[-97.1797,35.5087]},{"Plant":"Muskogee","State":"OK","Gas":171,"coordinates":[-95.2873,35.7614]},{"Plant":"Mustang","State":"OK","Gas":548,"coordinates":[-97.675,35.4699]},{"Plant":"Seminole","State":"OK","Gas":1518,"coordinates":[-96.7258,34.9665]},{"Plant":"Northeastern","State":"OK","Gas":633,"coordinates":[-95.7008,36.4317]},{"Plant":"Southwestern","State":"OK","Gas":472,"coordinates":[-98.3524,35.1009]},{"Plant":"Tulsa","State":"OK","Gas":415,"coordinates":[-95.991,36.1165]},{"Plant":"Weleetka","State":"OK","Gas":163,"coordinates":[-96.1352,35.3233]},{"Plant":"Barry","State":"AL","Gas":438.69,"coordinates":[-88.0103,31.0069]},{"Plant":"Anadarko Plant","State":"OK","Gas":357,"coordinates":[-98.23,35.0847]},{"Plant":"Mooreland","State":"OK","Gas":337,"coordinates":[-99.2254,36.4372]},{"Plant":"Encina","State":"CA","Gas":958,"coordinates":[-117.3364,33.1361]},{"Plant":"Kearny","State":"CA","Gas":127,"coordinates":[-117.1338,32.834]},{"Plant":"Brunot Island","State":"PA","Gas":145,"coordinates":[-80.0438,40.4649]},{"Plant":"Dynegy South Bay Power Plant","State":"CA","Gas":707,"coordinates":[-117.092,32.6114]},{"Plant":"Portland","State":"PA","Gas":169,"coordinates":[-75.0794,40.9102]},{"Plant":"AES Alamitos LLC","State":"CA","Gas":2083,"coordinates":[-118.1009,33.7688]},{"Plant":"Cromby Generating Station","State":"PA","Gas":201,"coordinates":[-75.5294,40.1531]},{"Plant":"Manchester Street","State":"RI","Gas":415.65,"coordinates":[-71.4042,41.8167]},{"Plant":"Darlington County","State":"SC","Gas":448,"coordinates":[-80.1657,34.4185]},{"Plant":"Coolwater","State":"CA","Gas":292,"coordinates":[-116.8539,34.8606]},{"Plant":"El Segundo Power","State":"CA","Gas":926.66,"coordinates":[-118.4242,33.9098]},{"Plant":"Riverside Canal Power","State":"CA","Gas":127,"coordinates":[-117.3312,34.0229]},{"Plant":"AES Huntington Beach LLC","State":"CA","Gas":563,"coordinates":[-117.9792,33.6439]},{"Plant":"Allen Steam Plant","State":"TN","Gas":460,"coordinates":[-90.1487,35.0741]},{"Plant":"Gallatin","State":"TN","Gas":576,"coordinates":[-86.4006,36.3156]},{"Plant":"Johnsonville","State":"TN","Gas":308,"coordinates":[-87.9861,36.0278]},{"Plant":"Long Beach Generation LLC","State":"CA","Gas":374.85,"coordinates":[-118.2248,33.7641]},{"Plant":"E S Joslin","State":"TX","Gas":249,"coordinates":[-96.5458,28.6472]},{"Plant":"J L Bates","State":"TX","Gas":182,"coordinates":[-98.3944,26.2222]},{"Plant":"Laredo","State":"TX","Gas":174,"coordinates":[-99.5089,27.5667]},{"Plant":"Lon C Hill","State":"TX","Gas":545,"coordinates":[-97.6167,27.85]},{"Plant":"Nueces Bay","State":"TX","Gas":559,"coordinates":[-97.4192,27.8194]},{"Plant":"La Palma","State":"TX","Gas":254,"coordinates":[-97.6389,26.1331]},{"Plant":"Victoria","State":"TX","Gas":482,"coordinates":[-97.01,28.7883]},{"Plant":"Mandalay","State":"CA","Gas":130,"coordinates":[-119.2511,34.2067]},{"Plant":"Lake Hubbard","State":"TX","Gas":921,"coordinates":[-96.5458,32.8358]},{"Plant":"Mountain Creek","State":"TX","Gas":902,"coordinates":[-96.9358,32.7231]},{"Plant":"North Lake","State":"TX","Gas":723,"coordinates":[-96.975,32.9506]},{"Plant":"Parkdale","State":"TX","Gas":330,"coordinates":[-96.7233,32.7767]},{"Plant":"Newman","State":"TX","Gas":412,"coordinates":[-106.4318,31.9836]},{"Plant":"Lewis Creek","State":"TX","Gas":520,"coordinates":[-95.5214,30.4356]},{"Plant":"Neches","State":"TX","Gas":265,"coordinates":[-94.0593,30.0612]},{"Plant":"Sabine","State":"TX","Gas":1804,"coordinates":[-93.878,30.0242]},{"Plant":"Cedar Bayou","State":"TX","Gas":2260,"coordinates":[-94.9256,29.75]},{"Plant":"Deepwater","State":"TX","Gas":178,"coordinates":[-95.2253,29.7199]},{"Plant":"Greens Bayou","State":"TX","Gas":760,"coordinates":[-95.2194,29.8222]},{"Plant":"P H Robinson","State":"TX","Gas":2213,"coordinates":[-94.9794,29.4867]},{"Plant":"Sam Bertron","State":"TX","Gas":844,"coordinates":[-95.0598,29.7268]},{"Plant":"T H Wharton","State":"TX","Gas":1046,"coordinates":[-95.5306,29.9417]},{"Plant":"W A Parish","State":"TX","Gas":1199,"coordinates":[-95.6311,29.4828]},{"Plant":"Webster","State":"TX","Gas":387,"coordinates":[-95.1081,29.5258]},{"Plant":"Knox Lee","State":"TX","Gas":479,"coordinates":[-94.6415,32.3766]},{"Plant":"Wilkes","State":"TX","Gas":882,"coordinates":[-94.548,32.8482]},{"Plant":"Jones","State":"TX","Gas":486,"coordinates":[-101.7392,33.5239]},{"Plant":"Nichols","State":"TX","Gas":457,"coordinates":[-101.7464,35.2834]},{"Plant":"Plant X","State":"TX","Gas":444,"coordinates":[-102.4114,34.1661]},{"Plant":"Eagle Mountain","State":"TX","Gas":674,"coordinates":[-97.4792,32.9056]},{"Plant":"Graham","State":"TX","Gas":645,"coordinates":[-98.6117,33.1344]},{"Plant":"Handley","State":"TX","Gas":1417.46,"coordinates":[-97.2192,32.7283]},{"Plant":"Morgan Creek","State":"TX","Gas":1266,"coordinates":[-100.9156,32.3358]},{"Plant":"Permian Basin","State":"TX","Gas":1003,"coordinates":[-102.9633,31.5839]},{"Plant":"Ormond Beach","State":"CA","Gas":750,"coordinates":[-119.1689,34.1292]},{"Plant":"Collin","State":"TX","Gas":153,"coordinates":[-96.8034,33.1576]},{"Plant":"Lake Creek","State":"TX","Gas":326,"coordinates":[-96.985,31.4647]},{"Plant":"River Crest","State":"TX","Gas":110,"coordinates":[-95.1467,33.3931]},{"Plant":"Stryker Creek","State":"TX","Gas":693,"coordinates":[-94.9898,31.9398]},{"Plant":"Tradinghouse","State":"TX","Gas":1393,"coordinates":[-96.9642,31.5728]},{"Plant":"Trinidad","State":"TX","Gas":244,"coordinates":[-96.1013,32.1245]},{"Plant":"Valley","State":"TX","Gas":1134,"coordinates":[-96.3676,33.6281]},{"Plant":"Paint Creek","State":"TX","Gas":238,"coordinates":[-99.7337,33.1576]},{"Plant":"Rio Pecos","State":"TX","Gas":141,"coordinates":[-102.3753,31.0706]},{"Plant":"San Angelo","State":"TX","Gas":124,"coordinates":[-100.491,31.3906]},{"Plant":"Decker Creek","State":"TX","Gas":938,"coordinates":[-97.6128,30.3033]},{"Plant":"Holly Street","State":"TX","Gas":569,"coordinates":[-97.7167,30.25]},{"Plant":"AES Redondo Beach LLC","State":"CA","Gas":1310,"coordinates":[-118.395,33.8504]},{"Plant":"Bryan","State":"TX","Gas":130,"coordinates":[-96.3723,30.6474]},{"Plant":"Ray Olinger","State":"TX","Gas":405.3,"coordinates":[-96.4525,33.0681]},{"Plant":"Mountainview Generating Station","State":"CA","Gas":120,"coordinates":[-117.2418,34.0818]},{"Plant":"Sim Gideon","State":"TX","Gas":620,"coordinates":[-97.2708,30.1456]},{"Plant":"Ty Cooke","State":"TX","Gas":148.6,"coordinates":[-101.7906,33.5211]},{"Plant":"J Robert Massengale","State":"TX","Gas":107,"coordinates":[-101.8408,33.6039]},{"Plant":"Leon Creek","State":"TX","Gas":160,"coordinates":[-98.5761,29.3525]},{"Plant":"O W Sommers","State":"TX","Gas":880,"coordinates":[-98.3242,29.3081]},{"Plant":"V H Braunig","State":"TX","Gas":865,"coordinates":[-98.3825,29.2567]},{"Plant":"W B Tuttle","State":"TX","Gas":420,"coordinates":[-98.4181,29.53]},{"Plant":"R W Miller","State":"TX","Gas":611,"coordinates":[-98.3103,32.6581]},{"Plant":"Gadsby","State":"UT","Gas":235,"coordinates":[-111.9289,40.7686]},{"Plant":"Grayson","State":"CA","Gas":223,"coordinates":[-118.2782,34.1556]},{"Plant":"Chesterfield","State":"VA","Gas":268,"coordinates":[-77.3833,37.3822]},{"Plant":"El Centro","State":"CA","Gas":202,"coordinates":[-115.54,32.8022]},{"Plant":"Harbor","State":"CA","Gas":198,"coordinates":[-118.2656,33.7706]},{"Plant":"Haynes","State":"CA","Gas":1570,"coordinates":[-118.0991,33.7647]},{"Plant":"Scattergood","State":"CA","Gas":803,"coordinates":[-118.4276,33.9182]},{"Plant":"Rock River","State":"WI","Gas":169.6,"coordinates":[-89.0276,42.582]},{"Plant":"West Marinette","State":"WI","Gas":157.4,"coordinates":[-87.6881,45.0869]},{"Plant":"Valley","State":"CA","Gas":517,"coordinates":[-118.3913,34.245]},{"Plant":"Broadway","State":"CA","Gas":161,"coordinates":[-118.148,34.1254]},{"Plant":"Spencer","State":"TX","Gas":179,"coordinates":[-97.1061,33.1975]},{"Plant":"Colbert","State":"AL","Gas":400,"coordinates":[-87.8486,34.7439]},{"Plant":"Zuni","State":"CO","Gas":107,"coordinates":[-105.017,39.7373]},{"Plant":"Thomas C Ferguson","State":"TX","Gas":420,"coordinates":[-98.3705,30.558]},{"Plant":"Fort Phantom","State":"TX","Gas":362,"coordinates":[-99.6778,32.5784]},{"Plant":"Barney M Davis","State":"TX","Gas":697,"coordinates":[-97.3117,27.6064]},{"Plant":"Riverside","State":"OK","Gas":917,"coordinates":[-95.9567,35.9978]},{"Plant":"Pittsfield Generating LP","State":"MA","Gas":101.4,"coordinates":[-73.2181,42.4564]},{"Plant":"Linden Cogen Plant","State":"NJ","Gas":717,"coordinates":[-74.2156,40.6322]},{"Plant":"Houston Chemical Complex Battleground","State":"TX","Gas":132,"coordinates":[-95.0839,29.7314]},{"Plant":"Sycamore Cogeneration","State":"CA","Gas":279.5,"coordinates":[-118.9853,35.4526]},{"Plant":"Union Carbide Seadrift Cogen","State":"TX","Gas":117,"coordinates":[-96.7706,28.5105]},{"Plant":"Dow St Charles Operations","State":"LA","Gas":208.26,"coordinates":[-90.4414,29.9861]},{"Plant":"Watson Cogeneration","State":"CA","Gas":328,"coordinates":[-118.2448,33.8166]},{"Plant":"Shell Deer Park","State":"TX","Gas":234.65,"coordinates":[-95.1289,29.7232]},{"Plant":"Mobile Energy Services LLC","State":"AL","Gas":124.9,"coordinates":[-88.0516,30.7365]},{"Plant":"PPG Riverside","State":"LA","Gas":154,"coordinates":[-93.2807,30.2217]},{"Plant":"PPG Powerhouse C","State":"LA","Gas":251.2,"coordinates":[-93.2831,30.2242]},{"Plant":"Bayonne Plant Holding LLC","State":"NJ","Gas":108,"coordinates":[-74.1124,40.6553]},{"Plant":"Rosemary Power Station","State":"NC","Gas":108.36,"coordinates":[-77.6594,36.4517]},{"Plant":"Eagle Point Power Generation","State":"NJ","Gas":157,"coordinates":[-75.1592,39.8746]},{"Plant":"TXU Sweetwater Generating Plant","State":"TX","Gas":264,"coordinates":[-100.365,32.4928]},{"Plant":"JM Shafer Generating Station","State":"CO","Gas":108.36,"coordinates":[-104.7736,40.0986]},{"Plant":"TCP 150","State":"CO","Gas":150,"coordinates":[-104.7988,40.1247]},{"Plant":"Gary Works","State":"IN","Gas":221,"coordinates":[-87.3289,41.6224]},{"Plant":"Optim Energy Altura Cogen LLC","State":"TX","Gas":384,"coordinates":[-95.1077,29.8161]},{"Plant":"Gramercy Holdings LLC","State":"LA","Gas":106,"coordinates":[-90.6693,30.054]},{"Plant":"Hardee Power Station","State":"FL","Gas":358,"coordinates":[-81.9636,27.6364]},{"Plant":"Bellmeade Power Station","State":"VA","Gas":383.5,"coordinates":[-77.4317,37.4964]},{"Plant":"Ocean State Power","State":"RI","Gas":142.42,"coordinates":[-71.6689,42.0097]},{"Plant":"LaO Energy Systems","State":"LA","Gas":302,"coordinates":[-91.2325,30.3186]},{"Plant":"Doswell Energy Center","State":"VA","Gas":579.62,"coordinates":[-77.1448,37.8182]},{"Plant":"Elizabeth River Power Station","State":"VA","Gas":312,"coordinates":[-76.3083,36.775]},{"Plant":"Texas City Power Plant","State":"TX","Gas":312,"coordinates":[-94.9438,29.3787]},{"Plant":"Dow Chemical Texas Operation","State":"TX","Gas":1378.6,"coordinates":[-95.4075,28.9913]},{"Plant":"Power Station 4","State":"TX","Gas":138,"coordinates":[-94.9219,29.3782]},{"Plant":"Midway Sunset Cogen","State":"CA","Gas":219,"coordinates":[-119.6294,35.2269]},{"Plant":"C R Wing Cogen Plant","State":"TX","Gas":133.3,"coordinates":[-101.4224,32.2732]},{"Plant":"McWilliams","State":"AL","Gas":105,"coordinates":[-86.4764,31.4003]},{"Plant":"J K Smith","State":"KY","Gas":514,"coordinates":[-84.1017,37.8833]},{"Plant":"Lockport Energy Associates LP","State":"NY","Gas":135,"coordinates":[-78.745,43.1619]},{"Plant":"March Point Cogeneration","State":"WA","Gas":120.2,"coordinates":[-122.56,48.4708]},{"Plant":"Ocean State Power II","State":"RI","Gas":142.42,"coordinates":[-71.6701,42.0099]},{"Plant":"Orange Cogeneration Facility","State":"FL","Gas":149.44,"coordinates":[-81.8251,27.8708]},{"Plant":"Devon Station","State":"CT","Gas":338,"coordinates":[-73.109,41.2098]},{"Plant":"Lake Cogen Ltd","State":"FL","Gas":109.5,"coordinates":[-81.676,28.9158]},{"Plant":"Mulberry Cogeneration Facility","State":"FL","Gas":120,"coordinates":[-81.8775,27.8489]},{"Plant":"Orlando Cogen LP","State":"FL","Gas":115,"coordinates":[-81.4123,28.4426]},{"Plant":"Formosa Plastics","State":"LA","Gas":121,"coordinates":[-91.1872,30.4992]},{"Plant":"Hartwell Energy Facility","State":"GA","Gas":298.2,"coordinates":[-82.8199,34.3396]},{"Plant":"Sithe Independence Station","State":"NY","Gas":574.8,"coordinates":[-76.4511,43.495]},{"Plant":"Saranac Facility","State":"NY","Gas":153,"coordinates":[-73.4557,44.7132]},{"Plant":"NAEA Lakewood LLC","State":"NJ","Gas":133.98,"coordinates":[-74.1686,40.0613]},{"Plant":"Auburndale Power Partners","State":"FL","Gas":116.1,"coordinates":[-81.8058,28.0542]},{"Plant":"Oyster Creek Unit VIII","State":"TX","Gas":309,"coordinates":[-95.342,28.9802]},{"Plant":"Hermiston Generating Plant","State":"OR","Gas":464,"coordinates":[-119.37,45.8042]},{"Plant":"Milford Power LP","State":"MA","Gas":110.85,"coordinates":[-71.5115,42.1294]},{"Plant":"Johnson County","State":"TX","Gas":163,"coordinates":[-97.4078,32.3994]},{"Plant":"Brandywine Power Facility","State":"MD","Gas":169.76,"coordinates":[-76.8678,38.6681]},{"Plant":"Gordonsville Energy LP","State":"VA","Gas":142.8,"coordinates":[-78.2138,38.1179]},{"Plant":"Sun Peak Generating Station","State":"NV","Gas":222,"coordinates":[-115.0339,36.1375]},{"Plant":"Brooklyn Navy Yard Cogeneration","State":"NY","Gas":170,"coordinates":[-73.9764,40.6994]},{"Plant":"LSP-Cottage Grove LP","State":"MN","Gas":154,"coordinates":[-92.9119,44.7956]},{"Plant":"LSP-Whitewater LP","State":"WI","Gas":154,"coordinates":[-88.7299,42.8555]},{"Plant":"Sweeny Cogen Facility","State":"TX","Gas":481.55,"coordinates":[-95.745,29.0728]},{"Plant":"Dighton Power Plant","State":"MA","Gas":143,"coordinates":[-71.1239,41.8312]},{"Plant":"De Pere Energy Center","State":"WI","Gas":174.3,"coordinates":[-88.072,44.4486]},{"Plant":"Androscoggin Energy Center","State":"ME","Gas":132.6,"coordinates":[-70.2423,44.5063]},{"Plant":"Delta Person LLC","State":"NM","Gas":140,"coordinates":[-106.644,35.026]},{"Plant":"Mid-Georgia Cogeneration Facility","State":"GA","Gas":213,"coordinates":[-83.6039,32.4856]},{"Plant":"Berkshire Power","State":"MA","Gas":246,"coordinates":[-72.6478,42.0476]},{"Plant":"Bridgeport Energy Project","State":"CT","Gas":344.6,"coordinates":[-73.1844,41.1692]},{"Plant":"Pasadena Cogeneration","State":"TX","Gas":463.25,"coordinates":[-95.1765,29.7248]},{"Plant":"Tiverton Power Plant","State":"RI","Gas":152.41,"coordinates":[-71.1706,41.6422]},{"Plant":"Axiall Plaquemine","State":"LA","Gas":240,"coordinates":[-91.185,30.2586]},{"Plant":"Tenaska Georgia Generation Facility","State":"GA","Gas":465,"coordinates":[-84.9996,33.3516]},{"Plant":"Batesville Generation Facility","State":"MS","Gas":476.01,"coordinates":[-89.9275,34.3356]},{"Plant":"Black Hawk Station","State":"TX","Gas":221.4,"coordinates":[-101.36,35.6957]},{"Plant":"Mustang Station","State":"TX","Gas":326,"coordinates":[-102.7417,32.9728]},{"Plant":"Maine Independence Station","State":"ME","Gas":303.76,"coordinates":[-68.7094,44.8242]},{"Plant":"Pine Bluff Energy Center","State":"AR","Gas":150,"coordinates":[-91.9025,34.2181]},{"Plant":"Desert Star Energy Center","State":"NV","Gas":320,"coordinates":[-114.9928,35.7867]},{"Plant":"Millennium Power","State":"MA","Gas":197.8,"coordinates":[-72.0151,42.1123]},{"Plant":"New Albany Energy Facility","State":"MS","Gas":360,"coordinates":[-88.9397,34.5408]},{"Plant":"Brownsville Peaking Power","State":"TN","Gas":449.82,"coordinates":[-89.198,35.5438]},{"Plant":"Caledonia Power Facility","State":"MS","Gas":441.18,"coordinates":[-88.3186,33.6482]},{"Plant":"Crockett Cogen Project","State":"CA","Gas":247.4,"coordinates":[-122.2161,38.0569]},{"Plant":"Gregory Power Facility","State":"TX","Gas":414,"coordinates":[-97.2584,27.8893]},{"Plant":"Zeeland Generating Station","State":"MI","Gas":290,"coordinates":[-85.9975,42.8206]},{"Plant":"Dearborn Industrial Generation","State":"MI","Gas":760,"coordinates":[-83.154,42.3026]},{"Plant":"Midlothian Energy Facility","State":"TX","Gas":860,"coordinates":[-97.0537,32.4302]},{"Plant":"Lamar Power Project","State":"TX","Gas":686.8,"coordinates":[-95.59,33.6308]},{"Plant":"Frontera Energy Center","State":"TX","Gas":300,"coordinates":[-98.3992,26.208]},{"Plant":"NRG Sterlington Power","State":"LA","Gas":173.35,"coordinates":[-92.0811,32.6889]},{"Plant":"Rumford Power Associates","State":"ME","Gas":164,"coordinates":[-70.5219,44.5303]},{"Plant":"Livingston Generating Station","State":"MI","Gas":132,"coordinates":[-84.7308,45.0304]},{"Plant":"Klamath Cogeneration Plant","State":"OR","Gas":470,"coordinates":[-121.8106,42.1739]},{"Plant":"Rocky Road Power LLC","State":"IL","Gas":340,"coordinates":[-88.2397,42.0931]},{"Plant":"Madison","State":"OH","Gas":580.72,"coordinates":[-84.4647,39.4522]},{"Plant":"Vermillion Energy Facility","State":"IN","Gas":560,"coordinates":[-87.4464,39.9223]},{"Plant":"Sutter Energy Center","State":"CA","Gas":530,"coordinates":[-121.6959,39.0531]},{"Plant":"Rockingham County CT Station","State":"NC","Gas":800,"coordinates":[-79.8297,36.3297]},{"Plant":"SRW Cogen LP","State":"TX","Gas":450,"coordinates":[-93.7574,30.0545]},{"Plant":"Magic Valley Generating Station","State":"TX","Gas":703,"coordinates":[-98.19,26.3403]},{"Plant":"Manchief Electric Generating Station","State":"CO","Gas":264,"coordinates":[-103.685,40.2171]},{"Plant":"Walton County Power LLC","State":"GA","Gas":483,"coordinates":[-83.6954,33.8148]},{"Plant":"Desert Basin","State":"AZ","Gas":598,"coordinates":[-111.7889,32.9042]},{"Plant":"Alliant Energy Neenah","State":"WI","Gas":308.5,"coordinates":[-88.5064,44.1936]},{"Plant":"Hawk Road Facility","State":"GA","Gas":495,"coordinates":[-84.9914,33.3585]},{"Plant":"Worthington Generation LLC","State":"IN","Gas":629,"coordinates":[-87.0128,39.0708]},{"Plant":"Lake Road Generating Plant","State":"CT","Gas":464,"coordinates":[-71.8958,41.872]},{"Plant":"ExxonMobil Baton Rouge Cogen","State":"LA","Gas":358.79,"coordinates":[-91.1808,30.5234]},{"Plant":"Guadalupe Generating Station","State":"TX","Gas":1000,"coordinates":[-98.1419,29.6244]},{"Plant":"Lost Pines 1 Power Project","State":"TX","Gas":340,"coordinates":[-97.2714,30.1478]},{"Plant":"Calcasieu","State":"LA","Gas":320,"coordinates":[-93.345,30.1608]},{"Plant":"Broad River Energy Center","State":"SC","Gas":775,"coordinates":[-81.575,35.0786]},{"Plant":"Bosque County Peaking","State":"TX","Gas":548,"coordinates":[-97.3586,31.8594]},{"Plant":"Eastman Cogeneration Facility","State":"TX","Gas":292.4,"coordinates":[-94.6903,32.4481]},{"Plant":"South Point Energy Center","State":"AZ","Gas":555,"coordinates":[-114.5317,34.8678]},{"Plant":"Dogwood Energy Facility","State":"MO","Gas":320,"coordinates":[-94.3006,38.7931]},{"Plant":"Rathdrum Power LLC","State":"ID","Gas":150,"coordinates":[-116.9203,47.7858]},{"Plant":"Champion Clean Energy","State":"ME","Gas":176,"coordinates":[-95.758,32.5184]},{"Plant":"Sunrise Power LLC","State":"CA","Gas":312,"coordinates":[-119.585,35.2097]},{"Plant":"Channelview Cogeneration Plant","State":"TX","Gas":167,"coordinates":[-95.1217,29.837]},{"Plant":"Cordova Energy","State":"IL","Gas":450,"coordinates":[-90.2797,41.7122]},{"Plant":"Osceola","State":"FL","Gas":312,"coordinates":[-81.0978,28.1289]},{"Plant":"Riverside Generating LLC","State":"KY","Gas":495,"coordinates":[-82.6046,38.1917]},{"Plant":"Elwood Energy LLC","State":"IL","Gas":1350,"coordinates":[-88.1236,41.4388]},{"Plant":"Gibson City","State":"IL","Gas":229.6,"coordinates":[-88.3987,40.4705]},{"Plant":"Pinckneyville","State":"IL","Gas":323.2,"coordinates":[-89.3467,38.1114]},{"Plant":"Kinmundy","State":"IL","Gas":229.6,"coordinates":[-89.0128,38.7619]},{"Plant":"ANP Blackstone Energy Project","State":"MA","Gas":433.5,"coordinates":[-71.5158,42.0599]},{"Plant":"Odessa Ector Generating Station","State":"TX","Gas":1026,"coordinates":[-102.3264,31.8403]},{"Plant":"Morris Cogeneration LLC","State":"IL","Gas":158,"coordinates":[-88.3328,41.4119]},{"Plant":"Los Medanos Energy Center","State":"CA","Gas":330,"coordinates":[-121.873,38.0301]},{"Plant":"Hinds Energy Facility","State":"MS","Gas":300,"coordinates":[-90.2199,32.379]},{"Plant":"Attala","State":"MS","Gas":294,"coordinates":[-89.6753,33.0147]},{"Plant":"Lincoln Generating Facility","State":"IL","Gas":588.24,"coordinates":[-87.9436,41.3933]},{"Plant":"Wheatland Generating Facility","State":"IN","Gas":472,"coordinates":[-87.2931,38.6716]},{"Plant":"Greenville Electric Generating Station","State":"OH","Gas":180,"coordinates":[-84.6151,40.0758]},{"Plant":"Montpelier Electric Generating Station","State":"IN","Gas":180,"coordinates":[-85.3057,40.6206]},{"Plant":"Handsome Lake Energy LLC","State":"PA","Gas":250,"coordinates":[-79.8061,41.2908]},{"Plant":"Audrain Generating Station","State":"MO","Gas":640,"coordinates":[-91.5369,39.3092]},{"Plant":"Lee Energy Facility","State":"IL","Gas":584,"coordinates":[-89.4054,41.8287]},{"Plant":"Energy Shelby County","State":"IL","Gas":344,"coordinates":[-88.4772,39.2794]},{"Plant":"NRG Rockford I","State":"IL","Gas":311,"coordinates":[-89.1012,42.2386]},{"Plant":"Hog Bayou Energy Center","State":"AL","Gas":230,"coordinates":[-88.0575,30.7478]},{"Plant":"Astoria Gas Turbines","State":"NY","Gas":420,"coordinates":[-73.9048,40.787]},{"Plant":"Doyle Energy Facility","State":"GA","Gas":355,"coordinates":[-83.6996,33.8377]},{"Plant":"Darby Electric Generating Station","State":"OH","Gas":292,"coordinates":[-83.1778,39.7139]},{"Plant":"University Park South","State":"IL","Gas":300,"coordinates":[-87.7532,41.4409]},{"Plant":"Gleason Generating Facility","State":"TN","Gas":540,"coordinates":[-88.612,36.2454]},{"Plant":"Edward L. Addison Generating Plant","State":"GA","Gas":600,"coordinates":[-84.3064,32.9111]},{"Plant":"Ceredo Generating Station","State":"WV","Gas":456.5,"coordinates":[-82.5339,38.3681]},{"Plant":"Aurora","State":"IL","Gas":750,"coordinates":[-88.2265,41.8151]},{"Plant":"Big Sandy Peaker Plant","State":"WV","Gas":300,"coordinates":[-82.5938,38.3441]},{"Plant":"Wolf Hills Energy","State":"VA","Gas":250,"coordinates":[-82.1044,36.6644]},{"Plant":"Westbrook Energy Center Power Plant","State":"ME","Gas":321,"coordinates":[-70.375,43.6575]},{"Plant":"Channel Energy Center LLC","State":"TX","Gas":175,"coordinates":[-95.2319,29.7189]},{"Plant":"Warren Peaking Power Facility","State":"MS","Gas":300,"coordinates":[-90.9284,32.2849]},{"Plant":"Baconton Power Plant","State":"GA","Gas":195.2,"coordinates":[-84.08,31.3869]},{"Plant":"Evangeline","State":"LA","Gas":778,"coordinates":[-92.2827,30.8987]},{"Plant":"Ingleside Cogeneration","State":"TX","Gas":310,"coordinates":[-97.2428,27.8828]},{"Plant":"Indian River","State":"FL","Gas":608,"coordinates":[-80.7802,28.4932]},{"Plant":"PPL Ironwood LLC","State":"PA","Gas":760.8,"coordinates":[-76.3658,40.3509]},{"Plant":"Exelon LaPorte Generating Station","State":"TX","Gas":168,"coordinates":[-95.0718,29.7028]},{"Plant":"RockGen Energy Center","State":"WI","Gas":462,"coordinates":[-89.0492,42.9767]},{"Plant":"Columbia Energy Center","State":"MO","Gas":138.4,"coordinates":[-92.2629,39.0192]},{"Plant":"Fountain Valley Power Facility","State":"CO","Gas":234,"coordinates":[-104.6875,38.5569]},{"Plant":"McClain Energy Facility","State":"OK","Gas":400,"coordinates":[-97.5898,35.2977]},{"Plant":"Tri Center Naniwa Energy","State":"NV","Gas":300,"coordinates":[-119.5178,39.5572]},{"Plant":"Wallingford Energy","State":"CT","Gas":190,"coordinates":[-72.8354,41.4487]},{"Plant":"Indigo Energy Facility","State":"CA","Gas":149.7,"coordinates":[-116.553,33.9109]},{"Plant":"Hidalgo Energy Center","State":"TX","Gas":252,"coordinates":[-98.1758,26.3417]},{"Plant":"Perryville Power Station","State":"LA","Gas":156,"coordinates":[-92.0183,32.6908]},{"Plant":"Spring Creek Energy Center","State":"OK","Gas":280,"coordinates":[-97.655,35.7422]},{"Plant":"Pierce Power Station","State":"WA","Gas":130.9,"coordinates":[-122.3758,47.1365]},{"Plant":"Power Plant 2","State":"TX","Gas":122.2,"coordinates":[-94.1,30.08]},{"Plant":"Big Cajun 1 Peakers","State":"LA","Gas":238,"coordinates":[-91.4145,30.6238]},{"Plant":"Olive","State":"CA","Gas":152.5,"coordinates":[-118.3147,34.1764]},{"Plant":"Collins","State":"IL","Gas":2671,"coordinates":[-88.3928,41.3461]},{"Plant":"Belle River","State":"MI","Gas":225,"coordinates":[-82.495,42.7756]},{"Plant":"Greenwood","State":"MI","Gas":225,"coordinates":[-82.6964,43.1056]},{"Plant":"Martin","State":"FL","Gas":1771.8,"coordinates":[-80.5628,27.0536]},{"Plant":"DeBary","State":"FL","Gas":258,"coordinates":[-81.3323,28.9039]},{"Plant":"Electrifarm","State":"IA","Gas":197,"coordinates":[-92.4205,42.4407]},{"Plant":"Fredonia","State":"WA","Gas":216,"coordinates":[-122.4358,48.4558]},{"Plant":"Victor J Daniel Jr","State":"MS","Gas":914.92,"coordinates":[-88.5553,30.5322]},{"Plant":"Greenwood","State":"MO","Gas":255.8,"coordinates":[-94.2982,38.8615]},{"Plant":"R M Schahfer","State":"IN","Gas":155,"coordinates":[-87.0261,41.2164]},{"Plant":"Cutler","State":"FL","Gas":215,"coordinates":[-80.2989,25.6321]},{"Plant":"Fort St Vrain","State":"CO","Gas":393.7,"coordinates":[-104.8742,40.2461]},{"Plant":"Whitehorn","State":"WA","Gas":158,"coordinates":[-122.6861,48.8288]},{"Plant":"McIntosh","State":"GA","Gas":668,"coordinates":[-81.1683,32.3563]},{"Plant":"Lauderdale","State":"FL","Gas":840,"coordinates":[-80.1984,26.0686]},{"Plant":"Port Everglades","State":"FL","Gas":420,"coordinates":[-80.1253,26.0856]},{"Plant":"Brame Energy Center","State":"LA","Gas":440,"coordinates":[-92.7167,31.395]},{"Plant":"Empire Energy Center","State":"MO","Gas":180,"coordinates":[-94.1041,37.1385]},{"Plant":"Dansby","State":"TX","Gas":110,"coordinates":[-96.4608,30.7217]},{"Plant":"Higgins","State":"FL","Gas":122,"coordinates":[-82.6615,28.0033]},{"Plant":"Rokeby","State":"NE","Gas":163.1,"coordinates":[-96.7364,40.7316]},{"Plant":"D G Hunter","State":"LA","Gas":157,"coordinates":[-92.4613,31.3207]},{"Plant":"George M Sullivan Generation Plant 2","State":"AK","Gas":185.9,"coordinates":[-149.7167,61.2297]},{"Plant":"Henry D King","State":"FL","Gas":122,"coordinates":[-80.3386,27.4486]},{"Plant":"Deerhaven Generating Station","State":"FL","Gas":195.5,"coordinates":[-82.3878,29.7592]},{"Plant":"J D Kennedy","State":"FL","Gas":158.6,"coordinates":[-81.626,30.3648]},{"Plant":"Larsen Memorial","State":"FL","Gas":167,"coordinates":[-81.9228,28.0797]},{"Plant":"C D McIntosh Jr","State":"FL","Gas":428,"coordinates":[-81.9229,28.0801]},{"Plant":"Indian River Plant","State":"FL","Gas":290,"coordinates":[-80.7801,28.4932]},{"Plant":"Arvah B Hopkins","State":"FL","Gas":350,"coordinates":[-84.4,30.4522]},{"Plant":"S O Purdom","State":"FL","Gas":301,"coordinates":[-84.2007,30.1623]},{"Plant":"Vero Beach Municipal Power Plant","State":"FL","Gas":150,"coordinates":[-80.3776,27.6334]},{"Plant":"Atkinson","State":"GA","Gas":182,"coordinates":[-84.4803,33.8175]},{"Plant":"Gravel Neck","State":"VA","Gas":292,"coordinates":[-76.6911,37.1575]},{"Plant":"McIntosh","State":"AL","Gas":340,"coordinates":[-88.0299,31.2546]},{"Plant":"Hay Road","State":"DE","Gas":336,"coordinates":[-75.5072,39.7436]},{"Plant":"Woodsdale","State":"OH","Gas":500.4,"coordinates":[-84.4611,39.4492]},{"Plant":"Concord","State":"WI","Gas":376,"coordinates":[-88.69,43.1669]},{"Plant":"South Fond Du Lac","State":"WI","Gas":333.8,"coordinates":[-88.4967,43.7353]},{"Plant":"Darbytown","State":"VA","Gas":288,"coordinates":[-77.3685,37.4982]},{"Plant":"Angus Anson","State":"SD","Gas":228.5,"coordinates":[-96.6356,43.6035]},{"Plant":"Cane Island","State":"FL","Gas":101,"coordinates":[-81.533,28.2764]},{"Plant":"Polk","State":"FL","Gas":150,"coordinates":[-81.9897,27.7286]},{"Plant":"491 E 48th Street","State":"MI","Gas":148.2,"coordinates":[-86.0853,42.7553]},{"Plant":"Paris","State":"WI","Gas":376,"coordinates":[-88.0131,42.6658]},{"Plant":"Lincoln Combustion","State":"NC","Gas":1267.2,"coordinates":[-81.0347,35.4317]},{"Plant":"State Line Combined Cycle","State":"MO","Gas":382,"coordinates":[-94.614,37.0659]},{"Plant":"Hines Energy Complex","State":"FL","Gas":482,"coordinates":[-81.87,27.7882]},{"Plant":"San Jacinto Steam Electric Station","State":"TX","Gas":162,"coordinates":[-95.0406,29.6948]},{"Plant":"Riverside","State":"GA","Gas":107,"coordinates":[-81.0956,32.0836]},{"Plant":"Robins","State":"GA","Gas":160,"coordinates":[-83.5822,32.5792]},{"Plant":"Coyote Springs","State":"OR","Gas":143,"coordinates":[-119.6739,45.848]},{"Plant":"Midulla Generating Station","State":"FL","Gas":504.82,"coordinates":[-81.9625,27.6417]},{"Plant":"Interstate","State":"IL","Gas":118,"coordinates":[-89.5891,39.8233]},{"Plant":"Rathdrum","State":"ID","Gas":136,"coordinates":[-116.8673,47.8043]},{"Plant":"Arthur Von Rosenberg","State":"TX","Gas":290,"coordinates":[-98.384,29.257]},{"Plant":"Wayne County","State":"NC","Gas":668,"coordinates":[-78.0981,35.3758]},{"Plant":"SCA Cogen 2","State":"CA","Gas":117,"coordinates":[-121.4001,38.5309]},{"Plant":"SPA Cogen 3","State":"CA","Gas":111,"coordinates":[-121.4735,38.511]},{"Plant":"St Francis Energy Facility","State":"MO","Gas":225,"coordinates":[-90.1779,36.5852]},{"Plant":"River Road Gen Plant","State":"WA","Gas":210,"coordinates":[-122.7256,45.6497]},{"Plant":"Tiger Bay","State":"FL","Gas":207,"coordinates":[-81.8494,27.7464]},{"Plant":"Dahlberg","State":"GA","Gas":750,"coordinates":[-83.3977,34.0423]},{"Plant":"Theodore Cogen Facility","State":"AL","Gas":231,"coordinates":[-88.1285,30.5254]},{"Plant":"Essex","State":"MO","Gas":107.4,"coordinates":[-89.8402,36.8682]},{"Plant":"Nodaway","State":"MO","Gas":182.8,"coordinates":[-94.7913,40.2877]},{"Plant":"Chouteau","State":"OK","Gas":330,"coordinates":[-95.2771,36.2221]},{"Plant":"Georgetown","State":"IN","Gas":259.5,"coordinates":[-86.2441,39.9026]},{"Plant":"Tilton","State":"IL","Gas":176,"coordinates":[-87.6538,40.1061]},{"Plant":"Henry County","State":"IN","Gas":114.75,"coordinates":[-85.5039,39.9528]},{"Plant":"MPC Generating","State":"GA","Gas":314.3,"coordinates":[-83.6953,33.8119]},{"Plant":"Sherwood H Smith Jr Energy Complex","State":"NC","Gas":720,"coordinates":[-79.7406,34.8392]},{"Plant":"Sewell Creek Energy","State":"GA","Gas":491.4,"coordinates":[-85.2769,33.9486]},{"Plant":"Alsey","State":"IL","Gas":125,"coordinates":[-90.436,39.5698]},{"Plant":"Fulton","State":"AR","Gas":153,"coordinates":[-93.7924,33.6094]},{"Plant":"Rowan","State":"NC","Gas":455.1,"coordinates":[-80.6019,35.7314]},{"Plant":"Smarr Energy Center","State":"GA","Gas":217.4,"coordinates":[-83.8464,32.9842]},{"Plant":"John S Rainey","State":"SC","Gas":447.2,"coordinates":[-82.776,34.3477]},{"Plant":"Remington","State":"VA","Gas":580,"coordinates":[-77.7714,38.5442]},{"Plant":"Ladysmith","State":"VA","Gas":290,"coordinates":[-77.5133,38.0722]},{"Plant":"Pleasant Valley","State":"MN","Gas":299.2,"coordinates":[-92.6829,43.7994]},{"Plant":"Lagoon Creek","State":"TN","Gas":616,"coordinates":[-89.3964,35.6578]},{"Plant":"MEPI GT Facility","State":"IL","Gas":256.2,"coordinates":[-88.8661,37.2175]},{"Plant":"Encogen","State":"WA","Gas":120,"coordinates":[-122.486,48.746]},{"Plant":"Sand Hill","State":"TX","Gas":174.4,"coordinates":[-97.6129,30.2098]},{"Plant":"Lakefield Junction","State":"MN","Gas":433.5,"coordinates":[-94.8415,43.7984]},{"Plant":"Sycamore","State":"IA","Gas":149,"coordinates":[-93.6769,41.6722]},{"Plant":"Intercession City","State":"FL","Gas":592,"coordinates":[-81.5486,28.2628]},{"Plant":"Gerald Andrus","State":"MS","Gas":741,"coordinates":[-91.1167,33.35]},{"Plant":"Waterford 1 & 2","State":"LA","Gas":811,"coordinates":[-90.4768,29.9989]},{"Plant":"Comanche","State":"OK","Gas":273,"coordinates":[-98.3244,34.5431]},{"Plant":"DeCordova Steam Electric Station","State":"TX","Gas":1113,"coordinates":[-97.7006,32.4031]},{"Plant":"Santan","State":"AZ","Gas":368,"coordinates":[-111.7503,33.3325]},{"Plant":"Beaver","State":"OR","Gas":351.6,"coordinates":[-123.1739,46.1724]},{"Plant":"Glen Gardner","State":"NJ","Gas":156.66,"coordinates":[-74.9207,40.6815]},{"Plant":"Grand Tower","State":"IL","Gas":213.2,"coordinates":[-89.5112,37.6577]},{"Plant":"Calumet","State":"IL","Gas":203.9,"coordinates":[-87.5428,41.7136]},{"Plant":"Crawford","State":"IL","Gas":172.8,"coordinates":[-87.7229,41.8285]},{"Plant":"Electric Junction","State":"IL","Gas":207.5,"coordinates":[-88.0833,41.8333]},{"Plant":"Joliet 9","State":"IL","Gas":115.1,"coordinates":[-88.1153,41.4931]},{"Plant":"Astoria Generating Station","State":"NY","Gas":190,"coordinates":[-73.9126,40.7877]},{"Plant":"Wood River","State":"IL","Gas":129.9,"coordinates":[-90.1347,38.8639]},{"Plant":"Beluga","State":"AK","Gas":310,"coordinates":[-151.0356,61.1861]},{"Plant":"Frederickson","State":"WA","Gas":158,"coordinates":[-122.365,47.0797]},{"Plant":"Harding Street","State":"IN","Gas":157,"coordinates":[-86.1969,39.7113]},{"Plant":"Dean H Mitchell","State":"IN","Gas":142,"coordinates":[-87.4069,41.6392]},{"Plant":"Michigan City","State":"IN","Gas":120,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Gas":995,"coordinates":[-87.7811,32.6017]},{"Plant":"NRG Energy Center Dover","State":"DE","Gas":104.4,"coordinates":[-75.5473,39.1495]},{"Plant":"Gilroy Power Plant","State":"CA","Gas":130,"coordinates":[-121.5367,37.0001]},{"Plant":"Pedricktown Cogeneration Company LP","State":"NJ","Gas":115.7,"coordinates":[-75.4238,39.7668]},{"Plant":"Broadway","State":"IN","Gas":115,"coordinates":[-87.6049,37.9691]},{"Plant":"Butler-Warner Generation Plant","State":"NC","Gas":283,"coordinates":[-78.8294,35.0986]},{"Plant":"El Segundo Cogen","State":"CA","Gas":127.7,"coordinates":[-118.4031,33.9058]},{"Plant":"ArcelorMittal Burns Harbor","State":"IN","Gas":177.7,"coordinates":[-87.1387,41.635]},{"Plant":"King City Power Plant","State":"CA","Gas":111,"coordinates":[-121.1278,36.225]},{"Plant":"Bayou Cogen Plant","State":"TX","Gas":260,"coordinates":[-95.0458,29.6225]},{"Plant":"Bellingham Cogeneration Facility","State":"MA","Gas":259,"coordinates":[-71.4833,42.0925]},{"Plant":"Sayreville Cogeneration Facility","State":"NJ","Gas":261,"coordinates":[-74.3444,40.439]},{"Plant":"Foster Wheeler Martinez","State":"CA","Gas":103.5,"coordinates":[-122.0589,38.0244]},{"Plant":"ExxonMobil Baytown Refinery","State":"TX","Gas":183.89,"coordinates":[-94.9973,29.7535]},{"Plant":"RG Steel Sparrows Point, LLC","State":"MD","Gas":152.3,"coordinates":[-76.4729,39.213]},{"Plant":"Kern River Cogeneration","State":"CA","Gas":294.8,"coordinates":[-118.9849,35.4515]},{"Plant":"Formosa Utility Venture Ltd","State":"TX","Gas":524.8,"coordinates":[-96.5417,28.6917]},{"Plant":"Hopewell Cogeneration","State":"VA","Gas":348.3,"coordinates":[-77.2811,37.2917]},{"Plant":"CES Placerita Power Plant","State":"CA","Gas":115,"coordinates":[-118.4999,34.3801]},{"Plant":"ExxonMobil Baytown Turbine","State":"TX","Gas":180.13,"coordinates":[-95.0096,29.7591]},{"Plant":"Selkirk Cogen","State":"NY","Gas":367,"coordinates":[-73.8592,42.5744]},{"Plant":"Masspower","State":"MA","Gas":231.5,"coordinates":[-72.5225,42.1575]},{"Plant":"Clear Lake Cogeneration Ltd","State":"TX","Gas":300,"coordinates":[-95.067,29.6255]},{"Plant":"Midland Cogeneration Venture","State":"MI","Gas":1802.31,"coordinates":[-84.2242,43.5861]},{"Plant":"Camden Plant Holding LLC","State":"NJ","Gas":148.5,"coordinates":[-75.1192,39.9175]},{"Plant":"River Hills","State":"IA","Gas":120,"coordinates":[-93.6195,41.5902]},{"Plant":"Hazelton","State":"PA","Gas":146.3,"coordinates":[-76.0409,40.9282]},{"Plant":"Ocotillo","State":"AZ","Gas":320,"coordinates":[-111.9122,33.4225]},{"Plant":"West Phoenix","State":"AZ","Gas":448.3,"coordinates":[-112.1583,33.4417]},{"Plant":"Saguaro","State":"AZ","Gas":310,"coordinates":[-111.3,32.5517]},{"Plant":"Yucca","State":"AZ","Gas":163,"coordinates":[-114.7106,32.7214]},{"Plant":"Gordon Evans Energy Center","State":"KS","Gas":833,"coordinates":[-97.5217,37.7903]},{"Plant":"Murray Gill","State":"KS","Gas":323,"coordinates":[-97.4136,37.5967]},{"Plant":"Hutchinson Energy Center","State":"KS","Gas":478,"coordinates":[-97.8747,38.0906]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Gas":316,"coordinates":[-110.9047,32.16]},{"Plant":"Kaw","State":"KS","Gas":129,"coordinates":[-94.6514,39.0867]},{"Plant":"McPherson 2","State":"KS","Gas":131.5,"coordinates":[-97.6834,38.3634]},{"Plant":"Garden City","State":"KS","Gas":226,"coordinates":[-100.8956,37.9703]},{"Plant":"E W Brown","State":"KY","Gas":962,"coordinates":[-84.7126,37.7883]},{"Plant":"Paddys Run","State":"KY","Gas":193,"coordinates":[-85.8417,38.2236]},{"Plant":"Louisiana 1","State":"LA","Gas":366.8,"coordinates":[-91.1864,30.4922]},{"Plant":"Louisiana 2","State":"LA","Gas":140,"coordinates":[-91.1864,30.4922]},{"Plant":"R S Nelson","State":"LA","Gas":653,"coordinates":[-93.2911,30.2844]},{"Plant":"Willow Glen","State":"LA","Gas":1787,"coordinates":[-91.1164,30.2743]},{"Plant":"Coughlin Power Station","State":"LA","Gas":773,"coordinates":[-92.2611,30.8439]},{"Plant":"Teche","State":"LA","Gas":430,"coordinates":[-91.5425,29.8222]},{"Plant":"Little Gypsy","State":"LA","Gas":1204,"coordinates":[-90.4617,30.0051]},{"Plant":"Nine Mile Point","State":"LA","Gas":1705,"coordinates":[-90.1458,29.9472]},{"Plant":"Sterlington","State":"LA","Gas":537,"coordinates":[-92.0792,32.7047]},{"Plant":"A B Paterson","State":"LA","Gas":122,"coordinates":[-90.0256,30.0158]},{"Plant":"Michoud","State":"LA","Gas":825,"coordinates":[-89.9372,30.0081]},{"Plant":"Agua Fria","State":"AZ","Gas":626,"coordinates":[-112.2153,33.5561]},{"Plant":"Arsenal Hill","State":"LA","Gas":110,"coordinates":[-93.7611,32.5181]},{"Plant":"Lieberman","State":"LA","Gas":271,"coordinates":[-93.9597,32.7047]},{"Plant":"Louis Doc Bonin","State":"LA","Gas":302,"coordinates":[-92.0463,30.238]},{"Plant":"Monroe","State":"LA","Gas":117,"coordinates":[-92.1794,32.5233]},{"Plant":"Big Cajun 1","State":"LA","Gas":238,"coordinates":[-91.3556,30.6739]},{"Plant":"Kyrene","State":"AZ","Gas":522,"coordinates":[-111.9353,33.3556]},{"Plant":"Notch Cliff","State":"MD","Gas":128,"coordinates":[-76.5087,39.4217]},{"Plant":"Riverside","State":"MD","Gas":207,"coordinates":[-76.5133,39.2369]},{"Plant":"Westport","State":"MD","Gas":121,"coordinates":[-76.6295,39.266]},{"Plant":"Chalk Point LLC","State":"MD","Gas":474,"coordinates":[-76.6861,38.5444]},{"Plant":"Dickerson","State":"MD","Gas":294,"coordinates":[-77.4644,39.2097]},{"Plant":"New Boston Generating Station","State":"MA","Gas":702,"coordinates":[-71.0353,42.3392]},{"Plant":"Kendall Square Station","State":"MA","Gas":175,"coordinates":[-71.0792,42.3633]},{"Plant":"Cecil Lynch","State":"AR","Gas":170,"coordinates":[-92.1987,34.7535]},{"Plant":"Hamilton Moses","State":"AR","Gas":138,"coordinates":[-90.8722,34.9806]},{"Plant":"Harvey Couch","State":"AR","Gas":148,"coordinates":[-93.4649,33.3592]},{"Plant":"B C Cobb","State":"MI","Gas":189,"coordinates":[-86.2423,43.2588]},{"Plant":"Lake Catherine","State":"AR","Gas":688,"coordinates":[-92.9049,34.4341]},{"Plant":"Dan E Karn","State":"MI","Gas":1276,"coordinates":[-83.8401,43.645]},{"Plant":"Thetford","State":"MI","Gas":192,"coordinates":[-83.6286,43.1567]},{"Plant":"Conners Creek","State":"MI","Gas":200,"coordinates":[-82.9597,42.3592]},{"Plant":"Delray","State":"MI","Gas":127,"coordinates":[-83.1019,42.2947]},{"Plant":"Robert E Ritchie","State":"AR","Gas":878,"coordinates":[-90.5987,34.4629]},{"Plant":"Hancock","State":"MI","Gas":141,"coordinates":[-83.4425,42.5497]},{"Plant":"River Rouge","State":"MI","Gas":225,"coordinates":[-83.1119,42.2739]},{"Plant":"Mistersky","State":"MI","Gas":154,"coordinates":[-83.0903,42.3039]},{"Plant":"Carl Bailey","State":"AR","Gas":122,"coordinates":[-91.3634,35.2601]},{"Plant":"McClellan","State":"AR","Gas":134,"coordinates":[-92.7917,33.5648]},{"Plant":"Chevron Oil","State":"MS","Gas":127,"coordinates":[-88.4919,30.34]},{"Plant":"Sweatt","State":"MS","Gas":125.6,"coordinates":[-88.7461,32.2925]},{"Plant":"Jack Watson","State":"MS","Gas":299,"coordinates":[-89.0286,30.4392]},{"Plant":"Baxter Wilson","State":"MS","Gas":1215,"coordinates":[-90.9306,32.2831]},{"Plant":"Delta","State":"MS","Gas":194,"coordinates":[-90.7139,33.7947]},{"Plant":"Rex Brown","State":"MS","Gas":295,"coordinates":[-90.213,32.357]},{"Plant":"L L Wilkins","State":"MS","Gas":311.5,"coordinates":[-90.5627,34.1845]},{"Plant":"Moselle","State":"MS","Gas":260,"coordinates":[-89.3004,31.528]},{"Plant":"Hawthorn","State":"MO","Gas":423,"coordinates":[-94.4778,39.1306]},{"Plant":"Lake Road","State":"MO","Gas":117,"coordinates":[-94.8773,39.7246]},{"Plant":"James River Power Station","State":"MO","Gas":155,"coordinates":[-93.2619,37.1086]},{"Plant":"Canaday","State":"NE","Gas":117.95,"coordinates":[-99.7011,40.6942]},{"Plant":"C W Burdick","State":"NE","Gas":107.3,"coordinates":[-98.3269,40.9228]},{"Plant":"Contra Costa","State":"CA","Gas":672,"coordinates":[-121.7642,38.0192]},{"Plant":"Clark","State":"NV","Gas":700,"coordinates":[-115.0507,36.0875]},{"Plant":"Sunrise","State":"NV","Gas":149,"coordinates":[-115.036,36.1384]},{"Plant":"Fort Churchill","State":"NV","Gas":226,"coordinates":[-119.1322,39.1281]},{"Plant":"Tracy","State":"NV","Gas":471,"coordinates":[-119.525,39.5625]},{"Plant":"Deepwater","State":"NJ","Gas":105,"coordinates":[-75.5083,39.6831]},{"Plant":"Sayreville","State":"NJ","Gas":220,"coordinates":[-74.3523,40.4765]},{"Plant":"Gilbert","State":"NJ","Gas":529,"coordinates":[-75.1639,40.5658]},{"Plant":"Bergen Generating Station","State":"NJ","Gas":1224,"coordinates":[-74.0244,40.8375]},{"Plant":"PSEG Burlington Generating Station","State":"NJ","Gas":413,"coordinates":[-74.8792,40.0766]},{"Plant":"PSEG Edison Generating Station","State":"NJ","Gas":504,"coordinates":[-74.3956,40.4911]},{"Plant":"PSEG Essex Generating Station","State":"NJ","Gas":617,"coordinates":[-74.1206,40.7372]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Gas":383,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Kearny Generating Station","State":"NJ","Gas":647.6,"coordinates":[-74.0965,40.7373]},{"Plant":"PSEG Linden Generating Station","State":"NJ","Gas":345,"coordinates":[-74.2072,40.6217]},{"Plant":"PSEG Sewaren Generating Station","State":"NJ","Gas":453,"coordinates":[-74.2469,40.5558]},{"Plant":"Rio Grande","State":"NM","Gas":238,"coordinates":[-106.5472,31.8047]},{"Plant":"Maddox","State":"NM","Gas":193,"coordinates":[-103.3015,32.7142]},{"Plant":"Reeves","State":"NM","Gas":154,"coordinates":[-106.6019,35.171]},{"Plant":"Cunningham","State":"NM","Gas":487,"coordinates":[-103.3533,32.7131]},{"Plant":"Humboldt Bay","State":"CA","Gas":105,"coordinates":[-124.2103,40.7415]},{"Plant":"Hunters Point","State":"CA","Gas":377,"coordinates":[-122.3897,37.7336]},{"Plant":"Arthur Kill Generating Station","State":"NY","Gas":841,"coordinates":[-74.2,40.5916]},{"Plant":"Gowanus Gas Turbines Generating","State":"NY","Gas":266,"coordinates":[-74.0051,40.6635]},{"Plant":"Narrows Gas Turbines Generating","State":"NY","Gas":266,"coordinates":[-74.0208,40.6486]},{"Plant":"Ravenswood","State":"NY","Gas":2173.9,"coordinates":[-73.9461,40.7592]},{"Plant":"E F Barrett","State":"NY","Gas":697.8,"coordinates":[-73.6479,40.6167]},{"Plant":"Far Rockaway","State":"NY","Gas":110.1,"coordinates":[-73.761,40.6109]},{"Plant":"Glenwood","State":"NY","Gas":229,"coordinates":[-73.6475,40.8271]},{"Plant":"Northport","State":"NY","Gas":779,"coordinates":[-73.3423,40.9236]},{"Plant":"Port Jefferson","State":"NY","Gas":294.9,"coordinates":[-73.0785,40.9497]},{"Plant":"Dynegy Morro Bay LLC","State":"CA","Gas":999,"coordinates":[-120.8566,35.3722]},{"Plant":"Oswego Harbor Power","State":"NY","Gas":838.3,"coordinates":[-76.5319,43.4586]},{"Plant":"Dynegy Moss Landing Power Plant","State":"CA","Gas":2680.28,"coordinates":[-121.7822,36.8048]},{"Plant":"Bowline Point","State":"NY","Gas":1139,"coordinates":[-73.9689,41.2044]},{"Plant":"Asheville","State":"NC","Gas":545,"coordinates":[-82.5417,35.4731]},{"Plant":"Pittsburg Power","State":"CA","Gas":1906,"coordinates":[-121.8945,38.0392]},{"Plant":"Potrero Power","State":"CA","Gas":206,"coordinates":[-122.387,37.7566]},{"Plant":"Dicks Creek","State":"OH","Gas":106.2,"coordinates":[-84.3778,39.465]},{"Plant":"Frank M Tait","State":"OH","Gas":256,"coordinates":[-84.2111,39.7272]},{"Plant":"Yankee Street","State":"OH","Gas":107,"coordinates":[-84.2047,39.603]},{"Plant":"FirstEnergy West Lorain","State":"OH","Gas":361,"coordinates":[-82.2644,41.4294]},{"Plant":"Richland","State":"OH","Gas":358,"coordinates":[-84.3346,41.3052]},{"Plant":"Horseshoe Lake","State":"OK","Gas":860,"coordinates":[-97.1797,35.5087]},{"Plant":"Muskogee","State":"OK","Gas":149,"coordinates":[-95.2873,35.7614]},{"Plant":"Mustang","State":"OK","Gas":533,"coordinates":[-97.675,35.4699]},{"Plant":"Seminole","State":"OK","Gas":1535.6,"coordinates":[-96.7258,34.9665]},{"Plant":"Northeastern","State":"OK","Gas":600,"coordinates":[-95.7008,36.4317]},{"Plant":"Southwestern","State":"OK","Gas":472,"coordinates":[-98.3524,35.1009]},{"Plant":"Tulsa","State":"OK","Gas":400,"coordinates":[-95.991,36.1165]},{"Plant":"Weleetka","State":"OK","Gas":162,"coordinates":[-96.1352,35.3233]},{"Plant":"Barry","State":"AL","Gas":862,"coordinates":[-88.0103,31.0069]},{"Plant":"Anadarko Plant","State":"OK","Gas":357,"coordinates":[-98.23,35.0847]},{"Plant":"Mooreland","State":"OK","Gas":337,"coordinates":[-99.2254,36.4372]},{"Plant":"Encina","State":"CA","Gas":958,"coordinates":[-117.3364,33.1361]},{"Plant":"Kearny","State":"CA","Gas":127,"coordinates":[-117.1338,32.834]},{"Plant":"Brunot Island","State":"PA","Gas":145,"coordinates":[-80.0438,40.4649]},{"Plant":"Dynegy South Bay Power Plant","State":"CA","Gas":707,"coordinates":[-117.092,32.6114]},{"Plant":"PPL Martins Creek","State":"PA","Gas":1670,"coordinates":[-75.1054,40.7978]},{"Plant":"AES Alamitos LLC","State":"CA","Gas":2083,"coordinates":[-118.1009,33.7688]},{"Plant":"Cromby Generating Station","State":"PA","Gas":201,"coordinates":[-75.5294,40.1531]},{"Plant":"Manchester Street","State":"RI","Gas":421.4,"coordinates":[-71.4042,41.8167]},{"Plant":"Darlington County","State":"SC","Gas":448,"coordinates":[-80.1657,34.4185]},{"Plant":"Coolwater","State":"CA","Gas":608,"coordinates":[-116.8539,34.8606]},{"Plant":"Urquhart","State":"SC","Gas":389,"coordinates":[-81.9111,33.435]},{"Plant":"El Segundo Power","State":"CA","Gas":940.54,"coordinates":[-118.4242,33.9098]},{"Plant":"Etiwanda Generating Station","State":"CA","Gas":1019,"coordinates":[-117.5266,34.0912]},{"Plant":"Riverside Canal Power","State":"CA","Gas":127,"coordinates":[-117.3312,34.0229]},{"Plant":"AES Huntington Beach LLC","State":"CA","Gas":563,"coordinates":[-117.9792,33.6439]},{"Plant":"Allen Steam Plant","State":"TN","Gas":456,"coordinates":[-90.1487,35.0741]},{"Plant":"Gallatin","State":"TN","Gas":596,"coordinates":[-86.4006,36.3156]},{"Plant":"Johnsonville","State":"TN","Gas":1112,"coordinates":[-87.9861,36.0278]},{"Plant":"Long Beach Generation LLC","State":"CA","Gas":584,"coordinates":[-118.2248,33.7641]},{"Plant":"E S Joslin","State":"TX","Gas":254,"coordinates":[-96.5458,28.6472]},{"Plant":"J L Bates","State":"TX","Gas":182,"coordinates":[-98.3944,26.2222]},{"Plant":"Laredo","State":"TX","Gas":178,"coordinates":[-99.5089,27.5667]},{"Plant":"Lon C Hill","State":"TX","Gas":559,"coordinates":[-97.6167,27.85]},{"Plant":"Nueces Bay","State":"TX","Gas":559,"coordinates":[-97.4192,27.8194]},{"Plant":"La Palma","State":"TX","Gas":255,"coordinates":[-97.6389,26.1331]},{"Plant":"Victoria","State":"TX","Gas":491,"coordinates":[-97.01,28.7883]},{"Plant":"Mandalay","State":"CA","Gas":560,"coordinates":[-119.2511,34.2067]},{"Plant":"Lake Hubbard","State":"TX","Gas":926,"coordinates":[-96.5458,32.8358]},{"Plant":"Mountain Creek","State":"TX","Gas":890,"coordinates":[-96.9358,32.7231]},{"Plant":"North Lake","State":"TX","Gas":675,"coordinates":[-96.975,32.9506]},{"Plant":"Parkdale","State":"TX","Gas":334,"coordinates":[-96.7233,32.7767]},{"Plant":"Newman","State":"TX","Gas":498,"coordinates":[-106.4318,31.9836]},{"Plant":"Lewis Creek","State":"TX","Gas":520,"coordinates":[-95.5214,30.4356]},{"Plant":"Neches","State":"TX","Gas":265,"coordinates":[-94.0593,30.0612]},{"Plant":"Sabine","State":"TX","Gas":1843,"coordinates":[-93.878,30.0242]},{"Plant":"Cedar Bayou","State":"TX","Gas":2320,"coordinates":[-94.9256,29.75]},{"Plant":"Deepwater","State":"TX","Gas":174,"coordinates":[-95.2253,29.7199]},{"Plant":"Greens Bayou","State":"TX","Gas":774,"coordinates":[-95.2194,29.8222]},{"Plant":"P H Robinson","State":"TX","Gas":2265,"coordinates":[-94.9794,29.4867]},{"Plant":"Sam Bertron","State":"TX","Gas":876,"coordinates":[-95.0598,29.7268]},{"Plant":"T H Wharton","State":"TX","Gas":1262,"coordinates":[-95.5306,29.9417]},{"Plant":"W A Parish","State":"TX","Gas":1216,"coordinates":[-95.6311,29.4828]},{"Plant":"Webster","State":"TX","Gas":403,"coordinates":[-95.1081,29.5258]},{"Plant":"Knox Lee","State":"TX","Gas":486,"coordinates":[-94.6415,32.3766]},{"Plant":"Wilkes","State":"TX","Gas":882,"coordinates":[-94.548,32.8482]},{"Plant":"Jones","State":"TX","Gas":486,"coordinates":[-101.7392,33.5239]},{"Plant":"Nichols","State":"TX","Gas":457,"coordinates":[-101.7464,35.2834]},{"Plant":"Plant X","State":"TX","Gas":442,"coordinates":[-102.4114,34.1661]},{"Plant":"Eagle Mountain","State":"TX","Gas":671,"coordinates":[-97.4792,32.9056]},{"Plant":"Graham","State":"TX","Gas":641,"coordinates":[-98.6117,33.1344]},{"Plant":"Handley","State":"TX","Gas":1421,"coordinates":[-97.2192,32.7283]},{"Plant":"Morgan Creek","State":"TX","Gas":1280,"coordinates":[-100.9156,32.3358]},{"Plant":"Permian Basin","State":"TX","Gas":1020,"coordinates":[-102.9633,31.5839]},{"Plant":"Ormond Beach","State":"CA","Gas":1499,"coordinates":[-119.1689,34.1292]},{"Plant":"Collin","State":"TX","Gas":154,"coordinates":[-96.8034,33.1576]},{"Plant":"Lake Creek","State":"TX","Gas":318,"coordinates":[-96.985,31.4647]},{"Plant":"River Crest","State":"TX","Gas":111,"coordinates":[-95.1467,33.3931]},{"Plant":"Stryker Creek","State":"TX","Gas":693,"coordinates":[-94.9898,31.9398]},{"Plant":"Tradinghouse","State":"TX","Gas":1375,"coordinates":[-96.9642,31.5728]},{"Plant":"Trinidad","State":"TX","Gas":236,"coordinates":[-96.1013,32.1245]},{"Plant":"Valley","State":"TX","Gas":727,"coordinates":[-96.3676,33.6281]},{"Plant":"Paint Creek","State":"TX","Gas":231,"coordinates":[-99.7337,33.1576]},{"Plant":"Rio Pecos","State":"TX","Gas":141,"coordinates":[-102.3753,31.0706]},{"Plant":"San Angelo","State":"TX","Gas":123,"coordinates":[-100.491,31.3906]},{"Plant":"Decker Creek","State":"TX","Gas":1010,"coordinates":[-97.6128,30.3033]},{"Plant":"Holly Street","State":"TX","Gas":591,"coordinates":[-97.7167,30.25]},{"Plant":"AES Redondo Beach LLC","State":"CA","Gas":1310,"coordinates":[-118.395,33.8504]},{"Plant":"Bryan","State":"TX","Gas":130,"coordinates":[-96.3723,30.6474]},{"Plant":"Ray Olinger","State":"TX","Gas":405.3,"coordinates":[-96.4525,33.0681]},{"Plant":"Mountainview Generating Station","State":"CA","Gas":120,"coordinates":[-117.2418,34.0818]},{"Plant":"Sim Gideon","State":"TX","Gas":620,"coordinates":[-97.2708,30.1456]},{"Plant":"Ty Cooke","State":"TX","Gas":148.6,"coordinates":[-101.7906,33.5211]},{"Plant":"J Robert Massengale","State":"TX","Gas":107,"coordinates":[-101.8408,33.6039]},{"Plant":"Leon Creek","State":"TX","Gas":160,"coordinates":[-98.5761,29.3525]},{"Plant":"O W Sommers","State":"TX","Gas":850,"coordinates":[-98.3242,29.3081]},{"Plant":"V H Braunig","State":"TX","Gas":862,"coordinates":[-98.3825,29.2567]},{"Plant":"W B Tuttle","State":"TX","Gas":425,"coordinates":[-98.4181,29.53]},{"Plant":"R W Miller","State":"TX","Gas":611,"coordinates":[-98.3103,32.6581]},{"Plant":"Gadsby","State":"UT","Gas":349,"coordinates":[-111.9289,40.7686]},{"Plant":"Grayson","State":"CA","Gas":250,"coordinates":[-118.2782,34.1556]},{"Plant":"Chesterfield","State":"VA","Gas":397,"coordinates":[-77.3833,37.3822]},{"Plant":"Transalta Centralia Generation","State":"WA","Gas":256,"coordinates":[-122.8598,46.7559]},{"Plant":"El Centro","State":"CA","Gas":225.9,"coordinates":[-115.54,32.8022]},{"Plant":"Harbor","State":"CA","Gas":500,"coordinates":[-118.2656,33.7706]},{"Plant":"Haynes","State":"CA","Gas":1570,"coordinates":[-118.0991,33.7647]},{"Plant":"Scattergood","State":"CA","Gas":803,"coordinates":[-118.4276,33.9182]},{"Plant":"Rock River","State":"WI","Gas":160.4,"coordinates":[-89.0276,42.582]},{"Plant":"West Marinette","State":"WI","Gas":155.9,"coordinates":[-87.6881,45.0869]},{"Plant":"Valley","State":"CA","Gas":564,"coordinates":[-118.3913,34.245]},{"Plant":"Broadway","State":"CA","Gas":161,"coordinates":[-118.148,34.1254]},{"Plant":"Spencer","State":"TX","Gas":179,"coordinates":[-97.1061,33.1975]},{"Plant":"Colbert","State":"AL","Gas":392,"coordinates":[-87.8486,34.7439]},{"Plant":"Zuni","State":"CO","Gas":107,"coordinates":[-105.017,39.7373]},{"Plant":"Thomas C Ferguson","State":"TX","Gas":420,"coordinates":[-98.3705,30.558]},{"Plant":"Fort Phantom","State":"TX","Gas":362,"coordinates":[-99.6778,32.5784]},{"Plant":"Barney M Davis","State":"TX","Gas":697,"coordinates":[-97.3117,27.6064]},{"Plant":"Riverside","State":"OK","Gas":917,"coordinates":[-95.9567,35.9978]},{"Plant":"Pittsfield Generating LP","State":"MA","Gas":141,"coordinates":[-73.2181,42.4564]},{"Plant":"Linden Cogen Plant","State":"NJ","Gas":899.8,"coordinates":[-74.2156,40.6322]},{"Plant":"Houston Chemical Complex Battleground","State":"TX","Gas":198,"coordinates":[-95.0839,29.7314]},{"Plant":"Sycamore Cogeneration","State":"CA","Gas":306,"coordinates":[-118.9853,35.4526]},{"Plant":"Union Carbide Seadrift Cogen","State":"TX","Gas":168,"coordinates":[-96.7706,28.5105]},{"Plant":"Dow St Charles Operations","State":"LA","Gas":291.6,"coordinates":[-90.4414,29.9861]},{"Plant":"Watson Cogeneration","State":"CA","Gas":398,"coordinates":[-118.2448,33.8166]},{"Plant":"Bethpage Power Plant","State":"NY","Gas":102,"coordinates":[-73.4994,40.7469]},{"Plant":"Shell Deer Park","State":"TX","Gas":234.65,"coordinates":[-95.1289,29.7232]},{"Plant":"Newark Bay Cogeneration Partnership LP","State":"NJ","Gas":118,"coordinates":[-74.13,40.7197]},{"Plant":"Mobile Energy Services LLC","State":"AL","Gas":124.9,"coordinates":[-88.0516,30.7365]},{"Plant":"Indeck Corinth Energy Center","State":"NY","Gas":131.5,"coordinates":[-73.8125,43.25]},{"Plant":"PPG Riverside","State":"LA","Gas":154,"coordinates":[-93.2807,30.2217]},{"Plant":"PPG Powerhouse C","State":"LA","Gas":303.2,"coordinates":[-93.2831,30.2242]},{"Plant":"Bayonne Plant Holding LLC","State":"NJ","Gas":170,"coordinates":[-74.1124,40.6553]},{"Plant":"Harbor Cogen","State":"CA","Gas":101.7,"coordinates":[-118.2303,33.7771]},{"Plant":"Rosemary Power Station","State":"NC","Gas":165,"coordinates":[-77.6594,36.4517]},{"Plant":"Oklahoma Cogeneration Project","State":"OK","Gas":111.4,"coordinates":[-97.625,35.4397]},{"Plant":"Eagle Point Power Generation","State":"NJ","Gas":195,"coordinates":[-75.1592,39.8746]},{"Plant":"TXU Sweetwater Generating Plant","State":"TX","Gas":264.7,"coordinates":[-100.365,32.4928]},{"Plant":"ExxonMobil Beaumont Refinery","State":"TX","Gas":201.2,"coordinates":[-94.0753,30.0636]},{"Plant":"JM Shafer Generating Station","State":"CO","Gas":248.54,"coordinates":[-104.7736,40.0986]},{"Plant":"Gary Works","State":"IN","Gas":221,"coordinates":[-87.3289,41.6224]},{"Plant":"Parlin Power Plant","State":"NJ","Gas":118,"coordinates":[-74.3272,40.4607]},{"Plant":"Optim Energy Altura Cogen LLC","State":"TX","Gas":448,"coordinates":[-95.1077,29.8161]},{"Plant":"Gramercy Holdings LLC","State":"LA","Gas":106,"coordinates":[-90.6693,30.054]},{"Plant":"Hardee Power Station","State":"FL","Gas":358,"coordinates":[-81.9636,27.6364]},{"Plant":"Bellmeade Power Station","State":"VA","Gas":230,"coordinates":[-77.4317,37.4964]},{"Plant":"Pryor Power Plant","State":"OK","Gas":111.5,"coordinates":[-95.3175,36.2977]},{"Plant":"Ocean State Power","State":"RI","Gas":218.62,"coordinates":[-71.6689,42.0097]},{"Plant":"LaO Energy Systems","State":"LA","Gas":588,"coordinates":[-91.2325,30.3186]},{"Plant":"Doswell Energy Center","State":"VA","Gas":819.8,"coordinates":[-77.1448,37.8182]},{"Plant":"Elizabeth River Power Station","State":"VA","Gas":312,"coordinates":[-76.3083,36.775]},{"Plant":"Texas City Power Plant","State":"TX","Gas":451,"coordinates":[-94.9438,29.3787]},{"Plant":"Dow Chemical Texas Operation","State":"TX","Gas":1378.6,"coordinates":[-95.4075,28.9913]},{"Plant":"Power Station 4","State":"TX","Gas":172,"coordinates":[-94.9219,29.3782]},{"Plant":"Midway Sunset Cogen","State":"CA","Gas":219,"coordinates":[-119.6294,35.2269]},{"Plant":"C R Wing Cogen Plant","State":"TX","Gas":227,"coordinates":[-101.4224,32.2732]},{"Plant":"Delaware City Plant","State":"DE","Gas":383.12,"coordinates":[-75.6343,39.5871]},{"Plant":"McWilliams","State":"AL","Gas":658,"coordinates":[-86.4764,31.4003]},{"Plant":"J K Smith","State":"KY","Gas":478,"coordinates":[-84.1017,37.8833]},{"Plant":"Lockport Energy Associates LP","State":"NY","Gas":210.2,"coordinates":[-78.745,43.1619]},{"Plant":"Kennedy International Airport Cogen","State":"NY","Gas":112.4,"coordinates":[-73.7778,40.6417]},{"Plant":"March Point Cogeneration","State":"WA","Gas":146.2,"coordinates":[-122.56,48.4708]},{"Plant":"Saguaro Power","State":"NV","Gas":101,"coordinates":[-115.0117,36.0417]},{"Plant":"Ocean State Power II","State":"RI","Gas":218.62,"coordinates":[-71.6701,42.0099]},{"Plant":"Orange Cogeneration Facility","State":"FL","Gas":117.48,"coordinates":[-81.8251,27.8708]},{"Plant":"Devon Station","State":"CT","Gas":120.4,"coordinates":[-73.109,41.2098]},{"Plant":"Lake Cogen Ltd","State":"FL","Gas":110,"coordinates":[-81.676,28.9158]},{"Plant":"Pasco Cogen Ltd","State":"FL","Gas":116.7,"coordinates":[-82.1889,28.3746]},{"Plant":"Mulberry Cogeneration Facility","State":"FL","Gas":152.57,"coordinates":[-81.8775,27.8489]},{"Plant":"Orlando Cogen LP","State":"FL","Gas":114.2,"coordinates":[-81.4123,28.4426]},{"Plant":"Sumas Power Plant","State":"WA","Gas":125.5,"coordinates":[-122.2733,48.9905]},{"Plant":"Formosa Plastics","State":"LA","Gas":121,"coordinates":[-91.1872,30.4992]},{"Plant":"Hartwell Energy Facility","State":"GA","Gas":302.5,"coordinates":[-82.8199,34.3396]},{"Plant":"Sithe Independence Station","State":"NY","Gas":982.2,"coordinates":[-76.4511,43.495]},{"Plant":"Saranac Facility","State":"NY","Gas":241,"coordinates":[-73.4557,44.7132]},{"Plant":"NAEA Lakewood LLC","State":"NJ","Gas":205.1,"coordinates":[-74.1686,40.0613]},{"Plant":"Auburndale Power Partners","State":"FL","Gas":165.72,"coordinates":[-81.8058,28.0542]},{"Plant":"Oyster Creek Unit VIII","State":"TX","Gas":379,"coordinates":[-95.342,28.9802]},{"Plant":"Hermiston Generating Plant","State":"OR","Gas":464,"coordinates":[-119.37,45.8042]},{"Plant":"Grays Ferry Cogeneration","State":"PA","Gas":150,"coordinates":[-75.1881,39.9422]},{"Plant":"Milford Power LP","State":"MA","Gas":148,"coordinates":[-71.5115,42.1294]},{"Plant":"Milagro Cogeneration Plant","State":"NM","Gas":121.6,"coordinates":[-107.9417,36.7367]},{"Plant":"Johnson County","State":"TX","Gas":267,"coordinates":[-97.4078,32.3994]},{"Plant":"Brandywine Power Facility","State":"MD","Gas":230,"coordinates":[-76.8678,38.6681]},{"Plant":"Gordonsville Energy LP","State":"VA","Gas":224,"coordinates":[-78.2138,38.1179]},{"Plant":"Sun Peak Generating Station","State":"NV","Gas":222,"coordinates":[-115.0339,36.1375]},{"Plant":"Brooklyn Navy Yard Cogeneration","State":"NY","Gas":230,"coordinates":[-73.9764,40.6994]},{"Plant":"Michigan Power LP","State":"MI","Gas":128,"coordinates":[-86.425,43.9375]},{"Plant":"LSP-Cottage Grove LP","State":"MN","Gas":251,"coordinates":[-92.9119,44.7956]},{"Plant":"LSP-Whitewater LP","State":"WI","Gas":251,"coordinates":[-88.7299,42.8555]},{"Plant":"Sweeny Cogen Facility","State":"TX","Gas":480,"coordinates":[-95.745,29.0728]},{"Plant":"Dighton Power Plant","State":"MA","Gas":143,"coordinates":[-71.1239,41.8312]},{"Plant":"De Pere Energy Center","State":"WI","Gas":174.3,"coordinates":[-88.072,44.4486]},{"Plant":"Androscoggin Energy Center","State":"ME","Gas":129.98,"coordinates":[-70.2423,44.5063]},{"Plant":"Delta Person LLC","State":"NM","Gas":140,"coordinates":[-106.644,35.026]},{"Plant":"Mid-Georgia Cogeneration Facility","State":"GA","Gas":316,"coordinates":[-83.6039,32.4856]},{"Plant":"Berkshire Power","State":"MA","Gas":246,"coordinates":[-72.6478,42.0476]},{"Plant":"Bridgeport Energy Project","State":"CT","Gas":454,"coordinates":[-73.1844,41.1692]},{"Plant":"Pasadena Cogeneration","State":"TX","Gas":700,"coordinates":[-95.1765,29.7248]},{"Plant":"Tiverton Power Plant","State":"RI","Gas":239.09,"coordinates":[-71.1706,41.6422]},{"Plant":"Axiall Plaquemine","State":"LA","Gas":240,"coordinates":[-91.185,30.2586]},{"Plant":"Tenaska Georgia Generation Facility","State":"GA","Gas":933,"coordinates":[-84.9996,33.3516]},{"Plant":"Tenaska Frontier Generation Station","State":"TX","Gas":860,"coordinates":[-95.9178,30.5924]},{"Plant":"Batesville Generation Facility","State":"MS","Gas":766.41,"coordinates":[-89.9275,34.3356]},{"Plant":"Black Hawk Station","State":"TX","Gas":221.4,"coordinates":[-101.36,35.6957]},{"Plant":"Mustang Station","State":"TX","Gas":486,"coordinates":[-102.7417,32.9728]},{"Plant":"Maine Independence Station","State":"ME","Gas":493.8,"coordinates":[-68.7094,44.8242]},{"Plant":"Pine Bluff Energy Center","State":"AR","Gas":198,"coordinates":[-91.9025,34.2181]},{"Plant":"Desert Star Energy Center","State":"NV","Gas":450,"coordinates":[-114.9928,35.7867]},{"Plant":"Millennium Power","State":"MA","Gas":337.8,"coordinates":[-72.0151,42.1123]},{"Plant":"New Albany Energy Facility","State":"MS","Gas":360,"coordinates":[-88.9397,34.5408]},{"Plant":"Brownsville Peaking Power","State":"TN","Gas":449.82,"coordinates":[-89.198,35.5438]},{"Plant":"Caledonia Power Facility","State":"MS","Gas":441.18,"coordinates":[-88.3186,33.6482]},{"Plant":"Crockett Cogen Project","State":"CA","Gas":247.4,"coordinates":[-122.2161,38.0569]},{"Plant":"Gregory Power Facility","State":"TX","Gas":412,"coordinates":[-97.2584,27.8893]},{"Plant":"Zeeland Generating Station","State":"MI","Gas":769.8,"coordinates":[-85.9975,42.8206]},{"Plant":"Dearborn Industrial Generation","State":"MI","Gas":760,"coordinates":[-83.154,42.3026]},{"Plant":"Taft Cogeneration Facility","State":"LA","Gas":790,"coordinates":[-90.4599,29.9888]},{"Plant":"Midlothian Energy Facility","State":"TX","Gas":1357,"coordinates":[-97.0537,32.4302]},{"Plant":"Lamar Power Project","State":"TX","Gas":1090.8,"coordinates":[-95.59,33.6308]},{"Plant":"Frontera Energy Center","State":"TX","Gas":475,"coordinates":[-98.3992,26.208]},{"Plant":"NRG Sterlington Power","State":"LA","Gas":178,"coordinates":[-92.0811,32.6889]},{"Plant":"Rumford Power Associates","State":"ME","Gas":254,"coordinates":[-70.5219,44.5303]},{"Plant":"Livingston Generating Station","State":"MI","Gas":132,"coordinates":[-84.7308,45.0304]},{"Plant":"Klamath Cogeneration Plant","State":"OR","Gas":470,"coordinates":[-121.8106,42.1739]},{"Plant":"Sabine Cogen","State":"TX","Gas":101,"coordinates":[-93.7714,30.0444]},{"Plant":"Entergy Rhode Island State Energy LP","State":"RI","Gas":515,"coordinates":[-71.5186,41.8017]},{"Plant":"Rocky Road Power LLC","State":"IL","Gas":340,"coordinates":[-88.2397,42.0931]},{"Plant":"Madison","State":"OH","Gas":580.72,"coordinates":[-84.4647,39.4522]},{"Plant":"Vermillion Energy Facility","State":"IN","Gas":560,"coordinates":[-87.4464,39.9223]},{"Plant":"Sutter Energy Center","State":"CA","Gas":530,"coordinates":[-121.6959,39.0531]},{"Plant":"Rockingham County CT Station","State":"NC","Gas":800,"coordinates":[-79.8297,36.3297]},{"Plant":"RS Cogen","State":"LA","Gas":395.6,"coordinates":[-93.2992,30.221]},{"Plant":"SRW Cogen LP","State":"TX","Gas":420,"coordinates":[-93.7574,30.0545]},{"Plant":"Magic Valley Generating Station","State":"TX","Gas":682,"coordinates":[-98.19,26.3403]},{"Plant":"Griffith Energy LLC","State":"AZ","Gas":588,"coordinates":[-114.1333,35.054]},{"Plant":"Manchief Electric Generating Station","State":"CO","Gas":264,"coordinates":[-103.685,40.2171]},{"Plant":"Walton County Power LLC","State":"GA","Gas":483,"coordinates":[-83.6954,33.8148]},{"Plant":"Desert Basin","State":"AZ","Gas":598,"coordinates":[-111.7889,32.9042]},{"Plant":"Kendall County Generation Facility","State":"IL","Gas":1145.72,"coordinates":[-88.2581,41.4797]},{"Plant":"Tenaska Gateway Generating Station","State":"TX","Gas":860,"coordinates":[-94.6197,32.0178]},{"Plant":"Alliant Energy Neenah","State":"WI","Gas":308.8,"coordinates":[-88.5064,44.1936]},{"Plant":"Rio Nogales Power Project","State":"TX","Gas":704,"coordinates":[-97.9732,29.5931]},{"Plant":"Hawk Road Facility","State":"GA","Gas":495,"coordinates":[-84.9914,33.3585]},{"Plant":"Hays Energy Project","State":"TX","Gas":876.8,"coordinates":[-97.9894,29.7806]},{"Plant":"Green Country Energy LLC","State":"OK","Gas":778.5,"coordinates":[-95.9346,35.9833]},{"Plant":"Worthington Generation LLC","State":"IN","Gas":170,"coordinates":[-87.0128,39.0708]},{"Plant":"Lake Road Generating Plant","State":"CT","Gas":695.8,"coordinates":[-71.8958,41.872]},{"Plant":"ExxonMobil Baton Rouge Cogen","State":"LA","Gas":332,"coordinates":[-91.1808,30.5234]},{"Plant":"Guadalupe Generating Station","State":"TX","Gas":1000,"coordinates":[-98.1419,29.6244]},{"Plant":"Lost Pines 1 Power Project","State":"TX","Gas":519,"coordinates":[-97.2714,30.1478]},{"Plant":"Bluegrass Generating Station","State":"KY","Gas":480,"coordinates":[-85.4133,38.3902]},{"Plant":"Calcasieu","State":"LA","Gas":320,"coordinates":[-93.345,30.1608]},{"Plant":"Broad River Energy Center","State":"SC","Gas":802.23,"coordinates":[-81.575,35.0786]},{"Plant":"Bastrop Energy Center","State":"TX","Gas":549.4,"coordinates":[-97.55,30.1458]},{"Plant":"Bosque County Peaking","State":"TX","Gas":548,"coordinates":[-97.3586,31.8594]},{"Plant":"Acadia Energy Center","State":"LA","Gas":1082,"coordinates":[-92.4131,30.4286]},{"Plant":"Eastman Cogeneration Facility","State":"TX","Gas":402.22,"coordinates":[-94.6903,32.4481]},{"Plant":"South Point Energy Center","State":"AZ","Gas":530,"coordinates":[-114.5317,34.8678]},{"Plant":"Dogwood Energy Facility","State":"MO","Gas":481,"coordinates":[-94.3006,38.7931]},{"Plant":"Rathdrum Power LLC","State":"ID","Gas":248,"coordinates":[-116.9203,47.7858]},{"Plant":"Champion Clean Energy","State":"ME","Gas":176,"coordinates":[-95.758,32.5184]},{"Plant":"Sunrise Power LLC","State":"CA","Gas":300,"coordinates":[-119.585,35.2097]},{"Plant":"Channelview Cogeneration Plant","State":"TX","Gas":818,"coordinates":[-95.1217,29.837]},{"Plant":"Cordova Energy","State":"IL","Gas":680,"coordinates":[-90.2797,41.7122]},{"Plant":"Osceola","State":"FL","Gas":482,"coordinates":[-81.0978,28.1289]},{"Plant":"Riverside Generating LLC","State":"KY","Gas":495,"coordinates":[-82.6046,38.1917]},{"Plant":"Elwood Energy LLC","State":"IL","Gas":1350,"coordinates":[-88.1236,41.4388]},{"Plant":"Arapahoe Combustion Turbine Project","State":"CO","Gas":122.5,"coordinates":[-105.0018,39.6692]},{"Plant":"Gibson City","State":"IL","Gas":234,"coordinates":[-88.3987,40.4705]},{"Plant":"Pinckneyville","State":"IL","Gas":315.6,"coordinates":[-89.3467,38.1114]},{"Plant":"Kinmundy","State":"IL","Gas":234,"coordinates":[-89.0128,38.7619]},{"Plant":"Corpus Christi Energy Center","State":"TX","Gas":400,"coordinates":[-97.4283,27.8139]},{"Plant":"Afton Generating Station","State":"NM","Gas":150.5,"coordinates":[-106.8465,32.1142]},{"Plant":"ANP Bellingham Energy Project","State":"MA","Gas":446.6,"coordinates":[-71.4535,42.1106]},{"Plant":"ANP Blackstone Energy Project","State":"MA","Gas":444.2,"coordinates":[-71.5158,42.0599]},{"Plant":"Odessa Ector Generating Station","State":"TX","Gas":1026,"coordinates":[-102.3264,31.8403]},{"Plant":"Morris Cogeneration LLC","State":"IL","Gas":176,"coordinates":[-88.3328,41.4119]},{"Plant":"Los Medanos Energy Center","State":"CA","Gas":567,"coordinates":[-121.873,38.0301]},{"Plant":"Hinds Energy Facility","State":"MS","Gas":450,"coordinates":[-90.2199,32.379]},{"Plant":"Southaven Energy Facility","State":"MS","Gas":624,"coordinates":[-90.0397,34.9808]},{"Plant":"Attala","State":"MS","Gas":459,"coordinates":[-89.6753,33.0147]},{"Plant":"Harry L. Oswald","State":"AR","Gas":568,"coordinates":[-92.2166,34.5923]},{"Plant":"Lincoln Generating Facility","State":"IL","Gas":588.24,"coordinates":[-87.9436,41.3933]},{"Plant":"Ennis Power Company LLC","State":"TX","Gas":359.5,"coordinates":[-96.675,32.32]},{"Plant":"Wheatland Generating Facility","State":"IN","Gas":472,"coordinates":[-87.2931,38.6716]},{"Plant":"Oneta Energy Center","State":"OK","Gas":560,"coordinates":[-95.6967,36.0119]},{"Plant":"Freestone Energy Center","State":"TX","Gas":886,"coordinates":[-96.1131,31.8907]},{"Plant":"Greenville Electric Generating Station","State":"OH","Gas":180,"coordinates":[-84.6151,40.0758]},{"Plant":"Montpelier Electric Generating Station","State":"IN","Gas":180,"coordinates":[-85.3057,40.6206]},{"Plant":"Liberty Electric Power Plant","State":"PA","Gas":528.12,"coordinates":[-75.3358,39.8614]},{"Plant":"Marshall Energy Facility","State":"KY","Gas":544,"coordinates":[-88.3958,37.0286]},{"Plant":"Handsome Lake Energy LLC","State":"PA","Gas":250,"coordinates":[-79.8061,41.2908]},{"Plant":"Audrain Generating Station","State":"MO","Gas":640,"coordinates":[-91.5369,39.3092]},{"Plant":"Lee Energy Facility","State":"IL","Gas":584,"coordinates":[-89.4054,41.8287]},{"Plant":"Energy Shelby County","State":"IL","Gas":344,"coordinates":[-88.4772,39.2794]},{"Plant":"NRG Rockford I","State":"IL","Gas":310,"coordinates":[-89.1012,42.2386]},{"Plant":"Red Oak Power LLC","State":"NJ","Gas":791.9,"coordinates":[-74.3489,40.4487]},{"Plant":"Hog Bayou Energy Center","State":"AL","Gas":230,"coordinates":[-88.0575,30.7478]},{"Plant":"Astoria Gas Turbines","State":"NY","Gas":420,"coordinates":[-73.9048,40.787]},{"Plant":"Doyle Energy Facility","State":"GA","Gas":355,"coordinates":[-83.6996,33.8377]},{"Plant":"Darby Electric Generating Station","State":"OH","Gas":451.8,"coordinates":[-83.1778,39.7139]},{"Plant":"Tait Electric Generating Station","State":"OH","Gas":319.6,"coordinates":[-84.2095,39.7277]},{"Plant":"University Park South","State":"IL","Gas":300,"coordinates":[-87.7532,41.4409]},{"Plant":"Gleason Generating Facility","State":"TN","Gas":540,"coordinates":[-88.612,36.2454]},{"Plant":"Crete Energy Venture LLC","State":"IL","Gas":293.4,"coordinates":[-87.6187,41.4294]},{"Plant":"Whiting Clean Energy","State":"IN","Gas":549.6,"coordinates":[-87.4775,41.6739]},{"Plant":"Edward L. Addison Generating Plant","State":"GA","Gas":609,"coordinates":[-84.3064,32.9111]},{"Plant":"Jackson Generating Station","State":"MI","Gas":554.8,"coordinates":[-84.3767,42.2488]},{"Plant":"Tenaska Lindsay Hill Generating Station","State":"AL","Gas":857.9,"coordinates":[-86.7386,32.6514]},{"Plant":"Ceredo Generating Station","State":"WV","Gas":456.5,"coordinates":[-82.5339,38.3681]},{"Plant":"Aurora","State":"IL","Gas":910,"coordinates":[-88.2265,41.8151]},{"Plant":"Southeast Chicago Energy Project","State":"IL","Gas":347,"coordinates":[-87.5449,41.7181]},{"Plant":"Arlington Valley Energy Facility","State":"AZ","Gas":580,"coordinates":[-112.8897,33.3417]},{"Plant":"Big Sandy Peaker Plant","State":"WV","Gas":300,"coordinates":[-82.5938,38.3441]},{"Plant":"Wolf Hills Energy","State":"VA","Gas":250,"coordinates":[-82.1044,36.6644]},{"Plant":"Oleander Power Project LP","State":"FL","Gas":596,"coordinates":[-80.7947,28.3661]},{"Plant":"Decatur Energy Center","State":"AL","Gas":469,"coordinates":[-87.0214,34.6292]},{"Plant":"Westbrook Energy Center Power Plant","State":"ME","Gas":506,"coordinates":[-70.375,43.6575]},{"Plant":"Calumet Energy Team LLC","State":"IL","Gas":265.2,"coordinates":[-87.5563,41.6835]},{"Plant":"Channel Energy Center LLC","State":"TX","Gas":574.9,"coordinates":[-95.2319,29.7189]},{"Plant":"West Phoenix CC4","State":"AZ","Gas":107,"coordinates":[-112.1589,33.441]},{"Plant":"Warren Peaking Power Facility","State":"MS","Gas":300,"coordinates":[-90.9284,32.2849]},{"Plant":"Baconton Power Plant","State":"GA","Gas":195.2,"coordinates":[-84.08,31.3869]},{"Plant":"Ingleside Cogeneration","State":"TX","Gas":460,"coordinates":[-97.2428,27.8828]},{"Plant":"Indian River","State":"FL","Gas":608,"coordinates":[-80.7802,28.4932]},{"Plant":"Baytown Energy Center","State":"TX","Gas":830,"coordinates":[-94.9019,29.7731]},{"Plant":"Hermiston Power Partnership","State":"OR","Gas":615,"coordinates":[-119.3133,45.794]},{"Plant":"Delta Energy Center","State":"CA","Gas":811.3,"coordinates":[-121.8439,38.0169]},{"Plant":"Holland Energy Facility","State":"IL","Gas":466,"coordinates":[-88.7584,39.2231]},{"Plant":"Ontelaunee Energy Center","State":"PA","Gas":560,"coordinates":[-75.9356,40.422]},{"Plant":"PPL Ironwood LLC","State":"PA","Gas":656.4,"coordinates":[-76.3658,40.3509]},{"Plant":"Armstrong","State":"PA","Gas":584,"coordinates":[-79.3517,40.638]},{"Plant":"Troy Energy LLC","State":"OH","Gas":584,"coordinates":[-83.4598,41.4772]},{"Plant":"Pleasants Energy LLC","State":"WV","Gas":292.4,"coordinates":[-81.3642,39.3325]},{"Plant":"Sugar Creek Power","State":"IN","Gas":300,"coordinates":[-87.5108,39.3931]},{"Plant":"Exelon LaPorte Generating Station","State":"TX","Gas":168,"coordinates":[-95.0718,29.7028]},{"Plant":"Enterprise Energy Facility","State":"MS","Gas":600,"coordinates":[-90.0394,34.9767]},{"Plant":"Thomas A Smith Energy Facility","State":"GA","Gas":1244,"coordinates":[-84.9175,34.7094]},{"Plant":"RockGen Energy Center","State":"WI","Gas":462,"coordinates":[-89.0492,42.9767]},{"Plant":"Zion Energy Center","State":"IL","Gas":304,"coordinates":[-87.895,42.4776]},{"Plant":"Crossroads Energy Center","State":"MS","Gas":308,"coordinates":[-90.5621,34.183]},{"Plant":"Washington Energy Facility","State":"OH","Gas":600,"coordinates":[-81.6564,39.58]},{"Plant":"Renaissance Power LLC","State":"MI","Gas":578,"coordinates":[-84.8429,43.1864]},{"Plant":"Shady Hills Generating Station","State":"FL","Gas":474,"coordinates":[-82.5586,28.3665]},{"Plant":"Vandolah Power Station","State":"FL","Gas":632,"coordinates":[-81.924,27.5236]},{"Plant":"Raccoon Creek Energy Center","State":"IL","Gas":325,"coordinates":[-88.5392,38.6996]},{"Plant":"Hot Spring Generating Facility","State":"AR","Gas":651.6,"coordinates":[-92.8683,34.2976]},{"Plant":"DeSoto County Plant","State":"FL","Gas":308,"coordinates":[-81.8092,27.2272]},{"Plant":"Bayou Cove Peaking Power","State":"LA","Gas":300,"coordinates":[-92.5997,30.2825]},{"Plant":"Elgin Energy Center","State":"IL","Gas":468,"coordinates":[-88.2446,42.0001]},{"Plant":"Columbia Energy Center","State":"MO","Gas":143.6,"coordinates":[-92.2629,39.0192]},{"Plant":"Fountain Valley Power Facility","State":"CO","Gas":234,"coordinates":[-104.6875,38.5569]},{"Plant":"McClain Energy Facility","State":"OK","Gas":400,"coordinates":[-97.5898,35.2977]},{"Plant":"Ouachita","State":"LA","Gas":816,"coordinates":[-92.0683,32.7061]},{"Plant":"Tri Center Naniwa Energy","State":"NV","Gas":300,"coordinates":[-119.5178,39.5572]},{"Plant":"Limon Generating Station","State":"CO","Gas":134,"coordinates":[-103.7005,39.2038]},{"Plant":"Frank Knutson","State":"CO","Gas":134,"coordinates":[-104.682,39.9411]},{"Plant":"Wallingford Energy","State":"CT","Gas":190,"coordinates":[-72.8354,41.4487]},{"Plant":"AES Greystone","State":"TN","Gas":468,"coordinates":[-89.3937,35.6532]},{"Plant":"Sundance","State":"AZ","Gas":383,"coordinates":[-111.5899,32.9285]},{"Plant":"Redhawk","State":"AZ","Gas":918,"coordinates":[-112.8374,33.3447]},{"Plant":"Indigo Energy Facility","State":"CA","Gas":149.7,"coordinates":[-116.553,33.9109]},{"Plant":"Hidalgo Energy Center","State":"TX","Gas":470,"coordinates":[-98.1758,26.3417]},{"Plant":"Perryville Power Station","State":"LA","Gas":718,"coordinates":[-92.0183,32.6908]},{"Plant":"West Valley Generation Project","State":"UT","Gas":185,"coordinates":[-112.0317,40.6667]},{"Plant":"University Park North","State":"IL","Gas":459.6,"coordinates":[-87.7514,41.4425]},{"Plant":"Plains End","State":"CO","Gas":113,"coordinates":[-105.226,39.8575]},{"Plant":"Spring Creek Energy Center","State":"OK","Gas":280,"coordinates":[-97.655,35.7422]},{"Plant":"EP Newington Energy LLC","State":"NH","Gas":525,"coordinates":[-70.8061,43.1047]},{"Plant":"AL Sandersville LLC","State":"GA","Gas":624,"coordinates":[-82.8608,33.1189]},{"Plant":"Bethlehem Power Plant","State":"PA","Gas":351,"coordinates":[-75.3147,40.6175]},{"Plant":"Pierce Power Station","State":"WA","Gas":130.9,"coordinates":[-122.3758,47.1365]},{"Plant":"Dean","State":"MI","Gas":295.4,"coordinates":[-82.4953,42.7725]},{"Plant":"Gilroy Peaking Energy Center","State":"CA","Gas":128.3,"coordinates":[-121.5363,36.999]},{"Plant":"Frederickson Power LP","State":"WA","Gas":254.5,"coordinates":[-122.3657,47.0861]},{"Plant":"Foothills Generating LLC","State":"KY","Gas":330,"coordinates":[-82.5873,38.2536]},{"Plant":"NRG Rockford II Energy Center","State":"IL","Gas":159,"coordinates":[-89.1011,42.2383]},{"Plant":"Big Cajun 1 Peakers","State":"LA","Gas":238,"coordinates":[-91.4145,30.6238]},{"Plant":"Wansley Combined Cycle","State":"GA","Gas":973.36,"coordinates":[-85.037,33.4064]},{"Plant":"Olive","State":"CA","Gas":152.5,"coordinates":[-118.3147,34.1764]},{"Plant":"Collins","State":"IL","Gas":2671,"coordinates":[-88.3928,41.3461]},{"Plant":"Belle River","State":"MI","Gas":225,"coordinates":[-82.495,42.7756]},{"Plant":"Greenwood","State":"MI","Gas":225,"coordinates":[-82.6964,43.1056]},{"Plant":"Martin","State":"FL","Gas":2850,"coordinates":[-80.5628,27.0536]},{"Plant":"DeBary","State":"FL","Gas":258,"coordinates":[-81.3323,28.9039]},{"Plant":"Wansley","State":"GA","Gas":977.6,"coordinates":[-85.0323,33.4134]},{"Plant":"Electrifarm","State":"IA","Gas":197,"coordinates":[-92.4205,42.4407]},{"Plant":"Fredonia","State":"WA","Gas":309.4,"coordinates":[-122.4358,48.4558]},{"Plant":"Trimble County","State":"KY","Gas":310,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Gas":914.92,"coordinates":[-88.5553,30.5322]},{"Plant":"Greenwood","State":"MO","Gas":242,"coordinates":[-94.2982,38.8615]},{"Plant":"R M Schahfer","State":"IN","Gas":155,"coordinates":[-87.0261,41.2164]},{"Plant":"Cutler","State":"FL","Gas":206,"coordinates":[-80.2989,25.6321]},{"Plant":"Fort St Vrain","State":"CO","Gas":690.7,"coordinates":[-104.8742,40.2461]},{"Plant":"Fort Myers","State":"FL","Gas":1423,"coordinates":[-81.7831,26.6967]},{"Plant":"Whitehorn","State":"WA","Gas":158,"coordinates":[-122.6861,48.8288]},{"Plant":"McIntosh","State":"GA","Gas":668,"coordinates":[-81.1683,32.3563]},{"Plant":"Lauderdale","State":"FL","Gas":1694,"coordinates":[-80.1984,26.0686]},{"Plant":"A B Brown","State":"IN","Gas":160,"coordinates":[-87.715,37.9053]},{"Plant":"Port Everglades","State":"FL","Gas":420,"coordinates":[-80.1253,26.0856]},{"Plant":"Brame Energy Center","State":"LA","Gas":440,"coordinates":[-92.7167,31.395]},{"Plant":"John Twitty Energy Center","State":"MO","Gas":148,"coordinates":[-93.388,37.1517]},{"Plant":"Sanford","State":"FL","Gas":391,"coordinates":[-81.3256,28.8419]},{"Plant":"Empire Energy Center","State":"MO","Gas":170,"coordinates":[-94.1041,37.1385]},{"Plant":"Dansby","State":"TX","Gas":110,"coordinates":[-96.4608,30.7217]},{"Plant":"Putnam","State":"FL","Gas":498,"coordinates":[-81.5851,29.6283]},{"Plant":"Higgins","State":"FL","Gas":122,"coordinates":[-82.6615,28.0033]},{"Plant":"Rokeby","State":"NE","Gas":262.7,"coordinates":[-96.7364,40.7316]},{"Plant":"Suwannee River","State":"FL","Gas":110,"coordinates":[-83.1806,30.3764]},{"Plant":"Lansing Smith","State":"FL","Gas":451,"coordinates":[-85.7003,30.2686]},{"Plant":"D G Hunter","State":"LA","Gas":157,"coordinates":[-92.4613,31.3207]},{"Plant":"George M Sullivan Generation Plant 2","State":"AK","Gas":219.9,"coordinates":[-149.7167,61.2297]},{"Plant":"Henry D King","State":"FL","Gas":130,"coordinates":[-80.3386,27.4486]},{"Plant":"Deerhaven Generating Station","State":"FL","Gas":194,"coordinates":[-82.3878,29.7592]},{"Plant":"John R Kelly","State":"FL","Gas":191,"coordinates":[-82.3208,29.6461]},{"Plant":"J D Kennedy","State":"FL","Gas":158.6,"coordinates":[-81.626,30.3648]},{"Plant":"Larsen Memorial","State":"FL","Gas":195,"coordinates":[-81.9228,28.0797]},{"Plant":"C D McIntosh Jr","State":"FL","Gas":532,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Gas":180,"coordinates":[-105.0212,40.8609]},{"Plant":"Indian River Plant","State":"FL","Gas":291,"coordinates":[-80.7801,28.4932]},{"Plant":"Arvah B Hopkins","State":"FL","Gas":350,"coordinates":[-84.4,30.4522]},{"Plant":"S O Purdom","State":"FL","Gas":301,"coordinates":[-84.2007,30.1623]},{"Plant":"Vero Beach Municipal Power Plant","State":"FL","Gas":150,"coordinates":[-80.3776,27.6334]},{"Plant":"Atkinson","State":"GA","Gas":182,"coordinates":[-84.4803,33.8175]},{"Plant":"Gravel Neck","State":"VA","Gas":292,"coordinates":[-76.6911,37.1575]},{"Plant":"McIntosh","State":"AL","Gas":340,"coordinates":[-88.0299,31.2546]},{"Plant":"Hay Road","State":"DE","Gas":1060,"coordinates":[-75.5072,39.7436]},{"Plant":"Woodsdale","State":"OH","Gas":462,"coordinates":[-84.4611,39.4492]},{"Plant":"Concord","State":"WI","Gas":376,"coordinates":[-88.69,43.1669]},{"Plant":"South Fond Du Lac","State":"WI","Gas":330.4,"coordinates":[-88.4967,43.7353]},{"Plant":"Darbytown","State":"VA","Gas":288,"coordinates":[-77.3685,37.4982]},{"Plant":"Angus Anson","State":"SD","Gas":228.5,"coordinates":[-96.6356,43.6035]},{"Plant":"Cane Island","State":"FL","Gas":380,"coordinates":[-81.533,28.2764]},{"Plant":"Polk","State":"FL","Gas":325,"coordinates":[-81.9897,27.7286]},{"Plant":"491 E 48th Street","State":"MI","Gas":148.2,"coordinates":[-86.0853,42.7553]},{"Plant":"Paris","State":"WI","Gas":400,"coordinates":[-88.0131,42.6658]},{"Plant":"Lincoln Combustion","State":"NC","Gas":1267.2,"coordinates":[-81.0347,35.4317]},{"Plant":"State Line Combined Cycle","State":"MO","Gas":601,"coordinates":[-94.614,37.0659]},{"Plant":"Hines Energy Complex","State":"FL","Gas":482,"coordinates":[-81.87,27.7882]},{"Plant":"Redding Power","State":"CA","Gas":143.6,"coordinates":[-122.4233,40.5073]},{"Plant":"Richard M Flynn","State":"NY","Gas":136.2,"coordinates":[-73.064,40.8158]},{"Plant":"San Jacinto Steam Electric Station","State":"TX","Gas":162,"coordinates":[-95.0406,29.6948]},{"Plant":"Riverside","State":"GA","Gas":107,"coordinates":[-81.0956,32.0836]},{"Plant":"Robins","State":"GA","Gas":160,"coordinates":[-83.5822,32.5792]},{"Plant":"Coyote Springs","State":"OR","Gas":213,"coordinates":[-119.6739,45.848]},{"Plant":"Midulla Generating Station","State":"FL","Gas":488,"coordinates":[-81.9625,27.6417]},{"Plant":"Interstate","State":"IL","Gas":128,"coordinates":[-89.5891,39.8233]},{"Plant":"Rathdrum","State":"ID","Gas":136,"coordinates":[-116.8673,47.8043]},{"Plant":"Arthur Von Rosenberg","State":"TX","Gas":482,"coordinates":[-98.384,29.257]},{"Plant":"Carson Ice-Gen Project","State":"CA","Gas":101,"coordinates":[-121.4624,38.4457]},{"Plant":"Wayne County","State":"NC","Gas":668,"coordinates":[-78.0981,35.3758]},{"Plant":"SCA Cogen 2","State":"CA","Gas":154.6,"coordinates":[-121.4001,38.5309]},{"Plant":"SPA Cogen 3","State":"CA","Gas":164,"coordinates":[-121.4735,38.511]},{"Plant":"St Francis Energy Facility","State":"MO","Gas":473,"coordinates":[-90.1779,36.5852]},{"Plant":"River Road Gen Plant","State":"WA","Gas":210,"coordinates":[-122.7256,45.6497]},{"Plant":"Washington County Cogeneration Facility","State":"AL","Gas":119.7,"coordinates":[-88.0156,31.2504]},{"Plant":"Tiger Bay","State":"FL","Gas":207,"coordinates":[-81.8494,27.7464]},{"Plant":"Dahlberg","State":"GA","Gas":750,"coordinates":[-83.3977,34.0423]},{"Plant":"H Allen Franklin Combined Cycle","State":"AL","Gas":490.56,"coordinates":[-85.0975,32.6078]},{"Plant":"Theodore Cogen Facility","State":"AL","Gas":224.7,"coordinates":[-88.1285,30.5254]},{"Plant":"Essex","State":"MO","Gas":107.4,"coordinates":[-89.8402,36.8682]},{"Plant":"Nodaway","State":"MO","Gas":182.8,"coordinates":[-94.7913,40.2877]},{"Plant":"Chouteau","State":"OK","Gas":495,"coordinates":[-95.2771,36.2221]},{"Plant":"Georgetown","State":"IN","Gas":295,"coordinates":[-86.2441,39.9026]},{"Plant":"Tilton","State":"IL","Gas":176,"coordinates":[-87.6538,40.1061]},{"Plant":"Henry County","State":"IN","Gas":114.75,"coordinates":[-85.5039,39.9528]},{"Plant":"MPC Generating","State":"GA","Gas":314.3,"coordinates":[-83.6953,33.8119]},{"Plant":"Sherwood H Smith Jr Energy Complex","State":"NC","Gas":1247,"coordinates":[-79.7406,34.8392]},{"Plant":"Sewell Creek Energy","State":"GA","Gas":491.4,"coordinates":[-85.2769,33.9486]},{"Plant":"Alsey","State":"IL","Gas":101,"coordinates":[-90.436,39.5698]},{"Plant":"Fulton","State":"AR","Gas":153,"coordinates":[-93.7924,33.6094]},{"Plant":"Rowan","State":"NC","Gas":455.1,"coordinates":[-80.6019,35.7314]},{"Plant":"Smarr Energy Center","State":"GA","Gas":217.4,"coordinates":[-83.8464,32.9842]},{"Plant":"John S Rainey","State":"SC","Gas":744,"coordinates":[-82.776,34.3477]},{"Plant":"Remington","State":"VA","Gas":580,"coordinates":[-77.7714,38.5442]},{"Plant":"Ladysmith","State":"VA","Gas":290,"coordinates":[-77.5133,38.0722]},{"Plant":"Goat Rock","State":"AL","Gas":490.2,"coordinates":[-85.2101,32.5594]},{"Plant":"Pleasant Valley","State":"MN","Gas":420.7,"coordinates":[-92.6829,43.7994]},{"Plant":"Lagoon Creek","State":"TN","Gas":952,"coordinates":[-89.3964,35.6578]},{"Plant":"Brandy Branch","State":"FL","Gas":475.8,"coordinates":[-81.9472,30.3206]},{"Plant":"Holden","State":"MO","Gas":232.8,"coordinates":[-93.9983,38.7538]},{"Plant":"MEPI GT Facility","State":"IL","Gas":241,"coordinates":[-88.8661,37.2175]},{"Plant":"Encogen","State":"WA","Gas":160,"coordinates":[-122.486,48.746]},{"Plant":"Robert P Mone Plant","State":"OH","Gas":447,"coordinates":[-84.7392,40.9297]},{"Plant":"Sand Hill","State":"TX","Gas":189.2,"coordinates":[-97.6129,30.2098]},{"Plant":"Talbot County Energy","State":"GA","Gas":434.8,"coordinates":[-84.6917,32.5892]},{"Plant":"Lakefield Junction","State":"MN","Gas":486.6,"coordinates":[-94.8415,43.7984]},{"Plant":"Kemper County","State":"MS","Gas":312,"coordinates":[-88.606,32.7976]},{"Plant":"Peno Creek","State":"MO","Gas":192,"coordinates":[-91.2295,39.3531]},{"Plant":"Sumpter","State":"MI","Gas":296,"coordinates":[-83.5318,42.167]},{"Plant":"Mill Creek","State":"SC","Gas":283.6,"coordinates":[-81.4306,35.1597]},{"Plant":"Murray Turbine","State":"UT","Gas":159,"coordinates":[-111.89,40.67]},{"Plant":"Sycamore","State":"IA","Gas":149,"coordinates":[-93.6769,41.6722]},{"Plant":"Intercession City","State":"FL","Gas":604,"coordinates":[-81.5486,28.2628]},{"Plant":"Gerald Andrus","State":"MS","Gas":761,"coordinates":[-91.1167,33.35]},{"Plant":"Waterford 1 & 2","State":"LA","Gas":811,"coordinates":[-90.4768,29.9989]},{"Plant":"Comanche","State":"OK","Gas":273,"coordinates":[-98.3244,34.5431]},{"Plant":"DeCordova Steam Electric Station","State":"TX","Gas":1104,"coordinates":[-97.7006,32.4031]},{"Plant":"Santan","State":"AZ","Gas":368,"coordinates":[-111.7503,33.3325]},{"Plant":"Beaver","State":"OR","Gas":516.6,"coordinates":[-123.1739,46.1724]},{"Plant":"Glen Gardner","State":"NJ","Gas":156.66,"coordinates":[-74.9207,40.6815]},{"Plant":"Grand Tower","State":"IL","Gas":521,"coordinates":[-89.5112,37.6577]},{"Plant":"Calumet","State":"IL","Gas":203.9,"coordinates":[-87.5428,41.7136]},{"Plant":"Crawford","State":"IL","Gas":172.8,"coordinates":[-87.7229,41.8285]},{"Plant":"Electric Junction","State":"IL","Gas":207.5,"coordinates":[-88.0833,41.8333]},{"Plant":"Joliet 9","State":"IL","Gas":115.1,"coordinates":[-88.1153,41.4931]},{"Plant":"Astoria Generating Station","State":"NY","Gas":190,"coordinates":[-73.9126,40.7877]},{"Plant":"Wood River","State":"IL","Gas":129.9,"coordinates":[-90.1347,38.8639]},{"Plant":"Beluga","State":"AK","Gas":338.2,"coordinates":[-151.0356,61.1861]},{"Plant":"Frederickson","State":"WA","Gas":158,"coordinates":[-122.365,47.0797]},{"Plant":"Harding Street","State":"IN","Gas":322,"coordinates":[-86.1969,39.7113]},{"Plant":"Dean H Mitchell","State":"IN","Gas":142,"coordinates":[-87.4069,41.6392]},{"Plant":"Michigan City","State":"IN","Gas":120,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Gas":995,"coordinates":[-87.7811,32.6017]},{"Plant":"NRG Energy Center Dover","State":"DE","Gas":104.4,"coordinates":[-75.5473,39.1495]},{"Plant":"Gilroy Power Plant","State":"CA","Gas":130,"coordinates":[-121.5367,37.0001]},{"Plant":"Noblesville","State":"IN","Gas":285.9,"coordinates":[-85.9714,40.0969]},{"Plant":"Pedricktown Cogeneration Company LP","State":"NJ","Gas":115.7,"coordinates":[-75.4238,39.7668]},{"Plant":"Broadway","State":"IN","Gas":115,"coordinates":[-87.6049,37.9691]},{"Plant":"Butler-Warner Generation Plant","State":"NC","Gas":283,"coordinates":[-78.8294,35.0986]},{"Plant":"El Segundo Cogen","State":"CA","Gas":127.7,"coordinates":[-118.4031,33.9058]},{"Plant":"ArcelorMittal Burns Harbor","State":"IN","Gas":177.7,"coordinates":[-87.1387,41.635]},{"Plant":"King City Power Plant","State":"CA","Gas":111,"coordinates":[-121.1278,36.225]},{"Plant":"Bayou Cogen Plant","State":"TX","Gas":260,"coordinates":[-95.0458,29.6225]},{"Plant":"Bellingham Cogeneration Facility","State":"MA","Gas":259,"coordinates":[-71.4833,42.0925]},{"Plant":"Sayreville Cogeneration Facility","State":"NJ","Gas":261,"coordinates":[-74.3444,40.439]},{"Plant":"Foster Wheeler Martinez","State":"CA","Gas":103.5,"coordinates":[-122.0589,38.0244]},{"Plant":"ExxonMobil Baytown Refinery","State":"TX","Gas":183.89,"coordinates":[-94.9973,29.7535]},{"Plant":"RG Steel Sparrows Point, LLC","State":"MD","Gas":152.3,"coordinates":[-76.4729,39.213]},{"Plant":"Kern River Cogeneration","State":"CA","Gas":293.2,"coordinates":[-118.9849,35.4515]},{"Plant":"Formosa Utility Venture Ltd","State":"TX","Gas":598.7,"coordinates":[-96.5417,28.6917]},{"Plant":"Hopewell Cogeneration","State":"VA","Gas":348.3,"coordinates":[-77.2811,37.2917]},{"Plant":"CES Placerita Power Plant","State":"CA","Gas":115,"coordinates":[-118.4999,34.3801]},{"Plant":"ExxonMobil Baytown Turbine","State":"TX","Gas":180.13,"coordinates":[-95.0096,29.7591]},{"Plant":"Selkirk Cogen","State":"NY","Gas":367,"coordinates":[-73.8592,42.5744]},{"Plant":"Masspower","State":"MA","Gas":231.5,"coordinates":[-72.5225,42.1575]},{"Plant":"Clear Lake Cogeneration Ltd","State":"TX","Gas":366,"coordinates":[-95.067,29.6255]},{"Plant":"Midland Cogeneration Venture","State":"MI","Gas":1811.4,"coordinates":[-84.2242,43.5861]},{"Plant":"Camden Plant Holding LLC","State":"NJ","Gas":148.5,"coordinates":[-75.1192,39.9175]},{"Plant":"River Hills","State":"IA","Gas":120,"coordinates":[-93.6195,41.5902]},{"Plant":"Hazelton","State":"PA","Gas":147.2,"coordinates":[-76.0409,40.9282]},{"Plant":"Ocotillo","State":"AZ","Gas":320,"coordinates":[-111.9122,33.4225]},{"Plant":"West Phoenix","State":"AZ","Gas":1047.3,"coordinates":[-112.1583,33.4417]},{"Plant":"Saguaro","State":"AZ","Gas":386,"coordinates":[-111.3,32.5517]},{"Plant":"Yucca","State":"AZ","Gas":163,"coordinates":[-114.7106,32.7214]},{"Plant":"Fort Dodge","State":"KS","Gas":142.3,"coordinates":[-99.9497,37.7328]},{"Plant":"Gordon Evans Energy Center","State":"KS","Gas":833,"coordinates":[-97.5217,37.7903]},{"Plant":"Murray Gill","State":"KS","Gas":322,"coordinates":[-97.4136,37.5967]},{"Plant":"Hutchinson Energy Center","State":"KS","Gas":477,"coordinates":[-97.8747,38.0906]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Gas":316,"coordinates":[-110.9047,32.16]},{"Plant":"Kaw","State":"KS","Gas":129,"coordinates":[-94.6514,39.0867]},{"Plant":"McPherson 2","State":"KS","Gas":131.5,"coordinates":[-97.6834,38.3634]},{"Plant":"Garden City","State":"KS","Gas":234.7,"coordinates":[-100.8956,37.9703]},{"Plant":"E W Brown","State":"KY","Gas":947,"coordinates":[-84.7126,37.7883]},{"Plant":"Paddys Run","State":"KY","Gas":193,"coordinates":[-85.8417,38.2236]},{"Plant":"Louisiana 1","State":"LA","Gas":218,"coordinates":[-91.1864,30.4922]},{"Plant":"Louisiana 2","State":"LA","Gas":140,"coordinates":[-91.1864,30.4922]},{"Plant":"R S Nelson","State":"LA","Gas":653,"coordinates":[-93.2911,30.2844]},{"Plant":"Willow Glen","State":"LA","Gas":1832,"coordinates":[-91.1164,30.2743]},{"Plant":"Coughlin Power Station","State":"LA","Gas":765,"coordinates":[-92.2611,30.8439]},{"Plant":"Teche","State":"LA","Gas":430,"coordinates":[-91.5425,29.8222]},{"Plant":"Little Gypsy","State":"LA","Gas":1204,"coordinates":[-90.4617,30.0051]},{"Plant":"Nine Mile Point","State":"LA","Gas":1705,"coordinates":[-90.1458,29.9472]},{"Plant":"Sterlington","State":"LA","Gas":552,"coordinates":[-92.0792,32.7047]},{"Plant":"A B Paterson","State":"LA","Gas":122,"coordinates":[-90.0256,30.0158]},{"Plant":"Michoud","State":"LA","Gas":825,"coordinates":[-89.9372,30.0081]},{"Plant":"Agua Fria","State":"AZ","Gas":626,"coordinates":[-112.2153,33.5561]},{"Plant":"Arsenal Hill","State":"LA","Gas":110,"coordinates":[-93.7611,32.5181]},{"Plant":"Lieberman","State":"LA","Gas":271,"coordinates":[-93.9597,32.7047]},{"Plant":"Louis Doc Bonin","State":"LA","Gas":302,"coordinates":[-92.0463,30.238]},{"Plant":"Monroe","State":"LA","Gas":127,"coordinates":[-92.1794,32.5233]},{"Plant":"Big Cajun 1","State":"LA","Gas":220,"coordinates":[-91.3556,30.6739]},{"Plant":"Kyrene","State":"AZ","Gas":522,"coordinates":[-111.9353,33.3556]},{"Plant":"Notch Cliff","State":"MD","Gas":128,"coordinates":[-76.5087,39.4217]},{"Plant":"Riverside","State":"MD","Gas":207,"coordinates":[-76.5133,39.2369]},{"Plant":"Westport","State":"MD","Gas":121,"coordinates":[-76.6295,39.266]},{"Plant":"Chalk Point LLC","State":"MD","Gas":474,"coordinates":[-76.6861,38.5444]},{"Plant":"Dickerson","State":"MD","Gas":294,"coordinates":[-77.4644,39.2097]},{"Plant":"Mystic Generating Station","State":"MA","Gas":1398.25,"coordinates":[-71.0675,42.3908]},{"Plant":"New Boston Generating Station","State":"MA","Gas":702,"coordinates":[-71.0353,42.3392]},{"Plant":"Kendall Square Station","State":"MA","Gas":207.69,"coordinates":[-71.0792,42.3633]},{"Plant":"Apache Station","State":"AZ","Gas":120,"coordinates":[-109.8931,32.0603]},{"Plant":"Cecil Lynch","State":"AR","Gas":178,"coordinates":[-92.1987,34.7535]},{"Plant":"Hamilton Moses","State":"AR","Gas":140,"coordinates":[-90.8722,34.9806]},{"Plant":"Harvey Couch","State":"AR","Gas":148,"coordinates":[-93.4649,33.3592]},{"Plant":"B C Cobb","State":"MI","Gas":183,"coordinates":[-86.2423,43.2588]},{"Plant":"Lake Catherine","State":"AR","Gas":735,"coordinates":[-92.9049,34.4341]},{"Plant":"Dan E Karn","State":"MI","Gas":1276,"coordinates":[-83.8401,43.645]},{"Plant":"Thetford","State":"MI","Gas":192,"coordinates":[-83.6286,43.1567]},{"Plant":"Conners Creek","State":"MI","Gas":215,"coordinates":[-82.9597,42.3592]},{"Plant":"Delray","State":"MI","Gas":127,"coordinates":[-83.1019,42.2947]},{"Plant":"Robert E Ritchie","State":"AR","Gas":883,"coordinates":[-90.5987,34.4629]},{"Plant":"Hancock","State":"MI","Gas":141,"coordinates":[-83.4425,42.5497]},{"Plant":"River Rouge","State":"MI","Gas":225,"coordinates":[-83.1119,42.2739]},{"Plant":"Mistersky","State":"MI","Gas":154,"coordinates":[-83.0903,42.3039]},{"Plant":"Black Dog","State":"MN","Gas":281.31,"coordinates":[-93.2501,44.8108]},{"Plant":"Inver Hills","State":"MN","Gas":360.9,"coordinates":[-93.042,44.781]},{"Plant":"Thomas Fitzhugh","State":"AR","Gas":171,"coordinates":[-93.8049,35.4624]},{"Plant":"Carl Bailey","State":"AR","Gas":122,"coordinates":[-91.3634,35.2601]},{"Plant":"McClellan","State":"AR","Gas":134,"coordinates":[-92.7917,33.5648]},{"Plant":"Chevron Oil","State":"MS","Gas":127,"coordinates":[-88.4919,30.34]},{"Plant":"Sweatt","State":"MS","Gas":125.6,"coordinates":[-88.7461,32.2925]},{"Plant":"Jack Watson","State":"MS","Gas":299,"coordinates":[-89.0286,30.4392]},{"Plant":"Baxter Wilson","State":"MS","Gas":1200,"coordinates":[-90.9306,32.2831]},{"Plant":"Delta","State":"MS","Gas":192,"coordinates":[-90.7139,33.7947]},{"Plant":"Rex Brown","State":"MS","Gas":295,"coordinates":[-90.213,32.357]},{"Plant":"L L Wilkins","State":"MS","Gas":311.5,"coordinates":[-90.5627,34.1845]},{"Plant":"Moselle","State":"MS","Gas":260,"coordinates":[-89.3004,31.528]},{"Plant":"Hawthorn","State":"MO","Gas":423,"coordinates":[-94.4778,39.1306]},{"Plant":"Lake Road","State":"MO","Gas":117,"coordinates":[-94.8773,39.7246]},{"Plant":"James River Power Station","State":"MO","Gas":155,"coordinates":[-93.2619,37.1086]},{"Plant":"Canaday","State":"NE","Gas":117.25,"coordinates":[-99.7011,40.6942]},{"Plant":"C W Burdick","State":"NE","Gas":175.3,"coordinates":[-98.3269,40.9228]},{"Plant":"Contra Costa","State":"CA","Gas":672,"coordinates":[-121.7642,38.0192]},{"Plant":"Clark","State":"NV","Gas":700,"coordinates":[-115.0507,36.0875]},{"Plant":"Sunrise","State":"NV","Gas":149,"coordinates":[-115.036,36.1384]},{"Plant":"Fort Churchill","State":"NV","Gas":226,"coordinates":[-119.1322,39.1281]},{"Plant":"Tracy","State":"NV","Gas":414,"coordinates":[-119.525,39.5625]},{"Plant":"Deepwater","State":"NJ","Gas":105,"coordinates":[-75.5083,39.6831]},{"Plant":"Bergen Generating Station","State":"NJ","Gas":1242,"coordinates":[-74.0244,40.8375]},{"Plant":"PSEG Burlington Generating Station","State":"NJ","Gas":413,"coordinates":[-74.8792,40.0766]},{"Plant":"PSEG Edison Generating Station","State":"NJ","Gas":504,"coordinates":[-74.3956,40.4911]},{"Plant":"PSEG Essex Generating Station","State":"NJ","Gas":617,"coordinates":[-74.1206,40.7372]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Gas":383,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Kearny Generating Station","State":"NJ","Gas":647.6,"coordinates":[-74.0965,40.7373]},{"Plant":"PSEG Linden Generating Station","State":"NJ","Gas":345,"coordinates":[-74.2072,40.6217]},{"Plant":"PSEG Sewaren Generating Station","State":"NJ","Gas":453,"coordinates":[-74.2469,40.5558]},{"Plant":"Rio Grande","State":"NM","Gas":231,"coordinates":[-106.5472,31.8047]},{"Plant":"Maddox","State":"NM","Gas":193,"coordinates":[-103.3015,32.7142]},{"Plant":"Reeves","State":"NM","Gas":154,"coordinates":[-106.6019,35.171]},{"Plant":"Cunningham","State":"NM","Gas":487,"coordinates":[-103.3533,32.7131]},{"Plant":"Humboldt Bay","State":"CA","Gas":105,"coordinates":[-124.2103,40.7415]},{"Plant":"Hunters Point","State":"CA","Gas":377,"coordinates":[-122.3897,37.7336]},{"Plant":"Arthur Kill Generating Station","State":"NY","Gas":841,"coordinates":[-74.2,40.5916]},{"Plant":"Gowanus Gas Turbines Generating","State":"NY","Gas":266,"coordinates":[-74.0051,40.6635]},{"Plant":"Narrows Gas Turbines Generating","State":"NY","Gas":266,"coordinates":[-74.0208,40.6486]},{"Plant":"Ravenswood","State":"NY","Gas":2446.6,"coordinates":[-73.9461,40.7592]},{"Plant":"E F Barrett","State":"NY","Gas":702.8,"coordinates":[-73.6479,40.6167]},{"Plant":"Far Rockaway","State":"NY","Gas":107,"coordinates":[-73.761,40.6109]},{"Plant":"Glenwood","State":"NY","Gas":315.7,"coordinates":[-73.6475,40.8271]},{"Plant":"Northport","State":"NY","Gas":772,"coordinates":[-73.3423,40.9236]},{"Plant":"Port Jefferson","State":"NY","Gas":269.5,"coordinates":[-73.0785,40.9497]},{"Plant":"Bethlehem Energy Center","State":"NY","Gas":365,"coordinates":[-73.7638,42.5942]},{"Plant":"Dynegy Morro Bay LLC","State":"CA","Gas":999,"coordinates":[-120.8566,35.3722]},{"Plant":"Dynegy Moss Landing Power Plant","State":"CA","Gas":2498,"coordinates":[-121.7822,36.8048]},{"Plant":"Bowline Point","State":"NY","Gas":1139,"coordinates":[-73.9689,41.2044]},{"Plant":"Asheville","State":"NC","Gas":545,"coordinates":[-82.5417,35.4731]},{"Plant":"Pittsburg Power","State":"CA","Gas":1906,"coordinates":[-121.8945,38.0392]},{"Plant":"Potrero Power","State":"CA","Gas":206,"coordinates":[-122.387,37.7566]},{"Plant":"Dicks Creek","State":"OH","Gas":106.2,"coordinates":[-84.3778,39.465]},{"Plant":"Frank M Tait","State":"OH","Gas":256,"coordinates":[-84.2111,39.7272]},{"Plant":"Yankee Street","State":"OH","Gas":107,"coordinates":[-84.2047,39.603]},{"Plant":"FirstEnergy West Lorain","State":"OH","Gas":370,"coordinates":[-82.2644,41.4294]},{"Plant":"Richland","State":"OH","Gas":358,"coordinates":[-84.3346,41.3052]},{"Plant":"Horseshoe Lake","State":"OK","Gas":860,"coordinates":[-97.1797,35.5087]},{"Plant":"Muskogee","State":"OK","Gas":149,"coordinates":[-95.2873,35.7614]},{"Plant":"Mustang","State":"OK","Gas":533,"coordinates":[-97.675,35.4699]},{"Plant":"Seminole","State":"OK","Gas":1535.6,"coordinates":[-96.7258,34.9665]},{"Plant":"Northeastern","State":"OK","Gas":600,"coordinates":[-95.7008,36.4317]},{"Plant":"Southwestern","State":"OK","Gas":472,"coordinates":[-98.3524,35.1009]},{"Plant":"Tulsa","State":"OK","Gas":400,"coordinates":[-95.991,36.1165]},{"Plant":"Weleetka","State":"OK","Gas":162,"coordinates":[-96.1352,35.3233]},{"Plant":"Barry","State":"AL","Gas":862,"coordinates":[-88.0103,31.0069]},{"Plant":"Anadarko Plant","State":"OK","Gas":356,"coordinates":[-98.23,35.0847]},{"Plant":"Mooreland","State":"OK","Gas":337,"coordinates":[-99.2254,36.4372]},{"Plant":"Encina","State":"CA","Gas":958,"coordinates":[-117.3364,33.1361]},{"Plant":"Kearny","State":"CA","Gas":127,"coordinates":[-117.1338,32.834]},{"Plant":"Brunot Island","State":"PA","Gas":289,"coordinates":[-80.0438,40.4649]},{"Plant":"Dynegy South Bay Power Plant","State":"CA","Gas":707,"coordinates":[-117.092,32.6114]},{"Plant":"AES Alamitos LLC","State":"CA","Gas":2120,"coordinates":[-118.1009,33.7688]},{"Plant":"Cromby Generating Station","State":"PA","Gas":201,"coordinates":[-75.5294,40.1531]},{"Plant":"Manchester Street","State":"RI","Gas":421.45,"coordinates":[-71.4042,41.8167]},{"Plant":"Darlington County","State":"SC","Gas":448,"coordinates":[-80.1657,34.4185]},{"Plant":"Coolwater","State":"CA","Gas":608,"coordinates":[-116.8539,34.8606]},{"Plant":"Urquhart","State":"SC","Gas":387,"coordinates":[-81.9111,33.435]},{"Plant":"El Segundo Power","State":"CA","Gas":940.54,"coordinates":[-118.4242,33.9098]},{"Plant":"Etiwanda Generating Station","State":"CA","Gas":1019,"coordinates":[-117.5266,34.0912]},{"Plant":"Riverside Canal Power","State":"CA","Gas":127,"coordinates":[-117.3312,34.0229]},{"Plant":"AES Huntington Beach LLC","State":"CA","Gas":983.4,"coordinates":[-117.9792,33.6439]},{"Plant":"Allen Steam Plant","State":"TN","Gas":456,"coordinates":[-90.1487,35.0741]},{"Plant":"Gallatin","State":"TN","Gas":596,"coordinates":[-86.4006,36.3156]},{"Plant":"Johnsonville","State":"TN","Gas":1124,"coordinates":[-87.9861,36.0278]},{"Plant":"Long Beach Generation LLC","State":"CA","Gas":584,"coordinates":[-118.2248,33.7641]},{"Plant":"E S Joslin","State":"TX","Gas":254,"coordinates":[-96.5458,28.6472]},{"Plant":"J L Bates","State":"TX","Gas":182,"coordinates":[-98.3944,26.2222]},{"Plant":"Laredo","State":"TX","Gas":178,"coordinates":[-99.5089,27.5667]},{"Plant":"Lon C Hill","State":"TX","Gas":559,"coordinates":[-97.6167,27.85]},{"Plant":"Nueces Bay","State":"TX","Gas":559,"coordinates":[-97.4192,27.8194]},{"Plant":"La Palma","State":"TX","Gas":255,"coordinates":[-97.6389,26.1331]},{"Plant":"Victoria","State":"TX","Gas":491,"coordinates":[-97.01,28.7883]},{"Plant":"Mandalay","State":"CA","Gas":560,"coordinates":[-119.2511,34.2067]},{"Plant":"Lake Hubbard","State":"TX","Gas":926,"coordinates":[-96.5458,32.8358]},{"Plant":"Mountain Creek","State":"TX","Gas":890,"coordinates":[-96.9358,32.7231]},{"Plant":"North Lake","State":"TX","Gas":675,"coordinates":[-96.975,32.9506]},{"Plant":"Parkdale","State":"TX","Gas":334,"coordinates":[-96.7233,32.7767]},{"Plant":"Newman","State":"TX","Gas":498,"coordinates":[-106.4318,31.9836]},{"Plant":"Lewis Creek","State":"TX","Gas":456,"coordinates":[-95.5214,30.4356]},{"Plant":"Neches","State":"TX","Gas":265,"coordinates":[-94.0593,30.0612]},{"Plant":"Sabine","State":"TX","Gas":1809,"coordinates":[-93.878,30.0242]},{"Plant":"Cedar Bayou","State":"TX","Gas":2258,"coordinates":[-94.9256,29.75]},{"Plant":"Deepwater","State":"TX","Gas":174,"coordinates":[-95.2253,29.7199]},{"Plant":"Greens Bayou","State":"TX","Gas":760,"coordinates":[-95.2194,29.8222]},{"Plant":"P H Robinson","State":"TX","Gas":2211,"coordinates":[-94.9794,29.4867]},{"Plant":"Sam Bertron","State":"TX","Gas":844,"coordinates":[-95.0598,29.7268]},{"Plant":"T H Wharton","State":"TX","Gas":1254,"coordinates":[-95.5306,29.9417]},{"Plant":"W A Parish","State":"TX","Gas":1191,"coordinates":[-95.6311,29.4828]},{"Plant":"Webster","State":"TX","Gas":387,"coordinates":[-95.1081,29.5258]},{"Plant":"Knox Lee","State":"TX","Gas":486,"coordinates":[-94.6415,32.3766]},{"Plant":"Wilkes","State":"TX","Gas":882,"coordinates":[-94.548,32.8482]},{"Plant":"Jones","State":"TX","Gas":486,"coordinates":[-101.7392,33.5239]},{"Plant":"Nichols","State":"TX","Gas":457,"coordinates":[-101.7464,35.2834]},{"Plant":"Plant X","State":"TX","Gas":442,"coordinates":[-102.4114,34.1661]},{"Plant":"Eagle Mountain","State":"TX","Gas":671,"coordinates":[-97.4792,32.9056]},{"Plant":"Graham","State":"TX","Gas":641,"coordinates":[-98.6117,33.1344]},{"Plant":"Handley","State":"TX","Gas":1421,"coordinates":[-97.2192,32.7283]},{"Plant":"Morgan Creek","State":"TX","Gas":1280,"coordinates":[-100.9156,32.3358]},{"Plant":"Permian Basin","State":"TX","Gas":1020,"coordinates":[-102.9633,31.5839]},{"Plant":"Ormond Beach","State":"CA","Gas":1516,"coordinates":[-119.1689,34.1292]},{"Plant":"Collin","State":"TX","Gas":154,"coordinates":[-96.8034,33.1576]},{"Plant":"Lake Creek","State":"TX","Gas":318,"coordinates":[-96.985,31.4647]},{"Plant":"River Crest","State":"TX","Gas":111,"coordinates":[-95.1467,33.3931]},{"Plant":"Stryker Creek","State":"TX","Gas":693,"coordinates":[-94.9898,31.9398]},{"Plant":"Tradinghouse","State":"TX","Gas":1375,"coordinates":[-96.9642,31.5728]},{"Plant":"Trinidad","State":"TX","Gas":236,"coordinates":[-96.1013,32.1245]},{"Plant":"Valley","State":"TX","Gas":727,"coordinates":[-96.3676,33.6281]},{"Plant":"Paint Creek","State":"TX","Gas":231,"coordinates":[-99.7337,33.1576]},{"Plant":"Rio Pecos","State":"TX","Gas":141,"coordinates":[-102.3753,31.0706]},{"Plant":"San Angelo","State":"TX","Gas":123,"coordinates":[-100.491,31.3906]},{"Plant":"Decker Creek","State":"TX","Gas":1010,"coordinates":[-97.6128,30.3033]},{"Plant":"Holly Street","State":"TX","Gas":591,"coordinates":[-97.7167,30.25]},{"Plant":"AES Redondo Beach LLC","State":"CA","Gas":1310,"coordinates":[-118.395,33.8504]},{"Plant":"Bryan","State":"TX","Gas":130,"coordinates":[-96.3723,30.6474]},{"Plant":"Ray Olinger","State":"TX","Gas":405.3,"coordinates":[-96.4525,33.0681]},{"Plant":"Mountainview Generating Station","State":"CA","Gas":120,"coordinates":[-117.2418,34.0818]},{"Plant":"Sim Gideon","State":"TX","Gas":620,"coordinates":[-97.2708,30.1456]},{"Plant":"Ty Cooke","State":"TX","Gas":148.6,"coordinates":[-101.7906,33.5211]},{"Plant":"J Robert Massengale","State":"TX","Gas":107,"coordinates":[-101.8408,33.6039]},{"Plant":"Leon Creek","State":"TX","Gas":160,"coordinates":[-98.5761,29.3525]},{"Plant":"O W Sommers","State":"TX","Gas":850,"coordinates":[-98.3242,29.3081]},{"Plant":"V H Braunig","State":"TX","Gas":862,"coordinates":[-98.3825,29.2567]},{"Plant":"W B Tuttle","State":"TX","Gas":425,"coordinates":[-98.4181,29.53]},{"Plant":"R W Miller","State":"TX","Gas":611,"coordinates":[-98.3103,32.6581]},{"Plant":"Sam Rayburn","State":"TX","Gas":229,"coordinates":[-97.135,28.8947]},{"Plant":"Gadsby","State":"UT","Gas":349,"coordinates":[-111.9289,40.7686]},{"Plant":"Grayson","State":"CA","Gas":250,"coordinates":[-118.2782,34.1556]},{"Plant":"Chesterfield","State":"VA","Gas":397,"coordinates":[-77.3833,37.3822]},{"Plant":"Possum Point","State":"VA","Gas":935,"coordinates":[-77.2806,38.5367]},{"Plant":"Transalta Centralia Generation","State":"WA","Gas":256,"coordinates":[-122.8598,46.7559]},{"Plant":"El Centro","State":"CA","Gas":225.9,"coordinates":[-115.54,32.8022]},{"Plant":"Harbor","State":"CA","Gas":500,"coordinates":[-118.2656,33.7706]},{"Plant":"Haynes","State":"CA","Gas":1570,"coordinates":[-118.0991,33.7647]},{"Plant":"Wheaton","State":"WI","Gas":350.95,"coordinates":[-91.5158,44.8854]},{"Plant":"Scattergood","State":"CA","Gas":803,"coordinates":[-118.4276,33.9182]},{"Plant":"Rock River","State":"WI","Gas":168.16,"coordinates":[-89.0276,42.582]},{"Plant":"West Marinette","State":"WI","Gas":160.9,"coordinates":[-87.6881,45.0869]},{"Plant":"Valley","State":"CA","Gas":564,"coordinates":[-118.3913,34.245]},{"Plant":"Broadway","State":"CA","Gas":161,"coordinates":[-118.148,34.1254]},{"Plant":"Spencer","State":"TX","Gas":179,"coordinates":[-97.1061,33.1975]},{"Plant":"Colbert","State":"AL","Gas":392,"coordinates":[-87.8486,34.7439]},{"Plant":"Zuni","State":"CO","Gas":107,"coordinates":[-105.017,39.7373]},{"Plant":"Thomas C Ferguson","State":"TX","Gas":420,"coordinates":[-98.3705,30.558]},{"Plant":"Fort Phantom","State":"TX","Gas":362,"coordinates":[-99.6778,32.5784]},{"Plant":"Barney M Davis","State":"TX","Gas":697,"coordinates":[-97.3117,27.6064]},{"Plant":"Riverside","State":"OK","Gas":917,"coordinates":[-95.9567,35.9978]},{"Plant":"Pittsfield Generating LP","State":"MA","Gas":141,"coordinates":[-73.2181,42.4564]},{"Plant":"Linden Cogen Plant","State":"NJ","Gas":899.8,"coordinates":[-74.2156,40.6322]},{"Plant":"Houston Chemical Complex Battleground","State":"TX","Gas":198,"coordinates":[-95.0839,29.7314]},{"Plant":"Sycamore Cogeneration","State":"CA","Gas":306.52,"coordinates":[-118.9853,35.4526]},{"Plant":"Union Carbide Seadrift Cogen","State":"TX","Gas":168,"coordinates":[-96.7706,28.5105]},{"Plant":"Dow St Charles Operations","State":"LA","Gas":291.6,"coordinates":[-90.4414,29.9861]},{"Plant":"Watson Cogeneration","State":"CA","Gas":398,"coordinates":[-118.2448,33.8166]},{"Plant":"Bucksport Generation LLC","State":"ME","Gas":269,"coordinates":[-68.8046,44.5738]},{"Plant":"Bethpage Power Plant","State":"NY","Gas":102,"coordinates":[-73.4994,40.7469]},{"Plant":"Shell Deer Park","State":"TX","Gas":234.65,"coordinates":[-95.1289,29.7232]},{"Plant":"Newark Bay Cogeneration Partnership LP","State":"NJ","Gas":118,"coordinates":[-74.13,40.7197]},{"Plant":"Mobile Energy Services LLC","State":"AL","Gas":124.9,"coordinates":[-88.0516,30.7365]},{"Plant":"Indeck Corinth Energy Center","State":"NY","Gas":131.5,"coordinates":[-73.8125,43.25]},{"Plant":"PPG Riverside","State":"LA","Gas":154,"coordinates":[-93.2807,30.2217]},{"Plant":"PPG Powerhouse C","State":"LA","Gas":303.2,"coordinates":[-93.2831,30.2242]},{"Plant":"Bayonne Plant Holding LLC","State":"NJ","Gas":170,"coordinates":[-74.1124,40.6553]},{"Plant":"Harbor Cogen","State":"CA","Gas":101.7,"coordinates":[-118.2303,33.7771]},{"Plant":"Rosemary Power Station","State":"NC","Gas":165,"coordinates":[-77.6594,36.4517]},{"Plant":"Oklahoma Cogeneration Project","State":"OK","Gas":111.4,"coordinates":[-97.625,35.4397]},{"Plant":"Eagle Point Power Generation","State":"NJ","Gas":195,"coordinates":[-75.1592,39.8746]},{"Plant":"TXU Sweetwater Generating Plant","State":"TX","Gas":264.7,"coordinates":[-100.365,32.4928]},{"Plant":"ExxonMobil Beaumont Refinery","State":"TX","Gas":194.6,"coordinates":[-94.0753,30.0636]},{"Plant":"JM Shafer Generating Station","State":"CO","Gas":248.54,"coordinates":[-104.7736,40.0986]},{"Plant":"Gary Works","State":"IN","Gas":221,"coordinates":[-87.3289,41.6224]},{"Plant":"Parlin Power Plant","State":"NJ","Gas":118,"coordinates":[-74.3272,40.4607]},{"Plant":"Optim Energy Altura Cogen LLC","State":"TX","Gas":448,"coordinates":[-95.1077,29.8161]},{"Plant":"Gramercy Holdings LLC","State":"LA","Gas":106,"coordinates":[-90.6693,30.054]},{"Plant":"Hardee Power Station","State":"FL","Gas":358,"coordinates":[-81.9636,27.6364]},{"Plant":"Bellmeade Power Station","State":"VA","Gas":230,"coordinates":[-77.4317,37.4964]},{"Plant":"Pryor Power Plant","State":"OK","Gas":111.5,"coordinates":[-95.3175,36.2977]},{"Plant":"Ocean State Power","State":"RI","Gas":218.62,"coordinates":[-71.6689,42.0097]},{"Plant":"LaO Energy Systems","State":"LA","Gas":588,"coordinates":[-91.2325,30.3186]},{"Plant":"Doswell Energy Center","State":"VA","Gas":819.8,"coordinates":[-77.1448,37.8182]},{"Plant":"Elizabeth River Power Station","State":"VA","Gas":312,"coordinates":[-76.3083,36.775]},{"Plant":"Texas City Power Plant","State":"TX","Gas":451,"coordinates":[-94.9438,29.3787]},{"Plant":"Dow Chemical Texas Operation","State":"TX","Gas":1138,"coordinates":[-95.4075,28.9913]},{"Plant":"Power Station 4","State":"TX","Gas":172,"coordinates":[-94.9219,29.3782]},{"Plant":"Midway Sunset Cogen","State":"CA","Gas":219,"coordinates":[-119.6294,35.2269]},{"Plant":"C R Wing Cogen Plant","State":"TX","Gas":227,"coordinates":[-101.4224,32.2732]},{"Plant":"Delaware City Plant","State":"DE","Gas":383.12,"coordinates":[-75.6343,39.5871]},{"Plant":"McWilliams","State":"AL","Gas":665,"coordinates":[-86.4764,31.4003]},{"Plant":"J K Smith","State":"KY","Gas":478,"coordinates":[-84.1017,37.8833]},{"Plant":"Lockport Energy Associates LP","State":"NY","Gas":210.2,"coordinates":[-78.745,43.1619]},{"Plant":"Kennedy International Airport Cogen","State":"NY","Gas":109.7,"coordinates":[-73.7778,40.6417]},{"Plant":"March Point Cogeneration","State":"WA","Gas":146.2,"coordinates":[-122.56,48.4708]},{"Plant":"Saguaro Power","State":"NV","Gas":101,"coordinates":[-115.0117,36.0417]},{"Plant":"Ocean State Power II","State":"RI","Gas":218.62,"coordinates":[-71.6701,42.0099]},{"Plant":"Orange Cogeneration Facility","State":"FL","Gas":117.48,"coordinates":[-81.8251,27.8708]},{"Plant":"Devon Station","State":"CT","Gas":122.8,"coordinates":[-73.109,41.2098]},{"Plant":"Lake Cogen Ltd","State":"FL","Gas":110,"coordinates":[-81.676,28.9158]},{"Plant":"Pasco Cogen Ltd","State":"FL","Gas":116.18,"coordinates":[-82.1889,28.3746]},{"Plant":"Mulberry Cogeneration Facility","State":"FL","Gas":107,"coordinates":[-81.8775,27.8489]},{"Plant":"Orlando Cogen LP","State":"FL","Gas":114.2,"coordinates":[-81.4123,28.4426]},{"Plant":"Sumas Power Plant","State":"WA","Gas":125.5,"coordinates":[-122.2733,48.9905]},{"Plant":"Formosa Plastics","State":"LA","Gas":115,"coordinates":[-91.1872,30.4992]},{"Plant":"Hartwell Energy Facility","State":"GA","Gas":302.5,"coordinates":[-82.8199,34.3396]},{"Plant":"Sithe Independence Station","State":"NY","Gas":982.2,"coordinates":[-76.4511,43.495]},{"Plant":"Saranac Facility","State":"NY","Gas":241,"coordinates":[-73.4557,44.7132]},{"Plant":"NAEA Lakewood LLC","State":"NJ","Gas":205.1,"coordinates":[-74.1686,40.0613]},{"Plant":"Auburndale Power Partners","State":"FL","Gas":165.72,"coordinates":[-81.8058,28.0542]},{"Plant":"Oyster Creek Unit VIII","State":"TX","Gas":379,"coordinates":[-95.342,28.9802]},{"Plant":"Hermiston Generating Plant","State":"OR","Gas":470,"coordinates":[-119.37,45.8042]},{"Plant":"Grays Ferry Cogeneration","State":"PA","Gas":150,"coordinates":[-75.1881,39.9422]},{"Plant":"Milford Power LP","State":"MA","Gas":148,"coordinates":[-71.5115,42.1294]},{"Plant":"Milagro Cogeneration Plant","State":"NM","Gas":121.6,"coordinates":[-107.9417,36.7367]},{"Plant":"Johnson County","State":"TX","Gas":267,"coordinates":[-97.4078,32.3994]},{"Plant":"Brandywine Power Facility","State":"MD","Gas":230,"coordinates":[-76.8678,38.6681]},{"Plant":"Gordonsville Energy LP","State":"VA","Gas":224,"coordinates":[-78.2138,38.1179]},{"Plant":"Sun Peak Generating Station","State":"NV","Gas":222,"coordinates":[-115.0339,36.1375]},{"Plant":"Brooklyn Navy Yard Cogeneration","State":"NY","Gas":230,"coordinates":[-73.9764,40.6994]},{"Plant":"Michigan Power LP","State":"MI","Gas":128,"coordinates":[-86.425,43.9375]},{"Plant":"LSP-Cottage Grove LP","State":"MN","Gas":251,"coordinates":[-92.9119,44.7956]},{"Plant":"LSP-Whitewater LP","State":"WI","Gas":251,"coordinates":[-88.7299,42.8555]},{"Plant":"Sweeny Cogen Facility","State":"TX","Gas":480,"coordinates":[-95.745,29.0728]},{"Plant":"Dighton Power Plant","State":"MA","Gas":159,"coordinates":[-71.1239,41.8312]},{"Plant":"De Pere Energy Center","State":"WI","Gas":183.3,"coordinates":[-88.072,44.4486]},{"Plant":"Androscoggin Energy Center","State":"ME","Gas":129.98,"coordinates":[-70.2423,44.5063]},{"Plant":"Delta Person LLC","State":"NM","Gas":140,"coordinates":[-106.644,35.026]},{"Plant":"Mid-Georgia Cogeneration Facility","State":"GA","Gas":316,"coordinates":[-83.6039,32.4856]},{"Plant":"Berkshire Power","State":"MA","Gas":232.12,"coordinates":[-72.6478,42.0476]},{"Plant":"Bridgeport Energy Project","State":"CT","Gas":454,"coordinates":[-73.1844,41.1692]},{"Plant":"Pasadena Cogeneration","State":"TX","Gas":700,"coordinates":[-95.1765,29.7248]},{"Plant":"Tiverton Power Plant","State":"RI","Gas":249.99,"coordinates":[-71.1706,41.6422]},{"Plant":"Axiall Plaquemine","State":"LA","Gas":240,"coordinates":[-91.185,30.2586]},{"Plant":"Tenaska Georgia Generation Facility","State":"GA","Gas":933,"coordinates":[-84.9996,33.3516]},{"Plant":"Tenaska Frontier Generation Station","State":"TX","Gas":860,"coordinates":[-95.9178,30.5924]},{"Plant":"Batesville Generation Facility","State":"MS","Gas":858,"coordinates":[-89.9275,34.3356]},{"Plant":"Black Hawk Station","State":"TX","Gas":221.4,"coordinates":[-101.36,35.6957]},{"Plant":"Mustang Station","State":"TX","Gas":486,"coordinates":[-102.7417,32.9728]},{"Plant":"Maine Independence Station","State":"ME","Gas":490.01,"coordinates":[-68.7094,44.8242]},{"Plant":"Pine Bluff Energy Center","State":"AR","Gas":198,"coordinates":[-91.9025,34.2181]},{"Plant":"Desert Star Energy Center","State":"NV","Gas":450,"coordinates":[-114.9928,35.7867]},{"Plant":"Millennium Power","State":"MA","Gas":337.8,"coordinates":[-72.0151,42.1123]},{"Plant":"New Albany Energy Facility","State":"MS","Gas":360,"coordinates":[-88.9397,34.5408]},{"Plant":"Brownsville Peaking Power","State":"TN","Gas":450,"coordinates":[-89.198,35.5438]},{"Plant":"Caledonia Power Facility","State":"MS","Gas":444,"coordinates":[-88.3186,33.6482]},{"Plant":"Crockett Cogen Project","State":"CA","Gas":247.4,"coordinates":[-122.2161,38.0569]},{"Plant":"Gregory Power Facility","State":"TX","Gas":412,"coordinates":[-97.2584,27.8893]},{"Plant":"Zeeland Generating Station","State":"MI","Gas":743.4,"coordinates":[-85.9975,42.8206]},{"Plant":"Dearborn Industrial Generation","State":"MI","Gas":700,"coordinates":[-83.154,42.3026]},{"Plant":"Taft Cogeneration Facility","State":"LA","Gas":790,"coordinates":[-90.4599,29.9888]},{"Plant":"Midlothian Energy Facility","State":"TX","Gas":1320,"coordinates":[-97.0537,32.4302]},{"Plant":"Lamar Power Project","State":"TX","Gas":1090.8,"coordinates":[-95.59,33.6308]},{"Plant":"Frontera Energy Center","State":"TX","Gas":475,"coordinates":[-98.3992,26.208]},{"Plant":"NRG Sterlington Power","State":"LA","Gas":176,"coordinates":[-92.0811,32.6889]},{"Plant":"Rumford Power Associates","State":"ME","Gas":254,"coordinates":[-70.5219,44.5303]},{"Plant":"Livingston Generating Station","State":"MI","Gas":132,"coordinates":[-84.7308,45.0304]},{"Plant":"Klamath Cogeneration Plant","State":"OR","Gas":470,"coordinates":[-121.8106,42.1739]},{"Plant":"Sabine Cogen","State":"TX","Gas":101,"coordinates":[-93.7714,30.0444]},{"Plant":"Entergy Rhode Island State Energy LP","State":"RI","Gas":515,"coordinates":[-71.5186,41.8017]},{"Plant":"Rocky Road Power LLC","State":"IL","Gas":340,"coordinates":[-88.2397,42.0931]},{"Plant":"Madison","State":"OH","Gas":576,"coordinates":[-84.4647,39.4522]},{"Plant":"Vermillion Energy Facility","State":"IN","Gas":560,"coordinates":[-87.4464,39.9223]},{"Plant":"Sutter Energy Center","State":"CA","Gas":530,"coordinates":[-121.6959,39.0531]},{"Plant":"Rockingham County CT Station","State":"NC","Gas":800,"coordinates":[-79.8297,36.3297]},{"Plant":"RS Cogen","State":"LA","Gas":395.6,"coordinates":[-93.2992,30.221]},{"Plant":"SRW Cogen LP","State":"TX","Gas":420,"coordinates":[-93.7574,30.0545]},{"Plant":"Magic Valley Generating Station","State":"TX","Gas":682,"coordinates":[-98.19,26.3403]},{"Plant":"Griffith Energy LLC","State":"AZ","Gas":588,"coordinates":[-114.1333,35.054]},{"Plant":"Manchief Electric Generating Station","State":"CO","Gas":264,"coordinates":[-103.685,40.2171]},{"Plant":"Walton County Power LLC","State":"GA","Gas":465,"coordinates":[-83.6954,33.8148]},{"Plant":"Desert Basin","State":"AZ","Gas":575,"coordinates":[-111.7889,32.9042]},{"Plant":"Kendall County Generation Facility","State":"IL","Gas":1140,"coordinates":[-88.2581,41.4797]},{"Plant":"Tenaska Gateway Generating Station","State":"TX","Gas":860,"coordinates":[-94.6197,32.0178]},{"Plant":"Alliant Energy Neenah","State":"WI","Gas":308.8,"coordinates":[-88.5064,44.1936]},{"Plant":"Rio Nogales Power Project","State":"TX","Gas":705,"coordinates":[-97.9732,29.5931]},{"Plant":"Wolf Hollow I LP","State":"TX","Gas":695.5,"coordinates":[-97.7317,32.3342]},{"Plant":"Hawk Road Facility","State":"GA","Gas":495,"coordinates":[-84.9914,33.3585]},{"Plant":"Hays Energy Project","State":"TX","Gas":876.8,"coordinates":[-97.9894,29.7806]},{"Plant":"Green Country Energy LLC","State":"OK","Gas":778.5,"coordinates":[-95.9346,35.9833]},{"Plant":"Worthington Generation LLC","State":"IN","Gas":170,"coordinates":[-87.0128,39.0708]},{"Plant":"Lake Road Generating Plant","State":"CT","Gas":732,"coordinates":[-71.8958,41.872]},{"Plant":"ExxonMobil Baton Rouge Cogen","State":"LA","Gas":332,"coordinates":[-91.1808,30.5234]},{"Plant":"La Paloma Generating LLC","State":"CA","Gas":840,"coordinates":[-119.5919,35.2956]},{"Plant":"Guadalupe Generating Station","State":"TX","Gas":1000,"coordinates":[-98.1419,29.6244]},{"Plant":"Lost Pines 1 Power Project","State":"TX","Gas":546,"coordinates":[-97.2714,30.1478]},{"Plant":"Bluegrass Generating Station","State":"KY","Gas":495,"coordinates":[-85.4133,38.3902]},{"Plant":"Calcasieu","State":"LA","Gas":320,"coordinates":[-93.345,30.1608]},{"Plant":"Broad River Energy Center","State":"SC","Gas":796.79,"coordinates":[-81.575,35.0786]},{"Plant":"Bastrop Energy Center","State":"TX","Gas":552,"coordinates":[-97.55,30.1458]},{"Plant":"Granite Ridge","State":"NH","Gas":797,"coordinates":[-71.4261,42.9042]},{"Plant":"Bosque County Peaking","State":"TX","Gas":548,"coordinates":[-97.3586,31.8594]},{"Plant":"Acadia Energy Center","State":"LA","Gas":1082,"coordinates":[-92.4131,30.4286]},{"Plant":"Eastman Cogeneration Facility","State":"TX","Gas":402.22,"coordinates":[-94.6903,32.4481]},{"Plant":"South Point Energy Center","State":"AZ","Gas":530,"coordinates":[-114.5317,34.8678]},{"Plant":"Dogwood Energy Facility","State":"MO","Gas":481,"coordinates":[-94.3006,38.7931]},{"Plant":"Rathdrum Power LLC","State":"ID","Gas":248,"coordinates":[-116.9203,47.7858]},{"Plant":"Sunrise Power LLC","State":"CA","Gas":545,"coordinates":[-119.585,35.2097]},{"Plant":"Channelview Cogeneration Plant","State":"TX","Gas":779,"coordinates":[-95.1217,29.837]},{"Plant":"Cordova Energy","State":"IL","Gas":680,"coordinates":[-90.2797,41.7122]},{"Plant":"Osceola","State":"FL","Gas":468,"coordinates":[-81.0978,28.1289]},{"Plant":"Caledonia","State":"MS","Gas":783,"coordinates":[-88.2717,33.6464]},{"Plant":"Riverside Generating LLC","State":"KY","Gas":495,"coordinates":[-82.6046,38.1917]},{"Plant":"Elwood Energy LLC","State":"IL","Gas":1350,"coordinates":[-88.1236,41.4388]},{"Plant":"Arapahoe Combustion Turbine Project","State":"CO","Gas":122.5,"coordinates":[-105.0018,39.6692]},{"Plant":"Gibson City","State":"IL","Gas":232,"coordinates":[-88.3987,40.4705]},{"Plant":"Pinckneyville","State":"IL","Gas":320,"coordinates":[-89.3467,38.1114]},{"Plant":"Kinmundy","State":"IL","Gas":232,"coordinates":[-89.0128,38.7619]},{"Plant":"Corpus Christi Energy Center","State":"TX","Gas":482.1,"coordinates":[-97.4283,27.8139]},{"Plant":"Afton Generating Station","State":"NM","Gas":141,"coordinates":[-106.8465,32.1142]},{"Plant":"ANP Bellingham Energy Project","State":"MA","Gas":443.4,"coordinates":[-71.4535,42.1106]},{"Plant":"ANP Blackstone Energy Project","State":"MA","Gas":444.2,"coordinates":[-71.5158,42.0599]},{"Plant":"Odessa Ector Generating Station","State":"TX","Gas":1026.2,"coordinates":[-102.3264,31.8403]},{"Plant":"Morris Cogeneration LLC","State":"IL","Gas":176,"coordinates":[-88.3328,41.4119]},{"Plant":"Los Medanos Energy Center","State":"CA","Gas":567,"coordinates":[-121.873,38.0301]},{"Plant":"Hinds Energy Facility","State":"MS","Gas":450,"coordinates":[-90.2199,32.379]},{"Plant":"Southaven Energy Facility","State":"MS","Gas":624,"coordinates":[-90.0397,34.9808]},{"Plant":"Attala","State":"MS","Gas":459,"coordinates":[-89.6753,33.0147]},{"Plant":"Harry L. Oswald","State":"AR","Gas":568,"coordinates":[-92.2166,34.5923]},{"Plant":"Lincoln Generating Facility","State":"IL","Gas":600,"coordinates":[-87.9436,41.3933]},{"Plant":"Ennis Power Company LLC","State":"TX","Gas":359.5,"coordinates":[-96.675,32.32]},{"Plant":"Wheatland Generating Facility","State":"IN","Gas":472,"coordinates":[-87.2931,38.6716]},{"Plant":"Oneta Energy Center","State":"OK","Gas":1082.1,"coordinates":[-95.6967,36.0119]},{"Plant":"Freestone Energy Center","State":"TX","Gas":886,"coordinates":[-96.1131,31.8907]},{"Plant":"Greenville Electric Generating Station","State":"OH","Gas":180,"coordinates":[-84.6151,40.0758]},{"Plant":"Montpelier Electric Generating Station","State":"IN","Gas":180,"coordinates":[-85.3057,40.6206]},{"Plant":"Liberty Electric Power Plant","State":"PA","Gas":458,"coordinates":[-75.3358,39.8614]},{"Plant":"Marshall Energy Facility","State":"KY","Gas":544,"coordinates":[-88.3958,37.0286]},{"Plant":"Handsome Lake Energy LLC","State":"PA","Gas":250,"coordinates":[-79.8061,41.2908]},{"Plant":"Audrain Generating Station","State":"MO","Gas":640,"coordinates":[-91.5369,39.3092]},{"Plant":"Lee Energy Facility","State":"IL","Gas":568,"coordinates":[-89.4054,41.8287]},{"Plant":"Energy Shelby County","State":"IL","Gas":371.6,"coordinates":[-88.4772,39.2794]},{"Plant":"NRG Rockford I","State":"IL","Gas":310,"coordinates":[-89.1012,42.2386]},{"Plant":"Red Oak Power LLC","State":"NJ","Gas":791.9,"coordinates":[-74.3489,40.4487]},{"Plant":"Hog Bayou Energy Center","State":"AL","Gas":230,"coordinates":[-88.0575,30.7478]},{"Plant":"Santa Rosa Energy Center","State":"FL","Gas":236.1,"coordinates":[-87.115,30.5664]},{"Plant":"Astoria Gas Turbines","State":"NY","Gas":420,"coordinates":[-73.9048,40.787]},{"Plant":"Doyle Energy Facility","State":"GA","Gas":355,"coordinates":[-83.6996,33.8377]},{"Plant":"Darby Electric Generating Station","State":"OH","Gas":451.8,"coordinates":[-83.1778,39.7139]},{"Plant":"Tait Electric Generating Station","State":"OH","Gas":319.6,"coordinates":[-84.2095,39.7277]},{"Plant":"University Park South","State":"IL","Gas":300,"coordinates":[-87.7532,41.4409]},{"Plant":"Gleason Generating Facility","State":"TN","Gas":540,"coordinates":[-88.612,36.2454]},{"Plant":"Crete Energy Venture LLC","State":"IL","Gas":293.4,"coordinates":[-87.6187,41.4294]},{"Plant":"Whiting Clean Energy","State":"IN","Gas":547,"coordinates":[-87.4775,41.6739]},{"Plant":"Edward L. Addison Generating Plant","State":"GA","Gas":609,"coordinates":[-84.3064,32.9111]},{"Plant":"TVA Southaven Combined Cycle","State":"MS","Gas":783,"coordinates":[-90.0378,34.9939]},{"Plant":"Jackson Generating Station","State":"MI","Gas":554.8,"coordinates":[-84.3767,42.2488]},{"Plant":"Tenaska Lindsay Hill Generating Station","State":"AL","Gas":857.9,"coordinates":[-86.7386,32.6514]},{"Plant":"Ceredo Generating Station","State":"WV","Gas":456.5,"coordinates":[-82.5339,38.3681]},{"Plant":"Aurora","State":"IL","Gas":910,"coordinates":[-88.2265,41.8151]},{"Plant":"Southeast Chicago Energy Project","State":"IL","Gas":304,"coordinates":[-87.5449,41.7181]},{"Plant":"Arlington Valley Energy Facility","State":"AZ","Gas":580,"coordinates":[-112.8897,33.3417]},{"Plant":"Front Range Power Plant","State":"CO","Gas":461.5,"coordinates":[-104.7069,38.6281]},{"Plant":"Big Sandy Peaker Plant","State":"WV","Gas":300,"coordinates":[-82.5938,38.3441]},{"Plant":"Wolf Hills Energy","State":"VA","Gas":250,"coordinates":[-82.1044,36.6644]},{"Plant":"Oleander Power Project LP","State":"FL","Gas":596,"coordinates":[-80.7947,28.3661]},{"Plant":"Decatur Energy Center","State":"AL","Gas":624,"coordinates":[-87.0214,34.6292]},{"Plant":"Morgan Energy Center","State":"AL","Gas":588,"coordinates":[-87.0639,34.6397]},{"Plant":"Westbrook Energy Center Power Plant","State":"ME","Gas":506,"coordinates":[-70.375,43.6575]},{"Plant":"Blythe Energy Inc","State":"CA","Gas":508.26,"coordinates":[-114.6865,33.6157]},{"Plant":"Calumet Energy Team LLC","State":"IL","Gas":324,"coordinates":[-87.5563,41.6835]},{"Plant":"New Covert Generating Facility","State":"MI","Gas":1058.4,"coordinates":[-86.2937,42.3224]},{"Plant":"Channel Energy Center LLC","State":"TX","Gas":574.9,"coordinates":[-95.2319,29.7189]},{"Plant":"Warren Peaking Power Facility","State":"MS","Gas":300,"coordinates":[-90.9284,32.2849]},{"Plant":"Baconton Power Plant","State":"GA","Gas":195.2,"coordinates":[-84.08,31.3869]},{"Plant":"Gila River Power Station","State":"AZ","Gas":2060,"coordinates":[-112.6944,32.975]},{"Plant":"Ingleside Cogeneration","State":"TX","Gas":460,"coordinates":[-97.2428,27.8828]},{"Plant":"Union Power Station","State":"AR","Gas":2020,"coordinates":[-92.5885,33.2985]},{"Plant":"Fore River Generating Station","State":"MA","Gas":683.51,"coordinates":[-70.9661,42.2422]},{"Plant":"Indian River","State":"FL","Gas":608,"coordinates":[-80.7802,28.4932]},{"Plant":"Baytown Energy Center","State":"TX","Gas":785,"coordinates":[-94.9019,29.7731]},{"Plant":"Hermiston Power Partnership","State":"OR","Gas":615,"coordinates":[-119.3133,45.794]},{"Plant":"Washington County","State":"GA","Gas":616,"coordinates":[-82.98,33.0922]},{"Plant":"Delta Energy Center","State":"CA","Gas":811.3,"coordinates":[-121.8439,38.0169]},{"Plant":"Holland Energy Facility","State":"IL","Gas":449,"coordinates":[-88.7584,39.2231]},{"Plant":"Ontelaunee Energy Center","State":"PA","Gas":516,"coordinates":[-75.9356,40.422]},{"Plant":"PPL Ironwood LLC","State":"PA","Gas":666,"coordinates":[-76.3658,40.3509]},{"Plant":"Armstrong","State":"PA","Gas":584,"coordinates":[-79.3517,40.638]},{"Plant":"Troy Energy LLC","State":"OH","Gas":584,"coordinates":[-83.4598,41.4772]},{"Plant":"Pleasants Energy LLC","State":"WV","Gas":292.4,"coordinates":[-81.3642,39.3325]},{"Plant":"Brazos Valley Generating Facility","State":"TX","Gas":718,"coordinates":[-95.6244,29.4731]},{"Plant":"Cottonwood Energy Project","State":"TX","Gas":1233.6,"coordinates":[-93.7353,30.2588]},{"Plant":"Sugar Creek Power","State":"IN","Gas":520.7,"coordinates":[-87.5108,39.3931]},{"Plant":"Exelon LaPorte Generating Station","State":"TX","Gas":168,"coordinates":[-95.0718,29.7028]},{"Plant":"Harquahala Generating Project","State":"AZ","Gas":355.2,"coordinates":[-113.1134,33.476]},{"Plant":"Enterprise Energy Facility","State":"MS","Gas":600,"coordinates":[-90.0394,34.9767]},{"Plant":"Thomas A Smith Energy Facility","State":"GA","Gas":1244,"coordinates":[-84.9175,34.7094]},{"Plant":"RockGen Energy Center","State":"WI","Gas":467.15,"coordinates":[-89.0492,42.9767]},{"Plant":"Zion Energy Center","State":"IL","Gas":456,"coordinates":[-87.895,42.4776]},{"Plant":"Crossroads Energy Center","State":"MS","Gas":308,"coordinates":[-90.5621,34.183]},{"Plant":"Washington Energy Facility","State":"OH","Gas":600,"coordinates":[-81.6564,39.58]},{"Plant":"Elk Hills Power LLC","State":"CA","Gas":525,"coordinates":[-119.4707,35.2803]},{"Plant":"Rolling Hills Generating","State":"OH","Gas":825,"coordinates":[-82.3328,39.0839]},{"Plant":"Renaissance Power LLC","State":"MI","Gas":660,"coordinates":[-84.8429,43.1864]},{"Plant":"Carville Energy LLC","State":"LA","Gas":500,"coordinates":[-91.065,30.2294]},{"Plant":"Effingham County Power Project","State":"GA","Gas":490,"coordinates":[-81.2844,32.2773]},{"Plant":"Calhoun Energy Center","State":"AL","Gas":620,"coordinates":[-85.9731,33.5883]},{"Plant":"Shady Hills Generating Station","State":"FL","Gas":468,"coordinates":[-82.5586,28.3665]},{"Plant":"Vandolah Power Station","State":"FL","Gas":632,"coordinates":[-81.924,27.5236]},{"Plant":"Raccoon Creek Energy Center","State":"IL","Gas":304,"coordinates":[-88.5392,38.6996]},{"Plant":"Hot Spring Generating Facility","State":"AR","Gas":651.6,"coordinates":[-92.8683,34.2976]},{"Plant":"DeSoto County Plant","State":"FL","Gas":308,"coordinates":[-81.8092,27.2272]},{"Plant":"Bayou Cove Peaking Power","State":"LA","Gas":300,"coordinates":[-92.5997,30.2825]},{"Plant":"Elgin Energy Center","State":"IL","Gas":452,"coordinates":[-88.2446,42.0001]},{"Plant":"Tenaska Central Alabama Generating Stn","State":"AL","Gas":808.3,"coordinates":[-86.74,32.6497]},{"Plant":"Columbia Energy Center","State":"MO","Gas":140,"coordinates":[-92.2629,39.0192]},{"Plant":"Magnolia Power Plant","State":"MS","Gas":863.1,"coordinates":[-89.2026,34.835]},{"Plant":"Fountain Valley Power Facility","State":"CO","Gas":234,"coordinates":[-104.6875,38.5569]},{"Plant":"McClain Energy Facility","State":"OK","Gas":451,"coordinates":[-97.5898,35.2977]},{"Plant":"Deer Park Energy Center","State":"TX","Gas":309.6,"coordinates":[-95.1345,29.7134]},{"Plant":"Ouachita","State":"LA","Gas":816,"coordinates":[-92.0683,32.7061]},{"Plant":"Green Power 2","State":"TX","Gas":584,"coordinates":[-94.9328,29.3781]},{"Plant":"Forney Energy Center","State":"TX","Gas":1564,"coordinates":[-96.4916,32.7563]},{"Plant":"Mesquite Generating Station","State":"AZ","Gas":1073.3,"coordinates":[-112.8642,33.345]},{"Plant":"Tri Center Naniwa Energy","State":"NV","Gas":300,"coordinates":[-119.5178,39.5572]},{"Plant":"Goose Creek Energy Center","State":"IL","Gas":456,"coordinates":[-88.5999,40.1069]},{"Plant":"Kiamichi Energy Facility","State":"OK","Gas":1178.4,"coordinates":[-95.9349,34.6831]},{"Plant":"AEP Waterford Facility","State":"OH","Gas":814,"coordinates":[-81.7178,39.5333]},{"Plant":"Limon Generating Station","State":"CO","Gas":134,"coordinates":[-103.7005,39.2038]},{"Plant":"Frank Knutson","State":"CO","Gas":134,"coordinates":[-104.682,39.9411]},{"Plant":"Apex Generating Station","State":"NV","Gas":494.4,"coordinates":[-114.9609,36.416]},{"Plant":"Fayette Energy Facility","State":"PA","Gas":600.5,"coordinates":[-79.9182,39.8592]},{"Plant":"Wallingford Energy","State":"CT","Gas":190,"coordinates":[-72.8354,41.4487]},{"Plant":"High Desert Power Plant","State":"CA","Gas":780,"coordinates":[-117.3647,34.5953]},{"Plant":"AES Greystone","State":"TN","Gas":468,"coordinates":[-89.3937,35.6532]},{"Plant":"Sundance","State":"AZ","Gas":383,"coordinates":[-111.5899,32.9285]},{"Plant":"Redhawk","State":"AZ","Gas":918,"coordinates":[-112.8374,33.3447]},{"Plant":"Indigo Energy Facility","State":"CA","Gas":149.7,"coordinates":[-116.553,33.9109]},{"Plant":"Hidalgo Energy Center","State":"TX","Gas":470,"coordinates":[-98.1758,26.3417]},{"Plant":"Perryville Power Station","State":"LA","Gas":718,"coordinates":[-92.0183,32.6908]},{"Plant":"West Valley Generation Project","State":"UT","Gas":185,"coordinates":[-112.0317,40.6667]},{"Plant":"University Park North","State":"IL","Gas":459.6,"coordinates":[-87.7514,41.4425]},{"Plant":"Blue Spruce Energy Center","State":"CO","Gas":276,"coordinates":[-104.6814,39.7479]},{"Plant":"Plains End","State":"CO","Gas":113,"coordinates":[-105.226,39.8575]},{"Plant":"Spring Creek Energy Center","State":"OK","Gas":280,"coordinates":[-97.655,35.7422]},{"Plant":"EP Newington Energy LLC","State":"NH","Gas":525,"coordinates":[-70.8061,43.1047]},{"Plant":"Chehalis Generating Facility","State":"WA","Gas":495,"coordinates":[-122.9131,46.6225]},{"Plant":"Harrison County Power Project","State":"TX","Gas":484.5,"coordinates":[-94.4367,32.3958]},{"Plant":"AL Sandersville LLC","State":"GA","Gas":624,"coordinates":[-82.8608,33.1189]},{"Plant":"Bethlehem Power Plant","State":"PA","Gas":1068,"coordinates":[-75.3147,40.6175]},{"Plant":"Pierce Power Station","State":"WA","Gas":130.9,"coordinates":[-122.3758,47.1365]},{"Plant":"Choctaw County","State":"MS","Gas":726,"coordinates":[-89.4201,33.2881]},{"Plant":"Allegheny Energy Units 3 4 & 5","State":"PA","Gas":509,"coordinates":[-79.7686,40.5453]},{"Plant":"Dean","State":"MI","Gas":295.4,"coordinates":[-82.4953,42.7725]},{"Plant":"Hanging Rock Energy Facility","State":"OH","Gas":1288,"coordinates":[-82.7833,38.5731]},{"Plant":"Los Esteros Critical Energy Center","State":"CA","Gas":180,"coordinates":[-121.9319,37.425]},{"Plant":"Gilroy Peaking Energy Center","State":"CA","Gas":128.3,"coordinates":[-121.5363,36.999]},{"Plant":"Frederickson Power LP","State":"WA","Gas":254.5,"coordinates":[-122.3657,47.0861]},{"Plant":"Curtis H Stanton Energy Center","State":"FL","Gas":591.93,"coordinates":[-81.1669,28.4882]},{"Plant":"Foothills Generating LLC","State":"KY","Gas":330,"coordinates":[-82.5873,38.2536]},{"Plant":"Tracy Combined Cycle Power Plant","State":"CA","Gas":167.13,"coordinates":[-121.4906,37.7107]},{"Plant":"NRG Rockford II Energy Center","State":"IL","Gas":159,"coordinates":[-89.1011,42.2383]},{"Plant":"NAEA Ocean Peaking Power LLC","State":"NJ","Gas":325.6,"coordinates":[-74.1672,40.0633]},{"Plant":"Las Vegas Cogeneration II LLC","State":"NV","Gas":220,"coordinates":[-115.1238,36.232]},{"Plant":"Big Cajun 1 Peakers","State":"LA","Gas":210,"coordinates":[-91.4145,30.6238]},{"Plant":"Wansley Combined Cycle","State":"GA","Gas":1065.56,"coordinates":[-85.037,33.4064]},{"Plant":"Hunterstown","State":"PA","Gas":810,"coordinates":[-77.1672,39.8725]},{"Plant":"Sylvarena","State":"MS","Gas":141,"coordinates":[-89.4081,31.9954]},{"Plant":"Olive","State":"CA","Gas":152.5,"coordinates":[-118.3147,34.1764]},{"Plant":"Collins","State":"IL","Gas":2671,"coordinates":[-88.3928,41.3461]},{"Plant":"Belle River","State":"MI","Gas":225,"coordinates":[-82.495,42.7756]},{"Plant":"Greenwood","State":"MI","Gas":225,"coordinates":[-82.6964,43.1056]},{"Plant":"Martin","State":"FL","Gas":2890,"coordinates":[-80.5628,27.0536]},{"Plant":"DeBary","State":"FL","Gas":258,"coordinates":[-81.3323,28.9039]},{"Plant":"Electrifarm","State":"IA","Gas":199.8,"coordinates":[-92.4205,42.4407]},{"Plant":"Fredonia","State":"WA","Gas":309.4,"coordinates":[-122.4358,48.4558]},{"Plant":"Trimble County","State":"KY","Gas":320,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Gas":1080,"coordinates":[-88.5553,30.5322]},{"Plant":"Greenwood","State":"MO","Gas":242,"coordinates":[-94.2982,38.8615]},{"Plant":"R M Schahfer","State":"IN","Gas":155,"coordinates":[-87.0261,41.2164]},{"Plant":"Cutler","State":"FL","Gas":206,"coordinates":[-80.2989,25.6321]},{"Plant":"Fort St Vrain","State":"CO","Gas":690.7,"coordinates":[-104.8742,40.2461]},{"Plant":"Fort Myers","State":"FL","Gas":1751,"coordinates":[-81.7831,26.6967]},{"Plant":"Whitehorn","State":"WA","Gas":158,"coordinates":[-122.6861,48.8288]},{"Plant":"McIntosh","State":"GA","Gas":668,"coordinates":[-81.1683,32.3563]},{"Plant":"Lauderdale","State":"FL","Gas":1699,"coordinates":[-80.1984,26.0686]},{"Plant":"A B Brown","State":"IN","Gas":160,"coordinates":[-87.715,37.9053]},{"Plant":"Port Everglades","State":"FL","Gas":420,"coordinates":[-80.1253,26.0856]},{"Plant":"Brame Energy Center","State":"LA","Gas":440,"coordinates":[-92.7167,31.395]},{"Plant":"John Twitty Energy Center","State":"MO","Gas":148,"coordinates":[-93.388,37.1517]},{"Plant":"Sanford","State":"FL","Gas":1880,"coordinates":[-81.3256,28.8419]},{"Plant":"Empire Energy Center","State":"MO","Gas":271,"coordinates":[-94.1041,37.1385]},{"Plant":"Dansby","State":"TX","Gas":110,"coordinates":[-96.4608,30.7217]},{"Plant":"Putnam","State":"FL","Gas":498,"coordinates":[-81.5851,29.6283]},{"Plant":"Higgins","State":"FL","Gas":122,"coordinates":[-82.6615,28.0033]},{"Plant":"Rokeby","State":"NE","Gas":262.7,"coordinates":[-96.7364,40.7316]},{"Plant":"Suwannee River","State":"FL","Gas":110,"coordinates":[-83.1806,30.3764]},{"Plant":"Lansing Smith","State":"FL","Gas":481,"coordinates":[-85.7003,30.2686]},{"Plant":"D G Hunter","State":"LA","Gas":157,"coordinates":[-92.4613,31.3207]},{"Plant":"George M Sullivan Generation Plant 2","State":"AK","Gas":219.9,"coordinates":[-149.7167,61.2297]},{"Plant":"Henry D King","State":"FL","Gas":130,"coordinates":[-80.3386,27.4486]},{"Plant":"Deerhaven Generating Station","State":"FL","Gas":194,"coordinates":[-82.3878,29.7592]},{"Plant":"John R Kelly","State":"FL","Gas":191,"coordinates":[-82.3208,29.6461]},{"Plant":"J D Kennedy","State":"FL","Gas":158.6,"coordinates":[-81.626,30.3648]},{"Plant":"Larsen Memorial","State":"FL","Gas":195,"coordinates":[-81.9228,28.0797]},{"Plant":"C D McIntosh Jr","State":"FL","Gas":532,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Gas":180,"coordinates":[-105.0212,40.8609]},{"Plant":"Indian River Plant","State":"FL","Gas":289,"coordinates":[-80.7801,28.4932]},{"Plant":"Arvah B Hopkins","State":"FL","Gas":340,"coordinates":[-84.4,30.4522]},{"Plant":"S O Purdom","State":"FL","Gas":301,"coordinates":[-84.2007,30.1623]},{"Plant":"Vero Beach Municipal Power Plant","State":"FL","Gas":150,"coordinates":[-80.3776,27.6334]},{"Plant":"Atkinson","State":"GA","Gas":182,"coordinates":[-84.4803,33.8175]},{"Plant":"Gravel Neck","State":"VA","Gas":292,"coordinates":[-76.6911,37.1575]},{"Plant":"McIntosh","State":"AL","Gas":340,"coordinates":[-88.0299,31.2546]},{"Plant":"Pleasant Hill","State":"IA","Gas":163,"coordinates":[-93.5242,41.5572]},{"Plant":"Hay Road","State":"DE","Gas":1060,"coordinates":[-75.5072,39.7436]},{"Plant":"Woodsdale","State":"OH","Gas":462,"coordinates":[-84.4611,39.4492]},{"Plant":"Concord","State":"WI","Gas":376,"coordinates":[-88.69,43.1669]},{"Plant":"South Fond Du Lac","State":"WI","Gas":332.97,"coordinates":[-88.4967,43.7353]},{"Plant":"Darbytown","State":"VA","Gas":288,"coordinates":[-77.3685,37.4982]},{"Plant":"Angus Anson","State":"SD","Gas":215.13,"coordinates":[-96.6356,43.6035]},{"Plant":"Cane Island","State":"FL","Gas":380,"coordinates":[-81.533,28.2764]},{"Plant":"Polk","State":"FL","Gas":325,"coordinates":[-81.9897,27.7286]},{"Plant":"Woodland","State":"CA","Gas":133,"coordinates":[-121.0204,37.6526]},{"Plant":"491 E 48th Street","State":"MI","Gas":148.2,"coordinates":[-86.0853,42.7553]},{"Plant":"Paris","State":"WI","Gas":400,"coordinates":[-88.0131,42.6658]},{"Plant":"Lincoln Combustion","State":"NC","Gas":1267.2,"coordinates":[-81.0347,35.4317]},{"Plant":"State Line Combined Cycle","State":"MO","Gas":589,"coordinates":[-94.614,37.0659]},{"Plant":"Hines Energy Complex","State":"FL","Gas":998,"coordinates":[-81.87,27.7882]},{"Plant":"Redding Power","State":"CA","Gas":133.6,"coordinates":[-122.4233,40.5073]},{"Plant":"Richard M Flynn","State":"NY","Gas":136.2,"coordinates":[-73.064,40.8158]},{"Plant":"San Jacinto Steam Electric Station","State":"TX","Gas":162,"coordinates":[-95.0406,29.6948]},{"Plant":"Riverside","State":"GA","Gas":107,"coordinates":[-81.0956,32.0836]},{"Plant":"Robins","State":"GA","Gas":160,"coordinates":[-83.5822,32.5792]},{"Plant":"Coyote Springs","State":"OR","Gas":220,"coordinates":[-119.6739,45.848]},{"Plant":"Midulla Generating Station","State":"FL","Gas":488,"coordinates":[-81.9625,27.6417]},{"Plant":"Interstate","State":"IL","Gas":128,"coordinates":[-89.5891,39.8233]},{"Plant":"Rathdrum","State":"ID","Gas":136,"coordinates":[-116.8673,47.8043]},{"Plant":"Arthur Von Rosenberg","State":"TX","Gas":482,"coordinates":[-98.384,29.257]},{"Plant":"Carson Ice-Gen Project","State":"CA","Gas":101,"coordinates":[-121.4624,38.4457]},{"Plant":"Wayne County","State":"NC","Gas":668,"coordinates":[-78.0981,35.3758]},{"Plant":"Ponca City","State":"OK","Gas":107.6,"coordinates":[-97.0858,36.7198]},{"Plant":"SCA Cogen 2","State":"CA","Gas":154.6,"coordinates":[-121.4001,38.5309]},{"Plant":"SPA Cogen 3","State":"CA","Gas":164,"coordinates":[-121.4735,38.511]},{"Plant":"St Francis Energy Facility","State":"MO","Gas":473,"coordinates":[-90.1779,36.5852]},{"Plant":"River Road Gen Plant","State":"WA","Gas":210,"coordinates":[-122.7256,45.6497]},{"Plant":"Washington County Cogeneration Facility","State":"AL","Gas":131.7,"coordinates":[-88.0156,31.2504]},{"Plant":"Tiger Bay","State":"FL","Gas":207,"coordinates":[-81.8494,27.7464]},{"Plant":"Dahlberg","State":"GA","Gas":750,"coordinates":[-83.3977,34.0423]},{"Plant":"H Allen Franklin Combined Cycle","State":"AL","Gas":1139.48,"coordinates":[-85.0975,32.6078]},{"Plant":"Theodore Cogen Facility","State":"AL","Gas":224.7,"coordinates":[-88.1285,30.5254]},{"Plant":"Essex","State":"MO","Gas":107.4,"coordinates":[-89.8402,36.8682]},{"Plant":"Nodaway","State":"MO","Gas":182.8,"coordinates":[-94.7913,40.2877]},{"Plant":"Chouteau","State":"OK","Gas":495,"coordinates":[-95.2771,36.2221]},{"Plant":"Georgetown","State":"IN","Gas":295,"coordinates":[-86.2441,39.9026]},{"Plant":"Tilton","State":"IL","Gas":176,"coordinates":[-87.6538,40.1061]},{"Plant":"Henry County","State":"IN","Gas":135.5,"coordinates":[-85.5039,39.9528]},{"Plant":"MPC Generating","State":"GA","Gas":314.3,"coordinates":[-83.6953,33.8119]},{"Plant":"Sherwood H Smith Jr Energy Complex","State":"NC","Gas":1247,"coordinates":[-79.7406,34.8392]},{"Plant":"Sewell Creek Energy","State":"GA","Gas":491.4,"coordinates":[-85.2769,33.9486]},{"Plant":"Alsey","State":"IL","Gas":121,"coordinates":[-90.436,39.5698]},{"Plant":"Fulton","State":"AR","Gas":153,"coordinates":[-93.7924,33.6094]},{"Plant":"Rowan","State":"NC","Gas":967.1,"coordinates":[-80.6019,35.7314]},{"Plant":"Smarr Energy Center","State":"GA","Gas":217.4,"coordinates":[-83.8464,32.9842]},{"Plant":"John S Rainey","State":"SC","Gas":744,"coordinates":[-82.776,34.3477]},{"Plant":"Essential Power Rock Springs LLC","State":"MD","Gas":633.6,"coordinates":[-76.1598,39.719]},{"Plant":"Louisa Generating","State":"VA","Gas":458.5,"coordinates":[-78.2139,38.1181]},{"Plant":"Remington","State":"VA","Gas":580,"coordinates":[-77.7714,38.5442]},{"Plant":"Ladysmith","State":"VA","Gas":290,"coordinates":[-77.5133,38.0722]},{"Plant":"Pleasant Valley","State":"MN","Gas":422.9,"coordinates":[-92.6829,43.7994]},{"Plant":"Lagoon Creek","State":"TN","Gas":952,"coordinates":[-89.3964,35.6578]},{"Plant":"Brandy Branch","State":"FL","Gas":475.8,"coordinates":[-81.9472,30.3206]},{"Plant":"Holden","State":"MO","Gas":232.8,"coordinates":[-93.9983,38.7538]},{"Plant":"MEPI GT Facility","State":"IL","Gas":239,"coordinates":[-88.8661,37.2175]},{"Plant":"Encogen","State":"WA","Gas":160,"coordinates":[-122.486,48.746]},{"Plant":"Robert P Mone Plant","State":"OH","Gas":447,"coordinates":[-84.7392,40.9297]},{"Plant":"H L Culbreath Bayside Power Station","State":"FL","Gas":1012,"coordinates":[-82.4231,27.9072]},{"Plant":"Cass County","State":"NE","Gas":320,"coordinates":[-95.9659,40.9441]},{"Plant":"E B Harris Electric Generating Plant","State":"AL","Gas":1035.4,"coordinates":[-86.5744,32.3814]},{"Plant":"Sand Hill","State":"TX","Gas":189.2,"coordinates":[-97.6129,30.2098]},{"Plant":"Talbot County Energy","State":"GA","Gas":652.2,"coordinates":[-84.6917,32.5892]},{"Plant":"Chattahoochee Energy Facility","State":"GA","Gas":465,"coordinates":[-85.0386,33.4072]},{"Plant":"Lakefield Junction","State":"MN","Gas":525.2,"coordinates":[-94.8415,43.7984]},{"Plant":"West Gardner","State":"KS","Gas":308,"coordinates":[-94.9861,38.7875]},{"Plant":"Coyote Springs II","State":"OR","Gas":244,"coordinates":[-119.674,45.848]},{"Plant":"Kemper County","State":"MS","Gas":312,"coordinates":[-88.606,32.7976]},{"Plant":"Peno Creek","State":"MO","Gas":188,"coordinates":[-91.2295,39.3531]},{"Plant":"Sumpter","State":"MI","Gas":296,"coordinates":[-83.5318,42.167]},{"Plant":"Pyramid","State":"NM","Gas":158,"coordinates":[-108.5494,32.2363]},{"Plant":"Mill Creek","State":"SC","Gas":572.8,"coordinates":[-81.4306,35.1597]},{"Plant":"Greater Des Moines","State":"IA","Gas":542,"coordinates":[-93.5283,41.5563]},{"Plant":"Murray Turbine","State":"UT","Gas":159,"coordinates":[-111.89,40.67]},{"Plant":"Sycamore","State":"IA","Gas":147.5,"coordinates":[-93.6769,41.6722]},{"Plant":"Intercession City","State":"FL","Gas":604,"coordinates":[-81.5486,28.2628]},{"Plant":"Gerald Andrus","State":"MS","Gas":741,"coordinates":[-91.1167,33.35]},{"Plant":"Waterford 1 & 2","State":"LA","Gas":822,"coordinates":[-90.4768,29.9989]},{"Plant":"Comanche","State":"OK","Gas":273,"coordinates":[-98.3244,34.5431]},{"Plant":"DeCordova Steam Electric Station","State":"TX","Gas":1104,"coordinates":[-97.7006,32.4031]},{"Plant":"Santan","State":"AZ","Gas":368,"coordinates":[-111.7503,33.3325]},{"Plant":"Beaver","State":"OR","Gas":494.8,"coordinates":[-123.1739,46.1724]},{"Plant":"Grand Tower","State":"IL","Gas":516,"coordinates":[-89.5112,37.6577]},{"Plant":"Calumet","State":"IL","Gas":203.9,"coordinates":[-87.5428,41.7136]},{"Plant":"Crawford","State":"IL","Gas":172.8,"coordinates":[-87.7229,41.8285]},{"Plant":"Electric Junction","State":"IL","Gas":207.5,"coordinates":[-88.0833,41.8333]},{"Plant":"Joliet 9","State":"IL","Gas":115.1,"coordinates":[-88.1153,41.4931]},{"Plant":"Astoria Generating Station","State":"NY","Gas":191,"coordinates":[-73.9126,40.7877]},{"Plant":"Wood River","State":"IL","Gas":129.9,"coordinates":[-90.1347,38.8639]},{"Plant":"Beluga","State":"AK","Gas":344.4,"coordinates":[-151.0356,61.1861]},{"Plant":"Marion","State":"IL","Gas":140,"coordinates":[-88.9531,37.6197]},{"Plant":"Frederickson","State":"WA","Gas":158,"coordinates":[-122.365,47.0797]},{"Plant":"Harding Street","State":"IN","Gas":322,"coordinates":[-86.1969,39.7113]},{"Plant":"Dean H Mitchell","State":"IN","Gas":142,"coordinates":[-87.4069,41.6392]},{"Plant":"Michigan City","State":"IN","Gas":120,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Gas":995,"coordinates":[-87.7811,32.6017]},{"Plant":"NRG Energy Center Dover","State":"DE","Gas":104.4,"coordinates":[-75.5473,39.1495]},{"Plant":"Gilroy Power Plant","State":"CA","Gas":130,"coordinates":[-121.5367,37.0001]},{"Plant":"Noblesville","State":"IN","Gas":285.9,"coordinates":[-85.9714,40.0969]},{"Plant":"Pedricktown Cogeneration Company LP","State":"NJ","Gas":115.7,"coordinates":[-75.4238,39.7668]},{"Plant":"Broadway","State":"IN","Gas":115,"coordinates":[-87.6049,37.9691]},{"Plant":"Butler-Warner Generation Plant","State":"NC","Gas":225,"coordinates":[-78.8294,35.0986]},{"Plant":"El Segundo Cogen","State":"CA","Gas":127.7,"coordinates":[-118.4031,33.9058]},{"Plant":"ArcelorMittal Burns Harbor","State":"IN","Gas":177.7,"coordinates":[-87.1387,41.635]},{"Plant":"King City Power Plant","State":"CA","Gas":111,"coordinates":[-121.1278,36.225]},{"Plant":"Bayou Cogen Plant","State":"TX","Gas":260,"coordinates":[-95.0458,29.6225]},{"Plant":"Bellingham Cogeneration Facility","State":"MA","Gas":305,"coordinates":[-71.4833,42.0925]},{"Plant":"Sayreville Cogeneration Facility","State":"NJ","Gas":271,"coordinates":[-74.3444,40.439]},{"Plant":"Foster Wheeler Martinez","State":"CA","Gas":103.5,"coordinates":[-122.0589,38.0244]},{"Plant":"ExxonMobil Baytown Refinery","State":"TX","Gas":183.89,"coordinates":[-94.9973,29.7535]},{"Plant":"RG Steel Sparrows Point, LLC","State":"MD","Gas":152.3,"coordinates":[-76.4729,39.213]},{"Plant":"Kern River Cogeneration","State":"CA","Gas":297.6,"coordinates":[-118.9849,35.4515]},{"Plant":"Formosa Utility Venture Ltd","State":"TX","Gas":597.3,"coordinates":[-96.5417,28.6917]},{"Plant":"Hopewell Cogeneration","State":"VA","Gas":348.3,"coordinates":[-77.2811,37.2917]},{"Plant":"CES Placerita Power Plant","State":"CA","Gas":115,"coordinates":[-118.4999,34.3801]},{"Plant":"ExxonMobil Baytown Turbine","State":"TX","Gas":320.38,"coordinates":[-95.0096,29.7591]},{"Plant":"Selkirk Cogen","State":"NY","Gas":359.01,"coordinates":[-73.8592,42.5744]},{"Plant":"Masspower","State":"MA","Gas":231.5,"coordinates":[-72.5225,42.1575]},{"Plant":"Clear Lake Cogeneration Ltd","State":"TX","Gas":366,"coordinates":[-95.067,29.6255]},{"Plant":"Midland Cogeneration Venture","State":"MI","Gas":1815.4,"coordinates":[-84.2242,43.5861]},{"Plant":"Camden Plant Holding LLC","State":"NJ","Gas":148.5,"coordinates":[-75.1192,39.9175]},{"Plant":"River Hills","State":"IA","Gas":120,"coordinates":[-93.6195,41.5902]},{"Plant":"Hazelton","State":"PA","Gas":147.2,"coordinates":[-76.0409,40.9282]},{"Plant":"Ocotillo","State":"AZ","Gas":320,"coordinates":[-111.9122,33.4225]},{"Plant":"West Phoenix","State":"AZ","Gas":1085.3,"coordinates":[-112.1583,33.4417]},{"Plant":"Saguaro","State":"AZ","Gas":356,"coordinates":[-111.3,32.5517]},{"Plant":"Yucca","State":"AZ","Gas":163,"coordinates":[-114.7106,32.7214]},{"Plant":"Fort Dodge","State":"KS","Gas":142.3,"coordinates":[-99.9497,37.7328]},{"Plant":"Gordon Evans Energy Center","State":"KS","Gas":831,"coordinates":[-97.5217,37.7903]},{"Plant":"Murray Gill","State":"KS","Gas":317,"coordinates":[-97.4136,37.5967]},{"Plant":"Hutchinson Energy Center","State":"KS","Gas":399,"coordinates":[-97.8747,38.0906]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Gas":316,"coordinates":[-110.9047,32.16]},{"Plant":"Kaw","State":"KS","Gas":140.3,"coordinates":[-94.6514,39.0867]},{"Plant":"McPherson 2","State":"KS","Gas":131.5,"coordinates":[-97.6834,38.3634]},{"Plant":"Garden City","State":"KS","Gas":234.7,"coordinates":[-100.8956,37.9703]},{"Plant":"E W Brown","State":"KY","Gas":849,"coordinates":[-84.7126,37.7883]},{"Plant":"Paddys Run","State":"KY","Gas":193,"coordinates":[-85.8417,38.2236]},{"Plant":"Louisiana 1","State":"LA","Gas":382.4,"coordinates":[-91.1864,30.4922]},{"Plant":"Louisiana 2","State":"LA","Gas":140,"coordinates":[-91.1864,30.4922]},{"Plant":"R S Nelson","State":"LA","Gas":653,"coordinates":[-93.2911,30.2844]},{"Plant":"Willow Glen","State":"LA","Gas":1832,"coordinates":[-91.1164,30.2743]},{"Plant":"Coughlin Power Station","State":"LA","Gas":747,"coordinates":[-92.2611,30.8439]},{"Plant":"Teche","State":"LA","Gas":430,"coordinates":[-91.5425,29.8222]},{"Plant":"Little Gypsy","State":"LA","Gas":1198,"coordinates":[-90.4617,30.0051]},{"Plant":"Nine Mile Point","State":"LA","Gas":1705,"coordinates":[-90.1458,29.9472]},{"Plant":"Sterlington","State":"LA","Gas":412,"coordinates":[-92.0792,32.7047]},{"Plant":"A B Paterson","State":"LA","Gas":122,"coordinates":[-90.0256,30.0158]},{"Plant":"Michoud","State":"LA","Gas":854,"coordinates":[-89.9372,30.0081]},{"Plant":"Agua Fria","State":"AZ","Gas":626,"coordinates":[-112.2153,33.5561]},{"Plant":"Arsenal Hill","State":"LA","Gas":110,"coordinates":[-93.7611,32.5181]},{"Plant":"Lieberman","State":"LA","Gas":271,"coordinates":[-93.9597,32.7047]},{"Plant":"Louis Doc Bonin","State":"LA","Gas":302,"coordinates":[-92.0463,30.238]},{"Plant":"Monroe","State":"LA","Gas":127,"coordinates":[-92.1794,32.5233]},{"Plant":"Big Cajun 1","State":"LA","Gas":430,"coordinates":[-91.3556,30.6739]},{"Plant":"Kyrene","State":"AZ","Gas":522,"coordinates":[-111.9353,33.3556]},{"Plant":"Notch Cliff","State":"MD","Gas":128,"coordinates":[-76.5087,39.4217]},{"Plant":"Westport","State":"MD","Gas":121,"coordinates":[-76.6295,39.266]},{"Plant":"Dickerson","State":"MD","Gas":294,"coordinates":[-77.4644,39.2097]},{"Plant":"Mystic Generating Station","State":"MA","Gas":1936.32,"coordinates":[-71.0675,42.3908]},{"Plant":"New Boston Generating Station","State":"MA","Gas":702,"coordinates":[-71.0353,42.3392]},{"Plant":"Kendall Square Station","State":"MA","Gas":207.69,"coordinates":[-71.0792,42.3633]},{"Plant":"Apache Station","State":"AZ","Gas":200.7,"coordinates":[-109.8931,32.0603]},{"Plant":"Cecil Lynch","State":"AR","Gas":178,"coordinates":[-92.1987,34.7535]},{"Plant":"Hamilton Moses","State":"AR","Gas":138,"coordinates":[-90.8722,34.9806]},{"Plant":"Harvey Couch","State":"AR","Gas":148,"coordinates":[-93.4649,33.3592]},{"Plant":"B C Cobb","State":"MI","Gas":183,"coordinates":[-86.2423,43.2588]},{"Plant":"Lake Catherine","State":"AR","Gas":735,"coordinates":[-92.9049,34.4341]},{"Plant":"Dan E Karn","State":"MI","Gas":1276,"coordinates":[-83.8401,43.645]},{"Plant":"Thetford","State":"MI","Gas":192,"coordinates":[-83.6286,43.1567]},{"Plant":"Conners Creek","State":"MI","Gas":215,"coordinates":[-82.9597,42.3592]},{"Plant":"Delray","State":"MI","Gas":127,"coordinates":[-83.1019,42.2947]},{"Plant":"Robert E Ritchie","State":"AR","Gas":883,"coordinates":[-90.5987,34.4629]},{"Plant":"Hancock","State":"MI","Gas":141,"coordinates":[-83.4425,42.5497]},{"Plant":"River Rouge","State":"MI","Gas":234,"coordinates":[-83.1119,42.2739]},{"Plant":"Mistersky","State":"MI","Gas":154,"coordinates":[-83.0903,42.3039]},{"Plant":"Fox Lake","State":"MN","Gas":109.18,"coordinates":[-94.7075,43.6728]},{"Plant":"Black Dog","State":"MN","Gas":281.31,"coordinates":[-93.2501,44.8108]},{"Plant":"Inver Hills","State":"MN","Gas":358.3,"coordinates":[-93.042,44.781]},{"Plant":"Thomas Fitzhugh","State":"AR","Gas":171,"coordinates":[-93.8049,35.4624]},{"Plant":"Carl Bailey","State":"AR","Gas":122,"coordinates":[-91.3634,35.2601]},{"Plant":"McClellan","State":"AR","Gas":134,"coordinates":[-92.7917,33.5648]},{"Plant":"Chevron Oil","State":"MS","Gas":127,"coordinates":[-88.4919,30.34]},{"Plant":"Sweatt","State":"MS","Gas":126,"coordinates":[-88.7461,32.2925]},{"Plant":"Jack Watson","State":"MS","Gas":299,"coordinates":[-89.0286,30.4392]},{"Plant":"Baxter Wilson","State":"MS","Gas":1190,"coordinates":[-90.9306,32.2831]},{"Plant":"Delta","State":"MS","Gas":192,"coordinates":[-90.7139,33.7947]},{"Plant":"Rex Brown","State":"MS","Gas":295,"coordinates":[-90.213,32.357]},{"Plant":"Moselle","State":"MS","Gas":252,"coordinates":[-89.3004,31.528]},{"Plant":"Hawthorn","State":"MO","Gas":423,"coordinates":[-94.4778,39.1306]},{"Plant":"Lake Road","State":"MO","Gas":117,"coordinates":[-94.8773,39.7246]},{"Plant":"James River Power Station","State":"MO","Gas":155,"coordinates":[-93.2619,37.1086]},{"Plant":"Canaday","State":"NE","Gas":117.95,"coordinates":[-99.7011,40.6942]},{"Plant":"C W Burdick","State":"NE","Gas":173.5,"coordinates":[-98.3269,40.9228]},{"Plant":"Contra Costa","State":"CA","Gas":672,"coordinates":[-121.7642,38.0192]},{"Plant":"Clark","State":"NV","Gas":700,"coordinates":[-115.0507,36.0875]},{"Plant":"Sunrise","State":"NV","Gas":149,"coordinates":[-115.036,36.1384]},{"Plant":"Fort Churchill","State":"NV","Gas":226,"coordinates":[-119.1322,39.1281]},{"Plant":"Tracy","State":"NV","Gas":480,"coordinates":[-119.525,39.5625]},{"Plant":"Deepwater","State":"NJ","Gas":105,"coordinates":[-75.5083,39.6831]},{"Plant":"Sayreville","State":"NJ","Gas":225,"coordinates":[-74.3523,40.4765]},{"Plant":"Bergen Generating Station","State":"NJ","Gas":1242,"coordinates":[-74.0244,40.8375]},{"Plant":"PSEG Burlington Generating Station","State":"NJ","Gas":413,"coordinates":[-74.8792,40.0766]},{"Plant":"PSEG Edison Generating Station","State":"NJ","Gas":504,"coordinates":[-74.3956,40.4911]},{"Plant":"PSEG Essex Generating Station","State":"NJ","Gas":617,"coordinates":[-74.1206,40.7372]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Gas":383,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Kearny Generating Station","State":"NJ","Gas":647.6,"coordinates":[-74.0965,40.7373]},{"Plant":"PSEG Linden Generating Station","State":"NJ","Gas":345,"coordinates":[-74.2072,40.6217]},{"Plant":"PSEG Sewaren Generating Station","State":"NJ","Gas":453,"coordinates":[-74.2469,40.5558]},{"Plant":"Rio Grande","State":"NM","Gas":231,"coordinates":[-106.5472,31.8047]},{"Plant":"Maddox","State":"NM","Gas":193,"coordinates":[-103.3015,32.7142]},{"Plant":"Reeves","State":"NM","Gas":154,"coordinates":[-106.6019,35.171]},{"Plant":"Cunningham","State":"NM","Gas":487,"coordinates":[-103.3533,32.7131]},{"Plant":"Humboldt Bay","State":"CA","Gas":105,"coordinates":[-124.2103,40.7415]},{"Plant":"Hunters Point","State":"CA","Gas":377,"coordinates":[-122.3897,37.7336]},{"Plant":"Arthur Kill Generating Station","State":"NY","Gas":841,"coordinates":[-74.2,40.5916]},{"Plant":"Gowanus Gas Turbines Generating","State":"NY","Gas":273,"coordinates":[-74.0051,40.6635]},{"Plant":"Narrows Gas Turbines Generating","State":"NY","Gas":279,"coordinates":[-74.0208,40.6486]},{"Plant":"Ravenswood","State":"NY","Gas":2385.8,"coordinates":[-73.9461,40.7592]},{"Plant":"E F Barrett","State":"NY","Gas":708.7,"coordinates":[-73.6479,40.6167]},{"Plant":"Far Rockaway","State":"NY","Gas":110.6,"coordinates":[-73.761,40.6109]},{"Plant":"Glenwood","State":"NY","Gas":317.8,"coordinates":[-73.6475,40.8271]},{"Plant":"Northport","State":"NY","Gas":1548.7,"coordinates":[-73.3423,40.9236]},{"Plant":"Port Jefferson","State":"NY","Gas":465.1,"coordinates":[-73.0785,40.9497]},{"Plant":"Bethlehem Energy Center","State":"NY","Gas":365,"coordinates":[-73.7638,42.5942]},{"Plant":"Dynegy Morro Bay LLC","State":"CA","Gas":999,"coordinates":[-120.8566,35.3722]},{"Plant":"Dynegy Moss Landing Power Plant","State":"CA","Gas":2498,"coordinates":[-121.7822,36.8048]},{"Plant":"Bowline Point","State":"NY","Gas":1139,"coordinates":[-73.9689,41.2044]},{"Plant":"Asheville","State":"NC","Gas":330,"coordinates":[-82.5417,35.4731]},{"Plant":"Pittsburg Power","State":"CA","Gas":1906,"coordinates":[-121.8945,38.0392]},{"Plant":"Potrero Power","State":"CA","Gas":206,"coordinates":[-122.387,37.7566]},{"Plant":"Riverbend","State":"NC","Gas":120,"coordinates":[-80.9742,35.36]},{"Plant":"Dicks Creek","State":"OH","Gas":106.2,"coordinates":[-84.3778,39.465]},{"Plant":"Frank M Tait","State":"OH","Gas":256,"coordinates":[-84.2111,39.7272]},{"Plant":"Yankee Street","State":"OH","Gas":107,"coordinates":[-84.2047,39.603]},{"Plant":"FirstEnergy West Lorain","State":"OH","Gas":370,"coordinates":[-82.2644,41.4294]},{"Plant":"Richland","State":"OH","Gas":358,"coordinates":[-84.3346,41.3052]},{"Plant":"Horseshoe Lake","State":"OK","Gas":865,"coordinates":[-97.1797,35.5087]},{"Plant":"Muskogee","State":"OK","Gas":150,"coordinates":[-95.2873,35.7614]},{"Plant":"Mustang","State":"OK","Gas":510,"coordinates":[-97.675,35.4699]},{"Plant":"Seminole","State":"OK","Gas":1541,"coordinates":[-96.7258,34.9665]},{"Plant":"Northeastern","State":"OK","Gas":600,"coordinates":[-95.7008,36.4317]},{"Plant":"Southwestern","State":"OK","Gas":472,"coordinates":[-98.3524,35.1009]},{"Plant":"Tulsa","State":"OK","Gas":400,"coordinates":[-95.991,36.1165]},{"Plant":"Weleetka","State":"OK","Gas":162,"coordinates":[-96.1352,35.3233]},{"Plant":"Barry","State":"AL","Gas":862,"coordinates":[-88.0103,31.0069]},{"Plant":"Anadarko Plant","State":"OK","Gas":356,"coordinates":[-98.23,35.0847]},{"Plant":"Mooreland","State":"OK","Gas":337,"coordinates":[-99.2254,36.4372]},{"Plant":"Encina","State":"CA","Gas":958,"coordinates":[-117.3364,33.1361]},{"Plant":"Kearny","State":"CA","Gas":127,"coordinates":[-117.1338,32.834]},{"Plant":"Brunot Island","State":"PA","Gas":278,"coordinates":[-80.0438,40.4649]},{"Plant":"Dynegy South Bay Power Plant","State":"CA","Gas":693,"coordinates":[-117.092,32.6114]},{"Plant":"AES Alamitos LLC","State":"CA","Gas":2130,"coordinates":[-118.1009,33.7688]},{"Plant":"Manchester Street","State":"RI","Gas":425.91,"coordinates":[-71.4042,41.8167]},{"Plant":"Darlington County","State":"SC","Gas":448,"coordinates":[-80.1657,34.4185]},{"Plant":"Buzzard Roost","State":"SC","Gas":196,"coordinates":[-81.9025,34.1692]},{"Plant":"Coolwater","State":"CA","Gas":608,"coordinates":[-116.8539,34.8606]},{"Plant":"Urquhart","State":"SC","Gas":387,"coordinates":[-81.9111,33.435]},{"Plant":"El Segundo Power","State":"CA","Gas":940.54,"coordinates":[-118.4242,33.9098]},{"Plant":"Etiwanda Generating Station","State":"CA","Gas":1019,"coordinates":[-117.5266,34.0912]},{"Plant":"Riverside Canal Power","State":"CA","Gas":127,"coordinates":[-117.3312,34.0229]},{"Plant":"AES Huntington Beach LLC","State":"CA","Gas":1036.6,"coordinates":[-117.9792,33.6439]},{"Plant":"Allen Steam Plant","State":"TN","Gas":461.6,"coordinates":[-90.1487,35.0741]},{"Plant":"Gallatin","State":"TN","Gas":599.2,"coordinates":[-86.4006,36.3156]},{"Plant":"Johnsonville","State":"TN","Gas":1135.2,"coordinates":[-87.9861,36.0278]},{"Plant":"Long Beach Generation LLC","State":"CA","Gas":584,"coordinates":[-118.2248,33.7641]},{"Plant":"E S Joslin","State":"TX","Gas":254,"coordinates":[-96.5458,28.6472]},{"Plant":"J L Bates","State":"TX","Gas":182,"coordinates":[-98.3944,26.2222]},{"Plant":"Laredo","State":"TX","Gas":171,"coordinates":[-99.5089,27.5667]},{"Plant":"Lon C Hill","State":"TX","Gas":559,"coordinates":[-97.6167,27.85]},{"Plant":"Nueces Bay","State":"TX","Gas":559,"coordinates":[-97.4192,27.8194]},{"Plant":"La Palma","State":"TX","Gas":255,"coordinates":[-97.6389,26.1331]},{"Plant":"Victoria","State":"TX","Gas":491,"coordinates":[-97.01,28.7883]},{"Plant":"Mandalay","State":"CA","Gas":560,"coordinates":[-119.2511,34.2067]},{"Plant":"Lake Hubbard","State":"TX","Gas":921,"coordinates":[-96.5458,32.8358]},{"Plant":"Mountain Creek","State":"TX","Gas":890,"coordinates":[-96.9358,32.7231]},{"Plant":"North Lake","State":"TX","Gas":715,"coordinates":[-96.975,32.9506]},{"Plant":"Parkdale","State":"TX","Gas":327,"coordinates":[-96.7233,32.7767]},{"Plant":"Newman","State":"TX","Gas":498,"coordinates":[-106.4318,31.9836]},{"Plant":"Lewis Creek","State":"TX","Gas":456,"coordinates":[-95.5214,30.4356]},{"Plant":"Neches","State":"TX","Gas":265,"coordinates":[-94.0593,30.0612]},{"Plant":"Sabine","State":"TX","Gas":1809,"coordinates":[-93.878,30.0242]},{"Plant":"Cedar Bayou","State":"TX","Gas":2258,"coordinates":[-94.9256,29.75]},{"Plant":"Deepwater","State":"TX","Gas":174,"coordinates":[-95.2253,29.7199]},{"Plant":"Greens Bayou","State":"TX","Gas":760,"coordinates":[-95.2194,29.8222]},{"Plant":"P H Robinson","State":"TX","Gas":2211,"coordinates":[-94.9794,29.4867]},{"Plant":"Sam Bertron","State":"TX","Gas":844,"coordinates":[-95.0598,29.7268]},{"Plant":"T H Wharton","State":"TX","Gas":1254,"coordinates":[-95.5306,29.9417]},{"Plant":"W A Parish","State":"TX","Gas":1191,"coordinates":[-95.6311,29.4828]},{"Plant":"Webster","State":"TX","Gas":387,"coordinates":[-95.1081,29.5258]},{"Plant":"Knox Lee","State":"TX","Gas":486,"coordinates":[-94.6415,32.3766]},{"Plant":"Wilkes","State":"TX","Gas":882,"coordinates":[-94.548,32.8482]},{"Plant":"Jones","State":"TX","Gas":486,"coordinates":[-101.7392,33.5239]},{"Plant":"Nichols","State":"TX","Gas":457,"coordinates":[-101.7464,35.2834]},{"Plant":"Plant X","State":"TX","Gas":442,"coordinates":[-102.4114,34.1661]},{"Plant":"Eagle Mountain","State":"TX","Gas":665,"coordinates":[-97.4792,32.9056]},{"Plant":"Graham","State":"TX","Gas":630,"coordinates":[-98.6117,33.1344]},{"Plant":"Handley","State":"TX","Gas":1421,"coordinates":[-97.2192,32.7283]},{"Plant":"Morgan Creek","State":"TX","Gas":1354,"coordinates":[-100.9156,32.3358]},{"Plant":"Permian Basin","State":"TX","Gas":1055,"coordinates":[-102.9633,31.5839]},{"Plant":"Ormond Beach","State":"CA","Gas":1516,"coordinates":[-119.1689,34.1292]},{"Plant":"Collin","State":"TX","Gas":154,"coordinates":[-96.8034,33.1576]},{"Plant":"Lake Creek","State":"TX","Gas":317,"coordinates":[-96.985,31.4647]},{"Plant":"River Crest","State":"TX","Gas":110,"coordinates":[-95.1467,33.3931]},{"Plant":"Stryker Creek","State":"TX","Gas":675,"coordinates":[-94.9898,31.9398]},{"Plant":"Tradinghouse","State":"TX","Gas":1383,"coordinates":[-96.9642,31.5728]},{"Plant":"Trinidad","State":"TX","Gas":240,"coordinates":[-96.1013,32.1245]},{"Plant":"Valley","State":"TX","Gas":1115,"coordinates":[-96.3676,33.6281]},{"Plant":"Paint Creek","State":"TX","Gas":231,"coordinates":[-99.7337,33.1576]},{"Plant":"Rio Pecos","State":"TX","Gas":141,"coordinates":[-102.3753,31.0706]},{"Plant":"San Angelo","State":"TX","Gas":123,"coordinates":[-100.491,31.3906]},{"Plant":"Decker Creek","State":"TX","Gas":932,"coordinates":[-97.6128,30.3033]},{"Plant":"Holly Street","State":"TX","Gas":591,"coordinates":[-97.7167,30.25]},{"Plant":"Silas Ray","State":"TX","Gas":125,"coordinates":[-97.5214,25.9131]},{"Plant":"AES Redondo Beach LLC","State":"CA","Gas":1310,"coordinates":[-118.395,33.8504]},{"Plant":"Bryan","State":"TX","Gas":130,"coordinates":[-96.3723,30.6474]},{"Plant":"Ray Olinger","State":"TX","Gas":405.3,"coordinates":[-96.4525,33.0681]},{"Plant":"Mountainview Generating Station","State":"CA","Gas":120,"coordinates":[-117.2418,34.0818]},{"Plant":"Sim Gideon","State":"TX","Gas":620,"coordinates":[-97.2708,30.1456]},{"Plant":"Ty Cooke","State":"TX","Gas":148.6,"coordinates":[-101.7906,33.5211]},{"Plant":"J Robert Massengale","State":"TX","Gas":107,"coordinates":[-101.8408,33.6039]},{"Plant":"Leon Creek","State":"TX","Gas":355.2,"coordinates":[-98.5761,29.3525]},{"Plant":"O W Sommers","State":"TX","Gas":850,"coordinates":[-98.3242,29.3081]},{"Plant":"V H Braunig","State":"TX","Gas":862,"coordinates":[-98.3825,29.2567]},{"Plant":"W B Tuttle","State":"TX","Gas":425,"coordinates":[-98.4181,29.53]},{"Plant":"R W Miller","State":"TX","Gas":574,"coordinates":[-98.3103,32.6581]},{"Plant":"Sam Rayburn","State":"TX","Gas":227,"coordinates":[-97.135,28.8947]},{"Plant":"Gadsby","State":"UT","Gas":349,"coordinates":[-111.9289,40.7686]},{"Plant":"Grayson","State":"CA","Gas":291.9,"coordinates":[-118.2782,34.1556]},{"Plant":"Chesterfield","State":"VA","Gas":397,"coordinates":[-77.3833,37.3822]},{"Plant":"Possum Point","State":"VA","Gas":867,"coordinates":[-77.2806,38.5367]},{"Plant":"Transalta Centralia Generation","State":"WA","Gas":256,"coordinates":[-122.8598,46.7559]},{"Plant":"El Centro","State":"CA","Gas":225.9,"coordinates":[-115.54,32.8022]},{"Plant":"Harbor","State":"CA","Gas":500,"coordinates":[-118.2656,33.7706]},{"Plant":"Haynes","State":"CA","Gas":1570,"coordinates":[-118.0991,33.7647]},{"Plant":"Wheaton","State":"WI","Gas":231.22,"coordinates":[-91.5158,44.8854]},{"Plant":"Scattergood","State":"CA","Gas":803,"coordinates":[-118.4276,33.9182]},{"Plant":"Rock River","State":"WI","Gas":305.52,"coordinates":[-89.0276,42.582]},{"Plant":"West Marinette","State":"WI","Gas":161.6,"coordinates":[-87.6881,45.0869]},{"Plant":"Valley","State":"CA","Gas":1068,"coordinates":[-118.3913,34.245]},{"Plant":"Broadway","State":"CA","Gas":161,"coordinates":[-118.148,34.1254]},{"Plant":"Glenarm","State":"CA","Gas":155,"coordinates":[-118.1494,34.126]},{"Plant":"Spencer","State":"TX","Gas":171,"coordinates":[-97.1061,33.1975]},{"Plant":"Colbert","State":"AL","Gas":390.4,"coordinates":[-87.8486,34.7439]},{"Plant":"Zuni","State":"CO","Gas":107,"coordinates":[-105.017,39.7373]},{"Plant":"Thomas C Ferguson","State":"TX","Gas":420,"coordinates":[-98.3705,30.558]},{"Plant":"Fort Phantom","State":"TX","Gas":362,"coordinates":[-99.6778,32.5784]},{"Plant":"Barney M Davis","State":"TX","Gas":682,"coordinates":[-97.3117,27.6064]},{"Plant":"Riverside","State":"OK","Gas":917,"coordinates":[-95.9567,35.9978]},{"Plant":"Pittsfield Generating LP","State":"MA","Gas":141,"coordinates":[-73.2181,42.4564]},{"Plant":"Linden Cogen Plant","State":"NJ","Gas":899.8,"coordinates":[-74.2156,40.6322]},{"Plant":"Houston Chemical Complex Battleground","State":"TX","Gas":198,"coordinates":[-95.0839,29.7314]},{"Plant":"Paris Energy Center","State":"TX","Gas":238,"coordinates":[-95.5577,33.6968]},{"Plant":"Hal C Weaver Power Plant","State":"TX","Gas":107.73,"coordinates":[-97.7356,30.2867]},{"Plant":"Sycamore Cogeneration","State":"CA","Gas":304.52,"coordinates":[-118.9853,35.4526]},{"Plant":"Union Carbide Seadrift Cogen","State":"TX","Gas":168,"coordinates":[-96.7706,28.5105]},{"Plant":"Dow St Charles Operations","State":"LA","Gas":291.6,"coordinates":[-90.4414,29.9861]},{"Plant":"Watson Cogeneration","State":"CA","Gas":398,"coordinates":[-118.2448,33.8166]},{"Plant":"Bucksport Generation LLC","State":"ME","Gas":269,"coordinates":[-68.8046,44.5738]},{"Plant":"Bethpage Power Plant","State":"NY","Gas":102,"coordinates":[-73.4994,40.7469]},{"Plant":"Shell Deer Park","State":"TX","Gas":140,"coordinates":[-95.1289,29.7232]},{"Plant":"Newark Bay Cogeneration Partnership LP","State":"NJ","Gas":118,"coordinates":[-74.13,40.7197]},{"Plant":"Indeck Corinth Energy Center","State":"NY","Gas":131.5,"coordinates":[-73.8125,43.25]},{"Plant":"PPG Riverside","State":"LA","Gas":154,"coordinates":[-93.2807,30.2217]},{"Plant":"PPG Powerhouse C","State":"LA","Gas":303.2,"coordinates":[-93.2831,30.2242]},{"Plant":"Bayonne Plant Holding LLC","State":"NJ","Gas":170,"coordinates":[-74.1124,40.6553]},{"Plant":"Harbor Cogen","State":"CA","Gas":101.7,"coordinates":[-118.2303,33.7771]},{"Plant":"Rosemary Power Station","State":"NC","Gas":165,"coordinates":[-77.6594,36.4517]},{"Plant":"Oklahoma Cogeneration Project","State":"OK","Gas":111.4,"coordinates":[-97.625,35.4397]},{"Plant":"Eagle Point Power Generation","State":"NJ","Gas":203,"coordinates":[-75.1592,39.8746]},{"Plant":"TXU Sweetwater Generating Plant","State":"TX","Gas":289,"coordinates":[-100.365,32.4928]},{"Plant":"ExxonMobil Beaumont Refinery","State":"TX","Gas":349.6,"coordinates":[-94.0753,30.0636]},{"Plant":"JM Shafer Generating Station","State":"CO","Gas":263.1,"coordinates":[-104.7736,40.0986]},{"Plant":"Gary Works","State":"IN","Gas":221,"coordinates":[-87.3289,41.6224]},{"Plant":"Parlin Power Plant","State":"NJ","Gas":118,"coordinates":[-74.3272,40.4607]},{"Plant":"Optim Energy Altura Cogen LLC","State":"TX","Gas":448,"coordinates":[-95.1077,29.8161]},{"Plant":"Gramercy Holdings LLC","State":"LA","Gas":106,"coordinates":[-90.6693,30.054]},{"Plant":"Hardee Power Station","State":"FL","Gas":358,"coordinates":[-81.9636,27.6364]},{"Plant":"Bellmeade Power Station","State":"VA","Gas":230,"coordinates":[-77.4317,37.4964]},{"Plant":"Pryor Power Plant","State":"OK","Gas":111.5,"coordinates":[-95.3175,36.2977]},{"Plant":"Ocean State Power","State":"RI","Gas":218.62,"coordinates":[-71.6689,42.0097]},{"Plant":"LaO Energy Systems","State":"LA","Gas":676.4,"coordinates":[-91.2325,30.3186]},{"Plant":"Doswell Energy Center","State":"VA","Gas":819.8,"coordinates":[-77.1448,37.8182]},{"Plant":"Elizabeth River Power Station","State":"VA","Gas":312,"coordinates":[-76.3083,36.775]},{"Plant":"Texas City Power Plant","State":"TX","Gas":451,"coordinates":[-94.9438,29.3787]},{"Plant":"Dow Chemical Texas Operation","State":"TX","Gas":1158,"coordinates":[-95.4075,28.9913]},{"Plant":"Power Station 4","State":"TX","Gas":172,"coordinates":[-94.9219,29.3782]},{"Plant":"Midway Sunset Cogen","State":"CA","Gas":219,"coordinates":[-119.6294,35.2269]},{"Plant":"C R Wing Cogen Plant","State":"TX","Gas":227,"coordinates":[-101.4224,32.2732]},{"Plant":"Delaware City Plant","State":"DE","Gas":387.12,"coordinates":[-75.6343,39.5871]},{"Plant":"McWilliams","State":"AL","Gas":650,"coordinates":[-86.4764,31.4003]},{"Plant":"J K Smith","State":"KY","Gas":433,"coordinates":[-84.1017,37.8833]},{"Plant":"Lockport Energy Associates LP","State":"NY","Gas":210.2,"coordinates":[-78.745,43.1619]},{"Plant":"Kennedy International Airport Cogen","State":"NY","Gas":129.8,"coordinates":[-73.7778,40.6417]},{"Plant":"March Point Cogeneration","State":"WA","Gas":146.2,"coordinates":[-122.56,48.4708]},{"Plant":"Saguaro Power","State":"NV","Gas":101,"coordinates":[-115.0117,36.0417]},{"Plant":"Ocean State Power II","State":"RI","Gas":218.62,"coordinates":[-71.6701,42.0099]},{"Plant":"Orange Cogeneration Facility","State":"FL","Gas":117.48,"coordinates":[-81.8251,27.8708]},{"Plant":"Devon Station","State":"CT","Gas":122.8,"coordinates":[-73.109,41.2098]},{"Plant":"Lake Cogen Ltd","State":"FL","Gas":110,"coordinates":[-81.676,28.9158]},{"Plant":"Pasco Cogen Ltd","State":"FL","Gas":116.18,"coordinates":[-82.1889,28.3746]},{"Plant":"Mulberry Cogeneration Facility","State":"FL","Gas":113,"coordinates":[-81.8775,27.8489]},{"Plant":"Orlando Cogen LP","State":"FL","Gas":120,"coordinates":[-81.4123,28.4426]},{"Plant":"Sumas Power Plant","State":"WA","Gas":125.5,"coordinates":[-122.2733,48.9905]},{"Plant":"Formosa Plastics","State":"LA","Gas":115,"coordinates":[-91.1872,30.4992]},{"Plant":"Ferndale Generating Station","State":"WA","Gas":271,"coordinates":[-122.6867,48.8288]},{"Plant":"Hartwell Energy Facility","State":"GA","Gas":302.5,"coordinates":[-82.8199,34.3396]},{"Plant":"Sithe Independence Station","State":"NY","Gas":982.2,"coordinates":[-76.4511,43.495]},{"Plant":"Saranac Facility","State":"NY","Gas":240,"coordinates":[-73.4557,44.7132]},{"Plant":"NAEA Lakewood LLC","State":"NJ","Gas":205.1,"coordinates":[-74.1686,40.0613]},{"Plant":"Auburndale Power Partners","State":"FL","Gas":154.7,"coordinates":[-81.8058,28.0542]},{"Plant":"Oyster Creek Unit VIII","State":"TX","Gas":379,"coordinates":[-95.342,28.9802]},{"Plant":"Hermiston Generating Plant","State":"OR","Gas":464,"coordinates":[-119.37,45.8042]},{"Plant":"Grays Ferry Cogeneration","State":"PA","Gas":150,"coordinates":[-75.1881,39.9422]},{"Plant":"Milford Power LP","State":"MA","Gas":148,"coordinates":[-71.5115,42.1294]},{"Plant":"Milagro Cogeneration Plant","State":"NM","Gas":121.6,"coordinates":[-107.9417,36.7367]},{"Plant":"Johnson County","State":"TX","Gas":267,"coordinates":[-97.4078,32.3994]},{"Plant":"Brandywine Power Facility","State":"MD","Gas":230,"coordinates":[-76.8678,38.6681]},{"Plant":"Gordonsville Energy LP","State":"VA","Gas":224,"coordinates":[-78.2138,38.1179]},{"Plant":"Sun Peak Generating Station","State":"NV","Gas":222,"coordinates":[-115.0339,36.1375]},{"Plant":"Brooklyn Navy Yard Cogeneration","State":"NY","Gas":230,"coordinates":[-73.9764,40.6994]},{"Plant":"Michigan Power LP","State":"MI","Gas":128,"coordinates":[-86.425,43.9375]},{"Plant":"LSP-Cottage Grove LP","State":"MN","Gas":251,"coordinates":[-92.9119,44.7956]},{"Plant":"LSP-Whitewater LP","State":"WI","Gas":253,"coordinates":[-88.7299,42.8555]},{"Plant":"Sweeny Cogen Facility","State":"TX","Gas":480,"coordinates":[-95.745,29.0728]},{"Plant":"Dighton Power Plant","State":"MA","Gas":142,"coordinates":[-71.1239,41.8312]},{"Plant":"De Pere Energy Center","State":"WI","Gas":184.7,"coordinates":[-88.072,44.4486]},{"Plant":"Androscoggin Energy Center","State":"ME","Gas":129.98,"coordinates":[-70.2423,44.5063]},{"Plant":"Delta Person LLC","State":"NM","Gas":140,"coordinates":[-106.644,35.026]},{"Plant":"Mid-Georgia Cogeneration Facility","State":"GA","Gas":316,"coordinates":[-83.6039,32.4856]},{"Plant":"Berkshire Power","State":"MA","Gas":232.12,"coordinates":[-72.6478,42.0476]},{"Plant":"Bridgeport Energy Project","State":"CT","Gas":454,"coordinates":[-73.1844,41.1692]},{"Plant":"Pasadena Cogeneration","State":"TX","Gas":700,"coordinates":[-95.1765,29.7248]},{"Plant":"Tiverton Power Plant","State":"RI","Gas":249.99,"coordinates":[-71.1706,41.6422]},{"Plant":"Axiall Plaquemine","State":"LA","Gas":240,"coordinates":[-91.185,30.2586]},{"Plant":"Tenaska Georgia Generation Facility","State":"GA","Gas":933,"coordinates":[-84.9996,33.3516]},{"Plant":"Tenaska Frontier Generation Station","State":"TX","Gas":860,"coordinates":[-95.9178,30.5924]},{"Plant":"Batesville Generation Facility","State":"MS","Gas":858,"coordinates":[-89.9275,34.3356]},{"Plant":"Black Hawk Station","State":"TX","Gas":221.4,"coordinates":[-101.36,35.6957]},{"Plant":"Mustang Station","State":"TX","Gas":486,"coordinates":[-102.7417,32.9728]},{"Plant":"Maine Independence Station","State":"ME","Gas":490.01,"coordinates":[-68.7094,44.8242]},{"Plant":"Pine Bluff Energy Center","State":"AR","Gas":198,"coordinates":[-91.9025,34.2181]},{"Plant":"Desert Star Energy Center","State":"NV","Gas":450,"coordinates":[-114.9928,35.7867]},{"Plant":"Millennium Power","State":"MA","Gas":337.8,"coordinates":[-72.0151,42.1123]},{"Plant":"New Albany Energy Facility","State":"MS","Gas":360,"coordinates":[-88.9397,34.5408]},{"Plant":"Brownsville Peaking Power","State":"TN","Gas":450,"coordinates":[-89.198,35.5438]},{"Plant":"Caledonia Power Facility","State":"MS","Gas":444,"coordinates":[-88.3186,33.6482]},{"Plant":"Crockett Cogen Project","State":"CA","Gas":247.4,"coordinates":[-122.2161,38.0569]},{"Plant":"Gregory Power Facility","State":"TX","Gas":412,"coordinates":[-97.2584,27.8893]},{"Plant":"Zeeland Generating Station","State":"MI","Gas":743.4,"coordinates":[-85.9975,42.8206]},{"Plant":"Dearborn Industrial Generation","State":"MI","Gas":700,"coordinates":[-83.154,42.3026]},{"Plant":"Taft Cogeneration Facility","State":"LA","Gas":790,"coordinates":[-90.4599,29.9888]},{"Plant":"Midlothian Energy Facility","State":"TX","Gas":1320,"coordinates":[-97.0537,32.4302]},{"Plant":"Lamar Power Project","State":"TX","Gas":1004,"coordinates":[-95.59,33.6308]},{"Plant":"Frontera Energy Center","State":"TX","Gas":475,"coordinates":[-98.3992,26.208]},{"Plant":"NRG Sterlington Power","State":"LA","Gas":176,"coordinates":[-92.0811,32.6889]},{"Plant":"Rumford Power Associates","State":"ME","Gas":254,"coordinates":[-70.5219,44.5303]},{"Plant":"Livingston Generating Station","State":"MI","Gas":132,"coordinates":[-84.7308,45.0304]},{"Plant":"Klamath Cogeneration Plant","State":"OR","Gas":470,"coordinates":[-121.8106,42.1739]},{"Plant":"Sabine Cogen","State":"TX","Gas":101,"coordinates":[-93.7714,30.0444]},{"Plant":"Entergy Rhode Island State Energy LP","State":"RI","Gas":515,"coordinates":[-71.5186,41.8017]},{"Plant":"Rocky Road Power LLC","State":"IL","Gas":340,"coordinates":[-88.2397,42.0931]},{"Plant":"Madison","State":"OH","Gas":576,"coordinates":[-84.4647,39.4522]},{"Plant":"Vermillion Energy Facility","State":"IN","Gas":560,"coordinates":[-87.4464,39.9223]},{"Plant":"Sutter Energy Center","State":"CA","Gas":530,"coordinates":[-121.6959,39.0531]},{"Plant":"Rockingham County CT Station","State":"NC","Gas":775,"coordinates":[-79.8297,36.3297]},{"Plant":"RS Cogen","State":"LA","Gas":395.6,"coordinates":[-93.2992,30.221]},{"Plant":"SRW Cogen LP","State":"TX","Gas":420,"coordinates":[-93.7574,30.0545]},{"Plant":"Magic Valley Generating Station","State":"TX","Gas":682,"coordinates":[-98.19,26.3403]},{"Plant":"Griffith Energy LLC","State":"AZ","Gas":588,"coordinates":[-114.1333,35.054]},{"Plant":"Milford Power Project","State":"CT","Gas":464,"coordinates":[-73.0997,41.2244]},{"Plant":"Manchief Electric Generating Station","State":"CO","Gas":264,"coordinates":[-103.685,40.2171]},{"Plant":"Walton County Power LLC","State":"GA","Gas":459.3,"coordinates":[-83.6954,33.8148]},{"Plant":"Desert Basin","State":"AZ","Gas":575,"coordinates":[-111.7889,32.9042]},{"Plant":"Kendall County Generation Facility","State":"IL","Gas":1140,"coordinates":[-88.2581,41.4797]},{"Plant":"Tenaska Gateway Generating Station","State":"TX","Gas":860,"coordinates":[-94.6197,32.0178]},{"Plant":"Alliant Energy Neenah","State":"WI","Gas":308.8,"coordinates":[-88.5064,44.1936]},{"Plant":"Rio Nogales Power Project","State":"TX","Gas":705,"coordinates":[-97.9732,29.5931]},{"Plant":"Wolf Hollow I LP","State":"TX","Gas":695.5,"coordinates":[-97.7317,32.3342]},{"Plant":"Hawk Road Facility","State":"GA","Gas":465,"coordinates":[-84.9914,33.3585]},{"Plant":"Hays Energy Project","State":"TX","Gas":876.8,"coordinates":[-97.9894,29.7806]},{"Plant":"Green Country Energy LLC","State":"OK","Gas":795,"coordinates":[-95.9346,35.9833]},{"Plant":"Worthington Generation LLC","State":"IN","Gas":179.2,"coordinates":[-87.0128,39.0708]},{"Plant":"Lake Road Generating Plant","State":"CT","Gas":729,"coordinates":[-71.8958,41.872]},{"Plant":"La Paloma Generating LLC","State":"CA","Gas":861,"coordinates":[-119.5919,35.2956]},{"Plant":"Guadalupe Generating Station","State":"TX","Gas":1000,"coordinates":[-98.1419,29.6244]},{"Plant":"Lost Pines 1 Power Project","State":"TX","Gas":546,"coordinates":[-97.2714,30.1478]},{"Plant":"Bluegrass Generating Station","State":"KY","Gas":495,"coordinates":[-85.4133,38.3902]},{"Plant":"Calcasieu","State":"LA","Gas":310,"coordinates":[-93.345,30.1608]},{"Plant":"Broad River Energy Center","State":"SC","Gas":842.64,"coordinates":[-81.575,35.0786]},{"Plant":"Bastrop Energy Center","State":"TX","Gas":552,"coordinates":[-97.55,30.1458]},{"Plant":"Granite Ridge","State":"NH","Gas":797,"coordinates":[-71.4261,42.9042]},{"Plant":"Bosque County Peaking","State":"TX","Gas":548,"coordinates":[-97.3586,31.8594]},{"Plant":"Acadia Energy Center","State":"LA","Gas":1063,"coordinates":[-92.4131,30.4286]},{"Plant":"Eastman Cogeneration Facility","State":"TX","Gas":402.22,"coordinates":[-94.6903,32.4481]},{"Plant":"South Point Energy Center","State":"AZ","Gas":550,"coordinates":[-114.5317,34.8678]},{"Plant":"Dogwood Energy Facility","State":"MO","Gas":620,"coordinates":[-94.3006,38.7931]},{"Plant":"Rathdrum Power LLC","State":"ID","Gas":248,"coordinates":[-116.9203,47.7858]},{"Plant":"Sunrise Power LLC","State":"CA","Gas":545,"coordinates":[-119.585,35.2097]},{"Plant":"Channelview Cogeneration Plant","State":"TX","Gas":779,"coordinates":[-95.1217,29.837]},{"Plant":"Cordova Energy","State":"IL","Gas":680,"coordinates":[-90.2797,41.7122]},{"Plant":"Osceola","State":"FL","Gas":468,"coordinates":[-81.0978,28.1289]},{"Plant":"Ontelaunee Energy Center","State":"PA","Gas":516,"coordinates":[-75.9356,40.4219]},{"Plant":"Caledonia","State":"MS","Gas":783,"coordinates":[-88.2717,33.6464]},{"Plant":"Riverside Generating LLC","State":"KY","Gas":825,"coordinates":[-82.6046,38.1917]},{"Plant":"Elwood Energy LLC","State":"IL","Gas":1350,"coordinates":[-88.1236,41.4388]},{"Plant":"Arapahoe Combustion Turbine Project","State":"CO","Gas":122.5,"coordinates":[-105.0018,39.6692]},{"Plant":"Gibson City","State":"IL","Gas":232,"coordinates":[-88.3987,40.4705]},{"Plant":"Pinckneyville","State":"IL","Gas":320,"coordinates":[-89.3467,38.1114]},{"Plant":"Kinmundy","State":"IL","Gas":232,"coordinates":[-89.0128,38.7619]},{"Plant":"Corpus Christi Energy Center","State":"TX","Gas":482.1,"coordinates":[-97.4283,27.8139]},{"Plant":"Afton Generating Station","State":"NM","Gas":141,"coordinates":[-106.8465,32.1142]},{"Plant":"ANP Bellingham Energy Project","State":"MA","Gas":484,"coordinates":[-71.4535,42.1106]},{"Plant":"ANP Blackstone Energy Project","State":"MA","Gas":440.64,"coordinates":[-71.5158,42.0599]},{"Plant":"Odessa Ector Generating Station","State":"TX","Gas":1026.2,"coordinates":[-102.3264,31.8403]},{"Plant":"Morris Cogeneration LLC","State":"IL","Gas":176,"coordinates":[-88.3328,41.4119]},{"Plant":"Los Medanos Energy Center","State":"CA","Gas":567,"coordinates":[-121.873,38.0301]},{"Plant":"Hinds Energy Facility","State":"MS","Gas":450,"coordinates":[-90.2199,32.379]},{"Plant":"Southaven Energy Facility","State":"MS","Gas":624,"coordinates":[-90.0397,34.9808]},{"Plant":"Attala","State":"MS","Gas":459,"coordinates":[-89.6753,33.0147]},{"Plant":"Harry L. Oswald","State":"AR","Gas":568,"coordinates":[-92.2166,34.5923]},{"Plant":"Lincoln Generating Facility","State":"IL","Gas":600,"coordinates":[-87.9436,41.3933]},{"Plant":"Ennis Power Company LLC","State":"TX","Gas":359.5,"coordinates":[-96.675,32.32]},{"Plant":"Wheatland Generating Facility","State":"IN","Gas":472,"coordinates":[-87.2931,38.6716]},{"Plant":"Oneta Energy Center","State":"OK","Gas":1082.1,"coordinates":[-95.6967,36.0119]},{"Plant":"Freestone Energy Center","State":"TX","Gas":984,"coordinates":[-96.1131,31.8907]},{"Plant":"Greenville Electric Generating Station","State":"OH","Gas":180,"coordinates":[-84.6151,40.0758]},{"Plant":"Montpelier Electric Generating Station","State":"IN","Gas":180,"coordinates":[-85.3057,40.6206]},{"Plant":"Liberty Electric Power Plant","State":"PA","Gas":528,"coordinates":[-75.3358,39.8614]},{"Plant":"Marshall Energy Facility","State":"KY","Gas":600,"coordinates":[-88.3958,37.0286]},{"Plant":"Handsome Lake Energy LLC","State":"PA","Gas":250,"coordinates":[-79.8061,41.2908]},{"Plant":"Audrain Generating Station","State":"MO","Gas":640,"coordinates":[-91.5369,39.3092]},{"Plant":"Lee Energy Facility","State":"IL","Gas":568,"coordinates":[-89.4054,41.8287]},{"Plant":"Energy Shelby County","State":"IL","Gas":371.6,"coordinates":[-88.4772,39.2794]},{"Plant":"NRG Rockford I","State":"IL","Gas":305,"coordinates":[-89.1012,42.2386]},{"Plant":"Red Oak Power LLC","State":"NJ","Gas":765.99,"coordinates":[-74.3489,40.4487]},{"Plant":"Hog Bayou Energy Center","State":"AL","Gas":230,"coordinates":[-88.0575,30.7478]},{"Plant":"Santa Rosa Energy Center","State":"FL","Gas":235.9,"coordinates":[-87.115,30.5664]},{"Plant":"Astoria Gas Turbines","State":"NY","Gas":420,"coordinates":[-73.9048,40.787]},{"Plant":"Doyle Energy Facility","State":"GA","Gas":355,"coordinates":[-83.6996,33.8377]},{"Plant":"Darby Electric Generating Station","State":"OH","Gas":451.8,"coordinates":[-83.1778,39.7139]},{"Plant":"Tait Electric Generating Station","State":"OH","Gas":319.6,"coordinates":[-84.2095,39.7277]},{"Plant":"University Park South","State":"IL","Gas":300,"coordinates":[-87.7532,41.4409]},{"Plant":"Gleason Generating Facility","State":"TN","Gas":540,"coordinates":[-88.612,36.2454]},{"Plant":"Crete Energy Venture LLC","State":"IL","Gas":293.4,"coordinates":[-87.6187,41.4294]},{"Plant":"Whiting Clean Energy","State":"IN","Gas":547,"coordinates":[-87.4775,41.6739]},{"Plant":"Edward L. Addison Generating Plant","State":"GA","Gas":609,"coordinates":[-84.3064,32.9111]},{"Plant":"TVA Southaven Combined Cycle","State":"MS","Gas":783,"coordinates":[-90.0378,34.9939]},{"Plant":"Jackson Generating Station","State":"MI","Gas":564,"coordinates":[-84.3767,42.2488]},{"Plant":"Tenaska Lindsay Hill Generating Station","State":"AL","Gas":857.9,"coordinates":[-86.7386,32.6514]},{"Plant":"Ceredo Generating Station","State":"WV","Gas":684.7,"coordinates":[-82.5339,38.3681]},{"Plant":"Aurora","State":"IL","Gas":910,"coordinates":[-88.2265,41.8151]},{"Plant":"Southeast Chicago Energy Project","State":"IL","Gas":304,"coordinates":[-87.5449,41.7181]},{"Plant":"Arlington Valley Energy Facility","State":"AZ","Gas":580,"coordinates":[-112.8897,33.3417]},{"Plant":"Front Range Power Plant","State":"CO","Gas":461.5,"coordinates":[-104.7069,38.6281]},{"Plant":"Big Sandy Peaker Plant","State":"WV","Gas":300,"coordinates":[-82.5938,38.3441]},{"Plant":"Wolf Hills Energy","State":"VA","Gas":250,"coordinates":[-82.1044,36.6644]},{"Plant":"Oleander Power Project LP","State":"FL","Gas":149,"coordinates":[-80.7947,28.3661]},{"Plant":"Decatur Energy Center","State":"AL","Gas":624,"coordinates":[-87.0214,34.6292]},{"Plant":"Morgan Energy Center","State":"AL","Gas":749,"coordinates":[-87.0639,34.6397]},{"Plant":"Westbrook Energy Center Power Plant","State":"ME","Gas":506,"coordinates":[-70.375,43.6575]},{"Plant":"Blythe Energy Inc","State":"CA","Gas":514.04,"coordinates":[-114.6865,33.6157]},{"Plant":"Calumet Energy Team LLC","State":"IL","Gas":324,"coordinates":[-87.5563,41.6835]},{"Plant":"New Covert Generating Facility","State":"MI","Gas":1058.4,"coordinates":[-86.2937,42.3224]},{"Plant":"Fairless Energy Center","State":"PA","Gas":1150.7,"coordinates":[-74.7411,40.1475]},{"Plant":"Channel Energy Center LLC","State":"TX","Gas":585,"coordinates":[-95.2319,29.7189]},{"Plant":"Warren Peaking Power Facility","State":"MS","Gas":300,"coordinates":[-90.9284,32.2849]},{"Plant":"Baconton Power Plant","State":"GA","Gas":195.2,"coordinates":[-84.08,31.3869]},{"Plant":"Gila River Power Station","State":"AZ","Gas":2060,"coordinates":[-112.6944,32.975]},{"Plant":"Ingleside Cogeneration","State":"TX","Gas":460,"coordinates":[-97.2428,27.8828]},{"Plant":"Fore River Generating Station","State":"MA","Gas":668.37,"coordinates":[-70.9661,42.2422]},{"Plant":"Wise County Power LLC","State":"TX","Gas":655,"coordinates":[-97.9103,33.0583]},{"Plant":"Baytown Energy Center","State":"TX","Gas":785,"coordinates":[-94.9019,29.7731]},{"Plant":"Hermiston Power Partnership","State":"OR","Gas":615,"coordinates":[-119.3133,45.794]},{"Plant":"Washington County","State":"GA","Gas":597.66,"coordinates":[-82.98,33.0922]},{"Plant":"Delta Energy Center","State":"CA","Gas":811.3,"coordinates":[-121.8439,38.0169]},{"Plant":"Holland Energy Facility","State":"IL","Gas":449,"coordinates":[-88.7584,39.2231]},{"Plant":"PPL Ironwood LLC","State":"PA","Gas":669,"coordinates":[-76.3658,40.3509]},{"Plant":"Armstrong","State":"PA","Gas":584,"coordinates":[-79.3517,40.638]},{"Plant":"Troy Energy LLC","State":"OH","Gas":584,"coordinates":[-83.4598,41.4772]},{"Plant":"Pleasants Energy LLC","State":"WV","Gas":292.4,"coordinates":[-81.3642,39.3325]},{"Plant":"Brazos Valley Generating Facility","State":"TX","Gas":718,"coordinates":[-95.6244,29.4731]},{"Plant":"Cottonwood Energy Project","State":"TX","Gas":1233.6,"coordinates":[-93.7353,30.2588]},{"Plant":"Sugar Creek Power","State":"IN","Gas":520.7,"coordinates":[-87.5108,39.3931]},{"Plant":"Exelon LaPorte Generating Station","State":"TX","Gas":168,"coordinates":[-95.0718,29.7028]},{"Plant":"Harquahala Generating Project","State":"AZ","Gas":1041.6,"coordinates":[-113.1134,33.476]},{"Plant":"Enterprise Energy Facility","State":"MS","Gas":600,"coordinates":[-90.0394,34.9767]},{"Plant":"Union Power Partners LP","State":"AR","Gas":2020,"coordinates":[-92.5894,33.2961]},{"Plant":"Thomas A Smith Energy Facility","State":"GA","Gas":1244,"coordinates":[-84.9175,34.7094]},{"Plant":"Columbia Energy Center","State":"SC","Gas":489.3,"coordinates":[-81.0178,33.8697]},{"Plant":"RockGen Energy Center","State":"WI","Gas":466.32,"coordinates":[-89.0492,42.9767]},{"Plant":"Zion Energy Center","State":"IL","Gas":456,"coordinates":[-87.895,42.4776]},{"Plant":"Crossroads Energy Center","State":"MS","Gas":308,"coordinates":[-90.5621,34.183]},{"Plant":"Washington Energy Facility","State":"OH","Gas":600,"coordinates":[-81.6564,39.58]},{"Plant":"Elk Hills Power LLC","State":"CA","Gas":525,"coordinates":[-119.4707,35.2803]},{"Plant":"Rolling Hills Generating","State":"OH","Gas":825,"coordinates":[-82.3328,39.0839]},{"Plant":"Renaissance Power LLC","State":"MI","Gas":660,"coordinates":[-84.8429,43.1864]},{"Plant":"Carville Energy LLC","State":"LA","Gas":500,"coordinates":[-91.065,30.2294]},{"Plant":"Athens Generating Plant","State":"NY","Gas":1137.9,"coordinates":[-73.8492,42.2728]},{"Plant":"Effingham County Power Project","State":"GA","Gas":450,"coordinates":[-81.2844,32.2773]},{"Plant":"Calhoun Energy Center","State":"AL","Gas":620,"coordinates":[-85.9731,33.5883]},{"Plant":"Osprey Energy Center Power Plant","State":"FL","Gas":597.9,"coordinates":[-81.8083,28.0525]},{"Plant":"Shady Hills Generating Station","State":"FL","Gas":468,"coordinates":[-82.5586,28.3665]},{"Plant":"Vandolah Power Station","State":"FL","Gas":632,"coordinates":[-81.924,27.5236]},{"Plant":"Raccoon Creek Energy Center","State":"IL","Gas":300,"coordinates":[-88.5392,38.6996]},{"Plant":"Hot Spring Generating Facility","State":"AR","Gas":651.6,"coordinates":[-92.8683,34.2976]},{"Plant":"Plaquemine Cogeneration Plant","State":"LA","Gas":843.7,"coordinates":[-91.2347,30.3217]},{"Plant":"DeSoto County Plant","State":"FL","Gas":312.81,"coordinates":[-81.8092,27.2272]},{"Plant":"Bayou Cove Peaking Power","State":"LA","Gas":300,"coordinates":[-92.5997,30.2825]},{"Plant":"Elgin Energy Center","State":"IL","Gas":452,"coordinates":[-88.2446,42.0001]},{"Plant":"Tenaska Virginia Generating Station","State":"VA","Gas":813.5,"coordinates":[-78.3813,37.8667]},{"Plant":"Tenaska Central Alabama Generating Stn","State":"AL","Gas":864,"coordinates":[-86.74,32.6497]},{"Plant":"Columbia Energy Center","State":"MO","Gas":140,"coordinates":[-92.2629,39.0192]},{"Plant":"Magnolia Power Plant","State":"MS","Gas":863.1,"coordinates":[-89.2026,34.835]},{"Plant":"Fountain Valley Power Facility","State":"CO","Gas":234,"coordinates":[-104.6875,38.5569]},{"Plant":"Red Hawk","State":"AZ","Gas":1020,"coordinates":[-112.8406,33.3346]},{"Plant":"McClain Energy Facility","State":"OK","Gas":451,"coordinates":[-97.5898,35.2977]},{"Plant":"Redbud Power Plant","State":"OK","Gas":1143.6,"coordinates":[-97.2264,35.6856]},{"Plant":"Deer Park Energy Center","State":"TX","Gas":877.2,"coordinates":[-95.1345,29.7134]},{"Plant":"Ouachita","State":"LA","Gas":816,"coordinates":[-92.0683,32.7061]},{"Plant":"Green Power 2","State":"TX","Gas":584,"coordinates":[-94.9328,29.3781]},{"Plant":"Forney Energy Center","State":"TX","Gas":1640,"coordinates":[-96.4916,32.7563]},{"Plant":"Mesquite Generating Station","State":"AZ","Gas":1073.3,"coordinates":[-112.8642,33.345]},{"Plant":"Goldendale Generating Station","State":"WA","Gas":219.9,"coordinates":[-120.833,45.8114]},{"Plant":"Tri Center Naniwa Energy","State":"NV","Gas":300,"coordinates":[-119.5178,39.5572]},{"Plant":"Goose Creek Energy Center","State":"IL","Gas":432,"coordinates":[-88.5999,40.1069]},{"Plant":"Kiamichi Energy Facility","State":"OK","Gas":1178.4,"coordinates":[-95.9349,34.6831]},{"Plant":"Lawrenceburg Energy Facility","State":"IN","Gas":1094,"coordinates":[-84.8669,39.0911]},{"Plant":"AEP Waterford Facility","State":"OH","Gas":814,"coordinates":[-81.7178,39.5333]},{"Plant":"Limon Generating Station","State":"CO","Gas":134,"coordinates":[-103.7005,39.2038]},{"Plant":"Frank Knutson","State":"CO","Gas":134,"coordinates":[-104.682,39.9411]},{"Plant":"Apex Generating Station","State":"NV","Gas":494.4,"coordinates":[-114.9609,36.416]},{"Plant":"Fayette Energy Facility","State":"PA","Gas":600.5,"coordinates":[-79.9182,39.8592]},{"Plant":"Wallingford Energy","State":"CT","Gas":190,"coordinates":[-72.8354,41.4487]},{"Plant":"High Desert Power Plant","State":"CA","Gas":780,"coordinates":[-117.3647,34.5953]},{"Plant":"AES Greystone","State":"TN","Gas":468,"coordinates":[-89.3937,35.6532]},{"Plant":"Sundance","State":"AZ","Gas":383,"coordinates":[-111.5899,32.9285]},{"Plant":"Indigo Energy Facility","State":"CA","Gas":149.7,"coordinates":[-116.553,33.9109]},{"Plant":"Hidalgo Energy Center","State":"TX","Gas":470,"coordinates":[-98.1758,26.3417]},{"Plant":"Perryville Power Station","State":"LA","Gas":718,"coordinates":[-92.0183,32.6908]},{"Plant":"West Valley Generation Project","State":"UT","Gas":185,"coordinates":[-112.0317,40.6667]},{"Plant":"University Park North","State":"IL","Gas":459.6,"coordinates":[-87.7514,41.4425]},{"Plant":"Riverside Energy Center","State":"WI","Gas":598.3,"coordinates":[-89.0355,42.5827]},{"Plant":"Blue Spruce Energy Center","State":"CO","Gas":276,"coordinates":[-104.6814,39.7479]},{"Plant":"Plains End","State":"CO","Gas":113,"coordinates":[-105.226,39.8575]},{"Plant":"Spring Creek Energy Center","State":"OK","Gas":280,"coordinates":[-97.655,35.7422]},{"Plant":"EP Newington Energy LLC","State":"NH","Gas":525,"coordinates":[-70.8061,43.1047]},{"Plant":"Chehalis Generating Facility","State":"WA","Gas":495,"coordinates":[-122.9131,46.6225]},{"Plant":"Harrison County Power Project","State":"TX","Gas":484.5,"coordinates":[-94.4367,32.3958]},{"Plant":"Lower Mount Bethel Energy","State":"PA","Gas":593.8,"coordinates":[-75.1076,40.8019]},{"Plant":"AL Sandersville LLC","State":"GA","Gas":624,"coordinates":[-82.8608,33.1189]},{"Plant":"Higgins Generating Station","State":"NV","Gas":570,"coordinates":[-115.3561,35.6139]},{"Plant":"Bethlehem Power Plant","State":"PA","Gas":1092,"coordinates":[-75.3147,40.6175]},{"Plant":"Pierce Power Station","State":"WA","Gas":130.9,"coordinates":[-122.3758,47.1365]},{"Plant":"Choctaw County","State":"MS","Gas":726,"coordinates":[-89.4201,33.2881]},{"Plant":"Allegheny Energy Units 3 4 & 5","State":"PA","Gas":509,"coordinates":[-79.7686,40.5453]},{"Plant":"Dean","State":"MI","Gas":295.4,"coordinates":[-82.4953,42.7725]},{"Plant":"Hanging Rock Energy Facility","State":"OH","Gas":1288,"coordinates":[-82.7833,38.5731]},{"Plant":"Los Esteros Critical Energy Center","State":"CA","Gas":180,"coordinates":[-121.9319,37.425]},{"Plant":"FPL Energy Marcus Hook LP","State":"PA","Gas":713.5,"coordinates":[-75.4216,39.807]},{"Plant":"Gilroy Peaking Energy Center","State":"CA","Gas":128.3,"coordinates":[-121.5363,36.999]},{"Plant":"Frederickson Power LP","State":"WA","Gas":254.5,"coordinates":[-122.3657,47.0861]},{"Plant":"Curtis H Stanton Energy Center","State":"FL","Gas":591.93,"coordinates":[-81.1669,28.4882]},{"Plant":"Auburndale Peaker Energy Center","State":"FL","Gas":118,"coordinates":[-81.8059,28.0535]},{"Plant":"Rocky Mountain Energy Center","State":"CO","Gas":608,"coordinates":[-104.5953,40.0908]},{"Plant":"Silverhawk","State":"NV","Gas":560,"coordinates":[-114.9606,36.4078]},{"Plant":"Jasper","State":"SC","Gas":752.5,"coordinates":[-81.1242,32.3594]},{"Plant":"Tracy Combined Cycle Power Plant","State":"CA","Gas":168.01,"coordinates":[-121.4906,37.7107]},{"Plant":"NRG Rockford II Energy Center","State":"IL","Gas":159,"coordinates":[-89.1011,42.2383]},{"Plant":"NAEA Ocean Peaking Power LLC","State":"NJ","Gas":325.6,"coordinates":[-74.1672,40.0633]},{"Plant":"Las Vegas Cogeneration II LLC","State":"NV","Gas":220,"coordinates":[-115.1238,36.232]},{"Plant":"Wansley Combined Cycle","State":"GA","Gas":1065.56,"coordinates":[-85.037,33.4064]},{"Plant":"Cass County","State":"NE","Gas":320,"coordinates":[-95.964,40.9479]},{"Plant":"Hunterstown","State":"PA","Gas":810,"coordinates":[-77.1672,39.8725]},{"Plant":"Nebo Power Station","State":"UT","Gas":120.4,"coordinates":[-111.7294,40.0614]},{"Plant":"Olive","State":"CA","Gas":152.5,"coordinates":[-118.3147,34.1764]},{"Plant":"Collins","State":"IL","Gas":2671,"coordinates":[-88.3928,41.3461]},{"Plant":"Belle River","State":"MI","Gas":225,"coordinates":[-82.495,42.7756]},{"Plant":"Greenwood","State":"MI","Gas":225,"coordinates":[-82.6964,43.1056]},{"Plant":"Martin","State":"FL","Gas":2906,"coordinates":[-80.5628,27.0536]},{"Plant":"DeBary","State":"FL","Gas":258,"coordinates":[-81.3323,28.9039]},{"Plant":"Electrifarm","State":"IA","Gas":199.8,"coordinates":[-92.4205,42.4407]},{"Plant":"Fredonia","State":"WA","Gas":309.4,"coordinates":[-122.4358,48.4558]},{"Plant":"Trimble County","State":"KY","Gas":960,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Gas":1080,"coordinates":[-88.5553,30.5322]},{"Plant":"Greenwood","State":"MO","Gas":242,"coordinates":[-94.2982,38.8615]},{"Plant":"R M Schahfer","State":"IN","Gas":155,"coordinates":[-87.0261,41.2164]},{"Plant":"Cutler","State":"FL","Gas":206,"coordinates":[-80.2989,25.6321]},{"Plant":"Fort St Vrain","State":"CO","Gas":690.7,"coordinates":[-104.8742,40.2461]},{"Plant":"Fort Myers","State":"FL","Gas":1751,"coordinates":[-81.7831,26.6967]},{"Plant":"Whitehorn","State":"WA","Gas":169.2,"coordinates":[-122.6861,48.8288]},{"Plant":"McIntosh","State":"GA","Gas":657.6,"coordinates":[-81.1683,32.3563]},{"Plant":"Lauderdale","State":"FL","Gas":1699,"coordinates":[-80.1984,26.0686]},{"Plant":"A B Brown","State":"IN","Gas":160,"coordinates":[-87.715,37.9053]},{"Plant":"Port Everglades","State":"FL","Gas":420,"coordinates":[-80.1253,26.0856]},{"Plant":"Brame Energy Center","State":"LA","Gas":440,"coordinates":[-92.7167,31.395]},{"Plant":"John Twitty Energy Center","State":"MO","Gas":104,"coordinates":[-93.388,37.1517]},{"Plant":"Sanford","State":"FL","Gas":1880,"coordinates":[-81.3256,28.8419]},{"Plant":"Empire Energy Center","State":"MO","Gas":271,"coordinates":[-94.1041,37.1385]},{"Plant":"Dansby","State":"TX","Gas":151.7,"coordinates":[-96.4608,30.7217]},{"Plant":"Putnam","State":"FL","Gas":498,"coordinates":[-81.5851,29.6283]},{"Plant":"Higgins","State":"FL","Gas":122,"coordinates":[-82.6615,28.0033]},{"Plant":"Rokeby","State":"NE","Gas":246.1,"coordinates":[-96.7364,40.7316]},{"Plant":"Suwannee River","State":"FL","Gas":110,"coordinates":[-83.1806,30.3764]},{"Plant":"Lansing Smith","State":"FL","Gas":481,"coordinates":[-85.7003,30.2686]},{"Plant":"D G Hunter","State":"LA","Gas":157,"coordinates":[-92.4613,31.3207]},{"Plant":"George M Sullivan Generation Plant 2","State":"AK","Gas":219.9,"coordinates":[-149.7167,61.2297]},{"Plant":"Henry D King","State":"FL","Gas":129.4,"coordinates":[-80.3386,27.4486]},{"Plant":"Deerhaven Generating Station","State":"FL","Gas":194,"coordinates":[-82.3878,29.7592]},{"Plant":"John R Kelly","State":"FL","Gas":191,"coordinates":[-82.3208,29.6461]},{"Plant":"J D Kennedy","State":"FL","Gas":158.6,"coordinates":[-81.626,30.3648]},{"Plant":"Larsen Memorial","State":"FL","Gas":195,"coordinates":[-81.9228,28.0797]},{"Plant":"C D McIntosh Jr","State":"FL","Gas":532,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Gas":264,"coordinates":[-105.0212,40.8609]},{"Plant":"Indian River Plant","State":"FL","Gas":290,"coordinates":[-80.7801,28.4932]},{"Plant":"Arvah B Hopkins","State":"FL","Gas":340,"coordinates":[-84.4,30.4522]},{"Plant":"S O Purdom","State":"FL","Gas":301,"coordinates":[-84.2007,30.1623]},{"Plant":"Vero Beach Municipal Power Plant","State":"FL","Gas":150,"coordinates":[-80.3776,27.6334]},{"Plant":"Atkinson","State":"GA","Gas":182,"coordinates":[-84.4803,33.8175]},{"Plant":"Gravel Neck","State":"VA","Gas":292,"coordinates":[-76.6911,37.1575]},{"Plant":"McIntosh","State":"AL","Gas":338,"coordinates":[-88.0299,31.2546]},{"Plant":"Pleasant Hill","State":"IA","Gas":163,"coordinates":[-93.5242,41.5572]},{"Plant":"Hay Road","State":"DE","Gas":1085,"coordinates":[-75.5072,39.7436]},{"Plant":"Woodsdale","State":"OH","Gas":462,"coordinates":[-84.4611,39.4492]},{"Plant":"Concord","State":"WI","Gas":376,"coordinates":[-88.69,43.1669]},{"Plant":"South Fond Du Lac","State":"WI","Gas":312.37,"coordinates":[-88.4967,43.7353]},{"Plant":"Darbytown","State":"VA","Gas":288,"coordinates":[-77.3685,37.4982]},{"Plant":"Angus Anson","State":"SD","Gas":215.13,"coordinates":[-96.6356,43.6035]},{"Plant":"Cane Island","State":"FL","Gas":380,"coordinates":[-81.533,28.2764]},{"Plant":"Polk","State":"FL","Gas":325,"coordinates":[-81.9897,27.7286]},{"Plant":"Woodland","State":"CA","Gas":133,"coordinates":[-121.0204,37.6526]},{"Plant":"491 E 48th Street","State":"MI","Gas":148.2,"coordinates":[-86.0853,42.7553]},{"Plant":"Paris","State":"WI","Gas":400,"coordinates":[-88.0131,42.6658]},{"Plant":"Lincoln Combustion","State":"NC","Gas":1267.2,"coordinates":[-81.0347,35.4317]},{"Plant":"State Line Combined Cycle","State":"MO","Gas":589,"coordinates":[-94.614,37.0659]},{"Plant":"Hines Energy Complex","State":"FL","Gas":998,"coordinates":[-81.87,27.7882]},{"Plant":"Redding Power","State":"CA","Gas":133.6,"coordinates":[-122.4233,40.5073]},{"Plant":"San Jacinto Steam Electric Station","State":"TX","Gas":162,"coordinates":[-95.0406,29.6948]},{"Plant":"Kraft","State":"GA","Gas":132,"coordinates":[-81.1458,32.1486]},{"Plant":"Anderson","State":"IN","Gas":146.8,"coordinates":[-85.7389,40.0529]},{"Plant":"Riverside","State":"GA","Gas":107,"coordinates":[-81.0956,32.0836]},{"Plant":"Robins","State":"GA","Gas":160,"coordinates":[-83.5822,32.5792]},{"Plant":"Coyote Springs","State":"OR","Gas":220,"coordinates":[-119.6739,45.848]},{"Plant":"Midulla Generating Station","State":"FL","Gas":488,"coordinates":[-81.9625,27.6417]},{"Plant":"Interstate","State":"IL","Gas":128,"coordinates":[-89.5891,39.8233]},{"Plant":"Rathdrum","State":"ID","Gas":136,"coordinates":[-116.8673,47.8043]},{"Plant":"Arthur Von Rosenberg","State":"TX","Gas":482,"coordinates":[-98.384,29.257]},{"Plant":"Carson Ice-Gen Project","State":"CA","Gas":101,"coordinates":[-121.4624,38.4457]},{"Plant":"Wayne County","State":"NC","Gas":668,"coordinates":[-78.0981,35.3758]},{"Plant":"Ponca City","State":"OK","Gas":104.4,"coordinates":[-97.0858,36.7198]},{"Plant":"SCA Cogen 2","State":"CA","Gas":154.6,"coordinates":[-121.4001,38.5309]},{"Plant":"SPA Cogen 3","State":"CA","Gas":164,"coordinates":[-121.4735,38.511]},{"Plant":"St Francis Energy Facility","State":"MO","Gas":473,"coordinates":[-90.1779,36.5852]},{"Plant":"River Road Gen Plant","State":"WA","Gas":220,"coordinates":[-122.7256,45.6497]},{"Plant":"Washington County Cogeneration Facility","State":"AL","Gas":131.7,"coordinates":[-88.0156,31.2504]},{"Plant":"Tiger Bay","State":"FL","Gas":207,"coordinates":[-81.8494,27.7464]},{"Plant":"Dahlberg","State":"GA","Gas":750,"coordinates":[-83.3977,34.0423]},{"Plant":"H Allen Franklin Combined Cycle","State":"AL","Gas":1139.48,"coordinates":[-85.0975,32.6078]},{"Plant":"Theodore Cogen Facility","State":"AL","Gas":224.7,"coordinates":[-88.1285,30.5254]},{"Plant":"Essex","State":"MO","Gas":107.4,"coordinates":[-89.8402,36.8682]},{"Plant":"Nodaway","State":"MO","Gas":182.8,"coordinates":[-94.7913,40.2877]},{"Plant":"Chouteau","State":"OK","Gas":495,"coordinates":[-95.2771,36.2221]},{"Plant":"Georgetown","State":"IN","Gas":295,"coordinates":[-86.2441,39.9026]},{"Plant":"Tilton","State":"IL","Gas":176,"coordinates":[-87.6538,40.1061]},{"Plant":"Henry County","State":"IN","Gas":135.5,"coordinates":[-85.5039,39.9528]},{"Plant":"MPC Generating","State":"GA","Gas":315.12,"coordinates":[-83.6953,33.8119]},{"Plant":"Sherwood H Smith Jr Energy Complex","State":"NC","Gas":1247,"coordinates":[-79.7406,34.8392]},{"Plant":"Sewell Creek Energy","State":"GA","Gas":491.4,"coordinates":[-85.2769,33.9486]},{"Plant":"Alsey","State":"IL","Gas":121,"coordinates":[-90.436,39.5698]},{"Plant":"Fulton","State":"AR","Gas":153,"coordinates":[-93.7924,33.6094]},{"Plant":"Rowan","State":"NC","Gas":977.01,"coordinates":[-80.6019,35.7314]},{"Plant":"Smarr Energy Center","State":"GA","Gas":217.4,"coordinates":[-83.8464,32.9842]},{"Plant":"John S Rainey","State":"SC","Gas":958.2,"coordinates":[-82.776,34.3477]},{"Plant":"Essential Power Rock Springs LLC","State":"MD","Gas":628.5,"coordinates":[-76.1598,39.719]},{"Plant":"Marsh Run Generating","State":"VA","Gas":469.5,"coordinates":[-77.7681,38.5283]},{"Plant":"Louisa Generating","State":"VA","Gas":458.5,"coordinates":[-78.2139,38.1181]},{"Plant":"Remington","State":"VA","Gas":580,"coordinates":[-77.7714,38.5442]},{"Plant":"Ladysmith","State":"VA","Gas":290,"coordinates":[-77.5133,38.0722]},{"Plant":"Pleasant Valley","State":"MN","Gas":427.3,"coordinates":[-92.6829,43.7994]},{"Plant":"Lagoon Creek","State":"TN","Gas":940.8,"coordinates":[-89.3964,35.6578]},{"Plant":"Brandy Branch","State":"FL","Gas":475.8,"coordinates":[-81.9472,30.3206]},{"Plant":"Holden","State":"MO","Gas":232.8,"coordinates":[-93.9983,38.7538]},{"Plant":"MEPI GT Facility","State":"IL","Gas":239,"coordinates":[-88.8661,37.2175]},{"Plant":"Encogen","State":"WA","Gas":170,"coordinates":[-122.486,48.746]},{"Plant":"Robert P Mone Plant","State":"OH","Gas":447,"coordinates":[-84.7392,40.9297]},{"Plant":"H L Culbreath Bayside Power Station","State":"FL","Gas":1632,"coordinates":[-82.4231,27.9072]},{"Plant":"Terry Bundy Generating Station","State":"NE","Gas":164.6,"coordinates":[-96.6131,40.9097]},{"Plant":"E B Harris Electric Generating Plant","State":"AL","Gas":1121.4,"coordinates":[-86.5744,32.3814]},{"Plant":"Sand Hill","State":"TX","Gas":447.2,"coordinates":[-97.6129,30.2098]},{"Plant":"Talbot County Energy","State":"GA","Gas":652.2,"coordinates":[-84.6917,32.5892]},{"Plant":"Chattahoochee Energy Facility","State":"GA","Gas":465,"coordinates":[-85.0386,33.4072]},{"Plant":"Lakefield Junction","State":"MN","Gas":512.8,"coordinates":[-94.8415,43.7984]},{"Plant":"West Gardner","State":"KS","Gas":308,"coordinates":[-94.9861,38.7875]},{"Plant":"Coyote Springs II","State":"OR","Gas":244,"coordinates":[-119.674,45.848]},{"Plant":"Wansley Unit 9","State":"GA","Gas":504.4,"coordinates":[-85.0403,33.4083]},{"Plant":"Kemper County","State":"MS","Gas":312.8,"coordinates":[-88.606,32.7976]},{"Plant":"Peno Creek","State":"MO","Gas":188,"coordinates":[-91.2295,39.3531]},{"Plant":"Sumpter","State":"MI","Gas":296,"coordinates":[-83.5318,42.167]},{"Plant":"Pyramid","State":"NM","Gas":158,"coordinates":[-108.5494,32.2363]},{"Plant":"Mill Creek","State":"SC","Gas":595.36,"coordinates":[-81.4306,35.1597]},{"Plant":"Greater Des Moines","State":"IA","Gas":491,"coordinates":[-93.5283,41.5563]},{"Plant":"Silver Creek","State":"MS","Gas":150,"coordinates":[-89.9468,31.6004]},{"Plant":"Sylvarena","State":"MS","Gas":129,"coordinates":[-89.4127,31.9821]},{"Plant":"Murray Turbine","State":"UT","Gas":159,"coordinates":[-111.89,40.67]},{"Plant":"Sycamore","State":"IA","Gas":149,"coordinates":[-93.6769,41.6722]},{"Plant":"Emery Station","State":"IA","Gas":557.2,"coordinates":[-93.2922,43.094]},{"Plant":"Intercession City","State":"FL","Gas":604,"coordinates":[-81.5486,28.2628]},{"Plant":"Gerald Andrus","State":"MS","Gas":741,"coordinates":[-91.1167,33.35]},{"Plant":"Waterford 1 & 2","State":"LA","Gas":822,"coordinates":[-90.4768,29.9989]},{"Plant":"Comanche","State":"OK","Gas":273,"coordinates":[-98.3244,34.5431]},{"Plant":"DeCordova Steam Electric Station","State":"TX","Gas":1138,"coordinates":[-97.7006,32.4031]},{"Plant":"Santan","State":"AZ","Gas":368,"coordinates":[-111.7503,33.3325]},{"Plant":"Beaver","State":"OR","Gas":494.8,"coordinates":[-123.1739,46.1724]},{"Plant":"Glen Gardner","State":"NJ","Gas":160,"coordinates":[-74.9207,40.6815]},{"Plant":"Grand Tower","State":"IL","Gas":516,"coordinates":[-89.5112,37.6577]},{"Plant":"Calumet","State":"IL","Gas":203.9,"coordinates":[-87.5428,41.7136]},{"Plant":"Crawford","State":"IL","Gas":172.8,"coordinates":[-87.7229,41.8285]},{"Plant":"Electric Junction","State":"IL","Gas":217.4,"coordinates":[-88.0833,41.8333]},{"Plant":"Joliet 9","State":"IL","Gas":115.1,"coordinates":[-88.1153,41.4931]},{"Plant":"Astoria Generating Station","State":"NY","Gas":191,"coordinates":[-73.9126,40.7877]},{"Plant":"Wood River","State":"IL","Gas":129.9,"coordinates":[-90.1347,38.8639]},{"Plant":"Beluga","State":"AK","Gas":344.4,"coordinates":[-151.0356,61.1861]},{"Plant":"Marion","State":"IL","Gas":140,"coordinates":[-88.9531,37.6197]},{"Plant":"Frederickson","State":"WA","Gas":158,"coordinates":[-122.365,47.0797]},{"Plant":"Harding Street","State":"IN","Gas":322,"coordinates":[-86.1969,39.7113]},{"Plant":"Dean H Mitchell","State":"IN","Gas":142,"coordinates":[-87.4069,41.6392]},{"Plant":"Michigan City","State":"IN","Gas":120,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Gas":740,"coordinates":[-87.7811,32.6017]},{"Plant":"NRG Energy Center Dover","State":"DE","Gas":104.4,"coordinates":[-75.5473,39.1495]},{"Plant":"Gilroy Power Plant","State":"CA","Gas":130,"coordinates":[-121.5367,37.0001]},{"Plant":"Noblesville","State":"IN","Gas":285.9,"coordinates":[-85.9714,40.0969]},{"Plant":"Pedricktown Cogeneration Company LP","State":"NJ","Gas":115.7,"coordinates":[-75.4238,39.7668]},{"Plant":"Broadway","State":"IN","Gas":115,"coordinates":[-87.6049,37.9691]},{"Plant":"Butler-Warner Generation Plant","State":"NC","Gas":225,"coordinates":[-78.8294,35.0986]},{"Plant":"El Segundo Cogen","State":"CA","Gas":127.7,"coordinates":[-118.4031,33.9058]},{"Plant":"ArcelorMittal Burns Harbor","State":"IN","Gas":177.7,"coordinates":[-87.1387,41.635]},{"Plant":"King City Power Plant","State":"CA","Gas":111,"coordinates":[-121.1278,36.225]},{"Plant":"Bayou Cogen Plant","State":"TX","Gas":260,"coordinates":[-95.0458,29.6225]},{"Plant":"Bellingham Cogeneration Facility","State":"MA","Gas":264,"coordinates":[-71.4833,42.0925]},{"Plant":"Sayreville Cogeneration Facility","State":"NJ","Gas":271,"coordinates":[-74.3444,40.439]},{"Plant":"Foster Wheeler Martinez","State":"CA","Gas":103.5,"coordinates":[-122.0589,38.0244]},{"Plant":"ExxonMobil Baytown Refinery","State":"TX","Gas":183.82,"coordinates":[-94.9973,29.7535]},{"Plant":"RG Steel Sparrows Point, LLC","State":"MD","Gas":152.3,"coordinates":[-76.4729,39.213]},{"Plant":"Kern River Cogeneration","State":"CA","Gas":264.8,"coordinates":[-118.9849,35.4515]},{"Plant":"Formosa Utility Venture Ltd","State":"TX","Gas":597.3,"coordinates":[-96.5417,28.6917]},{"Plant":"Hopewell Cogeneration","State":"VA","Gas":348.3,"coordinates":[-77.2811,37.2917]},{"Plant":"CES Placerita Power Plant","State":"CA","Gas":115,"coordinates":[-118.4999,34.3801]},{"Plant":"ExxonMobil Baytown Turbine","State":"TX","Gas":320.38,"coordinates":[-95.0096,29.7591]},{"Plant":"Selkirk Cogen","State":"NY","Gas":356.82,"coordinates":[-73.8592,42.5744]},{"Plant":"Masspower","State":"MA","Gas":231.5,"coordinates":[-72.5225,42.1575]},{"Plant":"Clear Lake Cogeneration Ltd","State":"TX","Gas":366,"coordinates":[-95.067,29.6255]},{"Plant":"Midland Cogeneration Venture","State":"MI","Gas":1823.4,"coordinates":[-84.2242,43.5861]},{"Plant":"Camden Plant Holding LLC","State":"NJ","Gas":148.5,"coordinates":[-75.1192,39.9175]},{"Plant":"River Hills","State":"IA","Gas":120,"coordinates":[-93.6195,41.5902]},{"Plant":"Hazelton","State":"PA","Gas":147.2,"coordinates":[-76.0409,40.9282]},{"Plant":"Ocotillo","State":"AZ","Gas":320,"coordinates":[-111.9122,33.4225]},{"Plant":"West Phoenix","State":"AZ","Gas":1047.3,"coordinates":[-112.1583,33.4417]},{"Plant":"Saguaro","State":"AZ","Gas":386,"coordinates":[-111.3,32.5517]},{"Plant":"Yucca","State":"AZ","Gas":163,"coordinates":[-114.7106,32.7214]},{"Plant":"Fort Dodge","State":"KS","Gas":142.3,"coordinates":[-99.9497,37.7328]},{"Plant":"Gordon Evans Energy Center","State":"KS","Gas":831,"coordinates":[-97.5217,37.7903]},{"Plant":"Murray Gill","State":"KS","Gas":317,"coordinates":[-97.4136,37.5967]},{"Plant":"Hutchinson Energy Center","State":"KS","Gas":399,"coordinates":[-97.8747,38.0906]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Gas":316,"coordinates":[-110.9047,32.16]},{"Plant":"Kaw","State":"KS","Gas":140.3,"coordinates":[-94.6514,39.0867]},{"Plant":"McPherson 2","State":"KS","Gas":131.5,"coordinates":[-97.6834,38.3634]},{"Plant":"Garden City","State":"KS","Gas":225.7,"coordinates":[-100.8956,37.9703]},{"Plant":"E W Brown","State":"KY","Gas":849,"coordinates":[-84.7126,37.7883]},{"Plant":"Paddys Run","State":"KY","Gas":193,"coordinates":[-85.8417,38.2236]},{"Plant":"Louisiana 1","State":"LA","Gas":382.4,"coordinates":[-91.1864,30.4922]},{"Plant":"Louisiana 2","State":"LA","Gas":138,"coordinates":[-91.1864,30.4922]},{"Plant":"R S Nelson","State":"LA","Gas":653,"coordinates":[-93.2911,30.2844]},{"Plant":"Willow Glen","State":"LA","Gas":2045,"coordinates":[-91.1164,30.2743]},{"Plant":"Coughlin Power Station","State":"LA","Gas":745,"coordinates":[-92.2611,30.8439]},{"Plant":"Teche","State":"LA","Gas":430,"coordinates":[-91.5425,29.8222]},{"Plant":"Little Gypsy","State":"LA","Gas":1198,"coordinates":[-90.4617,30.0051]},{"Plant":"Nine Mile Point","State":"LA","Gas":1804,"coordinates":[-90.1458,29.9472]},{"Plant":"Sterlington","State":"LA","Gas":408,"coordinates":[-92.0792,32.7047]},{"Plant":"A B Paterson","State":"LA","Gas":122,"coordinates":[-90.0256,30.0158]},{"Plant":"Michoud","State":"LA","Gas":860,"coordinates":[-89.9372,30.0081]},{"Plant":"Agua Fria","State":"AZ","Gas":626,"coordinates":[-112.2153,33.5561]},{"Plant":"Arsenal Hill","State":"LA","Gas":110,"coordinates":[-93.7611,32.5181]},{"Plant":"Lieberman","State":"LA","Gas":271,"coordinates":[-93.9597,32.7047]},{"Plant":"Louis Doc Bonin","State":"LA","Gas":302,"coordinates":[-92.0463,30.238]},{"Plant":"Monroe","State":"LA","Gas":126,"coordinates":[-92.1794,32.5233]},{"Plant":"Big Cajun 1","State":"LA","Gas":430,"coordinates":[-91.3556,30.6739]},{"Plant":"Kyrene","State":"AZ","Gas":522,"coordinates":[-111.9353,33.3556]},{"Plant":"Notch Cliff","State":"MD","Gas":128,"coordinates":[-76.5087,39.4217]},{"Plant":"Westport","State":"MD","Gas":121,"coordinates":[-76.6295,39.266]},{"Plant":"Dickerson","State":"MD","Gas":294,"coordinates":[-77.4644,39.2097]},{"Plant":"Mystic Generating Station","State":"MA","Gas":1925.01,"coordinates":[-71.0675,42.3908]},{"Plant":"New Boston Generating Station","State":"MA","Gas":702,"coordinates":[-71.0353,42.3392]},{"Plant":"Kendall Square Station","State":"MA","Gas":207.69,"coordinates":[-71.0792,42.3633]},{"Plant":"Apache Station","State":"AZ","Gas":198.5,"coordinates":[-109.8931,32.0603]},{"Plant":"Cecil Lynch","State":"AR","Gas":204,"coordinates":[-92.1987,34.7535]},{"Plant":"Hamilton Moses","State":"AR","Gas":138,"coordinates":[-90.8722,34.9806]},{"Plant":"Harvey Couch","State":"AR","Gas":161,"coordinates":[-93.4649,33.3592]},{"Plant":"B C Cobb","State":"MI","Gas":187,"coordinates":[-86.2423,43.2588]},{"Plant":"Lake Catherine","State":"AR","Gas":751,"coordinates":[-92.9049,34.4341]},{"Plant":"Dan E Karn","State":"MI","Gas":1276,"coordinates":[-83.8401,43.645]},{"Plant":"Thetford","State":"MI","Gas":192,"coordinates":[-83.6286,43.1567]},{"Plant":"Conners Creek","State":"MI","Gas":215,"coordinates":[-82.9597,42.3592]},{"Plant":"Delray","State":"MI","Gas":127,"coordinates":[-83.1019,42.2947]},{"Plant":"Robert E Ritchie","State":"AR","Gas":863,"coordinates":[-90.5987,34.4629]},{"Plant":"Hancock","State":"MI","Gas":141,"coordinates":[-83.4425,42.5497]},{"Plant":"River Rouge","State":"MI","Gas":234,"coordinates":[-83.1119,42.2739]},{"Plant":"Mistersky","State":"MI","Gas":154,"coordinates":[-83.0903,42.3039]},{"Plant":"Fox Lake","State":"MN","Gas":109.36,"coordinates":[-94.7075,43.6728]},{"Plant":"Black Dog","State":"MN","Gas":297.8,"coordinates":[-93.2501,44.8108]},{"Plant":"Inver Hills","State":"MN","Gas":350.05,"coordinates":[-93.042,44.781]},{"Plant":"Thomas Fitzhugh","State":"AR","Gas":171,"coordinates":[-93.8049,35.4624]},{"Plant":"Carl Bailey","State":"AR","Gas":122,"coordinates":[-91.3634,35.2601]},{"Plant":"McClellan","State":"AR","Gas":134,"coordinates":[-92.7917,33.5648]},{"Plant":"Chevron Oil","State":"MS","Gas":127,"coordinates":[-88.4919,30.34]},{"Plant":"Sweatt","State":"MS","Gas":124,"coordinates":[-88.7461,32.2925]},{"Plant":"Jack Watson","State":"MS","Gas":292,"coordinates":[-89.0286,30.4392]},{"Plant":"Baxter Wilson","State":"MS","Gas":1230,"coordinates":[-90.9306,32.2831]},{"Plant":"Delta","State":"MS","Gas":192,"coordinates":[-90.7139,33.7947]},{"Plant":"Rex Brown","State":"MS","Gas":310,"coordinates":[-90.213,32.357]},{"Plant":"Moselle","State":"MS","Gas":252,"coordinates":[-89.3004,31.528]},{"Plant":"Hawthorn","State":"MO","Gas":420,"coordinates":[-94.4778,39.1306]},{"Plant":"Lake Road","State":"MO","Gas":117,"coordinates":[-94.8773,39.7246]},{"Plant":"James River Power Station","State":"MO","Gas":155,"coordinates":[-93.2619,37.1086]},{"Plant":"C W Burdick","State":"NE","Gas":173.5,"coordinates":[-98.3269,40.9228]},{"Plant":"Contra Costa","State":"CA","Gas":672,"coordinates":[-121.7642,38.0192]},{"Plant":"Clark","State":"NV","Gas":700,"coordinates":[-115.0507,36.0875]},{"Plant":"Sunrise","State":"NV","Gas":149,"coordinates":[-115.036,36.1384]},{"Plant":"Fort Churchill","State":"NV","Gas":226,"coordinates":[-119.1322,39.1281]},{"Plant":"Tracy","State":"NV","Gas":480,"coordinates":[-119.525,39.5625]},{"Plant":"Deepwater","State":"NJ","Gas":105,"coordinates":[-75.5083,39.6831]},{"Plant":"Sayreville","State":"NJ","Gas":343,"coordinates":[-74.3523,40.4765]},{"Plant":"Gilbert","State":"NJ","Gas":540,"coordinates":[-75.1639,40.5658]},{"Plant":"Bergen Generating Station","State":"NJ","Gas":1202,"coordinates":[-74.0244,40.8375]},{"Plant":"PSEG Burlington Generating Station","State":"NJ","Gas":409,"coordinates":[-74.8792,40.0766]},{"Plant":"PSEG Edison Generating Station","State":"NJ","Gas":465,"coordinates":[-74.3956,40.4911]},{"Plant":"PSEG Essex Generating Station","State":"NJ","Gas":608.2,"coordinates":[-74.1206,40.7372]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Gas":339.3,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Kearny Generating Station","State":"NJ","Gas":618,"coordinates":[-74.0965,40.7373]},{"Plant":"PSEG Linden Generating Station","State":"NJ","Gas":355,"coordinates":[-74.2072,40.6217]},{"Plant":"PSEG Sewaren Generating Station","State":"NJ","Gas":417,"coordinates":[-74.2469,40.5558]},{"Plant":"Rio Grande","State":"NM","Gas":231,"coordinates":[-106.5472,31.8047]},{"Plant":"Maddox","State":"NM","Gas":192.7,"coordinates":[-103.3015,32.7142]},{"Plant":"Reeves","State":"NM","Gas":154,"coordinates":[-106.6019,35.171]},{"Plant":"Cunningham","State":"NM","Gas":487,"coordinates":[-103.3533,32.7131]},{"Plant":"Humboldt Bay","State":"CA","Gas":105,"coordinates":[-124.2103,40.7415]},{"Plant":"Hunters Point","State":"CA","Gas":377,"coordinates":[-122.3897,37.7336]},{"Plant":"Arthur Kill Generating Station","State":"NY","Gas":841,"coordinates":[-74.2,40.5916]},{"Plant":"East River","State":"NY","Gas":292.1,"coordinates":[-73.9742,40.7281]},{"Plant":"Gowanus Gas Turbines Generating","State":"NY","Gas":271,"coordinates":[-74.0051,40.6635]},{"Plant":"Narrows Gas Turbines Generating","State":"NY","Gas":277,"coordinates":[-74.0208,40.6486]},{"Plant":"Ravenswood","State":"NY","Gas":2400.8,"coordinates":[-73.9461,40.7592]},{"Plant":"E F Barrett","State":"NY","Gas":696.9,"coordinates":[-73.6479,40.6167]},{"Plant":"Far Rockaway","State":"NY","Gas":109.5,"coordinates":[-73.761,40.6109]},{"Plant":"Glenwood","State":"NY","Gas":316.1,"coordinates":[-73.6475,40.8271]},{"Plant":"Northport","State":"NY","Gas":1549.9,"coordinates":[-73.3423,40.9236]},{"Plant":"Port Jefferson","State":"NY","Gas":465.5,"coordinates":[-73.0785,40.9497]},{"Plant":"Bethlehem Energy Center","State":"NY","Gas":365,"coordinates":[-73.7638,42.5942]},{"Plant":"Dynegy Morro Bay LLC","State":"CA","Gas":999,"coordinates":[-120.8566,35.3722]},{"Plant":"Dynegy Moss Landing Power Plant","State":"CA","Gas":2498,"coordinates":[-121.7822,36.8048]},{"Plant":"Bowline Point","State":"NY","Gas":1139,"coordinates":[-73.9689,41.2044]},{"Plant":"Asheville","State":"NC","Gas":330,"coordinates":[-82.5417,35.4731]},{"Plant":"Pittsburg Power","State":"CA","Gas":1906,"coordinates":[-121.8945,38.0392]},{"Plant":"Potrero Power","State":"CA","Gas":206,"coordinates":[-122.387,37.7566]},{"Plant":"Riverbend","State":"NC","Gas":120,"coordinates":[-80.9742,35.36]},{"Plant":"Dicks Creek","State":"OH","Gas":106.2,"coordinates":[-84.3778,39.465]},{"Plant":"Frank M Tait","State":"OH","Gas":256,"coordinates":[-84.2111,39.7272]},{"Plant":"Yankee Street","State":"OH","Gas":107,"coordinates":[-84.2047,39.603]},{"Plant":"FirstEnergy West Lorain","State":"OH","Gas":370,"coordinates":[-82.2644,41.4294]},{"Plant":"Richland","State":"OH","Gas":358,"coordinates":[-84.3346,41.3052]},{"Plant":"Horseshoe Lake","State":"OK","Gas":881,"coordinates":[-97.1797,35.5087]},{"Plant":"Muskogee","State":"OK","Gas":166,"coordinates":[-95.2873,35.7614]},{"Plant":"Mustang","State":"OK","Gas":537.5,"coordinates":[-97.675,35.4699]},{"Plant":"Seminole","State":"OK","Gas":1541.5,"coordinates":[-96.7258,34.9665]},{"Plant":"Northeastern","State":"OK","Gas":600,"coordinates":[-95.7008,36.4317]},{"Plant":"Southwestern","State":"OK","Gas":472,"coordinates":[-98.3524,35.1009]},{"Plant":"Tulsa","State":"OK","Gas":400,"coordinates":[-95.991,36.1165]},{"Plant":"Weleetka","State":"OK","Gas":162,"coordinates":[-96.1352,35.3233]},{"Plant":"Barry","State":"AL","Gas":862,"coordinates":[-88.0103,31.0069]},{"Plant":"Anadarko Plant","State":"OK","Gas":350,"coordinates":[-98.23,35.0847]},{"Plant":"Mooreland","State":"OK","Gas":322,"coordinates":[-99.2254,36.4372]},{"Plant":"Encina","State":"CA","Gas":958,"coordinates":[-117.3364,33.1361]},{"Plant":"Kearny","State":"CA","Gas":127,"coordinates":[-117.1338,32.834]},{"Plant":"Brunot Island","State":"PA","Gas":278,"coordinates":[-80.0438,40.4649]},{"Plant":"Dynegy South Bay Power Plant","State":"CA","Gas":693,"coordinates":[-117.092,32.6114]},{"Plant":"AES Alamitos LLC","State":"CA","Gas":2130,"coordinates":[-118.1009,33.7688]},{"Plant":"Manchester Street","State":"RI","Gas":425.91,"coordinates":[-71.4042,41.8167]},{"Plant":"Darlington County","State":"SC","Gas":448,"coordinates":[-80.1657,34.4185]},{"Plant":"Buzzard Roost","State":"SC","Gas":196,"coordinates":[-81.9025,34.1692]},{"Plant":"Coolwater","State":"CA","Gas":608,"coordinates":[-116.8539,34.8606]},{"Plant":"Urquhart","State":"SC","Gas":383,"coordinates":[-81.9111,33.435]},{"Plant":"El Segundo Power","State":"CA","Gas":940.54,"coordinates":[-118.4242,33.9098]},{"Plant":"Etiwanda Generating Station","State":"CA","Gas":1019,"coordinates":[-117.5266,34.0912]},{"Plant":"Riverside Canal Power","State":"CA","Gas":127,"coordinates":[-117.3312,34.0229]},{"Plant":"AES Huntington Beach LLC","State":"CA","Gas":1036.6,"coordinates":[-117.9792,33.6439]},{"Plant":"Allen Steam Plant","State":"TN","Gas":427.2,"coordinates":[-90.1487,35.0741]},{"Plant":"Gallatin","State":"TN","Gas":599.2,"coordinates":[-86.4006,36.3156]},{"Plant":"Johnsonville","State":"TN","Gas":1064.8,"coordinates":[-87.9861,36.0278]},{"Plant":"Long Beach Generation LLC","State":"CA","Gas":584,"coordinates":[-118.2248,33.7641]},{"Plant":"E S Joslin","State":"TX","Gas":254,"coordinates":[-96.5458,28.6472]},{"Plant":"J L Bates","State":"TX","Gas":182,"coordinates":[-98.3944,26.2222]},{"Plant":"Laredo","State":"TX","Gas":171,"coordinates":[-99.5089,27.5667]},{"Plant":"Lon C Hill","State":"TX","Gas":559,"coordinates":[-97.6167,27.85]},{"Plant":"Nueces Bay","State":"TX","Gas":559,"coordinates":[-97.4192,27.8194]},{"Plant":"La Palma","State":"TX","Gas":255,"coordinates":[-97.6389,26.1331]},{"Plant":"Victoria","State":"TX","Gas":491,"coordinates":[-97.01,28.7883]},{"Plant":"Mandalay","State":"CA","Gas":560,"coordinates":[-119.2511,34.2067]},{"Plant":"Lake Hubbard","State":"TX","Gas":921,"coordinates":[-96.5458,32.8358]},{"Plant":"Mountain Creek","State":"TX","Gas":890,"coordinates":[-96.9358,32.7231]},{"Plant":"North Lake","State":"TX","Gas":715,"coordinates":[-96.975,32.9506]},{"Plant":"Parkdale","State":"TX","Gas":327,"coordinates":[-96.7233,32.7767]},{"Plant":"Newman","State":"TX","Gas":498,"coordinates":[-106.4318,31.9836]},{"Plant":"Lewis Creek","State":"TX","Gas":460,"coordinates":[-95.5214,30.4356]},{"Plant":"Neches","State":"TX","Gas":265,"coordinates":[-94.0593,30.0612]},{"Plant":"Sabine","State":"TX","Gas":1809,"coordinates":[-93.878,30.0242]},{"Plant":"Cedar Bayou","State":"TX","Gas":2258,"coordinates":[-94.9256,29.75]},{"Plant":"Deepwater","State":"TX","Gas":174,"coordinates":[-95.2253,29.7199]},{"Plant":"Greens Bayou","State":"TX","Gas":760,"coordinates":[-95.2194,29.8222]},{"Plant":"P H Robinson","State":"TX","Gas":2211,"coordinates":[-94.9794,29.4867]},{"Plant":"Sam Bertron","State":"TX","Gas":844,"coordinates":[-95.0598,29.7268]},{"Plant":"T H Wharton","State":"TX","Gas":1254,"coordinates":[-95.5306,29.9417]},{"Plant":"W A Parish","State":"TX","Gas":1191,"coordinates":[-95.6311,29.4828]},{"Plant":"Webster","State":"TX","Gas":387,"coordinates":[-95.1081,29.5258]},{"Plant":"Knox Lee","State":"TX","Gas":486,"coordinates":[-94.6415,32.3766]},{"Plant":"Wilkes","State":"TX","Gas":882,"coordinates":[-94.548,32.8482]},{"Plant":"Jones","State":"TX","Gas":486,"coordinates":[-101.7392,33.5239]},{"Plant":"Nichols","State":"TX","Gas":457,"coordinates":[-101.7464,35.2834]},{"Plant":"Plant X","State":"TX","Gas":442,"coordinates":[-102.4114,34.1661]},{"Plant":"Eagle Mountain","State":"TX","Gas":665,"coordinates":[-97.4792,32.9056]},{"Plant":"Graham","State":"TX","Gas":630,"coordinates":[-98.6117,33.1344]},{"Plant":"Handley","State":"TX","Gas":1421,"coordinates":[-97.2192,32.7283]},{"Plant":"Morgan Creek","State":"TX","Gas":1354,"coordinates":[-100.9156,32.3358]},{"Plant":"Permian Basin","State":"TX","Gas":1055,"coordinates":[-102.9633,31.5839]},{"Plant":"Ormond Beach","State":"CA","Gas":1516,"coordinates":[-119.1689,34.1292]},{"Plant":"Collin","State":"TX","Gas":154,"coordinates":[-96.8034,33.1576]},{"Plant":"Lake Creek","State":"TX","Gas":317,"coordinates":[-96.985,31.4647]},{"Plant":"River Crest","State":"TX","Gas":110,"coordinates":[-95.1467,33.3931]},{"Plant":"Stryker Creek","State":"TX","Gas":675,"coordinates":[-94.9898,31.9398]},{"Plant":"Tradinghouse","State":"TX","Gas":1383,"coordinates":[-96.9642,31.5728]},{"Plant":"Trinidad","State":"TX","Gas":240,"coordinates":[-96.1013,32.1245]},{"Plant":"Valley","State":"TX","Gas":1115,"coordinates":[-96.3676,33.6281]},{"Plant":"Paint Creek","State":"TX","Gas":231,"coordinates":[-99.7337,33.1576]},{"Plant":"Rio Pecos","State":"TX","Gas":141,"coordinates":[-102.3753,31.0706]},{"Plant":"San Angelo","State":"TX","Gas":123,"coordinates":[-100.491,31.3906]},{"Plant":"Decker Creek","State":"TX","Gas":932,"coordinates":[-97.6128,30.3033]},{"Plant":"Holly Street","State":"TX","Gas":591,"coordinates":[-97.7167,30.25]},{"Plant":"Silas Ray","State":"TX","Gas":125,"coordinates":[-97.5214,25.9131]},{"Plant":"AES Redondo Beach LLC","State":"CA","Gas":1310,"coordinates":[-118.395,33.8504]},{"Plant":"Bryan","State":"TX","Gas":130,"coordinates":[-96.3723,30.6474]},{"Plant":"Ray Olinger","State":"TX","Gas":405.3,"coordinates":[-96.4525,33.0681]},{"Plant":"Mountainview Generating Station","State":"CA","Gas":592.06,"coordinates":[-117.2418,34.0818]},{"Plant":"Sim Gideon","State":"TX","Gas":620,"coordinates":[-97.2708,30.1456]},{"Plant":"Ty Cooke","State":"TX","Gas":148.6,"coordinates":[-101.7906,33.5211]},{"Plant":"J Robert Massengale","State":"TX","Gas":107,"coordinates":[-101.8408,33.6039]},{"Plant":"Leon Creek","State":"TX","Gas":339,"coordinates":[-98.5761,29.3525]},{"Plant":"O W Sommers","State":"TX","Gas":850,"coordinates":[-98.3242,29.3081]},{"Plant":"V H Braunig","State":"TX","Gas":862,"coordinates":[-98.3825,29.2567]},{"Plant":"W B Tuttle","State":"TX","Gas":370,"coordinates":[-98.4181,29.53]},{"Plant":"R W Miller","State":"TX","Gas":574,"coordinates":[-98.3103,32.6581]},{"Plant":"Sam Rayburn","State":"TX","Gas":227,"coordinates":[-97.135,28.8947]},{"Plant":"Gadsby","State":"UT","Gas":352,"coordinates":[-111.9289,40.7686]},{"Plant":"Grayson","State":"CA","Gas":291.9,"coordinates":[-118.2782,34.1556]},{"Plant":"Chesterfield","State":"VA","Gas":397,"coordinates":[-77.3833,37.3822]},{"Plant":"Possum Point","State":"VA","Gas":854,"coordinates":[-77.2806,38.5367]},{"Plant":"Transalta Centralia Generation","State":"WA","Gas":256,"coordinates":[-122.8598,46.7559]},{"Plant":"El Centro","State":"CA","Gas":225.9,"coordinates":[-115.54,32.8022]},{"Plant":"Harbor","State":"CA","Gas":500,"coordinates":[-118.2656,33.7706]},{"Plant":"Haynes","State":"CA","Gas":2024.9,"coordinates":[-118.0991,33.7647]},{"Plant":"Wheaton","State":"WI","Gas":233.32,"coordinates":[-91.5158,44.8854]},{"Plant":"Scattergood","State":"CA","Gas":803,"coordinates":[-118.4276,33.9182]},{"Plant":"Port Washington Generating Station","State":"WI","Gas":575,"coordinates":[-87.8689,43.3842]},{"Plant":"Rock River","State":"WI","Gas":300.26,"coordinates":[-89.0276,42.582]},{"Plant":"West Marinette","State":"WI","Gas":160.5,"coordinates":[-87.6881,45.0869]},{"Plant":"Valley","State":"CA","Gas":1068,"coordinates":[-118.3913,34.245]},{"Plant":"Broadway","State":"CA","Gas":161,"coordinates":[-118.148,34.1254]},{"Plant":"Glenarm","State":"CA","Gas":155,"coordinates":[-118.1494,34.126]},{"Plant":"Spencer","State":"TX","Gas":171,"coordinates":[-97.1061,33.1975]},{"Plant":"Colbert","State":"AL","Gas":363.2,"coordinates":[-87.8486,34.7439]},{"Plant":"Zuni","State":"CO","Gas":107,"coordinates":[-105.017,39.7373]},{"Plant":"Thomas C Ferguson","State":"TX","Gas":420,"coordinates":[-98.3705,30.558]},{"Plant":"Fort Phantom","State":"TX","Gas":362,"coordinates":[-99.6778,32.5784]},{"Plant":"Barney M Davis","State":"TX","Gas":682,"coordinates":[-97.3117,27.6064]},{"Plant":"Riverside","State":"OK","Gas":917,"coordinates":[-95.9567,35.9978]},{"Plant":"Pittsfield Generating LP","State":"MA","Gas":141,"coordinates":[-73.2181,42.4564]},{"Plant":"Linden Cogen Plant","State":"NJ","Gas":899.8,"coordinates":[-74.2156,40.6322]},{"Plant":"Houston Chemical Complex Battleground","State":"TX","Gas":274,"coordinates":[-95.0839,29.7314]},{"Plant":"Paris Energy Center","State":"TX","Gas":238,"coordinates":[-95.5577,33.6968]},{"Plant":"Hal C Weaver Power Plant","State":"TX","Gas":107.73,"coordinates":[-97.7356,30.2867]},{"Plant":"Sycamore Cogeneration","State":"CA","Gas":308.4,"coordinates":[-118.9853,35.4526]},{"Plant":"Union Carbide Seadrift Cogen","State":"TX","Gas":168,"coordinates":[-96.7706,28.5105]},{"Plant":"Dow St Charles Operations","State":"LA","Gas":291.6,"coordinates":[-90.4414,29.9861]},{"Plant":"Watson Cogeneration","State":"CA","Gas":398,"coordinates":[-118.2448,33.8166]},{"Plant":"Bucksport Generation LLC","State":"ME","Gas":269,"coordinates":[-68.8046,44.5738]},{"Plant":"Bethpage Power Plant","State":"NY","Gas":184,"coordinates":[-73.4994,40.7469]},{"Plant":"Shell Deer Park","State":"TX","Gas":140,"coordinates":[-95.1289,29.7232]},{"Plant":"Newark Bay Cogeneration Partnership LP","State":"NJ","Gas":118,"coordinates":[-74.13,40.7197]},{"Plant":"Indeck Corinth Energy Center","State":"NY","Gas":131.5,"coordinates":[-73.8125,43.25]},{"Plant":"PPG Powerhouse C","State":"LA","Gas":303.2,"coordinates":[-93.2831,30.2242]},{"Plant":"Bayonne Plant Holding LLC","State":"NJ","Gas":170,"coordinates":[-74.1124,40.6553]},{"Plant":"Harbor Cogen","State":"CA","Gas":101.7,"coordinates":[-118.2303,33.7771]},{"Plant":"Rosemary Power Station","State":"NC","Gas":165,"coordinates":[-77.6594,36.4517]},{"Plant":"Oklahoma Cogeneration Project","State":"OK","Gas":111.4,"coordinates":[-97.625,35.4397]},{"Plant":"Eagle Point Power Generation","State":"NJ","Gas":195,"coordinates":[-75.1592,39.8746]},{"Plant":"TXU Sweetwater Generating Plant","State":"TX","Gas":289,"coordinates":[-100.365,32.4928]},{"Plant":"ExxonMobil Beaumont Refinery","State":"TX","Gas":637.2,"coordinates":[-94.0753,30.0636]},{"Plant":"JM Shafer Generating Station","State":"CO","Gas":263.1,"coordinates":[-104.7736,40.0986]},{"Plant":"Gary Works","State":"IN","Gas":221,"coordinates":[-87.3289,41.6224]},{"Plant":"Parlin Power Plant","State":"NJ","Gas":118,"coordinates":[-74.3272,40.4607]},{"Plant":"Optim Energy Altura Cogen LLC","State":"TX","Gas":448,"coordinates":[-95.1077,29.8161]},{"Plant":"Gramercy Holdings LLC","State":"LA","Gas":106,"coordinates":[-90.6693,30.054]},{"Plant":"Hardee Power Station","State":"FL","Gas":358,"coordinates":[-81.9636,27.6364]},{"Plant":"Bellmeade Power Station","State":"VA","Gas":230,"coordinates":[-77.4317,37.4964]},{"Plant":"Pryor Power Plant","State":"OK","Gas":111.5,"coordinates":[-95.3175,36.2977]},{"Plant":"Ocean State Power","State":"RI","Gas":218.62,"coordinates":[-71.6689,42.0097]},{"Plant":"LaO Energy Systems","State":"LA","Gas":676.4,"coordinates":[-91.2325,30.3186]},{"Plant":"Doswell Energy Center","State":"VA","Gas":819.8,"coordinates":[-77.1448,37.8182]},{"Plant":"Elizabeth River Power Station","State":"VA","Gas":309,"coordinates":[-76.3083,36.775]},{"Plant":"Texas City Power Plant","State":"TX","Gas":451,"coordinates":[-94.9438,29.3787]},{"Plant":"Dow Chemical Texas Operation","State":"TX","Gas":1158,"coordinates":[-95.4075,28.9913]},{"Plant":"Power Station 4","State":"TX","Gas":172,"coordinates":[-94.9219,29.3782]},{"Plant":"Midway Sunset Cogen","State":"CA","Gas":219,"coordinates":[-119.6294,35.2269]},{"Plant":"C R Wing Cogen Plant","State":"TX","Gas":227,"coordinates":[-101.4224,32.2732]},{"Plant":"Delaware City Plant","State":"DE","Gas":308,"coordinates":[-75.6343,39.5871]},{"Plant":"McWilliams","State":"AL","Gas":651,"coordinates":[-86.4764,31.4003]},{"Plant":"J K Smith","State":"KY","Gas":626,"coordinates":[-84.1017,37.8833]},{"Plant":"Lockport Energy Associates LP","State":"NY","Gas":210.2,"coordinates":[-78.745,43.1619]},{"Plant":"Kennedy International Airport Cogen","State":"NY","Gas":126.9,"coordinates":[-73.7778,40.6417]},{"Plant":"March Point Cogeneration","State":"WA","Gas":146.2,"coordinates":[-122.56,48.4708]},{"Plant":"Saguaro Power","State":"NV","Gas":101,"coordinates":[-115.0117,36.0417]},{"Plant":"Ocean State Power II","State":"RI","Gas":218.62,"coordinates":[-71.6701,42.0099]},{"Plant":"Orange Cogeneration Facility","State":"FL","Gas":117.48,"coordinates":[-81.8251,27.8708]},{"Plant":"Lake Cogen Ltd","State":"FL","Gas":110,"coordinates":[-81.676,28.9158]},{"Plant":"Pasco Cogen Ltd","State":"FL","Gas":116.18,"coordinates":[-82.1889,28.3746]},{"Plant":"Mulberry Cogeneration Facility","State":"FL","Gas":113,"coordinates":[-81.8775,27.8489]},{"Plant":"Orlando Cogen LP","State":"FL","Gas":120,"coordinates":[-81.4123,28.4426]},{"Plant":"Sumas Power Plant","State":"WA","Gas":125.5,"coordinates":[-122.2733,48.9905]},{"Plant":"Formosa Plastics","State":"LA","Gas":115,"coordinates":[-91.1872,30.4992]},{"Plant":"Ferndale Generating Station","State":"WA","Gas":271,"coordinates":[-122.6867,48.8288]},{"Plant":"Hartwell Energy Facility","State":"GA","Gas":304.4,"coordinates":[-82.8199,34.3396]},{"Plant":"Sithe Independence Station","State":"NY","Gas":982.2,"coordinates":[-76.4511,43.495]},{"Plant":"Saranac Facility","State":"NY","Gas":240,"coordinates":[-73.4557,44.7132]},{"Plant":"NAEA Lakewood LLC","State":"NJ","Gas":205.1,"coordinates":[-74.1686,40.0613]},{"Plant":"Auburndale Power Partners","State":"FL","Gas":154.7,"coordinates":[-81.8058,28.0542]},{"Plant":"Oyster Creek Unit VIII","State":"TX","Gas":379,"coordinates":[-95.342,28.9802]},{"Plant":"Hermiston Generating Plant","State":"OR","Gas":464,"coordinates":[-119.37,45.8042]},{"Plant":"Grays Ferry Cogeneration","State":"PA","Gas":150,"coordinates":[-75.1881,39.9422]},{"Plant":"Milford Power LP","State":"MA","Gas":148,"coordinates":[-71.5115,42.1294]},{"Plant":"Milagro Cogeneration Plant","State":"NM","Gas":121.6,"coordinates":[-107.9417,36.7367]},{"Plant":"Johnson County","State":"TX","Gas":267,"coordinates":[-97.4078,32.3994]},{"Plant":"Brandywine Power Facility","State":"MD","Gas":230,"coordinates":[-76.8678,38.6681]},{"Plant":"Gordonsville Energy LP","State":"VA","Gas":224,"coordinates":[-78.2138,38.1179]},{"Plant":"Sun Peak Generating Station","State":"NV","Gas":222,"coordinates":[-115.0339,36.1375]},{"Plant":"Brooklyn Navy Yard Cogeneration","State":"NY","Gas":230,"coordinates":[-73.9764,40.6994]},{"Plant":"Michigan Power LP","State":"MI","Gas":128,"coordinates":[-86.425,43.9375]},{"Plant":"LSP-Cottage Grove LP","State":"MN","Gas":251,"coordinates":[-92.9119,44.7956]},{"Plant":"LSP-Whitewater LP","State":"WI","Gas":253,"coordinates":[-88.7299,42.8555]},{"Plant":"Sweeny Cogen Facility","State":"TX","Gas":480,"coordinates":[-95.745,29.0728]},{"Plant":"Dighton Power Plant","State":"MA","Gas":142,"coordinates":[-71.1239,41.8312]},{"Plant":"De Pere Energy Center","State":"WI","Gas":181,"coordinates":[-88.072,44.4486]},{"Plant":"Androscoggin Energy Center","State":"ME","Gas":129.98,"coordinates":[-70.2423,44.5063]},{"Plant":"Delta Person LLC","State":"NM","Gas":140,"coordinates":[-106.644,35.026]},{"Plant":"Mid-Georgia Cogeneration Facility","State":"GA","Gas":316,"coordinates":[-83.6039,32.4856]},{"Plant":"Berkshire Power","State":"MA","Gas":232.12,"coordinates":[-72.6478,42.0476]},{"Plant":"Bridgeport Energy Project","State":"CT","Gas":454,"coordinates":[-73.1844,41.1692]},{"Plant":"Pasadena Cogeneration","State":"TX","Gas":700,"coordinates":[-95.1765,29.7248]},{"Plant":"Tiverton Power Plant","State":"RI","Gas":249.99,"coordinates":[-71.1706,41.6422]},{"Plant":"Axiall Plaquemine","State":"LA","Gas":240,"coordinates":[-91.185,30.2586]},{"Plant":"Tenaska Frontier Generation Station","State":"TX","Gas":860,"coordinates":[-95.9178,30.5924]},{"Plant":"Batesville Generation Facility","State":"MS","Gas":858,"coordinates":[-89.9275,34.3356]},{"Plant":"Black Hawk Station","State":"TX","Gas":221.4,"coordinates":[-101.36,35.6957]},{"Plant":"Mustang Station","State":"TX","Gas":486,"coordinates":[-102.7417,32.9728]},{"Plant":"Maine Independence Station","State":"ME","Gas":490.01,"coordinates":[-68.7094,44.8242]},{"Plant":"Pine Bluff Energy Center","State":"AR","Gas":198,"coordinates":[-91.9025,34.2181]},{"Plant":"Desert Star Energy Center","State":"NV","Gas":450,"coordinates":[-114.9928,35.7867]},{"Plant":"Millennium Power","State":"MA","Gas":325.8,"coordinates":[-72.0151,42.1123]},{"Plant":"New Albany Energy Facility","State":"MS","Gas":360,"coordinates":[-88.9397,34.5408]},{"Plant":"Brownsville Peaking Power","State":"TN","Gas":450,"coordinates":[-89.198,35.5438]},{"Plant":"Caledonia Power Facility","State":"MS","Gas":444,"coordinates":[-88.3186,33.6482]},{"Plant":"Crockett Cogen Project","State":"CA","Gas":247.4,"coordinates":[-122.2161,38.0569]},{"Plant":"Gregory Power Facility","State":"TX","Gas":412,"coordinates":[-97.2584,27.8893]},{"Plant":"Zeeland Generating Station","State":"MI","Gas":743.4,"coordinates":[-85.9975,42.8206]},{"Plant":"Dearborn Industrial Generation","State":"MI","Gas":700,"coordinates":[-83.154,42.3026]},{"Plant":"Taft Cogeneration Facility","State":"LA","Gas":790,"coordinates":[-90.4599,29.9888]},{"Plant":"Midlothian Energy Facility","State":"TX","Gas":1290,"coordinates":[-97.0537,32.4302]},{"Plant":"Lamar Power Project","State":"TX","Gas":1004,"coordinates":[-95.59,33.6308]},{"Plant":"Frontera Energy Center","State":"TX","Gas":475,"coordinates":[-98.3992,26.208]},{"Plant":"NRG Sterlington Power","State":"LA","Gas":176,"coordinates":[-92.0811,32.6889]},{"Plant":"Rumford Power Associates","State":"ME","Gas":254,"coordinates":[-70.5219,44.5303]},{"Plant":"Livingston Generating Station","State":"MI","Gas":132,"coordinates":[-84.7308,45.0304]},{"Plant":"Klamath Cogeneration Plant","State":"OR","Gas":470,"coordinates":[-121.8106,42.1739]},{"Plant":"Sabine Cogen","State":"TX","Gas":101,"coordinates":[-93.7714,30.0444]},{"Plant":"Entergy Rhode Island State Energy LP","State":"RI","Gas":515,"coordinates":[-71.5186,41.8017]},{"Plant":"Rocky Road Power LLC","State":"IL","Gas":340,"coordinates":[-88.2397,42.0931]},{"Plant":"Madison","State":"OH","Gas":576,"coordinates":[-84.4647,39.4522]},{"Plant":"Vermillion Energy Facility","State":"IN","Gas":560,"coordinates":[-87.4464,39.9223]},{"Plant":"Sutter Energy Center","State":"CA","Gas":530,"coordinates":[-121.6959,39.0531]},{"Plant":"Rockingham County CT Station","State":"NC","Gas":775,"coordinates":[-79.8297,36.3297]},{"Plant":"RS Cogen","State":"LA","Gas":395.6,"coordinates":[-93.2992,30.221]},{"Plant":"SRW Cogen LP","State":"TX","Gas":420,"coordinates":[-93.7574,30.0545]},{"Plant":"Magic Valley Generating Station","State":"TX","Gas":682,"coordinates":[-98.19,26.3403]},{"Plant":"Griffith Energy LLC","State":"AZ","Gas":570,"coordinates":[-114.1333,35.054]},{"Plant":"Milford Power Project","State":"CT","Gas":492.5,"coordinates":[-73.0997,41.2244]},{"Plant":"Manchief Electric Generating Station","State":"CO","Gas":264,"coordinates":[-103.685,40.2171]},{"Plant":"Walton County Power LLC","State":"GA","Gas":459.3,"coordinates":[-83.6954,33.8148]},{"Plant":"Desert Basin","State":"AZ","Gas":575,"coordinates":[-111.7889,32.9042]},{"Plant":"Kendall County Generation Facility","State":"IL","Gas":1140,"coordinates":[-88.2581,41.4797]},{"Plant":"Tenaska Gateway Generating Station","State":"TX","Gas":858,"coordinates":[-94.6197,32.0178]},{"Plant":"Alliant Energy Neenah","State":"WI","Gas":300.6,"coordinates":[-88.5064,44.1936]},{"Plant":"Rio Nogales Power Project","State":"TX","Gas":705,"coordinates":[-97.9732,29.5931]},{"Plant":"Wolf Hollow I LP","State":"TX","Gas":695.5,"coordinates":[-97.7317,32.3342]},{"Plant":"Hawk Road Facility","State":"GA","Gas":465,"coordinates":[-84.9914,33.3585]},{"Plant":"Hays Energy Project","State":"TX","Gas":876.8,"coordinates":[-97.9894,29.7806]},{"Plant":"Green Country Energy LLC","State":"OK","Gas":795,"coordinates":[-95.9346,35.9833]},{"Plant":"Worthington Generation LLC","State":"IN","Gas":179.2,"coordinates":[-87.0128,39.0708]},{"Plant":"Lake Road Generating Plant","State":"CT","Gas":729,"coordinates":[-71.8958,41.872]},{"Plant":"La Paloma Generating LLC","State":"CA","Gas":961.7,"coordinates":[-119.5919,35.2956]},{"Plant":"Guadalupe Generating Station","State":"TX","Gas":1000,"coordinates":[-98.1419,29.6244]},{"Plant":"Lost Pines 1 Power Project","State":"TX","Gas":546,"coordinates":[-97.2714,30.1478]},{"Plant":"Bluegrass Generating Station","State":"KY","Gas":495,"coordinates":[-85.4133,38.3902]},{"Plant":"Calcasieu","State":"LA","Gas":310,"coordinates":[-93.345,30.1608]},{"Plant":"Broad River Energy Center","State":"SC","Gas":845.06,"coordinates":[-81.575,35.0786]},{"Plant":"Bastrop Energy Center","State":"TX","Gas":552,"coordinates":[-97.55,30.1458]},{"Plant":"Granite Ridge","State":"NH","Gas":797,"coordinates":[-71.4261,42.9042]},{"Plant":"Bosque County Peaking","State":"TX","Gas":548,"coordinates":[-97.3586,31.8594]},{"Plant":"Acadia Energy Center","State":"LA","Gas":1063,"coordinates":[-92.4131,30.4286]},{"Plant":"Eastman Cogeneration Facility","State":"TX","Gas":402.22,"coordinates":[-94.6903,32.4481]},{"Plant":"South Point Energy Center","State":"AZ","Gas":550,"coordinates":[-114.5317,34.8678]},{"Plant":"Dogwood Energy Facility","State":"MO","Gas":620,"coordinates":[-94.3006,38.7931]},{"Plant":"Rathdrum Power LLC","State":"ID","Gas":248,"coordinates":[-116.9203,47.7858]},{"Plant":"Sunrise Power LLC","State":"CA","Gas":545,"coordinates":[-119.585,35.2097]},{"Plant":"Channelview Cogeneration Plant","State":"TX","Gas":779,"coordinates":[-95.1217,29.837]},{"Plant":"Cordova Energy","State":"IL","Gas":680,"coordinates":[-90.2797,41.7122]},{"Plant":"Osceola","State":"FL","Gas":468,"coordinates":[-81.0978,28.1289]},{"Plant":"Ontelaunee Energy Center","State":"PA","Gas":516,"coordinates":[-75.9356,40.4219]},{"Plant":"Caledonia","State":"MS","Gas":783,"coordinates":[-88.2717,33.6464]},{"Plant":"Riverside Generating LLC","State":"KY","Gas":825,"coordinates":[-82.6046,38.1917]},{"Plant":"Elwood Energy LLC","State":"IL","Gas":1350,"coordinates":[-88.1236,41.4388]},{"Plant":"Arapahoe Combustion Turbine Project","State":"CO","Gas":122.5,"coordinates":[-105.0018,39.6692]},{"Plant":"Gibson City","State":"IL","Gas":232,"coordinates":[-88.3987,40.4705]},{"Plant":"Pinckneyville","State":"IL","Gas":320,"coordinates":[-89.3467,38.1114]},{"Plant":"Kinmundy","State":"IL","Gas":232,"coordinates":[-89.0128,38.7619]},{"Plant":"Corpus Christi Energy Center","State":"TX","Gas":482.1,"coordinates":[-97.4283,27.8139]},{"Plant":"Afton Generating Station","State":"NM","Gas":141,"coordinates":[-106.8465,32.1142]},{"Plant":"ANP Bellingham Energy Project","State":"MA","Gas":493,"coordinates":[-71.4535,42.1106]},{"Plant":"ANP Blackstone Energy Project","State":"MA","Gas":440.64,"coordinates":[-71.5158,42.0599]},{"Plant":"Odessa Ector Generating Station","State":"TX","Gas":1026.2,"coordinates":[-102.3264,31.8403]},{"Plant":"Morris Cogeneration LLC","State":"IL","Gas":176,"coordinates":[-88.3328,41.4119]},{"Plant":"Los Medanos Energy Center","State":"CA","Gas":567,"coordinates":[-121.873,38.0301]},{"Plant":"Hinds Energy Facility","State":"MS","Gas":450,"coordinates":[-90.2199,32.379]},{"Plant":"Southaven Energy Facility","State":"MS","Gas":624,"coordinates":[-90.0397,34.9808]},{"Plant":"Attala","State":"MS","Gas":459,"coordinates":[-89.6753,33.0147]},{"Plant":"Harry L. Oswald","State":"AR","Gas":568,"coordinates":[-92.2166,34.5923]},{"Plant":"Lincoln Generating Facility","State":"IL","Gas":630.3,"coordinates":[-87.9436,41.3933]},{"Plant":"Ennis Power Company LLC","State":"TX","Gas":359.5,"coordinates":[-96.675,32.32]},{"Plant":"Wheatland Generating Facility","State":"IN","Gas":472,"coordinates":[-87.2931,38.6716]},{"Plant":"Oneta Energy Center","State":"OK","Gas":1082.1,"coordinates":[-95.6967,36.0119]},{"Plant":"Freestone Energy Center","State":"TX","Gas":984,"coordinates":[-96.1131,31.8907]},{"Plant":"Greenville Electric Generating Station","State":"OH","Gas":176,"coordinates":[-84.6151,40.0758]},{"Plant":"Montpelier Electric Generating Station","State":"IN","Gas":180,"coordinates":[-85.3057,40.6206]},{"Plant":"Liberty Electric Power Plant","State":"PA","Gas":521,"coordinates":[-75.3358,39.8614]},{"Plant":"Marshall Energy Facility","State":"KY","Gas":600,"coordinates":[-88.3958,37.0286]},{"Plant":"Handsome Lake Energy LLC","State":"PA","Gas":250,"coordinates":[-79.8061,41.2908]},{"Plant":"Audrain Generating Station","State":"MO","Gas":640,"coordinates":[-91.5369,39.3092]},{"Plant":"Lee Energy Facility","State":"IL","Gas":623.5,"coordinates":[-89.4054,41.8287]},{"Plant":"Energy Shelby County","State":"IL","Gas":371.6,"coordinates":[-88.4772,39.2794]},{"Plant":"NRG Rockford I","State":"IL","Gas":294,"coordinates":[-89.1012,42.2386]},{"Plant":"Red Oak Power LLC","State":"NJ","Gas":765.99,"coordinates":[-74.3489,40.4487]},{"Plant":"Hog Bayou Energy Center","State":"AL","Gas":230,"coordinates":[-88.0575,30.7478]},{"Plant":"Santa Rosa Energy Center","State":"FL","Gas":235.9,"coordinates":[-87.115,30.5664]},{"Plant":"Astoria Gas Turbines","State":"NY","Gas":420,"coordinates":[-73.9048,40.787]},{"Plant":"Doyle Energy Facility","State":"GA","Gas":355,"coordinates":[-83.6996,33.8377]},{"Plant":"Darby Electric Generating Station","State":"OH","Gas":451.8,"coordinates":[-83.1778,39.7139]},{"Plant":"Tait Electric Generating Station","State":"OH","Gas":319.6,"coordinates":[-84.2095,39.7277]},{"Plant":"University Park South","State":"IL","Gas":300,"coordinates":[-87.7532,41.4409]},{"Plant":"Gleason Generating Facility","State":"TN","Gas":540,"coordinates":[-88.612,36.2454]},{"Plant":"Crete Energy Venture LLC","State":"IL","Gas":300,"coordinates":[-87.6187,41.4294]},{"Plant":"Whiting Clean Energy","State":"IN","Gas":547,"coordinates":[-87.4775,41.6739]},{"Plant":"Edward L. Addison Generating Plant","State":"GA","Gas":609,"coordinates":[-84.3064,32.9111]},{"Plant":"TVA Southaven Combined Cycle","State":"MS","Gas":759,"coordinates":[-90.0378,34.9939]},{"Plant":"Jackson Generating Station","State":"MI","Gas":564,"coordinates":[-84.3767,42.2488]},{"Plant":"Tenaska Lindsay Hill Generating Station","State":"AL","Gas":857.9,"coordinates":[-86.7386,32.6514]},{"Plant":"Ceredo Generating Station","State":"WV","Gas":696.3,"coordinates":[-82.5339,38.3681]},{"Plant":"Aurora","State":"IL","Gas":910,"coordinates":[-88.2265,41.8151]},{"Plant":"Southeast Chicago Energy Project","State":"IL","Gas":296,"coordinates":[-87.5449,41.7181]},{"Plant":"Arlington Valley Energy Facility","State":"AZ","Gas":580,"coordinates":[-112.8897,33.3417]},{"Plant":"Front Range Power Plant","State":"CO","Gas":461.5,"coordinates":[-104.7069,38.6281]},{"Plant":"Big Sandy Peaker Plant","State":"WV","Gas":300,"coordinates":[-82.5938,38.3441]},{"Plant":"Wolf Hills Energy","State":"VA","Gas":250,"coordinates":[-82.1044,36.6644]},{"Plant":"Oleander Power Project LP","State":"FL","Gas":155.7,"coordinates":[-80.7947,28.3661]},{"Plant":"Decatur Energy Center","State":"AL","Gas":624,"coordinates":[-87.0214,34.6292]},{"Plant":"Morgan Energy Center","State":"AL","Gas":749,"coordinates":[-87.0639,34.6397]},{"Plant":"Westbrook Energy Center Power Plant","State":"ME","Gas":506,"coordinates":[-70.375,43.6575]},{"Plant":"Blythe Energy Inc","State":"CA","Gas":514.04,"coordinates":[-114.6865,33.6157]},{"Plant":"Calumet Energy Team LLC","State":"IL","Gas":324,"coordinates":[-87.5563,41.6835]},{"Plant":"New Covert Generating Facility","State":"MI","Gas":1058.4,"coordinates":[-86.2937,42.3224]},{"Plant":"Fairless Energy Center","State":"PA","Gas":1150.7,"coordinates":[-74.7411,40.1475]},{"Plant":"Channel Energy Center LLC","State":"TX","Gas":585,"coordinates":[-95.2319,29.7189]},{"Plant":"Warren Peaking Power Facility","State":"MS","Gas":300,"coordinates":[-90.9284,32.2849]},{"Plant":"Baconton Power Plant","State":"GA","Gas":195.2,"coordinates":[-84.08,31.3869]},{"Plant":"Gila River Power Station","State":"AZ","Gas":2060,"coordinates":[-112.6944,32.975]},{"Plant":"Ingleside Cogeneration","State":"TX","Gas":460,"coordinates":[-97.2428,27.8828]},{"Plant":"Fore River Generating Station","State":"MA","Gas":668.35,"coordinates":[-70.9661,42.2422]},{"Plant":"Wise County Power LLC","State":"TX","Gas":655,"coordinates":[-97.9103,33.0583]},{"Plant":"Baytown Energy Center","State":"TX","Gas":785,"coordinates":[-94.9019,29.7731]},{"Plant":"Hermiston Power Partnership","State":"OR","Gas":615,"coordinates":[-119.3133,45.794]},{"Plant":"Washington County","State":"GA","Gas":597.66,"coordinates":[-82.98,33.0922]},{"Plant":"Delta Energy Center","State":"CA","Gas":811.3,"coordinates":[-121.8439,38.0169]},{"Plant":"Holland Energy Facility","State":"IL","Gas":449,"coordinates":[-88.7584,39.2231]},{"Plant":"PPL Ironwood LLC","State":"PA","Gas":669,"coordinates":[-76.3658,40.3509]},{"Plant":"Armstrong","State":"PA","Gas":584,"coordinates":[-79.3517,40.638]},{"Plant":"Troy Energy LLC","State":"OH","Gas":584,"coordinates":[-83.4598,41.4772]},{"Plant":"Pleasants Energy LLC","State":"WV","Gas":292.2,"coordinates":[-81.3642,39.3325]},{"Plant":"Brazos Valley Generating Facility","State":"TX","Gas":718,"coordinates":[-95.6244,29.4731]},{"Plant":"Cottonwood Energy Project","State":"TX","Gas":1233.6,"coordinates":[-93.7353,30.2588]},{"Plant":"Sugar Creek Power","State":"IN","Gas":520.7,"coordinates":[-87.5108,39.3931]},{"Plant":"Exelon LaPorte Generating Station","State":"TX","Gas":168,"coordinates":[-95.0718,29.7028]},{"Plant":"Harquahala Generating Project","State":"AZ","Gas":1054.4,"coordinates":[-113.1134,33.476]},{"Plant":"Enterprise Energy Facility","State":"MS","Gas":600,"coordinates":[-90.0394,34.9767]},{"Plant":"Union Power Partners LP","State":"AR","Gas":2020,"coordinates":[-92.5894,33.2961]},{"Plant":"Thomas A Smith Energy Facility","State":"GA","Gas":1244,"coordinates":[-84.9175,34.7094]},{"Plant":"Columbia Energy Center","State":"SC","Gas":464.5,"coordinates":[-81.0178,33.8697]},{"Plant":"RockGen Energy Center","State":"WI","Gas":474,"coordinates":[-89.0492,42.9767]},{"Plant":"Zion Energy Center","State":"IL","Gas":456,"coordinates":[-87.895,42.4776]},{"Plant":"Metcalf Energy Center","State":"CA","Gas":546.1,"coordinates":[-121.7457,37.2207]},{"Plant":"Crossroads Energy Center","State":"MS","Gas":308,"coordinates":[-90.5621,34.183]},{"Plant":"Washington Energy Facility","State":"OH","Gas":600,"coordinates":[-81.6564,39.58]},{"Plant":"Elk Hills Power LLC","State":"CA","Gas":525,"coordinates":[-119.4707,35.2803]},{"Plant":"Rolling Hills Generating","State":"OH","Gas":825,"coordinates":[-82.3328,39.0839]},{"Plant":"Renaissance Power LLC","State":"MI","Gas":660,"coordinates":[-84.8429,43.1864]},{"Plant":"Carville Energy LLC","State":"LA","Gas":500,"coordinates":[-91.065,30.2294]},{"Plant":"Athens Generating Plant","State":"NY","Gas":1137.9,"coordinates":[-73.8492,42.2728]},{"Plant":"Effingham County Power Project","State":"GA","Gas":450,"coordinates":[-81.2844,32.2773]},{"Plant":"Calhoun Energy Center","State":"AL","Gas":624,"coordinates":[-85.9731,33.5883]},{"Plant":"Osprey Energy Center Power Plant","State":"FL","Gas":597.9,"coordinates":[-81.8083,28.0525]},{"Plant":"Shady Hills Generating Station","State":"FL","Gas":468,"coordinates":[-82.5586,28.3665]},{"Plant":"Vandolah Power Station","State":"FL","Gas":632,"coordinates":[-81.924,27.5236]},{"Plant":"Raccoon Creek Energy Center","State":"IL","Gas":300,"coordinates":[-88.5392,38.6996]},{"Plant":"Hot Spring Generating Facility","State":"AR","Gas":651.6,"coordinates":[-92.8683,34.2976]},{"Plant":"Plaquemine Cogeneration Plant","State":"LA","Gas":843.7,"coordinates":[-91.2347,30.3217]},{"Plant":"DeSoto County Plant","State":"FL","Gas":312.81,"coordinates":[-81.8092,27.2272]},{"Plant":"Bayou Cove Peaking Power","State":"LA","Gas":300,"coordinates":[-92.5997,30.2825]},{"Plant":"Elgin Energy Center","State":"IL","Gas":452,"coordinates":[-88.2446,42.0001]},{"Plant":"Tenaska Virginia Generating Station","State":"VA","Gas":909.9,"coordinates":[-78.3813,37.8667]},{"Plant":"Tenaska Central Alabama Generating Stn","State":"AL","Gas":864,"coordinates":[-86.74,32.6497]},{"Plant":"Columbia Energy Center","State":"MO","Gas":140,"coordinates":[-92.2629,39.0192]},{"Plant":"Magnolia Power Plant","State":"MS","Gas":863.1,"coordinates":[-89.2026,34.835]},{"Plant":"Fountain Valley Power Facility","State":"CO","Gas":234,"coordinates":[-104.6875,38.5569]},{"Plant":"Red Hawk","State":"AZ","Gas":948,"coordinates":[-112.8406,33.3346]},{"Plant":"McClain Energy Facility","State":"OK","Gas":461,"coordinates":[-97.5898,35.2977]},{"Plant":"Redbud Power Plant","State":"OK","Gas":1143.6,"coordinates":[-97.2264,35.6856]},{"Plant":"Deer Park Energy Center","State":"TX","Gas":877.2,"coordinates":[-95.1345,29.7134]},{"Plant":"Ouachita","State":"LA","Gas":816,"coordinates":[-92.0683,32.7061]},{"Plant":"Green Power 2","State":"TX","Gas":584,"coordinates":[-94.9328,29.3781]},{"Plant":"Forney Energy Center","State":"TX","Gas":1640,"coordinates":[-96.4916,32.7563]},{"Plant":"Mesquite Generating Station","State":"AZ","Gas":1073.3,"coordinates":[-112.8642,33.345]},{"Plant":"Goldendale Generating Station","State":"WA","Gas":219.9,"coordinates":[-120.833,45.8114]},{"Plant":"Tri Center Naniwa Energy","State":"NV","Gas":300,"coordinates":[-119.5178,39.5572]},{"Plant":"Goose Creek Energy Center","State":"IL","Gas":432,"coordinates":[-88.5999,40.1069]},{"Plant":"Kiamichi Energy Facility","State":"OK","Gas":1178.4,"coordinates":[-95.9349,34.6831]},{"Plant":"Lawrenceburg Energy Facility","State":"IN","Gas":1082,"coordinates":[-84.8669,39.0911]},{"Plant":"AEP Waterford Facility","State":"OH","Gas":806,"coordinates":[-81.7178,39.5333]},{"Plant":"Limon Generating Station","State":"CO","Gas":134,"coordinates":[-103.7005,39.2038]},{"Plant":"Frank Knutson","State":"CO","Gas":134,"coordinates":[-104.682,39.9411]},{"Plant":"Apex Generating Station","State":"NV","Gas":494.4,"coordinates":[-114.9609,36.416]},{"Plant":"Fayette Energy Facility","State":"PA","Gas":600.5,"coordinates":[-79.9182,39.8592]},{"Plant":"Wallingford Energy","State":"CT","Gas":190,"coordinates":[-72.8354,41.4487]},{"Plant":"High Desert Power Plant","State":"CA","Gas":780,"coordinates":[-117.3647,34.5953]},{"Plant":"AES Greystone","State":"TN","Gas":468,"coordinates":[-89.3937,35.6532]},{"Plant":"Sundance","State":"AZ","Gas":410,"coordinates":[-111.5899,32.9285]},{"Plant":"Indigo Energy Facility","State":"CA","Gas":149.7,"coordinates":[-116.553,33.9109]},{"Plant":"Hidalgo Energy Center","State":"TX","Gas":470,"coordinates":[-98.1758,26.3417]},{"Plant":"Perryville Power Station","State":"LA","Gas":718,"coordinates":[-92.0183,32.6908]},{"Plant":"West Valley Generation Project","State":"UT","Gas":202,"coordinates":[-112.0317,40.6667]},{"Plant":"University Park North","State":"IL","Gas":459.6,"coordinates":[-87.7514,41.4425]},{"Plant":"Riverside Energy Center","State":"WI","Gas":598.3,"coordinates":[-89.0355,42.5827]},{"Plant":"Blue Spruce Energy Center","State":"CO","Gas":276,"coordinates":[-104.6814,39.7479]},{"Plant":"Plains End","State":"CO","Gas":113,"coordinates":[-105.226,39.8575]},{"Plant":"Spring Creek Energy Center","State":"OK","Gas":280,"coordinates":[-97.655,35.7422]},{"Plant":"Pastoria Energy Facility, LLC","State":"CA","Gas":724,"coordinates":[-118.844,34.9556]},{"Plant":"EP Newington Energy LLC","State":"NH","Gas":525,"coordinates":[-70.8061,43.1047]},{"Plant":"Chehalis Generating Facility","State":"WA","Gas":495,"coordinates":[-122.9131,46.6225]},{"Plant":"Harrison County Power Project","State":"TX","Gas":484.5,"coordinates":[-94.4367,32.3958]},{"Plant":"Lower Mount Bethel Energy","State":"PA","Gas":593.8,"coordinates":[-75.1076,40.8019]},{"Plant":"AL Sandersville LLC","State":"GA","Gas":624,"coordinates":[-82.8608,33.1189]},{"Plant":"Higgins Generating Station","State":"NV","Gas":570,"coordinates":[-115.3561,35.6139]},{"Plant":"Bethlehem Power Plant","State":"PA","Gas":1092,"coordinates":[-75.3147,40.6175]},{"Plant":"Pierce Power Station","State":"WA","Gas":130.9,"coordinates":[-122.3758,47.1365]},{"Plant":"Choctaw County","State":"MS","Gas":726,"coordinates":[-89.4201,33.2881]},{"Plant":"Allegheny Energy Units 3 4 & 5","State":"PA","Gas":509,"coordinates":[-79.7686,40.5453]},{"Plant":"Magnet Cove","State":"AR","Gas":433.4,"coordinates":[-92.8317,34.4297]},{"Plant":"Dean","State":"MI","Gas":295.4,"coordinates":[-82.4953,42.7725]},{"Plant":"Hanging Rock Energy Facility","State":"OH","Gas":1288,"coordinates":[-82.7833,38.5731]},{"Plant":"Los Esteros Critical Energy Center","State":"CA","Gas":180,"coordinates":[-121.9319,37.425]},{"Plant":"FPL Energy Marcus Hook LP","State":"PA","Gas":713.5,"coordinates":[-75.4216,39.807]},{"Plant":"Gilroy Peaking Energy Center","State":"CA","Gas":128.3,"coordinates":[-121.5363,36.999]},{"Plant":"Frederickson Power LP","State":"WA","Gas":276.5,"coordinates":[-122.3657,47.0861]},{"Plant":"Curtis H Stanton Energy Center","State":"FL","Gas":591.93,"coordinates":[-81.1669,28.4882]},{"Plant":"Auburndale Peaker Energy Center","State":"FL","Gas":118,"coordinates":[-81.8059,28.0535]},{"Plant":"Rocky Mountain Energy Center","State":"CO","Gas":608,"coordinates":[-104.5953,40.0908]},{"Plant":"Silverhawk","State":"NV","Gas":560,"coordinates":[-114.9606,36.4078]},{"Plant":"Jasper","State":"SC","Gas":752.5,"coordinates":[-81.1242,32.3594]},{"Plant":"Tracy Combined Cycle Power Plant","State":"CA","Gas":164.08,"coordinates":[-121.4906,37.7107]},{"Plant":"NRG Rockford II Energy Center","State":"IL","Gas":157,"coordinates":[-89.1011,42.2383]},{"Plant":"NAEA Ocean Peaking Power LLC","State":"NJ","Gas":325.6,"coordinates":[-74.1672,40.0633]},{"Plant":"Las Vegas Cogeneration II LLC","State":"NV","Gas":220,"coordinates":[-115.1238,36.232]},{"Plant":"Wansley Combined Cycle","State":"GA","Gas":1129.18,"coordinates":[-85.037,33.4064]},{"Plant":"Cass County","State":"NE","Gas":320,"coordinates":[-95.964,40.9479]},{"Plant":"Hunterstown","State":"PA","Gas":810,"coordinates":[-77.1672,39.8725]},{"Plant":"Palomar Energy","State":"CA","Gas":284.6,"coordinates":[-117.1178,33.1197]},{"Plant":"Donald Von Raesfeld Power Plant","State":"CA","Gas":154,"coordinates":[-121.9508,37.3767]},{"Plant":"Fox Energy Center","State":"WI","Gas":425,"coordinates":[-88.2089,44.3204]},{"Plant":"Malburg","State":"CA","Gas":143,"coordinates":[-118.2219,33.9986]},{"Plant":"Bethlehem Energy Center","State":"NY","Gas":749.3,"coordinates":[-73.7831,42.6014]},{"Plant":"Magnolia Power Project","State":"CA","Gas":316,"coordinates":[-118.3153,34.1786]},{"Plant":"Currant Creek","State":"UT","Gas":282,"coordinates":[-111.8935,39.8214]},{"Plant":"Bennett Mountain","State":"ID","Gas":164,"coordinates":[-115.6657,43.1482]},{"Plant":"McIntosh Combined Cycle Facility","State":"GA","Gas":1184,"coordinates":[-81.1817,32.3478]},{"Plant":"South Harper","State":"MO","Gas":309.5,"coordinates":[-94.4824,38.6803]},{"Plant":"Faribault Energy Park","State":"MN","Gas":155,"coordinates":[-93.2906,44.3356]},{"Plant":"Sheboygan Falls","State":"WI","Gas":298.87,"coordinates":[-87.8781,43.7518]},{"Plant":"Nebo Power Station","State":"UT","Gas":120.4,"coordinates":[-111.7294,40.0614]},{"Plant":"500MW CC","State":"NY","Gas":454.08,"coordinates":[-73.9069,40.7889]},{"Plant":"EG178 Facility","State":"TX","Gas":101.3,"coordinates":[-100.9547,32.7471]},{"Plant":"Kings River","State":"CA","Gas":109,"coordinates":[-119.7404,36.6697]},{"Plant":"Olive","State":"CA","Gas":152.5,"coordinates":[-118.3147,34.1764]},{"Plant":"Collins","State":"IL","Gas":2671,"coordinates":[-88.3928,41.3461]},{"Plant":"Belle River","State":"MI","Gas":225,"coordinates":[-82.495,42.7756]},{"Plant":"Greenwood","State":"MI","Gas":225,"coordinates":[-82.6964,43.1056]},{"Plant":"Manatee","State":"FL","Gas":1107,"coordinates":[-82.3456,27.6058]},{"Plant":"Martin","State":"FL","Gas":3693,"coordinates":[-80.5628,27.0536]},{"Plant":"DeBary","State":"FL","Gas":258,"coordinates":[-81.3323,28.9039]},{"Plant":"Electrifarm","State":"IA","Gas":199.8,"coordinates":[-92.4205,42.4407]},{"Plant":"Fredonia","State":"WA","Gas":299,"coordinates":[-122.4358,48.4558]},{"Plant":"Trimble County","State":"KY","Gas":960,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Gas":946,"coordinates":[-88.5553,30.5322]},{"Plant":"Greenwood","State":"MO","Gas":242,"coordinates":[-94.2982,38.8615]},{"Plant":"R M Schahfer","State":"IN","Gas":155,"coordinates":[-87.0261,41.2164]},{"Plant":"Cutler","State":"FL","Gas":206,"coordinates":[-80.2989,25.6321]},{"Plant":"Fort St Vrain","State":"CO","Gas":690,"coordinates":[-104.8742,40.2461]},{"Plant":"Fort Myers","State":"FL","Gas":1767,"coordinates":[-81.7831,26.6967]},{"Plant":"Whitehorn","State":"WA","Gas":158,"coordinates":[-122.6861,48.8288]},{"Plant":"McIntosh","State":"GA","Gas":657.6,"coordinates":[-81.1683,32.3563]},{"Plant":"Lauderdale","State":"FL","Gas":1699,"coordinates":[-80.1984,26.0686]},{"Plant":"A B Brown","State":"IN","Gas":160,"coordinates":[-87.715,37.9053]},{"Plant":"Port Everglades","State":"FL","Gas":420,"coordinates":[-80.1253,26.0856]},{"Plant":"Brame Energy Center","State":"LA","Gas":440,"coordinates":[-92.7167,31.395]},{"Plant":"John Twitty Energy Center","State":"MO","Gas":104,"coordinates":[-93.388,37.1517]},{"Plant":"Sanford","State":"FL","Gas":1889,"coordinates":[-81.3256,28.8419]},{"Plant":"Empire Energy Center","State":"MO","Gas":271,"coordinates":[-94.1041,37.1385]},{"Plant":"Dansby","State":"TX","Gas":151.7,"coordinates":[-96.4608,30.7217]},{"Plant":"Putnam","State":"FL","Gas":498,"coordinates":[-81.5851,29.6283]},{"Plant":"Higgins","State":"FL","Gas":122,"coordinates":[-82.6615,28.0033]},{"Plant":"Rokeby","State":"NE","Gas":245.8,"coordinates":[-96.7364,40.7316]},{"Plant":"Suwannee River","State":"FL","Gas":110,"coordinates":[-83.1806,30.3764]},{"Plant":"Lansing Smith","State":"FL","Gas":481,"coordinates":[-85.7003,30.2686]},{"Plant":"D G Hunter","State":"LA","Gas":157,"coordinates":[-92.4613,31.3207]},{"Plant":"George M Sullivan Generation Plant 2","State":"AK","Gas":219.9,"coordinates":[-149.7167,61.2297]},{"Plant":"Henry D King","State":"FL","Gas":129.4,"coordinates":[-80.3386,27.4486]},{"Plant":"Deerhaven Generating Station","State":"FL","Gas":194,"coordinates":[-82.3878,29.7592]},{"Plant":"John R Kelly","State":"FL","Gas":191,"coordinates":[-82.3208,29.6461]},{"Plant":"J D Kennedy","State":"FL","Gas":158.6,"coordinates":[-81.626,30.3648]},{"Plant":"Larsen Memorial","State":"FL","Gas":195,"coordinates":[-81.9228,28.0797]},{"Plant":"C D McIntosh Jr","State":"FL","Gas":532,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Gas":264,"coordinates":[-105.0212,40.8609]},{"Plant":"Indian River Plant","State":"FL","Gas":290,"coordinates":[-80.7801,28.4932]},{"Plant":"Arvah B Hopkins","State":"FL","Gas":432,"coordinates":[-84.4,30.4522]},{"Plant":"S O Purdom","State":"FL","Gas":301,"coordinates":[-84.2007,30.1623]},{"Plant":"Vero Beach Municipal Power Plant","State":"FL","Gas":150,"coordinates":[-80.3776,27.6334]},{"Plant":"Atkinson","State":"GA","Gas":182,"coordinates":[-84.4803,33.8175]},{"Plant":"Gravel Neck","State":"VA","Gas":292,"coordinates":[-76.6911,37.1575]},{"Plant":"McIntosh","State":"AL","Gas":338,"coordinates":[-88.0299,31.2546]},{"Plant":"Pleasant Hill","State":"IA","Gas":163,"coordinates":[-93.5242,41.5572]},{"Plant":"Hay Road","State":"DE","Gas":1087.5,"coordinates":[-75.5072,39.7436]},{"Plant":"Woodsdale","State":"OH","Gas":462,"coordinates":[-84.4611,39.4492]},{"Plant":"Concord","State":"WI","Gas":376,"coordinates":[-88.69,43.1669]},{"Plant":"South Fond Du Lac","State":"WI","Gas":323.76,"coordinates":[-88.4967,43.7353]},{"Plant":"Darbytown","State":"VA","Gas":288,"coordinates":[-77.3685,37.4982]},{"Plant":"Angus Anson","State":"SD","Gas":383.8,"coordinates":[-96.6356,43.6035]},{"Plant":"Cane Island","State":"FL","Gas":380,"coordinates":[-81.533,28.2764]},{"Plant":"Polk","State":"FL","Gas":325,"coordinates":[-81.9897,27.7286]},{"Plant":"Woodland","State":"CA","Gas":133,"coordinates":[-121.0204,37.6526]},{"Plant":"491 E 48th Street","State":"MI","Gas":148.2,"coordinates":[-86.0853,42.7553]},{"Plant":"Paris","State":"WI","Gas":400,"coordinates":[-88.0131,42.6658]},{"Plant":"Lincoln Combustion","State":"NC","Gas":1267.2,"coordinates":[-81.0347,35.4317]},{"Plant":"State Line Combined Cycle","State":"MO","Gas":589,"coordinates":[-94.614,37.0659]},{"Plant":"Hines Energy Complex","State":"FL","Gas":1514,"coordinates":[-81.87,27.7882]},{"Plant":"Redding Power","State":"CA","Gas":133.6,"coordinates":[-122.4233,40.5073]},{"Plant":"San Jacinto Steam Electric Station","State":"TX","Gas":162,"coordinates":[-95.0406,29.6948]},{"Plant":"Kraft","State":"GA","Gas":132,"coordinates":[-81.1458,32.1486]},{"Plant":"Anderson","State":"IN","Gas":142,"coordinates":[-85.7389,40.0529]},{"Plant":"Riverside","State":"GA","Gas":107,"coordinates":[-81.0956,32.0836]},{"Plant":"Robins","State":"GA","Gas":160,"coordinates":[-83.5822,32.5792]},{"Plant":"Coyote Springs","State":"OR","Gas":218.6,"coordinates":[-119.6739,45.848]},{"Plant":"Midulla Generating Station","State":"FL","Gas":488,"coordinates":[-81.9625,27.6417]},{"Plant":"Interstate","State":"IL","Gas":128,"coordinates":[-89.5891,39.8233]},{"Plant":"Rathdrum","State":"ID","Gas":136,"coordinates":[-116.8673,47.8043]},{"Plant":"Arthur Von Rosenberg","State":"TX","Gas":482,"coordinates":[-98.384,29.257]},{"Plant":"Carson Ice-Gen Project","State":"CA","Gas":101,"coordinates":[-121.4624,38.4457]},{"Plant":"Wayne County","State":"NC","Gas":668,"coordinates":[-78.0981,35.3758]},{"Plant":"Ponca City","State":"OK","Gas":105,"coordinates":[-97.0858,36.7198]},{"Plant":"SCA Cogen 2","State":"CA","Gas":154.6,"coordinates":[-121.4001,38.5309]},{"Plant":"SPA Cogen 3","State":"CA","Gas":164,"coordinates":[-121.4735,38.511]},{"Plant":"St Francis Energy Facility","State":"MO","Gas":473,"coordinates":[-90.1779,36.5852]},{"Plant":"River Road Gen Plant","State":"WA","Gas":220,"coordinates":[-122.7256,45.6497]},{"Plant":"Tiger Bay","State":"FL","Gas":207,"coordinates":[-81.8494,27.7464]},{"Plant":"Dahlberg","State":"GA","Gas":750,"coordinates":[-83.3977,34.0423]},{"Plant":"H Allen Franklin Combined Cycle","State":"AL","Gas":1186,"coordinates":[-85.0975,32.6078]},{"Plant":"Theodore Cogen Facility","State":"AL","Gas":224.7,"coordinates":[-88.1285,30.5254]},{"Plant":"Essex","State":"MO","Gas":107.4,"coordinates":[-89.8402,36.8682]},{"Plant":"Nodaway","State":"MO","Gas":182.8,"coordinates":[-94.7913,40.2877]},{"Plant":"Chouteau","State":"OK","Gas":495,"coordinates":[-95.2771,36.2221]},{"Plant":"Georgetown","State":"IN","Gas":295,"coordinates":[-86.2441,39.9026]},{"Plant":"Tilton","State":"IL","Gas":176,"coordinates":[-87.6538,40.1061]},{"Plant":"Henry County","State":"IN","Gas":135.5,"coordinates":[-85.5039,39.9528]},{"Plant":"MPC Generating","State":"GA","Gas":315.12,"coordinates":[-83.6953,33.8119]},{"Plant":"Sherwood H Smith Jr Energy Complex","State":"NC","Gas":1247,"coordinates":[-79.7406,34.8392]},{"Plant":"Sewell Creek Energy","State":"GA","Gas":506.5,"coordinates":[-85.2769,33.9486]},{"Plant":"Alsey","State":"IL","Gas":121,"coordinates":[-90.436,39.5698]},{"Plant":"Fulton","State":"AR","Gas":153,"coordinates":[-93.7924,33.6094]},{"Plant":"Rowan","State":"NC","Gas":977.01,"coordinates":[-80.6019,35.7314]},{"Plant":"Smarr Energy Center","State":"GA","Gas":219.5,"coordinates":[-83.8464,32.9842]},{"Plant":"John S Rainey","State":"SC","Gas":958.2,"coordinates":[-82.776,34.3477]},{"Plant":"Essential Power Rock Springs LLC","State":"MD","Gas":632.2,"coordinates":[-76.1598,39.719]},{"Plant":"Marsh Run Generating","State":"VA","Gas":469.5,"coordinates":[-77.7681,38.5283]},{"Plant":"Louisa Generating","State":"VA","Gas":458.5,"coordinates":[-78.2139,38.1181]},{"Plant":"Remington","State":"VA","Gas":580,"coordinates":[-77.7714,38.5442]},{"Plant":"Ladysmith","State":"VA","Gas":290,"coordinates":[-77.5133,38.0722]},{"Plant":"Pleasant Valley","State":"MN","Gas":424.3,"coordinates":[-92.6829,43.7994]},{"Plant":"Lagoon Creek","State":"TN","Gas":940.8,"coordinates":[-89.3964,35.6578]},{"Plant":"Brandy Branch","State":"FL","Gas":660.8,"coordinates":[-81.9472,30.3206]},{"Plant":"Holden","State":"MO","Gas":232.8,"coordinates":[-93.9983,38.7538]},{"Plant":"MEPI GT Facility","State":"IL","Gas":239,"coordinates":[-88.8661,37.2175]},{"Plant":"Encogen","State":"WA","Gas":170,"coordinates":[-122.486,48.746]},{"Plant":"Robert P Mone Plant","State":"OH","Gas":447,"coordinates":[-84.7392,40.9297]},{"Plant":"H L Culbreath Bayside Power Station","State":"FL","Gas":1632,"coordinates":[-82.4231,27.9072]},{"Plant":"Terry Bundy Generating Station","State":"NE","Gas":169.9,"coordinates":[-96.6131,40.9097]},{"Plant":"E B Harris Electric Generating Plant","State":"AL","Gas":1253.7,"coordinates":[-86.5744,32.3814]},{"Plant":"Sand Hill","State":"TX","Gas":501.2,"coordinates":[-97.6129,30.2098]},{"Plant":"Talbot County Energy","State":"GA","Gas":676.5,"coordinates":[-84.6917,32.5892]},{"Plant":"Chattahoochee Energy Facility","State":"GA","Gas":465,"coordinates":[-85.0386,33.4072]},{"Plant":"Lakefield Junction","State":"MN","Gas":512.8,"coordinates":[-94.8415,43.7984]},{"Plant":"West Gardner","State":"KS","Gas":308,"coordinates":[-94.9861,38.7875]},{"Plant":"Coyote Springs II","State":"OR","Gas":244,"coordinates":[-119.674,45.848]},{"Plant":"Wansley Unit 9","State":"GA","Gas":504.4,"coordinates":[-85.0403,33.4083]},{"Plant":"Lawrence County Station","State":"IN","Gas":261,"coordinates":[-86.4511,38.8003]},{"Plant":"Kemper County","State":"MS","Gas":312.8,"coordinates":[-88.606,32.7976]},{"Plant":"Peno Creek","State":"MO","Gas":188,"coordinates":[-91.2295,39.3531]},{"Plant":"Sumpter","State":"MI","Gas":296,"coordinates":[-83.5318,42.167]},{"Plant":"Pyramid","State":"NM","Gas":158,"coordinates":[-108.5494,32.2363]},{"Plant":"Mill Creek","State":"SC","Gas":595.36,"coordinates":[-81.4306,35.1597]},{"Plant":"Greater Des Moines","State":"IA","Gas":491,"coordinates":[-93.5283,41.5563]},{"Plant":"Silver Creek","State":"MS","Gas":221,"coordinates":[-89.9468,31.6004]},{"Plant":"Sylvarena","State":"MS","Gas":129,"coordinates":[-89.4127,31.9821]},{"Plant":"West Campus Cogeneration Facility","State":"WI","Gas":130.2,"coordinates":[-89.4251,43.0751]},{"Plant":"Beatrice","State":"NE","Gas":237,"coordinates":[-96.8082,40.3302]},{"Plant":"Murray Turbine","State":"UT","Gas":159,"coordinates":[-111.89,40.67]},{"Plant":"Blue Lake","State":"MN","Gas":315.8,"coordinates":[-93.4315,44.7855]},{"Plant":"Sycamore","State":"IA","Gas":149,"coordinates":[-93.6769,41.6722]},{"Plant":"Emery Station","State":"IA","Gas":555.5,"coordinates":[-93.2922,43.094]},{"Plant":"Intercession City","State":"FL","Gas":604,"coordinates":[-81.5486,28.2628]},{"Plant":"Gerald Andrus","State":"MS","Gas":741,"coordinates":[-91.1167,33.35]},{"Plant":"Waterford 1 & 2","State":"LA","Gas":822,"coordinates":[-90.4768,29.9989]},{"Plant":"Comanche","State":"OK","Gas":273,"coordinates":[-98.3244,34.5431]},{"Plant":"DeCordova Steam Electric Station","State":"TX","Gas":1138,"coordinates":[-97.7006,32.4031]},{"Plant":"Santan","State":"AZ","Gas":918,"coordinates":[-111.7503,33.3325]},{"Plant":"Beaver","State":"OR","Gas":494.8,"coordinates":[-123.1739,46.1724]},{"Plant":"Glen Gardner","State":"NJ","Gas":160,"coordinates":[-74.9207,40.6815]},{"Plant":"Grand Tower","State":"IL","Gas":516,"coordinates":[-89.5112,37.6577]},{"Plant":"Calumet","State":"IL","Gas":203.9,"coordinates":[-87.5428,41.7136]},{"Plant":"Crawford","State":"IL","Gas":172.8,"coordinates":[-87.7229,41.8285]},{"Plant":"Electric Junction","State":"IL","Gas":217.4,"coordinates":[-88.0833,41.8333]},{"Plant":"Joliet 9","State":"IL","Gas":115.1,"coordinates":[-88.1153,41.4931]},{"Plant":"Astoria Generating Station","State":"NY","Gas":192,"coordinates":[-73.9126,40.7877]},{"Plant":"Wood River","State":"IL","Gas":129.9,"coordinates":[-90.1347,38.8639]},{"Plant":"Venice","State":"IL","Gas":503,"coordinates":[-90.1764,38.6642]},{"Plant":"Beluga","State":"AK","Gas":344.4,"coordinates":[-151.0356,61.1861]},{"Plant":"Marion","State":"IL","Gas":140,"coordinates":[-88.9531,37.6197]},{"Plant":"Frederickson","State":"WA","Gas":136,"coordinates":[-122.365,47.0797]},{"Plant":"Harding Street","State":"IN","Gas":322,"coordinates":[-86.1969,39.7113]},{"Plant":"Dean H Mitchell","State":"IN","Gas":142,"coordinates":[-87.4069,41.6392]},{"Plant":"Michigan City","State":"IN","Gas":120,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Gas":740,"coordinates":[-87.7811,32.6017]},{"Plant":"NRG Energy Center Dover","State":"DE","Gas":104.4,"coordinates":[-75.5473,39.1495]},{"Plant":"Gilroy Power Plant","State":"CA","Gas":130,"coordinates":[-121.5367,37.0001]},{"Plant":"Noblesville","State":"IN","Gas":285.9,"coordinates":[-85.9714,40.0969]},{"Plant":"Pedricktown Cogeneration Company LP","State":"NJ","Gas":115.7,"coordinates":[-75.4238,39.7668]},{"Plant":"Broadway","State":"IN","Gas":115,"coordinates":[-87.6049,37.9691]},{"Plant":"Butler-Warner Generation Plant","State":"NC","Gas":225,"coordinates":[-78.8294,35.0986]},{"Plant":"El Segundo Cogen","State":"CA","Gas":127.7,"coordinates":[-118.4031,33.9058]},{"Plant":"ArcelorMittal Burns Harbor","State":"IN","Gas":177.7,"coordinates":[-87.1387,41.635]},{"Plant":"King City Power Plant","State":"CA","Gas":111,"coordinates":[-121.1278,36.225]},{"Plant":"Bayou Cogen Plant","State":"TX","Gas":260,"coordinates":[-95.0458,29.6225]},{"Plant":"Bellingham Cogeneration Facility","State":"MA","Gas":264,"coordinates":[-71.4833,42.0925]},{"Plant":"Sayreville Cogeneration Facility","State":"NJ","Gas":271,"coordinates":[-74.3444,40.439]},{"Plant":"Foster Wheeler Martinez","State":"CA","Gas":103.5,"coordinates":[-122.0589,38.0244]},{"Plant":"ExxonMobil Baytown Refinery","State":"TX","Gas":183.82,"coordinates":[-94.9973,29.7535]},{"Plant":"RG Steel Sparrows Point, LLC","State":"MD","Gas":152.3,"coordinates":[-76.4729,39.213]},{"Plant":"Kern River Cogeneration","State":"CA","Gas":288,"coordinates":[-118.9849,35.4515]},{"Plant":"Formosa Utility Venture Ltd","State":"TX","Gas":597.3,"coordinates":[-96.5417,28.6917]},{"Plant":"Hopewell Cogeneration","State":"VA","Gas":348.3,"coordinates":[-77.2811,37.2917]},{"Plant":"CES Placerita Power Plant","State":"CA","Gas":115,"coordinates":[-118.4999,34.3801]},{"Plant":"ExxonMobil Baytown Turbine","State":"TX","Gas":320.38,"coordinates":[-95.0096,29.7591]},{"Plant":"Selkirk Cogen","State":"NY","Gas":365.6,"coordinates":[-73.8592,42.5744]},{"Plant":"Masspower","State":"MA","Gas":238.3,"coordinates":[-72.5225,42.1575]},{"Plant":"Clear Lake Cogeneration Ltd","State":"TX","Gas":366,"coordinates":[-95.067,29.6255]},{"Plant":"Midland Cogeneration Venture","State":"MI","Gas":1827.4,"coordinates":[-84.2242,43.5861]},{"Plant":"Camden Plant Holding LLC","State":"NJ","Gas":148.5,"coordinates":[-75.1192,39.9175]},{"Plant":"River Hills","State":"IA","Gas":120,"coordinates":[-93.6195,41.5902]},{"Plant":"Hazelton","State":"PA","Gas":147.2,"coordinates":[-76.0409,40.9282]},{"Plant":"Ocotillo","State":"AZ","Gas":320,"coordinates":[-111.9122,33.4225]},{"Plant":"West Phoenix","State":"AZ","Gas":1047.3,"coordinates":[-112.1583,33.4417]},{"Plant":"Saguaro","State":"AZ","Gas":386,"coordinates":[-111.3,32.5517]},{"Plant":"Yucca","State":"AZ","Gas":163,"coordinates":[-114.7106,32.7214]},{"Plant":"Fort Dodge","State":"KS","Gas":142.3,"coordinates":[-99.9497,37.7328]},{"Plant":"Gordon Evans Energy Center","State":"KS","Gas":823,"coordinates":[-97.5217,37.7903]},{"Plant":"Murray Gill","State":"KS","Gas":317,"coordinates":[-97.4136,37.5967]},{"Plant":"Hutchinson Energy Center","State":"KS","Gas":394,"coordinates":[-97.8747,38.0906]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Gas":316,"coordinates":[-110.9047,32.16]},{"Plant":"Kaw","State":"KS","Gas":140.3,"coordinates":[-94.6514,39.0867]},{"Plant":"McPherson 2","State":"KS","Gas":131.5,"coordinates":[-97.6834,38.3634]},{"Plant":"Garden City","State":"KS","Gas":227.2,"coordinates":[-100.8956,37.9703]},{"Plant":"E W Brown","State":"KY","Gas":849,"coordinates":[-84.7126,37.7883]},{"Plant":"Paddys Run","State":"KY","Gas":193,"coordinates":[-85.8417,38.2236]},{"Plant":"Louisiana 1","State":"LA","Gas":382.4,"coordinates":[-91.1864,30.4922]},{"Plant":"Louisiana 2","State":"LA","Gas":138,"coordinates":[-91.1864,30.4922]},{"Plant":"R S Nelson","State":"LA","Gas":653,"coordinates":[-93.2911,30.2844]},{"Plant":"Willow Glen","State":"LA","Gas":2045,"coordinates":[-91.1164,30.2743]},{"Plant":"Coughlin Power Station","State":"LA","Gas":743,"coordinates":[-92.2611,30.8439]},{"Plant":"Teche","State":"LA","Gas":430,"coordinates":[-91.5425,29.8222]},{"Plant":"Little Gypsy","State":"LA","Gas":1204,"coordinates":[-90.4617,30.0051]},{"Plant":"Nine Mile Point","State":"LA","Gas":1804,"coordinates":[-90.1458,29.9472]},{"Plant":"Sterlington","State":"LA","Gas":408,"coordinates":[-92.0792,32.7047]},{"Plant":"A B Paterson","State":"LA","Gas":112,"coordinates":[-90.0256,30.0158]},{"Plant":"Michoud","State":"LA","Gas":860,"coordinates":[-89.9372,30.0081]},{"Plant":"Agua Fria","State":"AZ","Gas":626,"coordinates":[-112.2153,33.5561]},{"Plant":"Arsenal Hill","State":"LA","Gas":110,"coordinates":[-93.7611,32.5181]},{"Plant":"Lieberman","State":"LA","Gas":268,"coordinates":[-93.9597,32.7047]},{"Plant":"Louis Doc Bonin","State":"LA","Gas":302,"coordinates":[-92.0463,30.238]},{"Plant":"Monroe","State":"LA","Gas":126,"coordinates":[-92.1794,32.5233]},{"Plant":"Big Cajun 1","State":"LA","Gas":430,"coordinates":[-91.3556,30.6739]},{"Plant":"Kyrene","State":"AZ","Gas":525,"coordinates":[-111.9353,33.3556]},{"Plant":"Notch Cliff","State":"MD","Gas":128,"coordinates":[-76.5087,39.4217]},{"Plant":"Perryman","State":"MD","Gas":152,"coordinates":[-76.2218,39.4428]},{"Plant":"Riverside","State":"MD","Gas":205,"coordinates":[-76.5133,39.2369]},{"Plant":"Westport","State":"MD","Gas":121,"coordinates":[-76.6295,39.266]},{"Plant":"Dickerson","State":"MD","Gas":294,"coordinates":[-77.4644,39.2097]},{"Plant":"Mystic Generating Station","State":"MA","Gas":1940.18,"coordinates":[-71.0675,42.3908]},{"Plant":"New Boston Generating Station","State":"MA","Gas":702,"coordinates":[-71.0353,42.3392]},{"Plant":"Kendall Square Station","State":"MA","Gas":207.69,"coordinates":[-71.0792,42.3633]},{"Plant":"Apache Station","State":"AZ","Gas":198.5,"coordinates":[-109.8931,32.0603]},{"Plant":"Cecil Lynch","State":"AR","Gas":204,"coordinates":[-92.1987,34.7535]},{"Plant":"Hamilton Moses","State":"AR","Gas":144,"coordinates":[-90.8722,34.9806]},{"Plant":"Harvey Couch","State":"AR","Gas":161,"coordinates":[-93.4649,33.3592]},{"Plant":"B C Cobb","State":"MI","Gas":187,"coordinates":[-86.2423,43.2588]},{"Plant":"Lake Catherine","State":"AR","Gas":751,"coordinates":[-92.9049,34.4341]},{"Plant":"Dan E Karn","State":"MI","Gas":1276,"coordinates":[-83.8401,43.645]},{"Plant":"Thetford","State":"MI","Gas":192,"coordinates":[-83.6286,43.1567]},{"Plant":"Conners Creek","State":"MI","Gas":230,"coordinates":[-82.9597,42.3592]},{"Plant":"Delray","State":"MI","Gas":127,"coordinates":[-83.1019,42.2947]},{"Plant":"Robert E Ritchie","State":"AR","Gas":918,"coordinates":[-90.5987,34.4629]},{"Plant":"Hancock","State":"MI","Gas":141,"coordinates":[-83.4425,42.5497]},{"Plant":"River Rouge","State":"MI","Gas":234,"coordinates":[-83.1119,42.2739]},{"Plant":"Mistersky","State":"MI","Gas":154,"coordinates":[-83.0903,42.3039]},{"Plant":"Fox Lake","State":"MN","Gas":109.1,"coordinates":[-94.7075,43.6728]},{"Plant":"Black Dog","State":"MN","Gas":297.8,"coordinates":[-93.2501,44.8108]},{"Plant":"Inver Hills","State":"MN","Gas":350.05,"coordinates":[-93.042,44.781]},{"Plant":"Thomas Fitzhugh","State":"AR","Gas":171,"coordinates":[-93.8049,35.4624]},{"Plant":"Carl Bailey","State":"AR","Gas":122,"coordinates":[-91.3634,35.2601]},{"Plant":"McClellan","State":"AR","Gas":134,"coordinates":[-92.7917,33.5648]},{"Plant":"Chevron Oil","State":"MS","Gas":127,"coordinates":[-88.4919,30.34]},{"Plant":"Sweatt","State":"MS","Gas":124,"coordinates":[-88.7461,32.2925]},{"Plant":"Jack Watson","State":"MS","Gas":292,"coordinates":[-89.0286,30.4392]},{"Plant":"Baxter Wilson","State":"MS","Gas":1246,"coordinates":[-90.9306,32.2831]},{"Plant":"Delta","State":"MS","Gas":207,"coordinates":[-90.7139,33.7947]},{"Plant":"Rex Brown","State":"MS","Gas":304,"coordinates":[-90.213,32.357]},{"Plant":"Moselle","State":"MS","Gas":327,"coordinates":[-89.3004,31.528]},{"Plant":"Hawthorn","State":"MO","Gas":420,"coordinates":[-94.4778,39.1306]},{"Plant":"Lake Road","State":"MO","Gas":128.7,"coordinates":[-94.8773,39.7246]},{"Plant":"James River Power Station","State":"MO","Gas":155,"coordinates":[-93.2619,37.1086]},{"Plant":"Canaday","State":"NE","Gas":117.95,"coordinates":[-99.7011,40.6942]},{"Plant":"C W Burdick","State":"NE","Gas":193.99,"coordinates":[-98.3269,40.9228]},{"Plant":"Contra Costa","State":"CA","Gas":672,"coordinates":[-121.7642,38.0192]},{"Plant":"Clark","State":"NV","Gas":700,"coordinates":[-115.0507,36.0875]},{"Plant":"Sunrise","State":"NV","Gas":149,"coordinates":[-115.036,36.1384]},{"Plant":"Fort Churchill","State":"NV","Gas":226,"coordinates":[-119.1322,39.1281]},{"Plant":"Tracy","State":"NV","Gas":480,"coordinates":[-119.525,39.5625]},{"Plant":"Deepwater","State":"NJ","Gas":105,"coordinates":[-75.5083,39.6831]},{"Plant":"Sayreville","State":"NJ","Gas":343,"coordinates":[-74.3523,40.4765]},{"Plant":"Gilbert","State":"NJ","Gas":540,"coordinates":[-75.1639,40.5658]},{"Plant":"Bergen Generating Station","State":"NJ","Gas":1246,"coordinates":[-74.0244,40.8375]},{"Plant":"PSEG Burlington Generating Station","State":"NJ","Gas":413,"coordinates":[-74.8792,40.0766]},{"Plant":"PSEG Edison Generating Station","State":"NJ","Gas":504,"coordinates":[-74.3956,40.4911]},{"Plant":"PSEG Essex Generating Station","State":"NJ","Gas":617,"coordinates":[-74.1206,40.7372]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Gas":383,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Kearny Generating Station","State":"NJ","Gas":640,"coordinates":[-74.0965,40.7373]},{"Plant":"PSEG Linden Generating Station","State":"NJ","Gas":1547,"coordinates":[-74.2072,40.6217]},{"Plant":"PSEG Sewaren Generating Station","State":"NJ","Gas":453,"coordinates":[-74.2469,40.5558]},{"Plant":"Rio Grande","State":"NM","Gas":229,"coordinates":[-106.5472,31.8047]},{"Plant":"Maddox","State":"NM","Gas":179,"coordinates":[-103.3015,32.7142]},{"Plant":"Reeves","State":"NM","Gas":154,"coordinates":[-106.6019,35.171]},{"Plant":"Cunningham","State":"NM","Gas":485,"coordinates":[-103.3533,32.7131]},{"Plant":"Humboldt Bay","State":"CA","Gas":105,"coordinates":[-124.2103,40.7415]},{"Plant":"Hunters Point","State":"CA","Gas":377,"coordinates":[-122.3897,37.7336]},{"Plant":"Arthur Kill Generating Station","State":"NY","Gas":841,"coordinates":[-74.2,40.5916]},{"Plant":"East River","State":"NY","Gas":297.4,"coordinates":[-73.9742,40.7281]},{"Plant":"Gowanus Gas Turbines Generating","State":"NY","Gas":283,"coordinates":[-74.0051,40.6635]},{"Plant":"Narrows Gas Turbines Generating","State":"NY","Gas":280,"coordinates":[-74.0208,40.6486]},{"Plant":"Ravenswood","State":"NY","Gas":2323.8,"coordinates":[-73.9461,40.7592]},{"Plant":"E F Barrett","State":"NY","Gas":689.7,"coordinates":[-73.6479,40.6167]},{"Plant":"Far Rockaway","State":"NY","Gas":110.6,"coordinates":[-73.761,40.6109]},{"Plant":"Glenwood","State":"NY","Gas":238.7,"coordinates":[-73.6475,40.8271]},{"Plant":"Northport","State":"NY","Gas":1551.7,"coordinates":[-73.3423,40.9236]},{"Plant":"Port Jefferson","State":"NY","Gas":462.4,"coordinates":[-73.0785,40.9497]},{"Plant":"Bethlehem Energy Center","State":"NY","Gas":1114.3,"coordinates":[-73.7638,42.5942]},{"Plant":"Dynegy Morro Bay LLC","State":"CA","Gas":999,"coordinates":[-120.8566,35.3722]},{"Plant":"Dynegy Moss Landing Power Plant","State":"CA","Gas":2498,"coordinates":[-121.7822,36.8048]},{"Plant":"Bowline Point","State":"NY","Gas":1139,"coordinates":[-73.9689,41.2044]},{"Plant":"Asheville","State":"NC","Gas":328,"coordinates":[-82.5417,35.4731]},{"Plant":"Pittsburg Power","State":"CA","Gas":1906,"coordinates":[-121.8945,38.0392]},{"Plant":"Potrero Power","State":"CA","Gas":206,"coordinates":[-122.387,37.7566]},{"Plant":"Riverbend","State":"NC","Gas":120,"coordinates":[-80.9742,35.36]},{"Plant":"Dicks Creek","State":"OH","Gas":106.2,"coordinates":[-84.3778,39.465]},{"Plant":"Frank M Tait","State":"OH","Gas":256,"coordinates":[-84.2111,39.7272]},{"Plant":"Yankee Street","State":"OH","Gas":107,"coordinates":[-84.2047,39.603]},{"Plant":"FirstEnergy West Lorain","State":"OH","Gas":370,"coordinates":[-82.2644,41.4294]},{"Plant":"Richland","State":"OH","Gas":358,"coordinates":[-84.3346,41.3052]},{"Plant":"Horseshoe Lake","State":"OK","Gas":881,"coordinates":[-97.1797,35.5087]},{"Plant":"Muskogee","State":"OK","Gas":166,"coordinates":[-95.2873,35.7614]},{"Plant":"Mustang","State":"OK","Gas":537.5,"coordinates":[-97.675,35.4699]},{"Plant":"Seminole","State":"OK","Gas":1541.5,"coordinates":[-96.7258,34.9665]},{"Plant":"Northeastern","State":"OK","Gas":877,"coordinates":[-95.7008,36.4317]},{"Plant":"Southwestern","State":"OK","Gas":467,"coordinates":[-98.3524,35.1009]},{"Plant":"Tulsa","State":"OK","Gas":396,"coordinates":[-95.991,36.1165]},{"Plant":"Weleetka","State":"OK","Gas":160,"coordinates":[-96.1352,35.3233]},{"Plant":"Barry","State":"AL","Gas":805,"coordinates":[-88.0103,31.0069]},{"Plant":"Anadarko Plant","State":"OK","Gas":350,"coordinates":[-98.23,35.0847]},{"Plant":"Mooreland","State":"OK","Gas":322,"coordinates":[-99.2254,36.4372]},{"Plant":"Encina","State":"CA","Gas":958,"coordinates":[-117.3364,33.1361]},{"Plant":"Kearny","State":"CA","Gas":127,"coordinates":[-117.1338,32.834]},{"Plant":"Brunot Island","State":"PA","Gas":278,"coordinates":[-80.0438,40.4649]},{"Plant":"Dynegy South Bay Power Plant","State":"CA","Gas":693,"coordinates":[-117.092,32.6114]},{"Plant":"AES Alamitos LLC","State":"CA","Gas":2130,"coordinates":[-118.1009,33.7688]},{"Plant":"Manchester Street","State":"RI","Gas":447,"coordinates":[-71.4042,41.8167]},{"Plant":"Darlington County","State":"SC","Gas":444,"coordinates":[-80.1657,34.4185]},{"Plant":"Buzzard Roost","State":"SC","Gas":196,"coordinates":[-81.9025,34.1692]},{"Plant":"Coolwater","State":"CA","Gas":608,"coordinates":[-116.8539,34.8606]},{"Plant":"Urquhart","State":"SC","Gas":559,"coordinates":[-81.9111,33.435]},{"Plant":"El Segundo Power","State":"CA","Gas":940.54,"coordinates":[-118.4242,33.9098]},{"Plant":"Etiwanda Generating Station","State":"CA","Gas":1019,"coordinates":[-117.5266,34.0912]},{"Plant":"Riverside Canal Power","State":"CA","Gas":127,"coordinates":[-117.3312,34.0229]},{"Plant":"AES Huntington Beach LLC","State":"CA","Gas":1036.6,"coordinates":[-117.9792,33.6439]},{"Plant":"Allen Steam Plant","State":"TN","Gas":461.6,"coordinates":[-90.1487,35.0741]},{"Plant":"Gallatin","State":"TN","Gas":599.2,"coordinates":[-86.4006,36.3156]},{"Plant":"Johnsonville","State":"TN","Gas":1135.2,"coordinates":[-87.9861,36.0278]},{"Plant":"Long Beach Generation LLC","State":"CA","Gas":584,"coordinates":[-118.2248,33.7641]},{"Plant":"E S Joslin","State":"TX","Gas":254,"coordinates":[-96.5458,28.6472]},{"Plant":"J L Bates","State":"TX","Gas":182,"coordinates":[-98.3944,26.2222]},{"Plant":"Laredo","State":"TX","Gas":171,"coordinates":[-99.5089,27.5667]},{"Plant":"Lon C Hill","State":"TX","Gas":559,"coordinates":[-97.6167,27.85]},{"Plant":"Nueces Bay","State":"TX","Gas":559,"coordinates":[-97.4192,27.8194]},{"Plant":"La Palma","State":"TX","Gas":255,"coordinates":[-97.6389,26.1331]},{"Plant":"Victoria","State":"TX","Gas":491,"coordinates":[-97.01,28.7883]},{"Plant":"Mandalay","State":"CA","Gas":560,"coordinates":[-119.2511,34.2067]},{"Plant":"Lake Hubbard","State":"TX","Gas":921,"coordinates":[-96.5458,32.8358]},{"Plant":"Mountain Creek","State":"TX","Gas":890,"coordinates":[-96.9358,32.7231]},{"Plant":"North Lake","State":"TX","Gas":715,"coordinates":[-96.975,32.9506]},{"Plant":"Parkdale","State":"TX","Gas":327,"coordinates":[-96.7233,32.7767]},{"Plant":"Newman","State":"TX","Gas":474,"coordinates":[-106.4318,31.9836]},{"Plant":"Lewis Creek","State":"TX","Gas":459,"coordinates":[-95.5214,30.4356]},{"Plant":"Neches","State":"TX","Gas":265,"coordinates":[-94.0593,30.0612]},{"Plant":"Sabine","State":"TX","Gas":1890,"coordinates":[-93.878,30.0242]},{"Plant":"Cedar Bayou","State":"TX","Gas":2258,"coordinates":[-94.9256,29.75]},{"Plant":"Deepwater","State":"TX","Gas":174,"coordinates":[-95.2253,29.7199]},{"Plant":"Greens Bayou","State":"TX","Gas":760,"coordinates":[-95.2194,29.8222]},{"Plant":"P H Robinson","State":"TX","Gas":2211,"coordinates":[-94.9794,29.4867]},{"Plant":"Sam Bertron","State":"TX","Gas":844,"coordinates":[-95.0598,29.7268]},{"Plant":"T H Wharton","State":"TX","Gas":1254,"coordinates":[-95.5306,29.9417]},{"Plant":"W A Parish","State":"TX","Gas":1191,"coordinates":[-95.6311,29.4828]},{"Plant":"Webster","State":"TX","Gas":387,"coordinates":[-95.1081,29.5258]},{"Plant":"Knox Lee","State":"TX","Gas":483,"coordinates":[-94.6415,32.3766]},{"Plant":"Wilkes","State":"TX","Gas":883,"coordinates":[-94.548,32.8482]},{"Plant":"Jones","State":"TX","Gas":486,"coordinates":[-101.7392,33.5239]},{"Plant":"Nichols","State":"TX","Gas":457,"coordinates":[-101.7464,35.2834]},{"Plant":"Plant X","State":"TX","Gas":442,"coordinates":[-102.4114,34.1661]},{"Plant":"Eagle Mountain","State":"TX","Gas":665,"coordinates":[-97.4792,32.9056]},{"Plant":"Graham","State":"TX","Gas":630,"coordinates":[-98.6117,33.1344]},{"Plant":"Handley","State":"TX","Gas":1421,"coordinates":[-97.2192,32.7283]},{"Plant":"Morgan Creek","State":"TX","Gas":1354,"coordinates":[-100.9156,32.3358]},{"Plant":"Permian Basin","State":"TX","Gas":1055,"coordinates":[-102.9633,31.5839]},{"Plant":"Ormond Beach","State":"CA","Gas":1516,"coordinates":[-119.1689,34.1292]},{"Plant":"Collin","State":"TX","Gas":154,"coordinates":[-96.8034,33.1576]},{"Plant":"Lake Creek","State":"TX","Gas":317,"coordinates":[-96.985,31.4647]},{"Plant":"River Crest","State":"TX","Gas":110,"coordinates":[-95.1467,33.3931]},{"Plant":"Stryker Creek","State":"TX","Gas":675,"coordinates":[-94.9898,31.9398]},{"Plant":"Tradinghouse","State":"TX","Gas":1383,"coordinates":[-96.9642,31.5728]},{"Plant":"Trinidad","State":"TX","Gas":240,"coordinates":[-96.1013,32.1245]},{"Plant":"Valley","State":"TX","Gas":1115,"coordinates":[-96.3676,33.6281]},{"Plant":"Paint Creek","State":"TX","Gas":231,"coordinates":[-99.7337,33.1576]},{"Plant":"Rio Pecos","State":"TX","Gas":141,"coordinates":[-102.3753,31.0706]},{"Plant":"San Angelo","State":"TX","Gas":123,"coordinates":[-100.491,31.3906]},{"Plant":"Decker Creek","State":"TX","Gas":932,"coordinates":[-97.6128,30.3033]},{"Plant":"Holly Street","State":"TX","Gas":591,"coordinates":[-97.7167,30.25]},{"Plant":"Silas Ray","State":"TX","Gas":125,"coordinates":[-97.5214,25.9131]},{"Plant":"AES Redondo Beach LLC","State":"CA","Gas":1310,"coordinates":[-118.395,33.8504]},{"Plant":"Bryan","State":"TX","Gas":130,"coordinates":[-96.3723,30.6474]},{"Plant":"Ray Olinger","State":"TX","Gas":405.3,"coordinates":[-96.4525,33.0681]},{"Plant":"Mountainview Generating Station","State":"CA","Gas":1062.12,"coordinates":[-117.2418,34.0818]},{"Plant":"Sim Gideon","State":"TX","Gas":620,"coordinates":[-97.2708,30.1456]},{"Plant":"Ty Cooke","State":"TX","Gas":148.6,"coordinates":[-101.7906,33.5211]},{"Plant":"J Robert Massengale","State":"TX","Gas":107,"coordinates":[-101.8408,33.6039]},{"Plant":"Leon Creek","State":"TX","Gas":339,"coordinates":[-98.5761,29.3525]},{"Plant":"O W Sommers","State":"TX","Gas":826,"coordinates":[-98.3242,29.3081]},{"Plant":"V H Braunig","State":"TX","Gas":863,"coordinates":[-98.3825,29.2567]},{"Plant":"W B Tuttle","State":"TX","Gas":404,"coordinates":[-98.4181,29.53]},{"Plant":"R W Miller","State":"TX","Gas":574,"coordinates":[-98.3103,32.6581]},{"Plant":"Sam Rayburn","State":"TX","Gas":227,"coordinates":[-97.135,28.8947]},{"Plant":"Gadsby","State":"UT","Gas":352,"coordinates":[-111.9289,40.7686]},{"Plant":"Grayson","State":"CA","Gas":291.9,"coordinates":[-118.2782,34.1556]},{"Plant":"Chesterfield","State":"VA","Gas":397,"coordinates":[-77.3833,37.3822]},{"Plant":"Possum Point","State":"VA","Gas":854,"coordinates":[-77.2806,38.5367]},{"Plant":"Transalta Centralia Generation","State":"WA","Gas":256,"coordinates":[-122.8598,46.7559]},{"Plant":"El Centro","State":"CA","Gas":225.9,"coordinates":[-115.54,32.8022]},{"Plant":"Harbor","State":"CA","Gas":500,"coordinates":[-118.2656,33.7706]},{"Plant":"Haynes","State":"CA","Gas":2024.9,"coordinates":[-118.0991,33.7647]},{"Plant":"Wheaton","State":"WI","Gas":233.32,"coordinates":[-91.5158,44.8854]},{"Plant":"Scattergood","State":"CA","Gas":803,"coordinates":[-118.4276,33.9182]},{"Plant":"Port Washington Generating Station","State":"WI","Gas":575,"coordinates":[-87.8689,43.3842]},{"Plant":"Rock River","State":"WI","Gas":293.79,"coordinates":[-89.0276,42.582]},{"Plant":"West Marinette","State":"WI","Gas":165.1,"coordinates":[-87.6881,45.0869]},{"Plant":"Valley","State":"CA","Gas":1068,"coordinates":[-118.3913,34.245]},{"Plant":"Broadway","State":"CA","Gas":161,"coordinates":[-118.148,34.1254]},{"Plant":"Glenarm","State":"CA","Gas":155,"coordinates":[-118.1494,34.126]},{"Plant":"Spencer","State":"TX","Gas":171,"coordinates":[-97.1061,33.1975]},{"Plant":"Colbert","State":"AL","Gas":390.4,"coordinates":[-87.8486,34.7439]},{"Plant":"Zuni","State":"CO","Gas":107,"coordinates":[-105.017,39.7373]},{"Plant":"Thomas C Ferguson","State":"TX","Gas":420,"coordinates":[-98.3705,30.558]},{"Plant":"Fort Phantom","State":"TX","Gas":362,"coordinates":[-99.6778,32.5784]},{"Plant":"Barney M Davis","State":"TX","Gas":682,"coordinates":[-97.3117,27.6064]},{"Plant":"Riverside","State":"OK","Gas":907,"coordinates":[-95.9567,35.9978]},{"Plant":"Pittsfield Generating LP","State":"MA","Gas":141,"coordinates":[-73.2181,42.4564]},{"Plant":"Linden Cogen Plant","State":"NJ","Gas":899.8,"coordinates":[-74.2156,40.6322]},{"Plant":"Houston Chemical Complex Battleground","State":"TX","Gas":274,"coordinates":[-95.0839,29.7314]},{"Plant":"Paris Energy Center","State":"TX","Gas":238,"coordinates":[-95.5577,33.6968]},{"Plant":"Hal C Weaver Power Plant","State":"TX","Gas":107.73,"coordinates":[-97.7356,30.2867]},{"Plant":"Sycamore Cogeneration","State":"CA","Gas":304,"coordinates":[-118.9853,35.4526]},{"Plant":"Union Carbide Seadrift Cogen","State":"TX","Gas":168,"coordinates":[-96.7706,28.5105]},{"Plant":"Dow St Charles Operations","State":"LA","Gas":291.6,"coordinates":[-90.4414,29.9861]},{"Plant":"Watson Cogeneration","State":"CA","Gas":398,"coordinates":[-118.2448,33.8166]},{"Plant":"Bucksport Generation LLC","State":"ME","Gas":269,"coordinates":[-68.8046,44.5738]},{"Plant":"Bethpage Power Plant","State":"NY","Gas":184,"coordinates":[-73.4994,40.7469]},{"Plant":"Shell Deer Park","State":"TX","Gas":140,"coordinates":[-95.1289,29.7232]},{"Plant":"Newark Bay Cogeneration Partnership LP","State":"NJ","Gas":118,"coordinates":[-74.13,40.7197]},{"Plant":"Indeck Corinth Energy Center","State":"NY","Gas":131.5,"coordinates":[-73.8125,43.25]},{"Plant":"PPG Powerhouse C","State":"LA","Gas":303.2,"coordinates":[-93.2831,30.2242]},{"Plant":"Bayonne Plant Holding LLC","State":"NJ","Gas":170,"coordinates":[-74.1124,40.6553]},{"Plant":"Harbor Cogen","State":"CA","Gas":101.7,"coordinates":[-118.2303,33.7771]},{"Plant":"Rosemary Power Station","State":"NC","Gas":165,"coordinates":[-77.6594,36.4517]},{"Plant":"Oklahoma Cogeneration Project","State":"OK","Gas":111.4,"coordinates":[-97.625,35.4397]},{"Plant":"Eagle Point Power Generation","State":"NJ","Gas":195,"coordinates":[-75.1592,39.8746]},{"Plant":"TXU Sweetwater Generating Plant","State":"TX","Gas":289,"coordinates":[-100.365,32.4928]},{"Plant":"ExxonMobil Beaumont Refinery","State":"TX","Gas":650.6,"coordinates":[-94.0753,30.0636]},{"Plant":"JM Shafer Generating Station","State":"CO","Gas":263.1,"coordinates":[-104.7736,40.0986]},{"Plant":"Gary Works","State":"IN","Gas":221,"coordinates":[-87.3289,41.6224]},{"Plant":"Parlin Power Plant","State":"NJ","Gas":118,"coordinates":[-74.3272,40.4607]},{"Plant":"Optim Energy Altura Cogen LLC","State":"TX","Gas":448,"coordinates":[-95.1077,29.8161]},{"Plant":"Gramercy Holdings LLC","State":"LA","Gas":106,"coordinates":[-90.6693,30.054]},{"Plant":"Hardee Power Station","State":"FL","Gas":358,"coordinates":[-81.9636,27.6364]},{"Plant":"Bellmeade Power Station","State":"VA","Gas":230,"coordinates":[-77.4317,37.4964]},{"Plant":"Pryor Power Plant","State":"OK","Gas":111.5,"coordinates":[-95.3175,36.2977]},{"Plant":"Ocean State Power","State":"RI","Gas":218.62,"coordinates":[-71.6689,42.0097]},{"Plant":"LaO Energy Systems","State":"LA","Gas":648.4,"coordinates":[-91.2325,30.3186]},{"Plant":"Doswell Energy Center","State":"VA","Gas":819.8,"coordinates":[-77.1448,37.8182]},{"Plant":"Elizabeth River Power Station","State":"VA","Gas":309,"coordinates":[-76.3083,36.775]},{"Plant":"Texas City Power Plant","State":"TX","Gas":451,"coordinates":[-94.9438,29.3787]},{"Plant":"Dow Chemical Texas Operation","State":"TX","Gas":1158,"coordinates":[-95.4075,28.9913]},{"Plant":"Power Station 4","State":"TX","Gas":172,"coordinates":[-94.9219,29.3782]},{"Plant":"Midway Sunset Cogen","State":"CA","Gas":219,"coordinates":[-119.6294,35.2269]},{"Plant":"C R Wing Cogen Plant","State":"TX","Gas":227,"coordinates":[-101.4224,32.2732]},{"Plant":"Delaware City Plant","State":"DE","Gas":308,"coordinates":[-75.6343,39.5871]},{"Plant":"McWilliams","State":"AL","Gas":650,"coordinates":[-86.4764,31.4003]},{"Plant":"J K Smith","State":"KY","Gas":626,"coordinates":[-84.1017,37.8833]},{"Plant":"Lockport Energy Associates LP","State":"NY","Gas":210.2,"coordinates":[-78.745,43.1619]},{"Plant":"Kennedy International Airport Cogen","State":"NY","Gas":126.25,"coordinates":[-73.7778,40.6417]},{"Plant":"March Point Cogeneration","State":"WA","Gas":146.2,"coordinates":[-122.56,48.4708]},{"Plant":"Saguaro Power","State":"NV","Gas":101,"coordinates":[-115.0117,36.0417]},{"Plant":"Ocean State Power II","State":"RI","Gas":218.62,"coordinates":[-71.6701,42.0099]},{"Plant":"Orange Cogeneration Facility","State":"FL","Gas":117.48,"coordinates":[-81.8251,27.8708]},{"Plant":"Lake Cogen Ltd","State":"FL","Gas":110,"coordinates":[-81.676,28.9158]},{"Plant":"Pasco Cogen Ltd","State":"FL","Gas":128.78,"coordinates":[-82.1889,28.3746]},{"Plant":"Mulberry Cogeneration Facility","State":"FL","Gas":113,"coordinates":[-81.8775,27.8489]},{"Plant":"Orlando Cogen LP","State":"FL","Gas":120,"coordinates":[-81.4123,28.4426]},{"Plant":"Sumas Power Plant","State":"WA","Gas":125.5,"coordinates":[-122.2733,48.9905]},{"Plant":"Formosa Plastics","State":"LA","Gas":115,"coordinates":[-91.1872,30.4992]},{"Plant":"Ferndale Generating Station","State":"WA","Gas":271,"coordinates":[-122.6867,48.8288]},{"Plant":"Hartwell Energy Facility","State":"GA","Gas":301.09,"coordinates":[-82.8199,34.3396]},{"Plant":"Sithe Independence Station","State":"NY","Gas":982.2,"coordinates":[-76.4511,43.495]},{"Plant":"Saranac Facility","State":"NY","Gas":240,"coordinates":[-73.4557,44.7132]},{"Plant":"NAEA Lakewood LLC","State":"NJ","Gas":205.1,"coordinates":[-74.1686,40.0613]},{"Plant":"Auburndale Power Partners","State":"FL","Gas":154.7,"coordinates":[-81.8058,28.0542]},{"Plant":"Oyster Creek Unit VIII","State":"TX","Gas":379,"coordinates":[-95.342,28.9802]},{"Plant":"Hermiston Generating Plant","State":"OR","Gas":464,"coordinates":[-119.37,45.8042]},{"Plant":"Grays Ferry Cogeneration","State":"PA","Gas":150,"coordinates":[-75.1881,39.9422]},{"Plant":"Milford Power LP","State":"MA","Gas":148,"coordinates":[-71.5115,42.1294]},{"Plant":"Milagro Cogeneration Plant","State":"NM","Gas":121.6,"coordinates":[-107.9417,36.7367]},{"Plant":"Johnson County","State":"TX","Gas":267,"coordinates":[-97.4078,32.3994]},{"Plant":"Brandywine Power Facility","State":"MD","Gas":230,"coordinates":[-76.8678,38.6681]},{"Plant":"Gordonsville Energy LP","State":"VA","Gas":224,"coordinates":[-78.2138,38.1179]},{"Plant":"Sun Peak Generating Station","State":"NV","Gas":222,"coordinates":[-115.0339,36.1375]},{"Plant":"Brooklyn Navy Yard Cogeneration","State":"NY","Gas":230,"coordinates":[-73.9764,40.6994]},{"Plant":"Michigan Power LP","State":"MI","Gas":128,"coordinates":[-86.425,43.9375]},{"Plant":"LSP-Cottage Grove LP","State":"MN","Gas":251,"coordinates":[-92.9119,44.7956]},{"Plant":"LSP-Whitewater LP","State":"WI","Gas":253,"coordinates":[-88.7299,42.8555]},{"Plant":"Sweeny Cogen Facility","State":"TX","Gas":480,"coordinates":[-95.745,29.0728]},{"Plant":"Dighton Power Plant","State":"MA","Gas":142,"coordinates":[-71.1239,41.8312]},{"Plant":"De Pere Energy Center","State":"WI","Gas":188.2,"coordinates":[-88.072,44.4486]},{"Plant":"Androscoggin Energy Center","State":"ME","Gas":127.29,"coordinates":[-70.2423,44.5063]},{"Plant":"Delta Person LLC","State":"NM","Gas":140,"coordinates":[-106.644,35.026]},{"Plant":"Mid-Georgia Cogeneration Facility","State":"GA","Gas":316,"coordinates":[-83.6039,32.4856]},{"Plant":"Berkshire Power","State":"MA","Gas":232.12,"coordinates":[-72.6478,42.0476]},{"Plant":"Bridgeport Energy Project","State":"CT","Gas":454,"coordinates":[-73.1844,41.1692]},{"Plant":"Pasadena Cogeneration","State":"TX","Gas":700,"coordinates":[-95.1765,29.7248]},{"Plant":"Tiverton Power Plant","State":"RI","Gas":249.99,"coordinates":[-71.1706,41.6422]},{"Plant":"Axiall Plaquemine","State":"LA","Gas":240,"coordinates":[-91.185,30.2586]},{"Plant":"Tenaska Frontier Generation Station","State":"TX","Gas":860,"coordinates":[-95.9178,30.5924]},{"Plant":"Batesville Generation Facility","State":"MS","Gas":858,"coordinates":[-89.9275,34.3356]},{"Plant":"Black Hawk Station","State":"TX","Gas":221.4,"coordinates":[-101.36,35.6957]},{"Plant":"Mustang Station","State":"TX","Gas":486,"coordinates":[-102.7417,32.9728]},{"Plant":"Maine Independence Station","State":"ME","Gas":490.01,"coordinates":[-68.7094,44.8242]},{"Plant":"Pine Bluff Energy Center","State":"AR","Gas":198,"coordinates":[-91.9025,34.2181]},{"Plant":"Desert Star Energy Center","State":"NV","Gas":450,"coordinates":[-114.9928,35.7867]},{"Plant":"Millennium Power","State":"MA","Gas":325.1,"coordinates":[-72.0151,42.1123]},{"Plant":"New Albany Energy Facility","State":"MS","Gas":360,"coordinates":[-88.9397,34.5408]},{"Plant":"Brownsville Peaking Power","State":"TN","Gas":450,"coordinates":[-89.198,35.5438]},{"Plant":"Crockett Cogen Project","State":"CA","Gas":247.4,"coordinates":[-122.2161,38.0569]},{"Plant":"Gregory Power Facility","State":"TX","Gas":412,"coordinates":[-97.2584,27.8893]},{"Plant":"Zeeland Generating Station","State":"MI","Gas":770,"coordinates":[-85.9975,42.8206]},{"Plant":"Dearborn Industrial Generation","State":"MI","Gas":700,"coordinates":[-83.154,42.3026]},{"Plant":"Taft Cogeneration Facility","State":"LA","Gas":790,"coordinates":[-90.4599,29.9888]},{"Plant":"Midlothian Energy Facility","State":"TX","Gas":1278,"coordinates":[-97.0537,32.4302]},{"Plant":"Lamar Power Project","State":"TX","Gas":1004,"coordinates":[-95.59,33.6308]},{"Plant":"Frontera Energy Center","State":"TX","Gas":475,"coordinates":[-98.3992,26.208]},{"Plant":"NRG Sterlington Power","State":"LA","Gas":176,"coordinates":[-92.0811,32.6889]},{"Plant":"Rumford Power Associates","State":"ME","Gas":254,"coordinates":[-70.5219,44.5303]},{"Plant":"Livingston Generating Station","State":"MI","Gas":132,"coordinates":[-84.7308,45.0304]},{"Plant":"Klamath Cogeneration Plant","State":"OR","Gas":470,"coordinates":[-121.8106,42.1739]},{"Plant":"Sabine Cogen","State":"TX","Gas":101,"coordinates":[-93.7714,30.0444]},{"Plant":"Entergy Rhode Island State Energy LP","State":"RI","Gas":515,"coordinates":[-71.5186,41.8017]},{"Plant":"Rocky Road Power LLC","State":"IL","Gas":340,"coordinates":[-88.2397,42.0931]},{"Plant":"Madison","State":"OH","Gas":576,"coordinates":[-84.4647,39.4522]},{"Plant":"Vermillion Energy Facility","State":"IN","Gas":560,"coordinates":[-87.4464,39.9223]},{"Plant":"Sutter Energy Center","State":"CA","Gas":530,"coordinates":[-121.6959,39.0531]},{"Plant":"Rockingham County CT Station","State":"NC","Gas":775,"coordinates":[-79.8297,36.3297]},{"Plant":"RS Cogen","State":"LA","Gas":395.6,"coordinates":[-93.2992,30.221]},{"Plant":"SRW Cogen LP","State":"TX","Gas":420,"coordinates":[-93.7574,30.0545]},{"Plant":"Magic Valley Generating Station","State":"TX","Gas":682,"coordinates":[-98.19,26.3403]},{"Plant":"Griffith Energy LLC","State":"AZ","Gas":570,"coordinates":[-114.1333,35.054]},{"Plant":"Milford Power Project","State":"CT","Gas":492.5,"coordinates":[-73.0997,41.2244]},{"Plant":"Manchief Electric Generating Station","State":"CO","Gas":264,"coordinates":[-103.685,40.2171]},{"Plant":"Walton County Power LLC","State":"GA","Gas":459.3,"coordinates":[-83.6954,33.8148]},{"Plant":"Desert Basin","State":"AZ","Gas":577,"coordinates":[-111.7889,32.9042]},{"Plant":"Kendall County Generation Facility","State":"IL","Gas":1140,"coordinates":[-88.2581,41.4797]},{"Plant":"Tenaska Gateway Generating Station","State":"TX","Gas":863,"coordinates":[-94.6197,32.0178]},{"Plant":"Alliant Energy Neenah","State":"WI","Gas":299.1,"coordinates":[-88.5064,44.1936]},{"Plant":"Rio Nogales Power Project","State":"TX","Gas":705,"coordinates":[-97.9732,29.5931]},{"Plant":"Wolf Hollow I LP","State":"TX","Gas":695.5,"coordinates":[-97.7317,32.3342]},{"Plant":"Hawk Road Facility","State":"GA","Gas":465,"coordinates":[-84.9914,33.3585]},{"Plant":"Hays Energy Project","State":"TX","Gas":876.8,"coordinates":[-97.9894,29.7806]},{"Plant":"Green Country Energy LLC","State":"OK","Gas":795,"coordinates":[-95.9346,35.9833]},{"Plant":"Worthington Generation LLC","State":"IN","Gas":179.2,"coordinates":[-87.0128,39.0708]},{"Plant":"Lake Road Generating Plant","State":"CT","Gas":712,"coordinates":[-71.8958,41.872]},{"Plant":"La Paloma Generating LLC","State":"CA","Gas":965.4,"coordinates":[-119.5919,35.2956]},{"Plant":"Guadalupe Generating Station","State":"TX","Gas":1000,"coordinates":[-98.1419,29.6244]},{"Plant":"Lost Pines 1 Power Project","State":"TX","Gas":516,"coordinates":[-97.2714,30.1478]},{"Plant":"Bluegrass Generating Station","State":"KY","Gas":495,"coordinates":[-85.4133,38.3902]},{"Plant":"Calcasieu","State":"LA","Gas":310,"coordinates":[-93.345,30.1608]},{"Plant":"Broad River Energy Center","State":"SC","Gas":841.21,"coordinates":[-81.575,35.0786]},{"Plant":"Bastrop Energy Center","State":"TX","Gas":552,"coordinates":[-97.55,30.1458]},{"Plant":"Granite Ridge","State":"NH","Gas":797,"coordinates":[-71.4261,42.9042]},{"Plant":"Bosque County Peaking","State":"TX","Gas":548,"coordinates":[-97.3586,31.8594]},{"Plant":"Acadia Energy Center","State":"LA","Gas":1063,"coordinates":[-92.4131,30.4286]},{"Plant":"Eastman Cogeneration Facility","State":"TX","Gas":402.22,"coordinates":[-94.6903,32.4481]},{"Plant":"South Point Energy Center","State":"AZ","Gas":550,"coordinates":[-114.5317,34.8678]},{"Plant":"Dogwood Energy Facility","State":"MO","Gas":620,"coordinates":[-94.3006,38.7931]},{"Plant":"Rathdrum Power LLC","State":"ID","Gas":248,"coordinates":[-116.9203,47.7858]},{"Plant":"Sunrise Power LLC","State":"CA","Gas":545,"coordinates":[-119.585,35.2097]},{"Plant":"Channelview Cogeneration Plant","State":"TX","Gas":779,"coordinates":[-95.1217,29.837]},{"Plant":"Cordova Energy","State":"IL","Gas":521.2,"coordinates":[-90.2797,41.7122]},{"Plant":"Osceola","State":"FL","Gas":468,"coordinates":[-81.0978,28.1289]},{"Plant":"Ontelaunee Energy Center","State":"PA","Gas":516,"coordinates":[-75.9356,40.4219]},{"Plant":"Caledonia","State":"MS","Gas":783,"coordinates":[-88.2717,33.6464]},{"Plant":"Riverside Generating LLC","State":"KY","Gas":825,"coordinates":[-82.6046,38.1917]},{"Plant":"Elwood Energy LLC","State":"IL","Gas":1350,"coordinates":[-88.1236,41.4388]},{"Plant":"Arapahoe Combustion Turbine Project","State":"CO","Gas":122.5,"coordinates":[-105.0018,39.6692]},{"Plant":"Gibson City","State":"IL","Gas":232,"coordinates":[-88.3987,40.4705]},{"Plant":"Pinckneyville","State":"IL","Gas":320,"coordinates":[-89.3467,38.1114]},{"Plant":"Kinmundy","State":"IL","Gas":232,"coordinates":[-89.0128,38.7619]},{"Plant":"Corpus Christi Energy Center","State":"TX","Gas":482.1,"coordinates":[-97.4283,27.8139]},{"Plant":"Afton Generating Station","State":"NM","Gas":141,"coordinates":[-106.8465,32.1142]},{"Plant":"ANP Bellingham Energy Project","State":"MA","Gas":493,"coordinates":[-71.4535,42.1106]},{"Plant":"ANP Blackstone Energy Project","State":"MA","Gas":440.64,"coordinates":[-71.5158,42.0599]},{"Plant":"Odessa Ector Generating Station","State":"TX","Gas":1026.2,"coordinates":[-102.3264,31.8403]},{"Plant":"Morris Cogeneration LLC","State":"IL","Gas":176,"coordinates":[-88.3328,41.4119]},{"Plant":"Los Medanos Energy Center","State":"CA","Gas":567,"coordinates":[-121.873,38.0301]},{"Plant":"Hinds Energy Facility","State":"MS","Gas":450,"coordinates":[-90.2199,32.379]},{"Plant":"Southaven Energy Facility","State":"MS","Gas":624,"coordinates":[-90.0397,34.9808]},{"Plant":"Attala","State":"MS","Gas":463,"coordinates":[-89.6753,33.0147]},{"Plant":"Harry L. Oswald","State":"AR","Gas":568,"coordinates":[-92.2166,34.5923]},{"Plant":"Lincoln Generating Facility","State":"IL","Gas":603.3,"coordinates":[-87.9436,41.3933]},{"Plant":"Ennis Power Company LLC","State":"TX","Gas":359.5,"coordinates":[-96.675,32.32]},{"Plant":"Wheatland Generating Facility","State":"IN","Gas":472,"coordinates":[-87.2931,38.6716]},{"Plant":"Oneta Energy Center","State":"OK","Gas":1082.1,"coordinates":[-95.6967,36.0119]},{"Plant":"Freestone Energy Center","State":"TX","Gas":984,"coordinates":[-96.1131,31.8907]},{"Plant":"Greenville Electric Generating Station","State":"OH","Gas":176,"coordinates":[-84.6151,40.0758]},{"Plant":"Montpelier Electric Generating Station","State":"IN","Gas":180,"coordinates":[-85.3057,40.6206]},{"Plant":"Jack County","State":"TX","Gas":620.5,"coordinates":[-97.9574,33.101]},{"Plant":"Liberty Electric Power Plant","State":"PA","Gas":521,"coordinates":[-75.3358,39.8614]},{"Plant":"Marshall Energy Facility","State":"KY","Gas":620.8,"coordinates":[-88.3958,37.0286]},{"Plant":"Handsome Lake Energy LLC","State":"PA","Gas":250,"coordinates":[-79.8061,41.2908]},{"Plant":"Audrain Generating Station","State":"MO","Gas":640,"coordinates":[-91.5369,39.3092]},{"Plant":"Lee Energy Facility","State":"IL","Gas":623.5,"coordinates":[-89.4054,41.8287]},{"Plant":"Energy Shelby County","State":"IL","Gas":371.6,"coordinates":[-88.4772,39.2794]},{"Plant":"NRG Rockford I","State":"IL","Gas":294,"coordinates":[-89.1012,42.2386]},{"Plant":"Red Oak Power LLC","State":"NJ","Gas":765.99,"coordinates":[-74.3489,40.4487]},{"Plant":"Hog Bayou Energy Center","State":"AL","Gas":230,"coordinates":[-88.0575,30.7478]},{"Plant":"Santa Rosa Energy Center","State":"FL","Gas":235.9,"coordinates":[-87.115,30.5664]},{"Plant":"Astoria Gas Turbines","State":"NY","Gas":420,"coordinates":[-73.9048,40.787]},{"Plant":"Doyle Energy Facility","State":"GA","Gas":355,"coordinates":[-83.6996,33.8377]},{"Plant":"Darby Electric Generating Station","State":"OH","Gas":451.8,"coordinates":[-83.1778,39.7139]},{"Plant":"Tait Electric Generating Station","State":"OH","Gas":319.6,"coordinates":[-84.2095,39.7277]},{"Plant":"University Park South","State":"IL","Gas":300,"coordinates":[-87.7532,41.4409]},{"Plant":"Gleason Generating Facility","State":"TN","Gas":521.9,"coordinates":[-88.612,36.2454]},{"Plant":"Crete Energy Venture LLC","State":"IL","Gas":300,"coordinates":[-87.6187,41.4294]},{"Plant":"Whiting Clean Energy","State":"IN","Gas":547,"coordinates":[-87.4775,41.6739]},{"Plant":"Edward L. Addison Generating Plant","State":"GA","Gas":609,"coordinates":[-84.3064,32.9111]},{"Plant":"TVA Southaven Combined Cycle","State":"MS","Gas":759,"coordinates":[-90.0378,34.9939]},{"Plant":"Jackson Generating Station","State":"MI","Gas":564,"coordinates":[-84.3767,42.2488]},{"Plant":"Tenaska Lindsay Hill Generating Station","State":"AL","Gas":857.9,"coordinates":[-86.7386,32.6514]},{"Plant":"Ceredo Generating Station","State":"WV","Gas":675,"coordinates":[-82.5339,38.3681]},{"Plant":"Aurora","State":"IL","Gas":878,"coordinates":[-88.2265,41.8151]},{"Plant":"Southeast Chicago Energy Project","State":"IL","Gas":296,"coordinates":[-87.5449,41.7181]},{"Plant":"Arlington Valley Energy Facility","State":"AZ","Gas":580,"coordinates":[-112.8897,33.3417]},{"Plant":"Front Range Power Plant","State":"CO","Gas":461.5,"coordinates":[-104.7069,38.6281]},{"Plant":"Big Sandy Peaker Plant","State":"WV","Gas":300,"coordinates":[-82.5938,38.3441]},{"Plant":"Wolf Hills Energy","State":"VA","Gas":250,"coordinates":[-82.1044,36.6644]},{"Plant":"Oleander Power Project LP","State":"FL","Gas":155.7,"coordinates":[-80.7947,28.3661]},{"Plant":"Decatur Energy Center","State":"AL","Gas":624,"coordinates":[-87.0214,34.6292]},{"Plant":"Morgan Energy Center","State":"AL","Gas":749,"coordinates":[-87.0639,34.6397]},{"Plant":"Westbrook Energy Center Power Plant","State":"ME","Gas":506,"coordinates":[-70.375,43.6575]},{"Plant":"Blythe Energy Inc","State":"CA","Gas":514.04,"coordinates":[-114.6865,33.6157]},{"Plant":"Calumet Energy Team LLC","State":"IL","Gas":329,"coordinates":[-87.5563,41.6835]},{"Plant":"New Covert Generating Facility","State":"MI","Gas":1058.4,"coordinates":[-86.2937,42.3224]},{"Plant":"Fairless Energy Center","State":"PA","Gas":1150.7,"coordinates":[-74.7411,40.1475]},{"Plant":"Channel Energy Center LLC","State":"TX","Gas":585,"coordinates":[-95.2319,29.7189]},{"Plant":"Warren Peaking Power Facility","State":"MS","Gas":300,"coordinates":[-90.9284,32.2849]},{"Plant":"Baconton Power Plant","State":"GA","Gas":195.2,"coordinates":[-84.08,31.3869]},{"Plant":"Gila River Power Station","State":"AZ","Gas":2060,"coordinates":[-112.6944,32.975]},{"Plant":"Ingleside Cogeneration","State":"TX","Gas":460,"coordinates":[-97.2428,27.8828]},{"Plant":"Fore River Generating Station","State":"MA","Gas":668.35,"coordinates":[-70.9661,42.2422]},{"Plant":"Wise County Power LLC","State":"TX","Gas":655,"coordinates":[-97.9103,33.0583]},{"Plant":"Chuck Lenzie Generating Station","State":"NV","Gas":935.2,"coordinates":[-114.9218,36.3837]},{"Plant":"Baytown Energy Center","State":"TX","Gas":785,"coordinates":[-94.9019,29.7731]},{"Plant":"Hermiston Power Partnership","State":"OR","Gas":615,"coordinates":[-119.3133,45.794]},{"Plant":"Washington County","State":"GA","Gas":597.66,"coordinates":[-82.98,33.0922]},{"Plant":"Delta Energy Center","State":"CA","Gas":811.3,"coordinates":[-121.8439,38.0169]},{"Plant":"Holland Energy Facility","State":"IL","Gas":449,"coordinates":[-88.7584,39.2231]},{"Plant":"PPL Ironwood LLC","State":"PA","Gas":669,"coordinates":[-76.3658,40.3509]},{"Plant":"Luna Energy Facility","State":"NM","Gas":559,"coordinates":[-107.7834,32.2993]},{"Plant":"Armstrong","State":"PA","Gas":584,"coordinates":[-79.3517,40.638]},{"Plant":"Troy Energy LLC","State":"OH","Gas":584,"coordinates":[-83.4598,41.4772]},{"Plant":"Pleasants Energy LLC","State":"WV","Gas":292.2,"coordinates":[-81.3642,39.3325]},{"Plant":"Brazos Valley Generating Facility","State":"TX","Gas":525,"coordinates":[-95.6244,29.4731]},{"Plant":"Cottonwood Energy Project","State":"TX","Gas":1233.6,"coordinates":[-93.7353,30.2588]},{"Plant":"Sugar Creek Power","State":"IN","Gas":520.7,"coordinates":[-87.5108,39.3931]},{"Plant":"Exelon LaPorte Generating Station","State":"TX","Gas":168,"coordinates":[-95.0718,29.7028]},{"Plant":"Harquahala Generating Project","State":"AZ","Gas":1054.4,"coordinates":[-113.1134,33.476]},{"Plant":"Enterprise Energy Facility","State":"MS","Gas":300,"coordinates":[-90.0394,34.9767]},{"Plant":"Astoria Energy","State":"NY","Gas":480,"coordinates":[-73.8964,40.7825]},{"Plant":"Union Power Partners LP","State":"AR","Gas":2020,"coordinates":[-92.5894,33.2961]},{"Plant":"Thomas A Smith Energy Facility","State":"GA","Gas":1244,"coordinates":[-84.9175,34.7094]},{"Plant":"Columbia Energy Center","State":"SC","Gas":464.5,"coordinates":[-81.0178,33.8697]},{"Plant":"RockGen Energy Center","State":"WI","Gas":471,"coordinates":[-89.0492,42.9767]},{"Plant":"Zion Energy Center","State":"IL","Gas":456,"coordinates":[-87.895,42.4776]},{"Plant":"Metcalf Energy Center","State":"CA","Gas":546.1,"coordinates":[-121.7457,37.2207]},{"Plant":"Crossroads Energy Center","State":"MS","Gas":308,"coordinates":[-90.5621,34.183]},{"Plant":"Washington Energy Facility","State":"OH","Gas":600,"coordinates":[-81.6564,39.58]},{"Plant":"Elk Hills Power LLC","State":"CA","Gas":525,"coordinates":[-119.4707,35.2803]},{"Plant":"Rolling Hills Generating","State":"OH","Gas":825,"coordinates":[-82.3328,39.0839]},{"Plant":"Renaissance Power LLC","State":"MI","Gas":660,"coordinates":[-84.8429,43.1864]},{"Plant":"Carville Energy LLC","State":"LA","Gas":500,"coordinates":[-91.065,30.2294]},{"Plant":"Athens Generating Plant","State":"NY","Gas":1137.9,"coordinates":[-73.8492,42.2728]},{"Plant":"Effingham County Power Project","State":"GA","Gas":450,"coordinates":[-81.2844,32.2773]},{"Plant":"Calhoun Energy Center","State":"AL","Gas":624,"coordinates":[-85.9731,33.5883]},{"Plant":"Osprey Energy Center Power Plant","State":"FL","Gas":595.1,"coordinates":[-81.8083,28.0525]},{"Plant":"Shady Hills Generating Station","State":"FL","Gas":468,"coordinates":[-82.5586,28.3665]},{"Plant":"Vandolah Power Station","State":"FL","Gas":632,"coordinates":[-81.924,27.5236]},{"Plant":"Raccoon Creek Energy Center","State":"IL","Gas":300,"coordinates":[-88.5392,38.6996]},{"Plant":"Hot Spring Generating Facility","State":"AR","Gas":651.6,"coordinates":[-92.8683,34.2976]},{"Plant":"Plaquemine Cogeneration Plant","State":"LA","Gas":843.7,"coordinates":[-91.2347,30.3217]},{"Plant":"DeSoto County Plant","State":"FL","Gas":312.81,"coordinates":[-81.8092,27.2272]},{"Plant":"Bayou Cove Peaking Power","State":"LA","Gas":300,"coordinates":[-92.5997,30.2825]},{"Plant":"Elgin Energy Center","State":"IL","Gas":452,"coordinates":[-88.2446,42.0001]},{"Plant":"Tenaska Virginia Generating Station","State":"VA","Gas":904,"coordinates":[-78.3813,37.8667]},{"Plant":"Tenaska Central Alabama Generating Stn","State":"AL","Gas":864,"coordinates":[-86.74,32.6497]},{"Plant":"Columbia Energy Center","State":"MO","Gas":140,"coordinates":[-92.2629,39.0192]},{"Plant":"Magnolia Power Plant","State":"MS","Gas":863.1,"coordinates":[-89.2026,34.835]},{"Plant":"Fountain Valley Power Facility","State":"CO","Gas":234,"coordinates":[-104.6875,38.5569]},{"Plant":"Red Hawk","State":"AZ","Gas":948,"coordinates":[-112.8406,33.3346]},{"Plant":"McClain Energy Facility","State":"OK","Gas":461,"coordinates":[-97.5898,35.2977]},{"Plant":"Redbud Power Plant","State":"OK","Gas":1143.6,"coordinates":[-97.2264,35.6856]},{"Plant":"Deer Park Energy Center","State":"TX","Gas":877.2,"coordinates":[-95.1345,29.7134]},{"Plant":"Ouachita","State":"LA","Gas":816,"coordinates":[-92.0683,32.7061]},{"Plant":"Green Power 2","State":"TX","Gas":584,"coordinates":[-94.9328,29.3781]},{"Plant":"Forney Energy Center","State":"TX","Gas":1640,"coordinates":[-96.4916,32.7563]},{"Plant":"Mesquite Generating Station","State":"AZ","Gas":1073.3,"coordinates":[-112.8642,33.345]},{"Plant":"Goldendale Generating Station","State":"WA","Gas":219.9,"coordinates":[-120.833,45.8114]},{"Plant":"Tri Center Naniwa Energy","State":"NV","Gas":300,"coordinates":[-119.5178,39.5572]},{"Plant":"Goose Creek Energy Center","State":"IL","Gas":432,"coordinates":[-88.5999,40.1069]},{"Plant":"Kiamichi Energy Facility","State":"OK","Gas":1178.4,"coordinates":[-95.9349,34.6831]},{"Plant":"Lawrenceburg Energy Facility","State":"IN","Gas":1080,"coordinates":[-84.8669,39.0911]},{"Plant":"AEP Waterford Facility","State":"OH","Gas":810,"coordinates":[-81.7178,39.5333]},{"Plant":"Limon Generating Station","State":"CO","Gas":134,"coordinates":[-103.7005,39.2038]},{"Plant":"Frank Knutson","State":"CO","Gas":134,"coordinates":[-104.682,39.9411]},{"Plant":"Apex Generating Station","State":"NV","Gas":494.4,"coordinates":[-114.9609,36.416]},{"Plant":"Fayette Energy Facility","State":"PA","Gas":600.5,"coordinates":[-79.9182,39.8592]},{"Plant":"Wallingford Energy","State":"CT","Gas":190,"coordinates":[-72.8354,41.4487]},{"Plant":"High Desert Power Plant","State":"CA","Gas":780,"coordinates":[-117.3647,34.5953]},{"Plant":"AES Greystone","State":"TN","Gas":468,"coordinates":[-89.3937,35.6532]},{"Plant":"Sundance","State":"AZ","Gas":410,"coordinates":[-111.5899,32.9285]},{"Plant":"Indigo Energy Facility","State":"CA","Gas":149.7,"coordinates":[-116.553,33.9109]},{"Plant":"Hidalgo Energy Center","State":"TX","Gas":470,"coordinates":[-98.1758,26.3417]},{"Plant":"Perryville Power Station","State":"LA","Gas":691,"coordinates":[-92.0183,32.6908]},{"Plant":"West Valley Generation Project","State":"UT","Gas":202,"coordinates":[-112.0317,40.6667]},{"Plant":"University Park North","State":"IL","Gas":504,"coordinates":[-87.7514,41.4425]},{"Plant":"Riverside Energy Center","State":"WI","Gas":598.3,"coordinates":[-89.0355,42.5827]},{"Plant":"Blue Spruce Energy Center","State":"CO","Gas":276,"coordinates":[-104.6814,39.7479]},{"Plant":"Plains End","State":"CO","Gas":113,"coordinates":[-105.226,39.8575]},{"Plant":"Spring Creek Energy Center","State":"OK","Gas":280,"coordinates":[-97.655,35.7422]},{"Plant":"Pastoria Energy Facility, LLC","State":"CA","Gas":724,"coordinates":[-118.844,34.9556]},{"Plant":"EP Newington Energy LLC","State":"NH","Gas":525,"coordinates":[-70.8061,43.1047]},{"Plant":"Chehalis Generating Facility","State":"WA","Gas":495,"coordinates":[-122.9131,46.6225]},{"Plant":"Harrison County Power Project","State":"TX","Gas":484.5,"coordinates":[-94.4367,32.3958]},{"Plant":"Lower Mount Bethel Energy","State":"PA","Gas":593.8,"coordinates":[-75.1076,40.8019]},{"Plant":"AL Sandersville LLC","State":"GA","Gas":624,"coordinates":[-82.8608,33.1189]},{"Plant":"Higgins Generating Station","State":"NV","Gas":570,"coordinates":[-115.3561,35.6139]},{"Plant":"Bethlehem Power Plant","State":"PA","Gas":1092,"coordinates":[-75.3147,40.6175]},{"Plant":"Quantum Choctaw Power LLC","State":"MS","Gas":735.2,"coordinates":[-89.2089,33.3792]},{"Plant":"Pierce Power Station","State":"WA","Gas":130.9,"coordinates":[-122.3758,47.1365]},{"Plant":"Choctaw County","State":"MS","Gas":726,"coordinates":[-89.4201,33.2881]},{"Plant":"Allegheny Energy Units 3 4 & 5","State":"PA","Gas":509,"coordinates":[-79.7686,40.5453]},{"Plant":"Magnet Cove","State":"AR","Gas":641.5,"coordinates":[-92.8317,34.4297]},{"Plant":"Dean","State":"MI","Gas":295.4,"coordinates":[-82.4953,42.7725]},{"Plant":"Hanging Rock Energy Facility","State":"OH","Gas":1288,"coordinates":[-82.7833,38.5731]},{"Plant":"Los Esteros Critical Energy Center","State":"CA","Gas":180,"coordinates":[-121.9319,37.425]},{"Plant":"FPL Energy Marcus Hook LP","State":"PA","Gas":717.5,"coordinates":[-75.4216,39.807]},{"Plant":"Gilroy Peaking Energy Center","State":"CA","Gas":128.3,"coordinates":[-121.5363,36.999]},{"Plant":"Frederickson Power LP","State":"WA","Gas":276.5,"coordinates":[-122.3657,47.0861]},{"Plant":"Curtis H Stanton Energy Center","State":"FL","Gas":591.93,"coordinates":[-81.1669,28.4882]},{"Plant":"Auburndale Peaker Energy Center","State":"FL","Gas":118,"coordinates":[-81.8059,28.0535]},{"Plant":"Rocky Mountain Energy Center","State":"CO","Gas":608,"coordinates":[-104.5953,40.0908]},{"Plant":"Silverhawk","State":"NV","Gas":560,"coordinates":[-114.9606,36.4078]},{"Plant":"Jasper","State":"SC","Gas":795.3,"coordinates":[-81.1242,32.3594]},{"Plant":"Tracy Combined Cycle Power Plant","State":"CA","Gas":164.08,"coordinates":[-121.4906,37.7107]},{"Plant":"NRG Rockford II Energy Center","State":"IL","Gas":157,"coordinates":[-89.1011,42.2383]},{"Plant":"NAEA Ocean Peaking Power LLC","State":"NJ","Gas":325.6,"coordinates":[-74.1672,40.0633]},{"Plant":"Las Vegas Cogeneration II LLC","State":"NV","Gas":220,"coordinates":[-115.1238,36.232]},{"Plant":"Wansley Combined Cycle","State":"GA","Gas":1129.18,"coordinates":[-85.037,33.4064]},{"Plant":"Cosumnes","State":"CA","Gas":477,"coordinates":[-121.124,38.3385]},{"Plant":"Cass County","State":"NE","Gas":320,"coordinates":[-95.964,40.9479]},{"Plant":"Hunterstown","State":"PA","Gas":810,"coordinates":[-77.1672,39.8725]},{"Plant":"Palomar Energy","State":"CA","Gas":510,"coordinates":[-117.1178,33.1197]},{"Plant":"Donald Von Raesfeld Power Plant","State":"CA","Gas":154,"coordinates":[-121.9508,37.3767]},{"Plant":"Fox Energy Center","State":"WI","Gas":600,"coordinates":[-88.2089,44.3204]},{"Plant":"Malburg","State":"CA","Gas":143,"coordinates":[-118.2219,33.9986]},{"Plant":"Magnolia Power Project","State":"CA","Gas":316,"coordinates":[-118.3153,34.1786]},{"Plant":"Walnut Energy Center","State":"CA","Gas":269,"coordinates":[-120.8956,37.4878]},{"Plant":"Currant Creek","State":"UT","Gas":527,"coordinates":[-111.8935,39.8214]},{"Plant":"Mankato Energy Center","State":"MN","Gas":500,"coordinates":[-94.003,44.1988]},{"Plant":"Bennett Mountain","State":"ID","Gas":164,"coordinates":[-115.6657,43.1482]},{"Plant":"McIntosh Combined Cycle Facility","State":"GA","Gas":1184,"coordinates":[-81.1817,32.3478]},{"Plant":"South Harper","State":"MO","Gas":315,"coordinates":[-94.4824,38.6803]},{"Plant":"Faribault Energy Park","State":"MN","Gas":160.2,"coordinates":[-93.2906,44.3356]},{"Plant":"Sheboygan Falls","State":"WI","Gas":294.56,"coordinates":[-87.8781,43.7518]},{"Plant":"Nebo Power Station","State":"UT","Gas":120.4,"coordinates":[-111.7294,40.0614]},{"Plant":"500MW CC","State":"NY","Gas":454.08,"coordinates":[-73.9069,40.7889]},{"Plant":"EG178 Facility","State":"TX","Gas":108,"coordinates":[-100.9547,32.7471]},{"Plant":"Kings River","State":"CA","Gas":109,"coordinates":[-119.7404,36.6697]},{"Plant":"Mustang Station Unit 4","State":"TX","Gas":145,"coordinates":[-102.7436,32.9746]},{"Plant":"Western 102 Power Plant","State":"NV","Gas":110.6,"coordinates":[-119.5108,39.5603]},{"Plant":"Jonesboro City Water & Light Plant","State":"AR","Gas":131,"coordinates":[-90.7254,35.8486]},{"Plant":"Olive","State":"CA","Gas":154.5,"coordinates":[-118.3147,34.1764]},{"Plant":"Collins","State":"IL","Gas":2671,"coordinates":[-88.3928,41.3461]},{"Plant":"Belle River","State":"MI","Gas":225,"coordinates":[-82.495,42.7756]},{"Plant":"Greenwood","State":"MI","Gas":225,"coordinates":[-82.6964,43.1056]},{"Plant":"Manatee","State":"FL","Gas":1114,"coordinates":[-82.3456,27.6058]},{"Plant":"Martin","State":"FL","Gas":3657,"coordinates":[-80.5628,27.0536]},{"Plant":"DeBary","State":"FL","Gas":249,"coordinates":[-81.3323,28.9039]},{"Plant":"Electrifarm","State":"IA","Gas":199.8,"coordinates":[-92.4205,42.4407]},{"Plant":"Fredonia","State":"WA","Gas":316,"coordinates":[-122.4358,48.4558]},{"Plant":"Trimble County","State":"KY","Gas":960,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Gas":966,"coordinates":[-88.5553,30.5322]},{"Plant":"Greenwood","State":"MO","Gas":232,"coordinates":[-94.2982,38.8615]},{"Plant":"R M Schahfer","State":"IN","Gas":155,"coordinates":[-87.0261,41.2164]},{"Plant":"Cutler","State":"FL","Gas":170,"coordinates":[-80.2989,25.6321]},{"Plant":"Fort St Vrain","State":"CO","Gas":690,"coordinates":[-104.8742,40.2461]},{"Plant":"Fort Myers","State":"FL","Gas":1767,"coordinates":[-81.7831,26.6967]},{"Plant":"Whitehorn","State":"WA","Gas":130,"coordinates":[-122.6861,48.8288]},{"Plant":"McIntosh","State":"GA","Gas":657.6,"coordinates":[-81.1683,32.3563]},{"Plant":"Lauderdale","State":"FL","Gas":1699,"coordinates":[-80.1984,26.0686]},{"Plant":"A B Brown","State":"IN","Gas":160,"coordinates":[-87.715,37.9053]},{"Plant":"Port Everglades","State":"FL","Gas":420,"coordinates":[-80.1253,26.0856]},{"Plant":"Brame Energy Center","State":"LA","Gas":440,"coordinates":[-92.7167,31.395]},{"Plant":"John Twitty Energy Center","State":"MO","Gas":104,"coordinates":[-93.388,37.1517]},{"Plant":"Sanford","State":"FL","Gas":1928,"coordinates":[-81.3256,28.8419]},{"Plant":"Empire Energy Center","State":"MO","Gas":271,"coordinates":[-94.1041,37.1385]},{"Plant":"Dansby","State":"TX","Gas":157.1,"coordinates":[-96.4608,30.7217]},{"Plant":"Putnam","State":"FL","Gas":494,"coordinates":[-81.5851,29.6283]},{"Plant":"Higgins","State":"FL","Gas":110,"coordinates":[-82.6615,28.0033]},{"Plant":"Rokeby","State":"NE","Gas":248.2,"coordinates":[-96.7364,40.7316]},{"Plant":"Suwannee River","State":"FL","Gas":106,"coordinates":[-83.1806,30.3764]},{"Plant":"Lansing Smith","State":"FL","Gas":481,"coordinates":[-85.7003,30.2686]},{"Plant":"D G Hunter","State":"LA","Gas":157,"coordinates":[-92.4613,31.3207]},{"Plant":"George M Sullivan Generation Plant 2","State":"AK","Gas":219.9,"coordinates":[-149.7167,61.2297]},{"Plant":"Henry D King","State":"FL","Gas":129.4,"coordinates":[-80.3386,27.4486]},{"Plant":"Deerhaven Generating Station","State":"FL","Gas":194,"coordinates":[-82.3878,29.7592]},{"Plant":"John R Kelly","State":"FL","Gas":191,"coordinates":[-82.3208,29.6461]},{"Plant":"J D Kennedy","State":"FL","Gas":158.6,"coordinates":[-81.626,30.3648]},{"Plant":"Larsen Memorial","State":"FL","Gas":195,"coordinates":[-81.9228,28.0797]},{"Plant":"C D McIntosh Jr","State":"FL","Gas":524,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Gas":264,"coordinates":[-105.0212,40.8609]},{"Plant":"Indian River Plant","State":"FL","Gas":290,"coordinates":[-80.7801,28.4932]},{"Plant":"Arvah B Hopkins","State":"FL","Gas":432,"coordinates":[-84.4,30.4522]},{"Plant":"S O Purdom","State":"FL","Gas":301,"coordinates":[-84.2007,30.1623]},{"Plant":"Vero Beach Municipal Power Plant","State":"FL","Gas":150,"coordinates":[-80.3776,27.6334]},{"Plant":"Atkinson","State":"GA","Gas":182,"coordinates":[-84.4803,33.8175]},{"Plant":"Gravel Neck","State":"VA","Gas":292,"coordinates":[-76.6911,37.1575]},{"Plant":"McIntosh","State":"AL","Gas":338,"coordinates":[-88.0299,31.2546]},{"Plant":"Harry Allen","State":"NV","Gas":138.3,"coordinates":[-114.9024,36.4306]},{"Plant":"Pleasant Hill","State":"IA","Gas":163,"coordinates":[-93.5242,41.5572]},{"Plant":"Hay Road","State":"DE","Gas":1090,"coordinates":[-75.5072,39.7436]},{"Plant":"Woodsdale","State":"OH","Gas":462,"coordinates":[-84.4611,39.4492]},{"Plant":"Concord","State":"WI","Gas":388,"coordinates":[-88.69,43.1669]},{"Plant":"South Fond Du Lac","State":"WI","Gas":322.68,"coordinates":[-88.4967,43.7353]},{"Plant":"Darbytown","State":"VA","Gas":288,"coordinates":[-77.3685,37.4982]},{"Plant":"Angus Anson","State":"SD","Gas":383.93,"coordinates":[-96.6356,43.6035]},{"Plant":"Cane Island","State":"FL","Gas":380,"coordinates":[-81.533,28.2764]},{"Plant":"Polk","State":"FL","Gas":325,"coordinates":[-81.9897,27.7286]},{"Plant":"Woodland","State":"CA","Gas":133,"coordinates":[-121.0204,37.6526]},{"Plant":"491 E 48th Street","State":"MI","Gas":148.2,"coordinates":[-86.0853,42.7553]},{"Plant":"Paris","State":"WI","Gas":400,"coordinates":[-88.0131,42.6658]},{"Plant":"Lincoln Combustion","State":"NC","Gas":1267.2,"coordinates":[-81.0347,35.4317]},{"Plant":"State Line Combined Cycle","State":"MO","Gas":589,"coordinates":[-94.614,37.0659]},{"Plant":"Hines Energy Complex","State":"FL","Gas":1456,"coordinates":[-81.87,27.7882]},{"Plant":"Redding Power","State":"CA","Gas":133.6,"coordinates":[-122.4233,40.5073]},{"Plant":"San Jacinto Steam Electric Station","State":"TX","Gas":162,"coordinates":[-95.0406,29.6948]},{"Plant":"Kraft","State":"GA","Gas":132,"coordinates":[-81.1458,32.1486]},{"Plant":"Anderson","State":"IN","Gas":142,"coordinates":[-85.7389,40.0529]},{"Plant":"Riverside","State":"GA","Gas":107,"coordinates":[-81.0956,32.0836]},{"Plant":"Robins","State":"GA","Gas":160,"coordinates":[-83.5822,32.5792]},{"Plant":"Coyote Springs","State":"OR","Gas":213,"coordinates":[-119.6739,45.848]},{"Plant":"Midulla Generating Station","State":"FL","Gas":758,"coordinates":[-81.9625,27.6417]},{"Plant":"Interstate","State":"IL","Gas":128,"coordinates":[-89.5891,39.8233]},{"Plant":"Rathdrum","State":"ID","Gas":136,"coordinates":[-116.8673,47.8043]},{"Plant":"Arthur Von Rosenberg","State":"TX","Gas":465,"coordinates":[-98.384,29.257]},{"Plant":"Carson Ice-Gen Project","State":"CA","Gas":101,"coordinates":[-121.4624,38.4457]},{"Plant":"Wayne County","State":"NC","Gas":686,"coordinates":[-78.0981,35.3758]},{"Plant":"Ponca City","State":"OK","Gas":107,"coordinates":[-97.0858,36.7198]},{"Plant":"SCA Cogen 2","State":"CA","Gas":154.6,"coordinates":[-121.4001,38.5309]},{"Plant":"SPA Cogen 3","State":"CA","Gas":164,"coordinates":[-121.4735,38.511]},{"Plant":"St Francis Energy Facility","State":"MO","Gas":473,"coordinates":[-90.1779,36.5852]},{"Plant":"River Road Gen Plant","State":"WA","Gas":220,"coordinates":[-122.7256,45.6497]},{"Plant":"Tiger Bay","State":"FL","Gas":203,"coordinates":[-81.8494,27.7464]},{"Plant":"Dahlberg","State":"GA","Gas":750,"coordinates":[-83.3977,34.0423]},{"Plant":"H Allen Franklin Combined Cycle","State":"AL","Gas":1186,"coordinates":[-85.0975,32.6078]},{"Plant":"Theodore Cogen Facility","State":"AL","Gas":224.7,"coordinates":[-88.1285,30.5254]},{"Plant":"Essex","State":"MO","Gas":107.4,"coordinates":[-89.8402,36.8682]},{"Plant":"Nodaway","State":"MO","Gas":182.8,"coordinates":[-94.7913,40.2877]},{"Plant":"Chouteau","State":"OK","Gas":495,"coordinates":[-95.2771,36.2221]},{"Plant":"Georgetown","State":"IN","Gas":295,"coordinates":[-86.2441,39.9026]},{"Plant":"Tilton","State":"IL","Gas":176,"coordinates":[-87.6538,40.1061]},{"Plant":"Henry County","State":"IN","Gas":135.5,"coordinates":[-85.5039,39.9528]},{"Plant":"MPC Generating","State":"GA","Gas":315.12,"coordinates":[-83.6953,33.8119]},{"Plant":"Sherwood H Smith Jr Energy Complex","State":"NC","Gas":1231,"coordinates":[-79.7406,34.8392]},{"Plant":"Sewell Creek Energy","State":"GA","Gas":497.5,"coordinates":[-85.2769,33.9486]},{"Plant":"Alsey","State":"IL","Gas":121,"coordinates":[-90.436,39.5698]},{"Plant":"Fulton","State":"AR","Gas":153,"coordinates":[-93.7924,33.6094]},{"Plant":"Rowan","State":"NC","Gas":977.01,"coordinates":[-80.6019,35.7314]},{"Plant":"Smarr Energy Center","State":"GA","Gas":219.5,"coordinates":[-83.8464,32.9842]},{"Plant":"John S Rainey","State":"SC","Gas":958.2,"coordinates":[-82.776,34.3477]},{"Plant":"Essential Power Rock Springs LLC","State":"MD","Gas":632.2,"coordinates":[-76.1598,39.719]},{"Plant":"Marsh Run Generating","State":"VA","Gas":469.5,"coordinates":[-77.7681,38.5283]},{"Plant":"Louisa Generating","State":"VA","Gas":458.5,"coordinates":[-78.2139,38.1181]},{"Plant":"Remington","State":"VA","Gas":580,"coordinates":[-77.7714,38.5442]},{"Plant":"Ladysmith","State":"VA","Gas":290,"coordinates":[-77.5133,38.0722]},{"Plant":"Pleasant Valley","State":"MN","Gas":420.4,"coordinates":[-92.6829,43.7994]},{"Plant":"Lagoon Creek","State":"TN","Gas":940.8,"coordinates":[-89.3964,35.6578]},{"Plant":"Brandy Branch","State":"FL","Gas":660.8,"coordinates":[-81.9472,30.3206]},{"Plant":"Holden","State":"MO","Gas":232.8,"coordinates":[-93.9983,38.7538]},{"Plant":"MEPI GT Facility","State":"IL","Gas":239,"coordinates":[-88.8661,37.2175]},{"Plant":"Encogen","State":"WA","Gas":170,"coordinates":[-122.486,48.746]},{"Plant":"Robert P Mone Plant","State":"OH","Gas":447,"coordinates":[-84.7392,40.9297]},{"Plant":"H L Culbreath Bayside Power Station","State":"FL","Gas":1632,"coordinates":[-82.4231,27.9072]},{"Plant":"Terry Bundy Generating Station","State":"NE","Gas":165.8,"coordinates":[-96.6131,40.9097]},{"Plant":"E B Harris Electric Generating Plant","State":"AL","Gas":1253.7,"coordinates":[-86.5744,32.3814]},{"Plant":"Sand Hill","State":"TX","Gas":501.2,"coordinates":[-97.6129,30.2098]},{"Plant":"Talbot County Energy","State":"GA","Gas":676.5,"coordinates":[-84.6917,32.5892]},{"Plant":"Chattahoochee Energy Facility","State":"GA","Gas":465,"coordinates":[-85.0386,33.4072]},{"Plant":"Lakefield Junction","State":"MN","Gas":499.6,"coordinates":[-94.8415,43.7984]},{"Plant":"West Gardner","State":"KS","Gas":308,"coordinates":[-94.9861,38.7875]},{"Plant":"Coyote Springs II","State":"OR","Gas":244,"coordinates":[-119.674,45.848]},{"Plant":"Wansley Unit 9","State":"GA","Gas":504.4,"coordinates":[-85.0403,33.4083]},{"Plant":"Lawrence County Station","State":"IN","Gas":261,"coordinates":[-86.4511,38.8003]},{"Plant":"Kemper County","State":"MS","Gas":312.8,"coordinates":[-88.606,32.7976]},{"Plant":"Peno Creek","State":"MO","Gas":188,"coordinates":[-91.2295,39.3531]},{"Plant":"Sumpter","State":"MI","Gas":296,"coordinates":[-83.5318,42.167]},{"Plant":"Pyramid","State":"NM","Gas":158,"coordinates":[-108.5494,32.2363]},{"Plant":"Mill Creek","State":"SC","Gas":595.36,"coordinates":[-81.4306,35.1597]},{"Plant":"Greater Des Moines","State":"IA","Gas":491,"coordinates":[-93.5283,41.5563]},{"Plant":"Silver Creek","State":"MS","Gas":225,"coordinates":[-89.9468,31.6004]},{"Plant":"Sylvarena","State":"MS","Gas":129,"coordinates":[-89.4127,31.9821]},{"Plant":"West Campus Cogeneration Facility","State":"WI","Gas":130.2,"coordinates":[-89.4251,43.0751]},{"Plant":"Beatrice","State":"NE","Gas":237,"coordinates":[-96.8082,40.3302]},{"Plant":"Blue Lake","State":"MN","Gas":315.8,"coordinates":[-93.4315,44.7855]},{"Plant":"Sycamore","State":"IA","Gas":149,"coordinates":[-93.6769,41.6722]},{"Plant":"Emery Station","State":"IA","Gas":558.76,"coordinates":[-93.2922,43.094]},{"Plant":"Intercession City","State":"FL","Gas":567,"coordinates":[-81.5486,28.2628]},{"Plant":"Gerald Andrus","State":"MS","Gas":670,"coordinates":[-91.1167,33.35]},{"Plant":"Waterford 1 & 2","State":"LA","Gas":805,"coordinates":[-90.4768,29.9989]},{"Plant":"Comanche","State":"OK","Gas":260,"coordinates":[-98.3244,34.5431]},{"Plant":"DeCordova Steam Electric Station","State":"TX","Gas":1138,"coordinates":[-97.7006,32.4031]},{"Plant":"Santan","State":"AZ","Gas":1227,"coordinates":[-111.7503,33.3325]},{"Plant":"Beaver","State":"OR","Gas":494.8,"coordinates":[-123.1739,46.1724]},{"Plant":"Glen Gardner","State":"NJ","Gas":160,"coordinates":[-74.9207,40.6815]},{"Plant":"Grand Tower","State":"IL","Gas":516,"coordinates":[-89.5112,37.6577]},{"Plant":"Calumet","State":"IL","Gas":203.9,"coordinates":[-87.5428,41.7136]},{"Plant":"Crawford","State":"IL","Gas":172.8,"coordinates":[-87.7229,41.8285]},{"Plant":"Electric Junction","State":"IL","Gas":217.4,"coordinates":[-88.0833,41.8333]},{"Plant":"Joliet 9","State":"IL","Gas":115.1,"coordinates":[-88.1153,41.4931]},{"Plant":"Astoria Generating Station","State":"NY","Gas":192,"coordinates":[-73.9126,40.7877]},{"Plant":"Wood River","State":"IL","Gas":116.01,"coordinates":[-90.1347,38.8639]},{"Plant":"Venice","State":"IL","Gas":503,"coordinates":[-90.1764,38.6642]},{"Plant":"Beluga","State":"AK","Gas":344.4,"coordinates":[-151.0356,61.1861]},{"Plant":"Marion","State":"IL","Gas":140,"coordinates":[-88.9531,37.6197]},{"Plant":"Frederickson","State":"WA","Gas":144,"coordinates":[-122.365,47.0797]},{"Plant":"Harding Street","State":"IN","Gas":322,"coordinates":[-86.1969,39.7113]},{"Plant":"Dean H Mitchell","State":"IN","Gas":142,"coordinates":[-87.4069,41.6392]},{"Plant":"Michigan City","State":"IN","Gas":120,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Gas":740,"coordinates":[-87.7811,32.6017]},{"Plant":"Gilroy Power Plant","State":"CA","Gas":130,"coordinates":[-121.5367,37.0001]},{"Plant":"Noblesville","State":"IN","Gas":285.9,"coordinates":[-85.9714,40.0969]},{"Plant":"Pedricktown Cogeneration Company LP","State":"NJ","Gas":119.2,"coordinates":[-75.4238,39.7668]},{"Plant":"Broadway","State":"IN","Gas":115,"coordinates":[-87.6049,37.9691]},{"Plant":"Butler-Warner Generation Plant","State":"NC","Gas":225,"coordinates":[-78.8294,35.0986]},{"Plant":"El Segundo Cogen","State":"CA","Gas":127.7,"coordinates":[-118.4031,33.9058]},{"Plant":"ArcelorMittal Burns Harbor","State":"IN","Gas":174.7,"coordinates":[-87.1387,41.635]},{"Plant":"King City Power Plant","State":"CA","Gas":111,"coordinates":[-121.1278,36.225]},{"Plant":"Bayou Cogen Plant","State":"TX","Gas":260,"coordinates":[-95.0458,29.6225]},{"Plant":"Bellingham Cogeneration Facility","State":"MA","Gas":264,"coordinates":[-71.4833,42.0925]},{"Plant":"Sayreville Cogeneration Facility","State":"NJ","Gas":271,"coordinates":[-74.3444,40.439]},{"Plant":"Foster Wheeler Martinez","State":"CA","Gas":103.5,"coordinates":[-122.0589,38.0244]},{"Plant":"ExxonMobil Baytown Refinery","State":"TX","Gas":176.8,"coordinates":[-94.9973,29.7535]},{"Plant":"RG Steel Sparrows Point, LLC","State":"MD","Gas":152.3,"coordinates":[-76.4729,39.213]},{"Plant":"Kern River Cogeneration","State":"CA","Gas":288,"coordinates":[-118.9849,35.4515]},{"Plant":"Formosa Utility Venture Ltd","State":"TX","Gas":597.3,"coordinates":[-96.5417,28.6917]},{"Plant":"Hopewell Cogeneration","State":"VA","Gas":348.3,"coordinates":[-77.2811,37.2917]},{"Plant":"CES Placerita Power Plant","State":"CA","Gas":115,"coordinates":[-118.4999,34.3801]},{"Plant":"ExxonMobil Baytown Turbine","State":"TX","Gas":320.4,"coordinates":[-95.0096,29.7591]},{"Plant":"Selkirk Cogen","State":"NY","Gas":365.6,"coordinates":[-73.8592,42.5744]},{"Plant":"Masspower","State":"MA","Gas":238.3,"coordinates":[-72.5225,42.1575]},{"Plant":"Clear Lake Cogeneration Ltd","State":"TX","Gas":366,"coordinates":[-95.067,29.6255]},{"Plant":"Midland Cogeneration Venture","State":"MI","Gas":1831.4,"coordinates":[-84.2242,43.5861]},{"Plant":"Camden Plant Holding LLC","State":"NJ","Gas":147.1,"coordinates":[-75.1192,39.9175]},{"Plant":"River Hills","State":"IA","Gas":116.8,"coordinates":[-93.6195,41.5902]},{"Plant":"Hazelton","State":"PA","Gas":147.2,"coordinates":[-76.0409,40.9282]},{"Plant":"Ocotillo","State":"AZ","Gas":320,"coordinates":[-111.9122,33.4225]},{"Plant":"West Phoenix","State":"AZ","Gas":1047.3,"coordinates":[-112.1583,33.4417]},{"Plant":"Saguaro","State":"AZ","Gas":386,"coordinates":[-111.3,32.5517]},{"Plant":"Yucca","State":"AZ","Gas":163,"coordinates":[-114.7106,32.7214]},{"Plant":"Fort Dodge","State":"KS","Gas":144.6,"coordinates":[-99.9497,37.7328]},{"Plant":"Riverton","State":"KS","Gas":194,"coordinates":[-94.6987,37.0726]},{"Plant":"Gordon Evans Energy Center","State":"KS","Gas":817,"coordinates":[-97.5217,37.7903]},{"Plant":"Murray Gill","State":"KS","Gas":296,"coordinates":[-97.4136,37.5967]},{"Plant":"Hutchinson Energy Center","State":"KS","Gas":390,"coordinates":[-97.8747,38.0906]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Gas":316,"coordinates":[-110.9047,32.16]},{"Plant":"Kaw","State":"KS","Gas":140.3,"coordinates":[-94.6514,39.0867]},{"Plant":"McPherson 2","State":"KS","Gas":131.5,"coordinates":[-97.6834,38.3634]},{"Plant":"Garden City","State":"KS","Gas":225.2,"coordinates":[-100.8956,37.9703]},{"Plant":"E W Brown","State":"KY","Gas":849,"coordinates":[-84.7126,37.7883]},{"Plant":"Paddys Run","State":"KY","Gas":193,"coordinates":[-85.8417,38.2236]},{"Plant":"Louisiana 1","State":"LA","Gas":382.4,"coordinates":[-91.1864,30.4922]},{"Plant":"Louisiana 2","State":"LA","Gas":138,"coordinates":[-91.1864,30.4922]},{"Plant":"R S Nelson","State":"LA","Gas":653,"coordinates":[-93.2911,30.2844]},{"Plant":"Willow Glen","State":"LA","Gas":1832,"coordinates":[-91.1164,30.2743]},{"Plant":"Coughlin Power Station","State":"LA","Gas":736,"coordinates":[-92.2611,30.8439]},{"Plant":"Teche","State":"LA","Gas":384,"coordinates":[-91.5425,29.8222]},{"Plant":"Little Gypsy","State":"LA","Gas":1198,"coordinates":[-90.4617,30.0051]},{"Plant":"Nine Mile Point","State":"LA","Gas":1752,"coordinates":[-90.1458,29.9472]},{"Plant":"Sterlington","State":"LA","Gas":392,"coordinates":[-92.0792,32.7047]},{"Plant":"A B Paterson","State":"LA","Gas":112,"coordinates":[-90.0256,30.0158]},{"Plant":"Michoud","State":"LA","Gas":825,"coordinates":[-89.9372,30.0081]},{"Plant":"Agua Fria","State":"AZ","Gas":626,"coordinates":[-112.2153,33.5561]},{"Plant":"Arsenal Hill","State":"LA","Gas":110,"coordinates":[-93.7611,32.5181]},{"Plant":"Lieberman","State":"LA","Gas":268,"coordinates":[-93.9597,32.7047]},{"Plant":"Louis Doc Bonin","State":"LA","Gas":302,"coordinates":[-92.0463,30.238]},{"Plant":"Monroe","State":"LA","Gas":126,"coordinates":[-92.1794,32.5233]},{"Plant":"Big Cajun 1","State":"LA","Gas":430,"coordinates":[-91.3556,30.6739]},{"Plant":"Kyrene","State":"AZ","Gas":525,"coordinates":[-111.9353,33.3556]},{"Plant":"Herbert A Wagner","State":"MD","Gas":126,"coordinates":[-76.5268,39.1781]},{"Plant":"Notch Cliff","State":"MD","Gas":120,"coordinates":[-76.5087,39.4217]},{"Plant":"Perryman","State":"MD","Gas":162,"coordinates":[-76.2218,39.4428]},{"Plant":"Riverside","State":"MD","Gas":193,"coordinates":[-76.5133,39.2369]},{"Plant":"Westport","State":"MD","Gas":116,"coordinates":[-76.6295,39.266]},{"Plant":"Dickerson","State":"MD","Gas":294,"coordinates":[-77.4644,39.2097]},{"Plant":"Mystic Generating Station","State":"MA","Gas":1937.7,"coordinates":[-71.0675,42.3908]},{"Plant":"New Boston Generating Station","State":"MA","Gas":702,"coordinates":[-71.0353,42.3392]},{"Plant":"Kendall Square Station","State":"MA","Gas":217.7,"coordinates":[-71.0792,42.3633]},{"Plant":"Apache Station","State":"AZ","Gas":198.5,"coordinates":[-109.8931,32.0603]},{"Plant":"Cecil Lynch","State":"AR","Gas":170,"coordinates":[-92.1987,34.7535]},{"Plant":"Hamilton Moses","State":"AR","Gas":140,"coordinates":[-90.8722,34.9806]},{"Plant":"Harvey Couch","State":"AR","Gas":137,"coordinates":[-93.4649,33.3592]},{"Plant":"B C Cobb","State":"MI","Gas":187,"coordinates":[-86.2423,43.2588]},{"Plant":"Lake Catherine","State":"AR","Gas":735,"coordinates":[-92.9049,34.4341]},{"Plant":"Dan E Karn","State":"MI","Gas":1276,"coordinates":[-83.8401,43.645]},{"Plant":"Thetford","State":"MI","Gas":192,"coordinates":[-83.6286,43.1567]},{"Plant":"Conners Creek","State":"MI","Gas":230,"coordinates":[-82.9597,42.3592]},{"Plant":"Delray","State":"MI","Gas":127,"coordinates":[-83.1019,42.2947]},{"Plant":"Robert E Ritchie","State":"AR","Gas":860,"coordinates":[-90.5987,34.4629]},{"Plant":"Hancock","State":"MI","Gas":141,"coordinates":[-83.4425,42.5497]},{"Plant":"River Rouge","State":"MI","Gas":234,"coordinates":[-83.1119,42.2739]},{"Plant":"Mistersky","State":"MI","Gas":154,"coordinates":[-83.0903,42.3039]},{"Plant":"Fox Lake","State":"MN","Gas":108.3,"coordinates":[-94.7075,43.6728]},{"Plant":"Black Dog","State":"MN","Gas":297.8,"coordinates":[-93.2501,44.8108]},{"Plant":"Inver Hills","State":"MN","Gas":350,"coordinates":[-93.042,44.781]},{"Plant":"Thomas Fitzhugh","State":"AR","Gas":171,"coordinates":[-93.8049,35.4624]},{"Plant":"Carl Bailey","State":"AR","Gas":122,"coordinates":[-91.3634,35.2601]},{"Plant":"McClellan","State":"AR","Gas":134,"coordinates":[-92.7917,33.5648]},{"Plant":"Cambridge CT","State":"MN","Gas":150,"coordinates":[-93.2081,45.601]},{"Plant":"Chevron Oil","State":"MS","Gas":127,"coordinates":[-88.4919,30.34]},{"Plant":"Sweatt","State":"MS","Gas":124,"coordinates":[-88.7461,32.2925]},{"Plant":"Jack Watson","State":"MS","Gas":292,"coordinates":[-89.0286,30.4392]},{"Plant":"Baxter Wilson","State":"MS","Gas":1200,"coordinates":[-90.9306,32.2831]},{"Plant":"Delta","State":"MS","Gas":192,"coordinates":[-90.7139,33.7947]},{"Plant":"Rex Brown","State":"MS","Gas":288,"coordinates":[-90.213,32.357]},{"Plant":"Moselle","State":"MS","Gas":327,"coordinates":[-89.3004,31.528]},{"Plant":"Hawthorn","State":"MO","Gas":420,"coordinates":[-94.4778,39.1306]},{"Plant":"Lake Road","State":"MO","Gas":128.7,"coordinates":[-94.8773,39.7246]},{"Plant":"James River Power Station","State":"MO","Gas":155,"coordinates":[-93.2619,37.1086]},{"Plant":"Canaday","State":"NE","Gas":118,"coordinates":[-99.7011,40.6942]},{"Plant":"C W Burdick","State":"NE","Gas":174.1,"coordinates":[-98.3269,40.9228]},{"Plant":"Contra Costa","State":"CA","Gas":672,"coordinates":[-121.7642,38.0192]},{"Plant":"Sarpy County","State":"NE","Gas":310.9,"coordinates":[-95.9706,41.1706]},{"Plant":"Clark","State":"NV","Gas":695,"coordinates":[-115.0507,36.0875]},{"Plant":"Sunrise","State":"NV","Gas":149,"coordinates":[-115.036,36.1384]},{"Plant":"Fort Churchill","State":"NV","Gas":226,"coordinates":[-119.1322,39.1281]},{"Plant":"Tracy","State":"NV","Gas":480.6,"coordinates":[-119.525,39.5625]},{"Plant":"Sayreville","State":"NJ","Gas":343,"coordinates":[-74.3523,40.4765]},{"Plant":"Gilbert","State":"NJ","Gas":540,"coordinates":[-75.1639,40.5658]},{"Plant":"Bergen Generating Station","State":"NJ","Gas":1246,"coordinates":[-74.0244,40.8375]},{"Plant":"PSEG Burlington Generating Station","State":"NJ","Gas":413,"coordinates":[-74.8792,40.0766]},{"Plant":"PSEG Edison Generating Station","State":"NJ","Gas":504,"coordinates":[-74.3956,40.4911]},{"Plant":"PSEG Essex Generating Station","State":"NJ","Gas":617,"coordinates":[-74.1206,40.7372]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Gas":355,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Kearny Generating Station","State":"NJ","Gas":616,"coordinates":[-74.0965,40.7373]},{"Plant":"PSEG Linden Generating Station","State":"NJ","Gas":1541,"coordinates":[-74.2072,40.6217]},{"Plant":"PSEG Sewaren Generating Station","State":"NJ","Gas":428,"coordinates":[-74.2469,40.5558]},{"Plant":"Rio Grande","State":"NM","Gas":236,"coordinates":[-106.5472,31.8047]},{"Plant":"Maddox","State":"NM","Gas":179,"coordinates":[-103.3015,32.7142]},{"Plant":"Reeves","State":"NM","Gas":154,"coordinates":[-106.6019,35.171]},{"Plant":"Cunningham","State":"NM","Gas":485,"coordinates":[-103.3533,32.7131]},{"Plant":"Humboldt Bay","State":"CA","Gas":105,"coordinates":[-124.2103,40.7415]},{"Plant":"Hunters Point","State":"CA","Gas":377,"coordinates":[-122.3897,37.7336]},{"Plant":"Arthur Kill Generating Station","State":"NY","Gas":841,"coordinates":[-74.2,40.5916]},{"Plant":"East River","State":"NY","Gas":295,"coordinates":[-73.9742,40.7281]},{"Plant":"Gowanus Gas Turbines Generating","State":"NY","Gas":293,"coordinates":[-74.0051,40.6635]},{"Plant":"Narrows Gas Turbines Generating","State":"NY","Gas":309.4,"coordinates":[-74.0208,40.6486]},{"Plant":"Ravenswood","State":"NY","Gas":2318.8,"coordinates":[-73.9461,40.7592]},{"Plant":"E F Barrett","State":"NY","Gas":685,"coordinates":[-73.6479,40.6167]},{"Plant":"Far Rockaway","State":"NY","Gas":105.6,"coordinates":[-73.761,40.6109]},{"Plant":"Glenwood","State":"NY","Gas":238.7,"coordinates":[-73.6475,40.8271]},{"Plant":"Northport","State":"NY","Gas":1569.9,"coordinates":[-73.3423,40.9236]},{"Plant":"Port Jefferson","State":"NY","Gas":468,"coordinates":[-73.0785,40.9497]},{"Plant":"Bethlehem Energy Center","State":"NY","Gas":1114.3,"coordinates":[-73.7638,42.5942]},{"Plant":"Dynegy Morro Bay LLC","State":"CA","Gas":999,"coordinates":[-120.8566,35.3722]},{"Plant":"Dynegy Moss Landing Power Plant","State":"CA","Gas":2529,"coordinates":[-121.7822,36.8048]},{"Plant":"Bowline Point","State":"NY","Gas":1139,"coordinates":[-73.9689,41.2044]},{"Plant":"Asheville","State":"NC","Gas":328,"coordinates":[-82.5417,35.4731]},{"Plant":"Pittsburg Power","State":"CA","Gas":1906,"coordinates":[-121.8945,38.0392]},{"Plant":"Potrero Power","State":"CA","Gas":206,"coordinates":[-122.387,37.7566]},{"Plant":"Riverbend","State":"NC","Gas":120,"coordinates":[-80.9742,35.36]},{"Plant":"Dicks Creek","State":"OH","Gas":106.2,"coordinates":[-84.3778,39.465]},{"Plant":"Frank M Tait","State":"OH","Gas":259,"coordinates":[-84.2111,39.7272]},{"Plant":"FirstEnergy West Lorain","State":"OH","Gas":425,"coordinates":[-82.2644,41.4294]},{"Plant":"Richland","State":"OH","Gas":358,"coordinates":[-84.3346,41.3052]},{"Plant":"Horseshoe Lake","State":"OK","Gas":875.7,"coordinates":[-97.1797,35.5087]},{"Plant":"Muskogee","State":"OK","Gas":170.5,"coordinates":[-95.2873,35.7614]},{"Plant":"Mustang","State":"OK","Gas":526.4,"coordinates":[-97.675,35.4699]},{"Plant":"Seminole","State":"OK","Gas":1542.5,"coordinates":[-96.7258,34.9665]},{"Plant":"Northeastern","State":"OK","Gas":877,"coordinates":[-95.7008,36.4317]},{"Plant":"Southwestern","State":"OK","Gas":451,"coordinates":[-98.3524,35.1009]},{"Plant":"Tulsa","State":"OK","Gas":370,"coordinates":[-95.991,36.1165]},{"Plant":"Weleetka","State":"OK","Gas":163,"coordinates":[-96.1352,35.3233]},{"Plant":"Barry","State":"AL","Gas":805,"coordinates":[-88.0103,31.0069]},{"Plant":"Anadarko Plant","State":"OK","Gas":350,"coordinates":[-98.23,35.0847]},{"Plant":"Mooreland","State":"OK","Gas":322,"coordinates":[-99.2254,36.4372]},{"Plant":"Encina","State":"CA","Gas":964,"coordinates":[-117.3364,33.1361]},{"Plant":"Kearny","State":"CA","Gas":136,"coordinates":[-117.1338,32.834]},{"Plant":"Brunot Island","State":"PA","Gas":278,"coordinates":[-80.0438,40.4649]},{"Plant":"Dynegy South Bay Power Plant","State":"CA","Gas":693,"coordinates":[-117.092,32.6114]},{"Plant":"AES Alamitos LLC","State":"CA","Gas":2130,"coordinates":[-118.1009,33.7688]},{"Plant":"Manchester Street","State":"RI","Gas":447,"coordinates":[-71.4042,41.8167]},{"Plant":"Darlington County","State":"SC","Gas":444,"coordinates":[-80.1657,34.4185]},{"Plant":"Buzzard Roost","State":"SC","Gas":196,"coordinates":[-81.9025,34.1692]},{"Plant":"W S Lee","State":"SC","Gas":159.8,"coordinates":[-82.435,34.6022]},{"Plant":"Coolwater","State":"CA","Gas":608,"coordinates":[-116.8539,34.8606]},{"Plant":"Urquhart","State":"SC","Gas":559,"coordinates":[-81.9111,33.435]},{"Plant":"El Segundo Power","State":"CA","Gas":940.6,"coordinates":[-118.4242,33.9098]},{"Plant":"Etiwanda Generating Station","State":"CA","Gas":1019,"coordinates":[-117.5266,34.0912]},{"Plant":"Riverside Canal Power","State":"CA","Gas":127,"coordinates":[-117.3312,34.0229]},{"Plant":"AES Huntington Beach LLC","State":"CA","Gas":1036.6,"coordinates":[-117.9792,33.6439]},{"Plant":"Allen Steam Plant","State":"TN","Gas":461.6,"coordinates":[-90.1487,35.0741]},{"Plant":"Gallatin","State":"TN","Gas":599.2,"coordinates":[-86.4006,36.3156]},{"Plant":"Johnsonville","State":"TN","Gas":1135.2,"coordinates":[-87.9861,36.0278]},{"Plant":"Long Beach Generation LLC","State":"CA","Gas":592,"coordinates":[-118.2248,33.7641]},{"Plant":"E S Joslin","State":"TX","Gas":254,"coordinates":[-96.5458,28.6472]},{"Plant":"J L Bates","State":"TX","Gas":182,"coordinates":[-98.3944,26.2222]},{"Plant":"Laredo","State":"TX","Gas":169,"coordinates":[-99.5089,27.5667]},{"Plant":"Lon C Hill","State":"TX","Gas":559,"coordinates":[-97.6167,27.85]},{"Plant":"Nueces Bay","State":"TX","Gas":559,"coordinates":[-97.4192,27.8194]},{"Plant":"La Palma","State":"TX","Gas":255,"coordinates":[-97.6389,26.1331]},{"Plant":"Victoria","State":"TX","Gas":491,"coordinates":[-97.01,28.7883]},{"Plant":"Mandalay","State":"CA","Gas":560,"coordinates":[-119.2511,34.2067]},{"Plant":"Lake Hubbard","State":"TX","Gas":921,"coordinates":[-96.5458,32.8358]},{"Plant":"Mountain Creek","State":"TX","Gas":884,"coordinates":[-96.9358,32.7231]},{"Plant":"North Lake","State":"TX","Gas":715,"coordinates":[-96.975,32.9506]},{"Plant":"Parkdale","State":"TX","Gas":327,"coordinates":[-96.7233,32.7767]},{"Plant":"Newman","State":"TX","Gas":474,"coordinates":[-106.4318,31.9836]},{"Plant":"Lewis Creek","State":"TX","Gas":459,"coordinates":[-95.5214,30.4356]},{"Plant":"Neches","State":"TX","Gas":265,"coordinates":[-94.0593,30.0612]},{"Plant":"Sabine","State":"TX","Gas":1814,"coordinates":[-93.878,30.0242]},{"Plant":"Cedar Bayou","State":"TX","Gas":2258,"coordinates":[-94.9256,29.75]},{"Plant":"Deepwater","State":"TX","Gas":174,"coordinates":[-95.2253,29.7199]},{"Plant":"Greens Bayou","State":"TX","Gas":760,"coordinates":[-95.2194,29.8222]},{"Plant":"P H Robinson","State":"TX","Gas":2211,"coordinates":[-94.9794,29.4867]},{"Plant":"Sam Bertron","State":"TX","Gas":841,"coordinates":[-95.0598,29.7268]},{"Plant":"T H Wharton","State":"TX","Gas":1254,"coordinates":[-95.5306,29.9417]},{"Plant":"W A Parish","State":"TX","Gas":1191,"coordinates":[-95.6311,29.4828]},{"Plant":"Webster","State":"TX","Gas":387,"coordinates":[-95.1081,29.5258]},{"Plant":"Knox Lee","State":"TX","Gas":485,"coordinates":[-94.6415,32.3766]},{"Plant":"Wilkes","State":"TX","Gas":881,"coordinates":[-94.548,32.8482]},{"Plant":"Jones","State":"TX","Gas":486,"coordinates":[-101.7392,33.5239]},{"Plant":"Nichols","State":"TX","Gas":457,"coordinates":[-101.7464,35.2834]},{"Plant":"Plant X","State":"TX","Gas":442,"coordinates":[-102.4114,34.1661]},{"Plant":"Eagle Mountain","State":"TX","Gas":665,"coordinates":[-97.4792,32.9056]},{"Plant":"Graham","State":"TX","Gas":630,"coordinates":[-98.6117,33.1344]},{"Plant":"Handley","State":"TX","Gas":1381,"coordinates":[-97.2192,32.7283]},{"Plant":"Morgan Creek","State":"TX","Gas":1354,"coordinates":[-100.9156,32.3358]},{"Plant":"Permian Basin","State":"TX","Gas":1055,"coordinates":[-102.9633,31.5839]},{"Plant":"Ormond Beach","State":"CA","Gas":1516,"coordinates":[-119.1689,34.1292]},{"Plant":"Collin","State":"TX","Gas":154,"coordinates":[-96.8034,33.1576]},{"Plant":"Lake Creek","State":"TX","Gas":317,"coordinates":[-96.985,31.4647]},{"Plant":"River Crest","State":"TX","Gas":110,"coordinates":[-95.1467,33.3931]},{"Plant":"Stryker Creek","State":"TX","Gas":675,"coordinates":[-94.9898,31.9398]},{"Plant":"Tradinghouse","State":"TX","Gas":1383,"coordinates":[-96.9642,31.5728]},{"Plant":"Trinidad","State":"TX","Gas":240,"coordinates":[-96.1013,32.1245]},{"Plant":"Valley","State":"TX","Gas":1115,"coordinates":[-96.3676,33.6281]},{"Plant":"Paint Creek","State":"TX","Gas":231,"coordinates":[-99.7337,33.1576]},{"Plant":"Rio Pecos","State":"TX","Gas":141,"coordinates":[-102.3753,31.0706]},{"Plant":"San Angelo","State":"TX","Gas":123,"coordinates":[-100.491,31.3906]},{"Plant":"Decker Creek","State":"TX","Gas":932,"coordinates":[-97.6128,30.3033]},{"Plant":"Holly Street","State":"TX","Gas":591,"coordinates":[-97.7167,30.25]},{"Plant":"Silas Ray","State":"TX","Gas":125,"coordinates":[-97.5214,25.9131]},{"Plant":"AES Redondo Beach LLC","State":"CA","Gas":1310,"coordinates":[-118.395,33.8504]},{"Plant":"Bryan","State":"TX","Gas":130,"coordinates":[-96.3723,30.6474]},{"Plant":"Ray Olinger","State":"TX","Gas":405.3,"coordinates":[-96.4525,33.0681]},{"Plant":"Mountainview Generating Station","State":"CA","Gas":1062.2,"coordinates":[-117.2418,34.0818]},{"Plant":"Sim Gideon","State":"TX","Gas":620,"coordinates":[-97.2708,30.1456]},{"Plant":"Ty Cooke","State":"TX","Gas":135,"coordinates":[-101.7906,33.5211]},{"Plant":"J Robert Massengale","State":"TX","Gas":105,"coordinates":[-101.8408,33.6039]},{"Plant":"Leon Creek","State":"TX","Gas":339,"coordinates":[-98.5761,29.3525]},{"Plant":"O W Sommers","State":"TX","Gas":826,"coordinates":[-98.3242,29.3081]},{"Plant":"V H Braunig","State":"TX","Gas":863,"coordinates":[-98.3825,29.2567]},{"Plant":"W B Tuttle","State":"TX","Gas":414,"coordinates":[-98.4181,29.53]},{"Plant":"R W Miller","State":"TX","Gas":574,"coordinates":[-98.3103,32.6581]},{"Plant":"Sam Rayburn","State":"TX","Gas":227,"coordinates":[-97.135,28.8947]},{"Plant":"Gadsby","State":"UT","Gas":352,"coordinates":[-111.9289,40.7686]},{"Plant":"Grayson","State":"CA","Gas":289.9,"coordinates":[-118.2782,34.1556]},{"Plant":"Chesterfield","State":"VA","Gas":397,"coordinates":[-77.3833,37.3822]},{"Plant":"Possum Point","State":"VA","Gas":844,"coordinates":[-77.2806,38.5367]},{"Plant":"Transalta Centralia Generation","State":"WA","Gas":256,"coordinates":[-122.8598,46.7559]},{"Plant":"El Centro","State":"CA","Gas":225.9,"coordinates":[-115.54,32.8022]},{"Plant":"Harbor","State":"CA","Gas":500,"coordinates":[-118.2656,33.7706]},{"Plant":"Haynes","State":"CA","Gas":2024.9,"coordinates":[-118.0991,33.7647]},{"Plant":"Wheaton","State":"WI","Gas":233.3,"coordinates":[-91.5158,44.8854]},{"Plant":"Scattergood","State":"CA","Gas":803,"coordinates":[-118.4276,33.9182]},{"Plant":"Port Washington Generating Station","State":"WI","Gas":575,"coordinates":[-87.8689,43.3842]},{"Plant":"Rock River","State":"WI","Gas":296.9,"coordinates":[-89.0276,42.582]},{"Plant":"West Marinette","State":"WI","Gas":151.6,"coordinates":[-87.6881,45.0869]},{"Plant":"Valley","State":"CA","Gas":1068,"coordinates":[-118.3913,34.245]},{"Plant":"Broadway","State":"CA","Gas":161,"coordinates":[-118.148,34.1254]},{"Plant":"Glenarm","State":"CA","Gas":155,"coordinates":[-118.1494,34.126]},{"Plant":"Spencer","State":"TX","Gas":171,"coordinates":[-97.1061,33.1975]},{"Plant":"Colbert","State":"AL","Gas":390.4,"coordinates":[-87.8486,34.7439]},{"Plant":"Thomas C Ferguson","State":"TX","Gas":420,"coordinates":[-98.3705,30.558]},{"Plant":"Fort Phantom","State":"TX","Gas":362,"coordinates":[-99.6778,32.5784]},{"Plant":"Barney M Davis","State":"TX","Gas":682,"coordinates":[-97.3117,27.6064]},{"Plant":"Riverside","State":"OK","Gas":909,"coordinates":[-95.9567,35.9978]},{"Plant":"Pittsfield Generating LP","State":"MA","Gas":141,"coordinates":[-73.2181,42.4564]},{"Plant":"Linden Cogen Plant","State":"NJ","Gas":899.8,"coordinates":[-74.2156,40.6322]},{"Plant":"Houston Chemical Complex Battleground","State":"TX","Gas":274,"coordinates":[-95.0839,29.7314]},{"Plant":"Paris Energy Center","State":"TX","Gas":238,"coordinates":[-95.5577,33.6968]},{"Plant":"Hal C Weaver Power Plant","State":"TX","Gas":131.4,"coordinates":[-97.7356,30.2867]},{"Plant":"Sycamore Cogeneration","State":"CA","Gas":300,"coordinates":[-118.9853,35.4526]},{"Plant":"Union Carbide Seadrift Cogen","State":"TX","Gas":168,"coordinates":[-96.7706,28.5105]},{"Plant":"Dow St Charles Operations","State":"LA","Gas":291.6,"coordinates":[-90.4414,29.9861]},{"Plant":"Watson Cogeneration","State":"CA","Gas":398,"coordinates":[-118.2448,33.8166]},{"Plant":"Bucksport Generation LLC","State":"ME","Gas":249.8,"coordinates":[-68.8046,44.5738]},{"Plant":"Bethpage Power Plant","State":"NY","Gas":184,"coordinates":[-73.4994,40.7469]},{"Plant":"Shell Deer Park","State":"TX","Gas":140,"coordinates":[-95.1289,29.7232]},{"Plant":"Newark Bay Cogeneration Partnership LP","State":"NJ","Gas":123,"coordinates":[-74.13,40.7197]},{"Plant":"Indeck Corinth Energy Center","State":"NY","Gas":131.5,"coordinates":[-73.8125,43.25]},{"Plant":"PPG Powerhouse C","State":"LA","Gas":303.2,"coordinates":[-93.2831,30.2242]},{"Plant":"Bayonne Plant Holding LLC","State":"NJ","Gas":160,"coordinates":[-74.1124,40.6553]},{"Plant":"Harbor Cogen","State":"CA","Gas":101.7,"coordinates":[-118.2303,33.7771]},{"Plant":"Rosemary Power Station","State":"NC","Gas":165,"coordinates":[-77.6594,36.4517]},{"Plant":"Oklahoma Cogeneration Project","State":"OK","Gas":111.4,"coordinates":[-97.625,35.4397]},{"Plant":"Eagle Point Power Generation","State":"NJ","Gas":195,"coordinates":[-75.1592,39.8746]},{"Plant":"TXU Sweetwater Generating Plant","State":"TX","Gas":289,"coordinates":[-100.365,32.4928]},{"Plant":"ExxonMobil Beaumont Refinery","State":"TX","Gas":650.6,"coordinates":[-94.0753,30.0636]},{"Plant":"JM Shafer Generating Station","State":"CO","Gas":263,"coordinates":[-104.7736,40.0986]},{"Plant":"Gary Works","State":"IN","Gas":221,"coordinates":[-87.3289,41.6224]},{"Plant":"Parlin Power Plant","State":"NJ","Gas":118,"coordinates":[-74.3272,40.4607]},{"Plant":"Optim Energy Altura Cogen LLC","State":"TX","Gas":493,"coordinates":[-95.1077,29.8161]},{"Plant":"Gramercy Holdings LLC","State":"LA","Gas":106,"coordinates":[-90.6693,30.054]},{"Plant":"Hardee Power Station","State":"FL","Gas":358,"coordinates":[-81.9636,27.6364]},{"Plant":"Bellmeade Power Station","State":"VA","Gas":232,"coordinates":[-77.4317,37.4964]},{"Plant":"Pryor Power Plant","State":"OK","Gas":111.5,"coordinates":[-95.3175,36.2977]},{"Plant":"Ocean State Power","State":"RI","Gas":218.6,"coordinates":[-71.6689,42.0097]},{"Plant":"LaO Energy Systems","State":"LA","Gas":574,"coordinates":[-91.2325,30.3186]},{"Plant":"Doswell Energy Center","State":"VA","Gas":819.8,"coordinates":[-77.1448,37.8182]},{"Plant":"Elizabeth River Power Station","State":"VA","Gas":300,"coordinates":[-76.3083,36.775]},{"Plant":"Texas City Power Plant","State":"TX","Gas":451,"coordinates":[-94.9438,29.3787]},{"Plant":"Dow Chemical Texas Operation","State":"TX","Gas":1132.1,"coordinates":[-95.4075,28.9913]},{"Plant":"Power Station 4","State":"TX","Gas":172,"coordinates":[-94.9219,29.3782]},{"Plant":"Midway Sunset Cogen","State":"CA","Gas":219,"coordinates":[-119.6294,35.2269]},{"Plant":"C R Wing Cogen Plant","State":"TX","Gas":227,"coordinates":[-101.4224,32.2732]},{"Plant":"Delaware City Plant","State":"DE","Gas":308,"coordinates":[-75.6343,39.5871]},{"Plant":"McWilliams","State":"AL","Gas":650,"coordinates":[-86.4764,31.4003]},{"Plant":"J K Smith","State":"KY","Gas":608,"coordinates":[-84.1017,37.8833]},{"Plant":"Lockport Energy Associates LP","State":"NY","Gas":203,"coordinates":[-78.745,43.1619]},{"Plant":"Kennedy International Airport Cogen","State":"NY","Gas":126.1,"coordinates":[-73.7778,40.6417]},{"Plant":"March Point Cogeneration","State":"WA","Gas":146.2,"coordinates":[-122.56,48.4708]},{"Plant":"Saguaro Power","State":"NV","Gas":101,"coordinates":[-115.0117,36.0417]},{"Plant":"Ocean State Power II","State":"RI","Gas":218.6,"coordinates":[-71.6701,42.0099]},{"Plant":"Orange Cogeneration Facility","State":"FL","Gas":110.6,"coordinates":[-81.8251,27.8708]},{"Plant":"Lake Cogen Ltd","State":"FL","Gas":123,"coordinates":[-81.676,28.9158]},{"Plant":"Pasco Cogen Ltd","State":"FL","Gas":128.8,"coordinates":[-82.1889,28.3746]},{"Plant":"Mulberry Cogeneration Facility","State":"FL","Gas":113,"coordinates":[-81.8775,27.8489]},{"Plant":"Orlando Cogen LP","State":"FL","Gas":120,"coordinates":[-81.4123,28.4426]},{"Plant":"Sumas Power Plant","State":"WA","Gas":125.5,"coordinates":[-122.2733,48.9905]},{"Plant":"Formosa Plastics","State":"LA","Gas":115,"coordinates":[-91.1872,30.4992]},{"Plant":"Ferndale Generating Station","State":"WA","Gas":271,"coordinates":[-122.6867,48.8288]},{"Plant":"Hartwell Energy Facility","State":"GA","Gas":300.4,"coordinates":[-82.8199,34.3396]},{"Plant":"Sithe Independence Station","State":"NY","Gas":982.2,"coordinates":[-76.4511,43.495]},{"Plant":"Saranac Facility","State":"NY","Gas":240,"coordinates":[-73.4557,44.7132]},{"Plant":"NAEA Lakewood LLC","State":"NJ","Gas":205.1,"coordinates":[-74.1686,40.0613]},{"Plant":"Auburndale Power Partners","State":"FL","Gas":154.7,"coordinates":[-81.8058,28.0542]},{"Plant":"Oyster Creek Unit VIII","State":"TX","Gas":379,"coordinates":[-95.342,28.9802]},{"Plant":"Hermiston Generating Plant","State":"OR","Gas":464,"coordinates":[-119.37,45.8042]},{"Plant":"Grays Ferry Cogeneration","State":"PA","Gas":150,"coordinates":[-75.1881,39.9422]},{"Plant":"Milford Power LP","State":"MA","Gas":148,"coordinates":[-71.5115,42.1294]},{"Plant":"Milagro Cogeneration Plant","State":"NM","Gas":121.6,"coordinates":[-107.9417,36.7367]},{"Plant":"Johnson County","State":"TX","Gas":267,"coordinates":[-97.4078,32.3994]},{"Plant":"Brandywine Power Facility","State":"MD","Gas":230,"coordinates":[-76.8678,38.6681]},{"Plant":"Gordonsville Energy LP","State":"VA","Gas":218,"coordinates":[-78.2138,38.1179]},{"Plant":"Sun Peak Generating Station","State":"NV","Gas":222,"coordinates":[-115.0339,36.1375]},{"Plant":"Brooklyn Navy Yard Cogeneration","State":"NY","Gas":230,"coordinates":[-73.9764,40.6994]},{"Plant":"Michigan Power LP","State":"MI","Gas":128,"coordinates":[-86.425,43.9375]},{"Plant":"LSP-Cottage Grove LP","State":"MN","Gas":251,"coordinates":[-92.9119,44.7956]},{"Plant":"LSP-Whitewater LP","State":"WI","Gas":261,"coordinates":[-88.7299,42.8555]},{"Plant":"Sweeny Cogen Facility","State":"TX","Gas":436,"coordinates":[-95.745,29.0728]},{"Plant":"Dighton Power Plant","State":"MA","Gas":146,"coordinates":[-71.1239,41.8312]},{"Plant":"De Pere Energy Center","State":"WI","Gas":167.9,"coordinates":[-88.072,44.4486]},{"Plant":"Androscoggin Energy Center","State":"ME","Gas":127.2,"coordinates":[-70.2423,44.5063]},{"Plant":"Delta Person LLC","State":"NM","Gas":140,"coordinates":[-106.644,35.026]},{"Plant":"Mid-Georgia Cogeneration Facility","State":"GA","Gas":316,"coordinates":[-83.6039,32.4856]},{"Plant":"Berkshire Power","State":"MA","Gas":232.1,"coordinates":[-72.6478,42.0476]},{"Plant":"Bridgeport Energy Project","State":"CT","Gas":454,"coordinates":[-73.1844,41.1692]},{"Plant":"Pasadena Cogeneration","State":"TX","Gas":700,"coordinates":[-95.1765,29.7248]},{"Plant":"Tiverton Power Plant","State":"RI","Gas":250,"coordinates":[-71.1706,41.6422]},{"Plant":"Axiall Plaquemine","State":"LA","Gas":240,"coordinates":[-91.185,30.2586]},{"Plant":"Tenaska Frontier Generation Station","State":"TX","Gas":860,"coordinates":[-95.9178,30.5924]},{"Plant":"Batesville Generation Facility","State":"MS","Gas":858,"coordinates":[-89.9275,34.3356]},{"Plant":"Black Hawk Station","State":"TX","Gas":221.4,"coordinates":[-101.36,35.6957]},{"Plant":"Mustang Station","State":"TX","Gas":486,"coordinates":[-102.7417,32.9728]},{"Plant":"Maine Independence Station","State":"ME","Gas":490,"coordinates":[-68.7094,44.8242]},{"Plant":"Pine Bluff Energy Center","State":"AR","Gas":192,"coordinates":[-91.9025,34.2181]},{"Plant":"Desert Star Energy Center","State":"NV","Gas":450,"coordinates":[-114.9928,35.7867]},{"Plant":"Millennium Power","State":"MA","Gas":325.1,"coordinates":[-72.0151,42.1123]},{"Plant":"New Albany Energy Facility","State":"MS","Gas":360,"coordinates":[-88.9397,34.5408]},{"Plant":"Brownsville Peaking Power","State":"TN","Gas":450,"coordinates":[-89.198,35.5438]},{"Plant":"Crockett Cogen Project","State":"CA","Gas":247.4,"coordinates":[-122.2161,38.0569]},{"Plant":"Gregory Power Facility","State":"TX","Gas":366,"coordinates":[-97.2584,27.8893]},{"Plant":"Zeeland Generating Station","State":"MI","Gas":868,"coordinates":[-85.9975,42.8206]},{"Plant":"Dearborn Industrial Generation","State":"MI","Gas":700,"coordinates":[-83.154,42.3026]},{"Plant":"Taft Cogeneration Facility","State":"LA","Gas":790,"coordinates":[-90.4599,29.9888]},{"Plant":"Midlothian Energy Facility","State":"TX","Gas":1278,"coordinates":[-97.0537,32.4302]},{"Plant":"Lamar Power Project","State":"TX","Gas":1004,"coordinates":[-95.59,33.6308]},{"Plant":"Frontera Energy Center","State":"TX","Gas":475,"coordinates":[-98.3992,26.208]},{"Plant":"NRG Sterlington Power","State":"LA","Gas":176,"coordinates":[-92.0811,32.6889]},{"Plant":"Rumford Power Associates","State":"ME","Gas":254,"coordinates":[-70.5219,44.5303]},{"Plant":"Livingston Generating Station","State":"MI","Gas":132,"coordinates":[-84.7308,45.0304]},{"Plant":"Klamath Cogeneration Plant","State":"OR","Gas":470,"coordinates":[-121.8106,42.1739]},{"Plant":"Sabine Cogen","State":"TX","Gas":101,"coordinates":[-93.7714,30.0444]},{"Plant":"Entergy Rhode Island State Energy LP","State":"RI","Gas":528,"coordinates":[-71.5186,41.8017]},{"Plant":"Rocky Road Power LLC","State":"IL","Gas":340,"coordinates":[-88.2397,42.0931]},{"Plant":"Madison","State":"OH","Gas":576,"coordinates":[-84.4647,39.4522]},{"Plant":"Vermillion Energy Facility","State":"IN","Gas":560,"coordinates":[-87.4464,39.9223]},{"Plant":"Sutter Energy Center","State":"CA","Gas":530,"coordinates":[-121.6959,39.0531]},{"Plant":"Rockingham County CT Station","State":"NC","Gas":775,"coordinates":[-79.8297,36.3297]},{"Plant":"RS Cogen","State":"LA","Gas":395.6,"coordinates":[-93.2992,30.221]},{"Plant":"SRW Cogen LP","State":"TX","Gas":420,"coordinates":[-93.7574,30.0545]},{"Plant":"Magic Valley Generating Station","State":"TX","Gas":682,"coordinates":[-98.19,26.3403]},{"Plant":"Griffith Energy LLC","State":"AZ","Gas":570,"coordinates":[-114.1333,35.054]},{"Plant":"Milford Power Project","State":"CT","Gas":489,"coordinates":[-73.0997,41.2244]},{"Plant":"Manchief Electric Generating Station","State":"CO","Gas":264,"coordinates":[-103.685,40.2171]},{"Plant":"Walton County Power LLC","State":"GA","Gas":460.2,"coordinates":[-83.6954,33.8148]},{"Plant":"Desert Basin","State":"AZ","Gas":577,"coordinates":[-111.7889,32.9042]},{"Plant":"Kendall County Generation Facility","State":"IL","Gas":1140,"coordinates":[-88.2581,41.4797]},{"Plant":"Tenaska Gateway Generating Station","State":"TX","Gas":863,"coordinates":[-94.6197,32.0178]},{"Plant":"Alliant Energy Neenah","State":"WI","Gas":300,"coordinates":[-88.5064,44.1936]},{"Plant":"Rio Nogales Power Project","State":"TX","Gas":705,"coordinates":[-97.9732,29.5931]},{"Plant":"Wolf Hollow I LP","State":"TX","Gas":695.5,"coordinates":[-97.7317,32.3342]},{"Plant":"Hawk Road Facility","State":"GA","Gas":492,"coordinates":[-84.9914,33.3585]},{"Plant":"Hays Energy Project","State":"TX","Gas":881,"coordinates":[-97.9894,29.7806]},{"Plant":"Green Country Energy LLC","State":"OK","Gas":783,"coordinates":[-95.9346,35.9833]},{"Plant":"Worthington Generation LLC","State":"IN","Gas":179.2,"coordinates":[-87.0128,39.0708]},{"Plant":"Lake Road Generating Plant","State":"CT","Gas":720.5,"coordinates":[-71.8958,41.872]},{"Plant":"La Paloma Generating LLC","State":"CA","Gas":965.4,"coordinates":[-119.5919,35.2956]},{"Plant":"Guadalupe Generating Station","State":"TX","Gas":1000,"coordinates":[-98.1419,29.6244]},{"Plant":"Lost Pines 1 Power Project","State":"TX","Gas":516,"coordinates":[-97.2714,30.1478]},{"Plant":"Bluegrass Generating Station","State":"KY","Gas":495,"coordinates":[-85.4133,38.3902]},{"Plant":"Calcasieu","State":"LA","Gas":310,"coordinates":[-93.345,30.1608]},{"Plant":"Broad River Energy Center","State":"SC","Gas":836.7,"coordinates":[-81.575,35.0786]},{"Plant":"Bastrop Energy Center","State":"TX","Gas":552,"coordinates":[-97.55,30.1458]},{"Plant":"Granite Ridge","State":"NH","Gas":797,"coordinates":[-71.4261,42.9042]},{"Plant":"Bosque County Peaking","State":"TX","Gas":548,"coordinates":[-97.3586,31.8594]},{"Plant":"Acadia Energy Center","State":"LA","Gas":1063,"coordinates":[-92.4131,30.4286]},{"Plant":"Eastman Cogeneration Facility","State":"TX","Gas":402.2,"coordinates":[-94.6903,32.4481]},{"Plant":"South Point Energy Center","State":"AZ","Gas":550,"coordinates":[-114.5317,34.8678]},{"Plant":"Dogwood Energy Facility","State":"MO","Gas":620,"coordinates":[-94.3006,38.7931]},{"Plant":"Rathdrum Power LLC","State":"ID","Gas":248,"coordinates":[-116.9203,47.7858]},{"Plant":"Sunrise Power LLC","State":"CA","Gas":545,"coordinates":[-119.585,35.2097]},{"Plant":"Channelview Cogeneration Plant","State":"TX","Gas":779,"coordinates":[-95.1217,29.837]},{"Plant":"Cordova Energy","State":"IL","Gas":521.2,"coordinates":[-90.2797,41.7122]},{"Plant":"Osceola","State":"FL","Gas":468,"coordinates":[-81.0978,28.1289]},{"Plant":"Ontelaunee Energy Center","State":"PA","Gas":516,"coordinates":[-75.9356,40.4219]},{"Plant":"Caledonia","State":"MS","Gas":744,"coordinates":[-88.2717,33.6464]},{"Plant":"Riverside Generating LLC","State":"KY","Gas":825,"coordinates":[-82.6046,38.1917]},{"Plant":"Elwood Energy LLC","State":"IL","Gas":1350,"coordinates":[-88.1236,41.4388]},{"Plant":"Arapahoe Combustion Turbine Project","State":"CO","Gas":122.5,"coordinates":[-105.0018,39.6692]},{"Plant":"Gibson City","State":"IL","Gas":226,"coordinates":[-88.3987,40.4705]},{"Plant":"Pinckneyville","State":"IL","Gas":320,"coordinates":[-89.3467,38.1114]},{"Plant":"Kinmundy","State":"IL","Gas":232,"coordinates":[-89.0128,38.7619]},{"Plant":"Corpus Christi Energy Center","State":"TX","Gas":482.1,"coordinates":[-97.4283,27.8139]},{"Plant":"Brush IV","State":"CO","Gas":140,"coordinates":[-103.6267,40.2419]},{"Plant":"Afton Generating Station","State":"NM","Gas":235.6,"coordinates":[-106.8465,32.1142]},{"Plant":"ANP Bellingham Energy Project","State":"MA","Gas":475,"coordinates":[-71.4535,42.1106]},{"Plant":"ANP Blackstone Energy Project","State":"MA","Gas":437.1,"coordinates":[-71.5158,42.0599]},{"Plant":"Odessa Ector Generating Station","State":"TX","Gas":1026.2,"coordinates":[-102.3264,31.8403]},{"Plant":"Morris Cogeneration LLC","State":"IL","Gas":176,"coordinates":[-88.3328,41.4119]},{"Plant":"Los Medanos Energy Center","State":"CA","Gas":567,"coordinates":[-121.873,38.0301]},{"Plant":"Hinds Energy Facility","State":"MS","Gas":450,"coordinates":[-90.2199,32.379]},{"Plant":"Southaven Energy Facility","State":"MS","Gas":624,"coordinates":[-90.0397,34.9808]},{"Plant":"Attala","State":"MS","Gas":455,"coordinates":[-89.6753,33.0147]},{"Plant":"Harry L. Oswald","State":"AR","Gas":548,"coordinates":[-92.2166,34.5923]},{"Plant":"Lincoln Generating Facility","State":"IL","Gas":628.2,"coordinates":[-87.9436,41.3933]},{"Plant":"Ennis Power Company LLC","State":"TX","Gas":359.5,"coordinates":[-96.675,32.32]},{"Plant":"Wheatland Generating Facility","State":"IN","Gas":472,"coordinates":[-87.2931,38.6716]},{"Plant":"Oneta Energy Center","State":"OK","Gas":1086.4,"coordinates":[-95.6967,36.0119]},{"Plant":"Freestone Energy Center","State":"TX","Gas":984,"coordinates":[-96.1131,31.8907]},{"Plant":"Greenville Electric Generating Station","State":"OH","Gas":176,"coordinates":[-84.6151,40.0758]},{"Plant":"Montpelier Electric Generating Station","State":"IN","Gas":180,"coordinates":[-85.3057,40.6206]},{"Plant":"Jack County","State":"TX","Gas":620.5,"coordinates":[-97.9574,33.101]},{"Plant":"Liberty Electric Power Plant","State":"PA","Gas":521,"coordinates":[-75.3358,39.8614]},{"Plant":"Marshall Energy Facility","State":"KY","Gas":620.8,"coordinates":[-88.3958,37.0286]},{"Plant":"Handsome Lake Energy LLC","State":"PA","Gas":267.5,"coordinates":[-79.8061,41.2908]},{"Plant":"Audrain Generating Station","State":"MO","Gas":600,"coordinates":[-91.5369,39.3092]},{"Plant":"Lee Energy Facility","State":"IL","Gas":623.5,"coordinates":[-89.4054,41.8287]},{"Plant":"Energy Shelby County","State":"IL","Gas":371.6,"coordinates":[-88.4772,39.2794]},{"Plant":"NRG Rockford I","State":"IL","Gas":296.9,"coordinates":[-89.1012,42.2386]},{"Plant":"Red Oak Power LLC","State":"NJ","Gas":765.9,"coordinates":[-74.3489,40.4487]},{"Plant":"Hog Bayou Energy Center","State":"AL","Gas":230,"coordinates":[-88.0575,30.7478]},{"Plant":"Santa Rosa Energy Center","State":"FL","Gas":235.9,"coordinates":[-87.115,30.5664]},{"Plant":"Astoria Gas Turbines","State":"NY","Gas":420,"coordinates":[-73.9048,40.787]},{"Plant":"Doyle Energy Facility","State":"GA","Gas":355,"coordinates":[-83.6996,33.8377]},{"Plant":"Darby Electric Generating Station","State":"OH","Gas":435,"coordinates":[-83.1778,39.7139]},{"Plant":"Tait Electric Generating Station","State":"OH","Gas":340,"coordinates":[-84.2095,39.7277]},{"Plant":"University Park South","State":"IL","Gas":300,"coordinates":[-87.7532,41.4409]},{"Plant":"Gleason Generating Facility","State":"TN","Gas":495,"coordinates":[-88.612,36.2454]},{"Plant":"Crete Energy Venture LLC","State":"IL","Gas":300,"coordinates":[-87.6187,41.4294]},{"Plant":"Whiting Clean Energy","State":"IN","Gas":547,"coordinates":[-87.4775,41.6739]},{"Plant":"Edward L. Addison Generating Plant","State":"GA","Gas":608,"coordinates":[-84.3064,32.9111]},{"Plant":"TVA Southaven Combined Cycle","State":"MS","Gas":759,"coordinates":[-90.0378,34.9939]},{"Plant":"Jackson Generating Station","State":"MI","Gas":564,"coordinates":[-84.3767,42.2488]},{"Plant":"Tenaska Lindsay Hill Generating Station","State":"AL","Gas":857.9,"coordinates":[-86.7386,32.6514]},{"Plant":"Ceredo Generating Station","State":"WV","Gas":450,"coordinates":[-82.5339,38.3681]},{"Plant":"Aurora","State":"IL","Gas":878,"coordinates":[-88.2265,41.8151]},{"Plant":"Southeast Chicago Energy Project","State":"IL","Gas":296,"coordinates":[-87.5449,41.7181]},{"Plant":"Arlington Valley Energy Facility","State":"AZ","Gas":580,"coordinates":[-112.8897,33.3417]},{"Plant":"Front Range Power Plant","State":"CO","Gas":461.5,"coordinates":[-104.7069,38.6281]},{"Plant":"Big Sandy Peaker Plant","State":"WV","Gas":300,"coordinates":[-82.5938,38.3441]},{"Plant":"Wolf Hills Energy","State":"VA","Gas":250,"coordinates":[-82.1044,36.6644]},{"Plant":"Oleander Power Project LP","State":"FL","Gas":310.7,"coordinates":[-80.7947,28.3661]},{"Plant":"Decatur Energy Center","State":"AL","Gas":624,"coordinates":[-87.0214,34.6292]},{"Plant":"Morgan Energy Center","State":"AL","Gas":749,"coordinates":[-87.0639,34.6397]},{"Plant":"Westbrook Energy Center Power Plant","State":"ME","Gas":506,"coordinates":[-70.375,43.6575]},{"Plant":"Blythe Energy Inc","State":"CA","Gas":514,"coordinates":[-114.6865,33.6157]},{"Plant":"Calumet Energy Team LLC","State":"IL","Gas":329,"coordinates":[-87.5563,41.6835]},{"Plant":"New Covert Generating Facility","State":"MI","Gas":1058.4,"coordinates":[-86.2937,42.3224]},{"Plant":"Fairless Energy Center","State":"PA","Gas":1150.7,"coordinates":[-74.7411,40.1475]},{"Plant":"Channel Energy Center LLC","State":"TX","Gas":585,"coordinates":[-95.2319,29.7189]},{"Plant":"Warren Peaking Power Facility","State":"MS","Gas":300,"coordinates":[-90.9284,32.2849]},{"Plant":"Baconton Power Plant","State":"GA","Gas":195.2,"coordinates":[-84.08,31.3869]},{"Plant":"Gila River Power Station","State":"AZ","Gas":2060,"coordinates":[-112.6944,32.975]},{"Plant":"Air Products Port Arthur","State":"TX","Gas":129.1,"coordinates":[-93.9651,29.8665]},{"Plant":"Ingleside Cogeneration","State":"TX","Gas":460,"coordinates":[-97.2428,27.8828]},{"Plant":"Fore River Generating Station","State":"MA","Gas":683.4,"coordinates":[-70.9661,42.2422]},{"Plant":"Wise County Power LLC","State":"TX","Gas":655,"coordinates":[-97.9103,33.0583]},{"Plant":"Chuck Lenzie Generating Station","State":"NV","Gas":1128,"coordinates":[-114.9218,36.3837]},{"Plant":"Baytown Energy Center","State":"TX","Gas":770,"coordinates":[-94.9019,29.7731]},{"Plant":"Hermiston Power Partnership","State":"OR","Gas":615,"coordinates":[-119.3133,45.794]},{"Plant":"Washington County","State":"GA","Gas":623.9,"coordinates":[-82.98,33.0922]},{"Plant":"Delta Energy Center","State":"CA","Gas":758.1,"coordinates":[-121.8439,38.0169]},{"Plant":"Holland Energy Facility","State":"IL","Gas":449,"coordinates":[-88.7584,39.2231]},{"Plant":"PPL Ironwood LLC","State":"PA","Gas":669,"coordinates":[-76.3658,40.3509]},{"Plant":"Dell Power Station","State":"AR","Gas":679,"coordinates":[-90.0253,35.8619]},{"Plant":"Luna Energy Facility","State":"NM","Gas":559,"coordinates":[-107.7834,32.2993]},{"Plant":"Armstrong","State":"PA","Gas":584,"coordinates":[-79.3517,40.638]},{"Plant":"Troy Energy LLC","State":"OH","Gas":584,"coordinates":[-83.4598,41.4772]},{"Plant":"Pleasants Energy LLC","State":"WV","Gas":292.2,"coordinates":[-81.3642,39.3325]},{"Plant":"Brazos Valley Generating Facility","State":"TX","Gas":525,"coordinates":[-95.6244,29.4731]},{"Plant":"Cottonwood Energy Project","State":"TX","Gas":1233.6,"coordinates":[-93.7353,30.2588]},{"Plant":"Sugar Creek Power","State":"IN","Gas":520.7,"coordinates":[-87.5108,39.3931]},{"Plant":"Exelon LaPorte Generating Station","State":"TX","Gas":153.2,"coordinates":[-95.0718,29.7028]},{"Plant":"Harquahala Generating Project","State":"AZ","Gas":1054.4,"coordinates":[-113.1134,33.476]},{"Plant":"Astoria Energy","State":"NY","Gas":480,"coordinates":[-73.8964,40.7825]},{"Plant":"Union Power Partners LP","State":"AR","Gas":2020,"coordinates":[-92.5894,33.2961]},{"Plant":"Thomas A Smith Energy Facility","State":"GA","Gas":1250,"coordinates":[-84.9175,34.7094]},{"Plant":"Columbia Energy Center","State":"SC","Gas":464.5,"coordinates":[-81.0178,33.8697]},{"Plant":"RockGen Energy Center","State":"WI","Gas":471,"coordinates":[-89.0492,42.9767]},{"Plant":"Zion Energy Center","State":"IL","Gas":456,"coordinates":[-87.895,42.4776]},{"Plant":"Metcalf Energy Center","State":"CA","Gas":546.1,"coordinates":[-121.7457,37.2207]},{"Plant":"Crossroads Energy Center","State":"MS","Gas":308,"coordinates":[-90.5621,34.183]},{"Plant":"Washington Energy Facility","State":"OH","Gas":600,"coordinates":[-81.6564,39.58]},{"Plant":"Elk Hills Power LLC","State":"CA","Gas":525,"coordinates":[-119.4707,35.2803]},{"Plant":"Rolling Hills Generating","State":"OH","Gas":825,"coordinates":[-82.3328,39.0839]},{"Plant":"Renaissance Power LLC","State":"MI","Gas":660,"coordinates":[-84.8429,43.1864]},{"Plant":"Carville Energy LLC","State":"LA","Gas":473,"coordinates":[-91.065,30.2294]},{"Plant":"Athens Generating Plant","State":"NY","Gas":1137.9,"coordinates":[-73.8492,42.2728]},{"Plant":"Effingham County Power Project","State":"GA","Gas":463.4,"coordinates":[-81.2844,32.2773]},{"Plant":"Calhoun Energy Center","State":"AL","Gas":628,"coordinates":[-85.9731,33.5883]},{"Plant":"Osprey Energy Center Power Plant","State":"FL","Gas":595.1,"coordinates":[-81.8083,28.0525]},{"Plant":"Shady Hills Generating Station","State":"FL","Gas":468,"coordinates":[-82.5586,28.3665]},{"Plant":"Vandolah Power Station","State":"FL","Gas":632,"coordinates":[-81.924,27.5236]},{"Plant":"Raccoon Creek Energy Center","State":"IL","Gas":300,"coordinates":[-88.5392,38.6996]},{"Plant":"Hot Spring Generating Facility","State":"AR","Gas":651.6,"coordinates":[-92.8683,34.2976]},{"Plant":"Plaquemine Cogeneration Plant","State":"LA","Gas":793,"coordinates":[-91.2347,30.3217]},{"Plant":"DeSoto County Plant","State":"FL","Gas":320,"coordinates":[-81.8092,27.2272]},{"Plant":"Bayou Cove Peaking Power","State":"LA","Gas":300,"coordinates":[-92.5997,30.2825]},{"Plant":"Elgin Energy Center","State":"IL","Gas":460,"coordinates":[-88.2446,42.0001]},{"Plant":"Tenaska Virginia Generating Station","State":"VA","Gas":935.4,"coordinates":[-78.3813,37.8667]},{"Plant":"Tenaska Central Alabama Generating Stn","State":"AL","Gas":864,"coordinates":[-86.74,32.6497]},{"Plant":"Columbia Energy Center","State":"MO","Gas":140,"coordinates":[-92.2629,39.0192]},{"Plant":"Magnolia Power Plant","State":"MS","Gas":863.1,"coordinates":[-89.2026,34.835]},{"Plant":"Fountain Valley Power Facility","State":"CO","Gas":234,"coordinates":[-104.6875,38.5569]},{"Plant":"Red Hawk","State":"AZ","Gas":948,"coordinates":[-112.8406,33.3346]},{"Plant":"McClain Energy Facility","State":"OK","Gas":363.1,"coordinates":[-97.5898,35.2977]},{"Plant":"Redbud Power Plant","State":"OK","Gas":1143.6,"coordinates":[-97.2264,35.6856]},{"Plant":"Deer Park Energy Center","State":"TX","Gas":877.2,"coordinates":[-95.1345,29.7134]},{"Plant":"Ouachita","State":"LA","Gas":816,"coordinates":[-92.0683,32.7061]},{"Plant":"Green Power 2","State":"TX","Gas":584,"coordinates":[-94.9328,29.3781]},{"Plant":"Forney Energy Center","State":"TX","Gas":1640,"coordinates":[-96.4916,32.7563]},{"Plant":"Mesquite Generating Station","State":"AZ","Gas":1073.3,"coordinates":[-112.8642,33.345]},{"Plant":"Goldendale Generating Station","State":"WA","Gas":219.9,"coordinates":[-120.833,45.8114]},{"Plant":"Tri Center Naniwa Energy","State":"NV","Gas":300,"coordinates":[-119.5178,39.5572]},{"Plant":"Goose Creek Energy Center","State":"IL","Gas":432,"coordinates":[-88.5999,40.1069]},{"Plant":"Kiamichi Energy Facility","State":"OK","Gas":1178.4,"coordinates":[-95.9349,34.6831]},{"Plant":"Lawrenceburg Energy Facility","State":"IN","Gas":1080,"coordinates":[-84.8669,39.0911]},{"Plant":"AEP Waterford Facility","State":"OH","Gas":810,"coordinates":[-81.7178,39.5333]},{"Plant":"Limon Generating Station","State":"CO","Gas":134,"coordinates":[-103.7005,39.2038]},{"Plant":"Frank Knutson","State":"CO","Gas":134,"coordinates":[-104.682,39.9411]},{"Plant":"Apex Generating Station","State":"NV","Gas":494.4,"coordinates":[-114.9609,36.416]},{"Plant":"Fayette Energy Facility","State":"PA","Gas":600.5,"coordinates":[-79.9182,39.8592]},{"Plant":"Wallingford Energy","State":"CT","Gas":190,"coordinates":[-72.8354,41.4487]},{"Plant":"High Desert Power Plant","State":"CA","Gas":780,"coordinates":[-117.3647,34.5953]},{"Plant":"AES Greystone","State":"TN","Gas":468,"coordinates":[-89.3937,35.6532]},{"Plant":"Sundance","State":"AZ","Gas":410,"coordinates":[-111.5899,32.9285]},{"Plant":"Indigo Energy Facility","State":"CA","Gas":149.7,"coordinates":[-116.553,33.9109]},{"Plant":"Hidalgo Energy Center","State":"TX","Gas":470,"coordinates":[-98.1758,26.3417]},{"Plant":"Perryville Power Station","State":"LA","Gas":691,"coordinates":[-92.0183,32.6908]},{"Plant":"West Valley Generation Project","State":"UT","Gas":202,"coordinates":[-112.0317,40.6667]},{"Plant":"University Park North","State":"IL","Gas":504,"coordinates":[-87.7514,41.4425]},{"Plant":"Riverside Energy Center","State":"WI","Gas":598.3,"coordinates":[-89.0355,42.5827]},{"Plant":"Blue Spruce Energy Center","State":"CO","Gas":276,"coordinates":[-104.6814,39.7479]},{"Plant":"Plains End","State":"CO","Gas":114,"coordinates":[-105.226,39.8575]},{"Plant":"Spring Creek Energy Center","State":"OK","Gas":300,"coordinates":[-97.655,35.7422]},{"Plant":"Pastoria Energy Facility, LLC","State":"CA","Gas":724,"coordinates":[-118.844,34.9556]},{"Plant":"EP Newington Energy LLC","State":"NH","Gas":525,"coordinates":[-70.8061,43.1047]},{"Plant":"Chehalis Generating Facility","State":"WA","Gas":495,"coordinates":[-122.9131,46.6225]},{"Plant":"Harrison County Power Project","State":"TX","Gas":514.4,"coordinates":[-94.4367,32.3958]},{"Plant":"Lower Mount Bethel Energy","State":"PA","Gas":593.8,"coordinates":[-75.1076,40.8019]},{"Plant":"AL Sandersville LLC","State":"GA","Gas":624,"coordinates":[-82.8608,33.1189]},{"Plant":"Higgins Generating Station","State":"NV","Gas":570,"coordinates":[-115.3561,35.6139]},{"Plant":"Bethlehem Power Plant","State":"PA","Gas":1092,"coordinates":[-75.3147,40.6175]},{"Plant":"Quantum Choctaw Power LLC","State":"MS","Gas":650,"coordinates":[-89.2089,33.3792]},{"Plant":"Pierce Power Station","State":"WA","Gas":130.9,"coordinates":[-122.3758,47.1365]},{"Plant":"Choctaw County","State":"MS","Gas":776,"coordinates":[-89.4201,33.2881]},{"Plant":"Allegheny Energy Units 3 4 & 5","State":"PA","Gas":509,"coordinates":[-79.7686,40.5453]},{"Plant":"Magnet Cove","State":"AR","Gas":641.5,"coordinates":[-92.8317,34.4297]},{"Plant":"Dean","State":"MI","Gas":295.4,"coordinates":[-82.4953,42.7725]},{"Plant":"Bennett Mountain","State":"ID","Gas":164,"coordinates":[-115.6666,43.1472]},{"Plant":"Hanging Rock Energy Facility","State":"OH","Gas":1288,"coordinates":[-82.7833,38.5731]},{"Plant":"Los Esteros Critical Energy Center","State":"CA","Gas":180,"coordinates":[-121.9319,37.425]},{"Plant":"FPL Energy Marcus Hook LP","State":"PA","Gas":717.5,"coordinates":[-75.4216,39.807]},{"Plant":"Gilroy Peaking Energy Center","State":"CA","Gas":128.3,"coordinates":[-121.5363,36.999]},{"Plant":"Frederickson Power LP","State":"WA","Gas":246,"coordinates":[-122.3657,47.0861]},{"Plant":"Curtis H Stanton Energy Center","State":"FL","Gas":592,"coordinates":[-81.1669,28.4882]},{"Plant":"Auburndale Peaker Energy Center","State":"FL","Gas":118,"coordinates":[-81.8059,28.0535]},{"Plant":"Rocky Mountain Energy Center","State":"CO","Gas":608,"coordinates":[-104.5953,40.0908]},{"Plant":"Silverhawk","State":"NV","Gas":560,"coordinates":[-114.9606,36.4078]},{"Plant":"Jasper","State":"SC","Gas":852,"coordinates":[-81.1242,32.3594]},{"Plant":"Tracy Combined Cycle Power Plant","State":"CA","Gas":163.6,"coordinates":[-121.4906,37.7107]},{"Plant":"NRG Rockford II Energy Center","State":"IL","Gas":154.6,"coordinates":[-89.1011,42.2383]},{"Plant":"NAEA Ocean Peaking Power LLC","State":"NJ","Gas":325.6,"coordinates":[-74.1672,40.0633]},{"Plant":"Las Vegas Cogeneration II LLC","State":"NV","Gas":220,"coordinates":[-115.1238,36.232]},{"Plant":"Wansley Combined Cycle","State":"GA","Gas":1129,"coordinates":[-85.037,33.4064]},{"Plant":"Cosumnes","State":"CA","Gas":477,"coordinates":[-121.124,38.3385]},{"Plant":"Cass County","State":"NE","Gas":320,"coordinates":[-95.964,40.9479]},{"Plant":"Hunterstown","State":"PA","Gas":855,"coordinates":[-77.1672,39.8725]},{"Plant":"Palomar Energy","State":"CA","Gas":522,"coordinates":[-117.1178,33.1197]},{"Plant":"Exira","State":"IA","Gas":140.9,"coordinates":[-94.9197,41.5144]},{"Plant":"Donald Von Raesfeld Power Plant","State":"CA","Gas":154,"coordinates":[-121.9508,37.3767]},{"Plant":"Fox Energy Center","State":"WI","Gas":600,"coordinates":[-88.2089,44.3204]},{"Plant":"Malburg","State":"CA","Gas":143,"coordinates":[-118.2219,33.9986]},{"Plant":"Magnolia Power Project","State":"CA","Gas":323,"coordinates":[-118.3153,34.1786]},{"Plant":"Walnut Energy Center","State":"CA","Gas":269,"coordinates":[-120.8956,37.4878]},{"Plant":"Currant Creek","State":"UT","Gas":527,"coordinates":[-111.8935,39.8214]},{"Plant":"Mankato Energy Center","State":"MN","Gas":300,"coordinates":[-94.003,44.1988]},{"Plant":"McIntosh Combined Cycle Facility","State":"GA","Gas":1184,"coordinates":[-81.1817,32.3478]},{"Plant":"South Harper","State":"MO","Gas":315,"coordinates":[-94.4824,38.6803]},{"Plant":"Freeport Energy Center","State":"TX","Gas":249.4,"coordinates":[-95.3954,28.9888]},{"Plant":"Faribault Energy Park","State":"MN","Gas":282.2,"coordinates":[-93.2906,44.3356]},{"Plant":"Sheboygan Falls","State":"WI","Gas":298,"coordinates":[-87.8781,43.7518]},{"Plant":"Nebo Power Station","State":"UT","Gas":120.4,"coordinates":[-111.7294,40.0614]},{"Plant":"500MW CC","State":"NY","Gas":454.1,"coordinates":[-73.9069,40.7889]},{"Plant":"Port Westward","State":"OR","Gas":381.5,"coordinates":[-123.172,46.1789]},{"Plant":"EG178 Facility","State":"TX","Gas":108,"coordinates":[-100.9547,32.7471]},{"Plant":"Lake Side Power Plant","State":"UT","Gas":488.5,"coordinates":[-111.7542,40.3317]},{"Plant":"Kings River","State":"CA","Gas":109,"coordinates":[-119.7404,36.6697]},{"Plant":"Anson County Generation Facility","State":"NC","Gas":339,"coordinates":[-79.9217,34.9687]},{"Plant":"Hamlet Generating Facility","State":"NC","Gas":282.5,"coordinates":[-79.7361,34.8423]},{"Plant":"Roseville Energy Park","State":"CA","Gas":141,"coordinates":[-121.3811,38.7928]},{"Plant":"Mustang Station Unit 4","State":"TX","Gas":290,"coordinates":[-102.7436,32.9746]},{"Plant":"Harry D Mattison Gas Plant","State":"AR","Gas":300,"coordinates":[-94.2841,36.1855]},{"Plant":"Quail Run Energy Center","State":"TX","Gas":380.5,"coordinates":[-102.315,31.8414]},{"Plant":"Colorado Bend Energy Center","State":"TX","Gas":405,"coordinates":[-96.0683,29.2878]},{"Plant":"Spindle Hill Energy Center","State":"CO","Gas":270,"coordinates":[-104.8878,40.0922]},{"Plant":"Western 102 Power Plant","State":"NV","Gas":110.6,"coordinates":[-119.5108,39.5603]},{"Plant":"Jonesboro City Water & Light Plant","State":"AR","Gas":177,"coordinates":[-90.7254,35.8486]},{"Plant":"Olive","State":"CA","Gas":154.5,"coordinates":[-118.3147,34.1764]},{"Plant":"Collins","State":"IL","Gas":2671,"coordinates":[-88.3928,41.3461]},{"Plant":"Belle River","State":"MI","Gas":225,"coordinates":[-82.495,42.7756]},{"Plant":"Greenwood","State":"MI","Gas":1010,"coordinates":[-82.6964,43.1056]},{"Plant":"Manatee","State":"FL","Gas":1104,"coordinates":[-82.3456,27.6058]},{"Plant":"Martin","State":"FL","Gas":3814,"coordinates":[-80.5628,27.0536]},{"Plant":"DeBary","State":"FL","Gas":247,"coordinates":[-81.3323,28.9039]},{"Plant":"Electrifarm","State":"IA","Gas":197.9,"coordinates":[-92.4205,42.4407]},{"Plant":"Fredonia","State":"WA","Gas":316,"coordinates":[-122.4358,48.4558]},{"Plant":"Trimble County","State":"KY","Gas":960,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Gas":966,"coordinates":[-88.5553,30.5322]},{"Plant":"Greenwood","State":"MO","Gas":238,"coordinates":[-94.2982,38.8615]},{"Plant":"R M Schahfer","State":"IN","Gas":155,"coordinates":[-87.0261,41.2164]},{"Plant":"Cutler","State":"FL","Gas":205,"coordinates":[-80.2989,25.6321]},{"Plant":"Fort St Vrain","State":"CO","Gas":695,"coordinates":[-104.8742,40.2461]},{"Plant":"Fort Myers","State":"FL","Gas":1764,"coordinates":[-81.7831,26.6967]},{"Plant":"Whitehorn","State":"WA","Gas":130,"coordinates":[-122.6861,48.8288]},{"Plant":"McIntosh","State":"GA","Gas":657.6,"coordinates":[-81.1683,32.3563]},{"Plant":"Lauderdale","State":"FL","Gas":1712,"coordinates":[-80.1984,26.0686]},{"Plant":"A B Brown","State":"IN","Gas":160,"coordinates":[-87.715,37.9053]},{"Plant":"Port Everglades","State":"FL","Gas":420,"coordinates":[-80.1253,26.0856]},{"Plant":"Brame Energy Center","State":"LA","Gas":435,"coordinates":[-92.7167,31.395]},{"Plant":"John Twitty Energy Center","State":"MO","Gas":104,"coordinates":[-93.388,37.1517]},{"Plant":"Sanford","State":"FL","Gas":1916,"coordinates":[-81.3256,28.8419]},{"Plant":"Turkey Point","State":"FL","Gas":1144,"coordinates":[-80.3308,25.4356]},{"Plant":"Empire Energy Center","State":"MO","Gas":272,"coordinates":[-94.1041,37.1385]},{"Plant":"Dansby","State":"TX","Gas":157.1,"coordinates":[-96.4608,30.7217]},{"Plant":"Putnam","State":"FL","Gas":498,"coordinates":[-81.5851,29.6283]},{"Plant":"Higgins","State":"FL","Gas":113,"coordinates":[-82.6615,28.0033]},{"Plant":"Rokeby","State":"NE","Gas":227.3,"coordinates":[-96.7364,40.7316]},{"Plant":"Suwannee River","State":"FL","Gas":103,"coordinates":[-83.1806,30.3764]},{"Plant":"Lansing Smith","State":"FL","Gas":481,"coordinates":[-85.7003,30.2686]},{"Plant":"D G Hunter","State":"LA","Gas":157,"coordinates":[-92.4613,31.3207]},{"Plant":"George M Sullivan Generation Plant 2","State":"AK","Gas":219.9,"coordinates":[-149.7167,61.2297]},{"Plant":"Henry D King","State":"FL","Gas":129.4,"coordinates":[-80.3386,27.4486]},{"Plant":"Deerhaven Generating Station","State":"FL","Gas":194,"coordinates":[-82.3878,29.7592]},{"Plant":"John R Kelly","State":"FL","Gas":191,"coordinates":[-82.3208,29.6461]},{"Plant":"J D Kennedy","State":"FL","Gas":158.6,"coordinates":[-81.626,30.3648]},{"Plant":"Larsen Memorial","State":"FL","Gas":145,"coordinates":[-81.9228,28.0797]},{"Plant":"C D McIntosh Jr","State":"FL","Gas":516,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Gas":260,"coordinates":[-105.0212,40.8609]},{"Plant":"Indian River Plant","State":"FL","Gas":290,"coordinates":[-80.7801,28.4932]},{"Plant":"Arvah B Hopkins","State":"FL","Gas":432,"coordinates":[-84.4,30.4522]},{"Plant":"S O Purdom","State":"FL","Gas":301,"coordinates":[-84.2007,30.1623]},{"Plant":"Vero Beach Municipal Power Plant","State":"FL","Gas":150,"coordinates":[-80.3776,27.6334]},{"Plant":"Atkinson","State":"GA","Gas":182,"coordinates":[-84.4803,33.8175]},{"Plant":"Gravel Neck","State":"VA","Gas":316,"coordinates":[-76.6911,37.1575]},{"Plant":"McIntosh","State":"AL","Gas":338,"coordinates":[-88.0299,31.2546]},{"Plant":"Harry Allen","State":"NV","Gas":144,"coordinates":[-114.9024,36.4306]},{"Plant":"Pleasant Hill","State":"IA","Gas":159.5,"coordinates":[-93.5242,41.5572]},{"Plant":"Hay Road","State":"DE","Gas":1090,"coordinates":[-75.5072,39.7436]},{"Plant":"Woodsdale","State":"OH","Gas":462,"coordinates":[-84.4611,39.4492]},{"Plant":"Concord","State":"WI","Gas":388,"coordinates":[-88.69,43.1669]},{"Plant":"South Fond Du Lac","State":"WI","Gas":324.2,"coordinates":[-88.4967,43.7353]},{"Plant":"Darbytown","State":"VA","Gas":312,"coordinates":[-77.3685,37.4982]},{"Plant":"Angus Anson","State":"SD","Gas":383.9,"coordinates":[-96.6356,43.6035]},{"Plant":"Cane Island","State":"FL","Gas":380,"coordinates":[-81.533,28.2764]},{"Plant":"Polk","State":"FL","Gas":621,"coordinates":[-81.9897,27.7286]},{"Plant":"Woodland","State":"CA","Gas":133,"coordinates":[-121.0204,37.6526]},{"Plant":"491 E 48th Street","State":"MI","Gas":148.2,"coordinates":[-86.0853,42.7553]},{"Plant":"Paris","State":"WI","Gas":400,"coordinates":[-88.0131,42.6658]},{"Plant":"Lincoln Combustion","State":"NC","Gas":1267.2,"coordinates":[-81.0347,35.4317]},{"Plant":"State Line Combined Cycle","State":"MO","Gas":589,"coordinates":[-94.614,37.0659]},{"Plant":"Hines Energy Complex","State":"FL","Gas":1930,"coordinates":[-81.87,27.7882]},{"Plant":"Redding Power","State":"CA","Gas":133.6,"coordinates":[-122.4233,40.5073]},{"Plant":"San Jacinto Steam Electric Station","State":"TX","Gas":162,"coordinates":[-95.0406,29.6948]},{"Plant":"Kraft","State":"GA","Gas":132,"coordinates":[-81.1458,32.1486]},{"Plant":"Anderson","State":"IN","Gas":140,"coordinates":[-85.7389,40.0529]},{"Plant":"Riverside","State":"GA","Gas":107,"coordinates":[-81.0956,32.0836]},{"Plant":"Robins","State":"GA","Gas":160,"coordinates":[-83.5822,32.5792]},{"Plant":"Coyote Springs","State":"OR","Gas":227,"coordinates":[-119.6739,45.848]},{"Plant":"Midulla Generating Station","State":"FL","Gas":758,"coordinates":[-81.9625,27.6417]},{"Plant":"Interstate","State":"IL","Gas":128,"coordinates":[-89.5891,39.8233]},{"Plant":"Rathdrum","State":"ID","Gas":136,"coordinates":[-116.8673,47.8043]},{"Plant":"Anchorage 1","State":"AK","Gas":106.1,"coordinates":[-149.8661,61.2221]},{"Plant":"Arthur Von Rosenberg","State":"TX","Gas":465,"coordinates":[-98.384,29.257]},{"Plant":"Carson Ice-Gen Project","State":"CA","Gas":101,"coordinates":[-121.4624,38.4457]},{"Plant":"Wayne County","State":"NC","Gas":686,"coordinates":[-78.0981,35.3758]},{"Plant":"Ponca City","State":"OK","Gas":106.8,"coordinates":[-97.0858,36.7198]},{"Plant":"SCA Cogen 2","State":"CA","Gas":154.6,"coordinates":[-121.4001,38.5309]},{"Plant":"SPA Cogen 3","State":"CA","Gas":164,"coordinates":[-121.4735,38.511]},{"Plant":"St Francis Energy Facility","State":"MO","Gas":473,"coordinates":[-90.1779,36.5852]},{"Plant":"River Road Gen Plant","State":"WA","Gas":220,"coordinates":[-122.7256,45.6497]},{"Plant":"Tiger Bay","State":"FL","Gas":204,"coordinates":[-81.8494,27.7464]},{"Plant":"Dahlberg","State":"GA","Gas":750,"coordinates":[-83.3977,34.0423]},{"Plant":"H Allen Franklin Combined Cycle","State":"AL","Gas":1186,"coordinates":[-85.0975,32.6078]},{"Plant":"Theodore Cogen Facility","State":"AL","Gas":224.7,"coordinates":[-88.1285,30.5254]},{"Plant":"Essex","State":"MO","Gas":107.4,"coordinates":[-89.8402,36.8682]},{"Plant":"Nodaway","State":"MO","Gas":182.8,"coordinates":[-94.7913,40.2877]},{"Plant":"Chouteau","State":"OK","Gas":495,"coordinates":[-95.2771,36.2221]},{"Plant":"Georgetown","State":"IN","Gas":295,"coordinates":[-86.2441,39.9026]},{"Plant":"Tilton","State":"IL","Gas":176,"coordinates":[-87.6538,40.1061]},{"Plant":"Henry County","State":"IN","Gas":135.5,"coordinates":[-85.5039,39.9528]},{"Plant":"MPC Generating","State":"GA","Gas":308.5,"coordinates":[-83.6953,33.8119]},{"Plant":"Sherwood H Smith Jr Energy Complex","State":"NC","Gas":1231,"coordinates":[-79.7406,34.8392]},{"Plant":"Sewell Creek Energy","State":"GA","Gas":495.2,"coordinates":[-85.2769,33.9486]},{"Plant":"Alsey","State":"IL","Gas":121,"coordinates":[-90.436,39.5698]},{"Plant":"Fulton","State":"AR","Gas":153,"coordinates":[-93.7924,33.6094]},{"Plant":"Rowan","State":"NC","Gas":974,"coordinates":[-80.6019,35.7314]},{"Plant":"Smarr Energy Center","State":"GA","Gas":217,"coordinates":[-83.8464,32.9842]},{"Plant":"John S Rainey","State":"SC","Gas":958.2,"coordinates":[-82.776,34.3477]},{"Plant":"Essential Power Rock Springs LLC","State":"MD","Gas":632.2,"coordinates":[-76.1598,39.719]},{"Plant":"Marsh Run Generating","State":"VA","Gas":469.5,"coordinates":[-77.7681,38.5283]},{"Plant":"Louisa Generating","State":"VA","Gas":458.5,"coordinates":[-78.2139,38.1181]},{"Plant":"Remington","State":"VA","Gas":582,"coordinates":[-77.7714,38.5442]},{"Plant":"Ladysmith","State":"VA","Gas":297,"coordinates":[-77.5133,38.0722]},{"Plant":"Pleasant Valley","State":"MN","Gas":420.4,"coordinates":[-92.6829,43.7994]},{"Plant":"Lagoon Creek","State":"TN","Gas":940.8,"coordinates":[-89.3964,35.6578]},{"Plant":"Brandy Branch","State":"FL","Gas":660.8,"coordinates":[-81.9472,30.3206]},{"Plant":"Holden","State":"MO","Gas":232.8,"coordinates":[-93.9983,38.7538]},{"Plant":"MEPI GT Facility","State":"IL","Gas":239,"coordinates":[-88.8661,37.2175]},{"Plant":"Encogen","State":"WA","Gas":170,"coordinates":[-122.486,48.746]},{"Plant":"Robert P Mone Plant","State":"OH","Gas":447,"coordinates":[-84.7392,40.9297]},{"Plant":"H L Culbreath Bayside Power Station","State":"FL","Gas":1632,"coordinates":[-82.4231,27.9072]},{"Plant":"Terry Bundy Generating Station","State":"NE","Gas":151.1,"coordinates":[-96.6131,40.9097]},{"Plant":"E B Harris Electric Generating Plant","State":"AL","Gas":1253.8,"coordinates":[-86.5744,32.3814]},{"Plant":"Sand Hill","State":"TX","Gas":501.2,"coordinates":[-97.6129,30.2098]},{"Plant":"Talbot County Energy","State":"GA","Gas":656.4,"coordinates":[-84.6917,32.5892]},{"Plant":"Chattahoochee Energy Facility","State":"GA","Gas":465,"coordinates":[-85.0386,33.4072]},{"Plant":"Lakefield Junction","State":"MN","Gas":499.6,"coordinates":[-94.8415,43.7984]},{"Plant":"West Gardner","State":"KS","Gas":308,"coordinates":[-94.9861,38.7875]},{"Plant":"Coyote Springs II","State":"OR","Gas":242.7,"coordinates":[-119.674,45.848]},{"Plant":"Wansley Unit 9","State":"GA","Gas":497.4,"coordinates":[-85.0403,33.4083]},{"Plant":"Lawrence County Station","State":"IN","Gas":261,"coordinates":[-86.4511,38.8003]},{"Plant":"Kemper County","State":"MS","Gas":312.8,"coordinates":[-88.606,32.7976]},{"Plant":"Peno Creek","State":"MO","Gas":188,"coordinates":[-91.2295,39.3531]},{"Plant":"Sumpter","State":"MI","Gas":340,"coordinates":[-83.5318,42.167]},{"Plant":"Pyramid","State":"NM","Gas":158,"coordinates":[-108.5494,32.2363]},{"Plant":"Mill Creek","State":"SC","Gas":595.2,"coordinates":[-81.4306,35.1597]},{"Plant":"Greater Des Moines","State":"IA","Gas":494,"coordinates":[-93.5283,41.5563]},{"Plant":"Silver Creek","State":"MS","Gas":225,"coordinates":[-89.9468,31.6004]},{"Plant":"Sylvarena","State":"MS","Gas":129,"coordinates":[-89.4127,31.9821]},{"Plant":"West Campus Cogeneration Facility","State":"WI","Gas":130.2,"coordinates":[-89.4251,43.0751]},{"Plant":"Beatrice","State":"NE","Gas":237,"coordinates":[-96.8082,40.3302]},{"Plant":"Blue Lake","State":"MN","Gas":315.8,"coordinates":[-93.4315,44.7855]},{"Plant":"Sycamore","State":"IA","Gas":148.5,"coordinates":[-93.6769,41.6722]},{"Plant":"Emery Station","State":"IA","Gas":551.8,"coordinates":[-93.2922,43.094]},{"Plant":"Intercession City","State":"FL","Gas":561,"coordinates":[-81.5486,28.2628]},{"Plant":"Gerald Andrus","State":"MS","Gas":741,"coordinates":[-91.1167,33.35]},{"Plant":"Waterford 1 & 2","State":"LA","Gas":816,"coordinates":[-90.4768,29.9989]},{"Plant":"Comanche","State":"OK","Gas":260,"coordinates":[-98.3244,34.5431]},{"Plant":"DeCordova Steam Electric Station","State":"TX","Gas":1138,"coordinates":[-97.7006,32.4031]},{"Plant":"Santan","State":"AZ","Gas":1227,"coordinates":[-111.7503,33.3325]},{"Plant":"Beaver","State":"OR","Gas":492.8,"coordinates":[-123.1739,46.1724]},{"Plant":"Glen Gardner","State":"NJ","Gas":160,"coordinates":[-74.9207,40.6815]},{"Plant":"Grand Tower","State":"IL","Gas":513,"coordinates":[-89.5112,37.6577]},{"Plant":"Calumet","State":"IL","Gas":203.9,"coordinates":[-87.5428,41.7136]},{"Plant":"Crawford","State":"IL","Gas":172.8,"coordinates":[-87.7229,41.8285]},{"Plant":"Electric Junction","State":"IL","Gas":217.4,"coordinates":[-88.0833,41.8333]},{"Plant":"Joliet 9","State":"IL","Gas":115.1,"coordinates":[-88.1153,41.4931]},{"Plant":"Astoria Generating Station","State":"NY","Gas":190.3,"coordinates":[-73.9126,40.7877]},{"Plant":"Wood River","State":"IL","Gas":116.1,"coordinates":[-90.1347,38.8639]},{"Plant":"Venice","State":"IL","Gas":503,"coordinates":[-90.1764,38.6642]},{"Plant":"Beluga","State":"AK","Gas":344.4,"coordinates":[-151.0356,61.1861]},{"Plant":"Marion","State":"IL","Gas":140,"coordinates":[-88.9531,37.6197]},{"Plant":"Frederickson","State":"WA","Gas":144,"coordinates":[-122.365,47.0797]},{"Plant":"Harding Street","State":"IN","Gas":322,"coordinates":[-86.1969,39.7113]},{"Plant":"Dean H Mitchell","State":"IN","Gas":142,"coordinates":[-87.4069,41.6392]},{"Plant":"Michigan City","State":"IN","Gas":120,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Gas":740,"coordinates":[-87.7811,32.6017]},{"Plant":"Gilroy Power Plant","State":"CA","Gas":105,"coordinates":[-121.5367,37.0001]},{"Plant":"Noblesville","State":"IN","Gas":285.9,"coordinates":[-85.9714,40.0969]},{"Plant":"Pedricktown Cogeneration Company LP","State":"NJ","Gas":126.2,"coordinates":[-75.4238,39.7668]},{"Plant":"Broadway","State":"IN","Gas":115,"coordinates":[-87.6049,37.9691]},{"Plant":"Butler-Warner Generation Plant","State":"NC","Gas":225,"coordinates":[-78.8294,35.0986]},{"Plant":"El Segundo Cogen","State":"CA","Gas":127.7,"coordinates":[-118.4031,33.9058]},{"Plant":"ArcelorMittal Burns Harbor","State":"IN","Gas":174.7,"coordinates":[-87.1387,41.635]},{"Plant":"King City Power Plant","State":"CA","Gas":111,"coordinates":[-121.1278,36.225]},{"Plant":"Bayou Cogen Plant","State":"TX","Gas":260,"coordinates":[-95.0458,29.6225]},{"Plant":"Bellingham Cogeneration Facility","State":"MA","Gas":264,"coordinates":[-71.4833,42.0925]},{"Plant":"Sayreville Cogeneration Facility","State":"NJ","Gas":271,"coordinates":[-74.3444,40.439]},{"Plant":"Foster Wheeler Martinez","State":"CA","Gas":103.5,"coordinates":[-122.0589,38.0244]},{"Plant":"ExxonMobil Baytown Refinery","State":"TX","Gas":176.8,"coordinates":[-94.9973,29.7535]},{"Plant":"RG Steel Sparrows Point, LLC","State":"MD","Gas":152.3,"coordinates":[-76.4729,39.213]},{"Plant":"Kern River Cogeneration","State":"CA","Gas":288,"coordinates":[-118.9849,35.4515]},{"Plant":"Formosa Utility Venture Ltd","State":"TX","Gas":597.3,"coordinates":[-96.5417,28.6917]},{"Plant":"Hopewell Cogeneration","State":"VA","Gas":348.3,"coordinates":[-77.2811,37.2917]},{"Plant":"CES Placerita Power Plant","State":"CA","Gas":115,"coordinates":[-118.4999,34.3801]},{"Plant":"Brush Generation Facility","State":"CO","Gas":292,"coordinates":[-103.631,40.2415]},{"Plant":"ExxonMobil Baytown Turbine","State":"TX","Gas":320.4,"coordinates":[-95.0096,29.7591]},{"Plant":"Selkirk Cogen","State":"NY","Gas":371.7,"coordinates":[-73.8592,42.5744]},{"Plant":"Masspower","State":"MA","Gas":238.3,"coordinates":[-72.5225,42.1575]},{"Plant":"Clear Lake Cogeneration Ltd","State":"TX","Gas":366,"coordinates":[-95.067,29.6255]},{"Plant":"Midland Cogeneration Venture","State":"MI","Gas":1831.4,"coordinates":[-84.2242,43.5861]},{"Plant":"Camden Plant Holding LLC","State":"NJ","Gas":147.4,"coordinates":[-75.1192,39.9175]},{"Plant":"River Hills","State":"IA","Gas":116.5,"coordinates":[-93.6195,41.5902]},{"Plant":"Hazelton","State":"PA","Gas":147.2,"coordinates":[-76.0409,40.9282]},{"Plant":"Ocotillo","State":"AZ","Gas":320,"coordinates":[-111.9122,33.4225]},{"Plant":"West Phoenix","State":"AZ","Gas":1047.3,"coordinates":[-112.1583,33.4417]},{"Plant":"Saguaro","State":"AZ","Gas":386,"coordinates":[-111.3,32.5517]},{"Plant":"Yucca","State":"AZ","Gas":259,"coordinates":[-114.7106,32.7214]},{"Plant":"Fort Dodge","State":"KS","Gas":144.6,"coordinates":[-99.9497,37.7328]},{"Plant":"Riverton","State":"KS","Gas":194,"coordinates":[-94.6987,37.0726]},{"Plant":"Gordon Evans Energy Center","State":"KS","Gas":822,"coordinates":[-97.5217,37.7903]},{"Plant":"Murray Gill","State":"KS","Gas":287,"coordinates":[-97.4136,37.5967]},{"Plant":"Hutchinson Energy Center","State":"KS","Gas":389,"coordinates":[-97.8747,38.0906]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Gas":316,"coordinates":[-110.9047,32.16]},{"Plant":"Kaw","State":"KS","Gas":140.3,"coordinates":[-94.6514,39.0867]},{"Plant":"McPherson 2","State":"KS","Gas":131.5,"coordinates":[-97.6834,38.3634]},{"Plant":"Garden City","State":"KS","Gas":224.7,"coordinates":[-100.8956,37.9703]},{"Plant":"E W Brown","State":"KY","Gas":849,"coordinates":[-84.7126,37.7883]},{"Plant":"Paddys Run","State":"KY","Gas":193,"coordinates":[-85.8417,38.2236]},{"Plant":"Louisiana 1","State":"LA","Gas":382.4,"coordinates":[-91.1864,30.4922]},{"Plant":"Louisiana 2","State":"LA","Gas":138,"coordinates":[-91.1864,30.4922]},{"Plant":"R S Nelson","State":"LA","Gas":653,"coordinates":[-93.2911,30.2844]},{"Plant":"Willow Glen","State":"LA","Gas":1762,"coordinates":[-91.1164,30.2743]},{"Plant":"Coughlin Power Station","State":"LA","Gas":732,"coordinates":[-92.2611,30.8439]},{"Plant":"Teche","State":"LA","Gas":384,"coordinates":[-91.5425,29.8222]},{"Plant":"Little Gypsy","State":"LA","Gas":1178,"coordinates":[-90.4617,30.0051]},{"Plant":"Nine Mile Point","State":"LA","Gas":1703,"coordinates":[-90.1458,29.9472]},{"Plant":"Sterlington","State":"LA","Gas":392,"coordinates":[-92.0792,32.7047]},{"Plant":"A B Paterson","State":"LA","Gas":112,"coordinates":[-90.0256,30.0158]},{"Plant":"Michoud","State":"LA","Gas":810,"coordinates":[-89.9372,30.0081]},{"Plant":"Agua Fria","State":"AZ","Gas":626,"coordinates":[-112.2153,33.5561]},{"Plant":"Arsenal Hill","State":"LA","Gas":110,"coordinates":[-93.7611,32.5181]},{"Plant":"Lieberman","State":"LA","Gas":268,"coordinates":[-93.9597,32.7047]},{"Plant":"Louis Doc Bonin","State":"LA","Gas":302,"coordinates":[-92.0463,30.238]},{"Plant":"Monroe","State":"LA","Gas":126,"coordinates":[-92.1794,32.5233]},{"Plant":"Big Cajun 1","State":"LA","Gas":430,"coordinates":[-91.3556,30.6739]},{"Plant":"Kyrene","State":"AZ","Gas":525,"coordinates":[-111.9353,33.3556]},{"Plant":"Herbert A Wagner","State":"MD","Gas":126,"coordinates":[-76.5268,39.1781]},{"Plant":"Notch Cliff","State":"MD","Gas":120,"coordinates":[-76.5087,39.4217]},{"Plant":"Perryman","State":"MD","Gas":149,"coordinates":[-76.2218,39.4428]},{"Plant":"Riverside","State":"MD","Gas":189,"coordinates":[-76.5133,39.2369]},{"Plant":"Westport","State":"MD","Gas":121,"coordinates":[-76.6295,39.266]},{"Plant":"Dickerson","State":"MD","Gas":294,"coordinates":[-77.4644,39.2097]},{"Plant":"Mystic Generating Station","State":"MA","Gas":1950.6,"coordinates":[-71.0675,42.3908]},{"Plant":"New Boston Generating Station","State":"MA","Gas":702,"coordinates":[-71.0353,42.3392]},{"Plant":"Kendall Square Station","State":"MA","Gas":217.7,"coordinates":[-71.0792,42.3633]},{"Plant":"Apache Station","State":"AZ","Gas":198.5,"coordinates":[-109.8931,32.0603]},{"Plant":"Cecil Lynch","State":"AR","Gas":170,"coordinates":[-92.1987,34.7535]},{"Plant":"Hamilton Moses","State":"AR","Gas":137,"coordinates":[-90.8722,34.9806]},{"Plant":"Harvey Couch","State":"AR","Gas":137,"coordinates":[-93.4649,33.3592]},{"Plant":"B C Cobb","State":"MI","Gas":187,"coordinates":[-86.2423,43.2588]},{"Plant":"Lake Catherine","State":"AR","Gas":720,"coordinates":[-92.9049,34.4341]},{"Plant":"Dan E Karn","State":"MI","Gas":1276,"coordinates":[-83.8401,43.645]},{"Plant":"Thetford","State":"MI","Gas":192,"coordinates":[-83.6286,43.1567]},{"Plant":"Conners Creek","State":"MI","Gas":230,"coordinates":[-82.9597,42.3592]},{"Plant":"Delray","State":"MI","Gas":127,"coordinates":[-83.1019,42.2947]},{"Plant":"Robert E Ritchie","State":"AR","Gas":860,"coordinates":[-90.5987,34.4629]},{"Plant":"Hancock","State":"MI","Gas":141,"coordinates":[-83.4425,42.5497]},{"Plant":"River Rouge","State":"MI","Gas":234,"coordinates":[-83.1119,42.2739]},{"Plant":"Mistersky","State":"MI","Gas":154,"coordinates":[-83.0903,42.3039]},{"Plant":"Fox Lake","State":"MN","Gas":108.3,"coordinates":[-94.7075,43.6728]},{"Plant":"Black Dog","State":"MN","Gas":297.8,"coordinates":[-93.2501,44.8108]},{"Plant":"High Bridge","State":"MN","Gas":565.7,"coordinates":[-93.1117,44.9314]},{"Plant":"Inver Hills","State":"MN","Gas":350,"coordinates":[-93.042,44.781]},{"Plant":"Thomas Fitzhugh","State":"AR","Gas":171,"coordinates":[-93.8049,35.4624]},{"Plant":"Carl Bailey","State":"AR","Gas":122,"coordinates":[-91.3634,35.2601]},{"Plant":"McClellan","State":"AR","Gas":134,"coordinates":[-92.7917,33.5648]},{"Plant":"Cambridge CT","State":"MN","Gas":150,"coordinates":[-93.2081,45.601]},{"Plant":"Chevron Oil","State":"MS","Gas":130,"coordinates":[-88.4919,30.34]},{"Plant":"Sweatt","State":"MS","Gas":124,"coordinates":[-88.7461,32.2925]},{"Plant":"Jack Watson","State":"MS","Gas":292,"coordinates":[-89.0286,30.4392]},{"Plant":"Baxter Wilson","State":"MS","Gas":1176,"coordinates":[-90.9306,32.2831]},{"Plant":"Delta","State":"MS","Gas":177,"coordinates":[-90.7139,33.7947]},{"Plant":"Rex Brown","State":"MS","Gas":288,"coordinates":[-90.213,32.357]},{"Plant":"Moselle","State":"MS","Gas":327,"coordinates":[-89.3004,31.528]},{"Plant":"Hawthorn","State":"MO","Gas":417,"coordinates":[-94.4778,39.1306]},{"Plant":"Lake Road","State":"MO","Gas":128.7,"coordinates":[-94.8773,39.7246]},{"Plant":"James River Power Station","State":"MO","Gas":155,"coordinates":[-93.2619,37.1086]},{"Plant":"Canaday","State":"NE","Gas":118,"coordinates":[-99.7011,40.6942]},{"Plant":"C W Burdick","State":"NE","Gas":174.1,"coordinates":[-98.3269,40.9228]},{"Plant":"Contra Costa","State":"CA","Gas":672,"coordinates":[-121.7642,38.0192]},{"Plant":"Sarpy County","State":"NE","Gas":310.9,"coordinates":[-95.9706,41.1706]},{"Plant":"Clark","State":"NV","Gas":1319,"coordinates":[-115.0507,36.0875]},{"Plant":"Sunrise","State":"NV","Gas":149,"coordinates":[-115.036,36.1384]},{"Plant":"Fort Churchill","State":"NV","Gas":226,"coordinates":[-119.1322,39.1281]},{"Plant":"Tracy","State":"NV","Gas":1033.6,"coordinates":[-119.525,39.5625]},{"Plant":"Sayreville","State":"NJ","Gas":172,"coordinates":[-74.3523,40.4765]},{"Plant":"Gilbert","State":"NJ","Gas":521,"coordinates":[-75.1639,40.5658]},{"Plant":"Bergen Generating Station","State":"NJ","Gas":1246,"coordinates":[-74.0244,40.8375]},{"Plant":"PSEG Burlington Generating Station","State":"NJ","Gas":413,"coordinates":[-74.8792,40.0766]},{"Plant":"PSEG Edison Generating Station","State":"NJ","Gas":504,"coordinates":[-74.3956,40.4911]},{"Plant":"PSEG Essex Generating Station","State":"NJ","Gas":617,"coordinates":[-74.1206,40.7372]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Gas":355,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Kearny Generating Station","State":"NJ","Gas":622,"coordinates":[-74.0965,40.7373]},{"Plant":"PSEG Linden Generating Station","State":"NJ","Gas":1543,"coordinates":[-74.2072,40.6217]},{"Plant":"PSEG Sewaren Generating Station","State":"NJ","Gas":453,"coordinates":[-74.2469,40.5558]},{"Plant":"Rio Grande","State":"NM","Gas":236,"coordinates":[-106.5472,31.8047]},{"Plant":"Maddox","State":"NM","Gas":179,"coordinates":[-103.3015,32.7142]},{"Plant":"Reeves","State":"NM","Gas":154,"coordinates":[-106.6019,35.171]},{"Plant":"Cunningham","State":"NM","Gas":485,"coordinates":[-103.3533,32.7131]},{"Plant":"Humboldt Bay","State":"CA","Gas":105,"coordinates":[-124.2103,40.7415]},{"Plant":"Hunters Point","State":"CA","Gas":377,"coordinates":[-122.3897,37.7336]},{"Plant":"Arthur Kill Generating Station","State":"NY","Gas":841,"coordinates":[-74.2,40.5916]},{"Plant":"East River","State":"NY","Gas":296.9,"coordinates":[-73.9742,40.7281]},{"Plant":"Gowanus Gas Turbines Generating","State":"NY","Gas":288.2,"coordinates":[-74.0051,40.6635]},{"Plant":"Narrows Gas Turbines Generating","State":"NY","Gas":296.7,"coordinates":[-74.0208,40.6486]},{"Plant":"Ravenswood","State":"NY","Gas":2316.7,"coordinates":[-73.9461,40.7592]},{"Plant":"E F Barrett","State":"NY","Gas":680.1,"coordinates":[-73.6479,40.6167]},{"Plant":"Far Rockaway","State":"NY","Gas":107,"coordinates":[-73.761,40.6109]},{"Plant":"Glenwood","State":"NY","Gas":220,"coordinates":[-73.6475,40.8271]},{"Plant":"Northport","State":"NY","Gas":1579.4,"coordinates":[-73.3423,40.9236]},{"Plant":"Port Jefferson","State":"NY","Gas":464.2,"coordinates":[-73.0785,40.9497]},{"Plant":"Bethlehem Energy Center","State":"NY","Gas":1114.3,"coordinates":[-73.7638,42.5942]},{"Plant":"Dynegy Morro Bay LLC","State":"CA","Gas":999,"coordinates":[-120.8566,35.3722]},{"Plant":"Dynegy Moss Landing Power Plant","State":"CA","Gas":2529,"coordinates":[-121.7822,36.8048]},{"Plant":"Bowline Point","State":"NY","Gas":1139,"coordinates":[-73.9689,41.2044]},{"Plant":"Asheville","State":"NC","Gas":327,"coordinates":[-82.5417,35.4731]},{"Plant":"Pittsburg Power","State":"CA","Gas":1906,"coordinates":[-121.8945,38.0392]},{"Plant":"Potrero Power","State":"CA","Gas":206,"coordinates":[-122.387,37.7566]},{"Plant":"Riverbend","State":"NC","Gas":120,"coordinates":[-80.9742,35.36]},{"Plant":"Dicks Creek","State":"OH","Gas":106.2,"coordinates":[-84.3778,39.465]},{"Plant":"Frank M Tait","State":"OH","Gas":256,"coordinates":[-84.2111,39.7272]},{"Plant":"FirstEnergy West Lorain","State":"OH","Gas":425,"coordinates":[-82.2644,41.4294]},{"Plant":"Richland","State":"OH","Gas":358,"coordinates":[-84.3346,41.3052]},{"Plant":"Horseshoe Lake","State":"OK","Gas":870.2,"coordinates":[-97.1797,35.5087]},{"Plant":"Muskogee","State":"OK","Gas":171,"coordinates":[-95.2873,35.7614]},{"Plant":"Mustang","State":"OK","Gas":538,"coordinates":[-97.675,35.4699]},{"Plant":"Seminole","State":"OK","Gas":1477,"coordinates":[-96.7258,34.9665]},{"Plant":"Northeastern","State":"OK","Gas":891,"coordinates":[-95.7008,36.4317]},{"Plant":"Southwestern","State":"OK","Gas":603,"coordinates":[-98.3524,35.1009]},{"Plant":"Tulsa","State":"OK","Gas":370,"coordinates":[-95.991,36.1165]},{"Plant":"Weleetka","State":"OK","Gas":163,"coordinates":[-96.1352,35.3233]},{"Plant":"Barry","State":"AL","Gas":805,"coordinates":[-88.0103,31.0069]},{"Plant":"Anadarko Plant","State":"OK","Gas":350,"coordinates":[-98.23,35.0847]},{"Plant":"Mooreland","State":"OK","Gas":322,"coordinates":[-99.2254,36.4372]},{"Plant":"Encina","State":"CA","Gas":964,"coordinates":[-117.3364,33.1361]},{"Plant":"Kearny","State":"CA","Gas":136,"coordinates":[-117.1338,32.834]},{"Plant":"Brunot Island","State":"PA","Gas":245,"coordinates":[-80.0438,40.4649]},{"Plant":"Dynegy South Bay Power Plant","State":"CA","Gas":693,"coordinates":[-117.092,32.6114]},{"Plant":"AES Alamitos LLC","State":"CA","Gas":2130,"coordinates":[-118.1009,33.7688]},{"Plant":"Manchester Street","State":"RI","Gas":447,"coordinates":[-71.4042,41.8167]},{"Plant":"Darlington County","State":"SC","Gas":442,"coordinates":[-80.1657,34.4185]},{"Plant":"Buzzard Roost","State":"SC","Gas":196,"coordinates":[-81.9025,34.1692]},{"Plant":"W S Lee","State":"SC","Gas":159.8,"coordinates":[-82.435,34.6022]},{"Plant":"Coolwater","State":"CA","Gas":608,"coordinates":[-116.8539,34.8606]},{"Plant":"Urquhart","State":"SC","Gas":559,"coordinates":[-81.9111,33.435]},{"Plant":"El Segundo Power","State":"CA","Gas":940.6,"coordinates":[-118.4242,33.9098]},{"Plant":"Etiwanda Generating Station","State":"CA","Gas":1019,"coordinates":[-117.5266,34.0912]},{"Plant":"Riverside Canal Power","State":"CA","Gas":127,"coordinates":[-117.3312,34.0229]},{"Plant":"AES Huntington Beach LLC","State":"CA","Gas":1036.6,"coordinates":[-117.9792,33.6439]},{"Plant":"Allen Steam Plant","State":"TN","Gas":461.6,"coordinates":[-90.1487,35.0741]},{"Plant":"Gallatin","State":"TN","Gas":599.2,"coordinates":[-86.4006,36.3156]},{"Plant":"Johnsonville","State":"TN","Gas":1135.2,"coordinates":[-87.9861,36.0278]},{"Plant":"Long Beach Generation LLC","State":"CA","Gas":592,"coordinates":[-118.2248,33.7641]},{"Plant":"E S Joslin","State":"TX","Gas":254,"coordinates":[-96.5458,28.6472]},{"Plant":"J L Bates","State":"TX","Gas":182,"coordinates":[-98.3944,26.2222]},{"Plant":"Laredo","State":"TX","Gas":347,"coordinates":[-99.5089,27.5667]},{"Plant":"Lon C Hill","State":"TX","Gas":559,"coordinates":[-97.6167,27.85]},{"Plant":"Nueces Bay","State":"TX","Gas":559,"coordinates":[-97.4192,27.8194]},{"Plant":"La Palma","State":"TX","Gas":255,"coordinates":[-97.6389,26.1331]},{"Plant":"Victoria","State":"TX","Gas":491,"coordinates":[-97.01,28.7883]},{"Plant":"Mandalay","State":"CA","Gas":560,"coordinates":[-119.2511,34.2067]},{"Plant":"Lake Hubbard","State":"TX","Gas":921,"coordinates":[-96.5458,32.8358]},{"Plant":"Mountain Creek","State":"TX","Gas":899,"coordinates":[-96.9358,32.7231]},{"Plant":"North Lake","State":"TX","Gas":715,"coordinates":[-96.975,32.9506]},{"Plant":"Parkdale","State":"TX","Gas":327,"coordinates":[-96.7233,32.7767]},{"Plant":"Newman","State":"TX","Gas":479,"coordinates":[-106.4318,31.9836]},{"Plant":"Lewis Creek","State":"TX","Gas":460,"coordinates":[-95.5214,30.4356]},{"Plant":"Neches","State":"TX","Gas":265,"coordinates":[-94.0593,30.0612]},{"Plant":"Sabine","State":"TX","Gas":1814,"coordinates":[-93.878,30.0242]},{"Plant":"Cedar Bayou","State":"TX","Gas":2255,"coordinates":[-94.9256,29.75]},{"Plant":"Deepwater","State":"TX","Gas":174,"coordinates":[-95.2253,29.7199]},{"Plant":"Greens Bayou","State":"TX","Gas":760,"coordinates":[-95.2194,29.8222]},{"Plant":"P H Robinson","State":"TX","Gas":2211,"coordinates":[-94.9794,29.4867]},{"Plant":"Sam Bertron","State":"TX","Gas":841,"coordinates":[-95.0598,29.7268]},{"Plant":"T H Wharton","State":"TX","Gas":1254,"coordinates":[-95.5306,29.9417]},{"Plant":"W A Parish","State":"TX","Gas":1191,"coordinates":[-95.6311,29.4828]},{"Plant":"Webster","State":"TX","Gas":387,"coordinates":[-95.1081,29.5258]},{"Plant":"Knox Lee","State":"TX","Gas":488,"coordinates":[-94.6415,32.3766]},{"Plant":"Wilkes","State":"TX","Gas":894,"coordinates":[-94.548,32.8482]},{"Plant":"Jones","State":"TX","Gas":486,"coordinates":[-101.7392,33.5239]},{"Plant":"Nichols","State":"TX","Gas":457,"coordinates":[-101.7464,35.2834]},{"Plant":"Plant X","State":"TX","Gas":442,"coordinates":[-102.4114,34.1661]},{"Plant":"Eagle Mountain","State":"TX","Gas":665,"coordinates":[-97.4792,32.9056]},{"Plant":"Graham","State":"TX","Gas":630,"coordinates":[-98.6117,33.1344]},{"Plant":"Handley","State":"TX","Gas":1382,"coordinates":[-97.2192,32.7283]},{"Plant":"Morgan Creek","State":"TX","Gas":1354,"coordinates":[-100.9156,32.3358]},{"Plant":"Permian Basin","State":"TX","Gas":1055,"coordinates":[-102.9633,31.5839]},{"Plant":"Ormond Beach","State":"CA","Gas":1516,"coordinates":[-119.1689,34.1292]},{"Plant":"Collin","State":"TX","Gas":154,"coordinates":[-96.8034,33.1576]},{"Plant":"Lake Creek","State":"TX","Gas":317,"coordinates":[-96.985,31.4647]},{"Plant":"River Crest","State":"TX","Gas":110,"coordinates":[-95.1467,33.3931]},{"Plant":"Stryker Creek","State":"TX","Gas":675,"coordinates":[-94.9898,31.9398]},{"Plant":"Tradinghouse","State":"TX","Gas":1383,"coordinates":[-96.9642,31.5728]},{"Plant":"Trinidad","State":"TX","Gas":240,"coordinates":[-96.1013,32.1245]},{"Plant":"Valley","State":"TX","Gas":1115,"coordinates":[-96.3676,33.6281]},{"Plant":"Paint Creek","State":"TX","Gas":231,"coordinates":[-99.7337,33.1576]},{"Plant":"Rio Pecos","State":"TX","Gas":141,"coordinates":[-102.3753,31.0706]},{"Plant":"San Angelo","State":"TX","Gas":123,"coordinates":[-100.491,31.3906]},{"Plant":"Decker Creek","State":"TX","Gas":932,"coordinates":[-97.6128,30.3033]},{"Plant":"Holly Street","State":"TX","Gas":591,"coordinates":[-97.7167,30.25]},{"Plant":"Silas Ray","State":"TX","Gas":125,"coordinates":[-97.5214,25.9131]},{"Plant":"AES Redondo Beach LLC","State":"CA","Gas":1310,"coordinates":[-118.395,33.8504]},{"Plant":"Bryan","State":"TX","Gas":130,"coordinates":[-96.3723,30.6474]},{"Plant":"Ray Olinger","State":"TX","Gas":395,"coordinates":[-96.4525,33.0681]},{"Plant":"Mountainview Generating Station","State":"CA","Gas":1062.2,"coordinates":[-117.2418,34.0818]},{"Plant":"Sim Gideon","State":"TX","Gas":620,"coordinates":[-97.2708,30.1456]},{"Plant":"Ty Cooke","State":"TX","Gas":135,"coordinates":[-101.7906,33.5211]},{"Plant":"J Robert Massengale","State":"TX","Gas":105,"coordinates":[-101.8408,33.6039]},{"Plant":"Leon Creek","State":"TX","Gas":339,"coordinates":[-98.5761,29.3525]},{"Plant":"O W Sommers","State":"TX","Gas":880,"coordinates":[-98.3242,29.3081]},{"Plant":"V H Braunig","State":"TX","Gas":862,"coordinates":[-98.3825,29.2567]},{"Plant":"W B Tuttle","State":"TX","Gas":414,"coordinates":[-98.4181,29.53]},{"Plant":"R W Miller","State":"TX","Gas":574,"coordinates":[-98.3103,32.6581]},{"Plant":"Sam Rayburn","State":"TX","Gas":227,"coordinates":[-97.135,28.8947]},{"Plant":"Gadsby","State":"UT","Gas":347.5,"coordinates":[-111.9289,40.7686]},{"Plant":"Grayson","State":"CA","Gas":289.9,"coordinates":[-118.2782,34.1556]},{"Plant":"Chesterfield","State":"VA","Gas":397,"coordinates":[-77.3833,37.3822]},{"Plant":"Possum Point","State":"VA","Gas":875,"coordinates":[-77.2806,38.5367]},{"Plant":"Transalta Centralia Generation","State":"WA","Gas":256,"coordinates":[-122.8598,46.7559]},{"Plant":"El Centro","State":"CA","Gas":225.9,"coordinates":[-115.54,32.8022]},{"Plant":"Harbor","State":"CA","Gas":497,"coordinates":[-118.2656,33.7706]},{"Plant":"Haynes","State":"CA","Gas":1968,"coordinates":[-118.0991,33.7647]},{"Plant":"Wheaton","State":"WI","Gas":233.3,"coordinates":[-91.5158,44.8854]},{"Plant":"Scattergood","State":"CA","Gas":796,"coordinates":[-118.4276,33.9182]},{"Plant":"Port Washington Generating Station","State":"WI","Gas":1150,"coordinates":[-87.8689,43.3842]},{"Plant":"Rock River","State":"WI","Gas":296.9,"coordinates":[-89.0276,42.582]},{"Plant":"West Marinette","State":"WI","Gas":149,"coordinates":[-87.6881,45.0869]},{"Plant":"Valley","State":"CA","Gas":1073,"coordinates":[-118.3913,34.245]},{"Plant":"Broadway","State":"CA","Gas":161,"coordinates":[-118.148,34.1254]},{"Plant":"Glenarm","State":"CA","Gas":155,"coordinates":[-118.1494,34.126]},{"Plant":"Spencer","State":"TX","Gas":168,"coordinates":[-97.1061,33.1975]},{"Plant":"Colbert","State":"AL","Gas":390.4,"coordinates":[-87.8486,34.7439]},{"Plant":"Thomas C Ferguson","State":"TX","Gas":420,"coordinates":[-98.3705,30.558]},{"Plant":"Fort Phantom","State":"TX","Gas":362,"coordinates":[-99.6778,32.5784]},{"Plant":"Barney M Davis","State":"TX","Gas":682,"coordinates":[-97.3117,27.6064]},{"Plant":"Riverside","State":"OK","Gas":1067,"coordinates":[-95.9567,35.9978]},{"Plant":"Pittsfield Generating LP","State":"MA","Gas":141,"coordinates":[-73.2181,42.4564]},{"Plant":"Linden Cogen Plant","State":"NJ","Gas":899.8,"coordinates":[-74.2156,40.6322]},{"Plant":"Houston Chemical Complex Battleground","State":"TX","Gas":263,"coordinates":[-95.0839,29.7314]},{"Plant":"Paris Energy Center","State":"TX","Gas":238,"coordinates":[-95.5577,33.6968]},{"Plant":"Hal C Weaver Power Plant","State":"TX","Gas":131.4,"coordinates":[-97.7356,30.2867]},{"Plant":"Sycamore Cogeneration","State":"CA","Gas":300,"coordinates":[-118.9853,35.4526]},{"Plant":"Union Carbide Seadrift Cogen","State":"TX","Gas":168,"coordinates":[-96.7706,28.5105]},{"Plant":"Dow St Charles Operations","State":"LA","Gas":291.6,"coordinates":[-90.4414,29.9861]},{"Plant":"Watson Cogeneration","State":"CA","Gas":398,"coordinates":[-118.2448,33.8166]},{"Plant":"Bucksport Generation LLC","State":"ME","Gas":249.8,"coordinates":[-68.8046,44.5738]},{"Plant":"Bethpage Power Plant","State":"NY","Gas":184,"coordinates":[-73.4994,40.7469]},{"Plant":"Shell Deer Park","State":"TX","Gas":140,"coordinates":[-95.1289,29.7232]},{"Plant":"Newark Bay Cogeneration Partnership LP","State":"NJ","Gas":120,"coordinates":[-74.13,40.7197]},{"Plant":"Indeck Corinth Energy Center","State":"NY","Gas":131.5,"coordinates":[-73.8125,43.25]},{"Plant":"PPG Powerhouse C","State":"LA","Gas":303.2,"coordinates":[-93.2831,30.2242]},{"Plant":"Bayonne Plant Holding LLC","State":"NJ","Gas":166,"coordinates":[-74.1124,40.6553]},{"Plant":"Harbor Cogen","State":"CA","Gas":101.7,"coordinates":[-118.2303,33.7771]},{"Plant":"Rosemary Power Station","State":"NC","Gas":165,"coordinates":[-77.6594,36.4517]},{"Plant":"Oklahoma Cogeneration Project","State":"OK","Gas":111.4,"coordinates":[-97.625,35.4397]},{"Plant":"Eagle Point Power Generation","State":"NJ","Gas":195,"coordinates":[-75.1592,39.8746]},{"Plant":"TXU Sweetwater Generating Plant","State":"TX","Gas":289,"coordinates":[-100.365,32.4928]},{"Plant":"ExxonMobil Beaumont Refinery","State":"TX","Gas":650.6,"coordinates":[-94.0753,30.0636]},{"Plant":"JM Shafer Generating Station","State":"CO","Gas":263,"coordinates":[-104.7736,40.0986]},{"Plant":"Gary Works","State":"IN","Gas":221,"coordinates":[-87.3289,41.6224]},{"Plant":"Parlin Power Plant","State":"NJ","Gas":118,"coordinates":[-74.3272,40.4607]},{"Plant":"Optim Energy Altura Cogen LLC","State":"TX","Gas":493,"coordinates":[-95.1077,29.8161]},{"Plant":"Gramercy Holdings LLC","State":"LA","Gas":106,"coordinates":[-90.6693,30.054]},{"Plant":"Hardee Power Station","State":"FL","Gas":358,"coordinates":[-81.9636,27.6364]},{"Plant":"Bellmeade Power Station","State":"VA","Gas":245,"coordinates":[-77.4317,37.4964]},{"Plant":"Pryor Power Plant","State":"OK","Gas":111.5,"coordinates":[-95.3175,36.2977]},{"Plant":"Ocean State Power","State":"RI","Gas":218.6,"coordinates":[-71.6689,42.0097]},{"Plant":"LaO Energy Systems","State":"LA","Gas":574,"coordinates":[-91.2325,30.3186]},{"Plant":"Doswell Energy Center","State":"VA","Gas":819.8,"coordinates":[-77.1448,37.8182]},{"Plant":"Elizabeth River Power Station","State":"VA","Gas":348,"coordinates":[-76.3083,36.775]},{"Plant":"Texas City Power Plant","State":"TX","Gas":451,"coordinates":[-94.9438,29.3787]},{"Plant":"Dow Chemical Texas Operation","State":"TX","Gas":1132.1,"coordinates":[-95.4075,28.9913]},{"Plant":"Power Station 4","State":"TX","Gas":172,"coordinates":[-94.9219,29.3782]},{"Plant":"Midway Sunset Cogen","State":"CA","Gas":219,"coordinates":[-119.6294,35.2269]},{"Plant":"C R Wing Cogen Plant","State":"TX","Gas":227,"coordinates":[-101.4224,32.2732]},{"Plant":"Delaware City Plant","State":"DE","Gas":308,"coordinates":[-75.6343,39.5871]},{"Plant":"McWilliams","State":"AL","Gas":650,"coordinates":[-86.4764,31.4003]},{"Plant":"J K Smith","State":"KY","Gas":608,"coordinates":[-84.1017,37.8833]},{"Plant":"Lockport Energy Associates LP","State":"NY","Gas":203,"coordinates":[-78.745,43.1619]},{"Plant":"Kennedy International Airport Cogen","State":"NY","Gas":115.1,"coordinates":[-73.7778,40.6417]},{"Plant":"March Point Cogeneration","State":"WA","Gas":146.2,"coordinates":[-122.56,48.4708]},{"Plant":"Saguaro Power","State":"NV","Gas":101,"coordinates":[-115.0117,36.0417]},{"Plant":"Ocean State Power II","State":"RI","Gas":218.6,"coordinates":[-71.6701,42.0099]},{"Plant":"Orange Cogeneration Facility","State":"FL","Gas":110.6,"coordinates":[-81.8251,27.8708]},{"Plant":"Lake Cogen Ltd","State":"FL","Gas":121,"coordinates":[-81.676,28.9158]},{"Plant":"Pasco Cogen Ltd","State":"FL","Gas":128.8,"coordinates":[-82.1889,28.3746]},{"Plant":"Mulberry Cogeneration Facility","State":"FL","Gas":113,"coordinates":[-81.8775,27.8489]},{"Plant":"Orlando Cogen LP","State":"FL","Gas":120,"coordinates":[-81.4123,28.4426]},{"Plant":"Sumas Power Plant","State":"WA","Gas":123,"coordinates":[-122.2733,48.9905]},{"Plant":"Formosa Plastics","State":"LA","Gas":115,"coordinates":[-91.1872,30.4992]},{"Plant":"Ferndale Generating Station","State":"WA","Gas":271,"coordinates":[-122.6867,48.8288]},{"Plant":"Hartwell Energy Facility","State":"GA","Gas":301.8,"coordinates":[-82.8199,34.3396]},{"Plant":"Sithe Independence Station","State":"NY","Gas":982.2,"coordinates":[-76.4511,43.495]},{"Plant":"Saranac Facility","State":"NY","Gas":253.7,"coordinates":[-73.4557,44.7132]},{"Plant":"NAEA Lakewood LLC","State":"NJ","Gas":218.1,"coordinates":[-74.1686,40.0613]},{"Plant":"Auburndale Power Partners","State":"FL","Gas":156.5,"coordinates":[-81.8058,28.0542]},{"Plant":"Oyster Creek Unit VIII","State":"TX","Gas":379,"coordinates":[-95.342,28.9802]},{"Plant":"Hermiston Generating Plant","State":"OR","Gas":464,"coordinates":[-119.37,45.8042]},{"Plant":"Grays Ferry Cogeneration","State":"PA","Gas":150,"coordinates":[-75.1881,39.9422]},{"Plant":"Milford Power LP","State":"MA","Gas":148,"coordinates":[-71.5115,42.1294]},{"Plant":"Milagro Cogeneration Plant","State":"NM","Gas":121.6,"coordinates":[-107.9417,36.7367]},{"Plant":"Johnson County","State":"TX","Gas":267,"coordinates":[-97.4078,32.3994]},{"Plant":"Brandywine Power Facility","State":"MD","Gas":230,"coordinates":[-76.8678,38.6681]},{"Plant":"Gordonsville Energy LP","State":"VA","Gas":218,"coordinates":[-78.2138,38.1179]},{"Plant":"Sun Peak Generating Station","State":"NV","Gas":222,"coordinates":[-115.0339,36.1375]},{"Plant":"Brooklyn Navy Yard Cogeneration","State":"NY","Gas":230,"coordinates":[-73.9764,40.6994]},{"Plant":"Michigan Power LP","State":"MI","Gas":128,"coordinates":[-86.425,43.9375]},{"Plant":"LSP-Cottage Grove LP","State":"MN","Gas":251,"coordinates":[-92.9119,44.7956]},{"Plant":"LSP-Whitewater LP","State":"WI","Gas":261,"coordinates":[-88.7299,42.8555]},{"Plant":"Sweeny Cogen Facility","State":"TX","Gas":436,"coordinates":[-95.745,29.0728]},{"Plant":"Dighton Power Plant","State":"MA","Gas":150,"coordinates":[-71.1239,41.8312]},{"Plant":"De Pere Energy Center","State":"WI","Gas":175.5,"coordinates":[-88.072,44.4486]},{"Plant":"Androscoggin Energy Center","State":"ME","Gas":136.8,"coordinates":[-70.2423,44.5063]},{"Plant":"Delta Person LLC","State":"NM","Gas":140,"coordinates":[-106.644,35.026]},{"Plant":"Mid-Georgia Cogeneration Facility","State":"GA","Gas":316,"coordinates":[-83.6039,32.4856]},{"Plant":"Berkshire Power","State":"MA","Gas":232.1,"coordinates":[-72.6478,42.0476]},{"Plant":"Bridgeport Energy Project","State":"CT","Gas":454,"coordinates":[-73.1844,41.1692]},{"Plant":"Pasadena Cogeneration","State":"TX","Gas":700,"coordinates":[-95.1765,29.7248]},{"Plant":"Tiverton Power Plant","State":"RI","Gas":250,"coordinates":[-71.1706,41.6422]},{"Plant":"Axiall Plaquemine","State":"LA","Gas":240,"coordinates":[-91.185,30.2586]},{"Plant":"Tenaska Frontier Generation Station","State":"TX","Gas":860,"coordinates":[-95.9178,30.5924]},{"Plant":"Batesville Generation Facility","State":"MS","Gas":858,"coordinates":[-89.9275,34.3356]},{"Plant":"Black Hawk Station","State":"TX","Gas":221.4,"coordinates":[-101.36,35.6957]},{"Plant":"Mustang Station","State":"TX","Gas":486,"coordinates":[-102.7417,32.9728]},{"Plant":"Maine Independence Station","State":"ME","Gas":490,"coordinates":[-68.7094,44.8242]},{"Plant":"Pine Bluff Energy Center","State":"AR","Gas":192,"coordinates":[-91.9025,34.2181]},{"Plant":"Desert Star Energy Center","State":"NV","Gas":450,"coordinates":[-114.9928,35.7867]},{"Plant":"Millennium Power","State":"MA","Gas":325.1,"coordinates":[-72.0151,42.1123]},{"Plant":"New Albany Energy Facility","State":"MS","Gas":360,"coordinates":[-88.9397,34.5408]},{"Plant":"Brownsville Peaking Power","State":"TN","Gas":450,"coordinates":[-89.198,35.5438]},{"Plant":"Crockett Cogen Project","State":"CA","Gas":247.4,"coordinates":[-122.2161,38.0569]},{"Plant":"Gregory Power Facility","State":"TX","Gas":366,"coordinates":[-97.2584,27.8893]},{"Plant":"Zeeland Generating Station","State":"MI","Gas":868,"coordinates":[-85.9975,42.8206]},{"Plant":"Dearborn Industrial Generation","State":"MI","Gas":700,"coordinates":[-83.154,42.3026]},{"Plant":"Taft Cogeneration Facility","State":"LA","Gas":790,"coordinates":[-90.4599,29.9888]},{"Plant":"Midlothian Energy Facility","State":"TX","Gas":1278,"coordinates":[-97.0537,32.4302]},{"Plant":"Lamar Power Project","State":"TX","Gas":1004,"coordinates":[-95.59,33.6308]},{"Plant":"Frontera Energy Center","State":"TX","Gas":475,"coordinates":[-98.3992,26.208]},{"Plant":"NRG Sterlington Power","State":"LA","Gas":176,"coordinates":[-92.0811,32.6889]},{"Plant":"Rumford Power Associates","State":"ME","Gas":254,"coordinates":[-70.5219,44.5303]},{"Plant":"Livingston Generating Station","State":"MI","Gas":132,"coordinates":[-84.7308,45.0304]},{"Plant":"Klamath Cogeneration Plant","State":"OR","Gas":470,"coordinates":[-121.8106,42.1739]},{"Plant":"Entergy Rhode Island State Energy LP","State":"RI","Gas":528,"coordinates":[-71.5186,41.8017]},{"Plant":"Rocky Road Power LLC","State":"IL","Gas":340,"coordinates":[-88.2397,42.0931]},{"Plant":"Madison","State":"OH","Gas":576,"coordinates":[-84.4647,39.4522]},{"Plant":"Vermillion Energy Facility","State":"IN","Gas":560,"coordinates":[-87.4464,39.9223]},{"Plant":"Sutter Energy Center","State":"CA","Gas":530,"coordinates":[-121.6959,39.0531]},{"Plant":"Rockingham County CT Station","State":"NC","Gas":775,"coordinates":[-79.8297,36.3297]},{"Plant":"RS Cogen","State":"LA","Gas":395.6,"coordinates":[-93.2992,30.221]},{"Plant":"SRW Cogen LP","State":"TX","Gas":420,"coordinates":[-93.7574,30.0545]},{"Plant":"Magic Valley Generating Station","State":"TX","Gas":682,"coordinates":[-98.19,26.3403]},{"Plant":"Griffith Energy LLC","State":"AZ","Gas":570,"coordinates":[-114.1333,35.054]},{"Plant":"Milford Power Project","State":"CT","Gas":522,"coordinates":[-73.0997,41.2244]},{"Plant":"Manchief Electric Generating Station","State":"CO","Gas":264,"coordinates":[-103.685,40.2171]},{"Plant":"Walton County Power LLC","State":"GA","Gas":465.2,"coordinates":[-83.6954,33.8148]},{"Plant":"Desert Basin","State":"AZ","Gas":577,"coordinates":[-111.7889,32.9042]},{"Plant":"Kendall County Generation Facility","State":"IL","Gas":1140,"coordinates":[-88.2581,41.4797]},{"Plant":"Tenaska Gateway Generating Station","State":"TX","Gas":863,"coordinates":[-94.6197,32.0178]},{"Plant":"Alliant Energy Neenah","State":"WI","Gas":300,"coordinates":[-88.5064,44.1936]},{"Plant":"Rio Nogales Power Project","State":"TX","Gas":728,"coordinates":[-97.9732,29.5931]},{"Plant":"Wolf Hollow I LP","State":"TX","Gas":695.5,"coordinates":[-97.7317,32.3342]},{"Plant":"Hawk Road Facility","State":"GA","Gas":492,"coordinates":[-84.9914,33.3585]},{"Plant":"Hays Energy Project","State":"TX","Gas":881,"coordinates":[-97.9894,29.7806]},{"Plant":"Green Country Energy LLC","State":"OK","Gas":783,"coordinates":[-95.9346,35.9833]},{"Plant":"Worthington Generation LLC","State":"IN","Gas":179.2,"coordinates":[-87.0128,39.0708]},{"Plant":"Lake Road Generating Plant","State":"CT","Gas":745.2,"coordinates":[-71.8958,41.872]},{"Plant":"La Paloma Generating LLC","State":"CA","Gas":965.4,"coordinates":[-119.5919,35.2956]},{"Plant":"Guadalupe Generating Station","State":"TX","Gas":1000,"coordinates":[-98.1419,29.6244]},{"Plant":"Lost Pines 1 Power Project","State":"TX","Gas":516,"coordinates":[-97.2714,30.1478]},{"Plant":"Bluegrass Generating Station","State":"KY","Gas":495,"coordinates":[-85.4133,38.3902]},{"Plant":"Calcasieu","State":"LA","Gas":310,"coordinates":[-93.345,30.1608]},{"Plant":"Broad River Energy Center","State":"SC","Gas":854,"coordinates":[-81.575,35.0786]},{"Plant":"Bastrop Energy Center","State":"TX","Gas":552,"coordinates":[-97.55,30.1458]},{"Plant":"Granite Ridge","State":"NH","Gas":661,"coordinates":[-71.4261,42.9042]},{"Plant":"Bosque County Peaking","State":"TX","Gas":548,"coordinates":[-97.3586,31.8594]},{"Plant":"Acadia Energy Center","State":"LA","Gas":1063,"coordinates":[-92.4131,30.4286]},{"Plant":"Eastman Cogeneration Facility","State":"TX","Gas":402.2,"coordinates":[-94.6903,32.4481]},{"Plant":"South Point Energy Center","State":"AZ","Gas":550,"coordinates":[-114.5317,34.8678]},{"Plant":"Dogwood Energy Facility","State":"MO","Gas":620,"coordinates":[-94.3006,38.7931]},{"Plant":"Rathdrum Power LLC","State":"ID","Gas":248,"coordinates":[-116.9203,47.7858]},{"Plant":"Sunrise Power LLC","State":"CA","Gas":545,"coordinates":[-119.585,35.2097]},{"Plant":"Channelview Cogeneration Plant","State":"TX","Gas":779,"coordinates":[-95.1217,29.837]},{"Plant":"Cordova Energy","State":"IL","Gas":521.2,"coordinates":[-90.2797,41.7122]},{"Plant":"Osceola","State":"FL","Gas":468,"coordinates":[-81.0978,28.1289]},{"Plant":"Ontelaunee Energy Center","State":"PA","Gas":516,"coordinates":[-75.9356,40.4219]},{"Plant":"Caledonia","State":"MS","Gas":765,"coordinates":[-88.2717,33.6464]},{"Plant":"Riverside Generating LLC","State":"KY","Gas":825,"coordinates":[-82.6046,38.1917]},{"Plant":"Elwood Energy LLC","State":"IL","Gas":1350,"coordinates":[-88.1236,41.4388]},{"Plant":"Arapahoe Combustion Turbine Project","State":"CO","Gas":122.5,"coordinates":[-105.0018,39.6692]},{"Plant":"Gibson City","State":"IL","Gas":236,"coordinates":[-88.3987,40.4705]},{"Plant":"Pinckneyville","State":"IL","Gas":316,"coordinates":[-89.3467,38.1114]},{"Plant":"Kinmundy","State":"IL","Gas":216,"coordinates":[-89.0128,38.7619]},{"Plant":"Corpus Christi Energy Center","State":"TX","Gas":482.1,"coordinates":[-97.4283,27.8139]},{"Plant":"Afton Generating Station","State":"NM","Gas":235.6,"coordinates":[-106.8465,32.1142]},{"Plant":"ANP Bellingham Energy Project","State":"MA","Gas":475,"coordinates":[-71.4535,42.1106]},{"Plant":"ANP Blackstone Energy Project","State":"MA","Gas":434.1,"coordinates":[-71.5158,42.0599]},{"Plant":"Odessa Ector Generating Station","State":"TX","Gas":1026.2,"coordinates":[-102.3264,31.8403]},{"Plant":"Morris Cogeneration LLC","State":"IL","Gas":176,"coordinates":[-88.3328,41.4119]},{"Plant":"Los Medanos Energy Center","State":"CA","Gas":567,"coordinates":[-121.873,38.0301]},{"Plant":"Hinds Energy Facility","State":"MS","Gas":450,"coordinates":[-90.2199,32.379]},{"Plant":"Southaven Energy Facility","State":"MS","Gas":612,"coordinates":[-90.0397,34.9808]},{"Plant":"Attala","State":"MS","Gas":455,"coordinates":[-89.6753,33.0147]},{"Plant":"Harry L. Oswald","State":"AR","Gas":548,"coordinates":[-92.2166,34.5923]},{"Plant":"Lincoln Generating Facility","State":"IL","Gas":624.9,"coordinates":[-87.9436,41.3933]},{"Plant":"Ennis Power Company LLC","State":"TX","Gas":359.5,"coordinates":[-96.675,32.32]},{"Plant":"Wheatland Generating Facility","State":"IN","Gas":472,"coordinates":[-87.2931,38.6716]},{"Plant":"Oneta Energy Center","State":"OK","Gas":1086.4,"coordinates":[-95.6967,36.0119]},{"Plant":"Freestone Energy Center","State":"TX","Gas":984,"coordinates":[-96.1131,31.8907]},{"Plant":"Greenville Electric Generating Station","State":"OH","Gas":201.6,"coordinates":[-84.6151,40.0758]},{"Plant":"Montpelier Electric Generating Station","State":"IN","Gas":180,"coordinates":[-85.3057,40.6206]},{"Plant":"Jack County","State":"TX","Gas":620.5,"coordinates":[-97.9574,33.101]},{"Plant":"Liberty Electric Power Plant","State":"PA","Gas":541,"coordinates":[-75.3358,39.8614]},{"Plant":"Marshall Energy Facility","State":"KY","Gas":620.8,"coordinates":[-88.3958,37.0286]},{"Plant":"Handsome Lake Energy LLC","State":"PA","Gas":267.5,"coordinates":[-79.8061,41.2908]},{"Plant":"Audrain Generating Station","State":"MO","Gas":608,"coordinates":[-91.5369,39.3092]},{"Plant":"Lee Energy Facility","State":"IL","Gas":623.5,"coordinates":[-89.4054,41.8287]},{"Plant":"Energy Shelby County","State":"IL","Gas":371.6,"coordinates":[-88.4772,39.2794]},{"Plant":"NRG Rockford I","State":"IL","Gas":296.3,"coordinates":[-89.1012,42.2386]},{"Plant":"Red Oak Power LLC","State":"NJ","Gas":765.9,"coordinates":[-74.3489,40.4487]},{"Plant":"Hog Bayou Energy Center","State":"AL","Gas":230,"coordinates":[-88.0575,30.7478]},{"Plant":"Santa Rosa Energy Center","State":"FL","Gas":235.9,"coordinates":[-87.115,30.5664]},{"Plant":"Astoria Gas Turbines","State":"NY","Gas":420,"coordinates":[-73.9048,40.787]},{"Plant":"Doyle Energy Facility","State":"GA","Gas":355,"coordinates":[-83.6996,33.8377]},{"Plant":"Darby Electric Generating Station","State":"OH","Gas":435,"coordinates":[-83.1778,39.7139]},{"Plant":"Tait Electric Generating Station","State":"OH","Gas":340,"coordinates":[-84.2095,39.7277]},{"Plant":"University Park South","State":"IL","Gas":300,"coordinates":[-87.7532,41.4409]},{"Plant":"Gleason Generating Facility","State":"TN","Gas":495,"coordinates":[-88.612,36.2454]},{"Plant":"Crete Energy Venture LLC","State":"IL","Gas":300,"coordinates":[-87.6187,41.4294]},{"Plant":"Whiting Clean Energy","State":"IN","Gas":513,"coordinates":[-87.4775,41.6739]},{"Plant":"Edward L. Addison Generating Plant","State":"GA","Gas":608,"coordinates":[-84.3064,32.9111]},{"Plant":"TVA Southaven Combined Cycle","State":"MS","Gas":777,"coordinates":[-90.0378,34.9939]},{"Plant":"Jackson Generating Station","State":"MI","Gas":564,"coordinates":[-84.3767,42.2488]},{"Plant":"Tenaska Lindsay Hill Generating Station","State":"AL","Gas":857.9,"coordinates":[-86.7386,32.6514]},{"Plant":"Ceredo Generating Station","State":"WV","Gas":450,"coordinates":[-82.5339,38.3681]},{"Plant":"Aurora","State":"IL","Gas":878,"coordinates":[-88.2265,41.8151]},{"Plant":"Southeast Chicago Energy Project","State":"IL","Gas":296,"coordinates":[-87.5449,41.7181]},{"Plant":"Arlington Valley Energy Facility","State":"AZ","Gas":580,"coordinates":[-112.8897,33.3417]},{"Plant":"Front Range Power Plant","State":"CO","Gas":461.5,"coordinates":[-104.7069,38.6281]},{"Plant":"Big Sandy Peaker Plant","State":"WV","Gas":300,"coordinates":[-82.5938,38.3441]},{"Plant":"Wolf Hills Energy","State":"VA","Gas":250,"coordinates":[-82.1044,36.6644]},{"Plant":"Oleander Power Project LP","State":"FL","Gas":315.9,"coordinates":[-80.7947,28.3661]},{"Plant":"Decatur Energy Center","State":"AL","Gas":624,"coordinates":[-87.0214,34.6292]},{"Plant":"Morgan Energy Center","State":"AL","Gas":749,"coordinates":[-87.0639,34.6397]},{"Plant":"Westbrook Energy Center Power Plant","State":"ME","Gas":506,"coordinates":[-70.375,43.6575]},{"Plant":"Blythe Energy Inc","State":"CA","Gas":514,"coordinates":[-114.6865,33.6157]},{"Plant":"Calumet Energy Team LLC","State":"IL","Gas":321.2,"coordinates":[-87.5563,41.6835]},{"Plant":"New Covert Generating Facility","State":"MI","Gas":1058.4,"coordinates":[-86.2937,42.3224]},{"Plant":"Fairless Energy Center","State":"PA","Gas":1207.2,"coordinates":[-74.7411,40.1475]},{"Plant":"Channel Energy Center LLC","State":"TX","Gas":585,"coordinates":[-95.2319,29.7189]},{"Plant":"Baconton Power Plant","State":"GA","Gas":195.2,"coordinates":[-84.08,31.3869]},{"Plant":"Gila River Power Station","State":"AZ","Gas":2060,"coordinates":[-112.6944,32.975]},{"Plant":"Air Products Port Arthur","State":"TX","Gas":129.1,"coordinates":[-93.9651,29.8665]},{"Plant":"Ingleside Cogeneration","State":"TX","Gas":460,"coordinates":[-97.2428,27.8828]},{"Plant":"Fore River Generating Station","State":"MA","Gas":688.3,"coordinates":[-70.9661,42.2422]},{"Plant":"Wise County Power LLC","State":"TX","Gas":655,"coordinates":[-97.9103,33.0583]},{"Plant":"Chuck Lenzie Generating Station","State":"NV","Gas":1128,"coordinates":[-114.9218,36.3837]},{"Plant":"Baytown Energy Center","State":"TX","Gas":770,"coordinates":[-94.9019,29.7731]},{"Plant":"Hermiston Power Partnership","State":"OR","Gas":615,"coordinates":[-119.3133,45.794]},{"Plant":"Washington County","State":"GA","Gas":627.3,"coordinates":[-82.98,33.0922]},{"Plant":"Delta Energy Center","State":"CA","Gas":769.1,"coordinates":[-121.8439,38.0169]},{"Plant":"Holland Energy Facility","State":"IL","Gas":643,"coordinates":[-88.7584,39.2231]},{"Plant":"PPL Ironwood LLC","State":"PA","Gas":669,"coordinates":[-76.3658,40.3509]},{"Plant":"Dell Power Station","State":"AR","Gas":679,"coordinates":[-90.0253,35.8619]},{"Plant":"Luna Energy Facility","State":"NM","Gas":559,"coordinates":[-107.7834,32.2993]},{"Plant":"Armstrong","State":"PA","Gas":584,"coordinates":[-79.3517,40.638]},{"Plant":"Troy Energy LLC","State":"OH","Gas":584,"coordinates":[-83.4598,41.4772]},{"Plant":"Pleasants Energy LLC","State":"WV","Gas":292.2,"coordinates":[-81.3642,39.3325]},{"Plant":"Brazos Valley Generating Facility","State":"TX","Gas":525,"coordinates":[-95.6244,29.4731]},{"Plant":"Cottonwood Energy Project","State":"TX","Gas":1233.6,"coordinates":[-93.7353,30.2588]},{"Plant":"Sugar Creek Power","State":"IN","Gas":520.7,"coordinates":[-87.5108,39.3931]},{"Plant":"Exelon LaPorte Generating Station","State":"TX","Gas":153.2,"coordinates":[-95.0718,29.7028]},{"Plant":"Harquahala Generating Project","State":"AZ","Gas":1054.4,"coordinates":[-113.1134,33.476]},{"Plant":"Astoria Energy","State":"NY","Gas":480,"coordinates":[-73.8964,40.7825]},{"Plant":"Union Power Partners LP","State":"AR","Gas":2020,"coordinates":[-92.5894,33.2961]},{"Plant":"Thomas A Smith Energy Facility","State":"GA","Gas":1250,"coordinates":[-84.9175,34.7094]},{"Plant":"Columbia Energy Center","State":"SC","Gas":464.5,"coordinates":[-81.0178,33.8697]},{"Plant":"RockGen Energy Center","State":"WI","Gas":471,"coordinates":[-89.0492,42.9767]},{"Plant":"Zion Energy Center","State":"IL","Gas":456,"coordinates":[-87.895,42.4776]},{"Plant":"Metcalf Energy Center","State":"CA","Gas":546.1,"coordinates":[-121.7457,37.2207]},{"Plant":"Crossroads Energy Center","State":"MS","Gas":308,"coordinates":[-90.5621,34.183]},{"Plant":"Washington Energy Facility","State":"OH","Gas":600,"coordinates":[-81.6564,39.58]},{"Plant":"Elk Hills Power LLC","State":"CA","Gas":525,"coordinates":[-119.4707,35.2803]},{"Plant":"Rolling Hills Generating","State":"OH","Gas":825,"coordinates":[-82.3328,39.0839]},{"Plant":"Renaissance Power LLC","State":"MI","Gas":660,"coordinates":[-84.8429,43.1864]},{"Plant":"Carville Energy LLC","State":"LA","Gas":473,"coordinates":[-91.065,30.2294]},{"Plant":"Athens Generating Plant","State":"NY","Gas":1137.9,"coordinates":[-73.8492,42.2728]},{"Plant":"Effingham County Power Project","State":"GA","Gas":463.4,"coordinates":[-81.2844,32.2773]},{"Plant":"Calhoun Energy Center","State":"AL","Gas":632,"coordinates":[-85.9731,33.5883]},{"Plant":"Osprey Energy Center Power Plant","State":"FL","Gas":595.1,"coordinates":[-81.8083,28.0525]},{"Plant":"Shady Hills Generating Station","State":"FL","Gas":468,"coordinates":[-82.5586,28.3665]},{"Plant":"Vandolah Power Station","State":"FL","Gas":632,"coordinates":[-81.924,27.5236]},{"Plant":"Raccoon Creek Energy Center","State":"IL","Gas":304,"coordinates":[-88.5392,38.6996]},{"Plant":"Hot Spring Generating Facility","State":"AR","Gas":630,"coordinates":[-92.8683,34.2976]},{"Plant":"Plaquemine Cogeneration Plant","State":"LA","Gas":793,"coordinates":[-91.2347,30.3217]},{"Plant":"DeSoto County Plant","State":"FL","Gas":320,"coordinates":[-81.8092,27.2272]},{"Plant":"Bayou Cove Peaking Power","State":"LA","Gas":300,"coordinates":[-92.5997,30.2825]},{"Plant":"Elgin Energy Center","State":"IL","Gas":460,"coordinates":[-88.2446,42.0001]},{"Plant":"Tenaska Virginia Generating Station","State":"VA","Gas":935.1,"coordinates":[-78.3813,37.8667]},{"Plant":"Tenaska Central Alabama Generating Stn","State":"AL","Gas":864,"coordinates":[-86.74,32.6497]},{"Plant":"Columbia Energy Center","State":"MO","Gas":140,"coordinates":[-92.2629,39.0192]},{"Plant":"Magnolia Power Plant","State":"MS","Gas":863.1,"coordinates":[-89.2026,34.835]},{"Plant":"Fountain Valley Power Facility","State":"CO","Gas":234,"coordinates":[-104.6875,38.5569]},{"Plant":"Red Hawk","State":"AZ","Gas":948,"coordinates":[-112.8406,33.3346]},{"Plant":"McClain Energy Facility","State":"OK","Gas":470,"coordinates":[-97.5898,35.2977]},{"Plant":"Redbud Power Plant","State":"OK","Gas":1143.6,"coordinates":[-97.2264,35.6856]},{"Plant":"Deer Park Energy Center","State":"TX","Gas":877.2,"coordinates":[-95.1345,29.7134]},{"Plant":"Ouachita","State":"LA","Gas":816,"coordinates":[-92.0683,32.7061]},{"Plant":"Green Power 2","State":"TX","Gas":584,"coordinates":[-94.9328,29.3781]},{"Plant":"Forney Energy Center","State":"TX","Gas":1640,"coordinates":[-96.4916,32.7563]},{"Plant":"Mesquite Generating Station","State":"AZ","Gas":1073.3,"coordinates":[-112.8642,33.345]},{"Plant":"Goldendale Generating Station","State":"WA","Gas":226,"coordinates":[-120.833,45.8114]},{"Plant":"Tri Center Naniwa Energy","State":"NV","Gas":300,"coordinates":[-119.5178,39.5572]},{"Plant":"Goose Creek Energy Center","State":"IL","Gas":438,"coordinates":[-88.5999,40.1069]},{"Plant":"Kiamichi Energy Facility","State":"OK","Gas":1178.4,"coordinates":[-95.9349,34.6831]},{"Plant":"Lawrenceburg Energy Facility","State":"IN","Gas":1080,"coordinates":[-84.8669,39.0911]},{"Plant":"AEP Waterford Facility","State":"OH","Gas":810,"coordinates":[-81.7178,39.5333]},{"Plant":"Limon Generating Station","State":"CO","Gas":134,"coordinates":[-103.7005,39.2038]},{"Plant":"Frank Knutson","State":"CO","Gas":134,"coordinates":[-104.682,39.9411]},{"Plant":"Apex Generating Station","State":"NV","Gas":494.4,"coordinates":[-114.9609,36.416]},{"Plant":"Fayette Energy Facility","State":"PA","Gas":600.5,"coordinates":[-79.9182,39.8592]},{"Plant":"Wallingford Energy","State":"CT","Gas":190,"coordinates":[-72.8354,41.4487]},{"Plant":"High Desert Power Plant","State":"CA","Gas":742.6,"coordinates":[-117.3647,34.5953]},{"Plant":"AES Greystone","State":"TN","Gas":468,"coordinates":[-89.3937,35.6532]},{"Plant":"Sundance","State":"AZ","Gas":410,"coordinates":[-111.5899,32.9285]},{"Plant":"Indigo Energy Facility","State":"CA","Gas":149.7,"coordinates":[-116.553,33.9109]},{"Plant":"Hidalgo Energy Center","State":"TX","Gas":470,"coordinates":[-98.1758,26.3417]},{"Plant":"Perryville Power Station","State":"LA","Gas":691,"coordinates":[-92.0183,32.6908]},{"Plant":"West Valley Generation Project","State":"UT","Gas":202,"coordinates":[-112.0317,40.6667]},{"Plant":"University Park North","State":"IL","Gas":504,"coordinates":[-87.7514,41.4425]},{"Plant":"Riverside Energy Center","State":"WI","Gas":598.3,"coordinates":[-89.0355,42.5827]},{"Plant":"Blue Spruce Energy Center","State":"CO","Gas":276,"coordinates":[-104.6814,39.7479]},{"Plant":"Plains End","State":"CO","Gas":114,"coordinates":[-105.226,39.8575]},{"Plant":"Spring Creek Energy Center","State":"OK","Gas":272,"coordinates":[-97.655,35.7422]},{"Plant":"Pastoria Energy Facility, LLC","State":"CA","Gas":724,"coordinates":[-118.844,34.9556]},{"Plant":"EP Newington Energy LLC","State":"NH","Gas":525,"coordinates":[-70.8061,43.1047]},{"Plant":"Chehalis Generating Facility","State":"WA","Gas":495,"coordinates":[-122.9131,46.6225]},{"Plant":"Harrison County Power Project","State":"TX","Gas":514.4,"coordinates":[-94.4367,32.3958]},{"Plant":"Lower Mount Bethel Energy","State":"PA","Gas":593.8,"coordinates":[-75.1076,40.8019]},{"Plant":"AL Sandersville LLC","State":"GA","Gas":596.8,"coordinates":[-82.8608,33.1189]},{"Plant":"Higgins Generating Station","State":"NV","Gas":570,"coordinates":[-115.3561,35.6139]},{"Plant":"Bethlehem Power Plant","State":"PA","Gas":1130,"coordinates":[-75.3147,40.6175]},{"Plant":"Quantum Choctaw Power LLC","State":"MS","Gas":650,"coordinates":[-89.2089,33.3792]},{"Plant":"Mint Farm Generating Station","State":"WA","Gas":292,"coordinates":[-122.9855,46.1388]},{"Plant":"Pierce Power Station","State":"WA","Gas":130.9,"coordinates":[-122.3758,47.1365]},{"Plant":"Choctaw County","State":"MS","Gas":848,"coordinates":[-89.4201,33.2881]},{"Plant":"Allegheny Energy Units 3 4 & 5","State":"PA","Gas":509,"coordinates":[-79.7686,40.5453]},{"Plant":"Magnet Cove","State":"AR","Gas":641.5,"coordinates":[-92.8317,34.4297]},{"Plant":"Dean","State":"MI","Gas":295.4,"coordinates":[-82.4953,42.7725]},{"Plant":"Bennett Mountain","State":"ID","Gas":164,"coordinates":[-115.6666,43.1472]},{"Plant":"Hanging Rock Energy Facility","State":"OH","Gas":1288,"coordinates":[-82.7833,38.5731]},{"Plant":"Los Esteros Critical Energy Center","State":"CA","Gas":180,"coordinates":[-121.9319,37.425]},{"Plant":"FPL Energy Marcus Hook LP","State":"PA","Gas":717.5,"coordinates":[-75.4216,39.807]},{"Plant":"Valencia Energy Facility","State":"NM","Gas":144.3,"coordinates":[-106.7322,34.6115]},{"Plant":"Gilroy Peaking Energy Center","State":"CA","Gas":135,"coordinates":[-121.5363,36.999]},{"Plant":"Frederickson Power LP","State":"WA","Gas":246,"coordinates":[-122.3657,47.0861]},{"Plant":"Curtis H Stanton Energy Center","State":"FL","Gas":592,"coordinates":[-81.1669,28.4882]},{"Plant":"Auburndale Peaker Energy Center","State":"FL","Gas":118,"coordinates":[-81.8059,28.0535]},{"Plant":"Rocky Mountain Energy Center","State":"CO","Gas":608,"coordinates":[-104.5953,40.0908]},{"Plant":"Silverhawk","State":"NV","Gas":560,"coordinates":[-114.9606,36.4078]},{"Plant":"Jasper","State":"SC","Gas":852,"coordinates":[-81.1242,32.3594]},{"Plant":"Tracy Combined Cycle Power Plant","State":"CA","Gas":167.1,"coordinates":[-121.4906,37.7107]},{"Plant":"NRG Rockford II Energy Center","State":"IL","Gas":153.2,"coordinates":[-89.1011,42.2383]},{"Plant":"NAEA Ocean Peaking Power LLC","State":"NJ","Gas":325.6,"coordinates":[-74.1672,40.0633]},{"Plant":"Las Vegas Cogeneration II LLC","State":"NV","Gas":220,"coordinates":[-115.1238,36.232]},{"Plant":"Wansley Combined Cycle","State":"GA","Gas":1129,"coordinates":[-85.037,33.4064]},{"Plant":"Cosumnes","State":"CA","Gas":477,"coordinates":[-121.124,38.3385]},{"Plant":"Cass County","State":"NE","Gas":320,"coordinates":[-95.964,40.9479]},{"Plant":"Hunterstown","State":"PA","Gas":810,"coordinates":[-77.1672,39.8725]},{"Plant":"Palomar Energy","State":"CA","Gas":562,"coordinates":[-117.1178,33.1197]},{"Plant":"Exira","State":"IA","Gas":139,"coordinates":[-94.9197,41.5144]},{"Plant":"Donald Von Raesfeld Power Plant","State":"CA","Gas":154,"coordinates":[-121.9508,37.3767]},{"Plant":"Fox Energy Center","State":"WI","Gas":548,"coordinates":[-88.2089,44.3204]},{"Plant":"Malburg","State":"CA","Gas":143,"coordinates":[-118.2219,33.9986]},{"Plant":"Magnolia Power Project","State":"CA","Gas":323,"coordinates":[-118.3153,34.1786]},{"Plant":"Walnut Energy Center","State":"CA","Gas":269,"coordinates":[-120.8956,37.4878]},{"Plant":"Currant Creek","State":"UT","Gas":527,"coordinates":[-111.8935,39.8214]},{"Plant":"Mankato Energy Center","State":"MN","Gas":300,"coordinates":[-94.003,44.1988]},{"Plant":"McIntosh Combined Cycle Facility","State":"GA","Gas":1184,"coordinates":[-81.1817,32.3478]},{"Plant":"South Harper","State":"MO","Gas":315,"coordinates":[-94.4824,38.6803]},{"Plant":"Freeport Energy Center","State":"TX","Gas":249.4,"coordinates":[-95.3954,28.9888]},{"Plant":"Faribault Energy Park","State":"MN","Gas":282.2,"coordinates":[-93.2906,44.3356]},{"Plant":"Sheboygan Falls","State":"WI","Gas":301.6,"coordinates":[-87.8781,43.7518]},{"Plant":"Nebo Power Station","State":"UT","Gas":120.4,"coordinates":[-111.7294,40.0614]},{"Plant":"500MW CC","State":"NY","Gas":454.1,"coordinates":[-73.9069,40.7889]},{"Plant":"Port Westward","State":"OR","Gas":392.2,"coordinates":[-123.172,46.1789]},{"Plant":"EG178 Facility","State":"TX","Gas":108,"coordinates":[-100.9547,32.7471]},{"Plant":"Lake Side Power Plant","State":"UT","Gas":488.5,"coordinates":[-111.7542,40.3317]},{"Plant":"Groton Generating Station","State":"SD","Gas":169,"coordinates":[-98.0987,45.3735]},{"Plant":"Kings River","State":"CA","Gas":109,"coordinates":[-119.7404,36.6697]},{"Plant":"Cannon Falls Energy Center","State":"MN","Gas":398,"coordinates":[-92.9155,44.5367]},{"Plant":"Anson County Generation Facility","State":"NC","Gas":339,"coordinates":[-79.9217,34.9687]},{"Plant":"Hamlet Generating Facility","State":"NC","Gas":282.5,"coordinates":[-79.7361,34.8423]},{"Plant":"Roseville Energy Park","State":"CA","Gas":141,"coordinates":[-121.3811,38.7928]},{"Plant":"Mustang Station Unit 4","State":"TX","Gas":290,"coordinates":[-102.7436,32.9746]},{"Plant":"Harry D Mattison Gas Plant","State":"AR","Gas":294,"coordinates":[-94.2841,36.1855]},{"Plant":"Quail Run Energy Center","State":"TX","Gas":482,"coordinates":[-102.315,31.8414]},{"Plant":"Colorado Bend Energy Center","State":"TX","Gas":510,"coordinates":[-96.0683,29.2878]},{"Plant":"Treasure Coast Energy Center","State":"FL","Gas":318,"coordinates":[-80.3775,27.3839]},{"Plant":"Spindle Hill Energy Center","State":"CO","Gas":270,"coordinates":[-104.8878,40.0922]},{"Plant":"Hobbs Generating Station","State":"NM","Gas":602,"coordinates":[-103.3094,32.7283]},{"Plant":"Western 102 Power Plant","State":"NV","Gas":110.6,"coordinates":[-119.5108,39.5603]},{"Plant":"Emporia Energy Center","State":"KS","Gas":323,"coordinates":[-96.0652,38.4459]},{"Plant":"Jonesboro City Water & Light Plant","State":"AR","Gas":177,"coordinates":[-90.7254,35.8486]},{"Plant":"Plains End II LLC","State":"CO","Gas":116.2,"coordinates":[-105.2256,39.8586]},{"Plant":"San Jacinto County Peaking Facility","State":"TX","Gas":156,"coordinates":[-95.0118,30.4193]},{"Plant":"Hardin County Peaking Facility","State":"TX","Gas":156,"coordinates":[-94.2526,30.3038]},{"Plant":"McKee Run","State":"DE","Gas":136,"coordinates":[-75.5466,39.1762]},{"Plant":"Olive","State":"CA","Gas":154.5,"coordinates":[-118.3147,34.1764]},{"Plant":"Collins","State":"IL","Gas":2671,"coordinates":[-88.3928,41.3461]},{"Plant":"Belle River","State":"MI","Gas":225,"coordinates":[-82.495,42.7756]},{"Plant":"Greenwood","State":"MI","Gas":1010,"coordinates":[-82.6964,43.1056]},{"Plant":"Manatee","State":"FL","Gas":1104,"coordinates":[-82.3456,27.6058]},{"Plant":"Martin","State":"FL","Gas":2136,"coordinates":[-80.5628,27.0536]},{"Plant":"DeBary","State":"FL","Gas":247,"coordinates":[-81.3323,28.9039]},{"Plant":"Electrifarm","State":"IA","Gas":197.9,"coordinates":[-92.4205,42.4407]},{"Plant":"Fredonia","State":"WA","Gas":266,"coordinates":[-122.4358,48.4558]},{"Plant":"Trimble County","State":"KY","Gas":960,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Gas":966,"coordinates":[-88.5553,30.5322]},{"Plant":"Greenwood","State":"MO","Gas":244.6,"coordinates":[-94.2982,38.8615]},{"Plant":"R M Schahfer","State":"IN","Gas":155,"coordinates":[-87.0261,41.2164]},{"Plant":"Cutler","State":"FL","Gas":205,"coordinates":[-80.2989,25.6321]},{"Plant":"Fort St Vrain","State":"CO","Gas":695,"coordinates":[-104.8742,40.2461]},{"Plant":"Fort Myers","State":"FL","Gas":1764,"coordinates":[-81.7831,26.6967]},{"Plant":"Whitehorn","State":"WA","Gas":126,"coordinates":[-122.6861,48.8288]},{"Plant":"McIntosh","State":"GA","Gas":657.6,"coordinates":[-81.1683,32.3563]},{"Plant":"Lauderdale","State":"FL","Gas":1712,"coordinates":[-80.1984,26.0686]},{"Plant":"A B Brown","State":"IN","Gas":160,"coordinates":[-87.715,37.9053]},{"Plant":"Port Everglades","State":"FL","Gas":420,"coordinates":[-80.1253,26.0856]},{"Plant":"Brame Energy Center","State":"LA","Gas":435,"coordinates":[-92.7167,31.395]},{"Plant":"John Twitty Energy Center","State":"MO","Gas":104,"coordinates":[-93.388,37.1517]},{"Plant":"Sanford","State":"FL","Gas":1916,"coordinates":[-81.3256,28.8419]},{"Plant":"Turkey Point","State":"FL","Gas":1144,"coordinates":[-80.3308,25.4356]},{"Plant":"Empire Energy Center","State":"MO","Gas":269,"coordinates":[-94.1041,37.1385]},{"Plant":"Dansby","State":"TX","Gas":157.1,"coordinates":[-96.4608,30.7217]},{"Plant":"Putnam","State":"FL","Gas":498,"coordinates":[-81.5851,29.6283]},{"Plant":"Higgins","State":"FL","Gas":113,"coordinates":[-82.6615,28.0033]},{"Plant":"Rokeby","State":"NE","Gas":245.7,"coordinates":[-96.7364,40.7316]},{"Plant":"Suwannee River","State":"FL","Gas":103,"coordinates":[-83.1806,30.3764]},{"Plant":"Lansing Smith","State":"FL","Gas":481,"coordinates":[-85.7003,30.2686]},{"Plant":"D G Hunter","State":"LA","Gas":157,"coordinates":[-92.4613,31.3207]},{"Plant":"George M Sullivan Generation Plant 2","State":"AK","Gas":219.9,"coordinates":[-149.7167,61.2297]},{"Plant":"Henry D King","State":"FL","Gas":129.4,"coordinates":[-80.3386,27.4486]},{"Plant":"Deerhaven Generating Station","State":"FL","Gas":194,"coordinates":[-82.3878,29.7592]},{"Plant":"John R Kelly","State":"FL","Gas":191.2,"coordinates":[-82.3208,29.6461]},{"Plant":"J D Kennedy","State":"FL","Gas":158.6,"coordinates":[-81.626,30.3648]},{"Plant":"Larsen Memorial","State":"FL","Gas":145,"coordinates":[-81.9228,28.0797]},{"Plant":"C D McIntosh Jr","State":"FL","Gas":524,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Gas":388,"coordinates":[-105.0212,40.8609]},{"Plant":"Indian River Plant","State":"FL","Gas":290,"coordinates":[-80.7801,28.4932]},{"Plant":"Arvah B Hopkins","State":"FL","Gas":500,"coordinates":[-84.4,30.4522]},{"Plant":"S O Purdom","State":"FL","Gas":301,"coordinates":[-84.2007,30.1623]},{"Plant":"Vero Beach Municipal Power Plant","State":"FL","Gas":150,"coordinates":[-80.3776,27.6334]},{"Plant":"Atkinson","State":"GA","Gas":182,"coordinates":[-84.4803,33.8175]},{"Plant":"Gravel Neck","State":"VA","Gas":316,"coordinates":[-76.6911,37.1575]},{"Plant":"McIntosh","State":"AL","Gas":338,"coordinates":[-88.0299,31.2546]},{"Plant":"Harry Allen","State":"NV","Gas":144,"coordinates":[-114.9024,36.4306]},{"Plant":"Pleasant Hill","State":"IA","Gas":159.5,"coordinates":[-93.5242,41.5572]},{"Plant":"Hay Road","State":"DE","Gas":1090,"coordinates":[-75.5072,39.7436]},{"Plant":"Woodsdale","State":"OH","Gas":462,"coordinates":[-84.4611,39.4492]},{"Plant":"Concord","State":"WI","Gas":388,"coordinates":[-88.69,43.1669]},{"Plant":"South Fond Du Lac","State":"WI","Gas":324.8,"coordinates":[-88.4967,43.7353]},{"Plant":"Darbytown","State":"VA","Gas":336,"coordinates":[-77.3685,37.4982]},{"Plant":"Angus Anson","State":"SD","Gas":383.9,"coordinates":[-96.6356,43.6035]},{"Plant":"Cane Island","State":"FL","Gas":380,"coordinates":[-81.533,28.2764]},{"Plant":"Polk","State":"FL","Gas":604,"coordinates":[-81.9897,27.7286]},{"Plant":"Woodland","State":"CA","Gas":133,"coordinates":[-121.0204,37.6526]},{"Plant":"491 E 48th Street","State":"MI","Gas":136,"coordinates":[-86.0853,42.7553]},{"Plant":"Paris","State":"WI","Gas":400,"coordinates":[-88.0131,42.6658]},{"Plant":"Lincoln Combustion","State":"NC","Gas":1267.2,"coordinates":[-81.0347,35.4317]},{"Plant":"State Line Combined Cycle","State":"MO","Gas":596,"coordinates":[-94.614,37.0659]},{"Plant":"Hines Energy Complex","State":"FL","Gas":1912,"coordinates":[-81.87,27.7882]},{"Plant":"Redding Power","State":"CA","Gas":137,"coordinates":[-122.4233,40.5073]},{"Plant":"San Jacinto Steam Electric Station","State":"TX","Gas":162,"coordinates":[-95.0406,29.6948]},{"Plant":"Kraft","State":"GA","Gas":132,"coordinates":[-81.1458,32.1486]},{"Plant":"Anderson","State":"IN","Gas":140,"coordinates":[-85.7389,40.0529]},{"Plant":"Riverside","State":"GA","Gas":107,"coordinates":[-81.0956,32.0836]},{"Plant":"Robins","State":"GA","Gas":160,"coordinates":[-83.5822,32.5792]},{"Plant":"Coyote Springs","State":"OR","Gas":226.1,"coordinates":[-119.6739,45.848]},{"Plant":"Midulla Generating Station","State":"FL","Gas":758,"coordinates":[-81.9625,27.6417]},{"Plant":"Interstate","State":"IL","Gas":128,"coordinates":[-89.5891,39.8233]},{"Plant":"Rathdrum","State":"ID","Gas":132,"coordinates":[-116.8673,47.8043]},{"Plant":"Anchorage 1","State":"AK","Gas":106.1,"coordinates":[-149.8661,61.2221]},{"Plant":"Arthur Von Rosenberg","State":"TX","Gas":465,"coordinates":[-98.384,29.257]},{"Plant":"Carson Ice-Gen Project","State":"CA","Gas":101,"coordinates":[-121.4624,38.4457]},{"Plant":"Wayne County","State":"NC","Gas":694,"coordinates":[-78.0981,35.3758]},{"Plant":"Ponca City","State":"OK","Gas":106.8,"coordinates":[-97.0858,36.7198]},{"Plant":"SCA Cogen 2","State":"CA","Gas":162.6,"coordinates":[-121.4001,38.5309]},{"Plant":"SPA Cogen 3","State":"CA","Gas":164,"coordinates":[-121.4735,38.511]},{"Plant":"St Francis Energy Facility","State":"MO","Gas":473,"coordinates":[-90.1779,36.5852]},{"Plant":"River Road Gen Plant","State":"WA","Gas":220,"coordinates":[-122.7256,45.6497]},{"Plant":"Tiger Bay","State":"FL","Gas":205,"coordinates":[-81.8494,27.7464]},{"Plant":"Dahlberg","State":"GA","Gas":750,"coordinates":[-83.3977,34.0423]},{"Plant":"H Allen Franklin Combined Cycle","State":"AL","Gas":1808.4,"coordinates":[-85.0975,32.6078]},{"Plant":"Theodore Cogen Facility","State":"AL","Gas":224.7,"coordinates":[-88.1285,30.5254]},{"Plant":"Essex","State":"MO","Gas":107.4,"coordinates":[-89.8402,36.8682]},{"Plant":"Nodaway","State":"MO","Gas":182.8,"coordinates":[-94.7913,40.2877]},{"Plant":"Chouteau","State":"OK","Gas":495,"coordinates":[-95.2771,36.2221]},{"Plant":"Georgetown","State":"IN","Gas":295,"coordinates":[-86.2441,39.9026]},{"Plant":"Tilton","State":"IL","Gas":176,"coordinates":[-87.6538,40.1061]},{"Plant":"Henry County","State":"IN","Gas":135.5,"coordinates":[-85.5039,39.9528]},{"Plant":"MPC Generating","State":"GA","Gas":309.4,"coordinates":[-83.6953,33.8119]},{"Plant":"Sherwood H Smith Jr Energy Complex","State":"NC","Gas":1287,"coordinates":[-79.7406,34.8392]},{"Plant":"Sewell Creek Energy","State":"GA","Gas":495.2,"coordinates":[-85.2769,33.9486]},{"Plant":"Alsey","State":"IL","Gas":121,"coordinates":[-90.436,39.5698]},{"Plant":"Fulton","State":"AR","Gas":153,"coordinates":[-93.7924,33.6094]},{"Plant":"Rowan","State":"NC","Gas":974,"coordinates":[-80.6019,35.7314]},{"Plant":"Smarr Energy Center","State":"GA","Gas":217,"coordinates":[-83.8464,32.9842]},{"Plant":"John S Rainey","State":"SC","Gas":958.2,"coordinates":[-82.776,34.3477]},{"Plant":"Essential Power Rock Springs LLC","State":"MD","Gas":632.2,"coordinates":[-76.1598,39.719]},{"Plant":"Marsh Run Generating","State":"VA","Gas":469.5,"coordinates":[-77.7681,38.5283]},{"Plant":"Louisa Generating","State":"VA","Gas":458.5,"coordinates":[-78.2139,38.1181]},{"Plant":"Remington","State":"VA","Gas":608,"coordinates":[-77.7714,38.5442]},{"Plant":"Ladysmith","State":"VA","Gas":623,"coordinates":[-77.5133,38.0722]},{"Plant":"Pleasant Valley","State":"MN","Gas":420.4,"coordinates":[-92.6829,43.7994]},{"Plant":"Lagoon Creek","State":"TN","Gas":940.8,"coordinates":[-89.3964,35.6578]},{"Plant":"Brandy Branch","State":"FL","Gas":660.8,"coordinates":[-81.9472,30.3206]},{"Plant":"Holden","State":"MO","Gas":232.8,"coordinates":[-93.9983,38.7538]},{"Plant":"MEPI GT Facility","State":"IL","Gas":239,"coordinates":[-88.8661,37.2175]},{"Plant":"Encogen","State":"WA","Gas":139.2,"coordinates":[-122.486,48.746]},{"Plant":"Robert P Mone Plant","State":"OH","Gas":446.2,"coordinates":[-84.7392,40.9297]},{"Plant":"H L Culbreath Bayside Power Station","State":"FL","Gas":1630,"coordinates":[-82.4231,27.9072]},{"Plant":"Terry Bundy Generating Station","State":"NE","Gas":167.4,"coordinates":[-96.6131,40.9097]},{"Plant":"E B Harris Electric Generating Plant","State":"AL","Gas":1253.8,"coordinates":[-86.5744,32.3814]},{"Plant":"Sand Hill","State":"TX","Gas":501.2,"coordinates":[-97.6129,30.2098]},{"Plant":"Talbot County Energy","State":"GA","Gas":656.4,"coordinates":[-84.6917,32.5892]},{"Plant":"Chattahoochee Energy Facility","State":"GA","Gas":465,"coordinates":[-85.0386,33.4072]},{"Plant":"Lakefield Junction","State":"MN","Gas":499.6,"coordinates":[-94.8415,43.7984]},{"Plant":"West Gardner","State":"KS","Gas":308,"coordinates":[-94.9861,38.7875]},{"Plant":"Coyote Springs II","State":"OR","Gas":242.7,"coordinates":[-119.674,45.848]},{"Plant":"Wansley Unit 9","State":"GA","Gas":497.4,"coordinates":[-85.0403,33.4083]},{"Plant":"Lawrence County Station","State":"IN","Gas":261,"coordinates":[-86.4511,38.8003]},{"Plant":"Evander Andrews Power Complex","State":"ID","Gas":240.2,"coordinates":[-115.7343,43.1792]},{"Plant":"Kemper County","State":"MS","Gas":312.8,"coordinates":[-88.606,32.7976]},{"Plant":"Peno Creek","State":"MO","Gas":188,"coordinates":[-91.2295,39.3531]},{"Plant":"Sumpter","State":"MI","Gas":340,"coordinates":[-83.5318,42.167]},{"Plant":"Pyramid","State":"NM","Gas":158,"coordinates":[-108.5494,32.2363]},{"Plant":"Mill Creek","State":"SC","Gas":595.2,"coordinates":[-81.4306,35.1597]},{"Plant":"Greater Des Moines","State":"IA","Gas":493,"coordinates":[-93.5283,41.5563]},{"Plant":"Silver Creek","State":"MS","Gas":225,"coordinates":[-89.9468,31.6004]},{"Plant":"Sylvarena","State":"MS","Gas":129,"coordinates":[-89.4127,31.9821]},{"Plant":"West Campus Cogeneration Facility","State":"WI","Gas":130.2,"coordinates":[-89.4251,43.0751]},{"Plant":"Grays Harbor Energy Facility","State":"WA","Gas":637,"coordinates":[-123.48,46.9692]},{"Plant":"Beatrice","State":"NE","Gas":237,"coordinates":[-96.8082,40.3302]},{"Plant":"Blue Lake","State":"MN","Gas":315.8,"coordinates":[-93.4315,44.7855]},{"Plant":"Sycamore","State":"IA","Gas":147.5,"coordinates":[-93.6769,41.6722]},{"Plant":"Emery Station","State":"IA","Gas":551.8,"coordinates":[-93.2922,43.094]},{"Plant":"Intercession City","State":"FL","Gas":560,"coordinates":[-81.5486,28.2628]},{"Plant":"Gerald Andrus","State":"MS","Gas":712,"coordinates":[-91.1167,33.35]},{"Plant":"Waterford 1 & 2","State":"LA","Gas":816,"coordinates":[-90.4768,29.9989]},{"Plant":"Comanche","State":"OK","Gas":260,"coordinates":[-98.3244,34.5431]},{"Plant":"DeCordova Steam Electric Station","State":"TX","Gas":1138,"coordinates":[-97.7006,32.4031]},{"Plant":"Santan","State":"AZ","Gas":1227,"coordinates":[-111.7503,33.3325]},{"Plant":"Beaver","State":"OR","Gas":492.8,"coordinates":[-123.1739,46.1724]},{"Plant":"Glen Gardner","State":"NJ","Gas":160,"coordinates":[-74.9207,40.6815]},{"Plant":"Grand Tower","State":"IL","Gas":513,"coordinates":[-89.5112,37.6577]},{"Plant":"Calumet","State":"IL","Gas":203.9,"coordinates":[-87.5428,41.7136]},{"Plant":"Crawford","State":"IL","Gas":172.8,"coordinates":[-87.7229,41.8285]},{"Plant":"Electric Junction","State":"IL","Gas":217.4,"coordinates":[-88.0833,41.8333]},{"Plant":"Joliet 9","State":"IL","Gas":115.1,"coordinates":[-88.1153,41.4931]},{"Plant":"Astoria Generating Station","State":"NY","Gas":190,"coordinates":[-73.9126,40.7877]},{"Plant":"Wood River","State":"IL","Gas":116.1,"coordinates":[-90.1347,38.8639]},{"Plant":"Venice","State":"IL","Gas":492,"coordinates":[-90.1764,38.6642]},{"Plant":"Beluga","State":"AK","Gas":344.4,"coordinates":[-151.0356,61.1861]},{"Plant":"Marion","State":"IL","Gas":140,"coordinates":[-88.9531,37.6197]},{"Plant":"Frederickson","State":"WA","Gas":126,"coordinates":[-122.365,47.0797]},{"Plant":"Harding Street","State":"IN","Gas":322,"coordinates":[-86.1969,39.7113]},{"Plant":"Dean H Mitchell","State":"IN","Gas":142,"coordinates":[-87.4069,41.6392]},{"Plant":"Michigan City","State":"IN","Gas":120,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Gas":740,"coordinates":[-87.7811,32.6017]},{"Plant":"Gilroy Power Plant","State":"CA","Gas":105,"coordinates":[-121.5367,37.0001]},{"Plant":"Noblesville","State":"IN","Gas":285.9,"coordinates":[-85.9714,40.0969]},{"Plant":"Pedricktown Cogeneration Company LP","State":"NJ","Gas":126.2,"coordinates":[-75.4238,39.7668]},{"Plant":"Broadway","State":"IN","Gas":115,"coordinates":[-87.6049,37.9691]},{"Plant":"Butler-Warner Generation Plant","State":"NC","Gas":225,"coordinates":[-78.8294,35.0986]},{"Plant":"El Segundo Cogen","State":"CA","Gas":127.7,"coordinates":[-118.4031,33.9058]},{"Plant":"ArcelorMittal Burns Harbor","State":"IN","Gas":174.7,"coordinates":[-87.1387,41.635]},{"Plant":"King City Power Plant","State":"CA","Gas":111,"coordinates":[-121.1278,36.225]},{"Plant":"Bayou Cogen Plant","State":"TX","Gas":260,"coordinates":[-95.0458,29.6225]},{"Plant":"Bellingham Cogeneration Facility","State":"MA","Gas":264,"coordinates":[-71.4833,42.0925]},{"Plant":"Sayreville Cogeneration Facility","State":"NJ","Gas":271,"coordinates":[-74.3444,40.439]},{"Plant":"Foster Wheeler Martinez","State":"CA","Gas":103.5,"coordinates":[-122.0589,38.0244]},{"Plant":"ExxonMobil Baytown Refinery","State":"TX","Gas":130,"coordinates":[-94.9973,29.7535]},{"Plant":"RG Steel Sparrows Point, LLC","State":"MD","Gas":152.3,"coordinates":[-76.4729,39.213]},{"Plant":"Kern River Cogeneration","State":"CA","Gas":288,"coordinates":[-118.9849,35.4515]},{"Plant":"Formosa Utility Venture Ltd","State":"TX","Gas":597.3,"coordinates":[-96.5417,28.6917]},{"Plant":"Hopewell Cogeneration","State":"VA","Gas":348.3,"coordinates":[-77.2811,37.2917]},{"Plant":"Brush Generation Facility","State":"CO","Gas":292,"coordinates":[-103.631,40.2415]},{"Plant":"ExxonMobil Baytown Turbine","State":"TX","Gas":320.4,"coordinates":[-95.0096,29.7591]},{"Plant":"Selkirk Cogen","State":"NY","Gas":368.9,"coordinates":[-73.8592,42.5744]},{"Plant":"Masspower","State":"MA","Gas":238.3,"coordinates":[-72.5225,42.1575]},{"Plant":"Clear Lake Cogeneration Ltd","State":"TX","Gas":366,"coordinates":[-95.067,29.6255]},{"Plant":"Midland Cogeneration Venture","State":"MI","Gas":1839.4,"coordinates":[-84.2242,43.5861]},{"Plant":"Camden Plant Holding LLC","State":"NJ","Gas":147.4,"coordinates":[-75.1192,39.9175]},{"Plant":"River Hills","State":"IA","Gas":116.5,"coordinates":[-93.6195,41.5902]},{"Plant":"Hazelton","State":"PA","Gas":147.2,"coordinates":[-76.0409,40.9282]},{"Plant":"Ocotillo","State":"AZ","Gas":320,"coordinates":[-111.9122,33.4225]},{"Plant":"West Phoenix","State":"AZ","Gas":939,"coordinates":[-112.1583,33.4417]},{"Plant":"Saguaro","State":"AZ","Gas":386,"coordinates":[-111.3,32.5517]},{"Plant":"Yucca","State":"AZ","Gas":259,"coordinates":[-114.7106,32.7214]},{"Plant":"Fort Dodge","State":"KS","Gas":146.6,"coordinates":[-99.9497,37.7328]},{"Plant":"Riverton","State":"KS","Gas":194,"coordinates":[-94.6987,37.0726]},{"Plant":"Gordon Evans Energy Center","State":"KS","Gas":832,"coordinates":[-97.5217,37.7903]},{"Plant":"Murray Gill","State":"KS","Gas":286,"coordinates":[-97.4136,37.5967]},{"Plant":"Hutchinson Energy Center","State":"KS","Gas":333,"coordinates":[-97.8747,38.0906]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Gas":316,"coordinates":[-110.9047,32.16]},{"Plant":"Kaw","State":"KS","Gas":140.3,"coordinates":[-94.6514,39.0867]},{"Plant":"McPherson 2","State":"KS","Gas":104,"coordinates":[-97.6834,38.3634]},{"Plant":"Garden City","State":"KS","Gas":225.1,"coordinates":[-100.8956,37.9703]},{"Plant":"E W Brown","State":"KY","Gas":849,"coordinates":[-84.7126,37.7883]},{"Plant":"Paddys Run","State":"KY","Gas":193,"coordinates":[-85.8417,38.2236]},{"Plant":"Louisiana 1","State":"LA","Gas":382.4,"coordinates":[-91.1864,30.4922]},{"Plant":"Louisiana 2","State":"LA","Gas":138,"coordinates":[-91.1864,30.4922]},{"Plant":"R S Nelson","State":"LA","Gas":603,"coordinates":[-93.2911,30.2844]},{"Plant":"Willow Glen","State":"LA","Gas":1752,"coordinates":[-91.1164,30.2743]},{"Plant":"Coughlin Power Station","State":"LA","Gas":732,"coordinates":[-92.2611,30.8439]},{"Plant":"Teche","State":"LA","Gas":384,"coordinates":[-91.5425,29.8222]},{"Plant":"Little Gypsy","State":"LA","Gas":1178,"coordinates":[-90.4617,30.0051]},{"Plant":"Nine Mile Point","State":"LA","Gas":1732,"coordinates":[-90.1458,29.9472]},{"Plant":"Sterlington","State":"LA","Gas":385,"coordinates":[-92.0792,32.7047]},{"Plant":"A B Paterson","State":"LA","Gas":112,"coordinates":[-90.0256,30.0158]},{"Plant":"Michoud","State":"LA","Gas":810,"coordinates":[-89.9372,30.0081]},{"Plant":"Agua Fria","State":"AZ","Gas":626,"coordinates":[-112.2153,33.5561]},{"Plant":"Arsenal Hill","State":"LA","Gas":116,"coordinates":[-93.7611,32.5181]},{"Plant":"Lieberman","State":"LA","Gas":268,"coordinates":[-93.9597,32.7047]},{"Plant":"Louis Doc Bonin","State":"LA","Gas":302,"coordinates":[-92.0463,30.238]},{"Plant":"Monroe","State":"LA","Gas":126,"coordinates":[-92.1794,32.5233]},{"Plant":"Big Cajun 1","State":"LA","Gas":430,"coordinates":[-91.3556,30.6739]},{"Plant":"Kyrene","State":"AZ","Gas":525,"coordinates":[-111.9353,33.3556]},{"Plant":"Herbert A Wagner","State":"MD","Gas":126,"coordinates":[-76.5268,39.1781]},{"Plant":"Notch Cliff","State":"MD","Gas":116.7,"coordinates":[-76.5087,39.4217]},{"Plant":"Perryman","State":"MD","Gas":147.6,"coordinates":[-76.2218,39.4428]},{"Plant":"Riverside","State":"MD","Gas":189,"coordinates":[-76.5133,39.2369]},{"Plant":"Westport","State":"MD","Gas":115.8,"coordinates":[-76.6295,39.266]},{"Plant":"Dickerson","State":"MD","Gas":294,"coordinates":[-77.4644,39.2097]},{"Plant":"Mystic Generating Station","State":"MA","Gas":1959.2,"coordinates":[-71.0675,42.3908]},{"Plant":"Kendall Square Station","State":"MA","Gas":217.7,"coordinates":[-71.0792,42.3633]},{"Plant":"Apache Station","State":"AZ","Gas":198.5,"coordinates":[-109.8931,32.0603]},{"Plant":"Potter Station 2","State":"MA","Gas":183.3,"coordinates":[-70.9672,42.235]},{"Plant":"Cecil Lynch","State":"AR","Gas":170,"coordinates":[-92.1987,34.7535]},{"Plant":"Hamilton Moses","State":"AR","Gas":137,"coordinates":[-90.8722,34.9806]},{"Plant":"Harvey Couch","State":"AR","Gas":137,"coordinates":[-93.4649,33.3592]},{"Plant":"B C Cobb","State":"MI","Gas":187,"coordinates":[-86.2423,43.2588]},{"Plant":"Lake Catherine","State":"AR","Gas":720,"coordinates":[-92.9049,34.4341]},{"Plant":"Dan E Karn","State":"MI","Gas":1276,"coordinates":[-83.8401,43.645]},{"Plant":"Thetford","State":"MI","Gas":192,"coordinates":[-83.6286,43.1567]},{"Plant":"Conners Creek","State":"MI","Gas":230,"coordinates":[-82.9597,42.3592]},{"Plant":"Delray","State":"MI","Gas":127,"coordinates":[-83.1019,42.2947]},{"Plant":"Robert E Ritchie","State":"AR","Gas":860,"coordinates":[-90.5987,34.4629]},{"Plant":"Hancock","State":"MI","Gas":141,"coordinates":[-83.4425,42.5497]},{"Plant":"River Rouge","State":"MI","Gas":234,"coordinates":[-83.1119,42.2739]},{"Plant":"Mistersky","State":"MI","Gas":154,"coordinates":[-83.0903,42.3039]},{"Plant":"Fox Lake","State":"MN","Gas":106.3,"coordinates":[-94.7075,43.6728]},{"Plant":"Black Dog","State":"MN","Gas":297.8,"coordinates":[-93.2501,44.8108]},{"Plant":"High Bridge","State":"MN","Gas":565.7,"coordinates":[-93.1117,44.9314]},{"Plant":"Inver Hills","State":"MN","Gas":350,"coordinates":[-93.042,44.781]},{"Plant":"Riverside","State":"MN","Gas":478,"coordinates":[-93.2753,45.0203]},{"Plant":"Thomas Fitzhugh","State":"AR","Gas":165,"coordinates":[-93.8049,35.4624]},{"Plant":"Carl Bailey","State":"AR","Gas":122,"coordinates":[-91.3634,35.2601]},{"Plant":"McClellan","State":"AR","Gas":134,"coordinates":[-92.7917,33.5648]},{"Plant":"Cambridge CT","State":"MN","Gas":156.2,"coordinates":[-93.2081,45.601]},{"Plant":"Elk River","State":"MN","Gas":178.9,"coordinates":[-93.5584,45.2968]},{"Plant":"Chevron Oil","State":"MS","Gas":130,"coordinates":[-88.4919,30.34]},{"Plant":"Sweatt","State":"MS","Gas":124,"coordinates":[-88.7461,32.2925]},{"Plant":"Jack Watson","State":"MS","Gas":292,"coordinates":[-89.0286,30.4392]},{"Plant":"Baxter Wilson","State":"MS","Gas":1176,"coordinates":[-90.9306,32.2831]},{"Plant":"Delta","State":"MS","Gas":177,"coordinates":[-90.7139,33.7947]},{"Plant":"Rex Brown","State":"MS","Gas":288,"coordinates":[-90.213,32.357]},{"Plant":"Moselle","State":"MS","Gas":327,"coordinates":[-89.3004,31.528]},{"Plant":"Hawthorn","State":"MO","Gas":417,"coordinates":[-94.4778,39.1306]},{"Plant":"Lake Road","State":"MO","Gas":128.7,"coordinates":[-94.8773,39.7246]},{"Plant":"James River Power Station","State":"MO","Gas":155,"coordinates":[-93.2619,37.1086]},{"Plant":"Canaday","State":"NE","Gas":118,"coordinates":[-99.7011,40.6942]},{"Plant":"C W Burdick","State":"NE","Gas":174.1,"coordinates":[-98.3269,40.9228]},{"Plant":"Contra Costa","State":"CA","Gas":672,"coordinates":[-121.7642,38.0192]},{"Plant":"Sarpy County","State":"NE","Gas":309,"coordinates":[-95.9706,41.1706]},{"Plant":"Clark","State":"NV","Gas":1138,"coordinates":[-115.0507,36.0875]},{"Plant":"Sunrise","State":"NV","Gas":149,"coordinates":[-115.036,36.1384]},{"Plant":"Fort Churchill","State":"NV","Gas":226,"coordinates":[-119.1322,39.1281]},{"Plant":"Tracy","State":"NV","Gas":1033.6,"coordinates":[-119.525,39.5625]},{"Plant":"Sayreville","State":"NJ","Gas":167,"coordinates":[-74.3523,40.4765]},{"Plant":"Gilbert","State":"NJ","Gas":536,"coordinates":[-75.1639,40.5658]},{"Plant":"Bergen Generating Station","State":"NJ","Gas":1199,"coordinates":[-74.0244,40.8375]},{"Plant":"PSEG Burlington Generating Station","State":"NJ","Gas":168,"coordinates":[-74.8792,40.0766]},{"Plant":"PSEG Edison Generating Station","State":"NJ","Gas":504,"coordinates":[-74.3956,40.4911]},{"Plant":"PSEG Essex Generating Station","State":"NJ","Gas":616.6,"coordinates":[-74.1206,40.7372]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Gas":355,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Kearny Generating Station","State":"NJ","Gas":446,"coordinates":[-74.0965,40.7373]},{"Plant":"PSEG Linden Generating Station","State":"NJ","Gas":1587,"coordinates":[-74.2072,40.6217]},{"Plant":"PSEG Sewaren Generating Station","State":"NJ","Gas":453,"coordinates":[-74.2469,40.5558]},{"Plant":"Rio Grande","State":"NM","Gas":236,"coordinates":[-106.5472,31.8047]},{"Plant":"Maddox","State":"NM","Gas":179,"coordinates":[-103.3015,32.7142]},{"Plant":"Reeves","State":"NM","Gas":154,"coordinates":[-106.6019,35.171]},{"Plant":"Cunningham","State":"NM","Gas":485,"coordinates":[-103.3533,32.7131]},{"Plant":"Humboldt Bay","State":"CA","Gas":105,"coordinates":[-124.2103,40.7415]},{"Plant":"Arthur Kill Generating Station","State":"NY","Gas":841,"coordinates":[-74.2,40.5916]},{"Plant":"East River","State":"NY","Gas":296.8,"coordinates":[-73.9742,40.7281]},{"Plant":"Gowanus Gas Turbines Generating","State":"NY","Gas":284.2,"coordinates":[-74.0051,40.6635]},{"Plant":"Narrows Gas Turbines Generating","State":"NY","Gas":283.7,"coordinates":[-74.0208,40.6486]},{"Plant":"Ravenswood","State":"NY","Gas":2295.9,"coordinates":[-73.9461,40.7592]},{"Plant":"E F Barrett","State":"NY","Gas":687.1,"coordinates":[-73.6479,40.6167]},{"Plant":"Far Rockaway","State":"NY","Gas":107.2,"coordinates":[-73.761,40.6109]},{"Plant":"Glenwood","State":"NY","Gas":232.5,"coordinates":[-73.6475,40.8271]},{"Plant":"Northport","State":"NY","Gas":1571.8,"coordinates":[-73.3423,40.9236]},{"Plant":"Port Jefferson","State":"NY","Gas":456.4,"coordinates":[-73.0785,40.9497]},{"Plant":"Bethlehem Energy Center","State":"NY","Gas":747,"coordinates":[-73.7638,42.5942]},{"Plant":"Dynegy Morro Bay LLC","State":"CA","Gas":999,"coordinates":[-120.8566,35.3722]},{"Plant":"Dynegy Moss Landing Power Plant","State":"CA","Gas":2529,"coordinates":[-121.7822,36.8048]},{"Plant":"Bowline Point","State":"NY","Gas":1139,"coordinates":[-73.9689,41.2044]},{"Plant":"Asheville","State":"NC","Gas":324,"coordinates":[-82.5417,35.4731]},{"Plant":"Pittsburg Power","State":"CA","Gas":1311,"coordinates":[-121.8945,38.0392]},{"Plant":"Potrero Power","State":"CA","Gas":206,"coordinates":[-122.387,37.7566]},{"Plant":"Dicks Creek","State":"OH","Gas":106.2,"coordinates":[-84.3778,39.465]},{"Plant":"Frank M Tait","State":"OH","Gas":256,"coordinates":[-84.2111,39.7272]},{"Plant":"FirstEnergy West Lorain","State":"OH","Gas":425,"coordinates":[-82.2644,41.4294]},{"Plant":"Richland","State":"OH","Gas":358,"coordinates":[-84.3346,41.3052]},{"Plant":"Horseshoe Lake","State":"OK","Gas":857,"coordinates":[-97.1797,35.5087]},{"Plant":"Muskogee","State":"OK","Gas":171,"coordinates":[-95.2873,35.7614]},{"Plant":"Mustang","State":"OK","Gas":531.8,"coordinates":[-97.675,35.4699]},{"Plant":"Seminole","State":"OK","Gas":1503.7,"coordinates":[-96.7258,34.9665]},{"Plant":"Northeastern","State":"OK","Gas":891,"coordinates":[-95.7008,36.4317]},{"Plant":"Southwestern","State":"OK","Gas":603,"coordinates":[-98.3524,35.1009]},{"Plant":"Tulsa","State":"OK","Gas":370,"coordinates":[-95.991,36.1165]},{"Plant":"Weleetka","State":"OK","Gas":163,"coordinates":[-96.1352,35.3233]},{"Plant":"Barry","State":"AL","Gas":958,"coordinates":[-88.0103,31.0069]},{"Plant":"Anadarko Plant","State":"OK","Gas":485,"coordinates":[-98.23,35.0847]},{"Plant":"Mooreland","State":"OK","Gas":322,"coordinates":[-99.2254,36.4372]},{"Plant":"Encina","State":"CA","Gas":964,"coordinates":[-117.3364,33.1361]},{"Plant":"Kearny","State":"CA","Gas":136,"coordinates":[-117.1338,32.834]},{"Plant":"Brunot Island","State":"PA","Gas":245,"coordinates":[-80.0438,40.4649]},{"Plant":"Dynegy South Bay Power Plant","State":"CA","Gas":296,"coordinates":[-117.092,32.6114]},{"Plant":"AES Alamitos LLC","State":"CA","Gas":1997,"coordinates":[-118.1009,33.7688]},{"Plant":"Manchester Street","State":"RI","Gas":447,"coordinates":[-71.4042,41.8167]},{"Plant":"Darlington County","State":"SC","Gas":440,"coordinates":[-80.1657,34.4185]},{"Plant":"Buzzard Roost","State":"SC","Gas":196,"coordinates":[-81.9025,34.1692]},{"Plant":"Hagood","State":"SC","Gas":104,"coordinates":[-79.9634,32.8265]},{"Plant":"Coolwater","State":"CA","Gas":608,"coordinates":[-116.8539,34.8606]},{"Plant":"Urquhart","State":"SC","Gas":559,"coordinates":[-81.9111,33.435]},{"Plant":"El Segundo Power","State":"CA","Gas":650,"coordinates":[-118.4242,33.9098]},{"Plant":"Etiwanda Generating Station","State":"CA","Gas":640,"coordinates":[-117.5266,34.0912]},{"Plant":"AES Huntington Beach LLC","State":"CA","Gas":903.6,"coordinates":[-117.9792,33.6439]},{"Plant":"Allen Steam Plant","State":"TN","Gas":461.6,"coordinates":[-90.1487,35.0741]},{"Plant":"Gallatin","State":"TN","Gas":599.2,"coordinates":[-86.4006,36.3156]},{"Plant":"Johnsonville","State":"TN","Gas":1135.2,"coordinates":[-87.9861,36.0278]},{"Plant":"Long Beach Generation LLC","State":"CA","Gas":260,"coordinates":[-118.2248,33.7641]},{"Plant":"E S Joslin","State":"TX","Gas":254,"coordinates":[-96.5458,28.6472]},{"Plant":"Laredo","State":"TX","Gas":178,"coordinates":[-99.5089,27.5667]},{"Plant":"Lon C Hill","State":"TX","Gas":164,"coordinates":[-97.6167,27.85]},{"Plant":"Nueces Bay","State":"TX","Gas":368,"coordinates":[-97.4192,27.8194]},{"Plant":"Victoria","State":"TX","Gas":290,"coordinates":[-97.01,28.7883]},{"Plant":"Mandalay","State":"CA","Gas":560,"coordinates":[-119.2511,34.2067]},{"Plant":"Lake Hubbard","State":"TX","Gas":921,"coordinates":[-96.5458,32.8358]},{"Plant":"Mountain Creek","State":"TX","Gas":805,"coordinates":[-96.9358,32.7231]},{"Plant":"Newman","State":"TX","Gas":619,"coordinates":[-106.4318,31.9836]},{"Plant":"Lewis Creek","State":"TX","Gas":460,"coordinates":[-95.5214,30.4356]},{"Plant":"Sabine","State":"TX","Gas":1814,"coordinates":[-93.878,30.0242]},{"Plant":"Cedar Bayou","State":"TX","Gas":1495,"coordinates":[-94.9256,29.75]},{"Plant":"Greens Bayou","State":"TX","Gas":760,"coordinates":[-95.2194,29.8222]},{"Plant":"Sam Bertron","State":"TX","Gas":765,"coordinates":[-95.0598,29.7268]},{"Plant":"T H Wharton","State":"TX","Gas":1025,"coordinates":[-95.5306,29.9417]},{"Plant":"W A Parish","State":"TX","Gas":1176,"coordinates":[-95.6311,29.4828]},{"Plant":"Knox Lee","State":"TX","Gas":488,"coordinates":[-94.6415,32.3766]},{"Plant":"Wilkes","State":"TX","Gas":883,"coordinates":[-94.548,32.8482]},{"Plant":"Jones","State":"TX","Gas":486,"coordinates":[-101.7392,33.5239]},{"Plant":"Nichols","State":"TX","Gas":457,"coordinates":[-101.7464,35.2834]},{"Plant":"Plant X","State":"TX","Gas":442,"coordinates":[-102.4114,34.1661]},{"Plant":"Eagle Mountain","State":"TX","Gas":665,"coordinates":[-97.4792,32.9056]},{"Plant":"Graham","State":"TX","Gas":630,"coordinates":[-98.6117,33.1344]},{"Plant":"Handley","State":"TX","Gas":1265,"coordinates":[-97.2192,32.7283]},{"Plant":"Morgan Creek","State":"TX","Gas":480,"coordinates":[-100.9156,32.3358]},{"Plant":"Permian Basin","State":"TX","Gas":1055,"coordinates":[-102.9633,31.5839]},{"Plant":"Ormond Beach","State":"CA","Gas":1516,"coordinates":[-119.1689,34.1292]},{"Plant":"Collin","State":"TX","Gas":154,"coordinates":[-96.8034,33.1576]},{"Plant":"Lake Creek","State":"TX","Gas":317,"coordinates":[-96.985,31.4647]},{"Plant":"Stryker Creek","State":"TX","Gas":675,"coordinates":[-94.9898,31.9398]},{"Plant":"Tradinghouse","State":"TX","Gas":818,"coordinates":[-96.9642,31.5728]},{"Plant":"Trinidad","State":"TX","Gas":240,"coordinates":[-96.1013,32.1245]},{"Plant":"Valley","State":"TX","Gas":1115,"coordinates":[-96.3676,33.6281]},{"Plant":"Decker Creek","State":"TX","Gas":932,"coordinates":[-97.6128,30.3033]},{"Plant":"Silas Ray","State":"TX","Gas":125,"coordinates":[-97.5214,25.9131]},{"Plant":"AES Redondo Beach LLC","State":"CA","Gas":1310,"coordinates":[-118.395,33.8504]},{"Plant":"Bryan","State":"TX","Gas":130,"coordinates":[-96.3723,30.6474]},{"Plant":"Ray Olinger","State":"TX","Gas":395,"coordinates":[-96.4525,33.0681]},{"Plant":"Mountainview Generating Station","State":"CA","Gas":942.2,"coordinates":[-117.2418,34.0818]},{"Plant":"Sim Gideon","State":"TX","Gas":620,"coordinates":[-97.2708,30.1456]},{"Plant":"Ty Cooke","State":"TX","Gas":135,"coordinates":[-101.7906,33.5211]},{"Plant":"J Robert Massengale","State":"TX","Gas":105,"coordinates":[-101.8408,33.6039]},{"Plant":"Leon Creek","State":"TX","Gas":339,"coordinates":[-98.5761,29.3525]},{"Plant":"O W Sommers","State":"TX","Gas":880,"coordinates":[-98.3242,29.3081]},{"Plant":"V H Braunig","State":"TX","Gas":862,"coordinates":[-98.3825,29.2567]},{"Plant":"W B Tuttle","State":"TX","Gas":314,"coordinates":[-98.4181,29.53]},{"Plant":"R W Miller","State":"TX","Gas":574,"coordinates":[-98.3103,32.6581]},{"Plant":"Sam Rayburn","State":"TX","Gas":227,"coordinates":[-97.135,28.8947]},{"Plant":"Gadsby","State":"UT","Gas":347.5,"coordinates":[-111.9289,40.7686]},{"Plant":"Grayson","State":"CA","Gas":122.7,"coordinates":[-118.2782,34.1556]},{"Plant":"Chesterfield","State":"VA","Gas":397,"coordinates":[-77.3833,37.3822]},{"Plant":"Possum Point","State":"VA","Gas":875,"coordinates":[-77.2806,38.5367]},{"Plant":"Transalta Centralia Generation","State":"WA","Gas":256,"coordinates":[-122.8598,46.7559]},{"Plant":"El Centro","State":"CA","Gas":225.9,"coordinates":[-115.54,32.8022]},{"Plant":"Harbor","State":"CA","Gas":459,"coordinates":[-118.2656,33.7706]},{"Plant":"Haynes","State":"CA","Gas":1524,"coordinates":[-118.0991,33.7647]},{"Plant":"Wheaton","State":"WI","Gas":233.3,"coordinates":[-91.5158,44.8854]},{"Plant":"Scattergood","State":"CA","Gas":796,"coordinates":[-118.4276,33.9182]},{"Plant":"Port Washington Generating Station","State":"WI","Gas":1150,"coordinates":[-87.8689,43.3842]},{"Plant":"Rock River","State":"WI","Gas":294.7,"coordinates":[-89.0276,42.582]},{"Plant":"West Marinette","State":"WI","Gas":152.3,"coordinates":[-87.6881,45.0869]},{"Plant":"Valley","State":"CA","Gas":556,"coordinates":[-118.3913,34.245]},{"Plant":"Glenarm","State":"CA","Gas":155,"coordinates":[-118.1494,34.126]},{"Plant":"Spencer","State":"TX","Gas":122,"coordinates":[-97.1061,33.1975]},{"Plant":"Colbert","State":"AL","Gas":390.4,"coordinates":[-87.8486,34.7439]},{"Plant":"Thomas C Ferguson","State":"TX","Gas":420,"coordinates":[-98.3705,30.558]},{"Plant":"Barney M Davis","State":"TX","Gas":682,"coordinates":[-97.3117,27.6064]},{"Plant":"Riverside","State":"OK","Gas":1067,"coordinates":[-95.9567,35.9978]},{"Plant":"Pittsfield Generating LP","State":"MA","Gas":141,"coordinates":[-73.2181,42.4564]},{"Plant":"Linden Cogen Plant","State":"NJ","Gas":899.8,"coordinates":[-74.2156,40.6322]},{"Plant":"Houston Chemical Complex Battleground","State":"TX","Gas":263,"coordinates":[-95.0839,29.7314]},{"Plant":"Paris Energy Center","State":"TX","Gas":238,"coordinates":[-95.5577,33.6968]},{"Plant":"Hal C Weaver Power Plant","State":"TX","Gas":113.8,"coordinates":[-97.7356,30.2867]},{"Plant":"Sycamore Cogeneration","State":"CA","Gas":300,"coordinates":[-118.9853,35.4526]},{"Plant":"Union Carbide Seadrift Cogen","State":"TX","Gas":168,"coordinates":[-96.7706,28.5105]},{"Plant":"Dow St Charles Operations","State":"LA","Gas":291.6,"coordinates":[-90.4414,29.9861]},{"Plant":"Watson Cogeneration","State":"CA","Gas":398,"coordinates":[-118.2448,33.8166]},{"Plant":"Bucksport Generation LLC","State":"ME","Gas":249.8,"coordinates":[-68.8046,44.5738]},{"Plant":"Bethpage Power Plant","State":"NY","Gas":184,"coordinates":[-73.4994,40.7469]},{"Plant":"Shell Deer Park","State":"TX","Gas":140,"coordinates":[-95.1289,29.7232]},{"Plant":"Newark Bay Cogeneration Partnership LP","State":"NJ","Gas":120,"coordinates":[-74.13,40.7197]},{"Plant":"Indeck Corinth Energy Center","State":"NY","Gas":131.5,"coordinates":[-73.8125,43.25]},{"Plant":"PPG Powerhouse C","State":"LA","Gas":303.2,"coordinates":[-93.2831,30.2242]},{"Plant":"Bayonne Plant Holding LLC","State":"NJ","Gas":166,"coordinates":[-74.1124,40.6553]},{"Plant":"Harbor Cogen","State":"CA","Gas":101.7,"coordinates":[-118.2303,33.7771]},{"Plant":"Rosemary Power Station","State":"NC","Gas":165,"coordinates":[-77.6594,36.4517]},{"Plant":"Oklahoma Cogeneration Project","State":"OK","Gas":111.4,"coordinates":[-97.625,35.4397]},{"Plant":"Eagle Point Power Generation","State":"NJ","Gas":195,"coordinates":[-75.1592,39.8746]},{"Plant":"ExxonMobil Beaumont Refinery","State":"TX","Gas":631.6,"coordinates":[-94.0753,30.0636]},{"Plant":"JM Shafer Generating Station","State":"CO","Gas":263,"coordinates":[-104.7736,40.0986]},{"Plant":"Gary Works","State":"IN","Gas":161,"coordinates":[-87.3289,41.6224]},{"Plant":"Parlin Power Plant","State":"NJ","Gas":118,"coordinates":[-74.3272,40.4607]},{"Plant":"Optim Energy Altura Cogen LLC","State":"TX","Gas":493,"coordinates":[-95.1077,29.8161]},{"Plant":"Cumberland","State":"NJ","Gas":174.1,"coordinates":[-74.9654,39.3757]},{"Plant":"Gramercy Holdings LLC","State":"LA","Gas":106,"coordinates":[-90.6693,30.054]},{"Plant":"Hardee Power Station","State":"FL","Gas":358,"coordinates":[-81.9636,27.6364]},{"Plant":"Bellmeade Power Station","State":"VA","Gas":245,"coordinates":[-77.4317,37.4964]},{"Plant":"Ocean State Power","State":"RI","Gas":218.6,"coordinates":[-71.6689,42.0097]},{"Plant":"LaO Energy Systems","State":"LA","Gas":574,"coordinates":[-91.2325,30.3186]},{"Plant":"Doswell Energy Center","State":"VA","Gas":819.8,"coordinates":[-77.1448,37.8182]},{"Plant":"Elizabeth River Power Station","State":"VA","Gas":348,"coordinates":[-76.3083,36.775]},{"Plant":"Texas City Power Plant","State":"TX","Gas":451,"coordinates":[-94.9438,29.3787]},{"Plant":"Dow Chemical Texas Operation","State":"TX","Gas":795.1,"coordinates":[-95.4075,28.9913]},{"Plant":"Power Station 4","State":"TX","Gas":172,"coordinates":[-94.9219,29.3782]},{"Plant":"Midway Sunset Cogen","State":"CA","Gas":219,"coordinates":[-119.6294,35.2269]},{"Plant":"C R Wing Cogen Plant","State":"TX","Gas":227,"coordinates":[-101.4224,32.2732]},{"Plant":"Delaware City Plant","State":"DE","Gas":307,"coordinates":[-75.6343,39.5871]},{"Plant":"McWilliams","State":"AL","Gas":650,"coordinates":[-86.4764,31.4003]},{"Plant":"J K Smith","State":"KY","Gas":608,"coordinates":[-84.1017,37.8833]},{"Plant":"Lockport Energy Associates LP","State":"NY","Gas":200,"coordinates":[-78.745,43.1619]},{"Plant":"Kennedy International Airport Cogen","State":"NY","Gas":120.7,"coordinates":[-73.7778,40.6417]},{"Plant":"March Point Cogeneration","State":"WA","Gas":146.2,"coordinates":[-122.56,48.4708]},{"Plant":"Saguaro Power","State":"NV","Gas":101,"coordinates":[-115.0117,36.0417]},{"Plant":"Ocean State Power II","State":"RI","Gas":218.6,"coordinates":[-71.6701,42.0099]},{"Plant":"Orange Cogeneration Facility","State":"FL","Gas":110.6,"coordinates":[-81.8251,27.8708]},{"Plant":"Lake Cogen Ltd","State":"FL","Gas":121,"coordinates":[-81.676,28.9158]},{"Plant":"Pasco Cogen Ltd","State":"FL","Gas":128.8,"coordinates":[-82.1889,28.3746]},{"Plant":"Mulberry Cogeneration Facility","State":"FL","Gas":113,"coordinates":[-81.8775,27.8489]},{"Plant":"Orlando Cogen LP","State":"FL","Gas":120,"coordinates":[-81.4123,28.4426]},{"Plant":"Sumas Power Plant","State":"WA","Gas":123,"coordinates":[-122.2733,48.9905]},{"Plant":"Formosa Plastics","State":"LA","Gas":115,"coordinates":[-91.1872,30.4992]},{"Plant":"Ferndale Generating Station","State":"WA","Gas":271,"coordinates":[-122.6867,48.8288]},{"Plant":"Hartwell Energy Facility","State":"GA","Gas":298,"coordinates":[-82.8199,34.3396]},{"Plant":"Sithe Independence Station","State":"NY","Gas":982.2,"coordinates":[-76.4511,43.495]},{"Plant":"Saranac Facility","State":"NY","Gas":253.7,"coordinates":[-73.4557,44.7132]},{"Plant":"NAEA Lakewood LLC","State":"NJ","Gas":218.1,"coordinates":[-74.1686,40.0613]},{"Plant":"Auburndale Power Partners","State":"FL","Gas":155.3,"coordinates":[-81.8058,28.0542]},{"Plant":"Oyster Creek Unit VIII","State":"TX","Gas":379,"coordinates":[-95.342,28.9802]},{"Plant":"Hermiston Generating Plant","State":"OR","Gas":464,"coordinates":[-119.37,45.8042]},{"Plant":"Grays Ferry Cogeneration","State":"PA","Gas":150,"coordinates":[-75.1881,39.9422]},{"Plant":"Milford Power LP","State":"MA","Gas":148,"coordinates":[-71.5115,42.1294]},{"Plant":"Milagro Cogeneration Plant","State":"NM","Gas":121.6,"coordinates":[-107.9417,36.7367]},{"Plant":"Johnson County","State":"TX","Gas":267,"coordinates":[-97.4078,32.3994]},{"Plant":"Brandywine Power Facility","State":"MD","Gas":230,"coordinates":[-76.8678,38.6681]},{"Plant":"Gordonsville Energy LP","State":"VA","Gas":218,"coordinates":[-78.2138,38.1179]},{"Plant":"Sun Peak Generating Station","State":"NV","Gas":222,"coordinates":[-115.0339,36.1375]},{"Plant":"Brooklyn Navy Yard Cogeneration","State":"NY","Gas":245,"coordinates":[-73.9764,40.6994]},{"Plant":"Michigan Power LP","State":"MI","Gas":128,"coordinates":[-86.425,43.9375]},{"Plant":"LSP-Cottage Grove LP","State":"MN","Gas":251,"coordinates":[-92.9119,44.7956]},{"Plant":"LSP-Whitewater LP","State":"WI","Gas":261,"coordinates":[-88.7299,42.8555]},{"Plant":"Sweeny Cogen Facility","State":"TX","Gas":436,"coordinates":[-95.745,29.0728]},{"Plant":"Dighton Power Plant","State":"MA","Gas":150,"coordinates":[-71.1239,41.8312]},{"Plant":"De Pere Energy Center","State":"WI","Gas":171.4,"coordinates":[-88.072,44.4486]},{"Plant":"Androscoggin Energy Center","State":"ME","Gas":136.6,"coordinates":[-70.2423,44.5063]},{"Plant":"Delta Person LLC","State":"NM","Gas":140,"coordinates":[-106.644,35.026]},{"Plant":"Mid-Georgia Cogeneration Facility","State":"GA","Gas":316,"coordinates":[-83.6039,32.4856]},{"Plant":"Berkshire Power","State":"MA","Gas":232.1,"coordinates":[-72.6478,42.0476]},{"Plant":"Bridgeport Energy Project","State":"CT","Gas":454,"coordinates":[-73.1844,41.1692]},{"Plant":"Pasadena Cogeneration","State":"TX","Gas":700,"coordinates":[-95.1765,29.7248]},{"Plant":"Tiverton Power Plant","State":"RI","Gas":250,"coordinates":[-71.1706,41.6422]},{"Plant":"Axiall Plaquemine","State":"LA","Gas":240,"coordinates":[-91.185,30.2586]},{"Plant":"Tenaska Frontier Generation Station","State":"TX","Gas":860,"coordinates":[-95.9178,30.5924]},{"Plant":"Batesville Generation Facility","State":"MS","Gas":858,"coordinates":[-89.9275,34.3356]},{"Plant":"Black Hawk Station","State":"TX","Gas":219.4,"coordinates":[-101.36,35.6957]},{"Plant":"Mustang Station","State":"TX","Gas":486,"coordinates":[-102.7417,32.9728]},{"Plant":"Maine Independence Station","State":"ME","Gas":490,"coordinates":[-68.7094,44.8242]},{"Plant":"Pine Bluff Energy Center","State":"AR","Gas":192,"coordinates":[-91.9025,34.2181]},{"Plant":"Desert Star Energy Center","State":"NV","Gas":450,"coordinates":[-114.9928,35.7867]},{"Plant":"Millennium Power","State":"MA","Gas":325.1,"coordinates":[-72.0151,42.1123]},{"Plant":"New Albany Energy Facility","State":"MS","Gas":360,"coordinates":[-88.9397,34.5408]},{"Plant":"Brownsville Peaking Power","State":"TN","Gas":467.6,"coordinates":[-89.198,35.5438]},{"Plant":"Crockett Cogen Project","State":"CA","Gas":247.4,"coordinates":[-122.2161,38.0569]},{"Plant":"Gregory Power Facility","State":"TX","Gas":366,"coordinates":[-97.2584,27.8893]},{"Plant":"Zeeland Generating Station","State":"MI","Gas":868,"coordinates":[-85.9975,42.8206]},{"Plant":"Dearborn Industrial Generation","State":"MI","Gas":700,"coordinates":[-83.154,42.3026]},{"Plant":"Taft Cogeneration Facility","State":"LA","Gas":790,"coordinates":[-90.4599,29.9888]},{"Plant":"Midlothian Energy Facility","State":"TX","Gas":1278,"coordinates":[-97.0537,32.4302]},{"Plant":"Lamar Power Project","State":"TX","Gas":1004,"coordinates":[-95.59,33.6308]},{"Plant":"Frontera Energy Center","State":"TX","Gas":475,"coordinates":[-98.3992,26.208]},{"Plant":"NRG Sterlington Power","State":"LA","Gas":176,"coordinates":[-92.0811,32.6889]},{"Plant":"Rumford Power Associates","State":"ME","Gas":254,"coordinates":[-70.5219,44.5303]},{"Plant":"Livingston Generating Station","State":"MI","Gas":132,"coordinates":[-84.7308,45.0304]},{"Plant":"Klamath Cogeneration Plant","State":"OR","Gas":470,"coordinates":[-121.8106,42.1739]},{"Plant":"Entergy Rhode Island State Energy LP","State":"RI","Gas":528,"coordinates":[-71.5186,41.8017]},{"Plant":"Rocky Road Power LLC","State":"IL","Gas":347,"coordinates":[-88.2397,42.0931]},{"Plant":"Madison","State":"OH","Gas":576,"coordinates":[-84.4647,39.4522]},{"Plant":"Vermillion Energy Facility","State":"IN","Gas":560,"coordinates":[-87.4464,39.9223]},{"Plant":"Sutter Energy Center","State":"CA","Gas":530,"coordinates":[-121.6959,39.0531]},{"Plant":"Rockingham County CT Station","State":"NC","Gas":775,"coordinates":[-79.8297,36.3297]},{"Plant":"RS Cogen","State":"LA","Gas":415.4,"coordinates":[-93.2992,30.221]},{"Plant":"SRW Cogen LP","State":"TX","Gas":420,"coordinates":[-93.7574,30.0545]},{"Plant":"Magic Valley Generating Station","State":"TX","Gas":682,"coordinates":[-98.19,26.3403]},{"Plant":"Griffith Energy LLC","State":"AZ","Gas":570,"coordinates":[-114.1333,35.054]},{"Plant":"Milford Power Project","State":"CT","Gas":510.8,"coordinates":[-73.0997,41.2244]},{"Plant":"Manchief Electric Generating Station","State":"CO","Gas":264,"coordinates":[-103.685,40.2171]},{"Plant":"Walton County Power LLC","State":"GA","Gas":465.2,"coordinates":[-83.6954,33.8148]},{"Plant":"Desert Basin","State":"AZ","Gas":577,"coordinates":[-111.7889,32.9042]},{"Plant":"Kendall County Generation Facility","State":"IL","Gas":1140,"coordinates":[-88.2581,41.4797]},{"Plant":"Tenaska Gateway Generating Station","State":"TX","Gas":845,"coordinates":[-94.6197,32.0178]},{"Plant":"Alliant Energy Neenah","State":"WI","Gas":302.8,"coordinates":[-88.5064,44.1936]},{"Plant":"Rio Nogales Power Project","State":"TX","Gas":732,"coordinates":[-97.9732,29.5931]},{"Plant":"Wolf Hollow I LP","State":"TX","Gas":695.5,"coordinates":[-97.7317,32.3342]},{"Plant":"Hawk Road Facility","State":"GA","Gas":487,"coordinates":[-84.9914,33.3585]},{"Plant":"Hays Energy Project","State":"TX","Gas":881,"coordinates":[-97.9894,29.7806]},{"Plant":"Green Country Energy LLC","State":"OK","Gas":783,"coordinates":[-95.9346,35.9833]},{"Plant":"Worthington Generation LLC","State":"IN","Gas":179.2,"coordinates":[-87.0128,39.0708]},{"Plant":"Lake Road Generating Plant","State":"CT","Gas":745.2,"coordinates":[-71.8958,41.872]},{"Plant":"La Paloma Generating LLC","State":"CA","Gas":965.4,"coordinates":[-119.5919,35.2956]},{"Plant":"Guadalupe Generating Station","State":"TX","Gas":1000,"coordinates":[-98.1419,29.6244]},{"Plant":"Lost Pines 1 Power Project","State":"TX","Gas":516,"coordinates":[-97.2714,30.1478]},{"Plant":"Bluegrass Generating Station","State":"KY","Gas":495,"coordinates":[-85.4133,38.3902]},{"Plant":"Calcasieu","State":"LA","Gas":310,"coordinates":[-93.345,30.1608]},{"Plant":"Broad River Energy Center","State":"SC","Gas":840.9,"coordinates":[-81.575,35.0786]},{"Plant":"Bastrop Energy Center","State":"TX","Gas":552,"coordinates":[-97.55,30.1458]},{"Plant":"Granite Ridge","State":"NH","Gas":661,"coordinates":[-71.4261,42.9042]},{"Plant":"Bosque County Peaking","State":"TX","Gas":548,"coordinates":[-97.3586,31.8594]},{"Plant":"Acadia Energy Center","State":"LA","Gas":1063,"coordinates":[-92.4131,30.4286]},{"Plant":"Eastman Cogeneration Facility","State":"TX","Gas":402.2,"coordinates":[-94.6903,32.4481]},{"Plant":"South Point Energy Center","State":"AZ","Gas":550,"coordinates":[-114.5317,34.8678]},{"Plant":"Dogwood Energy Facility","State":"MO","Gas":614.3,"coordinates":[-94.3006,38.7931]},{"Plant":"Rathdrum Power LLC","State":"ID","Gas":248,"coordinates":[-116.9203,47.7858]},{"Plant":"Sunrise Power LLC","State":"CA","Gas":545,"coordinates":[-119.585,35.2097]},{"Plant":"Channelview Cogeneration Plant","State":"TX","Gas":779,"coordinates":[-95.1217,29.837]},{"Plant":"Cordova Energy","State":"IL","Gas":521.2,"coordinates":[-90.2797,41.7122]},{"Plant":"Osceola","State":"FL","Gas":468,"coordinates":[-81.0978,28.1289]},{"Plant":"Ontelaunee Energy Center","State":"PA","Gas":516,"coordinates":[-75.9356,40.4219]},{"Plant":"Caledonia","State":"MS","Gas":765,"coordinates":[-88.2717,33.6464]},{"Plant":"Riverside Generating LLC","State":"KY","Gas":825,"coordinates":[-82.6046,38.1917]},{"Plant":"Elwood Energy LLC","State":"IL","Gas":1350,"coordinates":[-88.1236,41.4388]},{"Plant":"Arapahoe Combustion Turbine Project","State":"CO","Gas":122.5,"coordinates":[-105.0018,39.6692]},{"Plant":"Gibson City","State":"IL","Gas":236,"coordinates":[-88.3987,40.4705]},{"Plant":"Pinckneyville","State":"IL","Gas":316,"coordinates":[-89.3467,38.1114]},{"Plant":"Kinmundy","State":"IL","Gas":232,"coordinates":[-89.0128,38.7619]},{"Plant":"Corpus Christi Energy Center","State":"TX","Gas":455,"coordinates":[-97.4283,27.8139]},{"Plant":"Afton Generating Station","State":"NM","Gas":235.6,"coordinates":[-106.8465,32.1142]},{"Plant":"ANP Bellingham Energy Project","State":"MA","Gas":475,"coordinates":[-71.4535,42.1106]},{"Plant":"ANP Blackstone Energy Project","State":"MA","Gas":443.7,"coordinates":[-71.5158,42.0599]},{"Plant":"Odessa Ector Generating Station","State":"TX","Gas":1026.2,"coordinates":[-102.3264,31.8403]},{"Plant":"Morris Cogeneration LLC","State":"IL","Gas":176,"coordinates":[-88.3328,41.4119]},{"Plant":"Los Medanos Energy Center","State":"CA","Gas":567,"coordinates":[-121.873,38.0301]},{"Plant":"Hinds Energy Facility","State":"MS","Gas":450,"coordinates":[-90.2199,32.379]},{"Plant":"Southaven Energy Facility","State":"MS","Gas":150,"coordinates":[-90.0397,34.9808]},{"Plant":"Attala","State":"MS","Gas":455,"coordinates":[-89.6753,33.0147]},{"Plant":"Harry L. Oswald","State":"AR","Gas":548,"coordinates":[-92.2166,34.5923]},{"Plant":"Lincoln Generating Facility","State":"IL","Gas":625.4,"coordinates":[-87.9436,41.3933]},{"Plant":"Ennis Power Company LLC","State":"TX","Gas":359.5,"coordinates":[-96.675,32.32]},{"Plant":"Wheatland Generating Facility","State":"IN","Gas":472,"coordinates":[-87.2931,38.6716]},{"Plant":"Oneta Energy Center","State":"OK","Gas":1086.4,"coordinates":[-95.6967,36.0119]},{"Plant":"Freestone Energy Center","State":"TX","Gas":984,"coordinates":[-96.1131,31.8907]},{"Plant":"Greenville Electric Generating Station","State":"OH","Gas":202.9,"coordinates":[-84.6151,40.0758]},{"Plant":"Montpelier Electric Generating Station","State":"IN","Gas":180,"coordinates":[-85.3057,40.6206]},{"Plant":"Jack County","State":"TX","Gas":620.5,"coordinates":[-97.9574,33.101]},{"Plant":"Liberty Electric Power Plant","State":"PA","Gas":541,"coordinates":[-75.3358,39.8614]},{"Plant":"Marshall Energy Facility","State":"KY","Gas":620.8,"coordinates":[-88.3958,37.0286]},{"Plant":"Handsome Lake Energy LLC","State":"PA","Gas":267.5,"coordinates":[-79.8061,41.2908]},{"Plant":"Audrain Generating Station","State":"MO","Gas":608,"coordinates":[-91.5369,39.3092]},{"Plant":"Lee Energy Facility","State":"IL","Gas":568,"coordinates":[-89.4054,41.8287]},{"Plant":"Energy Shelby County","State":"IL","Gas":371.6,"coordinates":[-88.4772,39.2794]},{"Plant":"NRG Rockford I","State":"IL","Gas":301.5,"coordinates":[-89.1012,42.2386]},{"Plant":"Red Oak Power LLC","State":"NJ","Gas":765.9,"coordinates":[-74.3489,40.4487]},{"Plant":"Hog Bayou Energy Center","State":"AL","Gas":230,"coordinates":[-88.0575,30.7478]},{"Plant":"Santa Rosa Energy Center","State":"FL","Gas":235.9,"coordinates":[-87.115,30.5664]},{"Plant":"Astoria Gas Turbines","State":"NY","Gas":420,"coordinates":[-73.9048,40.787]},{"Plant":"Doyle Energy Facility","State":"GA","Gas":355,"coordinates":[-83.6996,33.8377]},{"Plant":"Darby Electric Generating Station","State":"OH","Gas":435,"coordinates":[-83.1778,39.7139]},{"Plant":"Tait Electric Generating Station","State":"OH","Gas":340,"coordinates":[-84.2095,39.7277]},{"Plant":"University Park South","State":"IL","Gas":300,"coordinates":[-87.7532,41.4409]},{"Plant":"Gleason Generating Facility","State":"TN","Gas":495,"coordinates":[-88.612,36.2454]},{"Plant":"Crete Energy Venture LLC","State":"IL","Gas":300,"coordinates":[-87.6187,41.4294]},{"Plant":"Whiting Clean Energy","State":"IN","Gas":513,"coordinates":[-87.4775,41.6739]},{"Plant":"Edward L. Addison Generating Plant","State":"GA","Gas":598.8,"coordinates":[-84.3064,32.9111]},{"Plant":"TVA Southaven Combined Cycle","State":"MS","Gas":774,"coordinates":[-90.0378,34.9939]},{"Plant":"Jackson Generating Station","State":"MI","Gas":564,"coordinates":[-84.3767,42.2488]},{"Plant":"Tenaska Lindsay Hill Generating Station","State":"AL","Gas":845,"coordinates":[-86.7386,32.6514]},{"Plant":"Ceredo Generating Station","State":"WV","Gas":450,"coordinates":[-82.5339,38.3681]},{"Plant":"Aurora","State":"IL","Gas":878,"coordinates":[-88.2265,41.8151]},{"Plant":"Southeast Chicago Energy Project","State":"IL","Gas":296,"coordinates":[-87.5449,41.7181]},{"Plant":"Arlington Valley Energy Facility","State":"AZ","Gas":580,"coordinates":[-112.8897,33.3417]},{"Plant":"Front Range Power Plant","State":"CO","Gas":461.5,"coordinates":[-104.7069,38.6281]},{"Plant":"Big Sandy Peaker Plant","State":"WV","Gas":300,"coordinates":[-82.5938,38.3441]},{"Plant":"Wolf Hills Energy","State":"VA","Gas":250,"coordinates":[-82.1044,36.6644]},{"Plant":"Oleander Power Project LP","State":"FL","Gas":315.9,"coordinates":[-80.7947,28.3661]},{"Plant":"Decatur Energy Center","State":"AL","Gas":624,"coordinates":[-87.0214,34.6292]},{"Plant":"Morgan Energy Center","State":"AL","Gas":749,"coordinates":[-87.0639,34.6397]},{"Plant":"Westbrook Energy Center Power Plant","State":"ME","Gas":506,"coordinates":[-70.375,43.6575]},{"Plant":"Blythe Energy Inc","State":"CA","Gas":514,"coordinates":[-114.6865,33.6157]},{"Plant":"Calumet Energy Team LLC","State":"IL","Gas":321.2,"coordinates":[-87.5563,41.6835]},{"Plant":"New Covert Generating Facility","State":"MI","Gas":1040.1,"coordinates":[-86.2937,42.3224]},{"Plant":"Fairless Energy Center","State":"PA","Gas":1207.2,"coordinates":[-74.7411,40.1475]},{"Plant":"Channel Energy Center LLC","State":"TX","Gas":585,"coordinates":[-95.2319,29.7189]},{"Plant":"Baconton Power Plant","State":"GA","Gas":195.2,"coordinates":[-84.08,31.3869]},{"Plant":"Gila River Power Station","State":"AZ","Gas":2060,"coordinates":[-112.6944,32.975]},{"Plant":"Air Products Port Arthur","State":"TX","Gas":129.1,"coordinates":[-93.9651,29.8665]},{"Plant":"Ingleside Cogeneration","State":"TX","Gas":460,"coordinates":[-97.2428,27.8828]},{"Plant":"Fore River Generating Station","State":"MA","Gas":688.3,"coordinates":[-70.9661,42.2422]},{"Plant":"Wise County Power LLC","State":"TX","Gas":655,"coordinates":[-97.9103,33.0583]},{"Plant":"Chuck Lenzie Generating Station","State":"NV","Gas":1128,"coordinates":[-114.9218,36.3837]},{"Plant":"Baytown Energy Center","State":"TX","Gas":770,"coordinates":[-94.9019,29.7731]},{"Plant":"Hermiston Power Partnership","State":"OR","Gas":615,"coordinates":[-119.3133,45.794]},{"Plant":"Washington County","State":"GA","Gas":627.3,"coordinates":[-82.98,33.0922]},{"Plant":"Delta Energy Center","State":"CA","Gas":769.1,"coordinates":[-121.8439,38.0169]},{"Plant":"Holland Energy Facility","State":"IL","Gas":643,"coordinates":[-88.7584,39.2231]},{"Plant":"PPL Ironwood LLC","State":"PA","Gas":669,"coordinates":[-76.3658,40.3509]},{"Plant":"Dell Power Station","State":"AR","Gas":679,"coordinates":[-90.0253,35.8619]},{"Plant":"Luna Energy Facility","State":"NM","Gas":559,"coordinates":[-107.7834,32.2993]},{"Plant":"Otay Mesa Generating Project","State":"CA","Gas":571,"coordinates":[-116.915,32.5815]},{"Plant":"Armstrong","State":"PA","Gas":584,"coordinates":[-79.3517,40.638]},{"Plant":"Troy Energy LLC","State":"OH","Gas":584,"coordinates":[-83.4598,41.4772]},{"Plant":"Pleasants Energy LLC","State":"WV","Gas":292.2,"coordinates":[-81.3642,39.3325]},{"Plant":"Brazos Valley Generating Facility","State":"TX","Gas":525,"coordinates":[-95.6244,29.4731]},{"Plant":"Cottonwood Energy Project","State":"TX","Gas":1233.6,"coordinates":[-93.7353,30.2588]},{"Plant":"Sugar Creek Power","State":"IN","Gas":520.7,"coordinates":[-87.5108,39.3931]},{"Plant":"Exelon LaPorte Generating Station","State":"TX","Gas":153.2,"coordinates":[-95.0718,29.7028]},{"Plant":"Harquahala Generating Project","State":"AZ","Gas":1054.4,"coordinates":[-113.1134,33.476]},{"Plant":"Astoria Energy","State":"NY","Gas":561,"coordinates":[-73.8964,40.7825]},{"Plant":"Union Power Partners LP","State":"AR","Gas":2020,"coordinates":[-92.5894,33.2961]},{"Plant":"Thomas A Smith Energy Facility","State":"GA","Gas":1250,"coordinates":[-84.9175,34.7094]},{"Plant":"Columbia Energy Center","State":"SC","Gas":407.9,"coordinates":[-81.0178,33.8697]},{"Plant":"RockGen Energy Center","State":"WI","Gas":471,"coordinates":[-89.0492,42.9767]},{"Plant":"Zion Energy Center","State":"IL","Gas":456,"coordinates":[-87.895,42.4776]},{"Plant":"Metcalf Energy Center","State":"CA","Gas":546.1,"coordinates":[-121.7457,37.2207]},{"Plant":"Crossroads Energy Center","State":"MS","Gas":308,"coordinates":[-90.5621,34.183]},{"Plant":"Washington Energy Facility","State":"OH","Gas":600,"coordinates":[-81.6564,39.58]},{"Plant":"Elk Hills Power LLC","State":"CA","Gas":525,"coordinates":[-119.4707,35.2803]},{"Plant":"Rolling Hills Generating","State":"OH","Gas":825,"coordinates":[-82.3328,39.0839]},{"Plant":"Renaissance Power LLC","State":"MI","Gas":660,"coordinates":[-84.8429,43.1864]},{"Plant":"Carville Energy LLC","State":"LA","Gas":473,"coordinates":[-91.065,30.2294]},{"Plant":"Athens Generating Plant","State":"NY","Gas":1137.9,"coordinates":[-73.8492,42.2728]},{"Plant":"Effingham County Power Project","State":"GA","Gas":463.4,"coordinates":[-81.2844,32.2773]},{"Plant":"Calhoun Energy Center","State":"AL","Gas":632,"coordinates":[-85.9731,33.5883]},{"Plant":"Osprey Energy Center Power Plant","State":"FL","Gas":595.1,"coordinates":[-81.8083,28.0525]},{"Plant":"Shady Hills Generating Station","State":"FL","Gas":468,"coordinates":[-82.5586,28.3665]},{"Plant":"Vandolah Power Station","State":"FL","Gas":632,"coordinates":[-81.924,27.5236]},{"Plant":"Raccoon Creek Energy Center","State":"IL","Gas":304,"coordinates":[-88.5392,38.6996]},{"Plant":"Hot Spring Generating Facility","State":"AR","Gas":630,"coordinates":[-92.8683,34.2976]},{"Plant":"Plaquemine Cogeneration Plant","State":"LA","Gas":793,"coordinates":[-91.2347,30.3217]},{"Plant":"DeSoto County Plant","State":"FL","Gas":320,"coordinates":[-81.8092,27.2272]},{"Plant":"Bayou Cove Peaking Power","State":"LA","Gas":300,"coordinates":[-92.5997,30.2825]},{"Plant":"Elgin Energy Center","State":"IL","Gas":460,"coordinates":[-88.2446,42.0001]},{"Plant":"Tenaska Virginia Generating Station","State":"VA","Gas":935.1,"coordinates":[-78.3813,37.8667]},{"Plant":"Tenaska Central Alabama Generating Stn","State":"AL","Gas":918.5,"coordinates":[-86.74,32.6497]},{"Plant":"Columbia Energy Center","State":"MO","Gas":140,"coordinates":[-92.2629,39.0192]},{"Plant":"Magnolia Power Plant","State":"MS","Gas":863.1,"coordinates":[-89.2026,34.835]},{"Plant":"Fountain Valley Power Facility","State":"CO","Gas":234,"coordinates":[-104.6875,38.5569]},{"Plant":"Red Hawk","State":"AZ","Gas":948,"coordinates":[-112.8406,33.3346]},{"Plant":"McClain Energy Facility","State":"OK","Gas":450.1,"coordinates":[-97.5898,35.2977]},{"Plant":"Redbud Power Plant","State":"OK","Gas":1160.2,"coordinates":[-97.2264,35.6856]},{"Plant":"Deer Park Energy Center","State":"TX","Gas":892.2,"coordinates":[-95.1345,29.7134]},{"Plant":"Ouachita","State":"LA","Gas":771,"coordinates":[-92.0683,32.7061]},{"Plant":"Green Power 2","State":"TX","Gas":825.5,"coordinates":[-94.9328,29.3781]},{"Plant":"Forney Energy Center","State":"TX","Gas":1640,"coordinates":[-96.4916,32.7563]},{"Plant":"Mesquite Generating Station","State":"AZ","Gas":1073.3,"coordinates":[-112.8642,33.345]},{"Plant":"Goldendale Generating Station","State":"WA","Gas":226,"coordinates":[-120.833,45.8114]},{"Plant":"Tri Center Naniwa Energy","State":"NV","Gas":200,"coordinates":[-119.5178,39.5572]},{"Plant":"Goose Creek Energy Center","State":"IL","Gas":438,"coordinates":[-88.5999,40.1069]},{"Plant":"Kiamichi Energy Facility","State":"OK","Gas":1178.4,"coordinates":[-95.9349,34.6831]},{"Plant":"Lawrenceburg Energy Facility","State":"IN","Gas":1080,"coordinates":[-84.8669,39.0911]},{"Plant":"AEP Waterford Facility","State":"OH","Gas":810,"coordinates":[-81.7178,39.5333]},{"Plant":"Limon Generating Station","State":"CO","Gas":134,"coordinates":[-103.7005,39.2038]},{"Plant":"Frank Knutson","State":"CO","Gas":134,"coordinates":[-104.682,39.9411]},{"Plant":"Apex Generating Station","State":"NV","Gas":494.4,"coordinates":[-114.9609,36.416]},{"Plant":"Fayette Energy Facility","State":"PA","Gas":600.5,"coordinates":[-79.9182,39.8592]},{"Plant":"Wallingford Energy","State":"CT","Gas":190,"coordinates":[-72.8354,41.4487]},{"Plant":"High Desert Power Plant","State":"CA","Gas":742.6,"coordinates":[-117.3647,34.5953]},{"Plant":"Sundance","State":"AZ","Gas":410,"coordinates":[-111.5899,32.9285]},{"Plant":"Indigo Energy Facility","State":"CA","Gas":149.7,"coordinates":[-116.553,33.9109]},{"Plant":"Hidalgo Energy Center","State":"TX","Gas":470,"coordinates":[-98.1758,26.3417]},{"Plant":"Perryville Power Station","State":"LA","Gas":691,"coordinates":[-92.0183,32.6908]},{"Plant":"West Valley Generation Project","State":"UT","Gas":189,"coordinates":[-112.0317,40.6667]},{"Plant":"University Park North","State":"IL","Gas":504,"coordinates":[-87.7514,41.4425]},{"Plant":"Riverside Energy Center","State":"WI","Gas":598.3,"coordinates":[-89.0355,42.5827]},{"Plant":"Blue Spruce Energy Center","State":"CO","Gas":276,"coordinates":[-104.6814,39.7479]},{"Plant":"Plains End","State":"CO","Gas":114,"coordinates":[-105.226,39.8575]},{"Plant":"Spring Creek Energy Center","State":"OK","Gas":274,"coordinates":[-97.655,35.7422]},{"Plant":"Pastoria Energy Facility, LLC","State":"CA","Gas":724,"coordinates":[-118.844,34.9556]},{"Plant":"EP Newington Energy LLC","State":"NH","Gas":525,"coordinates":[-70.8061,43.1047]},{"Plant":"Chehalis Generating Facility","State":"WA","Gas":509,"coordinates":[-122.9131,46.6225]},{"Plant":"Harrison County Power Project","State":"TX","Gas":514.4,"coordinates":[-94.4367,32.3958]},{"Plant":"Lower Mount Bethel Energy","State":"PA","Gas":593.8,"coordinates":[-75.1076,40.8019]},{"Plant":"AL Sandersville LLC","State":"GA","Gas":596.8,"coordinates":[-82.8608,33.1189]},{"Plant":"Higgins Generating Station","State":"NV","Gas":570,"coordinates":[-115.3561,35.6139]},{"Plant":"Bethlehem Power Plant","State":"PA","Gas":1130,"coordinates":[-75.3147,40.6175]},{"Plant":"Quantum Choctaw Power LLC","State":"MS","Gas":690,"coordinates":[-89.2089,33.3792]},{"Plant":"Mint Farm Generating Station","State":"WA","Gas":292,"coordinates":[-122.9855,46.1388]},{"Plant":"Choctaw County","State":"MS","Gas":848,"coordinates":[-89.4201,33.2881]},{"Plant":"Allegheny Energy Units 3 4 & 5","State":"PA","Gas":509,"coordinates":[-79.7686,40.5453]},{"Plant":"Magnet Cove","State":"AR","Gas":641.5,"coordinates":[-92.8317,34.4297]},{"Plant":"Dean","State":"MI","Gas":295.4,"coordinates":[-82.4953,42.7725]},{"Plant":"Bennett Mountain","State":"ID","Gas":164,"coordinates":[-115.6666,43.1472]},{"Plant":"Hanging Rock Energy Facility","State":"OH","Gas":1288,"coordinates":[-82.7833,38.5731]},{"Plant":"Los Esteros Critical Energy Center","State":"CA","Gas":180,"coordinates":[-121.9319,37.425]},{"Plant":"FPL Energy Marcus Hook LP","State":"PA","Gas":717.5,"coordinates":[-75.4216,39.807]},{"Plant":"Valencia Energy Facility","State":"NM","Gas":144.3,"coordinates":[-106.7322,34.6115]},{"Plant":"Gilroy Peaking Energy Center","State":"CA","Gas":135,"coordinates":[-121.5363,36.999]},{"Plant":"Frederickson Power LP","State":"WA","Gas":246,"coordinates":[-122.3657,47.0861]},{"Plant":"Curtis H Stanton Energy Center","State":"FL","Gas":656.9,"coordinates":[-81.1669,28.4882]},{"Plant":"Auburndale Peaker Energy Center","State":"FL","Gas":118,"coordinates":[-81.8059,28.0535]},{"Plant":"Rocky Mountain Energy Center","State":"CO","Gas":608,"coordinates":[-104.5953,40.0908]},{"Plant":"Silverhawk","State":"NV","Gas":560,"coordinates":[-114.9606,36.4078]},{"Plant":"Inland Empire Energy Center","State":"CA","Gas":345,"coordinates":[-117.1704,33.7388]},{"Plant":"Jasper","State":"SC","Gas":852,"coordinates":[-81.1242,32.3594]},{"Plant":"Tracy Combined Cycle Power Plant","State":"CA","Gas":167.1,"coordinates":[-121.4906,37.7107]},{"Plant":"NRG Rockford II Energy Center","State":"IL","Gas":156.1,"coordinates":[-89.1011,42.2383]},{"Plant":"NAEA Ocean Peaking Power LLC","State":"NJ","Gas":325.6,"coordinates":[-74.1672,40.0633]},{"Plant":"Las Vegas Cogeneration II LLC","State":"NV","Gas":220,"coordinates":[-115.1238,36.232]},{"Plant":"Wansley Combined Cycle","State":"GA","Gas":1143.1,"coordinates":[-85.037,33.4064]},{"Plant":"Cosumnes","State":"CA","Gas":477,"coordinates":[-121.124,38.3385]},{"Plant":"Cass County","State":"NE","Gas":322,"coordinates":[-95.964,40.9479]},{"Plant":"Hunterstown","State":"PA","Gas":810,"coordinates":[-77.1672,39.8725]},{"Plant":"Palomar Energy","State":"CA","Gas":562,"coordinates":[-117.1178,33.1197]},{"Plant":"Exira","State":"IA","Gas":140.1,"coordinates":[-94.9197,41.5144]},{"Plant":"Donald Von Raesfeld Power Plant","State":"CA","Gas":154,"coordinates":[-121.9508,37.3767]},{"Plant":"Fox Energy Center","State":"WI","Gas":548,"coordinates":[-88.2089,44.3204]},{"Plant":"Malburg","State":"CA","Gas":143,"coordinates":[-118.2219,33.9986]},{"Plant":"Magnolia Power Project","State":"CA","Gas":323,"coordinates":[-118.3153,34.1786]},{"Plant":"Walnut Energy Center","State":"CA","Gas":269,"coordinates":[-120.8956,37.4878]},{"Plant":"Currant Creek","State":"UT","Gas":540,"coordinates":[-111.8935,39.8214]},{"Plant":"Mankato Energy Center","State":"MN","Gas":300,"coordinates":[-94.003,44.1988]},{"Plant":"McIntosh Combined Cycle Facility","State":"GA","Gas":1256.8,"coordinates":[-81.1817,32.3478]},{"Plant":"South Harper","State":"MO","Gas":315,"coordinates":[-94.4824,38.6803]},{"Plant":"Freeport Energy Center","State":"TX","Gas":249.4,"coordinates":[-95.3954,28.9888]},{"Plant":"Faribault Energy Park","State":"MN","Gas":261,"coordinates":[-93.2906,44.3356]},{"Plant":"Sheboygan Falls","State":"WI","Gas":295.8,"coordinates":[-87.8781,43.7518]},{"Plant":"Nebo Power Station","State":"UT","Gas":130,"coordinates":[-111.7294,40.0614]},{"Plant":"500MW CC","State":"NY","Gas":454.1,"coordinates":[-73.9069,40.7889]},{"Plant":"Port Westward","State":"OR","Gas":372,"coordinates":[-123.172,46.1789]},{"Plant":"EG178 Facility","State":"TX","Gas":108,"coordinates":[-100.9547,32.7471]},{"Plant":"Caithness Long Island Energy Center","State":"NY","Gas":307,"coordinates":[-72.9403,40.8142]},{"Plant":"Lake Side Power Plant","State":"UT","Gas":557,"coordinates":[-111.7542,40.3317]},{"Plant":"Groton Generating Station","State":"SD","Gas":169,"coordinates":[-98.0987,45.3735]},{"Plant":"Kings River","State":"CA","Gas":109,"coordinates":[-119.7404,36.6697]},{"Plant":"Cannon Falls Energy Center","State":"MN","Gas":398,"coordinates":[-92.9155,44.5367]},{"Plant":"Anson County Generation Facility","State":"NC","Gas":339,"coordinates":[-79.9217,34.9687]},{"Plant":"Hamlet Generating Facility","State":"NC","Gas":282.5,"coordinates":[-79.7361,34.8423]},{"Plant":"Roseville Energy Park","State":"CA","Gas":141,"coordinates":[-121.3811,38.7928]},{"Plant":"Mustang Station Unit 4","State":"TX","Gas":290,"coordinates":[-102.7436,32.9746]},{"Plant":"Harry D Mattison Gas Plant","State":"AR","Gas":294,"coordinates":[-94.2841,36.1855]},{"Plant":"Quail Run Energy Center","State":"TX","Gas":482,"coordinates":[-102.315,31.8414]},{"Plant":"Colorado Bend Energy Center","State":"TX","Gas":510,"coordinates":[-96.0683,29.2878]},{"Plant":"Treasure Coast Energy Center","State":"FL","Gas":318,"coordinates":[-80.3775,27.3839]},{"Plant":"West County Energy Center","State":"FL","Gas":2462,"coordinates":[-80.3747,26.6986]},{"Plant":"Spindle Hill Energy Center","State":"CO","Gas":270,"coordinates":[-104.8878,40.0922]},{"Plant":"Hobbs Generating Station","State":"NM","Gas":526,"coordinates":[-103.3094,32.7283]},{"Plant":"Gateway Generating Station","State":"CA","Gas":563.4,"coordinates":[-121.7587,38.0175]},{"Plant":"Western 102 Power Plant","State":"NV","Gas":110.6,"coordinates":[-119.5108,39.5603]},{"Plant":"Emporia Energy Center","State":"KS","Gas":666,"coordinates":[-96.0652,38.4459]},{"Plant":"Jonesboro City Water & Light Plant","State":"AR","Gas":177,"coordinates":[-90.7254,35.8486]},{"Plant":"Plains End II LLC","State":"CO","Gas":116.2,"coordinates":[-105.2256,39.8586]},{"Plant":"San Jacinto County Peaking Facility","State":"TX","Gas":146,"coordinates":[-95.0118,30.4193]},{"Plant":"Hardin County Peaking Facility","State":"TX","Gas":147,"coordinates":[-94.2526,30.3038]},{"Plant":"Midway Peaking LLC","State":"CA","Gas":103,"coordinates":[-120.5797,36.6541]},{"Plant":"Panoche Energy Center","State":"CA","Gas":388,"coordinates":[-120.5833,36.6514]},{"Plant":"Cedar Bayou 4","State":"TX","Gas":502,"coordinates":[-94.9231,29.7516]},{"Plant":"McKee Run","State":"DE","Gas":136,"coordinates":[-75.5466,39.1762]},{"Plant":"Belle River","State":"MI","Gas":225,"coordinates":[-82.495,42.7756]},{"Plant":"Greenwood","State":"MI","Gas":1010,"coordinates":[-82.6964,43.1056]},{"Plant":"Manatee","State":"FL","Gas":1104,"coordinates":[-82.3456,27.6058]},{"Plant":"Martin","State":"FL","Gas":2136,"coordinates":[-80.5628,27.0536]},{"Plant":"DeBary","State":"FL","Gas":247,"coordinates":[-81.3323,28.9039]},{"Plant":"Electrifarm","State":"IA","Gas":197.9,"coordinates":[-92.4205,42.4407]},{"Plant":"Fredonia","State":"WA","Gas":266,"coordinates":[-122.4358,48.4558]},{"Plant":"Trimble County","State":"KY","Gas":960,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Gas":966,"coordinates":[-88.5553,30.5322]},{"Plant":"Greenwood","State":"MO","Gas":244.6,"coordinates":[-94.2982,38.8615]},{"Plant":"R M Schahfer","State":"IN","Gas":155,"coordinates":[-87.0261,41.2164]},{"Plant":"Cutler","State":"FL","Gas":205,"coordinates":[-80.2989,25.6321]},{"Plant":"Fort St Vrain","State":"CO","Gas":969,"coordinates":[-104.8742,40.2461]},{"Plant":"Fort Myers","State":"FL","Gas":1764,"coordinates":[-81.7831,26.6967]},{"Plant":"Whitehorn","State":"WA","Gas":126,"coordinates":[-122.6861,48.8288]},{"Plant":"McIntosh","State":"GA","Gas":657.6,"coordinates":[-81.1683,32.3563]},{"Plant":"Lauderdale","State":"FL","Gas":1712,"coordinates":[-80.1984,26.0686]},{"Plant":"A B Brown","State":"IN","Gas":160,"coordinates":[-87.715,37.9053]},{"Plant":"Port Everglades","State":"FL","Gas":420,"coordinates":[-80.1253,26.0856]},{"Plant":"Brame Energy Center","State":"LA","Gas":435,"coordinates":[-92.7167,31.395]},{"Plant":"John Twitty Energy Center","State":"MO","Gas":104,"coordinates":[-93.388,37.1517]},{"Plant":"Sanford","State":"FL","Gas":1916,"coordinates":[-81.3256,28.8419]},{"Plant":"Turkey Point","State":"FL","Gas":1144,"coordinates":[-80.3308,25.4356]},{"Plant":"Empire Energy Center","State":"MO","Gas":269,"coordinates":[-94.1041,37.1385]},{"Plant":"Dansby","State":"TX","Gas":157.1,"coordinates":[-96.4608,30.7217]},{"Plant":"Putnam","State":"FL","Gas":498,"coordinates":[-81.5851,29.6283]},{"Plant":"Higgins","State":"FL","Gas":114,"coordinates":[-82.6615,28.0033]},{"Plant":"P L Bartow","State":"FL","Gas":1225,"coordinates":[-82.6018,27.8595]},{"Plant":"Rokeby","State":"NE","Gas":239,"coordinates":[-96.7364,40.7316]},{"Plant":"Suwannee River","State":"FL","Gas":103,"coordinates":[-83.1806,30.3764]},{"Plant":"Lansing Smith","State":"FL","Gas":481,"coordinates":[-85.7003,30.2686]},{"Plant":"D G Hunter","State":"LA","Gas":130,"coordinates":[-92.4613,31.3207]},{"Plant":"George M Sullivan Generation Plant 2","State":"AK","Gas":219.9,"coordinates":[-149.7167,61.2297]},{"Plant":"Deerhaven Generating Station","State":"FL","Gas":193,"coordinates":[-82.3878,29.7592]},{"Plant":"John R Kelly","State":"FL","Gas":177.2,"coordinates":[-82.3208,29.6461]},{"Plant":"J D Kennedy","State":"FL","Gas":317.2,"coordinates":[-81.626,30.3648]},{"Plant":"Larsen Memorial","State":"FL","Gas":124,"coordinates":[-81.9228,28.0797]},{"Plant":"C D McIntosh Jr","State":"FL","Gas":524,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Gas":388,"coordinates":[-105.0212,40.8609]},{"Plant":"Indian River Plant","State":"FL","Gas":290,"coordinates":[-80.7801,28.4932]},{"Plant":"Arvah B Hopkins","State":"FL","Gas":504,"coordinates":[-84.4,30.4522]},{"Plant":"S O Purdom","State":"FL","Gas":290,"coordinates":[-84.2007,30.1623]},{"Plant":"Vero Beach Municipal Power Plant","State":"FL","Gas":150,"coordinates":[-80.3776,27.6334]},{"Plant":"Gravel Neck","State":"VA","Gas":316,"coordinates":[-76.6911,37.1575]},{"Plant":"McIntosh","State":"AL","Gas":338,"coordinates":[-88.0299,31.2546]},{"Plant":"Harry Allen","State":"NV","Gas":144,"coordinates":[-114.9024,36.4306]},{"Plant":"Pleasant Hill","State":"IA","Gas":159.5,"coordinates":[-93.5242,41.5572]},{"Plant":"Hay Road","State":"DE","Gas":1110,"coordinates":[-75.5072,39.7436]},{"Plant":"Woodsdale","State":"OH","Gas":462,"coordinates":[-84.4611,39.4492]},{"Plant":"Concord","State":"WI","Gas":400,"coordinates":[-88.69,43.1669]},{"Plant":"South Fond Du Lac","State":"WI","Gas":325.7,"coordinates":[-88.4967,43.7353]},{"Plant":"Darbytown","State":"VA","Gas":336,"coordinates":[-77.3685,37.4982]},{"Plant":"Angus Anson","State":"SD","Gas":383.9,"coordinates":[-96.6356,43.6035]},{"Plant":"Cane Island","State":"FL","Gas":380,"coordinates":[-81.533,28.2764]},{"Plant":"Polk","State":"FL","Gas":604,"coordinates":[-81.9897,27.7286]},{"Plant":"Woodland","State":"CA","Gas":133,"coordinates":[-121.0204,37.6526]},{"Plant":"491 E 48th Street","State":"MI","Gas":136,"coordinates":[-86.0853,42.7553]},{"Plant":"Paris","State":"WI","Gas":400,"coordinates":[-88.0131,42.6658]},{"Plant":"Lincoln Combustion","State":"NC","Gas":1267.2,"coordinates":[-81.0347,35.4317]},{"Plant":"State Line Combined Cycle","State":"MO","Gas":596,"coordinates":[-94.614,37.0659]},{"Plant":"Hines Energy Complex","State":"FL","Gas":1912,"coordinates":[-81.87,27.7882]},{"Plant":"Redding Power","State":"CA","Gas":135,"coordinates":[-122.4233,40.5073]},{"Plant":"San Jacinto Steam Electric Station","State":"TX","Gas":162,"coordinates":[-95.0406,29.6948]},{"Plant":"Kraft","State":"GA","Gas":132,"coordinates":[-81.1458,32.1486]},{"Plant":"Anderson","State":"IN","Gas":140,"coordinates":[-85.7389,40.0529]},{"Plant":"Robins","State":"GA","Gas":160,"coordinates":[-83.5822,32.5792]},{"Plant":"Coyote Springs","State":"OR","Gas":229,"coordinates":[-119.6739,45.848]},{"Plant":"Midulla Generating Station","State":"FL","Gas":758,"coordinates":[-81.9625,27.6417]},{"Plant":"Interstate","State":"IL","Gas":114,"coordinates":[-89.5891,39.8233]},{"Plant":"Rathdrum","State":"ID","Gas":132,"coordinates":[-116.8673,47.8043]},{"Plant":"Arthur Von Rosenberg","State":"TX","Gas":465,"coordinates":[-98.384,29.257]},{"Plant":"Carson Ice-Gen Project","State":"CA","Gas":101,"coordinates":[-121.4624,38.4457]},{"Plant":"Wayne County","State":"NC","Gas":863,"coordinates":[-78.0981,35.3758]},{"Plant":"Ponca City","State":"OK","Gas":106.8,"coordinates":[-97.0858,36.7198]},{"Plant":"SCA Cogen 2","State":"CA","Gas":170.6,"coordinates":[-121.4001,38.5309]},{"Plant":"SPA Cogen 3","State":"CA","Gas":164,"coordinates":[-121.4735,38.511]},{"Plant":"St Francis Energy Facility","State":"MO","Gas":473,"coordinates":[-90.1779,36.5852]},{"Plant":"River Road Gen Plant","State":"WA","Gas":220,"coordinates":[-122.7256,45.6497]},{"Plant":"Tiger Bay","State":"FL","Gas":205,"coordinates":[-81.8494,27.7464]},{"Plant":"Dahlberg","State":"GA","Gas":748.4,"coordinates":[-83.3977,34.0423]},{"Plant":"H Allen Franklin Combined Cycle","State":"AL","Gas":1800.9,"coordinates":[-85.0975,32.6078]},{"Plant":"Theodore Cogen Facility","State":"AL","Gas":224.7,"coordinates":[-88.1285,30.5254]},{"Plant":"Essex","State":"MO","Gas":107.4,"coordinates":[-89.8402,36.8682]},{"Plant":"Nodaway","State":"MO","Gas":182.8,"coordinates":[-94.7913,40.2877]},{"Plant":"Chouteau","State":"OK","Gas":495,"coordinates":[-95.2771,36.2221]},{"Plant":"Georgetown","State":"IN","Gas":295,"coordinates":[-86.2441,39.9026]},{"Plant":"Tilton","State":"IL","Gas":176,"coordinates":[-87.6538,40.1061]},{"Plant":"Henry County","State":"IN","Gas":135.5,"coordinates":[-85.5039,39.9528]},{"Plant":"MPC Generating","State":"GA","Gas":309.4,"coordinates":[-83.6953,33.8119]},{"Plant":"Sherwood H Smith Jr Energy Complex","State":"NC","Gas":1290,"coordinates":[-79.7406,34.8392]},{"Plant":"Sewell Creek Energy","State":"GA","Gas":490,"coordinates":[-85.2769,33.9486]},{"Plant":"Alsey","State":"IL","Gas":121,"coordinates":[-90.436,39.5698]},{"Plant":"Fulton","State":"AR","Gas":153,"coordinates":[-93.7924,33.6094]},{"Plant":"Rowan","State":"NC","Gas":924.6,"coordinates":[-80.6019,35.7314]},{"Plant":"Smarr Energy Center","State":"GA","Gas":214.6,"coordinates":[-83.8464,32.9842]},{"Plant":"John S Rainey","State":"SC","Gas":977,"coordinates":[-82.776,34.3477]},{"Plant":"Essential Power Rock Springs LLC","State":"MD","Gas":639.1,"coordinates":[-76.1598,39.719]},{"Plant":"Marsh Run Generating","State":"VA","Gas":481,"coordinates":[-77.7681,38.5283]},{"Plant":"Louisa Generating","State":"VA","Gas":466,"coordinates":[-78.2139,38.1181]},{"Plant":"Remington","State":"VA","Gas":608,"coordinates":[-77.7714,38.5442]},{"Plant":"Ladysmith","State":"VA","Gas":783,"coordinates":[-77.5133,38.0722]},{"Plant":"Pleasant Valley","State":"MN","Gas":412.5,"coordinates":[-92.6829,43.7994]},{"Plant":"Lagoon Creek","State":"TN","Gas":940.8,"coordinates":[-89.3964,35.6578]},{"Plant":"Brandy Branch","State":"FL","Gas":660.8,"coordinates":[-81.9472,30.3206]},{"Plant":"Holden","State":"MO","Gas":232.8,"coordinates":[-93.9983,38.7538]},{"Plant":"MEPI GT Facility","State":"IL","Gas":239,"coordinates":[-88.8661,37.2175]},{"Plant":"Encogen","State":"WA","Gas":139.2,"coordinates":[-122.486,48.746]},{"Plant":"Robert P Mone Plant","State":"OH","Gas":435,"coordinates":[-84.7392,40.9297]},{"Plant":"H L Culbreath Bayside Power Station","State":"FL","Gas":1854,"coordinates":[-82.4231,27.9072]},{"Plant":"Terry Bundy Generating Station","State":"NE","Gas":164.6,"coordinates":[-96.6131,40.9097]},{"Plant":"E B Harris Electric Generating Plant","State":"AL","Gas":1256.1,"coordinates":[-86.5744,32.3814]},{"Plant":"Sand Hill","State":"TX","Gas":501.2,"coordinates":[-97.6129,30.2098]},{"Plant":"Talbot County Energy","State":"GA","Gas":663.6,"coordinates":[-84.6917,32.5892]},{"Plant":"Chattahoochee Energy Facility","State":"GA","Gas":465,"coordinates":[-85.0386,33.4072]},{"Plant":"Lakefield Junction","State":"MN","Gas":486.6,"coordinates":[-94.8415,43.7984]},{"Plant":"West Gardner","State":"KS","Gas":308,"coordinates":[-94.9861,38.7875]},{"Plant":"Coyote Springs II","State":"OR","Gas":242.7,"coordinates":[-119.674,45.848]},{"Plant":"Wansley Unit 9","State":"GA","Gas":502.1,"coordinates":[-85.0403,33.4083]},{"Plant":"Lawrence County Station","State":"IN","Gas":261,"coordinates":[-86.4511,38.8003]},{"Plant":"Evander Andrews Power Complex","State":"ID","Gas":247,"coordinates":[-115.7343,43.1792]},{"Plant":"Kemper County","State":"MS","Gas":312.8,"coordinates":[-88.606,32.7976]},{"Plant":"Peno Creek","State":"MO","Gas":188,"coordinates":[-91.2295,39.3531]},{"Plant":"Sumpter","State":"MI","Gas":340,"coordinates":[-83.5318,42.167]},{"Plant":"Pyramid","State":"NM","Gas":158,"coordinates":[-108.5494,32.2363]},{"Plant":"Mill Creek","State":"SC","Gas":595.2,"coordinates":[-81.4306,35.1597]},{"Plant":"Greater Des Moines","State":"IA","Gas":493,"coordinates":[-93.5283,41.5563]},{"Plant":"Silver Creek","State":"MS","Gas":225,"coordinates":[-89.9468,31.6004]},{"Plant":"Sylvarena","State":"MS","Gas":129,"coordinates":[-89.4127,31.9821]},{"Plant":"West Campus Cogeneration Facility","State":"WI","Gas":130.4,"coordinates":[-89.4251,43.0751]},{"Plant":"Grays Harbor Energy Facility","State":"WA","Gas":637,"coordinates":[-123.48,46.9692]},{"Plant":"Beatrice","State":"NE","Gas":237,"coordinates":[-96.8082,40.3302]},{"Plant":"Blue Lake","State":"MN","Gas":315.8,"coordinates":[-93.4315,44.7855]},{"Plant":"Sycamore","State":"IA","Gas":147.5,"coordinates":[-93.6769,41.6722]},{"Plant":"Emery Station","State":"IA","Gas":516.1,"coordinates":[-93.2922,43.094]},{"Plant":"Intercession City","State":"FL","Gas":557,"coordinates":[-81.5486,28.2628]},{"Plant":"Gerald Andrus","State":"MS","Gas":712,"coordinates":[-91.1167,33.35]},{"Plant":"Waterford 1 & 2","State":"LA","Gas":816,"coordinates":[-90.4768,29.9989]},{"Plant":"Comanche","State":"OK","Gas":260,"coordinates":[-98.3244,34.5431]},{"Plant":"DeCordova Steam Electric Station","State":"TX","Gas":1138,"coordinates":[-97.7006,32.4031]},{"Plant":"Santan","State":"AZ","Gas":1227,"coordinates":[-111.7503,33.3325]},{"Plant":"Beaver","State":"OR","Gas":487,"coordinates":[-123.1739,46.1724]},{"Plant":"Glen Gardner","State":"NJ","Gas":160,"coordinates":[-74.9207,40.6815]},{"Plant":"Grand Tower","State":"IL","Gas":513,"coordinates":[-89.5112,37.6577]},{"Plant":"Astoria Generating Station","State":"NY","Gas":176.3,"coordinates":[-73.9126,40.7877]},{"Plant":"Wood River","State":"IL","Gas":116.1,"coordinates":[-90.1347,38.8639]},{"Plant":"Venice","State":"IL","Gas":500,"coordinates":[-90.1764,38.6642]},{"Plant":"Beluga","State":"AK","Gas":344.4,"coordinates":[-151.0356,61.1861]},{"Plant":"Marion","State":"IL","Gas":140,"coordinates":[-88.9531,37.6197]},{"Plant":"Frederickson","State":"WA","Gas":126,"coordinates":[-122.365,47.0797]},{"Plant":"Harding Street","State":"IN","Gas":322,"coordinates":[-86.1969,39.7113]},{"Plant":"Dean H Mitchell","State":"IN","Gas":142,"coordinates":[-87.4069,41.6392]},{"Plant":"Michigan City","State":"IN","Gas":120,"coordinates":[-86.9086,41.7208]}]

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Gas":740,"coordinates":[-87.7811,32.6017]},{"Plant":"Gilroy Power Plant","State":"CA","Gas":105,"coordinates":[-121.5367,37.0001]},{"Plant":"Noblesville","State":"IN","Gas":285.9,"coordinates":[-85.9714,40.0969]},{"Plant":"Pedricktown Cogeneration Company LP","State":"NJ","Gas":111.4,"coordinates":[-75.4238,39.7668]},{"Plant":"Broadway","State":"IN","Gas":115,"coordinates":[-87.6049,37.9691]},{"Plant":"Butler-Warner Generation Plant","State":"NC","Gas":225,"coordinates":[-78.8294,35.0986]},{"Plant":"El Segundo Cogen","State":"CA","Gas":116.6,"coordinates":[-118.4031,33.9058]},{"Plant":"ArcelorMittal Burns Harbor","State":"IN","Gas":174.7,"coordinates":[-87.1387,41.635]},{"Plant":"King City Power Plant","State":"CA","Gas":111,"coordinates":[-121.1278,36.225]},{"Plant":"Bayou Cogen Plant","State":"TX","Gas":260,"coordinates":[-95.0458,29.6225]},{"Plant":"Bellingham Cogeneration Facility","State":"MA","Gas":264,"coordinates":[-71.4833,42.0925]},{"Plant":"Sayreville Cogeneration Facility","State":"NJ","Gas":271,"coordinates":[-74.3444,40.439]},{"Plant":"Foster Wheeler Martinez","State":"CA","Gas":103.5,"coordinates":[-122.0589,38.0244]},{"Plant":"ExxonMobil Baytown Refinery","State":"TX","Gas":130,"coordinates":[-94.9973,29.7535]},{"Plant":"RG Steel Sparrows Point, LLC","State":"MD","Gas":152.3,"coordinates":[-76.4729,39.213]},{"Plant":"Kern River Cogeneration","State":"CA","Gas":288,"coordinates":[-118.9849,35.4515]},{"Plant":"Formosa Utility Venture Ltd","State":"TX","Gas":597.3,"coordinates":[-96.5417,28.6917]},{"Plant":"Hopewell Cogeneration","State":"VA","Gas":348.3,"coordinates":[-77.2811,37.2917]},{"Plant":"Brush Generation Facility","State":"CO","Gas":292,"coordinates":[-103.631,40.2415]},{"Plant":"ExxonMobil Baytown Turbine","State":"TX","Gas":320.4,"coordinates":[-95.0096,29.7591]},{"Plant":"Selkirk Cogen","State":"NY","Gas":360.6,"coordinates":[-73.8592,42.5744]},{"Plant":"Masspower","State":"MA","Gas":238.3,"coordinates":[-72.5225,42.1575]},{"Plant":"Clear Lake Cogeneration Ltd","State":"TX","Gas":366,"coordinates":[-95.067,29.6255]},{"Plant":"Midland Cogeneration Venture","State":"MI","Gas":1843.4,"coordinates":[-84.2242,43.5861]},{"Plant":"Camden Plant Holding LLC","State":"NJ","Gas":145,"coordinates":[-75.1192,39.9175]},{"Plant":"River Hills","State":"IA","Gas":119.7,"coordinates":[-93.6195,41.5902]},{"Plant":"Hazelton","State":"PA","Gas":147.2,"coordinates":[-76.0409,40.9282]},{"Plant":"Ocotillo","State":"AZ","Gas":320,"coordinates":[-111.9122,33.4225]},{"Plant":"West Phoenix","State":"AZ","Gas":937,"coordinates":[-112.1583,33.4417]},{"Plant":"Saguaro","State":"AZ","Gas":386,"coordinates":[-111.3,32.5517]},{"Plant":"Yucca","State":"AZ","Gas":257,"coordinates":[-114.7106,32.7214]},{"Plant":"Fort Dodge","State":"KS","Gas":146.6,"coordinates":[-99.9497,37.7328]},{"Plant":"Riverton","State":"KS","Gas":194,"coordinates":[-94.6987,37.0726]},{"Plant":"Gordon Evans Energy Center","State":"KS","Gas":832,"coordinates":[-97.5217,37.7903]},{"Plant":"Murray Gill","State":"KS","Gas":293,"coordinates":[-97.4136,37.5967]},{"Plant":"Hutchinson Energy Center","State":"KS","Gas":330,"coordinates":[-97.8747,38.0906]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Gas":316,"coordinates":[-110.9047,32.16]},{"Plant":"Kaw","State":"KS","Gas":140.3,"coordinates":[-94.6514,39.0867]},{"Plant":"McPherson 2","State":"KS","Gas":104,"coordinates":[-97.6834,38.3634]},{"Plant":"Garden City","State":"KS","Gas":225.3,"coordinates":[-100.8956,37.9703]},{"Plant":"E W Brown","State":"KY","Gas":849,"coordinates":[-84.7126,37.7883]},{"Plant":"Paddys Run","State":"KY","Gas":193,"coordinates":[-85.8417,38.2236]},{"Plant":"Louisiana 1","State":"LA","Gas":382.4,"coordinates":[-91.1864,30.4922]},{"Plant":"Louisiana 2","State":"LA","Gas":138,"coordinates":[-91.1864,30.4922]},{"Plant":"R S Nelson","State":"LA","Gas":603,"coordinates":[-93.2911,30.2844]},{"Plant":"Willow Glen","State":"LA","Gas":1752,"coordinates":[-91.1164,30.2743]},{"Plant":"Coughlin Power Station","State":"LA","Gas":732,"coordinates":[-92.2611,30.8439]},{"Plant":"Teche","State":"LA","Gas":379,"coordinates":[-91.5425,29.8222]},{"Plant":"Little Gypsy","State":"LA","Gas":1170,"coordinates":[-90.4617,30.0051]},{"Plant":"Nine Mile Point","State":"LA","Gas":1756,"coordinates":[-90.1458,29.9472]},{"Plant":"Sterlington","State":"LA","Gas":386,"coordinates":[-92.0792,32.7047]},{"Plant":"Michoud","State":"LA","Gas":813,"coordinates":[-89.9372,30.0081]},{"Plant":"Agua Fria","State":"AZ","Gas":626,"coordinates":[-112.2153,33.5561]},{"Plant":"Arsenal Hill","State":"LA","Gas":116,"coordinates":[-93.7611,32.5181]},{"Plant":"Lieberman","State":"LA","Gas":268,"coordinates":[-93.9597,32.7047]},{"Plant":"Louis Doc Bonin","State":"LA","Gas":302,"coordinates":[-92.0463,30.238]},{"Plant":"Monroe","State":"LA","Gas":126,"coordinates":[-92.1794,32.5233]},{"Plant":"Big Cajun 1","State":"LA","Gas":430,"coordinates":[-91.3556,30.6739]},{"Plant":"Kyrene","State":"AZ","Gas":525,"coordinates":[-111.9353,33.3556]},{"Plant":"Herbert A Wagner","State":"MD","Gas":126,"coordinates":[-76.5268,39.1781]},{"Plant":"Notch Cliff","State":"MD","Gas":116.7,"coordinates":[-76.5087,39.4217]},{"Plant":"Perryman","State":"MD","Gas":147.6,"coordinates":[-76.2218,39.4428]},{"Plant":"Riverside","State":"MD","Gas":189,"coordinates":[-76.5133,39.2369]},{"Plant":"Westport","State":"MD","Gas":115.8,"coordinates":[-76.6295,39.266]},{"Plant":"Dickerson","State":"MD","Gas":294,"coordinates":[-77.4644,39.2097]},{"Plant":"Mystic Generating Station","State":"MA","Gas":1959.4,"coordinates":[-71.0675,42.3908]},{"Plant":"Kendall Square Station","State":"MA","Gas":217.7,"coordinates":[-71.0792,42.3633]},{"Plant":"Apache Station","State":"AZ","Gas":198.5,"coordinates":[-109.8931,32.0603]},{"Plant":"Potter Station 2","State":"MA","Gas":183.3,"coordinates":[-70.9672,42.235]},{"Plant":"Cecil Lynch","State":"AR","Gas":170,"coordinates":[-92.1987,34.7535]},{"Plant":"Hamilton Moses","State":"AR","Gas":134,"coordinates":[-90.8722,34.9806]},{"Plant":"Harvey Couch","State":"AR","Gas":135,"coordinates":[-93.4649,33.3592]},{"Plant":"B C Cobb","State":"MI","Gas":187,"coordinates":[-86.2423,43.2588]},{"Plant":"Lake Catherine","State":"AR","Gas":712,"coordinates":[-92.9049,34.4341]},{"Plant":"Dan E Karn","State":"MI","Gas":1276,"coordinates":[-83.8401,43.645]},{"Plant":"Thetford","State":"MI","Gas":171.8,"coordinates":[-83.6286,43.1567]},{"Plant":"Conners Creek","State":"MI","Gas":230,"coordinates":[-82.9597,42.3592]},{"Plant":"Delray","State":"MI","Gas":120,"coordinates":[-83.1019,42.2947]},{"Plant":"Robert E Ritchie","State":"AR","Gas":860,"coordinates":[-90.5987,34.4629]},{"Plant":"Hancock","State":"MI","Gas":124,"coordinates":[-83.4425,42.5497]},{"Plant":"River Rouge","State":"MI","Gas":234,"coordinates":[-83.1119,42.2739]},{"Plant":"Mistersky","State":"MI","Gas":110,"coordinates":[-83.0903,42.3039]},{"Plant":"Black Dog","State":"MN","Gas":243,"coordinates":[-93.2501,44.8108]},{"Plant":"High Bridge","State":"MN","Gas":488,"coordinates":[-93.1117,44.9314]},{"Plant":"Inver Hills","State":"MN","Gas":282,"coordinates":[-93.042,44.781]},{"Plant":"Riverside","State":"MN","Gas":473,"coordinates":[-93.2753,45.0203]},{"Plant":"Thomas Fitzhugh","State":"AR","Gas":165,"coordinates":[-93.8049,35.4624]},{"Plant":"Carl Bailey","State":"AR","Gas":122,"coordinates":[-91.3634,35.2601]},{"Plant":"McClellan","State":"AR","Gas":134,"coordinates":[-92.7917,33.5648]},{"Plant":"Cambridge CT","State":"MN","Gas":159,"coordinates":[-93.2081,45.601]},{"Plant":"Elk River","State":"MN","Gas":178.9,"coordinates":[-93.5584,45.2968]},{"Plant":"Chevron Oil","State":"MS","Gas":130,"coordinates":[-88.4919,30.34]},{"Plant":"Sweatt","State":"MS","Gas":124,"coordinates":[-88.7461,32.2925]},{"Plant":"Jack Watson","State":"MS","Gas":292,"coordinates":[-89.0286,30.4392]},{"Plant":"Baxter Wilson","State":"MS","Gas":1176,"coordinates":[-90.9306,32.2831]},{"Plant":"Delta","State":"MS","Gas":177,"coordinates":[-90.7139,33.7947]},{"Plant":"Rex Brown","State":"MS","Gas":294,"coordinates":[-90.213,32.357]},{"Plant":"Moselle","State":"MS","Gas":327,"coordinates":[-89.3004,31.528]},{"Plant":"Hawthorn","State":"MO","Gas":420,"coordinates":[-94.4778,39.1306]},{"Plant":"Lake Road","State":"MO","Gas":126.1,"coordinates":[-94.8773,39.7246]},{"Plant":"James River Power Station","State":"MO","Gas":155,"coordinates":[-93.2619,37.1086]},{"Plant":"Canaday","State":"NE","Gas":110.9,"coordinates":[-99.7011,40.6942]},{"Plant":"C W Burdick","State":"NE","Gas":174.1,"coordinates":[-98.3269,40.9228]},{"Plant":"Contra Costa","State":"CA","Gas":672,"coordinates":[-121.7642,38.0192]},{"Plant":"Sarpy County","State":"NE","Gas":309,"coordinates":[-95.9706,41.1706]},{"Plant":"Clark","State":"NV","Gas":1138,"coordinates":[-115.0507,36.0875]},{"Plant":"Sunrise","State":"NV","Gas":149,"coordinates":[-115.036,36.1384]},{"Plant":"Fort Churchill","State":"NV","Gas":226,"coordinates":[-119.1322,39.1281]},{"Plant":"Tracy","State":"NV","Gas":1033.6,"coordinates":[-119.525,39.5625]},{"Plant":"Sayreville","State":"NJ","Gas":167,"coordinates":[-74.3523,40.4765]},{"Plant":"Gilbert","State":"NJ","Gas":536,"coordinates":[-75.1639,40.5658]},{"Plant":"Bergen Generating Station","State":"NJ","Gas":1199,"coordinates":[-74.0244,40.8375]},{"Plant":"PSEG Burlington Generating Station","State":"NJ","Gas":168,"coordinates":[-74.8792,40.0766]},{"Plant":"PSEG Edison Generating Station","State":"NJ","Gas":504,"coordinates":[-74.3956,40.4911]},{"Plant":"PSEG Essex Generating Station","State":"NJ","Gas":616.6,"coordinates":[-74.1206,40.7372]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Gas":355,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Kearny Generating Station","State":"NJ","Gas":446,"coordinates":[-74.0965,40.7373]},{"Plant":"PSEG Linden Generating Station","State":"NJ","Gas":1587,"coordinates":[-74.2072,40.6217]},{"Plant":"PSEG Sewaren Generating Station","State":"NJ","Gas":453,"coordinates":[-74.2469,40.5558]},{"Plant":"Rio Grande","State":"NM","Gas":236,"coordinates":[-106.5472,31.8047]},{"Plant":"Maddox","State":"NM","Gas":179,"coordinates":[-103.3015,32.7142]},{"Plant":"Reeves","State":"NM","Gas":154,"coordinates":[-106.6019,35.171]},{"Plant":"Cunningham","State":"NM","Gas":480,"coordinates":[-103.3533,32.7131]},{"Plant":"Humboldt Bay","State":"CA","Gas":150.3,"coordinates":[-124.2103,40.7415]},{"Plant":"Arthur Kill Generating Station","State":"NY","Gas":841,"coordinates":[-74.2,40.5916]},{"Plant":"East River","State":"NY","Gas":293.5,"coordinates":[-73.9742,40.7281]},{"Plant":"Gowanus Gas Turbines Generating","State":"NY","Gas":254.3,"coordinates":[-74.0051,40.6635]},{"Plant":"Narrows Gas Turbines Generating","State":"NY","Gas":264.9,"coordinates":[-74.0208,40.6486]},{"Plant":"Ravenswood","State":"NY","Gas":2255.8,"coordinates":[-73.9461,40.7592]},{"Plant":"E F Barrett","State":"NY","Gas":687.1,"coordinates":[-73.6479,40.6167]},{"Plant":"Far Rockaway","State":"NY","Gas":105.1,"coordinates":[-73.761,40.6109]},{"Plant":"Glenwood","State":"NY","Gas":229.2,"coordinates":[-73.6475,40.8271]},{"Plant":"Northport","State":"NY","Gas":1557.9,"coordinates":[-73.3423,40.9236]},{"Plant":"Port Jefferson","State":"NY","Gas":473.7,"coordinates":[-73.0785,40.9497]},{"Plant":"Bethlehem Energy Center","State":"NY","Gas":755,"coordinates":[-73.7638,42.5942]},{"Plant":"Dynegy Morro Bay LLC","State":"CA","Gas":999,"coordinates":[-120.8566,35.3722]},{"Plant":"Dynegy Moss Landing Power Plant","State":"CA","Gas":2529,"coordinates":[-121.7822,36.8048]},{"Plant":"Bowline Point","State":"NY","Gas":1139,"coordinates":[-73.9689,41.2044]},{"Plant":"Asheville","State":"NC","Gas":324,"coordinates":[-82.5417,35.4731]},{"Plant":"Pittsburg Power","State":"CA","Gas":1311,"coordinates":[-121.8945,38.0392]},{"Plant":"Potrero Power","State":"CA","Gas":206,"coordinates":[-122.387,37.7566]},{"Plant":"Dicks Creek","State":"OH","Gas":106.2,"coordinates":[-84.3778,39.465]},{"Plant":"Frank M Tait","State":"OH","Gas":256,"coordinates":[-84.2111,39.7272]},{"Plant":"Yankee Street","State":"OH","Gas":101.5,"coordinates":[-84.2047,39.603]},{"Plant":"FirstEnergy West Lorain","State":"OH","Gas":425,"coordinates":[-82.2644,41.4294]},{"Plant":"Richland","State":"OH","Gas":358,"coordinates":[-84.3346,41.3052]},{"Plant":"Horseshoe Lake","State":"OK","Gas":857,"coordinates":[-97.1797,35.5087]},{"Plant":"Mustang","State":"OK","Gas":531.8,"coordinates":[-97.675,35.4699]},{"Plant":"Seminole","State":"OK","Gas":1503.7,"coordinates":[-96.7258,34.9665]},{"Plant":"Northeastern","State":"OK","Gas":891,"coordinates":[-95.7008,36.4317]},{"Plant":"Southwestern","State":"OK","Gas":603,"coordinates":[-98.3524,35.1009]},{"Plant":"Tulsa","State":"OK","Gas":370,"coordinates":[-95.991,36.1165]},{"Plant":"Weleetka","State":"OK","Gas":163,"coordinates":[-96.1352,35.3233]},{"Plant":"Barry","State":"AL","Gas":962,"coordinates":[-88.0103,31.0069]},{"Plant":"Anadarko Plant","State":"OK","Gas":485,"coordinates":[-98.23,35.0847]},{"Plant":"Mooreland","State":"OK","Gas":322,"coordinates":[-99.2254,36.4372]},{"Plant":"Encina","State":"CA","Gas":964,"coordinates":[-117.3364,33.1361]},{"Plant":"Kearny","State":"CA","Gas":136,"coordinates":[-117.1338,32.834]},{"Plant":"Brunot Island","State":"PA","Gas":245,"coordinates":[-80.0438,40.4649]},{"Plant":"Dynegy South Bay Power Plant","State":"CA","Gas":296,"coordinates":[-117.092,32.6114]},{"Plant":"AES Alamitos LLC","State":"CA","Gas":1997,"coordinates":[-118.1009,33.7688]},{"Plant":"Manchester Street","State":"RI","Gas":447,"coordinates":[-71.4042,41.8167]},{"Plant":"Darlington County","State":"SC","Gas":442,"coordinates":[-80.1657,34.4185]},{"Plant":"Buzzard Roost","State":"SC","Gas":176,"coordinates":[-81.9025,34.1692]},{"Plant":"Hagood","State":"SC","Gas":126,"coordinates":[-79.9634,32.8265]},{"Plant":"Coolwater","State":"CA","Gas":608,"coordinates":[-116.8539,34.8606]},{"Plant":"Urquhart","State":"SC","Gas":559,"coordinates":[-81.9111,33.435]},{"Plant":"El Segundo Power","State":"CA","Gas":650,"coordinates":[-118.4242,33.9098]},{"Plant":"Etiwanda Generating Station","State":"CA","Gas":640,"coordinates":[-117.5266,34.0912]},{"Plant":"AES Huntington Beach LLC","State":"CA","Gas":903.6,"coordinates":[-117.9792,33.6439]},{"Plant":"Allen Steam Plant","State":"TN","Gas":461.6,"coordinates":[-90.1487,35.0741]},{"Plant":"Gallatin","State":"TN","Gas":599.2,"coordinates":[-86.4006,36.3156]},{"Plant":"Johnsonville","State":"TN","Gas":1135.2,"coordinates":[-87.9861,36.0278]},{"Plant":"Long Beach Generation LLC","State":"CA","Gas":260,"coordinates":[-118.2248,33.7641]},{"Plant":"E S Joslin","State":"TX","Gas":254,"coordinates":[-96.5458,28.6472]},{"Plant":"Laredo","State":"TX","Gas":178,"coordinates":[-99.5089,27.5667]},{"Plant":"Nueces Bay","State":"TX","Gas":718.2,"coordinates":[-97.4192,27.8194]},{"Plant":"Victoria","State":"TX","Gas":285,"coordinates":[-97.01,28.7883]},{"Plant":"Mandalay","State":"CA","Gas":560,"coordinates":[-119.2511,34.2067]},{"Plant":"Lake Hubbard","State":"TX","Gas":921,"coordinates":[-96.5458,32.8358]},{"Plant":"Mountain Creek","State":"TX","Gas":808,"coordinates":[-96.9358,32.7231]},{"Plant":"Newman","State":"TX","Gas":619,"coordinates":[-106.4318,31.9836]},{"Plant":"Lewis Creek","State":"TX","Gas":460,"coordinates":[-95.5214,30.4356]},{"Plant":"Sabine","State":"TX","Gas":1814,"coordinates":[-93.878,30.0242]},{"Plant":"Cedar Bayou","State":"TX","Gas":1495,"coordinates":[-94.9256,29.75]},{"Plant":"Greens Bayou","State":"TX","Gas":760,"coordinates":[-95.2194,29.8222]},{"Plant":"Sam Bertron","State":"TX","Gas":765,"coordinates":[-95.0598,29.7268]},{"Plant":"T H Wharton","State":"TX","Gas":817,"coordinates":[-95.5306,29.9417]},{"Plant":"W A Parish","State":"TX","Gas":1176,"coordinates":[-95.6311,29.4828]},{"Plant":"Knox Lee","State":"TX","Gas":488,"coordinates":[-94.6415,32.3766]},{"Plant":"Wilkes","State":"TX","Gas":883,"coordinates":[-94.548,32.8482]},{"Plant":"Jones","State":"TX","Gas":486,"coordinates":[-101.7392,33.5239]},{"Plant":"Nichols","State":"TX","Gas":457,"coordinates":[-101.7464,35.2834]},{"Plant":"Plant X","State":"TX","Gas":422,"coordinates":[-102.4114,34.1661]},{"Plant":"Eagle Mountain","State":"TX","Gas":665,"coordinates":[-97.4792,32.9056]},{"Plant":"Graham","State":"TX","Gas":630,"coordinates":[-98.6117,33.1344]},{"Plant":"Handley","State":"TX","Gas":1265,"coordinates":[-97.2192,32.7283]},{"Plant":"Morgan Creek","State":"TX","Gas":1166,"coordinates":[-100.9156,32.3358]},{"Plant":"Permian Basin","State":"TX","Gas":1055,"coordinates":[-102.9633,31.5839]},{"Plant":"Ormond Beach","State":"CA","Gas":1516,"coordinates":[-119.1689,34.1292]},{"Plant":"Stryker Creek","State":"TX","Gas":667,"coordinates":[-94.9898,31.9398]},{"Plant":"Tradinghouse","State":"TX","Gas":1383,"coordinates":[-96.9642,31.5728]},{"Plant":"Trinidad","State":"TX","Gas":226,"coordinates":[-96.1013,32.1245]},{"Plant":"Valley","State":"TX","Gas":1115,"coordinates":[-96.3676,33.6281]},{"Plant":"Decker Creek","State":"TX","Gas":932,"coordinates":[-97.6128,30.3033]},{"Plant":"Silas Ray","State":"TX","Gas":125,"coordinates":[-97.5214,25.9131]},{"Plant":"AES Redondo Beach LLC","State":"CA","Gas":1310,"coordinates":[-118.395,33.8504]},{"Plant":"Bryan","State":"TX","Gas":130,"coordinates":[-96.3723,30.6474]},{"Plant":"Ray Olinger","State":"TX","Gas":395,"coordinates":[-96.4525,33.0681]},{"Plant":"Mountainview Generating Station","State":"CA","Gas":942.2,"coordinates":[-117.2418,34.0818]},{"Plant":"Sim Gideon","State":"TX","Gas":620,"coordinates":[-97.2708,30.1456]},{"Plant":"Ty Cooke","State":"TX","Gas":131,"coordinates":[-101.7906,33.5211]},{"Plant":"Leon Creek","State":"TX","Gas":339,"coordinates":[-98.5761,29.3525]},{"Plant":"O W Sommers","State":"TX","Gas":880,"coordinates":[-98.3242,29.3081]},{"Plant":"V H Braunig","State":"TX","Gas":1050,"coordinates":[-98.3825,29.2567]},{"Plant":"W B Tuttle","State":"TX","Gas":314,"coordinates":[-98.4181,29.53]},{"Plant":"R W Miller","State":"TX","Gas":574,"coordinates":[-98.3103,32.6581]},{"Plant":"Pearsall","State":"TX","Gas":270.6,"coordinates":[-99.0919,28.9275]},{"Plant":"Sam Rayburn","State":"TX","Gas":227,"coordinates":[-97.135,28.8947]},{"Plant":"Gadsby","State":"UT","Gas":347.5,"coordinates":[-111.9289,40.7686]},{"Plant":"Grayson","State":"CA","Gas":130.1,"coordinates":[-118.2782,34.1556]},{"Plant":"Chesterfield","State":"VA","Gas":397,"coordinates":[-77.3833,37.3822]},{"Plant":"Possum Point","State":"VA","Gas":875,"coordinates":[-77.2806,38.5367]},{"Plant":"Transalta Centralia Generation","State":"WA","Gas":256,"coordinates":[-122.8598,46.7559]},{"Plant":"El Centro","State":"CA","Gas":225.9,"coordinates":[-115.54,32.8022]},{"Plant":"Harbor","State":"CA","Gas":461,"coordinates":[-118.2656,33.7706]},{"Plant":"Haynes","State":"CA","Gas":1524,"coordinates":[-118.0991,33.7647]},{"Plant":"Wheaton","State":"WI","Gas":196,"coordinates":[-91.5158,44.8854]},{"Plant":"Scattergood","State":"CA","Gas":796,"coordinates":[-118.4276,33.9182]},{"Plant":"Port Washington Generating Station","State":"WI","Gas":1090,"coordinates":[-87.8689,43.3842]},{"Plant":"Rock River","State":"WI","Gas":146.7,"coordinates":[-89.0276,42.582]},{"Plant":"West Marinette","State":"WI","Gas":148.9,"coordinates":[-87.6881,45.0869]},{"Plant":"Valley","State":"CA","Gas":556,"coordinates":[-118.3913,34.245]},{"Plant":"Powerlane Plant","State":"TX","Gas":111,"coordinates":[-96.1264,33.1707]},{"Plant":"Glenarm","State":"CA","Gas":155,"coordinates":[-118.1494,34.126]},{"Plant":"Spencer","State":"TX","Gas":122,"coordinates":[-97.1061,33.1975]},{"Plant":"Colbert","State":"AL","Gas":390.4,"coordinates":[-87.8486,34.7439]},{"Plant":"Thomas C Ferguson","State":"TX","Gas":420,"coordinates":[-98.3705,30.558]},{"Plant":"Barney M Davis","State":"TX","Gas":1032.2,"coordinates":[-97.3117,27.6064]},{"Plant":"Riverside","State":"OK","Gas":1067,"coordinates":[-95.9567,35.9978]},{"Plant":"Pittsfield Generating LP","State":"MA","Gas":141,"coordinates":[-73.2181,42.4564]},{"Plant":"Linden Cogen Plant","State":"NJ","Gas":897.3,"coordinates":[-74.2156,40.6322]},{"Plant":"Houston Chemical Complex Battleground","State":"TX","Gas":263,"coordinates":[-95.0839,29.7314]},{"Plant":"Paris Energy Center","State":"TX","Gas":238,"coordinates":[-95.5577,33.6968]},{"Plant":"Hal C Weaver Power Plant","State":"TX","Gas":146.8,"coordinates":[-97.7356,30.2867]},{"Plant":"Sycamore Cogeneration","State":"CA","Gas":300,"coordinates":[-118.9853,35.4526]},{"Plant":"Union Carbide Seadrift Cogen","State":"TX","Gas":168,"coordinates":[-96.7706,28.5105]},{"Plant":"Dow St Charles Operations","State":"LA","Gas":291.6,"coordinates":[-90.4414,29.9861]},{"Plant":"Watson Cogeneration","State":"CA","Gas":398,"coordinates":[-118.2448,33.8166]},{"Plant":"Bucksport Generation LLC","State":"ME","Gas":249.8,"coordinates":[-68.8046,44.5738]},{"Plant":"Bethpage Power Plant","State":"NY","Gas":184,"coordinates":[-73.4994,40.7469]},{"Plant":"Shell Deer Park","State":"TX","Gas":140,"coordinates":[-95.1289,29.7232]},{"Plant":"Newark Bay Cogeneration Partnership LP","State":"NJ","Gas":120.2,"coordinates":[-74.13,40.7197]},{"Plant":"Indeck Corinth Energy Center","State":"NY","Gas":130.6,"coordinates":[-73.8125,43.25]},{"Plant":"PPG Powerhouse C","State":"LA","Gas":303.2,"coordinates":[-93.2831,30.2242]},{"Plant":"Bayonne Plant Holding LLC","State":"NJ","Gas":158,"coordinates":[-74.1124,40.6553]},{"Plant":"Harbor Cogen","State":"CA","Gas":101.7,"coordinates":[-118.2303,33.7771]},{"Plant":"Rosemary Power Station","State":"NC","Gas":165,"coordinates":[-77.6594,36.4517]},{"Plant":"Oklahoma Cogeneration Project","State":"OK","Gas":111.4,"coordinates":[-97.625,35.4397]},{"Plant":"Eagle Point Power Generation","State":"NJ","Gas":150,"coordinates":[-75.1592,39.8746]},{"Plant":"TXU Sweetwater Generating Plant","State":"TX","Gas":213,"coordinates":[-100.365,32.4928]},{"Plant":"ExxonMobil Beaumont Refinery","State":"TX","Gas":610.6,"coordinates":[-94.0753,30.0636]},{"Plant":"JM Shafer Generating Station","State":"CO","Gas":263,"coordinates":[-104.7736,40.0986]},{"Plant":"Gary Works","State":"IN","Gas":161,"coordinates":[-87.3289,41.6224]},{"Plant":"Parlin Power Plant","State":"NJ","Gas":118,"coordinates":[-74.3272,40.4607]},{"Plant":"Optim Energy Altura Cogen LLC","State":"TX","Gas":493,"coordinates":[-95.1077,29.8161]},{"Plant":"Cumberland","State":"NJ","Gas":179.6,"coordinates":[-74.9654,39.3757]},{"Plant":"Gramercy Holdings LLC","State":"LA","Gas":106,"coordinates":[-90.6693,30.054]},{"Plant":"Hardee Power Station","State":"FL","Gas":358,"coordinates":[-81.9636,27.6364]},{"Plant":"Bellmeade Power Station","State":"VA","Gas":267,"coordinates":[-77.4317,37.4964]},{"Plant":"Ocean State Power","State":"RI","Gas":218.6,"coordinates":[-71.6689,42.0097]},{"Plant":"LaO Energy Systems","State":"LA","Gas":574,"coordinates":[-91.2325,30.3186]},{"Plant":"Doswell Energy Center","State":"VA","Gas":813.8,"coordinates":[-77.1448,37.8182]},{"Plant":"Elizabeth River Power Station","State":"VA","Gas":348,"coordinates":[-76.3083,36.775]},{"Plant":"Texas City Power Plant","State":"TX","Gas":451,"coordinates":[-94.9438,29.3787]},{"Plant":"Dow Chemical Texas Operation","State":"TX","Gas":795.1,"coordinates":[-95.4075,28.9913]},{"Plant":"Power Station 4","State":"TX","Gas":172,"coordinates":[-94.9219,29.3782]},{"Plant":"Midway Sunset Cogen","State":"CA","Gas":219,"coordinates":[-119.6294,35.2269]},{"Plant":"C R Wing Cogen Plant","State":"TX","Gas":227,"coordinates":[-101.4224,32.2732]},{"Plant":"Delaware City Plant","State":"DE","Gas":307,"coordinates":[-75.6343,39.5871]},{"Plant":"McWilliams","State":"AL","Gas":650,"coordinates":[-86.4764,31.4003]},{"Plant":"J K Smith","State":"KY","Gas":784,"coordinates":[-84.1017,37.8833]},{"Plant":"Lockport Energy Associates LP","State":"NY","Gas":204.2,"coordinates":[-78.745,43.1619]},{"Plant":"Kennedy International Airport Cogen","State":"NY","Gas":120.7,"coordinates":[-73.7778,40.6417]},{"Plant":"March Point Cogeneration","State":"WA","Gas":146.2,"coordinates":[-122.56,48.4708]},{"Plant":"Saguaro Power","State":"NV","Gas":101,"coordinates":[-115.0117,36.0417]},{"Plant":"Ocean State Power II","State":"RI","Gas":218.6,"coordinates":[-71.6701,42.0099]},{"Plant":"Orange Cogeneration Facility","State":"FL","Gas":110.6,"coordinates":[-81.8251,27.8708]},{"Plant":"Lake Cogen Ltd","State":"FL","Gas":121,"coordinates":[-81.676,28.9158]},{"Plant":"Pasco Cogen Ltd","State":"FL","Gas":121.6,"coordinates":[-82.1889,28.3746]},{"Plant":"Mulberry Cogeneration Facility","State":"FL","Gas":113,"coordinates":[-81.8775,27.8489]},{"Plant":"Orlando Cogen LP","State":"FL","Gas":120,"coordinates":[-81.4123,28.4426]},{"Plant":"Sumas Power Plant","State":"WA","Gas":125.5,"coordinates":[-122.2733,48.9905]},{"Plant":"Ferndale Generating Station","State":"WA","Gas":271,"coordinates":[-122.6867,48.8288]},{"Plant":"Hartwell Energy Facility","State":"GA","Gas":298,"coordinates":[-82.8199,34.3396]},{"Plant":"Sithe Independence Station","State":"NY","Gas":982.2,"coordinates":[-76.4511,43.495]},{"Plant":"Saranac Facility","State":"NY","Gas":252.1,"coordinates":[-73.4557,44.7132]},{"Plant":"NAEA Lakewood LLC","State":"NJ","Gas":218.1,"coordinates":[-74.1686,40.0613]},{"Plant":"Auburndale Power Partners","State":"FL","Gas":155.3,"coordinates":[-81.8058,28.0542]},{"Plant":"Oyster Creek Unit VIII","State":"TX","Gas":379,"coordinates":[-95.342,28.9802]},{"Plant":"Hermiston Generating Plant","State":"OR","Gas":464,"coordinates":[-119.37,45.8042]},{"Plant":"Grays Ferry Cogeneration","State":"PA","Gas":150,"coordinates":[-75.1881,39.9422]},{"Plant":"Milford Power LP","State":"MA","Gas":148,"coordinates":[-71.5115,42.1294]},{"Plant":"Milagro Cogeneration Plant","State":"NM","Gas":121.6,"coordinates":[-107.9417,36.7367]},{"Plant":"Johnson County","State":"TX","Gas":267,"coordinates":[-97.4078,32.3994]},{"Plant":"Brandywine Power Facility","State":"MD","Gas":230,"coordinates":[-76.8678,38.6681]},{"Plant":"Gordonsville Energy LP","State":"VA","Gas":218,"coordinates":[-78.2138,38.1179]},{"Plant":"Sun Peak Generating Station","State":"NV","Gas":222,"coordinates":[-115.0339,36.1375]},{"Plant":"Brooklyn Navy Yard Cogeneration","State":"NY","Gas":250,"coordinates":[-73.9764,40.6994]},{"Plant":"Michigan Power LP","State":"MI","Gas":128,"coordinates":[-86.425,43.9375]},{"Plant":"LSP-Cottage Grove LP","State":"MN","Gas":251,"coordinates":[-92.9119,44.7956]},{"Plant":"LSP-Whitewater LP","State":"WI","Gas":261,"coordinates":[-88.7299,42.8555]},{"Plant":"Sweeny Cogen Facility","State":"TX","Gas":436,"coordinates":[-95.745,29.0728]},{"Plant":"Dighton Power Plant","State":"MA","Gas":150,"coordinates":[-71.1239,41.8312]},{"Plant":"De Pere Energy Center","State":"WI","Gas":173.8,"coordinates":[-88.072,44.4486]},{"Plant":"Androscoggin Energy Center","State":"ME","Gas":136.6,"coordinates":[-70.2423,44.5063]},{"Plant":"Delta Person LLC","State":"NM","Gas":140,"coordinates":[-106.644,35.026]},{"Plant":"Mid-Georgia Cogeneration Facility","State":"GA","Gas":316,"coordinates":[-83.6039,32.4856]},{"Plant":"Berkshire Power","State":"MA","Gas":229,"coordinates":[-72.6478,42.0476]},{"Plant":"Bridgeport Energy Project","State":"CT","Gas":454,"coordinates":[-73.1844,41.1692]},{"Plant":"Pasadena Cogeneration","State":"TX","Gas":485,"coordinates":[-95.1765,29.7248]},{"Plant":"Tiverton Power Plant","State":"RI","Gas":250,"coordinates":[-71.1706,41.6422]},{"Plant":"Axiall Plaquemine","State":"LA","Gas":240,"coordinates":[-91.185,30.2586]},{"Plant":"Tenaska Frontier Generation Station","State":"TX","Gas":860,"coordinates":[-95.9178,30.5924]},{"Plant":"Batesville Generation Facility","State":"MS","Gas":858,"coordinates":[-89.9275,34.3356]},{"Plant":"Black Hawk Station","State":"TX","Gas":219.4,"coordinates":[-101.36,35.6957]},{"Plant":"Mustang Station","State":"TX","Gas":486,"coordinates":[-102.7417,32.9728]},{"Plant":"Maine Independence Station","State":"ME","Gas":490,"coordinates":[-68.7094,44.8242]},{"Plant":"Pine Bluff Energy Center","State":"AR","Gas":192,"coordinates":[-91.9025,34.2181]},{"Plant":"Desert Star Energy Center","State":"NV","Gas":450,"coordinates":[-114.9928,35.7867]},{"Plant":"Millennium Power","State":"MA","Gas":325.1,"coordinates":[-72.0151,42.1123]},{"Plant":"New Albany Energy Facility","State":"MS","Gas":360,"coordinates":[-88.9397,34.5408]},{"Plant":"Brownsville Peaking Power","State":"TN","Gas":467.6,"coordinates":[-89.198,35.5438]},{"Plant":"Crockett Cogen Project","State":"CA","Gas":247.4,"coordinates":[-122.2161,38.0569]},{"Plant":"Gregory Power Facility","State":"TX","Gas":366,"coordinates":[-97.2584,27.8893]},{"Plant":"Zeeland Generating Station","State":"MI","Gas":848.5,"coordinates":[-85.9975,42.8206]},{"Plant":"Dearborn Industrial Generation","State":"MI","Gas":710,"coordinates":[-83.154,42.3026]},{"Plant":"Taft Cogeneration Facility","State":"LA","Gas":790,"coordinates":[-90.4599,29.9888]},{"Plant":"Midlothian Energy Facility","State":"TX","Gas":1278,"coordinates":[-97.0537,32.4302]},{"Plant":"Lamar Power Project","State":"TX","Gas":1004,"coordinates":[-95.59,33.6308]},{"Plant":"Frontera Energy Center","State":"TX","Gas":475,"coordinates":[-98.3992,26.208]},{"Plant":"NRG Sterlington Power","State":"LA","Gas":176,"coordinates":[-92.0811,32.6889]},{"Plant":"Rumford Power Associates","State":"ME","Gas":254,"coordinates":[-70.5219,44.5303]},{"Plant":"Livingston Generating Station","State":"MI","Gas":132,"coordinates":[-84.7308,45.0304]},{"Plant":"Klamath Cogeneration Plant","State":"OR","Gas":470,"coordinates":[-121.8106,42.1739]},{"Plant":"Entergy Rhode Island State Energy LP","State":"RI","Gas":528,"coordinates":[-71.5186,41.8017]},{"Plant":"Rocky Road Power LLC","State":"IL","Gas":347,"coordinates":[-88.2397,42.0931]},{"Plant":"Madison","State":"OH","Gas":576,"coordinates":[-84.4647,39.4522]},{"Plant":"Vermillion Energy Facility","State":"IN","Gas":568,"coordinates":[-87.4464,39.9223]},{"Plant":"Sutter Energy Center","State":"CA","Gas":530,"coordinates":[-121.6959,39.0531]},{"Plant":"Rockingham County CT Station","State":"NC","Gas":775,"coordinates":[-79.8297,36.3297]},{"Plant":"RS Cogen","State":"LA","Gas":415.4,"coordinates":[-93.2992,30.221]},{"Plant":"SRW Cogen LP","State":"TX","Gas":420,"coordinates":[-93.7574,30.0545]},{"Plant":"Magic Valley Generating Station","State":"TX","Gas":682,"coordinates":[-98.19,26.3403]},{"Plant":"Griffith Energy LLC","State":"AZ","Gas":570,"coordinates":[-114.1333,35.054]},{"Plant":"Milford Power Project","State":"CT","Gas":506.7,"coordinates":[-73.0997,41.2244]},{"Plant":"Manchief Electric Generating Station","State":"CO","Gas":264,"coordinates":[-103.685,40.2171]},{"Plant":"Walton County Power LLC","State":"GA","Gas":465.2,"coordinates":[-83.6954,33.8148]},{"Plant":"Desert Basin","State":"AZ","Gas":577,"coordinates":[-111.7889,32.9042]},{"Plant":"Kendall County Generation Facility","State":"IL","Gas":1140,"coordinates":[-88.2581,41.4797]},{"Plant":"Tenaska Gateway Generating Station","State":"TX","Gas":845,"coordinates":[-94.6197,32.0178]},{"Plant":"Alliant Energy Neenah","State":"WI","Gas":309.2,"coordinates":[-88.5064,44.1936]},{"Plant":"Rio Nogales Power Project","State":"TX","Gas":755,"coordinates":[-97.9732,29.5931]},{"Plant":"Wolf Hollow I LP","State":"TX","Gas":695.5,"coordinates":[-97.7317,32.3342]},{"Plant":"Hawk Road Facility","State":"GA","Gas":498.5,"coordinates":[-84.9914,33.3585]},{"Plant":"Hays Energy Project","State":"TX","Gas":881,"coordinates":[-97.9894,29.7806]},{"Plant":"Green Country Energy LLC","State":"OK","Gas":783,"coordinates":[-95.9346,35.9833]},{"Plant":"Worthington Generation LLC","State":"IN","Gas":179.2,"coordinates":[-87.0128,39.0708]},{"Plant":"Lake Road Generating Plant","State":"CT","Gas":745.2,"coordinates":[-71.8958,41.872]},{"Plant":"La Paloma Generating LLC","State":"CA","Gas":965.4,"coordinates":[-119.5919,35.2956]},{"Plant":"Guadalupe Generating Station","State":"TX","Gas":995,"coordinates":[-98.1419,29.6244]},{"Plant":"Lost Pines 1 Power Project","State":"TX","Gas":516,"coordinates":[-97.2714,30.1478]},{"Plant":"Bluegrass Generating Station","State":"KY","Gas":495,"coordinates":[-85.4133,38.3902]},{"Plant":"Calcasieu","State":"LA","Gas":310,"coordinates":[-93.345,30.1608]},{"Plant":"Broad River Energy Center","State":"SC","Gas":837,"coordinates":[-81.575,35.0786]},{"Plant":"Bastrop Energy Center","State":"TX","Gas":552,"coordinates":[-97.55,30.1458]},{"Plant":"Granite Ridge","State":"NH","Gas":678,"coordinates":[-71.4261,42.9042]},{"Plant":"Bosque County Peaking","State":"TX","Gas":748,"coordinates":[-97.3586,31.8594]},{"Plant":"Acadia Energy Center","State":"LA","Gas":1063,"coordinates":[-92.4131,30.4286]},{"Plant":"Eastman Cogeneration Facility","State":"TX","Gas":402.2,"coordinates":[-94.6903,32.4481]},{"Plant":"South Point Energy Center","State":"AZ","Gas":550,"coordinates":[-114.5317,34.8678]},{"Plant":"Dogwood Energy Facility","State":"MO","Gas":614.3,"coordinates":[-94.3006,38.7931]},{"Plant":"Rathdrum Power LLC","State":"ID","Gas":248,"coordinates":[-116.9203,47.7858]},{"Plant":"Sunrise Power LLC","State":"CA","Gas":545,"coordinates":[-119.585,35.2097]},{"Plant":"Channelview Cogeneration Plant","State":"TX","Gas":779,"coordinates":[-95.1217,29.837]},{"Plant":"Cordova Energy","State":"IL","Gas":521.2,"coordinates":[-90.2797,41.7122]},{"Plant":"Osceola","State":"FL","Gas":468,"coordinates":[-81.0978,28.1289]},{"Plant":"Ontelaunee Energy Center","State":"PA","Gas":516,"coordinates":[-75.9356,40.4219]},{"Plant":"Caledonia","State":"MS","Gas":765,"coordinates":[-88.2717,33.6464]},{"Plant":"Riverside Generating LLC","State":"KY","Gas":825,"coordinates":[-82.6046,38.1917]},{"Plant":"Elwood Energy LLC","State":"IL","Gas":1350,"coordinates":[-88.1236,41.4388]},{"Plant":"Arapahoe Combustion Turbine Project","State":"CO","Gas":122.5,"coordinates":[-105.0018,39.6692]},{"Plant":"Gibson City","State":"IL","Gas":228,"coordinates":[-88.3987,40.4705]},{"Plant":"Pinckneyville","State":"IL","Gas":316,"coordinates":[-89.3467,38.1114]},{"Plant":"Kinmundy","State":"IL","Gas":208,"coordinates":[-89.0128,38.7619]},{"Plant":"Corpus Christi Energy Center","State":"TX","Gas":280,"coordinates":[-97.4283,27.8139]},{"Plant":"Afton Generating Station","State":"NM","Gas":235.6,"coordinates":[-106.8465,32.1142]},{"Plant":"ANP Bellingham Energy Project","State":"MA","Gas":475,"coordinates":[-71.4535,42.1106]},{"Plant":"ANP Blackstone Energy Project","State":"MA","Gas":437.1,"coordinates":[-71.5158,42.0599]},{"Plant":"Odessa Ector Generating Station","State":"TX","Gas":1030,"coordinates":[-102.3264,31.8403]},{"Plant":"Morris Cogeneration LLC","State":"IL","Gas":176,"coordinates":[-88.3328,41.4119]},{"Plant":"Los Medanos Energy Center","State":"CA","Gas":567,"coordinates":[-121.873,38.0301]},{"Plant":"Hinds Energy Facility","State":"MS","Gas":450,"coordinates":[-90.2199,32.379]},{"Plant":"Attala","State":"MS","Gas":455,"coordinates":[-89.6753,33.0147]},{"Plant":"Harry L. Oswald","State":"AR","Gas":548,"coordinates":[-92.2166,34.5923]},{"Plant":"Lincoln Generating Facility","State":"IL","Gas":625.1,"coordinates":[-87.9436,41.3933]},{"Plant":"Ennis Power Company LLC","State":"TX","Gas":359.5,"coordinates":[-96.675,32.32]},{"Plant":"Wheatland Generating Facility","State":"IN","Gas":472,"coordinates":[-87.2931,38.6716]},{"Plant":"Oneta Energy Center","State":"OK","Gas":1086.4,"coordinates":[-95.6967,36.0119]},{"Plant":"Freestone Energy Center","State":"TX","Gas":984,"coordinates":[-96.1131,31.8907]},{"Plant":"Greenville Electric Generating Station","State":"OH","Gas":199.5,"coordinates":[-84.6151,40.0758]},{"Plant":"Montpelier Electric Generating Station","State":"IN","Gas":180,"coordinates":[-85.3057,40.6206]},{"Plant":"Jack County","State":"TX","Gas":620.5,"coordinates":[-97.9574,33.101]},{"Plant":"Liberty Electric Power Plant","State":"PA","Gas":541,"coordinates":[-75.3358,39.8614]},{"Plant":"Marshall Energy Facility","State":"KY","Gas":620.8,"coordinates":[-88.3958,37.0286]},{"Plant":"Handsome Lake Energy LLC","State":"PA","Gas":267.5,"coordinates":[-79.8061,41.2908]},{"Plant":"Audrain Generating Station","State":"MO","Gas":608,"coordinates":[-91.5369,39.3092]},{"Plant":"Lee Energy Facility","State":"IL","Gas":568,"coordinates":[-89.4054,41.8287]},{"Plant":"Energy Shelby County","State":"IL","Gas":371.6,"coordinates":[-88.4772,39.2794]},{"Plant":"NRG Rockford I","State":"IL","Gas":303.6,"coordinates":[-89.1012,42.2386]},{"Plant":"Red Oak Power LLC","State":"NJ","Gas":765.9,"coordinates":[-74.3489,40.4487]},{"Plant":"Hog Bayou Energy Center","State":"AL","Gas":230,"coordinates":[-88.0575,30.7478]},{"Plant":"Santa Rosa Energy Center","State":"FL","Gas":235.9,"coordinates":[-87.115,30.5664]},{"Plant":"Astoria Gas Turbines","State":"NY","Gas":420,"coordinates":[-73.9048,40.787]},{"Plant":"Doyle Energy Facility","State":"GA","Gas":326.9,"coordinates":[-83.6996,33.8377]},{"Plant":"Darby Electric Generating Station","State":"OH","Gas":435,"coordinates":[-83.1778,39.7139]},{"Plant":"Tait Electric Generating Station","State":"OH","Gas":340,"coordinates":[-84.2095,39.7277]},{"Plant":"University Park South","State":"IL","Gas":300,"coordinates":[-87.7532,41.4409]},{"Plant":"Gleason Generating Facility","State":"TN","Gas":495,"coordinates":[-88.612,36.2454]},{"Plant":"Crete Energy Venture LLC","State":"IL","Gas":300,"coordinates":[-87.6187,41.4294]},{"Plant":"Whiting Clean Energy","State":"IN","Gas":513,"coordinates":[-87.4775,41.6739]},{"Plant":"Edward L. Addison Generating Plant","State":"GA","Gas":598.8,"coordinates":[-84.3064,32.9111]},{"Plant":"TVA Southaven Combined Cycle","State":"MS","Gas":774,"coordinates":[-90.0378,34.9939]},{"Plant":"Jackson Generating Station","State":"MI","Gas":564,"coordinates":[-84.3767,42.2488]},{"Plant":"Tenaska Lindsay Hill Generating Station","State":"AL","Gas":845,"coordinates":[-86.7386,32.6514]},{"Plant":"Ceredo Generating Station","State":"WV","Gas":450,"coordinates":[-82.5339,38.3681]},{"Plant":"Aurora","State":"IL","Gas":878,"coordinates":[-88.2265,41.8151]},{"Plant":"Southeast Chicago Energy Project","State":"IL","Gas":296,"coordinates":[-87.5449,41.7181]},{"Plant":"Arlington Valley Energy Facility","State":"AZ","Gas":579,"coordinates":[-112.8897,33.3417]},{"Plant":"Front Range Power Plant","State":"CO","Gas":461.5,"coordinates":[-104.7069,38.6281]},{"Plant":"Big Sandy Peaker Plant","State":"WV","Gas":300,"coordinates":[-82.5938,38.3441]},{"Plant":"Wolf Hills Energy","State":"VA","Gas":250,"coordinates":[-82.1044,36.6644]},{"Plant":"Oleander Power Project LP","State":"FL","Gas":315.9,"coordinates":[-80.7947,28.3661]},{"Plant":"Decatur Energy Center","State":"AL","Gas":624,"coordinates":[-87.0214,34.6292]},{"Plant":"Morgan Energy Center","State":"AL","Gas":749,"coordinates":[-87.0639,34.6397]},{"Plant":"Westbrook Energy Center Power Plant","State":"ME","Gas":506,"coordinates":[-70.375,43.6575]},{"Plant":"Blythe Energy Inc","State":"CA","Gas":514,"coordinates":[-114.6865,33.6157]},{"Plant":"Calumet Energy Team LLC","State":"IL","Gas":321.2,"coordinates":[-87.5563,41.6835]},{"Plant":"New Covert Generating Facility","State":"MI","Gas":1040.1,"coordinates":[-86.2937,42.3224]},{"Plant":"Fairless Energy Center","State":"PA","Gas":1209.2,"coordinates":[-74.7411,40.1475]},{"Plant":"Channel Energy Center LLC","State":"TX","Gas":585,"coordinates":[-95.2319,29.7189]},{"Plant":"Baconton Power Plant","State":"GA","Gas":195.2,"coordinates":[-84.08,31.3869]},{"Plant":"Gila River Power Station","State":"AZ","Gas":2060,"coordinates":[-112.6944,32.975]},{"Plant":"Air Products Port Arthur","State":"TX","Gas":129.1,"coordinates":[-93.9651,29.8665]},{"Plant":"Ingleside Cogeneration","State":"TX","Gas":460,"coordinates":[-97.2428,27.8828]},{"Plant":"Fore River Generating Station","State":"MA","Gas":688.4,"coordinates":[-70.9661,42.2422]},{"Plant":"Wise County Power LLC","State":"TX","Gas":655,"coordinates":[-97.9103,33.0583]},{"Plant":"Chuck Lenzie Generating Station","State":"NV","Gas":1128,"coordinates":[-114.9218,36.3837]},{"Plant":"Baytown Energy Center","State":"TX","Gas":770,"coordinates":[-94.9019,29.7731]},{"Plant":"Hermiston Power Partnership","State":"OR","Gas":615,"coordinates":[-119.3133,45.794]},{"Plant":"Washington County","State":"GA","Gas":627.3,"coordinates":[-82.98,33.0922]},{"Plant":"Delta Energy Center","State":"CA","Gas":769.1,"coordinates":[-121.8439,38.0169]},{"Plant":"Holland Energy Facility","State":"IL","Gas":643,"coordinates":[-88.7584,39.2231]},{"Plant":"PPL Ironwood LLC","State":"PA","Gas":669,"coordinates":[-76.3658,40.3509]},{"Plant":"Dell Power Station","State":"AR","Gas":679,"coordinates":[-90.0253,35.8619]},{"Plant":"Luna Energy Facility","State":"NM","Gas":559,"coordinates":[-107.7834,32.2993]},{"Plant":"Otay Mesa Generating Project","State":"CA","Gas":571,"coordinates":[-116.915,32.5815]},{"Plant":"Armstrong","State":"PA","Gas":584,"coordinates":[-79.3517,40.638]},{"Plant":"Troy Energy LLC","State":"OH","Gas":584,"coordinates":[-83.4598,41.4772]},{"Plant":"Pleasants Energy LLC","State":"WV","Gas":305.7,"coordinates":[-81.3642,39.3325]},{"Plant":"Brazos Valley Generating Facility","State":"TX","Gas":525,"coordinates":[-95.6244,29.4731]},{"Plant":"Cottonwood Energy Project","State":"TX","Gas":1233.6,"coordinates":[-93.7353,30.2588]},{"Plant":"Sugar Creek Power","State":"IN","Gas":520.7,"coordinates":[-87.5108,39.3931]},{"Plant":"Exelon LaPorte Generating Station","State":"TX","Gas":153.2,"coordinates":[-95.0718,29.7028]},{"Plant":"Harquahala Generating Project","State":"AZ","Gas":1054.4,"coordinates":[-113.1134,33.476]},{"Plant":"Astoria Energy","State":"NY","Gas":561,"coordinates":[-73.8964,40.7825]},{"Plant":"Union Power Partners LP","State":"AR","Gas":2020,"coordinates":[-92.5894,33.2961]},{"Plant":"Thomas A Smith Energy Facility","State":"GA","Gas":1250,"coordinates":[-84.9175,34.7094]},{"Plant":"Columbia Energy Center","State":"SC","Gas":415.7,"coordinates":[-81.0178,33.8697]},{"Plant":"RockGen Energy Center","State":"WI","Gas":471,"coordinates":[-89.0492,42.9767]},{"Plant":"Zion Energy Center","State":"IL","Gas":456,"coordinates":[-87.895,42.4776]},{"Plant":"Metcalf Energy Center","State":"CA","Gas":546.1,"coordinates":[-121.7457,37.2207]},{"Plant":"Crossroads Energy Center","State":"MS","Gas":308,"coordinates":[-90.5621,34.183]},{"Plant":"Washington Energy Facility","State":"OH","Gas":600,"coordinates":[-81.6564,39.58]},{"Plant":"Elk Hills Power LLC","State":"CA","Gas":525,"coordinates":[-119.4707,35.2803]},{"Plant":"Rolling Hills Generating","State":"OH","Gas":825,"coordinates":[-82.3328,39.0839]},{"Plant":"Renaissance Power LLC","State":"MI","Gas":660,"coordinates":[-84.8429,43.1864]},{"Plant":"Carville Energy LLC","State":"LA","Gas":473,"coordinates":[-91.065,30.2294]},{"Plant":"Athens Generating Plant","State":"NY","Gas":1137.9,"coordinates":[-73.8492,42.2728]},{"Plant":"Effingham County Power Project","State":"GA","Gas":463.4,"coordinates":[-81.2844,32.2773]},{"Plant":"Calhoun Energy Center","State":"AL","Gas":596,"coordinates":[-85.9731,33.5883]},{"Plant":"Hillabee Energy Center","State":"AL","Gas":695.4,"coordinates":[-85.9033,33.0007]},{"Plant":"Osprey Energy Center Power Plant","State":"FL","Gas":590,"coordinates":[-81.8083,28.0525]},{"Plant":"Shady Hills Generating Station","State":"FL","Gas":468,"coordinates":[-82.5586,28.3665]},{"Plant":"Vandolah Power Station","State":"FL","Gas":632,"coordinates":[-81.924,27.5236]},{"Plant":"Raccoon Creek Energy Center","State":"IL","Gas":304,"coordinates":[-88.5392,38.6996]},{"Plant":"Hot Spring Generating Facility","State":"AR","Gas":630,"coordinates":[-92.8683,34.2976]},{"Plant":"Plaquemine Cogeneration Plant","State":"LA","Gas":793,"coordinates":[-91.2347,30.3217]},{"Plant":"DeSoto County Plant","State":"FL","Gas":320,"coordinates":[-81.8092,27.2272]},{"Plant":"Bayou Cove Peaking Power","State":"LA","Gas":300,"coordinates":[-92.5997,30.2825]},{"Plant":"Elgin Energy Center","State":"IL","Gas":460,"coordinates":[-88.2446,42.0001]},{"Plant":"Tenaska Virginia Generating Station","State":"VA","Gas":926.8,"coordinates":[-78.3813,37.8667]},{"Plant":"Tenaska Central Alabama Generating Stn","State":"AL","Gas":915.8,"coordinates":[-86.74,32.6497]},{"Plant":"Columbia Energy Center","State":"MO","Gas":140,"coordinates":[-92.2629,39.0192]},{"Plant":"Magnolia Power Plant","State":"MS","Gas":863.1,"coordinates":[-89.2026,34.835]},{"Plant":"Fountain Valley Power Facility","State":"CO","Gas":234,"coordinates":[-104.6875,38.5569]},{"Plant":"Red Hawk","State":"AZ","Gas":934,"coordinates":[-112.8406,33.3346]},{"Plant":"McClain Energy Facility","State":"OK","Gas":450.1,"coordinates":[-97.5898,35.2977]},{"Plant":"Redbud Power Plant","State":"OK","Gas":1160.2,"coordinates":[-97.2264,35.6856]},{"Plant":"Deer Park Energy Center","State":"TX","Gas":922.2,"coordinates":[-95.1345,29.7134]},{"Plant":"Ouachita","State":"LA","Gas":771,"coordinates":[-92.0683,32.7061]},{"Plant":"Green Power 2","State":"TX","Gas":825.5,"coordinates":[-94.9328,29.3781]},{"Plant":"Forney Energy Center","State":"TX","Gas":1640,"coordinates":[-96.4916,32.7563]},{"Plant":"Mesquite Generating Station","State":"AZ","Gas":1073.3,"coordinates":[-112.8642,33.345]},{"Plant":"Goldendale Generating Station","State":"WA","Gas":256.7,"coordinates":[-120.833,45.8114]},{"Plant":"Tri Center Naniwa Energy","State":"NV","Gas":200,"coordinates":[-119.5178,39.5572]},{"Plant":"Goose Creek Energy Center","State":"IL","Gas":438,"coordinates":[-88.5999,40.1069]},{"Plant":"Kiamichi Energy Facility","State":"OK","Gas":1178.4,"coordinates":[-95.9349,34.6831]},{"Plant":"Lawrenceburg Energy Facility","State":"IN","Gas":1080,"coordinates":[-84.8669,39.0911]},{"Plant":"AEP Waterford Facility","State":"OH","Gas":810,"coordinates":[-81.7178,39.5333]},{"Plant":"Limon Generating Station","State":"CO","Gas":134,"coordinates":[-103.7005,39.2038]},{"Plant":"Frank Knutson","State":"CO","Gas":134,"coordinates":[-104.682,39.9411]},{"Plant":"Apex Generating Station","State":"NV","Gas":494.4,"coordinates":[-114.9609,36.416]},{"Plant":"Fayette Energy Facility","State":"PA","Gas":600.5,"coordinates":[-79.9182,39.8592]},{"Plant":"Wallingford Energy","State":"CT","Gas":190,"coordinates":[-72.8354,41.4487]},{"Plant":"High Desert Power Plant","State":"CA","Gas":468.6,"coordinates":[-117.3647,34.5953]},{"Plant":"Sundance","State":"AZ","Gas":410,"coordinates":[-111.5899,32.9285]},{"Plant":"Indigo Energy Facility","State":"CA","Gas":149.7,"coordinates":[-116.553,33.9109]},{"Plant":"Hidalgo Energy Center","State":"TX","Gas":470,"coordinates":[-98.1758,26.3417]},{"Plant":"Perryville Power Station","State":"LA","Gas":691,"coordinates":[-92.0183,32.6908]},{"Plant":"West Valley Generation Project","State":"UT","Gas":189,"coordinates":[-112.0317,40.6667]},{"Plant":"University Park North","State":"IL","Gas":504,"coordinates":[-87.7514,41.4425]},{"Plant":"Riverside Energy Center","State":"WI","Gas":598.3,"coordinates":[-89.0355,42.5827]},{"Plant":"Blue Spruce Energy Center","State":"CO","Gas":278,"coordinates":[-104.6814,39.7479]},{"Plant":"Plains End","State":"CO","Gas":114,"coordinates":[-105.226,39.8575]},{"Plant":"Spring Creek Energy Center","State":"OK","Gas":278,"coordinates":[-97.655,35.7422]},{"Plant":"Pastoria Energy Facility, LLC","State":"CA","Gas":724,"coordinates":[-118.844,34.9556]},{"Plant":"EP Newington Energy LLC","State":"NH","Gas":525,"coordinates":[-70.8061,43.1047]},{"Plant":"Chehalis Generating Facility","State":"WA","Gas":509,"coordinates":[-122.9131,46.6225]},{"Plant":"Harrison County Power Project","State":"TX","Gas":514.4,"coordinates":[-94.4367,32.3958]},{"Plant":"Lower Mount Bethel Energy","State":"PA","Gas":593.8,"coordinates":[-75.1076,40.8019]},{"Plant":"AL Sandersville LLC","State":"GA","Gas":596.8,"coordinates":[-82.8608,33.1189]},{"Plant":"Higgins Generating Station","State":"NV","Gas":570,"coordinates":[-115.3561,35.6139]},{"Plant":"Bethlehem Power Plant","State":"PA","Gas":1130,"coordinates":[-75.3147,40.6175]},{"Plant":"Quantum Choctaw Power LLC","State":"MS","Gas":690,"coordinates":[-89.2089,33.3792]},{"Plant":"Mint Farm Generating Station","State":"WA","Gas":275.9,"coordinates":[-122.9855,46.1388]},{"Plant":"Choctaw County","State":"MS","Gas":848,"coordinates":[-89.4201,33.2881]},{"Plant":"Allegheny Energy Units 3 4 & 5","State":"PA","Gas":509,"coordinates":[-79.7686,40.5453]},{"Plant":"Magnet Cove","State":"AR","Gas":641.5,"coordinates":[-92.8317,34.4297]},{"Plant":"Dean","State":"MI","Gas":295.4,"coordinates":[-82.4953,42.7725]},{"Plant":"Bennett Mountain","State":"ID","Gas":164,"coordinates":[-115.6666,43.1472]},{"Plant":"Hanging Rock Energy Facility","State":"OH","Gas":1288,"coordinates":[-82.7833,38.5731]},{"Plant":"Los Esteros Critical Energy Center","State":"CA","Gas":180,"coordinates":[-121.9319,37.425]},{"Plant":"FPL Energy Marcus Hook LP","State":"PA","Gas":717.5,"coordinates":[-75.4216,39.807]},{"Plant":"Valencia Energy Facility","State":"NM","Gas":144.3,"coordinates":[-106.7322,34.6115]},{"Plant":"Gilroy Peaking Energy Center","State":"CA","Gas":135,"coordinates":[-121.5363,36.999]},{"Plant":"Frederickson Power LP","State":"WA","Gas":242,"coordinates":[-122.3657,47.0861]},{"Plant":"Curtis H Stanton Energy Center","State":"FL","Gas":656.9,"coordinates":[-81.1669,28.4882]},{"Plant":"Auburndale Peaker Energy Center","State":"FL","Gas":122,"coordinates":[-81.8059,28.0535]},{"Plant":"Rocky Mountain Energy Center","State":"CO","Gas":601,"coordinates":[-104.5953,40.0908]},{"Plant":"Silverhawk","State":"NV","Gas":560,"coordinates":[-114.9606,36.4078]},{"Plant":"Inland Empire Energy Center","State":"CA","Gas":690,"coordinates":[-117.1704,33.7388]},{"Plant":"Jasper","State":"SC","Gas":852,"coordinates":[-81.1242,32.3594]},{"Plant":"Tracy Combined Cycle Power Plant","State":"CA","Gas":168.3,"coordinates":[-121.4906,37.7107]},{"Plant":"NRG Rockford II Energy Center","State":"IL","Gas":154.1,"coordinates":[-89.1011,42.2383]},{"Plant":"NAEA Ocean Peaking Power LLC","State":"NJ","Gas":325.6,"coordinates":[-74.1672,40.0633]},{"Plant":"Las Vegas Cogeneration II LLC","State":"NV","Gas":220,"coordinates":[-115.1238,36.232]},{"Plant":"Wansley Combined Cycle","State":"GA","Gas":1143.1,"coordinates":[-85.037,33.4064]},{"Plant":"Cosumnes","State":"CA","Gas":477,"coordinates":[-121.124,38.3385]},{"Plant":"Cass County","State":"NE","Gas":322,"coordinates":[-95.964,40.9479]},{"Plant":"Hunterstown","State":"PA","Gas":810,"coordinates":[-77.1672,39.8725]},{"Plant":"Palomar Energy","State":"CA","Gas":562,"coordinates":[-117.1178,33.1197]},{"Plant":"Exira","State":"IA","Gas":137.3,"coordinates":[-94.9197,41.5144]},{"Plant":"Donald Von Raesfeld Power Plant","State":"CA","Gas":154,"coordinates":[-121.9508,37.3767]},{"Plant":"Fox Energy Center","State":"WI","Gas":548,"coordinates":[-88.2089,44.3204]},{"Plant":"Malburg","State":"CA","Gas":143,"coordinates":[-118.2219,33.9986]},{"Plant":"Magnolia Power Project","State":"CA","Gas":301,"coordinates":[-118.3153,34.1786]},{"Plant":"Walnut Energy Center","State":"CA","Gas":269,"coordinates":[-120.8956,37.4878]},{"Plant":"Currant Creek","State":"UT","Gas":540,"coordinates":[-111.8935,39.8214]},{"Plant":"Mankato Energy Center","State":"MN","Gas":300,"coordinates":[-94.003,44.1988]},{"Plant":"McIntosh Combined Cycle Facility","State":"GA","Gas":1256.8,"coordinates":[-81.1817,32.3478]},{"Plant":"South Harper","State":"MO","Gas":296.6,"coordinates":[-94.4824,38.6803]},{"Plant":"Freeport Energy Center","State":"TX","Gas":249.4,"coordinates":[-95.3954,28.9888]},{"Plant":"Faribault Energy Park","State":"MN","Gas":261,"coordinates":[-93.2906,44.3356]},{"Plant":"Sheboygan Falls","State":"WI","Gas":296.4,"coordinates":[-87.8781,43.7518]},{"Plant":"Nebo Power Station","State":"UT","Gas":130,"coordinates":[-111.7294,40.0614]},{"Plant":"500MW CC","State":"NY","Gas":454.1,"coordinates":[-73.9069,40.7889]},{"Plant":"Port Westward","State":"OR","Gas":372,"coordinates":[-123.172,46.1789]},{"Plant":"EG178 Facility","State":"TX","Gas":108,"coordinates":[-100.9547,32.7471]},{"Plant":"Caithness Long Island Energy Center","State":"NY","Gas":307,"coordinates":[-72.9403,40.8142]},{"Plant":"Lake Side Power Plant","State":"UT","Gas":557,"coordinates":[-111.7542,40.3317]},{"Plant":"Groton Generating Station","State":"SD","Gas":169,"coordinates":[-98.0987,45.3735]},{"Plant":"Kings River","State":"CA","Gas":109,"coordinates":[-119.7404,36.6697]},{"Plant":"Cannon Falls Energy Center","State":"MN","Gas":398,"coordinates":[-92.9155,44.5367]},{"Plant":"Anson County Generation Facility","State":"NC","Gas":339,"coordinates":[-79.9217,34.9687]},{"Plant":"Empire Generating Co  LLC","State":"NY","Gas":580,"coordinates":[-73.75,42.6252]},{"Plant":"Hamlet Generating Facility","State":"NC","Gas":282.5,"coordinates":[-79.7361,34.8423]},{"Plant":"Roseville Energy Park","State":"CA","Gas":141,"coordinates":[-121.3811,38.7928]},{"Plant":"Mustang Station Unit 4","State":"TX","Gas":290,"coordinates":[-102.7436,32.9746]},{"Plant":"Harry D Mattison Gas Plant","State":"AR","Gas":294,"coordinates":[-94.2841,36.1855]},{"Plant":"Quail Run Energy Center","State":"TX","Gas":482,"coordinates":[-102.315,31.8414]},{"Plant":"Colorado Bend Energy Center","State":"TX","Gas":510,"coordinates":[-96.0683,29.2878]},{"Plant":"Stanton Energy Center","State":"FL","Gas":295,"coordinates":[-81.1678,28.4822]},{"Plant":"Treasure Coast Energy Center","State":"FL","Gas":318,"coordinates":[-80.3775,27.3839]},{"Plant":"West County Energy Center","State":"FL","Gas":2438,"coordinates":[-80.3747,26.6986]},{"Plant":"Spindle Hill Energy Center","State":"CO","Gas":270,"coordinates":[-104.8878,40.0922]},{"Plant":"Hobbs Generating Station","State":"NM","Gas":526,"coordinates":[-103.3094,32.7283]},{"Plant":"Gateway Generating Station","State":"CA","Gas":563.4,"coordinates":[-121.7587,38.0175]},{"Plant":"Western 102 Power Plant","State":"NV","Gas":110.6,"coordinates":[-119.5108,39.5603]},{"Plant":"Emporia Energy Center","State":"KS","Gas":663,"coordinates":[-96.0652,38.4459]},{"Plant":"Jonesboro City Water & Light Plant","State":"AR","Gas":177,"coordinates":[-90.7254,35.8486]},{"Plant":"Plains End II LLC","State":"CO","Gas":116.2,"coordinates":[-105.2256,39.8586]},{"Plant":"Colusa Generating Station","State":"CA","Gas":640,"coordinates":[-122.27,39.3661]},{"Plant":"PPS Power Plant No 1","State":"KY","Gas":110,"coordinates":[-88.6159,37.0339]},{"Plant":"J Lamar Stall Unit","State":"LA","Gas":507,"coordinates":[-93.7601,32.5195]},{"Plant":"San Jacinto County Peaking Facility","State":"TX","Gas":146,"coordinates":[-95.0118,30.4193]},{"Plant":"Hardin County Peaking Facility","State":"TX","Gas":146,"coordinates":[-94.2526,30.3038]},{"Plant":"Midway Peaking LLC","State":"CA","Gas":103,"coordinates":[-120.5797,36.6541]},{"Plant":"Winchester Power Park","State":"TX","Gas":179.2,"coordinates":[-96.9875,30.0381]},{"Plant":"Panoche Energy Center","State":"CA","Gas":388,"coordinates":[-120.5833,36.6514]},{"Plant":"Cedar Bayou 4","State":"TX","Gas":330,"coordinates":[-94.9231,29.7516]},{"Plant":"McKee Run","State":"DE","Gas":136,"coordinates":[-75.5466,39.1762]},{"Plant":"Belle River","State":"MI","Gas":222,"coordinates":[-82.495,42.7756]},{"Plant":"Greenwood","State":"MI","Gas":997,"coordinates":[-82.6964,43.1056]},{"Plant":"Manatee","State":"FL","Gas":1111,"coordinates":[-82.3456,27.6058]},{"Plant":"Martin","State":"FL","Gas":2043,"coordinates":[-80.5628,27.0536]},{"Plant":"DeBary","State":"FL","Gas":247,"coordinates":[-81.3323,28.9039]},{"Plant":"Electrifarm","State":"IA","Gas":198.5,"coordinates":[-92.4205,42.4407]},{"Plant":"Fredonia","State":"WA","Gas":280,"coordinates":[-122.4358,48.4558]},{"Plant":"Trimble County","State":"KY","Gas":960,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Gas":972,"coordinates":[-88.5553,30.5322]},{"Plant":"Greenwood","State":"MO","Gas":244.5,"coordinates":[-94.2982,38.8615]},{"Plant":"R M Schahfer","State":"IN","Gas":155,"coordinates":[-87.0261,41.2164]},{"Plant":"Cutler","State":"FL","Gas":205,"coordinates":[-80.2989,25.6321]},{"Plant":"Fort St Vrain","State":"CO","Gas":969,"coordinates":[-104.8742,40.2461]},{"Plant":"Fort Myers","State":"FL","Gas":1755,"coordinates":[-81.7831,26.6967]},{"Plant":"Whitehorn","State":"WA","Gas":134,"coordinates":[-122.6861,48.8288]},{"Plant":"McIntosh","State":"GA","Gas":657.6,"coordinates":[-81.1683,32.3563]},{"Plant":"Lauderdale","State":"FL","Gas":1724,"coordinates":[-80.1984,26.0686]},{"Plant":"A B Brown","State":"IN","Gas":160,"coordinates":[-87.715,37.9053]},{"Plant":"Port Everglades","State":"FL","Gas":420,"coordinates":[-80.1253,26.0856]},{"Plant":"Brame Energy Center","State":"LA","Gas":422,"coordinates":[-92.7167,31.395]},{"Plant":"John Twitty Energy Center","State":"MO","Gas":104,"coordinates":[-93.388,37.1517]},{"Plant":"Sanford","State":"FL","Gas":1912,"coordinates":[-81.3256,28.8419]},{"Plant":"Turkey Point","State":"FL","Gas":1148,"coordinates":[-80.3308,25.4356]},{"Plant":"Empire Energy Center","State":"MO","Gas":267,"coordinates":[-94.1041,37.1385]},{"Plant":"Dansby","State":"TX","Gas":204.2,"coordinates":[-96.4608,30.7217]},{"Plant":"Putnam","State":"FL","Gas":498,"coordinates":[-81.5851,29.6283]},{"Plant":"Higgins","State":"FL","Gas":113,"coordinates":[-82.6615,28.0033]},{"Plant":"P L Bartow","State":"FL","Gas":1225,"coordinates":[-82.6018,27.8595]},{"Plant":"Rokeby","State":"NE","Gas":234.3,"coordinates":[-96.7364,40.7316]},{"Plant":"Suwannee River","State":"FL","Gas":103,"coordinates":[-83.1806,30.3764]},{"Plant":"Lansing Smith","State":"FL","Gas":481,"coordinates":[-85.7003,30.2686]},{"Plant":"D G Hunter","State":"LA","Gas":130,"coordinates":[-92.4613,31.3207]},{"Plant":"George M Sullivan Generation Plant 2","State":"AK","Gas":219.9,"coordinates":[-149.7167,61.2297]},{"Plant":"Deerhaven Generating Station","State":"FL","Gas":193,"coordinates":[-82.3878,29.7592]},{"Plant":"John R Kelly","State":"FL","Gas":177.2,"coordinates":[-82.3208,29.6461]},{"Plant":"J D Kennedy","State":"FL","Gas":317.2,"coordinates":[-81.626,30.3648]},{"Plant":"Northside Generating Station","State":"FL","Gas":505,"coordinates":[-81.5525,30.4172]},{"Plant":"C D McIntosh Jr","State":"FL","Gas":414,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Gas":388,"coordinates":[-105.0212,40.8609]},{"Plant":"Indian River Plant","State":"FL","Gas":290,"coordinates":[-80.7801,28.4932]},{"Plant":"Arvah B Hopkins","State":"FL","Gas":504,"coordinates":[-84.4,30.4522]},{"Plant":"S O Purdom","State":"FL","Gas":290,"coordinates":[-84.2007,30.1623]},{"Plant":"Vero Beach Municipal Power Plant","State":"FL","Gas":150,"coordinates":[-80.3776,27.6334]},{"Plant":"Gravel Neck","State":"VA","Gas":340,"coordinates":[-76.6911,37.1575]},{"Plant":"McIntosh","State":"AL","Gas":678,"coordinates":[-88.0299,31.2546]},{"Plant":"Harry Allen","State":"NV","Gas":144,"coordinates":[-114.9024,36.4306]},{"Plant":"Pleasant Hill","State":"IA","Gas":164.2,"coordinates":[-93.5242,41.5572]},{"Plant":"Hay Road","State":"DE","Gas":1130,"coordinates":[-75.5072,39.7436]},{"Plant":"Woodsdale","State":"OH","Gas":462,"coordinates":[-84.4611,39.4492]},{"Plant":"Concord","State":"WI","Gas":352,"coordinates":[-88.69,43.1669]},{"Plant":"South Fond Du Lac","State":"WI","Gas":316.3,"coordinates":[-88.4967,43.7353]},{"Plant":"Darbytown","State":"VA","Gas":336,"coordinates":[-77.3685,37.4982]},{"Plant":"Angus Anson","State":"SD","Gas":338,"coordinates":[-96.6356,43.6035]},{"Plant":"Cane Island","State":"FL","Gas":380,"coordinates":[-81.533,28.2764]},{"Plant":"Polk","State":"FL","Gas":604,"coordinates":[-81.9897,27.7286]},{"Plant":"Woodland","State":"CA","Gas":133,"coordinates":[-121.0204,37.6526]},{"Plant":"491 E 48th Street","State":"MI","Gas":136,"coordinates":[-86.0853,42.7553]},{"Plant":"Paris","State":"WI","Gas":352,"coordinates":[-88.0131,42.6658]},{"Plant":"Lincoln Combustion","State":"NC","Gas":1267.2,"coordinates":[-81.0347,35.4317]},{"Plant":"State Line Combined Cycle","State":"MO","Gas":596,"coordinates":[-94.614,37.0659]},{"Plant":"Hines Energy Complex","State":"FL","Gas":1912,"coordinates":[-81.87,27.7882]},{"Plant":"Redding Power","State":"CA","Gas":128,"coordinates":[-122.4233,40.5073]},{"Plant":"San Jacinto Steam Electric Station","State":"TX","Gas":162,"coordinates":[-95.0406,29.6948]},{"Plant":"Kraft","State":"GA","Gas":132,"coordinates":[-81.1458,32.1486]},{"Plant":"Anderson","State":"IN","Gas":140,"coordinates":[-85.7389,40.0529]},{"Plant":"Robins","State":"GA","Gas":160,"coordinates":[-83.5822,32.5792]},{"Plant":"Coyote Springs","State":"OR","Gas":225.4,"coordinates":[-119.6739,45.848]},{"Plant":"Midulla Generating Station","State":"FL","Gas":754,"coordinates":[-81.9625,27.6417]},{"Plant":"Interstate","State":"IL","Gas":114,"coordinates":[-89.5891,39.8233]},{"Plant":"Rathdrum","State":"ID","Gas":132,"coordinates":[-116.8673,47.8043]},{"Plant":"Arthur Von Rosenberg","State":"TX","Gas":465,"coordinates":[-98.384,29.257]},{"Plant":"Carson Ice-Gen Project","State":"CA","Gas":109,"coordinates":[-121.4624,38.4457]},{"Plant":"Wayne County","State":"NC","Gas":863,"coordinates":[-78.0981,35.3758]},{"Plant":"Ponca City","State":"OK","Gas":106.8,"coordinates":[-97.0858,36.7198]},{"Plant":"SCA Cogen 2","State":"CA","Gas":176.6,"coordinates":[-121.4001,38.5309]},{"Plant":"SPA Cogen 3","State":"CA","Gas":164,"coordinates":[-121.4735,38.511]},{"Plant":"St Francis Energy Facility","State":"MO","Gas":473,"coordinates":[-90.1779,36.5852]},{"Plant":"River Road Gen Plant","State":"WA","Gas":220,"coordinates":[-122.7256,45.6497]},{"Plant":"Tiger Bay","State":"FL","Gas":205,"coordinates":[-81.8494,27.7464]},{"Plant":"Dahlberg","State":"GA","Gas":747.3,"coordinates":[-83.3977,34.0423]},{"Plant":"H Allen Franklin Combined Cycle","State":"AL","Gas":1815,"coordinates":[-85.0975,32.6078]},{"Plant":"Theodore Cogen Facility","State":"AL","Gas":224.7,"coordinates":[-88.1285,30.5254]},{"Plant":"Essex","State":"MO","Gas":107.4,"coordinates":[-89.8402,36.8682]},{"Plant":"Nodaway","State":"MO","Gas":182.8,"coordinates":[-94.7913,40.2877]},{"Plant":"Chouteau","State":"OK","Gas":495,"coordinates":[-95.2771,36.2221]},{"Plant":"Georgetown","State":"IN","Gas":295,"coordinates":[-86.2441,39.9026]},{"Plant":"Tilton","State":"IL","Gas":176,"coordinates":[-87.6538,40.1061]},{"Plant":"Henry County","State":"IN","Gas":135.5,"coordinates":[-85.5039,39.9528]},{"Plant":"MPC Generating","State":"GA","Gas":309.4,"coordinates":[-83.6953,33.8119]},{"Plant":"Sherwood H Smith Jr Energy Complex","State":"NC","Gas":1290,"coordinates":[-79.7406,34.8392]},{"Plant":"Sewell Creek Energy","State":"GA","Gas":490,"coordinates":[-85.2769,33.9486]},{"Plant":"Alsey","State":"IL","Gas":121,"coordinates":[-90.436,39.5698]},{"Plant":"Fulton","State":"AR","Gas":153,"coordinates":[-93.7924,33.6094]},{"Plant":"Rowan","State":"NC","Gas":924.6,"coordinates":[-80.6019,35.7314]},{"Plant":"Smarr Energy Center","State":"GA","Gas":216.6,"coordinates":[-83.8464,32.9842]},{"Plant":"John S Rainey","State":"SC","Gas":977,"coordinates":[-82.776,34.3477]},{"Plant":"Essential Power Rock Springs LLC","State":"MD","Gas":652,"coordinates":[-76.1598,39.719]},{"Plant":"Marsh Run Generating","State":"VA","Gas":481,"coordinates":[-77.7681,38.5283]},{"Plant":"Louisa Generating","State":"VA","Gas":466,"coordinates":[-78.2139,38.1181]},{"Plant":"Remington","State":"VA","Gas":608,"coordinates":[-77.7714,38.5442]},{"Plant":"Ladysmith","State":"VA","Gas":783,"coordinates":[-77.5133,38.0722]},{"Plant":"Pleasant Valley","State":"MN","Gas":436.1,"coordinates":[-92.6829,43.7994]},{"Plant":"Lagoon Creek","State":"TN","Gas":1480.8,"coordinates":[-89.3964,35.6578]},{"Plant":"Brandy Branch","State":"FL","Gas":660.8,"coordinates":[-81.9472,30.3206]},{"Plant":"Holden","State":"MO","Gas":232.8,"coordinates":[-93.9983,38.7538]},{"Plant":"MEPI GT Facility","State":"IL","Gas":239,"coordinates":[-88.8661,37.2175]},{"Plant":"Encogen","State":"WA","Gas":159.4,"coordinates":[-122.486,48.746]},{"Plant":"Robert P Mone Plant","State":"OH","Gas":447.8,"coordinates":[-84.7392,40.9297]},{"Plant":"H L Culbreath Bayside Power Station","State":"FL","Gas":1854,"coordinates":[-82.4231,27.9072]},{"Plant":"Terry Bundy Generating Station","State":"NE","Gas":165.3,"coordinates":[-96.6131,40.9097]},{"Plant":"E B Harris Electric Generating Plant","State":"AL","Gas":1268.7,"coordinates":[-86.5744,32.3814]},{"Plant":"Sand Hill","State":"TX","Gas":595.8,"coordinates":[-97.6129,30.2098]},{"Plant":"Talbot County Energy","State":"GA","Gas":663.6,"coordinates":[-84.6917,32.5892]},{"Plant":"Chattahoochee Energy Facility","State":"GA","Gas":455.8,"coordinates":[-85.0386,33.4072]},{"Plant":"Lakefield Junction","State":"MN","Gas":514.9,"coordinates":[-94.8415,43.7984]},{"Plant":"West Gardner","State":"KS","Gas":309.6,"coordinates":[-94.9861,38.7875]},{"Plant":"Coyote Springs II","State":"OR","Gas":242.7,"coordinates":[-119.674,45.848]},{"Plant":"Wansley Unit 9","State":"GA","Gas":503.3,"coordinates":[-85.0403,33.4083]},{"Plant":"Lawrence County Station","State":"IN","Gas":261,"coordinates":[-86.4511,38.8003]},{"Plant":"Evander Andrews Power Complex","State":"ID","Gas":247,"coordinates":[-115.7343,43.1792]},{"Plant":"Kemper County","State":"MS","Gas":312.8,"coordinates":[-88.606,32.7976]},{"Plant":"Peno Creek","State":"MO","Gas":188,"coordinates":[-91.2295,39.3531]},{"Plant":"Sumpter","State":"MI","Gas":298.8,"coordinates":[-83.5318,42.167]},{"Plant":"Pyramid","State":"NM","Gas":158,"coordinates":[-108.5494,32.2363]},{"Plant":"Mill Creek","State":"SC","Gas":595.2,"coordinates":[-81.4306,35.1597]},{"Plant":"Greater Des Moines","State":"IA","Gas":496.2,"coordinates":[-93.5283,41.5563]},{"Plant":"Silver Creek","State":"MS","Gas":225,"coordinates":[-89.9468,31.6004]},{"Plant":"Sylvarena","State":"MS","Gas":129,"coordinates":[-89.4127,31.9821]},{"Plant":"West Campus Cogeneration Facility","State":"WI","Gas":130.4,"coordinates":[-89.4251,43.0751]},{"Plant":"Grays Harbor Energy Facility","State":"WA","Gas":637,"coordinates":[-123.48,46.9692]},{"Plant":"Beatrice","State":"NE","Gas":237,"coordinates":[-96.8082,40.3302]},{"Plant":"Blue Lake","State":"MN","Gas":300,"coordinates":[-93.4315,44.7855]},{"Plant":"Sycamore","State":"IA","Gas":156.1,"coordinates":[-93.6769,41.6722]},{"Plant":"Emery Station","State":"IA","Gas":517.8,"coordinates":[-93.2922,43.094]},{"Plant":"Intercession City","State":"FL","Gas":557,"coordinates":[-81.5486,28.2628]},{"Plant":"Gerald Andrus","State":"MS","Gas":712,"coordinates":[-91.1167,33.35]},{"Plant":"Waterford 1 & 2","State":"LA","Gas":822,"coordinates":[-90.4768,29.9989]},{"Plant":"Comanche","State":"OK","Gas":260,"coordinates":[-98.3244,34.5431]},{"Plant":"DeCordova Steam Electric Station","State":"TX","Gas":1138,"coordinates":[-97.7006,32.4031]},{"Plant":"Santan","State":"AZ","Gas":1227,"coordinates":[-111.7503,33.3325]},{"Plant":"Beaver","State":"OR","Gas":348,"coordinates":[-123.1739,46.1724]},{"Plant":"Glen Gardner","State":"NJ","Gas":160,"coordinates":[-74.9207,40.6815]},{"Plant":"Grand Tower","State":"IL","Gas":513,"coordinates":[-89.5112,37.6577]},{"Plant":"Astoria Generating Station","State":"NY","Gas":195.3,"coordinates":[-73.9126,40.7877]},{"Plant":"Wood River","State":"IL","Gas":116.1,"coordinates":[-90.1347,38.8639]},{"Plant":"Venice","State":"IL","Gas":500,"coordinates":[-90.1764,38.6642]},{"Plant":"Beluga","State":"AK","Gas":344.4,"coordinates":[-151.0356,61.1861]},{"Plant":"Marion","State":"IL","Gas":140,"coordinates":[-88.9531,37.6197]},{"Plant":"Frederickson","State":"WA","Gas":134,"coordinates":[-122.365,47.0797]},{"Plant":"Harding Street","State":"IN","Gas":322,"coordinates":[-86.1969,39.7113]}]

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Gas":740,"coordinates":[-87.7811,32.6017]},{"Plant":"Gilroy Power Plant","State":"CA","Gas":105,"coordinates":[-121.5367,37.0001]},{"Plant":"Noblesville","State":"IN","Gas":285.2,"coordinates":[-85.9714,40.0969]},{"Plant":"Pedricktown Cogeneration Company LP","State":"NJ","Gas":117.9,"coordinates":[-75.4238,39.7668]},{"Plant":"Broadway","State":"IN","Gas":115,"coordinates":[-87.6049,37.9691]},{"Plant":"Butler-Warner Generation Plant","State":"NC","Gas":225,"coordinates":[-78.8294,35.0986]},{"Plant":"El Segundo Cogen","State":"CA","Gas":127.7,"coordinates":[-118.4031,33.9058]},{"Plant":"ArcelorMittal Burns Harbor","State":"IN","Gas":174.7,"coordinates":[-87.1387,41.635]},{"Plant":"King City Power Plant","State":"CA","Gas":111,"coordinates":[-121.1278,36.225]},{"Plant":"Bayou Cogen Plant","State":"TX","Gas":260,"coordinates":[-95.0458,29.6225]},{"Plant":"Bellingham Cogeneration Facility","State":"MA","Gas":264,"coordinates":[-71.4833,42.0925]},{"Plant":"Sayreville Cogeneration Facility","State":"NJ","Gas":271,"coordinates":[-74.3444,40.439]},{"Plant":"Foster Wheeler Martinez","State":"CA","Gas":103.5,"coordinates":[-122.0589,38.0244]},{"Plant":"ExxonMobil Baytown Refinery","State":"TX","Gas":130,"coordinates":[-94.9973,29.7535]},{"Plant":"RG Steel Sparrows Point, LLC","State":"MD","Gas":152.3,"coordinates":[-76.4729,39.213]},{"Plant":"Kern River Cogeneration","State":"CA","Gas":288,"coordinates":[-118.9849,35.4515]},{"Plant":"Formosa Utility Venture Ltd","State":"TX","Gas":597.3,"coordinates":[-96.5417,28.6917]},{"Plant":"Hopewell Cogeneration","State":"VA","Gas":348.3,"coordinates":[-77.2811,37.2917]},{"Plant":"Brush Generation Facility","State":"CO","Gas":292,"coordinates":[-103.631,40.2415]},{"Plant":"ExxonMobil Baytown Turbine","State":"TX","Gas":320.4,"coordinates":[-95.0096,29.7591]},{"Plant":"Selkirk Cogen","State":"NY","Gas":360.6,"coordinates":[-73.8592,42.5744]},{"Plant":"Masspower","State":"MA","Gas":238.3,"coordinates":[-72.5225,42.1575]},{"Plant":"Clear Lake Cogeneration Ltd","State":"TX","Gas":366,"coordinates":[-95.067,29.6255]},{"Plant":"Midland Cogeneration Venture","State":"MI","Gas":1847.4,"coordinates":[-84.2242,43.5861]},{"Plant":"Camden Plant Holding LLC","State":"NJ","Gas":145,"coordinates":[-75.1192,39.9175]},{"Plant":"River Hills","State":"IA","Gas":121.1,"coordinates":[-93.6195,41.5902]},{"Plant":"Hazelton","State":"PA","Gas":147.2,"coordinates":[-76.0409,40.9282]},{"Plant":"Ocotillo","State":"AZ","Gas":320,"coordinates":[-111.9122,33.4225]},{"Plant":"West Phoenix","State":"AZ","Gas":952,"coordinates":[-112.1583,33.4417]},{"Plant":"Saguaro","State":"AZ","Gas":386,"coordinates":[-111.3,32.5517]},{"Plant":"Yucca","State":"AZ","Gas":257,"coordinates":[-114.7106,32.7214]},{"Plant":"Fort Dodge","State":"KS","Gas":146.6,"coordinates":[-99.9497,37.7328]},{"Plant":"Great Bend","State":"KS","Gas":100.6,"coordinates":[-98.8689,38.41]},{"Plant":"Riverton","State":"KS","Gas":186,"coordinates":[-94.6987,37.0726]},{"Plant":"Gordon Evans Energy Center","State":"KS","Gas":833,"coordinates":[-97.5217,37.7903]},{"Plant":"Murray Gill","State":"KS","Gas":293,"coordinates":[-97.4136,37.5967]},{"Plant":"Hutchinson Energy Center","State":"KS","Gas":335,"coordinates":[-97.8747,38.0906]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Gas":316,"coordinates":[-110.9047,32.16]},{"Plant":"Kaw","State":"KS","Gas":140.3,"coordinates":[-94.6514,39.0867]},{"Plant":"McPherson 2","State":"KS","Gas":104,"coordinates":[-97.6834,38.3634]},{"Plant":"Garden City","State":"KS","Gas":227,"coordinates":[-100.8956,37.9703]},{"Plant":"E W Brown","State":"KY","Gas":812,"coordinates":[-84.7126,37.7883]},{"Plant":"Paddys Run","State":"KY","Gas":182,"coordinates":[-85.8417,38.2236]},{"Plant":"Louisiana 1","State":"LA","Gas":382.4,"coordinates":[-91.1864,30.4922]},{"Plant":"Louisiana 2","State":"LA","Gas":138,"coordinates":[-91.1864,30.4922]},{"Plant":"R S Nelson","State":"LA","Gas":595,"coordinates":[-93.2911,30.2844]},{"Plant":"Willow Glen","State":"LA","Gas":1752,"coordinates":[-91.1164,30.2743]},{"Plant":"Coughlin Power Station","State":"LA","Gas":732,"coordinates":[-92.2611,30.8439]},{"Plant":"Teche","State":"LA","Gas":380,"coordinates":[-91.5425,29.8222]},{"Plant":"Little Gypsy","State":"LA","Gas":1170,"coordinates":[-90.4617,30.0051]},{"Plant":"Nine Mile Point","State":"LA","Gas":1365,"coordinates":[-90.1458,29.9472]},{"Plant":"Sterlington","State":"LA","Gas":386,"coordinates":[-92.0792,32.7047]},{"Plant":"Michoud","State":"LA","Gas":762,"coordinates":[-89.9372,30.0081]},{"Plant":"Agua Fria","State":"AZ","Gas":626,"coordinates":[-112.2153,33.5561]},{"Plant":"Arsenal Hill","State":"LA","Gas":116,"coordinates":[-93.7611,32.5181]},{"Plant":"Lieberman","State":"LA","Gas":268,"coordinates":[-93.9597,32.7047]},{"Plant":"Louis Doc Bonin","State":"LA","Gas":285,"coordinates":[-92.0463,30.238]},{"Plant":"Big Cajun 1","State":"LA","Gas":430,"coordinates":[-91.3556,30.6739]},{"Plant":"Kyrene","State":"AZ","Gas":525,"coordinates":[-111.9353,33.3556]},{"Plant":"Herbert A Wagner","State":"MD","Gas":126,"coordinates":[-76.5268,39.1781]},{"Plant":"Notch Cliff","State":"MD","Gas":116.7,"coordinates":[-76.5087,39.4217]},{"Plant":"Perryman","State":"MD","Gas":147.6,"coordinates":[-76.2218,39.4428]},{"Plant":"Riverside","State":"MD","Gas":189,"coordinates":[-76.5133,39.2369]},{"Plant":"Westport","State":"MD","Gas":115.8,"coordinates":[-76.6295,39.266]},{"Plant":"Dickerson","State":"MD","Gas":294,"coordinates":[-77.4644,39.2097]},{"Plant":"Mystic Generating Station","State":"MA","Gas":1954.7,"coordinates":[-71.0675,42.3908]},{"Plant":"Kendall Square Station","State":"MA","Gas":217.7,"coordinates":[-71.0792,42.3633]},{"Plant":"Apache Station","State":"AZ","Gas":198.5,"coordinates":[-109.8931,32.0603]},{"Plant":"Potter Station 2","State":"MA","Gas":183.3,"coordinates":[-70.9672,42.235]},{"Plant":"Cecil Lynch","State":"AR","Gas":170,"coordinates":[-92.1987,34.7535]},{"Plant":"Hamilton Moses","State":"AR","Gas":134,"coordinates":[-90.8722,34.9806]},{"Plant":"Harvey Couch","State":"AR","Gas":123,"coordinates":[-93.4649,33.3592]},{"Plant":"B C Cobb","State":"MI","Gas":187,"coordinates":[-86.2423,43.2588]},{"Plant":"Lake Catherine","State":"AR","Gas":712,"coordinates":[-92.9049,34.4341]},{"Plant":"Dan E Karn","State":"MI","Gas":1276,"coordinates":[-83.8401,43.645]},{"Plant":"Thetford","State":"MI","Gas":171.8,"coordinates":[-83.6286,43.1567]},{"Plant":"Conners Creek","State":"MI","Gas":230,"coordinates":[-82.9597,42.3592]},{"Plant":"Delray","State":"MI","Gas":120,"coordinates":[-83.1019,42.2947]},{"Plant":"Robert E Ritchie","State":"AR","Gas":860,"coordinates":[-90.5987,34.4629]},{"Plant":"Hancock","State":"MI","Gas":124,"coordinates":[-83.4425,42.5497]},{"Plant":"River Rouge","State":"MI","Gas":234,"coordinates":[-83.1119,42.2739]},{"Plant":"Mistersky","State":"MI","Gas":110,"coordinates":[-83.0903,42.3039]},{"Plant":"Black Dog","State":"MN","Gas":236,"coordinates":[-93.2501,44.8108]},{"Plant":"High Bridge","State":"MN","Gas":486,"coordinates":[-93.1117,44.9314]},{"Plant":"Inver Hills","State":"MN","Gas":282,"coordinates":[-93.042,44.781]},{"Plant":"Riverside","State":"MN","Gas":470,"coordinates":[-93.2753,45.0203]},{"Plant":"Thomas Fitzhugh","State":"AR","Gas":165,"coordinates":[-93.8049,35.4624]},{"Plant":"Carl Bailey","State":"AR","Gas":122,"coordinates":[-91.3634,35.2601]},{"Plant":"McClellan","State":"AR","Gas":134,"coordinates":[-92.7917,33.5648]},{"Plant":"Cambridge CT","State":"MN","Gas":159,"coordinates":[-93.2081,45.601]},{"Plant":"Elk River","State":"MN","Gas":186.3,"coordinates":[-93.5584,45.2968]},{"Plant":"Chevron Oil","State":"MS","Gas":130,"coordinates":[-88.4919,30.34]},{"Plant":"Sweatt","State":"MS","Gas":124,"coordinates":[-88.7461,32.2925]},{"Plant":"Jack Watson","State":"MS","Gas":292,"coordinates":[-89.0286,30.4392]},{"Plant":"Baxter Wilson","State":"MS","Gas":1176,"coordinates":[-90.9306,32.2831]},{"Plant":"Delta","State":"MS","Gas":177,"coordinates":[-90.7139,33.7947]},{"Plant":"Rex Brown","State":"MS","Gas":279,"coordinates":[-90.213,32.357]},{"Plant":"Moselle","State":"MS","Gas":327,"coordinates":[-89.3004,31.528]},{"Plant":"Hawthorn","State":"MO","Gas":385.7,"coordinates":[-94.4778,39.1306]},{"Plant":"Lake Road","State":"MO","Gas":124.4,"coordinates":[-94.8773,39.7246]},{"Plant":"James River Power Station","State":"MO","Gas":155,"coordinates":[-93.2619,37.1086]},{"Plant":"C W Burdick","State":"NE","Gas":174.1,"coordinates":[-98.3269,40.9228]},{"Plant":"Contra Costa","State":"CA","Gas":672,"coordinates":[-121.7642,38.0192]},{"Plant":"Sarpy County","State":"NE","Gas":311.9,"coordinates":[-95.9706,41.1706]},{"Plant":"Clark","State":"NV","Gas":1138,"coordinates":[-115.0507,36.0875]},{"Plant":"Fort Churchill","State":"NV","Gas":226,"coordinates":[-119.1322,39.1281]},{"Plant":"Tracy","State":"NV","Gas":1033.6,"coordinates":[-119.525,39.5625]},{"Plant":"Deepwater","State":"NJ","Gas":160.1,"coordinates":[-75.5083,39.6831]},{"Plant":"Sayreville","State":"NJ","Gas":167,"coordinates":[-74.3523,40.4765]},{"Plant":"Gilbert","State":"NJ","Gas":536,"coordinates":[-75.1639,40.5658]},{"Plant":"Bergen Generating Station","State":"NJ","Gas":1206.8,"coordinates":[-74.0244,40.8375]},{"Plant":"PSEG Burlington Generating Station","State":"NJ","Gas":172,"coordinates":[-74.8792,40.0766]},{"Plant":"PSEG Edison Generating Station","State":"NJ","Gas":519.8,"coordinates":[-74.3956,40.4911]},{"Plant":"PSEG Essex Generating Station","State":"NJ","Gas":631.3,"coordinates":[-74.1206,40.7372]},{"Plant":"PSEG Kearny Generating Station","State":"NJ","Gas":465.1,"coordinates":[-74.0965,40.7373]},{"Plant":"PSEG Linden Generating Station","State":"NJ","Gas":1607.4,"coordinates":[-74.2072,40.6217]},{"Plant":"PSEG Sewaren Generating Station","State":"NJ","Gas":443,"coordinates":[-74.2469,40.5558]},{"Plant":"Rio Grande","State":"NM","Gas":236,"coordinates":[-106.5472,31.8047]},{"Plant":"Maddox","State":"NM","Gas":183,"coordinates":[-103.3015,32.7142]},{"Plant":"Reeves","State":"NM","Gas":154,"coordinates":[-106.6019,35.171]},{"Plant":"Cunningham","State":"NM","Gas":471,"coordinates":[-103.3533,32.7131]},{"Plant":"Humboldt Bay","State":"CA","Gas":167,"coordinates":[-124.2103,40.7415]},{"Plant":"Arthur Kill Generating Station","State":"NY","Gas":841,"coordinates":[-74.2,40.5916]},{"Plant":"East River","State":"NY","Gas":294.6,"coordinates":[-73.9742,40.7281]},{"Plant":"Gowanus Gas Turbines Generating","State":"NY","Gas":284.6,"coordinates":[-74.0051,40.6635]},{"Plant":"Narrows Gas Turbines Generating","State":"NY","Gas":292.6,"coordinates":[-74.0208,40.6486]},{"Plant":"Ravenswood","State":"NY","Gas":2325.6,"coordinates":[-73.9461,40.7592]},{"Plant":"E F Barrett","State":"NY","Gas":677.1,"coordinates":[-73.6479,40.6167]},{"Plant":"Far Rockaway","State":"NY","Gas":106.7,"coordinates":[-73.761,40.6109]},{"Plant":"Glenwood","State":"NY","Gas":223.7,"coordinates":[-73.6475,40.8271]},{"Plant":"Northport","State":"NY","Gas":1580.9,"coordinates":[-73.3423,40.9236]},{"Plant":"Port Jefferson","State":"NY","Gas":476.2,"coordinates":[-73.0785,40.9497]},{"Plant":"Bethlehem Energy Center","State":"NY","Gas":754.1,"coordinates":[-73.7638,42.5942]},{"Plant":"Dynegy Morro Bay LLC","State":"CA","Gas":999,"coordinates":[-120.8566,35.3722]},{"Plant":"Dynegy Moss Landing Power Plant","State":"CA","Gas":2529,"coordinates":[-121.7822,36.8048]},{"Plant":"Bowline Point","State":"NY","Gas":737.7,"coordinates":[-73.9689,41.2044]},{"Plant":"Asheville","State":"NC","Gas":324,"coordinates":[-82.5417,35.4731]},{"Plant":"Pittsburg Power","State":"CA","Gas":1311,"coordinates":[-121.8945,38.0392]},{"Plant":"Buck","State":"NC","Gas":682,"coordinates":[-80.3767,35.7133]},{"Plant":"Dicks Creek","State":"OH","Gas":106.2,"coordinates":[-84.3778,39.465]},{"Plant":"Frank M Tait","State":"OH","Gas":256,"coordinates":[-84.2111,39.7272]},{"Plant":"Yankee Street","State":"OH","Gas":100.3,"coordinates":[-84.2047,39.603]},{"Plant":"FirstEnergy West Lorain","State":"OH","Gas":425,"coordinates":[-82.2644,41.4294]},{"Plant":"Richland","State":"OH","Gas":358,"coordinates":[-84.3346,41.3052]},{"Plant":"Horseshoe Lake","State":"OK","Gas":858,"coordinates":[-97.1797,35.5087]},{"Plant":"Mustang","State":"OK","Gas":523,"coordinates":[-97.675,35.4699]},{"Plant":"Seminole","State":"OK","Gas":1501,"coordinates":[-96.7258,34.9665]},{"Plant":"Northeastern","State":"OK","Gas":891,"coordinates":[-95.7008,36.4317]},{"Plant":"Southwestern","State":"OK","Gas":603,"coordinates":[-98.3524,35.1009]},{"Plant":"Tulsa","State":"OK","Gas":370,"coordinates":[-95.991,36.1165]},{"Plant":"Weleetka","State":"OK","Gas":163,"coordinates":[-96.1352,35.3233]},{"Plant":"Barry","State":"AL","Gas":962,"coordinates":[-88.0103,31.0069]},{"Plant":"Anadarko Plant","State":"OK","Gas":485,"coordinates":[-98.23,35.0847]},{"Plant":"Mooreland","State":"OK","Gas":322,"coordinates":[-99.2254,36.4372]},{"Plant":"Encina","State":"CA","Gas":964,"coordinates":[-117.3364,33.1361]},{"Plant":"Kearny","State":"CA","Gas":136,"coordinates":[-117.1338,32.834]},{"Plant":"Brunot Island","State":"PA","Gas":245,"coordinates":[-80.0438,40.4649]},{"Plant":"AES Alamitos LLC","State":"CA","Gas":1997,"coordinates":[-118.1009,33.7688]},{"Plant":"Hunlock Power Station","State":"PA","Gas":126.1,"coordinates":[-76.07,41.2006]},{"Plant":"Manchester Street","State":"RI","Gas":447,"coordinates":[-71.4042,41.8167]},{"Plant":"Darlington County","State":"SC","Gas":441,"coordinates":[-80.1657,34.4185]},{"Plant":"Buzzard Roost","State":"SC","Gas":176,"coordinates":[-81.9025,34.1692]},{"Plant":"Hagood","State":"SC","Gas":126,"coordinates":[-79.9634,32.8265]},{"Plant":"Coolwater","State":"CA","Gas":608,"coordinates":[-116.8539,34.8606]},{"Plant":"Urquhart","State":"SC","Gas":559,"coordinates":[-81.9111,33.435]},{"Plant":"El Segundo Power","State":"CA","Gas":650,"coordinates":[-118.4242,33.9098]},{"Plant":"Etiwanda Generating Station","State":"CA","Gas":640,"coordinates":[-117.5266,34.0912]},{"Plant":"AES Huntington Beach LLC","State":"CA","Gas":903.6,"coordinates":[-117.9792,33.6439]},{"Plant":"Allen Steam Plant","State":"TN","Gas":461.6,"coordinates":[-90.1487,35.0741]},{"Plant":"Gallatin","State":"TN","Gas":599.2,"coordinates":[-86.4006,36.3156]},{"Plant":"Johnsonville","State":"TN","Gas":1135.2,"coordinates":[-87.9861,36.0278]},{"Plant":"Long Beach Generation LLC","State":"CA","Gas":260,"coordinates":[-118.2248,33.7641]},{"Plant":"E S Joslin","State":"TX","Gas":254,"coordinates":[-96.5458,28.6472]},{"Plant":"Laredo","State":"TX","Gas":178,"coordinates":[-99.5089,27.5667]},{"Plant":"Nueces Bay","State":"TX","Gas":718.2,"coordinates":[-97.4192,27.8194]},{"Plant":"Victoria","State":"TX","Gas":285,"coordinates":[-97.01,28.7883]},{"Plant":"Mandalay","State":"CA","Gas":560,"coordinates":[-119.2511,34.2067]},{"Plant":"Lake Hubbard","State":"TX","Gas":916,"coordinates":[-96.5458,32.8358]},{"Plant":"Mountain Creek","State":"TX","Gas":808,"coordinates":[-96.9358,32.7231]},{"Plant":"Newman","State":"TX","Gas":760.9,"coordinates":[-106.4318,31.9836]},{"Plant":"Lewis Creek","State":"TX","Gas":460,"coordinates":[-95.5214,30.4356]},{"Plant":"Sabine","State":"TX","Gas":1809,"coordinates":[-93.878,30.0242]},{"Plant":"Cedar Bayou","State":"TX","Gas":1495,"coordinates":[-94.9256,29.75]},{"Plant":"Greens Bayou","State":"TX","Gas":760,"coordinates":[-95.2194,29.8222]},{"Plant":"Sam Bertron","State":"TX","Gas":765,"coordinates":[-95.0598,29.7268]},{"Plant":"T H Wharton","State":"TX","Gas":1025,"coordinates":[-95.5306,29.9417]},{"Plant":"W A Parish","State":"TX","Gas":1176,"coordinates":[-95.6311,29.4828]},{"Plant":"Knox Lee","State":"TX","Gas":471,"coordinates":[-94.6415,32.3766]},{"Plant":"Wilkes","State":"TX","Gas":883,"coordinates":[-94.548,32.8482]},{"Plant":"Jones","State":"TX","Gas":657,"coordinates":[-101.7392,33.5239]},{"Plant":"Nichols","State":"TX","Gas":457,"coordinates":[-101.7464,35.2834]},{"Plant":"Plant X","State":"TX","Gas":412,"coordinates":[-102.4114,34.1661]},{"Plant":"Eagle Mountain","State":"TX","Gas":665,"coordinates":[-97.4792,32.9056]},{"Plant":"Graham","State":"TX","Gas":615,"coordinates":[-98.6117,33.1344]},{"Plant":"Handley","State":"TX","Gas":1265,"coordinates":[-97.2192,32.7283]},{"Plant":"Morgan Creek","State":"TX","Gas":1093,"coordinates":[-100.9156,32.3358]},{"Plant":"Permian Basin","State":"TX","Gas":1055,"coordinates":[-102.9633,31.5839]},{"Plant":"Ormond Beach","State":"CA","Gas":1516,"coordinates":[-119.1689,34.1292]},{"Plant":"Lake Creek","State":"TX","Gas":317,"coordinates":[-96.985,31.4647]},{"Plant":"Stryker Creek","State":"TX","Gas":669,"coordinates":[-94.9898,31.9398]},{"Plant":"Trinidad","State":"TX","Gas":226,"coordinates":[-96.1013,32.1245]},{"Plant":"Valley","State":"TX","Gas":1115,"coordinates":[-96.3676,33.6281]},{"Plant":"Decker Creek","State":"TX","Gas":932,"coordinates":[-97.6128,30.3033]},{"Plant":"Silas Ray","State":"TX","Gas":125,"coordinates":[-97.5214,25.9131]},{"Plant":"AES Redondo Beach LLC","State":"CA","Gas":1310,"coordinates":[-118.395,33.8504]},{"Plant":"Bryan","State":"TX","Gas":130,"coordinates":[-96.3723,30.6474]},{"Plant":"Ray Olinger","State":"TX","Gas":395,"coordinates":[-96.4525,33.0681]},{"Plant":"Mountainview Generating Station","State":"CA","Gas":1044,"coordinates":[-117.2418,34.0818]},{"Plant":"Sim Gideon","State":"TX","Gas":620,"coordinates":[-97.2708,30.1456]},{"Plant":"Ty Cooke","State":"TX","Gas":131,"coordinates":[-101.7906,33.5211]},{"Plant":"Leon Creek","State":"TX","Gas":339,"coordinates":[-98.5761,29.3525]},{"Plant":"O W Sommers","State":"TX","Gas":880,"coordinates":[-98.3242,29.3081]},{"Plant":"V H Braunig","State":"TX","Gas":1050,"coordinates":[-98.3825,29.2567]},{"Plant":"R W Miller","State":"TX","Gas":574,"coordinates":[-98.3103,32.6581]},{"Plant":"Pearsall","State":"TX","Gas":270.6,"coordinates":[-99.0919,28.9275]},{"Plant":"Sam Rayburn","State":"TX","Gas":227,"coordinates":[-97.135,28.8947]},{"Plant":"Gadsby","State":"UT","Gas":347.5,"coordinates":[-111.9289,40.7686]},{"Plant":"Grayson","State":"CA","Gas":130.1,"coordinates":[-118.2782,34.1556]},{"Plant":"Chesterfield","State":"VA","Gas":397,"coordinates":[-77.3833,37.3822]},{"Plant":"Possum Point","State":"VA","Gas":875,"coordinates":[-77.2806,38.5367]},{"Plant":"Transalta Centralia Generation","State":"WA","Gas":256,"coordinates":[-122.8598,46.7559]},{"Plant":"El Centro","State":"CA","Gas":183.9,"coordinates":[-115.54,32.8022]},{"Plant":"Harbor","State":"CA","Gas":461,"coordinates":[-118.2656,33.7706]},{"Plant":"Haynes","State":"CA","Gas":1524,"coordinates":[-118.0991,33.7647]},{"Plant":"Wheaton","State":"WI","Gas":196,"coordinates":[-91.5158,44.8854]},{"Plant":"Scattergood","State":"CA","Gas":796,"coordinates":[-118.4276,33.9182]},{"Plant":"Port Washington Generating Station","State":"WI","Gas":1073.8,"coordinates":[-87.8689,43.3842]},{"Plant":"Rock River","State":"WI","Gas":140,"coordinates":[-89.0276,42.582]},{"Plant":"West Marinette","State":"WI","Gas":152.8,"coordinates":[-87.6881,45.0869]},{"Plant":"Valley","State":"CA","Gas":556,"coordinates":[-118.3913,34.245]},{"Plant":"Powerlane Plant","State":"TX","Gas":111,"coordinates":[-96.1264,33.1707]},{"Plant":"Glenarm","State":"CA","Gas":155,"coordinates":[-118.1494,34.126]},{"Plant":"Spencer","State":"TX","Gas":122,"coordinates":[-97.1061,33.1975]},{"Plant":"Colbert","State":"AL","Gas":390.4,"coordinates":[-87.8486,34.7439]},{"Plant":"Thomas C Ferguson","State":"TX","Gas":420,"coordinates":[-98.3705,30.558]},{"Plant":"Barney M Davis","State":"TX","Gas":1032.2,"coordinates":[-97.3117,27.6064]},{"Plant":"Riverside","State":"OK","Gas":1067,"coordinates":[-95.9567,35.9978]},{"Plant":"Pittsfield Generating LP","State":"MA","Gas":154.3,"coordinates":[-73.2181,42.4564]},{"Plant":"Linden Cogen Plant","State":"NJ","Gas":897.3,"coordinates":[-74.2156,40.6322]},{"Plant":"Houston Chemical Complex Battleground","State":"TX","Gas":263,"coordinates":[-95.0839,29.7314]},{"Plant":"Paris Energy Center","State":"TX","Gas":238,"coordinates":[-95.5577,33.6968]},{"Plant":"Hal C Weaver Power Plant","State":"TX","Gas":146.8,"coordinates":[-97.7356,30.2867]},{"Plant":"Sycamore Cogeneration","State":"CA","Gas":300,"coordinates":[-118.9853,35.4526]},{"Plant":"Union Carbide Seadrift Cogen","State":"TX","Gas":168,"coordinates":[-96.7706,28.5105]},{"Plant":"Dow St Charles Operations","State":"LA","Gas":291.6,"coordinates":[-90.4414,29.9861]},{"Plant":"Watson Cogeneration","State":"CA","Gas":398,"coordinates":[-118.2448,33.8166]},{"Plant":"Bucksport Generation LLC","State":"ME","Gas":249.8,"coordinates":[-68.8046,44.5738]},{"Plant":"Bethpage Power Plant","State":"NY","Gas":184,"coordinates":[-73.4994,40.7469]},{"Plant":"Shell Deer Park","State":"TX","Gas":140,"coordinates":[-95.1289,29.7232]},{"Plant":"Newark Bay Cogeneration Partnership LP","State":"NJ","Gas":120.2,"coordinates":[-74.13,40.7197]},{"Plant":"Indeck Corinth Energy Center","State":"NY","Gas":129.5,"coordinates":[-73.8125,43.25]},{"Plant":"PPG Powerhouse C","State":"LA","Gas":303.2,"coordinates":[-93.2831,30.2242]},{"Plant":"Bayonne Plant Holding LLC","State":"NJ","Gas":158,"coordinates":[-74.1124,40.6553]},{"Plant":"Harbor Cogen","State":"CA","Gas":101.7,"coordinates":[-118.2303,33.7771]},{"Plant":"Rosemary Power Station","State":"NC","Gas":165,"coordinates":[-77.6594,36.4517]},{"Plant":"Oklahoma Cogeneration Project","State":"OK","Gas":111.4,"coordinates":[-97.625,35.4397]},{"Plant":"Eagle Point Power Generation","State":"NJ","Gas":195,"coordinates":[-75.1592,39.8746]},{"Plant":"TXU Sweetwater Generating Plant","State":"TX","Gas":213,"coordinates":[-100.365,32.4928]},{"Plant":"ExxonMobil Beaumont Refinery","State":"TX","Gas":610.6,"coordinates":[-94.0753,30.0636]},{"Plant":"JM Shafer Generating Station","State":"CO","Gas":263,"coordinates":[-104.7736,40.0986]},{"Plant":"Gary Works","State":"IN","Gas":161,"coordinates":[-87.3289,41.6224]},{"Plant":"Parlin Power Plant","State":"NJ","Gas":118,"coordinates":[-74.3272,40.4607]},{"Plant":"Optim Energy Altura Cogen LLC","State":"TX","Gas":493,"coordinates":[-95.1077,29.8161]},{"Plant":"Cumberland","State":"NJ","Gas":183.1,"coordinates":[-74.9654,39.3757]},{"Plant":"Gramercy Holdings LLC","State":"LA","Gas":106,"coordinates":[-90.6693,30.054]},{"Plant":"Hardee Power Station","State":"FL","Gas":358,"coordinates":[-81.9636,27.6364]},{"Plant":"Bellmeade Power Station","State":"VA","Gas":267,"coordinates":[-77.4317,37.4964]},{"Plant":"Motiva Enterprises Port Arthur Refinery","State":"TX","Gas":221.1,"coordinates":[-93.9569,29.8822]},{"Plant":"Ocean State Power","State":"RI","Gas":218.6,"coordinates":[-71.6689,42.0097]},{"Plant":"LaO Energy Systems","State":"LA","Gas":479,"coordinates":[-91.2325,30.3186]},{"Plant":"Doswell Energy Center","State":"VA","Gas":813.8,"coordinates":[-77.1448,37.8182]},{"Plant":"Elizabeth River Power Station","State":"VA","Gas":348,"coordinates":[-76.3083,36.775]},{"Plant":"Texas City Power Plant","State":"TX","Gas":451,"coordinates":[-94.9438,29.3787]},{"Plant":"Dow Chemical Texas Operation","State":"TX","Gas":795.1,"coordinates":[-95.4075,28.9913]},{"Plant":"Power Station 4","State":"TX","Gas":172,"coordinates":[-94.9219,29.3782]},{"Plant":"Midway Sunset Cogen","State":"CA","Gas":219,"coordinates":[-119.6294,35.2269]},{"Plant":"C R Wing Cogen Plant","State":"TX","Gas":227,"coordinates":[-101.4224,32.2732]},{"Plant":"Delaware City Plant","State":"DE","Gas":265,"coordinates":[-75.6343,39.5871]},{"Plant":"McWilliams","State":"AL","Gas":650,"coordinates":[-86.4764,31.4003]},{"Plant":"J K Smith","State":"KY","Gas":784,"coordinates":[-84.1017,37.8833]},{"Plant":"Lockport Energy Associates LP","State":"NY","Gas":204.2,"coordinates":[-78.745,43.1619]},{"Plant":"Kennedy International Airport Cogen","State":"NY","Gas":123.7,"coordinates":[-73.7778,40.6417]},{"Plant":"March Point Cogeneration","State":"WA","Gas":146.2,"coordinates":[-122.56,48.4708]},{"Plant":"Saguaro Power","State":"NV","Gas":101,"coordinates":[-115.0117,36.0417]},{"Plant":"Ocean State Power II","State":"RI","Gas":218.6,"coordinates":[-71.6701,42.0099]},{"Plant":"Orange Cogeneration Facility","State":"FL","Gas":110.6,"coordinates":[-81.8251,27.8708]},{"Plant":"Lake Cogen Ltd","State":"FL","Gas":121,"coordinates":[-81.676,28.9158]},{"Plant":"Pasco Cogen Ltd","State":"FL","Gas":121.6,"coordinates":[-82.1889,28.3746]},{"Plant":"Mulberry Cogeneration Facility","State":"FL","Gas":113,"coordinates":[-81.8775,27.8489]},{"Plant":"Orlando Cogen LP","State":"FL","Gas":120,"coordinates":[-81.4123,28.4426]},{"Plant":"Sumas Power Plant","State":"WA","Gas":125.5,"coordinates":[-122.2733,48.9905]},{"Plant":"Ferndale Generating Station","State":"WA","Gas":271,"coordinates":[-122.6867,48.8288]},{"Plant":"Hartwell Energy Facility","State":"GA","Gas":298,"coordinates":[-82.8199,34.3396]},{"Plant":"Sithe Independence Station","State":"NY","Gas":965,"coordinates":[-76.4511,43.495]},{"Plant":"Saranac Facility","State":"NY","Gas":247.5,"coordinates":[-73.4557,44.7132]},{"Plant":"NAEA Lakewood LLC","State":"NJ","Gas":218.1,"coordinates":[-74.1686,40.0613]},{"Plant":"Auburndale Power Partners","State":"FL","Gas":155.3,"coordinates":[-81.8058,28.0542]},{"Plant":"Oyster Creek Unit VIII","State":"TX","Gas":379,"coordinates":[-95.342,28.9802]},{"Plant":"Hermiston Generating Plant","State":"OR","Gas":464,"coordinates":[-119.37,45.8042]},{"Plant":"Grays Ferry Cogeneration","State":"PA","Gas":150,"coordinates":[-75.1881,39.9422]},{"Plant":"Milford Power LP","State":"MA","Gas":148,"coordinates":[-71.5115,42.1294]},{"Plant":"Milagro Cogeneration Plant","State":"NM","Gas":121.6,"coordinates":[-107.9417,36.7367]},{"Plant":"Johnson County","State":"TX","Gas":267,"coordinates":[-97.4078,32.3994]},{"Plant":"Brandywine Power Facility","State":"MD","Gas":230,"coordinates":[-76.8678,38.6681]},{"Plant":"Gordonsville Energy LP","State":"VA","Gas":218,"coordinates":[-78.2138,38.1179]},{"Plant":"Sun Peak Generating Station","State":"NV","Gas":222,"coordinates":[-115.0339,36.1375]},{"Plant":"Brooklyn Navy Yard Cogeneration","State":"NY","Gas":250,"coordinates":[-73.9764,40.6994]},{"Plant":"Michigan Power LP","State":"MI","Gas":128,"coordinates":[-86.425,43.9375]},{"Plant":"LSP-Cottage Grove LP","State":"MN","Gas":251,"coordinates":[-92.9119,44.7956]},{"Plant":"LSP-Whitewater LP","State":"WI","Gas":261,"coordinates":[-88.7299,42.8555]},{"Plant":"Sweeny Cogen Facility","State":"TX","Gas":436,"coordinates":[-95.745,29.0728]},{"Plant":"Dighton Power Plant","State":"MA","Gas":153.4,"coordinates":[-71.1239,41.8312]},{"Plant":"De Pere Energy Center","State":"WI","Gas":169.1,"coordinates":[-88.072,44.4486]},{"Plant":"Androscoggin Energy Center","State":"ME","Gas":136.6,"coordinates":[-70.2423,44.5063]},{"Plant":"Delta Person LLC","State":"NM","Gas":140,"coordinates":[-106.644,35.026]},{"Plant":"Mid-Georgia Cogeneration Facility","State":"GA","Gas":316,"coordinates":[-83.6039,32.4856]},{"Plant":"Berkshire Power","State":"MA","Gas":229.3,"coordinates":[-72.6478,42.0476]},{"Plant":"Bridgeport Energy Project","State":"CT","Gas":454,"coordinates":[-73.1844,41.1692]},{"Plant":"Pasadena Cogeneration","State":"TX","Gas":700,"coordinates":[-95.1765,29.7248]},{"Plant":"Tiverton Power Plant","State":"RI","Gas":250,"coordinates":[-71.1706,41.6422]},{"Plant":"Axiall Plaquemine","State":"LA","Gas":240,"coordinates":[-91.185,30.2586]},{"Plant":"Tenaska Georgia Generation Facility","State":"GA","Gas":933,"coordinates":[-84.9996,33.3516]},{"Plant":"Tenaska Frontier Generation Station","State":"TX","Gas":860,"coordinates":[-95.9178,30.5924]},{"Plant":"Batesville Generation Facility","State":"MS","Gas":858,"coordinates":[-89.9275,34.3356]},{"Plant":"Black Hawk Station","State":"TX","Gas":223,"coordinates":[-101.36,35.6957]},{"Plant":"Mustang Station","State":"TX","Gas":486,"coordinates":[-102.7417,32.9728]},{"Plant":"Maine Independence Station","State":"ME","Gas":490,"coordinates":[-68.7094,44.8242]},{"Plant":"Pine Bluff Energy Center","State":"AR","Gas":192,"coordinates":[-91.9025,34.2181]},{"Plant":"Desert Star Energy Center","State":"NV","Gas":450,"coordinates":[-114.9928,35.7867]},{"Plant":"Millennium Power","State":"MA","Gas":325.1,"coordinates":[-72.0151,42.1123]},{"Plant":"New Albany Energy Facility","State":"MS","Gas":360,"coordinates":[-88.9397,34.5408]},{"Plant":"Brownsville Peaking Power","State":"TN","Gas":467.6,"coordinates":[-89.198,35.5438]},{"Plant":"Crockett Cogen Project","State":"CA","Gas":247.4,"coordinates":[-122.2161,38.0569]},{"Plant":"Gregory Power Facility","State":"TX","Gas":366,"coordinates":[-97.2584,27.8893]},{"Plant":"Zeeland Generating Station","State":"MI","Gas":848.6,"coordinates":[-85.9975,42.8206]},{"Plant":"Dearborn Industrial Generation","State":"MI","Gas":710,"coordinates":[-83.154,42.3026]},{"Plant":"Taft Cogeneration Facility","State":"LA","Gas":790,"coordinates":[-90.4599,29.9888]},{"Plant":"Midlothian Energy Facility","State":"TX","Gas":1278,"coordinates":[-97.0537,32.4302]},{"Plant":"Lamar Power Project","State":"TX","Gas":1004,"coordinates":[-95.59,33.6308]},{"Plant":"Frontera Energy Center","State":"TX","Gas":475,"coordinates":[-98.3992,26.208]},{"Plant":"NRG Sterlington Power","State":"LA","Gas":176,"coordinates":[-92.0811,32.6889]},{"Plant":"Rumford Power Associates","State":"ME","Gas":254,"coordinates":[-70.5219,44.5303]},{"Plant":"Livingston Generating Station","State":"MI","Gas":132,"coordinates":[-84.7308,45.0304]},{"Plant":"Klamath Cogeneration Plant","State":"OR","Gas":470,"coordinates":[-121.8106,42.1739]},{"Plant":"Entergy Rhode Island State Energy LP","State":"RI","Gas":528,"coordinates":[-71.5186,41.8017]},{"Plant":"Rocky Road Power LLC","State":"IL","Gas":327.3,"coordinates":[-88.2397,42.0931]},{"Plant":"Madison","State":"OH","Gas":576,"coordinates":[-84.4647,39.4522]},{"Plant":"Vermillion Energy Facility","State":"IN","Gas":568,"coordinates":[-87.4464,39.9223]},{"Plant":"Sutter Energy Center","State":"CA","Gas":530,"coordinates":[-121.6959,39.0531]},{"Plant":"Rockingham County CT Station","State":"NC","Gas":825,"coordinates":[-79.8297,36.3297]},{"Plant":"RS Cogen","State":"LA","Gas":415.4,"coordinates":[-93.2992,30.221]},{"Plant":"SRW Cogen LP","State":"TX","Gas":420,"coordinates":[-93.7574,30.0545]},{"Plant":"Magic Valley Generating Station","State":"TX","Gas":682,"coordinates":[-98.19,26.3403]},{"Plant":"Griffith Energy LLC","State":"AZ","Gas":570,"coordinates":[-114.1333,35.054]},{"Plant":"Milford Power Project","State":"CT","Gas":506.7,"coordinates":[-73.0997,41.2244]},{"Plant":"Manchief Electric Generating Station","State":"CO","Gas":264,"coordinates":[-103.685,40.2171]},{"Plant":"Walton County Power LLC","State":"GA","Gas":454.5,"coordinates":[-83.6954,33.8148]},{"Plant":"Desert Basin","State":"AZ","Gas":577,"coordinates":[-111.7889,32.9042]},{"Plant":"Kendall County Generation Facility","State":"IL","Gas":1140,"coordinates":[-88.2581,41.4797]},{"Plant":"Tenaska Gateway Generating Station","State":"TX","Gas":844,"coordinates":[-94.6197,32.0178]},{"Plant":"Alliant Energy Neenah","State":"WI","Gas":298.2,"coordinates":[-88.5064,44.1936]},{"Plant":"Rio Nogales Power Project","State":"TX","Gas":755,"coordinates":[-97.9732,29.5931]},{"Plant":"Wolf Hollow I LP","State":"TX","Gas":695.5,"coordinates":[-97.7317,32.3342]},{"Plant":"Hawk Road Facility","State":"GA","Gas":486.1,"coordinates":[-84.9914,33.3585]},{"Plant":"Hays Energy Project","State":"TX","Gas":881,"coordinates":[-97.9894,29.7806]},{"Plant":"Green Country Energy LLC","State":"OK","Gas":783,"coordinates":[-95.9346,35.9833]},{"Plant":"Worthington Generation LLC","State":"IN","Gas":164.1,"coordinates":[-87.0128,39.0708]},{"Plant":"Lake Road Generating Plant","State":"CT","Gas":745.2,"coordinates":[-71.8958,41.872]},{"Plant":"La Paloma Generating LLC","State":"CA","Gas":965.4,"coordinates":[-119.5919,35.2956]},{"Plant":"Guadalupe Generating Station","State":"TX","Gas":995,"coordinates":[-98.1419,29.6244]},{"Plant":"Lost Pines 1 Power Project","State":"TX","Gas":516,"coordinates":[-97.2714,30.1478]},{"Plant":"Bluegrass Generating Station","State":"KY","Gas":501,"coordinates":[-85.4133,38.3902]},{"Plant":"Calcasieu","State":"LA","Gas":310,"coordinates":[-93.345,30.1608]},{"Plant":"Broad River Energy Center","State":"SC","Gas":848.9,"coordinates":[-81.575,35.0786]},{"Plant":"Bastrop Energy Center","State":"TX","Gas":552,"coordinates":[-97.55,30.1458]},{"Plant":"Granite Ridge","State":"NH","Gas":678,"coordinates":[-71.4261,42.9042]},{"Plant":"Bosque County Peaking","State":"TX","Gas":748,"coordinates":[-97.3586,31.8594]},{"Plant":"Acadia Energy Center","State":"LA","Gas":1063,"coordinates":[-92.4131,30.4286]},{"Plant":"Eastman Cogeneration Facility","State":"TX","Gas":402.2,"coordinates":[-94.6903,32.4481]},{"Plant":"South Point Energy Center","State":"AZ","Gas":550,"coordinates":[-114.5317,34.8678]},{"Plant":"Dogwood Energy Facility","State":"MO","Gas":614.3,"coordinates":[-94.3006,38.7931]},{"Plant":"Rathdrum Power LLC","State":"ID","Gas":248,"coordinates":[-116.9203,47.7858]},{"Plant":"Sunrise Power LLC","State":"CA","Gas":545,"coordinates":[-119.585,35.2097]},{"Plant":"Channelview Cogeneration Plant","State":"TX","Gas":779,"coordinates":[-95.1217,29.837]},{"Plant":"Cordova Energy","State":"IL","Gas":521.2,"coordinates":[-90.2797,41.7122]},{"Plant":"Osceola","State":"FL","Gas":468,"coordinates":[-81.0978,28.1289]},{"Plant":"Ontelaunee Energy Center","State":"PA","Gas":516,"coordinates":[-75.9356,40.4219]},{"Plant":"Caledonia","State":"MS","Gas":765,"coordinates":[-88.2717,33.6464]},{"Plant":"Riverside Generating LLC","State":"KY","Gas":825,"coordinates":[-82.6046,38.1917]},{"Plant":"Elwood Energy LLC","State":"IL","Gas":1350,"coordinates":[-88.1236,41.4388]},{"Plant":"Arapahoe Combustion Turbine Project","State":"CO","Gas":122.5,"coordinates":[-105.0018,39.6692]},{"Plant":"Gibson City","State":"IL","Gas":228,"coordinates":[-88.3987,40.4705]},{"Plant":"Pinckneyville","State":"IL","Gas":316,"coordinates":[-89.3467,38.1114]},{"Plant":"Kinmundy","State":"IL","Gas":208,"coordinates":[-89.0128,38.7619]},{"Plant":"Corpus Christi Energy Center","State":"TX","Gas":483,"coordinates":[-97.4283,27.8139]},{"Plant":"Afton Generating Station","State":"NM","Gas":235.6,"coordinates":[-106.8465,32.1142]},{"Plant":"ANP Bellingham Energy Project","State":"MA","Gas":475,"coordinates":[-71.4535,42.1106]},{"Plant":"ANP Blackstone Energy Project","State":"MA","Gas":439.6,"coordinates":[-71.5158,42.0599]},{"Plant":"Odessa Ector Generating Station","State":"TX","Gas":932.5,"coordinates":[-102.3264,31.8403]},{"Plant":"Morris Cogeneration LLC","State":"IL","Gas":176,"coordinates":[-88.3328,41.4119]},{"Plant":"Los Medanos Energy Center","State":"CA","Gas":567,"coordinates":[-121.873,38.0301]},{"Plant":"Hinds Energy Facility","State":"MS","Gas":450,"coordinates":[-90.2199,32.379]},{"Plant":"Attala","State":"MS","Gas":455,"coordinates":[-89.6753,33.0147]},{"Plant":"Harry L. Oswald","State":"AR","Gas":548,"coordinates":[-92.2166,34.5923]},{"Plant":"Lincoln Generating Facility","State":"IL","Gas":622.9,"coordinates":[-87.9436,41.3933]},{"Plant":"Ennis Power Company LLC","State":"TX","Gas":359.5,"coordinates":[-96.675,32.32]},{"Plant":"Wheatland Generating Facility","State":"IN","Gas":460,"coordinates":[-87.2931,38.6716]},{"Plant":"Oneta Energy Center","State":"OK","Gas":1086.4,"coordinates":[-95.6967,36.0119]},{"Plant":"Freestone Energy Center","State":"TX","Gas":953,"coordinates":[-96.1131,31.8907]},{"Plant":"Greenville Electric Generating Station","State":"OH","Gas":202.1,"coordinates":[-84.6151,40.0758]},{"Plant":"Montpelier Electric Generating Station","State":"IN","Gas":180,"coordinates":[-85.3057,40.6206]},{"Plant":"Jack County","State":"TX","Gas":1241,"coordinates":[-97.9574,33.101]},{"Plant":"Liberty Electric Power Plant","State":"PA","Gas":541,"coordinates":[-75.3358,39.8614]},{"Plant":"Marshall Energy Facility","State":"KY","Gas":620.8,"coordinates":[-88.3958,37.0286]},{"Plant":"Handsome Lake Energy LLC","State":"PA","Gas":267.5,"coordinates":[-79.8061,41.2908]},{"Plant":"Audrain Generating Station","State":"MO","Gas":600,"coordinates":[-91.5369,39.3092]},{"Plant":"Lee Energy Facility","State":"IL","Gas":568,"coordinates":[-89.4054,41.8287]},{"Plant":"Energy Shelby County","State":"IL","Gas":371.6,"coordinates":[-88.4772,39.2794]},{"Plant":"NRG Rockford I","State":"IL","Gas":297.9,"coordinates":[-89.1012,42.2386]},{"Plant":"Red Oak Power LLC","State":"NJ","Gas":765.9,"coordinates":[-74.3489,40.4487]},{"Plant":"Hog Bayou Energy Center","State":"AL","Gas":230,"coordinates":[-88.0575,30.7478]},{"Plant":"Santa Rosa Energy Center","State":"FL","Gas":235.9,"coordinates":[-87.115,30.5664]},{"Plant":"Astoria Gas Turbines","State":"NY","Gas":420,"coordinates":[-73.9048,40.787]},{"Plant":"Doyle Energy Facility","State":"GA","Gas":326.9,"coordinates":[-83.6996,33.8377]},{"Plant":"Darby Electric Generating Station","State":"OH","Gas":435,"coordinates":[-83.1778,39.7139]},{"Plant":"Tait Electric Generating Station","State":"OH","Gas":340,"coordinates":[-84.2095,39.7277]},{"Plant":"University Park South","State":"IL","Gas":300,"coordinates":[-87.7532,41.4409]},{"Plant":"Gleason Generating Facility","State":"TN","Gas":495,"coordinates":[-88.612,36.2454]},{"Plant":"Crete Energy Venture LLC","State":"IL","Gas":300,"coordinates":[-87.6187,41.4294]},{"Plant":"Whiting Clean Energy","State":"IN","Gas":513,"coordinates":[-87.4775,41.6739]},{"Plant":"Edward L. Addison Generating Plant","State":"GA","Gas":598.8,"coordinates":[-84.3064,32.9111]},{"Plant":"TVA Southaven Combined Cycle","State":"MS","Gas":774,"coordinates":[-90.0378,34.9939]},{"Plant":"Jackson Generating Station","State":"MI","Gas":564,"coordinates":[-84.3767,42.2488]},{"Plant":"Tenaska Lindsay Hill Generating Station","State":"AL","Gas":845,"coordinates":[-86.7386,32.6514]},{"Plant":"Ceredo Generating Station","State":"WV","Gas":450,"coordinates":[-82.5339,38.3681]},{"Plant":"Aurora","State":"IL","Gas":878,"coordinates":[-88.2265,41.8151]},{"Plant":"Southeast Chicago Energy Project","State":"IL","Gas":296,"coordinates":[-87.5449,41.7181]},{"Plant":"Arlington Valley Energy Facility","State":"AZ","Gas":579,"coordinates":[-112.8897,33.3417]},{"Plant":"Front Range Power Plant","State":"CO","Gas":461.5,"coordinates":[-104.7069,38.6281]},{"Plant":"Big Sandy Peaker Plant","State":"WV","Gas":300,"coordinates":[-82.5938,38.3441]},{"Plant":"Wolf Hills Energy","State":"VA","Gas":250,"coordinates":[-82.1044,36.6644]},{"Plant":"Oleander Power Project LP","State":"FL","Gas":315.9,"coordinates":[-80.7947,28.3661]},{"Plant":"Decatur Energy Center","State":"AL","Gas":725,"coordinates":[-87.0214,34.6292]},{"Plant":"Morgan Energy Center","State":"AL","Gas":749,"coordinates":[-87.0639,34.6397]},{"Plant":"Westbrook Energy Center Power Plant","State":"ME","Gas":506,"coordinates":[-70.375,43.6575]},{"Plant":"Blythe Energy Inc","State":"CA","Gas":514,"coordinates":[-114.6865,33.6157]},{"Plant":"Calumet Energy Team LLC","State":"IL","Gas":321.2,"coordinates":[-87.5563,41.6835]},{"Plant":"New Covert Generating Facility","State":"MI","Gas":1040.1,"coordinates":[-86.2937,42.3224]},{"Plant":"Fairless Energy Center","State":"PA","Gas":1211.2,"coordinates":[-74.7411,40.1475]},{"Plant":"Channel Energy Center LLC","State":"TX","Gas":585,"coordinates":[-95.2319,29.7189]},{"Plant":"Baconton Power Plant","State":"GA","Gas":196,"coordinates":[-84.08,31.3869]},{"Plant":"Gila River Power Station","State":"AZ","Gas":2060,"coordinates":[-112.6944,32.975]},{"Plant":"Air Products Port Arthur","State":"TX","Gas":129.1,"coordinates":[-93.9651,29.8665]},{"Plant":"Ingleside Cogeneration","State":"TX","Gas":460,"coordinates":[-97.2428,27.8828]},{"Plant":"Fore River Generating Station","State":"MA","Gas":688.4,"coordinates":[-70.9661,42.2422]},{"Plant":"Wise County Power LLC","State":"TX","Gas":655,"coordinates":[-97.9103,33.0583]},{"Plant":"Chuck Lenzie Generating Station","State":"NV","Gas":1128,"coordinates":[-114.9218,36.3837]},{"Plant":"Baytown Energy Center","State":"TX","Gas":770,"coordinates":[-94.9019,29.7731]},{"Plant":"Hermiston Power Partnership","State":"OR","Gas":615,"coordinates":[-119.3133,45.794]},{"Plant":"Washington County","State":"GA","Gas":604,"coordinates":[-82.98,33.0922]},{"Plant":"Delta Energy Center","State":"CA","Gas":769.1,"coordinates":[-121.8439,38.0169]},{"Plant":"Holland Energy Facility","State":"IL","Gas":622.1,"coordinates":[-88.7584,39.2231]},{"Plant":"PPL Ironwood LLC","State":"PA","Gas":669,"coordinates":[-76.3658,40.3509]},{"Plant":"Dell Power Station","State":"AR","Gas":679,"coordinates":[-90.0253,35.8619]},{"Plant":"Luna Energy Facility","State":"NM","Gas":559,"coordinates":[-107.7834,32.2993]},{"Plant":"Otay Mesa Generating Project","State":"CA","Gas":571,"coordinates":[-116.915,32.5815]},{"Plant":"Armstrong","State":"PA","Gas":584,"coordinates":[-79.3517,40.638]},{"Plant":"Troy Energy LLC","State":"OH","Gas":584,"coordinates":[-83.4598,41.4772]},{"Plant":"Pleasants Energy LLC","State":"WV","Gas":288,"coordinates":[-81.3642,39.3325]},{"Plant":"Brazos Valley Generating Facility","State":"TX","Gas":525,"coordinates":[-95.6244,29.4731]},{"Plant":"Cottonwood Energy Project","State":"TX","Gas":1233.6,"coordinates":[-93.7353,30.2588]},{"Plant":"Sugar Creek Power","State":"IN","Gas":529.7,"coordinates":[-87.5108,39.3931]},{"Plant":"Exelon LaPorte Generating Station","State":"TX","Gas":153.2,"coordinates":[-95.0718,29.7028]},{"Plant":"Harquahala Generating Project","State":"AZ","Gas":1054.4,"coordinates":[-113.1134,33.476]},{"Plant":"Astoria Energy","State":"NY","Gas":561,"coordinates":[-73.8964,40.7825]},{"Plant":"Union Power Partners LP","State":"AR","Gas":2020,"coordinates":[-92.5894,33.2961]},{"Plant":"Thomas A Smith Energy Facility","State":"GA","Gas":1250,"coordinates":[-84.9175,34.7094]},{"Plant":"Columbia Energy Center","State":"SC","Gas":408.7,"coordinates":[-81.0178,33.8697]},{"Plant":"RockGen Energy Center","State":"WI","Gas":471,"coordinates":[-89.0492,42.9767]},{"Plant":"Zion Energy Center","State":"IL","Gas":456,"coordinates":[-87.895,42.4776]},{"Plant":"Metcalf Energy Center","State":"CA","Gas":546.1,"coordinates":[-121.7457,37.2207]},{"Plant":"Crossroads Energy Center","State":"MS","Gas":308,"coordinates":[-90.5621,34.183]},{"Plant":"Washington Energy Facility","State":"OH","Gas":600,"coordinates":[-81.6564,39.58]},{"Plant":"Elk Hills Power LLC","State":"CA","Gas":525,"coordinates":[-119.4707,35.2803]},{"Plant":"Rolling Hills Generating","State":"OH","Gas":825,"coordinates":[-82.3328,39.0839]},{"Plant":"Renaissance Power LLC","State":"MI","Gas":660,"coordinates":[-84.8429,43.1864]},{"Plant":"Carville Energy LLC","State":"LA","Gas":473,"coordinates":[-91.065,30.2294]},{"Plant":"Athens Generating Plant","State":"NY","Gas":1137.9,"coordinates":[-73.8492,42.2728]},{"Plant":"Effingham County Power Project","State":"GA","Gas":509,"coordinates":[-81.2844,32.2773]},{"Plant":"Calhoun Energy Center","State":"AL","Gas":632,"coordinates":[-85.9731,33.5883]},{"Plant":"Hillabee Energy Center","State":"AL","Gas":695.4,"coordinates":[-85.9033,33.0007]},{"Plant":"Osprey Energy Center Power Plant","State":"FL","Gas":590,"coordinates":[-81.8083,28.0525]},{"Plant":"Shady Hills Generating Station","State":"FL","Gas":468,"coordinates":[-82.5586,28.3665]},{"Plant":"Vandolah Power Station","State":"FL","Gas":632,"coordinates":[-81.924,27.5236]},{"Plant":"Raccoon Creek Energy Center","State":"IL","Gas":300,"coordinates":[-88.5392,38.6996]},{"Plant":"Hot Spring Generating Facility","State":"AR","Gas":630,"coordinates":[-92.8683,34.2976]},{"Plant":"Plaquemine Cogeneration Plant","State":"LA","Gas":793,"coordinates":[-91.2347,30.3217]},{"Plant":"DeSoto County Plant","State":"FL","Gas":320,"coordinates":[-81.8092,27.2272]},{"Plant":"Bayou Cove Peaking Power","State":"LA","Gas":300,"coordinates":[-92.5997,30.2825]},{"Plant":"Elgin Energy Center","State":"IL","Gas":460,"coordinates":[-88.2446,42.0001]},{"Plant":"Tenaska Virginia Generating Station","State":"VA","Gas":919.8,"coordinates":[-78.3813,37.8667]},{"Plant":"Tenaska Central Alabama Generating Stn","State":"AL","Gas":915.8,"coordinates":[-86.74,32.6497]},{"Plant":"Columbia Energy Center","State":"MO","Gas":140,"coordinates":[-92.2629,39.0192]},{"Plant":"Magnolia Power Plant","State":"MS","Gas":863.1,"coordinates":[-89.2026,34.835]},{"Plant":"Fountain Valley Power Facility","State":"CO","Gas":234,"coordinates":[-104.6875,38.5569]},{"Plant":"Red Hawk","State":"AZ","Gas":934,"coordinates":[-112.8406,33.3346]},{"Plant":"McClain Energy Facility","State":"OK","Gas":459.1,"coordinates":[-97.5898,35.2977]},{"Plant":"Redbud Power Plant","State":"OK","Gas":1160.2,"coordinates":[-97.2264,35.6856]},{"Plant":"Deer Park Energy Center","State":"TX","Gas":922.2,"coordinates":[-95.1345,29.7134]},{"Plant":"Ouachita","State":"LA","Gas":770,"coordinates":[-92.0683,32.7061]},{"Plant":"Green Power 2","State":"TX","Gas":825.5,"coordinates":[-94.9328,29.3781]},{"Plant":"Forney Energy Center","State":"TX","Gas":1640,"coordinates":[-96.4916,32.7563]},{"Plant":"Mesquite Generating Station","State":"AZ","Gas":1073.3,"coordinates":[-112.8642,33.345]},{"Plant":"Goldendale Generating Station","State":"WA","Gas":256.7,"coordinates":[-120.833,45.8114]},{"Plant":"Tri Center Naniwa Energy","State":"NV","Gas":200,"coordinates":[-119.5178,39.5572]},{"Plant":"Goose Creek Energy Center","State":"IL","Gas":432,"coordinates":[-88.5999,40.1069]},{"Plant":"Kiamichi Energy Facility","State":"OK","Gas":1178.4,"coordinates":[-95.9349,34.6831]},{"Plant":"Lawrenceburg Energy Facility","State":"IN","Gas":1080,"coordinates":[-84.8669,39.0911]},{"Plant":"AEP Waterford Facility","State":"OH","Gas":810,"coordinates":[-81.7178,39.5333]},{"Plant":"Limon Generating Station","State":"CO","Gas":134,"coordinates":[-103.7005,39.2038]},{"Plant":"Frank Knutson","State":"CO","Gas":134,"coordinates":[-104.682,39.9411]},{"Plant":"Apex Generating Station","State":"NV","Gas":494.4,"coordinates":[-114.9609,36.416]},{"Plant":"Fayette Energy Facility","State":"PA","Gas":600.5,"coordinates":[-79.9182,39.8592]},{"Plant":"Wallingford Energy","State":"CT","Gas":209.8,"coordinates":[-72.8354,41.4487]},{"Plant":"High Desert Power Plant","State":"CA","Gas":742.6,"coordinates":[-117.3647,34.5953]},{"Plant":"Sundance","State":"AZ","Gas":410,"coordinates":[-111.5899,32.9285]},{"Plant":"York Energy Center","State":"PA","Gas":545,"coordinates":[-76.3067,39.7375]},{"Plant":"Indigo Energy Facility","State":"CA","Gas":149.7,"coordinates":[-116.553,33.9109]},{"Plant":"Hidalgo Energy Center","State":"TX","Gas":470,"coordinates":[-98.1758,26.3417]},{"Plant":"Perryville Power Station","State":"LA","Gas":691,"coordinates":[-92.0183,32.6908]},{"Plant":"West Valley Generation Project","State":"UT","Gas":189,"coordinates":[-112.0317,40.6667]},{"Plant":"University Park North","State":"IL","Gas":504,"coordinates":[-87.7514,41.4425]},{"Plant":"Riverside Energy Center","State":"WI","Gas":598.3,"coordinates":[-89.0355,42.5827]},{"Plant":"Blue Spruce Energy Center","State":"CO","Gas":264,"coordinates":[-104.6814,39.7479]},{"Plant":"Plains End","State":"CO","Gas":114,"coordinates":[-105.226,39.8575]},{"Plant":"Spring Creek Energy Center","State":"OK","Gas":279,"coordinates":[-97.655,35.7422]},{"Plant":"Pastoria Energy Facility, LLC","State":"CA","Gas":724,"coordinates":[-118.844,34.9556]},{"Plant":"EP Newington Energy LLC","State":"NH","Gas":525,"coordinates":[-70.8061,43.1047]},{"Plant":"Chehalis Generating Facility","State":"WA","Gas":509,"coordinates":[-122.9131,46.6225]},{"Plant":"Harrison County Power Project","State":"TX","Gas":514.4,"coordinates":[-94.4367,32.3958]},{"Plant":"Lower Mount Bethel Energy","State":"PA","Gas":551.2,"coordinates":[-75.1076,40.8019]},{"Plant":"AL Sandersville LLC","State":"GA","Gas":576.4,"coordinates":[-82.8608,33.1189]},{"Plant":"Higgins Generating Station","State":"NV","Gas":570,"coordinates":[-115.3561,35.6139]},{"Plant":"Bethlehem Power Plant","State":"PA","Gas":1130,"coordinates":[-75.3147,40.6175]},{"Plant":"Quantum Choctaw Power LLC","State":"MS","Gas":690,"coordinates":[-89.2089,33.3792]},{"Plant":"Mint Farm Generating Station","State":"WA","Gas":275.9,"coordinates":[-122.9855,46.1388]},{"Plant":"Choctaw County","State":"MS","Gas":848,"coordinates":[-89.4201,33.2881]},{"Plant":"Allegheny Energy Units 3 4 & 5","State":"PA","Gas":509,"coordinates":[-79.7686,40.5453]},{"Plant":"Magnet Cove","State":"AR","Gas":641.5,"coordinates":[-92.8317,34.4297]},{"Plant":"Dean","State":"MI","Gas":295.4,"coordinates":[-82.4953,42.7725]},{"Plant":"Bennett Mountain","State":"ID","Gas":164,"coordinates":[-115.6666,43.1472]},{"Plant":"Hanging Rock Energy Facility","State":"OH","Gas":1288,"coordinates":[-82.7833,38.5731]},{"Plant":"Los Esteros Critical Energy Center","State":"CA","Gas":180,"coordinates":[-121.9319,37.425]},{"Plant":"FPL Energy Marcus Hook LP","State":"PA","Gas":717.5,"coordinates":[-75.4216,39.807]},{"Plant":"Valencia Energy Facility","State":"NM","Gas":144.3,"coordinates":[-106.7322,34.6115]},{"Plant":"Gilroy Peaking Energy Center","State":"CA","Gas":135,"coordinates":[-121.5363,36.999]},{"Plant":"Frederickson Power LP","State":"WA","Gas":242,"coordinates":[-122.3657,47.0861]},{"Plant":"Curtis H Stanton Energy Center","State":"FL","Gas":656.9,"coordinates":[-81.1669,28.4882]},{"Plant":"Auburndale Peaker Energy Center","State":"FL","Gas":122,"coordinates":[-81.8059,28.0535]},{"Plant":"Rocky Mountain Energy Center","State":"CO","Gas":580,"coordinates":[-104.5953,40.0908]},{"Plant":"Silverhawk","State":"NV","Gas":560,"coordinates":[-114.9606,36.4078]},{"Plant":"Inland Empire Energy Center","State":"CA","Gas":690,"coordinates":[-117.1704,33.7388]},{"Plant":"Jasper","State":"SC","Gas":869,"coordinates":[-81.1242,32.3594]},{"Plant":"Tracy Combined Cycle Power Plant","State":"CA","Gas":163.9,"coordinates":[-121.4906,37.7107]},{"Plant":"NRG Rockford II Energy Center","State":"IL","Gas":153,"coordinates":[-89.1011,42.2383]},{"Plant":"NAEA Ocean Peaking Power LLC","State":"NJ","Gas":325.6,"coordinates":[-74.1672,40.0633]},{"Plant":"Las Vegas Cogeneration II LLC","State":"NV","Gas":220,"coordinates":[-115.1238,36.232]},{"Plant":"Wansley Combined Cycle","State":"GA","Gas":1143.1,"coordinates":[-85.037,33.4064]},{"Plant":"Cosumnes","State":"CA","Gas":477,"coordinates":[-121.124,38.3385]},{"Plant":"Cass County","State":"NE","Gas":323.1,"coordinates":[-95.964,40.9479]},{"Plant":"Hunterstown","State":"PA","Gas":810,"coordinates":[-77.1672,39.8725]},{"Plant":"Palomar Energy","State":"CA","Gas":562,"coordinates":[-117.1178,33.1197]},{"Plant":"Exira","State":"IA","Gas":137.3,"coordinates":[-94.9197,41.5144]},{"Plant":"Donald Von Raesfeld Power Plant","State":"CA","Gas":154,"coordinates":[-121.9508,37.3767]},{"Plant":"Fox Energy Center","State":"WI","Gas":548,"coordinates":[-88.2089,44.3204]},{"Plant":"Malburg","State":"CA","Gas":143,"coordinates":[-118.2219,33.9986]},{"Plant":"Magnolia Power Project","State":"CA","Gas":301,"coordinates":[-118.3153,34.1786]},{"Plant":"Walnut Energy Center","State":"CA","Gas":269,"coordinates":[-120.8956,37.4878]},{"Plant":"Currant Creek","State":"UT","Gas":540,"coordinates":[-111.8935,39.8214]},{"Plant":"Mankato Energy Center","State":"MN","Gas":300,"coordinates":[-94.003,44.1988]},{"Plant":"Riverside Energy Resource Center","State":"CA","Gas":196,"coordinates":[-117.4528,33.9636]},{"Plant":"McIntosh Combined Cycle Facility","State":"GA","Gas":1256.8,"coordinates":[-81.1817,32.3478]},{"Plant":"South Harper","State":"MO","Gas":317.2,"coordinates":[-94.4824,38.6803]},{"Plant":"Freeport Energy Center","State":"TX","Gas":249.4,"coordinates":[-95.3954,28.9888]},{"Plant":"Faribault Energy Park","State":"MN","Gas":261,"coordinates":[-93.2906,44.3356]},{"Plant":"Sheboygan Falls","State":"WI","Gas":296.9,"coordinates":[-87.8781,43.7518]},{"Plant":"Nebo Power Station","State":"UT","Gas":130,"coordinates":[-111.7294,40.0614]},{"Plant":"500MW CC","State":"NY","Gas":454.1,"coordinates":[-73.9069,40.7889]},{"Plant":"Port Westward","State":"OR","Gas":372,"coordinates":[-123.172,46.1789]},{"Plant":"EG178 Facility","State":"TX","Gas":108,"coordinates":[-100.9547,32.7471]},{"Plant":"Caithness Long Island Energy Center","State":"NY","Gas":307,"coordinates":[-72.9403,40.8142]},{"Plant":"Lake Side Power Plant","State":"UT","Gas":557,"coordinates":[-111.7542,40.3317]},{"Plant":"Groton Generating Station","State":"SD","Gas":153.3,"coordinates":[-98.0987,45.3735]},{"Plant":"Kings River","State":"CA","Gas":109,"coordinates":[-119.7404,36.6697]},{"Plant":"Cannon Falls Energy Center","State":"MN","Gas":398,"coordinates":[-92.9155,44.5367]},{"Plant":"Anson County Generation Facility","State":"NC","Gas":339,"coordinates":[-79.9217,34.9687]},{"Plant":"Empire Generating Co  LLC","State":"NY","Gas":580,"coordinates":[-73.75,42.6252]},{"Plant":"Hamlet Generating Facility","State":"NC","Gas":282.5,"coordinates":[-79.7361,34.8423]},{"Plant":"Roseville Energy Park","State":"CA","Gas":141,"coordinates":[-121.3811,38.7928]},{"Plant":"Mustang Station Unit 4","State":"TX","Gas":290,"coordinates":[-102.7436,32.9746]},{"Plant":"Harry D Mattison Gas Plant","State":"AR","Gas":294,"coordinates":[-94.2841,36.1855]},{"Plant":"Quail Run Energy Center","State":"TX","Gas":482,"coordinates":[-102.315,31.8414]},{"Plant":"Colorado Bend Energy Center","State":"TX","Gas":510,"coordinates":[-96.0683,29.2878]},{"Plant":"Stanton Energy Center","State":"FL","Gas":295,"coordinates":[-81.1678,28.4822]},{"Plant":"Treasure Coast Energy Center","State":"FL","Gas":318,"coordinates":[-80.3775,27.3839]},{"Plant":"West County Energy Center","State":"FL","Gas":3669,"coordinates":[-80.3747,26.6986]},{"Plant":"Spindle Hill Energy Center","State":"CO","Gas":270,"coordinates":[-104.8878,40.0922]},{"Plant":"Hobbs Generating Station","State":"NM","Gas":526,"coordinates":[-103.3094,32.7283]},{"Plant":"Gateway Generating Station","State":"CA","Gas":563.4,"coordinates":[-121.7587,38.0175]},{"Plant":"Western 102 Power Plant","State":"NV","Gas":110.6,"coordinates":[-119.5108,39.5603]},{"Plant":"Emporia Energy Center","State":"KS","Gas":663,"coordinates":[-96.0652,38.4459]},{"Plant":"Jonesboro City Water & Light Plant","State":"AR","Gas":177,"coordinates":[-90.7254,35.8486]},{"Plant":"Plains End II LLC","State":"CO","Gas":116.2,"coordinates":[-105.2256,39.8586]},{"Plant":"Colusa Generating Station","State":"CA","Gas":640,"coordinates":[-122.27,39.3661]},{"Plant":"PPS Power Plant No 1","State":"KY","Gas":110,"coordinates":[-88.6159,37.0339]},{"Plant":"J Lamar Stall Unit","State":"LA","Gas":507,"coordinates":[-93.7601,32.5195]},{"Plant":"San Jacinto County Peaking Facility","State":"TX","Gas":146,"coordinates":[-95.0118,30.4193]},{"Plant":"Hardin County Peaking Facility","State":"TX","Gas":146,"coordinates":[-94.2526,30.3038]},{"Plant":"Midway Peaking LLC","State":"CA","Gas":103,"coordinates":[-120.5797,36.6541]},{"Plant":"Winchester Power Park","State":"TX","Gas":179.2,"coordinates":[-96.9875,30.0381]},{"Plant":"Kleen Energy Systems Project","State":"CT","Gas":628,"coordinates":[-72.5969,41.5532]},{"Plant":"Greenland Energy Center","State":"FL","Gas":296,"coordinates":[-81.5184,30.1591]},{"Plant":"Panoche Energy Center","State":"CA","Gas":388,"coordinates":[-120.5833,36.6514]},{"Plant":"Cedar Bayou 4","State":"TX","Gas":502,"coordinates":[-94.9231,29.7516]},{"Plant":"Bear Garden","State":"VA","Gas":589,"coordinates":[-78.2853,37.6956]},{"Plant":"Dave Gates Generating Station","State":"MT","Gas":132.3,"coordinates":[-112.8766,46.1047]},{"Plant":"Coolidge Generation Station","State":"AZ","Gas":520.8,"coordinates":[-111.5033,32.9174]},{"Plant":"Canyon Power Plant","State":"CA","Gas":197,"coordinates":[-117.8617,33.8581]},{"Plant":"Astoria Energy II","State":"NY","Gas":540,"coordinates":[-73.8966,40.7813]},{"Plant":"Antelope Station","State":"TX","Gas":160.2,"coordinates":[-101.8433,33.865]},{"Plant":"Edge Moor","State":"DE","Gas":710,"coordinates":[-75.5038,39.7389]},{"Plant":"McKee Run","State":"DE","Gas":136,"coordinates":[-75.5466,39.1762]},{"Plant":"Belle River","State":"MI","Gas":222,"coordinates":[-82.495,42.7756]},{"Plant":"Greenwood","State":"MI","Gas":997,"coordinates":[-82.6964,43.1056]},{"Plant":"Manatee","State":"FL","Gas":1111,"coordinates":[-82.3456,27.6058]},{"Plant":"Martin","State":"FL","Gas":2043,"coordinates":[-80.5628,27.0536]},{"Plant":"DeBary","State":"FL","Gas":247,"coordinates":[-81.3323,28.9039]},{"Plant":"Electrifarm","State":"IA","Gas":188.8,"coordinates":[-92.4205,42.4407]},{"Plant":"Fredonia","State":"WA","Gas":280,"coordinates":[-122.4358,48.4558]},{"Plant":"Trimble County","State":"KY","Gas":942,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Gas":972,"coordinates":[-88.5553,30.5322]},{"Plant":"Greenwood","State":"MO","Gas":252.9,"coordinates":[-94.2982,38.8615]},{"Plant":"R M Schahfer","State":"IN","Gas":155,"coordinates":[-87.0261,41.2164]},{"Plant":"Cutler","State":"FL","Gas":205,"coordinates":[-80.2989,25.6321]},{"Plant":"Fort St Vrain","State":"CO","Gas":969,"coordinates":[-104.8742,40.2461]},{"Plant":"Fort Myers","State":"FL","Gas":1747,"coordinates":[-81.7831,26.6967]},{"Plant":"Whitehorn","State":"WA","Gas":134,"coordinates":[-122.6861,48.8288]},{"Plant":"McIntosh","State":"GA","Gas":657.6,"coordinates":[-81.1683,32.3563]},{"Plant":"Lauderdale","State":"FL","Gas":1724,"coordinates":[-80.1984,26.0686]},{"Plant":"A B Brown","State":"IN","Gas":160,"coordinates":[-87.715,37.9053]},{"Plant":"Port Everglades","State":"FL","Gas":420,"coordinates":[-80.1253,26.0856]},{"Plant":"Brame Energy Center","State":"LA","Gas":422,"coordinates":[-92.7167,31.395]},{"Plant":"John Twitty Energy Center","State":"MO","Gas":104,"coordinates":[-93.388,37.1517]},{"Plant":"Sanford","State":"FL","Gas":1912,"coordinates":[-81.3256,28.8419]},{"Plant":"Turkey Point","State":"FL","Gas":1148,"coordinates":[-80.3308,25.4356]},{"Plant":"Empire Energy Center","State":"MO","Gas":262,"coordinates":[-94.1041,37.1385]},{"Plant":"Dansby","State":"TX","Gas":204.2,"coordinates":[-96.4608,30.7217]},{"Plant":"Putnam","State":"FL","Gas":498,"coordinates":[-81.5851,29.6283]},{"Plant":"Higgins","State":"FL","Gas":105,"coordinates":[-82.6615,28.0033]},{"Plant":"P L Bartow","State":"FL","Gas":1225,"coordinates":[-82.6018,27.8595]},{"Plant":"Rokeby","State":"NE","Gas":225.8,"coordinates":[-96.7364,40.7316]},{"Plant":"Suwannee River","State":"FL","Gas":104,"coordinates":[-83.1806,30.3764]},{"Plant":"Lansing Smith","State":"FL","Gas":481,"coordinates":[-85.7003,30.2686]},{"Plant":"D G Hunter","State":"LA","Gas":130,"coordinates":[-92.4613,31.3207]},{"Plant":"George M Sullivan Generation Plant 2","State":"AK","Gas":219.9,"coordinates":[-149.7167,61.2297]},{"Plant":"Deerhaven Generating Station","State":"FL","Gas":193,"coordinates":[-82.3878,29.7592]},{"Plant":"John R Kelly","State":"FL","Gas":177.2,"coordinates":[-82.3208,29.6461]},{"Plant":"J D Kennedy","State":"FL","Gas":317.2,"coordinates":[-81.626,30.3648]},{"Plant":"Northside Generating Station","State":"FL","Gas":505,"coordinates":[-81.5525,30.4172]},{"Plant":"Larsen Memorial","State":"FL","Gas":124,"coordinates":[-81.9228,28.0797]},{"Plant":"C D McIntosh Jr","State":"FL","Gas":545,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Gas":388,"coordinates":[-105.0212,40.8609]},{"Plant":"Indian River Plant","State":"FL","Gas":290,"coordinates":[-80.7801,28.4932]},{"Plant":"Arvah B Hopkins","State":"FL","Gas":504,"coordinates":[-84.4,30.4522]},{"Plant":"S O Purdom","State":"FL","Gas":290,"coordinates":[-84.2007,30.1623]},{"Plant":"Vero Beach Municipal Power Plant","State":"FL","Gas":150,"coordinates":[-80.3776,27.6334]},{"Plant":"Gravel Neck","State":"VA","Gas":340,"coordinates":[-76.6911,37.1575]},{"Plant":"McIntosh","State":"AL","Gas":678,"coordinates":[-88.0299,31.2546]},{"Plant":"Harry Allen","State":"NV","Gas":566.8,"coordinates":[-114.9024,36.4306]},{"Plant":"Jack McDonough","State":"GA","Gas":904,"coordinates":[-84.4758,33.8239]},{"Plant":"Pleasant Hill","State":"IA","Gas":157.6,"coordinates":[-93.5242,41.5572]},{"Plant":"Hay Road","State":"DE","Gas":1130,"coordinates":[-75.5072,39.7436]},{"Plant":"Woodsdale","State":"OH","Gas":462,"coordinates":[-84.4611,39.4492]},{"Plant":"Concord","State":"WI","Gas":343.1,"coordinates":[-88.69,43.1669]},{"Plant":"South Fond Du Lac","State":"WI","Gas":306.4,"coordinates":[-88.4967,43.7353]},{"Plant":"Darbytown","State":"VA","Gas":336,"coordinates":[-77.3685,37.4982]},{"Plant":"Angus Anson","State":"SD","Gas":338,"coordinates":[-96.6356,43.6035]},{"Plant":"Cane Island","State":"FL","Gas":670,"coordinates":[-81.533,28.2764]},{"Plant":"Polk","State":"FL","Gas":604,"coordinates":[-81.9897,27.7286]},{"Plant":"Woodland","State":"CA","Gas":182.2,"coordinates":[-121.0204,37.6526]},{"Plant":"491 E 48th Street","State":"MI","Gas":136,"coordinates":[-86.0853,42.7553]},{"Plant":"Paris","State":"WI","Gas":335.9,"coordinates":[-88.0131,42.6658]},{"Plant":"Lincoln Combustion","State":"NC","Gas":1267.2,"coordinates":[-81.0347,35.4317]},{"Plant":"State Line Combined Cycle","State":"MO","Gas":589,"coordinates":[-94.614,37.0659]},{"Plant":"Hines Energy Complex","State":"FL","Gas":1921,"coordinates":[-81.87,27.7882]},{"Plant":"Redding Power","State":"CA","Gas":167,"coordinates":[-122.4233,40.5073]},{"Plant":"Richard M Flynn","State":"NY","Gas":136.2,"coordinates":[-73.064,40.8158]},{"Plant":"San Jacinto Steam Electric Station","State":"TX","Gas":162,"coordinates":[-95.0406,29.6948]},{"Plant":"Kraft","State":"GA","Gas":132,"coordinates":[-81.1458,32.1486]},{"Plant":"Anderson","State":"IN","Gas":140,"coordinates":[-85.7389,40.0529]},{"Plant":"Robins","State":"GA","Gas":160,"coordinates":[-83.5822,32.5792]},{"Plant":"Coyote Springs","State":"OR","Gas":276,"coordinates":[-119.6739,45.848]},{"Plant":"Midulla Generating Station","State":"FL","Gas":724,"coordinates":[-81.9625,27.6417]},{"Plant":"Interstate","State":"IL","Gas":114,"coordinates":[-89.5891,39.8233]},{"Plant":"Rathdrum","State":"ID","Gas":132,"coordinates":[-116.8673,47.8043]},{"Plant":"Arthur Von Rosenberg","State":"TX","Gas":530,"coordinates":[-98.384,29.257]},{"Plant":"Carson Ice-Gen Project","State":"CA","Gas":109,"coordinates":[-121.4624,38.4457]},{"Plant":"Wayne County","State":"NC","Gas":863,"coordinates":[-78.0981,35.3758]},{"Plant":"Ponca City","State":"OK","Gas":106.8,"coordinates":[-97.0858,36.7198]},{"Plant":"SCA Cogen 2","State":"CA","Gas":176.6,"coordinates":[-121.4001,38.5309]},{"Plant":"SPA Cogen 3","State":"CA","Gas":164,"coordinates":[-121.4735,38.511]},{"Plant":"St Francis Energy Facility","State":"MO","Gas":473,"coordinates":[-90.1779,36.5852]},{"Plant":"River Road Gen Plant","State":"WA","Gas":220,"coordinates":[-122.7256,45.6497]},{"Plant":"Tiger Bay","State":"FL","Gas":205,"coordinates":[-81.8494,27.7464]},{"Plant":"Dahlberg","State":"GA","Gas":747.3,"coordinates":[-83.3977,34.0423]},{"Plant":"H Allen Franklin Combined Cycle","State":"AL","Gas":1815,"coordinates":[-85.0975,32.6078]},{"Plant":"Theodore Cogen Facility","State":"AL","Gas":224.7,"coordinates":[-88.1285,30.5254]},{"Plant":"Essex","State":"MO","Gas":107.4,"coordinates":[-89.8402,36.8682]},{"Plant":"Nodaway","State":"MO","Gas":182.8,"coordinates":[-94.7913,40.2877]},{"Plant":"Chouteau","State":"OK","Gas":990,"coordinates":[-95.2771,36.2221]},{"Plant":"Georgetown","State":"IN","Gas":295,"coordinates":[-86.2441,39.9026]},{"Plant":"Tilton","State":"IL","Gas":176,"coordinates":[-87.6538,40.1061]},{"Plant":"Henry County","State":"IN","Gas":129,"coordinates":[-85.5039,39.9528]},{"Plant":"MPC Generating","State":"GA","Gas":302.5,"coordinates":[-83.6953,33.8119]},{"Plant":"Sherwood H Smith Jr Energy Complex","State":"NC","Gas":1904,"coordinates":[-79.7406,34.8392]},{"Plant":"Sewell Creek Energy","State":"GA","Gas":451.5,"coordinates":[-85.2769,33.9486]},{"Plant":"Alsey","State":"IL","Gas":121,"coordinates":[-90.436,39.5698]},{"Plant":"Fulton","State":"AR","Gas":153,"coordinates":[-93.7924,33.6094]},{"Plant":"Rowan","State":"NC","Gas":924.6,"coordinates":[-80.6019,35.7314]},{"Plant":"Smarr Energy Center","State":"GA","Gas":190.6,"coordinates":[-83.8464,32.9842]},{"Plant":"John S Rainey","State":"SC","Gas":977,"coordinates":[-82.776,34.3477]},{"Plant":"Essential Power Rock Springs LLC","State":"MD","Gas":653.8,"coordinates":[-76.1598,39.719]},{"Plant":"Marsh Run Generating","State":"VA","Gas":481,"coordinates":[-77.7681,38.5283]},{"Plant":"Louisa Generating","State":"VA","Gas":466,"coordinates":[-78.2139,38.1181]},{"Plant":"Remington","State":"VA","Gas":608,"coordinates":[-77.7714,38.5442]},{"Plant":"Ladysmith","State":"VA","Gas":783,"coordinates":[-77.5133,38.0722]},{"Plant":"Pleasant Valley","State":"MN","Gas":436.1,"coordinates":[-92.6829,43.7994]},{"Plant":"Lagoon Creek","State":"TN","Gas":1480.8,"coordinates":[-89.3964,35.6578]},{"Plant":"Brandy Branch","State":"FL","Gas":660.8,"coordinates":[-81.9472,30.3206]},{"Plant":"Holden","State":"MO","Gas":232.8,"coordinates":[-93.9983,38.7538]},{"Plant":"MEPI GT Facility","State":"IL","Gas":239,"coordinates":[-88.8661,37.2175]},{"Plant":"Encogen","State":"WA","Gas":159.4,"coordinates":[-122.486,48.746]},{"Plant":"Robert P Mone Plant","State":"OH","Gas":453.6,"coordinates":[-84.7392,40.9297]},{"Plant":"H L Culbreath Bayside Power Station","State":"FL","Gas":1854,"coordinates":[-82.4231,27.9072]},{"Plant":"Terry Bundy Generating Station","State":"NE","Gas":144.3,"coordinates":[-96.6131,40.9097]},{"Plant":"E B Harris Electric Generating Plant","State":"AL","Gas":1268.7,"coordinates":[-86.5744,32.3814]},{"Plant":"Sand Hill","State":"TX","Gas":595.8,"coordinates":[-97.6129,30.2098]},{"Plant":"Talbot County Energy","State":"GA","Gas":571.7,"coordinates":[-84.6917,32.5892]},{"Plant":"Chattahoochee Energy Facility","State":"GA","Gas":468.2,"coordinates":[-85.0386,33.4072]},{"Plant":"Lakefield Junction","State":"MN","Gas":514.9,"coordinates":[-94.8415,43.7984]},{"Plant":"West Gardner","State":"KS","Gas":309.6,"coordinates":[-94.9861,38.7875]},{"Plant":"Coyote Springs II","State":"OR","Gas":242.7,"coordinates":[-119.674,45.848]},{"Plant":"Wansley Unit 9","State":"GA","Gas":496.9,"coordinates":[-85.0403,33.4083]},{"Plant":"Lawrence County Station","State":"IN","Gas":251.5,"coordinates":[-86.4511,38.8003]},{"Plant":"Evander Andrews Power Complex","State":"ID","Gas":247,"coordinates":[-115.7343,43.1792]},{"Plant":"Kemper County","State":"MS","Gas":312.8,"coordinates":[-88.606,32.7976]},{"Plant":"Peno Creek","State":"MO","Gas":188,"coordinates":[-91.2295,39.3531]},{"Plant":"Sumpter","State":"MI","Gas":308.4,"coordinates":[-83.5318,42.167]},{"Plant":"Pyramid","State":"NM","Gas":158,"coordinates":[-108.5494,32.2363]},{"Plant":"Mill Creek","State":"SC","Gas":595.2,"coordinates":[-81.4306,35.1597]},{"Plant":"Greater Des Moines","State":"IA","Gas":495,"coordinates":[-93.5283,41.5563]},{"Plant":"Silver Creek","State":"MS","Gas":225,"coordinates":[-89.9468,31.6004]},{"Plant":"Sylvarena","State":"MS","Gas":129,"coordinates":[-89.4127,31.9821]},{"Plant":"West Campus Cogeneration Facility","State":"WI","Gas":130.4,"coordinates":[-89.4251,43.0751]},{"Plant":"Grays Harbor Energy Facility","State":"WA","Gas":637,"coordinates":[-123.48,46.9692]},{"Plant":"Beatrice","State":"NE","Gas":217,"coordinates":[-96.8082,40.3302]},{"Plant":"Roseton Generating Facility","State":"NY","Gas":1159,"coordinates":[-73.9663,41.5738]},{"Plant":"Blue Lake","State":"MN","Gas":300,"coordinates":[-93.4315,44.7855]},{"Plant":"Sycamore","State":"IA","Gas":149.1,"coordinates":[-93.6769,41.6722]},{"Plant":"Emery Station","State":"IA","Gas":524.3,"coordinates":[-93.2922,43.094]},{"Plant":"Intercession City","State":"FL","Gas":557,"coordinates":[-81.5486,28.2628]},{"Plant":"Gerald Andrus","State":"MS","Gas":712,"coordinates":[-91.1167,33.35]},{"Plant":"Waterford 1 & 2","State":"LA","Gas":822,"coordinates":[-90.4768,29.9989]},{"Plant":"Comanche","State":"OK","Gas":260,"coordinates":[-98.3244,34.5431]},{"Plant":"DeCordova Steam Electric Station","State":"TX","Gas":1138,"coordinates":[-97.7006,32.4031]},{"Plant":"Santan","State":"AZ","Gas":1227,"coordinates":[-111.7503,33.3325]},{"Plant":"Beaver","State":"OR","Gas":487,"coordinates":[-123.1739,46.1724]},{"Plant":"Glen Gardner","State":"NJ","Gas":160,"coordinates":[-74.9207,40.6815]},{"Plant":"Grand Tower","State":"IL","Gas":513,"coordinates":[-89.5112,37.6577]},{"Plant":"Astoria Generating Station","State":"NY","Gas":199.7,"coordinates":[-73.9126,40.7877]},{"Plant":"Venice","State":"IL","Gas":491,"coordinates":[-90.1764,38.6642]},{"Plant":"Beluga","State":"AK","Gas":344.4,"coordinates":[-151.0356,61.1861]},{"Plant":"Marion","State":"IL","Gas":140,"coordinates":[-88.9531,37.6197]},{"Plant":"Frederickson","State":"WA","Gas":134,"coordinates":[-122.365,47.0797]},{"Plant":"Harding Street","State":"IN","Gas":322,"coordinates":[-86.1969,39.7113]}]

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Gas":740,"coordinates":[-87.7811,32.6017]},{"Plant":"Gilroy Power Plant","State":"CA","Gas":105,"coordinates":[-121.5367,37.0001]},{"Plant":"Noblesville","State":"IN","Gas":285.2,"coordinates":[-85.9714,40.0969]},{"Plant":"Pedricktown Cogeneration Company LP","State":"NJ","Gas":117.9,"coordinates":[-75.4238,39.7668]},{"Plant":"Broadway","State":"IN","Gas":115,"coordinates":[-87.6049,37.9691]},{"Plant":"Butler-Warner Generation Plant","State":"NC","Gas":225,"coordinates":[-78.8294,35.0986]},{"Plant":"El Segundo Cogen","State":"CA","Gas":127.7,"coordinates":[-118.4031,33.9058]},{"Plant":"ArcelorMittal Burns Harbor","State":"IN","Gas":174.7,"coordinates":[-87.1387,41.635]},{"Plant":"King City Power Plant","State":"CA","Gas":111,"coordinates":[-121.1278,36.225]},{"Plant":"Bayou Cogen Plant","State":"TX","Gas":260,"coordinates":[-95.0458,29.6225]},{"Plant":"Bellingham Cogeneration Facility","State":"MA","Gas":264,"coordinates":[-71.4833,42.0925]},{"Plant":"Sayreville Cogeneration Facility","State":"NJ","Gas":271,"coordinates":[-74.3444,40.439]},{"Plant":"Foster Wheeler Martinez","State":"CA","Gas":103.5,"coordinates":[-122.0589,38.0244]},{"Plant":"ExxonMobil Baytown Refinery","State":"TX","Gas":130,"coordinates":[-94.9973,29.7535]},{"Plant":"Kern River Cogeneration","State":"CA","Gas":288,"coordinates":[-118.9849,35.4515]},{"Plant":"Formosa Utility Venture Ltd","State":"TX","Gas":597.3,"coordinates":[-96.5417,28.6917]},{"Plant":"Hopewell Cogeneration","State":"VA","Gas":348.3,"coordinates":[-77.2811,37.2917]},{"Plant":"Brush Generation Facility","State":"CO","Gas":292,"coordinates":[-103.631,40.2415]},{"Plant":"ExxonMobil Baytown Turbine","State":"TX","Gas":320.4,"coordinates":[-95.0096,29.7591]},{"Plant":"Selkirk Cogen","State":"NY","Gas":353.9,"coordinates":[-73.8592,42.5744]},{"Plant":"Masspower","State":"MA","Gas":714.9,"coordinates":[-72.5225,42.1575]},{"Plant":"Clear Lake Cogeneration Ltd","State":"TX","Gas":366,"coordinates":[-95.067,29.6255]},{"Plant":"Midland Cogeneration Venture","State":"MI","Gas":1859.4,"coordinates":[-84.2242,43.5861]},{"Plant":"Camden Plant Holding LLC","State":"NJ","Gas":145,"coordinates":[-75.1192,39.9175]},{"Plant":"Sutherland","State":"IA","Gas":107,"coordinates":[-92.8594,42.0473]},{"Plant":"River Hills","State":"IA","Gas":116.9,"coordinates":[-93.6195,41.5902]},{"Plant":"Hazelton","State":"PA","Gas":147.2,"coordinates":[-76.0409,40.9282]},{"Plant":"Ocotillo","State":"AZ","Gas":320,"coordinates":[-111.9122,33.4225]},{"Plant":"West Phoenix","State":"AZ","Gas":952,"coordinates":[-112.1583,33.4417]},{"Plant":"Saguaro","State":"AZ","Gas":386,"coordinates":[-111.3,32.5517]},{"Plant":"Yucca","State":"AZ","Gas":257,"coordinates":[-114.7106,32.7214]},{"Plant":"Fort Dodge","State":"KS","Gas":147.8,"coordinates":[-99.9497,37.7328]},{"Plant":"Great Bend","State":"KS","Gas":100.6,"coordinates":[-98.8689,38.41]},{"Plant":"Riverton","State":"KS","Gas":192,"coordinates":[-94.6987,37.0726]},{"Plant":"Gordon Evans Energy Center","State":"KS","Gas":821,"coordinates":[-97.5217,37.7903]},{"Plant":"Murray Gill","State":"KS","Gas":293,"coordinates":[-97.4136,37.5967]},{"Plant":"Hutchinson Energy Center","State":"KS","Gas":334,"coordinates":[-97.8747,38.0906]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Gas":316,"coordinates":[-110.9047,32.16]},{"Plant":"Kaw","State":"KS","Gas":140.3,"coordinates":[-94.6514,39.0867]},{"Plant":"McPherson 2","State":"KS","Gas":104,"coordinates":[-97.6834,38.3634]},{"Plant":"Garden City","State":"KS","Gas":230.7,"coordinates":[-100.8956,37.9703]},{"Plant":"E W Brown","State":"KY","Gas":812,"coordinates":[-84.7126,37.7883]},{"Plant":"Paddys Run","State":"KY","Gas":182,"coordinates":[-85.8417,38.2236]},{"Plant":"Louisiana 1","State":"LA","Gas":382.4,"coordinates":[-91.1864,30.4922]},{"Plant":"Louisiana 2","State":"LA","Gas":138,"coordinates":[-91.1864,30.4922]},{"Plant":"R S Nelson","State":"LA","Gas":556,"coordinates":[-93.2911,30.2844]},{"Plant":"Willow Glen","State":"LA","Gas":1752,"coordinates":[-91.1164,30.2743]},{"Plant":"Coughlin Power Station","State":"LA","Gas":732,"coordinates":[-92.2611,30.8439]},{"Plant":"Teche","State":"LA","Gas":380,"coordinates":[-91.5425,29.8222]},{"Plant":"Little Gypsy","State":"LA","Gas":1159,"coordinates":[-90.4617,30.0051]},{"Plant":"Nine Mile Point","State":"LA","Gas":1365,"coordinates":[-90.1458,29.9472]},{"Plant":"Sterlington","State":"LA","Gas":174,"coordinates":[-92.0792,32.7047]},{"Plant":"Michoud","State":"LA","Gas":705,"coordinates":[-89.9372,30.0081]},{"Plant":"Agua Fria","State":"AZ","Gas":626,"coordinates":[-112.2153,33.5561]},{"Plant":"Arsenal Hill","State":"LA","Gas":116,"coordinates":[-93.7611,32.5181]},{"Plant":"Lieberman","State":"LA","Gas":268,"coordinates":[-93.9597,32.7047]},{"Plant":"Louis Doc Bonin","State":"LA","Gas":256,"coordinates":[-92.0463,30.238]},{"Plant":"Big Cajun 1","State":"LA","Gas":430,"coordinates":[-91.3556,30.6739]},{"Plant":"Kyrene","State":"AZ","Gas":525,"coordinates":[-111.9353,33.3556]},{"Plant":"Herbert A Wagner","State":"MD","Gas":126,"coordinates":[-76.5268,39.1781]},{"Plant":"Notch Cliff","State":"MD","Gas":116.7,"coordinates":[-76.5087,39.4217]},{"Plant":"Perryman","State":"MD","Gas":147.6,"coordinates":[-76.2218,39.4428]},{"Plant":"Riverside","State":"MD","Gas":189,"coordinates":[-76.5133,39.2369]},{"Plant":"Westport","State":"MD","Gas":115.8,"coordinates":[-76.6295,39.266]},{"Plant":"Dickerson","State":"MD","Gas":278,"coordinates":[-77.4644,39.2097]},{"Plant":"Mystic Generating Station","State":"MA","Gas":1967.5,"coordinates":[-71.0675,42.3908]},{"Plant":"Kendall Square Station","State":"MA","Gas":208.5,"coordinates":[-71.0792,42.3633]},{"Plant":"Apache Station","State":"AZ","Gas":198.5,"coordinates":[-109.8931,32.0603]},{"Plant":"Potter Station 2","State":"MA","Gas":183.3,"coordinates":[-70.9672,42.235]},{"Plant":"Cecil Lynch","State":"AR","Gas":170,"coordinates":[-92.1987,34.7535]},{"Plant":"Hamilton Moses","State":"AR","Gas":134,"coordinates":[-90.8722,34.9806]},{"Plant":"Harvey Couch","State":"AR","Gas":123,"coordinates":[-93.4649,33.3592]},{"Plant":"B C Cobb","State":"MI","Gas":187,"coordinates":[-86.2423,43.2588]},{"Plant":"Lake Catherine","State":"AR","Gas":713,"coordinates":[-92.9049,34.4341]},{"Plant":"Dan E Karn","State":"MI","Gas":1276,"coordinates":[-83.8401,43.645]},{"Plant":"Thetford","State":"MI","Gas":183,"coordinates":[-83.6286,43.1567]},{"Plant":"Conners Creek","State":"MI","Gas":230,"coordinates":[-82.9597,42.3592]},{"Plant":"Delray","State":"MI","Gas":120,"coordinates":[-83.1019,42.2947]},{"Plant":"Robert E Ritchie","State":"AR","Gas":860,"coordinates":[-90.5987,34.4629]},{"Plant":"Hancock","State":"MI","Gas":124,"coordinates":[-83.4425,42.5497]},{"Plant":"River Rouge","State":"MI","Gas":234,"coordinates":[-83.1119,42.2739]},{"Plant":"Mistersky","State":"MI","Gas":110,"coordinates":[-83.0903,42.3039]},{"Plant":"Black Dog","State":"MN","Gas":270,"coordinates":[-93.2501,44.8108]},{"Plant":"High Bridge","State":"MN","Gas":486,"coordinates":[-93.1117,44.9314]},{"Plant":"Inver Hills","State":"MN","Gas":282,"coordinates":[-93.042,44.781]},{"Plant":"Riverside","State":"MN","Gas":470,"coordinates":[-93.2753,45.0203]},{"Plant":"Thomas Fitzhugh","State":"AR","Gas":165,"coordinates":[-93.8049,35.4624]},{"Plant":"Carl Bailey","State":"AR","Gas":122,"coordinates":[-91.3634,35.2601]},{"Plant":"McClellan","State":"AR","Gas":134,"coordinates":[-92.7917,33.5648]},{"Plant":"Cambridge CT","State":"MN","Gas":159,"coordinates":[-93.2081,45.601]},{"Plant":"Elk River","State":"MN","Gas":186.3,"coordinates":[-93.5584,45.2968]},{"Plant":"Chevron Oil","State":"MS","Gas":130,"coordinates":[-88.4919,30.34]},{"Plant":"Sweatt","State":"MS","Gas":124,"coordinates":[-88.7461,32.2925]},{"Plant":"Jack Watson","State":"MS","Gas":292,"coordinates":[-89.0286,30.4392]},{"Plant":"Baxter Wilson","State":"MS","Gas":1176,"coordinates":[-90.9306,32.2831]},{"Plant":"Rex Brown","State":"MS","Gas":279,"coordinates":[-90.213,32.357]},{"Plant":"Moselle","State":"MS","Gas":477,"coordinates":[-89.3004,31.528]},{"Plant":"Hawthorn","State":"MO","Gas":385.7,"coordinates":[-94.4778,39.1306]},{"Plant":"Lake Road","State":"MO","Gas":126.1,"coordinates":[-94.8773,39.7246]},{"Plant":"James River Power Station","State":"MO","Gas":155,"coordinates":[-93.2619,37.1086]},{"Plant":"C W Burdick","State":"NE","Gas":174.1,"coordinates":[-98.3269,40.9228]},{"Plant":"Contra Costa","State":"CA","Gas":674,"coordinates":[-121.7642,38.0192]},{"Plant":"Sarpy County","State":"NE","Gas":311.9,"coordinates":[-95.9706,41.1706]},{"Plant":"Clark","State":"NV","Gas":1138,"coordinates":[-115.0507,36.0875]},{"Plant":"Fort Churchill","State":"NV","Gas":226,"coordinates":[-119.1322,39.1281]},{"Plant":"Tracy","State":"NV","Gas":1033.6,"coordinates":[-119.525,39.5625]},{"Plant":"Deepwater","State":"NJ","Gas":160.1,"coordinates":[-75.5083,39.6831]},{"Plant":"Sayreville","State":"NJ","Gas":150,"coordinates":[-74.3523,40.4765]},{"Plant":"Gilbert","State":"NJ","Gas":516,"coordinates":[-75.1639,40.5658]},{"Plant":"Bergen Generating Station","State":"NJ","Gas":1206.5,"coordinates":[-74.0244,40.8375]},{"Plant":"PSEG Burlington Generating Station","State":"NJ","Gas":170.2,"coordinates":[-74.8792,40.0766]},{"Plant":"PSEG Edison Generating Station","State":"NJ","Gas":517.7,"coordinates":[-74.3956,40.4911]},{"Plant":"PSEG Essex Generating Station","State":"NJ","Gas":628.5,"coordinates":[-74.1206,40.7372]},{"Plant":"PSEG Kearny Generating Station","State":"NJ","Gas":488.9,"coordinates":[-74.0965,40.7373]},{"Plant":"PSEG Linden Generating Station","State":"NJ","Gas":1609.4,"coordinates":[-74.2072,40.6217]},{"Plant":"PSEG Sewaren Generating Station","State":"NJ","Gas":451.5,"coordinates":[-74.2469,40.5558]},{"Plant":"Rio Grande","State":"NM","Gas":236,"coordinates":[-106.5472,31.8047]},{"Plant":"Maddox","State":"NM","Gas":183,"coordinates":[-103.3015,32.7142]},{"Plant":"Reeves","State":"NM","Gas":154,"coordinates":[-106.6019,35.171]},{"Plant":"Cunningham","State":"NM","Gas":466,"coordinates":[-103.3533,32.7131]},{"Plant":"Humboldt Bay","State":"CA","Gas":167,"coordinates":[-124.2103,40.7415]},{"Plant":"Arthur Kill Generating Station","State":"NY","Gas":858,"coordinates":[-74.2,40.5916]},{"Plant":"East River","State":"NY","Gas":292.6,"coordinates":[-73.9742,40.7281]},{"Plant":"Gowanus Gas Turbines Generating","State":"NY","Gas":280.1,"coordinates":[-74.0051,40.6635]},{"Plant":"Narrows Gas Turbines Generating","State":"NY","Gas":286,"coordinates":[-74.0208,40.6486]},{"Plant":"Ravenswood","State":"NY","Gas":2323.2,"coordinates":[-73.9461,40.7592]},{"Plant":"E F Barrett","State":"NY","Gas":668,"coordinates":[-73.6479,40.6167]},{"Plant":"Northport","State":"NY","Gas":1572.3,"coordinates":[-73.3423,40.9236]},{"Plant":"Port Jefferson","State":"NY","Gas":478.4,"coordinates":[-73.0785,40.9497]},{"Plant":"Bethlehem Energy Center","State":"NY","Gas":756,"coordinates":[-73.7638,42.5942]},{"Plant":"Dynegy Morro Bay LLC","State":"CA","Gas":999,"coordinates":[-120.8566,35.3722]},{"Plant":"Dynegy Moss Landing Power Plant","State":"CA","Gas":2529,"coordinates":[-121.7822,36.8048]},{"Plant":"Bowline Point","State":"NY","Gas":753,"coordinates":[-73.9689,41.2044]},{"Plant":"Asheville","State":"NC","Gas":324,"coordinates":[-82.5417,35.4731]},{"Plant":"Pittsburg Power","State":"CA","Gas":1311,"coordinates":[-121.8945,38.0392]},{"Plant":"Buck","State":"NC","Gas":620,"coordinates":[-80.3767,35.7133]},{"Plant":"Dan River","State":"NC","Gas":620,"coordinates":[-79.7208,36.4862]},{"Plant":"Dicks Creek","State":"OH","Gas":106.2,"coordinates":[-84.3778,39.465]},{"Plant":"Frank M Tait","State":"OH","Gas":256,"coordinates":[-84.2111,39.7272]},{"Plant":"Yankee Street","State":"OH","Gas":100.3,"coordinates":[-84.2047,39.603]},{"Plant":"FirstEnergy West Lorain","State":"OH","Gas":425,"coordinates":[-82.2644,41.4294]},{"Plant":"Richland","State":"OH","Gas":358,"coordinates":[-84.3346,41.3052]},{"Plant":"Horseshoe Lake","State":"OK","Gas":883,"coordinates":[-97.1797,35.5087]},{"Plant":"Mustang","State":"OK","Gas":535,"coordinates":[-97.675,35.4699]},{"Plant":"Seminole","State":"OK","Gas":1447.2,"coordinates":[-96.7258,34.9665]},{"Plant":"Northeastern","State":"OK","Gas":891,"coordinates":[-95.7008,36.4317]},{"Plant":"Southwestern","State":"OK","Gas":603,"coordinates":[-98.3524,35.1009]},{"Plant":"Tulsa","State":"OK","Gas":305,"coordinates":[-95.991,36.1165]},{"Plant":"Weleetka","State":"OK","Gas":163,"coordinates":[-96.1352,35.3233]},{"Plant":"Barry","State":"AL","Gas":962,"coordinates":[-88.0103,31.0069]},{"Plant":"Anadarko Plant","State":"OK","Gas":485,"coordinates":[-98.23,35.0847]},{"Plant":"Mooreland","State":"OK","Gas":322,"coordinates":[-99.2254,36.4372]},{"Plant":"Encina","State":"CA","Gas":964,"coordinates":[-117.3364,33.1361]},{"Plant":"Kearny","State":"CA","Gas":136,"coordinates":[-117.1338,32.834]},{"Plant":"Brunot Island","State":"PA","Gas":198,"coordinates":[-80.0438,40.4649]},{"Plant":"PPL Martins Creek","State":"PA","Gas":1772,"coordinates":[-75.1054,40.7978]},{"Plant":"AES Alamitos LLC","State":"CA","Gas":1997,"coordinates":[-118.1009,33.7688]},{"Plant":"Hunlock Power Station","State":"PA","Gas":126.4,"coordinates":[-76.07,41.2006]},{"Plant":"Manchester Street","State":"RI","Gas":447,"coordinates":[-71.4042,41.8167]},{"Plant":"Darlington County","State":"SC","Gas":441,"coordinates":[-80.1657,34.4185]},{"Plant":"Hagood","State":"SC","Gas":126,"coordinates":[-79.9634,32.8265]},{"Plant":"Coolwater","State":"CA","Gas":636,"coordinates":[-116.8539,34.8606]},{"Plant":"Urquhart","State":"SC","Gas":640,"coordinates":[-81.9111,33.435]},{"Plant":"El Segundo Power","State":"CA","Gas":670,"coordinates":[-118.4242,33.9098]},{"Plant":"Etiwanda Generating Station","State":"CA","Gas":640,"coordinates":[-117.5266,34.0912]},{"Plant":"AES Huntington Beach LLC","State":"CA","Gas":451.6,"coordinates":[-117.9792,33.6439]},{"Plant":"Allen Steam Plant","State":"TN","Gas":427.2,"coordinates":[-90.1487,35.0741]},{"Plant":"Gallatin","State":"TN","Gas":579.6,"coordinates":[-86.4006,36.3156]},{"Plant":"John Sevier","State":"TN","Gas":878,"coordinates":[-82.9639,36.3767]},{"Plant":"Johnsonville","State":"TN","Gas":1044.8,"coordinates":[-87.9861,36.0278]},{"Plant":"Long Beach Generation LLC","State":"CA","Gas":260,"coordinates":[-118.2248,33.7641]},{"Plant":"E S Joslin","State":"TX","Gas":254,"coordinates":[-96.5458,28.6472]},{"Plant":"Laredo","State":"TX","Gas":178,"coordinates":[-99.5089,27.5667]},{"Plant":"Nueces Bay","State":"TX","Gas":718.2,"coordinates":[-97.4192,27.8194]},{"Plant":"Victoria","State":"TX","Gas":285,"coordinates":[-97.01,28.7883]},{"Plant":"Mandalay","State":"CA","Gas":560,"coordinates":[-119.2511,34.2067]},{"Plant":"Lake Hubbard","State":"TX","Gas":907,"coordinates":[-96.5458,32.8358]},{"Plant":"Mountain Creek","State":"TX","Gas":808,"coordinates":[-96.9358,32.7231]},{"Plant":"Newman","State":"TX","Gas":760.9,"coordinates":[-106.4318,31.9836]},{"Plant":"Lewis Creek","State":"TX","Gas":460,"coordinates":[-95.5214,30.4356]},{"Plant":"Sabine","State":"TX","Gas":1809,"coordinates":[-93.878,30.0242]},{"Plant":"Cedar Bayou","State":"TX","Gas":1495,"coordinates":[-94.9256,29.75]},{"Plant":"Greens Bayou","State":"TX","Gas":760,"coordinates":[-95.2194,29.8222]},{"Plant":"Sam Bertron","State":"TX","Gas":765,"coordinates":[-95.0598,29.7268]},{"Plant":"T H Wharton","State":"TX","Gas":1025,"coordinates":[-95.5306,29.9417]},{"Plant":"W A Parish","State":"TX","Gas":1176,"coordinates":[-95.6311,29.4828]},{"Plant":"Knox Lee","State":"TX","Gas":471,"coordinates":[-94.6415,32.3766]},{"Plant":"Wilkes","State":"TX","Gas":883,"coordinates":[-94.548,32.8482]},{"Plant":"Jones","State":"TX","Gas":657,"coordinates":[-101.7392,33.5239]},{"Plant":"Nichols","State":"TX","Gas":457,"coordinates":[-101.7464,35.2834]},{"Plant":"Plant X","State":"TX","Gas":412,"coordinates":[-102.4114,34.1661]},{"Plant":"Graham","State":"TX","Gas":615,"coordinates":[-98.6117,33.1344]},{"Plant":"Handley","State":"TX","Gas":1265,"coordinates":[-97.2192,32.7283]},{"Plant":"Morgan Creek","State":"TX","Gas":407,"coordinates":[-100.9156,32.3358]},{"Plant":"Permian Basin","State":"TX","Gas":995,"coordinates":[-102.9633,31.5839]},{"Plant":"Ormond Beach","State":"CA","Gas":1516,"coordinates":[-119.1689,34.1292]},{"Plant":"Lake Creek","State":"TX","Gas":317,"coordinates":[-96.985,31.4647]},{"Plant":"Stryker Creek","State":"TX","Gas":669,"coordinates":[-94.9898,31.9398]},{"Plant":"Trinidad","State":"TX","Gas":226,"coordinates":[-96.1013,32.1245]},{"Plant":"Valley","State":"TX","Gas":1069,"coordinates":[-96.3676,33.6281]},{"Plant":"Decker Creek","State":"TX","Gas":932,"coordinates":[-97.6128,30.3033]},{"Plant":"Silas Ray","State":"TX","Gas":125,"coordinates":[-97.5214,25.9131]},{"Plant":"AES Redondo Beach LLC","State":"CA","Gas":1310,"coordinates":[-118.395,33.8504]},{"Plant":"Bryan","State":"TX","Gas":130,"coordinates":[-96.3723,30.6474]},{"Plant":"Ray Olinger","State":"TX","Gas":395,"coordinates":[-96.4525,33.0681]},{"Plant":"Mountainview Generating Station","State":"CA","Gas":972,"coordinates":[-117.2418,34.0818]},{"Plant":"Sim Gideon","State":"TX","Gas":620,"coordinates":[-97.2708,30.1456]},{"Plant":"Ty Cooke","State":"TX","Gas":120,"coordinates":[-101.7906,33.5211]},{"Plant":"Leon Creek","State":"TX","Gas":339,"coordinates":[-98.5761,29.3525]},{"Plant":"O W Sommers","State":"TX","Gas":830,"coordinates":[-98.3242,29.3081]},{"Plant":"V H Braunig","State":"TX","Gas":1055,"coordinates":[-98.3825,29.2567]},{"Plant":"R W Miller","State":"TX","Gas":574,"coordinates":[-98.3103,32.6581]},{"Plant":"Pearsall","State":"TX","Gas":270.6,"coordinates":[-99.0919,28.9275]},{"Plant":"Sam Rayburn","State":"TX","Gas":227,"coordinates":[-97.135,28.8947]},{"Plant":"Gadsby","State":"UT","Gas":347.5,"coordinates":[-111.9289,40.7686]},{"Plant":"Grayson","State":"CA","Gas":256,"coordinates":[-118.2782,34.1556]},{"Plant":"Chesterfield","State":"VA","Gas":397,"coordinates":[-77.3833,37.3822]},{"Plant":"Possum Point","State":"VA","Gas":875,"coordinates":[-77.2806,38.5367]},{"Plant":"Transalta Centralia Generation","State":"WA","Gas":256,"coordinates":[-122.8598,46.7559]},{"Plant":"El Centro","State":"CA","Gas":328,"coordinates":[-115.54,32.8022]},{"Plant":"Harbor","State":"CA","Gas":461,"coordinates":[-118.2656,33.7706]},{"Plant":"Blount Street","State":"WI","Gas":100.1,"coordinates":[-89.3744,43.0789]},{"Plant":"Haynes","State":"CA","Gas":1524,"coordinates":[-118.0991,33.7647]},{"Plant":"Wheaton","State":"WI","Gas":190,"coordinates":[-91.5158,44.8854]},{"Plant":"Scattergood","State":"CA","Gas":796,"coordinates":[-118.4276,33.9182]},{"Plant":"Port Washington Generating Station","State":"WI","Gas":1090,"coordinates":[-87.8689,43.3842]},{"Plant":"Rock River","State":"WI","Gas":141.2,"coordinates":[-89.0276,42.582]},{"Plant":"West Marinette","State":"WI","Gas":156.4,"coordinates":[-87.6881,45.0869]},{"Plant":"Valley","State":"CA","Gas":556,"coordinates":[-118.3913,34.245]},{"Plant":"Powerlane Plant","State":"TX","Gas":111,"coordinates":[-96.1264,33.1707]},{"Plant":"Glenarm","State":"CA","Gas":155,"coordinates":[-118.1494,34.126]},{"Plant":"Spencer","State":"TX","Gas":122,"coordinates":[-97.1061,33.1975]},{"Plant":"Colbert","State":"AL","Gas":363.2,"coordinates":[-87.8486,34.7439]},{"Plant":"Thomas C Ferguson","State":"TX","Gas":350,"coordinates":[-98.3705,30.558]},{"Plant":"Barney M Davis","State":"TX","Gas":1032.2,"coordinates":[-97.3117,27.6064]},{"Plant":"Riverside","State":"OK","Gas":1067,"coordinates":[-95.9567,35.9978]},{"Plant":"Pittsfield Generating LP","State":"MA","Gas":154.3,"coordinates":[-73.2181,42.4564]},{"Plant":"Linden Cogen Plant","State":"NJ","Gas":916.4,"coordinates":[-74.2156,40.6322]},{"Plant":"Houston Chemical Complex Battleground","State":"TX","Gas":263,"coordinates":[-95.0839,29.7314]},{"Plant":"Paris Energy Center","State":"TX","Gas":238,"coordinates":[-95.5577,33.6968]},{"Plant":"Hal C Weaver Power Plant","State":"TX","Gas":146.8,"coordinates":[-97.7356,30.2867]},{"Plant":"Sycamore Cogeneration","State":"CA","Gas":300,"coordinates":[-118.9853,35.4526]},{"Plant":"Union Carbide Seadrift Cogen","State":"TX","Gas":168,"coordinates":[-96.7706,28.5105]},{"Plant":"Dow St Charles Operations","State":"LA","Gas":289.6,"coordinates":[-90.4414,29.9861]},{"Plant":"Watson Cogeneration","State":"CA","Gas":398,"coordinates":[-118.2448,33.8166]},{"Plant":"Bucksport Generation LLC","State":"ME","Gas":273.8,"coordinates":[-68.8046,44.5738]},{"Plant":"Bethpage Power Plant","State":"NY","Gas":184,"coordinates":[-73.4994,40.7469]},{"Plant":"Shell Deer Park","State":"TX","Gas":140,"coordinates":[-95.1289,29.7232]},{"Plant":"Newark Bay Cogeneration Partnership LP","State":"NJ","Gas":120.2,"coordinates":[-74.13,40.7197]},{"Plant":"Indeck Corinth Energy Center","State":"NY","Gas":129.8,"coordinates":[-73.8125,43.25]},{"Plant":"PPG Powerhouse C","State":"LA","Gas":303.2,"coordinates":[-93.2831,30.2242]},{"Plant":"Bayonne Plant Holding LLC","State":"NJ","Gas":158,"coordinates":[-74.1124,40.6553]},{"Plant":"Harbor Cogen","State":"CA","Gas":101.7,"coordinates":[-118.2303,33.7771]},{"Plant":"Rosemary Power Station","State":"NC","Gas":165,"coordinates":[-77.6594,36.4517]},{"Plant":"Oklahoma Cogeneration Project","State":"OK","Gas":111.4,"coordinates":[-97.625,35.4397]},{"Plant":"Eagle Point Power Generation","State":"NJ","Gas":195,"coordinates":[-75.1592,39.8746]},{"Plant":"ExxonMobil Beaumont Refinery","State":"TX","Gas":610.6,"coordinates":[-94.0753,30.0636]},{"Plant":"JM Shafer Generating Station","State":"CO","Gas":263,"coordinates":[-104.7736,40.0986]},{"Plant":"Gary Works","State":"IN","Gas":161,"coordinates":[-87.3289,41.6224]},{"Plant":"Parlin Power Plant","State":"NJ","Gas":116.6,"coordinates":[-74.3272,40.4607]},{"Plant":"Optim Energy Altura Cogen LLC","State":"TX","Gas":493,"coordinates":[-95.1077,29.8161]},{"Plant":"Cumberland","State":"NJ","Gas":183.1,"coordinates":[-74.9654,39.3757]},{"Plant":"Gramercy Holdings LLC","State":"LA","Gas":106,"coordinates":[-90.6693,30.054]},{"Plant":"Hardee Power Station","State":"FL","Gas":358,"coordinates":[-81.9636,27.6364]},{"Plant":"Bellmeade Power Station","State":"VA","Gas":267,"coordinates":[-77.4317,37.4964]},{"Plant":"Motiva Enterprises Port Arthur Refinery","State":"TX","Gas":211.4,"coordinates":[-93.9569,29.8822]},{"Plant":"Ocean State Power","State":"RI","Gas":218.6,"coordinates":[-71.6689,42.0097]},{"Plant":"LaO Energy Systems","State":"LA","Gas":479,"coordinates":[-91.2325,30.3186]},{"Plant":"Doswell Energy Center","State":"VA","Gas":813.8,"coordinates":[-77.1448,37.8182]},{"Plant":"Elizabeth River Power Station","State":"VA","Gas":348,"coordinates":[-76.3083,36.775]},{"Plant":"Texas City Power Plant","State":"TX","Gas":451,"coordinates":[-94.9438,29.3787]},{"Plant":"Dow Chemical Texas Operation","State":"TX","Gas":532.2,"coordinates":[-95.4075,28.9913]},{"Plant":"Power Station 4","State":"TX","Gas":172,"coordinates":[-94.9219,29.3782]},{"Plant":"Midway Sunset Cogen","State":"CA","Gas":219,"coordinates":[-119.6294,35.2269]},{"Plant":"C R Wing Cogen Plant","State":"TX","Gas":227,"coordinates":[-101.4224,32.2732]},{"Plant":"Delaware City Plant","State":"DE","Gas":265,"coordinates":[-75.6343,39.5871]},{"Plant":"McWilliams","State":"AL","Gas":650,"coordinates":[-86.4764,31.4003]},{"Plant":"J K Smith","State":"KY","Gas":784,"coordinates":[-84.1017,37.8833]},{"Plant":"Lockport Energy Associates LP","State":"NY","Gas":204.2,"coordinates":[-78.745,43.1619]},{"Plant":"Kennedy International Airport Cogen","State":"NY","Gas":123.5,"coordinates":[-73.7778,40.6417]},{"Plant":"March Point Cogeneration","State":"WA","Gas":146.2,"coordinates":[-122.56,48.4708]},{"Plant":"Saguaro Power","State":"NV","Gas":101,"coordinates":[-115.0117,36.0417]},{"Plant":"Ocean State Power II","State":"RI","Gas":218.6,"coordinates":[-71.6701,42.0099]},{"Plant":"Orange Cogeneration Facility","State":"FL","Gas":110.6,"coordinates":[-81.8251,27.8708]},{"Plant":"Lake Cogen Ltd","State":"FL","Gas":121,"coordinates":[-81.676,28.9158]},{"Plant":"Pasco Cogen Ltd","State":"FL","Gas":121,"coordinates":[-82.1889,28.3746]},{"Plant":"Mulberry Cogeneration Facility","State":"FL","Gas":113,"coordinates":[-81.8775,27.8489]},{"Plant":"Orlando Cogen LP","State":"FL","Gas":120,"coordinates":[-81.4123,28.4426]},{"Plant":"Sumas Power Plant","State":"WA","Gas":125.5,"coordinates":[-122.2733,48.9905]},{"Plant":"Ferndale Generating Station","State":"WA","Gas":270,"coordinates":[-122.6867,48.8288]},{"Plant":"Hartwell Energy Facility","State":"GA","Gas":293,"coordinates":[-82.8199,34.3396]},{"Plant":"Sithe Independence Station","State":"NY","Gas":933.2,"coordinates":[-76.4511,43.495]},{"Plant":"Saranac Facility","State":"NY","Gas":251.6,"coordinates":[-73.4557,44.7132]},{"Plant":"NAEA Lakewood LLC","State":"NJ","Gas":218.1,"coordinates":[-74.1686,40.0613]},{"Plant":"Auburndale Power Partners","State":"FL","Gas":155.3,"coordinates":[-81.8058,28.0542]},{"Plant":"Oyster Creek Unit VIII","State":"TX","Gas":379,"coordinates":[-95.342,28.9802]},{"Plant":"Hermiston Generating Plant","State":"OR","Gas":464,"coordinates":[-119.37,45.8042]},{"Plant":"Grays Ferry Cogeneration","State":"PA","Gas":150,"coordinates":[-75.1881,39.9422]},{"Plant":"Milford Power LP","State":"MA","Gas":148,"coordinates":[-71.5115,42.1294]},{"Plant":"Milagro Cogeneration Plant","State":"NM","Gas":121.6,"coordinates":[-107.9417,36.7367]},{"Plant":"Johnson County","State":"TX","Gas":267,"coordinates":[-97.4078,32.3994]},{"Plant":"Brandywine Power Facility","State":"MD","Gas":230,"coordinates":[-76.8678,38.6681]},{"Plant":"Gordonsville Energy LP","State":"VA","Gas":218,"coordinates":[-78.2138,38.1179]},{"Plant":"Sun Peak Generating Station","State":"NV","Gas":222,"coordinates":[-115.0339,36.1375]},{"Plant":"Brooklyn Navy Yard Cogeneration","State":"NY","Gas":250,"coordinates":[-73.9764,40.6994]},{"Plant":"Michigan Power LP","State":"MI","Gas":128,"coordinates":[-86.425,43.9375]},{"Plant":"LSP-Cottage Grove LP","State":"MN","Gas":251,"coordinates":[-92.9119,44.7956]},{"Plant":"LSP-Whitewater LP","State":"WI","Gas":261,"coordinates":[-88.7299,42.8555]},{"Plant":"Sweeny Cogen Facility","State":"TX","Gas":436,"coordinates":[-95.745,29.0728]},{"Plant":"Dighton Power Plant","State":"MA","Gas":157.3,"coordinates":[-71.1239,41.8312]},{"Plant":"De Pere Energy Center","State":"WI","Gas":168.1,"coordinates":[-88.072,44.4486]},{"Plant":"Androscoggin Energy Center","State":"ME","Gas":136.6,"coordinates":[-70.2423,44.5063]},{"Plant":"Delta Person LLC","State":"NM","Gas":140,"coordinates":[-106.644,35.026]},{"Plant":"Mid-Georgia Cogeneration Facility","State":"GA","Gas":316,"coordinates":[-83.6039,32.4856]},{"Plant":"Berkshire Power","State":"MA","Gas":229.3,"coordinates":[-72.6478,42.0476]},{"Plant":"Bridgeport Energy Project","State":"CT","Gas":454,"coordinates":[-73.1844,41.1692]},{"Plant":"Pasadena Cogeneration","State":"TX","Gas":700,"coordinates":[-95.1765,29.7248]},{"Plant":"Tiverton Power Plant","State":"RI","Gas":250,"coordinates":[-71.1706,41.6422]},{"Plant":"Axiall Plaquemine","State":"LA","Gas":240,"coordinates":[-91.185,30.2586]},{"Plant":"Tenaska Georgia Generation Facility","State":"GA","Gas":933,"coordinates":[-84.9996,33.3516]},{"Plant":"Tenaska Frontier Generation Station","State":"TX","Gas":860,"coordinates":[-95.9178,30.5924]},{"Plant":"Batesville Generation Facility","State":"MS","Gas":858,"coordinates":[-89.9275,34.3356]},{"Plant":"Black Hawk Station","State":"TX","Gas":219.5,"coordinates":[-101.36,35.6957]},{"Plant":"Mustang Station","State":"TX","Gas":486,"coordinates":[-102.7417,32.9728]},{"Plant":"Maine Independence Station","State":"ME","Gas":490,"coordinates":[-68.7094,44.8242]},{"Plant":"Pine Bluff Energy Center","State":"AR","Gas":192,"coordinates":[-91.9025,34.2181]},{"Plant":"Desert Star Energy Center","State":"NV","Gas":450,"coordinates":[-114.9928,35.7867]},{"Plant":"Millennium Power","State":"MA","Gas":334.9,"coordinates":[-72.0151,42.1123]},{"Plant":"New Albany Energy Facility","State":"MS","Gas":360,"coordinates":[-88.9397,34.5408]},{"Plant":"Brownsville Peaking Power","State":"TN","Gas":456,"coordinates":[-89.198,35.5438]},{"Plant":"Crockett Cogen Project","State":"CA","Gas":247.4,"coordinates":[-122.2161,38.0569]},{"Plant":"Gregory Power Facility","State":"TX","Gas":366,"coordinates":[-97.2584,27.8893]},{"Plant":"Zeeland Generating Station","State":"MI","Gas":850,"coordinates":[-85.9975,42.8206]},{"Plant":"Dearborn Industrial Generation","State":"MI","Gas":710,"coordinates":[-83.154,42.3026]},{"Plant":"Taft Cogeneration Facility","State":"LA","Gas":790,"coordinates":[-90.4599,29.9888]},{"Plant":"Midlothian Energy Facility","State":"TX","Gas":1315,"coordinates":[-97.0537,32.4302]},{"Plant":"Lamar Power Project","State":"TX","Gas":1002,"coordinates":[-95.59,33.6308]},{"Plant":"Frontera Energy Center","State":"TX","Gas":475,"coordinates":[-98.3992,26.208]},{"Plant":"NRG Sterlington Power","State":"LA","Gas":176,"coordinates":[-92.0811,32.6889]},{"Plant":"Rumford Power Associates","State":"ME","Gas":254,"coordinates":[-70.5219,44.5303]},{"Plant":"Livingston Generating Station","State":"MI","Gas":132,"coordinates":[-84.7308,45.0304]},{"Plant":"Klamath Cogeneration Plant","State":"OR","Gas":470,"coordinates":[-121.8106,42.1739]},{"Plant":"Entergy Rhode Island State Energy LP","State":"RI","Gas":528,"coordinates":[-71.5186,41.8017]},{"Plant":"Rocky Road Power LLC","State":"IL","Gas":327.3,"coordinates":[-88.2397,42.0931]},{"Plant":"Madison","State":"OH","Gas":576,"coordinates":[-84.4647,39.4522]},{"Plant":"Vermillion Energy Facility","State":"IN","Gas":568,"coordinates":[-87.4464,39.9223]},{"Plant":"Sutter Energy Center","State":"CA","Gas":530,"coordinates":[-121.6959,39.0531]},{"Plant":"Rockingham County CT Station","State":"NC","Gas":825,"coordinates":[-79.8297,36.3297]},{"Plant":"RS Cogen","State":"LA","Gas":415.4,"coordinates":[-93.2992,30.221]},{"Plant":"SRW Cogen LP","State":"TX","Gas":420,"coordinates":[-93.7574,30.0545]},{"Plant":"Magic Valley Generating Station","State":"TX","Gas":682,"coordinates":[-98.19,26.3403]},{"Plant":"Griffith Energy LLC","State":"AZ","Gas":570,"coordinates":[-114.1333,35.054]},{"Plant":"Milford Power Project","State":"CT","Gas":506.7,"coordinates":[-73.0997,41.2244]},{"Plant":"Manchief Electric Generating Station","State":"CO","Gas":264,"coordinates":[-103.685,40.2171]},{"Plant":"Walton County Power LLC","State":"GA","Gas":454.5,"coordinates":[-83.6954,33.8148]},{"Plant":"Desert Basin","State":"AZ","Gas":577,"coordinates":[-111.7889,32.9042]},{"Plant":"Kendall County Generation Facility","State":"IL","Gas":1140,"coordinates":[-88.2581,41.4797]},{"Plant":"Tenaska Gateway Generating Station","State":"TX","Gas":843,"coordinates":[-94.6197,32.0178]},{"Plant":"Alliant Energy Neenah","State":"WI","Gas":299.5,"coordinates":[-88.5064,44.1936]},{"Plant":"Rio Nogales Power Project","State":"TX","Gas":756,"coordinates":[-97.9732,29.5931]},{"Plant":"Wolf Hollow I LP","State":"TX","Gas":695.5,"coordinates":[-97.7317,32.3342]},{"Plant":"Hawk Road Facility","State":"GA","Gas":475.8,"coordinates":[-84.9914,33.3585]},{"Plant":"Hays Energy Project","State":"TX","Gas":881,"coordinates":[-97.9894,29.7806]},{"Plant":"Green Country Energy LLC","State":"OK","Gas":783,"coordinates":[-95.9346,35.9833]},{"Plant":"Worthington Generation LLC","State":"IN","Gas":164.1,"coordinates":[-87.0128,39.0708]},{"Plant":"Lake Road Generating Plant","State":"CT","Gas":745,"coordinates":[-71.8958,41.872]},{"Plant":"La Paloma Generating LLC","State":"CA","Gas":965.4,"coordinates":[-119.5919,35.2956]},{"Plant":"Guadalupe Generating Station","State":"TX","Gas":995,"coordinates":[-98.1419,29.6244]},{"Plant":"Lost Pines 1 Power Project","State":"TX","Gas":516,"coordinates":[-97.2714,30.1478]},{"Plant":"Bluegrass Generating Station","State":"KY","Gas":501,"coordinates":[-85.4133,38.3902]},{"Plant":"Calcasieu","State":"LA","Gas":310,"coordinates":[-93.345,30.1608]},{"Plant":"Broad River Energy Center","State":"SC","Gas":840.4,"coordinates":[-81.575,35.0786]},{"Plant":"Bastrop Energy Center","State":"TX","Gas":552,"coordinates":[-97.55,30.1458]},{"Plant":"Granite Ridge","State":"NH","Gas":678,"coordinates":[-71.4261,42.9042]},{"Plant":"Bosque County Peaking","State":"TX","Gas":748,"coordinates":[-97.3586,31.8594]},{"Plant":"Acadia Energy Center","State":"LA","Gas":1063,"coordinates":[-92.4131,30.4286]},{"Plant":"Eastman Cogeneration Facility","State":"TX","Gas":402.2,"coordinates":[-94.6903,32.4481]},{"Plant":"South Point Energy Center","State":"AZ","Gas":550,"coordinates":[-114.5317,34.8678]},{"Plant":"Dogwood Energy Facility","State":"MO","Gas":616,"coordinates":[-94.3006,38.7931]},{"Plant":"Rathdrum Power LLC","State":"ID","Gas":248,"coordinates":[-116.9203,47.7858]},{"Plant":"Sunrise Power LLC","State":"CA","Gas":545,"coordinates":[-119.585,35.2097]},{"Plant":"Channelview Cogeneration Plant","State":"TX","Gas":801,"coordinates":[-95.1217,29.837]},{"Plant":"Cordova Energy","State":"IL","Gas":521.2,"coordinates":[-90.2797,41.7122]},{"Plant":"Osceola","State":"FL","Gas":471,"coordinates":[-81.0978,28.1289]},{"Plant":"Ontelaunee Energy Center","State":"PA","Gas":465.7,"coordinates":[-75.9356,40.4219]},{"Plant":"Caledonia","State":"MS","Gas":765,"coordinates":[-88.2717,33.6464]},{"Plant":"Riverside Generating LLC","State":"KY","Gas":825,"coordinates":[-82.6046,38.1917]},{"Plant":"Elwood Energy LLC","State":"IL","Gas":1350,"coordinates":[-88.1236,41.4388]},{"Plant":"Arapahoe Combustion Turbine Project","State":"CO","Gas":122.5,"coordinates":[-105.0018,39.6692]},{"Plant":"Gibson City","State":"IL","Gas":228,"coordinates":[-88.3987,40.4705]},{"Plant":"Pinckneyville","State":"IL","Gas":316,"coordinates":[-89.3467,38.1114]},{"Plant":"Kinmundy","State":"IL","Gas":208,"coordinates":[-89.0128,38.7619]},{"Plant":"Corpus Christi Energy Center","State":"TX","Gas":483,"coordinates":[-97.4283,27.8139]},{"Plant":"Afton Generating Station","State":"NM","Gas":235.6,"coordinates":[-106.8465,32.1142]},{"Plant":"ANP Bellingham Energy Project","State":"MA","Gas":495.4,"coordinates":[-71.4535,42.1106]},{"Plant":"ANP Blackstone Energy Project","State":"MA","Gas":456.3,"coordinates":[-71.5158,42.0599]},{"Plant":"Odessa Ector Generating Station","State":"TX","Gas":982.5,"coordinates":[-102.3264,31.8403]},{"Plant":"Morris Cogeneration LLC","State":"IL","Gas":176,"coordinates":[-88.3328,41.4119]},{"Plant":"Los Medanos Energy Center","State":"CA","Gas":567,"coordinates":[-121.873,38.0301]},{"Plant":"Hinds Energy Facility","State":"MS","Gas":450,"coordinates":[-90.2199,32.379]},{"Plant":"Attala","State":"MS","Gas":454.9,"coordinates":[-89.6753,33.0147]},{"Plant":"Harry L. Oswald","State":"AR","Gas":548,"coordinates":[-92.2166,34.5923]},{"Plant":"Lincoln Generating Facility","State":"IL","Gas":622.9,"coordinates":[-87.9436,41.3933]},{"Plant":"Ennis Power Company LLC","State":"TX","Gas":359.5,"coordinates":[-96.675,32.32]},{"Plant":"Wheatland Generating Facility","State":"IN","Gas":460,"coordinates":[-87.2931,38.6716]},{"Plant":"Oneta Energy Center","State":"OK","Gas":1086.4,"coordinates":[-95.6967,36.0119]},{"Plant":"Freestone Energy Center","State":"TX","Gas":953,"coordinates":[-96.1131,31.8907]},{"Plant":"Greenville Electric Generating Station","State":"OH","Gas":201.5,"coordinates":[-84.6151,40.0758]},{"Plant":"Montpelier Electric Generating Station","State":"IN","Gas":180,"coordinates":[-85.3057,40.6206]},{"Plant":"Jack County","State":"TX","Gas":1241,"coordinates":[-97.9574,33.101]},{"Plant":"Liberty Electric Power Plant","State":"PA","Gas":541,"coordinates":[-75.3358,39.8614]},{"Plant":"Marshall Energy Facility","State":"KY","Gas":581.6,"coordinates":[-88.3958,37.0286]},{"Plant":"Handsome Lake Energy LLC","State":"PA","Gas":267.5,"coordinates":[-79.8061,41.2908]},{"Plant":"Audrain Generating Station","State":"MO","Gas":600,"coordinates":[-91.5369,39.3092]},{"Plant":"Lee Energy Facility","State":"IL","Gas":568,"coordinates":[-89.4054,41.8287]},{"Plant":"Energy Shelby County","State":"IL","Gas":336,"coordinates":[-88.4772,39.2794]},{"Plant":"NRG Rockford I","State":"IL","Gas":301.1,"coordinates":[-89.1012,42.2386]},{"Plant":"Red Oak Power LLC","State":"NJ","Gas":765.9,"coordinates":[-74.3489,40.4487]},{"Plant":"Hog Bayou Energy Center","State":"AL","Gas":230,"coordinates":[-88.0575,30.7478]},{"Plant":"Santa Rosa Energy Center","State":"FL","Gas":235.9,"coordinates":[-87.115,30.5664]},{"Plant":"Astoria Gas Turbines","State":"NY","Gas":410.3,"coordinates":[-73.9048,40.787]},{"Plant":"Doyle Energy Facility","State":"GA","Gas":326.9,"coordinates":[-83.6996,33.8377]},{"Plant":"Darby Electric Generating Station","State":"OH","Gas":435,"coordinates":[-83.1778,39.7139]},{"Plant":"Tait Electric Generating Station","State":"OH","Gas":340,"coordinates":[-84.2095,39.7277]},{"Plant":"University Park South","State":"IL","Gas":300,"coordinates":[-87.7532,41.4409]},{"Plant":"Gleason Generating Facility","State":"TN","Gas":360,"coordinates":[-88.612,36.2454]},{"Plant":"Crete Energy Venture LLC","State":"IL","Gas":300,"coordinates":[-87.6187,41.4294]},{"Plant":"Whiting Clean Energy","State":"IN","Gas":513,"coordinates":[-87.4775,41.6739]},{"Plant":"Edward L. Addison Generating Plant","State":"GA","Gas":598.8,"coordinates":[-84.3064,32.9111]},{"Plant":"TVA Southaven Combined Cycle","State":"MS","Gas":780,"coordinates":[-90.0378,34.9939]},{"Plant":"Jackson Generating Station","State":"MI","Gas":564,"coordinates":[-84.3767,42.2488]},{"Plant":"Tenaska Lindsay Hill Generating Station","State":"AL","Gas":845,"coordinates":[-86.7386,32.6514]},{"Plant":"Ceredo Generating Station","State":"WV","Gas":450,"coordinates":[-82.5339,38.3681]},{"Plant":"Aurora","State":"IL","Gas":832,"coordinates":[-88.2265,41.8151]},{"Plant":"Southeast Chicago Energy Project","State":"IL","Gas":296,"coordinates":[-87.5449,41.7181]},{"Plant":"Arlington Valley Energy Facility","State":"AZ","Gas":579,"coordinates":[-112.8897,33.3417]},{"Plant":"Front Range Power Plant","State":"CO","Gas":461.5,"coordinates":[-104.7069,38.6281]},{"Plant":"Big Sandy Peaker Plant","State":"WV","Gas":300,"coordinates":[-82.5938,38.3441]},{"Plant":"Wolf Hills Energy","State":"VA","Gas":250,"coordinates":[-82.1044,36.6644]},{"Plant":"Oleander Power Project LP","State":"FL","Gas":315.9,"coordinates":[-80.7947,28.3661]},{"Plant":"Decatur Energy Center","State":"AL","Gas":725,"coordinates":[-87.0214,34.6292]},{"Plant":"Morgan Energy Center","State":"AL","Gas":749,"coordinates":[-87.0639,34.6397]},{"Plant":"Westbrook Energy Center Power Plant","State":"ME","Gas":506,"coordinates":[-70.375,43.6575]},{"Plant":"Blythe Energy Inc","State":"CA","Gas":514,"coordinates":[-114.6865,33.6157]},{"Plant":"Calumet Energy Team LLC","State":"IL","Gas":321.2,"coordinates":[-87.5563,41.6835]},{"Plant":"New Covert Generating Facility","State":"MI","Gas":1040.1,"coordinates":[-86.2937,42.3224]},{"Plant":"Fairless Energy Center","State":"PA","Gas":1211.2,"coordinates":[-74.7411,40.1475]},{"Plant":"Channel Energy Center LLC","State":"TX","Gas":585,"coordinates":[-95.2319,29.7189]},{"Plant":"Baconton Power Plant","State":"GA","Gas":196,"coordinates":[-84.08,31.3869]},{"Plant":"Gila River Power Station","State":"AZ","Gas":2060,"coordinates":[-112.6944,32.975]},{"Plant":"Air Products Port Arthur","State":"TX","Gas":158.9,"coordinates":[-93.9651,29.8665]},{"Plant":"Ingleside Cogeneration","State":"TX","Gas":460,"coordinates":[-97.2428,27.8828]},{"Plant":"Fore River Generating Station","State":"MA","Gas":688.4,"coordinates":[-70.9661,42.2422]},{"Plant":"Indian River","State":"FL","Gas":576.4,"coordinates":[-80.7802,28.4932]},{"Plant":"Wise County Power LLC","State":"TX","Gas":680,"coordinates":[-97.9103,33.0583]},{"Plant":"Chuck Lenzie Generating Station","State":"NV","Gas":1128,"coordinates":[-114.9218,36.3837]},{"Plant":"Baytown Energy Center","State":"TX","Gas":770,"coordinates":[-94.9019,29.7731]},{"Plant":"Hermiston Power Partnership","State":"OR","Gas":615,"coordinates":[-119.3133,45.794]},{"Plant":"Washington County","State":"GA","Gas":604,"coordinates":[-82.98,33.0922]},{"Plant":"Delta Energy Center","State":"CA","Gas":769.1,"coordinates":[-121.8439,38.0169]},{"Plant":"Holland Energy Facility","State":"IL","Gas":622.7,"coordinates":[-88.7584,39.2231]},{"Plant":"PPL Ironwood LLC","State":"PA","Gas":660.1,"coordinates":[-76.3658,40.3509]},{"Plant":"Dell Power Station","State":"AR","Gas":464,"coordinates":[-90.0253,35.8619]},{"Plant":"Luna Energy Facility","State":"NM","Gas":559,"coordinates":[-107.7834,32.2993]},{"Plant":"Otay Mesa Generating Project","State":"CA","Gas":571,"coordinates":[-116.915,32.5815]},{"Plant":"Armstrong","State":"PA","Gas":584,"coordinates":[-79.3517,40.638]},{"Plant":"Troy Energy LLC","State":"OH","Gas":584,"coordinates":[-83.4598,41.4772]},{"Plant":"Pleasants Energy LLC","State":"WV","Gas":323.9,"coordinates":[-81.3642,39.3325]},{"Plant":"Dresden Energy Facility","State":"OH","Gas":540,"coordinates":[-82.0276,40.0928]},{"Plant":"Brazos Valley Generating Facility","State":"TX","Gas":525,"coordinates":[-95.6244,29.4731]},{"Plant":"Cottonwood Energy Project","State":"TX","Gas":1180,"coordinates":[-93.7353,30.2588]},{"Plant":"Sugar Creek Power","State":"IN","Gas":529.7,"coordinates":[-87.5108,39.3931]},{"Plant":"Exelon LaPorte Generating Station","State":"TX","Gas":153.2,"coordinates":[-95.0718,29.7028]},{"Plant":"Harquahala Generating Project","State":"AZ","Gas":1054.4,"coordinates":[-113.1134,33.476]},{"Plant":"Astoria Energy","State":"NY","Gas":561,"coordinates":[-73.8964,40.7825]},{"Plant":"Union Power Partners LP","State":"AR","Gas":2020,"coordinates":[-92.5894,33.2961]},{"Plant":"Thomas A Smith Energy Facility","State":"GA","Gas":1250,"coordinates":[-84.9175,34.7094]},{"Plant":"Columbia Energy Center","State":"SC","Gas":408.7,"coordinates":[-81.0178,33.8697]},{"Plant":"RockGen Energy Center","State":"WI","Gas":471,"coordinates":[-89.0492,42.9767]},{"Plant":"Zion Energy Center","State":"IL","Gas":456,"coordinates":[-87.895,42.4776]},{"Plant":"Metcalf Energy Center","State":"CA","Gas":546.1,"coordinates":[-121.7457,37.2207]},{"Plant":"Crossroads Energy Center","State":"MS","Gas":308,"coordinates":[-90.5621,34.183]},{"Plant":"Washington Energy Facility","State":"OH","Gas":626,"coordinates":[-81.6564,39.58]},{"Plant":"Elk Hills Power LLC","State":"CA","Gas":525,"coordinates":[-119.4707,35.2803]},{"Plant":"Rolling Hills Generating","State":"OH","Gas":825,"coordinates":[-82.3328,39.0839]},{"Plant":"Renaissance Power LLC","State":"MI","Gas":660,"coordinates":[-84.8429,43.1864]},{"Plant":"Carville Energy LLC","State":"LA","Gas":473,"coordinates":[-91.065,30.2294]},{"Plant":"Athens Generating Plant","State":"NY","Gas":1137.9,"coordinates":[-73.8492,42.2728]},{"Plant":"Effingham County Power Project","State":"GA","Gas":509,"coordinates":[-81.2844,32.2773]},{"Plant":"Calhoun Energy Center","State":"AL","Gas":632,"coordinates":[-85.9731,33.5883]},{"Plant":"Hillabee Energy Center","State":"AL","Gas":695.4,"coordinates":[-85.9033,33.0007]},{"Plant":"Osprey Energy Center Power Plant","State":"FL","Gas":590,"coordinates":[-81.8083,28.0525]},{"Plant":"Shady Hills Generating Station","State":"FL","Gas":468,"coordinates":[-82.5586,28.3665]},{"Plant":"Vandolah Power Station","State":"FL","Gas":632,"coordinates":[-81.924,27.5236]},{"Plant":"Raccoon Creek Energy Center","State":"IL","Gas":300,"coordinates":[-88.5392,38.6996]},{"Plant":"Hot Spring Generating Facility","State":"AR","Gas":630,"coordinates":[-92.8683,34.2976]},{"Plant":"Plaquemine Cogeneration Plant","State":"LA","Gas":793,"coordinates":[-91.2347,30.3217]},{"Plant":"DeSoto County Plant","State":"FL","Gas":320,"coordinates":[-81.8092,27.2272]},{"Plant":"Bayou Cove Peaking Power","State":"LA","Gas":300,"coordinates":[-92.5997,30.2825]},{"Plant":"Elgin Energy Center","State":"IL","Gas":460,"coordinates":[-88.2446,42.0001]},{"Plant":"Tenaska Virginia Generating Station","State":"VA","Gas":926.2,"coordinates":[-78.3813,37.8667]},{"Plant":"Tenaska Central Alabama Generating Stn","State":"AL","Gas":915.8,"coordinates":[-86.74,32.6497]},{"Plant":"Columbia Energy Center","State":"MO","Gas":140,"coordinates":[-92.2629,39.0192]},{"Plant":"Magnolia Power Plant","State":"MS","Gas":918,"coordinates":[-89.2026,34.835]},{"Plant":"Fountain Valley Power Facility","State":"CO","Gas":234,"coordinates":[-104.6875,38.5569]},{"Plant":"Red Hawk","State":"AZ","Gas":934,"coordinates":[-112.8406,33.3346]},{"Plant":"McClain Energy Facility","State":"OK","Gas":459.1,"coordinates":[-97.5898,35.2977]},{"Plant":"Redbud Power Plant","State":"OK","Gas":1754.3,"coordinates":[-97.2264,35.6856]},{"Plant":"Deer Park Energy Center","State":"TX","Gas":937.2,"coordinates":[-95.1345,29.7134]},{"Plant":"Ouachita","State":"LA","Gas":770,"coordinates":[-92.0683,32.7061]},{"Plant":"Green Power 2","State":"TX","Gas":825.5,"coordinates":[-94.9328,29.3781]},{"Plant":"Forney Energy Center","State":"TX","Gas":1760,"coordinates":[-96.4916,32.7563]},{"Plant":"Mesquite Generating Station","State":"AZ","Gas":1073.3,"coordinates":[-112.8642,33.345]},{"Plant":"Goldendale Generating Station","State":"WA","Gas":256.7,"coordinates":[-120.833,45.8114]},{"Plant":"Tri Center Naniwa Energy","State":"NV","Gas":200,"coordinates":[-119.5178,39.5572]},{"Plant":"Goose Creek Energy Center","State":"IL","Gas":432,"coordinates":[-88.5999,40.1069]},{"Plant":"Kiamichi Energy Facility","State":"OK","Gas":1178.4,"coordinates":[-95.9349,34.6831]},{"Plant":"Lawrenceburg Energy Facility","State":"IN","Gas":1080,"coordinates":[-84.8669,39.0911]},{"Plant":"AEP Waterford Facility","State":"OH","Gas":810,"coordinates":[-81.7178,39.5333]},{"Plant":"Limon Generating Station","State":"CO","Gas":134,"coordinates":[-103.7005,39.2038]},{"Plant":"Frank Knutson","State":"CO","Gas":134,"coordinates":[-104.682,39.9411]},{"Plant":"Apex Generating Station","State":"NV","Gas":494.4,"coordinates":[-114.9609,36.416]},{"Plant":"Fayette Energy Facility","State":"PA","Gas":628,"coordinates":[-79.9182,39.8592]},{"Plant":"Wallingford Energy","State":"CT","Gas":211.5,"coordinates":[-72.8354,41.4487]},{"Plant":"High Desert Power Plant","State":"CA","Gas":742.6,"coordinates":[-117.3647,34.5953]},{"Plant":"Sundance","State":"AZ","Gas":410,"coordinates":[-111.5899,32.9285]},{"Plant":"York Energy Center","State":"PA","Gas":545,"coordinates":[-76.3067,39.7375]},{"Plant":"Indigo Energy Facility","State":"CA","Gas":149.7,"coordinates":[-116.553,33.9109]},{"Plant":"Hidalgo Energy Center","State":"TX","Gas":470,"coordinates":[-98.1758,26.3417]},{"Plant":"Perryville Power Station","State":"LA","Gas":691,"coordinates":[-92.0183,32.6908]},{"Plant":"West Valley Generation Project","State":"UT","Gas":189,"coordinates":[-112.0317,40.6667]},{"Plant":"University Park North","State":"IL","Gas":504,"coordinates":[-87.7514,41.4425]},{"Plant":"Riverside Energy Center","State":"WI","Gas":595,"coordinates":[-89.0355,42.5827]},{"Plant":"Blue Spruce Energy Center","State":"CO","Gas":264,"coordinates":[-104.6814,39.7479]},{"Plant":"Plains End","State":"CO","Gas":114,"coordinates":[-105.226,39.8575]},{"Plant":"Spring Creek Energy Center","State":"OK","Gas":279,"coordinates":[-97.655,35.7422]},{"Plant":"Pastoria Energy Facility, LLC","State":"CA","Gas":468,"coordinates":[-118.844,34.9556]},{"Plant":"EP Newington Energy LLC","State":"NH","Gas":525,"coordinates":[-70.8061,43.1047]},{"Plant":"Chehalis Generating Facility","State":"WA","Gas":477,"coordinates":[-122.9131,46.6225]},{"Plant":"Harrison County Power Project","State":"TX","Gas":514.4,"coordinates":[-94.4367,32.3958]},{"Plant":"Lower Mount Bethel Energy","State":"PA","Gas":558.5,"coordinates":[-75.1076,40.8019]},{"Plant":"AL Sandersville LLC","State":"GA","Gas":576.4,"coordinates":[-82.8608,33.1189]},{"Plant":"Higgins Generating Station","State":"NV","Gas":570,"coordinates":[-115.3561,35.6139]},{"Plant":"Bethlehem Power Plant","State":"PA","Gas":1130,"coordinates":[-75.3147,40.6175]},{"Plant":"Quantum Choctaw Power LLC","State":"MS","Gas":690,"coordinates":[-89.2089,33.3792]},{"Plant":"Mint Farm Generating Station","State":"WA","Gas":275.9,"coordinates":[-122.9855,46.1388]},{"Plant":"Fremont Energy Center","State":"OH","Gas":667.3,"coordinates":[-83.1614,41.3771]},{"Plant":"Choctaw County","State":"MS","Gas":766,"coordinates":[-89.4201,33.2881]},{"Plant":"Allegheny Energy Units 3 4 & 5","State":"PA","Gas":509,"coordinates":[-79.7686,40.5453]},{"Plant":"Magnet Cove","State":"AR","Gas":641.5,"coordinates":[-92.8317,34.4297]},{"Plant":"Dean","State":"MI","Gas":295.4,"coordinates":[-82.4953,42.7725]},{"Plant":"Bennett Mountain","State":"ID","Gas":164,"coordinates":[-115.6666,43.1472]},{"Plant":"Hanging Rock Energy Facility","State":"OH","Gas":1252,"coordinates":[-82.7833,38.5731]},{"Plant":"Los Esteros Critical Energy Center","State":"CA","Gas":180,"coordinates":[-121.9319,37.425]},{"Plant":"FPL Energy Marcus Hook LP","State":"PA","Gas":726.5,"coordinates":[-75.4216,39.807]},{"Plant":"Valencia Energy Facility","State":"NM","Gas":144.3,"coordinates":[-106.7322,34.6115]},{"Plant":"Gilroy Peaking Energy Center","State":"CA","Gas":135,"coordinates":[-121.5363,36.999]},{"Plant":"Frederickson Power LP","State":"WA","Gas":242,"coordinates":[-122.3657,47.0861]},{"Plant":"Curtis H Stanton Energy Center","State":"FL","Gas":656.9,"coordinates":[-81.1669,28.4882]},{"Plant":"Auburndale Peaker Energy Center","State":"FL","Gas":122,"coordinates":[-81.8059,28.0535]},{"Plant":"Rocky Mountain Energy Center","State":"CO","Gas":580,"coordinates":[-104.5953,40.0908]},{"Plant":"Silverhawk","State":"NV","Gas":560,"coordinates":[-114.9606,36.4078]},{"Plant":"Inland Empire Energy Center","State":"CA","Gas":690,"coordinates":[-117.1704,33.7388]},{"Plant":"Jasper","State":"SC","Gas":869,"coordinates":[-81.1242,32.3594]},{"Plant":"Tracy Combined Cycle Power Plant","State":"CA","Gas":320.1,"coordinates":[-121.4906,37.7107]},{"Plant":"NRG Rockford II Energy Center","State":"IL","Gas":155.8,"coordinates":[-89.1011,42.2383]},{"Plant":"NAEA Ocean Peaking Power LLC","State":"NJ","Gas":325.6,"coordinates":[-74.1672,40.0633]},{"Plant":"Las Vegas Cogeneration II LLC","State":"NV","Gas":220,"coordinates":[-115.1238,36.232]},{"Plant":"Wansley Combined Cycle","State":"GA","Gas":1143.1,"coordinates":[-85.037,33.4064]},{"Plant":"Cosumnes","State":"CA","Gas":477,"coordinates":[-121.124,38.3385]},{"Plant":"Cass County","State":"NE","Gas":323.2,"coordinates":[-95.964,40.9479]},{"Plant":"Hunterstown","State":"PA","Gas":758,"coordinates":[-77.1672,39.8725]},{"Plant":"Palomar Energy","State":"CA","Gas":562,"coordinates":[-117.1178,33.1197]},{"Plant":"Exira","State":"IA","Gas":140.1,"coordinates":[-94.9197,41.5144]},{"Plant":"Donald Von Raesfeld Power Plant","State":"CA","Gas":154,"coordinates":[-121.9508,37.3767]},{"Plant":"Fox Energy Center","State":"WI","Gas":545.9,"coordinates":[-88.2089,44.3204]},{"Plant":"Malburg","State":"CA","Gas":143,"coordinates":[-118.2219,33.9986]},{"Plant":"Magnolia Power Project","State":"CA","Gas":301,"coordinates":[-118.3153,34.1786]},{"Plant":"Walnut Energy Center","State":"CA","Gas":269,"coordinates":[-120.8956,37.4878]},{"Plant":"Currant Creek","State":"UT","Gas":524,"coordinates":[-111.8935,39.8214]},{"Plant":"Mankato Energy Center","State":"MN","Gas":300,"coordinates":[-94.003,44.1988]},{"Plant":"Riverside Energy Resource Center","State":"CA","Gas":196,"coordinates":[-117.4528,33.9636]},{"Plant":"McIntosh Combined Cycle Facility","State":"GA","Gas":1256.8,"coordinates":[-81.1817,32.3478]},{"Plant":"South Harper","State":"MO","Gas":317.2,"coordinates":[-94.4824,38.6803]},{"Plant":"Freeport Energy Center","State":"TX","Gas":219.4,"coordinates":[-95.3954,28.9888]},{"Plant":"Faribault Energy Park","State":"MN","Gas":261,"coordinates":[-93.2906,44.3356]},{"Plant":"Sheboygan Falls","State":"WI","Gas":290.6,"coordinates":[-87.8781,43.7518]},{"Plant":"Nebo Power Station","State":"UT","Gas":130,"coordinates":[-111.7294,40.0614]},{"Plant":"500MW CC","State":"NY","Gas":454.1,"coordinates":[-73.9069,40.7889]},{"Plant":"Port Westward","State":"OR","Gas":372,"coordinates":[-123.172,46.1789]},{"Plant":"EG178 Facility","State":"TX","Gas":108,"coordinates":[-100.9547,32.7471]},{"Plant":"Caithness Long Island Energy Center","State":"NY","Gas":307,"coordinates":[-72.9403,40.8142]},{"Plant":"Lake Side Power Plant","State":"UT","Gas":547,"coordinates":[-111.7542,40.3317]},{"Plant":"Groton Generating Station","State":"SD","Gas":158.9,"coordinates":[-98.0987,45.3735]},{"Plant":"Kings River","State":"CA","Gas":109,"coordinates":[-119.7404,36.6697]},{"Plant":"Cannon Falls Energy Center","State":"MN","Gas":398,"coordinates":[-92.9155,44.5367]},{"Plant":"Anson County Generation Facility","State":"NC","Gas":339,"coordinates":[-79.9217,34.9687]},{"Plant":"Empire Generating Co  LLC","State":"NY","Gas":580,"coordinates":[-73.75,42.6252]},{"Plant":"Hamlet Generating Facility","State":"NC","Gas":282.5,"coordinates":[-79.7361,34.8423]},{"Plant":"Roseville Energy Park","State":"CA","Gas":141,"coordinates":[-121.3811,38.7928]},{"Plant":"Mustang Station Unit 4","State":"TX","Gas":290,"coordinates":[-102.7436,32.9746]},{"Plant":"Harry D Mattison Gas Plant","State":"AR","Gas":294,"coordinates":[-94.2841,36.1855]},{"Plant":"Quail Run Energy Center","State":"TX","Gas":482,"coordinates":[-102.315,31.8414]},{"Plant":"Colorado Bend Energy Center","State":"TX","Gas":510,"coordinates":[-96.0683,29.2878]},{"Plant":"Stanton Energy Center","State":"FL","Gas":295,"coordinates":[-81.1678,28.4822]},{"Plant":"Treasure Coast Energy Center","State":"FL","Gas":318,"coordinates":[-80.3775,27.3839]},{"Plant":"West County Energy Center","State":"FL","Gas":3669,"coordinates":[-80.3747,26.6986]},{"Plant":"Spindle Hill Energy Center","State":"CO","Gas":270,"coordinates":[-104.8878,40.0922]},{"Plant":"Hobbs Generating Station","State":"NM","Gas":530.4,"coordinates":[-103.3094,32.7283]},{"Plant":"Gateway Generating Station","State":"CA","Gas":563.4,"coordinates":[-121.7587,38.0175]},{"Plant":"Western 102 Power Plant","State":"NV","Gas":110.6,"coordinates":[-119.5108,39.5603]},{"Plant":"Emporia Energy Center","State":"KS","Gas":660,"coordinates":[-96.0652,38.4459]},{"Plant":"Jonesboro City Water & Light Plant","State":"AR","Gas":177,"coordinates":[-90.7254,35.8486]},{"Plant":"Plains End II LLC","State":"CO","Gas":116.2,"coordinates":[-105.2256,39.8586]},{"Plant":"Colusa Generating Station","State":"CA","Gas":640,"coordinates":[-122.27,39.3661]},{"Plant":"PPS Power Plant No 1","State":"KY","Gas":110,"coordinates":[-88.6159,37.0339]},{"Plant":"J Lamar Stall Unit","State":"LA","Gas":507,"coordinates":[-93.7601,32.5195]},{"Plant":"San Jacinto County Peaking Facility","State":"TX","Gas":146,"coordinates":[-95.0118,30.4193]},{"Plant":"Hardin County Peaking Facility","State":"TX","Gas":146,"coordinates":[-94.2526,30.3038]},{"Plant":"Deer Creek Station","State":"SD","Gas":290,"coordinates":[-96.5267,44.2908]},{"Plant":"Midway Peaking LLC","State":"CA","Gas":103,"coordinates":[-120.5797,36.6541]},{"Plant":"Winchester Power Park","State":"TX","Gas":179.2,"coordinates":[-96.9875,30.0381]},{"Plant":"Kleen Energy Systems Project","State":"CT","Gas":622,"coordinates":[-72.5969,41.5532]},{"Plant":"Greenland Energy Center","State":"FL","Gas":296,"coordinates":[-81.5184,30.1591]},{"Plant":"Panoche Energy Center","State":"CA","Gas":388,"coordinates":[-120.5833,36.6514]},{"Plant":"Cedar Bayou 4","State":"TX","Gas":502,"coordinates":[-94.9231,29.7516]},{"Plant":"Bear Garden","State":"VA","Gas":589,"coordinates":[-78.2853,37.6956]},{"Plant":"Dave Gates Generating Station","State":"MT","Gas":132.3,"coordinates":[-112.8766,46.1047]},{"Plant":"Coolidge Generation Station","State":"AZ","Gas":520.8,"coordinates":[-111.5033,32.9174]},{"Plant":"Bayonne Energy Center","State":"NJ","Gas":461.6,"coordinates":[-74.0915,40.6528]},{"Plant":"Pueblo Airport Generating Station","State":"CO","Gas":380,"coordinates":[-104.5264,38.3208]},{"Plant":"Canyon Power Plant","State":"CA","Gas":194.8,"coordinates":[-117.8617,33.8581]},{"Plant":"Langley Gulch Power Plant","State":"ID","Gas":298.7,"coordinates":[-116.8197,43.9044]},{"Plant":"Cleveland Cnty Generating Facility","State":"NC","Gas":720,"coordinates":[-81.4166,35.1705]},{"Plant":"Mariposa Energy Project","State":"CA","Gas":199.6,"coordinates":[-121.6019,37.7892]},{"Plant":"Astoria Energy II","State":"NY","Gas":540,"coordinates":[-73.8966,40.7813]},{"Plant":"Antelope Station","State":"TX","Gas":160.2,"coordinates":[-101.8433,33.865]},{"Plant":"Lodi Energy Center","State":"CA","Gas":257,"coordinates":[-121.3875,38.0881]},{"Plant":"Lee Combined Cycle Plant","State":"NC","Gas":920,"coordinates":[-78.0894,35.3736]},{"Plant":"Edge Moor","State":"DE","Gas":710,"coordinates":[-75.5038,39.7389]},{"Plant":"McKee Run","State":"DE","Gas":136,"coordinates":[-75.5466,39.1762]},{"Plant":"Belle River","State":"MI","Gas":222,"coordinates":[-82.495,42.7756]},{"Plant":"Greenwood","State":"MI","Gas":997,"coordinates":[-82.6964,43.1056]},{"Plant":"Manatee","State":"FL","Gas":1111,"coordinates":[-82.3456,27.6058]},{"Plant":"Martin","State":"FL","Gas":2043,"coordinates":[-80.5628,27.0536]},{"Plant":"DeBary","State":"FL","Gas":247,"coordinates":[-81.3323,28.9039]},{"Plant":"Electrifarm","State":"IA","Gas":195.1,"coordinates":[-92.4205,42.4407]},{"Plant":"Fredonia","State":"WA","Gas":280,"coordinates":[-122.4358,48.4558]},{"Plant":"Trimble County","State":"KY","Gas":942,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Gas":972,"coordinates":[-88.5553,30.5322]},{"Plant":"Greenwood","State":"MO","Gas":252.9,"coordinates":[-94.2982,38.8615]},{"Plant":"R M Schahfer","State":"IN","Gas":155,"coordinates":[-87.0261,41.2164]},{"Plant":"Fort St Vrain","State":"CO","Gas":969,"coordinates":[-104.8742,40.2461]},{"Plant":"Fort Myers","State":"FL","Gas":1747,"coordinates":[-81.7831,26.6967]},{"Plant":"Whitehorn","State":"WA","Gas":134,"coordinates":[-122.6861,48.8288]},{"Plant":"McIntosh","State":"GA","Gas":657.6,"coordinates":[-81.1683,32.3563]},{"Plant":"Lauderdale","State":"FL","Gas":1724,"coordinates":[-80.1984,26.0686]},{"Plant":"A B Brown","State":"IN","Gas":160,"coordinates":[-87.715,37.9053]},{"Plant":"Port Everglades","State":"FL","Gas":420,"coordinates":[-80.1253,26.0856]},{"Plant":"Brame Energy Center","State":"LA","Gas":422,"coordinates":[-92.7167,31.395]},{"Plant":"John Twitty Energy Center","State":"MO","Gas":104,"coordinates":[-93.388,37.1517]},{"Plant":"Sanford","State":"FL","Gas":1912,"coordinates":[-81.3256,28.8419]},{"Plant":"Turkey Point","State":"FL","Gas":1148,"coordinates":[-80.3308,25.4356]},{"Plant":"Empire Energy Center","State":"MO","Gas":262,"coordinates":[-94.1041,37.1385]},{"Plant":"Dansby","State":"TX","Gas":204.2,"coordinates":[-96.4608,30.7217]},{"Plant":"Putnam","State":"FL","Gas":498,"coordinates":[-81.5851,29.6283]},{"Plant":"Higgins","State":"FL","Gas":105,"coordinates":[-82.6615,28.0033]},{"Plant":"P L Bartow","State":"FL","Gas":1225,"coordinates":[-82.6018,27.8595]},{"Plant":"Rokeby","State":"NE","Gas":225.8,"coordinates":[-96.7364,40.7316]},{"Plant":"Suwannee River","State":"FL","Gas":104,"coordinates":[-83.1806,30.3764]},{"Plant":"Lansing Smith","State":"FL","Gas":481,"coordinates":[-85.7003,30.2686]},{"Plant":"D G Hunter","State":"LA","Gas":130,"coordinates":[-92.4613,31.3207]},{"Plant":"George M Sullivan Generation Plant 2","State":"AK","Gas":219.9,"coordinates":[-149.7167,61.2297]},{"Plant":"Deerhaven Generating Station","State":"FL","Gas":185,"coordinates":[-82.3878,29.7592]},{"Plant":"John R Kelly","State":"FL","Gas":177.2,"coordinates":[-82.3208,29.6461]},{"Plant":"J D Kennedy","State":"FL","Gas":317.2,"coordinates":[-81.626,30.3648]},{"Plant":"Northside Generating Station","State":"FL","Gas":505,"coordinates":[-81.5525,30.4172]},{"Plant":"Larsen Memorial","State":"FL","Gas":124,"coordinates":[-81.9228,28.0797]},{"Plant":"C D McIntosh Jr","State":"FL","Gas":545,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Gas":388,"coordinates":[-105.0212,40.8609]},{"Plant":"Indian River Plant","State":"FL","Gas":290,"coordinates":[-80.7801,28.4932]},{"Plant":"Arvah B Hopkins","State":"FL","Gas":504,"coordinates":[-84.4,30.4522]},{"Plant":"S O Purdom","State":"FL","Gas":290,"coordinates":[-84.2007,30.1623]},{"Plant":"Vero Beach Municipal Power Plant","State":"FL","Gas":150,"coordinates":[-80.3776,27.6334]},{"Plant":"Gravel Neck","State":"VA","Gas":340,"coordinates":[-76.6911,37.1575]},{"Plant":"McIntosh","State":"AL","Gas":678,"coordinates":[-88.0299,31.2546]},{"Plant":"Harry Allen","State":"NV","Gas":566.8,"coordinates":[-114.9024,36.4306]},{"Plant":"Jack McDonough","State":"GA","Gas":2578,"coordinates":[-84.4758,33.8239]},{"Plant":"Pleasant Hill","State":"IA","Gas":160,"coordinates":[-93.5242,41.5572]},{"Plant":"Hay Road","State":"DE","Gas":1130,"coordinates":[-75.5072,39.7436]},{"Plant":"Woodsdale","State":"OH","Gas":462,"coordinates":[-84.4611,39.4492]},{"Plant":"Concord","State":"WI","Gas":352,"coordinates":[-88.69,43.1669]},{"Plant":"South Fond Du Lac","State":"WI","Gas":304.1,"coordinates":[-88.4967,43.7353]},{"Plant":"Darbytown","State":"VA","Gas":336,"coordinates":[-77.3685,37.4982]},{"Plant":"Angus Anson","State":"SD","Gas":327,"coordinates":[-96.6356,43.6035]},{"Plant":"Cane Island","State":"FL","Gas":670,"coordinates":[-81.533,28.2764]},{"Plant":"Polk","State":"FL","Gas":604,"coordinates":[-81.9897,27.7286]},{"Plant":"Woodland","State":"CA","Gas":182.2,"coordinates":[-121.0204,37.6526]},{"Plant":"491 E 48th Street","State":"MI","Gas":136,"coordinates":[-86.0853,42.7553]},{"Plant":"Paris","State":"WI","Gas":352,"coordinates":[-88.0131,42.6658]},{"Plant":"Lincoln Combustion","State":"NC","Gas":1267.2,"coordinates":[-81.0347,35.4317]},{"Plant":"State Line Combined Cycle","State":"MO","Gas":589,"coordinates":[-94.614,37.0659]},{"Plant":"Hines Energy Complex","State":"FL","Gas":1912,"coordinates":[-81.87,27.7882]},{"Plant":"Redding Power","State":"CA","Gas":167,"coordinates":[-122.4233,40.5073]},{"Plant":"Richard M Flynn","State":"NY","Gas":136.2,"coordinates":[-73.064,40.8158]},{"Plant":"Almond Power Plant","State":"CA","Gas":199.5,"coordinates":[-120.985,37.5744]},{"Plant":"San Jacinto Steam Electric Station","State":"TX","Gas":162,"coordinates":[-95.0406,29.6948]},{"Plant":"Kraft","State":"GA","Gas":132,"coordinates":[-81.1458,32.1486]},{"Plant":"Anderson","State":"IN","Gas":140,"coordinates":[-85.7389,40.0529]},{"Plant":"Robins","State":"GA","Gas":160,"coordinates":[-83.5822,32.5792]},{"Plant":"Coyote Springs","State":"OR","Gas":235,"coordinates":[-119.6739,45.848]},{"Plant":"Midulla Generating Station","State":"FL","Gas":740,"coordinates":[-81.9625,27.6417]},{"Plant":"Interstate","State":"IL","Gas":112,"coordinates":[-89.5891,39.8233]},{"Plant":"Rathdrum","State":"ID","Gas":132,"coordinates":[-116.8673,47.8043]},{"Plant":"Arthur Von Rosenberg","State":"TX","Gas":530,"coordinates":[-98.384,29.257]},{"Plant":"Carson Ice-Gen Project","State":"CA","Gas":109,"coordinates":[-121.4624,38.4457]},{"Plant":"Wayne County","State":"NC","Gas":863,"coordinates":[-78.0981,35.3758]},{"Plant":"Ponca City","State":"OK","Gas":106.8,"coordinates":[-97.0858,36.7198]},{"Plant":"SCA Cogen 2","State":"CA","Gas":176.6,"coordinates":[-121.4001,38.5309]},{"Plant":"SPA Cogen 3","State":"CA","Gas":164,"coordinates":[-121.4735,38.511]},{"Plant":"St Francis Energy Facility","State":"MO","Gas":464,"coordinates":[-90.1779,36.5852]},{"Plant":"River Road Gen Plant","State":"WA","Gas":220,"coordinates":[-122.7256,45.6497]},{"Plant":"Tiger Bay","State":"FL","Gas":205,"coordinates":[-81.8494,27.7464]},{"Plant":"Dahlberg","State":"GA","Gas":747.3,"coordinates":[-83.3977,34.0423]},{"Plant":"H Allen Franklin Combined Cycle","State":"AL","Gas":1815,"coordinates":[-85.0975,32.6078]},{"Plant":"Theodore Cogen Facility","State":"AL","Gas":224.7,"coordinates":[-88.1285,30.5254]},{"Plant":"Nodaway","State":"MO","Gas":186,"coordinates":[-94.7913,40.2877]},{"Plant":"Chouteau","State":"OK","Gas":884,"coordinates":[-95.2771,36.2221]},{"Plant":"Georgetown","State":"IN","Gas":295,"coordinates":[-86.2441,39.9026]},{"Plant":"Tilton","State":"IL","Gas":176,"coordinates":[-87.6538,40.1061]},{"Plant":"Henry County","State":"IN","Gas":129,"coordinates":[-85.5039,39.9528]},{"Plant":"MPC Generating","State":"GA","Gas":302.5,"coordinates":[-83.6953,33.8119]},{"Plant":"Sherwood H Smith Jr Energy Complex","State":"NC","Gas":1922,"coordinates":[-79.7406,34.8392]},{"Plant":"Sewell Creek Energy","State":"GA","Gas":433.5,"coordinates":[-85.2769,33.9486]},{"Plant":"Alsey","State":"IL","Gas":121,"coordinates":[-90.436,39.5698]},{"Plant":"Fulton","State":"AR","Gas":153,"coordinates":[-93.7924,33.6094]},{"Plant":"Rowan","State":"NC","Gas":924.6,"coordinates":[-80.6019,35.7314]},{"Plant":"Smarr Energy Center","State":"GA","Gas":190.6,"coordinates":[-83.8464,32.9842]},{"Plant":"John S Rainey","State":"SC","Gas":977,"coordinates":[-82.776,34.3477]},{"Plant":"Essential Power Rock Springs LLC","State":"MD","Gas":658,"coordinates":[-76.1598,39.719]},{"Plant":"Marsh Run Generating","State":"VA","Gas":480.1,"coordinates":[-77.7681,38.5283]},{"Plant":"Louisa Generating","State":"VA","Gas":465.5,"coordinates":[-78.2139,38.1181]},{"Plant":"Remington","State":"VA","Gas":608,"coordinates":[-77.7714,38.5442]},{"Plant":"Ladysmith","State":"VA","Gas":783,"coordinates":[-77.5133,38.0722]},{"Plant":"Pleasant Valley","State":"MN","Gas":419.4,"coordinates":[-92.6829,43.7994]},{"Plant":"Lagoon Creek","State":"TN","Gas":1407,"coordinates":[-89.3964,35.6578]},{"Plant":"Brandy Branch","State":"FL","Gas":660.8,"coordinates":[-81.9472,30.3206]},{"Plant":"Holden","State":"MO","Gas":228,"coordinates":[-93.9983,38.7538]},{"Plant":"MEPI GT Facility","State":"IL","Gas":239,"coordinates":[-88.8661,37.2175]},{"Plant":"Encogen","State":"WA","Gas":159.4,"coordinates":[-122.486,48.746]},{"Plant":"Robert P Mone Plant","State":"OH","Gas":450.6,"coordinates":[-84.7392,40.9297]},{"Plant":"H L Culbreath Bayside Power Station","State":"FL","Gas":1854,"coordinates":[-82.4231,27.9072]},{"Plant":"Terry Bundy Generating Station","State":"NE","Gas":144.3,"coordinates":[-96.6131,40.9097]},{"Plant":"E B Harris Electric Generating Plant","State":"AL","Gas":1268.7,"coordinates":[-86.5744,32.3814]},{"Plant":"Sand Hill","State":"TX","Gas":595.8,"coordinates":[-97.6129,30.2098]},{"Plant":"Talbot County Energy","State":"GA","Gas":574.2,"coordinates":[-84.6917,32.5892]},{"Plant":"Chattahoochee Energy Facility","State":"GA","Gas":469.3,"coordinates":[-85.0386,33.4072]},{"Plant":"Lakefield Junction","State":"MN","Gas":517.4,"coordinates":[-94.8415,43.7984]},{"Plant":"West Gardner","State":"KS","Gas":309.6,"coordinates":[-94.9861,38.7875]},{"Plant":"Coyote Springs II","State":"OR","Gas":242.7,"coordinates":[-119.674,45.848]},{"Plant":"Wansley Unit 9","State":"GA","Gas":497.8,"coordinates":[-85.0403,33.4083]},{"Plant":"Lawrence County Station","State":"IN","Gas":251.5,"coordinates":[-86.4511,38.8003]},{"Plant":"Evander Andrews Power Complex","State":"ID","Gas":247,"coordinates":[-115.7343,43.1792]},{"Plant":"Kemper County","State":"MS","Gas":293.2,"coordinates":[-88.606,32.7976]},{"Plant":"Peno Creek","State":"MO","Gas":188,"coordinates":[-91.2295,39.3531]},{"Plant":"Sumpter","State":"MI","Gas":308.4,"coordinates":[-83.5318,42.167]},{"Plant":"Pyramid","State":"NM","Gas":158,"coordinates":[-108.5494,32.2363]},{"Plant":"Mill Creek","State":"SC","Gas":595.2,"coordinates":[-81.4306,35.1597]},{"Plant":"Greater Des Moines","State":"IA","Gas":492.6,"coordinates":[-93.5283,41.5563]},{"Plant":"Silver Creek","State":"MS","Gas":225,"coordinates":[-89.9468,31.6004]},{"Plant":"Sylvarena","State":"MS","Gas":129,"coordinates":[-89.4127,31.9821]},{"Plant":"West Campus Cogeneration Facility","State":"WI","Gas":126.3,"coordinates":[-89.4251,43.0751]},{"Plant":"Grays Harbor Energy Facility","State":"WA","Gas":637,"coordinates":[-123.48,46.9692]},{"Plant":"Beatrice","State":"NE","Gas":217,"coordinates":[-96.8082,40.3302]},{"Plant":"Roseton Generating Facility","State":"NY","Gas":1206.2,"coordinates":[-73.9663,41.5738]},{"Plant":"Blue Lake","State":"MN","Gas":300,"coordinates":[-93.4315,44.7855]},{"Plant":"Sycamore","State":"IA","Gas":148.5,"coordinates":[-93.6769,41.6722]},{"Plant":"Emery Station","State":"IA","Gas":535.6,"coordinates":[-93.2922,43.094]},{"Plant":"Intercession City","State":"FL","Gas":557,"coordinates":[-81.5486,28.2628]},{"Plant":"Gerald Andrus","State":"MS","Gas":712,"coordinates":[-91.1167,33.35]},{"Plant":"Waterford 1 & 2","State":"LA","Gas":411,"coordinates":[-90.4768,29.9989]},{"Plant":"Comanche","State":"OK","Gas":260,"coordinates":[-98.3244,34.5431]},{"Plant":"DeCordova Steam Electric Station","State":"TX","Gas":1138,"coordinates":[-97.7006,32.4031]},{"Plant":"Santan","State":"AZ","Gas":1227,"coordinates":[-111.7503,33.3325]},{"Plant":"Beaver","State":"OR","Gas":487,"coordinates":[-123.1739,46.1724]},{"Plant":"Glen Gardner","State":"NJ","Gas":144,"coordinates":[-74.9207,40.6815]},{"Plant":"Grand Tower","State":"IL","Gas":513,"coordinates":[-89.5112,37.6577]},{"Plant":"Astoria Generating Station","State":"NY","Gas":199.7,"coordinates":[-73.9126,40.7877]},{"Plant":"Venice","State":"IL","Gas":491,"coordinates":[-90.1764,38.6642]},{"Plant":"Beluga","State":"AK","Gas":344.4,"coordinates":[-151.0356,61.1861]},{"Plant":"Marion","State":"IL","Gas":140,"coordinates":[-88.9531,37.6197]},{"Plant":"Frederickson","State":"WA","Gas":134,"coordinates":[-122.365,47.0797]},{"Plant":"Harding Street","State":"IN","Gas":322,"coordinates":[-86.1969,39.7113]}]

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Gas":740,"coordinates":[-87.7811,32.6017]},{"Plant":"NRG Energy Center Dover","State":"DE","Gas":104,"coordinates":[-75.5473,39.1495]},{"Plant":"Gilroy Power Plant","State":"CA","Gas":115,"coordinates":[-121.5367,37.0001]},{"Plant":"Noblesville","State":"IN","Gas":285.2,"coordinates":[-85.9714,40.0969]},{"Plant":"Pedricktown Cogeneration Company LP","State":"NJ","Gas":117.9,"coordinates":[-75.4238,39.7668]},{"Plant":"Broadway","State":"IN","Gas":115,"coordinates":[-87.6049,37.9691]},{"Plant":"Butler-Warner Generation Plant","State":"NC","Gas":225,"coordinates":[-78.8294,35.0986]},{"Plant":"El Segundo Cogen","State":"CA","Gas":125.7,"coordinates":[-118.4031,33.9058]},{"Plant":"ArcelorMittal Burns Harbor","State":"IN","Gas":174.7,"coordinates":[-87.1387,41.635]},{"Plant":"King City Power Plant","State":"CA","Gas":111,"coordinates":[-121.1278,36.225]},{"Plant":"Bayou Cogen Plant","State":"TX","Gas":260,"coordinates":[-95.0458,29.6225]},{"Plant":"Bellingham Cogeneration Facility","State":"MA","Gas":264,"coordinates":[-71.4833,42.0925]},{"Plant":"Sayreville Cogeneration Facility","State":"NJ","Gas":291,"coordinates":[-74.3444,40.439]},{"Plant":"Foster Wheeler Martinez","State":"CA","Gas":103.5,"coordinates":[-122.0589,38.0244]},{"Plant":"ExxonMobil Baytown Refinery","State":"TX","Gas":134,"coordinates":[-94.9973,29.7535]},{"Plant":"Kern River Cogeneration","State":"CA","Gas":288,"coordinates":[-118.9849,35.4515]},{"Plant":"Formosa Utility Venture Ltd","State":"TX","Gas":597.3,"coordinates":[-96.5417,28.6917]},{"Plant":"Hopewell Cogeneration","State":"VA","Gas":252.3,"coordinates":[-77.2811,37.2917]},{"Plant":"Brush Generation Facility","State":"CO","Gas":292,"coordinates":[-103.631,40.2415]},{"Plant":"ExxonMobil Baytown Turbine","State":"TX","Gas":297,"coordinates":[-95.0096,29.7591]},{"Plant":"Selkirk Cogen","State":"NY","Gas":348.2,"coordinates":[-73.8592,42.5744]},{"Plant":"Masspower","State":"MA","Gas":245,"coordinates":[-72.5225,42.1575]},{"Plant":"Clear Lake Cogeneration Ltd","State":"TX","Gas":366,"coordinates":[-95.067,29.6255]},{"Plant":"Midland Cogeneration Venture","State":"MI","Gas":1859.4,"coordinates":[-84.2242,43.5861]},{"Plant":"Camden Plant Holding LLC","State":"NJ","Gas":145,"coordinates":[-75.1192,39.9175]},{"Plant":"Sutherland","State":"IA","Gas":110.7,"coordinates":[-92.8594,42.0473]},{"Plant":"River Hills","State":"IA","Gas":116.9,"coordinates":[-93.6195,41.5902]},{"Plant":"Hazelton","State":"PA","Gas":147.2,"coordinates":[-76.0409,40.9282]},{"Plant":"Ocotillo","State":"AZ","Gas":320,"coordinates":[-111.9122,33.4225]},{"Plant":"West Phoenix","State":"AZ","Gas":952,"coordinates":[-112.1583,33.4417]},{"Plant":"Saguaro","State":"AZ","Gas":176,"coordinates":[-111.3,32.5517]},{"Plant":"Yucca","State":"AZ","Gas":257,"coordinates":[-114.7106,32.7214]},{"Plant":"Fort Dodge","State":"KS","Gas":147.8,"coordinates":[-99.9497,37.7328]},{"Plant":"Great Bend","State":"KS","Gas":100.6,"coordinates":[-98.8689,38.41]},{"Plant":"Riverton","State":"KS","Gas":192,"coordinates":[-94.6987,37.0726]},{"Plant":"Gordon Evans Energy Center","State":"KS","Gas":808,"coordinates":[-97.5217,37.7903]},{"Plant":"Murray Gill","State":"KS","Gas":268,"coordinates":[-97.4136,37.5967]},{"Plant":"Hutchinson Energy Center","State":"KS","Gas":328,"coordinates":[-97.8747,38.0906]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Gas":314,"coordinates":[-110.9047,32.16]},{"Plant":"Kaw","State":"KS","Gas":140.3,"coordinates":[-94.6514,39.0867]},{"Plant":"McPherson 2","State":"KS","Gas":104,"coordinates":[-97.6834,38.3634]},{"Plant":"Garden City","State":"KS","Gas":222,"coordinates":[-100.8956,37.9703]},{"Plant":"E W Brown","State":"KY","Gas":812,"coordinates":[-84.7126,37.7883]},{"Plant":"Paddys Run","State":"KY","Gas":182,"coordinates":[-85.8417,38.2236]},{"Plant":"Louisiana 1","State":"LA","Gas":382.4,"coordinates":[-91.1864,30.4922]},{"Plant":"Louisiana 2","State":"LA","Gas":138,"coordinates":[-91.1864,30.4922]},{"Plant":"R S Nelson","State":"LA","Gas":570.3,"coordinates":[-93.2911,30.2844]},{"Plant":"Willow Glen","State":"LA","Gas":1748.8,"coordinates":[-91.1164,30.2743]},{"Plant":"Coughlin Power Station","State":"LA","Gas":732,"coordinates":[-92.2611,30.8439]},{"Plant":"Teche","State":"LA","Gas":380,"coordinates":[-91.5425,29.8222]},{"Plant":"Little Gypsy","State":"LA","Gas":1169.3,"coordinates":[-90.4617,30.0051]},{"Plant":"Nine Mile Point","State":"LA","Gas":1519.2,"coordinates":[-90.1458,29.9472]},{"Plant":"Sterlington","State":"LA","Gas":174,"coordinates":[-92.0792,32.7047]},{"Plant":"Michoud","State":"LA","Gas":781.2,"coordinates":[-89.9372,30.0081]},{"Plant":"Agua Fria","State":"AZ","Gas":626,"coordinates":[-112.2153,33.5561]},{"Plant":"Arsenal Hill","State":"LA","Gas":116,"coordinates":[-93.7611,32.5181]},{"Plant":"Lieberman","State":"LA","Gas":268,"coordinates":[-93.9597,32.7047]},{"Plant":"Louis Doc Bonin","State":"LA","Gas":256,"coordinates":[-92.0463,30.238]},{"Plant":"Big Cajun 1","State":"LA","Gas":430,"coordinates":[-91.3556,30.6739]},{"Plant":"Kyrene","State":"AZ","Gas":525,"coordinates":[-111.9353,33.3556]},{"Plant":"Herbert A Wagner","State":"MD","Gas":126,"coordinates":[-76.5268,39.1781]},{"Plant":"Notch Cliff","State":"MD","Gas":116.7,"coordinates":[-76.5087,39.4217]},{"Plant":"Perryman","State":"MD","Gas":147.6,"coordinates":[-76.2218,39.4428]},{"Plant":"Riverside","State":"MD","Gas":189,"coordinates":[-76.5133,39.2369]},{"Plant":"Westport","State":"MD","Gas":115.8,"coordinates":[-76.6295,39.266]},{"Plant":"Dickerson","State":"MD","Gas":294,"coordinates":[-77.4644,39.2097]},{"Plant":"Mystic Generating Station","State":"MA","Gas":1992.8,"coordinates":[-71.0675,42.3908]},{"Plant":"Kendall Square Station","State":"MA","Gas":208.5,"coordinates":[-71.0792,42.3633]},{"Plant":"Apache Station","State":"AZ","Gas":198.5,"coordinates":[-109.8931,32.0603]},{"Plant":"Potter Station 2","State":"MA","Gas":183.3,"coordinates":[-70.9672,42.235]},{"Plant":"B C Cobb","State":"MI","Gas":187,"coordinates":[-86.2423,43.2588]},{"Plant":"Lake Catherine","State":"AR","Gas":519.7,"coordinates":[-92.9049,34.4341]},{"Plant":"Dan E Karn","State":"MI","Gas":1204,"coordinates":[-83.8401,43.645]},{"Plant":"Thetford","State":"MI","Gas":114,"coordinates":[-83.6286,43.1567]},{"Plant":"Delray","State":"MI","Gas":120,"coordinates":[-83.1019,42.2947]},{"Plant":"Hancock","State":"MI","Gas":124,"coordinates":[-83.4425,42.5497]},{"Plant":"River Rouge","State":"MI","Gas":234,"coordinates":[-83.1119,42.2739]},{"Plant":"Mistersky","State":"MI","Gas":110,"coordinates":[-83.0903,42.3039]},{"Plant":"Black Dog","State":"MN","Gas":271,"coordinates":[-93.2501,44.8108]},{"Plant":"High Bridge","State":"MN","Gas":534,"coordinates":[-93.1117,44.9314]},{"Plant":"Inver Hills","State":"MN","Gas":282,"coordinates":[-93.042,44.781]},{"Plant":"Riverside","State":"MN","Gas":470,"coordinates":[-93.2753,45.0203]},{"Plant":"Thomas Fitzhugh","State":"AR","Gas":162,"coordinates":[-93.8049,35.4624]},{"Plant":"Carl Bailey","State":"AR","Gas":122,"coordinates":[-91.3634,35.2601]},{"Plant":"McClellan","State":"AR","Gas":134,"coordinates":[-92.7917,33.5648]},{"Plant":"Cambridge CT","State":"MN","Gas":166.9,"coordinates":[-93.2081,45.601]},{"Plant":"Elk River","State":"MN","Gas":195.9,"coordinates":[-93.5584,45.2968]},{"Plant":"Chevron Oil","State":"MS","Gas":130,"coordinates":[-88.4919,30.34]},{"Plant":"Sweatt","State":"MS","Gas":124,"coordinates":[-88.7461,32.2925]},{"Plant":"Jack Watson","State":"MS","Gas":292,"coordinates":[-89.0286,30.4392]},{"Plant":"Baxter Wilson","State":"MS","Gas":1162.7,"coordinates":[-90.9306,32.2831]},{"Plant":"Rex Brown","State":"MS","Gas":232.8,"coordinates":[-90.213,32.357]},{"Plant":"Moselle","State":"MS","Gas":477,"coordinates":[-89.3004,31.528]},{"Plant":"Hawthorn","State":"MO","Gas":384.3,"coordinates":[-94.4778,39.1306]},{"Plant":"Lake Road","State":"MO","Gas":102,"coordinates":[-94.8773,39.7246]},{"Plant":"James River Power Station","State":"MO","Gas":155,"coordinates":[-93.2619,37.1086]},{"Plant":"Canaday","State":"NE","Gas":115,"coordinates":[-99.7011,40.6942]},{"Plant":"C W Burdick","State":"NE","Gas":174.1,"coordinates":[-98.3269,40.9228]},{"Plant":"Sarpy County","State":"NE","Gas":315.3,"coordinates":[-95.9706,41.1706]},{"Plant":"Clark","State":"NV","Gas":1141,"coordinates":[-115.0507,36.0875]},{"Plant":"Fort Churchill","State":"NV","Gas":226,"coordinates":[-119.1322,39.1281]},{"Plant":"Tracy","State":"NV","Gas":1033.6,"coordinates":[-119.525,39.5625]},{"Plant":"Deepwater","State":"NJ","Gas":160.1,"coordinates":[-75.5083,39.6831]},{"Plant":"Sayreville","State":"NJ","Gas":150,"coordinates":[-74.3523,40.4765]},{"Plant":"Gilbert","State":"NJ","Gas":516,"coordinates":[-75.1639,40.5658]},{"Plant":"Bergen Generating Station","State":"NJ","Gas":1208,"coordinates":[-74.0244,40.8375]},{"Plant":"PSEG Burlington Generating Station","State":"NJ","Gas":170,"coordinates":[-74.8792,40.0766]},{"Plant":"PSEG Edison Generating Station","State":"NJ","Gas":516,"coordinates":[-74.3956,40.4911]},{"Plant":"PSEG Essex Generating Station","State":"NJ","Gas":617,"coordinates":[-74.1206,40.7372]},{"Plant":"PSEG Kearny Generating Station","State":"NJ","Gas":442,"coordinates":[-74.0965,40.7373]},{"Plant":"PSEG Linden Generating Station","State":"NJ","Gas":1572,"coordinates":[-74.2072,40.6217]},{"Plant":"PSEG Sewaren Generating Station","State":"NJ","Gas":452.6,"coordinates":[-74.2469,40.5558]},{"Plant":"Rio Grande","State":"NM","Gas":324.2,"coordinates":[-106.5472,31.8047]},{"Plant":"Maddox","State":"NM","Gas":183,"coordinates":[-103.3015,32.7142]},{"Plant":"Reeves","State":"NM","Gas":154,"coordinates":[-106.6019,35.171]},{"Plant":"Cunningham","State":"NM","Gas":466,"coordinates":[-103.3533,32.7131]},{"Plant":"Humboldt Bay","State":"CA","Gas":163.4,"coordinates":[-124.2103,40.7415]},{"Plant":"Arthur Kill Generating Station","State":"NY","Gas":858,"coordinates":[-74.2,40.5916]},{"Plant":"East River","State":"NY","Gas":287.5,"coordinates":[-73.9742,40.7281]},{"Plant":"Gowanus Gas Turbines Generating","State":"NY","Gas":280.1,"coordinates":[-74.0051,40.6635]},{"Plant":"Narrows Gas Turbines Generating","State":"NY","Gas":286,"coordinates":[-74.0208,40.6486]},{"Plant":"Ravenswood","State":"NY","Gas":2207.6,"coordinates":[-73.9461,40.7592]},{"Plant":"E F Barrett","State":"NY","Gas":668,"coordinates":[-73.6479,40.6167]},{"Plant":"Northport","State":"NY","Gas":1580.7,"coordinates":[-73.3423,40.9236]},{"Plant":"Port Jefferson","State":"NY","Gas":475.7,"coordinates":[-73.0785,40.9497]},{"Plant":"Bethlehem Energy Center","State":"NY","Gas":755,"coordinates":[-73.7638,42.5942]},{"Plant":"Dynegy Morro Bay LLC","State":"CA","Gas":999,"coordinates":[-120.8566,35.3722]},{"Plant":"Dynegy Moss Landing Power Plant","State":"CA","Gas":2529,"coordinates":[-121.7822,36.8048]},{"Plant":"Bowline Point","State":"NY","Gas":1153,"coordinates":[-73.9689,41.2044]},{"Plant":"Asheville","State":"NC","Gas":324,"coordinates":[-82.5417,35.4731]},{"Plant":"Pittsburg Power","State":"CA","Gas":1311,"coordinates":[-121.8945,38.0392]},{"Plant":"Buck","State":"NC","Gas":631,"coordinates":[-80.3767,35.7133]},{"Plant":"Dan River","State":"NC","Gas":637,"coordinates":[-79.7208,36.4862]},{"Plant":"Dicks Creek","State":"OH","Gas":106.2,"coordinates":[-84.3778,39.465]},{"Plant":"Frank M Tait","State":"OH","Gas":256,"coordinates":[-84.2111,39.7272]},{"Plant":"Yankee Street","State":"OH","Gas":100.3,"coordinates":[-84.2047,39.603]},{"Plant":"FirstEnergy West Lorain","State":"OH","Gas":425,"coordinates":[-82.2644,41.4294]},{"Plant":"Richland","State":"OH","Gas":358,"coordinates":[-84.3346,41.3052]},{"Plant":"Hamilton","State":"OH","Gas":123,"coordinates":[-84.5543,39.4098]},{"Plant":"Horseshoe Lake","State":"OK","Gas":847,"coordinates":[-97.1797,35.5087]},{"Plant":"Mustang","State":"OK","Gas":535,"coordinates":[-97.675,35.4699]},{"Plant":"Seminole","State":"OK","Gas":1473,"coordinates":[-96.7258,34.9665]},{"Plant":"Northeastern","State":"OK","Gas":891,"coordinates":[-95.7008,36.4317]},{"Plant":"Southwestern","State":"OK","Gas":603,"coordinates":[-98.3524,35.1009]},{"Plant":"Tulsa","State":"OK","Gas":305,"coordinates":[-95.991,36.1165]},{"Plant":"Weleetka","State":"OK","Gas":163,"coordinates":[-96.1352,35.3233]},{"Plant":"Barry","State":"AL","Gas":962,"coordinates":[-88.0103,31.0069]},{"Plant":"Anadarko Plant","State":"OK","Gas":485,"coordinates":[-98.23,35.0847]},{"Plant":"Mooreland","State":"OK","Gas":322,"coordinates":[-99.2254,36.4372]},{"Plant":"Encina","State":"CA","Gas":964,"coordinates":[-117.3364,33.1361]},{"Plant":"Kearny","State":"CA","Gas":136,"coordinates":[-117.1338,32.834]},{"Plant":"Brunot Island","State":"PA","Gas":198,"coordinates":[-80.0438,40.4649]},{"Plant":"PPL Martins Creek","State":"PA","Gas":1772,"coordinates":[-75.1054,40.7978]},{"Plant":"AES Alamitos LLC","State":"CA","Gas":1997,"coordinates":[-118.1009,33.7688]},{"Plant":"Hunlock Power Station","State":"PA","Gas":126.4,"coordinates":[-76.07,41.2006]},{"Plant":"Manchester Street","State":"RI","Gas":447,"coordinates":[-71.4042,41.8167]},{"Plant":"Darlington County","State":"SC","Gas":441,"coordinates":[-80.1657,34.4185]},{"Plant":"Hagood","State":"SC","Gas":126,"coordinates":[-79.9634,32.8265]},{"Plant":"Coolwater","State":"CA","Gas":636,"coordinates":[-116.8539,34.8606]},{"Plant":"Urquhart","State":"SC","Gas":640,"coordinates":[-81.9111,33.435]},{"Plant":"El Segundo Power","State":"CA","Gas":335,"coordinates":[-118.4242,33.9098]},{"Plant":"Etiwanda Generating Station","State":"CA","Gas":640,"coordinates":[-117.5266,34.0912]},{"Plant":"AES Huntington Beach LLC","State":"CA","Gas":451.6,"coordinates":[-117.9792,33.6439]},{"Plant":"Allen Steam Plant","State":"TN","Gas":427.2,"coordinates":[-90.1487,35.0741]},{"Plant":"Gallatin","State":"TN","Gas":579.6,"coordinates":[-86.4006,36.3156]},{"Plant":"John Sevier","State":"TN","Gas":878,"coordinates":[-82.9639,36.3767]},{"Plant":"Johnsonville","State":"TN","Gas":1044.8,"coordinates":[-87.9861,36.0278]},{"Plant":"Long Beach Generation LLC","State":"CA","Gas":260,"coordinates":[-118.2248,33.7641]},{"Plant":"E S Joslin","State":"TX","Gas":254,"coordinates":[-96.5458,28.6472]},{"Plant":"Laredo","State":"TX","Gas":188.4,"coordinates":[-99.5089,27.5667]},{"Plant":"Nueces Bay","State":"TX","Gas":633,"coordinates":[-97.4192,27.8194]},{"Plant":"Victoria","State":"TX","Gas":285,"coordinates":[-97.01,28.7883]},{"Plant":"Mandalay","State":"CA","Gas":560,"coordinates":[-119.2511,34.2067]},{"Plant":"Lake Hubbard","State":"TX","Gas":907,"coordinates":[-96.5458,32.8358]},{"Plant":"Mountain Creek","State":"TX","Gas":808,"coordinates":[-96.9358,32.7231]},{"Plant":"Newman","State":"TX","Gas":760.9,"coordinates":[-106.4318,31.9836]},{"Plant":"Lewis Creek","State":"TX","Gas":460.2,"coordinates":[-95.5214,30.4356]},{"Plant":"Sabine","State":"TX","Gas":1822.8,"coordinates":[-93.878,30.0242]},{"Plant":"Cedar Bayou","State":"TX","Gas":1495,"coordinates":[-94.9256,29.75]},{"Plant":"Greens Bayou","State":"TX","Gas":760,"coordinates":[-95.2194,29.8222]},{"Plant":"Sam Bertron","State":"TX","Gas":765,"coordinates":[-95.0598,29.7268]},{"Plant":"T H Wharton","State":"TX","Gas":1025,"coordinates":[-95.5306,29.9417]},{"Plant":"W A Parish","State":"TX","Gas":1176,"coordinates":[-95.6311,29.4828]},{"Plant":"Knox Lee","State":"TX","Gas":471,"coordinates":[-94.6415,32.3766]},{"Plant":"Wilkes","State":"TX","Gas":883,"coordinates":[-94.548,32.8482]},{"Plant":"Jones","State":"TX","Gas":825,"coordinates":[-101.7392,33.5239]},{"Plant":"Nichols","State":"TX","Gas":457,"coordinates":[-101.7464,35.2834]},{"Plant":"Plant X","State":"TX","Gas":411,"coordinates":[-102.4114,34.1661]},{"Plant":"Graham","State":"TX","Gas":615,"coordinates":[-98.6117,33.1344]},{"Plant":"Handley","State":"TX","Gas":1265,"coordinates":[-97.2192,32.7283]},{"Plant":"Morgan Creek","State":"TX","Gas":407,"coordinates":[-100.9156,32.3358]},{"Plant":"Permian Basin","State":"TX","Gas":995,"coordinates":[-102.9633,31.5839]},{"Plant":"Ormond Beach","State":"CA","Gas":1516,"coordinates":[-119.1689,34.1292]},{"Plant":"Lake Creek","State":"TX","Gas":317,"coordinates":[-96.985,31.4647]},{"Plant":"Stryker Creek","State":"TX","Gas":669,"coordinates":[-94.9898,31.9398]},{"Plant":"Trinidad","State":"TX","Gas":226,"coordinates":[-96.1013,32.1245]},{"Plant":"Valley","State":"TX","Gas":1069,"coordinates":[-96.3676,33.6281]},{"Plant":"Decker Creek","State":"TX","Gas":932,"coordinates":[-97.6128,30.3033]},{"Plant":"Silas Ray","State":"TX","Gas":125,"coordinates":[-97.5214,25.9131]},{"Plant":"AES Redondo Beach LLC","State":"CA","Gas":1310,"coordinates":[-118.395,33.8504]},{"Plant":"Bryan","State":"TX","Gas":130,"coordinates":[-96.3723,30.6474]},{"Plant":"Ray Olinger","State":"TX","Gas":395,"coordinates":[-96.4525,33.0681]},{"Plant":"Mountainview Generating Station","State":"CA","Gas":972,"coordinates":[-117.2418,34.0818]},{"Plant":"Sim Gideon","State":"TX","Gas":620,"coordinates":[-97.2708,30.1456]},{"Plant":"Ty Cooke","State":"TX","Gas":120,"coordinates":[-101.7906,33.5211]},{"Plant":"Leon Creek","State":"TX","Gas":184,"coordinates":[-98.5761,29.3525]},{"Plant":"O W Sommers","State":"TX","Gas":830,"coordinates":[-98.3242,29.3081]},{"Plant":"V H Braunig","State":"TX","Gas":1055,"coordinates":[-98.3825,29.2567]},{"Plant":"R W Miller","State":"TX","Gas":574,"coordinates":[-98.3103,32.6581]},{"Plant":"Pearsall","State":"TX","Gas":270.6,"coordinates":[-99.0919,28.9275]},{"Plant":"Sam Rayburn","State":"TX","Gas":205,"coordinates":[-97.135,28.8947]},{"Plant":"Gadsby","State":"UT","Gas":354.5,"coordinates":[-111.9289,40.7686]},{"Plant":"Grayson","State":"CA","Gas":256,"coordinates":[-118.2782,34.1556]},{"Plant":"Bremo Bluff","State":"VA","Gas":227,"coordinates":[-78.2878,37.7089]},{"Plant":"Chesterfield","State":"VA","Gas":397,"coordinates":[-77.3833,37.3822]},{"Plant":"Possum Point","State":"VA","Gas":875,"coordinates":[-77.2806,38.5367]},{"Plant":"El Centro","State":"CA","Gas":325.3,"coordinates":[-115.54,32.8022]},{"Plant":"Harbor","State":"CA","Gas":461,"coordinates":[-118.2656,33.7706]},{"Plant":"Haynes","State":"CA","Gas":1571.8,"coordinates":[-118.0991,33.7647]},{"Plant":"Wheaton","State":"WI","Gas":190,"coordinates":[-91.5158,44.8854]},{"Plant":"Scattergood","State":"CA","Gas":796,"coordinates":[-118.4276,33.9182]},{"Plant":"Port Washington Generating Station","State":"WI","Gas":1081.6,"coordinates":[-87.8689,43.3842]},{"Plant":"Rock River","State":"WI","Gas":126.4,"coordinates":[-89.0276,42.582]},{"Plant":"West Marinette","State":"WI","Gas":156.4,"coordinates":[-87.6881,45.0869]},{"Plant":"Valley","State":"CA","Gas":556,"coordinates":[-118.3913,34.245]},{"Plant":"Powerlane Plant","State":"TX","Gas":111,"coordinates":[-96.1264,33.1707]},{"Plant":"Glenarm","State":"CA","Gas":151.6,"coordinates":[-118.1494,34.126]},{"Plant":"Spencer","State":"TX","Gas":122,"coordinates":[-97.1061,33.1975]},{"Plant":"Colbert","State":"AL","Gas":363.2,"coordinates":[-87.8486,34.7439]},{"Plant":"Barney M Davis","State":"TX","Gas":968,"coordinates":[-97.3117,27.6064]},{"Plant":"Riverside","State":"OK","Gas":1067,"coordinates":[-95.9567,35.9978]},{"Plant":"Pittsfield Generating LP","State":"MA","Gas":154.3,"coordinates":[-73.2181,42.4564]},{"Plant":"Linden Cogen Plant","State":"NJ","Gas":906.2,"coordinates":[-74.2156,40.6322]},{"Plant":"Houston Chemical Complex Battleground","State":"TX","Gas":263,"coordinates":[-95.0839,29.7314]},{"Plant":"Paris Energy Center","State":"TX","Gas":236,"coordinates":[-95.5577,33.6968]},{"Plant":"Hal C Weaver Power Plant","State":"TX","Gas":146.8,"coordinates":[-97.7356,30.2867]},{"Plant":"Sycamore Cogeneration","State":"CA","Gas":300,"coordinates":[-118.9853,35.4526]},{"Plant":"Union Carbide Seadrift Cogen","State":"TX","Gas":168,"coordinates":[-96.7706,28.5105]},{"Plant":"Dow St Charles Operations","State":"LA","Gas":270,"coordinates":[-90.4414,29.9861]},{"Plant":"Watson Cogeneration","State":"CA","Gas":398,"coordinates":[-118.2448,33.8166]},{"Plant":"Bucksport Generation LLC","State":"ME","Gas":273.8,"coordinates":[-68.8046,44.5738]},{"Plant":"Bethpage Power Plant","State":"NY","Gas":184,"coordinates":[-73.4994,40.7469]},{"Plant":"Shell Deer Park","State":"TX","Gas":140,"coordinates":[-95.1289,29.7232]},{"Plant":"Newark Bay Cogeneration Partnership LP","State":"NJ","Gas":120.2,"coordinates":[-74.13,40.7197]},{"Plant":"Indeck Corinth Energy Center","State":"NY","Gas":133,"coordinates":[-73.8125,43.25]},{"Plant":"Procter & Gamble Mehoopany Mill","State":"PA","Gas":104.9,"coordinates":[-76.0432,41.5743]},{"Plant":"PPG Powerhouse C","State":"LA","Gas":303.2,"coordinates":[-93.2831,30.2242]},{"Plant":"Bayonne Plant Holding LLC","State":"NJ","Gas":170.2,"coordinates":[-74.1124,40.6553]},{"Plant":"Harbor Cogen","State":"CA","Gas":101.7,"coordinates":[-118.2303,33.7771]},{"Plant":"Rosemary Power Station","State":"NC","Gas":165,"coordinates":[-77.6594,36.4517]},{"Plant":"Oklahoma Cogeneration Project","State":"OK","Gas":111.4,"coordinates":[-97.625,35.4397]},{"Plant":"Eagle Point Power Generation","State":"NJ","Gas":195,"coordinates":[-75.1592,39.8746]},{"Plant":"ExxonMobil Beaumont Refinery","State":"TX","Gas":610.6,"coordinates":[-94.0753,30.0636]},{"Plant":"JM Shafer Generating Station","State":"CO","Gas":263,"coordinates":[-104.7736,40.0986]},{"Plant":"Gary Works","State":"IN","Gas":161,"coordinates":[-87.3289,41.6224]},{"Plant":"Parlin Power Plant","State":"NJ","Gas":116.6,"coordinates":[-74.3272,40.4607]},{"Plant":"Optim Energy Altura Cogen LLC","State":"TX","Gas":496.8,"coordinates":[-95.1077,29.8161]},{"Plant":"Cumberland","State":"NJ","Gas":183.1,"coordinates":[-74.9654,39.3757]},{"Plant":"Gramercy Holdings LLC","State":"LA","Gas":106,"coordinates":[-90.6693,30.054]},{"Plant":"Hardee Power Station","State":"FL","Gas":358,"coordinates":[-81.9636,27.6364]},{"Plant":"Bellmeade Power Station","State":"VA","Gas":267,"coordinates":[-77.4317,37.4964]},{"Plant":"Motiva Enterprises Port Arthur Refinery","State":"TX","Gas":215.4,"coordinates":[-93.9569,29.8822]},{"Plant":"Ocean State Power","State":"RI","Gas":218.6,"coordinates":[-71.6689,42.0097]},{"Plant":"LaO Energy Systems","State":"LA","Gas":479,"coordinates":[-91.2325,30.3186]},{"Plant":"Doswell Energy Center","State":"VA","Gas":813.8,"coordinates":[-77.1448,37.8182]},{"Plant":"Elizabeth River Power Station","State":"VA","Gas":348,"coordinates":[-76.3083,36.775]},{"Plant":"Texas City Power Plant","State":"TX","Gas":451,"coordinates":[-94.9438,29.3787]},{"Plant":"Dow Chemical Texas Operation","State":"TX","Gas":532.2,"coordinates":[-95.4075,28.9913]},{"Plant":"Power Station 4","State":"TX","Gas":172,"coordinates":[-94.9219,29.3782]},{"Plant":"Midway Sunset Cogen","State":"CA","Gas":219,"coordinates":[-119.6294,35.2269]},{"Plant":"C R Wing Cogen Plant","State":"TX","Gas":212,"coordinates":[-101.4224,32.2732]},{"Plant":"Delaware City Plant","State":"DE","Gas":265,"coordinates":[-75.6343,39.5871]},{"Plant":"McWilliams","State":"AL","Gas":663,"coordinates":[-86.4764,31.4003]},{"Plant":"J K Smith","State":"KY","Gas":784,"coordinates":[-84.1017,37.8833]},{"Plant":"Lockport Energy Associates LP","State":"NY","Gas":198.8,"coordinates":[-78.745,43.1619]},{"Plant":"Kennedy International Airport Cogen","State":"NY","Gas":122.3,"coordinates":[-73.7778,40.6417]},{"Plant":"March Point Cogeneration","State":"WA","Gas":146.2,"coordinates":[-122.56,48.4708]},{"Plant":"Saguaro Power","State":"NV","Gas":101,"coordinates":[-115.0117,36.0417]},{"Plant":"Ocean State Power II","State":"RI","Gas":218.6,"coordinates":[-71.6701,42.0099]},{"Plant":"Orange Cogeneration Facility","State":"FL","Gas":110.6,"coordinates":[-81.8251,27.8708]},{"Plant":"Lake Cogen Ltd","State":"FL","Gas":121,"coordinates":[-81.676,28.9158]},{"Plant":"Pasco Cogen Ltd","State":"FL","Gas":121,"coordinates":[-82.1889,28.3746]},{"Plant":"Mulberry Cogeneration Facility","State":"FL","Gas":113,"coordinates":[-81.8775,27.8489]},{"Plant":"Orlando Cogen LP","State":"FL","Gas":120,"coordinates":[-81.4123,28.4426]},{"Plant":"Ferndale Generating Station","State":"WA","Gas":270,"coordinates":[-122.6867,48.8288]},{"Plant":"Hartwell Energy Facility","State":"GA","Gas":289,"coordinates":[-82.8199,34.3396]},{"Plant":"Sithe Independence Station","State":"NY","Gas":930.4,"coordinates":[-76.4511,43.495]},{"Plant":"Saranac Facility","State":"NY","Gas":241.5,"coordinates":[-73.4557,44.7132]},{"Plant":"NAEA Lakewood LLC","State":"NJ","Gas":218.1,"coordinates":[-74.1686,40.0613]},{"Plant":"Auburndale Power Partners","State":"FL","Gas":155.3,"coordinates":[-81.8058,28.0542]},{"Plant":"Oyster Creek Unit VIII","State":"TX","Gas":379,"coordinates":[-95.342,28.9802]},{"Plant":"Hermiston Generating Plant","State":"OR","Gas":464,"coordinates":[-119.37,45.8042]},{"Plant":"Grays Ferry Cogeneration","State":"PA","Gas":150,"coordinates":[-75.1881,39.9422]},{"Plant":"Milford Power LP","State":"MA","Gas":148,"coordinates":[-71.5115,42.1294]},{"Plant":"Milagro Cogeneration Plant","State":"NM","Gas":121.6,"coordinates":[-107.9417,36.7367]},{"Plant":"Johnson County","State":"TX","Gas":267,"coordinates":[-97.4078,32.3994]},{"Plant":"Brandywine Power Facility","State":"MD","Gas":230,"coordinates":[-76.8678,38.6681]},{"Plant":"Gordonsville Energy LP","State":"VA","Gas":218,"coordinates":[-78.2138,38.1179]},{"Plant":"Sun Peak Generating Station","State":"NV","Gas":222,"coordinates":[-115.0339,36.1375]},{"Plant":"Brooklyn Navy Yard Cogeneration","State":"NY","Gas":250,"coordinates":[-73.9764,40.6994]},{"Plant":"Michigan Power LP","State":"MI","Gas":128,"coordinates":[-86.425,43.9375]},{"Plant":"LSP-Cottage Grove LP","State":"MN","Gas":251,"coordinates":[-92.9119,44.7956]},{"Plant":"LSP-Whitewater LP","State":"WI","Gas":261,"coordinates":[-88.7299,42.8555]},{"Plant":"Sweeny Cogen Facility","State":"TX","Gas":436,"coordinates":[-95.745,29.0728]},{"Plant":"Dighton Power Plant","State":"MA","Gas":164.2,"coordinates":[-71.1239,41.8312]},{"Plant":"De Pere Energy Center","State":"WI","Gas":171.3,"coordinates":[-88.072,44.4486]},{"Plant":"Androscoggin Energy Center","State":"ME","Gas":136.6,"coordinates":[-70.2423,44.5063]},{"Plant":"Delta Person LLC","State":"NM","Gas":140,"coordinates":[-106.644,35.026]},{"Plant":"Mid-Georgia Cogeneration Facility","State":"GA","Gas":303,"coordinates":[-83.6039,32.4856]},{"Plant":"Berkshire Power","State":"MA","Gas":229.3,"coordinates":[-72.6478,42.0476]},{"Plant":"Bridgeport Energy Project","State":"CT","Gas":454,"coordinates":[-73.1844,41.1692]},{"Plant":"Pasadena Cogeneration","State":"TX","Gas":700,"coordinates":[-95.1765,29.7248]},{"Plant":"Tiverton Power Plant","State":"RI","Gas":250,"coordinates":[-71.1706,41.6422]},{"Plant":"Axiall Plaquemine","State":"LA","Gas":240,"coordinates":[-91.185,30.2586]},{"Plant":"Tenaska Georgia Generation Facility","State":"GA","Gas":933,"coordinates":[-84.9996,33.3516]},{"Plant":"Tenaska Frontier Generation Station","State":"TX","Gas":860,"coordinates":[-95.9178,30.5924]},{"Plant":"Batesville Generation Facility","State":"MS","Gas":858,"coordinates":[-89.9275,34.3356]},{"Plant":"Black Hawk Station","State":"TX","Gas":220.4,"coordinates":[-101.36,35.6957]},{"Plant":"Mustang Station","State":"TX","Gas":486,"coordinates":[-102.7417,32.9728]},{"Plant":"Maine Independence Station","State":"ME","Gas":490,"coordinates":[-68.7094,44.8242]},{"Plant":"Pine Bluff Energy Center","State":"AR","Gas":192,"coordinates":[-91.9025,34.2181]},{"Plant":"Desert Star Energy Center","State":"NV","Gas":450,"coordinates":[-114.9928,35.7867]},{"Plant":"Millennium Power","State":"MA","Gas":334.9,"coordinates":[-72.0151,42.1123]},{"Plant":"New Albany Energy Facility","State":"MS","Gas":360,"coordinates":[-88.9397,34.5408]},{"Plant":"Brownsville Peaking Power","State":"TN","Gas":456,"coordinates":[-89.198,35.5438]},{"Plant":"Crockett Cogen Project","State":"CA","Gas":247.4,"coordinates":[-122.2161,38.0569]},{"Plant":"Gregory Power Facility","State":"TX","Gas":366,"coordinates":[-97.2584,27.8893]},{"Plant":"Zeeland Generating Station","State":"MI","Gas":839.8,"coordinates":[-85.9975,42.8206]},{"Plant":"Dearborn Industrial Generation","State":"MI","Gas":710,"coordinates":[-83.154,42.3026]},{"Plant":"Taft Cogeneration Facility","State":"LA","Gas":790,"coordinates":[-90.4599,29.9888]},{"Plant":"Midlothian Energy Facility","State":"TX","Gas":1444,"coordinates":[-97.0537,32.4302]},{"Plant":"Lamar Power Project","State":"TX","Gas":1002,"coordinates":[-95.59,33.6308]},{"Plant":"Frontera Energy Center","State":"TX","Gas":500,"coordinates":[-98.3992,26.208]},{"Plant":"NRG Sterlington Power","State":"LA","Gas":176,"coordinates":[-92.0811,32.6889]},{"Plant":"Rumford Power Associates","State":"ME","Gas":254,"coordinates":[-70.5219,44.5303]},{"Plant":"Livingston Generating Station","State":"MI","Gas":132,"coordinates":[-84.7308,45.0304]},{"Plant":"Klamath Cogeneration Plant","State":"OR","Gas":490,"coordinates":[-121.8106,42.1739]},{"Plant":"Entergy Rhode Island State Energy LP","State":"RI","Gas":538,"coordinates":[-71.5186,41.8017]},{"Plant":"Rocky Road Power LLC","State":"IL","Gas":327.3,"coordinates":[-88.2397,42.0931]},{"Plant":"Madison","State":"OH","Gas":576,"coordinates":[-84.4647,39.4522]},{"Plant":"Vermillion Energy Facility","State":"IN","Gas":568,"coordinates":[-87.4464,39.9223]},{"Plant":"Sutter Energy Center","State":"CA","Gas":530,"coordinates":[-121.6959,39.0531]},{"Plant":"Rockingham County CT Station","State":"NC","Gas":825,"coordinates":[-79.8297,36.3297]},{"Plant":"RS Cogen","State":"LA","Gas":415.4,"coordinates":[-93.2992,30.221]},{"Plant":"SRW Cogen LP","State":"TX","Gas":420,"coordinates":[-93.7574,30.0545]},{"Plant":"Magic Valley Generating Station","State":"TX","Gas":682,"coordinates":[-98.19,26.3403]},{"Plant":"Griffith Energy LLC","State":"AZ","Gas":570,"coordinates":[-114.1333,35.054]},{"Plant":"Milford Power Project","State":"CT","Gas":506.7,"coordinates":[-73.0997,41.2244]},{"Plant":"Manchief Electric Generating Station","State":"CO","Gas":264,"coordinates":[-103.685,40.2171]},{"Plant":"Walton County Power LLC","State":"GA","Gas":454.5,"coordinates":[-83.6954,33.8148]},{"Plant":"Desert Basin","State":"AZ","Gas":577,"coordinates":[-111.7889,32.9042]},{"Plant":"Kendall County Generation Facility","State":"IL","Gas":1140,"coordinates":[-88.2581,41.4797]},{"Plant":"Tenaska Gateway Generating Station","State":"TX","Gas":845,"coordinates":[-94.6197,32.0178]},{"Plant":"Alliant Energy Neenah","State":"WI","Gas":299.7,"coordinates":[-88.5064,44.1936]},{"Plant":"Rio Nogales Power Project","State":"TX","Gas":756,"coordinates":[-97.9732,29.5931]},{"Plant":"Wolf Hollow I LP","State":"TX","Gas":705,"coordinates":[-97.7317,32.3342]},{"Plant":"Hawk Road Facility","State":"GA","Gas":475.8,"coordinates":[-84.9914,33.3585]},{"Plant":"Hays Energy Project","State":"TX","Gas":881,"coordinates":[-97.9894,29.7806]},{"Plant":"Green Country Energy LLC","State":"OK","Gas":783,"coordinates":[-95.9346,35.9833]},{"Plant":"Worthington Generation LLC","State":"IN","Gas":164.1,"coordinates":[-87.0128,39.0708]},{"Plant":"Lake Road Generating Plant","State":"CT","Gas":757.3,"coordinates":[-71.8958,41.872]},{"Plant":"La Paloma Generating LLC","State":"CA","Gas":965.4,"coordinates":[-119.5919,35.2956]},{"Plant":"Guadalupe Generating Station","State":"TX","Gas":982.3,"coordinates":[-98.1419,29.6244]},{"Plant":"Lost Pines 1 Power Project","State":"TX","Gas":516,"coordinates":[-97.2714,30.1478]},{"Plant":"Bluegrass Generating Station","State":"KY","Gas":501,"coordinates":[-85.4133,38.3902]},{"Plant":"Calcasieu","State":"LA","Gas":301.9,"coordinates":[-93.345,30.1608]},{"Plant":"Broad River Energy Center","State":"SC","Gas":840.4,"coordinates":[-81.575,35.0786]},{"Plant":"Bastrop Energy Center","State":"TX","Gas":525,"coordinates":[-97.55,30.1458]},{"Plant":"Granite Ridge","State":"NH","Gas":678,"coordinates":[-71.4261,42.9042]},{"Plant":"Bosque County Peaking","State":"TX","Gas":748,"coordinates":[-97.3586,31.8594]},{"Plant":"Acadia Energy Center","State":"LA","Gas":1063,"coordinates":[-92.4131,30.4286]},{"Plant":"Eastman Cogeneration Facility","State":"TX","Gas":402.2,"coordinates":[-94.6903,32.4481]},{"Plant":"South Point Energy Center","State":"AZ","Gas":550,"coordinates":[-114.5317,34.8678]},{"Plant":"Dogwood Energy Facility","State":"MO","Gas":616,"coordinates":[-94.3006,38.7931]},{"Plant":"Rathdrum Power LLC","State":"ID","Gas":248,"coordinates":[-116.9203,47.7858]},{"Plant":"Sunrise Power LLC","State":"CA","Gas":545,"coordinates":[-119.585,35.2097]},{"Plant":"Channelview Cogeneration Plant","State":"TX","Gas":811,"coordinates":[-95.1217,29.837]},{"Plant":"Cordova Energy","State":"IL","Gas":521.2,"coordinates":[-90.2797,41.7122]},{"Plant":"Osceola","State":"FL","Gas":471,"coordinates":[-81.0978,28.1289]},{"Plant":"Ontelaunee Energy Center","State":"PA","Gas":526,"coordinates":[-75.9356,40.4219]},{"Plant":"Caledonia","State":"MS","Gas":765,"coordinates":[-88.2717,33.6464]},{"Plant":"Riverside Generating LLC","State":"KY","Gas":825,"coordinates":[-82.6046,38.1917]},{"Plant":"Elwood Energy LLC","State":"IL","Gas":1350,"coordinates":[-88.1236,41.4388]},{"Plant":"Arapahoe Combustion Turbine Project","State":"CO","Gas":122.5,"coordinates":[-105.0018,39.6692]},{"Plant":"Gibson City","State":"IL","Gas":228,"coordinates":[-88.3987,40.4705]},{"Plant":"Pinckneyville","State":"IL","Gas":316,"coordinates":[-89.3467,38.1114]},{"Plant":"Kinmundy","State":"IL","Gas":208,"coordinates":[-89.0128,38.7619]},{"Plant":"Corpus Christi Energy Center","State":"TX","Gas":467,"coordinates":[-97.4283,27.8139]},{"Plant":"Afton Generating Station","State":"NM","Gas":235.6,"coordinates":[-106.8465,32.1142]},{"Plant":"ANP Bellingham Energy Project","State":"MA","Gas":471.7,"coordinates":[-71.4535,42.1106]},{"Plant":"ANP Blackstone Energy Project","State":"MA","Gas":454.8,"coordinates":[-71.5158,42.0599]},{"Plant":"Odessa Ector Generating Station","State":"TX","Gas":1001.1,"coordinates":[-102.3264,31.8403]},{"Plant":"Morris Cogeneration LLC","State":"IL","Gas":176,"coordinates":[-88.3328,41.4119]},{"Plant":"Los Medanos Energy Center","State":"CA","Gas":567,"coordinates":[-121.873,38.0301]},{"Plant":"Hinds Energy Facility","State":"MS","Gas":300,"coordinates":[-90.2199,32.379]},{"Plant":"Attala","State":"MS","Gas":454.9,"coordinates":[-89.6753,33.0147]},{"Plant":"Harry L. Oswald","State":"AR","Gas":548,"coordinates":[-92.2166,34.5923]},{"Plant":"Lincoln Generating Facility","State":"IL","Gas":622.9,"coordinates":[-87.9436,41.3933]},{"Plant":"Ennis Power Company LLC","State":"TX","Gas":359.5,"coordinates":[-96.675,32.32]},{"Plant":"Wheatland Generating Facility","State":"IN","Gas":460,"coordinates":[-87.2931,38.6716]},{"Plant":"Oneta Energy Center","State":"OK","Gas":1086.4,"coordinates":[-95.6967,36.0119]},{"Plant":"Freestone Energy Center","State":"TX","Gas":953,"coordinates":[-96.1131,31.8907]},{"Plant":"Greenville Electric Generating Station","State":"OH","Gas":196,"coordinates":[-84.6151,40.0758]},{"Plant":"Montpelier Electric Generating Station","State":"IN","Gas":180,"coordinates":[-85.3057,40.6206]},{"Plant":"Jack County","State":"TX","Gas":1241,"coordinates":[-97.9574,33.101]},{"Plant":"Liberty Electric Power Plant","State":"PA","Gas":541,"coordinates":[-75.3358,39.8614]},{"Plant":"Marshall Energy Facility","State":"KY","Gas":581.6,"coordinates":[-88.3958,37.0286]},{"Plant":"Handsome Lake Energy LLC","State":"PA","Gas":267.5,"coordinates":[-79.8061,41.2908]},{"Plant":"Audrain Generating Station","State":"MO","Gas":608,"coordinates":[-91.5369,39.3092]},{"Plant":"Lee Energy Facility","State":"IL","Gas":568,"coordinates":[-89.4054,41.8287]},{"Plant":"Energy Shelby County","State":"IL","Gas":336,"coordinates":[-88.4772,39.2794]},{"Plant":"NRG Rockford I","State":"IL","Gas":296.9,"coordinates":[-89.1012,42.2386]},{"Plant":"Red Oak Power LLC","State":"NJ","Gas":765.9,"coordinates":[-74.3489,40.4487]},{"Plant":"Hog Bayou Energy Center","State":"AL","Gas":230,"coordinates":[-88.0575,30.7478]},{"Plant":"Santa Rosa Energy Center","State":"FL","Gas":235.9,"coordinates":[-87.115,30.5664]},{"Plant":"Astoria Gas Turbines","State":"NY","Gas":410.3,"coordinates":[-73.9048,40.787]},{"Plant":"Doyle Energy Facility","State":"GA","Gas":326.9,"coordinates":[-83.6996,33.8377]},{"Plant":"Darby Electric Generating Station","State":"OH","Gas":435,"coordinates":[-83.1778,39.7139]},{"Plant":"Tait Electric Generating Station","State":"OH","Gas":340,"coordinates":[-84.2095,39.7277]},{"Plant":"University Park South","State":"IL","Gas":300,"coordinates":[-87.7532,41.4409]},{"Plant":"Gleason Generating Facility","State":"TN","Gas":360,"coordinates":[-88.612,36.2454]},{"Plant":"Crete Energy Venture LLC","State":"IL","Gas":300,"coordinates":[-87.6187,41.4294]},{"Plant":"Whiting Clean Energy","State":"IN","Gas":513,"coordinates":[-87.4775,41.6739]},{"Plant":"Edward L. Addison Generating Plant","State":"GA","Gas":598.8,"coordinates":[-84.3064,32.9111]},{"Plant":"TVA Southaven Combined Cycle","State":"MS","Gas":780,"coordinates":[-90.0378,34.9939]},{"Plant":"Jackson Generating Station","State":"MI","Gas":564,"coordinates":[-84.3767,42.2488]},{"Plant":"Tenaska Lindsay Hill Generating Station","State":"AL","Gas":845,"coordinates":[-86.7386,32.6514]},{"Plant":"Ceredo Generating Station","State":"WV","Gas":450,"coordinates":[-82.5339,38.3681]},{"Plant":"Aurora","State":"IL","Gas":832,"coordinates":[-88.2265,41.8151]},{"Plant":"Southeast Chicago Energy Project","State":"IL","Gas":296,"coordinates":[-87.5449,41.7181]},{"Plant":"Arlington Valley Energy Facility","State":"AZ","Gas":579,"coordinates":[-112.8897,33.3417]},{"Plant":"Front Range Power Plant","State":"CO","Gas":460,"coordinates":[-104.7069,38.6281]},{"Plant":"Big Sandy Peaker Plant","State":"WV","Gas":300,"coordinates":[-82.5938,38.3441]},{"Plant":"Wolf Hills Energy","State":"VA","Gas":250,"coordinates":[-82.1044,36.6644]},{"Plant":"Oleander Power Project LP","State":"FL","Gas":790.2,"coordinates":[-80.7947,28.3661]},{"Plant":"Decatur Energy Center","State":"AL","Gas":725,"coordinates":[-87.0214,34.6292]},{"Plant":"Morgan Energy Center","State":"AL","Gas":749,"coordinates":[-87.0639,34.6397]},{"Plant":"Westbrook Energy Center Power Plant","State":"ME","Gas":506,"coordinates":[-70.375,43.6575]},{"Plant":"Blythe Energy Inc","State":"CA","Gas":514,"coordinates":[-114.6865,33.6157]},{"Plant":"Calumet Energy Team LLC","State":"IL","Gas":321.2,"coordinates":[-87.5563,41.6835]},{"Plant":"New Covert Generating Facility","State":"MI","Gas":1040.1,"coordinates":[-86.2937,42.3224]},{"Plant":"Fairless Energy Center","State":"PA","Gas":1211.2,"coordinates":[-74.7411,40.1475]},{"Plant":"Channel Energy Center LLC","State":"TX","Gas":585,"coordinates":[-95.2319,29.7189]},{"Plant":"Baconton Power Plant","State":"GA","Gas":196,"coordinates":[-84.08,31.3869]},{"Plant":"Gila River Power Station","State":"AZ","Gas":1030,"coordinates":[-112.6944,32.975]},{"Plant":"Air Products Port Arthur","State":"TX","Gas":158.9,"coordinates":[-93.9651,29.8665]},{"Plant":"Ingleside Cogeneration","State":"TX","Gas":460,"coordinates":[-97.2428,27.8828]},{"Plant":"Fore River Generating Station","State":"MA","Gas":726,"coordinates":[-70.9661,42.2422]},{"Plant":"Indian River","State":"FL","Gas":576.4,"coordinates":[-80.7802,28.4932]},{"Plant":"Wise County Power LLC","State":"TX","Gas":680,"coordinates":[-97.9103,33.0583]},{"Plant":"Chuck Lenzie Generating Station","State":"NV","Gas":1170,"coordinates":[-114.9218,36.3837]},{"Plant":"Baytown Energy Center","State":"TX","Gas":770,"coordinates":[-94.9019,29.7731]},{"Plant":"Hermiston Power Partnership","State":"OR","Gas":615,"coordinates":[-119.3133,45.794]},{"Plant":"Washington County","State":"GA","Gas":604,"coordinates":[-82.98,33.0922]},{"Plant":"Delta Energy Center","State":"CA","Gas":769.1,"coordinates":[-121.8439,38.0169]},{"Plant":"Holland Energy Facility","State":"IL","Gas":605.8,"coordinates":[-88.7584,39.2231]},{"Plant":"PPL Ironwood LLC","State":"PA","Gas":660.1,"coordinates":[-76.3658,40.3509]},{"Plant":"Dell Power Station","State":"AR","Gas":437,"coordinates":[-90.0253,35.8619]},{"Plant":"Luna Energy Facility","State":"NM","Gas":559,"coordinates":[-107.7834,32.2993]},{"Plant":"Otay Mesa Generating Project","State":"CA","Gas":571,"coordinates":[-116.915,32.5815]},{"Plant":"Armstrong","State":"PA","Gas":603.1,"coordinates":[-79.3517,40.638]},{"Plant":"Troy Energy LLC","State":"OH","Gas":584,"coordinates":[-83.4598,41.4772]},{"Plant":"Pleasants Energy LLC","State":"WV","Gas":323.9,"coordinates":[-81.3642,39.3325]},{"Plant":"Dresden Energy Facility","State":"OH","Gas":540,"coordinates":[-82.0276,40.0928]},{"Plant":"Brazos Valley Generating Facility","State":"TX","Gas":525,"coordinates":[-95.6244,29.4731]},{"Plant":"Cottonwood Energy Project","State":"TX","Gas":1180,"coordinates":[-93.7353,30.2588]},{"Plant":"Sugar Creek Power","State":"IN","Gas":549,"coordinates":[-87.5108,39.3931]},{"Plant":"Exelon LaPorte Generating Station","State":"TX","Gas":153.2,"coordinates":[-95.0718,29.7028]},{"Plant":"Harquahala Generating Project","State":"AZ","Gas":1054.4,"coordinates":[-113.1134,33.476]},{"Plant":"Astoria Energy","State":"NY","Gas":540,"coordinates":[-73.8964,40.7825]},{"Plant":"Union Power Partners LP","State":"AR","Gas":2020,"coordinates":[-92.5894,33.2961]},{"Plant":"Thomas A Smith Energy Facility","State":"GA","Gas":1250,"coordinates":[-84.9175,34.7094]},{"Plant":"Columbia Energy Center","State":"SC","Gas":543,"coordinates":[-81.0178,33.8697]},{"Plant":"RockGen Energy Center","State":"WI","Gas":471,"coordinates":[-89.0492,42.9767]},{"Plant":"Zion Energy Center","State":"IL","Gas":456,"coordinates":[-87.895,42.4776]},{"Plant":"Metcalf Energy Center","State":"CA","Gas":546.1,"coordinates":[-121.7457,37.2207]},{"Plant":"Crossroads Energy Center","State":"MS","Gas":308,"coordinates":[-90.5621,34.183]},{"Plant":"Washington Energy Facility","State":"OH","Gas":626,"coordinates":[-81.6564,39.58]},{"Plant":"Elk Hills Power LLC","State":"CA","Gas":525,"coordinates":[-119.4707,35.2803]},{"Plant":"Rolling Hills Generating","State":"OH","Gas":825,"coordinates":[-82.3328,39.0839]},{"Plant":"Renaissance Power LLC","State":"MI","Gas":660,"coordinates":[-84.8429,43.1864]},{"Plant":"Carville Energy LLC","State":"LA","Gas":525,"coordinates":[-91.065,30.2294]},{"Plant":"Athens Generating Plant","State":"NY","Gas":1137.9,"coordinates":[-73.8492,42.2728]},{"Plant":"Effingham County Power Project","State":"GA","Gas":509,"coordinates":[-81.2844,32.2773]},{"Plant":"Calhoun Energy Center","State":"AL","Gas":632,"coordinates":[-85.9731,33.5883]},{"Plant":"Hillabee Energy Center","State":"AL","Gas":721.8,"coordinates":[-85.9033,33.0007]},{"Plant":"Osprey Energy Center Power Plant","State":"FL","Gas":590,"coordinates":[-81.8083,28.0525]},{"Plant":"Shady Hills Generating Station","State":"FL","Gas":463.2,"coordinates":[-82.5586,28.3665]},{"Plant":"Vandolah Power Station","State":"FL","Gas":646,"coordinates":[-81.924,27.5236]},{"Plant":"Raccoon Creek Energy Center","State":"IL","Gas":304,"coordinates":[-88.5392,38.6996]},{"Plant":"Hot Spring Generating Facility","State":"AR","Gas":630,"coordinates":[-92.8683,34.2976]},{"Plant":"Plaquemine Cogeneration Plant","State":"LA","Gas":793,"coordinates":[-91.2347,30.3217]},{"Plant":"DeSoto County Plant","State":"FL","Gas":320,"coordinates":[-81.8092,27.2272]},{"Plant":"Bayou Cove Peaking Power","State":"LA","Gas":300,"coordinates":[-92.5997,30.2825]},{"Plant":"Elgin Energy Center","State":"IL","Gas":460,"coordinates":[-88.2446,42.0001]},{"Plant":"Tenaska Virginia Generating Station","State":"VA","Gas":899.1,"coordinates":[-78.3813,37.8667]},{"Plant":"Tenaska Central Alabama Generating Stn","State":"AL","Gas":923.8,"coordinates":[-86.74,32.6497]},{"Plant":"Columbia Energy Center","State":"MO","Gas":140,"coordinates":[-92.2629,39.0192]},{"Plant":"Magnolia Power Plant","State":"MS","Gas":918,"coordinates":[-89.2026,34.835]},{"Plant":"Fountain Valley Power Facility","State":"CO","Gas":234,"coordinates":[-104.6875,38.5569]},{"Plant":"Red Hawk","State":"AZ","Gas":934,"coordinates":[-112.8406,33.3346]},{"Plant":"McClain Energy Facility","State":"OK","Gas":353,"coordinates":[-97.5898,35.2977]},{"Plant":"Redbud Power Plant","State":"OK","Gas":1752.4,"coordinates":[-97.2264,35.6856]},{"Plant":"Deer Park Energy Center","State":"TX","Gas":961.2,"coordinates":[-95.1345,29.7134]},{"Plant":"Ouachita","State":"LA","Gas":770,"coordinates":[-92.0683,32.7061]},{"Plant":"Green Power 2","State":"TX","Gas":825.5,"coordinates":[-94.9328,29.3781]},{"Plant":"Forney Energy Center","State":"TX","Gas":1760,"coordinates":[-96.4916,32.7563]},{"Plant":"Mesquite Generating Station","State":"AZ","Gas":537.5,"coordinates":[-112.8642,33.345]},{"Plant":"Goldendale Generating Station","State":"WA","Gas":256.7,"coordinates":[-120.833,45.8114]},{"Plant":"Tri Center Naniwa Energy","State":"NV","Gas":200,"coordinates":[-119.5178,39.5572]},{"Plant":"Goose Creek Energy Center","State":"IL","Gas":438,"coordinates":[-88.5999,40.1069]},{"Plant":"Kiamichi Energy Facility","State":"OK","Gas":1178.4,"coordinates":[-95.9349,34.6831]},{"Plant":"Lawrenceburg Energy Facility","State":"IN","Gas":1080,"coordinates":[-84.8669,39.0911]},{"Plant":"AEP Waterford Facility","State":"OH","Gas":810,"coordinates":[-81.7178,39.5333]},{"Plant":"Limon Generating Station","State":"CO","Gas":134,"coordinates":[-103.7005,39.2038]},{"Plant":"Frank Knutson","State":"CO","Gas":134,"coordinates":[-104.682,39.9411]},{"Plant":"Apex Generating Station","State":"NV","Gas":494.4,"coordinates":[-114.9609,36.416]},{"Plant":"Fayette Energy Facility","State":"PA","Gas":628,"coordinates":[-79.9182,39.8592]},{"Plant":"Wallingford Energy","State":"CT","Gas":211.5,"coordinates":[-72.8354,41.4487]},{"Plant":"High Desert Power Plant","State":"CA","Gas":742.6,"coordinates":[-117.3647,34.5953]},{"Plant":"Sundance","State":"AZ","Gas":410,"coordinates":[-111.5899,32.9285]},{"Plant":"York Energy Center","State":"PA","Gas":545,"coordinates":[-76.3067,39.7375]},{"Plant":"Indigo Energy Facility","State":"CA","Gas":142.5,"coordinates":[-116.553,33.9109]},{"Plant":"Hidalgo Energy Center","State":"TX","Gas":470,"coordinates":[-98.1758,26.3417]},{"Plant":"Perryville Power Station","State":"LA","Gas":680.8,"coordinates":[-92.0183,32.6908]},{"Plant":"West Valley Generation Project","State":"UT","Gas":185,"coordinates":[-112.0317,40.6667]},{"Plant":"University Park North","State":"IL","Gas":504,"coordinates":[-87.7514,41.4425]},{"Plant":"Riverside Energy Center","State":"WI","Gas":579.5,"coordinates":[-89.0355,42.5827]},{"Plant":"Blue Spruce Energy Center","State":"CO","Gas":264,"coordinates":[-104.6814,39.7479]},{"Plant":"Plains End","State":"CO","Gas":114,"coordinates":[-105.226,39.8575]},{"Plant":"Spring Creek Energy Center","State":"OK","Gas":269,"coordinates":[-97.655,35.7422]},{"Plant":"Pastoria Energy Facility, LLC","State":"CA","Gas":724,"coordinates":[-118.844,34.9556]},{"Plant":"EP Newington Energy LLC","State":"NH","Gas":523,"coordinates":[-70.8061,43.1047]},{"Plant":"Chehalis Generating Facility","State":"WA","Gas":477,"coordinates":[-122.9131,46.6225]},{"Plant":"Harrison County Power Project","State":"TX","Gas":514.4,"coordinates":[-94.4367,32.3958]},{"Plant":"Lower Mount Bethel Energy","State":"PA","Gas":537.5,"coordinates":[-75.1076,40.8019]},{"Plant":"AL Sandersville LLC","State":"GA","Gas":576.4,"coordinates":[-82.8608,33.1189]},{"Plant":"Higgins Generating Station","State":"NV","Gas":550,"coordinates":[-115.3561,35.6139]},{"Plant":"Bethlehem Power Plant","State":"PA","Gas":1130,"coordinates":[-75.3147,40.6175]},{"Plant":"Quantum Choctaw Power LLC","State":"MS","Gas":690,"coordinates":[-89.2089,33.3792]},{"Plant":"Mint Farm Generating Station","State":"WA","Gas":275.9,"coordinates":[-122.9855,46.1388]},{"Plant":"Fremont Energy Center","State":"OH","Gas":667.3,"coordinates":[-83.1614,41.3771]},{"Plant":"Choctaw County","State":"MS","Gas":785,"coordinates":[-89.4201,33.2881]},{"Plant":"Allegheny Energy Units 3 4 & 5","State":"PA","Gas":509,"coordinates":[-79.7686,40.5453]},{"Plant":"Magnet Cove","State":"AR","Gas":641.5,"coordinates":[-92.8317,34.4297]},{"Plant":"Dean","State":"MI","Gas":295.4,"coordinates":[-82.4953,42.7725]},{"Plant":"Bennett Mountain","State":"ID","Gas":164,"coordinates":[-115.6666,43.1472]},{"Plant":"Hanging Rock Energy Facility","State":"OH","Gas":1252,"coordinates":[-82.7833,38.5731]},{"Plant":"Los Esteros Critical Energy Center","State":"CA","Gas":306.1,"coordinates":[-121.9319,37.425]},{"Plant":"FPL Energy Marcus Hook LP","State":"PA","Gas":765.2,"coordinates":[-75.4216,39.807]},{"Plant":"Valencia Energy Facility","State":"NM","Gas":144.3,"coordinates":[-106.7322,34.6115]},{"Plant":"Gilroy Peaking Energy Center","State":"CA","Gas":135,"coordinates":[-121.5363,36.999]},{"Plant":"Frederickson Power LP","State":"WA","Gas":242,"coordinates":[-122.3657,47.0861]},{"Plant":"Curtis H Stanton Energy Center","State":"FL","Gas":656.9,"coordinates":[-81.1669,28.4882]},{"Plant":"Auburndale Peaker Energy Center","State":"FL","Gas":117,"coordinates":[-81.8059,28.0535]},{"Plant":"Rocky Mountain Energy Center","State":"CO","Gas":580,"coordinates":[-104.5953,40.0908]},{"Plant":"Silverhawk","State":"NV","Gas":560,"coordinates":[-114.9606,36.4078]},{"Plant":"Inland Empire Energy Center","State":"CA","Gas":690,"coordinates":[-117.1704,33.7388]},{"Plant":"Jasper","State":"SC","Gas":869,"coordinates":[-81.1242,32.3594]},{"Plant":"Tracy Combined Cycle Power Plant","State":"CA","Gas":320.1,"coordinates":[-121.4906,37.7107]},{"Plant":"NRG Rockford II Energy Center","State":"IL","Gas":153,"coordinates":[-89.1011,42.2383]},{"Plant":"NAEA Ocean Peaking Power LLC","State":"NJ","Gas":325.6,"coordinates":[-74.1672,40.0633]},{"Plant":"Las Vegas Cogeneration II LLC","State":"NV","Gas":232,"coordinates":[-115.1238,36.232]},{"Plant":"Wansley Combined Cycle","State":"GA","Gas":1143.1,"coordinates":[-85.037,33.4064]},{"Plant":"Cosumnes","State":"CA","Gas":477,"coordinates":[-121.124,38.3385]},{"Plant":"Cass County","State":"NE","Gas":323.2,"coordinates":[-95.964,40.9479]},{"Plant":"Hunterstown","State":"PA","Gas":758,"coordinates":[-77.1672,39.8725]},{"Plant":"Palomar Energy","State":"CA","Gas":562,"coordinates":[-117.1178,33.1197]},{"Plant":"Exira","State":"IA","Gas":139.5,"coordinates":[-94.9197,41.5144]},{"Plant":"Donald Von Raesfeld Power Plant","State":"CA","Gas":154,"coordinates":[-121.9508,37.3767]},{"Plant":"Fox Energy Center","State":"WI","Gas":564.7,"coordinates":[-88.2089,44.3204]},{"Plant":"Malburg","State":"CA","Gas":143,"coordinates":[-118.2219,33.9986]},{"Plant":"Magnolia Power Project","State":"CA","Gas":301,"coordinates":[-118.3153,34.1786]},{"Plant":"Walnut Energy Center","State":"CA","Gas":269,"coordinates":[-120.8956,37.4878]},{"Plant":"Currant Creek","State":"UT","Gas":524,"coordinates":[-111.8935,39.8214]},{"Plant":"Mankato Energy Center","State":"MN","Gas":300,"coordinates":[-94.003,44.1988]},{"Plant":"Riverside Energy Resource Center","State":"CA","Gas":196,"coordinates":[-117.4528,33.9636]},{"Plant":"McIntosh Combined Cycle Facility","State":"GA","Gas":1256.8,"coordinates":[-81.1817,32.3478]},{"Plant":"South Harper","State":"MO","Gas":303.3,"coordinates":[-94.4824,38.6803]},{"Plant":"Freeport Energy Center","State":"TX","Gas":219.4,"coordinates":[-95.3954,28.9888]},{"Plant":"Faribault Energy Park","State":"MN","Gas":261,"coordinates":[-93.2906,44.3356]},{"Plant":"Sheboygan Falls","State":"WI","Gas":297.9,"coordinates":[-87.8781,43.7518]},{"Plant":"Nebo Power Station","State":"UT","Gas":130,"coordinates":[-111.7294,40.0614]},{"Plant":"500MW CC","State":"NY","Gas":454.1,"coordinates":[-73.9069,40.7889]},{"Plant":"Port Westward","State":"OR","Gas":392.2,"coordinates":[-123.172,46.1789]},{"Plant":"EG178 Facility","State":"TX","Gas":108,"coordinates":[-100.9547,32.7471]},{"Plant":"Caithness Long Island Energy Center","State":"NY","Gas":307,"coordinates":[-72.9403,40.8142]},{"Plant":"Lake Side Power Plant","State":"UT","Gas":547,"coordinates":[-111.7542,40.3317]},{"Plant":"Groton Generating Station","State":"SD","Gas":158.9,"coordinates":[-98.0987,45.3735]},{"Plant":"Kings River","State":"CA","Gas":109,"coordinates":[-119.7404,36.6697]},{"Plant":"Cannon Falls Energy Center","State":"MN","Gas":398,"coordinates":[-92.9155,44.5367]},{"Plant":"Anson County Generation Facility","State":"NC","Gas":339,"coordinates":[-79.9217,34.9687]},{"Plant":"Empire Generating Co  LLC","State":"NY","Gas":580,"coordinates":[-73.75,42.6252]},{"Plant":"Hamlet Generating Facility","State":"NC","Gas":339,"coordinates":[-79.7361,34.8423]},{"Plant":"Roseville Energy Park","State":"CA","Gas":151,"coordinates":[-121.3811,38.7928]},{"Plant":"Mustang Station Unit 4","State":"TX","Gas":435,"coordinates":[-102.7436,32.9746]},{"Plant":"Harry D Mattison Gas Plant","State":"AR","Gas":294,"coordinates":[-94.2841,36.1855]},{"Plant":"Quail Run Energy Center","State":"TX","Gas":482,"coordinates":[-102.315,31.8414]},{"Plant":"Colorado Bend Energy Center","State":"TX","Gas":510,"coordinates":[-96.0683,29.2878]},{"Plant":"Stanton Energy Center","State":"FL","Gas":295,"coordinates":[-81.1678,28.4822]},{"Plant":"Treasure Coast Energy Center","State":"FL","Gas":318,"coordinates":[-80.3775,27.3839]},{"Plant":"West County Energy Center","State":"FL","Gas":3669,"coordinates":[-80.3747,26.6986]},{"Plant":"Spindle Hill Energy Center","State":"CO","Gas":270,"coordinates":[-104.8878,40.0922]},{"Plant":"Hobbs Generating Station","State":"NM","Gas":530.4,"coordinates":[-103.3094,32.7283]},{"Plant":"Russell City Energy Center","State":"CA","Gas":615,"coordinates":[-122.1338,37.6347]},{"Plant":"Gateway Generating Station","State":"CA","Gas":563.4,"coordinates":[-121.7587,38.0175]},{"Plant":"Western 102 Power Plant","State":"NV","Gas":110.6,"coordinates":[-119.5108,39.5603]},{"Plant":"Emporia Energy Center","State":"KS","Gas":646,"coordinates":[-96.0652,38.4459]},{"Plant":"Jonesboro City Water & Light Plant","State":"AR","Gas":177,"coordinates":[-90.7254,35.8486]},{"Plant":"Plains End II LLC","State":"CO","Gas":116.2,"coordinates":[-105.2256,39.8586]},{"Plant":"Colusa Generating Station","State":"CA","Gas":640,"coordinates":[-122.27,39.3661]},{"Plant":"PPS Power Plant No 1","State":"KY","Gas":110,"coordinates":[-88.6159,37.0339]},{"Plant":"J Lamar Stall Unit","State":"LA","Gas":507,"coordinates":[-93.7601,32.5195]},{"Plant":"San Jacinto County Peaking Facility","State":"TX","Gas":146,"coordinates":[-95.0118,30.4193]},{"Plant":"Hardin County Peaking Facility","State":"TX","Gas":146,"coordinates":[-94.2526,30.3038]},{"Plant":"Deer Creek Station","State":"SD","Gas":290,"coordinates":[-96.5267,44.2908]},{"Plant":"Midway Peaking LLC","State":"CA","Gas":103,"coordinates":[-120.5797,36.6541]},{"Plant":"Winchester Power Park","State":"TX","Gas":179.2,"coordinates":[-96.9875,30.0381]},{"Plant":"CFB Power Plant","State":"TX","Gas":286.2,"coordinates":[-96.5397,28.6503]},{"Plant":"Kleen Energy Systems Project","State":"CT","Gas":622,"coordinates":[-72.5969,41.5532]},{"Plant":"Greenland Energy Center","State":"FL","Gas":296,"coordinates":[-81.5184,30.1591]},{"Plant":"Panoche Energy Center","State":"CA","Gas":388,"coordinates":[-120.5833,36.6514]},{"Plant":"Cedar Bayou 4","State":"TX","Gas":502,"coordinates":[-94.9231,29.7516]},{"Plant":"Bear Garden","State":"VA","Gas":589,"coordinates":[-78.2853,37.6956]},{"Plant":"Dave Gates Generating Station","State":"MT","Gas":132.3,"coordinates":[-112.8766,46.1047]},{"Plant":"Coolidge Generation Station","State":"AZ","Gas":520.8,"coordinates":[-111.5033,32.9174]},{"Plant":"Bayonne Energy Center","State":"NJ","Gas":479.9,"coordinates":[-74.0915,40.6528]},{"Plant":"Pueblo Airport Generating Station","State":"CO","Gas":380,"coordinates":[-104.5264,38.3208]},{"Plant":"Canyon Power Plant","State":"CA","Gas":194.8,"coordinates":[-117.8617,33.8581]},{"Plant":"Langley Gulch Power Plant","State":"ID","Gas":298.7,"coordinates":[-116.8197,43.9044]},{"Plant":"Cleveland Cnty Generating Facility","State":"NC","Gas":720,"coordinates":[-81.4166,35.1705]},{"Plant":"Southcentral Power Plant","State":"AK","Gas":169.7,"coordinates":[-149.9053,61.1674]},{"Plant":"Marsh Landing Generating Station","State":"CA","Gas":764.3,"coordinates":[-121.765,38.0169]},{"Plant":"CPV Sentinel Energy Project","State":"CA","Gas":800,"coordinates":[-116.5714,33.9342]},{"Plant":"Mariposa Energy Project","State":"CA","Gas":199.6,"coordinates":[-121.6019,37.7892]},{"Plant":"Walnut Creek Energy Park","State":"CA","Gas":485,"coordinates":[-117.9449,34.0087]},{"Plant":"Astoria Energy II","State":"NY","Gas":540,"coordinates":[-73.8966,40.7813]},{"Plant":"Antelope Station","State":"TX","Gas":160.2,"coordinates":[-101.8433,33.865]},{"Plant":"El Segundo Energy Center LLC","State":"CA","Gas":510,"coordinates":[-118.425,33.9106]},{"Plant":"Lodi Energy Center","State":"CA","Gas":162,"coordinates":[-121.3875,38.0881]},{"Plant":"Lee Combined Cycle Plant","State":"NC","Gas":916,"coordinates":[-78.0894,35.3736]},{"Plant":"Mesquite Generating Station Block 1","State":"AZ","Gas":535.8,"coordinates":[-112.8642,33.345]},{"Plant":"L V Sutton Combined Cycle","State":"NC","Gas":622,"coordinates":[-77.9853,34.2831]},{"Plant":"Edge Moor","State":"DE","Gas":710,"coordinates":[-75.5038,39.7389]},{"Plant":"PB1 - Gila River","State":"AZ","Gas":1030,"coordinates":[-112.6944,32.975]},{"Plant":"McKee Run","State":"DE","Gas":136,"coordinates":[-75.5466,39.1762]},{"Plant":"Belle River","State":"MI","Gas":222,"coordinates":[-82.495,42.7756]},{"Plant":"Greenwood","State":"MI","Gas":997,"coordinates":[-82.6964,43.1056]},{"Plant":"Manatee","State":"FL","Gas":1111,"coordinates":[-82.3456,27.6058]},{"Plant":"Martin","State":"FL","Gas":2043,"coordinates":[-80.5628,27.0536]},{"Plant":"DeBary","State":"FL","Gas":247,"coordinates":[-81.3323,28.9039]},{"Plant":"Electrifarm","State":"IA","Gas":195.1,"coordinates":[-92.4205,42.4407]},{"Plant":"Fredonia","State":"WA","Gas":280,"coordinates":[-122.4358,48.4558]},{"Plant":"Trimble County","State":"KY","Gas":942,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Gas":972,"coordinates":[-88.5553,30.5322]},{"Plant":"Greenwood","State":"MO","Gas":246.8,"coordinates":[-94.2982,38.8615]},{"Plant":"R M Schahfer","State":"IN","Gas":155,"coordinates":[-87.0261,41.2164]},{"Plant":"Cape Canaveral","State":"FL","Gas":1210,"coordinates":[-80.7644,28.4698]},{"Plant":"Fort St Vrain","State":"CO","Gas":969,"coordinates":[-104.8742,40.2461]},{"Plant":"Fort Myers","State":"FL","Gas":1747,"coordinates":[-81.7831,26.6967]},{"Plant":"Whitehorn","State":"WA","Gas":134,"coordinates":[-122.6861,48.8288]},{"Plant":"McIntosh","State":"GA","Gas":657.6,"coordinates":[-81.1683,32.3563]},{"Plant":"Lauderdale","State":"FL","Gas":1724,"coordinates":[-80.1984,26.0686]},{"Plant":"A B Brown","State":"IN","Gas":160,"coordinates":[-87.715,37.9053]},{"Plant":"Port Everglades","State":"FL","Gas":420,"coordinates":[-80.1253,26.0856]},{"Plant":"Brame Energy Center","State":"LA","Gas":422,"coordinates":[-92.7167,31.395]},{"Plant":"John Twitty Energy Center","State":"MO","Gas":104,"coordinates":[-93.388,37.1517]},{"Plant":"Sanford","State":"FL","Gas":1912,"coordinates":[-81.3256,28.8419]},{"Plant":"Turkey Point","State":"FL","Gas":1148,"coordinates":[-80.3308,25.4356]},{"Plant":"Empire Energy Center","State":"MO","Gas":262,"coordinates":[-94.1041,37.1385]},{"Plant":"Dansby","State":"TX","Gas":204.2,"coordinates":[-96.4608,30.7217]},{"Plant":"Putnam","State":"FL","Gas":498,"coordinates":[-81.5851,29.6283]},{"Plant":"Higgins","State":"FL","Gas":105,"coordinates":[-82.6615,28.0033]},{"Plant":"P L Bartow","State":"FL","Gas":1166,"coordinates":[-82.6018,27.8595]},{"Plant":"Rokeby","State":"NE","Gas":255,"coordinates":[-96.7364,40.7316]},{"Plant":"Suwannee River","State":"FL","Gas":104,"coordinates":[-83.1806,30.3764]},{"Plant":"Lansing Smith","State":"FL","Gas":481,"coordinates":[-85.7003,30.2686]},{"Plant":"D G Hunter","State":"LA","Gas":130,"coordinates":[-92.4613,31.3207]},{"Plant":"George M Sullivan Generation Plant 2","State":"AK","Gas":248.1,"coordinates":[-149.7167,61.2297]},{"Plant":"Deerhaven Generating Station","State":"FL","Gas":185,"coordinates":[-82.3878,29.7592]},{"Plant":"John R Kelly","State":"FL","Gas":112,"coordinates":[-82.3208,29.6461]},{"Plant":"J D Kennedy","State":"FL","Gas":317.2,"coordinates":[-81.626,30.3648]},{"Plant":"Northside Generating Station","State":"FL","Gas":524,"coordinates":[-81.5525,30.4172]},{"Plant":"C D McIntosh Jr","State":"FL","Gas":545,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Gas":388,"coordinates":[-105.0212,40.8609]},{"Plant":"Indian River Plant","State":"FL","Gas":290,"coordinates":[-80.7801,28.4932]},{"Plant":"Arvah B Hopkins","State":"FL","Gas":364,"coordinates":[-84.4,30.4522]},{"Plant":"S O Purdom","State":"FL","Gas":242,"coordinates":[-84.2007,30.1623]},{"Plant":"Vero Beach Municipal Power Plant","State":"FL","Gas":150,"coordinates":[-80.3776,27.6334]},{"Plant":"Gravel Neck","State":"VA","Gas":340,"coordinates":[-76.6911,37.1575]},{"Plant":"McIntosh","State":"AL","Gas":688,"coordinates":[-88.0299,31.2546]},{"Plant":"Harry Allen","State":"NV","Gas":654,"coordinates":[-114.9024,36.4306]},{"Plant":"Jack McDonough","State":"GA","Gas":2578,"coordinates":[-84.4758,33.8239]},{"Plant":"Pleasant Hill","State":"IA","Gas":160,"coordinates":[-93.5242,41.5572]},{"Plant":"Hay Road","State":"DE","Gas":1136,"coordinates":[-75.5072,39.7436]},{"Plant":"Woodsdale","State":"OH","Gas":462,"coordinates":[-84.4611,39.4492]},{"Plant":"Concord","State":"WI","Gas":352,"coordinates":[-88.69,43.1669]},{"Plant":"South Fond Du Lac","State":"WI","Gas":307.4,"coordinates":[-88.4967,43.7353]},{"Plant":"Darbytown","State":"VA","Gas":336,"coordinates":[-77.3685,37.4982]},{"Plant":"Angus Anson","State":"SD","Gas":327,"coordinates":[-96.6356,43.6035]},{"Plant":"Cane Island","State":"FL","Gas":411,"coordinates":[-81.533,28.2764]},{"Plant":"Polk","State":"FL","Gas":604,"coordinates":[-81.9897,27.7286]},{"Plant":"Woodland","State":"CA","Gas":182.2,"coordinates":[-121.0204,37.6526]},{"Plant":"491 E 48th Street","State":"MI","Gas":136,"coordinates":[-86.0853,42.7553]},{"Plant":"Paris","State":"WI","Gas":352,"coordinates":[-88.0131,42.6658]},{"Plant":"Lincoln Combustion","State":"NC","Gas":1267.2,"coordinates":[-81.0347,35.4317]},{"Plant":"State Line Combined Cycle","State":"MO","Gas":589,"coordinates":[-94.614,37.0659]},{"Plant":"Hines Energy Complex","State":"FL","Gas":1912,"coordinates":[-81.87,27.7882]},{"Plant":"Redding Power","State":"CA","Gas":171,"coordinates":[-122.4233,40.5073]},{"Plant":"Richard M Flynn","State":"NY","Gas":136.2,"coordinates":[-73.064,40.8158]},{"Plant":"Almond Power Plant","State":"CA","Gas":199.5,"coordinates":[-120.985,37.5744]},{"Plant":"San Jacinto Steam Electric Station","State":"TX","Gas":162,"coordinates":[-95.0406,29.6948]},{"Plant":"Kraft","State":"GA","Gas":132,"coordinates":[-81.1458,32.1486]},{"Plant":"Anderson","State":"IN","Gas":140,"coordinates":[-85.7389,40.0529]},{"Plant":"Robins","State":"GA","Gas":160,"coordinates":[-83.5822,32.5792]},{"Plant":"Coyote Springs","State":"OR","Gas":235,"coordinates":[-119.6739,45.848]},{"Plant":"Midulla Generating Station","State":"FL","Gas":751,"coordinates":[-81.9625,27.6417]},{"Plant":"Interstate","State":"IL","Gas":112,"coordinates":[-89.5891,39.8233]},{"Plant":"Rathdrum","State":"ID","Gas":132,"coordinates":[-116.8673,47.8043]},{"Plant":"Arthur Von Rosenberg","State":"TX","Gas":530,"coordinates":[-98.384,29.257]},{"Plant":"Carson Ice-Gen Project","State":"CA","Gas":109,"coordinates":[-121.4624,38.4457]},{"Plant":"Wayne County","State":"NC","Gas":863,"coordinates":[-78.0981,35.3758]},{"Plant":"Ponca City","State":"OK","Gas":106.8,"coordinates":[-97.0858,36.7198]},{"Plant":"SCA Cogen 2","State":"CA","Gas":176.6,"coordinates":[-121.4001,38.5309]},{"Plant":"SPA Cogen 3","State":"CA","Gas":164,"coordinates":[-121.4735,38.511]},{"Plant":"St Francis Energy Facility","State":"MO","Gas":464,"coordinates":[-90.1779,36.5852]},{"Plant":"River Road Gen Plant","State":"WA","Gas":220,"coordinates":[-122.7256,45.6497]},{"Plant":"Tiger Bay","State":"FL","Gas":205,"coordinates":[-81.8494,27.7464]},{"Plant":"Dahlberg","State":"GA","Gas":747.3,"coordinates":[-83.3977,34.0423]},{"Plant":"H Allen Franklin Combined Cycle","State":"AL","Gas":1815,"coordinates":[-85.0975,32.6078]},{"Plant":"Theodore Cogen Facility","State":"AL","Gas":224.7,"coordinates":[-88.1285,30.5254]},{"Plant":"Nodaway","State":"MO","Gas":186,"coordinates":[-94.7913,40.2877]},{"Plant":"Chouteau","State":"OK","Gas":799,"coordinates":[-95.2771,36.2221]},{"Plant":"Georgetown","State":"IN","Gas":276,"coordinates":[-86.2441,39.9026]},{"Plant":"Tilton","State":"IL","Gas":176,"coordinates":[-87.6538,40.1061]},{"Plant":"Henry County","State":"IN","Gas":129,"coordinates":[-85.5039,39.9528]},{"Plant":"MPC Generating","State":"GA","Gas":302.5,"coordinates":[-83.6953,33.8119]},{"Plant":"Sherwood H Smith Jr Energy Complex","State":"NC","Gas":1872,"coordinates":[-79.7406,34.8392]},{"Plant":"Sewell Creek Energy","State":"GA","Gas":431.3,"coordinates":[-85.2769,33.9486]},{"Plant":"Alsey","State":"IL","Gas":121,"coordinates":[-90.436,39.5698]},{"Plant":"Fulton","State":"AR","Gas":153,"coordinates":[-93.7924,33.6094]},{"Plant":"Rowan","State":"NC","Gas":924.6,"coordinates":[-80.6019,35.7314]},{"Plant":"Smarr Energy Center","State":"GA","Gas":187.4,"coordinates":[-83.8464,32.9842]},{"Plant":"John S Rainey","State":"SC","Gas":977,"coordinates":[-82.776,34.3477]},{"Plant":"Essential Power Rock Springs LLC","State":"MD","Gas":653.5,"coordinates":[-76.1598,39.719]},{"Plant":"Marsh Run Generating","State":"VA","Gas":480.1,"coordinates":[-77.7681,38.5283]},{"Plant":"Louisa Generating","State":"VA","Gas":465.5,"coordinates":[-78.2139,38.1181]},{"Plant":"Remington","State":"VA","Gas":608,"coordinates":[-77.7714,38.5442]},{"Plant":"Ladysmith","State":"VA","Gas":783,"coordinates":[-77.5133,38.0722]},{"Plant":"Pleasant Valley","State":"MN","Gas":423.8,"coordinates":[-92.6829,43.7994]},{"Plant":"Lagoon Creek","State":"TN","Gas":1407,"coordinates":[-89.3964,35.6578]},{"Plant":"Brandy Branch","State":"FL","Gas":660.8,"coordinates":[-81.9472,30.3206]},{"Plant":"Holden","State":"MO","Gas":210,"coordinates":[-93.9983,38.7538]},{"Plant":"MEPI GT Facility","State":"IL","Gas":239,"coordinates":[-88.8661,37.2175]},{"Plant":"Encogen","State":"WA","Gas":159.4,"coordinates":[-122.486,48.746]},{"Plant":"Robert P Mone Plant","State":"OH","Gas":435,"coordinates":[-84.7392,40.9297]},{"Plant":"H L Culbreath Bayside Power Station","State":"FL","Gas":1854,"coordinates":[-82.4231,27.9072]},{"Plant":"Terry Bundy Generating Station","State":"NE","Gas":169.6,"coordinates":[-96.6131,40.9097]},{"Plant":"E B Harris Electric Generating Plant","State":"AL","Gas":1268.7,"coordinates":[-86.5744,32.3814]},{"Plant":"Sand Hill","State":"TX","Gas":595.8,"coordinates":[-97.6129,30.2098]},{"Plant":"Talbot County Energy","State":"GA","Gas":574.7,"coordinates":[-84.6917,32.5892]},{"Plant":"Chattahoochee Energy Facility","State":"GA","Gas":449.9,"coordinates":[-85.0386,33.4072]},{"Plant":"Lakefield Junction","State":"MN","Gas":522.9,"coordinates":[-94.8415,43.7984]},{"Plant":"West Gardner","State":"KS","Gas":311.1,"coordinates":[-94.9861,38.7875]},{"Plant":"Coyote Springs II","State":"OR","Gas":242.7,"coordinates":[-119.674,45.848]},{"Plant":"Wansley Unit 9","State":"GA","Gas":496,"coordinates":[-85.0403,33.4083]},{"Plant":"Lawrence County Station","State":"IN","Gas":251.5,"coordinates":[-86.4511,38.8003]},{"Plant":"Evander Andrews Power Complex","State":"ID","Gas":247,"coordinates":[-115.7343,43.1792]},{"Plant":"Kemper County","State":"MS","Gas":293.2,"coordinates":[-88.606,32.7976]},{"Plant":"Peno Creek","State":"MO","Gas":192,"coordinates":[-91.2295,39.3531]},{"Plant":"Sumpter","State":"MI","Gas":308.4,"coordinates":[-83.5318,42.167]},{"Plant":"Pyramid","State":"NM","Gas":158,"coordinates":[-108.5494,32.2363]},{"Plant":"Mill Creek","State":"SC","Gas":595.2,"coordinates":[-81.4306,35.1597]},{"Plant":"Greater Des Moines","State":"IA","Gas":492.6,"coordinates":[-93.5283,41.5563]},{"Plant":"Silver Creek","State":"MS","Gas":225,"coordinates":[-89.9468,31.6004]},{"Plant":"Sylvarena","State":"MS","Gas":129,"coordinates":[-89.4127,31.9821]},{"Plant":"West Campus Cogeneration Facility","State":"WI","Gas":125.2,"coordinates":[-89.4251,43.0751]},{"Plant":"Grays Harbor Energy Facility","State":"WA","Gas":637,"coordinates":[-123.48,46.9692]},{"Plant":"Beatrice","State":"NE","Gas":217,"coordinates":[-96.8082,40.3302]},{"Plant":"Roseton Generating Facility","State":"NY","Gas":1246.5,"coordinates":[-73.9663,41.5738]},{"Plant":"Blue Lake","State":"MN","Gas":300,"coordinates":[-93.4315,44.7855]},{"Plant":"Sycamore","State":"IA","Gas":148.5,"coordinates":[-93.6769,41.6722]},{"Plant":"Emery Station","State":"IA","Gas":496.8,"coordinates":[-93.2922,43.094]},{"Plant":"Anclote","State":"FL","Gas":991,"coordinates":[-82.7886,28.1844]},{"Plant":"Intercession City","State":"FL","Gas":557,"coordinates":[-81.5486,28.2628]},{"Plant":"Gerald Andrus","State":"MS","Gas":672.6,"coordinates":[-91.1167,33.35]},{"Plant":"Waterford 1 & 2","State":"LA","Gas":821.7,"coordinates":[-90.4768,29.9989]},{"Plant":"Comanche","State":"OK","Gas":260,"coordinates":[-98.3244,34.5431]},{"Plant":"DeCordova Steam Electric Station","State":"TX","Gas":320,"coordinates":[-97.7006,32.4031]},{"Plant":"Santan","State":"AZ","Gas":1227,"coordinates":[-111.7503,33.3325]},{"Plant":"Beaver","State":"OR","Gas":487,"coordinates":[-123.1739,46.1724]},{"Plant":"Glen Gardner","State":"NJ","Gas":144,"coordinates":[-74.9207,40.6815]},{"Plant":"Grand Tower","State":"IL","Gas":511,"coordinates":[-89.5112,37.6577]},{"Plant":"Astoria Generating Station","State":"NY","Gas":199.7,"coordinates":[-73.9126,40.7877]},{"Plant":"Venice","State":"IL","Gas":491,"coordinates":[-90.1764,38.6642]},{"Plant":"Beluga","State":"AK","Gas":344.4,"coordinates":[-151.0356,61.1861]},{"Plant":"Marion","State":"IL","Gas":140,"coordinates":[-88.9531,37.6197]},{"Plant":"Frederickson","State":"WA","Gas":134,"coordinates":[-122.365,47.0797]},{"Plant":"Harding Street","State":"IN","Gas":288,"coordinates":[-86.1969,39.7113]}]

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Gas":740,"coordinates":[-87.7811,32.6017]},{"Plant":"NRG Energy Center Dover","State":"DE","Gas":104,"coordinates":[-75.5473,39.1495]},{"Plant":"Gilroy Power Plant","State":"CA","Gas":115,"coordinates":[-121.5367,37.0001]},{"Plant":"Noblesville","State":"IN","Gas":285.2,"coordinates":[-85.9714,40.0969]},{"Plant":"Pedricktown Cogeneration Company LP","State":"NJ","Gas":117.9,"coordinates":[-75.4238,39.7668]},{"Plant":"Broadway","State":"IN","Gas":115,"coordinates":[-87.6049,37.9691]},{"Plant":"Butler-Warner Generation Plant","State":"NC","Gas":225,"coordinates":[-78.8294,35.0986]},{"Plant":"El Segundo Cogen","State":"CA","Gas":171.6,"coordinates":[-118.4031,33.9058]},{"Plant":"ArcelorMittal Burns Harbor","State":"IN","Gas":174.7,"coordinates":[-87.1387,41.635]},{"Plant":"King City Power Plant","State":"CA","Gas":111,"coordinates":[-121.1278,36.225]},{"Plant":"Bayou Cogen Plant","State":"TX","Gas":270,"coordinates":[-95.0458,29.6225]},{"Plant":"Bellingham Cogeneration Facility","State":"MA","Gas":264,"coordinates":[-71.4833,42.0925]},{"Plant":"Sayreville Cogeneration Facility","State":"NJ","Gas":294.4,"coordinates":[-74.3444,40.439]},{"Plant":"Foster Wheeler Martinez","State":"CA","Gas":103.5,"coordinates":[-122.0589,38.0244]},{"Plant":"ExxonMobil Baytown Refinery","State":"TX","Gas":134,"coordinates":[-94.9973,29.7535]},{"Plant":"Kern River Cogeneration","State":"CA","Gas":288,"coordinates":[-118.9849,35.4515]},{"Plant":"Formosa Utility Venture Ltd","State":"TX","Gas":597.3,"coordinates":[-96.5417,28.6917]},{"Plant":"Hopewell Cogeneration","State":"VA","Gas":252.3,"coordinates":[-77.2811,37.2917]},{"Plant":"Brush Generation Facility","State":"CO","Gas":292,"coordinates":[-103.631,40.2415]},{"Plant":"ExxonMobil Baytown Turbine","State":"TX","Gas":297,"coordinates":[-95.0096,29.7591]},{"Plant":"Selkirk Cogen","State":"NY","Gas":346.6,"coordinates":[-73.8592,42.5744]},{"Plant":"Masspower","State":"MA","Gas":245,"coordinates":[-72.5225,42.1575]},{"Plant":"Clear Lake Cogeneration Ltd","State":"TX","Gas":362.4,"coordinates":[-95.067,29.6255]},{"Plant":"Midland Cogeneration Venture","State":"MI","Gas":1859.4,"coordinates":[-84.2242,43.5861]},{"Plant":"Camden Plant Holding LLC","State":"NJ","Gas":145,"coordinates":[-75.1192,39.9175]},{"Plant":"Las Vegas Cogeneration LP","State":"NV","Gas":282,"coordinates":[-115.1222,36.2319]},{"Plant":"Sutherland","State":"IA","Gas":110.7,"coordinates":[-92.8594,42.0473]},{"Plant":"River Hills","State":"IA","Gas":116.9,"coordinates":[-93.6195,41.5902]},{"Plant":"Hazelton","State":"PA","Gas":147.2,"coordinates":[-76.0409,40.9282]},{"Plant":"Ocotillo","State":"AZ","Gas":320,"coordinates":[-111.9122,33.4225]},{"Plant":"West Phoenix","State":"AZ","Gas":952,"coordinates":[-112.1583,33.4417]},{"Plant":"Saguaro","State":"AZ","Gas":176,"coordinates":[-111.3,32.5517]},{"Plant":"Yucca","State":"AZ","Gas":257,"coordinates":[-114.7106,32.7214]},{"Plant":"Earl F Wisdom","State":"IA","Gas":113.5,"coordinates":[-95.2569,43.1606]},{"Plant":"Fort Dodge","State":"KS","Gas":147.8,"coordinates":[-99.9497,37.7328]},{"Plant":"Riverton","State":"KS","Gas":246,"coordinates":[-94.6987,37.0726]},{"Plant":"Gordon Evans Energy Center","State":"KS","Gas":806,"coordinates":[-97.5217,37.7903]},{"Plant":"Murray Gill","State":"KS","Gas":183,"coordinates":[-97.4136,37.5967]},{"Plant":"Hutchinson Energy Center","State":"KS","Gas":336,"coordinates":[-97.8747,38.0906]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Gas":314,"coordinates":[-110.9047,32.16]},{"Plant":"Kaw","State":"KS","Gas":140.3,"coordinates":[-94.6514,39.0867]},{"Plant":"McPherson 2","State":"KS","Gas":104,"coordinates":[-97.6834,38.3634]},{"Plant":"Garden City","State":"KS","Gas":207.3,"coordinates":[-100.8956,37.9703]},{"Plant":"E W Brown","State":"KY","Gas":812,"coordinates":[-84.7126,37.7883]},{"Plant":"Paddys Run","State":"KY","Gas":182,"coordinates":[-85.8417,38.2236]},{"Plant":"Louisiana 1","State":"LA","Gas":382.4,"coordinates":[-91.1864,30.4922]},{"Plant":"Louisiana 2","State":"LA","Gas":138,"coordinates":[-91.1864,30.4922]},{"Plant":"R S Nelson","State":"LA","Gas":569.7,"coordinates":[-93.2911,30.2844]},{"Plant":"Willow Glen","State":"LA","Gas":1748.9,"coordinates":[-91.1164,30.2743]},{"Plant":"Coughlin Power Station","State":"LA","Gas":739,"coordinates":[-92.2611,30.8439]},{"Plant":"Teche","State":"LA","Gas":387,"coordinates":[-91.5425,29.8222]},{"Plant":"Little Gypsy","State":"LA","Gas":1159.1,"coordinates":[-90.4617,30.0051]},{"Plant":"Nine Mile Point","State":"LA","Gas":2083.3,"coordinates":[-90.1458,29.9472]},{"Plant":"Sterlington","State":"LA","Gas":107.5,"coordinates":[-92.0792,32.7047]},{"Plant":"Michoud","State":"LA","Gas":781.8,"coordinates":[-89.9372,30.0081]},{"Plant":"Agua Fria","State":"AZ","Gas":626,"coordinates":[-112.2153,33.5561]},{"Plant":"Arsenal Hill","State":"LA","Gas":116,"coordinates":[-93.7611,32.5181]},{"Plant":"Lieberman","State":"LA","Gas":243,"coordinates":[-93.9597,32.7047]},{"Plant":"Louis Doc Bonin","State":"LA","Gas":256,"coordinates":[-92.0463,30.238]},{"Plant":"Big Cajun 1","State":"LA","Gas":430,"coordinates":[-91.3556,30.6739]},{"Plant":"Kyrene","State":"AZ","Gas":525,"coordinates":[-111.9353,33.3556]},{"Plant":"Herbert A Wagner","State":"MD","Gas":126,"coordinates":[-76.5268,39.1781]},{"Plant":"Notch Cliff","State":"MD","Gas":116.7,"coordinates":[-76.5087,39.4217]},{"Plant":"Perryman","State":"MD","Gas":147.6,"coordinates":[-76.2218,39.4428]},{"Plant":"Westport","State":"MD","Gas":115.8,"coordinates":[-76.6295,39.266]},{"Plant":"Dickerson","State":"MD","Gas":294,"coordinates":[-77.4644,39.2097]},{"Plant":"Mystic Generating Station","State":"MA","Gas":1988.1,"coordinates":[-71.0675,42.3908]},{"Plant":"Kendall Square Station","State":"MA","Gas":214.1,"coordinates":[-71.0792,42.3633]},{"Plant":"Apache Station","State":"AZ","Gas":198.5,"coordinates":[-109.8931,32.0603]},{"Plant":"Essential Power Massachusetts LLC","State":"MA","Gas":168.6,"coordinates":[-72.595,42.095]},{"Plant":"Potter Station 2","State":"MA","Gas":183.3,"coordinates":[-70.9672,42.235]},{"Plant":"B C Cobb","State":"MI","Gas":187,"coordinates":[-86.2423,43.2588]},{"Plant":"Lake Catherine","State":"AR","Gas":516.7,"coordinates":[-92.9049,34.4341]},{"Plant":"Dan E Karn","State":"MI","Gas":1204,"coordinates":[-83.8401,43.645]},{"Plant":"Thetford","State":"MI","Gas":114,"coordinates":[-83.6286,43.1567]},{"Plant":"Delray","State":"MI","Gas":124,"coordinates":[-83.1019,42.2947]},{"Plant":"Hancock","State":"MI","Gas":139,"coordinates":[-83.4425,42.5497]},{"Plant":"River Rouge","State":"MI","Gas":206,"coordinates":[-83.1119,42.2739]},{"Plant":"Black Dog","State":"MN","Gas":271,"coordinates":[-93.2501,44.8108]},{"Plant":"High Bridge","State":"MN","Gas":534,"coordinates":[-93.1117,44.9314]},{"Plant":"Inver Hills","State":"MN","Gas":282,"coordinates":[-93.042,44.781]},{"Plant":"Riverside","State":"MN","Gas":470,"coordinates":[-93.2753,45.0203]},{"Plant":"Thomas Fitzhugh","State":"AR","Gas":162,"coordinates":[-93.8049,35.4624]},{"Plant":"Carl Bailey","State":"AR","Gas":122,"coordinates":[-91.3634,35.2601]},{"Plant":"McClellan","State":"AR","Gas":134,"coordinates":[-92.7917,33.5648]},{"Plant":"Cambridge CT","State":"MN","Gas":167.6,"coordinates":[-93.2081,45.601]},{"Plant":"Elk River","State":"MN","Gas":191.6,"coordinates":[-93.5584,45.2968]},{"Plant":"Chevron Oil","State":"MS","Gas":130,"coordinates":[-88.4919,30.34]},{"Plant":"Sweatt","State":"MS","Gas":124,"coordinates":[-88.7461,32.2925]},{"Plant":"Jack Watson","State":"MS","Gas":292,"coordinates":[-89.0286,30.4392]},{"Plant":"Baxter Wilson","State":"MS","Gas":1143.2,"coordinates":[-90.9306,32.2831]},{"Plant":"Rex Brown","State":"MS","Gas":243.5,"coordinates":[-90.213,32.357]},{"Plant":"Moselle","State":"MS","Gas":477,"coordinates":[-89.3004,31.528]},{"Plant":"Hawthorn","State":"MO","Gas":384.4,"coordinates":[-94.4778,39.1306]},{"Plant":"Lake Road","State":"MO","Gas":102,"coordinates":[-94.8773,39.7246]},{"Plant":"James River Power Station","State":"MO","Gas":155,"coordinates":[-93.2619,37.1086]},{"Plant":"Canaday","State":"NE","Gas":115,"coordinates":[-99.7011,40.6942]},{"Plant":"C W Burdick","State":"NE","Gas":174.1,"coordinates":[-98.3269,40.9228]},{"Plant":"Sarpy County","State":"NE","Gas":315,"coordinates":[-95.9706,41.1706]},{"Plant":"Clark","State":"NV","Gas":1141,"coordinates":[-115.0507,36.0875]},{"Plant":"Fort Churchill","State":"NV","Gas":226,"coordinates":[-119.1322,39.1281]},{"Plant":"Tracy","State":"NV","Gas":897.6,"coordinates":[-119.525,39.5625]},{"Plant":"Sayreville","State":"NJ","Gas":150,"coordinates":[-74.3523,40.4765]},{"Plant":"Gilbert","State":"NJ","Gas":530,"coordinates":[-75.1639,40.5658]},{"Plant":"Bergen Generating Station","State":"NJ","Gas":1219,"coordinates":[-74.0244,40.8375]},{"Plant":"PSEG Burlington Generating Station","State":"NJ","Gas":172.5,"coordinates":[-74.8792,40.0766]},{"Plant":"PSEG Edison Generating Station","State":"NJ","Gas":516,"coordinates":[-74.3956,40.4911]},{"Plant":"PSEG Essex Generating Station","State":"NJ","Gas":623,"coordinates":[-74.1206,40.7372]},{"Plant":"PSEG Kearny Generating Station","State":"NJ","Gas":452.2,"coordinates":[-74.0965,40.7373]},{"Plant":"PSEG Linden Generating Station","State":"NJ","Gas":1639.2,"coordinates":[-74.2072,40.6217]},{"Plant":"PSEG Sewaren Generating Station","State":"NJ","Gas":452.6,"coordinates":[-74.2469,40.5558]},{"Plant":"Rio Grande","State":"NM","Gas":324.2,"coordinates":[-106.5472,31.8047]},{"Plant":"Maddox","State":"NM","Gas":183,"coordinates":[-103.3015,32.7142]},{"Plant":"Reeves","State":"NM","Gas":154,"coordinates":[-106.6019,35.171]},{"Plant":"Cunningham","State":"NM","Gas":466,"coordinates":[-103.3533,32.7131]},{"Plant":"Humboldt Bay","State":"CA","Gas":163.4,"coordinates":[-124.2103,40.7415]},{"Plant":"Arthur Kill Generating Station","State":"NY","Gas":858,"coordinates":[-74.2,40.5916]},{"Plant":"East River","State":"NY","Gas":289.4,"coordinates":[-73.9742,40.7281]},{"Plant":"Gowanus Gas Turbines Generating","State":"NY","Gas":282.4,"coordinates":[-74.0051,40.6635]},{"Plant":"Narrows Gas Turbines Generating","State":"NY","Gas":283,"coordinates":[-74.0208,40.6486]},{"Plant":"Ravenswood","State":"NY","Gas":2216.5,"coordinates":[-73.9461,40.7592]},{"Plant":"E F Barrett","State":"NY","Gas":667.9,"coordinates":[-73.6479,40.6167]},{"Plant":"Northport","State":"NY","Gas":1578.6,"coordinates":[-73.3423,40.9236]},{"Plant":"Port Jefferson","State":"NY","Gas":474.9,"coordinates":[-73.0785,40.9497]},{"Plant":"Bethlehem Energy Center","State":"NY","Gas":774.5,"coordinates":[-73.7638,42.5942]},{"Plant":"Dynegy Moss Landing Power Plant","State":"CA","Gas":2529,"coordinates":[-121.7822,36.8048]},{"Plant":"Bowline Point","State":"NY","Gas":1137,"coordinates":[-73.9689,41.2044]},{"Plant":"Asheville","State":"NC","Gas":324,"coordinates":[-82.5417,35.4731]},{"Plant":"Pittsburg Power","State":"CA","Gas":1311,"coordinates":[-121.8945,38.0392]},{"Plant":"Buck","State":"NC","Gas":668.2,"coordinates":[-80.3767,35.7133]},{"Plant":"Dan River","State":"NC","Gas":637.7,"coordinates":[-79.7208,36.4862]},{"Plant":"Dicks Creek","State":"OH","Gas":106.2,"coordinates":[-84.3778,39.465]},{"Plant":"Frank M Tait","State":"OH","Gas":256,"coordinates":[-84.2111,39.7272]},{"Plant":"Yankee Street","State":"OH","Gas":101.3,"coordinates":[-84.2047,39.603]},{"Plant":"FirstEnergy West Lorain","State":"OH","Gas":425,"coordinates":[-82.2644,41.4294]},{"Plant":"Richland","State":"OH","Gas":358,"coordinates":[-84.3346,41.3052]},{"Plant":"Hamilton","State":"OH","Gas":123,"coordinates":[-84.5543,39.4098]},{"Plant":"Horseshoe Lake","State":"OK","Gas":889,"coordinates":[-97.1797,35.5087]},{"Plant":"Mustang","State":"OK","Gas":542.5,"coordinates":[-97.675,35.4699]},{"Plant":"Seminole","State":"OK","Gas":1506.5,"coordinates":[-96.7258,34.9665]},{"Plant":"Northeastern","State":"OK","Gas":906,"coordinates":[-95.7008,36.4317]},{"Plant":"Southwestern","State":"OK","Gas":603,"coordinates":[-98.3524,35.1009]},{"Plant":"Tulsa","State":"OK","Gas":305,"coordinates":[-95.991,36.1165]},{"Plant":"Weleetka","State":"OK","Gas":163,"coordinates":[-96.1352,35.3233]},{"Plant":"Barry","State":"AL","Gas":962,"coordinates":[-88.0103,31.0069]},{"Plant":"Anadarko Plant","State":"OK","Gas":485,"coordinates":[-98.23,35.0847]},{"Plant":"Mooreland","State":"OK","Gas":322,"coordinates":[-99.2254,36.4372]},{"Plant":"Encina","State":"CA","Gas":964,"coordinates":[-117.3364,33.1361]},{"Plant":"Kearny","State":"CA","Gas":120,"coordinates":[-117.1338,32.834]},{"Plant":"Brunot Island","State":"PA","Gas":244,"coordinates":[-80.0438,40.4649]},{"Plant":"PPL Martins Creek","State":"PA","Gas":1772,"coordinates":[-75.1054,40.7978]},{"Plant":"AES Alamitos LLC","State":"CA","Gas":1997,"coordinates":[-118.1009,33.7688]},{"Plant":"Hunlock Power Station","State":"PA","Gas":126.4,"coordinates":[-76.07,41.2006]},{"Plant":"Manchester Street","State":"RI","Gas":447,"coordinates":[-71.4042,41.8167]},{"Plant":"Darlington County","State":"SC","Gas":441,"coordinates":[-80.1657,34.4185]},{"Plant":"W S Lee","State":"SC","Gas":252,"coordinates":[-82.435,34.6022]},{"Plant":"Hagood","State":"SC","Gas":126,"coordinates":[-79.9634,32.8265]},{"Plant":"Urquhart","State":"SC","Gas":640,"coordinates":[-81.9111,33.435]},{"Plant":"El Segundo Power","State":"CA","Gas":335,"coordinates":[-118.4242,33.9098]},{"Plant":"Etiwanda Generating Station","State":"CA","Gas":640,"coordinates":[-117.5266,34.0912]},{"Plant":"AES Huntington Beach LLC","State":"CA","Gas":451.6,"coordinates":[-117.9792,33.6439]},{"Plant":"Allen Steam Plant","State":"TN","Gas":427.2,"coordinates":[-90.1487,35.0741]},{"Plant":"Gallatin","State":"TN","Gas":579.6,"coordinates":[-86.4006,36.3156]},{"Plant":"John Sevier","State":"TN","Gas":878,"coordinates":[-82.9639,36.3767]},{"Plant":"Johnsonville","State":"TN","Gas":1044.8,"coordinates":[-87.9861,36.0278]},{"Plant":"Long Beach Generation LLC","State":"CA","Gas":260,"coordinates":[-118.2248,33.7641]},{"Plant":"Laredo","State":"TX","Gas":188.4,"coordinates":[-99.5089,27.5667]},{"Plant":"Nueces Bay","State":"TX","Gas":633,"coordinates":[-97.4192,27.8194]},{"Plant":"Victoria","State":"TX","Gas":285,"coordinates":[-97.01,28.7883]},{"Plant":"Mandalay","State":"CA","Gas":560,"coordinates":[-119.2511,34.2067]},{"Plant":"Lake Hubbard","State":"TX","Gas":907,"coordinates":[-96.5458,32.8358]},{"Plant":"Mountain Creek","State":"TX","Gas":808,"coordinates":[-96.9358,32.7231]},{"Plant":"Newman","State":"TX","Gas":760.9,"coordinates":[-106.4318,31.9836]},{"Plant":"Lewis Creek","State":"TX","Gas":460.2,"coordinates":[-95.5214,30.4356]},{"Plant":"Sabine","State":"TX","Gas":1824.9,"coordinates":[-93.878,30.0242]},{"Plant":"Cedar Bayou","State":"TX","Gas":1495,"coordinates":[-94.9256,29.75]},{"Plant":"Greens Bayou","State":"TX","Gas":760,"coordinates":[-95.2194,29.8222]},{"Plant":"Sam Bertron","State":"TX","Gas":765,"coordinates":[-95.0598,29.7268]},{"Plant":"T H Wharton","State":"TX","Gas":1025,"coordinates":[-95.5306,29.9417]},{"Plant":"W A Parish","State":"TX","Gas":1176,"coordinates":[-95.6311,29.4828]},{"Plant":"Knox Lee","State":"TX","Gas":471,"coordinates":[-94.6415,32.3766]},{"Plant":"Wilkes","State":"TX","Gas":883,"coordinates":[-94.548,32.8482]},{"Plant":"Jones","State":"TX","Gas":824,"coordinates":[-101.7392,33.5239]},{"Plant":"Nichols","State":"TX","Gas":457,"coordinates":[-101.7464,35.2834]},{"Plant":"Plant X","State":"TX","Gas":411,"coordinates":[-102.4114,34.1661]},{"Plant":"Graham","State":"TX","Gas":615,"coordinates":[-98.6117,33.1344]},{"Plant":"Handley","State":"TX","Gas":1265,"coordinates":[-97.2192,32.7283]},{"Plant":"Morgan Creek","State":"TX","Gas":407,"coordinates":[-100.9156,32.3358]},{"Plant":"Permian Basin","State":"TX","Gas":967,"coordinates":[-102.9633,31.5839]},{"Plant":"Ormond Beach","State":"CA","Gas":1516,"coordinates":[-119.1689,34.1292]},{"Plant":"Stryker Creek","State":"TX","Gas":669,"coordinates":[-94.9898,31.9398]},{"Plant":"Trinidad","State":"TX","Gas":226,"coordinates":[-96.1013,32.1245]},{"Plant":"Valley","State":"TX","Gas":1069,"coordinates":[-96.3676,33.6281]},{"Plant":"Decker Creek","State":"TX","Gas":932,"coordinates":[-97.6128,30.3033]},{"Plant":"Silas Ray","State":"TX","Gas":125,"coordinates":[-97.5214,25.9131]},{"Plant":"AES Redondo Beach LLC","State":"CA","Gas":1310,"coordinates":[-118.395,33.8504]},{"Plant":"Ray Olinger","State":"TX","Gas":395,"coordinates":[-96.4525,33.0681]},{"Plant":"Mountainview Generating Station","State":"CA","Gas":972,"coordinates":[-117.2418,34.0818]},{"Plant":"Sim Gideon","State":"TX","Gas":620,"coordinates":[-97.2708,30.1456]},{"Plant":"Ty Cooke","State":"TX","Gas":120,"coordinates":[-101.7906,33.5211]},{"Plant":"Leon Creek","State":"TX","Gas":184,"coordinates":[-98.5761,29.3525]},{"Plant":"O W Sommers","State":"TX","Gas":830,"coordinates":[-98.3242,29.3081]},{"Plant":"V H Braunig","State":"TX","Gas":1055,"coordinates":[-98.3825,29.2567]},{"Plant":"R W Miller","State":"TX","Gas":574,"coordinates":[-98.3103,32.6581]},{"Plant":"Pearsall","State":"TX","Gas":270.6,"coordinates":[-99.0919,28.9275]},{"Plant":"Sam Rayburn","State":"TX","Gas":205,"coordinates":[-97.135,28.8947]},{"Plant":"Gadsby","State":"UT","Gas":354.5,"coordinates":[-111.9289,40.7686]},{"Plant":"Grayson","State":"CA","Gas":256,"coordinates":[-118.2782,34.1556]},{"Plant":"Bremo Bluff","State":"VA","Gas":227,"coordinates":[-78.2878,37.7089]},{"Plant":"Chesterfield","State":"VA","Gas":397,"coordinates":[-77.3833,37.3822]},{"Plant":"Possum Point","State":"VA","Gas":875,"coordinates":[-77.2806,38.5367]},{"Plant":"El Centro","State":"CA","Gas":325.3,"coordinates":[-115.54,32.8022]},{"Plant":"Harbor","State":"CA","Gas":461,"coordinates":[-118.2656,33.7706]},{"Plant":"Blount Street","State":"WI","Gas":103,"coordinates":[-89.3744,43.0789]},{"Plant":"Haynes","State":"CA","Gas":1571.8,"coordinates":[-118.0991,33.7647]},{"Plant":"Wheaton","State":"WI","Gas":190,"coordinates":[-91.5158,44.8854]},{"Plant":"Scattergood","State":"CA","Gas":796,"coordinates":[-118.4276,33.9182]},{"Plant":"Port Washington Generating Station","State":"WI","Gas":1081.6,"coordinates":[-87.8689,43.3842]},{"Plant":"Rock River","State":"WI","Gas":123.1,"coordinates":[-89.0276,42.582]},{"Plant":"West Marinette","State":"WI","Gas":153.8,"coordinates":[-87.6881,45.0869]},{"Plant":"Valley","State":"CA","Gas":556,"coordinates":[-118.3913,34.245]},{"Plant":"Powerlane Plant","State":"TX","Gas":111,"coordinates":[-96.1264,33.1707]},{"Plant":"Glenarm","State":"CA","Gas":151.6,"coordinates":[-118.1494,34.126]},{"Plant":"Spencer","State":"TX","Gas":122,"coordinates":[-97.1061,33.1975]},{"Plant":"Colbert","State":"AL","Gas":363.2,"coordinates":[-87.8486,34.7439]},{"Plant":"Thomas C Ferguson","State":"TX","Gas":521,"coordinates":[-98.3705,30.558]},{"Plant":"Barney M Davis","State":"TX","Gas":968,"coordinates":[-97.3117,27.6064]},{"Plant":"Riverside","State":"OK","Gas":1067,"coordinates":[-95.9567,35.9978]},{"Plant":"Pittsfield Generating LP","State":"MA","Gas":151.4,"coordinates":[-73.2181,42.4564]},{"Plant":"Linden Cogen Plant","State":"NJ","Gas":912.2,"coordinates":[-74.2156,40.6322]},{"Plant":"Houston Chemical Complex Battleground","State":"TX","Gas":263,"coordinates":[-95.0839,29.7314]},{"Plant":"Paris Energy Center","State":"TX","Gas":236,"coordinates":[-95.5577,33.6968]},{"Plant":"Hal C Weaver Power Plant","State":"TX","Gas":146.8,"coordinates":[-97.7356,30.2867]},{"Plant":"Sycamore Cogeneration","State":"CA","Gas":300,"coordinates":[-118.9853,35.4526]},{"Plant":"Union Carbide Seadrift Cogen","State":"TX","Gas":168,"coordinates":[-96.7706,28.5105]},{"Plant":"Dow St Charles Operations","State":"LA","Gas":270,"coordinates":[-90.4414,29.9861]},{"Plant":"Watson Cogeneration","State":"CA","Gas":398,"coordinates":[-118.2448,33.8166]},{"Plant":"Bucksport Generation LLC","State":"ME","Gas":273.8,"coordinates":[-68.8046,44.5738]},{"Plant":"Bethpage Power Plant","State":"NY","Gas":184,"coordinates":[-73.4994,40.7469]},{"Plant":"Shell Deer Park","State":"TX","Gas":140,"coordinates":[-95.1289,29.7232]},{"Plant":"Newark Bay Cogeneration Partnership LP","State":"NJ","Gas":120.2,"coordinates":[-74.13,40.7197]},{"Plant":"Indeck Corinth Energy Center","State":"NY","Gas":131.8,"coordinates":[-73.8125,43.25]},{"Plant":"Procter & Gamble Mehoopany Mill","State":"PA","Gas":104.9,"coordinates":[-76.0432,41.5743]},{"Plant":"PPG Powerhouse C","State":"LA","Gas":303.2,"coordinates":[-93.2831,30.2242]},{"Plant":"Bayonne Plant Holding LLC","State":"NJ","Gas":170.2,"coordinates":[-74.1124,40.6553]},{"Plant":"Harbor Cogen","State":"CA","Gas":101.7,"coordinates":[-118.2303,33.7771]},{"Plant":"Rosemary Power Station","State":"NC","Gas":165,"coordinates":[-77.6594,36.4517]},{"Plant":"Oklahoma Cogeneration Project","State":"OK","Gas":111.4,"coordinates":[-97.625,35.4397]},{"Plant":"Eagle Point Power Generation","State":"NJ","Gas":195,"coordinates":[-75.1592,39.8746]},{"Plant":"ExxonMobil Beaumont Refinery","State":"TX","Gas":610.6,"coordinates":[-94.0753,30.0636]},{"Plant":"JM Shafer Generating Station","State":"CO","Gas":263,"coordinates":[-104.7736,40.0986]},{"Plant":"Gary Works","State":"IN","Gas":161,"coordinates":[-87.3289,41.6224]},{"Plant":"Parlin Power Plant","State":"NJ","Gas":114.6,"coordinates":[-74.3272,40.4607]},{"Plant":"Optim Energy Altura Cogen LLC","State":"TX","Gas":538,"coordinates":[-95.1077,29.8161]},{"Plant":"Cumberland","State":"NJ","Gas":183.1,"coordinates":[-74.9654,39.3757]},{"Plant":"Gramercy Holdings LLC","State":"LA","Gas":106,"coordinates":[-90.6693,30.054]},{"Plant":"Hardee Power Station","State":"FL","Gas":358,"coordinates":[-81.9636,27.6364]},{"Plant":"Bellmeade Power Station","State":"VA","Gas":267,"coordinates":[-77.4317,37.4964]},{"Plant":"Motiva Enterprises Port Arthur Refinery","State":"TX","Gas":239.4,"coordinates":[-93.9569,29.8822]},{"Plant":"Ocean State Power","State":"RI","Gas":218.6,"coordinates":[-71.6689,42.0097]},{"Plant":"LaO Energy Systems","State":"LA","Gas":509,"coordinates":[-91.2325,30.3186]},{"Plant":"Doswell Energy Center","State":"VA","Gas":813.8,"coordinates":[-77.1448,37.8182]},{"Plant":"Elizabeth River Power Station","State":"VA","Gas":348,"coordinates":[-76.3083,36.775]},{"Plant":"Texas City Power Plant","State":"TX","Gas":451,"coordinates":[-94.9438,29.3787]},{"Plant":"Richmond Cogen","State":"CA","Gas":130.4,"coordinates":[-122.3909,37.9418]},{"Plant":"Dow Chemical Texas Operation","State":"TX","Gas":532.2,"coordinates":[-95.4075,28.9913]},{"Plant":"Power Station 4","State":"TX","Gas":172,"coordinates":[-94.9219,29.3782]},{"Plant":"Midway Sunset Cogen","State":"CA","Gas":219,"coordinates":[-119.6294,35.2269]},{"Plant":"C R Wing Cogen Plant","State":"TX","Gas":212,"coordinates":[-101.4224,32.2732]},{"Plant":"Delaware City Plant","State":"DE","Gas":265,"coordinates":[-75.6343,39.5871]},{"Plant":"McWilliams","State":"AL","Gas":663,"coordinates":[-86.4764,31.4003]},{"Plant":"J K Smith","State":"KY","Gas":784,"coordinates":[-84.1017,37.8833]},{"Plant":"Lockport Energy Associates LP","State":"NY","Gas":203,"coordinates":[-78.745,43.1619]},{"Plant":"International Paper Riverdale Mill","State":"AL","Gas":104.2,"coordinates":[-86.8709,32.426]},{"Plant":"Kennedy International Airport Cogen","State":"NY","Gas":126.2,"coordinates":[-73.7778,40.6417]},{"Plant":"March Point Cogeneration","State":"WA","Gas":146.2,"coordinates":[-122.56,48.4708]},{"Plant":"Saguaro Power","State":"NV","Gas":101,"coordinates":[-115.0117,36.0417]},{"Plant":"Ocean State Power II","State":"RI","Gas":218.6,"coordinates":[-71.6701,42.0099]},{"Plant":"Orange Cogeneration Facility","State":"FL","Gas":110.6,"coordinates":[-81.8251,27.8708]},{"Plant":"Lake Cogen Ltd","State":"FL","Gas":121,"coordinates":[-81.676,28.9158]},{"Plant":"Pasco Cogen Ltd","State":"FL","Gas":121,"coordinates":[-82.1889,28.3746]},{"Plant":"Mulberry Cogeneration Facility","State":"FL","Gas":113,"coordinates":[-81.8775,27.8489]},{"Plant":"Orlando Cogen LP","State":"FL","Gas":120,"coordinates":[-81.4123,28.4426]},{"Plant":"Ferndale Generating Station","State":"WA","Gas":270,"coordinates":[-122.6867,48.8288]},{"Plant":"Hartwell Energy Facility","State":"GA","Gas":293.7,"coordinates":[-82.8199,34.3396]},{"Plant":"Sithe Independence Station","State":"NY","Gas":930.4,"coordinates":[-76.4511,43.495]},{"Plant":"Saranac Facility","State":"NY","Gas":244.9,"coordinates":[-73.4557,44.7132]},{"Plant":"NAEA Lakewood LLC","State":"NJ","Gas":218.1,"coordinates":[-74.1686,40.0613]},{"Plant":"Oyster Creek Unit VIII","State":"TX","Gas":379,"coordinates":[-95.342,28.9802]},{"Plant":"Hermiston Generating Plant","State":"OR","Gas":464,"coordinates":[-119.37,45.8042]},{"Plant":"Grays Ferry Cogeneration","State":"PA","Gas":177,"coordinates":[-75.1881,39.9422]},{"Plant":"Milford Power LP","State":"MA","Gas":148,"coordinates":[-71.5115,42.1294]},{"Plant":"Milagro Cogeneration Plant","State":"NM","Gas":121.6,"coordinates":[-107.9417,36.7367]},{"Plant":"Johnson County","State":"TX","Gas":267,"coordinates":[-97.4078,32.3994]},{"Plant":"Brandywine Power Facility","State":"MD","Gas":230,"coordinates":[-76.8678,38.6681]},{"Plant":"Gordonsville Energy LP","State":"VA","Gas":218,"coordinates":[-78.2138,38.1179]},{"Plant":"Sun Peak Generating Station","State":"NV","Gas":222,"coordinates":[-115.0339,36.1375]},{"Plant":"Brooklyn Navy Yard Cogeneration","State":"NY","Gas":250,"coordinates":[-73.9764,40.6994]},{"Plant":"Michigan Power LP","State":"MI","Gas":128,"coordinates":[-86.425,43.9375]},{"Plant":"LSP-Cottage Grove LP","State":"MN","Gas":251,"coordinates":[-92.9119,44.7956]},{"Plant":"LSP-Whitewater LP","State":"WI","Gas":261,"coordinates":[-88.7299,42.8555]},{"Plant":"Sweeny Cogen Facility","State":"TX","Gas":436,"coordinates":[-95.745,29.0728]},{"Plant":"Dighton Power Plant","State":"MA","Gas":164.2,"coordinates":[-71.1239,41.8312]},{"Plant":"De Pere Energy Center","State":"WI","Gas":166.2,"coordinates":[-88.072,44.4486]},{"Plant":"Androscoggin Energy Center","State":"ME","Gas":136.6,"coordinates":[-70.2423,44.5063]},{"Plant":"Delta Person LLC","State":"NM","Gas":138,"coordinates":[-106.644,35.026]},{"Plant":"Mid-Georgia Cogeneration Facility","State":"GA","Gas":303,"coordinates":[-83.6039,32.4856]},{"Plant":"Berkshire Power","State":"MA","Gas":229.3,"coordinates":[-72.6478,42.0476]},{"Plant":"Bridgeport Energy Project","State":"CT","Gas":454,"coordinates":[-73.1844,41.1692]},{"Plant":"Pasadena Cogeneration","State":"TX","Gas":710,"coordinates":[-95.1765,29.7248]},{"Plant":"Tiverton Power Plant","State":"RI","Gas":250,"coordinates":[-71.1706,41.6422]},{"Plant":"Axiall Plaquemine","State":"LA","Gas":240,"coordinates":[-91.185,30.2586]},{"Plant":"Tenaska Georgia Generation Facility","State":"GA","Gas":933,"coordinates":[-84.9996,33.3516]},{"Plant":"Tenaska Frontier Generation Station","State":"TX","Gas":860,"coordinates":[-95.9178,30.5924]},{"Plant":"Batesville Generation Facility","State":"MS","Gas":858,"coordinates":[-89.9275,34.3356]},{"Plant":"Black Hawk Station","State":"TX","Gas":220.4,"coordinates":[-101.36,35.6957]},{"Plant":"Mustang Station","State":"TX","Gas":486,"coordinates":[-102.7417,32.9728]},{"Plant":"Maine Independence Station","State":"ME","Gas":490,"coordinates":[-68.7094,44.8242]},{"Plant":"Pine Bluff Energy Center","State":"AR","Gas":192,"coordinates":[-91.9025,34.2181]},{"Plant":"Desert Star Energy Center","State":"NV","Gas":450,"coordinates":[-114.9928,35.7867]},{"Plant":"Millennium Power","State":"MA","Gas":334.9,"coordinates":[-72.0151,42.1123]},{"Plant":"New Albany Energy Facility","State":"MS","Gas":360,"coordinates":[-88.9397,34.5408]},{"Plant":"Brownsville Peaking Power","State":"TN","Gas":456,"coordinates":[-89.198,35.5438]},{"Plant":"Crockett Cogen Project","State":"CA","Gas":247.4,"coordinates":[-122.2161,38.0569]},{"Plant":"Gregory Power Facility","State":"TX","Gas":366,"coordinates":[-97.2584,27.8893]},{"Plant":"Zeeland Generating Station","State":"MI","Gas":843,"coordinates":[-85.9975,42.8206]},{"Plant":"Dearborn Industrial Generation","State":"MI","Gas":710,"coordinates":[-83.154,42.3026]},{"Plant":"Taft Cogeneration Facility","State":"LA","Gas":738.9,"coordinates":[-90.4599,29.9888]},{"Plant":"Midlothian Energy Facility","State":"TX","Gas":1460,"coordinates":[-97.0537,32.4302]},{"Plant":"Lamar Power Project","State":"TX","Gas":1002,"coordinates":[-95.59,33.6308]},{"Plant":"Frontera Energy Center","State":"TX","Gas":500,"coordinates":[-98.3992,26.208]},{"Plant":"NRG Sterlington Power","State":"LA","Gas":176,"coordinates":[-92.0811,32.6889]},{"Plant":"Rumford Power Associates","State":"ME","Gas":254,"coordinates":[-70.5219,44.5303]},{"Plant":"Livingston Generating Station","State":"MI","Gas":132,"coordinates":[-84.7308,45.0304]},{"Plant":"Klamath Cogeneration Plant","State":"OR","Gas":490,"coordinates":[-121.8106,42.1739]},{"Plant":"Entergy Rhode Island State Energy LP","State":"RI","Gas":538,"coordinates":[-71.5186,41.8017]},{"Plant":"Rocky Road Power LLC","State":"IL","Gas":342.8,"coordinates":[-88.2397,42.0931]},{"Plant":"Madison","State":"OH","Gas":576,"coordinates":[-84.4647,39.4522]},{"Plant":"Vermillion Energy Facility","State":"IN","Gas":568,"coordinates":[-87.4464,39.9223]},{"Plant":"Sutter Energy Center","State":"CA","Gas":530,"coordinates":[-121.6959,39.0531]},{"Plant":"Rockingham County CT Station","State":"NC","Gas":825,"coordinates":[-79.8297,36.3297]},{"Plant":"RS Cogen","State":"LA","Gas":415.4,"coordinates":[-93.2992,30.221]},{"Plant":"SRW Cogen LP","State":"TX","Gas":420,"coordinates":[-93.7574,30.0545]},{"Plant":"Magic Valley Generating Station","State":"TX","Gas":682,"coordinates":[-98.19,26.3403]},{"Plant":"Griffith Energy LLC","State":"AZ","Gas":570,"coordinates":[-114.1333,35.054]},{"Plant":"Milford Power Project","State":"CT","Gas":506.7,"coordinates":[-73.0997,41.2244]},{"Plant":"Manchief Electric Generating Station","State":"CO","Gas":264,"coordinates":[-103.685,40.2171]},{"Plant":"Walton County Power LLC","State":"GA","Gas":454.5,"coordinates":[-83.6954,33.8148]},{"Plant":"Desert Basin","State":"AZ","Gas":577,"coordinates":[-111.7889,32.9042]},{"Plant":"Kendall County Generation Facility","State":"IL","Gas":1140,"coordinates":[-88.2581,41.4797]},{"Plant":"Tenaska Gateway Generating Station","State":"TX","Gas":845,"coordinates":[-94.6197,32.0178]},{"Plant":"Alliant Energy Neenah","State":"WI","Gas":300.3,"coordinates":[-88.5064,44.1936]},{"Plant":"Rio Nogales Power Project","State":"TX","Gas":756,"coordinates":[-97.9732,29.5931]},{"Plant":"Wolf Hollow I LP","State":"TX","Gas":705,"coordinates":[-97.7317,32.3342]},{"Plant":"Hawk Road Facility","State":"GA","Gas":486.9,"coordinates":[-84.9914,33.3585]},{"Plant":"Hays Energy Project","State":"TX","Gas":881,"coordinates":[-97.9894,29.7806]},{"Plant":"Green Country Energy LLC","State":"OK","Gas":783,"coordinates":[-95.9346,35.9833]},{"Plant":"Worthington Generation LLC","State":"IN","Gas":174.5,"coordinates":[-87.0128,39.0708]},{"Plant":"Lake Road Generating Plant","State":"CT","Gas":757.3,"coordinates":[-71.8958,41.872]},{"Plant":"La Paloma Generating LLC","State":"CA","Gas":965.4,"coordinates":[-119.5919,35.2956]},{"Plant":"Guadalupe Generating Station","State":"TX","Gas":982.3,"coordinates":[-98.1419,29.6244]},{"Plant":"Lost Pines 1 Power Project","State":"TX","Gas":516,"coordinates":[-97.2714,30.1478]},{"Plant":"Bluegrass Generating Station","State":"KY","Gas":501,"coordinates":[-85.4133,38.3902]},{"Plant":"Calcasieu","State":"LA","Gas":302.1,"coordinates":[-93.345,30.1608]},{"Plant":"Broad River Energy Center","State":"SC","Gas":850.8,"coordinates":[-81.575,35.0786]},{"Plant":"Bastrop Energy Center","State":"TX","Gas":525,"coordinates":[-97.55,30.1458]},{"Plant":"Granite Ridge","State":"NH","Gas":678,"coordinates":[-71.4261,42.9042]},{"Plant":"Bosque County Peaking","State":"TX","Gas":748,"coordinates":[-97.3586,31.8594]},{"Plant":"Acadia Energy Center","State":"LA","Gas":1120.3,"coordinates":[-92.4131,30.4286]},{"Plant":"Eastman Cogeneration Facility","State":"TX","Gas":402.2,"coordinates":[-94.6903,32.4481]},{"Plant":"South Point Energy Center","State":"AZ","Gas":550,"coordinates":[-114.5317,34.8678]},{"Plant":"Dogwood Energy Facility","State":"MO","Gas":616,"coordinates":[-94.3006,38.7931]},{"Plant":"Rathdrum Power LLC","State":"ID","Gas":248,"coordinates":[-116.9203,47.7858]},{"Plant":"Sunrise Power LLC","State":"CA","Gas":545,"coordinates":[-119.585,35.2097]},{"Plant":"Channelview Cogeneration Plant","State":"TX","Gas":833,"coordinates":[-95.1217,29.837]},{"Plant":"Cordova Energy","State":"IL","Gas":521.2,"coordinates":[-90.2797,41.7122]},{"Plant":"Osceola","State":"FL","Gas":471,"coordinates":[-81.0978,28.1289]},{"Plant":"Ontelaunee Energy Center","State":"PA","Gas":526,"coordinates":[-75.9356,40.4219]},{"Plant":"Caledonia","State":"MS","Gas":765,"coordinates":[-88.2717,33.6464]},{"Plant":"Riverside Generating LLC","State":"KY","Gas":825,"coordinates":[-82.6046,38.1917]},{"Plant":"Elwood Energy LLC","State":"IL","Gas":1350,"coordinates":[-88.1236,41.4388]},{"Plant":"Arapahoe Combustion Turbine Project","State":"CO","Gas":122.5,"coordinates":[-105.0018,39.6692]},{"Plant":"Gibson City","State":"IL","Gas":228,"coordinates":[-88.3987,40.4705]},{"Plant":"Pinckneyville","State":"IL","Gas":316,"coordinates":[-89.3467,38.1114]},{"Plant":"Kinmundy","State":"IL","Gas":206,"coordinates":[-89.0128,38.7619]},{"Plant":"Corpus Christi Energy Center","State":"TX","Gas":469,"coordinates":[-97.4283,27.8139]},{"Plant":"Afton Generating Station","State":"NM","Gas":235.6,"coordinates":[-106.8465,32.1142]},{"Plant":"ANP Bellingham Energy Project","State":"MA","Gas":471.7,"coordinates":[-71.4535,42.1106]},{"Plant":"ANP Blackstone Energy Project","State":"MA","Gas":473.2,"coordinates":[-71.5158,42.0599]},{"Plant":"Odessa Ector Generating Station","State":"TX","Gas":999.5,"coordinates":[-102.3264,31.8403]},{"Plant":"Morris Cogeneration LLC","State":"IL","Gas":183.8,"coordinates":[-88.3328,41.4119]},{"Plant":"Los Medanos Energy Center","State":"CA","Gas":567,"coordinates":[-121.873,38.0301]},{"Plant":"Hinds Energy Facility","State":"MS","Gas":288,"coordinates":[-90.2199,32.379]},{"Plant":"Attala","State":"MS","Gas":457.3,"coordinates":[-89.6753,33.0147]},{"Plant":"Harry L. Oswald","State":"AR","Gas":548,"coordinates":[-92.2166,34.5923]},{"Plant":"Lincoln Generating Facility","State":"IL","Gas":622.9,"coordinates":[-87.9436,41.3933]},{"Plant":"Ennis Power Company LLC","State":"TX","Gas":359.5,"coordinates":[-96.675,32.32]},{"Plant":"Wheatland Generating Facility","State":"IN","Gas":460,"coordinates":[-87.2931,38.6716]},{"Plant":"Oneta Energy Center","State":"OK","Gas":1086.4,"coordinates":[-95.6967,36.0119]},{"Plant":"Freestone Energy Center","State":"TX","Gas":953,"coordinates":[-96.1131,31.8907]},{"Plant":"Greenville Electric Generating Station","State":"OH","Gas":196,"coordinates":[-84.6151,40.0758]},{"Plant":"Montpelier Electric Generating Station","State":"IN","Gas":180,"coordinates":[-85.3057,40.6206]},{"Plant":"Jack County","State":"TX","Gas":1241,"coordinates":[-97.9574,33.101]},{"Plant":"Liberty Electric Power Plant","State":"PA","Gas":541,"coordinates":[-75.3358,39.8614]},{"Plant":"Marshall Energy Facility","State":"KY","Gas":581.6,"coordinates":[-88.3958,37.0286]},{"Plant":"Handsome Lake Energy LLC","State":"PA","Gas":267.5,"coordinates":[-79.8061,41.2908]},{"Plant":"Audrain Generating Station","State":"MO","Gas":600,"coordinates":[-91.5369,39.3092]},{"Plant":"Lee Energy Facility","State":"IL","Gas":568,"coordinates":[-89.4054,41.8287]},{"Plant":"Energy Shelby County","State":"IL","Gas":336,"coordinates":[-88.4772,39.2794]},{"Plant":"NRG Rockford I","State":"IL","Gas":301.3,"coordinates":[-89.1012,42.2386]},{"Plant":"Red Oak Power LLC","State":"NJ","Gas":765.9,"coordinates":[-74.3489,40.4487]},{"Plant":"Hog Bayou Energy Center","State":"AL","Gas":230,"coordinates":[-88.0575,30.7478]},{"Plant":"Santa Rosa Energy Center","State":"FL","Gas":235.9,"coordinates":[-87.115,30.5664]},{"Plant":"Astoria Gas Turbines","State":"NY","Gas":396.5,"coordinates":[-73.9048,40.787]},{"Plant":"Doyle Energy Facility","State":"GA","Gas":326.9,"coordinates":[-83.6996,33.8377]},{"Plant":"Darby Electric Generating Station","State":"OH","Gas":435,"coordinates":[-83.1778,39.7139]},{"Plant":"Tait Electric Generating Station","State":"OH","Gas":340,"coordinates":[-84.2095,39.7277]},{"Plant":"University Park South","State":"IL","Gas":300,"coordinates":[-87.7532,41.4409]},{"Plant":"Gleason Generating Facility","State":"TN","Gas":360,"coordinates":[-88.612,36.2454]},{"Plant":"Crete Energy Venture LLC","State":"IL","Gas":300,"coordinates":[-87.6187,41.4294]},{"Plant":"Whiting Clean Energy","State":"IN","Gas":513,"coordinates":[-87.4775,41.6739]},{"Plant":"Edward L. Addison Generating Plant","State":"GA","Gas":598.8,"coordinates":[-84.3064,32.9111]},{"Plant":"TVA Southaven Combined Cycle","State":"MS","Gas":780,"coordinates":[-90.0378,34.9939]},{"Plant":"Jackson Generating Station","State":"MI","Gas":564,"coordinates":[-84.3767,42.2488]},{"Plant":"Tenaska Lindsay Hill Generating Station","State":"AL","Gas":845,"coordinates":[-86.7386,32.6514]},{"Plant":"Ceredo Generating Station","State":"WV","Gas":450,"coordinates":[-82.5339,38.3681]},{"Plant":"Aurora","State":"IL","Gas":832,"coordinates":[-88.2265,41.8151]},{"Plant":"Southeast Chicago Energy Project","State":"IL","Gas":296,"coordinates":[-87.5449,41.7181]},{"Plant":"Arlington Valley Energy Facility","State":"AZ","Gas":579,"coordinates":[-112.8897,33.3417]},{"Plant":"Front Range Power Plant","State":"CO","Gas":460,"coordinates":[-104.7069,38.6281]},{"Plant":"Big Sandy Peaker Plant","State":"WV","Gas":300,"coordinates":[-82.5938,38.3441]},{"Plant":"Wolf Hills Energy","State":"VA","Gas":250,"coordinates":[-82.1044,36.6644]},{"Plant":"Oleander Power Project LP","State":"FL","Gas":790.2,"coordinates":[-80.7947,28.3661]},{"Plant":"Decatur Energy Center","State":"AL","Gas":725,"coordinates":[-87.0214,34.6292]},{"Plant":"Morgan Energy Center","State":"AL","Gas":749,"coordinates":[-87.0639,34.6397]},{"Plant":"Westbrook Energy Center Power Plant","State":"ME","Gas":506,"coordinates":[-70.375,43.6575]},{"Plant":"Blythe Energy Inc","State":"CA","Gas":514,"coordinates":[-114.6865,33.6157]},{"Plant":"Calumet Energy Team LLC","State":"IL","Gas":321.2,"coordinates":[-87.5563,41.6835]},{"Plant":"New Covert Generating Facility","State":"MI","Gas":1040.1,"coordinates":[-86.2937,42.3224]},{"Plant":"Fairless Energy Center","State":"PA","Gas":1233.2,"coordinates":[-74.7411,40.1475]},{"Plant":"Channel Energy Center LLC","State":"TX","Gas":768,"coordinates":[-95.2319,29.7189]},{"Plant":"Baconton Power Plant","State":"GA","Gas":196,"coordinates":[-84.08,31.3869]},{"Plant":"Gila River Power Station","State":"AZ","Gas":515,"coordinates":[-112.6944,32.975]},{"Plant":"Air Products Port Arthur","State":"TX","Gas":158.9,"coordinates":[-93.9651,29.8665]},{"Plant":"Ingleside Cogeneration","State":"TX","Gas":460,"coordinates":[-97.2428,27.8828]},{"Plant":"Fore River Generating Station","State":"MA","Gas":726,"coordinates":[-70.9661,42.2422]},{"Plant":"Indian River","State":"FL","Gas":576.4,"coordinates":[-80.7802,28.4932]},{"Plant":"Wise County Power LLC","State":"TX","Gas":680,"coordinates":[-97.9103,33.0583]},{"Plant":"Chuck Lenzie Generating Station","State":"NV","Gas":1170,"coordinates":[-114.9218,36.3837]},{"Plant":"Baytown Energy Center","State":"TX","Gas":770,"coordinates":[-94.9019,29.7731]},{"Plant":"Hermiston Power Partnership","State":"OR","Gas":615,"coordinates":[-119.3133,45.794]},{"Plant":"Washington County","State":"GA","Gas":604,"coordinates":[-82.98,33.0922]},{"Plant":"Delta Energy Center","State":"CA","Gas":769.1,"coordinates":[-121.8439,38.0169]},{"Plant":"Holland Energy Facility","State":"IL","Gas":612.7,"coordinates":[-88.7584,39.2231]},{"Plant":"PPL Ironwood LLC","State":"PA","Gas":660.1,"coordinates":[-76.3658,40.3509]},{"Plant":"Dell Power Station","State":"AR","Gas":437,"coordinates":[-90.0253,35.8619]},{"Plant":"Luna Energy Facility","State":"NM","Gas":559,"coordinates":[-107.7834,32.2993]},{"Plant":"Otay Mesa Generating Project","State":"CA","Gas":571,"coordinates":[-116.915,32.5815]},{"Plant":"Armstrong","State":"PA","Gas":603.1,"coordinates":[-79.3517,40.638]},{"Plant":"Troy Energy LLC","State":"OH","Gas":584,"coordinates":[-83.4598,41.4772]},{"Plant":"Pleasants Energy LLC","State":"WV","Gas":321.3,"coordinates":[-81.3642,39.3325]},{"Plant":"Dresden Energy Facility","State":"OH","Gas":540,"coordinates":[-82.0276,40.0928]},{"Plant":"Brazos Valley Generating Facility","State":"TX","Gas":525,"coordinates":[-95.6244,29.4731]},{"Plant":"Cottonwood Energy Project","State":"TX","Gas":1180,"coordinates":[-93.7353,30.2588]},{"Plant":"Sugar Creek Power","State":"IN","Gas":549,"coordinates":[-87.5108,39.3931]},{"Plant":"Exelon LaPorte Generating Station","State":"TX","Gas":153.2,"coordinates":[-95.0718,29.7028]},{"Plant":"Harquahala Generating Project","State":"AZ","Gas":1020,"coordinates":[-113.1134,33.476]},{"Plant":"Astoria Energy","State":"NY","Gas":540,"coordinates":[-73.8964,40.7825]},{"Plant":"Union Power Partners LP","State":"AR","Gas":2020,"coordinates":[-92.5894,33.2961]},{"Plant":"Thomas A Smith Energy Facility","State":"GA","Gas":1290,"coordinates":[-84.9175,34.7094]},{"Plant":"Columbia Energy Center","State":"SC","Gas":543,"coordinates":[-81.0178,33.8697]},{"Plant":"RockGen Energy Center","State":"WI","Gas":471,"coordinates":[-89.0492,42.9767]},{"Plant":"Zion Energy Center","State":"IL","Gas":456,"coordinates":[-87.895,42.4776]},{"Plant":"Metcalf Energy Center","State":"CA","Gas":546.1,"coordinates":[-121.7457,37.2207]},{"Plant":"Crossroads Energy Center","State":"MS","Gas":308,"coordinates":[-90.5621,34.183]},{"Plant":"Washington Energy Facility","State":"OH","Gas":626,"coordinates":[-81.6564,39.58]},{"Plant":"Elk Hills Power LLC","State":"CA","Gas":312,"coordinates":[-119.4707,35.2803]},{"Plant":"Rolling Hills Generating","State":"OH","Gas":825,"coordinates":[-82.3328,39.0839]},{"Plant":"Renaissance Power LLC","State":"MI","Gas":660,"coordinates":[-84.8429,43.1864]},{"Plant":"Carville Energy LLC","State":"LA","Gas":525,"coordinates":[-91.065,30.2294]},{"Plant":"Athens Generating Plant","State":"NY","Gas":1137.9,"coordinates":[-73.8492,42.2728]},{"Plant":"Effingham County Power Project","State":"GA","Gas":509,"coordinates":[-81.2844,32.2773]},{"Plant":"Calhoun Energy Center","State":"AL","Gas":632,"coordinates":[-85.9731,33.5883]},{"Plant":"Hillabee Energy Center","State":"AL","Gas":721.8,"coordinates":[-85.9033,33.0007]},{"Plant":"Osprey Energy Center Power Plant","State":"FL","Gas":590,"coordinates":[-81.8083,28.0525]},{"Plant":"Shady Hills Generating Station","State":"FL","Gas":463.2,"coordinates":[-82.5586,28.3665]},{"Plant":"Vandolah Power Station","State":"FL","Gas":646,"coordinates":[-81.924,27.5236]},{"Plant":"Raccoon Creek Energy Center","State":"IL","Gas":300,"coordinates":[-88.5392,38.6996]},{"Plant":"Hot Spring Generating Facility","State":"AR","Gas":596.8,"coordinates":[-92.8683,34.2976]},{"Plant":"Plaquemine Cogeneration Plant","State":"LA","Gas":793,"coordinates":[-91.2347,30.3217]},{"Plant":"DeSoto County Plant","State":"FL","Gas":320,"coordinates":[-81.8092,27.2272]},{"Plant":"Bayou Cove Peaking Power","State":"LA","Gas":300,"coordinates":[-92.5997,30.2825]},{"Plant":"Elgin Energy Center","State":"IL","Gas":460,"coordinates":[-88.2446,42.0001]},{"Plant":"Tenaska Virginia Generating Station","State":"VA","Gas":899.1,"coordinates":[-78.3813,37.8667]},{"Plant":"Tenaska Central Alabama Generating Stn","State":"AL","Gas":923.8,"coordinates":[-86.74,32.6497]},{"Plant":"Columbia Energy Center","State":"MO","Gas":140,"coordinates":[-92.2629,39.0192]},{"Plant":"Magnolia Power Plant","State":"MS","Gas":918,"coordinates":[-89.2026,34.835]},{"Plant":"Fountain Valley Power Facility","State":"CO","Gas":234,"coordinates":[-104.6875,38.5569]},{"Plant":"Red Hawk","State":"AZ","Gas":934,"coordinates":[-112.8406,33.3346]},{"Plant":"McClain Energy Facility","State":"OK","Gas":370.4,"coordinates":[-97.5898,35.2977]},{"Plant":"Redbud Power Plant","State":"OK","Gas":1784.3,"coordinates":[-97.2264,35.6856]},{"Plant":"Deer Park Energy Center","State":"TX","Gas":1116,"coordinates":[-95.1345,29.7134]},{"Plant":"Ouachita","State":"LA","Gas":731.2,"coordinates":[-92.0683,32.7061]},{"Plant":"Green Power 2","State":"TX","Gas":825.5,"coordinates":[-94.9328,29.3781]},{"Plant":"Forney Energy Center","State":"TX","Gas":1760,"coordinates":[-96.4916,32.7563]},{"Plant":"Mesquite Generating Station","State":"AZ","Gas":595,"coordinates":[-112.8642,33.345]},{"Plant":"Goldendale Generating Station","State":"WA","Gas":256.7,"coordinates":[-120.833,45.8114]},{"Plant":"Tri Center Naniwa Energy","State":"NV","Gas":200,"coordinates":[-119.5178,39.5572]},{"Plant":"Goose Creek Energy Center","State":"IL","Gas":432,"coordinates":[-88.5999,40.1069]},{"Plant":"Kiamichi Energy Facility","State":"OK","Gas":1178.4,"coordinates":[-95.9349,34.6831]},{"Plant":"Lawrenceburg Energy Facility","State":"IN","Gas":1080,"coordinates":[-84.8669,39.0911]},{"Plant":"AEP Waterford Facility","State":"OH","Gas":810,"coordinates":[-81.7178,39.5333]},{"Plant":"Limon Generating Station","State":"CO","Gas":134,"coordinates":[-103.7005,39.2038]},{"Plant":"Frank Knutson","State":"CO","Gas":134,"coordinates":[-104.682,39.9411]},{"Plant":"Apex Generating Station","State":"NV","Gas":494.4,"coordinates":[-114.9609,36.416]},{"Plant":"Fayette Energy Facility","State":"PA","Gas":628,"coordinates":[-79.9182,39.8592]},{"Plant":"Wallingford Energy","State":"CT","Gas":211.5,"coordinates":[-72.8354,41.4487]},{"Plant":"High Desert Power Plant","State":"CA","Gas":774.3,"coordinates":[-117.3647,34.5953]},{"Plant":"Sundance","State":"AZ","Gas":410,"coordinates":[-111.5899,32.9285]},{"Plant":"York Energy Center","State":"PA","Gas":545,"coordinates":[-76.3067,39.7375]},{"Plant":"Indigo Energy Facility","State":"CA","Gas":142.5,"coordinates":[-116.553,33.9109]},{"Plant":"Hidalgo Energy Center","State":"TX","Gas":470,"coordinates":[-98.1758,26.3417]},{"Plant":"Perryville Power Station","State":"LA","Gas":686.5,"coordinates":[-92.0183,32.6908]},{"Plant":"West Valley Generation Project","State":"UT","Gas":185,"coordinates":[-112.0317,40.6667]},{"Plant":"University Park North","State":"IL","Gas":504,"coordinates":[-87.7514,41.4425]},{"Plant":"Riverside Energy Center","State":"WI","Gas":579.5,"coordinates":[-89.0355,42.5827]},{"Plant":"Blue Spruce Energy Center","State":"CO","Gas":264,"coordinates":[-104.6814,39.7479]},{"Plant":"Plains End","State":"CO","Gas":114,"coordinates":[-105.226,39.8575]},{"Plant":"Spring Creek Energy Center","State":"OK","Gas":271,"coordinates":[-97.655,35.7422]},{"Plant":"Pastoria Energy Facility, LLC","State":"CA","Gas":724,"coordinates":[-118.844,34.9556]},{"Plant":"EP Newington Energy LLC","State":"NH","Gas":523,"coordinates":[-70.8061,43.1047]},{"Plant":"Chehalis Generating Facility","State":"WA","Gas":477,"coordinates":[-122.9131,46.6225]},{"Plant":"Harrison County Power Project","State":"TX","Gas":514.4,"coordinates":[-94.4367,32.3958]},{"Plant":"Lower Mount Bethel Energy","State":"PA","Gas":537.5,"coordinates":[-75.1076,40.8019]},{"Plant":"AL Sandersville LLC","State":"GA","Gas":576.4,"coordinates":[-82.8608,33.1189]},{"Plant":"Higgins Generating Station","State":"NV","Gas":550,"coordinates":[-115.3561,35.6139]},{"Plant":"Bethlehem Power Plant","State":"PA","Gas":1134,"coordinates":[-75.3147,40.6175]},{"Plant":"Quantum Choctaw Power LLC","State":"MS","Gas":710,"coordinates":[-89.2089,33.3792]},{"Plant":"Mint Farm Generating Station","State":"WA","Gas":275.9,"coordinates":[-122.9855,46.1388]},{"Plant":"Fremont Energy Center","State":"OH","Gas":676.7,"coordinates":[-83.1614,41.3771]},{"Plant":"Choctaw County","State":"MS","Gas":781,"coordinates":[-89.4201,33.2881]},{"Plant":"Allegheny Energy Units 3 4 & 5","State":"PA","Gas":509,"coordinates":[-79.7686,40.5453]},{"Plant":"Magnet Cove","State":"AR","Gas":641.5,"coordinates":[-92.8317,34.4297]},{"Plant":"Dean","State":"MI","Gas":295.4,"coordinates":[-82.4953,42.7725]},{"Plant":"Bennett Mountain","State":"ID","Gas":164,"coordinates":[-115.6666,43.1472]},{"Plant":"Hanging Rock Energy Facility","State":"OH","Gas":1252,"coordinates":[-82.7833,38.5731]},{"Plant":"Los Esteros Critical Energy Center","State":"CA","Gas":306.1,"coordinates":[-121.9319,37.425]},{"Plant":"FPL Energy Marcus Hook LP","State":"PA","Gas":779,"coordinates":[-75.4216,39.807]},{"Plant":"Valencia Energy Facility","State":"NM","Gas":144.3,"coordinates":[-106.7322,34.6115]},{"Plant":"Gilroy Peaking Energy Center","State":"CA","Gas":135,"coordinates":[-121.5363,36.999]},{"Plant":"Frederickson Power LP","State":"WA","Gas":242,"coordinates":[-122.3657,47.0861]},{"Plant":"Curtis H Stanton Energy Center","State":"FL","Gas":656.9,"coordinates":[-81.1669,28.4882]},{"Plant":"Auburndale Peaker Energy Center","State":"FL","Gas":117,"coordinates":[-81.8059,28.0535]},{"Plant":"Rocky Mountain Energy Center","State":"CO","Gas":580,"coordinates":[-104.5953,40.0908]},{"Plant":"Silverhawk","State":"NV","Gas":560,"coordinates":[-114.9606,36.4078]},{"Plant":"Inland Empire Energy Center","State":"CA","Gas":690,"coordinates":[-117.1704,33.7388]},{"Plant":"Jasper","State":"SC","Gas":862,"coordinates":[-81.1242,32.3594]},{"Plant":"Tracy Combined Cycle Power Plant","State":"CA","Gas":320.1,"coordinates":[-121.4906,37.7107]},{"Plant":"NRG Rockford II Energy Center","State":"IL","Gas":154.4,"coordinates":[-89.1011,42.2383]},{"Plant":"NAEA Ocean Peaking Power LLC","State":"NJ","Gas":325.6,"coordinates":[-74.1672,40.0633]},{"Plant":"Warren County","State":"VA","Gas":1472.2,"coordinates":[-78.1772,38.9717]},{"Plant":"Wansley Combined Cycle","State":"GA","Gas":1143.1,"coordinates":[-85.037,33.4064]},{"Plant":"Cosumnes","State":"CA","Gas":503,"coordinates":[-121.124,38.3385]},{"Plant":"Cass County","State":"NE","Gas":324.4,"coordinates":[-95.964,40.9479]},{"Plant":"Hunterstown","State":"PA","Gas":758,"coordinates":[-77.1672,39.8725]},{"Plant":"Palomar Energy","State":"CA","Gas":562,"coordinates":[-117.1178,33.1197]},{"Plant":"Exira","State":"IA","Gas":139.5,"coordinates":[-94.9197,41.5144]},{"Plant":"Donald Von Raesfeld Power Plant","State":"CA","Gas":154,"coordinates":[-121.9508,37.3767]},{"Plant":"Fox Energy Center","State":"WI","Gas":565.1,"coordinates":[-88.2089,44.3204]},{"Plant":"Malburg","State":"CA","Gas":143,"coordinates":[-118.2219,33.9986]},{"Plant":"Magnolia Power Project","State":"CA","Gas":301,"coordinates":[-118.3153,34.1786]},{"Plant":"Walnut Energy Center","State":"CA","Gas":269,"coordinates":[-120.8956,37.4878]},{"Plant":"Currant Creek","State":"UT","Gas":524,"coordinates":[-111.8935,39.8214]},{"Plant":"Mankato Energy Center","State":"MN","Gas":300,"coordinates":[-94.003,44.1988]},{"Plant":"Riverside Energy Resource Center","State":"CA","Gas":196,"coordinates":[-117.4528,33.9636]},{"Plant":"McIntosh Combined Cycle Facility","State":"GA","Gas":1256.8,"coordinates":[-81.1817,32.3478]},{"Plant":"South Harper","State":"MO","Gas":303.3,"coordinates":[-94.4824,38.6803]},{"Plant":"Freeport Energy Center","State":"TX","Gas":219.4,"coordinates":[-95.3954,28.9888]},{"Plant":"Faribault Energy Park","State":"MN","Gas":261,"coordinates":[-93.2906,44.3356]},{"Plant":"Sheboygan Falls","State":"WI","Gas":299.4,"coordinates":[-87.8781,43.7518]},{"Plant":"Nebo Power Station","State":"UT","Gas":130,"coordinates":[-111.7294,40.0614]},{"Plant":"500MW CC","State":"NY","Gas":454.1,"coordinates":[-73.9069,40.7889]},{"Plant":"Port Westward","State":"OR","Gas":392.2,"coordinates":[-123.172,46.1789]},{"Plant":"EG178 Facility","State":"TX","Gas":110,"coordinates":[-100.9547,32.7471]},{"Plant":"Caithness Long Island Energy Center","State":"NY","Gas":307,"coordinates":[-72.9403,40.8142]},{"Plant":"Lake Side Power Plant","State":"UT","Gas":1176,"coordinates":[-111.7542,40.3317]},{"Plant":"Groton Generating Station","State":"SD","Gas":158.9,"coordinates":[-98.0987,45.3735]},{"Plant":"Kings River","State":"CA","Gas":109,"coordinates":[-119.7404,36.6697]},{"Plant":"Cannon Falls Energy Center","State":"MN","Gas":398,"coordinates":[-92.9155,44.5367]},{"Plant":"Anson County Generation Facility","State":"NC","Gas":339,"coordinates":[-79.9217,34.9687]},{"Plant":"Empire Generating Co  LLC","State":"NY","Gas":580,"coordinates":[-73.75,42.6252]},{"Plant":"Hamlet Generating Facility","State":"NC","Gas":339,"coordinates":[-79.7361,34.8423]},{"Plant":"Roseville Energy Park","State":"CA","Gas":151,"coordinates":[-121.3811,38.7928]},{"Plant":"Mustang Station Unit 4","State":"TX","Gas":435,"coordinates":[-102.7436,32.9746]},{"Plant":"Harry D Mattison Gas Plant","State":"AR","Gas":294,"coordinates":[-94.2841,36.1855]},{"Plant":"Quail Run Energy Center","State":"TX","Gas":482,"coordinates":[-102.315,31.8414]},{"Plant":"Colorado Bend Energy Center","State":"TX","Gas":510,"coordinates":[-96.0683,29.2878]},{"Plant":"Stanton Energy Center","State":"FL","Gas":295,"coordinates":[-81.1678,28.4822]},{"Plant":"Treasure Coast Energy Center","State":"FL","Gas":318,"coordinates":[-80.3775,27.3839]},{"Plant":"West County Energy Center","State":"FL","Gas":3669,"coordinates":[-80.3747,26.6986]},{"Plant":"Spindle Hill Energy Center","State":"CO","Gas":270,"coordinates":[-104.8878,40.0922]},{"Plant":"Hobbs Generating Station","State":"NM","Gas":567.9,"coordinates":[-103.3094,32.7283]},{"Plant":"Russell City Energy Center","State":"CA","Gas":615,"coordinates":[-122.1338,37.6347]},{"Plant":"Gateway Generating Station","State":"CA","Gas":563.4,"coordinates":[-121.7587,38.0175]},{"Plant":"Western 102 Power Plant","State":"NV","Gas":110.6,"coordinates":[-119.5108,39.5603]},{"Plant":"Emporia Energy Center","State":"KS","Gas":646,"coordinates":[-96.0652,38.4459]},{"Plant":"Jonesboro City Water & Light Plant","State":"AR","Gas":177,"coordinates":[-90.7254,35.8486]},{"Plant":"Plains End II LLC","State":"CO","Gas":116.2,"coordinates":[-105.2256,39.8586]},{"Plant":"Colusa Generating Station","State":"CA","Gas":640,"coordinates":[-122.27,39.3661]},{"Plant":"PPS Power Plant No 1","State":"KY","Gas":110,"coordinates":[-88.6159,37.0339]},{"Plant":"J Lamar Stall Unit","State":"LA","Gas":507,"coordinates":[-93.7601,32.5195]},{"Plant":"San Jacinto County Peaking Facility","State":"TX","Gas":146,"coordinates":[-95.0118,30.4193]},{"Plant":"Hardin County Peaking Facility","State":"TX","Gas":146,"coordinates":[-94.2526,30.3038]},{"Plant":"Deer Creek Station","State":"SD","Gas":290,"coordinates":[-96.5267,44.2908]},{"Plant":"Midway Peaking LLC","State":"CA","Gas":118.5,"coordinates":[-120.5797,36.6541]},{"Plant":"Winchester Power Park","State":"TX","Gas":179.2,"coordinates":[-96.9875,30.0381]},{"Plant":"CFB Power Plant","State":"TX","Gas":286.2,"coordinates":[-96.5397,28.6503]},{"Plant":"Kleen Energy Systems Project","State":"CT","Gas":622,"coordinates":[-72.5969,41.5532]},{"Plant":"Greenland Energy Center","State":"FL","Gas":296,"coordinates":[-81.5184,30.1591]},{"Plant":"Panoche Energy Center","State":"CA","Gas":388,"coordinates":[-120.5833,36.6514]},{"Plant":"Cedar Bayou 4","State":"TX","Gas":502,"coordinates":[-94.9231,29.7516]},{"Plant":"Bear Garden","State":"VA","Gas":589,"coordinates":[-78.2853,37.6956]},{"Plant":"Dave Gates Generating Station","State":"MT","Gas":132.3,"coordinates":[-112.8766,46.1047]},{"Plant":"Coolidge Generation Station","State":"AZ","Gas":520.8,"coordinates":[-111.5033,32.9174]},{"Plant":"West Deptford Energy Station","State":"NJ","Gas":669.3,"coordinates":[-75.2214,39.8414]},{"Plant":"Bayonne Energy Center","State":"NJ","Gas":479.9,"coordinates":[-74.0915,40.6528]},{"Plant":"Pueblo Airport Generating Station","State":"CO","Gas":368,"coordinates":[-104.5264,38.3208]},{"Plant":"Canyon Power Plant","State":"CA","Gas":194.8,"coordinates":[-117.8617,33.8581]},{"Plant":"Langley Gulch Power Plant","State":"ID","Gas":299.7,"coordinates":[-116.8197,43.9044]},{"Plant":"Cleveland Cnty Generating Facility","State":"NC","Gas":720,"coordinates":[-81.4166,35.1705]},{"Plant":"Southcentral Power Plant","State":"AK","Gas":169.7,"coordinates":[-149.9053,61.1674]},{"Plant":"Kemper County IGCC Project","State":"MS","Gas":555.2,"coordinates":[-88.7622,32.6547]},{"Plant":"Marsh Landing Generating Station","State":"CA","Gas":764.3,"coordinates":[-121.765,38.0169]},{"Plant":"CPV Sentinel Energy Project","State":"CA","Gas":800,"coordinates":[-116.5714,33.9342]},{"Plant":"Mariposa Energy Project","State":"CA","Gas":199.6,"coordinates":[-121.6019,37.7892]},{"Plant":"Walnut Creek Energy Park","State":"CA","Gas":485,"coordinates":[-117.9449,34.0087]},{"Plant":"Astoria Energy II","State":"NY","Gas":540,"coordinates":[-73.8966,40.7813]},{"Plant":"Cheyenne Prairie Generating Station","State":"WY","Gas":131,"coordinates":[-104.72,41.1236]},{"Plant":"Antelope Station","State":"TX","Gas":160.2,"coordinates":[-101.8433,33.865]},{"Plant":"Pioneer Generating Station","State":"ND","Gas":120,"coordinates":[-103.9528,48.2325]},{"Plant":"El Segundo Energy Center LLC","State":"CA","Gas":510,"coordinates":[-118.425,33.9106]},{"Plant":"Lodi Energy Center","State":"CA","Gas":162,"coordinates":[-121.3875,38.0881]},{"Plant":"Panda Temple Power Station","State":"TX","Gas":734,"coordinates":[-97.3172,31.0558]},{"Plant":"Panda Sherman Power Station","State":"TX","Gas":717,"coordinates":[-96.6179,33.5826]},{"Plant":"Lee Combined Cycle Plant","State":"NC","Gas":910,"coordinates":[-78.0894,35.3736]},{"Plant":"Rubart","State":"KS","Gas":108,"coordinates":[-93.3369,36.8283]},{"Plant":"Port Westward Unit 2","State":"OR","Gas":205.7,"coordinates":[-123.1719,46.1789]},{"Plant":"Mesquite Generating Station Block 1","State":"AZ","Gas":595,"coordinates":[-112.8642,33.345]},{"Plant":"L V Sutton Combined Cycle","State":"NC","Gas":622,"coordinates":[-77.9853,34.2831]},{"Plant":"Edge Moor","State":"DE","Gas":710,"coordinates":[-75.5038,39.7389]},{"Plant":"PB1 - Gila River","State":"AZ","Gas":1030,"coordinates":[-112.6944,32.975]},{"Plant":"Gila River Power Block 3","State":"AZ","Gas":515,"coordinates":[-112.6944,32.975]},{"Plant":"McKee Run","State":"DE","Gas":136,"coordinates":[-75.5466,39.1762]},{"Plant":"Belle River","State":"MI","Gas":224,"coordinates":[-82.495,42.7756]},{"Plant":"Greenwood","State":"MI","Gas":1009,"coordinates":[-82.6964,43.1056]},{"Plant":"Manatee","State":"FL","Gas":1111,"coordinates":[-82.3456,27.6058]},{"Plant":"Martin","State":"FL","Gas":2043,"coordinates":[-80.5628,27.0536]},{"Plant":"DeBary","State":"FL","Gas":247,"coordinates":[-81.3323,28.9039]},{"Plant":"Electrifarm","State":"IA","Gas":195.1,"coordinates":[-92.4205,42.4407]},{"Plant":"Fredonia","State":"WA","Gas":280,"coordinates":[-122.4358,48.4558]},{"Plant":"Trimble County","State":"KY","Gas":942,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Gas":972,"coordinates":[-88.5553,30.5322]},{"Plant":"Greenwood","State":"MO","Gas":246.1,"coordinates":[-94.2982,38.8615]},{"Plant":"R M Schahfer","State":"IN","Gas":155,"coordinates":[-87.0261,41.2164]},{"Plant":"Cape Canaveral","State":"FL","Gas":1210,"coordinates":[-80.7644,28.4698]},{"Plant":"Fort St Vrain","State":"CO","Gas":969,"coordinates":[-104.8742,40.2461]},{"Plant":"Fort Myers","State":"FL","Gas":1747,"coordinates":[-81.7831,26.6967]},{"Plant":"Whitehorn","State":"WA","Gas":134,"coordinates":[-122.6861,48.8288]},{"Plant":"McIntosh","State":"GA","Gas":657.6,"coordinates":[-81.1683,32.3563]},{"Plant":"Lauderdale","State":"FL","Gas":1724,"coordinates":[-80.1984,26.0686]},{"Plant":"A B Brown","State":"IN","Gas":160,"coordinates":[-87.715,37.9053]},{"Plant":"Port Everglades","State":"FL","Gas":420,"coordinates":[-80.1253,26.0856]},{"Plant":"Riviera","State":"FL","Gas":1212,"coordinates":[-80.0525,26.7653]},{"Plant":"Brame Energy Center","State":"LA","Gas":426.8,"coordinates":[-92.7167,31.395]},{"Plant":"John Twitty Energy Center","State":"MO","Gas":104,"coordinates":[-93.388,37.1517]},{"Plant":"Sanford","State":"FL","Gas":1912,"coordinates":[-81.3256,28.8419]},{"Plant":"Turkey Point","State":"FL","Gas":1148,"coordinates":[-80.3308,25.4356]},{"Plant":"Empire Energy Center","State":"MO","Gas":262,"coordinates":[-94.1041,37.1385]},{"Plant":"Dansby","State":"TX","Gas":204.2,"coordinates":[-96.4608,30.7217]},{"Plant":"Higgins","State":"FL","Gas":109,"coordinates":[-82.6615,28.0033]},{"Plant":"P L Bartow","State":"FL","Gas":1194,"coordinates":[-82.6018,27.8595]},{"Plant":"Rokeby","State":"NE","Gas":255,"coordinates":[-96.7364,40.7316]},{"Plant":"Suwannee River","State":"FL","Gas":232,"coordinates":[-83.1806,30.3764]},{"Plant":"Lansing Smith","State":"FL","Gas":481,"coordinates":[-85.7003,30.2686]},{"Plant":"D G Hunter","State":"LA","Gas":130,"coordinates":[-92.4613,31.3207]},{"Plant":"George M Sullivan Generation Plant 2","State":"AK","Gas":248.1,"coordinates":[-149.7167,61.2297]},{"Plant":"Deerhaven Generating Station","State":"FL","Gas":185,"coordinates":[-82.3878,29.7592]},{"Plant":"John R Kelly","State":"FL","Gas":112,"coordinates":[-82.3208,29.6461]},{"Plant":"J D Kennedy","State":"FL","Gas":317.2,"coordinates":[-81.626,30.3648]},{"Plant":"Northside Generating Station","State":"FL","Gas":524,"coordinates":[-81.5525,30.4172]},{"Plant":"C D McIntosh Jr","State":"FL","Gas":545,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Gas":388,"coordinates":[-105.0212,40.8609]},{"Plant":"Indian River Plant","State":"FL","Gas":290,"coordinates":[-80.7801,28.4932]},{"Plant":"Arvah B Hopkins","State":"FL","Gas":364,"coordinates":[-84.4,30.4522]},{"Plant":"S O Purdom","State":"FL","Gas":242,"coordinates":[-84.2007,30.1623]},{"Plant":"Vero Beach Municipal Power Plant","State":"FL","Gas":117,"coordinates":[-80.3776,27.6334]},{"Plant":"Gravel Neck","State":"VA","Gas":340,"coordinates":[-76.6911,37.1575]},{"Plant":"McIntosh","State":"AL","Gas":688,"coordinates":[-88.0299,31.2546]},{"Plant":"Harry Allen","State":"NV","Gas":654,"coordinates":[-114.9024,36.4306]},{"Plant":"Jack McDonough","State":"GA","Gas":2578,"coordinates":[-84.4758,33.8239]},{"Plant":"Pleasant Hill","State":"IA","Gas":160,"coordinates":[-93.5242,41.5572]},{"Plant":"Hay Road","State":"DE","Gas":1136,"coordinates":[-75.5072,39.7436]},{"Plant":"Woodsdale","State":"OH","Gas":462,"coordinates":[-84.4611,39.4492]},{"Plant":"Concord","State":"WI","Gas":352,"coordinates":[-88.69,43.1669]},{"Plant":"South Fond Du Lac","State":"WI","Gas":305.3,"coordinates":[-88.4967,43.7353]},{"Plant":"Darbytown","State":"VA","Gas":336,"coordinates":[-77.3685,37.4982]},{"Plant":"Angus Anson","State":"SD","Gas":327,"coordinates":[-96.6356,43.6035]},{"Plant":"Cane Island","State":"FL","Gas":411,"coordinates":[-81.533,28.2764]},{"Plant":"Polk","State":"FL","Gas":604,"coordinates":[-81.9897,27.7286]},{"Plant":"Woodland","State":"CA","Gas":182.2,"coordinates":[-121.0204,37.6526]},{"Plant":"491 E 48th Street","State":"MI","Gas":136,"coordinates":[-86.0853,42.7553]},{"Plant":"Paris","State":"WI","Gas":352,"coordinates":[-88.0131,42.6658]},{"Plant":"Lincoln Combustion","State":"NC","Gas":1267.2,"coordinates":[-81.0347,35.4317]},{"Plant":"State Line Combined Cycle","State":"MO","Gas":589,"coordinates":[-94.614,37.0659]},{"Plant":"Hines Energy Complex","State":"FL","Gas":1912,"coordinates":[-81.87,27.7882]},{"Plant":"Redding Power","State":"CA","Gas":171,"coordinates":[-122.4233,40.5073]},{"Plant":"Richard M Flynn","State":"NY","Gas":134.4,"coordinates":[-73.064,40.8158]},{"Plant":"Almond Power Plant","State":"CA","Gas":199.5,"coordinates":[-120.985,37.5744]},{"Plant":"San Jacinto Steam Electric Station","State":"TX","Gas":162,"coordinates":[-95.0406,29.6948]},{"Plant":"Kraft","State":"GA","Gas":132,"coordinates":[-81.1458,32.1486]},{"Plant":"Anderson","State":"IN","Gas":140,"coordinates":[-85.7389,40.0529]},{"Plant":"Robins","State":"GA","Gas":160,"coordinates":[-83.5822,32.5792]},{"Plant":"Coyote Springs","State":"OR","Gas":235,"coordinates":[-119.6739,45.848]},{"Plant":"Midulla Generating Station","State":"FL","Gas":751,"coordinates":[-81.9625,27.6417]},{"Plant":"Interstate","State":"IL","Gas":112,"coordinates":[-89.5891,39.8233]},{"Plant":"Rathdrum","State":"ID","Gas":132,"coordinates":[-116.8673,47.8043]},{"Plant":"Arthur Von Rosenberg","State":"TX","Gas":530,"coordinates":[-98.384,29.257]},{"Plant":"Carson Ice-Gen Project","State":"CA","Gas":109,"coordinates":[-121.4624,38.4457]},{"Plant":"Wayne County","State":"NC","Gas":863,"coordinates":[-78.0981,35.3758]},{"Plant":"Ponca City","State":"OK","Gas":106.8,"coordinates":[-97.0858,36.7198]},{"Plant":"SCA Cogen 2","State":"CA","Gas":176.6,"coordinates":[-121.4001,38.5309]},{"Plant":"SPA Cogen 3","State":"CA","Gas":164,"coordinates":[-121.4735,38.511]},{"Plant":"St Francis Energy Facility","State":"MO","Gas":464,"coordinates":[-90.1779,36.5852]},{"Plant":"River Road Gen Plant","State":"WA","Gas":220,"coordinates":[-122.7256,45.6497]},{"Plant":"Tiger Bay","State":"FL","Gas":205,"coordinates":[-81.8494,27.7464]},{"Plant":"Dahlberg","State":"GA","Gas":747.3,"coordinates":[-83.3977,34.0423]},{"Plant":"H Allen Franklin Combined Cycle","State":"AL","Gas":1815,"coordinates":[-85.0975,32.6078]},{"Plant":"Theodore Cogen Facility","State":"AL","Gas":224.7,"coordinates":[-88.1285,30.5254]},{"Plant":"Nodaway","State":"MO","Gas":186,"coordinates":[-94.7913,40.2877]},{"Plant":"Chouteau","State":"OK","Gas":799,"coordinates":[-95.2771,36.2221]},{"Plant":"Georgetown","State":"IN","Gas":276,"coordinates":[-86.2441,39.9026]},{"Plant":"Tilton","State":"IL","Gas":176,"coordinates":[-87.6538,40.1061]},{"Plant":"Henry County","State":"IN","Gas":129,"coordinates":[-85.5039,39.9528]},{"Plant":"MPC Generating","State":"GA","Gas":302.5,"coordinates":[-83.6953,33.8119]},{"Plant":"Sherwood H Smith Jr Energy Complex","State":"NC","Gas":1868,"coordinates":[-79.7406,34.8392]},{"Plant":"Sewell Creek Energy","State":"GA","Gas":437.9,"coordinates":[-85.2769,33.9486]},{"Plant":"Alsey","State":"IL","Gas":121,"coordinates":[-90.436,39.5698]},{"Plant":"Fulton","State":"AR","Gas":153,"coordinates":[-93.7924,33.6094]},{"Plant":"Rowan","State":"NC","Gas":924.6,"coordinates":[-80.6019,35.7314]},{"Plant":"Smarr Energy Center","State":"GA","Gas":187.4,"coordinates":[-83.8464,32.9842]},{"Plant":"John S Rainey","State":"SC","Gas":977,"coordinates":[-82.776,34.3477]},{"Plant":"Essential Power Rock Springs LLC","State":"MD","Gas":653.5,"coordinates":[-76.1598,39.719]},{"Plant":"Marsh Run Generating","State":"VA","Gas":481.1,"coordinates":[-77.7681,38.5283]},{"Plant":"Louisa Generating","State":"VA","Gas":466,"coordinates":[-78.2139,38.1181]},{"Plant":"Remington","State":"VA","Gas":608,"coordinates":[-77.7714,38.5442]},{"Plant":"Ladysmith","State":"VA","Gas":783,"coordinates":[-77.5133,38.0722]},{"Plant":"Pleasant Valley","State":"MN","Gas":430,"coordinates":[-92.6829,43.7994]},{"Plant":"Lagoon Creek","State":"TN","Gas":1407,"coordinates":[-89.3964,35.6578]},{"Plant":"Brandy Branch","State":"FL","Gas":660.8,"coordinates":[-81.9472,30.3206]},{"Plant":"Holden","State":"MO","Gas":210,"coordinates":[-93.9983,38.7538]},{"Plant":"MEPI GT Facility","State":"IL","Gas":239,"coordinates":[-88.8661,37.2175]},{"Plant":"Encogen","State":"WA","Gas":103.5,"coordinates":[-122.486,48.746]},{"Plant":"Robert P Mone Plant","State":"OH","Gas":435,"coordinates":[-84.7392,40.9297]},{"Plant":"H L Culbreath Bayside Power Station","State":"FL","Gas":1854,"coordinates":[-82.4231,27.9072]},{"Plant":"Terry Bundy Generating Station","State":"NE","Gas":174.4,"coordinates":[-96.6131,40.9097]},{"Plant":"E B Harris Electric Generating Plant","State":"AL","Gas":1268.7,"coordinates":[-86.5744,32.3814]},{"Plant":"Sand Hill","State":"TX","Gas":595.8,"coordinates":[-97.6129,30.2098]},{"Plant":"Talbot County Energy","State":"GA","Gas":576.6,"coordinates":[-84.6917,32.5892]},{"Plant":"Chattahoochee Energy Facility","State":"GA","Gas":449.9,"coordinates":[-85.0386,33.4072]},{"Plant":"Lakefield Junction","State":"MN","Gas":515.6,"coordinates":[-94.8415,43.7984]},{"Plant":"West Gardner","State":"KS","Gas":311.1,"coordinates":[-94.9861,38.7875]},{"Plant":"Coyote Springs II","State":"OR","Gas":242.7,"coordinates":[-119.674,45.848]},{"Plant":"Wansley Unit 9","State":"GA","Gas":496,"coordinates":[-85.0403,33.4083]},{"Plant":"Lawrence County Station","State":"IN","Gas":264.1,"coordinates":[-86.4511,38.8003]},{"Plant":"Evander Andrews Power Complex","State":"ID","Gas":261.5,"coordinates":[-115.7343,43.1792]},{"Plant":"Kemper County","State":"MS","Gas":293.2,"coordinates":[-88.606,32.7976]},{"Plant":"Peno Creek","State":"MO","Gas":188,"coordinates":[-91.2295,39.3531]},{"Plant":"Sumpter","State":"MI","Gas":308.4,"coordinates":[-83.5318,42.167]},{"Plant":"Pyramid","State":"NM","Gas":158,"coordinates":[-108.5494,32.2363]},{"Plant":"Mill Creek","State":"SC","Gas":595.2,"coordinates":[-81.4306,35.1597]},{"Plant":"Greater Des Moines","State":"IA","Gas":492.6,"coordinates":[-93.5283,41.5563]},{"Plant":"Silver Creek","State":"MS","Gas":225,"coordinates":[-89.9468,31.6004]},{"Plant":"Sylvarena","State":"MS","Gas":129,"coordinates":[-89.4127,31.9821]},{"Plant":"West Campus Cogeneration Facility","State":"WI","Gas":127.1,"coordinates":[-89.4251,43.0751]},{"Plant":"Grays Harbor Energy Facility","State":"WA","Gas":637,"coordinates":[-123.48,46.9692]},{"Plant":"Beatrice","State":"NE","Gas":220,"coordinates":[-96.8082,40.3302]},{"Plant":"Roseton Generating Facility","State":"NY","Gas":1208,"coordinates":[-73.9663,41.5738]},{"Plant":"Blue Lake","State":"MN","Gas":300,"coordinates":[-93.4315,44.7855]},{"Plant":"Sycamore","State":"IA","Gas":148.5,"coordinates":[-93.6769,41.6722]},{"Plant":"Emery Station","State":"IA","Gas":515,"coordinates":[-93.2922,43.094]},{"Plant":"Anclote","State":"FL","Gas":1041,"coordinates":[-82.7886,28.1844]},{"Plant":"Intercession City","State":"FL","Gas":555,"coordinates":[-81.5486,28.2628]},{"Plant":"Gerald Andrus","State":"MS","Gas":672.6,"coordinates":[-91.1167,33.35]},{"Plant":"Waterford 1 & 2","State":"LA","Gas":795.8,"coordinates":[-90.4768,29.9989]},{"Plant":"Comanche","State":"OK","Gas":260,"coordinates":[-98.3244,34.5431]},{"Plant":"DeCordova Steam Electric Station","State":"TX","Gas":278,"coordinates":[-97.7006,32.4031]},{"Plant":"Santan","State":"AZ","Gas":1227,"coordinates":[-111.7503,33.3325]},{"Plant":"Beaver","State":"OR","Gas":487,"coordinates":[-123.1739,46.1724]},{"Plant":"Glen Gardner","State":"NJ","Gas":144,"coordinates":[-74.9207,40.6815]},{"Plant":"Grand Tower","State":"IL","Gas":511,"coordinates":[-89.5112,37.6577]},{"Plant":"Astoria Generating Station","State":"NY","Gas":1333.4,"coordinates":[-73.9126,40.7877]},{"Plant":"Venice","State":"IL","Gas":487,"coordinates":[-90.1764,38.6642]},{"Plant":"Beluga","State":"AK","Gas":344.4,"coordinates":[-151.0356,61.1861]},{"Plant":"Marion","State":"IL","Gas":140,"coordinates":[-88.9531,37.6197]},{"Plant":"Frederickson","State":"WA","Gas":134,"coordinates":[-122.365,47.0797]},{"Plant":"Harding Street","State":"IN","Gas":288,"coordinates":[-86.1969,39.7113]}]

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Gas":740,"coordinates":[-87.7811,32.6017]},{"Plant":"NRG Energy Center Dover","State":"DE","Gas":104,"coordinates":[-75.5473,39.1495]},{"Plant":"Gilroy Power Plant","State":"CA","Gas":115,"coordinates":[-121.5367,37.0001]},{"Plant":"Noblesville","State":"IN","Gas":285.2,"coordinates":[-85.9714,40.0969]},{"Plant":"Pedricktown Cogeneration Company LP","State":"NJ","Gas":117.3,"coordinates":[-75.4238,39.7668]},{"Plant":"Broadway","State":"IN","Gas":115,"coordinates":[-87.6049,37.9691]},{"Plant":"Butler-Warner Generation Plant","State":"NC","Gas":225,"coordinates":[-78.8294,35.0986]},{"Plant":"El Segundo Cogen","State":"CA","Gas":171.6,"coordinates":[-118.4031,33.9058]},{"Plant":"ArcelorMittal Burns Harbor","State":"IN","Gas":174.7,"coordinates":[-87.1387,41.635]},{"Plant":"King City Power Plant","State":"CA","Gas":111,"coordinates":[-121.1278,36.225]},{"Plant":"Bayou Cogen Plant","State":"TX","Gas":290,"coordinates":[-95.0458,29.6225]},{"Plant":"Bellingham Cogeneration Facility","State":"MA","Gas":264,"coordinates":[-71.4833,42.0925]},{"Plant":"Sayreville Cogeneration Facility","State":"NJ","Gas":292,"coordinates":[-74.3444,40.439]},{"Plant":"Foster Wheeler Martinez","State":"CA","Gas":103.5,"coordinates":[-122.0589,38.0244]},{"Plant":"ExxonMobil Baytown Refinery","State":"TX","Gas":134,"coordinates":[-94.9973,29.7535]},{"Plant":"Kern River Cogeneration","State":"CA","Gas":288,"coordinates":[-118.9849,35.4515]},{"Plant":"Formosa Utility Venture Ltd","State":"TX","Gas":597.3,"coordinates":[-96.5417,28.6917]},{"Plant":"Hopewell Cogeneration","State":"VA","Gas":348.3,"coordinates":[-77.2811,37.2917]},{"Plant":"Brush Generation Facility","State":"CO","Gas":292,"coordinates":[-103.631,40.2415]},{"Plant":"ExxonMobil Baytown Turbine","State":"TX","Gas":297,"coordinates":[-95.0096,29.7591]},{"Plant":"Selkirk Cogen","State":"NY","Gas":355.9,"coordinates":[-73.8592,42.5744]},{"Plant":"Masspower","State":"MA","Gas":245,"coordinates":[-72.5225,42.1575]},{"Plant":"Clear Lake Cogeneration Ltd","State":"TX","Gas":362.4,"coordinates":[-95.067,29.6255]},{"Plant":"Midland Cogeneration Venture","State":"MI","Gas":1859.4,"coordinates":[-84.2242,43.5861]},{"Plant":"Camden Plant Holding LLC","State":"NJ","Gas":145,"coordinates":[-75.1192,39.9175]},{"Plant":"Las Vegas Cogeneration LP","State":"NV","Gas":282,"coordinates":[-115.1222,36.2319]},{"Plant":"Sutherland","State":"IA","Gas":108.7,"coordinates":[-92.8594,42.0473]},{"Plant":"Sabine River Works","State":"TX","Gas":507,"coordinates":[-93.7579,30.0552]},{"Plant":"Riverside","State":"IA","Gas":125,"coordinates":[-90.4481,41.54]},{"Plant":"River Hills","State":"IA","Gas":116.9,"coordinates":[-93.6195,41.5902]},{"Plant":"Hazelton","State":"PA","Gas":145.6,"coordinates":[-76.0409,40.9282]},{"Plant":"Ocotillo","State":"AZ","Gas":320,"coordinates":[-111.9122,33.4225]},{"Plant":"West Phoenix","State":"AZ","Gas":932,"coordinates":[-112.1583,33.4417]},{"Plant":"Saguaro","State":"AZ","Gas":176,"coordinates":[-111.3,32.5517]},{"Plant":"Yucca","State":"AZ","Gas":257,"coordinates":[-114.7106,32.7214]},{"Plant":"Earl F Wisdom","State":"IA","Gas":113.5,"coordinates":[-95.2569,43.1606]},{"Plant":"Fort Dodge","State":"KS","Gas":147.8,"coordinates":[-99.9497,37.7328]},{"Plant":"Riverton","State":"KS","Gas":177,"coordinates":[-94.6987,37.0726]},{"Plant":"Gordon Evans Energy Center","State":"KS","Gas":814,"coordinates":[-97.5217,37.7903]},{"Plant":"Murray Gill","State":"KS","Gas":183,"coordinates":[-97.4136,37.5967]},{"Plant":"Hutchinson Energy Center","State":"KS","Gas":165,"coordinates":[-97.8747,38.0906]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Gas":314,"coordinates":[-110.9047,32.16]},{"Plant":"Kaw","State":"KS","Gas":140.3,"coordinates":[-94.6514,39.0867]},{"Plant":"Quindaro","State":"KS","Gas":170,"coordinates":[-94.6381,39.1492]},{"Plant":"McPherson 2","State":"KS","Gas":104,"coordinates":[-97.6834,38.3634]},{"Plant":"Garden City","State":"KS","Gas":207.3,"coordinates":[-100.8956,37.9703]},{"Plant":"E W Brown","State":"KY","Gas":906,"coordinates":[-84.7126,37.7883]},{"Plant":"Cane Run","State":"KY","Gas":677.3,"coordinates":[-85.8892,38.1831]},{"Plant":"Paddys Run","State":"KY","Gas":182,"coordinates":[-85.8417,38.2236]},{"Plant":"Louisiana 1","State":"LA","Gas":382.4,"coordinates":[-91.1864,30.4922]},{"Plant":"Louisiana 2","State":"LA","Gas":138,"coordinates":[-91.1864,30.4922]},{"Plant":"R S Nelson","State":"LA","Gas":570.7,"coordinates":[-93.2911,30.2844]},{"Plant":"Willow Glen","State":"LA","Gas":1749,"coordinates":[-91.1164,30.2743]},{"Plant":"Coughlin Power Station","State":"LA","Gas":723.1,"coordinates":[-92.2611,30.8439]},{"Plant":"Teche","State":"LA","Gas":377.5,"coordinates":[-91.5425,29.8222]},{"Plant":"Little Gypsy","State":"LA","Gas":930.4,"coordinates":[-90.4617,30.0051]},{"Plant":"Nine Mile Point","State":"LA","Gas":2056,"coordinates":[-90.1458,29.9472]},{"Plant":"Sterlington","State":"LA","Gas":104.6,"coordinates":[-92.0792,32.7047]},{"Plant":"Michoud","State":"LA","Gas":785.4,"coordinates":[-89.9372,30.0081]},{"Plant":"Agua Fria","State":"AZ","Gas":626,"coordinates":[-112.2153,33.5561]},{"Plant":"Arsenal Hill","State":"LA","Gas":116,"coordinates":[-93.7611,32.5181]},{"Plant":"Lieberman","State":"LA","Gas":243,"coordinates":[-93.9597,32.7047]},{"Plant":"Louis Doc Bonin","State":"LA","Gas":256,"coordinates":[-92.0463,30.238]},{"Plant":"Big Cajun 1","State":"LA","Gas":430,"coordinates":[-91.3556,30.6739]},{"Plant":"Kyrene","State":"AZ","Gas":525,"coordinates":[-111.9353,33.3556]},{"Plant":"Herbert A Wagner","State":"MD","Gas":126,"coordinates":[-76.5268,39.1781]},{"Plant":"Notch Cliff","State":"MD","Gas":116.7,"coordinates":[-76.5087,39.4217]},{"Plant":"Perryman","State":"MD","Gas":257.4,"coordinates":[-76.2218,39.4428]},{"Plant":"Westport","State":"MD","Gas":115.8,"coordinates":[-76.6295,39.266]},{"Plant":"Chalk Point LLC","State":"MD","Gas":1164,"coordinates":[-76.6861,38.5444]},{"Plant":"Dickerson","State":"MD","Gas":294,"coordinates":[-77.4644,39.2097]},{"Plant":"Mystic Generating Station","State":"MA","Gas":1417.3,"coordinates":[-71.0675,42.3908]},{"Plant":"Kendall Square Station","State":"MA","Gas":214.7,"coordinates":[-71.0792,42.3633]},{"Plant":"Apache Station","State":"AZ","Gas":198.5,"coordinates":[-109.8931,32.0603]},{"Plant":"Essential Power Massachusetts LLC","State":"MA","Gas":168.6,"coordinates":[-72.595,42.095]},{"Plant":"Potter Station 2","State":"MA","Gas":183.3,"coordinates":[-70.9672,42.235]},{"Plant":"Lake Catherine","State":"AR","Gas":522.3,"coordinates":[-92.9049,34.4341]},{"Plant":"Dan E Karn","State":"MI","Gas":1151,"coordinates":[-83.8401,43.645]},{"Plant":"Delray","State":"MI","Gas":127,"coordinates":[-83.1019,42.2947]},{"Plant":"Hancock","State":"MI","Gas":139,"coordinates":[-83.4425,42.5497]},{"Plant":"River Rouge","State":"MI","Gas":206,"coordinates":[-83.1119,42.2739]},{"Plant":"Black Dog","State":"MN","Gas":282,"coordinates":[-93.2501,44.8108]},{"Plant":"High Bridge","State":"MN","Gas":538,"coordinates":[-93.1117,44.9314]},{"Plant":"Inver Hills","State":"MN","Gas":282,"coordinates":[-93.042,44.781]},{"Plant":"Riverside","State":"MN","Gas":470,"coordinates":[-93.2753,45.0203]},{"Plant":"Thomas Fitzhugh","State":"AR","Gas":162,"coordinates":[-93.8049,35.4624]},{"Plant":"Carl Bailey","State":"AR","Gas":122,"coordinates":[-91.3634,35.2601]},{"Plant":"McClellan","State":"AR","Gas":134,"coordinates":[-92.7917,33.5648]},{"Plant":"Cambridge CT","State":"MN","Gas":160,"coordinates":[-93.2081,45.601]},{"Plant":"Elk River","State":"MN","Gas":189.7,"coordinates":[-93.5584,45.2968]},{"Plant":"Chevron Oil","State":"MS","Gas":132,"coordinates":[-88.4919,30.34]},{"Plant":"Sweatt","State":"MS","Gas":124,"coordinates":[-88.7461,32.2925]},{"Plant":"Jack Watson","State":"MS","Gas":856,"coordinates":[-89.0286,30.4392]},{"Plant":"Baxter Wilson","State":"MS","Gas":1231.3,"coordinates":[-90.9306,32.2831]},{"Plant":"Rex Brown","State":"MS","Gas":243.7,"coordinates":[-90.213,32.357]},{"Plant":"Moselle","State":"MS","Gas":477,"coordinates":[-89.3004,31.528]},{"Plant":"Hawthorn","State":"MO","Gas":391.7,"coordinates":[-94.4778,39.1306]},{"Plant":"Lake Road","State":"MO","Gas":117.9,"coordinates":[-94.8773,39.7246]},{"Plant":"James River Power Station","State":"MO","Gas":155,"coordinates":[-93.2619,37.1086]},{"Plant":"Canaday","State":"NE","Gas":115,"coordinates":[-99.7011,40.6942]},{"Plant":"C W Burdick","State":"NE","Gas":174.1,"coordinates":[-98.3269,40.9228]},{"Plant":"Sarpy County","State":"NE","Gas":315.6,"coordinates":[-95.9706,41.1706]},{"Plant":"Clark","State":"NV","Gas":1141,"coordinates":[-115.0507,36.0875]},{"Plant":"Fort Churchill","State":"NV","Gas":226,"coordinates":[-119.1322,39.1281]},{"Plant":"Tracy","State":"NV","Gas":897.6,"coordinates":[-119.525,39.5625]},{"Plant":"Sayreville","State":"NJ","Gas":150,"coordinates":[-74.3523,40.4765]},{"Plant":"Gilbert","State":"NJ","Gas":444,"coordinates":[-75.1639,40.5658]},{"Plant":"Bergen Generating Station","State":"NJ","Gas":1193,"coordinates":[-74.0244,40.8375]},{"Plant":"PSEG Burlington Generating Station","State":"NJ","Gas":168,"coordinates":[-74.8792,40.0766]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Gas":620,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Kearny Generating Station","State":"NJ","Gas":445,"coordinates":[-74.0965,40.7373]},{"Plant":"PSEG Linden Generating Station","State":"NJ","Gas":1601.6,"coordinates":[-74.2072,40.6217]},{"Plant":"PSEG Sewaren Generating Station","State":"NJ","Gas":450.6,"coordinates":[-74.2469,40.5558]},{"Plant":"Rio Grande","State":"NM","Gas":324.2,"coordinates":[-106.5472,31.8047]},{"Plant":"Maddox","State":"NM","Gas":183,"coordinates":[-103.3015,32.7142]},{"Plant":"Reeves","State":"NM","Gas":154,"coordinates":[-106.6019,35.171]},{"Plant":"Cunningham","State":"NM","Gas":466,"coordinates":[-103.3533,32.7131]},{"Plant":"Humboldt Bay","State":"CA","Gas":163.4,"coordinates":[-124.2103,40.7415]},{"Plant":"Danskammer Generating Station","State":"NY","Gas":478.7,"coordinates":[-73.975,41.5712]},{"Plant":"Arthur Kill Generating Station","State":"NY","Gas":858,"coordinates":[-74.2,40.5916]},{"Plant":"East River","State":"NY","Gas":629.3,"coordinates":[-73.9742,40.7281]},{"Plant":"Gowanus Gas Turbines Generating","State":"NY","Gas":280.1,"coordinates":[-74.0051,40.6635]},{"Plant":"Narrows Gas Turbines Generating","State":"NY","Gas":283.4,"coordinates":[-74.0208,40.6486]},{"Plant":"Ravenswood","State":"NY","Gas":2246.4,"coordinates":[-73.9461,40.7592]},{"Plant":"E F Barrett","State":"NY","Gas":668.2,"coordinates":[-73.6479,40.6167]},{"Plant":"Northport","State":"NY","Gas":1580.7,"coordinates":[-73.3423,40.9236]},{"Plant":"Port Jefferson","State":"NY","Gas":461.4,"coordinates":[-73.0785,40.9497]},{"Plant":"Bethlehem Energy Center","State":"NY","Gas":756.8,"coordinates":[-73.7638,42.5942]},{"Plant":"E C Gaston","State":"AL","Gas":256,"coordinates":[-86.4581,33.2442]},{"Plant":"Dynegy Moss Landing Power Plant","State":"CA","Gas":2529,"coordinates":[-121.7822,36.8048]},{"Plant":"Bowline Point","State":"NY","Gas":1137,"coordinates":[-73.9689,41.2044]},{"Plant":"Asheville","State":"NC","Gas":324,"coordinates":[-82.5417,35.4731]},{"Plant":"Pittsburg Power","State":"CA","Gas":1311,"coordinates":[-121.8945,38.0392]},{"Plant":"Buck","State":"NC","Gas":668.2,"coordinates":[-80.3767,35.7133]},{"Plant":"Dan River","State":"NC","Gas":651,"coordinates":[-79.7208,36.4862]},{"Plant":"Dicks Creek","State":"OH","Gas":106.2,"coordinates":[-84.3778,39.465]},{"Plant":"Frank M Tait","State":"OH","Gas":256,"coordinates":[-84.2111,39.7272]},{"Plant":"Yankee Street","State":"OH","Gas":101.3,"coordinates":[-84.2047,39.603]},{"Plant":"FirstEnergy West Lorain","State":"OH","Gas":425,"coordinates":[-82.2644,41.4294]},{"Plant":"Richland","State":"OH","Gas":358,"coordinates":[-84.3346,41.3052]},{"Plant":"Hamilton","State":"OH","Gas":123,"coordinates":[-84.5543,39.4098]},{"Plant":"Horseshoe Lake","State":"OK","Gas":889.5,"coordinates":[-97.1797,35.5087]},{"Plant":"Mustang","State":"OK","Gas":439,"coordinates":[-97.675,35.4699]},{"Plant":"Seminole","State":"OK","Gas":1437.5,"coordinates":[-96.7258,34.9665]},{"Plant":"Northeastern","State":"OK","Gas":906,"coordinates":[-95.7008,36.4317]},{"Plant":"Southwestern","State":"OK","Gas":603,"coordinates":[-98.3524,35.1009]},{"Plant":"Tulsa","State":"OK","Gas":305,"coordinates":[-95.991,36.1165]},{"Plant":"Weleetka","State":"OK","Gas":163,"coordinates":[-96.1352,35.3233]},{"Plant":"Barry","State":"AL","Gas":1072,"coordinates":[-88.0103,31.0069]},{"Plant":"Anadarko Plant","State":"OK","Gas":485,"coordinates":[-98.23,35.0847]},{"Plant":"Mooreland","State":"OK","Gas":322,"coordinates":[-99.2254,36.4372]},{"Plant":"Encina","State":"CA","Gas":964,"coordinates":[-117.3364,33.1361]},{"Plant":"Brunot Island","State":"PA","Gas":244,"coordinates":[-80.0438,40.4649]},{"Plant":"PPL Martins Creek","State":"PA","Gas":1772,"coordinates":[-75.1054,40.7978]},{"Plant":"AES Alamitos LLC","State":"CA","Gas":1997,"coordinates":[-118.1009,33.7688]},{"Plant":"Eddystone Generating Station","State":"PA","Gas":760,"coordinates":[-75.323,39.858]},{"Plant":"Hunlock Power Station","State":"PA","Gas":127.2,"coordinates":[-76.07,41.2006]},{"Plant":"Manchester Street","State":"RI","Gas":475.5,"coordinates":[-71.4042,41.8167]},{"Plant":"Darlington County","State":"SC","Gas":441,"coordinates":[-80.1657,34.4185]},{"Plant":"W S Lee","State":"SC","Gas":252,"coordinates":[-82.435,34.6022]},{"Plant":"Hagood","State":"SC","Gas":126,"coordinates":[-79.9634,32.8265]},{"Plant":"Urquhart","State":"SC","Gas":640,"coordinates":[-81.9111,33.435]},{"Plant":"Etiwanda Generating Station","State":"CA","Gas":640,"coordinates":[-117.5266,34.0912]},{"Plant":"AES Huntington Beach LLC","State":"CA","Gas":451.6,"coordinates":[-117.9792,33.6439]},{"Plant":"Allen Steam Plant","State":"TN","Gas":427.2,"coordinates":[-90.1487,35.0741]},{"Plant":"Gallatin","State":"TN","Gas":579.6,"coordinates":[-86.4006,36.3156]},{"Plant":"John Sevier","State":"TN","Gas":878,"coordinates":[-82.9639,36.3767]},{"Plant":"Johnsonville","State":"TN","Gas":1044.8,"coordinates":[-87.9861,36.0278]},{"Plant":"Long Beach Generation LLC","State":"CA","Gas":260,"coordinates":[-118.2248,33.7641]},{"Plant":"Laredo","State":"TX","Gas":177.4,"coordinates":[-99.5089,27.5667]},{"Plant":"Nueces Bay","State":"TX","Gas":633,"coordinates":[-97.4192,27.8194]},{"Plant":"Victoria","State":"TX","Gas":285,"coordinates":[-97.01,28.7883]},{"Plant":"Mandalay","State":"CA","Gas":560,"coordinates":[-119.2511,34.2067]},{"Plant":"Lake Hubbard","State":"TX","Gas":915,"coordinates":[-96.5458,32.8358]},{"Plant":"Mountain Creek","State":"TX","Gas":808,"coordinates":[-96.9358,32.7231]},{"Plant":"Newman","State":"TX","Gas":760.9,"coordinates":[-106.4318,31.9836]},{"Plant":"Lewis Creek","State":"TX","Gas":508.1,"coordinates":[-95.5214,30.4356]},{"Plant":"Sabine","State":"TX","Gas":1763.8,"coordinates":[-93.878,30.0242]},{"Plant":"Cedar Bayou","State":"TX","Gas":1495,"coordinates":[-94.9256,29.75]},{"Plant":"Greens Bayou","State":"TX","Gas":760,"coordinates":[-95.2194,29.8222]},{"Plant":"Sam Bertron","State":"TX","Gas":765,"coordinates":[-95.0598,29.7268]},{"Plant":"T H Wharton","State":"TX","Gas":1025,"coordinates":[-95.5306,29.9417]},{"Plant":"W A Parish","State":"TX","Gas":1176,"coordinates":[-95.6311,29.4828]},{"Plant":"Knox Lee","State":"TX","Gas":471,"coordinates":[-94.6415,32.3766]},{"Plant":"Wilkes","State":"TX","Gas":883,"coordinates":[-94.548,32.8482]},{"Plant":"Jones","State":"TX","Gas":824,"coordinates":[-101.7392,33.5239]},{"Plant":"Nichols","State":"TX","Gas":457,"coordinates":[-101.7464,35.2834]},{"Plant":"Plant X","State":"TX","Gas":411,"coordinates":[-102.4114,34.1661]},{"Plant":"Graham","State":"TX","Gas":624,"coordinates":[-98.6117,33.1344]},{"Plant":"Handley","State":"TX","Gas":1265,"coordinates":[-97.2192,32.7283]},{"Plant":"Morgan Creek","State":"TX","Gas":407,"coordinates":[-100.9156,32.3358]},{"Plant":"Permian Basin","State":"TX","Gas":967,"coordinates":[-102.9633,31.5839]},{"Plant":"Ormond Beach","State":"CA","Gas":1516,"coordinates":[-119.1689,34.1292]},{"Plant":"Stryker Creek","State":"TX","Gas":669,"coordinates":[-94.9898,31.9398]},{"Plant":"Trinidad","State":"TX","Gas":235,"coordinates":[-96.1013,32.1245]},{"Plant":"Decker Creek","State":"TX","Gas":932,"coordinates":[-97.6128,30.3033]},{"Plant":"Silas Ray","State":"TX","Gas":125,"coordinates":[-97.5214,25.9131]},{"Plant":"AES Redondo Beach LLC","State":"CA","Gas":1310,"coordinates":[-118.395,33.8504]},{"Plant":"Ray Olinger","State":"TX","Gas":395,"coordinates":[-96.4525,33.0681]},{"Plant":"Mountainview Generating Station","State":"CA","Gas":972,"coordinates":[-117.2418,34.0818]},{"Plant":"Sim Gideon","State":"TX","Gas":607,"coordinates":[-97.2708,30.1456]},{"Plant":"Ty Cooke","State":"TX","Gas":120,"coordinates":[-101.7906,33.5211]},{"Plant":"Leon Creek","State":"TX","Gas":184,"coordinates":[-98.5761,29.3525]},{"Plant":"O W Sommers","State":"TX","Gas":830,"coordinates":[-98.3242,29.3081]},{"Plant":"V H Braunig","State":"TX","Gas":1055,"coordinates":[-98.3825,29.2567]},{"Plant":"R W Miller","State":"TX","Gas":574,"coordinates":[-98.3103,32.6581]},{"Plant":"Pearsall","State":"TX","Gas":270.6,"coordinates":[-99.0919,28.9275]},{"Plant":"Sam Rayburn","State":"TX","Gas":205,"coordinates":[-97.135,28.8947]},{"Plant":"Gadsby","State":"UT","Gas":354.5,"coordinates":[-111.9289,40.7686]},{"Plant":"Grayson","State":"CA","Gas":256,"coordinates":[-118.2782,34.1556]},{"Plant":"Bremo Bluff","State":"VA","Gas":227,"coordinates":[-78.2878,37.7089]},{"Plant":"Chesterfield","State":"VA","Gas":397,"coordinates":[-77.3833,37.3822]},{"Plant":"Possum Point","State":"VA","Gas":875,"coordinates":[-77.2806,38.5367]},{"Plant":"El Centro","State":"CA","Gas":314,"coordinates":[-115.54,32.8022]},{"Plant":"Harbor","State":"CA","Gas":461,"coordinates":[-118.2656,33.7706]},{"Plant":"Blount Street","State":"WI","Gas":103.5,"coordinates":[-89.3744,43.0789]},{"Plant":"Haynes","State":"CA","Gas":1571.8,"coordinates":[-118.0991,33.7647]},{"Plant":"Wheaton","State":"WI","Gas":190,"coordinates":[-91.5158,44.8854]},{"Plant":"Scattergood","State":"CA","Gas":351,"coordinates":[-118.4276,33.9182]},{"Plant":"Port Washington Generating Station","State":"WI","Gas":1081.6,"coordinates":[-87.8689,43.3842]},{"Plant":"Valley","State":"WI","Gas":120,"coordinates":[-87.9233,43.0303]},{"Plant":"Rock River","State":"WI","Gas":127.9,"coordinates":[-89.0276,42.582]},{"Plant":"West Marinette","State":"WI","Gas":152.8,"coordinates":[-87.6881,45.0869]},{"Plant":"Valley","State":"CA","Gas":556,"coordinates":[-118.3913,34.245]},{"Plant":"Powerlane Plant","State":"TX","Gas":111,"coordinates":[-96.1264,33.1707]},{"Plant":"Glenarm","State":"CA","Gas":151.6,"coordinates":[-118.1494,34.126]},{"Plant":"Spencer","State":"TX","Gas":122,"coordinates":[-97.1061,33.1975]},{"Plant":"Cherokee","State":"CO","Gas":576,"coordinates":[-104.9645,39.8073]},{"Plant":"Colbert","State":"AL","Gas":363.2,"coordinates":[-87.8486,34.7439]},{"Plant":"Thomas C Ferguson","State":"TX","Gas":516,"coordinates":[-98.3705,30.558]},{"Plant":"Barney M Davis","State":"TX","Gas":963,"coordinates":[-97.3117,27.6064]},{"Plant":"Riverside","State":"OK","Gas":1067,"coordinates":[-95.9567,35.9978]},{"Plant":"Pittsfield Generating LP","State":"MA","Gas":151.4,"coordinates":[-73.2181,42.4564]},{"Plant":"Linden Cogen Plant","State":"NJ","Gas":906.8,"coordinates":[-74.2156,40.6322]},{"Plant":"Houston Chemical Complex Battleground","State":"TX","Gas":263,"coordinates":[-95.0839,29.7314]},{"Plant":"Paris Energy Center","State":"TX","Gas":236,"coordinates":[-95.5577,33.6968]},{"Plant":"Hal C Weaver Power Plant","State":"TX","Gas":146.8,"coordinates":[-97.7356,30.2867]},{"Plant":"Sycamore Cogeneration","State":"CA","Gas":300,"coordinates":[-118.9853,35.4526]},{"Plant":"Union Carbide Seadrift Cogen","State":"TX","Gas":168,"coordinates":[-96.7706,28.5105]},{"Plant":"Dow St Charles Operations","State":"LA","Gas":270,"coordinates":[-90.4414,29.9861]},{"Plant":"Watson Cogeneration","State":"CA","Gas":398,"coordinates":[-118.2448,33.8166]},{"Plant":"Bucksport Generation LLC","State":"ME","Gas":156.8,"coordinates":[-68.8046,44.5738]},{"Plant":"Bethpage Power Plant","State":"NY","Gas":184,"coordinates":[-73.4994,40.7469]},{"Plant":"Shell Deer Park","State":"TX","Gas":140,"coordinates":[-95.1289,29.7232]},{"Plant":"Newark Bay Cogeneration Partnership LP","State":"NJ","Gas":120.2,"coordinates":[-74.13,40.7197]},{"Plant":"Indeck Corinth Energy Center","State":"NY","Gas":131.1,"coordinates":[-73.8125,43.25]},{"Plant":"Procter & Gamble Mehoopany Mill","State":"PA","Gas":104.9,"coordinates":[-76.0432,41.5743]},{"Plant":"PPG Powerhouse C","State":"LA","Gas":303.2,"coordinates":[-93.2831,30.2242]},{"Plant":"Bayonne Plant Holding LLC","State":"NJ","Gas":163,"coordinates":[-74.1124,40.6553]},{"Plant":"Harbor Cogen","State":"CA","Gas":101.7,"coordinates":[-118.2303,33.7771]},{"Plant":"Rosemary Power Station","State":"NC","Gas":165,"coordinates":[-77.6594,36.4517]},{"Plant":"Oklahoma Cogeneration Project","State":"OK","Gas":111.4,"coordinates":[-97.625,35.4397]},{"Plant":"Eagle Point Power Generation","State":"NJ","Gas":210,"coordinates":[-75.1592,39.8746]},{"Plant":"ExxonMobil Beaumont Refinery","State":"TX","Gas":610.6,"coordinates":[-94.0753,30.0636]},{"Plant":"JM Shafer Generating Station","State":"CO","Gas":263,"coordinates":[-104.7736,40.0986]},{"Plant":"Gary Works","State":"IN","Gas":161,"coordinates":[-87.3289,41.6224]},{"Plant":"Parlin Power Plant","State":"NJ","Gas":114.6,"coordinates":[-74.3272,40.4607]},{"Plant":"Optim Energy Altura Cogen LLC","State":"TX","Gas":536.5,"coordinates":[-95.1077,29.8161]},{"Plant":"Cumberland","State":"NJ","Gas":183.1,"coordinates":[-74.9654,39.3757]},{"Plant":"Hardee Power Station","State":"FL","Gas":358,"coordinates":[-81.9636,27.6364]},{"Plant":"Bellmeade Power Station","State":"VA","Gas":267,"coordinates":[-77.4317,37.4964]},{"Plant":"Motiva Enterprises Port Arthur Refinery","State":"TX","Gas":239.4,"coordinates":[-93.9569,29.8822]},{"Plant":"Ocean State Power","State":"RI","Gas":218.6,"coordinates":[-71.6689,42.0097]},{"Plant":"LaO Energy Systems","State":"LA","Gas":479,"coordinates":[-91.2325,30.3186]},{"Plant":"Doswell Energy Center","State":"VA","Gas":813.8,"coordinates":[-77.1448,37.8182]},{"Plant":"Elizabeth River Power Station","State":"VA","Gas":348,"coordinates":[-76.3083,36.775]},{"Plant":"Texas City Power Plant","State":"TX","Gas":451,"coordinates":[-94.9438,29.3787]},{"Plant":"Richmond Cogen","State":"CA","Gas":130.4,"coordinates":[-122.3909,37.9418]},{"Plant":"Dow Chemical Texas Operation","State":"TX","Gas":532.2,"coordinates":[-95.4075,28.9913]},{"Plant":"Power Station 4","State":"TX","Gas":172,"coordinates":[-94.9219,29.3782]},{"Plant":"Midway Sunset Cogen","State":"CA","Gas":219,"coordinates":[-119.6294,35.2269]},{"Plant":"C R Wing Cogen Plant","State":"TX","Gas":212,"coordinates":[-101.4224,32.2732]},{"Plant":"Delaware City Plant","State":"DE","Gas":265,"coordinates":[-75.6343,39.5871]},{"Plant":"McWilliams","State":"AL","Gas":663,"coordinates":[-86.4764,31.4003]},{"Plant":"J K Smith","State":"KY","Gas":784,"coordinates":[-84.1017,37.8833]},{"Plant":"Lockport Energy Associates LP","State":"NY","Gas":203,"coordinates":[-78.745,43.1619]},{"Plant":"Kennedy International Airport Cogen","State":"NY","Gas":126.2,"coordinates":[-73.7778,40.6417]},{"Plant":"March Point Cogeneration","State":"WA","Gas":120.2,"coordinates":[-122.56,48.4708]},{"Plant":"Saguaro Power","State":"NV","Gas":101,"coordinates":[-115.0117,36.0417]},{"Plant":"Ocean State Power II","State":"RI","Gas":218.6,"coordinates":[-71.6701,42.0099]},{"Plant":"Orange Cogeneration Facility","State":"FL","Gas":110.6,"coordinates":[-81.8251,27.8708]},{"Plant":"Lake Cogen Ltd","State":"FL","Gas":121,"coordinates":[-81.676,28.9158]},{"Plant":"Pasco Cogen Ltd","State":"FL","Gas":121,"coordinates":[-82.1889,28.3746]},{"Plant":"Mulberry Cogeneration Facility","State":"FL","Gas":113,"coordinates":[-81.8775,27.8489]},{"Plant":"Orlando Cogen LP","State":"FL","Gas":120,"coordinates":[-81.4123,28.4426]},{"Plant":"Sumas Power Plant","State":"WA","Gas":125.5,"coordinates":[-122.2733,48.9905]},{"Plant":"Ferndale Generating Station","State":"WA","Gas":270,"coordinates":[-122.6867,48.8288]},{"Plant":"Hartwell Energy Facility","State":"GA","Gas":293.7,"coordinates":[-82.8199,34.3396]},{"Plant":"Sithe Independence Station","State":"NY","Gas":910.8,"coordinates":[-76.4511,43.495]},{"Plant":"Saranac Facility","State":"NY","Gas":246.3,"coordinates":[-73.4557,44.7132]},{"Plant":"NAEA Lakewood LLC","State":"NJ","Gas":233.1,"coordinates":[-74.1686,40.0613]},{"Plant":"Oyster Creek Unit VIII","State":"TX","Gas":379,"coordinates":[-95.342,28.9802]},{"Plant":"Hermiston Generating Plant","State":"OR","Gas":464,"coordinates":[-119.37,45.8042]},{"Plant":"Grays Ferry Cogeneration","State":"PA","Gas":170,"coordinates":[-75.1881,39.9422]},{"Plant":"Milford Power LP","State":"MA","Gas":148,"coordinates":[-71.5115,42.1294]},{"Plant":"Milagro Cogeneration Plant","State":"NM","Gas":121.6,"coordinates":[-107.9417,36.7367]},{"Plant":"Johnson County","State":"TX","Gas":267,"coordinates":[-97.4078,32.3994]},{"Plant":"Brandywine Power Facility","State":"MD","Gas":230,"coordinates":[-76.8678,38.6681]},{"Plant":"Gordonsville Energy LP","State":"VA","Gas":218,"coordinates":[-78.2138,38.1179]},{"Plant":"Sun Peak Generating Station","State":"NV","Gas":222,"coordinates":[-115.0339,36.1375]},{"Plant":"Brooklyn Navy Yard Cogeneration","State":"NY","Gas":250,"coordinates":[-73.9764,40.6994]},{"Plant":"Michigan Power LP","State":"MI","Gas":128,"coordinates":[-86.425,43.9375]},{"Plant":"LSP-Cottage Grove LP","State":"MN","Gas":251,"coordinates":[-92.9119,44.7956]},{"Plant":"LSP-Whitewater LP","State":"WI","Gas":261,"coordinates":[-88.7299,42.8555]},{"Plant":"Sweeny Cogen Facility","State":"TX","Gas":436,"coordinates":[-95.745,29.0728]},{"Plant":"Dighton Power Plant","State":"MA","Gas":164.2,"coordinates":[-71.1239,41.8312]},{"Plant":"De Pere Energy Center","State":"WI","Gas":158.3,"coordinates":[-88.072,44.4486]},{"Plant":"Androscoggin Energy Center","State":"ME","Gas":136.5,"coordinates":[-70.2423,44.5063]},{"Plant":"Delta Person LLC","State":"NM","Gas":138,"coordinates":[-106.644,35.026]},{"Plant":"Mid-Georgia Cogeneration Facility","State":"GA","Gas":303,"coordinates":[-83.6039,32.4856]},{"Plant":"Berkshire Power","State":"MA","Gas":229.3,"coordinates":[-72.6478,42.0476]},{"Plant":"Bridgeport Energy Project","State":"CT","Gas":492,"coordinates":[-73.1844,41.1692]},{"Plant":"Pasadena Cogeneration","State":"TX","Gas":710,"coordinates":[-95.1765,29.7248]},{"Plant":"Tiverton Power Plant","State":"RI","Gas":250,"coordinates":[-71.1706,41.6422]},{"Plant":"Axiall Plaquemine","State":"LA","Gas":240,"coordinates":[-91.185,30.2586]},{"Plant":"Tenaska Georgia Generation Facility","State":"GA","Gas":945,"coordinates":[-84.9996,33.3516]},{"Plant":"Tenaska Frontier Generation Station","State":"TX","Gas":860,"coordinates":[-95.9178,30.5924]},{"Plant":"Batesville Generation Facility","State":"MS","Gas":858,"coordinates":[-89.9275,34.3356]},{"Plant":"Black Hawk Station","State":"TX","Gas":219.4,"coordinates":[-101.36,35.6957]},{"Plant":"Mustang Station","State":"TX","Gas":479,"coordinates":[-102.7417,32.9728]},{"Plant":"Maine Independence Station","State":"ME","Gas":490,"coordinates":[-68.7094,44.8242]},{"Plant":"Pine Bluff Energy Center","State":"AR","Gas":192,"coordinates":[-91.9025,34.2181]},{"Plant":"Desert Star Energy Center","State":"NV","Gas":450,"coordinates":[-114.9928,35.7867]},{"Plant":"Millennium Power","State":"MA","Gas":334.9,"coordinates":[-72.0151,42.1123]},{"Plant":"New Albany Energy Facility","State":"MS","Gas":360,"coordinates":[-88.9397,34.5408]},{"Plant":"Brownsville Peaking Power","State":"TN","Gas":456,"coordinates":[-89.198,35.5438]},{"Plant":"Crockett Cogen Project","State":"CA","Gas":247.4,"coordinates":[-122.2161,38.0569]},{"Plant":"Gregory Power Facility","State":"TX","Gas":366,"coordinates":[-97.2584,27.8893]},{"Plant":"Zeeland Generating Station","State":"MI","Gas":843,"coordinates":[-85.9975,42.8206]},{"Plant":"Dearborn Industrial Generation","State":"MI","Gas":741.6,"coordinates":[-83.154,42.3026]},{"Plant":"Taft Cogeneration Facility","State":"LA","Gas":738.9,"coordinates":[-90.4599,29.9888]},{"Plant":"Midlothian Energy Facility","State":"TX","Gas":1483,"coordinates":[-97.0537,32.4302]},{"Plant":"Lamar Power Project","State":"TX","Gas":1002,"coordinates":[-95.59,33.6308]},{"Plant":"Frontera Energy Center","State":"TX","Gas":500,"coordinates":[-98.3992,26.208]},{"Plant":"NRG Sterlington Power","State":"LA","Gas":176,"coordinates":[-92.0811,32.6889]},{"Plant":"Rumford Power Associates","State":"ME","Gas":254,"coordinates":[-70.5219,44.5303]},{"Plant":"Livingston Generating Station","State":"MI","Gas":132,"coordinates":[-84.7308,45.0304]},{"Plant":"Klamath Cogeneration Plant","State":"OR","Gas":490,"coordinates":[-121.8106,42.1739]},{"Plant":"Entergy Rhode Island State Energy LP","State":"RI","Gas":539,"coordinates":[-71.5186,41.8017]},{"Plant":"Rocky Road Power LLC","State":"IL","Gas":330.4,"coordinates":[-88.2397,42.0931]},{"Plant":"Madison","State":"OH","Gas":576,"coordinates":[-84.4647,39.4522]},{"Plant":"Vermillion Energy Facility","State":"IN","Gas":568,"coordinates":[-87.4464,39.9223]},{"Plant":"Sutter Energy Center","State":"CA","Gas":530,"coordinates":[-121.6959,39.0531]},{"Plant":"Rockingham County CT Station","State":"NC","Gas":825,"coordinates":[-79.8297,36.3297]},{"Plant":"RS Cogen","State":"LA","Gas":415.4,"coordinates":[-93.2992,30.221]},{"Plant":"Magic Valley Generating Station","State":"TX","Gas":682,"coordinates":[-98.19,26.3403]},{"Plant":"Griffith Energy LLC","State":"AZ","Gas":570,"coordinates":[-114.1333,35.054]},{"Plant":"Milford Power Project","State":"CT","Gas":506.7,"coordinates":[-73.0997,41.2244]},{"Plant":"Manchief Electric Generating Station","State":"CO","Gas":264,"coordinates":[-103.685,40.2171]},{"Plant":"Walton County Power LLC","State":"GA","Gas":454.5,"coordinates":[-83.6954,33.8148]},{"Plant":"Desert Basin","State":"AZ","Gas":577,"coordinates":[-111.7889,32.9042]},{"Plant":"Kendall County Generation Facility","State":"IL","Gas":1140,"coordinates":[-88.2581,41.4797]},{"Plant":"Tenaska Gateway Generating Station","State":"TX","Gas":844,"coordinates":[-94.6197,32.0178]},{"Plant":"Alliant Energy Neenah","State":"WI","Gas":303.2,"coordinates":[-88.5064,44.1936]},{"Plant":"Rio Nogales Power Project","State":"TX","Gas":756,"coordinates":[-97.9732,29.5931]},{"Plant":"Wolf Hollow I LP","State":"TX","Gas":673.3,"coordinates":[-97.7317,32.3342]},{"Plant":"Hawk Road Facility","State":"GA","Gas":486.9,"coordinates":[-84.9914,33.3585]},{"Plant":"Hays Energy Project","State":"TX","Gas":881,"coordinates":[-97.9894,29.7806]},{"Plant":"Green Country Energy LLC","State":"OK","Gas":783,"coordinates":[-95.9346,35.9833]},{"Plant":"Worthington Generation LLC","State":"IN","Gas":174.5,"coordinates":[-87.0128,39.0708]},{"Plant":"Lake Road Generating Plant","State":"CT","Gas":757.3,"coordinates":[-71.8958,41.872]},{"Plant":"La Paloma Generating LLC","State":"CA","Gas":965.4,"coordinates":[-119.5919,35.2956]},{"Plant":"Guadalupe Generating Station","State":"TX","Gas":986,"coordinates":[-98.1419,29.6244]},{"Plant":"Lost Pines 1 Power Project","State":"TX","Gas":510,"coordinates":[-97.2714,30.1478]},{"Plant":"Bluegrass Generating Station","State":"KY","Gas":501,"coordinates":[-85.4133,38.3902]},{"Plant":"Calcasieu","State":"LA","Gas":301.6,"coordinates":[-93.345,30.1608]},{"Plant":"Broad River Energy Center","State":"SC","Gas":850.8,"coordinates":[-81.575,35.0786]},{"Plant":"Bastrop Energy Center","State":"TX","Gas":525,"coordinates":[-97.55,30.1458]},{"Plant":"Granite Ridge","State":"NH","Gas":678,"coordinates":[-71.4261,42.9042]},{"Plant":"Bosque County Peaking","State":"TX","Gas":748,"coordinates":[-97.3586,31.8594]},{"Plant":"Acadia Energy Center","State":"LA","Gas":1123.1,"coordinates":[-92.4131,30.4286]},{"Plant":"Eastman Cogeneration Facility","State":"TX","Gas":402.2,"coordinates":[-94.6903,32.4481]},{"Plant":"South Point Energy Center","State":"AZ","Gas":550,"coordinates":[-114.5317,34.8678]},{"Plant":"Dogwood Energy Facility","State":"MO","Gas":616,"coordinates":[-94.3006,38.7931]},{"Plant":"Rathdrum Power LLC","State":"ID","Gas":248,"coordinates":[-116.9203,47.7858]},{"Plant":"Sunrise Power LLC","State":"CA","Gas":545,"coordinates":[-119.585,35.2097]},{"Plant":"Nelson Energy Center","State":"IL","Gas":570.6,"coordinates":[-89.6072,41.7744]},{"Plant":"Channelview Cogeneration Plant","State":"TX","Gas":819,"coordinates":[-95.1217,29.837]},{"Plant":"Cordova Energy","State":"IL","Gas":521.2,"coordinates":[-90.2797,41.7122]},{"Plant":"Osceola","State":"FL","Gas":471,"coordinates":[-81.0978,28.1289]},{"Plant":"Ontelaunee Energy Center","State":"PA","Gas":526,"coordinates":[-75.9356,40.4219]},{"Plant":"Caledonia","State":"MS","Gas":765,"coordinates":[-88.2717,33.6464]},{"Plant":"Riverside Generating LLC","State":"KY","Gas":825,"coordinates":[-82.6046,38.1917]},{"Plant":"Elwood Energy LLC","State":"IL","Gas":1350,"coordinates":[-88.1236,41.4388]},{"Plant":"Arapahoe Combustion Turbine Project","State":"CO","Gas":122.5,"coordinates":[-105.0018,39.6692]},{"Plant":"Gibson City","State":"IL","Gas":228,"coordinates":[-88.3987,40.4705]},{"Plant":"Pinckneyville","State":"IL","Gas":316,"coordinates":[-89.3467,38.1114]},{"Plant":"Kinmundy","State":"IL","Gas":207,"coordinates":[-89.0128,38.7619]},{"Plant":"Corpus Christi Energy Center","State":"TX","Gas":469,"coordinates":[-97.4283,27.8139]},{"Plant":"Afton Generating Station","State":"NM","Gas":235.6,"coordinates":[-106.8465,32.1142]},{"Plant":"ANP Bellingham Energy Project","State":"MA","Gas":502,"coordinates":[-71.4535,42.1106]},{"Plant":"ANP Blackstone Energy Project","State":"MA","Gas":486.6,"coordinates":[-71.5158,42.0599]},{"Plant":"Odessa Ector Generating Station","State":"TX","Gas":984,"coordinates":[-102.3264,31.8403]},{"Plant":"Morris Cogeneration LLC","State":"IL","Gas":183.8,"coordinates":[-88.3328,41.4119]},{"Plant":"Los Medanos Energy Center","State":"CA","Gas":567,"coordinates":[-121.873,38.0301]},{"Plant":"Hinds Energy Facility","State":"MS","Gas":444.4,"coordinates":[-90.2199,32.379]},{"Plant":"Attala","State":"MS","Gas":452.8,"coordinates":[-89.6753,33.0147]},{"Plant":"Harry L. Oswald","State":"AR","Gas":548,"coordinates":[-92.2166,34.5923]},{"Plant":"Lincoln Generating Facility","State":"IL","Gas":622.9,"coordinates":[-87.9436,41.3933]},{"Plant":"Ennis Power Company LLC","State":"TX","Gas":359.5,"coordinates":[-96.675,32.32]},{"Plant":"Wheatland Generating Facility","State":"IN","Gas":460,"coordinates":[-87.2931,38.6716]},{"Plant":"Oneta Energy Center","State":"OK","Gas":1086.4,"coordinates":[-95.6967,36.0119]},{"Plant":"Freestone Energy Center","State":"TX","Gas":953,"coordinates":[-96.1131,31.8907]},{"Plant":"Greenville Electric Generating Station","State":"OH","Gas":196,"coordinates":[-84.6151,40.0758]},{"Plant":"Montpelier Electric Generating Station","State":"IN","Gas":180,"coordinates":[-85.3057,40.6206]},{"Plant":"Jack County","State":"TX","Gas":1241,"coordinates":[-97.9574,33.101]},{"Plant":"Liberty Electric Power Plant","State":"PA","Gas":541,"coordinates":[-75.3358,39.8614]},{"Plant":"Marshall Energy Facility","State":"KY","Gas":581.6,"coordinates":[-88.3958,37.0286]},{"Plant":"Handsome Lake Energy LLC","State":"PA","Gas":267.5,"coordinates":[-79.8061,41.2908]},{"Plant":"Audrain Generating Station","State":"MO","Gas":600,"coordinates":[-91.5369,39.3092]},{"Plant":"Lee Energy Facility","State":"IL","Gas":568,"coordinates":[-89.4054,41.8287]},{"Plant":"Energy Shelby County","State":"IL","Gas":336,"coordinates":[-88.4772,39.2794]},{"Plant":"NRG Rockford I","State":"IL","Gas":299.6,"coordinates":[-89.1012,42.2386]},{"Plant":"Red Oak Power LLC","State":"NJ","Gas":765.9,"coordinates":[-74.3489,40.4487]},{"Plant":"Hog Bayou Energy Center","State":"AL","Gas":230,"coordinates":[-88.0575,30.7478]},{"Plant":"Santa Rosa Energy Center","State":"FL","Gas":235.9,"coordinates":[-87.115,30.5664]},{"Plant":"Astoria Gas Turbines","State":"NY","Gas":409.7,"coordinates":[-73.9048,40.787]},{"Plant":"Doyle Energy Facility","State":"GA","Gas":326.7,"coordinates":[-83.6996,33.8377]},{"Plant":"Darby Electric Generating Station","State":"OH","Gas":435,"coordinates":[-83.1778,39.7139]},{"Plant":"Tait Electric Generating Station","State":"OH","Gas":340,"coordinates":[-84.2095,39.7277]},{"Plant":"University Park South","State":"IL","Gas":300,"coordinates":[-87.7532,41.4409]},{"Plant":"Gleason Generating Facility","State":"TN","Gas":360,"coordinates":[-88.612,36.2454]},{"Plant":"Crete Energy Venture LLC","State":"IL","Gas":300,"coordinates":[-87.6187,41.4294]},{"Plant":"Whiting Clean Energy","State":"IN","Gas":513,"coordinates":[-87.4775,41.6739]},{"Plant":"Edward L. Addison Generating Plant","State":"GA","Gas":595.1,"coordinates":[-84.3064,32.9111]},{"Plant":"TVA Southaven Combined Cycle","State":"MS","Gas":780,"coordinates":[-90.0378,34.9939]},{"Plant":"Jackson Generating Station","State":"MI","Gas":564,"coordinates":[-84.3767,42.2488]},{"Plant":"Tenaska Lindsay Hill Generating Station","State":"AL","Gas":845,"coordinates":[-86.7386,32.6514]},{"Plant":"Ceredo Generating Station","State":"WV","Gas":450,"coordinates":[-82.5339,38.3681]},{"Plant":"Aurora","State":"IL","Gas":832,"coordinates":[-88.2265,41.8151]},{"Plant":"Southeast Chicago Energy Project","State":"IL","Gas":296,"coordinates":[-87.5449,41.7181]},{"Plant":"Arlington Valley Energy Facility","State":"AZ","Gas":580,"coordinates":[-112.8897,33.3417]},{"Plant":"Front Range Power Plant","State":"CO","Gas":460,"coordinates":[-104.7069,38.6281]},{"Plant":"Big Sandy Peaker Plant","State":"WV","Gas":300,"coordinates":[-82.5938,38.3441]},{"Plant":"Wolf Hills Energy","State":"VA","Gas":250,"coordinates":[-82.1044,36.6644]},{"Plant":"Oleander Power Project LP","State":"FL","Gas":790.2,"coordinates":[-80.7947,28.3661]},{"Plant":"Decatur Energy Center","State":"AL","Gas":725,"coordinates":[-87.0214,34.6292]},{"Plant":"Morgan Energy Center","State":"AL","Gas":749,"coordinates":[-87.0639,34.6397]},{"Plant":"Westbrook Energy Center Power Plant","State":"ME","Gas":506,"coordinates":[-70.375,43.6575]},{"Plant":"Blythe Energy Inc","State":"CA","Gas":514,"coordinates":[-114.6865,33.6157]},{"Plant":"Calumet Energy Team LLC","State":"IL","Gas":321.2,"coordinates":[-87.5563,41.6835]},{"Plant":"New Covert Generating Facility","State":"MI","Gas":1040.1,"coordinates":[-86.2937,42.3224]},{"Plant":"Fairless Energy Center","State":"PA","Gas":1272,"coordinates":[-74.7411,40.1475]},{"Plant":"Channel Energy Center LLC","State":"TX","Gas":768,"coordinates":[-95.2319,29.7189]},{"Plant":"Baconton Power Plant","State":"GA","Gas":196,"coordinates":[-84.08,31.3869]},{"Plant":"Gila River Power Station","State":"AZ","Gas":515,"coordinates":[-112.6944,32.975]},{"Plant":"Air Products Port Arthur","State":"TX","Gas":158.9,"coordinates":[-93.9651,29.8665]},{"Plant":"Ingleside Cogeneration","State":"TX","Gas":460,"coordinates":[-97.2428,27.8828]},{"Plant":"Fore River Generating Station","State":"MA","Gas":726,"coordinates":[-70.9661,42.2422]},{"Plant":"Indian River","State":"FL","Gas":576.4,"coordinates":[-80.7802,28.4932]},{"Plant":"Wise County Power LLC","State":"TX","Gas":680,"coordinates":[-97.9103,33.0583]},{"Plant":"Chuck Lenzie Generating Station","State":"NV","Gas":1170,"coordinates":[-114.9218,36.3837]},{"Plant":"Baytown Energy Center","State":"TX","Gas":770,"coordinates":[-94.9019,29.7731]},{"Plant":"Hermiston Power Partnership","State":"OR","Gas":615,"coordinates":[-119.3133,45.794]},{"Plant":"Washington County","State":"GA","Gas":615.5,"coordinates":[-82.98,33.0922]},{"Plant":"Delta Energy Center","State":"CA","Gas":769.1,"coordinates":[-121.8439,38.0169]},{"Plant":"Holland Energy Facility","State":"IL","Gas":612.7,"coordinates":[-88.7584,39.2231]},{"Plant":"PPL Ironwood LLC","State":"PA","Gas":660.1,"coordinates":[-76.3658,40.3509]},{"Plant":"Dell Power Station","State":"AR","Gas":437,"coordinates":[-90.0253,35.8619]},{"Plant":"Luna Energy Facility","State":"NM","Gas":559,"coordinates":[-107.7834,32.2993]},{"Plant":"Otay Mesa Generating Project","State":"CA","Gas":571,"coordinates":[-116.915,32.5815]},{"Plant":"Armstrong","State":"PA","Gas":603.1,"coordinates":[-79.3517,40.638]},{"Plant":"Troy Energy LLC","State":"OH","Gas":584,"coordinates":[-83.4598,41.4772]},{"Plant":"Pleasants Energy LLC","State":"WV","Gas":321.3,"coordinates":[-81.3642,39.3325]},{"Plant":"Dresden Energy Facility","State":"OH","Gas":540,"coordinates":[-82.0276,40.0928]},{"Plant":"Brazos Valley Generating Facility","State":"TX","Gas":525,"coordinates":[-95.6244,29.4731]},{"Plant":"Cottonwood Energy Project","State":"TX","Gas":1180,"coordinates":[-93.7353,30.2588]},{"Plant":"Sugar Creek Power","State":"IN","Gas":549,"coordinates":[-87.5108,39.3931]},{"Plant":"Exelon LaPorte Generating Station","State":"TX","Gas":153.2,"coordinates":[-95.0718,29.7028]},{"Plant":"Harquahala Generating Project","State":"AZ","Gas":1018,"coordinates":[-113.1134,33.476]},{"Plant":"Astoria Energy","State":"NY","Gas":540,"coordinates":[-73.8964,40.7825]},{"Plant":"Union Power Partners LP","State":"AR","Gas":2020,"coordinates":[-92.5894,33.2961]},{"Plant":"Thomas A Smith Energy Facility","State":"GA","Gas":1286,"coordinates":[-84.9175,34.7094]},{"Plant":"Columbia Energy Center","State":"SC","Gas":543,"coordinates":[-81.0178,33.8697]},{"Plant":"RockGen Energy Center","State":"WI","Gas":471,"coordinates":[-89.0492,42.9767]},{"Plant":"Zion Energy Center","State":"IL","Gas":456,"coordinates":[-87.895,42.4776]},{"Plant":"Metcalf Energy Center","State":"CA","Gas":546.1,"coordinates":[-121.7457,37.2207]},{"Plant":"Crossroads Energy Center","State":"MS","Gas":308,"coordinates":[-90.5621,34.183]},{"Plant":"Washington Energy Facility","State":"OH","Gas":626,"coordinates":[-81.6564,39.58]},{"Plant":"Elk Hills Power LLC","State":"CA","Gas":525,"coordinates":[-119.4707,35.2803]},{"Plant":"Rolling Hills Generating","State":"OH","Gas":825,"coordinates":[-82.3328,39.0839]},{"Plant":"Renaissance Power LLC","State":"MI","Gas":612,"coordinates":[-84.8429,43.1864]},{"Plant":"Carville Energy LLC","State":"LA","Gas":525,"coordinates":[-91.065,30.2294]},{"Plant":"Athens Generating Plant","State":"NY","Gas":968.9,"coordinates":[-73.8492,42.2728]},{"Plant":"Effingham County Power Project","State":"GA","Gas":509,"coordinates":[-81.2844,32.2773]},{"Plant":"Calhoun Energy Center","State":"AL","Gas":632,"coordinates":[-85.9731,33.5883]},{"Plant":"Hillabee Energy Center","State":"AL","Gas":721.8,"coordinates":[-85.9033,33.0007]},{"Plant":"Osprey Energy Center Power Plant","State":"FL","Gas":590,"coordinates":[-81.8083,28.0525]},{"Plant":"Shady Hills Generating Station","State":"FL","Gas":463.2,"coordinates":[-82.5586,28.3665]},{"Plant":"Vandolah Power Station","State":"FL","Gas":646,"coordinates":[-81.924,27.5236]},{"Plant":"Raccoon Creek Energy Center","State":"IL","Gas":300,"coordinates":[-88.5392,38.6996]},{"Plant":"Hot Spring Generating Facility","State":"AR","Gas":602.4,"coordinates":[-92.8683,34.2976]},{"Plant":"Plaquemine Cogeneration Plant","State":"LA","Gas":793,"coordinates":[-91.2347,30.3217]},{"Plant":"Bayou Cove Peaking Power","State":"LA","Gas":300,"coordinates":[-92.5997,30.2825]},{"Plant":"Elgin Energy Center","State":"IL","Gas":460,"coordinates":[-88.2446,42.0001]},{"Plant":"Tenaska Virginia Generating Station","State":"VA","Gas":899.1,"coordinates":[-78.3813,37.8667]},{"Plant":"Tenaska Central Alabama Generating Stn","State":"AL","Gas":923.8,"coordinates":[-86.74,32.6497]},{"Plant":"Columbia Energy Center","State":"MO","Gas":140,"coordinates":[-92.2629,39.0192]},{"Plant":"Magnolia Power Plant","State":"MS","Gas":918,"coordinates":[-89.2026,34.835]},{"Plant":"Fountain Valley Power Facility","State":"CO","Gas":234,"coordinates":[-104.6875,38.5569]},{"Plant":"Red Hawk","State":"AZ","Gas":934,"coordinates":[-112.8406,33.3346]},{"Plant":"McClain Energy Facility","State":"OK","Gas":493.6,"coordinates":[-97.5898,35.2977]},{"Plant":"Redbud Power Plant","State":"OK","Gas":1219.5,"coordinates":[-97.2264,35.6856]},{"Plant":"Deer Park Energy Center","State":"TX","Gas":1116,"coordinates":[-95.1345,29.7134]},{"Plant":"Ouachita","State":"LA","Gas":741.1,"coordinates":[-92.0683,32.7061]},{"Plant":"Green Power 2","State":"TX","Gas":825.5,"coordinates":[-94.9328,29.3781]},{"Plant":"Forney Energy Center","State":"TX","Gas":1838,"coordinates":[-96.4916,32.7563]},{"Plant":"Mesquite Generating Station","State":"AZ","Gas":595,"coordinates":[-112.8642,33.345]},{"Plant":"Goldendale Generating Station","State":"WA","Gas":256.7,"coordinates":[-120.833,45.8114]},{"Plant":"Tri Center Naniwa Energy","State":"NV","Gas":200,"coordinates":[-119.5178,39.5572]},{"Plant":"Goose Creek Energy Center","State":"IL","Gas":432,"coordinates":[-88.5999,40.1069]},{"Plant":"Kiamichi Energy Facility","State":"OK","Gas":1178.4,"coordinates":[-95.9349,34.6831]},{"Plant":"Lawrenceburg Energy Facility","State":"IN","Gas":1080,"coordinates":[-84.8669,39.0911]},{"Plant":"AEP Waterford Facility","State":"OH","Gas":810,"coordinates":[-81.7178,39.5333]},{"Plant":"Limon Generating Station","State":"CO","Gas":134,"coordinates":[-103.7005,39.2038]},{"Plant":"Frank Knutson","State":"CO","Gas":134,"coordinates":[-104.682,39.9411]},{"Plant":"Apex Generating Station","State":"NV","Gas":494.4,"coordinates":[-114.9609,36.416]},{"Plant":"Fayette Energy Facility","State":"PA","Gas":644,"coordinates":[-79.9182,39.8592]},{"Plant":"Wallingford Energy","State":"CT","Gas":211.5,"coordinates":[-72.8354,41.4487]},{"Plant":"High Desert Power Plant","State":"CA","Gas":774.3,"coordinates":[-117.3647,34.5953]},{"Plant":"Sundance","State":"AZ","Gas":410,"coordinates":[-111.5899,32.9285]},{"Plant":"York Energy Center","State":"PA","Gas":545,"coordinates":[-76.3067,39.7375]},{"Plant":"Indigo Energy Facility","State":"CA","Gas":142.5,"coordinates":[-116.553,33.9109]},{"Plant":"Hidalgo Energy Center","State":"TX","Gas":470,"coordinates":[-98.1758,26.3417]},{"Plant":"Perryville Power Station","State":"LA","Gas":701.3,"coordinates":[-92.0183,32.6908]},{"Plant":"West Valley Generation Project","State":"UT","Gas":185,"coordinates":[-112.0317,40.6667]},{"Plant":"University Park North","State":"IL","Gas":504,"coordinates":[-87.7514,41.4425]},{"Plant":"Riverside Energy Center","State":"WI","Gas":573.5,"coordinates":[-89.0355,42.5827]},{"Plant":"Blue Spruce Energy Center","State":"CO","Gas":264,"coordinates":[-104.6814,39.7479]},{"Plant":"Plains End","State":"CO","Gas":114,"coordinates":[-105.226,39.8575]},{"Plant":"Spring Creek Energy Center","State":"OK","Gas":271,"coordinates":[-97.655,35.7422]},{"Plant":"Pastoria Energy Facility, LLC","State":"CA","Gas":724,"coordinates":[-118.844,34.9556]},{"Plant":"EP Newington Energy LLC","State":"NH","Gas":557.2,"coordinates":[-70.8061,43.1047]},{"Plant":"Chehalis Generating Facility","State":"WA","Gas":477,"coordinates":[-122.9131,46.6225]},{"Plant":"Harrison County Power Project","State":"TX","Gas":514.4,"coordinates":[-94.4367,32.3958]},{"Plant":"Lower Mount Bethel Energy","State":"PA","Gas":537.5,"coordinates":[-75.1076,40.8019]},{"Plant":"AL Sandersville LLC","State":"GA","Gas":576.4,"coordinates":[-82.8608,33.1189]},{"Plant":"Higgins Generating Station","State":"NV","Gas":550,"coordinates":[-115.3561,35.6139]},{"Plant":"Bethlehem Power Plant","State":"PA","Gas":1134,"coordinates":[-75.3147,40.6175]},{"Plant":"Quantum Choctaw Power LLC","State":"MS","Gas":710,"coordinates":[-89.2089,33.3792]},{"Plant":"Mint Farm Generating Station","State":"WA","Gas":275.9,"coordinates":[-122.9855,46.1388]},{"Plant":"Fremont Energy Center","State":"OH","Gas":673.1,"coordinates":[-83.1614,41.3771]},{"Plant":"Choctaw County","State":"MS","Gas":781,"coordinates":[-89.4201,33.2881]},{"Plant":"Allegheny Energy Units 3 4 & 5","State":"PA","Gas":509,"coordinates":[-79.7686,40.5453]},{"Plant":"Magnet Cove","State":"AR","Gas":641.5,"coordinates":[-92.8317,34.4297]},{"Plant":"Dean","State":"MI","Gas":312,"coordinates":[-82.4953,42.7725]},{"Plant":"Bennett Mountain","State":"ID","Gas":164,"coordinates":[-115.6666,43.1472]},{"Plant":"Hanging Rock Energy Facility","State":"OH","Gas":1322,"coordinates":[-82.7833,38.5731]},{"Plant":"Los Esteros Critical Energy Center","State":"CA","Gas":306.1,"coordinates":[-121.9319,37.425]},{"Plant":"FPL Energy Marcus Hook LP","State":"PA","Gas":785.7,"coordinates":[-75.4216,39.807]},{"Plant":"Valencia Energy Facility","State":"NM","Gas":144.3,"coordinates":[-106.7322,34.6115]},{"Plant":"Gilroy Peaking Energy Center","State":"CA","Gas":135,"coordinates":[-121.5363,36.999]},{"Plant":"Frederickson Power LP","State":"WA","Gas":242,"coordinates":[-122.3657,47.0861]},{"Plant":"Curtis H Stanton Energy Center","State":"FL","Gas":656.9,"coordinates":[-81.1669,28.4882]},{"Plant":"Auburndale Peaker Energy Center","State":"FL","Gas":117,"coordinates":[-81.8059,28.0535]},{"Plant":"Rocky Mountain Energy Center","State":"CO","Gas":580,"coordinates":[-104.5953,40.0908]},{"Plant":"Silverhawk","State":"NV","Gas":560,"coordinates":[-114.9606,36.4078]},{"Plant":"Inland Empire Energy Center","State":"CA","Gas":690,"coordinates":[-117.1704,33.7388]},{"Plant":"Jasper","State":"SC","Gas":862,"coordinates":[-81.1242,32.3594]},{"Plant":"Tracy Combined Cycle Power Plant","State":"CA","Gas":320.1,"coordinates":[-121.4906,37.7107]},{"Plant":"NRG Rockford II Energy Center","State":"IL","Gas":156.6,"coordinates":[-89.1011,42.2383]},{"Plant":"NAEA Ocean Peaking Power LLC","State":"NJ","Gas":325.6,"coordinates":[-74.1672,40.0633]},{"Plant":"Warren County","State":"VA","Gas":1472.2,"coordinates":[-78.1772,38.9717]},{"Plant":"Wansley Combined Cycle","State":"GA","Gas":1145.5,"coordinates":[-85.037,33.4064]},{"Plant":"Cosumnes","State":"CA","Gas":503,"coordinates":[-121.124,38.3385]},{"Plant":"Cass County","State":"NE","Gas":324.4,"coordinates":[-95.964,40.9479]},{"Plant":"Hunterstown","State":"PA","Gas":758,"coordinates":[-77.1672,39.8725]},{"Plant":"Palomar Energy","State":"CA","Gas":562,"coordinates":[-117.1178,33.1197]},{"Plant":"Exira","State":"IA","Gas":139.5,"coordinates":[-94.9197,41.5144]},{"Plant":"Donald Von Raesfeld Power Plant","State":"CA","Gas":154,"coordinates":[-121.9508,37.3767]},{"Plant":"Fox Energy Center","State":"WI","Gas":554.2,"coordinates":[-88.2089,44.3204]},{"Plant":"Malburg","State":"CA","Gas":134,"coordinates":[-118.2219,33.9986]},{"Plant":"Magnolia Power Project","State":"CA","Gas":301,"coordinates":[-118.3153,34.1786]},{"Plant":"Walnut Energy Center","State":"CA","Gas":269,"coordinates":[-120.8956,37.4878]},{"Plant":"Currant Creek","State":"UT","Gas":524,"coordinates":[-111.8935,39.8214]},{"Plant":"Mankato Energy Center","State":"MN","Gas":300,"coordinates":[-94.003,44.1988]},{"Plant":"Riverside Energy Resource Center","State":"CA","Gas":196,"coordinates":[-117.4528,33.9636]},{"Plant":"McIntosh Combined Cycle Facility","State":"GA","Gas":1256.8,"coordinates":[-81.1817,32.3478]},{"Plant":"South Harper","State":"MO","Gas":303.3,"coordinates":[-94.4824,38.6803]},{"Plant":"Freeport Energy Center","State":"TX","Gas":219.4,"coordinates":[-95.3954,28.9888]},{"Plant":"Faribault Energy Park","State":"MN","Gas":261,"coordinates":[-93.2906,44.3356]},{"Plant":"Sheboygan Falls","State":"WI","Gas":300.5,"coordinates":[-87.8781,43.7518]},{"Plant":"Nebo Power Station","State":"UT","Gas":130,"coordinates":[-111.7294,40.0614]},{"Plant":"500MW CC","State":"NY","Gas":454.1,"coordinates":[-73.9069,40.7889]},{"Plant":"Middletown","State":"CT","Gas":353,"coordinates":[-72.5791,41.5549]},{"Plant":"Port Westward","State":"OR","Gas":392.2,"coordinates":[-123.172,46.1789]},{"Plant":"EG178 Facility","State":"TX","Gas":110,"coordinates":[-100.9547,32.7471]},{"Plant":"Caithness Long Island Energy Center","State":"NY","Gas":316.9,"coordinates":[-72.9403,40.8142]},{"Plant":"Lake Side Power Plant","State":"UT","Gas":1176,"coordinates":[-111.7542,40.3317]},{"Plant":"Groton Generating Station","State":"SD","Gas":158.9,"coordinates":[-98.0987,45.3735]},{"Plant":"Cannon Falls Energy Center","State":"MN","Gas":398,"coordinates":[-92.9155,44.5367]},{"Plant":"Anson County Generation Facility","State":"NC","Gas":339,"coordinates":[-79.9217,34.9687]},{"Plant":"Empire Generating Co  LLC","State":"NY","Gas":580,"coordinates":[-73.75,42.6252]},{"Plant":"Hamlet Generating Facility","State":"NC","Gas":339,"coordinates":[-79.7361,34.8423]},{"Plant":"Roseville Energy Park","State":"CA","Gas":151,"coordinates":[-121.3811,38.7928]},{"Plant":"Shute Creek Facility","State":"WY","Gas":106.8,"coordinates":[-110.0904,41.8805]},{"Plant":"Mustang Station Unit 4","State":"TX","Gas":458.3,"coordinates":[-102.7436,32.9746]},{"Plant":"Harry D Mattison Gas Plant","State":"AR","Gas":294,"coordinates":[-94.2841,36.1855]},{"Plant":"Quail Run Energy Center","State":"TX","Gas":482,"coordinates":[-102.315,31.8414]},{"Plant":"Colorado Bend Energy Center","State":"TX","Gas":510,"coordinates":[-96.0683,29.2878]},{"Plant":"Stanton Energy Center","State":"FL","Gas":295,"coordinates":[-81.1678,28.4822]},{"Plant":"Treasure Coast Energy Center","State":"FL","Gas":318,"coordinates":[-80.3775,27.3839]},{"Plant":"West County Energy Center","State":"FL","Gas":3669,"coordinates":[-80.3747,26.6986]},{"Plant":"Spindle Hill Energy Center","State":"CO","Gas":270,"coordinates":[-104.8878,40.0922]},{"Plant":"Hobbs Generating Station","State":"NM","Gas":549,"coordinates":[-103.3094,32.7283]},{"Plant":"Russell City Energy Center","State":"CA","Gas":615,"coordinates":[-122.1338,37.6347]},{"Plant":"Gateway Generating Station","State":"CA","Gas":563.4,"coordinates":[-121.7587,38.0175]},{"Plant":"Western 102 Power Plant","State":"NV","Gas":110.6,"coordinates":[-119.5108,39.5603]},{"Plant":"Emporia Energy Center","State":"KS","Gas":648,"coordinates":[-96.0652,38.4459]},{"Plant":"Jonesboro City Water & Light Plant","State":"AR","Gas":177,"coordinates":[-90.7254,35.8486]},{"Plant":"Plains End II LLC","State":"CO","Gas":116.2,"coordinates":[-105.2256,39.8586]},{"Plant":"Colusa Generating Station","State":"CA","Gas":640,"coordinates":[-122.27,39.3661]},{"Plant":"PPS Power Plant No 1","State":"KY","Gas":110,"coordinates":[-88.6159,37.0339]},{"Plant":"J Lamar Stall Unit","State":"LA","Gas":507,"coordinates":[-93.7601,32.5195]},{"Plant":"San Jacinto County Peaking Facility","State":"TX","Gas":146,"coordinates":[-95.0118,30.4193]},{"Plant":"Hardin County Peaking Facility","State":"TX","Gas":146,"coordinates":[-94.2526,30.3038]},{"Plant":"Deer Creek Station","State":"SD","Gas":290,"coordinates":[-96.5267,44.2908]},{"Plant":"Midway Peaking LLC","State":"CA","Gas":111.2,"coordinates":[-120.5797,36.6541]},{"Plant":"Winchester Power Park","State":"TX","Gas":176,"coordinates":[-96.9875,30.0381]},{"Plant":"CFB Power Plant","State":"TX","Gas":286.2,"coordinates":[-96.5397,28.6503]},{"Plant":"Kleen Energy Systems Project","State":"CT","Gas":622,"coordinates":[-72.5969,41.5532]},{"Plant":"Greenland Energy Center","State":"FL","Gas":296,"coordinates":[-81.5184,30.1591]},{"Plant":"Panoche Energy Center","State":"CA","Gas":388,"coordinates":[-120.5833,36.6514]},{"Plant":"Cedar Bayou 4","State":"TX","Gas":502,"coordinates":[-94.9231,29.7516]},{"Plant":"Bear Garden","State":"VA","Gas":589,"coordinates":[-78.2853,37.6956]},{"Plant":"Dave Gates Generating Station","State":"MT","Gas":132.3,"coordinates":[-112.8766,46.1047]},{"Plant":"Coolidge Generation Station","State":"AZ","Gas":520.8,"coordinates":[-111.5033,32.9174]},{"Plant":"West Deptford Energy Station","State":"NJ","Gas":711,"coordinates":[-75.2214,39.8414]},{"Plant":"Bayonne Energy Center","State":"NJ","Gas":479.9,"coordinates":[-74.0915,40.6528]},{"Plant":"Pueblo Airport Generating Station","State":"CO","Gas":368,"coordinates":[-104.5264,38.3208]},{"Plant":"Canyon Power Plant","State":"CA","Gas":194.8,"coordinates":[-117.8617,33.8581]},{"Plant":"Langley Gulch Power Plant","State":"ID","Gas":299.7,"coordinates":[-116.8197,43.9044]},{"Plant":"Cleveland Cnty Generating Facility","State":"NC","Gas":738,"coordinates":[-81.4166,35.1705]},{"Plant":"Southcentral Power Plant","State":"AK","Gas":169.7,"coordinates":[-149.9053,61.1674]},{"Plant":"Kemper County IGCC Project","State":"MS","Gas":555.2,"coordinates":[-88.7622,32.6547]},{"Plant":"Marsh Landing Generating Station","State":"CA","Gas":765.7,"coordinates":[-121.765,38.0169]},{"Plant":"Garrison Energy Center LLC","State":"DE","Gas":316,"coordinates":[-75.4994,39.1872]},{"Plant":"CPV Sentinel Energy Project","State":"CA","Gas":800,"coordinates":[-116.5714,33.9342]},{"Plant":"Mariposa Energy Project","State":"CA","Gas":199.6,"coordinates":[-121.6019,37.7892]},{"Plant":"Walnut Creek Energy Park","State":"CA","Gas":485,"coordinates":[-117.9449,34.0087]},{"Plant":"Astoria Energy II","State":"NY","Gas":540,"coordinates":[-73.8966,40.7813]},{"Plant":"Cheyenne Prairie Generating Station","State":"WY","Gas":131,"coordinates":[-104.72,41.1236]},{"Plant":"Woodbridge Energy Center","State":"NJ","Gas":725,"coordinates":[-74.3189,40.515]},{"Plant":"Antelope Station","State":"TX","Gas":163.8,"coordinates":[-101.8433,33.865]},{"Plant":"Pioneer Generating Station","State":"ND","Gas":120,"coordinates":[-103.9528,48.2325]},{"Plant":"El Segundo Energy Center LLC","State":"CA","Gas":510,"coordinates":[-118.425,33.9106]},{"Plant":"Lonesome Creek Station","State":"ND","Gas":120,"coordinates":[-103.5786,47.7967]},{"Plant":"Lodi Energy Center","State":"CA","Gas":257,"coordinates":[-121.3875,38.0881]},{"Plant":"Panda Temple Power Station","State":"TX","Gas":1468,"coordinates":[-97.3172,31.0558]},{"Plant":"Panda Sherman Power Station","State":"TX","Gas":717,"coordinates":[-96.6179,33.5826]},{"Plant":"Newark Energy Center","State":"NJ","Gas":685,"coordinates":[-74.1258,40.7072]},{"Plant":"Lee Combined Cycle Plant","State":"NC","Gas":910,"coordinates":[-78.0894,35.3736]},{"Plant":"Rubart","State":"KS","Gas":108,"coordinates":[-93.3369,36.8283]},{"Plant":"Port Westward Unit 2","State":"OR","Gas":224.4,"coordinates":[-123.1719,46.1789]},{"Plant":"Charles D. Lamb Energy Center","State":"OK","Gas":122,"coordinates":[-97.1253,36.8139]},{"Plant":"Ector County Energy Center","State":"TX","Gas":326.6,"coordinates":[-102.5856,32.0692]},{"Plant":"Mesquite Generating Station Block 1","State":"AZ","Gas":595,"coordinates":[-112.8642,33.345]},{"Plant":"Montana Power Station","State":"TX","Gas":190,"coordinates":[-106.2119,31.8239]},{"Plant":"L V Sutton Combined Cycle","State":"NC","Gas":622,"coordinates":[-77.9853,34.2831]},{"Plant":"Elk Station","State":"TX","Gas":195,"coordinates":[-101.8433,33.865]},{"Plant":"Eklutna Generation Station","State":"AK","Gas":165,"coordinates":[-149.3514,61.4578]},{"Plant":"Edge Moor","State":"DE","Gas":710,"coordinates":[-75.5038,39.7389]},{"Plant":"PB1 - Gila River","State":"AZ","Gas":1030,"coordinates":[-112.6944,32.975]},{"Plant":"Gila River Power Block 3","State":"AZ","Gas":515,"coordinates":[-112.6944,32.975]},{"Plant":"McKee Run","State":"DE","Gas":136,"coordinates":[-75.5466,39.1762]},{"Plant":"Belle River","State":"MI","Gas":224,"coordinates":[-82.495,42.7756]},{"Plant":"Greenwood","State":"MI","Gas":1009,"coordinates":[-82.6964,43.1056]},{"Plant":"Manatee","State":"FL","Gas":1111,"coordinates":[-82.3456,27.6058]},{"Plant":"Martin","State":"FL","Gas":2043,"coordinates":[-80.5628,27.0536]},{"Plant":"DeBary","State":"FL","Gas":247,"coordinates":[-81.3323,28.9039]},{"Plant":"Big Cajun 2","State":"LA","Gas":575,"coordinates":[-91.3692,30.7261]},{"Plant":"Electrifarm","State":"IA","Gas":195.1,"coordinates":[-92.4205,42.4407]},{"Plant":"Fredonia","State":"WA","Gas":280,"coordinates":[-122.4358,48.4558]},{"Plant":"Trimble County","State":"KY","Gas":954,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Gas":969,"coordinates":[-88.5553,30.5322]},{"Plant":"Greenwood","State":"MO","Gas":246,"coordinates":[-94.2982,38.8615]},{"Plant":"R M Schahfer","State":"IN","Gas":155,"coordinates":[-87.0261,41.2164]},{"Plant":"Cape Canaveral","State":"FL","Gas":1210,"coordinates":[-80.7644,28.4698]},{"Plant":"Fort St Vrain","State":"CO","Gas":969,"coordinates":[-104.8742,40.2461]},{"Plant":"Fort Myers","State":"FL","Gas":1747,"coordinates":[-81.7831,26.6967]},{"Plant":"Whitehorn","State":"WA","Gas":134,"coordinates":[-122.6861,48.8288]},{"Plant":"McIntosh","State":"GA","Gas":657.6,"coordinates":[-81.1683,32.3563]},{"Plant":"Lauderdale","State":"FL","Gas":1724,"coordinates":[-80.1984,26.0686]},{"Plant":"A B Brown","State":"IN","Gas":160,"coordinates":[-87.715,37.9053]},{"Plant":"Port Everglades","State":"FL","Gas":420,"coordinates":[-80.1253,26.0856]},{"Plant":"Riviera","State":"FL","Gas":1212,"coordinates":[-80.0525,26.7653]},{"Plant":"Brame Energy Center","State":"LA","Gas":419.2,"coordinates":[-92.7167,31.395]},{"Plant":"John Twitty Energy Center","State":"MO","Gas":104,"coordinates":[-93.388,37.1517]},{"Plant":"Sanford","State":"FL","Gas":1912,"coordinates":[-81.3256,28.8419]},{"Plant":"Turkey Point","State":"FL","Gas":1544,"coordinates":[-80.3308,25.4356]},{"Plant":"Empire Energy Center","State":"MO","Gas":262,"coordinates":[-94.1041,37.1385]},{"Plant":"Dansby","State":"TX","Gas":204.2,"coordinates":[-96.4608,30.7217]},{"Plant":"Higgins","State":"FL","Gas":109,"coordinates":[-82.6615,28.0033]},{"Plant":"P L Bartow","State":"FL","Gas":1194,"coordinates":[-82.6018,27.8595]},{"Plant":"Rokeby","State":"NE","Gas":255,"coordinates":[-96.7364,40.7316]},{"Plant":"Suwannee River","State":"FL","Gas":232,"coordinates":[-83.1806,30.3764]},{"Plant":"Lansing Smith","State":"FL","Gas":481,"coordinates":[-85.7003,30.2686]},{"Plant":"D G Hunter","State":"LA","Gas":130,"coordinates":[-92.4613,31.3207]},{"Plant":"George M Sullivan Generation Plant 2","State":"AK","Gas":248.1,"coordinates":[-149.7167,61.2297]},{"Plant":"Deerhaven Generating Station","State":"FL","Gas":185,"coordinates":[-82.3878,29.7592]},{"Plant":"John R Kelly","State":"FL","Gas":112,"coordinates":[-82.3208,29.6461]},{"Plant":"J D Kennedy","State":"FL","Gas":317.2,"coordinates":[-81.626,30.3648]},{"Plant":"Northside Generating Station","State":"FL","Gas":524,"coordinates":[-81.5525,30.4172]},{"Plant":"Larsen Memorial","State":"FL","Gas":124,"coordinates":[-81.9228,28.0797]},{"Plant":"C D McIntosh Jr","State":"FL","Gas":460,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Gas":388,"coordinates":[-105.0212,40.8609]},{"Plant":"Indian River Plant","State":"FL","Gas":290,"coordinates":[-80.7801,28.4932]},{"Plant":"Arvah B Hopkins","State":"FL","Gas":504,"coordinates":[-84.4,30.4522]},{"Plant":"S O Purdom","State":"FL","Gas":246,"coordinates":[-84.2007,30.1623]},{"Plant":"Gadsden","State":"AL","Gas":130,"coordinates":[-85.9708,34.0128]},{"Plant":"Gravel Neck","State":"VA","Gas":340,"coordinates":[-76.6911,37.1575]},{"Plant":"McIntosh","State":"AL","Gas":688,"coordinates":[-88.0299,31.2546]},{"Plant":"Harry Allen","State":"NV","Gas":654,"coordinates":[-114.9024,36.4306]},{"Plant":"Jack McDonough","State":"GA","Gas":2594,"coordinates":[-84.4758,33.8239]},{"Plant":"Pleasant Hill","State":"IA","Gas":160,"coordinates":[-93.5242,41.5572]},{"Plant":"Hay Road","State":"DE","Gas":1136,"coordinates":[-75.5072,39.7436]},{"Plant":"Woodsdale","State":"OH","Gas":462,"coordinates":[-84.4611,39.4492]},{"Plant":"Concord","State":"WI","Gas":352,"coordinates":[-88.69,43.1669]},{"Plant":"South Fond Du Lac","State":"WI","Gas":316.8,"coordinates":[-88.4967,43.7353]},{"Plant":"Darbytown","State":"VA","Gas":336,"coordinates":[-77.3685,37.4982]},{"Plant":"Angus Anson","State":"SD","Gas":327,"coordinates":[-96.6356,43.6035]},{"Plant":"Cane Island","State":"FL","Gas":670,"coordinates":[-81.533,28.2764]},{"Plant":"Polk","State":"FL","Gas":604,"coordinates":[-81.9897,27.7286]},{"Plant":"Woodland","State":"CA","Gas":182.2,"coordinates":[-121.0204,37.6526]},{"Plant":"491 E 48th Street","State":"MI","Gas":136,"coordinates":[-86.0853,42.7553]},{"Plant":"Paris","State":"WI","Gas":352,"coordinates":[-88.0131,42.6658]},{"Plant":"Lincoln Combustion","State":"NC","Gas":1267.2,"coordinates":[-81.0347,35.4317]},{"Plant":"Yates","State":"GA","Gas":707,"coordinates":[-84.8986,33.4622]},{"Plant":"State Line Combined Cycle","State":"MO","Gas":589,"coordinates":[-94.614,37.0659]},{"Plant":"Hines Energy Complex","State":"FL","Gas":1912,"coordinates":[-81.87,27.7882]},{"Plant":"Redding Power","State":"CA","Gas":171,"coordinates":[-122.4233,40.5073]},{"Plant":"Richard M Flynn","State":"NY","Gas":134.4,"coordinates":[-73.064,40.8158]},{"Plant":"Almond Power Plant","State":"CA","Gas":199.5,"coordinates":[-120.985,37.5744]},{"Plant":"San Jacinto Steam Electric Station","State":"TX","Gas":162,"coordinates":[-95.0406,29.6948]},{"Plant":"Anderson","State":"IN","Gas":140,"coordinates":[-85.7389,40.0529]},{"Plant":"Robins","State":"GA","Gas":160,"coordinates":[-83.5822,32.5792]},{"Plant":"Coyote Springs","State":"OR","Gas":235,"coordinates":[-119.6739,45.848]},{"Plant":"Midulla Generating Station","State":"FL","Gas":751,"coordinates":[-81.9625,27.6417]},{"Plant":"Interstate","State":"IL","Gas":112,"coordinates":[-89.5891,39.8233]},{"Plant":"Rathdrum","State":"ID","Gas":132,"coordinates":[-116.8673,47.8043]},{"Plant":"Arthur Von Rosenberg","State":"TX","Gas":530,"coordinates":[-98.384,29.257]},{"Plant":"Carson Ice-Gen Project","State":"CA","Gas":109,"coordinates":[-121.4624,38.4457]},{"Plant":"Wayne County","State":"NC","Gas":863,"coordinates":[-78.0981,35.3758]},{"Plant":"Ponca City","State":"OK","Gas":106.8,"coordinates":[-97.0858,36.7198]},{"Plant":"SCA Cogen 2","State":"CA","Gas":176.6,"coordinates":[-121.4001,38.5309]},{"Plant":"SPA Cogen 3","State":"CA","Gas":164,"coordinates":[-121.4735,38.511]},{"Plant":"St Francis Energy Facility","State":"MO","Gas":464,"coordinates":[-90.1779,36.5852]},{"Plant":"River Road Gen Plant","State":"WA","Gas":220,"coordinates":[-122.7256,45.6497]},{"Plant":"Tiger Bay","State":"FL","Gas":205,"coordinates":[-81.8494,27.7464]},{"Plant":"Dahlberg","State":"GA","Gas":745.3,"coordinates":[-83.3977,34.0423]},{"Plant":"H Allen Franklin Combined Cycle","State":"AL","Gas":1816,"coordinates":[-85.0975,32.6078]},{"Plant":"Theodore Cogen Facility","State":"AL","Gas":224.7,"coordinates":[-88.1285,30.5254]},{"Plant":"Nodaway","State":"MO","Gas":186,"coordinates":[-94.7913,40.2877]},{"Plant":"Chouteau","State":"OK","Gas":799,"coordinates":[-95.2771,36.2221]},{"Plant":"Georgetown","State":"IN","Gas":276,"coordinates":[-86.2441,39.9026]},{"Plant":"Tilton","State":"IL","Gas":176,"coordinates":[-87.6538,40.1061]},{"Plant":"Henry County","State":"IN","Gas":129,"coordinates":[-85.5039,39.9528]},{"Plant":"MPC Generating","State":"GA","Gas":302.5,"coordinates":[-83.6953,33.8119]},{"Plant":"Sherwood H Smith Jr Energy Complex","State":"NC","Gas":1868,"coordinates":[-79.7406,34.8392]},{"Plant":"Sewell Creek Energy","State":"GA","Gas":437.9,"coordinates":[-85.2769,33.9486]},{"Plant":"Alsey","State":"IL","Gas":121,"coordinates":[-90.436,39.5698]},{"Plant":"Fulton","State":"AR","Gas":153,"coordinates":[-93.7924,33.6094]},{"Plant":"Rowan","State":"NC","Gas":938.8,"coordinates":[-80.6019,35.7314]},{"Plant":"Smarr Energy Center","State":"GA","Gas":187.4,"coordinates":[-83.8464,32.9842]},{"Plant":"John S Rainey","State":"SC","Gas":977,"coordinates":[-82.776,34.3477]},{"Plant":"Essential Power Rock Springs LLC","State":"MD","Gas":653.5,"coordinates":[-76.1598,39.719]},{"Plant":"Marsh Run Generating","State":"VA","Gas":481.1,"coordinates":[-77.7681,38.5283]},{"Plant":"Louisa Generating","State":"VA","Gas":466,"coordinates":[-78.2139,38.1181]},{"Plant":"Remington","State":"VA","Gas":608,"coordinates":[-77.7714,38.5442]},{"Plant":"Ladysmith","State":"VA","Gas":783,"coordinates":[-77.5133,38.0722]},{"Plant":"Pleasant Valley","State":"MN","Gas":441.9,"coordinates":[-92.6829,43.7994]},{"Plant":"Lagoon Creek","State":"TN","Gas":1407,"coordinates":[-89.3964,35.6578]},{"Plant":"Brandy Branch","State":"FL","Gas":660.8,"coordinates":[-81.9472,30.3206]},{"Plant":"Holden","State":"MO","Gas":210,"coordinates":[-93.9983,38.7538]},{"Plant":"MEPI GT Facility","State":"IL","Gas":239,"coordinates":[-88.8661,37.2175]},{"Plant":"Encogen","State":"WA","Gas":159.4,"coordinates":[-122.486,48.746]},{"Plant":"Robert P Mone Plant","State":"OH","Gas":435,"coordinates":[-84.7392,40.9297]},{"Plant":"H L Culbreath Bayside Power Station","State":"FL","Gas":1854,"coordinates":[-82.4231,27.9072]},{"Plant":"Terry Bundy Generating Station","State":"NE","Gas":174.4,"coordinates":[-96.6131,40.9097]},{"Plant":"E B Harris Electric Generating Plant","State":"AL","Gas":1273.8,"coordinates":[-86.5744,32.3814]},{"Plant":"Sand Hill","State":"TX","Gas":595.8,"coordinates":[-97.6129,30.2098]},{"Plant":"Talbot County Energy","State":"GA","Gas":576.6,"coordinates":[-84.6917,32.5892]},{"Plant":"Chattahoochee Energy Facility","State":"GA","Gas":445.5,"coordinates":[-85.0386,33.4072]},{"Plant":"Lakefield Junction","State":"MN","Gas":513.6,"coordinates":[-94.8415,43.7984]},{"Plant":"West Gardner","State":"KS","Gas":311.1,"coordinates":[-94.9861,38.7875]},{"Plant":"Coyote Springs II","State":"OR","Gas":242.7,"coordinates":[-119.674,45.848]},{"Plant":"Wansley Unit 9","State":"GA","Gas":493.4,"coordinates":[-85.0403,33.4083]},{"Plant":"Lawrence County Station","State":"IN","Gas":264.1,"coordinates":[-86.4511,38.8003]},{"Plant":"Evander Andrews Power Complex","State":"ID","Gas":261.5,"coordinates":[-115.7343,43.1792]},{"Plant":"Kemper County","State":"MS","Gas":293.2,"coordinates":[-88.606,32.7976]},{"Plant":"Peno Creek","State":"MO","Gas":188,"coordinates":[-91.2295,39.3531]},{"Plant":"Sumpter","State":"MI","Gas":308.4,"coordinates":[-83.5318,42.167]},{"Plant":"Pyramid","State":"NM","Gas":158,"coordinates":[-108.5494,32.2363]},{"Plant":"Mill Creek","State":"SC","Gas":595.2,"coordinates":[-81.4306,35.1597]},{"Plant":"Greater Des Moines","State":"IA","Gas":492.6,"coordinates":[-93.5283,41.5563]},{"Plant":"Silver Creek","State":"MS","Gas":225,"coordinates":[-89.9468,31.6004]},{"Plant":"Sylvarena","State":"MS","Gas":129,"coordinates":[-89.4127,31.9821]},{"Plant":"West Campus Cogeneration Facility","State":"WI","Gas":119.7,"coordinates":[-89.4251,43.0751]},{"Plant":"Grays Harbor Energy Facility","State":"WA","Gas":637,"coordinates":[-123.48,46.9692]},{"Plant":"Beatrice","State":"NE","Gas":220,"coordinates":[-96.8082,40.3302]},{"Plant":"Roseton Generating Facility","State":"NY","Gas":1196.5,"coordinates":[-73.9663,41.5738]},{"Plant":"Blue Lake","State":"MN","Gas":300,"coordinates":[-93.4315,44.7855]},{"Plant":"Sycamore","State":"IA","Gas":148.5,"coordinates":[-93.6769,41.6722]},{"Plant":"Emery Station","State":"IA","Gas":509.8,"coordinates":[-93.2922,43.094]},{"Plant":"Anclote","State":"FL","Gas":1041,"coordinates":[-82.7886,28.1844]},{"Plant":"Intercession City","State":"FL","Gas":555,"coordinates":[-81.5486,28.2628]},{"Plant":"Gerald Andrus","State":"MS","Gas":734.2,"coordinates":[-91.1167,33.35]},{"Plant":"Waterford 1 & 2","State":"LA","Gas":778.4,"coordinates":[-90.4768,29.9989]},{"Plant":"Comanche","State":"OK","Gas":260,"coordinates":[-98.3244,34.5431]},{"Plant":"DeCordova Steam Electric Station","State":"TX","Gas":278,"coordinates":[-97.7006,32.4031]},{"Plant":"Santan","State":"AZ","Gas":1227,"coordinates":[-111.7503,33.3325]},{"Plant":"Beaver","State":"OR","Gas":487,"coordinates":[-123.1739,46.1724]},{"Plant":"Grand Tower","State":"IL","Gas":511,"coordinates":[-89.5112,37.6577]},{"Plant":"Astoria Generating Station","State":"NY","Gas":1319.6,"coordinates":[-73.9126,40.7877]},{"Plant":"Venice","State":"IL","Gas":488,"coordinates":[-90.1764,38.6642]},{"Plant":"Beluga","State":"AK","Gas":300.4,"coordinates":[-151.0356,61.1861]},{"Plant":"Marion","State":"IL","Gas":140,"coordinates":[-88.9531,37.6197]},{"Plant":"Frederickson","State":"WA","Gas":134,"coordinates":[-122.365,47.0797]},{"Plant":"Harding Street","State":"IN","Gas":288,"coordinates":[-86.1969,39.7113]}]

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports = [{"Plant":"Greene County","State":"AL","Gas":1248,"coordinates":[-87.7811,32.6017]},{"Plant":"NRG Energy Center Dover","State":"DE","Gas":104,"coordinates":[-75.5473,39.1495]},{"Plant":"Gilroy Power Plant","State":"CA","Gas":115,"coordinates":[-121.5367,37.0001]},{"Plant":"Noblesville","State":"IN","Gas":264,"coordinates":[-85.9714,40.0969]},{"Plant":"Pedricktown Cogeneration Company LP","State":"NJ","Gas":117.3,"coordinates":[-75.4238,39.7668]},{"Plant":"Broadway","State":"IN","Gas":115,"coordinates":[-87.6049,37.9691]},{"Plant":"Butler-Warner Generation Plant","State":"NC","Gas":225,"coordinates":[-78.8294,35.0986]},{"Plant":"El Segundo Cogen","State":"CA","Gas":171.6,"coordinates":[-118.4031,33.9058]},{"Plant":"ArcelorMittal Burns Harbor","State":"IN","Gas":174.7,"coordinates":[-87.1387,41.635]},{"Plant":"King City Power Plant","State":"CA","Gas":111,"coordinates":[-121.1278,36.225]},{"Plant":"Bayou Cogen Plant","State":"TX","Gas":290,"coordinates":[-95.0458,29.6225]},{"Plant":"Bellingham Cogeneration Facility","State":"MA","Gas":264,"coordinates":[-71.4833,42.0925]},{"Plant":"Sayreville Cogeneration Facility","State":"NJ","Gas":292,"coordinates":[-74.3444,40.439]},{"Plant":"Foster Wheeler Martinez","State":"CA","Gas":103.5,"coordinates":[-122.0589,38.0244]},{"Plant":"ExxonMobil Baytown Refinery","State":"TX","Gas":134,"coordinates":[-94.9973,29.7535]},{"Plant":"Milton L Kapp","State":"IA","Gas":112.5,"coordinates":[-90.2336,41.8081]},{"Plant":"Kern River Cogeneration","State":"CA","Gas":288,"coordinates":[-118.9849,35.4515]},{"Plant":"Formosa Utility Venture Ltd","State":"TX","Gas":597.3,"coordinates":[-96.5417,28.6917]},{"Plant":"Hopewell Cogeneration","State":"VA","Gas":378.3,"coordinates":[-77.2811,37.2917]},{"Plant":"Brush Generation Facility","State":"CO","Gas":292,"coordinates":[-103.631,40.2415]},{"Plant":"ExxonMobil Baytown Turbine","State":"TX","Gas":297,"coordinates":[-95.0096,29.7591]},{"Plant":"Selkirk Cogen","State":"NY","Gas":355.5,"coordinates":[-73.8592,42.5744]},{"Plant":"Masspower","State":"MA","Gas":245,"coordinates":[-72.5225,42.1575]},{"Plant":"Clear Lake Cogeneration Ltd","State":"TX","Gas":362.4,"coordinates":[-95.067,29.6255]},{"Plant":"Midland Cogeneration Venture","State":"MI","Gas":1859.4,"coordinates":[-84.2242,43.5861]},{"Plant":"Camden Plant Holding LLC","State":"NJ","Gas":145,"coordinates":[-75.1192,39.9175]},{"Plant":"Las Vegas Cogeneration LP","State":"NV","Gas":282,"coordinates":[-115.1222,36.2319]},{"Plant":"Sutherland","State":"IA","Gas":102.5,"coordinates":[-92.8594,42.0473]},{"Plant":"Sabine River Works","State":"TX","Gas":507,"coordinates":[-93.7579,30.0552]},{"Plant":"Riverside","State":"IA","Gas":113,"coordinates":[-90.4481,41.54]},{"Plant":"River Hills","State":"IA","Gas":116.9,"coordinates":[-93.6195,41.5902]},{"Plant":"Hazelton","State":"PA","Gas":145.6,"coordinates":[-76.0409,40.9282]},{"Plant":"Ames Electric Services Power Plant","State":"IA","Gas":105.4,"coordinates":[-93.6089,42.0258]},{"Plant":"Ocotillo","State":"AZ","Gas":320,"coordinates":[-111.9122,33.4225]},{"Plant":"West Phoenix","State":"AZ","Gas":932,"coordinates":[-112.1583,33.4417]},{"Plant":"Saguaro","State":"AZ","Gas":176,"coordinates":[-111.3,32.5517]},{"Plant":"Yucca","State":"AZ","Gas":257,"coordinates":[-114.7106,32.7214]},{"Plant":"Earl F Wisdom","State":"IA","Gas":113.5,"coordinates":[-95.2569,43.1606]},{"Plant":"Fort Dodge","State":"KS","Gas":147.8,"coordinates":[-99.9497,37.7328]},{"Plant":"Riverton","State":"KS","Gas":294,"coordinates":[-94.6987,37.0726]},{"Plant":"Gordon Evans Energy Center","State":"KS","Gas":815,"coordinates":[-97.5217,37.7903]},{"Plant":"Murray Gill","State":"KS","Gas":190,"coordinates":[-97.4136,37.5967]},{"Plant":"Hutchinson Energy Center","State":"KS","Gas":165,"coordinates":[-97.8747,38.0906]},{"Plant":"H Wilson Sundt Generating Station","State":"AZ","Gas":470,"coordinates":[-110.9047,32.16]},{"Plant":"Kaw","State":"KS","Gas":140.3,"coordinates":[-94.6514,39.0867]},{"Plant":"Quindaro","State":"KS","Gas":157,"coordinates":[-94.6381,39.1492]},{"Plant":"McPherson 2","State":"KS","Gas":104,"coordinates":[-97.6834,38.3634]},{"Plant":"Garden City","State":"KS","Gas":207.3,"coordinates":[-100.8956,37.9703]},{"Plant":"Big Sandy","State":"KY","Gas":260,"coordinates":[-82.6176,38.1707]},{"Plant":"E W Brown","State":"KY","Gas":906,"coordinates":[-84.7126,37.7883]},{"Plant":"Cane Run","State":"KY","Gas":677,"coordinates":[-85.8892,38.1831]},{"Plant":"Paddys Run","State":"KY","Gas":182,"coordinates":[-85.8417,38.2236]},{"Plant":"Louisiana 1","State":"LA","Gas":382.4,"coordinates":[-91.1864,30.4922]},{"Plant":"Louisiana 2","State":"LA","Gas":138,"coordinates":[-91.1864,30.4922]},{"Plant":"R S Nelson","State":"LA","Gas":570.7,"coordinates":[-93.2911,30.2844]},{"Plant":"Willow Glen","State":"LA","Gas":662,"coordinates":[-91.1164,30.2743]},{"Plant":"Coughlin Power Station","State":"LA","Gas":726.6,"coordinates":[-92.2611,30.8439]},{"Plant":"Teche","State":"LA","Gas":367.2,"coordinates":[-91.5425,29.8222]},{"Plant":"Little Gypsy","State":"LA","Gas":931.4,"coordinates":[-90.4617,30.0051]},{"Plant":"Nine Mile Point","State":"LA","Gas":1881.6,"coordinates":[-90.1458,29.9472]},{"Plant":"Sterlington","State":"LA","Gas":156.5,"coordinates":[-92.0792,32.7047]},{"Plant":"Agua Fria","State":"AZ","Gas":626,"coordinates":[-112.2153,33.5561]},{"Plant":"Arsenal Hill","State":"LA","Gas":116,"coordinates":[-93.7611,32.5181]},{"Plant":"Lieberman","State":"LA","Gas":243,"coordinates":[-93.9597,32.7047]},{"Plant":"Louis Doc Bonin","State":"LA","Gas":256,"coordinates":[-92.0463,30.238]},{"Plant":"Big Cajun 1","State":"LA","Gas":430,"coordinates":[-91.3556,30.6739]},{"Plant":"Kyrene","State":"AZ","Gas":525,"coordinates":[-111.9353,33.3556]},{"Plant":"Herbert A Wagner","State":"MD","Gas":126,"coordinates":[-76.5268,39.1781]},{"Plant":"Notch Cliff","State":"MD","Gas":116.7,"coordinates":[-76.5087,39.4217]},{"Plant":"Perryman","State":"MD","Gas":257.4,"coordinates":[-76.2218,39.4428]},{"Plant":"Westport","State":"MD","Gas":115.8,"coordinates":[-76.6295,39.266]},{"Plant":"Chalk Point LLC","State":"MD","Gas":1543,"coordinates":[-76.6861,38.5444]},{"Plant":"Dickerson","State":"MD","Gas":294,"coordinates":[-77.4644,39.2097]},{"Plant":"Mystic Generating Station","State":"MA","Gas":1417.3,"coordinates":[-71.0675,42.3908]},{"Plant":"Kendall Square Station","State":"MA","Gas":215.4,"coordinates":[-71.0792,42.3633]},{"Plant":"Apache Station","State":"AZ","Gas":198.5,"coordinates":[-109.8931,32.0603]},{"Plant":"Essential Power Massachusetts LLC","State":"MA","Gas":170.4,"coordinates":[-72.595,42.095]},{"Plant":"Potter Station 2","State":"MA","Gas":183.3,"coordinates":[-70.9672,42.235]},{"Plant":"Cleary Flood","State":"MA","Gas":105,"coordinates":[-71.1061,41.8653]},{"Plant":"Lake Catherine","State":"AR","Gas":519.7,"coordinates":[-92.9049,34.4341]},{"Plant":"Dan E Karn","State":"MI","Gas":1000,"coordinates":[-83.8401,43.645]},{"Plant":"Delray","State":"MI","Gas":127,"coordinates":[-83.1019,42.2947]},{"Plant":"Hancock","State":"MI","Gas":128,"coordinates":[-83.4425,42.5497]},{"Plant":"Black Dog","State":"MN","Gas":282,"coordinates":[-93.2501,44.8108]},{"Plant":"High Bridge","State":"MN","Gas":530,"coordinates":[-93.1117,44.9314]},{"Plant":"Inver Hills","State":"MN","Gas":282,"coordinates":[-93.042,44.781]},{"Plant":"Riverside","State":"MN","Gas":454,"coordinates":[-93.2753,45.0203]},{"Plant":"Thomas Fitzhugh","State":"AR","Gas":162,"coordinates":[-93.8049,35.4624]},{"Plant":"Carl Bailey","State":"AR","Gas":122,"coordinates":[-91.3634,35.2601]},{"Plant":"McClellan","State":"AR","Gas":134,"coordinates":[-92.7917,33.5648]},{"Plant":"Cambridge CT","State":"MN","Gas":156.8,"coordinates":[-93.2081,45.601]},{"Plant":"Elk River","State":"MN","Gas":183.2,"coordinates":[-93.5584,45.2968]},{"Plant":"Chevron Oil","State":"MS","Gas":132,"coordinates":[-88.4919,30.34]},{"Plant":"Jack Watson","State":"MS","Gas":856,"coordinates":[-89.0286,30.4392]},{"Plant":"Baxter Wilson","State":"MS","Gas":1224.5,"coordinates":[-90.9306,32.2831]},{"Plant":"Rex Brown","State":"MS","Gas":225.6,"coordinates":[-90.213,32.357]},{"Plant":"Moselle","State":"MS","Gas":477,"coordinates":[-89.3004,31.528]},{"Plant":"Hawthorn","State":"MO","Gas":391.7,"coordinates":[-94.4778,39.1306]},{"Plant":"Lake Road","State":"MO","Gas":125,"coordinates":[-94.8773,39.7246]},{"Plant":"James River Power Station","State":"MO","Gas":308,"coordinates":[-93.2619,37.1086]},{"Plant":"C W Burdick","State":"NE","Gas":135.6,"coordinates":[-98.3269,40.9228]},{"Plant":"North Omaha","State":"NE","Gas":241.6,"coordinates":[-95.9447,41.3291]},{"Plant":"Sarpy County","State":"NE","Gas":316.5,"coordinates":[-95.9706,41.1706]},{"Plant":"Clark","State":"NV","Gas":1141,"coordinates":[-115.0507,36.0875]},{"Plant":"Fort Churchill","State":"NV","Gas":226,"coordinates":[-119.1322,39.1281]},{"Plant":"Tracy","State":"NV","Gas":897.6,"coordinates":[-119.525,39.5625]},{"Plant":"Sayreville","State":"NJ","Gas":200,"coordinates":[-74.3523,40.4765]},{"Plant":"Gilbert","State":"NJ","Gas":444,"coordinates":[-75.1639,40.5658]},{"Plant":"Bergen Generating Station","State":"NJ","Gas":1229,"coordinates":[-74.0244,40.8375]},{"Plant":"PSEG Burlington Generating Station","State":"NJ","Gas":168,"coordinates":[-74.8792,40.0766]},{"Plant":"PSEG Hudson Generating Station","State":"NJ","Gas":565,"coordinates":[-74.0722,40.7478]},{"Plant":"PSEG Kearny Generating Station","State":"NJ","Gas":459.4,"coordinates":[-74.0965,40.7373]},{"Plant":"PSEG Linden Generating Station","State":"NJ","Gas":1566.2,"coordinates":[-74.2072,40.6217]},{"Plant":"PSEG Sewaren Generating Station","State":"NJ","Gas":444.8,"coordinates":[-74.2469,40.5558]},{"Plant":"Rio Grande","State":"NM","Gas":324.2,"coordinates":[-106.5472,31.8047]},{"Plant":"Maddox","State":"NM","Gas":183,"coordinates":[-103.3015,32.7142]},{"Plant":"Reeves","State":"NM","Gas":154,"coordinates":[-106.6019,35.171]},{"Plant":"Cunningham","State":"NM","Gas":466,"coordinates":[-103.3533,32.7131]},{"Plant":"Humboldt Bay","State":"CA","Gas":163.4,"coordinates":[-124.2103,40.7415]},{"Plant":"Danskammer Generating Station","State":"NY","Gas":495.8,"coordinates":[-73.975,41.5712]},{"Plant":"Arthur Kill Generating Station","State":"NY","Gas":858,"coordinates":[-74.2,40.5916]},{"Plant":"East River","State":"NY","Gas":630.1,"coordinates":[-73.9742,40.7281]},{"Plant":"Gowanus Gas Turbines Generating","State":"NY","Gas":279.8,"coordinates":[-74.0051,40.6635]},{"Plant":"Narrows Gas Turbines Generating","State":"NY","Gas":278.4,"coordinates":[-74.0208,40.6486]},{"Plant":"Ravenswood","State":"NY","Gas":2296.3,"coordinates":[-73.9461,40.7592]},{"Plant":"E F Barrett","State":"NY","Gas":668.2,"coordinates":[-73.6479,40.6167]},{"Plant":"Northport","State":"NY","Gas":1580.7,"coordinates":[-73.3423,40.9236]},{"Plant":"Port Jefferson","State":"NY","Gas":461.4,"coordinates":[-73.0785,40.9497]},{"Plant":"Bethlehem Energy Center","State":"NY","Gas":772.8,"coordinates":[-73.7638,42.5942]},{"Plant":"E C Gaston","State":"AL","Gas":1020,"coordinates":[-86.4581,33.2442]},{"Plant":"Dynegy Moss Landing Power Plant","State":"CA","Gas":1020,"coordinates":[-121.7822,36.8048]},{"Plant":"Bowline Point","State":"NY","Gas":1137,"coordinates":[-73.9689,41.2044]},{"Plant":"Asheville","State":"NC","Gas":320,"coordinates":[-82.5417,35.4731]},{"Plant":"Pittsburg Power","State":"CA","Gas":1311,"coordinates":[-121.8945,38.0392]},{"Plant":"Buck","State":"NC","Gas":668,"coordinates":[-80.3767,35.7133]},{"Plant":"Dan River","State":"NC","Gas":662,"coordinates":[-79.7208,36.4862]},{"Plant":"Dicks Creek","State":"OH","Gas":106.2,"coordinates":[-84.3778,39.465]},{"Plant":"Frank M Tait","State":"OH","Gas":256,"coordinates":[-84.2111,39.7272]},{"Plant":"Yankee Street","State":"OH","Gas":101.3,"coordinates":[-84.2047,39.603]},{"Plant":"FirstEnergy West Lorain","State":"OH","Gas":425,"coordinates":[-82.2644,41.4294]},{"Plant":"Richland","State":"OH","Gas":358,"coordinates":[-84.3346,41.3052]},{"Plant":"Hamilton","State":"OH","Gas":123,"coordinates":[-84.5543,39.4098]},{"Plant":"Horseshoe Lake","State":"OK","Gas":883.5,"coordinates":[-97.1797,35.5087]},{"Plant":"Mustang","State":"OK","Gas":431.5,"coordinates":[-97.675,35.4699]},{"Plant":"Seminole","State":"OK","Gas":1343.5,"coordinates":[-96.7258,34.9665]},{"Plant":"Northeastern","State":"OK","Gas":906,"coordinates":[-95.7008,36.4317]},{"Plant":"Southwestern","State":"OK","Gas":603,"coordinates":[-98.3524,35.1009]},{"Plant":"Tulsa","State":"OK","Gas":305,"coordinates":[-95.991,36.1165]},{"Plant":"Weleetka","State":"OK","Gas":163,"coordinates":[-96.1352,35.3233]},{"Plant":"Barry","State":"AL","Gas":1072,"coordinates":[-88.0103,31.0069]},{"Plant":"Anadarko Plant","State":"OK","Gas":485,"coordinates":[-98.23,35.0847]},{"Plant":"Mooreland","State":"OK","Gas":322,"coordinates":[-99.2254,36.4372]},{"Plant":"Encina","State":"CA","Gas":964,"coordinates":[-117.3364,33.1361]},{"Plant":"Brunot Island","State":"PA","Gas":244,"coordinates":[-80.0438,40.4649]},{"Plant":"Shawville","State":"PA","Gas":565,"coordinates":[-78.3662,41.0675]},{"Plant":"New Castle Plant","State":"PA","Gas":305,"coordinates":[-80.369,40.9379]},{"Plant":"PPL Martins Creek","State":"PA","Gas":1772,"coordinates":[-75.1054,40.7978]},{"Plant":"AES Alamitos LLC","State":"CA","Gas":1997,"coordinates":[-118.1009,33.7688]},{"Plant":"Eddystone Generating Station","State":"PA","Gas":760,"coordinates":[-75.323,39.858]},{"Plant":"Hunlock Power Station","State":"PA","Gas":127.3,"coordinates":[-76.07,41.2006]},{"Plant":"Manchester Street","State":"RI","Gas":468,"coordinates":[-71.4042,41.8167]},{"Plant":"Darlington County","State":"SC","Gas":432,"coordinates":[-80.1657,34.4185]},{"Plant":"W S Lee","State":"SC","Gas":254,"coordinates":[-82.435,34.6022]},{"Plant":"Hagood","State":"SC","Gas":126,"coordinates":[-79.9634,32.8265]},{"Plant":"McMeekin","State":"SC","Gas":250,"coordinates":[-81.2172,34.0556]},{"Plant":"Urquhart","State":"SC","Gas":639,"coordinates":[-81.9111,33.435]},{"Plant":"Etiwanda Generating Station","State":"CA","Gas":640,"coordinates":[-117.5266,34.0912]},{"Plant":"AES Huntington Beach LLC","State":"CA","Gas":451.6,"coordinates":[-117.9792,33.6439]},{"Plant":"Allen Steam Plant","State":"TN","Gas":427.2,"coordinates":[-90.1487,35.0741]},{"Plant":"Gallatin","State":"TN","Gas":579.6,"coordinates":[-86.4006,36.3156]},{"Plant":"John Sevier","State":"TN","Gas":878,"coordinates":[-82.9639,36.3767]},{"Plant":"Johnsonville","State":"TN","Gas":1044.8,"coordinates":[-87.9861,36.0278]},{"Plant":"Long Beach Generation LLC","State":"CA","Gas":260,"coordinates":[-118.2248,33.7641]},{"Plant":"Laredo","State":"TX","Gas":177.4,"coordinates":[-99.5089,27.5667]},{"Plant":"Nueces Bay","State":"TX","Gas":633,"coordinates":[-97.4192,27.8194]},{"Plant":"Victoria","State":"TX","Gas":285,"coordinates":[-97.01,28.7883]},{"Plant":"Mandalay","State":"CA","Gas":560,"coordinates":[-119.2511,34.2067]},{"Plant":"Lake Hubbard","State":"TX","Gas":915,"coordinates":[-96.5458,32.8358]},{"Plant":"Mountain Creek","State":"TX","Gas":808,"coordinates":[-96.9358,32.7231]},{"Plant":"Newman","State":"TX","Gas":760.9,"coordinates":[-106.4318,31.9836]},{"Plant":"Lewis Creek","State":"TX","Gas":502,"coordinates":[-95.5214,30.4356]},{"Plant":"Sabine","State":"TX","Gas":1581.8,"coordinates":[-93.878,30.0242]},{"Plant":"Cedar Bayou","State":"TX","Gas":1495,"coordinates":[-94.9256,29.75]},{"Plant":"Greens Bayou","State":"TX","Gas":760,"coordinates":[-95.2194,29.8222]},{"Plant":"Sam Bertron","State":"TX","Gas":765,"coordinates":[-95.0598,29.7268]},{"Plant":"T H Wharton","State":"TX","Gas":1025,"coordinates":[-95.5306,29.9417]},{"Plant":"W A Parish","State":"TX","Gas":1176,"coordinates":[-95.6311,29.4828]},{"Plant":"Knox Lee","State":"TX","Gas":471,"coordinates":[-94.6415,32.3766]},{"Plant":"Wilkes","State":"TX","Gas":883,"coordinates":[-94.548,32.8482]},{"Plant":"Jones","State":"TX","Gas":824,"coordinates":[-101.7392,33.5239]},{"Plant":"Nichols","State":"TX","Gas":457,"coordinates":[-101.7464,35.2834]},{"Plant":"Plant X","State":"TX","Gas":411,"coordinates":[-102.4114,34.1661]},{"Plant":"Graham","State":"TX","Gas":624,"coordinates":[-98.6117,33.1344]},{"Plant":"Handley","State":"TX","Gas":1265,"coordinates":[-97.2192,32.7283]},{"Plant":"Morgan Creek","State":"TX","Gas":407,"coordinates":[-100.9156,32.3358]},{"Plant":"Permian Basin","State":"TX","Gas":340,"coordinates":[-102.9633,31.5839]},{"Plant":"Ormond Beach","State":"CA","Gas":1516,"coordinates":[-119.1689,34.1292]},{"Plant":"Stryker Creek","State":"TX","Gas":669,"coordinates":[-94.9898,31.9398]},{"Plant":"Trinidad","State":"TX","Gas":235,"coordinates":[-96.1013,32.1245]},{"Plant":"Decker Creek","State":"TX","Gas":932,"coordinates":[-97.6128,30.3033]},{"Plant":"Silas Ray","State":"TX","Gas":107,"coordinates":[-97.5214,25.9131]},{"Plant":"AES Redondo Beach LLC","State":"CA","Gas":1310,"coordinates":[-118.395,33.8504]},{"Plant":"Ray Olinger","State":"TX","Gas":395,"coordinates":[-96.4525,33.0681]},{"Plant":"Mountainview Generating Station","State":"CA","Gas":972,"coordinates":[-117.2418,34.0818]},{"Plant":"Sim Gideon","State":"TX","Gas":607,"coordinates":[-97.2708,30.1456]},{"Plant":"Ty Cooke","State":"TX","Gas":120,"coordinates":[-101.7906,33.5211]},{"Plant":"Leon Creek","State":"TX","Gas":181,"coordinates":[-98.5761,29.3525]},{"Plant":"O W Sommers","State":"TX","Gas":830,"coordinates":[-98.3242,29.3081]},{"Plant":"V H Braunig","State":"TX","Gas":1053,"coordinates":[-98.3825,29.2567]},{"Plant":"R W Miller","State":"TX","Gas":574,"coordinates":[-98.3103,32.6581]},{"Plant":"Pearsall","State":"TX","Gas":270.6,"coordinates":[-99.0919,28.9275]},{"Plant":"Sam Rayburn","State":"TX","Gas":205,"coordinates":[-97.135,28.8947]},{"Plant":"Gadsby","State":"UT","Gas":354.5,"coordinates":[-111.9289,40.7686]},{"Plant":"Grayson","State":"CA","Gas":256,"coordinates":[-118.2782,34.1556]},{"Plant":"Clinch River","State":"VA","Gas":460,"coordinates":[-82.1997,36.9333]},{"Plant":"Bremo Bluff","State":"VA","Gas":227,"coordinates":[-78.2878,37.7089]},{"Plant":"Chesterfield","State":"VA","Gas":397,"coordinates":[-77.3833,37.3822]},{"Plant":"Possum Point","State":"VA","Gas":875,"coordinates":[-77.2806,38.5367]},{"Plant":"El Centro","State":"CA","Gas":314,"coordinates":[-115.54,32.8022]},{"Plant":"Harbor","State":"CA","Gas":437,"coordinates":[-118.2656,33.7706]},{"Plant":"Blount Street","State":"WI","Gas":101.6,"coordinates":[-89.3744,43.0789]},{"Plant":"Haynes","State":"CA","Gas":1571.8,"coordinates":[-118.0991,33.7647]},{"Plant":"Wheaton","State":"WI","Gas":190,"coordinates":[-91.5158,44.8854]},{"Plant":"Scattergood","State":"CA","Gas":794,"coordinates":[-118.4276,33.9182]},{"Plant":"Port Washington Generating Station","State":"WI","Gas":1182,"coordinates":[-87.8689,43.3842]},{"Plant":"Valley","State":"WI","Gas":240,"coordinates":[-87.9233,43.0303]},{"Plant":"Rock River","State":"WI","Gas":140.8,"coordinates":[-89.0276,42.582]},{"Plant":"West Marinette","State":"WI","Gas":149.4,"coordinates":[-87.6881,45.0869]},{"Plant":"Weston","State":"WI","Gas":131.4,"coordinates":[-89.6553,44.8606]},{"Plant":"Valley","State":"CA","Gas":556,"coordinates":[-118.3913,34.245]},{"Plant":"Powerlane Plant","State":"TX","Gas":111,"coordinates":[-96.1264,33.1707]},{"Plant":"Glenarm","State":"CA","Gas":235.6,"coordinates":[-118.1494,34.126]},{"Plant":"Spencer","State":"TX","Gas":122,"coordinates":[-97.1061,33.1975]},{"Plant":"Cherokee","State":"CO","Gas":576,"coordinates":[-104.9645,39.8073]},{"Plant":"Colbert","State":"AL","Gas":363.2,"coordinates":[-87.8486,34.7439]},{"Plant":"Thomas C Ferguson","State":"TX","Gas":516,"coordinates":[-98.3705,30.558]},{"Plant":"Barney M Davis","State":"TX","Gas":963,"coordinates":[-97.3117,27.6064]},{"Plant":"Riverside","State":"OK","Gas":1067,"coordinates":[-95.9567,35.9978]},{"Plant":"Pittsfield Generating LP","State":"MA","Gas":151.4,"coordinates":[-73.2181,42.4564]},{"Plant":"Linden Cogen Plant","State":"NJ","Gas":917.2,"coordinates":[-74.2156,40.6322]},{"Plant":"Houston Chemical Complex Battleground","State":"TX","Gas":263,"coordinates":[-95.0839,29.7314]},{"Plant":"Paris Energy Center","State":"TX","Gas":236,"coordinates":[-95.5577,33.6968]},{"Plant":"Hal C Weaver Power Plant","State":"TX","Gas":146.8,"coordinates":[-97.7356,30.2867]},{"Plant":"Sycamore Cogeneration","State":"CA","Gas":300,"coordinates":[-118.9853,35.4526]},{"Plant":"Union Carbide Seadrift Cogen","State":"TX","Gas":153,"coordinates":[-96.7706,28.5105]},{"Plant":"Dow St Charles Operations","State":"LA","Gas":270,"coordinates":[-90.4414,29.9861]},{"Plant":"Watson Cogeneration","State":"CA","Gas":398,"coordinates":[-118.2448,33.8166]},{"Plant":"Bucksport Generation LLC","State":"ME","Gas":156.8,"coordinates":[-68.8046,44.5738]},{"Plant":"Bethpage Power Plant","State":"NY","Gas":184,"coordinates":[-73.4994,40.7469]},{"Plant":"Shell Deer Park","State":"TX","Gas":140,"coordinates":[-95.1289,29.7232]},{"Plant":"Newark Bay Cogeneration Partnership LP","State":"NJ","Gas":120.2,"coordinates":[-74.13,40.7197]},{"Plant":"Indeck Corinth Energy Center","State":"NY","Gas":131.8,"coordinates":[-73.8125,43.25]},{"Plant":"Procter & Gamble Mehoopany Mill","State":"PA","Gas":104.9,"coordinates":[-76.0432,41.5743]},{"Plant":"PPG Powerhouse C","State":"LA","Gas":303.2,"coordinates":[-93.2831,30.2242]},{"Plant":"Axiall Natrium Plant","State":"WV","Gas":123,"coordinates":[-80.8547,39.7475]},{"Plant":"Bayonne Plant Holding LLC","State":"NJ","Gas":163,"coordinates":[-74.1124,40.6553]},{"Plant":"Harbor Cogen","State":"CA","Gas":101.7,"coordinates":[-118.2303,33.7771]},{"Plant":"Rosemary Power Station","State":"NC","Gas":165,"coordinates":[-77.6594,36.4517]},{"Plant":"Oklahoma Cogeneration Project","State":"OK","Gas":111.4,"coordinates":[-97.625,35.4397]},{"Plant":"Eagle Point Power Generation","State":"NJ","Gas":236.8,"coordinates":[-75.1592,39.8746]},{"Plant":"ExxonMobil Beaumont Refinery","State":"TX","Gas":610.6,"coordinates":[-94.0753,30.0636]},{"Plant":"JM Shafer Generating Station","State":"CO","Gas":263,"coordinates":[-104.7736,40.0986]},{"Plant":"Gary Works","State":"IN","Gas":161,"coordinates":[-87.3289,41.6224]},{"Plant":"Parlin Power Plant","State":"NJ","Gas":114.6,"coordinates":[-74.3272,40.4607]},{"Plant":"Optim Energy Altura Cogen LLC","State":"TX","Gas":536.5,"coordinates":[-95.1077,29.8161]},{"Plant":"Cumberland","State":"NJ","Gas":183.1,"coordinates":[-74.9654,39.3757]},{"Plant":"Hardee Power Station","State":"FL","Gas":373,"coordinates":[-81.9636,27.6364]},{"Plant":"Bellmeade Power Station","State":"VA","Gas":267,"coordinates":[-77.4317,37.4964]},{"Plant":"Motiva Enterprises Port Arthur Refinery","State":"TX","Gas":239.4,"coordinates":[-93.9569,29.8822]},{"Plant":"Ocean State Power","State":"RI","Gas":218.6,"coordinates":[-71.6689,42.0097]},{"Plant":"LaO Energy Systems","State":"LA","Gas":384,"coordinates":[-91.2325,30.3186]},{"Plant":"Doswell Energy Center","State":"VA","Gas":813.8,"coordinates":[-77.1448,37.8182]},{"Plant":"Elizabeth River Power Station","State":"VA","Gas":348,"coordinates":[-76.3083,36.775]},{"Plant":"Texas City Power Plant","State":"TX","Gas":451,"coordinates":[-94.9438,29.3787]},{"Plant":"Richmond Cogen","State":"CA","Gas":130.4,"coordinates":[-122.3909,37.9418]},{"Plant":"Dow Chemical Texas Operation","State":"TX","Gas":517.2,"coordinates":[-95.4075,28.9913]},{"Plant":"Power Station 4","State":"TX","Gas":172,"coordinates":[-94.9219,29.3782]},{"Plant":"Midway Sunset Cogen","State":"CA","Gas":219,"coordinates":[-119.6294,35.2269]},{"Plant":"C R Wing Cogen Plant","State":"TX","Gas":212,"coordinates":[-101.4224,32.2732]},{"Plant":"Delaware City Plant","State":"DE","Gas":265,"coordinates":[-75.6343,39.5871]},{"Plant":"McWilliams","State":"AL","Gas":663,"coordinates":[-86.4764,31.4003]},{"Plant":"J K Smith","State":"KY","Gas":784,"coordinates":[-84.1017,37.8833]},{"Plant":"Lockport Energy Associates LP","State":"NY","Gas":203.6,"coordinates":[-78.745,43.1619]},{"Plant":"Kennedy International Airport Cogen","State":"NY","Gas":124.7,"coordinates":[-73.7778,40.6417]},{"Plant":"March Point Cogeneration","State":"WA","Gas":120.2,"coordinates":[-122.56,48.4708]},{"Plant":"Saguaro Power","State":"NV","Gas":101,"coordinates":[-115.0117,36.0417]},{"Plant":"Ocean State Power II","State":"RI","Gas":218.6,"coordinates":[-71.6701,42.0099]},{"Plant":"Orange Cogeneration Facility","State":"FL","Gas":110.6,"coordinates":[-81.8251,27.8708]},{"Plant":"Pasco Cogen Ltd","State":"FL","Gas":121,"coordinates":[-82.1889,28.3746]},{"Plant":"Mulberry Cogeneration Facility","State":"FL","Gas":113,"coordinates":[-81.8775,27.8489]},{"Plant":"Orlando Cogen LP","State":"FL","Gas":120,"coordinates":[-81.4123,28.4426]},{"Plant":"Sumas Power Plant","State":"WA","Gas":125.5,"coordinates":[-122.2733,48.9905]},{"Plant":"Ferndale Generating Station","State":"WA","Gas":270,"coordinates":[-122.6867,48.8288]},{"Plant":"Hartwell Energy Facility","State":"GA","Gas":293.7,"coordinates":[-82.8199,34.3396]},{"Plant":"Sithe Independence Station","State":"NY","Gas":938.4,"coordinates":[-76.4511,43.495]},{"Plant":"Saranac Facility","State":"NY","Gas":246.4,"coordinates":[-73.4557,44.7132]},{"Plant":"NAEA Lakewood LLC","State":"NJ","Gas":233.1,"coordinates":[-74.1686,40.0613]},{"Plant":"Oyster Creek Unit VIII","State":"TX","Gas":379,"coordinates":[-95.342,28.9802]},{"Plant":"Hermiston Generating Plant","State":"OR","Gas":464,"coordinates":[-119.37,45.8042]},{"Plant":"Grays Ferry Cogeneration","State":"PA","Gas":170.6,"coordinates":[-75.1881,39.9422]},{"Plant":"Milford Power LP","State":"MA","Gas":148,"coordinates":[-71.5115,42.1294]},{"Plant":"Johnson County","State":"TX","Gas":267,"coordinates":[-97.4078,32.3994]},{"Plant":"Brandywine Power Facility","State":"MD","Gas":230,"coordinates":[-76.8678,38.6681]},{"Plant":"Gordonsville Energy LP","State":"VA","Gas":218,"coordinates":[-78.2138,38.1179]},{"Plant":"Sun Peak Generating Station","State":"NV","Gas":222,"coordinates":[-115.0339,36.1375]},{"Plant":"Brooklyn Navy Yard Cogeneration","State":"NY","Gas":250,"coordinates":[-73.9764,40.6994]},{"Plant":"Michigan Power LP","State":"MI","Gas":128,"coordinates":[-86.425,43.9375]},{"Plant":"LSP-Cottage Grove LP","State":"MN","Gas":251,"coordinates":[-92.9119,44.7956]},{"Plant":"LSP-Whitewater LP","State":"WI","Gas":261,"coordinates":[-88.7299,42.8555]},{"Plant":"Sweeny Cogen Facility","State":"TX","Gas":436,"coordinates":[-95.745,29.0728]},{"Plant":"Dighton Power Plant","State":"MA","Gas":162.8,"coordinates":[-71.1239,41.8312]},{"Plant":"De Pere Energy Center","State":"WI","Gas":169.5,"coordinates":[-88.072,44.4486]},{"Plant":"Androscoggin Energy Center","State":"ME","Gas":136.5,"coordinates":[-70.2423,44.5063]},{"Plant":"Delta Person LLC","State":"NM","Gas":138,"coordinates":[-106.644,35.026]},{"Plant":"Mid-Georgia Cogeneration Facility","State":"GA","Gas":303,"coordinates":[-83.6039,32.4856]},{"Plant":"Berkshire Power","State":"MA","Gas":229.3,"coordinates":[-72.6478,42.0476]},{"Plant":"Bridgeport Energy Project","State":"CT","Gas":492,"coordinates":[-73.1844,41.1692]},{"Plant":"Pasadena Cogeneration","State":"TX","Gas":710,"coordinates":[-95.1765,29.7248]},{"Plant":"Tiverton Power Plant","State":"RI","Gas":268,"coordinates":[-71.1706,41.6422]},{"Plant":"Axiall Plaquemine","State":"LA","Gas":225,"coordinates":[-91.185,30.2586]},{"Plant":"Tenaska Georgia Generation Facility","State":"GA","Gas":945,"coordinates":[-84.9996,33.3516]},{"Plant":"Tenaska Frontier Generation Station","State":"TX","Gas":860,"coordinates":[-95.9178,30.5924]},{"Plant":"Batesville Generation Facility","State":"MS","Gas":858,"coordinates":[-89.9275,34.3356]},{"Plant":"Black Hawk Station","State":"TX","Gas":219.4,"coordinates":[-101.36,35.6957]},{"Plant":"Mustang Station","State":"TX","Gas":479,"coordinates":[-102.7417,32.9728]},{"Plant":"Maine Independence Station","State":"ME","Gas":490,"coordinates":[-68.7094,44.8242]},{"Plant":"Pine Bluff Energy Center","State":"AR","Gas":192,"coordinates":[-91.9025,34.2181]},{"Plant":"Desert Star Energy Center","State":"NV","Gas":450,"coordinates":[-114.9928,35.7867]},{"Plant":"Millennium Power","State":"MA","Gas":334.9,"coordinates":[-72.0151,42.1123]},{"Plant":"New Albany Energy Facility","State":"MS","Gas":360,"coordinates":[-88.9397,34.5408]},{"Plant":"Brownsville Peaking Power","State":"TN","Gas":456,"coordinates":[-89.198,35.5438]},{"Plant":"Crockett Cogen Project","State":"CA","Gas":247.4,"coordinates":[-122.2161,38.0569]},{"Plant":"Gregory Power Facility","State":"TX","Gas":366,"coordinates":[-97.2584,27.8893]},{"Plant":"Zeeland Generating Station","State":"MI","Gas":842.1,"coordinates":[-85.9975,42.8206]},{"Plant":"Dearborn Industrial Generation","State":"MI","Gas":741.6,"coordinates":[-83.154,42.3026]},{"Plant":"Taft Cogeneration Facility","State":"LA","Gas":738.9,"coordinates":[-90.4599,29.9888]},{"Plant":"Midlothian Energy Facility","State":"TX","Gas":1483,"coordinates":[-97.0537,32.4302]},{"Plant":"Lamar Power Project","State":"TX","Gas":1018,"coordinates":[-95.59,33.6308]},{"Plant":"NRG Sterlington Power","State":"LA","Gas":176,"coordinates":[-92.0811,32.6889]},{"Plant":"Rumford Power Associates","State":"ME","Gas":254,"coordinates":[-70.5219,44.5303]},{"Plant":"Livingston Generating Station","State":"MI","Gas":132,"coordinates":[-84.7308,45.0304]},{"Plant":"Klamath Cogeneration Plant","State":"OR","Gas":490,"coordinates":[-121.8106,42.1739]},{"Plant":"Entergy Rhode Island State Energy LP","State":"RI","Gas":544,"coordinates":[-71.5186,41.8017]},{"Plant":"Rocky Road Power LLC","State":"IL","Gas":332,"coordinates":[-88.2397,42.0931]},{"Plant":"Madison","State":"OH","Gas":566,"coordinates":[-84.4647,39.4522]},{"Plant":"Vermillion Energy Facility","State":"IN","Gas":576,"coordinates":[-87.4464,39.9223]},{"Plant":"Sutter Energy Center","State":"CA","Gas":530,"coordinates":[-121.6959,39.0531]},{"Plant":"Rockingham County CT Station","State":"NC","Gas":825,"coordinates":[-79.8297,36.3297]},{"Plant":"RS Cogen","State":"LA","Gas":415.4,"coordinates":[-93.2992,30.221]},{"Plant":"Magic Valley Generating Station","State":"TX","Gas":682,"coordinates":[-98.19,26.3403]},{"Plant":"Griffith Energy LLC","State":"AZ","Gas":570,"coordinates":[-114.1333,35.054]},{"Plant":"Milford Power Project","State":"CT","Gas":506.7,"coordinates":[-73.0997,41.2244]},{"Plant":"Manchief Electric Generating Station","State":"CO","Gas":264,"coordinates":[-103.685,40.2171]},{"Plant":"Walton County Power LLC","State":"GA","Gas":454.5,"coordinates":[-83.6954,33.8148]},{"Plant":"Desert Basin","State":"AZ","Gas":577,"coordinates":[-111.7889,32.9042]},{"Plant":"Kendall County Generation Facility","State":"IL","Gas":1140,"coordinates":[-88.2581,41.4797]},{"Plant":"Tenaska Gateway Generating Station","State":"TX","Gas":845,"coordinates":[-94.6197,32.0178]},{"Plant":"Alliant Energy Neenah","State":"WI","Gas":298.9,"coordinates":[-88.5064,44.1936]},{"Plant":"Rio Nogales Power Project","State":"TX","Gas":785,"coordinates":[-97.9732,29.5931]},{"Plant":"Wolf Hollow I LP","State":"TX","Gas":705,"coordinates":[-97.7317,32.3342]},{"Plant":"Hawk Road Facility","State":"GA","Gas":486.9,"coordinates":[-84.9914,33.3585]},{"Plant":"Hays Energy Project","State":"TX","Gas":881,"coordinates":[-97.9894,29.7806]},{"Plant":"Green Country Energy LLC","State":"OK","Gas":783,"coordinates":[-95.9346,35.9833]},{"Plant":"Worthington Generation LLC","State":"IN","Gas":174.5,"coordinates":[-87.0128,39.0708]},{"Plant":"Lake Road Generating Plant","State":"CT","Gas":750.6,"coordinates":[-71.8958,41.872]},{"Plant":"La Paloma Generating LLC","State":"CA","Gas":965.4,"coordinates":[-119.5919,35.2956]},{"Plant":"Guadalupe Generating Station","State":"TX","Gas":986,"coordinates":[-98.1419,29.6244]},{"Plant":"Lost Pines 1 Power Project","State":"TX","Gas":510,"coordinates":[-97.2714,30.1478]},{"Plant":"Bluegrass Generating Station","State":"KY","Gas":501,"coordinates":[-85.4133,38.3902]},{"Plant":"Calcasieu","State":"LA","Gas":299.5,"coordinates":[-93.345,30.1608]},{"Plant":"Broad River Energy Center","State":"SC","Gas":848.3,"coordinates":[-81.575,35.0786]},{"Plant":"Bastrop Energy Center","State":"TX","Gas":525,"coordinates":[-97.55,30.1458]},{"Plant":"Granite Ridge","State":"NH","Gas":678,"coordinates":[-71.4261,42.9042]},{"Plant":"Bosque County Peaking","State":"TX","Gas":748,"coordinates":[-97.3586,31.8594]},{"Plant":"Acadia Energy Center","State":"LA","Gas":1118.2,"coordinates":[-92.4131,30.4286]},{"Plant":"Eastman Cogeneration Facility","State":"TX","Gas":402.2,"coordinates":[-94.6903,32.4481]},{"Plant":"South Point Energy Center","State":"AZ","Gas":550,"coordinates":[-114.5317,34.8678]},{"Plant":"Dogwood Energy Facility","State":"MO","Gas":619.3,"coordinates":[-94.3006,38.7931]},{"Plant":"Rathdrum Power LLC","State":"ID","Gas":248,"coordinates":[-116.9203,47.7858]},{"Plant":"Sunrise Power LLC","State":"CA","Gas":545,"coordinates":[-119.585,35.2097]},{"Plant":"Nelson Energy Center","State":"IL","Gas":586,"coordinates":[-89.6072,41.7744]},{"Plant":"Channelview Cogeneration Plant","State":"TX","Gas":810,"coordinates":[-95.1217,29.837]},{"Plant":"Cordova Energy","State":"IL","Gas":521.2,"coordinates":[-90.2797,41.7122]},{"Plant":"Osceola","State":"FL","Gas":471,"coordinates":[-81.0978,28.1289]},{"Plant":"Ontelaunee Energy Center","State":"PA","Gas":540,"coordinates":[-75.9356,40.4219]},{"Plant":"Caledonia","State":"MS","Gas":765,"coordinates":[-88.2717,33.6464]},{"Plant":"Riverside Generating LLC","State":"KY","Gas":825,"coordinates":[-82.6046,38.1917]},{"Plant":"Elwood Energy LLC","State":"IL","Gas":1350,"coordinates":[-88.1236,41.4388]},{"Plant":"Arapahoe Combustion Turbine Project","State":"CO","Gas":122.5,"coordinates":[-105.0018,39.6692]},{"Plant":"Gibson City","State":"IL","Gas":228,"coordinates":[-88.3987,40.4705]},{"Plant":"Pinckneyville","State":"IL","Gas":316,"coordinates":[-89.3467,38.1114]},{"Plant":"Kinmundy","State":"IL","Gas":207,"coordinates":[-89.0128,38.7619]},{"Plant":"Corpus Christi Energy Center","State":"TX","Gas":469,"coordinates":[-97.4283,27.8139]},{"Plant":"Afton Generating Station","State":"NM","Gas":235.6,"coordinates":[-106.8465,32.1142]},{"Plant":"ANP Bellingham Energy Project","State":"MA","Gas":502,"coordinates":[-71.4535,42.1106]},{"Plant":"ANP Blackstone Energy Project","State":"MA","Gas":477,"coordinates":[-71.5158,42.0599]},{"Plant":"Odessa Ector Generating Station","State":"TX","Gas":990.8,"coordinates":[-102.3264,31.8403]},{"Plant":"Morris Cogeneration LLC","State":"IL","Gas":190.6,"coordinates":[-88.3328,41.4119]},{"Plant":"Los Medanos Energy Center","State":"CA","Gas":567,"coordinates":[-121.873,38.0301]},{"Plant":"Hinds Energy Facility","State":"MS","Gas":454,"coordinates":[-90.2199,32.379]},{"Plant":"Attala","State":"MS","Gas":457,"coordinates":[-89.6753,33.0147]},{"Plant":"Harry L. Oswald","State":"AR","Gas":548,"coordinates":[-92.2166,34.5923]},{"Plant":"Lincoln Generating Facility","State":"IL","Gas":622.9,"coordinates":[-87.9436,41.3933]},{"Plant":"Ennis Power Company LLC","State":"TX","Gas":359.5,"coordinates":[-96.675,32.32]},{"Plant":"Wheatland Generating Facility","State":"IN","Gas":450,"coordinates":[-87.2931,38.6716]},{"Plant":"Oneta Energy Center","State":"OK","Gas":1086.4,"coordinates":[-95.6967,36.0119]},{"Plant":"Freestone Energy Center","State":"TX","Gas":953,"coordinates":[-96.1131,31.8907]},{"Plant":"Greenville Electric Generating Station","State":"OH","Gas":196,"coordinates":[-84.6151,40.0758]},{"Plant":"Montpelier Electric Generating Station","State":"IN","Gas":236,"coordinates":[-85.3057,40.6206]},{"Plant":"Jack County","State":"TX","Gas":1241,"coordinates":[-97.9574,33.101]},{"Plant":"Liberty Electric Power Plant","State":"PA","Gas":551.5,"coordinates":[-75.3358,39.8614]},{"Plant":"Marshall Energy Facility","State":"KY","Gas":581.6,"coordinates":[-88.3958,37.0286]},{"Plant":"Handsome Lake Energy LLC","State":"PA","Gas":267.5,"coordinates":[-79.8061,41.2908]},{"Plant":"Audrain Generating Station","State":"MO","Gas":600,"coordinates":[-91.5369,39.3092]},{"Plant":"Lee Energy Facility","State":"IL","Gas":568,"coordinates":[-89.4054,41.8287]},{"Plant":"Energy Shelby County","State":"IL","Gas":336,"coordinates":[-88.4772,39.2794]},{"Plant":"NRG Rockford I","State":"IL","Gas":299.5,"coordinates":[-89.1012,42.2386]},{"Plant":"Red Oak Power LLC","State":"NJ","Gas":765.9,"coordinates":[-74.3489,40.4487]},{"Plant":"Hog Bayou Energy Center","State":"AL","Gas":230,"coordinates":[-88.0575,30.7478]},{"Plant":"Santa Rosa Energy Center","State":"FL","Gas":235.9,"coordinates":[-87.115,30.5664]},{"Plant":"Astoria Gas Turbines","State":"NY","Gas":413.8,"coordinates":[-73.9048,40.787]},{"Plant":"Doyle Energy Facility","State":"GA","Gas":329,"coordinates":[-83.6996,33.8377]},{"Plant":"Darby Electric Generating Station","State":"OH","Gas":435,"coordinates":[-83.1778,39.7139]},{"Plant":"Tait Electric Generating Station","State":"OH","Gas":340,"coordinates":[-84.2095,39.7277]},{"Plant":"University Park South","State":"IL","Gas":300,"coordinates":[-87.7532,41.4409]},{"Plant":"Gleason Generating Facility","State":"TN","Gas":360,"coordinates":[-88.612,36.2454]},{"Plant":"Crete Energy Venture LLC","State":"IL","Gas":300,"coordinates":[-87.6187,41.4294]},{"Plant":"Whiting Clean Energy","State":"IN","Gas":513,"coordinates":[-87.4775,41.6739]},{"Plant":"Edward L. Addison Generating Plant","State":"GA","Gas":595.1,"coordinates":[-84.3064,32.9111]},{"Plant":"TVA Southaven Combined Cycle","State":"MS","Gas":780,"coordinates":[-90.0378,34.9939]},{"Plant":"Jackson Generating Station","State":"MI","Gas":547,"coordinates":[-84.3767,42.2488]},{"Plant":"Tenaska Lindsay Hill Generating Station","State":"AL","Gas":845,"coordinates":[-86.7386,32.6514]},{"Plant":"Ceredo Generating Station","State":"WV","Gas":450,"coordinates":[-82.5339,38.3681]},{"Plant":"Aurora","State":"IL","Gas":928,"coordinates":[-88.2265,41.8151]},{"Plant":"Southeast Chicago Energy Project","State":"IL","Gas":296,"coordinates":[-87.5449,41.7181]},{"Plant":"Arlington Valley Energy Facility","State":"AZ","Gas":580,"coordinates":[-112.8897,33.3417]},{"Plant":"Front Range Power Plant","State":"CO","Gas":460,"coordinates":[-104.7069,38.6281]},{"Plant":"Big Sandy Peaker Plant","State":"WV","Gas":300,"coordinates":[-82.5938,38.3441]},{"Plant":"Wolf Hills Energy","State":"VA","Gas":250,"coordinates":[-82.1044,36.6644]},{"Plant":"Oleander Power Project LP","State":"FL","Gas":790.2,"coordinates":[-80.7947,28.3661]},{"Plant":"Decatur Energy Center","State":"AL","Gas":725,"coordinates":[-87.0214,34.6292]},{"Plant":"Morgan Energy Center","State":"AL","Gas":749,"coordinates":[-87.0639,34.6397]},{"Plant":"Westbrook Energy Center Power Plant","State":"ME","Gas":506,"coordinates":[-70.375,43.6575]},{"Plant":"Blythe Energy Inc","State":"CA","Gas":514,"coordinates":[-114.6865,33.6157]},{"Plant":"Calumet Energy Team LLC","State":"IL","Gas":321.2,"coordinates":[-87.5563,41.6835]},{"Plant":"New Covert Generating Facility","State":"MI","Gas":1055.5,"coordinates":[-86.2937,42.3224]},{"Plant":"Fairless Energy Center","State":"PA","Gas":1272,"coordinates":[-74.7411,40.1475]},{"Plant":"Channel Energy Center LLC","State":"TX","Gas":768,"coordinates":[-95.2319,29.7189]},{"Plant":"Baconton Power Plant","State":"GA","Gas":196,"coordinates":[-84.08,31.3869]},{"Plant":"Gila River Power Station","State":"AZ","Gas":515,"coordinates":[-112.6944,32.975]},{"Plant":"Air Products Port Arthur","State":"TX","Gas":158.9,"coordinates":[-93.9651,29.8665]},{"Plant":"Ingleside Cogeneration","State":"TX","Gas":460,"coordinates":[-97.2428,27.8828]},{"Plant":"Fore River Generating Station","State":"MA","Gas":726,"coordinates":[-70.9661,42.2422]},{"Plant":"Indian River","State":"FL","Gas":576.4,"coordinates":[-80.7802,28.4932]},{"Plant":"Wise County Power LLC","State":"TX","Gas":680,"coordinates":[-97.9103,33.0583]},{"Plant":"Chuck Lenzie Generating Station","State":"NV","Gas":1170,"coordinates":[-114.9218,36.3837]},{"Plant":"Baytown Energy Center","State":"TX","Gas":770,"coordinates":[-94.9019,29.7731]},{"Plant":"Hermiston Power Partnership","State":"OR","Gas":615,"coordinates":[-119.3133,45.794]},{"Plant":"Washington County","State":"GA","Gas":615.5,"coordinates":[-82.98,33.0922]},{"Plant":"Delta Energy Center","State":"CA","Gas":769.1,"coordinates":[-121.8439,38.0169]},{"Plant":"Holland Energy Facility","State":"IL","Gas":610.4,"coordinates":[-88.7584,39.2231]},{"Plant":"PPL Ironwood LLC","State":"PA","Gas":660.1,"coordinates":[-76.3658,40.3509]},{"Plant":"Dell Power Station","State":"AR","Gas":429,"coordinates":[-90.0253,35.8619]},{"Plant":"Luna Energy Facility","State":"NM","Gas":559,"coordinates":[-107.7834,32.2993]},{"Plant":"Otay Mesa Generating Project","State":"CA","Gas":571,"coordinates":[-116.915,32.5815]},{"Plant":"Armstrong","State":"PA","Gas":603.1,"coordinates":[-79.3517,40.638]},{"Plant":"Troy Energy LLC","State":"OH","Gas":584,"coordinates":[-83.4598,41.4772]},{"Plant":"Pleasants Energy LLC","State":"WV","Gas":321.3,"coordinates":[-81.3642,39.3325]},{"Plant":"Dresden Energy Facility","State":"OH","Gas":540,"coordinates":[-82.0276,40.0928]},{"Plant":"Brazos Valley Generating Facility","State":"TX","Gas":525,"coordinates":[-95.6244,29.4731]},{"Plant":"Cottonwood Energy Project","State":"TX","Gas":1180,"coordinates":[-93.7353,30.2588]},{"Plant":"Sugar Creek Power","State":"IN","Gas":549,"coordinates":[-87.5108,39.3931]},{"Plant":"Exelon LaPorte Generating Station","State":"TX","Gas":152,"coordinates":[-95.0718,29.7028]},{"Plant":"Harquahala Generating Project","State":"AZ","Gas":1042.9,"coordinates":[-113.1134,33.476]},{"Plant":"Astoria Energy","State":"NY","Gas":540,"coordinates":[-73.8964,40.7825]},{"Plant":"Union Power Partners LP","State":"AR","Gas":2039.5,"coordinates":[-92.5894,33.2961]},{"Plant":"Thomas A Smith Energy Facility","State":"GA","Gas":1260,"coordinates":[-84.9175,34.7094]},{"Plant":"Columbia Energy Center","State":"SC","Gas":543,"coordinates":[-81.0178,33.8697]},{"Plant":"RockGen Energy Center","State":"WI","Gas":471,"coordinates":[-89.0492,42.9767]},{"Plant":"Zion Energy Center","State":"IL","Gas":456,"coordinates":[-87.895,42.4776]},{"Plant":"Metcalf Energy Center","State":"CA","Gas":546.1,"coordinates":[-121.7457,37.2207]},{"Plant":"Crossroads Energy Center","State":"MS","Gas":308,"coordinates":[-90.5621,34.183]},{"Plant":"Washington Energy Facility","State":"OH","Gas":661,"coordinates":[-81.6564,39.58]},{"Plant":"Elk Hills Power LLC","State":"CA","Gas":525,"coordinates":[-119.4707,35.2803]},{"Plant":"Rolling Hills Generating","State":"OH","Gas":825,"coordinates":[-82.3328,39.0839]},{"Plant":"Renaissance Power LLC","State":"MI","Gas":652,"coordinates":[-84.8429,43.1864]},{"Plant":"Carville Energy LLC","State":"LA","Gas":525,"coordinates":[-91.065,30.2294]},{"Plant":"Athens Generating Plant","State":"NY","Gas":980.8,"coordinates":[-73.8492,42.2728]},{"Plant":"Effingham County Power Project","State":"GA","Gas":509,"coordinates":[-81.2844,32.2773]},{"Plant":"Calhoun Energy Center","State":"AL","Gas":632,"coordinates":[-85.9731,33.5883]},{"Plant":"Hillabee Energy Center","State":"AL","Gas":721.8,"coordinates":[-85.9033,33.0007]},{"Plant":"Osprey Energy Center Power Plant","State":"FL","Gas":590,"coordinates":[-81.8083,28.0525]},{"Plant":"Shady Hills Generating Station","State":"FL","Gas":463.2,"coordinates":[-82.5586,28.3665]},{"Plant":"Vandolah Power Station","State":"FL","Gas":646,"coordinates":[-81.924,27.5236]},{"Plant":"Raccoon Creek Energy Center","State":"IL","Gas":300,"coordinates":[-88.5392,38.6996]},{"Plant":"Hot Spring Generating Facility","State":"AR","Gas":608.5,"coordinates":[-92.8683,34.2976]},{"Plant":"Plaquemine Cogeneration Plant","State":"LA","Gas":793,"coordinates":[-91.2347,30.3217]},{"Plant":"Bayou Cove Peaking Power","State":"LA","Gas":300,"coordinates":[-92.5997,30.2825]},{"Plant":"Elgin Energy Center","State":"IL","Gas":460,"coordinates":[-88.2446,42.0001]},{"Plant":"Tenaska Virginia Generating Station","State":"VA","Gas":943.7,"coordinates":[-78.3813,37.8667]},{"Plant":"Tenaska Central Alabama Generating Stn","State":"AL","Gas":919.2,"coordinates":[-86.74,32.6497]},{"Plant":"Columbia Energy Center","State":"MO","Gas":140,"coordinates":[-92.2629,39.0192]},{"Plant":"Magnolia Power Plant","State":"MS","Gas":918,"coordinates":[-89.2026,34.835]},{"Plant":"Fountain Valley Power Facility","State":"CO","Gas":234,"coordinates":[-104.6875,38.5569]},{"Plant":"Red Hawk","State":"AZ","Gas":934,"coordinates":[-112.8406,33.3346]},{"Plant":"McClain Energy Facility","State":"OK","Gas":492.2,"coordinates":[-97.5898,35.2977]},{"Plant":"Redbud Power Plant","State":"OK","Gas":1207.4,"coordinates":[-97.2264,35.6856]},{"Plant":"Deer Park Energy Center","State":"TX","Gas":1116,"coordinates":[-95.1345,29.7134]},{"Plant":"Ouachita","State":"LA","Gas":758.5,"coordinates":[-92.0683,32.7061]},{"Plant":"Green Power 2","State":"TX","Gas":825.5,"coordinates":[-94.9328,29.3781]},{"Plant":"Forney Energy Center","State":"TX","Gas":1838,"coordinates":[-96.4916,32.7563]},{"Plant":"Mesquite Generating Station","State":"AZ","Gas":595,"coordinates":[-112.8642,33.345]},{"Plant":"Goldendale Generating Station","State":"WA","Gas":263.7,"coordinates":[-120.833,45.8114]},{"Plant":"Tri Center Naniwa Energy","State":"NV","Gas":200,"coordinates":[-119.5178,39.5572]},{"Plant":"Goose Creek Energy Center","State":"IL","Gas":432,"coordinates":[-88.5999,40.1069]},{"Plant":"Kiamichi Energy Facility","State":"OK","Gas":1178.4,"coordinates":[-95.9349,34.6831]},{"Plant":"Lawrenceburg Energy Facility","State":"IN","Gas":1080,"coordinates":[-84.8669,39.0911]},{"Plant":"AEP Waterford Facility","State":"OH","Gas":810,"coordinates":[-81.7178,39.5333]},{"Plant":"Limon Generating Station","State":"CO","Gas":134,"coordinates":[-103.7005,39.2038]},{"Plant":"Frank Knutson","State":"CO","Gas":134,"coordinates":[-104.682,39.9411]},{"Plant":"Apex Generating Station","State":"NV","Gas":494.4,"coordinates":[-114.9609,36.416]},{"Plant":"Fayette Energy Facility","State":"PA","Gas":662,"coordinates":[-79.9182,39.8592]},{"Plant":"Wallingford Energy","State":"CT","Gas":211.5,"coordinates":[-72.8354,41.4487]},{"Plant":"High Desert Power Plant","State":"CA","Gas":774.3,"coordinates":[-117.3647,34.5953]},{"Plant":"Sundance","State":"AZ","Gas":410,"coordinates":[-111.5899,32.9285]},{"Plant":"York Energy Center","State":"PA","Gas":545,"coordinates":[-76.3067,39.7375]},{"Plant":"Indigo Energy Facility","State":"CA","Gas":142.5,"coordinates":[-116.553,33.9109]},{"Plant":"Hidalgo Energy Center","State":"TX","Gas":470,"coordinates":[-98.1758,26.3417]},{"Plant":"Perryville Power Station","State":"LA","Gas":690.5,"coordinates":[-92.0183,32.6908]},{"Plant":"West Valley Generation Project","State":"UT","Gas":185,"coordinates":[-112.0317,40.6667]},{"Plant":"University Park North","State":"IL","Gas":504,"coordinates":[-87.7514,41.4425]},{"Plant":"Riverside Energy Center","State":"WI","Gas":566.4,"coordinates":[-89.0355,42.5827]},{"Plant":"Blue Spruce Energy Center","State":"CO","Gas":264,"coordinates":[-104.6814,39.7479]},{"Plant":"Plains End","State":"CO","Gas":114,"coordinates":[-105.226,39.8575]},{"Plant":"Spring Creek Energy Center","State":"OK","Gas":273,"coordinates":[-97.655,35.7422]},{"Plant":"Pastoria Energy Facility, LLC","State":"CA","Gas":765,"coordinates":[-118.844,34.9556]},{"Plant":"EP Newington Energy LLC","State":"NH","Gas":553,"coordinates":[-70.8061,43.1047]},{"Plant":"Chehalis Generating Facility","State":"WA","Gas":477,"coordinates":[-122.9131,46.6225]},{"Plant":"Harrison County Power Project","State":"TX","Gas":514.4,"coordinates":[-94.4367,32.3958]},{"Plant":"Lower Mount Bethel Energy","State":"PA","Gas":537.5,"coordinates":[-75.1076,40.8019]},{"Plant":"AL Sandersville LLC","State":"GA","Gas":576.4,"coordinates":[-82.8608,33.1189]},{"Plant":"Higgins Generating Station","State":"NV","Gas":550,"coordinates":[-115.3561,35.6139]},{"Plant":"Bethlehem Power Plant","State":"PA","Gas":1134,"coordinates":[-75.3147,40.6175]},{"Plant":"Quantum Choctaw Power LLC","State":"MS","Gas":710,"coordinates":[-89.2089,33.3792]},{"Plant":"Mint Farm Generating Station","State":"WA","Gas":275.9,"coordinates":[-122.9855,46.1388]},{"Plant":"Fremont Energy Center","State":"OH","Gas":671.9,"coordinates":[-83.1614,41.3771]},{"Plant":"Choctaw County","State":"MS","Gas":781,"coordinates":[-89.4201,33.2881]},{"Plant":"Allegheny Energy Units 3 4 & 5","State":"PA","Gas":509,"coordinates":[-79.7686,40.5453]},{"Plant":"Magnet Cove","State":"AR","Gas":641.5,"coordinates":[-92.8317,34.4297]},{"Plant":"Dean","State":"MI","Gas":312,"coordinates":[-82.4953,42.7725]},{"Plant":"Bennett Mountain","State":"ID","Gas":164,"coordinates":[-115.6666,43.1472]},{"Plant":"Hanging Rock Energy Facility","State":"OH","Gas":1322,"coordinates":[-82.7833,38.5731]},{"Plant":"Los Esteros Critical Energy Center","State":"CA","Gas":306.1,"coordinates":[-121.9319,37.425]},{"Plant":"FPL Energy Marcus Hook LP","State":"PA","Gas":785.7,"coordinates":[-75.4216,39.807]},{"Plant":"Valencia Energy Facility","State":"NM","Gas":144.3,"coordinates":[-106.7322,34.6115]},{"Plant":"Gilroy Peaking Energy Center","State":"CA","Gas":135,"coordinates":[-121.5363,36.999]},{"Plant":"Frederickson Power LP","State":"WA","Gas":242,"coordinates":[-122.3657,47.0861]},{"Plant":"Curtis H Stanton Energy Center","State":"FL","Gas":657,"coordinates":[-81.1669,28.4882]},{"Plant":"Auburndale Peaker Energy Center","State":"FL","Gas":117,"coordinates":[-81.8059,28.0535]},{"Plant":"Rocky Mountain Energy Center","State":"CO","Gas":580,"coordinates":[-104.5953,40.0908]},{"Plant":"Silverhawk","State":"NV","Gas":560,"coordinates":[-114.9606,36.4078]},{"Plant":"Inland Empire Energy Center","State":"CA","Gas":690,"coordinates":[-117.1704,33.7388]},{"Plant":"Jasper","State":"SC","Gas":852,"coordinates":[-81.1242,32.3594]},{"Plant":"Tracy Combined Cycle Power Plant","State":"CA","Gas":320.1,"coordinates":[-121.4906,37.7107]},{"Plant":"NRG Rockford II Energy Center","State":"IL","Gas":154.5,"coordinates":[-89.1011,42.2383]},{"Plant":"NAEA Ocean Peaking Power LLC","State":"NJ","Gas":325.6,"coordinates":[-74.1672,40.0633]},{"Plant":"Warren County","State":"VA","Gas":1472.2,"coordinates":[-78.1772,38.9717]},{"Plant":"Wansley Combined Cycle","State":"GA","Gas":1150,"coordinates":[-85.037,33.4064]},{"Plant":"Cosumnes","State":"CA","Gas":503,"coordinates":[-121.124,38.3385]},{"Plant":"Cass County","State":"NE","Gas":322.8,"coordinates":[-95.964,40.9479]},{"Plant":"Hunterstown","State":"PA","Gas":758,"coordinates":[-77.1672,39.8725]},{"Plant":"Palomar Energy","State":"CA","Gas":562,"coordinates":[-117.1178,33.1197]},{"Plant":"Exira","State":"IA","Gas":139.5,"coordinates":[-94.9197,41.5144]},{"Plant":"Donald Von Raesfeld Power Plant","State":"CA","Gas":147.8,"coordinates":[-121.9508,37.3767]},{"Plant":"Fox Energy Center","State":"WI","Gas":557.2,"coordinates":[-88.2089,44.3204]},{"Plant":"Malburg","State":"CA","Gas":134,"coordinates":[-118.2219,33.9986]},{"Plant":"Magnolia Power Project","State":"CA","Gas":301,"coordinates":[-118.3153,34.1786]},{"Plant":"Walnut Energy Center","State":"CA","Gas":269,"coordinates":[-120.8956,37.4878]},{"Plant":"Currant Creek","State":"UT","Gas":524,"coordinates":[-111.8935,39.8214]},{"Plant":"Mankato Energy Center","State":"MN","Gas":330,"coordinates":[-94.003,44.1988]},{"Plant":"Riverside Energy Resource Center","State":"CA","Gas":196,"coordinates":[-117.4528,33.9636]},{"Plant":"McIntosh Combined Cycle Facility","State":"GA","Gas":1318.6,"coordinates":[-81.1817,32.3478]},{"Plant":"South Harper","State":"MO","Gas":303.3,"coordinates":[-94.4824,38.6803]},{"Plant":"Freeport Energy Center","State":"TX","Gas":219.4,"coordinates":[-95.3954,28.9888]},{"Plant":"Faribault Energy Park","State":"MN","Gas":261,"coordinates":[-93.2906,44.3356]},{"Plant":"Sheboygan Falls","State":"WI","Gas":300.8,"coordinates":[-87.8781,43.7518]},{"Plant":"Nebo Power Station","State":"UT","Gas":130,"coordinates":[-111.7294,40.0614]},{"Plant":"500MW CC","State":"NY","Gas":454.1,"coordinates":[-73.9069,40.7889]},{"Plant":"Middletown","State":"CT","Gas":353,"coordinates":[-72.5791,41.5549]},{"Plant":"Port Westward","State":"OR","Gas":392.2,"coordinates":[-123.172,46.1789]},{"Plant":"EG178 Facility","State":"TX","Gas":110,"coordinates":[-100.9547,32.7471]},{"Plant":"Caithness Long Island Energy Center","State":"NY","Gas":316.9,"coordinates":[-72.9403,40.8142]},{"Plant":"Lake Side Power Plant","State":"UT","Gas":1176,"coordinates":[-111.7542,40.3317]},{"Plant":"Groton Generating Station","State":"SD","Gas":158.9,"coordinates":[-98.0987,45.3735]},{"Plant":"Cannon Falls Energy Center","State":"MN","Gas":316,"coordinates":[-92.9155,44.5367]},{"Plant":"Anson County Generation Facility","State":"NC","Gas":339,"coordinates":[-79.9217,34.9687]},{"Plant":"Empire Generating Co  LLC","State":"NY","Gas":580,"coordinates":[-73.75,42.6252]},{"Plant":"Hamlet Generating Facility","State":"NC","Gas":339,"coordinates":[-79.7361,34.8423]},{"Plant":"Roseville Energy Park","State":"CA","Gas":151,"coordinates":[-121.3811,38.7928]},{"Plant":"Shute Creek Facility","State":"WY","Gas":106.8,"coordinates":[-110.0904,41.8805]},{"Plant":"Mustang Station Unit 4","State":"TX","Gas":458.3,"coordinates":[-102.7436,32.9746]},{"Plant":"Harry D Mattison Gas Plant","State":"AR","Gas":294,"coordinates":[-94.2841,36.1855]},{"Plant":"Quail Run Energy Center","State":"TX","Gas":472.2,"coordinates":[-102.315,31.8414]},{"Plant":"Colorado Bend Energy Center","State":"TX","Gas":468,"coordinates":[-96.0683,29.2878]},{"Plant":"Stanton Energy Center","State":"FL","Gas":295,"coordinates":[-81.1678,28.4822]},{"Plant":"Treasure Coast Energy Center","State":"FL","Gas":318,"coordinates":[-80.3775,27.3839]},{"Plant":"West County Energy Center","State":"FL","Gas":3669,"coordinates":[-80.3747,26.6986]},{"Plant":"Spindle Hill Energy Center","State":"CO","Gas":270,"coordinates":[-104.8878,40.0922]},{"Plant":"Hobbs Generating Station","State":"NM","Gas":562,"coordinates":[-103.3094,32.7283]},{"Plant":"Russell City Energy Center","State":"CA","Gas":615,"coordinates":[-122.1338,37.6347]},{"Plant":"Gateway Generating Station","State":"CA","Gas":563.4,"coordinates":[-121.7587,38.0175]},{"Plant":"Goodman Energy Center","State":"KS","Gas":101.4,"coordinates":[-99.3617,38.9303]},{"Plant":"Western 102 Power Plant","State":"NV","Gas":110.6,"coordinates":[-119.5108,39.5603]},{"Plant":"Emporia Energy Center","State":"KS","Gas":645,"coordinates":[-96.0652,38.4459]},{"Plant":"Jonesboro City Water & Light Plant","State":"AR","Gas":177,"coordinates":[-90.7254,35.8486]},{"Plant":"Plains End II LLC","State":"CO","Gas":116.2,"coordinates":[-105.2256,39.8586]},{"Plant":"Colusa Generating Station","State":"CA","Gas":640,"coordinates":[-122.27,39.3661]},{"Plant":"PPS Power Plant No 1","State":"KY","Gas":110,"coordinates":[-88.6159,37.0339]},{"Plant":"J Lamar Stall Unit","State":"LA","Gas":507,"coordinates":[-93.7601,32.5195]},{"Plant":"San Jacinto County Peaking Facility","State":"TX","Gas":146,"coordinates":[-95.0118,30.4193]},{"Plant":"Hardin County Peaking Facility","State":"TX","Gas":146,"coordinates":[-94.2526,30.3038]},{"Plant":"Deer Creek Station","State":"SD","Gas":290,"coordinates":[-96.5267,44.2908]},{"Plant":"Midway Peaking LLC","State":"CA","Gas":111.2,"coordinates":[-120.5797,36.6541]},{"Plant":"Winchester Power Park","State":"TX","Gas":176,"coordinates":[-96.9875,30.0381]},{"Plant":"CFB Power Plant","State":"TX","Gas":286.2,"coordinates":[-96.5397,28.6503]},{"Plant":"Kleen Energy Systems Project","State":"CT","Gas":622,"coordinates":[-72.5969,41.5532]},{"Plant":"Greenland Energy Center","State":"FL","Gas":296,"coordinates":[-81.5184,30.1591]},{"Plant":"Panoche Energy Center","State":"CA","Gas":388,"coordinates":[-120.5833,36.6514]},{"Plant":"Cedar Bayou 4","State":"TX","Gas":502,"coordinates":[-94.9231,29.7516]},{"Plant":"Bear Garden","State":"VA","Gas":589,"coordinates":[-78.2853,37.6956]},{"Plant":"Dave Gates Generating Station","State":"MT","Gas":132.3,"coordinates":[-112.8766,46.1047]},{"Plant":"Coolidge Generation Station","State":"AZ","Gas":520.8,"coordinates":[-111.5033,32.9174]},{"Plant":"West Deptford Energy Station","State":"NJ","Gas":723.4,"coordinates":[-75.2214,39.8414]},{"Plant":"Bayonne Energy Center","State":"NJ","Gas":473.2,"coordinates":[-74.0915,40.6528]},{"Plant":"Pueblo Airport Generating Station","State":"CO","Gas":408,"coordinates":[-104.5264,38.3208]},{"Plant":"Canyon Power Plant","State":"CA","Gas":194.8,"coordinates":[-117.8617,33.8581]},{"Plant":"Langley Gulch Power Plant","State":"ID","Gas":299.7,"coordinates":[-116.8197,43.9044]},{"Plant":"Cleveland Cnty Generating Facility","State":"NC","Gas":738.2,"coordinates":[-81.4166,35.1705]},{"Plant":"Southcentral Power Plant","State":"AK","Gas":169.7,"coordinates":[-149.9053,61.1674]},{"Plant":"Kemper County IGCC Project","State":"MS","Gas":555.2,"coordinates":[-88.7622,32.6547]},{"Plant":"Marsh Landing Generating Station","State":"CA","Gas":765.7,"coordinates":[-121.765,38.0169]},{"Plant":"Garrison Energy Center LLC","State":"DE","Gas":316,"coordinates":[-75.4994,39.1872]},{"Plant":"CPV Sentinel Energy Project","State":"CA","Gas":800,"coordinates":[-116.5714,33.9342]},{"Plant":"Mariposa Energy Project","State":"CA","Gas":199.6,"coordinates":[-121.6019,37.7892]},{"Plant":"Walnut Creek Energy Park","State":"CA","Gas":485,"coordinates":[-117.9449,34.0087]},{"Plant":"Pio Pico Energy Center","State":"CA","Gas":291,"coordinates":[-116.9178,32.5739]},{"Plant":"Astoria Energy II","State":"NY","Gas":540,"coordinates":[-73.8966,40.7813]},{"Plant":"Cheyenne Prairie Generating Station","State":"WY","Gas":131,"coordinates":[-104.72,41.1236]},{"Plant":"Woodbridge Energy Center","State":"NJ","Gas":719.6,"coordinates":[-74.3189,40.515]},{"Plant":"Antelope Station","State":"TX","Gas":163.8,"coordinates":[-101.8433,33.865]},{"Plant":"Pioneer Generating Station","State":"ND","Gas":120,"coordinates":[-103.9528,48.2325]},{"Plant":"El Segundo Energy Center LLC","State":"CA","Gas":510,"coordinates":[-118.425,33.9106]},{"Plant":"Lonesome Creek Station","State":"ND","Gas":120,"coordinates":[-103.5786,47.7967]},{"Plant":"Lodi Energy Center","State":"CA","Gas":257,"coordinates":[-121.3875,38.0881]},{"Plant":"Panda Temple Power Station","State":"TX","Gas":1468,"coordinates":[-97.3172,31.0558]},{"Plant":"Panda Sherman Power Station","State":"TX","Gas":717,"coordinates":[-96.6179,33.5826]},{"Plant":"Newark Energy Center","State":"NJ","Gas":696.9,"coordinates":[-74.1258,40.7072]},{"Plant":"Lee Combined Cycle Plant","State":"NC","Gas":888,"coordinates":[-78.0894,35.3736]},{"Plant":"Rubart","State":"KS","Gas":108,"coordinates":[-93.3369,36.8283]},{"Plant":"Brunswick County Power Station","State":"VA","Gas":1371.1,"coordinates":[-77.7139,36.765]},{"Plant":"Port Westward Unit 2","State":"OR","Gas":224.4,"coordinates":[-123.1719,46.1789]},{"Plant":"Charles D. Lamb Energy Center","State":"OK","Gas":122,"coordinates":[-97.1253,36.8139]},{"Plant":"Moxie Liberty Generation Plant","State":"PA","Gas":756,"coordinates":[-76.39,41.7675]},{"Plant":"Moxie Patriot Generation Plant","State":"PA","Gas":765,"coordinates":[-76.8392,41.1808]},{"Plant":"Ector County Energy Center","State":"TX","Gas":300,"coordinates":[-102.5856,32.0692]},{"Plant":"Carty Generating Station","State":"OR","Gas":413,"coordinates":[-119.8131,45.6986]},{"Plant":"Mesquite Generating Station Block 1","State":"AZ","Gas":595,"coordinates":[-112.8642,33.345]},{"Plant":"Montana Power Station","State":"TX","Gas":380,"coordinates":[-106.2119,31.8239]},{"Plant":"L V Sutton Combined Cycle","State":"NC","Gas":607,"coordinates":[-77.9853,34.2831]},{"Plant":"Elk Station","State":"TX","Gas":581,"coordinates":[-101.8433,33.865]},{"Plant":"Eklutna Generation Station","State":"AK","Gas":165,"coordinates":[-149.3514,61.4578]},{"Plant":"Edge Moor","State":"DE","Gas":710,"coordinates":[-75.5038,39.7389]},{"Plant":"PB1 - Gila River","State":"AZ","Gas":515,"coordinates":[-112.6944,32.975]},{"Plant":"Red Gate Power Plant","State":"TX","Gas":219.6,"coordinates":[-98.1775,26.4511]},{"Plant":"Gila River Power Block 3","State":"AZ","Gas":515,"coordinates":[-112.6944,32.975]},{"Plant":"McKee Run","State":"DE","Gas":137.7,"coordinates":[-75.5466,39.1762]},{"Plant":"Alpine Power Plant","State":"MI","Gas":405.2,"coordinates":[-84.8253,45.0637]},{"Plant":"Belle River","State":"MI","Gas":224,"coordinates":[-82.495,42.7756]},{"Plant":"Greenwood","State":"MI","Gas":1009,"coordinates":[-82.6964,43.1056]},{"Plant":"Manatee","State":"FL","Gas":1111,"coordinates":[-82.3456,27.6058]},{"Plant":"Martin","State":"FL","Gas":2043,"coordinates":[-80.5628,27.0536]},{"Plant":"DeBary","State":"FL","Gas":237,"coordinates":[-81.3323,28.9039]},{"Plant":"Big Cajun 2","State":"LA","Gas":575,"coordinates":[-91.3692,30.7261]},{"Plant":"Electrifarm","State":"IA","Gas":195.1,"coordinates":[-92.4205,42.4407]},{"Plant":"Fredonia","State":"WA","Gas":280,"coordinates":[-122.4358,48.4558]},{"Plant":"Trimble County","State":"KY","Gas":954,"coordinates":[-85.4117,38.5847]},{"Plant":"Victor J Daniel Jr","State":"MS","Gas":969,"coordinates":[-88.5553,30.5322]},{"Plant":"Greenwood","State":"MO","Gas":242.1,"coordinates":[-94.2982,38.8615]},{"Plant":"PB2 - Gila River","State":"AZ","Gas":515,"coordinates":[-112.6944,32.975]},{"Plant":"R M Schahfer","State":"IN","Gas":155,"coordinates":[-87.0261,41.2164]},{"Plant":"Cape Canaveral","State":"FL","Gas":1210,"coordinates":[-80.7644,28.4698]},{"Plant":"Fort St Vrain","State":"CO","Gas":968,"coordinates":[-104.8742,40.2461]},{"Plant":"Fort Myers","State":"FL","Gas":2258,"coordinates":[-81.7831,26.6967]},{"Plant":"Whitehorn","State":"WA","Gas":134,"coordinates":[-122.6861,48.8288]},{"Plant":"McIntosh","State":"GA","Gas":657.6,"coordinates":[-81.1683,32.3563]},{"Plant":"Lauderdale","State":"FL","Gas":2109,"coordinates":[-80.1984,26.0686]},{"Plant":"A B Brown","State":"IN","Gas":160,"coordinates":[-87.715,37.9053]},{"Plant":"Port Everglades","State":"FL","Gas":1260,"coordinates":[-80.1253,26.0856]},{"Plant":"Riviera","State":"FL","Gas":1212,"coordinates":[-80.0525,26.7653]},{"Plant":"Brame Energy Center","State":"LA","Gas":421.1,"coordinates":[-92.7167,31.395]},{"Plant":"John Twitty Energy Center","State":"MO","Gas":104,"coordinates":[-93.388,37.1517]},{"Plant":"Sanford","State":"FL","Gas":1912,"coordinates":[-81.3256,28.8419]},{"Plant":"Turkey Point","State":"FL","Gas":1148,"coordinates":[-80.3308,25.4356]},{"Plant":"Empire Energy Center","State":"MO","Gas":262,"coordinates":[-94.1041,37.1385]},{"Plant":"Dansby","State":"TX","Gas":204.2,"coordinates":[-96.4608,30.7217]},{"Plant":"Higgins","State":"FL","Gas":107,"coordinates":[-82.6615,28.0033]},{"Plant":"P L Bartow","State":"FL","Gas":1209,"coordinates":[-82.6018,27.8595]},{"Plant":"Rokeby","State":"NE","Gas":255,"coordinates":[-96.7364,40.7316]},{"Plant":"Lansing Smith","State":"FL","Gas":502,"coordinates":[-85.7003,30.2686]},{"Plant":"George M Sullivan Generation Plant 2","State":"AK","Gas":309.3,"coordinates":[-149.7167,61.2297]},{"Plant":"Deerhaven Generating Station","State":"FL","Gas":185,"coordinates":[-82.3878,29.7592]},{"Plant":"John R Kelly","State":"FL","Gas":112,"coordinates":[-82.3208,29.6461]},{"Plant":"J D Kennedy","State":"FL","Gas":317.2,"coordinates":[-81.626,30.3648]},{"Plant":"Northside Generating Station","State":"FL","Gas":524,"coordinates":[-81.5525,30.4172]},{"Plant":"Larsen Memorial","State":"FL","Gas":124,"coordinates":[-81.9228,28.0797]},{"Plant":"C D McIntosh Jr","State":"FL","Gas":460,"coordinates":[-81.9229,28.0801]},{"Plant":"Rawhide","State":"CO","Gas":388,"coordinates":[-105.0212,40.8609]},{"Plant":"Indian River Plant","State":"FL","Gas":290,"coordinates":[-80.7801,28.4932]},{"Plant":"Arvah B Hopkins","State":"FL","Gas":504,"coordinates":[-84.4,30.4522]},{"Plant":"S O Purdom","State":"FL","Gas":246,"coordinates":[-84.2007,30.1623]},{"Plant":"Gadsden","State":"AL","Gas":130,"coordinates":[-85.9708,34.0128]},{"Plant":"Gravel Neck","State":"VA","Gas":340,"coordinates":[-76.6911,37.1575]},{"Plant":"McIntosh","State":"AL","Gas":688,"coordinates":[-88.0299,31.2546]},{"Plant":"Harry Allen","State":"NV","Gas":654,"coordinates":[-114.9024,36.4306]},{"Plant":"Jack McDonough","State":"GA","Gas":2534,"coordinates":[-84.4758,33.8239]},{"Plant":"Pleasant Hill","State":"IA","Gas":160,"coordinates":[-93.5242,41.5572]},{"Plant":"Hay Road","State":"DE","Gas":1136,"coordinates":[-75.5072,39.7436]},{"Plant":"Woodsdale","State":"OH","Gas":476,"coordinates":[-84.4611,39.4492]},{"Plant":"Concord","State":"WI","Gas":352,"coordinates":[-88.69,43.1669]},{"Plant":"South Fond Du Lac","State":"WI","Gas":325.7,"coordinates":[-88.4967,43.7353]},{"Plant":"Darbytown","State":"VA","Gas":336,"coordinates":[-77.3685,37.4982]},{"Plant":"Angus Anson","State":"SD","Gas":327,"coordinates":[-96.6356,43.6035]},{"Plant":"Cane Island","State":"FL","Gas":670,"coordinates":[-81.533,28.2764]},{"Plant":"Polk","State":"FL","Gas":604,"coordinates":[-81.9897,27.7286]},{"Plant":"Woodland","State":"CA","Gas":182.2,"coordinates":[-121.0204,37.6526]},{"Plant":"491 E 48th Street","State":"MI","Gas":136,"coordinates":[-86.0853,42.7553]},{"Plant":"Paris","State":"WI","Gas":352,"coordinates":[-88.0131,42.6658]},{"Plant":"Lincoln Combustion","State":"NC","Gas":1193,"coordinates":[-81.0347,35.4317]},{"Plant":"Yates","State":"GA","Gas":714,"coordinates":[-84.8986,33.4622]},{"Plant":"State Line Combined Cycle","State":"MO","Gas":589,"coordinates":[-94.614,37.0659]},{"Plant":"Hines Energy Complex","State":"FL","Gas":2067,"coordinates":[-81.87,27.7882]},{"Plant":"Redding Power","State":"CA","Gas":171,"coordinates":[-122.4233,40.5073]},{"Plant":"Richard M Flynn","State":"NY","Gas":134.4,"coordinates":[-73.064,40.8158]},{"Plant":"Almond Power Plant","State":"CA","Gas":199.5,"coordinates":[-120.985,37.5744]},{"Plant":"San Jacinto Steam Electric Station","State":"TX","Gas":162,"coordinates":[-95.0406,29.6948]},{"Plant":"Anderson","State":"IN","Gas":140,"coordinates":[-85.7389,40.0529]},{"Plant":"Robins","State":"GA","Gas":160,"coordinates":[-83.5822,32.5792]},{"Plant":"Coyote Springs","State":"OR","Gas":235,"coordinates":[-119.6739,45.848]},{"Plant":"Midulla Generating Station","State":"FL","Gas":751,"coordinates":[-81.9625,27.6417]},{"Plant":"Interstate","State":"IL","Gas":112,"coordinates":[-89.5891,39.8233]},{"Plant":"Rathdrum","State":"ID","Gas":132,"coordinates":[-116.8673,47.8043]},{"Plant":"Arthur Von Rosenberg","State":"TX","Gas":466,"coordinates":[-98.384,29.257]},{"Plant":"Carson Ice-Gen Project","State":"CA","Gas":109,"coordinates":[-121.4624,38.4457]},{"Plant":"Wayne County","State":"NC","Gas":857,"coordinates":[-78.0981,35.3758]},{"Plant":"Ponca City","State":"OK","Gas":106.8,"coordinates":[-97.0858,36.7198]},{"Plant":"SCA Cogen 2","State":"CA","Gas":176.6,"coordinates":[-121.4001,38.5309]},{"Plant":"SPA Cogen 3","State":"CA","Gas":164,"coordinates":[-121.4735,38.511]},{"Plant":"St Francis Energy Facility","State":"MO","Gas":420,"coordinates":[-90.1779,36.5852]},{"Plant":"River Road Gen Plant","State":"WA","Gas":220,"coordinates":[-122.7256,45.6497]},{"Plant":"Tiger Bay","State":"FL","Gas":200,"coordinates":[-81.8494,27.7464]},{"Plant":"Dahlberg","State":"GA","Gas":746.6,"coordinates":[-83.3977,34.0423]},{"Plant":"H Allen Franklin Combined Cycle","State":"AL","Gas":1861.8,"coordinates":[-85.0975,32.6078]},{"Plant":"Theodore Cogen Facility","State":"AL","Gas":224.7,"coordinates":[-88.1285,30.5254]},{"Plant":"Essex","State":"MO","Gas":104,"coordinates":[-89.8402,36.8682]},{"Plant":"Nodaway","State":"MO","Gas":172,"coordinates":[-94.7913,40.2877]},{"Plant":"Chouteau","State":"OK","Gas":876,"coordinates":[-95.2771,36.2221]},{"Plant":"Georgetown","State":"IN","Gas":276,"coordinates":[-86.2441,39.9026]},{"Plant":"Tilton","State":"IL","Gas":176,"coordinates":[-87.6538,40.1061]},{"Plant":"Henry County","State":"IN","Gas":129,"coordinates":[-85.5039,39.9528]},{"Plant":"MPC Generating","State":"GA","Gas":302.5,"coordinates":[-83.6953,33.8119]},{"Plant":"Sherwood H Smith Jr Energy Complex","State":"NC","Gas":1845,"coordinates":[-79.7406,34.8392]},{"Plant":"Sewell Creek Energy","State":"GA","Gas":448.1,"coordinates":[-85.2769,33.9486]},{"Plant":"Alsey","State":"IL","Gas":163,"coordinates":[-90.436,39.5698]},{"Plant":"Fulton","State":"AR","Gas":153,"coordinates":[-93.7924,33.6094]},{"Plant":"Rowan","State":"NC","Gas":938.8,"coordinates":[-80.6019,35.7314]},{"Plant":"Smarr Energy Center","State":"GA","Gas":187.4,"coordinates":[-83.8464,32.9842]},{"Plant":"John S Rainey","State":"SC","Gas":977,"coordinates":[-82.776,34.3477]},{"Plant":"Essential Power Rock Springs LLC","State":"MD","Gas":653.5,"coordinates":[-76.1598,39.719]},{"Plant":"Marsh Run Generating","State":"VA","Gas":481.3,"coordinates":[-77.7681,38.5283]},{"Plant":"Louisa Generating","State":"VA","Gas":466,"coordinates":[-78.2139,38.1181]},{"Plant":"Remington","State":"VA","Gas":608,"coordinates":[-77.7714,38.5442]},{"Plant":"Ladysmith","State":"VA","Gas":783,"coordinates":[-77.5133,38.0722]},{"Plant":"Pleasant Valley","State":"MN","Gas":439.9,"coordinates":[-92.6829,43.7994]},{"Plant":"Lagoon Creek","State":"TN","Gas":1407,"coordinates":[-89.3964,35.6578]},{"Plant":"Brandy Branch","State":"FL","Gas":660.8,"coordinates":[-81.9472,30.3206]},{"Plant":"Holden","State":"MO","Gas":243,"coordinates":[-93.9983,38.7538]},{"Plant":"MEPI GT Facility","State":"IL","Gas":239,"coordinates":[-88.8661,37.2175]},{"Plant":"Encogen","State":"WA","Gas":159.4,"coordinates":[-122.486,48.746]},{"Plant":"Robert P Mone Plant","State":"OH","Gas":435,"coordinates":[-84.7392,40.9297]},{"Plant":"H L Culbreath Bayside Power Station","State":"FL","Gas":1854,"coordinates":[-82.4231,27.9072]},{"Plant":"Terry Bundy Generating Station","State":"NE","Gas":174.4,"coordinates":[-96.6131,40.9097]},{"Plant":"E B Harris Electric Generating Plant","State":"AL","Gas":1276.2,"coordinates":[-86.5744,32.3814]},{"Plant":"Sand Hill","State":"TX","Gas":595.8,"coordinates":[-97.6129,30.2098]},{"Plant":"Talbot County Energy","State":"GA","Gas":576.6,"coordinates":[-84.6917,32.5892]},{"Plant":"Chattahoochee Energy Facility","State":"GA","Gas":457.9,"coordinates":[-85.0386,33.4072]},{"Plant":"Lakefield Junction","State":"MN","Gas":505.4,"coordinates":[-94.8415,43.7984]},{"Plant":"West Gardner","State":"KS","Gas":312.9,"coordinates":[-94.9861,38.7875]},{"Plant":"Coyote Springs II","State":"OR","Gas":290,"coordinates":[-119.674,45.848]},{"Plant":"Wansley Unit 9","State":"GA","Gas":489.2,"coordinates":[-85.0403,33.4083]},{"Plant":"Lawrence County Station","State":"IN","Gas":264.1,"coordinates":[-86.4511,38.8003]},{"Plant":"Evander Andrews Power Complex","State":"ID","Gas":261.5,"coordinates":[-115.7343,43.1792]},{"Plant":"Kemper County","State":"MS","Gas":293.2,"coordinates":[-88.606,32.7976]},{"Plant":"Peno Creek","State":"MO","Gas":188,"coordinates":[-91.2295,39.3531]},{"Plant":"Sumpter","State":"MI","Gas":308.4,"coordinates":[-83.5318,42.167]},{"Plant":"Pyramid","State":"NM","Gas":158,"coordinates":[-108.5494,32.2363]},{"Plant":"Mill Creek","State":"SC","Gas":563,"coordinates":[-81.4306,35.1597]},{"Plant":"Greater Des Moines","State":"IA","Gas":492.6,"coordinates":[-93.5283,41.5563]},{"Plant":"Silver Creek","State":"MS","Gas":225,"coordinates":[-89.9468,31.6004]},{"Plant":"Sylvarena","State":"MS","Gas":129,"coordinates":[-89.4127,31.9821]},{"Plant":"West Campus Cogeneration Facility","State":"WI","Gas":124.4,"coordinates":[-89.4251,43.0751]},{"Plant":"Grays Harbor Energy Facility","State":"WA","Gas":604,"coordinates":[-123.48,46.9692]},{"Plant":"Beatrice","State":"NE","Gas":220,"coordinates":[-96.8082,40.3302]},{"Plant":"Newington","State":"NH","Gas":400.2,"coordinates":[-70.7908,43.1]},{"Plant":"Roseton Generating Facility","State":"NY","Gas":1189,"coordinates":[-73.9663,41.5738]},{"Plant":"Blue Lake","State":"MN","Gas":300,"coordinates":[-93.4315,44.7855]},{"Plant":"Sycamore","State":"IA","Gas":148.5,"coordinates":[-93.6769,41.6722]},{"Plant":"Emery Station","State":"IA","Gas":505.1,"coordinates":[-93.2922,43.094]},{"Plant":"Anclote","State":"FL","Gas":1013,"coordinates":[-82.7886,28.1844]},{"Plant":"Intercession City","State":"FL","Gas":534,"coordinates":[-81.5486,28.2628]},{"Plant":"Gerald Andrus","State":"MS","Gas":731.9,"coordinates":[-91.1167,33.35]},{"Plant":"Waterford 1 & 2","State":"LA","Gas":821.3,"coordinates":[-90.4768,29.9989]},{"Plant":"Comanche","State":"OK","Gas":260,"coordinates":[-98.3244,34.5431]},{"Plant":"DeCordova Steam Electric Station","State":"TX","Gas":278,"coordinates":[-97.7006,32.4031]},{"Plant":"Santan","State":"AZ","Gas":1227,"coordinates":[-111.7503,33.3325]},{"Plant":"Beaver","State":"OR","Gas":485,"coordinates":[-123.1739,46.1724]},{"Plant":"Grand Tower","State":"IL","Gas":511,"coordinates":[-89.5112,37.6577]},{"Plant":"Astoria Generating Station","State":"NY","Gas":1326.3,"coordinates":[-73.9126,40.7877]},{"Plant":"Venice","State":"IL","Gas":488,"coordinates":[-90.1764,38.6642]},{"Plant":"Beluga","State":"AK","Gas":300.4,"coordinates":[-151.0356,61.1861]},{"Plant":"Marion","State":"IL","Gas":140,"coordinates":[-88.9531,37.6197]},{"Plant":"Frederickson","State":"WA","Gas":134,"coordinates":[-122.365,47.0797]},{"Plant":"Harding Street","State":"IN","Gas":906,"coordinates":[-86.1969,39.7113]}]

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ComposableMap = __webpack_require__(545);

Object.defineProperty(exports, "ComposableMap", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ComposableMap).default;
  }
});

var _ZoomableGroup = __webpack_require__(697);

Object.defineProperty(exports, "ZoomableGroup", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ZoomableGroup).default;
  }
});

var _ZoomableGlobe = __webpack_require__(698);

Object.defineProperty(exports, "ZoomableGlobe", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ZoomableGlobe).default;
  }
});

var _Geographies = __webpack_require__(699);

Object.defineProperty(exports, "Geographies", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Geographies).default;
  }
});

var _Geography = __webpack_require__(708);

Object.defineProperty(exports, "Geography", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Geography).default;
  }
});

var _Marker = __webpack_require__(709);

Object.defineProperty(exports, "Marker", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Marker).default;
  }
});

var _Markers = __webpack_require__(710);

Object.defineProperty(exports, "Markers", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Markers).default;
  }
});

var _Annotation = __webpack_require__(711);

Object.defineProperty(exports, "Annotation", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Annotation).default;
  }
});

var _Annotations = __webpack_require__(712);

Object.defineProperty(exports, "Annotations", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Annotations).default;
  }
});

var _Graticule = __webpack_require__(713);

Object.defineProperty(exports, "Graticule", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Graticule).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _projections = __webpack_require__(546);

var _projections2 = _interopRequireDefault(_projections);

var _projectionConfig = __webpack_require__(306);

var _projectionConfig2 = _interopRequireDefault(_projectionConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ComposableMap = function (_Component) {
  _inherits(ComposableMap, _Component);

  function ComposableMap() {
    _classCallCheck(this, ComposableMap);

    var _this = _possibleConstructorReturn(this, (ComposableMap.__proto__ || Object.getPrototypeOf(ComposableMap)).call(this));

    _this.projection = _this.projection.bind(_this);
    return _this;
  }

  _createClass(ComposableMap, [{
    key: "projection",
    value: function projection() {
      var _props = this.props,
          projection = _props.projection,
          projectionConfig = _props.projectionConfig,
          width = _props.width,
          height = _props.height;


      return typeof projection !== "function" ? (0, _projections2.default)(width, height, projectionConfig, projection) : projection(width, height, projectionConfig);
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          width = _props2.width,
          height = _props2.height,
          style = _props2.style,
          className = _props2.className,
          showCenter = _props2.showCenter,
          children = _props2.children,
          aspectRatio = _props2.aspectRatio,
          viewBox = _props2.viewBox,
          defs = _props2.defs;


      return _react2.default.createElement(
        "svg",
        { width: width,
          height: height,
          viewBox: viewBox ? viewBox : "0 0 " + width + " " + height,
          className: "rsm-svg " + (className || ''),
          style: style,
          preserveAspectRatio: aspectRatio },
        defs && _react2.default.createElement(
          "defs",
          null,
          defs
        ),
        _react2.default.cloneElement(this.props.children, {
          projection: this.projection(),
          width: width,
          height: height
        }),
        showCenter && _react2.default.createElement(
          "g",
          null,
          _react2.default.createElement("rect", { x: width / 2 - 0.5, y: 0, width: 1, height: height, fill: "#e91e63" }),
          _react2.default.createElement("rect", { x: 0, y: height / 2 - 0.5, width: width, height: 1, fill: "#e91e63" })
        )
      );
    }
  }]);

  return ComposableMap;
}(_react.Component);

ComposableMap.defaultProps = {
  width: 800,
  height: 450,
  projection: "times",
  projectionConfig: _projectionConfig2.default,
  aspectRatio: "xMidYMid",
  viewBox: null
};

exports.default = ComposableMap;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (width, height, config, projectionName) {

  var scale = config.scale || _projectionConfig2.default.scale;
  var xOffset = config.xOffset || _projectionConfig2.default.xOffset;
  var yOffset = config.yOffset || _projectionConfig2.default.yOffset;
  var rotation = config.rotation || _projectionConfig2.default.rotation;
  var precision = config.precision || _projectionConfig2.default.precision;

  var baseProjection = projectionReference[projectionName]().scale(scale).translate([xOffset + width / 2, yOffset + height / 2]).precision(precision);

  return projectionName === "albersUsa" ? baseProjection : projectionName === "orthographic" ? baseProjection.rotate(rotation).clipAngle(90) : baseProjection.rotate(rotation);
};

var _d3GeoProjection = __webpack_require__(547);

var _d3Geo = __webpack_require__(42);

var _projectionConfig = __webpack_require__(306);

var _projectionConfig2 = _interopRequireDefault(_projectionConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var projectionReference = {
  mercator: _d3Geo.geoMercator,
  miller: _d3GeoProjection.geoMiller,
  times: _d3GeoProjection.geoTimes,
  robinson: _d3GeoProjection.geoRobinson,
  winkel3: _d3GeoProjection.geoWinkel3,
  eckert4: _d3GeoProjection.geoEckert4,
  albersUsa: _d3Geo.geoAlbersUsa,
  orthographic: _d3Geo.geoOrthographic
};

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_airy__ = __webpack_require__(548);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoAiry", function() { return __WEBPACK_IMPORTED_MODULE_0__src_airy__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoAiryRaw", function() { return __WEBPACK_IMPORTED_MODULE_0__src_airy__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_aitoff__ = __webpack_require__(283);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoAitoff", function() { return __WEBPACK_IMPORTED_MODULE_1__src_aitoff__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoAitoffRaw", function() { return __WEBPACK_IMPORTED_MODULE_1__src_aitoff__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_armadillo__ = __webpack_require__(592);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoArmadillo", function() { return __WEBPACK_IMPORTED_MODULE_2__src_armadillo__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoArmadilloRaw", function() { return __WEBPACK_IMPORTED_MODULE_2__src_armadillo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_august__ = __webpack_require__(284);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoAugust", function() { return __WEBPACK_IMPORTED_MODULE_3__src_august__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoAugustRaw", function() { return __WEBPACK_IMPORTED_MODULE_3__src_august__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_baker__ = __webpack_require__(593);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoBaker", function() { return __WEBPACK_IMPORTED_MODULE_4__src_baker__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoBakerRaw", function() { return __WEBPACK_IMPORTED_MODULE_4__src_baker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_berghaus__ = __webpack_require__(594);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoBerghaus", function() { return __WEBPACK_IMPORTED_MODULE_5__src_berghaus__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoBerghausRaw", function() { return __WEBPACK_IMPORTED_MODULE_5__src_berghaus__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_boggs__ = __webpack_require__(285);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoBoggs", function() { return __WEBPACK_IMPORTED_MODULE_6__src_boggs__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoBoggsRaw", function() { return __WEBPACK_IMPORTED_MODULE_6__src_boggs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_bonne__ = __webpack_require__(595);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoBonne", function() { return __WEBPACK_IMPORTED_MODULE_7__src_bonne__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoBonneRaw", function() { return __WEBPACK_IMPORTED_MODULE_7__src_bonne__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_bottomley__ = __webpack_require__(596);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoBottomley", function() { return __WEBPACK_IMPORTED_MODULE_8__src_bottomley__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoBottomleyRaw", function() { return __WEBPACK_IMPORTED_MODULE_8__src_bottomley__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_bromley__ = __webpack_require__(597);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoBromley", function() { return __WEBPACK_IMPORTED_MODULE_9__src_bromley__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoBromleyRaw", function() { return __WEBPACK_IMPORTED_MODULE_9__src_bromley__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_chamberlin__ = __webpack_require__(598);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoChamberlin", function() { return __WEBPACK_IMPORTED_MODULE_10__src_chamberlin__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoChamberlinRaw", function() { return __WEBPACK_IMPORTED_MODULE_10__src_chamberlin__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoChamberlinAfrica", function() { return __WEBPACK_IMPORTED_MODULE_10__src_chamberlin__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_collignon__ = __webpack_require__(153);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoCollignon", function() { return __WEBPACK_IMPORTED_MODULE_11__src_collignon__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoCollignonRaw", function() { return __WEBPACK_IMPORTED_MODULE_11__src_collignon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_craig__ = __webpack_require__(599);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoCraig", function() { return __WEBPACK_IMPORTED_MODULE_12__src_craig__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoCraigRaw", function() { return __WEBPACK_IMPORTED_MODULE_12__src_craig__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_craster__ = __webpack_require__(600);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoCraster", function() { return __WEBPACK_IMPORTED_MODULE_13__src_craster__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoCrasterRaw", function() { return __WEBPACK_IMPORTED_MODULE_13__src_craster__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_cylindricalEqualArea__ = __webpack_require__(286);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoCylindricalEqualArea", function() { return __WEBPACK_IMPORTED_MODULE_14__src_cylindricalEqualArea__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoCylindricalEqualAreaRaw", function() { return __WEBPACK_IMPORTED_MODULE_14__src_cylindricalEqualArea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cylindricalStereographic__ = __webpack_require__(601);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoCylindricalStereographic", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cylindricalStereographic__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoCylindricalStereographicRaw", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cylindricalStereographic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_eckert1_js__ = __webpack_require__(602);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoEckert1", function() { return __WEBPACK_IMPORTED_MODULE_16__src_eckert1_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoEckert1Raw", function() { return __WEBPACK_IMPORTED_MODULE_16__src_eckert1_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_eckert2_js__ = __webpack_require__(603);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoEckert2", function() { return __WEBPACK_IMPORTED_MODULE_17__src_eckert2_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoEckert2Raw", function() { return __WEBPACK_IMPORTED_MODULE_17__src_eckert2_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_eckert3_js__ = __webpack_require__(604);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoEckert3", function() { return __WEBPACK_IMPORTED_MODULE_18__src_eckert3_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoEckert3Raw", function() { return __WEBPACK_IMPORTED_MODULE_18__src_eckert3_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_eckert4_js__ = __webpack_require__(605);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoEckert4", function() { return __WEBPACK_IMPORTED_MODULE_19__src_eckert4_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoEckert4Raw", function() { return __WEBPACK_IMPORTED_MODULE_19__src_eckert4_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_eckert5_js__ = __webpack_require__(606);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoEckert5", function() { return __WEBPACK_IMPORTED_MODULE_20__src_eckert5_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoEckert5Raw", function() { return __WEBPACK_IMPORTED_MODULE_20__src_eckert5_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_eckert6_js__ = __webpack_require__(607);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoEckert6", function() { return __WEBPACK_IMPORTED_MODULE_21__src_eckert6_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoEckert6Raw", function() { return __WEBPACK_IMPORTED_MODULE_21__src_eckert6_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_eisenlohr_js__ = __webpack_require__(608);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoEisenlohr", function() { return __WEBPACK_IMPORTED_MODULE_22__src_eisenlohr_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoEisenlohrRaw", function() { return __WEBPACK_IMPORTED_MODULE_22__src_eisenlohr_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_fahey_js__ = __webpack_require__(609);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoFahey", function() { return __WEBPACK_IMPORTED_MODULE_23__src_fahey_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoFaheyRaw", function() { return __WEBPACK_IMPORTED_MODULE_23__src_fahey_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_foucaut_js__ = __webpack_require__(610);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoFoucaut", function() { return __WEBPACK_IMPORTED_MODULE_24__src_foucaut_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoFoucautRaw", function() { return __WEBPACK_IMPORTED_MODULE_24__src_foucaut_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_gilbert_js__ = __webpack_require__(611);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoGilbert", function() { return __WEBPACK_IMPORTED_MODULE_25__src_gilbert_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_gingery_js__ = __webpack_require__(612);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoGingery", function() { return __WEBPACK_IMPORTED_MODULE_26__src_gingery_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoGingeryRaw", function() { return __WEBPACK_IMPORTED_MODULE_26__src_gingery_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_ginzburg4_js__ = __webpack_require__(613);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoGinzburg4", function() { return __WEBPACK_IMPORTED_MODULE_27__src_ginzburg4_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoGinzburg4Raw", function() { return __WEBPACK_IMPORTED_MODULE_27__src_ginzburg4_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_ginzburg5_js__ = __webpack_require__(614);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoGinzburg5", function() { return __WEBPACK_IMPORTED_MODULE_28__src_ginzburg5_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoGinzburg5Raw", function() { return __WEBPACK_IMPORTED_MODULE_28__src_ginzburg5_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__src_ginzburg6_js__ = __webpack_require__(615);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoGinzburg6", function() { return __WEBPACK_IMPORTED_MODULE_29__src_ginzburg6_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoGinzburg6Raw", function() { return __WEBPACK_IMPORTED_MODULE_29__src_ginzburg6_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__src_ginzburg8_js__ = __webpack_require__(616);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoGinzburg8", function() { return __WEBPACK_IMPORTED_MODULE_30__src_ginzburg8_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoGinzburg8Raw", function() { return __WEBPACK_IMPORTED_MODULE_30__src_ginzburg8_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__src_ginzburg9_js__ = __webpack_require__(617);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoGinzburg9", function() { return __WEBPACK_IMPORTED_MODULE_31__src_ginzburg9_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoGinzburg9Raw", function() { return __WEBPACK_IMPORTED_MODULE_31__src_ginzburg9_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__src_gringorten_js__ = __webpack_require__(287);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoGringorten", function() { return __WEBPACK_IMPORTED_MODULE_32__src_gringorten_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoGringortenRaw", function() { return __WEBPACK_IMPORTED_MODULE_32__src_gringorten_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__src_guyou_js__ = __webpack_require__(289);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoGuyou", function() { return __WEBPACK_IMPORTED_MODULE_33__src_guyou_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoGuyouRaw", function() { return __WEBPACK_IMPORTED_MODULE_33__src_guyou_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__src_hammer_js__ = __webpack_require__(619);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoHammer", function() { return __WEBPACK_IMPORTED_MODULE_34__src_hammer_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoHammerRaw", function() { return __WEBPACK_IMPORTED_MODULE_34__src_hammer_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__src_hammerRetroazimuthal_js__ = __webpack_require__(620);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoHammerRetroazimuthal", function() { return __WEBPACK_IMPORTED_MODULE_35__src_hammerRetroazimuthal_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoHammerRetroazimuthalRaw", function() { return __WEBPACK_IMPORTED_MODULE_35__src_hammerRetroazimuthal_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__src_healpix_js__ = __webpack_require__(621);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoHealpix", function() { return __WEBPACK_IMPORTED_MODULE_36__src_healpix_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoHealpixRaw", function() { return __WEBPACK_IMPORTED_MODULE_36__src_healpix_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__src_hill_js__ = __webpack_require__(622);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoHill", function() { return __WEBPACK_IMPORTED_MODULE_37__src_hill_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoHillRaw", function() { return __WEBPACK_IMPORTED_MODULE_37__src_hill_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__src_homolosine_js__ = __webpack_require__(290);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoHomolosine", function() { return __WEBPACK_IMPORTED_MODULE_38__src_homolosine_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoHomolosineRaw", function() { return __WEBPACK_IMPORTED_MODULE_38__src_homolosine_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__src_interrupted_index__ = __webpack_require__(41);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoInterrupt", function() { return __WEBPACK_IMPORTED_MODULE_39__src_interrupted_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__src_interrupted_boggs__ = __webpack_require__(623);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoInterruptedBoggs", function() { return __WEBPACK_IMPORTED_MODULE_40__src_interrupted_boggs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__src_interrupted_homolosine__ = __webpack_require__(624);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoInterruptedHomolosine", function() { return __WEBPACK_IMPORTED_MODULE_41__src_interrupted_homolosine__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__src_interrupted_mollweide__ = __webpack_require__(625);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoInterruptedMollweide", function() { return __WEBPACK_IMPORTED_MODULE_42__src_interrupted_mollweide__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__src_interrupted_mollweideHemispheres__ = __webpack_require__(626);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoInterruptedMollweideHemispheres", function() { return __WEBPACK_IMPORTED_MODULE_43__src_interrupted_mollweideHemispheres__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__src_interrupted_sinuMollweide__ = __webpack_require__(627);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoInterruptedSinuMollweide", function() { return __WEBPACK_IMPORTED_MODULE_44__src_interrupted_sinuMollweide__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__src_interrupted_sinusoidal__ = __webpack_require__(628);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoInterruptedSinusoidal", function() { return __WEBPACK_IMPORTED_MODULE_45__src_interrupted_sinusoidal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__src_kavrayskiy7_js__ = __webpack_require__(629);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoKavrayskiy7", function() { return __WEBPACK_IMPORTED_MODULE_46__src_kavrayskiy7_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoKavrayskiy7Raw", function() { return __WEBPACK_IMPORTED_MODULE_46__src_kavrayskiy7_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__src_lagrange_js__ = __webpack_require__(630);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoLagrange", function() { return __WEBPACK_IMPORTED_MODULE_47__src_lagrange_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoLagrangeRaw", function() { return __WEBPACK_IMPORTED_MODULE_47__src_lagrange_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__src_larrivee__ = __webpack_require__(631);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoLarrivee", function() { return __WEBPACK_IMPORTED_MODULE_48__src_larrivee__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoLarriveeRaw", function() { return __WEBPACK_IMPORTED_MODULE_48__src_larrivee__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__src_laskowski__ = __webpack_require__(632);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoLaskowski", function() { return __WEBPACK_IMPORTED_MODULE_49__src_laskowski__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoLaskowskiRaw", function() { return __WEBPACK_IMPORTED_MODULE_49__src_laskowski__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__src_littrow_js__ = __webpack_require__(633);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoLittrow", function() { return __WEBPACK_IMPORTED_MODULE_50__src_littrow_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoLittrowRaw", function() { return __WEBPACK_IMPORTED_MODULE_50__src_littrow_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__src_loximuthal_js__ = __webpack_require__(634);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoLoximuthal", function() { return __WEBPACK_IMPORTED_MODULE_51__src_loximuthal_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoLoximuthalRaw", function() { return __WEBPACK_IMPORTED_MODULE_51__src_loximuthal_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__src_miller__ = __webpack_require__(635);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoMiller", function() { return __WEBPACK_IMPORTED_MODULE_52__src_miller__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoMillerRaw", function() { return __WEBPACK_IMPORTED_MODULE_52__src_miller__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__src_modifiedStereographic__ = __webpack_require__(636);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoModifiedStereographic", function() { return __WEBPACK_IMPORTED_MODULE_53__src_modifiedStereographic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoModifiedStereographicRaw", function() { return __WEBPACK_IMPORTED_MODULE_53__src_modifiedStereographic__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoModifiedStereographicAlaska", function() { return __WEBPACK_IMPORTED_MODULE_53__src_modifiedStereographic__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoModifiedStereographicGs48", function() { return __WEBPACK_IMPORTED_MODULE_53__src_modifiedStereographic__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoModifiedStereographicGs50", function() { return __WEBPACK_IMPORTED_MODULE_53__src_modifiedStereographic__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoModifiedStereographicMiller", function() { return __WEBPACK_IMPORTED_MODULE_53__src_modifiedStereographic__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoModifiedStereographicLee", function() { return __WEBPACK_IMPORTED_MODULE_53__src_modifiedStereographic__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__src_mollweide__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoMollweide", function() { return __WEBPACK_IMPORTED_MODULE_54__src_mollweide__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoMollweideRaw", function() { return __WEBPACK_IMPORTED_MODULE_54__src_mollweide__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__src_mtFlatPolarParabolic__ = __webpack_require__(637);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoMtFlatPolarParabolic", function() { return __WEBPACK_IMPORTED_MODULE_55__src_mtFlatPolarParabolic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoMtFlatPolarParabolicRaw", function() { return __WEBPACK_IMPORTED_MODULE_55__src_mtFlatPolarParabolic__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__src_mtFlatPolarQuartic__ = __webpack_require__(638);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoMtFlatPolarQuartic", function() { return __WEBPACK_IMPORTED_MODULE_56__src_mtFlatPolarQuartic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoMtFlatPolarQuarticRaw", function() { return __WEBPACK_IMPORTED_MODULE_56__src_mtFlatPolarQuartic__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__src_mtFlatPolarSinusoidal__ = __webpack_require__(639);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoMtFlatPolarSinusoidal", function() { return __WEBPACK_IMPORTED_MODULE_57__src_mtFlatPolarSinusoidal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoMtFlatPolarSinusoidalRaw", function() { return __WEBPACK_IMPORTED_MODULE_57__src_mtFlatPolarSinusoidal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__src_naturalEarth__ = __webpack_require__(640);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoNaturalEarth", function() { return __WEBPACK_IMPORTED_MODULE_58__src_naturalEarth__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoNaturalEarthRaw", function() { return __WEBPACK_IMPORTED_MODULE_58__src_naturalEarth__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__src_nellHammer__ = __webpack_require__(641);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoNellHammer", function() { return __WEBPACK_IMPORTED_MODULE_59__src_nellHammer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoNellHammerRaw", function() { return __WEBPACK_IMPORTED_MODULE_59__src_nellHammer__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__src_patterson__ = __webpack_require__(642);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoPatterson", function() { return __WEBPACK_IMPORTED_MODULE_60__src_patterson__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoPattersonRaw", function() { return __WEBPACK_IMPORTED_MODULE_60__src_patterson__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__src_polyconic__ = __webpack_require__(643);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoPolyconic", function() { return __WEBPACK_IMPORTED_MODULE_61__src_polyconic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoPolyconicRaw", function() { return __WEBPACK_IMPORTED_MODULE_61__src_polyconic__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__src_polyhedral_index_js__ = __webpack_require__(104);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoPolyhedral", function() { return __WEBPACK_IMPORTED_MODULE_62__src_polyhedral_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__src_polyhedral_butterfly_js__ = __webpack_require__(645);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoPolyhedralButterfly", function() { return __WEBPACK_IMPORTED_MODULE_63__src_polyhedral_butterfly_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__src_polyhedral_collignon_js__ = __webpack_require__(646);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoPolyhedralCollignon", function() { return __WEBPACK_IMPORTED_MODULE_64__src_polyhedral_collignon_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__src_polyhedral_waterman_js__ = __webpack_require__(647);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoPolyhedralWaterman", function() { return __WEBPACK_IMPORTED_MODULE_65__src_polyhedral_waterman_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__src_project_index__ = __webpack_require__(648);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoProject", function() { return __WEBPACK_IMPORTED_MODULE_66__src_project_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__src_quincuncial_gringorten_js__ = __webpack_require__(652);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoGringortenQuincuncial", function() { return __WEBPACK_IMPORTED_MODULE_67__src_quincuncial_gringorten_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__src_quincuncial_peirce_js__ = __webpack_require__(291);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoPeirceQuincuncial", function() { return __WEBPACK_IMPORTED_MODULE_68__src_quincuncial_peirce_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoPierceQuincuncial", function() { return __WEBPACK_IMPORTED_MODULE_68__src_quincuncial_peirce_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__src_quantize__ = __webpack_require__(653);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoQuantize", function() { return __WEBPACK_IMPORTED_MODULE_69__src_quantize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__src_quincuncial_index_js__ = __webpack_require__(156);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoQuincuncial", function() { return __WEBPACK_IMPORTED_MODULE_70__src_quincuncial_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__src_rectangularPolyconic__ = __webpack_require__(654);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoRectangularPolyconic", function() { return __WEBPACK_IMPORTED_MODULE_71__src_rectangularPolyconic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoRectangularPolyconicRaw", function() { return __WEBPACK_IMPORTED_MODULE_71__src_rectangularPolyconic__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__src_robinson__ = __webpack_require__(655);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoRobinson", function() { return __WEBPACK_IMPORTED_MODULE_72__src_robinson__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoRobinsonRaw", function() { return __WEBPACK_IMPORTED_MODULE_72__src_robinson__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__src_satellite__ = __webpack_require__(656);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoSatellite", function() { return __WEBPACK_IMPORTED_MODULE_73__src_satellite__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoSatelliteRaw", function() { return __WEBPACK_IMPORTED_MODULE_73__src_satellite__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__src_sinuMollweide__ = __webpack_require__(154);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoSinuMollweide", function() { return __WEBPACK_IMPORTED_MODULE_74__src_sinuMollweide__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoSinuMollweideRaw", function() { return __WEBPACK_IMPORTED_MODULE_74__src_sinuMollweide__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__src_sinusoidal__ = __webpack_require__(66);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoSinusoidal", function() { return __WEBPACK_IMPORTED_MODULE_75__src_sinusoidal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoSinusoidalRaw", function() { return __WEBPACK_IMPORTED_MODULE_75__src_sinusoidal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__src_stitch__ = __webpack_require__(657);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoStitch", function() { return __WEBPACK_IMPORTED_MODULE_76__src_stitch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__src_times__ = __webpack_require__(658);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoTimes", function() { return __WEBPACK_IMPORTED_MODULE_77__src_times__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoTimesRaw", function() { return __WEBPACK_IMPORTED_MODULE_77__src_times__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__src_twoPointAzimuthal__ = __webpack_require__(659);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoTwoPointAzimuthal", function() { return __WEBPACK_IMPORTED_MODULE_78__src_twoPointAzimuthal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoTwoPointAzimuthalRaw", function() { return __WEBPACK_IMPORTED_MODULE_78__src_twoPointAzimuthal__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoTwoPointAzimuthalUsa", function() { return __WEBPACK_IMPORTED_MODULE_78__src_twoPointAzimuthal__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__src_twoPointEquidistant__ = __webpack_require__(660);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoTwoPointEquidistant", function() { return __WEBPACK_IMPORTED_MODULE_79__src_twoPointEquidistant__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoTwoPointEquidistantRaw", function() { return __WEBPACK_IMPORTED_MODULE_79__src_twoPointEquidistant__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoTwoPointEquidistantUsa", function() { return __WEBPACK_IMPORTED_MODULE_79__src_twoPointEquidistant__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__src_vanDerGrinten__ = __webpack_require__(661);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoVanDerGrinten", function() { return __WEBPACK_IMPORTED_MODULE_80__src_vanDerGrinten__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoVanDerGrintenRaw", function() { return __WEBPACK_IMPORTED_MODULE_80__src_vanDerGrinten__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__src_vanDerGrinten2__ = __webpack_require__(662);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoVanDerGrinten2", function() { return __WEBPACK_IMPORTED_MODULE_81__src_vanDerGrinten2__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoVanDerGrinten2Raw", function() { return __WEBPACK_IMPORTED_MODULE_81__src_vanDerGrinten2__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__src_vanDerGrinten3__ = __webpack_require__(663);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoVanDerGrinten3", function() { return __WEBPACK_IMPORTED_MODULE_82__src_vanDerGrinten3__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoVanDerGrinten3Raw", function() { return __WEBPACK_IMPORTED_MODULE_82__src_vanDerGrinten3__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__src_vanDerGrinten4__ = __webpack_require__(664);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoVanDerGrinten4", function() { return __WEBPACK_IMPORTED_MODULE_83__src_vanDerGrinten4__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoVanDerGrinten4Raw", function() { return __WEBPACK_IMPORTED_MODULE_83__src_vanDerGrinten4__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__src_wagner4_js__ = __webpack_require__(665);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoWagner4", function() { return __WEBPACK_IMPORTED_MODULE_84__src_wagner4_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoWagner4Raw", function() { return __WEBPACK_IMPORTED_MODULE_84__src_wagner4_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__src_wagner6_js__ = __webpack_require__(666);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoWagner6", function() { return __WEBPACK_IMPORTED_MODULE_85__src_wagner6_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoWagner6Raw", function() { return __WEBPACK_IMPORTED_MODULE_85__src_wagner6_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__src_wagner7_js__ = __webpack_require__(667);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoWagner7", function() { return __WEBPACK_IMPORTED_MODULE_86__src_wagner7_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoWagner7Raw", function() { return __WEBPACK_IMPORTED_MODULE_86__src_wagner7_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__src_wiechel_js__ = __webpack_require__(668);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoWiechel", function() { return __WEBPACK_IMPORTED_MODULE_87__src_wiechel_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoWiechelRaw", function() { return __WEBPACK_IMPORTED_MODULE_87__src_wiechel_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__src_winkel3__ = __webpack_require__(669);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoWinkel3", function() { return __WEBPACK_IMPORTED_MODULE_88__src_winkel3__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "geoWinkel3Raw", function() { return __WEBPACK_IMPORTED_MODULE_88__src_winkel3__["b"]; });





































































 // DEPRECATED misspelling






















/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = airyRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function airyRaw(beta) {
  var tanBeta_2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(beta / 2),
      b = 2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["p" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(beta / 2)) / (tanBeta_2 * tanBeta_2);

  function forward(x, y) {
    var cosx = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(x),
        cosy = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(y),
        siny = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(y),
        cosz = cosy * cosx,
        k = -((1 - cosz ? Object(__WEBPACK_IMPORTED_MODULE_1__math__["p" /* log */])((1 + cosz) / 2) / (1 - cosz) : -0.5) + b / (1 + cosz));
    return [k * cosy * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(x), k * siny];
  }

  forward.invert = function(x, y) {
    var r = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(x * x + y * y),
        z = -beta / 2,
        i = 50, delta;
    if (!r) return [0, 0];
    do {
      var z_2 = z / 2,
          cosz_2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(z_2),
          sinz_2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(z_2),
          tanz_2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(z_2),
          lnsecz_2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["p" /* log */])(1 / cosz_2);
      z -= delta = (2 / tanz_2 * lnsecz_2 - b * tanz_2 - r) / (-lnsecz_2 / (sinz_2 * sinz_2) + 1 - b / (2 * cosz_2 * cosz_2));
    } while (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] && --i > 0);
    var sinz = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(z);
    return [Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(x * sinz, r * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(z)), Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(y * sinz / r)];
  };

  return forward;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  var beta = __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */],
      m = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["l" /* geoProjectionMutator */])(airyRaw),
      p = m(beta);

  p.radius = function(_) {
    return arguments.length ? m(beta = _ * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */]) : beta * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */];
  };

  return p
      .scale(179.976)
      .clipAngle(147);
});


/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stream__ = __webpack_require__(40);






var lambda0, phi0, lambda1, phi1, // bounds
    lambda2, // previous lambda-coordinate
    lambda00, phi00, // first point
    p0, // previous 3D point
    deltaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    ranges,
    range;

var boundsStream = {
  point: boundsPoint,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream.point = boundsRingPoint;
    boundsStream.lineStart = boundsRingStart;
    boundsStream.lineEnd = boundsRingEnd;
    deltaSum.reset();
    __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].polygonStart();
  },
  polygonEnd: function() {
    __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].polygonEnd();
    boundsStream.point = boundsPoint;
    boundsStream.lineStart = boundsLineStart;
    boundsStream.lineEnd = boundsLineEnd;
    if (__WEBPACK_IMPORTED_MODULE_1__area__["a" /* areaRingSum */] < 0) lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    else if (deltaSum > __WEBPACK_IMPORTED_MODULE_3__math__["i" /* epsilon */]) phi1 = 90;
    else if (deltaSum < -__WEBPACK_IMPORTED_MODULE_3__math__["i" /* epsilon */]) phi0 = -90;
    range[0] = lambda0, range[1] = lambda1;
  }
};

function boundsPoint(lambda, phi) {
  ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
}

function linePoint(lambda, phi) {
  var p = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["a" /* cartesian */])([lambda * __WEBPACK_IMPORTED_MODULE_3__math__["r" /* radians */], phi * __WEBPACK_IMPORTED_MODULE_3__math__["r" /* radians */]]);
  if (p0) {
    var normal = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["c" /* cartesianCross */])(p0, p),
        equatorial = [normal[1], -normal[0], 0],
        inflection = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["c" /* cartesianCross */])(equatorial, normal);
    Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["e" /* cartesianNormalizeInPlace */])(inflection);
    inflection = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["g" /* spherical */])(inflection);
    var delta = lambda - lambda2,
        sign = delta > 0 ? 1 : -1,
        lambdai = inflection[0] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */] * sign,
        phii,
        antimeridian = Object(__WEBPACK_IMPORTED_MODULE_3__math__["a" /* abs */])(delta) > 180;
    if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = inflection[1] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */];
      if (phii > phi1) phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = -inflection[1] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */];
      if (phii < phi0) phi0 = phii;
    } else {
      if (phi < phi0) phi0 = phi;
      if (phi > phi1) phi1 = phi;
    }
    if (antimeridian) {
      if (lambda < lambda2) {
        if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
      } else {
        if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
      }
    } else {
      if (lambda1 >= lambda0) {
        if (lambda < lambda0) lambda0 = lambda;
        if (lambda > lambda1) lambda1 = lambda;
      } else {
        if (lambda > lambda2) {
          if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
        } else {
          if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        }
      }
    }
  } else {
    ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  }
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
  p0 = p, lambda2 = lambda;
}

function boundsLineStart() {
  boundsStream.point = linePoint;
}

function boundsLineEnd() {
  range[0] = lambda0, range[1] = lambda1;
  boundsStream.point = boundsPoint;
  p0 = null;
}

function boundsRingPoint(lambda, phi) {
  if (p0) {
    var delta = lambda - lambda2;
    deltaSum.add(Object(__WEBPACK_IMPORTED_MODULE_3__math__["a" /* abs */])(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    lambda00 = lambda, phi00 = phi;
  }
  __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].point(lambda, phi);
  linePoint(lambda, phi);
}

function boundsRingStart() {
  __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].lineStart();
}

function boundsRingEnd() {
  boundsRingPoint(lambda00, phi00);
  __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].lineEnd();
  if (Object(__WEBPACK_IMPORTED_MODULE_3__math__["a" /* abs */])(deltaSum) > __WEBPACK_IMPORTED_MODULE_3__math__["i" /* epsilon */]) lambda0 = -(lambda1 = 180);
  range[0] = lambda0, range[1] = lambda1;
  p0 = null;
}

// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}

function rangeCompare(a, b) {
  return a[0] - b[0];
}

function rangeContains(range, x) {
  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

/* harmony default export */ __webpack_exports__["a"] = (function(feature) {
  var i, n, a, b, merged, deltaMax, delta;

  phi1 = lambda1 = -(lambda0 = phi0 = Infinity);
  ranges = [];
  Object(__WEBPACK_IMPORTED_MODULE_4__stream__["a" /* default */])(feature, boundsStream);

  // First, sort ranges by their minimum longitudes.
  if (n = ranges.length) {
    ranges.sort(rangeCompare);

    // Then, merge any ranges that overlap.
    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
      } else {
        merged.push(a = b);
      }
    }

    // Finally, find the largest gap between the merged ranges.
    // The final bounding box will be the inverse of this gap.
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
      b = merged[i];
      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0 = b[0], lambda1 = a[1];
    }
  }

  ranges = range = null;

  return lambda0 === Infinity || phi0 === Infinity
      ? [[NaN, NaN], [NaN, NaN]]
      : [[lambda0, phi0], [lambda1, phi1]];
});


/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stream__ = __webpack_require__(40);




var W0, W1,
    X0, Y0, Z0,
    X1, Y1, Z1,
    X2, Y2, Z2,
    lambda00, phi00, // first point
    x0, y0, z0; // previous point

var centroidStream = {
  sphere: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  }
};

// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  centroidPointCartesian(cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda), cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda), Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi));
}

function centroidPointCartesian(x, y, z) {
  ++W0;
  X0 += (x - X0) / W0;
  Y0 += (y - Y0) / W0;
  Z0 += (z - Z0) / W0;
}

function centroidLineStart() {
  centroidStream.point = centroidLinePointFirst;
}

function centroidLinePointFirst(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  x0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda);
  y0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda);
  z0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi);
  centroidStream.point = centroidLinePoint;
  centroidPointCartesian(x0, y0, z0);
}

function centroidLinePoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi),
      x = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda),
      y = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda),
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi),
      w = Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
  centroidStream.point = centroidRingPointFirst;
}

function centroidRingEnd() {
  centroidRingPoint(lambda00, phi00);
  centroidStream.point = centroidPoint;
}

function centroidRingPointFirst(lambda, phi) {
  lambda00 = lambda, phi00 = phi;
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  centroidStream.point = centroidRingPoint;
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  x0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda);
  y0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda);
  z0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi);
  centroidPointCartesian(x0, y0, z0);
}

function centroidRingPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi),
      x = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda),
      y = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda),
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi),
      cx = y0 * z - z0 * y,
      cy = z0 * x - x0 * z,
      cz = x0 * y - y0 * x,
      m = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(cx * cx + cy * cy + cz * cz),
      w = Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(m), // line weight = angle
      v = m && -w / m; // area weight multiplier
  X2 += v * cx;
  Y2 += v * cy;
  Z2 += v * cz;
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

/* harmony default export */ __webpack_exports__["a"] = (function(object) {
  W0 = W1 =
  X0 = Y0 = Z0 =
  X1 = Y1 = Z1 =
  X2 = Y2 = Z2 = 0;
  Object(__WEBPACK_IMPORTED_MODULE_2__stream__["a" /* default */])(object, centroidStream);

  var x = X2,
      y = Y2,
      z = Z2,
      m = x * x + y * y + z * z;

  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
  if (m < __WEBPACK_IMPORTED_MODULE_0__math__["j" /* epsilon2 */]) {
    x = X1, y = Y1, z = Z1;
    // If the feature has zero length, fall back to arithmetic mean of point vectors.
    if (W1 < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) x = X0, y = Y0, z = Z0;
    m = x * x + y * y + z * z;
    // If the feature still has an undefined ccentroid, then return.
    if (m < __WEBPACK_IMPORTED_MODULE_0__math__["j" /* epsilon2 */]) return [NaN, NaN];
  }

  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(y, x) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(z / Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(m)) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
});


/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(267);


/* harmony default export */ __webpack_exports__["a"] = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["b" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});


/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(274);









/* harmony default export */ __webpack_exports__["a"] = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = Object(__WEBPACK_IMPORTED_MODULE_6__ticks__["c" /* tickStep */])(x0, x1, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[Object(__WEBPACK_IMPORTED_MODULE_1__bisect__["c" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(147);





/* harmony default export */ __webpack_exports__["a"] = (function(values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(268);


/* harmony default export */ __webpack_exports__["a"] = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * Object(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(64);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});


/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(147);




/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});


/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});


/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});


/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(52);


/* harmony default export */ __webpack_exports__["a"] = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});


/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(276);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rectangle__ = __webpack_require__(101);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var x0 = 0,
      y0 = 0,
      x1 = 960,
      y1 = 500,
      cache,
      cacheStream,
      clip;

  return clip = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = Object(__WEBPACK_IMPORTED_MODULE_0__rectangle__["a" /* default */])(x0, y0, x1, y1)(cacheStream = stream);
    },
    extent: function(_) {
      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
    }
  };
});


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b, x0, y0, x1, y1) {
  var ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
  return true;
});


/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polygonContains__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__distance__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(4);




var containsObjectType = {
  Feature: function(object, point) {
    return containsGeometry(object.geometry, point);
  },
  FeatureCollection: function(object, point) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
    return false;
  }
};

var containsGeometryType = {
  Sphere: function() {
    return true;
  },
  Point: function(object, point) {
    return containsPoint(object.coordinates, point);
  },
  MultiPoint: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
    return false;
  },
  LineString: function(object, point) {
    return containsLine(object.coordinates, point);
  },
  MultiLineString: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsLine(coordinates[i], point)) return true;
    return false;
  },
  Polygon: function(object, point) {
    return containsPolygon(object.coordinates, point);
  },
  MultiPolygon: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
    return false;
  },
  GeometryCollection: function(object, point) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
    return false;
  }
};

function containsGeometry(geometry, point) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
      ? containsGeometryType[geometry.type](geometry, point)
      : false;
}

function containsPoint(coordinates, point) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates, point) === 0;
}

function containsLine(coordinates, point) {
  var ab = Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates[0], coordinates[1]),
      ao = Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates[0], point),
      ob = Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(point, coordinates[1]);
  return ao + ob <= ab + __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];
}

function containsPolygon(coordinates, point) {
  return !!Object(__WEBPACK_IMPORTED_MODULE_0__polygonContains__["a" /* default */])(coordinates.map(ringRadians), pointRadians(point));
}

function ringRadians(ring) {
  return ring = ring.map(pointRadians), ring.pop(), ring;
}

function pointRadians(point) {
  return [point[0] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */], point[1] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */]];
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(object, point) {
  return (object && containsObjectType.hasOwnProperty(object.type)
      ? containsObjectType[object.type]
      : containsGeometry)(object, point);
});


/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export graticule10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(4);



function graticuleX(y0, y1, dy) {
  var y = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(y0, y1 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */], dy).concat(y1);
  return function(x) { return y.map(function(y) { return [x, y]; }); };
}

function graticuleY(x0, x1, dx) {
  var x = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(x0, x1 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */], dx).concat(x1);
  return function(y) { return x.map(function(x) { return [x, y]; }); };
}

function graticule() {
  var x1, x0, X1, X0,
      y1, y0, Y1, Y0,
      dx = 10, dy = dx, DX = 90, DY = 360,
      x, y, X, Y,
      precision = 2.5;

  function graticule() {
    return {type: "MultiLineString", coordinates: lines()};
  }

  function lines() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(X0 / DX) * DX, X1, DX).map(X)
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(Y0 / DY) * DY, Y1, DY).map(Y))
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(x0 / dx) * dx, x1, dx).filter(function(x) { return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(x % DX) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]; }).map(x))
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(y0 / dy) * dy, y1, dy).filter(function(y) { return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(y % DY) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]; }).map(y));
  }

  graticule.lines = function() {
    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
  };

  graticule.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        X(X0).concat(
        Y(Y1).slice(1),
        X(X1).reverse().slice(1),
        Y(Y0).reverse().slice(1))
      ]
    };
  };

  graticule.extent = function(_) {
    if (!arguments.length) return graticule.extentMinor();
    return graticule.extentMajor(_).extentMinor(_);
  };

  graticule.extentMajor = function(_) {
    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
    X0 = +_[0][0], X1 = +_[1][0];
    Y0 = +_[0][1], Y1 = +_[1][1];
    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
    return graticule.precision(precision);
  };

  graticule.extentMinor = function(_) {
    if (!arguments.length) return [[x0, y0], [x1, y1]];
    x0 = +_[0][0], x1 = +_[1][0];
    y0 = +_[0][1], y1 = +_[1][1];
    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
    return graticule.precision(precision);
  };

  graticule.step = function(_) {
    if (!arguments.length) return graticule.stepMinor();
    return graticule.stepMajor(_).stepMinor(_);
  };

  graticule.stepMajor = function(_) {
    if (!arguments.length) return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule;
  };

  graticule.stepMinor = function(_) {
    if (!arguments.length) return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule;
  };

  graticule.precision = function(_) {
    if (!arguments.length) return precision;
    precision = +_;
    x = graticuleX(y0, y1, 90);
    y = graticuleY(x0, x1, precision);
    X = graticuleX(Y0, Y1, 90);
    Y = graticuleY(X0, X1, precision);
    return graticule;
  };

  return graticule
      .extentMajor([[-180, -90 + __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]], [180, 90 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]]])
      .extentMinor([[-180, -80 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]], [180, 80 + __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]]]);
}

function graticule10() {
  return graticule()();
}


/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(4);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var x0 = a[0] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      y0 = a[1] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      x1 = b[0] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      y1 = b[1] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y0),
      sy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0),
      cy1 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y1),
      sy1 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y1),
      kx0 = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x0),
      ky0 = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x0),
      kx1 = cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x1),
      ky1 = cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x1),
      d = 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* haversin */])(y1 - y0) + cy0 * cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* haversin */])(x1 - x0))),
      k = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(d);

  var interpolate = d ? function(t) {
    var B = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(t *= d) / k,
        A = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(d - t) / k,
        x = A * kx0 + B * kx1,
        y = A * ky0 + B * ky1,
        z = A * sy0 + B * sy1;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(y, x) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */],
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(z, Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + y * y)) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]
    ];
  } : function() {
    return [x0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], y0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
  };

  interpolate.distance = d;

  return interpolate;
});


/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stream__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__area__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bounds__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__centroid__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__measure__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__string__ = __webpack_require__(578);









/* unused harmony default export */ var _unused_webpack_default_export = (function(projection, context) {
  var pointRadius = 4.5,
      projectionStream,
      contextStream;

  function path(object) {
    if (object) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(contextStream));
    }
    return contextStream.result();
  }

  path.area = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_2__area__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_2__area__["a" /* default */].result();
  };

  path.measure = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_6__measure__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_6__measure__["a" /* default */].result();
  };

  path.bounds = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_3__bounds__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_3__bounds__["a" /* default */].result();
  };

  path.centroid = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_4__centroid__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_4__centroid__["a" /* default */].result();
  };

  path.projection = function(_) {
    return arguments.length ? (projectionStream = _ == null ? (projection = null, __WEBPACK_IMPORTED_MODULE_0__identity__["a" /* default */]) : (projection = _).stream, path) : projection;
  };

  path.context = function(_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new __WEBPACK_IMPORTED_MODULE_7__string__["a" /* default */]) : new __WEBPACK_IMPORTED_MODULE_5__context__["a" /* default */](context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path;
  };

  path.pointRadius = function(_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };

  return path.projection(projection).context(context);
});


/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(31);




var areaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    areaRingSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    x00,
    y00,
    x0,
    y0;

var areaStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: function() {
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    areaStream.lineStart = areaStream.lineEnd = areaStream.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
    areaSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(areaRingSum));
    areaRingSum.reset();
  },
  result: function() {
    var area = areaSum / 2;
    areaSum.reset();
    return area;
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaPointFirst(x, y) {
  areaStream.point = areaPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function areaPoint(x, y) {
  areaRingSum.add(y0 * x - x0 * y);
  x0 = x, y0 = y;
}

function areaRingEnd() {
  areaPoint(x00, y00);
}

/* harmony default export */ __webpack_exports__["a"] = (areaStream);


/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(4);


// TODO Enforce positive area for exterior, negative area for interior?

var X0 = 0,
    Y0 = 0,
    Z0 = 0,
    X1 = 0,
    Y1 = 0,
    Z1 = 0,
    X2 = 0,
    Y2 = 0,
    Z2 = 0,
    x00,
    y00,
    x0,
    y0;

var centroidStream = {
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.point = centroidPoint;
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  },
  result: function() {
    var centroid = Z2 ? [X2 / Z2, Y2 / Z2]
        : Z1 ? [X1 / Z1, Y1 / Z1]
        : Z0 ? [X0 / Z0, Y0 / Z0]
        : [NaN, NaN];
    X0 = Y0 = Z0 =
    X1 = Y1 = Z1 =
    X2 = Y2 = Z2 = 0;
    return centroid;
  }
};

function centroidPoint(x, y) {
  X0 += x;
  Y0 += y;
  ++Z0;
}

function centroidLineStart() {
  centroidStream.point = centroidPointFirstLine;
}

function centroidPointFirstLine(x, y) {
  centroidStream.point = centroidPointLine;
  centroidPoint(x0 = x, y0 = y);
}

function centroidPointLine(x, y) {
  var dx = x - x0, dy = y - y0, z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(dx * dx + dy * dy);
  X1 += z * (x0 + x) / 2;
  Y1 += z * (y0 + y) / 2;
  Z1 += z;
  centroidPoint(x0 = x, y0 = y);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

function centroidRingStart() {
  centroidStream.point = centroidPointFirstRing;
}

function centroidRingEnd() {
  centroidPointRing(x00, y00);
}

function centroidPointFirstRing(x, y) {
  centroidStream.point = centroidPointRing;
  centroidPoint(x00 = x0 = x, y00 = y0 = y);
}

function centroidPointRing(x, y) {
  var dx = x - x0,
      dy = y - y0,
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(dx * dx + dy * dy);

  X1 += z * (x0 + x) / 2;
  Y1 += z * (y0 + y) / 2;
  Z1 += z;

  z = y0 * x - x0 * y;
  X2 += z * (x0 + x);
  Y2 += z * (y0 + y);
  Z2 += z * 3;
  centroidPoint(x0 = x, y0 = y);
}

/* harmony default export */ __webpack_exports__["a"] = (centroidStream);


/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PathContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(31);



function PathContext(context) {
  this._context = context;
}

PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(_) {
    return this._radius = _, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._context.closePath();
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(x, y);
        this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(x, y);
        break;
      }
      default: {
        this._context.moveTo(x + this._radius, y);
        this._context.arc(x, y, this._radius, 0, __WEBPACK_IMPORTED_MODULE_0__math__["w" /* tau */]);
        break;
      }
    }
  },
  result: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */]
};


/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(31);




var lengthSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lengthRing,
    x00,
    y00,
    x0,
    y0;

var lengthStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: function() {
    lengthStream.point = lengthPointFirst;
  },
  lineEnd: function() {
    if (lengthRing) lengthPoint(x00, y00);
    lengthStream.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
  },
  polygonStart: function() {
    lengthRing = true;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var length = +lengthSum;
    lengthSum.reset();
    return length;
  }
};

function lengthPointFirst(x, y) {
  lengthStream.point = lengthPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function lengthPoint(x, y) {
  x0 -= x, y0 -= y;
  lengthSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* sqrt */])(x0 * x0 + y0 * y0));
  x0 = x, y0 = y;
}

/* harmony default export */ __webpack_exports__["a"] = (lengthStream);


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PathString;
function PathString() {
  this._string = [];
}

PathString.prototype = {
  _radius: 4.5,
  _circle: circle(4.5),
  pointRadius: function(_) {
    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
    return this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._string.push("Z");
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._string.push("M", x, ",", y);
        this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", x, ",", y);
        break;
      }
      default: {
        if (this._circle == null) this._circle = circle(this._radius);
        this._string.push("M", x, ",", y, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var result = this._string.join("");
      this._string = [];
      return result;
    } else {
      return null;
    }
  }
};

function circle(radius) {
  return "m0," + radius
      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
      + "z";
}


/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transform__ = __webpack_require__(102);




var maxDepth = 16, // maximum depth of subdivision
    cosMinDistance = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(30 * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */]); // cos(minimum angular distance)

/* harmony default export */ __webpack_exports__["a"] = (function(project, delta2) {
  return +delta2 ? resample(project, delta2) : resampleNone(project);
});

function resampleNone(project) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__transform__["a" /* transformer */])({
    point: function(x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}

function resample(project, delta2) {

  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
    var dx = x1 - x0,
        dy = y1 - y0,
        d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1,
          b = b0 + b1,
          c = c0 + c1,
          m = Object(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* sqrt */])(a * a + b * b + c * c),
          phi2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* asin */])(c /= m),
          lambda2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(c) - 1) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */] || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda0 - lambda1) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */] ? (lambda0 + lambda1) / 2 : Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(b, a),
          p = project(lambda2, phi2),
          x2 = p[0],
          y2 = p[1],
          dx2 = x2 - x0,
          dy2 = y2 - y0,
          dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 // perpendicular projected distance
          || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda00, x00, y00, a00, b00, c00, // first point
        lambda0, x0, y0, a0, b0, c0; // previous point

    var resampleStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
    };

    function point(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }

    function lineStart() {
      x0 = NaN;
      resampleStream.point = linePoint;
      stream.lineStart();
    }

    function linePoint(lambda, phi) {
      var c = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])([lambda, phi]), p = project(lambda, phi);
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
      stream.point(x0, y0);
    }

    function lineEnd() {
      resampleStream.point = point;
      stream.lineEnd();
    }

    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }

    function ringPoint(lambda, phi) {
      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint;
    }

    function ringEnd() {
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }

    return resampleStream;
  };
}


/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cylindricalEqualAreaRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(4);


function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi) / cosPhi0];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(y * cosPhi0)];
  };

  return forward;
}


/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__albers__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conicEqualArea__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fit__ = __webpack_require__(151);





// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
  };
}

// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var cache,
      cacheStream,
      lower48 = Object(__WEBPACK_IMPORTED_MODULE_1__albers__["a" /* default */])(), lower48Point,
      alaska = Object(__WEBPACK_IMPORTED_MODULE_2__conicEqualArea__["a" /* default */])().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
      hawaii = Object(__WEBPACK_IMPORTED_MODULE_2__conicEqualArea__["a" /* default */])().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
      point, pointStream = {point: function(x, y) { point = [x, y]; }};

  function albersUsa(coordinates) {
    var x = coordinates[0], y = coordinates[1];
    return point = null,
        (lower48Point.point(x, y), point)
        || (alaskaPoint.point(x, y), point)
        || (hawaiiPoint.point(x, y), point);
  }

  albersUsa.invert = function(coordinates) {
    var k = lower48.scale(),
        t = lower48.translate(),
        x = (coordinates[0] - t[0]) / k,
        y = (coordinates[1] - t[1]) / k;
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
        : lower48).invert(coordinates);
  };

  albersUsa.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };

  albersUsa.precision = function(_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };

  albersUsa.scale = function(_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa.translate(lower48.translate());
  };

  albersUsa.translate = function(_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(), x = +_[0], y = +_[1];

    lower48Point = lower48
        .translate(_)
        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
        .stream(pointStream);

    alaskaPoint = alaska
        .translate([x - 0.307 * k, y + 0.201 * k])
        .clipExtent([[x - 0.425 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.120 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]], [x - 0.214 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.234 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]]])
        .stream(pointStream);

    hawaiiPoint = hawaii
        .translate([x - 0.205 * k, y + 0.212 * k])
        .clipExtent([[x - 0.214 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.166 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]], [x - 0.115 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.234 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]]])
        .stream(pointStream);

    return reset();
  };

  albersUsa.fitExtent = function(extent, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["a" /* fitExtent */])(albersUsa, extent, object);
  };

  albersUsa.fitSize = function(size, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["c" /* fitSize */])(albersUsa, size, object);
  };

  albersUsa.fitWidth = function(width, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["d" /* fitWidth */])(albersUsa, width, object);
  };

  albersUsa.fitHeight = function(height, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["b" /* fitHeight */])(albersUsa, height, object);
  };

  function reset() {
    cache = cacheStream = null;
    return albersUsa;
  }

  return albersUsa.scale(1070);
});


/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return azimuthalEqualAreaRaw; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(23);




var azimuthalEqualAreaRaw = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["b" /* azimuthalRaw */])(function(cxcy) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(2 / (1 + cxcy));
});

azimuthalEqualAreaRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(z / 2);
});

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(azimuthalEqualAreaRaw)
      .scale(124.75)
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return azimuthalEquidistantRaw; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(23);




var azimuthalEquidistantRaw = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["b" /* azimuthalRaw */])(function(c) {
  return (c = Object(__WEBPACK_IMPORTED_MODULE_0__math__["b" /* acos */])(c)) && c / Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(c);
});

azimuthalEquidistantRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return z;
});

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(azimuthalEquidistantRaw)
      .scale(79.4188)
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export conicConformalRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mercator__ = __webpack_require__(152);




function tany(y) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["v" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + y) / 2);
}

function conicConformalRaw(y0, y1) {
  var cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y0),
      n = y0 === y1 ? Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0) : Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(cy0 / Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y1)) / Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(tany(y1) / tany(y0)),
      f = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["p" /* pow */])(tany(y0), n) / n;

  if (!n) return __WEBPACK_IMPORTED_MODULE_2__mercator__["b" /* mercatorRaw */];

  function project(x, y) {
    if (f > 0) { if (y < -__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) y = -__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]; }
    else { if (y > __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) y = __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]; }
    var r = f / Object(__WEBPACK_IMPORTED_MODULE_0__math__["p" /* pow */])(tany(y), n);
    return [r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(n * x), f - r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(n * x)];
  }

  project.invert = function(x, y) {
    var fy = f - y, r = Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(n) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + fy * fy);
    return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(fy)) / n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(fy), 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["p" /* pow */])(f / r, 1 / n)) - __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */]];
  };

  return project;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicConformalRaw)
      .scale(109.5)
      .parallels([30, 30]);
});


/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export conicEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equirectangular__ = __webpack_require__(282);




function conicEquidistantRaw(y0, y1) {
  var cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y0),
      n = y0 === y1 ? Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0) : (cy0 - Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y1)) / (y1 - y0),
      g = cy0 / n + y0;

  if (Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(n) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) return __WEBPACK_IMPORTED_MODULE_2__equirectangular__["b" /* equirectangularRaw */];

  function project(x, y) {
    var gy = g - y, nx = n * x;
    return [gy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(nx), g - gy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(nx)];
  }

  project.invert = function(x, y) {
    var gy = g - y;
    return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(gy)) / n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(gy), g - Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(n) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + gy * gy)];
  };

  return project;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicEquidistantRaw)
      .scale(131.154)
      .center([0, 13.9389]);
});


/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = gnomonicRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(23);




function gnomonicRaw(x, y) {
  var cy = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y), k = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x) * cy;
  return [cy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x) / k, Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y) / k];
}

gnomonicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */]);

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(gnomonicRaw)
      .scale(144.049)
      .clipAngle(60);
});


/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clip_rectangle__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transform__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fit__ = __webpack_require__(151);





function scaleTranslate(kx, ky, tx, ty) {
  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */] : Object(__WEBPACK_IMPORTED_MODULE_2__transform__["a" /* transformer */])({
    point: function(x, y) {
      this.stream.point(x * kx + tx, y * ky + ty);
    }
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */], // scale, translate and reflect
      x0 = null, y0, x1, y1, // clip extent
      postclip = __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */],
      cache,
      cacheStream,
      projection;

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return projection = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
    },
    postclip: function(_) {
      return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    },
    clipExtent: function(_) {
      return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */]) : Object(__WEBPACK_IMPORTED_MODULE_0__clip_rectangle__["a" /* default */])(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
    },
    scale: function(_) {
      return arguments.length ? (transform = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
    },
    translate: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
    },
    reflectX: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
    },
    reflectY: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
    },
    fitExtent: function(extent, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["a" /* fitExtent */])(projection, extent, object);
    },
    fitSize: function(size, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["c" /* fitSize */])(projection, size, object);
    },
    fitWidth: function(width, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["d" /* fitWidth */])(projection, width, object);
    },
    fitHeight: function(height, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["b" /* fitHeight */])(projection, height, object);
    }
  };
});


/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export naturalEarth1Raw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(4);



function naturalEarth1Raw(lambda, phi) {
  var phi2 = phi * phi, phi4 = phi2 * phi2;
  return [
    lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
    phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
  ];
}

naturalEarth1Raw.invert = function(x, y) {
  var phi = y, i = 25, delta;
  do {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) /
        (1.007226 + phi2 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi2 - 0.005916 * 11 * phi4)));
  } while (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */] && --i > 0);
  return [
    x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
    phi
  ];
};

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(naturalEarth1Raw)
      .scale(175.295);
});


/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export orthographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(23);




function orthographicRaw(x, y) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x), Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y)];
}

orthographicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */]);

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(orthographicRaw)
      .scale(249.5)
      .clipAngle(90 + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]);
});


/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stereographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(23);




function stereographicRaw(x, y) {
  var cy = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y), k = 1 + Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x) * cy;
  return [cy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x) / k, Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y) / k];
}

stereographicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(z);
});

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(stereographicRaw)
      .scale(250)
      .clipAngle(142);
});


/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export transverseMercatorRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mercator__ = __webpack_require__(152);



function transverseMercatorRaw(lambda, phi) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["v" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + phi) / 2)), -lambda];
}

transverseMercatorRaw.invert = function(x, y) {
  return [-y, 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["k" /* exp */])(x)) - __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */]];
};

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var m = Object(__WEBPACK_IMPORTED_MODULE_1__mercator__["a" /* mercatorProjection */])(transverseMercatorRaw),
      center = m.center,
      rotate = m.rotate;

  m.center = function(_) {
    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
  };

  m.rotate = function(_) {
    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
  };

  return rotate([0, 0, 90])
      .scale(159.155);
});


/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = armadilloRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function armadilloRaw(phi0) {
  var sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi0),
      cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi0),
      sPhi0 = phi0 >= 0 ? 1 : -1,
      tanPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(sPhi0 * phi0),
      k = (1 + sinPhi0 - cosPhi0) / 2;

  function forward(lambda, phi) {
    var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi),
        cosLambda = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(lambda /= 2);
    return [
      (1 + cosPhi) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(lambda),
      (sPhi0 * phi > -Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(cosLambda, tanPhi0) - 1e-3 ? 0 : -sPhi0 * 10) + k + Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi) * cosPhi0 - (1 + cosPhi) * sinPhi0 * cosLambda // TODO D3 core should allow null or [NaN, NaN] to be returned.
    ];
  }

  forward.invert = function(x, y) {
    var lambda = 0,
        phi = 0,
        i = 50;
    do {
      var cosLambda = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(lambda),
          sinLambda = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(lambda),
          cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi),
          sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi),
          A = 1 + cosPhi,
          fx = A * sinLambda - x,
          fy = k + sinPhi * cosPhi0 - A * sinPhi0 * cosLambda - y,
          dxdLambda = A * cosLambda / 2,
          dxdPhi = -sinLambda * sinPhi,
          dydLambda = sinPhi0 * A * sinLambda / 2,
          dydPhi = cosPhi0 * cosPhi + sinPhi0 * cosLambda * sinPhi,
          denominator = dxdPhi * dydLambda - dydPhi * dxdLambda,
          dLambda = (fy * dxdPhi - fx * dydPhi) / denominator / 2,
          dPhi = (fx * dydLambda - fy * dxdLambda) / denominator;
      lambda -= dLambda, phi -= dPhi;
    } while ((Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(dLambda) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(dPhi) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]) && --i > 0);
    return sPhi0 * phi > -Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(lambda), tanPhi0) - 1e-3 ? [lambda * 2, phi] : null;
  };

  return forward;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  var phi0 = 20 * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */],
      sPhi0 = phi0 >= 0 ? 1 : -1,
      tanPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(sPhi0 * phi0),
      m = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["l" /* geoProjectionMutator */])(armadilloRaw),
      p = m(phi0),
      stream_ = p.stream;

  p.parallel = function(_) {
    if (!arguments.length) return phi0 * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */];
    tanPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])((sPhi0 = (phi0 = _ * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */]) >= 0 ? 1 : -1) * phi0);
    return m(phi0);
  };

  p.stream = function(stream) {
    var rotate = p.rotate(),
        rotateStream = stream_(stream),
        sphereStream = (p.rotate([0, 0]), stream_(stream));
    p.rotate(rotate);
    rotateStream.sphere = function() {
      sphereStream.polygonStart(), sphereStream.lineStart();
      for (var lambda = sPhi0 * -180; sPhi0 * lambda < 180; lambda += sPhi0 * 90) sphereStream.point(lambda, sPhi0 * 90);
      while (sPhi0 * (lambda -= phi0) >= -180) { // TODO precision?
        sphereStream.point(lambda, sPhi0 * -Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(lambda * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */] / 2), tanPhi0) * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */]);
      }
      sphereStream.lineEnd(), sphereStream.polygonEnd();
    };
    return rotateStream;
  };

  return p
      .scale(218.695)
      .center([0, 28.0974]);
});


/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bakerRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



var sqrt8 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(8),
    phi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["p" /* log */])(1 + __WEBPACK_IMPORTED_MODULE_1__math__["D" /* sqrt2 */]);

function bakerRaw(lambda, phi) {
  var phi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(phi);
  return phi0 < __WEBPACK_IMPORTED_MODULE_1__math__["u" /* quarterPi */]
      ? [lambda, Object(__WEBPACK_IMPORTED_MODULE_1__math__["p" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* quarterPi */] + phi / 2))]
      : [lambda * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi0) * (2 * __WEBPACK_IMPORTED_MODULE_1__math__["D" /* sqrt2 */] - 1 / Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi0)), Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(phi) * (2 * __WEBPACK_IMPORTED_MODULE_1__math__["D" /* sqrt2 */] * (phi0 - __WEBPACK_IMPORTED_MODULE_1__math__["u" /* quarterPi */]) - Object(__WEBPACK_IMPORTED_MODULE_1__math__["p" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(phi0 / 2)))];
}

bakerRaw.invert = function(x, y) {
  if ((y0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(y)) < phi0) return [x, 2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["m" /* exp */])(y)) - __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]];
  var phi = __WEBPACK_IMPORTED_MODULE_1__math__["u" /* quarterPi */], i = 25, delta, y0;
  do {
    var cosPhi_2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi / 2), tanPhi_2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(phi / 2);
    phi -= delta = (sqrt8 * (phi - __WEBPACK_IMPORTED_MODULE_1__math__["u" /* quarterPi */]) - Object(__WEBPACK_IMPORTED_MODULE_1__math__["p" /* log */])(tanPhi_2) - y0) / (sqrt8 - cosPhi_2 * cosPhi_2 / (2 * tanPhi_2));
  } while (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_1__math__["l" /* epsilon2 */] && --i > 0);
  return [x / (Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi) * (sqrt8 - 1 / Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi))), Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(y) * phi];
};

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(bakerRaw)
      .scale(112.314);
});


/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = berghausRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function berghausRaw(lobes) {
  var k = 2 * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / lobes;

  function forward(lambda, phi) {
    var p = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["b" /* geoAzimuthalEquidistantRaw */])(lambda, phi);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda) > __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]) { // back hemisphere
      var theta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(p[1], p[0]),
          r = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(p[0] * p[0] + p[1] * p[1]),
          theta0 = k * Object(__WEBPACK_IMPORTED_MODULE_1__math__["w" /* round */])((theta - __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]) / k) + __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */],
          α = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(theta -= theta0), 2 - Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(theta)); // angle relative to lobe end
      theta = theta0 + Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / r * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(α)) - α;
      p[0] = r * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(theta);
      p[1] = r * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(theta);
    }
    return p;
  }

  forward.invert = function(x, y) {
    var r = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(x * x + y * y);
    if (r > __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]) {
      var theta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(y, x),
          theta0 = k * Object(__WEBPACK_IMPORTED_MODULE_1__math__["w" /* round */])((theta - __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]) / k) + __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */],
          s = theta > theta0 ? -1 : 1,
          A = r * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(theta0 - theta),
          cotα = 1 / Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(s * Object(__WEBPACK_IMPORTED_MODULE_1__math__["b" /* acos */])((A - __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]) / Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * (__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] - 2 * A) + r * r)));
      theta = theta0 + 2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* atan */])((cotα + s * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(cotα * cotα - 3)) / 3);
      x = r * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(theta), y = r * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(theta);
    }
    return __WEBPACK_IMPORTED_MODULE_0_d3_geo__["b" /* geoAzimuthalEquidistantRaw */].invert(x, y);
  };

  return forward;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  var lobes = 5,
      m = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["l" /* geoProjectionMutator */])(berghausRaw),
      p = m(lobes),
      projectionStream = p.stream,
      epsilon = 1e-2,
      cr = -Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(epsilon * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */]),
      sr = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(epsilon * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */]);

  p.lobes = function(_) {
    return arguments.length ? m(lobes = +_) : lobes;
  };

  p.stream = function(stream) {
    var rotate = p.rotate(),
        rotateStream = projectionStream(stream),
        sphereStream = (p.rotate([0, 0]), projectionStream(stream));
    p.rotate(rotate);
    rotateStream.sphere = function() {
      sphereStream.polygonStart(), sphereStream.lineStart();
      for (var i = 0, delta = 360 / lobes, delta0 = 2 * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / lobes, phi = 90 - 180 / lobes, phi0 = __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]; i < lobes; ++i, phi -= delta, phi0 -= delta0) {
        sphereStream.point(Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(sr * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi0), cr) * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */], Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(sr * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi0)) * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */]);
        if (phi < -90) {
          sphereStream.point(-90, -180 - phi - epsilon);
          sphereStream.point(-90, -180 - phi + epsilon);
        } else {
          sphereStream.point(90, phi + epsilon);
          sphereStream.point(90, phi - epsilon);
        }
      }
      sphereStream.lineEnd(), sphereStream.polygonEnd();
    };
    return rotateStream;
  };

  return p
      .scale(87.8076)
      .center([0, 17.1875])
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bonneRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parallel1__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sinusoidal__ = __webpack_require__(66);




function bonneRaw(phi0) {
  if (!phi0) return __WEBPACK_IMPORTED_MODULE_2__sinusoidal__["b" /* sinusoidalRaw */];
  var cotPhi0 = 1 / Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(phi0);

  function forward(lambda, phi) {
    var rho = cotPhi0 + phi0 - phi,
        e = rho ? lambda * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi) / rho : rho;
    return [rho * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(e), cotPhi0 - rho * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(e)];
  }

  forward.invert = function(x, y) {
    var rho = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(x * x + (y = cotPhi0 - y) * y),
        phi = cotPhi0 + phi0 - rho;
    return [rho / Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(x, y), phi];
  };

  return forward;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__parallel1__["a" /* default */])(bonneRaw)
      .scale(123.082)
      .center([0, 26.1441])
      .parallel(45);
});


/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bottomleyRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function bottomleyRaw(sinPsi) {

  function forward(lambda, phi) {
    var rho = __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */] - phi,
        eta = rho ? lambda * sinPsi * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(rho) / rho : rho;
    return [rho * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(eta) / sinPsi, __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */] - rho * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(eta)];
  }

  forward.invert = function(x, y) {
    var x1 = x * sinPsi,
        y1 = __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */] - y,
        rho = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(x1 * x1 + y1 * y1),
        eta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(x1, y1);
    return [(rho ? rho / Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(rho) : 1) * eta / sinPsi, __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */] - rho];
  };

  return forward;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  var sinPsi = 0.5,
      m = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["l" /* geoProjectionMutator */])(bottomleyRaw),
      p = m(sinPsi);

  p.fraction = function(_) {
    return arguments.length ? m(sinPsi = +_) : sinPsi;
  };

  return p
      .scale(158.837);
});


/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bromleyRaw; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mollweide__ = __webpack_require__(32);




var bromleyRaw = Object(__WEBPACK_IMPORTED_MODULE_2__mollweide__["b" /* mollweideBromleyRaw */])(1, 4 / __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */], __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]);

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(bromleyRaw)
      .scale(152.63);
});


/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = chamberlinRaw;
/* harmony export (immutable) */ __webpack_exports__["a"] = chamberlinAfrica;
/* harmony export (immutable) */ __webpack_exports__["c"] = chamberlin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



// Azimuthal distance.
function distance(dPhi, c1, s1, c2, s2, dLambda) {
  var cosdLambda = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(dLambda), r;
  if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(dPhi) > 1 || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(dLambda) > 1) {
    r = Object(__WEBPACK_IMPORTED_MODULE_1__math__["b" /* acos */])(s1 * s2 + c1 * c2 * cosdLambda);
  } else {
    var sindPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(dPhi / 2), sindLambda = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(dLambda / 2);
    r = 2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(sindPhi * sindPhi + c1 * c2 * sindLambda * sindLambda));
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(r) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] ? [r, Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(c2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(dLambda), c1 * s2 - s1 * c2 * cosdLambda)] : [0, 0];
}

// Angle opposite a, and contained between sides of lengths b and c.
function angle(b, c, a) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__math__["b" /* acos */])((b * b + c * c - a * a) / (2 * b * c));
}

// Normalize longitude.
function longitude(lambda) {
  return lambda - 2 * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["n" /* floor */])((lambda + __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]) / (2 * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]));
}

function chamberlinRaw(p0, p1, p2) {
  var points = [
    [p0[0], p0[1], Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(p0[1]), Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(p0[1])],
    [p1[0], p1[1], Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(p1[1]), Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(p1[1])],
    [p2[0], p2[1], Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(p2[1]), Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(p2[1])]
  ];

  for (var a = points[2], b, i = 0; i < 3; ++i, a = b) {
    b = points[i];
    a.v = distance(b[1] - a[1], a[3], a[2], b[3], b[2], b[0] - a[0]);
    a.point = [0, 0];
  }

  var beta0 = angle(points[0].v[0], points[2].v[0], points[1].v[0]),
      beta1 = angle(points[0].v[0], points[1].v[0], points[2].v[0]),
      beta2 = __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] - beta0;

  points[2].point[1] = 0;
  points[0].point[0] = -(points[1].point[0] = points[0].v[0] / 2);

  var mean = [
    points[2].point[0] = points[0].point[0] + points[2].v[0] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(beta0),
    2 * (points[0].point[1] = points[1].point[1] = points[2].v[0] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(beta0))
  ];

  function forward(lambda, phi) {
    var sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi),
        cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi),
        v = new Array(3), i;

    // Compute distance and azimuth from control points.
    for (i = 0; i < 3; ++i) {
      var p = points[i];
      v[i] = distance(phi - p[1], p[3], p[2], cosPhi, sinPhi, lambda - p[0]);
      if (!v[i][0]) return p.point;
      v[i][1] = longitude(v[i][1] - p.v[1]);
    }

    // Arithmetic mean of interception points.
    var point = mean.slice();
    for (i = 0; i < 3; ++i) {
      var j = i == 2 ? 0 : i + 1;
      var a = angle(points[i].v[0], v[i][0], v[j][0]);
      if (v[i][1] < 0) a = -a;

      if (!i) {
        point[0] += v[i][0] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(a);
        point[1] -= v[i][0] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(a);
      } else if (i == 1) {
        a = beta1 - a;
        point[0] -= v[i][0] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(a);
        point[1] -= v[i][0] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(a);
      } else {
        a = beta2 - a;
        point[0] += v[i][0] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(a);
        point[1] += v[i][0] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(a);
      }
    }

    point[0] /= 3, point[1] /= 3;
    return point;
  }

  return forward;
}

function pointRadians(p) {
  return p[0] *= __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */], p[1] *= __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */], p;
}

function chamberlinAfrica() {
  return chamberlin([0, 22], [45, 22], [22.5, -22])
      .scale(380)
      .center([22.5, 2]);
}

function chamberlin(p0, p1, p2) { // TODO order matters!
  var c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["d" /* geoCentroid */])({type: "MultiPoint", coordinates: [p0, p1, p2]}),
      R = [-c[0], -c[1]],
      r = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["m" /* geoRotation */])(R),
      p = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(chamberlinRaw(pointRadians(r(p0)), pointRadians(r(p1)), pointRadians(r(p2)))).rotate(R),
      center = p.center;

  delete p.rotate;

  p.center = function(_) {
    return arguments.length ? center(r(_)) : r.invert(center());
  };

  return p
      .clipAngle(90);
}


/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = craigRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parallel1__ = __webpack_require__(53);



function craigRaw(phi0) {
  var tanPhi0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["F" /* tan */])(phi0);

  function forward(lambda, phi) {
    return [lambda, (lambda ? lambda / Object(__WEBPACK_IMPORTED_MODULE_0__math__["y" /* sin */])(lambda) : 1) * (Object(__WEBPACK_IMPORTED_MODULE_0__math__["y" /* sin */])(phi) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["h" /* cos */])(lambda) - tanPhi0 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["h" /* cos */])(phi))];
  }

  forward.invert = tanPhi0 ? function(x, y) {
    if (x) y *= Object(__WEBPACK_IMPORTED_MODULE_0__math__["y" /* sin */])(x) / x;
    var cosλ = Object(__WEBPACK_IMPORTED_MODULE_0__math__["h" /* cos */])(x);
    return [x, 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* atan2 */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["B" /* sqrt */])(cosλ * cosλ + tanPhi0 * tanPhi0 - y * y) - cosλ, tanPhi0 - y)];
  } : function(x, y) {
    return [x, Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* asin */])(x ? y * Object(__WEBPACK_IMPORTED_MODULE_0__math__["F" /* tan */])(x) / x : y)];
  };

  return forward;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__parallel1__["a" /* default */])(craigRaw)
      .scale(249.828)
      .clipAngle(90);
});


/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = crasterRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



var sqrt3 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(3);

function crasterRaw(lambda, phi) {
  return [sqrt3 * lambda * (2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(2 * phi / 3) - 1) / __WEBPACK_IMPORTED_MODULE_1__math__["E" /* sqrtPi */], sqrt3 * __WEBPACK_IMPORTED_MODULE_1__math__["E" /* sqrtPi */] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi / 3)];
}

crasterRaw.invert = function(x, y) {
  var phi = 3 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(y / (sqrt3 * __WEBPACK_IMPORTED_MODULE_1__math__["E" /* sqrtPi */]));
  return [__WEBPACK_IMPORTED_MODULE_1__math__["E" /* sqrtPi */] * x / (sqrt3 * (2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(2 * phi / 3) - 1)), phi];
};

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(crasterRaw)
      .scale(156.19);
});


/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cylindricalStereographicRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parallel1__ = __webpack_require__(53);



function cylindricalStereographicRaw(phi0) {
  var cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["h" /* cos */])(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, (1 + cosPhi0) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["F" /* tan */])(phi / 2)];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, Object(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* atan */])(y / (1 + cosPhi0)) * 2];
  };

  return forward;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__parallel1__["a" /* default */])(cylindricalStereographicRaw)
      .scale(124.75);
});


/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = eckert1Raw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function eckert1Raw(lambda, phi) {
  var alpha = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(8 / (3 * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]));
  return [
    alpha * lambda * (1 - Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(phi) / __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]),
    alpha * phi
  ];
}

eckert1Raw.invert = function(x, y) {
  var alpha = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(8 / (3 * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */])),
      phi = y / alpha;
  return [
    x / (alpha * (1 - Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(phi) / __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */])),
    phi
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(eckert1Raw)
      .scale(165.664);
});


/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = eckert2Raw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function eckert2Raw(lambda, phi) {
  var alpha = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(4 - 3 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(phi)));
  return [
    2 / Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(6 * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]) * lambda * alpha,
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(phi) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(2 * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / 3) * (2 - alpha)
  ];
}

eckert2Raw.invert = function(x, y) {
  var alpha = 2 - Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(y) / Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(2 * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / 3);
  return [
    x * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(6 * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]) / (2 * alpha),
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(y) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])((4 - alpha * alpha) / 3)
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(eckert2Raw)
      .scale(165.664);
});


/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = eckert3Raw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function eckert3Raw(lambda, phi) {
  var k = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * (4 + __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]));
  return [
    2 / k * lambda * (1 + Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(1 - 4 * phi * phi / (__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]))),
    4 / k * phi
  ];
}

eckert3Raw.invert = function(x, y) {
  var k = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * (4 + __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */])) / 2;
  return [
    x * k / (1 + Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(1 - y * y * (4 + __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]) / (4 * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]))),
    y * k / 2
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(eckert3Raw)
      .scale(180.739);
});


/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = eckert4Raw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function eckert4Raw(lambda, phi) {
  var k = (2 + __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi);
  phi /= 2;
  for (var i = 0, delta = Infinity; i < 10 && Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]; i++) {
    var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi);
    phi -= delta = (phi + Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi) * (cosPhi + 2) - k) / (2 * cosPhi * (1 + cosPhi));
  }
  return [
    2 / Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * (4 + __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */])) * lambda * (1 + Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi)),
    2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / (4 + __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */])) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi)
  ];
}

eckert4Raw.invert = function(x, y) {
  var A = y * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])((4 + __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]) / __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]) / 2,
      k = Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(A),
      c = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(k);
  return [
    x / (2 / Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * (4 + __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */])) * (1 + c)),
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])((k + A * (c + 2)) / (2 + __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]))
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(eckert4Raw)
      .scale(180.739);
});


/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = eckert5Raw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function eckert5Raw(lambda, phi) {
  return [
    lambda * (1 + Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi)) / Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(2 + __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]),
    2 * phi / Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(2 + __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */])
  ];
}

eckert5Raw.invert = function(x, y) {
  var k = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(2 + __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]),
      phi = y * k / 2;
  return [
    k * x / (1 + Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi)),
    phi
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(eckert5Raw)
      .scale(173.044);
});


/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = eckert6Raw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function eckert6Raw(lambda, phi) {
  var k = (1 + __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi);
  for (var i = 0, delta = Infinity; i < 10 && Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]; i++) {
    phi -= delta = (phi + Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi) - k) / (1 + Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi));
  }
  k = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(2 + __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]);
  return [
    lambda * (1 + Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi)) / k,
    2 * phi / k
  ];
}

eckert6Raw.invert = function(x, y) {
  var j = 1 + __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */],
      k = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(j / 2);
  return [
    x * 2 * k / (1 + Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(y *= k)),
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])((y + Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(y)) / j)
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(eckert6Raw)
      .scale(173.044);
});


/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = eisenlohrRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__august__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(1);




var eisenlohrK = 3 + 2 * __WEBPACK_IMPORTED_MODULE_2__math__["D" /* sqrt2 */];

function eisenlohrRaw(lambda, phi) {
  var s0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["y" /* sin */])(lambda /= 2),
      c0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(lambda),
      k = Object(__WEBPACK_IMPORTED_MODULE_2__math__["B" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(phi)),
      c1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(phi /= 2),
      t = Object(__WEBPACK_IMPORTED_MODULE_2__math__["y" /* sin */])(phi) / (c1 + __WEBPACK_IMPORTED_MODULE_2__math__["D" /* sqrt2 */] * c0 * k),
      c = Object(__WEBPACK_IMPORTED_MODULE_2__math__["B" /* sqrt */])(2 / (1 + t * t)),
      v = Object(__WEBPACK_IMPORTED_MODULE_2__math__["B" /* sqrt */])((__WEBPACK_IMPORTED_MODULE_2__math__["D" /* sqrt2 */] * c1 + (c0 + s0) * k) / (__WEBPACK_IMPORTED_MODULE_2__math__["D" /* sqrt2 */] * c1 + (c0 - s0) * k));
  return [
    eisenlohrK * (c * (v - 1 / v) - 2 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["p" /* log */])(v)),
    eisenlohrK * (c * t * (v + 1 / v) - 2 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["f" /* atan */])(t))
  ];
}

eisenlohrRaw.invert = function(x, y) {
  if (!(p = __WEBPACK_IMPORTED_MODULE_1__august__["a" /* augustRaw */].invert(x / 1.2, y * 1.065))) return null;
  var lambda = p[0], phi = p[1], i = 20, p;
  x /= eisenlohrK, y /= eisenlohrK;
  do {
    var _0 = lambda / 2,
        _1 = phi / 2,
        s0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["y" /* sin */])(_0),
        c0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(_0),
        s1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["y" /* sin */])(_1),
        c1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(_1),
        cos1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(phi),
        k = Object(__WEBPACK_IMPORTED_MODULE_2__math__["B" /* sqrt */])(cos1),
        t = s1 / (c1 + __WEBPACK_IMPORTED_MODULE_2__math__["D" /* sqrt2 */] * c0 * k),
        t2 = t * t,
        c = Object(__WEBPACK_IMPORTED_MODULE_2__math__["B" /* sqrt */])(2 / (1 + t2)),
        v0 = (__WEBPACK_IMPORTED_MODULE_2__math__["D" /* sqrt2 */] * c1 + (c0 + s0) * k),
        v1 = (__WEBPACK_IMPORTED_MODULE_2__math__["D" /* sqrt2 */] * c1 + (c0 - s0) * k),
        v2 = v0 / v1,
        v = Object(__WEBPACK_IMPORTED_MODULE_2__math__["B" /* sqrt */])(v2),
        vm1v = v - 1 / v,
        vp1v = v + 1 / v,
        fx = c * vm1v - 2 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["p" /* log */])(v) - x,
        fy = c * t * vp1v - 2 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["f" /* atan */])(t) - y,
        deltatDeltaLambda = s1 && __WEBPACK_IMPORTED_MODULE_2__math__["C" /* sqrt1_2 */] * k * s0 * t2 / s1,
        deltatDeltaPhi = (__WEBPACK_IMPORTED_MODULE_2__math__["D" /* sqrt2 */] * c0 * c1 + k) / (2 * (c1 + __WEBPACK_IMPORTED_MODULE_2__math__["D" /* sqrt2 */] * c0 * k) * (c1 + __WEBPACK_IMPORTED_MODULE_2__math__["D" /* sqrt2 */] * c0 * k) * k),
        deltacDeltat = -0.5 * t * c * c * c,
        deltacDeltaLambda = deltacDeltat * deltatDeltaLambda,
        deltacDeltaPhi = deltacDeltat * deltatDeltaPhi,
        A = (A = 2 * c1 + __WEBPACK_IMPORTED_MODULE_2__math__["D" /* sqrt2 */] * k * (c0 - s0)) * A * v,
        deltavDeltaLambda = (__WEBPACK_IMPORTED_MODULE_2__math__["D" /* sqrt2 */] * c0 * c1 * k + cos1) / A,
        deltavDeltaPhi = -(__WEBPACK_IMPORTED_MODULE_2__math__["D" /* sqrt2 */] * s0 * s1) / (k * A),
        deltaxDeltaLambda = vm1v * deltacDeltaLambda - 2 * deltavDeltaLambda / v + c * (deltavDeltaLambda + deltavDeltaLambda / v2),
        deltaxDeltaPhi = vm1v * deltacDeltaPhi - 2 * deltavDeltaPhi / v + c * (deltavDeltaPhi + deltavDeltaPhi / v2),
        deltayDeltaLambda = t * vp1v * deltacDeltaLambda - 2 * deltatDeltaLambda / (1 + t2) + c * vp1v * deltatDeltaLambda + c * t * (deltavDeltaLambda - deltavDeltaLambda / v2),
        deltayDeltaPhi = t * vp1v * deltacDeltaPhi - 2 * deltatDeltaPhi / (1 + t2) + c * vp1v * deltatDeltaPhi + c * t * (deltavDeltaPhi - deltavDeltaPhi / v2),
        denominator = deltaxDeltaPhi * deltayDeltaLambda - deltayDeltaPhi * deltaxDeltaLambda;
    if (!denominator) break;
    var deltaLambda = (fy * deltaxDeltaPhi - fx * deltayDeltaPhi) / denominator,
        deltaPhi = (fx * deltayDeltaLambda - fy * deltaxDeltaLambda) / denominator;
    lambda -= deltaLambda;
    phi = Object(__WEBPACK_IMPORTED_MODULE_2__math__["q" /* max */])(-__WEBPACK_IMPORTED_MODULE_2__math__["o" /* halfPi */], Object(__WEBPACK_IMPORTED_MODULE_2__math__["r" /* min */])(__WEBPACK_IMPORTED_MODULE_2__math__["o" /* halfPi */], phi - deltaPhi));
  } while ((Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(deltaLambda) > __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */] || Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(deltaPhi) > __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */]) && --i > 0);
  return Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(phi) - __WEBPACK_IMPORTED_MODULE_2__math__["o" /* halfPi */]) < __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */] ? [0, phi] : i && [lambda, phi];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(eisenlohrRaw)
      .scale(62.5271);
});


/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = faheyRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



var faheyK = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(35 * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */]);

function faheyRaw(lambda, phi) {
  var t = Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(phi / 2);
  return [lambda * faheyK * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(1 - t * t), (1 + faheyK) * t];
}

faheyRaw.invert = function(x, y) {
  var t = y / (1 + faheyK);
  return [x && x / (faheyK * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(1 - t * t)), 2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* atan */])(t)];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(faheyRaw)
      .scale(137.152);
});


/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = foucautRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function foucautRaw(lambda, phi) {
  var k = phi / 2, cosk = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(k);
  return [ 2 * lambda / __WEBPACK_IMPORTED_MODULE_1__math__["E" /* sqrtPi */] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi) * cosk * cosk, __WEBPACK_IMPORTED_MODULE_1__math__["E" /* sqrtPi */] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(k)];
}

foucautRaw.invert = function(x, y) {
  var k = Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* atan */])(y / __WEBPACK_IMPORTED_MODULE_1__math__["E" /* sqrtPi */]), cosk = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(k), phi = 2 * k;
  return [x * __WEBPACK_IMPORTED_MODULE_1__math__["E" /* sqrtPi */] / 2 / (Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi) * cosk * cosk), phi];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(foucautRaw)
      .scale(135.264);
});


/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function gilbertForward(point) {
  return [point[0] / 2, Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(point[1] / 2 * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */])) * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */]];
}

function gilbertInvert(point) {
  return [point[0] * 2, 2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(point[1] * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */])) * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */]];
}

/* harmony default export */ __webpack_exports__["a"] = (function(projectionType) {
  if (projectionType == null) projectionType = __WEBPACK_IMPORTED_MODULE_0_d3_geo__["j" /* geoOrthographic */];
  var projection = projectionType(),
      equirectangular = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["f" /* geoEquirectangular */])().scale(__WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */]).precision(0).clipAngle(null).translate([0, 0]); // antimeridian cutting

  function gilbert(point) {
    return projection(gilbertForward(point));
  }

  if (projection.invert) gilbert.invert = function(point) {
    return gilbertInvert(projection.invert(point));
  };

  gilbert.stream = function(stream) {
    var s1 = projection.stream(stream), s0 = equirectangular.stream({
      point: function(lambda, phi) { s1.point(lambda / 2, Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(-phi / 2 * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */])) * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */]); },
      lineStart: function() { s1.lineStart(); },
      lineEnd: function() { s1.lineEnd(); },
      polygonStart: function() { s1.polygonStart(); },
      polygonEnd: function() { s1.polygonEnd(); }
    });
    s0.sphere = s1.sphere;
    return s0;
  };

  function property(name) {
    gilbert[name] = function(_) {
      return arguments.length ? (projection[name](_), gilbert) : projection[name]();
    };
  }

  gilbert.rotate = function(_) {
    return arguments.length ? (equirectangular.rotate(_), gilbert) : equirectangular.rotate();
  };

  gilbert.center = function(_) {
    return arguments.length ? (projection.center(gilbertForward(_)), gilbert) : gilbertInvert(projection.center());
  };

  property("clipAngle");
  property("clipExtent");
  property("scale");
  property("translate");
  property("precision");

  return gilbert
      .scale(249.5);
});


/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = gingeryRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function gingeryRaw(rho, n) {
  var k = 2 * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / n,
      rho2 = rho * rho;

  function forward(lambda, phi) {
    var p = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["b" /* geoAzimuthalEquidistantRaw */])(lambda, phi),
        x = p[0],
        y = p[1],
        r2 = x * x + y * y;

    if (r2 > rho2) {
      var r = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(r2),
          theta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(y, x),
          theta0 = k * Object(__WEBPACK_IMPORTED_MODULE_1__math__["w" /* round */])(theta / k),
          alpha = theta - theta0,
          rhoCosAlpha = rho * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(alpha),
          k_ = (rho * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(alpha) - alpha * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(rhoCosAlpha)) / (__WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */] - rhoCosAlpha),
          s_ = gingeryLength(alpha, k_),
          e = (__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] - rho) / gingeryIntegrate(s_, rhoCosAlpha, __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]);

      x = r;
      var i = 50, delta;
      do {
        x -= delta = (rho + gingeryIntegrate(s_, rhoCosAlpha, x) * e - r) / (s_(x) * e);
      } while (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] && --i > 0);

      y = alpha * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(x);
      if (x < __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]) y -= k_ * (x - __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]);

      var s = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(theta0),
          c = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(theta0);
      p[0] = x * c - y * s;
      p[1] = x * s + y * c;
    }
    return p;
  }

  forward.invert = function(x, y) {
    var r2 = x * x + y * y;
    if (r2 > rho2) {
      var r = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(r2),
          theta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(y, x),
          theta0 = k * Object(__WEBPACK_IMPORTED_MODULE_1__math__["w" /* round */])(theta / k),
          dTheta = theta - theta0;

      x = r * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(dTheta);
      y = r * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(dTheta);

      var x_halfPi = x - __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */],
          sinx = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(x),
          alpha = y / sinx,
          delta = x < __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */] ? Infinity : 0,
          i = 10;

      while (true) {
        var rhosinAlpha = rho * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(alpha),
            rhoCosAlpha = rho * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(alpha),
            sinRhoCosAlpha = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(rhoCosAlpha),
            halfPi_RhoCosAlpha = __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */] - rhoCosAlpha,
            k_ = (rhosinAlpha - alpha * sinRhoCosAlpha) / halfPi_RhoCosAlpha,
            s_ = gingeryLength(alpha, k_);

        if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) < __WEBPACK_IMPORTED_MODULE_1__math__["l" /* epsilon2 */] || !--i) break;

        alpha -= delta = (alpha * sinx - k_ * x_halfPi - y) / (
          sinx - x_halfPi * 2 * (
            halfPi_RhoCosAlpha * (rhoCosAlpha + alpha * rhosinAlpha * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(rhoCosAlpha) - sinRhoCosAlpha) -
            rhosinAlpha * (rhosinAlpha - alpha * sinRhoCosAlpha)
          ) / (halfPi_RhoCosAlpha * halfPi_RhoCosAlpha));
      }
      r = rho + gingeryIntegrate(s_, rhoCosAlpha, x) * (__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] - rho) / gingeryIntegrate(s_, rhoCosAlpha, __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]);
      theta = theta0 + alpha;
      x = r * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(theta);
      y = r * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(theta);
    }
    return __WEBPACK_IMPORTED_MODULE_0_d3_geo__["b" /* geoAzimuthalEquidistantRaw */].invert(x, y);
  };

  return forward;
}

function gingeryLength(alpha, k) {
  return function(x) {
    var y_ = alpha * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(x);
    if (x < __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]) y_ -= k;
    return Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(1 + y_ * y_);
  };
}

// Numerical integration: trapezoidal rule.
function gingeryIntegrate(f, a, b) {
  var n = 50,
      h = (b - a) / n,
      s = f(a) + f(b);
  for (var i = 1, x = a; i < n; ++i) s += 2 * f(x += h);
  return s * 0.5 * h;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var n = 6,
      rho = 30 * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */],
      cRho = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(rho),
      sRho = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(rho),
      m = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["l" /* geoProjectionMutator */])(gingeryRaw),
      p = m(rho, n),
      stream_ = p.stream,
      epsilon = 1e-2,
      cr = -Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(epsilon * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */]),
      sr = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(epsilon * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */]);

  p.radius = function(_) {
    if (!arguments.length) return rho * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */];
    cRho = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(rho = _ * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */]);
    sRho = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(rho);
    return m(rho, n);
  };

  p.lobes = function(_) {
    if (!arguments.length) return n;
    return m(rho, n = +_);
  };

  p.stream = function(stream) {
    var rotate = p.rotate(),
        rotateStream = stream_(stream),
        sphereStream = (p.rotate([0, 0]), stream_(stream));
    p.rotate(rotate);
    rotateStream.sphere = function() {
      sphereStream.polygonStart(), sphereStream.lineStart();
      for (var i = 0, delta = 2 * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / n, phi = 0; i < n; ++i, phi -= delta) {
        sphereStream.point(Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(sr * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi), cr) * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */], Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(sr * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi)) * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */]);
        sphereStream.point(Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(sRho * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi - delta / 2), cRho) * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */], Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(sRho * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi - delta / 2)) * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */]);
      }
      sphereStream.lineEnd(), sphereStream.polygonEnd();
    };
    return rotateStream;
  };

  return p
      .rotate([90, -40])
      .scale(91.7095)
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ginzburg4Raw; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ginzburgPolyconic__ = __webpack_require__(103);



var ginzburg4Raw = Object(__WEBPACK_IMPORTED_MODULE_1__ginzburgPolyconic__["a" /* default */])(2.8284, -1.6988, 0.75432, -0.18071, 1.76003, -0.38914, 0.042555);

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(ginzburg4Raw)
      .scale(149.995);
});


/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ginzburg5Raw; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ginzburgPolyconic__ = __webpack_require__(103);



var ginzburg5Raw = Object(__WEBPACK_IMPORTED_MODULE_1__ginzburgPolyconic__["a" /* default */])(2.583819, -0.835827, 0.170354, -0.038094, 1.543313, -0.411435,0.082742);

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(ginzburg5Raw)
      .scale(153.93);
});


/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ginzburg6Raw; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ginzburgPolyconic__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(1);




var ginzburg6Raw = Object(__WEBPACK_IMPORTED_MODULE_1__ginzburgPolyconic__["a" /* default */])(5 / 6 * __WEBPACK_IMPORTED_MODULE_2__math__["s" /* pi */], -0.62636, -0.0344, 0, 1.3493, -0.05524, 0, 0.045);

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(ginzburg6Raw)
      .scale(130.945);
});


/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = ginzburg8Raw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function ginzburg8Raw(lambda, phi) {
  var lambda2 = lambda * lambda,
      phi2 = phi * phi;
  return [
    lambda * (1 - 0.162388 * phi2) * (0.87 - 0.000952426 * lambda2 * lambda2),
    phi * (1 + phi2 / 12)
  ];
}

ginzburg8Raw.invert = function(x, y) {
  var lambda = x,
      phi = y,
      i = 50, delta;
  do {
    var phi2 = phi * phi;
    phi -= delta = (phi * (1 + phi2 / 12) - y) / (1 + phi2 / 4);
  } while (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] && --i > 0);
  i = 50;
  x /= 1 -0.162388 * phi2;
  do {
    var lambda4 = (lambda4 = lambda * lambda) * lambda4;
    lambda -= delta = (lambda * (0.87 - 0.000952426 * lambda4) - x) / (0.87 - 0.00476213 * lambda4);
  } while (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] && --i > 0);
  return [lambda, phi];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(ginzburg8Raw)
      .scale(131.747);
});


/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ginzburg9Raw; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ginzburgPolyconic__ = __webpack_require__(103);



var ginzburg9Raw = Object(__WEBPACK_IMPORTED_MODULE_1__ginzburgPolyconic__["a" /* default */])(2.6516, -0.76534, 0.19123, -0.047094, 1.36289, -0.13965,0.031762);

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(ginzburg9Raw)
      .scale(131.087);
});


/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = ellipticJi;
/* unused harmony export ellipticJ */
/* harmony export (immutable) */ __webpack_exports__["b"] = ellipticFi;
/* harmony export (immutable) */ __webpack_exports__["a"] = ellipticF;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(1);


// Returns [sn, cn, dn](u + iv|m).
function ellipticJi(u, v, m) {
  var a, b, c;
  if (!u) {
    b = ellipticJ(v, 1 - m);
    return [
      [0, b[0] / b[1]],
      [1 / b[1], 0],
      [b[2] / b[1], 0]
    ];
  }
  a = ellipticJ(u, m);
  if (!v) return [[a[0], 0], [a[1], 0], [a[2], 0]];
  b = ellipticJ(v, 1 - m);
  c = b[1] * b[1] + m * a[0] * a[0] * b[0] * b[0];
  return [
    [a[0] * b[2] / c, a[1] * a[2] * b[0] * b[1] / c],
    [a[1] * b[1] / c, -a[0] * a[2] * b[0] * b[2] / c],
    [a[2] * b[1] * b[2] / c, -m * a[0] * a[1] * b[0] / c]
  ];
}

// Returns [sn, cn, dn, ph](u|m).
function ellipticJ(u, m) {
  var ai, b, phi, t, twon;
  if (m < __WEBPACK_IMPORTED_MODULE_0__math__["k" /* epsilon */]) {
    t = Object(__WEBPACK_IMPORTED_MODULE_0__math__["y" /* sin */])(u);
    b = Object(__WEBPACK_IMPORTED_MODULE_0__math__["h" /* cos */])(u);
    ai = m * (u - t * b) / 4;
    return [
      t - ai * b,
      b + ai * t,
      1 - m * t * t / 2,
      u - ai
    ];
  }
  if (m >= 1 - __WEBPACK_IMPORTED_MODULE_0__math__["k" /* epsilon */]) {
    ai = (1 - m) / 4;
    b = Object(__WEBPACK_IMPORTED_MODULE_0__math__["i" /* cosh */])(u);
    t = Object(__WEBPACK_IMPORTED_MODULE_0__math__["G" /* tanh */])(u);
    phi = 1 / b;
    twon = b * Object(__WEBPACK_IMPORTED_MODULE_0__math__["A" /* sinh */])(u);
    return [
      t + ai * (twon - u) / (b * b),
      phi - ai * t * phi * (twon - u),
      phi + ai * t * phi * (twon + u),
      2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* exp */])(u)) - __WEBPACK_IMPORTED_MODULE_0__math__["o" /* halfPi */] + ai * (twon - u) / b
    ];
  }

  var a = [1, 0, 0, 0, 0, 0, 0, 0, 0],
      c = [Object(__WEBPACK_IMPORTED_MODULE_0__math__["B" /* sqrt */])(m), 0, 0, 0, 0, 0, 0, 0, 0],
      i = 0;
  b = Object(__WEBPACK_IMPORTED_MODULE_0__math__["B" /* sqrt */])(1 - m);
  twon = 1;

  while (Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(c[i] / a[i]) > __WEBPACK_IMPORTED_MODULE_0__math__["k" /* epsilon */] && i < 8) {
    ai = a[i++];
    c[i] = (ai - b) / 2;
    a[i] = (ai + b) / 2;
    b = Object(__WEBPACK_IMPORTED_MODULE_0__math__["B" /* sqrt */])(ai * b);
    twon *= 2;
  }

  phi = twon * a[i] * u;
  do {
    t = c[i] * Object(__WEBPACK_IMPORTED_MODULE_0__math__["y" /* sin */])(b = phi) / a[i];
    phi = (Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* asin */])(t) + phi) / 2;
  } while (--i);

  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["y" /* sin */])(phi), t = Object(__WEBPACK_IMPORTED_MODULE_0__math__["h" /* cos */])(phi), t / Object(__WEBPACK_IMPORTED_MODULE_0__math__["h" /* cos */])(phi - b), phi];
}

// Calculate F(phi+iPsi|m).
// See Abramowitz and Stegun, 17.4.11.
function ellipticFi(phi, psi, m) {
  var r = Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(phi),
      i = Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(psi),
      sinhPsi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["A" /* sinh */])(i);
  if (r) {
    var cscPhi = 1 / Object(__WEBPACK_IMPORTED_MODULE_0__math__["y" /* sin */])(r),
        cotPhi2 = 1 / (Object(__WEBPACK_IMPORTED_MODULE_0__math__["F" /* tan */])(r) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["F" /* tan */])(r)),
        b = -(cotPhi2 + m * (sinhPsi * sinhPsi * cscPhi * cscPhi) - 1 + m),
        c = (m - 1) * cotPhi2,
        cotLambda2 = (-b + Object(__WEBPACK_IMPORTED_MODULE_0__math__["B" /* sqrt */])(b * b - 4 * c)) / 2;
    return [
      ellipticF(Object(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* atan */])(1 / Object(__WEBPACK_IMPORTED_MODULE_0__math__["B" /* sqrt */])(cotLambda2)), m) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["x" /* sign */])(phi),
      ellipticF(Object(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["B" /* sqrt */])((cotLambda2 / cotPhi2 - 1) / m)), 1 - m) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["x" /* sign */])(psi)
    ];
  }
  return [
    0,
    ellipticF(Object(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* atan */])(sinhPsi), 1 - m) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["x" /* sign */])(psi)
  ];
}

// Calculate F(phi|m) where m = k² = sin²α.
// See Abramowitz and Stegun, 17.6.7.
function ellipticF(phi, m) {
  if (!m) return phi;
  if (m === 1) return Object(__WEBPACK_IMPORTED_MODULE_0__math__["p" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["F" /* tan */])(phi / 2 + __WEBPACK_IMPORTED_MODULE_0__math__["u" /* quarterPi */]));
  var a = 1,
      b = Object(__WEBPACK_IMPORTED_MODULE_0__math__["B" /* sqrt */])(1 - m),
      c = Object(__WEBPACK_IMPORTED_MODULE_0__math__["B" /* sqrt */])(m);
  for (var i = 0; Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(c) > __WEBPACK_IMPORTED_MODULE_0__math__["k" /* epsilon */]; i++) {
    if (phi % __WEBPACK_IMPORTED_MODULE_0__math__["s" /* pi */]) {
      var dPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* atan */])(b * Object(__WEBPACK_IMPORTED_MODULE_0__math__["F" /* tan */])(phi) / a);
      if (dPhi < 0) dPhi += __WEBPACK_IMPORTED_MODULE_0__math__["s" /* pi */];
      phi += dPhi + ~~(phi / __WEBPACK_IMPORTED_MODULE_0__math__["s" /* pi */]) * __WEBPACK_IMPORTED_MODULE_0__math__["s" /* pi */];
    } else phi += phi;
    c = (a + b) / 2;
    b = Object(__WEBPACK_IMPORTED_MODULE_0__math__["B" /* sqrt */])(a * b);
    c = ((a = c) - b) / 2;
  }
  return phi / (Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* pow */])(2, i) * a);
}


/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = hammerRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function hammerRaw(A, B) {
  if (arguments.length < 2) B = A;
  if (B === 1) return __WEBPACK_IMPORTED_MODULE_0_d3_geo__["a" /* geoAzimuthalEqualAreaRaw */];
  if (B === Infinity) return hammerQuarticAuthalicRaw;

  function forward(lambda, phi) {
    var coordinates = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["a" /* geoAzimuthalEqualAreaRaw */])(lambda / B, phi);
    coordinates[0] *= A;
    return coordinates;
  }

  forward.invert = function(x, y) {
    var coordinates = __WEBPACK_IMPORTED_MODULE_0_d3_geo__["a" /* geoAzimuthalEqualAreaRaw */].invert(x / A, y);
    coordinates[0] *= B;
    return coordinates;
  };

  return forward;
}

function hammerQuarticAuthalicRaw(lambda, phi) {
  return [
    lambda * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi) / Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi /= 2),
    2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi)
  ];
}

hammerQuarticAuthalicRaw.invert = function(x, y) {
  var phi = 2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(y / 2);
  return [
    x * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi / 2) / Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi),
    phi
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var B = 2,
      m = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["l" /* geoProjectionMutator */])(hammerRaw),
      p = m(B);

  p.coefficient = function(_) {
    if (!arguments.length) return B;
    return m(B = +_);
  };

  return p
    .scale(169.529);
});


/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = hammerRetroazimuthalRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function hammerRetroazimuthalRaw(phi0) {
  var sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi0),
      cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi0),
      rotate = hammerRetroazimuthalRotation(phi0);

  rotate.invert = hammerRetroazimuthalRotation(-phi0);

  function forward(lambda, phi) {
    var p = rotate(lambda, phi);
    lambda = p[0], phi = p[1];
    var sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi),
        cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi),
        cosLambda = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(lambda),
        z = Object(__WEBPACK_IMPORTED_MODULE_1__math__["b" /* acos */])(sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosLambda),
        sinz = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(z),
        K = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(sinz) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] ? z / sinz : 1;
    return [
      K * cosPhi0 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(lambda),
      (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda) > __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */] ? K : -K) // rotate for back hemisphere
        * (sinPhi0 * cosPhi - cosPhi0 * sinPhi * cosLambda)
    ];
  }

  forward.invert = function(x, y) {
    var rho = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(x * x + y * y),
        sinz = -Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(rho),
        cosz = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(rho),
        a = rho * cosz,
        b = -y * sinz,
        c = rho * sinPhi0,
        d = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(a * a + b * b - c * c),
        phi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(a * c + b * d, b * c - a * d),
        lambda = (rho > __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */] ? -1 : 1) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(x * sinz, rho * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi) * cosz + y * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi) * sinz);
    return rotate.invert(lambda, phi);
  };

  return forward;
}

// Latitudinal rotation by phi0.
// Temporary hack until D3 supports arbitrary small-circle clipping origins.
function hammerRetroazimuthalRotation(phi0) {
  var sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi0),
      cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi0);

  return function(lambda, phi) {
    var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi),
        x = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(lambda) * cosPhi,
        y = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(lambda) * cosPhi,
        z = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi);
    return [
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(y, x * cosPhi0 - z * sinPhi0),
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(z * cosPhi0 + x * sinPhi0)
    ];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var phi0 = 0,
      m = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["l" /* geoProjectionMutator */])(hammerRetroazimuthalRaw),
      p = m(phi0),
      rotate_ = p.rotate,
      stream_ = p.stream,
      circle = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["e" /* geoCircle */])();

  p.parallel = function(_) {
    if (!arguments.length) return phi0 * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */];
    var r = p.rotate();
    return m(phi0 = _ * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */]).rotate(r);
  };

  // Temporary hack; see hammerRetroazimuthalRotation.
  p.rotate = function(_) {
    if (!arguments.length) return (_ = rotate_.call(p), _[1] += phi0 * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */], _);
    rotate_.call(p, [_[0], _[1] - phi0 * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */]]);
    circle.center([-_[0], -_[1]]);
    return p;
  };

  p.stream = function(stream) {
    stream = stream_(stream);
    stream.sphere = function() {
      stream.polygonStart();
      var epsilon = 1e-2,
          ring = circle.radius(90 - epsilon)().coordinates[0],
          n = ring.length - 1,
          i = -1,
          p;
      stream.lineStart();
      while (++i < n) stream.point((p = ring[i])[0], p[1]);
      stream.lineEnd();
      ring = circle.radius(90 + epsilon)().coordinates[0];
      n = ring.length - 1;
      stream.lineStart();
      while (--i >= 0) stream.point((p = ring[i])[0], p[1]);
      stream.lineEnd();
      stream.polygonEnd();
    };
    return stream;
  };

  return p
      .scale(79.4187)
      .parallel(45)
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = healpixRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__collignon__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cylindricalEqualArea__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__math__ = __webpack_require__(1);






var healpixParallel = 41 + 48 / 36 + 37 / 3600, // for K=3; TODO automate
    healpixLambert = Object(__WEBPACK_IMPORTED_MODULE_3__cylindricalEqualArea__["a" /* cylindricalEqualAreaRaw */])(0);

function healpixRaw(H) {
  var phi0 = healpixParallel * __WEBPACK_IMPORTED_MODULE_4__math__["v" /* radians */],
      dx = Object(__WEBPACK_IMPORTED_MODULE_2__collignon__["a" /* collignonRaw */])(__WEBPACK_IMPORTED_MODULE_4__math__["s" /* pi */], phi0)[0] - Object(__WEBPACK_IMPORTED_MODULE_2__collignon__["a" /* collignonRaw */])(-__WEBPACK_IMPORTED_MODULE_4__math__["s" /* pi */], phi0)[0],
      y0 = healpixLambert(0, phi0)[1],
      y1 = Object(__WEBPACK_IMPORTED_MODULE_2__collignon__["a" /* collignonRaw */])(0, phi0)[1],
      dy1 = __WEBPACK_IMPORTED_MODULE_4__math__["E" /* sqrtPi */] - y1,
      k = __WEBPACK_IMPORTED_MODULE_4__math__["H" /* tau */] / H,
      w = 4 / __WEBPACK_IMPORTED_MODULE_4__math__["H" /* tau */],
      h = y0 + (dy1 * dy1 * 4) / __WEBPACK_IMPORTED_MODULE_4__math__["H" /* tau */];

  function forward(lambda, phi) {
    var point,
        phi2 = Object(__WEBPACK_IMPORTED_MODULE_4__math__["a" /* abs */])(phi);
    if (phi2 > phi0) {
      var i = Object(__WEBPACK_IMPORTED_MODULE_4__math__["r" /* min */])(H - 1, Object(__WEBPACK_IMPORTED_MODULE_4__math__["q" /* max */])(0, Object(__WEBPACK_IMPORTED_MODULE_4__math__["n" /* floor */])((lambda + __WEBPACK_IMPORTED_MODULE_4__math__["s" /* pi */]) / k)));
      lambda += __WEBPACK_IMPORTED_MODULE_4__math__["s" /* pi */] * (H - 1) / H - i * k;
      point = Object(__WEBPACK_IMPORTED_MODULE_2__collignon__["a" /* collignonRaw */])(lambda, phi2);
      point[0] = point[0] * __WEBPACK_IMPORTED_MODULE_4__math__["H" /* tau */] / dx - __WEBPACK_IMPORTED_MODULE_4__math__["H" /* tau */] * (H - 1) / (2 * H) + i * __WEBPACK_IMPORTED_MODULE_4__math__["H" /* tau */] / H;
      point[1] = y0 + (point[1] - y1) * 4 * dy1 / __WEBPACK_IMPORTED_MODULE_4__math__["H" /* tau */];
      if (phi < 0) point[1] = -point[1];
    } else {
      point = healpixLambert(lambda, phi);
    }
    point[0] *= w, point[1] /= h;
    return point;
  }

  forward.invert = function(x, y) {
    x /= w, y *= h;
    var y2 = Object(__WEBPACK_IMPORTED_MODULE_4__math__["a" /* abs */])(y);
    if (y2 > y0) {
      var i = Object(__WEBPACK_IMPORTED_MODULE_4__math__["r" /* min */])(H - 1, Object(__WEBPACK_IMPORTED_MODULE_4__math__["q" /* max */])(0, Object(__WEBPACK_IMPORTED_MODULE_4__math__["n" /* floor */])((x + __WEBPACK_IMPORTED_MODULE_4__math__["s" /* pi */]) / k)));
      x = (x + __WEBPACK_IMPORTED_MODULE_4__math__["s" /* pi */] * (H - 1) / H - i * k) * dx / __WEBPACK_IMPORTED_MODULE_4__math__["H" /* tau */];
      var point = __WEBPACK_IMPORTED_MODULE_2__collignon__["a" /* collignonRaw */].invert(x, 0.25 * (y2 - y0) * __WEBPACK_IMPORTED_MODULE_4__math__["H" /* tau */] / dy1 + y1);
      point[0] -= __WEBPACK_IMPORTED_MODULE_4__math__["s" /* pi */] * (H - 1) / H - i * k;
      if (y < 0) point[1] = -point[1];
      return point;
    }
    return healpixLambert.invert(x, y);
  };

  return forward;
}

function sphere(step) {
  return {
    type: "Polygon",
    coordinates: [
      Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(-180, 180 + step / 2, step).map(function(x, i) { return [x, i & 1 ? 90 - 1e-6 : healpixParallel]; })
      .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(180, -180 - step / 2, -step).map(function(x, i) { return [x, i & 1 ? -90 + 1e-6 : -healpixParallel]; }))
    ]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var H = 4,
      m = Object(__WEBPACK_IMPORTED_MODULE_1_d3_geo__["l" /* geoProjectionMutator */])(healpixRaw),
      p = m(H),
      stream_ = p.stream;

  p.lobes = function(_) {
    return arguments.length ? m(H = +_) : H;
  };

  p.stream = function(stream) {
    var rotate = p.rotate(),
        rotateStream = stream_(stream),
        sphereStream = (p.rotate([0, 0]), stream_(stream));
    p.rotate(rotate);
    rotateStream.sphere = function() { Object(__WEBPACK_IMPORTED_MODULE_1_d3_geo__["n" /* geoStream */])(sphere(180 / H), sphereStream); };
    return rotateStream;
  };

  return p
      .scale(239.75);
});


/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = hillRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function hillRaw(K) {
  var L = 1 + K,
      sinBt = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(1 / L),
      Bt = Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(sinBt),
      A = 2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / (B = __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] + 4 * Bt * L)),
      B,
      rho0 = 0.5 * A * (L + Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(K * (2 + K))),
      K2 = K * K,
      L2 = L * L;

  function forward(lambda, phi) {
    var t = 1 - Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi),
        rho,
        omega;
    if (t && t < 2) {
      var theta = __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */] - phi, i = 25, delta;
      do {
        var sinTheta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(theta),
            cosTheta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(theta),
            Bt_Bt1 = Bt + Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(sinTheta, L - cosTheta),
            C = 1 + L2 - 2 * L * cosTheta;
        theta -= delta = (theta - K2 * Bt - L * sinTheta + C * Bt_Bt1 -0.5 * t * B) / (2 * L * sinTheta * Bt_Bt1);
      } while (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_1__math__["l" /* epsilon2 */] && --i > 0);
      rho = A * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(C);
      omega = lambda * Bt_Bt1 / __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */];
    } else {
      rho = A * (K + t);
      omega = lambda * Bt / __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */];
    }
    return [
      rho * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(omega),
      rho0 - rho * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(omega)
    ];
  }

  forward.invert = function(x, y) {
    var rho2 = x * x + (y -= rho0) * y,
        cosTheta = (1 + L2 - rho2 / (A * A)) / (2 * L),
        theta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["b" /* acos */])(cosTheta),
        sinTheta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(theta),
        Bt_Bt1 = Bt + Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(sinTheta, L - cosTheta);
    return [
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(x / Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(rho2)) * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / Bt_Bt1,
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(1 - 2 * (theta - K2 * Bt - L * sinTheta + (1 + L2 - 2 * L * cosTheta) * Bt_Bt1) / B)
    ];
  };

  return forward;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var K = 1,
      m = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["l" /* geoProjectionMutator */])(hillRaw),
      p = m(K);

  p.ratio = function(_) {
    return arguments.length ? m(K = +_) : K;
  };

  return p
      .scale(167.774)
      .center([0, 18.67]);
});


/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__boggs__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(41);



var lobes = [[ // northern hemisphere
  [[-180,   0], [-100,  90], [ -40,   0]],
  [[ -40,   0], [  30,  90], [ 180,   0]]
], [ // southern hemisphere
  [[-180,   0], [-160, -90], [-100,   0]],
  [[-100,   0], [ -60, -90], [ -20,   0]],
  [[ -20,   0], [  20, -90], [  80,   0]],
  [[  80,   0], [ 140, -90], [ 180,   0]]
]];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__boggs__["a" /* boggsRaw */], lobes)
      .scale(160.857);
});


/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__homolosine__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(41);



var lobes = [[ // northern hemisphere
  [[-180,   0], [-100,  90], [ -40,   0]],
  [[ -40,   0], [  30,  90], [ 180,   0]]
], [ // southern hemisphere
  [[-180,   0], [-160, -90], [-100,   0]],
  [[-100,   0], [ -60, -90], [ -20,   0]],
  [[ -20,   0], [  20, -90], [  80,   0]],
  [[  80,   0], [ 140, -90], [ 180,   0]]
]];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__homolosine__["b" /* homolosineRaw */], lobes)
      .scale(152.63);
});


/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mollweide__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(41);



var lobes = [[ // northern hemisphere
  [[-180,   0], [-100,  90], [ -40,   0]],
  [[ -40,   0], [  30,  90], [ 180,   0]]
], [ // southern hemisphere
  [[-180,   0], [-160, -90], [-100,   0]],
  [[-100,   0], [ -60, -90], [ -20,   0]],
  [[ -20,   0], [  20, -90], [  80,   0]],
  [[  80,   0], [ 140, -90], [ 180,   0]]
]];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__mollweide__["d" /* mollweideRaw */], lobes)
      .scale(169.529);
});


/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mollweide__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(41);



var lobes = [[ // northern hemisphere
  [[-180,   0], [ -90,  90], [   0,   0]],
  [[   0,   0], [  90,  90], [ 180,   0]]
], [ // southern hemisphere
  [[-180,   0], [ -90, -90], [   0,   0]],
  [[   0,   0], [  90, -90], [ 180,   0]]
]];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__mollweide__["d" /* mollweideRaw */], lobes)
      .scale(169.529)
      .rotate([20, 0]);
});


/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sinuMollweide__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(41);



var lobes = [[ // northern hemisphere
  [[-180,  35], [ -30,  90], [   0,  35]],
  [[   0,  35], [  30,  90], [ 180,  35]]
], [ // southern hemisphere
  [[-180, -10], [-102, -90], [ -65, -10]],
  [[ -65, -10], [   5, -90], [  77, -10]],
  [[  77, -10], [ 103, -90], [ 180, -10]]
]];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__sinuMollweide__["c" /* sinuMollweideRaw */], lobes)
      .rotate([-20, -55])
      .scale(164.263)
      .center([0, -5.4036]);
});


/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sinusoidal__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(41);



var lobes = [[ // northern hemisphere
  [[-180,   0], [-110,  90], [ -40,   0]],
  [[ -40,   0], [   0,  90], [  40,   0]],
  [[  40,   0], [ 110,  90], [ 180,   0]]
], [ // southern hemisphere
  [[-180,   0], [-110, -90], [ -40,   0]],
  [[ -40,   0], [   0, -90], [  40,   0]],
  [[  40,   0], [ 110, -90], [ 180,   0]]
]];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__sinusoidal__["b" /* sinusoidalRaw */], lobes)
      .scale(152.63)
      .rotate([-20, 0]);
});


/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = kavrayskiy7Raw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function kavrayskiy7Raw(lambda, phi) {
  return [3 / __WEBPACK_IMPORTED_MODULE_1__math__["H" /* tau */] * lambda * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / 3 - phi * phi), phi];
}

kavrayskiy7Raw.invert = function(x, y) {
  return [__WEBPACK_IMPORTED_MODULE_1__math__["H" /* tau */] / 3 * x / Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / 3 - y * y), y];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(kavrayskiy7Raw)
      .scale(158.837);
});


/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = lagrangeRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function lagrangeRaw(n) {

  function forward(lambda, phi) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(phi) - __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]) return [0, phi < 0 ? -2 : 2];
    var sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi),
        v = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* pow */])((1 + sinPhi) / (1 - sinPhi), n / 2),
        c = 0.5 * (v + 1 / v) + Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(lambda *= n);
    return [
      2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(lambda) / c,
      (v - 1 / v) / c
    ];
  }

  forward.invert = function(x, y) {
    var y0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(y);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(y0 - 2) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]) return x ? null : [0, Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(y) * __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]];
    if (y0 > 2) return null;

    x /= 2, y /= 2;
    var x2 = x * x,
        y2 = y * y,
        t = 2 * y / (1 + x2 + y2); // tanh(nPhi)
    t = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* pow */])((1 + t) / (1 - t), 1 / n);
    return [
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(2 * x, 1 - x2 - y2) / n,
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])((t - 1) / (t + 1))
    ];
  };

  return forward;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var n = 0.5,
      m = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["l" /* geoProjectionMutator */])(lagrangeRaw),
      p = m(n);

  p.spacing = function(_) {
    return arguments.length ? m(n = +_) : n;
  };

  return p
      .scale(124.75);
});


/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = larriveeRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



var pi_sqrt2 = __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / __WEBPACK_IMPORTED_MODULE_1__math__["D" /* sqrt2 */];

function larriveeRaw(lambda, phi) {
  return [
    lambda * (1 + Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi))) / 2,
    phi / (Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi / 2) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(lambda / 6))
  ];
}

larriveeRaw.invert = function(x, y) {
  var x0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(x),
      y0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(y),
      lambda = __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */],
      phi = __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */];
  if (y0 < pi_sqrt2) phi *= y0 / pi_sqrt2;
  else lambda += 6 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["b" /* acos */])(pi_sqrt2 / y0);
  for (var i = 0; i < 25; i++) {
    var sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi),
        sqrtcosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi)),
        sinPhi_2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi / 2),
        cosPhi_2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi / 2),
        sinLambda_6 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(lambda / 6),
        cosLambda_6 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(lambda / 6),
        f0 = 0.5 * lambda * (1 + sqrtcosPhi) - x0,
        f1 = phi / (cosPhi_2 * cosLambda_6) - y0,
        df0dPhi = sqrtcosPhi ? -0.25 * lambda * sinPhi / sqrtcosPhi : 0,
        df0dLambda = 0.5 * (1 + sqrtcosPhi),
        df1dPhi = (1 +0.5 * phi * sinPhi_2 / cosPhi_2) / (cosPhi_2 * cosLambda_6),
        df1dLambda = (phi / cosPhi_2) * (sinLambda_6 / 6) / (cosLambda_6 * cosLambda_6),
        denom = df0dPhi * df1dLambda - df1dPhi * df0dLambda,
        dPhi = (f0 * df1dLambda - f1 * df0dLambda) / denom,
        dLambda = (f1 * df0dPhi - f0 * df1dPhi) / denom;
    phi -= dPhi;
    lambda -= dLambda;
    if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(dPhi) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] && Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(dLambda) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]) break;
  }
  return [x < 0 ? -lambda : lambda, y < 0 ? -phi : phi];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(larriveeRaw)
      .scale(97.2672);
});


/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = laskowskiRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function laskowskiRaw(lambda, phi) {
  var lambda2 = lambda * lambda, phi2 = phi * phi;
  return [
    lambda * (0.975534 + phi2 * (-0.119161 + lambda2 * -0.0143059 + phi2 * -0.0547009)),
    phi * (1.00384 + lambda2 * (0.0802894 + phi2 * -0.02855 + lambda2 * 0.000199025) + phi2 * (0.0998909 + phi2 * -0.0491032))
  ];
}

laskowskiRaw.invert = function(x, y) {
  var lambda = Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(x) * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */],
      phi = y / 2,
      i = 50;
  do {
    var lambda2 = lambda * lambda,
        phi2 = phi * phi,
        lambdaPhi = lambda * phi,
        fx = lambda * (0.975534 + phi2 * (-0.119161 + lambda2 * -0.0143059 + phi2 * -0.0547009)) - x,
        fy = phi * (1.00384 + lambda2 * (0.0802894 + phi2 * -0.02855 + lambda2 * 0.000199025) + phi2 * (0.0998909 + phi2 * -0.0491032)) - y,
        deltaxDeltaLambda = 0.975534 - phi2 * (0.119161 + 3 * lambda2 * 0.0143059 + phi2 * 0.0547009),
        deltaxDeltaPhi = -lambdaPhi * (2 * 0.119161 + 4 * 0.0547009 * phi2 + 2 * 0.0143059 * lambda2),
        deltayDeltaLambda = lambdaPhi * (2 * 0.0802894 + 4 * 0.000199025 * lambda2 + 2 * -0.02855 * phi2),
        deltayDeltaPhi = 1.00384 + lambda2 * (0.0802894 + 0.000199025 * lambda2) + phi2 * (3 * (0.0998909 - 0.02855 * lambda2) - 5 * 0.0491032 * phi2),
        denominator = deltaxDeltaPhi * deltayDeltaLambda - deltayDeltaPhi * deltaxDeltaLambda,
        deltaLambda = (fy * deltaxDeltaPhi - fx * deltayDeltaPhi) / denominator,
        deltaPhi = (fx * deltayDeltaLambda - fy * deltaxDeltaLambda) / denominator;
    lambda -= deltaLambda, phi -= deltaPhi;
  } while ((Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(deltaLambda) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(deltaPhi) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]) && --i > 0);
  return i && [lambda, phi];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(laskowskiRaw)
      .scale(139.98);
});


/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = littrowRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function littrowRaw(lambda, phi) {
  return [
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(lambda) / Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi),
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(phi) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(lambda)
  ];
}

littrowRaw.invert = function(x, y) {
  var x2 = x * x,
      y2 = y * y,
      y2_1 = y2 + 1,
      cosPhi = x
          ? __WEBPACK_IMPORTED_MODULE_1__math__["C" /* sqrt1_2 */] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])((y2_1 - Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(x2 * x2 + 2 * x2 * (y2 - 1) + y2_1 * y2_1)) / x2 + 1)
          : 1 / Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(y2_1);
  return [
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(x * cosPhi),
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(y) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["b" /* acos */])(cosPhi)
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(littrowRaw)
      .scale(144.049)
      .clipAngle(90 - 1e-3);
});


/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = loximuthalRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parallel1__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function loximuthalRaw(phi0) {
  var cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi0),
      tanPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* quarterPi */] + phi0 / 2);

  function forward(lambda, phi) {
    var y = phi - phi0,
        x = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(y) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] ? lambda * cosPhi0
            : Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(x = __WEBPACK_IMPORTED_MODULE_1__math__["u" /* quarterPi */] + phi / 2) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(x) - __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]
            ? 0 : lambda * y / Object(__WEBPACK_IMPORTED_MODULE_1__math__["p" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(x) / tanPhi0);
    return [x, y];
  }

  forward.invert = function(x, y) {
    var lambda,
        phi = y + phi0;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(y) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] ? x / cosPhi0
          : (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda = __WEBPACK_IMPORTED_MODULE_1__math__["u" /* quarterPi */] + phi / 2) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda) - __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]) ? 0
          : x * Object(__WEBPACK_IMPORTED_MODULE_1__math__["p" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(lambda) / tanPhi0) / y,
      phi
    ];
  };

  return forward;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__parallel1__["a" /* default */])(loximuthalRaw)
      .parallel(40)
      .scale(158.837);
});


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = millerRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function millerRaw(lambda, phi) {
  return [lambda, 1.25 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["p" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* quarterPi */] + 0.4 * phi))];
}

millerRaw.invert = function(x, y) {
  return [x, 2.5 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["m" /* exp */])(0.8 * y)) - 0.625 * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(millerRaw)
      .scale(108.318);
});


/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = modifiedStereographicRaw;
/* harmony export (immutable) */ __webpack_exports__["b"] = modifiedStereographicAlaska;
/* harmony export (immutable) */ __webpack_exports__["c"] = modifiedStereographicGs48;
/* harmony export (immutable) */ __webpack_exports__["d"] = modifiedStereographicGs50;
/* harmony export (immutable) */ __webpack_exports__["f"] = modifiedStereographicMiller;
/* harmony export (immutable) */ __webpack_exports__["e"] = modifiedStereographicLee;
/* harmony export (immutable) */ __webpack_exports__["a"] = modifiedStereographic;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function modifiedStereographicRaw(C) {
  var m = C.length - 1;

  function forward(lambda, phi) {
    var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi),
        k = 2 / (1 + cosPhi * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(lambda)),
        zr = k * cosPhi * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(lambda),
        zi = k * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi),
        i = m,
        w = C[i],
        ar = w[0],
        ai = w[1],
        t;
    while (--i >= 0) {
      w = C[i];
      ar = w[0] + zr * (t = ar) - zi * ai;
      ai = w[1] + zr * ai + zi * t;
    }
    ar = zr * (t = ar) - zi * ai;
    ai = zr * ai + zi * t;
    return [ar, ai];
  }

  forward.invert = function(x, y) {
    var i = 20,
        zr = x,
        zi = y;
    do {
      var j = m,
          w = C[j],
          ar = w[0],
          ai = w[1],
          br = 0,
          bi = 0,
          t;

      while (--j >= 0) {
        w = C[j];
        br = ar + zr * (t = br) - zi * bi;
        bi = ai + zr * bi + zi * t;
        ar = w[0] + zr * (t = ar) - zi * ai;
        ai = w[1] + zr * ai + zi * t;
      }
      br = ar + zr * (t = br) - zi * bi;
      bi = ai + zr * bi + zi * t;
      ar = zr * (t = ar) - zi * ai - x;
      ai = zr * ai + zi * t - y;

      var denominator = br * br + bi * bi, deltar, deltai;
      zr -= deltar = (ar * br + ai * bi) / denominator;
      zi -= deltai = (ai * br - ar * bi) / denominator;
    } while (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(deltar) + Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(deltai) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] * __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] && --i > 0);

    if (i) {
      var rho = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(zr * zr + zi * zi),
          c = 2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* atan */])(rho * 0.5),
          sinc = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(c);
      return [Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(zr * sinc, rho * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(c)), rho ? Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(zi * sinc / rho) : 0];
    }
  };

  return forward;
}

var alaska = [[0.9972523, 0], [0.0052513, -0.0041175], [0.0074606, 0.0048125], [-0.0153783, -0.1968253], [0.0636871, -0.1408027], [0.3660976, -0.2937382]],
    gs48 = [[0.98879, 0], [0, 0], [-0.050909, 0], [0, 0], [0.075528, 0]],
    gs50 = [[0.9842990, 0], [0.0211642, 0.0037608], [-0.1036018, -0.0575102], [-0.0329095, -0.0320119], [0.0499471, 0.1223335], [0.0260460, 0.0899805], [0.0007388, -0.1435792], [0.0075848, -0.1334108], [-0.0216473, 0.0776645], [-0.0225161, 0.0853673]],
    miller = [[0.9245, 0], [0, 0], [0.01943, 0]],
    lee = [[0.721316, 0], [0, 0], [-0.00881625, -0.00617325]];

function modifiedStereographicAlaska() {
  return modifiedStereographic(alaska, [152, -64])
      .scale(1500)
      .center([-160.908, 62.4864])
      .clipAngle(25);
}

function modifiedStereographicGs48() {
  return modifiedStereographic(gs48, [95, -38])
      .scale(1000)
      .clipAngle(55)
      .center([-96.5563, 38.8675]);
}

function modifiedStereographicGs50() {
  return modifiedStereographic(gs50, [120, -45])
      .scale(359.513)
      .clipAngle(55)
      .center([-117.474, 53.0628]);
}

function modifiedStereographicMiller() {
  return modifiedStereographic(miller, [-20, -18])
      .scale(209.091)
      .center([20, 16.7214])
      .clipAngle(82);
}

function modifiedStereographicLee() {
  return modifiedStereographic(lee, [165, 10])
      .scale(250)
      .clipAngle(130)
      .center([-165, -10]);
}

function modifiedStereographic(coefficients, rotate) {
  var p = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(modifiedStereographicRaw(coefficients)).rotate(rotate).clipAngle(90),
      r = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["m" /* geoRotation */])(rotate),
      center = p.center;

  delete p.rotate;

  p.center = function(_) {
    return arguments.length ? center(r(_)) : r.invert(center());
  };

  return p;
}


/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = mtFlatPolarParabolicRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



var sqrt6 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(6),
    sqrt7 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(7);

function mtFlatPolarParabolicRaw(lambda, phi) {
  var theta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(7 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi) / (3 * sqrt6));
  return [
    sqrt6 * lambda * (2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(2 * theta / 3) - 1) / sqrt7,
    9 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(theta / 3) / sqrt7
  ];
}

mtFlatPolarParabolicRaw.invert = function(x, y) {
  var theta = 3 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(y * sqrt7 / 9);
  return [
    x * sqrt7 / (sqrt6 * (2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(2 * theta / 3) - 1)),
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(theta) * 3 * sqrt6 / 7)
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(mtFlatPolarParabolicRaw)
      .scale(164.859);
});


/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = mtFlatPolarQuarticRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function mtFlatPolarQuarticRaw(lambda, phi) {
  var k = (1 + __WEBPACK_IMPORTED_MODULE_1__math__["C" /* sqrt1_2 */]) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi),
      theta = phi;
  for (var i = 0, delta; i < 25; i++) {
    theta -= delta = (Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(theta / 2) + Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(theta) - k) / (0.5 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(theta / 2) + Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(theta));
    if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]) break;
  }
  return [
    lambda * (1 + 2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(theta) / Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(theta / 2)) / (3 * __WEBPACK_IMPORTED_MODULE_1__math__["D" /* sqrt2 */]),
    2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(3) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(theta / 2) / Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(2 + __WEBPACK_IMPORTED_MODULE_1__math__["D" /* sqrt2 */])
  ];
}

mtFlatPolarQuarticRaw.invert = function(x, y) {
  var sinTheta_2 = y * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(2 + __WEBPACK_IMPORTED_MODULE_1__math__["D" /* sqrt2 */]) / (2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(3)),
      theta = 2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(sinTheta_2);
  return [
    3 * __WEBPACK_IMPORTED_MODULE_1__math__["D" /* sqrt2 */] * x / (1 + 2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(theta) / Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(theta / 2)),
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])((sinTheta_2 + Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(theta)) / (1 + __WEBPACK_IMPORTED_MODULE_1__math__["C" /* sqrt1_2 */]))
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(mtFlatPolarQuarticRaw)
      .scale(188.209);
});


/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = mtFlatPolarSinusoidalRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function mtFlatPolarSinusoidalRaw(lambda, phi) {
  var A = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(6 / (4 + __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */])),
      k = (1 + __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / 4) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi),
      theta = phi / 2;
  for (var i = 0, delta; i < 25; i++) {
    theta -= delta = (theta / 2 + Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(theta) - k) / (0.5 + Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(theta));
    if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]) break;
  }
  return [
    A * (0.5 + Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(theta)) * lambda / 1.5,
    A * theta
  ];
}

mtFlatPolarSinusoidalRaw.invert = function(x, y) {
  var A = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(6 / (4 + __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */])),
      theta = y / A;
  if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(theta) - __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]) theta = theta < 0 ? -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */] : __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */];
  return [
    1.5 * x / (A * (0.5 + Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(theta))),
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])((theta / 2 + Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(theta)) / (1 + __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / 4))
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(mtFlatPolarSinusoidalRaw)
      .scale(166.518);
});


/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = naturalEarthRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function naturalEarthRaw(lambda, phi) {
  var phi2 = phi * phi, phi4 = phi2 * phi2;
  return [
    lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
    phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
  ];
}

naturalEarthRaw.invert = function(x, y) {
  var phi = y, i = 25, delta;
  do {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) /
        (1.007226 + phi2 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi2 - 0.005916 * 11 * phi4)));
  } while (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] && --i > 0);
  return [
    x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
    phi
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(naturalEarthRaw)
      .scale(175.295);
});


/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = nellHammerRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function nellHammerRaw(lambda, phi) {
  return [
    lambda * (1 + Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi)) / 2,
    2 * (phi - Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(phi / 2))
  ];
}

nellHammerRaw.invert = function(x, y) {
  var p = y / 2;
  for (var i = 0, delta = Infinity; i < 10 && Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]; ++i) {
    var c = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(y / 2);
    y -= delta = (y - Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(y / 2) - p) / (1 - 0.5 / (c * c));
  }
  return [
    2 * x / (1 + Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(y)),
    y
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(nellHammerRaw)
      .scale(152.63);
});


/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = pattersonRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



// Based on Java implementation by Bojan Savric.
// https://github.com/OSUCartography/JMapProjLib/blob/master/src/com/jhlabs/map/proj/PattersonProjection.java

var pattersonK1 = 1.0148,
    pattersonK2 = 0.23185,
    pattersonK3 = -0.14499,
    pattersonK4 = 0.02406,
    pattersonC1 = pattersonK1,
    pattersonC2 = 5 * pattersonK2,
    pattersonC3 = 7 * pattersonK3,
    pattersonC4 = 9 * pattersonK4,
    pattersonYmax = 1.790857183;

function pattersonRaw(lambda, phi) {
  var phi2 = phi * phi;
  return [
    lambda,
    phi * (pattersonK1 + phi2 * phi2 * (pattersonK2 + phi2 * (pattersonK3 + pattersonK4 * phi2)))
  ];
}

pattersonRaw.invert = function(x, y) {
  if (y > pattersonYmax) y = pattersonYmax;
  else if (y < -pattersonYmax) y = -pattersonYmax;
  var yc = y, delta;

  do { // Newton-Raphson
    var y2 = yc * yc;
    yc -= delta = ((yc * (pattersonK1 + y2 * y2 * (pattersonK2 + y2 * (pattersonK3 + pattersonK4 * y2)))) - y) / (pattersonC1 + y2 * y2 * (pattersonC2 + y2 * (pattersonC3 + pattersonC4 * y2)));
  } while (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]);

  return [x, yc];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(pattersonRaw)
      .scale(139.319);
});


/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = polyconicRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function polyconicRaw(lambda, phi) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(phi) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]) return [lambda, 0];
  var tanPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(phi),
      k = lambda * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi);
  return [
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(k) / tanPhi,
    phi + (1 - Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(k)) / tanPhi
  ];
}

polyconicRaw.invert = function(x, y) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(y) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]) return [x, 0];
  var k = x * x + y * y,
      phi = y * 0.5,
      i = 10, delta;
  do {
    var tanPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(phi),
        secPhi = 1 / Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi),
        j = k - 2 * y * phi + phi * phi;
    phi -= delta = (tanPhi * j + 2 * (phi - y)) / (2 + j * secPhi * secPhi + 2 * (phi - y) * tanPhi);
  } while (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] && --i > 0);
  tanPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(phi);
  return [
    (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(y) < Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(phi + 1 / tanPhi) ? Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(x * tanPhi) : Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(x) * (Object(__WEBPACK_IMPORTED_MODULE_1__math__["b" /* acos */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(x * tanPhi)) + __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */])) / Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi),
    phi
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(polyconicRaw)
      .scale(103.74);
});


/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = inverse;
/* harmony export (immutable) */ __webpack_exports__["c"] = multiply;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(1);


// Note: 6-element arrays are used to denote the 3x3 affine transform matrix:
// [a, b, c,
//  d, e, f,
//  0, 0, 1] - this redundant row is left out.

// Transform matrix for [a0, a1] -> [b0, b1].
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var u = subtract(a[1], a[0]),
      v = subtract(b[1], b[0]),
      phi = angle(u, v),
      s = length(u) / length(v);

  return multiply([
    1, 0, a[0][0],
    0, 1, a[0][1]
  ], multiply([
    s, 0, 0,
    0, s, 0
  ], multiply([
    Object(__WEBPACK_IMPORTED_MODULE_0__math__["h" /* cos */])(phi), Object(__WEBPACK_IMPORTED_MODULE_0__math__["y" /* sin */])(phi), 0,
    -Object(__WEBPACK_IMPORTED_MODULE_0__math__["y" /* sin */])(phi), Object(__WEBPACK_IMPORTED_MODULE_0__math__["h" /* cos */])(phi), 0
  ], [
    1, 0, -b[0][0],
    0, 1, -b[0][1]
  ])));
});

// Inverts a transform matrix.
function inverse(m) {
  var k = 1 / (m[0] * m[4] - m[1] * m[3]);
  return [
    k * m[4], -k * m[1], k * (m[1] * m[5] - m[2] * m[4]),
    -k * m[3], k * m[0], k * (m[2] * m[3] - m[0] * m[5])
  ];
}

// Multiplies two 3x2 matrices.
function multiply(a, b) {
  return [
    a[0] * b[0] + a[1] * b[3],
    a[0] * b[1] + a[1] * b[4],
    a[0] * b[2] + a[1] * b[5] + a[2],
    a[3] * b[0] + a[4] * b[3],
    a[3] * b[1] + a[4] * b[4],
    a[3] * b[2] + a[4] * b[5] + a[5]
  ];
}

// Subtracts 2D vectors.
function subtract(a, b) {
  return [a[0] - b[0], a[1] - b[1]];
}

// Magnitude of a 2D vector.
function length(v) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["B" /* sqrt */])(v[0] * v[0] + v[1] * v[1]);
}

// Angle between two 2D vectors.
function angle(a, b) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* atan2 */])(a[0] * b[1] - a[1] * b[0], a[0] * b[0] + a[1] * b[1]);
}


/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__octahedron__ = __webpack_require__(155);





/* harmony default export */ __webpack_exports__["a"] = (function(faceProjection) {

  faceProjection = faceProjection || function(face) {
    var c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["d" /* geoCentroid */])({type: "MultiPoint", coordinates: face});
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["g" /* geoGnomonic */])().scale(1).translate([0, 0]).rotate([-c[0], -c[1]]);
  };

  var faces = __WEBPACK_IMPORTED_MODULE_3__octahedron__["a" /* default */].map(function(face) {
    return {face: face, project: faceProjection(face)};
  });

  [-1, 0, 0, 1, 0, 1, 4, 5].forEach(function(d, i) {
    var node = faces[d];
    node && (node.children || (node.children = [])).push(faces[i]);
  });

  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(faces[0], function(lambda, phi) {
        return faces[lambda < -__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / 2 ? phi < 0 ? 6 : 4
            : lambda < 0 ? phi < 0 ? 2 : 0
            : lambda < __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / 2 ? phi < 0 ? 3 : 1
            : phi < 0 ? 7 : 5];
      })
      .scale(101.858)
      .center([0, 45]);
});


/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__collignon__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__octahedron__ = __webpack_require__(155);






var kx = 2 / Object(__WEBPACK_IMPORTED_MODULE_2__math__["B" /* sqrt */])(3);

function collignonK(a, b) {
  var p = Object(__WEBPACK_IMPORTED_MODULE_1__collignon__["a" /* collignonRaw */])(a, b);
  return [p[0] * kx, p[1]];
}

collignonK.invert = function(x,y) {
  return __WEBPACK_IMPORTED_MODULE_1__collignon__["a" /* collignonRaw */].invert(x / kx, y);
};

/* harmony default export */ __webpack_exports__["a"] = (function(faceProjection) {

  faceProjection = faceProjection || function(face) {
    var c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["d" /* geoCentroid */])({type: "MultiPoint", coordinates: face});
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(collignonK).translate([0, 0]).scale(1).rotate(c[1] > 0 ? [-c[0], 0] : [180 - c[0], 180]);
  };

  var faces = __WEBPACK_IMPORTED_MODULE_4__octahedron__["a" /* default */].map(function(face) {
    return {face: face, project: faceProjection(face)};
  });

  [-1, 0, 0, 1, 0, 1, 4, 5].forEach(function(d, i) {
    var node = faces[d];
    node && (node.children || (node.children = [])).push(faces[i]);
  });

  return Object(__WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */])(faces[0], function(lambda, phi) {
        return faces[lambda < -__WEBPACK_IMPORTED_MODULE_2__math__["s" /* pi */] / 2 ? phi < 0 ? 6 : 4
            : lambda < 0 ? phi < 0 ? 2 : 0
            : lambda < __WEBPACK_IMPORTED_MODULE_2__math__["s" /* pi */] / 2 ? phi < 0 ? 3 : 1
            : phi < 0 ? 7 : 5];
      })
      .scale(121.906)
      .center([0, 48.5904]);
});


/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__octahedron__ = __webpack_require__(155);





/* harmony default export */ __webpack_exports__["a"] = (function(faceProjection) {

  faceProjection = faceProjection || function(face) {
    var c = face.length === 6 ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["d" /* geoCentroid */])({type: "MultiPoint", coordinates: face}) : face[0];
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["g" /* geoGnomonic */])().scale(1).translate([0, 0]).rotate([-c[0], -c[1]]);
  };

  var w5 = __WEBPACK_IMPORTED_MODULE_3__octahedron__["a" /* default */].map(function(face) {
    var xyz = face.map(cartesian),
        n = xyz.length,
        a = xyz[n - 1],
        b,
        hexagon = [];
    for (var i = 0; i < n; ++i) {
      b = xyz[i];
      hexagon.push(spherical([
        a[0] * 0.9486832980505138 + b[0] * 0.31622776601683794,
        a[1] * 0.9486832980505138 + b[1] * 0.31622776601683794,
        a[2] * 0.9486832980505138 + b[2] * 0.31622776601683794
      ]), spherical([
        b[0] * 0.9486832980505138 + a[0] * 0.31622776601683794,
        b[1] * 0.9486832980505138 + a[1] * 0.31622776601683794,
        b[2] * 0.9486832980505138 + a[2] * 0.31622776601683794
      ]));
      a = b;
    }
    return hexagon;
  });

  var cornerNormals = [];

  var parents = [-1, 0, 0, 1, 0, 1, 4, 5];

  w5.forEach(function(hexagon, j) {
    var face = __WEBPACK_IMPORTED_MODULE_3__octahedron__["a" /* default */][j],
        n = face.length,
        normals = cornerNormals[j] = [];
    for (var i = 0; i < n; ++i) {
      w5.push([
        face[i],
        hexagon[(i * 2 + 2) % (2 * n)],
        hexagon[(i * 2 + 1) % (2 * n)]
      ]);
      parents.push(j);
      normals.push(cross(
        cartesian(hexagon[(i * 2 + 2) % (2 * n)]),
        cartesian(hexagon[(i * 2 + 1) % (2 * n)])
      ));
    }
  });

  var faces = w5.map(function(face) {
    return {
      project: faceProjection(face),
      face: face
    };
  });

  parents.forEach(function(d, i) {
    var parent = faces[d];
    parent && (parent.children || (parent.children = [])).push(faces[i]);
  });

  function face(lambda, phi) {
    var cosphi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi),
        p = [cosphi * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(lambda), cosphi * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(lambda), Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi)];

    var hexagon = lambda < -__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / 2 ? phi < 0 ? 6 : 4
        : lambda < 0 ? phi < 0 ? 2 : 0
        : lambda < __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / 2 ? phi < 0 ? 3 : 1
        : phi < 0 ? 7 : 5;

    var n = cornerNormals[hexagon];

    return faces[dot(n[0], p) < 0 ? 8 + 3 * hexagon
        : dot(n[1], p) < 0 ? 8 + 3 * hexagon + 1
        : dot(n[2], p) < 0 ? 8 + 3 * hexagon + 2
        : hexagon];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(faces[0], face)
      .scale(110.625)
      .center([0,45]);
});

function dot(a, b) {
  for (var i = 0, n = a.length, s = 0; i < n; ++i) s += a[i] * b[i];
  return s;
}

function cross(a, b) {
  return [
    a[1] * b[2] - a[2] * b[1],
    a[2] * b[0] - a[0] * b[2],
    a[0] * b[1] - a[1] * b[0]
  ];
}

// Converts 3D Cartesian to spherical coordinates (degrees).
function spherical(cartesian) {
  return [
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(cartesian[1], cartesian[0]) * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */],
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["q" /* max */])(-1, Object(__WEBPACK_IMPORTED_MODULE_1__math__["r" /* min */])(1, cartesian[2]))) * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */]
  ];
}

// Converts spherical coordinates (degrees) to 3D Cartesian.
function cartesian(coordinates) {
  var lambda = coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */],
      phi = coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */],
      cosphi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi);
  return [
    cosphi * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(lambda),
    cosphi * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(lambda),
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi)
  ];
}


/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clockwise__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contains__ = __webpack_require__(651);





/* harmony default export */ __webpack_exports__["a"] = (function(object, projection) {
  var stream = projection.stream, project;
  if (!stream) throw new Error("invalid projection");
  switch (object && object.type) {
    case "Feature": project = projectFeature; break;
    case "FeatureCollection": project = projectFeatureCollection; break;
    default: project = projectGeometry; break;
  }
  return project(object, stream);
});

function projectFeatureCollection(o, stream) {
  return {
    type: "FeatureCollection",
    features: o.features.map(function(f) {
      return projectFeature(f, stream);
    })
  };
}

function projectFeature(o, stream) {
  return {
    type: "Feature",
    id: o.id,
    properties: o.properties,
    geometry: projectGeometry(o.geometry, stream)
  };
}

function projectGeometryCollection(o, stream) {
  return {
    type: "GeometryCollection",
    geometries: o.geometries.map(function(o) {
      return projectGeometry(o, stream);
    })
  };
}

function projectGeometry(o, stream) {
  if (!o) return null;
  if (o.type === "GeometryCollection") return projectGeometryCollection(o, stream);
  var sink;
  switch (o.type) {
    case "Point": sink = sinkPoint; break;
    case "MultiPoint": sink = sinkPoint; break;
    case "LineString": sink = sinkLine; break;
    case "MultiLineString": sink = sinkLine; break;
    case "Polygon": sink = sinkPolygon; break;
    case "MultiPolygon": sink = sinkPolygon; break;
    case "Sphere": sink = sinkPolygon; break;
    default: return null;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["n" /* geoStream */])(o, stream(sink));
  return sink.result();
}

var points = [],
    lines = [];

var sinkPoint = {
  point: function(x, y) {
    points.push([x, y]);
  },
  result: function() {
    var result = !points.length ? null
        : points.length < 2 ? {type: "Point", coordinates: points[0]}
        : {type: "MultiPoint", coordinates: points};
    points = [];
    return result;
  }
};

var sinkLine = {
  lineStart: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  point: function(x, y) {
    points.push([x, y]);
  },
  lineEnd: function() {
    if (points.length) lines.push(points), points = [];
  },
  result: function() {
    var result = !lines.length ? null
        : lines.length < 2 ? {type: "LineString", coordinates: lines[0]}
        : {type: "MultiLineString", coordinates: lines};
    lines = [];
    return result;
  }
};

var sinkPolygon = {
  polygonStart: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  lineStart: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  point: function(x, y) {
    points.push([x, y]);
  },
  lineEnd: function() {
    var n = points.length;
    if (n) {
      do points.push(points[0].slice()); while (++n < 4);
      lines.push(points), points = [];
    }
  },
  polygonEnd: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  result: function() {
    if (!lines.length) return null;
    var polygons = [],
        holes = [];

    // https://github.com/d3/d3/issues/1558
    lines.forEach(function(ring) {
      if (Object(__WEBPACK_IMPORTED_MODULE_2__clockwise__["a" /* default */])(ring)) polygons.push([ring]);
      else holes.push(ring);
    });

    holes.forEach(function(hole) {
      var point = hole[0];
      polygons.some(function(polygon) {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__contains__["a" /* default */])(polygon[0], point)) {
          polygon.push(hole);
          return true;
        }
      }) || polygons.push([hole]);
    });

    lines = [];

    return !polygons.length ? null
        : polygons.length > 1 ? {type: "MultiPolygon", coordinates: polygons}
        : {type: "Polygon", coordinates: polygons[0]};
  }
};


/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(ring) {
  if ((n = ring.length) < 4) return false;
  var i = 0,
      n,
      area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
  while (++i < n) area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
  return area <= 0;
});


/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(ring, point) {
  var x = point[0],
      y = point[1],
      contains = false;
  for (var i = 0, n = ring.length, j = n - 1; i < n; j = i++) {
    var pi = ring[i], xi = pi[0], yi = pi[1],
        pj = ring[j], xj = pj[0], yj = pj[1];
    if (((yi > y) ^ (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi)) contains = !contains;
  }
  return contains;
});


/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gringorten__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(156);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__gringorten__["b" /* gringortenRaw */])
      .scale(176.423);
});


/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(o, digits) {
  if (!(0 <= (digits = +digits) && digits <= 20)) throw new Error("invalid digits");

  function quantizePoint(coordinates) {
    coordinates[0] = +coordinates[0].toFixed(digits);
    coordinates[1] = +coordinates[1].toFixed(digits);
  }

  function quantizePoints(coordinates) {
    coordinates.forEach(quantizePoint);
  }

  function quantizePolygon(coordinates) {
    coordinates.forEach(quantizePoints);
  }

  function quantizeGeometry(o) {
    if (o) switch (o.type) {
      case "GeometryCollection": o.geometries.forEach(quantizeGeometry); break;
      case "Point": quantizePoint(o.coordinates); break;
      case "MultiPoint": case "LineString": quantizePoints(o.coordinates); break;
      case "MultiLineString": case "Polygon": quantizePolygon(o.coordinates); break;
      case "MultiPolygon": o.coordinates.forEach(quantizePolygon); break;
      default: return;
    }
  }

  function quantizeFeature(o) {
    quantizeGeometry(o.geometry);
  }

  if (o) switch (o.type) {
    case "Feature": quantizeFeature(o); break;
    case "FeatureCollection": o.features.forEach(quantizeFeature); break;
    default: quantizeGeometry(o); break;
  }

  return o;
});


/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = rectangularPolyconicRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parallel1__ = __webpack_require__(53);



function rectangularPolyconicRaw(phi0) {
  var sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["y" /* sin */])(phi0);

  function forward(lambda, phi) {
    var A = sinPhi0 ? Object(__WEBPACK_IMPORTED_MODULE_0__math__["F" /* tan */])(lambda * sinPhi0 / 2) / sinPhi0 : lambda / 2;
    if (!phi) return [2 * A, -phi0];
    var E = 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* atan */])(A * Object(__WEBPACK_IMPORTED_MODULE_0__math__["y" /* sin */])(phi)),
        cotPhi = 1 / Object(__WEBPACK_IMPORTED_MODULE_0__math__["F" /* tan */])(phi);
    return [
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["y" /* sin */])(E) * cotPhi,
      phi + (1 - Object(__WEBPACK_IMPORTED_MODULE_0__math__["h" /* cos */])(E)) * cotPhi - phi0
    ];
  }

  // TODO return null for points outside outline.
  forward.invert = function(x, y) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(y += phi0) < __WEBPACK_IMPORTED_MODULE_0__math__["k" /* epsilon */]) return [sinPhi0 ? 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* atan */])(sinPhi0 * x / 2) / sinPhi0 : x, 0];
    var k = x * x + y * y,
        phi = 0,
        i = 10, delta;
    do {
      var tanPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["F" /* tan */])(phi),
          secPhi = 1 / Object(__WEBPACK_IMPORTED_MODULE_0__math__["h" /* cos */])(phi),
          j = k - 2 * y * phi + phi * phi;
      phi -= delta = (tanPhi * j + 2 * (phi - y)) / (2 + j * secPhi * secPhi + 2 * (phi - y) * tanPhi);
    } while (Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_0__math__["k" /* epsilon */] && --i > 0);
    var E = x * (tanPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["F" /* tan */])(phi)),
        A = Object(__WEBPACK_IMPORTED_MODULE_0__math__["F" /* tan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(y) < Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(phi + 1 / tanPhi) ? Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* asin */])(E) * 0.5 : Object(__WEBPACK_IMPORTED_MODULE_0__math__["b" /* acos */])(E) * 0.5 + __WEBPACK_IMPORTED_MODULE_0__math__["s" /* pi */] / 4) / Object(__WEBPACK_IMPORTED_MODULE_0__math__["y" /* sin */])(phi);
    return [
      sinPhi0 ? 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* atan */])(sinPhi0 * A) / sinPhi0 : 2 * A,
      phi
    ];
  };

  return forward;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__parallel1__["a" /* default */])(rectangularPolyconicRaw)
      .scale(131.215);
});


/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = robinsonRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



var K = [
  [0.9986, -0.062],
  [1.0000, 0.0000],
  [0.9986, 0.0620],
  [0.9954, 0.1240],
  [0.9900, 0.1860],
  [0.9822, 0.2480],
  [0.9730, 0.3100],
  [0.9600, 0.3720],
  [0.9427, 0.4340],
  [0.9216, 0.4958],
  [0.8962, 0.5571],
  [0.8679, 0.6176],
  [0.8350, 0.6769],
  [0.7986, 0.7346],
  [0.7597, 0.7903],
  [0.7186, 0.8435],
  [0.6732, 0.8936],
  [0.6213, 0.9394],
  [0.5722, 0.9761],
  [0.5322, 1.0000]
];

K.forEach(function(d) {
  d[1] *= 1.0144;
});

function robinsonRaw(lambda, phi) {
  var i = Object(__WEBPACK_IMPORTED_MODULE_1__math__["r" /* min */])(18, Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(phi) * 36 / __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]),
      i0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["n" /* floor */])(i),
      di = i - i0,
      ax = (k = K[i0])[0],
      ay = k[1],
      bx = (k = K[++i0])[0],
      by = k[1],
      cx = (k = K[Object(__WEBPACK_IMPORTED_MODULE_1__math__["r" /* min */])(19, ++i0)])[0],
      cy = k[1],
      k;
  return [
    lambda * (bx + di * (cx - ax) / 2 + di * di * (cx - 2 * bx + ax) / 2),
    (phi > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]) * (by + di * (cy - ay) / 2 + di * di * (cy - 2 * by + ay) / 2)
  ];
}

robinsonRaw.invert = function(x, y) {
  var yy = y / __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */],
      phi = yy * 90,
      i = Object(__WEBPACK_IMPORTED_MODULE_1__math__["r" /* min */])(18, Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(phi / 5)),
      i0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["q" /* max */])(0, Object(__WEBPACK_IMPORTED_MODULE_1__math__["n" /* floor */])(i));
  do {
    var ay = K[i0][1],
        by = K[i0 + 1][1],
        cy = K[Object(__WEBPACK_IMPORTED_MODULE_1__math__["r" /* min */])(19, i0 + 2)][1],
        u = cy - ay,
        v = cy - 2 * by + ay,
        t = 2 * (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(yy) - by) / u,
        c = v / u,
        di = t * (1 - c * t * (1 - 2 * c * t));
    if (di >= 0 || i0 === 1) {
      phi = (y >= 0 ? 5 : -5) * (di + i);
      var j = 50, delta;
      do {
        i = Object(__WEBPACK_IMPORTED_MODULE_1__math__["r" /* min */])(18, Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(phi) / 5);
        i0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["n" /* floor */])(i);
        di = i - i0;
        ay = K[i0][1];
        by = K[i0 + 1][1];
        cy = K[Object(__WEBPACK_IMPORTED_MODULE_1__math__["r" /* min */])(19, i0 + 2)][1];
        phi -= (delta = (y >= 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]) * (by + di * (cy - ay) / 2 + di * di * (cy - 2 * by + ay) / 2) - y) * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */];
      } while (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_1__math__["l" /* epsilon2 */] && --j > 0);
      break;
    }
  } while (--i0 >= 0);
  var ax = K[i0][0],
      bx = K[i0 + 1][0],
      cx = K[Object(__WEBPACK_IMPORTED_MODULE_1__math__["r" /* min */])(19, i0 + 2)][0];
  return [
    x / (bx + di * (cx - ax) / 2 + di * di * (cx - 2 * bx + ax) / 2),
    phi * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */]
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(robinsonRaw)
      .scale(152.63);
});


/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = satelliteRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function satelliteVerticalRaw(P) {
  function forward(lambda, phi) {
    var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi),
        k = (P - 1) / (P - cosPhi * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(lambda));
    return [
      k * cosPhi * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(lambda),
      k * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi)
    ];
  }

  forward.invert = function(x, y) {
    var rho2 = x * x + y * y,
        rho = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(rho2),
        sinc = (P - Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(1 - rho2 * (P + 1) / (P - 1))) / ((P - 1) / rho + rho / (P - 1));
    return [
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(x * sinc, rho * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(1 - sinc * sinc)),
      rho ? Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(y * sinc / rho) : 0
    ];
  };

  return forward;
}

function satelliteRaw(P, omega) {
  var vertical = satelliteVerticalRaw(P);
  if (!omega) return vertical;
  var cosOmega = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(omega),
      sinOmega = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(omega);

  function forward(lambda, phi) {
    var coordinates = vertical(lambda, phi),
        y = coordinates[1],
        A = y * sinOmega / (P - 1) + cosOmega;
    return [
      coordinates[0] * cosOmega / A,
      y / A
    ];
  }

  forward.invert = function(x, y) {
    var k = (P - 1) / (P - 1 - y * sinOmega);
    return vertical.invert(k * x, k * y * cosOmega);
  };

  return forward;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var distance = 2,
      omega = 0,
      m = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["l" /* geoProjectionMutator */])(satelliteRaw),
      p = m(distance, omega);

  // As a multiple of radius.
  p.distance = function(_) {
    if (!arguments.length) return distance;
    return m(distance = +_, omega);
  };

  p.tilt = function(_) {
    if (!arguments.length) return omega * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */];
    return m(distance, omega = _ * __WEBPACK_IMPORTED_MODULE_1__math__["v" /* radians */]);
  };

  return p
      .scale(432.147)
      .clipAngle(Object(__WEBPACK_IMPORTED_MODULE_1__math__["b" /* acos */])(1 / distance) * __WEBPACK_IMPORTED_MODULE_1__math__["j" /* degrees */] - 1e-6);
});


/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var epsilon = 1e-4,
    epsilonInverse = 1e4,
    x0 = -180, x0e = x0 + epsilon,
    x1 = 180, x1e = x1 - epsilon,
    y0 = -90, y0e = y0 + epsilon,
    y1 = 90, y1e = y1 - epsilon;

function quantize(x) {
  return Math.floor(x * epsilonInverse) / epsilonInverse;
}

function normalizePoint(y) {
  return y === y0 || y === y1
      ? [0, y] // pole
      : [x0, quantize(y)]; // antimeridian
}

function clampPoint(p) {
  if (p[0] <= x0e) p[0] = x0;
  else if (p[0] >= x1e) p[0] = x1;
  if (p[1] <= y0e) p[1] = y0;
  else if (p[1] >= y1e) p[1] = y1;
}

function clampPoints(points) {
  points.forEach(clampPoint);
}

// For each ring, detect where it crosses the antimeridian or pole.
function extractFragments(polygon, fragments) {
  for (var j = 0, m = polygon.length; j < m; ++j) {
    var ring = polygon[j];
    ring.polygon = polygon;

    // By default, assume that this ring doesn’t need any stitching.
    fragments.push(ring);

    for (var i = 0, n = ring.length; i < n; ++i) {
      var point = ring[i],
          x = point[0],
          y = point[1];

      // If this is an antimeridian or polar point…
      if (x <= x0e || x >= x1e || y <= y0e || y >= y1e) {
        clampPoint(point);

        // Advance through any antimeridian or polar points…
        for (var k = i + 1; k < n; ++k) {
          var pointk = ring[k],
              xk = pointk[0],
              yk = pointk[1];
          if (xk > x0e && xk < x1e && yk > y0e && yk < y1e) break;
        }

        // If this was just a single antimeridian or polar point,
        // we don’t need to cut this ring into a fragment;
        // we can just leave it as-is.
        if (k === i + 1) continue;

        // Otherwise, if this is not the first point in the ring,
        // cut the current fragment so that it ends at the current point.
        // The current point is also normalized for later joining.
        if (i) {
          var fragmentBefore = ring.slice(0, i + 1);
          fragmentBefore.polygon = polygon;
          fragmentBefore[fragmentBefore.length - 1] = normalizePoint(y);
          fragments[fragments.length - 1] = fragmentBefore;
        }

        // If the ring started with an antimeridian fragment,
        // we can ignore that fragment entirely.
        else fragments.pop();

        // If the remainder of the ring is an antimeridian fragment,
        // move on to the next ring.
        if (k >= n) break;

        // Otherwise, add the remaining ring fragment and continue.
        fragments.push(ring = ring.slice(k - 1));
        ring[0] = normalizePoint(ring[0][1]);
        ring.polygon = polygon;
        i = -1;
        n = ring.length;
      }
    }
  }
  polygon.length = 0;
}

// Now stitch the fragments back together into rings.
// TODO remove empty polygons.
function stitchFragments(fragments) {
  var i, n = fragments.length;

  // To connect the fragments start-to-end, create a simple index by end.
  var fragmentByStart = {},
      fragmentByEnd = {},
      fragment,
      start,
      startFragment,
      end,
      endFragment;

  // For each fragment…
  for (i = 0; i < n; ++i) {
    fragment = fragments[i];
    start = fragment[0];
    end = fragment[fragment.length - 1];

    // If this fragment is closed, add it as a standalone ring.
    if (start[0] === end[0] && start[1] === end[1]) {
      fragment.polygon.push(fragment);
      fragments[i] = null;
      continue;
    }

    fragment.index = i;
    fragmentByStart[start] = fragmentByEnd[end] = fragment;
  }

  // For each open fragment…
  for (i = 0; i < n; ++i) {
    fragment = fragments[i];
    if (fragment) {
      start = fragment[0];
      end = fragment[fragment.length - 1];
      startFragment = fragmentByEnd[start];
      endFragment = fragmentByStart[end];

      delete fragmentByStart[start];
      delete fragmentByEnd[end];

      // If this fragment is closed, add it as a standalone ring.
      if (start[0] === end[0] && start[1] === end[1]) {
        fragment.polygon.push(fragment);
        continue;
      }

      if (startFragment) {
        delete fragmentByEnd[start];
        delete fragmentByStart[startFragment[0]];
        startFragment.pop(); // drop the shared coordinate
        fragments[startFragment.index] = null;
        fragment = startFragment.concat(fragment);
        fragment.polygon = startFragment.polygon;

        if (startFragment === endFragment) {
          // Connect both ends to this single fragment to create a ring.
          fragment.polygon.push(fragment);
        } else {
          fragment.index = n++;
          fragments.push(fragmentByStart[fragment[0]] = fragmentByEnd[fragment[fragment.length - 1]] = fragment);
        }
      } else if (endFragment) {
        delete fragmentByStart[end];
        delete fragmentByEnd[endFragment[endFragment.length - 1]];
        fragment.pop(); // drop the shared coordinate
        fragment = fragment.concat(endFragment);
        fragment.polygon = endFragment.polygon;
        fragment.index = n++;
        fragments[endFragment.index] = null;
        fragments.push(fragmentByStart[fragment[0]] = fragmentByEnd[fragment[fragment.length - 1]] = fragment);
      } else {
        fragment.push(fragment[0]); // close ring
        fragment.polygon.push(fragment);
      }
    }
  }
}

function stitchFeature(o) {
  stitchGeometry(o.geometry);
}

function stitchGeometry(o) {
  if (!o) return;
  var fragments, i, n;

  switch (o.type) {
    case "GeometryCollection": {
      o.geometries.forEach(stitchGeometry);
      return;
    }
    case "Point": {
      clampPoint(o.coordinates);
      break;
    }
    case "MultiPoint":
    case "LineString": {
      clampPoints(o.coordinates);
      break;
    }
    case "MultiLineString": {
      o.coordinates.forEach(clampPoints);
      break;
    }
    case "Polygon": {
      extractFragments(o.coordinates, fragments = []);
      break;
    }
    case "MultiPolygon": {
      fragments = [], i = -1, n = o.coordinates.length;
      while (++i < n) extractFragments(o.coordinates[i], fragments);
      break;
    }
    default: return;
  }

  stitchFragments(fragments);
}

/* harmony default export */ __webpack_exports__["a"] = (function(o) {
  if (o) switch (o.type) {
    case "Feature": stitchFeature(o); break;
    case "FeatureCollection": o.features.forEach(stitchFeature); break;
    default: stitchGeometry(o); break;
  }
  return o;
});


/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = timesRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function timesRaw(lambda, phi) {
  var t = Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(phi / 2),
      s = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* quarterPi */] * t);
  return [
    lambda * (0.74482 - 0.34588 * s * s),
    1.70711 * t
  ];
}

timesRaw.invert = function(x, y) {
  var t = y / 1.70711,
      s = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* quarterPi */] * t);
  return [
    x / (0.74482 - 0.34588 * s * s),
    2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* atan */])(t)
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(timesRaw)
      .scale(146.153);
});


/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = twoPointAzimuthalRaw;
/* harmony export (immutable) */ __webpack_exports__["c"] = twoPointAzimuthalUsa;
/* harmony export (immutable) */ __webpack_exports__["a"] = twoPointAzimuthal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__twoPoint__ = __webpack_require__(292);




function twoPointAzimuthalRaw(d) {
  var cosd = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(d);

  function forward(lambda, phi) {
    var coordinates = Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["h" /* geoGnomonicRaw */])(lambda, phi);
    coordinates[0] *= cosd;
    return coordinates;
  }

  forward.invert = function(x, y) {
    return __WEBPACK_IMPORTED_MODULE_0_d3_geo__["h" /* geoGnomonicRaw */].invert(x / cosd, y);
  };

  return forward;
}

function twoPointAzimuthalUsa() {
  return twoPointAzimuthal([-158, 21.5], [-77, 39])
      .clipAngle(60)
      .scale(400);
}

function twoPointAzimuthal(p0, p1) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__twoPoint__["a" /* default */])(twoPointAzimuthalRaw, p0, p1);
}


/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = twoPointEquidistantRaw;
/* harmony export (immutable) */ __webpack_exports__["c"] = twoPointEquidistantUsa;
/* harmony export (immutable) */ __webpack_exports__["a"] = twoPointEquidistant;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__twoPoint__ = __webpack_require__(292);




// TODO clip to ellipse
function twoPointEquidistantRaw(z0) {
  if (!(z0 *= 2)) return __WEBPACK_IMPORTED_MODULE_0_d3_geo__["b" /* geoAzimuthalEquidistantRaw */];
  var lambdaa = -z0 / 2,
      lambdab = -lambdaa,
      z02 = z0 * z0,
      tanLambda0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(lambdab),
      S = 0.5 / Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(lambdab);

  function forward(lambda, phi) {
    var za = Object(__WEBPACK_IMPORTED_MODULE_1__math__["b" /* acos */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(lambda - lambdaa)),
        zb = Object(__WEBPACK_IMPORTED_MODULE_1__math__["b" /* acos */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(lambda - lambdab)),
        ys = phi < 0 ? -1 : 1;
    za *= za, zb *= zb;
    return [
      (za - zb) / (2 * z0),
      ys * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(4 * z02 * zb - (z02 - za + zb) * (z02 - za + zb)) / (2 * z0)
    ];
  }

  forward.invert = function(x, y) {
    var y2 = y * y,
        cosza = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(y2 + (t = x + lambdaa) * t)),
        coszb = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(y2 + (t = x + lambdab) * t)),
        t,
        d;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(d = cosza - coszb, t = (cosza + coszb) * tanLambda0),
      (y < 0 ? -1 : 1) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["b" /* acos */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(t * t + d * d) * S)
    ];
  };

  return forward;
}

function twoPointEquidistantUsa() {
  return twoPointEquidistant([-158, 21.5], [-77, 39])
      .clipAngle(130)
      .scale(122.571);
}

function twoPointEquidistant(p0, p1) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__twoPoint__["a" /* default */])(twoPointEquidistantRaw, p0, p1);
}


/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = vanDerGrintenRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function vanDerGrintenRaw(lambda, phi) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(phi) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]) return [lambda, 0];
  var sinTheta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(phi / __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]),
      theta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(sinTheta);
  if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(phi) - __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]) return [0, Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(phi) * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(theta / 2)];
  var cosTheta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(theta),
      A = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / lambda - lambda / __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]) / 2,
      A2 = A * A,
      G = cosTheta / (sinTheta + cosTheta - 1),
      P = G * (2 / sinTheta - 1),
      P2 = P * P,
      P2_A2 = P2 + A2,
      G_P2 = G - P2,
      Q = A2 + G;
  return [
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(lambda) * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * (A * G_P2 + Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(A2 * G_P2 * G_P2 - P2_A2 * (G * G - P2))) / P2_A2,
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(phi) * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * (P * Q - A * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])((A2 + 1) * P2_A2 - Q * Q)) / P2_A2
  ];
}

vanDerGrintenRaw.invert = function(x, y) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(y) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]) return [x, 0];
  if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(x) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]) return [0, __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* atan */])(y / __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]))];
  var x2 = (x /= __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]) * x,
      y2 = (y /= __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]) * y,
      x2_y2 = x2 + y2,
      z = x2_y2 * x2_y2,
      c1 = -Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(y) * (1 + x2_y2),
      c2 = c1 - 2 * y2 + x2,
      c3 = -2 * c1 + 1 + 2 * y2 + z,
      d = y2 / c3 + (2 * c2 * c2 * c2 / (c3 * c3 * c3) - 9 * c1 * c2 / (c3 * c3)) / 27,
      a1 = (c1 - c2 * c2 / (3 * c3)) / c3,
      m1 = 2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(-a1 / 3),
      theta1 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["b" /* acos */])(3 * d / (a1 * m1)) / 3;
  return [
    __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * (x2_y2 - 1 + Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(1 + 2 * (x2 - y2) + z)) / (2 * x),
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(y) * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * (-m1 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(theta1 + __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / 3) - c2 / (3 * c3))
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(vanDerGrintenRaw)
      .scale(79.4183);
});


/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = vanDerGrinten2Raw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function vanDerGrinten2Raw(lambda, phi) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(phi) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]) return [lambda, 0];
  var sinTheta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(phi / __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]),
      theta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(sinTheta);
  if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(phi) - __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]) return [0, Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(phi) * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(theta / 2)];
  var cosTheta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(theta),
      A = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / lambda - lambda / __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]) / 2,
      A2 = A * A,
      x1 = cosTheta * (Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(1 + A2) - A * cosTheta) / (1 + A2 * sinTheta * sinTheta);
  return [
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(lambda) * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * x1,
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(phi) * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(1 - x1 * (2 * A + x1))
  ];
}

vanDerGrinten2Raw.invert = function(x, y) {
  if (!x) return [0, __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* atan */])(y / __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]))];
  var x1 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(x / __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]),
      A = (1 - x1 * x1 - (y /= __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]) * y) / (2 * x1),
      A2 = A * A,
      B = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(A2 + 1);
  return [
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(x) * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * (B - A),
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(y) * __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])((1 - 2 * A * x1) * (A + B) - x1), Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(B + A + x1)))
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(vanDerGrinten2Raw)
      .scale(79.4183);
});


/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = vanDerGrinten3Raw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function vanDerGrinten3Raw(lambda, phi) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(phi) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]) return [lambda, 0];
  var sinTheta = phi / __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */],
      theta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(sinTheta);
  if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(phi) - __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]) < __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */]) return [0, __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(theta / 2)];
  var A = (__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / lambda - lambda / __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */]) / 2,
      y1 = sinTheta / (1 + Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(theta));
  return [
    __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * (Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(lambda) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(A * A + 1 - y1 * y1) - A),
    __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * y1
  ];
}

vanDerGrinten3Raw.invert = function(x, y) {
  if (!y) return [x, 0];
  var y1 = y / __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */],
      A = (__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * (1 - y1 * y1) - x * x) / (2 * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * x);
  return [
    x ? __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * (Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(x) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(A * A + 1) - A) : 0,
    __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* atan */])(y1))
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(vanDerGrinten3Raw)
        .scale(79.4183);
});


/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = vanDerGrinten4Raw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function vanDerGrinten4Raw(lambda, phi) {
  if (!phi) return [lambda, 0];
  var phi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(phi);
  if (!lambda || phi0 === __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]) return [0, phi];
  var B = phi0 / __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */],
      B2 = B * B,
      C = (8 * B - B2 * (B2 + 2) - 5) / (2 * B2 * (B - 1)),
      C2 = C * C,
      BC = B * C,
      B_C2 = B2 + C2 + 2 * BC,
      B_3C = B + 3 * C,
      lambda0 = lambda / __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */],
      lambda1 = lambda0 + 1 / lambda0,
      D = Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda) - __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */]) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(lambda1 * lambda1 - 4),
      D2 = D * D,
      F = B_C2 * (B2 + C2 * D2 - 1) + (1 - B2) * (B2 * (B_3C * B_3C + 4 * C2) + 12 * BC * C2 + 4 * C2 * C2),
      x1 = (D * (B_C2 + C2 - 1) + 2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(F)) / (4 * B_C2 + D2);
  return [
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(lambda) * __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */] * x1,
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(phi) * __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(1 + D * Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(x1) - x1 * x1)
  ];
}

vanDerGrinten4Raw.invert = function(x, y) {
  var delta;
  if (!x || !y) return [x, y];
  y /= __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */];
  var x1 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(x) * x / __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */],
      D = (x1 * x1 - 1 + 4 * y * y) / Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(x1),
      D2 = D * D,
      B = 2 * y,
      i = 50;
  do {
    var B2 = B * B,
        C = (8 * B - B2 * (B2 + 2) - 5) / (2 * B2 * (B - 1)),
        C_ = (3 * B - B2 * B - 10) / (2 * B2 * B),
        C2 = C * C,
        BC = B * C,
        B_C = B + C,
        B_C2 = B_C * B_C,
        B_3C = B + 3 * C,
        F = B_C2 * (B2 + C2 * D2 - 1) + (1 - B2) * (B2 * (B_3C * B_3C + 4 * C2) + C2 * (12 * BC + 4 * C2)),
        F_ = -2 * B_C * (4 * BC * C2 + (1 - 4 * B2 + 3 * B2 * B2) * (1 + C_) + C2 * (-6 + 14 * B2 - D2 + (-8 + 8 * B2 - 2 * D2) * C_) + BC * (-8 + 12 * B2 + (-10 + 10 * B2 - D2) * C_)),
        sqrtF = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(F),
        f = D * (B_C2 + C2 - 1) + 2 * sqrtF - x1 * (4 * B_C2 + D2),
        f_ = D * (2 * C * C_ + 2 * B_C * (1 + C_)) + F_ / sqrtF - 8 * B_C * (D * (-1 + C2 + B_C2) + 2 * sqrtF) * (1 + C_) / (D2 + 4 * B_C2);
    B -= delta = f / f_;
  } while (delta > __WEBPACK_IMPORTED_MODULE_1__math__["k" /* epsilon */] && --i > 0);
  return [
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["x" /* sign */])(x) * (Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(D * D + 4) + D) * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] / 4,
    __WEBPACK_IMPORTED_MODULE_1__math__["o" /* halfPi */] * B
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(vanDerGrinten4Raw)
      .scale(127.16);
});


/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return wagner4Raw; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mollweide__ = __webpack_require__(32);




var A = 4 * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] + 3 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(3),
    B = 2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(2 * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(3) / A);

var wagner4Raw = Object(__WEBPACK_IMPORTED_MODULE_2__mollweide__["b" /* mollweideBromleyRaw */])(B * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(3) / __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */], B, A / 6);

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(wagner4Raw)
      .scale(176.84);
});


/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = wagner6Raw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function wagner6Raw(lambda, phi) {
  return [lambda * Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(1 - 3 * phi * phi / (__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */])), phi];
}

wagner6Raw.invert = function(x, y) {
  return [x / Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(1 - 3 * y * y / (__WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */] * __WEBPACK_IMPORTED_MODULE_1__math__["s" /* pi */])), y];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(wagner6Raw)
      .scale(152.63);
});


/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = wagner7Raw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function wagner7Raw(lambda, phi) {
  var s = 0.90631 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi),
      c0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(1 - s * s),
      c1 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(2 / (1 + c0 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(lambda /= 3)));
  return [
    2.66723 * c0 * c1 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(lambda),
    1.24104 * s * c1
  ];
}

wagner7Raw.invert = function(x, y) {
  var t1 = x / 2.66723,
      t2 = y / 1.24104,
      p = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(t1 * t1 + t2 * t2),
      c = 2 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(p / 2);
  return [
    3 * Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(x * Object(__WEBPACK_IMPORTED_MODULE_1__math__["F" /* tan */])(c), 2.66723 * p),
    p && Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(y * Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(c) / (1.24104 * 0.90631 * p))
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(wagner7Raw)
      .scale(172.632);
});


/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = wiechelRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(1);



function wiechelRaw(lambda, phi) {
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(phi),
      sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(lambda) * cosPhi,
      sin1_Phi = 1 - sinPhi,
      cosLambda = Object(__WEBPACK_IMPORTED_MODULE_1__math__["h" /* cos */])(lambda = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(lambda) * cosPhi, -Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(phi))),
      sinLambda = Object(__WEBPACK_IMPORTED_MODULE_1__math__["y" /* sin */])(lambda);
  cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(1 - sinPhi * sinPhi);
  return [
    sinLambda * cosPhi - cosLambda * sin1_Phi,
    -cosLambda * cosPhi - sinLambda * sin1_Phi
  ];
}

wiechelRaw.invert = function(x, y) {
  var w = (x * x + y * y) / -2,
      k = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(-w * (2 + w)),
      b = y * w + x * k,
      a = x * w - y * k,
      D = Object(__WEBPACK_IMPORTED_MODULE_1__math__["B" /* sqrt */])(a * a + b * b);
  return [
    Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* atan2 */])(k * b, D * (1 + w)),
    D ? -Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* asin */])(k * a / D) : 0
  ];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(wiechelRaw)
      .rotate([0, -90, 45])
      .scale(124.75)
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = winkel3Raw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_geo__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aitoff__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(1);




function winkel3Raw(lambda, phi) {
  var coordinates = Object(__WEBPACK_IMPORTED_MODULE_1__aitoff__["a" /* aitoffRaw */])(lambda, phi);
  return [
    (coordinates[0] + lambda / __WEBPACK_IMPORTED_MODULE_2__math__["o" /* halfPi */]) / 2,
    (coordinates[1] + phi) / 2
  ];
}

winkel3Raw.invert = function(x, y) {
  var lambda = x, phi = y, i = 25;
  do {
    var cosphi = Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(phi),
        sinphi = Object(__WEBPACK_IMPORTED_MODULE_2__math__["y" /* sin */])(phi),
        sin_2phi = Object(__WEBPACK_IMPORTED_MODULE_2__math__["y" /* sin */])(2 * phi),
        sin2phi = sinphi * sinphi,
        cos2phi = cosphi * cosphi,
        sinlambda = Object(__WEBPACK_IMPORTED_MODULE_2__math__["y" /* sin */])(lambda),
        coslambda_2 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(lambda / 2),
        sinlambda_2 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["y" /* sin */])(lambda / 2),
        sin2lambda_2 = sinlambda_2 * sinlambda_2,
        C = 1 - cos2phi * coslambda_2 * coslambda_2,
        E = C ? Object(__WEBPACK_IMPORTED_MODULE_2__math__["b" /* acos */])(cosphi * coslambda_2) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["B" /* sqrt */])(F = 1 / C) : F = 0,
        F,
        fx = 0.5 * (2 * E * cosphi * sinlambda_2 + lambda / __WEBPACK_IMPORTED_MODULE_2__math__["o" /* halfPi */]) - x,
        fy = 0.5 * (E * sinphi + phi) - y,
        dxdlambda = 0.5 * F * (cos2phi * sin2lambda_2 + E * cosphi * coslambda_2 * sin2phi) + 0.5 / __WEBPACK_IMPORTED_MODULE_2__math__["o" /* halfPi */],
        dxdphi = F * (sinlambda * sin_2phi / 4 - E * sinphi * sinlambda_2),
        dydlambda = 0.125 * F * (sin_2phi * sinlambda_2 - E * sinphi * cos2phi * sinlambda),
        dydphi = 0.5 * F * (sin2phi * coslambda_2 + E * sin2lambda_2 * cosphi) + 0.5,
        denominator = dxdphi * dydlambda - dydphi * dxdlambda,
        dlambda = (fy * dxdphi - fx * dydphi) / denominator,
        dphi = (fx * dydlambda - fy * dxdlambda) / denominator;
    lambda -= dlambda, phi -= dphi;
  } while ((Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(dlambda) > __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */] || Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(dphi) > __WEBPACK_IMPORTED_MODULE_2__math__["k" /* epsilon */]) && --i > 0);
  return [lambda, phi];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_geo__["k" /* geoProjection */])(winkel3Raw)
      .scale(158.837);
});


/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stream__ = __webpack_require__(43);






var lambda0, phi0, lambda1, phi1, // bounds
    lambda2, // previous lambda-coordinate
    lambda00, phi00, // first point
    p0, // previous 3D point
    deltaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    ranges,
    range;

var boundsStream = {
  point: boundsPoint,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream.point = boundsRingPoint;
    boundsStream.lineStart = boundsRingStart;
    boundsStream.lineEnd = boundsRingEnd;
    deltaSum.reset();
    __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].polygonStart();
  },
  polygonEnd: function() {
    __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].polygonEnd();
    boundsStream.point = boundsPoint;
    boundsStream.lineStart = boundsLineStart;
    boundsStream.lineEnd = boundsLineEnd;
    if (__WEBPACK_IMPORTED_MODULE_1__area__["a" /* areaRingSum */] < 0) lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    else if (deltaSum > __WEBPACK_IMPORTED_MODULE_3__math__["i" /* epsilon */]) phi1 = 90;
    else if (deltaSum < -__WEBPACK_IMPORTED_MODULE_3__math__["i" /* epsilon */]) phi0 = -90;
    range[0] = lambda0, range[1] = lambda1;
  }
};

function boundsPoint(lambda, phi) {
  ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
}

function linePoint(lambda, phi) {
  var p = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["a" /* cartesian */])([lambda * __WEBPACK_IMPORTED_MODULE_3__math__["r" /* radians */], phi * __WEBPACK_IMPORTED_MODULE_3__math__["r" /* radians */]]);
  if (p0) {
    var normal = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["c" /* cartesianCross */])(p0, p),
        equatorial = [normal[1], -normal[0], 0],
        inflection = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["c" /* cartesianCross */])(equatorial, normal);
    Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["e" /* cartesianNormalizeInPlace */])(inflection);
    inflection = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian__["g" /* spherical */])(inflection);
    var delta = lambda - lambda2,
        sign = delta > 0 ? 1 : -1,
        lambdai = inflection[0] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */] * sign,
        phii,
        antimeridian = Object(__WEBPACK_IMPORTED_MODULE_3__math__["a" /* abs */])(delta) > 180;
    if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = inflection[1] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */];
      if (phii > phi1) phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = -inflection[1] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */];
      if (phii < phi0) phi0 = phii;
    } else {
      if (phi < phi0) phi0 = phi;
      if (phi > phi1) phi1 = phi;
    }
    if (antimeridian) {
      if (lambda < lambda2) {
        if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
      } else {
        if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
      }
    } else {
      if (lambda1 >= lambda0) {
        if (lambda < lambda0) lambda0 = lambda;
        if (lambda > lambda1) lambda1 = lambda;
      } else {
        if (lambda > lambda2) {
          if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
        } else {
          if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        }
      }
    }
  } else {
    ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  }
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
  p0 = p, lambda2 = lambda;
}

function boundsLineStart() {
  boundsStream.point = linePoint;
}

function boundsLineEnd() {
  range[0] = lambda0, range[1] = lambda1;
  boundsStream.point = boundsPoint;
  p0 = null;
}

function boundsRingPoint(lambda, phi) {
  if (p0) {
    var delta = lambda - lambda2;
    deltaSum.add(Object(__WEBPACK_IMPORTED_MODULE_3__math__["a" /* abs */])(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    lambda00 = lambda, phi00 = phi;
  }
  __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].point(lambda, phi);
  linePoint(lambda, phi);
}

function boundsRingStart() {
  __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].lineStart();
}

function boundsRingEnd() {
  boundsRingPoint(lambda00, phi00);
  __WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaStream */].lineEnd();
  if (Object(__WEBPACK_IMPORTED_MODULE_3__math__["a" /* abs */])(deltaSum) > __WEBPACK_IMPORTED_MODULE_3__math__["i" /* epsilon */]) lambda0 = -(lambda1 = 180);
  range[0] = lambda0, range[1] = lambda1;
  p0 = null;
}

// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}

function rangeCompare(a, b) {
  return a[0] - b[0];
}

function rangeContains(range, x) {
  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

/* harmony default export */ __webpack_exports__["a"] = (function(feature) {
  var i, n, a, b, merged, deltaMax, delta;

  phi1 = lambda1 = -(lambda0 = phi0 = Infinity);
  ranges = [];
  Object(__WEBPACK_IMPORTED_MODULE_4__stream__["a" /* default */])(feature, boundsStream);

  // First, sort ranges by their minimum longitudes.
  if (n = ranges.length) {
    ranges.sort(rangeCompare);

    // Then, merge any ranges that overlap.
    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
      } else {
        merged.push(a = b);
      }
    }

    // Finally, find the largest gap between the merged ranges.
    // The final bounding box will be the inverse of this gap.
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
      b = merged[i];
      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0 = b[0], lambda1 = a[1];
    }
  }

  ranges = range = null;

  return lambda0 === Infinity || phi0 === Infinity
      ? [[NaN, NaN], [NaN, NaN]]
      : [[lambda0, phi0], [lambda1, phi1]];
});


/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stream__ = __webpack_require__(43);




var W0, W1,
    X0, Y0, Z0,
    X1, Y1, Z1,
    X2, Y2, Z2,
    lambda00, phi00, // first point
    x0, y0, z0; // previous point

var centroidStream = {
  sphere: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  }
};

// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  centroidPointCartesian(cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda), cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda), Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi));
}

function centroidPointCartesian(x, y, z) {
  ++W0;
  X0 += (x - X0) / W0;
  Y0 += (y - Y0) / W0;
  Z0 += (z - Z0) / W0;
}

function centroidLineStart() {
  centroidStream.point = centroidLinePointFirst;
}

function centroidLinePointFirst(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  x0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda);
  y0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda);
  z0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi);
  centroidStream.point = centroidLinePoint;
  centroidPointCartesian(x0, y0, z0);
}

function centroidLinePoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi),
      x = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda),
      y = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda),
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi),
      w = Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
  centroidStream.point = centroidRingPointFirst;
}

function centroidRingEnd() {
  centroidRingPoint(lambda00, phi00);
  centroidStream.point = centroidPoint;
}

function centroidRingPointFirst(lambda, phi) {
  lambda00 = lambda, phi00 = phi;
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  centroidStream.point = centroidRingPoint;
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi);
  x0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda);
  y0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda);
  z0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi);
  centroidPointCartesian(x0, y0, z0);
}

function centroidRingPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi),
      x = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(lambda),
      y = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(lambda),
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi),
      cx = y0 * z - z0 * y,
      cy = z0 * x - x0 * z,
      cz = x0 * y - y0 * x,
      m = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(cx * cx + cy * cy + cz * cz),
      w = Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(m), // line weight = angle
      v = m && -w / m; // area weight multiplier
  X2 += v * cx;
  Y2 += v * cy;
  Z2 += v * cz;
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

/* harmony default export */ __webpack_exports__["a"] = (function(object) {
  W0 = W1 =
  X0 = Y0 = Z0 =
  X1 = Y1 = Z1 =
  X2 = Y2 = Z2 = 0;
  Object(__WEBPACK_IMPORTED_MODULE_2__stream__["a" /* default */])(object, centroidStream);

  var x = X2,
      y = Y2,
      z = Z2,
      m = x * x + y * y + z * z;

  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
  if (m < __WEBPACK_IMPORTED_MODULE_0__math__["j" /* epsilon2 */]) {
    x = X1, y = Y1, z = Z1;
    // If the feature has zero length, fall back to arithmetic mean of point vectors.
    if (W1 < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) x = X0, y = Y0, z = Z0;
    m = x * x + y * y + z * z;
    // If the feature still has an undefined ccentroid, then return.
    if (m < __WEBPACK_IMPORTED_MODULE_0__math__["j" /* epsilon2 */]) return [NaN, NaN];
  }

  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(y, x) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(z / Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(m)) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
});


/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b, x0, y0, x1, y1) {
  var ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
  return true;
});


/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polygonContains__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__distance__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(6);




var containsObjectType = {
  Feature: function(object, point) {
    return containsGeometry(object.geometry, point);
  },
  FeatureCollection: function(object, point) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
    return false;
  }
};

var containsGeometryType = {
  Sphere: function() {
    return true;
  },
  Point: function(object, point) {
    return containsPoint(object.coordinates, point);
  },
  MultiPoint: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
    return false;
  },
  LineString: function(object, point) {
    return containsLine(object.coordinates, point);
  },
  MultiLineString: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsLine(coordinates[i], point)) return true;
    return false;
  },
  Polygon: function(object, point) {
    return containsPolygon(object.coordinates, point);
  },
  MultiPolygon: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
    return false;
  },
  GeometryCollection: function(object, point) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
    return false;
  }
};

function containsGeometry(geometry, point) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
      ? containsGeometryType[geometry.type](geometry, point)
      : false;
}

function containsPoint(coordinates, point) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates, point) === 0;
}

function containsLine(coordinates, point) {
  var ab = Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates[0], coordinates[1]),
      ao = Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates[0], point),
      ob = Object(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(point, coordinates[1]);
  return ao + ob <= ab + __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];
}

function containsPolygon(coordinates, point) {
  return !!Object(__WEBPACK_IMPORTED_MODULE_0__polygonContains__["a" /* default */])(coordinates.map(ringRadians), pointRadians(point));
}

function ringRadians(ring) {
  return ring = ring.map(pointRadians), ring.pop(), ring;
}

function pointRadians(point) {
  return [point[0] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */], point[1] * __WEBPACK_IMPORTED_MODULE_2__math__["r" /* radians */]];
}

/* harmony default export */ __webpack_exports__["a"] = (function(object, point) {
  return (object && containsObjectType.hasOwnProperty(object.type)
      ? containsObjectType[object.type]
      : containsGeometry)(object, point);
});


/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = graticule;
/* harmony export (immutable) */ __webpack_exports__["b"] = graticule10;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(6);



function graticuleX(y0, y1, dy) {
  var y = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(y0, y1 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */], dy).concat(y1);
  return function(x) { return y.map(function(y) { return [x, y]; }); };
}

function graticuleY(x0, x1, dx) {
  var x = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(x0, x1 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */], dx).concat(x1);
  return function(y) { return x.map(function(x) { return [x, y]; }); };
}

function graticule() {
  var x1, x0, X1, X0,
      y1, y0, Y1, Y0,
      dx = 10, dy = dx, DX = 90, DY = 360,
      x, y, X, Y,
      precision = 2.5;

  function graticule() {
    return {type: "MultiLineString", coordinates: lines()};
  }

  function lines() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(X0 / DX) * DX, X1, DX).map(X)
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(Y0 / DY) * DY, Y1, DY).map(Y))
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(x0 / dx) * dx, x1, dx).filter(function(x) { return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(x % DX) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]; }).map(x))
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* ceil */])(y0 / dy) * dy, y1, dy).filter(function(y) { return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(y % DY) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]; }).map(y));
  }

  graticule.lines = function() {
    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
  };

  graticule.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        X(X0).concat(
        Y(Y1).slice(1),
        X(X1).reverse().slice(1),
        Y(Y0).reverse().slice(1))
      ]
    };
  };

  graticule.extent = function(_) {
    if (!arguments.length) return graticule.extentMinor();
    return graticule.extentMajor(_).extentMinor(_);
  };

  graticule.extentMajor = function(_) {
    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
    X0 = +_[0][0], X1 = +_[1][0];
    Y0 = +_[0][1], Y1 = +_[1][1];
    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
    return graticule.precision(precision);
  };

  graticule.extentMinor = function(_) {
    if (!arguments.length) return [[x0, y0], [x1, y1]];
    x0 = +_[0][0], x1 = +_[1][0];
    y0 = +_[0][1], y1 = +_[1][1];
    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
    return graticule.precision(precision);
  };

  graticule.step = function(_) {
    if (!arguments.length) return graticule.stepMinor();
    return graticule.stepMajor(_).stepMinor(_);
  };

  graticule.stepMajor = function(_) {
    if (!arguments.length) return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule;
  };

  graticule.stepMinor = function(_) {
    if (!arguments.length) return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule;
  };

  graticule.precision = function(_) {
    if (!arguments.length) return precision;
    precision = +_;
    x = graticuleX(y0, y1, 90);
    y = graticuleY(x0, x1, precision);
    X = graticuleX(Y0, Y1, 90);
    Y = graticuleY(X0, X1, precision);
    return graticule;
  };

  return graticule
      .extentMajor([[-180, -90 + __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]], [180, 90 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]]])
      .extentMinor([[-180, -80 - __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]], [180, 80 + __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]]]);
}

function graticule10() {
  return graticule()();
}


/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var x0 = a[0] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      y0 = a[1] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      x1 = b[0] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      y1 = b[1] * __WEBPACK_IMPORTED_MODULE_0__math__["r" /* radians */],
      cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y0),
      sy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0),
      cy1 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y1),
      sy1 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y1),
      kx0 = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x0),
      ky0 = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x0),
      kx1 = cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x1),
      ky1 = cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x1),
      d = 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* haversin */])(y1 - y0) + cy0 * cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* haversin */])(x1 - x0))),
      k = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(d);

  var interpolate = d ? function(t) {
    var B = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(t *= d) / k,
        A = Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(d - t) / k,
        x = A * kx0 + B * kx1,
        y = A * ky0 + B * ky1,
        z = A * sy0 + B * sy1;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(y, x) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */],
      Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(z, Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + y * y)) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]
    ];
  } : function() {
    return [x0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], y0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
  };

  interpolate.distance = d;

  return interpolate;
});


/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stream__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__area__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bounds__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__centroid__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__measure__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__string__ = __webpack_require__(682);









/* harmony default export */ __webpack_exports__["a"] = (function(projection, context) {
  var pointRadius = 4.5,
      projectionStream,
      contextStream;

  function path(object) {
    if (object) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(contextStream));
    }
    return contextStream.result();
  }

  path.area = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_2__area__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_2__area__["a" /* default */].result();
  };

  path.measure = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_6__measure__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_6__measure__["a" /* default */].result();
  };

  path.bounds = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_3__bounds__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_3__bounds__["a" /* default */].result();
  };

  path.centroid = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_4__centroid__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_4__centroid__["a" /* default */].result();
  };

  path.projection = function(_) {
    return arguments.length ? (projectionStream = _ == null ? (projection = null, __WEBPACK_IMPORTED_MODULE_0__identity__["a" /* default */]) : (projection = _).stream, path) : projection;
  };

  path.context = function(_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new __WEBPACK_IMPORTED_MODULE_7__string__["a" /* default */]) : new __WEBPACK_IMPORTED_MODULE_5__context__["a" /* default */](context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path;
  };

  path.pointRadius = function(_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };

  return path.projection(projection).context(context);
});


/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(33);




var areaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    areaRingSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    x00,
    y00,
    x0,
    y0;

var areaStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: function() {
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    areaStream.lineStart = areaStream.lineEnd = areaStream.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
    areaSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(areaRingSum));
    areaRingSum.reset();
  },
  result: function() {
    var area = areaSum / 2;
    areaSum.reset();
    return area;
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaPointFirst(x, y) {
  areaStream.point = areaPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function areaPoint(x, y) {
  areaRingSum.add(y0 * x - x0 * y);
  x0 = x, y0 = y;
}

function areaRingEnd() {
  areaPoint(x00, y00);
}

/* harmony default export */ __webpack_exports__["a"] = (areaStream);


/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(6);


// TODO Enforce positive area for exterior, negative area for interior?

var X0 = 0,
    Y0 = 0,
    Z0 = 0,
    X1 = 0,
    Y1 = 0,
    Z1 = 0,
    X2 = 0,
    Y2 = 0,
    Z2 = 0,
    x00,
    y00,
    x0,
    y0;

var centroidStream = {
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.point = centroidPoint;
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  },
  result: function() {
    var centroid = Z2 ? [X2 / Z2, Y2 / Z2]
        : Z1 ? [X1 / Z1, Y1 / Z1]
        : Z0 ? [X0 / Z0, Y0 / Z0]
        : [NaN, NaN];
    X0 = Y0 = Z0 =
    X1 = Y1 = Z1 =
    X2 = Y2 = Z2 = 0;
    return centroid;
  }
};

function centroidPoint(x, y) {
  X0 += x;
  Y0 += y;
  ++Z0;
}

function centroidLineStart() {
  centroidStream.point = centroidPointFirstLine;
}

function centroidPointFirstLine(x, y) {
  centroidStream.point = centroidPointLine;
  centroidPoint(x0 = x, y0 = y);
}

function centroidPointLine(x, y) {
  var dx = x - x0, dy = y - y0, z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(dx * dx + dy * dy);
  X1 += z * (x0 + x) / 2;
  Y1 += z * (y0 + y) / 2;
  Z1 += z;
  centroidPoint(x0 = x, y0 = y);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

function centroidRingStart() {
  centroidStream.point = centroidPointFirstRing;
}

function centroidRingEnd() {
  centroidPointRing(x00, y00);
}

function centroidPointFirstRing(x, y) {
  centroidStream.point = centroidPointRing;
  centroidPoint(x00 = x0 = x, y00 = y0 = y);
}

function centroidPointRing(x, y) {
  var dx = x - x0,
      dy = y - y0,
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(dx * dx + dy * dy);

  X1 += z * (x0 + x) / 2;
  Y1 += z * (y0 + y) / 2;
  Z1 += z;

  z = y0 * x - x0 * y;
  X2 += z * (x0 + x);
  Y2 += z * (y0 + y);
  Z2 += z * 3;
  centroidPoint(x0 = x, y0 = y);
}

/* harmony default export */ __webpack_exports__["a"] = (centroidStream);


/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PathContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(33);



function PathContext(context) {
  this._context = context;
}

PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(_) {
    return this._radius = _, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._context.closePath();
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(x, y);
        this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(x, y);
        break;
      }
      default: {
        this._context.moveTo(x + this._radius, y);
        this._context.arc(x, y, this._radius, 0, __WEBPACK_IMPORTED_MODULE_0__math__["w" /* tau */]);
        break;
      }
    }
  },
  result: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */]
};


/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(33);




var lengthSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lengthRing,
    x00,
    y00,
    x0,
    y0;

var lengthStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: function() {
    lengthStream.point = lengthPointFirst;
  },
  lineEnd: function() {
    if (lengthRing) lengthPoint(x00, y00);
    lengthStream.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
  },
  polygonStart: function() {
    lengthRing = true;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var length = +lengthSum;
    lengthSum.reset();
    return length;
  }
};

function lengthPointFirst(x, y) {
  lengthStream.point = lengthPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function lengthPoint(x, y) {
  x0 -= x, y0 -= y;
  lengthSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* sqrt */])(x0 * x0 + y0 * y0));
  x0 = x, y0 = y;
}

/* harmony default export */ __webpack_exports__["a"] = (lengthStream);


/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PathString;
function PathString() {
  this._string = [];
}

PathString.prototype = {
  _circle: circle(4.5),
  pointRadius: function(_) {
    return this._circle = circle(_), this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._string.push("Z");
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._string.push("M", x, ",", y);
        this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", x, ",", y);
        break;
      }
      default: {
        this._string.push("M", x, ",", y, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var result = this._string.join("");
      this._string = [];
      return result;
    }
  }
};

function circle(radius) {
  return "m0," + radius
      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
      + "z";
}


/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(
  function() { return true; },
  clipAntimeridianLine,
  clipAntimeridianInterpolate,
  [-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], -__WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */]]
));

// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
  var lambda0 = NaN,
      phi0 = NaN,
      sign0 = NaN,
      clean; // no intersections

  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda1, phi1) {
      var sign1 = lambda1 > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */],
          delta = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda1 - lambda0);
      if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(delta - __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */]) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) { // line crosses a pole
        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */]);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        stream.point(lambda1, phi0);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */]) { // line crosses antimeridian
        if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda0 - sign0) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) lambda0 -= sign0 * __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]; // handle degeneracies
        if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda1 - sign1) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) lambda1 -= sign1 * __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */];
        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        clean = 0;
      }
      stream.point(lambda0 = lambda1, phi0 = phi1);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda0 = phi0 = NaN;
    },
    clean: function() {
      return 2 - clean; // if intersections, rejoin first and last segments
    }
  };
}

function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
  var cosPhi0,
      cosPhi1,
      sinLambda0Lambda1 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda0 - lambda1);
  return Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(sinLambda0Lambda1) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]
      ? Object(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* atan */])((Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi0) * (cosPhi1 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi1)) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda1)
          - Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(phi1) * (cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(phi0)) * Object(__WEBPACK_IMPORTED_MODULE_1__math__["t" /* sin */])(lambda0))
          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
      : (phi0 + phi1) / 2;
}

function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi;
  if (from == null) {
    phi = direction * __WEBPACK_IMPORTED_MODULE_1__math__["l" /* halfPi */];
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], phi);
    stream.point(0, phi);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], phi);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], 0);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], -phi);
    stream.point(0, -phi);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], -phi);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], 0);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */], phi);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(from[0] - to[0]) > __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */]) {
    var lambda = from[0] < to[0] ? __WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["o" /* pi */];
    phi = direction * lambda / 2;
    stream.point(-lambda, phi);
    stream.point(0, phi);
    stream.point(lambda, phi);
  } else {
    stream.point(to[0], to[1]);
  }
}


/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__circle__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pointEqual__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(304);






/* harmony default export */ __webpack_exports__["a"] = (function(radius, delta) {
  var cr = Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(radius),
      smallRadius = cr > 0,
      notHemisphere = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(cr) > __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */]; // TODO optimise for this common case

  function interpolate(from, to, direction, stream) {
    Object(__WEBPACK_IMPORTED_MODULE_1__circle__["a" /* circleStream */])(stream, radius, delta, direction, from, to);
  }

  function visible(lambda, phi) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(lambda) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* cos */])(phi) > cr;
  }

  // Takes a line and cuts into visible segments. Return values used for polygon
  // clipping: 0 - there were intersections or the line was empty; 1 - no
  // intersections 2 - there were intersections, and the first and last segments
  // should be rejoined.
  function clipLine(stream) {
    var point0, // previous point
        c0, // code for previous point
        v0, // visibility of previous point
        v00, // visibility of first point
        clean; // no intersections
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi) {
        var point1 = [lambda, phi],
            point2,
            v = visible(lambda, phi),
            c = smallRadius
              ? v ? 0 : code(lambda, phi)
              : v ? code(lambda + (lambda < 0 ? __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */] : -__WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */]), phi) : 0;
        if (!point0 && (v00 = v0 = v)) stream.lineStart();
        // Handle degeneracies.
        // TODO ignore if not clipping polygons.
        if (v !== v0) {
          point2 = intersect(point0, point1);
          if (Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point0, point2) || Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point1, point2)) {
            point1[0] += __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];
            point1[1] += __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];
            v = visible(point1[0], point1[1]);
          }
        }
        if (v !== v0) {
          clean = 0;
          if (v) {
            // outside going in
            stream.lineStart();
            point2 = intersect(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            // inside going out
            point2 = intersect(point0, point1);
            stream.point(point2[0], point2[1]);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          // If the codes for two points are different, or are both zero,
          // and there this segment intersects with the small circle.
          if (!(c & c0) && (t = intersect(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
            }
          }
        }
        if (v && (!point0 || !Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c;
      },
      lineEnd: function() {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | ((v00 && v0) << 1);
      }
    };
  }

  // Intersects the great circle between a and b with the clip circle.
  function intersect(a, b, two) {
    var pa = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(a),
        pb = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(b);

    // We have two planes, n1.p = d1 and n2.p = d2.
    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
    var n1 = [1, 0, 0], // normal
        n2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianCross */])(pa, pb),
        n2n2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(n2, n2),
        n1n2 = n2[0], // cartesianDot(n1, n2),
        determinant = n2n2 - n1n2 * n1n2;

    // Two polar points.
    if (!determinant) return !two && a;

    var c1 =  cr * n2n2 / determinant,
        c2 = -cr * n1n2 / determinant,
        n1xn2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianCross */])(n1, n2),
        A = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(n1, c1),
        B = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(n2, c2);
    Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianAddInPlace */])(A, B);

    // Solve |p(t)|^2 = 1.
    var u = n1xn2,
        w = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(A, u),
        uu = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(u, u),
        t2 = w * w - uu * (Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianDot */])(A, A) - 1);

    if (t2 < 0) return;

    var t = Object(__WEBPACK_IMPORTED_MODULE_2__math__["u" /* sqrt */])(t2),
        q = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(u, (-w - t) / uu);
    Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianAddInPlace */])(q, A);
    q = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" /* spherical */])(q);

    if (!two) return q;

    // Two intersection points.
    var lambda0 = a[0],
        lambda1 = b[0],
        phi0 = a[1],
        phi1 = b[1],
        z;

    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;

    var delta = lambda1 - lambda0,
        polar = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(delta - __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */]) < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */],
        meridian = polar || delta < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */];

    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;

    // Check that the first point is between a and b.
    if (meridian
        ? polar
          ? phi0 + phi1 > 0 ^ q[1] < (Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(q[0] - lambda0) < __WEBPACK_IMPORTED_MODULE_2__math__["i" /* epsilon */] ? phi0 : phi1)
          : phi0 <= q[1] && q[1] <= phi1
        : delta > __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */] ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
      var q1 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* cartesianScale */])(u, (-w + t) / uu);
      Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianAddInPlace */])(q1, A);
      return [q, Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" /* spherical */])(q1)];
    }
  }

  // Generates a 4-bit vector representing the location of a point relative to
  // the small circle's bounding box.
  function code(lambda, phi) {
    var r = smallRadius ? radius : __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */] - radius,
        code = 0;
    if (lambda < -r) code |= 1; // left
    else if (lambda > r) code |= 2; // right
    if (phi < -r) code |= 4; // below
    else if (phi > r) code |= 8; // above
    return code;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */])(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-__WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */], radius - __WEBPACK_IMPORTED_MODULE_2__math__["o" /* pi */]]);
});


/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transform__ = __webpack_require__(106);




var maxDepth = 16, // maximum depth of subdivision
    cosMinDistance = Object(__WEBPACK_IMPORTED_MODULE_1__math__["g" /* cos */])(30 * __WEBPACK_IMPORTED_MODULE_1__math__["r" /* radians */]); // cos(minimum angular distance)

/* harmony default export */ __webpack_exports__["a"] = (function(project, delta2) {
  return +delta2 ? resample(project, delta2) : resampleNone(project);
});

function resampleNone(project) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__transform__["b" /* transformer */])({
    point: function(x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}

function resample(project, delta2) {

  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
    var dx = x1 - x0,
        dy = y1 - y0,
        d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1,
          b = b0 + b1,
          c = c0 + c1,
          m = Object(__WEBPACK_IMPORTED_MODULE_1__math__["u" /* sqrt */])(a * a + b * b + c * c),
          phi2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* asin */])(c /= m),
          lambda2 = Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(c) - 1) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */] || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])(lambda0 - lambda1) < __WEBPACK_IMPORTED_MODULE_1__math__["i" /* epsilon */] ? (lambda0 + lambda1) / 2 : Object(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(b, a),
          p = project(lambda2, phi2),
          x2 = p[0],
          y2 = p[1],
          dx2 = x2 - x0,
          dy2 = y2 - y0,
          dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 // perpendicular projected distance
          || Object(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* abs */])((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda00, x00, y00, a00, b00, c00, // first point
        lambda0, x0, y0, a0, b0, c0; // previous point

    var resampleStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
    };

    function point(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }

    function lineStart() {
      x0 = NaN;
      resampleStream.point = linePoint;
      stream.lineStart();
    }

    function linePoint(lambda, phi) {
      var c = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])([lambda, phi]), p = project(lambda, phi);
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
      stream.point(x0, y0);
    }

    function lineEnd() {
      resampleStream.point = point;
      stream.lineEnd();
    }

    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }

    function ringPoint(lambda, phi) {
      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint;
    }

    function ringEnd() {
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }

    return resampleStream;
  };
}


/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cylindricalEqualAreaRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(6);


function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(phi) / cosPhi0];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(y * cosPhi0)];
  };

  return forward;
}


/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__albers__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conicEqualArea__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fit__ = __webpack_require__(161);





// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
  };
}

// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var cache,
      cacheStream,
      lower48 = Object(__WEBPACK_IMPORTED_MODULE_1__albers__["a" /* default */])(), lower48Point,
      alaska = Object(__WEBPACK_IMPORTED_MODULE_2__conicEqualArea__["b" /* default */])().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
      hawaii = Object(__WEBPACK_IMPORTED_MODULE_2__conicEqualArea__["b" /* default */])().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
      point, pointStream = {point: function(x, y) { point = [x, y]; }};

  function albersUsa(coordinates) {
    var x = coordinates[0], y = coordinates[1];
    return point = null,
        (lower48Point.point(x, y), point)
        || (alaskaPoint.point(x, y), point)
        || (hawaiiPoint.point(x, y), point);
  }

  albersUsa.invert = function(coordinates) {
    var k = lower48.scale(),
        t = lower48.translate(),
        x = (coordinates[0] - t[0]) / k,
        y = (coordinates[1] - t[1]) / k;
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
        : lower48).invert(coordinates);
  };

  albersUsa.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };

  albersUsa.precision = function(_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };

  albersUsa.scale = function(_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa.translate(lower48.translate());
  };

  albersUsa.translate = function(_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(), x = +_[0], y = +_[1];

    lower48Point = lower48
        .translate(_)
        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
        .stream(pointStream);

    alaskaPoint = alaska
        .translate([x - 0.307 * k, y + 0.201 * k])
        .clipExtent([[x - 0.425 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.120 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]], [x - 0.214 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.234 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]]])
        .stream(pointStream);

    hawaiiPoint = hawaii
        .translate([x - 0.205 * k, y + 0.212 * k])
        .clipExtent([[x - 0.214 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.166 * k + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]], [x - 0.115 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */], y + 0.234 * k - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]]])
        .stream(pointStream);

    return reset();
  };

  albersUsa.fitExtent = function(extent, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["a" /* fitExtent */])(albersUsa, extent, object);
  };

  albersUsa.fitSize = function(size, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["b" /* fitSize */])(albersUsa, size, object);
  };

  function reset() {
    cache = cacheStream = null;
    return albersUsa;
  }

  return albersUsa.scale(1070);
});


/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return azimuthalEqualAreaRaw; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(25);




var azimuthalEqualAreaRaw = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["b" /* azimuthalRaw */])(function(cxcy) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(2 / (1 + cxcy));
});

azimuthalEqualAreaRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */])(z / 2);
});

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(azimuthalEqualAreaRaw)
      .scale(124.75)
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return azimuthalEquidistantRaw; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(25);




var azimuthalEquidistantRaw = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["b" /* azimuthalRaw */])(function(c) {
  return (c = Object(__WEBPACK_IMPORTED_MODULE_0__math__["b" /* acos */])(c)) && c / Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(c);
});

azimuthalEquidistantRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return z;
});

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(azimuthalEquidistantRaw)
      .scale(79.4188)
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = conicConformalRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mercator__ = __webpack_require__(162);




function tany(y) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math__["v" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + y) / 2);
}

function conicConformalRaw(y0, y1) {
  var cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y0),
      n = y0 === y1 ? Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0) : Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(cy0 / Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y1)) / Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(tany(y1) / tany(y0)),
      f = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["p" /* pow */])(tany(y0), n) / n;

  if (!n) return __WEBPACK_IMPORTED_MODULE_2__mercator__["c" /* mercatorRaw */];

  function project(x, y) {
    if (f > 0) { if (y < -__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) y = -__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]; }
    else { if (y > __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) y = __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]; }
    var r = f / Object(__WEBPACK_IMPORTED_MODULE_0__math__["p" /* pow */])(tany(y), n);
    return [r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(n * x), f - r * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(n * x)];
  }

  project.invert = function(x, y) {
    var fy = f - y, r = Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(n) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + fy * fy);
    return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(fy)) / n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(fy), 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["p" /* pow */])(f / r, 1 / n)) - __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */]];
  };

  return project;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicConformalRaw)
      .scale(109.5)
      .parallels([30, 30]);
});


/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = conicEquidistantRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equirectangular__ = __webpack_require__(305);




function conicEquidistantRaw(y0, y1) {
  var cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y0),
      n = y0 === y1 ? Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y0) : (cy0 - Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y1)) / (y1 - y0),
      g = cy0 / n + y0;

  if (Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(n) < __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]) return __WEBPACK_IMPORTED_MODULE_2__equirectangular__["b" /* equirectangularRaw */];

  function project(x, y) {
    var gy = g - y, nx = n * x;
    return [gy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(nx), g - gy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(nx)];
  }

  project.invert = function(x, y) {
    var gy = g - y;
    return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math__["a" /* abs */])(gy)) / n * Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(gy), g - Object(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(n) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* sqrt */])(x * x + gy * gy)];
  };

  return project;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicEquidistantRaw)
      .scale(131.154)
      .center([0, 13.9389]);
});


/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = gnomonicRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(25);




function gnomonicRaw(x, y) {
  var cy = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y), k = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x) * cy;
  return [cy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x) / k, Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y) / k];
}

gnomonicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */]);

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(gnomonicRaw)
      .scale(144.049)
      .clipAngle(60);
});


/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clip_extent__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transform__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fit__ = __webpack_require__(161);





function scaleTranslate(kx, ky, tx, ty) {
  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */] : Object(__WEBPACK_IMPORTED_MODULE_2__transform__["b" /* transformer */])({
    point: function(x, y) {
      this.stream.point(x * kx + tx, y * ky + ty);
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */], // scale, translate and reflect
      x0 = null, y0, x1, y1, clip = __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */], // clip extent
      cache,
      cacheStream,
      projection;

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return projection = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = transform(clip(cacheStream = stream));
    },
    clipExtent: function(_) {
      return arguments.length ? (clip = _ == null ? (x0 = y0 = x1 = y1 = null, __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */]) : Object(__WEBPACK_IMPORTED_MODULE_0__clip_extent__["a" /* clipExtent */])(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
    },
    scale: function(_) {
      return arguments.length ? (transform = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
    },
    translate: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
    },
    reflectX: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
    },
    reflectY: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
    },
    fitExtent: function(extent, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["a" /* fitExtent */])(projection, extent, object);
    },
    fitSize: function(size, object) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__fit__["b" /* fitSize */])(projection, size, object);
    }
  };
});


/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = orthographicRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(25);




function orthographicRaw(x, y) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y) * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x), Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y)];
}

orthographicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* asin */]);

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(orthographicRaw)
      .scale(249.5)
      .clipAngle(90 + __WEBPACK_IMPORTED_MODULE_0__math__["i" /* epsilon */]);
});


/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = stereographicRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(25);




function stereographicRaw(x, y) {
  var cy = Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(y), k = 1 + Object(__WEBPACK_IMPORTED_MODULE_0__math__["g" /* cos */])(x) * cy;
  return [cy * Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(x) / k, Object(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* sin */])(y) / k];
}

stereographicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(z);
});

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(stereographicRaw)
      .scale(250)
      .clipAngle(142);
});


/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = transverseMercatorRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mercator__ = __webpack_require__(162);



function transverseMercatorRaw(lambda, phi) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["v" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */] + phi) / 2)), -lambda];
}

transverseMercatorRaw.invert = function(x, y) {
  return [-y, 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math__["k" /* exp */])(x)) - __WEBPACK_IMPORTED_MODULE_0__math__["l" /* halfPi */]];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var m = Object(__WEBPACK_IMPORTED_MODULE_1__mercator__["b" /* mercatorProjection */])(transverseMercatorRaw),
      center = m.center,
      rotate = m.rotate;

  m.center = function(_) {
    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
  };

  m.rotate = function(_) {
    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
  };

  return rotate([0, 0, 90])
      .scale(159.155);
});


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Geo = __webpack_require__(42);

var _utils = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ZoomableGroup = function (_Component) {
  _inherits(ZoomableGroup, _Component);

  function ZoomableGroup(props) {
    _classCallCheck(this, ZoomableGroup);

    var _this = _possibleConstructorReturn(this, (ZoomableGroup.__proto__ || Object.getPrototypeOf(ZoomableGroup)).call(this, props));

    var backdrop = (0, _utils.computeBackdrop)(props.projection, props.backdrop);

    _this.state = {
      mouseX: (0, _utils.calculateMousePosition)("x", props.projection, props, props.zoom, 1),
      mouseY: (0, _utils.calculateMousePosition)("y", props.projection, props, props.zoom, 1),
      mouseXStart: 0,
      mouseYStart: 0,
      isPressed: false,
      resizeFactorX: 1,
      resizeFactorY: 1,
      backdrop: {
        width: Math.round(backdrop.width),
        height: Math.round(backdrop.height),
        x: Math.round(backdrop.x),
        y: Math.round(backdrop.y)
      }
    };

    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
    _this.handleTouchStart = _this.handleTouchStart.bind(_this);
    _this.handleTouchMove = _this.handleTouchMove.bind(_this);
    _this.handleResize = _this.handleResize.bind(_this);

    return _this;
  }

  _createClass(ZoomableGroup, [{
    key: "handleMouseMove",
    value: function handleMouseMove(_ref) {
      var pageX = _ref.pageX,
          pageY = _ref.pageY;

      if (this.props.disablePanning) return;
      if (!this.state.isPressed) return;
      this.setState({
        mouseX: pageX - this.state.mouseXStart,
        mouseY: pageY - this.state.mouseYStart
      });
    }
  }, {
    key: "handleTouchMove",
    value: function handleTouchMove(_ref2) {
      var touches = _ref2.touches;

      this.handleMouseMove(touches[0]);
    }
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp() {
      if (this.props.disablePanning) return;
      if (!this.state.isPressed) return;
      this.setState({
        isPressed: false
      });
      if (!this.props.onMoveEnd) return;
      var _state = this.state,
          mouseX = _state.mouseX,
          mouseY = _state.mouseY,
          resizeFactorX = _state.resizeFactorX,
          resizeFactorY = _state.resizeFactorY;
      var _props = this.props,
          zoom = _props.zoom,
          width = _props.width,
          height = _props.height,
          projection = _props.projection,
          onMoveEnd = _props.onMoveEnd;

      var x = width / 2 - mouseX * resizeFactorX / zoom;
      var y = height / 2 - mouseY * resizeFactorY / zoom;
      var newCenter = projection.invert([x, y]);
      onMoveEnd(newCenter);
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(_ref3) {
      var pageX = _ref3.pageX,
          pageY = _ref3.pageY;

      if (this.props.disablePanning) return;
      var _state2 = this.state,
          mouseX = _state2.mouseX,
          mouseY = _state2.mouseY,
          resizeFactorX = _state2.resizeFactorX,
          resizeFactorY = _state2.resizeFactorY;
      var _props2 = this.props,
          zoom = _props2.zoom,
          width = _props2.width,
          height = _props2.height,
          projection = _props2.projection,
          onMoveStart = _props2.onMoveStart;

      this.setState({
        isPressed: true,
        mouseXStart: pageX - mouseX,
        mouseYStart: pageY - mouseY
      });
      if (!onMoveStart) return;
      var x = width / 2 - mouseX * resizeFactorX / zoom;
      var y = height / 2 - mouseY * resizeFactorY / zoom;
      var currentCenter = projection.invert([x, y]);
      onMoveStart(currentCenter);
    }
  }, {
    key: "handleTouchStart",
    value: function handleTouchStart(_ref4) {
      var touches = _ref4.touches;

      if (touches.length > 1) {
        this.handleMouseDown(touches[0]);
      } else {
        this.handleMouseUp();
      }
    }
  }, {
    key: "preventTouchScroll",
    value: function preventTouchScroll(evt) {
      if (evt.touches.length > 1) {
        evt.preventDefault();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _state3 = this.state,
          mouseX = _state3.mouseX,
          mouseY = _state3.mouseY,
          resizeFactorX = _state3.resizeFactorX,
          resizeFactorY = _state3.resizeFactorY;
      var _props3 = this.props,
          projection = _props3.projection,
          center = _props3.center,
          zoom = _props3.zoom;


      var zoomFactor = nextProps.zoom / zoom;
      var centerChanged = JSON.stringify(nextProps.center) !== JSON.stringify(center);

      this.setState({
        zoom: nextProps.zoom,
        mouseX: centerChanged ? (0, _utils.calculateMousePosition)("x", nextProps.projection, nextProps, nextProps.zoom, resizeFactorX) : mouseX * zoomFactor,
        mouseY: centerChanged ? (0, _utils.calculateMousePosition)("y", nextProps.projection, nextProps, nextProps.zoom, resizeFactorY) : mouseY * zoomFactor
      });
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      var _props4 = this.props,
          width = _props4.width,
          height = _props4.height,
          projection = _props4.projection,
          zoom = _props4.zoom;


      var resizeFactorX = (0, _utils.calculateResizeFactor)(this.zoomableGroupNode.parentNode.getBoundingClientRect().width, width);
      var resizeFactorY = (0, _utils.calculateResizeFactor)(this.zoomableGroupNode.parentNode.getBoundingClientRect().height, height);

      var xPercentageChange = 1 / resizeFactorX * this.state.resizeFactorX;
      var yPercentageChange = 1 / resizeFactorY * this.state.resizeFactorY;

      this.setState({
        resizeFactorX: resizeFactorX,
        resizeFactorY: resizeFactorY,
        mouseX: this.state.mouseX * xPercentageChange,
        mouseY: this.state.mouseY * yPercentageChange
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props5 = this.props,
          width = _props5.width,
          height = _props5.height,
          projection = _props5.projection,
          zoom = _props5.zoom;


      var resizeFactorX = (0, _utils.calculateResizeFactor)(this.zoomableGroupNode.parentNode.getBoundingClientRect().width, width);
      var resizeFactorY = (0, _utils.calculateResizeFactor)(this.zoomableGroupNode.parentNode.getBoundingClientRect().height, height);

      this.setState({
        resizeFactorX: resizeFactorX,
        resizeFactorY: resizeFactorY,
        mouseX: (0, _utils.calculateMousePosition)("x", projection, this.props, zoom, resizeFactorX),
        mouseY: (0, _utils.calculateMousePosition)("y", projection, this.props, zoom, resizeFactorY)
      });

      window.addEventListener("resize", this.handleResize);
      window.addEventListener("mouseup", this.handleMouseUp);
      this.zoomableGroupNode.addEventListener("touchmove", this.preventTouchScroll);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.handleResize);
      window.removeEventListener("mouseup", this.handleMouseUp);
      this.zoomableGroupNode.removeEventListener("touchmove", this.preventTouchScroll);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props6 = this.props,
          width = _props6.width,
          height = _props6.height,
          zoom = _props6.zoom,
          style = _props6.style,
          projection = _props6.projection,
          children = _props6.children;
      var _state4 = this.state,
          mouseX = _state4.mouseX,
          mouseY = _state4.mouseY,
          resizeFactorX = _state4.resizeFactorX,
          resizeFactorY = _state4.resizeFactorY;


      return _react2.default.createElement(
        "g",
        { className: "rsm-zoomable-group",
          ref: function ref(zoomableGroupNode) {
            return _this2.zoomableGroupNode = zoomableGroupNode;
          },
          transform: "\n           translate(\n             " + Math.round((width / 2 + resizeFactorX * mouseX) * 100) / 100 + "\n             " + Math.round((height / 2 + resizeFactorY * mouseY) * 100) / 100 + "\n           )\n           scale(" + zoom + ")\n           translate(" + -width / 2 + " " + -height / 2 + ")\n         ",
          onMouseMove: this.handleMouseMove,
          onMouseUp: this.handleMouseUp,
          onMouseDown: this.handleMouseDown,
          onTouchStart: this.handleTouchStart,
          onTouchMove: this.handleTouchMove,
          onTouchEnd: this.handleMouseUp,
          style: style
        },
        _react2.default.createElement("rect", {
          x: this.state.backdrop.x,
          y: this.state.backdrop.y,
          width: this.state.backdrop.width,
          height: this.state.backdrop.height,
          fill: "transparent",
          style: { strokeWidth: 0 }
        }),
        (0, _utils.createNewChildren)(children, this.props)
      );
    }
  }]);

  return ZoomableGroup;
}(_react.Component);

ZoomableGroup.defaultProps = {
  center: [0, 0],
  backdrop: {
    x: [-179.9, 179.9],
    y: [89.9, -89.9]
  },
  zoom: 1,
  disablePanning: false
};

exports.default = ZoomableGroup;

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Geo = __webpack_require__(42);

var _utils = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ZoomableGlobe = function (_Component) {
  _inherits(ZoomableGlobe, _Component);

  function ZoomableGlobe(props) {
    _classCallCheck(this, ZoomableGlobe);

    var _this = _possibleConstructorReturn(this, (ZoomableGlobe.__proto__ || Object.getPrototypeOf(ZoomableGlobe)).call(this, props));

    var initialRotation = props.projection.rotate();

    _this.state = {
      mouseX: 0,
      mouseY: 0,
      mouseXStart: 0,
      mouseYStart: 0,
      isPressed: false,
      rotation: [initialRotation[0] - props.center[0], initialRotation[1] - props.center[1], initialRotation[2]]
    };

    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
    _this.handleTouchStart = _this.handleTouchStart.bind(_this);
    _this.handleTouchMove = _this.handleTouchMove.bind(_this);
    return _this;
  }

  _createClass(ZoomableGlobe, [{
    key: "handleMouseMove",
    value: function handleMouseMove(_ref) {
      var pageX = _ref.pageX,
          pageY = _ref.pageY,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      if (this.props.disablePanning) return;
      if (!this.state.isPressed) return;

      var differenceX = clientX - this.state.mouseXStart;
      var differenceY = clientY - this.state.mouseYStart;

      this.setState({
        mouseX: clientX,
        mouseY: clientY,
        mouseXStart: clientX,
        mouseYStart: clientY,
        rotation: [this.state.rotation[0] + differenceX * this.props.sensitivity, this.state.rotation[1] - differenceY * this.props.sensitivity, this.state.rotation[2]]
      });
    }
  }, {
    key: "handleTouchMove",
    value: function handleTouchMove(_ref2) {
      var touches = _ref2.touches;

      this.handleMouseMove(touches[0]);
    }
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp() {
      if (this.props.disablePanning) return;
      if (!this.state.isPressed) return;
      this.setState({
        isPressed: false
      });
      if (!this.props.onMoveEnd) return;
      var newCenter = this.props.projection.invert([this.props.width / 2, this.props.height / 2]);
      this.props.onMoveEnd(newCenter);
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(_ref3) {
      var pageX = _ref3.pageX,
          pageY = _ref3.pageY,
          clientX = _ref3.clientX,
          clientY = _ref3.clientY;

      if (this.props.disablePanning) return;
      this.setState({
        isPressed: true,
        mouseXStart: clientX,
        mouseYStart: clientY
      });
      if (!this.props.onMoveStart) return;
      var currentCenter = this.props.projection.invert([this.props.width / 2, this.props.height / 2]);
      this.props.onMoveStart(currentCenter);
    }
  }, {
    key: "handleTouchStart",
    value: function handleTouchStart(_ref4) {
      var touches = _ref4.touches;

      if (touches.length > 1) {
        this.handleMouseDown(touches[0]);
      } else {
        this.handleMouseUp();
      }
    }
  }, {
    key: "preventTouchScroll",
    value: function preventTouchScroll(evt) {
      if (evt.touches.length > 1) {
        evt.preventDefault();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _state = this.state,
          mouseX = _state.mouseX,
          mouseY = _state.mouseY;
      var _props = this.props,
          projection = _props.projection,
          center = _props.center,
          zoom = _props.zoom;


      var zoomFactor = nextProps.zoom / zoom;
      var centerChanged = JSON.stringify(nextProps.center) !== JSON.stringify(center);

      this.setState({
        zoom: nextProps.zoom,
        rotation: centerChanged ? [-nextProps.center[0], -nextProps.center[1], this.state.rotation[2]] : this.state.rotation
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props2 = this.props,
          width = _props2.width,
          height = _props2.height,
          projection = _props2.projection,
          zoom = _props2.zoom;


      window.addEventListener("resize", this.handleResize);
      window.addEventListener("mouseup", this.handleMouseUp);
      this.zoomableGlobeNode.addEventListener("touchmove", this.preventTouchScroll);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.handleResize);
      window.removeEventListener("mouseup", this.handleMouseUp);
      this.zoomableGlobeNode.removeEventListener("touchmove", this.preventTouchScroll);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          width = _props3.width,
          height = _props3.height,
          zoom = _props3.zoom,
          style = _props3.style,
          projection = _props3.projection,
          children = _props3.children;
      var _state2 = this.state,
          mouseX = _state2.mouseX,
          mouseY = _state2.mouseY;


      return _react2.default.createElement(
        "g",
        { className: "rsm-zoomable-globe",
          ref: function ref(zoomableGlobeNode) {
            return _this2.zoomableGlobeNode = zoomableGlobeNode;
          },
          transform: "\n           translate(" + width / 2 + " " + height / 2 + ")\n           scale(" + zoom + ")\n           translate(" + -width / 2 + " " + -height / 2 + ")\n         ",
          onMouseMove: this.handleMouseMove,
          onMouseUp: this.handleMouseUp,
          onMouseDown: this.handleMouseDown,
          onTouchStart: this.handleTouchStart,
          onTouchMove: this.handleTouchMove,
          onTouchEnd: this.handleMouseUp,
          style: style
        },
        (0, _utils.createNewChildren)(children, {
          width: width,
          height: height,
          center: this.center,
          backdrop: this.backdrop,
          zoom: this.props.zoom,
          disablePanning: this.props.disablePanning,
          children: children,
          projection: projection.rotate(this.state.rotation)
        })
      );
    }
  }]);

  return ZoomableGlobe;
}(_react.Component);

ZoomableGlobe.defaultProps = {
  center: [0, 0],
  zoom: 1,
  disablePanning: false,
  sensitivity: 0.25
};

exports.default = ZoomableGlobe;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _topojsonClient = __webpack_require__(700);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Geographies = function (_Component) {
  _inherits(Geographies, _Component);

  function Geographies(props) {
    _classCallCheck(this, Geographies);

    var _this = _possibleConstructorReturn(this, (Geographies.__proto__ || Object.getPrototypeOf(Geographies)).call(this, props));

    _this.state = {
      geographyPaths: _this.shouldFetchGeographies(props.geography) ? [] : _this.parseGeographies(props.geography)
    };
    return _this;
  }

  _createClass(Geographies, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.geography !== this.props.geography) {
        if (this.shouldFetchGeographies(nextProps.geography)) {
          this.fetchGeographies(nextProps.geography);
        } else {
          this.setState({
            geographyPaths: this.parseGeographies(nextProps.geography)
          });
        }
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var geoPathsChanged = nextState.geographyPaths.length !== this.state.geographyPaths.length;
      return geoPathsChanged || nextProps.disableOptimization;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.geographyUrl || this.props.geographyPaths) {
        console.warn("You are using the deprecated geographyUrl or geographyPaths props. Use the new geography prop instead. Check out the new docs here: https://github.com/zcreativelabs/react-simple-maps#Geographies-component");
      }
      if (this.shouldFetchGeographies(this.props.geography)) {
        this.fetchGeographies(this.props.geography);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelPendingRequest();
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          projection = _props.projection,
          style = _props.style,
          children = _props.children;

      return _react2.default.createElement(
        "g",
        { className: "rsm-geographies", style: style },
        children(this.state.geographyPaths || [], projection)
      );
    }
  }, {
    key: "shouldFetchGeographies",
    value: function shouldFetchGeographies(geography) {
      return typeof geography === 'string';
    }
  }, {
    key: "parseGeographies",
    value: function parseGeographies(geography) {
      if (Array.isArray(geography)) {
        return geography;
      }

      if (Object.prototype.toString.call(geography) === '[object Object]') {
        return (0, _topojsonClient.feature)(geography, geography.objects[Object.keys(geography.objects)[0]]).features;
      }

      return [];
    }
  }, {
    key: "fetchGeographies",
    value: function fetchGeographies(geography) {
      var _this2 = this;

      var request = new XMLHttpRequest();
      request.open("GET", geography, true);
      request.onload = function () {
        if (request.status >= 200 && request.status < 400) {
          var geographyPaths = JSON.parse(request.responseText);
          _this2.setState({
            geographyPaths: _this2.parseGeographies(geographyPaths)
          }, function () {
            if (_this2.props.onGeographyPathsLoaded) {
              _this2.props.onGeographyPathsLoaded(String(request.status));
            }
          });
        } else {
          if (_this2.props.onGeographyPathsLoaded) {
            _this2.props.onGeographyPathsLoaded(String(request.status));
          }
        }
      };
      request.onerror = function () {
        console.log("There was a connection error...");
      };
      request.send();

      this.cancelPendingRequest();
      this._xhr = request;
    }
  }, {
    key: "cancelPendingRequest",
    value: function cancelPendingRequest() {
      if (this._xhr) {
        this._xhr.abort();
        this._xhr = null;
      }
    }
  }]);

  return Geographies;
}(_react.Component);

Geographies.defaultProps = {
  componentIdentifier: "Geographies",
  disableOptimization: false,
  geography: ""
};

exports.default = Geographies;

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_bbox__ = __webpack_require__(307);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bbox", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_feature__ = __webpack_require__(164);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "feature", function() { return __WEBPACK_IMPORTED_MODULE_1__src_feature__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_mesh__ = __webpack_require__(702);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mesh", function() { return __WEBPACK_IMPORTED_MODULE_2__src_mesh__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "meshArcs", function() { return __WEBPACK_IMPORTED_MODULE_2__src_mesh__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_merge__ = __webpack_require__(703);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return __WEBPACK_IMPORTED_MODULE_3__src_merge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mergeArcs", function() { return __WEBPACK_IMPORTED_MODULE_3__src_merge__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_neighbors__ = __webpack_require__(704);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "neighbors", function() { return __WEBPACK_IMPORTED_MODULE_4__src_neighbors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_quantize__ = __webpack_require__(706);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "quantize", function() { return __WEBPACK_IMPORTED_MODULE_5__src_quantize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_transform__ = __webpack_require__(163);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "transform", function() { return __WEBPACK_IMPORTED_MODULE_6__src_transform__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_untransform__ = __webpack_require__(707);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "untransform", function() { return __WEBPACK_IMPORTED_MODULE_7__src_untransform__["a"]; });










/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(array, n) {
  var t, j = array.length, i = j - n;
  while (i < --j) t = array[i], array[i++] = array[j], array[j] = t;
});


/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = meshArcs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__feature__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stitch__ = __webpack_require__(309);



/* harmony default export */ __webpack_exports__["a"] = (function(topology) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__feature__["b" /* object */])(topology, meshArcs.apply(this, arguments));
});

function meshArcs(topology, object, filter) {
  var arcs, i, n;
  if (arguments.length > 1) arcs = extractArcs(topology, object, filter);
  else for (i = 0, arcs = new Array(n = topology.arcs.length); i < n; ++i) arcs[i] = i;
  return {type: "MultiLineString", arcs: Object(__WEBPACK_IMPORTED_MODULE_1__stitch__["a" /* default */])(topology, arcs)};
}

function extractArcs(topology, object, filter) {
  var arcs = [],
      geomsByArc = [],
      geom;

  function extract0(i) {
    var j = i < 0 ? ~i : i;
    (geomsByArc[j] || (geomsByArc[j] = [])).push({i: i, g: geom});
  }

  function extract1(arcs) {
    arcs.forEach(extract0);
  }

  function extract2(arcs) {
    arcs.forEach(extract1);
  }

  function extract3(arcs) {
    arcs.forEach(extract2);
  }

  function geometry(o) {
    switch (geom = o, o.type) {
      case "GeometryCollection": o.geometries.forEach(geometry); break;
      case "LineString": extract1(o.arcs); break;
      case "MultiLineString": case "Polygon": extract2(o.arcs); break;
      case "MultiPolygon": extract3(o.arcs); break;
    }
  }

  geometry(object);

  geomsByArc.forEach(filter == null
      ? function(geoms) { arcs.push(geoms[0].i); }
      : function(geoms) { if (filter(geoms[0].g, geoms[geoms.length - 1].g)) arcs.push(geoms[0].i); });

  return arcs;
}


/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = mergeArcs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__feature__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stitch__ = __webpack_require__(309);



function planarRingArea(ring) {
  var i = -1, n = ring.length, a, b = ring[n - 1], area = 0;
  while (++i < n) a = b, b = ring[i], area += a[0] * b[1] - a[1] * b[0];
  return Math.abs(area); // Note: doubled area!
}

/* harmony default export */ __webpack_exports__["a"] = (function(topology) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__feature__["b" /* object */])(topology, mergeArcs.apply(this, arguments));
});

function mergeArcs(topology, objects) {
  var polygonsByArc = {},
      polygons = [],
      groups = [];

  objects.forEach(geometry);

  function geometry(o) {
    switch (o.type) {
      case "GeometryCollection": o.geometries.forEach(geometry); break;
      case "Polygon": extract(o.arcs); break;
      case "MultiPolygon": o.arcs.forEach(extract); break;
    }
  }

  function extract(polygon) {
    polygon.forEach(function(ring) {
      ring.forEach(function(arc) {
        (polygonsByArc[arc = arc < 0 ? ~arc : arc] || (polygonsByArc[arc] = [])).push(polygon);
      });
    });
    polygons.push(polygon);
  }

  function area(ring) {
    return planarRingArea(Object(__WEBPACK_IMPORTED_MODULE_0__feature__["b" /* object */])(topology, {type: "Polygon", arcs: [ring]}).coordinates[0]);
  }

  polygons.forEach(function(polygon) {
    if (!polygon._) {
      var group = [],
          neighbors = [polygon];
      polygon._ = 1;
      groups.push(group);
      while (polygon = neighbors.pop()) {
        group.push(polygon);
        polygon.forEach(function(ring) {
          ring.forEach(function(arc) {
            polygonsByArc[arc < 0 ? ~arc : arc].forEach(function(polygon) {
              if (!polygon._) {
                polygon._ = 1;
                neighbors.push(polygon);
              }
            });
          });
        });
      }
    }
  });

  polygons.forEach(function(polygon) {
    delete polygon._;
  });

  return {
    type: "MultiPolygon",
    arcs: groups.map(function(polygons) {
      var arcs = [], n;

      // Extract the exterior (unique) arcs.
      polygons.forEach(function(polygon) {
        polygon.forEach(function(ring) {
          ring.forEach(function(arc) {
            if (polygonsByArc[arc < 0 ? ~arc : arc].length < 2) {
              arcs.push(arc);
            }
          });
        });
      });

      // Stitch the arcs into one or more rings.
      arcs = Object(__WEBPACK_IMPORTED_MODULE_1__stitch__["a" /* default */])(topology, arcs);

      // If more than one ring is returned,
      // at most one of these rings can be the exterior;
      // choose the one with the greatest absolute area.
      if ((n = arcs.length) > 1) {
        for (var i = 1, k = area(arcs[0]), ki, t; i < n; ++i) {
          if ((ki = area(arcs[i])) > k) {
            t = arcs[0], arcs[0] = arcs[i], arcs[i] = t, k = ki;
          }
        }
      }

      return arcs;
    })
  };
}


/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bisect__ = __webpack_require__(705);


/* harmony default export */ __webpack_exports__["a"] = (function(objects) {
  var indexesByArc = {}, // arc index -> array of object indexes
      neighbors = objects.map(function() { return []; });

  function line(arcs, i) {
    arcs.forEach(function(a) {
      if (a < 0) a = ~a;
      var o = indexesByArc[a];
      if (o) o.push(i);
      else indexesByArc[a] = [i];
    });
  }

  function polygon(arcs, i) {
    arcs.forEach(function(arc) { line(arc, i); });
  }

  function geometry(o, i) {
    if (o.type === "GeometryCollection") o.geometries.forEach(function(o) { geometry(o, i); });
    else if (o.type in geometryType) geometryType[o.type](o.arcs, i);
  }

  var geometryType = {
    LineString: line,
    MultiLineString: polygon,
    Polygon: polygon,
    MultiPolygon: function(arcs, i) { arcs.forEach(function(arc) { polygon(arc, i); }); }
  };

  objects.forEach(geometry);

  for (var i in indexesByArc) {
    for (var indexes = indexesByArc[i], m = indexes.length, j = 0; j < m; ++j) {
      for (var k = j + 1; k < m; ++k) {
        var ij = indexes[j], ik = indexes[k], n;
        if ((n = neighbors[ij])[i = Object(__WEBPACK_IMPORTED_MODULE_0__bisect__["a" /* default */])(n, ik)] !== ik) n.splice(i, 0, ik);
        if ((n = neighbors[ik])[i = Object(__WEBPACK_IMPORTED_MODULE_0__bisect__["a" /* default */])(n, ij)] !== ij) n.splice(i, 0, ij);
      }
    }
  }

  return neighbors;
});


/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, x) {
  var lo = 0, hi = a.length;
  while (lo < hi) {
    var mid = lo + hi >>> 1;
    if (a[mid] < x) lo = mid + 1;
    else hi = mid;
  }
  return lo;
});


/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bbox__ = __webpack_require__(307);


/* harmony default export */ __webpack_exports__["a"] = (function(topology, n) {
  if (!((n = Math.floor(n)) >= 2)) throw new Error("n must be ≥2");
  if (topology.transform) throw new Error("already quantized");
  var bb = Object(__WEBPACK_IMPORTED_MODULE_0__bbox__["a" /* default */])(topology), name,
      dx = bb[0], kx = (bb[2] - dx) / (n - 1) || 1,
      dy = bb[1], ky = (bb[3] - dy) / (n - 1) || 1;

  function quantizePoint(p) {
    p[0] = Math.round((p[0] - dx) / kx);
    p[1] = Math.round((p[1] - dy) / ky);
  }

  function quantizeGeometry(o) {
    switch (o.type) {
      case "GeometryCollection": o.geometries.forEach(quantizeGeometry); break;
      case "Point": quantizePoint(o.coordinates); break;
      case "MultiPoint": o.coordinates.forEach(quantizePoint); break;
    }
  }

  topology.arcs.forEach(function(arc) {
    var i = 1,
        j = 1,
        n = arc.length,
        pi = arc[0],
        x0 = pi[0] = Math.round((pi[0] - dx) / kx),
        y0 = pi[1] = Math.round((pi[1] - dy) / ky),
        pj,
        x1,
        y1;

    for (; i < n; ++i) {
      pi = arc[i];
      x1 = Math.round((pi[0] - dx) / kx);
      y1 = Math.round((pi[1] - dy) / ky);
      if (x1 !== x0 || y1 !== y0) {
        pj = arc[j++];
        pj[0] = x1 - x0, x0 = x1;
        pj[1] = y1 - y0, y0 = y1;
      }
    }

    if (j < 2) {
      pj = arc[j++];
      pj[0] = 0;
      pj[1] = 0;
    }

    arc.length = j;
  });

  for (name in topology.objects) {
    quantizeGeometry(topology.objects[name]);
  }

  topology.transform = {
    scale: [kx, ky],
    translate: [dx, dy]
  };

  return topology;
});


/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity__ = __webpack_require__(308);


/* harmony default export */ __webpack_exports__["a"] = (function(topology) {
  if ((transform = topology.transform) == null) return __WEBPACK_IMPORTED_MODULE_0__identity__["a" /* default */];
  var transform,
      x0,
      y0,
      kx = transform.scale[0],
      ky = transform.scale[1],
      dx = transform.translate[0],
      dy = transform.translate[1];
  return function(point, i) {
    if (!i) x0 = y0 = 0;
    var x1 = Math.round((point[0] - dx) / kx),
        y1 = Math.round((point[1] - dy) / ky);
    point[0] = x1 - x0, x0 = x1;
    point[1] = y1 - y0, y0 = y1;
    return point;
  };
});


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Geo = __webpack_require__(42);

var _utils = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var pathCache = {};

var renderPath = function renderPath(cacheId, geography, projection, round, precision) {
  if (pathCache[cacheId]) return pathCache[cacheId];

  var pathString = cacheId ? pathCache[cacheId] ? pathCache[cacheId] : round ? (0, _utils.roundPath)((0, _d3Geo.geoPath)().projection(projection)(geography), precision) : (0, _d3Geo.geoPath)().projection(projection)(geography) : round ? (0, _utils.roundPath)((0, _d3Geo.geoPath)().projection(projection)(geography), precision) : (0, _d3Geo.geoPath)().projection(projection)(geography);

  if (cacheId) pathCache[cacheId] = pathString;

  return pathString;
};

var Geography = function (_Component) {
  _inherits(Geography, _Component);

  function Geography() {
    _classCallCheck(this, Geography);

    var _this = _possibleConstructorReturn(this, (Geography.__proto__ || Object.getPrototypeOf(Geography)).call(this));

    _this.state = {
      hover: false,
      pressed: false
    };

    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
    _this.handleMouseClick = _this.handleMouseClick.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    return _this;
  }

  _createClass(Geography, [{
    key: "handleMouseClick",
    value: function handleMouseClick(evt) {
      evt.persist();
      var _props = this.props,
          onClick = _props.onClick,
          geography = _props.geography;

      return onClick && onClick(geography, evt);
    }
  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter(evt) {
      evt.persist();
      var _props2 = this.props,
          onMouseEnter = _props2.onMouseEnter,
          geography = _props2.geography;

      this.setState({
        hover: true
      }, function () {
        return onMouseEnter && onMouseEnter(geography, evt);
      });
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(evt) {
      evt.persist();
      if (this.state.pressed) return;
      var _props3 = this.props,
          onMouseMove = _props3.onMouseMove,
          geography = _props3.geography;

      if (!this.state.hover) {
        this.setState({
          hover: true
        }, function () {
          return onMouseMove && onMouseMove(geography, evt);
        });
      } else if (onMouseMove) onMouseMove(geography, evt);else return;
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave(evt) {
      evt.persist();
      var _props4 = this.props,
          onMouseLeave = _props4.onMouseLeave,
          geography = _props4.geography;

      this.setState({
        hover: false,
        pressed: false
      }, function () {
        return onMouseLeave && onMouseLeave(geography, evt);
      });
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(evt) {
      evt.persist();
      var _props5 = this.props,
          onMouseDown = _props5.onMouseDown,
          geography = _props5.geography;

      this.setState({
        pressed: true
      }, function () {
        return onMouseDown && onMouseDown(geography, evt);
      });
    }
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp(evt) {
      evt.persist();
      var _props6 = this.props,
          onMouseUp = _props6.onMouseUp,
          geography = _props6.geography;

      this.setState({
        pressed: false
      }, function () {
        return onMouseUp && onMouseUp(geography, evt);
      });
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(evt) {
      evt.persist();
      var _props7 = this.props,
          onFocus = _props7.onFocus,
          geography = _props7.geography;

      this.setState({
        hover: true
      }, function () {
        return onFocus && onFocus(geography, evt);
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(evt) {
      evt.persist();
      var _props8 = this.props,
          onBlur = _props8.onBlur,
          geography = _props8.geography;

      this.setState({
        hover: false
      }, function () {
        return onBlur && onBlur(geography, evt);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props9 = this.props,
          geography = _props9.geography,
          projection = _props9.projection,
          round = _props9.round,
          cacheId = _props9.cacheId,
          precision = _props9.precision,
          tabable = _props9.tabable,
          style = _props9.style;
      var _state = this.state,
          hover = _state.hover,
          pressed = _state.pressed;


      var pathString = renderPath(cacheId, geography, projection, round, precision);

      var excludeProps = ["geography", "projection", "round", "cacheId", "precision", "tabable", "style", "onClick", "onMouseEnter", "onMouseMove", "onMouseLeave", "onMouseDown", "onMouseUp", "onFocus", "onBlur"];

      var restProps = Object.keys(this.props).filter(function (key) {
        return excludeProps.indexOf(key) === -1;
      }).reduce(function (obj, key) {
        obj[key] = _this2.props[key];
        return obj;
      }, {});

      return _react2.default.createElement("path", _extends({
        d: pathString,
        className: "rsm-geography" + (pressed ? " rsm-geography--pressed" : "") + (hover ? " rsm-geography--hover" : ""),
        style: style[pressed || hover ? pressed ? "pressed" : "hover" : "default"],
        onClick: this.handleMouseClick,
        onMouseEnter: this.handleMouseEnter,
        onMouseMove: this.handleMouseMove,
        onMouseLeave: this.handleMouseLeave,
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        tabIndex: tabable ? 0 : -1
      }, restProps));
    }
  }]);

  return Geography;
}(_react.Component);

Geography.defaultProps = {
  precision: 0.1,
  cacheId: null,
  round: false,
  tabable: true,
  style: {
    default: {},
    hover: {},
    pressed: {}
  }
};

exports.default = Geography;

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Geo = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Marker = function (_Component) {
  _inherits(Marker, _Component);

  function Marker() {
    _classCallCheck(this, Marker);

    var _this = _possibleConstructorReturn(this, (Marker.__proto__ || Object.getPrototypeOf(Marker)).call(this));

    _this.state = {
      hover: false,
      pressed: false
    };

    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
    _this.handleMouseClick = _this.handleMouseClick.bind(_this);
    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    return _this;
  }

  _createClass(Marker, [{
    key: "handleMouseEnter",
    value: function handleMouseEnter(evt) {
      evt.persist();
      var _props = this.props,
          onMouseEnter = _props.onMouseEnter,
          marker = _props.marker;

      this.setState({
        hover: true
      }, function () {
        return onMouseEnter && onMouseEnter(marker, evt);
      });
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(evt) {
      evt.persist();
      if (this.state.pressed) return;
      var _props2 = this.props,
          onMouseMove = _props2.onMouseMove,
          marker = _props2.marker;

      if (!this.state.hover) {
        this.setState({
          hover: true
        }, function () {
          return onMouseMove && onMouseMove(marker, evt);
        });
      } else if (onMouseMove) onMouseMove(marker, evt);else return;
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave(evt) {
      evt.persist();
      var _props3 = this.props,
          onMouseLeave = _props3.onMouseLeave,
          marker = _props3.marker;

      this.setState({
        hover: false
      }, function () {
        return onMouseLeave && onMouseLeave(marker, evt);
      });
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(evt) {
      evt.persist();
      var _props4 = this.props,
          onMouseDown = _props4.onMouseDown,
          marker = _props4.marker;

      this.setState({
        pressed: true
      }, function () {
        return onMouseDown && onMouseDown(marker, evt);
      });
    }
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp(evt) {
      evt.persist();
      var _props5 = this.props,
          onMouseUp = _props5.onMouseUp,
          marker = _props5.marker;

      this.setState({
        pressed: false
      }, function () {
        return onMouseUp && onMouseUp(marker, evt);
      });
    }
  }, {
    key: "handleMouseClick",
    value: function handleMouseClick(evt) {
      if (!this.props.onClick) return;
      evt.persist();
      var _props6 = this.props,
          onClick = _props6.onClick,
          marker = _props6.marker,
          projection = _props6.projection;

      return onClick && onClick(marker, projection(marker.coordinates), evt);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(evt) {
      evt.persist();
      var _props7 = this.props,
          onFocus = _props7.onFocus,
          marker = _props7.marker;

      this.setState({
        hover: true
      }, function () {
        return onFocus && onFocus(marker, evt);
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(evt) {
      evt.persist();
      var _props8 = this.props,
          onBlur = _props8.onBlur,
          marker = _props8.marker;

      this.setState({
        hover: false
      }, function () {
        return onBlur && onBlur(marker, evt);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props9 = this.props,
          projection = _props9.projection,
          marker = _props9.marker,
          style = _props9.style,
          tabable = _props9.tabable,
          zoom = _props9.zoom,
          children = _props9.children,
          preserveMarkerAspect = _props9.preserveMarkerAspect,
          width = _props9.width,
          height = _props9.height;
      var _state = this.state,
          pressed = _state.pressed,
          hover = _state.hover;


      var scale = preserveMarkerAspect ? " scale(" + 1 / zoom + ")" : "";
      var translation = projection(marker.coordinates);

      var lineString = {
        "type": "Feature",
        "geometry": {
          "type": "LineString",
          "coordinates": [projection.invert([width / 2, height / 2]), marker.coordinates]
        }
      };

      var isHidden = (0, _d3Geo.geoLength)(lineString) > 1.5708;

      return _react2.default.createElement(
        "g",
        { className: "rsm-marker" + (pressed ? " rsm-marker--pressed" : "") + (hover ? " rsm-marker--hover" : ""),
          transform: "translate(\n           " + translation[0] + "\n           " + translation[1] + "\n         ) " + scale,
          style: style[isHidden ? "hidden" : pressed || hover ? pressed ? "pressed" : "hover" : "default"],
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          onMouseDown: this.handleMouseDown,
          onMouseUp: this.handleMouseUp,
          onClick: this.handleMouseClick,
          onMouseMove: this.handleMouseMove,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          tabIndex: tabable ? 0 : -1
        },
        children
      );
    }
  }]);

  return Marker;
}(_react.Component);

Marker.defaultProps = {
  style: {
    default: {},
    hover: {},
    pressed: {}
  },
  marker: {
    coordinates: [0, 0]
  },
  tabable: true,
  preserveMarkerAspect: true
};

exports.default = Marker;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Markers = function (_Component) {
  _inherits(Markers, _Component);

  function Markers() {
    _classCallCheck(this, Markers);

    return _possibleConstructorReturn(this, (Markers.__proto__ || Object.getPrototypeOf(Markers)).apply(this, arguments));
  }

  _createClass(Markers, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          projection = _props.projection,
          style = _props.style,
          zoom = _props.zoom,
          width = _props.width,
          height = _props.height;

      return _react2.default.createElement(
        "g",
        { className: "rsm-markers", style: style },
        !children ? null : children.length === undefined ? _react2.default.cloneElement(children, {
          projection: projection,
          zoom: zoom,
          width: width,
          height: height
        }) : children.map(function (child, i) {
          return !child ? null : _react2.default.cloneElement(child, {
            key: child.key || "marker-" + i,
            projection: projection,
            zoom: zoom,
            width: width,
            height: height
          });
        })
      );
    }
  }]);

  return Markers;
}(_react.Component);

Markers.defaultProps = {
  componentIdentifier: "Markers"
};

exports.default = Markers;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Geo = __webpack_require__(42);

var _utils = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Annotation = function (_Component) {
  _inherits(Annotation, _Component);

  function Annotation() {
    _classCallCheck(this, Annotation);

    return _possibleConstructorReturn(this, (Annotation.__proto__ || Object.getPrototypeOf(Annotation)).apply(this, arguments));
  }

  _createClass(Annotation, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          projection = _props.projection,
          subject = _props.subject,
          style = _props.style,
          hiddenStyle = _props.hiddenStyle,
          dx = _props.dx,
          dy = _props.dy,
          zoom = _props.zoom,
          stroke = _props.stroke,
          strokeWidth = _props.strokeWidth,
          children = _props.children,
          curve = _props.curve,
          markerEnd = _props.markerEnd,
          width = _props.width,
          height = _props.height;


      var connectorPath = (0, _utils.createConnectorPath)(null, [-dx / zoom, -dy / zoom], curve);
      var translation = projection(subject);

      var lineString = {
        "type": "Feature",
        "geometry": {
          "type": "LineString",
          "coordinates": [projection.invert([width / 2, height / 2]), subject]
        }
      };

      var isHidden = (0, _d3Geo.geoLength)(lineString) > 1.5708;

      return _react2.default.createElement(
        "g",
        {
          className: "rsm-annotation",
          style: isHidden ? _extends({}, style, hiddenStyle) : style,
          transform: "translate(\n          " + (translation[0] + dx / zoom) + "\n          " + (translation[1] + dy / zoom) + "\n        )",
          textAnchor: (0, _utils.createTextAnchor)(dx)
        },
        children,
        _react2.default.createElement("path", {
          d: connectorPath,
          stroke: stroke,
          strokeWidth: strokeWidth,
          fill: "none",
          markerEnd: markerEnd
        })
      );
    }
  }]);

  return Annotation;
}(_react.Component);

Annotation.defaultProps = {
  curve: 0,
  markerEnd: "none",
  componentIdentifier: "Annotation",
  stroke: "#000000",
  strokeWidth: 1,
  zoom: 1
};

exports.default = Annotation;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Annotations = function (_Component) {
  _inherits(Annotations, _Component);

  function Annotations() {
    _classCallCheck(this, Annotations);

    return _possibleConstructorReturn(this, (Annotations.__proto__ || Object.getPrototypeOf(Annotations)).apply(this, arguments));
  }

  _createClass(Annotations, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          projection = _props.projection,
          style = _props.style,
          width = _props.width,
          height = _props.height;


      return _react2.default.createElement(
        "g",
        { className: "rsm-annotations", style: style },
        !children ? null : children.length === undefined ? _react2.default.cloneElement(children, {
          projection: projection,
          width: width,
          height: height
        }) : children.map(function (child, i) {
          return !child ? null : _react2.default.cloneElement(child, {
            key: child.key || "annotation-" + i,
            projection: projection,
            width: width,
            height: height
          });
        })
      );
    }
  }]);

  return Annotations;
}(_react.Component);

Annotations.defaultProps = {
  componentIdentifier: "Annotations"
};

exports.default = Annotations;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Geo = __webpack_require__(42);

var _utils = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var computeGraticule = function computeGraticule(projection, step) {
  return (0, _d3Geo.geoPath)().projection(projection)((0, _d3Geo.geoGraticule)().step(step)());
};

var computeOutline = function computeOutline(projection) {
  return (0, _d3Geo.geoPath)().projection(projection)((0, _d3Geo.geoGraticule)().outline());
};

var Graticule = function (_Component) {
  _inherits(Graticule, _Component);

  function Graticule() {
    _classCallCheck(this, Graticule);

    var _this = _possibleConstructorReturn(this, (Graticule.__proto__ || Object.getPrototypeOf(Graticule)).call(this));

    _this.state = {
      renderGraticule: false,
      graticulePath: "",
      outlinePath: ""
    };
    _this.renderGraticule = _this.renderGraticule.bind(_this);
    return _this;
  }

  _createClass(Graticule, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.renderGraticule();
    }
  }, {
    key: "renderGraticule",
    value: function renderGraticule() {
      var _props = this.props,
          step = _props.step,
          projection = _props.projection,
          round = _props.round,
          precision = _props.precision;


      this.setState({
        renderGraticule: true,
        graticulePath: round ? (0, _utils.roundPath)(computeGraticule(projection, step), precision) : computeGraticule(projection, step),
        outlinePath: round ? (0, _utils.roundPath)(computeOutline(projection), precision) : computeOutline(projection)
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _props2 = this.props,
          step = _props2.step,
          projection = _props2.projection,
          round = _props2.round,
          precision = _props2.precision,
          globe = _props2.globe;


      if (nextProps.round !== round || nextProps.precision !== precision || globe) {
        this.setState({
          graticulePath: nextProps.round ? (0, _utils.roundPath)(computeGraticule(projection, step), precision) : computeGraticule(projection, step),
          outlinePath: nextProps.round ? (0, _utils.roundPath)(computeOutline(projection), precision) : computeOutline(projection)
        });
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.disableOptimization;
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          zoom = _props3.zoom,
          style = _props3.style,
          outline = _props3.outline,
          fill = _props3.fill,
          stroke = _props3.stroke;


      return this.state.renderGraticule && _react2.default.createElement(
        "g",
        { className: "rsm-graticule" },
        _react2.default.createElement("path", {
          fill: fill,
          stroke: stroke,
          d: this.state.graticulePath,
          style: style
        }),
        outline && _react2.default.createElement("path", {
          fill: fill,
          stroke: stroke,
          d: this.state.outlinePath,
          style: style
        })
      );
    }
  }]);

  return Graticule;
}(_react.Component);

Graticule.defaultProps = {
  componentIdentifier: "Graticule",
  disableOptimization: true,
  globe: false,
  round: true,
  precision: 0.1,
  step: [10, 10],
  outline: true,
  stroke: "#DDDDDD",
  fill: "transparent",
  style: {
    pointerEvents: "none"
  }
};

exports.default = Graticule;

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export point */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ordinal__ = __webpack_require__(310);



function band() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_1__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}


/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(165);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (sortValues != null) array.sort(sortValues);
      return rollup != null ? rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])();
}

function setMap(map, key, value) {
  map.set(key, value);
}


/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(165);


function Set() {}

var proto = __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[__WEBPACK_IMPORTED_MODULE_0__map__["b" /* prefix */] + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

/* harmony default export */ __webpack_exports__["a"] = (set);


/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
});


/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
});


/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
});


/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(319);




function identity() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity().domain(domain);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["a" /* linearish */])(scale);
}


/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* unused harmony export Lab */
/* harmony export (immutable) */ __webpack_exports__["b"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(311);




var Kn = 18,
    Xn = 0.950470, // D65 standard referent
    Yn = 1,
    Zn = 1.088830,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */];
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var b = rgb2xyz(o.r),
      a = rgb2xyz(o.g),
      l = rgb2xyz(o.b),
      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Lab, lab, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function xyz2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2xyz(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hcl, hcl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));


/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(311);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Cubehelix, cubehelix, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return interpolateTransformCss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return interpolateTransformSvg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(725);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(726);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  value = value.matrix;
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* harmony default export */ __webpack_exports__["a"] = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(71);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hsl"])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hsl"])(end)).h),
        s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(71);



function lab(start, end) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["lab"])(start)).l, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["lab"])(end)).l),
      a = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(71);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hcl"])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hcl"])(end)).h),
        c = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(71);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(end)).h),
          s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* unused harmony default export */ var _unused_webpack_default_export = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(26);



/* harmony default export */ __webpack_exports__["a"] = (function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start, stop, count == null ? 10 : count),
      precision;
  specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["c" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* precisionPrefix */])(step, value))) specifier.precision = precision;
      return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["b" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
});


/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatPrefix; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(320);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});


/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});


/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  x = x.toPrecision(p);

  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (x[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      case "e": break out;
      default: if (i0 > 0) i0 = 0; break;
    }
  }

  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
});


/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(171);


/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});


/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3 - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(max) - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(step)) + 1;
});


/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nice__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(109);






function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(b);
}

function reinterpolate(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["b" /* default */])(deinterpolate, reinterpolate).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["ticks"])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(Object(__WEBPACK_IMPORTED_MODULE_3__nice__["a" /* default */])(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* copy */])(scale, log().base(base));
  };

  return scale;
}


/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export sqrt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(109);




function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent)))
        ? function(x) { return (raise(x, exponent) - a) / b; }
        : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function(t) { return raise(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, pow().exponent(exponent));
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["a" /* linearish */])(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}


/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(44);



function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["quantile"])(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["ascending"]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(70);




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2__linear__["a" /* linearish */])(scale);
}


/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(44);



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export milliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(13);


var millisecond = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (millisecond);
var milliseconds = millisecond.range;


/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export seconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(27);



var second = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */];
}, function(date) {
  return date.getUTCSeconds();
});

/* harmony default export */ __webpack_exports__["a"] = (second);
var seconds = second.range;


/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export minutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(27);



var minute = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */];
}, function(date) {
  return date.getMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (minute);
var minutes = minute.range;


/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(27);



var hour = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  var offset = date.getTimezoneOffset() * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */] % __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
  if (offset < 0) offset += __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
  date.setTime(Math.floor((+date - offset) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */] + offset);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
}, function(date) {
  return date.getHours();
});

/* harmony default export */ __webpack_exports__["a"] = (hour);
var hours = hour.range;


/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export days */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(27);



var day = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationDay */];
}, function(date) {
  return date.getDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (day);
var days = day.range;


/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return monday; });
/* unused harmony export tuesday */
/* unused harmony export wednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return thursday; });
/* unused harmony export friday */
/* unused harmony export saturday */
/* unused harmony export sundays */
/* unused harmony export mondays */
/* unused harmony export tuesdays */
/* unused harmony export wednesdays */
/* unused harmony export thursdays */
/* unused harmony export fridays */
/* unused harmony export saturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(27);



function weekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationWeek */];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export months */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(13);


var month = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (month);
var months = month.range;


/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export years */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(13);


var year = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (year);
var years = year.range;


/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(27);



var utcMinute = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */];
}, function(date) {
  return date.getUTCMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMinute);
var utcMinutes = utcMinute.range;


/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(27);



var utcHour = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
}, function(date) {
  return date.getUTCHours();
});

/* harmony default export */ __webpack_exports__["a"] = (utcHour);
var utcHours = utcHour.range;


/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(27);



var utcDay = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationDay */];
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;


/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcSunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcMonday; });
/* unused harmony export utcTuesday */
/* unused harmony export utcWednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcThursday; });
/* unused harmony export utcFriday */
/* unused harmony export utcSaturday */
/* unused harmony export utcSundays */
/* unused harmony export utcMondays */
/* unused harmony export utcTuesdays */
/* unused harmony export utcWednesdays */
/* unused harmony export utcThursdays */
/* unused harmony export utcFridays */
/* unused harmony export utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(27);



function utcWeekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationWeek */];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(13);


var utcMonth = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMonth);
var utcMonths = utcMonth.range;


/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(13);


var utcYear = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;


/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isoFormat__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultLocale__ = __webpack_require__(172);



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_1__defaultLocale__["c" /* utcParse */])(__WEBPACK_IMPORTED_MODULE_0__isoFormat__["a" /* isoSpecifier */]);

/* unused harmony default export */ var _unused_webpack_default_export = (parseIso);


/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(24);




/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__time__["a" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["v" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["q" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["u" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["l" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["m" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["o" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["r" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["n" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["b" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
});


/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(70);


function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__linear__["a" /* linearish */])(scale);
}


/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports = [{"MSN":"CLETPUS","coordinates":[{"MSN":"CLETPUS","YYYYMM":"1949-01-01T05:00:00.000Z","value":135451},{"MSN":"CLETPUS","YYYYMM":"1950-01-01T05:00:00.000Z","value":154519},{"MSN":"CLETPUS","YYYYMM":"1951-01-01T05:00:00.000Z","value":185203},{"MSN":"CLETPUS","YYYYMM":"1952-01-01T05:00:00.000Z","value":195436},{"MSN":"CLETPUS","YYYYMM":"1953-01-01T05:00:00.000Z","value":218846},{"MSN":"CLETPUS","YYYYMM":"1954-01-01T05:00:00.000Z","value":239145},{"MSN":"CLETPUS","YYYYMM":"1955-01-01T05:00:00.000Z","value":301362},{"MSN":"CLETPUS","YYYYMM":"1956-01-01T05:00:00.000Z","value":338503},{"MSN":"CLETPUS","YYYYMM":"1957-01-01T05:00:00.000Z","value":346386},{"MSN":"CLETPUS","YYYYMM":"1958-01-01T05:00:00.000Z","value":344365},{"MSN":"CLETPUS","YYYYMM":"1959-01-01T05:00:00.000Z","value":378424},{"MSN":"CLETPUS","YYYYMM":"1960-01-01T05:00:00.000Z","value":403067},{"MSN":"CLETPUS","YYYYMM":"1961-01-01T05:00:00.000Z","value":421870},{"MSN":"CLETPUS","YYYYMM":"1962-01-01T05:00:00.000Z","value":450249},{"MSN":"CLETPUS","YYYYMM":"1963-01-01T05:00:00.000Z","value":493926},{"MSN":"CLETPUS","YYYYMM":"1964-01-01T05:00:00.000Z","value":526230},{"MSN":"CLETPUS","YYYYMM":"1965-01-01T05:00:00.000Z","value":570925},{"MSN":"CLETPUS","YYYYMM":"1966-01-01T05:00:00.000Z","value":613474},{"MSN":"CLETPUS","YYYYMM":"1967-01-01T05:00:00.000Z","value":630483},{"MSN":"CLETPUS","YYYYMM":"1968-01-01T05:00:00.000Z","value":684904},{"MSN":"CLETPUS","YYYYMM":"1969-01-01T05:00:00.000Z","value":706001},{"MSN":"CLETPUS","YYYYMM":"1970-01-01T05:00:00.000Z","value":704394},{"MSN":"CLETPUS","YYYYMM":"1971-01-01T05:00:00.000Z","value":713102},{"MSN":"CLETPUS","YYYYMM":"1972-01-01T05:00:00.000Z","value":771131},{"MSN":"CLETPUS","YYYYMM":"1973-01-01T05:00:00.000Z","value":847651},{"MSN":"CLETPUS","YYYYMM":"1974-01-01T05:00:00.000Z","value":828432},{"MSN":"CLETPUS","YYYYMM":"1975-01-01T05:00:00.000Z","value":852786},{"MSN":"CLETPUS","YYYYMM":"1976-01-01T05:00:00.000Z","value":944390},{"MSN":"CLETPUS","YYYYMM":"1977-01-01T05:00:00.000Z","value":985218},{"MSN":"CLETPUS","YYYYMM":"1978-01-01T05:00:00.000Z","value":975742},{"MSN":"CLETPUS","YYYYMM":"1979-01-01T05:00:00.000Z","value":1075037},{"MSN":"CLETPUS","YYYYMM":"1980-01-01T05:00:00.000Z","value":1161562},{"MSN":"CLETPUS","YYYYMM":"1981-01-01T05:00:00.000Z","value":1203203},{"MSN":"CLETPUS","YYYYMM":"1982-01-01T05:00:00.000Z","value":1192004},{"MSN":"CLETPUS","YYYYMM":"1983-01-01T05:00:00.000Z","value":1259424},{"MSN":"CLETPUS","YYYYMM":"1984-01-01T05:00:00.000Z","value":1341680},{"MSN":"CLETPUS","YYYYMM":"1985-01-01T05:00:00.000Z","value":1402128},{"MSN":"CLETPUS","YYYYMM":"1986-01-01T05:00:00.000Z","value":1385831},{"MSN":"CLETPUS","YYYYMM":"1987-01-01T05:00:00.000Z","value":1463781},{"MSN":"CLETPUS","YYYYMM":"1988-01-01T05:00:00.000Z","value":1540652},{"MSN":"CLETPUS","YYYYMM":"1989-01-01T05:00:00.000Z","value":1583779},{"MSN":"CLETPUS","YYYYMM":"1990-01-01T05:00:00.000Z","value":1594011},{"MSN":"CLETPUS","YYYYMM":"1991-01-01T05:00:00.000Z","value":1590622},{"MSN":"CLETPUS","YYYYMM":"1992-01-01T05:00:00.000Z","value":1621206},{"MSN":"CLETPUS","YYYYMM":"1993-01-01T05:00:00.000Z","value":1690070},{"MSN":"CLETPUS","YYYYMM":"1994-01-01T05:00:00.000Z","value":1690693},{"MSN":"CLETPUS","YYYYMM":"1995-01-01T05:00:00.000Z","value":1709426},{"MSN":"CLETPUS","YYYYMM":"1996-01-01T05:00:00.000Z","value":1795195},{"MSN":"CLETPUS","YYYYMM":"1997-01-01T05:00:00.000Z","value":1845015},{"MSN":"CLETPUS","YYYYMM":"1998-01-01T05:00:00.000Z","value":1873515},{"MSN":"CLETPUS","YYYYMM":"1999-01-01T05:00:00.000Z","value":1881087},{"MSN":"CLETPUS","YYYYMM":"2000-01-01T05:00:00.000Z","value":1966264},{"MSN":"CLETPUS","YYYYMM":"2001-01-01T05:00:00.000Z","value":1903955},{"MSN":"CLETPUS","YYYYMM":"2002-01-01T05:00:00.000Z","value":1933130},{"MSN":"CLETPUS","YYYYMM":"2003-01-01T05:00:00.000Z","value":1973736},{"MSN":"CLETPUS","YYYYMM":"2004-01-01T05:00:00.000Z","value":1978300},{"MSN":"CLETPUS","YYYYMM":"2005-01-01T05:00:00.000Z","value":2012873},{"MSN":"CLETPUS","YYYYMM":"2006-01-01T05:00:00.000Z","value":1990511},{"MSN":"CLETPUS","YYYYMM":"2007-01-01T05:00:00.000Z","value":2016455},{"MSN":"CLETPUS","YYYYMM":"2008-01-01T05:00:00.000Z","value":1985801},{"MSN":"CLETPUS","YYYYMM":"2009-01-01T05:00:00.000Z","value":1755904},{"MSN":"CLETPUS","YYYYMM":"2010-01-01T05:00:00.000Z","value":1847290},{"MSN":"CLETPUS","YYYYMM":"2011-01-01T05:00:00.000Z","value":1733430},{"MSN":"CLETPUS","YYYYMM":"2012-01-01T05:00:00.000Z","value":1514042},{"MSN":"CLETPUS","YYYYMM":"2013-01-01T05:00:00.000Z","value":1581114},{"MSN":"CLETPUS","YYYYMM":"2014-01-01T05:00:00.000Z","value":1581710},{"MSN":"CLETPUS","YYYYMM":"2015-01-01T05:00:00.000Z","value":1352398},{"MSN":"CLETPUS","YYYYMM":"2016-01-01T05:00:00.000Z","value":1239148}]},{"MSN":"PAETPUS","coordinates":[{"MSN":"PAETPUS","YYYYMM":"1949-01-01T05:00:00.000Z","value":28547},{"MSN":"PAETPUS","YYYYMM":"1950-01-01T05:00:00.000Z","value":33734},{"MSN":"PAETPUS","YYYYMM":"1951-01-01T05:00:00.000Z","value":28712},{"MSN":"PAETPUS","YYYYMM":"1952-01-01T05:00:00.000Z","value":29749},{"MSN":"PAETPUS","YYYYMM":"1953-01-01T05:00:00.000Z","value":38404},{"MSN":"PAETPUS","YYYYMM":"1954-01-01T05:00:00.000Z","value":31520},{"MSN":"PAETPUS","YYYYMM":"1955-01-01T05:00:00.000Z","value":37138},{"MSN":"PAETPUS","YYYYMM":"1956-01-01T05:00:00.000Z","value":35946},{"MSN":"PAETPUS","YYYYMM":"1957-01-01T05:00:00.000Z","value":40499},{"MSN":"PAETPUS","YYYYMM":"1958-01-01T05:00:00.000Z","value":40371},{"MSN":"PAETPUS","YYYYMM":"1959-01-01T05:00:00.000Z","value":46839},{"MSN":"PAETPUS","YYYYMM":"1960-01-01T05:00:00.000Z","value":47986},{"MSN":"PAETPUS","YYYYMM":"1961-01-01T05:00:00.000Z","value":48519},{"MSN":"PAETPUS","YYYYMM":"1962-01-01T05:00:00.000Z","value":48879},{"MSN":"PAETPUS","YYYYMM":"1963-01-01T05:00:00.000Z","value":52001},{"MSN":"PAETPUS","YYYYMM":"1964-01-01T05:00:00.000Z","value":56953},{"MSN":"PAETPUS","YYYYMM":"1965-01-01T05:00:00.000Z","value":64801},{"MSN":"PAETPUS","YYYYMM":"1966-01-01T05:00:00.000Z","value":78926},{"MSN":"PAETPUS","YYYYMM":"1967-01-01T05:00:00.000Z","value":89270},{"MSN":"PAETPUS","YYYYMM":"1968-01-01T05:00:00.000Z","value":104275},{"MSN":"PAETPUS","YYYYMM":"1969-01-01T05:00:00.000Z","value":137847},{"MSN":"PAETPUS","YYYYMM":"1970-01-01T05:00:00.000Z","value":184183},{"MSN":"PAETPUS","YYYYMM":"1971-01-01T05:00:00.000Z","value":220225},{"MSN":"PAETPUS","YYYYMM":"1972-01-01T05:00:00.000Z","value":274295},{"MSN":"PAETPUS","YYYYMM":"1973-01-01T05:00:00.000Z","value":314342},{"MSN":"PAETPUS","YYYYMM":"1974-01-01T05:00:00.000Z","value":300930},{"MSN":"PAETPUS","YYYYMM":"1975-01-01T05:00:00.000Z","value":289094},{"MSN":"PAETPUS","YYYYMM":"1976-01-01T05:00:00.000Z","value":319988},{"MSN":"PAETPUS","YYYYMM":"1977-01-01T05:00:00.000Z","value":358178},{"MSN":"PAETPUS","YYYYMM":"1978-01-01T05:00:00.000Z","value":365060},{"MSN":"PAETPUS","YYYYMM":"1979-01-01T05:00:00.000Z","value":303525},{"MSN":"PAETPUS","YYYYMM":"1980-01-01T05:00:00.000Z","value":245994},{"MSN":"PAETPUS","YYYYMM":"1981-01-01T05:00:00.000Z","value":206420},{"MSN":"PAETPUS","YYYYMM":"1982-01-01T05:00:00.000Z","value":146797},{"MSN":"PAETPUS","YYYYMM":"1983-01-01T05:00:00.000Z","value":144498},{"MSN":"PAETPUS","YYYYMM":"1984-01-01T05:00:00.000Z","value":119807},{"MSN":"PAETPUS","YYYYMM":"1985-01-01T05:00:00.000Z","value":100202},{"MSN":"PAETPUS","YYYYMM":"1986-01-01T05:00:00.000Z","value":136584},{"MSN":"PAETPUS","YYYYMM":"1987-01-01T05:00:00.000Z","value":118492},{"MSN":"PAETPUS","YYYYMM":"1988-01-01T05:00:00.000Z","value":148899},{"MSN":"PAETPUS","YYYYMM":"1989-01-01T05:00:00.000Z","value":164358},{"MSN":"PAETPUS","YYYYMM":"1990-01-01T05:00:00.000Z","value":126460},{"MSN":"PAETPUS","YYYYMM":"1991-01-01T05:00:00.000Z","value":119751},{"MSN":"PAETPUS","YYYYMM":"1992-01-01T05:00:00.000Z","value":100154},{"MSN":"PAETPUS","YYYYMM":"1993-01-01T05:00:00.000Z","value":112788},{"MSN":"PAETPUS","YYYYMM":"1994-01-01T05:00:00.000Z","value":105900},{"MSN":"PAETPUS","YYYYMM":"1995-01-01T05:00:00.000Z","value":74554},{"MSN":"PAETPUS","YYYYMM":"1996-01-01T05:00:00.000Z","value":81411},{"MSN":"PAETPUS","YYYYMM":"1997-01-01T05:00:00.000Z","value":92554},{"MSN":"PAETPUS","YYYYMM":"1998-01-01T05:00:00.000Z","value":128800},{"MSN":"PAETPUS","YYYYMM":"1999-01-01T05:00:00.000Z","value":118060},{"MSN":"PAETPUS","YYYYMM":"2000-01-01T05:00:00.000Z","value":111220},{"MSN":"PAETPUS","YYYYMM":"2001-01-01T05:00:00.000Z","value":124880},{"MSN":"PAETPUS","YYYYMM":"2002-01-01T05:00:00.000Z","value":94567},{"MSN":"PAETPUS","YYYYMM":"2003-01-01T05:00:00.000Z","value":119405},{"MSN":"PAETPUS","YYYYMM":"2004-01-01T05:00:00.000Z","value":121145},{"MSN":"PAETPUS","YYYYMM":"2005-01-01T05:00:00.000Z","value":122225},{"MSN":"PAETPUS","YYYYMM":"2006-01-01T05:00:00.000Z","value":64166},{"MSN":"PAETPUS","YYYYMM":"2007-01-01T05:00:00.000Z","value":65738},{"MSN":"PAETPUS","YYYYMM":"2008-01-01T05:00:00.000Z","value":46242},{"MSN":"PAETPUS","YYYYMM":"2009-01-01T05:00:00.000Z","value":38936},{"MSN":"PAETPUS","YYYYMM":"2010-01-01T05:00:00.000Z","value":37061},{"MSN":"PAETPUS","YYYYMM":"2011-01-01T05:00:00.000Z","value":30182},{"MSN":"PAETPUS","YYYYMM":"2012-01-01T05:00:00.000Z","value":23189},{"MSN":"PAETPUS","YYYYMM":"2013-01-01T05:00:00.000Z","value":27164},{"MSN":"PAETPUS","YYYYMM":"2014-01-01T05:00:00.000Z","value":30231},{"MSN":"PAETPUS","YYYYMM":"2015-01-01T05:00:00.000Z","value":28248},{"MSN":"PAETPUS","YYYYMM":"2016-01-01T05:00:00.000Z","value":24204}]},{"MSN":"NGETPUS","coordinates":[{"MSN":"NGETPUS","YYYYMM":"1949-01-01T05:00:00.000Z","value":36966},{"MSN":"NGETPUS","YYYYMM":"1950-01-01T05:00:00.000Z","value":44559},{"MSN":"NGETPUS","YYYYMM":"1951-01-01T05:00:00.000Z","value":56615},{"MSN":"NGETPUS","YYYYMM":"1952-01-01T05:00:00.000Z","value":68453},{"MSN":"NGETPUS","YYYYMM":"1953-01-01T05:00:00.000Z","value":79790},{"MSN":"NGETPUS","YYYYMM":"1954-01-01T05:00:00.000Z","value":93688},{"MSN":"NGETPUS","YYYYMM":"1955-01-01T05:00:00.000Z","value":95285},{"MSN":"NGETPUS","YYYYMM":"1956-01-01T05:00:00.000Z","value":104037},{"MSN":"NGETPUS","YYYYMM":"1957-01-01T05:00:00.000Z","value":114212},{"MSN":"NGETPUS","YYYYMM":"1958-01-01T05:00:00.000Z","value":119759},{"MSN":"NGETPUS","YYYYMM":"1959-01-01T05:00:00.000Z","value":146619},{"MSN":"NGETPUS","YYYYMM":"1960-01-01T05:00:00.000Z","value":157969},{"MSN":"NGETPUS","YYYYMM":"1961-01-01T05:00:00.000Z","value":169285},{"MSN":"NGETPUS","YYYYMM":"1962-01-01T05:00:00.000Z","value":184301},{"MSN":"NGETPUS","YYYYMM":"1963-01-01T05:00:00.000Z","value":201602},{"MSN":"NGETPUS","YYYYMM":"1964-01-01T05:00:00.000Z","value":220038},{"MSN":"NGETPUS","YYYYMM":"1965-01-01T05:00:00.000Z","value":221559},{"MSN":"NGETPUS","YYYYMM":"1966-01-01T05:00:00.000Z","value":251151},{"MSN":"NGETPUS","YYYYMM":"1967-01-01T05:00:00.000Z","value":264805},{"MSN":"NGETPUS","YYYYMM":"1968-01-01T05:00:00.000Z","value":304432},{"MSN":"NGETPUS","YYYYMM":"1969-01-01T05:00:00.000Z","value":333278},{"MSN":"NGETPUS","YYYYMM":"1970-01-01T05:00:00.000Z","value":372890},{"MSN":"NGETPUS","YYYYMM":"1971-01-01T05:00:00.000Z","value":374030},{"MSN":"NGETPUS","YYYYMM":"1972-01-01T05:00:00.000Z","value":375747},{"MSN":"NGETPUS","YYYYMM":"1973-01-01T05:00:00.000Z","value":340858},{"MSN":"NGETPUS","YYYYMM":"1974-01-01T05:00:00.000Z","value":320065},{"MSN":"NGETPUS","YYYYMM":"1975-01-01T05:00:00.000Z","value":299778},{"MSN":"NGETPUS","YYYYMM":"1976-01-01T05:00:00.000Z","value":294623},{"MSN":"NGETPUS","YYYYMM":"1977-01-01T05:00:00.000Z","value":305504},{"MSN":"NGETPUS","YYYYMM":"1978-01-01T05:00:00.000Z","value":305390},{"MSN":"NGETPUS","YYYYMM":"1979-01-01T05:00:00.000Z","value":329485},{"MSN":"NGETPUS","YYYYMM":"1980-01-01T05:00:00.000Z","value":346239},{"MSN":"NGETPUS","YYYYMM":"1981-01-01T05:00:00.000Z","value":345777},{"MSN":"NGETPUS","YYYYMM":"1982-01-01T05:00:00.000Z","value":305259},{"MSN":"NGETPUS","YYYYMM":"1983-01-01T05:00:00.000Z","value":274098},{"MSN":"NGETPUS","YYYYMM":"1984-01-01T05:00:00.000Z","value":297393},{"MSN":"NGETPUS","YYYYMM":"1985-01-01T05:00:00.000Z","value":291945},{"MSN":"NGETPUS","YYYYMM":"1986-01-01T05:00:00.000Z","value":248508},{"MSN":"NGETPUS","YYYYMM":"1987-01-01T05:00:00.000Z","value":272620},{"MSN":"NGETPUS","YYYYMM":"1988-01-01T05:00:00.000Z","value":252800},{"MSN":"NGETPUS","YYYYMM":"1989-01-01T05:00:00.000Z","value":352628},{"MSN":"NGETPUS","YYYYMM":"1990-01-01T05:00:00.000Z","value":372765},{"MSN":"NGETPUS","YYYYMM":"1991-01-01T05:00:00.000Z","value":381553},{"MSN":"NGETPUS","YYYYMM":"1992-01-01T05:00:00.000Z","value":404074},{"MSN":"NGETPUS","YYYYMM":"1993-01-01T05:00:00.000Z","value":414926},{"MSN":"NGETPUS","YYYYMM":"1994-01-01T05:00:00.000Z","value":460218},{"MSN":"NGETPUS","YYYYMM":"1995-01-01T05:00:00.000Z","value":496057},{"MSN":"NGETPUS","YYYYMM":"1996-01-01T05:00:00.000Z","value":455055},{"MSN":"NGETPUS","YYYYMM":"1997-01-01T05:00:00.000Z","value":479398},{"MSN":"NGETPUS","YYYYMM":"1998-01-01T05:00:00.000Z","value":531257},{"MSN":"NGETPUS","YYYYMM":"1999-01-01T05:00:00.000Z","value":556396},{"MSN":"NGETPUS","YYYYMM":"2000-01-01T05:00:00.000Z","value":601038},{"MSN":"NGETPUS","YYYYMM":"2001-01-01T05:00:00.000Z","value":639129},{"MSN":"NGETPUS","YYYYMM":"2002-01-01T05:00:00.000Z","value":691005},{"MSN":"NGETPUS","YYYYMM":"2003-01-01T05:00:00.000Z","value":649907},{"MSN":"NGETPUS","YYYYMM":"2004-01-01T05:00:00.000Z","value":710100},{"MSN":"NGETPUS","YYYYMM":"2005-01-01T05:00:00.000Z","value":760960},{"MSN":"NGETPUS","YYYYMM":"2006-01-01T05:00:00.000Z","value":816440},{"MSN":"NGETPUS","YYYYMM":"2007-01-01T05:00:00.000Z","value":896589},{"MSN":"NGETPUS","YYYYMM":"2008-01-01T05:00:00.000Z","value":882980},{"MSN":"NGETPUS","YYYYMM":"2009-01-01T05:00:00.000Z","value":920978},{"MSN":"NGETPUS","YYYYMM":"2010-01-01T05:00:00.000Z","value":987697},{"MSN":"NGETPUS","YYYYMM":"2011-01-01T05:00:00.000Z","value":1013688},{"MSN":"NGETPUS","YYYYMM":"2012-01-01T05:00:00.000Z","value":1225894},{"MSN":"NGETPUS","YYYYMM":"2013-01-01T05:00:00.000Z","value":1124835},{"MSN":"NGETPUS","YYYYMM":"2014-01-01T05:00:00.000Z","value":1126608},{"MSN":"NGETPUS","YYYYMM":"2015-01-01T05:00:00.000Z","value":1333482},{"MSN":"NGETPUS","YYYYMM":"2016-01-01T05:00:00.000Z","value":1378306}]},{"MSN":"OJETPUS","coordinates":[{"MSN":"OJETPUS","YYYYMM":"1949-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1950-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1951-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1952-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1953-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1954-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1955-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1956-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1957-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1958-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1959-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1960-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1961-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1962-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1963-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1964-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1965-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1966-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1967-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1968-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1969-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1970-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1971-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1972-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1973-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1974-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1975-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1976-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1977-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1978-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1979-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1980-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1981-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1982-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1983-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1984-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1985-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1986-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1987-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1988-01-01T05:00:00.000Z","value":0},{"MSN":"OJETPUS","YYYYMM":"1989-01-01T05:00:00.000Z","value":7862},{"MSN":"OJETPUS","YYYYMM":"1990-01-01T05:00:00.000Z","value":10382},{"MSN":"OJETPUS","YYYYMM":"1991-01-01T05:00:00.000Z","value":11335},{"MSN":"OJETPUS","YYYYMM":"1992-01-01T05:00:00.000Z","value":13270},{"MSN":"OJETPUS","YYYYMM":"1993-01-01T05:00:00.000Z","value":12955},{"MSN":"OJETPUS","YYYYMM":"1994-01-01T05:00:00.000Z","value":13319},{"MSN":"OJETPUS","YYYYMM":"1995-01-01T05:00:00.000Z","value":13869},{"MSN":"OJETPUS","YYYYMM":"1996-01-01T05:00:00.000Z","value":14355},{"MSN":"OJETPUS","YYYYMM":"1997-01-01T05:00:00.000Z","value":13350},{"MSN":"OJETPUS","YYYYMM":"1998-01-01T05:00:00.000Z","value":13492},{"MSN":"OJETPUS","YYYYMM":"1999-01-01T05:00:00.000Z","value":14125},{"MSN":"OJETPUS","YYYYMM":"2000-01-01T05:00:00.000Z","value":13954},{"MSN":"OJETPUS","YYYYMM":"2001-01-01T05:00:00.000Z","value":9039},{"MSN":"OJETPUS","YYYYMM":"2002-01-01T05:00:00.000Z","value":11462},{"MSN":"OJETPUS","YYYYMM":"2003-01-01T05:00:00.000Z","value":15600},{"MSN":"OJETPUS","YYYYMM":"2004-01-01T05:00:00.000Z","value":15252},{"MSN":"OJETPUS","YYYYMM":"2005-01-01T05:00:00.000Z","value":13464},{"MSN":"OJETPUS","YYYYMM":"2006-01-01T05:00:00.000Z","value":14176},{"MSN":"OJETPUS","YYYYMM":"2007-01-01T05:00:00.000Z","value":13453},{"MSN":"OJETPUS","YYYYMM":"2008-01-01T05:00:00.000Z","value":11706},{"MSN":"OJETPUS","YYYYMM":"2009-01-01T05:00:00.000Z","value":10632},{"MSN":"OJETPUS","YYYYMM":"2010-01-01T05:00:00.000Z","value":11312},{"MSN":"OJETPUS","YYYYMM":"2011-01-01T05:00:00.000Z","value":11566},{"MSN":"OJETPUS","YYYYMM":"2012-01-01T05:00:00.000Z","value":11897},{"MSN":"OJETPUS","YYYYMM":"2013-01-01T05:00:00.000Z","value":12852},{"MSN":"OJETPUS","YYYYMM":"2014-01-01T05:00:00.000Z","value":12021},{"MSN":"OJETPUS","YYYYMM":"2015-01-01T05:00:00.000Z","value":13116},{"MSN":"OJETPUS","YYYYMM":"2016-01-01T05:00:00.000Z","value":12807}]},{"MSN":"NUETPUS","coordinates":[{"MSN":"NUETPUS","YYYYMM":"1949-01-01T05:00:00.000Z","value":0},{"MSN":"NUETPUS","YYYYMM":"1950-01-01T05:00:00.000Z","value":0},{"MSN":"NUETPUS","YYYYMM":"1951-01-01T05:00:00.000Z","value":0},{"MSN":"NUETPUS","YYYYMM":"1952-01-01T05:00:00.000Z","value":0},{"MSN":"NUETPUS","YYYYMM":"1953-01-01T05:00:00.000Z","value":0},{"MSN":"NUETPUS","YYYYMM":"1954-01-01T05:00:00.000Z","value":0},{"MSN":"NUETPUS","YYYYMM":"1955-01-01T05:00:00.000Z","value":0},{"MSN":"NUETPUS","YYYYMM":"1956-01-01T05:00:00.000Z","value":0},{"MSN":"NUETPUS","YYYYMM":"1957-01-01T05:00:00.000Z","value":9},{"MSN":"NUETPUS","YYYYMM":"1958-01-01T05:00:00.000Z","value":164},{"MSN":"NUETPUS","YYYYMM":"1959-01-01T05:00:00.000Z","value":188},{"MSN":"NUETPUS","YYYYMM":"1960-01-01T05:00:00.000Z","value":518},{"MSN":"NUETPUS","YYYYMM":"1961-01-01T05:00:00.000Z","value":1692},{"MSN":"NUETPUS","YYYYMM":"1962-01-01T05:00:00.000Z","value":2269},{"MSN":"NUETPUS","YYYYMM":"1963-01-01T05:00:00.000Z","value":3211},{"MSN":"NUETPUS","YYYYMM":"1964-01-01T05:00:00.000Z","value":3342},{"MSN":"NUETPUS","YYYYMM":"1965-01-01T05:00:00.000Z","value":3656},{"MSN":"NUETPUS","YYYYMM":"1966-01-01T05:00:00.000Z","value":5519},{"MSN":"NUETPUS","YYYYMM":"1967-01-01T05:00:00.000Z","value":7655},{"MSN":"NUETPUS","YYYYMM":"1968-01-01T05:00:00.000Z","value":12528},{"MSN":"NUETPUS","YYYYMM":"1969-01-01T05:00:00.000Z","value":13927},{"MSN":"NUETPUS","YYYYMM":"1970-01-01T05:00:00.000Z","value":21804},{"MSN":"NUETPUS","YYYYMM":"1971-01-01T05:00:00.000Z","value":38104},{"MSN":"NUETPUS","YYYYMM":"1972-01-01T05:00:00.000Z","value":54091},{"MSN":"NUETPUS","YYYYMM":"1973-01-01T05:00:00.000Z","value":83479},{"MSN":"NUETPUS","YYYYMM":"1974-01-01T05:00:00.000Z","value":113975},{"MSN":"NUETPUS","YYYYMM":"1975-01-01T05:00:00.000Z","value":172505},{"MSN":"NUETPUS","YYYYMM":"1976-01-01T05:00:00.000Z","value":191103},{"MSN":"NUETPUS","YYYYMM":"1977-01-01T05:00:00.000Z","value":250883},{"MSN":"NUETPUS","YYYYMM":"1978-01-01T05:00:00.000Z","value":276403},{"MSN":"NUETPUS","YYYYMM":"1979-01-01T05:00:00.000Z","value":255154},{"MSN":"NUETPUS","YYYYMM":"1980-01-01T05:00:00.000Z","value":251115},{"MSN":"NUETPUS","YYYYMM":"1981-01-01T05:00:00.000Z","value":272673},{"MSN":"NUETPUS","YYYYMM":"1982-01-01T05:00:00.000Z","value":282773},{"MSN":"NUETPUS","YYYYMM":"1983-01-01T05:00:00.000Z","value":293677},{"MSN":"NUETPUS","YYYYMM":"1984-01-01T05:00:00.000Z","value":327633},{"MSN":"NUETPUS","YYYYMM":"1985-01-01T05:00:00.000Z","value":383690},{"MSN":"NUETPUS","YYYYMM":"1986-01-01T05:00:00.000Z","value":414038},{"MSN":"NUETPUS","YYYYMM":"1987-01-01T05:00:00.000Z","value":455270},{"MSN":"NUETPUS","YYYYMM":"1988-01-01T05:00:00.000Z","value":526973},{"MSN":"NUETPUS","YYYYMM":"1989-01-01T05:00:00.000Z","value":529354},{"MSN":"NUETPUS","YYYYMM":"1990-01-01T05:00:00.000Z","value":576861},{"MSN":"NUETPUS","YYYYMM":"1991-01-01T05:00:00.000Z","value":612565},{"MSN":"NUETPUS","YYYYMM":"1992-01-01T05:00:00.000Z","value":618776},{"MSN":"NUETPUS","YYYYMM":"1993-01-01T05:00:00.000Z","value":610291},{"MSN":"NUETPUS","YYYYMM":"1994-01-01T05:00:00.000Z","value":640439},{"MSN":"NUETPUS","YYYYMM":"1995-01-01T05:00:00.000Z","value":673402},{"MSN":"NUETPUS","YYYYMM":"1996-01-01T05:00:00.000Z","value":674728},{"MSN":"NUETPUS","YYYYMM":"1997-01-01T05:00:00.000Z","value":628644},{"MSN":"NUETPUS","YYYYMM":"1998-01-01T05:00:00.000Z","value":673702},{"MSN":"NUETPUS","YYYYMM":"1999-01-01T05:00:00.000Z","value":728254},{"MSN":"NUETPUS","YYYYMM":"2000-01-01T05:00:00.000Z","value":753892},{"MSN":"NUETPUS","YYYYMM":"2001-01-01T05:00:00.000Z","value":768826},{"MSN":"NUETPUS","YYYYMM":"2002-01-01T05:00:00.000Z","value":780064},{"MSN":"NUETPUS","YYYYMM":"2003-01-01T05:00:00.000Z","value":763732},{"MSN":"NUETPUS","YYYYMM":"2004-01-01T05:00:00.000Z","value":788528},{"MSN":"NUETPUS","YYYYMM":"2005-01-01T05:00:00.000Z","value":781986},{"MSN":"NUETPUS","YYYYMM":"2006-01-01T05:00:00.000Z","value":787218},{"MSN":"NUETPUS","YYYYMM":"2007-01-01T05:00:00.000Z","value":806424},{"MSN":"NUETPUS","YYYYMM":"2008-01-01T05:00:00.000Z","value":806208},{"MSN":"NUETPUS","YYYYMM":"2009-01-01T05:00:00.000Z","value":798854},{"MSN":"NUETPUS","YYYYMM":"2010-01-01T05:00:00.000Z","value":806968},{"MSN":"NUETPUS","YYYYMM":"2011-01-01T05:00:00.000Z","value":790204},{"MSN":"NUETPUS","YYYYMM":"2012-01-01T05:00:00.000Z","value":769331},{"MSN":"NUETPUS","YYYYMM":"2013-01-01T05:00:00.000Z","value":789016},{"MSN":"NUETPUS","YYYYMM":"2014-01-01T05:00:00.000Z","value":797165},{"MSN":"NUETPUS","YYYYMM":"2015-01-01T05:00:00.000Z","value":797177},{"MSN":"NUETPUS","YYYYMM":"2016-01-01T05:00:00.000Z","value":805693}]},{"MSN":"HPETPUS","coordinates":[{"MSN":"HPETPUS","YYYYMM":"1949-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1950-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1951-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1952-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1953-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1954-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1955-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1956-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1957-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1958-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1959-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1960-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1961-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1962-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1963-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1964-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1965-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1966-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1967-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1968-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1969-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1970-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1971-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1972-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1973-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1974-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1975-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1976-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1977-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1978-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1979-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1980-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1981-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1982-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1983-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1984-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1985-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1986-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1987-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1988-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1989-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1990-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1991-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1992-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1993-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1994-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1995-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1996-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1997-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1998-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"1999-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"2000-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"2001-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"2002-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"2003-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"2004-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"2005-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"2006-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"2007-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"2008-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"2009-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"2010-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"2011-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"2012-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"2013-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"2014-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"2015-01-01T05:00:00.000Z","value":0},{"MSN":"HPETPUS","YYYYMM":"2016-01-01T05:00:00.000Z","value":0}]},{"MSN":"HVETPUS","coordinates":[{"MSN":"HVETPUS","YYYYMM":"1949-01-01T05:00:00.000Z","value":94772},{"MSN":"HVETPUS","YYYYMM":"1950-01-01T05:00:00.000Z","value":100884},{"MSN":"HVETPUS","YYYYMM":"1951-01-01T05:00:00.000Z","value":104376},{"MSN":"HVETPUS","YYYYMM":"1952-01-01T05:00:00.000Z","value":109708},{"MSN":"HVETPUS","YYYYMM":"1953-01-01T05:00:00.000Z","value":109617},{"MSN":"HVETPUS","YYYYMM":"1954-01-01T05:00:00.000Z","value":111639},{"MSN":"HVETPUS","YYYYMM":"1955-01-01T05:00:00.000Z","value":116235},{"MSN":"HVETPUS","YYYYMM":"1956-01-01T05:00:00.000Z","value":125236},{"MSN":"HVETPUS","YYYYMM":"1957-01-01T05:00:00.000Z","value":133357},{"MSN":"HVETPUS","YYYYMM":"1958-01-01T05:00:00.000Z","value":143614},{"MSN":"HVETPUS","YYYYMM":"1959-01-01T05:00:00.000Z","value":141154},{"MSN":"HVETPUS","YYYYMM":"1960-01-01T05:00:00.000Z","value":149440},{"MSN":"HVETPUS","YYYYMM":"1961-01-01T05:00:00.000Z","value":155536},{"MSN":"HVETPUS","YYYYMM":"1962-01-01T05:00:00.000Z","value":172015},{"MSN":"HVETPUS","YYYYMM":"1963-01-01T05:00:00.000Z","value":168990},{"MSN":"HVETPUS","YYYYMM":"1964-01-01T05:00:00.000Z","value":180301},{"MSN":"HVETPUS","YYYYMM":"1965-01-01T05:00:00.000Z","value":196984},{"MSN":"HVETPUS","YYYYMM":"1966-01-01T05:00:00.000Z","value":197937},{"MSN":"HVETPUS","YYYYMM":"1967-01-01T05:00:00.000Z","value":224948},{"MSN":"HVETPUS","YYYYMM":"1968-01-01T05:00:00.000Z","value":225873},{"MSN":"HVETPUS","YYYYMM":"1969-01-01T05:00:00.000Z","value":253468},{"MSN":"HVETPUS","YYYYMM":"1970-01-01T05:00:00.000Z","value":250957},{"MSN":"HVETPUS","YYYYMM":"1971-01-01T05:00:00.000Z","value":269531},{"MSN":"HVETPUS","YYYYMM":"1972-01-01T05:00:00.000Z","value":275928},{"MSN":"HVETPUS","YYYYMM":"1973-01-01T05:00:00.000Z","value":275430},{"MSN":"HVETPUS","YYYYMM":"1974-01-01T05:00:00.000Z","value":304211},{"MSN":"HVETPUS","YYYYMM":"1975-01-01T05:00:00.000Z","value":303152},{"MSN":"HVETPUS","YYYYMM":"1976-01-01T05:00:00.000Z","value":286924},{"MSN":"HVETPUS","YYYYMM":"1977-01-01T05:00:00.000Z","value":223598},{"MSN":"HVETPUS","YYYYMM":"1978-01-01T05:00:00.000Z","value":283465},{"MSN":"HVETPUS","YYYYMM":"1979-01-01T05:00:00.000Z","value":283075},{"MSN":"HVETPUS","YYYYMM":"1980-01-01T05:00:00.000Z","value":279182},{"MSN":"HVETPUS","YYYYMM":"1981-01-01T05:00:00.000Z","value":263844},{"MSN":"HVETPUS","YYYYMM":"1982-01-01T05:00:00.000Z","value":312374},{"MSN":"HVETPUS","YYYYMM":"1983-01-01T05:00:00.000Z","value":335290},{"MSN":"HVETPUS","YYYYMM":"1984-01-01T05:00:00.000Z","value":324311},{"MSN":"HVETPUS","YYYYMM":"1985-01-01T05:00:00.000Z","value":284310},{"MSN":"HVETPUS","YYYYMM":"1986-01-01T05:00:00.000Z","value":294005},{"MSN":"HVETPUS","YYYYMM":"1987-01-01T05:00:00.000Z","value":252856},{"MSN":"HVETPUS","YYYYMM":"1988-01-01T05:00:00.000Z","value":226100},{"MSN":"HVETPUS","YYYYMM":"1989-01-01T05:00:00.000Z","value":271976},{"MSN":"HVETPUS","YYYYMM":"1990-01-01T05:00:00.000Z","value":292865},{"MSN":"HVETPUS","YYYYMM":"1991-01-01T05:00:00.000Z","value":288994},{"MSN":"HVETPUS","YYYYMM":"1992-01-01T05:00:00.000Z","value":253088},{"MSN":"HVETPUS","YYYYMM":"1993-01-01T05:00:00.000Z","value":280494},{"MSN":"HVETPUS","YYYYMM":"1994-01-01T05:00:00.000Z","value":260125},{"MSN":"HVETPUS","YYYYMM":"1995-01-01T05:00:00.000Z","value":310832},{"MSN":"HVETPUS","YYYYMM":"1996-01-01T05:00:00.000Z","value":347162},{"MSN":"HVETPUS","YYYYMM":"1997-01-01T05:00:00.000Z","value":356453},{"MSN":"HVETPUS","YYYYMM":"1998-01-01T05:00:00.000Z","value":323335},{"MSN":"HVETPUS","YYYYMM":"1999-01-01T05:00:00.000Z","value":319536},{"MSN":"HVETPUS","YYYYMM":"2000-01-01T05:00:00.000Z","value":275572},{"MSN":"HVETPUS","YYYYMM":"2001-01-01T05:00:00.000Z","value":216961},{"MSN":"HVETPUS","YYYYMM":"2002-01-01T05:00:00.000Z","value":264328},{"MSN":"HVETPUS","YYYYMM":"2003-01-01T05:00:00.000Z","value":275806},{"MSN":"HVETPUS","YYYYMM":"2004-01-01T05:00:00.000Z","value":268417},{"MSN":"HVETPUS","YYYYMM":"2005-01-01T05:00:00.000Z","value":270321},{"MSN":"HVETPUS","YYYYMM":"2006-01-01T05:00:00.000Z","value":289246},{"MSN":"HVETPUS","YYYYMM":"2007-01-01T05:00:00.000Z","value":247509},{"MSN":"HVETPUS","YYYYMM":"2008-01-01T05:00:00.000Z","value":254831},{"MSN":"HVETPUS","YYYYMM":"2009-01-01T05:00:00.000Z","value":273445},{"MSN":"HVETPUS","YYYYMM":"2010-01-01T05:00:00.000Z","value":260203},{"MSN":"HVETPUS","YYYYMM":"2011-01-01T05:00:00.000Z","value":319354},{"MSN":"HVETPUS","YYYYMM":"2012-01-01T05:00:00.000Z","value":276240},{"MSN":"HVETPUS","YYYYMM":"2013-01-01T05:00:00.000Z","value":268565},{"MSN":"HVETPUS","YYYYMM":"2014-01-01T05:00:00.000Z","value":259366},{"MSN":"HVETPUS","YYYYMM":"2015-01-01T05:00:00.000Z","value":249080},{"MSN":"HVETPUS","YYYYMM":"2016-01-01T05:00:00.000Z","value":267812}]},{"MSN":"WDETPUS","coordinates":[{"MSN":"WDETPUS","YYYYMM":"1949-01-01T05:00:00.000Z","value":386},{"MSN":"WDETPUS","YYYYMM":"1950-01-01T05:00:00.000Z","value":389},{"MSN":"WDETPUS","YYYYMM":"1951-01-01T05:00:00.000Z","value":390},{"MSN":"WDETPUS","YYYYMM":"1952-01-01T05:00:00.000Z","value":481},{"MSN":"WDETPUS","YYYYMM":"1953-01-01T05:00:00.000Z","value":389},{"MSN":"WDETPUS","YYYYMM":"1954-01-01T05:00:00.000Z","value":263},{"MSN":"WDETPUS","YYYYMM":"1955-01-01T05:00:00.000Z","value":276},{"MSN":"WDETPUS","YYYYMM":"1956-01-01T05:00:00.000Z","value":151},{"MSN":"WDETPUS","YYYYMM":"1957-01-01T05:00:00.000Z","value":176},{"MSN":"WDETPUS","YYYYMM":"1958-01-01T05:00:00.000Z","value":175},{"MSN":"WDETPUS","YYYYMM":"1959-01-01T05:00:00.000Z","value":152},{"MSN":"WDETPUS","YYYYMM":"1960-01-01T05:00:00.000Z","value":140},{"MSN":"WDETPUS","YYYYMM":"1961-01-01T05:00:00.000Z","value":125},{"MSN":"WDETPUS","YYYYMM":"1962-01-01T05:00:00.000Z","value":127},{"MSN":"WDETPUS","YYYYMM":"1963-01-01T05:00:00.000Z","value":127},{"MSN":"WDETPUS","YYYYMM":"1964-01-01T05:00:00.000Z","value":148},{"MSN":"WDETPUS","YYYYMM":"1965-01-01T05:00:00.000Z","value":268},{"MSN":"WDETPUS","YYYYMM":"1966-01-01T05:00:00.000Z","value":333},{"MSN":"WDETPUS","YYYYMM":"1967-01-01T05:00:00.000Z","value":315},{"MSN":"WDETPUS","YYYYMM":"1968-01-01T05:00:00.000Z","value":375},{"MSN":"WDETPUS","YYYYMM":"1969-01-01T05:00:00.000Z","value":319},{"MSN":"WDETPUS","YYYYMM":"1970-01-01T05:00:00.000Z","value":136},{"MSN":"WDETPUS","YYYYMM":"1971-01-01T05:00:00.000Z","value":111},{"MSN":"WDETPUS","YYYYMM":"1972-01-01T05:00:00.000Z","value":130},{"MSN":"WDETPUS","YYYYMM":"1973-01-01T05:00:00.000Z","value":130},{"MSN":"WDETPUS","YYYYMM":"1974-01-01T05:00:00.000Z","value":68},{"MSN":"WDETPUS","YYYYMM":"1975-01-01T05:00:00.000Z","value":17},{"MSN":"WDETPUS","YYYYMM":"1976-01-01T05:00:00.000Z","value":84},{"MSN":"WDETPUS","YYYYMM":"1977-01-01T05:00:00.000Z","value":307},{"MSN":"WDETPUS","YYYYMM":"1978-01-01T05:00:00.000Z","value":197},{"MSN":"WDETPUS","YYYYMM":"1979-01-01T05:00:00.000Z","value":299},{"MSN":"WDETPUS","YYYYMM":"1980-01-01T05:00:00.000Z","value":275},{"MSN":"WDETPUS","YYYYMM":"1981-01-01T05:00:00.000Z","value":245},{"MSN":"WDETPUS","YYYYMM":"1982-01-01T05:00:00.000Z","value":195},{"MSN":"WDETPUS","YYYYMM":"1983-01-01T05:00:00.000Z","value":215},{"MSN":"WDETPUS","YYYYMM":"1984-01-01T05:00:00.000Z","value":461},{"MSN":"WDETPUS","YYYYMM":"1985-01-01T05:00:00.000Z","value":743},{"MSN":"WDETPUS","YYYYMM":"1986-01-01T05:00:00.000Z","value":491},{"MSN":"WDETPUS","YYYYMM":"1987-01-01T05:00:00.000Z","value":783},{"MSN":"WDETPUS","YYYYMM":"1988-01-01T05:00:00.000Z","value":935},{"MSN":"WDETPUS","YYYYMM":"1989-01-01T05:00:00.000Z","value":27236},{"MSN":"WDETPUS","YYYYMM":"1990-01-01T05:00:00.000Z","value":32521},{"MSN":"WDETPUS","YYYYMM":"1991-01-01T05:00:00.000Z","value":33725},{"MSN":"WDETPUS","YYYYMM":"1992-01-01T05:00:00.000Z","value":36528},{"MSN":"WDETPUS","YYYYMM":"1993-01-01T05:00:00.000Z","value":37623},{"MSN":"WDETPUS","YYYYMM":"1994-01-01T05:00:00.000Z","value":37937},{"MSN":"WDETPUS","YYYYMM":"1995-01-01T05:00:00.000Z","value":36521},{"MSN":"WDETPUS","YYYYMM":"1996-01-01T05:00:00.000Z","value":36800},{"MSN":"WDETPUS","YYYYMM":"1997-01-01T05:00:00.000Z","value":36948},{"MSN":"WDETPUS","YYYYMM":"1998-01-01T05:00:00.000Z","value":36338},{"MSN":"WDETPUS","YYYYMM":"1999-01-01T05:00:00.000Z","value":37040},{"MSN":"WDETPUS","YYYYMM":"2000-01-01T05:00:00.000Z","value":37594},{"MSN":"WDETPUS","YYYYMM":"2001-01-01T05:00:00.000Z","value":35199},{"MSN":"WDETPUS","YYYYMM":"2002-01-01T05:00:00.000Z","value":38665},{"MSN":"WDETPUS","YYYYMM":"2003-01-01T05:00:00.000Z","value":37529},{"MSN":"WDETPUS","YYYYMM":"2004-01-01T05:00:00.000Z","value":38116},{"MSN":"WDETPUS","YYYYMM":"2005-01-01T05:00:00.000Z","value":38856},{"MSN":"WDETPUS","YYYYMM":"2006-01-01T05:00:00.000Z","value":38762},{"MSN":"WDETPUS","YYYYMM":"2007-01-01T05:00:00.000Z","value":39014},{"MSN":"WDETPUS","YYYYMM":"2008-01-01T05:00:00.000Z","value":37299},{"MSN":"WDETPUS","YYYYMM":"2009-01-01T05:00:00.000Z","value":36050},{"MSN":"WDETPUS","YYYYMM":"2010-01-01T05:00:00.000Z","value":37172},{"MSN":"WDETPUS","YYYYMM":"2011-01-01T05:00:00.000Z","value":37449},{"MSN":"WDETPUS","YYYYMM":"2012-01-01T05:00:00.000Z","value":37799},{"MSN":"WDETPUS","YYYYMM":"2013-01-01T05:00:00.000Z","value":40027},{"MSN":"WDETPUS","YYYYMM":"2014-01-01T05:00:00.000Z","value":42339},{"MSN":"WDETPUS","YYYYMM":"2015-01-01T05:00:00.000Z","value":41928},{"MSN":"WDETPUS","YYYYMM":"2016-01-01T05:00:00.000Z","value":40947}]},{"MSN":"WSETPUS","coordinates":[{"MSN":"WSETPUS","YYYYMM":"1949-01-01T05:00:00.000Z","value":0},{"MSN":"WSETPUS","YYYYMM":"1950-01-01T05:00:00.000Z","value":0},{"MSN":"WSETPUS","YYYYMM":"1951-01-01T05:00:00.000Z","value":0},{"MSN":"WSETPUS","YYYYMM":"1952-01-01T05:00:00.000Z","value":0},{"MSN":"WSETPUS","YYYYMM":"1953-01-01T05:00:00.000Z","value":0},{"MSN":"WSETPUS","YYYYMM":"1954-01-01T05:00:00.000Z","value":0},{"MSN":"WSETPUS","YYYYMM":"1955-01-01T05:00:00.000Z","value":0},{"MSN":"WSETPUS","YYYYMM":"1956-01-01T05:00:00.000Z","value":0},{"MSN":"WSETPUS","YYYYMM":"1957-01-01T05:00:00.000Z","value":0},{"MSN":"WSETPUS","YYYYMM":"1958-01-01T05:00:00.000Z","value":0},{"MSN":"WSETPUS","YYYYMM":"1959-01-01T05:00:00.000Z","value":0},{"MSN":"WSETPUS","YYYYMM":"1960-01-01T05:00:00.000Z","value":0},{"MSN":"WSETPUS","YYYYMM":"1961-01-01T05:00:00.000Z","value":0},{"MSN":"WSETPUS","YYYYMM":"1962-01-01T05:00:00.000Z","value":0},{"MSN":"WSETPUS","YYYYMM":"1963-01-01T05:00:00.000Z","value":0},{"MSN":"WSETPUS","YYYYMM":"1964-01-01T05:00:00.000Z","value":0},{"MSN":"WSETPUS","YYYYMM":"1965-01-01T05:00:00.000Z","value":0},{"MSN":"WSETPUS","YYYYMM":"1966-01-01T05:00:00.000Z","value":0},{"MSN":"WSETPUS","YYYYMM":"1967-01-01T05:00:00.000Z","value":0},{"MSN":"WSETPUS","YYYYMM":"1968-01-01T05:00:00.000Z","value":0},{"MSN":"WSETPUS","YYYYMM":"1969-01-01T05:00:00.000Z","value":0},{"MSN":"WSETPUS","YYYYMM":"1970-01-01T05:00:00.000Z","value":220},{"MSN":"WSETPUS","YYYYMM":"1971-01-01T05:00:00.000Z","value":199},{"MSN":"WSETPUS","YYYYMM":"1972-01-01T05:00:00.000Z","value":199},{"MSN":"WSETPUS","YYYYMM":"1973-01-01T05:00:00.000Z","value":197},{"MSN":"WSETPUS","YYYYMM":"1974-01-01T05:00:00.000Z","value":182},{"MSN":"WSETPUS","YYYYMM":"1975-01-01T05:00:00.000Z","value":173},{"MSN":"WSETPUS","YYYYMM":"1976-01-01T05:00:00.000Z","value":182},{"MSN":"WSETPUS","YYYYMM":"1977-01-01T05:00:00.000Z","value":173},{"MSN":"WSETPUS","YYYYMM":"1978-01-01T05:00:00.000Z","value":140},{"MSN":"WSETPUS","YYYYMM":"1979-01-01T05:00:00.000Z","value":198},{"MSN":"WSETPUS","YYYYMM":"1980-01-01T05:00:00.000Z","value":157},{"MSN":"WSETPUS","YYYYMM":"1981-01-01T05:00:00.000Z","value":122},{"MSN":"WSETPUS","YYYYMM":"1982-01-01T05:00:00.000Z","value":124},{"MSN":"WSETPUS","YYYYMM":"1983-01-01T05:00:00.000Z","value":162},{"MSN":"WSETPUS","YYYYMM":"1984-01-01T05:00:00.000Z","value":424},{"MSN":"WSETPUS","YYYYMM":"1985-01-01T05:00:00.000Z","value":639},{"MSN":"WSETPUS","YYYYMM":"1986-01-01T05:00:00.000Z","value":685},{"MSN":"WSETPUS","YYYYMM":"1987-01-01T05:00:00.000Z","value":693},{"MSN":"WSETPUS","YYYYMM":"1988-01-01T05:00:00.000Z","value":738},{"MSN":"WSETPUS","YYYYMM":"1989-01-01T05:00:00.000Z","value":9162},{"MSN":"WSETPUS","YYYYMM":"1990-01-01T05:00:00.000Z","value":13260},{"MSN":"WSETPUS","YYYYMM":"1991-01-01T05:00:00.000Z","value":15664},{"MSN":"WSETPUS","YYYYMM":"1992-01-01T05:00:00.000Z","value":17816},{"MSN":"WSETPUS","YYYYMM":"1993-01-01T05:00:00.000Z","value":18333},{"MSN":"WSETPUS","YYYYMM":"1994-01-01T05:00:00.000Z","value":19128},{"MSN":"WSETPUS","YYYYMM":"1995-01-01T05:00:00.000Z","value":20404},{"MSN":"WSETPUS","YYYYMM":"1996-01-01T05:00:00.000Z","value":20911},{"MSN":"WSETPUS","YYYYMM":"1997-01-01T05:00:00.000Z","value":21709},{"MSN":"WSETPUS","YYYYMM":"1998-01-01T05:00:00.000Z","value":22447},{"MSN":"WSETPUS","YYYYMM":"1999-01-01T05:00:00.000Z","value":22572},{"MSN":"WSETPUS","YYYYMM":"2000-01-01T05:00:00.000Z","value":23131},{"MSN":"WSETPUS","YYYYMM":"2001-01-01T05:00:00.000Z","value":14548},{"MSN":"WSETPUS","YYYYMM":"2002-01-01T05:00:00.000Z","value":15043},{"MSN":"WSETPUS","YYYYMM":"2003-01-01T05:00:00.000Z","value":15811},{"MSN":"WSETPUS","YYYYMM":"2004-01-01T05:00:00.000Z","value":15420},{"MSN":"WSETPUS","YYYYMM":"2005-01-01T05:00:00.000Z","value":15420},{"MSN":"WSETPUS","YYYYMM":"2006-01-01T05:00:00.000Z","value":16098},{"MSN":"WSETPUS","YYYYMM":"2007-01-01T05:00:00.000Z","value":16524},{"MSN":"WSETPUS","YYYYMM":"2008-01-01T05:00:00.000Z","value":17733},{"MSN":"WSETPUS","YYYYMM":"2009-01-01T05:00:00.000Z","value":18442},{"MSN":"WSETPUS","YYYYMM":"2010-01-01T05:00:00.000Z","value":18917},{"MSN":"WSETPUS","YYYYMM":"2011-01-01T05:00:00.000Z","value":19221},{"MSN":"WSETPUS","YYYYMM":"2012-01-01T05:00:00.000Z","value":19823},{"MSN":"WSETPUS","YYYYMM":"2013-01-01T05:00:00.000Z","value":20830},{"MSN":"WSETPUS","YYYYMM":"2014-01-01T05:00:00.000Z","value":21649},{"MSN":"WSETPUS","YYYYMM":"2015-01-01T05:00:00.000Z","value":21703},{"MSN":"WSETPUS","YYYYMM":"2016-01-01T05:00:00.000Z","value":21813}]},{"MSN":"GEETPUS","coordinates":[{"MSN":"GEETPUS","YYYYMM":"1949-01-01T05:00:00.000Z","value":0},{"MSN":"GEETPUS","YYYYMM":"1950-01-01T05:00:00.000Z","value":0},{"MSN":"GEETPUS","YYYYMM":"1951-01-01T05:00:00.000Z","value":0},{"MSN":"GEETPUS","YYYYMM":"1952-01-01T05:00:00.000Z","value":0},{"MSN":"GEETPUS","YYYYMM":"1953-01-01T05:00:00.000Z","value":0},{"MSN":"GEETPUS","YYYYMM":"1954-01-01T05:00:00.000Z","value":0},{"MSN":"GEETPUS","YYYYMM":"1955-01-01T05:00:00.000Z","value":0},{"MSN":"GEETPUS","YYYYMM":"1956-01-01T05:00:00.000Z","value":0},{"MSN":"GEETPUS","YYYYMM":"1957-01-01T05:00:00.000Z","value":0},{"MSN":"GEETPUS","YYYYMM":"1958-01-01T05:00:00.000Z","value":0},{"MSN":"GEETPUS","YYYYMM":"1959-01-01T05:00:00.000Z","value":0},{"MSN":"GEETPUS","YYYYMM":"1960-01-01T05:00:00.000Z","value":33},{"MSN":"GEETPUS","YYYYMM":"1961-01-01T05:00:00.000Z","value":94},{"MSN":"GEETPUS","YYYYMM":"1962-01-01T05:00:00.000Z","value":100},{"MSN":"GEETPUS","YYYYMM":"1963-01-01T05:00:00.000Z","value":167},{"MSN":"GEETPUS","YYYYMM":"1964-01-01T05:00:00.000Z","value":203},{"MSN":"GEETPUS","YYYYMM":"1965-01-01T05:00:00.000Z","value":189},{"MSN":"GEETPUS","YYYYMM":"1966-01-01T05:00:00.000Z","value":187},{"MSN":"GEETPUS","YYYYMM":"1967-01-01T05:00:00.000Z","value":316},{"MSN":"GEETPUS","YYYYMM":"1968-01-01T05:00:00.000Z","value":435},{"MSN":"GEETPUS","YYYYMM":"1969-01-01T05:00:00.000Z","value":614},{"MSN":"GEETPUS","YYYYMM":"1970-01-01T05:00:00.000Z","value":525},{"MSN":"GEETPUS","YYYYMM":"1971-01-01T05:00:00.000Z","value":547},{"MSN":"GEETPUS","YYYYMM":"1972-01-01T05:00:00.000Z","value":1452},{"MSN":"GEETPUS","YYYYMM":"1973-01-01T05:00:00.000Z","value":1965},{"MSN":"GEETPUS","YYYYMM":"1974-01-01T05:00:00.000Z","value":2452},{"MSN":"GEETPUS","YYYYMM":"1975-01-01T05:00:00.000Z","value":3246},{"MSN":"GEETPUS","YYYYMM":"1976-01-01T05:00:00.000Z","value":3616},{"MSN":"GEETPUS","YYYYMM":"1977-01-01T05:00:00.000Z","value":3582},{"MSN":"GEETPUS","YYYYMM":"1978-01-01T05:00:00.000Z","value":2977},{"MSN":"GEETPUS","YYYYMM":"1979-01-01T05:00:00.000Z","value":3888},{"MSN":"GEETPUS","YYYYMM":"1980-01-01T05:00:00.000Z","value":5073},{"MSN":"GEETPUS","YYYYMM":"1981-01-01T05:00:00.000Z","value":5686},{"MSN":"GEETPUS","YYYYMM":"1982-01-01T05:00:00.000Z","value":4842},{"MSN":"GEETPUS","YYYYMM":"1983-01-01T05:00:00.000Z","value":6075},{"MSN":"GEETPUS","YYYYMM":"1984-01-01T05:00:00.000Z","value":7740},{"MSN":"GEETPUS","YYYYMM":"1985-01-01T05:00:00.000Z","value":9325},{"MSN":"GEETPUS","YYYYMM":"1986-01-01T05:00:00.000Z","value":10307},{"MSN":"GEETPUS","YYYYMM":"1987-01-01T05:00:00.000Z","value":10775},{"MSN":"GEETPUS","YYYYMM":"1988-01-01T05:00:00.000Z","value":10300},{"MSN":"GEETPUS","YYYYMM":"1989-01-01T05:00:00.000Z","value":14593},{"MSN":"GEETPUS","YYYYMM":"1990-01-01T05:00:00.000Z","value":15434},{"MSN":"GEETPUS","YYYYMM":"1991-01-01T05:00:00.000Z","value":15966},{"MSN":"GEETPUS","YYYYMM":"1992-01-01T05:00:00.000Z","value":16137},{"MSN":"GEETPUS","YYYYMM":"1993-01-01T05:00:00.000Z","value":16788},{"MSN":"GEETPUS","YYYYMM":"1994-01-01T05:00:00.000Z","value":15535},{"MSN":"GEETPUS","YYYYMM":"1995-01-01T05:00:00.000Z","value":13378},{"MSN":"GEETPUS","YYYYMM":"1996-01-01T05:00:00.000Z","value":14328},{"MSN":"GEETPUS","YYYYMM":"1997-01-01T05:00:00.000Z","value":14726},{"MSN":"GEETPUS","YYYYMM":"1998-01-01T05:00:00.000Z","value":14773},{"MSN":"GEETPUS","YYYYMM":"1999-01-01T05:00:00.000Z","value":14827},{"MSN":"GEETPUS","YYYYMM":"2000-01-01T05:00:00.000Z","value":14093},{"MSN":"GEETPUS","YYYYMM":"2001-01-01T05:00:00.000Z","value":13740},{"MSN":"GEETPUS","YYYYMM":"2002-01-01T05:00:00.000Z","value":14491},{"MSN":"GEETPUS","YYYYMM":"2003-01-01T05:00:00.000Z","value":14424},{"MSN":"GEETPUS","YYYYMM":"2004-01-01T05:00:00.000Z","value":14810},{"MSN":"GEETPUS","YYYYMM":"2005-01-01T05:00:00.000Z","value":14691},{"MSN":"GEETPUS","YYYYMM":"2006-01-01T05:00:00.000Z","value":14568},{"MSN":"GEETPUS","YYYYMM":"2007-01-01T05:00:00.000Z","value":14637},{"MSN":"GEETPUS","YYYYMM":"2008-01-01T05:00:00.000Z","value":14839},{"MSN":"GEETPUS","YYYYMM":"2009-01-01T05:00:00.000Z","value":15008},{"MSN":"GEETPUS","YYYYMM":"2010-01-01T05:00:00.000Z","value":15219},{"MSN":"GEETPUS","YYYYMM":"2011-01-01T05:00:00.000Z","value":15316},{"MSN":"GEETPUS","YYYYMM":"2012-01-01T05:00:00.000Z","value":15562},{"MSN":"GEETPUS","YYYYMM":"2013-01-01T05:00:00.000Z","value":15774},{"MSN":"GEETPUS","YYYYMM":"2014-01-01T05:00:00.000Z","value":15876},{"MSN":"GEETPUS","YYYYMM":"2015-01-01T05:00:00.000Z","value":15917},{"MSN":"GEETPUS","YYYYMM":"2016-01-01T05:00:00.000Z","value":15825}]},{"MSN":"SOETPUS","coordinates":[{"MSN":"SOETPUS","YYYYMM":"1949-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1950-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1951-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1952-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1953-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1954-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1955-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1956-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1957-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1958-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1959-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1960-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1961-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1962-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1963-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1964-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1965-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1966-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1967-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1968-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1969-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1970-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1971-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1972-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1973-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1974-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1975-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1976-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1977-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1978-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1979-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1980-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1981-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1982-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1983-01-01T05:00:00.000Z","value":0},{"MSN":"SOETPUS","YYYYMM":"1984-01-01T05:00:00.000Z","value":5},{"MSN":"SOETPUS","YYYYMM":"1985-01-01T05:00:00.000Z","value":10},{"MSN":"SOETPUS","YYYYMM":"1986-01-01T05:00:00.000Z","value":14},{"MSN":"SOETPUS","YYYYMM":"1987-01-01T05:00:00.000Z","value":10},{"MSN":"SOETPUS","YYYYMM":"1988-01-01T05:00:00.000Z","value":9},{"MSN":"SOETPUS","YYYYMM":"1989-01-01T05:00:00.000Z","value":250},{"MSN":"SOETPUS","YYYYMM":"1990-01-01T05:00:00.000Z","value":367},{"MSN":"SOETPUS","YYYYMM":"1991-01-01T05:00:00.000Z","value":471},{"MSN":"SOETPUS","YYYYMM":"1992-01-01T05:00:00.000Z","value":399},{"MSN":"SOETPUS","YYYYMM":"1993-01-01T05:00:00.000Z","value":462},{"MSN":"SOETPUS","YYYYMM":"1994-01-01T05:00:00.000Z","value":486},{"MSN":"SOETPUS","YYYYMM":"1995-01-01T05:00:00.000Z","value":496},{"MSN":"SOETPUS","YYYYMM":"1996-01-01T05:00:00.000Z","value":521},{"MSN":"SOETPUS","YYYYMM":"1997-01-01T05:00:00.000Z","value":511},{"MSN":"SOETPUS","YYYYMM":"1998-01-01T05:00:00.000Z","value":502},{"MSN":"SOETPUS","YYYYMM":"1999-01-01T05:00:00.000Z","value":495},{"MSN":"SOETPUS","YYYYMM":"2000-01-01T05:00:00.000Z","value":493},{"MSN":"SOETPUS","YYYYMM":"2001-01-01T05:00:00.000Z","value":542},{"MSN":"SOETPUS","YYYYMM":"2002-01-01T05:00:00.000Z","value":554},{"MSN":"SOETPUS","YYYYMM":"2003-01-01T05:00:00.000Z","value":534},{"MSN":"SOETPUS","YYYYMM":"2004-01-01T05:00:00.000Z","value":575},{"MSN":"SOETPUS","YYYYMM":"2005-01-01T05:00:00.000Z","value":550},{"MSN":"SOETPUS","YYYYMM":"2006-01-01T05:00:00.000Z","value":507},{"MSN":"SOETPUS","YYYYMM":"2007-01-01T05:00:00.000Z","value":611},{"MSN":"SOETPUS","YYYYMM":"2008-01-01T05:00:00.000Z","value":864},{"MSN":"SOETPUS","YYYYMM":"2009-01-01T05:00:00.000Z","value":891},{"MSN":"SOETPUS","YYYYMM":"2010-01-01T05:00:00.000Z","value":1212},{"MSN":"SOETPUS","YYYYMM":"2011-01-01T05:00:00.000Z","value":1817},{"MSN":"SOETPUS","YYYYMM":"2012-01-01T05:00:00.000Z","value":4326},{"MSN":"SOETPUS","YYYYMM":"2013-01-01T05:00:00.000Z","value":9035},{"MSN":"SOETPUS","YYYYMM":"2014-01-01T05:00:00.000Z","value":17691},{"MSN":"SOETPUS","YYYYMM":"2015-01-01T05:00:00.000Z","value":24892},{"MSN":"SOETPUS","YYYYMM":"2016-01-01T05:00:00.000Z","value":36054}]},{"MSN":"WYETPUS","coordinates":[{"MSN":"WYETPUS","YYYYMM":"1949-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1950-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1951-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1952-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1953-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1954-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1955-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1956-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1957-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1958-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1959-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1960-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1961-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1962-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1963-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1964-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1965-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1966-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1967-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1968-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1969-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1970-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1971-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1972-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1973-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1974-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1975-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1976-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1977-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1978-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1979-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1980-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1981-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1982-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1983-01-01T05:00:00.000Z","value":2},{"MSN":"WYETPUS","YYYYMM":"1984-01-01T05:00:00.000Z","value":6},{"MSN":"WYETPUS","YYYYMM":"1985-01-01T05:00:00.000Z","value":5},{"MSN":"WYETPUS","YYYYMM":"1986-01-01T05:00:00.000Z","value":4},{"MSN":"WYETPUS","YYYYMM":"1987-01-01T05:00:00.000Z","value":3},{"MSN":"WYETPUS","YYYYMM":"1988-01-01T05:00:00.000Z","value":0},{"MSN":"WYETPUS","YYYYMM":"1989-01-01T05:00:00.000Z","value":2112},{"MSN":"WYETPUS","YYYYMM":"1990-01-01T05:00:00.000Z","value":2788},{"MSN":"WYETPUS","YYYYMM":"1991-01-01T05:00:00.000Z","value":2950},{"MSN":"WYETPUS","YYYYMM":"1992-01-01T05:00:00.000Z","value":2887},{"MSN":"WYETPUS","YYYYMM":"1993-01-01T05:00:00.000Z","value":3005},{"MSN":"WYETPUS","YYYYMM":"1994-01-01T05:00:00.000Z","value":3447},{"MSN":"WYETPUS","YYYYMM":"1995-01-01T05:00:00.000Z","value":3164},{"MSN":"WYETPUS","YYYYMM":"1996-01-01T05:00:00.000Z","value":3234},{"MSN":"WYETPUS","YYYYMM":"1997-01-01T05:00:00.000Z","value":3288},{"MSN":"WYETPUS","YYYYMM":"1998-01-01T05:00:00.000Z","value":3025},{"MSN":"WYETPUS","YYYYMM":"1999-01-01T05:00:00.000Z","value":4487},{"MSN":"WYETPUS","YYYYMM":"2000-01-01T05:00:00.000Z","value":5593},{"MSN":"WYETPUS","YYYYMM":"2001-01-01T05:00:00.000Z","value":6737},{"MSN":"WYETPUS","YYYYMM":"2002-01-01T05:00:00.000Z","value":10354},{"MSN":"WYETPUS","YYYYMM":"2003-01-01T05:00:00.000Z","value":11187},{"MSN":"WYETPUS","YYYYMM":"2004-01-01T05:00:00.000Z","value":14143},{"MSN":"WYETPUS","YYYYMM":"2005-01-01T05:00:00.000Z","value":17810},{"MSN":"WYETPUS","YYYYMM":"2006-01-01T05:00:00.000Z","value":26589},{"MSN":"WYETPUS","YYYYMM":"2007-01-01T05:00:00.000Z","value":34449},{"MSN":"WYETPUS","YYYYMM":"2008-01-01T05:00:00.000Z","value":55363},{"MSN":"WYETPUS","YYYYMM":"2009-01-01T05:00:00.000Z","value":73886},{"MSN":"WYETPUS","YYYYMM":"2010-01-01T05:00:00.000Z","value":94652},{"MSN":"WYETPUS","YYYYMM":"2011-01-01T05:00:00.000Z","value":120176},{"MSN":"WYETPUS","YYYYMM":"2012-01-01T05:00:00.000Z","value":140821},{"MSN":"WYETPUS","YYYYMM":"2013-01-01T05:00:00.000Z","value":167839},{"MSN":"WYETPUS","YYYYMM":"2014-01-01T05:00:00.000Z","value":181655},{"MSN":"WYETPUS","YYYYMM":"2015-01-01T05:00:00.000Z","value":190718},{"MSN":"WYETPUS","YYYYMM":"2016-01-01T05:00:00.000Z","value":226992}]}]

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Semiotic_Stacked_Area; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semiotic__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semiotic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_semiotic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_scale__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__colorMap__ = __webpack_require__(252);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//Author: Ian Banatoski
var color={CLETPUS:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['coal'],//Coal
PAETPUS:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['petroleum'],//Petroleum
NGETPUS:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['naturalGas'],//Natural Gas
OJETPUS:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['otherGas'],//Other Gases
NUETPUS:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['nuclear'],//Nuclear
HPETPUS:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['hydroPumped'],//Hydroelectric Pumped Storage
HVETPUS:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['hydroConventional'],//Conventional Hydroelectric Power
WDETPUS:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['wood'],//Wood
WSETPUS:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['waste'],//Waste
GEETPUS:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['geothermal'],//Geothermal
SOETPUS:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['solar'],//Solar
WYETPUS:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['wind']//Wind
};var name={CLETPUS:"Coal",//Coal
PAETPUS:"Petroleum",//Petroleum
NGETPUS:"Natural Gas",//Natural Gas
OJETPUS:"Other Gases",//Other Gases
NUETPUS:"Nuclear",//Nuclear
HPETPUS:"Hydroelectric Pumped Storage",//Hydroelectric Pumped Storage
HVETPUS:"Conventional Hydroelectric Power",//Conventional Hydroelectric Power
WDETPUS:"Wood",//Wood
WSETPUS:"Waste",//Waste
GEETPUS:"Geothermal",//Geothermal
SOETPUS:"Solar",//Solar
WYETPUS:"Wind",//Wind
ELETPUS:"Total"//total
};var Semiotic_Stacked_Area=function(_React$Component){_inherits(Semiotic_Stacked_Area,_React$Component);function Semiotic_Stacked_Area(props){_classCallCheck(this,Semiotic_Stacked_Area);return _possibleConstructorReturn(this,(Semiotic_Stacked_Area.__proto__||Object.getPrototypeOf(Semiotic_Stacked_Area)).call(this,props));}_createClass(Semiotic_Stacked_Area,[{key:"render",value:function render(){//console.log("props", this.props);
var annotations=this.props.annotations;//console.log("state.data#########", this.state.data);
var data=JSON.parse(JSON.stringify(this.props.data));var chartAxes=[{orient:"left",label:"Million Megawatt Hours",ticks:5,tickFormat:function tickFormat(d){return d/1000000;}},{orient:"bottom",ticks:10,tickFormat:function tickFormat(d){return new Date(d).getFullYear();}}];var areaLegendGroups=[{styleFn:function styleFn(d){return{fill:color[d.MSN],stroke:color[d.MSN]};},items:[{label:"Coal",color:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['coal']},//Coal
{label:"Petroleum",color:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['petroleum']},//Petroleum
{label:"Natural Gas",color:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['naturalGas']},//Natural Gas
{label:"Other Gases",color:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['otherGas']},//Other Gases
{label:"Nuclear",color:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['nuclear']},//Nuclear
{label:"Hydroelectric Pumped Storage",color:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['hydroPumped']},//Hydroelectric Pumped Storage
{label:"Conventional Hydroelectric Power",color:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['hydroConventional']},//Conventional Hydroelectric Power
{label:"Wood",color:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['wood']},//Wood
{label:"Waste",color:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['waste']},//Waste
{label:"Geothermal",color:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['geothermal']},//Geothermal
{label:"Solar",color:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['solar']},//Solar
{label:"Wind",color:__WEBPACK_IMPORTED_MODULE_4__colorMap__["a" /* default */]['wind']}]}];var chartSettings={responsiveWidth:true,responsiveHeight:false,size:[100,400],margin:{top:0,bottom:50,left:60,right:30},lineRendermode:"sketchy",lines:data,xScaleType:Object(__WEBPACK_IMPORTED_MODULE_3_d3_scale__["a" /* scaleTime */])(),lineType:{type:"stackedarea",interpolator:__WEBPACK_IMPORTED_MODULE_1_d3__["a" /* curveMonotoneX */]},xAccessor:function xAccessor(d){return new Date(d.YYYYMM);},yAccessor:"value",lineDataAccessor:function lineDataAccessor(d){return d.coordinates;},lineIDAccessor:"MSN",lineStyle:function lineStyle(d){return{fill:color[d.MSN],stroke:color[d.MSN],fillOpacity:0.75};},axes:chartAxes,annotations:annotations,hoverAnnotation:[{type:"frame-hover"},function(d){return{type:"x",color:"#FFF",connector:{end:"none"}};}],tooltipContent:function tooltipContent(d){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tooltip-content",style:{boxShadow:"2px 2px 5px grey",color:"#000",opacity:0.9,background:"#FFF",padding:10,borderRadius:5,transform:"translate(10px,10px)"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,new Date(d.YYYYMM).getFullYear()," | ",name[d.MSN])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,d.value.toString())," Mwh"));}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semiotic__["ResponsiveXYFrame"],chartSettings);}}]);return Semiotic_Stacked_Area;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export name */
/* unused harmony export version */
/* unused harmony export description */
/* unused harmony export keywords */
/* unused harmony export homepage */
/* unused harmony export license */
/* unused harmony export author */
/* unused harmony export main */
/* unused harmony export unpkg */
/* unused harmony export jsdelivr */
/* unused harmony export module */
/* unused harmony export repository */
/* unused harmony export scripts */
/* unused harmony export devDependencies */
/* unused harmony export dependencies */
var name = "d3";
var version = "4.13.0";
var description = "Data-Driven Documents";
var keywords = ["dom","visualization","svg","animation","canvas"];
var homepage = "https://d3js.org";
var license = "BSD-3-Clause";
var author = {"name":"Mike Bostock","url":"https://bost.ocks.org/mike"};
var main = "build/d3.node.js";
var unpkg = "build/d3.min.js";
var jsdelivr = "build/d3.min.js";
var module = "index";
var repository = {"type":"git","url":"https://github.com/d3/d3.git"};
var scripts = {"pretest":"rimraf build && mkdir build && json2module package.json > build/package.js && node rollup.node","test":"tape 'test/**/*-test.js'","prepublishOnly":"npm run test && rollup -c --banner \"$(preamble)\" && uglifyjs -b beautify=false,preamble=\"'$(preamble)'\" build/d3.js -c negate_iife=false -m -o build/d3.min.js","postpublish":"git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/build/d3.js d3.v4.js && cp ../d3/build/d3.min.js d3.v4.min.js && git add d3.v4.js d3.v4.min.js && git commit -m \"d3 ${npm_package_version}\" && git push && cd - && cd ../d3-bower && git pull && cp ../d3/LICENSE ../d3/README.md ../d3/build/d3.js ../d3/build/d3.min.js . && git add -- LICENSE README.md d3.js d3.min.js && git commit -m \"${npm_package_version}\" && git tag -am \"${npm_package_version}\" v${npm_package_version} && git push && git push --tags && cd - && zip -j build/d3.zip -- LICENSE README.md API.md CHANGES.md build/d3.js build/d3.min.js"};
var devDependencies = {"json2module":"0.0","package-preamble":"0.1","rimraf":"2","rollup":"0.53","rollup-plugin-ascii":"0.0","rollup-plugin-node-resolve":"3","tape":"4","uglify-js":"3.2"};
var dependencies = {"d3-array":"1.2.1","d3-axis":"1.0.8","d3-brush":"1.0.4","d3-chord":"1.0.4","d3-collection":"1.0.4","d3-color":"1.0.3","d3-dispatch":"1.0.3","d3-drag":"1.2.1","d3-dsv":"1.0.8","d3-ease":"1.0.3","d3-force":"1.1.0","d3-format":"1.2.2","d3-geo":"1.9.1","d3-hierarchy":"1.1.5","d3-interpolate":"1.1.6","d3-path":"1.0.5","d3-polygon":"1.0.3","d3-quadtree":"1.0.3","d3-queue":"3.0.7","d3-random":"1.1.0","d3-request":"1.0.6","d3-scale":"1.0.7","d3-selection":"1.3.0","d3-shape":"1.2.0","d3-time":"1.0.8","d3-time-format":"2.1.1","d3-timer":"1.0.7","d3-transition":"1.1.1","d3-voronoi":"1.1.2","d3-zoom":"1.7.1"};


/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_axis__ = __webpack_require__(769);
/* unused harmony reexport axisTop */
/* unused harmony reexport axisRight */
/* unused harmony reexport axisBottom */
/* unused harmony reexport axisLeft */



/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export axisTop */
/* unused harmony export axisRight */
/* unused harmony export axisBottom */
/* unused harmony export axisLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(771);



var top = 1,
    right = 2,
    bottom = 3,
    left = 4,
    epsilon = 1e-6;

function translateX(x) {
  return "translate(" + (x + 0.5) + ",0)";
}

function translateY(y) {
  return "translate(0," + (y + 0.5) + ")";
}

function number(scale) {
  return function(d) {
    return +scale(d);
  };
}

function center(scale) {
  var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
  if (scale.round()) offset = Math.round(offset);
  return function(d) {
    return +scale(d) + offset;
  };
}

function entering() {
  return !this.__axis;
}

function axis(orient, scale) {
  var tickArguments = [],
      tickValues = null,
      tickFormat = null,
      tickSizeInner = 6,
      tickSizeOuter = 6,
      tickPadding = 3,
      k = orient === top || orient === left ? -1 : 1,
      x = orient === left || orient === right ? "x" : "y",
      transform = orient === top || orient === bottom ? translateX : translateY;

  function axis(context) {
    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */]) : tickFormat,
        spacing = Math.max(tickSizeInner, 0) + tickPadding,
        range = scale.range(),
        range0 = +range[0] + 0.5,
        range1 = +range[range.length - 1] + 0.5,
        position = (scale.bandwidth ? center : number)(scale.copy()),
        selection = context.selection ? context.selection() : context,
        path = selection.selectAll(".domain").data([null]),
        tick = selection.selectAll(".tick").data(values, scale).order(),
        tickExit = tick.exit(),
        tickEnter = tick.enter().append("g").attr("class", "tick"),
        line = tick.select("line"),
        text = tick.select("text");

    path = path.merge(path.enter().insert("path", ".tick")
        .attr("class", "domain")
        .attr("stroke", "#000"));

    tick = tick.merge(tickEnter);

    line = line.merge(tickEnter.append("line")
        .attr("stroke", "#000")
        .attr(x + "2", k * tickSizeInner));

    text = text.merge(tickEnter.append("text")
        .attr("fill", "#000")
        .attr(x, k * spacing)
        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));

    if (context !== selection) {
      path = path.transition(context);
      tick = tick.transition(context);
      line = line.transition(context);
      text = text.transition(context);

      tickExit = tickExit.transition(context)
          .attr("opacity", epsilon)
          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform"); });

      tickEnter
          .attr("opacity", epsilon)
          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform(p && isFinite(p = p(d)) ? p : position(d)); });
    }

    tickExit.remove();

    path
        .attr("d", orient === left || orient == right
            ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter
            : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);

    tick
        .attr("opacity", 1)
        .attr("transform", function(d) { return transform(position(d)); });

    line
        .attr(x + "2", k * tickSizeInner);

    text
        .attr(x, k * spacing)
        .text(format);

    selection.filter(entering)
        .attr("fill", "none")
        .attr("font-size", 10)
        .attr("font-family", "sans-serif")
        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");

    selection
        .each(function() { this.__axis = position; });
  }

  axis.scale = function(_) {
    return arguments.length ? (scale = _, axis) : scale;
  };

  axis.ticks = function() {
    return tickArguments = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(arguments), axis;
  };

  axis.tickArguments = function(_) {
    return arguments.length ? (tickArguments = _ == null ? [] : __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_), axis) : tickArguments.slice();
  };

  axis.tickValues = function(_) {
    return arguments.length ? (tickValues = _ == null ? null : __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_), axis) : tickValues && tickValues.slice();
  };

  axis.tickFormat = function(_) {
    return arguments.length ? (tickFormat = _, axis) : tickFormat;
  };

  axis.tickSize = function(_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
  };

  axis.tickSizeInner = function(_) {
    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
  };

  axis.tickSizeOuter = function(_) {
    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
  };

  axis.tickPadding = function(_) {
    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
  };

  return axis;
}

function axisTop(scale) {
  return axis(top, scale);
}

function axisRight(scale) {
  return axis(right, scale);
}

function axisBottom(scale) {
  return axis(bottom, scale);
}

function axisLeft(scale) {
  return axis(left, scale);
}


/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = brushSelection;
/* harmony export (immutable) */ __webpack_exports__["b"] = brushX;
/* harmony export (immutable) */ __webpack_exports__["c"] = brushY;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_drag__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_selection__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_transition__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constant__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__noevent__ = __webpack_require__(845);









var MODE_DRAG = {name: "drag"},
    MODE_SPACE = {name: "space"},
    MODE_HANDLE = {name: "handle"},
    MODE_CENTER = {name: "center"};

var X = {
  name: "x",
  handles: ["e", "w"].map(type),
  input: function(x, e) { return x && [[x[0], e[0][1]], [x[1], e[1][1]]]; },
  output: function(xy) { return xy && [xy[0][0], xy[1][0]]; }
};

var Y = {
  name: "y",
  handles: ["n", "s"].map(type),
  input: function(y, e) { return y && [[e[0][0], y[0]], [e[1][0], y[1]]]; },
  output: function(xy) { return xy && [xy[0][1], xy[1][1]]; }
};

var XY = {
  name: "xy",
  handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(type),
  input: function(xy) { return xy; },
  output: function(xy) { return xy; }
};

var cursors = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
};

var flipX = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
};

var flipY = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
};

var signsX = {
  overlay: +1,
  selection: +1,
  n: null,
  e: +1,
  s: null,
  w: -1,
  nw: -1,
  ne: +1,
  se: +1,
  sw: -1
};

var signsY = {
  overlay: +1,
  selection: +1,
  n: -1,
  e: null,
  s: +1,
  w: null,
  nw: -1,
  ne: -1,
  se: +1,
  sw: +1
};

function type(t) {
  return {type: t};
}

// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].button;
}

function defaultExtent() {
  var svg = this.ownerSVGElement || this;
  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
}

// Like d3.local, but with the name “__brush” rather than auto-generated.
function local(node) {
  while (!node.__brush) if (!(node = node.parentNode)) return;
  return node.__brush;
}

function empty(extent) {
  return extent[0][0] === extent[1][0]
      || extent[0][1] === extent[1][1];
}

function brushSelection(node) {
  var state = node.__brush;
  return state ? state.dim.output(state.selection) : null;
}

function brushX() {
  return brush(X);
}

function brushY() {
  return brush(Y);
}

/* harmony default export */ __webpack_exports__["d"] = (function() {
  return brush(XY);
});

function brush(dim) {
  var extent = defaultExtent,
      filter = defaultFilter,
      listeners = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])(brush, "start", "brush", "end"),
      handleSize = 6,
      touchending;

  function brush(group) {
    var overlay = group
        .property("__brush", initialize)
      .selectAll(".overlay")
      .data([type("overlay")]);

    overlay.enter().append("rect")
        .attr("class", "overlay")
        .attr("pointer-events", "all")
        .attr("cursor", cursors.overlay)
      .merge(overlay)
        .each(function() {
          var extent = local(this).extent;
          Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["f" /* select */])(this)
              .attr("x", extent[0][0])
              .attr("y", extent[0][1])
              .attr("width", extent[1][0] - extent[0][0])
              .attr("height", extent[1][1] - extent[0][1]);
        });

    group.selectAll(".selection")
      .data([type("selection")])
      .enter().append("rect")
        .attr("class", "selection")
        .attr("cursor", cursors.selection)
        .attr("fill", "#777")
        .attr("fill-opacity", 0.3)
        .attr("stroke", "#fff")
        .attr("shape-rendering", "crispEdges");

    var handle = group.selectAll(".handle")
      .data(dim.handles, function(d) { return d.type; });

    handle.exit().remove();

    handle.enter().append("rect")
        .attr("class", function(d) { return "handle handle--" + d.type; })
        .attr("cursor", function(d) { return cursors[d.type]; });

    group
        .each(redraw)
        .attr("fill", "none")
        .attr("pointer-events", "all")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
        .on("mousedown.brush touchstart.brush", started);
  }

  brush.move = function(group, selection) {
    if (group.selection) {
      group
          .on("start.brush", function() { emitter(this, arguments).beforestart().start(); })
          .on("interrupt.brush end.brush", function() { emitter(this, arguments).end(); })
          .tween("brush", function() {
            var that = this,
                state = that.__brush,
                emit = emitter(that, arguments),
                selection0 = state.selection,
                selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent),
                i = Object(__WEBPACK_IMPORTED_MODULE_2_d3_interpolate__["a" /* interpolate */])(selection0, selection1);

            function tween(t) {
              state.selection = t === 1 && empty(selection1) ? null : i(t);
              redraw.call(that);
              emit.brush();
            }

            return selection0 && selection1 ? tween : tween(1);
          });
    } else {
      group
          .each(function() {
            var that = this,
                args = arguments,
                state = that.__brush,
                selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent),
                emit = emitter(that, args).beforestart();

            Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["a" /* interrupt */])(that);
            state.selection = selection1 == null || empty(selection1) ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
          });
    }
  };

  function redraw() {
    var group = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["f" /* select */])(this),
        selection = local(this).selection;

    if (selection) {
      group.selectAll(".selection")
          .style("display", null)
          .attr("x", selection[0][0])
          .attr("y", selection[0][1])
          .attr("width", selection[1][0] - selection[0][0])
          .attr("height", selection[1][1] - selection[0][1]);

      group.selectAll(".handle")
          .style("display", null)
          .attr("x", function(d) { return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2; })
          .attr("y", function(d) { return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2; })
          .attr("width", function(d) { return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize; })
          .attr("height", function(d) { return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize; });
    }

    else {
      group.selectAll(".selection,.handle")
          .style("display", "none")
          .attr("x", null)
          .attr("y", null)
          .attr("width", null)
          .attr("height", null);
    }
  }

  function emitter(that, args) {
    return that.__brush.emitter || new Emitter(that, args);
  }

  function Emitter(that, args) {
    this.that = that;
    this.args = args;
    this.state = that.__brush;
    this.active = 0;
  }

  Emitter.prototype = {
    beforestart: function() {
      if (++this.active === 1) this.state.emitter = this, this.starting = true;
      return this;
    },
    start: function() {
      if (this.starting) this.starting = false, this.emit("start");
      return this;
    },
    brush: function() {
      this.emit("brush");
      return this;
    },
    end: function() {
      if (--this.active === 0) delete this.state.emitter, this.emit("end");
      return this;
    },
    emit: function(type) {
      Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["a" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_6__event__["a" /* default */](brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function started() {
    if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].touches) { if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].changedTouches.length < __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].touches.length) return Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])(); }
    else if (touchending) return;
    if (!filter.apply(this, arguments)) return;

    var that = this,
        type = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].target.__data__.type,
        mode = (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].altKey ? MODE_CENTER : MODE_HANDLE),
        signX = dim === Y ? null : signsX[type],
        signY = dim === X ? null : signsY[type],
        state = local(that),
        extent = state.extent,
        selection = state.selection,
        W = extent[0][0], w0, w1,
        N = extent[0][1], n0, n1,
        E = extent[1][0], e0, e1,
        S = extent[1][1], s0, s1,
        dx,
        dy,
        moving,
        shifting = signX && signY && __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].shiftKey,
        lockX,
        lockY,
        point0 = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* mouse */])(that),
        point = point0,
        emit = emitter(that, arguments).beforestart();

    if (type === "overlay") {
      state.selection = selection = [
        [w0 = dim === Y ? W : point0[0], n0 = dim === X ? N : point0[1]],
        [e0 = dim === Y ? E : w0, s0 = dim === X ? S : n0]
      ];
    } else {
      w0 = selection[0][0];
      n0 = selection[0][1];
      e0 = selection[1][0];
      s0 = selection[1][1];
    }

    w1 = w0;
    n1 = n0;
    e1 = e0;
    s1 = s0;

    var group = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["f" /* select */])(that)
        .attr("pointer-events", "none");

    var overlay = group.selectAll(".overlay")
        .attr("cursor", cursors[type]);

    if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].touches) {
      group
          .on("touchmove.brush", moved, true)
          .on("touchend.brush touchcancel.brush", ended, true);
    } else {
      var view = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].view)
          .on("keydown.brush", keydowned, true)
          .on("keyup.brush", keyupped, true)
          .on("mousemove.brush", moved, true)
          .on("mouseup.brush", ended, true);

      Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["a" /* dragDisable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].view);
    }

    Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["b" /* nopropagation */])();
    Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["a" /* interrupt */])(that);
    redraw.call(that);
    emit.start();

    function moved() {
      var point1 = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* mouse */])(that);
      if (shifting && !lockX && !lockY) {
        if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
        else lockX = true;
      }
      point = point1;
      moving = true;
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])();
      move();
    }

    function move() {
      var t;

      dx = point[0] - point0[0];
      dy = point[1] - point0[1];

      switch (mode) {
        case MODE_SPACE:
        case MODE_DRAG: {
          if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
          if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
          break;
        }
        case MODE_HANDLE: {
          if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
          else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
          if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
          else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
          break;
        }
        case MODE_CENTER: {
          if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
          if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
          break;
        }
      }

      if (e1 < w1) {
        signX *= -1;
        t = w0, w0 = e0, e0 = t;
        t = w1, w1 = e1, e1 = t;
        if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
      }

      if (s1 < n1) {
        signY *= -1;
        t = n0, n0 = s0, s0 = t;
        t = n1, n1 = s1, s1 = t;
        if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
      }

      if (state.selection) selection = state.selection; // May be set by brush.move!
      if (lockX) w1 = selection[0][0], e1 = selection[1][0];
      if (lockY) n1 = selection[0][1], s1 = selection[1][1];

      if (selection[0][0] !== w1
          || selection[0][1] !== n1
          || selection[1][0] !== e1
          || selection[1][1] !== s1) {
        state.selection = [[w1, n1], [e1, s1]];
        redraw.call(that);
        emit.brush();
      }
    }

    function ended() {
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["b" /* nopropagation */])();
      if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].touches) {
        if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].touches.length) return;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
        group.on("touchmove.brush touchend.brush touchcancel.brush", null);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["b" /* dragEnable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].view, moving);
        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      }
      group.attr("pointer-events", "all");
      overlay.attr("cursor", cursors.overlay);
      if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
      if (empty(selection)) state.selection = null, redraw.call(that);
      emit.end();
    }

    function keydowned() {
      switch (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].keyCode) {
        case 16: { // SHIFT
          shifting = signX && signY;
          break;
        }
        case 18: { // ALT
          if (mode === MODE_HANDLE) {
            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
            mode = MODE_CENTER;
            move();
          }
          break;
        }
        case 32: { // SPACE; takes priority over ALT
          if (mode === MODE_HANDLE || mode === MODE_CENTER) {
            if (signX < 0) e0 = e1 - dx; else if (signX > 0) w0 = w1 - dx;
            if (signY < 0) s0 = s1 - dy; else if (signY > 0) n0 = n1 - dy;
            mode = MODE_SPACE;
            overlay.attr("cursor", cursors.selection);
            move();
          }
          break;
        }
        default: return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])();
    }

    function keyupped() {
      switch (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].keyCode) {
        case 16: { // SHIFT
          if (shifting) {
            lockX = lockY = shifting = false;
            move();
          }
          break;
        }
        case 18: { // ALT
          if (mode === MODE_CENTER) {
            if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
            if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
            mode = MODE_HANDLE;
            move();
          }
          break;
        }
        case 32: { // SPACE
          if (mode === MODE_SPACE) {
            if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].altKey) {
              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
              mode = MODE_CENTER;
            } else {
              if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
              if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
              mode = MODE_HANDLE;
            }
            overlay.attr("cursor", cursors[type]);
            move();
          }
          break;
        }
        default: return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])();
    }
  }

  function initialize() {
    var state = this.__brush || {selection: null};
    state.extent = extent.apply(this, arguments);
    state.dim = dim;
    return state;
  }

  brush.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), brush) : extent;
  };

  brush.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(!!_), brush) : filter;
  };

  brush.handleSize = function(_) {
    return arguments.length ? (handleSize = +_, brush) : handleSize;
  };

  brush.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? brush : value;
  };

  return brush;
}


/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var noop = {value: function() {}};

function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = parseTypenames(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

/* harmony default export */ __webpack_exports__["a"] = (dispatch);


/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodrag__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__noevent__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constant__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event__ = __webpack_require__(810);







// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].button;
}

function defaultContainer() {
  return this.parentNode;
}

function defaultSubject(d) {
  return d == null ? {x: __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].x, y: __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].y} : d;
}

function defaultTouchable() {
  return "ontouchstart" in this;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var filter = defaultFilter,
      container = defaultContainer,
      subject = defaultSubject,
      touchable = defaultTouchable,
      gestures = {},
      listeners = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("start", "drag", "end"),
      active = 0,
      mousedownx,
      mousedowny,
      mousemoving,
      touchending,
      clickDistance2 = 0;

  function drag(selection) {
    selection
        .on("mousedown.drag", mousedowned)
      .filter(touchable)
        .on("touchstart.drag", touchstarted)
        .on("touchmove.drag", touchmoved)
        .on("touchend.drag touchcancel.drag", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var gesture = beforestart("mouse", container.apply(this, arguments), __WEBPACK_IMPORTED_MODULE_1_d3_selection__["d" /* mouse */], this, arguments);
    if (!gesture) return;
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
    Object(__WEBPACK_IMPORTED_MODULE_2__nodrag__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].view);
    Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" /* nopropagation */])();
    mousemoving = false;
    mousedownx = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].clientX;
    mousedowny = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].clientY;
    gesture("start");
  }

  function mousemoved() {
    Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" /* default */])();
    if (!mousemoving) {
      var dx = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].clientX - mousedownx, dy = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].clientY - mousedowny;
      mousemoving = dx * dx + dy * dy > clickDistance2;
    }
    gestures.mouse("drag");
  }

  function mouseupped() {
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].view).on("mousemove.drag mouseup.drag", null);
    Object(__WEBPACK_IMPORTED_MODULE_2__nodrag__["b" /* yesdrag */])(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].view, mousemoving);
    Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" /* default */])();
    gestures.mouse("end");
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].changedTouches,
        c = container.apply(this, arguments),
        n = touches.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = beforestart(touches[i].identifier, c, __WEBPACK_IMPORTED_MODULE_1_d3_selection__["k" /* touch */], this, arguments)) {
        Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" /* nopropagation */])();
        gesture("start");
      }
    }
  }

  function touchmoved() {
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].changedTouches,
        n = touches.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["a" /* default */])();
        gesture("drag");
      }
    }
  }

  function touchended() {
    var touches = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].changedTouches,
        n = touches.length, i, gesture;

    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        Object(__WEBPACK_IMPORTED_MODULE_3__noevent__["b" /* nopropagation */])();
        gesture("end");
      }
    }
  }

  function beforestart(id, container, point, that, args) {
    var p = point(container, id), s, dx, dy,
        sublisteners = listeners.copy();

    if (!Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["a" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_5__event__["a" /* default */](drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
      if ((__WEBPACK_IMPORTED_MODULE_1_d3_selection__["b" /* event */].subject = s = subject.apply(that, args)) == null) return false;
      dx = s.x - p[0] || 0;
      dy = s.y - p[1] || 0;
      return true;
    })) return;

    return function gesture(type) {
      var p0 = p, n;
      switch (type) {
        case "start": gestures[id] = gesture, n = active++; break;
        case "end": delete gestures[id], --active; // nobreak
        case "drag": p = point(container, id), n = active; break;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["a" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_5__event__["a" /* default */](drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [type, that, args]);
    };
  }

  drag.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(!!_), drag) : filter;
  };

  drag.container = function(_) {
    return arguments.length ? (container = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(_), drag) : container;
  };

  drag.subject = function(_) {
    return arguments.length ? (subject = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(_), drag) : subject;
  };

  drag.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(!!_), drag) : touchable;
  };

  drag.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? drag : value;
  };

  drag.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
  };

  return drag;
});


/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__select__ = __webpack_require__(330);



/* unused harmony default export */ var _unused_webpack_default_export = (function(name) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__select__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name).call(document.documentElement));
});


/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(176);



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, this._parents);
});


/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectorAll__ = __webpack_require__(331);



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_1__selectorAll__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, parents);
});


/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matcher__ = __webpack_require__(332);



/* harmony default export */ __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = Object(__WEBPACK_IMPORTED_MODULE_1__matcher__["a" /* default */])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, this._parents);
});


/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enter__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(780);




var keyPrefix = "$"; // Protect against keys like “__proto__”.

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["a" /* EnterNode */](parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = {},
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
      if (keyValue in nodeByKeyValue) {
        exit[i] = node;
      } else {
        nodeByKeyValue[keyValue] = node;
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = keyPrefix + key.call(parent, data[i], i, data);
    if (node = nodeByKeyValue[keyValue]) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue[keyValue] = null;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["a" /* EnterNode */](parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
      exit[i] = node;
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (function(value, key) {
  if (!value) {
    data = new Array(this.size()), j = -1;
    this.each(function(d) { data[++j] = d; });
    return data;
  }

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = value.call(parent, parent && parent.__data__, j, parents),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
});


/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(17);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Selection */](this._exit || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});


/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(17);


/* harmony default export */ __webpack_exports__["a"] = (function(selection) {

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](merges, this._parents);
});


/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
});


/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(17);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (!compare) compare = ascending;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](sortgroups, this._parents).order();
});

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
});


/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
});


/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
});


/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
});


/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return !this.node();
});


/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
});


/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(174);


function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)
      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
});


/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
});


/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
});


/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction
          : textConstant)(value))
      : this.node().textContent;
});


/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
});


/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(raise);
});


/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(lower);
});


/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(111);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var create = typeof name === "function" ? name : Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
});


/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(176);



function constantNull() {
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, before) {
  var create = typeof name === "function" ? name : Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name),
      select = before == null ? constantNull : typeof before === "function" ? before : Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
});


/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(remove);
});


/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function selection_cloneShallow() {
  return this.parentNode.insertBefore(this.cloneNode(false), this.nextSibling);
}

function selection_cloneDeep() {
  return this.parentNode.insertBefore(this.cloneNode(true), this.nextSibling);
}

/* harmony default export */ __webpack_exports__["a"] = (function(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
});


/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
});


/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(177);


function dispatchEvent(node, type, params) {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
});


/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
var nextId = 0;

function local() {
  return new Local;
}

function Local() {
  this._ = "@" + (++nextId).toString(36);
}

Local.prototype = local.prototype = {
  constructor: Local,
  get: function(node) {
    var id = this._;
    while (!(id in node)) if (!(node = node.parentNode)) return;
    return node[id];
  },
  set: function(node, value) {
    return node[this._] = value;
  },
  remove: function(node) {
    return this._ in node && delete node[this._];
  },
  toString: function() {
    return this._;
  }
};


/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(112);



/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  var event = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])();
  if (event.changedTouches) event = event.changedTouches[0];
  return Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, event);
});


/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(17);


/* unused harmony default export */ var _unused_webpack_default_export = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([document.querySelectorAll(selector)], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([selector == null ? [] : selector], __WEBPACK_IMPORTED_MODULE_0__selection_index__["c" /* root */]);
});


/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(112);



/* harmony default export */ __webpack_exports__["a"] = (function(node, touches, identifier) {
  if (arguments.length < 3) identifier = touches, touches = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().changedTouches;

  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
    if ((touch = touches[i]).identifier === identifier) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touch);
    }
  }

  return null;
});


/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(112);



/* unused harmony default export */ var _unused_webpack_default_export = (function(node, touches) {
  if (touches == null) touches = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().touches;

  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
    points[i] = Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touches[i]);
  }

  return points;
});


/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DragEvent;
function DragEvent(target, type, subject, id, active, x, y, dx, dy, dispatch) {
  this.target = target;
  this.type = type;
  this.subject = subject;
  this.identifier = id;
  this.active = active;
  this.x = x;
  this.y = y;
  this.dx = dx;
  this.dy = dy;
  this._ = dispatch;
}

DragEvent.prototype.on = function() {
  var value = this._.on.apply(this._, arguments);
  return value === this._ ? this : value;
};


/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interrupt__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transition__ = __webpack_require__(815);




__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* selection */].prototype.interrupt = __WEBPACK_IMPORTED_MODULE_1__interrupt__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* selection */].prototype.transition = __WEBPACK_IMPORTED_MODULE_2__transition__["a" /* default */];


/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interrupt__ = __webpack_require__(338);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  return this.each(function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__interrupt__["a" /* default */])(this, name);
  });
});


/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(181);


/* harmony default export */ __webpack_exports__["a"] = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["a" /* Timer */];
  delay = delay == null ? 0 : +delay;
  t.restart(function(elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
});


/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(181);


/* unused harmony default export */ var _unused_webpack_default_export = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["a" /* Timer */], total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  delay = +delay, time = time == null ? Object(__WEBPACK_IMPORTED_MODULE_0__timer__["b" /* now */])() : +time;
  t.restart(function tick(elapsed) {
    elapsed += total;
    t.restart(tick, total += delay, time);
    callback(elapsed);
  }, delay, time);
  return t;
});


/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_index__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transition_schedule__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_ease__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_timer__ = __webpack_require__(45);





var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: __WEBPACK_IMPORTED_MODULE_2_d3_ease__["a" /* easeCubicInOut */]
};

function inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      return defaultTiming.time = Object(__WEBPACK_IMPORTED_MODULE_3_d3_timer__["a" /* now */])(), defaultTiming;
    }
  }
  return timing;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var id,
      timing;

  if (name instanceof __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */]) {
    id = name._id, name = name._name;
  } else {
    id = Object(__WEBPACK_IMPORTED_MODULE_0__transition_index__["b" /* newId */])(), (timing = defaultTiming).time = Object(__WEBPACK_IMPORTED_MODULE_3_d3_timer__["a" /* now */])(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        Object(__WEBPACK_IMPORTED_MODULE_1__transition_schedule__["e" /* default */])(node, name, id, i, group, timing || inherit(node, id));
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */](groups, this._parents, name, id);
});


/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tween__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interpolate__ = __webpack_require__(339);





function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function attrConstantNS(fullname, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function attrFunction(name, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttribute(name);
    value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

function attrFunctionNS(fullname, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["e" /* namespace */])(name), i = fullname === "transform" ? __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["i" /* interpolateTransformSvg */] : __WEBPACK_IMPORTED_MODULE_3__interpolate__["a" /* default */];
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, Object(__WEBPACK_IMPORTED_MODULE_2__tween__["b" /* tweenValue */])(this, "attr." + name, value))
      : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname)
      : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value + ""));
});


/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(11);


function attrTweenNS(fullname, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttributeNS(fullname.space, fullname.local, i(t));
    };
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttribute(name, i(t));
    };
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["e" /* namespace */])(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
});


/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(18);


function delayFunction(id, value) {
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */])(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */])(this, id).delay = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).delay;
});


/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(18);


function durationFunction(id, value) {
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).duration = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).duration;
});


/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(18);


function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).ease = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).ease;
});


/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(35);



/* harmony default export */ __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["c" /* matcher */])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, this._parents, this._name, this._id);
});


/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(35);


/* harmony default export */ __webpack_exports__["a"] = (function(transition) {
  if (transition._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Transition */](merges, this._parents, this._name, this._id);
});


/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(18);


function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = start(name) ? __WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */] : __WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */];
  return function() {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
});


/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.on("end.remove", removeFunction(this._id));
});


/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schedule__ = __webpack_require__(18);




/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["h" /* selector */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["e" /* default */])(subgroup[i], name, id, i, subgroup, Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["f" /* get */])(node, id));
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, this._parents, name, id);
});


/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schedule__ = __webpack_require__(18);




/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["i" /* selectorAll */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select.call(node, node.__data__, i, group), child, inherit = Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["f" /* get */])(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["e" /* default */])(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, parents, name, id);
});


/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(11);


var Selection = __WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* selection */].prototype.constructor;

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new Selection(this._groups, this._parents);
});


/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tween__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interpolate__ = __webpack_require__(339);





function styleRemove(name, interpolate) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["j" /* style */])(this, name),
        value1 = (this.style.removeProperty(name), Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["j" /* style */])(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

function styleRemoveEnd(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["j" /* style */])(this, name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function styleFunction(name, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["j" /* style */])(this, name),
        value1 = value(this);
    if (value1 == null) value1 = (this.style.removeProperty(name), Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["j" /* style */])(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  var i = (name += "") === "transform" ? __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["h" /* interpolateTransformCss */] : __WEBPACK_IMPORTED_MODULE_3__interpolate__["a" /* default */];
  return value == null ? this
          .styleTween(name, styleRemove(name, i))
          .on("end.style." + name, styleRemoveEnd(name))
      : this.styleTween(name, typeof value === "function"
          ? styleFunction(name, i, Object(__WEBPACK_IMPORTED_MODULE_2__tween__["b" /* tweenValue */])(this, "style." + name, value))
          : styleConstant(name, i, value + ""), priority);
});


/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function styleTween(name, value, priority) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.style.setProperty(name, i(t), priority);
    };
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
});


/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tween__ = __webpack_require__(113);


function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return this.tween("text", typeof value === "function"
      ? textFunction(Object(__WEBPACK_IMPORTED_MODULE_0__tween__["b" /* tweenValue */])(this, "text", value))
      : textConstant(value == null ? "" : value + ""));
});


/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schedule__ = __webpack_require__(18);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  var name = this._name,
      id0 = this._id,
      id1 = Object(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* newId */])();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = Object(__WEBPACK_IMPORTED_MODULE_1__schedule__["f" /* get */])(node, id0);
        Object(__WEBPACK_IMPORTED_MODULE_1__schedule__["e" /* default */])(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Transition */](groups, this._parents, name, id1);
});


/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export linear */
function linear(t) {
  return +t;
}


/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export quadIn */
/* unused harmony export quadOut */
/* unused harmony export quadInOut */
function quadIn(t) {
  return t * t;
}

function quadOut(t) {
  return t * (2 - t);
}

function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}


/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export cubicIn */
/* unused harmony export cubicOut */
/* harmony export (immutable) */ __webpack_exports__["a"] = cubicInOut;
function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}


/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export polyIn */
/* unused harmony export polyOut */
/* unused harmony export polyInOut */
var exponent = 3;

var polyIn = (function custom(e) {
  e = +e;

  function polyIn(t) {
    return Math.pow(t, e);
  }

  polyIn.exponent = custom;

  return polyIn;
})(exponent);

var polyOut = (function custom(e) {
  e = +e;

  function polyOut(t) {
    return 1 - Math.pow(1 - t, e);
  }

  polyOut.exponent = custom;

  return polyOut;
})(exponent);

var polyInOut = (function custom(e) {
  e = +e;

  function polyInOut(t) {
    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
  }

  polyInOut.exponent = custom;

  return polyInOut;
})(exponent);


/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sinIn */
/* unused harmony export sinOut */
/* unused harmony export sinInOut */
var pi = Math.PI,
    halfPi = pi / 2;

function sinIn(t) {
  return 1 - Math.cos(t * halfPi);
}

function sinOut(t) {
  return Math.sin(t * halfPi);
}

function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}


/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export expIn */
/* unused harmony export expOut */
/* unused harmony export expInOut */
function expIn(t) {
  return Math.pow(2, 10 * t - 10);
}

function expOut(t) {
  return 1 - Math.pow(2, -10 * t);
}

function expInOut(t) {
  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
}


/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export circleIn */
/* unused harmony export circleOut */
/* unused harmony export circleInOut */
function circleIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}

function circleOut(t) {
  return Math.sqrt(1 - --t * t);
}

function circleInOut(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}


/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bounceIn */
/* unused harmony export bounceOut */
/* unused harmony export bounceInOut */
var b1 = 4 / 11,
    b2 = 6 / 11,
    b3 = 8 / 11,
    b4 = 3 / 4,
    b5 = 9 / 11,
    b6 = 10 / 11,
    b7 = 15 / 16,
    b8 = 21 / 22,
    b9 = 63 / 64,
    b0 = 1 / b1 / b1;

function bounceIn(t) {
  return 1 - bounceOut(1 - t);
}

function bounceOut(t) {
  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}

function bounceInOut(t) {
  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}


/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export backIn */
/* unused harmony export backOut */
/* unused harmony export backInOut */
var overshoot = 1.70158;

var backIn = (function custom(s) {
  s = +s;

  function backIn(t) {
    return t * t * ((s + 1) * t - s);
  }

  backIn.overshoot = custom;

  return backIn;
})(overshoot);

var backOut = (function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((s + 1) * t + s) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
})(overshoot);

var backInOut = (function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
})(overshoot);


/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export elasticIn */
/* unused harmony export elasticOut */
/* unused harmony export elasticInOut */
var tau = 2 * Math.PI,
    amplitude = 1,
    period = 0.3;

var elasticIn = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticIn(t) {
    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
  }

  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
  elasticIn.period = function(p) { return custom(a, p); };

  return elasticIn;
})(amplitude, period);

var elasticOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticOut(t) {
    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
  }

  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticOut.period = function(p) { return custom(a, p); };

  return elasticOut;
})(amplitude, period);

var elasticInOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticInOut(t) {
    return ((t = t * 2 - 1) < 0
        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
  }

  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticInOut.period = function(p) { return custom(a, p); };

  return elasticInOut;
})(amplitude, period);


/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_index__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transition_schedule__ = __webpack_require__(18);



var root = [null];

/* unused harmony default export */ var _unused_webpack_default_export = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      i;

  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule = schedules[i]).state > __WEBPACK_IMPORTED_MODULE_1__transition_schedule__["c" /* SCHEDULED */] && schedule.name === name) {
        return new __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */]([[node]], root, name, +i);
      }
    }
  }

  return null;
});


/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(target, type, selection) {
  this.target = target;
  this.type = type;
  this.selection = selection;
});


/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = nopropagation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(11);


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].stopImmediatePropagation();
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].stopImmediatePropagation();
});


/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(341);



function compareValue(compare) {
  return function(a, b) {
    return compare(
      a.source.value + a.target.value,
      b.source.value + b.target.value
    );
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var padAngle = 0,
      sortGroups = null,
      sortSubgroups = null,
      sortChords = null;

  function chord(matrix) {
    var n = matrix.length,
        groupSums = [],
        groupIndex = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(n),
        subgroupIndex = [],
        chords = [],
        groups = chords.groups = new Array(n),
        subgroups = new Array(n * n),
        k,
        x,
        x0,
        dx,
        i,
        j;

    // Compute the sum.
    k = 0, i = -1; while (++i < n) {
      x = 0, j = -1; while (++j < n) {
        x += matrix[i][j];
      }
      groupSums.push(x);
      subgroupIndex.push(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(n));
      k += x;
    }

    // Sort groups…
    if (sortGroups) groupIndex.sort(function(a, b) {
      return sortGroups(groupSums[a], groupSums[b]);
    });

    // Sort subgroups…
    if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
      d.sort(function(a, b) {
        return sortSubgroups(matrix[i][a], matrix[i][b]);
      });
    });

    // Convert the sum to scaling factor for [0, 2pi].
    // TODO Allow start and end angle to be specified?
    // TODO Allow padding to be specified as percentage?
    k = Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* max */])(0, __WEBPACK_IMPORTED_MODULE_1__math__["e" /* tau */] - padAngle * n) / k;
    dx = k ? padAngle : __WEBPACK_IMPORTED_MODULE_1__math__["e" /* tau */] / n;

    // Compute the start and end angle for each group and subgroup.
    // Note: Opera has a bug reordering object literal properties!
    x = 0, i = -1; while (++i < n) {
      x0 = x, j = -1; while (++j < n) {
        var di = groupIndex[i],
            dj = subgroupIndex[di][j],
            v = matrix[di][dj],
            a0 = x,
            a1 = x += v * k;
        subgroups[dj * n + di] = {
          index: di,
          subindex: dj,
          startAngle: a0,
          endAngle: a1,
          value: v
        };
      }
      groups[di] = {
        index: di,
        startAngle: x0,
        endAngle: x,
        value: groupSums[di]
      };
      x += dx;
    }

    // Generate chords for each (non-empty) subgroup-subgroup link.
    i = -1; while (++i < n) {
      j = i - 1; while (++j < n) {
        var source = subgroups[j * n + i],
            target = subgroups[i * n + j];
        if (source.value || target.value) {
          chords.push(source.value < target.value
              ? {source: target, target: source}
              : {source: source, target: target});
        }
      }
    }

    return sortChords ? chords.sort(sortChords) : chords;
  }

  chord.padAngle = function(_) {
    return arguments.length ? (padAngle = Object(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* max */])(0, _), chord) : padAngle;
  };

  chord.sortGroups = function(_) {
    return arguments.length ? (sortGroups = _, chord) : sortGroups;
  };

  chord.sortSubgroups = function(_) {
    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
  };

  chord.sortChords = function(_) {
    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
  };

  return chord;
});


/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_path__ = __webpack_require__(14);





function defaultSource(d) {
  return d.source;
}

function defaultTarget(d) {
  return d.target;
}

function defaultRadius(d) {
  return d.radius;
}

function defaultStartAngle(d) {
  return d.startAngle;
}

function defaultEndAngle(d) {
  return d.endAngle;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var source = defaultSource,
      target = defaultTarget,
      radius = defaultRadius,
      startAngle = defaultStartAngle,
      endAngle = defaultEndAngle,
      context = null;

  function ribbon() {
    var buffer,
        argv = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(arguments),
        s = source.apply(this, argv),
        t = target.apply(this, argv),
        sr = +radius.apply(this, (argv[0] = s, argv)),
        sa0 = startAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */],
        sa1 = endAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */],
        sx0 = sr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* cos */])(sa0),
        sy0 = sr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(sa0),
        tr = +radius.apply(this, (argv[0] = t, argv)),
        ta0 = startAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */],
        ta1 = endAngle.apply(this, argv) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */];

    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_3_d3_path__["a" /* path */])();

    context.moveTo(sx0, sy0);
    context.arc(0, 0, sr, sa0, sa1);
    if (sa0 !== ta0 || sa1 !== ta1) { // TODO sr !== tr?
      context.quadraticCurveTo(0, 0, tr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* cos */])(ta0), tr * Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(ta0));
      context.arc(0, 0, tr, ta0, ta1);
    }
    context.quadraticCurveTo(0, 0, sx0, sy0);
    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  ribbon.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), ribbon) : radius;
  };

  ribbon.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), ribbon) : startAngle;
  };

  ribbon.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), ribbon) : endAngle;
  };

  ribbon.source = function(_) {
    return arguments.length ? (source = _, ribbon) : source;
  };

  ribbon.target = function(_) {
    return arguments.length ? (target = _, ribbon) : target;
  };

  ribbon.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), ribbon) : context;
  };

  return ribbon;
});


/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pi = Math.PI,
    tau = 2 * pi,
    epsilon = 1e-6,
    tauEpsilon = tau - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon)) {}

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (path);


/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return csvParse; });
/* unused harmony export csvParseRows */
/* unused harmony export csvFormat */
/* unused harmony export csvFormatRows */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dsv__ = __webpack_require__(184);


var csv = Object(__WEBPACK_IMPORTED_MODULE_0__dsv__["a" /* default */])(",");

var csvParse = csv.parse;
var csvParseRows = csv.parseRows;
var csvFormat = csv.format;
var csvFormatRows = csv.formatRows;


/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tsvParse; });
/* unused harmony export tsvParseRows */
/* unused harmony export tsvFormat */
/* unused harmony export tsvFormatRows */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dsv__ = __webpack_require__(184);


var tsv = Object(__WEBPACK_IMPORTED_MODULE_0__dsv__["a" /* default */])("\t");

var tsvParse = tsv.parse;
var tsvParseRows = tsv.parseRows;
var tsvFormat = tsv.format;
var tsvFormatRows = tsv.formatRows;


/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_center__ = __webpack_require__(854);
/* unused harmony reexport forceCenter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_collide__ = __webpack_require__(855);
/* unused harmony reexport forceCollide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_link__ = __webpack_require__(869);
/* unused harmony reexport forceLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_manyBody__ = __webpack_require__(870);
/* unused harmony reexport forceManyBody */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_radial__ = __webpack_require__(871);
/* unused harmony reexport forceRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_simulation__ = __webpack_require__(342);
/* unused harmony reexport forceSimulation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_x__ = __webpack_require__(872);
/* unused harmony reexport forceX */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_y__ = __webpack_require__(873);
/* unused harmony reexport forceY */










/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(x, y) {
  var nodes;

  if (x == null) x = 0;
  if (y == null) y = 0;

  function force() {
    var i,
        n = nodes.length,
        node,
        sx = 0,
        sy = 0;

    for (i = 0; i < n; ++i) {
      node = nodes[i], sx += node.x, sy += node.y;
    }

    for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
      node = nodes[i], node.x -= sx, node.y -= sy;
    }
  }

  force.initialize = function(_) {
    nodes = _;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
});


/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_quadtree__ = __webpack_require__(72);




function x(d) {
  return d.x + d.vx;
}

function y(d) {
  return d.y + d.vy;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(radius) {
  var nodes,
      radii,
      strength = 1,
      iterations = 1;

  if (typeof radius !== "function") radius = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(radius == null ? 1 : +radius);

  function force() {
    var i, n = nodes.length,
        tree,
        node,
        xi,
        yi,
        ri,
        ri2;

    for (var k = 0; k < iterations; ++k) {
      tree = Object(__WEBPACK_IMPORTED_MODULE_2_d3_quadtree__["a" /* quadtree */])(nodes, x, y).visitAfter(prepare);
      for (i = 0; i < n; ++i) {
        node = nodes[i];
        ri = radii[node.index], ri2 = ri * ri;
        xi = node.x + node.vx;
        yi = node.y + node.vy;
        tree.visit(apply);
      }
    }

    function apply(quad, x0, y0, x1, y1) {
      var data = quad.data, rj = quad.r, r = ri + rj;
      if (data) {
        if (data.index > node.index) {
          var x = xi - data.x - data.vx,
              y = yi - data.y - data.vy,
              l = x * x + y * y;
          if (l < r * r) {
            if (x === 0) x = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += x * x;
            if (y === 0) y = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += y * y;
            l = (r - (l = Math.sqrt(l))) / l * strength;
            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
            node.vy += (y *= l) * r;
            data.vx -= x * (r = 1 - r);
            data.vy -= y * r;
          }
        }
        return;
      }
      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
    }
  }

  function prepare(quad) {
    if (quad.data) return quad.r = radii[quad.data.index];
    for (var i = quad.r = 0; i < 4; ++i) {
      if (quad[i] && quad[i].r > quad.r) {
        quad.r = quad[i].r;
      }
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    radii = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = +_, force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : radius;
  };

  return force;
});


/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quadtree;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__add__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cover__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__find__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__remove__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__root__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__size__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__visit__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__visitAfter__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__x__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__y__ = __webpack_require__(868);













function quadtree(nodes, x, y) {
  var tree = new Quadtree(x == null ? __WEBPACK_IMPORTED_MODULE_10__x__["b" /* defaultX */] : x, y == null ? __WEBPACK_IMPORTED_MODULE_11__y__["b" /* defaultY */] : y, NaN, NaN, NaN, NaN);
  return nodes == null ? tree : tree.addAll(nodes);
}

function Quadtree(x, y, x0, y0, x1, y1) {
  this._x = x;
  this._y = y;
  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  this._root = undefined;
}

function leaf_copy(leaf) {
  var copy = {data: leaf.data}, next = copy;
  while (leaf = leaf.next) next = next.next = {data: leaf.data};
  return copy;
}

var treeProto = quadtree.prototype = Quadtree.prototype;

treeProto.copy = function() {
  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
      node = this._root,
      nodes,
      child;

  if (!node) return copy;

  if (!node.length) return copy._root = leaf_copy(node), copy;

  nodes = [{source: node, target: copy._root = new Array(4)}];
  while (node = nodes.pop()) {
    for (var i = 0; i < 4; ++i) {
      if (child = node.source[i]) {
        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
        else node.target[i] = leaf_copy(child);
      }
    }
  }

  return copy;
};

treeProto.add = __WEBPACK_IMPORTED_MODULE_0__add__["b" /* default */];
treeProto.addAll = __WEBPACK_IMPORTED_MODULE_0__add__["a" /* addAll */];
treeProto.cover = __WEBPACK_IMPORTED_MODULE_1__cover__["a" /* default */];
treeProto.data = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */];
treeProto.extent = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */];
treeProto.find = __WEBPACK_IMPORTED_MODULE_4__find__["a" /* default */];
treeProto.remove = __WEBPACK_IMPORTED_MODULE_5__remove__["a" /* default */];
treeProto.removeAll = __WEBPACK_IMPORTED_MODULE_5__remove__["b" /* removeAll */];
treeProto.root = __WEBPACK_IMPORTED_MODULE_6__root__["a" /* default */];
treeProto.size = __WEBPACK_IMPORTED_MODULE_7__size__["a" /* default */];
treeProto.visit = __WEBPACK_IMPORTED_MODULE_8__visit__["a" /* default */];
treeProto.visitAfter = __WEBPACK_IMPORTED_MODULE_9__visitAfter__["a" /* default */];
treeProto.x = __WEBPACK_IMPORTED_MODULE_10__x__["a" /* default */];
treeProto.y = __WEBPACK_IMPORTED_MODULE_11__y__["a" /* default */];


/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addAll;
/* harmony default export */ __webpack_exports__["b"] = (function(d) {
  var x = +this._x.call(null, d),
      y = +this._y.call(null, d);
  return add(this.cover(x, y), x, y, d);
});

function add(tree, x, y, d) {
  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points

  var parent,
      node = tree._root,
      leaf = {data: d},
      x0 = tree._x0,
      y0 = tree._y0,
      x1 = tree._x1,
      y1 = tree._y1,
      xm,
      ym,
      xp,
      yp,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return tree._root = leaf, tree;

  // Find the existing leaf for the new point, or add it.
  while (node.length) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
  }

  // Is the new point is exactly coincident with the existing point?
  xp = +tree._x.call(null, node.data);
  yp = +tree._y.call(null, node.data);
  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;

  // Otherwise, split the leaf node until the old and new point are separated.
  do {
    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
  return parent[j] = node, parent[i] = leaf, tree;
}

function addAll(data) {
  var d, i, n = data.length,
      x,
      y,
      xz = new Array(n),
      yz = new Array(n),
      x0 = Infinity,
      y0 = Infinity,
      x1 = -Infinity,
      y1 = -Infinity;

  // Compute the points and their extent.
  for (i = 0; i < n; ++i) {
    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
    xz[i] = x;
    yz[i] = y;
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
  }

  // If there were no (valid) points, inherit the existing extent.
  if (x1 < x0) x0 = this._x0, x1 = this._x1;
  if (y1 < y0) y0 = this._y0, y1 = this._y1;

  // Expand the tree to cover the new points.
  this.cover(x0, y0).cover(x1, y1);

  // Add the new points.
  for (i = 0; i < n; ++i) {
    add(this, xz[i], yz[i], data[i]);
  }

  return this;
}


/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points

  var x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1;

  // If the quadtree has no extent, initialize them.
  // Integer extent are necessary so that if we later double the extent,
  // the existing quadrant boundaries don’t change due to floating point error!
  if (isNaN(x0)) {
    x1 = (x0 = Math.floor(x)) + 1;
    y1 = (y0 = Math.floor(y)) + 1;
  }

  // Otherwise, double repeatedly to cover.
  else if (x0 > x || x > x1 || y0 > y || y > y1) {
    var z = x1 - x0,
        node = this._root,
        parent,
        i;

    switch (i = (y < (y0 + y1) / 2) << 1 | (x < (x0 + x1) / 2)) {
      case 0: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
        break;
      }
      case 1: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
        break;
      }
      case 2: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
        break;
      }
      case 3: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
        break;
      }
    }

    if (this._root && this._root.length) this._root = node;
  }

  // If the quadtree covers the point already, just return.
  else return this;

  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  return this;
});


/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var data = [];
  this.visit(function(node) {
    if (!node.length) do data.push(node.data); while (node = node.next)
  });
  return data;
});


/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(_) {
  return arguments.length
      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
});


/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(186);


/* harmony default export */ __webpack_exports__["a"] = (function(x, y, radius) {
  var data,
      x0 = this._x0,
      y0 = this._y0,
      x1,
      y1,
      x2,
      y2,
      x3 = this._x1,
      y3 = this._y1,
      quads = [],
      node = this._root,
      q,
      i;

  if (node) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node, x0, y0, x3, y3));
  if (radius == null) radius = Infinity;
  else {
    x0 = x - radius, y0 = y - radius;
    x3 = x + radius, y3 = y + radius;
    radius *= radius;
  }

  while (q = quads.pop()) {

    // Stop searching if this quadrant can’t contain a closer node.
    if (!(node = q.node)
        || (x1 = q.x0) > x3
        || (y1 = q.y0) > y3
        || (x2 = q.x1) < x0
        || (y2 = q.y1) < y0) continue;

    // Bisect the current quadrant.
    if (node.length) {
      var xm = (x1 + x2) / 2,
          ym = (y1 + y2) / 2;

      quads.push(
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[3], xm, ym, x2, y2),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[2], x1, ym, xm, y2),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[1], xm, y1, x2, ym),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[0], x1, y1, xm, ym)
      );

      // Visit the closest quadrant first.
      if (i = (y >= ym) << 1 | (x >= xm)) {
        q = quads[quads.length - 1];
        quads[quads.length - 1] = quads[quads.length - 1 - i];
        quads[quads.length - 1 - i] = q;
      }
    }

    // Visit this point. (Visiting coincident points isn’t necessary!)
    else {
      var dx = x - +this._x.call(null, node.data),
          dy = y - +this._y.call(null, node.data),
          d2 = dx * dx + dy * dy;
      if (d2 < radius) {
        var d = Math.sqrt(radius = d2);
        x0 = x - d, y0 = y - d;
        x3 = x + d, y3 = y + d;
        data = node.data;
      }
    }
  }

  return data;
});


/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = removeAll;
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points

  var parent,
      node = this._root,
      retainer,
      previous,
      next,
      x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1,
      x,
      y,
      xm,
      ym,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return this;

  // Find the leaf node for the point.
  // While descending, also retain the deepest parent with a non-removed sibling.
  if (node.length) while (true) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
    if (!node.length) break;
    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
  }

  // Find the point to remove.
  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
  if (next = node.next) delete node.next;

  // If there are multiple coincident points, remove just the point.
  if (previous) return (next ? previous.next = next : delete previous.next), this;

  // If this is the root point, remove it.
  if (!parent) return this._root = next, this;

  // Remove this leaf.
  next ? parent[i] = next : delete parent[i];

  // If the parent now contains exactly one leaf, collapse superfluous parents.
  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
      && node === (parent[3] || parent[2] || parent[1] || parent[0])
      && !node.length) {
    if (retainer) retainer[j] = node;
    else this._root = node;
  }

  return this;
});

function removeAll(data) {
  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
  return this;
}


/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this._root;
});


/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var size = 0;
  this.visit(function(node) {
    if (!node.length) do ++size; while (node = node.next)
  });
  return size;
});


/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(186);


/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
  if (node) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[3]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, ym, x1, y1));
      if (child = node[2]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, ym, xm, y1));
      if (child = node[1]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, y0, x1, ym));
      if (child = node[0]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, y0, xm, ym));
    }
  }
  return this;
});


/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(186);


/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var quads = [], next = [], q;
  if (this._root) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](this._root, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    var node = q.node;
    if (node.length) {
      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[0]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, y0, xm, ym));
      if (child = node[1]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, y0, x1, ym));
      if (child = node[2]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, ym, xm, y1));
      if (child = node[3]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, ym, x1, y1));
    }
    next.push(q);
  }
  while (q = next.pop()) {
    callback(q.node, q.x0, q.y0, q.x1, q.y1);
  }
  return this;
});


/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultX;
function defaultX(d) {
  return d[0];
}

/* harmony default export */ __webpack_exports__["a"] = (function(_) {
  return arguments.length ? (this._x = _, this) : this._x;
});


/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultY;
function defaultY(d) {
  return d[1];
}

/* harmony default export */ __webpack_exports__["a"] = (function(_) {
  return arguments.length ? (this._y = _, this) : this._y;
});


/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_collection__ = __webpack_require__(34);




function index(d) {
  return d.index;
}

function find(nodeById, nodeId) {
  var node = nodeById.get(nodeId);
  if (!node) throw new Error("missing: " + nodeId);
  return node;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(links) {
  var id = index,
      strength = defaultStrength,
      strengths,
      distance = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(30),
      distances,
      nodes,
      count,
      bias,
      iterations = 1;

  if (links == null) links = [];

  function defaultStrength(link) {
    return 1 / Math.min(count[link.source.index], count[link.target.index]);
  }

  function force(alpha) {
    for (var k = 0, n = links.length; k < iterations; ++k) {
      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
        link = links[i], source = link.source, target = link.target;
        x = target.x + target.vx - source.x - source.vx || Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])();
        y = target.y + target.vy - source.y - source.vy || Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])();
        l = Math.sqrt(x * x + y * y);
        l = (l - distances[i]) / l * alpha * strengths[i];
        x *= l, y *= l;
        target.vx -= x * (b = bias[i]);
        target.vy -= y * b;
        source.vx += x * (b = 1 - b);
        source.vy += y * b;
      }
    }
  }

  function initialize() {
    if (!nodes) return;

    var i,
        n = nodes.length,
        m = links.length,
        nodeById = Object(__WEBPACK_IMPORTED_MODULE_2_d3_collection__["map"])(nodes, id),
        link;

    for (i = 0, count = new Array(n); i < m; ++i) {
      link = links[i], link.index = i;
      if (typeof link.source !== "object") link.source = find(nodeById, link.source);
      if (typeof link.target !== "object") link.target = find(nodeById, link.target);
      count[link.source.index] = (count[link.source.index] || 0) + 1;
      count[link.target.index] = (count[link.target.index] || 0) + 1;
    }

    for (i = 0, bias = new Array(m); i < m; ++i) {
      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
    }

    strengths = new Array(m), initializeStrength();
    distances = new Array(m), initializeDistance();
  }

  function initializeStrength() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      strengths[i] = +strength(links[i], i, links);
    }
  }

  function initializeDistance() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      distances[i] = +distance(links[i], i, links);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.links = function(_) {
    return arguments.length ? (links = _, initialize(), force) : links;
  };

  force.id = function(_) {
    return arguments.length ? (id = _, force) : id;
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initializeStrength(), force) : strength;
  };

  force.distance = function(_) {
    return arguments.length ? (distance = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initializeDistance(), force) : distance;
  };

  return force;
});


/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_quadtree__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__simulation__ = __webpack_require__(342);





/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var nodes,
      node,
      alpha,
      strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(-30),
      strengths,
      distanceMin2 = 1,
      distanceMax2 = Infinity,
      theta2 = 0.81;

  function force(_) {
    var i, n = nodes.length, tree = Object(__WEBPACK_IMPORTED_MODULE_2_d3_quadtree__["a" /* quadtree */])(nodes, __WEBPACK_IMPORTED_MODULE_3__simulation__["a" /* x */], __WEBPACK_IMPORTED_MODULE_3__simulation__["b" /* y */]).visitAfter(accumulate);
    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    strengths = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
  }

  function accumulate(quad) {
    var strength = 0, q, c, weight = 0, x, y, i;

    // For internal nodes, accumulate forces from child quadrants.
    if (quad.length) {
      for (x = y = i = 0; i < 4; ++i) {
        if ((q = quad[i]) && (c = Math.abs(q.value))) {
          strength += q.value, weight += c, x += c * q.x, y += c * q.y;
        }
      }
      quad.x = x / weight;
      quad.y = y / weight;
    }

    // For leaf nodes, accumulate forces from coincident quadrants.
    else {
      q = quad;
      q.x = q.data.x;
      q.y = q.data.y;
      do strength += strengths[q.data.index];
      while (q = q.next);
    }

    quad.value = strength;
  }

  function apply(quad, x1, _, x2) {
    if (!quad.value) return true;

    var x = quad.x - node.x,
        y = quad.y - node.y,
        w = x2 - x1,
        l = x * x + y * y;

    // Apply the Barnes-Hut approximation if possible.
    // Limit forces for very close nodes; randomize direction if coincident.
    if (w * w / theta2 < l) {
      if (l < distanceMax2) {
        if (x === 0) x = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += x * x;
        if (y === 0) y = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += y * y;
        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        node.vx += x * quad.value * alpha / l;
        node.vy += y * quad.value * alpha / l;
      }
      return true;
    }

    // Otherwise, process points directly.
    else if (quad.length || l >= distanceMax2) return;

    // Limit forces for very close nodes; randomize direction if coincident.
    if (quad.data !== node || quad.next) {
      if (x === 0) x = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += x * x;
      if (y === 0) y = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += y * y;
      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
    }

    do if (quad.data !== node) {
      w = strengths[quad.data.index] * alpha / l;
      node.vx += x * w;
      node.vy += y * w;
    } while (quad = quad.next);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.distanceMin = function(_) {
    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
  };

  force.distanceMax = function(_) {
    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
  };

  force.theta = function(_) {
    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
  };

  return force;
});


/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(55);


/* unused harmony default export */ var _unused_webpack_default_export = (function(radius, x, y) {
  var nodes,
      strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0.1),
      strengths,
      radiuses;

  if (typeof radius !== "function") radius = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+radius);
  if (x == null) x = 0;
  if (y == null) y = 0;

  function force(alpha) {
    for (var i = 0, n = nodes.length; i < n; ++i) {
      var node = nodes[i],
          dx = node.x - x || 1e-6,
          dy = node.y - y || 1e-6,
          r = Math.sqrt(dx * dx + dy * dy),
          k = (radiuses[i] - r) * strengths[i] * alpha / r;
      node.vx += dx * k;
      node.vy += dy * k;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    radiuses = new Array(n);
    for (i = 0; i < n; ++i) {
      radiuses[i] = +radius(nodes[i], i, nodes);
      strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _, initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : radius;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
});


/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(55);


/* unused harmony default export */ var _unused_webpack_default_export = (function(x) {
  var strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0.1),
      nodes,
      strengths,
      xz;

  if (typeof x !== "function") x = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(x == null ? 0 : +x);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    xz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : x;
  };

  return force;
});


/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(55);


/* unused harmony default export */ var _unused_webpack_default_export = (function(y) {
  var strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0.1),
      nodes,
      strengths,
      yz;

  if (typeof y !== "function") y = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(y == null ? 0 : +y);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    yz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : y;
  };

  return force;
});


/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_cluster__ = __webpack_require__(875);
/* unused harmony reexport cluster */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_hierarchy_index__ = __webpack_require__(187);
/* unused harmony reexport hierarchy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_pack_index__ = __webpack_require__(887);
/* unused harmony reexport pack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_pack_siblings__ = __webpack_require__(343);
/* unused harmony reexport packSiblings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_pack_enclose__ = __webpack_require__(344);
/* unused harmony reexport packEnclose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_partition__ = __webpack_require__(889);
/* unused harmony reexport partition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_stratify__ = __webpack_require__(890);
/* unused harmony reexport stratify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_tree__ = __webpack_require__(891);
/* unused harmony reexport tree */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_treemap_index__ = __webpack_require__(892);
/* unused harmony reexport treemap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_treemap_binary__ = __webpack_require__(893);
/* unused harmony reexport treemapBinary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_treemap_dice__ = __webpack_require__(73);
/* unused harmony reexport treemapDice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_treemap_slice__ = __webpack_require__(114);
/* unused harmony reexport treemapSlice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_treemap_sliceDice__ = __webpack_require__(894);
/* unused harmony reexport treemapSliceDice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_treemap_squarify__ = __webpack_require__(189);
/* unused harmony reexport treemapSquarify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_treemap_resquarify__ = __webpack_require__(895);
/* unused harmony reexport treemapResquarify */

















/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

function meanX(children) {
  return children.reduce(meanXReduce, 0) / children.length;
}

function meanXReduce(x, c) {
  return x + c.x;
}

function maxY(children) {
  return 1 + children.reduce(maxYReduce, 0);
}

function maxYReduce(y, c) {
  return Math.max(y, c.y);
}

function leafLeft(node) {
  var children;
  while (children = node.children) node = children[0];
  return node;
}

function leafRight(node) {
  var children;
  while (children = node.children) node = children[children.length - 1];
  return node;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = false;

  function cluster(root) {
    var previousNode,
        x = 0;

    // First walk, computing the initial x & y values.
    root.eachAfter(function(node) {
      var children = node.children;
      if (children) {
        node.x = meanX(children);
        node.y = maxY(children);
      } else {
        node.x = previousNode ? x += separation(node, previousNode) : 0;
        node.y = 0;
        previousNode = node;
      }
    });

    var left = leafLeft(root),
        right = leafRight(root),
        x0 = left.x - separation(left, right) / 2,
        x1 = right.x + separation(right, left) / 2;

    // Second walk, normalizing x & y to the desired size.
    return root.eachAfter(nodeSize ? function(node) {
      node.x = (node.x - root.x) * dx;
      node.y = (root.y - node.y) * dy;
    } : function(node) {
      node.x = (node.x - x0) / (x1 - x0) * dx;
      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
    });
  }

  cluster.separation = function(x) {
    return arguments.length ? (separation = x, cluster) : separation;
  };

  cluster.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
  };

  cluster.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
  };

  return cluster;
});


/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function count(node) {
  var sum = 0,
      children = node.children,
      i = children && children.length;
  if (!i) sum = 1;
  else while (--i >= 0) sum += children[i].value;
  node.value = sum;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.eachAfter(count);
});


/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, current, next = [node], children, i, n;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      callback(node), children = node.children;
      if (children) for (i = 0, n = children.length; i < n; ++i) {
        next.push(children[i]);
      }
    }
  } while (next.length);
  return this;
});


/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, nodes = [node], children, i;
  while (node = nodes.pop()) {
    callback(node), children = node.children;
    if (children) for (i = children.length - 1; i >= 0; --i) {
      nodes.push(children[i]);
    }
  }
  return this;
});


/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, nodes = [node], next = [], children, i, n;
  while (node = nodes.pop()) {
    next.push(node), children = node.children;
    if (children) for (i = 0, n = children.length; i < n; ++i) {
      nodes.push(children[i]);
    }
  }
  while (node = next.pop()) {
    callback(node);
  }
  return this;
});


/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return this.eachAfter(function(node) {
    var sum = +value(node.data) || 0,
        children = node.children,
        i = children && children.length;
    while (--i >= 0) sum += children[i].value;
    node.value = sum;
  });
});


/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
});


/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(end) {
  var start = this,
      ancestor = leastCommonAncestor(start, end),
      nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k, 0, end);
    end = end.parent;
  }
  return nodes;
});

function leastCommonAncestor(a, b) {
  if (a === b) return a;
  var aNodes = a.ancestors(),
      bNodes = b.ancestors(),
      c = null;
  a = aNodes.pop();
  b = bNodes.pop();
  while (a === b) {
    c = a;
    a = aNodes.pop();
    b = bNodes.pop();
  }
  return c;
}


/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
});


/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes = [];
  this.each(function(node) {
    nodes.push(node);
  });
  return nodes;
});


/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
});


/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var root = this, links = [];
  root.each(function(node) {
    if (node !== root) { // Don’t include the root’s parent, if any.
      links.push({source: node.parent, target: node});
    }
  });
  return links;
});


/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__siblings__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessors__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(345);




function defaultRadius(d) {
  return Math.sqrt(d.value);
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var radius = null,
      dx = 1,
      dy = 1,
      padding = __WEBPACK_IMPORTED_MODULE_2__constant__["a" /* constantZero */];

  function pack(root) {
    root.x = dx / 2, root.y = dy / 2;
    if (radius) {
      root.eachBefore(radiusLeaf(radius))
          .eachAfter(packChildren(padding, 0.5))
          .eachBefore(translateChild(1));
    } else {
      root.eachBefore(radiusLeaf(defaultRadius))
          .eachAfter(packChildren(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* constantZero */], 1))
          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
    }
    return root;
  }

  pack.radius = function(x) {
    return arguments.length ? (radius = Object(__WEBPACK_IMPORTED_MODULE_1__accessors__["a" /* optional */])(x), pack) : radius;
  };

  pack.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
  };

  pack.padding = function(x) {
    return arguments.length ? (padding = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["b" /* default */])(+x), pack) : padding;
  };

  return pack;
});

function radiusLeaf(radius) {
  return function(node) {
    if (!node.children) {
      node.r = Math.max(0, +radius(node) || 0);
    }
  };
}

function packChildren(padding, k) {
  return function(node) {
    if (children = node.children) {
      var children,
          i,
          n = children.length,
          r = padding(node) * k || 0,
          e;

      if (r) for (i = 0; i < n; ++i) children[i].r += r;
      e = Object(__WEBPACK_IMPORTED_MODULE_0__siblings__["a" /* packEnclose */])(children);
      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
      node.r = e + r;
    }
  };
}

function translateChild(k) {
  return function(node) {
    var parent = node.parent;
    node.r *= k;
    if (parent) {
      node.x = parent.x + k * node.x;
      node.y = parent.y + k * node.y;
    }
  };
}


/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (immutable) */ __webpack_exports__["a"] = shuffle;
var slice = Array.prototype.slice;

function shuffle(array) {
  var m = array.length,
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }

  return array;
}


/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__treemap_round__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__treemap_dice__ = __webpack_require__(73);



/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var dx = 1,
      dy = 1,
      padding = 0,
      round = false;

  function partition(root) {
    var n = root.height + 1;
    root.x0 =
    root.y0 = padding;
    root.x1 = dx;
    root.y1 = dy / n;
    root.eachBefore(positionNode(dy, n));
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__treemap_round__["a" /* default */]);
    return root;
  }

  function positionNode(dy, n) {
    return function(node) {
      if (node.children) {
        Object(__WEBPACK_IMPORTED_MODULE_1__treemap_dice__["a" /* default */])(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
      }
      var x0 = node.x0,
          y0 = node.y0,
          x1 = node.x1 - padding,
          y1 = node.y1 - padding;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;
    };
  }

  partition.round = function(x) {
    return arguments.length ? (round = !!x, partition) : round;
  };

  partition.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
  };

  partition.padding = function(x) {
    return arguments.length ? (padding = +x, partition) : padding;
  };

  return partition;
});


/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessors__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__ = __webpack_require__(187);



var keyPrefix = "$", // Protect against keys like “__proto__”.
    preroot = {depth: -1},
    ambiguous = {};

function defaultId(d) {
  return d.id;
}

function defaultParentId(d) {
  return d.parentId;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var id = defaultId,
      parentId = defaultParentId;

  function stratify(data) {
    var d,
        i,
        n = data.length,
        root,
        parent,
        node,
        nodes = new Array(n),
        nodeId,
        nodeKey,
        nodeByKey = {};

    for (i = 0; i < n; ++i) {
      d = data[i], node = nodes[i] = new __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__["a" /* Node */](d);
      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
        nodeKey = keyPrefix + (node.id = nodeId);
        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
      }
    }

    for (i = 0; i < n; ++i) {
      node = nodes[i], nodeId = parentId(data[i], i, data);
      if (nodeId == null || !(nodeId += "")) {
        if (root) throw new Error("multiple roots");
        root = node;
      } else {
        parent = nodeByKey[keyPrefix + nodeId];
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);
        else parent.children = [node];
        node.parent = parent;
      }
    }

    if (!root) throw new Error("no root");
    root.parent = preroot;
    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(__WEBPACK_IMPORTED_MODULE_1__hierarchy_index__["b" /* computeHeight */]);
    root.parent = null;
    if (n > 0) throw new Error("cycle");

    return root;
  }

  stratify.id = function(x) {
    return arguments.length ? (id = Object(__WEBPACK_IMPORTED_MODULE_0__accessors__["b" /* required */])(x), stratify) : id;
  };

  stratify.parentId = function(x) {
    return arguments.length ? (parentId = Object(__WEBPACK_IMPORTED_MODULE_0__accessors__["b" /* required */])(x), stratify) : parentId;
  };

  return stratify;
});


/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hierarchy_index__ = __webpack_require__(187);


function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }

// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
  var children = v.children;
  return children ? children[0] : v.t;
}

// This function works analogously to nextLeft.
function nextRight(v) {
  var children = v.children;
  return children ? children[children.length - 1] : v.t;
}

// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
}

// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
  var shift = 0,
      change = 0,
      children = v.children,
      i = children.length,
      w;
  while (--i >= 0) {
    w = children[i];
    w.z += shift;
    w.m += shift;
    shift += w.s + (change += w.c);
  }
}

// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
  return vim.a.parent === v.parent ? vim.a : ancestor;
}

function TreeNode(node, i) {
  this._ = node;
  this.parent = null;
  this.children = null;
  this.A = null; // default ancestor
  this.a = this; // ancestor
  this.z = 0; // prelim
  this.m = 0; // mod
  this.c = 0; // change
  this.s = 0; // shift
  this.t = null; // thread
  this.i = i; // number
}

TreeNode.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_0__hierarchy_index__["a" /* Node */].prototype);

function treeRoot(root) {
  var tree = new TreeNode(root, 0),
      node,
      nodes = [tree],
      child,
      children,
      i,
      n;

  while (node = nodes.pop()) {
    if (children = node._.children) {
      node.children = new Array(n = children.length);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
        child.parent = node;
      }
    }
  }

  (tree.parent = new TreeNode(null, 0)).children = [tree];
  return tree;
}

// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = null;

  function tree(root) {
    var t = treeRoot(root);

    // Compute the layout using Buchheim et al.’s algorithm.
    t.eachAfter(firstWalk), t.parent.m = -t.z;
    t.eachBefore(secondWalk);

    // If a fixed node size is specified, scale x and y.
    if (nodeSize) root.eachBefore(sizeNode);

    // If a fixed tree size is specified, scale x and y based on the extent.
    // Compute the left-most, right-most, and depth-most nodes for extents.
    else {
      var left = root,
          right = root,
          bottom = root;
      root.eachBefore(function(node) {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
        if (node.depth > bottom.depth) bottom = node;
      });
      var s = left === right ? 1 : separation(left, right) / 2,
          tx = s - left.x,
          kx = dx / (right.x + s + tx),
          ky = dy / (bottom.depth || 1);
      root.eachBefore(function(node) {
        node.x = (node.x + tx) * kx;
        node.y = node.depth * ky;
      });
    }

    return root;
  }

  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
  // applied recursively to the children of v, as well as the function
  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
  // node v is placed to the midpoint of its outermost children.
  function firstWalk(v) {
    var children = v.children,
        siblings = v.parent.children,
        w = v.i ? siblings[v.i - 1] : null;
    if (children) {
      executeShifts(v);
      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
      if (w) {
        v.z = w.z + separation(v._, w._);
        v.m = v.z - midpoint;
      } else {
        v.z = midpoint;
      }
    } else if (w) {
      v.z = w.z + separation(v._, w._);
    }
    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
  }

  // Computes all real x-coordinates by summing up the modifiers recursively.
  function secondWalk(v) {
    v._.x = v.z + v.parent.m;
    v.m += v.parent.m;
  }

  // The core of the algorithm. Here, a new subtree is combined with the
  // previous subtrees. Threads are used to traverse the inside and outside
  // contours of the left and right subtree up to the highest common level. The
  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
  // superscript o means outside and i means inside, the subscript - means left
  // subtree and + means right subtree. For summing up the modifiers along the
  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
  // nodes of the inside contours conflict, we compute the left one of the
  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
  // Finally, we add a new thread (if necessary).
  function apportion(v, w, ancestor) {
    if (w) {
      var vip = v,
          vop = v,
          vim = w,
          vom = vip.parent.children[0],
          sip = vip.m,
          sop = vop.m,
          sim = vim.m,
          som = vom.m,
          shift;
      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
          sip += shift;
          sop += shift;
        }
        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }
      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }
      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v;
      }
    }
    return ancestor;
  }

  function sizeNode(node) {
    node.x *= dx;
    node.y = node.depth * dy;
  }

  tree.separation = function(x) {
    return arguments.length ? (separation = x, tree) : separation;
  };

  tree.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
  };

  tree.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
  };

  return tree;
});


/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__round__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__squarify__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accessors__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(345);





/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var tile = __WEBPACK_IMPORTED_MODULE_1__squarify__["a" /* default */],
      round = false,
      dx = 1,
      dy = 1,
      paddingStack = [0],
      paddingInner = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingTop = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingRight = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingBottom = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingLeft = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */];

  function treemap(root) {
    root.x0 =
    root.y0 = 0;
    root.x1 = dx;
    root.y1 = dy;
    root.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__round__["a" /* default */]);
    return root;
  }

  function positionNode(node) {
    var p = paddingStack[node.depth],
        x0 = node.x0 + p,
        y0 = node.y0 + p,
        x1 = node.x1 - p,
        y1 = node.y1 - p;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p;
      y0 += paddingTop(node) - p;
      x1 -= paddingRight(node) - p;
      y1 -= paddingBottom(node) - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }

  treemap.round = function(x) {
    return arguments.length ? (round = !!x, treemap) : round;
  };

  treemap.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
  };

  treemap.tile = function(x) {
    return arguments.length ? (tile = Object(__WEBPACK_IMPORTED_MODULE_2__accessors__["b" /* required */])(x), treemap) : tile;
  };

  treemap.padding = function(x) {
    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
  };

  treemap.paddingInner = function(x) {
    return arguments.length ? (paddingInner = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingInner;
  };

  treemap.paddingOuter = function(x) {
    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
  };

  treemap.paddingTop = function(x) {
    return arguments.length ? (paddingTop = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingTop;
  };

  treemap.paddingRight = function(x) {
    return arguments.length ? (paddingRight = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingRight;
  };

  treemap.paddingBottom = function(x) {
    return arguments.length ? (paddingBottom = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingBottom;
  };

  treemap.paddingLeft = function(x) {
    return arguments.length ? (paddingLeft = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingLeft;
  };

  return treemap;
});


/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      i, n = nodes.length,
      sum, sums = new Array(n + 1);

  for (sums[0] = sum = i = 0; i < n; ++i) {
    sums[i + 1] = sum += nodes[i].value;
  }

  partition(0, n, parent.value, x0, y0, x1, y1);

  function partition(i, j, value, x0, y0, x1, y1) {
    if (i >= j - 1) {
      var node = nodes[i];
      node.x0 = x0, node.y0 = y0;
      node.x1 = x1, node.y1 = y1;
      return;
    }

    var valueOffset = sums[i],
        valueTarget = (value / 2) + valueOffset,
        k = i + 1,
        hi = j - 1;

    while (k < hi) {
      var mid = k + hi >>> 1;
      if (sums[mid] < valueTarget) k = mid + 1;
      else hi = mid;
    }

    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;

    var valueLeft = sums[k] - valueOffset,
        valueRight = value - valueLeft;

    if ((x1 - x0) > (y1 - y0)) {
      var xk = (x0 * valueRight + x1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, xk, y1);
      partition(k, j, valueRight, xk, y0, x1, y1);
    } else {
      var yk = (y0 * valueRight + y1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, x1, yk);
      partition(k, j, valueRight, x0, yk, x1, y1);
    }
  }
});


/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(114);



/* unused harmony default export */ var _unused_webpack_default_export = (function(parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? __WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(parent, x0, y0, x1, y1);
});


/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__squarify__ = __webpack_require__(189);




/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(ratio) {

  function resquarify(parent, x0, y0, x1, y1) {
    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
      var rows,
          row,
          nodes,
          i,
          j = -1,
          n,
          m = rows.length,
          value = parent.value;

      while (++j < m) {
        row = rows[j], nodes = row.children;
        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
        if (row.dice) Object(__WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
        else Object(__WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */])(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = Object(__WEBPACK_IMPORTED_MODULE_2__squarify__["c" /* squarifyRatio */])(ratio, parent, x0, y0, x1, y1);
      rows.ratio = ratio;
    }
  }

  resquarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return resquarify;
})(__WEBPACK_IMPORTED_MODULE_2__squarify__["b" /* phi */]));


/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_area__ = __webpack_require__(897);
/* unused harmony reexport polygonArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_centroid__ = __webpack_require__(898);
/* unused harmony reexport polygonCentroid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_hull__ = __webpack_require__(899);
/* unused harmony reexport polygonHull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_contains__ = __webpack_require__(901);
/* unused harmony reexport polygonContains */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_length__ = __webpack_require__(902);
/* unused harmony reexport polygonLength */







/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(polygon) {
  var i = -1,
      n = polygon.length,
      a,
      b = polygon[n - 1],
      area = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    area += a[1] * b[0] - a[0] * b[1];
  }

  return area / 2;
});


/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(polygon) {
  var i = -1,
      n = polygon.length,
      x = 0,
      y = 0,
      a,
      b = polygon[n - 1],
      c,
      k = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    k += c = a[0] * b[1] - b[0] * a[1];
    x += (a[0] + b[0]) * c;
    y += (a[1] + b[1]) * c;
  }

  return k *= 3, [x / k, y / k];
});


/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cross__ = __webpack_require__(900);


function lexicographicOrder(a, b) {
  return a[0] - b[0] || a[1] - b[1];
}

// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function computeUpperHullIndexes(points) {
  var n = points.length,
      indexes = [0, 1],
      size = 2;

  for (var i = 2; i < n; ++i) {
    while (size > 1 && Object(__WEBPACK_IMPORTED_MODULE_0__cross__["a" /* default */])(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0) --size;
    indexes[size++] = i;
  }

  return indexes.slice(0, size); // remove popped points
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(points) {
  if ((n = points.length) < 3) return null;

  var i,
      n,
      sortedPoints = new Array(n),
      flippedPoints = new Array(n);

  for (i = 0; i < n; ++i) sortedPoints[i] = [+points[i][0], +points[i][1], i];
  sortedPoints.sort(lexicographicOrder);
  for (i = 0; i < n; ++i) flippedPoints[i] = [sortedPoints[i][0], -sortedPoints[i][1]];

  var upperIndexes = computeUpperHullIndexes(sortedPoints),
      lowerIndexes = computeUpperHullIndexes(flippedPoints);

  // Construct the hull polygon, removing possible duplicate endpoints.
  var skipLeft = lowerIndexes[0] === upperIndexes[0],
      skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1],
      hull = [];

  // Add upper hull in right-to-l order.
  // Then add lower hull in left-to-right order.
  for (i = upperIndexes.length - 1; i >= 0; --i) hull.push(points[sortedPoints[upperIndexes[i]][2]]);
  for (i = +skipLeft; i < lowerIndexes.length - skipRight; ++i) hull.push(points[sortedPoints[lowerIndexes[i]][2]]);

  return hull;
});


/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
/* harmony default export */ __webpack_exports__["a"] = (function(a, b, c) {
  return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
});


/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(polygon, point) {
  var n = polygon.length,
      p = polygon[n - 1],
      x = point[0], y = point[1],
      x0 = p[0], y0 = p[1],
      x1, y1,
      inside = false;

  for (var i = 0; i < n; ++i) {
    p = polygon[i], x1 = p[0], y1 = p[1];
    if (((y1 > y) !== (y0 > y)) && (x < (x0 - x1) * (y - y1) / (y0 - y1) + x1)) inside = !inside;
    x0 = x1, y0 = y1;
  }

  return inside;
});


/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(polygon) {
  var i = -1,
      n = polygon.length,
      b = polygon[n - 1],
      xa,
      ya,
      xb = b[0],
      yb = b[1],
      perimeter = 0;

  while (++i < n) {
    xa = xb;
    ya = yb;
    b = polygon[i];
    xb = b[0];
    yb = b[1];
    xa -= xb;
    ya -= yb;
    perimeter += Math.sqrt(xa * xa + ya * ya);
  }

  return perimeter;
});


/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_queue__ = __webpack_require__(904);
/* unused harmony reexport queue */



/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(905);


var noabort = {};

function Queue(size) {
  this._size = size;
  this._call =
  this._error = null;
  this._tasks = [];
  this._data = [];
  this._waiting =
  this._active =
  this._ended =
  this._start = 0; // inside a synchronous task callback?
}

Queue.prototype = queue.prototype = {
  constructor: Queue,
  defer: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("defer after await");
    if (this._error != null) return this;
    var t = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(arguments, 1);
    t.push(callback);
    ++this._waiting, this._tasks.push(t);
    poke(this);
    return this;
  },
  abort: function() {
    if (this._error == null) abort(this, new Error("abort"));
    return this;
  },
  await: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    this._call = function(error, results) { callback.apply(null, [error].concat(results)); };
    maybeNotify(this);
    return this;
  },
  awaitAll: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    this._call = callback;
    maybeNotify(this);
    return this;
  }
};

function poke(q) {
  if (!q._start) {
    try { start(q); } // let the current task complete
    catch (e) {
      if (q._tasks[q._ended + q._active - 1]) abort(q, e); // task errored synchronously
      else if (!q._data) throw e; // await callback errored synchronously
    }
  }
}

function start(q) {
  while (q._start = q._waiting && q._active < q._size) {
    var i = q._ended + q._active,
        t = q._tasks[i],
        j = t.length - 1,
        c = t[j];
    t[j] = end(q, i);
    --q._waiting, ++q._active;
    t = c.apply(null, t);
    if (!q._tasks[i]) continue; // task finished synchronously
    q._tasks[i] = t || noabort;
  }
}

function end(q, i) {
  return function(e, r) {
    if (!q._tasks[i]) return; // ignore multiple callbacks
    --q._active, ++q._ended;
    q._tasks[i] = null;
    if (q._error != null) return; // ignore secondary errors
    if (e != null) {
      abort(q, e);
    } else {
      q._data[i] = r;
      if (q._waiting) poke(q);
      else maybeNotify(q);
    }
  };
}

function abort(q, e) {
  var i = q._tasks.length, t;
  q._error = e; // ignore active callbacks
  q._data = undefined; // allow gc
  q._waiting = NaN; // prevent starting

  while (--i >= 0) {
    if (t = q._tasks[i]) {
      q._tasks[i] = null;
      if (t.abort) {
        try { t.abort(); }
        catch (e) { /* ignore */ }
      }
    }
  }

  q._active = NaN; // allow notification
  maybeNotify(q);
}

function maybeNotify(q) {
  if (!q._active && q._call) {
    var d = q._data;
    q._data = undefined; // allow gc
    q._call(q._error, d);
  }
}

function queue(concurrency) {
  if (concurrency == null) concurrency = Infinity;
  else if (!((concurrency = +concurrency) >= 1)) throw new Error("invalid concurrency");
  return new Queue(concurrency);
}


/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = [].slice;


/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_uniform__ = __webpack_require__(907);
/* unused harmony reexport randomUniform */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_normal__ = __webpack_require__(347);
/* unused harmony reexport randomNormal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_logNormal__ = __webpack_require__(908);
/* unused harmony reexport randomLogNormal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_bates__ = __webpack_require__(909);
/* unused harmony reexport randomBates */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_irwinHall__ = __webpack_require__(348);
/* unused harmony reexport randomIrwinHall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_exponential__ = __webpack_require__(910);
/* unused harmony reexport randomExponential */








/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(56);


/* unused harmony default export */ var _unused_webpack_default_export = ((function sourceRandomUniform(source) {
  function randomUniform(min, max) {
    min = min == null ? 0 : +min;
    max = max == null ? 1 : +max;
    if (arguments.length === 1) max = min, min = 0;
    else max -= min;
    return function() {
      return source() * max + min;
    };
  }

  randomUniform.source = sourceRandomUniform;

  return randomUniform;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__normal__ = __webpack_require__(347);



/* unused harmony default export */ var _unused_webpack_default_export = ((function sourceRandomLogNormal(source) {
  function randomLogNormal() {
    var randomNormal = __WEBPACK_IMPORTED_MODULE_1__normal__["a" /* default */].source(source).apply(this, arguments);
    return function() {
      return Math.exp(randomNormal());
    };
  }

  randomLogNormal.source = sourceRandomLogNormal;

  return randomLogNormal;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__irwinHall__ = __webpack_require__(348);



/* unused harmony default export */ var _unused_webpack_default_export = ((function sourceRandomBates(source) {
  function randomBates(n) {
    var randomIrwinHall = __WEBPACK_IMPORTED_MODULE_1__irwinHall__["a" /* default */].source(source)(n);
    return function() {
      return randomIrwinHall() / n;
    };
  }

  randomBates.source = sourceRandomBates;

  return randomBates;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultSource__ = __webpack_require__(56);


/* unused harmony default export */ var _unused_webpack_default_export = ((function sourceRandomExponential(source) {
  function randomExponential(lambda) {
    return function() {
      return -Math.log(1 - source()) / lambda;
    };
  }

  randomExponential.source = sourceRandomExponential;

  return randomExponential;
})(__WEBPACK_IMPORTED_MODULE_0__defaultSource__["a" /* default */]));


/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_request__ = __webpack_require__(190);
/* unused harmony reexport request */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_html__ = __webpack_require__(912);
/* unused harmony reexport html */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_json__ = __webpack_require__(913);
/* unused harmony reexport json */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_text__ = __webpack_require__(914);
/* unused harmony reexport text */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_xml__ = __webpack_require__(915);
/* unused harmony reexport xml */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_csv__ = __webpack_require__(916);
/* unused harmony reexport csv */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_tsv__ = __webpack_require__(917);
/* unused harmony reexport tsv */









/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(115);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__type__["a" /* default */])("text/html", function(xhr) {
  return document.createRange().createContextualFragment(xhr.responseText);
}));


/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(115);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__type__["a" /* default */])("application/json", function(xhr) {
  return JSON.parse(xhr.responseText);
}));


/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(115);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__type__["a" /* default */])("text/plain", function(xhr) {
  return xhr.responseText;
}));


/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type__ = __webpack_require__(115);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__type__["a" /* default */])("application/xml", function(xhr) {
  var xml = xhr.responseXML;
  if (!xml) throw new Error("parse error");
  return xml;
}));


/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dsv__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dsv__ = __webpack_require__(349);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__dsv__["a" /* default */])("text/csv", __WEBPACK_IMPORTED_MODULE_0_d3_dsv__["a" /* csvParse */]));


/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dsv__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dsv__ = __webpack_require__(349);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__dsv__["a" /* default */])("text/tab-separated-values", __WEBPACK_IMPORTED_MODULE_0_d3_dsv__["b" /* tsvParse */]));


/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_band__ = __webpack_require__(919);
/* unused harmony reexport scaleBand */
/* unused harmony reexport scalePoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_identity__ = __webpack_require__(920);
/* unused harmony reexport scaleIdentity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_linear__ = __webpack_require__(74);
/* unused harmony reexport scaleLinear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_log__ = __webpack_require__(922);
/* unused harmony reexport scaleLog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_ordinal__ = __webpack_require__(350);
/* unused harmony reexport scaleOrdinal */
/* unused harmony reexport scaleImplicit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_pow__ = __webpack_require__(923);
/* unused harmony reexport scalePow */
/* unused harmony reexport scaleSqrt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_quantile__ = __webpack_require__(924);
/* unused harmony reexport scaleQuantile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_quantize__ = __webpack_require__(925);
/* unused harmony reexport scaleQuantize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold__ = __webpack_require__(926);
/* unused harmony reexport scaleThreshold */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_time__ = __webpack_require__(353);
/* unused harmony reexport scaleTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcTime__ = __webpack_require__(927);
/* unused harmony reexport scaleUtc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_category10__ = __webpack_require__(928);
/* unused harmony reexport schemeCategory10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_category20b__ = __webpack_require__(929);
/* unused harmony reexport schemeCategory20b */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_category20c__ = __webpack_require__(930);
/* unused harmony reexport schemeCategory20c */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_category20__ = __webpack_require__(931);
/* unused harmony reexport schemeCategory20 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(932);
/* unused harmony reexport interpolateCubehelixDefault */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_rainbow__ = __webpack_require__(933);
/* unused harmony reexport interpolateRainbow */
/* unused harmony reexport interpolateWarm */
/* unused harmony reexport interpolateCool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_viridis__ = __webpack_require__(934);
/* unused harmony reexport interpolateViridis */
/* unused harmony reexport interpolateMagma */
/* unused harmony reexport interpolateInferno */
/* unused harmony reexport interpolatePlasma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_sequential__ = __webpack_require__(935);
/* unused harmony reexport scaleSequential */







































/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export point */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ordinal__ = __webpack_require__(350);



function band() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_1__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}


/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(351);




function identity() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity().domain(domain);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["a" /* linearish */])(scale);
}


/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(26);



/* harmony default export */ __webpack_exports__["a"] = (function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start, stop, count == null ? 10 : count),
      precision;
  specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["c" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* precisionPrefix */])(step, value))) specifier.precision = precision;
      return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["b" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
});


/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nice__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(116);






function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(b);
}

function reinterpolate(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["b" /* default */])(deinterpolate, reinterpolate).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["ticks"])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(Object(__WEBPACK_IMPORTED_MODULE_3__nice__["a" /* default */])(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* copy */])(scale, log().base(base));
  };

  return scale;
}


/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export sqrt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(116);




function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent)))
        ? function(x) { return (raise(x, exponent) - a) / b; }
        : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function(t) { return raise(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, pow().exponent(exponent));
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["a" /* linearish */])(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}


/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(46);



function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["quantile"])(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["ascending"]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(74);




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2__linear__["a" /* linearish */])(scale);
}


/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(46);



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(24);




/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__time__["a" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["v" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["q" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["u" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["l" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["m" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["o" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["r" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["n" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["b" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
});


/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(75);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));


/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(75);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"));


/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(75);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"));


/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(75);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"));


/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(10);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(300, 0.5, 0.0), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(-240, 0.5, 1.0)));


/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export warm */
/* unused harmony export cool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(10);



var warm = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(-100, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(80, 1.50, 0.8));

var cool = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(260, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(80, 1.50, 0.8));

var rainbow = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])();

/* unused harmony default export */ var _unused_webpack_default_export = (function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
});


/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export magma */
/* unused harmony export inferno */
/* unused harmony export plasma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(75);


function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));


/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(74);


function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__linear__["a" /* linearish */])(scale);
}


/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(77);




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* max */])(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["g" /* halfPi */],
        a1 = endAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["g" /* halfPi */],
        da = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > __WEBPACK_IMPORTED_MODULE_2__math__["m" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
      context.moveTo(r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a0), r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        context.moveTo(r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a1), r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) && (padRadius ? +padRadius.apply(this, arguments) : Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(r0 * r0 + r1 * r1)),
          rc = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        var p0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(rp / r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(ap)),
            p1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(rp / r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(ap));
        if ((da0 -= p0 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a01),
          y01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a01),
          x10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a10),
          y10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a10);

      // Apply rounded corners?
      if (rc > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        var x11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a11),
            y11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a11),
            x00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a00),
            y00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a00);

        // Restrict the corner radius according to the sector angle.
        if (da < __WEBPACK_IMPORTED_MODULE_2__math__["j" /* pi */]) {
          var oc = da0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */] ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
              ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["b" /* acos */])((ax * bx + ay * by) / (Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(ax * ax + ay * ay) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(bx * bx + by * by))) / 2),
              lc = Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(rc, (r0 - lc) / (kc - 1));
          rc1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) || !(da0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - __WEBPACK_IMPORTED_MODULE_2__math__["j" /* pi */] / 2;
    return [Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a) * r, Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
});


/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__descending__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(77);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_2__identity__["a" /* default */],
      sortValues = __WEBPACK_IMPORTED_MODULE_1__descending__["a" /* default */],
      sort = null,
      startAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0),
      endAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */]),
      padAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */], Math.max(-__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */], endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : padAngle;
  };

  return pie;
});


/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  return d;
});


/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lineRadial__ = __webpack_require__(356);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  var a = Object(__WEBPACK_IMPORTED_MODULE_1__area__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* curveRadialLinear */]),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* default */])(_)) : c()._curve;
  };

  return a;
});


/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = linkHorizontal;
/* harmony export (immutable) */ __webpack_exports__["c"] = linkVertical;
/* harmony export (immutable) */ __webpack_exports__["b"] = linkRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pointRadial__ = __webpack_require__(357);






function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link(curve) {
  var source = linkSource,
      target = linkTarget,
      x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      context = null;

  function link() {
    var buffer, argv = __WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : x;
  };

  link.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : y;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial(context, x0, y0, x1, y1) {
  var p0 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0),
      p1 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0 = (y0 + y1) / 2),
      p2 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y0),
      p3 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link(curveHorizontal);
}

function linkVertical() {
  return link(curveVertical);
}

function linkRadial() {
  var l = link(curveRadial);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}


/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return symbols; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__symbol_circle__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_cross__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symbol_star__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__symbol_square__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__symbol_wye__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant__ = __webpack_require__(47);










var symbols = [
  __WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_2__symbol_cross__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_5__symbol_square__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_4__symbol_star__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_7__symbol_wye__["a" /* default */]
];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var type = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */]),
      size = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
});


/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(119);



function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__basis__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisClosed(context);
});


/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(119);


function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__basis__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisOpen(context);
});


/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(119);


function Bundle(context, beta) {
  this._basis = new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85));


/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__catmullRom__ = __webpack_require__(194);




function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_2__catmullRom__["b" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__["a" /* CardinalClosed */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__catmullRom__ = __webpack_require__(194);



function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_1__catmullRom__["b" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__["a" /* CardinalOpen */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(118);


function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new LinearClosed(context);
});


/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = monotoneX;
/* harmony export (immutable) */ __webpack_exports__["b"] = monotoneY;
function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
}

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}


/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Natural(context);
});


/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = stepBefore;
/* harmony export (immutable) */ __webpack_exports__["b"] = stepAfter;
function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Step(context, 0.5);
});

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}


/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__offset_none__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__order_none__ = __webpack_require__(79);





function stackValue(d, key) {
  return d[key];
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var keys = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([]),
      order = __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */],
      offset = __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */],
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */] : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */] : _, stack) : offset;
  };

  return stack;
});


/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(78);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = yp;
      }
    }
  }
});


/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(78);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(78);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(195);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(series).reverse();
});


/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(195);



/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(__WEBPACK_IMPORTED_MODULE_1__ascending__["b" /* sum */]),
      order = Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[b] - sums[a]; }),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
});


/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(79);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).reverse();
});


/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_voronoi__ = __webpack_require__(961);
/* unused harmony reexport voronoi */



/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Diagram__ = __webpack_require__(80);




/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_1__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_1__point__["b" /* y */],
      extent = null;

  function voronoi(data) {
    return new __WEBPACK_IMPORTED_MODULE_2__Diagram__["d" /* default */](data.map(function(d, i) {
      var s = [Math.round(x(d, i, data) / __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */]) * __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */], Math.round(y(d, i, data) / __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */]) * __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */]];
      s.index = i;
      s.data = d;
      return s;
    }), extent);
  }

  voronoi.polygons = function(data) {
    return voronoi(data).polygons();
  };

  voronoi.links = function(data) {
    return voronoi(data).links();
  };

  voronoi.triangles = function(data) {
    return voronoi(data).triangles();
  };

  voronoi.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), voronoi) : x;
  };

  voronoi.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), voronoi) : y;
  };

  voronoi.extent = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
  };

  voronoi.size = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
  };

  return voronoi;
});


/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(d) {
  return d[0];
}

function y(d) {
  return d[1];
}


/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = removeBeach;
/* harmony export (immutable) */ __webpack_exports__["a"] = addBeach;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RedBlackTree__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cell__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Circle__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Edge__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Diagram__ = __webpack_require__(80);






var beachPool = [];

function Beach() {
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(this);
  this.edge =
  this.site =
  this.circle = null;
}

function createBeach(site) {
  var beach = beachPool.pop() || new Beach;
  beach.site = site;
  return beach;
}

function detachBeach(beach) {
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(beach);
  __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */].remove(beach);
  beachPool.push(beach);
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(beach);
}

function removeBeach(beach) {
  var circle = beach.circle,
      x = circle.x,
      y = circle.cy,
      vertex = [x, y],
      previous = beach.P,
      next = beach.N,
      disappearing = [beach];

  detachBeach(beach);

  var lArc = previous;
  while (lArc.circle
      && Math.abs(x - lArc.circle.x) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]
      && Math.abs(y - lArc.circle.cy) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
    previous = lArc.P;
    disappearing.unshift(lArc);
    detachBeach(lArc);
    lArc = previous;
  }

  disappearing.unshift(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);

  var rArc = next;
  while (rArc.circle
      && Math.abs(x - rArc.circle.x) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]
      && Math.abs(y - rArc.circle.cy) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
    next = rArc.N;
    disappearing.push(rArc);
    detachBeach(rArc);
    rArc = next;
  }

  disappearing.push(rArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(rArc);

  var nArcs = disappearing.length,
      iArc;
  for (iArc = 1; iArc < nArcs; ++iArc) {
    rArc = disappearing[iArc];
    lArc = disappearing[iArc - 1];
    Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* setEdgeEnd */])(rArc.edge, lArc.site, rArc.site, vertex);
  }

  lArc = disappearing[0];
  rArc = disappearing[nArcs - 1];
  rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lArc.site, rArc.site, null, vertex);

  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(rArc);
}

function addBeach(site) {
  var x = site[0],
      directrix = site[1],
      lArc,
      rArc,
      dxl,
      dxr,
      node = __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */]._;

  while (node) {
    dxl = leftBreakPoint(node, directrix) - x;
    if (dxl > __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) node = node.L; else {
      dxr = x - rightBreakPoint(node, directrix);
      if (dxr > __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
        if (!node.R) {
          lArc = node;
          break;
        }
        node = node.R;
      } else {
        if (dxl > -__WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
          lArc = node.P;
          rArc = node;
        } else if (dxr > -__WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
          lArc = node;
          rArc = node.N;
        } else {
          lArc = rArc = node;
        }
        break;
      }
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["c" /* createCell */])(site);
  var newArc = createBeach(site);
  __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */].insert(lArc, newArc);

  if (!lArc && !rArc) return;

  if (lArc === rArc) {
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);
    rArc = createBeach(lArc.site);
    __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */].insert(newArc, rArc);
    newArc.edge = rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lArc.site, newArc.site);
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(lArc);
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(rArc);
    return;
  }

  if (!rArc) { // && lArc
    newArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lArc.site, newArc.site);
    return;
  }

  // else lArc !== rArc
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(rArc);

  var lSite = lArc.site,
      ax = lSite[0],
      ay = lSite[1],
      bx = site[0] - ax,
      by = site[1] - ay,
      rSite = rArc.site,
      cx = rSite[0] - ax,
      cy = rSite[1] - ay,
      d = 2 * (bx * cy - by * cx),
      hb = bx * bx + by * by,
      hc = cx * cx + cy * cy,
      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];

  Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* setEdgeEnd */])(rArc.edge, lSite, rSite, vertex);
  newArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lSite, site, null, vertex);
  rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(site, rSite, null, vertex);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(rArc);
}

function leftBreakPoint(arc, directrix) {
  var site = arc.site,
      rfocx = site[0],
      rfocy = site[1],
      pby2 = rfocy - directrix;

  if (!pby2) return rfocx;

  var lArc = arc.P;
  if (!lArc) return -Infinity;

  site = lArc.site;
  var lfocx = site[0],
      lfocy = site[1],
      plby2 = lfocy - directrix;

  if (!plby2) return lfocx;

  var hl = lfocx - rfocx,
      aby2 = 1 / pby2 - 1 / plby2,
      b = hl / plby2;

  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;

  return (rfocx + lfocx) / 2;
}

function rightBreakPoint(arc, directrix) {
  var rArc = arc.N;
  if (rArc) return leftBreakPoint(rArc, directrix);
  var site = arc.site;
  return site[1] === directrix ? site[0] : Infinity;
}


/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_zoom__ = __webpack_require__(966);
/* unused harmony reexport zoom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_transform__ = __webpack_require__(370);
/* unused harmony reexport zoomTransform */
/* unused harmony reexport zoomIdentity */




/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_drag__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_selection__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_transition__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constant__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transform__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__noevent__ = __webpack_require__(969);










// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].button;
}

function defaultExtent() {
  var e = this, w, h;
  if (e instanceof SVGElement) {
    e = e.ownerSVGElement || e;
    w = e.width.baseVal.value;
    h = e.height.baseVal.value;
  } else {
    w = e.clientWidth;
    h = e.clientHeight;
  }
  return [[0, 0], [w, h]];
}

function defaultTransform() {
  return this.__zoom || __WEBPACK_IMPORTED_MODULE_7__transform__["b" /* identity */];
}

function defaultWheelDelta() {
  return -__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].deltaY * (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].deltaMode ? 120 : 1) / 500;
}

function defaultTouchable() {
  return "ontouchstart" in this;
}

function defaultConstrain(transform, extent, translateExtent) {
  var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0],
      dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0],
      dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1],
      dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
  return transform.translate(
    dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1),
    dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1)
  );
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var filter = defaultFilter,
      extent = defaultExtent,
      constrain = defaultConstrain,
      wheelDelta = defaultWheelDelta,
      touchable = defaultTouchable,
      scaleExtent = [0, Infinity],
      translateExtent = [[-Infinity, -Infinity], [Infinity, Infinity]],
      duration = 250,
      interpolate = __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__["j" /* interpolateZoom */],
      gestures = [],
      listeners = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("start", "zoom", "end"),
      touchstarting,
      touchending,
      touchDelay = 500,
      wheelDelay = 150,
      clickDistance2 = 0;

  function zoom(selection) {
    selection
        .property("__zoom", defaultTransform)
        .on("wheel.zoom", wheeled)
        .on("mousedown.zoom", mousedowned)
        .on("dblclick.zoom", dblclicked)
      .filter(touchable)
        .on("touchstart.zoom", touchstarted)
        .on("touchmove.zoom", touchmoved)
        .on("touchend.zoom touchcancel.zoom", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  zoom.transform = function(collection, transform) {
    var selection = collection.selection ? collection.selection() : collection;
    selection.property("__zoom", defaultTransform);
    if (collection !== selection) {
      schedule(collection, transform);
    } else {
      selection.interrupt().each(function() {
        gesture(this, arguments)
            .start()
            .zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform)
            .end();
      });
    }
  };

  zoom.scaleBy = function(selection, k) {
    zoom.scaleTo(selection, function() {
      var k0 = this.__zoom.k,
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return k0 * k1;
    });
  };

  zoom.scaleTo = function(selection, k) {
    zoom.transform(selection, function() {
      var e = extent.apply(this, arguments),
          t0 = this.__zoom,
          p0 = centroid(e),
          p1 = t0.invert(p0),
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
    });
  };

  zoom.translateBy = function(selection, x, y) {
    zoom.transform(selection, function() {
      return constrain(this.__zoom.translate(
        typeof x === "function" ? x.apply(this, arguments) : x,
        typeof y === "function" ? y.apply(this, arguments) : y
      ), extent.apply(this, arguments), translateExtent);
    });
  };

  zoom.translateTo = function(selection, x, y) {
    zoom.transform(selection, function() {
      var e = extent.apply(this, arguments),
          t = this.__zoom,
          p = centroid(e);
      return constrain(__WEBPACK_IMPORTED_MODULE_7__transform__["b" /* identity */].translate(p[0], p[1]).scale(t.k).translate(
        typeof x === "function" ? -x.apply(this, arguments) : -x,
        typeof y === "function" ? -y.apply(this, arguments) : -y
      ), e, translateExtent);
    });
  };

  function scale(transform, k) {
    k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
    return k === transform.k ? transform : new __WEBPACK_IMPORTED_MODULE_7__transform__["a" /* Transform */](k, transform.x, transform.y);
  }

  function translate(transform, p0, p1) {
    var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
    return x === transform.x && y === transform.y ? transform : new __WEBPACK_IMPORTED_MODULE_7__transform__["a" /* Transform */](transform.k, x, y);
  }

  function centroid(extent) {
    return [(+extent[0][0] + +extent[1][0]) / 2, (+extent[0][1] + +extent[1][1]) / 2];
  }

  function schedule(transition, transform, center) {
    transition
        .on("start.zoom", function() { gesture(this, arguments).start(); })
        .on("interrupt.zoom end.zoom", function() { gesture(this, arguments).end(); })
        .tween("zoom", function() {
          var that = this,
              args = arguments,
              g = gesture(that, args),
              e = extent.apply(that, args),
              p = center || centroid(e),
              w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]),
              a = that.__zoom,
              b = typeof transform === "function" ? transform.apply(that, args) : transform,
              i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
          return function(t) {
            if (t === 1) t = b; // Avoid rounding error on end.
            else { var l = i(t), k = w / l[2]; t = new __WEBPACK_IMPORTED_MODULE_7__transform__["a" /* Transform */](k, p[0] - l[0] * k, p[1] - l[1] * k); }
            g.zoom(null, t);
          };
        });
  }

  function gesture(that, args) {
    for (var i = 0, n = gestures.length, g; i < n; ++i) {
      if ((g = gestures[i]).that === that) {
        return g;
      }
    }
    return new Gesture(that, args);
  }

  function Gesture(that, args) {
    this.that = that;
    this.args = args;
    this.index = -1;
    this.active = 0;
    this.extent = extent.apply(that, args);
  }

  Gesture.prototype = {
    start: function() {
      if (++this.active === 1) {
        this.index = gestures.push(this) - 1;
        this.emit("start");
      }
      return this;
    },
    zoom: function(key, transform) {
      if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
      if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
      if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
      this.that.__zoom = transform;
      this.emit("zoom");
      return this;
    },
    end: function() {
      if (--this.active === 0) {
        gestures.splice(this.index, 1);
        this.index = -1;
        this.emit("end");
      }
      return this;
    },
    emit: function(type) {
      Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["a" /* customEvent */])(new __WEBPACK_IMPORTED_MODULE_6__event__["a" /* default */](zoom, type, this.that.__zoom), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function wheeled() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        t = this.__zoom,
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))),
        p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* mouse */])(this);

    // If the mouse is in the same location as before, reuse it.
    // If there were recent wheel events, reset the wheel idle timeout.
    if (g.wheel) {
      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
        g.mouse[1] = t.invert(g.mouse[0] = p);
      }
      clearTimeout(g.wheel);
    }

    // If this wheel event won’t trigger a transform change, ignore it.
    else if (t.k === k) return;

    // Otherwise, capture the mouse point and location at the start.
    else {
      g.mouse = [p, t.invert(p)];
      Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["a" /* interrupt */])(this);
      g.start();
    }

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
    g.wheel = setTimeout(wheelidled, wheelDelay);
    g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));

    function wheelidled() {
      g.wheel = null;
      g.end();
    }
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        v = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true),
        p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* mouse */])(this),
        x0 = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].clientX,
        y0 = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].clientY;

    Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["a" /* dragDisable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].view);
    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["b" /* nopropagation */])();
    g.mouse = [p, this.__zoom.invert(p)];
    Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["a" /* interrupt */])(this);
    g.start();

    function mousemoved() {
      Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
      if (!g.moved) {
        var dx = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].clientX - x0, dy = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].clientY - y0;
        g.moved = dx * dx + dy * dy > clickDistance2;
      }
      g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* mouse */])(g.that), g.mouse[1]), g.extent, translateExtent));
    }

    function mouseupped() {
      v.on("mousemove.zoom mouseup.zoom", null);
      Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["b" /* dragEnable */])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].view, g.moved);
      Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
      g.end();
    }
  }

  function dblclicked() {
    if (!filter.apply(this, arguments)) return;
    var t0 = this.__zoom,
        p0 = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["d" /* mouse */])(this),
        p1 = t0.invert(p0),
        k1 = t0.k * (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].shiftKey ? 0.5 : 2),
        t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments), translateExtent);

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
    if (duration > 0) Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["f" /* select */])(this).transition().duration(duration).call(schedule, t1, p0);
    else Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["f" /* select */])(this).call(zoom.transform, t1);
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        touches = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].changedTouches,
        started,
        n = touches.length, i, t, p;

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["b" /* nopropagation */])();
    for (i = 0; i < n; ++i) {
      t = touches[i], p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" /* touch */])(this, touches, t.identifier);
      p = [p, this.__zoom.invert(p), t.identifier];
      if (!g.touch0) g.touch0 = p, started = true;
      else if (!g.touch1) g.touch1 = p;
    }

    // If this is a dbltap, reroute to the (optional) dblclick.zoom handler.
    if (touchstarting) {
      touchstarting = clearTimeout(touchstarting);
      if (!g.touch1) {
        g.end();
        p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["f" /* select */])(this).on("dblclick.zoom");
        if (p) p.apply(this, arguments);
        return;
      }
    }

    if (started) {
      touchstarting = setTimeout(function() { touchstarting = null; }, touchDelay);
      Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["a" /* interrupt */])(this);
      g.start();
    }
  }

  function touchmoved() {
    var g = gesture(this, arguments),
        touches = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].changedTouches,
        n = touches.length, i, t, p, l;

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["a" /* default */])();
    if (touchstarting) touchstarting = clearTimeout(touchstarting);
    for (i = 0; i < n; ++i) {
      t = touches[i], p = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["k" /* touch */])(this, touches, t.identifier);
      if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
      else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
    }
    t = g.that.__zoom;
    if (g.touch1) {
      var p0 = g.touch0[0], l0 = g.touch0[1],
          p1 = g.touch1[0], l1 = g.touch1[1],
          dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp,
          dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
      t = scale(t, Math.sqrt(dp / dl));
      p = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
    }
    else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
    else return;
    g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
  }

  function touchended() {
    var g = gesture(this, arguments),
        touches = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["b" /* event */].changedTouches,
        n = touches.length, i, t;

    Object(__WEBPACK_IMPORTED_MODULE_8__noevent__["b" /* nopropagation */])();
    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, touchDelay);
    for (i = 0; i < n; ++i) {
      t = touches[i];
      if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
      else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
    }
    if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
    if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
    else g.end();
  }

  zoom.wheelDelta = function(_) {
    return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(+_), zoom) : wheelDelta;
  };

  zoom.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(!!_), zoom) : filter;
  };

  zoom.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(!!_), zoom) : touchable;
  };

  zoom.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom) : extent;
  };

  zoom.scaleExtent = function(_) {
    return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [scaleExtent[0], scaleExtent[1]];
  };

  zoom.translateExtent = function(_) {
    return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [[translateExtent[0][0], translateExtent[0][1]], [translateExtent[1][0], translateExtent[1][1]]];
  };

  zoom.constrain = function(_) {
    return arguments.length ? (constrain = _, zoom) : constrain;
  };

  zoom.duration = function(_) {
    return arguments.length ? (duration = +_, zoom) : duration;
  };

  zoom.interpolate = function(_) {
    return arguments.length ? (interpolate = _, zoom) : interpolate;
  };

  zoom.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? zoom : value;
  };

  zoom.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
  };

  return zoom;
});


/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ZoomEvent;
function ZoomEvent(target, type, transform) {
  this.target = target;
  this.type = type;
  this.transform = transform;
}


/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = nopropagation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(11);


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].stopImmediatePropagation();
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["b" /* event */].stopImmediatePropagation();
});


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.bumpAnnotations = bumpAnnotations;

var _d3labeler = __webpack_require__(971);

var _d3labeler2 = _interopRequireDefault(_d3labeler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basicPointSizeFunction = function basicPointSizeFunction() {
  return 5;
};
var basicLabelSizeFunction = function basicLabelSizeFunction(noteData, characterWidth, lineHeight, padding) {
  var text = noteData.note.label || noteData.note.title;

  var textLength = text.length;
  var wrap = noteData.note.wrap || 120;
  var width = Math.min(wrap, textLength * characterWidth) + padding * 2;
  var height = Math.ceil(textLength * characterWidth / 120) * lineHeight + padding * 2;
  return [width, height];
};

function bumpAnnotations(adjustableNotes, props, processor) {
  var size = props.size,
      propsPointSizeFunction = props.pointSizeFunction,
      propsLabelSizeFunction = props.labelSizeFunction;
  var _processor$padding = processor.padding,
      padding = _processor$padding === undefined ? 1 : _processor$padding,
      _processor$characterW = processor.characterWidth,
      characterWidth = _processor$characterW === undefined ? 8 : _processor$characterW,
      _processor$lineHeight = processor.lineHeight,
      lineHeight = _processor$lineHeight === undefined ? 20 : _processor$lineHeight,
      _processor$iterations = processor.iterations,
      iterations = _processor$iterations === undefined ? 500 : _processor$iterations,
      _processor$pointSizeF = processor.pointSizeFunction,
      pointSizeFunction = _processor$pointSizeF === undefined ? propsPointSizeFunction || basicPointSizeFunction : _processor$pointSizeF,
      _processor$labelSizeF = processor.labelSizeFunction,
      labelSizeFunction = _processor$labelSizeF === undefined ? propsLabelSizeFunction || basicLabelSizeFunction : _processor$labelSizeF;


  var labels = adjustableNotes.map(function (d, i) {
    var anchorX = d.props.noteData.x + (d.props.noteData.dx !== undefined ? d.props.noteData.dx : (i % 3 - 1) * -10);
    var anchorY = d.props.noteData.y + (d.props.noteData.dy !== undefined ? d.props.noteData.dy : (i % 3 - 1) * 10);

    var _labelSizeFunction = labelSizeFunction(d.props.noteData, characterWidth, lineHeight, padding),
        _labelSizeFunction2 = _slicedToArray(_labelSizeFunction, 2),
        labelWidth = _labelSizeFunction2[0],
        labelHeight = _labelSizeFunction2[1];

    return {
      x: anchorX,
      y: anchorY,
      above: anchorY < d.props.noteData.y,
      left: anchorX < d.props.noteData.x,
      width: labelWidth,
      height: labelHeight,
      type: "label",
      name: "",
      originalNote: d
    };
  });

  var points = adjustableNotes.map(function (d) {
    return {
      x: d.props.noteData.x,
      y: d.props.noteData.y,
      fx: d.props.noteData.x,
      fy: d.props.noteData.y,
      r: pointSizeFunction(d.props.noteData),
      type: "point",
      originalNote: d
    };
  });

  (0, _d3labeler2.default)().label(labels).anchor(points).width(size[0]).height(size[1]).start(iterations);

  labels.forEach(function (d) {
    if (d.type === "label") {
      var adjusted = adjustedXY(d.originalNote.props.noteData, d, padding);
      d.originalNote.props.noteData.nx = adjusted[0];
      d.originalNote.props.noteData.ny = adjusted[1];
    }
  });

  return adjustableNotes;
}

function adjustedXY(note, calculated /*, padding*/) {
  if (note.y > calculated.y) {
    //below
    return [calculated.x + calculated.width / 2, calculated.y - calculated.height];
  }
  return [calculated.x + calculated.width / 2, calculated.y];
}

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var lab = [],
      anc = [],
      w = 1,
      // box width
  h = 1,
      // box width
  labeler = {};

  var max_move = 5.0,
      max_angle = 0.5,
      acc = 0,
      rej = 0;

  // weights
  var w_len = 0.2,
      // leader line length
  w_inter = 1.0,
      // leader line intersection
  w_lab2 = 30.0,
      // label-label overlap
  w_lab_anc = 30.0,
      // label-anchor overlap
  w_orient = 3.0; // orientation bias

  // booleans for user defined functions
  var user_energy = false,
      user_schedule = false;

  var user_defined_energy = void 0,
      user_defined_schedule = void 0;

  var energy = function energy(index) {
    // energy function, tailored for label placement

    var m = lab.length,
        ener = 0,
        dx = lab[index].x - anc[index].x,
        dy = anc[index].y - lab[index].y,
        dist = Math.sqrt(dx * dx + dy * dy),
        overlap = true,
        amount = 0,
        theta = 0;

    // penalty for length of leader line
    if (dist > 0) ener += dist * w_len;

    // label orientation bias
    dx /= dist;
    dy /= dist;
    if (dx > 0 && dy > 0) {
      ener += 0 * w_orient;
    } else if (dx < 0 && dy > 0) {
      ener += 1 * w_orient;
    } else if (dx < 0 && dy < 0) {
      ener += 2 * w_orient;
    } else {
      ener += 3 * w_orient;
    }

    var x21 = lab[index].x,
        y21 = lab[index].y - lab[index].height + 2.0,
        x22 = lab[index].x + lab[index].width,
        y22 = lab[index].y + 2.0;
    var x11 = void 0,
        x12 = void 0,
        y11 = void 0,
        y12 = void 0,
        x_overlap = void 0,
        y_overlap = void 0,
        overlap_area = void 0;

    for (var i = 0; i < m; i++) {
      if (i !== index) {
        // penalty for intersection of leader lines
        var _overlap = intersect(anc[index].x, lab[index].x, anc[i].x, lab[i].x, anc[index].y, lab[index].y, anc[i].y, lab[i].y);
        if (_overlap) ener += w_inter;

        // penalty for label-label overlap
        x11 = lab[i].x;
        y11 = lab[i].y - lab[i].height + 2.0;
        x12 = lab[i].x + lab[i].width;
        y12 = lab[i].y + 2.0;
        x_overlap = Math.max(0, Math.min(x12, x22) - Math.max(x11, x21));
        y_overlap = Math.max(0, Math.min(y12, y22) - Math.max(y11, y21));
        overlap_area = x_overlap * y_overlap;
        ener += overlap_area * w_lab2;
      }

      // penalty for label-anchor overlap
      x11 = anc[i].x - anc[i].r;
      y11 = anc[i].y - anc[i].r;
      x12 = anc[i].x + anc[i].r;
      y12 = anc[i].y + anc[i].r;
      x_overlap = Math.max(0, Math.min(x12, x22) - Math.max(x11, x21));
      y_overlap = Math.max(0, Math.min(y12, y22) - Math.max(y11, y21));
      overlap_area = x_overlap * y_overlap;
      ener += overlap_area * w_lab_anc;
    }
    return ener;
  };

  var mcmove = function mcmove(currT) {
    // Monte Carlo translation move

    // select a random label
    var i = Math.floor(Math.random() * lab.length);

    // save old coordinates
    var x_old = lab[i].x;
    var y_old = lab[i].y;

    // old energy
    var old_energy = void 0;
    if (user_energy) {
      old_energy = user_defined_energy(i, lab, anc);
    } else {
      old_energy = energy(i);
    }

    // random translation
    lab[i].x += (Math.random() - 0.5) * max_move;
    lab[i].y += (Math.random() - 0.5) * max_move;

    // hard wall boundaries
    if (lab[i].x > w) lab[i].x = x_old;
    if (lab[i].x < 0) lab[i].x = x_old;
    if (lab[i].y > h) lab[i].y = y_old;
    if (lab[i].y < 0) lab[i].y = y_old;

    // new energy
    var new_energy = void 0;
    if (user_energy) {
      new_energy = user_defined_energy(i, lab, anc);
    } else {
      new_energy = energy(i);
    }

    // delta E
    var delta_energy = new_energy - old_energy;

    if (Math.random() < Math.exp(-delta_energy / currT)) {
      acc += 1;
    } else {
      // move back to old coordinates
      lab[i].x = x_old;
      lab[i].y = y_old;
      rej += 1;
    }
  };

  var mcrotate = function mcrotate(currT) {
    // Monte Carlo rotation move

    // select a random label
    var i = Math.floor(Math.random() * lab.length);

    // save old coordinates
    var x_old = lab[i].x;
    var y_old = lab[i].y;

    // old energy
    var old_energy = void 0;
    if (user_energy) {
      old_energy = user_defined_energy(i, lab, anc);
    } else {
      old_energy = energy(i);
    }

    // random angle
    var angle = (Math.random() - 0.5) * max_angle;

    var s = Math.sin(angle);
    var c = Math.cos(angle);

    // translate label (relative to anchor at origin):
    lab[i].x -= anc[i].x;
    lab[i].y -= anc[i].y;

    // rotate label
    var x_new = lab[i].x * c - lab[i].y * s,
        y_new = lab[i].x * s + lab[i].y * c;

    // translate label back
    lab[i].x = x_new + anc[i].x;
    lab[i].y = y_new + anc[i].y;

    // hard wall boundaries
    if (lab[i].x > w) lab[i].x = x_old;
    if (lab[i].x < 0) lab[i].x = x_old;
    if (lab[i].y > h) lab[i].y = y_old;
    if (lab[i].y < 0) lab[i].y = y_old;

    // new energy
    var new_energy = void 0;
    if (user_energy) {
      new_energy = user_defined_energy(i, lab, anc);
    } else {
      new_energy = energy(i);
    }

    // delta E
    var delta_energy = new_energy - old_energy;

    if (Math.random() < Math.exp(-delta_energy / currT)) {
      acc += 1;
    } else {
      // move back to old coordinates
      lab[i].x = x_old;
      lab[i].y = y_old;
      rej += 1;
    }
  };

  var intersect = function intersect(x1, x2, x3, x4, y1, y2, y3, y4) {
    // returns true if two lines intersect, else false
    // from http://paulbourke.net/geometry/lineline2d/

    var mua = void 0,
        mub = void 0;
    var denom = void 0,
        numera = void 0,
        numerb = void 0;

    denom = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
    numera = (x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3);
    numerb = (x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3);

    /* Is the intersection along the the segments */
    mua = numera / denom;
    mub = numerb / denom;
    if (!(mua < 0 || mua > 1 || mub < 0 || mub > 1)) {
      return true;
    }
    return false;
  };

  var cooling_schedule = function cooling_schedule(currT, initialT, nsweeps) {
    // linear cooling
    return currT - initialT / nsweeps;
  };

  labeler.start = function (nsweeps) {
    // main simulated annealing function
    var m = lab.length,
        currT = 1.0,
        initialT = 1.0;

    for (var i = 0; i < nsweeps; i++) {
      for (var j = 0; j < m; j++) {
        if (Math.random() < 0.5) {
          mcmove(currT);
        } else {
          mcrotate(currT);
        }
      }
      currT = cooling_schedule(currT, initialT, nsweeps);
    }
  };

  labeler.width = function (x) {
    // users insert graph width
    if (!arguments.length) return w;
    w = x;
    return labeler;
  };

  labeler.height = function (x) {
    // users insert graph height
    if (!arguments.length) return h;
    h = x;
    return labeler;
  };

  labeler.label = function (x) {
    // users insert label positions
    if (!arguments.length) return lab;
    lab = x;
    return labeler;
  };

  labeler.anchor = function (x) {
    // users insert anchor positions
    if (!arguments.length) return anc;
    anc = x;
    return labeler;
  };

  labeler.alt_energy = function (x) {
    // user defined energy
    if (!arguments.length) return energy;
    user_defined_energy = x;
    user_energy = true;
    return labeler;
  };

  labeler.alt_schedule = function (x) {
    // user defined cooling_schedule
    if (!arguments.length) return cooling_schedule;
    user_defined_schedule = x;
    user_schedule = true;
    return labeler;
  };

  return labeler;
};

/*eslint-enable */
module.exports = exports['default']; // from Evan Wang's https://github.com/tinker10/D3-Labeler
/*eslint-disable */

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Builder = __webpack_require__(16);

var _typeLine = __webpack_require__(374);

var _d3Shape = __webpack_require__(76);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var createPoints = function createPoints(offset) {
  var anchors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  var diff = { x: offset.x / (anchors + 1), y: offset.y / (anchors + 1) };
  var p = [];

  var i = 1;
  for (; i <= anchors; i++) {
    p.push([diff.x * i + i % 2 * 20, diff.y * i - i % 2 * 20]);
  }
  return p;
};

exports.default = function (_ref) {
  var curve = _ref.curve,
      points = _ref.points,
      x = _ref.x,
      y = _ref.y,
      dx = _ref.dx,
      dy = _ref.dy,
      radius = _ref.radius,
      outerRadius = _ref.outerRadius,
      width = _ref.width,
      height = _ref.height;

  if (!points || typeof points === "number") {
    points = createPoints({ x: dx, y: dy }, points);
  }
  if (!curve) {
    curve = _d3Shape.curveCatmullRom;
  }

  var handles = [];

  // if (type.editMode) {
  //   const cHandles = connectorData.points.map((c, i) => ({
  //     ...pointHandle({ cx: c[0], cy: c[1] }),
  //     index: i
  //   }))

  //   const updatePoint = index => {
  //     connectorData.points[index][0] += event.dx
  //     connectorData.points[index][1] += event.dy
  //     type.redrawConnector()
  //   }

  //   handles = type.mapHandles(
  //     cHandles.map(h => ({ ...h.move, drag: updatePoint.bind(type, h.index) }))
  //   )
  // }

  // let data = lineSetup({ type, subjectType })
  var data = (0, _typeLine.lineSetup)({ x: x, y: y, dx: dx, dy: dy, radius: radius, outerRadius: outerRadius, width: width, height: height });
  data = [data[0]].concat(_toConsumableArray(points), [data[1]]);
  var components = [(0, _Builder.lineBuilder)({ data: data, curve: curve, className: "connector" })];

  return { components: components, handles: handles };
};

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Builder = __webpack_require__(16);

exports.default = function (_ref) {
  var dx = _ref.dx,
      dy = _ref.dy,
      radius = _ref.radius,
      outerRadius = _ref.outerRadius,
      radiusPadding = _ref.radiusPadding,
      width = _ref.width,
      height = _ref.height;

  var x1 = 0,
      x2 = dx,
      y1 = 0,
      y2 = dy;

  if (width && height) {
    if (width > 0 && dx > 0 || width < 0 && dx < 0) {
      if (Math.abs(width) > Math.abs(dx)) x1 = width / 2;else x1 = width;
    }
    if (height > 0 && dy > 0 || height < 0 && dy < 0) {
      if (Math.abs(height) > Math.abs(dy)) y1 = height / 2;else y1 = height;
    }
    if (x1 === width / 2 && y1 === height / 2) {
      x1 = x2;
      y1 = y2;
    }
  }

  var data = [[x1, y1], [x2, y2]];

  var diffY = y2 - y1;
  var diffX = x2 - x1;
  var xe = x2;
  var ye = y2;
  var opposite = y2 < y1 && x2 > x1 || x2 < x1 && y2 > y1 ? -1 : 1;

  if (Math.abs(diffX) < Math.abs(diffY)) {
    xe = x2;
    ye = y1 + diffX * opposite;
  } else {
    ye = y2;
    xe = x1 + diffY * opposite;
  }

  if (outerRadius || radius) {
    var r = (outerRadius || radius) + (radiusPadding || 0);
    var length = r / Math.sqrt(2);

    if (Math.abs(diffX) > length && Math.abs(diffY) > length) {
      x1 = length * (x2 < 0 ? -1 : 1);
      y1 = length * (y2 < 0 ? -1 : 1);
      data = [[x1, y1], [xe, ye], [x2, y2]];
    } else if (Math.abs(diffX) > Math.abs(diffY)) {
      var angle = Math.asin(-y2 / r);
      x1 = Math.abs(Math.cos(angle) * r) * (x2 < 0 ? -1 : 1);
      data = [[x1, y2], [x2, y2]];
    } else {
      var _angle = Math.acos(x2 / r);
      y1 = Math.abs(Math.sin(_angle) * r) * (y2 < 0 ? -1 : 1);
      data = [[x2, y1], [x2, y2]];
    }
  } else {
    data = [[x1, y1], [xe, ye], [x2, y2]];
  }

  return { components: [(0, _Builder.lineBuilder)({ data: data, className: "connector" })] };
};

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Builder = __webpack_require__(16);

exports.default = function (_ref) {
  var lineData = _ref.lineData,
      _ref$scale = _ref.scale,
      scale = _ref$scale === undefined ? 1 : _ref$scale;

  var dot = (0, _Builder.arcBuilder)({
    className: "connector-end connector-dot",
    classID: "connector-end",
    data: { radius: 3 * Math.sqrt(scale) }
  });
  dot.attrs.transform = "translate(" + lineData[0][0] + ", " + lineData[0][1] + ")";

  return { components: [dot] };
};

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Builder = __webpack_require__(16);

exports.default = function (_ref) {
  var dx = _ref.dx,
      dy = _ref.dy,
      start = _ref.start,
      end = _ref.end,
      _ref$scale = _ref.scale,
      scale = _ref$scale === undefined ? 1 : _ref$scale;

  if (!start) {
    start = [dx, dy];
  } else {
    start = [-end[0] + start[0], -end[1] + start[1]];
  }
  if (!end) {
    end = [0, 0];
  }

  var x1 = end[0],
      y1 = end[1];

  var size = 10 * scale;
  var angleOffset = 16 / 180 * Math.PI;
  var angle = Math.atan(start[1] / start[0]);

  if (start[0] < 0) {
    angle += Math.PI;
  }

  var data = [[x1, y1], [Math.cos(angle + angleOffset) * size + x1, Math.sin(angle + angleOffset) * size + y1], [Math.cos(angle - angleOffset) * size + x1, Math.sin(angle - angleOffset) * size + y1], [x1, y1]];

  //TODO add in reverse
  // if (canvasContext.arrowReverse){
  //   data = [[x1, y1],
  //   [Math.cos(angle + angleOffset)*size, Math.sin(angle + angleOffset)*size],
  //   [Math.cos(angle - angleOffset)*size, Math.sin(angle - angleOffset)*size],
  //   [x1, y1]
  //   ]
  // } else {
  //   data = [[x1, y1],
  //   [Math.cos(angle + angleOffset)*size, Math.sin(angle + angleOffset)*size],
  //   [Math.cos(angle - angleOffset)*size, Math.sin(angle - angleOffset)*size],
  //   [x1, y1]
  //   ]
  // }

  return {
    components: [(0, _Builder.lineBuilder)({
      data: data,
      className: "connector-end connector-arrow",
      classID: "connector-end"
    })]
  };
};

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(255), __webpack_require__(0));
	else if(typeof define === 'function' && define.amd)
		define(["react-dom", "react"], factory);
	else if(typeof exports === 'object')
		exports["ReactDraggable"] = factory(require("react-dom"), require("react"));
	else
		root["ReactDraggable"] = factory(root["ReactDOM"], root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_6__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 12);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findInArray = findInArray;
exports.isFunction = isFunction;
exports.isNum = isNum;
exports.int = int;
exports.dontSetMe = dontSetMe;

// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function findInArray(array /*: Array<any> | TouchList*/, callback /*: Function*/) /*: any*/ {
  for (var i = 0, length = array.length; i < length; i++) {
    if (callback.apply(callback, [array[i], i, array])) return array[i];
  }
}

function isFunction(func /*: any*/) /*: boolean*/ {
  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}

function isNum(num /*: any*/) /*: boolean*/ {
  return typeof num === 'number' && !isNaN(num);
}

function int(a /*: string*/) /*: number*/ {
  return parseInt(a, 10);
}

function dontSetMe(props /*: Object*/, propName /*: string*/, componentName /*: string*/) {
  if (props[propName]) {
    return new Error('Invalid prop ' + propName + ' passed to ' + componentName + ' - do not set this, set it on the child.');
  }
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.matchesSelector = matchesSelector;
exports.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
exports.addEvent = addEvent;
exports.removeEvent = removeEvent;
exports.outerHeight = outerHeight;
exports.outerWidth = outerWidth;
exports.innerHeight = innerHeight;
exports.innerWidth = innerWidth;
exports.offsetXYFromParent = offsetXYFromParent;
exports.createCSSTransform = createCSSTransform;
exports.createSVGTransform = createSVGTransform;
exports.getTouch = getTouch;
exports.getTouchIdentifier = getTouchIdentifier;
exports.addUserSelectStyles = addUserSelectStyles;
exports.removeUserSelectStyles = removeUserSelectStyles;
exports.styleHacks = styleHacks;
exports.addClassName = addClassName;
exports.removeClassName = removeClassName;

var _shims = __webpack_require__(0);

var _getPrefix = __webpack_require__(18);

var _getPrefix2 = _interopRequireDefault(_getPrefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*:: import type {ControlPosition, MouseTouchEvent} from './types';*/


var matchesSelectorFunc = '';
function matchesSelector(el /*: Node*/, selector /*: string*/) /*: boolean*/ {
  if (!matchesSelectorFunc) {
    matchesSelectorFunc = (0, _shims.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
      // $FlowIgnore: Doesn't think elements are indexable
      return (0, _shims.isFunction)(el[method]);
    });
  }

  // $FlowIgnore: Doesn't think elements are indexable
  return el[matchesSelectorFunc].call(el, selector);
}

// Works up the tree to the draggable itself attempting to match selector.
function matchesSelectorAndParentsTo(el /*: Node*/, selector /*: string*/, baseNode /*: Node*/) /*: boolean*/ {
  var node = el;
  do {
    if (matchesSelector(node, selector)) return true;
    if (node === baseNode) return false;
    node = node.parentNode;
  } while (node);

  return false;
}

function addEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
  if (!el) {
    return;
  }
  if (el.attachEvent) {
    el.attachEvent('on' + event, handler);
  } else if (el.addEventListener) {
    el.addEventListener(event, handler, true);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
  }
}

function removeEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
  if (!el) {
    return;
  }
  if (el.detachEvent) {
    el.detachEvent('on' + event, handler);
  } else if (el.removeEventListener) {
    el.removeEventListener(event, handler, true);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
  }
}

function outerHeight(node /*: HTMLElement*/) /*: number*/ {
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetTop which is including margin. See getBoundPosition
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height += (0, _shims.int)(computedStyle.borderTopWidth);
  height += (0, _shims.int)(computedStyle.borderBottomWidth);
  return height;
}

function outerWidth(node /*: HTMLElement*/) /*: number*/ {
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetLeft which is including margin. See getBoundPosition
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width += (0, _shims.int)(computedStyle.borderLeftWidth);
  width += (0, _shims.int)(computedStyle.borderRightWidth);
  return width;
}
function innerHeight(node /*: HTMLElement*/) /*: number*/ {
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height -= (0, _shims.int)(computedStyle.paddingTop);
  height -= (0, _shims.int)(computedStyle.paddingBottom);
  return height;
}

function innerWidth(node /*: HTMLElement*/) /*: number*/ {
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width -= (0, _shims.int)(computedStyle.paddingLeft);
  width -= (0, _shims.int)(computedStyle.paddingRight);
  return width;
}

// Get from offsetParent
function offsetXYFromParent(evt /*: {clientX: number, clientY: number}*/, offsetParent /*: HTMLElement*/) /*: ControlPosition*/ {
  var isBody = offsetParent === offsetParent.ownerDocument.body;
  var offsetParentRect = isBody ? { left: 0, top: 0 } : offsetParent.getBoundingClientRect();

  var x = evt.clientX + offsetParent.scrollLeft - offsetParentRect.left;
  var y = evt.clientY + offsetParent.scrollTop - offsetParentRect.top;

  return { x: x, y: y };
}

function createCSSTransform(_ref) /*: Object*/ {
  var x = _ref.x,
      y = _ref.y;

  // Replace unitless items with px
  return _defineProperty({}, (0, _getPrefix.browserPrefixToKey)('transform', _getPrefix2.default), 'translate(' + x + 'px,' + y + 'px)');
}

function createSVGTransform(_ref3) /*: string*/ {
  var x = _ref3.x,
      y = _ref3.y;

  return 'translate(' + x + ',' + y + ')';
}

function getTouch(e /*: MouseTouchEvent*/, identifier /*: number*/) /*: ?{clientX: number, clientY: number}*/ {
  return e.targetTouches && (0, _shims.findInArray)(e.targetTouches, function (t) {
    return identifier === t.identifier;
  }) || e.changedTouches && (0, _shims.findInArray)(e.changedTouches, function (t) {
    return identifier === t.identifier;
  });
}

function getTouchIdentifier(e /*: MouseTouchEvent*/) /*: ?number*/ {
  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}

// User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.

// Note we're passing `document` b/c we could be iframed
function addUserSelectStyles(doc /*: Document*/) {
  var styleEl = doc.getElementById('react-draggable-style-el');
  if (!styleEl) {
    styleEl = doc.createElement('style');
    styleEl.type = 'text/css';
    styleEl.id = 'react-draggable-style-el';
    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {background: transparent;}\n';
    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {background: transparent;}\n';
    doc.getElementsByTagName('head')[0].appendChild(styleEl);
  }
  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
}

function removeUserSelectStyles(doc /*: Document*/) {
  if (doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection');
  window.getSelection().removeAllRanges(); // remove selection caused by scroll
}

function styleHacks() /*: Object*/ {
  var childStyle /*: Object*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // Workaround IE pointer events; see #51
  // https://github.com/mzabriskie/react-draggable/issues/51#issuecomment-103488278
  return _extends({
    touchAction: 'none'
  }, childStyle);
}

function addClassName(el /*: HTMLElement*/, className /*: string*/) {
  if (el.classList) {
    el.classList.add(className);
  } else {
    if (!el.className.match(new RegExp('(?:^|\\s)' + className + '(?!\\S)'))) {
      el.className += ' ' + className;
    }
  }
}

function removeClassName(el /*: HTMLElement*/, className /*: string*/) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(new RegExp('(?:^|\\s)' + className + '(?!\\S)', 'g'), '');
  }
}

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(14)(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(16)();
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(1);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBoundPosition = getBoundPosition;
exports.snapToGrid = snapToGrid;
exports.canDragX = canDragX;
exports.canDragY = canDragY;
exports.getControlPosition = getControlPosition;
exports.createCoreData = createCoreData;
exports.createDraggableData = createDraggableData;

var _shims = __webpack_require__(0);

var _reactDom = __webpack_require__(4);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _domFns = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*:: import type Draggable from '../Draggable';*/
/*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/
/*:: import type DraggableCore from '../DraggableCore';*/
function getBoundPosition(draggable /*: Draggable*/, x /*: number*/, y /*: number*/) /*: [number, number]*/ {
  // If no bounds, short-circuit and move on
  if (!draggable.props.bounds) return [x, y];

  // Clone new bounds
  var bounds = draggable.props.bounds;

  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
  var node = findDOMNode(draggable);

  if (typeof bounds === 'string') {
    var ownerDocument = node.ownerDocument;

    var ownerWindow = ownerDocument.defaultView;
    var boundNode = void 0;
    if (bounds === 'parent') {
      boundNode = node.parentNode;
    } else {
      boundNode = ownerDocument.querySelector(bounds);
    }
    if (!(boundNode instanceof HTMLElement)) {
      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
    }
    var nodeStyle = ownerWindow.getComputedStyle(node);
    var boundNodeStyle = ownerWindow.getComputedStyle(boundNode);
    // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
    bounds = {
      left: -node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingLeft) + (0, _shims.int)(nodeStyle.marginLeft),
      top: -node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingTop) + (0, _shims.int)(nodeStyle.marginTop),
      right: (0, _domFns.innerWidth)(boundNode) - (0, _domFns.outerWidth)(node) - node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingRight) - (0, _shims.int)(nodeStyle.marginRight),
      bottom: (0, _domFns.innerHeight)(boundNode) - (0, _domFns.outerHeight)(node) - node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingBottom) - (0, _shims.int)(nodeStyle.marginBottom)
    };
  }

  // Keep x and y below right and bottom limits...
  if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
  if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);

  // But above left and top limits.
  if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
  if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);

  return [x, y];
}

function snapToGrid(grid /*: [number, number]*/, pendingX /*: number*/, pendingY /*: number*/) /*: [number, number]*/ {
  var x = Math.round(pendingX / grid[0]) * grid[0];
  var y = Math.round(pendingY / grid[1]) * grid[1];
  return [x, y];
}

function canDragX(draggable /*: Draggable*/) /*: boolean*/ {
  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}

function canDragY(draggable /*: Draggable*/) /*: boolean*/ {
  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
}

// Get {x, y} positions from event.
function getControlPosition(e /*: MouseTouchEvent*/, touchIdentifier /*: ?number*/, draggableCore /*: DraggableCore*/) /*: ?ControlPosition*/ {
  var touchObj = typeof touchIdentifier === 'number' ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
  var node = findDOMNode(draggableCore);
  // User can provide an offsetParent if desired.
  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
  return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent);
}

// Create an data object exposed by <DraggableCore>'s events
function createCoreData(draggable /*: DraggableCore*/, x /*: number*/, y /*: number*/) /*: DraggableData*/ {
  var state = draggable.state;
  var isStart = !(0, _shims.isNum)(state.lastX);
  var node = findDOMNode(draggable);

  if (isStart) {
    // If this is our first move, use the x and y as last coords.
    return {
      node: node,
      deltaX: 0, deltaY: 0,
      lastX: x, lastY: y,
      x: x, y: y
    };
  } else {
    // Otherwise calculate proper values.
    return {
      node: node,
      deltaX: x - state.lastX, deltaY: y - state.lastY,
      lastX: state.lastX, lastY: state.lastY,
      x: x, y: y
    };
  }
}

// Create an data exposed by <Draggable>'s events
function createDraggableData(draggable /*: Draggable*/, coreData /*: DraggableData*/) /*: DraggableData*/ {
  return {
    node: coreData.node,
    x: draggable.state.x + coreData.deltaX,
    y: draggable.state.y + coreData.deltaY,
    deltaX: coreData.deltaX,
    deltaY: coreData.deltaY,
    lastX: draggable.state.x,
    lastY: draggable.state.y
  };
}

// A lot faster than stringify/parse
function cloneBounds(bounds /*: Bounds*/) /*: Bounds*/ {
  return {
    left: bounds.left,
    top: bounds.top,
    right: bounds.right,
    bottom: bounds.bottom
  };
}

function findDOMNode(draggable /*: Draggable | DraggableCore*/) /*: HTMLElement*/ {
  var node = _reactDom2.default.findDOMNode(draggable);
  if (!node) {
    throw new Error('<DraggableCore>: Unmounted during event!');
  }
  // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
  return node;
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(6);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(4);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _domFns = __webpack_require__(5);

var _positionFns = __webpack_require__(9);

var _shims = __webpack_require__(0);

var _log = __webpack_require__(11);

var _log2 = _interopRequireDefault(_log);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/


// Simple abstraction for dragging events names.
/*:: import type {Element as ReactElement} from 'react';*/
var eventsFor = {
  touch: {
    start: 'touchstart',
    move: 'touchmove',
    stop: 'touchend'
  },
  mouse: {
    start: 'mousedown',
    move: 'mousemove',
    stop: 'mouseup'
  }
};

// Default to mouse events.
var dragEventFor = eventsFor.mouse;

/*:: type DraggableCoreState = {
  dragging: boolean,
  lastX: number,
  lastY: number,
  touchIdentifier: ?number
};*/
/*:: export type DraggableBounds = {
  left: number,
  right: number,
  top: number,
  bottom: number,
};*/
/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/
/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void;*/
/*:: export type ControlPosition = {x: number, y: number};*/


//
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//

/*:: export type DraggableCoreProps = {
  allowAnyClick: boolean,
  cancel: string,
  children: ReactElement<any>,
  disabled: boolean,
  enableUserSelectHack: boolean,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
};*/

var DraggableCore = function (_React$Component) {
  _inherits(DraggableCore, _React$Component);

  function DraggableCore() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DraggableCore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DraggableCore.__proto__ || Object.getPrototypeOf(DraggableCore)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      dragging: false,
      // Used while dragging to determine deltas.
      lastX: NaN, lastY: NaN,
      touchIdentifier: null
    }, _this.handleDragStart = function (e) {
      // Make it possible to attach event handlers on top of this one.
      _this.props.onMouseDown(e);

      // Only accept left-clicks.
      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;

      // Get nodes. Be sure to grab relative document (could be iframed)
      var thisNode = _reactDom2.default.findDOMNode(_this);
      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
        throw new Error('<DraggableCore> not mounted on DragStart!');
      }
      var ownerDocument = thisNode.ownerDocument;

      // Short circuit if handle or cancel prop was provided and selector doesn't match.

      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) {
        return;
      }

      // Set touch identifier in component state if this is a touch event. This allows us to
      // distinguish between individual touches on multitouch screens by identifying which
      // touchpoint was set to this element.
      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
      _this.setState({ touchIdentifier: touchIdentifier });

      // Get the current drag point from the event. This is used as the offset.
      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _this);
      if (position == null) return; // not possible but satisfies flow
      var x = position.x,
          y = position.y;

      // Create an event object with all the data parents need to make a decision here.

      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);

      (0, _log2.default)('DraggableCore: handleDragStart: %j', coreEvent);

      // Call event handler. If it returns explicit false, cancel.
      (0, _log2.default)('calling', _this.props.onStart);
      var shouldUpdate = _this.props.onStart(e, coreEvent);
      if (shouldUpdate === false) return;

      // Add a style to the body to disable user-select. This prevents text from
      // being selected all over the page.
      if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument);

      // Initiate dragging. Set the current x and y as offsets
      // so we know how much we've moved during the drag. This allows us
      // to drag elements around even if they have been moved, without issue.
      _this.setState({
        dragging: true,

        lastX: x,
        lastY: y
      });

      // Add events to the document directly so we catch when the user's mouse/touch moves outside of
      // this element. We use different events depending on whether or not we have detected that this
      // is a touch-capable device.
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
    }, _this.handleDrag = function (e) {

      // Prevent scrolling on mobile devices, like ipad/iphone.
      if (e.type === 'touchmove') e.preventDefault();

      // Get the current drag point from the event. This is used as the offset.
      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _this);
      if (position == null) return;
      var x = position.x,
          y = position.y;

      // Snap to grid if prop has been provided

      if (Array.isArray(_this.props.grid)) {
        var _deltaX = x - _this.state.lastX,
            _deltaY = y - _this.state.lastY;

        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, _deltaX, _deltaY);

        var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);

        _deltaX = _snapToGrid2[0];
        _deltaY = _snapToGrid2[1];

        if (!_deltaX && !_deltaY) return; // skip useless drag
        x = _this.state.lastX + _deltaX, y = _this.state.lastY + _deltaY;
      }

      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);

      (0, _log2.default)('DraggableCore: handleDrag: %j', coreEvent);

      // Call event handler. If it returns explicit false, trigger end.
      var shouldUpdate = _this.props.onDrag(e, coreEvent);
      if (shouldUpdate === false) {
        try {
          // $FlowIgnore
          _this.handleDragStop(new MouseEvent('mouseup'));
        } catch (err) {
          // Old browsers
          var event = ((document.createEvent('MouseEvents') /*: any*/) /*: MouseTouchEvent*/);
          // I see why this insanity was deprecated
          // $FlowIgnore
          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
          _this.handleDragStop(event);
        }
        return;
      }

      _this.setState({
        lastX: x,
        lastY: y
      });
    }, _this.handleDragStop = function (e) {
      if (!_this.state.dragging) return;

      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _this);
      if (position == null) return;
      var x = position.x,
          y = position.y;

      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);

      var thisNode = _reactDom2.default.findDOMNode(_this);
      if (thisNode) {
        // Remove user-select hack
        if (_this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
      }

      (0, _log2.default)('DraggableCore: handleDragStop: %j', coreEvent);

      // Reset the el.
      _this.setState({
        dragging: false,
        lastX: NaN,
        lastY: NaN
      });

      // Call event handler
      _this.props.onStop(e, coreEvent);

      if (thisNode) {
        // Remove event handlers
        (0, _log2.default)('DraggableCore: Removing handlers');
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
      }
    }, _this.onMouseDown = function (e) {
      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse

      return _this.handleDragStart(e);
    }, _this.onMouseUp = function (e) {
      dragEventFor = eventsFor.mouse;

      return _this.handleDragStop(e);
    }, _this.onTouchStart = function (e) {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;

      return _this.handleDragStart(e);
    }, _this.onTouchEnd = function (e) {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;

      return _this.handleDragStop(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DraggableCore, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Remove any leftover event handlers. Remove both touch and mouse handlers in case
      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
      var thisNode = _reactDom2.default.findDOMNode(this);
      if (thisNode) {
        var ownerDocument = thisNode.ownerDocument;

        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
        if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument);
      }
    }

    // Same as onMouseDown (start drag), but now consider this a touch device.

  }, {
    key: 'render',
    value: function render() {
      // Reuse the child provided
      // This makes it flexible to use whatever element is wanted (div, ul, etc)
      return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), {
        style: (0, _domFns.styleHacks)(this.props.children.props.style),

        // Note: mouseMove handler is attached to document so it will still function
        // when the user drags quickly and leaves the bounds of the element.
        onMouseDown: this.onMouseDown,
        onTouchStart: this.onTouchStart,
        onMouseUp: this.onMouseUp,
        onTouchEnd: this.onTouchEnd
      });
    }
  }]);

  return DraggableCore;
}(_react2.default.Component);

DraggableCore.displayName = 'DraggableCore';
DraggableCore.propTypes = {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: _propTypes2.default.bool,

  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: _propTypes2.default.bool,

  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: _propTypes2.default.bool,

  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function offsetParent(props, propName) {
    if (process.browser && props[propName] && props[propName].nodeType !== 1) {
      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    }
  },

  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: _propTypes2.default.arrayOf(_propTypes2.default.number),

  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: _propTypes2.default.string,

  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: _propTypes2.default.string,

  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: _propTypes2.default.func,

  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: _propTypes2.default.func,

  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: _propTypes2.default.func,

  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
};
DraggableCore.defaultProps = {
  allowAnyClick: false, // by default only accept left click
  cancel: null,
  disabled: false,
  enableUserSelectHack: true,
  offsetParent: null,
  handle: null,
  grid: null,
  transform: null,
  onStart: function onStart() {},
  onDrag: function onDrag() {},
  onStop: function onStop() {},
  onMouseDown: function onMouseDown() {}
};
exports.default = DraggableCore;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = log;

/*eslint no-console:0*/
function log() {
  var _console;

  if (undefined) (_console = console).log.apply(_console, arguments);
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Draggable = __webpack_require__(13).default;

// Previous versions of this lib exported <Draggable> as the root export. As to not break
// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
module.exports = Draggable;
module.exports.default = Draggable;
module.exports.DraggableCore = __webpack_require__(10).default;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(6);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(4);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _domFns = __webpack_require__(5);

var _positionFns = __webpack_require__(9);

var _shims = __webpack_require__(0);

var _DraggableCore = __webpack_require__(10);

var _DraggableCore2 = _interopRequireDefault(_DraggableCore);

var _log = __webpack_require__(11);

var _log2 = _interopRequireDefault(_log);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*:: import type {ControlPosition, DraggableBounds, DraggableCoreProps} from './DraggableCore';*/
/*:: import type {DraggableEventHandler} from './utils/types';*/
/*:: import type {Element as ReactElement} from 'react';*/
/*:: type DraggableState = {
  dragging: boolean,
  dragged: boolean,
  x: number, y: number,
  slackX: number, slackY: number,
  isElementSVG: boolean
};*/


//
// Define <Draggable>
//

/*:: export type DraggableProps = {
  ...$Exact<DraggableCoreProps>,
  axis: 'both' | 'x' | 'y' | 'none',
  bounds: DraggableBounds | string | false,
  defaultClassName: string,
  defaultClassNameDragging: string,
  defaultClassNameDragged: string,
  defaultPosition: ControlPosition,
  position: ControlPosition,
};*/

var Draggable = function (_React$Component) {
  _inherits(Draggable, _React$Component);

  function Draggable(props /*: DraggableProps*/) {
    _classCallCheck(this, Draggable);

    var _this = _possibleConstructorReturn(this, (Draggable.__proto__ || Object.getPrototypeOf(Draggable)).call(this, props));

    _this.onDragStart = function (e, coreData) {
      (0, _log2.default)('Draggable: onDragStart: %j', coreData);

      // Short-circuit if user's callback killed it.
      var shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_this, coreData));
      // Kills start event on core as well, so move handlers are never bound.
      if (shouldStart === false) return false;

      _this.setState({ dragging: true, dragged: true });
    };

    _this.onDrag = function (e, coreData) {
      if (!_this.state.dragging) return false;
      (0, _log2.default)('Draggable: onDrag: %j', coreData);

      var uiData = (0, _positionFns.createDraggableData)(_this, coreData);

      var newState /*: $Shape<DraggableState>*/ = {
        x: uiData.x,
        y: uiData.y
      };

      // Keep within bounds.
      if (_this.props.bounds) {
        // Save original x and y.
        var _x = newState.x,
            _y = newState.y;

        // Add slack to the values used to calculate bound position. This will ensure that if
        // we start removing slack, the element won't react to it right away until it's been
        // completely removed.

        newState.x += _this.state.slackX;
        newState.y += _this.state.slackY;

        // Get bound position. This will ceil/floor the x and y within the boundaries.
        // $FlowBug

        // Recalculate slack by noting how much was shaved by the boundPosition handler.
        var _getBoundPosition = (0, _positionFns.getBoundPosition)(_this, newState.x, newState.y);

        var _getBoundPosition2 = _slicedToArray(_getBoundPosition, 2);

        newState.x = _getBoundPosition2[0];
        newState.y = _getBoundPosition2[1];
        newState.slackX = _this.state.slackX + (_x - newState.x);
        newState.slackY = _this.state.slackY + (_y - newState.y);

        // Update the event we fire to reflect what really happened after bounds took effect.
        uiData.x = newState.x;
        uiData.y = newState.y;
        uiData.deltaX = newState.x - _this.state.x;
        uiData.deltaY = newState.y - _this.state.y;
      }

      // Short-circuit if user's callback killed it.
      var shouldUpdate = _this.props.onDrag(e, uiData);
      if (shouldUpdate === false) return false;

      _this.setState(newState);
    };

    _this.onDragStop = function (e, coreData) {
      if (!_this.state.dragging) return false;

      // Short-circuit if user's callback killed it.
      var shouldStop = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_this, coreData));
      if (shouldStop === false) return false;

      (0, _log2.default)('Draggable: onDragStop: %j', coreData);

      var newState /*: $Shape<DraggableState>*/ = {
        dragging: false,
        slackX: 0,
        slackY: 0
      };

      // If this is a controlled component, the result of this operation will be to
      // revert back to the old position. We expect a handler on `onDragStop`, at the least.
      var controlled = Boolean(_this.props.position);
      if (controlled) {
        var _this$props$position = _this.props.position,
            _x2 = _this$props$position.x,
            _y2 = _this$props$position.y;

        newState.x = _x2;
        newState.y = _y2;
      }

      _this.setState(newState);
    };

    _this.state = {
      // Whether or not we are currently dragging.
      dragging: false,

      // Whether or not we have been dragged before.
      dragged: false,

      // Current transform x and y.
      x: props.position ? props.position.x : props.defaultPosition.x,
      y: props.position ? props.position.y : props.defaultPosition.y,

      // Used for compensating for out-of-bounds drags
      slackX: 0, slackY: 0,

      // Can only determine if SVG after mounting
      isElementSVG: false
    };
    return _this;
  }

  _createClass(Draggable, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.position && !(this.props.onDrag || this.props.onStop)) {
        // eslint-disable-next-line
        console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Check to see if the element passed is an instanceof SVGElement
      if (typeof window.SVGElement !== 'undefined' && _reactDom2.default.findDOMNode(this) instanceof window.SVGElement) {
        this.setState({ isElementSVG: true });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps /*: Object*/) {
      // Set x/y if position has changed
      if (nextProps.position && (!this.props.position || nextProps.position.x !== this.props.position.x || nextProps.position.y !== this.props.position.y)) {
        this.setState({ x: nextProps.position.x, y: nextProps.position.y });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.setState({ dragging: false }); // prevents invariant if unmounted while dragging
    }
  }, {
    key: 'render',
    value: function render() /*: ReactElement<any>*/ {
      var _classNames;

      var style = {},
          svgTransform = null;

      // If this is controlled, we don't want to move it - unless it's dragging.
      var controlled = Boolean(this.props.position);
      var draggable = !controlled || this.state.dragging;

      var position = this.props.position || this.props.defaultPosition;
      var transformOpts = {
        // Set left if horizontal drag is enabled
        x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : position.x,

        // Set top if vertical drag is enabled
        y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : position.y
      };

      // If this element was SVG, we use the `transform` attribute.
      if (this.state.isElementSVG) {
        svgTransform = (0, _domFns.createSVGTransform)(transformOpts);
      } else {
        // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, _domFns.createCSSTransform)(transformOpts);
      }

      var _props = this.props,
          defaultClassName = _props.defaultClassName,
          defaultClassNameDragging = _props.defaultClassNameDragging,
          defaultClassNameDragged = _props.defaultClassNameDragged;

      // Mark with class while dragging

      var className = (0, _classnames2.default)(this.props.children.props.className || '', defaultClassName, (_classNames = {}, _defineProperty(_classNames, defaultClassNameDragging, this.state.dragging), _defineProperty(_classNames, defaultClassNameDragged, this.state.dragged), _classNames));

      // Reuse the child provided
      // This makes it flexible to use whatever element is wanted (div, ul, etc)
      return _react2.default.createElement(
        _DraggableCore2.default,
        _extends({}, this.props, { onStart: this.onDragStart, onDrag: this.onDrag, onStop: this.onDragStop }),
        _react2.default.cloneElement(_react2.default.Children.only(this.props.children), {
          className: className,
          style: _extends({}, this.props.children.props.style, style),
          transform: svgTransform
        })
      );
    }
  }]);

  return Draggable;
}(_react2.default.Component);

Draggable.displayName = 'Draggable';
Draggable.propTypes = _extends({}, _DraggableCore2.default.propTypes, {

  /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */
  axis: _propTypes2.default.oneOf(['both', 'x', 'y', 'none']),

  /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  bounds: _propTypes2.default.oneOfType([_propTypes2.default.shape({
    left: _propTypes2.default.number,
    right: _propTypes2.default.number,
    top: _propTypes2.default.number,
    bottom: _propTypes2.default.number
  }), _propTypes2.default.string, _propTypes2.default.oneOf([false])]),

  defaultClassName: _propTypes2.default.string,
  defaultClassNameDragging: _propTypes2.default.string,
  defaultClassNameDragged: _propTypes2.default.string,

  /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */
  defaultPosition: _propTypes2.default.shape({
    x: _propTypes2.default.number,
    y: _propTypes2.default.number
  }),

  /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */
  position: _propTypes2.default.shape({
    x: _propTypes2.default.number,
    y: _propTypes2.default.number
  }),

  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
});
Draggable.defaultProps = _extends({}, _DraggableCore2.default.defaultProps, {
  axis: 'both',
  bounds: false,
  defaultClassName: 'react-draggable',
  defaultClassNameDragging: 'react-draggable-dragging',
  defaultClassNameDragged: 'react-draggable-dragged',
  defaultPosition: { x: 0, y: 0 },
  position: null
});
exports.default = Draggable;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(1);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(8);

var ReactPropTypesSecret = __webpack_require__(3);
var checkPropTypes = __webpack_require__(15);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
  var invariant = __webpack_require__(2);
  var warning = __webpack_require__(8);
  var ReactPropTypesSecret = __webpack_require__(3);
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(1);
var invariant = __webpack_require__(2);
var ReactPropTypesSecret = __webpack_require__(3);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPrefix = getPrefix;
exports.browserPrefixToKey = browserPrefixToKey;
exports.browserPrefixToStyle = browserPrefixToStyle;
var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
function getPrefix() /*: string*/ {
  var prop /*: string*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';

  // Checking specifically for 'window.document' is for pseudo-browser server-side
  // environments that define 'window' as the global context.
  // E.g. React-rails (see https://github.com/reactjs/react-rails/pull/84)
  if (typeof window === 'undefined' || typeof window.document === 'undefined') return '';

  var style = window.document.documentElement.style;

  if (prop in style) return '';

  for (var i = 0; i < prefixes.length; i++) {
    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
  }

  return '';
}

function browserPrefixToKey(prop /*: string*/, prefix /*: string*/) /*: string*/ {
  return prefix ? '' + prefix + kebabToTitleCase(prop) : prop;
}

function browserPrefixToStyle(prop /*: string*/, prefix /*: string*/) /*: string*/ {
  return prefix ? '-' + prefix.toLowerCase() + '-' + prop : prop;
}

function kebabToTitleCase(str /*: string*/) /*: string*/ {
  var out = '';
  var shouldCapitalize = true;
  for (var i = 0; i < str.length; i++) {
    if (shouldCapitalize) {
      out += str[i].toUpperCase();
      shouldCapitalize = false;
    } else if (str[i] === '-') {
      shouldCapitalize = true;
    } else {
      out += str[i];
    }
  }
  return out;
}

// Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
exports.default = getPrefix();

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=react-draggable.js.map

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Builder = __webpack_require__(16);

exports.default = function (_ref) {
  var _ref$radius = _ref.radius,
      radius = _ref$radius === undefined ? 14 : _ref$radius,
      leftRight = _ref.leftRight,
      topBottom = _ref.topBottom,
      text = _ref.text,
      color = _ref.color,
      editMode = _ref.editMode;

  var handles = [];
  var components = [];

  var innerRadius = radius * 0.7;
  var x = 0;
  var y = 0;

  var notCornerOffset = Math.sqrt(2) * radius;
  var placement = {
    xleftcorner: -radius,
    xrightcorner: radius,
    ytopcorner: -radius,
    ybottomcorner: radius,
    xleft: -notCornerOffset,
    xright: notCornerOffset,
    ytop: -notCornerOffset,
    ybottom: notCornerOffset
  };

  if (leftRight && !topBottom) {
    x = placement["x" + leftRight];
  } else if (topBottom && !leftRight) {
    y = placement["y" + topBottom];
  } else if (leftRight && topBottom) {
    x = placement["x" + leftRight + "corner"];
    y = placement["y" + topBottom + "corner"];
  }

  var transform = "translate(" + x + ", " + y + ")";
  var circlebg = (0, _Builder.arcBuilder)({ className: "subject", data: { radius: radius } });
  circlebg.attrs.transform = transform;
  circlebg.attrs.fill = color;
  circlebg.attrs["stroke-linecap"] = "round";
  circlebg.attrs["stroke-width"] = "3px";

  var circle = (0, _Builder.arcBuilder)({
    className: "subject-ring",
    data: { outerRadius: radius, innerRadius: innerRadius }
  });

  circle.attrs.transform = transform;
  circle.attrs["stroke-width"] = "3px";
  circle.attrs.fill = "white";

  var pointer = void 0;
  if (x && y || !x && !y) {
    pointer = (0, _Builder.lineBuilder)({
      className: "subject-pointer",
      data: [[0, 0], [x || 0, 0], [0, y || 0], [0, 0]]
    });
  } else if (x || y) {
    var notCornerPointerXY = function notCornerPointerXY(v) {
      var sign = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return v && v / Math.sqrt(2) / Math.sqrt(2) || sign * radius / Math.sqrt(2);
    };

    pointer = (0, _Builder.lineBuilder)({
      className: "subject-pointer",
      data: [[0, 0], [notCornerPointerXY(x), notCornerPointerXY(y)], [notCornerPointerXY(x, -1), notCornerPointerXY(y, -1)], [0, 0]]
    });
  }

  if (pointer) {
    pointer.attrs.fill = color;
    pointer.attrs["stroke-linecap"] = "round";
    pointer.attrs["stroke-width"] = "3px";
    components.push(pointer);
  }

  if (editMode) {
    var bHandles = {
      x: x * 2,
      y: y * 2,
      offsetParent: true
    };
    if (!bHandles.x && !bHandles.y) {
      bHandles.y = -radius;
    }

    handles = [bHandles];
  }

  var textNode = void 0;
  if (text) {
    textNode = {
      type: "text",
      className: "badge-text",
      attrs: {
        fill: "white",
        stroke: "none",
        "font-size": ".7em",
        text: text,
        "text-anchor": "middle",
        dy: ".25em",
        x: x,
        y: y
      }
    };
  }

  components.push(circlebg);
  components.push(circle);
  components.push(textNode);

  return { components: components, handles: handles };
};

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.circleHandles = undefined;

var _Builder = __webpack_require__(16);

var circleHandles = exports.circleHandles = function circleHandles(_ref) {
  var _ref$cx = _ref.cx,
      cx = _ref$cx === undefined ? 0 : _ref$cx,
      _ref$cy = _ref.cy,
      cy = _ref$cy === undefined ? 0 : _ref$cy,
      r1 = _ref.r1,
      r2 = _ref.r2,
      padding = _ref.padding;

  var h = { move: { x: cx, y: cy } };

  if (r1 !== undefined) {
    h.r1 = { x: cx + r1 / Math.sqrt(2), y: cy + r1 / Math.sqrt(2) };
  }

  if (r2 !== undefined) {
    h.r2 = { x: cx + r2 / Math.sqrt(2), y: cy + r2 / Math.sqrt(2) };
  }

  if (padding !== undefined) {
    h.padding = { x: cx + r1 + padding, y: cy };
  }

  return h;
};

exports.default = function (_ref2) {
  var radius = _ref2.radius,
      radiusPadding = _ref2.radiusPadding,
      outerRadius = _ref2.outerRadius,
      innerRadius = _ref2.innerRadius,
      editMode = _ref2.editMode;

  var handles = [];
  var c = (0, _Builder.arcBuilder)({
    data: { radius: radius, outerRadius: outerRadius, innerRadius: innerRadius },
    className: "subject"
  });

  if (editMode) {
    var h = circleHandles({
      r1: c.data.outerRadius || c.data.radius,
      r2: c.data.innerRadius,
      padding: radiusPadding
    });

    var cHandles = [{
      x: h.r1.x,
      y: h.r1.y,
      key: c.data.outerRadius ? "outerRadius" : "radius"
    }];

    if (innerRadius) {
      cHandles.push({ x: h.r2.x, y: h.r2.y, key: "innerRadius" });
    }
    handles = cHandles;
  }

  c.attrs["fill-opacity"] = 0;

  return { components: [c], handles: handles };
};

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Builder = __webpack_require__(16);

exports.default = function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === undefined ? 100 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 100 : _ref$height,
      editMode = _ref.editMode;

  var handles = [];

  var data = [[0, 0], [width, 0], [width, height], [0, height], [0, 0]];
  var rect = (0, _Builder.lineBuilder)({ data: data, className: "subject" });

  if (editMode) {
    handles = [{ x: width, y: height / 2, key: "width" }, { x: width / 2, y: height, key: "height" }];
  }
  rect.attrs["fill-opacity"] = 0.1;
  return { components: [rect], handles: handles };
};

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Builder = __webpack_require__(16);

exports.default = function (_ref) {
  var x1 = _ref.x1,
      x2 = _ref.x2,
      y1 = _ref.y1,
      y2 = _ref.y2,
      x = _ref.x,
      y = _ref.y;

  x1 = (x1 !== undefined ? x1 : x) - x;
  x2 = (x2 !== undefined ? x2 : x) - x;
  y1 = (y1 !== undefined ? y1 : y) - y;
  y2 = (y2 !== undefined ? y2 : y) - y;

  var data = [[x1, y1], [x2, y2]];
  return { components: [(0, _Builder.lineBuilder)({ data: data, className: "subject" })] };
};

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Builder = __webpack_require__(16);

//This curly brace function was
//made by Alex Hornbake
//http://bl.ocks.org/alexhornbake/6005176
function makeCurlyBrace(x1, y1, x2, y2, w, q) {
  //Calculate unit vector
  var dx = x1 - x2;
  var dy = y1 - y2;
  var len = Math.sqrt(dx * dx + dy * dy);
  dx = dx / len;
  dy = dy / len;

  //Calculate Control Points of path,
  var qx1 = x1 + q * w * dy;
  var qy1 = y1 - q * w * dx;
  var qx2 = x1 - 0.25 * len * dx + (1 - q) * w * dy;
  var qy2 = y1 - 0.25 * len * dy - (1 - q) * w * dx;
  var tx1 = x1 - 0.5 * len * dx + w * dy;
  var ty1 = y1 - 0.5 * len * dy - w * dx;
  var qx3 = x2 + q * w * dy;
  var qy3 = y2 - q * w * dx;
  var qx4 = x1 - 0.75 * len * dx + (1 - q) * w * dy;
  var qy4 = y1 - 0.75 * len * dy - (1 - q) * w * dx;

  return "M " + x1 + " " + y1 + " Q " + qx1 + " " + qy1 + " " + qx2 + " " + qy2 + " T " + tx1 + " " + ty1 + " M " + x2 + " " + y2 + " Q " + qx3 + " " + qy3 + " " + qx4 + " " + qy4 + " T " + tx1 + " " + ty1;
}

exports.default = function (_ref) {
  var height = _ref.height,
      width = _ref.width,
      depth = _ref.depth,
      type = _ref.type,
      editMode = _ref.editMode;

  var handles = [];
  var data = void 0;
  var bracket = void 0;
  if (type === "square") {
    if (height) {
      data = [[0, 0], [depth, 0], [depth, height], [0, height]];
    } else if (width) {
      data = [[0, 0], [0, depth], [width, depth], [width, 0]];
    }
    bracket = (0, _Builder.lineBuilder)({ data: data, className: "subject" });
  } else if (type === "curly") {
    bracket = (0, _Builder.pathBuilder)({
      d: makeCurlyBrace(0, 0, width || 0, height || 0, height && height > 0 || width && width < 0 ? -depth : depth, 0.55),
      className: "subject"
    });
  }

  if (editMode) {
    handles = [{
      x: height ? depth : width / 2,
      y: height ? height / 2 : depth,
      key: "depth",
      type: height ? "X" : "Y"
    }, {
      x: width || 0,
      y: height || 0,
      key: height ? "height" : "width"
    }];
  }

  bracket.attrs["fill-opacity"] = 0.1;
  return { components: [bracket], handles: handles };
};

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Builder = __webpack_require__(16);

var _alignment = __webpack_require__(200);

exports.default = function (_ref) {
  var align = _ref.align,
      _ref$x = _ref.x,
      x = _ref$x === undefined ? 0 : _ref$x,
      _ref$y = _ref.y,
      y = _ref$y === undefined ? 0 : _ref$y,
      bbox = _ref.bbox,
      offset = _ref.offset;

  align = (0, _alignment.leftRightDynamic)(align, offset.y);

  if (align === "top") {
    y -= bbox.height;
  } else if (align === "middle") {
    y -= bbox.height / 2;
  }

  var data = [[x, y], [x, y + bbox.height]];
  return { components: [(0, _Builder.lineBuilder)({ data: data, className: "note-line" })] };
};

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Builder = __webpack_require__(16);

var _alignment = __webpack_require__(200);

exports.default = function (_ref) {
  var align = _ref.align,
      _ref$x = _ref.x,
      x = _ref$x === undefined ? 0 : _ref$x,
      _ref$y = _ref.y,
      y = _ref$y === undefined ? 0 : _ref$y,
      offset = _ref.offset,
      bbox = _ref.bbox;

  align = (0, _alignment.topBottomDynamic)(align, offset.x);

  if (align === "right") {
    x -= bbox.width;
  } else if (align === "middle") {
    x -= bbox.width / 2;
  }

  var data = [[x, y], [x + bbox.width, y]];
  return { components: [(0, _Builder.lineBuilder)({ data: data, className: "note-line" })] };
};

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.AnnotationLabel = AnnotationLabel;
exports.AnnotationCallout = AnnotationCallout;
exports.AnnotationCalloutElbow = AnnotationCalloutElbow;
exports.AnnotationCalloutCurve = AnnotationCalloutCurve;
exports.AnnotationCalloutCircle = AnnotationCalloutCircle;
exports.AnnotationCalloutRect = AnnotationCalloutRect;
exports.AnnotationXYThreshold = AnnotationXYThreshold;
exports.AnnotationBadge = AnnotationBadge;
exports.AnnotationBracket = AnnotationBracket;
exports.AnnotationCalloutCustom = AnnotationCalloutCustom;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Annotation = __webpack_require__(201);

var _Annotation2 = _interopRequireDefault(_Annotation);

var _EditableAnnotation = __webpack_require__(387);

var _EditableAnnotation2 = _interopRequireDefault(_EditableAnnotation);

var _ConnectorLine = __webpack_require__(376);

var _ConnectorLine2 = _interopRequireDefault(_ConnectorLine);

var _ConnectorElbow = __webpack_require__(375);

var _ConnectorElbow2 = _interopRequireDefault(_ConnectorElbow);

var _ConnectorCurve = __webpack_require__(373);

var _ConnectorCurve2 = _interopRequireDefault(_ConnectorCurve);

var _ConnectorEndDot = __webpack_require__(377);

var _ConnectorEndDot2 = _interopRequireDefault(_ConnectorEndDot);

var _ConnectorEndArrow = __webpack_require__(379);

var _ConnectorEndArrow2 = _interopRequireDefault(_ConnectorEndArrow);

var _Subject = __webpack_require__(36);

var _Subject2 = _interopRequireDefault(_Subject);

var _SubjectCircle = __webpack_require__(381);

var _SubjectCircle2 = _interopRequireDefault(_SubjectCircle);

var _SubjectBadge = __webpack_require__(380);

var _SubjectBadge2 = _interopRequireDefault(_SubjectBadge);

var _SubjectBracket = __webpack_require__(384);

var _SubjectBracket2 = _interopRequireDefault(_SubjectBracket);

var _BracketNote = __webpack_require__(386);

var _BracketNote2 = _interopRequireDefault(_BracketNote);

var _SubjectRect = __webpack_require__(382);

var _SubjectRect2 = _interopRequireDefault(_SubjectRect);

var _SubjectThreshold = __webpack_require__(383);

var _SubjectThreshold2 = _interopRequireDefault(_SubjectThreshold);

var _SubjectCustom = __webpack_require__(385);

var _SubjectCustom2 = _interopRequireDefault(_SubjectCustom);

var _Note = __webpack_require__(199);

var _Note2 = _interopRequireDefault(_Note);

var _classnames = __webpack_require__(202);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAnnotationType = function getAnnotationType(editMode) {
  return editMode ? _EditableAnnotation2.default : _Annotation2.default;
};

var annotationMapper = function annotationMapper(props, Connector) {
  var NoteDefaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var Subject = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _Subject2.default;
  var SubjectDefaultProps = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var NoteType = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : _Note2.default;
  var _props$disable = props.disable,
      disable = _props$disable === undefined ? [] : _props$disable,
      connector = props.connector,
      note = props.note,
      subject = props.subject,
      x = props.x,
      y = props.y,
      dx = props.dx,
      dy = props.dy,
      nx = props.nx,
      ny = props.ny,
      color = props.color,
      className = props.className,
      onDrag = props.onDrag,
      onDragStart = props.onDragStart,
      onDragEnd = props.onDragEnd,
      editMode = props.editMode,
      events = props.events;

  var CONNECTORS = {
    type: {
      curve: _ConnectorCurve2.default,
      line: _ConnectorLine2.default,
      elbow: _ConnectorElbow2.default
    },
    end: {
      dot: _ConnectorEndDot2.default,
      arrow: _ConnectorEndArrow2.default
    }
  };

  var ConnectorType = void 0,
      ConnectorEndType = void 0;
  if (disable.indexOf("connector") === -1) {
    ConnectorType = connector && CONNECTORS.type[connector.type] || Connector;
    ConnectorEndType = connector && CONNECTORS.end[connector.end];
  }

  var AnnotationType = getAnnotationType(props.editMode);
  return _react2.default.createElement(
    AnnotationType,
    _extends({
      x: x,
      y: y,
      dx: dx,
      dy: dy,
      nx: nx,
      ny: ny,
      color: color,
      className: className,
      onDrag: onDrag,
      onDragStart: onDragStart,
      onDragEnd: onDragEnd,
      editMode: editMode
    }, SubjectDefaultProps, subject, {
      events: events
    }),
    ConnectorType && _react2.default.createElement(
      ConnectorType,
      connector,
      ConnectorEndType && _react2.default.createElement(ConnectorEndType, null)
    ),
    Subject && disable.indexOf("subject") === -1 && _react2.default.createElement(Subject, null),
    note && disable.indexOf("note") === -1 && _react2.default.createElement(NoteType, _extends({}, NoteDefaultProps, note))
  );
};

function AnnotationLabel(props) {
  var className = (0, _classnames2.default)("label", props.className);
  return annotationMapper(_extends({}, props, { className: className }), _ConnectorLine2.default, {
    align: "middle"
  });
}

function AnnotationCallout(props) {
  var className = (0, _classnames2.default)("callout", props.className);
  return annotationMapper(_extends({}, props, { className: className }), _ConnectorLine2.default, {
    lineType: "horizontal"
  });
}

function AnnotationCalloutElbow(props) {
  var className = (0, _classnames2.default)("callout elbow", props.className);
  return annotationMapper(_extends({}, props, { className: className }), _ConnectorElbow2.default, {
    lineType: "horizontal"
  });
}

function AnnotationCalloutCurve(props) {
  var className = (0, _classnames2.default)("callout curve", props.className);
  return annotationMapper(_extends({}, props, { className: className }), _ConnectorCurve2.default, {
    lineType: "horizontal"
  });
}

function AnnotationCalloutCircle(props) {
  var className = (0, _classnames2.default)("callout circle", props.className);
  return annotationMapper(_extends({}, props, { className: className }), _ConnectorElbow2.default, { lineType: "horizontal" }, _SubjectCircle2.default, { radius: 20 });
}

function AnnotationCalloutRect(props) {
  var className = (0, _classnames2.default)("callout rect", props.className);
  return annotationMapper(_extends({}, props, { className: className }), _ConnectorElbow2.default, { lineType: "horizontal" }, _SubjectRect2.default, { width: 100, height: 100 });
}

function AnnotationXYThreshold(props) {
  var className = (0, _classnames2.default)("callout xythreshold", props.className);
  return annotationMapper(_extends({}, props, { className: className }), _ConnectorElbow2.default, { lineType: "horizontal" }, _SubjectThreshold2.default);
}

function AnnotationBadge(props) {
  var className = (0, _classnames2.default)("badge", props.className);
  return annotationMapper(_extends({ disable: ["connector", "note"] }, props, { className: className }), null, null, _SubjectBadge2.default);
}

function AnnotationBracket(props) {
  var className = (0, _classnames2.default)("bracket", props.className);
  return annotationMapper(_extends({ disable: ["connector"] }, props, { className: className }), null, null, _SubjectBracket2.default, { depth: 20 }, _BracketNote2.default);
}

function AnnotationCalloutCustom(props) {
  var className = (0, _classnames2.default)("callout custom", props.className);
  return annotationMapper(_extends({}, props, { className: className }), _ConnectorElbow2.default, { lineType: "horizontal" }, _SubjectCustom2.default);
}

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.labella=e():t.labella=e()}(this,function(){return function(t){function e(n){if(r[n])return r[n].exports;var i=r[n]={exports:{},id:n,loaded:!1};return t[n].call(i.exports,i,i.exports,e),i.loaded=!0,i.exports}var r={};return e.m=t,e.c=r,e.p="",e(0)}([function(t,e,r){"use strict";t.exports={Node:r(1),Force:r(2),Distributor:r(3),Renderer:r(10)}},function(t,e){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=function(){function t(e,n,i){r(this,t),this.idealPos=e,this.currentPos=e,this.width=n,this.data=i,this.layerIndex=0}return n(t,[{key:"distanceFrom",value:function(t){var e=this.width/2,r=t.width/2;return Math.max(this.currentPos-e,t.currentPos-r)-Math.min(this.currentPos+e,t.currentPos+r)}},{key:"moveToIdealPosition",value:function(){return this.currentPos=this.idealPos,this}},{key:"displacement",value:function(){return this.idealPos-this.currentPos}},{key:"overlapWithNode",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return this.distanceFrom(t)-e<0}},{key:"overlapWithPoint",value:function(t){var e=this.width/2;return t>=this.currentPos-e&&t<=this.currentPos+e}},{key:"positionBefore",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return t.currentLeft()-this.width/2-e}},{key:"positionAfter",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return t.currentRight()+this.width/2+e}},{key:"currentRight",value:function(){return this.currentPos+this.width/2}},{key:"currentLeft",value:function(){return this.currentPos-this.width/2}},{key:"idealRight",value:function(){return this.idealPos+this.width/2}},{key:"idealLeft",value:function(){return this.idealPos-this.width/2}},{key:"createStub",value:function(e){var r=new t(this.idealPos,e,this.data);return r.currentPos=this.currentPos,r.child=this,this.parent=r,r}},{key:"removeStub",value:function(){return this.parent&&(this.parent.child=null,this.parent=null),this}},{key:"isStub",value:function(){return!!this.child}},{key:"getPathToRoot",value:function(){for(var t=[],e=this;e;)t.push(e),e=e.parent;return t}},{key:"getPathFromRoot",value:function(){return this.getPathToRoot().reverse()}},{key:"getPathToRootLength",value:function(){for(var t=0,e=this;e;){var r=e.parent?e.parent.currentPos:e.idealPos;t+=Math.abs(e.currentPos-r),e=e.parent}return t}},{key:"getRoot",value:function(){for(var t=this,e=this;e;)t=e,e=e.parent;return t}},{key:"getLayerIndex",value:function(){return this.layerIndex}},{key:"clone",value:function(){var e=new t(this.idealPos,this.width,this.data);return e.currentPos=this.currentPos,e.layerIndex=this.layerIndex,e}}]),t}();t.exports=i},function(t,e,r){"use strict";var n=r(3),i=r(4),o=r(8),s={nodeSpacing:3,minPos:0,maxPos:null,algorithm:"overlap",removeOverlap:!0,density:.85,stubWidth:1},u=function(t){var e={},r=i.extend({},s),u=new n,a=[],c=null;return e.nodes=function(t){return arguments.length?(a=t,c=[t.concat()],e):a},e.getLayers=function(){return c},e.options=function(t){if(!arguments.length)return r;r=i.extend(r,t);var o=i.pick(r,Object.keys(n.DEFAULT_OPTIONS));return i.isDefined(r.minPos)&&i.isDefined(r.maxPos)?o.layerWidth=r.maxPos-r.minPos:o.layerWidth=null,u.options(o),e},e.options(t),e.compute=function(){var t=i.pick(r,Object.keys(o.DEFAULT_OPTIONS));return a.forEach(function(t){t.removeStub()}),c=u.distribute(a),c.map(function(e,n){e.forEach(function(t){t.layerIndex=n}),r.removeOverlap&&o(e,t)}),e},e.start=function(){console.log("[warning] force.start() is deprecated. Please use force.compute() instead.")},e};u.DEFAULT_OPTIONS=s,t.exports=u},function(t,e,r){"use strict";var n=r(4),i=r(6),o={algorithm:"overlap",layerWidth:1e3,density:.75,nodeSpacing:3,stubWidth:1},s=function(t){var e={};t=n.extend({},o,t),e.options=function(r){return arguments.length?(t=n.extend(t,r),e):t},e.computeRequiredWidth=function(e){return n.sum(e,function(e){return e.width+t.nodeSpacing})-t.nodeSpacing},e.maxWidthPerLayer=function(){return t.density*t.layerWidth},e.needToSplit=function(t){return e.estimateRequiredLayers(t)>1},e.estimateRequiredLayers=function(r){return t.layerWidth?Math.ceil(e.computeRequiredWidth(r)/e.maxWidthPerLayer()):1};var r={simple:function(r){for(var n=e.estimateRequiredLayers(r),i=[],o=0;o<n;o++)i.push([]);return r.forEach(function(e,r){var o=r%n;i[o].push(e);for(var s=e,u=o-1;u>=0;u--)s=s.createStub(t.stubWidth),i[u].push(s)}),i},roundRobin:function(t){var e=[];return e},overlap:function(r){for(var n=[],i=e.maxWidthPerLayer(),o=r.concat(),s=e.computeRequiredWidth(o);s>i;){e.countIdealOverlaps(o);var u=o.concat(),a=s;for(o=[];u.length>2&&a>i;){u.sort(function(t,e){return e.overlapCount-t.overlapCount});var c=u.shift();a-=c.width,a+=t.stubWidth,c.overlaps.forEach(function(t){t.overlapCount--}),o.push(c)}n.push(u),s=e.computeRequiredWidth(o)}o.length>0&&n.push(o);for(var h=n.length-1;h>=1;h--)for(var l=n[h],f=0;f<l.length;f++){var p=l[f];if(!p.isStub())for(var d=p,v=h-1;v>=0;v--)d=d.createStub(t.stubWidth),n[v].push(d)}return n}};return e.countIdealOverlaps=function(e){var r=new i(t.layerWidth/2);return e.forEach(function(t){r.add([t.idealLeft(),t.idealRight(),t])}),e.forEach(function(t){var e=r.search(t.idealLeft(),t.idealRight());t.overlaps=e.map(function(t){return t.data[2]}),t.overlapCount=e.length}),e},e.distribute=function(i){if(!i||0===i.length)return[];if("none"==t.algorithm||!n.isDefined(t.algorithm))return[i];if(!e.needToSplit(i))return[i];var o=i.concat().sort(function(t,e){return t.idealPos-e.idealPos});if("function"==typeof t.algorithm)return t.algorithm(o,t);if(r.hasOwnProperty(t.algorithm))return r[t.algorithm](o);throw"Unknown algorithm: "+t.algorithm},e};s.DEFAULT_OPTIONS=o,t.exports=s},function(t,e,r){"use strict";var n={isDefined:function(t){return null!==t&&void 0!==t},last:function(t){return t.length>0?t[t.length-1]:null},pick:function(t,e){return e.reduce(function(e,r){return e[r]=t[r],e},{})},sum:function(t,e){return t.map(e).reduce(function(t,e){return t+e},0)}};n.extend=r(5),t.exports=n},function(t,e){"use strict";var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},n=Object.prototype.hasOwnProperty,i=Object.prototype.toString,o=function(t){return"function"==typeof Array.isArray?Array.isArray(t):"[object Array]"===i.call(t)},s=function(t){if(!t||"[object Object]"!==i.call(t))return!1;var e=n.call(t,"constructor"),r=t.constructor&&t.constructor.prototype&&n.call(t.constructor.prototype,"isPrototypeOf");if(t.constructor&&!e&&!r)return!1;var o;for(o in t);return void 0===o||n.call(t,o)};t.exports=function u(){var t,e,n,i,a,c,h=arguments[0],l=1,f=arguments.length,p=!1;for("boolean"==typeof h?(p=h,h=arguments[1]||{},l=2):("object"!==("undefined"==typeof h?"undefined":r(h))&&"function"!=typeof h||null==h)&&(h={});l<f;++l)if(t=arguments[l],null!=t)for(e in t)n=h[e],i=t[e],h!==i&&(p&&i&&(s(i)||(a=o(i)))?(a?(a=!1,c=n&&o(n)?n:[]):c=n&&s(n)?n:{},h[e]=u(p,c,i)):void 0!==i&&(h[e]=i));return h}},function(t,e,r){"use strict";function n(t,e){if(e||(e={}),this.startKey=e.startKey||0,this.endKey=e.endKey||1,this.intervalHash={},this.pointTree=new c({compare:function(t,e){if(null==t)return-1;if(null==e)return 1;var r=t[0]-e[0];return r>0?1:0==r?0:-1}}),this._autoIncrement=0,!t||"number"!=typeof t)throw new Error("you must specify center index as the 2nd argument.");this.root=new u(t,this)}function i(t,e){return e.end<t.idx?(t.left||(t.left=new u(e.start+e.end>>1,this)),i.call(this,t.left,e)):t.idx<e.start?(t.right||(t.right=new u(e.start+e.end>>1,this)),i.call(this,t.right,e)):t.insert(e)}function o(t,e,r){if(t)return e<t.idx?(t.starts.every(function(t){var n=t.start<=e;return n&&r.push(t.result()),n}),o.call(this,t.left,e,r)):e>t.idx?(t.ends.every(function(t){var n=t.end>=e;return n&&r.push(t.result()),n}),o.call(this,t.right,e,r)):void t.starts.map(function(t){r.push(t.result())})}function s(t,e,r){if(e-t<=0)throw new Error("end must be greater than start. start: "+t+", end: "+e);var n={},i=[];o.call(this,this.root,t+e>>1,i,!0),i.forEach(function(t){n[t.id]=!0});for(var s=this.pointTree.bsearch([t,null]),u=this.pointTree;s>=0&&u[s][0]==t;)s--;var a=this.pointTree.bsearch([e,null]);if(a>=0){for(var c=u.length-1;a<=c&&u[a][0]<=e;)a++;u.slice(s+1,a).forEach(function(t){var e=t[1];n[e]=!0},this),Object.keys(n).forEach(function(n){var i=this.intervalHash[n];r.push(i.result(t,e))},this)}}function u(t){this.idx=t,this.starts=new c({compare:function(t,e){if(null==t)return-1;if(null==e)return 1;var r=t.start-e.start;return r>0?1:0==r?0:-1}}),this.ends=new c({compare:function(t,e){if(null==t)return-1;if(null==e)return 1;var r=t.end-e.end;return r<0?1:0==r?0:-1}})}function a(t,e,r,n){if(this.id=e,this.start=t[r],this.end=t[n],this.data=t,"number"!=typeof this.start||"number"!=typeof this.end)throw new Error("start, end must be number. start: "+this.start+", end: "+this.end);if(this.start>=this.end)throw new Error("start must be smaller than end. start: "+this.start+", end: "+this.end)}var c=r(7);n.prototype.add=function(t,e){if(this.intervalHash[e])throw new Error("id "+e+" is already registered.");if(void 0==e){for(;this.intervalHash[this._autoIncrement];)this._autoIncrement++;e=this._autoIncrement}var r=new a(t,e,this.startKey,this.endKey);this.pointTree.insert([r.start,e]),this.pointTree.insert([r.end,e]),this.intervalHash[e]=r,this._autoIncrement++,i.call(this,this.root,r)},n.prototype.search=function(t,e){var r=[];if("number"!=typeof t)throw new Error(t+": invalid input");if(void 0==e)o.call(this,this.root,t,r);else{if("number"!=typeof e)throw new Error(t+","+e+": invalid input");s.call(this,t,e,r)}return r},n.prototype.remove=function(t){},u.prototype.insert=function(t){this.starts.insert(t),this.ends.insert(t)},a.prototype.result=function(t,e){var r={id:this.id,data:this.data};if("number"==typeof t&&"number"==typeof e){var n=Math.max(this.start,t),i=Math.min(this.end,e),o=i-n;r.rate1=o/(e-t),r.rate2=o/(this.end-this.start)}return r},t.exports=n},function(t,e){"use strict";var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},n=function i(){var t=null,e={},n=arguments;["0","1"].forEach(function(i){var o=n[i];Array.isArray(o)?t=o:o&&"object"==("undefined"==typeof o?"undefined":r(o))&&(e=o)}),"function"==typeof e.filter&&(this._filter=e.filter),"function"==typeof e.compare?this._compare=e.compare:"string"==typeof e.compare&&i.compares[e.compare]&&(this._compare=i.compares[e.compare]),this._unique=!!e.unique,e.resume&&t?t.forEach(function(t,e){this.push(t)},this):t&&this.insert.apply(this,t)};n.create=function(t,e){return new n(t,e)},n.prototype=new Array,n.prototype.constructor=Array.prototype.constructor,n.prototype.insertOne=function(t){var e=this.bsearch(t);return(!this._unique||null==this.key(t,e))&&(!!this._filter(t,e)&&(this.splice(e+1,0,t),e+1))},n.prototype.insert=function(){return Array.prototype.map.call(arguments,function(t){return this.insertOne(t)},this)},n.prototype.remove=function(t){return this.splice(t,1),this},n.prototype.bsearch=function(t){if(!this.length)return-1;for(var e,r=0,n=this.length;n-r>1;){e=Math.floor((r+n)/2);var i=this[e],o=this._compare(t,i);if(0==o)return e;o>0?r=e:n=e}return 0==r&&this._compare(this[0],t)>0?-1:r},n.prototype.key=function(t,e){null==e&&(e=this.bsearch(t));var r=e;if(r==-1||this._compare(this[r],t)<0)return r+1<this.length&&0==this._compare(this[r+1],t)?r+1:null;for(;r>=1&&0==this._compare(this[r-1],t);)r--;return r},n.prototype.keys=function(t,e){var r=[];null==e&&(e=this.bsearch(t));for(var n=e;n>=0&&0==this._compare(this[n],t);)r.push(n),n--;var i=this.length;for(n=e+1;n<i&&0==this._compare(this[n],t);)r.push(n),n++;return r.length?r:null},n.prototype.unique=function(t){if(t)return this.filter(function(t,e){return 0==e||0!=this._compare(this[e-1],t)},this);var e=0;return this.map(function(t,r){return 0==r||0!=this._compare(this[r-1],t)?null:r-e++},this).forEach(function(t){null!=t&&this.remove(t)},this),this},n.prototype.toArray=function(){return this.slice()},n.prototype._filter=function(t,e){return!0},n.compares={number:function(t,e){var r=t-e;return r>0?1:0==r?0:-1},string:function(t,e){return t>e?1:t==e?0:-1}},n.prototype._compare=n.compares.string,t.exports=n},function(t,e,r){"use strict";function n(t){var e=new s.Variable(t.targetPos);return e.node=t,e}function i(t,e){if(t.length>0){e=o.extend(u,e),t.forEach(function(t,e){t.targetPos=t.parent?t.parent.currentPos:t.idealPos,t.index=e});for(var r=t.concat().sort(function(t,e){var r=t.targetPos-e.targetPos;if(0!==r)return r;var n=t.isStub()-e.isStub();return 0!==n?n:t.index-e.index}).map(n),i=[],a=1;a<r.length;a++){var c=r[a-1],h=r[a],l=void 0;l=c.node.isStub()&&h.node.isStub()?(c.node.width+h.node.width)/2+e.lineSpacing:(c.node.width+h.node.width)/2+e.nodeSpacing,i.push(new s.Constraint(c,h,l))}if(o.isDefined(e.minPos)){var f=new s.Variable(e.minPos,1e10),p=r[0];i.push(new s.Constraint(f,p,p.node.width/2)),r.unshift(f)}if(o.isDefined(e.maxPos)){var d=new s.Variable(e.maxPos,1e10),v=o.last(r);i.push(new s.Constraint(v,d,v.node.width/2)),r.push(d)}new s.Solver(r,i).solve(),r.filter(function(t){return t.node}).map(function(t){return t.node.currentPos=Math.round(t.position()),t})}return t}var o=r(4),s=r(9),u={lineSpacing:2,nodeSpacing:3,minPos:0,maxPos:null};i.DEFAULT_OPTIONS=u,t.exports=i},function(t,e){"use strict";var r={},n=function(){function t(t){this.scale=t,this.AB=0,this.AD=0,this.A2=0}return t.prototype.addVariable=function(t){var e=this.scale/t.scale,r=t.offset/t.scale,n=t.weight;this.AB+=n*e*r,this.AD+=n*e*t.desiredPosition,this.A2+=n*e*e},t.prototype.getPosn=function(){return(this.AD-this.AB)/this.A2},t}();r.PositionStats=n;var i=function(){function t(t,e,r,n){void 0===n&&(n=!1),this.left=t,this.right=e,this.gap=r,this.equality=n,this.active=!1,this.unsatisfiable=!1,this.left=t,this.right=e,this.gap=r,this.equality=n}return t.prototype.slack=function(){return this.unsatisfiable?Number.MAX_VALUE:this.right.scale*this.right.position()-this.gap-this.left.scale*this.left.position()},t}();r.Constraint=i;var o=function(){function t(t,e,r){void 0===e&&(e=1),void 0===r&&(r=1),this.desiredPosition=t,this.weight=e,this.scale=r,this.offset=0}return t.prototype.dfdv=function(){return 2*this.weight*(this.position()-this.desiredPosition)},t.prototype.position=function(){return(this.block.ps.scale*this.block.posn+this.offset)/this.scale},t.prototype.visitNeighbours=function(t,e){var r=function(r,n){return r.active&&t!==n&&e(r,n)};this.cOut.forEach(function(t){return r(t,t.right)}),this.cIn.forEach(function(t){return r(t,t.left)})},t}();r.Variable=o;var s=function(){function t(t){this.vars=[],t.offset=0,this.ps=new n(t.scale),this.addVariable(t)}return t.prototype.addVariable=function(t){t.block=this,this.vars.push(t),this.ps.addVariable(t),this.posn=this.ps.getPosn()},t.prototype.updateWeightedPosition=function(){this.ps.AB=this.ps.AD=this.ps.A2=0;for(var t=0,e=this.vars.length;t<e;++t)this.ps.addVariable(this.vars[t]);this.posn=this.ps.getPosn()},t.prototype.compute_lm=function(t,e,r){var n=this,i=t.dfdv();return t.visitNeighbours(e,function(e,o){var s=n.compute_lm(o,t,r);o===e.right?(i+=s*e.left.scale,e.lm=s):(i+=s*e.right.scale,e.lm=-s),r(e)}),i/t.scale},t.prototype.populateSplitBlock=function(t,e){var r=this;t.visitNeighbours(e,function(e,n){n.offset=t.offset+(n===e.right?e.gap:-e.gap),r.addVariable(n),r.populateSplitBlock(n,t)})},t.prototype.traverse=function(t,e,r,n){var i=this;void 0===r&&(r=this.vars[0]),void 0===n&&(n=null),r.visitNeighbours(n,function(n,o){e.push(t(n)),i.traverse(t,e,o,r)})},t.prototype.findMinLM=function(){var t=null;return this.compute_lm(this.vars[0],null,function(e){!e.equality&&(null===t||e.lm<t.lm)&&(t=e)}),t},t.prototype.findMinLMBetween=function(t,e){this.compute_lm(t,null,function(){});var r=null;return this.findPath(t,null,e,function(t,e){!t.equality&&t.right===e&&(null===r||t.lm<r.lm)&&(r=t)}),r},t.prototype.findPath=function(t,e,r,n){var i=this,o=!1;return t.visitNeighbours(e,function(e,s){o||s!==r&&!i.findPath(s,t,r,n)||(o=!0,n(e,s))}),o},t.prototype.isActiveDirectedPathBetween=function(t,e){if(t===e)return!0;for(var r=t.cOut.length;r--;){var n=t.cOut[r];if(n.active&&this.isActiveDirectedPathBetween(n.right,e))return!0}return!1},t.split=function(e){return e.active=!1,[t.createSplitBlock(e.left),t.createSplitBlock(e.right)]},t.createSplitBlock=function(e){var r=new t(e);return r.populateSplitBlock(e,null),r},t.prototype.splitBetween=function(e,r){var n=this.findMinLMBetween(e,r);if(null!==n){var i=t.split(n);return{constraint:n,lb:i[0],rb:i[1]}}return null},t.prototype.mergeAcross=function(t,e,r){e.active=!0;for(var n=0,i=t.vars.length;n<i;++n){var o=t.vars[n];o.offset+=r,this.addVariable(o)}this.posn=this.ps.getPosn()},t.prototype.cost=function(){for(var t=0,e=this.vars.length;e--;){var r=this.vars[e],n=r.position()-r.desiredPosition;t+=n*n*r.weight}return t},t}();r.Block=s;var u=function(){function t(t){this.vs=t;var e=t.length;for(this.list=new Array(e);e--;){var r=new s(t[e]);this.list[e]=r,r.blockInd=e}}return t.prototype.cost=function(){for(var t=0,e=this.list.length;e--;)t+=this.list[e].cost();return t},t.prototype.insert=function(t){t.blockInd=this.list.length,this.list.push(t)},t.prototype.remove=function(t){var e=this.list.length-1,r=this.list[e];this.list.length=e,t!==r&&(this.list[t.blockInd]=r,r.blockInd=t.blockInd)},t.prototype.merge=function(t){var e=t.left.block,r=t.right.block,n=t.right.offset-t.left.offset-t.gap;e.vars.length<r.vars.length?(r.mergeAcross(e,t,n),this.remove(e)):(e.mergeAcross(r,t,-n),this.remove(r))},t.prototype.forEach=function(t){this.list.forEach(t)},t.prototype.updateBlockPositions=function(){this.list.forEach(function(t){return t.updateWeightedPosition()})},t.prototype.split=function(t){var e=this;this.updateBlockPositions(),this.list.forEach(function(r){var n=r.findMinLM();null!==n&&n.lm<a.LAGRANGIAN_TOLERANCE&&(r=n.left.block,s.split(n).forEach(function(t){return e.insert(t)}),e.remove(r),t.push(n))})},t}();r.Blocks=u;var a=function(){function t(t,e){this.vs=t,this.cs=e,this.vs=t,t.forEach(function(t){t.cIn=[],t.cOut=[]}),this.cs=e,e.forEach(function(t){t.left.cOut.push(t),t.right.cIn.push(t)}),this.inactive=e.map(function(t){return t.active=!1,t}),this.bs=null}return t.prototype.cost=function(){return this.bs.cost()},t.prototype.setStartingPositions=function(t){this.inactive=this.cs.map(function(t){return t.active=!1,t}),this.bs=new u(this.vs),this.bs.forEach(function(e,r){return e.posn=t[r]})},t.prototype.setDesiredPositions=function(t){this.vs.forEach(function(e,r){return e.desiredPosition=t[r]})},t.prototype.mostViolated=function(){for(var e=Number.MAX_VALUE,r=null,n=this.inactive,i=n.length,o=i,s=0;s<i;++s){var u=n[s];if(!u.unsatisfiable){var a=u.slack();if((u.equality||a<e)&&(e=a,r=u,o=s,u.equality))break}}return o!==i&&(e<t.ZERO_UPPERBOUND&&!r.active||r.equality)&&(n[o]=n[i-1],n.length=i-1),r},t.prototype.satisfy=function(){null==this.bs&&(this.bs=new u(this.vs)),this.bs.split(this.inactive);for(var e=null;(e=this.mostViolated())&&(e.equality||e.slack()<t.ZERO_UPPERBOUND&&!e.active);){var r=e.left.block,n=e.right.block;if(r!==n)this.bs.merge(e);else{if(r.isActiveDirectedPathBetween(e.right,e.left)){e.unsatisfiable=!0;continue}var i=r.splitBetween(e.left,e.right);if(null===i){e.unsatisfiable=!0;continue}this.bs.insert(i.lb),this.bs.insert(i.rb),this.bs.remove(r),this.inactive.push(i.constraint),e.slack()>=0?this.inactive.push(e):this.bs.merge(e)}}},t.prototype.solve=function(){this.satisfy();for(var t=Number.MAX_VALUE,e=this.bs.cost();Math.abs(t-e)>1e-4;)this.satisfy(),t=e,e=this.bs.cost();return e},t.LAGRANGIAN_TOLERANCE=-1e-4,t.ZERO_UPPERBOUND=-1e-10,t}();r.Solver=a,t.exports=r},function(t,e,r){"use strict";function n(t){this.options=c.extend({layerGap:60,nodeHeight:10,direction:"down"},t)}function i(t){return"L "+t.join(" ")}function o(t){return"M "+t.join(" ")}function s(t,e,r){return"C "+t.join(" ")+" "+e.join(" ")+" "+r.join(" ")}function u(t,e){var r=(t[1]+e[1])/2;return s([t[0],r],[e[0],r],e)}function a(t,e){var r=(t[0]+e[0])/2;return s([r,t[1]],[r,e[1]],e)}var c=r(4);n.lineTo=i,n.moveTo=o,n.curveTo=s,n.vCurveBetween=u,n.hCurveBetween=a,n.prototype.getWaypoints=function(t){var e=this.options,r=e.direction,n=t.getPathFromRoot(),i=e.nodeHeight+e.layerGap;return"left"===r?[[[0,n[0].idealPos]]].concat(n.map(function(t,r){var n=i*(r+1)*-1;return[[n+e.nodeHeight,t.currentPos],[n,t.currentPos]]})):"right"===r?[[[0,n[0].idealPos]]].concat(n.map(function(t,r){var n=i*(r+1);return[[n-e.nodeHeight,t.currentPos],[n,t.currentPos]]})):"up"===r?[[[n[0].idealPos,0]]].concat(n.map(function(t,r){var n=i*(r+1)*-1;return[[t.currentPos,n+e.nodeHeight],[t.currentPos,n]]})):[[[n[0].idealPos,0]]].concat(n.map(function(t,r){var n=i*(r+1);return[[t.currentPos,n-e.nodeHeight],[t.currentPos,n]]}))},n.prototype.layout=function(t){var e=this.options,r=e.layerGap+e.nodeHeight;switch(e.direction){case"left":t.forEach(function(t){var n=t.getLayerIndex()*r+e.layerGap;t.x=-n-e.nodeHeight,t.y=t.currentPos,t.dx=e.nodeHeight,t.dy=t.width});break;case"right":t.forEach(function(t){var n=t.getLayerIndex()*r+e.layerGap;t.x=n,t.y=t.currentPos,t.dx=e.nodeHeight,t.dy=t.width});break;case"up":t.forEach(function(t){var n=t.getLayerIndex()*r+e.layerGap;t.x=t.currentPos,t.y=-n-e.nodeHeight,t.dx=t.width,t.dy=e.nodeHeight});break;default:case"down":t.forEach(function(t){var n=t.getLayerIndex()*r+e.layerGap;t.x=t.currentPos,t.y=n,t.dx=t.width,t.dy=e.nodeHeight})}return t},n.prototype.generatePath=function(t){var e=this.options,r=e.direction,n=this.getWaypoints(t,r),s=[o(n[0][0])];return"left"===r||"right"===r?n.reduce(function(t,e,r){return s.push(a(t[t.length-1],e[0])),r<n.length-1&&s.push(i(e[1])),e}):n.reduce(function(t,e,r){return s.push(u(t[t.length-1],e[0])),r<n.length-1&&s.push(i(e[1])),e}),s.join(" ")},t.exports=n}])});

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Shape = __webpack_require__(30);

var _lineDrawing = __webpack_require__(126);

var _semioticMark = __webpack_require__(15);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// components

var DividedLine = function (_React$Component) {
  _inherits(DividedLine, _React$Component);

  function DividedLine(props) {
    _classCallCheck(this, DividedLine);

    var _this = _possibleConstructorReturn(this, (DividedLine.__proto__ || Object.getPrototypeOf(DividedLine)).call(this, props));

    _this.createLineSegments = _this.createLineSegments.bind(_this);
    return _this;
  }

  _createClass(DividedLine, [{
    key: "createLineSegments",
    value: function createLineSegments() {
      var _this2 = this;

      var params = this.props.parameters;
      var className = this.props.className;
      var interpolate = this.props.interpolate || _d3Shape.curveLinear;

      var data = (0, _lineDrawing.projectLineData)({
        data: this.props.data,
        lineDataAccessor: this.props.lineDataAccessor,
        xProp: "_x",
        yProp: "_y",
        xAccessor: this.props.customAccessors.x,
        yAccessor: this.props.customAccessors.y
      });

      //Compatibility before Semiotic 2
      data.forEach(function (projectedD) {
        projectedD.data = projectedD.data.map(function (d) {
          return _extends({}, d.data, d);
        });
      });

      var lines = (0, _lineDrawing.dividedLine)(params, data[0].data, this.props.searchIterations);

      var lineRender = (0, _d3Shape.line)().curve(interpolate).x(function (d) {
        return d._x;
      }).y(function (d) {
        return d._y;
      });

      return lines.map(function (d, i) {
        return _react2.default.createElement(_semioticMark.Mark, _extends({}, _this2.props, {
          className: className,
          markType: "path",
          key: "DividedLine-" + i,
          style: d.key,
          d: lineRender(d.points)
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var lines = this.createLineSegments();

      return _react2.default.createElement(
        "g",
        null,
        lines
      );
    }
  }]);

  return DividedLine;
}(_react2.default.Component);

DividedLine.propTypes = {
  parameters: _propTypes2.default.func,
  className: _propTypes2.default.string,
  interpolate: _propTypes2.default.func,
  data: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  lineDataAccessor: _propTypes2.default.func,
  customAccessors: _propTypes2.default.object,
  searchIterations: _propTypes2.default.number
};

exports.default = DividedLine;
module.exports = exports['default'];

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(82);




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function asin(x) {
  return x >= 1 ? __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */] : x <= -1 ? -__WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */] : Math.asin(x);
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */],
        a1 = endAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */],
        da = Math.abs(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */])) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > __WEBPACK_IMPORTED_MODULE_2__math__["d" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
      context.moveTo(r1 * Math.cos(a0), r1 * Math.sin(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        context.moveTo(r0 * Math.cos(a1), r0 * Math.sin(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) && (padRadius ? +padRadius.apply(this, arguments) : Math.sqrt(r0 * r0 + r1 * r1)),
          rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        var p0 = asin(rp / r0 * Math.sin(ap)),
            p1 = asin(rp / r1 * Math.sin(ap));
        if ((da0 -= p0 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * Math.cos(a01),
          y01 = r1 * Math.sin(a01),
          x10 = r0 * Math.cos(a10),
          y10 = r0 * Math.sin(a10);

      // Apply rounded corners?
      if (rc > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        var x11 = r1 * Math.cos(a11),
            y11 = r1 * Math.sin(a11),
            x00 = r0 * Math.cos(a00),
            y00 = r0 * Math.sin(a00);

        // Restrict the corner radius according to the sector angle.
        if (da < __WEBPACK_IMPORTED_MODULE_2__math__["c" /* pi */]) {
          var oc = da0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */] ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
              ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2),
              lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */])) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) || !(da0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */])) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - __WEBPACK_IMPORTED_MODULE_2__math__["c" /* pi */] / 2;
    return [Math.cos(a) * r, Math.sin(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
});


/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__descending__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(82);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_2__identity__["a" /* default */],
      sortValues = __WEBPACK_IMPORTED_MODULE_1__descending__["a" /* default */],
      sort = null,
      startAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0),
      endAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__math__["d" /* tau */]),
      padAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(__WEBPACK_IMPORTED_MODULE_3__math__["d" /* tau */], Math.max(-__WEBPACK_IMPORTED_MODULE_3__math__["d" /* tau */], endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : padAngle;
  };

  return pie;
});


/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  return d;
});


/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__radialLine__ = __webpack_require__(391);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  var a = Object(__WEBPACK_IMPORTED_MODULE_1__area__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* curveRadialLinear */]),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__radialLine__["b" /* radialLine */])(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__radialLine__["b" /* radialLine */])(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__radialLine__["b" /* radialLine */])(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__radialLine__["b" /* radialLine */])(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* default */])(_)) : c()._curve;
  };

  return a;
});


/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return symbols; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__symbol_circle__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_cross__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symbol_star__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__symbol_square__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__symbol_wye__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant__ = __webpack_require__(58);










var symbols = [
  __WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_2__symbol_cross__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_5__symbol_square__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_4__symbol_star__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_7__symbol_wye__["a" /* default */]
];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var type = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */]),
      size = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
});


/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(124);



function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__basis__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisClosed(context);
});


/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(124);


function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__basis__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisOpen(context);
});


/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(124);


function Bundle(context, beta) {
  this._basis = new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85));


/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__catmullRom__ = __webpack_require__(205);




function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_2__catmullRom__["b" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__["a" /* CardinalClosed */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__catmullRom__ = __webpack_require__(205);



function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_1__catmullRom__["b" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__["a" /* CardinalOpen */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(123);


function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new LinearClosed(context);
});


/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = monotoneX;
/* harmony export (immutable) */ __webpack_exports__["b"] = monotoneY;
function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
}

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}


/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Natural(context);
});


/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = stepBefore;
/* harmony export (immutable) */ __webpack_exports__["b"] = stepAfter;
function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Step(context, 0.5);
});

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}


/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__offset_none__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__order_none__ = __webpack_require__(84);





function stackValue(d, key) {
  return d[key];
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var keys = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([]),
      order = __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */],
      offset = __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */],
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */] : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */] : _, stack) : offset;
  };

  return stack;
});


/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(83);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(83);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(83);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(206);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(series).reverse();
});


/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(206);



/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(__WEBPACK_IMPORTED_MODULE_1__ascending__["b" /* sum */]),
      order = Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[b] - sums[a]; }),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
});


/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(84);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).reverse();
});


/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(403);


/* harmony default export */ __webpack_exports__["a"] = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["b" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});


/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(410);









/* harmony default export */ __webpack_exports__["a"] = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = Object(__WEBPACK_IMPORTED_MODULE_6__ticks__["c" /* tickStep */])(x0, x1, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[Object(__WEBPACK_IMPORTED_MODULE_1__bisect__["c" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});


/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(207);





/* harmony default export */ __webpack_exports__["a"] = (function(values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(404);


/* harmony default export */ __webpack_exports__["a"] = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * Object(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});


/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(85);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});


/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(207);




/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});


/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});


/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});


/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(59);


/* harmony default export */ __webpack_exports__["a"] = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});


/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});


/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});


/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(412);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});


/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = local;
var nextId = 0;

function local() {
  return new Local;
}

function Local() {
  this._ = "@" + (++nextId).toString(36);
}

Local.prototype = local.prototype = {
  constructor: Local,
  get: function(node) {
    var id = this._;
    while (!(id in node)) if (!(node = node.parentNode)) return;
    return node[id];
  },
  set: function(node, value) {
    return node[this._] = value;
  },
  remove: function(node) {
    return this._ in node && delete node[this._];
  },
  toString: function() {
    return this._;
  }
};


/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(213);



/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  var event = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])();
  if (event.changedTouches) event = event.changedTouches[0];
  return Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, event);
});


/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([[document.querySelector(selector)]], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([[selector]], __WEBPACK_IMPORTED_MODULE_0__selection_index__["c" /* root */]);
});


/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(214);



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, this._parents);
});


/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectorAll__ = __webpack_require__(415);



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_1__selectorAll__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, parents);
});


/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matcher__ = __webpack_require__(414);



/* harmony default export */ __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = Object(__WEBPACK_IMPORTED_MODULE_1__matcher__["a" /* default */])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, this._parents);
});


/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enter__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(1033);




var keyPrefix = "$"; // Protect against keys like “__proto__”.

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["a" /* EnterNode */](parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = {},
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
      if (keyValue in nodeByKeyValue) {
        exit[i] = node;
      } else {
        nodeByKeyValue[keyValue] = node;
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = keyPrefix + key.call(parent, data[i], i, data);
    if (node = nodeByKeyValue[keyValue]) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue[keyValue] = null;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["a" /* EnterNode */](parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
      exit[i] = node;
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (function(value, key) {
  if (!value) {
    data = new Array(this.size()), j = -1;
    this.each(function(d) { data[++j] = d; });
    return data;
  }

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = value.call(parent, parent && parent.__data__, j, parents),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
});


/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(20);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Selection */](this._exit || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});


/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = (function(selection) {

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](merges, this._parents);
});


/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
});


/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (!compare) compare = ascending;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](sortgroups, this._parents).order();
});

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
});


/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
});


/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
});


/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
});


/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return !this.node();
});


/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
});


/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(209);


function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)
      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
});


/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
});


/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
});


/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction
          : textConstant)(value))
      : this.node().textContent;
});


/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
});


/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(raise);
});


/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(lower);
});


/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(208);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var create = typeof name === "function" ? name : Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
});


/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(214);



function constantNull() {
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, before) {
  var create = typeof name === "function" ? name : Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name),
      select = before == null ? constantNull : typeof before === "function" ? before : Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
});


/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(remove);
});


/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
});


/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(215);


function dispatchEvent(node, type, params) {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
});


/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([document.querySelectorAll(selector)], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([selector == null ? [] : selector], __WEBPACK_IMPORTED_MODULE_0__selection_index__["c" /* root */]);
});


/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(213);



/* harmony default export */ __webpack_exports__["a"] = (function(node, touches, identifier) {
  if (arguments.length < 3) identifier = touches, touches = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().changedTouches;

  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
    if ((touch = touches[i]).identifier === identifier) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touch);
    }
  }

  return null;
});


/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(213);



/* harmony default export */ __webpack_exports__["a"] = (function(node, touches) {
  if (touches == null) touches = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().touches;

  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
    points[i] = Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touches[i]);
  }

  return points;
});


/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_selection_index__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_transition_index__ = __webpack_require__(37);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "transition", function() { return __WEBPACK_IMPORTED_MODULE_1__src_transition_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_active__ = __webpack_require__(1089);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "active", function() { return __WEBPACK_IMPORTED_MODULE_2__src_active__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_interrupt__ = __webpack_require__(419);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interrupt", function() { return __WEBPACK_IMPORTED_MODULE_3__src_interrupt__["a"]; });






/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interrupt__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transition__ = __webpack_require__(1062);




__WEBPACK_IMPORTED_MODULE_0_d3_selection__["selection"].prototype.interrupt = __WEBPACK_IMPORTED_MODULE_1__interrupt__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_d3_selection__["selection"].prototype.transition = __WEBPACK_IMPORTED_MODULE_2__transition__["a" /* default */];


/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interrupt__ = __webpack_require__(419);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  return this.each(function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__interrupt__["a" /* default */])(this, name);
  });
});


/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_index__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transition_schedule__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_ease__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_timer__ = __webpack_require__(45);





var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: __WEBPACK_IMPORTED_MODULE_2_d3_ease__["a" /* easeCubicInOut */]
};

function inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      return defaultTiming.time = Object(__WEBPACK_IMPORTED_MODULE_3_d3_timer__["a" /* now */])(), defaultTiming;
    }
  }
  return timing;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var id,
      timing;

  if (name instanceof __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */]) {
    id = name._id, name = name._name;
  } else {
    id = Object(__WEBPACK_IMPORTED_MODULE_0__transition_index__["c" /* newId */])(), (timing = defaultTiming).time = Object(__WEBPACK_IMPORTED_MODULE_3_d3_timer__["a" /* now */])(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        Object(__WEBPACK_IMPORTED_MODULE_1__transition_schedule__["e" /* default */])(node, name, id, i, group, timing || inherit(node, id));
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */](groups, this._parents, name, id);
});


/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tween__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interpolate__ = __webpack_require__(427);





function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function attrConstantNS(fullname, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function attrFunction(name, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttribute(name);
    value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

function attrFunctionNS(fullname, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["namespace"])(name), i = fullname === "transform" ? __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["h" /* interpolateTransformSvg */] : __WEBPACK_IMPORTED_MODULE_3__interpolate__["a" /* default */];
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, Object(__WEBPACK_IMPORTED_MODULE_2__tween__["b" /* tweenValue */])(this, "attr." + name, value))
      : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname)
      : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value));
});


/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return interpolateTransformCss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return interpolateTransformSvg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(1066);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(1067);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  value = value.matrix;
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* unused harmony default export */ var _unused_webpack_default_export = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(86);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hsl"])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hsl"])(end)).h),
        s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(86);



function lab(start, end) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["lab"])(start)).l, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["lab"])(end)).l),
      a = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(86);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hcl"])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hcl"])(end)).h),
        c = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(86);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(end)).h),
          s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* unused harmony default export */ var _unused_webpack_default_export = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(19);


function attrTweenNS(fullname, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttributeNS(fullname.space, fullname.local, i(t));
    };
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttribute(name, i(t));
    };
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["namespace"])(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
});


/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(21);


function delayFunction(id, value) {
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */])(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */])(this, id).delay = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).delay;
});


/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(21);


function durationFunction(id, value) {
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).duration = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).duration;
});


/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(21);


function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).ease = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).ease;
});


/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(37);



/* harmony default export */ __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["matcher"])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, this._parents, this._name, this._id);
});


/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = (function(transition) {
  if (transition._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Transition */](merges, this._parents, this._name, this._id);
});


/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(21);


function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = start(name) ? __WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */] : __WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */];
  return function() {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
});


/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.on("end.remove", removeFunction(this._id));
});


/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schedule__ = __webpack_require__(21);




/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["selector"])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["e" /* default */])(subgroup[i], name, id, i, subgroup, Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["f" /* get */])(node, id));
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, this._parents, name, id);
});


/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schedule__ = __webpack_require__(21);




/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["selectorAll"])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select.call(node, node.__data__, i, group), child, inherit = Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["f" /* get */])(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["e" /* default */])(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, parents, name, id);
});


/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(19);


var Selection = __WEBPACK_IMPORTED_MODULE_0_d3_selection__["selection"].prototype.constructor;

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new Selection(this._groups, this._parents);
});


/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tween__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interpolate__ = __webpack_require__(427);





function styleRemove(name, interpolate) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var style = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["window"])(this).getComputedStyle(this, null),
        value0 = style.getPropertyValue(name),
        value1 = (this.style.removeProperty(name), style.getPropertyValue(name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

function styleRemoveEnd(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["window"])(this).getComputedStyle(this, null).getPropertyValue(name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function styleFunction(name, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var style = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["window"])(this).getComputedStyle(this, null),
        value0 = style.getPropertyValue(name),
        value1 = value(this);
    if (value1 == null) value1 = (this.style.removeProperty(name), style.getPropertyValue(name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  var i = (name += "") === "transform" ? __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["g" /* interpolateTransformCss */] : __WEBPACK_IMPORTED_MODULE_3__interpolate__["a" /* default */];
  return value == null ? this
          .styleTween(name, styleRemove(name, i))
          .on("end.style." + name, styleRemoveEnd(name))
      : this.styleTween(name, typeof value === "function"
          ? styleFunction(name, i, Object(__WEBPACK_IMPORTED_MODULE_2__tween__["b" /* tweenValue */])(this, "style." + name, value))
          : styleConstant(name, i, value), priority);
});


/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function styleTween(name, value, priority) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.style.setProperty(name, i(t), priority);
    };
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
});


/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tween__ = __webpack_require__(128);


function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return this.tween("text", typeof value === "function"
      ? textFunction(Object(__WEBPACK_IMPORTED_MODULE_0__tween__["b" /* tweenValue */])(this, "text", value))
      : textConstant(value == null ? "" : value + ""));
});


/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schedule__ = __webpack_require__(21);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  var name = this._name,
      id0 = this._id,
      id1 = Object(__WEBPACK_IMPORTED_MODULE_0__index__["c" /* newId */])();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = Object(__WEBPACK_IMPORTED_MODULE_1__schedule__["f" /* get */])(node, id0);
        Object(__WEBPACK_IMPORTED_MODULE_1__schedule__["e" /* default */])(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Transition */](groups, this._parents, name, id1);
});


/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_index__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transition_schedule__ = __webpack_require__(21);



var root = [null];

/* harmony default export */ __webpack_exports__["a"] = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      i;

  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule = schedules[i]).state > __WEBPACK_IMPORTED_MODULE_1__transition_schedule__["c" /* SCHEDULED */] && schedule.name === name) {
        return new __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */]([[node]], root, name, +i);
      }
    }
  }

  return null;
});


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.areaLineGenerator = areaLineGenerator;
exports.areaLine = areaLine;
exports.verticalbar = verticalbar;
exports.horizontalbar = horizontalbar;
exports.pathStr = pathStr;
exports.circlePath = circlePath;
exports.rectPath = rectPath;
exports.linePath = linePath;
exports.jitterLine = jitterLine;
exports.cheapSketchy = cheapSketchy;
exports.cheapPopArtsy = cheapPopArtsy;
exports.randomColor = randomColor;
exports.painty = painty;
exports.sketchy = sketchy;
exports.generateSVG = generateSVG;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Shape = __webpack_require__(1091);

var _d3Color = __webpack_require__(8);

var _d3Selection = __webpack_require__(19);

var _d3Scale = __webpack_require__(1115);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//All generic line constructors expect a projected coordinates array with x & y coordinates, if there are no y1 & x1 coordinates then it defaults to 0-width
function roundToTenth(number) {
  return Math.round(number * 10) / 10;
}

function areaLineGenerator(customAccessors, interpolator) {
  var lineGenerator = (0, _d3Shape.area)().x0(customAccessors.x).y0(customAccessors.y).x1(customAccessors.x1).y1(customAccessors.y1).interpolate(interpolator || "linear");
  return lineGenerator;
}

function areaLine(props) {
  var lineGenerator = areaLineGenerator(props.customAccessors, props.interpolate);
  props.d = lineGenerator(props.coordinates);

  return props;
}

function verticalbar(props) {
  props.y = props.y - props.height;
  return props;
}

function horizontalbar(props) {
  //just flips height for width
  var originalHeight = props.height;
  var originalWidth = props.width;
  props.width = originalHeight;
  props.height = originalWidth;

  return props;
}

function pathStr(_ref) {
  var x = _ref.x,
      y = _ref.y,
      width = _ref.width,
      height = _ref.height,
      cx = _ref.cx,
      cy = _ref.cy,
      r = _ref.r;

  if (cx !== undefined) {
    return ["M", roundToTenth(cx - r), roundToTenth(cy), "a", r, r, 0, 1, 0, r * 2, 0, "a", r, r, 0, 1, 0, -(r * 2), 0].join(" ") + "Z";
  }
  return ["M", roundToTenth(x), roundToTenth(y), "h", width, "v", height, "h", -width, "v", -height].join(" ") + "Z";
}

function circlePath(cx, cy, r) {
  return pathStr({ cx: cx, cy: cy, r: r });
}

function rectPath(x, y, width, height) {
  return pathStr({ x: x, y: y, width: width, height: height });
}

function linePath(x1, x2, y1, y2) {
  return "M" + x1 + "," + y1 + "L" + x2 + "," + y2 + "L";
}

function jitterLine(pathNode) {
  var length = pathNode.getTotalLength();
  var j = 2;
  var x = j + Math.random() * j * 5;
  var jitteredPoints = [];
  var lineGen = (0, _d3Shape.line)().x(function (d) {
    return d.x;
  }).y(function (d) {
    return d.y;
  }).curve(_d3Shape.curveBasis);

  var newPoint = pathNode.getPointAtLength(0);
  jitteredPoints.push(newPoint);

  while (x < length) {
    newPoint = pathNode.getPointAtLength(x);
    var newX = newPoint.x + (Math.random() * j - j / 2);
    var newY = newPoint.y + (Math.random() * j - j / 2);
    jitteredPoints.push({ x: newX, y: newY });
    x += j + Math.random() * j * 5;
  }
  newPoint = pathNode.getPointAtLength(length);
  jitteredPoints.push(newPoint);

  return lineGen(jitteredPoints);
}

function cheapSketchy(path) {
  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (opacity === 0) {
    //no fill
    return "";
  }
  var opacitySketchyScale = (0, _d3Scale.scaleLinear)().domain([0, 1]).range([10, 1]).clamp(true);
  var length = path.getTotalLength();
  var drawCode = "";
  var x = 0;
  var step = opacitySketchyScale(opacity);

  while (x < length / 2) {
    var start = path.getPointAtLength(x);
    var end = path.getPointAtLength(length - x);

    drawCode += " M" + (start.x + (Math.random() * step - step / 2)) + " " + (start.y + (Math.random() * step - step / 2)) + "L" + (end.x + (Math.random() * step - step / 2)) + " " + (end.y + (Math.random() * step - step / 2));

    x += step + Math.random() * step;
  }

  return drawCode;
}

function cheapPopArtsy(path, size) {
  var length = path.getTotalLength();
  var circles = [];
  var x = 0;
  var step = size * 3;

  while (x < length / 2) {
    var start = path.getPointAtLength(x);
    var end = path.getPointAtLength(length - x);
    var distance = Math.sqrt(Math.pow(end.x - start.x, 2) + Math.pow(end.y - start.y, 2));
    var begin = size / 2;
    while (begin < distance - size / 2) {
      var percent = begin / distance;
      var circleXa = percent * start.x;
      var circleXb = (1 - percent) * end.x;
      var circleYa = percent * start.y;
      var circleYb = (1 - percent) * end.y;
      circles.push([circleXa + circleXb, circleYa + circleYb]);
      begin = begin + (step + Math.random());
    }
    x = x + step;
  }

  return circles;
}

function randomColor(baseColor, range) {
  var hslBase = (0, _d3Color.hsl)(baseColor);
  hslBase.h = hslBase.h + (Math.floor(Math.random() * (range * 255)) - Math.floor(range / 2));
  hslBase.s = hslBase.s + (Math.floor(Math.random() * range) - Math.floor(range / 2));
  hslBase.l = hslBase.l + (Math.floor(Math.random() * range) - Math.floor(range / 2));
  return hslBase.toString();
}

function painty(markType, cloneProps) {
  delete cloneProps.markType;
  if ((markType === "path" || markType === "circle" || markType === "line" || markType === "rect") && cloneProps.style && (cloneProps.style.stroke || cloneProps.style.fill)) {
    if (markType === "circle") {
      cloneProps.d = circlePath(cloneProps.cx || 0, cloneProps.cy || 0, cloneProps.r);
    }

    if (markType === "rect") {
      cloneProps.d = rectPath(cloneProps.x || 0, cloneProps.y || 0, cloneProps.width, cloneProps.height);
    }

    if (markType === "line") {
      cloneProps.d = linePath(cloneProps.x1, cloneProps.x2, cloneProps.y1, cloneProps.y2);
    }

    (0, _d3Selection.select)("body").append("svg").attr("id", "sketchyTempSVG");

    var fills = [];
    var outlines = [];

    cloneProps.d.split("M").filter(function (d, i) {
      return i !== 0;
    }).forEach(function (pathD, i) {
      var pathDummy = (0, _d3Selection.select)("#sketchyTempSVG").append("path").attr("class", cloneProps.className).attr("d", "M" + pathD);

      var pathNode = pathDummy.node();

      if (cloneProps.style && cloneProps.style.fill !== "none") {
        var sketchyFill = cheapPopArtsy(pathNode, 4);
        var fillProps = _extends({}, cloneProps);
        var fillStyle = _extends({}, cloneProps.style);
        var fillValue = fillStyle.fill;
        fillProps.style = fillStyle;
        delete fillProps.d;
        delete fillProps.style.fillOpacity;
        delete fillProps.style.stroke;
        delete fillProps.style.strokeWidth;

        fills.push(sketchyFill.map(function (circle, ci) {
          fillProps.key = "painty-fill-" + i + "-" + ci;
          fillProps.cx = circle[0];
          fillProps.cy = circle[1];
          fillProps.style = _extends({}, fillProps.style);
          fillProps.style.fill = fillProps.style.fill.substr(0, 3) === "url" ? fillProps.style.fill : randomColor(fillValue, 0.05);
          fillProps.r = Math.random() * 2 + 3;
          return _react2.default.createElement("circle", fillProps);
        }));
      }

      if (cloneProps.style && cloneProps.style.stroke !== "none" && cloneProps.style.strokeWidth !== 0) {
        var sketchyOutline = jitterLine(pathNode);

        var outlineProps = _extends({}, cloneProps);
        var outlineStyle = _extends({}, cloneProps.style);
        outlineProps.style = outlineStyle;
        outlineProps.d = sketchyOutline;
        outlineProps.key = "painty-outline-" + i;
        outlineProps.style.fill = "none";

        outlines.push(_react2.default.createElement("path", outlineProps));
      }
    });

    (0, _d3Selection.select)("#sketchyTempSVG").remove();

    return [_react2.default.createElement("path", {
      key: "painty-interaction-overlay",
      d: cloneProps.d,
      style: { opacity: 0 }
    }), _react2.default.createElement(
      "g",
      { key: "painty-fill", style: { filter: "url(#paintyFilterHeavy)" } },
      fills
    ), outlines];
  }

  return _react2.default.createElement(markType, cloneProps);
}

function sketchy(markType, cloneProps) {
  delete cloneProps.markType;
  if (markType === "text" && _typeof(cloneProps.children) !== "object") {
    var stringyChild = cloneProps.children.toString();
    var x = 0;
    var sketchyText = [];
    var sketchyBase = [];
    while (x <= stringyChild.length + 1) {
      var random = parseInt(Math.random() * 2) + 1;
      var randomSub = stringyChild.substring(x, random + x);

      var randomTspan = _react2.default.createElement(
        "tspan",
        {
          style: {
            fontSize: 10 + parseInt(Math.random() * 6) + "px",
            strokeWidth: 0,
            fontWeight: Math.random() < 0.5 ? "900" : "100"
          }
        },
        randomSub
      );
      sketchyBase.push(randomSub);
      sketchyText.push(randomTspan);
      x += random;
    }

    cloneProps.children = sketchyText;
    return _react2.default.createElement("text", cloneProps);
  }

  if ((markType === "path" || markType === "circle" || markType === "line" || markType === "rect") && cloneProps.style && (cloneProps.style.stroke || cloneProps.style.fill)) {
    if (markType === "circle") {
      cloneProps.d = circlePath(cloneProps.cx || 0, cloneProps.cy || 0, cloneProps.r);
    }

    if (markType === "rect") {
      cloneProps.d = rectPath(cloneProps.x || 0, cloneProps.y || 0, cloneProps.width, cloneProps.height);
    }

    if (markType === "line") {
      cloneProps.d = linePath(cloneProps.x1, cloneProps.x2, cloneProps.y1, cloneProps.y2);
    }
    var fills = [];
    var outlines = [];
    var sketchKey = Math.random().toString();

    if (cloneProps.d) {
      (0, _d3Selection.select)("body").append("svg").attr("id", "sketchyTempSVG");

      var mType = cloneProps.d.substring(0, 1) === "M" ? "M" : "m";

      cloneProps.d.split(mType).filter(function (d, i) {
        return i !== 0;
      }).forEach(function (pathD, i) {
        var pathDummy = (0, _d3Selection.select)("#sketchyTempSVG").append("path").attr("class", cloneProps.className).attr("d", "" + mType + pathD);

        var pathNode = pathDummy.node();
        if (cloneProps.style && cloneProps.style.fill !== "none") {
          var fillProps = _extends({}, cloneProps);
          var fillStyle = _extends({}, cloneProps.style);
          var sketchyFill = cheapSketchy(pathNode, fillStyle.fillOpacity);
          if (markType !== "rect" && markType !== "circle") {
            fillStyle.clipPath = "url(#clip-path-" + sketchKey + ")";
          }
          fillProps.style = fillStyle;
          fillProps.d = sketchyFill;
          fillStyle.stroke = fillStyle.fill;
          fillStyle.strokeWidth = "1px";
          //            fillStyle.strokeOpacity = fillStyle.fillOpacity ? fillStyle.fillOpacity : 1;
          fillStyle.fill = "none";
          fillProps.key = "sketchFill-" + i;
          fills.push(_react2.default.createElement("path", fillProps));
        }
        if (cloneProps.style && cloneProps.style.stroke !== "none" && cloneProps.style.strokeWidth !== 0) {
          var sketchyOutline = jitterLine(pathNode);

          var outlineProps = _extends({}, cloneProps);
          var outlineStyle = _extends({}, cloneProps.style);
          outlineProps.style = outlineStyle;
          outlineProps.d = sketchyOutline;
          outlineProps.key = "sketchOutline-" + i;
          outlineProps.style.fill = "none";
          outlines.push(_react2.default.createElement("path", outlineProps));
        }
      });
    }

    (0, _d3Selection.select)("#sketchyTempSVG").remove();
    var generatedClipPath = void 0;
    if (markType !== "rect" && markType !== "circle") {
      generatedClipPath = _react2.default.createElement(
        "clipPath",
        { key: "sketchy-clip-overlay", id: "clip-path-" + sketchKey },
        _react2.default.createElement("path", { d: cloneProps.d, style: { opacity: 0 } })
      );
    }

    return [generatedClipPath, _react2.default.createElement("path", {
      key: "sketchy-interaction-overlay",
      d: cloneProps.d,
      style: { opacity: 0 }
    }), fills, outlines];
  }

  return _react2.default.createElement(markType, cloneProps);
}

function generateSVG(props, className) {
  var markType = props.markType;
  var renderMode = props.renderMode;

  var cloneProps = _extends({}, props);
  delete cloneProps.markType;
  delete cloneProps.renderMode;
  delete cloneProps.resetAfter;
  delete cloneProps.droppable;
  delete cloneProps.nid;
  delete cloneProps.dropFunction;
  delete cloneProps.context;
  delete cloneProps.updateContext;
  delete cloneProps.parameters;
  delete cloneProps.lineDataAccessor;
  delete cloneProps.customAccessors;
  delete cloneProps.interpolate;
  delete cloneProps.forceUpdate;
  delete cloneProps.searchIterations;
  delete cloneProps.simpleInterpolate;
  delete cloneProps.transitionDuration;

  if (markType === "verticalbar") {
    markType = "rect";
    cloneProps = verticalbar(cloneProps);
  } else if (markType === "horizontalbar") {
    markType = "rect";
    cloneProps = horizontalbar(cloneProps);
  } else if (markType === "simpleline") {
    markType = "path";
    cloneProps = areaLine(cloneProps);
  }

  //        let transform = cloneProps['transform'];
  if (props.draggable) {
    delete cloneProps.transform;
  }

  cloneProps.className = className;

  var actualSVG = null;

  if (renderMode === "sketchy") {
    actualSVG = sketchy(markType, cloneProps);
  } else if (renderMode === "painty") {
    actualSVG = painty(markType, cloneProps);
  } else if (renderMode === "forcePath" && markType === "circle") {
    cloneProps.d = circlePath(cloneProps.cx || 0, cloneProps.cy || 0, cloneProps.r);
    markType = "path";
    actualSVG = _react2.default.createElement(markType, cloneProps);
  } else if (renderMode === "forcePath" && markType === "rect") {
    cloneProps.d = rectPath(cloneProps.x || 0, cloneProps.y || 0, cloneProps.width, cloneProps.height);
    markType = "path";
    actualSVG = _react2.default.createElement(markType, cloneProps);
  } else {
    if (props.markType === "text" && _typeof(cloneProps.children) !== "object") {
      cloneProps.children = _react2.default.createElement(
        "tspan",
        null,
        cloneProps.children
      );
    }
    actualSVG = _react2.default.createElement(markType, cloneProps);
  }
  return actualSVG;
}

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_arc__ = __webpack_require__(1092);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "arc", function() { return __WEBPACK_IMPORTED_MODULE_0__src_arc__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_area__ = __webpack_require__(428);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "area", function() { return __WEBPACK_IMPORTED_MODULE_1__src_area__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_line__ = __webpack_require__(218);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "line", function() { return __WEBPACK_IMPORTED_MODULE_2__src_line__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_pie__ = __webpack_require__(1093);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pie", function() { return __WEBPACK_IMPORTED_MODULE_3__src_pie__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_radialArea__ = __webpack_require__(1096);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "radialArea", function() { return __WEBPACK_IMPORTED_MODULE_4__src_radialArea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_radialLine__ = __webpack_require__(431);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "radialLine", function() { return __WEBPACK_IMPORTED_MODULE_5__src_radialLine__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_symbol__ = __webpack_require__(1097);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbol", function() { return __WEBPACK_IMPORTED_MODULE_6__src_symbol__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbols", function() { return __WEBPACK_IMPORTED_MODULE_6__src_symbol__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_symbol_circle__ = __webpack_require__(432);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolCircle", function() { return __WEBPACK_IMPORTED_MODULE_7__src_symbol_circle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_symbol_cross__ = __webpack_require__(433);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolCross", function() { return __WEBPACK_IMPORTED_MODULE_8__src_symbol_cross__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_symbol_diamond__ = __webpack_require__(434);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolDiamond", function() { return __WEBPACK_IMPORTED_MODULE_9__src_symbol_diamond__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_symbol_square__ = __webpack_require__(436);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolSquare", function() { return __WEBPACK_IMPORTED_MODULE_10__src_symbol_square__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_symbol_star__ = __webpack_require__(435);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolStar", function() { return __WEBPACK_IMPORTED_MODULE_11__src_symbol_star__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_symbol_triangle__ = __webpack_require__(437);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolTriangle", function() { return __WEBPACK_IMPORTED_MODULE_12__src_symbol_triangle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_symbol_wye__ = __webpack_require__(438);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolWye", function() { return __WEBPACK_IMPORTED_MODULE_13__src_symbol_wye__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_curve_basisClosed__ = __webpack_require__(1098);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_14__src_curve_basisClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_curve_basisOpen__ = __webpack_require__(1099);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasisOpen", function() { return __WEBPACK_IMPORTED_MODULE_15__src_curve_basisOpen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_curve_basis__ = __webpack_require__(131);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasis", function() { return __WEBPACK_IMPORTED_MODULE_16__src_curve_basis__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_curve_bundle__ = __webpack_require__(1100);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBundle", function() { return __WEBPACK_IMPORTED_MODULE_17__src_curve_bundle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_curve_cardinalClosed__ = __webpack_require__(439);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinalClosed", function() { return __WEBPACK_IMPORTED_MODULE_18__src_curve_cardinalClosed__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_curve_cardinalOpen__ = __webpack_require__(440);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinalOpen", function() { return __WEBPACK_IMPORTED_MODULE_19__src_curve_cardinalOpen__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_curve_cardinal__ = __webpack_require__(132);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinal", function() { return __WEBPACK_IMPORTED_MODULE_20__src_curve_cardinal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_curve_catmullRomClosed__ = __webpack_require__(1101);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRomClosed", function() { return __WEBPACK_IMPORTED_MODULE_21__src_curve_catmullRomClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_curve_catmullRomOpen__ = __webpack_require__(1102);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRomOpen", function() { return __WEBPACK_IMPORTED_MODULE_22__src_curve_catmullRomOpen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_curve_catmullRom__ = __webpack_require__(219);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRom", function() { return __WEBPACK_IMPORTED_MODULE_23__src_curve_catmullRom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_curve_linearClosed__ = __webpack_require__(1103);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveLinearClosed", function() { return __WEBPACK_IMPORTED_MODULE_24__src_curve_linearClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_curve_linear__ = __webpack_require__(129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveLinear", function() { return __WEBPACK_IMPORTED_MODULE_25__src_curve_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_curve_monotone__ = __webpack_require__(1104);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveMonotoneX", function() { return __WEBPACK_IMPORTED_MODULE_26__src_curve_monotone__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveMonotoneY", function() { return __WEBPACK_IMPORTED_MODULE_26__src_curve_monotone__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_curve_natural__ = __webpack_require__(1105);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveNatural", function() { return __WEBPACK_IMPORTED_MODULE_27__src_curve_natural__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_curve_step__ = __webpack_require__(1106);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStep", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_step__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStepAfter", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_step__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStepBefore", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_step__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__src_stack__ = __webpack_require__(1107);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stack", function() { return __WEBPACK_IMPORTED_MODULE_29__src_stack__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__src_offset_expand__ = __webpack_require__(1109);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetExpand", function() { return __WEBPACK_IMPORTED_MODULE_30__src_offset_expand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__src_offset_none__ = __webpack_require__(88);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetNone", function() { return __WEBPACK_IMPORTED_MODULE_31__src_offset_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__src_offset_silhouette__ = __webpack_require__(1110);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetSilhouette", function() { return __WEBPACK_IMPORTED_MODULE_32__src_offset_silhouette__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__src_offset_wiggle__ = __webpack_require__(1111);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetWiggle", function() { return __WEBPACK_IMPORTED_MODULE_33__src_offset_wiggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__src_order_ascending__ = __webpack_require__(220);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderAscending", function() { return __WEBPACK_IMPORTED_MODULE_34__src_order_ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__src_order_descending__ = __webpack_require__(1112);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderDescending", function() { return __WEBPACK_IMPORTED_MODULE_35__src_order_descending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__src_order_insideOut__ = __webpack_require__(1113);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderInsideOut", function() { return __WEBPACK_IMPORTED_MODULE_36__src_order_insideOut__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__src_order_none__ = __webpack_require__(89);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderNone", function() { return __WEBPACK_IMPORTED_MODULE_37__src_order_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__src_order_reverse__ = __webpack_require__(1114);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderReverse", function() { return __WEBPACK_IMPORTED_MODULE_38__src_order_reverse__["a"]; });












































/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(87);




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function asin(x) {
  return x >= 1 ? __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */] : x <= -1 ? -__WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */] : Math.asin(x);
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */],
        a1 = endAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* halfPi */],
        da = Math.abs(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */])) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > __WEBPACK_IMPORTED_MODULE_2__math__["d" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
      context.moveTo(r1 * Math.cos(a0), r1 * Math.sin(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        context.moveTo(r0 * Math.cos(a1), r0 * Math.sin(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) && (padRadius ? +padRadius.apply(this, arguments) : Math.sqrt(r0 * r0 + r1 * r1)),
          rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        var p0 = asin(rp / r0 * Math.sin(ap)),
            p1 = asin(rp / r1 * Math.sin(ap));
        if ((da0 -= p0 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * Math.cos(a01),
          y01 = r1 * Math.sin(a01),
          x10 = r0 * Math.cos(a10),
          y10 = r0 * Math.sin(a10);

      // Apply rounded corners?
      if (rc > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        var x11 = r1 * Math.cos(a11),
            y11 = r1 * Math.sin(a11),
            x00 = r0 * Math.cos(a00),
            y00 = r0 * Math.sin(a00);

        // Restrict the corner radius according to the sector angle.
        if (da < __WEBPACK_IMPORTED_MODULE_2__math__["c" /* pi */]) {
          var oc = da0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */] ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
              ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2),
              lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */])) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) || !(da0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */])) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - __WEBPACK_IMPORTED_MODULE_2__math__["c" /* pi */] / 2;
    return [Math.cos(a) * r, Math.sin(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
});


/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__descending__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(87);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_2__identity__["a" /* default */],
      sortValues = __WEBPACK_IMPORTED_MODULE_1__descending__["a" /* default */],
      sort = null,
      startAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0),
      endAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__math__["d" /* tau */]),
      padAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(__WEBPACK_IMPORTED_MODULE_3__math__["d" /* tau */], Math.max(-__WEBPACK_IMPORTED_MODULE_3__math__["d" /* tau */], endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : padAngle;
  };

  return pie;
});


/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  return d;
});


/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__radialLine__ = __webpack_require__(431);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  var a = Object(__WEBPACK_IMPORTED_MODULE_1__area__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* curveRadialLinear */]),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__radialLine__["b" /* radialLine */])(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__radialLine__["b" /* radialLine */])(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__radialLine__["b" /* radialLine */])(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__radialLine__["b" /* radialLine */])(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* default */])(_)) : c()._curve;
  };

  return a;
});


/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return symbols; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__symbol_circle__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_cross__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symbol_star__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__symbol_square__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__symbol_wye__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant__ = __webpack_require__(60);










var symbols = [
  __WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_2__symbol_cross__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_5__symbol_square__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_4__symbol_star__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_7__symbol_wye__["a" /* default */]
];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var type = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */]),
      size = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
});


/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(131);



function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__basis__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisClosed(context);
});


/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(131);


function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__basis__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisOpen(context);
});


/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(131);


function Bundle(context, beta) {
  this._basis = new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85));


/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__catmullRom__ = __webpack_require__(219);




function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_2__catmullRom__["b" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__["a" /* CardinalClosed */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__catmullRom__ = __webpack_require__(219);



function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_1__catmullRom__["b" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__["a" /* CardinalOpen */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(130);


function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new LinearClosed(context);
});


/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = monotoneX;
/* harmony export (immutable) */ __webpack_exports__["b"] = monotoneY;
function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
}

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}


/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Natural(context);
});


/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = stepBefore;
/* harmony export (immutable) */ __webpack_exports__["b"] = stepAfter;
function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Step(context, 0.5);
});

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}


/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__offset_none__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__order_none__ = __webpack_require__(89);





function stackValue(d, key) {
  return d[key];
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var keys = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([]),
      order = __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */],
      offset = __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */],
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */] : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */] : _, stack) : offset;
  };

  return stack;
});


/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(88);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(88);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(88);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(220);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(series).reverse();
});


/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(220);



/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(__WEBPACK_IMPORTED_MODULE_1__ascending__["b" /* sum */]),
      order = Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[b] - sums[a]; }),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
});


/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).reverse();
});


/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_band__ = __webpack_require__(1116);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleBand", function() { return __WEBPACK_IMPORTED_MODULE_0__src_band__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scalePoint", function() { return __WEBPACK_IMPORTED_MODULE_0__src_band__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_identity__ = __webpack_require__(1117);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleIdentity", function() { return __WEBPACK_IMPORTED_MODULE_1__src_identity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_linear__ = __webpack_require__(90);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleLinear", function() { return __WEBPACK_IMPORTED_MODULE_2__src_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_log__ = __webpack_require__(1119);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleLog", function() { return __WEBPACK_IMPORTED_MODULE_3__src_log__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_ordinal__ = __webpack_require__(441);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleOrdinal", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleImplicit", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_pow__ = __webpack_require__(1120);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scalePow", function() { return __WEBPACK_IMPORTED_MODULE_5__src_pow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSqrt", function() { return __WEBPACK_IMPORTED_MODULE_5__src_pow__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_quantile__ = __webpack_require__(1121);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleQuantile", function() { return __WEBPACK_IMPORTED_MODULE_6__src_quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_quantize__ = __webpack_require__(1122);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleQuantize", function() { return __WEBPACK_IMPORTED_MODULE_7__src_quantize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold__ = __webpack_require__(1123);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleThreshold", function() { return __WEBPACK_IMPORTED_MODULE_8__src_threshold__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_time__ = __webpack_require__(444);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleTime", function() { return __WEBPACK_IMPORTED_MODULE_9__src_time__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcTime__ = __webpack_require__(1124);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleUtc", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcTime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_category10__ = __webpack_require__(1125);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory10", function() { return __WEBPACK_IMPORTED_MODULE_11__src_category10__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_category20b__ = __webpack_require__(1126);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory20b", function() { return __WEBPACK_IMPORTED_MODULE_12__src_category20b__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_category20c__ = __webpack_require__(1127);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory20c", function() { return __WEBPACK_IMPORTED_MODULE_13__src_category20c__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_category20__ = __webpack_require__(1128);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory20", function() { return __WEBPACK_IMPORTED_MODULE_14__src_category20__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(1129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelixDefault", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_rainbow__ = __webpack_require__(1130);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRainbow", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateWarm", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCool", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_viridis__ = __webpack_require__(1131);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateViridis", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateMagma", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateInferno", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolatePlasma", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_sequential__ = __webpack_require__(1132);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequential", function() { return __WEBPACK_IMPORTED_MODULE_18__src_sequential__["a"]; });







































/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = band;
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ordinal__ = __webpack_require__(441);



function band() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_1__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}


/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(442);




function identity() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity().domain(domain);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(26);



/* harmony default export */ __webpack_exports__["a"] = (function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start, stop, count == null ? 10 : count),
      precision;
  specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["c" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* precisionPrefix */])(step, value))) specifier.precision = precision;
      return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["b" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
});


/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nice__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(133);






function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(b);
}

function reinterpolate(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["b" /* default */])(deinterpolate, reinterpolate).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["ticks"])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(Object(__WEBPACK_IMPORTED_MODULE_3__nice__["a" /* default */])(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* copy */])(scale, log().base(base));
  };

  return scale;
}


/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pow;
/* harmony export (immutable) */ __webpack_exports__["b"] = sqrt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(133);




function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent)))
        ? function(x) { return (raise(x, exponent) - a) / b; }
        : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function(t) { return raise(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, pow().exponent(exponent));
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}


/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(49);



function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["quantile"])(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["ascending"]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(90);




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = threshold;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(49);



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(24);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__time__["a" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["v" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["q" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["u" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["l" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["m" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["o" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["r" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["n" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["b" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
});


/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(91);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));


/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(91);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"));


/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(91);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"));


/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(91);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"));


/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(38);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(300, 0.5, 0.0), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(-240, 0.5, 1.0)));


/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return warm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cool; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(38);



var warm = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(-100, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(80, 1.50, 0.8));

var cool = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(260, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(80, 1.50, 0.8));

var rainbow = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])();

/* harmony default export */ __webpack_exports__["b"] = (function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
});


/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return magma; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return inferno; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return plasma; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(91);


function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));


/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sequential;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(90);


function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var styleTransitionWhitelist = exports.styleTransitionWhitelist = ["strokeOpacity", "fillOpacity", "strokeWidth", "fill", "stroke", "opacity", "strokeDasharray"];

var attributeTransitionWhitelist = exports.attributeTransitionWhitelist = ["d", "height", "width", "transform", "x", "y", "cx", "cy", "x1", "x2", "y1", "y2", "rx", "ry", "r"].concat(styleTransitionWhitelist);

//TODO find React Everything to everything translater
var reactCSSNameStyleHash = exports.reactCSSNameStyleHash = {
  strokeWidth: "stroke-width",
  fillOpacity: "fill-opacity",
  strokeOpacity: "stroke-opacity",
  strokeDasharray: "stroke-dasharray"
};

var differentD = exports.differentD = function differentD(d, newD) {
  if (!d || !newD) {
    return true;
  }
  var lowerD = d.toLowerCase();
  var lowerNewD = newD.toLowerCase();

  if ((lowerD.match(/m/g) || []).length !== (lowerNewD.match(/m/g) || []).length) {
    return true;
  }

  if ((lowerD.match(/l/g) || []).length !== (lowerNewD.match(/l/g) || []).length) {
    return true;
  }

  if ((lowerD.match(/c/g) || []).length !== (lowerNewD.match(/c/g) || []).length) {
    return true;
  }

  if ((lowerD.match(/a/g) || []).length !== (lowerNewD.match(/a/g) || []).length) {
    return true;
  }

  return false;
};

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Mark = __webpack_require__(413);

var _Mark2 = _interopRequireDefault(_Mark);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DraggableMark = function (_React$Component) {
  _inherits(DraggableMark, _React$Component);

  function DraggableMark() {
    _classCallCheck(this, DraggableMark);

    return _possibleConstructorReturn(this, (DraggableMark.__proto__ || Object.getPrototypeOf(DraggableMark)).apply(this, arguments));
  }

  _createClass(DraggableMark, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(_Mark2.default, _extends({
        draggable: true,
        resetAfter: true,
        droppable: true
      }, this.props));
    }
  }]);

  return DraggableMark;
}(_react2.default.Component);

DraggableMark.propTypes = {
  draggable: _propTypes2.default.bool,
  resetAfter: _propTypes2.default.bool,
  droppable: _propTypes2.default.bool
};

exports.default = DraggableMark;
module.exports = exports['default'];

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// components

var MarkContext = function (_React$Component) {
  _inherits(MarkContext, _React$Component);

  function MarkContext(props) {
    _classCallCheck(this, MarkContext);

    var _this = _possibleConstructorReturn(this, (MarkContext.__proto__ || Object.getPrototypeOf(MarkContext)).call(this, props));

    _this.mapElements = _this.mapElements.bind(_this);
    _this.shouldComponentUpdate = _this.shouldComponentUpdate.bind(_this);
    _this.updateContext = _this.updateContext.bind(_this);
    _this.state = { context: {} };
    return _this;
  }

  _createClass(MarkContext, [{
    key: "mapElements",
    value: function mapElements(element, ei) {
      if (!element) return null;

      var props = {
        key: "mc-mark-" + ei
      };

      if (typeof element.type !== "string") {
        props.context = this.state.context;
        props.updateContext = this.updateContext;
      }
      if (Array.isArray(element)) return element.map(this.mapElements);

      return _react2.default.cloneElement(element, props);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.xyFrameChildren && this.props.renderNumber === nextProps.renderNumber) {
        return false;
      }
      return true;
    }
  }, {
    key: "updateContext",
    value: function updateContext(prop, value) {
      var currentContext = this.state.context;
      currentContext[prop] = value;
      this.setState({ context: currentContext });
    }
  }, {
    key: "render",
    value: function render() {
      var elements = null;

      if (Array.isArray(this.props.children)) elements = this.props.children.map(this.mapElements);else if (_typeof(this.props.children) === "object") elements = this.mapElements(this.props.children);

      var transform = [0, 0];

      transform[0] = this.props.position ? this.props.position[0] : 0;
      transform[1] = this.props.position ? this.props.position[1] : 0;

      return _react2.default.createElement(
        "g",
        { transform: "translate(" + transform.toString() + ")" },
        elements
      );
    }
  }]);

  return MarkContext;
}(_react2.default.Component);

MarkContext.propTypes = {
  position: _propTypes2.default.array,
  xyFrameChildren: _propTypes2.default.bool,
  renderNumber: _propTypes2.default.number
};
exports.default = MarkContext;
module.exports = exports['default'];

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = band;
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ordinal__ = __webpack_require__(445);



function band() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_1__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}


/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(222);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) return rollup != null
        ? rollup(array) : (sortValues != null
        ? array.sort(sortValues)
        : array);

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])();
}

function setMap(map, key, value) {
  map.set(key, value);
}


/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(222);


function Set() {}

var proto = __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[__WEBPACK_IMPORTED_MODULE_0__map__["b" /* prefix */] + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

/* harmony default export */ __webpack_exports__["a"] = (set);


/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
});


/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
});


/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
});


/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(453);




function identity() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity().domain(domain);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return interpolateTransformCss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return interpolateTransformSvg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(1145);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(1146);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  value = value.matrix;
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* harmony default export */ __webpack_exports__["a"] = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hslLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(94);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hsl"])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hsl"])(end)).h),
        s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(94);



function lab(start, end) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["lab"])(start)).l, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["lab"])(end)).l),
      a = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hclLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(94);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hcl"])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hcl"])(end)).h),
        c = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(94);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(end)).h),
          s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* harmony default export */ __webpack_exports__["b"] = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(26);



/* harmony default export */ __webpack_exports__["a"] = (function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start, stop, count == null ? 10 : count),
      precision;
  specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["c" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* precisionPrefix */])(step, value))) specifier.precision = precision;
      return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["b" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
});


/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nice__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(136);






function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(b);
}

function reinterpolate(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["b" /* default */])(deinterpolate, reinterpolate).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["ticks"])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(Object(__WEBPACK_IMPORTED_MODULE_3__nice__["a" /* default */])(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* copy */])(scale, log().base(base));
  };

  return scale;
}


/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pow;
/* harmony export (immutable) */ __webpack_exports__["b"] = sqrt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(136);




function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent)))
        ? function(x) { return (raise(x, exponent) - a) / b; }
        : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function(t) { return raise(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, pow().exponent(exponent));
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}


/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(50);



function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["quantile"])(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["ascending"]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(93);




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = threshold;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(50);



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(24);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__time__["a" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["v" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["q" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["u" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["l" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["m" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["o" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["r" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["n" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["b" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
});


/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));


/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"));


/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"));


/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"));


/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(62);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateCubehelixLong"])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(300, 0.5, 0.0), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(-240, 0.5, 1.0)));


/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return warm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cool; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(62);



var warm = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateCubehelixLong"])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(-100, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(80, 1.50, 0.8));

var cool = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateCubehelixLong"])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(260, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(80, 1.50, 0.8));

var rainbow = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])();

/* harmony default export */ __webpack_exports__["b"] = (function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
});


/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return magma; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return inferno; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return plasma; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(95);


function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));


/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sequential;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(93);


function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Module dependencies.
 */
var os = __webpack_require__(1170);
var lodashGet = __webpack_require__(1171);
var lodashFlatten = __webpack_require__(1172);
var lodashUniq = __webpack_require__(1173);
var lodashSet = __webpack_require__(1174);
var lodashCloneDeep = __webpack_require__(1175);
var flatten = __webpack_require__(1177);

/**
 * @name Json2CsvParams
 * @typedef {Object}
 * @property {Array} data - array of JSON objects
 * @property {Array} [fields] - see documentation for details
 * @property {String[]} [fieldNames] - names for fields at the same indexes. Must be same length as fields array
 *                                   (Optional. Maintained for backwards compatibility. Use fields config object for more features)
 * @property {String} [del=","] - delimiter of columns
 * @property {String} [defaultValue="<empty>"] - default value to use when missing data
 * @property {String} [quotes='"'] - quotes around cell values and column names
 * @property {String} [doubleQuotes='"""'] - the value to replace double quotes in strings
 * @property {Boolean} [hasCSVColumnTitle=true] - determines whether or not CSV file will contain a title column
 * @property {String} [eol=''] - it gets added to each row of data
 * @property {String} [newLine] - overrides the default OS line ending (\n on Unix \r\n on Windows)
 * @property {Boolean} [flatten=false] - flattens nested JSON using flat (https://www.npmjs.com/package/flat)
 * @property {String} [unwindPath] - similar to MongoDB's $unwind, Deconstructs an array field from the input JSON to output a row for each element
 * @property {Boolean} [excelStrings] - converts string data into normalized Excel style data
 * @property {Boolean} [includeEmptyRows=false] - includes empty rows
 */

/**
 * Main function that converts json to csv.
 *
 * @param {Json2CsvParams} params Function parameters containing data, fields,
 * delimiter (default is ','), hasCSVColumnTitle (default is true)
 * and default value (default is '')
 * @param {Function} [callback] Callback function
 *   if error, returning error in call back.
 *   if csv is created successfully, returning csv output to callback.
 */
module.exports = function (params, callback) {
  var hasCallback = typeof callback === 'function';
  var err;

  try {
    checkParams(params);
  } catch (err) {
    if (hasCallback) {
      return process.nextTick(function () {
        callback(err);
      });
    } else {
      throw err;
    }
  }

  var titles = createColumnTitles(params);
  var csv = createColumnContent(params, titles);

  if (hasCallback) {
    return process.nextTick(function () {
      callback(null, csv);
    });
  } else {
    return csv;
  }
};


/**
 * Check passing params.
 *
 * Note that this modifies params.
 *
 * @param {Json2CsvParams} params Function parameters containing data, fields,
 * delimiter, default value, mark quotes and hasCSVColumnTitle
 */
function checkParams(params) {
  params.data = params.data || [];

  // if data is an Object, not in array [{}], then just create 1 item array.
  // So from now all data in array of object format.
  if (!Array.isArray(params.data)) {
    params.data = [params.data];
  }

  if (params.flatten) {
    params.data = params.data.map(flatten);
  }

  // Set params.fields default to first data element's keys
  if (!params.fields && (params.data.length === 0 || typeof params.data[0] !== 'object')) {
    throw new Error('params should include "fields" and/or non-empty "data" array of objects');
  }

  if (!params.fields) {
    var dataFields = params.data.map(function (item) {
      return Object.keys(item);
    });

    dataFields = lodashFlatten(dataFields);
    params.fields = lodashUniq(dataFields);
  }


  //#check fieldNames
  if (params.fieldNames && params.fieldNames.length !== params.fields.length) {
    throw new Error('fieldNames and fields should be of the same length, if fieldNames is provided.');
  }

  // Get fieldNames from fields
  params.fieldNames = params.fields.map(function (field, i) {
    if (params.fieldNames && typeof field === 'string') {
      return params.fieldNames[i];
    }
    return (typeof field === 'string') ? field : (field.label || field.value);
  });

  //#check delimiter
  params.del = params.del || ',';

  //#check end of line character
  params.eol = params.eol || '';

  //#check quotation mark
  params.quotes = typeof params.quotes === 'string' ? params.quotes : '"';

  //#check double quotes
  params.doubleQuotes = typeof params.doubleQuotes === 'string' ? params.doubleQuotes : Array(3).join(params.quotes);

  //#check default value
  params.defaultValue = params.defaultValue;

  //#check hasCSVColumnTitle, if it is not explicitly set to false then true.
  params.hasCSVColumnTitle = params.hasCSVColumnTitle !== false;

  //#check include empty rows, defaults to false
  params.includeEmptyRows = params.includeEmptyRows || false;
}

/**
 * Create the title row with all the provided fields as column headings
 *
 * @param {Json2CsvParams} params Function parameters containing data, fields and delimiter
 * @returns {String} titles as a string
 */
function createColumnTitles(params) {
  var str = '';

  //if CSV has column title, then create it
  if (params.hasCSVColumnTitle) {
    params.fieldNames.forEach(function (element) {
      if (str !== '') {
        str += params.del;
      }
      str += JSON.stringify(element).replace(/\"/g, params.quotes);
    });
  }

  return str;
}

/**
 * Replace the quotation marks of the field element if needed (can be a not string-like item)
 *
 * @param {string} stringifiedElement The field element after JSON.stringify()
 * @param {string} quotes The params.quotes value. At this point we know that is not equal to double (")
 */
function replaceQuotationMarks(stringifiedElement, quotes) {
  var lastCharIndex = stringifiedElement.length - 1;

  //check if it's an string-like element
  if (stringifiedElement[0] === '"' && stringifiedElement[lastCharIndex] === '"') {
    //split the stringified field element because Strings are immutable
    var splitElement = stringifiedElement.split('');

    //replace the quotation marks
    splitElement[0] = quotes;
    splitElement[lastCharIndex] = quotes;

    //join again
    stringifiedElement = splitElement.join('');
  }

  return stringifiedElement;
}

/**
 * Create the content column by column and row by row below the title
 *
 * @param {Object} params Function parameters containing data, fields and delimiter
 * @param {String} str Title row as a string
 * @returns {String} csv string
 */
function createColumnContent(params, str) {
  var dataRows = createDataRows(params);
  dataRows.forEach(function (dataElement) {
    //if null do nothing, if empty object without includeEmptyRows do nothing
    if (dataElement && (Object.getOwnPropertyNames(dataElement).length > 0 || params.includeEmptyRows)) {
      var line = '';
      var eol = params.newLine || os.EOL || '\n';

      params.fields.forEach(function (fieldElement) {
        var val;
        var defaultValue = params.defaultValue;
        if (typeof fieldElement === 'object' && 'default' in fieldElement) {
          defaultValue = fieldElement.default;
        }

        if (fieldElement && (typeof fieldElement === 'string' || typeof fieldElement.value === 'string')) {
          var path = (typeof fieldElement === 'string') ? fieldElement : fieldElement.value;
          val = lodashGet(dataElement, path, defaultValue);
        } else if (fieldElement && typeof fieldElement.value === 'function') {
          var field = {
            label: fieldElement.label,
            default: fieldElement.default
          };
          val = fieldElement.value(dataElement, field, params.data);
        }

        if (val === null || val === undefined){
          val = defaultValue;
        }

        if (val !== undefined) {
          var stringifiedElement = JSON.stringify(val);

          if (typeof val === 'object') stringifiedElement = JSON.stringify(stringifiedElement);

          if (params.quotes !== '"') {
            stringifiedElement = replaceQuotationMarks(stringifiedElement, params.quotes);
          }

          //JSON.stringify('\\') results in a string with two backslash
          //characters in it. I.e. '\\\\'.
          stringifiedElement = stringifiedElement.replace(/\\\\/g, '\\');

          if (params.excelStrings && typeof val === 'string') {
            stringifiedElement = '"="' + stringifiedElement + '""';
          }

          line += stringifiedElement;
        }

        line += params.del;
      });

      //remove last delimeter
      line = line.substring(0, line.length - 1);
      //Replace single quotes with double quotes. Single quotes are preceeded by
      //a backslash. Be careful not to remove backslash content from the string.
      line = line.split('\\\\').map(function (portion) {
        return portion.replace(/\\"/g, params.doubleQuotes);
      }).join('\\\\');
      //Remove the final excess backslashes from the stringified value.
      line = line.replace(/\\\\/g, '\\');
      //If header exists, add it, otherwise, print only content
      if (str !== '') {
        str += eol + line + params.eol;
      } else {
        str = line + params.eol;
      }
    }
  });

  return str;
}

/**
 * Performs the unwind logic if necessary to convert single JSON document into multiple rows
 * @param params
 */
function createDataRows(params) {
  var dataRows = params.data;
  
  if (params.unwindPath) {
    dataRows = [];
    params.data.forEach(function(dataEl) {
      var unwindArray = lodashGet(dataEl, params.unwindPath);
      var isArr = Array.isArray(unwindArray);
      
      if (isArr && unwindArray.length) {
        unwindArray.forEach(function(unwindEl) {
          var dataCopy = lodashCloneDeep(dataEl);
          lodashSet(dataCopy, params.unwindPath, unwindEl);
          dataRows.push(dataCopy);
        });
      } else if (isArr && !unwindArray.length) {
        var dataCopy = lodashCloneDeep(dataEl);
        lodashSet(dataCopy, params.unwindPath, undefined);
        dataRows.push(dataCopy);
      } else {
        dataRows.push(dataEl);
      }
    });
  }
  
  return dataRows;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1169)))

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 1170 */
/***/ (function(module, exports) {

exports.endianness = function () { return 'LE' };

exports.hostname = function () {
    if (typeof location !== 'undefined') {
        return location.hostname
    }
    else return '';
};

exports.loadavg = function () { return [] };

exports.uptime = function () { return 0 };

exports.freemem = function () {
    return Number.MAX_VALUE;
};

exports.totalmem = function () {
    return Number.MAX_VALUE;
};

exports.cpus = function () { return [] };

exports.type = function () { return 'Browser' };

exports.release = function () {
    if (typeof navigator !== 'undefined') {
        return navigator.appVersion;
    }
    return '';
};

exports.networkInterfaces
= exports.getNetworkInterfaces
= function () { return {} };

exports.arch = function () { return 'javascript' };

exports.platform = function () { return 'browser' };

exports.tmpdir = exports.tmpDir = function () {
    return '/tmp';
};

exports.EOL = '\n';

exports.homedir = function () {
	return '/'
};


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array ? array.length : 0;
  return length ? baseFlatten(array, 1) : [];
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = flatten;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    Set = getNative(root, 'Set'),
    nativeCreate = getNative(Object, 'create');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each
 * element is kept.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length)
    ? baseUniq(array)
    : [];
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = uniq;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = isKey(path, object) ? [path] : castPath(path);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39), __webpack_require__(1176)(module)))

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

var isBuffer = __webpack_require__(1178)

var flat = module.exports = flatten
flatten.flatten = flatten
flatten.unflatten = unflatten

function flatten(target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var maxDepth = opts.maxDepth
  var output = {}

  function step(object, prev, currentDepth) {
    currentDepth = currentDepth ? currentDepth : 1
    Object.keys(object).forEach(function(key) {
      var value = object[key]
      var isarray = opts.safe && Array.isArray(value)
      var type = Object.prototype.toString.call(value)
      var isbuffer = isBuffer(value)
      var isobject = (
        type === "[object Object]" ||
        type === "[object Array]"
      )

      var newKey = prev
        ? prev + delimiter + key
        : key

      if (!isarray && !isbuffer && isobject && Object.keys(value).length &&
        (!opts.maxDepth || currentDepth < maxDepth)) {
        return step(value, newKey, currentDepth + 1)
      }

      output[newKey] = value
    })
  }

  step(target)

  return output
}

function unflatten(target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var overwrite = opts.overwrite || false
  var result = {}

  var isbuffer = isBuffer(target)
  if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
    return target
  }

  // safely ensure that the key is
  // an integer.
  function getkey(key) {
    var parsedKey = Number(key)

    return (
      isNaN(parsedKey) ||
      key.indexOf('.') !== -1
    ) ? key
      : parsedKey
  }

  Object.keys(target).forEach(function(key) {
    var split = key.split(delimiter)
    var key1 = getkey(split.shift())
    var key2 = getkey(split[0])
    var recipient = result

    while (key2 !== undefined) {
      var type = Object.prototype.toString.call(recipient[key1])
      var isobject = (
        type === "[object Object]" ||
        type === "[object Array]"
      )

      // do not write over falsey, non-undefined values if overwrite is false
      if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') {
        return
      }

      if ((overwrite && !isobject) || (!overwrite && recipient[key1] == null)) {
        recipient[key1] = (
          typeof key2 === 'number' &&
          !opts.object ? [] : {}
        )
      }

      recipient = recipient[key1]
      if (split.length > 0) {
        key1 = getkey(split.shift())
        key2 = getkey(split[0])
      }
    }

    // unflatten again for 'messy objects'
    recipient[key1] = unflatten(target[key], opts)
  })

  return result
}


/***/ }),
/* 1178 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = local;
var nextId = 0;

function local() {
  return new Local;
}

function Local() {
  this._ = "@" + (++nextId).toString(36);
}

Local.prototype = local.prototype = {
  constructor: Local,
  get: function(node) {
    var id = this._;
    while (!(id in node)) if (!(node = node.parentNode)) return;
    return node[id];
  },
  set: function(node, value) {
    return node[this._] = value;
  },
  remove: function(node) {
    return this._ in node && delete node[this._];
  },
  toString: function() {
    return this._;
  }
};


/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(235);



/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  var event = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])();
  if (event.changedTouches) event = event.changedTouches[0];
  return Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, event);
});


/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([[document.querySelector(selector)]], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([[selector]], __WEBPACK_IMPORTED_MODULE_0__selection_index__["c" /* root */]);
});


/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(236);



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, this._parents);
});


/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectorAll__ = __webpack_require__(458);



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_1__selectorAll__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, parents);
});


/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matcher__ = __webpack_require__(457);



/* harmony default export */ __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = Object(__WEBPACK_IMPORTED_MODULE_1__matcher__["a" /* default */])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, this._parents);
});


/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enter__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(1186);




var keyPrefix = "$"; // Protect against keys like “__proto__”.

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["a" /* EnterNode */](parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = {},
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
      if (keyValue in nodeByKeyValue) {
        exit[i] = node;
      } else {
        nodeByKeyValue[keyValue] = node;
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = keyPrefix + key.call(parent, data[i], i, data);
    if (node = nodeByKeyValue[keyValue]) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue[keyValue] = null;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["a" /* EnterNode */](parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
      exit[i] = node;
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (function(value, key) {
  if (!value) {
    data = new Array(this.size()), j = -1;
    this.each(function(d) { data[++j] = d; });
    return data;
  }

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = value.call(parent, parent && parent.__data__, j, parents),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
});


/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(22);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Selection */](this._exit || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});


/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = (function(selection) {

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](merges, this._parents);
});


/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
});


/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (!compare) compare = ascending;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](sortgroups, this._parents).order();
});

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
});


/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
});


/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
});


/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
});


/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return !this.node();
});


/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
});


/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(231);


function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)
      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
});


/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
});


/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
});


/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction
          : textConstant)(value))
      : this.node().textContent;
});


/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
});


/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(raise);
});


/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(lower);
});


/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(230);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var create = typeof name === "function" ? name : Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
});


/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(236);



function constantNull() {
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, before) {
  var create = typeof name === "function" ? name : Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name),
      select = before == null ? constantNull : typeof before === "function" ? before : Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
});


/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(remove);
});


/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
});


/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(237);


function dispatchEvent(node, type, params) {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
});


/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([document.querySelectorAll(selector)], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([selector == null ? [] : selector], __WEBPACK_IMPORTED_MODULE_0__selection_index__["c" /* root */]);
});


/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(235);



/* harmony default export */ __webpack_exports__["a"] = (function(node, touches, identifier) {
  if (arguments.length < 3) identifier = touches, touches = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().changedTouches;

  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
    if ((touch = touches[i]).identifier === identifier) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touch);
    }
  }

  return null;
});


/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(235);



/* harmony default export */ __webpack_exports__["a"] = (function(node, touches) {
  if (touches == null) touches = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().touches;

  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
    points[i] = Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touches[i]);
  }

  return points;
});


/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_voronoi__ = __webpack_require__(1213);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "voronoi", function() { return __WEBPACK_IMPORTED_MODULE_0__src_voronoi__["a"]; });



/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Diagram__ = __webpack_require__(96);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_1__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_1__point__["b" /* y */],
      extent = null;

  function voronoi(data) {
    return new __WEBPACK_IMPORTED_MODULE_2__Diagram__["d" /* default */](data.map(function(d, i) {
      var s = [Math.round(x(d, i, data) / __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */]) * __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */], Math.round(y(d, i, data) / __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */]) * __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */]];
      s.index = i;
      s.data = d;
      return s;
    }), extent);
  }

  voronoi.polygons = function(data) {
    return voronoi(data).polygons();
  };

  voronoi.links = function(data) {
    return voronoi(data).links();
  };

  voronoi.triangles = function(data) {
    return voronoi(data).triangles();
  };

  voronoi.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), voronoi) : x;
  };

  voronoi.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), voronoi) : y;
  };

  voronoi.extent = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
  };

  voronoi.size = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
  };

  return voronoi;
});


/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(d) {
  return d[0];
}

function y(d) {
  return d[1];
}


/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = removeBeach;
/* harmony export (immutable) */ __webpack_exports__["a"] = addBeach;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RedBlackTree__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cell__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Circle__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Edge__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Diagram__ = __webpack_require__(96);






var beachPool = [];

function Beach() {
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(this);
  this.edge =
  this.site =
  this.circle = null;
}

function createBeach(site) {
  var beach = beachPool.pop() || new Beach;
  beach.site = site;
  return beach;
}

function detachBeach(beach) {
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(beach);
  __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */].remove(beach);
  beachPool.push(beach);
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(beach);
}

function removeBeach(beach) {
  var circle = beach.circle,
      x = circle.x,
      y = circle.cy,
      vertex = [x, y],
      previous = beach.P,
      next = beach.N,
      disappearing = [beach];

  detachBeach(beach);

  var lArc = previous;
  while (lArc.circle
      && Math.abs(x - lArc.circle.x) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]
      && Math.abs(y - lArc.circle.cy) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
    previous = lArc.P;
    disappearing.unshift(lArc);
    detachBeach(lArc);
    lArc = previous;
  }

  disappearing.unshift(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);

  var rArc = next;
  while (rArc.circle
      && Math.abs(x - rArc.circle.x) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]
      && Math.abs(y - rArc.circle.cy) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
    next = rArc.N;
    disappearing.push(rArc);
    detachBeach(rArc);
    rArc = next;
  }

  disappearing.push(rArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(rArc);

  var nArcs = disappearing.length,
      iArc;
  for (iArc = 1; iArc < nArcs; ++iArc) {
    rArc = disappearing[iArc];
    lArc = disappearing[iArc - 1];
    Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* setEdgeEnd */])(rArc.edge, lArc.site, rArc.site, vertex);
  }

  lArc = disappearing[0];
  rArc = disappearing[nArcs - 1];
  rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lArc.site, rArc.site, null, vertex);

  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(rArc);
}

function addBeach(site) {
  var x = site[0],
      directrix = site[1],
      lArc,
      rArc,
      dxl,
      dxr,
      node = __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */]._;

  while (node) {
    dxl = leftBreakPoint(node, directrix) - x;
    if (dxl > __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) node = node.L; else {
      dxr = x - rightBreakPoint(node, directrix);
      if (dxr > __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
        if (!node.R) {
          lArc = node;
          break;
        }
        node = node.R;
      } else {
        if (dxl > -__WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
          lArc = node.P;
          rArc = node;
        } else if (dxr > -__WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
          lArc = node;
          rArc = node.N;
        } else {
          lArc = rArc = node;
        }
        break;
      }
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["c" /* createCell */])(site);
  var newArc = createBeach(site);
  __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */].insert(lArc, newArc);

  if (!lArc && !rArc) return;

  if (lArc === rArc) {
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);
    rArc = createBeach(lArc.site);
    __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */].insert(newArc, rArc);
    newArc.edge = rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lArc.site, newArc.site);
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(lArc);
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(rArc);
    return;
  }

  if (!rArc) { // && lArc
    newArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lArc.site, newArc.site);
    return;
  }

  // else lArc !== rArc
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(rArc);

  var lSite = lArc.site,
      ax = lSite[0],
      ay = lSite[1],
      bx = site[0] - ax,
      by = site[1] - ay,
      rSite = rArc.site,
      cx = rSite[0] - ax,
      cy = rSite[1] - ay,
      d = 2 * (bx * cy - by * cx),
      hb = bx * bx + by * by,
      hc = cx * cx + cy * cy,
      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];

  Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* setEdgeEnd */])(rArc.edge, lSite, rSite, vertex);
  newArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lSite, site, null, vertex);
  rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(site, rSite, null, vertex);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(rArc);
}

function leftBreakPoint(arc, directrix) {
  var site = arc.site,
      rfocx = site[0],
      rfocy = site[1],
      pby2 = rfocy - directrix;

  if (!pby2) return rfocx;

  var lArc = arc.P;
  if (!lArc) return -Infinity;

  site = lArc.site;
  var lfocx = site[0],
      lfocy = site[1],
      plby2 = lfocy - directrix;

  if (!plby2) return lfocx;

  var hl = lfocx - rfocx,
      aby2 = 1 / pby2 - 1 / plby2,
      b = hl / plby2;

  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;

  return (rfocx + lfocx) / 2;
}

function rightBreakPoint(arc, directrix) {
  var rArc = arc.N;
  if (rArc) return leftBreakPoint(rArc, directrix);
  var site = arc.site;
  return site[1] === directrix ? site[0] : Infinity;
}


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.svgEncloseAnnotation = exports.svgRectEncloseRule = exports.htmlTooltipAnnotation = exports.svgAreaAnnotation = exports.svgLineAnnotation = exports.svgBoundsAnnotation = exports.svgYAnnotation = exports.svgXAnnotation = exports.basicReactAnnotation = exports.svgXYAnnotation = exports.svgVerticalPointsAnnotation = exports.svgHorizontalPointsAnnotation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semioticMark = __webpack_require__(15);

var _Annotation = __webpack_require__(57);

var _Annotation2 = _interopRequireDefault(_Annotation);

var _reactAnnotation = __webpack_require__(48);

var _d3Shape = __webpack_require__(30);

var _d3Hierarchy = __webpack_require__(139);

var _d3Array = __webpack_require__(12);

var _baseRules = __webpack_require__(243);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var pointsAlong = function pointsAlong(along) {
  return function (_ref) {
    var d = _ref.d,
        lines = _ref.lines,
        points = _ref.points,
        xScale = _ref.xScale,
        yScale = _ref.yScale,
        pointStyle = _ref.pointStyle;

    var alongScale = along === "x" ? xScale : yScale;
    along = along === "yTop" && d.yMiddle ? "yMiddle" : along;
    if (d && d[along]) {
      var _d$threshold = d.threshold,
          threshold = _d$threshold === undefined ? 1 : _d$threshold,
          _d$r = d.r,
          r = _d$r === undefined ? function () {
        return 4;
      } : _d$r,
          _d$styleFn = d.styleFn,
          styleFn = _d$styleFn === undefined ? pointStyle : _d$styleFn;

      var foundPoints = [];

      var halfThreshold = threshold / 2;

      if (lines && lines.length > 0) {
        lines.forEach(function (linedata) {
          var linePoints = linedata.data.filter(function (p) {
            var pAlong = alongScale(p[along]);
            var dAlong = alongScale(d[along]);

            return pAlong <= dAlong + halfThreshold && pAlong >= dAlong - halfThreshold;
          });
          foundPoints.push.apply(foundPoints, _toConsumableArray(linePoints));
        });
      }

      if (points && points.length > 0) {
        var pointPoints = points.filter(function (p) {
          var pAlong = alongScale(p[along]);
          var dAlong = alongScale(d[along]);

          return pAlong <= dAlong + halfThreshold && pAlong >= dAlong - halfThreshold;
        });
        foundPoints.push.apply(foundPoints, _toConsumableArray(pointPoints));
      }

      return foundPoints.map(function (p, i) {
        return _react2.default.createElement("circle", {
          key: "found-circle-" + i,
          r: r(p, i),
          style: styleFn(p, i),
          cx: xScale(p.x),
          cy: yScale(p.yMiddle || p.yTop)
        });
      });
    }
    return null;
  };
};

var svgHorizontalPointsAnnotation = exports.svgHorizontalPointsAnnotation = pointsAlong("yTop");
var svgVerticalPointsAnnotation = exports.svgVerticalPointsAnnotation = pointsAlong("x");

var svgXYAnnotation = exports.svgXYAnnotation = function svgXYAnnotation(_ref2) {
  var screenCoordinates = _ref2.screenCoordinates,
      i = _ref2.i,
      d = _ref2.d;

  var laLine = _react2.default.createElement(_semioticMark.Mark, {
    className: "annotation " + d.type + " " + (d.className || "") + " ",
    key: "annotationpoint" + i,
    markType: "circle",
    cx: screenCoordinates[0],
    cy: screenCoordinates[1],
    forceUpdate: true,
    r: 5
  });
  var laLabel = void 0;
  if (d.type === "xy") {
    laLabel = _react2.default.createElement(
      _semioticMark.Mark,
      {
        markType: "text",
        key: d.label + "annotationtext" + i,
        forceUpdate: true,
        x: screenCoordinates[0],
        y: 10 + screenCoordinates[1],
        className: "annotation annotation-xy-label " + (d.className || "") + " "
      },
      d.label
    );
  }

  return [laLine, laLabel];
};

var basicReactAnnotation = exports.basicReactAnnotation = function basicReactAnnotation(_ref3) {
  var screenCoordinates = _ref3.screenCoordinates,
      d = _ref3.d,
      i = _ref3.i;

  var noteData = _extends({
    dx: 0,
    dy: 0,
    note: { label: d.label },
    connector: { end: "arrow" }
  }, d, {
    type: d.type,
    screenCoordinates: screenCoordinates
  });

  noteData.x = noteData.fixedX ? noteData.fixedX : screenCoordinates[0];
  noteData.y = noteData.fixedY ? noteData.fixedY : screenCoordinates[1];

  return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: noteData });
};

var svgXAnnotation = exports.svgXAnnotation = function svgXAnnotation(_ref4) {
  var screenCoordinates = _ref4.screenCoordinates,
      d = _ref4.d,
      i = _ref4.i,
      adjustedSize = _ref4.adjustedSize;

  var noteData = _extends({
    dx: 50,
    dy: 20,
    y: 0,
    note: { label: d.label },
    connector: { end: "arrow" }
  }, d, {
    type: _reactAnnotation.AnnotationXYThreshold,
    x: screenCoordinates[0],
    subject: {
      x: screenCoordinates[0],
      y1: 0,
      y2: adjustedSize[1]
    }
  });
  return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: noteData });
};

var svgYAnnotation = exports.svgYAnnotation = function svgYAnnotation(_ref5) {
  var screenCoordinates = _ref5.screenCoordinates,
      d = _ref5.d,
      i = _ref5.i,
      adjustedSize = _ref5.adjustedSize,
      adjustedPosition = _ref5.adjustedPosition;

  var xPosition = i * 25;

  var noteData = _extends({
    dx: 50,
    dy: -20,
    x: xPosition,
    note: { label: d.label },
    connector: { end: "arrow" }
  }, d, {
    type: _reactAnnotation.AnnotationXYThreshold,
    y: screenCoordinates[1],
    subject: {
      y: screenCoordinates[1],
      x1: 0,
      x2: adjustedSize[0] + adjustedPosition[0]
    }
  });
  return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: noteData });
};

var svgBoundsAnnotation = exports.svgBoundsAnnotation = function svgBoundsAnnotation(_ref6) {
  var d = _ref6.d,
      i = _ref6.i,
      adjustedSize = _ref6.adjustedSize,
      xAccessor = _ref6.xAccessor,
      yAccessor = _ref6.yAccessor,
      xScale = _ref6.xScale,
      yScale = _ref6.yScale;

  var startXValue = xAccessor(d.bounds[0]);
  var startYValue = yAccessor(d.bounds[0]);
  var endXValue = xAccessor(d.bounds[1]);
  var endYValue = yAccessor(d.bounds[1]);

  var x0Position = startXValue ? xScale(startXValue) : 0;
  var y0Position = startYValue ? yScale(startYValue) : adjustedSize[1];
  var x1Position = endXValue ? xScale(endXValue) : adjustedSize[0];
  var y1Position = endYValue ? yScale(endYValue) : 0;

  var noteData = _extends({
    dx: 250,
    dy: -20,
    note: { label: d.label },
    connector: { end: "arrow" }
  }, d, {
    type: _reactAnnotation.AnnotationCalloutRect,
    x: Math.min(x0Position, x1Position),
    y: Math.min(y0Position, y1Position),
    subject: {
      width: Math.abs(x1Position - x0Position),
      height: Math.abs(y0Position - y1Position)
    }
  });
  return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: noteData });
};

var svgLineAnnotation = exports.svgLineAnnotation = function svgLineAnnotation(_ref7) {
  var d = _ref7.d,
      i = _ref7.i,
      screenCoordinates = _ref7.screenCoordinates;

  var lineGenerator = (0, _d3Shape.line)().x(function (p) {
    return p[0];
  }).y(function (p) {
    return p[1];
  });
  var lineD = lineGenerator(screenCoordinates);
  var laLine = _react2.default.createElement(_semioticMark.Mark, {
    key: d.label + "annotationline" + i,
    markType: "path",
    d: lineD,
    className: "annotation annotation-line " + (d.className || "") + " "
  });

  var laLabel = _react2.default.createElement(
    _semioticMark.Mark,
    {
      markType: "text",
      key: d.label + "annotationlinetext" + i,
      x: (screenCoordinates[0][0] + screenCoordinates[1][0]) / 2,
      y: (screenCoordinates[0][1] + screenCoordinates[1][1]) / 2,
      className: "annotation annotation-line-label " + (d.className || "") + " "
    },
    d.label
  );

  return [laLine, laLabel];
};

var svgAreaAnnotation = exports.svgAreaAnnotation = function svgAreaAnnotation(_ref8) {
  var d = _ref8.d,
      i = _ref8.i,
      xScale = _ref8.xScale,
      xAccessor = _ref8.xAccessor,
      yScale = _ref8.yScale,
      yAccessor = _ref8.yAccessor,
      annotationLayer = _ref8.annotationLayer;

  var mappedCoordinates = "M" + d.coordinates.map(function (p) {
    return [xScale(xAccessor(p)), yScale(yAccessor(p))];
  }).join("L") + "Z";
  var xBounds = (0, _d3Array.extent)(d.coordinates.map(function (p) {
    return xScale(xAccessor(p));
  }));
  var yBounds = (0, _d3Array.extent)(d.coordinates.map(function (p) {
    return yScale(yAccessor(p));
  }));
  var xCenter = (xBounds[0] + xBounds[1]) / 2;
  var yCenter = (yBounds[0] + yBounds[1]) / 2;

  var laLine = _react2.default.createElement(_semioticMark.Mark, {
    key: d.label + "-annotationarea-" + i,
    markType: "path",
    transform: "translate(" + annotationLayer.position + ")",
    d: mappedCoordinates,
    className: "annotation annotation-area " + (d.className || "") + " "
  });

  var laLabel = _react2.default.createElement(
    _semioticMark.Mark,
    {
      markType: "text",
      key: d.label + "-annotationtext-" + i,
      forceUpdate: true,
      x: xCenter,
      y: yCenter,
      transform: "translate(" + annotationLayer.position + ")",
      className: "annotation annotation-area-label " + (d.className || "") + " ",
      style: { textAnchor: "middle" }
    },
    d.label
  );

  return [laLine, laLabel];
};

var htmlTooltipAnnotation = exports.htmlTooltipAnnotation = function htmlTooltipAnnotation(_ref9) {
  var content = _ref9.content,
      screenCoordinates = _ref9.screenCoordinates,
      i = _ref9.i,
      d = _ref9.d;

  //To string because React gives a DOM error if it gets a date

  return _react2.default.createElement(
    "div",
    {
      key: "xylabel-" + i,
      className: "annotation annotation-xy-label " + (d.className || "") + " ",
      style: {
        position: "absolute",
        top: screenCoordinates[1] + "px",
        left: screenCoordinates[0] + "px"
      }
    },
    content
  );
};

var svgRectEncloseRule = exports.svgRectEncloseRule = function svgRectEncloseRule(_ref10) {
  var d = _ref10.d,
      i = _ref10.i,
      screenCoordinates = _ref10.screenCoordinates;

  var bboxNodes = screenCoordinates.map(function (p) {
    return {
      x0: p.x0 = p[0],
      x1: p.x1 = p[0],
      y0: p.y0 = p[1],
      y1: p.y1 = p[1]
    };
  });

  return (0, _baseRules.rectangleEnclosure)({ bboxNodes: bboxNodes, d: d, i: i });
};

var svgEncloseAnnotation = exports.svgEncloseAnnotation = function svgEncloseAnnotation(_ref11) {
  var screenCoordinates = _ref11.screenCoordinates,
      d = _ref11.d;

  var circle = (0, _d3Hierarchy.packEnclose)(screenCoordinates.map(function (p) {
    return { x: p[0], y: p[1], r: 2 };
  }));

  return (0, _baseRules.circleEnclosure)({ d: d, circle: circle });
};

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

function meanX(children) {
  return children.reduce(meanXReduce, 0) / children.length;
}

function meanXReduce(x, c) {
  return x + c.x;
}

function maxY(children) {
  return 1 + children.reduce(maxYReduce, 0);
}

function maxYReduce(y, c) {
  return Math.max(y, c.y);
}

function leafLeft(node) {
  var children;
  while (children = node.children) node = children[0];
  return node;
}

function leafRight(node) {
  var children;
  while (children = node.children) node = children[children.length - 1];
  return node;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = false;

  function cluster(root) {
    var previousNode,
        x = 0;

    // First walk, computing the initial x & y values.
    root.eachAfter(function(node) {
      var children = node.children;
      if (children) {
        node.x = meanX(children);
        node.y = maxY(children);
      } else {
        node.x = previousNode ? x += separation(node, previousNode) : 0;
        node.y = 0;
        previousNode = node;
      }
    });

    var left = leafLeft(root),
        right = leafRight(root),
        x0 = left.x - separation(left, right) / 2,
        x1 = right.x + separation(right, left) / 2;

    // Second walk, normalizing x & y to the desired size.
    return root.eachAfter(nodeSize ? function(node) {
      node.x = (node.x - root.x) * dx;
      node.y = (root.y - node.y) * dy;
    } : function(node) {
      node.x = (node.x - x0) / (x1 - x0) * dx;
      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
    });
  }

  cluster.separation = function(x) {
    return arguments.length ? (separation = x, cluster) : separation;
  };

  cluster.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
  };

  cluster.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
  };

  return cluster;
});


/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function count(node) {
  var sum = 0,
      children = node.children,
      i = children && children.length;
  if (!i) sum = 1;
  else while (--i >= 0) sum += children[i].value;
  node.value = sum;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.eachAfter(count);
});


/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, current, next = [node], children, i, n;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      callback(node), children = node.children;
      if (children) for (i = 0, n = children.length; i < n; ++i) {
        next.push(children[i]);
      }
    }
  } while (next.length);
  return this;
});


/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, nodes = [node], children, i;
  while (node = nodes.pop()) {
    callback(node), children = node.children;
    if (children) for (i = children.length - 1; i >= 0; --i) {
      nodes.push(children[i]);
    }
  }
  return this;
});


/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, nodes = [node], next = [], children, i, n;
  while (node = nodes.pop()) {
    next.push(node), children = node.children;
    if (children) for (i = 0, n = children.length; i < n; ++i) {
      nodes.push(children[i]);
    }
  }
  while (node = next.pop()) {
    callback(node);
  }
  return this;
});


/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return this.eachAfter(function(node) {
    var sum = +value(node.data) || 0,
        children = node.children,
        i = children && children.length;
    while (--i >= 0) sum += children[i].value;
    node.value = sum;
  });
});


/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
});


/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(end) {
  var start = this,
      ancestor = leastCommonAncestor(start, end),
      nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k, 0, end);
    end = end.parent;
  }
  return nodes;
});

function leastCommonAncestor(a, b) {
  if (a === b) return a;
  var aNodes = a.ancestors(),
      bNodes = b.ancestors(),
      c = null;
  a = aNodes.pop();
  b = bNodes.pop();
  while (a === b) {
    c = a;
    a = aNodes.pop();
    b = bNodes.pop();
  }
  return c;
}


/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
});


/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes = [];
  this.each(function(node) {
    nodes.push(node);
  });
  return nodes;
});


/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
});


/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var root = this, links = [];
  root.each(function(node) {
    if (node !== root) { // Don’t include the root’s parent, if any.
      links.push({source: node.parent, target: node});
    }
  });
  return links;
});


/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__siblings__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessors__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(469);




function defaultRadius(d) {
  return Math.sqrt(d.value);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var radius = null,
      dx = 1,
      dy = 1,
      padding = __WEBPACK_IMPORTED_MODULE_2__constant__["a" /* constantZero */];

  function pack(root) {
    root.x = dx / 2, root.y = dy / 2;
    if (radius) {
      root.eachBefore(radiusLeaf(radius))
          .eachAfter(packChildren(padding, 0.5))
          .eachBefore(translateChild(1));
    } else {
      root.eachBefore(radiusLeaf(defaultRadius))
          .eachAfter(packChildren(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* constantZero */], 1))
          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
    }
    return root;
  }

  pack.radius = function(x) {
    return arguments.length ? (radius = Object(__WEBPACK_IMPORTED_MODULE_1__accessors__["a" /* optional */])(x), pack) : radius;
  };

  pack.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
  };

  pack.padding = function(x) {
    return arguments.length ? (padding = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["b" /* default */])(+x), pack) : padding;
  };

  return pack;
});

function radiusLeaf(radius) {
  return function(node) {
    if (!node.children) {
      node.r = Math.max(0, +radius(node) || 0);
    }
  };
}

function packChildren(padding, k) {
  return function(node) {
    if (children = node.children) {
      var children,
          i,
          n = children.length,
          r = padding(node) * k || 0,
          e;

      if (r) for (i = 0; i < n; ++i) children[i].r += r;
      e = Object(__WEBPACK_IMPORTED_MODULE_0__siblings__["b" /* packEnclose */])(children);
      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
      node.r = e + r;
    }
  };
}

function translateChild(k) {
  return function(node) {
    var parent = node.parent;
    node.r *= k;
    if (parent) {
      node.x = parent.x + k * node.x;
      node.y = parent.y + k * node.y;
    }
  };
}


/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Node(value) {
  this._ = value;
  this.next = null;
}

/* harmony default export */ __webpack_exports__["a"] = (function(array) {
  var i,
      n = (array = array.slice()).length,
      head = null,
      node = head;

  while (n) {
    var next = new Node(array[n - 1]);
    if (node) node = node.next = next;
    else node = head = next;
    array[i] = array[--n];
  }

  return {
    head: head,
    tail: node
  };
});


/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__treemap_round__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__treemap_dice__ = __webpack_require__(97);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  var dx = 1,
      dy = 1,
      padding = 0,
      round = false;

  function partition(root) {
    var n = root.height + 1;
    root.x0 =
    root.y0 = padding;
    root.x1 = dx;
    root.y1 = dy / n;
    root.eachBefore(positionNode(dy, n));
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__treemap_round__["a" /* default */]);
    return root;
  }

  function positionNode(dy, n) {
    return function(node) {
      if (node.children) {
        Object(__WEBPACK_IMPORTED_MODULE_1__treemap_dice__["a" /* default */])(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
      }
      var x0 = node.x0,
          y0 = node.y0,
          x1 = node.x1 - padding,
          y1 = node.y1 - padding;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;
    };
  }

  partition.round = function(x) {
    return arguments.length ? (round = !!x, partition) : round;
  };

  partition.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
  };

  partition.padding = function(x) {
    return arguments.length ? (padding = +x, partition) : padding;
  };

  return partition;
});


/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessors__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__ = __webpack_require__(240);



var keyPrefix = "$", // Protect against keys like “__proto__”.
    preroot = {depth: -1},
    ambiguous = {};

function defaultId(d) {
  return d.id;
}

function defaultParentId(d) {
  return d.parentId;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var id = defaultId,
      parentId = defaultParentId;

  function stratify(data) {
    var d,
        i,
        n = data.length,
        root,
        parent,
        node,
        nodes = new Array(n),
        nodeId,
        nodeKey,
        nodeByKey = {};

    for (i = 0; i < n; ++i) {
      d = data[i], node = nodes[i] = new __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__["a" /* Node */](d);
      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
        nodeKey = keyPrefix + (node.id = nodeId);
        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
      }
    }

    for (i = 0; i < n; ++i) {
      node = nodes[i], nodeId = parentId(data[i], i, data);
      if (nodeId == null || !(nodeId += "")) {
        if (root) throw new Error("multiple roots");
        root = node;
      } else {
        parent = nodeByKey[keyPrefix + nodeId];
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);
        else parent.children = [node];
        node.parent = parent;
      }
    }

    if (!root) throw new Error("no root");
    root.parent = preroot;
    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(__WEBPACK_IMPORTED_MODULE_1__hierarchy_index__["b" /* computeHeight */]);
    root.parent = null;
    if (n > 0) throw new Error("cycle");

    return root;
  }

  stratify.id = function(x) {
    return arguments.length ? (id = Object(__WEBPACK_IMPORTED_MODULE_0__accessors__["b" /* required */])(x), stratify) : id;
  };

  stratify.parentId = function(x) {
    return arguments.length ? (parentId = Object(__WEBPACK_IMPORTED_MODULE_0__accessors__["b" /* required */])(x), stratify) : parentId;
  };

  return stratify;
});


/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hierarchy_index__ = __webpack_require__(240);


function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }

// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
  var children = v.children;
  return children ? children[0] : v.t;
}

// This function works analogously to nextLeft.
function nextRight(v) {
  var children = v.children;
  return children ? children[children.length - 1] : v.t;
}

// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
}

// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
  var shift = 0,
      change = 0,
      children = v.children,
      i = children.length,
      w;
  while (--i >= 0) {
    w = children[i];
    w.z += shift;
    w.m += shift;
    shift += w.s + (change += w.c);
  }
}

// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
  return vim.a.parent === v.parent ? vim.a : ancestor;
}

function TreeNode(node, i) {
  this._ = node;
  this.parent = null;
  this.children = null;
  this.A = null; // default ancestor
  this.a = this; // ancestor
  this.z = 0; // prelim
  this.m = 0; // mod
  this.c = 0; // change
  this.s = 0; // shift
  this.t = null; // thread
  this.i = i; // number
}

TreeNode.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_0__hierarchy_index__["a" /* Node */].prototype);

function treeRoot(root) {
  var tree = new TreeNode(root, 0),
      node,
      nodes = [tree],
      child,
      children,
      i,
      n;

  while (node = nodes.pop()) {
    if (children = node._.children) {
      node.children = new Array(n = children.length);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
        child.parent = node;
      }
    }
  }

  (tree.parent = new TreeNode(null, 0)).children = [tree];
  return tree;
}

// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = null;

  function tree(root) {
    var t = treeRoot(root);

    // Compute the layout using Buchheim et al.’s algorithm.
    t.eachAfter(firstWalk), t.parent.m = -t.z;
    t.eachBefore(secondWalk);

    // If a fixed node size is specified, scale x and y.
    if (nodeSize) root.eachBefore(sizeNode);

    // If a fixed tree size is specified, scale x and y based on the extent.
    // Compute the left-most, right-most, and depth-most nodes for extents.
    else {
      var left = root,
          right = root,
          bottom = root;
      root.eachBefore(function(node) {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
        if (node.depth > bottom.depth) bottom = node;
      });
      var s = left === right ? 1 : separation(left, right) / 2,
          tx = s - left.x,
          kx = dx / (right.x + s + tx),
          ky = dy / (bottom.depth || 1);
      root.eachBefore(function(node) {
        node.x = (node.x + tx) * kx;
        node.y = node.depth * ky;
      });
    }

    return root;
  }

  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
  // applied recursively to the children of v, as well as the function
  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
  // node v is placed to the midpoint of its outermost children.
  function firstWalk(v) {
    var children = v.children,
        siblings = v.parent.children,
        w = v.i ? siblings[v.i - 1] : null;
    if (children) {
      executeShifts(v);
      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
      if (w) {
        v.z = w.z + separation(v._, w._);
        v.m = v.z - midpoint;
      } else {
        v.z = midpoint;
      }
    } else if (w) {
      v.z = w.z + separation(v._, w._);
    }
    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
  }

  // Computes all real x-coordinates by summing up the modifiers recursively.
  function secondWalk(v) {
    v._.x = v.z + v.parent.m;
    v.m += v.parent.m;
  }

  // The core of the algorithm. Here, a new subtree is combined with the
  // previous subtrees. Threads are used to traverse the inside and outside
  // contours of the left and right subtree up to the highest common level. The
  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
  // superscript o means outside and i means inside, the subscript - means left
  // subtree and + means right subtree. For summing up the modifiers along the
  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
  // nodes of the inside contours conflict, we compute the left one of the
  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
  // Finally, we add a new thread (if necessary).
  function apportion(v, w, ancestor) {
    if (w) {
      var vip = v,
          vop = v,
          vim = w,
          vom = vip.parent.children[0],
          sip = vip.m,
          sop = vop.m,
          sim = vim.m,
          som = vom.m,
          shift;
      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
          sip += shift;
          sop += shift;
        }
        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }
      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }
      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v;
      }
    }
    return ancestor;
  }

  function sizeNode(node) {
    node.x *= dx;
    node.y = node.depth * dy;
  }

  tree.separation = function(x) {
    return arguments.length ? (separation = x, tree) : separation;
  };

  tree.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
  };

  tree.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
  };

  return tree;
});


/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__round__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__squarify__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accessors__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(469);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var tile = __WEBPACK_IMPORTED_MODULE_1__squarify__["a" /* default */],
      round = false,
      dx = 1,
      dy = 1,
      paddingStack = [0],
      paddingInner = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingTop = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingRight = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingBottom = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingLeft = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */];

  function treemap(root) {
    root.x0 =
    root.y0 = 0;
    root.x1 = dx;
    root.y1 = dy;
    root.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__round__["a" /* default */]);
    return root;
  }

  function positionNode(node) {
    var p = paddingStack[node.depth],
        x0 = node.x0 + p,
        y0 = node.y0 + p,
        x1 = node.x1 - p,
        y1 = node.y1 - p;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p;
      y0 += paddingTop(node) - p;
      x1 -= paddingRight(node) - p;
      y1 -= paddingBottom(node) - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }

  treemap.round = function(x) {
    return arguments.length ? (round = !!x, treemap) : round;
  };

  treemap.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
  };

  treemap.tile = function(x) {
    return arguments.length ? (tile = Object(__WEBPACK_IMPORTED_MODULE_2__accessors__["b" /* required */])(x), treemap) : tile;
  };

  treemap.padding = function(x) {
    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
  };

  treemap.paddingInner = function(x) {
    return arguments.length ? (paddingInner = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingInner;
  };

  treemap.paddingOuter = function(x) {
    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
  };

  treemap.paddingTop = function(x) {
    return arguments.length ? (paddingTop = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingTop;
  };

  treemap.paddingRight = function(x) {
    return arguments.length ? (paddingRight = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingRight;
  };

  treemap.paddingBottom = function(x) {
    return arguments.length ? (paddingBottom = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingBottom;
  };

  treemap.paddingLeft = function(x) {
    return arguments.length ? (paddingLeft = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingLeft;
  };

  return treemap;
});


/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      i, n = nodes.length,
      sum, sums = new Array(n + 1);

  for (sums[0] = sum = i = 0; i < n; ++i) {
    sums[i + 1] = sum += nodes[i].value;
  }

  partition(0, n, parent.value, x0, y0, x1, y1);

  function partition(i, j, value, x0, y0, x1, y1) {
    if (i >= j - 1) {
      var node = nodes[i];
      node.x0 = x0, node.y0 = y0;
      node.x1 = x1, node.y1 = y1;
      return;
    }

    var valueOffset = sums[i],
        valueTarget = (value / 2) + valueOffset,
        k = i + 1,
        hi = j - 1;

    while (k < hi) {
      var mid = k + hi >>> 1;
      if (sums[mid] < valueTarget) k = mid + 1;
      else hi = mid;
    }

    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;

    var valueLeft = sums[k] - valueOffset,
        valueRight = value - valueLeft;

    if ((x1 - x0) > (y1 - y0)) {
      var xk = (x0 * valueRight + x1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, xk, y1);
      partition(k, j, valueRight, xk, y0, x1, y1);
    } else {
      var yk = (y0 * valueRight + y1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, x1, yk);
      partition(k, j, valueRight, x0, yk, x1, y1);
    }
  }
});


/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(140);



/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? __WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(parent, x0, y0, x1, y1);
});


/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__squarify__ = __webpack_require__(242);




/* harmony default export */ __webpack_exports__["a"] = ((function custom(ratio) {

  function resquarify(parent, x0, y0, x1, y1) {
    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
      var rows,
          row,
          nodes,
          i,
          j = -1,
          n,
          m = rows.length,
          value = parent.value;

      while (++j < m) {
        row = rows[j], nodes = row.children;
        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
        if (row.dice) Object(__WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
        else Object(__WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */])(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = Object(__WEBPACK_IMPORTED_MODULE_2__squarify__["c" /* squarifyRatio */])(ratio, parent, x0, y0, x1, y1);
      rows.ratio = ratio;
    }
  }

  resquarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return resquarify;
})(__WEBPACK_IMPORTED_MODULE_2__squarify__["b" /* phi */]));


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.lineGeneratorDecorator = lineGeneratorDecorator;
exports.createPoints = createPoints;
exports.createLines = createLines;
exports.createAreas = createAreas;
exports.clonedAppliedElement = clonedAppliedElement;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semioticMark = __webpack_require__(15);

var _d3Shape = __webpack_require__(30);

var _areaDrawing = __webpack_require__(244);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function lineGeneratorDecorator(_ref) {
  var generator = _ref.generator,
      projectedCoordinateNames = _ref.projectedCoordinateNames,
      defined = _ref.defined,
      xScale = _ref.xScale,
      yScale = _ref.yScale,
      interpolator = _ref.interpolator,
      simpleLine = _ref.simpleLine;
  var x = projectedCoordinateNames.x,
      y = projectedCoordinateNames.y,
      yTop = projectedCoordinateNames.yTop,
      yBottom = projectedCoordinateNames.yBottom;


  generator.x(function (d) {
    return xScale(d[x]);
  }).curve(interpolator);

  if (simpleLine) {
    generator.y(function (d) {
      return yScale(d[y]);
    });
  } else {
    generator.y0(function (d) {
      return yScale(d[yBottom]);
    }).y1(function (d) {
      return yScale(d[yTop]);
    });
  }

  if (defined) {
    generator.defined(function (p, q) {
      return defined(p, q);
    });
  } else {
    generator.defined(function (p) {
      return !p._xyFrameUndefined;
    });
  }
}

function createPoints(_ref2) {
  var xScale = _ref2.xScale,
      yScale = _ref2.yScale,
      canvasDrawing = _ref2.canvasDrawing,
      data = _ref2.data,
      projectedCoordinateNames = _ref2.projectedCoordinateNames,
      customMark = _ref2.customMark,
      canvasRender = _ref2.canvasRender,
      styleFn = _ref2.styleFn,
      classFn = _ref2.classFn,
      renderKeyFn = _ref2.renderKeyFn,
      renderMode = _ref2.renderMode,
      baseMarkProps = _ref2.baseMarkProps;
  var y = projectedCoordinateNames.y,
      x = projectedCoordinateNames.x;

  var mappedPoints = [];
  data.forEach(function (d, i) {
    var dX = xScale(d[x]);
    var dY = yScale(d[y]);
    var renderedCustomMark = customMark && customMark({ d: d.data, i: i, xScale: xScale, yScale: yScale });
    var markProps = customMark ? _extends(baseMarkProps, renderedCustomMark.props) : _extends({}, baseMarkProps, { key: "piece-" + i, markType: "circle", r: 2 });

    if (renderedCustomMark && !renderedCustomMark.props.markType && (!canvasRender || canvasRender(d.data, i) !== true)) {
      mappedPoints.push(_react2.default.createElement(
        "g",
        {
          transform: "translate(" + dX + "," + dY + ")",
          key: renderKeyFn ? renderKeyFn(d.data, i) : "custom-point-mark-" + i,
          style: styleFn ? styleFn(d.data, i) : {},
          className: classFn ? classFn(d.data, i) : ""
        },
        renderedCustomMark
      ));
    } else {
      if (canvasRender && canvasRender(d.data, i) === true) {
        var canvasPoint = {
          type: "point",
          baseClass: "frame-piece",
          tx: dX,
          ty: dY,
          d: d,
          i: i,
          markProps: markProps,
          styleFn: styleFn,
          renderFn: renderMode,
          classFn: classFn
        };
        canvasDrawing.push(canvasPoint);
      } else {
        mappedPoints.push(clonedAppliedElement({
          baseClass: "frame-piece",
          tx: dX,
          ty: dY,
          d: d.data || d,
          i: i,
          markProps: markProps,
          styleFn: styleFn,
          renderFn: renderMode,
          renderKeyFn: renderKeyFn,
          classFn: classFn
        }));
      }
    }
  });
  return mappedPoints;
}

function createLines(_ref3) {
  var xScale = _ref3.xScale,
      yScale = _ref3.yScale,
      canvasDrawing = _ref3.canvasDrawing,
      data = _ref3.data,
      projectedCoordinateNames = _ref3.projectedCoordinateNames,
      customMark = _ref3.customMark,
      canvasRender = _ref3.canvasRender,
      styleFn = _ref3.styleFn,
      classFn = _ref3.classFn,
      renderMode = _ref3.renderMode,
      renderKeyFn = _ref3.renderKeyFn,
      type = _ref3.type,
      defined = _ref3.defined,
      baseMarkProps = _ref3.baseMarkProps;

  var customLine = (typeof type === "undefined" ? "undefined" : _typeof(type)) === "object" ? type : { type: type };
  var interpolator = customLine.interpolator ? customLine.interpolator : _d3Shape.curveLinear;
  var lineGenerator = (0, _d3Shape.area)();

  lineGeneratorDecorator({
    projectedCoordinateNames: projectedCoordinateNames,
    defined: defined,
    interpolator: interpolator,
    generator: lineGenerator,
    xScale: xScale,
    yScale: yScale,
    simpleLine: customLine.simpleLine
  });

  var mappedLines = [];
  data.forEach(function (d, i) {
    if (customMark && typeof customMark === "function") {
      //shim to make customLineMark work until Semiotic 2
      var compatibleData = _extends({}, d, {
        data: d.data.map(function (p) {
          return _extends({}, p.data, p);
        })
      });
      mappedLines.push(customMark({ d: compatibleData, i: i, xScale: xScale, yScale: yScale, canvasDrawing: canvasDrawing }));
    } else {
      var markProps = _extends({}, baseMarkProps, {
        markType: "path",
        d: lineGenerator(d.data.map(function (p) {
          return _extends({}, p.data, p);
        }))
      });
      if (canvasRender && canvasRender(d, i) === true) {
        var canvasLine = {
          type: "line",
          baseClass: "xyframe-line",
          tx: 0,
          ty: 0,
          d: d,
          i: i,
          markProps: markProps,
          styleFn: styleFn,
          renderFn: renderMode,
          classFn: classFn
        };
        canvasDrawing.push(canvasLine);
      } else {
        mappedLines.push(clonedAppliedElement({
          baseClass: "xyframe-line",
          d: d,
          i: i,
          markProps: markProps,
          styleFn: styleFn,
          renderFn: renderMode,
          renderKeyFn: renderKeyFn,
          classFn: classFn
        }));
      }
    }
  });

  if (customLine.type === "difference" && data.length === 2) {
    //Create the overlay line for the difference chart

    var diffdataA = data[0].data.map(function (basedata, baseI) {
      var linePoint = basedata._xyfYTop > data[1].data[baseI]._xyfYTop ? basedata._xyfYTop : basedata._xyfYBottom;
      return {
        _xyfX: basedata._xyfX,
        _xyfY: linePoint,
        _xyfYBottom: linePoint,
        _xyfYTop: linePoint
      };
    });

    var diffdataB = data[0].data.map(function (basedata, baseI) {
      var linePoint = data[1].data[baseI]._xyfYTop > basedata._xyfYTop ? data[1].data[baseI]._xyfYTop : data[1].data[baseI]._xyfYBottom;
      return {
        _xyfX: basedata._xyfX,
        _xyfY: linePoint,
        _xyfYBottom: linePoint,
        _xyfYTop: linePoint
      };
    });

    var doClassname = classFn ? "xyframe-line " + classFn(diffdataA) : "xyframe-line";

    var overLine = (0, _d3Shape.line)();

    lineGeneratorDecorator({
      projectedCoordinateNames: projectedCoordinateNames,
      defined: defined,
      interpolator: interpolator,
      generator: overLine,
      xScale: xScale,
      yScale: yScale,
      simpleLine: true
    });

    //      let baseStyle = props.lineStyle ? props.lineStyle(diffdata, 0) : {}
    var diffOverlayA = _react2.default.createElement(_semioticMark.Mark, {
      key: "xyline-diff-a",
      className: doClassname + " difference-overlay-a",
      markType: "path",
      d: overLine(diffdataA),
      style: { fill: "none", pointerEvents: "none" }
    });
    mappedLines.push(diffOverlayA);

    var diffOverlayB = _react2.default.createElement(_semioticMark.Mark, {
      key: "xyline-diff-b",
      className: doClassname + " difference-overlay-b",
      markType: "path",
      d: overLine(diffdataB),
      style: { fill: "none", pointerEvents: "none" }
    });
    mappedLines.push(diffOverlayB);
  }

  return mappedLines;
}

function createAreas(_ref4) {
  var xScale = _ref4.xScale,
      yScale = _ref4.yScale,
      canvasDrawing = _ref4.canvasDrawing,
      data = _ref4.data,
      canvasRender = _ref4.canvasRender,
      styleFn = _ref4.styleFn,
      classFn = _ref4.classFn,
      renderKeyFn = _ref4.renderKeyFn,
      renderMode = _ref4.renderMode,
      baseMarkProps = _ref4.baseMarkProps,
      customMark = _ref4.customMark,
      type = _ref4.type;

  var areaClass = classFn || function () {
    return "";
  };
  var areaStyle = styleFn || function () {
    return {};
  };

  var renderFn = renderMode;

  if (!Array.isArray(data)) {
    data = [data];
  }

  var renderedAreas = [];

  data.forEach(function (d, i) {
    var className = "xyframe-area";
    if (areaClass) {
      className = "xyframe-area " + areaClass(d);
    }
    var drawD = "";
    if (d.type === "MultiPolygon") {
      d.coordinates.forEach(function (coord) {
        coord.forEach(function (c) {
          drawD += "M" + c.map(function (p) {
            return xScale(p[0]) + "," + yScale(p[1]);
          }).join("L") + "Z ";
        });
      });
    } else if (customMark) {
      var projectedCoordinates = d._xyfCoordinates.map(function (d) {
        return [xScale(d[0]), yScale(d[1])];
      });
      drawD = customMark({
        d: d,
        projectedCoordinates: projectedCoordinates,
        xScale: xScale,
        yScale: yScale,
        bounds: (0, _areaDrawing.shapeBounds)(projectedCoordinates)
      });
    } else {
      drawD = "M" + d._xyfCoordinates.map(function (p) {
        return xScale(p[0]) + "," + yScale(p[1]);
      }).join("L") + "Z";
    }

    var renderKey = renderKeyFn ? renderKeyFn(d, i) : "area-" + i;

    if (_react2.default.isValidElement(drawD)) {
      renderedAreas.push(drawD);
    } else if (canvasRender && canvasRender(d, i) === true) {
      var canvasArea = {
        type: "area",
        baseClass: "xyframe-area",
        tx: 0,
        ty: 0,
        d: d,
        i: i,
        markProps: { markType: "path", d: drawD },
        styleFn: areaStyle,
        renderFn: renderFn,
        classFn: function classFn() {
          return className;
        }
      };
      canvasDrawing.push(canvasArea);
    } else {
      renderedAreas.push(_react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
        key: renderKey,
        forceUpdate: true,
        renderMode: renderFn ? renderFn(d, i) : undefined,
        className: className,
        markType: "path",
        d: drawD,
        style: areaStyle(d, i)
      })));
    }
  });
  return renderedAreas;
}

function clonedAppliedElement(_ref5) {
  var tx = _ref5.tx,
      ty = _ref5.ty,
      d = _ref5.d,
      i = _ref5.i,
      markProps = _ref5.markProps,
      styleFn = _ref5.styleFn,
      renderFn = _ref5.renderFn,
      classFn = _ref5.classFn,
      renderKeyFn = _ref5.renderKeyFn,
      baseClass = _ref5.baseClass;

  markProps.style = styleFn ? styleFn(d, i) : {};

  markProps.className = baseClass;

  markProps.key = renderKeyFn ? renderKeyFn(d, i) : baseClass + "-" + (d.key === undefined ? i : d.key);

  if (tx || ty) {
    markProps.transform = "translate(" + (tx || 0) + "," + (ty || 0) + ")";
  }

  if (classFn) {
    markProps.className = baseClass + " " + classFn(d, i);
  }

  if (!markProps.markType) {
    return _react2.default.createElement("markProps", null);
  }

  markProps.renderMode = renderFn ? renderFn(d, i) : undefined;

  return _react2.default.createElement(_semioticMark.Mark, markProps);
}

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_contours__ = __webpack_require__(471);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "contours", function() { return __WEBPACK_IMPORTED_MODULE_0__src_contours__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_density__ = __webpack_require__(1245);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "contourDensity", function() { return __WEBPACK_IMPORTED_MODULE_1__src_density__["a"]; });




/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a - b;
});


/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(ring) {
  var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
  while (++i < n) area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
  return area;
});


/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(ring, hole) {
  var i = -1, n = hole.length, c;
  while (++i < n) if (c = ringContains(ring, hole[i])) return c;
  return 0;
});

function ringContains(ring, point) {
  var x = point[0], y = point[1], contains = -1;
  for (var i = 0, n = ring.length, j = n - 1; i < n; j = i++) {
    var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
    if (segmentContains(pi, pj, point)) return 0;
    if (((yi > y) !== (yj > y)) && ((x < (xj - xi) * (y - yi) / (yj - yi) + xi))) contains = -contains;
  }
  return contains;
}

function segmentContains(a, b, c) {
  var i; return collinear(a, b, c) && within(a[i = +(a[0] === b[0])], c[i], b[i]);
}

function collinear(a, b, c) {
  return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}

function within(p, q, r) {
  return p <= q && q <= r || r <= q && q <= p;
}


/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blur__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contours__ = __webpack_require__(471);






function defaultX(d) {
  return d[0];
}

function defaultY(d) {
  return d[1];
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = defaultX,
      y = defaultY,
      dx = 960,
      dy = 500,
      r = 20, // blur radius
      k = 2, // log2(grid cell size)
      o = r * 3, // grid offset, to pad for blur
      n = (dx + o * 2) >> k, // grid width
      m = (dy + o * 2) >> k, // grid height
      threshold = Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(20);

  function density(data) {
    var values0 = new Float32Array(n * m),
        values1 = new Float32Array(n * m);

    data.forEach(function(d, i, data) {
      var xi = (x(d, i, data) + o) >> k,
          yi = (y(d, i, data) + o) >> k;
      if (xi >= 0 && xi < n && yi >= 0 && yi < m) {
        ++values0[xi + yi * n];
      }
    });

    // TODO Optimize.
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["a" /* blurX */])({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["b" /* blurY */])({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["a" /* blurX */])({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["b" /* blurY */])({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["a" /* blurX */])({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["b" /* blurY */])({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);

    var tz = threshold(values0);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      var stop = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["max"])(values0);
      tz = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(0, stop, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(0, Math.floor(stop / tz) * tz, tz);
      tz.shift();
    }

    return Object(__WEBPACK_IMPORTED_MODULE_4__contours__["a" /* default */])()
        .thresholds(tz)
        .size([n, m])
      (values0)
        .map(transform);
  }

  function transform(geometry) {
    geometry.value *= Math.pow(2, -2 * k); // Density in points per square pixel.
    geometry.coordinates.forEach(transformPolygon);
    return geometry;
  }

  function transformPolygon(coordinates) {
    coordinates.forEach(transformRing);
  }

  function transformRing(coordinates) {
    coordinates.forEach(transformPoint);
  }

  // TODO Optimize.
  function transformPoint(coordinates) {
    coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
    coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
  }

  function resize() {
    o = r * 3;
    n = (dx + o * 2) >> k;
    m = (dy + o * 2) >> k;
    return density;
  }

  density.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(+_), density) : x;
  };

  density.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(+_), density) : y;
  };

  density.size = function(_) {
    if (!arguments.length) return [dx, dy];
    var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
    if (!(_0 >= 0) && !(_0 >= 0)) throw new Error("invalid size");
    return dx = _0, dy = _1, resize();
  };

  density.cellSize = function(_) {
    if (!arguments.length) return 1 << k;
    if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
    return k = Math.floor(Math.log(_) / Math.LN2), resize();
  };

  density.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(_), density) : threshold;
  };

  density.bandwidth = function(_) {
    if (!arguments.length) return Math.sqrt(r * (r + 1));
    if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
    return r = Math.round((Math.sqrt(4 * _ * _ + 1) - 1) / 2), resize();
  };

  return density;
});


/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = blurX;
/* harmony export (immutable) */ __webpack_exports__["b"] = blurY;
// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
function blurX(source, target, r) {
  var n = source.width,
      m = source.height,
      w = (r << 1) + 1;
  for (var j = 0; j < m; ++j) {
    for (var i = 0, sr = 0; i < n + r; ++i) {
      if (i < n) {
        sr += source.data[i + j * n];
      }
      if (i >= r) {
        if (i >= w) {
          sr -= source.data[i - w + j * n];
        }
        target.data[i - r + j * n] = sr / Math.min(i + 1, n - 1 + w - i, w);
      }
    }
  }
}

// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
function blurY(source, target, r) {
  var n = source.width,
      m = source.height,
      w = (r << 1) + 1;
  for (var i = 0; i < n; ++i) {
    for (var j = 0, sr = 0; j < m + r; ++j) {
      if (j < m) {
        sr += source.data[i + j * n];
      }
      if (j >= r) {
        if (j >= w) {
          sr -= source.data[i + (j - w) * n];
        }
        target.data[i + (j - r) * n] = sr / Math.min(j + 1, m - 1 + w - j, w);
      }
    }
  }
}


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Queue = __webpack_require__(1248);

module.exports = polylabel;
module.exports.default = polylabel;

function polylabel(polygon, precision, debug) {
    precision = precision || 1.0;

    // find the bounding box of the outer ring
    var minX, minY, maxX, maxY;
    for (var i = 0; i < polygon[0].length; i++) {
        var p = polygon[0][i];
        if (!i || p[0] < minX) minX = p[0];
        if (!i || p[1] < minY) minY = p[1];
        if (!i || p[0] > maxX) maxX = p[0];
        if (!i || p[1] > maxY) maxY = p[1];
    }

    var width = maxX - minX;
    var height = maxY - minY;
    var cellSize = Math.min(width, height);
    var h = cellSize / 2;

    // a priority queue of cells in order of their "potential" (max distance to polygon)
    var cellQueue = new Queue(null, compareMax);

    if (cellSize === 0) return [minX, minY];

    // cover polygon with initial cells
    for (var x = minX; x < maxX; x += cellSize) {
        for (var y = minY; y < maxY; y += cellSize) {
            cellQueue.push(new Cell(x + h, y + h, h, polygon));
        }
    }

    // take centroid as the first best guess
    var bestCell = getCentroidCell(polygon);

    // special case for rectangular polygons
    var bboxCell = new Cell(minX + width / 2, minY + height / 2, 0, polygon);
    if (bboxCell.d > bestCell.d) bestCell = bboxCell;

    var numProbes = cellQueue.length;

    while (cellQueue.length) {
        // pick the most promising cell from the queue
        var cell = cellQueue.pop();

        // update the best cell if we found a better one
        if (cell.d > bestCell.d) {
            bestCell = cell;
            if (debug) console.log('found best %d after %d probes', Math.round(1e4 * cell.d) / 1e4, numProbes);
        }

        // do not drill down further if there's no chance of a better solution
        if (cell.max - bestCell.d <= precision) continue;

        // split the cell into four cells
        h = cell.h / 2;
        cellQueue.push(new Cell(cell.x - h, cell.y - h, h, polygon));
        cellQueue.push(new Cell(cell.x + h, cell.y - h, h, polygon));
        cellQueue.push(new Cell(cell.x - h, cell.y + h, h, polygon));
        cellQueue.push(new Cell(cell.x + h, cell.y + h, h, polygon));
        numProbes += 4;
    }

    if (debug) {
        console.log('num probes: ' + numProbes);
        console.log('best distance: ' + bestCell.d);
    }

    return [bestCell.x, bestCell.y];
}

function compareMax(a, b) {
    return b.max - a.max;
}

function Cell(x, y, h, polygon) {
    this.x = x; // cell center x
    this.y = y; // cell center y
    this.h = h; // half the cell size
    this.d = pointToPolygonDist(x, y, polygon); // distance from cell center to polygon
    this.max = this.d + this.h * Math.SQRT2; // max distance to polygon within a cell
}

// signed distance from point to polygon outline (negative if point is outside)
function pointToPolygonDist(x, y, polygon) {
    var inside = false;
    var minDistSq = Infinity;

    for (var k = 0; k < polygon.length; k++) {
        var ring = polygon[k];

        for (var i = 0, len = ring.length, j = len - 1; i < len; j = i++) {
            var a = ring[i];
            var b = ring[j];

            if ((a[1] > y !== b[1] > y) &&
                (x < (b[0] - a[0]) * (y - a[1]) / (b[1] - a[1]) + a[0])) inside = !inside;

            minDistSq = Math.min(minDistSq, getSegDistSq(x, y, a, b));
        }
    }

    return (inside ? 1 : -1) * Math.sqrt(minDistSq);
}

// get polygon centroid
function getCentroidCell(polygon) {
    var area = 0;
    var x = 0;
    var y = 0;
    var points = polygon[0];

    for (var i = 0, len = points.length, j = len - 1; i < len; j = i++) {
        var a = points[i];
        var b = points[j];
        var f = a[0] * b[1] - b[0] * a[1];
        x += (a[0] + b[0]) * f;
        y += (a[1] + b[1]) * f;
        area += f * 3;
    }
    if (area === 0) return new Cell(points[0][0], points[0][1], 0, polygon);
    return new Cell(x / area, y / area, 0, polygon);
}

// get squared distance from a point to a segment
function getSegDistSq(px, py, a, b) {

    var x = a[0];
    var y = a[1];
    var dx = b[0] - x;
    var dy = b[1] - y;

    if (dx !== 0 || dy !== 0) {

        var t = ((px - x) * dx + (py - y) * dy) / (dx * dx + dy * dy);

        if (t > 1) {
            x = b[0];
            y = b[1];

        } else if (t > 0) {
            x += dx * t;
            y += dy * t;
        }
    }

    dx = px - x;
    dy = py - y;

    return dx * dx + dy * dy;
}


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = TinyQueue;
module.exports.default = TinyQueue;

function TinyQueue(data, compare) {
    if (!(this instanceof TinyQueue)) return new TinyQueue(data, compare);

    this.data = data || [];
    this.length = this.data.length;
    this.compare = compare || defaultCompare;

    if (this.length > 0) {
        for (var i = (this.length >> 1) - 1; i >= 0; i--) this._down(i);
    }
}

function defaultCompare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}

TinyQueue.prototype = {

    push: function (item) {
        this.data.push(item);
        this.length++;
        this._up(this.length - 1);
    },

    pop: function () {
        if (this.length === 0) return undefined;

        var top = this.data[0];
        this.length--;

        if (this.length > 0) {
            this.data[0] = this.data[this.length];
            this._down(0);
        }
        this.data.pop();

        return top;
    },

    peek: function () {
        return this.data[0];
    },

    _up: function (pos) {
        var data = this.data;
        var compare = this.compare;
        var item = data[pos];

        while (pos > 0) {
            var parent = (pos - 1) >> 1;
            var current = data[parent];
            if (compare(item, current) >= 0) break;
            data[pos] = current;
            pos = parent;
        }

        data[pos] = item;
    },

    _down: function (pos) {
        var data = this.data;
        var compare = this.compare;
        var halfLength = this.length >> 1;
        var item = data[pos];

        while (pos < halfLength) {
            var left = (pos << 1) + 1;
            var right = left + 1;
            var best = data[left];

            if (right < this.length && compare(data[right], best) < 0) {
                left = right;
                best = data[right];
            }
            if (compare(best, item) >= 0) break;

            data[pos] = best;
            pos = left;
        }

        data[pos] = item;
    }
};


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.svgRectEncloseRule = exports.htmlColumnHoverRule = exports.htmlFrameHoverRule = exports.svgCategoryRule = exports.svgRRule = exports.svgEncloseRule = exports.basicReactAnnotationRule = exports.svgORRule = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semioticMark = __webpack_require__(15);

var _Annotation = __webpack_require__(57);

var _Annotation2 = _interopRequireDefault(_Annotation);

var _reactAnnotation = __webpack_require__(48);

var _d3Hierarchy = __webpack_require__(139);

var _d3Array = __webpack_require__(12);

var _pieceDrawing = __webpack_require__(142);

var _baseRules = __webpack_require__(243);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians)
  };
}

function arcBracket(_ref) {
  var x = _ref.x,
      y = _ref.y,
      radius = _ref.radius,
      startAngle = _ref.startAngle,
      endAngle = _ref.endAngle,
      inset = _ref.inset,
      outset = _ref.outset,
      _ref$curly = _ref.curly,
      curly = _ref$curly === undefined ? true : _ref$curly;

  var start = polarToCartesian(x, y, radius + outset, endAngle);
  var end = polarToCartesian(x, y, radius + outset, startAngle);

  var innerStart = polarToCartesian(x, y, radius + outset - inset, endAngle);
  var innerEnd = polarToCartesian(x, y, radius + outset - inset, startAngle);

  var angleSize = endAngle - startAngle;
  var largeArcFlag = angleSize <= 180 ? "0" : "1";
  var d = void 0;
  if (curly) {
    var curlyOffset = Math.min(10, angleSize / 4);

    var middleLeft = polarToCartesian(x, y, radius + outset, (startAngle + endAngle) / 2 + curlyOffset);

    var middle = polarToCartesian(x, y, radius + outset + 10, (startAngle + endAngle) / 2);
    var middleRight = polarToCartesian(x, y, radius + outset, (startAngle + endAngle) / 2 - curlyOffset);

    d = ["M", innerStart.x, innerStart.y, "L", start.x, start.y, "A", radius + outset, radius + outset, 0, 0, 0, middleLeft.x, middleLeft.y, "A", radius + outset, radius + outset, 1, 0, 1, middle.x, middle.y, "A", radius + outset, radius + outset, 1, 0, 1, middleRight.x, middleRight.y, "A", radius + outset, radius + outset, 0, 0, 0, end.x, end.y, "L", innerEnd.x, innerEnd.y].join(" ");
  } else {
    d = ["M", innerStart.x, innerStart.y, "L", start.x, start.y, "A", radius + outset, radius + outset, 0, largeArcFlag, 0, end.x, end.y, "L", innerEnd.x, innerEnd.y].join(" ");
  }

  var midAngle = (startAngle + endAngle) / 2;
  var textOffset = void 0,
      largeTextArcFlag = void 0,
      finalTextEnd = void 0,
      finalTextStart = void 0,
      arcFlip = void 0;
  var lowerArc = midAngle > 90 && midAngle < 270;
  if (lowerArc) {
    textOffset = 12;
    largeTextArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    arcFlip = 0;
  } else {
    largeTextArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    textOffset = 5;
    arcFlip = 1;
  }
  textOffset += curly ? 10 : 0;
  var textStart = polarToCartesian(x, y, radius + outset + textOffset, endAngle);
  var textEnd = polarToCartesian(x, y, radius + outset + textOffset, startAngle);
  if (lowerArc) {
    finalTextStart = textStart;
    finalTextEnd = textEnd;
  } else {
    finalTextStart = textEnd;
    finalTextEnd = textStart;
  }

  var textD = ["M", finalTextStart.x, finalTextStart.y, "A", radius + outset + textOffset, radius + outset + textOffset, arcFlip, largeTextArcFlag, arcFlip, finalTextEnd.x, finalTextEnd.y].join(" ");

  return { arcPath: d, textArcPath: textD };
}

var svgORRule = exports.svgORRule = function svgORRule(_ref2) {
  var d = _ref2.d,
      i = _ref2.i,
      screenCoordinates = _ref2.screenCoordinates,
      projection = _ref2.projection;

  return _react2.default.createElement(
    _semioticMark.Mark,
    {
      markType: "text",
      key: d.label + "annotationtext" + i,
      forceUpdate: true,
      x: screenCoordinates[0] + (projection === "horizontal" ? 10 : 0),
      y: screenCoordinates[1] + (projection === "vertical" ? 10 : 0),
      className: "annotation annotation-or-label " + (d.className || ""),
      textAnchor: "middle"
    },
    d.label
  );
};

var basicReactAnnotationRule = exports.basicReactAnnotationRule = function basicReactAnnotationRule(_ref3) {
  var d = _ref3.d,
      i = _ref3.i,
      screenCoordinates = _ref3.screenCoordinates;

  var noteData = _extends({
    dx: 0,
    dy: 0,
    note: { label: d.label },
    connector: { end: "arrow" }
  }, d, {
    x: screenCoordinates[0],
    y: screenCoordinates[1],
    type: typeof d.type === "function" ? d.type : undefined,
    screenCoordinates: screenCoordinates
  });
  if (d.fixedX) noteData.x = d.fixedX;
  if (d.fixedY) noteData.y = d.fixedY;
  return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: noteData });
};

var svgEncloseRule = exports.svgEncloseRule = function svgEncloseRule(_ref4) {
  var d = _ref4.d,
      i = _ref4.i,
      screenCoordinates = _ref4.screenCoordinates;

  var circle = (0, _d3Hierarchy.packEnclose)(screenCoordinates.map(function (p) {
    return { x: p[0], y: p[1], r: 2 };
  }));

  return (0, _baseRules.circleEnclosure)({ d: d, i: i, circle: circle });
};

var svgRRule = exports.svgRRule = function svgRRule(_ref5) {
  var d = _ref5.d,
      i = _ref5.i,
      screenCoordinates = _ref5.screenCoordinates,
      rScale = _ref5.rScale,
      rAccessor = _ref5.rAccessor,
      adjustedSize = _ref5.adjustedSize,
      adjustedPosition = _ref5.adjustedPosition,
      projection = _ref5.projection;

  var x = void 0,
      y = void 0,
      xPosition = void 0,
      yPosition = void 0,
      subject = void 0,
      dx = void 0,
      dy = void 0;
  if (projection === "radial") {
    return _react2.default.createElement(_Annotation2.default, {
      key: d.key || "annotation-" + i,
      noteData: _extends({
        dx: 50,
        dy: 50,
        note: { label: d.label },
        connector: { end: "arrow" }
      }, d, {
        type: _reactAnnotation.AnnotationCalloutCircle,
        subject: {
          radius: rScale(rAccessor(d)) / 2,
          radiusPadding: 0
        },
        x: adjustedSize[0] / 2,
        y: adjustedSize[1] / 2
      })
    });
  } else if (projection === "horizontal") {
    dx = 50;
    dy = 50;
    yPosition = d.offset || i * 25;
    x = screenCoordinates[0];
    y = yPosition;
    subject = {
      x: x,
      y1: 0,
      y2: adjustedSize[1] + adjustedPosition[1]
    };
  } else {
    dx = 50;
    dy = -20;
    xPosition = d.offset || i * 25;
    y = screenCoordinates[1];
    x = xPosition;
    subject = {
      y: y,
      x1: 0,
      x2: adjustedSize[0] + adjustedPosition[0]
    };
  }

  var noteData = _extends({
    dx: dx,
    dy: dy,
    note: { label: d.label },
    connector: { end: "arrow" }
  }, d, {
    type: _reactAnnotation.AnnotationXYThreshold,
    x: x,
    y: y,
    subject: subject
  });
  return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: noteData });
};

var svgCategoryRule = exports.svgCategoryRule = function svgCategoryRule(_ref6) {
  var projection = _ref6.projection,
      d = _ref6.d,
      i = _ref6.i,
      categories = _ref6.categories,
      adjustedSize = _ref6.adjustedSize;
  var _d$bracketType = d.bracketType,
      bracketType = _d$bracketType === undefined ? "curly" : _d$bracketType,
      _d$position = d.position,
      position = _d$position === undefined ? projection === "vertical" ? "top" : "left" : _d$position,
      _d$depth = d.depth,
      depth = _d$depth === undefined ? 30 : _d$depth,
      _d$offset = d.offset,
      offset = _d$offset === undefined ? 0 : _d$offset,
      _d$padding = d.padding,
      padding = _d$padding === undefined ? 0 : _d$padding;

  var actualCategories = Array.isArray(d.categories) ? d.categories : [d.categories];
  var cats = actualCategories.map(function (c) {
    return categories[c];
  });

  if (projection === "radial") {
    var arcPadding = padding / adjustedSize[1];
    var leftX = (0, _d3Array.min)(cats.map(function (p) {
      return p.pct_start + p.pct_padding / 2 + arcPadding / 2;
    }));
    var rightX = (0, _d3Array.max)(cats.map(function (p) {
      return p.pct_start + p.pct - p.pct_padding / 2 - arcPadding / 2;
    }));

    var chartSize = Math.min(adjustedSize[0], adjustedSize[1]) / 2;
    var centerX = adjustedSize[0] / 2;
    var centerY = adjustedSize[1] / 2;

    var _arcBracket = arcBracket({
      x: 0,
      y: 0,
      radius: chartSize,
      startAngle: leftX * 360,
      endAngle: rightX * 360,
      inset: depth,
      outset: offset,
      curly: bracketType === "curly"
    }),
        arcPath = _arcBracket.arcPath,
        textArcPath = _arcBracket.textArcPath;

    var textPathID = "text-path-" + i + "-" + Math.random();
    return _react2.default.createElement(
      "g",
      {
        className: "category-annotation annotation",
        transform: "translate(" + centerX + "," + centerY + ")"
      },
      _react2.default.createElement("path", { d: arcPath, fill: "none" }),
      _react2.default.createElement("path", { id: textPathID, d: textArcPath, style: { display: "none" } }),
      _react2.default.createElement(
        "text",
        { "font-size": "12.5" },
        _react2.default.createElement(
          "textPath",
          {
            startOffset: "50%",
            textAnchor: "middle",
            xlinkHref: "#" + textPathID
          },
          d.label
        )
      )
    );
  } else {
    var _leftX = (0, _d3Array.min)(cats.map(function (p) {
      return p.x;
    }));
    var _rightX = (0, _d3Array.max)(cats.map(function (p) {
      return p.x + p.width;
    }));

    if (projection === "vertical") {
      var yPosition = position === "top" ? 0 : adjustedSize[1];
      yPosition += position === "top" ? -offset : offset;
      var noteData = {
        type: _reactAnnotation.AnnotationBracket,
        y: yPosition,
        x: _leftX - padding,
        note: {
          title: d.title || d.label,
          label: d.title ? d.label : undefined
        },
        subject: {
          type: bracketType,
          width: _rightX - _leftX + padding * 2,
          depth: position === "top" ? -depth : depth
        }
      };
      return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: noteData });
    } else if (projection === "horizontal") {
      var _yPosition = position === "left" ? 0 : adjustedSize[0];
      _yPosition += position === "left" ? -offset : offset;
      var _noteData = {
        type: _reactAnnotation.AnnotationBracket,
        x: _yPosition,
        y: _leftX - padding,
        note: {
          title: d.title || d.label,
          label: d.title ? d.label : undefined
        },
        subject: {
          type: bracketType,
          height: _rightX - _leftX + padding * 2,
          depth: position === "left" ? -depth : depth
        }
      };
      return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: _noteData });
    }
  }
};

var htmlFrameHoverRule = exports.htmlFrameHoverRule = function htmlFrameHoverRule(_ref7) {
  var d = _ref7.d,
      i = _ref7.i,
      rAccessor = _ref7.rAccessor,
      oAccessor = _ref7.oAccessor,
      projection = _ref7.projection,
      tooltipContent = _ref7.tooltipContent;

  //To string because React gives a DOM error if it gets a date
  var contentFill = void 0;
  if (d.isSummaryData) {
    var summaryLabel = _react2.default.createElement(
      "p",
      { key: "html-annotation-content-2" },
      d.label
    );
    if (d.pieces && d.pieces.length !== 0) {
      if (d.pieces.length === 1) {
        summaryLabel = _react2.default.createElement(
          "p",
          { key: "html-annotation-content-2" },
          rAccessor(d.pieces[0].data)
        );
      } else {
        var pieceData = (0, _d3Array.extent)(d.pieces.map(function (p) {
          return p.data;
        }).map(rAccessor));
        summaryLabel = _react2.default.createElement(
          "p",
          { key: "html-annotation-content-2" },
          "From ",
          pieceData[0],
          " to ",
          pieceData[1]
        );
      }
    }
    contentFill = [_react2.default.createElement(
      "p",
      { key: "html-annotation-content-1" },
      d.key
    ), summaryLabel, _react2.default.createElement(
      "p",
      { key: "html-annotation-content-3" },
      d.value
    )];
  } else {
    contentFill = [oAccessor(d.data) && _react2.default.createElement(
      "p",
      { key: "html-annotation-content-1" },
      oAccessor(d.data).toString()
    ), rAccessor(d.data) && _react2.default.createElement(
      "p",
      { key: "html-annotation-content-2" },
      rAccessor(d.data).toString()
    )];
  }
  var content = _react2.default.createElement(
    "div",
    { className: "tooltip-content" },
    contentFill
  );

  if (d.type === "frame-hover" && tooltipContent) {
    content = tooltipContent(d);
  }

  return _react2.default.createElement(
    "div",
    {
      key: "xylabel-" + i,
      className: "annotation annotation-or-label tooltip " + projection + " " + (d.className || ""),
      style: {
        position: "absolute",
        top: d.y + "px",
        left: d.x + "px"
      }
    },
    content
  );
};

var htmlColumnHoverRule = exports.htmlColumnHoverRule = function htmlColumnHoverRule(_ref8) {
  var d = _ref8.d,
      i = _ref8.i,
      summaryType = _ref8.summaryType,
      oAccessor = _ref8.oAccessor,
      projectedColumns = _ref8.projectedColumns,
      type = _ref8.type,
      adjustedPosition = _ref8.adjustedPosition,
      adjustedSize = _ref8.adjustedSize,
      projection = _ref8.projection,
      tooltipContent = _ref8.tooltipContent;

  //we need to ignore negative pieces to make sure the hover behavior populates on top of the positive bar
  var positionValue = summaryType.type || ["swarm", "point", "clusterbar"].find(function (p) {
    return p === type.type;
  }) ? (0, _d3Array.max)(d.pieces.map(function (p) {
    return p.scaledValue;
  })) : (0, _d3Array.sum)(d.pieces.map(function (p) {
    return p.scaledValue;
  }).filter(function (p) {
    return p > 0;
  }));

  var column = projectedColumns[oAccessor(d.pieces[0].data)];

  var xPosition = column.middle + adjustedPosition[0];
  var yPosition = adjustedSize[1] - positionValue;
  yPosition += 10;

  if (projection === "horizontal") {
    yPosition = projectedColumns[oAccessor(d.pieces[0].data)].middle;
    xPosition = positionValue + adjustedPosition[0];
  } else if (projection === "radial") {
    ;
    var _pointOnArcAtAngle = (0, _pieceDrawing.pointOnArcAtAngle)([d.arcAngles.translate[0], d.arcAngles.translate[1]], d.arcAngles.midAngle, d.arcAngles.length);

    var _pointOnArcAtAngle2 = _slicedToArray(_pointOnArcAtAngle, 2);

    xPosition = _pointOnArcAtAngle2[0];
    yPosition = _pointOnArcAtAngle2[1];

    yPosition += 10;
  }

  //To string because React gives a DOM error if it gets a date
  var content = _react2.default.createElement(
    "div",
    { className: "tooltip-content" },
    oAccessor(d.pieces[0].data) && _react2.default.createElement(
      "p",
      { key: "or-annotation-1" },
      oAccessor(d.pieces[0].data).toString()
    ),
    _react2.default.createElement(
      "p",
      { key: "or-annotation-2" },
      (0, _d3Array.sum)(d.pieces.map(function (p) {
        return p.value;
      }).filter(function (p) {
        return p > 0;
      }))
    )
  );

  if (d.type === "column-hover" && tooltipContent) {
    if (tooltipContent === "pie") {
      content = _react2.default.createElement(
        "div",
        { className: "tooltip-content" },
        oAccessor(d.pieces[0].data) && _react2.default.createElement(
          "p",
          { key: "or-annotation-1" },
          oAccessor(d.pieces[0].data).toString()
        ),
        _react2.default.createElement(
          "p",
          { key: "or-annotation-2" },
          (column.pct * 100).toFixed(0) + "%"
        )
      );
    } else {
      content = tooltipContent(_extends({}, d, {
        pieces: d.pieces.map(function (p) {
          return p.data;
        }),
        column: column
      }));
    }
  }

  if (d.type === "xy") {
    content = d.label;
  }

  return _react2.default.createElement(
    "div",
    {
      key: "orlabel-" + i,
      className: "annotation annotation-or-label tooltip " + projection + " " + (d.className || ""),
      style: {
        position: "absolute",
        top: yPosition + "px",
        left: xPosition + "px"
      }
    },
    content
  );
};

var svgRectEncloseRule = exports.svgRectEncloseRule = function svgRectEncloseRule(_ref9) {
  var d = _ref9.d,
      i = _ref9.i,
      screenCoordinates = _ref9.screenCoordinates;

  var bboxNodes = screenCoordinates.map(function (p) {
    return {
      x0: p.x0 = p[0],
      x1: p.x1 = p[0],
      y0: p.y0 = p[1],
      y1: p.y1 = p[1]
    };
  });

  return (0, _baseRules.rectangleEnclosure)({ bboxNodes: bboxNodes, d: d, i: i });
};

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.pointOnArcAtAngle = pointOnArcAtAngle;
exports.clusterBarLayout = clusterBarLayout;
exports.barLayout = barLayout;
exports.timelineLayout = timelineLayout;
exports.pointLayout = pointLayout;
exports.swarmLayout = swarmLayout;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Force = __webpack_require__(476);

var _d3Shape = __webpack_require__(30);

var _svgPathBoundingBox = __webpack_require__(1257);

var _svgPathBoundingBox2 = _interopRequireDefault(_svgPathBoundingBox);

var _semioticMark = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var twoPI = Math.PI * 2;

var iconBarCustomMark = function iconBarCustomMark(_ref) {
  var type = _ref.type,
      projection = _ref.projection,
      finalHeight = _ref.finalHeight,
      finalWidth = _ref.finalWidth,
      styleFn = _ref.styleFn,
      renderValue = _ref.renderValue,
      classFn = _ref.classFn;
  return function (piece, i, xy) {
    var iconD = typeof type.icon === "string" ? type.icon : type.icon(piece.data, i);
    var _type$iconPadding = type.iconPadding,
        iconPadding = _type$iconPadding === undefined ? 1 : _type$iconPadding,
        _type$resize = type.resize,
        resize = _type$resize === undefined ? "auto" : _type$resize;


    var iconBounds = (0, _svgPathBoundingBox2.default)(iconD);
    var iconTranslate = [0 - iconBounds.x1 + iconPadding, 0 - iconBounds.y1 + iconPadding];
    iconBounds.height += iconPadding * 2;
    iconBounds.width += iconPadding * 2;

    var icons = [];

    var stackedIconSize = iconBounds.height;
    var stackedIconNumber = 1;
    var iconScale = 1;
    var spaceToUse = projection === "horizontal" ? finalHeight : finalWidth;
    var sizeToFit = projection === "horizontal" ? iconBounds.height : iconBounds.width;
    var sizeToPad = projection === "horizontal" ? iconBounds.width : iconBounds.height;
    var spaceToFill = projection === "horizontal" ? xy.width : xy.height;
    var spaceToStackFill = projection === "horizontal" ? xy.height : xy.width;
    if (resize === "auto") {
      stackedIconSize = spaceToUse / sizeToFit;
      if (stackedIconSize < 1) {
        iconScale = stackedIconSize;
      } else {
        stackedIconNumber = Math.floor(stackedIconSize);
        iconScale = 1 + (stackedIconSize - stackedIconNumber) / stackedIconNumber;
      }
    } else if (resize === "fixed") {
      iconScale = spaceToUse / sizeToFit;
    }

    //  const finalIconWidth = iconBounds.width * iconScale;
    var finalIconHeight = iconBounds.height * iconScale;

    var spaceToStep = sizeToPad * iconScale;
    var spaceToStackStep = sizeToFit * iconScale;

    iconTranslate[0] = iconTranslate[0] * iconScale;
    iconTranslate[1] = iconTranslate[1] * iconScale;

    var randoClipID = "iso-clip-" + i + "-" + Math.random();
    var clipPath = "url(#" + randoClipID + ")";
    if (xy.width > 0) {
      icons.push(_react2.default.createElement(
        "clipPath",
        { key: randoClipID, id: randoClipID },
        _react2.default.createElement("rect", { x: 0, y: 0, width: xy.width, height: xy.height })
      ));
      var iconPieces = [];
      var stepStart = projection === "horizontal" ? 0 : xy.height - finalIconHeight;
      var stepper = projection === "horizontal" ? spaceToStep : -spaceToStep;
      var stepTest = projection === "horizontal" ? function (step, spaceToFillValue) {
        return step < spaceToFillValue;
      } : function (step, spaceToFillValue, stepperValue) {
        return step > 0 + stepperValue;
      };

      for (var step = stepStart; stepTest(step, spaceToFill, stepper); step += stepper) {
        for (var stack = 0; stack < spaceToStackFill; stack += spaceToStackStep) {
          var stepX = projection === "horizontal" ? step : stack;
          var stepY = projection === "horizontal" ? stack : step;
          var paddedX = stepX + iconTranslate[0];
          var paddedY = stepY + iconTranslate[1];
          iconPieces.push(_react2.default.createElement(_semioticMark.Mark, {
            forceUpdate: true,
            markType: "path",
            key: "icon-" + step + "-" + stack,
            transform: "translate(" + paddedX + "," + paddedY + ") scale(" + iconScale + ")",
            vectorEffect: "non-scaling-stroke",
            d: iconD,
            style: styleFn(piece.data, i),
            renderMode: renderValue,
            className: classFn(piece.data, i)
          }));
        }
      }
      icons.push(_react2.default.createElement(
        "g",
        { key: "clipped-region-" + i, clipPath: clipPath },
        iconPieces
      ));
    }
    return icons;
  };
};

function pointOnArcAtAngle(center, angle, distance) {
  var radians = Math.PI * (angle + 0.75) * 2;

  var xPosition = center[0] + distance * Math.cos(radians);
  var yPosition = center[1] + distance * Math.sin(radians);

  return [xPosition, yPosition];
}

function clusterBarLayout(_ref2) {
  var type = _ref2.type,
      data = _ref2.data,
      renderMode = _ref2.renderMode,
      eventListenersGenerator = _ref2.eventListenersGenerator,
      styleFn = _ref2.styleFn,
      projection = _ref2.projection,
      classFn = _ref2.classFn,
      adjustedSize = _ref2.adjustedSize;

  var allCalculatedPieces = [];
  var keys = Object.keys(data);
  keys.forEach(function (key, ordsetI) {
    var ordset = data[key];

    var barColumnWidth = ordset.width;
    var clusterWidth = barColumnWidth / ordset.pieceData.length;

    var currentX = 0;
    var currentY = 0;

    var calculatedPieces = ordset.pieceData.map(function (piece, i) {
      var renderValue = renderMode && renderMode(piece.data, i);

      var xPosition = piece.x;
      var yPosition = piece.base;
      var finalWidth = clusterWidth;
      var finalHeight = piece.scaledValue;
      var xy = {};
      if (!piece.negative) {
        yPosition -= piece.scaledValue;
      }

      if (projection === "horizontal") {
        //TODO: NEGATIVE FOR HORIZONTAL
        yPosition = piece.x;
        xPosition = piece.base;
        finalHeight = clusterWidth;
        finalWidth = piece.scaledValue;
        if (piece.negative) {
          xPosition -= piece.scaledValue;
        }
      }

      var markD = void 0,
          translate = void 0,
          markProps = {};

      if (projection === "radial") {
        var arcGenerator = (0, _d3Shape.arc)().innerRadius(0).outerRadius(piece.scaledValue / 2);

        var angle = (ordset.pct - ordset.pct_padding) / ordset.pieceData.length;
        var startAngle = ordset.pct_start + i / ordset.pieceData.length * (ordset.pct - ordset.pct_padding);
        var endAngle = startAngle + angle;

        markD = arcGenerator({
          startAngle: startAngle * twoPI,
          endAngle: endAngle * twoPI
        });
        var xOffset = adjustedSize[0] / 2;
        var yOffset = adjustedSize[1] / 2;
        translate = "translate(" + xOffset + "," + yOffset + ")";

        var startAngleFinal = startAngle * twoPI;
        var endAngleFinal = endAngle * twoPI;
        var outerPoint = pointOnArcAtAngle([0, 0], (startAngle + endAngle) / 2, piece.scaledValue / 2);

        xy.arcGenerator = arcGenerator;
        xy.startAngle = startAngleFinal;
        xy.endAngle = endAngleFinal;
        xy.dx = outerPoint[0];
        xy.dy = outerPoint[1];

        var centroid = arcGenerator.centroid({
          startAngle: startAngleFinal,
          endAngle: endAngleFinal
        });
        finalHeight = undefined;
        finalWidth = undefined;
        xPosition = centroid[0] + xOffset;
        yPosition = centroid[1] + yOffset;

        markProps = {
          markType: "path",
          d: markD,
          tx: xOffset,
          ty: yOffset
        };
      } else {
        xPosition += currentX;
        yPosition += currentY;
        markProps = {
          markType: "rect",
          x: xPosition,
          y: yPosition,
          width: finalWidth,
          height: finalHeight,
          rx: 0,
          ry: 0
        };
      }

      var eventListeners = eventListenersGenerator(piece, i);

      xy.x = xPosition;
      xy.y = yPosition;
      xy.middle = clusterWidth / 2;
      xy.height = finalHeight;
      xy.width = finalWidth;

      if (type.icon && projection !== "radial") {
        type.customMark = iconBarCustomMark({
          type: type,
          projection: projection,
          finalHeight: finalHeight,
          finalWidth: finalWidth,
          styleFn: styleFn,
          renderValue: renderValue,
          classFn: classFn
        });
      } else if (type.icon && projection === "radial") {
        console.error("Icons are currently unsupported on radial charts");
      }

      var renderElementObject = type.customMark ? _react2.default.createElement(
        "g",
        {
          key: "piece-" + piece.renderKey,
          transform: translate ? translate : "translate(" + xPosition + "," + yPosition + ")"
        },
        type.customMark(_extends({}, piece.data, piece), i, xy)
      ) : _extends({
        className: classFn(piece.data, i),
        renderMode: renderValue,
        key: "piece-" + piece.renderKey,
        transform: translate,
        style: styleFn(piece.data, ordsetI)
      }, markProps, eventListeners);

      var calculatedPiece = {
        o: key,
        xy: xy,
        piece: piece,
        renderElement: renderElementObject
      };
      if (projection === "horizontal") {
        currentY += finalHeight;
      } else {
        currentX += finalWidth;
      }

      //        currentOffset += pieceSize
      return calculatedPiece;
    });
    allCalculatedPieces = [].concat(_toConsumableArray(allCalculatedPieces), _toConsumableArray(calculatedPieces));
  });
  return allCalculatedPieces;
}

function barLayout(_ref3) {
  var type = _ref3.type,
      data = _ref3.data,
      renderMode = _ref3.renderMode,
      eventListenersGenerator = _ref3.eventListenersGenerator,
      styleFn = _ref3.styleFn,
      projection = _ref3.projection,
      classFn = _ref3.classFn,
      adjustedSize = _ref3.adjustedSize;

  var keys = Object.keys(data);
  var allCalculatedPieces = [];
  keys.forEach(function (key, ordsetI) {
    var ordset = data[key];
    var barColumnWidth = ordset.width;

    var calculatedPieces = ordset.pieceData.map(function (piece, i) {
      var pieceSize = piece.scaledValue;
      var renderValue = renderMode && renderMode(piece.data, i);

      var xPosition = piece.x;
      var yPosition = piece.bottom;
      var finalWidth = barColumnWidth;
      var finalHeight = pieceSize;

      if (!piece.negative) {
        yPosition -= piece.scaledValue;
      }

      if (projection === "horizontal") {
        yPosition = piece.x;
        xPosition = piece.bottom;
        finalHeight = barColumnWidth;
        finalWidth = pieceSize;
        if (piece.negative) {
          xPosition = piece.bottom - piece.scaledValue;
        }
      }

      var markD = void 0,
          markProps = void 0;

      if (projection === "radial") {
        var innerRadius = type.innerRadius;

        var innerSize = piece.bottom / 2;
        var outerSize = piece.scaledValue / 2 + piece.bottom / 2;
        if (innerRadius) {
          innerRadius = parseInt(innerRadius, 10);
          var canvasRadius = adjustedSize[0] / 2;
          var donutMod = (canvasRadius - innerRadius) / canvasRadius;
          innerSize = innerSize * donutMod + innerRadius;
          outerSize = outerSize * donutMod + innerRadius;
        }

        var arcGenerator = (0, _d3Shape.arc)().innerRadius(innerSize).outerRadius(outerSize);
        //          .padAngle(ordset.pct_padding * twoPI);

        var angle = ordset.pct;
        var startAngle = ordset.pct === 1 ? 0 : ordset.pct_start;
        var endAngle = ordset.pct === 1 ? 1 : Math.max(startAngle, startAngle + angle - ordset.pct_padding / 2);

        markD = arcGenerator({
          startAngle: startAngle * twoPI,
          endAngle: endAngle * twoPI
        });
        var centroid = arcGenerator.centroid({
          startAngle: startAngle * twoPI,
          endAngle: endAngle * twoPI
        });
        finalHeight = undefined;
        finalWidth = undefined;
        var xOffset = adjustedSize[0] / 2;
        var yOffset = adjustedSize[1] / 2;
        xPosition = centroid[0] + xOffset;
        yPosition = centroid[1] + yOffset;

        markProps = {
          markType: "path",
          d: markD,
          tx: xOffset,
          ty: yOffset,
          transform: "translate(" + xOffset + "," + yOffset + ")"
        };
      } else {
        markProps = {
          markType: "rect",
          x: xPosition,
          y: yPosition,
          width: finalWidth,
          height: finalHeight,
          rx: 0,
          ry: 0
        };
      }

      var eventListeners = eventListenersGenerator(piece, i);
      var xy = {
        x: xPosition,
        y: yPosition,
        middle: barColumnWidth / 2,
        height: finalHeight,
        width: finalWidth
      };

      if (type.icon && projection !== "radial") {
        type.customMark = iconBarCustomMark({
          type: type,
          projection: projection,
          finalHeight: finalHeight,
          finalWidth: finalWidth,
          styleFn: styleFn,
          renderValue: renderValue,
          classFn: classFn
        });
      } else if (type.icon && projection !== "horizontal") {
        console.error("Icons are currently unsupported in radial charts");
      }

      var renderElementObject = type.customMark ? _react2.default.createElement(
        "g",
        {
          key: "piece-" + piece.renderKey,
          transform: "translate(" + xPosition + "," + yPosition + ")"
        },
        type.customMark(_extends({}, piece.data, piece), i, xy)
      ) : _extends({
        className: classFn(piece.data, i),
        renderMode: renderValue,
        key: "piece-" + piece.renderKey,
        style: styleFn(piece.data, ordsetI)
      }, eventListeners, markProps);

      var calculatedPiece = {
        o: key,
        xy: xy,
        piece: piece,
        renderElement: renderElementObject
      };
      return calculatedPiece;
    });
    allCalculatedPieces = [].concat(_toConsumableArray(allCalculatedPieces), _toConsumableArray(calculatedPieces));
  });

  return allCalculatedPieces;
}

function timelineLayout(_ref4) {
  var type = _ref4.type,
      data = _ref4.data,
      renderMode = _ref4.renderMode,
      eventListenersGenerator = _ref4.eventListenersGenerator,
      styleFn = _ref4.styleFn,
      projection = _ref4.projection,
      classFn = _ref4.classFn,
      adjustedSize = _ref4.adjustedSize;

  var allCalculatedPieces = [];
  var keys = Object.keys(data);
  keys.forEach(function (key, ordsetI) {
    var ordset = data[key];
    var calculatedPieces = [];

    ordset.pieceData.forEach(function (piece, i) {
      var renderValue = renderMode && renderMode(piece.data, i);
      var xPosition = ordset.x;
      var height = piece.scaledEndValue - piece.scaledValue;
      var yPosition = piece.scaledVerticalValue - height;
      var width = ordset.width;
      var markProps = {
        markType: "rect",
        height: height < 0 ? -height : height,
        width: width,
        x: xPosition,
        y: height < 0 ? yPosition + height : yPosition
      };

      if (projection === "horizontal") {
        yPosition = ordset.x;
        xPosition = piece.scaledValue;
        width = piece.scaledEndValue - piece.scaledValue;
        height = ordset.width;
        markProps = {
          markType: "rect",
          height: height,
          width: width < 0 ? -width : width,
          x: width < 0 ? xPosition + width : xPosition,
          y: yPosition
        };
      } else if (projection === "radial") {
        var innerRadius = type.innerRadius;

        var innerSize = piece.scaledValue / 2;
        var outerSize = piece.scaledEndValue / 2;
        if (innerRadius) {
          innerRadius = parseInt(innerRadius, 10);
          var canvasRadius = adjustedSize[0] / 2;
          var donutMod = (canvasRadius - innerRadius) / canvasRadius;
          innerSize = innerSize * donutMod + innerRadius;
          outerSize = outerSize * donutMod + innerRadius;
        }

        var arcGenerator = (0, _d3Shape.arc)().innerRadius(innerSize).outerRadius(outerSize);
        //          .padAngle(ordset.pct_padding * twoPI);

        var angle = ordset.pct;
        var startAngle = ordset.pct === 1 ? 0 : ordset.pct_start;
        var endAngle = ordset.pct === 1 ? 1 : Math.max(startAngle, startAngle + angle - ordset.pct_padding / 2);

        var markD = arcGenerator({
          startAngle: startAngle * twoPI,
          endAngle: endAngle * twoPI
        });

        var xOffset = adjustedSize[0] / 2;
        var yOffset = adjustedSize[1] / 2;
        markProps = {
          markType: "path",
          d: markD,
          transform: "translate(" + xOffset + "," + yOffset + ")",
          tx: xOffset,
          ty: yOffset
        };
      }

      //Only return the actual piece if you're rendering points, otherwise you just needed to iterate and calculate the points for the contour summary type

      var eventListeners = eventListenersGenerator(piece, i);
      var xy = {
        x: xPosition,
        y: yPosition,
        height: height
      };

      var renderElementObject = type.customMark ? _react2.default.createElement(
        "g",
        {
          key: "piece-" + piece.renderKey,
          transform: "translate(" + xPosition + "," + (yPosition + height) + ")"
        },
        type.customMark(_extends({}, piece.data, piece), i, xy)
      ) : _extends({
        className: classFn(piece.data, i),
        renderMode: renderValue,
        key: "piece-" + piece.renderKey,
        style: styleFn(piece.data, ordsetI)
      }, markProps, eventListeners);

      var calculatedPiece = {
        o: key,
        xy: xy,
        piece: piece,
        renderElement: renderElementObject
      };

      calculatedPieces.push(calculatedPiece);
    });
    allCalculatedPieces = [].concat(_toConsumableArray(allCalculatedPieces), calculatedPieces);
  });

  return allCalculatedPieces;
}

function pointLayout(_ref5) {
  var type = _ref5.type,
      data = _ref5.data,
      renderMode = _ref5.renderMode,
      eventListenersGenerator = _ref5.eventListenersGenerator,
      styleFn = _ref5.styleFn,
      projection = _ref5.projection,
      classFn = _ref5.classFn,
      adjustedSize = _ref5.adjustedSize;

  var circleRadius = type.r || 3;
  var allCalculatedPieces = [];
  var keys = Object.keys(data);
  keys.forEach(function (key, ordsetI) {
    var ordset = data[key];

    var calculatedPieces = [];

    ordset.pieceData.forEach(function (piece, i) {
      var renderValue = renderMode && renderMode(piece.data, i);

      var xPosition = ordset.middle;
      var yPosition = piece.scaledVerticalValue;

      if (projection === "horizontal") {
        yPosition = ordset.middle;
        xPosition = piece.scaledValue;
      } else if (projection === "radial") {
        var angle = ordset.pct_middle;

        var rPosition = piece.scaledValue / 2;
        var baseCentroid = pointOnArcAtAngle([adjustedSize[0] / 2, adjustedSize[1] / 2], angle, rPosition);
        xPosition = baseCentroid[0];
        yPosition = baseCentroid[1];
      }

      //Only return the actual piece if you're rendering points, otherwise you just needed to iterate and calculate the points for the contour summary type
      var actualCircleRadius = typeof circleRadius === "function" ? circleRadius(piece, i) : circleRadius;
      var eventListeners = eventListenersGenerator(piece, i);

      var renderElementObject = type.customMark ? _react2.default.createElement(
        "g",
        {
          key: "piece-" + piece.renderKey,
          transform: "translate(" + xPosition + "," + yPosition + ")"
        },
        type.customMark(_extends({}, piece.data, piece), i)
      ) : _extends({
        className: classFn(piece.data, i),
        markType: "rect",
        renderMode: renderValue,
        key: "piece-" + piece.renderKey,
        height: actualCircleRadius * 2,
        width: actualCircleRadius * 2,
        x: xPosition - actualCircleRadius,
        y: yPosition - actualCircleRadius,
        rx: actualCircleRadius,
        ry: actualCircleRadius,
        style: styleFn(piece.data, ordsetI)
      }, eventListeners);

      var calculatedPiece = {
        o: key,
        xy: {
          x: xPosition,
          y: yPosition
        },
        piece: piece,
        renderElement: renderElementObject
      };

      calculatedPieces.push(calculatedPiece);
    });
    allCalculatedPieces = [].concat(_toConsumableArray(allCalculatedPieces), calculatedPieces);
  });

  return allCalculatedPieces;
}

function swarmLayout(_ref6) {
  var type = _ref6.type,
      data = _ref6.data,
      renderMode = _ref6.renderMode,
      eventListenersGenerator = _ref6.eventListenersGenerator,
      styleFn = _ref6.styleFn,
      projection = _ref6.projection,
      classFn = _ref6.classFn,
      adjustedSize = _ref6.adjustedSize;

  var allCalculatedPieces = [];
  var iterations = type.iterations || 120;

  var columnKeys = Object.keys(data);

  columnKeys.forEach(function (key, ordsetI) {
    var oColumn = data[key];
    var anglePiece = 1 / columnKeys.length;
    var oData = oColumn.pieceData;
    var adjustedColumnWidth = oColumn.width;

    var circleRadius = type.r || Math.max(2, Math.min(5, 4 * adjustedColumnWidth / oData.length));

    var simulation = (0, _d3Force.forceSimulation)(oData).force("y", (0, _d3Force.forceY)(function (d) {
      return d.scaledValue;
    }).strength(type.strength || 2)).force("x", (0, _d3Force.forceX)(oColumn.middle)).force("collide", (0, _d3Force.forceCollide)(circleRadius)).stop();

    if (projection === "vertical") {
      simulation.force("y", (0, _d3Force.forceY)(function (d) {
        return d.scaledVerticalValue;
      }).strength(type.strength || 2));
    }

    for (var i = 0; i < iterations; ++i) {
      simulation.tick();
    }var calculatedPieces = oData.map(function (piece, i) {
      var renderValue = renderMode && renderMode(piece.data, i);

      var xPosition = piece.x;
      var yPosition = piece.y;

      if (projection === "horizontal") {
        yPosition = piece.x;
        xPosition = piece.y;
      } else if (projection === "radial") {
        var angle = oColumn.pct_middle;
        xPosition = (piece.x - oColumn.middle) / adjustedColumnWidth * anglePiece;
        var rPosition = piece.scaledValue / 2;
        var xAngle = angle + xPosition;
        var baseCentroid = pointOnArcAtAngle([adjustedSize[0] / 2, adjustedSize[1] / 2], xAngle, rPosition);
        xPosition = baseCentroid[0];
        yPosition = baseCentroid[1];
      }

      var actualCircleRadius = typeof circleRadius === "function" ? circleRadius(piece, i) : circleRadius;

      var eventListeners = eventListenersGenerator(piece, i);

      var renderElementObject = type.customMark ? _react2.default.createElement(
        "g",
        {
          key: "piece-" + piece.renderKey,
          transform: "translate(" + xPosition + "," + yPosition + ")"
        },
        type.customMark(_extends({}, piece.data, piece), i)
      ) : _extends({
        className: classFn(piece.data, i),
        markType: "rect",
        renderMode: renderValue,
        key: "piece-" + piece.renderKey,
        height: actualCircleRadius * 2,
        width: actualCircleRadius * 2,
        x: xPosition - actualCircleRadius,
        y: yPosition - actualCircleRadius,
        rx: actualCircleRadius,
        ry: actualCircleRadius,
        style: styleFn(piece.data, ordsetI)
      }, eventListeners);

      var calculatedPiece = {
        o: key,
        xy: {
          x: xPosition,
          y: yPosition
        },
        piece: piece,
        renderElement: renderElementObject
      };

      return calculatedPiece;
    });
    allCalculatedPieces = [].concat(_toConsumableArray(allCalculatedPieces), _toConsumableArray(calculatedPieces));
  });

  return allCalculatedPieces;
}

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  var nodes;

  if (x == null) x = 0;
  if (y == null) y = 0;

  function force() {
    var i,
        n = nodes.length,
        node,
        sx = 0,
        sy = 0;

    for (i = 0; i < n; ++i) {
      node = nodes[i], sx += node.x, sy += node.y;
    }

    for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
      node = nodes[i], node.x -= sx, node.y -= sy;
    }
  }

  force.initialize = function(_) {
    nodes = _;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
});


/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_quadtree__ = __webpack_require__(72);




function x(d) {
  return d.x + d.vx;
}

function y(d) {
  return d.y + d.vy;
}

/* harmony default export */ __webpack_exports__["a"] = (function(radius) {
  var nodes,
      radii,
      strength = 1,
      iterations = 1;

  if (typeof radius !== "function") radius = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(radius == null ? 1 : +radius);

  function force() {
    var i, n = nodes.length,
        tree,
        node,
        xi,
        yi,
        ri,
        ri2;

    for (var k = 0; k < iterations; ++k) {
      tree = Object(__WEBPACK_IMPORTED_MODULE_2_d3_quadtree__["a" /* quadtree */])(nodes, x, y).visitAfter(prepare);
      for (i = 0; i < n; ++i) {
        node = nodes[i];
        ri = radii[i], ri2 = ri * ri;
        xi = node.x + node.vx;
        yi = node.y + node.vy;
        tree.visit(apply);
      }
    }

    function apply(quad, x0, y0, x1, y1) {
      var data = quad.data, rj = quad.r, r = ri + rj;
      if (data) {
        if (data.index > i) {
          var x = xi - data.x - data.vx,
              y = yi - data.y - data.vy,
              l = x * x + y * y;
          if (l < r * r) {
            if (x === 0) x = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += x * x;
            if (y === 0) y = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += y * y;
            l = (r - (l = Math.sqrt(l))) / l * strength;
            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
            node.vy += (y *= l) * r;
            data.vx -= x * (r = 1 - r);
            data.vy -= y * r;
          }
        }
        return;
      }
      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
    }
  }

  function prepare(quad) {
    if (quad.data) return quad.r = radii[quad.data.index];
    for (var i = quad.r = 0; i < 4; ++i) {
      if (quad[i] && quad[i].r > quad.r) {
        quad.r = quad[i].r;
      }
    }
  }

  force.initialize = function(_) {
    var i, n = (nodes = _).length; radii = new Array(n);
    for (i = 0; i < n; ++i) radii[i] = +radius(nodes[i], i, nodes);
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = +_, force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), force) : radius;
  };

  return force;
});


/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_collection__ = __webpack_require__(134);




function index(d, i) {
  return i;
}

/* harmony default export */ __webpack_exports__["a"] = (function(links) {
  var id = index,
      strength = defaultStrength,
      strengths,
      distance = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(30),
      distances,
      nodes,
      count,
      bias,
      iterations = 1;

  if (links == null) links = [];

  function defaultStrength(link) {
    return 1 / Math.min(count[link.source.index], count[link.target.index]);
  }

  function force(alpha) {
    for (var k = 0, n = links.length; k < iterations; ++k) {
      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
        link = links[i], source = link.source, target = link.target;
        x = target.x + target.vx - source.x - source.vx || Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])();
        y = target.y + target.vy - source.y - source.vy || Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])();
        l = Math.sqrt(x * x + y * y);
        l = (l - distances[i]) / l * alpha * strengths[i];
        x *= l, y *= l;
        target.vx -= x * (b = bias[i]);
        target.vy -= y * b;
        source.vx += x * (b = 1 - b);
        source.vy += y * b;
      }
    }
  }

  function initialize() {
    if (!nodes) return;

    var i,
        n = nodes.length,
        m = links.length,
        nodeById = Object(__WEBPACK_IMPORTED_MODULE_2_d3_collection__["map"])(nodes, id),
        link;

    for (i = 0, count = new Array(n); i < n; ++i) {
      count[i] = 0;
    }

    for (i = 0; i < m; ++i) {
      link = links[i], link.index = i;
      if (typeof link.source !== "object") link.source = nodeById.get(link.source);
      if (typeof link.target !== "object") link.target = nodeById.get(link.target);
      ++count[link.source.index], ++count[link.target.index];
    }

    for (i = 0, bias = new Array(m); i < m; ++i) {
      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
    }

    strengths = new Array(m), initializeStrength();
    distances = new Array(m), initializeDistance();
  }

  function initializeStrength() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      strengths[i] = +strength(links[i], i, links);
    }
  }

  function initializeDistance() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      distances[i] = +distance(links[i], i, links);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.links = function(_) {
    return arguments.length ? (links = _, initialize(), force) : links;
  };

  force.id = function(_) {
    return arguments.length ? (id = _, force) : id;
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initializeStrength(), force) : strength;
  };

  force.distance = function(_) {
    return arguments.length ? (distance = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initializeDistance(), force) : distance;
  };

  return force;
});


/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jiggle__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_quadtree__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__simulation__ = __webpack_require__(477);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes,
      node,
      alpha,
      strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(-30),
      strengths,
      distanceMin2 = 1,
      distanceMax2 = Infinity,
      theta2 = 0.81;

  function force(_) {
    var i, n = nodes.length, tree = Object(__WEBPACK_IMPORTED_MODULE_2_d3_quadtree__["a" /* quadtree */])(nodes, __WEBPACK_IMPORTED_MODULE_3__simulation__["b" /* x */], __WEBPACK_IMPORTED_MODULE_3__simulation__["c" /* y */]).visitAfter(accumulate);
    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    for (i = 0; i < n; ++i) strengths[i] = +strength(nodes[i], i, nodes);
  }

  function accumulate(quad) {
    var strength = 0, q, c, x, y, i;

    // For internal nodes, accumulate forces from child quadrants.
    if (quad.length) {
      for (x = y = i = 0; i < 4; ++i) {
        if ((q = quad[i]) && (c = q.value)) {
          strength += c, x += c * q.x, y += c * q.y;
        }
      }
      quad.x = x / strength;
      quad.y = y / strength;
    }

    // For leaf nodes, accumulate forces from coincident quadrants.
    else {
      q = quad;
      q.x = q.data.x;
      q.y = q.data.y;
      do strength += strengths[q.data.index];
      while (q = q.next);
    }

    quad.value = strength;
  }

  function apply(quad, x1, _, x2) {
    if (!quad.value) return true;

    var x = quad.x - node.x,
        y = quad.y - node.y,
        w = x2 - x1,
        l = x * x + y * y;

    // Apply the Barnes-Hut approximation if possible.
    // Limit forces for very close nodes; randomize direction if coincident.
    if (w * w / theta2 < l) {
      if (l < distanceMax2) {
        if (x === 0) x = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += x * x;
        if (y === 0) y = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += y * y;
        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        node.vx += x * quad.value * alpha / l;
        node.vy += y * quad.value * alpha / l;
      }
      return true;
    }

    // Otherwise, process points directly.
    else if (quad.length || l >= distanceMax2) return;

    // Limit forces for very close nodes; randomize direction if coincident.
    if (quad.data !== node || quad.next) {
      if (x === 0) x = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += x * x;
      if (y === 0) y = Object(__WEBPACK_IMPORTED_MODULE_1__jiggle__["a" /* default */])(), l += y * y;
      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
    }

    do if (quad.data !== node) {
      w = strengths[quad.data.index] * alpha / l;
      node.vx += x * w;
      node.vy += y * w;
    } while (quad = quad.next);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.distanceMin = function(_) {
    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
  };

  force.distanceMax = function(_) {
    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
  };

  force.theta = function(_) {
    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
  };

  return force;
});


/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  var strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0.1),
      nodes,
      strengths,
      xz;

  if (typeof x !== "function") x = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(x == null ? 0 : +x);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    xz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : x;
  };

  return force;
});


/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = (function(y) {
  var strength = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0.1),
      nodes,
      strengths,
      yz;

  if (typeof y !== "function") y = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(y == null ? 0 : +y);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    yz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : strength;
  };

  force.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), initialize(), force) : y;
  };

  return force;
});


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = __webpack_require__(1258);

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

var
  Path = __webpack_require__(1259);

module.exports = caster;

function caster(path) {
  return new Path(path).getBoundingBox();
}

caster.Path = Path;

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

var
  BoundingBox = __webpack_require__(1260),
  BoundingBoxView = __webpack_require__(1261),
  SvgPath = __webpack_require__(1262);

module.exports = Path;

function Path(d) {
  this.d = d;
}

Path.prototype = {

  getBoundingBox: function() {
    var
      pathDriver,
      boundingBox;

    pathDriver = new SvgPath(this.d);
    boundingBox = new BoundingBox();

    pathDriver
      .abs()
      .unarc()
      .unshort()
      .iterate(function(seg, index, x, y) {

        switch(seg[0]) {
          case 'M':
          case 'L':
            boundingBox.addPoint(
              seg[1],
              seg[2]
            );
            break;
          case 'H':
            boundingBox.addX(seg[1]);
            break;
          case 'V':
            boundingBox.addY(seg[1]);
            break;
          case 'Q':
            boundingBox.addQuadraticCurve(
              x,
              y,
              seg[1],
              seg[2],
              seg[3],
              seg[4]
            );
            break;
          case 'C':
            boundingBox.addBezierCurve(
              x,
              y,
              seg[1],
              seg[2],
              seg[3],
              seg[4],
              seg[5],
              seg[6]
            );
            break;
        }

      });

    return new BoundingBoxView(boundingBox);
  }

};


/***/ }),
/* 1260 */
/***/ (function(module, exports) {

module.exports = BoundingBox;

// from https://github.com/gabelerner/canvg/blob/860e418aca67b9a41e858a223d74d375793ec364/canvg.js#L449

function BoundingBox(x1, y1, x2, y2) { // pass in initial points if you want
  this.x1 = Number.NaN;
  this.y1 = Number.NaN;
  this.x2 = Number.NaN;
  this.y2 = Number.NaN;

  this.addPoint(x1, y1);
  this.addPoint(x2, y2);
}

BoundingBox.prototype = {

  width: function () {
    return this.x2 - this.x1;
  },

  height: function () {
    return this.y2 - this.y1;
  },

  addPoint: function (x, y) {
    if (x != null) {
      if (isNaN(this.x1) || isNaN(this.x2)) {
        this.x1 = x;
        this.x2 = x;
      }
      if (x < this.x1) this.x1 = x;
      if (x > this.x2) this.x2 = x;
    }

    if (y != null) {
      if (isNaN(this.y1) || isNaN(this.y2)) {
        this.y1 = y;
        this.y2 = y;
      }
      if (y < this.y1) this.y1 = y;
      if (y > this.y2) this.y2 = y;
    }
  },

  addX: function (x) {
    this.addPoint(x, null);
  },

  addY: function (y) {
    this.addPoint(null, y);
  },

  addQuadraticCurve: function (p0x, p0y, p1x, p1y, p2x, p2y) {
    var cp1x = p0x + 2 / 3 * (p1x - p0x); // CP1 = QP0 + 2/3 *(QP1-QP0)
    var cp1y = p0y + 2 / 3 * (p1y - p0y); // CP1 = QP0 + 2/3 *(QP1-QP0)
    var cp2x = cp1x + 1 / 3 * (p2x - p0x); // CP2 = CP1 + 1/3 *(QP2-QP0)
    var cp2y = cp1y + 1 / 3 * (p2y - p0y); // CP2 = CP1 + 1/3 *(QP2-QP0)
    this.addBezierCurve(p0x, p0y, cp1x, cp2x, cp1y, cp2y, p2x, p2y);
  },

  addBezierCurve: function (p0x, p0y, p1x, p1y, p2x, p2y, p3x, p3y) {
    // from http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
    var
      i,
      p0 = [p0x, p0y],
      p1 = [p1x, p1y],
      p2 = [p2x, p2y],
      p3 = [p3x, p3y];

    this.addPoint(p0[0], p0[1]);
    this.addPoint(p3[0], p3[1]);

    for (i = 0; i <= 1; i++) {
      var f = function (t) {
        return Math.pow(1 - t, 3) * p0[i]
          + 3 * Math.pow(1 - t, 2) * t * p1[i]
          + 3 * (1 - t) * Math.pow(t, 2) * p2[i]
          + Math.pow(t, 3) * p3[i];
      };

      var b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
      var a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
      var c = 3 * p1[i] - 3 * p0[i];

      if (a == 0) {
        if (b == 0) continue;
        var t = -c / b;
        if (0 < t && t < 1) {
          if (i == 0) this.addX(f(t));
          if (i == 1) this.addY(f(t));
        }
        continue;
      }

      var b2ac = Math.pow(b, 2) - 4 * c * a;
      if (b2ac < 0) continue;
      var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
      if (0 < t1 && t1 < 1) {
        if (i == 0) this.addX(f(t1));
        if (i == 1) this.addY(f(t1));
      }
      var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
      if (0 < t2 && t2 < 1) {
        if (i == 0) this.addX(f(t2));
        if (i == 1) this.addY(f(t2));
      }
    }
  }

};



/***/ }),
/* 1261 */
/***/ (function(module, exports) {


module.exports = BoundingBoxView;

function BoundingBoxView(boundingBox) {

  this.x1 = this.minX = boundingBox.x1 || 0;
  this.y1 = this.minY = boundingBox.y1 || 0;
  this.x2 = this.maxX = boundingBox.x2 || 0;
  this.y2 = this.maxY = boundingBox.y2 || 0;
  this.width = boundingBox.width() || 0;
  this.height = boundingBox.height() || 0;

}

BoundingBoxView.prototype = {

  round: function(precision) {
    precision = precision || 0;

    this.x1 = this.minX = +this.x1.toFixed(precision);
    this.y1 = this.minY = +this.y1.toFixed(precision);
    this.x2 = this.maxX = +this.x2.toFixed(precision);
    this.y2 = this.maxY = +this.y2.toFixed(precision);
    this.width = +this.width.toFixed(precision);
    this.height = +this.height.toFixed(precision);

    return this;
  },

  scale: function(scale) {
    var
      self = this;

    scale = scale || 1;

    [
      'x1',
      'minX',
      'y1',
      'minY',
      'x2',
      'maxX',
      'y2',
      'maxY',
      'width',
      'height'
    ]
      .forEach(function(name) {
        self[name] = self[name] * scale;
      });

    return this;
  },

  toString: function() {
    return [
      this.minX,
      this.minY,
      this.width,
      this.height
    ]
      .join(' ');
  }

};

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1263);


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// SVG Path transformations library
//
// Usage:
//
//    SvgPath('...')
//      .translate(-150, -100)
//      .scale(0.5)
//      .translate(-150, -100)
//      .toFixed(1)
//      .toString()
//




var pathParse      = __webpack_require__(1264);
var transformParse = __webpack_require__(1265);
var matrix         = __webpack_require__(478);
var a2c            = __webpack_require__(1266);
var ellipse        = __webpack_require__(1267);


// Class constructor
//
function SvgPath(path) {
  if (!(this instanceof SvgPath)) { return new SvgPath(path); }

  var pstate = pathParse(path);

  // Array of path segments.
  // Each segment is array [command, param1, param2, ...]
  this.segments = pstate.segments;

  // Error message on parse error.
  this.err      = pstate.err;

  // Transforms stack for lazy evaluation
  this.__stack    = [];
}


SvgPath.prototype.__matrix = function (m) {
  var self = this, i;

  // Quick leave for empty matrix
  if (!m.queue.length) { return; }

  this.iterate(function (s, index, x, y) {
    var p, result, name, isRelative;

    switch (s[0]) {

      // Process 'assymetric' commands separately
      case 'v':
        p      = m.calc(0, s[1], true);
        result = (p[0] === 0) ? [ 'v', p[1] ] : [ 'l', p[0], p[1] ];
        break;

      case 'V':
        p      = m.calc(x, s[1], false);
        result = (p[0] === m.calc(x, y, false)[0]) ? [ 'V', p[1] ] : [ 'L', p[0], p[1] ];
        break;

      case 'h':
        p      = m.calc(s[1], 0, true);
        result = (p[1] === 0) ? [ 'h', p[0] ] : [ 'l', p[0], p[1] ];
        break;

      case 'H':
        p      = m.calc(s[1], y, false);
        result = (p[1] === m.calc(x, y, false)[1]) ? [ 'H', p[0] ] : [ 'L', p[0], p[1] ];
        break;

      case 'a':
      case 'A':
        // ARC is: ['A', rx, ry, x-axis-rotation, large-arc-flag, sweep-flag, x, y]

        // Drop segment if arc is empty (end point === start point)
        /*if ((s[0] === 'A' && s[6] === x && s[7] === y) ||
            (s[0] === 'a' && s[6] === 0 && s[7] === 0)) {
          return [];
        }*/

        // Transform rx, ry and the x-axis-rotation
        var ma = m.toArray();
        var e = ellipse(s[1], s[2], s[3]).transform(ma);

        // flip sweep-flag if matrix is not orientation-preserving
        if (ma[0] * ma[3] - ma[1] * ma[2] < 0) {
          s[5] = s[5] ? '0' : '1';
        }

        // Transform end point as usual (without translation for relative notation)
        p = m.calc(s[6], s[7], s[0] === 'a');

        // Empty arcs can be ignored by renderer, but should not be dropped
        // to avoid collisions with `S A S` and so on. Replace with empty line.
        if ((s[0] === 'A' && s[6] === x && s[7] === y) ||
            (s[0] === 'a' && s[6] === 0 && s[7] === 0)) {
          result = [ s[0] === 'a' ? 'l' : 'L', p[0], p[1] ];
          break;
        }

        // if the resulting ellipse is (almost) a segment ...
        if (e.isDegenerate()) {
          // replace the arc by a line
          result = [ s[0] === 'a' ? 'l' : 'L', p[0], p[1] ];
        } else {
          // if it is a real ellipse
          // s[0], s[4] and s[5] are not modified
          result = [ s[0], e.rx, e.ry, e.ax, s[4], s[5], p[0], p[1] ];
        }

        break;

      case 'm':
        // Edge case. The very first `m` should be processed as absolute, if happens.
        // Make sense for coord shift transforms.
        isRelative = index > 0;

        p = m.calc(s[1], s[2], isRelative);
        result = [ 'm', p[0], p[1] ];
        break;

      default:
        name       = s[0];
        result     = [ name ];
        isRelative = (name.toLowerCase() === name);

        // Apply transformations to the segment
        for (i = 1; i < s.length; i += 2) {
          p = m.calc(s[i], s[i + 1], isRelative);
          result.push(p[0], p[1]);
        }
    }

    self.segments[index] = result;
  }, true);
};


// Apply stacked commands
//
SvgPath.prototype.__evaluateStack = function () {
  var m, i;

  if (!this.__stack.length) { return; }

  if (this.__stack.length === 1) {
    this.__matrix(this.__stack[0]);
    this.__stack = [];
    return;
  }

  m = matrix();
  i = this.__stack.length;

  while (--i >= 0) {
    m.matrix(this.__stack[i].toArray());
  }

  this.__matrix(m);
  this.__stack = [];
};


// Convert processed SVG Path back to string
//
SvgPath.prototype.toString = function () {
  var elements = [], skipCmd, cmd;

  this.__evaluateStack();

  for (var i = 0; i < this.segments.length; i++) {
    // remove repeating commands names
    cmd = this.segments[i][0];
    skipCmd = i > 0 && cmd !== 'm' && cmd !== 'M' && cmd === this.segments[i - 1][0];
    elements = elements.concat(skipCmd ? this.segments[i].slice(1) : this.segments[i]);
  }

  return elements.join(' ')
            // Optimizations: remove spaces around commands & before `-`
            //
            // We could also remove leading zeros for `0.5`-like values,
            // but their count is too small to spend time for.
            .replace(/ ?([achlmqrstvz]) ?/gi, '$1')
            .replace(/ \-/g, '-')
            // workaround for FontForge SVG importing bug
            .replace(/zm/g, 'z m');
};


// Translate path to (x [, y])
//
SvgPath.prototype.translate = function (x, y) {
  this.__stack.push(matrix().translate(x, y || 0));
  return this;
};


// Scale path to (sx [, sy])
// sy = sx if not defined
//
SvgPath.prototype.scale = function (sx, sy) {
  this.__stack.push(matrix().scale(sx, (!sy && (sy !== 0)) ? sx : sy));
  return this;
};


// Rotate path around point (sx [, sy])
// sy = sx if not defined
//
SvgPath.prototype.rotate = function (angle, rx, ry) {
  this.__stack.push(matrix().rotate(angle, rx || 0, ry || 0));
  return this;
};


// Skew path along the X axis by `degrees` angle
//
SvgPath.prototype.skewX = function (degrees) {
  this.__stack.push(matrix().skewX(degrees));
  return this;
};


// Skew path along the Y axis by `degrees` angle
//
SvgPath.prototype.skewY = function (degrees) {
  this.__stack.push(matrix().skewY(degrees));
  return this;
};


// Apply matrix transform (array of 6 elements)
//
SvgPath.prototype.matrix = function (m) {
  this.__stack.push(matrix().matrix(m));
  return this;
};


// Transform path according to "transform" attr of SVG spec
//
SvgPath.prototype.transform = function (transformString) {
  if (!transformString.trim()) {
    return this;
  }
  this.__stack.push(transformParse(transformString));
  return this;
};


// Round coords with given decimal precition.
// 0 by default (to integers)
//
SvgPath.prototype.round = function (d) {
  var contourStartDeltaX = 0, contourStartDeltaY = 0, deltaX = 0, deltaY = 0, l;

  d = d || 0;

  this.__evaluateStack();

  this.segments.forEach(function (s) {
    var isRelative = (s[0].toLowerCase() === s[0]);

    switch (s[0]) {
      case 'H':
      case 'h':
        if (isRelative) { s[1] += deltaX; }
        deltaX = s[1] - s[1].toFixed(d);
        s[1] = +s[1].toFixed(d);
        return;

      case 'V':
      case 'v':
        if (isRelative) { s[1] += deltaY; }
        deltaY = s[1] - s[1].toFixed(d);
        s[1] = +s[1].toFixed(d);
        return;

      case 'Z':
      case 'z':
        deltaX = contourStartDeltaX;
        deltaY = contourStartDeltaY;
        return;

      case 'M':
      case 'm':
        if (isRelative) {
          s[1] += deltaX;
          s[2] += deltaY;
        }

        deltaX = s[1] - s[1].toFixed(d);
        deltaY = s[2] - s[2].toFixed(d);

        contourStartDeltaX = deltaX;
        contourStartDeltaY = deltaY;

        s[1] = +s[1].toFixed(d);
        s[2] = +s[2].toFixed(d);
        return;

      case 'A':
      case 'a':
        // [cmd, rx, ry, x-axis-rotation, large-arc-flag, sweep-flag, x, y]
        if (isRelative) {
          s[6] += deltaX;
          s[7] += deltaY;
        }

        deltaX = s[6] - s[6].toFixed(d);
        deltaY = s[7] - s[7].toFixed(d);

        s[1] = +s[1].toFixed(d);
        s[2] = +s[2].toFixed(d);
        s[3] = +s[3].toFixed(d + 2); // better precision for rotation
        s[6] = +s[6].toFixed(d);
        s[7] = +s[7].toFixed(d);
        return;

      default:
        // a c l q s t
        l = s.length;

        if (isRelative) {
          s[l - 2] += deltaX;
          s[l - 1] += deltaY;
        }

        deltaX = s[l - 2] - s[l - 2].toFixed(d);
        deltaY = s[l - 1] - s[l - 1].toFixed(d);

        s.forEach(function (val, i) {
          if (!i) { return; }
          s[i] = +s[i].toFixed(d);
        });
        return;
    }
  });

  return this;
};


// Apply iterator function to all segments. If function returns result,
// current segment will be replaced to array of returned segments.
// If empty array is returned, current regment will be deleted.
//
SvgPath.prototype.iterate = function (iterator, keepLazyStack) {
  var segments = this.segments,
      replacements = {},
      needReplace = false,
      lastX = 0,
      lastY = 0,
      countourStartX = 0,
      countourStartY = 0;
  var i, j, newSegments;

  if (!keepLazyStack) {
    this.__evaluateStack();
  }

  segments.forEach(function (s, index) {

    var res = iterator(s, index, lastX, lastY);

    if (Array.isArray(res)) {
      replacements[index] = res;
      needReplace = true;
    }

    var isRelative = (s[0] === s[0].toLowerCase());

    // calculate absolute X and Y
    switch (s[0]) {
      case 'm':
      case 'M':
        lastX = s[1] + (isRelative ? lastX : 0);
        lastY = s[2] + (isRelative ? lastY : 0);
        countourStartX = lastX;
        countourStartY = lastY;
        return;

      case 'h':
      case 'H':
        lastX = s[1] + (isRelative ? lastX : 0);
        return;

      case 'v':
      case 'V':
        lastY = s[1] + (isRelative ? lastY : 0);
        return;

      case 'z':
      case 'Z':
        // That make sence for multiple contours
        lastX = countourStartX;
        lastY = countourStartY;
        return;

      default:
        lastX = s[s.length - 2] + (isRelative ? lastX : 0);
        lastY = s[s.length - 1] + (isRelative ? lastY : 0);
    }
  });

  // Replace segments if iterator return results

  if (!needReplace) { return this; }

  newSegments = [];

  for (i = 0; i < segments.length; i++) {
    if (typeof replacements[i] !== 'undefined') {
      for (j = 0; j < replacements[i].length; j++) {
        newSegments.push(replacements[i][j]);
      }
    } else {
      newSegments.push(segments[i]);
    }
  }

  this.segments = newSegments;

  return this;
};


// Converts segments from relative to absolute
//
SvgPath.prototype.abs = function () {

  this.iterate(function (s, index, x, y) {
    var name = s[0],
        nameUC = name.toUpperCase(),
        i;

    // Skip absolute commands
    if (name === nameUC) { return; }

    s[0] = nameUC;

    switch (name) {
      case 'v':
        // v has shifted coords parity
        s[1] += y;
        return;

      case 'a':
        // ARC is: ['A', rx, ry, x-axis-rotation, large-arc-flag, sweep-flag, x, y]
        // touch x, y only
        s[6] += x;
        s[7] += y;
        return;

      default:
        for (i = 1; i < s.length; i++) {
          s[i] += i % 2 ? x : y; // odd values are X, even - Y
        }
    }
  }, true);

  return this;
};


// Converts segments from absolute to relative
//
SvgPath.prototype.rel = function () {

  this.iterate(function (s, index, x, y) {
    var name = s[0],
        nameLC = name.toLowerCase(),
        i;

    // Skip relative commands
    if (name === nameLC) { return; }

    // Don't touch the first M to avoid potential confusions.
    if (index === 0 && name === 'M') { return; }

    s[0] = nameLC;

    switch (name) {
      case 'V':
        // V has shifted coords parity
        s[1] -= y;
        return;

      case 'A':
        // ARC is: ['A', rx, ry, x-axis-rotation, large-arc-flag, sweep-flag, x, y]
        // touch x, y only
        s[6] -= x;
        s[7] -= y;
        return;

      default:
        for (i = 1; i < s.length; i++) {
          s[i] -= i % 2 ? x : y; // odd values are X, even - Y
        }
    }
  }, true);

  return this;
};


// Converts arcs to cubic bézier curves
//
SvgPath.prototype.unarc = function () {
  this.iterate(function (s, index, x, y) {
    var new_segments, nextX, nextY, result = [], name = s[0];

    // Skip anything except arcs
    if (name !== 'A' && name !== 'a') { return null; }

    if (name === 'a') {
      // convert relative arc coordinates to absolute
      nextX = x + s[6];
      nextY = y + s[7];
    } else {
      nextX = s[6];
      nextY = s[7];
    }

    new_segments = a2c(x, y, nextX, nextY, s[4], s[5], s[1], s[2], s[3]);

    // Degenerated arcs can be ignored by renderer, but should not be dropped
    // to avoid collisions with `S A S` and so on. Replace with empty line.
    if (new_segments.length === 0) {
      return [ [ s[0] === 'a' ? 'l' : 'L', s[6], s[7] ] ];
    }

    new_segments.forEach(function (s) {
      result.push([ 'C', s[2], s[3], s[4], s[5], s[6], s[7] ]);
    });

    return result;
  });

  return this;
};


// Converts smooth curves (with missed control point) to generic curves
//
SvgPath.prototype.unshort = function () {
  var segments = this.segments;
  var prevControlX, prevControlY, prevSegment;
  var curControlX, curControlY;

  // TODO: add lazy evaluation flag when relative commands supported

  this.iterate(function (s, idx, x, y) {
    var name = s[0], nameUC = name.toUpperCase(), isRelative;

    // First command MUST be M|m, it's safe to skip.
    // Protect from access to [-1] for sure.
    if (!idx) { return; }

    if (nameUC === 'T') { // quadratic curve
      isRelative = (name === 't');

      prevSegment = segments[idx - 1];

      if (prevSegment[0] === 'Q') {
        prevControlX = prevSegment[1] - x;
        prevControlY = prevSegment[2] - y;
      } else if (prevSegment[0] === 'q') {
        prevControlX = prevSegment[1] - prevSegment[3];
        prevControlY = prevSegment[2] - prevSegment[4];
      } else {
        prevControlX = 0;
        prevControlY = 0;
      }

      curControlX = -prevControlX;
      curControlY = -prevControlY;

      if (!isRelative) {
        curControlX += x;
        curControlY += y;
      }

      segments[idx] = [
        isRelative ? 'q' : 'Q',
        curControlX, curControlY,
        s[1], s[2]
      ];

    } else if (nameUC === 'S') { // cubic curve
      isRelative = (name === 's');

      prevSegment = segments[idx - 1];

      if (prevSegment[0] === 'C') {
        prevControlX = prevSegment[3] - x;
        prevControlY = prevSegment[4] - y;
      } else if (prevSegment[0] === 'c') {
        prevControlX = prevSegment[3] - prevSegment[5];
        prevControlY = prevSegment[4] - prevSegment[6];
      } else {
        prevControlX = 0;
        prevControlY = 0;
      }

      curControlX = -prevControlX;
      curControlY = -prevControlY;

      if (!isRelative) {
        curControlX += x;
        curControlY += y;
      }

      segments[idx] = [
        isRelative ? 'c' : 'C',
        curControlX, curControlY,
        s[1], s[2], s[3], s[4]
      ];
    }
  });

  return this;
};


module.exports = SvgPath;


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var paramCounts = { a: 7, c: 6, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, z: 0 };

var SPECIAL_SPACES = [
  0x1680, 0x180E, 0x2000, 0x2001, 0x2002, 0x2003, 0x2004, 0x2005, 0x2006,
  0x2007, 0x2008, 0x2009, 0x200A, 0x202F, 0x205F, 0x3000, 0xFEFF
];

function isSpace(ch) {
  return (ch === 0x0A) || (ch === 0x0D) || (ch === 0x2028) || (ch === 0x2029) || // Line terminators
    // White spaces
    (ch === 0x20) || (ch === 0x09) || (ch === 0x0B) || (ch === 0x0C) || (ch === 0xA0) ||
    (ch >= 0x1680 && SPECIAL_SPACES.indexOf(ch) >= 0);
}

function isCommand(code) {
  /*eslint-disable no-bitwise*/
  switch (code | 0x20) {
    case 0x6D/* m */:
    case 0x7A/* z */:
    case 0x6C/* l */:
    case 0x68/* h */:
    case 0x76/* v */:
    case 0x63/* c */:
    case 0x73/* s */:
    case 0x71/* q */:
    case 0x74/* t */:
    case 0x61/* a */:
    case 0x72/* r */:
      return true;
  }
  return false;
}

function isDigit(code) {
  return (code >= 48 && code <= 57);   // 0..9
}

function isDigitStart(code) {
  return (code >= 48 && code <= 57) || /* 0..9 */
          code === 0x2B || /* + */
          code === 0x2D || /* - */
          code === 0x2E;   /* . */
}


function State(path) {
  this.index  = 0;
  this.path   = path;
  this.max    = path.length;
  this.result = [];
  this.param  = 0.0;
  this.err    = '';
  this.segmentStart = 0;
  this.data   = [];
}

function skipSpaces(state) {
  while (state.index < state.max && isSpace(state.path.charCodeAt(state.index))) {
    state.index++;
  }
}


function scanParam(state) {
  var start = state.index,
      index = start,
      max = state.max,
      zeroFirst = false,
      hasCeiling = false,
      hasDecimal = false,
      hasDot = false,
      ch;

  if (index >= max) {
    state.err = 'SvgPath: missed param (at pos ' + index + ')';
    return;
  }
  ch = state.path.charCodeAt(index);

  if (ch === 0x2B/* + */ || ch === 0x2D/* - */) {
    index++;
    ch = (index < max) ? state.path.charCodeAt(index) : 0;
  }

  // This logic is shamelessly borrowed from Esprima
  // https://github.com/ariya/esprimas
  //
  if (!isDigit(ch) && ch !== 0x2E/* . */) {
    state.err = 'SvgPath: param should start with 0..9 or `.` (at pos ' + index + ')';
    return;
  }

  if (ch !== 0x2E/* . */) {
    zeroFirst = (ch === 0x30/* 0 */);
    index++;

    ch = (index < max) ? state.path.charCodeAt(index) : 0;

    if (zeroFirst && index < max) {
      // decimal number starts with '0' such as '09' is illegal.
      if (ch && isDigit(ch)) {
        state.err = 'SvgPath: numbers started with `0` such as `09` are ilegal (at pos ' + start + ')';
        return;
      }
    }

    while (index < max && isDigit(state.path.charCodeAt(index))) {
      index++;
      hasCeiling = true;
    }
    ch = (index < max) ? state.path.charCodeAt(index) : 0;
  }

  if (ch === 0x2E/* . */) {
    hasDot = true;
    index++;
    while (isDigit(state.path.charCodeAt(index))) {
      index++;
      hasDecimal = true;
    }
    ch = (index < max) ? state.path.charCodeAt(index) : 0;
  }

  if (ch === 0x65/* e */ || ch === 0x45/* E */) {
    if (hasDot && !hasCeiling && !hasDecimal) {
      state.err = 'SvgPath: invalid float exponent (at pos ' + index + ')';
      return;
    }

    index++;

    ch = (index < max) ? state.path.charCodeAt(index) : 0;
    if (ch === 0x2B/* + */ || ch === 0x2D/* - */) {
      index++;
    }
    if (index < max && isDigit(state.path.charCodeAt(index))) {
      while (index < max && isDigit(state.path.charCodeAt(index))) {
        index++;
      }
    } else {
      state.err = 'SvgPath: invalid float exponent (at pos ' + index + ')';
      return;
    }
  }

  state.index = index;
  state.param = parseFloat(state.path.slice(start, index)) + 0.0;
}


function finalizeSegment(state) {
  var cmd, cmdLC;

  // Process duplicated commands (without comand name)

  // This logic is shamelessly borrowed from Raphael
  // https://github.com/DmitryBaranovskiy/raphael/
  //
  cmd   = state.path[state.segmentStart];
  cmdLC = cmd.toLowerCase();

  var params = state.data;

  if (cmdLC === 'm' && params.length > 2) {
    state.result.push([ cmd, params[0], params[1] ]);
    params = params.slice(2);
    cmdLC = 'l';
    cmd = (cmd === 'm') ? 'l' : 'L';
  }

  if (cmdLC === 'r') {
    state.result.push([ cmd ].concat(params));
  } else {

    while (params.length >= paramCounts[cmdLC]) {
      state.result.push([ cmd ].concat(params.splice(0, paramCounts[cmdLC])));
      if (!paramCounts[cmdLC]) {
        break;
      }
    }
  }
}


function scanSegment(state) {
  var max = state.max,
      cmdCode, comma_found, need_params, i;

  state.segmentStart = state.index;
  cmdCode = state.path.charCodeAt(state.index);

  if (!isCommand(cmdCode)) {
    state.err = 'SvgPath: bad command ' + state.path[state.index] + ' (at pos ' + state.index + ')';
    return;
  }

  need_params = paramCounts[state.path[state.index].toLowerCase()];

  state.index++;
  skipSpaces(state);

  state.data = [];

  if (!need_params) {
    // Z
    finalizeSegment(state);
    return;
  }

  comma_found = false;

  for (;;) {
    for (i = need_params; i > 0; i--) {
      scanParam(state);
      if (state.err.length) {
        return;
      }
      state.data.push(state.param);

      skipSpaces(state);
      comma_found = false;

      if (state.index < max && state.path.charCodeAt(state.index) === 0x2C/* , */) {
        state.index++;
        skipSpaces(state);
        comma_found = true;
      }
    }

    // after ',' param is mandatory
    if (comma_found) {
      continue;
    }

    if (state.index >= state.max) {
      break;
    }

    // Stop on next segment
    if (!isDigitStart(state.path.charCodeAt(state.index))) {
      break;
    }
  }

  finalizeSegment(state);
}


/* Returns array of segments:
 *
 * [
 *   [ command, coord1, coord2, ... ]
 * ]
 */
module.exports = function pathParse(svgPath) {
  var state = new State(svgPath);
  var max = state.max;

  skipSpaces(state);

  while (state.index < max && !state.err.length) {
    scanSegment(state);
  }

  if (state.err.length) {
    state.result = [];

  } else if (state.result.length) {

    if ('mM'.indexOf(state.result[0][0]) < 0) {
      state.err = 'SvgPath: string should start with `M` or `m`';
      state.result = [];
    } else {
      state.result[0][0] = 'M';
    }
  }

  return {
    err: state.err,
    segments: state.result
  };
};


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var Matrix = __webpack_require__(478);

var operations = {
  matrix: true,
  scale: true,
  rotate: true,
  translate: true,
  skewX: true,
  skewY: true
};

var CMD_SPLIT_RE    = /\s*(matrix|translate|scale|rotate|skewX|skewY)\s*\(\s*(.+?)\s*\)[\s,]*/;
var PARAMS_SPLIT_RE = /[\s,]+/;


module.exports = function transformParse(transformString) {
  var matrix = new Matrix();
  var cmd, params;

  // Split value into ['', 'translate', '10 50', '', 'scale', '2', '', 'rotate',  '-45', '']
  transformString.split(CMD_SPLIT_RE).forEach(function (item) {

    // Skip empty elements
    if (!item.length) { return; }

    // remember operation
    if (typeof operations[item] !== 'undefined') {
      cmd = item;
      return;
    }

    // extract params & att operation to matrix
    params = item.split(PARAMS_SPLIT_RE).map(function (i) {
      return +i || 0;
    });

    // If params count is not correct - ignore command
    switch (cmd) {
      case 'matrix':
        if (params.length === 6) {
          matrix.matrix(params);
        }
        return;

      case 'scale':
        if (params.length === 1) {
          matrix.scale(params[0], params[0]);
        } else if (params.length === 2) {
          matrix.scale(params[0], params[1]);
        }
        return;

      case 'rotate':
        if (params.length === 1) {
          matrix.rotate(params[0], 0, 0);
        } else if (params.length === 3) {
          matrix.rotate(params[0], params[1], params[2]);
        }
        return;

      case 'translate':
        if (params.length === 1) {
          matrix.translate(params[0], 0);
        } else if (params.length === 2) {
          matrix.translate(params[0], params[1]);
        }
        return;

      case 'skewX':
        if (params.length === 1) {
          matrix.skewX(params[0]);
        }
        return;

      case 'skewY':
        if (params.length === 1) {
          matrix.skewY(params[0]);
        }
        return;
    }
  });

  return matrix;
};


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Convert an arc to a sequence of cubic bézier curves
//



var TAU = Math.PI * 2;


/* eslint-disable space-infix-ops */

// Calculate an angle between two vectors
//
function vector_angle(ux, uy, vx, vy) {
  var sign = (ux * vy - uy * vx < 0) ? -1 : 1;
  var umag = Math.sqrt(ux * ux + uy * uy);
  var vmag = Math.sqrt(ux * ux + uy * uy);
  var dot  = ux * vx + uy * vy;
  var div  = dot / (umag * vmag);

  // rounding errors, e.g. -1.0000000000000002 can screw up this
  if (div >  1.0) { div =  1.0; }
  if (div < -1.0) { div = -1.0; }

  return sign * Math.acos(div);
}


// Convert from endpoint to center parameterization,
// see http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
//
// Return [cx, cy, theta1, delta_theta]
//
function get_arc_center(x1, y1, x2, y2, fa, fs, rx, ry, sin_phi, cos_phi) {
  // Step 1.
  //
  // Moving an ellipse so origin will be the middlepoint between our two
  // points. After that, rotate it to line up ellipse axes with coordinate
  // axes.
  //
  var x1p =  cos_phi*(x1-x2)/2 + sin_phi*(y1-y2)/2;
  var y1p = -sin_phi*(x1-x2)/2 + cos_phi*(y1-y2)/2;

  var rx_sq  =  rx * rx;
  var ry_sq  =  ry * ry;
  var x1p_sq = x1p * x1p;
  var y1p_sq = y1p * y1p;

  // Step 2.
  //
  // Compute coordinates of the centre of this ellipse (cx', cy')
  // in the new coordinate system.
  //
  var radicant = (rx_sq * ry_sq) - (rx_sq * y1p_sq) - (ry_sq * x1p_sq);

  if (radicant < 0) {
    // due to rounding errors it might be e.g. -1.3877787807814457e-17
    radicant = 0;
  }

  radicant /=   (rx_sq * y1p_sq) + (ry_sq * x1p_sq);
  radicant = Math.sqrt(radicant) * (fa === fs ? -1 : 1);

  var cxp = radicant *  rx/ry * y1p;
  var cyp = radicant * -ry/rx * x1p;

  // Step 3.
  //
  // Transform back to get centre coordinates (cx, cy) in the original
  // coordinate system.
  //
  var cx = cos_phi*cxp - sin_phi*cyp + (x1+x2)/2;
  var cy = sin_phi*cxp + cos_phi*cyp + (y1+y2)/2;

  // Step 4.
  //
  // Compute angles (theta1, delta_theta).
  //
  var v1x =  (x1p - cxp) / rx;
  var v1y =  (y1p - cyp) / ry;
  var v2x = (-x1p - cxp) / rx;
  var v2y = (-y1p - cyp) / ry;

  var theta1 = vector_angle(1, 0, v1x, v1y);
  var delta_theta = vector_angle(v1x, v1y, v2x, v2y);

  if (fs === 0 && delta_theta > 0) {
    delta_theta -= TAU;
  }
  if (fs === 1 && delta_theta < 0) {
    delta_theta += TAU;
  }

  return [ cx, cy, theta1, delta_theta ];
}

//
// Approximate one unit arc segment with bézier curves,
// see http://math.stackexchange.com/questions/873224
//
function approximate_unit_arc(theta1, delta_theta) {
  var alpha = 4/3 * Math.tan(delta_theta/4);

  var x1 = Math.cos(theta1);
  var y1 = Math.sin(theta1);
  var x2 = Math.cos(theta1 + delta_theta);
  var y2 = Math.sin(theta1 + delta_theta);

  return [ x1, y1, x1 - y1*alpha, y1 + x1*alpha, x2 + y2*alpha, y2 - x2*alpha, x2, y2 ];
}

module.exports = function a2c(x1, y1, x2, y2, fa, fs, rx, ry, phi) {
  var sin_phi = Math.sin(phi * TAU / 360);
  var cos_phi = Math.cos(phi * TAU / 360);

  // Make sure radii are valid
  //
  var x1p =  cos_phi*(x1-x2)/2 + sin_phi*(y1-y2)/2;
  var y1p = -sin_phi*(x1-x2)/2 + cos_phi*(y1-y2)/2;

  if (x1p === 0 && y1p === 0) {
    // we're asked to draw line to itself
    return [];
  }

  if (rx === 0 || ry === 0) {
    // one of the radii is zero
    return [];
  }


  // Compensate out-of-range radii
  //
  rx = Math.abs(rx);
  ry = Math.abs(ry);

  var lambda = (x1p * x1p) / (rx * rx) + (y1p * y1p) / (ry * ry);
  if (lambda > 1) {
    rx *= Math.sqrt(lambda);
    ry *= Math.sqrt(lambda);
  }


  // Get center parameters (cx, cy, theta1, delta_theta)
  //
  var cc = get_arc_center(x1, y1, x2, y2, fa, fs, rx, ry, sin_phi, cos_phi);

  var result = [];
  var theta1 = cc[2];
  var delta_theta = cc[3];

  // Split an arc to multiple segments, so each segment
  // will be less than τ/4 (= 90°)
  //
  var segments = Math.max(Math.ceil(Math.abs(delta_theta) / (TAU / 4)), 1);
  delta_theta /= segments;

  for (var i = 0; i < segments; i++) {
    result.push(approximate_unit_arc(theta1, delta_theta));
    theta1 += delta_theta;
  }

  // We have a bezier approximation of a unit circle,
  // now need to transform back to the original ellipse
  //
  return result.map(function (curve) {
    for (var i = 0; i < curve.length; i += 2) {
      var x = curve[i + 0];
      var y = curve[i + 1];

      // scale
      x *= rx;
      y *= ry;

      // rotate
      var xp = cos_phi*x - sin_phi*y;
      var yp = sin_phi*x + cos_phi*y;

      // translate
      curve[i + 0] = xp + cc[0];
      curve[i + 1] = yp + cc[1];
    }

    return curve;
  });
};


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable space-infix-ops */

// The precision used to consider an ellipse as a circle
//
var epsilon = 0.0000000001;

// To convert degree in radians
//
var torad = Math.PI / 180;

// Class constructor :
//  an ellipse centred at 0 with radii rx,ry and x - axis - angle ax.
//
function Ellipse(rx, ry, ax) {
  if (!(this instanceof Ellipse)) { return new Ellipse(rx, ry, ax); }
  this.rx = rx;
  this.ry = ry;
  this.ax = ax;
}

// Apply a linear transform m to the ellipse
// m is an array representing a matrix :
//    -         -
//   | m[0] m[2] |
//   | m[1] m[3] |
//    -         -
//
Ellipse.prototype.transform = function (m) {
  // We consider the current ellipse as image of the unit circle
  // by first scale(rx,ry) and then rotate(ax) ...
  // So we apply ma =  m x rotate(ax) x scale(rx,ry) to the unit circle.
  var c = Math.cos(this.ax * torad), s = Math.sin(this.ax * torad);
  var ma = [
    this.rx * (m[0]*c + m[2]*s),
    this.rx * (m[1]*c + m[3]*s),
    this.ry * (-m[0]*s + m[2]*c),
    this.ry * (-m[1]*s + m[3]*c)
  ];

  // ma * transpose(ma) = [ J L ]
  //                      [ L K ]
  // L is calculated later (if the image is not a circle)
  var J = ma[0]*ma[0] + ma[2]*ma[2],
      K = ma[1]*ma[1] + ma[3]*ma[3];

  // the discriminant of the characteristic polynomial of ma * transpose(ma)
  var D = ((ma[0]-ma[3])*(ma[0]-ma[3]) + (ma[2]+ma[1])*(ma[2]+ma[1])) *
          ((ma[0]+ma[3])*(ma[0]+ma[3]) + (ma[2]-ma[1])*(ma[2]-ma[1]));

  // the "mean eigenvalue"
  var JK = (J + K) / 2;

  // check if the image is (almost) a circle
  if (D < epsilon * JK) {
    // if it is
    this.rx = this.ry = Math.sqrt(JK);
    this.ax = 0;
    return this;
  }

  // if it is not a circle
  var L = ma[0]*ma[1] + ma[2]*ma[3];

  D = Math.sqrt(D);

  // {l1,l2} = the two eigen values of ma * transpose(ma)
  var l1 = JK + D/2,
      l2 = JK - D/2;
  // the x - axis - rotation angle is the argument of the l1 - eigenvector
  this.ax = (Math.abs(L) < epsilon && Math.abs(l1 - K) < epsilon) ?
    90
  :
    Math.atan(Math.abs(L) > Math.abs(l1 - K) ?
      (l1 - J) / L
    :
      L / (l1 - K)
    ) * 180 / Math.PI;

  // if ax > 0 => rx = sqrt(l1), ry = sqrt(l2), else exchange axes and ax += 90
  if (this.ax >= 0) {
    // if ax in [0,90]
    this.rx = Math.sqrt(l1);
    this.ry = Math.sqrt(l2);
  } else {
    // if ax in ]-90,0[ => exchange axes
    this.ax += 90;
    this.rx = Math.sqrt(l2);
    this.ry = Math.sqrt(l1);
  }

  return this;
};

// Check if the ellipse is (almost) degenerate, i.e. rx = 0 or ry = 0
//
Ellipse.prototype.isDegenerate = function () {
  return (this.rx < epsilon * this.ry || this.ry < epsilon * this.rx);
};

module.exports = Ellipse;


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _NetworkFrame2 = __webpack_require__(145);

var _NetworkFrame3 = _interopRequireDefault(_NetworkFrame2);

var _MiniMap = __webpack_require__(250);

var _MiniMap2 = _interopRequireDefault(_MiniMap);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// components


var MinimapNetworkFrame = function (_NetworkFrame) {
  _inherits(MinimapNetworkFrame, _NetworkFrame);

  function MinimapNetworkFrame(props) {
    _classCallCheck(this, MinimapNetworkFrame);

    var _this = _possibleConstructorReturn(this, (MinimapNetworkFrame.__proto__ || Object.getPrototypeOf(MinimapNetworkFrame)).call(this, props));

    _this.generateMinimap = _this.generateMinimap.bind(_this);
    return _this;
  }

  _createClass(MinimapNetworkFrame, [{
    key: "generateMinimap",
    value: function generateMinimap() {
      var miniDefaults = {
        title: "",
        position: [0, 0],
        size: [this.props.size[0] * 5, this.props.size[1] * 5],
        edges: this.props.edges,
        nodes: this.props.nodes,
        xBrushable: true,
        yBrushable: true,
        brushStart: function brushStart() {},
        brush: function brush() {},
        brushEnd: function brushEnd() {}
      };

      var combinedOptions = _extends(miniDefaults, this.props.minimap);

      combinedOptions.hoverAnnotation = false;

      return _react2.default.createElement(_MiniMap2.default, combinedOptions);
    }
  }, {
    key: "render",
    value: function render() {
      var miniMap = this.generateMinimap();
      var options = {};
      if (this.props.renderBefore) {
        options.beforeElements = miniMap;
      } else {
        options.afterElements = miniMap;
      }

      return this.renderBody(options);
    }
  }]);

  return MinimapNetworkFrame;
}(_NetworkFrame3.default);

MinimapNetworkFrame.propTypes = {
  size: _propTypes2.default.array,
  xAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  yAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  points: _propTypes2.default.array,
  lines: _propTypes2.default.array,
  areas: _propTypes2.default.array,
  lineDataAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  lineType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  minimap: _propTypes2.default.object,
  renderBefore: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])
};

exports.default = MinimapNetworkFrame;
module.exports = exports['default'];

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(1270)) :
  typeof define === 'function' && define.amd ? define(['exports', 'd3-quadtree'], factory) :
  (factory((global.d3 = global.d3 || {}),global.d3));
}(this, function (exports,d3Quadtree) { 'use strict';

  function bboxCollide (bbox) {

    function x (d) {
      return d.x + d.vx;
    }

    function y (d) {
      return d.y + d.vy;
    }

    function constant (x) {
      return function () {
        return x;
      };
    }

    var nodes,
        boundingBoxes,
        strength = 1,
        iterations = 1;

        if (typeof bbox !== "function") {
          bbox = constant(bbox === null ? [[0,0][1,1]] : bbox)
        }

        function force () {
          var i,
              tree,
              node,
              xi,
              yi,
              bbi,
              nx1,
              ny1,
              nx2,
              ny2

              var cornerNodes = []
              nodes.forEach(function (d, i) {
                cornerNodes.push({node: d, vx: d.vx, vy: d.vy, x: d.x + (boundingBoxes[i][1][0] + boundingBoxes[i][0][0]) / 2, y: d.y + (boundingBoxes[i][0][1] + boundingBoxes[i][1][1]) / 2})
                cornerNodes.push({node: d, vx: d.vx, vy: d.vy, x: d.x + boundingBoxes[i][0][0], y: d.y + boundingBoxes[i][0][1]})
                cornerNodes.push({node: d, vx: d.vx, vy: d.vy, x: d.x + boundingBoxes[i][0][0], y: d.y + boundingBoxes[i][1][1]})
                cornerNodes.push({node: d, vx: d.vx, vy: d.vy, x: d.x + boundingBoxes[i][1][0], y: d.y + boundingBoxes[i][0][1]})
                cornerNodes.push({node: d, vx: d.vx, vy: d.vy, x: d.x + boundingBoxes[i][1][0], y: d.y + boundingBoxes[i][1][1]})
              })
              var cn = cornerNodes.length

          for (var k = 0; k < iterations; ++k) {
            tree = d3Quadtree.quadtree(cornerNodes, x, y).visitAfter(prepareCorners);

            for (i = 0; i < cn; ++i) {
              var nodeI = ~~(i / 5);
              node = nodes[nodeI]
              bbi = boundingBoxes[nodeI]
              xi = node.x + node.vx
              yi = node.y + node.vy
              nx1 = xi + bbi[0][0]
              ny1 = yi + bbi[0][1]
              nx2 = xi + bbi[1][0]
              ny2 = yi + bbi[1][1]
              tree.visit(apply);
            }
          }

          function apply (quad, x0, y0, x1, y1) {
              var data = quad.data
              if (data) {
                var bWidth = bbLength(bbi, 0),
                bHeight = bbLength(bbi, 1);

                if (data.node.index !== nodeI) {
                  var dataNode = data.node
                  var bbj = boundingBoxes[dataNode.index],
                    dnx1 = dataNode.x + dataNode.vx + bbj[0][0],
                    dny1 = dataNode.y + dataNode.vy + bbj[0][1],
                    dnx2 = dataNode.x + dataNode.vx + bbj[1][0],
                    dny2 = dataNode.y + dataNode.vy + bbj[1][1],
                    dWidth = bbLength(bbj, 0),
                    dHeight = bbLength(bbj, 1)

                  if (nx1 <= dnx2 && dnx1 <= nx2 && ny1 <= dny2 && dny1 <= ny2) {

                    var xSize = [Math.min.apply(null, [dnx1, dnx2, nx1, nx2]), Math.max.apply(null, [dnx1, dnx2, nx1, nx2])]
                    var ySize = [Math.min.apply(null, [dny1, dny2, ny1, ny2]), Math.max.apply(null, [dny1, dny2, ny1, ny2])]

                    var xOverlap = bWidth + dWidth - (xSize[1] - xSize[0])
                    var yOverlap = bHeight + dHeight - (ySize[1] - ySize[0])

                    var xBPush = xOverlap * strength * (yOverlap / bHeight)
                    var yBPush = yOverlap * strength * (xOverlap / bWidth)

                    var xDPush = xOverlap * strength * (yOverlap / dHeight)
                    var yDPush = yOverlap * strength * (xOverlap / dWidth)

                    if ((nx1 + nx2) / 2 < (dnx1 + dnx2) / 2) {
                      node.vx -= xBPush
                      dataNode.vx += xDPush
                    }
                    else {
                      node.vx += xBPush
                      dataNode.vx -= xDPush
                    }
                    if ((ny1 + ny2) / 2 < (dny1 + dny2) / 2) {
                      node.vy -= yBPush
                      dataNode.vy += yDPush
                    }
                    else {
                      node.vy += yBPush
                      dataNode.vy -= yDPush
                    }
                  }

                }
                return;
              }

              return x0 > nx2 || x1 < nx1 || y0 > ny2 || y1 < ny1;
          }

        }

        function prepareCorners (quad) {

          if (quad.data) {
            return quad.bb = boundingBoxes[quad.data.node.index]
          }
            quad.bb = [[0,0],[0,0]]
            for (var i = 0; i < 4; ++i) {
              if (quad[i] && quad[i].bb[0][0] < quad.bb[0][0]) {
                quad.bb[0][0] = quad[i].bb[0][0]
              }
              if (quad[i] && quad[i].bb[0][1] < quad.bb[0][1]) {
                quad.bb[0][1] = quad[i].bb[0][1]
              }
              if (quad[i] && quad[i].bb[1][0] > quad.bb[1][0]) {
                quad.bb[1][0] = quad[i].bb[1][0]
              }
              if (quad[i] && quad[i].bb[1][1] > quad.bb[1][1]) {
                quad.bb[1][1] = quad[i].bb[1][1]
              }
          }
        }

        function bbLength (bbox, heightWidth) {
          return bbox[1][heightWidth] - bbox[0][heightWidth]
        }

        force.initialize = function (_) {
          var i, n = (nodes = _).length; boundingBoxes = new Array(n);
          for (i = 0; i < n; ++i) boundingBoxes[i] = bbox(nodes[i], i, nodes);
        };

        force.iterations = function (_) {
          return arguments.length ? (iterations = +_, force) : iterations;
        };

        force.strength = function (_) {
          return arguments.length ? (strength = +_, force) : strength;
        };

        force.bbox = function (_) {
          return arguments.length ? (bbox = typeof _ === "function" ? _ : constant(+_), force) : bbox;
        };

        return force;
  }

  exports.bboxCollide = bboxCollide;

  Object.defineProperty(exports, '__esModule', { value: true });

}));

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_quadtree__ = __webpack_require__(1271);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "quadtree", function() { return __WEBPACK_IMPORTED_MODULE_0__src_quadtree__["a"]; });



/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quadtree;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__add__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cover__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__find__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__remove__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__root__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__size__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__visit__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__visitAfter__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__x__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__y__ = __webpack_require__(1283);













function quadtree(nodes, x, y) {
  var tree = new Quadtree(x == null ? __WEBPACK_IMPORTED_MODULE_10__x__["b" /* defaultX */] : x, y == null ? __WEBPACK_IMPORTED_MODULE_11__y__["b" /* defaultY */] : y, NaN, NaN, NaN, NaN);
  return nodes == null ? tree : tree.addAll(nodes);
}

function Quadtree(x, y, x0, y0, x1, y1) {
  this._x = x;
  this._y = y;
  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  this._root = undefined;
}

function leaf_copy(leaf) {
  var copy = {data: leaf.data}, next = copy;
  while (leaf = leaf.next) next = next.next = {data: leaf.data};
  return copy;
}

var treeProto = quadtree.prototype = Quadtree.prototype;

treeProto.copy = function() {
  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
      node = this._root,
      nodes,
      child;

  if (!node) return copy;

  if (!node.length) return copy._root = leaf_copy(node), copy;

  nodes = [{source: node, target: copy._root = new Array(4)}];
  while (node = nodes.pop()) {
    for (var i = 0; i < 4; ++i) {
      if (child = node.source[i]) {
        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
        else node.target[i] = leaf_copy(child);
      }
    }
  }

  return copy;
};

treeProto.add = __WEBPACK_IMPORTED_MODULE_0__add__["b" /* default */];
treeProto.addAll = __WEBPACK_IMPORTED_MODULE_0__add__["a" /* addAll */];
treeProto.cover = __WEBPACK_IMPORTED_MODULE_1__cover__["a" /* default */];
treeProto.data = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */];
treeProto.extent = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */];
treeProto.find = __WEBPACK_IMPORTED_MODULE_4__find__["a" /* default */];
treeProto.remove = __WEBPACK_IMPORTED_MODULE_5__remove__["a" /* default */];
treeProto.removeAll = __WEBPACK_IMPORTED_MODULE_5__remove__["b" /* removeAll */];
treeProto.root = __WEBPACK_IMPORTED_MODULE_6__root__["a" /* default */];
treeProto.size = __WEBPACK_IMPORTED_MODULE_7__size__["a" /* default */];
treeProto.visit = __WEBPACK_IMPORTED_MODULE_8__visit__["a" /* default */];
treeProto.visitAfter = __WEBPACK_IMPORTED_MODULE_9__visitAfter__["a" /* default */];
treeProto.x = __WEBPACK_IMPORTED_MODULE_10__x__["a" /* default */];
treeProto.y = __WEBPACK_IMPORTED_MODULE_11__y__["a" /* default */];


/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addAll;
/* harmony default export */ __webpack_exports__["b"] = (function(d) {
  var x = +this._x.call(null, d),
      y = +this._y.call(null, d);
  return add(this.cover(x, y), x, y, d);
});

function add(tree, x, y, d) {
  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points

  var parent,
      node = tree._root,
      leaf = {data: d},
      x0 = tree._x0,
      y0 = tree._y0,
      x1 = tree._x1,
      y1 = tree._y1,
      xm,
      ym,
      xp,
      yp,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return tree._root = leaf, tree;

  // Find the existing leaf for the new point, or add it.
  while (node.length) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
  }

  // Is the new point is exactly coincident with the existing point?
  xp = +tree._x.call(null, node.data);
  yp = +tree._y.call(null, node.data);
  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;

  // Otherwise, split the leaf node until the old and new point are separated.
  do {
    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
  return parent[j] = node, parent[i] = leaf, tree;
}

function addAll(data) {
  var d, i, n = data.length,
      x,
      y,
      xz = new Array(n),
      yz = new Array(n),
      x0 = Infinity,
      y0 = Infinity,
      x1 = -Infinity,
      y1 = -Infinity;

  // Compute the points and their extent.
  for (i = 0; i < n; ++i) {
    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
    xz[i] = x;
    yz[i] = y;
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
  }

  // If there were no (valid) points, inherit the existing extent.
  if (x1 < x0) x0 = this._x0, x1 = this._x1;
  if (y1 < y0) y0 = this._y0, y1 = this._y1;

  // Expand the tree to cover the new points.
  this.cover(x0, y0).cover(x1, y1);

  // Add the new points.
  for (i = 0; i < n; ++i) {
    add(this, xz[i], yz[i], data[i]);
  }

  return this;
}


/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points

  var x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1;

  // If the quadtree has no extent, initialize them.
  // Integer extent are necessary so that if we later double the extent,
  // the existing quadrant boundaries don’t change due to floating point error!
  if (isNaN(x0)) {
    x1 = (x0 = Math.floor(x)) + 1;
    y1 = (y0 = Math.floor(y)) + 1;
  }

  // Otherwise, double repeatedly to cover.
  else if (x0 > x || x > x1 || y0 > y || y > y1) {
    var z = x1 - x0,
        node = this._root,
        parent,
        i;

    switch (i = (y < (y0 + y1) / 2) << 1 | (x < (x0 + x1) / 2)) {
      case 0: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
        break;
      }
      case 1: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
        break;
      }
      case 2: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
        break;
      }
      case 3: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
        break;
      }
    }

    if (this._root && this._root.length) this._root = node;
  }

  // If the quadtree covers the point already, just return.
  else return this;

  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  return this;
});


/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var data = [];
  this.visit(function(node) {
    if (!node.length) do data.push(node.data); while (node = node.next)
  });
  return data;
});


/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(_) {
  return arguments.length
      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
});


/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(251);


/* harmony default export */ __webpack_exports__["a"] = (function(x, y, radius) {
  var data,
      x0 = this._x0,
      y0 = this._y0,
      x1,
      y1,
      x2,
      y2,
      x3 = this._x1,
      y3 = this._y1,
      quads = [],
      node = this._root,
      q,
      i;

  if (node) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node, x0, y0, x3, y3));
  if (radius == null) radius = Infinity;
  else {
    x0 = x - radius, y0 = y - radius;
    x3 = x + radius, y3 = y + radius;
    radius *= radius;
  }

  while (q = quads.pop()) {

    // Stop searching if this quadrant can’t contain a closer node.
    if (!(node = q.node)
        || (x1 = q.x0) > x3
        || (y1 = q.y0) > y3
        || (x2 = q.x1) < x0
        || (y2 = q.y1) < y0) continue;

    // Bisect the current quadrant.
    if (node.length) {
      var xm = (x1 + x2) / 2,
          ym = (y1 + y2) / 2;

      quads.push(
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[3], xm, ym, x2, y2),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[2], x1, ym, xm, y2),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[1], xm, y1, x2, ym),
        new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node[0], x1, y1, xm, ym)
      );

      // Visit the closest quadrant first.
      if (i = (y >= ym) << 1 | (x >= xm)) {
        q = quads[quads.length - 1];
        quads[quads.length - 1] = quads[quads.length - 1 - i];
        quads[quads.length - 1 - i] = q;
      }
    }

    // Visit this point. (Visiting coincident points isn’t necessary!)
    else {
      var dx = x - +this._x.call(null, node.data),
          dy = y - +this._y.call(null, node.data),
          d2 = dx * dx + dy * dy;
      if (d2 < radius) {
        var d = Math.sqrt(radius = d2);
        x0 = x - d, y0 = y - d;
        x3 = x + d, y3 = y + d;
        data = node.data;
      }
    }
  }

  return data;
});


/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = removeAll;
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points

  var parent,
      node = this._root,
      retainer,
      previous,
      next,
      x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1,
      x,
      y,
      xm,
      ym,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return this;

  // Find the leaf node for the point.
  // While descending, also retain the deepest parent with a non-removed sibling.
  if (node.length) while (true) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
    if (!node.length) break;
    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
  }

  // Find the point to remove.
  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
  if (next = node.next) delete node.next;

  // If there are multiple coincident points, remove just the point.
  if (previous) return (next ? previous.next = next : delete previous.next), this;

  // If this is the root point, remove it.
  if (!parent) return this._root = next, this;

  // Remove this leaf.
  next ? parent[i] = next : delete parent[i];

  // If the parent now contains exactly one leaf, collapse superfluous parents.
  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
      && node === (parent[3] || parent[2] || parent[1] || parent[0])
      && !node.length) {
    if (retainer) retainer[j] = node;
    else this._root = node;
  }

  return this;
});

function removeAll(data) {
  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
  return this;
}


/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this._root;
});


/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var size = 0;
  this.visit(function(node) {
    if (!node.length) do ++size; while (node = node.next)
  });
  return size;
});


/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(251);


/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
  if (node) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](node, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[3]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, ym, x1, y1));
      if (child = node[2]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, ym, xm, y1));
      if (child = node[1]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, y0, x1, ym));
      if (child = node[0]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, y0, xm, ym));
    }
  }
  return this;
});


/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad__ = __webpack_require__(251);


/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var quads = [], next = [], q;
  if (this._root) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](this._root, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    var node = q.node;
    if (node.length) {
      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[0]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, y0, xm, ym));
      if (child = node[1]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, y0, x1, ym));
      if (child = node[2]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, x0, ym, xm, y1));
      if (child = node[3]) quads.push(new __WEBPACK_IMPORTED_MODULE_0__quad__["a" /* default */](child, xm, ym, x1, y1));
    }
    next.push(q);
  }
  while (q = next.pop()) {
    callback(q.node, q.x0, q.y0, q.x1, q.y1);
  }
  return this;
});


/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultX;
function defaultX(d) {
  return d[0];
}

/* harmony default export */ __webpack_exports__["a"] = (function(_) {
  return arguments.length ? (this._x = _, this) : this._x;
});


/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultY;
function defaultY(d) {
  return d[1];
}

/* harmony default export */ __webpack_exports__["a"] = (function(_) {
  return arguments.length ? (this._y = _, this) : this._y;
});


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.drawEdges = exports.drawNodes = exports.hierarchicalRectNodeGenerator = exports.radialRectNodeGenerator = exports.chordNodeGenerator = exports.sankeyNodeGenerator = exports.wordcloudNodeGenerator = exports.chordEdgeGenerator = exports.circleNodeGenerator = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.topologicalSort = topologicalSort;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semioticMark = __webpack_require__(15);

var _d3Glyphedge = __webpack_require__(1285);

var _d3Shape = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customEdgeHashD = {
  linearc: function linearc(d) {
    return _d3Glyphedge.d.lineArc(d);
  },
  ribbon: function ribbon(d) {
    return _d3Glyphedge.d.ribbon(d, d.width);
  },
  arrowhead: function arrowhead(d) {
    return _d3Glyphedge.d.arrowHead(d, d.target.nodeSize, d.width, d.width * 1.5);
  },
  halfarrow: function halfarrow(d) {
    return _d3Glyphedge.d.halfArrow(d, d.target.nodeSize, d.width, d.width * 1.5);
  },
  nail: function nail(d) {
    return _d3Glyphedge.d.nail(d, d.source.nodeSize);
  },
  comet: function comet(d) {
    return _d3Glyphedge.d.comet(d, d.target.nodeSize);
  },
  taffy: function taffy(d) {
    return _d3Glyphedge.d.taffy(d, d.source.nodeSize / 2, d.target.nodeSize / 2, (d.source.nodeSize + d.target.nodeSize) / 4);
  }
};

var circleNodeGenerator = exports.circleNodeGenerator = function circleNodeGenerator(_ref) {
  var d = _ref.d,
      i = _ref.i,
      styleFn = _ref.styleFn,
      renderMode = _ref.renderMode,
      key = _ref.key,
      className = _ref.className,
      transform = _ref.transform,
      baseMarkProps = _ref.baseMarkProps;

  //this is repetitious
  return _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
    key: key,
    transform: transform,
    markType: "rect",
    width: d.nodeSize * 2,
    height: d.nodeSize * 2,
    ry: d.nodeSize * 2,
    rx: d.nodeSize * 2,
    x: -d.nodeSize,
    y: -d.nodeSize,
    style: styleFn(d, i),
    renderMode: renderMode ? renderMode(d, i) : undefined,
    className: className
  }));
};

var chordEdgeGenerator = exports.chordEdgeGenerator = function chordEdgeGenerator(size) {
  return function (_ref2) {
    var d = _ref2.d,
        i = _ref2.i,
        styleFn = _ref2.styleFn,
        renderMode = _ref2.renderMode,
        key = _ref2.key,
        className = _ref2.className,
        baseMarkProps = _ref2.baseMarkProps;
    return _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
      renderMode: renderMode ? renderMode(d, i) : undefined,
      key: key,
      className: className,
      simpleInterpolate: true,
      transform: "translate(" + size[0] / 2 + "," + size[1] / 2 + ")",
      markType: "path",
      d: d.d,
      style: styleFn(d, i)
    }));
  };
};

var wordcloudNodeGenerator = exports.wordcloudNodeGenerator = function wordcloudNodeGenerator(_ref3) {
  var d = _ref3.d,
      i = _ref3.i,
      styleFn = _ref3.styleFn,
      key = _ref3.key,
      className = _ref3.className,
      transform = _ref3.transform;

  var textStyle = styleFn(d, i);
  textStyle.fontSize = d.fontSize + "px";
  textStyle.fontWeight = d.fontWeight;
  textStyle.textAnchor = "middle";
  var textTransform = void 0,
      textY = void 0,
      textX = void 0;
  textTransform = "scale(" + d.scale + ")";

  if (!d.rotate) {
    textY = d.textHeight / 4;
    textTransform = "scale(" + d.scale + ")";
  } else {
    textTransform = "rotate(90) scale(" + d.scale + ")";
    textY = d.textHeight / 4;
  }

  return _react2.default.createElement(
    "g",
    { key: key, transform: transform },
    _react2.default.createElement(
      "text",
      {
        style: textStyle,
        y: textY,
        x: textX,
        transform: textTransform,
        className: className + " wordcloud"
      },
      d._NWFText
    )
  );
};

var sankeyNodeGenerator = exports.sankeyNodeGenerator = function sankeyNodeGenerator(_ref4) {
  var d = _ref4.d,
      i = _ref4.i,
      styleFn = _ref4.styleFn,
      renderMode = _ref4.renderMode,
      key = _ref4.key,
      className = _ref4.className,
      transform = _ref4.transform,
      baseMarkProps = _ref4.baseMarkProps;
  return _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
    renderMode: renderMode ? renderMode(d, i) : undefined,
    key: key,
    className: className,
    transform: transform,
    markType: "rect",
    height: d.height,
    width: d.width,
    x: -d.width / 2,
    y: -d.height / 2,
    rx: 0,
    ry: 0,
    style: styleFn(d)
  }));
};

var chordNodeGenerator = exports.chordNodeGenerator = function chordNodeGenerator(size) {
  return function (_ref5) {
    var d = _ref5.d,
        i = _ref5.i,
        styleFn = _ref5.styleFn,
        renderMode = _ref5.renderMode,
        key = _ref5.key,
        className = _ref5.className,
        baseMarkProps = _ref5.baseMarkProps;
    return _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
      renderMode: renderMode ? renderMode(d, i) : undefined,
      key: key,
      className: className,
      transform: "translate(" + size[0] / 2 + "," + size[1] / 2 + ")",
      markType: "path",
      d: d.d,
      style: styleFn(d, i)
    }));
  };
};

var radialRectNodeGenerator = exports.radialRectNodeGenerator = function radialRectNodeGenerator(size, center) {
  var radialArc = (0, _d3Shape.arc)();
  return function (_ref6) {
    var d = _ref6.d,
        i = _ref6.i,
        styleFn = _ref6.styleFn,
        renderMode = _ref6.renderMode,
        key = _ref6.key,
        className = _ref6.className,
        baseMarkProps = _ref6.baseMarkProps;

    radialArc.innerRadius(d.y0 / 2).outerRadius(d.y1 / 2);

    return _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
      key: key,
      transform: "translate(" + center + ")",
      markType: "path",
      d: radialArc({
        startAngle: d.x0 / size[0] * Math.PI * 2,
        endAngle: d.x1 / size[0] * Math.PI * 2
      }),
      style: styleFn(d, i),
      renderMode: renderMode ? renderMode(d, i) : undefined,
      className: className
    }));
  };
};

var hierarchicalRectNodeGenerator = exports.hierarchicalRectNodeGenerator = function hierarchicalRectNodeGenerator(_ref7) {
  var d = _ref7.d,
      i = _ref7.i,
      styleFn = _ref7.styleFn,
      renderMode = _ref7.renderMode,
      key = _ref7.key,
      className = _ref7.className,
      baseMarkProps = _ref7.baseMarkProps;

  //this is repetitious
  return _react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
    key: key,
    transform: "translate(0,0)",
    markType: "rect",
    width: d.x1 - d.x0,
    height: d.y1 - d.y0,
    x: d.x0,
    y: d.y0,
    rx: 0,
    ry: 0,
    style: styleFn(d, i),
    renderMode: renderMode ? renderMode(d, i) : undefined,
    className: className
  }));
};

var genericLineGenerator = function genericLineGenerator(d) {
  return "M" + d.source.x + "," + d.source.y + "L" + d.target.x + "," + d.target.y;
};

var drawNodes = exports.drawNodes = function drawNodes(_ref8) {
  var data = _ref8.data,
      renderKeyFn = _ref8.renderKeyFn,
      customMark = _ref8.customMark,
      styleFn = _ref8.styleFn,
      classFn = _ref8.classFn,
      renderMode = _ref8.renderMode,
      canvasDrawing = _ref8.canvasDrawing,
      canvasRenderFn = _ref8.canvasRenderFn,
      baseMarkProps = _ref8.baseMarkProps;

  var markGenerator = customMark || circleNodeGenerator;
  var renderedData = [];

  if (customMark && canvasRenderFn) {
    console.error("canvas rendering currently only supports generic circle nodes based on nodeSize");
  }

  data.forEach(function (d, i) {
    if (canvasRenderFn && canvasRenderFn(d, i) === true) {
      var canvasNode = {
        baseClass: "frame-piece",
        tx: d.x,
        ty: d.y,
        d: d,
        i: i,
        markProps: { markType: "circle", r: d.nodeSize },
        styleFn: styleFn,
        renderFn: renderMode,
        classFn: classFn
      };
      canvasDrawing.push(canvasNode);
    } else {
      renderedData.push(markGenerator({
        d: d,
        i: i,
        renderKeyFn: renderKeyFn,
        styleFn: styleFn,
        classFn: classFn,
        renderMode: renderMode,
        key: renderKeyFn ? renderKeyFn(d, i) : d.id || "node-" + i,
        className: "node " + classFn(d, i),
        transform: "translate(" + d.x + "," + d.y + ")",
        baseMarkProps: baseMarkProps
      }));
    }
  });
  return renderedData;
};

var drawEdges = exports.drawEdges = function drawEdges(_ref9) {
  var data = _ref9.data,
      renderKeyFn = _ref9.renderKeyFn,
      customMark = _ref9.customMark,
      styleFn = _ref9.styleFn,
      classFn = _ref9.classFn,
      renderMode = _ref9.renderMode,
      canvasRenderFn = _ref9.canvasRenderFn,
      canvasDrawing = _ref9.canvasDrawing,
      type = _ref9.type,
      baseMarkProps = _ref9.baseMarkProps;

  var dGenerator = genericLineGenerator;
  var renderedData = [];
  if (customMark) {
    data.forEach(function (d, i) {
      renderedData.push(customMark({
        d: d,
        i: i,
        renderKeyFn: renderKeyFn,
        styleFn: styleFn,
        classFn: classFn,
        renderMode: renderMode,
        key: renderKeyFn ? renderKeyFn(d, i) : "edge-" + i,
        className: classFn(d, i) + " edge",
        transform: "translate(" + d.x + "," + d.y + ")",
        baseMarkProps: baseMarkProps
      }));
    });
  } else {
    if (type) {
      if (typeof type === "function") {
        dGenerator = type;
      } else if (customEdgeHashD[type]) {
        dGenerator = function dGenerator(d) {
          return customEdgeHashD[type](d);
        };
      }
    }
    data.forEach(function (d, i) {
      if (canvasRenderFn && canvasRenderFn(d, i) === true) {
        var canvasNode = {
          baseClass: "frame-piece",
          tx: d.x,
          ty: d.y,
          d: d,
          i: i,
          markProps: { markType: "path", d: dGenerator(d) },
          styleFn: styleFn,
          renderFn: renderMode,
          classFn: classFn
        };
        canvasDrawing.push(canvasNode);
      } else {
        renderedData.push(_react2.default.createElement(_semioticMark.Mark, _extends({}, baseMarkProps, {
          key: renderKeyFn ? renderKeyFn(d, i) : "edge-" + i,
          markType: "path",
          renderMode: renderMode ? renderMode(d, i) : undefined,
          className: classFn(d) + " edge",
          d: dGenerator(d),
          style: styleFn(d, i)
        })));
      }
    });
  }

  return renderedData;
};

function topologicalSort(nodesArray, edgesArray) {
  // adapted from https://simplapi.wordpress.com/2015/08/19/detect-graph-cycle-in-javascript/
  var nodes = [];
  var nodeHash = {};
  edgesArray.forEach(function (edge) {
    if (!edge.source.id || !edge.target.id) {
      return false;
    }
    if (!nodeHash[edge.source.id]) {
      nodeHash[edge.source.id] = { _id: edge.source.id, links: [] };
      nodes.push(nodeHash[edge.source.id]);
    }
    if (!nodeHash[edge.target.id]) {
      nodeHash[edge.target.id] = { _id: edge.target.id, links: [] };
      nodes.push(nodeHash[edge.target.id]);
    }
    nodeHash[edge.source.id].links.push(edge.target.id);
  });

  // Test if a node got any icoming edge
  function hasIncomingEdge(list, node) {
    for (var i = 0, l = list.length; i < l; ++i) {
      if (list[i].links.indexOf(node._id) !== -1) {
        return true;
      }
    }
    return false;
  }

  // Kahn Algorithm
  var L = [],
      S = nodes.filter(function (node) {
    return !hasIncomingEdge(nodes, node);
  });

  var n = null;

  while (S.length) {
    // Remove a node n from S
    n = S.pop();
    // Add n to tail of L
    L.push(n);

    var i = n.links.length;
    while (i--) {
      // Getting the node associated to the current stored id in links
      var m = nodes[nodes.map(function (d) {
        return d._id;
      }).indexOf(n.links[i])];

      // Remove edge e from the graph
      n.links.pop();

      if (!hasIncomingEdge(nodes, m)) {
        S.push(m);
      }
    }
  }

  // If any of them still got links, there is cycle somewhere
  var nodeWithEdge = nodes.find(function (node) {
    return node.links.length !== 0;
  });

  return nodeWithEdge ? null : L;
}

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
         true ? factory(exports) :
        typeof define === 'function' && define.amd ? define('d3-glyphEdge', ['exports'], factory) :
        factory((global.d3_glyphEdge = {}));
}(this, function (exports) { 'use strict';

        function halfArrow(d, nodeTargetSize, bodySize, headSize) {
            var diffX = d.target.y - d.source.y;
            var diffY = d.target.x - d.source.x;

            var headDistance = headSize * 3;

            var angle0 = ( Math.atan2( diffY, diffX ) + ( Math.PI / 2 ) );
            var angle1 = angle0 - ( Math.PI / 2 );
            var angle2 = angle0 + ( Math.PI / 2 );

            var x1 = d.source.x + (headSize * Math.cos(angle1));
            var y1 = d.source.y - (headSize * Math.sin(angle1));
            var x2 = d.source.x + (headSize * Math.cos(angle2));
            var y2 = d.source.y - (headSize * Math.sin(angle2));
            var x3 = d.target.x - (headSize * Math.cos(angle1));
            var y3 = d.target.y + (headSize * Math.sin(angle1));

            var mx1 = d.source.x + (bodySize * Math.cos(angle1));
            var my1 = d.source.y - (bodySize * Math.sin(angle1));
            var mx2 = d.source.x + (bodySize * Math.cos(angle2));
            var my2 = d.source.y - (bodySize * Math.sin(angle2));

            var mx3 = d.target.x + (bodySize * Math.cos(angle1));
            var my3 = d.target.y - (bodySize * Math.sin(angle1));

            var dY = d.source.y - d.target.y;
            var dX = d.source.x - d.target.x;

            var midDiffY1 = my1 - my3;
            var midDiffX1 = mx1 - mx3;

            var diffY1 = y1 - y3;
            var diffX1 = x1 - x3;

            var pythag = Math.sqrt((midDiffX1 * midDiffX1) + (midDiffY1 * midDiffY1));
            var pythag2 = Math.sqrt((dX * dX) + (dY * dY));

            var adjX1 = mx2 - ((midDiffX1 * (pythag - headDistance - nodeTargetSize)) / pythag);
            var adjY1 = my2 - ((midDiffY1 * (pythag - headDistance - nodeTargetSize)) / pythag);

            var headX1 = x2 - ((diffX1 * (pythag - headDistance - nodeTargetSize)) / pythag);
            var headY1 = y2 - ((diffY1 * (pythag - headDistance - nodeTargetSize)) / pythag);

            var tipX = d.source.x - ((dX * (pythag2 - nodeTargetSize)) / pythag2);
            var tipY = d.source.y - ((dY * (pythag2 - nodeTargetSize)) / pythag2);

            return "M" + d.source.x + "," + d.source.y + "L" + mx2 + "," + my2 + "L" + adjX1 + "," + adjY1 + "L" + headX1 + "," + headY1 + "L" + tipX + "," + tipY + "L" + d.source.x + "," + d.source.y + "z";
        };

        function lineArc(d) {
          var dx = d.target.x - d.source.x,
              dy = d.target.y - d.source.y,
              dr = Math.sqrt(dx * dx + dy * dy);
          return "M" + d.source.x + "," + d.source.y + "A" + dr + "," + dr + " 0 0,1 " + d.target.x + "," + d.target.y;
        };

        function ribbon(d, bodySize) {
                var diffX = d.target.y - d.source.y;
                var diffY = d.target.x - d.source.x;

                var angle0 = ( Math.atan2( diffY, diffX ) + ( Math.PI / 2 ) );
                var angle1 = angle0 - ( Math.PI / 2 );
                var angle2 = angle0 + ( Math.PI / 2 );

                var mx1 = d.source.x + (bodySize * Math.cos(angle1));
                var my1 = d.source.y - (bodySize * Math.sin(angle1));
                var mx2 = d.source.x + (bodySize * Math.cos(angle2));
                var my2 = d.source.y - (bodySize * Math.sin(angle2));

                var mx3 = d.target.x - (bodySize * Math.cos(angle1));
                var my3 = d.target.y + (bodySize * Math.sin(angle1));
                var mx4 = d.target.x - (bodySize * Math.cos(angle2));
                var my4 = d.target.y + (bodySize * Math.sin(angle2));

                return "M" + mx1 + "," + my1 + "L" + mx2 + "," + my2 + "L" + mx3 + "," + my3 + "L" + mx4 + "," + my4 + "z";
        }

        function taffy(d, nodeSourceSize, nodeTargetSize, midpointSize) {
            var diffX = d.target.y - d.source.y;
            var diffY = d.target.x - d.source.x;

            var angle0 = ( Math.atan2( diffY, diffX ) + ( Math.PI / 2 ) );
            var angle1 = angle0 - ( Math.PI / 2 );
            var angle2 = angle0 + ( Math.PI / 2 );

            var x1 = d.source.x + (nodeSourceSize * Math.cos(angle1));
            var y1 = d.source.y - (nodeSourceSize * Math.sin(angle1));
            var x2 = d.source.x + (nodeSourceSize * Math.cos(angle2));
            var y2 = d.source.y - (nodeSourceSize * Math.sin(angle2));

            var x3 = d.target.x + (nodeTargetSize * Math.cos(angle2));
            var y3 = d.target.y - (nodeTargetSize * Math.sin(angle2));
            var x4 = d.target.x + (nodeTargetSize * Math.cos(angle1));
            var y4 = d.target.y - (nodeTargetSize * Math.sin(angle1));

            var mx1 = d.source.x + (midpointSize * Math.cos(angle1));
            var my1 = d.source.y - (midpointSize * Math.sin(angle1));
            var mx2 = d.source.x + (midpointSize * Math.cos(angle2));
            var my2 = d.source.y - (midpointSize * Math.sin(angle2));

            var mx3 = d.target.x + (midpointSize * Math.cos(angle1));
            var my3 = d.target.y - (midpointSize * Math.sin(angle1));
            var mx4 = d.target.x + (midpointSize * Math.cos(angle2));
            var my4 = d.target.y - (midpointSize * Math.sin(angle2));

            var midY2 = (my1 + my3) / 2;
            var midX2 = (mx1 + mx3) / 2;
            var midY1 = (my2 + my4) / 2;
            var midX1 = (mx2 + mx4) / 2;

            return "M" + x1 + "," + y1 + "L" + x2 + "," + y2 + " L " + midX1 + "," + midY1 + " L " + x3 + "," + y3 + " L " + x4 + "," + y4 + " L " + midX2 + "," + midY2 + "z";
        };

        function nail(d, nodeSize) {
            var diffX = d.target.y - d.source.y;
            var diffY = d.target.x - d.source.x;

            var angle0 = ( Math.atan2( diffY, diffX ) + ( Math.PI / 2 ) );
            var angle1 = angle0 - ( Math.PI / 2 );
            var angle2 = angle0 + ( Math.PI / 2 );

            var x1 = d.source.x + (nodeSize * Math.cos(angle1));
            var y1 = d.source.y - (nodeSize * Math.sin(angle1));
            var x2 = d.source.x + (nodeSize * Math.cos(angle2));
            var y2 = d.source.y - (nodeSize * Math.sin(angle2));

            return "M" + x1 + "," + y1 + "L" + x2 + "," + y2 + " L " + d.target.x + "," + d.target.y + "z";
        };

        function comet(d, nodeSize) {
            var diffX = d.target.y - d.source.y;
            var diffY = d.target.x - d.source.x;

            var angle0 = ( Math.atan2( diffY, diffX ) + ( Math.PI / 2 ) );
            var angle1 = angle0 - ( Math.PI / 2 );
            var angle2 = angle0 + ( Math.PI / 2 );

            var x1 = d.target.x + (nodeSize * Math.cos(angle1));
            var y1 = d.target.y - (nodeSize * Math.sin(angle1));
            var x2 = d.target.x + (nodeSize * Math.cos(angle2));
            var y2 = d.target.y - (nodeSize * Math.sin(angle2));

            return "M" + x1 + "," + y1 + "L" + x2 + "," + y2 + " L " + d.source.x + "," + d.source.y + "z";
        };

        function arrowHead(d, nodeTargetSize, bodySize, headSize) {
            var diffX = d.target.y - d.source.y;
            var diffY = d.target.x - d.source.x;

            var headDistance = headSize * 3;

            var angle0 = ( Math.atan2( diffY, diffX ) + ( Math.PI / 2 ) );
            var angle1 = angle0 - ( Math.PI / 2 );
            var angle2 = angle0 + ( Math.PI / 2 );

            var x1 = d.source.x + (headSize * Math.cos(angle1));
            var y1 = d.source.y - (headSize * Math.sin(angle1));
            var x2 = d.source.x + (headSize * Math.cos(angle2));
            var y2 = d.source.y - (headSize * Math.sin(angle2));

            var x3 = d.target.x - (headSize * Math.cos(angle1));
            var y3 = d.target.y + (headSize * Math.sin(angle1));
            var x4 = d.target.x - (headSize * Math.cos(angle2));
            var y4 = d.target.y + (headSize * Math.sin(angle2));

            var mx1 = d.source.x + (bodySize * Math.cos(angle1));
            var my1 = d.source.y - (bodySize * Math.sin(angle1));
            var mx2 = d.source.x + (bodySize * Math.cos(angle2));
            var my2 = d.source.y - (bodySize * Math.sin(angle2));

            var mx3 = d.target.x + (bodySize * Math.cos(angle1));
            var my3 = d.target.y - (bodySize * Math.sin(angle1));
            var mx4 = d.target.x + (bodySize * Math.cos(angle2));
            var my4 = d.target.y - (bodySize * Math.sin(angle2));

            var dY = d.source.y - d.target.y;
            var dX = d.source.x - d.target.x;

            var midDiffY1 = my1 - my3;
            var midDiffX1 = mx1 - mx3;
            var midDiffY2 = my2 - my4;
            var midDiffX2 = mx2 - mx4;

            var diffY1 = y1 - y3;
            var diffX1 = x1 - x3;
            var diffY2 = y2 - y4;
            var diffX2 = x2 - x4;

            var pythag = Math.sqrt((midDiffX1 * midDiffX1) + (midDiffY1 * midDiffY1));
            var pythag2 = Math.sqrt((dX * dX) + (dY * dY));

            var adjX1 = mx2 - ((midDiffX1 * (pythag - headDistance - nodeTargetSize)) / pythag);
            var adjY1 = my2 - ((midDiffY1 * (pythag - headDistance - nodeTargetSize)) / pythag);
            var adjX2 = mx1 - ((midDiffX2 * (pythag - headDistance - nodeTargetSize)) / pythag);
            var adjY2 = my1 - ((midDiffY2 * (pythag - headDistance - nodeTargetSize)) / pythag);

            var headX2 = x1 - ((diffX2 * (pythag - headDistance - nodeTargetSize)) / pythag);
            var headY2 = y1 - ((diffY2 * (pythag - headDistance - nodeTargetSize)) / pythag);
            var headX1 = x2 - ((diffX1 * (pythag - headDistance - nodeTargetSize)) / pythag);
            var headY1 = y2 - ((diffY1 * (pythag - headDistance - nodeTargetSize)) / pythag);

            var tipX = d.source.x - ((dX * (pythag2 - nodeTargetSize)) / pythag2);
            var tipY = d.source.y - ((dY * (pythag2 - nodeTargetSize)) / pythag2);

            return "M" + mx2 + "," + my2 + "L" + adjX1 + "," + adjY1 + "L" + headX1 + "," + headY1 + "L" + tipX + "," + tipY + "L" + headX2 + "," + headY2 + "L" + adjX2 + "," + adjY2 + "L" + mx1 + "," + my1 + "z";
        };

        function parallel(d, sourceSize, targetSize, edgeNumber) {

          var diffX = d.target.y - d.source.y;
          var diffY = d.target.x - d.source.x;

          var angle0 = ( Math.atan2( diffY, diffX ) + ( Math.PI / 2 ) );
          var angle1 = angle0 + ( (Math.PI * 0.75) + (edgeNumber * 0.25) );
          var angle2 = angle0 + ( (Math.PI * 0.25) - (edgeNumber * 0.25) );

          var x1 = d.source.x + (sourceSize * Math.cos(angle1));
          var y1 = d.source.y - (sourceSize * Math.sin(angle1));
          var x2 = d.target.x + (targetSize * Math.cos(angle2));
          var y2 = d.target.y - (targetSize * Math.sin(angle2));

          return {source: {x: x1, y: y1}, target: {x: x2, y: y2}};

        }

        function offset(d, nodeSize) {
          var diffX = d.target.y - d.source.y;
          var diffY = d.target.x - d.source.x;

          var angle0 = ( Math.atan2( diffY, diffX ) + ( Math.PI / 2 ) );
          var angle1 = angle0 + ( Math.PI * 0.75 );
          var angle2 = angle0 + ( Math.PI * 0.25 );

          var x1 = d.source.x + (nodeSize * Math.cos(angle1));
          var y1 = d.source.y - (nodeSize * Math.sin(angle1));
          var x2 = d.target.x + (nodeSize * Math.cos(angle2));
          var y2 = d.target.y - (nodeSize * Math.sin(angle2));

          return {source: {x: x1, y: y1}, target: {x: x2, y: y2}};

        }

        function particle(d, path, pathWidth, speed) {
            pathWidth = pathWidth / 2;

            d.particles = d.particles.filter(function (d) {return d.current < path.getTotalLength()});

            if (d.frequency < 1) {
                if (Math.random() < d.frequency) {
                    pushParticle();
                }
            } else {
                for (var x = 0; x < d.frequency; x++) {
                    pushParticle();
                }
            }

            function pushParticle() {
                d.particles.push({current: 0, xOffset: pathWidth - (pathWidth * Math.random() * 2), yOffset: pathWidth - (pathWidth * Math.random() * 2)});
            }

            d.particles.forEach(function (particle) {
                particle.current = particle.current + speed;
                var currentPosition = path.getPointAtLength(particle.current);
                particle.x = currentPosition.x + particle.xOffset;
                particle.y = currentPosition.y + particle.yOffset;
            });
        };

        var d = {
          arrowHead: arrowHead,
          comet: comet,
          nail: nail,
          taffy: taffy,
          ribbon: ribbon,
          lineArc: lineArc,
          halfArrow: halfArrow
        };

        var project = {
          offset: offset,
          parallel: parallel
        };

        var mutate = {
          particle: particle
        };

        var version = "1.2.0";

        exports.version = version;
        exports.d = d;
        exports.project = project;
        exports.mutate = mutate;

}));

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sankeyCircular = __webpack_require__(1287);

Object.defineProperty(exports, "sankeyCircular", {
  enumerable: true,
  get: function () {
    return _interopRequireDefault(_sankeyCircular).default;
  }
});

var _align = __webpack_require__(480);

Object.defineProperty(exports, "sankeyCenter", {
  enumerable: true,
  get: function () {
    return _align.center;
  }
});
Object.defineProperty(exports, "sankeyLeft", {
  enumerable: true,
  get: function () {
    return _align.left;
  }
});
Object.defineProperty(exports, "sankeyRight", {
  enumerable: true,
  get: function () {
    return _align.right;
  }
});
Object.defineProperty(exports, "sankeyJustify", {
  enumerable: true,
  get: function () {
    return _align.justify;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  // Set the default values
  var x0 = 0,
      y0 = 0,
      x1 = 1,
      y1 = 1,
      // extent
  dx = 24,
      // nodeWidth
  py,
      // nodePadding, for vertical postioning
  id = defaultId,
      align = _align.justify,
      nodes = defaultNodes,
      links = defaultLinks,
      iterations = 32,
      circularLinkGap = 2,
      paddingRatio;

  function sankeyCircular() {
    var graph = {
      nodes: nodes.apply(null, arguments),
      links: links.apply(null, arguments)

      // Process the graph's nodes and links, setting their positions

      // 1.  Associate the nodes with their respective links, and vice versa
    };computeNodeLinks(graph);

    // 2.  Determine which links result in a circular path in the graph
    identifyCircles(graph, id);

    // 3.  Determine how the circular links will be drawn,
    //     either travelling back above the main chart ("top")
    //     or below the main chart ("bottom")
    selectCircularLinkTypes(graph, id);

    // 4. Calculate the nodes' values, based on the values of the incoming and outgoing links
    computeNodeValues(graph);

    // 5.  Calculate the nodes' depth based on the incoming and outgoing links
    //     Sets the nodes':
    //     - depth:  the depth in the graph
    //     - column: the depth (0, 1, 2, etc), as is relates to visual position from left to right
    //     - x0, x1: the x coordinates, as is relates to visual position from left to right
    computeNodeDepths(graph);

    // 6.  Calculate the nodes' and links' vertical position within their respective column
    //     Also readjusts sankeyCircular size if circular links are needed, and node x's
    computeNodeBreadths(graph, iterations, id);
    computeLinkBreadths(graph);

    // 7.  Sort links per node, based on the links' source/target nodes' breadths
    // 8.  Adjust nodes that overlap links that span 2+ columns

    var linkSortingIterations = 4; //Possibly let user control this number, like the iterations over node placement
    for (var iteration = 0; iteration < linkSortingIterations; iteration++) {

      sortSourceLinks(graph, y1, id);
      sortTargetLinks(graph, y1, id);
      resolveNodeLinkOverlaps(graph, y0, y1, id);
      sortSourceLinks(graph, y1, id);
      sortTargetLinks(graph, y1, id);
    }

    // 9. Calculate visually appealling path for the circular paths, and create the "d" string
    addCircularPathData(graph, circularLinkGap, y1, id);

    return graph;
  } // end of sankeyCircular function

  // TODO - update this function to take into account circular changes
  /*sankeyCircular.update = function (graph) {
    computeLinkBreadths(graph)
    return graph
  }*/

  // Set the sankeyCircular parameters
  // nodeID, nodeAlign, nodeWidth, nodePadding, nodes, links, size, extent, iterations, nodePaddingRatio, circularLinkGap
  sankeyCircular.nodeId = function (_) {
    return arguments.length ? (id = typeof _ === 'function' ? _ : (0, _constant2.default)(_), sankeyCircular) : id;
  };

  sankeyCircular.nodeAlign = function (_) {
    return arguments.length ? (align = typeof _ === 'function' ? _ : (0, _constant2.default)(_), sankeyCircular) : align;
  };

  sankeyCircular.nodeWidth = function (_) {
    return arguments.length ? (dx = +_, sankeyCircular) : dx;
  };

  sankeyCircular.nodePadding = function (_) {
    return arguments.length ? (py = +_, sankeyCircular) : py;
  };

  sankeyCircular.nodes = function (_) {
    return arguments.length ? (nodes = typeof _ === 'function' ? _ : (0, _constant2.default)(_), sankeyCircular) : nodes;
  };

  sankeyCircular.links = function (_) {
    return arguments.length ? (links = typeof _ === 'function' ? _ : (0, _constant2.default)(_), sankeyCircular) : links;
  };

  sankeyCircular.size = function (_) {
    return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], sankeyCircular) : [x1 - x0, y1 - y0];
  };

  sankeyCircular.extent = function (_) {
    return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], sankeyCircular) : [[x0, y0], [x1, y1]];
  };

  sankeyCircular.iterations = function (_) {
    return arguments.length ? (iterations = +_, sankeyCircular) : iterations;
  };

  sankeyCircular.circularLinkGap = function (_) {
    return arguments.length ? (circularLinkGap = +_, sankeyCircular) : circularLinkGap;
  };

  sankeyCircular.nodePaddingRatio = function (_) {
    return arguments.length ? (paddingRatio = +_, sankeyCircular) : paddingRatio;
  };

  // Populate the sourceLinks and targetLinks for each node.
  // Also, if the source and target are not objects, assume they are indices.
  function computeNodeLinks(graph) {
    graph.nodes.forEach(function (node, i) {
      node.index = i;
      node.sourceLinks = [];
      node.targetLinks = [];
    });
    var nodeById = (0, _d3Collection.map)(graph.nodes, id);
    graph.links.forEach(function (link, i) {
      link.index = i;
      var source = link.source;
      var target = link.target;
      if (typeof source !== 'object') {
        source = link.source = find(nodeById, source);
      }
      if (typeof target !== 'object') {
        target = link.target = find(nodeById, target);
      }
      source.sourceLinks.push(link);
      target.targetLinks.push(link);
    });
  }

  // Compute the value (size) and cycleness of each node by summing the associated links.
  function computeNodeValues(graph) {
    graph.nodes.forEach(function (node) {
      node.partOfCycle = false;
      node.value = Math.max((0, _d3Array.sum)(node.sourceLinks, value), (0, _d3Array.sum)(node.targetLinks, value));
      node.sourceLinks.forEach(function (link) {
        if (link.circular) {
          node.partOfCycle = true;
          node.circularLinkType = link.circularLinkType;
        }
      });
      node.targetLinks.forEach(function (link) {
        if (link.circular) {
          node.partOfCycle = true;
          node.circularLinkType = link.circularLinkType;
        }
      });
    });
  }

  function getCircleMargins(graph) {
    var totalTopLinksWidth = 0,
        totalBottomLinksWidth = 0,
        totalRightLinksWidth = 0,
        totalLeftLinksWidth = 0;

    var maxColumn = (0, _d3Array.max)(graph.nodes, function (node) {
      return node.column;
    });

    graph.links.forEach(function (link) {
      if (link.circular) {
        if (link.circularLinkType == 'top') {
          totalTopLinksWidth = totalTopLinksWidth + link.width;
        } else {
          totalBottomLinksWidth = totalBottomLinksWidth + link.width;
        }

        if (link.target.column == 0) {
          totalLeftLinksWidth = totalLeftLinksWidth + link.width;
        }

        if (link.source.column == maxColumn) {
          totalRightLinksWidth = totalRightLinksWidth + link.width;
        }
      }
    });

    //account for radius of curves and padding between links
    totalTopLinksWidth = totalTopLinksWidth > 0 ? totalTopLinksWidth + verticalMargin + baseRadius : totalTopLinksWidth;
    totalBottomLinksWidth = totalBottomLinksWidth > 0 ? totalBottomLinksWidth + verticalMargin + baseRadius : totalBottomLinksWidth;
    totalRightLinksWidth = totalRightLinksWidth > 0 ? totalRightLinksWidth + verticalMargin + baseRadius : totalRightLinksWidth;
    totalLeftLinksWidth = totalLeftLinksWidth > 0 ? totalLeftLinksWidth + verticalMargin + baseRadius : totalLeftLinksWidth;

    return { "top": totalTopLinksWidth, "bottom": totalBottomLinksWidth, "left": totalLeftLinksWidth, "right": totalRightLinksWidth };
  }

  // Update the x0, y0, x1 and y1 for the sankeyCircular, to allow space for any circular links
  function scaleSankeySize(graph, margin) {

    var maxColumn = (0, _d3Array.max)(graph.nodes, function (node) {
      return node.column;
    });

    var currentWidth = x1 - x0;
    var currentHeight = y1 - y0;

    var newWidth = currentWidth + margin.right + margin.left;
    var newHeight = currentHeight + margin.top + margin.bottom;

    var scaleX = currentWidth / newWidth;
    var scaleY = currentHeight / newHeight;

    x0 = x0 * scaleX + margin.left;
    x1 = margin.right == 0 ? x1 : x1 * scaleX;
    y0 = y0 * scaleY + margin.top;
    y1 = y1 * scaleY;

    graph.nodes.forEach(function (node) {
      node.x0 = x0 + node.column * ((x1 - x0 - dx) / maxColumn);
      node.x1 = node.x0 + dx;
    });

    return scaleY;
  }

  // Iteratively assign the depth for each node.
  // Nodes are assigned the maximum depth of incoming neighbors plus one;
  // nodes with no incoming links are assigned depth zero, while
  // nodes with no outgoing links are assigned the maximum depth.
  function computeNodeDepths(graph) {
    var nodes, next, x;

    for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
      nodes.forEach(function (node) {
        node.depth = x;
        node.sourceLinks.forEach(function (link) {
          if (next.indexOf(link.target) < 0 && !link.circular) {
            next.push(link.target);
          }
        });
      });
    }

    for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
      nodes.forEach(function (node) {
        node.height = x;
        node.targetLinks.forEach(function (link) {
          if (next.indexOf(link.source) < 0 && !link.circular) {
            next.push(link.source);
          }
        });
      });
    }

    // assign column numbers, and get max value
    graph.nodes.forEach(function (node) {
      node.column = Math.floor(align.call(null, node, x));
    });
  }

  // Assign nodes' breadths, and then shift nodes that overlap (resolveCollisions)
  function computeNodeBreadths(graph, iterations, id) {
    var columns = (0, _d3Collection.nest)().key(function (d) {
      return d.column;
    }).sortKeys(_d3Array.ascending).entries(graph.nodes).map(function (d) {
      return d.values;
    });

    initializeNodeBreadth(id);
    resolveCollisions();

    for (var alpha = 1, n = iterations; n > 0; --n) {
      relaxLeftAndRight(alpha *= 0.99, id);
      resolveCollisions();
    }

    function initializeNodeBreadth(id) {

      //override py if nodePadding has been set
      if (paddingRatio) {
        var padding = Infinity;
        columns.forEach(function (nodes) {
          var thisPadding = y1 * paddingRatio / (nodes.length + 1);
          padding = thisPadding < padding ? thisPadding : padding;
        });
        py = padding;
      }

      var ky = (0, _d3Array.min)(columns, function (nodes) {
        return (y1 - y0 - (nodes.length - 1) * py) / (0, _d3Array.sum)(nodes, value);
      });

      //calculate the widths of the links
      ky = ky * scale;

      graph.links.forEach(function (link) {
        link.width = link.value * ky;
      });

      //determine how much to scale down the chart, based on circular links
      var margin = getCircleMargins(graph);
      var ratio = scaleSankeySize(graph, margin);

      //re-calculate widths
      ky = ky * ratio;

      graph.links.forEach(function (link) {
        link.width = link.value * ky;
      });

      columns.forEach(function (nodes) {
        var nodesLength = nodes.length;
        nodes.forEach(function (node, i) {
          if (node.partOfCycle) {
            if (numberOfNonSelfLinkingCycles(node, id) == 0) {
              node.y0 = y1 / 2 + i;
              node.y1 = node.y0 + node.value * ky;
            } else if (node.circularLinkType == 'top') {
              node.y0 = y0 + i;
              node.y1 = node.y0 + node.value * ky;
            } else {
              node.y0 = y1 - node.value * ky - i;
              node.y1 = node.y0 + node.value * ky;
            }
          } else {
            if (margin.top == 0 || margin.bottom == 0) {
              node.y0 = (y1 - y0) / nodesLength * i;
              node.y1 = node.y0 + node.value * ky;
            } else {
              node.y0 = (y1 - y0) / 2 - nodesLength / 2 + i;
              node.y1 = node.y0 + node.value * ky;
            }
          }
        });
      });
    }

    // For each node in each column, check the node's vertical position in relation to its targets and sources vertical position
    // and shift up/down to be closer to the vertical middle of those targets and sources
    function relaxLeftAndRight(alpha, id) {
      var columnsLength = columns.length;

      columns.forEach(function (nodes, i) {
        var n = nodes.length;
        var depth = nodes[0].depth;

        nodes.forEach(function (node) {
          // check the node is not an orphan
          if (node.sourceLinks.length || node.targetLinks.length) {
            if (node.partOfCycle && numberOfNonSelfLinkingCycles(node, id) > 0) {} else if (depth == 0 && n == 1) {
              var nodeHeight = node.y1 - node.y0;

              node.y0 = y1 / 2 - nodeHeight / 2;
              node.y1 = y1 / 2 + nodeHeight / 2;
            } else if (depth == columnsLength - 1 && n == 1) {
              var nodeHeight = node.y1 - node.y0;

              node.y0 = y1 / 2 - nodeHeight / 2;
              node.y1 = y1 / 2 + nodeHeight / 2;
            } else {
              var avg = 0;

              var avgTargetY = (0, _d3Array.mean)(node.sourceLinks, linkTargetCenter);
              var avgSourceY = (0, _d3Array.mean)(node.targetLinks, linkSourceCenter);

              if (avgTargetY && avgSourceY) {
                avg = (avgTargetY + avgSourceY) / 2;
              } else {
                avg = avgTargetY || avgSourceY;
              }

              var dy = (avg - nodeCenter(node)) * alpha;
              // positive if it node needs to move down
              node.y0 += dy;
              node.y1 += dy;
            }
          }
        });
      });
    }

    // For each column, check if nodes are overlapping, and if so, shift up/down
    function resolveCollisions() {
      columns.forEach(function (nodes) {
        var node,
            dy,
            y = y0,
            n = nodes.length,
            i;

        // Push any overlapping nodes down.
        nodes.sort(ascendingBreadth);

        for (i = 0; i < n; ++i) {
          node = nodes[i];
          dy = y - node.y0;

          if (dy > 0) {
            node.y0 += dy;
            node.y1 += dy;
          }
          y = node.y1 + py;
        }

        // If the bottommost node goes outside the bounds, push it back up.
        dy = y - py - y1;
        if (dy > 0) {
          ;y = node.y0 -= dy, node.y1 -= dy;

          // Push any overlapping nodes back up.
          for (i = n - 2; i >= 0; --i) {
            node = nodes[i];
            dy = node.y1 + py - y;
            if (dy > 0) node.y0 -= dy, node.y1 -= dy;
            y = node.y0;
          }
        }
      });
    }
  }

  // Assign the links y0 and y1 based on source/target nodes position,
  // plus the link's relative position to other links to the same node
  function computeLinkBreadths(graph) {
    graph.nodes.forEach(function (node) {
      node.sourceLinks.sort(ascendingTargetBreadth);
      node.targetLinks.sort(ascendingSourceBreadth);
    });
    graph.nodes.forEach(function (node) {
      var y0 = node.y0;
      var y1 = y0;

      // start from the bottom of the node for cycle links
      var y0cycle = node.y1;
      var y1cycle = y0cycle;

      node.sourceLinks.forEach(function (link) {
        if (link.circular) {
          link.y0 = y0cycle - link.width / 2;
          y0cycle = y0cycle - link.width;
        } else {
          link.y0 = y0 + link.width / 2;
          y0 += link.width;
        }
      });
      node.targetLinks.forEach(function (link) {
        if (link.circular) {
          link.y1 = y1cycle - link.width / 2;
          y1cycle = y1cycle - link.width;
        } else {
          link.y1 = y1 + link.width / 2;
          y1 += link.width;
        }
      });
    });
  }

  return sankeyCircular;
};

var _d3Array = __webpack_require__(3);

var _d3Collection = __webpack_require__(34);

var _align = __webpack_require__(480);

var _constant = __webpack_require__(1288);

var _constant2 = _interopRequireDefault(_constant);

var _d3Shape = __webpack_require__(76);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// sort links' breadth (ie top to bottom in a column), based on their source nodes' breadths
function ascendingSourceBreadth(a, b) {
  return ascendingBreadth(a.source, b.source) || a.index - b.index;
}

// sort links' breadth (ie top to bottom in a column), based on their target nodes' breadths
// https://github.com/tomshanley/d3-sankeyCircular-circular
// fork of https://github.com/d3/d3-sankeyCircular copyright Mike Bostock
function ascendingTargetBreadth(a, b) {
  return ascendingBreadth(a.target, b.target) || a.index - b.index;
}

// sort nodes' breadth (ie top to bottom in a column)
// if both nodes have circular links, or both don't have circular links, then sort by the top (y0) of the node
// else push nodes that have top circular links to the top, and nodes that have bottom circular links to the bottom
function ascendingBreadth(a, b) {
  if (a.partOfCycle === b.partOfCycle) {
    return a.y0 - b.y0;
  } else {
    if (a.circularLinkType === 'top' || b.circularLinkType === 'bottom') {
      return -1;
    } else {
      return 1;
    }
  }
}

// return the value of a node or link
function value(d) {
  return d.value;
}

// return the vertical center of a node
function nodeCenter(node) {
  return (node.y0 + node.y1) / 2;
}

// return the vertical center of a link's source node
function linkSourceCenter(link) {
  return nodeCenter(link.source);
}

// return the vertical center of a link's target node
function linkTargetCenter(link) {
  return nodeCenter(link.target);
}

/* function weightedSource (link) {
  return nodeCenter(link.source) * link.value
} */

/* function weightedTarget (link) {
  return nodeCenter(link.target) * link.value
} */

// Return the default value for ID for node, d.index
function defaultId(d) {
  return d.index;
}

// Return the default object the graph's nodes, graph.nodes
function defaultNodes(graph) {
  return graph.nodes;
}

// Return the default object the graph's nodes, graph.links
function defaultLinks(graph) {
  return graph.links;
}

// Return the node from the collection that matches the provided ID, or throw an error if no match
function find(nodeById, id) {
  var node = nodeById.get(id);
  if (!node) throw new Error('missing: ' + id);
  return node;
}

function getNodeID(node, id) {
  return id(node);
}

// The main sankeyCircular functions

// Some constants for circular link calculations
var verticalMargin = 25;
var baseRadius = 10;
var scale = 0.3; //Possibly let user control this, although anything over 0.5 starts to get too cramped

/// /////////////////////////////////////////////////////////////////////////////////
// Cycle functions
// portion of code to detect circular links based on Colin Fergus' bl.ock https://gist.github.com/cfergus/3956043

// Identify circles in the link objects
function identifyCircles(graph, id) {
  var addedLinks = [];
  var circularLinkID = 0;
  graph.links.forEach(function (link) {
    if (createsCycle(link.source, link.target, addedLinks, id)) {
      link.circular = true;
      link.circularLinkID = circularLinkID;
      circularLinkID = circularLinkID + 1;
    } else {
      link.circular = false;
      addedLinks.push(link);
    }
  });
}

// Assign a circular link type (top or bottom), based on:
// - if the source/target node already has circular links, then use the same type
// - if not, choose the type with fewer links
function selectCircularLinkTypes(graph, id) {
  var numberOfTops = 0;
  var numberOfBottoms = 0;
  graph.links.forEach(function (link) {
    if (link.circular) {
      // if either souce or target has type already use that
      if (link.source.circularLinkType || link.target.circularLinkType) {
        // default to source type if available
        link.circularLinkType = link.source.circularLinkType ? link.source.circularLinkType : link.target.circularLinkType;
      } else {
        link.circularLinkType = numberOfTops < numberOfBottoms ? 'top' : 'bottom';
      }

      if (link.circularLinkType == 'top') {
        numberOfTops = numberOfTops + 1;
      } else {
        numberOfBottoms = numberOfBottoms + 1;
      }

      graph.nodes.forEach(function (node) {
        if (getNodeID(node, id) == getNodeID(link.source, id) || getNodeID(node, id) == getNodeID(link.target, id)) {
          node.circularLinkType = link.circularLinkType;
        }
      });
    }
  });

  //correct self-linking links to be same direction as node
  graph.links.forEach(function (link) {
    if (link.circular) {
      //if both source and target node are same type, then link should have same type
      if (link.source.circularLinkType == link.target.circularLinkType) {
        link.circularLinkType = link.source.circularLinkType;
      }
      //if link is selflinking, then link should have same type as node
      if (selfLinking(link, id)) {
        link.circularLinkType = link.source.circularLinkType;
      }
    }
  });
}

// Checks if link creates a cycle
function createsCycle(originalSource, nodeToCheck, graph, id) {

  // Check for self linking nodes
  if (getNodeID(originalSource, id) == getNodeID(nodeToCheck, id)) {
    return true;
  }

  if (graph.length == 0) {
    return false;
  }

  var nextLinks = findLinksOutward(nodeToCheck, graph);
  // leaf node check
  if (nextLinks.length == 0) {
    return false;
  }

  // cycle check
  for (var i = 0; i < nextLinks.length; i++) {
    var nextLink = nextLinks[i];

    if (nextLink.target === originalSource) {
      return true;
    }

    // Recurse
    if (createsCycle(originalSource, nextLink.target, graph, id)) {
      return true;
    }
  }

  // Exhausted all links
  return false;
}

// Given a node, find all links for which this is a source in the current 'known' graph
function findLinksOutward(node, graph) {
  var children = [];

  for (var i = 0; i < graph.length; i++) {
    if (node == graph[i].source) {
      children.push(graph[i]);
    }
  }

  return children;
}

// Return the angle between a straight line between the source and target of the link, and the vertical plane of the node
function linkAngle(link) {
  var adjacent = Math.abs(link.y1 - link.y0);
  var opposite = Math.abs(link.target.x0 - link.source.x1);

  return Math.atan(opposite / adjacent);
}

// Check if two circular links potentially overlap
function circularLinksCross(link1, link2) {
  if (link1.source.column < link2.target.column) {
    return false;
  } else if (link1.target.column > link2.source.column) {
    return false;
  } else {
    return true;
  }
}

// Return the number of circular links for node, not including self linking links
function numberOfNonSelfLinkingCycles(node, id) {
  var sourceCount = 0;
  node.sourceLinks.forEach(function (l) {
    sourceCount = l.circular && !selfLinking(l, id) ? sourceCount + 1 : sourceCount;
  });

  var targetCount = 0;
  node.targetLinks.forEach(function (l) {
    targetCount = l.circular && !selfLinking(l, id) ? targetCount + 1 : targetCount;
  });

  return sourceCount + targetCount;
}

// Check if a circular link is the only circular link for both its source and target node
function onlyCircularLink(link) {
  var nodeSourceLinks = link.source.sourceLinks;
  var sourceCount = 0;
  nodeSourceLinks.forEach(function (l) {
    sourceCount = l.circular ? sourceCount + 1 : sourceCount;
  });

  var nodeTargetLinks = link.target.targetLinks;
  var targetCount = 0;
  nodeTargetLinks.forEach(function (l) {
    targetCount = l.circular ? targetCount + 1 : targetCount;
  });

  if (sourceCount > 1 || targetCount > 1) {
    return false;
  } else {
    return true;
  }
}

// creates vertical buffer values per set of top/bottom links
function calcVerticalBuffer(links, circularLinkGap, id) {
  links.sort(sortLinkColumnAscending);
  links.forEach(function (link, i) {
    var buffer = 0;

    if (selfLinking(link, id) && onlyCircularLink(link)) {
      link.circularPathData.verticalBuffer = buffer + link.width / 2;
    } else {
      var j = 0;
      for (j; j < i; j++) {
        if (circularLinksCross(links[i], links[j])) {
          var bufferOverThisLink = links[j].circularPathData.verticalBuffer + links[j].width / 2 + circularLinkGap;
          buffer = bufferOverThisLink > buffer ? bufferOverThisLink : buffer;
        }
      }

      link.circularPathData.verticalBuffer = buffer + link.width / 2;
    }
  });

  return links;
}

// calculate the optimum path for a link to reduce overlaps
function addCircularPathData(graph, circularLinkGap, y1, id) {
  //var baseRadius = 10
  var buffer = 5;
  //var verticalMargin = 25

  var minY = (0, _d3Array.min)(graph.links, function (link) {
    return link.source.y0;
  });

  // create object for circular Path Data
  graph.links.forEach(function (link) {
    if (link.circular) {
      link.circularPathData = {};
    }
  });

  // calc vertical offsets per top/bottom links
  var topLinks = graph.links.filter(function (l) {
    return l.circularLinkType == 'top';
  });
  topLinks = calcVerticalBuffer(topLinks, circularLinkGap, id);

  var bottomLinks = graph.links.filter(function (l) {
    return l.circularLinkType == 'bottom';
  });
  bottomLinks = calcVerticalBuffer(bottomLinks, circularLinkGap, id);

  // add the base data for each link
  graph.links.forEach(function (link) {
    if (link.circular) {
      link.circularPathData.arcRadius = link.width + baseRadius;
      link.circularPathData.leftNodeBuffer = buffer;
      link.circularPathData.rightNodeBuffer = buffer;
      link.circularPathData.sourceWidth = link.source.x1 - link.source.x0;
      link.circularPathData.sourceX = link.source.x0 + link.circularPathData.sourceWidth;
      link.circularPathData.targetX = link.target.x0;
      link.circularPathData.sourceY = link.y0;
      link.circularPathData.targetY = link.y1;

      // for self linking paths, and that the only circular link in/out of that node
      if (selfLinking(link, id) && onlyCircularLink(link)) {
        link.circularPathData.leftSmallArcRadius = baseRadius + link.width / 2;
        link.circularPathData.leftLargeArcRadius = baseRadius + link.width / 2;
        link.circularPathData.rightSmallArcRadius = baseRadius + link.width / 2;
        link.circularPathData.rightLargeArcRadius = baseRadius + link.width / 2;

        if (link.circularLinkType == 'bottom') {
          link.circularPathData.verticalFullExtent = link.source.y1 + verticalMargin + link.circularPathData.verticalBuffer;
          link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.leftLargeArcRadius;
          link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.rightLargeArcRadius;
        } else {
          // top links
          link.circularPathData.verticalFullExtent = link.source.y0 - verticalMargin - link.circularPathData.verticalBuffer;
          link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.leftLargeArcRadius;
          link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.rightLargeArcRadius;
        }
      } else {
        // else calculate normally
        // add left extent coordinates, based on links with same source column and circularLink type
        var thisColumn = link.source.column;
        var thisCircularLinkType = link.circularLinkType;
        var sameColumnLinks = graph.links.filter(function (l) {
          return l.source.column == thisColumn && l.circularLinkType == thisCircularLinkType;
        });

        if (link.circularLinkType == 'bottom') {
          sameColumnLinks.sort(sortLinkSourceYDescending);
        } else {
          sameColumnLinks.sort(sortLinkSourceYAscending);
        }

        var radiusOffset = 0;
        sameColumnLinks.forEach(function (l, i) {
          if (l.circularLinkID == link.circularLinkID) {
            link.circularPathData.leftSmallArcRadius = baseRadius + link.width / 2 + radiusOffset;
            link.circularPathData.leftLargeArcRadius = baseRadius + link.width / 2 + i * circularLinkGap + radiusOffset;
          }
          radiusOffset = radiusOffset + l.width;
        });

        // add right extent coordinates, based on links with same target column and circularLink type
        thisColumn = link.target.column;
        sameColumnLinks = graph.links.filter(function (l) {
          return l.target.column == thisColumn && l.circularLinkType == thisCircularLinkType;
        });
        if (link.circularLinkType == 'bottom') {
          sameColumnLinks.sort(sortLinkTargetYDescending);
        } else {
          sameColumnLinks.sort(sortLinkTargetYAscending);
        }

        radiusOffset = 0;
        sameColumnLinks.forEach(function (l, i) {
          if (l.circularLinkID == link.circularLinkID) {
            link.circularPathData.rightSmallArcRadius = baseRadius + link.width / 2 + radiusOffset;
            link.circularPathData.rightLargeArcRadius = baseRadius + link.width / 2 + i * circularLinkGap + radiusOffset;
          }
          radiusOffset = radiusOffset + l.width;
        });

        // bottom links
        if (link.circularLinkType == 'bottom') {
          link.circularPathData.verticalFullExtent = y1 + verticalMargin + link.circularPathData.verticalBuffer;
          link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.leftLargeArcRadius;
          link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.rightLargeArcRadius;
        } else {
          // top links
          link.circularPathData.verticalFullExtent = minY - verticalMargin - link.circularPathData.verticalBuffer;
          link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.leftLargeArcRadius;
          link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.rightLargeArcRadius;
        }
      }

      // all links
      link.circularPathData.leftInnerExtent = link.circularPathData.sourceX + link.circularPathData.leftNodeBuffer;
      link.circularPathData.rightInnerExtent = link.circularPathData.targetX - link.circularPathData.rightNodeBuffer;
      link.circularPathData.leftFullExtent = link.circularPathData.sourceX + link.circularPathData.leftLargeArcRadius + link.circularPathData.leftNodeBuffer;
      link.circularPathData.rightFullExtent = link.circularPathData.targetX - link.circularPathData.rightLargeArcRadius - link.circularPathData.rightNodeBuffer;
    }

    if (link.circular) {
      link.path = createCircularPathString(link);
    } else {
      var normalPath = (0, _d3Shape.linkHorizontal)().source(function (d) {
        var x = d.source.x0 + (d.source.x1 - d.source.x0);
        var y = d.y0;
        return [x, y];
      }).target(function (d) {
        var x = d.target.x0;
        var y = d.y1;
        return [x, y];
      });
      link.path = normalPath(link);
    }
  });
}

// create a d path using the addCircularPathData
function createCircularPathString(link) {
  var pathString = '';
  var pathData = {};

  if (link.circularLinkType == 'top') {
    pathString =
    // start at the right of the source node
    'M' + link.circularPathData.sourceX + ' ' + link.circularPathData.sourceY + ' ' +
    // line right to buffer point
    'L' + link.circularPathData.leftInnerExtent + ' ' + link.circularPathData.sourceY + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.leftLargeArcRadius + ' ' + link.circularPathData.leftSmallArcRadius + ' 0 0 0 ' +
    // End of arc X //End of arc Y
    link.circularPathData.leftFullExtent + ' ' + (link.circularPathData.sourceY - link.circularPathData.leftSmallArcRadius) + ' ' + // End of arc X
    // line up to buffer point
    'L' + link.circularPathData.leftFullExtent + ' ' + link.circularPathData.verticalLeftInnerExtent + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.leftLargeArcRadius + ' ' + link.circularPathData.leftLargeArcRadius + ' 0 0 0 ' +
    // End of arc X //End of arc Y
    link.circularPathData.leftInnerExtent + ' ' + link.circularPathData.verticalFullExtent + ' ' + // End of arc X
    // line left to buffer point
    'L' + link.circularPathData.rightInnerExtent + ' ' + link.circularPathData.verticalFullExtent + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.rightLargeArcRadius + ' ' + link.circularPathData.rightLargeArcRadius + ' 0 0 0 ' +
    // End of arc X //End of arc Y
    link.circularPathData.rightFullExtent + ' ' + link.circularPathData.verticalRightInnerExtent + ' ' + // End of arc X
    // line down
    'L' + link.circularPathData.rightFullExtent + ' ' + (link.circularPathData.targetY - link.circularPathData.rightSmallArcRadius) + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.rightLargeArcRadius + ' ' + link.circularPathData.rightSmallArcRadius + ' 0 0 0 ' +
    // End of arc X //End of arc Y
    link.circularPathData.rightInnerExtent + ' ' + link.circularPathData.targetY + ' ' + // End of arc X
    // line to end
    'L' + link.circularPathData.targetX + ' ' + link.circularPathData.targetY;
  } else {
    // bottom path
    pathString =
    // start at the right of the source node
    'M' + link.circularPathData.sourceX + ' ' + link.circularPathData.sourceY + ' ' +
    // line right to buffer point
    'L' + link.circularPathData.leftInnerExtent + ' ' + link.circularPathData.sourceY + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.leftLargeArcRadius + ' ' + link.circularPathData.leftSmallArcRadius + ' 0 0 1 ' +
    // End of arc X //End of arc Y
    link.circularPathData.leftFullExtent + ' ' + (link.circularPathData.sourceY + link.circularPathData.leftSmallArcRadius) + ' ' + // End of arc X
    // line down to buffer point
    'L' + link.circularPathData.leftFullExtent + ' ' + link.circularPathData.verticalLeftInnerExtent + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.leftLargeArcRadius + ' ' + link.circularPathData.leftLargeArcRadius + ' 0 0 1 ' +
    // End of arc X //End of arc Y
    link.circularPathData.leftInnerExtent + ' ' + link.circularPathData.verticalFullExtent + ' ' + // End of arc X
    // line left to buffer point
    'L' + link.circularPathData.rightInnerExtent + ' ' + link.circularPathData.verticalFullExtent + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.rightLargeArcRadius + ' ' + link.circularPathData.rightLargeArcRadius + ' 0 0 1 ' +
    // End of arc X //End of arc Y
    link.circularPathData.rightFullExtent + ' ' + link.circularPathData.verticalRightInnerExtent + ' ' + // End of arc X
    // line up
    'L' + link.circularPathData.rightFullExtent + ' ' + (link.circularPathData.targetY + link.circularPathData.rightSmallArcRadius) + ' ' +
    // Arc around: Centre of arc X and  //Centre of arc Y
    'A' + link.circularPathData.rightLargeArcRadius + ' ' + link.circularPathData.rightSmallArcRadius + ' 0 0 1 ' +
    // End of arc X //End of arc Y
    link.circularPathData.rightInnerExtent + ' ' + link.circularPathData.targetY + ' ' + // End of arc X
    // line to end
    'L' + link.circularPathData.targetX + ' ' + link.circularPathData.targetY;
  }

  return pathString;
}

// sort links based on the distance between the source and tartget node columns
// if the same, then use Y position of the source node
function sortLinkColumnAscending(link1, link2) {
  if (linkColumnDistance(link1) == linkColumnDistance(link2)) {
    return link1.circularLinkType == 'bottom' ? sortLinkSourceYDescending(link1, link2) : sortLinkSourceYAscending(link1, link2);
  } else {
    return linkColumnDistance(link2) - linkColumnDistance(link1);
  }
}

// sort ascending links by their source vertical position, y0
function sortLinkSourceYAscending(link1, link2) {
  return link1.y0 - link2.y0;
}

// sort descending links by their source vertical position, y0
function sortLinkSourceYDescending(link1, link2) {
  return link2.y0 - link1.y0;
}

// sort ascending links by their target vertical position, y1
function sortLinkTargetYAscending(link1, link2) {
  return link1.y1 - link2.y1;
}

// sort descending links by their target vertical position, y1
function sortLinkTargetYDescending(link1, link2) {
  return link2.y1 - link1.y1;
}

// return the distance between the link's target and source node, in terms of the nodes' column
function linkColumnDistance(link) {
  return link.target.column - link.source.column;
}

// return the distance between the link's target and source node, in terms of the nodes' X coordinate
function linkXLength(link) {
  return link.target.x0 - link.source.x1;
}

// Return the Y coordinate on the longerLink path * which is perpendicular shorterLink's source.
// * approx, based on a straight line from target to source, when in fact the path is a bezier
function linkPerpendicularYToLinkSource(longerLink, shorterLink) {
  // get the angle for the longer link
  var angle = linkAngle(longerLink);

  // get the adjacent length to the other link's x position
  var heightFromY1ToPependicular = linkXLength(shorterLink) / Math.tan(angle);

  // add or subtract from longer link1's original y1, depending on the slope
  var yPerpendicular = incline(longerLink) == 'up' ? longerLink.y1 + heightFromY1ToPependicular : longerLink.y1 - heightFromY1ToPependicular;

  return yPerpendicular;
}

// Return the Y coordinate on the longerLink path * which is perpendicular shorterLink's source.
// * approx, based on a straight line from target to source, when in fact the path is a bezier
function linkPerpendicularYToLinkTarget(longerLink, shorterLink) {
  // get the angle for the longer link
  var angle = linkAngle(longerLink);

  // get the adjacent length to the other link's x position
  var heightFromY1ToPependicular = linkXLength(shorterLink) / Math.tan(angle);

  // add or subtract from longer link's original y1, depending on the slope
  var yPerpendicular = incline(longerLink) == 'up' ? longerLink.y1 - heightFromY1ToPependicular : longerLink.y1 + heightFromY1ToPependicular;

  return yPerpendicular;
}

// Move any nodes that overlap links which span 2+ columns
function resolveNodeLinkOverlaps(graph, y0, y1, id) {

  graph.links.forEach(function (link) {
    if (link.circular) {
      return;
    }

    if (link.target.column - link.source.column > 1) {
      var columnToTest = link.source.column + 1;
      var maxColumnToTest = link.target.column - 1;

      var i = 1;
      var numberOfColumnsToTest = maxColumnToTest - columnToTest + 1;

      for (columnToTest, i = 1; columnToTest <= maxColumnToTest; columnToTest++, i++) {
        graph.nodes.forEach(function (node) {
          if (node.column == columnToTest) {
            var t = i / (numberOfColumnsToTest + 1);

            // Find all the points of a cubic bezier curve in javascript
            // https://stackoverflow.com/questions/15397596/find-all-the-points-of-a-cubic-bezier-curve-in-javascript

            var B0_t = Math.pow(1 - t, 3);
            var B1_t = 3 * t * Math.pow(1 - t, 2);
            var B2_t = 3 * Math.pow(t, 2) * (1 - t);
            var B3_t = Math.pow(t, 3);

            var py_t = B0_t * link.y0 + B1_t * link.y0 + B2_t * link.y1 + B3_t * link.y1;

            var linkY0AtColumn = py_t - link.width / 2;
            var linkY1AtColumn = py_t + link.width / 2;

            // If top of link overlaps node, push node up
            if (linkY0AtColumn > node.y0 && linkY0AtColumn < node.y1) {

              var dy = node.y1 - linkY0AtColumn + 10;
              dy = node.circularLinkType == 'bottom' ? dy : -dy;

              node = adjustNodeHeight(node, dy, y0, y1);

              // check if other nodes need to move up too
              graph.nodes.forEach(function (otherNode) {
                // don't need to check itself or nodes at different columns
                if (getNodeID(otherNode, id) == getNodeID(node, id) || otherNode.column != node.column) {
                  return;
                }
                if (nodesOverlap(node, otherNode)) {
                  adjustNodeHeight(otherNode, dy, y0, y1);
                }
              });
            } else if (linkY1AtColumn > node.y0 && linkY1AtColumn < node.y1) {
              // If bottom of link overlaps node, push node down
              var dy = linkY1AtColumn - node.y0 + 10;

              node = adjustNodeHeight(node, dy, y0, y1);

              // check if other nodes need to move down too
              graph.nodes.forEach(function (otherNode) {
                // don't need to check itself or nodes at different columns
                if (getNodeID(otherNode, id) == getNodeID(node, id) || otherNode.column != node.column) {
                  return;
                }
                if (otherNode.y0 < node.y1 && otherNode.y1 > node.y1) {
                  adjustNodeHeight(otherNode, dy, y0, y1);
                }
              });
            } else if (linkY0AtColumn < node.y0 && linkY1AtColumn > node.y1) {
              // if link completely overlaps node
              var dy = linkY1AtColumn - node.y0 + 10;

              node = adjustNodeHeight(node, dy, y0, y1);

              graph.nodes.forEach(function (otherNode) {
                // don't need to check itself or nodes at different columns
                if (getNodeID(otherNode, id) == getNodeID(node, id) || otherNode.column != node.column) {
                  return;
                }
                if (otherNode.y0 < node.y1 && otherNode.y1 > node.y1) {
                  adjustNodeHeight(otherNode, dy, y0, y1);
                }
              });
            }
          }
        });
      }
    }
  });
}

// check if two nodes overlap
function nodesOverlap(nodeA, nodeB) {
  // test if nodeA top partially overlaps nodeB
  if (nodeA.y0 > nodeB.y0 && nodeA.y0 < nodeB.y1) {
    return true;
  } else if (nodeA.y1 > nodeB.y0 && nodeA.y1 < nodeB.y1) {
    // test if nodeA bottom partially overlaps nodeB
    return true;
  } else if (nodeA.y0 < nodeB.y0 && nodeA.y1 > nodeB.y1) {
    // test if nodeA covers nodeB
    return true;
  } else {
    return false;
  }
}

// update a node, and its associated links, vertical positions (y0, y1)
function adjustNodeHeight(node, dy, sankeyY0, sankeyY1) {
  if (node.y0 + dy >= sankeyY0 && node.y1 + dy <= sankeyY1) {
    node.y0 = node.y0 + dy;
    node.y1 = node.y1 + dy;

    node.targetLinks.forEach(function (l) {
      l.y1 = l.y1 + dy;
    });

    node.sourceLinks.forEach(function (l) {
      l.y0 = l.y0 + dy;
    });
  }
  return node;
}

// sort and set the links' y0 for each node
function sortSourceLinks(graph, y1, id) {
  graph.nodes.forEach(function (node) {
    // move any nodes up which are off the bottom
    if (node.y + (node.y1 - node.y0) > y1) {
      node.y = node.y - (node.y + (node.y1 - node.y0) - y1);
    }

    var nodesSourceLinks = graph.links.filter(function (l) {
      return getNodeID(l.source, id) == getNodeID(node, id);
    });

    var nodeSourceLinksLength = nodesSourceLinks.length;

    // if more than 1 link then sort
    if (nodeSourceLinksLength > 1) {
      nodesSourceLinks.sort(function (link1, link2) {
        // if both are not circular...
        if (!link1.circular && !link2.circular) {
          // if the target nodes are the same column, then sort by the link's target y
          if (link1.target.column == link2.target.column) {
            return link1.y1 - link2.y1;
          } else if (!sameInclines(link1, link2)) {
            // if the links slope in different directions, then sort by the link's target y
            return link1.y1 - link2.y1;

            // if the links slope in same directions, then sort by any overlap
          } else {
            if (link1.target.column > link2.target.column) {
              var link2Adj = linkPerpendicularYToLinkTarget(link2, link1);
              return link1.y1 - link2Adj;
            }
            if (link2.target.column > link1.target.column) {
              var link1Adj = linkPerpendicularYToLinkTarget(link1, link2);
              return link1Adj - link2.y1;
            }
          }
        }

        // if only one is circular, the move top links up, or bottom links down
        if (link1.circular && !link2.circular) {
          return link1.circularLinkType == 'top' ? -1 : 1;
        } else if (link2.circular && !link1.circular) {
          return link2.circularLinkType == 'top' ? 1 : -1;
        }

        // if both links are circular...
        if (link1.circular && link2.circular) {
          // ...and they both loop the same way (both top)
          if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == 'top') {
            // ...and they both connect to a target with same column, then sort by the target's y
            if (link1.target.column === link2.target.column) {
              return link1.target.y1 - link2.target.y1;
            } else {
              // ...and they connect to different column targets, then sort by how far back they
              return link2.target.column - link1.target.column;
            }
          } else if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == 'bottom') {
            // ...and they both loop the same way (both bottom)
            // ...and they both connect to a target with same column, then sort by the target's y
            if (link1.target.column === link2.target.column) {
              return link2.target.y1 - link1.target.y1;
            } else {
              // ...and they connect to different column targets, then sort by how far back they
              return link1.target.column - link2.target.column;
            }
          } else {
            // ...and they loop around different ways, the move top up and bottom down
            return link1.circularLinkType == 'top' ? -1 : 1;
          }
        }
      });
    }

    // update y0 for links
    var ySourceOffset = node.y0;

    nodesSourceLinks.forEach(function (link) {
      link.y0 = ySourceOffset + link.width / 2;
      ySourceOffset = ySourceOffset + link.width;
    });

    // correct any circular bottom links so they are at the bottom of the node
    nodesSourceLinks.forEach(function (link, i) {
      if (link.circularLinkType == 'bottom') {
        var j = i + 1;
        var offsetFromBottom = 0;
        // sum the widths of any links that are below this link
        for (j; j < nodeSourceLinksLength; j++) {
          offsetFromBottom = offsetFromBottom + nodesSourceLinks[j].width;
        }
        link.y0 = node.y1 - offsetFromBottom - link.width / 2;
      }
    });
  });
}

// sort and set the links' y1 for each node
function sortTargetLinks(graph, y1, id) {
  graph.nodes.forEach(function (node) {
    var nodesTargetLinks = graph.links.filter(function (l) {
      return getNodeID(l.target, id) == getNodeID(node, id);
    });

    var nodesTargetLinksLength = nodesTargetLinks.length;

    if (nodesTargetLinksLength > 1) {
      nodesTargetLinks.sort(function (link1, link2) {
        // if both are not circular, the base on the source y position
        if (!link1.circular && !link2.circular) {
          if (link1.source.column == link2.source.column) {
            return link1.y0 - link2.y0;
          } else if (!sameInclines(link1, link2)) {
            return link1.y0 - link2.y0;
          } else {
            // get the angle of the link to the further source node (ie the smaller column)
            if (link2.source.column < link1.source.column) {
              var link2Adj = linkPerpendicularYToLinkSource(link2, link1);

              return link1.y0 - link2Adj;
            }
            if (link1.source.column < link2.source.column) {
              var link1Adj = linkPerpendicularYToLinkSource(link1, link2);

              return link1Adj - link2.y0;
            }
          }
        }

        // if only one is circular, the move top links up, or bottom links down
        if (link1.circular && !link2.circular) {
          return link1.circularLinkType == 'top' ? -1 : 1;
        } else if (link2.circular && !link1.circular) {
          return link2.circularLinkType == 'top' ? 1 : -1;
        }

        // if both links are circular...
        if (link1.circular && link2.circular) {
          // ...and they both loop the same way (both top)
          if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == 'top') {
            // ...and they both connect to a target with same column, then sort by the target's y
            if (link1.source.column === link2.source.column) {
              return link1.source.y1 - link2.source.y1;
            } else {
              // ...and they connect to different column targets, then sort by how far back they
              return link1.source.column - link2.source.column;
            }
          } else if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == 'bottom') {
            // ...and they both loop the same way (both bottom)
            // ...and they both connect to a target with same column, then sort by the target's y
            if (link1.source.column === link2.source.column) {
              return link1.source.y1 - link2.source.y1;
            } else {
              // ...and they connect to different column targets, then sort by how far back they
              return link2.source.column - link1.source.column;
            }
          } else {
            // ...and they loop around different ways, the move top up and bottom down
            return link1.circularLinkType == 'top' ? -1 : 1;
          }
        }
      });
    }

    // update y1 for links
    var yTargetOffset = node.y0;

    nodesTargetLinks.forEach(function (link) {
      link.y1 = yTargetOffset + link.width / 2;
      yTargetOffset = yTargetOffset + link.width;
    });

    // correct any circular bottom links so they are at the bottom of the node
    nodesTargetLinks.forEach(function (link, i) {
      if (link.circularLinkType == 'bottom') {
        var j = i + 1;
        var offsetFromBottom = 0;
        // sum the widths of any links that are below this link
        for (j; j < nodesTargetLinksLength; j++) {
          offsetFromBottom = offsetFromBottom + nodesTargetLinks[j].width;
        }
        link.y1 = node.y1 - offsetFromBottom - link.width / 2;
      }
    });
  });
}

// test if links both slope up, or both slope down
function sameInclines(link1, link2) {
  return incline(link1) == incline(link2);
}

// returns the slope of a link, from source to target
// up => slopes up from source to target
// down => slopes down from source to target
function incline(link) {
  return link.y0 - link.y1 > 0 ? 'up' : 'down';
}

// check if link is self linking, ie links a node to the same node
function selfLinking(link, id) {
  return getNodeID(link.source, id) == getNodeID(link.target, id);
}

/// ////////////////////////////////////////////////////////////////////////////

/*exports.sankeyCircular = sankeyCircular
exports.sankeyCenter = center
exports.sankeyLeft = left
exports.sankeyRight = right
exports.sankeyJustify = justify
  Object.defineProperty(exports, '__esModule', { value: true })*/

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = constant;
// returns a function, using the parameter given to the sankey setting
function constant(x) {
  return function () {
    return x;
  };
}

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.svgRectEncloseRule = exports.svgEncloseRule = exports.svgReactAnnotationRule = exports.svgNodeRule = exports.htmlFrameHoverRule = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Annotation = __webpack_require__(57);

var _Annotation2 = _interopRequireDefault(_Annotation);

var _reactAnnotation = __webpack_require__(48);

var _d3Hierarchy = __webpack_require__(139);

var _baseRules = __webpack_require__(243);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var htmlFrameHoverRule = exports.htmlFrameHoverRule = function htmlFrameHoverRule(_ref) {
  var d = _ref.d,
      i = _ref.i,
      tooltipContent = _ref.tooltipContent;

  var content = d.edge ? _react2.default.createElement(
    "div",
    { className: "tooltip-content" },
    _react2.default.createElement(
      "p",
      { key: "html-annotation-content-1" },
      d.edge.source.id,
      " to ",
      d.edge.target.id
    )
  ) : _react2.default.createElement(
    "div",
    { className: "tooltip-content" },
    _react2.default.createElement(
      "p",
      { key: "html-annotation-content-1" },
      d.id
    ),
    _react2.default.createElement(
      "p",
      { key: "html-annotation-content-2" },
      "Degree: ",
      d.degree
    )
  );

  if (d.type === "frame-hover" && tooltipContent) {
    content = tooltipContent(d);
  }

  return _react2.default.createElement(
    "div",
    {
      key: "xylabel" + i,
      className: "annotation annotation-network-label " + (d.className || ""),
      style: {
        position: "absolute",
        top: d.y + "px",
        left: d.x + "px"
      }
    },
    content
  );
};

var svgNodeRule = exports.svgNodeRule = function svgNodeRule(_ref2) {
  var d = _ref2.d,
      i = _ref2.i,
      projectedNodes = _ref2.projectedNodes,
      nodeIDAccessor = _ref2.nodeIDAccessor,
      nodeSizeAccessor = _ref2.nodeSizeAccessor;

  var selectedNode = d.x && d.y ? d : projectedNodes.find(function (p) {
    return nodeIDAccessor(p) === d.id;
  });
  if (!selectedNode) {
    return null;
  }
  var noteData = _extends({
    dx: d.dx || -25,
    dy: d.dy || -25,
    x: selectedNode.x,
    y: selectedNode.y,
    note: { label: d.label },
    connector: { end: "arrow" }
  }, d, {
    type: _reactAnnotation.AnnotationCalloutCircle,
    subject: {
      radius: d.radius || selectedNode.radius || nodeSizeAccessor(d)
    }
  });
  return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: noteData });
};

var svgReactAnnotationRule = exports.svgReactAnnotationRule = function svgReactAnnotationRule(_ref3) {
  var d = _ref3.d,
      i = _ref3.i,
      projectedNodes = _ref3.projectedNodes,
      nodeIDAccessor = _ref3.nodeIDAccessor;

  var selectedNode = d.x && d.y ? d : projectedNodes.find(function (p) {
    return nodeIDAccessor(p) === d.id;
  });
  if (!selectedNode) {
    return null;
  }
  var noteData = _extends({
    dx: 0,
    dy: 0,
    x: selectedNode.x,
    y: selectedNode.y,
    note: { label: d.label },
    connector: { end: "arrow" }
  }, d, { type: typeof d.type === "function" ? d.type : undefined });
  return _react2.default.createElement(_Annotation2.default, { key: d.key || "annotation-" + i, noteData: noteData });
};

var svgEncloseRule = exports.svgEncloseRule = function svgEncloseRule(_ref4) {
  var d = _ref4.d,
      projectedNodes = _ref4.projectedNodes,
      nodeIDAccessor = _ref4.nodeIDAccessor,
      nodeSizeAccessor = _ref4.nodeSizeAccessor;

  var selectedNodes = projectedNodes.filter(function (p) {
    return d.ids.indexOf(nodeIDAccessor(p)) !== -1;
  });
  if (selectedNodes.length === 0) {
    return null;
  }
  var circle = (0, _d3Hierarchy.packEnclose)(selectedNodes.map(function (p) {
    return { x: p.x, y: p.y, r: nodeSizeAccessor(p) };
  }));
  return (0, _baseRules.circleEnclosure)({ circle: circle, d: d });
};

var svgRectEncloseRule = exports.svgRectEncloseRule = function svgRectEncloseRule(_ref5) {
  var d = _ref5.d,
      i = _ref5.i,
      projectedNodes = _ref5.projectedNodes,
      nodeIDAccessor = _ref5.nodeIDAccessor,
      nodeSizeAccessor = _ref5.nodeSizeAccessor;

  var selectedNodes = projectedNodes.filter(function (p) {
    return d.ids.indexOf(nodeIDAccessor(p)) !== -1;
  });
  if (selectedNodes.length === 0) {
    return null;
  }

  var bboxNodes = selectedNodes.map(function (p) {
    var nodeSize = nodeSizeAccessor(p);
    return {
      x0: p.x0 === undefined ? p.x - nodeSize : p.x0,
      x1: p.x1 === undefined ? p.x + nodeSize : p.x1,
      y0: p.y0 === undefined ? p.y - nodeSize : p.y0,
      y1: p.y1 === undefined ? p.y + nodeSize : p.y1
    };
  });
  return (0, _baseRules.rectangleEnclosure)({ bboxNodes: bboxNodes, d: d, i: i });
};

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
  var shouldRender = typeof props.shouldRender !== "undefined" ? props.shouldRender : "production" !== "production";

  if (!shouldRender) return null;

  return _react2.default.createElement(
    "div",
    { "class": "abacus-debug" },
    props.children
  );
};

module.exports = exports['default'];

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponsiveMinimapXYFrame = exports.ResponsiveSmartFrame = exports.ResponsiveNetworkFrame = exports.ResponsiveORFrame = exports.ResponsiveOrdinalFrame = exports.ResponsiveXYFrame = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _XYFrame = __webpack_require__(61);

var _XYFrame2 = _interopRequireDefault(_XYFrame);

var _OrdinalFrame = __webpack_require__(144);

var _OrdinalFrame2 = _interopRequireDefault(_OrdinalFrame);

var _NetworkFrame = __webpack_require__(145);

var _NetworkFrame2 = _interopRequireDefault(_NetworkFrame);

var _SmartFrame = __webpack_require__(249);

var _SmartFrame2 = _interopRequireDefault(_SmartFrame);

var _MinimapXYFrame = __webpack_require__(479);

var _MinimapXYFrame2 = _interopRequireDefault(_MinimapXYFrame);

var _elementResizeEvent = __webpack_require__(1292);

var _elementResizeEvent2 = _interopRequireDefault(_elementResizeEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createResponsiveFrame = function createResponsiveFrame(Frame) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    _inherits(ResponsiveFrame, _React$Component);

    function ResponsiveFrame(props) {
      _classCallCheck(this, ResponsiveFrame);

      var _this = _possibleConstructorReturn(this, (ResponsiveFrame.__proto__ || Object.getPrototypeOf(ResponsiveFrame)).call(this, props));

      _this._onResize = function (width, height) {
        _this.setState({ containerHeight: height, containerWidth: width });
      };

      _this.state = {
        containerHeight: undefined,
        containerWidth: undefined
      };
      return _this;
    }

    _createClass(ResponsiveFrame, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        var element = this.node;
        (0, _elementResizeEvent2.default)(element, function () {
          _this2.setState({
            containerHeight: element.offsetHeight,
            containerWidth: element.offsetWidth
          });
        });
        this.setState({
          containerHeight: element.offsetHeight,
          containerWidth: element.offsetWidth
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;

        var _props = this.props,
            responsiveWidth = _props.responsiveWidth,
            responsiveHeight = _props.responsiveHeight,
            size = _props.size,
            dataVersion = _props.dataVersion,
            _props$style = _props.style,
            style = _props$style === undefined ? {} : _props$style;
        var _state = this.state,
            containerHeight = _state.containerHeight,
            containerWidth = _state.containerWidth;


        var actualSize = [].concat(_toConsumableArray(size));

        var returnEmpty = false;

        if (responsiveWidth) {
          if (!containerWidth) returnEmpty = true;
          actualSize[0] = containerWidth;
        }

        if (responsiveHeight) {
          if (!containerHeight) returnEmpty = true;
          actualSize[1] = containerHeight;
        }

        var dataVersionWithSize = dataVersion + actualSize.toString();

        return _react2.default.createElement(
          "div",
          {
            className: "responsive-container",
            style: _extends({ height: "100%", width: "100%" }, style),
            ref: function ref(node) {
              return _this3.node = node;
            }
          },
          !returnEmpty && _react2.default.createElement(Frame, _extends({}, this.props, {
            size: actualSize,
            dataVersion: dataVersion ? dataVersionWithSize : undefined
          }))
        );
      }
    }]);

    return ResponsiveFrame;
  }(_react2.default.Component), _class.propTypes = {
    size: _propTypes2.default.array
  }, _class.defaultProps = {
    size: [500, 500]
  }, _temp;
};

var ResponsiveXYFrame = exports.ResponsiveXYFrame = createResponsiveFrame(_XYFrame2.default);
var ResponsiveOrdinalFrame = exports.ResponsiveOrdinalFrame = createResponsiveFrame(_OrdinalFrame2.default);
var ResponsiveORFrame = exports.ResponsiveORFrame = createResponsiveFrame(_OrdinalFrame2.default);
var ResponsiveNetworkFrame = exports.ResponsiveNetworkFrame = createResponsiveFrame(_NetworkFrame2.default);
var ResponsiveSmartFrame = exports.ResponsiveSmartFrame = createResponsiveFrame(_SmartFrame2.default);
var ResponsiveMinimapXYFrame = exports.ResponsiveMinimapXYFrame = createResponsiveFrame(_MinimapXYFrame2.default);

/***/ }),
/* 1292 */
/***/ (function(module, exports) {

var exports = function exports(element, fn) {
  var window = this
  var document = window.document
  var isIE
  var requestFrame

  var attachEvent = document.attachEvent
  if (typeof navigator !== 'undefined') {
    isIE = navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/Edge/)
  }

  requestFrame = (function () {
    var raf = window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
          function fallbackRAF(func) {
            return window.setTimeout(func, 20)
          }
    return function requestFrameFunction(func) {
      return raf(func)
    }
  })()

  var cancelFrame = (function () {
    var cancel = window.cancelAnimationFrame ||
      window.mozCancelAnimationFrame ||
        window.webkitCancelAnimationFrame ||
          window.clearTimeout
    return function cancelFrameFunction(id) {
      return cancel(id)
    }
  })()

  function resizeListener(e) {
    var win = e.target || e.srcElement
    if (win.__resizeRAF__) {
      cancelFrame(win.__resizeRAF__)
    }
    win.__resizeRAF__ = requestFrame(function () {
      var trigger = win.__resizeTrigger__
      if(trigger !== undefined) {
        trigger.__resizeListeners__.forEach(function (fn) {
          fn.call(trigger, e)
        })
      }
    })
  }

  function objectLoad() {
    this.contentDocument.defaultView.__resizeTrigger__ = this.__resizeElement__
    this.contentDocument.defaultView.addEventListener('resize', resizeListener)
  }

  if (!element.__resizeListeners__) {
    element.__resizeListeners__ = []
    if (attachEvent) {
      element.__resizeTrigger__ = element
      element.attachEvent('onresize', resizeListener)
    } else {
      if (getComputedStyle(element).position === 'static') {
        element.style.position = 'relative'
      }
      var obj = element.__resizeTrigger__ = document.createElement('object')
      obj.setAttribute('style', 'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; pointer-events: none; z-index: -1; opacity: 0;')
      obj.setAttribute('class', 'resize-sensor')
      obj.__resizeElement__ = element
      obj.onload = objectLoad
      obj.type = 'text/html'
      if (isIE) {
        element.appendChild(obj)
      }
      obj.data = 'about:blank'
      if (!isIE) {
        element.appendChild(obj)
      }
    }
  }
  element.__resizeListeners__.push(fn)
}

exports.unbind = function(element, fn){
  var attachEvent = document.attachEvent;
  element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
  if (!element.__resizeListeners__.length) {
    if (attachEvent) {
      element.detachEvent('onresize', resizeListener);
    } else {
      element.__resizeTrigger__.contentDocument.defaultView.removeEventListener('resize', resizeListener);
      element.__resizeTrigger__ = !element.removeChild(element.__resizeTrigger__);
    }
  }
}

module.exports = (typeof window === 'undefined') ? exports : exports.bind(window)


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SparkSmartFrame = exports.SparkNetworkFrame = exports.SparkOrdinalFrame = exports.SparkXYFrame = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _XYFrame = __webpack_require__(61);

var _XYFrame2 = _interopRequireDefault(_XYFrame);

var _OrdinalFrame = __webpack_require__(144);

var _OrdinalFrame2 = _interopRequireDefault(_OrdinalFrame);

var _NetworkFrame = __webpack_require__(145);

var _NetworkFrame2 = _interopRequireDefault(_NetworkFrame);

var _SmartFrame = __webpack_require__(249);

var _SmartFrame2 = _interopRequireDefault(_SmartFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function sparkNetworkSettings() {
  var originalSettings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'force';

  var finalSettings = {};
  if (originalSettings) {
    finalSettings = originalSettings;
    if (originalSettings === 'force') finalSettings = { type: 'force' };

    return _extends({
      edgeStrength: 2,
      edgeDistance: 5,
      nodePadding: 1,
      nodeWidth: 5,
      groupWidth: 4
    }, finalSettings);
  }
  return originalSettings;
}

var axisDefaults = {
  tickFormat: function tickFormat() {
    return '';
  },
  baseline: false
};

var allFrameDefaults = {
  margin: 0
};

function simpleValueAccessor(props, d) {
  var value = d.y;
  if (props.yAccessor) value = typeof props.yAccessor === 'string' ? d[props.yAccessor] : props.yAccessor(d);

  return value.toString ? value.toString() : value;
}

var xyFrameDefaults = function xyFrameDefaults(props) {
  return _extends({}, allFrameDefaults, props, {
    hoverAnnotation: props.hoverAnnotation === true ? [function (d) {
      return {
        type: 'react-annotation',
        label: simpleValueAccessor(props, d),
        dx: 50,
        dy: -50
      };
    }] : props.hoverAnnotation,
    axes: props.axes ? props.axes.map(function (a) {
      return _extends({}, axisDefaults, a);
    }) : props.axes
  });
};

var ordinalFrameDefaults = function ordinalFrameDefaults(props) {
  return _extends({}, allFrameDefaults, props, {
    //  hoverAnnotation: props.hoverAnnotation === true ? [{ type: "react-annotation"}] : props.hoverAnnotation,
    axis: props.axis ? _extends({ axisDefaults: axisDefaults }, props.axis) : props.axis
  });
};

var networkFrameDefaults = function networkFrameDefaults(props) {
  return _extends({}, allFrameDefaults, {
    nodeSizeAccessor: 2
  }, props, {
    networkType: sparkNetworkSettings(props.networkType)
    //  hoverAnnotation: props.hoverAnnotation === true ? [{ type: "react-annotation"}] : props.hoverAnnotation,
  });
};

var createSparkFrame = function createSparkFrame(Frame, defaults) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    _inherits(SparkFrame, _React$Component);

    function SparkFrame(props) {
      _classCallCheck(this, SparkFrame);

      var _this = _possibleConstructorReturn(this, (SparkFrame.__proto__ || Object.getPrototypeOf(SparkFrame)).call(this, props));

      _this._onResize = function (width, height) {
        _this.setState({ containerHeight: height, containerWidth: width });
      };

      _this.state = {
        containerHeight: props.size[1],
        containerWidth: props.size[0]
      };
      return _this;
    }

    _createClass(SparkFrame, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var element = this.node;
        var lineHeight = +window.getComputedStyle(element).lineHeight.split('px')[0] - 5;

        this.setState({
          containerHeight: isNaN(lineHeight) ? element.offsetHeight : lineHeight,
          containerWidth: element.offsetWidth
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            size = _props.size,
            _props$style = _props.style,
            style = _props$style === undefined ? {} : _props$style;
        var _state$containerHeigh = this.state.containerHeight,
            containerHeight = _state$containerHeigh === undefined ? 30 : _state$containerHeigh;


        var actualSize = [];

        actualSize[0] = typeof size === 'number' ? size : size[0] ? size[0] : containerHeight;
        actualSize[1] = containerHeight;

        return _react2.default.createElement(
          'span',
          {
            style: _extends({
              width: actualSize[0] + 'px',
              height: actualSize[1] + 'px',
              display: 'inline-block',
              marginLeft: '5px',
              marginRight: '5px'
            }, style),
            ref: function ref(node) {
              return _this2.node = node;
            }
          },
          _react2.default.createElement(Frame, _extends({}, defaults(this.props), { size: actualSize, useSpans: true }))
        );
      }
    }]);

    return SparkFrame;
  }(_react2.default.Component), _class.propTypes = {
    size: _propTypes2.default.array
  }, _class.defaultProps = {
    size: []
  }, _temp;
};

var SparkXYFrame = exports.SparkXYFrame = createSparkFrame(_XYFrame2.default, xyFrameDefaults);
var SparkOrdinalFrame = exports.SparkOrdinalFrame = createSparkFrame(_OrdinalFrame2.default, ordinalFrameDefaults);
var SparkNetworkFrame = exports.SparkNetworkFrame = createSparkFrame(_NetworkFrame2.default, networkFrameDefaults);
var SparkSmartFrame = exports.SparkSmartFrame = createSparkFrame(_SmartFrame2.default, {});

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Semiotic_Line_Graph; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_scale_chromatic__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_shape__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semiotic__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semiotic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semiotic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3_scale__ = __webpack_require__(107);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//Author: Ian Banatoski
var color={CLETPUS:"black",//Coal
PAETPUS:"#19586D",//Petroleum
NGETPUS:"#ffcc00",//Natural Gas
OJETPUS:"#D3D3D3",//Other Gases
NUETPUS:"#81FF14",//Nuclear
HPETPUS:"blue",//Hydroelectric Pumped Storage
HVETPUS:"blue",//Conventional Hydroelectric Power
WDETPUS:"brown",//Wood
WSETPUS:"#847e08",//Waste
GEETPUS:"#ee3b3b",//Geothermal
SOETPUS:"#ffd900",//Solar
WYETPUS:"#ADD8E6",//Wind
ELETPUS:"red"//total
};var name={CLETPUS:"Coal",//Coal
PAETPUS:"Petroleum",//Petroleum
NGETPUS:"Natural Gas",//Natural Gas
OJETPUS:"Other Gases",//Other Gases
NUETPUS:"Nuclear",//Nuclear
HPETPUS:"Hydroelectric Pumped Storage",//Hydroelectric Pumped Storage
HVETPUS:"Conventional Hydroelectric Power",//Conventional Hydroelectric Power
WDETPUS:"Wood",//Wood
WSETPUS:"Waste",//Waste
GEETPUS:"Geothermal",//Geothermal
SOETPUS:"Solar",//Solar
WYETPUS:"Wind",//Wind
ELETPUS:"Total"//total
};var Semiotic_Line_Graph=function(_React$Component){_inherits(Semiotic_Line_Graph,_React$Component);function Semiotic_Line_Graph(props){_classCallCheck(this,Semiotic_Line_Graph);return _possibleConstructorReturn(this,(Semiotic_Line_Graph.__proto__||Object.getPrototypeOf(Semiotic_Line_Graph)).call(this,props));}_createClass(Semiotic_Line_Graph,[{key:"render",value:function render(){//console.log("props", this.props);
var annotations=this.props.annotations;// console.log("semiotic line", data);
var data=JSON.parse(JSON.stringify(this.props.data));data=data.filter(function(msn){return msn.MSN=="CLETPUS"||msn.MSN=="NGETPUS";});data.forEach(function(msn){msn.coordinates=msn.coordinates.filter(function(year){return new Date(year.YYYYMM).getFullYear()>2000;});});var chartAxes=[{orient:"left",ticks:4,label:'Million MWh',tickFormat:function tickFormat(d){return d/100000;}},{orient:"bottom",ticks:5,tickFormat:function tickFormat(d){return new Date(d).getFullYear();}}];var chartSettings={responsiveWidth:true,responsiveHeight:false,size:[80,150],margin:{top:30,bottom:35,left:60,right:50},lines:data,lineType:"line",xScaleType:Object(__WEBPACK_IMPORTED_MODULE_5_d3_scale__["a" /* scaleTime */])(),xAccessor:function xAccessor(d){return new Date(d.YYYYMM);},yAccessor:"value",lineDataAccessor:function lineDataAccessor(d){return d.coordinates;},lineStyle:function lineStyle(d){return{stroke:color[d.MSN],strokeWidth:2,fillOpacity:0.75};},axes:chartAxes,annotations:annotations,hoverAnnotation:[{type:"frame-hover"},function(d){return{type:"x",color:"#000"};}],tooltipContent:function tooltipContent(d){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tooltip-content",style:{boxShadow:"2px 2px 5px grey",color:"#000",opacity:0.9,background:"#FFF",padding:10,borderRadius:5,transform:"translate(10px,10px)"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,new Date(d.YYYYMM).getFullYear()," | ",name[d.MSN])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,d.value.toString())," Mwh"));}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semiotic__["ResponsiveXYFrame"],chartSettings);}}]);return Semiotic_Line_Graph;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_categorical_category10__ = __webpack_require__(1296);
/* unused harmony reexport schemeCategory10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_categorical_Accent__ = __webpack_require__(1297);
/* unused harmony reexport schemeAccent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_categorical_Dark2__ = __webpack_require__(1298);
/* unused harmony reexport schemeDark2 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_categorical_Paired__ = __webpack_require__(1299);
/* unused harmony reexport schemePaired */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_categorical_Pastel1__ = __webpack_require__(1300);
/* unused harmony reexport schemePastel1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_categorical_Pastel2__ = __webpack_require__(1301);
/* unused harmony reexport schemePastel2 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_categorical_Set1__ = __webpack_require__(1302);
/* unused harmony reexport schemeSet1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_categorical_Set2__ = __webpack_require__(1303);
/* unused harmony reexport schemeSet2 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_categorical_Set3__ = __webpack_require__(1304);
/* unused harmony reexport schemeSet3 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_diverging_BrBG__ = __webpack_require__(1305);
/* unused harmony reexport interpolateBrBG */
/* unused harmony reexport schemeBrBG */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_diverging_PRGn__ = __webpack_require__(1306);
/* unused harmony reexport interpolatePRGn */
/* unused harmony reexport schemePRGn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_diverging_PiYG__ = __webpack_require__(1307);
/* unused harmony reexport interpolatePiYG */
/* unused harmony reexport schemePiYG */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_diverging_PuOr__ = __webpack_require__(1308);
/* unused harmony reexport interpolatePuOr */
/* unused harmony reexport schemePuOr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_diverging_RdBu__ = __webpack_require__(1309);
/* unused harmony reexport interpolateRdBu */
/* unused harmony reexport schemeRdBu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_diverging_RdGy__ = __webpack_require__(1310);
/* unused harmony reexport interpolateRdGy */
/* unused harmony reexport schemeRdGy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_diverging_RdYlBu__ = __webpack_require__(1311);
/* unused harmony reexport interpolateRdYlBu */
/* unused harmony reexport schemeRdYlBu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_diverging_RdYlGn__ = __webpack_require__(1312);
/* unused harmony reexport interpolateRdYlGn */
/* unused harmony reexport schemeRdYlGn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_diverging_Spectral__ = __webpack_require__(1313);
/* unused harmony reexport interpolateSpectral */
/* unused harmony reexport schemeSpectral */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_sequential_multi_BuGn__ = __webpack_require__(1314);
/* unused harmony reexport interpolateBuGn */
/* unused harmony reexport schemeBuGn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_sequential_multi_BuPu__ = __webpack_require__(1315);
/* unused harmony reexport interpolateBuPu */
/* unused harmony reexport schemeBuPu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_sequential_multi_GnBu__ = __webpack_require__(1316);
/* unused harmony reexport interpolateGnBu */
/* unused harmony reexport schemeGnBu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_sequential_multi_OrRd__ = __webpack_require__(1317);
/* unused harmony reexport interpolateOrRd */
/* unused harmony reexport schemeOrRd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_sequential_multi_PuBuGn__ = __webpack_require__(1318);
/* unused harmony reexport interpolatePuBuGn */
/* unused harmony reexport schemePuBuGn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_sequential_multi_PuBu__ = __webpack_require__(1319);
/* unused harmony reexport interpolatePuBu */
/* unused harmony reexport schemePuBu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_sequential_multi_PuRd__ = __webpack_require__(1320);
/* unused harmony reexport interpolatePuRd */
/* unused harmony reexport schemePuRd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_sequential_multi_RdPu__ = __webpack_require__(1321);
/* unused harmony reexport interpolateRdPu */
/* unused harmony reexport schemeRdPu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_sequential_multi_YlGnBu__ = __webpack_require__(1322);
/* unused harmony reexport interpolateYlGnBu */
/* unused harmony reexport schemeYlGnBu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_sequential_multi_YlGn__ = __webpack_require__(1323);
/* unused harmony reexport interpolateYlGn */
/* unused harmony reexport schemeYlGn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_sequential_multi_YlOrBr__ = __webpack_require__(1324);
/* unused harmony reexport interpolateYlOrBr */
/* unused harmony reexport schemeYlOrBr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__src_sequential_multi_YlOrRd__ = __webpack_require__(1325);
/* unused harmony reexport interpolateYlOrRd */
/* unused harmony reexport schemeYlOrRd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__src_sequential_single_Blues__ = __webpack_require__(1326);
/* unused harmony reexport interpolateBlues */
/* unused harmony reexport schemeBlues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__src_sequential_single_Greens__ = __webpack_require__(1327);
/* unused harmony reexport interpolateGreens */
/* unused harmony reexport schemeGreens */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__src_sequential_single_Greys__ = __webpack_require__(1328);
/* unused harmony reexport interpolateGreys */
/* unused harmony reexport schemeGreys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__src_sequential_single_Purples__ = __webpack_require__(1329);
/* unused harmony reexport interpolatePurples */
/* unused harmony reexport schemePurples */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__src_sequential_single_Reds__ = __webpack_require__(1330);
/* unused harmony reexport interpolateReds */
/* unused harmony reexport schemeReds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__src_sequential_single_Oranges__ = __webpack_require__(1331);
/* unused harmony reexport interpolateOranges */
/* unused harmony reexport schemeOranges */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__src_sequential_multi_cubehelix__ = __webpack_require__(1332);
/* unused harmony reexport interpolateCubehelixDefault */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__src_sequential_multi_rainbow__ = __webpack_require__(1333);
/* unused harmony reexport interpolateRainbow */
/* unused harmony reexport interpolateWarm */
/* unused harmony reexport interpolateCool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__src_sequential_multi_viridis__ = __webpack_require__(1334);
/* unused harmony reexport interpolateViridis */
/* unused harmony reexport interpolateMagma */
/* unused harmony reexport interpolateInferno */
/* unused harmony reexport interpolatePlasma */









































/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));


/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666"));


/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666"));


/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928"));


/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2"));


/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc"));


/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999"));


/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3"));


/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f"));


/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "d8b365f5f5f55ab4ac",
  "a6611adfc27d80cdc1018571",
  "a6611adfc27df5f5f580cdc1018571",
  "8c510ad8b365f6e8c3c7eae55ab4ac01665e",
  "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e",
  "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e",
  "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e",
  "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30",
  "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "af8dc3f7f7f77fbf7b",
  "7b3294c2a5cfa6dba0008837",
  "7b3294c2a5cff7f7f7a6dba0008837",
  "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837",
  "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837",
  "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837",
  "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837",
  "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b",
  "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "e9a3c9f7f7f7a1d76a",
  "d01c8bf1b6dab8e1864dac26",
  "d01c8bf1b6daf7f7f7b8e1864dac26",
  "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221",
  "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221",
  "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221",
  "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221",
  "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419",
  "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "998ec3f7f7f7f1a340",
  "5e3c99b2abd2fdb863e66101",
  "5e3c99b2abd2f7f7f7fdb863e66101",
  "542788998ec3d8daebfee0b6f1a340b35806",
  "542788998ec3d8daebf7f7f7fee0b6f1a340b35806",
  "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806",
  "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806",
  "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08",
  "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "ef8a62f7f7f767a9cf",
  "ca0020f4a58292c5de0571b0",
  "ca0020f4a582f7f7f792c5de0571b0",
  "b2182bef8a62fddbc7d1e5f067a9cf2166ac",
  "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac",
  "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac",
  "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac",
  "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061",
  "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "ef8a62ffffff999999",
  "ca0020f4a582bababa404040",
  "ca0020f4a582ffffffbababa404040",
  "b2182bef8a62fddbc7e0e0e09999994d4d4d",
  "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d",
  "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d",
  "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d",
  "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a",
  "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "fc8d59ffffbf91bfdb",
  "d7191cfdae61abd9e92c7bb6",
  "d7191cfdae61ffffbfabd9e92c7bb6",
  "d73027fc8d59fee090e0f3f891bfdb4575b4",
  "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4",
  "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4",
  "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4",
  "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695",
  "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "fc8d59ffffbf91cf60",
  "d7191cfdae61a6d96a1a9641",
  "d7191cfdae61ffffbfa6d96a1a9641",
  "d73027fc8d59fee08bd9ef8b91cf601a9850",
  "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850",
  "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850",
  "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850",
  "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837",
  "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "fc8d59ffffbf99d594",
  "d7191cfdae61abdda42b83ba",
  "d7191cfdae61ffffbfabdda42b83ba",
  "d53e4ffc8d59fee08be6f59899d5943288bd",
  "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd",
  "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd",
  "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd",
  "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2",
  "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "e5f5f999d8c92ca25f",
  "edf8fbb2e2e266c2a4238b45",
  "edf8fbb2e2e266c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "e0ecf49ebcda8856a7",
  "edf8fbb3cde38c96c688419d",
  "edf8fbb3cde38c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "e0f3dba8ddb543a2ca",
  "f0f9e8bae4bc7bccc42b8cbe",
  "f0f9e8bae4bc7bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "fee8c8fdbb84e34a33",
  "fef0d9fdcc8afc8d59d7301f",
  "fef0d9fdcc8afc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "ece2f0a6bddb1c9099",
  "f6eff7bdc9e167a9cf02818a",
  "f6eff7bdc9e167a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "ece7f2a6bddb2b8cbe",
  "f1eef6bdc9e174a9cf0570b0",
  "f1eef6bdc9e174a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "e7e1efc994c7dd1c77",
  "f1eef6d7b5d8df65b0ce1256",
  "f1eef6d7b5d8df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "fde0ddfa9fb5c51b8a",
  "feebe2fbb4b9f768a1ae017e",
  "feebe2fbb4b9f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "edf8b17fcdbb2c7fb8",
  "ffffcca1dab441b6c4225ea8",
  "ffffcca1dab441b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "f7fcb9addd8e31a354",
  "ffffccc2e69978c679238443",
  "ffffccc2e69978c67931a354006837",
  "ffffccd9f0a3addd8e78c67931a354006837",
  "ffffccd9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "fff7bcfec44fd95f0e",
  "ffffd4fed98efe9929cc4c02",
  "ffffd4fed98efe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "ffeda0feb24cf03b20",
  "ffffb2fecc5cfd8d3ce31a1c",
  "ffffb2fecc5cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "deebf79ecae13182bd",
  "eff3ffbdd7e76baed62171b5",
  "eff3ffbdd7e76baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "e5f5e0a1d99b31a354",
  "edf8e9bae4b374c476238b45",
  "edf8e9bae4b374c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "f0f0f0bdbdbd636363",
  "f7f7f7cccccc969696525252",
  "f7f7f7cccccc969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "efedf5bcbddc756bb1",
  "f2f0f7cbc9e29e9ac86a51a3",
  "f2f0f7cbc9e29e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "fee0d2fc9272de2d26",
  "fee5d9fcae91fb6a4acb181d",
  "fee5d9fcae91fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(9);



var scheme = new Array(3).concat(
  "fee6cefdae6be6550d",
  "feeddefdbe85fd8d3cd94701",
  "feeddefdbe85fd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704"
).map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));


/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(10);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(300, 0.5, 0.0), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(-240, 0.5, 1.0)));


/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export warm */
/* unused harmony export cool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(10);



var warm = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(-100, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(80, 1.50, 0.8));

var cool = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(260, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(80, 1.50, 0.8));

var rainbow = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])();

/* unused harmony default export */ var _unused_webpack_default_export = (function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
});


/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export magma */
/* unused harmony export inferno */
/* unused harmony export plasma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(5);


function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));


/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semiotic__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semiotic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_semiotic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__employment_data__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_scale__ = __webpack_require__(107);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// console.log(employmentData);
var SampleChart=function(_Component){_inherits(SampleChart,_Component);function SampleChart(){_classCallCheck(this,SampleChart);return _possibleConstructorReturn(this,(SampleChart.__proto__||Object.getPrototypeOf(SampleChart)).apply(this,arguments));}_createClass(SampleChart,[{key:'handleWaypointEnter',value:function handleWaypointEnter(){//console.log("Enter")
}},{key:'handleWaypointLeave',value:function handleWaypointLeave(){//console.log("Leave")
}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-container',style:{width:'700px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semiotic__["ResponsiveXYFrame"],{title:"Coal Miner Employment (Bureau of Labor Statistics)",responsiveWidth:true,size:[700,400],lines:__WEBPACK_IMPORTED_MODULE_2__employment_data__["a" /* default */],xScaleType:Object(__WEBPACK_IMPORTED_MODULE_3_d3_scale__["a" /* scaleTime */])(),xAccessor:function xAccessor(d,i){var date=new Date(d["Date"]);//console.log(date);
return date;},yAccessor:"Employees",lineStyle:{stroke:"#00a2ce"},margin:{left:80,bottom:50,right:20,top:40},axes:[{orient:"left",label:"Employees (thousands)"},{orient:"bottom",label:"Year",tickFormat:function tickFormat(d){//console.log(d);
return d.getFullYear();},ticks:8}]}));}}]);return SampleChart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SampleChart);

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var employmentData=[{'coordinates':[{"Date":"1/1/2008","Employees":77.2},{"Date":"2/1/2008","Employees":77.3},{"Date":"3/1/2008","Employees":77.6},{"Date":"4/1/2008","Employees":78},{"Date":"5/1/2008","Employees":79.2},{"Date":"6/1/2008","Employees":80.3},{"Date":"7/1/2008","Employees":80.4},{"Date":"8/1/2008","Employees":82.7},{"Date":"9/1/2008","Employees":83.6},{"Date":"10/1/2008","Employees":84.8},{"Date":"11/1/2008","Employees":86.1},{"Date":"12/1/2008","Employees":86.3},{"Date":"1/1/2009","Employees":86.4},{"Date":"2/1/2009","Employees":85.9},{"Date":"3/1/2009","Employees":85.2},{"Date":"4/1/2009","Employees":83.9},{"Date":"5/1/2009","Employees":82.2},{"Date":"6/1/2009","Employees":81},{"Date":"7/1/2009","Employees":79.9},{"Date":"8/1/2009","Employees":80},{"Date":"9/1/2009","Employees":79.4},{"Date":"10/1/2009","Employees":78.3},{"Date":"11/1/2009","Employees":77.9},{"Date":"12/1/2009","Employees":77.7},{"Date":"1/1/2010","Employees":77.8},{"Date":"2/1/2010","Employees":78.6},{"Date":"3/1/2010","Employees":79.1},{"Date":"4/1/2010","Employees":79.2},{"Date":"5/1/2010","Employees":80.3},{"Date":"6/1/2010","Employees":80.2},{"Date":"7/1/2010","Employees":80.9},{"Date":"8/1/2010","Employees":81.2},{"Date":"9/1/2010","Employees":82},{"Date":"10/1/2010","Employees":82.7},{"Date":"11/1/2010","Employees":83.4},{"Date":"12/1/2010","Employees":84},{"Date":"1/1/2011","Employees":83.9},{"Date":"2/1/2011","Employees":83.1},{"Date":"3/1/2011","Employees":84.4},{"Date":"4/1/2011","Employees":86},{"Date":"5/1/2011","Employees":87.6},{"Date":"6/1/2011","Employees":88.3},{"Date":"7/1/2011","Employees":87.8},{"Date":"8/1/2011","Employees":88.6},{"Date":"9/1/2011","Employees":89.3},{"Date":"10/1/2011","Employees":89.5},{"Date":"11/1/2011","Employees":89.6},{"Date":"12/1/2011","Employees":89.4},{"Date":"1/1/2012","Employees":89.7},{"Date":"2/1/2012","Employees":89.3},{"Date":"3/1/2012","Employees":88.9},{"Date":"4/1/2012","Employees":87.9},{"Date":"5/1/2012","Employees":87.6},{"Date":"6/1/2012","Employees":85.8},{"Date":"7/1/2012","Employees":84.6},{"Date":"8/1/2012","Employees":83},{"Date":"9/1/2012","Employees":81.6},{"Date":"10/1/2012","Employees":79.4},{"Date":"11/1/2012","Employees":79.1},{"Date":"12/1/2012","Employees":78.9},{"Date":"1/1/2013","Employees":78.4},{"Date":"2/1/2013","Employees":79.3},{"Date":"3/1/2013","Employees":79.6},{"Date":"4/1/2013","Employees":78.1},{"Date":"5/1/2013","Employees":78.6},{"Date":"6/1/2013","Employees":78.8},{"Date":"7/1/2013","Employees":78.4},{"Date":"8/1/2013","Employees":78},{"Date":"9/1/2013","Employees":77.2},{"Date":"10/1/2013","Employees":77.2},{"Date":"11/1/2013","Employees":77},{"Date":"12/1/2013","Employees":76.7},{"Date":"1/1/2014","Employees":76},{"Date":"2/1/2014","Employees":75},{"Date":"3/1/2014","Employees":73.7},{"Date":"4/1/2014","Employees":74.1},{"Date":"5/1/2014","Employees":74},{"Date":"6/1/2014","Employees":74},{"Date":"7/1/2014","Employees":74.4},{"Date":"8/1/2014","Employees":73.2},{"Date":"9/1/2014","Employees":72.6},{"Date":"10/1/2014","Employees":71.2},{"Date":"11/1/2014","Employees":70.6},{"Date":"12/1/2014","Employees":69.7},{"Date":"1/1/2015","Employees":68.9},{"Date":"2/1/2015","Employees":68.6},{"Date":"3/1/2015","Employees":68.1},{"Date":"4/1/2015","Employees":67},{"Date":"5/1/2015","Employees":66},{"Date":"6/1/2015","Employees":65.1},{"Date":"7/1/2015","Employees":64.1},{"Date":"8/1/2015","Employees":62.8},{"Date":"9/1/2015","Employees":61.6},{"Date":"10/1/2015","Employees":60.5},{"Date":"11/1/2015","Employees":58.8},{"Date":"12/1/2015","Employees":57.1},{"Date":"1/1/2016","Employees":55.4},{"Date":"2/1/2016","Employees":53.4},{"Date":"3/1/2016","Employees":52.1},{"Date":"4/1/2016","Employees":51.1},{"Date":"5/1/2016","Employees":49.9},{"Date":"6/1/2016","Employees":49.2},{"Date":"7/1/2016","Employees":48.9},{"Date":"8/1/2016","Employees":48.9},{"Date":"9/1/2016","Employees":48.9},{"Date":"10/1/2016","Employees":49.7},{"Date":"11/1/2016","Employees":50.3},{"Date":"12/1/2016","Employees":50.4},{"Date":"1/1/2017","Employees":50.7},{"Date":"2/1/2017","Employees":50.9},{"Date":"3/1/2017","Employees":51.2},{"Date":"4/1/2017","Employees":51.8},{"Date":"5/1/2017","Employees":51.9},{"Date":"6/1/2017","Employees":52},{"Date":"7/1/2017","Employees":52},{"Date":"8/1/2017","Employees":52.5},{"Date":"9/1/2017","Employees":52.8},{"Date":"10/1/2017","Employees":52.7},{"Date":"11/1/2017","Employees":52.1},{"Date":"12/1/2017","Employees":51.7},{"Date":"1/1/2018","Employees":51.8}]}];/* harmony default export */ __webpack_exports__["a"] = (employmentData);

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semiotic__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semiotic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_semiotic__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ScrollyTextBox=function(_Component){_inherits(ScrollyTextBox,_Component);function ScrollyTextBox(){_classCallCheck(this,ScrollyTextBox);return _possibleConstructorReturn(this,(ScrollyTextBox.__proto__||Object.getPrototypeOf(ScrollyTextBox)).apply(this,arguments));}_createClass(ScrollyTextBox,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-box-wrapper",ref:this.props.innerRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"scrolly-text-box"+(this.props.active?" active":""),style:{borderLeftColor:this.props.color}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,this.props.description),this.props.href!=null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{float:"right"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:this.props.href},"[",this.props.id,"]")):null));}}]);return ScrollyTextBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ScrollyTextBox);

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return waypoints; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorMap__ = __webpack_require__(252);
/*  For Reference
var color = {
    CLETPUS: colorMap['coal'], //Coal
    PAETPUS: colorMap['petroleum'], //Petroleum
    NGETPUS: colorMap['naturalGas'], //Natural Gas
    OJETPUS: colorMap['otherGas'], //Other Gases
    NUETPUS: colorMap['nuclear'], //Nuclear
    HPETPUS: colorMap['hydroPumped'], //Hydroelectric Pumped Storage
    HVETPUS: colorMap['hydroConventional'], //Conventional Hydroelectric Power
    WDETPUS: colorMap['wood'], //Wood
    WSETPUS: colorMap['waste'], //Waste
    GEETPUS: colorMap['geothermal'], //Geothermal
    SOETPUS: colorMap['solar'], //Solar
    WYETPUS: colorMap['wind'], //Wind
};
*/var waypoints=[{id:0,textBoxDescription:"After the end of the Second World War, growing suburbinzation and increased demand led to the expansion of coal supplying the country with over 50% of its electrical power generation beginning in 1954.",textBoxTitle:"1954",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],citation:"http://americanhistory.si.edu/powering/past/history2.htm",correspondingVis:1,annotations:[{type:"bounds",YYYYMM:"01/01/1954",bounds:[{YYYYMM:new Date("1/1/1954")},{YYYYMM:new Date("1/1/1960")}],label:"Coal Dominates Power Production",color:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],dy:-10,dx:0,connector:{end:"none"}}]},{id:0,textBoxDescription:"The Organization of the Petroleum Exporting Countries (OPEC) enacted an embargo on the United States. In response gas shortages occured across the US and citizens began rationing fuel to conserve use. The 1973 Oil Crisis displayed the United State's reliance on foreign energy.",textBoxTitle:"1973",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['petroleum'],citation:"http://sites.utexas.edu/energyinstitute/files/2016/09/UTAustin_FCe_History_2016.pdf https://thebreakthrough.org/index.php/programs/energy-and-climate/gas-driven-carbon-reductions-point-to-new-climate-paradigm",correspondingVis:1,annotations:[{type:"x",note:{label:"OPEC Embargo Causes Oil Crisis",align:"middle"},YYYYMM:"1/1/1973",color:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['petroleum'],dy:-10,dx:350,connector:{end:"none"}}]},{id:0,textBoxDescription:"Passed during the energy crises caused by OPEC's embargo, The Powerplant and Industrial Fuel Use Act (PIFUA), was designed to increase the use of coal and other alternate fuels as primary energy sources for baseload* power generation.",textBoxTitle:"1978",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],citation:"http://heinonline.org/HOL/LandingPage?handle=hein.journals/helr3&div=12&id=&page=",correspondingVis:1,annotations:[{type:"x",YYYYMM:"01/01/1978",note:{label:"The Powerplant and Industrial Fuel Use Act (PIFUA)"},color:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],dy:-10,dx:50,connector:{end:"none"}}]},{id:0,textBoxDescription:"In the same year, the Natural Gas Policy Act (NGPA) started the process of phasing out regulations on gas wellhead prices. Over the next ten years, advances in natural gas technology eventually led to greater availability and lower prices.",textBoxTitle:"1978",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['naturalGas'],citation:"http://sites.utexas.edu/energyinstitute/files/2016/09/UTAustin_FCe_History_2016.pdf",correspondingVis:1,annotations:[{type:"x",YYYYMM:"01/01/1978",note:{label:"Petroleum is Energy Leader",align:"middle"},color:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['naturalGas'],dy:-10,dx:50,connector:{end:"none"}}]},{id:0,textBoxDescription:"Beginning in 1985, a series of orders by the Federal Energy Regulatory Commission (FERC) further supported the growth of the natural gas market.",textBoxTitle:"1985",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['naturalGas'],// citation: "https://alternativeenergy.procon.org/view.timeline.php?timelineID=000015#1951-1999",
correspondingVis:1,annotations:[{type:"x",YYYYMM:"01/01/1985",note:{label:"FERC Acts",align:"middle"},color:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['natural gas'],dy:-10,dx:50,connector:{end:"none"}}]},{id:0,textBoxDescription:"In 1999, heightened awairness in US cities and states led to a petition to persuade the Environmental Protection Agency (EPA) to take action in reducing greenhouse gases. However later in 2003, the EPA asserted that it did not possess the authority to regulate greenhouse gases and that even if the agency did, it would not exercise it.",textBoxTitle:"1999 - 2003",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],citation:"https://thebreakthrough.org/index.php/programs/energy-and-climate/making-fossil-fuels-irrelevant",correspondingVis:1,annotations:[{type:"bounds",YYYYMM:"01/01/1999",bounds:[{YYYYMM:new Date("1/1/1999")},{YYYYMM:new Date("1/1/2003")}],label:"Climate Change Fears Arise",color:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],dy:-10,dx:0,connector:{end:"none"}}]},{id:0,textBoxDescription:"With increased oil prices, many of the oil-fired peak capacity generators responsible for handling high demand were swtiched to natural gas.",textBoxTitle:"2007",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['naturalGas'],correspondingVis:1,citation:"https://thebreakthrough.org/index.php/programs/energy-and-climate/gas-driven-carbon-reductions-point-to-new-climate-paradigm",annotations:[{type:"x",YYYYMM:"1/1/2007",note:{label:"Natural Gas Prices Reduce Greatly",align:"middle"},color:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['naturalGas'],dy:-10,dx:50,connector:{end:"none"}}]},{id:0,textBoxDescription:"During the 2008 recession coal was hit especially hard. In addtion the US unemployment rate rose from 4.7% in November 2007 to peak at 10% in October 2009",textBoxTitle:"2008",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],correspondingVis:1,citation:"https://fred.stlouisfed.org/series/UNRATE",annotations:[{type:"bounds",YYYYMM:"1/1/2008",bounds:[{YYYYMM:new Date("1/1/2007")},{YYYYMM:new Date("1/1/2009")}],label:"2008 Great Recession",color:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],dy:-10,dx:0,connector:{end:"none"}}]},{id:0,textBoxDescription:"Here, things start to get interesting. In order to understand why coal begins to decline, let's take a closer look at how coal energy production has changed over the past two decades.",textBoxTitle:"",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],correspondingVis:1,annotations:[{type:"bounds",YYYYMM:"1/1/2008",bounds:[{YYYYMM:new Date("1/1/2001")},{YYYYMM:new Date("1/1/2016")}],label:"What Happened?",color:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],dy:-10,dx:0,connector:{end:"none"}}]},// Transition to Map ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
{id:0,textBoxDescription:"Coal-fired power plants largely dominated the landscape, when compared to natural gas plants.",textBoxTitle:"2001",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['naturalGas'],correspondingVis:4,annotations:[{type:"x",YYYYMM:"1/1/2001",color:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['naturalGas'],note:{label:"Coal plants largely dominate landscape",align:"middle"},dy:-10,dx:0,connector:{end:"none"},annotationSettings:{strokeWidth:5}}]},{id:0,textBoxDescription:"",textBoxTitle:"2002",textBoxColor:"grey",correspondingVis:4,annotations:[{type:"x",YYYYMM:"1/1/2002",note:{label:"2002",align:"right"},color:"grey",dy:-10,dx:0,connector:{end:"none"}}]},{id:0,textBoxDescription:"",textBoxTitle:"2003",textBoxColor:"grey",correspondingVis:4,annotations:[{type:"x",YYYYMM:"1/1/2003",note:{label:"2003",align:"right"},color:"grey",dy:-10,dx:0,connector:{end:"none"}}]},{id:0,textBoxDescription:"",textBoxTitle:"2004",textBoxColor:"grey",correspondingVis:4,annotations:[{type:"x",YYYYMM:"1/1/2004",note:{label:"2004",align:"right"},color:"grey",dy:-10,dx:0,connector:{end:"none"}}]},{id:0,textBoxDescription:"",textBoxTitle:"2005",textBoxColor:"grey",correspondingVis:4,annotations:[{type:"x",YYYYMM:"1/1/2005",note:{label:"2005",align:"right"},color:"grey",dy:-10,dx:0,connector:{end:"none"}}]},{id:0,textBoxDescription:"",textBoxTitle:"2006",textBoxColor:"grey",correspondingVis:4,annotations:[{type:"x",YYYYMM:"1/1/2006",note:{label:"2006",align:"right"},color:"grey",dy:-10,dx:0,connector:{end:"none"}}]},{id:0,textBoxDescription:"",textBoxTitle:"2007",textBoxColor:"grey",correspondingVis:4,annotations:[{type:"x",YYYYMM:"1/1/2007",note:{label:"2007",align:"right"},color:"grey",dy:-10,dx:0,connector:{end:"none"}}]},{id:0,textBoxDescription:"Throughout the early 2000's, advances in hydraulic fracturing (fracking) and drilling allowed for natural gas to be harvested from deep in shale deposits. As a result of new shale gas discoveries, estimates for US natural gas supply were 35% higher than in 2006–anew source of cheap, abundant natural gas.",textBoxTitle:"2008",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['naturalGas'],correspondingVis:4,citation:"http://www.nytimes.com/2009/06/18/business/energy-environment/18gas.html",annotations:[{type:"x",YYYYMM:"1/1/2008",note:{label:"Shale Hydraulic Fracturing",align:"right"},color:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['naturalGas'],dy:-10,dx:0,connector:{end:"none"}}]},{id:0,textBoxDescription:"The 2008 recession crippled demand for energy from all sectors. Coal was hit especially hard, falling 8.5% in 2009 to 1.07 billion tons, \"the largest percentage decline since 1958 and the biggest tonnage drop-off since 1949,\" according to the Energy Information Administration (EIA). Much of the decline was caused by weak industrial demand for electricity and low gas prices. Utilities and power generators began using more of this cheap gas to produce power.",textBoxTitle:"2008",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],correspondingVis:4,citation:"http://www.nbcnews.com/id/36199456/ns/business-oil_and_energy/t/tough-times-us-coal-industry/#.WpXJLxPwZmA",annotations:[{type:"bounds",YYYYMM:"1/1/2008",note:{label:"2008 Great Recession Hurts Coal",align:"right"},bounds:[{YYYYMM:new Date("1/1/2008")},{YYYYMM:new Date("1/1/2010")}],color:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],dy:-10,dx:0,connector:{end:"none"}}]},{id:0,textBoxDescription:"",textBoxTitle:"2009",textBoxColor:"grey",correspondingVis:4,annotations:[{type:"x",YYYYMM:"1/1/2009",note:{label:"2009",align:"right"},color:"grey",dy:-10,dx:0,connector:{end:"none"}}]},{id:0,textBoxDescription:"",textBoxTitle:"2010",textBoxColor:"grey",correspondingVis:4,annotations:[{type:"x",YYYYMM:"1/1/2010",note:{label:"2010",align:"right"},color:"grey",dy:-10,dx:0,connector:{end:"none"}}]},{id:0,textBoxDescription:"",textBoxTitle:"2011",textBoxColor:"grey",correspondingVis:4,annotations:[{type:"x",YYYYMM:"1/1/2011",note:{label:"2011",align:"right"},color:"grey",dy:-10,dx:0,connector:{end:"none"}}]},{id:0,textBoxDescription:"",textBoxTitle:"2012",textBoxColor:"grey",correspondingVis:4,annotations:[{type:"x",YYYYMM:"1/1/2012",note:{label:"2012",align:"right"},color:"grey",dy:-10,dx:0,connector:{end:"none"}}]},{id:0,textBoxDescription:"",textBoxTitle:"2013",textBoxColor:"grey",correspondingVis:4,annotations:[{type:"x",YYYYMM:"1/1/2013",note:{label:"2013",align:"right"},color:"grey",dy:-10,dx:0,connector:{end:"none"}}]},{id:0,textBoxDescription:"The EPA introduced the Clean Power Plan. Officially finalized by the Obama administration in 2015, the plan focused on increasing existing plant efficiency, suplementing natural gas for coal to reduce emmissions and transitioning to renewable sources from fossil fuels.",textBoxTitle:"2014",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['naturalGas'],citation:"https://en.wikipedia.org/wiki/Clean_Power_Plan",correspondingVis:4,annotations:[{type:"x",YYYYMM:"1/1/2014",color:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['naturalGas'],label:"Clean Power Plan",dy:-10,dx:0,connector:{end:"none"}}]},{id:0,textBoxDescription:"",textBoxTitle:"2015",textBoxColor:"grey",correspondingVis:4,annotations:[{type:"x",YYYYMM:"1/1/2015",note:{label:"2015",align:"right"},color:"grey",dy:-10,dx:0,connector:{end:"none"}}]},{id:0,textBoxDescription:"While coal advocates blame the Clean Power Plan (CPP) for waging the war on coal, the EIA says that natural gas and renewables would have claimed a large market share from coal regardless of the CPP–many experts claim that coal is dying regardless of EPA regulations. The market forces at play make opening new coal plants financially unviable.",textBoxTitle:"2016",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],citation:"http://time.com/coals-last-kick/",correspondingVis:4,annotations:[{type:"x",YYYYMM:"1/1/2016",color:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],note:{label:"2016",align:"right"},dy:-10,dx:0,connector:{end:"none"}}]},{id:0,textBoxDescription:"What does this mean for jobs?",textBoxTitle:"",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],correspondingVis:4,annotations:[{type:"x",YYYYMM:"1/1/2015",color:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],label:"Jobs?",dy:-10,dx:0,connector:{end:"none"}}]},// Transition to Employment ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
{id:0,textBoxDescription:"Beginning in 2012, two years before the introduction of the CPP, the United States workforce of coal miners began declining from a high of almost 90,000 workers. By 2016, the workforce had declined over 50%, having the largest impact in West Virginia and other states that are heavily investing in coal mining.",textBoxTitle:"2012",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],correspondingVis:3,annotations:[{type:"x",YYYYMM:"1/1/2014",color:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],label:"Clean Power Plan",dy:-10,dx:0,connector:{end:"none"}}]},{id:0,textBoxDescription:"Trump began the process of repealing the CPP, and announced that he added 45,000 jobs in the coal sector, however the Bureau of Labor Statistics shows a much smaller increase of just a few thousand.",textBoxTitle:"2017",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],citation:"http://www.newsweek.com/donald-trump-has-only-delivered-1200-coal-mining-jobs-despite-claiming-have-751885",correspondingVis:3,annotations:[{type:"x",YYYYMM:"1/1/2017",color:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],label:"Trump repeals the CPP",dy:-10,dx:0,connector:{end:"none"}}]},{id:0,textBoxDescription:"Despite a bleak forcast for current coal mining employees, opportunities in the gas and renewable sectors may provide other employment opportunities moving forward. The U.S. Department of Energy projects that the wind energy sector will employ 600,000 employees by 2050.",textBoxTitle:"2050",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['wind'],citation:"https://energy.gov/eere/articles/wind-energy-supporting-600000-jobs-2050",correspondingVis:3,annotations:[]},{id:0,textBoxDescription:"Finally, let's take a look at one last piece of the puzzle. Can coal really be \"clean\"?",textBoxTitle:"",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],correspondingVis:3,annotations:[]},// Transition to Environment ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
{id:0,textBoxDescription:"When assessing the effects of different energy sources on our environment, it's important to understand that different greenhouses gases have different potencies. The Intergovernmental Panel on Climate Change's (IPCC) assesses the total global warming potential (GWP) of each energy type in terms of their CO2 equivalent effects.",textBoxTitle:"",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],correspondingVis:2,annotations:[]},{id:0,textBoxDescription:"Comparing these GWP's, we can see that coal has by far the biggest impact on our climate. It is objectively the least \"clean\" energy source according to the IPCC.",textBoxTitle:"",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],correspondingVis:2,annotations:[]},{id:0,textBoxDescription:"So is there any way to make coal clean? Carbon capture and storage/sequestration (CCS) is the technology usually associated with \"clean coal.\" The various strategies for CCS could reduce coal emissions by as much as 75% acording to the IPCC. But in his 2018 budget proposal, Trump proposed cutting CCS funding by 55%. In 2019, he proposes to a 20% cut compared to 2016. Only time will tell if this new technology really helps to revitalize coal, however in the absense of serious and substantial CCS funding, \"clean coal\" appears to be an oxymoron.",textBoxTitle:"",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['coal'],citation:"https://www.washingtonpost.com/politics/2018/live-updates/trump-white-house/fact-checking-and-analysis-of-trumps-state-of-the-union-2018-address/about-that-war-on-beautiful-clean-coal/?utm_term=.40805d66257a",correspondingVis:2,annotations:[]},{id:0,textBoxDescription:"While natural gas is still a fossil fuel and is by no means a \"clean\" energy source, watt-for-watt it does produce roughly 40% less atmospheric warming.",textBoxTitle:"",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['naturalGas'],correspondingVis:2,annotations:[]},{id:0,textBoxDescription:"While cheap natural gas means competition for all forms of energy, many energy researchers believe that natural gas is largely replacing coal, not competiting with renewables and other low carbon sources, such as nuclear. Evidence shows that while renewables are typcially credited with reducing emissions, the switch from coal to natural gas may actually be responsible for the decline in U.S. emmissions.",textBoxTitle:"",textBoxColor:__WEBPACK_IMPORTED_MODULE_0__colorMap__["a" /* default */]['naturalGas'],citation:"https://thebreakthrough.org/index.php/issues/natural-gas/natural-gas-overwhelmingly-replaces-coal",correspondingVis:2,annotations:[]}];

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semiotic__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semiotic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_semiotic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colorMap__ = __webpack_require__(252);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var colorMap2={coal:"#282827",//Coal
petroleum:"#7DAAA7",//Petroleum
naturalGas:"#F9BD15",//Natural Gas
otherGas:"#F04B31",//Other Gases
nuclear:"#D385AA",//Nuclear
hydroPumped:"#3F87A6",//Hydroelectric Pumped Storage
hydroConventional:"#3F87A6",//Conventional Hydroelectric Power
wood:"#B15A28",//Wood
waste:"#938373",//Waste
geothermal:"#426B45",//Geothermal
solar:"#F58020",//Solar
wind:"#8DC179"//Wind
};var EmmissionsChart=function(_Component){_inherits(EmmissionsChart,_Component);function EmmissionsChart(){_classCallCheck(this,EmmissionsChart);return _possibleConstructorReturn(this,(EmmissionsChart.__proto__||Object.getPrototypeOf(EmmissionsChart)).apply(this,arguments));}_createClass(EmmissionsChart,[{key:'render',value:function render(){var emissionsData=[{type:"Coal – PC",color:__WEBPACK_IMPORTED_MODULE_2__colorMap__["a" /* default */]['coal'],emissions:820},{type:"Biomass – Cofiring with coal",color:__WEBPACK_IMPORTED_MODULE_2__colorMap__["a" /* default */]['wood'],emissions:740},{type:"Gas – combined cycle",color:__WEBPACK_IMPORTED_MODULE_2__colorMap__["a" /* default */]['naturalGas'],emissions:490},{type:"Biomass – Dedicated",color:__WEBPACK_IMPORTED_MODULE_2__colorMap__["a" /* default */]['coal'],emissions:230},{type:"CCS – Coal – PC",color:__WEBPACK_IMPORTED_MODULE_2__colorMap__["a" /* default */]['coal'],emissions:220},{type:"CCS – Coal – IGCC",color:__WEBPACK_IMPORTED_MODULE_2__colorMap__["a" /* default */]['coal'],emissions:200},{type:"CCS – Gas – combined cycle",color:__WEBPACK_IMPORTED_MODULE_2__colorMap__["a" /* default */]['naturalGas'],emissions:170},{type:"CCS – Coal – oxyfuel",color:__WEBPACK_IMPORTED_MODULE_2__colorMap__["a" /* default */]['coal'],emissions:160},{type:"Solar PV – Utility scale",color:__WEBPACK_IMPORTED_MODULE_2__colorMap__["a" /* default */]['solar'],emissions:48},{type:"Solar PV – rooftop",color:__WEBPACK_IMPORTED_MODULE_2__colorMap__["a" /* default */]['solar'],emissions:41},{type:"Geothermal",color:__WEBPACK_IMPORTED_MODULE_2__colorMap__["a" /* default */]['geothermal'],emissions:38},{type:"Concentrated solar power",color:__WEBPACK_IMPORTED_MODULE_2__colorMap__["a" /* default */]['solar'],emissions:27},{type:"Hydropower",color:__WEBPACK_IMPORTED_MODULE_2__colorMap__["a" /* default */]['hydroConventional'],emissions:24},{type:"Ocean (Tidal and wave)",color:__WEBPACK_IMPORTED_MODULE_2__colorMap__["a" /* default */]['hydroConventional'],emissions:17},{type:"Nuclear",color:__WEBPACK_IMPORTED_MODULE_2__colorMap__["a" /* default */]['nuclear'],emissions:12},{type:"Wind Offshore",color:__WEBPACK_IMPORTED_MODULE_2__colorMap__["a" /* default */]['wind'],emissions:12},{type:"Wind Onshore",color:__WEBPACK_IMPORTED_MODULE_2__colorMap__["a" /* default */]['wind'],emissions:11}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semiotic__["ResponsiveOrdinalFrame"],{title:"IPCC Global Warming Potential of Electricity Sources",size:[700,500],data:emissionsData,responsiveWidth:true,oAccessor:"type",rAccessor:function rAccessor(d){return d.emissions;},style:function style(d){return{fill:d.color};},type:"bar",oLabel:function oLabel(d){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(-15,0)rotate(45)'},d);},axis:{orient:"left",label:"Median Life cycle CO2 equivalent (gCO2eq/kWh)",fontSize:11},margin:{left:70,bottom:170,right:50,top:55},oPadding:5});}}]);return EmmissionsChart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (EmmissionsChart);

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("/DataVisFinal",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl="/DataVisFinal"+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.990ec2f2.js